    const { useState, useMemo, useRef, useEffect } = React;
    
    // Simple SVG icon components to replace Lucide
    const TrendingUp = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>;
    const DollarSign = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>;
    const AlertCircle = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>;
    const FileText = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
    const Calculator = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"></rect><line x1="8" y1="6" x2="16" y2="6"></line><line x1="8" y1="10" x2="8" y2="10"></line><line x1="12" y1="10" x2="12" y2="10"></line><line x1="16" y1="10" x2="16" y2="10"></line><line x1="8" y1="14" x2="8" y2="14"></line><line x1="12" y1="14" x2="12" y2="14"></line><line x1="16" y1="14" x2="16" y2="14"></line><line x1="8" y1="18" x2="8" y2="18"></line><line x1="12" y1="18" x2="12" y2="18"></line><line x1="16" y1="18" x2="16" y2="18"></line></svg>;
    const ChevronDown = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>;
    const ChevronUp = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>;
    const Plus = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
    const Trash2 = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>;
    const Database = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path></svg>;
    const AlertTriangle = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>;
    const Settings = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;
    const Link = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>;
    const HelpCircle = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>;
    const Check = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>;
    const Upload = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>;
    const Download = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>;
    const Save = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>;
    const FolderOpen = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><path d="M2 10h20"></path></svg>;
    const Copy = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>;
    const Mail = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>;
    const EyeOff = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>;
    const RotateCcw = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path></svg>;
    const RotateCw = ({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path></svg>;

// Paginate any Supabase select query through PostgREST's max-rows cap
// (default 1000). Pass a function that builds a fresh query — Supabase
// builders are single-use, so each page chains .range() on a new
// builder. Returns the concatenated rows (always an array). Use this
// for any multi-row select that fetches "everything" — without it the
// query is silently truncated at 1000 rows.
const fetchAllRows = async (buildQuery, pageSize = 1000) => {
  const all = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await buildQuery()
      .range(from, from + pageSize - 1);
    if (error) throw error;
    if (!data || data.length === 0) break;
    all.push(...data);
    if (data.length < pageSize) break;
  }
  return all;
};

// Balance-sheet line totals (Colleen 10-10, Aeroform): the CPA statements call it "Trade receivables - Net"
// and the interim QuickBooks report "Accounts Receivable", so one business carries TWO receivable rows, each
// filled for different columns. Taking the first name match read $0 for the interim AR. Sum the matching
// rows instead. Trade AR excludes other/employee/officer/related-party/note receivables; when a statement
// has none of those trade rows, fall back to the first receivable row (the old behavior). Cash sums every
// bank account row (multiple accounts are normal) but not life-insurance cash value.
const isTradeReceivable = (name) => /receivable/i.test(name || '')
  && !/\b(other|employee|officer|shareholder|stockholder|member|related|due from|loan|note)/i.test(name || '');
const bsTradeAR = (rows, key) => {
  const list = rows || [];
  const trade = list.filter(r => isTradeReceivable(r.name));
  if (trade.length) return trade.reduce((s, r) => s + (Number(r[key]) || 0), 0);
  return Number((list.find(r => /receivable/i.test(r.name || '')) || {})[key]) || 0;
};
const bsCashTotal = (rows, key) => (rows || [])
  .filter(r => /\bcash\b/i.test(r.name || '') && !/surrender|life insurance|cash value/i.test(r.name || ''))
  .reduce((s, r) => s + (Number(r[key]) || 0), 0);

// Formatted currency input component
const CurrencyInput = ({ value, onChange, className = '', placeholder = '', onKeyDown }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [localValue, setLocalValue] = useState('');
  const inputRef = useRef(null);
  
  const formatWithCommas = (num) => {
    if (num === 0 || num === null || num === undefined || isNaN(num)) return '';
    try {
      // Show cents if present, whole dollars if not
      const hasDecimals = num % 1 !== 0;
      if (hasDecimals) {
        return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return Math.round(num).toLocaleString('en-US');
    } catch (e) {
      return '';
    }
  };
  
  const parseValue = (str) => {
    if (!str) return 0;
    const cleaned = str.replace(/[^0-9.-]/g, '');
    const num = parseFloat(cleaned);
    // Keep full precision - don't round stored values
    return isNaN(num) ? 0 : num;
  };
  
  const handleFocus = (e) => {
    setIsFocused(true);
    // Preserve full precision when editing - show decimals if they exist
    const safeValue = (value !== null && value !== undefined && !isNaN(value)) ? value.toString() : '';
    setLocalValue(safeValue);
    // Select all text after a tiny delay to ensure value is set
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.select();
      }
    }, 0);
  };
  
  const handleBlur = () => {
    setIsFocused(false);
    onChange(parseValue(localValue));
  };
  
  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // Save current value on Enter
      onChange(parseValue(localValue));
      // Let parent onKeyDown handle navigation
    }
    // Call parent onKeyDown if provided
    if (onKeyDown) onKeyDown(e);
  };
  
  return (
    <input
      ref={inputRef}
      type="text"
      value={isFocused ? localValue : formatWithCommas(value)}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      className={className}
      placeholder={placeholder}
      autoComplete="off"
    />
  );
};

// ========== EXPANDABLE NOTES COMPONENT ==========
const ExpandableNotes = ({ value, onChange, hasVariance, placeholder, isFlagged, onToggleFlag, noteKey, resolvedData }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showResolved, setShowResolved] = useState(false);
  const textareaRef = useRef(null);
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (isFocused && textareaRef.current) {
      textareaRef.current.focus();
      // Move cursor to end
      textareaRef.current.selectionStart = textareaRef.current.value.length;
    }
  }, [isFocused]);
  
  const handleFlagClick = (e) => {
    e.stopPropagation();
    if (onToggleFlag) {
      onToggleFlag();
      // Auto-expand notes when flagging
      if (!isFlagged) {
        setIsFocused(true);
      }
    }
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      // Close current note
      setIsFocused(false);
      
      // Find all expandable notes inputs and move to next one
      setTimeout(() => {
        const allNoteInputs = document.querySelectorAll('[data-expandable-note]');
        const inputsArray = Array.from(allNoteInputs);
        const currentIndex = inputsArray.findIndex(el => el.dataset.expandableNote === noteKey);
        
        if (currentIndex !== -1 && currentIndex < inputsArray.length - 1) {
          // Focus the next input
          inputsArray[currentIndex + 1].focus();
        }
      }, 50);
    }
  };
  
  // Check if there's a resolved Q&A for this item
  const hasResolvedQA = resolvedData?.resolved && resolvedData?.resolution;
  
  if (isFocused) {
    return (
      <div ref={containerRef} className="relative flex items-center gap-1">
        {hasResolvedQA ? (
          <button 
            onClick={(e) => { e.stopPropagation(); setShowResolved(!showResolved); }}
            className="flex-shrink-0 w-5 h-5 rounded text-xs bg-green-500 text-white"
            title="View resolved Q&A"
          >
            ✓
          </button>
        ) : (
          <button 
            onClick={handleFlagClick}
            className={`flex-shrink-0 w-5 h-5 rounded text-xs ${isFlagged ? 'bg-purple-500 text-white' : 'bg-gray-200 text-gray-500 hover:bg-gray-300'}`}
            title={isFlagged ? 'Remove flag' : 'Flag for review'}
          >
            🚩
          </button>
        )}
        <textarea
          ref={textareaRef}
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={handleKeyDown}
          className={`absolute left-6 top-0 z-50 w-64 h-24 p-2 text-xs border-2 rounded shadow-lg ${isFlagged ? 'border-purple-400 bg-purple-50' : hasVariance ? 'border-blue-400 bg-amber-50' : 'border-blue-400 bg-white'}`}
          placeholder={isFlagged ? 'Add review note...' : placeholder}
        />
      </div>
    );
  }
  
  return (
    <div className="flex items-center gap-1 relative">
      {hasResolvedQA ? (
        <>
          <button 
            onClick={(e) => { e.stopPropagation(); setShowResolved(!showResolved); }}
            className="flex-shrink-0 w-5 h-5 rounded text-xs bg-green-500 text-white hover:bg-green-600"
            title="View resolved Q&A"
          >
            ✓
          </button>
          {showResolved && (
            <div className="absolute left-6 top-0 z-50 w-72 p-2 bg-green-50 border-2 border-green-400 rounded shadow-lg text-xs">
              <div className="font-semibold text-green-800 mb-1">Resolved Question</div>
              <div className="text-gray-700 mb-2"><span className="font-medium">Q:</span> {value || resolvedData.item || 'No question recorded'}</div>
              <div className="text-green-700"><span className="font-medium">A:</span> {resolvedData.resolution}</div>
              <div className="text-gray-400 text-xs mt-1">Resolved: {resolvedData.resolvedDate || 'N/A'}</div>
              <button 
                onClick={(e) => { e.stopPropagation(); setShowResolved(false); }}
                className="absolute top-1 right-1 text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>
          )}
        </>
      ) : (
        <button 
          onClick={handleFlagClick}
          className={`flex-shrink-0 w-5 h-5 rounded text-xs ${isFlagged ? 'bg-purple-500 text-white' : 'bg-gray-200 text-gray-400 hover:bg-gray-300 hover:text-gray-600'}`}
          title={isFlagged ? 'Remove flag' : 'Flag for review'}
        >
          🚩
        </button>
      )}
      <input 
        type="text"
        data-expandable-note={noteKey}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onKeyDown={handleKeyDown}
        className={`flex-grow min-w-0 p-1 text-xs border-0 truncate ${isFlagged ? 'bg-purple-50' : hasVariance ? 'bg-amber-50' : ''}`}
        placeholder={isFlagged ? 'Add review note...' : placeholder}
        title={value || ''}
      />
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════════
   SUPABASE AUTH + 2FA
   Shared auth with Vista Deal Manager (same Supabase project,
   same users). 2FA enrollment is voluntary — a user can enroll
   via the "2FA" button in the topbar. Once enrolled, the user
   is challenged on every future login. No forced enrollment
   until Mark flips the server-side enforcement.
   If Supabase is not configured (local dev), AuthGate passes
   through and the app works without login.
══════════════════════════════════════════════════════════════════ */

const SUPABASE_URL = window.SUPABASE_URL || (typeof localStorage !== 'undefined' ? localStorage.getItem('SUPABASE_URL') : '') || '';
const SUPABASE_ANON_KEY = window.SUPABASE_ANON_KEY || (typeof localStorage !== 'undefined' ? localStorage.getItem('SUPABASE_ANON_KEY') : '') || '';

// 👁 LOOK-ONLY ACCOUNT (Mark 10-27): the office PC's Claude signs in as claude@ to SEE VT (any screen, "view as"
// anyone) but never change it. The write block itself lives in the shared sign-in snippet server.js injects into
// every page (ssoStorageSnippet: window.__vtLookOnly + a fetch guard); the server refuses the same requests.
const LOOK_ONLY_EMAILS = ['claude@vistabusinessgroup.com'];
const isLookOnlyEmail = (e) => LOOK_ONLY_EMAILS.includes(String(e || '').trim().toLowerCase());

let supabaseClient = null;
if (SUPABASE_URL && SUPABASE_ANON_KEY && window.supabase) {
  // SSO (ROADMAP #9): session in a domain cookie via the server-injected
  // adapter — one login serves the Dashboard, SE, playbooks, CIM, and DM.
  supabaseClient = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY,
    window.vbgSsoStorage ? { auth: { storage: window.vbgSsoStorage() } } : undefined);
  window.__vtSupabase = supabaseClient;   // the 🐞 Report widget reads the session token (10-20)
}

async function signIn(email, password) {
  if (!supabaseClient) throw new Error('Auth not configured.');
  const { data, error } = await supabaseClient.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

async function signOut() {
  if (!supabaseClient) return;
  await supabaseClient.auth.signOut();
}

async function getSession() {
  if (!supabaseClient) return null;
  const { data } = await supabaseClient.auth.getSession();
  return data.session;
}

async function listMfaFactors() {
  if (!supabaseClient) return { totp: [] };
  const { data, error } = await supabaseClient.auth.mfa.listFactors();
  if (error) throw error;
  return data;
}

async function enrollMfa() {
  if (!supabaseClient) throw new Error('Auth not configured');
  const { data, error } = await supabaseClient.auth.mfa.enroll({ factorType: 'totp', friendlyName: 'Authenticator' });
  if (error) throw error;
  return data;
}

async function challengeMfa(factorId) {
  const { data, error } = await supabaseClient.auth.mfa.challenge({ factorId });
  if (error) throw error;
  return data;
}

async function verifyMfa(factorId, challengeId, code) {
  const { data, error } = await supabaseClient.auth.mfa.verify({ factorId, challengeId, code });
  if (error) throw error;
  return data;
}

async function unenrollMfa(factorId) {
  const { error } = await supabaseClient.auth.mfa.unenroll({ factorId });
  if (error) throw error;
}

async function getAssuranceLevel() {
  if (!supabaseClient) return { currentLevel: null, nextLevel: null };
  const { data, error } = await supabaseClient.auth.mfa.getAuthenticatorAssuranceLevel();
  if (error) throw error;
  return data;
}

/* ── PASSWORD RECOVERY (2026-08-05, Scott's locked-out go-live morning) ──
   The Supabase recovery email signs the user in with a special token but
   needs a page that actually SETS the new password — this is that page.
   The flag is captured at bundle-parse time because supabase-js strips
   the #type=recovery hash as soon as it processes the URL. */
let AUTH_RECOVERY_FLOW = typeof window !== 'undefined' && /type=recovery/.test(window.location.hash || '');

/* ── LOGIN SCREEN ── */
const LoginScreen = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resetNote, setResetNote] = useState('');

  const handleSubmit = async () => {
    if (!email || !password) return;
    setLoading(true);
    setError('');
    try {
      await signIn(email, password);
      onLogin();
    } catch (err) {
      setError(err.message || 'Login failed. Check your email and password.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    if (!email) { setError('Enter your email above first, then click Forgot password.'); return; }
    setError('');
    try {
      const { error: rErr } = await supabaseClient.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin,
      });
      if (rErr) throw rErr;
      setResetNote('Recovery email sent — open the link on THIS computer and you\'ll be asked to set a new password.');
    } catch (err) {
      setError(err.message || 'Could not send the recovery email.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-md rounded-lg shadow-lg p-8" style={{ background: 'var(--s1)', border: '1px solid var(--border)' }}>
        <div className="text-center mb-6">
          <img src="/public/logo.jpg" alt="Vista Business Group" className="mx-auto mb-3" style={{ height: 88 }} />
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>Vista Dashboard</h1>
          <p className="text-sm mt-1" style={{ color: 'var(--muted)' }}>Vista Business Group</p>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2">{error}</div>
          )}
          {resetNote && (
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded p-2">{resetNote}</div>
          )}
          <button
            onClick={handleSubmit}
            disabled={loading || !email || !password}
            className="w-full bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700 disabled:bg-gray-300"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
          <button
            onClick={handleForgot}
            className="w-full text-xs font-semibold py-1"
            style={{ color: 'var(--muted)' }}
          >
            Forgot password? Email me a reset link
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── SET NEW PASSWORD (arrival from a recovery-email link) ── */
const SetNewPasswordScreen = ({ onDone }) => {
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const submit = async () => {
    if (pw1.length < 8) { setError('Use at least 8 characters.'); return; }
    if (pw1 !== pw2) { setError('The two entries don\'t match.'); return; }
    setSaving(true); setError('');
    try {
      const { error: uErr } = await supabaseClient.auth.updateUser({ password: pw1 });
      if (uErr) throw uErr;
      AUTH_RECOVERY_FLOW = false;
      onDone();
    } catch (err) {
      setError(err.message || 'Could not set the password.');
      setSaving(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-md rounded-lg shadow-lg p-8" style={{ background: 'var(--s1)', border: '1px solid var(--border)' }}>
        <div className="text-center mb-6">
          <img src="/public/logo.jpg" alt="Vista Business Group" className="mx-auto mb-3" style={{ height: 88 }} />
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>Set your new password</h1>
          <p className="text-sm mt-1" style={{ color: 'var(--muted)' }}>This one password signs you into every Vista module.</p>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">New password</label>
            <input type="password" value={pw1} onChange={(e) => setPw1(e.target.value)} autoFocus
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Repeat it</label>
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400" />
          </div>
          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2">{error}</div>}
          <button onClick={submit} disabled={saving || !pw1 || !pw2}
            className="w-full bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700 disabled:bg-gray-300">
            {saving ? 'Saving…' : 'Set password & continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── 2FA CHALLENGE SCREEN (shown after login if user has enrolled factor) ── */
const TwoFactorChallenge = ({ factorId, onVerified, onCancel }) => {
  const [code, setCode] = useState('');
  const [challengeId, setChallengeId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    challengeMfa(factorId)
      .then(d => setChallengeId(d.id))
      .catch(err => setError(err.message || 'Could not start challenge.'));
  }, [factorId]);

  const handleVerify = async () => {
    if (!code || !challengeId) return;
    setLoading(true);
    setError('');
    try {
      await verifyMfa(factorId, challengeId, code);
      onVerified();
    } catch (err) {
      setError(err.message || 'Invalid code. Please try again.');
      setCode('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-xl font-bold text-gray-800 mb-2">Two-Factor Authentication</h1>
        <p className="text-sm text-gray-500 mb-4">Enter the 6-digit code from your authenticator app.</p>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          onKeyDown={(e) => { if (e.key === 'Enter') handleVerify(); }}
          placeholder="000000"
          maxLength={6}
          autoFocus
          className="w-full px-3 py-2 text-center text-2xl tracking-widest border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3"
        />
        {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2 mb-3">{error}</div>}
        <button
          onClick={handleVerify}
          disabled={loading || code.length !== 6}
          className="w-full bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700 disabled:bg-gray-300 mb-2"
        >
          {loading ? 'Verifying...' : 'Verify'}
        </button>
        <button onClick={onCancel} className="w-full text-sm text-gray-500 hover:text-gray-700">Sign out</button>
      </div>
    </div>
  );
};

/* ── 2FA ENROLLMENT SCREEN (voluntary) ── */
const TwoFactorEnroll = ({ onDone, onCancel }) => {
  const [factor, setFactor] = useState(null);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    enrollMfa().then(setFactor).catch(err => setError(err.message || 'Could not start enrollment.'));
  }, []);

  const handleVerify = async () => {
    if (!code || !factor) return;
    setLoading(true);
    setError('');
    try {
      const challenge = await challengeMfa(factor.id);
      await verifyMfa(factor.id, challenge.id, code);
      onDone();
    } catch (err) {
      setError(err.message || 'Invalid code. Please try again.');
      setCode('');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    if (factor) {
      try { await unenrollMfa(factor.id); } catch (e) { /* ignore */ }
    }
    onCancel();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-xl font-bold text-gray-800 mb-2">Set Up Two-Factor Authentication</h1>
        <p className="text-sm text-gray-500 mb-4">
          Scan this QR code with an authenticator app (Google Authenticator, Authy, 1Password, etc.), then enter the 6-digit code to verify.
        </p>
        {!factor && !error && <div className="text-center text-gray-400 py-8">Generating code...</div>}
        {factor && (
          <React.Fragment>
            <div className="flex justify-center mb-3 bg-white p-2 border border-gray-200 rounded">
              <img src={factor.totp.qr_code} alt="QR code" className="w-48 h-48" />
            </div>
            <div className="text-xs text-gray-500 mb-3 text-center">
              Or enter manually: <code className="bg-gray-100 px-1 py-0.5 rounded text-xs">{factor.totp.secret}</code>
            </div>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              onKeyDown={(e) => { if (e.key === 'Enter') handleVerify(); }}
              placeholder="000000"
              maxLength={6}
              className="w-full px-3 py-2 text-center text-2xl tracking-widest border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3"
            />
          </React.Fragment>
        )}
        {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2 mb-3">{error}</div>}
        <button
          onClick={handleVerify}
          disabled={loading || code.length !== 6 || !factor}
          className="w-full bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700 disabled:bg-gray-300 mb-2"
        >
          {loading ? 'Verifying...' : 'Verify & Enable'}
        </button>
        <button onClick={handleCancel} className="w-full text-sm text-gray-500 hover:text-gray-700">Cancel</button>
      </div>
    </div>
  );
};

/* ── AUTH GATE — wraps the whole app ── */
const AuthGate = ({ children }) => {
  const [authState, setAuthState] = useState('loading');
  const [currentFactorId, setCurrentFactorId] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [hasMfa, setHasMfa] = useState(false);

  const evaluateSession = async () => {
    const session = await getSession();
    if (!session) { setAuthState('login'); return; }
    setUserEmail(session.user?.email || '');
    window.__vtLookOnly = isLookOnlyEmail(session.user?.email);
    try {
      const factors = await listMfaFactors();
      const totp = (factors.totp || []).filter(f => f.status === 'verified')[0];
      setHasMfa(!!totp);
      // The look-only account never runs on a password alone: no authenticator yet = set one up now.
      if (!totp && window.__vtLookOnly) { setAuthState('enroll'); return; }
      if (totp) {
        const aal = await getAssuranceLevel();
        if (aal.currentLevel !== 'aal2') {
          setCurrentFactorId(totp.id);
          setAuthState('challenge');
          return;
        }
      }
      // Resolve the shared staff table (falls back to the built-in
      // directory) BEFORE the app renders, so every role gate below sees
      // the final directory on first paint.
      await loadStaffDirectory();
      setAuthState('authed');
    } catch (err) {
      console.error('Auth evaluation error:', err);
      await loadStaffDirectory();
      setAuthState('authed');
    }
  };

  useEffect(() => {
    if (!supabaseClient) { setAuthState('authed'); return; }
    evaluateSession();
    const { data: sub } = supabaseClient.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT') {
        window.__vtLookOnly = false;
        setUserEmail('');
        setHasMfa(false);
        setAuthState('login');
      }
      // Belt to the parse-time flag's suspenders: supabase fires this when
      // it consumes a recovery-link token.
      if (event === 'PASSWORD_RECOVERY') setAuthState('setPassword');
    });
    return () => { try { sub?.subscription?.unsubscribe?.(); } catch (e) {} };
  }, []);

  if (!supabaseClient) return children;

  // Arrived via a password-recovery email: the token signed them in, but
  // the whole point is setting the new password before anything else.
  // EXCEPT the 2FA challenge (Mark hit this live, 08-05): an MFA-enrolled
  // account may only change its password at AAL2, so the TOTP prompt must
  // run first — evaluateSession routes to 'challenge', and once verified
  // we land back here and show the reset form.
  if ((AUTH_RECOVERY_FLOW && authState !== 'login' && authState !== 'challenge') || authState === 'setPassword') {
    return <SetNewPasswordScreen onDone={() => { setAuthState('loading'); evaluateSession(); }} />;
  }

  if (authState === 'loading') {
    return <div className="min-h-screen flex items-center justify-center text-gray-400" style={{ background: 'var(--bg)' }}>Loading...</div>;
  }
  if (authState === 'login') {
    return <LoginScreen onLogin={evaluateSession} />;
  }
  if (authState === 'challenge') {
    return <TwoFactorChallenge factorId={currentFactorId} onVerified={evaluateSession} onCancel={async () => { await signOut(); setAuthState('login'); }} />;
  }
  if (authState === 'enroll') {
    return <TwoFactorEnroll onDone={async () => { setHasMfa(true); if (window.__vtLookOnly) await evaluateSession(); else setAuthState('authed'); }}
      onCancel={async () => { if (window.__vtLookOnly) { await signOut(); setAuthState('login'); } else setAuthState('authed'); }} />;
  }

  return React.cloneElement(children, {
    userEmail,
    hasMfa,
    onEnrollMfa: () => setAuthState('enroll'),
    onSignOut: async () => { await signOut(); }
  });
};

/* ═══════════════════════════════════════════════════════════════
   CLIENT LIST + NEW CLIENT MODAL + ROUTER
   The home screen after login. Lists all clients and their
   valuations. Each card expands to show the client's valuations
   sorted by last updated. Data flows from Supabase; the router
   (VistaApp) toggles between this list and BusinessValuationTool.
══════════════════════════════════════════════════════════════════ */

const formatRelativeDate = (ts) => {
  if (!ts) return 'never';
  const d = new Date(ts);
  const diffMs = Date.now() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin} min ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} hour${diffHr !== 1 ? 's' : ''} ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return `${diffDay} day${diffDay !== 1 ? 's' : ''} ago`;
  return d.toLocaleDateString();
};

const FACTOR_TAG_NAMES = {
  A: 'Revenue Quality', B: 'EBITDA Quality', C: 'Customer Retention & Growth',
  D: 'Contract Terms', E: 'Concentration Risk', G: 'A/R & Collections Quality',
  H: 'Owner Continuity', J: 'Owner Dependency',
};

const ClientList = ({ userEmail, hasMfa, onEnrollMfa, onSignOut, onOpenValuation, onNewValuation, onNewClient, onImport, newClientIds = [], refreshKey, onGoToDashboard = null }) => {
  const [clients, setClients] = useState([]);
  const [valuationsByClient, setValuationsByClient] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedClient, setExpandedClient] = useState(null);
  const [error, setError] = useState('');
  // Map of valuation_id -> array of viewer emails currently active in that file
  const [presenceByValuation, setPresenceByValuation] = useState({});
  const PRESENCE_LIST_TTL_MS = 90 * 1000;
  const PRESENCE_LIST_POLL_MS = 20 * 1000;
  const formatViewerName = (email) => {
    const local = (email || '').split('@')[0];
    if (!local) return 'Someone';
    return local.split(/[._-]+/).filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  };

  const newClientIdSet = new Set(newClientIds);

  // Seed a NEW valuation from an old JSON, under THIS client (Mark 09-15, the
  // returning-client fix). The bulk "Import JSONs" tool matches by company
  // name and silently makes a NEW client on any mismatch — so a returning
  // client whose name drifted (JM Addington "…Technology Solutions" vs the
  // file's "…LLC") duplicated every time. Here the client is already chosen,
  // so a duplicate is impossible: the old model lands on the right record and
  // opens, ready for Setup → ↻ Start Revalue.
  const seedValuationFromJson = (client) => {
    // GUARD (Mark 09-16): "+ From JSON" is ONLY for clients that were never
    // valued in VT. If the client already has a deal, seeding a second
    // valuation makes a DUPLICATE — the split scatters the reminder, the
    // review date, and the revalue across two records (Colleen hit this on
    // Charter; JM Addington before). We've hand-merged this twice; the button
    // has to refuse it. Returning client already in VT → open the deal and use
    // ↻ Start Revalue instead (carries prior answers forward, one record).
    if ((valuationsByClient[client.id] || []).length) {
      window.alert(`${client.company_name} already has a deal in VT — "+ From JSON" would create a duplicate.\n\nOpen the existing deal and use ↻ Start Revalue on the Setup tab: it carries the prior answers forward and keeps everything on one record.\n\n("+ From JSON" is only for clients that were never valued in VT.)`);
      return;
    }
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = async () => {
      const file = input.files && input.files[0];
      if (!file) return;
      try {
        const data = JSON.parse(await file.text());
        // Authoritative re-check at the moment of insert (the in-memory list
        // could be stale): never insert a second valuation for a client that
        // already has one.
        const { data: already, error: chkErr } = await supabaseClient.from('valuations')
          .select('id').eq('client_id', client.id).limit(1);
        if (chkErr) throw chkErr;
        if (already && already.length) {
          window.alert(`${client.company_name} already has a deal in VT — open it and use ↻ Start Revalue instead. (No duplicate was created.)`);
          return;
        }
        const savedDate = data.savedAt || data.autoSavedAt || new Date().toISOString();
        const dateStr = new Date(savedDate).toISOString().split('T')[0];
        const name = `${dateStr} Valuation (imported)`;
        const { data: ins, error } = await supabaseClient.from('valuations').insert({
          client_id: client.id, name, version: data.version || 'imported',
          data, created_at: savedDate, updated_at: savedDate,
        }).select('id, name').single();
        if (error) throw error;
        window.alert(`Loaded "${file.name}" onto ${client.company_name}. Opening it now — go to Setup and click ↻ Start Revalue to begin the new cycle.`);
        onOpenValuation({ id: ins.id, name: ins.name });
      } catch (e) {
        window.alert('Could not load that JSON: ' + (e.message || e));
      }
    };
    input.click();
  };

  useEffect(() => {
    const load = async () => {
      if (!supabaseClient) { setLoading(false); return; }
      setLoading(true);
      setError('');
      try {
        const clientsData = await fetchAllRows(() => supabaseClient
          .from('clients')
          .select('*')
          .order('company_name', { ascending: true }));
        setClients(clientsData || []);

        const valuationsData = await fetchAllRows(() => supabaseClient
          .from('valuations')
          .select('id, client_id, name, version, created_at, updated_at, owner_first_name, owner_last_name, owner_email, lead, account_manager, path, likelihood_pct, deal_profile:data->dealProfile')
          .order('updated_at', { ascending: false }));

        const grouped = {};
        (valuationsData || []).forEach(v => {
          if (!v.client_id) return;
          if (!grouped[v.client_id]) grouped[v.client_id] = [];
          grouped[v.client_id].push(v);
        });
        setValuationsByClient(grouped);
      } catch (err) {
        console.error('Load clients failed:', err);
        setError(err.message || 'Failed to load clients.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [refreshKey]);

  // Poll active presence so the list shows "👁 Konnie viewing" pills on files in use.
  // Each ClientList user excludes themselves so their own previously-open tab in another window
  // doesn't show as a foreign viewer.
  useEffect(() => {
    if (!supabaseClient) return;
    let cancelled = false;
    const fetchPresence = async () => {
      try {
        const { data: { session } } = await supabaseClient.auth.getSession();
        const myId = session?.user?.id;
        const cutoff = new Date(Date.now() - PRESENCE_LIST_TTL_MS).toISOString();
        const { data, error } = await supabaseClient
          .from('valuation_presence')
          .select('valuation_id, user_id, user_email')
          .gte('last_seen', cutoff);
        if (error) { console.error('ClientList presence poll error:', error); return; }
        if (cancelled) return;
        const map = {};
        (data || []).forEach(p => {
          if (myId && p.user_id === myId) return; // hide myself
          if (!map[p.valuation_id]) map[p.valuation_id] = [];
          map[p.valuation_id].push(p.user_email);
        });
        // Only redraw when someone opened or closed a deal (Zac 10-23: the 20-second redraw wiped card progress).
        setPresenceByValuation(prev => (JSON.stringify(prev) === JSON.stringify(map) ? prev : map));
      } catch (err) {
        console.error('ClientList presence poll exception:', err);
      }
    };
    fetchPresence();
    const interval = setInterval(fetchPresence, PRESENCE_LIST_POLL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, [refreshKey]);

  const q = searchQuery.trim().toLowerCase();
  // Tokenized, multi-field search (Adam 09-16: "search doesn't work well" +
  // "add the ability to search by email"). Every word must appear SOMEWHERE in
  // the client's haystack, in any order — so "logic design" finds "Design Logic
  // Systems," and a partial name still hits. The haystack now includes the
  // owner EMAIL and name from the client's valuations (the clients table itself
  // has no email column), so typing an address finds the client.
  const qTokens = q.split(/\s+/).filter(Boolean);
  const clientHaystack = (c) => {
    const vs = valuationsByClient[c.id] || [];
    return [
      c.company_name, c.city, c.state, String(c.vista_id || ''), c.website,
      ...vs.flatMap(v => [v.owner_email, v.owner_first_name, v.owner_last_name]),
    ].filter(Boolean).join('  ').toLowerCase();
  };
  const filteredClients = !q ? clients : clients.filter(c => {
    const hay = clientHaystack(c);
    return qTokens.every(t => hay.includes(t));
  });

  // Delete an empty client (no valuations attached). The delete button is
  // only rendered when valuations.length === 0, so this can only ever
  // remove a truly empty client row — the recovery path for accidental
  // duplicates that slip past the new-client duplicate-name check.
  const handleDeleteClient = async (client) => {
    if (!supabaseClient || !client?.id) return;
    if (!window.confirm(
      `Delete "${client.company_name}"?\n\n` +
      `This client has no valuations attached. The deletion is permanent.`
    )) return;
    try {
      const { error } = await supabaseClient.from('clients').delete().eq('id', client.id);
      if (error) throw error;
      setClients(prev => prev.filter(c => c.id !== client.id));
    } catch (err) {
      console.error('Delete client failed:', err);
      window.alert('Delete failed: ' + (err.message || 'unknown error'));
    }
  };

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Shared shell (consolidation Phase 2) — same topnav as the
          Dashboard and Deal Manager. */}
      <div className="topnav">
        <div className="logo">
          <img src="/public/logo.jpg" alt="" style={{ height: 40 }} />
          <div className="ln">Vista <span>Dashboard</span></div>
        </div>
        {onGoToDashboard ? (
          <nav className="nav-tabs">
            <button onClick={onGoToDashboard} className="nav-tab">🏠 Dashboard</button>
            <button className="nav-tab on">📁 Clients</button>
            <a href="/playbook" target="_blank" rel="noopener" className="nav-tab">📖 My Playbook</a>
          </nav>
        ) : <div />}
        <div className="nav-right">
          {userEmail && (
            <React.Fragment>
              <span className="text-xs truncate max-w-[200px]" style={{ color: 'var(--muted)' }} title={userEmail}>{userEmail}</span>
              {!hasMfa && (
                <button onClick={onEnrollMfa} className="px-2 py-1 rounded text-xs font-semibold bg-amber-100 text-amber-700 hover:bg-amber-200">
                  Set up 2FA
                </button>
              )}
              {hasMfa && (
                <span className="text-xs" style={{ color: 'var(--green)' }}>✓ 2FA</span>
              )}
              <button onClick={onSignOut} className="nav-tab" style={{ border: '1px solid var(--border)' }}>
                Sign Out
              </button>
            </React.Fragment>
          )}
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex items-center gap-3 mb-4">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by name, owner email, city, state, or Vista ID..."
            className="flex-1 px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          {onImport && (
            <button onClick={onImport} className="px-4 py-2 bg-gray-100 text-gray-700 rounded text-sm font-semibold hover:bg-gray-200 whitespace-nowrap border border-gray-300">
              Import JSONs
            </button>
          )}
          <button onClick={onNewClient} className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-700 whitespace-nowrap">
            + New Client
          </button>
        </div>

        {loading && <div className="text-center text-gray-400 py-12">Loading clients...</div>}
        {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded p-3 mb-4 text-sm">{error}</div>}

        {!loading && !error && filteredClients.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 mb-4">
              {clients.length === 0 ? 'No clients yet. Create your first one to get started.' : 'No clients match your search.'}
            </p>
            {clients.length === 0 && (
              <button onClick={onNewClient} className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-700">
                + New Client
              </button>
            )}
          </div>
        )}

        <div className="space-y-2">
          {filteredClients.map(client => {
            const valuations = valuationsByClient[client.id] || [];
            const isExpanded = expandedClient === client.id;
            const mostRecent = valuations[0];
            // Any valuation under this client currently in use? Used to tint the whole row.
            const clientHasViewers = valuations.some(v => (presenceByValuation[v.id] || []).length > 0);
            const mostRecentViewers = mostRecent ? (presenceByValuation[mostRecent.id] || []) : [];
            const renderViewerPill = (emails) => {
              if (!emails || emails.length === 0) return null;
              const first = formatViewerName(emails[0]);
              const label = emails.length === 1 ? first : `${first} +${emails.length - 1}`;
              const title = emails.map(formatViewerName).join(', ') + (emails.length === 1 ? ' is viewing this file' : ' are viewing this file');
              return (
                <span
                  className="flex-shrink-0 text-[11px] font-semibold bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full whitespace-nowrap"
                  title={title}
                >
                  👁 {label}
                </span>
              );
            };
            return (
              <div
                key={client.id}
                className={`bg-white rounded border overflow-hidden ${clientHasViewers ? 'border-amber-300 border-l-4' : 'border-gray-200'}`}
              >
                <div
                  className="px-4 py-3 flex items-center justify-between cursor-pointer hover:bg-gray-50"
                  onClick={() => setExpandedClient(isExpanded ? null : client.id)}
                >
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-gray-800 truncate flex items-center gap-2">
                      <span className="truncate">{client.company_name}</span>
                      {newClientIdSet.has(client.id) && (
                        <span className="flex-shrink-0 text-[10px] font-bold bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded uppercase tracking-wide">New</span>
                      )}
                      {(() => {
                        if (!mostRecent) return null;
                        const v = mostRecent, dp = v.deal_profile || {};
                        const missing = [];
                        if (!String(v.owner_first_name || '').trim()) missing.push('owner first name');
                        if (!String(v.owner_last_name || '').trim()) missing.push('owner last name');
                        if (!String(v.owner_email || '').trim()) missing.push('owner email');
                        if (!String(dp.ownerRole || '').trim()) missing.push('owner role');
                        if (!String(v.lead || '').trim()) missing.push('Lead');
                        if (!String(v.account_manager || '').trim()) missing.push('Account Manager');
                        if (!String(v.path || '').trim()) missing.push('path');
                        if (v.likelihood_pct === '' || v.likelihood_pct == null) missing.push('likelihood %');
                        if (!String(dp.city || client.city || '').trim()) missing.push('city');
                        if (!String(dp.state || client.state || '').trim()) missing.push('state');
                        if (!missing.length) return null;
                        return (
                          <span
                            className="flex-shrink-0 text-[10px] font-bold bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded uppercase tracking-wide"
                            title={`Setup tab incomplete on the latest valuation — a revalue can't start until these are filled: ${missing.join(', ')}. Usually a file set up before the Setup tab existed; fill once on the Setup tab and save.`}
                          >Setup incomplete · {missing.length}</span>
                        );
                      })()}
                      {renderViewerPill(mostRecentViewers)}
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">
                      {[client.city, client.state].filter(Boolean).join(', ') || <span className="italic text-gray-400">no location</span>}
                      {valuations.length > 0 && (
                        <span className="ml-3">· {valuations.length} valuation{valuations.length !== 1 ? 's' : ''}</span>
                      )}
                      {mostRecent && (
                        <span className="ml-3">· last updated {formatRelativeDate(mostRecent.updated_at)}</span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 ml-4">
                    <button
                      onClick={(e) => { e.stopPropagation(); onNewValuation(client); }}
                      className="px-3 py-1 text-xs font-semibold bg-blue-100 text-blue-700 rounded hover:bg-blue-200 whitespace-nowrap"
                    >
                      + New Valuation
                    </button>
                    <button
                      onClick={(e) => { e.stopPropagation(); seedValuationFromJson(client); }}
                      className="px-3 py-1 text-xs font-semibold bg-violet-100 text-violet-700 rounded hover:bg-violet-200 whitespace-nowrap"
                      title="Returning client / revalue: load an old valuation's JSON file as a new valuation UNDER THIS client. No duplicate client (you're already inside the right one). Then open it and use ↻ Start Revalue. Don't use the top 'Import JSONs' button for a client already in VT — that one can duplicate."
                    >
                      + From JSON
                    </button>
                    {valuations.length === 0 && (
                      <button
                        onClick={(e) => { e.stopPropagation(); handleDeleteClient(client); }}
                        className="px-2 py-1 text-xs font-semibold bg-red-50 text-red-600 rounded hover:bg-red-100 whitespace-nowrap"
                        title="Delete this empty client (no valuations attached)"
                      >
                        🗑 Delete
                      </button>
                    )}
                    {mostRecent && (
                      <button
                        onClick={(e) => { e.stopPropagation(); onOpenValuation(mostRecent); }}
                        className="px-3 py-1 text-xs font-semibold bg-green-100 text-green-700 rounded hover:bg-green-200 whitespace-nowrap"
                      >
                        Open Latest
                      </button>
                    )}
                    <span className="text-gray-400 text-sm w-4 text-center">{isExpanded ? '▼' : '▶'}</span>
                  </div>
                </div>
                {isExpanded && valuations.length > 0 && (
                  <div className="border-t border-gray-100 bg-gray-50 divide-y divide-gray-100">
                    {valuations.map(v => {
                      const viewers = presenceByValuation[v.id] || [];
                      return (
                        <div
                          key={v.id}
                          className={`px-4 py-2 flex items-center justify-between hover:bg-white cursor-pointer ${viewers.length > 0 ? 'bg-amber-50/50' : ''}`}
                          onClick={() => onOpenValuation(v)}
                        >
                          <div className="flex-1 min-w-0">
                            <div className="text-sm text-gray-800 truncate flex items-center gap-2">
                              <span className="truncate">{v.name || <span className="italic text-gray-400">Untitled valuation</span>}</span>
                              {renderViewerPill(viewers)}
                            </div>
                            <div className="text-xs text-gray-500">
                              {v.version && <span>{v.version} · </span>}
                              Updated {formatRelativeDate(v.updated_at)}
                            </div>
                          </div>
                          <div className="text-xs text-blue-600 ml-2 whitespace-nowrap">Open →</div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {isExpanded && valuations.length === 0 && (
                  <div className="border-t border-gray-100 bg-gray-50 px-4 py-3 text-xs text-gray-500 italic">
                    No valuations yet for this client.
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// Marketing-source vocabulary — Zoho's Lead Source pick list VERBATIM (Mark's
// screenshots, 2026-07-24; spellings like "LinkedIn- Workflow" and "LinkedIN
// Targeted Ad Campaign" are Zoho's own — keep them exact so VT-era deals and
// the imported sold history report under the same labels), plus two values
// that appear in the sold history but not the current pick list.
const MARKETING_SOURCES = [
  'Email- Marketing Listing Services',
  'Email - On behalf of Buyside Client',
  'Website - Submitted Form',
  'Internet Search',
  'Direct Buyside Letter Campaign',
  'Direct Sellside Letter Campaign',
  'Result from participating as buyer',
  'LinkedIn - Messaging',
  'LinkedIn- Workflow',
  'LinkedIn - Inmail',
  'LinkedIN Targeted Ad Campaign',
  'Google Ads',
  'Google Search - Email',
  'Referral',
  'Networking',
  'Conference',
  'Zoominfo',
  'Found us',        // historical (sold history)
  'Broker Listing',  // historical (sold history)
];

// `warmMode` switches the modal into the warm-account flow (Warm → Active
// onboarding). Available to AMs (Adam/J.C.) AND Leads (Zac/Thatcher) — a Lead
// who self-generates a client (e.g. a referral) acts as both Lead and AM, so
// they need the same pre-meeting flow. The creator captures only what's known
// then (company, Vista ID, city/state, primary contact + role, the Lead, optional
// intro meeting date) — committal/path are hidden (set by the Lead at activation).
// Saving seeds workflow_stage 'warm' and hands off to the intro-email preview.
// A Lead creating their own account defaults as both Lead and AM. Everyone else
// (Colleen/Mark) gets the full standard modal.
const NewClientModal = ({ onClose, onCreated, creatorRole = '', creatorName = '' }) => {
  const creatorIsLead = creatorRole === 'lead';
  // Leads choose how they're setting up the client: Warm (pre-meeting: portal +
  // intro email, activate after the meeting) vs Active now (already met: set path
  // + committal, goes active immediately). AMs are always Warm; Colleen/Mark are
  // always standard. Leads default to Warm.
  const [activeNow, setActiveNow] = useState(false);
  // New prospect (never valued) vs Returning client (valued in Vista's OLD system,
  // re-engaging organically). Returning skips the warm/intro-meeting + Lead
  // activation: it goes active immediately and sends an organic portal-invite
  // email. Available to every creator role. See docs/RETURNING-CLIENT-SPEC.md.
  // (Marketing-source vocabulary = the exact Zoho lead_source strings from the
  // 107-deal sold history, most-frequent first, so old + new report together.)
  const [accountType, setAccountType] = useState('new'); // 'new' | 'returning'
  const isReturning = accountType === 'returning';
  const warmMode = !isReturning && (creatorRole === 'account_manager' || (creatorIsLead && !activeNow));
  const [companyName, setCompanyName] = useState('');
  const [vistaId, setVistaId] = useState('');
  const [city, setCity] = useState('');
  const [stateVal, setStateVal] = useState('');
  const [website, setWebsite] = useState('');
  // Marketing source — REQUIRED (Mark 2026-07-24): without it every VT-era
  // closing reports a blank lead source forever. Vocabulary = Zoho's history.
  const [marketingSource, setMarketingSource] = useState('');
  const [marketingSourceOther, setMarketingSourceOther] = useState('');
  const [showOptional, setShowOptional] = useState(false);
  // Project (Stage 1.5) fields — captured at discovery completion so the
  // cadence engine + OIR work from day one (Mark 2026-05-27).
  const [ownerFirstName, setOwnerFirstName] = useState('');
  const [ownerLastName, setOwnerLastName] = useState('');
  const [ownerEmail, setOwnerEmail] = useState('');
  const [ownerRole, setOwnerRole] = useState('Owner'); // Owner / CEO / President / …
  const [ownerAdditional, setOwnerAdditional] = useState([]); // [{name,email}] CC'd
  const [committedDate, setCommittedDate] = useState('');
  const [path, setPath] = useState('');               // 'full_valuation' | 'partial'
  // A Lead who self-generates a client acts as both Lead and AM, so default the
  // Lead slot to them (an AM creating leaves it blank to pick the Lead).
  const [lead, setLead] = useState(creatorIsLead ? (creatorName || '') : '');
  // Warm flow: the creator owns the account as AM; default the AM slot to them.
  const [accountManager, setAccountManager] = useState(warmMode ? (creatorName || '') : '');
  const [discoveryDate, setDiscoveryDate] = useState('');
  const [likelihood, setLikelihood] = useState('');
  // 📋 The size screen, required in warm mode (Mark + Zac 10-16, Pro Door & Trim). See QUAL_FLOORS.
  const [qual, setQual] = useState(emptyQual());
  // Partial picker defaults to the minimum-tier documents checked
  // (Mark 2026-05-27); editable before create.
  const [plannedIds, setPlannedIds] = useState(
    DEFAULT_DOCUMENT_CHECKLIST.filter(d => d.tier === 'minimum').map(d => d.id)
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  // SE → create-form prefill (Mark 09-08, Konnie/Blue Spruce: "if it has an
  // ID why are we retyping it?" — the Zoho-era Vista # already lives on the
  // Sales Engine record; fetching it is the machine's job, not Konnie's).
  // When the typed owner email matches an SE record carrying a 6-digit
  // vista_auto_id, the Vista # fills itself (still editable); blank city/
  // state fill too. The note under the field says where the number came
  // from, so nobody wonders.
  const [sePrefillNote, setSePrefillNote] = useState('');
  const [vidOverride, setVidOverride] = useState(false);   // "Already has a Vista #?" — existing numbers only (10-12)
  useEffect(() => {
    let cancelled = false;
    const em = String(ownerEmail || '').trim().toLowerCase();
    if (!supabaseClient || !em || !/@.+\./.test(em)) return undefined;
    const t = setTimeout(async () => {
      try {
        const { data } = await supabaseClient.from('se_owners')
          .select('vista_auto_id, company_name, city, state')
          .overlaps('emails', [em]).limit(1);
        const o = data && data[0];
        if (cancelled || !o) return;
        if (o.vista_auto_id && /^\d{6}$/.test(String(o.vista_auto_id))) {
          setVistaId(prev => prev || String(o.vista_auto_id));
          setSePrefillNote(`Vista # ${o.vista_auto_id} pulled from the Sales Engine record (${o.company_name || 'match by email'}) — their existing number, kept automatically.`);
        }
        if (o.city) setCity(prev => prev || o.city);
        if (o.state) setStateVal(prev => prev || o.state);
      } catch (_) { /* prefill is a convenience — silence on failure */ }
    }, 600);
    return () => { cancelled = true; clearTimeout(t); };
  }, [ownerEmail, supabaseClient]);
  // ShareFile folder auto-provisioning (best-effort). `provisioning` shows a
  // "setting up" state on Save; on failure we hold the modal with `provisionNote`
  // + a Continue button (the client row is already created — `pendingCreated`
  // carries it forward) so account creation is never blocked by ShareFile.
  const [provisioning, setProvisioning] = useState(false);
  const [provisionNote, setProvisionNote] = useState('');
  const [pendingCreated, setPendingCreated] = useState(null);

  // Best-effort call to the ShareFile provisioning endpoint. Creates the client's
  // "New Business" folder tree + subscribes the Data Room. Never throws — returns
  // the server payload or { ok:false, error } so the caller can proceed either way.
  const provisionShareFile = async (vid, name) => {
    try {
      if (!supabaseClient) return { ok: false, error: 'auth not configured' };
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) return { ok: false, error: 'session expired' };
      const r = await fetch('/api/sharefile/provision', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ vistaId: vid, companyName: name }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) return { ok: false, error: d.error || `HTTP ${r.status}` };
      return d;
    } catch (e) {
      return { ok: false, error: e.message || 'network error' };
    }
  };

  const togglePlanned = (id) => setPlannedIds(prev =>
    prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const addOwner = () => setOwnerAdditional(prev => [...prev, { name: '', email: '' }]);
  const updOwner = (i, f, v) => setOwnerAdditional(prev => prev.map((o, idx) => idx === i ? { ...o, [f]: v } : o));
  const rmOwner = (i) => setOwnerAdditional(prev => prev.filter((_, idx) => idx !== i));

  const handleSave = async () => {
    const name = companyName.trim();
    if (!name) return;
    const vid = vistaId.trim();
    // Vista # is OPTIONAL since the in-house mint (061; Mark 08-24 after Adam
    // invented numbers for KC Heating + Aeroform): blank = the DB sequence
    // assigns the next 710xxx at insert. Typed values must be a real 6-digit
    // number (KC arrived with the company NAME in this field) — only for
    // pre-cloud businesses that already carry a Zoho-era number.
    if (vid && !/^\d{6}$/.test(vid)) {
      setError('Vista # must be 6 digits — or leave it BLANK and the tool assigns the next number automatically. Only fill this for a business that already has a Zoho-era Vista #.');
      return;
    }
    // Existing numbers only (Mark 10-12: Adam was copying Zoho's next number, 708227 → 708234). A number
    // that isn't already on a Sales Engine record is a made-up one — the tool assigns those.
    if (vid && supabaseClient) {
      try {
        const { data: hit } = await supabaseClient.from('se_owners').select('id').eq('vista_auto_id', vid).limit(1);
        if (!hit || !hit.length) {
          setError(`No business in Sales Engine has Vista # ${vid}. Leave it to the tool — it assigns the number. (Only an existing number from the business's Sales Engine record can be used.)`);
          return;
        }
      } catch (e) { /* lookup failed — let the save proceed with the existing-format number */ }
    }
    // Every field is required now (Mark 2026-06-23) — no half-filled projects.
    // Shared by both flows: location, full primary contact, Lead. (The only
    // optional fields are the CC'd additional owners and the website.)
    if (!city.trim() || !stateVal.trim()) { setError('City and State are required.'); return; }
    if (!ownerFirstName.trim() || !ownerLastName.trim() || !ownerEmail.trim()) { setError('Owner first name, last name, and email are all required.'); return; }
    if (!ownerRole.trim()) { setError('Primary contact role is required (Owner, CEO, …).'); return; }
    if (!lead.trim()) { setError('Lead is required.'); return; }
    // Marketing source is required (Mark 2026-07-24) — it feeds the Closed
    // Deals lead-source yield; a blank here is a blank in reporting forever.
    const marketingSourceVal = marketingSource === 'Other' ? marketingSourceOther.trim() : marketingSource;
    if (!marketingSourceVal) { setError('Marketing Source is required — how did this prospect come to us?'); return; }
    // Likelihood is captured in BOTH flows now (Mark 2026-06-24): the AM gives an
    // initial read at creation; the Lead can adjust it after the meeting.
    if (likelihood === '' || likelihood == null) { setError('Likelihood % is required.'); return; }
    // The intro/discovery meeting date is required in BOTH flows (Mark 2026-06-24):
    // coordinating + setting that meeting is part of the AM's job.
    if (!discoveryDate) { setError(warmMode ? 'Intro Meeting Date is required.' : 'Discovery Meeting Date is required.'); return; }
    if (warmMode) { const qe = qualError(qual); if (qe) { setError(qe); return; } }
    // The standard (non-AM) flow also captures path / committal / AM up front. The
    // AM warm flow intentionally hides those — the Lead sets them at activation.
    if (!warmMode) {
      if (!path) { setError('Path is required.'); return; }
      if (!committedDate) { setError('Upload Committal Date is required.'); return; }
      if (!accountManager.trim()) { setError('Account Manager is required.'); return; }
    }
    setSaving(true);
    setError('');
    try {
      // Duplicate-OWNER guard (2026-07-21): the portal signs an owner in by
      // EMAIL, resolved to the MOST RECENTLY UPDATED matching deal — so a
      // second account on the same email silently takes over that owner's
      // portal link. A second business under the same owner is legitimate
      // (warn, don't block), but staff must see what it does before creating.
      const emailNorm = ownerEmail.trim();
      if (emailNorm) {
        const emailEsc = emailNorm.replace(/[\\%_]/g, c => '\\' + c);
        const { data: sameOwner, error: soErr } = await supabaseClient
          .from('valuations')
          .select('id, client_id, workflow_stage, lead')
          .ilike('owner_email', emailEsc);
        if (soErr) throw soErr;
        if (sameOwner && sameOwner.length > 0) {
          const cids = [...new Set(sameOwner.map(v => v.client_id).filter(Boolean))];
          const namesById = {};
          if (cids.length) {
            const { data: cs } = await supabaseClient.from('clients').select('id, company_name').in('id', cids);
            (cs || []).forEach(c => { namesById[c.id] = c.company_name; });
          }
          const lines = sameOwner.map(v =>
            `• ${namesById[v.client_id] || '(unknown client)'} — ${(WORKFLOW_STAGES[v.workflow_stage] || {}).label || v.workflow_stage || 'unknown stage'}${v.lead ? `, Lead: ${v.lead}` : ''}`
          ).join('\n');
          const proceed = window.confirm(
            `${emailNorm} is already the owner on:\n\n${lines}\n\n` +
            `ℹ The owner portal signs in by EMAIL and opens the deal whose portal is OPEN (documents released) — so the deal above keeps the portal link unless you release documents on this new one (Mark 10-12).\n\n` +
            `OK — continue (normal when the same owner has a second business).\n` +
            `Cancel — stop and check with the team first.`
          );
          if (!proceed) { setSaving(false); return; }
        }
      }
      // Duplicate-name guard — case-insensitive exact match. If a client
      // with this name already exists, ask whether to use it (the common
      // case) or create a true duplicate (sometimes warranted: same name
      // in a different city). Escape Postgres LIKE wildcards so names
      // like "Smith_Co" can't cause false positives.
      const escaped = name.replace(/[\\%_]/g, c => '\\' + c);
      const { data: existing, error: dupErr } = await supabaseClient
        .from('clients')
        .select('id, company_name, city, state, marketing_source')
        .ilike('company_name', escaped);
      if (dupErr) throw dupErr;
      // projectSetup carries the Stage 1.5 fields forward to the seeded
      // new valuation (see VistaApp.handleNewValuation).
      const projectSetup = {
        owner_first_name: ownerFirstName.trim(),
        owner_last_name: ownerLastName.trim(),
        owner_email: ownerEmail.trim(),
        owner_role: ownerRole.trim(),
        owner_additional: ownerAdditional
          .map(o => ({ name: (o.name || '').trim(), email: (o.email || '').trim() }))
          .filter(o => o.email),
        committed_upload_date: committedDate || '',
        path,
        lead,
        account_manager: accountManager,
        discovery_meeting_date: discoveryDate || '',
        likelihood_pct: likelihood === '' ? '' : likelihood,
        qualification: warmMode ? qual : null,
        plannedIds: path === 'partial' ? plannedIds.slice() : [],
        // AM flow → seed the account as Warm (pre-meeting, off the active
        // pipeline). The seed path sets workflow_stage 'warm' + holds the docs
        // gate, and triggers the intro-email preview after the create.
        warm: !!warmMode,
        // Returning client (old-system re-engagement): active now + organic
        // portal invite, no Lead meeting. Routed to handleReturningClientCreated.
        returningClient: isReturning,
      };
      if (existing && existing.length > 0) {
        const listing = existing.map(c => {
          const loc = [c.city, c.state].filter(Boolean).join(', ');
          return `• ${c.company_name}${loc ? ` (${loc})` : ''}`;
        }).join('\n');
        const useExisting = window.confirm(
          `A client named "${name}" already exists:\n\n${listing}\n\n` +
          `OK — use the existing client.\n` +
          `Cancel — create a new (duplicate) client anyway.`
        );
        if (useExisting) {
          // Backfill the source on an existing client only when it's blank —
          // never overwrite how the relationship originally came to us.
          if (!existing[0].marketing_source) {
            try { await supabaseClient.from('clients').update({ marketing_source: marketingSourceVal }).eq('id', existing[0].id).is('marketing_source', null); } catch (_) {}
          }
          onCreated(existing[0], projectSetup);
          return;
        }
      }
      const { data, error } = await supabaseClient
        .from('clients')
        .insert({
          company_name: name,
          // null → the vista_number_seq trigger mints the next 710xxx (061)
          vista_id: vid || null,
          city: city.trim() || null,
          state: stateVal.trim() || null,
          website: website.trim() || null,
          marketing_source: marketingSourceVal
        })
        .select()
        .single();
      if (error) throw error;
      // The row comes back with the MINTED number when the field was blank —
      // everything downstream (ShareFile, messages) must use data.vista_id,
      // never the (possibly empty) typed value.
      const finalVid = String(data.vista_id || vid || '').trim();
      // Best-effort: auto-provision the client's ShareFile folder tree (New
      // Business template) + subscribe the Data Room. The client row already
      // exists, so a ShareFile failure must NOT lose the account — on failure we
      // hold the modal with a note + Continue button; the Vista-ID auto-link cron
      // remains the fallback once a folder with the ID exists.
      setSaving(false);
      setProvisioning(true);
      const prov = await provisionShareFile(finalVid, name);
      setProvisioning(false);
      if (!prov.ok) {
        setPendingCreated({ data, projectSetup });
        setProvisionNote(
          `Account created — Vista # ${finalVid}. ShareFile folder couldn't be auto-created (${prov.error}) — ` +
          `create a "Data Room" folder with ${finalVid} in its name in ShareFile, or it'll auto-link ` +
          `once a folder containing the ID exists. Click Continue to open the valuation.`
        );
        return;
      }
      onCreated(data, projectSetup);
    } catch (err) {
      console.error('Create project failed:', err);
      setError(err.message || 'Failed to create project.');
      setSaving(false);
    }
  };

  const inputCls = "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-400";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[92vh] flex flex-col">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">{warmMode ? 'New Warm Account' : (isReturning ? 'Returning Client' : 'Start a Project')}</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            {warmMode
              ? 'Pre-meeting setup. Saving sends the owner their portal link + intro email and makes the discovery questions live. The Lead sets the path & committal date after the meeting.'
              : isReturning
              ? 'A business we valued in the old system, re-engaging. Goes active now and sends an organic portal invite — no Lead meeting. Set the path, committal & likelihood here.'
              : 'Captured at discovery — these start the cadence and pre-fill the OIR.'}
          </p>
        </div>
        <div className="px-6 py-4 overflow-y-auto space-y-4">
          <div className="bg-gray-50 border border-gray-200 rounded p-3">
            <div className="text-xs font-semibold text-gray-600 mb-1.5">What kind of account is this?</div>
            <div className="flex gap-2">
              <button type="button" onClick={() => setAccountType('new')}
                className={`flex-1 text-left px-3 py-2 rounded border ${!isReturning ? 'border-green-600 bg-green-50' : 'border-gray-300'}`}>
                <div className={`text-xs font-semibold ${!isReturning ? 'text-green-800' : 'text-gray-700'}`}>New prospect</div>
                <div className="text-[11px] text-gray-500 mt-0.5">Never valued — <strong>or valued years ago</strong>. Full onboarding.</div>
              </button>
              <button type="button" onClick={() => setAccountType('returning')}
                className={`flex-1 text-left px-3 py-2 rounded border ${isReturning ? 'border-green-600 bg-green-50' : 'border-gray-300'}`}>
                <div className={`text-xs font-semibold ${isReturning ? 'text-green-800' : 'text-gray-700'}`}>Returning client</div>
                <div className="text-[11px] text-gray-500 mt-0.5">Recent valuation + ongoing strategic meetings. Active now + portal invite; no Lead meeting.</div>
              </button>
            </div>
            {isReturning && (
              <div className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1.5 mt-1.5">
                ⚠ <strong>Use only when the last valuation is under 12 months old AND you've been having strategic meetings</strong> — this skips the Lead meeting on purpose. Valued <strong>years ago</strong> and now wants a revalue? Use <strong>New prospect</strong> instead (full onboarding — don't skip the steps). Already in VT? Open the existing deal and use ↻ Start Revalue.
              </div>
            )}
          </div>
          {creatorIsLead && !isReturning && (
            <div className="bg-gray-50 border border-gray-200 rounded p-3">
              <div className="text-xs font-semibold text-gray-600 mb-1.5">How are you setting this up?</div>
              <div className="flex gap-2">
                <button type="button" onClick={() => setActiveNow(false)}
                  className={`flex-1 text-left px-3 py-2 rounded border ${!activeNow ? 'border-green-600 bg-green-50' : 'border-gray-300'}`}>
                  <div className={`text-xs font-semibold ${!activeNow ? 'text-green-800' : 'text-gray-700'}`}>Warm — pre-meeting</div>
                  <div className="text-[11px] text-gray-500 mt-0.5">Send the owner their portal link + intro; activate after the meeting.</div>
                </button>
                <button type="button" onClick={() => setActiveNow(true)}
                  className={`flex-1 text-left px-3 py-2 rounded border ${activeNow ? 'border-green-600 bg-green-50' : 'border-gray-300'}`}>
                  <div className={`text-xs font-semibold ${activeNow ? 'text-green-800' : 'text-gray-700'}`}>Active now — already met</div>
                  <div className="text-[11px] text-gray-500 mt-0.5">No portal/intro; set path + committal, goes active immediately.</div>
                </button>
              </div>
            </div>
          )}
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2">
              <label className="block text-xs font-semibold text-gray-600 mb-1">Company Name <span className="text-red-500">*</span></label>
              <input
                type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)}
                className={inputCls} autoFocus
              />
            </div>
            <div>
              {/* No typing (Mark 10-12): Adam was still copying Zoho's next number (708227 → 708234).
                  The business's existing number comes from its Sales Engine record; otherwise the
                  database assigns the next one on save. */}
              <label className="block text-xs font-semibold text-gray-600 mb-1">Vista #</label>
              {!vidOverride ? (
                <div className="px-3 py-2 text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded" title="Assigned by the tool. A business already in Sales Engine keeps its existing number.">
                  {vistaId || 'assigned on save'}
                </div>
              ) : (
                <input type="text" value={vistaId} onChange={(e) => setVistaId(e.target.value)} placeholder="existing 6-digit #" className={inputCls} />
              )}
              {!vistaId && !vidOverride && (
                <button type="button" onClick={() => setVidOverride(true)} className="mt-0.5 text-[11px] text-gray-400 underline hover:text-gray-600"
                  title="Only for a returning business whose number didn't fill in from its email. The number must already be on a Sales Engine record.">Already has a Vista #?</button>
              )}
            </div>
          </div>
          <p className="text-[11px] text-gray-400 -mt-2">The tool assigns the Vista # — a business already in Sales Engine keeps its existing number (it fills in when you enter the owner's email). No need to set anything up in Zoho. The # auto-links the client's ShareFile Data Room.</p>
          {sePrefillNote && <p className="text-[11px] text-emerald-700 -mt-1">✓ {sePrefillNote}</p>}

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Marketing Source <span className="text-red-500">*</span></label>
            <select value={marketingSource} onChange={(e) => setMarketingSource(e.target.value)} className={inputCls}>
              <option value="">— how did this prospect come to us? —</option>
              {MARKETING_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
              <option value="Other">Other…</option>
            </select>
            {marketingSource === 'Other' && (
              <input type="text" value={marketingSourceOther} onChange={(e) => setMarketingSourceOther(e.target.value)}
                placeholder="Describe the source" className={`${inputCls} mt-1.5`} />
            )}
            <p className="text-[11px] text-gray-400 mt-1">Feeds the Closed Deals lead-source reporting — same vocabulary as the Zoho history so old and new report together.</p>
          </div>

          {/* Project setup — Path + Committal are set by the Lead at activation,
              not by the AM pre-meeting, so they're hidden in the warm flow. */}
          {!warmMode && (
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Path <span className="text-red-500">*</span></label>
                <select value={path} onChange={(e) => setPath(e.target.value)} className={inputCls}>
                  <option value="">— select —</option>
                  <option value="full_valuation">Full Valuation</option>
                  <option value="partial">Partial</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-amber-700 mb-1">Upload Committal Date <span className="text-red-500">*</span></label>
                <input type="date" value={committedDate} onChange={(e) => setCommittedDate(e.target.value)} className={`${inputCls} border-amber-300`} />
              </div>
            </div>
          )}
          <div className="grid gap-3 grid-cols-3">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Lead <span className="text-red-500">*</span></label>
              <select value={lead} onChange={(e) => setLead(e.target.value)} className={inputCls}>
                <option value="">—</option>
                {STAFF_LEADS.map(n => <option key={n} value={n}>{n}</option>)}
              </select>
              {warmMode && <p className="text-[11px] text-gray-400 mt-1">Introduced in the intro email as the person leading the project.</p>}
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Account Mgr <span className="text-red-500">*</span></label>
              <select value={accountManager} onChange={(e) => setAccountManager(e.target.value)} className={inputCls}>
                <option value="">—</option>
                {STAFF_AMS.map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Likelihood % <span className="text-red-500">*</span></label>
              <input type="number" min="0" max="100" value={likelihood} onChange={(e) => setLikelihood(e.target.value)} placeholder="0–100" className={inputCls} />
              {warmMode && <p className="text-[11px] text-gray-400 mt-1">Your initial read on selling in ~30 days; the Lead can adjust after the meeting.</p>}
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">{warmMode ? 'Intro Meeting Date' : 'Discovery Meeting Date'} <span className="text-red-500">*</span>{warmMode && <span className="font-normal text-gray-400"> — the meeting you're coordinating; shown in the intro email</span>}</label>
            <input type="date" value={discoveryDate} onChange={(e) => setDiscoveryDate(e.target.value)} className={inputCls} />
          </div>
          {warmMode && <QualificationFields q={qual} setQ={setQual} inputCls={inputCls} />}

          {/* Owner contact */}
          <div className="border-t pt-3">
            <label className="block text-xs font-semibold text-gray-600 mb-1">👤 Primary contact <span className="text-red-500">*</span> <span className="font-normal text-gray-400">— auto-fills OIR / reminder recipient + greeting</span></label>
            <div className="grid grid-cols-3 gap-3 mb-2">
              <input type="text" value={ownerFirstName} onChange={(e) => setOwnerFirstName(e.target.value)} placeholder="First name *" className={inputCls} />
              <input type="text" value={ownerLastName} onChange={(e) => setOwnerLastName(e.target.value)} placeholder="Last name *" className={inputCls} />
              <input type="email" value={ownerEmail} onChange={(e) => setOwnerEmail(e.target.value)} placeholder="Email *" className={inputCls} />
            </div>
            <div className="grid grid-cols-3 gap-3 mb-2">
              <div>
                <label className="block text-[11px] font-semibold text-gray-500 mb-1">Role <span className="text-red-500">*</span></label>
                <select value={ownerRole} onChange={(e) => setOwnerRole(e.target.value)} className={inputCls}>
                  {['Owner', 'CEO', 'President', 'Partner', 'CFO', 'Other'].map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
            </div>
            <label className="block text-xs font-semibold text-gray-600 mb-1 mt-2">🔑 Portal access <span className="font-normal text-gray-400">— anyone else who should get into the portal (co-owner, CEO, etc.). They sign in with their own email and are CC'd on portal emails. Not accountants/attorneys you only correspond with — add those under Professional Contacts.</span></label>
            {ownerAdditional.map((o, i) => (
              <div key={i} className="grid grid-cols-12 gap-2 mb-2 items-center">
                <input type="text" value={o.name} onChange={(e) => updOwner(i, 'name', e.target.value)} placeholder="Name" className={`${inputCls} col-span-5`} />
                <input type="email" value={o.email} onChange={(e) => updOwner(i, 'email', e.target.value)} placeholder="Email" className={`${inputCls} col-span-6`} />
                <button type="button" onClick={() => rmOwner(i)} className="col-span-1 text-gray-400 hover:text-red-600 text-lg leading-none" title="Remove">×</button>
              </div>
            ))}
            <button type="button" onClick={addOwner} className="px-3 py-1.5 text-xs font-medium rounded bg-gray-100 text-gray-700 hover:bg-gray-200">
              + Add portal access
            </button>
          </div>

          {/* Partial → planned items */}
          {path === 'partial' && (
            <div className="border-t pt-3">
              <label className="block text-xs font-semibold text-gray-600 mb-1">Items the owner plans to provide <span className="font-normal text-gray-400">— drives the "X of Y" progress</span></label>
              <div className="border border-gray-200 rounded p-2 max-h-44 overflow-y-auto space-y-1">
                {DEFAULT_DOCUMENT_CHECKLIST.map(d => (
                  <label key={d.id} className="flex items-start gap-2 text-xs cursor-pointer hover:bg-gray-50 rounded px-1 py-0.5">
                    <input type="checkbox" checked={plannedIds.includes(d.id)} onChange={() => togglePlanned(d.id)} className="mt-0.5" />
                    <span className="text-gray-700">{d.name}</span>
                  </label>
                ))}
              </div>
              <p className="text-[11px] text-gray-400 mt-1">{plannedIds.length} selected (minimum docs pre-checked). Leave empty to track all 18.</p>
            </div>
          )}

          {/* Location — required in both flows. Website stays optional below. */}
          <div className="border-t pt-3">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">City <span className="text-red-500">*</span></label>
                <input type="text" value={city} onChange={(e) => setCity(e.target.value)} className={inputCls} />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">State <span className="text-red-500">*</span></label>
                <input type="text" value={stateVal} onChange={(e) => setStateVal(e.target.value)} maxLength={2} className={inputCls} />
              </div>
            </div>
          </div>

          {/* Website — the only optional field; everything else above is required. */}
          <div className="border-t pt-2">
            <button type="button" onClick={() => setShowOptional(o => !o)} className="text-xs font-semibold text-gray-500 hover:text-gray-700">
              {showOptional ? '▾' : '▸'} Website (optional)
            </button>
            {showOptional && (
              <div className="mt-2">
                <input type="text" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="example.com" className={inputCls} />
              </div>
            )}
          </div>

          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2">{error}</div>}
          {provisionNote && <div className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">{provisionNote}</div>}
        </div>
        <div className="flex justify-end gap-2 px-6 py-4 border-t">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800">Cancel</button>
          {pendingCreated ? (
            <button onClick={() => onCreated(pendingCreated.data, pendingCreated.projectSetup)} className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-700">
              Continue & Open
            </button>
          ) : (
            <button onClick={handleSave} disabled={saving || provisioning || !companyName.trim()} className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-700 disabled:bg-gray-300">
              {provisioning ? 'Setting up ShareFile…' : saving ? 'Creating…' : (warmMode ? 'Create Warm Account' : 'Create & Open')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Maps the account owner's display name to their Gmail multi-sender key
// (server.js GMAIL_SENDERS). The warm-account intro email sends AS whoever owns
// the account in the AM slot — an AM (Adam/J.C.) OR a Lead acting as both
// (Zac/Thatcher), so all four STAFF_AMS are mapped. Returns null only if there's
// no connected sender — the modal then blocks the send with a "connect Gmail"
// message rather than silently falling back to Konnie.
const AM_GMAIL_SENDER = { 'Adam': 'adam', 'J.C.': 'jc', 'Zac': 'zac', 'Thatcher': 'thatcher' };
// amOwner (defined with the staffing config below): a departed AM's deals
// send as the inheriting AM — J.C.'s Gmail token is being retired.
const amSenderKey = (name) => AM_GMAIL_SENDER[amOwner(String(name || '').trim())] || null;

// Lead → Gmail sender key (server.js GMAIL_SENDERS). The docs-ready email sends
// AS the Lead the owner already knows; the server falls back to Konnie if that
// Lead's Gmail isn't connected yet.
const LEAD_GMAIL_SENDER = { 'Zac': 'zac', 'Thatcher': 'thatcher' };
const leadGmailKey = (name) => LEAD_GMAIL_SENDER[String(name || '').trim()] || null;

// Builds the "your document list is ready" email, sent to the owner when the
// Lead activates (releases the documents to the portal). Vista-branded, from the
// Lead, with a clear next step + timeliness framing. (2026-06-23)
// Shared "Secure Document Portal" template chrome for the docs-ready + revalue-
// review emails: an editable body (plain-text paragraphs) wrapped in the locked
// Vista header, portal button, sign-in note, and signature. (Mark 2026-06-24)
const buildPortalEmailHtml = ({ bodyText, signerName, portalUrl, extraHtml }) => {
  const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const FONT = "'Segoe UI', Helvetica, Arial, sans-serif";
  const signer = (signerName || '').trim() || 'Vista Business Group';
  const bodyHtml = String(bodyText || '').split(/\n\s*\n/)
    .map(p => `<p style="margin:0 0 14px;white-space:pre-wrap;">${esc(p.trim())}</p>`).join('')
    + (extraHtml || '');
  return `<div style="background:#f4f4f0;padding:0;margin:0;font-family:${FONT};">
    <div style="max-width:560px;margin:0 auto;">
      <div style="background:#3d5c35;padding:20px 24px;">
        <div style="font-size:20px;font-weight:700;color:#ffffff;letter-spacing:.2px;">Vista Business Group</div>
        <div style="font-size:13px;color:#c9d6c3;margin-top:2px;">Secure Document Portal</div>
      </div>
      <div style="background:#ffffff;padding:24px;color:#1a1a1a;line-height:1.55;border:1px solid #ececec;border-top:0;">
        ${bodyHtml}
        <p style="margin:22px 0;"><a href="${esc(portalUrl)}" style="background:#3d5c35;color:#fff;text-decoration:none;padding:12px 24px;border-radius:6px;font-weight:600;display:inline-block;">Open my secure portal</a></p>
        <p style="font-size:12px;color:#666;margin:0 0 18px;">If you've used the portal in the last few days, the button takes you straight in. Otherwise, enter the email address this message was sent to and we'll send you a fresh sign-in link.</p>
        <p style="margin:0 0 2px;">Thanks,</p>
        <p style="margin:0;font-weight:600;">${esc(signer)}</p>
        <p style="margin:0;font-size:13px;color:#666;">Vista Business Group</p>
      </div>
      <div style="text-align:center;padding:16px;color:#999;font-size:11px;">Vista Business Group · Confidential</div>
    </div>
  </div>`;
};

// Editable prose of the docs-ready email ("your document list is ready").
// This is the HANDOFF MOMENT (Thatcher/Mark 2026-07-23): document emails come
// FROM Konnie — she manages collection and owners' replies belong with her —
// so the first document email INTRODUCES her by way of the Lead the owner
// already knows. Every later document email (reminders, re-requests, as-of)
// then arrives from someone the owner was told about.
const docsReadyBodyText = ({ ownerFirstName, companyName, committalDate, leadName }) => {
  const name = (ownerFirstName || '').trim();
  const company = (companyName || '').trim() || 'your business';
  const lead = (leadName || '').trim();
  const greeting = name ? `Hi ${name},` : 'Hi,';
  const intro = `I'm Konnie — I work with ${lead || 'the team'} here at Vista Business Group and manage document collection for your valuation. I'll be your contact for uploads and any questions about your document list.`;
  const main = `Following up on ${lead ? `your conversation with ${lead}` : 'our conversation'} about ${company} — the list of documents we need for your valuation is now ready in your secure portal. Most come straight from your accounting software, and you can upload them right there.`;
  const byLine = committalDate
    ? `We're aiming to have everything in by ${new Date(committalDate + 'T00:00:00').toLocaleDateString(undefined, { month: 'long', day: 'numeric' })} — getting the documents to us around then keeps your numbers current. If that timing doesn't work for you, just let us know.`
    : '';
  return [greeting, intro, main, byLine].filter(Boolean).join('\n\n');
};
const buildDocsReadyEmailHtml = ({ ownerFirstName, leadName, companyName, committalDate, portalUrl, bodyText }) => {
  const text = (bodyText != null && String(bodyText).trim() !== '')
    ? bodyText : docsReadyBodyText({ ownerFirstName, companyName, committalDate, leadName });
  // The QB-guide callout ships as fixed HTML, not editable prose (Konnie
  // 08-31: "the last several companies have sent reports with the wrong
  // format and time frame" — the bold pointer survives any staff edit to
  // the body). The guide itself is portal-gated and date-matched per
  // engagement, so we point INTO the portal rather than attach a copy
  // whose dates would go stale.
  const guideCallout = `<p style="margin:0 0 14px;background:#f0f4ee;border-left:4px solid #3d5c35;padding:10px 12px;">`
    + `<strong>One thing before you export anything: open the \u{1F4D8} QuickBooks Report Guide — the first link inside your portal. It shows the exact format, settings, and date ranges each report needs.</strong> `
    + `Reports exported without it usually arrive in the wrong format or time frame, and we have to ask you to redo them.</p>`;
  return buildPortalEmailHtml({ bodyText: text, signerName: 'Konnie', portalUrl, extraHtml: guideCallout });
};

// Editable prose of the revalue "review your answers" email — prior answers are
// carried forward in review-mode, so this asks the owner to review and update
// what's changed; the document list follows once Konnie curates it.
const revalueReviewBodyText = ({ ownerFirstName, companyName }) => {
  const name = (ownerFirstName || '').trim();
  const company = (companyName || '').trim() || 'your business';
  const greeting = name ? `Hi ${name},` : 'Hi,';
  const p1 = `We're picking back up on your business valuation for ${company}. To get started, we've reopened your secure portal — and the answers you shared with us previously are already filled in.`;
  const p2 = `Please take a few minutes to review each answer and update anything that's changed — then let us know you're finished. We'll send the list of documents we need shortly after.`;
  return [greeting, p1, p2].join('\n\n');
};
const buildRevalueReviewEmailHtml = ({ ownerFirstName, leadName, companyName, portalUrl, bodyText }) => {
  const text = (bodyText != null && String(bodyText).trim() !== '')
    ? bodyText : revalueReviewBodyText({ ownerFirstName, companyName });
  return buildPortalEmailHtml({ bodyText: text, signerName: leadName, portalUrl });
};

// Organic "here's your secure portal + how it works" invite for a RETURNING
// client (valued in the old system, re-engaging). Not the templated Lead intro —
// no meeting, no Lead introduction; just the portal link + how to use it. Editable
// in the review-and-send modal before it goes. (2026-07-02)
const portalInviteBodyText = ({ ownerFirstName, companyName }) => {
  const name = (ownerFirstName || '').trim();
  const company = (companyName || '').trim() || 'your business';
  const greeting = name ? `Hi ${name},` : 'Hi,';
  const p1 = `Good to be reconnecting on the valuation of ${company}. To make this easy, we've set up a secure online portal where you can answer a few questions about the business and, shortly, upload the documents we'll need — all in one place.`;
  const p2 = `Click the button below to get in: enter your email and we'll send you a one-time secure sign-in link (no password to remember). Once you're in, you'll see a short set of questions to answer — please fill those in when you have a few minutes.`;
  const p3 = `Anything at all, just reply to this email.`;
  return [greeting, p1, p2, p3].join('\n\n');
};

// Builds the warm-account intro email (Warm → Active onboarding). Framed per
// Mark's D1 feedback: greet by first name, position the upcoming meeting as an
// "introductory meeting with the person who'll lead your project", introduce
// the Lead by name, optional meeting date, signed by the AM. The portal button
// links to the sign-in page where the owner self-requests their secure link
// (the emailed 30-min magic link would expire before a pre-meeting open).
// The editable prose of the intro email — everything between the header and the
// portal button. Staff send it as-is or tweak it in the modal; the branding,
// portal button, sign-in note, and signature stay locked. (Mark 2026-06-24:
// "send the pre-written email or edit it.")
const introBodyText = ({ ownerFirstName, leadName, companyName, meetingDate, isReengagement = false, amIsLead = false }) => {
  const name = (ownerFirstName || '').trim();
  const company = (companyName || '').trim() || 'your business';
  const lead = (leadName || '').trim() || 'your project lead';
  const leadFirst = lead.split(' ')[0];
  const mtg = (meetingDate || '').trim();
  const greeting = name ? `Hi ${name},` : 'Hi,';
  const opening = isReengagement
    ? `It's been a little while since we last looked at ${company} together — we're glad to be picking things back up with you.`
    : `Thank you for taking the time to speak with us about ${company}. We're glad to be working with you.`;
  // When the sender (AM) is also the Lead — a Lead who self-generated the client
  // and is acting as both — the intro reads first-person instead of introducing
  // a separate Lead in the third person.
  const leadIntro = amIsLead
    ? (isReengagement
        ? `I'll be leading your valuation again personally. I guide the valuation, walk you through your options, and will be your point of contact throughout.`
        : `I'll be leading your valuation personally. I guide the valuation, walk you through your options, and will be your point of contact throughout.`)
    : (isReengagement
        ? `${lead} will be leading your valuation this time around. ${leadFirst} guides the valuation, walks you through your options, and will be your point of contact throughout.`
        : `Ahead of the introductory meeting, I'd like to introduce you to ${lead}, who will lead your project. ${leadFirst} guides the valuation, walks you through your options, and will be your point of contact throughout.`);
  // Personalize who is looking forward to the meeting: first person when the AM
  // is also the Lead, otherwise the Lead by name (warmer than a generic "we").
  const whoLooks = amIsLead ? `I'm` : `${leadFirst} is`;
  const mtgLine = mtg
    ? `${whoLooks} looking forward to ${isReengagement ? 'catching up with you' : 'meeting you'} on ${new Date(mtg + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })}.`
    : '';
  const portalLine = isReengagement
    ? `We've reopened your secure portal — your previous answers are already there for you to review and update, and you'll share any new documents in the same place when the time comes.`
    : `To make things easy, we've set up a secure online portal — one place to answer a few quick questions and, when the time comes, share documents. It's a short list (mostly a few reports straight from your accounting software).`;
  const timeliness = `Getting everything to us promptly is what keeps your numbers current and your valuation accurate. When information comes in piecemeal over several weeks, the earlier reports can go stale and need re-running — so the sooner it's all in, the better the picture we can give you.`;
  // Portal education pointer (2026-07-23): the ambient CA + selling guide live
  // in the portal from day one — this line makes sure the owner knows to look.
  const educationLine = `You'll also find two things waiting in the portal: our confidentiality agreement, already signed on our side — everything you share with us is covered from day one — and a short guide to how selling a business works, start to finish.`;
  return [greeting, opening, leadIntro, mtgLine, portalLine, educationLine, timeliness].filter(Boolean).join('\n\n');
};

// Wrap the (editable) prose in the locked Vista template. `bodyText` is the
// editable middle; if omitted, the default prose is generated.
const buildIntroEmailHtml = ({ ownerFirstName, leadName, amName, companyName, meetingDate, portalUrl, isReengagement = false, bodyText }) => {
  const esc = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const FONT = "'Segoe UI', Helvetica, Arial, sans-serif";
  const am = (amName || '').trim() || 'Vista Business Group';
  const amIsLead = !!(amName || '').trim() && (amName || '').trim().split(/\s+/)[0].toLowerCase() === (leadName || '').trim().split(/\s+/)[0].toLowerCase();
  const text = (bodyText != null && String(bodyText).trim() !== '')
    ? bodyText
    : introBodyText({ ownerFirstName, leadName, companyName, meetingDate, isReengagement, amIsLead });
  const bodyHtml = String(text).split(/\n\s*\n/)
    .map(p => `<p style="margin:0 0 14px;white-space:pre-wrap;">${esc(p.trim())}</p>`).join('');
  return `<div style="background:#f4f4f0;padding:0;margin:0;font-family:${FONT};">
    <div style="max-width:560px;margin:0 auto;">
      <div style="background:#3d5c35;padding:20px 24px;">
        <div style="font-size:20px;font-weight:700;color:#ffffff;letter-spacing:.2px;">Vista Business Group</div>
        <div style="font-size:13px;color:#c9d6c3;margin-top:2px;">Business Valuation</div>
      </div>
      <div style="background:#ffffff;padding:24px;color:#1a1a1a;line-height:1.55;border:1px solid #ececec;border-top:0;">
        ${bodyHtml}
        <p style="margin:22px 0;"><a href="${esc(portalUrl)}" style="background:#3d5c35;color:#fff;text-decoration:none;padding:12px 24px;border-radius:6px;font-weight:600;display:inline-block;">Open my secure portal</a></p>
        <p style="font-size:12px;color:#666;margin:0 0 18px;">Your email is already filled in — just confirm it and we'll send you a one-time secure sign-in link. (This quick step is how we keep your information protected.) The link is good for 30 minutes, so it's best to open it right away.</p>
        <p style="margin:0 0 2px;">We're looking forward to working with you,</p>
        <p style="margin:0;font-weight:600;">${esc(am)}</p>
        <p style="margin:0;font-size:13px;color:#666;">Vista Business Group</p>
      </div>
      <div style="text-align:center;padding:16px;color:#999;font-size:11px;">Vista Business Group · Confidential</div>
    </div>
  </div>`;
};

// Preview-and-send modal for the warm-account intro email. Standalone (no
// valuation-editor state, no engagement_id required — the owner self-requests
// their portal link), so it's reusable from the create flow AND the AM's My
// Work "Resend" action. Sends AS the AM via /api/gmail/send; logs an `outreach`
// activity directly (bypassing the AM read-only guard — this is their one
// permitted write). (2026-06-16)
const IntroEmailModal = ({ engagementId = null, ownerFirstName = '', ownerEmail = '', ownerAdditional = [], leadName = '', amName = '', companyName = '', meetingDate = '', actorEmail = '', isReengagement = false, mandatory = false, onClose, onSent }) => {
  // AM = Lead (a Lead who self-generated the client and acts as both): the intro
  // reads first-person rather than introducing a separate Lead.
  const amIsLead = !!(amName || '').trim() && (amName || '').trim().split(/\s+/)[0].toLowerCase() === (leadName || '').trim().split(/\s+/)[0].toLowerCase();
  // The full message body is editable — pre-filled with the default prose; staff
  // send as-is or tweak it. The branding/portal button/signature stay locked.
  const [body, setBody] = useState(() => introBodyText({ ownerFirstName, leadName, companyName, meetingDate, isReengagement, amIsLead }));
  // ✏ THE DATE IS FIXABLE HERE (Adam 09-11: clicked the wrong meeting date
  // creating a client, caught it proofreading the email, and — with no way
  // back — hand-edited the PROSE, leaving the stored date wrong while the
  // owner read the right one. The stored date drives prep cards and
  // first-mile timing, so it must be the thing that gets fixed. Editing it
  // here writes through to the deal AND regenerates the email — unless the
  // body was hand-edited, in which case the record still updates and the
  // author keeps their prose.)
  const [mtgDate, setMtgDate] = useState(meetingDate || '');
  const [bodyTouched, setBodyTouched] = useState(false);
  const [dateSaved, setDateSaved] = useState(null);
  const changeMeetingDate = async (d) => {
    setMtgDate(d);
    if (!d || !/^\d{4}-\d{2}-\d{2}$/.test(d)) return;
    if (!bodyTouched) setBody(introBodyText({ ownerFirstName, leadName, companyName, meetingDate: d, isReengagement, amIsLead }));
    if (engagementId && supabaseClient) {
      try {
        const { error } = await supabaseClient.from('valuations')
          .update({ discovery_meeting_date: d, updated_at: new Date().toISOString() }).eq('id', engagementId);
        setDateSaved(error ? 'error' : 'ok');
      } catch (_) { setDateSaved('error'); }
    }
  };
  const [to, setTo] = useState(ownerEmail || '');
  // Title-case subjects (Adam 09-11: "I've been doing it manually").
  const [subject, setSubject] = useState(isReengagement ? 'Reconnecting About Your Valuation — Vista Business Group' : 'An Introduction From Vista Business Group');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const senderKey = amSenderKey(amName);
  // #12: carry the owner's email as a hint on the portal link so the sign-in
  // field is pre-filled (one click → Send my secure link, no typing). Uses the
  // URL HASH (#e=…), which is never sent to the server, so the address isn't
  // logged. It's the owner's own email and grants nothing on its own — the
  // secure two-hop flow (request → short-lived link) is unchanged. (Colleen 2026-06-30)
  const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal'
    + ((to || '').trim() ? '#e=' + encodeURIComponent((to || '').trim()) : '');
  // CC the Lead being introduced (so they're looped in + the owner can reply-all
  // to reach them), plus any additional owner contacts. De-duped. (2026-06-23)
  const ccList = (() => {
    const leadEmail = staffEmailByName(leadName);
    const list = [leadEmail, ...(ownerAdditional || []).map(o => (o && o.email ? String(o.email).trim() : ''))].filter(Boolean);
    return [...new Set(list.map(e => e.toLowerCase()))].map(low => list.find(e => e.toLowerCase() === low));
  })();

  const html = buildIntroEmailHtml({ ownerFirstName, leadName, amName, companyName, meetingDate: mtgDate, portalUrl, isReengagement, bodyText: body });

  const send = async () => {
    if (!to.trim() || !subject.trim()) { setResult({ ok: false, msg: 'Recipient email and subject are both required.' }); return; }
    if (!senderKey) { setResult({ ok: false, msg: `No Gmail sender is connected for ${amName || 'this AM'}. Connect it at /api/gmail/auth/<who> before sending the intro.` }); return; }
    setSending(true); setResult(null);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) throw new Error('Your session expired — reload the page and sign in again.');
      const resp = await fetch('/api/gmail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ to: to.trim(), cc: ccList.length ? ccList.join(', ') : undefined, subject: subject.trim(), body: html, sender: senderKey }),
      });
      const r = await resp.json().catch(() => ({}));
      if (!resp.ok || !r.ok) throw new Error(r.error || `Send failed (HTTP ${resp.status})`);
      // Log the outreach (AM's permitted write — direct insert bypasses the
      // editor's read-only guard). Best-effort; never fail the send on a log error.
      if (engagementId && supabaseClient) {
        try {
          await supabaseClient.from('project_activity_log').insert({
            project_id: engagementId,
            actor_email: actorEmail || 'unknown',
            actor_name: actorEmail ? actorEmail.split('@')[0] : (amName || null),
            kind: 'outreach',
            note: `Intro email + portal link sent to ${to.trim()}`,
            metadata: { kind: 'warm_intro', to: to.trim(), sender: senderKey },
          });
        } catch (logErr) { console.warn('Intro outreach log failed:', logErr); }
      }
      setResult({ ok: true, msg: 'Intro email sent.' });
      setTimeout(() => { if (onSent) onSent(); }, 1200);
    } catch (err) {
      setResult({ ok: false, msg: err.message || 'Send failed.' });
    } finally {
      setSending(false);
    }
  };

  const inputCls = "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-400";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[92vh] flex flex-col">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">Send intro email</h2>
          <p className="text-xs text-gray-500 mt-0.5">Sends as <strong>{amName || '—'}</strong>. The owner gets a portal link + a first-name intro to {leadName || 'the Lead'}. Review and tweak the message before sending.</p>
          {mandatory && (
            <p className="text-xs font-semibold text-amber-700 mt-1">This email is part of creating the account — it's how the owner gets their portal link, so it can't be skipped.</p>
          )}
        </div>
        <div className="px-6 py-4 overflow-y-auto space-y-3">
          {!senderKey && (
            <div className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">
              No Gmail sender is connected for {amName || 'this AM'}. Connect it via <code>/api/gmail/auth/&lt;who&gt;</code> before the intro can send.
            </div>
          )}
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">To</label>
              <input type="email" value={to} onChange={(e) => setTo(e.target.value)} className={inputCls} />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Subject</label>
              <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} className={inputCls} />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Meeting date <span className="font-normal text-gray-400">— wrong? fix it here</span></label>
              <input type="date" value={mtgDate} onChange={(e) => changeMeetingDate(e.target.value)} className={inputCls}
                title="Clicked the wrong date on the form? Change it here — it updates the account AND the email text together, so the system and the owner hear the same date." />
              {dateSaved === 'ok' && <p className="text-[11px] text-green-700 mt-0.5">✓ date fixed on the account + in the email</p>}
              {dateSaved === 'error' && <p className="text-[11px] text-red-600 mt-0.5">couldn't save the date — fix it on the Setup tab after sending</p>}
            </div>
          </div>
          {ccList.length > 0 && <p className="text-[11px] text-gray-400">CC: {ccList.join(', ')}</p>}
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Message <span className="font-normal text-gray-400">— send as-is or edit it to suit this owner</span></label>
            <textarea value={body} onChange={(e) => { setBody(e.target.value); setBodyTouched(true); }} rows={10} className={inputCls} placeholder="The message body…" />
            <p className="text-[11px] text-gray-400 mt-1">This is the editable body. The Vista header, the “Open my secure portal” button, the sign-in note, and your signature are added automatically (see the preview).</p>
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Preview</label>
            <iframe title="Intro email preview" srcDoc={html} className="w-full border border-gray-200 rounded" style={{ height: '320px' }} />
          </div>
          {result && (
            <div className={`text-sm rounded p-2 border ${result.ok ? 'text-green-700 bg-green-50 border-green-200' : 'text-red-600 bg-red-50 border-red-200'}`}>{result.msg}</div>
          )}
        </div>
        <div className="flex justify-end gap-2 px-6 py-4 border-t">
          {/* Mandatory (warm-create) mode: no Cancel until the send succeeds —
              a warm account without the intro is an owner with no portal link
              (Mark 2026-07-24). Escape hatches stay: no connected Gmail sender
              means sending is impossible, so Cancel returns rather than
              trapping the modal. */}
          {(!mandatory || !senderKey || (result && result.ok)) && (
            <button onClick={onClose} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800">{result && result.ok ? 'Close' : 'Cancel'}</button>
          )}
          <button onClick={send} disabled={sending || (result && result.ok)} className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-700 disabled:bg-gray-300">
            {sending ? 'Sending…' : 'Send intro email'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Generic review-and-send modal for the owner emails that used to fire
// automatically (docs-ready, revalue-review). Pre-fills an editable body +
// subject so staff always see what's going out and can tweak before sending.
// `buildHtml(bodyText)` wraps the editable body in that email's locked template.
// (Mark 2026-06-24 — "send the pre-written email or edit it.")
const EmailReviewModal = ({ heading, hint, to, cc = [], subject: subj0 = '', sender, senderFixed = false, defaultBody = '', buildHtml, onClose, onSent, onBack, backLabel, logActivity = null }) => {
  const [body, setBody] = useState(defaultBody);
  const [subject, setSubject] = useState(subj0);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const inputCls = "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-400";
  const ccStr = (Array.isArray(cc) ? cc : []).filter(Boolean).join(', ');
  // Sender choice (Colleen 08-19): the voice the owner hears from should be
  // the relationship-holder's — default to the person clicking Send when
  // their mailbox is connected, else the caller's suggestion, else Konnie;
  // always visible, always changeable; "not connected" shown plainly
  // instead of the server's silent Konnie fallback.
  const [senders, setSenders] = useState(null);
  const [senderPick, setSenderPick] = useState(sender || 'konnie');
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: { session } } = await supabaseClient.auth.getSession();
        const at = session && session.access_token;
        const r = await fetch('/api/gmail/senders', { headers: { Authorization: 'Bearer ' + at } });
        const d = await r.json();
        if (cancelled || !d || !Array.isArray(d.senders)) return;
        setSenders(d.senders);
        const me = String((session && session.user && session.user.email) || '').toLowerCase();
        const mine = d.senders.find(x => x.connected && String(x.from || '').toLowerCase().includes('<' + me + '>'));
        const suggested = d.senders.find(x => x.key === (sender || '').toLowerCase());
        // FIXED-VOICE templates (Thatcher 09-11, the release-docs modal: the
        // dropdown defaulted to HIM while the prose said "I'm Konnie" — he
        // was hand-switching every send). When the body is written in a
        // specific person's voice, the caller's sender WINS over the
        // default-to-me rule; relationship emails keep defaulting to the
        // person clicking Send (Colleen 08-19).
        if (senderFixed && suggested && suggested.connected) setSenderPick(suggested.key);
        else if (mine) setSenderPick(mine.key);
        else if (suggested && suggested.connected) setSenderPick(suggested.key);
        else setSenderPick('konnie');
      } catch (_) { /* dropdown falls back to the plain label */ }
    })();
    return () => { cancelled = true; };
  }, []);
  // The signature must match the mailbox (Colleen 08-20): buildHtml gets
  // the picked sender's display name as a second arg — templates that sign
  // per-sender use it; fixed-signer templates (docs-ready is deliberately
  // Konnie, her prose introduces her) simply ignore it.
  const senderDisplay = senderPick ? senderPick.charAt(0).toUpperCase() + senderPick.slice(1) : '';
  const html = buildHtml ? buildHtml(body, senderDisplay) : '';
  const send = async () => {
    if (!to || !subject.trim()) { setResult({ ok: false, msg: 'Recipient and subject are both required.' }); return; }
    setSending(true); setResult(null);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const at = session && session.access_token;
      if (!at) throw new Error('Your session expired — reload and sign in again.');
      const resp = await fetch('/api/gmail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + at },
        body: JSON.stringify({ to, cc: ccStr || undefined, subject: subject.trim(), body: html, sender: senderPick || sender || 'konnie', logActivity: logActivity || undefined }),
      });
      const r = await resp.json().catch(() => ({}));
      if (!resp.ok || !r.ok) throw new Error(r.error || `Send failed (HTTP ${resp.status})`);
      setResult({ ok: true, msg: 'Sent.' });
      // Server owns the durable log write now; tell onSent whether it landed so
      // it can fall back (tab-side) only when the server said it did not.
      if (onSent) { try { onSent({ logged: !!r.logged }); } catch (_) {} }
      setTimeout(() => onClose && onClose(), 900);
    } catch (e) {
      setResult({ ok: false, msg: e.message || 'Send failed.' });
    } finally { setSending(false); }
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[92vh] flex flex-col">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">{heading || 'Review & send email'}</h2>
          {hint && <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1 mt-1">{hint}</p>}
          <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-2 flex-wrap">
            <span>To: {to || '—'}{ccStr ? ` · CC: ${ccStr}` : ''}</span>
            <span>· sends as</span>
            {senders ? (
              <select
                value={senderPick}
                onChange={e => setSenderPick(e.target.value)}
                className="border border-gray-300 rounded px-1.5 py-0.5 text-xs bg-white"
                title="Whose mailbox this goes out from — pick the person the owner actually knows. Greyed = that person's Gmail isn't connected yet (it would silently send as Konnie)."
              >
                {senders.map(x => (
                  <option key={x.key} value={x.key} disabled={!x.connected}>
                    {x.key.charAt(0).toUpperCase() + x.key.slice(1)}{x.connected ? '' : ' (not connected)'}
                  </option>
                ))}
              </select>
            ) : <span>{senderPick}</span>}
          </p>
          {senderFixed && senderPick && senderPick !== (sender || 'konnie') && (
            <p className="text-xs text-red-700 bg-red-50 border border-red-200 rounded px-2 py-1 mt-1">⚠ This email's wording is written in {(sender || 'konnie').charAt(0).toUpperCase() + (sender || 'konnie').slice(1)}'s voice — sending it as {senderPick.charAt(0).toUpperCase() + senderPick.slice(1)} will read wrong unless you rewrite the body.</p>
          )}
        </div>
        <div className="px-6 py-4 overflow-y-auto space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Subject</label>
            <input type="text" value={subject} onChange={e => setSubject(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Message <span className="font-normal text-gray-400">— send as-is or edit it</span></label>
            <textarea value={body} onChange={e => setBody(e.target.value)} rows={9} className={inputCls} />
            <p className="text-[11px] text-gray-400 mt-1">The Vista header, portal button, sign-in note, and signature are added automatically (see preview).</p>
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Preview</label>
            <iframe title="Email preview" srcDoc={html} className="w-full border border-gray-200 rounded" style={{ height: '300px' }} />
          </div>
          {result && (
            <div className={`text-sm rounded p-2 border ${result.ok ? 'text-green-700 bg-green-50 border-green-200' : 'text-red-600 bg-red-50 border-red-200'}`}>{result.msg}</div>
          )}
        </div>
        <div className="flex items-center gap-2 px-6 py-4 border-t">
          {/* Back returns to the modal this email came from (entries preserved
              by the caller) — hidden once the email has sent. */}
          {onBack && !(result && result.ok) && (
            <button onClick={onBack} disabled={sending} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800 border border-gray-300 rounded">{backLabel || '← Back'}</button>
          )}
          <div className="flex-1" />
          <button onClick={onClose} disabled={sending} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800">{result && result.ok ? 'Close' : 'Cancel'}</button>
          <button onClick={send} disabled={sending || (result && result.ok)} className="px-4 py-2 bg-green-600 text-white rounded text-sm font-semibold hover:bg-green-700 disabled:bg-gray-300">
            {sending ? 'Sending…' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Fireflies meeting-notes panel. Fetches the owner's Fireflies transcript
// summaries via /api/fireflies/transcripts (server proxies to Fireflies
// GraphQL with the API key server-side). Match is by participant email,
// so the panel re-fetches whenever `ownerEmail` changes. Card per meeting:
// title + date + duration; click to expand the overview + action items;
// "Open full transcript" links out to Fireflies for the raw conversation.
// (Mark 2026-05-27 — summary in VT, link out for the full read.)
const FirefliesNotesPanel = ({ ownerEmail, additionalEmails, autoExpandFirst = false, overviewOnly = false }) => {
  const [transcripts, setTranscripts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState({});
  const [fetchedFor, setFetchedFor] = useState('');
  // 🔗 Link a recording by hand (Colleen 10-12, Dem360): Fireflies added to a meeting manually often records
  // without the guest list, so the owner's email never matches. Pick the meeting + the recording; the server
  // stores it on the meeting and the list below includes it from then on.
  const [linkOpen, setLinkOpen] = useState(false);
  const [linkData, setLinkData] = useState(null);
  const [linkMeetingId, setLinkMeetingId] = useState('');
  const [linkBusy, setLinkBusy] = useState(false);
  const [linkErr, setLinkErr] = useState('');

  // Every address this owner might attend under — primary + any CC'd owners
  // (an owner with two emails has meetings recorded under both). Serialized to
  // a stable string so the effect doesn't refire when the parent passes a fresh
  // array instance each render.
  const emailKey = [ownerEmail, ...(additionalEmails || [])]
    .map(e => (e || '').trim().toLowerCase())
    .filter(Boolean)
    .filter((e, i, a) => a.indexOf(e) === i)
    .join('|');

  const fetchTranscripts = async () => {
    const emails = emailKey ? emailKey.split('|') : [];
    if (emails.length === 0) return;
    setLoading(true);
    setError('');
    try {
      if (!supabaseClient) throw new Error('Auth not configured.');
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) throw new Error('Your session expired — reload the page and sign in again.');
      const r = await fetch('/api/fireflies/transcripts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ emails }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || `Fetch failed (HTTP ${r.status})`);
      // Most recent first.
      const sorted = (d.transcripts || []).slice().sort((a, b) => {
        const ta = a.date ? new Date(a.date).getTime() : 0;
        const tb = b.date ? new Date(b.date).getTime() : 0;
        return (tb || 0) - (ta || 0);
      });
      setTranscripts(sorted);
      // Meeting-prep (Mark 09-16): on a strategic-review card the last recap
      // should be READABLE with no clicks — auto-open the most recent one.
      if (autoExpandFirst && sorted.length) setExpanded(e => ({ ...e, [sorted[0].id]: true }));
      setFetchedFor((ownerEmail || emails[0] || '').trim());
    } catch (e) {
      setError(e.message || 'Fetch failed.');
    } finally {
      setLoading(false);
    }
  };

  const ffPost = async (path, body) => {
    if (!supabaseClient) throw new Error('Auth not configured.');
    const { data: { session } } = await supabaseClient.auth.getSession();
    const accessToken = session && session.access_token;
    if (!accessToken) throw new Error('Your session expired — reload the page and sign in again.');
    const r = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken }, body: JSON.stringify(body) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok || !d.ok) throw new Error(d.error || `Request failed (HTTP ${r.status})`);
    return d;
  };
  const openLink = async () => {
    setLinkOpen(true); setLinkErr(''); setLinkData(null); setLinkBusy(true);
    try {
      const d = await ffPost('/api/fireflies/link-candidates', { emails: emailKey ? emailKey.split('|') : [] });
      setLinkData(d);
      const firstOpen = (d.meetings || []).find(m => !m.fireflies_id);
      setLinkMeetingId(firstOpen ? firstOpen.id : ((d.meetings || [])[0] || {}).id || '');
    } catch (e) { setLinkErr(e.message || 'Could not load recordings.'); }
    finally { setLinkBusy(false); }
  };
  const linkRecording = async (recId) => {
    if (!linkMeetingId) return;
    setLinkBusy(true); setLinkErr('');
    try {
      await ffPost('/api/fireflies/link', { meeting_id: linkMeetingId, transcript_id: recId });
      setLinkOpen(false);
      await fetchTranscripts();
    } catch (e) { setLinkErr(e.message || 'Could not link it.'); }
    finally { setLinkBusy(false); }
  };

  useEffect(() => {
    if (emailKey) {
      fetchTranscripts();
    } else {
      setTranscripts([]);
      setError('');
      setFetchedFor('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailKey]);

  if (!ownerEmail || !ownerEmail.trim()) {
    return (
      <div className="border-t pt-3">
        <label className="block text-xs font-medium text-gray-600 mb-1">📞 Meeting notes <span className="text-gray-400 font-normal">— pulled from Fireflies by owner email</span></label>
        <div className="text-xs text-gray-400 italic">Add an owner email above to pull this owner's meeting history from Fireflies.</div>
      </div>
    );
  }

  return (
    <div className="border-t pt-3">
      <div className="flex items-center justify-between mb-2">
        <label className="text-xs font-medium text-gray-600">
          📞 Meeting notes <span className="text-gray-400 font-normal">— matched on {fetchedFor || ownerEmail}</span>
        </label>
        <button
          type="button"
          onClick={() => fetchTranscripts()}
          disabled={loading}
          className="px-2 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-40"
        >
          {loading ? 'Loading…' : 'Refresh'}
        </button>
      </div>
      <div className="mb-2">
        {!linkOpen ? (
          <button type="button" onClick={openLink} className="text-xs text-indigo-700 hover:text-indigo-900 underline"
            title="A meeting's recording isn't listed (Fireflies added by hand often leaves the owner off the participant list)? Pick the meeting and the recording.">
            🔗 Link a recording
          </button>
        ) : (() => {
          const meetings = (linkData && linkData.meetings) || [];
          const sel = meetings.find(m => m.id === linkMeetingId);
          const selMs = sel ? new Date(sel.starts_at).getTime() : null;
          const recs = ((linkData && linkData.recordings) || [])
            .filter(t => selMs == null || Math.abs(Number(t.date) - selMs) <= 2 * 86400000)
            .sort((a, b) => (selMs == null ? Number(b.date) - Number(a.date) : Math.abs(Number(a.date) - selMs) - Math.abs(Number(b.date) - selMs)));
          return (
            <div className="p-2 border border-indigo-200 bg-indigo-50 rounded text-xs space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-semibold text-indigo-900">🔗 Link a recording to a meeting</span>
                <button type="button" onClick={() => setLinkOpen(false)} className="text-gray-500 hover:text-gray-700">Close</button>
              </div>
              {linkErr && <div className="text-red-700">{linkErr}</div>}
              {linkBusy && !linkData && <div className="text-gray-500">Loading recordings…</div>}
              {linkData && meetings.length === 0 && <div className="text-gray-600">No calendar meetings with this owner in the last 90 days.</div>}
              {meetings.length > 0 && (
                <select value={linkMeetingId} onChange={e => setLinkMeetingId(e.target.value)} className="w-full p-1 border rounded">
                  {meetings.map(m => (
                    <option key={m.id} value={m.id}>{new Date(m.starts_at).toLocaleDateString()} · {m.summary || 'Meeting'}{m.fireflies_id ? ' (has a recording)' : ''}</option>
                  ))}
                </select>
              )}
              {linkData && sel && recs.length === 0 && <div className="text-gray-600">No Fireflies recording within 2 days of this meeting in Vista's workspace. If one was recorded, it may be in a personal Fireflies account.</div>}
              {recs.map(t => (
                <div key={t.id} className="flex items-start justify-between gap-2 bg-white border rounded p-1.5">
                  <div className="min-w-0">
                    <div className="font-medium text-gray-800 truncate">{t.title || 'Untitled'}</div>
                    <div className="text-gray-500">{new Date(Number(t.date)).toLocaleString()}{t.duration ? ` · ${Math.round(Number(t.duration))} min` : ''}{t.organizer ? ` · ${t.organizer}` : ''}</div>
                    <div className="text-gray-400 truncate">{(t.participants || []).join(', ') || 'no participants listed'}</div>
                    {t.linked_to && <div className="text-amber-700">already linked to: {t.linked_to}</div>}
                  </div>
                  <button type="button" disabled={linkBusy || !linkMeetingId} onClick={() => linkRecording(t.id)}
                    className="flex-shrink-0 px-2 py-0.5 rounded bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-40">Link</button>
                </div>
              ))}
            </div>
          );
        })()}
      </div>
      {error && (
        <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded p-2 mb-2">{error}</div>
      )}
      {!loading && !error && transcripts.length === 0 && (
        <div className="text-xs text-gray-400 italic">No matching meetings yet. Fireflies finds meetings where this email was a participant.</div>
      )}
      <div className="space-y-2">
        {transcripts.map(t => {
          const isOpen = !!expanded[t.id];
          const dateStr = t.date ? new Date(t.date).toLocaleDateString() : '—';
          const dur = t.duration ? `${Math.round(Number(t.duration) / 60)} min` : '';
          const rawActions = t.summary && t.summary.action_items;
          const actions = Array.isArray(rawActions)
            ? rawActions
            : (rawActions ? String(rawActions).split(/\n+/).map(s => s.trim()).filter(Boolean) : []);
          const keywords = Array.isArray(t.summary && t.summary.keywords) ? t.summary.keywords : [];
          return (
            <div key={t.id} className="bg-white border border-gray-200 rounded">
              <button
                type="button"
                onClick={() => setExpanded(e => ({ ...e, [t.id]: !isOpen }))}
                className="w-full flex items-center justify-between px-3 py-2 text-left hover:bg-gray-50"
              >
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-gray-800 truncate">{t.title || 'Untitled meeting'}</div>
                  <div className="text-xs text-gray-500">{dateStr}{dur ? ` · ${dur}` : ''}</div>
                </div>
                <span className="text-gray-400 ml-2">{isOpen ? '▾' : '▸'}</span>
              </button>
              {isOpen && (
                <div className="px-3 pb-3 pt-1 border-t border-gray-100 space-y-2 text-xs text-gray-700">
                  {t.summary && t.summary.overview && (
                    <div>
                      <div className="font-semibold text-gray-600 mb-0.5">Overview</div>
                      <div className="whitespace-pre-line">{t.summary.overview}</div>
                    </div>
                  )}
                  {!overviewOnly && actions.length > 0 && (
                    <div>
                      <div className="font-semibold text-gray-600 mb-0.5">Action items</div>
                      <ul className="list-disc list-inside space-y-0.5">
                        {actions.map((a, i) => <li key={i}>{a}</li>)}
                      </ul>
                    </div>
                  )}
                  {keywords.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {keywords.slice(0, 8).map((k, i) => (
                        <span key={i} className="text-[10px] bg-gray-100 text-gray-600 rounded px-1.5 py-0.5">{k}</span>
                      ))}
                    </div>
                  )}
                  {t.transcript_url && (
                    <a
                      href={t.transcript_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block mt-1 text-blue-600 hover:underline"
                    >
                      Open full transcript on Fireflies →
                    </a>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

/* ── ROUTER — toggles between ClientList and BusinessValuationTool ── */
const normalizeCompanyName = (name) => {
  if (!name) return '';
  return String(name)
    .toLowerCase()
    .trim()
    .replace(/[,.]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/\s+(inc|llc|ltd|corp|corporation|company|co|lp|llp|pllc|pc)\.?$/i, '')
    .trim();
};

const JsonImporter = ({ onClose, onComplete }) => {
  const [files, setFiles] = useState([]);
  const [results, setResults] = useState([]);
  const [importing, setImporting] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const importFileRef = useRef(null);

  const handleFiles = (fileList) => {
    const arr = Array.from(fileList).filter(f => f.name.toLowerCase().endsWith('.json'));
    setFiles(arr);
    setResults(arr.map(f => ({ filename: f.name, status: 'pending', message: '' })));
  };

  const runImport = async () => {
    if (files.length === 0 || importing) return;
    setImporting(true);

    let existingClients = [];
    try {
      existingClients = await fetchAllRows(() => supabaseClient.from('clients').select('id, company_name'));
    } catch (err) {
      const errored = results.map(r => ({ ...r, status: 'error', message: 'Failed to load clients: ' + err.message }));
      setResults(errored);
      setImporting(false);
      return;
    }

    const clientLookup = new Map();
    existingClients.forEach(c => {
      const key = normalizeCompanyName(c.company_name);
      if (key) clientLookup.set(key, c);
    });

    const newResults = [...results];
    const newClientIds = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      newResults[i] = { ...newResults[i], status: 'processing' };
      setResults([...newResults]);

      try {
        const text = await file.text();
        const data = JSON.parse(text);

        const companyName = data.dealProfile?.companyName?.trim();
        if (!companyName) {
          newResults[i] = { ...newResults[i], status: 'error', message: 'No company name found in JSON' };
          setResults([...newResults]);
          continue;
        }

        const normalized = normalizeCompanyName(companyName);
        let clientRecord = clientLookup.get(normalized);
        let isNewClient = false;

        // JSON-OPEN TRAP (Thatcher 08-31 "Combined Companies"; Mark 09-28):
        // a name miss used to create a client silently — opening a file to
        // LOOK at it made a company. Now it asks; Cancel writes nothing.
        if (!clientRecord && !window.confirm(`"${companyName}" doesn't match any client in VT.\n\nCreate a NEW client and import this valuation under it?\n\nCancel if:\n• the business is already in VT under a different spelling — use "+ From JSON" on its row instead, or\n• you only wanted to look at the file — nothing is saved.`)) {
          newResults[i] = { ...newResults[i], status: 'error', message: 'Skipped — no client created (nothing saved)' };
          setResults([...newResults]);
          continue;
        }
        if (!clientRecord) {
          const { data: newClient, error: clientErr } = await supabaseClient
            .from('clients')
            .insert({
              company_name: companyName,
              city: data.dealProfile?.city || null,
              state: data.dealProfile?.state || null
            })
            .select()
            .single();
          if (clientErr) throw clientErr;
          clientRecord = newClient;
          clientLookup.set(normalized, newClient);
          isNewClient = true;
          newClientIds.push(newClient.id);
        }

        const savedDate = data.savedAt || data.autoSavedAt || new Date().toISOString();
        const dateStr = new Date(savedDate).toISOString().split('T')[0];
        const valuationName = `${dateStr} Valuation (imported)`;

        const { error: valErr } = await supabaseClient
          .from('valuations')
          .insert({
            client_id: clientRecord.id,
            name: valuationName,
            version: data.version || 'imported',
            data: data,
            created_at: savedDate,
            updated_at: savedDate
          });
        if (valErr) throw valErr;

        newResults[i] = {
          ...newResults[i],
          status: 'success',
          message: isNewClient ? `New client: ${clientRecord.company_name}` : `Matched: ${clientRecord.company_name}`,
          isNewClient
        };
      } catch (err) {
        console.error(`Import failed for ${file.name}:`, err);
        newResults[i] = { ...newResults[i], status: 'error', message: err.message || 'Import failed' };
      }

      setResults([...newResults]);
    }

    setImporting(false);
    onComplete(newClientIds);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files) handleFiles(e.dataTransfer.files);
  };

  const successCount = results.filter(r => r.status === 'success').length;
  const errorCount = results.filter(r => r.status === 'error').length;
  const newClientCount = results.filter(r => r.isNewClient).length;
  const hasPending = results.some(r => r.status === 'pending');
  const hasDone = results.some(r => r.status === 'success' || r.status === 'error');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6 max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-gray-800">Import Valuations from JSON</h2>
          <button onClick={onClose} disabled={importing} className="text-gray-400 hover:text-gray-600 disabled:opacity-30 text-xl">
            ×
          </button>
        </div>

        <p className="text-xs text-gray-500 mb-3">
          Drop in your existing valuation JSON files. Each file becomes a new valuation, matched to an existing client by company name (case-insensitive), or a new client is created automatically.
        </p>

        {files.length === 0 && (
          <div
            onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
            onClick={() => importFileRef.current?.click()}
            className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${isDragging ? 'border-blue-400 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}
          >
            <Upload className="w-10 h-10 mx-auto text-gray-400 mb-3" />
            <p className="text-sm text-gray-600 mb-1">Drag and drop JSON files here</p>
            <p className="text-xs text-gray-500">or click to browse (you can select multiple files)</p>
            <input ref={importFileRef} type="file" accept=".json" multiple className="hidden" onChange={(e) => handleFiles(e.target.files)} />
          </div>
        )}

        {files.length > 0 && (
          <div className="flex-1 overflow-y-auto mb-4 border rounded divide-y min-h-[200px]">
            {results.map((r, idx) => (
              <div key={idx} className="px-3 py-2 flex items-center gap-2 text-sm">
                <div className="w-5 flex-shrink-0 text-center">
                  {r.status === 'pending' && <span className="text-gray-400">•</span>}
                  {r.status === 'processing' && <span className="text-blue-500 animate-pulse">⟳</span>}
                  {r.status === 'success' && !r.isNewClient && <span className="text-green-600">✓</span>}
                  {r.status === 'success' && r.isNewClient && <span className="text-blue-600">★</span>}
                  {r.status === 'error' && <span className="text-red-600">✕</span>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-gray-800 truncate">{r.filename}</div>
                  {r.message && (
                    <div className={`text-xs ${r.status === 'error' ? 'text-red-600' : 'text-gray-500'}`}>{r.message}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {results.length > 0 && !importing && hasDone && (
          <div className="mb-3 text-xs text-gray-600 bg-gray-50 rounded p-2">
            {successCount > 0 && <span className="text-green-700 font-semibold">{successCount} imported</span>}
            {newClientCount > 0 && <span className="text-blue-700"> ({newClientCount} new client{newClientCount !== 1 ? 's' : ''})</span>}
            {errorCount > 0 && <span className="text-red-700">{successCount > 0 ? ', ' : ''}{errorCount} failed</span>}
            {hasPending && <span className="text-gray-500">{(successCount + errorCount > 0) ? ', ' : ''}{results.filter(r => r.status === 'pending').length} pending</span>}
          </div>
        )}

        <div className="flex justify-end gap-2">
          {files.length > 0 && !importing && hasPending && !hasDone && (
            <button onClick={() => { setFiles([]); setResults([]); }} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800">
              Choose different files
            </button>
          )}
          <button onClick={onClose} disabled={importing} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800 disabled:opacity-30">
            {importing ? 'Importing...' : (hasDone ? 'Done' : 'Cancel')}
          </button>
          {files.length > 0 && !importing && hasPending && (
            <button onClick={runImport} className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-700">
              Import {files.length} file{files.length !== 1 ? 's' : ''}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// ============================================================================
// SHARED NORMALIZED EBITDA MODEL
// Single source of truth for the in-app Norm EBITDA view AND the CIM Excel
// export. Anything that displays the EBITDA bridge MUST consume this model —
// reimplementing it inline is what caused the duplicate-owner-salary and
// missing-D/I/A/T bugs in earlier export versions.
//
// Inputs are already-prepared structures (no React state). The same `data`
// object built by getReportData() can supply most of them.
//
// The engine's adjustedEbitda from `calculations.years[i]` is the source of
// truth for the final number. The breakdown is reconciled against it; if
// they disagree by more than $1, the model flags `reconciliation.allMatch`
// as false so callers can refuse to export.
// ============================================================================
const OWNER_COMP_KEYWORDS = ['owner', 'salary', 'compensation', 'wage', 'bonus', 'benefit', 'health', 'insurance', 'auto', 'vehicle', 'car', 'personal', 'family'];
const DIAT_CATEGORIES = ['Depreciation', 'Interest', 'Amortization', 'Taxes'];

// Label for a line-based (%) adjustment on the presentation: the staff description when there is one
// (with the % when it's partial), else the old "N% add-back" fallback (Colleen 09-29).
const lineAdjLabel = (desc, pct, fallback) => {
  const d = String(desc || '').trim();
  if (!d) return fallback;
  return Number(pct) > 0 && Number(pct) < 100 ? `${d} (${pct}%)` : d;
};

const isExpensePlLine = (plLine) => {
  const lower = (plLine || '').toLowerCase();
  // An income line is never an expense, even when its name says "/(Expense)" (Aeroform 10-21: the 2024
  // interest-income add-back printed with the wrong sign). Matches the engine's OtherIncome: rule.
  if (lower === 'other income' || lower.startsWith('otherincome')) return false;
  return lower.startsWith('cogs') || lower.startsWith('opex') ||
         lower.includes('expense') || lower === 'rent (market adj)' ||
         lower === 'capex';
};

// A MANUAL adjustment categorized Depreciation / Interest / Amortization / Taxes on an expense line (Colleen
// 10-14, Aeroform: depreciation sitting inside COGS). It belongs in the D/I/A/T rows and Reported EBITDA,
// not "Other Normalizing Adjustments". The engine already adds it back (a COGS/expense deduct), so the
// normalized EBITDA is unchanged — only which row of the bridge shows it. Every bridge uses these helpers.
const isManualDiatAdj = (a) => !!a && a.included !== false && DIAT_CATEGORIES.includes(a.category) && isExpensePlLine(a.plLine);
const manualDiatImpact = (a) => (a.type === 'add' ? -(Number(a.amount) || 0) : (Number(a.amount) || 0));
const manualDiatSum = (items, component, matchesPeriod) => (items || [])
  .filter(a => isManualDiatAdj(a) && (!component || a.category.toLowerCase() === component) && matchesPeriod(a))
  .reduce((s, a) => s + manualDiatImpact(a), 0);

const isOwnerCompAdjustment = (category, descriptionLower, plLineLower) => {
  if (category === 'Owner Benefits' || category === 'Personal Expense') return true;
  if (category) return false;
  return OWNER_COMP_KEYWORDS.some(kw => descriptionLower.includes(kw) || (plLineLower || '').includes(kw));
};

const buildNormalizedEbitdaModel = ({
  adjustments,           // included adjustment items only
  lineBasedAdjustments,  // [{name, source, addbackPct, category, year3, year4, year5, ttm}]
  diatBreakdown,         // {depreciation: {y3,y4,y5,ttm}, interest: ..., amortization: ..., taxes: ...} from legacy diatCategories
  ownerCompensation,
  yearLabels,            // {year3, year4, year5}
  ttmLabel,              // string
  payrollTaxMethod,      // 'wage_base' | 'flat' (grandfathered)
  payrollTaxYears,       // {year3, year4, year5, ttm} calendar years for the wage base
  netIncome,             // {year3, year4, year5, ttm}
  engineEbitda,          // {year3, year4, year5, ttm} — calculations.years[i].adjustedEbitda
}) => {
  const adjs = Array.isArray(adjustments) ? adjustments : [];
  const lineAdjs = Array.isArray(lineBasedAdjustments) ? lineBasedAdjustments : [];
  const diat = diatBreakdown || { depreciation: {}, interest: {}, amortization: {}, taxes: {} };

  // ---- D/I/A/T: combine legacy diatBreakdown + line-based items tagged with D/I/A/T category ----
  const diatFromLegacy = {
    depreciation: { year3: diat.depreciation?.year3 || 0, year4: diat.depreciation?.year4 || 0, year5: diat.depreciation?.year5 || 0, ttm: diat.depreciation?.ttm || 0 },
    interest:     { year3: diat.interest?.year3     || 0, year4: diat.interest?.year4     || 0, year5: diat.interest?.year5     || 0, ttm: diat.interest?.ttm     || 0 },
    amortization: { year3: diat.amortization?.year3 || 0, year4: diat.amortization?.year4 || 0, year5: diat.amortization?.year5 || 0, ttm: diat.amortization?.ttm || 0 },
    taxes:        { year3: diat.taxes?.year3        || 0, year4: diat.taxes?.year4        || 0, year5: diat.taxes?.year5        || 0, ttm: diat.taxes?.ttm        || 0 }
  };

  const diatFromLineBased = {
    depreciation: { year3: 0, year4: 0, year5: 0, ttm: 0, items: [] },
    interest:     { year3: 0, year4: 0, year5: 0, ttm: 0, items: [] },
    amortization: { year3: 0, year4: 0, year5: 0, ttm: 0, items: [] },
    taxes:        { year3: 0, year4: 0, year5: 0, ttm: 0, items: [] }
  };

  lineAdjs.forEach(adj => {
    const bucket = adj.category === 'Depreciation' ? diatFromLineBased.depreciation
                 : adj.category === 'Interest'     ? diatFromLineBased.interest
                 : adj.category === 'Amortization' ? diatFromLineBased.amortization
                 : adj.category === 'Taxes'        ? diatFromLineBased.taxes
                 : null;
    if (!bucket) return;
    bucket.year3 += adj.year3 || 0;
    bucket.year4 += adj.year4 || 0;
    bucket.year5 += adj.year5 || 0;
    bucket.ttm   += adj.ttm   || 0;
    bucket.items.push(adj);
  });
  // Manual D/I/A/T adjustments (e.g. depreciation inside COGS) — same period rule as the grouping below.
  adjs.forEach(adj => {
    if (!isManualDiatAdj(adj)) return;
    const bucket = diatFromLineBased[adj.category.toLowerCase()];
    const amt = manualDiatImpact(adj);
    const ttmStr0 = ttmLabel || 'TTM';
    if (adj.year === 'All Years') { bucket.year3 += amt; bucket.year4 += amt; bucket.year5 += amt; bucket.ttm += amt; }
    else if (adj.year === yearLabels?.year3) bucket.year3 += amt;
    else if (adj.year === yearLabels?.year4) bucket.year4 += amt;
    else if (adj.year === yearLabels?.year5) bucket.year5 += amt;
    else if (adj.year === 'TTM' || adj.year === ttmStr0) bucket.ttm += amt;
    if (!bucket.items.some(i => i.name === adj.plLine)) bucket.items.push({ name: adj.plLine });
  });

  const diatCombined = {};
  ['depreciation', 'interest', 'amortization', 'taxes'].forEach(k => {
    diatCombined[k] = {
      year3: diatFromLegacy[k].year3 + diatFromLineBased[k].year3,
      year4: diatFromLegacy[k].year4 + diatFromLineBased[k].year4,
      year5: diatFromLegacy[k].year5 + diatFromLineBased[k].year5,
      ttm:   diatFromLegacy[k].ttm   + diatFromLineBased[k].ttm,
      items: diatFromLineBased[k].items
    };
  });

  const diatTotal = {
    year3: diatCombined.depreciation.year3 + diatCombined.interest.year3 + diatCombined.amortization.year3 + diatCombined.taxes.year3,
    year4: diatCombined.depreciation.year4 + diatCombined.interest.year4 + diatCombined.amortization.year4 + diatCombined.taxes.year4,
    year5: diatCombined.depreciation.year5 + diatCombined.interest.year5 + diatCombined.amortization.year5 + diatCombined.taxes.year5,
    ttm:   diatCombined.depreciation.ttm   + diatCombined.interest.ttm   + diatCombined.amortization.ttm   + diatCombined.taxes.ttm
  };

  // ---- Group regular adjustments + non-D/I/A/T line-based addbacks by plLine|description ----
  const groupedOwnerComp = {};
  const groupedOther = {};

  const yLabel3 = yearLabels?.year3;
  const yLabel4 = yearLabels?.year4;
  const yLabel5 = yearLabels?.year5;
  const ttmStr = ttmLabel || 'TTM';

  adjs.forEach(adj => {
    if (isManualDiatAdj(adj)) return;  // already in diatCombined
    const plLine = adj.plLine || '';
    const desc = (adj.description || '').trim();
    const key = plLine + '|' + desc.toLowerCase();
    const descLower = desc.toLowerCase();
    const plLineLower = plLine.toLowerCase();
    const isOwnerComp = isOwnerCompAdjustment(adj.category, descLower, plLineLower);
    const targetGroup = isOwnerComp ? groupedOwnerComp : groupedOther;

    if (!targetGroup[key]) {
      targetGroup[key] = { plLine, description: desc || '(No description)', year3: 0, year4: 0, year5: 0, ttm: 0 };
    }

    const isExpense = isExpensePlLine(plLine);
    const isAdd = adj.type === 'add';
    const amount = adj.amount || 0;
    // Expense line: deduct = +EBITDA, add = -EBITDA. Income line: add = +EBITDA, deduct = -EBITDA.
    const ebitdaImpact = isExpense ? (isAdd ? -amount : amount) : (isAdd ? amount : -amount);

    if (adj.year === 'All Years') {
      targetGroup[key].year3 += ebitdaImpact;
      targetGroup[key].year4 += ebitdaImpact;
      targetGroup[key].year5 += ebitdaImpact;
      targetGroup[key].ttm   += ebitdaImpact;
    } else if (adj.year === yLabel3) {
      targetGroup[key].year3 += ebitdaImpact;
    } else if (adj.year === yLabel4) {
      targetGroup[key].year4 += ebitdaImpact;
    } else if (adj.year === yLabel5) {
      targetGroup[key].year5 += ebitdaImpact;
    } else if (adj.year === 'TTM' || adj.year === ttmStr) {
      targetGroup[key].ttm += ebitdaImpact;
    }
  });

  lineAdjs.forEach(adj => {
    if (DIAT_CATEGORIES.includes(adj.category)) return;  // already in diatCombined
    const key = adj.name + '|' + adj.addbackPct + '% add-back';
    const descLower = (adj.name || '').toLowerCase();
    const isOwnerComp = isOwnerCompAdjustment(adj.category, descLower, '');
    const targetGroup = isOwnerComp ? groupedOwnerComp : groupedOther;
    if (!targetGroup[key]) {
      targetGroup[key] = {
        plLine: 'OpEx: ' + adj.name,
        description: lineAdjLabel(adj.description, adj.addbackPct, adj.addbackPct + '% add-back'),
        year3: 0, year4: 0, year5: 0, ttm: 0
      };
    }
    targetGroup[key].year3 += adj.year3 || 0;
    targetGroup[key].year4 += adj.year4 || 0;
    targetGroup[key].year5 += adj.year5 || 0;
    targetGroup[key].ttm   += adj.ttm   || 0;
  });

  // ---- Market Replacement + Employer Payroll Tax (synthetic owner-comp lines) ----
  const marketRate = ownerCompensation?.marketReplacement || 0;
  const mkP = { year3: ocMarketFor(ownerCompensation, 'year3'), year4: ocMarketFor(ownerCompensation, 'year4'), year5: ocMarketFor(ownerCompensation, 'year5'), ttm: ocMarketFor(ownerCompensation, 'ttm') };
  if (marketRate > 0 || mkP.year3 || mkP.year4 || mkP.year5 || mkP.ttm) {
    groupedOwnerComp['_marketReplacement'] = {
      plLine: 'Less: Market Replacement',
      description: 'Cost to hire replacement manager',
      year3: -mkP.year3, year4: -mkP.year4, year5: -mkP.year5, ttm: -mkP.ttm,
      sortOrder: 2
    };
  }

  const getTtmSalary = (oc) => oc?.ttm?.salary || (oc?.embeddedInWages ? (oc?.year5?.salary || 0) : 0);
  const ownerSalaryAdj = {
    year3: (ownerCompensation?.year3?.salary || 0) - mkP.year3,
    year4: (ownerCompensation?.year4?.salary || 0) - mkP.year4,
    year5: (ownerCompensation?.year5?.salary || 0) - mkP.year5,
    ttm:   getTtmSalary(ownerCompensation) - mkP.ttm
  };
  const hasOwnerSalaryAdj = ownerSalaryAdj.year3 !== 0 || ownerSalaryAdj.year4 !== 0 || ownerSalaryAdj.year5 !== 0 || ownerSalaryAdj.ttm !== 0;
  const payrollTaxRate = ownerCompensation?.includePayrollTax !== false ? ((ownerCompensation?.payrollTaxRate || 7.65) / 100) : 0;
  const ptY = payrollTaxYears || {};
  const ptAddback = (sal, yr, period) => -ownerPayrollTaxDiff(ownerCompensation, sal, mkP[period], yr, payrollTaxMethod, period);
  if (payrollTaxRate > 0 && hasOwnerSalaryAdj) {
    groupedOwnerComp['_payrollTax'] = {
      plLine: 'Employer Payroll Tax',
      description: payrollTaxDescribe(ownerCompensation, payrollTaxMethod),
      year3: ptAddback(ownerCompensation?.year3?.salary || 0, ptY.year3, 'year3'),
      year4: ptAddback(ownerCompensation?.year4?.salary || 0, ptY.year4, 'year4'),
      year5: ptAddback(ownerCompensation?.year5?.salary || 0, ptY.year5, 'year5'),
      ttm:   ptAddback(getTtmSalary(ownerCompensation), ptY.ttm, 'ttm'),
      sortOrder: 3
    };
  }

  // Tag salary-removal items so they sort to the top of the owner-comp section.
  Object.values(groupedOwnerComp).forEach(item => {
    if (item.sortOrder !== undefined) return;
    const lower = (item.plLine || '').toLowerCase();
    if (lower.includes('payroll') || lower.includes('salary') || lower.includes('wages')) {
      item.sortOrder = 1;
      if (item.description && item.description.includes('add-back')) {
        item.description = 'Owner salary removed from payroll expenses';
      }
    } else {
      item.sortOrder = 4;
    }
  });

  const ownerCompRows = Object.values(groupedOwnerComp).sort((a, b) => (a.sortOrder || 99) - (b.sortOrder || 99));
  const otherRows = Object.values(groupedOther).filter(g => g.year3 || g.year4 || g.year5 || g.ttm);

  const sumByYear = (rows) => rows.reduce((acc, r) => ({
    year3: acc.year3 + (r.year3 || 0),
    year4: acc.year4 + (r.year4 || 0),
    year5: acc.year5 + (r.year5 || 0),
    ttm:   acc.ttm   + (r.ttm   || 0)
  }), { year3: 0, year4: 0, year5: 0, ttm: 0 });

  const ownerCompTotal = sumByYear(ownerCompRows);
  const otherTotal = sumByYear(otherRows);
  const normalizingTotal = {
    year3: ownerCompTotal.year3 + otherTotal.year3,
    year4: ownerCompTotal.year4 + otherTotal.year4,
    year5: ownerCompTotal.year5 + otherTotal.year5,
    ttm:   ownerCompTotal.ttm   + otherTotal.ttm
  };

  const ni = netIncome || { year3: 0, year4: 0, year5: 0, ttm: 0 };
  const reportedEbitda = {
    year3: ni.year3 + diatTotal.year3,
    year4: ni.year4 + diatTotal.year4,
    year5: ni.year5 + diatTotal.year5,
    ttm:   ni.ttm   + diatTotal.ttm
  };

  // Engine value is the source of truth. Reconciliation compares the displayed
  // bridge total against it.
  const engine = engineEbitda || { year3: 0, year4: 0, year5: 0, ttm: 0 };
  const breakdownTotal = {
    year3: reportedEbitda.year3 + normalizingTotal.year3,
    year4: reportedEbitda.year4 + normalizingTotal.year4,
    year5: reportedEbitda.year5 + normalizingTotal.year5,
    ttm:   reportedEbitda.ttm   + normalizingTotal.ttm
  };
  const RECON_TOLERANCE = 1; // dollars
  const diff = {
    year3: breakdownTotal.year3 - engine.year3,
    year4: breakdownTotal.year4 - engine.year4,
    year5: breakdownTotal.year5 - engine.year5,
    ttm:   breakdownTotal.ttm   - engine.ttm
  };
  const matches = {
    year3: Math.abs(diff.year3) <= RECON_TOLERANCE,
    year4: Math.abs(diff.year4) <= RECON_TOLERANCE,
    year5: Math.abs(diff.year5) <= RECON_TOLERANCE,
    ttm:   Math.abs(diff.ttm)   <= RECON_TOLERANCE
  };
  const allMatch = matches.year3 && matches.year4 && matches.year5 && matches.ttm;

  return {
    diat: {
      depreciation: diatCombined.depreciation,
      interest:     diatCombined.interest,
      amortization: diatCombined.amortization,
      taxes:        diatCombined.taxes,
      total:        diatTotal
    },
    ownerCompRows,
    otherRows,
    totals: {
      ownerComp:   ownerCompTotal,
      other:       otherTotal,
      normalizing: normalizingTotal
    },
    netIncome: ni,
    reportedEbitda,
    adjustedEbitda: engine,           // engine, source of truth
    marketReplacement: { amount: marketRate, payrollTaxRate },
    reconciliation: { breakdownTotal, engineTotal: engine, diff, matches, allMatch }
  };
};

/* ══════════════════════════════════════════════════════════════════
   FEATURE FLAG: staff preview
   ──────────────────────────────────────────────────────────────────
   STAFF_PREVIEW_EMAILS is injected by server.js from the
   STAFF_ALLOWLIST env var on Render. When the current user's email
   is in the list, they see the new Dashboard (My Work + Pipeline),
   the ActivityLog pane on projects, the OIR/cadence UI, and the
   ingestion-related views being built for the A+B+C bundle.

   Everyone else sees VT exactly as it was — no new nav items,
   no new buttons, no new screens. Default landing for flagged
   users is the Dashboard; for everyone else it stays as the
   client list.

   Empty allowlist = nobody sees previews. Safe default.
   ══════════════════════════════════════════════════════════════════ */
const STAFF_PREVIEW_EMAILS = Array.isArray(window.STAFF_PREVIEW_EMAILS)
  ? window.STAFF_PREVIEW_EMAILS
  : [];
const isStaffPreview = (email) => {
  if (!email) return false;
  return STAFF_PREVIEW_EMAILS.includes(String(email).trim().toLowerCase());
};

/* ══════════════════════════════════════════════════════════════════
   STAFF DIRECTORY
   Maps login email -> display name + role. Replaces the old fragile
   substring matching ("does the email contain 'zac'"). Drives the
   Setup-page Lead/AM dropdowns, "My Work" filtering, and Responsibility
   matching — all by exact email match.

   CONSOLIDATION Phase 0 (2026-08-04): the object below is now only the
   FALLBACK. When the shared `staff` table exists (migration 052),
   loadStaffDirectory() replaces the contents and re-derives the lists at
   login, so a role change or new hire is a database row, not a rebuild.
   DM reads the same table — one identity source across both apps.
   ══════════════════════════════════════════════════════════════════ */
const STAFF_DIRECTORY = {
  'adamborst@vistabusinessgroup.com': { name: 'Adam',     role: 'account_manager' },
  'jc@vistabusinessgroup.com':        { name: 'J.C.',     role: 'account_manager' },
  'zac@vistabusinessgroup.com':       { name: 'Zac',      role: 'lead' },
  'thatcher@vistabusinessgroup.com':  { name: 'Thatcher', role: 'lead' },
  'konnie@vistabusinessgroup.com':    { name: 'Konnie',   role: 'document_mgmt' },
  'colleen@vistabusinessgroup.com':   { name: 'Colleen',  role: 'analysis' },
  'mark@vistabusinessgroup.com':      { name: 'Mark',     role: 'owner' },
};
// Who can be assigned to each slot on the Setup tab. Leads rotate between
// Zac and Thatcher; any of the four sales staff can carry the AM role.
let STAFF_LEADS = ['Zac', 'Thatcher'];
// J.C. removed 2026-07-27 (offboarded): assignable to nothing NEW; his
// existing deals keep the stored name (see AM_INHERITANCE above the
// stageResponsibility helper) and the Setup select shows a legacy option.
let STAFF_AMS   = ['Adam', 'Zac', 'Thatcher'];

// A Sales Engine reminder routes to its CREATOR only while the creator still
// holds a plate (active staff, not inherited away). Departed staff (J.C.) and
// Zoho-only names (Roman) route to the relationship holder instead (Mark 10-07,
// the plate audit: the Zoho import stamped each task's Zoho owner as creator, so
// 7 reminders sat on NOBODY's My Work while the 7:30 email nagged the holder).
// Mirrors server.js seReminderHolder -- keep the two in sync.
// "Holds a plate" = one of the SE serving plates (= SE_AM_NAMES inside the
// component). Mark, Colleen and Konnie have no SE serving on My Work, so a
// reminder they created (Zoho task owner on import) routes to the holder too
// (Mark 10-07, CCA Technology: his imported "Reach Out" was due today and
// carded nowhere — the owner role never loads the SE serving).
const SE_PLATE_HOLDERS = ['Zac', 'Thatcher', 'Adam', 'Scott'];
// …and Colleen + Konnie KEEP the reminders they set (Colleen 10-07: "I set
// reminders in Zoho, I want to see them") — theirs show in "⏰ Reminders you
// set" on their own My Work (no SE serving). Only Mark (owner = radar) hands
// his to the holder. Mirrors server.js SE_REMINDER_KEEPERS.
const SE_REMINDER_KEEPERS = [...SE_PLATE_HOLDERS, 'Colleen', 'Konnie'];
function seCreatorIsLive(name) {
  const n = String(name || '').trim();
  if (!n || AM_INHERITANCE[n] || !SE_REMINDER_KEEPERS.includes(n)) return false;
  return Object.values(STAFF_DIRECTORY).some(r => r.name === n && r.active !== false);
}
// A pick retires only reminders the picker owns: their own, unowned imports,
// or ones routed to the holder. Never a reminder a keeper set for themselves
// (Colleen 10-07: 6 of her reminders — Blue Spruce, PCDoctor, Schring… — were
// cancelled when Adam set his own date on the same business).
function seRetirableBy(c, actor) {
  return !c.created_by || c.created_by === actor || !seCreatorIsLive(c.created_by);
}

// Raw staff-table rows (null until loaded). Kept for the pieces that need
// more than name+role: modules (module switcher, SE gating), full_name.
let STAFF_TABLE_ROWS = null;
async function loadStaffDirectory() {
  if (!supabaseClient || STAFF_TABLE_ROWS) return;
  try {
    const { data, error } = await supabaseClient
      .from('staff')
      .select('*')
      .order('created_at', { ascending: true });
    // Table missing (migration not applied yet) or empty: keep the fallback.
    if (error || !data || data.length === 0) return;
    STAFF_TABLE_ROWS = data;
    Object.keys(STAFF_DIRECTORY).forEach(k => { delete STAFF_DIRECTORY[k]; });
    data.forEach(r => {
      const email = String(r.email || '').trim().toLowerCase();
      if (email && r.name) {
        STAFF_DIRECTORY[email] = {
          name: r.name,
          role: r.role,
          active: r.active !== false,
          modules: Array.isArray(r.modules) ? r.modules : [],
        };
      }
    });
    // Inactive staff stay in the lookup (legacy deals keep resolving their
    // names) but drop out of every assignable/viewable list.
    const active = data.filter(r => r.active !== false && r.name);
    STAFF_LEADS = active.filter(r => r.role === 'lead').map(r => r.name);
    STAFF_AMS = [
      ...active.filter(r => r.role === 'account_manager').map(r => r.name),
      ...active.filter(r => r.role === 'lead').map(r => r.name),
    ];
    VIEW_AS_NAMES = active.filter(r => r.role !== 'owner').map(r => r.name);
  } catch (e) {
    console.warn('Staff table load failed — using built-in directory', e);
  }
}
// Resolve a login email to that person's display name (e.g. for "My Work").
const staffName = (email) => {
  if (!email) return null;
  const s = STAFF_DIRECTORY[String(email).trim().toLowerCase()];
  return s ? s.name : null;
};

// Reverse lookup — given a display name (e.g. "Adam", "Thatcher"), find
// the staff email. Used to auto-CC the project's AM + Lead on cadence
// sends so they get internal visibility on each reminder Konnie ships.
const staffEmailByName = (name) => {
  if (!name) return null;
  const target = String(name).trim().toLowerCase();
  if (!target) return null;
  for (const [email, info] of Object.entries(STAFF_DIRECTORY)) {
    if (info && info.name && info.name.toLowerCase() === target) return email;
  }
  return null;
};

// Staff whose "My Work" the owner can view-as while tuning each person's
// queue. Everyone but the owner role. Drives the Dashboard "View as" picker.
let VIEW_AS_NAMES = Object.values(STAFF_DIRECTORY)
  .filter(s => s && s.role !== 'owner' && s.name)
  // J.C. offboarded (2026-07-27): his cards work from Adam's plate via the
  // inheritance alias, so a J.C. view would always be empty.
  .filter(s => s.name !== 'J.C.')
  .map(s => s.name);

// Canonical 18-item document checklist. Single source of truth shared by
// the valuation's in-memory checklist state and the New Project modal's
// partial-items picker. Clone (map spread) before putting in state so no
// component mutates the shared template.
const DEFAULT_DOCUMENT_CHECKLIST = [
  { id: 1, name: 'P&L Statements (3 years) - Accrual - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 27, name: 'P&L Statements (3 years) - Cash - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 28, name: 'Revenue Classification Form', status: 'not_received', dateProvided: '', notes: 'VT-generated after P&Ls are entered; owner classifies revenue lines and returns', receivedNotes: '', pendingNotes: '', tier: 'full', unlockedBy: [1, 27] },
  { id: 2, name: 'TTM P&L (monthly breakdown) - Cash & Accrual - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'minimum' },
  { id: 3, name: 'Balance Sheets (3 years + Interim) - Accrual - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 4, name: 'TTM Balance Sheet (monthly breakdown) - Accrual - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'minimum' },
  { id: 5, name: 'Sales Report by Customer (5 years) - Cash & Accrual', status: 'not_received', dateProvided: '', notes: 'For concentration and retention analysis', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 26, name: 'Sales Report by Customer (TTM) - Cash & Accrual', status: 'not_received', dateProvided: '', notes: 'Current period customer breakdown', receivedNotes: '', pendingNotes: '', tier: 'minimum' },
  { id: 29, name: 'Client Detail Form', status: 'not_received', dateProvided: '', notes: 'VT-generated after Sales Report is entered; owner provides additional client info and returns', receivedNotes: '', pendingNotes: '', tier: 'full', unlockedBy: [5, 26] },
  { id: 7, name: 'Sales Report by Product/Service (5 years)', status: 'not_received', dateProvided: '', notes: 'If applicable', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 8, name: 'Tax Returns (3 years)', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 9, name: 'Salary & Benefits for Owner (3 years + TTM)', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 10, name: 'Payroll Report (TTM)', status: 'not_received', dateProvided: '', notes: 'All employees (owners included): payroll summary, used to verify owner pay and total staffing cost', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 11, name: 'List of Non-Recurring Business Expenses (3 years + TTM)', status: 'not_received', dateProvided: '', notes: 'If any - addbacks', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 12, name: 'List of Nonbusiness Related Expenses (3 years + TTM)', status: 'not_received', dateProvided: '', notes: 'If any - addbacks', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 13, name: 'Discovery Questionnaire', status: 'not_received', dateProvided: '', notes: 'See Discovery tab', receivedNotes: '', pendingNotes: '', tier: 'minimum' },
  { id: 15, name: 'Current Accounts Receivable Aging Report - Excel', status: 'not_received', dateProvided: '', notes: 'As of same date as current Balance Sheet', receivedNotes: '', pendingNotes: '', tier: 'full' },
  { id: 16, name: 'Current Accounts Payable Aging Report - Excel', status: 'not_received', dateProvided: '', notes: 'As of same date as current Balance Sheet', receivedNotes: '', pendingNotes: '', tier: 'full' },
];

// Owner-facing per-document detail (format + which date range applies), mirroring
// the downloadable Document Request so the weekly reminder emails + the owner
// portal show the SAME specifics (e.g. "each month its own column, not just a
// total"). Keyed by checklist id; `range` picks a frozen date range computed
// from the engagement's discovery/activation date so it never drifts. Owners
// work off this list, not the original docs — so it has to be explicit. (2026-06-24)
// ─── AS-OF date engine (design completed w/ Mark 2026-07-20; migration 031) ───
// One anchor date per collection cycle; auto-advances monthly until the first
// upload lands (upload_started_date = the lock), respecting the deal's books
// lag; locked thereafter (advancing becomes a staff decision prompt). A server
// mirror will be needed when the portal displays it (increment 3).
// asOfAutoTarget: the month-END of the last month this business's books are
// assumed closed. 7-day close window: month M counts closed from the 8th of
// M+1 (lag 1); each extra lag month shifts one further back.
const asOfAutoTarget = (now, lagMonths) => {
  const lag = Math.max(1, Math.min(6, Number(lagMonths) || 1));
  const anchor = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
  const m = new Date(anchor.getFullYear(), anchor.getMonth() - (lag - 1), 1);
  return new Date(m.getFullYear(), m.getMonth(), 0); // month-end of the prior month
};
// asOfEffective: the cycle's operative as-of date + lock state.
//  - locked (uploads started): the stored date; if none was ever stored, the
//    lock-time value is RETRO-COMPUTED **legacy-faithfully** — month-end
//    before the OLD anchor's month (discovery || committal), i.e. exactly
//    what computeDocRequestDates showed this owner before the AS-OF system
//    existed. TRANSITION SAFETY: every in-flight locked deal's displayed
//    ranges are pixel-identical through the swap; an owner mid-collection
//    never sees their requested dates move. (Only if neither legacy anchor
//    exists do we fall back to the lag-target at upload start.)
//  - unlocked: max(stored, auto target) — a staff date ahead of auto holds
//    until the target passes it; systematic slowness belongs in the lag.
//    Unlocked deals' ranges MAY advance vs the old discovery-frozen display —
//    that is the drift bug this system exists to fix, and it's safe (nothing
//    has been uploaded against the old dates).
const asOfEffective = (deal, now = new Date()) => {
  const lag = deal.books_lag_months || 1;
  const parse = (s) => { const d = s ? new Date(String(s).slice(0, 10) + 'T00:00:00') : null; return d && !isNaN(d.getTime()) ? d : null; };
  const stored = parse(deal.as_of_date);
  if (deal.upload_started_date) {
    if (stored) return { date: stored, locked: true };
    const legacy = parse(deal.discovery_meeting_date) || parse(deal.committed_upload_date);
    if (legacy) return { date: new Date(legacy.getFullYear(), legacy.getMonth(), 0), locked: true };
    const started = parse(deal.upload_started_date);
    return { date: asOfAutoTarget(started || now, lag), locked: true };
  }
  const auto = asOfAutoTarget(now, lag);
  return { date: stored && stored > auto ? stored : auto, locked: false };
};
// Anchor feed for the existing range math: computeDocRequestDates/qbGuideDates
// derive every range from "month-end before the anchor month" — so the anchor
// that reproduces as-of X is the 1st of the month AFTER X.
const asOfRangeAnchor = (deal, now = new Date()) => {
  const eff = asOfEffective(deal, now);
  return new Date(eff.date.getFullYear(), eff.date.getMonth() + 1, 1);
};
const asOfLabel = (d) => d ? d.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' }) : '';
// The docs that must be re-requested when a locked as-of date advances:
// TTM-ranged items (2 TTM P&L, 4 TTM BS, 26 TTM customer breakdown, 10 payroll
// for owner-salary verification) + the balance-sheet-dated AR/AP agings
// (15/16 — "as of the same date as your current Balance Sheet"). Everything
// else (annuals, tax returns, adjustments) survives an advance unchanged.
const AS_OF_DATE_SENSITIVE_IDS = new Set([2, 4, 26, 10, 15, 16]);

const DOC_REQUEST_DETAIL = {
  1:  { fmt: 'Each year in its own column (set "Display columns by" to Years) · Accrual basis · Excel', range: 'annual' },
  27: { fmt: 'Each year in its own column (set "Display columns by" to Years) · Cash basis · Excel', range: 'annual' },
  2:  { fmt: 'Each month its own column (not just a TTM total) · Cash AND Accrual · Excel', range: 'ttm' },
  3:  { fmt: 'Each year in its own column (set "Display columns by" to Years) · Accrual basis · Excel · plus the most recent interim', range: 'annual' },
  4:  { fmt: 'Each month its own column · Accrual · Excel', range: 'ttm' },
  5:  { fmt: 'Each year in its own column (set "Display columns by" to Years) · For customer concentration & retention · Excel', range: 'cust' },
  26: { fmt: 'Customer breakdown for the trailing 12 months · Excel', range: 'ttm' },
  7:  { fmt: 'If you have distinct product / service lines · Each year in its own column · Excel', range: 'cust' },
  8:  { fmt: 'Complete business returns with all schedules', range: 'tax' },
  9:  { fmt: 'All forms of owner compensation', range: 'annualToTtm' },
  10: { fmt: 'All employees (owners included): payroll summary, used to verify owner pay and total staffing cost', range: 'ttm' },
  11: { fmt: 'One-time / unusual expenses — use the Adjustments Template we provide', range: 'annualToTtm' },
  12: { fmt: 'Personal expenses run through the business — use the Adjustments Template we provide', range: 'annualToTtm' },
  15: { fmt: 'The SUMMARY report, not Detail (search "A/R Aging Summary") · As of the same date as your current Balance Sheet · Excel', range: null },
  16: { fmt: 'The SUMMARY report, not Detail (search "A/P Aging Summary") · As of the same date as your current Balance Sheet · Excel', range: null },
};

// Frozen date ranges for the document request, computed from a fixed anchor (the
// engagement's discovery/activation date) so weekly reminders don't drift. Mirrors
// the Document Request template's date math. Returns formatted range strings.
function computeDocRequestDates(anchor) {
  const now = (anchor instanceof Date && !isNaN(anchor.getTime())) ? anchor : new Date();
  const fmt = (d) => d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  const priorMonth = new Date(now.getFullYear(), now.getMonth(), 0); // last day of prior month
  const ttmStart = new Date(priorMonth.getFullYear(), priorMonth.getMonth() - 11, 1);
  const cy = now.getFullYear();
  const aY = cy - 3;
  const annualEnd = fmt(priorMonth);
  return {
    ttm: `${fmt(ttmStart)} through ${fmt(priorMonth)}`,
    annual: `01/01/${aY} through ${annualEnd}`,
    annualToTtm: `01/01/${aY} through ${annualEnd}`,
    cust: `01/01/${cy - 5} through 12/31/${cy - 1}`,
    tax: `${aY}, ${aY + 1}, ${aY + 2}`,
  };
}

// The owner-facing detail line for a document id, given a frozen date set.
function docRequestDetailLine(id, dates) {
  const d = DOC_REQUEST_DETAIL[id];
  if (!d) return '';
  const range = (d.range && dates) ? dates[d.range] : '';
  return [d.fmt, range].filter(Boolean).join(' · ');
}

// Canonical discovery questionnaire (sellerQA). Single source of truth, shared
// by the valuation's in-memory state (cloned per instance) AND the warm-account
// direct insert — so the owner portal shows the same questions the moment an AM
// creates a warm account, before anyone opens the valuation in the editor.
// Clone before mutating (the component spreads each item with a fresh followUps).
// ── POSITIONS IN THE PERIOD (Zac 09-29, Midwest H&C: a buyer flagged that the P&L carried only
// half a year of a new trainer's salary and 3/4 of a new service manager's). Q10 asked about new
// roles but nothing ever used the answer. One row per role that is NET NEW or VACATED in a P&L
// period; each row writes its own adjustment (Colleen clicks — never automatic):
//   net new hire  → + Add "Missing Expense": pay × (12 − months on P&L)/12 × (1 + payroll tax)
//   vacated, not refilled → − Deduct "Non-Recurring Expense": pay × months on P&L/12 × (1 + payroll tax)
//   replacement   → no adjustment (the predecessor's pay is already on the P&L)
const POSITION_PAYROLL_TAX = 0.0765;
const positionAdjAmount = (r) => {
  const pay = Number(r.pay) || 0;
  const m = Math.min(12, Math.max(0, Number(r.months) || 0));
  if (r.kind === 'new') return Math.round(pay * (12 - m) / 12 * (1 + POSITION_PAYROLL_TAX));
  if (r.kind === 'vacated') return Math.round(pay * m / 12 * (1 + POSITION_PAYROLL_TAX));
  return 0;
};
const positionAdjItem = (r, plLine) => {
  const amt = positionAdjAmount(r);
  const m = Number(r.months) || 0;
  const role = (r.role || 'Unnamed role').trim();
  return r.kind === 'new'
    ? { type: 'add', category: 'Missing Expense', plLine, year: r.year, amount: amt, included: true, ttmMonth: 'spread', verificationDoc: '',
        source: 'Q10 positions table', description: `Net new hire — ${role}: ${m} of 12 months on the P&L; annualized to a full year (+7.65% payroll tax)` }
    : { type: 'deduct', category: 'Non-Recurring Expense', plLine, year: r.year, amount: amt, included: true, ttmMonth: 'spread', verificationDoc: '',
        source: 'Q10 positions table', description: `Vacated, not refilled — ${role}: ${m} months of pay on the P&L won't recur (+7.65% payroll tax)` };
};
function PositionsInPeriod({ positions, onChange, yearOptions, salaryLine, adjustmentItems, setAdjustmentItems }) {
  const rows = Array.isArray(positions) ? positions : [];
  const fmt = (n) => '$' + Math.round(n || 0).toLocaleString();
  const setRow = (id, patch) => onChange(rows.map(r => r.id === id ? { ...r, ...patch } : r));
  const addRow = () => onChange([...rows, { id: Date.now(), role: '', pay: '', months: '', kind: 'new', year: yearOptions[yearOptions.length - 1] || 'TTM', adjId: null }]);
  const adjFor = (r) => r.adjId ? (adjustmentItems || []).find(a => a.id === r.adjId) : null;
  const inSync = (r, a) => a && a.amount === positionAdjAmount(r) && a.year === r.year && a.type === (r.kind === 'new' ? 'add' : 'deduct');
  const pushAdj = (r) => {
    const item = positionAdjItem(r, salaryLine);
    const a = adjFor(r);
    if (a) { setAdjustmentItems(prev => prev.map(x => x.id === a.id ? { ...x, ...item } : x)); return; }
    const id = Date.now();
    setAdjustmentItems(prev => [...prev, { ...item, id, sourceAddedAt: new Date().toLocaleDateString() }]);
    setRow(r.id, { adjId: id });
  };
  const removeRow = (r) => {
    const a = adjFor(r);
    if (a && window.confirm(`Also remove its adjustment (${fmt(a.amount)}) from the Adjustments tab?`)) setAdjustmentItems(prev => prev.filter(x => x.id !== a.id));
    onChange(rows.filter(x => x.id !== r.id));
  };
  const total = rows.reduce((s, r) => s + (r.kind === 'new' ? -1 : r.kind === 'vacated' ? 1 : 0) * positionAdjAmount(r), 0);
  return (
    <div className="mt-2 p-2 border border-indigo-200 bg-indigo-50/40 rounded">
      <div className="text-xs font-semibold text-indigo-900">👥 Positions added or vacated — by P&L period (pick the year on each row)</div>
      <div className="text-[11px] text-gray-600 mb-1">One row per role that's <b>net new</b> or <b>vacated and not refilled</b>, per period. A new hire with part of a year on the P&L understates what the business costs to run — buyers catch it. Replacements need no adjustment.</div>
      {rows.length > 0 && (
        <table className="w-full text-xs mb-1">
          <thead><tr className="text-left text-gray-500"><th className="font-normal">Role</th><th className="font-normal">Annual pay</th><th className="font-normal" title="How many of the period's 12 months the P&L carries their pay">Months on P&L</th><th className="font-normal">What happened</th><th className="font-normal">Period</th><th className="font-normal text-right">Adjustment</th><th></th></tr></thead>
          <tbody>
            {rows.map(r => {
              const a = adjFor(r);
              const amt = positionAdjAmount(r);
              const ready = r.kind !== 'replacement' && amt > 0 && (r.role || '').trim();
              return (
                <tr key={r.id} className="align-middle">
                  <td><input value={r.role} onChange={e => setRow(r.id, { role: e.target.value })} placeholder="e.g. Service Manager" className="w-full p-1 border rounded text-xs" /></td>
                  <td><input type="number" value={r.pay} onChange={e => setRow(r.id, { pay: e.target.value })} placeholder="120000" className="w-24 p-1 border rounded text-xs text-right" /></td>
                  <td><input type="number" min="0" max="12" step="0.5" value={r.months} onChange={e => setRow(r.id, { months: e.target.value })} placeholder="6" className="w-16 p-1 border rounded text-xs text-right" /></td>
                  <td><select value={r.kind} onChange={e => setRow(r.id, { kind: e.target.value })} className="p-1 border rounded text-xs">
                    <option value="new">Net new hire</option><option value="vacated">Vacated, not refilled</option><option value="replacement">Replacement (no adjustment)</option>
                  </select></td>
                  <td><select value={r.year} onChange={e => setRow(r.id, { year: e.target.value })} className="p-1 border rounded text-xs">
                    {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
                  </select></td>
                  <td className="text-right whitespace-nowrap">
                    {r.kind === 'replacement' ? <span className="text-gray-400">none</span>
                      : <span className={r.kind === 'new' ? 'text-red-700' : 'text-green-700'}>{r.kind === 'new' ? '−' : '+'}{fmt(amt)} EBITDA</span>}
                  </td>
                  <td className="whitespace-nowrap pl-1">
                    {ready && (inSync(r, a)
                      ? <span className="text-green-700 text-[11px]">✓ in Adjustments</span>
                      : <button onClick={() => pushAdj(r)} className="px-2 py-0.5 text-[11px] rounded bg-indigo-600 text-white">{a ? '⟳ Update adjustment' : '＋ Create adjustment'}</button>)}
                    <button onClick={() => removeRow(r)} title="Remove row" className="ml-1 text-gray-400 hover:text-red-600">✕</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      <div className="flex items-center gap-3 text-[11px]">
        <button onClick={addRow} className="px-2 py-0.5 rounded border border-indigo-300 bg-white text-indigo-700">＋ Add position</button>
        {rows.length > 0 && <span className="text-gray-600">Net effect on EBITDA: <b className={total < 0 ? 'text-red-700' : 'text-green-700'}>{total < 0 ? '−' : '+'}{fmt(Math.abs(total))}</b> · posts to <b>{salaryLine}</b> (change the line on the Adjustments tab if needed) · includes 7.65% payroll tax; add benefits by hand</span>}
      </div>
    </div>
  );
}

const DEFAULT_SELLER_QA = [
  // ========== 1. FOUNDATIONAL / WHY ==========
  { id: 1, question: 'Why are you considering selling, and what is your ideal timeline?', answer: '', status: 'pending', followUps: [], notes: 'Understand seller motivation and urgency', section: 'foundational' },
  { id: 2, question: 'Who are the owners/partners in the business?', answer: '', status: 'pending', followUps: [], notes: 'Verify against tax return / operating agreement later', section: 'foundational' },
  { id: 30, question: 'Does the business hold any ownership designations or certifications — for example woman-owned, minority-owned, veteran-owned or service-disabled veteran-owned, or any similar status?', answer: '', status: 'pending', followUps: [], notes: 'Diversity / veteran ownership certifications (WOSB, MBE/DBE, VOSB / SDVOSB, etc.) can widen the buyer pool and qualify the business for set-aside contracts — a marketability / value driver. Flag for the CIM if present.', section: 'foundational' },
  { id: 31, question: "Does the business need to hold any licenses, certifications, or special qualifications to legally operate — for example a contractor's license, master plumber or journeyman electrician license, or another professional or regulatory credential? If so, please list them and note who holds each.", answer: '', status: 'pending', followUps: [], notes: 'Operating licenses / professional certifications REQUIRED to run the business (contractor, master plumber, journeyman electrician, etc.) — distinct from the ownership-designation question (id 30). Transferability / continuity risk: a credential held only by a departing owner can block the buyer from operating; flag for the CIM and the owner-dependency assessment.', section: 'foundational' },

  // ========== 2. BUSINESS MODEL ==========
  { id: 3, question: 'What percentage of your customers are businesses vs residential/consumers?', answer: '', numericValue: null, status: 'pending', followUps: [], notes: 'B2B customers typically stickier. Verify with Sales tab data.', section: 'business_model', inputType: 'percent' },
  { id: 4, question: "Please estimate the total number of active clients you currently serve.", answer: '', numericValue: null, status: 'pending', followUps: [], notes: 'More clients = better diversification. Verify with Sales tab (calculated from the Sales by Customer report if provided).', section: 'business_model', inputType: 'number' },
  { id: 5, question: "Please estimate what percentage of your revenue comes from your largest customer.", answer: '', numericValue: null, status: 'pending', followUps: [], notes: 'Under 15% is ideal. Verify with Sales tab (calculated from the Sales by Customer report if provided).', section: 'business_model', inputType: 'percent' },
  { id: 23, question: 'Do you have any clients outside the United States? If so, what percentage of revenue do they generate?', answer: '', numericValue: null, status: 'pending', followUps: [], notes: 'International clients = currency risk, legal jurisdiction, service delivery complexity.', section: 'business_model', inputType: 'percent' },
  { id: 6, question: 'Is your largest customer under contract? If so, what are the terms (length, renewal)?', answer: '', status: 'pending', followUps: [], notes: 'M2M top customer = high risk. Multi-year = protected.', section: 'business_model' },
  { id: 7, question: 'What is your typical contract length with customers? (M2M, Annual, Multi-year)', answer: '', status: 'pending', followUps: [], notes: 'Longer contracts = higher value.', section: 'business_model' },
  { id: 8, question: 'Describe the timing of when you receive payment relative to when services are performed. Do customers pay in advance, at milestones/stages, or after services are complete?', answer: '', status: 'pending', followUps: [], notes: 'Helps understand cash/revenue cycle and recognition practices.', section: 'business_model' },
  { id: 9, question: 'Is revenue seasonal? If so, describe the pattern.', answer: '', status: 'pending', followUps: [], notes: 'Affects TTM analysis - ensure apples to apples comparison.', section: 'business_model' },

  // ========== 3. OPERATIONS ==========
  { id: 10, question: 'How many people work for your business today? Over the past 12 months, has your team grown, shrunk, or stayed about the same — and roughly how many people joined and how many left? A quick note on any new roles or restructuring is helpful.', answer: '', numericValue: null, numericValue2: null, status: 'pending', followUps: [], notes: 'Total → Revenue per Employee. Departures → turnover signal (>15% of headcount may indicate culture/comp issues). Growth/new roles live in the narrative answer.', section: 'operations', inputType: 'number', inputType2: 'number', inputLabel: 'Total Employees', inputLabel2: 'Departures (12 mo)' },
  { id: 24, question: 'Do you have any employees or contractors who live outside the United States? If so, where and in what roles?', answer: '', status: 'pending', followUps: [], notes: 'International workers = labor law compliance, time zones, communication challenges.', section: 'operations' },
  { id: 11, question: 'Describe the management structure of the company. Are there key employees or department heads critical to operations?', answer: '', status: 'pending', followUps: [], notes: 'Deeper management = easier transition. Key person dependency = risk.', section: 'operations' },
  { id: 12, question: 'Do any family members work for the company? What are their duties? What would it cost to replace them?', answer: '', status: 'pending', followUps: [], notes: 'Family may work below market (adjustment). Surface issues early.', section: 'operations', flagKeywords: ['yes', 'wife', 'husband', 'son', 'daughter', 'brother', 'sister', 'father', 'mother', 'spouse'] },
  { id: 13, question: 'How does the company acquire new customers? (Referrals, marketing, outbound sales, etc.)', answer: '', status: 'pending', followUps: [], notes: 'If owner is primary salesperson = customer relationship risk.', section: 'operations' },
  { id: 14, question: 'Are there any critical vendor or supplier relationships? Any single-source dependencies?', answer: '', status: 'pending', followUps: [], notes: 'Single-source dependency = supply chain risk.', section: 'operations' },

  // ========== 4. OWNER INVOLVEMENT ==========
  { id: 15, question: 'How active are the owners in the business? Approximately how many hours per week does each work?', answer: '', numericValue: null, status: 'pending', followUps: [], notes: 'Less active owner = easier transition = higher value.', section: 'owner', inputType: 'number' },
  { id: 16, question: "What are the owners' roles in the business? (e.g., CEO, sales, operations, strategic oversight)", answer: '', status: 'pending', followUps: [], notes: 'Describes what the owner does day-to-day.', section: 'owner' },
  { id: 26, question: 'What percentage of revenue comes from customer relationships the owner personally manages?', answer: '', numericValue: null, status: 'pending', followUps: [], notes: 'High owner-managed revenue = transition risk. This directly impacts valuation.', section: 'owner', inputType: 'select', selectOptions: [
    { value: 0, label: '0-10% — Sales team handles customer relationships' },
    { value: 17, label: '10-25% — Owner has a few key accounts' },
    { value: 37, label: '25-50% — Owner manages significant portion' },
    { value: 62, label: '50-75% — Owner is primary salesperson' },
    { value: 87, label: '75-100% — Nearly all revenue through owner' }
  ]},
  { id: 17, question: 'Do the owners want to exit post sale, or would any want to stay?', answer: '', status: 'pending', followUps: [], notes: 'If transition requires owner 90+ days = red flag for dependency issues.', section: 'owner' },
  { id: 18, question: 'If any owners are staying post-sale, what salary would each require?', answer: '', status: 'pending', followUps: [], notes: 'If exiting, we calculate replacement cost based on role + hours + location.', section: 'owner' },

  // ========== 5. FINANCIAL / ACCOUNTING PRACTICES ==========
  { id: 19, question: 'Do any customer contracts exceed 12 months in length? If so, how do you recognize the revenue - upfront when signed, or over the service period?', answer: '', status: 'pending', followUps: [], notes: 'Upfront recognition of multi-year contracts = potential restatement needed.', section: 'financial' },
  { id: 20, question: 'Do you have any multi-year vendor agreements or prepaid vendor invoices?', answer: '', status: 'pending', followUps: [], notes: 'Large prepayments should be amortized, not expensed upfront.', section: 'financial' },
  { id: 21, question: 'Does the company regularly post accounts payable (AP) to the books?', answer: '', status: 'pending', followUps: [], notes: 'If No: Accrual P&L may be unreliable. Consider Cash basis for analysis.', section: 'financial' },
  // id 25 restored 2026-07-31 (Zac, option A): the CapEx Investigation flag
  // has cross-checked this id against the Balance Sheet all along — the
  // question itself was missing, so owners were never asked.
  { id: 25, question: 'Have you purchased any major equipment, vehicles, technology, or facility improvements in the last 3 years? Please list the significant items. Is anything major going to need replacement or repair in the next 2–3 years?', answer: '', status: 'pending', followUps: [], notes: 'Feeds the CapEx Investigation flag. Cross-checked against Balance Sheet fixed assets: "none" + significant BS assets = discrepancy flag. Item keywords (vehicle/equipment/server/renovation…) auto-flag for a maintenance-CapEx adjustment. Rare for service businesses — decisive for asset-heavy ones.', section: 'financial', ownerWhy: 'Equipment and vehicles wear out. Knowing what you have bought recently and what will need replacing soon lets us present your true ongoing profit accurately to buyers.' },
  // id 32 added 2026-09-08 (Zac, from the Dorian buyer-QoE: Withum caught
  // DDS's severance as DA-06 +$75K TTM; we'd missed the same addback on
  // Loyal IT — "if a company pays severance this should be included as an
  // addback. Should be added to questionnaire."). Owners almost never list
  // severance on the Adjustments Template unprompted — it hides in payroll.
  { id: 32, question: 'In the last 3 years, have you paid severance to anyone, or eliminated any roles you do not plan to refill? If so, what role, roughly when, and about how much did the severance cost?', answer: '', status: 'pending', followUps: [], notes: 'Severance for an eliminated role = one-time addback (and the eliminated role reduces go-forward payroll). Cross-check the Adjustments Template — a yes here that is missing there is the follow-up. Companion example row lives on the template (added 09-08).', section: 'financial', flagKeywords: ['yes', 'severance', 'laid off', 'let go', 'eliminated', 'terminated'], ownerWhy: 'Severance for a role that will not be refilled is a one-time cost, not part of your ongoing operations — adding it back shows buyers your true continuing profit.' },
  // CONTINGENT LIABILITIES (Mark 09-26, replacing Zac's 09-25 SBA / personal-
  // guarantee gate). The deal that prompted the gate was the BUSINESS guaranteeing
  // someone else's loan — a contingent liability, off the balance sheet, that no
  // other question surfaces. An owner's PG on the business's OWN debt is routine
  // (every SBA loan has one), sits on the balance sheet, and clears at closing —
  // gating on it told owners a normal thing was a problem. New id (34): the
  // re-sync drops the old id-33 answers (its option values meant other things).
  // 'Yes' = CRITICAL until Colleen has quantified it (outstandingAnalysis 4b);
  // 'Not sure' = a follow-up, not a hold.
  { id: 34, question: 'Does the business have any contingent liabilities — obligations that only become real if something happens? If yes, describe them.', answer: '', numericValue: null, status: 'pending', followUps: [], notes: "Mark 09-26: guarantees of anyone else's debt, pending/threatened claims, open tax notices, LCs/bonds, abnormal warranty exposure, regulatory notices. A yes must be quantified by Colleen before Analysis Complete (critical flag); 'Not sure' = follow-up. The owner's PG on the business's own loans is NOT this — that's on the balance sheet and pays off at close.", section: 'financial', inputType: 'select', selectOptions: [
    { value: 0, label: 'No — nothing like that' },
    { value: 1, label: 'Yes — described below' },
    { value: 2, label: 'Not sure' }
  ], flagKeywords: ['yes', 'not sure', 'guarant', 'co-sign', 'cosign', 'lawsuit', 'audit', 'dispute'], ownerWhy: "Examples: the business has guaranteed or co-signed a loan, lease, or line of credit for anyone else (you, a family member, or another company you own); a lawsuit, claim, or dispute that is pending or has been threatened; an open tax notice or audit; warranty or refund obligations beyond the normal course; letters of credit or bonds outstanding; an environmental or regulatory issue you've been notified about. Not counted: a loan the business took out in its own name, even if you personally guaranteed it — that is already on the balance sheet and is paid off at closing. Buyers find these in due diligence; knowing now keeps a sale from stalling later." },

  // ========== 6. REAL ESTATE ==========
  { id: 22, question: 'Is the real estate owned by you personally, the company, or leased from a third party? If owned, do you intend to sell it with the company or retain ownership and lease it to the buyer? If leasing to buyer, what terms (rate, gross/triple net)?', answer: '', status: 'pending', followUps: [], notes: 'If owner retains and leases, verify rate is at market.', section: 'real_estate' }
];

// Discovery display numbers (Mark 09-28). Question ids are permanent storage
// keys and skip numbers (retired ids are never reused); what staff and owners
// SEE is the position: section order, then id within the section. Every "Q#"
// label, the questionnaire download and the paste-answers import use this one
// ordering — never print q.id as a question number.
const DISCOVERY_SECTION_ORDER = ['foundational', 'business_model', 'operations', 'owner', 'financial', 'real_estate'];
const sortDiscoveryQuestions = (qa) => [...(qa || [])].sort((a, b) => {
  const sectionDiff = DISCOVERY_SECTION_ORDER.indexOf(a.section) - DISCOVERY_SECTION_ORDER.indexOf(b.section);
  if (sectionDiff !== 0) return sectionDiff;
  return a.id - b.id;
});
const discoveryDisplayNumbers = (qa) => {
  const nums = {};
  sortDiscoveryQuestions(qa).forEach((q, idx) => { nums[q.id] = idx + 1; });
  return nums;
};

/* ══════════════════════════════════════════════════════════════════
   WORKFLOW STAGE METADATA  (13-stage model — migration 005)
   ──────────────────────────────────────────────────────────────────
   Each stage has:
     label          — display text
     color          — badge classes
     responsibility — fn(project) -> the person whose job it is, RIGHT
                      NOW, to move the project out of this stage
     targetDays     — business-day target for time-in-stage; the
                      "Days in Stage" column colors green/amber/red
                      against this. Tune with the team — these are
                      first-pass defaults from the workflow doc.
   ══════════════════════════════════════════════════════════════════ */
const WORKFLOW_STAGES = {
  // Pre-meeting onboarding state (Warm → Active lifecycle). Created by an AM
  // before the introductory meeting: portal questions go live + the intro email
  // goes out, but the account is EXCLUDED from the active pipeline (not in
  // ACTIVE_STAGES) so no-shows never clutter Konnie/Colleen. The AM owns it
  // (chase the link / follow up); the Lead activates or passes after the meeting.
  warm:                   { label: 'Warm — Pre-Meeting',       color: 'bg-orange-100 text-orange-700', targetDays: null, responsibility: (p) => p.account_manager || 'AM' },
  awaiting_upload:        { label: 'Awaiting Upload',          color: 'bg-amber-100 text-amber-700',   targetDays: 5,  responsibility: ()  => 'Konnie' },
  upload_started:         { label: 'Upload Started',           color: 'bg-amber-100 text-amber-700',   targetDays: 5,  responsibility: ()  => 'Konnie' },
  upload_complete:        { label: 'Upload Complete',          color: 'bg-blue-100 text-blue-700',     targetDays: 1,  responsibility: ()  => 'Konnie' },
  data_entry_complete:    { label: 'Data Entry Complete',      color: 'bg-blue-100 text-blue-700',     targetDays: 3,
    // Partials (2026-06-08): skip routes straight to the Lead (Leads set the
    // valuation meeting); quick-look / blank goes to Colleen for a fast
    // glance. Full valuations are always Colleen's analysis.
    responsibility: (p) => (p.path === 'partial' && p.colleen_review_decision === 'skip') ? (p.lead || 'Lead') : 'Colleen' },
  adjustments_entered:    { label: 'Adjustments Entered',      color: 'bg-blue-100 text-blue-700',     targetDays: 2,
    responsibility: (p) => (p.path === 'partial' && p.colleen_review_decision === 'skip') ? (p.lead || 'Lead') : 'Colleen' },
  analysis_complete:      { label: 'Analysis Complete',        color: 'bg-indigo-100 text-indigo-700', targetDays: 1,
    // Meeting-setting is the Lead's job for partials (2026-06-08). Full
    // valuations stay with Colleen here pending Mark's call on whether Leads
    // set those meetings too.
    responsibility: (p) => p.path === 'partial' ? (p.lead || 'Lead') : 'Colleen' },
  val_meeting_set:        { label: 'Valuation Meeting Set',    color: 'bg-purple-100 text-purple-700', targetDays: 5,  responsibility: (p) => p.lead || 'Lead' },
  awaiting_decision:      { label: 'Awaiting Decision',        color: 'bg-purple-100 text-purple-700', targetDays: 5,  responsibility: (p) => p.lead || 'Lead' },
  // Fallback is '⚠ Unassigned', not 'AM' — a bare 'AM' on the team radar
  // reads like a person and hides the real problem (Erosion Pros sat stalled
  // with NO account manager, invisible to every plate and nudge; Mark
  // 2026-07-29 read the label as maybe-Adam/maybe-J.C.).
  stalled_returned_to_am: { label: 'Stalled — Returned to AM', color: 'bg-red-100 text-red-700',       targetDays: 30, responsibility: (p) => p.account_manager || '⚠ Unassigned' },
  engaged:                { label: 'Engaged',                 color: 'bg-green-100 text-green-700',   targetDays: null, responsibility: (p) => p.lead || 'Lead' },
  strategic_review_set:   { label: 'Active — Strategic Review Set', color: 'bg-teal-100 text-teal-700',  targetDays: null, responsibility: (p) => p.lead || 'Lead' },
  // Valued, owner is strongly considering and asked us to circle back on a
  // date (e.g. +90 days). Stays valuation-active and Lead-owned — the Lead
  // holds the owner relationship; Colleen may chase the follow-up but never
  // takes ownership. Only moves to the AM if it later flips to inactive. The
  // follow-up date lives in snooze_until ("next-touch", same as the AM bucket).
  considering_followup:   { label: 'Active — Follow-up Scheduled', color: 'bg-amber-100 text-amber-800', targetDays: null, responsibility: (p) => p.lead || 'Lead' },
  val_complete_inactive:  { label: 'Valuation Complete — Inactive', color: 'bg-gray-200 text-gray-600', targetDays: null, responsibility: (p) => p.account_manager || 'AM' },
  val_complete_dead:      { label: 'Valuation Complete — Dead',     color: 'bg-gray-200 text-gray-600', targetDays: null, responsibility: ()  => '—' },
  // Dead BEFORE any valuation was produced — the Lead passed on a warm account
  // (too small / not a fit) or an AM marked a never-valued owner dead. Distinct
  // from val_complete_dead (a valuation WAS delivered, then the owner went dead)
  // so "Valuation Complete" is never claimed falsely. Terminal + off the active
  // pipeline; the row + ShareFile folder are kept so no one re-markets. The
  // routing (which of the two dead stages) lives in passWarm / markOwnerDead.
  // (2026-07-13)
  disqualified:           { label: 'Dead — No Valuation',           color: 'bg-gray-200 text-gray-600', targetDays: null, responsibility: ()  => '—' },
};

// Lifecycle rank of each stage (WORKFLOW_STAGES is defined in lifecycle order),
// so the Pipeline "Stage" column sorts first-stage → last-stage (and reverse)
// instead of alphabetically. (2026-06-22)
const STAGE_RANK = Object.keys(WORKFLOW_STAGES).reduce((m, s, i) => { m[s] = i; return m; }, {});

// Stages where an overdue clock means a STAFF member is sitting on actionable
// work (Mark 2026-07-27, after Information Systems Solutions sat 12d in
// Awaiting Decision unnoticed). Deliberately excludes awaiting_upload /
// upload_started (waiting on the OWNER — the cadence chases them, staff
// can't) and val_meeting_set (a meeting legitimately scheduled 2 weeks out
// is not negligence). Powers Mark's team-overdue radar AND mirrors the
// server's overdue-nudge email scope (server.js NUDGE_STAGES — keep in sync).
const OVERDUE_RADAR_STAGES = new Set([
  'upload_complete', 'data_entry_complete', 'adjustments_entered',
  'analysis_complete', 'awaiting_decision', 'stalled_returned_to_am',
]);
// The overdue clock (Adam 09-28, Corporate IT / McCarty): a follow-up date the
// person SET in this stage is the plan. Once it passes, the clock runs from
// that date — 3 business days' grace, 2× (6) = stuck/copied to Mark — never
// from the stage entry (the June stall read "55 days past target" the first
// morning after his own 9/25 date). Stage age only governs a deal nobody has
// dated. Mirrors server.js sendOverdueNudges — keep the two in sync.
const overdueClock = (p, stageTarget) => {
  const snz = p.snooze_until ? String(p.snooze_until).slice(0, 10) : null;
  const entered = p.stage_entered_at ? String(p.stage_entered_at).slice(0, 10) : null;
  if (snz && entered && snz > entered) {
    return { days: businessDaysBetween(snz, new Date().toISOString()), target: 3, since: snz };
  }
  return { days: p.daysInStage, target: stageTarget, since: null };
};

// "All Others" remainder row (top-20 engine fix, Mark 2026-08-04): for huge
// books (Midwest HVAC, thousands of clients) the grid holds the top clients
// individually plus ONE row named "All Others" carrying the aggregate revenue
// of everyone else. It counts in totals — so concentration percentages are
// computed against the real book — but is excluded from top-client picks,
// retention/churn, client counts, and contract detail.
const isRemainderRow = (c) => /^\s*(all\s+|the\s+)?others?\b|\bremainder\b|^\s*balance of\b/i.test(String((c && c.name) || ''));

// Stages that count as "in the active pipeline" — shown on the dashboard.
// Excludes the four terminal/exit stages.
const ACTIVE_STAGES = [
  'awaiting_upload', 'upload_started', 'upload_complete',
  'data_entry_complete', 'adjustments_entered', 'analysis_complete',
  'val_meeting_set', 'awaiting_decision',
];
// Stages where the committal date is still meaningful (upload phase only).
const UPLOAD_PHASE_STAGES = ['awaiting_upload', 'upload_started'];

// ── AWAITING DECISION RULE (Mark 09-28, Integrated / Assura) ──
// A deal stays Awaiting Decision until the owner decides (strategic review ·
// engage · neither). A dated "follow up with me" is a REMINDER on a deal that
// is still deciding (snooze_until), not a reason to leave the bucket —
// Integrated (company meeting 10/5, near-certain to engage) vanished from the
// staff meeting when it was moved to Considering. Only a circle-back further
// out than DECIDING_WINDOW_DAYS parks the deal in Considering.
const DECIDING_WINDOW_DAYS = 90;
const followupStage = (dateIso) => {
  const limit = new Date(Date.now() + DECIDING_WINDOW_DAYS * 86400000).toISOString().slice(0, 10);
  return dateIso && String(dateIso).slice(0, 10) <= limit ? 'awaiting_decision' : 'considering_followup';
};
// The Lead's read on a deciding owner — one click writes likelihood_pct (the
// existing near-term likelihood field), the mark is derived from it.
const LIKELIHOOD_MARKS = [
  ['🔥', 'Likely to engage', 80],
  ['🤔', 'Undecided', 50],
  ['❄', 'Unlikely', 20],
];
const likelihoodMark = (pct) => {
  if (pct === '' || pct == null || isNaN(Number(pct))) return null;
  const n = Number(pct);
  return n >= 75 ? '🔥' : n >= 40 ? '🤔' : '❄';
};
// Staff-meeting sub-group inside Awaiting Decision: agreement out first, then
// deciding now (no date / within 14 days), then deciding later (dated further).
const decidingGroup = (p) => {
  if (!p || p.workflow_stage !== 'awaiting_decision') return null;
  if (p.agreementOutAt) return { rank: 0, label: '📝 Agreement out' };
  const d = p.snooze_until ? String(p.snooze_until).slice(0, 10) : null;
  const soon = new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10);
  if (d && d > soon) return { rank: 2, label: `Deciding later — follow up ${d}` };
  return { rank: 1, label: d ? `Deciding now — follow up ${d}` : 'Deciding now' };
};
// Valuation date = the day the valuation meeting happened (Mark 09-28: the
// committee counts VT dates). Stamped whenever a meeting outcome is recorded
// and the field is empty: the booked valuation-meeting date if it has passed,
// else today.
const valuationDateOnOutcome = (w) => {
  if (!w || w.valuation_date) return {};
  const today = new Date().toISOString().slice(0, 10);
  const booked = w.next_meeting_date && /val/i.test(w.next_meeting_type || '') ? String(w.next_meeting_date).slice(0, 10) : null;
  return { valuation_date: booked && booked <= today ? booked : today };
};

// Likelihood % = how seriously the owner is considering selling in the next ~30
// days — a metric for the ACTIVE pipeline only. When a project leaves the active
// funnel (engaged, inactive, dead, stalled, or parked into a review/follow-up
// cadence), the likelihood resets to 0 so the metric reflects only live deals; a
// re-engagement sets a fresh read. `warm` is the pre-pipeline intake where the AM
// sets the initial read, so it's excluded from the reset. (Mark 2026-06-24)
const stageZeroesLikelihood = (stage) => stage !== 'warm' && ACTIVE_STAGES.indexOf(stage) === -1;

// Canonical Pipeline column list. Drives both the column-visibility menu
// (Mark 2026-05-27: per-user "Columns" picker) and the table render. `key`
// matches the sort column where applicable. `required` columns can't be
// hidden — Business is the row identity. Persistence stores HIDDEN keys, so
// future columns added here default to visible for existing users.
const PIPELINE_COLUMNS = [
  { key: 'company_name',      label: 'Business',    required: true  },
  { key: 'workflow_stage',    label: 'Stage'        },
  { key: 'path',              label: 'Path'         },
  // The owner's "wants to discuss value by" date, picked on their first
  // portal visit (Mark 2026-07-28: good to see while reviewing for staff
  // meeting). Hidden-keys persistence → defaults visible for everyone.
  { key: 'owner_target_valuation_date', label: '🎯 Owner Target' },
  { key: 'likelihood_pct',    label: '%'            },
  { key: 'lead',              label: 'Lead'         },
  { key: 'account_manager',   label: 'AM'           },
  { key: 'responsibility',    label: 'Resp.'        },
  { key: 'daysPastCommitted', label: 'Committal'    },
  { key: 'docsOutstanding',   label: 'Docs'         },
  { key: 'openItemsOpen',     label: 'Open'         },
  { key: 'value_provided_high',  label: 'Valuation'       },
  { key: 'estimated_commission', label: 'Est. Commission' },
  { key: 'nextAction',        label: 'Next Action'  },
  { key: 'interactionAt',     label: 'Last'         },
];

const stageLabel = (key) => (WORKFLOW_STAGES[key] || { label: key || '—' }).label;
const stageColor = (key) => (WORKFLOW_STAGES[key] || { color: 'bg-gray-100 text-gray-700' }).color;
const stageTargetDays = (key) => {
  const s = WORKFLOW_STAGES[key];
  return s && typeof s.targetDays === 'number' ? s.targetDays : null;
};
// ── AM inheritance (J.C. offboarded — Mark 2026-07-27) ──────────
// The stored account_manager NEVER changes for J.C.'s active-pipeline and
// listed deals: attribution stays his, and if they close Vista pays his
// commission. But the WORK routes to Adam — every plate/bucket/nudge that
// asks "whose job is this?" resolves through this map, and cards wear a
// "from J.C." badge so Adam knows the owner has never spoken to him.
// (Stale deals — stalled/valued-inactive — were genuinely reassigned via
// jc-stale-reassign.sql instead.) Keep in sync with server.js AM_INHERITANCE.
const AM_INHERITANCE = { 'J.C.': 'Adam' };
const amOwner = (name) => AM_INHERITANCE[String(name || '').trim()] || name;
// Badge for inherited accounts — shown wherever the deal surfaces as work.
const InheritedAmBadge = ({ am }) => (AM_INHERITANCE[String(am || '').trim()]
  ? <span className="ml-1.5 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-slate-200 text-slate-600" title={`${am}'s account — ${am} has left Vista, so it works from ${AM_INHERITANCE[String(am).trim()]}'s plate. History and commission attribution stay with ${am}.`}>from {am}</span>
  : null);

const stageResponsibility = (project) => {
  const s = WORKFLOW_STAGES[project.workflow_stage];
  if (!s) return '—';
  // amOwner: a departed AM's plate work routes to their inheritor; Lead /
  // Konnie / Colleen names pass through untouched.
  try { return amOwner(s.responsibility(project)) || '—'; }
  catch (e) { return '—'; }
};

// Estimated Vista commission on the top valuation — the same tiered schedule
// the valuation tool uses elsewhere (8% first $1M, then 5/4/3% on the next
// $1M tiers, 2% above $4M, minimum $40,000). Used to snapshot the pipeline
// commission alongside the top value. (2026-06-08)
const computeCommission = (topValue) => {
  let commission = 0, remaining = topValue || 0;
  const tiers = [
    { limit: 1000000, rate: 0.08 },
    { limit: 1000000, rate: 0.05 },
    { limit: 1000000, rate: 0.04 },
    { limit: 1000000, rate: 0.03 },
    { limit: Infinity,  rate: 0.02 },
  ];
  for (const tier of tiers) {
    if (remaining <= 0) break;
    const amt = Math.min(remaining, tier.limit);
    commission += amt * tier.rate;
    remaining -= amt;
  }
  return Math.max(40000, commission);
};

// Setup fields the tool needs to do its job. Returns short human labels for
// what's missing on a project, each gated to where the field is actually
// relevant, so a late-stage project isn't nagged about an upload-phase
// field. Drives the "Needs setup" block on My Work (2026-06-08). These gaps
// fail silently today (e.g. no committed date → invisible to the cadence
// engine), so they're surfaced as the top, most-actionable bucket.
const setupIssues = (project) => {
  if (!project) return [];
  const issues = [];
  const inUpload = UPLOAD_PHASE_STAGES.indexOf(project.workflow_stage) !== -1;
  // committed date + owner email only matter while we're still chasing the
  // owner for uploads.
  if (inUpload && !project.committed_upload_date) issues.push('committed upload date');
  if (inUpload && !project.owner_email) issues.push('owner email');
  // path + partial planned-docs + lead are fundamental at any active stage.
  if (!project.path) issues.push('valuation type (Full/Partial)');
  if (project.path === 'partial' && project.counts && project.counts.plannedTotal === 0) {
    issues.push('planned documents');
  }
  if (!project.lead) issues.push('lead');
  return issues;
};

// P&L paste: a row whose NAME says "expense" inside the Other Income section
// (or "income/gain" inside Other Expense) goes where its name says (Konnie
// 09-22, Hawver Display: a non-QB statement lists Interest Income … Interest
// Expense … "Total Other Income" with no section headers at all, so the whole
// tail after "Total Expenses" parsed as Other Income and $32K/yr of interest
// expense became income). QB-style sign convention is respected: if a re-
// routed row's figures are all negative (an expense shown as negative other
// income), they flip to positive in their new section.
// Taxes (Mark 10-12, tie-out regression): "State Income Tax" / "KS Corporate Income Tax" sit under Other
// Expense; the word "Income" moved them to Other Income and net income came out twice the tax too high.
// Income/franchise/excise taxes only: "Sales Tax Discounts" under Other Income is income.
const OTHER_EXPENSE_NAME_RX = /\b(expenses?|income\s+tax(es)?|(franchise|excise)\s+tax(es)?|loss(es)? on|amortization|penalt(y|ies)|interest paid|write[\s-]?offs?|bad debt)\b/i;
const OTHER_INCOME_NAME_RX = /\b(incomes?|gains? on|refunds?|rebates?|reimbursements?|dividends?)\b/i;
// DUPLICATE CHILD NAMES across headings (Fabkom 10-05: "Payroll-Officers' > FICA/Med/ADP" AND
// "Payroll > FICA/Med/ADP" in one paste). The cross-format child match refuses ambiguous children, so both
// became NEW lines — the stored 100%-add-back officers line sat at $0 and the officers' tax landed on a line
// with no add-back (EBITDA silently dropped). Resolve them by HEADING first, then by elimination:
//   A) a stored name that is exactly child + heading in any order ("FICA/Med/ADP - Payroll-Officers'") → that row;
//   B) the one row left for a child ↔ the one stored plain-child line left ("FICA/Med/ADP").
// Returns Map(pasteRowIndex → existing index). Rows it can't pin stay unmatched (→ new line), as before.
// 📌 EBITDA SNAPSHOTS (Mark/Zac 10-05). A fixed record of the numbers at a moment — what we PRESENTED,
// each hand-off, or on demand. Lines = every P&L line's TTM + its add-back %, adj = every adjustment, so a
// later comparison can say exactly what moved. Pure helpers (also used for archived revalue data).
// 🤖 AI REVIEW LESSONS — real misses, one line each (Mark 10-05: "I'll provide the errors she makes so we keep
// enhancing this"). Every new miss becomes a line here; the review checks each one on every deal. The goal:
// AI does the FIRST review, not the last.
const AI_REVIEW_LESSONS = [
  'Owner estimates / single-month bookings (10-05): if most expense lines for a period are booked in ONE month (e.g. everything in December) or look like round owner estimates, the TTM/YTD expenses are not real monthly books — flag it; the reviewer must explain it to the Lead before the valuation call.',
  'Fabkom (10-03): an add-back line (owner/officer payroll or payroll tax) at $0 while a similar non-add-back line jumped by about the same amount — a re-paste put the money on the wrong line.',
  'Fabkom (10-03): a TTM dollar adjustment equal to the PRIOR period\'s amount (stale), or larger than its P&L line for that year.',
  'Fabkom (10-03): duplicate-looking lines ("X (2)") or the same line name under two headings.',
  // A FALSE ALARM to stop raising (Colleen 10-28, Forward Slash: "Why are you flagging the Interest Expense as a
  // potential doubled entry? Only removed once and is an above the line expense on the P&L").
  'NOT an error (Forward Slash 10-28): in this tool EBITDA is BUILT by setting interest, income taxes (state and federal), depreciation and amortization P&L lines to a 100% add-back, and interest INCOME to 100% (removed). That add-back IS the EBITDA calculation, not a second adjustment. Never flag those lines at 100% as double-counting or as distorting EBITDA. Flag one only if the same expense ALSO appears as a separate dollar adjustment.',
];
const SNAP_SECTIONS = [['revenue', 'revenueCategories'], ['cogs', 'cogsCategories'], ['opex', 'opexCategories'], ['otherIncome', 'otherIncomeCategories'], ['otherExpense', 'otherExpenseCategories']];
const snapNorm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
const snapLeaf = (s) => snapNorm(String(s || '').split(' > ').pop());
const buildSnapLines = (src, basis) => {
  const b = basis === 'tax' ? 'cash' : (basis || 'cash');
  const out = [];
  SNAP_SECTIONS.forEach(([sec, key]) => (Array.isArray(src && src[key]) ? src[key] : []).forEach(c => {
    if (!c || !c.name) return;
    const v = (c[b] && c[b].ttm) || 0;
    out.push({ s: sec, n: c.name, t: Math.round(v * 100) / 100, a: Number(c.addbackPct) || 0 });
  }));
  return out;
};
const buildSnapAdj = (items) => (Array.isArray(items) ? items : []).map(a => ({
  d: a.description || '', l: a.plLine || '', y: a.year || '', amt: Number(a.amount) || 0, ty: a.type || '', inc: a.included !== false,
}));
// EBITDA effect of a line moving from "then" to "now": revenue adds, an expense subtracts net of its add-back.
const snapLineEffect = (sec, dt, a) => (sec === 'revenue' || sec === 'otherIncome') ? dt : -dt * (1 - (Number(a) || 0) / 100);
const snapLineMovers = (thenLines, nowLines) => {
  const key = (l) => l.s + '|' + snapNorm(l.n);
  const T = new Map((thenLines || []).map(l => [key(l), l])), N = new Map((nowLines || []).map(l => [key(l), l]));
  // A renamed line (heading added on re-paste) is the same line: pair leftovers by leaf name when unique.
  const leftT = [...T.keys()].filter(k => !N.has(k)), leftN = [...N.keys()].filter(k => !T.has(k));
  const leafN = {}; leftN.forEach(k => { const l = N.get(k); const lk = l.s + '|' + snapLeaf(l.n); (leafN[lk] = leafN[lk] || []).push(k); });
  const pairs = [];
  [...T.keys()].forEach(k => { if (N.has(k)) pairs.push([T.get(k), N.get(k)]); });
  leftT.forEach(k => { const l = T.get(k); const lk = l.s + '|' + snapLeaf(l.n); const c = leafN[lk]; if (c && c.length === 1) { pairs.push([l, N.get(c[0])]); leftN.splice(leftN.indexOf(c[0]), 1); c.length = 0; } else pairs.push([l, null]); });
  leftN.forEach(k => pairs.push([null, N.get(k)]));
  return pairs.map(([a, b]) => {
    const sec = (b || a).s, tt = a ? a.t : 0, nt = b ? b.t : 0;
    const effect = (b ? snapLineEffect(sec, nt, b.a) : 0) - (a ? snapLineEffect(sec, tt, a.a) : 0);
    return { name: (b || a).n, then: tt, now: nt, aThen: a ? a.a : null, aNow: b ? b.a : null, effect, sec };
  }).filter(m => Math.abs(m.effect) >= 1 || Math.abs(m.now - m.then) >= 1000 || (m.aThen !== m.aNow))   // money leaving a 100% add-back line has no direct EBITDA effect but shows where it went
    .sort((x, y) => (Math.abs(y.effect) - Math.abs(x.effect)) || (Math.abs(y.now - y.then) - Math.abs(x.now - x.then)));
};
const snapAdjChanges = (thenAdj, nowAdj) => {
  const k = (a) => snapNorm(a.d) + '|' + snapNorm(a.l) + '|' + a.y;
  const T = new Map((thenAdj || []).filter(a => a.inc).map(a => [k(a), a])), N = new Map((nowAdj || []).filter(a => a.inc).map(a => [k(a), a]));
  const out = [];
  N.forEach((a, key) => { const o = T.get(key); if (!o) out.push({ kind: 'added', a }); else if (Math.abs(o.amt - a.amt) >= 1) out.push({ kind: 'changed', a, was: o.amt }); });
  T.forEach((a, key) => { if (!N.has(key)) out.push({ kind: 'removed', a }); });
  return out;
};
const SNAP_KIND_LABEL = { presented: 'Presented to owner', baseline: 'Baseline', handoff: 'Hand-off', manual: 'Saved', prior_valuation: 'Prior valuation', period: 'TTM update', before_paste: 'Before P&L paste' };
// The owner screen only compares against numbers the owner was actually GIVEN (Colleen 10-06, Concise: the
// 'baseline' = whatever was on file the day snapshots began — never presented, and higher than what the owner
// was last told). Baseline, hand-offs and pastes are staff-only.
const SNAP_OWNER_KINDS = ['presented', 'prior_valuation'];
// Stages where the valuation has been delivered to the owner — a valuation in one of these with no saved
// revenueScoring flag keeps the pre-10-06 (legacy) revenue scoring until its next revalue (Mark 10-06).
const REV_SCORING_LEGACY_STAGES = new Set(['awaiting_decision', 'strategic_review_set', 'considering_followup', 'engaged', 'val_complete_inactive', 'val_complete_dead', 'stalled_returned_to_am']);
// 🧾 EMPLOYER PAYROLL TAX, ACCURATELY (Colleen 10-22 🐞, Arakyta → Mark: "we should accurately calculate it"). The owner
// adjustment used to be a flat 7.65% × (owner salary − market replacement). But Social Security (6.2%) stops at the
// year's wage base; only Medicare (1.45%) runs on every dollar. So the adjustment is now the real tax on the
// replacement minus the real tax on the owner's pay, each with that year's wage base. A custom rate above 6.2% keeps
// the extra as uncapped (e.g. state taxes). 'flat' = the old math, kept for valuations presented before 10-22 until
// their next revalue (same rule as the capex and growth-test changes).
const SS_WAGE_BASE = { 2018: 128400, 2019: 132900, 2020: 137700, 2021: 142800, 2022: 147000, 2023: 160200, 2024: 168600, 2025: 176100, 2026: 184500 };
const ssWageBase = (year) => {
  const y = Number(year), ks = Object.keys(SS_WAGE_BASE).map(Number);
  if (SS_WAGE_BASE[y]) return SS_WAGE_BASE[y];
  return SS_WAGE_BASE[y > Math.max(...ks) || !y ? Math.max(...ks) : Math.min(...ks)];
};
const employerPayrollTax = (pay, year, ratePct, method) => {
  const p = Math.max(0, Number(pay) || 0), rate = Number(ratePct) || 7.65;
  if (method === 'flat') return p * rate / 100;
  const ss = Math.min(6.2, rate);
  return Math.min(p, ssWageBase(year)) * ss / 100 + p * (rate - ss) / 100;
};
// The owner adjustment as an EXPENSE change: tax on the replacement minus tax on the owner's pay (+ = costs more).
// PER PERSON (Mark 10-23, Arakyta: "has 3 owners, is it calculating correctly"): the wage base caps each person, so
// the owner salary is split evenly over oc.ownerCount people, and the replacement over its roles (replacementRoles,
// each taxed on its own) or oc.replacementCount people. Arakyta: 3 owners ($505K) and 3 hires ($470K), everyone under
// the cap = full 7.65% on both sides.
// PER-YEAR OWNERS + REPLACEMENT (Colleen 10-26 🔴, Arakyta: "three owners currently, but in 2023 & 2024 only one owner
// ... we need to be able to make the market rate salary adjustment year specific ... or we are overstating the market
// rate salary expense and understating normalized EBITDA in those years"). Each period may carry its own owner count
// (oc[period].owners) and its own replacement cost (oc[period].market); blank = the overall rate and counts. A period
// with its own replacement replaces its own owners one for one (payroll tax per person on both sides).
const ocHasMarketFor = (oc, period) => !!(period && oc && oc[period] && oc[period].market !== undefined && oc[period].market !== null && oc[period].market !== '');
const ocMarketFor = (oc, period) => (ocHasMarketFor(oc, period) ? (Number(oc[period].market) || 0) : (Number(oc && oc.marketReplacement) || 0));
const ocOwnersFor = (oc, period) => { const v = period && oc && oc[period] && Number(oc[period].owners); return v ? Math.max(1, Math.round(v)) : Math.max(1, Math.round(Number(oc && oc.ownerCount) || 1)); };
const ownerPayrollTaxDiff = (oc, salary, market, year, method, period) => {
  if (!oc || oc.includePayrollTax === false) return 0;
  const rate = Number(oc.payrollTaxRate) || 7.65;
  const tax = (p) => employerPayrollTax(p, year, rate, method);
  const mk = Math.max(0, Number(market) || 0), sal = Math.max(0, Number(salary) || 0);
  const nOwn = ocOwnersFor(oc, period);
  const roles = Array.isArray(oc.replacementRoles) ? oc.replacementRoles.filter(r => r && Number(r.salary) > 0) : [];
  const rolesTotal = roles.reduce((s, r) => s + Number(r.salary), 0);
  const nRep = Math.max(1, Math.round(Number(oc.replacementCount) || 1));
  const repTax = ocHasMarketFor(oc, period) ? nOwn * tax(mk / nOwn)
    : roles.length && rolesTotal > 0 ? roles.reduce((s, r) => s + tax(mk * Number(r.salary) / rolesTotal), 0) : nRep * tax(mk / nRep);
  return repTax - nOwn * tax(sal / nOwn);
};
const payrollTaxDescribe = (oc, method) => method === 'flat'
  ? (Number(oc && oc.payrollTaxRate) || 7.65).toFixed(2) + '% employer taxes on salary adjustment'
  : 'Employer payroll tax difference (Social Security to the wage base + Medicare)';

// THEN vs NOW panel — owner view (headline numbers) + staff detail (what moved). Mark 10-05: review the
// prior EBITDA with the owner in the presentation; Zac: see what changed before it reaches the Lead.
const PriorVsNowPanel = ({ snapshots, current, fmt, onSave, canEdit, ownerView = false }) => {
  const list = [...(snapshots || [])].filter(s => !ownerView || SNAP_OWNER_KINDS.includes(s.kind)).sort((a, b) => String(b.at || '').localeCompare(String(a.at || '')));
  const [selId, setSelId] = React.useState(null);
  // Nothing the owner was given → no comparison on the owner screen at all.
  if (ownerView && !list.length) return null;
  const preferred = list.find(s => s.kind === 'presented') || list.find(s => s.kind === 'prior_valuation') || list[0];
  const then = list.find(s => s.id === selId) || preferred || null;
  const pct = (a, b) => (b && Math.abs(b) > 0.5) ? ((a - b) / Math.abs(b) * 100) : null;
  const money = (v) => (v === null || v === undefined || isNaN(v)) ? '—' : fmt(v);
  const margin = (s) => (s && s.revenue) ? (s.adjustedEbitda / s.revenue * 100) : null;
  const Row = ({ label, a, b, kind }) => {
    const d = (a !== null && a !== undefined && b !== null && b !== undefined) ? b - a : null;
    const p = kind === 'pct' ? null : pct(b, a);
    const show = (v) => kind === 'pct' ? (v === null ? '—' : v.toFixed(1) + '%') : kind === 'x' ? (v ? v.toFixed(2) + 'x' : '—') : money(v);
    const good = d === null ? null : d > 0;
    return (
      <tr className="border-t">
        <td className="py-1.5 pr-3 text-gray-700">{label}</td>
        <td className="py-1.5 px-3 text-right text-gray-600">{show(a)}</td>
        <td className="py-1.5 px-3 text-right font-semibold text-gray-800">{show(b)}</td>
        <td className={`py-1.5 pl-3 text-right text-xs font-semibold ${good === null ? 'text-gray-400' : good ? 'text-green-700' : 'text-red-600'}`}>
          {d === null ? '—' : kind === 'pct' ? `${d >= 0 ? '+' : ''}${d.toFixed(1)} pts` : kind === 'x' ? `${d >= 0 ? '+' : ''}${d.toFixed(2)}x` : `${d >= 0 ? '+' : '−'}${money(Math.abs(d))}${p !== null ? ` (${p >= 0 ? '+' : ''}${p.toFixed(0)}%)` : ''}`}
        </td>
      </tr>
    );
  };
  const movers = then && then.lines ? snapLineMovers(then.lines, current.lines).slice(0, 10) : [];
  const adjCh = then && then.adj ? snapAdjChanges(then.adj, current.adj).slice(0, 12) : [];
  return (
    <div className="mb-4 p-3 bg-white border border-indigo-200 rounded-lg">
      <div className="flex items-center gap-2 flex-wrap mb-2">
        <h3 className="font-semibold text-gray-800">📊 Then vs now</h3>
        {list.length > 0 && (
          <select value={then ? then.id : ''} onChange={e => setSelId(e.target.value)} className="text-xs border rounded px-2 py-1 bg-white">
            {list.map(s => <option key={s.id} value={s.id}>{(SNAP_KIND_LABEL[s.kind] || s.kind)} · {s.label || ''} · {s.at ? new Date(s.at).toLocaleDateString() : ''}</option>)}
          </select>
        )}
        {canEdit && onSave && <button type="button" onClick={onSave} className="ml-auto text-xs px-2 py-1 rounded border border-indigo-300 text-indigo-700 hover:bg-indigo-50" title="Save today's numbers as a fixed point to compare against later.">📌 Save snapshot</button>}
      </div>
      {!then ? (
        <p className="text-xs text-gray-500">No saved snapshot yet. VT saves one when a valuation is presented, at each hand-off, and when you click 📌 Save snapshot.</p>
      ) : (
        <>
          <table className="w-full text-sm">
            <thead><tr className="text-xs text-gray-500"><th className="text-left font-medium pb-1"></th><th className="text-right font-medium px-3 pb-1">Then · {then.at ? new Date(then.at).toLocaleDateString() : ''}</th><th className="text-right font-medium px-3 pb-1">Now</th><th className="text-right font-medium pl-3 pb-1">Change</th></tr></thead>
            <tbody>
              <Row label="TTM revenue" a={then.revenue} b={current.revenue} />
              <Row label="Adjusted EBITDA (TTM)" a={then.adjustedEbitda} b={current.adjustedEbitda} />
              <Row label="Adjusted EBITDA margin" a={margin(then)} b={margin(current)} kind="pct" />
              {(then.multiple || current.multiple) ? <Row label="Multiple" a={then.multiple} b={current.multiple} kind="x" /> : null}
              {(then.valueHigh || current.valueHigh) ? (
                <tr className="border-t">
                  <td className="py-1.5 pr-3 text-gray-700">Value range</td>
                  <td className="py-1.5 px-3 text-right text-gray-600">{then.valueHigh ? `${money(then.valueLow)} – ${money(then.valueHigh)}` : '—'}</td>
                  <td className="py-1.5 px-3 text-right font-semibold text-gray-800">{`${money(current.valueLow)} – ${money(current.valueHigh)}`}</td>
                  <td className="py-1.5 pl-3 text-right text-xs text-gray-500">{then.valueHigh ? (() => { const p = pct(current.valueHigh, then.valueHigh); return p === null ? '—' : `${p >= 0 ? '+' : ''}${p.toFixed(0)}%`; })() : '—'}</td>
                </tr>
              ) : null}
              <tr className="border-t text-xs text-gray-500"><td className="py-1 pr-3">TTM period</td><td className="py-1 px-3 text-right">{then.ttmLabel || '—'}</td><td className="py-1 px-3 text-right">{current.ttmLabel || '—'}</td><td></td></tr>
            </tbody>
          </table>
          {list.length > 1 && (
            <details className="mt-2">
              <summary className="text-xs font-semibold text-indigo-700 cursor-pointer">History — every saved point ({list.length})</summary>
              <table className="w-full text-xs mt-1">
                <thead><tr className="text-gray-500"><th className="text-left font-medium">Date</th><th className="text-left font-medium">Point</th><th className="text-left font-medium">TTM period</th><th className="text-right font-medium">Revenue</th><th className="text-right font-medium">Adj. EBITDA</th><th className="text-right font-medium">Margin</th></tr></thead>
                <tbody>{[...list].reverse().map(s => (
                  <tr key={s.id} className="border-t">
                    <td className="py-0.5 pr-2 text-gray-600">{s.at ? new Date(s.at).toLocaleDateString() : ''}</td>
                    <td className="py-0.5 pr-2">{SNAP_KIND_LABEL[s.kind] || s.kind}{s.label ? <span className="text-gray-400"> · {s.label}</span> : null}</td>
                    <td className="py-0.5 pr-2 text-gray-600">{s.ttmLabel || '—'}</td>
                    <td className="py-0.5 text-right">{money(s.revenue)}</td>
                    <td className="py-0.5 text-right font-semibold">{money(s.adjustedEbitda)}</td>
                    <td className="py-0.5 text-right">{margin(s) === null ? '—' : margin(s).toFixed(1) + '%'}</td>
                  </tr>
                ))}
                  <tr className="border-t bg-indigo-50"><td className="py-0.5 pr-2 font-semibold">Now</td><td></td><td className="py-0.5 pr-2 text-gray-600">{current.ttmLabel || '—'}</td><td className="py-0.5 text-right">{money(current.revenue)}</td><td className="py-0.5 text-right font-semibold">{money(current.adjustedEbitda)}</td><td className="py-0.5 text-right">{margin(current) === null ? '—' : margin(current).toFixed(1) + '%'}</td></tr>
                </tbody>
              </table>
            </details>
          )}
          {(movers.length > 0 || adjCh.length > 0) && (
            <details className="mt-2">
              <summary className="text-xs font-semibold text-indigo-700 cursor-pointer">Staff: what moved ({movers.length} line{movers.length === 1 ? '' : 's'}{adjCh.length ? `, ${adjCh.length} adjustment change${adjCh.length === 1 ? '' : 's'}` : ''})</summary>
              {movers.length > 0 && (
                <table className="w-full text-xs mt-1">
                  <thead><tr className="text-gray-500"><th className="text-left font-medium">Line</th><th className="text-right font-medium">Then TTM</th><th className="text-right font-medium">Now TTM</th><th className="text-right font-medium">EBITDA effect</th></tr></thead>
                  <tbody>{movers.map((m, i) => (
                    <tr key={i} className="border-t">
                      <td className="py-0.5 pr-2">{m.name}{m.aThen !== m.aNow ? <span className="ml-1 text-amber-700">(add-back {m.aThen === null ? '—' : m.aThen + '%'} → {m.aNow === null ? '—' : m.aNow + '%'})</span> : (m.aNow ? <span className="ml-1 text-gray-400">({m.aNow}% add-back)</span> : null)}</td>
                      <td className="py-0.5 text-right text-gray-600">{money(m.then)}</td>
                      <td className="py-0.5 text-right">{money(m.now)}</td>
                      <td className={`py-0.5 text-right font-semibold ${m.effect >= 0 ? 'text-green-700' : 'text-red-600'}`}>{m.effect >= 0 ? '+' : '−'}{money(Math.abs(m.effect))}</td>
                    </tr>
                  ))}</tbody>
                </table>
              )}
              {adjCh.length > 0 && (
                <ul className="mt-1 text-xs space-y-0.5">{adjCh.map((c, i) => (
                  <li key={i}><span className={c.kind === 'removed' ? 'text-red-600' : c.kind === 'added' ? 'text-green-700' : 'text-amber-700'}>{c.kind === 'added' ? '＋ added' : c.kind === 'removed' ? '− removed' : '≠ changed'}</span> {c.a.d || 'Adjustment'} · {c.a.l} · {c.a.y} · {money(c.a.amt)}{c.kind === 'changed' ? ` (was ${money(c.was)})` : ''}</li>
                ))}</ul>
              )}
            </details>
          )}
        </>
      )}
    </div>
  );
};
const preassignDuplicateChildren = (rows, existing, norm) => {
  const out = new Map();
  const groups = {};
  rows.forEach((r, i) => {
    if (!r || !r.name || !r.name.includes(' > ')) return;
    const parts = r.name.split(' > ');
    const child = norm(parts.pop().trim()); const parent = norm(parts.join(' > ').trim());
    if (!child) return;
    (groups[child] = groups[child] || []).push({ i, parent });
  });
  const taken = new Set();
  Object.entries(groups).forEach(([child, list]) => {
    if (list.length < 2) return;   // unique children are the existing cross-format pass's job
    list.forEach(r => {
      const j = existing.findIndex((e, k) => !taken.has(k) && e && e.name && (() => {
        const en = norm(e.name);
        return en.includes(child) && en.replace(child, '') === r.parent;
      })());
      if (j !== -1) { out.set(r.i, j); taken.add(j); }
    });
    const left = list.filter(r => !out.has(r.i));
    const plain = existing.map((e, k) => k).filter(k => !taken.has(k) && existing[k] && norm(existing[k].name || '') === child);
    if (left.length === 1 && plain.length === 1) { out.set(left[0].i, plain[0]); taken.add(plain[0]); }
  });
  return out;
};
// SUBTOTAL BY ARITHMETIC (Konnie 10-06, Aeroform): statements that aren't QB exports label their
// subtotals "Net Revenue", "Net Labor", "Net Variable OH" — no "Total" in the name, so they were imported
// as accounts and doubled the section. A row whose values equal the sum of the 2+ lines above it (since
// the last header) in EVERY period is a subtotal. Works on monthly arrays and annual { yearKey: v } maps.
const plValKeys = (v) => (Array.isArray(v) ? v.map((_, i) => i) : Object.keys(v || {}));
// minPeriods 1 = a one-year statement (Aeroform AFA 10-12), allowed only for a "Net …"/"Total …" name.
const equalsGroupSum = (vals, group, minPeriods = 2) => {
  if (!group || group.length < 2) return false;
  const keys = plValKeys(vals);
  if (keys.filter(k => Math.abs(Number(vals[k]) || 0) > 0.005).length < minPeriods) return false;
  return keys.every(k => Math.abs((Number(vals[k]) || 0) - group.reduce((a, g) => a + (Number(g[k]) || 0), 0)) < 1.01);
};
// A NAMED SUBTOTAL ACROSS A BLANK LINE (Konnie 10-12, Aeroform annual): "Labor: / Indirect Labor / Payroll Taxes /
// Contract Labor (blank) / Total labor / COGS Labor / Net Labor" — the value-less "Contract Labor" restarted the
// line group, so "Net Labor" ($811,927 = the three labor lines) no longer equalled "the lines above" and was
// imported as an account: COGS double-counted labor and Income (Loss) came out $811,927 low. A "Net …" /
// "Total …" line is also a subtotal when it equals the sum of the last 2+ lines of its section.
const equalsSectionTail = (vals, lines, minPeriods = 2) => {
  if (!Array.isArray(lines) || lines.length < 2) return false;
  const keys = plValKeys(vals);
  if (keys.filter(k => Math.abs(Number(vals[k]) || 0) > 0.005).length < minPeriods) return false;
  const acc = {};
  for (let i = lines.length - 1; i >= 0; i--) {
    keys.forEach(k => { acc[k] = (acc[k] || 0) + (Number(lines[i][k]) || 0); });
    if (lines.length - i >= 2 && keys.every(k => Math.abs((Number(vals[k]) || 0) - acc[k]) < 1.01)) return true;
  }
  return false;
};
// PERCENT ROWS + "NET REVENUE" ENDS REVENUE (Colleen 10-10, Aeroform annual AFA statements). The export
// prints a "Net Revenue (%)" / "Net Labor (%)" ratio line (100, 24, 14) under each subtotal — a ratio,
// never an amount, so it is skipped. And there is no "Cost of Sales" heading: "Purchase (New)" and
// "Material" follow "Net Revenue" directly, so they imported as REVENUE (2023 revenue $7.1M vs $3.2M).
// A "Net Revenue" / "Net Sales" line equal to the sum of every revenue line above it is the section's
// grand total — the lines after it are costs. Name AND arithmetic must both hold, so a nested
// sub-group total can't end Revenue early (the Canitan lesson).
const isPlPercentRow = (name) => /\(\s*%\s*\)\s*$|(^|\s)%\s*$|^%\s|%\s+of\s+(net\s+)?(sales|revenues?|income)\b/i.test((name || '').trim());
const endsRevenueSection = (name, vals, revenueRows, valKey) => {
  if (!/^net\s+(revenues?|sales)\s*$/i.test((name || '').trim())) return false;
  if (!revenueRows || revenueRows.length < 2) return false;
  const keys = plValKeys(vals);
  if (!keys.some(k => Math.abs(Number(vals[k]) || 0) > 0.005)) return false;
  return keys.every(k => Math.abs((Number(vals[k]) || 0) - revenueRows.reduce((a, r) => a + (Number((r[valKey] || {})[k]) || 0), 0)) < 1.01);
};
// RE-PASTE KEEPS A LINE'S IDENTITY (Mark 10-12, Blue Spruce): Clear & Replace rebuilt every P&L line with a
// new id — the owner's Revenue Classification answers (keyed by line id) orphaned and every revenue type and
// Verified mark was lost (all 4 lines untyped; "accept" found 0 of 4). A new line whose name matches a line
// from before the paste takes over that line's id and its classification; only the numbers are new.
const plLineKey = (n) => String(n || '').split(' > ').pop().trim().toLowerCase();
const inheritLineIdentity = (newRow, prior, used) => {
  if (!Array.isArray(prior) || !prior.length) return newRow;
  const full = String(newRow.name || '').trim().toLowerCase();
  const hit = prior.find(p => p && !used.has(p.id) && String(p.name || '').trim().toLowerCase() === full)
    || prior.find(p => p && !used.has(p.id) && plLineKey(p.name) === plLineKey(newRow.name));
  if (!hit) return newRow;
  used.add(hit.id);
  const { cash, accrual, tax, name, id, ...meta } = hit;   // classification travels; the numbers don't
  return { ...meta, ...newRow, id: hit.id };
};
// BELOW THE BOTTOM LINE (Mark 10-12, tie-out regression): a "Net Income" row in the expense / other
// sections is the statement's bottom line. Rows after it are someone's EBITDA build-up (Interest,
// Depreciation, Amortization re-listed) — they were imported as a second set of expenses.
const PL_BOTTOM_LINE_RX = /^net\s*(income|profit|earnings)(\s*[\/(]\s*\(?\s*loss\s*\)?\)?)?\s*$|^net\s+loss\s*$/i;
// NESTED "INCOME" GROUP (Konnie 11-02, Epic Electric): QB can nest an "Income" group inside the
// "Income" section — its "Total Income" sits one level deeper than the real one. Reading it as the
// end of revenue sent the accounts between the two totals (Income Tax Refunds, $81k) into COGS.
// Each value-less "Income"/"Revenue" header is pushed with its indent; a "Total Income" closes the
// latest one, and it only ends the section when no shallower header is still open. Flat pastes
// (every row at indent 0) never count as nested, so they behave as before.
const PL_INCOME_HEADER_RX = /^\s*(income|revenues?)\s*$/i;
const closesNestedIncome = (openIndents, indent) => {
  openIndents.pop();
  return openIndents.some(d => d < indent);
};

// CLIENT TYPE WORDS (Konnie 11-02, HPT Consulting): the owner types words ("Municipality", "Non Profit",
// "Church", "Govenment") but the grid's Type dropdown only speaks B2B / Residential / Government /
// Non-Profit — an unmatched word was saved yet showed as "—", so the accept looked like it did nothing.
// Anything still unmatched passes through and the dropdown shows it in amber (CLIENT_TYPES).
const CLIENT_TYPES = ['B2B', 'Residential', 'Government', 'Non-Profit'];
const normalizeOwnerClientType = (raw) => {
  const s = String(raw == null ? '' : raw).trim();
  const w = ' ' + s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  if (/^ (business(es)?|b2b|commercial|company|corporate|corp|enterprise) $/.test(w)) return 'B2B';
  if (/^ (residential|consumer|b2c|home|personal|individual) $/.test(w)) return 'Residential';
  if (/ (non ?profit|not for profit|charity|church|congregation|ministry|501 ?c ?3?) /.test(w)) return 'Non-Profit';
  if (/ (gov|govt|government|govenment|goverment|municipal|municipality|township|borough|county|city|state|federal|police|public sector) /.test(w)) return 'Government';
  return s;
};
// REROUTE vs THE STATEMENT (Mark 10-12, tie-out regression): the name-based move between Other Income
// and Other Expense (Hawver 09-22) must not overrule the statement's own section totals — "Candyco
// Reimbursement for Svc" sat under Other Expense, "Gain or Loss On Sale of Asset" under Other Income.
// When the report prints Total Other Income / Total Other Expense(s), a moved line goes back to where
// the report had it whenever that brings those totals closer.
const undoReroutesAgainstStatement = (parsed, skipped, valKey) => {
  const tot = { otherIncome: null, otherExpense: null };
  (skipped || []).forEach(s => {
    if (!s || s.values == null) return;
    const n = String(s.name || '').trim();
    if (/^total\s*(for\s*)?other\s+incomes?\s*$/i.test(n)) tot.otherIncome = s.values;
    else if (/^total\s*(for\s*)?other\s+expenses?\s*$/i.test(n)) tot.otherExpense = s.values;
  });
  if (!tot.otherIncome && !tot.otherExpense) return;
  const keys = plValKeys(tot.otherIncome || tot.otherExpense);
  const miss = () => ['otherIncome', 'otherExpense'].reduce((m, sec) => (!tot[sec] ? m
    : m + keys.reduce((a, k) => a + Math.abs((Number(tot[sec][k]) || 0) - (parsed[sec] || []).reduce((x, r) => x + (Number((r[valKey] || {})[k]) || 0), 0)), 0)), 0);
  ['otherIncome', 'otherExpense'].forEach(sec => {
    (parsed[sec] || []).filter(r => r._rerouteFrom).forEach(r => {
      const before = miss();
      const from = r._rerouteFrom.section;
      const back = { ...r, [valKey]: r._rerouteFrom.values };
      delete back._rerouteFrom;
      parsed[sec] = parsed[sec].filter(x => x !== r);
      parsed[from] = [...(parsed[from] || []), back];
      if (miss() + 0.5 >= before) {   // no closer: keep the move
        parsed[from] = parsed[from].filter(x => x !== back);
        parsed[sec] = [...parsed[sec], r];
      }
    });
  });
};
// COMBINED "Other Income/(Expense)" SIGNS (Konnie 10-06, Aeroform's "B12 Management Fee" $100K is an
// expense with no "expense" in its name, so it landed in Other Income). The report's own total for the
// block is authoritative: find the sign for each item (fewest changes from the name-based guess) that
// makes the items add up to that total in every period, and keep EVERY line (management fees and bonuses
// are add-back candidates — never collapse them into one net line when the arithmetic can be solved).
// Returns true when the items already fit or were re-signed; false when no combination fits.
const resolveCombinedOtherSigns = (parsed, totalVals, valKey) => {
  const items = [
    ...parsed.otherIncome.filter(r => r._fromCombinedSection).map(r => ({ r, sign: 1 })),
    ...parsed.otherExpense.filter(r => r._fromCombinedSection).map(r => ({ r, sign: -1 })),
  ];
  if (!items.length || items.length > 12) return false;
  const keys = plValKeys(totalVals);
  const cur = items.map(({ r, sign }) => keys.map(k => sign * (Number((r[valKey] || {})[k]) || 0)));
  const fits = (rows) => keys.every((k, ki) => Math.abs(rows.reduce((a, row) => a + row[ki], 0) - (Number(totalVals[k]) || 0)) < 1.01);
  if (fits(cur)) return true;
  let best = -1, bestFlips = 99;
  for (let mask = 1; mask < (1 << items.length); mask++) {
    let flips = 0; for (let m = mask; m; m >>= 1) flips += m & 1;
    if (flips >= bestFlips) continue;
    if (fits(cur.map((row, i) => ((mask >> i) & 1 ? row.map(x => -x) : row)))) { best = mask; bestFlips = flips; }
  }
  if (best < 0) return false;
  parsed.otherIncome = parsed.otherIncome.filter(r => !r._fromCombinedSection);
  parsed.otherExpense = parsed.otherExpense.filter(r => !r._fromCombinedSection);
  items.forEach(({ r }, i) => {
    const contrib = (best >> i) & 1 ? cur[i].map(x => -x) : cur[i];
    const toIncome = contrib.reduce((a, b) => a + b, 0) >= 0;
    const stored = contrib.map(x => (toIncome ? x : -x));
    const values = Array.isArray(r[valKey]) ? stored : Object.fromEntries(keys.map((k, ki) => [k, stored[ki]]));
    parsed[toIncome ? 'otherIncome' : 'otherExpense'].push({ ...r, [valKey]: values, _signResolved: true });
  });
  return true;
};
const otherSectionReroute = (section, name, values) => {
  const n = String(name || '').split(' > ').pop();   // judge the leaf, not a QB sub-group prefix
  let target = section;
  if (section === 'otherIncome' && OTHER_EXPENSE_NAME_RX.test(n) && !OTHER_INCOME_NAME_RX.test(n)) target = 'otherExpense';
  else if (section === 'otherExpense' && OTHER_INCOME_NAME_RX.test(n) && !OTHER_EXPENSE_NAME_RX.test(n)) target = 'otherIncome';
  if (target === section) return { section, values };
  const nums = Array.isArray(values) ? values : Object.values(values || {});
  const nonZero = nums.filter(x => typeof x === 'number' && x !== 0);
  const allNeg = nonZero.length > 0 && nonZero.every(x => x < 0);
  const flip = (x) => (typeof x === 'number' ? -x : x);
  const out = !allNeg ? values : (Array.isArray(values) ? values.map(flip) : Object.fromEntries(Object.entries(values || {}).map(([k, v]) => [k, flip(v)])));
  return { section: target, values: out };
};

// Statement totals captured by one paste, keyed by period label ("2023", "TTM", "interim",
// "ttmbs:Aug 2026"). Every pasted period gets an entry — an empty one drops a stale total.
const stmtPick = (skipped, keys, pick) => {
  const t = stmtTotalsFrom(skipped, keys);
  const e = {};
  Object.entries(t).forEach(([f, vals]) => { const x = Number(pick(vals)); if (Math.abs(x) > 0.004) e[f] = x; });
  return e;
};
const PL_STMT_KEYS = ['revenue', 'grossProfit', 'netIncome'];
const BS_STMT_KEYS = ['assets', 'liabilities', 'equity', 'liabEquity'];
const stmtPeriodLabel = (slot, info, labels) => (slot === 'ttm' ? 'TTM' : slot === 'interim' ? 'interim'
  : (/^\d{4}$/.test(String(info?.detected || '')) ? String(info.detected) : String(labels?.[slot] || slot)));
const plStmtByLabel = (preview, labels) => {
  const out = {};
  [...new Set(Object.values(preview?.yearColumns || {}))].filter(Boolean).forEach(slot => {
    const info = (preview.yearMatchInfo || []).find(i => i.mappedTo === slot);
    out[stmtPeriodLabel(slot, info, labels)] = stmtPick(preview.skipped, PL_STMT_KEYS, v => v?.[slot]);
  });
  return out;
};
const bsStmtByLabel = (preview, labels) => {
  const out = {};
  [...new Set(Object.values(preview?.yearColumns || {}))].filter(Boolean).forEach(slot => {
    const info = (preview.yearMatchInfo || []).find(i => i.mappedTo === slot);
    out[stmtPeriodLabel(slot, info, labels)] = stmtPick(preview.skipped, BS_STMT_KEYS, v => v?.[slot]);
  });
  return out;
};

// ── TIES TO THE SOURCE (Mark 10-12) ─────────────────────────────────────────────────────────────
// "By the time it gets to Colleen, everything should be entered correctly." Every paste keeps the
// statement's OWN totals (Total Income / Gross Profit / Net Income, Total Assets / Liabilities /
// Equity) in data.sourceTotals, keyed by period label. ✓ Data entered opens one check: a total the
// paste captured compares automatically (✓, or red when it doesn't match); every other number gets
// a tick box Konnie checks against the statement — one box per number, no "check all". Red = fix the
// entry or re-request the report; the override takes a written reason and lands on Mark's radar.
// Rounding: within $5, or half a dollar per line entered when that's more (whole-dollar exports).
const TIE_TOL = 5;
const STMT_TOTAL_RX = {
  revenue: /^(total\s*(for\s*)?(income|revenues?|sales)|total\s+net\s+(revenues?|sales)|net\s+(revenues?|sales)|(income|revenues?)\s*-?\s*total)\s*$/i,
  grossProfit: /^gross\s*(profit|margin)(\s*[\/(]\s*\(?\s*loss\s*\)?\)?)?\s*$/i,
  netIncome: /^(net\s*(income|profit|earnings)(\s*[\/(]\s*\(?\s*loss\s*\)?\)?)?|net\s+loss|income\s*\(\s*loss\s*\)|profit\s*(\/|&|and)\s*loss)\s*$/i,
  assets: /^total\s+assets\s*$/i,
  liabilities: /^total\s+liabilities\s*$/i,
  equity: /^total\s+(equity|capital|net\s+worth|(stockholders|shareholders|owners|members|partners)['’]?\s*(equity|capital|deficit))\s*$/i,
  liabEquity: /^total\s+liabilities\s*(&|and)\s*(equity|capital|net\s+worth|(stockholders|shareholders|owners|members|partners)['’]?\s*(equity|capital|deficit))\s*$/i,
};
// The statement's own total rows out of a parser's skipped list (each skipped subtotal carries its
// values). The last match wins — the grand total / bottom line comes after any nested one.
const stmtTotalsFrom = (skipped, keys) => {
  const out = {};
  (skipped || []).forEach(s => {
    if (!s || s.values == null) return;
    const nm = String(s.name || '').replace(/^\d{3,6}(?:\.\d+)?\s*[·•.:\-–—]\s*/, '').replace(/:\s*$/, '').trim();
    for (const k of keys) {
      if (STMT_TOTAL_RX[k].test(nm)) { out[k] = s.values; break; }
    }
  });
  return out;
};
const tieMoney = (n) => (n == null ? '' : (n < 0 ? '−$' : '$') + Math.abs(Math.round(Number(n) || 0)).toLocaleString());
// The check itself, from a saved data blob (the My Work card) or buildDealData() (the editor).
const computeTieOut = (d) => {
  d = d || {};
  const st = d.sourceTotals || {};
  const sum = (rows, b, k) => (Array.isArray(rows) ? rows : []).reduce((a, r) => a + (Number(b ? r?.[b]?.[k] : r?.[k]) || 0), 0);
  const cnt = (rows, b, k) => (Array.isArray(rows) ? rows : []).filter(r => Math.abs(Number(b ? r?.[b]?.[k] : r?.[k]) || 0) > 0.004).length;
  const tolFor = (lines) => Math.max(TIE_TOL, 0.5 * lines);
  const sections = [], flags = [], badList = [];
  const cell = (id, tool, stmt, what, tol) => {
    const status = stmt == null ? 'tick' : (Math.abs((Number(tool) || 0) - (Number(stmt) || 0)) <= tol ? 'ok' : 'bad');
    if (status === 'bad') badList.push(what + ': entered ' + tieMoney(tool) + ', statement ' + tieMoney(stmt));
    return { id, tool, stmt, status };
  };
  // P&L — every basis with revenue entered.
  const yl = d.basisYearLabels || {};
  const PL = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
  ['accrual', 'cash'].forEach(b => {
    const per = PL.filter(k => Math.abs(sum(d.revenueCategories, b, k)) > 0.5);
    if (!per.length) return;
    const lbl = (k) => (k === 'ttm' ? 'TTM' : String(yl[k] || k));
    const diat = (k) => ['depreciation', 'interest', 'amortization', 'taxes'].reduce((a, x) => a + (Number(d.diatCategories?.[x]?.[b]?.[k]) || 0), 0);
    const v = {};
    per.forEach(k => {
      const rev = sum(d.revenueCategories, b, k), cogs = sum(d.cogsCategories, b, k), opex = sum(d.opexCategories, b, k);
      const oi = sum(d.otherIncomeCategories, b, k), oe = sum(d.otherExpenseCategories, b, k);
      v[k] = { revenue: rev, grossProfit: rev - cogs, netIncome: rev - cogs - opex - diat(k) + oi - oe };
    });
    const src = st.pl?.[b] || {};
    const title = 'P&L (' + b + ')';
    sections.push({ title, periods: per.map(lbl), rows: [['revenue', 'Revenue'], ['grossProfit', 'Gross profit'], ['netIncome', 'Net income']].map(([f, label]) => ({
      label, cells: per.map(k => cell('pl:' + b + ':' + lbl(k) + ':' + f, v[k][f], src[lbl(k)]?.[f], title + ' ' + lbl(k) + ' ' + label,
        tolFor(['revenueCategories', 'cogsCategories', 'opexCategories', 'otherIncomeCategories', 'otherExpenseCategories'].reduce((n, c) => n + cnt(d[c], b, k), 0)))),
    })) });
    // A year pasted into two columns (Aeroform 10-12: the position fallback wrote 2023 into 2024 too).
    // TTM is left out: a TTM ending in December IS the calendar year.
    const yrs = per.filter(k => k !== 'ttm');
    for (let i = 0; i < yrs.length; i++) for (let j = i + 1; j < yrs.length; j++) {
      const a = v[yrs[i]], c = v[yrs[j]];
      if (Math.abs(a.revenue - c.revenue) < 0.01 && Math.abs(a.netIncome - c.netIncome) < 0.01 && Math.abs(a.grossProfit - c.grossProfit) < 0.01) {
        flags.push(title + ': ' + lbl(yrs[j]) + ' has exactly the same numbers as ' + lbl(yrs[i]) + ' — one year pasted into two columns?');
      }
    }
  });
  // Balance sheet — the annual years + the interim.
  const bl = d.bsYearLabels || {};
  const A = (k) => sum(d.bsCurrentAssets, null, k) + sum(d.bsFixedAssets, null, k) + sum(d.bsOtherAssets, null, k);
  const L = (k) => sum(d.bsCurrentLiabilities, null, k) + sum(d.bsLongTermLiabilities, null, k);
  const E = (k) => sum(d.bsEquity, null, k);
  const bsLines = (k) => ['bsCurrentAssets', 'bsFixedAssets', 'bsOtherAssets', 'bsCurrentLiabilities', 'bsLongTermLiabilities', 'bsEquity'].reduce((n, c) => n + cnt(d[c], null, k), 0);
  const bper = ['year1', 'year2', 'year3', 'interim'].filter(k => Math.abs(A(k)) > 0.5 || Math.abs(L(k)) + Math.abs(E(k)) > 0.5);
  if (bper.length) {
    const blbl = (k) => (k === 'interim' ? String(bl.interim || 'Interim') : String(bl[k] || k));
    const stFor = (k) => {
      if (k !== 'interim') return st.bs?.[blbl(k)] || {};
      const a = st.bs?.interim, t = st.bs?.['ttmbs:' + (bl.interim || '')];
      if (a && t) return String(a.at || '') >= String(t.at || '') ? a : t;
      return a || t || {};
    };
    const title = 'Balance sheet';
    sections.push({ title, periods: bper.map(blbl), rows: [['assets', 'Total assets', A], ['liabilities', 'Total liabilities', L], ['equity', 'Total equity', E]].map(([f, label, fn]) => ({
      label, cells: bper.map(k => {
        const s = stFor(k);
        let sv = s[f];
        if (sv == null && f === 'equity' && s.liabEquity != null && s.liabilities != null) sv = s.liabEquity - s.liabilities;
        if (sv == null && f === 'liabilities' && s.liabEquity != null && s.equity != null) sv = s.liabEquity - s.equity;
        return cell('bs:' + blbl(k) + ':' + f, fn(k), sv, title + ' ' + blbl(k) + ' ' + label, tolFor(bsLines(k)));
      }),
    })) });
    bper.forEach(k => {
      const diff = A(k) - L(k) - E(k);
      if (Math.abs(diff) > tolFor(bsLines(k))) flags.push('Balance sheet ' + blbl(k) + " doesn't balance: "
        + (diff > 0 ? 'assets are ' + tieMoney(diff) + ' more than liabilities + equity.' : 'liabilities + equity are ' + tieMoney(-diff) + ' more than assets.'));
    });
  }
  const ticks = [];
  sections.forEach(s => s.rows.forEach(r => r.cells.forEach(c => { if (c.status === 'tick') ticks.push(c.id); })));
  // Documents (Mark 10-12): every document this deal needs — the curated (planned) list when there is one,
  // else the whole checklist — is in, or carries its reason. Complete passes; "Not provided (yet)" with its
  // note, or Partial with what's still needed, passes in amber (Colleen sees why); anything else blocks.
  // E2E (no balance sheets) and Integrated (no tax returns) were deliberate calls nobody could explain later.
  const docList = Array.isArray(d.documentChecklist) ? d.documentChecklist : [];
  const docsNeeded = docList.some(x => x && x.planned) ? docList.filter(x => x && x.planned) : docList.filter(Boolean);
  const docsMissing = [], docsExplained = [];
  docsNeeded.forEach(x => {
    if (x.status === 'complete') return;
    const note = String(x.pendingNotes || '').trim();
    if ((x.status === 'not_provided' || x.status === 'partial') && note) docsExplained.push({ id: x.id, name: x.name, status: x.status, note });
    else docsMissing.push({ id: x.id, name: x.name, status: x.status || 'not_received' });
  });
  return { sections, flags, badList, bad: badList.length + flags.length, ticks, docsMissing, docsExplained };
};
const tieOutNote = (who, res) => '✓ Data entered — handed to ' + who + (res && res.override ? ' ⚠ WITHOUT matching the statements: ' + res.override : ' (ties to the statements)');
const tieOutMeta = (res) => (res ? { override: res.override || null, auto: res.auto, ticked: res.ticked.length, unticked: res.unticked.length, bad: res.bad.slice(0, 20), not_provided: (res.notProvided || []).slice(0, 20) } : null);
// ── END TIES TO THE SOURCE ──

// The ✓ Data entered check (one popup). Hand-off is enabled only when nothing is red and every tick
// box is ticked; otherwise the override needs a reason (Mark sees it on his radar).
const TieOutModal = ({ company, target, result, onCancel, onConfirm, onMarkNotProvided }) => {
  const [ticked, setTicked] = useState({});
  const [overriding, setOverriding] = useState(false);
  const [reason, setReason] = useState('');
  const [npNotes, setNpNotes] = useState({});
  const [npBusy, setNpBusy] = useState(null);
  const docsMissing = result.docsMissing || [], docsExplained = result.docsExplained || [];
  const left = result.ticks.filter(id => !ticked[id]).length;
  const ready = result.bad === 0 && left === 0 && docsMissing.length === 0;
  const done = (override) => onConfirm({
    override: override ? reason.trim() : null,
    ticked: result.ticks.filter(id => ticked[id]),
    auto: result.sections.reduce((n, s) => n + s.rows.reduce((m, r) => m + r.cells.filter(c => c.status === 'ok').length, 0), 0),
    bad: result.badList.concat(result.flags).concat(docsMissing.map(x => 'Document not received: ' + x.name)),
    unticked: result.ticks.filter(id => !ticked[id]),
    notProvided: docsExplained.map(x => x.name + ' — ' + x.note),
  });
  const markNp = async (doc) => {
    const note = String(npNotes[doc.id] || '').trim();
    if (note.length < 3 || !onMarkNotProvided) return;
    setNpBusy(doc.id);
    try { await onMarkNotProvided(doc, note); } finally { setNpBusy(null); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center overflow-y-auto p-4" onClick={onCancel}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl mt-6 p-5" onClick={e => e.stopPropagation()}>
        <h2 className="text-lg font-bold text-slate-800">✓ Ties to the source — {company}</h2>
        <p className="text-sm text-slate-600 mt-1">
          Before this goes to {target}, every number below must match the owner's statement.{' '}
          <span className="text-green-700 font-semibold">✓</span> = checked against the statement's own total.{' '}
          <span className="font-semibold">☐</span> = look at the statement and tick it.{' '}
          <span className="text-red-700 font-semibold">Red</span> = doesn't match: fix the entry, or re-request the report.
        </p>
        {result.sections.length === 0 && (
          <div className="mt-4 p-3 bg-slate-50 border rounded text-sm text-slate-600">No P&amp;L or balance sheet is entered on this deal yet.</div>
        )}
        {result.sections.map(sec => (
          <div key={sec.title} className="mt-4 overflow-x-auto">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-slate-100">
                  <th className="p-2 text-left">{sec.title}</th>
                  {sec.periods.map(p => <th key={p} className="p-2 text-right whitespace-nowrap">{p}</th>)}
                </tr>
              </thead>
              <tbody>
                {sec.rows.map(r => (
                  <tr key={r.label} className="border-t">
                    <td className="p-2 font-medium whitespace-nowrap">{r.label}</td>
                    {r.cells.map(c => (
                      <td key={c.id} className={`p-2 text-right align-top ${c.status === 'bad' ? 'bg-red-50' : ''}`}>
                        <div className="font-mono">{tieMoney(c.tool)}</div>
                        {c.status === 'ok' && <div className="text-xs text-green-700" title={'Statement total ' + tieMoney(c.stmt)}>✓ matches</div>}
                        {c.status === 'bad' && <div className="text-xs text-red-700 font-semibold">statement {tieMoney(c.stmt)}<br />off {tieMoney(c.tool - c.stmt)}</div>}
                        {c.status === 'tick' && (
                          <label className="text-xs text-slate-600 inline-flex items-center gap-1 cursor-pointer">
                            <input type="checkbox" checked={!!ticked[c.id]} onChange={e => { const on = e.target.checked; setTicked(t => ({ ...t, [c.id]: on })); }} /> matches
                          </label>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        {result.flags.length > 0 && (
          <div className="mt-3 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-800">
            {result.flags.map((f, i) => <div key={i}>🚩 {f}</div>)}
          </div>
        )}
        {(docsMissing.length > 0 || docsExplained.length > 0) && (
          <div className="mt-4">
            <div className="text-sm font-semibold text-slate-700">Documents</div>
            {docsMissing.map(doc => (
              <div key={doc.id} className="mt-1 p-2 bg-red-50 border border-red-200 rounded text-sm">
                <div className="text-red-800"><b>{doc.name}</b>: not received. Get it, or say why it's not here.</div>
                {onMarkNotProvided ? (
                  <div className="mt-1 flex gap-2">
                    <input type="text" value={npNotes[doc.id] || ''} onChange={e => { const v = e.target.value; setNpNotes(n => ({ ...n, [doc.id]: v })); }}
                      placeholder="Why it's not here / when expected (Colleen sees this)" className="flex-1 p-1 border rounded text-xs" />
                    <button type="button" disabled={npBusy === doc.id || String(npNotes[doc.id] || '').trim().length < 3} onClick={() => markNp(doc)}
                      className="px-2 py-1 rounded text-xs font-semibold bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-40">⏳ Not provided (yet)</button>
                  </div>
                ) : (
                  <div className="text-xs text-slate-600 mt-1">Open the deal → Documents → set it to "Not provided (yet)" with the reason.</div>
                )}
              </div>
            ))}
            {docsExplained.map(doc => (
              <div key={doc.id} className="mt-1 px-2 py-1 bg-orange-50 border border-orange-200 rounded text-xs text-orange-900">
                ⏳ <b>{doc.name}</b> {doc.status === 'partial' ? '(partial)' : 'not provided yet'}: {doc.note}
              </div>
            ))}
          </div>
        )}
        {!overriding ? (
          <div className="mt-4 flex flex-wrap items-center justify-end gap-3">
            {!ready && (
              <span className="text-xs text-slate-500 mr-auto">
                {result.bad > 0 ? 'Red numbers don’t match the statement. Fix them first.' : docsMissing.length > 0 ? `${docsMissing.length} document(s) need a reason.` : `${left} left to tick.`}
                {' '}<button type="button" className="underline text-slate-500 hover:text-slate-700" onClick={() => setOverriding(true)}>Can't make it tie? Override…</button>
              </span>
            )}
            <button type="button" className="px-3 py-1.5 rounded border text-sm" onClick={onCancel}>Cancel</button>
            <button type="button" disabled={!ready} onClick={() => done(false)}
              className="px-3 py-1.5 rounded text-sm font-semibold bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">✓ Hand to {target}</button>
          </div>
        ) : (
          <div className="mt-4 p-3 bg-amber-50 border border-amber-300 rounded">
            <div className="text-sm font-semibold text-amber-900">Hand off without matching. Mark sees this.</div>
            <textarea value={reason} onChange={e => setReason(e.target.value)} rows={2} autoFocus
              placeholder="Why can't it tie, and what happens next? e.g. the owner's 2024 P&L doesn't foot by $412; asked them for a corrected one."
              className="mt-2 w-full p-2 border rounded text-sm" />
            <div className="mt-2 flex justify-end gap-3">
              <button type="button" className="px-3 py-1.5 rounded border text-sm" onClick={() => setOverriding(false)}>Back</button>
              <button type="button" disabled={reason.trim().length < 10} onClick={() => done(true)}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-40">Hand off anyway</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const businessDaysBetween = (from, to) => {
  // Inclusive of `to`, exclusive of `from`. Returns int business days.
  if (!from) return null;
  const start = new Date(from);
  const end = to ? new Date(to) : new Date();
  start.setHours(0,0,0,0); end.setHours(0,0,0,0);
  let count = 0;
  const cur = new Date(start);
  while (cur < end) {
    cur.setDate(cur.getDate() + 1);
    const dow = cur.getDay();
    if (dow !== 0 && dow !== 6) count++;
  }
  return count;
};

// "What does this row need right now?" — a short imperative string for
// the My Work card and the Pipeline view. No actor prefix: the
// Responsibility column right beside it carries that, so the prefix
// would be redundant noise. Wording is contextual where actor differs
// from responsibility ("Ready for Colleen — adjustments / analysis").
// Replaces the paper notebook Konnie/Colleen keep — staff read the
// action instead of decoding stage + dates + docs counts.
// Hybrid 5-star deal priority (spec § FIRST-MILE CADENCE): the app SUGGESTS
// from what it knows; a manual priority_stars pick always wins. Stars order
// the follow-up queues — they never change who gets touched.
const suggestedStars = (p) => {
  let s = 3;
  if (p.owner_intent === 'selling_soon') s += 1;
  if (p.owner_intent === 'planning_ahead') s -= 1;
  if (p.owner_target_valuation_date) s += 1;
  if ((p.estimated_commission || 0) >= 40000) s += 1;
  return Math.max(1, Math.min(5, s));
};
const effectiveStars = (p) => p.priorityStars || suggestedStars(p);
// Solid amber = set by a human; pale amber = the app's suggestion. Clicking
// the currently-set star clears back to suggested.
const StarRating = ({ p, onSet }) => {
  const manual = !!p.priorityStars;
  const val = effectiveStars(p);
  return (
    <span className="inline-flex items-center" title={manual
      ? `Priority ${val}★ (set manually — click a star to change; click the same star to return to the suggestion)`
      : `Suggested ${val}★ from size/intent/dates — click to set manually`}>
      {[1, 2, 3, 4, 5].map(n => (
        <button key={n} type="button"
          onClick={() => onSet && onSet(p, (manual && p.priorityStars === n) ? null : n)}
          className={`text-sm leading-none px-0.5 ${n <= val ? (manual ? 'text-amber-500' : 'text-amber-300') : 'text-gray-300'} hover:text-amber-600`}>
          {n <= val ? '★' : '☆'}
        </button>
      ))}
    </span>
  );
};

const computeNextAction = (p) => {
  if (!p) return '—';
  const fmt = (s) => s ? new Date(s + 'T00:00:00').toLocaleDateString() : null;
  if (p.isSnoozed) {
    const until = p.snooze_until ? new Date(p.snooze_until).toLocaleDateString() : '';
    return `Snoozed${until ? ' until ' + until : ''}${p.snooze_reason ? ' — ' + p.snooze_reason : ''}`;
  }
  const isPartialSkip = p.path === 'partial' && p.colleen_review_decision === 'skip';
  // Owner's target valuation date, surfaced on the ANALYSIS-phase plates
  // (Mark 2026-08-03: Colleen had no heads-up that a date existed once the
  // deal became hers). Turns red inside 5 days.
  const targetChip = (() => {
    if (!p.owner_target_valuation_date || p.valuation_date) return '';
    if (!['upload_complete', 'data_entry_complete', 'adjustments_entered', 'analysis_complete'].includes(p.workflow_stage)) return '';
    const days = Math.ceil((new Date(p.owner_target_valuation_date + 'T00:00:00') - new Date(new Date().toISOString().slice(0, 10) + 'T00:00:00')) / 86400000);
    return ` · 🎯 owner wants value by ${fmt(p.owner_target_valuation_date)}${days <= 5 ? ` — ${days < 0 ? 'PAST' : days + 'd left'}` : ''}`;
  })();
  const withTarget = (s) => s + targetChip;
  switch (p.workflow_stage) {
    case 'warm': {
      // Pre-meeting onboarding. The intro meeting date lives in
      // discovery_meeting_date (the intro = discovery meeting). Before it,
      // the AM has sent the link and we're awaiting the meeting; after it,
      // the Lead activates (Warm → Active) or passes.
      const md = p.discovery_meeting_date ? new Date(p.discovery_meeting_date + 'T00:00:00') : null;
      const today0 = new Date(); today0.setHours(0, 0, 0, 0);
      if (md && md >= today0) return `Intro meeting ${fmt(p.discovery_meeting_date)} — activate after`;
      if (md && md < today0) return `Meeting was ${fmt(p.discovery_meeting_date)} — activate or pass`;
      return 'Send intro + portal link; awaiting the meeting';
    }
    case 'awaiting_upload':
      if (p.daysPastCommitted != null && p.daysPastCommitted > 0) {
        return `Owner ${p.daysPastCommitted}d past committal — follow up`;
      }
      return p.committed_upload_date
        ? `Monitor upload — owner committed ${fmt(p.committed_upload_date)}`
        : 'Confirm committal date with owner';
    case 'upload_started': {
      const missing = (p.docsTotal || 0) - (p.docsDone || 0);
      return missing > 0
        ? `Enter received docs — ${p.docsDone}/${p.docsTotal} in, ${missing} to go`
        : 'Confirm all docs entered';
    }
    case 'upload_complete':
      return withTarget('Docs are in — enter the data, then ✓ Data entered');
    case 'data_entry_complete':
      if (isPartialSkip) return withTarget('Ready for the Lead to set the valuation meeting');
      if (p.path === 'partial') return withTarget('Ready for Colleen — quick look');
      return withTarget('Ready for Colleen — adjustments / analysis');
    case 'adjustments_entered':
      if (isPartialSkip) return withTarget('Ready for the Lead to set the valuation meeting');
      if (p.path === 'partial') return withTarget('Ready for Colleen — quick look');
      return withTarget('Finish analysis (accuracy gauge to 100%)');
    case 'analysis_complete':
      return withTarget('Set the valuation meeting date with the owner');
    case 'val_meeting_set': {
      // Before the meeting: prep ("Review valuation"). Once the meeting date
      // has passed with no outcome recorded, the plate flips to the to-do
      // "Record the valuation meeting outcome" — the safety net so the post-
      // meeting wrap-up (value/commission, decision, review date) isn't
      // forgotten (Mark 2026-06-09). It clears when the outcome is recorded
      // (stage advances off val_meeting_set).
      const md = p.next_meeting_date ? new Date(p.next_meeting_date + 'T00:00:00') : null;
      const today0 = new Date(); today0.setHours(0, 0, 0, 0);
      if (md && md < today0) return 'Record the valuation meeting outcome';
      return md
        ? `Review valuation — meeting ${fmt(p.next_meeting_date)}`
        : 'Review valuation — meeting scheduled';
    }
    case 'awaiting_decision':
      return "Record the owner's decision on Setup tab";
    case 'engaged':
      return 'Engagement signed — moved to Deal Manager';
    case 'strategic_review_set':
      return p.next_meeting_date
        ? `Strategic review ${fmt(p.next_meeting_date)}`
        : 'On strategic review cadence';
    case 'considering_followup':
      return p.snooze_until
        ? `Follow up ${fmt(p.snooze_until)} — owner considering`
        : 'Considering — set a follow-up date';
    case 'val_complete_inactive':
      return 'Owner inactive — with the AM';
    case 'val_complete_dead':
      return 'Owner not for sale';
    case 'disqualified':
      return 'Dead — no valuation';
    case 'stalled_returned_to_am':
      return 'Stalled — re-engage when ready';
    default:
      return stageLabel(p.workflow_stage);
  }
};

/* ══════════════════════════════════════════════════════════════════
   ACTIVITY-LOG INTERACTION KINDS
   The "Last Interaction" column shows only communication touchpoints
   (we reached out / they responded) — not internal events like notes
   or stage changes. Those still live in the full activity-log pane.
   ══════════════════════════════════════════════════════════════════ */
const INTERACTION_KINDS = {
  reminder_sent:     { label: 'Reminder sent',   dir: 'out' },
  oir_sent:          { label: 'OIR sent',        dir: 'out' },
  questions_sent:    { label: 'Questions sent',  dir: 'out' },
  outreach:          { label: 'Reached out',     dir: 'out' },
  document_received: { label: 'Doc received',    dir: 'in'  },
  owner_responded:   { label: 'Owner responded', dir: 'in'  },
  meeting_held:      { label: 'Meeting held',    dir: 'neutral' },
};
const isInteractionKind = (k) => Object.prototype.hasOwnProperty.call(INTERACTION_KINDS, k);

// ── Re-engagement Lead-meeting rule (2026-06-23) ──────────────────────
// When a previously-engaged project is re-engaged, the Lead meeting can be
// SKIPPED only when it's a FULL valuation AND we last spoke with the owner
// within 12 months (newest of discovery_meeting_date / valuation_date).
// Everything else — partial, cold (>12mo), or no dates on record — requires a
// fresh introductory meeting. The skip decision is the SYSTEM's, never the AM's.
const REENGAGE_SKIP_MONTHS = 12;
const monthsSinceIso = (iso) => {
  if (!iso) return null;
  const d = new Date(iso + 'T00:00:00');
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  return (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth())
    - (now.getDate() < d.getDate() ? 1 : 0);
};
// SYNCED MEETINGS ARE CONTACT (Mark 10-05, Adam / Computer Superheroes): a
// review call on Adam's calendar 9/30 was invisible to the re-engage check —
// it only read VT's hand-typed date fields, which were blank on an imported
// deal — so the card said "no prior meeting on record". A past calendar
// meeting tied to the deal (by valuation_id, or via the SE owner's
// vt_client_id) now counts. Cancelled / dismissed / no-show never count;
// buyer, vendor and personal meetings aren't owner contact.
const NOT_OWNER_CONTACT_MEETING = new Set(['buyer_relationship', 'vendor', 'personal']);
const isHeldOwnerMeeting = (m, nowIso) => !!m && m.starts_at && m.starts_at < nowIso
  && m.status !== 'cancelled' && m.status !== 'dismissed' && m.outcome !== 'no_show'
  && !NOT_OWNER_CONTACT_MEETING.has(m.meeting_type);
// Newest held meeting date (YYYY-MM-DD) for a deal, from already-loaded
// se_meetings rows (the dashboard's seMeetingsAll carries owner.vt_client_id).
const lastHeldMeetingFrom = (rows, valuationId, clientId) => {
  const nowIso = new Date().toISOString();
  let best = null;
  (rows || []).forEach(m => {
    if (!isHeldOwnerMeeting(m, nowIso)) return;
    const tied = (valuationId && m.valuation_id === valuationId)
      || (clientId && m.owner && m.owner.vt_client_id === clientId);
    if (tied && (!best || m.starts_at > best)) best = m.starts_at;
  });
  return best ? best.slice(0, 10) : null;
};
// Same, fetched fresh — for the Re-engage / Start Revalue clicks, which
// re-read the deal from the DB instead of trusting a card.
const fetchLastHeldMeeting = async (supabaseClient, valuationId, clientId) => {
  if (!supabaseClient) return null;
  try {
    const ownerIds = [];
    if (clientId) {
      const { data: os } = await supabaseClient.from('se_owners').select('id').eq('vt_client_id', clientId);
      (os || []).forEach(o => ownerIds.push(o.id));
    }
    const ors = [valuationId ? `valuation_id.eq.${valuationId}` : null, ownerIds.length ? `owner_id.in.(${ownerIds.join(',')})` : null].filter(Boolean);
    if (!ors.length) return null;
    const { data: ms } = await supabaseClient.from('se_meetings')
      .select('starts_at, status, outcome, meeting_type, valuation_id').or(ors.join(','))
      .lt('starts_at', new Date().toISOString()).order('starts_at', { ascending: false }).limit(20);
    const nowIso = new Date().toISOString();
    const hit = (ms || []).find(m => isHeldOwnerMeeting(m, nowIso));
    return hit ? hit.starts_at.slice(0, 10) : null;
  } catch (_) { return null; }  // routing falls back to VT's own dates
};
const computeReengageRouting = (row) => {
  // Newest KNOWN contact: discovery meeting, valuation date, AND any held
  // meeting on the record (Colleen/Modo 08-26: a pre-cloud client in a
  // strategic-review cadence had yesterday's review meeting sitting in
  // next_meeting_date while the routing read only the 2025 dates and
  // demanded a fresh intro — review calls ARE contact). A next_meeting_date
  // in the future is a plan, not contact — only count it once it has passed.
  const todayIso = new Date().toISOString().slice(0, 10);
  const heldMeeting = row.next_meeting_date && row.next_meeting_date <= todayIso
    ? row.next_meeting_date : null;
  // row.last_held_meeting = newest synced calendar meeting (lastHeldMeetingFrom /
  // fetchLastHeldMeeting above) — set by callers that have it.
  const lastContact = [row.discovery_meeting_date, row.valuation_date, heldMeeting, row.last_held_meeting || null]
    .filter(Boolean).sort().pop() || null;
  const months = monthsSinceIso(lastContact);
  const isFull = String(row.path || '') === 'full_valuation';
  const recent = months != null && months <= REENGAGE_SKIP_MONTHS;
  // A BOOKED FUTURE review meeting (Mojo 09-08 — the second Mojo routing
  // miss: the owner asked to update EARLY with next month's strategic
  // review already on the calendar, and the routing demanded a fresh
  // intro anyway, exiling the deal to Warm). 08-26 taught that a PAST
  // review is contact; today's lesson is that a FUTURE one is a plan we
  // should USE, not ignore: the booked call IS the meeting, so collection
  // starts now and the review becomes the delivery conversation. The
  // strategic_review_set stage counts even when next_meeting_date is
  // blank — being in that stage MEANS a review is arranged.
  const bookedAhead = !!(row.next_meeting_date && row.next_meeting_date > todayIso)
    || String(row.workflow_stage || '') === 'strategic_review_set';
  return { skipMeeting: isFull && (recent || bookedAhead), months, lastContact, isFull, bookedAhead };
};

/* ══════════════════════════════════════════════════════════════════
   DASHBOARD
   Two tabs:
     - My Work: filtered to the logged-in user's queue, three urgency
                buckets (past committed, stuck-in-stage, this week).
     - Pipeline: all active projects in a sortable/filterable table,
                 with a stage-distribution bar at the top.
   Replaces the freeform "Action Item" PDF report.

   Feature-flag-gated. Non-staff never see this component.
   ══════════════════════════════════════════════════════════════════ */
const Dashboard = ({ userEmail, hasMfa, onEnrollMfa, onSignOut, onOpenValuation, onGoToClientList }) => {
  const [tab, setTab] = useState('mywork');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [projects, setProjects] = useState([]);
  // Strategic-review projects (a terminal stage, excluded from the active
  // pipeline) — fetched separately so Leads can see upcoming review meetings
  // without these counting toward Pipeline. (2026-06-08)
  const [reviewProjects, setReviewProjects] = useState([]);
  // AM projects (stalled-returned + valued-inactive) — also off the active
  // pipeline, fetched separately for the Account Manager's My Work. (2026-06-08)
  const [amProjects, setAmProjects] = useState([]);
  // Considering — follow-up-later projects (valued, owner strongly considering,
  // dated circle-back). Off the active pipeline, Lead-owned; fetched separately
  // for the Lead's follow-up sections and Colleen's "Following" monitor. The
  // follow-up date lives in snooze_until (next-touch). (2026-06-12)
  const [followUpProjects, setFollowUpProjects] = useState([]);
  // Full-funnel list (ALL stages, incl. post-valuation) for the Pipeline view
  // only. Kept separate from `projects` (active-only) so terminal stages never
  // leak into My Work buckets. (2026-06-09) Warm (pre-meeting onboarding) is
  // ALSO excluded — it lives in warmProjects below.
  const [pipelineProjects, setPipelineProjects] = useState([]);
  // Deal Manager listings (shared Supabase, fetched via /api/dm/listings) —
  // feed the ladder's Under LOI rung + the commission override. null =
  // fetch failed (rung renders a warning), [] = loaded and empty. (#6 A1)
  const [dmListings, setDmListings] = useState([]);
  const [dmStatusLog, setDmStatusLog] = useState([]); // listing_status_log rows (Timeline view)
  const [dmSheetHistory, setDmSheetHistory] = useState(null); // frozen Active-Projects sheet history (Timeline view)
  const [dmDateOverrides, setDmDateOverrides] = useState(null); // Mark's correct-dates report (Timeline view)
  // DM My Work signals (consolidation Phase 1) — every person's Deal
  // Manager cards, computed server-side from DM's own triage rules;
  // filtered to the effective viewer below so View-as works.
  const [dmMyWork, setDmMyWork] = useState([]);
  // DM closings (card-captured + Zoho sold-history import) — feed the Closed
  // Deals tab. Same null/[] semantics as dmListings. (#6 B1)
  const [dmClosings, setDmClosings] = useState([]);
  // Weekly metric snapshots (migration 036) — feed the Committee tab. null =
  // unavailable (pre-036 or fetch failed; tab shows a setup note). (#6 B2)
  const [metricSnapshots, setMetricSnapshots] = useState([]);
  const [bsStocks, setBsStocks] = useState(null);
  // ALL valuations' dates incl. terminal stages — the valuations gauge's
  // baseline windows (last month/quarter/year) must not undercount deals
  // that later died or went inactive. (Mark 2026-07-22 eve)
  const [valuationHistory, setValuationHistory] = useState([]);
  // LOI-signing dates from DM's listing_status_log (flips to Under LOI) —
  // the Signed LOIs gauge. Log born 2026-07-22: forward-looking only.
  const [loiSignings, setLoiSignings] = useState([]);
  // Historic Zoho metric events (migration 037) — valuations that never
  // touched VT still count in gauge history windows. (Mark 2026-07-22 eve)
  const [importedEvents, setImportedEvents] = useState([]);
  // New-buyer counts by month from DM (B3 monthly scorecard). null = the
  // aggregate wasn't available; the scorecard column shows em-dashes.
  const [dmBuyersByMonth, setDmBuyersByMonth] = useState(null);
  // Effective-dated targets (migration 035) — feed the activity gauges.
  // Tolerated missing: gauges render targetless until the migration runs. (#6 A3)
  const [targets, setTargets] = useState([]);
  // stage_changed events with metadata.to — the transition history feeding
  // the Stage Flow section (weekly entries + cohort conversion). (#6 A4)
  const [stageEvents, setStageEvents] = useState([]);
  // Owner-engagement latency source (Conversion card): first intro-email send
  // + first owner response per project, reduced to two small maps.
  const [ownerEngagement, setOwnerEngagement] = useState(null);
  // First-Mile Funnel (spec § FIRST-MILE CADENCE, 2026-08-03): the baseline
  // readout — discovery → upload-complete conversion + median days — measured
  // BEFORE the touch system ships so its effect is provable.
  const [funnelStats, setFunnelStats] = useState(null);
  // "Owner answered" live toasts (Colleen's pick, 2026-07-24 — options 1+3):
  // a minute-poll of owner_answer_unreviewed raises a corner toast + a "(n)"
  // tab-title badge for NEWLY flagged deals. Analysis role only; pairs with
  // the server's instant email (same flag, same one-per-batch semantics).
  const [answerToasts, setAnswerToasts] = useState([]);
  const seenAnswerFlagsRef = useRef(null); // null = first poll seeds silently
  const baseTitleRef = useRef(typeof document !== 'undefined' ? document.title : '');
  // Warm projects (pre-meeting onboarding) — created by an AM before the intro
  // meeting. Off the active pipeline + Pipeline view; surfaced on the AM's My
  // Work (send link / follow up) and the Lead's (activate or pass after the
  // meeting). The intro meeting date lives in discovery_meeting_date. (2026-06-16)
  const [warmProjects, setWarmProjects] = useState([]);
  // Bump to force a full reload of the dashboard data (used after an action that
  // moves a project between buckets loaded by separate queries — e.g. re-engage,
  // which sends a project to the Warm query).
  const [reloadTick, setReloadTick] = useState(0);
  // ⏳ warm no-show watches (loaded further down). Declared HERE because the My Work buckets memo reads it
  // earlier in this component — declared below it, the page crashed blank on load (10-01 → 10-02).
  const [warmWatchByPid, setWarmWatchByPid] = useState({});
  // 🎯 rebook-email counts + strategy picks on warm no-shows (Mark 10-15) — same reason, declared here.
  const [warmRebookByPid, setWarmRebookByPid] = useState({});
  const [warmStrategyTarget, setWarmStrategyTarget] = useState(null);
  // 📋 the latest qualification per warm deal + the modal target (Mark + Zac 10-16). Declared up here too.
  const [warmQualByPid, setWarmQualByPid] = useState({});
  const [warmQualifyTarget, setWarmQualifyTarget] = useState(null);
  const [presenceByValuation, setPresenceByValuation] = useState({}); // valuation_id -> [viewer name]
  const [myReminders, setMyReminders] = useState([]); // this user's open personal reminders
  const [sortQueue, setSortQueue] = useState([]); // Stage C: ShareFile uploads needing manual classification

  // Pipeline filters/sort. Sort persists across sessions via localStorage
  // so the view stays the way the user left it (Mark's request 2026-05-26).
  // Pipeline filters persist per browser too (2026-06-09) so the view always
  // reopens the way the user left it ("returns to most recent view").
  const savedFilters = (() => {
    try {
      const raw = localStorage.getItem('vt.pipeline.filters');
      if (raw) { const f = JSON.parse(raw); if (f && typeof f === 'object') return f; }
    } catch (e) { /* non-critical */ }
    return {};
  })();
  // Stage filter is multi-select: an array of stage keys ([] = all stages).
  // Back-compat with the prior single-string format ('all' or one stage key).
  const [filterStage, setFilterStage] = useState(
    Array.isArray(savedFilters.stage)
      ? savedFilters.stage
      : (savedFilters.stage && savedFilters.stage !== 'all') ? [savedFilters.stage] : []
  );
  const [filterLead, setFilterLead]   = useState(savedFilters.lead  || 'all');
  const [filterAM, setFilterAM]       = useState(savedFilters.am    || 'all');
  const [filterOwner, setFilterOwner] = useState(savedFilters.owner || 'all');
  const [sortBy, setSortBy] = useState(() => {
    try {
      const raw = localStorage.getItem('vt.pipeline.sort');
      if (raw) {
        const p = JSON.parse(raw);
        if (typeof p?.sortBy === 'string') return p.sortBy;
      }
    } catch (e) { /* non-critical */ }
    return 'daysInStage';
  });
  const [sortDir, setSortDir] = useState(() => {
    try {
      const raw = localStorage.getItem('vt.pipeline.sort');
      if (raw) {
        const p = JSON.parse(raw);
        if (p?.sortDir === 'asc' || p?.sortDir === 'desc') return p.sortDir;
      }
    } catch (e) { /* non-critical */ }
    return 'desc';
  });

  useEffect(() => {
    try { localStorage.setItem('vt.pipeline.sort', JSON.stringify({ sortBy, sortDir })); }
    catch (e) { /* non-critical */ }
  }, [sortBy, sortDir]);

  useEffect(() => {
    try { localStorage.setItem('vt.pipeline.filters', JSON.stringify({ stage: filterStage, lead: filterLead, am: filterAM, owner: filterOwner })); }
    catch (e) { /* non-critical */ }
  }, [filterStage, filterLead, filterAM, filterOwner]);

  // Saved Pipeline views (Zac 2026-08-05: "sorted one way for personal use,
  // but during staff meeting he has to change the sorting and columns").
  // A named view = one snapshot of everything the toolbar controls: stage/
  // lead/AM/owner filters, sort column + direction, hidden columns.
  // Per-browser storage — the same place the live state already persists.
  const [pipelineViews, setPipelineViews] = useState(() => {
    try {
      const raw = localStorage.getItem('vt.pipeline.views');
      if (raw) { const v = JSON.parse(raw); if (v && typeof v === 'object') return v; }
    } catch (e) { /* non-critical */ }
    return {};
  });
  useEffect(() => {
    try { localStorage.setItem('vt.pipeline.views', JSON.stringify(pipelineViews)); }
    catch (e) { /* non-critical */ }
  }, [pipelineViews]);
  const savePipelineView = (name) => {
    const clean = String(name || '').trim();
    if (!clean) return;
    setPipelineViews(v => ({ ...v, [clean]: {
      stage: filterStage, lead: filterLead, am: filterAM, owner: filterOwner,
      sortBy, sortDir, hidden: [...hiddenColumns],
    } }));
  };
  const applyPipelineView = (name) => {
    const v = pipelineViews[name];
    if (!v) return;
    setFilterStage(Array.isArray(v.stage) ? v.stage : []);
    setFilterLead(v.lead || 'all');
    setFilterAM(v.am || 'all');
    setFilterOwner(v.owner || 'all');
    if (v.sortBy) setSortBy(v.sortBy);
    if (v.sortDir === 'asc' || v.sortDir === 'desc') setSortDir(v.sortDir);
    setHiddenColumns(new Set(Array.isArray(v.hidden) ? v.hidden : []));
  };
  const deletePipelineView = (name) => setPipelineViews(v => {
    const next = { ...v }; delete next[name]; return next;
  });

  // Per-user Pipeline column visibility. Stores the HIDDEN set (not the
  // visible set) so a deploy that adds a new column shows it to existing
  // users by default. Required columns are always visible.
  const [hiddenColumns, setHiddenColumns] = useState(() => {
    try {
      const raw = localStorage.getItem('vt.pipeline.hiddenColumns');
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) return new Set(arr.filter(k => typeof k === 'string'));
      }
    } catch (e) { /* non-critical */ }
    return new Set();
  });
  const toggleColumn = (key) => {
    const col = PIPELINE_COLUMNS.find(c => c.key === key);
    if (col && col.required) return;
    setHiddenColumns(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };
  useEffect(() => {
    try { localStorage.setItem('vt.pipeline.hiddenColumns', JSON.stringify([...hiddenColumns])); }
    catch (e) { /* non-critical */ }
  }, [hiddenColumns]);

  // Who am I — exact email match against the staff directory.
  // 👁 The look-only account (Claude on the office PC) is not a staff row: it has no plate of its own, may view as
  // anyone, and every write is blocked (LOOK_ONLY_EMAILS at the top of this file).
  const lookOnly = useMemo(() => isLookOnlyEmail(userEmail), [userEmail]);
  const myName = useMemo(() => (isLookOnlyEmail(userEmail) ? 'Claude' : staffName(userEmail)), [userEmail]);
  const myRole = useMemo(() => {
    const s = STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()];
    return s ? s.role : null;
  }, [userEmail]);

  // Pipeline layout follows the SIGN-IN, not the browser (Colleen 10-30: the
  // nightly-shutdown security setup has Chrome delete site data on close, so
  // her saved views and hidden columns were gone every morning). The pieces
  // above still cache in localStorage; this mirrors them into the user's
  // Supabase auth metadata (vt_pipeline) and restores them at sign-in. The
  // saved copy wins when present, and nothing is written back until the
  // restore has run, so a wiped browser's defaults never overwrite it.
  const [pipePrefsReady, setPipePrefsReady] = useState(false);
  useEffect(() => {
    if (!supabaseClient || !userEmail || lookOnly) return;
    let gone = false;
    setPipePrefsReady(false);
    (async () => {
      try {
        const { data } = await supabaseClient.auth.getUser();
        const p = data && data.user && data.user.user_metadata && data.user.user_metadata.vt_pipeline;
        if (!gone && p && typeof p === 'object') {
          if (p.views && typeof p.views === 'object') setPipelineViews(p.views);
          if (Array.isArray(p.hidden)) setHiddenColumns(new Set(p.hidden.filter(k => typeof k === 'string')));
          if (typeof p.sortBy === 'string') setSortBy(p.sortBy);
          if (p.sortDir === 'asc' || p.sortDir === 'desc') setSortDir(p.sortDir);
          const f = p.filters;
          if (f && typeof f === 'object') {
            setFilterStage(Array.isArray(f.stage) ? f.stage : []);
            setFilterLead(f.lead || 'all'); setFilterAM(f.am || 'all'); setFilterOwner(f.owner || 'all');
          }
        }
      } catch (e) { /* non-critical: the browser copy still works */ }
      if (!gone) setPipePrefsReady(true);
    })();
    return () => { gone = true; };
  }, [userEmail, lookOnly]);
  useEffect(() => {
    if (!pipePrefsReady || !supabaseClient || !userEmail || lookOnly) return;
    const vt_pipeline = { views: pipelineViews, hidden: [...hiddenColumns], sortBy, sortDir,
      filters: { stage: filterStage, lead: filterLead, am: filterAM, owner: filterOwner } };
    if (JSON.stringify(vt_pipeline).length > 6000) return; // rides in the sign-in token; keep it small
    const t = setTimeout(() => { supabaseClient.auth.updateUser({ data: { vt_pipeline } }).catch(() => {}); }, 2000);
    return () => clearTimeout(t);
  }, [pipePrefsReady, pipelineViews, hiddenColumns, sortBy, sortDir, filterStage, filterLead, filterAM, filterOwner, userEmail, lookOnly]);

  // ─── "View as" (owner-only) ─────────────────────────────────────
  // Lets Mark render another staffer's My Work exactly as they see it,
  // so he can tune each person's queue (Konnie first, then Colleen).
  // Gated to the owner role — everyone else only ever sees their own
  // work. `effectiveName` drives the responsibility filter; the picker
  // re-points the personal-reminders query at that person's email too.
  // Morning front door (Mark 08-07: "I want them to see their cards each
  // morning and not have a path that doesn't expose their cards"). The
  // Dashboard stamps the browser with today's ET date on a domain cookie;
  // DM and the SE page check it and route the FIRST visit of each day
  // through here. Direct bookmarks work the rest of the day.
  useEffect(() => {
    try {
      if (!/vistabusinessgroup\.com$/.test(window.location.hostname)) return;
      const d = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(new Date());
      document.cookie = 'vbg_dash=' + d + '; Domain=.vistabusinessgroup.com; Path=/; Max-Age=172800; SameSite=Lax; Secure';
    } catch (e) { /* cosmetic */ }
  }, []);

  // ── Vacation coverage (Mark 09-02, Konnie's four days out): a staff row
  // with out_until >= today and a backup_name makes the backup a temporary
  // view-as holder for that ONE person. Flipping into their view reuses the
  // owner's view-as machinery wholesale — effectiveName/effectiveRole carry
  // the plate, Sort Queue, setup bucket, and personal reminders across —
  // while every action still runs (and logs) as the real logged-in person.
  // Expires by itself when out_until passes; no off switch to forget.
  const coveringFor = useMemo(() => {
    const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(new Date());
    return (STAFF_TABLE_ROWS || [])
      .filter(r => r.name && r.name !== myName && r.backup_name === myName
        && r.out_until && r.out_until >= today)
      .map(r => ({ name: r.name, until: r.out_until }));
  }, [myName]);
  const canViewAs = myRole === 'owner' || lookOnly || coveringFor.length > 0;
  const [viewAs, setViewAs] = useState(''); // '' = view as myself
  // Owner can view anyone; a covering backup only the person they cover
  // (guards a stale tab whose coverage window has since expired).
  const viewAsValid = !!viewAs && (myRole === 'owner' || lookOnly || coveringFor.some(c => c.name === viewAs));
  const effectiveName  = viewAsValid ? viewAs : myName;
  const effectiveEmail = viewAsValid ? (staffEmailByName(viewAs) || '') : userEmail;
  const effectiveRole  = (STAFF_DIRECTORY[String(effectiveEmail || '').trim().toLowerCase()] || {}).role || null;

  // ===== Sales Engine serving (P2) — data + ranking + actions =====
  // Loads the effective person's SE book (responder tier only; cold is P3's
  // problem) + open commitments. Independent of the main dashboard load so a
  // missing se_owners table can never break My Work.
  // Scott joined 08-05 (response-desk go-live): his "book" is every owner
  // mid-scheduling — responded, no meeting set yet (his OneNote cadence).
  const SE_AM_NAMES = ['Zac', 'Thatcher', 'Adam', 'Scott'];
  // ROLLOUT GATE (Mark 2026-07-28 evening: "we need it completely working…
  // before he does anything"): the serving renders ONLY for the owner
  // account (Mark, incl. View-as) until this is flipped. Set to true to go
  // team-wide — nothing else needs to change.
  // FLIPPED 2026-08-05 (Mark: "my goal today is to go live with the SE").
  // Serving cards render for Zac/Thatcher/Adam; Adam's reply-due backlog
  // ships UNCAPPED (Mark's call: "show the honest wall").
  const SE_SERVING_TEAM_LIVE = true;
  const [seOwnersMine, setSeOwnersMine] = useState(null);
  // 📥 Reply guests (Mark 10-21): owners who answered an email sent from YOUR mailbox, whatever book or tier they sit on.
  const [seReplyGuests, setSeReplyGuests] = useState([]);
  const [seCommitmentsMine, setSeCommitmentsMine] = useState([]);
  const [seTick, setSeTick] = useState(0);
  const [seOutcomeTarget, setSeOutcomeTarget] = useState(null);
  // 📪 on a WARM account (Adam 10-26, BluRock: the address was marked dead but the card had no way to clear):
  // { owner, addr, openIds } while the "what next?" choices are up.
  const [seBounceChoice, setSeBounceChoice] = useState(null);
  // 📞 Log outcome from ANY Sales Engine record (Adam 09-29: "the RAM card isn't displayed" — the
  // form only existed on a card due that day). /?logOutcome=<se_owner id> opens it for that business;
  // an open follow-up on it is treated like the card (logging clears it, as on the plate).
  useEffect(() => {
    if (typeof window === 'undefined' || !supabaseClient) return;
    let id = null;
    try { id = new URLSearchParams(window.location.search).get('logOutcome'); } catch (e) { /* no params */ }
    if (!id) return;
    try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* ignore */ }
    openOutcomeFor(id);
  }, [supabaseClient]);   // eslint-disable-line react-hooks/exhaustive-deps
  async function openOutcomeFor(id) {
    if (!supabaseClient || !id) return;
    const { data: owner } = await supabaseClient.from('se_owners').select('*').eq('id', id).maybeSingle();
    if (!owner) { window.alert('That business was not found in the Sales Engine.'); return; }
    const { data: oc } = await supabaseClient.from('se_commitments').select('id, due, note, created_by, created_at')
      .eq('owner_id', id).eq('status', 'open').order('due', { ascending: true }).limit(1);
    setSeOutcomeTarget({ ...owner, _commitment: (oc || [])[0] || null,
      _why: 'Opened from the record — log what happened, record a buyside step, or set the next move.' });
  }
  // "Finish the thought" prefill: opening the outcome modal from a backfill
  // card carries the actor's ORIGINAL note + the ftt quota marker.
  const [seOutcomePrefill, setSeOutcomePrefill] = useState(null);
  // ── Finish the thought (Mark 08-28): outcome logs saved without a pick
  // (stale-tab era) drip back 3/day — each card shows the actor's own note
  // and asks only for the strategy. Self-serving: anyone with orphans sees
  // their own; resolves through the normal outcome modal.
  const [seFinish, setSeFinish] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient || !effectiveName) { setSeFinish(null); return; }
    (async () => {
      try {
        const { data: calls } = await supabaseClient.from('se_touches')
          .select('id, owner_id, subject, meta, created_at')
          .eq('actor', effectiveName).eq('kind', 'call').eq('channel', 'phone')
          .order('created_at', { ascending: true }).limit(1000);
        let orphanTouches = (calls || []).filter(t => t.owner_id
          && !(t.meta && t.meta.disposition) && !(t.meta && t.meta.next_date) && !(t.meta && t.meta.ftt)
          && !String(t.subject || '').startsWith('Reached out'));
        // Older date-only saves carry no next_date: a reminder this person made for the same business within 10
        // minutes of the note was that save's pick (Adam 10-26: ASI 9/14 → 9/15 reminder, Dakotech 8/17 → 8/24).
        if (orphanTouches.length) {
          const oids = [...new Set(orphanTouches.map(t => t.owner_id))];
          const made = [];
          for (let i = 0; i < oids.length; i += 50) {
            const { data: cs } = await supabaseClient.from('se_commitments').select('owner_id, created_at')
              .eq('created_by', effectiveName).in('owner_id', oids.slice(i, i + 50));
            (cs || []).forEach(c => made.push(c));
          }
          orphanTouches = orphanTouches.filter(t => !made.some(c => c.owner_id === t.owner_id
            && Math.abs(new Date(c.created_at).getTime() - new Date(t.created_at).getTime()) <= 10 * 60000));
        }
        if (!orphanTouches.length) { if (!cancelled) setSeFinish(null); return; }
        const ownerIds = [...new Set(orphanTouches.map(t => t.owner_id))];
        const { data: owners } = await supabaseClient.from('se_owners')
          .select('id, company_name, contact_name, disposition, next_touch_at, status, notes, action_item, vt_client_id')
          .in('id', ownerIds);
        const unparked = new Map((owners || [])
          .filter(o => o.status === 'active' && !o.disposition && !o.next_touch_at)
          .map(o => [o.id, o]));
        // A live dated promise = NOT forgotten (Adam 09-02, AVS: he picked
        // "follow up on a specific date" — TWICE — and this card kept
        // returning, because a date-only pick leaves no disposition on the
        // touch and no next_touch_at on the owner. An owner with ANY open
        // commitment is the exact opposite of the "tool forgets this owner"
        // case the drip exists for.) .in() chunked ≤50 — the URL-length law.
        {
          const ids = [...unparked.keys()];
          for (let i = 0; i < ids.length; i += 50) {
            const { data: openC } = await supabaseClient.from('se_commitments')
              .select('owner_id').eq('status', 'open').in('owner_id', ids.slice(i, i + 50));
            (openC || []).forEach(c => unparked.delete(c.owner_id));
          }
        }
        // Latest orphan note per still-unparked owner, oldest owner first.
        const perOwner = new Map();
        orphanTouches.forEach(t => { if (unparked.has(t.owner_id)) perOwner.set(t.owner_id, t); });
        const items = [...perOwner.values()].map(t => ({ touch: t, owner: unparked.get(t.owner_id) }));
        // 3-a-day quota: today's ftt-marked touches spend it.
        const dayStart = new Date(); dayStart.setHours(0, 0, 0, 0);
        const { data: todays } = await supabaseClient.from('se_touches')
          .select('id, meta').eq('actor', effectiveName)
          .gte('created_at', dayStart.toISOString()).limit(200);
        const doneToday = (todays || []).filter(t => t.meta && t.meta.ftt).length;
        if (!cancelled) setSeFinish({ items, doneToday, remaining: Math.max(0, 3 - doneToday) });
      } catch (e) { if (!cancelled) setSeFinish(null); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, effectiveName, seTick, reloadTick]);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient || !SE_AM_NAMES.includes(effectiveName || '')
        || (!SE_SERVING_TEAM_LIVE && !canViewAs)) {
      setSeOwnersMine(null); setSeCommitmentsMine([]); setSeReplyGuests([]);
      return;
    }
    (async () => {
      try {
        // notes/action_item/description/not_ready_reason = the Zoho
        // at-a-glance context (Adam's MySmartPlans point 08-13: "in Zoho I
        // can see notes from prior conversations and decide instantly") —
        // they ride the card as the 📝 line.
        const cols = 'id, zoho_id, company_name, contact_name, emails, city, state, sector, phone, website, size_revenue, ebitda, size_employees, business_type, vt_client_id, tier, zoho_status, triage_tier, zoho_last_activity, last_meeting_at, last_meeting_type, next_meeting_at, next_meeting_type, last_touch_at, next_touch_at, disposition, zoho_valuation_date, zoho_value_provided, captured_at, email_campaign, notes, action_item, description, not_ready_reason';
        // 'unsubscribed' stays servable (go-live gap hunt 08-05): opting out
        // of MARKETING EMAIL doesn't opt out of being managed — a phone
        // responder who once unsubscribed still belongs on the AM's plate.
        // Wave suppression checks status independently, so this can never
        // leak them back into campaigns.
        const loadOwners = (c) => fetchAllRows(() => supabaseClient.from('se_owners').select(c)
          .eq('assigned_to', effectiveName).eq('tier', 'responder').in('status', ['active', 'unsubscribed'])
          .order('id', { ascending: true }));
        let owners;
        try {
          owners = await loadOwners(cols + ', linkedin_url, last_inbound_at, last_outbound_at');
        } catch (e) {
          // Migration 048/050 not applied yet — serve without the extras
          // rather than losing the whole section.
          if (!/linkedin_url|last_inbound_at|last_outbound_at/i.test(String(e?.message || e))) throw e;
          owners = await loadOwners(cols);
        }
        // Step 2 (Adam-plate plan 08-11): reply-due cards CARRY the email.
        // Latest REAL inbound (calendar machinery excluded — same rule as
        // the server truth pass) for owners in inbound-newer-than-outbound
        // posture; card shows subject/snippet/date, 🧵 opens the thread.
        const CAL_RX = /^\s*(?:accepted|declined|tentative(?:ly accepted)?|invitation|updated invitation|new event|cancell?ed(?: event)?|meeting forward notification)\s*:/i;
        // Deal/listing threads ("… (704110)") aren't relationship mail either
        // (the CentriLogic class) — same rule as the server truth pass.
        const LISTING_RX = /\(\d{6}\)\s*$/;
        // Nor are out-of-office autoresponders (the HDCE French vacation reply).
        const OOO_RX = /^\s*(?:(?:re|fwd?|aw|tr)\s*:\s*)*(?:automatic reply|auto[- ]?reply|out of office|absence du bureau|r[ée]ponse automatique|abwesenheit)/i;
        const OOO_ANY_RX = /\bout[\s-]of[\s-]office\b/i;
        try {
          // Card horizon (Mark 09-24): an inbound older than 180 days is
          // history, not an owner waiting — the three-year inhale must never
          // card old mail. Mirrors the server's clock horizon.
          const posture = (owners || []).filter(o => o.last_inbound_at
            && (!o.last_outbound_at || o.last_inbound_at > o.last_outbound_at)
            && (Date.now() - new Date(o.last_inbound_at).getTime()) < 180 * 86400000);
          const INTERNAL_RX = /@vistabusinessgroup\.com$/i;
          for (let i = 0; i < posture.length; i += 50) {
            const chunk = posture.slice(i, i + 50);
            // suspicious/_reason = the 🚩 phishing-buyer flag (migration 066);
            // fall back to the bare select until the columns exist.
            let mails;
            {
              const r1 = await supabaseClient.from('se_emails')
                .select('owner_id, subject, snippet, sent_at, to_emails, from_email, suspicious, suspicious_reason')
                .in('owner_id', chunk.map(o => o.id)).eq('direction', 'inbound')
                .order('sent_at', { ascending: false }).limit(1000);
              if (r1.error) {
                const r2 = await supabaseClient.from('se_emails')
                  .select('owner_id, subject, snippet, sent_at, to_emails, from_email')
                  .in('owner_id', chunk.map(o => o.id)).eq('direction', 'inbound')
                  .order('sent_at', { ascending: false }).limit(1000);
                mails = r2.data;
              } else mails = r1.data;
            }
            const first = new Map();
            (mails || []).forEach(m => {
              const s = m.subject || '';
              if (CAL_RX.test(s) || LISTING_RX.test(s) || OOO_RX.test(s) || OOO_ANY_RX.test(s)) return;
              // Vista-from = a colleague's inbox copy of OUR mail (direction
              // is mailbox-relative), never the owner writing (Colleen→RVS
              // 08-24) — must not surface as "their email" on a card.
              if (INTERNAL_RX.test(m.from_email || '')) return;
              // CC-only rule (UpTime 08-11): no Vista address in TO + another
              // external in TO = intro chatter, not a question for us.
              const to = Array.isArray(m.to_emails) ? m.to_emails : [];
              if (!to.some(a => INTERNAL_RX.test(a)) && to.some(a => !INTERNAL_RX.test(a))) return;
              // To-Scott-only mail (Red Lane 08-11): asks Scott, not this
              // book's holder — unless this IS Scott's book.
              const internalTo = to.filter(a => INTERNAL_RX.test(a));
              if (effectiveName !== 'Scott' && internalTo.length > 0
                && internalTo.every(a => String(a).toLowerCase() === 'scott@vistabusinessgroup.com')) return;
              if (!first.has(m.owner_id)) first.set(m.owner_id, m);
            });
            chunk.forEach(o => { const m = first.get(o.id); if (m) o._lastInbound = m; });
            // ✕ "No reply needed" dismissals AND logged-outcome dispositions
            // — either one NEWER than the last inbound clears the card; a
            // fresh email re-fires it. Reading the outcome touches directly
            // (not just the write-time suppression marker fix #8 added)
            // makes the law RETROACTIVE: Adam's MainStay/Tyler/Virtua cards
            // 08-17 were outcome-logged earlier in the week on pre-fix code,
            // so no marker existed and the cards sat "worked" but standing.
            // A slide-22 disposition = an owner-consented conversation = the
            // reply; AM-side strategy picks still deliberately don't clear.
            const dispKeys = new Set(SE_DISPOSITIONS.map(d => d.key));
            const { data: nrr } = await supabaseClient.from('se_touches')
              .select('owner_id, at, kind, meta').in('owner_id', chunk.map(o => o.id))
              .in('kind', ['no_reply_needed', 'call', 'email', 'linkedin', 'other'])
              .order('at', { ascending: false }).limit(1000);
            const nrrFirst = new Map();
            (nrr || []).forEach(t => {
              const clears = t.kind === 'no_reply_needed'
                || (t.meta && t.meta.disposition && dispKeys.has(t.meta.disposition));
              if (clears && !nrrFirst.has(t.owner_id)) nrrFirst.set(t.owner_id, t.at);
            });
            chunk.forEach(o => { const t = nrrFirst.get(o.id); if (t) o._noReplyAt = t; });
          }
          // RECIPIENT LAW, outbound half (LifeSpaces 08-11): a "no response
          // — pick the play" card belongs to whoever SENT the email. Fetch
          // the last outbound's mailbox for the band-4 window so the card
          // can check "was that me?" — Adam's re-engagement pitch never
          // dangles on Thatcher's plate, and a Konnie doc-reminder send
          // never creates AM pressure.
          const outPosture = (owners || []).filter(o => o.last_outbound_at
            && (!o.last_inbound_at || o.last_inbound_at < o.last_outbound_at)
            && (Date.now() - new Date(o.last_outbound_at).getTime()) > 9 * 86400000
            && (Date.now() - new Date(o.last_outbound_at).getTime()) < 46 * 86400000);
          for (let i = 0; i < outPosture.length; i += 50) {
            const chunk = outPosture.slice(i, i + 50);
            const { data: outs } = await supabaseClient.from('se_emails')
              .select('owner_id, mailbox, sent_at')
              .in('owner_id', chunk.map(o => o.id)).eq('direction', 'outbound')
              .order('sent_at', { ascending: false }).limit(1000);
            const firstOut = new Map();
            (outs || []).forEach(m => { if (!firstOut.has(m.owner_id)) firstOut.set(m.owner_id, m.mailbox); });
            chunk.forEach(o => { const mb = firstOut.get(o.id); if (mb) o._lastOutMailbox = mb; });
          }
        } catch (e) { /* cards render without the email context */ }
        // 🔕 WENT-QUIET SENDER POOL (Mark 09-17: "it needs to land on the
        // plate of the person who SENT the email. Period."). The band-4
        // enrichment above only stamps _lastOutMailbox in the 9–46d window,
        // so a fresh 2-day stall had it UNSET and routed to the book holder;
        // and it only ever looked at your own book, so a sender outside it
        // got nothing. Here: the owners YOU emailed in the engaged window,
        // confirmed YOU were the LAST sender (someone else writing later
        // takes the card with them), stamped on in-book rows and fetched as
        // _wqGuest rows when they're on someone else's book — visible ONLY
        // to the went-quiet band. The card follows the conversation, not
        // the assignment.
        let wqGuests = [];
        try {
          const wqSince = new Date(Date.now() - 20 * 86400000).toISOString();
          const { data: mineOut } = await supabaseClient.from('se_emails')
            .select('owner_id').eq('mailbox', effectiveName).eq('direction', 'outbound')
            .gte('sent_at', wqSince).not('owner_id', 'is', null).limit(2000);
          const candIds = [...new Set((mineOut || []).map(m => m.owner_id))];
          const lastOutBy = new Map();
          for (let i = 0; i < candIds.length; i += 100) {
            const { data: outs } = await supabaseClient.from('se_emails')
              .select('owner_id, mailbox, sent_at').in('owner_id', candIds.slice(i, i + 100))
              .eq('direction', 'outbound').order('sent_at', { ascending: false }).limit(1000);
            (outs || []).forEach(m => { if (!lastOutBy.has(m.owner_id)) lastOutBy.set(m.owner_id, m.mailbox); });
          }
          const senderIds = new Set(candIds.filter(id => lastOutBy.get(id) === effectiveName));
          const inBook = new Set((owners || []).map(o => o.id));
          (owners || []).forEach(o => { if (senderIds.has(o.id)) o._lastOutMailbox = effectiveName; });
          const extraIds = [...senderIds].filter(id => !inBook.has(id));
          for (let i = 0; i < extraIds.length; i += 100) {
            const { data: rows } = await supabaseClient.from('se_owners')
              .select(cols + ', last_inbound_at, last_outbound_at').in('id', extraIds.slice(i, i + 100))
              .in('status', ['active', 'unsubscribed']);
            (rows || []).forEach(o => wqGuests.push({ ...o, _wqGuest: true, _lastOutMailbox: effectiveName }));
          }
        } catch (e) { /* the sender pool is best-effort — in-book cards still render */ }
        // 📥 REPLY GUESTS (Mark 10-21, Bob Rouch / Professional Kitchen Services, Sacramento): an owner who answered an
        // email sent from YOUR mailbox is yours to answer, whatever book or tier the record sits on. A cold record never
        // reached the reply card, so Scott found Bob's question only by reading ~400 out-of-office notes. Machine mail
        // (auto-replies by subject OR body, calendar responses, listing threads, our own copies) never counts. Visible to
        // the reply band only, carded the same day; an answer from our side, a logged outcome or ✕ clears it.
        let replyGuests = [];
        try {
          const rSince = new Date(Date.now() - 14 * 86400000).toISOString();
          const R_CAL = /^\s*(?:accepted|declined|tentative(?:ly accepted)?|invitation|updated invitation|new event|cancell?ed(?: event)?|meeting forward notification)\s*:/i;
          const R_AUTO_SUBJ = /^\s*(?:(?:re|fwd?|aw|tr)\s*:\s*)*(?:automatic reply|auto[- ]?(?:reply|response)|autoreply|autoresponse|out of (?:the )?office|absence du bureau|r[ée]ponse automatique|abwesenheit|undeliver|delivery status|mail delivery|returned mail|your (?:mail|message|e-?mail) to|you(?:r)? message has been received)/i;
          const R_AUTO_BODY = /out[\s-]of[\s-](?:the[\s-])?office|i am (?:currently )?(?:away|out of)|i'?m (?:currently )?(?:away|out of)|on vacation|on holiday|limited access to (?:my )?e-?mail|will (?:respond|reply|return|get back)|automatic(?:ally)? (?:reply|response|generated)|no longer with|(?:is|are) not monitored|has been received|thank you for (?:your (?:e-?mail|message|mail)|contacting)|high volume of e-?mails|office (?:is|will be) closed|back in the (?:store|office)/i;
          const R_DEAL = /\b7\d{5}\b/;   // a Vista ID in the subject = a deal / listing thread (buyer side), not the response desk
          const R_INTERNAL = /@vistabusinessgroup\.com$/i;
          // A reply to YOUR email has you in To (Ajit 10-21: "Hi Adam, can we reschedule" with Scott only copied is Adam's).
          const myAddrs = Object.keys(STAFF_DIRECTORY || {}).filter(e => STAFF_DIRECTORY[e] && STAFF_DIRECTORY[e].name === effectiveName).map(e => e.toLowerCase());
          const { data: rin } = await supabaseClient.from('se_emails')
            .select('owner_id, subject, snippet, sent_at, to_emails, from_email')
            .eq('mailbox', effectiveName).eq('direction', 'inbound').gte('sent_at', rSince)
            .not('owner_id', 'is', null).order('sent_at', { ascending: false }).limit(3000);
          const inBook = new Set((owners || []).map(o => o.id));
          const lastReal = new Map();
          const decided = new Set();   // an owner's LATEST real email decides; never fall back to an older one
          (rin || []).forEach(m => {
            if (inBook.has(m.owner_id) || decided.has(m.owner_id)) return;
            const subj = m.subject || '';
            if (R_CAL.test(subj) || /\(\d{6}\)\s*$/.test(subj) || R_DEAL.test(subj) || R_AUTO_SUBJ.test(subj) || R_AUTO_BODY.test(m.snippet || '')) return;
            if (R_INTERNAL.test(m.from_email || '')) return;
            decided.add(m.owner_id);
            const toList = (Array.isArray(m.to_emails) ? m.to_emails : []).map(a => String(a).toLowerCase());
            if (myAddrs.length && toList.length && !toList.some(a => myAddrs.includes(a))) return;
            lastReal.set(m.owner_id, m);
          });
          const rIds = [...lastReal.keys()];
          for (let i = 0; i < rIds.length; i += 100) {
            const { data: rows } = await supabaseClient.from('se_owners')
              .select(cols + ', last_inbound_at, last_outbound_at').in('id', rIds.slice(i, i + 100))
              .in('status', ['active', 'unsubscribed']);
            (rows || []).forEach(o => {
              const m = lastReal.get(o.id);
              replyGuests.push({ ...o, _replyGuest: true, _lastInbound: m, _replyAt: m.sent_at });
            });
          }
          if (replyGuests.length) {
            const gIds = replyGuests.map(o => o.id);
            const answered = new Map();
            for (let i = 0; i < gIds.length; i += 100) {
              const chunk = gIds.slice(i, i + 100);
              const [{ data: outs }, { data: tch }] = await Promise.all([
                supabaseClient.from('se_emails').select('owner_id, sent_at').in('owner_id', chunk).eq('direction', 'outbound').gte('sent_at', rSince),
                supabaseClient.from('se_touches').select('owner_id, at, kind').in('owner_id', chunk)
                  .in('kind', ['no_reply_needed', 'email_in', 'call', 'email', 'linkedin', 'other']).gte('at', rSince),
              ]);
              (outs || []).concat((tch || []).map(t => ({ owner_id: t.owner_id, sent_at: t.at }))).forEach(x => {
                if (!answered.has(x.owner_id) || x.sent_at > answered.get(x.owner_id)) answered.set(x.owner_id, x.sent_at);
              });
            }
            replyGuests = replyGuests.filter(o => !(answered.get(o.id) && answered.get(o.id) > o._replyAt));
          }
        } catch (e) { replyGuests = []; /* best-effort: the in-book reply cards still render */ }
        const commits = await fetchAllRows(() => supabaseClient.from('se_commitments')
          .select('id, owner_id, due, note, created_by, created_at, se_owners!inner(assigned_to)')
          .eq('status', 'open').eq('se_owners.assigned_to', effectiveName)
          .order('id', { ascending: true }));
        // Scheduling-cadence chains card their CREATOR, not the relationship
        // holder (Mark 08-11, the Jack Immendorf case: Scott logged a
        // response on Adam's past relationship — Adam keeps the owner, Scott
        // chases the meeting). Pull chains I started on other people's
        // books; drop other people's chains from mine. A chain with no
        // creator recorded keeps the old assigned_to routing.
        const isChain = (c) => /^Scheduling follow-up/.test(c.note || '');
        // CREATOR ROUTING, generalized (Mark 09-17, the ⏰ New-reminder door:
        // "it lands on the plate of the person who set it"): every HUMAN-set
        // reminder follows its creator, not the relationship holder — the
        // same law the scheduling chains used since the Jack case. Zoho /
        // system rows (no creator) keep holder routing.
        // …and a creator who no longer holds a plate hands the reminder to the
        // relationship holder (seCreatorIsLive — Mark 10-07).
        const mineCommits = (commits || []).filter(c => !c.created_by || c.created_by === effectiveName || !seCreatorIsLive(c.created_by));
        const chains = await fetchAllRows(() => supabaseClient.from('se_commitments')
          .select('id, owner_id, due, note, created_by')
          .eq('status', 'open').eq('created_by', effectiveName)
          .order('id', { ascending: true }));
        const haveCommit = new Set(mineCommits.map(c => c.id));
        const allCommits = mineCommits.concat((chains || []).filter(c => !haveCommit.has(c.id)));
        // Chain targets outside my book (the Jack case) still need their
        // owner row to render the card — fetched as guests, visible ONLY to
        // the scheduling bucket (never reply-due / pick-the-play / ideas:
        // those belong to the relationship holder).
        const haveOwner = new Set((owners || []).map(o => o.id));
        const guestIds = [...new Set(allCommits.filter(c => !haveOwner.has(c.owner_id)).map(c => c.owner_id))];
        let guests = [];
        if (guestIds.length) {
          const { data: g } = await supabaseClient.from('se_owners').select(cols)
            .in('id', guestIds).in('status', ['active', 'unsubscribed']);
          guests = (g || []).map(o => ({ ...o, _schedGuest: true }));
        }
        // Went-quiet guests ride in seOwnersMine too (a row already carried as a
        // scheduling guest is not duplicated); every band but went-quiet
        // filters _wqGuest out at the servable line.
        const guestSet = new Set(guestIds);
        // Latest buyside step per owner (Adam 10-09, Xperts ↔ N2): a deal step recorded after our last
        // email is the conversation moving, so "went quiet" stands down. Best-effort; small set.
        const allRows = (owners || []).concat(guests).concat(wqGuests.filter(o => !guestSet.has(o.id)));
        try {
          const quietIds = allRows.filter(o => o.last_outbound_at).map(o => o.id);
          const lastStep = new Map();
          for (let i = 0; i < quietIds.length; i += 200) {
            const { data: bt } = await supabaseClient.from('se_buyer_touches').select('owner_id, at')
              .in('owner_id', quietIds.slice(i, i + 200)).neq('kind', 'note').order('at', { ascending: false }).limit(1000);
            (bt || []).forEach(t => { if (!lastStep.has(t.owner_id)) lastStep.set(t.owner_id, t.at); });
          }
          allRows.forEach(o => { if (lastStep.has(o.id)) o._lastBuysideAt = lastStep.get(o.id); });
        } catch (_) { /* went-quiet just behaves as before */ }
        if (!cancelled) { setSeOwnersMine(allRows); setSeCommitmentsMine(allCommits); setSeReplyGuests(replyGuests); }
      } catch (e) {
        console.warn('SE serving load skipped (table missing or unreachable):', e?.message || e);
        if (!cancelled) { setSeOwnersMine(null); setSeCommitmentsMine([]); setSeReplyGuests([]); }
      }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, effectiveName, seTick, reloadTick]);

  // ===== Meeting truth (ROADMAP #12, settled 2026-08-06) — booked ≠ held =====
  // se_meetings feeds two consumers: the Committee tab's meeting blocks (all
  // rows) and the "No notes — did this meeting happen?" cards. Grace window
  // is NEXT MORNING (Mark): a meeting cards only once its ET day has fully
  // passed with no Fireflies match, no logged touch, and no stage move.
  // Own effect on the serving pattern — a missing 049 table never breaks
  // My Work or Committee.
  const [seMeetingsAll, setSeMeetingsAll] = useState(null);
  const [meetingTruthRaw, setMeetingTruthRaw] = useState([]);
  const [mtTick, setMtTick] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return;
    (async () => {
      try {
        // holder = the ↷ hand-off override (migration 067); fall back to
        // the bare select until the column exists.
        let rows;
        try {
          rows = await fetchAllRows(() => supabaseClient.from('se_meetings')
            .select('id, calendar_owner, holder, raw, summary, starts_at, ends_at, meeting_type, status, outcome, attendees, external_emails, owner_id, buyer_id, se_buyer_id, valuation_id, match_kind, needs_review, owner:se_owners(id, company_name, contact_name, city, state, sector, industry, business_type, size_revenue, ebitda, net_profit, size_employees, assigned_to, disposition, vt_client_id, tier, last_touch_at)')
            .order('starts_at', { ascending: true }));
        } catch (_) {
          rows = await fetchAllRows(() => supabaseClient.from('se_meetings')
            .select('id, calendar_owner, raw, summary, starts_at, ends_at, meeting_type, status, outcome, attendees, external_emails, owner_id, buyer_id, se_buyer_id, valuation_id, match_kind, needs_review, owner:se_owners(id, company_name, contact_name, city, state, sector, industry, business_type, size_revenue, ebitda, net_profit, size_employees, assigned_to, disposition, vt_client_id, tier, last_touch_at)')
            .order('starts_at', { ascending: true }));
        }
        if (cancelled) return;
        setSeMeetingsAll(rows || []);
        const etDay = (iso) => new Date(iso).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
        const todayET = etDay(new Date().toISOString());
        const cutoff45 = new Date(Date.now() - 45 * 86400000).toISOString();
        // Candidates: matched (unmatched rows belong to the SE confirm queue
        // first), still 'booked', unverified, day fully past, not ancient.
        // Deal-process meetings (listed/engaged businesses — Zac 08-11) are
        // DM-side work: never carded here; the server sweep reclassifies them.
        const cands = (rows || []).filter(mt => mt.status === 'booked' && !mt.outcome && !mt.needs_review
          && !['deal_process', 'buyer_relationship', 'vendor', 'personal'].includes(mt.meeting_type)
          && (mt.owner_id || mt.valuation_id) && mt.starts_at >= cutoff45 && etDay(mt.starts_at) < todayET);
        if (!cands.length) { setMeetingTruthRaw([]); return; }
        // Evidence sweep — DECISION-BEARING activity after the meeting (or a
        // stage move) suppresses the card. Narrowed 08-27 (Mark, the Adam/
        // Genusys case): a bare 'note' touch no longer counts — a note is not
        // an outcome, and the old any-touch test meant doing the OPTIONAL
        // thing (fresh color notes) silently cancelled the prompt for the
        // REQUIRED thing (the pick). Notes ride alongside the card now.
        const ownerIds = [...new Set(cands.map(m => m.owner_id).filter(Boolean))];
        const minStart = cands.reduce((a, m) => (m.starts_at < a ? m.starts_at : a), cands[0].starts_at);
        let touches = [];
        if (ownerIds.length) {
          touches = (await fetchAllRows(() => supabaseClient.from('se_touches')
            .select('owner_id, at, kind').in('owner_id', ownerIds).gt('at', minStart))) || [];
        }
        const valIds = [...new Set(cands.map(m => m.valuation_id).filter(Boolean))];
        const stageById = {};
        if (valIds.length) {
          const { data: vs } = await supabaseClient.from('valuations')
            .select('id, stage_entered_at').in('id', valIds);
          (vs || []).forEach(v => { stageById[v.id] = v.stage_entered_at; });
        }
        const NON_DECISION_TOUCH_KINDS = new Set(['arrival', 'note']);
        const noEvidence = cands.filter(mt => {
          const touched = touches.some(t => t.owner_id === mt.owner_id && t.at > mt.starts_at && !NON_DECISION_TOUCH_KINDS.has(t.kind));
          const staged = mt.valuation_id && stageById[mt.valuation_id] && stageById[mt.valuation_id] > mt.starts_at;
          return !touched && !staged;
        });
        if (!cancelled) setMeetingTruthRaw(noEvidence);
      } catch (e) {
        console.warn('Meeting-truth load skipped (se_meetings missing or unreachable):', e?.message || e);
        if (!cancelled) { setSeMeetingsAll(null); setMeetingTruthRaw([]); }
      }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, mtTick, reloadTick]);

  // Holder derivation, shared by the held-cards and Today's meetings.
  // THE LEAD RULE (Mark 08-31, the KC Heating-Air archaeology): Adam
  // organizes every discovery and since ~08-11 lands on the invite too —
  // but he doesn't ATTEND; the Lead runs it. Which calendar the sync read
  // first decided the card's plate (a coin-flip that favored Adam over
  // Thatcher). So: 2+ internal attendees with exactly ONE Lead → the
  // Lead holds. Explicit ↷ hand-off still outranks everything; the
  // Quandary Mark-fallback stays for the rest.
  const mtDeriveHolder = (mt) => {
    if (mt.holder) return mt.holder;
    // Strategic reviews are set up by Colleen or the Lead, NEVER the AM (Mark
    // 09-17): whoever ORIGINATED it owns it. The organizer on the invite is the
    // reliable originator — calendar_owner is just whichever calendar the sync
    // read first (usually Mark, since he attends). So a review's accountability
    // (the "no notes — did it happen?" card) lands on the person who scheduled it.
    if (mt.meeting_type === 'strategic_review') {
      const org = mt.raw && mt.raw.organizer;
      const email = org && String(org.email || org).toLowerCase();
      if (email && STAFF_DIRECTORY[email]) return STAFF_DIRECTORY[email].name;
      if (mt.calendar_owner) return mt.calendar_owner;   // organizer not staff/unknown → the calendar it lives on
    }
    const internals = (mt.attendees || []).map(a => String((a && a.email) || '').toLowerCase())
      .filter(e => /@vistabusinessgroup\.com$/.test(e));
    if (internals.length >= 2) {
      const leads = [...new Set(internals.filter(e => e.startsWith('zac@') || e.startsWith('thatcher@')))];
      if (leads.length === 1) return leads[0].startsWith('zac@') ? 'Zac' : 'Thatcher';
    }
    return (mt.calendar_owner && mt.calendar_owner !== 'Mark')
      ? mt.calendar_owner
      : ((mt.owner && mt.owner.assigned_to) || mt.calendar_owner || null);
  };

  // 📅 Today's meetings (Adam 08-31: "businesses I'm meeting with that
  // day, so I can add notes right after the call"). Computed from the
  // already-loaded meeting store — matched, booked, mine, today (ET),
  // ordered by start. The Log-outcome button opens the STANDARD outcome
  // modal, so the after-call note carries the strategy pick — and the
  // logged touch pre-empts tomorrow's "did this meeting happen?" card.
  const mtToday = useMemo(() => {
    const etDay = (iso) => new Date(iso).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
    const todayET = etDay(new Date().toISOString());
    // Prep window is TODAY only (Mark 09-17, Zac: "I don't need tomorrow's
    // meetings today"). The card is informational (walk-in prep + an optional
    // log after); it never needs clearing — it just falls off once the day
    // passes.
    // Prep follows WHO'S INVITED, not who the AM/Lead is (Mark 09-17: "the
    // meetings should show based on who is invited, not who the AM or Lead is
    // — they may be in the meeting, but maybe not"). You get a meeting on your
    // prep when your Vista address is on the invite, or you organized it / it
    // was handed to you. So one meeting with two internal attendees (Mark AND
    // Colleen) shows on BOTH plates, independently — no single holder.
    const myEmail = Object.keys(STAFF_DIRECTORY).find(e => STAFF_DIRECTORY[e].name === effectiveName) || null;
    const LEAD_PREP_TYPES = new Set(['strategic_review', 'valuation_meeting', 'discovery']);
    const invited = (mt) => {
      if ((mt.holder || mt.calendar_owner) === effectiveName) return true;   // you organized it / it was handed to you
      if (!myEmail) return false;
      return (mt.attendees || []).some(a => String((a && a.email) || '').toLowerCase() === myEmail);  // your address is on the invite
    };
    // No seller-record requirement (Mark 09-17, Zac's ITOS/Nexus + Peterson-LOI
    // sync): a meeting you're invited to belongs on your prep even when it has
    // no se_owner match — a buyer call, an LOI sync, a deal-process meeting.
    // The card just shows lighter (no owner-derived prep lines) for those.
    return (seMeetingsAll || [])
      .filter(mt => mt.status === 'booked' && etDay(mt.starts_at) === todayET)
      .map(mt => ({ ...mt, _holder: mtDeriveHolder(mt), _day: 'today' }))
      .filter(invited)
      // Adam's tweak (08-31): an AM who BOOKS a discovery lands on the invite
      // but doesn't RUN it — keep those off the AM's prep even though he's
      // technically an attendee. The Lead who runs it still sees it (invited).
      .filter(mt => !(effectiveRole === 'account_manager' && /\bdiscovery\b/i.test(mt.summary || '')))
      // LEADS PREP FOR SELLER MEETINGS ONLY (Zac 09-17: "only want review
      // calls and valuation calls on there"; Mark's call: both Leads, and
      // discovery too). A Lead's recurring buyer / deal syncs — buyside
      // intros, buyer weeklies, deal-process, LOI syncs, unmatched — aren't
      // prep, they're the work itself. AMs keep every invited meeting; the
      // buyer/deal brain is theirs.
      .filter(mt => effectiveRole !== 'lead' || LEAD_PREP_TYPES.has(mt.meeting_type))
      .sort((a, b) => (a.starts_at < b.starts_at ? -1 : 1));
  }, [seMeetingsAll, effectiveName, effectiveRole]);

  // 🧾 Meeting-prep data (Mark 09-16; buyer/deal brain added 09-17 after Zac —
  // 93% of a Lead's meetings are buyer/deal, so the card must carry the BUYER
  // (who they are + BSA/fees) and the DEAL, not just seller prep). Keyed by
  // MEETING id (a buyer/deal meeting has no se_owner). Per meeting we assemble:
  //   val   — the valuation (by valuation_id, else the owner's vt_client_id)
  //   note  — the latest REAL note (system stamps like "Linked to the VT deal"
  //           are filtered — they're not prep, Zac 09-17)
  //   owe   — open seller commitments
  //   buyer — the se_buyer (by se_buyer_id, dm buyer_id, or an invited email):
  //           company · contact · BSA-signed · willing-fees
  // Fireflies notes still load lazily on the card (a click, not every render).
  const [mtPrep, setMtPrep] = useState({});
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    const meetings = mtToday || [];
    if (!meetings.length) { setMtPrep({}); return undefined; }
    (async () => {
      try {
        const prep = {};
        meetings.forEach(m => { prep[m.id] = { note: null, owe: [], val: null, buyer: null }; });

        // Valuations — by direct valuation_id AND by the owner's vt_client_id.
        const valIds = [...new Set(meetings.map(m => m.valuation_id).filter(Boolean))];
        const clientIds = [...new Set(meetings.map(m => m.owner && m.owner.vt_client_id).filter(Boolean))];
        const valSel = 'id, name, client_id, workflow_stage, path, value_provided_low, value_provided_high, discovery_meeting_date, valuation_date, next_meeting_date, next_meeting_type, buyside, owner_first_name, owner_last_name';
        const [vIdRes, vClientRes] = await Promise.all([
          valIds.length ? supabaseClient.from('valuations').select(valSel).in('id', valIds) : Promise.resolve({ data: [] }),
          clientIds.length ? supabaseClient.from('valuations').select(valSel).in('client_id', clientIds) : Promise.resolve({ data: [] }),
        ]);
        const valById = new Map((vIdRes.data || []).map(v => [v.id, v]));
        const valByClient = new Map((vClientRes.data || []).map(v => [v.client_id, v]));

        // Seller touches + commitments (owner-scoped). Real notes only.
        const ownerIds = [...new Set(meetings.map(m => m.owner_id).filter(Boolean))];
        let touches = [], comms = [], webByOwner = new Map();
        if (ownerIds.length) {
          const [tRes, cRes] = await Promise.all([
            supabaseClient.from('se_touches').select('owner_id, at, kind, subject')
              .in('owner_id', ownerIds).in('kind', ['meeting', 'note', 'call'])
              .order('at', { ascending: false }).limit(800),
            supabaseClient.from('se_commitments').select('owner_id, due, note')
              .in('owner_id', ownerIds).eq('status', 'open').order('due', { ascending: true }),
          ]);
          touches = tRes.data || []; comms = cRes.data || [];
          // 🌐 What the owner told us on the website (Mark 10-21, self-booking): a self-booked call comes with no email
          // chain, so the card carries the form itself. Latest website arrival in 120 days.
          try {
            const { data: arr } = await supabaseClient.from('se_touches').select('owner_id, at, meta')
              .in('owner_id', ownerIds).eq('kind', 'arrival').eq('channel', 'website')
              .gte('at', new Date(Date.now() - 120 * 86400000).toISOString()).order('at', { ascending: false }).limit(200);
            webByOwner = new Map(); (arr || []).forEach(t => { if (!webByOwner.has(t.owner_id)) webByOwner.set(t.owner_id, t); });
          } catch (e) { webByOwner = new Map(); }
        }
        const SYSTEM_NOTE = /^(Linked to the VT deal|SE record minted|Meeting on the calendar|Auto-created|First-time meeting|Booked: )/i;
        const realNote = (t) => t && t.kind !== 'arrival' && !SYSTEM_NOTE.test(t.subject || '');

        // Buyers — se_buyers by se_buyer_id, by dm buyer_id, or by an invited email.
        const seBuyerIds = [...new Set(meetings.map(m => m.se_buyer_id).filter(Boolean))];
        const dmBuyerIds = [...new Set(meetings.map(m => m.buyer_id).filter(Boolean))];
        const allEmails = [...new Set(meetings.flatMap(m => (m.external_emails || []).map(e => String(e).toLowerCase())))];
        const bSel = 'id, company_name, contact_name, dm_buyer_id, emails, bsa_signed, willing_buyside_fees, qualifications, grade, buyside_status';
        const bQ = [];
        if (seBuyerIds.length) bQ.push(supabaseClient.from('se_buyers').select(bSel).in('id', seBuyerIds));
        if (dmBuyerIds.length) bQ.push(supabaseClient.from('se_buyers').select(bSel).in('dm_buyer_id', dmBuyerIds));
        for (let i = 0; i < allEmails.length; i += 100) bQ.push(supabaseClient.from('se_buyers').select(bSel).overlaps('emails', allEmails.slice(i, i + 100)));
        const bRes = await Promise.all(bQ);
        const buyerById = new Map(), buyerByDm = new Map(), buyerByEmail = new Map();
        bRes.forEach(r => (r.data || []).forEach(b => {
          buyerById.set(b.id, b);
          if (b.dm_buyer_id) buyerByDm.set(b.dm_buyer_id, b);
          (b.emails || []).forEach(e => buyerByEmail.set(String(e).toLowerCase(), b));
        }));

        meetings.forEach(m => {
          const p = prep[m.id];
          p.val = (m.valuation_id && valById.get(m.valuation_id))
            || (m.owner && m.owner.vt_client_id && valByClient.get(m.owner.vt_client_id)) || null;
          if (m.owner_id) {
            p.note = touches.find(t => t.owner_id === m.owner_id && realNote(t)) || null;
            p.owe = comms.filter(c => c.owner_id === m.owner_id);
            p.web = webByOwner.get(m.owner_id) || null;
            // Self-booked: the booking page's own title says so, or the sync closed an open website request at booking.
            // The website booking pages' own titles (Mark 10-22: Adam's "Vista Intro Call", Zac's "Vista Valuation
            // Meeting"; the "(booked online)" suffix never made it in). Google titles a booking "<page title> (<name>)".
            p.selfBooked = /booked online|^Vista Intro Call\b|^Vista Valuation Meeting\b/i.test(m.summary || '')
              || touches.some(t => t.owner_id === m.owner_id && /^Booked: .*website valuation request/i.test(t.subject || ''));
          }
          let b = (m.se_buyer_id && buyerById.get(m.se_buyer_id)) || (m.buyer_id && buyerByDm.get(m.buyer_id)) || null;
          if (!b) { for (const e of (m.external_emails || [])) { const hit = buyerByEmail.get(String(e).toLowerCase()); if (hit) { b = hit; break; } } }
          p.buyer = b;
        });
        // THE PAIR IS THE RECORD (Adam 09-22, Allevia: he had tied the owner to IT
        // Partners that morning, and the seller-only call's prep card still read
        // "Tie to a buyer" with no buyer shown — the card only knew what the
        // meeting row carried). The owner's latest buyside step (se_buyer_touches)
        // rides on every prep card for that owner: it names the buyer, shows
        // where the deal is, and retires the tie door.
        try {
          const pairOwnerIds = [...new Set(meetings.map(m => m.owner_id).filter(Boolean))];
          if (pairOwnerIds.length) {
            const { data: pt } = await supabaseClient.from('se_buyer_touches')
              .select('owner_id, buyer_id, kind, at')
              .in('owner_id', pairOwnerIds).neq('kind', 'note').order('at', { ascending: false }).limit(400);
            const latestPair = new Map();
            (pt || []).forEach(t => { if (!latestPair.has(t.owner_id)) latestPair.set(t.owner_id, t); });
            const missing = [...new Set([...latestPair.values()].map(t => t.buyer_id).filter(id => id && !buyerById.has(id)))];
            if (missing.length) {
              const { data: more } = await supabaseClient.from('se_buyers').select(bSel).in('id', missing);
              (more || []).forEach(bb => buyerById.set(bb.id, bb));
            }
            meetings.forEach(m => {
              const t = m.owner_id && latestPair.get(m.owner_id);
              if (!t) return;
              const p = prep[m.id];
              p.pair = { kind: t.kind, at: t.at, buyer: buyerById.get(t.buyer_id) || null };
              if (!p.buyer && p.pair.buyer) p.buyer = p.pair.buyer;
            });
          }
        } catch (pe) { /* the pair line is additive — the card renders without it */ }

        // 📋 Discovery answers ON the card (Zac 09-17: "if it could populate
        // their discovery questions as well that you could read on the card").
        // The owner's questionnaire lives in the valuation's data.sellerQA;
        // fetched only for today's DISCOVERY meetings, answered = a non-empty
        // answer (the editor's own test) or a numeric-input value.
        const discIds = [...new Set(meetings.filter(m => m.meeting_type === 'discovery' && prep[m.id].val && prep[m.id].val.id).map(m => prep[m.id].val.id))];
        if (discIds.length) {
          const { data: qaRows } = await supabaseClient.from('valuations').select('id, sellerQA:data->sellerQA').in('id', discIds);
          const qaByVal = new Map((qaRows || []).map(r => [r.id, Array.isArray(r.sellerQA) ? r.sellerQA : []]));
          meetings.forEach(m => {
            const p = prep[m.id];
            if (m.meeting_type !== 'discovery' || !p.val || !qaByVal.has(p.val.id)) return;
            const all = qaByVal.get(p.val.id);
            const fmtNum = (q) => q.numericValue == null ? '' : (q.inputType === 'percent' ? `${q.numericValue}%` : String(q.numericValue));
            const answered = all
              .filter(q => q && (String(q.answer || '').trim() || q.numericValue != null))
              .map(q => ({ id: q.id, question: q.question, section: q.section || '', answer: String(q.answer || '').trim() || fmtNum(q) }));
            p.discoveryQA = { answered, total: all.length };
          });
        }
        if (!cancelled) setMtPrep(prep);
      } catch (e) { if (!cancelled) setMtPrep({}); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, mtToday, reloadTick]);

  // 🗂 Classify cards (Mark 09-01, the holder-card workflow — built the day
  // the 92-card central queue finished its hand cleanup): every synced meeting
  // the matcher couldn't finish now cards its HOLDER's plate the moment it
  // syncs, instead of pooling in the SE page's central queue. One card per
  // RELATIONSHIP (the same external-attendee grouping as the SE confirm
  // queue — a weekly series classifies once, ever). Variant Ⓐ: matched to a
  // business but untypeable — pick the purpose. Variant Ⓑ: nobody on the
  // invite is in SE — add them (seller or buyer) and categorize; the card
  // teaches that a participant added BEFORE booking automates all of this.
  // Variant Ⓒ (Frank & Jean): a buyer-context pick on a seller-only match
  // offers one-click "also add as buyer" — dual roles, never collapsed.
  const mtClassify = useMemo(() => {
    const nowIso = new Date().toISOString();
    const groups = new Map();
    (seMeetingsAll || [])
      .filter(mt => mt.needs_review && mt.status === 'booked')
      .forEach(mt => {
        const key = [...(mt.external_emails || [])].map(e => String(e).toLowerCase()).sort().join(',') || mt.id;
        if (!groups.has(key)) groups.set(key, { key, ids: [], dates: [], rep: null, count: 0 });
        const g = groups.get(key);
        g.ids.push(mt.id); g.dates.push(mt.starts_at); g.count++;
        // Representative = the latest occurrence that has ALREADY HAPPENED
        // (Mark 09-17: classify is retrospective — the card is about the meeting
        // that occurred, so its face is the most recent past instance).
        if (mt.starts_at <= nowIso && (!g.rep || mt.starts_at > g.rep.starts_at)) g.rep = mt;
      });
    return [...groups.values()]
      // Only meetings that have OCCURRED (Mark 09-17): don't ask anyone to
      // classify a meeting before it happens — it might reschedule or cancel,
      // and you can't say what it was until it's done. A recurring series shows
      // once it's had a past instance (g.rep set); a purely-future one-off waits.
      // A save still covers the whole series (all g.ids), future instances included.
      .filter(g => g.rep)
      .map(g => ({ ...g, _holder: mtDeriveHolder(g.rep) }))
      .filter(g => g._holder === effectiveName)
      .sort((a, b) => (a.rep.starts_at < b.rep.starts_at ? -1 : 1));
  }, [seMeetingsAll, effectiveName]);

  // 🤝 Existing-buyer recognition for classify cards (Mark 09-17, Zac's "Tech
  // Clarity Updates" w/ kevin@itpartners.com — already a buyer, IT Partners
  // (US)). The classify card's matched-check only looks at sellside owners, so
  // a meeting with a KNOWN buyer read as "nobody in the system" and Save would
  // have created a DUPLICATE buyer. Look up se_buyers by the unmatched cards'
  // attendee emails so the card can attach to the existing buyer instead of
  // minting a new one. (Owners are already linked server-side via owner_id.)
  const [mtClassifyBuyers, setMtClassifyBuyers] = useState({});
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    const emails = [...new Set((mtClassify || [])
      .filter(c => !(c.rep.owner_id && c.rep.owner))
      .flatMap(c => (c.rep.external_emails || []).map(e => String(e).toLowerCase())))]
      .filter(e => e.includes('@'));
    if (!emails.length) { setMtClassifyBuyers({}); return undefined; }
    (async () => {
      try {
        const { data } = await supabaseClient.from('se_buyers')
          .select('id, company_name, contact_name, emails, buyer_type, dm_buyer_id').overlaps('emails', emails);
        const map = {};
        (data || []).forEach(b => (b.emails || []).forEach(e => {
          const k = String(e).toLowerCase();
          if (emails.includes(k) && !map[k]) map[k] = b;
        }));
        if (!cancelled) setMtClassifyBuyers(map);
      } catch (e) { if (!cancelled) setMtClassifyBuyers({}); }
    })();
    return () => { cancelled = true; };
  }, [mtClassify, supabaseClient]);

  // Holder = whoever was IN the meeting (Quandary 08-12: Zac organized,
  // Adam never attended, yet Adam's book put the card on his plate — he
  // can't answer "did it happen?"). Prefer calendar_owner EXCEPT when it's
  // Mark — the sync's first-calendar-wins dedupe stamps Mark as owner
  // whenever he's merely on the invite, so Mark-owned rows fall back to
  // the relationship holder (assigned_to), the pre-08-12 behavior.
  // The card says what VT already knows (Mark 10-28, TCS: Gabriel declined the 9/30 invite and a 10/28 meeting was
  // already booked, but the card only asked "did it happen?" and Adam left it). _declined = every outside guest
  // declined the invite; _rebooked = the next booked meeting with the same deal/owner, so the card can offer
  // "didn't happen, already rebooked" in one click.
  const meetingTruth = useMemo(() => {
    const isStaff = (e) => /@vistabusinessgroup\.com$/i.test(String(e || ''));
    const declined = (mt) => { const ext = (mt.attendees || []).filter(a => a && a.email && !isStaff(a.email)); return ext.length > 0 && ext.every(a => a.response === 'declined'); };
    const later = (mt) => (seMeetingsAll || []).filter(o => o.id !== mt.id && o.status === 'booked' && o.starts_at > mt.starts_at && !o.outcome && !declined(o)
      && ((mt.valuation_id && o.valuation_id === mt.valuation_id) || (mt.owner_id && o.owner_id === mt.owner_id)))
      .sort((a, b) => a.starts_at.localeCompare(b.starts_at))[0] || null;
    return (meetingTruthRaw || [])
      .map(mt => ({ ...mt, _holder: mtDeriveHolder(mt), _declined: declined(mt), _rebooked: later(mt) }))
      .filter(mt => mt._holder === effectiveName);
  }, [meetingTruthRaw, effectiveName, seMeetingsAll]);

  // ✓ Held — verify the meeting, then (matched owners) log the outcome.
  // Phone-handoff meetings with no Fireflies get counted this way too.
  // VERIFY-ON-SAVE (Adam, day one 08-06: he clicked Held, cancelled the
  // outcome modal to get back to the main screen, and the card was gone —
  // held had already been written). Now nothing writes until the outcome
  // SAVES: cancel = never mind, the card stays for later. Meetings with no
  // owner row have no modal, so they still confirm on click.
  const [mtHeldPending, setMtHeldPending] = useState(null);
  // Buyside meetings never open the SELLSIDE outcome modal (Adam, day one:
  // "This doesn't offer a field for buy-side meetings" — Digital Boardwalk
  // intro). The buyside outcome vocabulary deliberately waits for Zac's
  // mandate blueprint; until then ✓ Held confirms directly with an optional
  // note logged to the owner's history.
  const mtIsBuyside = (mt) => mt.meeting_type === 'buyside_intro' || mt.meeting_type === 'buyside_call';
  // No-forced-outcome types (08-27, Adam's "I won't know the outcome" on
  // Colleen's Logic Technology review call): buyside meetings AND strategic
  // reviews confirm with an optional note only — their real outcomes live
  // in another lane (the mandate machinery / the valuation workflow), and
  // demanding an SE disposition from whoever holds the card forces a pick
  // they can't honestly make.
  const mtNoOutcome = (mt) => mtIsBuyside(mt) || mt.meeting_type === 'strategic_review';
  const seMeetingHeld = async (mt) => {
    if (!supabaseClient) return;
    if (mt.owner && !mtNoOutcome(mt)) {
      setMtHeldPending(mt);
      setSeOutcomeTarget(mt.owner);
      return;
    }
    let note = null;
    if (mt.owner && mtNoOutcome(mt)) {
      if (mt.meeting_type === 'strategic_review') {
        // The review DOES need an outcome (Mark 08-27) — one sentence, from
        // whoever can give it (post-calendar-fix that's Colleen, the person
        // the card reaches). Required like every other exit; what's never
        // demanded is the SE disposition pick — wrong vocabulary for a
        // review call.
        note = window.prompt('Held ✓ — the outcome in one sentence (required): what came of the review, what happens next?\n(e.g. "Staying on cadence — next review Nov" · "Wants to talk listing — flagged to Zac" · "Run by Colleen — outcome in her notes")', '');
        if (note === null) return; // Cancel = never mind, the card stays
        note = note.trim();
        if (!note) { window.alert('The outcome sentence is the record — the card stays until it has one.'); return; }
      } else {
        note = window.prompt('Held ✓ — optional note on how the buyside meeting went (saved to the owner\'s history):', '');
        if (note === null) return; // Cancel = never mind, the card stays
        note = note.trim() || null;
      }
    }
    try {
      const { error } = await supabaseClient.from('se_meetings')
        .update({ outcome: 'held', updated_at: new Date().toISOString() }).eq('id', mt.id);
      if (error) throw error;
      if (mt.owner && note) {
        await supabaseClient.from('se_touches').insert({
          owner_id: mt.owner.id, kind: 'meeting', channel: mtIsBuyside(mt) ? 'buyside' : 'se', actor: effectiveName,
          subject: `${mtIsBuyside(mt) ? 'Buyside meeting' : 'Strategic review'} held — ${note}`.slice(0, 300),
        });
      }
      // Advance the buyside pair automatically (Mark 09-15): a held intro IS
      // the intro_held on the lineage — the funnel shouldn't depend on Adam
      // clicking a second button somewhere else. Only when the meeting is
      // buyer-linked; guard against a double if it was already recorded.
      if (mtIsBuyside(mt) && mt.owner_id && (mt.se_buyer_id || mt.buyer_id)) {
        try {
          // The SE buyer: the meeting's own SE link, else the SE record linked to its DM buyer.
          let seBuyerId = mt.se_buyer_id || null;
          if (!seBuyerId && mt.buyer_id) {
            const { data: sb1 } = await supabaseClient.from('se_buyers').select('id').eq('dm_buyer_id', mt.buyer_id).limit(1);
            seBuyerId = (sb1 && sb1[0] && sb1[0].id) || null;
          }
          if (!seBuyerId) throw new Error('no SE buyer for this meeting');
          const { data: existing } = await supabaseClient.from('se_buyer_touches')
            .select('id').eq('owner_id', mt.owner_id).eq('buyer_id', seBuyerId).eq('kind', 'intro_held').limit(1);
          if (!existing || !existing.length) {
            await supabaseClient.from('se_buyer_touches').insert({
              buyer_id: seBuyerId, owner_id: mt.owner_id, kind: 'intro_held', channel: 'se', actor: effectiveName,
              subject: `Intro held — ${(mt.owner && mt.owner.company_name) || 'business'} (from calendar)`,
            });
          }
        } catch (be) { /* pair advance is best-effort; the meeting is marked held regardless */ }
      }
    } catch (e) { window.alert('Could not mark held: ' + (e?.message || '')); return; }
    setMtTick(t => t + 1);
  };

  // ✓ All held (the grouped card, Mark 09-18: Zac's three NIC meetings were
  // three cards for one question). Regular meetings with an owner: the
  // outcome modal opens ONCE and its save stamps every meeting in the group
  // (mtHeldPending carries the array). Reviews / buyside / no-owner rows
  // take the single path one by one, so each keeps its own prompt.
  const seMeetingHeldAll = async (mts) => {
    if (!supabaseClient || !mts || !mts.length) return;
    // The owner the outcome modal opens for = the latest meeting that has one
    // (a deal-keyed group can span two owner records — NIC / ClearLink).
    const first = [...mts].reverse().find(m => m.owner) || mts[0];
    if (first.owner && !mtNoOutcome(first)) {
      setMtHeldPending(mts);
      setSeOutcomeTarget(first.owner);
      return;
    }
    for (const mt of mts) await seMeetingHeld(mt);
  };

  // Category correction at the confirm moment (Mark 08-12): the metrics
  // are only as good as the type, and the human in the room is looking at
  // the card right now. Recapture re-counts the month automatically.
  const seMeetingSetType = async (mt, type) => {
    if (!supabaseClient || !mt || !type) return;
    try {
      const { error } = await supabaseClient.from('se_meetings')
        .update({ meeting_type: type, updated_at: new Date().toISOString() }).eq('id', mt.id);
      if (error) throw error;
    } catch (e) { window.alert('Could not set the meeting type: ' + (e?.message || '')); return; }
    setMtTick(t => t + 1);
  };

  // ↷ Hand off the held-card (Adam's KC Heating-Air, 08-31: he organized
  // the discovery from his calendar, Thatcher ran it — the card followed
  // calendar_owner onto the wrong plate). One click moves it to whoever
  // was actually in the meeting; the override persists on the row.
  const seMeetingSetHolder = async (mt, name) => {
    if (!supabaseClient || !mt || !name) return;
    try {
      const { error } = await supabaseClient.from('se_meetings')
        .update({ holder: name, updated_at: new Date().toISOString() }).eq('id', mt.id);
      if (error) throw error;
    } catch (e) { window.alert('Could not hand the card off: ' + (e?.message || '') + (/holder/.test(String(e?.message)) ? ' — migration 067 may not be applied yet.' : '')); return; }
    setMtTick(t => t + 1);
  };

  // Save a classify card (holder-card workflow, Mark 09-01). Mirrors the SE
  // page's mt-save semantics: the verdict applies to EVERY occurrence in the
  // relationship group, the owner's meeting clocks stamp right away, and an
  // inline add creates the missing seller/buyer record first. Role-cross
  // (variant Ⓒ) inserts the second-role record linked by owner_id — both
  // roles kept, never collapsed.
  const seMeetingClassify = async (card, opts) => {
    if (!supabaseClient) return;
    const nowIso = new Date().toISOString();
    try {
      let ownerId = card.rep.owner_id || null;
      let buyerId = card.rep.buyer_id || null;
      const emails = (card.rep.external_emails || []).map(e => String(e).toLowerCase());
      // Attach to an EXISTING se_buyer the card recognized by attendee email
      // (Mark 09-17). se_meetings.buyer_id references the DM buyers table, so we
      // only put it there when the se_buyer actually has a DM link — for an
      // SE-only buyer (the common case) the meeting's link to the buyer is
      // recorded on the buyer's SE ledger (se_buyer_touches) below, not here.
      if (opts.attachSeBuyer && opts.attachSeBuyer.dm_buyer_id) buyerId = opts.attachSeBuyer.dm_buyer_id;
      // 🛑 Duplicate guard (Mark 09-17, Blacktip): before creating a NEW
      // seller/buyer, check whether this business is already in the system under
      // a different email — exact-email matching can't catch "blacktip.com" vs
      // "blacktipit.com". If it's there on the SAME side, attach to it and ADD
      // this email to that record instead of spawning a second one; if it's
      // there on the OTHER side, warn before splitting the business in two.
      let skipCreate = false;
      const dupName = (opts.company || '').trim();
      if ((opts.addSide === 'seller' || opts.addSide === 'buyer') && dupName) {
        const norm = s => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '').replace(/(inc|llc|llp|corp|co|ltd|company|corporation|group)$/, '');
        const want = norm(dupName);
        const newEmail = String(opts.email || '').toLowerCase().trim();
        try {
          const [ownRes, buyRes] = await Promise.all([
            supabaseClient.from('se_owners').select('id, company_name, contact_name, emails').ilike('company_name', '%' + dupName + '%').limit(25),
            supabaseClient.from('se_buyers').select('id, company_name, contact_name, emails, dm_buyer_id').ilike('company_name', '%' + dupName + '%').limit(25),
          ]);
          const ownerMatch = (ownRes.data || []).find(o => norm(o.company_name) === want);
          const buyerMatch = (buyRes.data || []).find(b => norm(b.company_name) === want);
          const sameSide = opts.addSide === 'seller' ? ownerMatch : buyerMatch;
          const crossSide = opts.addSide === 'seller' ? buyerMatch : ownerMatch;
          if (sameSide) {
            const already = (sameSide.emails || []).map(e => String(e).toLowerCase());
            const addingEmail = newEmail && !already.includes(newEmail);
            if (window.confirm(`"${sameSide.company_name}" is already in the system as a ${opts.addSide}${sameSide.contact_name ? ` (${sameSide.contact_name})` : ''}.\n\nAttach this meeting to that record${addingEmail ? ` and add ${newEmail} to it` : ''} — instead of creating a duplicate?\n\nOK = attach (no duplicate).   Cancel = create a separate record anyway.`)) {
              if (addingEmail) {
                await supabaseClient.from(opts.addSide === 'seller' ? 'se_owners' : 'se_buyers')
                  .update({ emails: [...new Set([...already, newEmail])] }).eq('id', sameSide.id);
              }
              if (opts.addSide === 'seller') ownerId = sameSide.id;
              else {
                opts.attachSeBuyer = { id: sameSide.id, dm_buyer_id: sameSide.dm_buyer_id || null, name: sameSide.company_name };
                if (opts.attachSeBuyer.dm_buyer_id) buyerId = opts.attachSeBuyer.dm_buyer_id;
              }
              skipCreate = true;
            }
          } else if (crossSide) {
            if (!window.confirm(`Heads up: "${crossSide.company_name}" is already in the system as a ${opts.addSide === 'seller' ? 'buyer' : 'seller'}${crossSide.contact_name ? ` (${crossSide.contact_name})` : ''}.\n\nCreating a new ${opts.addSide} record would split the same business in two. If it's the same one, Cancel and use "Neither — just a meeting" (or classify on the right side).\n\nOK = create the new ${opts.addSide} anyway.   Cancel = stop.`)) {
              return;
            }
          }
        } catch (dupErr) { /* dup-check is best-effort — fall through to create */ }
      }
      if (opts.addSide === 'seller' && !skipCreate) {
        const { data, error } = await supabaseClient.from('se_owners').insert({
          zoho_id: 'se-' + crypto.randomUUID(),
          company_name: opts.company, contact_name: opts.contact || null,
          emails: [...new Set([String(opts.email || '').toLowerCase(), ...emails].filter(e => e.includes('@')))],
          tier: 'responder', status: 'active',
          leadgen_source: 'Meeting capture', captured_at: nowIso.slice(0, 10),
        }).select('id').single();
        if (error) throw error;
        ownerId = data.id;
      } else if (opts.addSide === 'buyer' && !skipCreate) {
        const { data, error } = await supabaseClient.from('se_buyers').insert({
          company_name: opts.company || null, contact_name: opts.contact || null,
          emails: [...new Set([String(opts.email || '').toLowerCase(), ...emails].filter(e => e.includes('@')))],
          buyer_type: opts.buyerType || 'individual', source: 'meeting-capture', status: 'active',
        }).select('id').single();
        if (error) throw error;
        buyerId = data.id;
      }
      if (opts.alsoBuyer && ownerId && card.rep.owner) {
        const { error } = await supabaseClient.from('se_buyers').insert({
          company_name: card.rep.owner.company_name, contact_name: card.rep.owner.contact_name || null,
          emails, buyer_type: 'individual', source: 'role-cross meeting card', status: 'active',
          owner_id: ownerId,
        });
        if (error) window.alert('Meeting saved, but the add-as-buyer failed: ' + error.message);
      }
      const upd = { needs_review: false, meeting_type: opts.type, updated_at: nowIso };
      if (ownerId && !card.rep.owner_id) { upd.owner_id = ownerId; upd.match_kind = 'manual'; }
      if (buyerId && !card.rep.buyer_id) upd.buyer_id = buyerId;
      // "Neither — just a meeting" (Mark 09-17): no party record, but stamp
      // match_kind='manual' so the calendar sync's attendee-memory remembers the
      // verdict and future meetings with the same people don't re-card.
      if (opts.addSide === 'none') upd.match_kind = 'manual';
      // Stamp the se_buyer link (migration 072) so the calendar sync sees it's
      // already handled and never re-records the ledger note.
      if (opts.attachSeBuyer && opts.attachSeBuyer.id) upd.se_buyer_id = opts.attachSeBuyer.id;
      const { error: mErr } = await supabaseClient.from('se_meetings').update(upd).in('id', card.ids);
      if (mErr) throw mErr;
      // Record the meeting on the recognized se_buyer's ledger (Mark 09-17) —
      // this is the buyer link that matters (buyerFollow/board read se_buyer_touches),
      // since se_meetings.buyer_id is DM-scoped and can't hold an SE-only buyer.
      if (opts.attachSeBuyer && opts.attachSeBuyer.id) {
        try {
          await supabaseClient.from('se_buyer_touches').insert({
            buyer_id: opts.attachSeBuyer.id, kind: 'note', channel: 'se', actor: effectiveName,
            subject: `Meeting logged — ${opts.type}${card.rep.summary ? `: ${card.rep.summary}` : ''} (${new Date(card.rep.starts_at).toLocaleDateString()})`,
          });
        } catch (te) { /* the meeting is classified regardless of the ledger note */ }
      }
      if (ownerId) {
        try {
          const pastD = card.dates.filter(d => d && d <= nowIso).sort().pop();
          const futD = card.dates.filter(d => d && d > nowIso).sort()[0];
          const { data: oR } = await supabaseClient.from('se_owners')
            .select('id, last_meeting_at, next_meeting_at').eq('id', ownerId).limit(1);
          const o = oR && oR[0];
          if (o) {
            const clk = {};
            if (pastD && (!o.last_meeting_at || pastD.slice(0, 10) > o.last_meeting_at)) { clk.last_meeting_at = pastD.slice(0, 10); clk.last_meeting_type = opts.type; }
            if (futD && (!o.next_meeting_at || futD.slice(0, 10) < o.next_meeting_at)) { clk.next_meeting_at = futD.slice(0, 10); clk.next_meeting_type = opts.type; }
            if (Object.keys(clk).length) await supabaseClient.from('se_owners').update(clk).eq('id', o.id);
          }
        } catch (_) { /* clocks catch up on the next cron pass */ }
      }
      setMtTick(t => t + 1);
    } catch (e) { window.alert('Classify failed: ' + (e?.message || e)); }
  };
  const seMeetingClassifyDismiss = async (card) => {
    if (!supabaseClient) return;
    try {
      const { error } = await supabaseClient.from('se_meetings')
        .update({ status: 'dismissed', needs_review: false, updated_at: new Date().toISOString() }).in('id', card.ids);
      if (error) throw error;
      setMtTick(t => t + 1);
    } catch (e) { window.alert('Dismiss failed: ' + (e?.message || e)); }
  };
  const seMeetingClassifyHandOff = async (card, name) => {
    if (!supabaseClient || !name) return;
    try {
      const { error } = await supabaseClient.from('se_meetings')
        .update({ holder: name, updated_at: new Date().toISOString() }).in('id', card.ids);
      if (error) throw error;
      setMtTick(t => t + 1);
    } catch (e) { window.alert('Could not hand the card off: ' + (e?.message || e)); }
  };

  // 🤝 Buyside-match data for the serving cards (scenario 3, Mark 09-01).
  // Searches + taxonomy load once per session; each serving refresh scores
  // just the served businesses (a handful × ~2k searches — instant).
  const [seBuysideMatches, setSeBuysideMatches] = useState({});
  const seMatcherRef = useRef(null);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient || !seServing || !seServing.length) return;
    (async () => {
      try {
        if (!seMatcherRef.current) {
          const tax = await fetch('/api/industry-taxonomy').then(r => r.json()).catch(() => null);
          const taxIndex = new Map();
          ((tax && tax.groups) || []).forEach(g => {
            const gTokens = [g.name, ...(g.aliases || [])].map(x => x.toLowerCase());
            const branch = [...gTokens];
            (g.sectors || []).forEach(x => {
              const own = [x.name, ...(x.aliases || [])].map(v => v.toLowerCase());
              branch.push(...own);
              taxIndex.set(x.name.toLowerCase(), [...own, ...gTokens]);
            });
            taxIndex.set(g.name.toLowerCase(), branch);
          });
          const searches = await fetchAllRows(() => supabaseClient.from('se_buyer_searches')
            .select('id, buyer_id, sectors, keywords, geo_states, revenue_min, revenue_max, ebitda_min, ebitda_max, service_level, meta, buyer:se_buyers!inner(id, company_name, contact_name, grade, status, owner_id, bsa_signed, willing_buyside_fees)')
            .eq('status', 'active').eq('buyer.status', 'active').order('id', { ascending: true }));
          const tok = (str, rx) => String(str || '').toLowerCase().split(rx).map(t => t.trim()).filter(t => t.length > 2);
          (searches || []).forEach(s => {
            const sec = tok(s.sectors, /[;,]/);
            s._sec = [...new Set(sec.flatMap(t => [t, ...(taxIndex.get(t) || [])]))];
            s._kw = tok(s.keywords, /[;,]/);
            s._geo = new Set((s.geo_states || []).map(x => String(x).toUpperCase()));
            s._cities = tok(s.meta && s.meta.geo_cities, /[;,]/);
            s._n = (s._sec.length ? 1 : 0) + (s._kw.length ? 1 : 0) + ((s._geo.size || s._cities.length) ? 1 : 0)
              + ((s.revenue_min != null || s.revenue_max != null) ? 1 : 0)
              + ((s.ebitda_min != null || s.ebitda_max != null) ? 1 : 0);
          });
          seMatcherRef.current = (searches || []).filter(s => s._n > 0);
        }
        const ids = [...new Set(seServing.map(o => o.id))];
        const { data: bizRows } = await supabaseClient.from('se_owners')
          .select('id, company_name, sector, state, city, size_revenue, ebitda, keywords, description, last_marketed_at, last_meeting_at, zoho_last_activity')
          .in('id', ids);
        if (cancelled) return;
        const daysAgo = (d) => d ? Math.floor((Date.now() - new Date(d).getTime()) / 86400000) : null;
        const map = {};
        (bizRows || []).forEach(biz => {
          const hits = [];
          for (const s of seMatcherRef.current) {
            const m = seScoreSearch(s, biz);
            if (m && (m.pct >= 60 || (m.condPct === 100 && m.pct >= 50))) hits.push(m);
          }
          hits.sort((a, b) => (b.pct - a.pct) || ((b.s.buyer.grade || 0) - (a.s.buyer.grade || 0)));
          const quiet = Math.min(...[biz.last_marketed_at, biz.last_meeting_at, biz.zoho_last_activity].map(daysAgo).filter(x => x != null).concat([9999]));
          map[biz.id] = {
            count: hits.length,
            best: hits.length ? hits[0].pct : 0,
            // Paper status rides the match (Mark 09-16): a fitting buyer who
            // only SAID they'd pay fees but hasn't signed a BSA can't be
            // introduced — the count shouldn't read as "ready" without saying so.
            unsigned: hits.filter(h => !(h.s.buyer && h.s.buyer.bsa_signed)).length,
            quiet, cooldown: quiet < 90,
            top: hits.slice(0, 5).map(h => {
              const bz = h.s.buyer || {};
              const paper = bz.bsa_signed ? ' · ✒ BSA signed' : (bz.willing_buyside_fees ? ' · 🔒 interested, unsigned' : ' · 🔒 no BSA');
              return `${bz.contact_name || bz.company_name || 'buyer'} — ${h.pct}%${h.s.service_level === 'active_search' ? ' ⭐ active search' : ''}${paper}`;
            }),
          };
        });
        if (!cancelled) setSeBuysideMatches(map);
      } catch (e) { /* chips are optional decoration — never break the plate */ }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, seServing]);

  // ✗ Didn't happen — no_show, then Mark's optional pick (08-06): REBOOK
  // (send the reschedule note now = email 1, cadence chain takes over) or
  // RELEASE ("You didn't make the meeting, please let me know if you'd like
  // to reschedule" — then drop; owner parks until they reach out).
  const seMeetingNoShow = async (mt, action) => {
    if (!supabaseClient) return;
    const nowIso = new Date().toISOString();
    try {
      const { error } = await supabaseClient.from('se_meetings')
        .update({ outcome: 'no_show', updated_at: nowIso }).eq('id', mt.id);
      if (error) throw error;
      if (mt.owner && action === 'rebook') {
        const { data: openC } = await supabaseClient.from('se_commitments')
          .select('id, note').eq('owner_id', mt.owner.id).eq('status', 'open');
        const hasChain = (openC || []).some(c => /^Scheduling follow-up/.test(c.note || ''));
        if (!hasChain) {
          const { error: cErr } = await supabaseClient.from('se_commitments').insert({
            owner_id: mt.owner.id, due: new Date(Date.now() + 86400000).toISOString().slice(0, 10),
            note: 'Scheduling follow-up — rebook after missed meeting (step 2/5). Cadence: 1d → 1d → 7d → 30d.',
            created_by: effectiveName,
          });
          if (cErr) throw cErr;
        }
        await supabaseClient.from('se_touches').insert({
          owner_id: mt.owner.id, kind: 'note', channel: 'se', actor: effectiveName,
          subject: 'Meeting didn’t happen — reschedule note sent, rebook cadence started',
        });
        await supabaseClient.from('se_owners')
          .update({ last_touch_at: nowIso, updated_at: nowIso }).eq('id', mt.owner.id);
      } else if (action === 'rebooked' && mt._rebooked) {
        // Already rebooked: no reschedule email, no cadence. The deal's discovery date follows the new meeting
        // (only when it still names the missed day), so the Committee count and the next card are right.
        const etDay = (iso) => new Date(iso).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
        const newDay = etDay(mt._rebooked.starts_at), oldDay = etDay(mt.starts_at);
        if (mt.valuation_id && mt.meeting_type === 'discovery') {
          await supabaseClient.from('valuations').update({ discovery_meeting_date: newDay })
            .eq('id', mt.valuation_id).eq('discovery_meeting_date', oldDay);
        }
        if (mt.owner) {
          await supabaseClient.from('se_touches').insert({
            owner_id: mt.owner.id, kind: 'note', channel: 'se', actor: effectiveName,
            subject: `Meeting didn’t happen on ${oldDay}${mt._declined ? ' (the owner declined the invite)' : ''}: already rebooked for ${newDay}`,
          });
        }
      } else if (mt.owner && action === 'release') {
        await supabaseClient.from('se_touches').insert({
          owner_id: mt.owner.id, kind: 'note', channel: 'se', actor: effectiveName,
          subject: 'Meeting didn’t happen — asked owner to reschedule, released (owner will reach out)',
        });
        const { data: openC } = await supabaseClient.from('se_commitments')
          .select('id').eq('owner_id', mt.owner.id).eq('status', 'open');
        if ((openC || []).length) {
          await supabaseClient.from('se_commitments')
            .update({ status: 'cancelled' }).in('id', (openC || []).map(c => c.id));
        }
        await supabaseClient.from('se_owners').update({
          disposition: 'owner_reaches_out',
          next_touch_at: new Date(Date.now() + 365 * 86400000).toISOString().slice(0, 10),
          last_touch_at: nowIso, updated_at: nowIso,
        }).eq('id', mt.owner.id);
      }
    } catch (e) { window.alert('Could not record the no-show: ' + (e?.message || '')); return; }
    setMtTick(t => t + 1);
    setSeTick(t => t + 1);
  };

  // ===== Buyside review cards (outline C+M, built 2026-08-07) =====
  // A new/changed buyer search (portal, staff, email) flags needs_review →
  // a card on the reviewer's plate: reviewed-on-the-list · let's-talk (=
  // Zac's vetting stage begins) · not-a-fit-right-now (kept on record) —
  // and an active-search request surfaces loudly. status='review' rows
  // persist as standing vetting cards until accepted or declined. A buyer-
  // retired search cards once for acknowledgement.
  const [buyerReviews, setBuyerReviews] = useState(null);
  const [brTick, setBrTick] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return;
    (async () => {
      try {
        const { data } = await supabaseClient.from('se_buyer_searches')
          .select('id, buyer_id, label, description, sectors, keywords, geo_states, geo_notes, revenue_min, revenue_max, ebitda_min, ebitda_max, service_level, status, assigned_to, created_via, needs_review, created_at, meta, buyer:se_buyers(id, company_name, contact_name, emails, buyer_type, willing_buyside_fees, bsa_signed, meta, source, dm_buyer_id, portal_token, qualifications)')
          .or('needs_review.eq.true,status.eq.review')
          .order('created_at', { ascending: false })
          .limit(200);
        if (!cancelled) setBuyerReviews(data || []);
      } catch (e) {
        console.warn('Buyside review load skipped (migration 058 pending?):', e?.message || e);
        if (!cancelled) setBuyerReviews(null);
      }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, brTick, reloadTick]);

  // ===== ROUTING B–D (BUYSIDE-OUTLINE, Mark's 08-25 "I like what you have,
  // let's run with that"; built 08-27 — supersedes the 08-19 quiet period).
  // Unassigned reviews now route by KIND instead of all parking on Mark:
  //   B — non-active interest → the shared CLAIM POOL (Adam/Zac/Thatcher;
  //       opportunity not obligation; claim = exclusive 7-day hold via
  //       meta.claim; no action in 7 days → back to the pool with an aging
  //       badge; unclaimed ~10 days → one line on Mark's exception radar).
  //   C — active-search requests → no qualification answers yet: SCOTT's
  //       same-day respond-and-ask card; answers on file: cards ZAC
  //       (Thatcher backup) for the 20-minute accept/decline.
  //   D — red wagons (rare ask, warm/valued hit) → route BY THE MATCH,
  //       never rotate: the matched business's relationship holder gets
  //       "buyer in hand — call your owner"; ignored ~3 days → Mark's
  //       radar. No warm hit → stays in Scott's routine SE lane (no card).
  // Mark (owner role) still sees every card, with the radar on top.
  const buysideRouting = useMemo(() => {
    const now = Date.now();
    const CLAIM_DAYS = 7, POOL_RADAR_DAYS = 10, WAGON_RADAR_DAYS = 3;
    const days = (iso) => (now - new Date(iso).getTime()) / 86400000;
    const isPreQualified = (b) => {
      const q = (b && b.qualifications) || {};
      return !!((q.past_acquisitions && (q.past_acquisitions.role || q.past_acquisitions.count != null))
        || q.timeline || q.capital_range || (q.lender && q.lender.type));
    };
    const out = { pool: [], claimedBy: new Map(), scottAsk: [], zacDecide: [], wagons: [], radar: [] };
    for (const s of (buyerReviews || [])) {
      if (s.assigned_to) continue;                       // explicitly held — normal card flow
      if (s.status === 'retired') continue;              // ack cards keep their existing path
      const meta = s.meta || {};
      const im = meta.instant_match || {};
      const ageDays = days(s.created_at);
      // D — wagons first: routing by the match beats every other lane.
      if (meta.red_wagon) {
        const hits = im.full != null ? im.full : (im.strong || 0);
        const rare = hits >= 1 && hits <= 5;             // rarity IS the wagon test
        const warmTop = (im.warm_top || []).filter(h => h && h.id);
        if (rare && warmTop.length && !meta.wagon_handled) {
          const holder = warmTop[0].assigned_to || 'Zac';  // holderless warm hit → the buyside lead
          out.wagons.push({ s, holder, hit: warmTop[0], ageDays });
          if (ageDays > WAGON_RADAR_DAYS) out.radar.push({ kind: 'wagon', s, holder, ageDays });
          continue;
        }
        // No rare+warm hit → Scott's routine lane on the SE page; pre-08-27
        // wagons have no warm_top and deliberately fall through the same way.
        if (s.service_level !== 'active_search') continue;
      }
      // ACTIVE-SEARCH REQUEST → Zac's accept/decline, and ONLY that (Mark
      // 09-16): "the only time Zac gets notified is when someone says they'd
      // like an active search — it doesn't matter how much they filled out."
      // The request signal is the buyer's own retained/active-search box
      // (meta.retained_search_interest), NOT a service_level that can ride in
      // on a Zoho import. A buyer who reviewed their criteria and agreed to
      // buyside fees but did NOT ask for an active search (e.g. Slingshot, an
      // imported service_level) is NOT a card of any kind — the old Scott
      // same-day respond-and-ask lane (routing C) is retired, and these never
      // fall through to the claim pool either.
      if (s.service_level === 'active_search') {
        const bmeta = (s.buyer && s.buyer.meta) || {};
        if (bmeta.retained_search_interest === true) out.zacDecide.push({ s, ageDays });
        continue;
      }
      // B — the pool. A live claim (< 7 days) parks it on the claimer's
      // plate; an expired claim returns it wearing the aging badge.
      const c = meta.claim;
      const claimAge = c && c.at ? days(c.at) : null;
      if (c && c.by && claimAge != null && claimAge < CLAIM_DAYS) {
        const list = out.claimedBy.get(c.by) || [];
        list.push({ s, claim: { ...c, daysLeft: Math.max(0, Math.ceil(CLAIM_DAYS - claimAge)) } });
        out.claimedBy.set(c.by, list);
      } else {
        out.pool.push({ s, ageDays, returned: !!(c && c.by) , returnedBy: c && c.by });
        if (ageDays > POOL_RADAR_DAYS) out.radar.push({ kind: 'pool', s, ageDays });
      }
    }
    return out;
  }, [buyerReviews]);

  // Actionable review cards per viewer: explicitly-held cases (unchanged),
  // plus my live pool claims, plus — for Zac/Thatcher — the pre-qualified
  // active-search decisions (routing C). Owner still sees everything.
  const buyerReviewCards = useMemo(() => {
    const all = (buyerReviews || []).map(s => ({ ...s, _holder: s.assigned_to || 'Mark' }));
    if (effectiveRole === 'owner') return all;
    const mine = all.filter(s => s.assigned_to && s.assigned_to === effectiveName);
    const claimed = (buysideRouting.claimedBy.get(effectiveName) || [])
      .map(({ s, claim }) => ({ ...s, _holder: effectiveName, _claimed: claim }));
    const decide = ['Zac', 'Thatcher'].includes(effectiveName)
      ? buysideRouting.zacDecide.map(({ s }) => ({ ...s, _holder: 'Zac (routing C)', _preQualified: true }))
      : [];
    const seen = new Set();
    return [...mine, ...claimed, ...decide].filter(s => (seen.has(s.id) ? false : (seen.add(s.id), true)));
  }, [buyerReviews, buysideRouting, effectiveName, effectiveRole]);

  // Claim / release / wagon-handled / questions-sent writers — all meta
  // merges that preserve staff keys, each leaving a ledger touch.
  const buysideMetaAct = async (s, patch, subject) => {
    if (!supabaseClient) return;
    try {
      const { error } = await supabaseClient.from('se_buyer_searches')
        .update({ meta: { ...(s.meta || {}), ...patch }, updated_at: new Date().toISOString() }).eq('id', s.id);
      if (error) throw error;
      await supabaseClient.from('se_buyer_touches').insert({
        buyer_id: s.buyer_id, search_id: s.id, kind: 'note', channel: 'se', actor: effectiveName, subject,
      });
    } catch (e) { window.alert('Could not record: ' + (e?.message || '')); return; }
    setBrTick(t => t + 1);
  };
  const buyerClaim = (s) => buysideMetaAct(s, { claim: { by: effectiveName, at: new Date().toISOString() } },
    `Claimed from the buyside pool — ${effectiveName}'s 7-day hold (vetting conversation + tier decision + grade)`);
  const buyerRelease = (s) => buysideMetaAct(s, { claim: null },
    `Released back to the buyside pool by ${effectiveName}`);
  const wagonHandled = (s) => buysideMetaAct(s, { wagon_handled: { by: effectiveName, at: new Date().toISOString() } },
    '🚩 Wagon handled — holder called/decided on the matched owner');
  const scottQualsAsked = (s) => buysideMetaAct(s, { quals_asked_at: new Date().toISOString() },
    'Active-search request answered same-day — qualification questions sent (portal)');

  const buyerReviewAct = async (s, action) => {
    if (!supabaseClient) return;
    if (action === 'release') return buyerRelease(s);   // pool claim handed back early
    const nowIso = new Date().toISOString();
    const upd = { needs_review: false, updated_at: nowIso };
    let subject = '';
    // 'new' AND 'review' both activate (Mark hit the dead end 08-19: a
    // search that entered vetting could never leave — "Reviewed" kept
    // status 'review' forever, 🎯 targets stayed locked out).
    if (action === 'ok') { upd.status = ['new', 'review'].includes(s.status) ? 'active' : s.status; subject = 'Reviewed — on the list (matching runs against it)'; }
    else if (action === 'talk') { upd.status = 'review'; upd.assigned_to = effectiveName; subject = "Let's talk — vetting begun"; }
    else if (action === 'decline') { upd.status = 'declined'; subject = 'Not a good fit right now — kept on record'; }
    else if (action === 'accept') { upd.status = 'active'; upd.assigned_to = s.assigned_to || effectiveName; subject = 'ACTIVE SEARCH accepted — mandate live'; }
    else if (action === 'ack') { subject = 'Acknowledged — buyer retired this search'; }
    try {
      const { error } = await supabaseClient.from('se_buyer_searches').update(upd).eq('id', s.id);
      if (error) throw error;
      await supabaseClient.from('se_buyer_touches').insert({
        buyer_id: s.buyer_id, search_id: s.id, kind: 'note', channel: 'se', actor: effectiveName, subject,
      });
    } catch (e) { window.alert('Could not record: ' + (e?.message || '')); return; }
    setBrTick(t => t + 1);
  };

  // ===== G: shared-with-buyer SLA + post-IOI clocks (outline G, built
  // 2026-08-09; carries N's 24-48h buyer-feedback SLA — "silence = assumed
  // pass, told to the client" — and Mark's lead-by-ignoring post-IOI nag).
  // Pair state = the touch stream per buyer×business (permanent lineage,
  // both sides). Cards: ① a 'shared' with no buyer response after 48h
  // ② an IOI-active pair silent 7+ days. Assumed passes feed I's
  // freshness pass-trigger automatically.
  const [buyerFollow, setBuyerFollow] = useState(null);
  const [bfTick, setBfTick] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return;
    (async () => {
      try {
        const since = new Date(Date.now() - 180 * 86400000).toISOString();
        // channel 'dm' excluded: DM manages its own deal workflow (no card
        // where another tool already reminds) — the imported DM lineage
        // feeds the LOI trigger, never these clocks.
        const { data: touches } = await supabaseClient.from('se_buyer_touches')
          .select('id, buyer_id, search_id, owner_id, at, kind, actor, subject, meta')
          .not('owner_id', 'is', null).neq('channel', 'dm')
          .in('kind', ['matched', 'nda_sent', 'coordinating_meeting', 'shared', 'intro_set', 'intro_held', 'awaiting_docs', 'responded', 'passed', 'owner_withdrew', 'ioi', 'loi', 'closed', 'note'])
          .gte('at', since).order('at', { ascending: true });
        const pairs = new Map();
        (touches || []).forEach(t => {
          const k = t.buyer_id + '|' + t.owner_id;
          const p = pairs.get(k) || { buyer_id: t.buyer_id, owner_id: t.owner_id, touches: [] };
          p.touches.push(t); pairs.set(k, p);
        });
        const list = [...pairs.values()];
        const nameMap = async (table, ids, cols) => {
          const m = new Map();
          for (let i = 0; i < ids.length; i += 200) {
            const { data } = await supabaseClient.from(table).select(cols).in('id', ids.slice(i, i + 200));
            (data || []).forEach(r => m.set(r.id, r));
          }
          return m;
        };
        const [bm, om] = await Promise.all([
          nameMap('se_buyers', [...new Set(list.map(p => p.buyer_id))], 'id, company_name, contact_name, buyer_type, willing_buyside_fees, bsa_signed'),
          nameMap('se_owners', [...new Set(list.map(p => p.owner_id))], 'id, company_name, tier, assigned_to, vt_client_id'),
        ]);
        // "No valuation while a buyside project is open" (Mark 09-29): a discovery / valuation meeting
        // booked on a business whose pair is still live cards the pair holder to record who punted.
        const TERMINAL = ['passed', 'owner_withdrew', 'loi', 'closed'];
        const openOwnerIds = [...new Set(list.filter(p => { const l = p.touches.filter(t => t.kind !== 'note'); const c = l[l.length - 1]; return c && !TERMINAL.includes(c.kind); }).map(p => p.owner_id))];
        const sellMeets = new Map();
        for (let i = 0; i < openOwnerIds.length; i += 100) {
          const { data: ms } = await supabaseClient.from('se_meetings').select('owner_id, starts_at, meeting_type, summary')
            .in('owner_id', openOwnerIds.slice(i, i + 100)).in('meeting_type', ['discovery', 'valuation_meeting']).eq('status', 'booked');
          (ms || []).forEach(m => (sellMeets.get(m.owner_id) || sellMeets.set(m.owner_id, []).get(m.owner_id)).push(m));
        }
        if (!cancelled) setBuyerFollow(list.map(p => ({ ...p, buyer: bm.get(p.buyer_id), owner: om.get(p.owner_id),
          sellMeetings: (sellMeets.get(p.owner_id) || []).filter(m => m.starts_at >= p.touches[0].at) })));
      } catch (e) {
        console.warn('Buyside follow load skipped (migration 058 pending?):', e?.message || e);
        if (!cancelled) setBuyerFollow(null);
      }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, bfTick, reloadTick]);

  const buyerFollowCards = useMemo(() => {
    const now = Date.now();
    const todayIso = new Date().toISOString().slice(0, 10);
    const cards = [];
    (buyerFollow || []).forEach(p => {
      const ts = p.touches;
      const last = ts[ts.length - 1];
      const lastStaff = [...ts].reverse().find(t => t.actor && t.actor !== 'system' && t.actor !== 'buyer');
      const holder = (lastStaff && lastStaff.actor) || (p.owner && p.owner.assigned_to) || 'Zac';
      // 🤙 THE OWNER-PROMISE LOOP (Mark 09-11: "we must say to them we
      // will reach back with a confirmation on X date. Then we have to
      // make sure we reach back to them on that day, even if the buyer
      // decides its not a fit"). A share recorded with promised_owner_by
      // owes the owner an answer ON that date — the card fires from the
      // promise day and clears ONLY when the reach-back is logged. It
      // deliberately survives a pass: "not a fit" is still owed to the
      // owner, on time. Our word is the deliverable.
      const sharedT = [...ts].reverse().find(t => t.kind === 'shared');
      const promise = (sharedT && sharedT.meta && sharedT.meta.promised_owner_by) || null;
      const reachedBack = !promise || ts.some(t => t.at > sharedT.at && t.meta && t.meta.owner_reachback);
      if (promise && !reachedBack && todayIso >= promise) {
        cards.push({ type: 'owner_promise', p, holder, promise,
          overdueDays: Math.max(0, Math.round((now - new Date(promise + 'T00:00:00').getTime()) / 86400000)) });
      }
      // 📄 PRE-IOI — buyer's IN, waiting on the SELLER for documents (Mark
      // 09-15, Dakotech↔Syscom). The real buyside funnel after an intro:
      // buyer reviews basic financials → IOI → LOI, and the wait is on the
      // OWNER to deliver docs — NOT the buyer going silent. This state exists
      // so a live match no longer masquerades as a "buyer went quiet, assume
      // pass" SLA. The clock is the SELLER'S promised doc date (Mark: "a week
      // is arbitrary — it depends what the owner promised"), defaulting to a
      // gentle +7d only if no date was captured. The action is CHASE THE
      // SELLER; recording this state retires the owner's generic auto-watches
      // (below) so it's one reminder, correctly framed, not a duplicate.
      const lineage = ts.filter(t => t.kind !== 'note');
      const curr = lineage.length ? lineage[lineage.length - 1] : null;
      if (curr && !['passed', 'owner_withdrew', 'loi', 'closed'].includes(curr.kind) && (p.sellMeetings || []).length) {
        const m = [...p.sellMeetings].sort((a, b) => a.starts_at.localeCompare(b.starts_at))[0];
        cards.push({ type: 'punt_check', p, holder, meeting: m });
        return;
      }
      if (curr && curr.kind === 'awaiting_docs') {
        const promisedBy = (curr.meta && curr.meta.promised_by) || null;
        const dueIso = promisedBy || new Date(new Date(curr.at).getTime() + 7 * 86400000).toISOString().slice(0, 10);
        if (todayIso >= dueIso) {
          cards.push({ type: 'awaiting_docs', p, holder, promisedBy, dueIso,
            overdueDays: Math.max(0, Math.round((now - new Date(dueIso + 'T00:00:00').getTime()) / 86400000)) });
        }
        return;   // handled by the doc-wait clock — never fall through to the buyer-silence SLA
      }
      // The one-door waiting-states (Mark 09-17, the curated step list): each
      // waits on a named party by a date — "NDA sent, waiting on signature",
      // "coordinating the meeting", or "tied, nothing sent yet". The card fires
      // when that date arrives (promised_by, else a gentle default) so Adam
      // is prompted for the next move instead of having to remember it.
      if (curr && ['nda_sent', 'coordinating_meeting', 'matched'].includes(curr.kind)) {
        const def = curr.kind === 'matched' ? 3 : 5;
        const promisedBy = (curr.meta && curr.meta.promised_by) || null;
        const dueIso = promisedBy || new Date(new Date(curr.at).getTime() + def * 86400000).toISOString().slice(0, 10);
        if (todayIso >= dueIso) {
          cards.push({ type: curr.kind === 'nda_sent' ? 'nda_wait' : curr.kind === 'coordinating_meeting' ? 'coord_wait' : 'matched_next',
            p, holder, promisedBy, dueIso, waitingOn: (curr.meta && curr.meta.waiting_on) || null,
            overdueDays: Math.max(0, Math.round((now - new Date(dueIso + 'T00:00:00').getTime()) / 86400000)) });
        }
        return;   // handled by its own clock — never the buyer-silence SLA
      }
      if (['passed', 'owner_withdrew', 'loi', 'closed'].includes(last.kind)) return;   // pair closed (pass feeds I; owner withdrew = over, buyer not asked; LOI = DM-land; closed = won)
      const ageH = (now - new Date(last.at).getTime()) / 3600000;
      if (last.kind === 'shared') {
        if (promise && !reachedBack) {
          // Promise-calibrated chase: the buyer needs chasing at the
          // HALFWAY mark of the window we gave the owner — not at a flat
          // 48h. If Adam promised Friday, Wednesday is the chase.
          const halfway = new Date(sharedT.at).getTime() + (new Date(promise + 'T23:59:59').getTime() - new Date(sharedT.at).getTime()) / 2;
          if (now >= halfway && todayIso < promise) cards.push({ type: 'sla', p, holder, ageH: Math.floor(ageH), promise });
        } else if (!promise && ageH >= 48) cards.push({ type: 'sla', p, holder, ageH: Math.floor(ageH) });
      }
      else if (ts.some(t => t.kind === 'ioi') && ageH >= 24 * 7) cards.push({ type: 'ioi', p, holder, ageDays: Math.floor(ageH / 24) });
    });
    return cards.filter(c => effectiveRole === 'owner' ? true : c.holder === effectiveName);
  }, [buyerFollow, effectiveName, effectiveRole]);

  // 📊 Per-buyer responsiveness, computed from the lineage the system
  // already keeps (Mark 09-11: pick the promise date from how this buyer
  // ACTUALLY behaves; a slow, pass-everything buyer shows their pattern
  // before we burn another owner promise on them). Median hours from
  // 'shared' to the buyer's first reaction, plus the pass rate.
  const buyerStatsById = useMemo(() => {
    const acc = {};
    (buyerFollow || []).forEach(p => {
      const a = acc[p.buyer_id] = acc[p.buyer_id] || { hours: [], passes: 0, outcomes: 0, shares: 0 };
      const sharedT = p.touches.find(t => t.kind === 'shared');
      if (sharedT) {
        a.shares++;
        const react = p.touches.find(t => t.at > sharedT.at && ['responded', 'intro_set', 'intro_held', 'ioi', 'passed', 'owner_withdrew'].includes(t.kind));
        if (react) a.hours.push((new Date(react.at) - new Date(sharedT.at)) / 3600000);
      }
      const lineage = p.touches.filter(t => t.kind !== 'note');
      const lastK = lineage.length ? lineage[lineage.length - 1].kind : null;
      if (['passed', 'loi', 'ioi', 'intro_held'].includes(lastK)) { a.outcomes++; if (lastK === 'passed') a.passes++; }
    });
    const out = {};
    Object.entries(acc).forEach(([id, a]) => {
      const sorted = [...a.hours].sort((x, y) => x - y);
      out[id] = {
        medianH: sorted.length ? sorted[Math.floor(sorted.length / 2)] : null,
        passPct: a.outcomes >= 2 ? Math.round(100 * a.passes / a.outcomes) : null,
        n: a.shares,
      };
    });
    return out;
  }, [buyerFollow]);

  // 🟣 Buyside under LOI (Closing Engine slice 1, Mark 09-02): live pairs
  // whose latest action is 🏁 LOI — the buyside half of the under-LOI
  // roster. Channel 'dm' (imported history) is already excluded upstream,
  // so every hit here is a real mandate LOI. Feeds the staff-meeting tab's
  // Under LOI section; the weekly snapshot cron adds the commission to the
  // pipeline server-side with the same rule.
  const buysideLoiPairs = useMemo(() => {
    return (buyerFollow || [])
      // Lineage-based, notes ignored (09-11 fix: an "owner told" note after
      // the LOI must not knock a live deal off the under-LOI roster). A
      // 'closed' or 'passed' after the LOI is the real exit.
      .filter(p => {
        const lineage = p.touches.filter(t => t.kind !== 'note');
        return lineage.length && lineage[lineage.length - 1].kind === 'loi';
      })
      .map(p => {
        const loiT = [...p.touches].reverse().find(t => t.kind === 'loi');
        // Credit follows the INTRODUCER (Mark 09-23) — see buysideIntroCredit.
        const credit = buysideIntroCredit(p.touches, p.owner);
        return {
          buyer: p.buyer, owner: p.owner, loiAt: loiT.at,
          estCommission: Number(loiT.meta && loiT.meta.est_commission) || 0,
          holder: credit.name, credit,
        };
      })
      .sort((a, b) => (a.loiAt < b.loiAt ? 1 : -1));
  }, [buyerFollow]);

  // 📋 THE BUYSIDE BOARD (Mark 09-04, as Adam's first pair batch landed:
  // "not a to-do section, but a here is what's happening section"). Every
  // OPEN pair — latest lineage action isn't a pass — with stage, last
  // movement, and next booked meeting: the ambient glance. The clock cards
  // above it stay the to-dos; the board never asks for anything. Holder
  // sees their own pairs; the owner sees everyone's with a holder column.
  const buysideBoard = useMemo(() => {
    const STAGE = {
      shared: ['📤 Shared', 'bg-sky-100 text-sky-800'],
      responded: ['💬 Responded', 'bg-teal-100 text-teal-800'],
      intro_set: ['🤝 Intro set', 'bg-indigo-100 text-indigo-800'],
      intro_held: ['🤝 Intro held', 'bg-indigo-100 text-indigo-800'],
      awaiting_docs: ['📄 Awaiting docs', 'bg-amber-100 text-amber-800'],
      // The one-door states (Mark 09-17): every real buyside path has a home.
      matched: ['🔗 Matched', 'bg-gray-100 text-gray-700'],
      nda_sent: ['📝 NDA sent', 'bg-amber-100 text-amber-800'],
      coordinating_meeting: ['📅 Coordinating meeting', 'bg-sky-100 text-sky-800'],
      ioi: ['📄 IOI', 'bg-violet-100 text-violet-800'],
      loi: ['🏁 LOI', 'bg-emerald-100 text-emerald-800'],
      owner_withdrew: ['🚪 Owner backed out', 'bg-gray-100 text-gray-600'],
    };
    const now = Date.now();
    const rows = (buyerFollow || []).map(p => {
      const lineage = p.touches.filter(t => t.kind !== 'note');
      if (!lineage.length) return null;
      const last = lineage[lineage.length - 1];
      if (last.kind === 'passed' || last.kind === 'owner_withdrew' || last.kind === 'closed') return null;   // failure (either side) and SUCCESS all exit the board
      const lastAny = p.touches[p.touches.length - 1];
      const lastStaff = [...p.touches].reverse().find(t => t.actor && t.actor !== 'system' && t.actor !== 'buyer');
      const holder = (lastStaff && lastStaff.actor) || (p.owner && p.owner.assigned_to) || 'Zac';
      const mt = (seMeetingsAll || []).find(m => m.status === 'booked' && m.starts_at && new Date(m.starts_at).getTime() > now
        && (m.buyer_id === p.buyer_id || (m.owner_id === p.owner_id && /buyside/.test(m.meeting_type || ''))));
      // 🤙 pending owner-promise (Mark 09-11) + the buyer's track record —
      // both ride the row so the glance shows our word and their pattern.
      const sharedT = [...p.touches].reverse().find(t => t.kind === 'shared');
      const promise = (sharedT && sharedT.meta && sharedT.meta.promised_owner_by) || null;
      const reachedBack = !promise || p.touches.some(t => t.at > sharedT.at && t.meta && t.meta.owner_reachback);
      return {
        p, holder, credit: buysideIntroCredit(p.touches, p.owner),
        stage: STAGE[last.kind] || [last.kind, 'bg-gray-100 text-gray-700'],
        stageAt: last.at, lastAt: lastAny.at, lastSubject: lastAny.subject || '',
        quietDays: Math.floor((now - new Date(lastAny.at).getTime()) / 86400000),
        nextMeeting: mt ? { at: mt.starts_at, summary: mt.summary } : null,
        ownerPromise: promise && !reachedBack ? promise : null,
        buyerStats: buyerStatsById[p.buyer_id] || null,
      };
    }).filter(Boolean);
    rows.sort((a, b) => (a.lastAt < b.lastAt ? 1 : -1));
    return rows.filter(r => effectiveRole === 'owner' ? true : r.holder === effectiveName);
  }, [buyerFollow, seMeetingsAll, effectiveName, effectiveRole, buyerStatsById]);

  // ─── Closing Engine slice 3: the MOVEMENT DETECTOR (Mark 09-02) ───
  // Weekly both-sides movement per under-LOI deal, computed from what the
  // system already watches: milestone checkoffs (closing plans), meetings
  // held, and vault mail in both directions. A side quiet ≥7 business-ish
  // days ambers; ≥14 reds (req ②). The synthesis (req ④ — awareness ≠
  // alarm): quiet × pace-overrun compresses into ONE escalation card for
  // Mark + Zac (req ③), and the card demands a STALL REASON (req ⑦) —
  // recorded as an amendment on the plan, so the why travels with the deal.
  const [cpPlansAll, setCpPlansAll] = useState(null);
  const [cpPlansTick, setCpPlansTick] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    (async () => {
      try {
        const { data, error } = await supabaseClient.from('closing_plans').select('*').limit(500);
        if (error) throw error;
        if (!cancelled) setCpPlansAll(data || []);
      } catch (e) { if (!cancelled) setCpPlansAll(null); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, cpPlansTick, reloadTick]);

  const [closingHealth, setClosingHealth] = useState({});
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    (async () => {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const days = (d) => d ? Math.floor((Date.now() - new Date(d.length === 10 ? d + 'T12:00:00' : d).getTime()) / 86400000) : null;
        const ssRows = (Array.isArray(dmListings) ? dmListings : []).filter(r => r.status === 'Under LOI');
        const bsRows = buysideLoiPairs || [];
        if (!ssRows.length && !bsRows.length) { if (!cancelled) setClosingHealth({}); return; }
        // vista_id → SE owner for the sellside deals (mail + meetings live there)
        const vistas = ssRows.map(r => String(r.vista_id || '').trim()).filter(Boolean);
        let ownerByVista = new Map();
        if (vistas.length) {
          const { data: cls } = await supabaseClient.from('clients').select('id, vista_id').in('vista_id', vistas);
          const clientIds = (cls || []).map(c => c.id);
          const vistaByClient = new Map((cls || []).map(c => [c.id, String(c.vista_id).trim()]));
          if (clientIds.length) {
            const { data: os } = await supabaseClient.from('se_owners').select('id, vt_client_id').in('vt_client_id', clientIds);
            (os || []).forEach(o => { const v = vistaByClient.get(o.vt_client_id); if (v) ownerByVista.set(v, o.id); });
          }
        }
        const ownerIds = [...new Set([...ownerByVista.values(), ...bsRows.map(p => p.owner && p.owner.id).filter(Boolean)])];
        const buyerIds = [...new Set(bsRows.map(p => p.buyer && p.buyer.id).filter(Boolean))];
        const since = new Date(Date.now() - 45 * 86400000).toISOString();
        let mailRows = [];
        if (ownerIds.length) {
          const { data: m1 } = await supabaseClient.from('se_emails')
            .select('owner_id, direction, sent_at').in('owner_id', ownerIds).gte('sent_at', since).limit(2000);
          mailRows = m1 || [];
        }
        let buyerMail = [];
        if (buyerIds.length) {
          const { data: m2 } = await supabaseClient.from('se_emails')
            .select('se_buyer_id, direction, sent_at').in('se_buyer_id', buyerIds).gte('sent_at', since).limit(1000);
          buyerMail = m2 || [];
        }
        const lastMeetingByOwner = new Map();
        (seMeetingsAll || []).forEach(mt => {
          if (!mt.owner_id || mt.status !== 'booked' || mt.starts_at > new Date().toISOString()) return;
          if (mt.outcome === 'no_show') return;
          const cur = lastMeetingByOwner.get(mt.owner_id);
          if (!cur || mt.starts_at > cur) lastMeetingByOwner.set(mt.owner_id, mt.starts_at);
        });
        const planFor = (dealKey) => (cpPlansAll || []).find(p => (p._key || (p.side === 'sellside' ? 'ss|' + p.vista_id : 'bs|' + p.buyer_id + '|' + p.owner_id)) === dealKey);
        const sideMoves = (plan, sideRe) => {
          let last = null;
          ((plan && plan.milestones) || []).forEach(m => {
            if (m.done_at && sideRe.test(m.owner || '') && (!last || m.done_at > last)) last = m.done_at;
          });
          return last;
        };
        const latest = (...ds) => ds.filter(Boolean).sort().pop() || null;
        const stallInfo = (plan) => {
          const s = [...((plan && plan.amendments) || [])].reverse().find(a => a.kind === 'stall_reason');
          return s ? { reason: s.reason, at: s.at, by: s.by } : null;
        };
        const health = {};
        const compute = (dealKey, name, ownerId, buyerId, loiDate, extraBuyerLast, holder) => {
          const plan = planFor(dealKey);
          const inbound = mailRows.filter(r => r.owner_id === ownerId && r.direction === 'inbound').map(r => r.sent_at).sort().pop();
          const meeting = ownerId ? lastMeetingByOwner.get(ownerId) : null;
          const bMail = buyerId ? buyerMail.filter(r => r.se_buyer_id === buyerId && r.direction === 'inbound').map(r => r.sent_at).sort().pop() : null;
          const floor = loiDate || null; // a fresh LOI isn't stalled
          const lastSeller = latest(inbound, meeting, sideMoves(plan, /Seller/), floor);
          const lastBuyer = latest(meeting, bMail, extraBuyerLast, sideMoves(plan, /Buyer|Lender/), floor);
          const qS = days(lastSeller), qB = days(lastBuyer);
          const worst = Math.max(qS == null ? 99 : qS, qB == null ? 99 : qB);
          const pace = plan ? cpPace(plan) : null;
          const level = worst >= 14 ? 'red' : worst >= 7 ? 'amber' : 'green';
          health[dealKey] = {
            key: dealKey, name, plan, level, qSeller: qS, qBuyer: qB,
            behindBd: pace ? pace.behindBd : 0, honestClose: pace ? pace.honestClose : null,
            stall: stallInfo(plan),
            // Who owns the deal — so a Lead sees only their own sliding closings
            // while Zac (quarterback) + Mark (oversight) see them all.
            holder: holder || null,
            // The stage the deal is heading into (next incomplete critical
            // milestone + due) — shown on the slip card and the staff-meeting row.
            nextStage: plan ? cpNextStage(plan) : null,
            escalate: level === 'red' || (level === 'amber' && pace && pace.behindBd > 0),
          };
        };
        ssRows.forEach(r => compute('ss|' + String(r.vista_id || '').trim(), r.name, ownerByVista.get(String(r.vista_id || '').trim()) || null, null, r.signed_loi_date, undefined, r.lead || r.account_manager || null));
        bsRows.forEach(p => compute('bs|' + (p.buyer && p.buyer.id) + '|' + (p.owner && p.owner.id),
          `${(p.owner && p.owner.company_name) || 'Business'} ← ${(p.buyer && (p.buyer.contact_name || p.buyer.company_name)) || 'buyer'}`,
          p.owner && p.owner.id, p.buyer && p.buyer.id, p.loiAt && p.loiAt.slice(0, 10), p.loiAt, p.holder));
        // Sold together: the follower shows its partner's movement and never escalates on its own; the partner's
        // card names it, so one plan update covers both.
        Object.values(health).forEach(h => {
          const v = cpSoldWith(h.plan); const lead = v && health['ss|' + v];
          if (!lead || lead === h) return;
          Object.assign(h, { level: lead.level, qSeller: lead.qSeller, qBuyer: lead.qBuyer, behindBd: lead.behindBd,
            honestClose: lead.honestClose, nextStage: lead.nextStage, escalate: false, soldWith: lead.name });
          lead.alsoCloses = [...(lead.alsoCloses || []), h.name];
        });
        if (!cancelled) setClosingHealth(health);
      } catch (e) { console.warn('Closing movement detector skipped:', e?.message || e); if (!cancelled) setClosingHealth({}); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, dmListings, buysideLoiPairs, seMeetingsAll, cpPlansAll]);

  // 📮 Staged cadence sends (slice 5): the sweep drafts, a human sends.
  const [stagedSends, setStagedSends] = useState(null);
  const [stagedTick, setStagedTick] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    (async () => {
      try {
        const { data, error } = await supabaseClient.from('pending_sends')
          .select('*').eq('status', 'pending').order('staged_at', { ascending: true }).limit(300);   // 300: Scott's freshness batch (≤50) + cadence drafts
        if (error) throw error;
        // Hide staged sends whose meeting has already passed (Mark 09-16): the
        // agenda is moot once the meeting is behind us. The server sweep
        // discards these; this filter drops any not yet pruned so a stale draft
        // never sits on the plate.
        const todayIso = new Date().toISOString().slice(0, 10);
        if (!cancelled) setStagedSends((data || []).filter(s => !s.meeting_date || s.meeting_date >= todayIso));
      } catch (e) { if (!cancelled) setStagedSends(null); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, stagedTick, reloadTick]);
  const stagedSendCards = useMemo(() => {
    const engageCut = new Date(Date.now() - 4 * 86400000).toISOString();
    return (stagedSends || [])
      .filter(s => s.kind !== 'linkedin_engage' || (s.staged_at || '') >= engageCut)   // a like + repost ask is stale after 4 days
      // Mark has his own 🏁 listing-ended copy, so like the engage asks he doesn't also see Zac's and Colleen's.
      .filter(s => (effectiveRole === 'owner' && s.kind !== 'linkedin_engage' && s.kind !== 'listing_ended' && s.kind !== 'email_bounced') ? true : s.holder === effectiveName);
  }, [stagedSends, effectiveRole, effectiveName]);
  const stagedSendAct = async (row, action) => {
    if (!supabaseClient) return;
    try {
      if (action === 'discard') {
        const { error } = await supabaseClient.from('pending_sends')
          .update({ status: 'discarded' }).eq('id', row.id);
        if (error) throw error;
      } else if (action === 'done') {
        const { error } = await supabaseClient.from('pending_sends')
          .update({ status: 'sent', sent_at: new Date().toISOString(), sent_by: userEmail || null }).eq('id', row.id);
        if (error) throw error;
      } else {
        const { data: { session } } = await supabaseClient.auth.getSession();
        const at = session && session.access_token;
        if (!at) throw new Error('Session expired — reload and sign in again.');
        const r = await fetch('/api/closing/send-staged', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
          body: JSON.stringify({ id: row.id }),
        });
        const d = await r.json();
        if (!r.ok || !d.ok) throw new Error(d.error || ('HTTP ' + r.status));
        window.alert('✓ Sent from your mailbox to: ' + d.to);
      }
      setStagedTick(t => t + 1);
    } catch (e) { window.alert('Failed: ' + (e?.message || e)); }
  };

  // 📣 LinkedIn (Mark 10-21): Scott posted the drafted post on the Vista company page → his card closes with the post's
  // link, and everyone else gets a 30-second like + repost card (LinkedIn can't be automated; this puts the ask in front
  // of them).
  const LINKEDIN_TEAM = ['Mark', 'Zac', 'Thatcher', 'Adam', 'Konnie', 'Colleen', 'Scott'];
  const linkedInPosted = async (row, url) => {
    if (!supabaseClient) return;
    try {
      const { error } = await supabaseClient.from('pending_sends')
        .update({ status: 'sent', sent_at: new Date().toISOString(), sent_by: userEmail || null, meta: { ...(row.meta || {}), post_url: url } }).eq('id', row.id);
      if (error) throw error;
      const others = LINKEDIN_TEAM.filter(n => n !== effectiveName);
      const { error: e2 } = await supabaseClient.from('pending_sends').insert(others.map(n => ({
        kind: 'linkedin_engage', holder: n, to_emails: '', subject: 'Like + repost the new Vista post', body_html: '',
        meta: { post_url: url, title: (row.meta && row.meta.title) || null, posted_by: effectiveName || null },
      })));
      if (e2) throw e2;
      window.alert('✓ Done. ' + others.length + ' teammates now have a 30-second like + repost card.');
      setStagedTick(t => t + 1);
    } catch (e) { window.alert('Failed: ' + (e?.message || e)); }
  };

  // 👋 Contact gone → Sold / closed (Mark 10-21): the owner's auto-reply says they left or retired and the business
  // sold. Same disposition as logging 'sold elsewhere': out of every list and the rotation.
  // 📪 Bounce card (step 2, Mark 10-27): the server flagged the address and staged this; the AM's choice is step 1's
  // three-way window. The card closes when a choice is saved; "Decide later" leaves it on the plate.
  const openBounceCard = async (row) => {
    if (!supabaseClient) return;
    const m = row.meta || {};
    try {
      const { data: ow, error } = await supabaseClient.from('se_owners').select('id, company_name, contact_name, phone, emails, next_touch_at').eq('id', m.owner_id).maybeSingle();
      if (error) throw error;
      if (!ow) { window.alert('That business is no longer in Sales Engine.'); return; }
      const { data: openRows } = await supabaseClient.from('se_commitments').select('id, created_by').eq('owner_id', ow.id).eq('status', 'open');
      setSeBounceChoice({ owner: ow, addr: m.addr, openIds: (openRows || []).filter(c => seRetirableBy(c, effectiveName)).map(c => c.id), cardRow: row });
    } catch (e) { window.alert('Could not open it: ' + (e?.message || '')); }
  };
  const contactGoneSold = async (row) => {
    if (!supabaseClient) return;
    const m = row.meta || {};
    try {
      const { error } = await supabaseClient.from('se_owners').update({ disposition: 'sold_elsewhere', updated_at: new Date().toISOString() }).eq('id', m.owner_id);
      if (error) throw error;
      await supabaseClient.from('se_touches').insert({ owner_id: m.owner_id, kind: 'note', channel: 'se', actor: effectiveName || null,
        subject: 'Marked sold / closed from a contact-gone auto-reply (' + (m.from || '') + '): “' + String(m.text || '').slice(0, 160) + '”' });
      const { error: e2 } = await supabaseClient.from('pending_sends').update({ status: 'sent', sent_at: new Date().toISOString(), sent_by: userEmail || null }).eq('id', row.id);
      if (e2) throw e2;
      setStagedTick(t => t + 1);
    } catch (e) { window.alert('Failed: ' + (e?.message || e)); }
  };

  // 🔄 Freshness batch (Mark 10-21): send the checked asks one by one from the caller's mailbox, then ONE summary.
  const stagedSendBulk = async (rows) => {
    if (!supabaseClient || !rows.length) return;
    const { data: { session } } = await supabaseClient.auth.getSession();
    const at = session && session.access_token;
    if (!at) { window.alert('Session expired — reload and sign in again.'); return; }
    let sent = 0; const failed = [];
    for (const row of rows) {
      try {
        const r = await fetch('/api/closing/send-staged', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
          body: JSON.stringify({ id: row.id }),
        });
        const d = await r.json();
        if (!r.ok || !d.ok) throw new Error(d.error || ('HTTP ' + r.status));
        sent++;
      } catch (e) { failed.push(((row.meta && (row.meta.company || row.meta.contact)) || row.to_emails) + ': ' + (e?.message || e)); }
    }
    window.alert(`✓ ${sent} sent from your mailbox.` + (failed.length ? `\n\n${failed.length} not sent:\n` + failed.slice(0, 8).join('\n') : ''));
    setStagedTick(t => t + 1);
  };

  // Escalation cards — the ONE card per sliding deal (Mark 09-15: Zac is the
  // closing quarterback and sees EVERY sliding deal firm-wide; Mark sees them
  // all as oversight; every other Lead now sees only the deals THEY own, so a
  // Lead like Thatcher is no longer blind to his own slipping closings — the
  // sliding alarm was Zac+Mark-only before). Redundancy guard: if this person
  // already has a pending staged cadence send for the deal, that send is the
  // action in this window (it carries the "N days behind" message), so the slip
  // card yields rather than double-nudging the same actor (notification rule).
  const closingEscalations = useMemo(() => {
    // Zac 10-29: "Community Systems isn't my opportunity. Shouldn't be on my card." Zac now sees his own, like every
    // Lead (the deal's own Lead still gets the card; Mark keeps the firm-wide view; the Staff Meeting tab shows all).
    const isAll = effectiveRole === 'owner';
    if (!(isAll || effectiveRole === 'lead')) return [];
    const myPendingPlans = new Set((stagedSends || [])
      .filter(s => s.holder === effectiveName && s.plan_id).map(s => s.plan_id));
    return Object.values(closingHealth)
      .filter(h => h.escalate)
      .filter(h => isAll || h.holder === effectiveName)
      .filter(h => !(h.plan && myPendingPlans.has(h.plan.id)))
      .sort((a, b) => (b.behindBd - a.behindBd) || (Math.max(b.qSeller || 0, b.qBuyer || 0) - Math.max(a.qSeller || 0, a.qBuyer || 0)));
  }, [closingHealth, effectiveRole, effectiveName, stagedSends]);
  const closingStallSave = async (h, reason, note) => {
    if (!supabaseClient) return;
    if (!h.plan) { window.alert('This deal has no closing plan yet — open 📋 Plan on the Staff Meeting tab first; the stall reason lives on the plan.'); return; }
    try {
      const amendments = [...(h.plan.amendments || []), { at: new Date().toISOString(), by: effectiveName || null, kind: 'stall_reason', reason, note: note || null }];
      const { error } = await supabaseClient.from('closing_plans').update({ amendments, updated_at: new Date().toISOString() }).eq('id', h.plan.id);
      if (error) throw error;
      setCpPlansTick(t => t + 1);
    } catch (e) { window.alert('Could not record the stall reason: ' + (e?.message || e)); }
  };

  // ===== The invite check (Mark 08-10, found verifying the first real wave
  // response: Scott logs a meeting → instant AM handoff, but NOTHING
  // verified the real Google invite ever got sent — meeting-truth can only
  // doubt meetings the calendar knows about). An open first-time-meeting
  // commitment near its date with NO matched calendar event for that owner
  // cards the BOOKER (created_by). The card clears itself the moment the
  // hourly :20 sync sees the event — no action buttons needed.
  const [inviteChecks, setInviteChecks] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return;
    (async () => {
      try {
        const today = new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
        const lo = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
        // Callback requests stay until the call is logged (below) — reach back further for them.
        const loCallback = new Date(Date.now() - 60 * 86400000).toISOString().slice(0, 10);
        const hi = new Date(Date.now() + 1 * 86400000).toISOString().slice(0, 10);
        const { data: comms } = await supabaseClient.from('se_commitments')
          .select('id, owner_id, due, note, created_by, created_at')
          .eq('status', 'open').ilike('note', 'First-time meeting%')
          .gte('due', loCallback).lte('due', hi);
        if (!comms || !comms.length) { if (!cancelled) setInviteChecks([]); return; }
        const ownerIds = [...new Set(comms.map(c => c.owner_id))];
        const [{ data: meets }, { data: owners }] = await Promise.all([
          supabaseClient.from('se_meetings')
            .select('owner_id, starts_at, status').in('owner_id', ownerIds).neq('status', 'cancelled'),
          supabaseClient.from('se_owners').select('id, company_name, contact_name').in('id', ownerIds),
        ]);
        const nameOf = new Map((owners || []).map(o => [o.id, o]));
        const LIVE_CALL_RX = /\b(transferred|transfer(red)?\s+live|live\s+(call|transfer)|called\s+in|on\s+the\s+phone)\b/i;
        // 📞 Callback requests (Mark 10-14, Vector Automation): the owner said "call me", Scott asked the AM to
        // call. Not a booked meeting — the card stays on SCOTT (he's the one who remembers) until the AM LOGS
        // the call (a 'call' touch by anyone but the booker, after it was logged) — that's the handoff. No call
        // logged → Scott checks with the AM: called → remind him to log it; not yet → nudge him; owner not
        // answering → Scott chases the owner. Stays up past the usual 7-day window until it's resolved.
        // + text / email requests (Mark 10-28, Electro Surface "text him", Cityscape "I prefer emails"): = server SE_CALLBACK_RX.
        const CALLBACK_RX = /\b(call me|give me a call|give (him|her) a call|call (him|her) (at|back)|call ?back|reach me at|call at|my cell|speak|talk|text (me|him|her)|send (me |him |her )?a text|prefers? (to )?(email|text)|emails? over|email me|by email|via email)\b/i;
        const EMAIL_REQ_RX = /\b(prefers? (to )?email|emails? over|email me|by email|via email)\b/i;
        // An owner who gives a number is asking for a call (Eliasen CPA 10-14: "speak… on my cell 508-…").
        const NOTE_PHONE_RX = /\(?[2-9]\d{2}\)?[\s.-]?\d{3}[\s.-]?\d{4}\b/;
        const isCallback = (c) => CALLBACK_RX.test(c.note || '') || NOTE_PHONE_RX.test(c.note || '');
        const cbOwners = [...new Set(comms.filter(isCallback).map(c => c.owner_id))];
        const { data: cbTouches } = cbOwners.length
          ? await supabaseClient.from('se_touches').select('owner_id, at, kind, actor, subject')
            .in('owner_id', cbOwners).gte('at', loCallback).in('kind', ['call', 'note']).order('at', { ascending: false })
          : { data: [] };
        // What the AM and the owner have EMAILED since the request (Vector, 10-14: Adam left a voicemail and
        // emailed within the hour but never logged the call — the card has to show that, or Scott chases the
        // wrong person). Shown, not cleared on: the handoff is still the AM's logged call.
        const { data: cbEmails } = cbOwners.length
          ? await supabaseClient.from('se_emails').select('owner_id, sent_at, mailbox, direction, from_email, snippet')
            .in('owner_id', cbOwners).gte('sent_at', loCallback).order('sent_at', { ascending: false })
          : { data: [] };
        const cards = comms.filter(c => {
          if (isCallback(c)) {
            const after = (t) => t.owner_id === c.owner_id && c.created_at && t.at > c.created_at;
            return !(cbTouches || []).some(t => after(t) && t.kind === 'call' && t.actor && t.actor !== c.created_by);
          }
          if (c.due < lo) return false;   // the usual 7-day window for booked meetings
          // a live call never gets an invite (Scott 10-12) — only when the meeting IS the day it was logged; a call-in
          // that BOOKED a later meeting still needs its invite.
          if (LIVE_CALL_RX.test(c.note || '') && c.created_at && c.due <= new Date(c.created_at).toLocaleDateString('en-CA', { timeZone: 'America/New_York' })) return false;
          const dueT = new Date(c.due + 'T00:00:00').getTime();
          return !(meets || []).some(m => m.owner_id === c.owner_id
            && Math.abs(new Date(m.starts_at).getTime() - dueT) < 2.5 * 86400000);
        }).map(c => ({
          ...c, owner: nameOf.get(c.owner_id),
          am: (String(c.note).match(/^First-time meeting with ([\w.]+)/) || [])[1] || null,
          overdue: c.due < today,
          holder: c.created_by || 'Scott',
          callback: isCallback(c),
          // Scott's latest chase note, so a card that stays up shows where it stands.
          lastChase: isCallback(c) ? (cbTouches || []).find(t => t.owner_id === c.owner_id && t.kind === 'note' && /^📞 Callback chase/.test(t.subject || '')) || null : null,
          ...(isCallback(c) ? (() => {
            const am = ((String(c.note).match(/^First-time meeting with ([\w.]+)/) || [])[1] || '').toLowerCase();
            const mine = (cbEmails || []).filter(e => e.owner_id === c.owner_id && c.created_at && e.sent_at > c.created_at);
            // newest first: the AM's own outbound email, and the owner's newest reply
            const amEmail = am ? mine.find(e => e.direction === 'outbound' && String(e.from_email || '').toLowerCase().startsWith(am)) || null : null;
            const ownerReply = mine.find(e => e.direction === 'inbound' && !/@vistabusinessgroup\.com$/i.test(e.from_email || '')) || null;
            return { amEmail, ownerReply };
          })() : {}),
          // What the owner asked for, in their words (the note after the dash, minus the "(set by …)" tag).
          request: String(c.note || '').replace(/^First-time meeting with [\w.]+\s*[—-]\s*/, '').replace(/\s*\(set by [^)]*\)\s*$/, '').trim() || null,
          emailRequest: EMAIL_REQ_RX.test(c.note || ''),
        // The owner asked for email and the AM emailed them: that IS the contact (= server first-meeting sweep).
        })).filter(c => !(c.callback && c.emailRequest && c.amEmail));
        if (!cancelled) setInviteChecks(cards);
      } catch (e) {
        console.warn('Invite check skipped:', e?.message || e);
        if (!cancelled) setInviteChecks(null);
      }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, reloadTick]);
  // 📞 Live call (Scott 10-12): the invite check's commitment is done — log it on the owner, drop the card.
  const inviteLiveCall = async (c) => {
    if (!supabaseClient || !c || !c.id) return;
    try {
      const { error } = await supabaseClient.from('se_commitments').update({ status: 'done', done_at: new Date().toISOString() }).eq('id', c.id);
      if (error) throw error;
      await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: 'note', channel: 'se', actor: effectiveName || 'staff',
        subject: '📞 Live call — no calendar invite needed (first-time meeting ' + c.due + (c.am ? ' with ' + c.am : '') + ')' });
    } catch (e) { window.alert('Could not clear it: ' + (e?.message || '')); return; }
    setInviteChecks(list => (list || []).filter(x => x.id !== c.id));
  };
  // 📞 Callback chase (Mark 10-14): Scott's two moves while the AM hasn't logged the call — logged on the owner
  // and shown on the card; the card itself stays until the AM logs the call.
  const inviteCallbackChase = async (c, which) => {
    if (!supabaseClient || !c || !c.owner_id) return;
    const am = c.am || 'the AM';
    const subject = which === 'owner'
      ? `📞 Callback chase — owner not answering; ${effectiveName || 'Scott'} chasing the owner`
      : `📞 Callback chase — nudged ${am} to call (or to log the call if it happened)`;
    try {
      const { error } = await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: 'note', channel: 'se', actor: effectiveName || 'staff', subject });
      if (error) throw error;
    } catch (e) { window.alert('Could not log it: ' + (e?.message || '')); return; }
    setInviteChecks(list => (list || []).map(x => x.id === c.id ? { ...x, lastChase: { at: new Date().toISOString(), subject } } : x));
  };
  const inviteCheckCards = useMemo(() =>
    (inviteChecks || []).filter(c => effectiveRole === 'owner' ? true : c.holder === effectiveName),
  [inviteChecks, effectiveName, effectiveRole]);
  // 📲 THE AM'S SIDE OF A HANDOFF (Mark 10-28: Scott's Electro Surface card waited days on Adam, and Mark forwarded the
  // morning email to him because nothing was on Adam's own plate). The owner asked Scott for a call / text / email
  // from the AM: the AM sees the ask, in the owner's words, with one click per way of reaching them.
  const amHandoffCards = useMemo(() =>
    (inviteChecks || []).filter(c => c.callback && c.am && String(c.am).toLowerCase() === String(effectiveName || '').toLowerCase()
      && c.holder !== effectiveName),
  [inviteChecks, effectiveName]);
  // ✓ Called / Texted / Emailed: logged on the owner (a 'call' touch for a call or text: the handoff rule) and the
  // reminder closes, so Scott's card and the morning email clear with it.
  const amHandoffDone = async (c, how) => {
    if (!supabaseClient || !c || !c.id) return;
    const verb = { called: 'Called', texted: 'Texted', emailed: 'Emailed' }[how] || 'Contacted';
    try {
      const { error } = await supabaseClient.from('se_commitments').update({ status: 'done', done_at: new Date().toISOString() }).eq('id', c.id);
      if (error) throw error;
      await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: how === 'emailed' ? 'note' : 'call', channel: 'se', actor: effectiveName || 'staff',
        subject: `📲 ${verb} the owner, as they asked ${c.created_by || 'Scott'} on ${c.created_at ? new Date(c.created_at).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }) : c.due}` });
    } catch (e) { window.alert('Could not record it: ' + (e?.message || '')); return; }
    setInviteChecks(list => (list || []).filter(x => x.id !== c.id));
  };

  // Every action writes BOTH ledgers: the buyer's (with owner lineage) and
  // the business's history (kind 'buyside').
  // A recorded buyside step IS the reply (Adam 09-29, RAM; again 10-02 RAM + Allevia): any open
  // "Awaiting reply" auto-watch on the owner is answered — retire it. Shared by every door that records a
  // step (pair-card buttons AND the step picker); before 10-05 only the picker did it, so "🤝 Intro set"
  // on a pair card saved the step but left the watch card up — it looked like nothing happened.
  const retireReplyWatch = async (ownerId, stepLabel) => {
    try {
      const { data: watches } = await supabaseClient.from('se_commitments').select('id')
        .eq('owner_id', ownerId).eq('status', 'open').like('note', 'Awaiting reply — auto-watch%');
      if (watches && watches.length) {
        await supabaseClient.from('se_commitments').update({ status: 'done', done_at: new Date().toISOString() }).in('id', watches.map(w => w.id));
        await supabaseClient.from('se_touches').insert({
          owner_id: ownerId, kind: 'note', channel: 'se', actor: 'system',
          subject: `⏳ reply-watch retired — buyside step recorded (${stepLabel}); the deal moving is the reply`,
        });
      }
    } catch (we) { /* best-effort — the step itself is recorded */ }
    // …and the OVERDUE reminders a person set on this owner (Adam 10-16, ASI Networks: his 9-24 reminder
    // "call with ITPartners", due 10-8, kept carding after he recorded the pair step "Shared with buyer").
    // Once the pair moves, it has its own clocks (shared → 48h buyer SLA, IOI silence, …), so a promise that
    // was already due is answered by the step. Future-dated reminders stay: those are new intentions.
    try {
      const todayIso = new Date().toISOString().slice(0, 10);
      const { data: due } = await supabaseClient.from('se_commitments').select('id, note, due')
        .eq('owner_id', ownerId).eq('status', 'open').lte('due', todayIso);
      const mine = (due || []).filter(c => !/^Awaiting reply — auto-watch/.test(String(c.note || '')));
      if (mine.length) {
        await supabaseClient.from('se_commitments').update({ status: 'done', done_at: new Date().toISOString() }).in('id', mine.map(c => c.id));
        await supabaseClient.from('se_touches').insert({
          owner_id: ownerId, kind: 'note', channel: 'se', actor: 'system',
          subject: `⏰ ${mine.length === 1 ? `reminder "${String(mine[0].note || 'Reach out').slice(0, 60)}" (due ${mine[0].due})` : `${mine.length} overdue reminders`} closed — buyside step recorded (${stepLabel}); the pair's own clocks take over`,
        });
      }
    } catch (we) { /* best-effort */ }
  };
  const buyerFollowAct = async (card, action) => {
    if (!supabaseClient) return;
    const p = card.p;
    const buyerName = (p.buyer && (p.buyer.company_name || p.buyer.contact_name)) || 'the buyer';
    const bizName = (p.owner && p.owner.company_name) || 'the business';
    // 🤝 Credit override (Mark 09-23): who made the introduction, by hand,
    // with a reason. Recorded as a 'note' so it never touches the lineage.
    if (action === 'credit') {
      const cur = buysideIntroCredit(p.touches || [], p.owner);
      const who = window.prompt(`${bizName} × ${buyerName}: who made the introduction to our buyside client?\n\nCredit currently: ${cur.name} (${BUYSIDE_CREDIT_WHY[cur.source] || cur.source}). Type the first name exactly as it appears in the tool.`, cur.name || '');
      if (who === null) return;
      const name = (who || '').trim();
      if (!name) return;
      const why = window.prompt(`One line on why ${name} gets the credit (required — it travels with the record):`);
      if (why === null) return;
      if (!(why || '').trim()) { window.alert('The reason is required.'); return; }
      try {
        const { error } = await supabaseClient.from('se_buyer_touches').insert({
          buyer_id: p.buyer_id, owner_id: p.owner_id, kind: 'note', channel: 'se', actor: effectiveName,
          subject: `🤝 Buyside credit set to ${name} — ${why.trim()}`,
          meta: { credit_to: name, credit_reason: why.trim(), credit_prev: cur.name, credit_prev_source: cur.source },
        });
        if (error) throw error;
        await supabaseClient.from('se_touches').insert({
          owner_id: p.owner_id, kind: 'buyside', channel: 'se', actor: effectiveName,
          subject: `🤝 Buyside credit for ${buyerName} set to ${name} — ${why.trim()}`,
        });
      } catch (e) { window.alert('Could not record the credit: ' + (e?.message || '')); return; }
      setSeTick(t => t + 1);
      return;
    }
    const A = {
      pass: { kind: 'passed', bSub: `Assumed pass — no feedback inside the 24–48h SLA on ${bizName} (owner to be told)`, oSub: `Buyer assumed passed after silence (SLA): ${buyerName}` },
      responded: { kind: 'responded', bSub: `Buyer responded on ${bizName}`, oSub: `Buyer responded: ${buyerName}` },
      intro: { kind: 'intro_set', bSub: `Introduction set — ${bizName}`, oSub: `Buyer introduction set: ${buyerName}` },
      intro_held: { kind: 'intro_held', bSub: `Intro held — ${buyerName} & ${bizName} met`, oSub: `Buyside intro held with ${buyerName}` },
      awaiting_docs: { kind: 'awaiting_docs', bSub: `Buyer reviewing — awaiting documents from the owner (${bizName})`, oSub: `Buyer reviewing financials — awaiting docs from owner (buyside: ${buyerName})` },
      ioi: { kind: 'ioi', bSub: `IOI received — ${bizName}`, oSub: `IOI received from buyer: ${buyerName}` },
      moving: { kind: 'note', bSub: `IOI check-in — still moving (${bizName})`, oSub: `IOI check-in — still moving: ${buyerName}` },
      owner_told: { kind: 'note', bSub: `Owner reach-back done on time — ${bizName} told where things stand`, oSub: `Promise kept: owner told where things stand with ${buyerName}` },
      loi: { kind: 'loi', bSub: `LOI — ${bizName}`, oSub: `LOI with buyer: ${buyerName}` },
      dead: { kind: 'passed', bSub: `Post-IOI died — ${bizName}`, oSub: `Post-IOI died: ${buyerName}` },
      // 🎉 The success exit (Mark 09-11: every failure had a verb, the one
      // outcome we most want recorded had no button). Retires the pair
      // from the board with the final commission on the lineage.
      closed_won: { kind: 'closed', bSub: `🎉 CLOSED — ${bizName} sold to ${buyerName}`, oSub: `🎉 Business SOLD to buyside client ${buyerName}` },
      fell_through: { kind: 'passed', bSub: `LOI fell through — ${bizName}`, oSub: `LOI fell through: ${buyerName}` },
    }[action];
    if (!A) return;
    // 🏁 LOI asks the money question at the moment of record (slice 1,
    // Mark 09-02): the estimated buyside commission rides the LOI touch's
    // meta and flows into the commission pipeline + the staff-meeting
    // Under LOI section. Cancel = record the LOI with $0 (fix later by
    // re-recording); blank is allowed the same way.
    const touchMeta = {};
    if (action === 'owner_told') {
      const note = window.prompt(`${bizName}: confirm you reached back to the owner (call or email — even a "not a fit" counts, ON the promised day).\n\nOne line on what you told them (optional):`);
      if (note === null) return;
      touchMeta.owner_reachback = true;
      if ((note || '').trim()) touchMeta.note = note.trim();
    }
    if (action === 'loi') {
      const raw = window.prompt(`Estimated Vista commission on this buyside close (${buyerName} × ${bizName})?\n\nNumbers only, e.g. 250000 — it joins the commission pipeline and the staff-meeting Under LOI section.`, '');
      const n = Number(String(raw || '').replace(/[$,\s]/g, ''));
      if (raw !== null && !isNaN(n) && n > 0) touchMeta.est_commission = n;
    }
    if (action === 'closed_won') {
      const raw = window.prompt(`🎉 ${bizName} → ${buyerName}: the deal CLOSED.\n\nFinal Vista commission (numbers only, e.g. 250000 — recorded on the lineage; the pair retires from the board and the under-LOI roster):`, '');
      if (raw === null) return;
      const n = Number(String(raw || '').replace(/[$,\s]/g, ''));
      if (!isNaN(n) && n > 0) touchMeta.final_commission = n;
    }
    if (action === 'fell_through') {
      const why = window.prompt(`${bizName} × ${buyerName}: the LOI fell through — one line on why (travels with the record):`);
      if (why === null) return;
      if ((why || '').trim()) touchMeta.note = why.trim();
    }
    if (action === 'awaiting_docs') {
      const raw = window.prompt(`${bizName}: buyer's in and reviewing — we're waiting on the OWNER for documents.\n\nWhat date did the owner promise the docs by? (YYYY-MM-DD — the reminder to chase them keys off this date; leave blank for a gentle 7-day nudge)`, '');
      if (raw === null) return;
      const d = (raw || '').trim();
      if (d) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(d) || isNaN(new Date(d + 'T00:00:00').getTime())) { window.alert('Use YYYY-MM-DD (e.g. 2026-09-25), or leave blank.'); return; }
        touchMeta.promised_by = d;
      }
    }
    // 💲 The offer price on the card buttons too (same ask as the step picker, buysideAskPrice).
    let priceTail = '';
    if (action === 'ioi' || action === 'loi') {
      const pr = buysideAskPrice(action === 'ioi' ? 'IOI' : 'LOI', buyerName, bizName);
      if (pr) { touchMeta.price_low = pr.price_low; touchMeta.price_high = pr.price_high; priceTail = ` (${pr.label})`; }
    }
    try {
      const { error } = await supabaseClient.from('se_buyer_touches').insert({
        buyer_id: p.buyer_id, owner_id: p.owner_id, kind: A.kind, channel: 'se', actor: effectiveName, subject: A.bSub + priceTail,
        ...(Object.keys(touchMeta).length ? { meta: touchMeta } : {}),
      });
      if (error) throw error;
      await supabaseClient.from('se_touches').insert({
        owner_id: p.owner_id, kind: 'buyside', channel: 'se', actor: effectiveName, subject: A.oSub + priceTail,
      });
      if (A.kind !== 'passed') await retireReplyWatch(p.owner_id, A.oSub);   // a buyer pass isn't the owner replying
      // Dedup (Mark 09-15): reframing this as a buyside doc-wait REPLACES the
      // owner's generic "waiting on their reply / pick the play" auto-watches
      // — otherwise the seller gets chased twice for the same docs, once
      // correctly (this card) and once mislabeled. Retire the owner's open
      // commitments due on/before the doc-promise horizon (future deliberate
      // ones survive); log the handoff. Mirrors seRemindMe's stacked cleanup.
      if (action === 'awaiting_docs') {
        try {
          const horizon = touchMeta.promised_by || new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
          const { data: openC } = await supabaseClient.from('se_commitments')
            .select('id').eq('owner_id', p.owner_id).eq('status', 'open').lte('due', horizon);
          if (openC && openC.length) {
            await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).in('id', openC.map(c => c.id));
            await supabaseClient.from('se_touches').insert({
              owner_id: p.owner_id, kind: 'note', channel: 'se', actor: effectiveName,
              subject: `Doc-chase now tracked on the buyside pair (${buyerName})${touchMeta.promised_by ? ` — owner promised docs by ${touchMeta.promised_by}` : ''}; retired ${openC.length} generic reminder${openC.length === 1 ? '' : 's'}`,
            });
          }
        } catch (de) { /* dedup is best-effort — the pair touch already landed */ }
      }
    } catch (e) { window.alert('Could not record: ' + (e?.message || '')); return; }
    setBfTick(t => t + 1);
  };

  // ➕ THE ONE DOOR (Mark 09-17, the Ignition × IT Partners case): tie a
  // business owner to an existing buyside client from the plate — owner +
  // buyer + "where is it right now" — and the Buyside Engine takes over (the
  // board + the clock cards). Covers both paths: the owner who emailed and is
  // off-plate (Noam), and the meeting path (the prep card pre-fills the
  // owner). Every later move is the same picker from the board row / clock
  // card. Writes both ledgers exactly like buyerFollowAct.
  const [buysideNewOpen, setBuysideNewOpen] = useState(false);
  const [buysideNewPrefill, setBuysideNewPrefill] = useState(null);
  // Rank type-ahead hits so the exact name wins (Adam 09-17: "Ignition" never
  // made the list — an unordered limit(8) on '%ignition%' returned Kansas
  // Ignition Interlock, Guardian Ignition Interlock Manufacturing… and cut the
  // two records actually NAMED Ignition). Exact → starts-with → contains, then
  // the live relationship (client / responder / warm) above cold shells, then
  // A–Z. Fetch wide, rank, then trim.
  const rankHits = (rows, q, nameOf) => {
    const s = String(q || '').trim().toLowerCase();
    const TIER = { client: 0, responder: 1, warm: 1, active: 1, cold: 3 };
    const score = (r) => { const n = String(nameOf(r) || '').toLowerCase(); return n === s ? 0 : n.startsWith(s) ? 1 : 2; };
    return [...rows].sort((a, b) => (score(a) - score(b))
      || ((TIER[a.tier] ?? 2) - (TIER[b.tier] ?? 2))
      || String(nameOf(a) || '').localeCompare(String(nameOf(b) || '')));
  };
  const buysideSearchOwners = async (q) => {
    const s = String(q || '').trim();
    if (s.length < 2 || !supabaseClient) return [];
    const { data } = await supabaseClient.from('se_owners').select('id, company_name, contact_name, city, state, tier, assigned_to')
      .ilike('company_name', `%${s.replace(/[%,()]/g, ' ')}%`).limit(40);
    return rankHits(data || [], s, r => r.company_name).slice(0, 12);
  };
  const buysideSearchBuyers = async (q) => {
    const s = String(q || '').trim();
    if (s.length < 2 || !supabaseClient) return [];
    const clean = s.replace(/[%,()]/g, ' ');
    const { data } = await supabaseClient.from('se_buyers')
      .select('id, company_name, contact_name, buyer_type, bsa_signed, willing_buyside_fees, buyside_status')
      .or(`company_name.ilike.%${clean}%,contact_name.ilike.%${clean}%`).eq('status', 'active').limit(40);
    return rankHits(data || [], s, r => r.company_name || r.contact_name).slice(0, 12);
  };
  const buysidePairRecord = async ({ owner, buyer, step }) => {
    if (!supabaseClient || !owner || !buyer || !step) return false;
    const S = BUYSIDE_STEPS.find(s => s.kind === step.kind) || { label: step.kind };
    const buyerName = buyer.company_name || buyer.contact_name || 'buyer';
    const bizName = owner.company_name || 'business';
    const meta = { manual: true, step: step.kind };
    if (step.waitingOn) meta.waiting_on = step.waitingOn;
    if (step.byDate) meta.promised_by = step.byDate;
    // LOI via the step picker (tie / ⟳ Record the next step / board) asks the same money question as
    // the 🏁 LOI card button (Mark 09-30: Zac records from SE → Log outcome, which skipped it).
    // Cancel or blank = recorded with no figure, same as the card.
    let priceTail = '';
    if (step.kind === 'ioi' || step.kind === 'loi') {
      const pr = buysideAskPrice(step.kind === 'ioi' ? 'IOI' : 'LOI', buyerName, bizName);
      if (pr) { meta.price_low = pr.price_low; meta.price_high = pr.price_high; priceTail = ` (${pr.label})`; }
    }
    if (step.kind === 'loi') {
      const raw = window.prompt(`Estimated Vista commission on this buyside close (${buyerName} × ${bizName})?\n\nNumbers only, e.g. 250000 — it joins the commission pipeline and the staff-meeting Under LOI section.`, '');
      const n = Number(String(raw || '').replace(/[$,\s]/g, ''));
      if (raw !== null && !isNaN(n) && n > 0) meta.est_commission = n;
    }
    const tail = step.waitingOn ? ` — waiting on ${step.waitingOn}${step.byDate ? ` by ${step.byDate}` : ''}` : (step.byDate ? ` — by ${step.byDate}` : '');
    try {
      const { error } = await supabaseClient.from('se_buyer_touches').insert({
        buyer_id: buyer.id, owner_id: owner.id, kind: step.kind, channel: 'se', actor: effectiveName,
        subject: `${S.label}${priceTail} — ${bizName}${tail}`, meta,
      });
      if (error) throw error;
      await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'buyside', channel: 'se', actor: effectiveName,
        subject: `Buyside (${buyerName}): ${S.label}${priceTail}${tail}`,
      });
      // The deal moved, so the conversation happened (Adam 09-29, RAM) — shared rule, see retireReplyWatch.
      await retireReplyWatch(owner.id, S.label);
    } catch (e) { window.alert('Could not record the buyside step: ' + (e?.message || '')); return false; }
    setBfTick(t => t + 1);
    return true;
  };
  const buysideStepFor = (p, step) => buysidePairRecord({ owner: p.owner || { id: p.owner_id }, buyer: p.buyer || { id: p.buyer_id }, step });
  // ✒ Mark BSA signed (Mark 09-17): bsa_signed was a Zoho-import-only column
  // nothing in-app could set, so the intro gate keyed on a flag nobody could
  // clear. Stamps the date for provenance and logs it on the buyer's ledger.
  const buysideMarkBsaSigned = async (buyer) => {
    if (!supabaseClient || !buyer || !buyer.id) return false;
    const raw = window.prompt(`${buyer.company_name || buyer.contact_name || 'This buyer'}: mark the buyside agreement (BSA) as SIGNED.\n\nSigned date (YYYY-MM-DD):`, new Date().toISOString().slice(0, 10));
    if (raw === null) return false;
    const d = (raw || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d) || isNaN(new Date(d + 'T00:00:00').getTime())) { window.alert('Use YYYY-MM-DD (e.g. 2026-09-17).'); return false; }
    try {
      const { error } = await supabaseClient.from('se_buyers').update({ bsa_signed: true, bsa_signed_date: d, updated_at: new Date().toISOString() }).eq('id', buyer.id);
      if (error) throw error;
      await supabaseClient.from('se_buyer_touches').insert({ buyer_id: buyer.id, kind: 'note', channel: 'se', actor: effectiveName, subject: `✒ BSA marked signed (${d}) — intro gate cleared` });
    } catch (e) { window.alert('Could not mark the BSA signed: ' + (e?.message || '')); return false; }
    setBfTick(t => t + 1);
    return true;
  };
  // ⏰ REMINDERS YOU SET — for staff without an SE plate (Colleen, Konnie;
  // Colleen 10-07). Only reminders THEY created, due today or earlier, with
  // the owner's contact on the card. ✓ Done / ⏰ new date / ✕ Drop.
  const [seMyReminders, setSeMyReminders] = useState([]);
  const [myRemTick, setMyRemTick] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const nm = effectiveName || '';
    if (!supabaseClient || !nm || SE_PLATE_HOLDERS.includes(nm) || !SE_REMINDER_KEEPERS.includes(nm)) { setSeMyReminders([]); return; }
    (async () => {
      try {
        const todayIso = new Date().toISOString().slice(0, 10);
        const { data, error } = await supabaseClient.from('se_commitments')
          .select('id, owner_id, due, note, created_at, se_owners(id, company_name, contact_name, phone, emails, assigned_to, last_outbound_at, last_touch_at, last_meeting_at)')
          .eq('status', 'open').eq('created_by', nm).lte('due', todayIso).order('due', { ascending: true }).limit(200);
        if (error) throw error;
        if (!cancelled) setSeMyReminders((data || []).filter(c => c.se_owners));
      } catch (e) { if (!cancelled) setSeMyReminders([]); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, effectiveName, reloadTick, myRemTick]);
  const myReminderAct = async (c, act) => {
    if (!supabaseClient || !c) return;
    const co = (c.se_owners && c.se_owners.company_name) || 'this business';
    const nowIso = new Date().toISOString();
    try {
      if (act === 'done') {
        const what = window.prompt(`${co}: what happened? (one line — saved to the record)`, '');
        if (what === null) return;
        if (!what.trim()) { window.alert('One line on what happened, please.'); return; }
        await supabaseClient.from('se_commitments').update({ status: 'done', done_at: nowIso }).eq('id', c.id);
        await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: 'note', channel: 'se', actor: effectiveName, subject: `✓ Reminder done — ${what.trim()}`.slice(0, 180) });
      } else if (act === 'later') {
        const d = new Date(); d.setDate(d.getDate() + 30);
        const due = window.prompt(`${co}: new date (YYYY-MM-DD)?`, d.toISOString().slice(0, 10));
        if (due === null) return;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(due.trim()) || due.trim() <= nowIso.slice(0, 10)) { window.alert('Pick a future date as YYYY-MM-DD.'); return; }
        const why = window.prompt('Why this date / what happens then?', c.note || '');
        if (why === null) return;
        const { error } = await supabaseClient.from('se_commitments').insert({ owner_id: c.owner_id, due: due.trim(), note: (why.trim() || c.note || 'Reach out'), created_by: effectiveName });
        if (error) throw error;
        await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).eq('id', c.id);
        await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: 'note', channel: 'se', actor: effectiveName, subject: `⏰ Reminder moved to ${due.trim()} — ${why.trim() || c.note || ''}`.slice(0, 180) });
      } else if (act === 'handoff') {
        // OVERSIGHT reminders (Mark 10-07): Colleen often sets one to make sure
        // the holder follows up. ↪ puts a card on the holder's plate today with
        // her note, and closes hers.
        const HAND_TO = ['Adam', 'Thatcher', 'Zac'];
        const dflt = (c.se_owners && HAND_TO.includes(c.se_owners.assigned_to)) ? c.se_owners.assigned_to : 'Adam';
        const pick = window.prompt(`${co}: hand this to whom? (Adam, Thatcher or Zac)`, dflt);
        if (pick === null) return;
        const holder = HAND_TO.find(n => n.toLowerCase() === pick.trim().toLowerCase());
        if (!holder) { window.alert('Type Adam, Thatcher or Zac.'); return; }
        const msg = window.prompt(`${co}: hand this to ${holder} — it lands on their My Work today. Your note to them:`, c.note || 'Please follow up');
        if (msg === null) return;
        const { error } = await supabaseClient.from('se_commitments').insert({ owner_id: c.owner_id, due: nowIso.slice(0, 10), note: `From ${effectiveName}: ${msg.trim() || c.note || 'please follow up'}`, created_by: holder });
        if (error) throw error;
        await supabaseClient.from('se_commitments').update({ status: 'done', done_at: nowIso }).eq('id', c.id);
        await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: 'note', channel: 'se', actor: effectiveName, subject: `↪ Reminder handed to ${holder} — ${msg.trim()}`.slice(0, 180) });
      } else if (act === 'drop') {
        const why = window.prompt(`${co}: drop this reminder — one line on why:`, '');
        if (why === null) return;
        if (!why.trim()) { window.alert('One line on why, please — it stays on the record.'); return; }
        await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).eq('id', c.id);
        await supabaseClient.from('se_touches').insert({ owner_id: c.owner_id, kind: 'note', channel: 'se', actor: effectiveName, subject: `✕ Reminder dropped — ${why.trim()}`.slice(0, 180) });
      }
    } catch (e) { window.alert('Could not save: ' + (e?.message || '')); return; }
    setMyRemTick(t => t + 1);
  };
  // ⏰ The one door for a reminder with no card (Mark 09-17). Reuses seRemindMe
  // (type-prefixed note, created_by = me, retires stacked chains) — it comes
  // back to the SETTER's plate on the date (creator routing in the load).
  const [seNewRemOpen, setSeNewRemOpen] = useState(false);
  const seNewReminderProps = {
    open: seNewRemOpen, onOpen: () => setSeNewRemOpen(true), onClose: () => setSeNewRemOpen(false),
    searchOwners: buysideSearchOwners,
    onCreate: async ({ owner, due, type, note }) => { await seRemindMe(owner, due, note, null, type); return true; },
  };
  const buysideTieFromCard = (owner) => { setBuysideNewPrefill(owner); setBuysideNewOpen(true); };
  const buysideNewMatchProps = {
    open: buysideNewOpen, prefillOwner: buysideNewPrefill,
    onOpen: () => setBuysideNewOpen(true),
    onClose: () => { setBuysideNewOpen(false); setBuysideNewPrefill(null); },
    searchOwners: buysideSearchOwners, searchBuyers: buysideSearchBuyers, onCreate: buysidePairRecord, onMarkBsa: buysideMarkBsaSigned,
  };

  // Owner team-radar line: per-AM counts of SE follow-ups >7 days overdue
  // (the same items the 7:30 nudge chases). Owner role only; count queries
  // are head-only so this stays cheap.
  const [seTeamOverdue, setSeTeamOverdue] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient || effectiveRole !== 'owner') { setSeTeamOverdue(null); return; }
    (async () => {
      try {
        const cutoff = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
        const out = [];
        for (const n of SE_AM_NAMES) {
          const { count: c1 } = await supabaseClient.from('se_owners')
            .select('id', { count: 'exact', head: true })
            .eq('tier', 'responder').eq('status', 'active').eq('assigned_to', n)
            .lt('next_touch_at', cutoff);
          // Reminders count for whoever My Work + the 7:30 email route them to
          // (creator while on staff, else the holder — Mark 10-07).
          const { data: dueC } = await supabaseClient.from('se_commitments')
            .select('id, created_by, se_owners!inner(assigned_to, tier, status)')
            .eq('status', 'open').lt('due', cutoff)
            .eq('se_owners.tier', 'responder').eq('se_owners.status', 'active').limit(2000);
          const c2 = (dueC || []).filter(c => (seCreatorIsLive(c.created_by) ? c.created_by : c.se_owners.assigned_to) === n).length;
          const total = (c1 || 0) + (c2 || 0);
          if (total > 0) out.push({ name: n, count: total });
        }
        // Unanswered owner emails per AM (no-response flag; migration 050).
        // PostgREST can't compare two columns — fetch the inbound-bearing
        // rows (small) and compute here. Non-fatal pre-migration.
        try {
          const { data: inRows } = await supabaseClient.from('se_owners')
            .select('assigned_to, last_inbound_at, last_outbound_at')
            .eq('tier', 'responder').eq('status', 'active')
            .not('last_inbound_at', 'is', null).limit(2000);
          const cutoffMs = Date.now() - 2 * 86400000;
          (inRows || []).forEach(r => {
            if ((!r.last_outbound_at || r.last_inbound_at > r.last_outbound_at)
                && new Date(r.last_inbound_at).getTime() < cutoffMs
                && (Date.now() - new Date(r.last_inbound_at).getTime()) < 180 * 86400000) {   // card horizon
              const hit = out.find(o => o.name === r.assigned_to);
              if (hit) hit.unanswered = (hit.unanswered || 0) + 1;
              else if (SE_AM_NAMES.includes(r.assigned_to)) out.push({ name: r.assigned_to, count: 0, unanswered: 1 });
            }
          });
        } catch (e) { console.warn('SE unanswered-email counts skipped:', e?.message || e); }
        if (!cancelled) setSeTeamOverdue(out);
      } catch (e) {
        console.warn('SE team-overdue counts skipped:', e?.message || e);
        if (!cancelled) setSeTeamOverdue(null);
      }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, effectiveRole, reloadTick]);

  // The serving, per SE_SERVING_CONFIG (Mark 2026-07-28 walkthrough):
  // PROMISES (everyone, always, cap 5/day oldest-first) = due commitments +
  // arrived follow-up dates — owner-consented, escalation applies.
  // IDEAS (Adam only, auto-ramped from rampStart) = resurrection suggestions:
  // prior-valuation businesses first, revenue tiebreak, dark tier never.
  // Never escalated — a suggestion that nags isn't a suggestion.
  const seServingMode = (SE_SERVING_CONFIG[effectiveName] || { mode: 'promises' }).mode;
  // "Give me the next one" (Mark 2026-07-29): pull-based self-serve for Adam
  // — one button, one lead, the system decides. ONE OPEN FETCH AT A TIME:
  // the button locks until the fetched lead gets a decision (closing the
  // loop is the price of the next lead). STICKY SNAPSHOTS since 08-27
  // (Adam/Shamrock: he fetched, started the email, and a background data
  // refresh moved the owner out of the queue — the id-based render made
  // his card evaporate mid-work). A fetch stores the owner OBJECT; the
  // card renders from the snapshot no matter what the queue does, and only
  // HIS action releases it (outcome · ⏰ · ✕ · snooze — releaseFetched in
  // each handler). If the owner meanwhile earns a REAL card (e.g. the
  // backfill made them reply-due), the real card supersedes the snapshot.
  const [seFetched, setSeFetched] = useState([]);
  const releaseFetched = (ownerId) => setSeFetched(prev => prev.filter(o => o.id !== ownerId));
  // The snapshot survives refreshes AND the new-version auto-reload (we
  // deploy many times a day — state alone would re-create the Shamrock
  // vanish on every push). Browser-local by design: it's the fetcher's own
  // open loop, on the machine they fetched it on.
  const seFetchedHydrated = useRef(false);
  useEffect(() => {
    seFetchedHydrated.current = false;
    try {
      const raw = localStorage.getItem('se_fetched_v1');
      if (raw) {
        const p = JSON.parse(raw);
        if (p && p.who === effectiveName && Array.isArray(p.cards)) setSeFetched(p.cards);
        else setSeFetched([]);
      }
    } catch (_) { /* storage unavailable — session-only stickiness still holds */ }
    seFetchedHydrated.current = true;
  }, [effectiveName]);
  useEffect(() => {
    if (!seFetchedHydrated.current) return;
    try { localStorage.setItem('se_fetched_v1', JSON.stringify({ who: effectiveName, cards: seFetched })); } catch (_) {}
  }, [seFetched, effectiveName]);
  // 🤝 / 🏷 SELLSIDE HOLD (Adam 10-23, Allevia + ASI Networks ↔ ITPartners: "make sure businesses aren't carded when
  // they're in a buy-side conversation with a specific paired buyer, and ... when they're listed. This is a
  // time-waster."). An OPEN buyside pair (keyed by the owner: neither had a VT client link, so the client-keyed guard
  // missed both) or a live Deal Manager listing = the relationship is being worked elsewhere, so no sellside
  // follow-up card (dates, imported reminders, reply watches, went quiet, pick the play, valued, ideas, and 🧠 Finish
  // the thought: Adam 10-26, ASI again). Reply-due still shows: an owner waiting on us outranks everything. A
  // reminder a person set in VT still shows. Its own memo so every band shares one rule (seServingData is weekday-only).
  const seSellsideHold = useMemo(() => {
    const PAIR_TERMINAL = ['passed', 'owner_withdrew', 'loi', 'closed'];
    const openPairByOwner = new Map();
    (buyerFollow || []).forEach(p => {
      const l = (p.touches || []).filter(t => t.kind !== 'note'); const c = l[l.length - 1];
      if (c && !PAIR_TERMINAL.includes(c.kind)) openPairByOwner.set(p.owner_id, (p.buyer && p.buyer.company_name) || 'a buyer');
    });
    const normCo = (s) => String(s || '').toLowerCase().replace(/\b(inc|llc|ltd|corp|co|company|incorporated)\b\.?/g, '').replace(/[^a-z0-9]/g, '');
    const LIVE_LISTING = new Set(['In Market', 'Paused', 'IOI Round', 'Round 2', 'Contract Pending', 'In Negotiation', 'Under LOI']);
    const liveListings = (Array.isArray(dmListings) ? dmListings : []).filter(l => l && LIVE_LISTING.has(l.status));
    const listingByVista = new Map(liveListings.filter(l => l.vista_id).map(l => [String(l.vista_id).trim(), l]));
    const listingByName = new Map(liveListings.filter(l => normCo(l.name)).map(l => [normCo(l.name), l]));
    const vistaByClient = new Map((pipelineProjects || []).filter(p => p.client_id && p.vista_id).map(p => [p.client_id, String(p.vista_id).trim()]));
    return (o) => {
      if (openPairByOwner.has(o.id)) return 'Buyside project open with ' + openPairByOwner.get(o.id);
      const l = (o.vt_client_id && listingByVista.get(vistaByClient.get(o.vt_client_id))) || listingByName.get(normCo(o.company_name));
      return l ? 'Listed (' + l.status + ')' : null;
    };
  }, [buyerFollow, dmListings, pipelineProjects]);
  // 🧠 Finish the thought minus held owners (Adam 10-26: ASI Networks, paired with ITPartners, asked for a strategy pick).
  const seFinishShown = useMemo(() => {
    if (!seFinish) return null;
    const items = seFinish.items.filter(i => !seSellsideHold(i.owner));
    return items.length ? { ...seFinish, items } : null;
  }, [seFinish, seSellsideHold]);
  const seServingData = useMemo(() => {
    if (!seOwnersMine || seOwnersMine.length === 0) return null;
    if ([0, 6].includes(new Date().getDay())) return null; // weekdays only
    const cfg = SE_SERVING_CONFIG[effectiveName] || { mode: 'promises' };
    const todayIso = new Date().toISOString().slice(0, 10);
    const quietText = (d) => {
      if (!d) return 'no recorded activity';
      const mo = Math.round((Date.now() - new Date(d).getTime()) / (30.44 * 86400000));
      return mo < 12 ? `quiet ${mo} months` : `quiet ${(mo / 12).toFixed(1)} years`;
    };
    const items = [];
    const used = new Set();
    const push = (o, band, why, commitment) => {
      if (used.has(o.id)) return;
      used.add(o.id);
      items.push({ ...o, _band: band, _why: why, _commitment: commitment || null });
    };
    // Terminal dispositions are dead in EVERY band (Adam's TDS IT 08-13:
    // logged sold_elsewhere, but the reply-due card survived — reply-due is
    // email truth and never consulted the disposition). The kill is Log
    // outcome → sold/not-a-fit; this line is what makes the kill stick.
    // not_a_fit_small keeps its 24-month recheck and is deliberately NOT here.
    // NO CONTACT = NO ROTATION (Mark 10-21, Adam / TeamLogicIT Laguna Beach): a business with no contact name, email
    // or phone has nobody to follow up, so an old Zoho date, the ideas band and the valued-no-review band skip it.
    // The record stays (market data, buyside targets, owners can be found later); a reminder a person set on
    // purpose (a commitment) still shows.
    const hasContact = (o) => !!(String(o.contact_name || '').trim() || (o.emails || []).length || String(o.phone || '').trim());
    const servable = seOwnersMine.filter(o => !o._wqGuest
      && o.disposition !== 'not_a_fit' && o.disposition !== 'sold_elsewhere' && o.disposition !== 'not_a_seller');
    // Went-quiet guests: owners on someone else's book that YOU were the last
    // to email — visible to the went-quiet band only (Mark 09-17).
    const wqGuests = seOwnersMine.filter(o => o._wqGuest
      && o.disposition !== 'not_a_fit' && o.disposition !== 'sold_elsewhere' && o.disposition !== 'not_a_seller');
    // 🍂 VT-ACTIVE SUPPRESSION (Adam 09-11, TeamLogic Flower Mound: the
    // reengage was held 9/10, the deal entered the VT pipeline, and the
    // pre-VT "email again in a week" commitment still fired — third report
    // of the Natix class). Once a linked VT deal is in the ACTIVE pipeline,
    // the VT machinery owns the relationship cadence: promises, dangles,
    // and ideas stand down here. REPLY-DUE deliberately survives — an
    // owner waiting on an answer outranks every process boundary.
    const vtActiveClients = new Set((projects || []).map(p => p.client_id).filter(Boolean));
    const inActiveVt = (o) => !!(o.vt_client_id && vtActiveClients.has(o.vt_client_id));
    const sellsideHold = seSellsideHold;   // the shared rule above
    const holdWarn = (o) => { const h = sellsideHold(o); return h ? `. ⚠ ${h}: check with whoever is running it before you contact them` : ''; };
    // ── Unanswered owner emails (email sync's NO-RESPONSE FLAG — Mark
    // 2026-07-30: "Thatcher and Adam open owner emails, get distracted,
    // forget to reply — often"). An inbound newer than our last outbound,
    // sitting 2+ days → a dropped ball. NEVER capped — these aren't quota,
    // they're owners waiting on us. Top of the serving.
    const replyDue = servable
      .filter(o => !o._schedGuest)
      .filter(o => o.last_inbound_at
        && (!o.last_outbound_at || o.last_inbound_at > o.last_outbound_at)
        && (Date.now() - new Date(o.last_inbound_at).getTime()) > 2 * 86400000
        // A meeting booked or held AFTER the owner's email IS the reply
        // (Proficio 08-11: the AM answered with a Calendar invite, which
        // never registers as an outbound email).
        && !(o.last_meeting_at && new Date(o.last_meeting_at) > new Date(o.last_inbound_at))
        && !(o.next_meeting_at && new Date(o.next_meeting_at) > new Date(o.last_inbound_at))
        // ✕ "No reply needed" pressed after the email — dismissed until
        // the owner writes again (UpTime 08-11).
        && !(o._noReplyAt && new Date(o._noReplyAt) > new Date(o.last_inbound_at))
        // "Perfect, thanks!" asks nothing (Zac 10-29).
        && !(o._lastInbound && seCourtesyClose(o._lastInbound.snippet)))
      .sort((a, b) => (a.last_inbound_at < b.last_inbound_at ? -1 : 1));
    replyDue.forEach(o => {
      const days = Math.floor((Date.now() - new Date(o.last_inbound_at).getTime()) / 86400000);
      push(o, 0, `The owner emailed ${days} days ago and no reply has gone out — answer them first.`);
    });
    // 📥 Replies to YOUR email from owners off your book (Mark 10-21): carded the same day, never capped.
    (seReplyGuests || [])
      .filter(o => o.disposition !== 'not_a_fit' && o.disposition !== 'sold_elsewhere' && o.disposition !== 'not_a_seller')
      .filter(o => !(o.next_meeting_at && new Date(o.next_meeting_at) > new Date(o._replyAt)) && !(o.last_meeting_at && new Date(o.last_meeting_at) > new Date(o._replyAt)))
      .filter(o => !(o._lastInbound && seCourtesyClose(o._lastInbound.snippet)))
      .sort((a, b) => (a._replyAt < b._replyAt ? -1 : 1))
      .forEach(o => {
        const hrs = Math.floor((Date.now() - new Date(o._replyAt).getTime()) / 3600000);
        const when = hrs < 1 ? 'within the hour' : hrs < 24 ? hrs + ' hour' + (hrs === 1 ? '' : 's') + ' ago' : Math.floor(hrs / 24) + ' day' + (hrs < 48 ? '' : 's') + ' ago';
        push(o, 0, `📥 Replied to your email ${when}${o.assigned_to && o.assigned_to !== effectiveName ? ` (record on ${o.assigned_to}'s book${o.tier === 'cold' ? ', cold' : ''})` : ''}. Their words are on the card: answer them, then 📨 Log response, or ✕ if no reply is needed.`);
      });
    // Stacked-chain warning (Mark 2026-08-04): the imported Zoho reminders
    // include strategy-free chains ("Reach Out" → "6 month follow up" → …,
    // dated to 2032). The card says so, and logging any outcome retires them.
    const commitCountByOwner = new Map();
    seCommitmentsMine.forEach(c => commitCountByOwner.set(c.owner_id, (commitCountByOwner.get(c.owner_id) || 0) + 1));
    const chainNote = (ownerId, excludeOne) => {
      const n = (commitCountByOwner.get(ownerId) || 0) - (excludeOne ? 1 : 0);
      return n > 0 ? ` · ⚠ ${n} more reminder${n === 1 ? '' : 's'} stacked — your pick here retires them; strategy takes over.` : '';
    };
    // ── Promises (cap 5, oldest first) ──
    const promises = [];
    seCommitmentsMine
      .filter(c => c.due && c.due <= todayIso)
      .forEach(c => {
        const o = servable.find(x => x.id === c.owner_id);
        if (o) {
          // Provenance honesty (Mark 08-20, Adam's Cohesive card): a
          // reminder that rode in on the 07-28 Zoho import is NOT a
          // personal promise to the owner — it's an old Zoho reminder,
          // sometimes set by someone else entirely. The card says which.
          const imported = c.created_at && String(c.created_at) < '2026-07-29';
          // A matured ⏳ reply-watch asks the now-answerable question — the
          // owner had their 2 business days and stayed silent (Mark 08-21).
          const awaiting = /^Awaiting reply/.test(c.note || '');
          // THE MEETING IS THE REPLY — for watches too (Mark 09-02, Natix:
          // he set the ⏳, THATCHER held the reengage meeting 8/31, and the
          // matured watch still carded Mark for an answer the meeting
          // already gave — "digging through cards like that robs
          // bandwidth"). Same law the reply-due band applies above: a
          // meeting held or booked after the watch started answers it.
          // The watch cancels itself with a logged touch; the meeting
          // holder's own flow owns the next step.
          if (awaiting && ((o.last_meeting_at && new Date(o.last_meeting_at) > new Date(c.created_at))
            || (o.next_meeting_at && new Date(o.next_meeting_at) > new Date(c.created_at)))) {
            try {
              supabaseClient.from('se_commitments').update({ status: 'cancelled' }).eq('id', c.id)
                .then(() => supabaseClient.from('se_touches').insert({
                  owner_id: o.id, kind: 'note', channel: 'se', actor: 'system',
                  subject: `⏳ reply-watch retired — a meeting ${o.last_meeting_at && new Date(o.last_meeting_at) > new Date(c.created_at) ? 'was held' : 'is booked'} after the watch started; the meeting is the reply`,
                }))
                .then(() => {}, () => {});
            } catch (e) { /* retire best-effort — worst case the card shows once more */ }
            return;
          }
          // 📅 THE MEETING RETIRES ITS OWN INVITE-CHECK (Scott 09-23, TLG): a
          // "First-time meeting with Zac" commitment is the response desk's
          // invite-check device — it exists so the meeting gets onto the
          // calendar. Nothing ever closed it: once the meeting was booked it
          // was merely hidden (invite-check filter, then VT-active
          // suppression), and the day the deal left the active VT pipeline
          // (TLG → considering) the 35-day-old "reminder" resurfaced on Scott,
          // who had nothing to do — the meeting was held 8/19 and the
          // valuation delivered 9/21. A held or booked meeting on/after the
          // due date means the invite-check did its job: mark it done, log
          // why, and never card it. (Scott's re-log of the response on 9/22
          // had also created a second copy — the response desk now dedupes.)
          // 🔁 FORKED SCHEDULING CHAINS HEAL (Scott 09-23, R&R Fmg): a twin
          // row of an earlier or equal step, when a later step is already
          // open for the same owner, is a fork left by a double-click —
          // retire it, log why, never card it. Same-step twins keep the
          // lowest id so exactly one survives.
          if (/^Scheduling follow-up/.test(c.note || '')) {
            const stepOf = (x) => { const mm = /step (\d)\/5/.exec(x.note || ''); return mm ? Number(mm[1]) : 0; };
            const mine = stepOf(c);
            const stale = seCommitmentsMine.some(x => x.id !== c.id && x.owner_id === c.owner_id
              && /^Scheduling follow-up/.test(x.note || '')
              && (stepOf(x) > mine || (stepOf(x) === mine && String(x.id) < String(c.id))));
            if (stale) {
              try {
                supabaseClient.from('se_commitments').update({ status: 'cancelled' }).eq('id', c.id)
                  .then(() => supabaseClient.from('se_touches').insert({
                    owner_id: o.id, kind: 'note', channel: 'se', actor: 'system',
                    subject: `🔁 Duplicate scheduling step ${mine} retired — the chain already moved past it (a double-click had forked it)`,
                  }))
                  .then(() => {}, () => {});
              } catch (e) { /* best-effort */ }
              return;
            }
          }
          const firstTime = /^First-time meeting with /i.test(c.note || '');
          if (firstTime && ((o.last_meeting_at && String(o.last_meeting_at).slice(0, 10) >= c.due)
            || (o.next_meeting_at && String(o.next_meeting_at).slice(0, 10) >= c.due))) {
            try {
              const held = o.last_meeting_at && String(o.last_meeting_at).slice(0, 10) >= c.due;
              supabaseClient.from('se_commitments').update({ status: 'done', done_at: new Date().toISOString() }).eq('id', c.id)
                .then(() => supabaseClient.from('se_touches').insert({
                  owner_id: o.id, kind: 'note', channel: 'se', actor: 'system',
                  subject: `📅 First-time-meeting reminder closed — the meeting ${held ? `was held (${String(o.last_meeting_at).slice(0, 10)})` : `is booked (${String(o.next_meeting_at).slice(0, 10)})`}; the invite-check did its job`,
                }))
                .then(() => {}, () => {});
            } catch (e) { /* retire best-effort — worst case the card shows once more */ }
            return;
          }
          // …and while still open it is NEVER a "Reminders you set" card (Scott
          // 09-29, Affordable IT Pros: he'd handed the meeting to Zac, and on the
          // meeting date it came back to HIS plate asking him to Log outcome).
          // Its one job — getting the meeting onto a calendar — is carded by
          // "Meeting logged — no calendar invite found", which reads this same
          // row and clears the moment the calendar sync sees the event.
          if (firstTime) return;
          const silentD = o.last_outbound_at ? Math.floor((Date.now() - new Date(o.last_outbound_at).getTime()) / 86400000) : null;
          const why = awaiting
            ? `⏳ The reply watch is up — you reached out${silentD !== null ? ` ${silentD}d ago` : ''} and they've stayed silent. Now what? 📞 Log outcome (email again, or pick the strategy: marketing takes over, with or without a dated follow-up) or ⏰ a new date — or ⏳ again if you just nudged them.${chainNote(o.id, true)}`
            : imported
              ? `Zoho reminder (imported${c.created_by ? ` — set by ${c.created_by}` : ''}): "${c.note || 'Reach Out'}" was due ${c.due}. Still worth doing? 📞 Log outcome or ⏰ pick a real date — either clears it.${chainNote(o.id, true)}`
              : `Reminder was due ${c.due}: ${(reminderTypeOf(c.note) ? reminderTypeOf(c.note).text : (c.note || 'reach out'))}${chainNote(o.id, true)}`;
          if (inActiveVt(o)) return;   // VT owns the cadence now (Adam 09-11)
          if ((imported || awaiting) && sellsideHold(o)) return;   // paired with a buyer or listed (Adam 10-23)
          if (imported && !hasContact(o)) return;   // an old Zoho reminder with nobody to reach (Adam 10-23, Curb Allure)
          promises.push({ o, when: c.due, band: 1, why: why + holdWarn(o), c });
        }
      });
    servable
      // A date a PERSON set (it carries the pick) fires even while the business is paired or listed, with the warning
      // on the card (Mark 10-27: "let them fire with warning" — a promised call must not vanish if the deal falls
      // through). A pick-less date (Zoho archaeology) stays held.
      .filter(o => !o._schedGuest && !inActiveVt(o) && !(sellsideHold(o) && !o.disposition) && o.next_touch_at && o.next_touch_at <= todayIso && hasContact(o))
      // Provenance honesty for DATES too (Logic TCG 08-24: an imported Zoho
      // date fired with no label — commitments got the honesty pair 08-20,
      // the next_touch_at path never did). A real SE date always carries the
      // owner-consented pick that set it; date with no pick = archaeology.
      .forEach(o => promises.push({ o, when: o.next_touch_at, band: 1, why: `Follow-up date arrived (${o.next_touch_at}${o.disposition ? ' — owner chose: ' + String(o.disposition).replace(/_/g, ' ') : ' — no recorded pick behind this date, likely a Zoho import; 📞 Log outcome or ⏰ replaces it with a real plan'})${!String(o.contact_name || '').trim() && !(o.emails || []).length && !String(o.phone || '').trim() ? '. This record has NO contact (no name, email or phone), so there is nobody to follow up: ✕ Drop this date and say “no contact on the record” (Adam 10-20, TeamLogicIT)' : ''}${chainNote(o.id, false)}${holdWarn(o)}` }));
    // UNCAPPED since 08-14 (Mark, watching Adam's 19-item backlog hide
    // behind the old 5/day cap while the nudge email showed all 19: "I want
    // him to spend his time cleaning his plate — the plate should be clean
    // each day"). Every due promise cards, oldest first — the plate IS the
    // honest wall, same law as reply-due.
    // 🔕 WENT QUIET (Mark 09-17, Adam's "yes → booked" crack): the automatic
    // mirror of reply-due. Reply-due catches the owner waiting on US; nothing
    // caught US waiting on the OWNER — a LIVE conversation (they'd replied
    // inside 14 days) where we wrote last and 2 business days passed with no
    // answer only surfaced if Adam remembered to arm ⏳, else it sat 10 days
    // for the Pick-the-play band. Same resolves as a matured watch. Stands
    // down for active-VT (VT owns the cadence) and for owners already carrying
    // a watch / reminder / next-touch (no double cards); pushing here marks the
    // owner used, so Pick-the-play skips them too.
    const WENT_QUIET_ENGAGED_DAYS = 14;
    const hasCommit = new Set(seCommitmentsMine.map(c => c.owner_id));
    [...servable, ...wqGuests]
      .filter(o => !o._schedGuest && !inActiveVt(o) && !sellsideHold(o) && !hasCommit.has(o.id) && !o.next_touch_at)
      .filter(o => o.last_inbound_at && o.last_outbound_at && o.last_outbound_at > o.last_inbound_at
        && (Date.now() - new Date(o.last_inbound_at).getTime()) <= WENT_QUIET_ENGAGED_DAYS * 86400000
        // A meeting held or booked after our email IS their answer.
        && !(o.last_meeting_at && new Date(o.last_meeting_at) > new Date(o.last_outbound_at))
        // …and so is a buyside deal step recorded after it (Adam 10-09, Xperts ↔ N2).
        && !(o._lastBuysideAt && new Date(o._lastBuysideAt) > new Date(o.last_outbound_at))
        // …and so is a play logged after it (Adam 10-09, Baseline Creative: "Let monthly marketing take
        // over" didn't clear the card). Log outcome stamps last_touch_at; a pick made after our email is the answer.
        && !(o.disposition && o.last_touch_at && new Date(o.last_touch_at) > new Date(o.last_outbound_at))
        && !(o.next_meeting_at && new Date(o.next_meeting_at) > new Date(o.last_outbound_at))
        // SENDER, PERIOD (Mark 09-17): the card lands on whoever sent the last
        // email — strict, no "unknown passes" (the sender pool above stamps the
        // mailbox for every candidate, so unset means you weren't the sender).
        && o._lastOutMailbox === effectiveName)
      .forEach(o => {
        const bd = businessDaysBetween(o.last_outbound_at, todayIso);
        if (bd == null || bd < 2) return;
        const silentD = Math.floor((Date.now() - new Date(o.last_outbound_at).getTime()) / 86400000);
        promises.push({ o, when: String(o.last_outbound_at).slice(0, 10), band: 1,
          why: `🔕 They went quiet — they'd replied, you wrote back ${silentD}d ago, and nothing since. Nudge them by email, ⏳/⏰ a date — or 📞 log it if it's over.${chainNote(o.id, false)}` });
      });
    promises.sort((a, b) => (a.when < b.when ? -1 : 1));
    promises.forEach(p => push(p.o, p.band, p.why, p.c));
    // ── No response → 🎯 PICK THE PLAY (Mark 2026-08-04, "every send
    // resolves"): observed outbound ≥10 days old with no inbound since, not
    // parked, not ancient (>45d sends predate the strategy doctrine). Capped
    // 3/day oldest-first — decisions, not quota; the rest surface as these
    // resolve. ──
    servable
      .filter(o => !used.has(o.id) && !o._schedGuest && !inActiveVt(o) && !sellsideHold(o))
      .filter(o => o.last_outbound_at
        && (!o.last_inbound_at || o.last_inbound_at < o.last_outbound_at)
        && (Date.now() - new Date(o.last_outbound_at).getTime()) > 10 * 86400000
        && (Date.now() - new Date(o.last_outbound_at).getTime()) < 45 * 86400000
        && !(o.next_touch_at && o.next_touch_at > todayIso)
        // A FUTURE human-set reminder IS a picked play (Red Five 08-17:
        // Adam ⏰'d December and the card stood — this band only knew
        // next_touch_at). created_by-null rows are the imported Zoho junk
        // chains, which deliberately DON'T count as strategy.
        && !seCommitmentsMine.some(c => c.owner_id === o.id && c.due > todayIso && c.created_by)
        // A BOOKED FUTURE MEETING is a picked play (RDS 08-11: discovery
        // meeting set for 8/17, card still nagged) — nothing dangles.
        && !(o.next_meeting_at && o.next_meeting_at > todayIso.slice(0, 10))
        // Recipient law, outbound half: only the SENDER's dangle (LifeSpaces
        // 08-11 — "You emailed" must be true on whoever sees the card).
        && (!o._lastOutMailbox || o._lastOutMailbox === effectiveName)
        // A LOGGED STRATEGY PICK newer than the send IS the picked play
        // (GHPBuysHouses 09-08: Adam logged the 9/2 call outcome + "let
        // monthly marketing take over" — the one play that deliberately
        // sets NO date, so every date-shaped exclusion above missed it and
        // this band re-served a finished thought). strategy_marketing is
        // the dateless play; every other pick leaves a date/commitment the
        // exclusions above already honor.
        && !(o.disposition === 'strategy_marketing' && o.last_touch_at && o.last_outbound_at && o.last_touch_at > o.last_outbound_at))
      .sort((a, b) => (a.last_outbound_at < b.last_outbound_at ? -1 : 1))
      .slice(0, 3)
      .forEach(o => {
        const days = Math.floor((Date.now() - new Date(o.last_outbound_at).getTime()) / 86400000);
        push(o, 4, `You emailed the owner ${days} days ago — no response yet. Pick the strategy so this doesn't dangle.${chainNote(o.id, false)}`);
      });
    // ── 🔁 VALUED, NO REVIEW — RE-ENGAGE (Mark 09-24) ──
    // 168 owners carry a Zoho valuation and no VT file (Adam 104 / Zac 36 /
    // Thatcher 28); 67 of them nobody had touched since the Sales Engine
    // started. They surfaced only as ideas, three at a time. Rules (Mark):
    // highest value first; Adam three a day with 🎯 for more; Leads one a
    // week. Zoho "Valued Active" meant a strategic review was set — for most
    // it was the valuation meeting itself, long held — so it rides the same
    // list with a flag. Being worked (touch ≤ 90d, meeting ahead, parked,
    // reminder open) waits its turn; terminal dispositions never show.
    const VALUED_TERMINAL = new Set(['not_a_fit', 'not_a_fit_small', 'sold_elsewhere']);
    // A retired strategic BUYER (Mark 08-11) can carry a Zoho valuation date — never a seller to re-engage.
    const isZohoValued = (o) => !/strategic buyer/i.test(o.zoho_status || '') && (/valued/i.test(o.zoho_status || '') || !!o.zoho_valuation_date);
    const valuedManaged = new Set(seCommitmentsMine.map(c => c.owner_id));
    const valuedPop = servable
      .filter(o => isZohoValued(o) && hasContact(o) && !o.vt_client_id && !inActiveVt(o) && !sellsideHold(o) && !used.has(o.id) && !valuedManaged.has(o.id)
        && !VALUED_TERMINAL.has(o.disposition)
        && !(o.next_touch_at && o.next_touch_at > todayIso)
        && !(o.next_meeting_at && String(o.next_meeting_at).slice(0, 10) > todayIso)
        && !(o.last_touch_at && (Date.now() - new Date(o.last_touch_at).getTime()) < 90 * 86400000))
      .sort((a, b) => ((Number(b.zoho_value_provided) || 0) - (Number(a.zoho_value_provided) || 0))
        || String(b.zoho_valuation_date || '').localeCompare(String(a.zoho_valuation_date || ''))
        || String(a.id).localeCompare(String(b.id)));
    const valuedWhy = (o) => {
      const m = o.zoho_valuation_date ? Math.round((Date.now() - new Date(o.zoho_valuation_date).getTime()) / (30.44 * 86400000)) : null;
      const val = Number(o.zoho_value_provided) > 0 ? ` (≈$${(Math.round(Number(o.zoho_value_provided) / 1e5) / 10).toLocaleString()}M)` : '';
      const active = /valued active/i.test(o.zoho_status || '') ? ' — Zoho had a strategic review set' : '';
      return `We valued this business${m != null ? ` ${m} months ago` : ''}${val}${active} — no review on the books since. Re-engage: 📞 Log outcome (review meeting · still considering + date · not now · not for sale), or ⏰ a date.`;
    };
    // Pace: Adam three a day (+ 🎯 pull for more); Leads one at a time and
    // one a week — a valued owner touched inside 7 days holds the next.
    const valuedCap = effectiveRole === 'lead' ? 1 : 3;
    const valuedWeekHold = effectiveRole === 'lead' && seOwnersMine.some(o => isZohoValued(o) && !o.vt_client_id
      && o.last_touch_at && (Date.now() - new Date(o.last_touch_at).getTime()) < 7 * 86400000);
    const valuedServed = valuedWeekHold ? [] : valuedPop.slice(0, valuedCap);
    valuedServed.forEach(o => push(o, 5, valuedWhy(o)));
    const valuedRest = (valuedWeekHold ? [] : valuedPop.slice(valuedCap))
      .map(o => ({ ...o, _band: 5, _commitment: null, _why: valuedWhy(o) }));
    // ── Ideas: the auto-ramp cards AND the pull-button's queue ──
    let queue = [];
    let overdueGate = 0;
    if (cfg.mode === 'ideas') {
      const monthsSince = (d) => Math.round((Date.now() - new Date(d).getTime()) / (30.44 * 86400000));
      // A business with ANY open reminder is being managed — never an idea
      // card (Mark 2026-07-28: "if there is a reminder set, we'll assume
      // it's being managed correctly"). Its promise card fires on its date.
      const managed = new Set(seCommitmentsMine.map(c => c.owner_id));
      // Ranking (Mark 2026-07-29, from Scott's Seller file): ① RECENT-DROPPED
      // — arrived within ~12 months, no marketing campaign ever set, and (by
      // the managed-exclusion filters) no reminder either: "likely the ball
      // was completely dropped." Still warm — save them first. ② prior-
      // valuation resurrections. ③ revenue.
      const recentIso = new Date(Date.now() - 365 * 86400000).toISOString().slice(0, 10);
      const isDropped = (o) => !o.email_campaign && o.captured_at && o.captured_at >= recentIso;
      const ideaWhy = (o) => isDropped(o)
        ? `They showed interest ${monthsSince(o.captured_at)} month${monthsSince(o.captured_at) === 1 ? '' : 's'} ago and the ball was dropped — no follow-up, no marketing running. Still warm — worth the call?`
        : o.zoho_valuation_date
          ? `We valued this business ${monthsSince(o.zoho_valuation_date)} months ago${o.zoho_value_provided ? ` (≈$${(Math.round(Number(o.zoho_value_provided) / 1e5) / 10).toLocaleString()}M)` : ''} — worth a call to see if we can resurrect it?`
          : [
              o.size_revenue ? `$${(Math.round(Number(o.size_revenue) / 1e5) / 10).toLocaleString()}M revenue` : null,
              quietText(o.zoho_last_activity),
              'worth a re-engagement call?',
            ].filter(Boolean).join(' · ');
      // SIZE-AWARE RE-ORDER (Adam 09-09 "prioritize the bigger ones, then
      // once they've all been worked, go to the smaller ones" · Mark's
      // guard: cold-lead revenue is a third-party ESTIMATE or blank — never
      // FILTER on it, you'd silently discard every unknown, and unknown ≠
      // small). The compromise, built: within each warmth band, bigger
      // serves first (recency becomes the tiebreak); a KNOWN-small lead
      // (estimated revenue > 0 but under $1M) sinks below the entire rest
      // of the queue — served last, never dropped. Unknown/blank revenue
      // keeps its warmth-band position untouched.
      const SMALL_KNOWN_REVENUE = 1_000_000;
      // WHALE BAND (Adam 09-10, K2 Partnering $40mm EBITDA at the top of
      // his queue: "Without a BSC, it's a waste of time" · Mark's same-day
      // guard: "EBITDA Like Revenue is a guess"). The big-first tiebreak
      // was serving the whales FIRST. Known EBITDA >= $10mm now sinks
      // below the whole queue — even below the small-known band — but is
      // never dropped: the estimate may be wrong, and with a buy-side
      // client a whale is exactly what we want findable. Unknown EBITDA
      // keeps its position untouched (unknown != huge).
      const BIG_KNOWN_EBITDA = 10_000_000;
      const ranked = servable
        .filter(o => !used.has(o.id) && !o._schedGuest && !inActiveVt(o) && !sellsideHold(o) && hasContact(o))
        .filter(o => !managed.has(o.id))
        .filter(o => ['current', 'recent', 'cooling', 'stale'].includes(o.triage_tier))
        .filter(o => !(o.next_touch_at && o.next_touch_at > todayIso)) // parked → respect it
        // BEING WORKED IS NOT AN IDEA (Adam 09-24, Allevia: strategic review
        // held Tuesday, buyside intro booked for Thursday, and the ideas band
        // still served "we valued this 16 months ago — resurrect it?"). A
        // booked meeting ahead, a meeting held inside 30 days, or a human
        // touch inside 14 days means someone has it — the idea band is for
        // businesses nobody is touching.
        .filter(o => !(o.next_meeting_at && String(o.next_meeting_at).slice(0, 10) > todayIso))
        .filter(o => !(o.last_meeting_at && (Date.now() - new Date(String(o.last_meeting_at).slice(0, 10) + 'T12:00:00').getTime()) < 30 * 86400000))
        .filter(o => !(o.last_touch_at && (Date.now() - new Date(o.last_touch_at).getTime()) < 14 * 86400000))
        .map(o => {
          const rev = Number(o.size_revenue) || 0;
          const smallKnown = rev > 0 && rev < SMALL_KNOWN_REVENUE;
          const bigKnown = (Number(o.ebitda) || 0) >= BIG_KNOWN_EBITDA;
          const warmBand = isDropped(o) ? 0 : o.zoho_valuation_date ? 1 : 2;
          return { o, sortBand: bigKnown ? warmBand + 20 : smallKnown ? warmBand + 10 : warmBand, rev,
            recency: isDropped(o) ? new Date(o.captured_at).getTime() : 0, smallKnown, bigKnown };
        })
        .sort((a, b) => (a.sortBand - b.sortBand)
          || (b.rev - a.rev)
          || (b.recency - a.recency)
          || String(a.o.id).localeCompare(String(b.o.id)))
        .map(({ o, smallKnown, bigKnown }) => ({ ...o, _band: 3, _commitment: null,
          _why: ideaWhy(o)
            + (smallKnown ? ' (est. revenue under $1M — served after the bigger book; the estimate may be wrong, so it stays in the queue rather than being filtered)' : '')
            + (bigKnown ? ` (est. EBITDA $${(Math.round((Number(o.ebitda) || 0) / 1e5) / 10)}M — likely needs a buy-side client, served last; the estimate may be wrong, so it stays in the queue rather than being filtered)` : '') }));
      // THE CLEAN-PLATE GATE (Mark 08-19): ideas — auto-ramped AND the 🎯
      // pull button — serve only when the plate has ZERO overdue promises.
      // Due-today doesn't block (that's today's work); older does. No
      // nagging: the faucet reopens mechanically the moment the plate is
      // clean, and survives the lobster ramp and buyside going live.
      overdueGate = promises.filter(p => p.when < todayIso).length;
      // Automatic ramp cards (2026-08-27 → 2/day → 4 → 6).
      let ideaCap = 0;
      if (overdueGate === 0 && cfg.rampStart && todayIso >= cfg.rampStart) {
        const week = Math.floor((Date.now() - new Date(cfg.rampStart + 'T00:00:00').getTime()) / (7 * 86400000));
        ideaCap = cfg.caps[Math.min(Math.max(week, 0), cfg.caps.length - 1)] || 0;
      }
      ranked.slice(0, ideaCap).forEach(c => { used.add(c.id); items.push(c); });
      // Everything below the ramp line feeds the 🎯 pull button — which the
      // gate also freezes (an overdue plate deals no fresh leads).
      // The valued re-engage remainder feeds the pull FIRST (Mark 09-24:
      // "three a day … with an option to get more"), then the ideas ramp.
      queue = overdueGate === 0 ? [...valuedRest, ...ranked.slice(ideaCap)] : [];
    }
    return { cards: items, queue, overdueGate };
  }, [seOwnersMine, seCommitmentsMine, effectiveName, projects, seReplyGuests, seSellsideHold]);

  // Cards shown = automatic cards + any button-fetched leads still open.
  // A fetched lead that gets an outcome logged is parked by the disposition,
  // drops out of the queue on the next data reload, and vanishes from view —
  // which also releases the button lock.
  // DM cards for the effective viewer (consolidation Phase 1; exception
  // radar per Mark 08-05). The owner sees ONLY alert-aged items ("notify
  // me if there is an issue"), grouped by person. Individuals see their
  // own items — minus Scott's processing lane: DM is his workflow, cards
  // would just be a slower copy of his queue.
  const dmSignalsView = useMemo(() => {
    const items = dmMyWork || [];
    if (!items.length) return null;
    if (effectiveRole === 'owner') {
      const alerts = items.filter(i => i.alert);
      if (!alerts.length) return null;
      const byWho = {};
      alerts.forEach(i => { (byWho[i.who] = byWho[i.who] || []).push(i); });
      return { grouped: byWho, mine: null };
    }
    const mine = items.filter(i => i.who === effectiveName && !i.processing);
    return mine.length ? { grouped: null, mine } : null;
  }, [dmMyWork, effectiveName, effectiveRole]);
  // Deep links into DM only work for people with the dm module (REAL
  // login, not View-as) — everyone else gets the signal as a plain card.
  const canOpenDm = (() => {
    const me = STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()] || {};
    return Array.isArray(me.modules) && me.modules.includes('dm');
  })();

  const seServing = useMemo(() => {
    if (!seServingData) return null;
    // Snapshots render regardless of the live queue (the Shamrock rule) —
    // unless the same owner now has a REAL card, which supersedes.
    const cardIds = new Set(seServingData.cards.map(c => c.id));
    const fetched = seFetched
      .filter(o => !cardIds.has(o.id))
      .map(c => ({ ...c, _fetched: true }));
    return [...seServingData.cards, ...fetched];
  }, [seServingData, seFetched]);
  // The lock holds until the fetched lead is RELEASED by a decision — not
  // until a data reload happens to drop it (the old silent unlock).
  const seFetchLocked = !!(seServingData && seFetched.some(o => !seServingData.cards.some(c => c.id === o.id)));
  const seFetchNext = () => {
    if (!seServingData) return;
    if (seFetchLocked) {
      window.alert('Finish the lead you fetched first — log its outcome, then grab the next one. One at a time is the whole trick.');
      return;
    }
    const shown = new Set([...seServingData.cards.map(c => c.id), ...seFetched.map(o => o.id)]);
    const next = seServingData.queue.find(q => !shown.has(q.id));
    if (!next) { window.alert('Nothing eligible in the queue right now — nicely done.'); return; }
    setSeFetched(prev => [...prev, next]);   // the SNAPSHOT — sticky until a decision releases it
  };

  // Log an outcome: touch row + owner clock/disposition + optional dated
  // commitment; a worked band-1 commitment closes.
  const seLogOutcome = async (owner, { kind, note, disposition, commitDue, commitNote, ftt }) => {
    if (!supabaseClient || !owner) return;
    const nowIso = new Date().toISOString();
    try {
      // ftt = a "Finish the thought" backfill pick (Mark 08-28): the marker
      // drives the 3-a-day drip quota, nothing else.
      const meta = {};
      if (disposition) meta.disposition = disposition;
      // A dated next step IS the pick (Adam 10-26, ASI + Dakotech: date-only saves left no mark here, so once the
      // reminder was done 🧠 Finish the thought asked for a strategy he had already given).
      if (commitDue) meta.next_date = commitDue;
      if (ftt) meta.ftt = true;
      const { error: tErr } = await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: kind || 'call', channel: kind === 'call' ? 'phone' : (kind || null),
        actor: effectiveName, subject: note || null,
        meta: Object.keys(meta).length ? meta : null,
      });
      if (tErr) throw tErr;
      const upd = { last_touch_at: nowIso, updated_at: nowIso };
      const d = SE_DISPOSITIONS.find(x => x.key === disposition);
      const strat = SE_STRATEGIES.find(x => x.key === disposition);
      if (d) {
        upd.disposition = disposition;
        // Terminal dispositions (not_a_fit, sold_elsewhere) carry no
        // follow-up date — and CLEAR any parked one, or the old date keeps
        // carding a dead record (Adam's TDS IT kill, 08-13).
        if (d.days) upd.next_touch_at = new Date(Date.now() + d.days * 86400000).toISOString().slice(0, 10);
        else upd.next_touch_at = null;
        if ((disposition === 'not_ready' || disposition === 'not_a_fit' || disposition === 'not_a_fit_small' || disposition === 'sold_elsewhere') && note) upd.not_ready_reason = note;
      } else if (strat && strat.noTouchChange) {
        // 🛠 Working session on an active client: the touch + note are the
        // whole record. No disposition overwrite (a parked play survives),
        // no next-touch change (any standing cadence survives) — VT owns
        // this relationship's clock. The touch meta still carries the pick
        // for the audit trail.
      } else if (strat) {
        upd.disposition = disposition;
        // Marketing takeover: personal cadence ENDS deliberately — clearing
        // next_touch_at makes the owner wave-eligible again.
        upd.next_touch_at = strat.clearTouch ? null
          : (commitDue || new Date(Date.now() + strat.days * 86400000).toISOString().slice(0, 10));
      }
      // CHAIN RETIREMENT (Mark 2026-08-04: 895 imported reminders, 187 owners
      // with stacked strategy-free chains dated to 2032): any decision here
      // retires the owner's OTHER open reminders — strategy takes over.
      let retired = 0;
      // A working session retires NOTHING — it isn't a strategy decision,
      // so the owner's standing plays and reminders stay armed.
      // A DATED pick retires like any other (Adam 09-02, AVS: date-only
      // saves skipped retirement, so each save stacked a duplicate — the
      // modal has always promised "one pick retires the stacked reminders").
      if ((d || strat || commitDue) && !(strat && strat.noTouchChange)) {
        const { data: openC } = await supabaseClient.from('se_commitments')
          .select('id, created_by').eq('owner_id', owner.id).eq('status', 'open').then(r => ({ ...r, data: (r.data || []).filter(c => seRetirableBy(c, effectiveName)) }));
        const toCancel = (openC || []).filter(c => !owner._commitment || c.id !== owner._commitment.id);
        if (toCancel.length) {
          const { error: rErr } = await supabaseClient.from('se_commitments')
            .update({ status: 'cancelled' }).in('id', toCancel.map(c => c.id));
          if (!rErr) retired = toCancel.length;
        }
      }
      const { error: oErr } = await supabaseClient.from('se_owners').update(upd).eq('id', owner.id);
      if (oErr) throw oErr;
      // A logged outcome with a slide-22 DISPOSITION means a conversation
      // happened, and the conversation IS the reply (same law as the
      // meeting-suppresses rule — Adam's five stuck cards, 08-13: he phoned
      // the owners, logged outcomes, and the reply-due section never heard).
      // Suppression is the ✕-style touch: a NEW owner email re-fires the
      // card. AM-side strategy picks deliberately don't clear — no owner
      // conversation is implied. "Reached out today" also stays non-clearing
      // (a voicemail isn't an answer — Mark's recorded rule).
      if (d && owner.last_inbound_at && (!owner.last_outbound_at || owner.last_inbound_at > owner.last_outbound_at)) {
        await supabaseClient.from('se_touches').insert({
          owner_id: owner.id, kind: 'no_reply_needed', channel: 'se', actor: effectiveName,
          subject: `Outcome logged — ${d.label}: the conversation answered their email (a new email re-fires the card)`,
        });
      }
      // "Wants to meet the buyside client" (Adam 09-18): the pair is the
      // record. An existing pair gets the coordinating-meeting step right
      // here; no pair yet → the plate's tie-a-buyer door opens with the
      // owner filled in and the step preset, so the pick still lands.
      if (disposition === 'meet_bsc') {
        let pair = null;
        try {
          const { data: pt } = await supabaseClient.from('se_buyer_touches')
            .select('buyer_id, at, buyer:se_buyers(id, company_name, contact_name, bsa_signed)')
            .eq('owner_id', owner.id).order('at', { ascending: false }).limit(1);
          pair = (pt || [])[0] || null;
        } catch (pe) { pair = null; }
        if (pair && pair.buyer_id) {
          await buysidePairRecord({ owner, buyer: pair.buyer || { id: pair.buyer_id },
            step: { kind: 'coordinating_meeting', waitingOn: 'both sides — scheduling' } });
        } else {
          buysideTieFromCard({ ...owner, _step: 'coordinating_meeting' });
        }
      }
      if (commitDue || (strat && strat.buysideNote)) {
        const due = commitDue || new Date(Date.now() + strat.days * 86400000).toISOString().slice(0, 10);
        const { error: cErr } = await supabaseClient.from('se_commitments').insert({
          owner_id: owner.id, due,
          note: (strat && strat.buysideNote && !commitNote)
            ? (strat.noteText
              ? strat.noteText(owner.company_name)
              : `Buyside-leverage play: find a buyside client that fits ${owner.company_name}, then approach — "I have a buyer, you're a perfect match."`)
            : (commitNote || null),
          created_by: effectiveName,
        });
        if (cErr) throw cErr;
      }
      if (owner._commitment) {
        await supabaseClient.from('se_commitments')
          .update({ status: 'done', done_at: nowIso }).eq('id', owner._commitment.id);
      }
      if (retired > 0) {
        await supabaseClient.from('se_touches').insert({
          owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
          subject: `Strategy set — retired ${retired} stacked reminder${retired === 1 ? '' : 's'} (chain replaced by the picked play)`,
        });
      }
    } catch (e) {
      window.alert('Could not log the outcome: ' + (e?.message || 'unknown error'));
      return;
    }
    // A meeting-truth Held that rode this modal confirms only NOW, on save.
    if (mtHeldPending) {
      // A grouped card's "All held" parks the whole relationship group here
      // (Mark 09-18) — one save stamps every meeting on the card.
      const heldIds = (Array.isArray(mtHeldPending) ? mtHeldPending : [mtHeldPending]).map(m => m.id);
      try {
        await supabaseClient.from('se_meetings')
          .update({ outcome: 'held', updated_at: new Date().toISOString() }).in('id', heldIds);
      } catch (e2) { console.warn('Meeting held-stamp failed:', e2?.message || e2); }
      setMtHeldPending(null);
      setMtTick(t => t + 1);
    }
    setSeOutcomeTarget(null);
    setSeOutcomePrefill(null);  // never leak a backfill prefill into the next open
    releaseFetched(owner.id);   // the decision closes the fetch (Shamrock rule)
    setSeTick(t => t + 1);
  };

  // Scott's scheduling cadence (his OneNote spec, verbatim 08-05): response
  // email goes ASAP, then follow-ups next morning → next morning → +7d →
  // +30d. "✉ Sent it" on a scheduling card closes the step and books the
  // next one; after email 5 the cadence is spent, so the outcome modal
  // opens — Scott picks the park (his old "Wouldn't Set A Meeting").
  const SE_SCHED_NEXT_DAYS = { 2: 1, 3: 7, 4: 30 }; // email just sent → days until the next
  // THE CHAIN IS ONE CHAIN (Scott 09-23, R&R Fmg): a double-click on "Sent
  // it" for email 2 ran this twice before the plate re-rendered — two
  // step-3 rows, each carried forward on every later click, until a
  // step-4 twin sat on his plate "due today" after he had sent email 4 and
  // clicked the button. Three guards: one click in flight per owner, close
  // EVERY open scheduling row for the owner (not just the one on the card),
  // and never book a step that is already booked.
  const seCadenceBusyRef = useRef(new Set());
  const seCadenceAdvance = async (owner) => {
    if (!supabaseClient || !owner || !owner._commitment) return;
    if (seCadenceBusyRef.current.has(owner.id)) return;
    seCadenceBusyRef.current.add(owner.id);
    const m = /step (\d)\/5/.exec(owner._commitment.note || '');
    const step = m ? Number(m[1]) : 2;
    const nowIso = new Date().toISOString();
    try {
      const { error: tErr } = await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'email_out', channel: 'scheduling', actor: effectiveName,
        subject: `Scheduling follow-up sent (email ${step} of 5)`,
      });
      if (tErr) throw tErr;
      const { data: openSched } = await supabaseClient.from('se_commitments')
        .select('id, note').eq('owner_id', owner.id).eq('status', 'open')
        .ilike('note', 'Scheduling follow-up%');
      const stepOf = (c) => { const mm = /step (\d)\/5/.exec(c.note || ''); return mm ? Number(mm[1]) : 0; };
      const toClose = (openSched || []).filter(c => stepOf(c) <= step).map(c => c.id);
      if (!toClose.includes(owner._commitment.id)) toClose.push(owner._commitment.id);
      await supabaseClient.from('se_commitments')
        .update({ status: 'done', done_at: nowIso }).in('id', toClose);
      await supabaseClient.from('se_owners')
        .update({ last_touch_at: nowIso, updated_at: nowIso }).eq('id', owner.id);
      const nextBooked = (openSched || []).some(c => stepOf(c) === step + 1);
      if (step < 5 && !nextBooked) {
        const days = SE_SCHED_NEXT_DAYS[step] ?? 30;
        const due = new Date(Date.now() + days * 86400000).toISOString().slice(0, 10);
        const { error: cErr } = await supabaseClient.from('se_commitments').insert({
          owner_id: owner.id, due,
          note: `Scheduling follow-up — email ${step + 1} of 5 (step ${step + 1}/5). Cadence: 1d → 1d → 7d → 30d.`,
          created_by: effectiveName,
        });
        if (cErr) throw cErr;
      }
    } catch (e) {
      window.alert('Could not advance the cadence: ' + (e?.message || 'unknown error'));
      return;
    } finally {
      seCadenceBusyRef.current.delete(owner.id);
    }
    setSeTick(t => t + 1);
    // Cadence spent — force the deliberate park decision.
    if (step >= 5) setSeOutcomeTarget(owner);
  };

  // Quick voicemail-style log — a touch, no date changes, card stays.
  const seQuickReached = async (owner) => {
    if (!supabaseClient || !owner) return;
    try {
      const { error } = await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'call', channel: 'phone', actor: effectiveName,
        subject: 'Reached out (no answer / quick touch)',
      });
      if (error) throw error;
      await supabaseClient.from('se_owners')
        .update({ last_touch_at: new Date().toISOString(), updated_at: new Date().toISOString() })
        .eq('id', owner.id);
    } catch (e) { window.alert('Could not log: ' + (e?.message || '')); return; }
    setSeTick(t => t + 1);
  };

  // ✕ No reply needed (UpTime 08-11): the honest exit for "I looked,
  // nothing's hanging" — intro chatter, courtesy notes. A touch, not a
  // clock edit: a NEW email from the owner re-fires the card.
  const seNoReplyNeeded = async (owner) => {
    if (!supabaseClient || !owner) return;
    // Reason REQUIRED (Mark 08-13: "we can't let him clear things off his
    // plate with a simple button push — there has to be action or we force
    // him to explain strategy"). The reason is the record's defense of the
    // decision, and it shows on the 📝 line forever.
    const note = window.prompt('No reply needed — WHY is nothing hanging? Required, saved to the record.\n(e.g. "intro chatter, no ask" · "courtesy thank-you" · "handled by phone — see outcome")', '');
    if (note === null) return; // cancel = never mind
    if (!note.trim()) { window.alert('A reason is required — the record has to show why no reply was the right call.'); return; }
    try {
      const { error } = await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'no_reply_needed', channel: 'se', actor: effectiveName,
        subject: 'No reply needed — ' + note.trim(),
      });
      if (error) throw error;
      // Clear the card across bands, not just reply-due (Adam/ASI Networks
      // 09-15: he pressed ✕ on ASI and "nothing happened" — the ✕ only cleared
      // the reply-due band via the no_reply_needed touch, but ASI was carding
      // on an OPEN COMMITMENT due today, which the touch never touched). A
      // reasoned "nothing hanging" retires the owner's CURRENTLY-DUE
      // commitments (the dangle carding the promise band now); future-dated
      // commitments a deliberate follow-up he set are left intact.
      const todayIso = new Date().toISOString().slice(0, 10);
      const { data: dueC } = await supabaseClient.from('se_commitments')
        .select('id, created_by').eq('owner_id', owner.id).eq('status', 'open').lte('due', todayIso).then(r => ({ ...r, data: (r.data || []).filter(c => seRetirableBy(c, effectiveName)) }));
      if (dueC && dueC.length) {
        await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).in('id', dueC.map(c => c.id));
        await supabaseClient.from('se_touches').insert({
          owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
          subject: `No reply needed — retired ${dueC.length} due reminder${dueC.length === 1 ? '' : 's'} (nothing hanging: ${note.trim()})`,
        });
      }
    } catch (e) { window.alert('Could not record: ' + (e?.message || '')); return; }
    releaseFetched(owner.id);   // ✕ is a decision — closes the fetch
    setSeTick(t => t + 1);
  };

  // ⏰ Remind me (UpTime 08-11): a dated return with a strategy note —
  // "sent the follow-up, check back if they don't respond." Lands as a
  // promise card on the date, note riding it.
  // Setting a reminder must also CLEAR what carded the owner today, or the
  // button reads as broken (Adam's LeeShanok report 08-12: reply-due card,
  // picked 6 months, "nothing happened" — the reminder saved but the card
  // just sat there, because each section cards off its own clock):
  //  · replydue → the ✕-style deferral touch (picking a return date IS the
  //    decision not to answer today; a fresh owner email re-fires the card
  //    before the date)
  //  · promises → retire the due commitment it rode in on (superseded, not
  //    done) + move an arrived next_touch_at to the new date. Scheduling-
  //    cadence chains are deliberately untouched — ✉ Sent it owns those.
  //  · ideas → retires the owner's other open reminders (the card's own
  //    promise: "your pick here retires them"); the future reminder also
  //    suppresses pick-the-play via the band-4 created_by check (Red Five
  //    08-17 — band 4 previously only consulted next_touch_at).
  const seRemindMe = async (owner, due, note, cardMode, type) => {
    if (!supabaseClient || !owner || !due) return;
    try {
      // Type rides the note as a natural-language prefix (Mark 09-16) — the
      // card reads it back as a chip; default Follow-up if none was picked.
      const typeLabel = { followup: 'Follow-up', checkin: 'Check-in', waiting: 'Waiting on them' }[type] || 'Follow-up';
      const { data: newC, error } = await supabaseClient.from('se_commitments').insert({
        owner_id: owner.id, due,
        note: `${typeLabel}: ${(note || '').trim() || 'check back'}`,
        created_by: effectiveName,
      }).select('id').single();
      if (error) throw error;
      // Ideas / pick-the-play cards SAY "your pick here retires them" —
      // ⏰ must honor that too (Red Five 08-17: Adam's December reminder
      // left the 3 stacked junk chains alive). Retire every OTHER open
      // reminder; the new one is the strategy now.
      // …and EVERY mode must honor it, not just ideas (Adam 08-20: "the
      // cards still shouldn't be showing if I selected remind me on X
      // date" — correct; promises-mode ⏰ cancelled only its own driver and
      // replydue-mode none, so a pick left stacked import chains alive to
      // card again later). The new reminder IS the strategy: everything
      // else open retires, whatever card the pick came from.
      {
        const { data: openC } = await supabaseClient.from('se_commitments')
          .select('id, created_by').eq('owner_id', owner.id).eq('status', 'open').neq('id', newC.id).then(r => ({ ...r, data: (r.data || []).filter(c => seRetirableBy(c, effectiveName)) }));
        if (openC && openC.length) {
          await supabaseClient.from('se_commitments')
            .update({ status: 'cancelled' }).in('id', openC.map(c => c.id));
          await supabaseClient.from('se_touches').insert({
            owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
            subject: `Reminder set for ${due} — retired ${openC.length} stacked reminder${openC.length === 1 ? '' : 's'} (the pick replaces the chain)`,
          });
        }
      }
      if (cardMode === 'replydue') {
        const { error: tErr } = await supabaseClient.from('se_touches').insert({
          owner_id: owner.id, kind: 'no_reply_needed', channel: 'se', actor: effectiveName,
          subject: `Deferred — reminder set for ${due}` + ((note || '').trim() ? ` — ${note.trim()}` : ''),
        });
        if (tErr) throw tErr;
      }
      // A stale owner-consented date re-dates to the pick — any mode
      // (was promises-only; a replydue ⏰ on a stale-dated owner left the
      // old date to card again).
      {
        const todayIso = new Date().toISOString().slice(0, 10);
        if (owner.next_touch_at && owner.next_touch_at <= todayIso) {
          const { error: nErr } = await supabaseClient.from('se_owners')
            .update({ next_touch_at: due, updated_at: new Date().toISOString() }).eq('id', owner.id);
          if (nErr) throw nErr;
        }
      }
    } catch (e) { window.alert('Could not set the reminder: ' + (e?.message || '')); return; }
    releaseFetched(owner.id);   // ⏰ is a decision — closes the fetch
    setSeTick(t => t + 1);
  };

  // ⏰ Remind me — from a meeting-truth card (Mark 09-15: "a reminder button
  // on this card so they don't have to dig deeper"). Self-contained, no
  // retire-all side effect: a project reminder when the meeting is tied to a
  // valuation (surfaces on the actor's My Work due-reminders), else an owner
  // commitment for an SE-only meeting (surfaces on their SE serving cards).
  const meetingRemindMe = async (mt, due, note) => {
    if (!supabaseClient || !mt || !due) return;
    try {
      if (mt.valuation_id) {
        const { error } = await supabaseClient.from('project_reminders').insert({
          project_id: mt.valuation_id, actor_email: userEmail,
          remind_at: due, note: (note || '').trim() || 'Meeting follow-up',
        });
        if (error) throw error;
      } else if (mt.owner && mt.owner.id) {
        const { error } = await supabaseClient.from('se_commitments').insert({
          owner_id: mt.owner.id, due,
          note: `Reminder — ${(note || '').trim() || 'meeting follow-up'}`,
          created_by: effectiveName,
        });
        if (error) throw error;
      } else { window.alert('No deal or owner on this meeting to attach a reminder to.'); return; }
      setSeTick(t => t + 1);
    } catch (e) { window.alert('Could not set the reminder: ' + (e?.message || '')); }
  };

  // ⏳ Waiting on their reply (Mark 08-21, the Zobrist gap): after an
  // outreach the conversation is on the OWNER's clock, and neither old pick
  // fits — no outcome has happened yet, and the right date depends on
  // whether they answer. One click arms a 2-business-day watch:
  //  · they reply first → the email sync retires the watch (the reminder
  //    law holds: this reminder was explicitly conditional — "ask me IF no
  //    response" — so the response arriving retires it by the human's own
  //    instruction) and the reply-due card takes over
  //  · silence → a promise card serves the now-answerable question
  // Like ⏰, arming IS the strategy: every other open reminder retires.
  // The sync also AUTO-arms this watch whenever an outbound clears a
  // reply-due with nothing else planned — every active conversation is
  // always in exactly one state: on their clock (watched) or on ours
  // (carded); no third state where a thread evaporates.
  const seAddBusinessDays = (from, n) => {
    const d = new Date(from);
    let left = n;
    while (left > 0) { d.setDate(d.getDate() + 1); if (![0, 6].includes(d.getDay())) left--; }
    return d.toISOString().slice(0, 10);
  };
  // ↪ SOMEONE ELSE HAS IT (Adam 10-01, Compass: Zac was working it, the card sat on Adam's plate and the
  // only way off was ⏰ a made-up date). Hands the record to the person working it: assigned_to moves,
  // this card's reminder/date is retired, the hand-off is logged. No card for them — they own it now.
  const SE_HANDOFF_NAMES = ['Zac', 'Thatcher', 'Adam', 'Scott', 'Colleen', 'Mark'];
  const seHandOff = async (owner) => {
    if (!supabaseClient || !owner) return;
    const others = SE_HANDOFF_NAMES.filter(n => n !== effectiveName);
    const raw = window.prompt(`${owner.company_name}: who is working this?\n\n${others.join(' · ')}\n\nThe record moves to them and this card clears. Type the name:`);
    if (raw === null) return;
    const who = SE_HANDOFF_NAMES.find(n => n.toLowerCase() === String(raw).trim().toLowerCase());
    if (!who) { window.alert('Type one of: ' + others.join(', ')); return; }
    const nowIso = new Date().toISOString();
    try {
      const upd = { assigned_to: who, updated_at: nowIso };
      if (!owner._commitment) upd.next_touch_at = null;   // the card was the record's date
      const { error } = await supabaseClient.from('se_owners').update(upd).eq('id', owner.id);
      if (error) throw error;
      if (owner._commitment && owner._commitment.id) {
        await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).eq('id', owner._commitment.id);
      }
      await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
        subject: `↪ ${who} is working this — record handed from ${owner.assigned_to || 'unassigned'} to ${who}; ${effectiveName}'s reminder card cleared`,
      });
    } catch (e) { window.alert('Could not hand it off: ' + (e?.message || '')); return; }
    releaseFetched(owner.id);
    setSeTick(t => t + 1);
  };
  // ✕ DROP THIS DATE — imported Zoho dates only (no SE pick behind them). The date was never anyone's
  // plan, so dropping it needs no new date; one line on why goes on the record. Dates a person set in SE
  // keep the honest resolves (Log outcome / ⏰ / ⏳).
  const seDropDate = async (owner) => {
    if (!supabaseClient || !owner) return;
    const why = window.prompt(`${owner.company_name}: drop this imported Zoho date — no follow-up needed.\n\nOne line on why (e.g. "Zac has it", "already handled", "not a fit"):`);
    if (why === null) return;
    if (!String(why).trim()) { window.alert('One line on why, please — it stays on the record.'); return; }
    try {
      if (owner._commitment && owner._commitment.id) {
        const { error } = await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).eq('id', owner._commitment.id);
        if (error) throw error;
      } else {
        const { error } = await supabaseClient.from('se_owners').update({ next_touch_at: null, updated_at: new Date().toISOString() }).eq('id', owner.id);
        if (error) throw error;
      }
      await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
        subject: `✕ Imported Zoho date dropped — ${String(why).trim()}`,
      });
    } catch (e) { window.alert('Could not drop the date: ' + (e?.message || '')); return; }
    releaseFetched(owner.id);
    setSeTick(t => t + 1);
  };
  const seAwaitReply = async (owner) => {
    if (!supabaseClient || !owner) return;
    // Honesty guard (Mark's 08-13 law — no clearing without action): the
    // watch presumes an outreach actually went out. Email truth or a touch
    // inside 2 days counts; otherwise confirm before arming.
    const outNewer = owner.last_outbound_at
      && (!owner.last_inbound_at || owner.last_outbound_at > owner.last_inbound_at);
    const touchedRecently = owner.last_touch_at
      && (Date.now() - new Date(owner.last_touch_at).getTime()) < 2 * 86400000;
    if (!outNewer && !touchedRecently
      && !window.confirm('No sent email or recent touch is on this record yet — ⏳ is for right after you reach out. Arm the 2-day watch anyway?')) return;
    const due = seAddBusinessDays(new Date(), 2);
    const todayIso = new Date().toISOString().slice(0, 10);
    try {
      const { data: newC, error } = await supabaseClient.from('se_commitments').insert({
        owner_id: owner.id, due,
        note: `Awaiting reply — watching since ${todayIso}; silent by ${due} → pick the play`,
        created_by: effectiveName,
      }).select('id').single();
      if (error) throw error;
      const { data: openC } = await supabaseClient.from('se_commitments')
        .select('id, created_by').eq('owner_id', owner.id).eq('status', 'open').neq('id', newC.id).then(r => ({ ...r, data: (r.data || []).filter(c => seRetirableBy(c, effectiveName)) }));
      if (openC && openC.length) {
        await supabaseClient.from('se_commitments')
          .update({ status: 'cancelled' }).in('id', openC.map(c => c.id));
      }
      await supabaseClient.from('se_touches').insert({
        owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
        subject: `⏳ Waiting on their reply — watch set for ${due}; their email retires it, silence cards the play${openC && openC.length ? ` (retired ${openC.length} stacked reminder${openC.length === 1 ? '' : 's'})` : ''}`,
      });
      // A stale owner-consented date re-dates to the watch (same as ⏰).
      if (owner.next_touch_at && owner.next_touch_at <= todayIso) {
        await supabaseClient.from('se_owners')
          .update({ next_touch_at: due, updated_at: new Date().toISOString() }).eq('id', owner.id);
      }
    } catch (e) { window.alert('Could not arm the reply watch: ' + (e?.message || '')); return; }
    releaseFetched(owner.id);   // ⏳ is a decision — closes the fetch
    setSeTick(t => t + 1);
  };

  // 30-day snooze — someone else fills the slot tomorrow. On PROMISE cards
  // the reason is REQUIRED and logged (Mark 08-13: no clearing without
  // action or explained strategy — a promise was made to the owner, so
  // deferring it needs a why on the record). Idea cards stay one-click:
  // declining a suggestion isn't breaking a promise. Reply-due cards don't
  // offer snooze at all (it never cleared them — false affordance).
  const seSnooze = async (owner, cardMode) => {
    if (!supabaseClient || !owner) return;
    let note = null;
    if (cardMode === 'promises') {
      note = window.prompt('Snoozing a PROMISED follow-up 30 days — why? Required, saved to the record.', '');
      if (note === null) return;
      if (!note.trim()) { window.alert('A reason is required — this follow-up was promised to the owner.'); return; }
    }
    const next = new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10);
    try {
      const { error } = await supabaseClient.from('se_owners')
        .update({ next_touch_at: next, updated_at: new Date().toISOString() })
        .eq('id', owner.id);
      if (error) throw error;
      if (note) {
        await supabaseClient.from('se_touches').insert({
          owner_id: owner.id, kind: 'note', channel: 'se', actor: effectiveName,
          subject: `Snoozed 30 days (to ${next}) — ${note.trim()}`,
        });
      }
    } catch (e) { window.alert('Could not snooze: ' + (e?.message || '')); return; }
    releaseFetched(owner.id);   // snooze is a decision — closes the fetch
    setSeTick(t => t + 1);
  };

  // Format a viewer email into a display name (mirrors the client list).
  const formatViewerName = (email) => {
    const local = (email || '').split('@')[0];
    if (!local) return 'Someone';
    return local.split(/[._-]+/).filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  };

  // Poll file presence so the dashboard warns "someone is in this file" the
  // same way the client list does — opening a file from the dashboard
  // otherwise gives no warning, which has caused lost work.
  useEffect(() => {
    if (!supabaseClient) return;
    let cancelled = false;
    const fetchPresence = async () => {
      try {
        const { data: { session } } = await supabaseClient.auth.getSession();
        const myId = session?.user?.id;
        const cutoff = new Date(Date.now() - 90 * 1000).toISOString();
        const { data, error } = await supabaseClient
          .from('valuation_presence')
          .select('valuation_id, user_id, user_email')
          .gte('last_seen', cutoff);
        if (error || cancelled) return;
        const map = {};
        (data || []).forEach(p => {
          if (myId && p.user_id === myId) return; // hide myself
          if (!map[p.valuation_id]) map[p.valuation_id] = [];
          map[p.valuation_id].push(formatViewerName(p.user_email));
        });
        // Only redraw when someone opened or closed a deal (Zac 10-23: the 20-second redraw wiped card progress).
        setPresenceByValuation(prev => (JSON.stringify(prev) === JSON.stringify(map) ? prev : map));
      } catch (err) { /* non-fatal — presence is advisory */ }
    };
    fetchPresence();
    const interval = setInterval(fetchPresence, 20 * 1000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!supabaseClient) { setLoading(false); return; }
      setLoading(true);
      setError('');
      try {
        // 1. Active projects (excludes the four terminal/exit stages)
        const { data: vals, error: vErr } = await supabaseClient
          .from('valuations')
          .select('id, client_id, name, version, updated_at, workflow_stage, stage_entered_at, path, colleen_review_decision, account_manager, lead, likelihood_pct, owner_first_name, owner_email, owner_additional, first_meeting_date, discovery_meeting_date, committed_upload_date, owner_target_valuation_date, upload_started_date, upload_complete_date, valuation_date, next_meeting_date, next_meeting_type, snooze_until, snooze_reason, open_items_open, open_items_resolved, questions_to_send, questions_awaiting, owner_answer_unreviewed, owner_form_unreviewed, owner_uploads_done, owner_intent, owner_priority, value_provided_high, estimated_commission, revalue_docs_pending, revalue_review_pending, portal_docs_released, financial_reminder_paused, books_lag_months, as_of_date, as_of_prompt_snooze_until, upload_started_date, upload_complete_date, buyside, ai_status, ttm_config:data->monthlyTtmConfig, account_type:data->>accountType');
        if (vErr) throw vErr;

        // 2. Clients (for company name + vista_id — the DM join key)
        const clients = await fetchAllRows(() => supabaseClient
          .from('clients')
          .select('id, company_name, vista_id, marketing_source'));
        const clientById = {};
        (clients || []).forEach(c => { clientById[c.id] = c; });

        // 1b. First-Mile extras (migration 047) — separate NON-FATAL query so
        // the dashboard keeps loading before the migration is applied.
        const fmExtrasById = {};
        try {
          const ex = await fetchAllRows(() => supabaseClient
            .from('valuations').select('id, priority_stars, comm_pref, comm_pref_phone'));
          (ex || []).forEach(r => { fmExtrasById[r.id] = r; });
        } catch (e) { console.warn('First-mile extras skipped (apply migration 047):', e); }

        // 2a. Deal Manager listings (#6 A1) — via the server route (service
        // role; DM tables aren't visible to the browser's anon client).
        // Non-fatal: the dashboard still loads if DM is unreachable; the
        // ladder's Under LOI rung shows a warning instead of silently
        // rendering incomplete numbers.
        try {
          const { data: { session } } = await supabaseClient.auth.getSession();
          const at = session && session.access_token;
          const r = await fetch('/api/dm/listings', { headers: { Authorization: 'Bearer ' + at } });
          const d = await r.json().catch(() => ({}));
          if (!cancelled) setDmListings((r.ok && d.ok) ? (d.listings || []) : null);
          if (!cancelled && r.ok && d.ok) setLoiSignings(d.loi_signings || []);
          if (!cancelled && r.ok && d.ok) setDmStatusLog(d.status_log || []);
          if (!cancelled && r.ok && d.ok) setDmSheetHistory(d.sheet_history || null);
          if (!cancelled && r.ok && d.ok) setDmDateOverrides(d.date_overrides || null);
          if (!cancelled && r.ok && d.ok) setDmBuyersByMonth(d.buyers_by_month || null);
        } catch (e) {
          console.warn('DM listings fetch failed (ladder shows VT-only):', e);
          if (!cancelled) setDmListings(null);
        }

        // 2a-i-b. DM closings (#6 B1) — same gate, same non-fatal semantics;
        // independent of the listings fetch so one failing never nulls the other.
        try {
          const { data: { session } } = await supabaseClient.auth.getSession();
          const at = session && session.access_token;
          const rc = await fetch('/api/dm/closings', { headers: { Authorization: 'Bearer ' + at } });
          const dc = await rc.json().catch(() => ({}));
          if (!cancelled) setDmClosings((rc.ok && dc.ok) ? (dc.closings || []) : null);
        } catch (e) {
          console.warn('DM closings fetch failed (Closed Deals tab shows a warning):', e);
          if (!cancelled) setDmClosings(null);
        }

        // 2a-i-b2. DM My Work signals (consolidation Phase 1) — non-fatal:
        // no DM reachability never blocks the rest of the dashboard.
        try {
          const { data: { session } } = await supabaseClient.auth.getSession();
          const at = session && session.access_token;
          const rw = await fetch('/api/dm/my-work', { headers: { Authorization: 'Bearer ' + at } });
          const dw = await rw.json().catch(() => ({}));
          if (!cancelled) setDmMyWork((rw.ok && dw.ok) ? (dw.items || []) : []);
        } catch (e) {
          if (!cancelled) setDmMyWork([]);
        }

        // 2a-i-c. Metric snapshots (#6 B2) — non-fatal: before migration 036
        // the table doesn't exist and the Committee tab shows a setup note.
        try {
          const sRows = await fetchAllRows(() => supabaseClient.from('metric_snapshots').select('week_of, metric_key, value').order('week_of', { ascending: true }));
          if (!cancelled) setMetricSnapshots(sRows || []);
        } catch (e) {
          console.warn('Metric snapshots fetch skipped (Committee tab shows setup note):', e);
          if (!cancelled) setMetricSnapshots(null);
        }

        // 2a-i-c2. Buyside client stocks for the Committee funnel chips (Mark
        // 09-01) — Engaged vs Active/Very Active buyside_status counts. Tiny
        // (<100 rows carry a status); non-fatal.
        try {
          const { data: bsRows } = await supabaseClient.from('se_buyers')
            .select('buyside_status').not('buyside_status', 'is', null);
          if (!cancelled) {
            const engaged = (bsRows || []).filter(r => /^engaged/i.test(r.buyside_status || '')).length;
            const active = (bsRows || []).filter(r => /active/i.test(r.buyside_status || '')).length;
            setBsStocks({ engaged, active });
          }
        } catch (e) { if (!cancelled) setBsStocks(null); }

        // 2a-i-d. Valuation/discovery-date history for the gauge baselines —
        // tiny columns, every stage. Non-fatal: gauges fall back to live rows.
        try {
          const vh = await fetchAllRows(() => supabaseClient.from('valuations')
            .select('id, client_id, valuation_date, discovery_meeting_date, path, value_provided_high, buyside')
            .or('valuation_date.not.is.null,discovery_meeting_date.not.is.null'));
          if (!cancelled) setValuationHistory((vh || []).filter(p => !p.buyside));
        } catch (e) {
          console.warn('Valuation history fetch skipped (gauges use live rows):', e);
          if (!cancelled) setValuationHistory(null);
        }

        // 2a-i-e. Imported metric events (migration 037) — non-fatal: before
        // the migration the gauges just use VT-native history.
        try {
          const ie = await fetchAllRows(() => supabaseClient.from('imported_metric_events')
            .select('kind, event_date, value'));
          if (!cancelled) setImportedEvents(ie || []);
        } catch (e) {
          console.warn('Imported events fetch skipped (gauges use VT history only):', e);
          if (!cancelled) setImportedEvents([]);
        }

        // 2a-ii. Targets (#6 A3) — non-fatal: before migration 035 the table
        // doesn't exist and the gauges simply render without target bars.
        try {
          const tRows = await fetchAllRows(() => supabaseClient.from('targets').select('*'));
          if (!cancelled) setTargets(tRows || []);
        } catch (e) {
          console.warn('Targets fetch skipped (gauges render targetless):', e);
          if (!cancelled) setTargets([]);
        }

        // 2a-iii. Stage-transition history (#6 A4) — only stage_changed rows,
        // and only those whose metadata captured the entered stage (older
        // events predate from/to capture; the Stage Flow header shows the
        // history start so partial history is never read as slow weeks).
        try {
          const evRows = await fetchAllRows(() => supabaseClient
            .from('project_activity_log')
            .select('project_id, at, metadata')
            .eq('kind', 'stage_changed')
            .order('at', { ascending: true }));
          // Buy-side projects' transitions stay out of Stage Flow + the engaged gauge
          const buysideIds = new Set((vals || []).filter(v => v.buyside).map(v => v.id));
          if (!cancelled) setStageEvents((evRows || []).filter(e => e.metadata && e.metadata.to && !buysideIds.has(e.project_id)));
        } catch (e) {
          console.warn('Stage-events fetch skipped (Stage Flow hidden):', e);
          if (!cancelled) setStageEvents([]);
        }

        // 2a-iii-b. Owner-engagement latency (Conversion card): intro sends
        // (outreach w/ metadata.kind='warm_intro', logged since 2026-06-24) +
        // each project's FIRST owner_responded. Non-fatal; row hides without it.
        try {
          const actRows = await fetchAllRows(() => supabaseClient
            .from('project_activity_log')
            .select('project_id, at, kind, metadata')
            .in('kind', ['outreach', 'owner_responded'])
            .order('at', { ascending: true }));
          const intro = {}, firstResp = {};
          (actRows || []).forEach(r => {
            if (r.kind === 'outreach' && r.metadata && r.metadata.kind === 'warm_intro') {
              if (!intro[r.project_id]) intro[r.project_id] = r.at;
            } else if (r.kind === 'owner_responded') {
              if (!firstResp[r.project_id]) firstResp[r.project_id] = r.at;
            }
          });
          if (!cancelled) setOwnerEngagement({ intro, firstResp });
        } catch (e) {
          console.warn('Owner-engagement fetch skipped (Conversion latency row hidden):', e);
          if (!cancelled) setOwnerEngagement(null);
        }

        // 2b. Prior-cycle marker (returning-client spec Phase 2): any archived
        // revision in valuation_revisions means the deal has been revalued at
        // least once → the pipeline badges it '↻ Revalue'. Ids only — cheap.
        let revaluedIds = new Set();
        try {
          const revRows = await fetchAllRows(() => supabaseClient
            .from('valuation_revisions').select('valuation_id'));
          revaluedIds = new Set((revRows || []).map(r => r.valuation_id));
        } catch (e) { console.warn('Revisions fetch skipped (badges only):', e); }

        // 3. Activity per project — keep the latest of ANY kind and the
        //    latest INTERACTION kind separately.
        const activities = await fetchAllRows(() => supabaseClient
          .from('project_activity_log')
          .select('project_id, at, note, kind, actor_name, metadata')
          .order('at', { ascending: false }));
        const latestInteractionByProject = {};
        const lastReminderByProject = {};      // most recent reminder_sent per project
        const lastUploadByProject = {};        // most recent document_received per project
        const lastQuestionsSentByProject = {}; // most recent questions_sent per project
        const agreementOutByProject = {};      // most recent agreement_out per project (Mark 09-28)
        (activities || []).forEach(a => {
          if (a.kind === 'agreement_out' && !agreementOutByProject[a.project_id]) {
            agreementOutByProject[a.project_id] = a;
          }
          if (isInteractionKind(a.kind) && !latestInteractionByProject[a.project_id]) {
            latestInteractionByProject[a.project_id] = a;
          }
          if (a.kind === 'reminder_sent' && !lastReminderByProject[a.project_id]) {
            lastReminderByProject[a.project_id] = a;
          }
          if (a.kind === 'document_received' && !lastUploadByProject[a.project_id]) {
            lastUploadByProject[a.project_id] = a;
          }
          if (a.kind === 'questions_sent' && !lastQuestionsSentByProject[a.project_id]) {
            lastQuestionsSentByProject[a.project_id] = a;
          }
        });
        // 📌 Where it left off (Adam-plate punch list (c), 08-11): newest
        // leave_off note; falls back to a stage_changed INTO a parked state
        // that carried a reason (covers historic stalls made before the
        // required-note rule). Feeds the AM re-engage cards.
        const leaveOffByProject = {};
        (activities || []).forEach(a => {
          if (leaveOffByProject[a.project_id]) return;
          if (a.kind === 'leave_off' && a.note) {
            leaveOffByProject[a.project_id] = { note: a.note, at: a.at, who: a.actor_name };
          } else if (a.kind === 'stage_changed' && a.metadata
            && ['val_complete_inactive', 'stalled_returned_to_am'].includes(a.metadata.to)
            && a.metadata.reason
            // machine tokens, not human context — never show as 📌
            && !/^(meeting-outcome|cadence-final)$/.test(a.metadata.reason)) {
            leaveOffByProject[a.project_id] = { note: a.metadata.reason, at: a.at, who: a.actor_name };
          }
        });
        // EARLIEST document_received per project (list is DESC, so keep
        // overwriting — the last write is the first upload). Funnel input.
        const firstUploadByProject = {};
        (activities || []).forEach(a => {
          if (a.kind === 'document_received') firstUploadByProject[a.project_id] = a;
        });
        // First-Mile touches already sent, parsed from outreach notes
        // ("First-mile T2 …") — the touch cards' don't-repeat memory.
        const firstMileSentByProject = {};
        (activities || []).forEach(a => {
          if (a.kind === 'outreach' && a.note) {
            const m = /^First-mile (T\d[a-z]?)\b/.exec(a.note);
            if (m) (firstMileSentByProject[a.project_id] = firstMileSentByProject[a.project_id] || new Set()).add(m[1]);
          }
        });

        // 3c. Observed email truth (RECOGNITION SLICE — Colleen's Westech
        // complaint 2026-08-03): the email sync stores every owner exchange
        // matched to a deal, so cards can show real outreach without anyone
        // logging it. Latest outbound + inbound per valuation, 60-day window
        // (older earns no recency credit anyway). Non-fatal pre-migration-050.
        const emailTruthByProject = {};
        try {
          const emailWindow = new Date(Date.now() - 60 * 86400000).toISOString();
          const INTERNAL_FROM_RX = /@vistabusinessgroup\.com$/i;
          // Machine mail is not an owner waiting (Konnie 09-10, Little Bird:
          // the "owner emailed you 9/8" was an out-of-office auto-reply —
          // the same lesson the revival section learned from GDC 09-09).
          // Tested on subject AND snippet: Priscilla's OOO subject was
          // "paella, and more paella (oh, and sangria)" — the tell was in
          // the body ("I'm on vacation in sunny Spain"), so subject-only
          // patterns miss real-world auto-replies.
          const AUTO_REPLY_SUBJ_RX = /automatic reply|auto[- ]?reply|autoreply|out of (the )?office|vacation reply|away from (the )?office|\bon vacation\b|\bon holiday\b|limited access to (my )?email|will (respond|reply) (when|upon|after) (i|my) return/i;
          // Calendar responses are not mail (Adam 09-17, Xperts Unlimited: the
          // owner ACCEPTED the meeting invite — Google's "Accepted: …" auto-
          // response was read as "owner emailed you, no reply since" and carded
          // an owner-waiting card for a meeting he'd just booked). Google and
          // Outlook both prefix these by subject; matched on subject only.
          const CAL_RESPONSE_SUBJ_RX = /^\s*(accepted|declined|tentatively accepted|tentative|invitation|updated invitation|new event|canceled event|cancelled event|event (accepted|declined|updated|canceled|cancelled))\s*:/i;
          // ✕ dismissals load FIRST (Zac 09-14, NIC: the owner wears three
          // hats — valuation client, buyer, past-deal party — and his
          // monthly seller-note clawback report carded as "owner waiting"
          // on the valuation. A ✕ can now mute the THREAD: its subject
          // stem is stored, and future inbounds matching the stem never
          // count as the waiting email at all. Muting is exactly as broad
          // as the human's judgment — the topic, never the person.)
          const stemOf = (s) => String(s || '').toLowerCase()
            .replace(/^\s*((re|fwd?|aw)\s*:\s*)+/g, '')
            .replace(/\b(january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sept?|oct|nov|dec|q[1-4])\b/g, '')
            .replace(/\d+/g, '').replace(/[^a-z\s]/g, ' ').replace(/\s+/g, ' ').trim();
          // No window on this fetch: a thread mute must outlive the 60-day
          // email horizon (NIC's clawback report runs for the life of the
          // seller note). Volume is tiny — every row is a deliberate click.
          const { data: nrRows } = await supabaseClient.from('project_activity_log')
            .select('project_id, at, metadata')
            .eq('kind', 'no_reply_needed');
          const mutedStems = {};
          (nrRows || []).forEach(r => {
            const st = r.metadata && r.metadata.thread_stem;
            if (st) (mutedStems[r.project_id] = mutedStems[r.project_id] || new Set()).add(st);
          });
          const emailRows = await fetchAllRows(() => supabaseClient
            .from('se_emails')
            .select('valuation_id, direction, sent_at, mailbox, rfc_message_id, from_email, subject, snippet')
            .not('valuation_id', 'is', null)
            .gte('sent_at', emailWindow)
            .order('sent_at', { ascending: false }));
          (emailRows || []).forEach(e => {
            const t = emailTruthByProject[e.valuation_id] = emailTruthByProject[e.valuation_id] || {};
            // Rows arrive newest-first: the first row per deal is the latest
            // message — its RFC id deep-links the whole Gmail thread.
            if (!t.lastRfc && e.rfc_message_id) t.lastRfc = e.rfc_message_id;
            // Classify by SENDER, not stored direction (Colleen→RVS 08-24:
            // her follow-up to the owner landed in a colleague's synced
            // inbox, stored direction=inbound, and the card said "owner
            // emailed 15 min ago"). Vista-from = we wrote, whatever mailbox
            // held the copy; external-from = they wrote.
            const vistaFrom = INTERNAL_FROM_RX.test(e.from_email || '');
            // Newest message either direction, WITH content (Mark 09-11,
            // the first-mile review: "they have to be able to glance at
            // this, see that there hasn't been any communication and
            // quickly send... OR see there has been correspondence and
            // waive"). Rows arrive newest-first, so first row per deal.
            if (!t.lastMsg && !CAL_RESPONSE_SUBJ_RX.test(String(e.subject || ''))) t.lastMsg = { at: e.sent_at, vistaFrom,
              who: vistaFrom ? (e.from_email || '').split('@')[0] : 'the owner',
              subject: e.subject || '', snippet: e.snippet || '' };
            if (vistaFrom && !t.lastOut) {
              t.lastOut = e.sent_at;
              t.lastOutBy = e.direction === 'outbound' ? e.mailbox : (e.from_email || '').split('@')[0];
            }
            if (!vistaFrom && e.direction === 'inbound' && !t.lastIn
                && !CAL_RESPONSE_SUBJ_RX.test(String(e.subject || ''))
                && !AUTO_REPLY_SUBJ_RX.test(String(e.subject || '') + ' ' + String(e.snippet || ''))
                && !(mutedStems[e.valuation_id] && mutedStems[e.valuation_id].has(stemOf(e.subject)))) { t.lastIn = e.sent_at; t.lastInMailbox = e.mailbox; }
          });
          // ✕ No-reply-needed dismissals (Colleen 09-10): the dismissed
          // inbound never re-cards; a NEWER inbound starts fresh. (Rows
          // already fetched above for the thread stems.)
          (nrRows || []).forEach(r => {
            const t = emailTruthByProject[r.project_id];
            if (!t) return;
            const upTo = (r.metadata && r.metadata.inbound_at) || r.at;
            if (!t.noReplyUpTo || upTo > t.noReplyUpTo) t.noReplyUpTo = upTo;
          });
          // ⏰ Scheduled answers (Mark 09-14, the owner-waiting section
          // review): "yes I do need to follow up, but not for a couple of
          // days." A deferral hides the card until its date; it returns
          // that morning wearing the history — a scheduled reply, not an
          // escape hatch.
          const { data: dfRows } = await supabaseClient.from('project_activity_log')
            .select('project_id, at, metadata')
            .eq('kind', 'reply_deferred').gte('at', emailWindow);
          (dfRows || []).forEach(r => {
            const t = emailTruthByProject[r.project_id];
            if (!t) return;
            t.deferCount = (t.deferCount || 0) + 1;
            if (!t.deferral || r.at > t.deferral.at) t.deferral = { at: r.at,
              until: (r.metadata && r.metadata.until) || null,
              inbound_at: (r.metadata && r.metadata.inbound_at) || null };
          });
        } catch (e) { console.warn('Observed-email fetch skipped (migration 050 pending?):', e?.message || e); }

        // 3b. First-Mile Funnel — every deal that ever had a discovery meeting,
        // terminal stages included (the failures ARE the denominator).
        try {
          const funnelRows = await fetchAllRows(() => supabaseClient
            .from('valuations')
            .select('id, workflow_stage, path, discovery_meeting_date, valuation_date')
            .not('discovery_meeting_date', 'is', null)
            .order('id', { ascending: true }));
          const PASSED_UPLOAD_STAGES = new Set([
            'upload_complete', 'data_entry_complete', 'adjustments_entered', 'analysis_complete',
            'val_meeting_set', 'awaiting_decision',
            // Post-valuation states imply the docs made it in.
            'engaged', 'under_loi', 'strategic_review_set', 'considering_followup',
          ]);
          const passed = (v) => PASSED_UPLOAD_STAGES.has(v.workflow_stage) || !!v.valuation_date;
          const inUpload = (v) => ['awaiting_upload', 'upload_started'].includes(v.workflow_stage);
          const dayDiff = (a, b) => Math.round((new Date(b) - new Date(a + (a.length === 10 ? 'T00:00:00' : ''))) / 86400000);
          const median = (arr) => {
            if (!arr.length) return null;
            const s = [...arr].sort((x, y) => x - y);
            return s.length % 2 ? s[(s.length - 1) / 2] : Math.round((s[s.length / 2 - 1] + s[s.length / 2]) / 2);
          };
          const now = Date.now();
          const windowStats = (fromDays, toDays) => {
            const rows = funnelRows.filter(v => {
              const d = new Date(v.discovery_meeting_date + 'T00:00:00').getTime();
              const age = (now - d) / 86400000;
              return age >= toDays && age < fromDays;
            });
            const conv = rows.filter(passed);
            const toUpload = rows.map(v => {
              const fu = firstUploadByProject[v.id];
              return fu ? dayDiff(v.discovery_meeting_date, fu.at) : null;
            }).filter(d => d != null && d >= 0 && d < 365);
            const toVal = rows.filter(v => v.valuation_date)
              .map(v => dayDiff(v.discovery_meeting_date, v.valuation_date + 'T00:00:00'))
              .filter(d => d >= 0 && d < 365);
            // Mark 2026-08-03: upload-complete → valuation is "way too long on
            // average" — measure it (last upload received → valuation delivered).
            const uploadToVal = rows.filter(v => v.valuation_date && lastUploadByProject[v.id])
              .map(v => dayDiff(lastUploadByProject[v.id].at.slice(0, 10), v.valuation_date + 'T00:00:00'))
              .filter(d => d >= 0 && d < 365);
            return {
              n: rows.length, converted: conv.length,
              pct: rows.length ? Math.round(100 * conv.length / rows.length) : null,
              medFirstUpload: median(toUpload),
              medToValuation: median(toVal),
              medUploadToVal: median(uploadToVal),
              within14: toVal.length ? Math.round(100 * toVal.filter(d => d <= 14).length / toVal.length) : null,
              inFlight: rows.filter(v => !passed(v) && inUpload(v)).length,
            };
          };
          if (!cancelled) setFunnelStats({
            last90: windowStats(90, 0),
            prior90: windowStats(180, 90),
            allTime: windowStats(Infinity, 0),
          });
        } catch (e) {
          console.warn('Funnel stats skipped:', e);
          if (!cancelled) setFunnelStats(null);
        }

        // 4. Checklist items — planned-aware counts per project
        const items = await fetchAllRows(() => supabaseClient
          .from('engagement_checklist_items')
          .select('engagement_id, item_key, display_name, status, verified_at, planned, sharefile_received_at, sharefile_file_id, ai_classification_confidence, owner_na, owner_na_note, pending_notes'));
        // `received` here counts both 'complete' AND 'partial' items
        // (Mark 2026-05-27). An owner who sent 2 of 3 tax returns
        // (marked partial) should count as engaged on that item for
        // X-of-Y display; the partial item still appears in the
        // outstanding list with its "still need" note. Field name
        // `complete` is kept for back-compat — semantic is now
        // "received in any form."
        const isReceived = (s) => s === 'complete' || s === 'partial';
        const countsByProject = {};
        // Which documents are still out, by project — the hover on the docs count (Mark 10-12 staff meeting:
        // "16/18" and nobody could say which two).
        const docItemsByProject = {};
        // Discovery Questionnaire (item 13) answered — set when the owner
        // clicks "questions done" in the portal. Feeds the Lead's
        // pre-discovery nudge card. (Mark 2026-07-23)
        const questionsDoneByProject = {};
        // Stage C: items auto-Received from ShareFile (sharefile_received_at set)
        // that Konnie hasn't entered yet (status not 'complete') — her worklist.
        const sfAwaitingByProject = {};
        // #8: items the OWNER flagged "doesn't apply" (pending Vista's confirm) —
        // surfaced on Konnie's My Work so she doesn't have to open the portal.
        const naByProject = {};
        // AS-OF increment 4: date-sensitive doc states per project — the
        // Advance prompt shows exactly what an advance would re-request.
        const dateSensitiveByProject = {};
        (items || []).forEach(it => {
          if (Number(it.item_key) === 13 && it.status === 'complete') questionsDoneByProject[it.engagement_id] = true;
          if (AS_OF_DATE_SENSITIVE_IDS.has(Number(it.item_key))) {
            (dateSensitiveByProject[it.engagement_id] = dateSensitiveByProject[it.engagement_id] || [])
              .push({ itemKey: String(it.item_key), name: it.display_name, received: it.status === 'complete' || it.status === 'partial' });
          }
          if (it.owner_na && !isReceived(it.status)) {
            (naByProject[it.engagement_id] = naByProject[it.engagement_id] || [])
              .push({ itemKey: it.item_key, name: it.display_name, note: it.owner_na_note || '' });
          }
          (docItemsByProject[it.engagement_id] = docItemsByProject[it.engagement_id] || []).push(it);
          const c = countsByProject[it.engagement_id] ||
            { total: 0, complete: 0, needsVerify: 0, plannedTotal: 0, plannedComplete: 0 };
          c.total += 1;
          if (isReceived(it.status)) c.complete += 1;
          if (it.status === 'complete' && !it.verified_at) c.needsVerify += 1;
          if (it.planned) {
            c.plannedTotal += 1;
            if (isReceived(it.status)) c.plannedComplete += 1;
          }
          countsByProject[it.engagement_id] = c;
          // Awaiting entry = received via ShareFile but Konnie hasn't entered it
          // yet. "Entered" matches isReceived (complete OR partial) — consistent
          // with the Docs count + OIR — so once she marks an item Partial (e.g.
          // entered the years that were provided), it drops off this worklist.
          if (it.sharefile_received_at && !isReceived(it.status)) {
            (sfAwaitingByProject[it.engagement_id] = sfAwaitingByProject[it.engagement_id] || [])
              .push({
                itemKey: it.item_key,
                name: it.display_name,
                receivedAt: it.sharefile_received_at,
                confidence: it.ai_classification_confidence,
                fileId: it.sharefile_file_id || null,
              });
          }
        });
        // The FILE behind each awaiting item (Konnie 10-07, Vision Press: the card
        // said "Salary & Benefits for Owner", the owner's file was named "VP Payroll
        // Summary Andy Nilon.xlsx", so she ticked Payroll Report instead and the
        // card never cleared). The name lives on the ShareFile receipt log line
        // ("<file> → <item> (85%)").
        try {
          const sfEids = Object.keys(sfAwaitingByProject);
          const fileName = new Map();
          for (let i = 0; i < sfEids.length; i += 100) {
            const { data: rcpt } = await supabaseClient.from('project_activity_log')
              .select('note, metadata').in('project_id', sfEids.slice(i, i + 100))
              .eq('kind', 'document_received').eq('actor_name', 'ShareFile').limit(2000);
            (rcpt || []).forEach(r => {
              const fid = r.metadata && r.metadata.sharefile_file_id;
              const nm = String(r.note || '').split(' → ')[0];
              if (fid && nm) fileName.set(fid, nm);
            });
          }
          Object.values(sfAwaitingByProject).forEach(list => list.forEach(x => { if (x.fileId && fileName.has(x.fileId)) x.fileName = fileName.get(x.fileId); }));
        } catch (e) { /* cards render with the item name only */ }

        // 5. Compose dashboard rows
        //    (Personal reminders are fetched in their own effect, keyed on
        //    effectiveEmail, so the "View as" picker re-points them without
        //    reloading the whole pipeline.)
        const today = new Date();
        const todayIso = today.toISOString();
        const composed = (vals || []).map(v => {
          const client = clientById[v.client_id] || {};
          const counts = countsByProject[v.id] ||
            { total: 0, complete: 0, needsVerify: 0, plannedTotal: 0, plannedComplete: 0 };
          const interaction = latestInteractionByProject[v.id] || null;

          // Days in current stage (from stage_entered_at)
          const daysInStage = v.stage_entered_at
            ? businessDaysBetween(v.stage_entered_at, todayIso)
            : null;
          const targetDays = stageTargetDays(v.workflow_stage);
          const stageOverdue = targetDays != null && daysInStage != null && daysInStage > targetDays;

          // Committal date — only meaningful during the upload phase
          const inUploadPhase = UPLOAD_PHASE_STAGES.indexOf(v.workflow_stage) !== -1;
          const daysPastCommitted = (inUploadPhase && v.committed_upload_date)
            ? businessDaysBetween(v.committed_upload_date, todayIso)
            : null;

          // Snooze: never changes the numbers, only how we color them
          const isSnoozed = !!(v.snooze_until && new Date(v.snooze_until) > today);

          // Docs Outstanding — planned-aware, with fallback to all-items
          const usePlanned = counts.plannedTotal > 0;
          const docsDone  = usePlanned ? counts.plannedComplete : counts.complete;
          const docsTotal = usePlanned ? counts.plannedTotal    : counts.total;
          const docsOutstanding = docsTotal > 0 ? (docsTotal - docsDone) : null;
          const docsMissing = (docItemsByProject[v.id] || []).filter(x => (usePlanned ? x.planned : true) && !isReceived(x.status))
            .map(x => (x.display_name || 'Item ' + x.item_key) + (x.pending_notes ? ' — ' + x.pending_notes : ''));

          // Cadence state — weekly reminders + 28-day stop window from
          // committed_upload_date (or last upload, whichever is later).
          // Only applies to upload-phase stages where docs are still being
          // chased; once past upload_started the project moves out of
          // owner-chase mode.
          const cadenceEligible = !v.buyside
            && UPLOAD_PHASE_STAGES.indexOf(v.workflow_stage) !== -1
            && !!v.committed_upload_date;
          let cadence = null;
          if (cadenceEligible) {
            const lastReminder = lastReminderByProject[v.id] || null;
            const lastUpload   = lastUploadByProject[v.id] || null;
            const targetMs = new Date(v.committed_upload_date + 'T00:00:00').getTime();
            const lastUploadMs = lastUpload ? new Date(lastUpload.at).getTime() : 0;
            const anchorMs = Math.max(targetMs, lastUploadMs);
            const stopMs = anchorMs + 28 * 24 * 60 * 60 * 1000;
            const nowMs = today.getTime();
            const todayMs = new Date(today.toISOString().slice(0,10) + 'T00:00:00').getTime();
            const targetReached = todayMs >= targetMs;
            // Floor the stop cutoff to a whole calendar day, matching targetReached
            // and the weekly gate. The stop anchor can be a mid-day UPLOAD timestamp,
            // so comparing the live clock (nowMs) against it flipped weekly→final
            // PARTWAY THROUGH the stop date — surfacing the same account as a weekly
            // reminder in the morning and a final follow-up in the afternoon (the
            // Finite Solutions double-send, 2026-06-29). Compare dates so the handoff
            // happens once, at midnight; weekly and final stay mutually exclusive.
            const stopDateMs = new Date(new Date(stopMs).toISOString().slice(0, 10) + 'T00:00:00').getTime();
            const isPastStopDate = todayMs >= stopDateMs;
            // Reminder gate: 7+ calendar days since the last reminder (or never).
            // Applies to BOTH the weekly AND the final follow-up. Without it on the
            // final, a deal that crosses the stop date the day after a weekly went
            // out fires a final back-to-back (Riverso: weekly 7/7 → final 7/8). The
            // gate keeps at least a week between ANY two owner reminders — the final
            // simply waits until a week after the last weekly. (Sibling of the
            // Finite Solutions weekly/final double-send fix, 2026-06-29.)
            const daysSinceReminder = lastReminder
              ? Math.floor((nowMs - new Date(lastReminder.at).getTime()) / (24*60*60*1000))
              : null;
            const reminderGapOk = lastReminder == null || daysSinceReminder >= 7;
            // #9: once the owner has said "I've uploaded everything," stop the
            // automated nags — the "Owner portal update" card takes over so staff
            // follow up deliberately instead of the weekly/final auto-reminders.
            const ownerSaidDone = !!v.owner_uploads_done;
            const cadenceDue   = !isSnoozed && !ownerSaidDone && targetReached && !isPastStopDate && reminderGapOk;
            const cadenceFinal = !isSnoozed && !ownerSaidDone && isPastStopDate && reminderGapOk;
            cadence = {
              targetDate: v.committed_upload_date,
              lastUploadAt: lastUpload ? lastUpload.at : null,
              lastReminderAt: lastReminder ? lastReminder.at : null,
              daysSinceReminder,
              stopDate: new Date(stopMs).toISOString().slice(0, 10),
              isPastStopDate,
              cadenceDue,
              cadenceFinal,
            };
          }

          const partial = {
            ...v,
            buyside: !!v.buyside,
            discoveryQuestionsDone: !!questionsDoneByProject[v.id],
            company_name: client.company_name || '(unnamed)',
            vista_id: client.vista_id || null,
            vista_id: client.vista_id || null,
            marketing_source: client.marketing_source || null,
            has_prior_cycles: revaluedIds.has(v.id),
            responsibility: stageResponsibility(v),
            counts,
            usePlanned,
            docsDone,
            docsMissing,
            docsTotal,
            docsOutstanding,
            daysInStage,
            targetDays,
            stageOverdue,
            daysPastCommitted,
            isSnoozed,
            interactionKind: interaction ? interaction.kind : null,
            interactionNote: interaction ? (interaction.note || '') : '',
            interactionActor: interaction ? interaction.actor_name : null,
            interactionAt: interaction ? interaction.at : null,
            // Outreach verification (email sync): the claim didn't reconcile
            // against actually-sent mail — visible to Mark AND the AM.
            interactionEmailUnverified: !!(interaction && interaction.metadata && interaction.metadata.email_verified === false),
            emailTruth: emailTruthByProject[v.id] || null,
            openItemsOpen: (v.open_items_open == null ? null : v.open_items_open),
            openItemsResolved: (v.open_items_resolved == null ? null : v.open_items_resolved),
            questionsToSend: (v.questions_to_send == null ? 0 : v.questions_to_send),
            questionsAwaiting: (v.questions_awaiting == null ? 0 : v.questions_awaiting),
            ownerAnswerUnreviewed: !!v.owner_answer_unreviewed,
            // Portal forms (migration 034): owner marked a form finished —
            // review & accept it in the editor (Revenue section banner).
            ownerFormUnreviewed: !!v.owner_form_unreviewed,
            lastQuestionsSentAt: lastQuestionsSentByProject[v.id] ? lastQuestionsSentByProject[v.id].at : null,
            // 📝 Agreement out (Mark 09-28): the owner asked for the engagement
            // agreement and it went out. Current only while the deal is still
            // deciding and the mark is newer than its stage entry (a later
            // exit + return clears it).
            agreementOutAt: (() => {
              const a = agreementOutByProject[v.id];
              if (!a || !['awaiting_decision', 'considering_followup'].includes(v.workflow_stage)) return null;
              if (v.stage_entered_at && new Date(a.at).getTime() < new Date(v.stage_entered_at).getTime() - 5 * 60000) return null;
              return a.at;
            })(),
            daysSinceQuestionsSent: lastQuestionsSentByProject[v.id]
              ? Math.floor((today.getTime() - new Date(lastQuestionsSentByProject[v.id].at).getTime()) / (24*60*60*1000))
              : null,
            cadence,
            // Stage C: docs auto-Received from ShareFile, awaiting Konnie's entry.
            sfAwaiting: sfAwaitingByProject[v.id] || [],
            // First-Mile Cadence (spec 2026-08-03): which touches already went
            // out (parsed from outreach notes) + when anything last uploaded.
            firstMileSent: firstMileSentByProject[v.id] || null,
            lastUploadAt: lastUploadByProject[v.id] ? lastUploadByProject[v.id].at : null,
            priorityStars: fmExtrasById[v.id] ? (fmExtrasById[v.id].priority_stars ?? null) : null,
            commPref: fmExtrasById[v.id] ? (fmExtrasById[v.id].comm_pref || null) : null,
            commPrefPhone: fmExtrasById[v.id] ? (fmExtrasById[v.id].comm_pref_phone || null) : null,
            // Owner self-service portal signals (#8/#9) — surfaced on Konnie's
            // My Work so she needn't open the portal to find them.
            ownerUploadsDone: v.owner_uploads_done || null,
            ownerNaItems: naByProject[v.id] || [],
            _dateSensitiveDocs: dateSensitiveByProject[v.id] || [],
          };
          return { ...partial, nextAction: computeNextAction(partial) };
        });
        // Pipeline gets the full funnel EXCEPT warm (pre-meeting onboarding,
        // deliberately out of the pipeline so no-shows don't clutter it). My
        // Work keeps only the active stages (so terminal/post-valuation rows
        // can't leak into the buckets). Warm feeds its own bucket below.
        // Buy-side engagements (#8 Phase 0) are OUT of the pipeline and every
        // metric built on it — like warm. They stay in `projects` (My Work)
        // so Colleen/Konnie still work them, badged, with zero owner cadence.
        if (!cancelled) setPipelineProjects(composed.filter(p => p.workflow_stage !== 'warm' && !p.buyside));
        if (!cancelled) setProjects(composed.filter(p => ACTIVE_STAGES.indexOf(p.workflow_stage) !== -1));
        // Warm deals also carry their answered-discovery-question count: the
        // "questions done" flag only flips when the owner clicks "I'm
        // finished", so an owner who answered everything but skipped the
        // button read as unanswered (Baxter I.T., Mark 2026-07-23). The
        // nudge card treats real answers as engagement.
        const warmRows = composed.filter(p => p.workflow_stage === 'warm');
        const answeredByProject = {};
        try {
          const warmIds = warmRows.map(p => p.id);
          if (warmIds.length) {
            const { data: ansRows } = await supabaseClient
              .from('owner_question_responses')
              .select('engagement_id, answer')
              .eq('question_type', 'discovery')
              .in('engagement_id', warmIds);
            (ansRows || []).forEach(r => {
              if (String(r.answer || '').trim()) answeredByProject[r.engagement_id] = (answeredByProject[r.engagement_id] || 0) + 1;
            });
          }
        } catch (e) { console.warn('Warm answer counts skipped:', e); }
        if (!cancelled) setWarmProjects(warmRows.map(p => ({ ...p, discoveryAnswerCount: answeredByProject[p.id] || 0 })));

        // Stage C: Sort Queue — ShareFile uploads we couldn't auto-classify
        // (needs_sort) or couldn't map to a project (needs_linkage). Decorated
        // with company name for display. Rendered only on Konnie's My Work.
        const nameByEngagement = {};
        composed.forEach(p => { nameByEngagement[p.id] = p.company_name; });
        const queueRows = await fetchAllRows(() => supabaseClient
          .from('engagement_upload_queue')
          .select('id, engagement_id, sharefile_file_id, sharefile_folder_id, file_name, mime_type, ai_item_id, ai_confidence, ai_rationale, status, received_at')
          .in('status', ['needs_sort', 'needs_linkage'])
          .order('received_at', { ascending: false }));
        if (!cancelled) {
          setSortQueue((queueRows || []).map(r => ({
            ...r,
            company_name: r.engagement_id ? (nameByEngagement[r.engagement_id] || '(project not in active pipeline)') : null,
          })));
        }

        // Strategic-review projects (terminal stage, not in ACTIVE_STAGES) —
        // fetched on their own so Leads can watch upcoming review meetings.
        const { data: reviews } = await supabaseClient
          .from('valuations')
          .select('id, client_id, name, workflow_stage, lead, account_manager, path, stage_entered_at, next_meeting_date, next_meeting_type')
          .eq('workflow_stage', 'strategic_review_set');
        const composedReviews = (reviews || []).map(v => {
          const client = clientById[v.client_id] || {};
          const partial = {
            ...v,
            company_name: client.company_name || '(unnamed)',
            vista_id: client.vista_id || null,
            responsibility: stageResponsibility(v),
            daysInStage: v.stage_entered_at ? businessDaysBetween(v.stage_entered_at, todayIso) : null,
            emailTruth: emailTruthByProject[v.id] || null,
          };
          const dateStr = v.next_meeting_date
            ? new Date(v.next_meeting_date + 'T00:00:00').toLocaleDateString() : null;
          return { ...partial, nextAction: dateStr ? `Strategic review meeting ${dateStr}` : 'Schedule the strategic review' };
        });
        if (!cancelled) setReviewProjects(composedReviews);

        // AM projects (stalled-returned + valued-inactive) — terminal/exit
        // stages, not in ACTIVE_STAGES; fetched on their own for the Account
        // Manager's My Work (stalled handoffs to re-engage + inactive
        // relationships to nurture).
        const { data: amRows } = await supabaseClient
          .from('valuations')
          // discovery_meeting_date + valuation_date feed computeReengageRouting
          // so the card can show the Lead-meeting verdict before the AM acts.
          // value_provided_high tells markOwnerDead whether a valuation was ever
          // produced (routes to val_complete_dead vs the no-valuation disqualified).
          // ai_status rides too (step 2, 08-11): the 🤖 Last/Next/Waiting-on
          // line answers "how did the valuation call go" right on the card.
          .select('id, client_id, name, workflow_stage, lead, account_manager, path, discovery_meeting_date, valuation_date, value_provided_high, stage_entered_at, snooze_until, snooze_reason, ai_status, owner_first_name, owner_last_name, owner_email')
          .in('workflow_stage', ['stalled_returned_to_am', 'val_complete_inactive']);
        // Contact ON the card (Adam 09-28: he kept leaving "Owners to follow up"
        // for the account page just to get the phone number). The SE record
        // carries phone + contact name; the deal carries the owner's email.
        const seContactByClient = new Map();
        try {
          const cids = [...new Set((amRows || []).map(v => v.client_id).filter(Boolean))];
          for (let i = 0; i < cids.length; i += 50) {
            const { data: so } = await supabaseClient.from('se_owners')
              .select('id, vt_client_id, contact_name, phone, emails').in('vt_client_id', cids.slice(i, i + 50));
            (so || []).forEach(o => { if (!seContactByClient.has(o.vt_client_id)) seContactByClient.set(o.vt_client_id, o); });
          }
          const needPhone = [...seContactByClient.values()].filter(o => !o.phone).map(o => o.id);
          for (let i = 0; i < needPhone.length; i += 50) {
            const { data: mails } = await supabaseClient.from('se_emails')
              .select('owner_id, body_text, snippet, from_email, sent_at').in('owner_id', needPhone.slice(i, i + 50))
              .eq('direction', 'inbound').order('sent_at', { ascending: false }).limit(400);
            const got = new Map();
            (mails || []).forEach(m => {
              if (got.has(m.owner_id) || /@vistabusinessgroup\.com$/i.test(m.from_email || '')) return;
              const ph = phoneFromEmailBody(m.body_text || m.snippet);
              if (ph) got.set(m.owner_id, ph);
            });
            seContactByClient.forEach(o => { if (!o.phone && got.has(o.id)) { o.phone = got.get(o.id); o._phoneFromEmail = true; } });
          }
        } catch (e) { /* contact line is a convenience — cards still render */ }
        const composedAm = (amRows || []).map(v => {
          const client = clientById[v.client_id] || {};
          const interaction = latestInteractionByProject[v.id] || null;
          const partial = {
            ...v,
            company_name: client.company_name || '(unnamed)',
            vista_id: client.vista_id || null,
            responsibility: stageResponsibility(v),
            daysInStage: v.stage_entered_at ? businessDaysBetween(v.stage_entered_at, todayIso) : null,
            // snooze_until doubles as the AM's "next touch" date: a future date
            // parks the follow-up; unset/past = due now (the safety net).
            isSnoozed: !!(v.snooze_until && new Date(v.snooze_until) > today),
            // Most recent contact note — shows on the card so the AM has the
            // last conversation's context before the next touch.
            interactionNote: interaction ? (interaction.note || '') : '',
            interactionAt: interaction ? interaction.at : null,
            interactionActor: interaction ? interaction.actor_name : null,
            interactionEmailUnverified: !!(interaction && interaction.metadata && interaction.metadata.email_verified === false),
            emailTruth: emailTruthByProject[v.id] || null,
            leaveOff: leaveOffByProject[v.id] || null,
            contact: (() => {
              const so = seContactByClient.get(v.client_id) || null;
              const name = [v.owner_first_name, v.owner_last_name].filter(Boolean).join(' ') || (so && so.contact_name) || null;
              const email = v.owner_email || (so && Array.isArray(so.emails) ? so.emails[0] : null) || null;
              return { name, phone: (so && so.phone) || null, phoneFromEmail: !!(so && so._phoneFromEmail), email, seOwnerId: so ? so.id : null };
            })(),
          };
          return { ...partial, nextAction: computeNextAction(partial) };
        });
        if (!cancelled) setAmProjects(composedAm);

        // Considering — follow-up-later projects (valuation-active, Lead-owned).
        // Off ACTIVE_STAGES, fetched on their own. snooze_until holds the
        // follow-up date: future → parked ("following up later"); due/past →
        // surfaces on the Lead's plate. Also feeds Colleen's "Following" monitor.
        const { data: followUpRows } = await supabaseClient
          .from('valuations')
          .select('id, client_id, name, workflow_stage, lead, account_manager, path, colleen_review_decision, stage_entered_at, snooze_until, snooze_reason, owner_email, owner_first_name, valuation_date, value_provided_high, next_meeting_date, ai_status')
          .eq('workflow_stage', 'considering_followup');
        const composedFollowUp = (followUpRows || []).map(v => {
          const client = clientById[v.client_id] || {};
          const partial = {
            ...v,
            company_name: client.company_name || '(unnamed)',
            vista_id: client.vista_id || null,
            responsibility: stageResponsibility(v),
            daysInStage: v.stage_entered_at ? businessDaysBetween(v.stage_entered_at, todayIso) : null,
            isSnoozed: !!(v.snooze_until && new Date(v.snooze_until) > today),
            emailTruth: emailTruthByProject[v.id] || null,
          };
          return { ...partial, nextAction: computeNextAction(partial) };
        });
        if (!cancelled) setFollowUpProjects(composedFollowUp);
      } catch (err) {
        console.error('Dashboard load failed:', err);
        if (!cancelled) setError(err.message || 'Failed to load dashboard.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [reloadTick]);

  // "Owner answered" live poll (analysis role): every 60s read the flagged
  // deals; anything newly flagged since the last look raises a toast. First
  // poll seeds silently — the My Work card already shows the morning backlog,
  // toasts are for arrivals DURING the session. When a flag clears (Colleen
  // accepted), the id leaves the seen-set so the deal's NEXT batch re-toasts.
  useEffect(() => {
    if (!supabaseClient || effectiveRole !== 'analysis') { setAnswerToasts([]); seenAnswerFlagsRef.current = null; return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data: flagged } = await supabaseClient.from('valuations')
          .select('id, name, client_id')
          .eq('owner_answer_unreviewed', true);
        if (cancelled || !Array.isArray(flagged)) return;
        const ids = new Set(flagged.map(r => r.id));
        if (seenAnswerFlagsRef.current === null) { seenAnswerFlagsRef.current = ids; return; }
        const fresh = flagged.filter(r => !seenAnswerFlagsRef.current.has(r.id));
        seenAnswerFlagsRef.current = ids;
        if (!fresh.length) return;
        // Company names: one tiny lookup (the poll select stays valuations-only
        // so it never depends on FK-join support).
        let nameById = {};
        try {
          const { data: cs } = await supabaseClient.from('clients')
            .select('id, company_name').in('id', fresh.map(r => r.client_id).filter(Boolean));
          (cs || []).forEach(c => { nameById[c.id] = c.company_name; });
        } catch (_) { /* cosmetic */ }
        setAnswerToasts(prev => {
          const have = new Set(prev.map(t => t.id));
          const add = fresh.filter(r => !have.has(r.id)).map(r => ({
            id: r.id, name: r.name, company: nameById[r.client_id] || 'A client',
          }));
          return add.length ? [...prev, ...add] : prev;
        });
      } catch (_) { /* poll is best-effort; next tick retries */ }
    };
    poll();
    const t = setInterval(poll, 60 * 1000);
    return () => { cancelled = true; clearInterval(t); };
  }, [effectiveRole]);

  // Tab-title badge: "(n) Vista Valuation Tool" while toasts are waiting, so
  // a glance at the browser catches it from Excel/email. Restored at zero.
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.title = answerToasts.length ? `(${answerToasts.length}) ${baseTitleRef.current}` : baseTitleRef.current;
  }, [answerToasts.length]);

  // Personal reminders for the effective user (self, or whoever the owner
  // is viewing as). Own effect so switching "View as" re-fetches reminders
  // without reloading the full pipeline.
  useEffect(() => {
    let cancelled = false;
    const loadReminders = async () => {
      if (!supabaseClient || !effectiveEmail) { setMyReminders([]); return; }
      try {
        const remRows = await fetchAllRows(() => supabaseClient
          .from('project_reminders')
          .select('id, project_id, remind_at, note, created_at')
          .eq('actor_email', effectiveEmail)
          .is('completed_at', null)
          .order('remind_at', { ascending: true }));
        if (!cancelled) setMyReminders(remRows || []);
      } catch (e) { /* non-fatal — reminders are advisory */ }
    };
    loadReminders();
    return () => { cancelled = true; };
  }, [effectiveEmail]);

  // ─── My Work view ───────────────────────────────────────────────
  // "My Work" = every project where I'm the Responsibility, bucketed
  // by urgency. Snoozed projects drop out of the urgent buckets.
  // ⚖ Partial review-decision nudge (Mark 09-03, Colleen's NTi find): a
  // blank "Colleen Review Decision" SAYS "decision needed" but BEHAVES as
  // quick-look — deals land on Colleen's plate with nobody having decided.
  // A partial sitting ≥2 days with the field blank cards its LEAD: one click
  // writes the decision, card clears.
  // (A) DECISION-WHEN-THERE'S-SOMETHING-TO-DECIDE (Mark 09-15): the call is
  // "does Colleen quick-look these numbers?" — meaningless until the numbers
  // exist, so it fires only once documents are IN (upload_complete onward),
  // never in the pre-upload stages. A partial still collecting docs is the
  // document CADENCE's chase (Konnie owns it after the committal), not a
  // routing decision — firing here on an empty partial (Canitan 27d, Eastwind
  // 46d, nothing uploaded) asked a question no one could act on.
  const PARTIAL_DECISION_STAGES = new Set(['upload_complete', 'data_entry_complete', 'adjustments_entered']);
  const partialDecisionCards = useMemo(() => {
    const cutoff = new Date(Date.now() - 2 * 86400000).toISOString();
    return (projects || []).filter(p => p.path === 'partial'
      && !p.colleen_review_decision
      && PARTIAL_DECISION_STAGES.has(p.workflow_stage)
      && (!p.stage_entered_at || p.stage_entered_at <= cutoff)
      && !(p.snooze_until && p.snooze_until > new Date().toISOString().slice(0, 10)))
      .filter(p => effectiveRole === 'owner' || (p.lead || 'Lead') === effectiveName);
  }, [projects, effectiveName, effectiveRole]);
  const partialDecisionSet = async (p, decision) => {
    if (!supabaseClient || !p) return;
    const nowIso = new Date().toISOString();
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ colleen_review_decision: decision, updated_at: nowIso }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed',
        note: `Partial review decision set from the nudge card: ${decision === 'skip' ? 'Skip Colleen — straight to the Lead' : 'Colleen quick-look'}`,
        metadata: { colleen_review_decision: decision, via: 'my_work_card' },
      });
    } catch (e) { window.alert('Could not set the decision: ' + (e?.message || e)); return; }
    setReloadTick(t => t + 1);
  };

  // 🌱 STALL-REVIVAL DETECTOR (Mark 09-08, E2E Tech Solutions: the cadence
  // final note flipped the deal to stalled_returned_to_am and Kamal replied
  // EIGHT MINUTES later — Adam then held a card whose advice was already
  // stale, and the reinstatement the 05-27 design assumed ("reinstate
  // manually if owner responds") had no surface. The rule as Mark stated
  // it: the owner comes back → the committal date resets → THE CLOCK
  // STARTS OVER — Konnie works it until her attempts fail, and only then
  // does it return to the AM. The date belongs to Konnie's conversation,
  // so the resume card is HERS; the AM's card just wears the state until
  // she acts, then clears itself with the stage change.)
  // Detection: a FRESH stall (≤45 days — older revivals go through the
  // AM's full ↻ Re-engage, which archives the cycle) whose owner sent a
  // non-Vista inbound AFTER the stall moment.
  const [stalledRevivals, setStalledRevivals] = useState([]);
  useEffect(() => {
    let cancelled = false;
    // THE REPLY IS THE EVENT, NOT THE STALL'S AGE (Adam 09-25, Precision Digital:
    // stalled 7/14, Arie replied 9/24 — 73 days in, and this 45-day window
    // never looked at the reply, so no 🌱 banner and no Resume door). Any
    // stall inside 18 months qualifies; the reply itself must still be newer
    // than the stall (checked below).
    const stalled = (amProjects || []).filter(p => p.workflow_stage === 'stalled_returned_to_am' && p.stage_entered_at
      && (Date.now() - new Date(p.stage_entered_at).getTime()) / 86400000 <= 540);
    if (!supabaseClient || !stalled.length) { setStalledRevivals([]); return undefined; }
    (async () => {
      try {
        const cids = [...new Set(stalled.map(p => p.client_id).filter(Boolean))];
        const owners = [];
        for (let i = 0; i < cids.length; i += 50) {
          const { data } = await supabaseClient.from('se_owners').select('id, vt_client_id').in('vt_client_id', cids.slice(i, i + 50));
          owners.push(...(data || []));
        }
        const ownerByCid = new Map(owners.map(o => [o.vt_client_id, o.id]));
        const oids = owners.map(o => o.id);
        if (!oids.length) { if (!cancelled) setStalledRevivals([]); return; }
        const minStall = stalled.map(p => p.stage_entered_at).sort()[0];
        const { data: replies } = await supabaseClient.from('se_emails')
          .select('owner_id, from_email, sent_at, snippet, subject')
          .in('owner_id', oids).eq('direction', 'inbound')
          .gte('sent_at', minStall).order('sent_at', { ascending: false }).limit(200);
        // KONNIE'S DAY-ONE REVIEW (09-09, four cards on her first look):
        // ① GDC's "re-engagement" was an OUT-OF-OFFICE auto-reply — machine
        // mail is not a human coming back; filter it. ② The section itself
        // must not claim intent — the system only knows the owner REPLIED;
        // whether it's a revival or a brush-off is Konnie's read, so the
        // card offers Resume AND a "not re-engaging" dismiss (logged, and
        // that reply never re-cards).
        const AUTO_REPLY_RX = /automatic reply|auto[- ]?reply|autoreply|out of (the )?office|vacation reply|away from (the )?office/i;
        // A reply the AM has ALREADY ACTED ON is not a new event (Adam 09-25:
        // eight stalled cards sat on his plate with 🌱 banners — Silverlane's
        // was an August reply he'd answered "check back end of year" on 09-10,
        // Mayfront's an August reply he'd reached out on three times since.
        // Nobody had ever clicked the dismiss; the banner kept overriding his
        // Reschedule and the cards never left). Any staff action logged on
        // the project AFTER the reply — a logged outreach, a no-reply-needed,
        // a deferred reply, or the explicit dismiss — answers it; only a
        // reply NEWER than the last action cards again.
        const { data: dismissals } = await supabaseClient.from('project_activity_log')
          .select('project_id, at, kind, metadata')
          .in('kind', ['revival_dismissed', 'outreach', 'no_reply_needed', 'reply_deferred'])
          .in('project_id', stalled.map(p => p.id));
        const dismissedUntil = {};
        (dismissals || []).forEach(d => {
          const t = d.kind === 'revival_dismissed' ? ((d.metadata && d.metadata.reply_at) || d.at) : d.at;
          if (!dismissedUntil[d.project_id] || t > dismissedUntil[d.project_id]) dismissedUntil[d.project_id] = t;
        });
        // A REMINDER SET IN SE after the reply answers it too (Adam 09-30, Advatek: he emailed the owner and
        // set a January reminder on the SE record; the card still held because only its own buttons counted).
        // The SE reminder already brings the owner back to him — no second reminder (notification rule).
        const { data: seReminders } = await supabaseClient.from('se_commitments')
          .select('owner_id, created_at').in('owner_id', oids).gte('created_at', minStall);
        const seReminderAt = {};
        (seReminders || []).forEach(c => { if (!seReminderAt[c.owner_id] || c.created_at > seReminderAt[c.owner_id]) seReminderAt[c.owner_id] = c.created_at; });
        // Gmail snippets arrive HTML-escaped ("&lt;adam@...&gt;") — show them as written.
        const unescapeSnippet = (s) => String(s || '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
          .replace(/&#39;|&#x27;/g, "'").replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
        const out = [];
        stalled.forEach(p => {
          const oid = ownerByCid.get(p.client_id);
          if (!oid) return;
          const r = (replies || []).find(x => x.owner_id === oid && x.sent_at > p.stage_entered_at
            && !/@vistabusinessgroup\.com$/i.test(String(x.from_email || ''))
            && !AUTO_REPLY_RX.test(String(x.subject || '') + ' ' + String(x.snippet || ''))
            && !(dismissedUntil[p.id] && x.sent_at <= dismissedUntil[p.id])
            && !(seReminderAt[oid] && x.sent_at <= seReminderAt[oid]));
          if (r) out.push({ project: p, ownerId: oid, replyAt: r.sent_at, replyFrom: r.from_email, replySnippet: unescapeSnippet(r.snippet || r.subject || '').slice(0, 160) });
        });
        if (!cancelled) setStalledRevivals(out);
      } catch (e) { if (!cancelled) setStalledRevivals([]); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, amProjects, reloadTick]);
  const revivalByPid = useMemo(() => new Map(stalledRevivals.map(rv => [rv.project.id, rv])), [stalledRevivals]);
  // Konnie's resume: the LIGHT reset — stage back to awaiting_upload with
  // the new committal, nothing archived and nothing wiped (the cycle never
  // ended in substance; the heavy archive-and-reset belongs to the AM's
  // ↻ Re-engage for genuinely old stalls). Her cadence restarts against
  // the new date; blowing it re-runs final-note → back to the AM.
  const revivalResume = async (rv) => {
    if (!supabaseClient) return;
    const p = rv.project;
    const committal = window.prompt(
      `${p.company_name}: the owner replied AFTER the final reminder (${new Date(rv.replyAt).toLocaleDateString()}) and you read it as back-in-motion.\n\n`
      + 'Resume collection: the deal returns to Awaiting Upload, Konnie\'s reminder cadence restarts against the new date, and this card clears. '
      + 'Use the date from their reply or your conversation.\n\n'
      + 'New committed upload date (YYYY-MM-DD):');
    if (!committal) return;
    const c = committal.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(c)) { window.alert('Please enter the date as YYYY-MM-DD.'); return; }
    const nowIso = new Date().toISOString();
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ workflow_stage: 'awaiting_upload', committed_upload_date: c, stage_entered_at: nowIso, snooze_until: null, updated_at: nowIso })
        .eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed',
        note: `Owner re-engaged after the final reminder — collection resumed, new committal ${c}`,
        metadata: { from: 'stalled_returned_to_am', to: 'awaiting_upload', reason: 'owner-re-engaged', committed_upload_date: c },
      });
      setReloadTick(t => t + 1);
    } catch (e) { window.alert('Resume failed: ' + (e?.message || e)); }
  };
  // "Not re-engaging" (Konnie's day-one review, 09-09: two of her four
  // cards were polite deferrals — "pushed back", "sooner rather than
  // later" — which are NOT collection restarts). Her read gets a verb:
  // the judgment is logged, that reply never re-cards, the deal stays
  // stalled on the AM's plate, and a NEWER reply starts fresh.
  const revivalDismiss = async (rv) => {
    if (!supabaseClient) return;
    const p = rv.project;
    const note = window.prompt(
      `${p.company_name}: mark this reply as NOT a restart right now (a deferral like "a month or two", a brush-off, or noise).\n\n`
      + 'Nothing starts. The deal stays with you as a stalled follow-up and comes back on the Reschedule date you set on the card; if the owner writes again, a fresh card appears.\n\n'
      + 'One line on what the reply actually said:');
    if (note === null) return;
    try {
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'revival_dismissed',
        note: `Reply after the final reminder judged NOT a re-engagement: ${(note || '').trim() || '(no note)'}`,
        metadata: { reply_at: rv.replyAt, reply_from: rv.replyFrom },
      });
      setReloadTick(t => t + 1);
    } catch (e) { window.alert('Could not record: ' + (e?.message || e)); }
  };

  // 📋 REVIEW-OUTCOME CARDS (Mark 09-10 "Go" — born from Colleen's 9/9
  // calls: TechNellogic + AT Technology were held, confirmed… and left NO
  // recorded outcome anywhere. The SE side forces Log Outcome after every
  // touch; the strategic-review side asked nothing after a held review.
  // Now a held strategic_review meeting on a review-cadence deal cards the
  // review runner until a decision is on the record. The card self-clears
  // when ANY decision lands: a Start Revalue (revalue_started), one of
  // this card's own writes (review_outcome), or a stage move.)
  const [reviewOutcomes, setReviewOutcomes] = useState([]);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    const cutoffMs = Date.now() - 14 * 86400000;
    const held = (seMeetingsAll || []).filter(m => m.meeting_type === 'strategic_review'
      && m.outcome === 'held' && m.starts_at && new Date(m.starts_at).getTime() > cutoffMs
      && m.owner && m.owner.vt_client_id);
    const byClient = new Map();
    held.forEach(m => { const c = m.owner.vt_client_id; if (!byClient.has(c) || m.starts_at > byClient.get(c).starts_at) byClient.set(c, m); });
    const deals = (reviewProjects || []).filter(p => byClient.has(p.client_id));
    if (!deals.length) { setReviewOutcomes([]); return undefined; }
    (async () => {
      try {
        const ids = deals.map(p => p.id);
        const { data: logs } = await supabaseClient.from('project_activity_log')
          // The ledger's timestamp column is `at` (Colleen 09-25, DDS Tech Pro:
          // she clicked New review date, the write landed, and the card stayed
          // — this query asked for created_at, errored silently, and no card
          // decision ever cleared the section; only a stage move did).
          .select('project_id, at, kind')
          .in('project_id', ids).in('kind', ['review_outcome', 'revalue_started', 'stage_changed'])
          .gte('at', new Date(cutoffMs).toISOString());
        const latestByPid = {};
        (logs || []).forEach(l => { if (!latestByPid[l.project_id] || l.at > latestByPid[l.project_id]) latestByPid[l.project_id] = l.at; });
        const out = deals.map(p => {
          const m = byClient.get(p.client_id);
          const decided = (latestByPid[p.id] && latestByPid[p.id] > m.starts_at)
            || (p.stage_entered_at && p.stage_entered_at > m.starts_at);
          return decided ? null : { p, meetingAt: m.starts_at, meetingSummary: m.summary || '' };
        }).filter(Boolean);
        if (!cancelled) setReviewOutcomes(out);
      } catch (e) { if (!cancelled) setReviewOutcomes([]); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, seMeetingsAll, reviewProjects, reloadTick]);
  const reviewOutcomeAct = async (card, action) => {
    if (!supabaseClient) return;
    const p = card.p;
    const nowIso = new Date().toISOString();
    const log = async (note, metadata) => supabaseClient.from('project_activity_log').insert({
      project_id: p.id, actor_email: userEmail || 'unknown',
      actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
      kind: 'review_outcome', note, metadata: metadata || {},
    });
    try {
      if (action === 'date') {
        const d = window.prompt(`${p.company_name}: next strategic review date (YYYY-MM-DD):`);
        if (!d) return;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(d.trim())) { window.alert('Please enter the date as YYYY-MM-DD.'); return; }
        if (d.trim() <= nowIso.slice(0, 10)) { window.alert(d.trim() + ' is not in the future — enter the NEXT review date (check the year).'); return; }
        const { error } = await supabaseClient.from('valuations').update({ next_meeting_date: d.trim(), next_meeting_type: 'Strategic review', updated_at: nowIso }).eq('id', p.id);
        if (error) throw error;
        await log(`Review held ${String(card.meetingAt).slice(0, 10)} — decision: stay on cadence, next review ${d.trim()}`, { next_meeting_date: d.trim() });
      } else if (action === 'considering') {
        const d = window.prompt(`${p.company_name}: the owner is considering — follow up when? (YYYY-MM-DD):`);
        if (!d) return;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(d.trim())) { window.alert('Please enter the date as YYYY-MM-DD.'); return; }
        if (d.trim() <= nowIso.slice(0, 10)) { window.alert(d.trim() + ' is not in the future — enter the follow-up date (check the year).'); return; }
        const { error } = await supabaseClient.from('valuations').update({ workflow_stage: 'considering_followup', snooze_until: d.trim(), stage_entered_at: nowIso, updated_at: nowIso }).eq('id', p.id);
        if (error) throw error;
        await log(`Review held ${String(card.meetingAt).slice(0, 10)} — decision: considering, follow up ${d.trim()}`, { from: p.workflow_stage, to: 'considering_followup' });
      } else if (action === 'inactive') {
        const why = window.prompt(`${p.company_name}: going inactive — one line on why (shows in the history):`);
        if (why === null) return;
        const { error } = await supabaseClient.from('valuations').update({ workflow_stage: 'val_complete_inactive', stage_entered_at: nowIso, updated_at: nowIso }).eq('id', p.id);
        if (error) throw error;
        await log(`Review held ${String(card.meetingAt).slice(0, 10)} — decision: inactive. ${(why || '').trim()}`, { from: p.workflow_stage, to: 'val_complete_inactive' });
      }
      setReloadTick(t => t + 1);
    } catch (e) { window.alert('Could not record: ' + (e?.message || e)); }
  };

  // 🗓 Set-review-date on the dateless-review card (Mark 09-10): the one
  // verb the card exists for. Same write as reviewOutcomeAct's 'date' branch
  // but without a held meeting attached.
  const setReviewDateAct = async (p) => {
    if (!supabaseClient) return;
    const d = window.prompt(`${p.company_name}: this deal has promised a strategic review since ${String(p.stage_entered_at || '').slice(0, 10)} with no date.\n\nNext review date (YYYY-MM-DD):`);
    if (!d) return;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d.trim())) { window.alert('Please enter the date as YYYY-MM-DD.'); return; }
    try {
      const { error } = await supabaseClient.from('valuations').update({ next_meeting_date: d.trim(), next_meeting_type: 'Strategic review', updated_at: new Date().toISOString() }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'review_scheduled',
        note: `Next strategic review set to ${d.trim()} from the no-date card (stage had promised a review with no date since ${String(p.stage_entered_at || '').slice(0, 10)})`,
        metadata: { next_meeting_date: d.trim(), via: 'dateless_review_card' },
      });
      setReloadTick(t => t + 1);
    } catch (e) { window.alert('Could not set the date: ' + (e?.message || e)); }
  };

  // ⏰ Scheduled answer on the owner-waiting card (Mark 09-14): the reply
  // is real but not today's — hide until the date, return wearing history.
  const ownerWaitingDefer = async (p) => {
    if (!supabaseClient || !p) return;
    const todayIso0 = new Date().toISOString().slice(0, 10);
    const d = window.prompt(
      `${p.company_name}: you'll answer the owner on which date? (YYYY-MM-DD)\n\n`
      + 'The card hides until then and returns that morning showing this deferral — a scheduled reply, not a skip. The one-business-day standard stays the default.');
    if (!d) return;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d.trim()) || d.trim() <= todayIso0) { window.alert('Please enter a future date as YYYY-MM-DD.'); return; }
    try {
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'reply_deferred',
        note: `Reply to the owner's ${String(p._waitSince).slice(0, 10)} email scheduled for ${d.trim()}`,
        metadata: { inbound_at: p._waitSince, until: d.trim() },
      });
      setReloadTick(t => t + 1);
    } catch (e) { window.alert('Could not record: ' + (e?.message || e)); }
  };

  // ✕ No-reply-needed on the owner-waiting card (Colleen 09-10): logs the
  // judgment; that inbound never re-cards, a newer inbound starts fresh.
  const ownerWaitingDismiss = async (p) => {
    if (!supabaseClient) return;
    const note = window.prompt(
      `${p.company_name}: mark this email as needing no reply (answered by phone/meeting, an FYI, or a closer).\n\n`
      + 'A newer email from the owner will card again.\n\nOne line on why (optional):');
    if (note === null) return;
    // 🔇 Thread mute (Zac 09-14, NIC's monthly clawback reports): when the
    // topic recurs — administrative or buyside threads on a multi-hat
    // owner — the whole thread can stand down, not just this instance.
    // The subject stem (dates/months stripped) is the mute key, so "report
    // for September" also covers October's. The PERSON is never muted:
    // any new topic cards normally.
    const stemOf = (s) => String(s || '').toLowerCase()
      .replace(/^\s*((re|fwd?|aw)\s*:\s*)+/g, '')
      .replace(/\b(january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sept?|oct|nov|dec|q[1-4])\b/g, '')
      .replace(/\d+/g, '').replace(/[^a-z\s]/g, ' ').replace(/\s+/g, ' ').trim();
    const subj = (p._lastMsg && p._lastMsg.subject) || '';
    const stem = stemOf(subj);
    let muteThread = false;
    if (stem) {
      muteThread = window.confirm(
        `Mute this WHOLE THREAD going forward?\n\nSubject: "${subj}"\n\n`
        + 'OK = future emails on this topic never card again (e.g. a recurring report — the owner\'s other emails still card normally).\n'
        + 'Cancel = just this one email; a newer email cards again.');
    }
    try {
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'no_reply_needed',
        note: `Owner email ${String(p._waitSince).slice(0, 10)} — no reply needed${muteThread ? ` (thread muted: "${subj.slice(0, 60)}")` : ''}. ${(note || '').trim()}`,
        metadata: { inbound_at: p._waitSince, ...(muteThread ? { thread_stem: stem } : {}) },
      });
      setReloadTick(t => t + 1);
    } catch (e) { window.alert('Could not record: ' + (e?.message || e)); }
  };

  // ⚠ LISTED-BUSINESS AWARENESS for the reminder queue (Mark 09-09, "go,
  // build the banner" — Konnie/TechClarity: a live listing's collection
  // cycle nagged the owner in valuation language while he was mid-deal.
  // The cadence card now KNOWS the business is on the market: send stays
  // possible — the docs are usually wanted FOR the deal — but the framing
  // guidance is on the card, not in anyone's memory.)
  const listedKeys = useMemo(() => {
    const vistas = new Set(); const names = new Set();
    const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    (Array.isArray(dmListings) ? dmListings : []).forEach(l => {
      if (!l || l.status === 'Sold') return;
      if (l.vista_id) vistas.add(String(l.vista_id).trim());
      if (l.name) names.add(norm(l.name));
    });
    return { vistas, names, norm };
  }, [dmListings]);

  const myWorkBuckets = useMemo(() => {
    // Count this user's open reminders per project so the card can
    // surface "🔔 N" without a separate query per row.
    const reminderCountByProject = {};
    myReminders.forEach(r => {
      reminderCountByProject[r.project_id] = (reminderCountByProject[r.project_id] || 0) + 1;
    });
    const mine = projects
      .filter(p => !effectiveName || p.responsibility === effectiveName)
      .map(p => ({ ...p, myReminderCount: reminderCountByProject[p.id] || 0 }));

    // ⚠ OWNER-WAITING (Mark 09-10, the Concise lesson: Jeffrey Atto's 9/4
    // redline email sat SIX DAYS answered by nobody — client-tier owners
    // are excluded from SE reply-due, the deal's considering-snooze had
    // lapsed 8/26, and the approval rode chat; Colleen's midnight memory
    // was the only system in play. The recipient law, inbound half: an
    // owner email on ANY tracked deal, unanswered by ANYONE at Vista for
    // 1 business day, cards THE MAILBOX THAT RECEIVED IT — loudly. Tier
    // and assignment play no part; the person the owner wrote to owes the
    // answer. Mark's standard: "we need to respond back in 1 day, and she
    // shouldn't remember in the middle of the night.")
    const ownerWaiting = [];
    {
      const todayIso = new Date().toISOString().slice(0, 10);
      const seenDeal = new Set();
      [...(projects || []), ...(reviewProjects || []), ...(followUpProjects || []), ...(amProjects || [])].forEach(p => {
        if (!p || seenDeal.has(p.id) || p.buyside) return;
        seenDeal.add(p.id);
        const t = p.emailTruth;
        if (!t || !t.lastIn) return;
        if (t.lastOut && t.lastOut > t.lastIn) return;   // someone at Vista answered
        // ✕ dismissed (no reply needed) — that inbound is settled; a newer one re-cards.
        if (t.noReplyUpTo && t.lastIn <= t.noReplyUpTo) return;
        // ⏰ deferred for THIS inbound: hidden until the chosen date, then
        // the card returns wearing its deferral (Mark 09-14).
        const dfr = (t.deferral && t.deferral.inbound_at === t.lastIn) ? t.deferral : null;
        if (dfr && dfr.until && dfr.until > todayIso) return;
        // THE MEETING IS THE REPLY — but only a meeting that already
        // HAPPENED after the email (they talked; the thread moved to a
        // room). A FUTURE booked meeting does NOT suppress: the owner's
        // question still deserves an answer today (Mark 09-10 on Assured —
        // Jan-2027 review booked, "does need a follow up"). Judgment calls
        // stay human via the ✕ verb; only certainties auto-clear.
        if (p.next_meeting_date && p.next_meeting_date >= t.lastIn.slice(0, 10) && p.next_meeting_date <= todayIso) return;
        const waitDays = businessDaysBetween(t.lastIn, todayIso);
        if (waitDays == null || waitDays < 1) return;    // the 1-business-day standard
        ownerWaiting.push({ ...p, _waitDays: waitDays, _waitSince: t.lastIn, _waitMailbox: t.lastInMailbox || null,
          _lastMsg: t.lastMsg || null, _defer: dfr, _deferCount: t.deferCount || 0 });
      });
      ownerWaiting.sort((a, b) => b._waitDays - a._waitDays);
    }
    const ownerWaitingMine = ownerWaiting.filter(w => effectiveRole === 'owner'
      || (w._waitMailbox ? w._waitMailbox === effectiveName : w.responsibility === effectiveName));

    // 🗓 Review promised, no date (Mark 09-10, Partners Data: "Says active
    // review meeting set, but nothing is in the date field"). The Lead-plate
    // "Schedule the strategic review" card has existed since 7/24 — and three
    // deals still sat dateless for months, because nothing escalated and
    // Colleen (who runs the review cadence) never saw them. Analysis + owner
    // get the debt list with a direct set-date verb; the stage's promise IS
    // a date, and this drives the count visibly to zero.
    const datelessReviews = [];
    if (effectiveRole === 'analysis' || effectiveRole === 'owner') {
      (reviewProjects || []).forEach(p => {
        if (!p.next_meeting_date) datelessReviews.push(p);
      });
      datelessReviews.sort((a, b) => String(a.stage_entered_at || '') < String(b.stage_entered_at || '') ? -1 : 1);
    }

    // Bucketing redesign (2026-06-08). Principle: every section is either
    // *waiting on me* (drive to zero — the go-home-clean goal) or *waiting on
    // someone else* (a calm monitor, not a to-do). Precedence per project:
    //   1. snoozed            → parked, collapsed; reappears when it lapses
    //   2. missing setup      → top of plate (fails silently otherwise)
    //   3. upload phase       → owner has the ball; calm "Waiting on owners"
    //   4. everything else    → "On your plate" (work I can clear)
    // The old "Past committed" + the owner-waiting half of "Stuck" both fold
    // into "Waiting on owners"; "Stuck"'s I-control items (e.g. docs in,
    // awaiting entry — upload_complete and later) land on the plate. Stage-
    // target / committed-date *misses* are management signals → Pipeline.
    const needsSetup = [];
    const onYourPlate = [];
    const waitingOnOwners = [];
    const awaitingAnswers = [];
    const snoozed = [];
    // "Needs setup" is the data steward's (Konnie's) job — completing a
    // project's intake fields. Other roles (Colleen's analysis, the Leads)
    // shouldn't have their work hijacked into a setup bucket for a gap they
    // don't own (e.g. an unassigned lead), so the bucket is scoped to the
    // document_mgmt role. (2026-06-08)
    const showSetupBucket = effectiveRole === 'document_mgmt';
    mine.forEach(p => {
      if (p.isSnoozed) { snoozed.push(p); return; }
      const issues = showSetupBucket ? setupIssues(p) : [];
      if (issues.length > 0) { needsSetup.push({ ...p, setupIssues: issues }); return; }
      const inUploadPhase = UPLOAD_PHASE_STAGES.indexOf(p.workflow_stage) !== -1;
      if (inUploadPhase) { waitingOnOwners.push(p); return; } // owner's ball
      // Analysis (Colleen): a project with owner questions (flagged-but-unsent,
      // sent-and-awaiting, or answered-pending-review) is handled by the
      // dedicated "Owner questions" section below — sourced from ALL projects,
      // not just `mine` — so keep it off the plate here to avoid double-listing.
      // (2026-06-24)
      if (effectiveRole === 'analysis'
        && ((p.questionsToSend || 0) > 0 || (p.questionsAwaiting || 0) > 0 || p.ownerAnswerUnreviewed)) {
        return;
      }
      // Analysis project whose only outstanding thing is owner answers to
      // questions already sent — ball's with the owner, so it's a calm monitor,
      // not plate work. analysis_complete stays on the plate (setting the
      // meeting is actionable). (2026-06-08)
      const fullyAwaiting = (p.questionsAwaiting || 0) > 0
        && (p.questionsToSend || 0) === 0
        && p.openItemsOpen === 0
        && (p.workflow_stage === 'data_entry_complete' || p.workflow_stage === 'adjustments_entered');
      if (fullyAwaiting) { awaitingAnswers.push(p); return; }
      onYourPlate.push(p);
    });
    awaitingAnswers.sort((a, b) => (b.daysSinceQuestionsSent || 0) - (a.daysSinceQuestionsSent || 0));

    // "Following" (analysis role only) — businesses Colleen analyzed that have
    // moved past her to the Lead (valuation meeting set / awaiting decision).
    // Not her work; a collapsed monitor so she can watch deals she worked on
    // through to the owner's decision. Proxy for "she analyzed it" (no analyst
    // field; she's the sole analyst): full vals + non-skip partials. Decided
    // projects leave the active pipeline, so they drop off naturally. (2026-06-08)
    const following = [];
    if (effectiveRole === 'analysis') {
      const analyzedByColleen = (p) => p.path === 'full_valuation'
        || (p.path === 'partial' && p.colleen_review_decision !== 'skip');
      projects.forEach(p => {
        if (p.workflow_stage !== 'val_meeting_set' && p.workflow_stage !== 'awaiting_decision') return;
        if (analyzedByColleen(p)) following.push(p);
      });
      // Considering / follow-up-later deals she worked on stay in the monitor
      // too — the Lead owns them, but Colleen keeps eyes on them and can set
      // herself a reminder to chase the follow-up. (2026-06-12)
      (followUpProjects || []).forEach(p => {
        if (analyzedByColleen(p)) following.push(p);
      });
      following.sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));
    }

    // Owner review queue (owner role only) — every project Colleen has taken
    // to analysis_complete surfaces for Mark's review. Non-blocking: it's a
    // reminder to look, not a gate (Mark 2026-06-08, option A). Built from all
    // projects (Mark isn't anyone's "responsibility"). Custom action label.
    const toReview = [];
    if (effectiveRole === 'owner') {
      projects.forEach(p => {
        if (p.workflow_stage === 'analysis_complete') {
          toReview.push({ ...p, nextAction: 'Review the completed analysis' });
        }
      });
      toReview.sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));
    }

    // Upcoming strategic reviews (lead role only) — review meetings within the
    // next 7 days (and any overdue), so the Lead preps/runs them. (2026-06-08)
    const upcomingReviews = [];
    // ORIGINATOR ROUTING (Mark 09-17 — Zac: three of Colleen's reviews on his
    // plate; he wasn't on any invite, the deals just still carried him as Lead
    // of record from the original valuation). A review belongs to whoever SET
    // IT UP: the synced review meeting's organizer (Colleen, or the Lead), via
    // the same mtDeriveHolder law the meeting cards use. No synced meeting →
    // the Lead of record. Mark-organized reviews fall back to the Lead (the
    // owner's plate is radar, not a worklist). Renders for whoever holds it —
    // Lead or Colleen (analysis) — so a review never vanishes when it leaves
    // a plate.
    if (effectiveRole === 'lead' || effectiveRole === 'analysis') {
      const horizon = new Date(); horizon.setHours(0, 0, 0, 0); horizon.setDate(horizon.getDate() + 7);
      const reviewHolder = (p) => {
        // The LATEST booked review meeting, past or future — an overdue review
        // whose date was never advanced (Cowen: held 9/15, still dated 9/15)
        // must still route to whoever ran it, not fall back to the Lead.
        const mt = (seMeetingsAll || [])
          .filter(m => m.valuation_id === p.id && m.meeting_type === 'strategic_review' && m.status === 'booked')
          .sort((a, b) => (a.starts_at < b.starts_at ? 1 : -1))[0] || null;
        const h = mt ? mtDeriveHolder(mt) : null;
        return (h && h !== 'Mark') ? h : p.responsibility;
      };
      (reviewProjects || []).forEach(p => {
        if (effectiveName && reviewHolder(p) !== effectiveName) return;
        // A review with NO date is a scheduling debt, not a parked deal.
        // Dateless strategic reviews were invisible — no bucket anywhere
        // picked them up (Partners Data, Mark 2026-07-24). They surface
        // here with their composed "Schedule the strategic review" action,
        // sorted first.
        if (!p.next_meeting_date) { upcomingReviews.push(p); return; }
        if (new Date(p.next_meeting_date + 'T00:00:00') <= horizon) upcomingReviews.push(p);
      });
      upcomingReviews.sort((a, b) => new Date(a.next_meeting_date || 0) - new Date(b.next_meeting_date || 0));
    }

    // Considering — follow-up-later (lead role only). The Lead owns these. A
    // due/unset follow-up date lands on the plate; a future date parks in a
    // collapsed "Following up later" monitor. Mirrors the AM pattern, but these
    // stay valuation-active and never leave the Lead. (2026-06-12)
    const leadFollowUpDue = [];
    const leadFollowUpLater = [];
    if (effectiveRole === 'lead') {
      const todayIsoFU = new Date().toISOString().slice(0, 10);
      (followUpProjects || []).forEach(p => {
        if (effectiveName && p.responsibility !== effectiveName) return;
        // UNANSWERED EMAIL (Mark 09-22): on a considering deal, our last email
        // to the owner ≥5 business days old with nothing back pulls the card
        // up to the plate even when the circle-back date is still ahead —
        // the only other net was the date the Lead set himself.
        const t = p.emailTruth;
        // Only emails sent AFTER the deal went into considering count — the
        // pre-decision thread already got its answer (All Quik: 'hold off till
        // January' would otherwise read as 21 days of silence).
        const silentBd = (t && t.lastOut && (!t.lastIn || t.lastIn < t.lastOut) && (!p.stage_entered_at || t.lastOut > p.stage_entered_at)) ? businessDaysBetween(t.lastOut, todayIsoFU) : 0;
        // The date itself cards tomorrow — a circle-back within one business
        // day does not need the no-reply pull a day early (Mark 09-24, CCW
        // Tech: Colleen's email hit 5 bd the day before Zac's own "call with
        // Allen on the 25th").
        const dateImminent = p.isSnoozed && p.snooze_until && businessDaysBetween(todayIsoFU, p.snooze_until) <= 1;
        const silent = silentBd >= 5 && !dateImminent;
        if (p.isSnoozed && !silent) {
          const until = p.snooze_until ? new Date(p.snooze_until + 'T00:00:00').toLocaleDateString() : '';
          leadFollowUpLater.push({ ...p, nextAction: until ? `Following up ${until}` : 'Following up later' });
        } else if (silent) {
          leadFollowUpDue.push({ ...p, _silentBd: silentBd, nextAction: `📭 No reply — ${t.lastOutBy || 'we'} emailed the owner ${silentBd} business days ago and nothing came back${p.snooze_until ? ` (circle-back ${p.snooze_until})` : ''}. Email again, push the date, or record the decision (no call unless the owner asked for one).` });
        } else {
          leadFollowUpDue.push({ ...p, nextAction: p.snooze_until
            ? `Follow up — owner was considering (was due ${p.snooze_until})`
            : 'Follow up — owner was considering (no circle-back date was set)' });
        }
      });
      leadFollowUpDue.sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));
      leadFollowUpLater.sort((a, b) => new Date(a.snooze_until || 0) - new Date(b.snooze_until || 0));
    }

    // Account-Manager view (account_manager role only). The AM's projects sit
    // at off-pipeline stages — stalled_returned_to_am (owner went cold during
    // collection) and val_complete_inactive (valued, declined a strategic
    // review). Both are AM follow-ups; the only difference is timing, set per
    // owner via Snooze Until ("next touch date", option 2 + safety net,
    // 2026-06-08). Due now / no date → on the plate; a future next-touch →
    // the "Following up later" monitor. Unset stays on the plate so a follow-
    // up is never silently forgotten. Card stage badge shows which path.
    const amFollowUp = [];
    const amLater = [];
    // VT client → the buyer name of an OPEN buyside pair (last step not passed / withdrew / LOI / closed).
    const buysideOpenByClient = new Map();
    (buyerFollow || []).forEach(pr => {
      const steps = (pr.touches || []).filter(t => t.kind !== 'note');
      const last = steps[steps.length - 1];
      const cid = pr.owner && pr.owner.vt_client_id;
      if (cid && last && !['passed', 'owner_withdrew', 'loi', 'closed'].includes(last.kind)) {
        buysideOpenByClient.set(cid, (pr.buyer && (pr.buyer.company_name || pr.buyer.contact_name)) || 'a buyer');
      }
    });
    // Leads too (Mark 09-22): a Lead who is the AM OF RECORD on a stalled
    // deal (Zac on Sonic Web Dev / Connect Solutions / PowerSol — his own
    // older deals) got the 7:30 nudge for it but never a card, because this
    // bucket was AM-role only. The recipient law: the card goes to whoever
    // the deal's responsibility names, whatever their role.
    if (effectiveRole === 'account_manager' || effectiveRole === 'lead') {
      // The next BOOKED meeting per valuation (by valuation_id, or the owner's VT client) — see the stalled rule below.
      const meetNowIso = new Date().toISOString();
      const nextMeetByVal = new Map(), nextMeetByClient = new Map();
      const keepSooner = (map, key, m) => { if (!key) return; const cur = map.get(key); if (!cur || m.starts_at < cur.starts_at) map.set(key, m); };
      (seMeetingsAll || []).forEach(m => {
        if (m.status !== 'booked' || !m.starts_at || m.starts_at < meetNowIso) return;
        keepSooner(nextMeetByVal, m.valuation_id, m);
        keepSooner(nextMeetByClient, m.owner && m.owner.vt_client_id, m);
      });
      (amProjects || []).forEach(p => {
        if (effectiveName && p.responsibility !== effectiveName) return;
        // THE GRACE WINDOW (Mark 09-08, right after the revival build: "maybe
        // the simple thing would have been a delay"): a freshly stalled deal
        // stays OFF the AM's plate for 5 business days after the final note.
        // Owners who answer the final reminder (Kamal: 8 minutes) resolve
        // entirely between Konnie and the 🌱 resume card — the AM never sees
        // a card that was stale on arrival. Silence through the window =
        // the card lands as before. Revival detection still covers replies
        // that arrive after the window, via the card's 🌱 banner.
        // …EXCEPT when the owner has replied (Mark 09-09, correcting the
        // 09-08 design: "once a business stalls it goes back to the AM.
        // Konnie's job is data + reminders" — the post-stall reply is the
        // AM's to read, so it SURFACES the card instead of carding Konnie).
        if (p.workflow_stage === 'stalled_returned_to_am' && p.daysInStage != null && p.daysInStage < 5 && !revivalByPid.get(p.id)) return;
        // A MEETING ALREADY BOOKED IS THE RE-ENGAGEMENT (Adam's 🐞 report 10-21, KC Heating and Air: he booked the
        // discovery call for 10-23 on 10-19, yet his own 10-21 follow-up date brought the stalled card back). The deal
        // waits in Later naming the meeting; after the call it returns here for ▶ Moving forward — re-engage (that
        // click resets the deal for a new cycle, so it stays a person's decision, not the calendar's).
        if (p.workflow_stage === 'stalled_returned_to_am') {
          const nm = nextMeetByVal.get(p.id) || nextMeetByClient.get(p.client_id);
          if (nm) {
            const when = new Date(nm.starts_at).toLocaleDateString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' });
            amLater.push({ ...p, nextAction: `${nm.meeting_type === 'discovery' ? 'Discovery call' : 'Meeting'} booked for ${when}: comes back after the call to re-engage` });
            return;
          }
        }
        // NO VALUATION WHILE A BUYSIDE PROJECT IS OPEN (Mark 09-29; Adam 10-16, Xperts Unlimited: tied to buyer
        // N2, yet the stalled valuation kept carding as a sellside revival, because Brian's reply about the
        // buyer's due-diligence questions read as interest in the valuation). An open pair is the
        // relationship's clock: the stalled deal waits in Later, saying why, and comes back when the pair ends.
        const openPair = buysideOpenByClient.get(p.client_id);
        if (openPair) {
          amLater.push({ ...p, nextAction: `Buyside project open with ${openPair}: no valuation while it's open. Comes back if the pair ends (passed / withdrew).` });
          return;
        }
        // THE REPLY BEATS THE SNOOZE (Adam 09-25, Precision Digital Networks:
        // he parked the stalled deal to 9/29 on 9/22, Arie replied "let's pick
        // up the revalue" on 9/24 — and the deal sat in the collapsed monitor
        // with no 🌱 banner, because the banner only rides the plate card).
        // An owner reply after the final reminder is the event the snooze was
        // waiting for: the card comes back up with the reply on it.
        if (p.isSnoozed && !revivalByPid.get(p.id)) {
          const until = p.snooze_until ? new Date(p.snooze_until + 'T00:00:00').toLocaleDateString() : '';
          amLater.push({ ...p, nextAction: until ? `Following up ${until}` : 'Following up later' });
        } else {
          const rv = revivalByPid.get(p.id) || null;
          // The owner-replied case is the AM's to ACT on (Mark 09-09: a
          // post-stall reply goes back to the AM; Konnie is data + reminders).
          // The old copy said "Konnie resumes; nothing for you" — a leftover
          // from the 09-08 design that contradicted both this badge and the
          // card's own Resume / record-outcome buttons (Adam 09-15).
          amFollowUp.push({ ...p, _revival: rv, nextAction: rv
            ? 'Owner replied on their own — your read: back now → Resume with their date · later or a brush-off → set Reschedule below, then Not now'
            : 'Follow up with the owner to re-engage' });
        }
      });
      amFollowUp.sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));
      amLater.sort((a, b) => new Date(a.snooze_until || 0) - new Date(b.snooze_until || 0));
    }

    // Warm accounts (pre-meeting onboarding, Warm → Active). Surfaced on two
    // plates: the AM's (send/resend the intro link + chase no-shows that age
    // without activating) and the Lead's (activate or pass after the
    // introductory meeting). Off the active pipeline, so they don't touch
    // Konnie/Colleen. The intro meeting date lives in discovery_meeting_date.
    // (2026-06-16)
    const amWarm = [];
    const leadWarm = [];
    // Intro-sent state for the warm cards, from the warm_intro outreach log
    // (the send's only persistent trace; logged since 2026-06-24, which
    // predates every production warm account). null = known NOT sent → red
    // chip; undefined = the log fetch failed/loading → unknown, chip stays
    // quiet rather than crying wolf.
    const introSentAt = (p) => (ownerEngagement && ownerEngagement.intro) ? (ownerEngagement.intro[p.id] || null) : undefined;
    // MEETING TRUTH ON THE WARM CARD (Mark 09-11, KC Heating: the card said
    // "Meeting was 8/27" for 15 days while the record KNEW it was a no-show
    // — Thatcher had logged it, the truth card cleared, and nothing owned
    // the reschedule. The card now reads the meeting record: held / no-show
    // / never-logged are three different jobs and it says which one.)
    const warmMeetingTruth = (p) => {
      const ms = (seMeetingsAll || []).filter(m => m.valuation_id === p.id && m.starts_at
        && new Date(m.starts_at) <= new Date() && m.status !== 'cancelled');
      if (!ms.length) return null;
      const last = ms[ms.length - 1];
      // What VT already knows (Mark 10-28, TCS): the owner declined the invite, and/or a new meeting is booked.
      const ext = (last.attendees || []).filter(a => a && a.email && !/@vistabusinessgroup.com$/i.test(a.email));
      const declined = ext.length > 0 && ext.every(a => a.response === 'declined');
      const next = (seMeetingsAll || []).filter(m => m.valuation_id === p.id && m.status === 'booked' && m.starts_at && new Date(m.starts_at) > new Date()
        && !(m.attendees || []).filter(a => a && a.email && !/@vistabusinessgroup.com$/i.test(a.email)).every(a => a.response === 'declined'))
        .sort((a, b) => a.starts_at.localeCompare(b.starts_at))[0] || null;
      const rebookedTo = next ? new Date(next.starts_at).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }) : null;
      return { outcome: last.outcome || null, at: last.starts_at, declined, rebookedTo };
    };
    (warmProjects || []).forEach(p => {
      const ww = warmWatchByPid[p.id] || null;
      const todayIsoW = new Date().toISOString().slice(0, 10);
      const watchLive = !!(ww && ww.until && ww.until > todayIsoW && !ww.replied);
      // A strategy pick (🎯, after 3 rebook emails) steps the AM's card aside until the owner writes back.
      const rb = warmRebookByPid[p.id] || null;
      const pickLive = !!(rb && rb.pick && !rb.repliedSincePick);
      const wp = { ...p, introSentAt: introSentAt(p), meetingTruth2: warmMeetingTruth(p),
        _watch: ww && !watchLive ? (ww.replied ? 'replied' : 'silent') : null,
        _attempts: rb ? rb.attempts : 0, _pick: rb ? rb.pick : null, _pickLive: pickLive,
        _qual: warmQualByPid[p.id] || null };
      // amOwner: J.C.'s warm accounts work from Adam's plate (inheritance). A live ⏳ watch steps the AM's
      // card aside (Adam 10-01); the Lead's card is untouched.
      // A 🎯 marketing pick parks the account: no Lead meeting to prepare for, so the missing size screen doesn't hold
      // the card (Mark 10-20, Adam / Lew Plumbing: a silent no-show can't give a profit number). If the owner writes
      // back, pickLive ends and the card returns WITH 📋 Finish the qualification before any Lead meeting.
      if (effectiveRole === 'account_manager' && amOwner(p.account_manager) === effectiveName && !pickLive && (!watchLive || !warmQualByPid[p.id])) amWarm.push(wp);
      // A logged no-show is the AM's to rebook (Zac 10-28, Pro Door & Trim: "I've hit owner missed meeting several
      // times but it won't clear. It should go on AMs plate"). The Lead's card steps aside until a new meeting is on
      // the calendar or the date is moved; a Lead who is also the AM keeps it.
      const mtw = wp.meetingTruth2;
      const noShowWaitingOnAm = !!(mtw && mtw.outcome === 'no_show' && !mtw.rebookedTo && p.discovery_meeting_date
        && new Date(p.discovery_meeting_date + 'T00:00:00') <= new Date() && p.account_manager && p.account_manager !== p.lead);
      if (effectiveRole === 'lead' && p.lead === effectiveName && !noShowWaitingOnAm) leadWarm.push(wp);
    });
    // AM: longest-waiting first (the no-shows that need a nudge). Lead: by
    // intro-meeting date so the ones to activate next sit at the top.
    amWarm.sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));
    leadWarm.sort((a, b) => new Date(a.discovery_meeting_date || '2999-12-31') - new Date(b.discovery_meeting_date || '2999-12-31'));
    // Activated, docs-ready email never sent (release commits on send).
    // ANY upload-phase stage, not just awaiting_upload (Mark 09-14,
    // TechClarity: Konnie staff-loaded 9 docs which advanced the stage to
    // upload_started — and the only card built to catch "owner never got
    // the list" went blind. 28 days stalled, a committal blew past for an
    // owner who never knew a date existed. Staff-loaded progress doesn't
    // change the fact the owner has no portal ask.)
    const docsNotSent = (projects || []).filter(p =>
      UPLOAD_PHASE_STAGES.indexOf(p.workflow_stage) !== -1
      && p.portal_docs_released !== true
      && !p.revalue_docs_pending
      && !p.revalue_review_pending
      && !p.buyside
      && (effectiveRole === 'owner' || (effectiveRole === 'lead' && p.lead === effectiveName))
    ).sort((a, b) => new Date(a.stage_entered_at || 0) - new Date(b.stage_entered_at || 0));

    // Plate: overdue first, then longest-in-stage.
    onYourPlate.sort((a,b) => {
      if (!!a.stageOverdue !== !!b.stageOverdue) return a.stageOverdue ? -1 : 1;
      return (b.daysInStage || 0) - (a.daysInStage || 0);
    });
    needsSetup.sort((a,b) => (b.daysInStage || 0) - (a.daysInStage || 0));
    waitingOnOwners.sort((a,b) => (b.daysPastCommitted || 0) - (a.daysPastCommitted || 0));
    snoozed.sort((a,b) => new Date(a.snooze_until || 0) - new Date(b.snooze_until || 0));

    // Personal reminders due today or overdue, decorated with the
    // project's company name from the active-pipeline list.
    const todayMid = new Date();
    todayMid.setHours(0, 0, 0, 0);
    const projectById = {};
    projects.forEach(p => { projectById[p.id] = p; });
    const dueReminders = myReminders
      .filter(r => {
        const due = new Date(r.remind_at + 'T00:00:00');
        return due <= todayMid;
      })
      .map(r => {
        const due = new Date(r.remind_at + 'T00:00:00');
        const daysOverdue = Math.floor((todayMid - due) / (1000 * 60 * 60 * 24));
        const proj = projectById[r.project_id];
        return {
          id: r.id,
          project_id: r.project_id,
          company_name: proj?.company_name || '(project not in active pipeline)',
          remind_at: r.remind_at,
          note: r.note,
          daysOverdue,
        };
      });

    // Cadence reminder queue — projects at/past a weekly beat or past their
    // stop date. Scoped by responsibility (2026-06-08): the owner document-
    // chase is Konnie's job, so the queue shows only on her My Work (and
    // Mark's via View-as), not on Colleen's / the Leads'. (Reverses the
    // 2026-05-27 "show to every allowlisted user" note, which was a
    // misunderstanding.) Cadence-eligible stages are upload-phase, whose
    // responsibility is always Konnie — including the final-due (stalled→AM
    // handoff) cards, which Mark confirmed remain Konnie's to send. Final-due
    // ranks above weekly-due; both sorted by days past target.
    const cadenceQueue = mine
      .filter(p => p.cadence && (p.cadence.cadenceDue || p.cadence.cadenceFinal))
      .map(p => {
        const daysPastTarget = p.cadence.targetDate
          ? Math.floor((new Date(todayMid) - new Date(p.cadence.targetDate + 'T00:00:00')) / (1000 * 60 * 60 * 24))
          : 0;
        return { ...p, _cadenceDaysPast: daysPastTarget };
      })
      .sort((a, b) => {
        // Final beats first
        if (a.cadence.cadenceFinal !== b.cadence.cadenceFinal) {
          return a.cadence.cadenceFinal ? -1 : 1;
        }
        return b._cadenceDaysPast - a._cadenceDaysPast;
      });

    // Stage C: docs auto-Received from ShareFile that Konnie hasn't entered
    // yet — her "received, awaiting entry" worklist. Scoped to the document-mgmt
    // role (Konnie, or Mark via View-as). Sourced from ALL active projects (not
    // the responsibility-filtered `mine`): entering received docs is Konnie's
    // job whatever stage the project is in. Each card carries its list of
    // received-but-unentered items; most-recent first.
    const receivedWorklist = (effectiveRole === 'document_mgmt')
      ? projects
          .filter(p => Array.isArray(p.sfAwaiting) && p.sfAwaiting.length > 0)
          .map(p => ({ ...p, _sfCount: p.sfAwaiting.length }))
          .sort((a, b) => {
            const am = Math.max(...a.sfAwaiting.map(x => new Date(x.receivedAt).getTime()));
            const bm = Math.max(...b.sfAwaiting.map(x => new Date(x.receivedAt).getTime()));
            return bm - am;
          })
      : [];

    // Revalue doc-curation: projects where a revalue just started and the docs
    // gate is waiting on Konnie to review the file, check the needed boxes, and
    // release the tailored list. Document-mgmt role only (Konnie / Mark via
    // View-as). Opening a card takes her into the valuation to curate + release.
    const revalueDocsReview = (effectiveRole === 'document_mgmt')
      ? projects.filter(p => p.revalue_docs_pending === true
          // Self-heal (Konnie 2026-07-28: Fabkom + one more sat on this card
          // since revalue start): the card's job is the curated release BEFORE
          // this cycle's docs flow. Once the release happened another way, the
          // owner is already uploading, the valuation was delivered, or the
          // deal left awaiting_upload, the release moment has passed — stop
          // showing it. The flag itself is cleared by release or by the card's
          // "Not needed" action, so history stays explicit.
          && !p.portal_docs_released
          && !p.upload_started_date && !p.upload_complete_date && !p.valuation_date
          && p.workflow_stage === 'awaiting_upload')
      : [];

    // #8/#9: owner self-service portal updates awaiting Konnie's review — the
    // owner marked "I've uploaded everything" and/or flagged a document as "doesn't
    // apply." These previously only showed inside the portal / the editor badge, so
    // she'd miss them unless she looked. Document-mgmt role; all active projects.
    // Most-recently-signaled first. Cleared via the card's "✓ Reviewed" action.
    const COLLECTION_STAGE = ['awaiting_upload', 'upload_started', 'upload_complete'];
    const ownerPortalReview = (effectiveRole === 'document_mgmt')
      ? projects
          .filter(p =>
            // Finished-uploading: only while still collecting (auto-clears once
            // Konnie processes the docs and the deal advances).
            (!!p.ownerUploadsDone && COLLECTION_STAGE.indexOf(p.workflow_stage) !== -1)
            // Or the owner flagged a doc "doesn't apply" (still outstanding).
            || (Array.isArray(p.ownerNaItems) && p.ownerNaItems.length > 0))
          .sort((a, b) => {
            const at = new Date(a.ownerUploadsDone || 0).getTime();
            const bt = new Date(b.ownerUploadsDone || 0).getTime();
            return bt - at;
          })
      : [];

    // Owner questions (analysis role / Colleen) — active projects with a pending
    // or answered Ask-Owner question, sourced from ALL projects (not the
    // responsibility-filtered `mine`) so a question doesn't hide just because the
    // stage's primary owner is someone else. BUT floored above the collection
    // phase: while a project is still uploading/entering docs it's Konnie's, and
    // owner questions there are noise for Colleen (Mark 2026-06-24). So exclude
    // awaiting_upload / upload_started / upload_complete; surface from
    // data_entry_complete onward. Answered-and-waiting-for-her first (a reply
    // just landed), then to-send (she controls it), then longest-awaiting.
    const COLLECTION_STAGES = ['awaiting_upload', 'upload_started', 'upload_complete'];
    const ownerQuestions = (effectiveRole === 'analysis')
      ? projects
          .filter(p => COLLECTION_STAGES.indexOf(p.workflow_stage) === -1
            && ((p.questionsToSend || 0) > 0 || (p.questionsAwaiting || 0) > 0 || p.ownerAnswerUnreviewed))
          .map(p => {
            const toSend = (p.questionsToSend || 0) > 0;
            return { ...p, nextAction: p.ownerAnswerUnreviewed
              ? 'Owner answered — review & accept'
              : toSend ? 'Send the owner their questions'
              : 'Awaiting the owner’s answers — nudge if it’s been a while' };
          })
          .sort((a, b) => {
            const aTop = !!a.ownerAnswerUnreviewed, bTop = !!b.ownerAnswerUnreviewed;
            if (aTop !== bTop) return aTop ? -1 : 1;
            const aSend = (a.questionsToSend || 0) > 0, bSend = (b.questionsToSend || 0) > 0;
            if (aSend !== bSend) return aSend ? -1 : 1;
            return (b.daysSinceQuestionsSent || 0) - (a.daysSinceQuestionsSent || 0);
          })
      : [];

    // Portal-form reviews route to KONNIE (Mark 2026-08-04, from the Concise
    // confusion: the chip rode the stage-holder's plate and landed on Colleen,
    // but form entry is Konnie's lane — review-and-accept applies grid/type
    // values, i.e. data entry). Forms can complete during ANY stage (Revenue
    // Classification unlocks once the P&L is in), so no stage floor.
    const formReviews = (effectiveRole === 'document_mgmt')
      ? projects.filter(p => p.ownerFormUnreviewed)
          // openTarget: the editor lands directly on the waiting form's tab.
          .map(p => ({ ...p, nextAction: 'Owner completed a portal form — review & accept', openTarget: 'ownerFormReview' }))
      : [];

    // Monthly financial-update reminders for ENGAGED (on-market) deals
    // (Mark, 2026-07-20): a listing's financials refresh after every
    // month-end. Fire from the 8th of each month (owners need ~7 days to
    // close books) when the deal's data TTM end-month is older than the last
    // closed month. Per-deal pause (financial_reminder_paused, migration 030)
    // covers due-diligence/closing, where updates stop being entered into VT.
    // Shown to Konnie (document_mgmt) AND the deal's Lead.
    const financialUpdates = [];
    {
      const now = new Date();
      const wantRole = effectiveRole === 'document_mgmt' || effectiveRole === 'lead' || effectiveRole === 'owner';
      if (wantRole) projects.forEach(p => {
        if (p.workflow_stage !== 'engaged' || p.financial_reminder_paused || p.buyside) return;
        if (effectiveRole === 'lead' && effectiveName && p.lead !== effectiveName) return;
        const cfg = p.ttm_config;
        if (!cfg || cfg.endYear == null || cfg.endMonth == null) return;
        const dataEnd = new Date(Number(cfg.endYear), Number(cfg.endMonth), 1); // endMonth is 0-based
        if (isNaN(dataEnd.getTime())) return;
        // Per-deal target via the shared AS-OF engine: the last month THIS
        // business's books are assumed closed (7-day close window + books
        // lag — a 60-day closer isn't nagged for a month it can't produce).
        const target = asOfAutoTarget(now, p.books_lag_months);
        const targetMonth = new Date(target.getFullYear(), target.getMonth(), 1);
        if (dataEnd >= targetMonth) return; // data current for this business
        const monthsBehind = (targetMonth.getFullYear() - dataEnd.getFullYear()) * 12 + (targetMonth.getMonth() - dataEnd.getMonth());
        financialUpdates.push({ ...p, _dataEndIso: dataEnd.toISOString(), _needMonthIso: targetMonth.toISOString(), _monthsBehind: monthsBehind });
      });
      financialUpdates.sort((a, b) => b._monthsBehind - a._monthsBehind);
    }

    // AS-OF increment 4: the locked-date ADVANCE decision prompt. A locked
    // collection (uploads started, not complete) whose as-of has fallen ≥2
    // months behind this deal's auto target gets a decision card for Konnie +
    // the Lead. NEVER auto-advances — advancing re-requests the date-sensitive
    // docs, which is a staff/relationship call (Mark: "depends on the deal and
    // circumstances"). Gated on STAGE, not the Setup-tab date fields: those
    // dates are manually entered and upload_complete_date is routinely left
    // blank, which kept valued/awaiting-decision deals in this card forever
    // (Konnie, Network Solutions, 2026-07-21). A collection is "in flight"
    // only in the upload-phase stages; once the deal moves on, advancing the
    // as-of is a revalue/financial-update concern, not a collection one.
    const asOfAdvance = [];
    {
      const now = new Date();
      const wantRole = effectiveRole === 'document_mgmt' || effectiveRole === 'lead' || effectiveRole === 'owner';
      if (wantRole) projects.forEach(p => {
        if (p.buyside) return; // buy-side: zero automated owner-outreach prompts (#8 Phase 0)
        if (UPLOAD_PHASE_STAGES.indexOf(p.workflow_stage) === -1) return;
        if (!p.upload_started_date || p.upload_complete_date) return;
        if (effectiveRole === 'lead' && effectiveName && p.lead !== effectiveName) return;
        if (p.as_of_prompt_snooze_until && new Date(p.as_of_prompt_snooze_until + 'T00:00:00') > now) return;
        const eff = asOfEffective(p, now);
        const target = asOfAutoTarget(now, p.books_lag_months);
        const monthsBehind = (target.getFullYear() - eff.date.getFullYear()) * 12 + (target.getMonth() - eff.date.getMonth());
        if (monthsBehind < 2) return;
        asOfAdvance.push({ ...p, _effIso: eff.date.toISOString(), _targetIso: target.toISOString(), _monthsBehind: monthsBehind });
      });
      asOfAdvance.sort((a, b) => b._monthsBehind - a._monthsBehind);
    }

    // Pre-discovery nudge (Mark 2026-07-23, covering for Thatcher on Baxter
    // I.T.): the Lead's discovery meeting is inside 48h and the owner hasn't
    // answered the portal questions — surface it with a one-click check-in
    // (the email Mark was writing by hand). Warm phase only; the meeting
    // date has no time-of-day, so the window is meeting today/tomorrow and
    // it stays visible through the meeting day itself.
    const discoveryPrep = [];
    {
      const nowMs = Date.now();
      const wantRole = effectiveRole === 'lead' || effectiveRole === 'owner' || effectiveRole === 'account_manager';
      if (wantRole) (warmProjects || []).forEach(p => {
        if (p.buyside || p.discoveryQuestionsDone) return;
        // 3+ real answers = the owner is engaged, button click or not — no
        // nudge. 1–2 answers still nudges, with the count shown on the card.
        if ((p.discoveryAnswerCount || 0) >= 3) return;
        if (!p.discovery_meeting_date || !p.owner_email) return;
        if (effectiveRole === 'lead' && effectiveName && p.lead !== effectiveName) return;
        // The AM booked the meeting and owns the relationship until activation,
        // so their own deals' prep cards show on their plate too — view-only;
        // the check-in email stays the Lead's send (Mark 2026-07-24).
        if (effectiveRole === 'account_manager' && effectiveName && p.account_manager !== effectiveName) return;
        const t = new Date(p.discovery_meeting_date + 'T00:00:00').getTime();
        // First-Mile T1 (Mark 2026-08-03): the meeting is usually NEXT DAY
        // after the intro, so the window narrows from 48h to 24h before the
        // meeting (day-of when booked even later) — still visible through
        // the meeting day itself.
        if (t - nowMs > 24 * 3600 * 1000 || nowMs - t > 36 * 3600 * 1000) return;
        // Owner = exception radar (Mark 08-05: "only notify me if there is
        // an issue"): his card appears only once the meeting day has
        // arrived and the owner still hasn't answered — the leads carry
        // the normal 24h-out window on their own plates.
        if (effectiveRole === 'owner' && t - nowMs > 0) return;
        discoveryPrep.push({ ...p });
      });
      discoveryPrep.sort((a, b) => (a.discovery_meeting_date < b.discovery_meeting_date ? -1 : 1));
    }

    // First-Mile touches T2–T4 (spec § FIRST-MILE CADENCE, 2026-08-03).
    // Activity-gated: each fires only while the owner is quiet, one touch per
    // deal at a time (earliest applicable), and never repeats (sent markers
    // ride in the activity log). Lead-sent; owner (Mark) sees all.
    const firstMileTouches = [];
    {
      const wantRole = effectiveRole === 'lead' || effectiveRole === 'owner';
      const dayMs = 86400000;
      const todayMs = new Date(new Date().toISOString().slice(0, 10) + 'T00:00:00').getTime();
      const isListedDeal = (p) => !!(listedKeys && ((p.vista_id && listedKeys.vistas.has(String(p.vista_id).trim())) || listedKeys.names.has(listedKeys.norm(p.company_name))));
      if (wantRole) (projects || []).forEach(p => {
        if (p.buyside || !p.owner_email) return;
        if (effectiveRole === 'lead' && effectiveName && p.lead !== effectiveName) return;
        // Listed businesses are PAST the first mile (Mark 09-15, TechClarity: a
        // month-end buyer-package refresh wore the "defend the owner's valuation
        // date" costume, and the T5 stall clock read the ORIGINAL valuation's
        // uploads — "5/7 in, nothing new for 28d" the morning after the refresh
        // list went out and the committal was reset). Once on-market the document
        // cadence owns collection (it already carries the LISTED banner + buyer-
        // package framing); a second channel nudging the same owner is the
        // overwhelm rule. First mile is the pre-listing before-layer only.
        if (isListedDeal(p)) return;
        // No nudge before the list exists (Mark 09-11, ITCS: activated two
        // hours earlier, docs-ready email still pending review — the owner
        // had no document list, yet the pre-committal nudge fired. An owner
        // who CAN'T upload can't be nudged to; the docs-not-sent card
        // chases the staff side of that state.)
        if (p.portal_docs_released !== true) return;
        const sent = p.firstMileSent || new Set();
        const noDocs = (p.docsDone || 0) === 0 && !p.lastUploadAt;
        const inUpload = UPLOAD_PHASE_STAGES.indexOf(p.workflow_stage) !== -1;
        const discMs = p.discovery_meeting_date ? new Date(p.discovery_meeting_date + 'T00:00:00').getTime() : null;
        const commMs = p.committed_upload_date ? new Date(p.committed_upload_date + 'T00:00:00').getTime() : null;
        const targMs = p.owner_target_valuation_date ? new Date(p.owner_target_valuation_date + 'T00:00:00').getTime() : null;
        // T3 outranks T2 when both apply (the committal is the harder date).
        if (inUpload && noDocs && commMs != null && commMs - todayMs <= 2 * dayMs && commMs - todayMs >= 0 && !sent.has('T3')) {
          firstMileTouches.push({ ...p, touch: 'T3', touchLabel: 'Pre-committal nudge',
            touchWhy: `Committal date ${p.committed_upload_date} is ${Math.ceil((commMs - todayMs) / dayMs)}d away — zero documents received.`,
            ownerAlert: commMs - todayMs <= 1 * dayMs });
          return;
        }
        // T2 — post-discovery check-in (+2d; 21d cap keeps ancient deals from
        // flooding the plate on day one — the cadence owns the long tail).
        // A PAST committal ends the first mile for this deal (Thatcher
        // 09-14, Natix: the T2 draft said "aiming for your documents by
        // September 7" a week after the 7th — the before-layer's date was
        // already missed, and Konnie's cadence owns everything after the
        // deadline; two channels nudging one owner is the overwhelm rule).
        if (commMs != null && commMs < todayMs) return;
        if (inUpload && noDocs && discMs != null && todayMs - discMs >= 2 * dayMs && todayMs - discMs <= 21 * dayMs && !sent.has('T2')) {
          firstMileTouches.push({ ...p, touch: 'T2', touchLabel: 'Post-discovery check-in',
            touchWhy: `Discovery was ${Math.round((todayMs - discMs) / dayMs)}d ago — nothing uploaded since.`,
            ownerAlert: todayMs - discMs >= 9 * dayMs });
          return;
        }
        // T4 — the owner's own valuation date as leverage: fires at −7d while
        // docs are incomplete (workflow math: docs due 2d before the meeting);
        // escalates as a separate touch at −3d.
        if (targMs != null && !p.valuation_date && (p.docsOutstanding == null || p.docsOutstanding > 0)
            && targMs - todayMs <= 7 * dayMs && targMs - todayMs >= -2 * dayMs) {
          const esc = targMs - todayMs <= 3 * dayMs;
          const key = esc ? 'T4b' : 'T4';
          if (!sent.has(key)) {
            firstMileTouches.push({ ...p, touch: key,
              touchLabel: esc ? 'Valuation date AT RISK' : 'Valuation-date leverage',
              touchWhy: `Owner wants to be discussing value by ${p.owner_target_valuation_date} — documents incomplete (${p.docsDone || 0}/${p.docsTotal || '?'}); we need everything 2 days before the meeting.`,
              ownerAlert: esc });
            return;
          }
        }
        // T5 — mid-upload stall watch (star-weighted): they started, then
        // stopped — no new documents for ~5 days. Naturally exclusive with
        // T2/T3 (those require zero docs).
        if (inUpload && (p.docsDone || 0) > 0 && p.lastUploadAt
            && todayMs - new Date(p.lastUploadAt).getTime() >= 5 * dayMs && !sent.has('T5')) {
          firstMileTouches.push({ ...p, touch: 'T5', touchLabel: 'Mid-upload stall',
            touchWhy: `${p.docsDone}/${p.docsTotal || '?'} docs in, nothing new for ${Math.floor((todayMs - new Date(p.lastUploadAt).getTime()) / dayMs)}d${p.committed_upload_date ? ` — committal ${p.committed_upload_date}` : ''}.`,
            ownerAlert: todayMs - new Date(p.lastUploadAt).getTime() >= 10 * dayMs });
        }
      });
      // Owner = exception radar (Mark 08-05): only touches that have aged
      // into an issue — T4b escalations, committal day-of/tomorrow, T2 a
      // week past its fire point, stalls at 10d+. The leads always carry
      // the full set on their own plates.
      if (effectiveRole === 'owner') {
        const alertsOnly = firstMileTouches.filter(t => t.ownerAlert);
        firstMileTouches.length = 0;
        firstMileTouches.push(...alertsOnly);
      }
      // Severity first, then stars (spec: stars set ORDER, never frequency).
      const ord = { T4b: 0, T3: 1, T4: 2, T5: 3, T2: 4 };
      // Likelihood inside severity (Mark 09-11): the Lead's own conviction
      // orders the queue — a 90% deal earns the personal touch first.
      firstMileTouches.sort((a, b) => ((ord[a.touch] ?? 9) - (ord[b.touch] ?? 9))
        || ((b.likelihood_pct || 0) - (a.likelihood_pct || 0))
        || (effectiveStars(b) - effectiveStars(a)));
    }

    // Team-overdue radar (Mark 2026-07-27, option A): owner's My Work only —
    // every actionable plate item past its stage target, ACROSS all staff,
    // grouped by the responsible person. The per-person plates already sort
    // overdue-first; this exists for the case where the person doesn't look.
    // Same stage scope as the server's overdue-nudge emails (option B).
    const teamOverdue = [];
    if (effectiveRole === 'owner') {
      const now = new Date();
      const all = [...projects, ...(amProjects || [])];
      const seen = new Set();
      all.forEach(p => {
        if (seen.has(p.id)) return; seen.add(p.id);
        if (p.buyside) return;
        if (!OVERDUE_RADAR_STAGES.has(p.workflow_stage)) return;
        if (p.snooze_until && new Date(p.snooze_until) > now) return;
        // Compute overdue here rather than trusting p.stageOverdue — the AM
        // rows (stalled) are composed without that field.
        const clk = overdueClock(p, WORKFLOW_STAGES[p.workflow_stage]?.targetDays);
        if (clk.target == null || clk.days == null || clk.days <= clk.target) return;
        teamOverdue.push({ ...p, targetDays: clk.target, daysOver: clk.days - clk.target, _clockDays: clk.days, _clockSince: clk.since });
      });
      teamOverdue.sort((a, b) => (b.daysOver || 0) - (a.daysOver || 0));
    }

    // ⚠ LEFT WITHOUT A REVIEW DATE (Mark 09-21): a valuation meeting that
    // closed on "circle back later" — no engagement, no review meeting — cards
    // the Lead 2 business days later and keeps asking until the deal has a
    // review date, an engagement, or goes inactive. Bounded to deals that
    // entered the soft stage in the last 45 days (legacy circle-backs aren't
    // re-litigated). Awaiting-decision rows already sit on the plate with the
    // same picker, so they're not doubled here.
    const noReviewDate = [];
    if (effectiveRole === 'lead') {
      const todayIsoNR = new Date().toISOString().slice(0, 10);
      const cutoff45 = Date.now() - 45 * 86400000;
      (followUpProjects || []).forEach(p => {
        if (p.workflow_stage !== 'considering_followup' || p.lead !== effectiveName || !p.stage_entered_at) return;
        if (new Date(p.stage_entered_at).getTime() < cutoff45) return;
        if (businessDaysBetween(p.stage_entered_at, todayIsoNR) < 2) return;
        // A circle-back with a DATE still ahead and a WRITTEN REASON is a plan,
        // not a gap (Mark 09-23, the first firing: CCW "call with Allen on the
        // 25th", All Quik "rerun the numbers after year end" were noise; Assura's
        // passed date and Partners Data / KGM with no reason were the real
        // cards). Fire when the date has passed, or when no reason is on record.
        const dateAhead = !!(p.snooze_until && p.snooze_until > todayIsoNR);
        const hasReason = !!((p.snooze_reason || '').trim());
        if (dateAhead && hasReason) return;
        noReviewDate.push({ ...p, _nagWhy: !p.snooze_until ? 'no circle-back date' : (!dateAhead ? `circle-back ${p.snooze_until} has passed` : 'no reason on record for the circle-back') });
      });
      noReviewDate.sort((a, b) => String(a.stage_entered_at) < String(b.stage_entered_at) ? -1 : 1);
    }
    // Synced calendar meetings feed the cards' re-engage verdict (Mark 10-05).
    const withHeld = (arr) => arr.map(p => {
      const d = lastHeldMeetingFrom(seMeetingsAll, p.id, p.client_id);
      return d ? { ...p, last_held_meeting: d } : p;
    });
    return { needsSetup, onYourPlate, waitingOnOwners, awaitingAnswers, ownerQuestions, formReviews, following, toReview, upcomingReviews, leadFollowUpDue: withHeld(leadFollowUpDue), leadFollowUpLater: withHeld(leadFollowUpLater), amFollowUp: withHeld(amFollowUp), amLater: withHeld(amLater), amWarm, leadWarm, docsNotSent, snoozed, dueReminders, cadenceQueue, receivedWorklist, revalueDocsReview, ownerPortalReview, financialUpdates, asOfAdvance, discoveryPrep, firstMileTouches, teamOverdue, ownerWaiting: ownerWaitingMine, datelessReviews, noReviewDate };
  }, [projects, reviewProjects, amProjects, followUpProjects, warmProjects, effectiveName, effectiveRole, myReminders, ownerEngagement, revivalByPid, seMeetingsAll, listedKeys, warmWatchByPid, warmRebookByPid, warmQualByPid, buyerFollow]);

  // Stage C: resolve a Sort Queue item. itemId > 0 → stamp that checklist item
  // Received (same signal the auto-classifier writes) + log + mark the queue row
  // resolved. itemId null → dismiss (not a checklist doc, or unlinked folder).
  const resolveSortQueueItem = async (item, itemId) => {
    if (!supabaseClient || !item) return;
    try {
      if (itemId && item.engagement_id) {
        const itemKey = String(itemId);
        const { error: cErr } = await supabaseClient
          .from('engagement_checklist_items')
          .update({
            sharefile_received_at: new Date().toISOString(),
            sharefile_file_id: item.sharefile_file_id,
            ai_classification_confidence: item.ai_confidence,
          })
          .eq('engagement_id', item.engagement_id).eq('item_key', itemKey);
        if (cErr) throw cErr;
        await supabaseClient.from('project_activity_log').insert({
          project_id: item.engagement_id,
          actor_email: userEmail,
          actor_name: staffName(userEmail) || null,
          kind: 'document_received',
          note: `${item.file_name || 'upload'} → sorted to item ${itemKey}`,
          metadata: { item_key: itemKey, source: 'sharefile_sort', sharefile_file_id: item.sharefile_file_id },
        });
        await supabaseClient.from('engagement_upload_queue')
          .update({ status: 'resolved', resolved_item_key: itemKey, resolved_at: new Date().toISOString(), resolved_by: userEmail })
          .eq('id', item.id);
        // The as-of LOCK (Konnie 09-11, E2E): first received document stamps
        // upload_started_date if missing — without it the as-of auto-advance
        // silently overrides a staff-set collection date (her 7/31 lost to
        // the calendar's 8/31 because the revival reset had nulled the lock).
        await supabaseClient.from('valuations')
          .update({ upload_started_date: new Date().toISOString().slice(0, 10) })
          .eq('id', item.engagement_id).is('upload_started_date', null);
      } else {
        await supabaseClient.from('engagement_upload_queue')
          .update({ status: 'dismissed', resolved_at: new Date().toISOString(), resolved_by: userEmail })
          .eq('id', item.id);
      }
      setSortQueue(prev => prev.filter(q => q.id !== item.id));
    } catch (e) {
      console.error('Sort queue resolve failed:', e);
      window.alert('Failed to sort: ' + (e?.message || 'unknown error'));
    }
  };

  // ─── Monthly financial-update reminders (Engaged deals) ───
  // Request: review-and-send email to the owner naming the stale docs + the
  // month needed (docs-release pattern: Lead sender, Konnie fallback, portal
  // button via buildPortalEmailHtml). Pause: due diligence / closing — updates
  // stop being entered into VT, so the reminders stop too (its own COLUMN;
  // never a read-modify-write of the deal data blob from the dashboard).
  const monthYearLabel = (iso) => new Date(iso).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
  // One-click pre-discovery check-in — a RELATIONSHIP email, so it sends AS
  // the Lead (the document-email→Konnie rule deliberately does not apply).
  const sendDiscoveryNudge = (p) => {
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
    const cc = (Array.isArray(p.owner_additional) ? p.owner_additional : [])
      .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    const fn = (p.owner_first_name || '').trim();
    const todayIso = new Date().toISOString().slice(0, 10);
    const when = p.discovery_meeting_date === todayIso ? 'today'
      : new Date(p.discovery_meeting_date + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'long' });
    setPendingEmail({
      heading: 'Send: pre-meeting check-in (portal link + questions)',
      to: (p.owner_email || '').trim(), cc,
      subject: `Ahead of our meeting — ${p.company_name || 'your business'}`,
      sender: leadGmailKey(p.lead) || 'konnie',
      defaultBody: `Hi${fn ? ' ' + fn : ''},\n\nLooking forward to talking ${when}. Two quick things ahead of it:\n\nDid our secure portal link reach you? The button below will get you signed in — just use the email address this message was sent to.\n\nIf you can find a few minutes before we meet, answering the short set of questions in the portal helps us spend our time on your goals instead of the basics. No problem if not — we'll cover it together.\n\nIf the link never arrived or anything is unclear, just reply and I'll get you sorted.`,
      buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: (p.lead || '').trim() || 'Vista Business Group', portalUrl }),
      onSent: async () => {
        try {
          await supabaseClient.from('project_activity_log').insert({
            project_id: p.id, actor_email: userEmail || 'unknown',
            actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
            kind: 'outreach', note: 'Pre-discovery check-in sent — portal link + questions reminder',
            metadata: { kind: 'discovery_prep_nudge' },
          });
        } catch (e) { console.warn('Nudge log failed (email sent):', e); }
      },
    });
  };

  // First-Mile touch sender (spec § FIRST-MILE CADENCE): informal, Lead-sent,
  // review-tweak-send. Copy branches per touch; T2 additionally branches on
  // whether the owner gave a committal date or left it blank (estimated).
  const sendFirstMileTouch = (p) => {
    if (!p || !p.owner_email) { window.alert('No owner email on this deal.'); return; }
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
    const cc = (Array.isArray(p.owner_additional) ? p.owner_additional : [])
      .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    // Konnie always rides CC (Mark 09-11): she owns the collection thread,
    // so a Lead nudge she never saw would blind the person running the list.
    if (!cc.some(e => /^konnie@/i.test(e))) cc.push('konnie@vistabusinessgroup.com');
    const fn = (p.owner_first_name || '').trim();
    const hi = fn ? `Hi ${fn},` : 'Hello,';
    const fmtD = (d) => d ? new Date(d + 'T00:00:00').toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) : '';
    let subject, body;
    if (p.touch === 'T2') {
      subject = `Quick check-in — ${p.company_name || 'your valuation'}`;
      body = p.committed_upload_date
        ? `${hi}\n\nJust checking in after our conversation — any questions about the document list, or anything tricky to pull? Happy to walk through where any of it lives in QuickBooks.\n\nWe're aiming for your documents by ${fmtD(p.committed_upload_date)}, which keeps everything on track. The portal button below takes you straight to your list.`
        : `${hi}\n\nJust checking in after our conversation — any questions about the document list, or anything tricky to pull? Happy to walk through where any of it lives in QuickBooks.\n\nAs we discussed, the sooner the documents land the sooner we can put a value in front of you — most owners knock the list out in a sitting or two. The portal button below takes you straight to it.`;
    } else if (p.touch === 'T3') {
      subject = `Your upload date is ${fmtD(p.committed_upload_date)} — anything in the way?`;
      body = `${hi}\n\nWe're coming up on ${fmtD(p.committed_upload_date)} — the date we penciled for your documents — and I haven't seen anything land yet. No stress; just want to make sure nothing's in the way.\n\nAny questions about the list, or trouble with the portal? A quick reply here works, or grab me by phone.`;
    } else if (p.touch === 'T5') {
      subject = `Almost there — ${p.company_name || 'your documents'}`;
      body = `${hi}\n\nYou're most of the way through the document list — nice progress. I noticed nothing new has come in for a few days, so I wanted to check: is anything on the remaining items giving you trouble, or has life just gotten busy?\n\nIf any of them are confusing or hard to pull, reply and I'll point you right at it — the last few usually go quickly. The portal button below shows exactly what's left.`;
    } else {
      // T4 / T4b — their date, our math.
      subject = p.touch === 'T4b'
        ? `Holding your ${fmtD(p.owner_target_valuation_date)} valuation date`
        : `Your valuation discussion by ${fmtD(p.owner_target_valuation_date)}`;
      body = `${hi}\n\nYou mentioned wanting to be discussing your valuation by ${fmtD(p.owner_target_valuation_date)} — I'd love to hold that date for you. To get there, we need your remaining documents about two days before we meet so the analysis is ready.\n\nThe portal shows exactly what's still open (button below). Anything unclear or hard to pull, tell me and we'll sort it — a few of the items usually take five minutes each in QuickBooks.`;
    }
    setPendingEmail({
      heading: `Send: ${p.touchLabel} (${p.touch})`,
      to: (p.owner_email || '').trim(), cc,
      subject,
      sender: leadGmailKey(p.lead) || 'konnie',
      defaultBody: body,
      buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: (p.lead || '').trim() || 'Vista Business Group', portalUrl }),
      // The first-mile "sent" marker lives in this row (parsed from the note),
      // so it MUST survive. The server writes it atomically with the send;
      // logActivity carries the exact note the marker parser reads. The tab-
      // side insert below is now only a fallback for the rare case the server
      // reports it could not write (res.logged === false).
      logActivity: {
        project_id: p.id,
        kind: 'outreach',
        note: `First-mile ${p.touch} — ${p.touchLabel} emailed to ${(p.owner_email || '').trim()}`,
        metadata: { kind: 'first_mile_touch', touch: p.touch },
      },
      onSent: async (res) => {
        if (!res || !res.logged) {
          try {
            await supabaseClient.from('project_activity_log').insert({
              project_id: p.id, actor_email: userEmail || 'unknown',
              actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
              kind: 'outreach', note: `First-mile ${p.touch} — ${p.touchLabel} emailed to ${(p.owner_email || '').trim()}`,
              metadata: { kind: 'first_mile_touch', touch: p.touch },
            });
          } catch (e) { console.warn('First-mile log fallback failed (email sent):', e); }
        }
        setReloadTick(t => t + 1);
      },
    });
  };

  // 🤝 First-mile waive (Mark 09-11): the correspondence shows the owner is
  // engaged, so the Lead stands down and Konnie's weekly cadence carries it.
  // Writes the SAME "First-mile T_" marker shape the sent-parser reads, so
  // the touch never re-cards — a conscious stand-down is as final as a send.
  const firstMileWaive = async (p) => {
    if (!supabaseClient || !p) return;
    try {
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'outreach',
        note: `First-mile ${p.touch} waived — Konnie's cadence carries it (${p.touchLabel}; the correspondence showed the owner engaged)`,
        metadata: { kind: 'first_mile_touch', touch: p.touch, waived: true },
      });
      // Clear the card in place, no full reload (Zac 10-28: "a loading screen and it takes 10-15 seconds"). The
      // waive is logged; the next normal load reads it from the activity log, same as here.
      const patch = (x) => x.id === p.id ? { ...x, firstMileSent: new Set([...(x.firstMileSent || []), p.touch]) } : x;
      setProjects(prev => prev.map(patch));
      setPipelineProjects(prev => prev.map(patch));
    } catch (e) { window.alert('Could not record the waive: ' + (e?.message || e)); }
  };

  // Manual 5-star priority (null = back to the app's suggestion). Deliberately
  // does NOT bump updated_at — a star click must never trip the editor's
  // save-conflict guard.
  const setPriorityStars = async (p, stars) => {
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ priority_stars: stars }).eq('id', p.id);
      if (error) throw error;
      const patch = (x) => x.id === p.id ? { ...x, priorityStars: stars } : x;
      setProjects(prev => prev.map(patch));
      setPipelineProjects(prev => prev.map(patch));
      setWarmProjects(prev => (prev || []).map(patch));
    } catch (e) { window.alert('Stars save failed (is migration 047 applied?): ' + (e.message || e)); }
  };

  const requestFinancialUpdate = (p) => {
    if (!p || !p.owner_email) { window.alert('No owner email on this deal.'); return; }
    const needMonth = monthYearLabel(p._needMonthIso);
    const dataEnd = monthYearLabel(p._dataEndIso);
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
    const cc = (Array.isArray(p.owner_additional) ? p.owner_additional : [])
      .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    setPendingEmail({
      heading: 'Send: monthly financials update request',
      to: (p.owner_email || '').trim(), cc,
      subject: `Updated financials through ${needMonth} — ${p.company_name || 'your listing'}`,
      // Document-flow email → Konnie (Thatcher/Mark 2026-07-23): replies about
      // documents belong with the person who manages them.
      sender: 'konnie', senderFixed: true,
      defaultBody:
`Hi ${p.owner_first_name || 'there'},

With your business on the market, buyers expect financials that run through the most recent month-end — it keeps your listing's numbers credible and current. Our data for you currently runs through ${dataEnd}.

Now that ${needMonth.split(' ')[0]} has closed, could you upload the following when you have a moment?

• Updated TTM Profit & Loss (monthly breakdown)
• Updated TTM Balance Sheet
• Current AR and AP aging reports

The button below takes you straight to your secure portal. We'll refresh your listing materials as soon as they're in.

Thank you!`,
      buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: 'Konnie', portalUrl }),
      onSent: async () => {
        try {
          await supabaseClient.from('project_activity_log').insert({
            project_id: p.id, actor_email: userEmail || 'unknown',
            actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
            kind: 'outreach',
            note: `Monthly financials update requested (through ${needMonth}) — data was through ${dataEnd}`,
            metadata: { source: 'financial_update_reminder', need_month: p._needMonthIso, data_end: p._dataEndIso },
          });
        } catch (e) { console.warn('Financial-update log failed:', e); }
      },
    });
  };
  const pauseFinancialReminders = async (p, pause = true) => {
    if (!supabaseClient || !p) return;
    const label = pause ? 'Pause financial-update reminders' : 'Resume financial-update reminders';
    if (pause && !window.confirm(`${label} for ${p.company_name || 'this deal'}?\n\nUse when the deal is in due diligence / closing and monthly updates are no longer entered into VT.`)) return;
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ financial_reminder_paused: pause, updated_at: new Date().toISOString() })
        .eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'outreach',
        note: pause ? 'Financial-update reminders PAUSED (due diligence / closing)' : 'Financial-update reminders resumed',
        metadata: { source: 'financial_update_reminder', paused: pause },
      });
      setProjects(prev => prev.map(x => x.id === p.id ? { ...x, financial_reminder_paused: pause } : x));
    } catch (e) {
      console.error('Pause reminders failed:', e);
      window.alert('Failed: ' + (e?.message || 'unknown error'));
    }
  };

  // ─── AS-OF Advance decision prompt (increment 4) ───
  // Advance: the staff decision to roll a LOCKED collection's anchor forward.
  // Does the bookkeeping in one click: updates as_of_date to the target,
  // re-opens the RECEIVED date-sensitive items via the established re-request
  // pattern (status not_received + rerequest_note + cleared ShareFile receipt),
  // logs, and preps the roll-forward owner email. Hold: snoozes this prompt a
  // month (its own column — not the deal-wide cadence snooze).
  const advanceAsOf = async (p) => {
    if (!supabaseClient || !p) return;
    const targetIso = p._targetIso.slice(0, 10);
    const targetLabel = monthYearLabel(p._targetIso);
    const effLabel = monthYearLabel(p._effIso);
    const toReRequest = (p._dateSensitiveDocs || []).filter(d => d.received);
    if (!window.confirm(
      `Advance ${p.company_name || 'this deal'}'s as-of date from ${effLabel} to ${targetLabel}?\n\n` +
      (toReRequest.length
        ? `This re-opens ${toReRequest.length} received date-sensitive document(s) for updated versions:\n• ${toReRequest.map(d => d.name).join('\n• ')}\n\nAnnuals and tax returns are unaffected. An editable owner email follows.`
        : `No received date-sensitive documents yet — the requested ranges simply roll forward. An editable owner email follows.`)
    )) return;
    try {
      const nowIso = new Date().toISOString();
      const { error: vErr } = await supabaseClient.from('valuations')
        .update({ as_of_date: targetIso, updated_at: nowIso }).eq('id', p.id);
      if (vErr) throw vErr;
      for (const d of toReRequest) {
        const { error } = await supabaseClient.from('engagement_checklist_items')
          .update({ sharefile_received_at: null, sharefile_file_id: null, ai_classification_confidence: null, status: 'not_received', rerequest_note: `Updated version through ${targetLabel} requested — collection date advanced.` })
          .eq('engagement_id', p.id).eq('item_key', d.itemKey);
        if (error) throw error;
      }
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'document_rerequested',
        note: `As-of date advanced ${effLabel} → ${targetLabel}; ${toReRequest.length} date-sensitive item(s) re-opened for updated versions`,
        metadata: { source: 'as_of_advance', from: p._effIso, to: p._targetIso, reopened: toReRequest.map(d => d.itemKey) },
      });
      setProjects(prev => prev.map(x => x.id === p.id ? { ...x, as_of_date: targetIso } : x));
      if (p.owner_email) {
        const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
        const cc = (Array.isArray(p.owner_additional) ? p.owner_additional : [])
          .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
        setPendingEmail({
          heading: 'Send: collection date rolled forward',
          to: (p.owner_email || '').trim(), cc,
          subject: `Your document collection date has moved to ${targetLabel} — ${p.company_name || ''}`.trim(),
          sender: 'konnie', senderFixed: true, // document-flow → Konnie (2026-07-23)
          defaultBody:
`Hi ${p.owner_first_name || 'there'},

Since your document collection has been underway for a while, we've rolled your file forward so your valuation reflects current numbers — we're now collecting your documents as of ${asOfLabel(new Date(p._targetIso))}.

Most of what you've already sent still works as-is. ${toReRequest.length ? `We just need updated versions of:\n\n${toReRequest.map(d => '• ' + d.name).join('\n')}\n\nYour portal shows the updated date ranges next to each item.` : 'Your portal shows the updated date ranges next to each item.'}

Thank you — this keeps your valuation as accurate as possible.`,
          buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: 'Konnie', portalUrl }),
          onSent: async () => {},
        });
      } else {
        window.alert('As-of date advanced. No owner email on file — add one on Setup to notify them.');
      }
    } catch (e) {
      console.error('Advance as-of failed:', e);
      window.alert('Advance failed: ' + (e?.message || 'unknown error'));
    }
  };
  const holdAsOf = async (p) => {
    if (!supabaseClient || !p) return;
    try {
      const until = new Date(); until.setMonth(until.getMonth() + 1);
      const untilIso = until.toISOString().slice(0, 10);
      const { error } = await supabaseClient.from('valuations')
        .update({ as_of_prompt_snooze_until: untilIso, updated_at: new Date().toISOString() }).eq('id', p.id);
      if (error) throw error;
      setProjects(prev => prev.map(x => x.id === p.id ? { ...x, as_of_prompt_snooze_until: untilIso } : x));
    } catch (e) {
      console.error('Hold as-of prompt failed:', e);
      window.alert('Hold failed: ' + (e?.message || 'unknown error'));
    }
  };

  // Mark a reminder done — sets completed_at, removes from the local list.
  const dismissReminder = async (reminderId) => {
    if (!supabaseClient || !reminderId) return;
    try {
      const { error } = await supabaseClient
        .from('project_reminders')
        .update({ completed_at: new Date().toISOString() })
        .eq('id', reminderId);
      if (error) throw error;
      setMyReminders(prev => prev.filter(r => r.id !== reminderId));
    } catch (e) {
      console.error('Dismiss reminder failed:', e);
      window.alert('Failed to dismiss: ' + (e?.message || 'unknown error'));
    }
  };

  // ─── AM follow-up actions (inline on the card, no file access) ───
  // Set the next-touch date (reuses snooze_until). Optimistic local update so
  // the card immediately re-buckets to "Following up later". (2026-06-09)
  const setFollowUpDate = async (projectId, dateStr, note = '', revival = null) => {
    if (!supabaseClient || !projectId || !dateStr) return;
    const todayMid = new Date(); todayMid.setHours(0, 0, 0, 0);
    const trimmed = (note || '').trim();
    const nowIso = new Date().toISOString();
    const applyDate = (p) => p.id === projectId
      ? { ...p, snooze_until: dateStr, isSnoozed: new Date(dateStr + 'T00:00:00') > todayMid,
          ...(trimmed ? { interactionNote: trimmed, interactionAt: nowIso, interactionActor: myName || null } : {}) }
      : p;
    setAmProjects(prev => prev.map(applyDate));
    setFollowUpProjects(prev => prev.map(applyDate)); // Lead's considering-followup cards
    try {
      await supabaseClient.from('valuations')
        .update({ snooze_until: dateStr, updated_at: nowIso })
        .eq('id', projectId);
      // Every date set leaves a trace (Adam 10-13, Berkman: "I'm fairly certain I
      // already marked it for 2 months" — a date set without a note wrote nothing,
      // so nobody could tell what was set, when, or by whom).
      await supabaseClient.from('project_activity_log').insert({
        project_id: projectId, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'followup_set', note: `Next follow-up set for ${dateStr}`,
        metadata: { until: dateStr },
      });
      // If the AM jotted a note with this touch, log it as the contact note.
      if (trimmed) {
        await supabaseClient.from('project_activity_log').insert({
          project_id: projectId, actor_email: userEmail || 'unknown',
          actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
          kind: 'outreach', note: trimmed,
        });
      } else if (revival) {
        // Reschedule on a 🌱 card IS the answer to the owner's reply (Adam 09-28,
        // Erosion Pros: "3 mo" set the date but the banner held the card — the
        // old two-step "Reschedule, then ✕ Not now"). Logged as a deferral, so
        // the card clears until the date; a NEWER reply cards again.
        await supabaseClient.from('project_activity_log').insert({
          project_id: projectId, actor_email: userEmail || 'unknown',
          actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
          kind: 'reply_deferred', note: `Owner's reply answered with a later check-in — card returns ${dateStr}`,
          metadata: { reply_at: revival.replyAt || null, reply_from: revival.replyFrom || null, until: dateStr },
        });
        setReloadTick(t => t + 1);
      }
    } catch (e) { console.error('Set follow-up failed:', e); }
  };

  // Bring a parked owner back to the active follow-up list now.
  const clearFollowUp = async (projectId) => {
    if (!supabaseClient || !projectId) return;
    const applyClear = (p) => p.id === projectId
      ? { ...p, snooze_until: null, isSnoozed: false } : p;
    setAmProjects(prev => prev.map(applyClear));
    setFollowUpProjects(prev => prev.map(applyClear)); // Lead's considering-followup cards
    try {
      await supabaseClient.from('valuations')
        .update({ snooze_until: null, updated_at: new Date().toISOString() })
        .eq('id', projectId);
    } catch (e) { console.error('Clear follow-up failed:', e); }
  };

  // Log that the AM reached out to the owner (shows in the project history +
  // Last Interaction). Optional note captures what happened, and surfaces on the
  // card next time. Actor is the signed-in user.
  const logOutreach = async (projectId, note = '') => {
    if (!supabaseClient || !projectId) return;
    const trimmed = (note || '').trim();
    const display = trimmed || 'Reached out to the owner';
    const nowIso = new Date().toISOString();
    try {
      await supabaseClient.from('project_activity_log').insert({
        project_id: projectId,
        actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'outreach',
        note: display,
      });
      // Reflect on the card immediately so the note is there for the next touch
      // without waiting for a reload.
      const stamp = (p) => p.id === projectId
        ? { ...p, interactionNote: display, interactionAt: nowIso, interactionActor: myName || null } : p;
      setAmProjects(prev => prev.map(stamp));
      setFollowUpProjects(prev => prev.map(stamp));
    } catch (e) { console.error('Log outreach failed:', e); }
  };

  // ─── Warm-account actions (Warm → Active onboarding) ───
  // Intro-email resend target (AM) and Activate/Pass target (Lead). Null = closed.
  const [warmIntroTarget, setWarmIntroTarget] = useState(null);
  const [warmActivateTarget, setWarmActivateTarget] = useState(null);
  // Review-and-send payload for the formerly-auto-sent owner emails (docs-ready,
  // revalue-review). Null = closed. Set by activate/re-engage so staff see + can
  // edit the message before it goes. (Mark 2026-06-24)
  const [pendingEmail, setPendingEmail] = useState(null);

  // #8/#9: Konnie reviewed an owner portal update (finished-uploading and/or a
  // "doesn't apply" flag). Clears the signals so the card drops off her My Work —
  // she handles the actual documents in the deal. Clearing the flags returns the
  // portal items to normal tracking (staff decides; if a doc is truly needed she
  // re-requests via the deal). Best-effort per signal.
  const reviewedPortalUpdate = async (p) => {
    if (!supabaseClient || !p) return;
    const nowIso = new Date().toISOString();
    try {
      if (p.ownerUploadsDone) {
        await supabaseClient.from('valuations')
          .update({ owner_uploads_done: null, updated_at: nowIso }).eq('id', p.id);
      }
      if (Array.isArray(p.ownerNaItems) && p.ownerNaItems.length > 0) {
        await supabaseClient.from('engagement_checklist_items')
          .update({ owner_na: false, owner_na_note: null, updated_at: nowIso })
          .eq('engagement_id', p.id).eq('owner_na', true);
      }
    } catch (e) {
      console.error('Reviewed portal update failed:', e);
      window.alert('Could not clear this update: ' + (e?.message || 'unknown error'));
      return;
    }
    setReloadTick(t => t + 1);
  };

  // Konnie: a revalue whose doc-curation card isn't needed this cycle — the
  // docs were handled outside the portal release, or the cycle moved on
  // (Konnie 2026-07-28: "it has been there since it started to be revalued").
  // Clears the gate; logged so the release history stays honest.
  const dismissRevalueDocsCard = async (p) => {
    if (!supabaseClient || !p) return;
    if (!window.confirm(`Clear the revalue doc-review card for ${p.company_name || p.name}? Use this when the cycle doesn't need a curated portal release — the owner's document list stays exactly as it is.`)) return;
    const nowIso = new Date().toISOString();
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ revalue_docs_pending: false, updated_at: nowIso }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed',
        note: 'Revalue doc-review card cleared — no curated release needed this cycle',
        metadata: { revalue_docs_pending_cleared: true, via: 'my_work_card' },
      });
    } catch (e) {
      console.error('Dismiss revalue docs card failed:', e);
      window.alert('Could not clear the card: ' + (e?.message || 'unknown error'));
      return;
    }
    setReloadTick(t => t + 1);
  };

  const openWarmIntro = (p) => setWarmIntroTarget({
    engagementId: p.id,
    ownerFirstName: p.owner_first_name || '',
    ownerEmail: p.owner_email || '',
    ownerAdditional: Array.isArray(p.owner_additional) ? p.owner_additional : [],
    leadName: p.lead || '',
    amName: p.account_manager || '',
    companyName: p.company_name || '',
    meetingDate: p.discovery_meeting_date || '',
    // A re-engaged (re-Warmed) project carries revalue_review_pending; a
    // first-time warm never does — so the intro email uses "Hi again" framing.
    isReengagement: !!p.revalue_review_pending,
  });

  // Lead activates a warm account: Warm → Active (awaiting_upload), set the
  // committal date + path/likelihood, and RELEASE the portal documents — one
  // action. Partial path also writes the planned-doc subset into the row's data
  // so the "X of Y" progress tracks only the agreed items.
  const activateWarm = async (p, { committal, path, likelihood, discoveryDate, plannedIds, revision }) => {
    if (!supabaseClient || !p) return;
    // A committal is a date the owner promised documents BY — it must be in
    // the future (Mark 09-11, ITCS: Thatcher activated right after the
    // morning meeting but the committal saved as the activation day itself,
    // which fired the pre-committal nudge instantly on a two-hour-old deal).
    const todayIso0 = new Date().toISOString().slice(0, 10);
    if (committal && committal <= todayIso0) {
      window.alert(`The committed upload date (${committal}) must be in the future — it's the date the owner promised their documents BY, from your conversation. Today or a past date can't be a committal.`);
      return;
    }
    const nowIso = new Date().toISOString();
    const plannedSet = new Set(Array.isArray(plannedIds) ? plannedIds : []);
    const isPartial = path === 'partial';
    let existingData = {};
    try {
      const { data: row } = await supabaseClient.from('valuations').select('data').eq('id', p.id).single();
      existingData = (row && row.data) || {};
    } catch (e) { console.warn('Data read for activation skipped:', e); }
    // A genuine re-engagement is flagged explicitly by the re-engage flow
    // (reEngageProject sets revalue_review_pending = true, and ONLY it does).
    // The previous heuristic — "the account already has a documentChecklist in
    // data" — misfired: fresh warm accounts now carry a checklist too, so every
    // FIRST-TIME activation was wrongly treated as a re-engagement (docs held +
    // handed to Konnie to curate, instead of auto-released). Use the flag.
    const isReengagement = !!p.revalue_review_pending;
    // Build the checklist from the activation choice — Full → all 18, Partial →
    // just the planned subset the Lead selected — for first-time AND
    // re-engagement alike. The Lead's path/planned choice is the starting set;
    // on a re-engagement Konnie then refines it via the Data-Entered sections.
    // (sellerQA carries forward separately in existingData.)
    const checklist = DEFAULT_DOCUMENT_CHECKLIST.map(d => ({ ...d, planned: isPartial ? plannedSet.has(d.id) : false }));
    const update = {
      workflow_stage: 'awaiting_upload',
      stage_entered_at: nowIso,
      // Docs release is GATED ON THE EMAIL for first-time too: held false here
      // and flipped true in the email modal's onSent, so cancelling the email
      // box leaves the deal activated-but-unreleased with the Setup "Release
      // document list" button ready — never released-without-notification (the
      // Zac 2026-07-17 bug: Cancel had already committed the release + logged it,
      // so the owner got no email but everything read as sent). Mirrors
      // releaseDocsToOwner. Re-engagement was already held here (Konnie curates +
      // releases; revalue_docs_pending set below).
      portal_docs_released: false,
      committed_upload_date: committal || null,
      // Stamp the discovery/intro meeting date (defaults to today in the modal).
      // Drives the future revalue Lead-meeting rule. Only set when provided so a
      // re-activation can't blank an existing date.
      ...(discoveryDate ? { discovery_meeting_date: discoveryDate } : {}),
      path: path || null,
      likelihood_pct: (likelihood === '' || likelihood == null) ? null : Number(likelihood),
      updated_at: nowIso,
      data: { ...existingData, documentChecklist: checklist },
    };
    if (isReengagement) update.revalue_docs_pending = true;
    try {
      // Seed the checklist that the owner portal + Konnie's worklist read. Do this
      // BEFORE releasing the docs, so a failure aborts instead of leaving a
      // released-but-empty portal. IMPORTANT: supabase-js returns errors in the
      // result object — it does NOT throw — so check them explicitly, or a failed
      // seed is silent (no popup, no rows; the exact symptom seen 2026-06-26).
      const items = checklist.map((d, i) => ({
        engagement_id: p.id,
        item_key: String(d.id),
        display_name: d.name,
        tier: d.tier === 'minimum' ? 'minimum' : 'full',
        status: 'not_received',
        notes: d.notes || null,
        planned: d.planned === true,
        sort_order: i,
        updated_at: nowIso,
      }));
      const { error: seedErr } = await supabaseClient
        .from('engagement_checklist_items').upsert(items, { onConflict: 'engagement_id,item_key' });
      if (seedErr) throw new Error('seeding the document checklist failed: ' + (seedErr.message || JSON.stringify(seedErr)));
      const { error: updErr } = await supabaseClient.from('valuations').update(update).eq('id', p.id);
      if (updErr) throw new Error('releasing the account failed: ' + (updErr.message || JSON.stringify(updErr)));
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed',
        // `revision` = the Lead came ← Back from the email review to correct a
        // field; the same writes re-run (they're idempotent) but the history
        // shouldn't read as a second activation.
        note: revision
          ? 'Activation details revised (← Back from the email review) — docs-ready email pending review'
          : isReengagement
            ? 'Activated re-engagement — Warm → Active; docs handed to Konnie to curate'
            : 'Activated — Warm → Active; docs-ready email pending review (release commits when it sends)',
        metadata: { from: 'warm', to: 'awaiting_upload', released_docs: false, reengagement: isReengagement, revision: !!revision },
      });
      setWarmProjects(prev => prev.filter(x => x.id !== p.id)); // off the warm list now
      // Full reload so the now-Active project lands in the pipeline + (for a
      // re-engagement) Konnie's "Review docs required" card, without a manual
      // page refresh.
      setReloadTick(t => t + 1);
    } catch (e) {
      console.error('Activate failed:', e);
      window.alert('Activation failed: ' + (e?.message || 'unknown error'));
      return;
    }
    // First-time: review + send the "documents ready" email (re-engagement skips
    // it — Konnie sends it when she releases the curated list). Staff see + can
    // edit the message before it goes.
    if (!isReengagement && p.owner_email) {
      const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
      const cc = (Array.isArray(p.owner_additional) ? p.owner_additional : [])
        .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
      setPendingEmail({
        heading: 'Send: your document list is ready',
        to: (p.owner_email || '').trim(), cc,
        subject: 'Your Vista Business Group document list is ready',
        sender: 'konnie', senderFixed: true, // document-flow → Konnie; the body introduces her (2026-07-23)
        defaultBody: docsReadyBodyText({ ownerFirstName: p.owner_first_name, companyName: p.company_name, committalDate: committal, leadName: p.lead }),
        buildHtml: (b) => buildDocsReadyEmailHtml({ leadName: p.lead, portalUrl, bodyText: b }),
        // ← Back (Zac 2026-07-17): reopen the activation form with every entry
        // preserved so a committal-date fix doesn't cost the whole form. The
        // activation already committed; re-Activating re-runs the same
        // idempotent writes as a logged "revision" and pops this email again
        // with the corrected date baked in.
        backLabel: '← Back to activation',
        onBack: () => {
          setPendingEmail(null);
          setWarmActivateTarget({ ...p, _activateInitial: { committal, path, likelihood, discoveryDate, plannedIds } });
        },
        // Release commits HERE, only after the email actually sends — matches
        // releaseDocsToOwner. Cancel → onSent never runs → docs stay unreleased
        // and the Setup "Release document list" button is ready to send later.
        onSent: async () => {
          const sentIso = new Date().toISOString();
          try {
            const { error: relErr } = await supabaseClient.from('valuations')
              .update({ portal_docs_released: true, updated_at: sentIso })
              .eq('id', p.id);
            if (relErr) throw relErr;
            await supabaseClient.from('project_activity_log').insert({
              project_id: p.id, actor_email: userEmail || 'unknown',
              actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
              kind: 'stage_changed',
              note: 'Document list released to the owner portal + owner emailed',
              metadata: { released_docs: true, via: 'activation' },
            });
            setReloadTick(t => t + 1); // reflect the now-released state in the pipeline
          } catch (e) {
            console.error('Release-after-email failed:', e);
            window.alert('The email sent, but opening the documents failed: ' + (e?.message || '') + '\nOpen the deal → Setup and click “Release document list to owner”, or flip the release toggle.');
          }
        },
      });
    }
    setWarmActivateTarget(null);
  };

  // Email the owner that their document list is ready in the portal, sent as the
  // Lead (server falls back to Konnie if the Lead's Gmail isn't connected).
  // Best-effort — never blocks activation.
  const sendDocsReadyEmail = async (p) => {
    if (!supabaseClient || !p || !p.owner_email) return;
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) return;
      const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
      const html = buildDocsReadyEmailHtml({
        ownerFirstName: p.owner_first_name || '',
        leadName: p.lead || '',
        companyName: p.company_name || '',
        committalDate: p.committed_upload_date || '',
        portalUrl,
      });
      const cc = (Array.isArray(p.owner_additional) ? p.owner_additional : [])
        .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
      await fetch('/api/gmail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({
          to: p.owner_email.trim(),
          cc: cc.length ? cc.join(', ') : undefined,
          subject: 'Your Vista Business Group document list is ready',
          body: html,
          sender: 'konnie', // document-flow → Konnie; the body introduces her (2026-07-23)
        }),
      });
    } catch (e) { console.warn('Docs-ready email failed (non-fatal):', e); }
  };

  // Lead passes on a warm account after the meeting (too small / not a fit):
  // Warm → Disqualified. No valuation was ever produced, so this is the
  // no-valuation dead state (never val_complete_dead). Keeps the row + ShareFile
  // folder for history, off the pipeline.
  const passWarm = async (p, reason) => {
    if (!supabaseClient || !p) return;
    const nowIso = new Date().toISOString();
    try {
      const { error: deadErr } = await supabaseClient.from('valuations')
        .update({ workflow_stage: 'disqualified', stage_entered_at: nowIso, likelihood_pct: 0, updated_at: nowIso })
        .eq('id', p.id);
      if (deadErr) throw deadErr; // supabase-js returns errors in the result; check or it fails silently
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed', note: `Passed — not a fit${reason ? ': ' + reason : ''}`,
        metadata: { from: 'warm', to: 'disqualified', reason: reason || null },
      });
      setWarmProjects(prev => prev.filter(x => x.id !== p.id));
    } catch (e) {
      console.error('Pass failed:', e);
      window.alert('Pass failed: ' + (e?.message || 'unknown error'));
      return;
    }
    setWarmActivateTarget(null);
  };

  // Owner missed the introductory meeting and the Lead couldn't get them to
  // reschedule. Not a "pass" (the owner never declined) — hand the warm account
  // back to the AM to keep nurturing. Lands on the AM's "Owners to follow up"
  // plate (stalled_returned_to_am, likelihood reset); the AM can set a next
  // touch and re-engage later (which routes back through Warm for a new intro).
  const returnWarmToAm = async (p, reason) => {
    if (!supabaseClient || !p) return;
    // Leave-off note REQUIRED (Mark 08-11) — greets the AM on the card.
    let why = (reason || '').trim();
    if (!why) {
      why = (window.prompt('Where did it leave off? (required — this line shows on the AM\'s follow-up card)') || '').trim();
      if (!why) return;
    }
    reason = why;
    const nowIso = new Date().toISOString();
    try {
      const { error: retErr } = await supabaseClient.from('valuations')
        .update({ workflow_stage: 'stalled_returned_to_am', stage_entered_at: nowIso, likelihood_pct: 0, updated_at: nowIso })
        .eq('id', p.id);
      if (retErr) throw retErr; // supabase-js returns errors in the result; check or it fails silently
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed',
        note: `Intro meeting missed — couldn't reschedule; returned to the AM: ${reason}`,
        metadata: { from: 'warm', to: 'stalled_returned_to_am', reason },
      });
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'leave_off', note: reason, metadata: { stage: 'stalled_returned_to_am' },
      });
      setWarmProjects(prev => prev.filter(x => x.id !== p.id));
      // The AM bucket is a separate query — reload so it surfaces there now.
      setReloadTick(t => t + 1);
    } catch (e) {
      console.error('Return to AM failed:', e);
      window.alert('Return to AM failed: ' + (e?.message || 'unknown error'));
      return;
    }
    setWarmActivateTarget(null);
  };

  // Re-engage an AM-owned stalled / inactive project (piece 4). AMs are
  // read-only in the editor, so this is a whitelisted button-action that runs
  // the whole archive → reset → route flow at the DB level (no editor). The
  // Lead-meeting rule decides: skip-eligible (full + last contact ≤12mo) → a
  // light revalue straight back into the upload flow with the Lead review email;
  // otherwise → re-Warm, where the existing intro→activate lifecycle takes over.
  const reEngageProject = async (p) => {
    if (!supabaseClient || !p) return;
    const { data: row, error } = await supabaseClient.from('valuations')
      .select('data, path, valuation_date, discovery_meeting_date, next_meeting_date, workflow_stage, value_provided_low, value_provided_high, owner_email, owner_first_name, lead, owner_additional')
      .eq('id', p.id).single();
    if (error || !row) { window.alert('Could not load this project to re-engage.'); return; }
    row.last_held_meeting = await fetchLastHeldMeeting(supabaseClient, p.id, p.client_id);
    const routing = computeReengageRouting(row);
    const ago = routing.months == null ? 'no prior meeting/valuation on record' : `last contact ~${routing.months} mo ago`;

    let committal = null;
    let meetingDate = null;
    let likelihoodPct = null;
    if (routing.skipMeeting) {
      committal = window.prompt(
        `${p.company_name}: full valuation, ${ago} — no Lead meeting needed.\n\n`
        + 'This re-engages them directly: prior answers reopen for review and the document list comes back.\n\n'
        + 'Enter the new committed upload date (YYYY-MM-DD):');
      if (!committal) return;
      committal = committal.trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(committal)) { window.alert('Please enter the date as YYYY-MM-DD.'); return; }
      // The project's likelihood was zeroed when it left the pipeline; this
      // re-engagement is back in the active funnel, so capture a fresh read.
      const lk = window.prompt(`How likely is ${p.company_name} to sell in the next ~30 days? Enter 0–100:`, '');
      if (lk === null) return;
      const n = Number(lk);
      if (lk.trim() === '' || isNaN(n) || n < 0 || n > 100) { window.alert('Enter a likelihood from 0 to 100.'); return; }
      likelihoodPct = n;
    } else {
      // Meeting required → re-Warm. The AM schedules the intro meeting with the
      // Lead right here, so capture that date (it shows on the Warm card and the
      // intro email; leave blank to set it later).
      const why = routing.isFull ? ago : 'partial valuation';
      meetingDate = window.prompt(
        `${p.company_name}: ${why} → this re-engagement needs a fresh introductory meeting with the Lead.\n\n`
        + 'This archives the prior cycle, reopens the questions for review, and moves it to Warm so you can send the intro email.\n\n'
        + 'Enter the introductory meeting date (YYYY-MM-DD), or leave blank to set it later:');
      if (meetingDate === null) return; // cancelled
      meetingDate = meetingDate.trim();
      if (meetingDate && !/^\d{4}-\d{2}-\d{2}$/.test(meetingDate)) { window.alert('Please enter the date as YYYY-MM-DD.'); return; }
    }

    const nowIso = new Date().toISOString();
    try {
      // 1. Archive the prior cycle (must succeed before any reset).
      const { error: aErr } = await supabaseClient.from('valuation_revisions').insert({
        valuation_id: p.id,
        valued_date: row.valuation_date || null,
        value_low: row.value_provided_low ?? null,
        value_high: row.value_provided_high ?? null,
        data: row.data,
      });
      if (aErr) throw aErr;
      // 2. Reset progress signals in the data blob (sellerQA carries forward).
      const data = { ...(row.data || {}) };
      // Current template, not a status-reset of the old list (Konnie 08-20 —
      // see startRevalue's matching change).
      data.documentChecklist = DEFAULT_DOCUMENT_CHECKLIST.map(d => ({ ...d }));
      // Current-period clear (Mark 08-20 — closed history carries, the
      // current window doesn't): drop the keys so the next open hydrates
      // pristine defaults; zero category TTM/YTD + sales-grid TTM columns
      // in place (closed years + customer enrichment stay).
      ['ttmMonthlyData', 'monthlyTtmRevenue', 'monthlyTtmCogs', 'monthlyTtmOpex', 'monthlyTtmOtherIncome',
        'monthlyTtmOtherExpense', 'monthlyTtmDiat', 'monthlyTtmNotes', 'ttmBsMonthLabels', 'ttmBsCurrentAssets',
        'ttmBsFixedAssets', 'ttmBsOtherAssets', 'ttmBsCurrentLiabilities', 'ttmBsLongTermLiabilities', 'ttmBsEquity',
        'wcCustomMonths', 'arAgingData', 'arAgingLineItems', 'arAgingBucketLabels', 'arReviewChecklist', 'arAgingNotes',
        'apAnalysis', 'apAgingLineItems', 'apAgingBucketLabels', 'apReviewChecklist', 'monthlySalesData',
        'reconVarianceStatus', 'reconQualityChecklist', 'bsVarianceStatus', 'incomeVarianceStatus',
      ].forEach(k => { delete data[k]; });
      const zeroTtmBlob = (cats) => (Array.isArray(cats) ? cats.map(c => ({
        ...c,
        cash: c.cash ? { ...c.cash, ttm: 0, ytd: 0 } : c.cash,
        accrual: c.accrual ? { ...c.accrual, ttm: 0, ytd: 0 } : c.accrual,
      })) : cats);
      ['revenueCategories', 'cogsCategories', 'opexCategories', 'otherIncomeCategories', 'otherExpenseCategories', 'diatCategories']
        .forEach(k => { if (data[k]) data[k] = zeroTtmBlob(data[k]); });
      ['customerSalesCash', 'customerSalesAccrual', 'customerSalesData', 'customerSalesDataAlt']
        .forEach(k => { if (Array.isArray(data[k])) data[k] = data[k].map(r => ({ ...r, ttm: 0 })); });
      data.adjustmentsStatus = 'not_started';
      data.revenueScoring = 'mrr';   // a revalue leaves the grandfathered (legacy) revenue scoring (Mark 10-06)
      data.capexMethod = 'fcf';      // and moves to the free-cash-flow basis (10-20)
      data.growthTest = 'ttm';       // and to the TTM growth test (10-21)
      data.spikeMath = 'consistent'; // and to the consistent spike math (10-28)
      data.payrollTaxMethod = 'wage_base';   // and to the accurate payroll tax (10-22)
      // 3. Clear the table's ShareFile receipts + statuses for the new cycle.
      try {
        await supabaseClient.from('engagement_checklist_items')
          .update({ sharefile_received_at: null, sharefile_file_id: null, ai_classification_confidence: null, status: 'not_received' })
          .eq('engagement_id', p.id);
      } catch (e) { console.warn('Re-engage: clearing checklist signals failed:', e); }
      // 4. Route + reset the row.
      const update = {
        data,
        portal_docs_released: false,
        revalue_review_pending: true,
        upload_started_date: null, upload_complete_date: null, valuation_date: null,
        next_meeting_date: null, next_meeting_type: null,
        stage_entered_at: nowIso, updated_at: nowIso,
      };
      if (routing.skipMeeting) {
        // Light revalue: Konnie curates docs now (gate the card immediately).
        update.workflow_stage = 'awaiting_upload';
        update.committed_upload_date = committal;
        update.revalue_docs_pending = true;
        update.likelihood_pct = likelihoodPct; // fresh read on re-entry

      } else {
        // Re-Warm: docs are curated AFTER the Lead meeting/activation, so don't
        // arm Konnie's doc card yet (activation handles it). Questions still go
        // into review-mode so the owner reviews carried-forward answers. Stamp
        // the scheduled intro meeting date if the AM set one.
        update.workflow_stage = 'warm';
        update.committed_upload_date = null;
        update.revalue_docs_pending = false;
        if (meetingDate) update.discovery_meeting_date = meetingDate;
      }
      const { error: uErr } = await supabaseClient.from('valuations').update(update).eq('id', p.id);
      if (uErr) throw uErr;
      // 5. Log.
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'revalue_started',
        note: routing.skipMeeting
          ? 'Re-engaged — full revalue, Lead meeting skipped (recent contact)'
          : 'Re-engaged — routed to a new introductory meeting (Warm)',
        metadata: { from: p.workflow_stage, skip_meeting: routing.skipMeeting, months_since_contact: routing.months, path: row.path },
      });
      // 6. Off the AM list + full reload (Warm is a separate query that won't
      //    update from the local state edit alone).
      setAmProjects(prev => prev.filter(x => x.id !== p.id));
      setReloadTick(t => t + 1);
      // 7. Skip path → review-and-send the "review your answers" email (staff see
      //    + can edit it before it goes). Meeting path → the AM sends the intro
      //    from the Warm section instead, so just confirm the move.
      if (routing.skipMeeting) {
        if (row.owner_email) {
          const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
          const cc = (Array.isArray(row.owner_additional) ? row.owner_additional : [])
            .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
          setPendingEmail({
            heading: 'Send: review your answers',
            to: row.owner_email.trim(), cc,
            subject: 'Continuing your Vista Business Group valuation',
            sender: leadGmailKey(row.lead) || 'konnie',
            defaultBody: revalueReviewBodyText({ ownerFirstName: row.owner_first_name, companyName: p.company_name }),
            buildHtml: (b, signer) => buildRevalueReviewEmailHtml({ leadName: signer || row.lead, portalUrl, bodyText: b }),
          });
        }
      } else {
        window.alert('Re-engaged — moved to Warm. Open the Warm section to send the intro email; the Lead activates after the meeting.');
      }
    } catch (e) {
      console.error('Re-engage failed:', e);
      window.alert('Re-engage failed — nothing was changed.\n\n' + (e?.message || ''));
    }
  };

  // Mark an AM-owned follow-up dead — the owner is definitively not moving
  // forward. One of the three outreach outcomes (set next touch / re-engage /
  // dead). Routes to the right terminal state: val_complete_dead only when a
  // valuation was actually produced (came from val_complete_inactive, or a
  // valuation figure/date exists), otherwise the no-valuation disqualified
  // state — so "Valuation Complete" is never claimed falsely. Logs + drops off
  // the AM list. (2026-06-24, split 2026-07-13)
  // ── Valuation-meeting outcome, FROM THE PLATE (Mark 09-21: "we should never
  // need to leave the card"). Same writes as the editor's outcome form minus
  // the value lock (no engine on the plate — the value on record stands; the
  // editor's drift prompt corrects it). Logs like the editor does.
  const plateRecordOutcome = async (p, { decision: picked, date, reason }) => {
    if (!supabaseClient || !p || !picked) return false;
    const nowIso = new Date().toISOString();
    const isReview = picked === 'strategic_review_set';
    const isFollowup = picked === 'considering_followup';
    // Awaiting Decision rule (Mark 09-28): a dated follow-up inside the window
    // keeps the deal Awaiting Decision; the date is its reminder.
    const decision = isFollowup ? followupStage(date) : picked;
    if ((isReview || isFollowup) && !date) { window.alert(isReview ? 'A strategic review is a MEETING — the date is required.' : 'The circle-back date is required.'); return false; }
    let leaveOff = null;
    if (decision === 'val_complete_inactive') {
      leaveOff = (reason || '').trim() || window.prompt('Where did it leave off? (required — this line shows on the follow-up card months from now)', '');
      if (!leaveOff || !leaveOff.trim()) { window.alert('The leave-off note is required.'); return false; }
    }
    const updates = {
      valuation_date: p.valuation_date || p.next_meeting_date || nowIso.slice(0, 10),
      workflow_stage: decision, stage_entered_at: nowIso,
      next_meeting_date: isReview ? date : null,
      next_meeting_type: isReview ? 'Strategic Review' : null,
      ...(isFollowup ? { snooze_until: date } : {}),
      ...(decision === 'considering_followup' ? { likelihood_pct: 0 } : {}),
      updated_at: nowIso,
    };
    try {
      const { error } = await supabaseClient.from('valuations').update(updates).eq('id', p.id);
      if (error) throw error;
      const actor = { actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null) };
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, ...actor, kind: 'stage_changed',
        note: `Valuation meeting outcome recorded — ${stageLabel(decision)}${date ? ` (${date})` : ''}`,
        metadata: { from: p.workflow_stage, to: decision, reason: 'meeting-outcome', via: 'plate' },
      });
      if (leaveOff) await supabaseClient.from('project_activity_log').insert({ project_id: p.id, ...actor, kind: 'leave_off', note: leaveOff.trim(), metadata: { stage: decision } });
      else if ((reason || '').trim()) await supabaseClient.from('project_activity_log').insert({ project_id: p.id, ...actor, kind: 'note', note: `Outcome reason — ${reason.trim()}`, metadata: { stage: decision, reason: 'meeting-outcome' } });
    } catch (e) { window.alert('Could not record the outcome: ' + (e?.message || '')); return false; }
    setReloadTick(t => t + 1);
    return true;
  };
  // 📝 Agreement out (Mark 09-28, Assura: "send us the engagement agreement"
  // should move the deal a step). Pulls a follow-up / considering deal back
  // into Awaiting Decision, top of the staff-meeting group, and logs the mark
  // the pipeline reads. Engaged comes when it's signed.
  const plateAgreementOut = async (p) => {
    if (!supabaseClient || !p) return false;
    if (!window.confirm(`${p.company_name}: the engagement agreement went out to the owner?\n\nThe deal shows as "📝 Agreement out" at the top of Awaiting Decision until it's signed.`)) return false;
    const nowIso = new Date().toISOString();
    const actor = { actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null) };
    try {
      const upd = { snooze_until: null, updated_at: nowIso,
        likelihood_pct: Math.max(Number(p.likelihood_pct) || 0, 80) };
      if (p.workflow_stage !== 'awaiting_decision') { upd.workflow_stage = 'awaiting_decision'; upd.stage_entered_at = nowIso; }
      const { error } = await supabaseClient.from('valuations').update(upd).eq('id', p.id);
      if (error) throw error;
      if (upd.workflow_stage) await supabaseClient.from('project_activity_log').insert({ project_id: p.id, ...actor, kind: 'stage_changed',
        note: 'Owner asked for the engagement agreement — back to Awaiting Decision', metadata: { from: p.workflow_stage, to: 'awaiting_decision', reason: 'agreement-out' } });
      await supabaseClient.from('project_activity_log').insert({ project_id: p.id, ...actor, kind: 'agreement_out',
        note: '📝 Engagement agreement sent to the owner', metadata: {} });
    } catch (e) { window.alert('Could not record: ' + (e?.message || '')); return false; }
    setReloadTick(t => t + 1);
    return true;
  };
  // 🔥 / 🤔 / ❄ — the Lead's read on a deciding owner, one click from the card
  // (writes the existing likelihood_pct; the staff meeting sorts on it).
  const plateSetLikelihood = async (p, pct) => {
    if (!supabaseClient || !p) return;
    try {
      const { error } = await supabaseClient.from('valuations').update({ likelihood_pct: pct, updated_at: new Date().toISOString() }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({ project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null), kind: 'note',
        note: `Likelihood set ${likelihoodMark(pct)} ${pct}%`, metadata: { likelihood_pct: pct } });
    } catch (e) { window.alert('Could not save: ' + (e?.message || '')); return; }
    setReloadTick(t => t + 1);
  };
  // ✓ Data entered (Mark 09-28) — Konnie's hand-off to Colleen. Ties to the source (Mark 10-12): the
  // card opens the check first (saved numbers vs the statements); the hand-off happens only from there.
  const [plateTieOut, setPlateTieOut] = useState(null);
  const plateDataEntered = async (p) => {
    if (!supabaseClient || !p) return;
    const to = (p.path === 'partial' && p.colleen_review_decision === 'skip') ? 'analysis_complete' : 'data_entry_complete';
    const { data: row, error } = await supabaseClient.from('valuations').select('data').eq('id', p.id).single();
    if (error) { window.alert('Could not load the numbers: ' + (error.message || '')); return; }
    setPlateTieOut({ p, to, result: computeTieOut((row && row.data) || {}) });
  };
  // "Not provided (yet)" from the card's check (Mark 10-12): written only if the deal hasn't changed since
  // it was read (an open editor tab then refuses its stale save instead of overwriting this).
  const plateMarkNotProvided = async (p, doc, note) => {
    const { data: row, error } = await supabaseClient.from('valuations').select('data, updated_at').eq('id', p.id).single();
    if (error || !row) { window.alert('Could not load the deal: ' + ((error && error.message) || '')); return; }
    const data = row.data || {};
    const list = (data.documentChecklist || []).map(x => x.id === doc.id ? { ...x, status: 'not_provided', pendingNotes: note } : x);
    const nowIso = new Date().toISOString();
    const { data: hit, error: e2 } = await supabaseClient.from('valuations').update({ data: { ...data, documentChecklist: list }, updated_at: nowIso })
      .eq('id', p.id).eq('updated_at', row.updated_at).select('id');
    if (e2 || !hit || !hit.length) { window.alert('The deal changed while this was open. Open the deal and mark the document there.'); return; }
    try {
      await supabaseClient.from('engagement_checklist_items').update({ pending_notes: note, updated_at: nowIso })
        .eq('engagement_id', p.id).eq('item_key', String(doc.id));
      await supabaseClient.from('project_activity_log').insert({ project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null), kind: 'document_not_provided',
        note: doc.name + ' marked not provided at this time — ' + note, metadata: { item_key: String(doc.id), display_name: doc.name, via: 'data_entered_check' } });
    } catch (e) { /* the deal itself is saved; table + log are best-effort */ }
    setPlateTieOut(t => (t ? { ...t, result: computeTieOut({ ...data, documentChecklist: list }) } : t));
  };
  const plateHandOff = async (p, to, res) => {
    setPlateTieOut(null);
    const nowIso = new Date().toISOString();
    const who = to === 'analysis_complete' ? 'the Lead' : 'Colleen';
    try {
      const { error } = await supabaseClient.from('valuations').update({ workflow_stage: to, stage_entered_at: nowIso, updated_at: nowIso })
        .eq('id', p.id).eq('workflow_stage', 'upload_complete');
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({ project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null), kind: 'stage_changed',
        note: tieOutNote(who, res), metadata: { from: 'upload_complete', to, via: 'data_entered', tie_out: tieOutMeta(res), company: p.company_name || '' } });
    } catch (e) { window.alert('Could not record: ' + (e?.message || '')); return; }
    setReloadTick(t => t + 1);
  };
  // Mark's radar (Mark 10-12): hand-offs that went forward WITHOUT matching the statements, last 14 days.
  const [tieOverrides, setTieOverrides] = useState([]);
  useEffect(() => {
    if (effectiveRole !== 'owner' || !supabaseClient) { setTieOverrides([]); return; }
    let live = true;
    (async () => {
      try {
        const since = new Date(Date.now() - 14 * 864e5).toISOString();
        const { data } = await supabaseClient.from('project_activity_log').select('id, project_id, actor_name, at, metadata')
          .eq('kind', 'stage_changed').gte('at', since).not('metadata->tie_out->>override', 'is', null)
          .order('at', { ascending: false }).limit(20);
        let seen = {};
        try { seen = JSON.parse(localStorage.getItem('vt_tie_override_seen') || '{}'); } catch (e) { seen = {}; }
        if (live) setTieOverrides((data || []).filter(r => !seen[r.id]));
      } catch (e) { if (live) setTieOverrides([]); }
    })();
    return () => { live = false; };
  }, [effectiveRole, reloadTick]);
  const tieOverrideSeen = (id) => {
    try { const s = JSON.parse(localStorage.getItem('vt_tie_override_seen') || '{}'); s[id] = 1; localStorage.setItem('vt_tie_override_seen', JSON.stringify(s)); } catch (e) { /* view-only convenience */ }
    setTieOverrides(list => list.filter(r => r.id !== id));
  };
  // ⏳ WAITING ON THE OWNER at Upload Complete (Konnie 10-07, Forward Slash: the
  // docs were in, she entered them, found the revalue still needed the Client
  // Detail form, chased Monte + his CPA the same day — and the stage clock kept
  // running, copying Mark at "6 days past target"). The chase is the action:
  // one line on what's missing + a check-back date. The card parks in Snoozed,
  // the 7:30 email stands down, and the date coming back re-cards it.
  const plateUploadWaiting = async (p) => {
    if (!supabaseClient || !p) return;
    const what = window.prompt(`${p.company_name}: what are you waiting on from the owner?\n\nOne line — e.g. "Client Detail form (asked Monte 10/2)".`, '');
    if (what === null) return;
    if (!what.trim()) { window.alert('One line on what is missing, please — it shows on the card while it waits.'); return; }
    const d = new Date(); let left = 3;
    while (left > 0) { d.setDate(d.getDate() + 1); if (![0, 6].includes(d.getDay())) left--; }
    const until = window.prompt('Check back on (YYYY-MM-DD) — the card and the 7:30 email stand down until then:', d.toISOString().slice(0, 10));
    if (until === null) return;
    const todayIso = new Date().toISOString().slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(until.trim()) || until.trim() <= todayIso) { window.alert('Pick a future date as YYYY-MM-DD.'); return; }
    const nowIso = new Date().toISOString();
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ snooze_until: until.trim(), snooze_reason: `Waiting on the owner — ${what.trim()}`, updated_at: nowIso }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'note', note: `⏳ Waiting on the owner — ${what.trim()} (check back ${until.trim()})`,
      });
    } catch (e) { window.alert('Could not save: ' + (e?.message || '')); return; }
    setReloadTick(t => t + 1);
  };
  // ✓ Reviewed — hide the prep card until the meeting day (Mark 09-21,
  // Integrated Technology: a future-meeting card is a reminder, not a to-do;
  // it parks on the meeting date and comes back that morning).
  const plateMarkReviewed = async (p) => {
    if (!supabaseClient || !p || !p.next_meeting_date) return;
    const nowIso = new Date().toISOString();
    try {
      const { error } = await supabaseClient.from('valuations')
        .update({ snooze_until: p.next_meeting_date, snooze_reason: 'Reviewed — ready for the meeting', updated_at: nowIso }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'note', note: `Valuation reviewed ahead of the ${p.next_meeting_date} meeting`,
      });
    } catch (e) { window.alert('Could not park the card: ' + (e?.message || '')); return; }
    setReloadTick(t => t + 1);
  };

  // ↩ OWNER MISSED THE INTRO — RESCHEDULE (Adam 09-22, HD Solutions: RJ missed
  // the 9/17 discovery; Fireflies transcribed 11 minutes of Thatcher and Adam
  // waiting and stamped the meeting HELD, so the warm card read "meeting held
  // — the Lead hasn't activated". One click from the card corrects the meeting
  // record to no-show, moves the intro date, and logs it.)
  // ⏳ WAITING ON THE OWNER'S REPLY — warm no-show cards (Adam 10-01: he'd emailed the owner to rebook and
  // the card nagged daily with no way to say so). Same law as SE's ⏳: a 2-business-day watch, the owner's
  // email ends it early, silence brings the card back saying so. Not a snooze — it can't be stretched.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!supabaseClient || !(warmProjects || []).length) { if (!cancelled) setWarmWatchByPid({}); return; }
      try {
        const ids = warmProjects.map(p => p.id);
        const since = new Date(Date.now() - 30 * 86400000).toISOString();
        const { data: logs } = await supabaseClient.from('project_activity_log').select('project_id, at, metadata')
          .eq('kind', 'awaiting_reply').in('project_id', ids).gte('at', since).order('at', { ascending: false });
        const latest = {};
        (logs || []).forEach(l => { if (!latest[l.project_id]) latest[l.project_id] = l; });
        const pids = Object.keys(latest);
        const ownerOf = {};
        warmProjects.forEach(p => { if (latest[p.id] && p.client_id && SE_OWNER_BY_CLIENT.get(p.client_id)) ownerOf[p.id] = SE_OWNER_BY_CLIENT.get(p.client_id); });
        const oids = [...new Set(Object.values(ownerOf))];
        let inbound = [];
        if (oids.length) {
          const minAt = pids.map(id => latest[id].at).sort()[0];
          const { data: em } = await supabaseClient.from('se_emails').select('owner_id, sent_at, from_email')
            .in('owner_id', oids).eq('direction', 'inbound').gte('sent_at', minAt);
          inbound = (em || []).filter(e => !/@vistabusinessgroup\.com$/i.test(String(e.from_email || '')));
        }
        const out = {};
        pids.forEach(pid => {
          const w = latest[pid];
          const replied = inbound.some(e => e.owner_id === ownerOf[pid] && e.sent_at > w.at);
          out[pid] = { at: w.at, until: (w.metadata && w.metadata.until) || null, replied };
        });
        if (!cancelled) setWarmWatchByPid(out);
      } catch (e) { if (!cancelled) setWarmWatchByPid({}); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, warmProjects, reloadTick]);   // eslint-disable-line react-hooks/exhaustive-deps
  // 🎯 STRATEGY AFTER THREE EMAILS (Mark 10-15, Lew Plumbing: Adam emailed to rebook a missed intro three
  // times, no reply, and the card kept coming back with nothing left to do). We don't follow up by phone
  // unless the owner asked for a call — owners take our calls away from their employees, so timing is
  // theirs. After 3 emails the AM sets the strategy: monthly marketing takes over, or marketing + a dated
  // reminder. Counts the days the AM side emailed the owner after the meeting date (calendar mail
  // excluded); a logged pick steps the AM's card aside until the owner writes back.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const list = (warmProjects || []).filter(p => p.discovery_meeting_date && p.client_id);
      if (!supabaseClient || !list.length) { if (!cancelled) setWarmRebookByPid({}); return; }
      try {
        const { data: so } = await supabaseClient.from('se_owners').select('id, vt_client_id')
          .in('vt_client_id', [...new Set(list.map(p => p.client_id))]);
        const ownerByClient = {};
        (so || []).forEach(o => { if (!ownerByClient[o.vt_client_id]) ownerByClient[o.vt_client_id] = o.id; });
        const withOwner = list.filter(p => ownerByClient[p.client_id]);
        if (!withOwner.length) { if (!cancelled) setWarmRebookByPid({}); return; }
        const minDate = withOwner.map(p => p.discovery_meeting_date).sort()[0];
        const [{ data: em }, { data: picks }] = await Promise.all([
          supabaseClient.from('se_emails').select('owner_id, sent_at, from_email, direction, subject')
            .in('owner_id', [...new Set(withOwner.map(p => ownerByClient[p.client_id]))]).gte('sent_at', minDate + 'T00:00:00Z'),
          supabaseClient.from('project_activity_log').select('project_id, at, metadata')
            .eq('kind', 'warm_strategy').in('project_id', withOwner.map(p => p.id)).order('at', { ascending: false }),
        ]);
        const fromVista = (e) => /@vistabusinessgroup\.com>?$/i.test(String(e.from_email || '').trim());
        const calendarMail = (e) => /^(invitation|updated invitation|accepted|declined|canceled|cancelled|appointment booked)\b/i.test(String(e.subject || '').trim());
        const latestPick = {};
        (picks || []).forEach(l => { if (!latestPick[l.project_id]) latestPick[l.project_id] = l; });
        const out = {};
        withOwner.forEach(p => {
          const oid = ownerByClient[p.client_id];
          // Unanswered emails only: count from the meeting day or the owner's last email, whichever is later
          // (Total Computer Solutions: 4 of ours, 8 of theirs — a conversation, not silence).
          const lastIn = (em || []).filter(e => e.owner_id === oid && e.direction === 'inbound' && !fromVista(e))
            .map(e => String(e.sent_at)).sort().pop() || '';
          const meetEnd = p.discovery_meeting_date + 'T23:59:59Z';
          const after = lastIn > meetEnd ? lastIn : meetEnd;
          const sentDays = new Set((em || []).filter(e => e.owner_id === oid && e.direction === 'outbound' && fromVista(e)
            && !calendarMail(e) && e.sent_at > after).map(e => String(e.sent_at).slice(0, 10)));
          const pick = latestPick[p.id] || null;
          const repliedSincePick = !!pick && (em || []).some(e => e.owner_id === oid && e.direction === 'inbound' && !fromVista(e) && e.sent_at > pick.at);
          out[p.id] = { attempts: sentDays.size, pick: pick ? { at: pick.at, ...(pick.metadata || {}) } : null, repliedSincePick };
        });
        if (!cancelled) setWarmRebookByPid(out);
      } catch (e) { if (!cancelled) setWarmRebookByPid({}); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, warmProjects, reloadTick]);   // eslint-disable-line react-hooks/exhaustive-deps
  // 📋 QUALIFICATION per warm deal (Mark + Zac 10-16): the latest 'qualification' record. Missing → the AM's
  // card stays on the plate (no ⏳ / 🎯 step-aside) with 📋 Finish the qualification.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const list = (warmProjects || []);
      if (!supabaseClient || !list.length) { if (!cancelled) setWarmQualByPid({}); return; }
      try {
        const { data: logs } = await supabaseClient.from('project_activity_log').select('project_id, at, actor_name, metadata')
          .in('project_id', list.map(p => p.id)).eq('kind', 'qualification').order('at', { ascending: false });
        const out = {};
        (logs || []).forEach(l => { if (!out[l.project_id]) out[l.project_id] = { ...(l.metadata || {}), at: l.at, who: l.actor_name }; });
        if (!cancelled) setWarmQualByPid(out);
      } catch (e) { if (!cancelled) setWarmQualByPid({}); }
    })();
    return () => { cancelled = true; };
  }, [supabaseClient, warmProjects, reloadTick]);   // eslint-disable-line react-hooks/exhaustive-deps
  // 🚫 TOO SMALL from the warm card (Mark 10-19, Lew Plumbing): the playbook's "if they're too small, stop
  // here" for an account that was already created. SE: not_a_fit_small (the same write as the outcome
  // form: marketing pauses, 24-month recheck). VT: the warm account closes like a Lead's Pass.
  const warmTooSmall = async (p, q, why) => {
    const nowIso = new Date().toISOString();
    try {
      const { data: so } = await supabaseClient.from('se_owners').select('id, company_name').eq('vt_client_id', p.client_id).limit(1);
      const owner = (so || [])[0] || null;
      if (owner) await seLogOutcome(owner, { kind: 'note', note: `Too small today (warm account closed): ${why}`, disposition: 'not_a_fit_small' });
      const { error } = await supabaseClient.from('valuations')
        .update({ workflow_stage: 'disqualified', stage_entered_at: nowIso, likelihood_pct: 0, updated_at: nowIso }).eq('id', p.id);
      if (error) throw error;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed', note: `🚫 Too small — closed by ${myName || 'the AM'}: ${why}`,
        metadata: { from: 'warm', to: 'disqualified', reason: why, tooSmall: true, qualification: q || null },
      });
      setWarmProjects(prev => prev.filter(x => x.id !== p.id));
    } catch (e) { window.alert('Could not close it: ' + (e?.message || '')); return false; }
    setWarmQualifyTarget(null);
    setReloadTick(t => t + 1);
    return true;
  };
  const warmQualifySave = async (p, q) => {
    try {
      await saveQualification(supabaseClient, { valuationId: p.id, clientId: p.client_id, ownerEmail: p.owner_email,
        actorEmail: userEmail, actorName: myName || (userEmail ? userEmail.split('@')[0] : null), q });
    } catch (e) { window.alert('Could not save the qualification: ' + (e?.message || '')); return false; }
    setWarmQualifyTarget(null);
    setReloadTick(t => t + 1);
    return true;
  };
  const warmStrategyPick = async (p, { disposition, due, note }) => {
    if (!supabaseClient || !p) return;
    const play = disposition === 'strategy_followup' ? `marketing takes over + personal follow-up ${due}` : 'monthly marketing takes over';
    const why = p._notNow
      ? `Owner says not now (paused). Strategy: ${play}. ${note}`
      : `Missed the ${p.discovery_meeting_date || 'intro'} meeting; ${p._attempts || 0} rebook emails, no reply. Strategy: ${play}. ${note}`;
    try {
      const { data: so } = await supabaseClient.from('se_owners').select('id, company_name').eq('vt_client_id', p.client_id).limit(1);
      const owner = (so || [])[0] || null;
      // The same write as the Sales Engine's strategy pick: disposition, clock, retired reminders, dated commitment.
      if (owner) await seLogOutcome(owner, { kind: 'note', note: why, disposition,
        commitDue: disposition === 'strategy_followup' ? due : undefined,
        commitNote: disposition === 'strategy_followup' ? (p._notNow ? `Follow up with ${p.company_name} (owner asked to pause): ${note}` : `Follow up with ${p.company_name} (missed the intro, no reply to ${p._attempts || 0} emails): ${note}`) : undefined });
      const { error } = await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'warm_strategy', note: `${p._notNow ? '⏸' : '🎯'} ${why}`, metadata: { disposition, due: due || null, attempts: p._attempts || 0, notNow: !!p._notNow, why: note },
      });
      if (error) throw error;
    } catch (e) { window.alert('Could not save the strategy: ' + (e?.message || '')); return; }
    setWarmStrategyTarget(null);
    setReloadTick(t => t + 1);
  };
  const warmAwaitReply = async (p) => {
    if (!supabaseClient || !p) return;
    const until = seAddBusinessDays(new Date(), 2);
    const note = window.prompt(`${p.company_name}: you reached out to rebook and are waiting on the owner.\n\nThe card steps aside until ${until} — their reply brings it back sooner. One line on how you reached out (optional):`, '');
    if (note === null) return;
    try {
      const { error } = await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'awaiting_reply', note: `⏳ Waiting on the owner's reply to rebook — watch until ${until}${note.trim() ? ': ' + note.trim() : ''}`,
        metadata: { until },
      });
      if (error) throw error;
      const ownerId = p.client_id ? (SE_OWNER_BY_CLIENT.get(p.client_id) || null) : null;
      if (ownerId) await supabaseClient.from('se_touches').insert({ owner_id: ownerId, kind: 'note', channel: 'se', actor: effectiveName,
        subject: `⏳ Waiting on their reply to rebook the missed intro — watch until ${until}${note.trim() ? '; ' + note.trim() : ''}` });
    } catch (e) { window.alert('Could not set the watch: ' + (e?.message || '')); return; }
    setReloadTick(t => t + 1);
  };
  const warmMissedReschedule = async (p) => {
    if (!supabaseClient || !p) return;
    // The calendar already has the new meeting: confirm it instead of asking Adam to retype a date (Mark 10-28, TCS).
    const raw = p._rebookTo
      ? (window.confirm(`${p.company_name}: mark the ${p.discovery_meeting_date || 'intro'} meeting as didn't happen, and move the deal's meeting date to ${p._rebookTo} (the meeting already on the calendar)?

The card then shows the new date; the day after it, it asks how it went.`) ? p._rebookTo : null)
      : window.prompt(`${p.company_name}: the owner missed the ${p.discovery_meeting_date || 'intro'} meeting.

New meeting date (YYYY-MM-DD) — leave blank if it isn't rebooked yet:`, '');
    if (raw === null) return;
    const newDate = raw.trim();
    if (newDate && (!/^\d{4}-\d{2}-\d{2}$/.test(newDate) || isNaN(new Date(newDate + 'T00:00:00').getTime()))) { window.alert('Use YYYY-MM-DD, e.g. 2026-10-08.'); return; }
    const nowIso = new Date().toISOString();
    try {
      const past = (seMeetingsAll || []).filter(m => m.valuation_id === p.id && m.starts_at && new Date(m.starts_at) <= new Date() && m.status !== 'cancelled');
      const last = past[past.length - 1];
      if (last) {
        const { error: mErr } = await supabaseClient.from('se_meetings')
          .update({ outcome: 'no_show', updated_at: nowIso }).eq('id', last.id);
        if (mErr) throw mErr;
      }
      const upd = { updated_at: nowIso };
      if (newDate) upd.discovery_meeting_date = newDate;
      const { error: vErr } = await supabaseClient.from('valuations').update(upd).eq('id', p.id);
      if (vErr) throw vErr;
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown', actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'outreach', note: `Owner missed the ${p.discovery_meeting_date || 'intro'} meeting${newDate ? ` — rescheduled to ${newDate}` : ' — rebooking'}`,
      });
      const ownerId = p.client_id ? (SE_OWNER_BY_CLIENT.get(p.client_id) || null) : null;
      if (ownerId) await supabaseClient.from('se_touches').insert({ owner_id: ownerId, kind: 'note', channel: 'se', actor: effectiveName, subject: `Missed the intro meeting${newDate ? `; rescheduled to ${newDate}` : '; rebooking'}` });
    } catch (e) { window.alert('Could not record the reschedule: ' + (e?.message || '')); return; }
    setMtTick(t => t + 1);
    setReloadTick(t => t + 1);
  };

  const markOwnerDead = async (p) => {
    if (!supabaseClient || !p) return;
    const reason = window.prompt(`Mark ${p.company_name} as dead — the owner isn't moving forward?\n\nReason (optional):`);
    if (reason === null) return; // cancelled
    const hadValuation = p.workflow_stage === 'val_complete_inactive' || !!p.value_provided_high || !!p.valuation_date;
    const deadStage = hadValuation ? 'val_complete_dead' : 'disqualified';
    const nowIso = new Date().toISOString();
    try {
      const { error: deadErr } = await supabaseClient.from('valuations')
        .update({ workflow_stage: deadStage, stage_entered_at: nowIso, likelihood_pct: 0, updated_at: nowIso })
        .eq('id', p.id);
      if (deadErr) throw deadErr; // supabase-js returns errors in the result; check or it fails silently
      await supabaseClient.from('project_activity_log').insert({
        project_id: p.id, actor_email: userEmail || 'unknown',
        actor_name: myName || (userEmail ? userEmail.split('@')[0] : null),
        kind: 'stage_changed',
        note: `Marked dead — owner not moving forward${reason.trim() ? ': ' + reason.trim() : ''}`,
        metadata: { from: p.workflow_stage, to: deadStage, reason: reason.trim() || null },
      });
      setAmProjects(prev => prev.filter(x => x.id !== p.id));
      setReloadTick(t => t + 1);
    } catch (e) {
      console.error('Mark dead failed:', e);
      window.alert('Mark dead failed: ' + (e?.message || 'unknown error'));
    }
  };

  // ─── Metrics Phase A (#6 A3): activity gauges vs TARGETS + history ──
  // Family-2 amendment (Mark 2026-07-22): every gauge carries BOTH baselines
  // as peers — the effective-dated target AND the prior-period actual.
  // Targets are rows in `targets` (migration 035); saveTarget closes the
  // open row and inserts a successor so goal lineage survives. Discovery
  // meetings include warm projects — the warm intro meeting IS the
  // discovery meeting ("Pre Value Meeting", renamed — Q3). The valuations
  // gauge absorbs the old v1 "valuations last 30 days" tile.
  const currentTargetFor = (metricKey, period) => {
    const today = new Date().toISOString().slice(0, 10);
    const live = (targets || []).filter(t => t.metric_key === metricKey && t.period === period
      && String(t.effective_from) <= today && (!t.effective_to || String(t.effective_to) >= today));
    if (!live.length) return null;
    live.sort((a, b) => String(a.effective_from) === String(b.effective_from)
      ? String(a.created_at || '').localeCompare(String(b.created_at || ''))
      : String(a.effective_from).localeCompare(String(b.effective_from)));
    return live[live.length - 1];
  };
  const gauges = useMemo(() => {
    const now = Date.now();
    const DAY = 24 * 60 * 60 * 1000;
    const inWindow = (dateStr, fromMs, toMs) => {
      if (!dateStr) return false;
      const t = new Date(String(dateStr).slice(0, 10) + 'T00:00:00').getTime();
      return !isNaN(t) && t >= fromMs && t < toMs;
    };
    const all = [...(pipelineProjects || []), ...(warmProjects || [])];
    const countBy = (field, fromMs, toMs) => all.filter(p => inWindow(p[field], fromMs, toMs)).length;
    const mk = (key, period, label, field, days, tip) => ({
      key, period, label, tip,
      actual: countBy(field, now - days * DAY, now + DAY),
      prior: countBy(field, now - 2 * days * DAY, now - days * DAY),
      target: (currentTargetFor(key, period) || {}).value ?? null,
    });
    // ALL gauges reworked (Mark 2026-07-22 eve): targets retired everywhere —
    // pre-VT they meant capacity; the standing goal is "always more than last
    // month, last quarter, last year", so those three windows ARE the
    // baselines on every gauge. A baseline whose window fully predates its
    // data source renders as a neutral chip, never a fake zero-beat.
    // Dedupe by client: duplicate valuation rows for one business (Securis.EU,
    // audit 2026-07-22) must never double-count a discovery or a valuation.
    const histRaw = (Array.isArray(valuationHistory) && valuationHistory.length ? valuationHistory : all);
    const seenClientDate = new Set();
    const hist = histRaw.filter(p => {
      const k = (p.client_id || p.id || Math.random()) + '|' + (p.valuation_date || '') + '|' + (p.discovery_meeting_date || '');
      if (seenClientDate.has(k)) return false;
      seenClientDate.add(k);
      return true;
    });
    // Zoho-imported valuation events (businesses that never touched VT — the
    // generator deduped VT-known names at import time). Zoho can't tell full
    // from partial, so imported events all count as full.
    const importedVal = (Array.isArray(importedEvents) ? importedEvents : []).filter(e => e.kind === 'valuation' && e.event_date);
    // date/value pairs power both the counts and the avg-value lines
    const valPairs = hist.filter(p => p.valuation_date && p.path !== 'partial')
      .map(p => ({ d: p.valuation_date, v: Number(p.value_provided_high) || 0 }))
      .concat(importedVal.map(e => ({ d: e.event_date, v: Number(e.value) || 0 })));
    const fullValDates = valPairs.map(p => p.d);
    const partialValDates = hist.filter(p => p.valuation_date && p.path === 'partial').map(p => p.valuation_date);
    const discoveryDates = hist.filter(p => p.discovery_meeting_date).map(p => p.discovery_meeting_date);
    const valueByProject = {};
    (pipelineProjects || []).forEach(p => { valueByProject[p.id] = Number(p.value_provided_high) || 0; });
    const engagedPairs = (stageEvents || []).filter(e => e.metadata && e.metadata.to === 'engaged')
      .map(e => ({ d: String(e.at).slice(0, 10), v: valueByProject[e.project_id] || 0 }));
    const engagedDates = engagedPairs.map(p => p.d);
    // loi_signings arrive as {d, value: winning LOI price} (older server: bare date strings)
    // Imported loi_signed history (kind added 2026-07-27; the SQL import
    // dedupes against the live status log at insert time, so concatenating
    // here never double-counts). value = LOI price where the source knew it
    // (closings rows) — avgIn skips the zero-value sheet/report events.
    const importedLoi = importedEvents.filter(e => e.kind === 'loi_signed' && e.event_date)
      .map(e => ({ d: String(e.event_date).slice(0, 10), v: Number(e.value) || 0 }));
    const loiPairs = [
      ...(Array.isArray(loiSignings) ? loiSignings : [])
        .map(s => typeof s === 'string' ? { d: s, v: 0 } : { d: s.d, v: Number(s.value) || 0 }),
      ...importedLoi,
    ].filter(p => p.d);
    const soldPairs = (Array.isArray(dmClosings) ? dmClosings : []).filter(c => c.closing_date)
      .map(c => ({ d: c.closing_date, v: Number(c.loi_price) || 0 }));
    const soldDates = soldPairs.map(p => p.d);
    const avgIn = (pairs, from, to) => {
      const vs = pairs.filter(p => inWindow(p.d, from, to)).map(p => p.v).filter(v => v > 0);
      return vs.length ? { avg: vs.reduce((s, v) => s + v, 0) / vs.length, n: vs.length } : null;
    };
    const setAvg = (gauge, pairs, days) => {
      const a = avgIn(pairs, now - days * DAY, now + DAY);
      gauge.avgValue = a ? a.avg : null;
      gauge.avgValueN = a ? a.n : 0;
    };
    // Low-frequency gauges (sold ~19/yr, signed LOIs) use ROLLING 30/90/365
    // lookbacks (Mark 2026-07-22 eve, refining the calendar-period take: a
    // quarter you're days into measures the calendar, not the business).
    // Headline = last 30 days; chips = prev 30d, then the 90d and 365d
    // lookbacks each vs the preceding same-length window. YTD line kept as
    // the scoreboard; avg value over the trailing 90d so it's rarely empty.
    const rollingGauge = (key, label, dates, pairs, tip, historyStartMs) => {
      const nd = new Date();
      const ys = new Date(nd.getFullYear(), 0, 1).getTime();
      const lys = new Date(nd.getFullYear() - 1, 0, 1).getTime();
      const guard = (to, v) => (historyStartMs && to <= historyStartMs) ? null : v;
      const cnt = (from, to) => cntD(dates, from, to);
      const look = (days) => ({
        label: days + 'd',
        value: cnt(now - days * DAY, now + DAY),
        prior: guard(now - days * DAY, cnt(now - 2 * days * DAY, now - days * DAY)),
      });
      const gauge = {
        key, period: 'rolling', label, tip, noTarget: true, target: null,
        actual: cnt(now - 30 * DAY, now + DAY),
        prior: cnt(now - 60 * DAY, now - 30 * DAY),
        baselines: [{ label: 'prev 30d', value: guard(now - 30 * DAY, cnt(now - 60 * DAY, now - 30 * DAY)) }],
        lookbacks: [look(90), look(365)],
        ytd: { cur: cnt(ys, now + DAY), prior: guard(now - 365 * DAY, cntD(dates, lys, now - 365 * DAY)) },
      };
      const a = avgIn(pairs, now - 90 * DAY, now + DAY);
      gauge.avgValue = a ? a.avg : null;
      gauge.avgValueN = a ? a.n : 0;
      return gauge;
    };
    const cntD = (dates, from, to) => dates.filter(d => inWindow(d, from, to)).length;
    const STAGE_LOG_START = new Date('2026-05-14T00:00:00').getTime();
    const mkTrend = (key, label, days, dates, tip, historyStartMs) => {
      const win = (backDays) => {
        const to = now - backDays * DAY, from = to - days * DAY;
        if (historyStartMs && to <= historyStartMs) return null; // window predates the data source
        return cntD(dates, from, to);
      };
      return {
        key, period: days + 'd', label, tip, noTarget: true, target: null,
        actual: cntD(dates, now - days * DAY, now + DAY),
        prior: win(days) ?? 0,
        baselines: [
          { label: days === 7 ? 'prev 7d' : 'prev 30d', value: win(days) },
          { label: 'last qtr', value: win(90) },
          { label: 'last yr', value: win(365) },
        ],
      };
    };
    const vGauge = mkTrend('valuations', 'Valuations — last 30 days', 30, fullValDates,
      'FULL valuations delivered (Valuation Date) in the trailing 30 days — partials are noted but never counted. The goal is trend, not a quota: beat the previous 30 days, the same window last quarter, and last year. History includes deals that later went inactive/dead, and imported pre-VT records as far back as they carry dates.');
    setAvg(vGauge, valPairs, 30);
    const p30 = cntD(partialValDates, now - 30 * DAY, now + DAY);
    vGauge.partialNote = p30 ? `+ ${p30} partial (not counted)` : null;
    const v7 = mkTrend('valuations_7d', 'Valuations — last 7 days', 7, fullValDates,
      'FULL valuations delivered in the trailing 7 days (partials not counted). Baselines: the preceding 7 days, the same week last quarter, last year.');
    setAvg(v7, valPairs, 7);
    const engagedG = mkTrend('engaged', 'Engaged — last 30 days', 30, engagedDates,
      'Deals that ENTERED the Engaged stage in the trailing 30 days (from the stage-transition log, which starts 2026-05-14 — quarter/year chips stay neutral until history accrues). Avg value = the engaged deals\' valuations.', STAGE_LOG_START);
    setAvg(engagedG, engagedPairs, 30);
    // With the loi_signed history imported (2026-07-27), the gauge's history
    // starts at the sheet era (2017-11), not the status log's birth — the
    // lookback/prior-year chips go live. Falls back to the log birthday when
    // the import hasn't been applied yet (chips stay guarded, not wrong).
    const LOI_HISTORY_START = importedLoi.length
      ? new Date('2017-11-01T00:00:00').getTime()
      : new Date('2026-07-22T00:00:00').getTime();
    const loiG = rollingGauge('signed_lois', 'Signed LOIs — last 30 days', loiPairs.map(p => p.d), loiPairs,
      'Signed LOIs: DM\'s live status log (born 2026-07-22) + the imported history (closings, the corrected-dates Zoho report, and the Active-Projects sheet\'s Due-Diligence entries back to 2017 — sheet events carry month precision). Chips: previous 30 days, then rolling 90- and 365-day lookbacks each vs the preceding same-length window. Avg value = the winning LOI\'s price where known, trailing 90d.', LOI_HISTORY_START);
    const soldG = rollingGauge('sold', 'Sold — last 30 days', soldDates, soldPairs,
      'Closings from the closings record (card-captured + the Zoho sold history to 2011). Chips: previous 30 days, then rolling 90- and 365-day lookbacks — each vs the preceding same-length window, so the arrows read "faster or slower than the stretch before". YTD vs the same span last year underneath. Avg value = LOI price, trailing 90d.');
    // Card order = the order things happen (Mark): discovery → valuation →
    // engaged → LOI → sold.
    const g = [
      mkTrend('discovery_meetings', 'Discovery meetings — last 30 days', 30, discoveryDates,
        'Discovery ("Pre Value") meetings dated in the trailing 30 days, warm included. Trend baselines: preceding 30 days, same window last quarter, last year.'),
      mkTrend('discovery_meetings_7d', 'Discovery meetings — last 7 days', 7, discoveryDates,
        'Discovery meetings dated in the trailing 7 days, warm included. Trend baselines: preceding 7 days, same week last quarter, last year.'),
      vGauge,
      v7,
      engagedG,
      loiG,
      soldG,
    ];
    return g;
  }, [pipelineProjects, warmProjects, targets, valuationHistory, stageEvents, dmClosings, loiSignings, importedEvents]);

  // Close the open target row and insert its successor — never update a
  // value in place, so the goal lineage survives (#6 A3).
  const saveTarget = async (metricKey, period, newValue) => {
    const today = new Date().toISOString().slice(0, 10);
    try {
      const { error: closeErr } = await supabaseClient.from('targets')
        .update({ effective_to: today })
        .eq('metric_key', metricKey).eq('period', period).is('effective_to', null);
      if (closeErr) throw closeErr;
      const { error: insErr } = await supabaseClient.from('targets')
        .insert({ metric_key: metricKey, period, value: newValue, effective_from: today, created_by: userEmail || null });
      if (insErr) throw insErr;
      const tRows = await fetchAllRows(() => supabaseClient.from('targets').select('*'));
      setTargets(tRows || []);
    } catch (e) {
      console.error('Save target failed:', e);
      window.alert('Save target failed: ' + (e?.message || 'unknown error'));
    }
  };

  // ─── Metrics Phase A (#6 A4): stage flow vs history ─────────────
  // "We need measure, so we can make changes that improve" (Mark). Two views
  // over stage_changed events (metadata.to = the stage entered):
  // 1) ENTRIES — deals entering each stage per trailing week vs the typical
  //    week (up-to-12-week average from before the displayed 4 weeks).
  // 2) CONVERSION — per-project first-entry cohorts for the hops that tell
  //    the operational story ("what % moved to the upload stage, then
  //    completed the upload"): the last-90d cohort vs the prior 90d vs all
  //    earlier history. The last-90d cohort is still maturing by nature.
  const stageFlow = useMemo(() => {
    const events = stageEvents || [];
    if (!events.length) return null;
    const DAY = 24 * 60 * 60 * 1000;
    const WEEK = 7 * DAY;
    const now = Date.now();
    const earliest = events.reduce((m, e) => {
      const t = new Date(e.at).getTime();
      return isNaN(t) ? m : Math.min(m, t);
    }, Infinity);
    if (!isFinite(earliest)) return null;

    // Weekly ENTRY counts: trailing 7-day blocks, W0 = the last 7 days.
    const weeksAvailable = Math.max(0, Math.floor((now - earliest) / WEEK));
    const typBlocks = Math.min(12, Math.max(0, weeksAvailable - 4));
    const entries = {};
    events.forEach(e => {
      const to = e.metadata && e.metadata.to;
      const t = new Date(e.at).getTime();
      if (!to || isNaN(t)) return;
      const block = Math.floor((now - t) / WEEK);
      if (block < 0) return;
      const row = entries[to] || (entries[to] = { w: [0, 0, 0, 0], typTotal: 0 });
      if (block < 4) row.w[block] += 1;
      else if (block < 4 + typBlocks) row.typTotal += 1;
    });
    const entryRows = Object.keys(entries)
      .filter(s => STAGE_RANK[s] != null)
      .sort((a, b) => (STAGE_RANK[a] || 0) - (STAGE_RANK[b] || 0))
      .map(s => ({ stage: s, w: entries[s].w, typical: typBlocks > 0 ? entries[s].typTotal / typBlocks : null }));

    // First time each project entered each stage — the cohort basis.
    const firstEntry = {};
    events.forEach(e => {
      const to = e.metadata && e.metadata.to;
      const t = new Date(e.at).getTime();
      if (!to || !e.project_id || isNaN(t)) return;
      const m = firstEntry[e.project_id] || (firstEntry[e.project_id] = {});
      if (m[to] == null || t < m[to]) m[to] = t;
    });
    const PAIRS = [
      ['awaiting_upload', 'upload_started'],
      ['upload_started', 'upload_complete'],
      ['upload_complete', 'analysis_complete'],
      ['val_meeting_set', 'awaiting_decision'],
      ['awaiting_decision', 'engaged'],
    ];
    const conversions = PAIRS.map(([x, y]) => {
      const cohort = (loMs, hiMs) => {
        let n = 0, converted = 0;
        Object.values(firstEntry).forEach(m => {
          const tx = m[x];
          if (tx == null || tx < loMs || tx >= hiMs) return;
          n += 1;
          if (m[y] != null && m[y] >= tx) converted += 1;
        });
        return { n, converted, pct: n > 0 ? Math.round(converted / n * 100) : null };
      };
      return {
        from: x, to: y,
        current: cohort(now - 90 * DAY, now + DAY),
        prior: cohort(now - 180 * DAY, now - 90 * DAY),
        older: cohort(0, now - 180 * DAY),
      };
    }).filter(c => c.current.n + c.prior.n + c.older.n > 0);

    return { since: new Date(earliest), totalEvents: events.length, typBlocks, entryRows, conversions };
  }, [stageEvents]);

  // ─── Metrics Phase A (#6 A1): the commission ladder ─────────────
  // Post-valuation pipeline in Mark's finalized buckets (METRICS-SPEC
  // ★ PHASE A): Analysis Complete + Meeting Set → Awaiting Decision →
  // Engaged → Under LOI; Strategic Review Set + Follow-up Scheduled are the
  // future-pipeline BRANCH (loop back to the funnel start), Valued Inactive
  // is a side-view. Rules:
  // - Under LOI rows come from DM (`listings`, status 'Under LOI'); a VT
  //   deal whose listing is Under LOI counts ONLY there (no double count).
  // - DM estimated_commission is an OVERRIDE: null = use VT's figure; any
  //   number INCLUDING 0 = the lead's figure wins (zeroing keeps the
  //   pipeline honest). Overridden/zeroed rows carry flags for the UI.
  // - DM-only listings (pre-VT businesses, no client row) are NEVER
  //   dropped: Under LOI ones join that rung; In Market/Paused ones join
  //   Engaged ("Engaged catches every listed business" — Mark), both with
  //   a noVt marker and commission from the DM override (else 0).
  // - Money attribution = account_manager (Q2/Q5); DM-only rows have none.
  const ladder = useMemo(() => {
    const dmRows = Array.isArray(dmListings) ? dmListings : [];
    const key = (v) => String(v || '').trim();
    const dmByVista = {};
    dmRows.forEach(r => { const k = key(r.vista_id); if (k) dmByVista[k] = r; });
    const vtByVista = {};
    (pipelineProjects || []).forEach(p => { const k = key(p.vista_id); if (k && !vtByVista[k]) vtByVista[k] = p; });
    // "In Negotiation" (pre-signature exclusive negotiation — Zac/Thatcher's
    // deliberate late-process hold, named honestly 2026-07-24) counts in the
    // Under LOI rung: same late-stage money conversation, badged apart.
    // 'Contract Pending' = DM's 2026-07-23 rename of 'In Negotiation' (same
    // hold, clearer name); the legacy string stays matched for safety.
    const LOI_RUNG_STATUSES = ['Under LOI', 'Contract Pending', 'In Negotiation'];
    const underLoiVistas = new Set(dmRows.filter(r => LOI_RUNG_STATUSES.includes(r.status)).map(r => key(r.vista_id)).filter(Boolean));

    const mk = (k, label, tip) => ({ key: k, label, tip, count: 0, commission: 0, byAm: {}, rows: [] });
    const addRow = (bucket, name, am, commission, flags, extra) => {
      bucket.count += 1;
      bucket.commission += commission;
      const amKey = am || '(no AM)';
      const b = bucket.byAm[amKey] || (bucket.byAm[amKey] = { count: 0, commission: 0 });
      b.count += 1; b.commission += commission;
      bucket.rows.push({ name, am: am || null, commission, ...(extra || {}), ...flags });
    };
    // VT-side commission with the DM override applied (shared rule —
    // commissionWithOverride keeps the ladder and staff-meeting view honest
    // together). noVt is forced false here: a VT row obviously has a VT record.
    const effective = (p) => ({ ...commissionWithOverride(dmByVista[key(p.vista_id)], p), noVt: false });

    const rungs = {
      analysis: mk('analysis', 'Analysis Complete + Meeting Set', 'Valued, valuation meeting pending or set (stages Analysis Complete + Valuation Meeting Set). Commission = captured estimates, AM-attributed.'),
      awaiting: mk('awaiting', 'Awaiting Decision', 'Valuation delivered, owner deciding. Commission = captured estimates.'),
      engaged:  mk('engaged', 'Engaged', 'Agreement signed — includes every listed business not yet under LOI (In Market listings live here). DM-only legacy listings appear with a "no VT record" marker.'),
      underLoi: mk('underLoi', 'Under LOI', 'Listings Under LOI or Contract Pending in Deal Manager (contract pending = pre-signature exclusive negotiation, badged in the breakdown). Commission = the lead\'s DM override when set (0 = deliberately zeroed), else VT\'s figure; pre-VT businesses show "no VT record".'),
    };
    const branch = mk('branch', 'Future Pipeline — Reviews & Follow-ups', 'Valued businesses in the 6-month strategic-review loop or with a scheduled follow-up — not near-term, loops back to the funnel start when they decide. Full valuations only; a PARTIAL parked in these stages sits in no tile at all — the review cadence and the pipeline table track it.');
    const inactive = mk('inactive', 'Valued Inactive', 'Valuation Complete — Inactive. Usually excluded from pipeline totals; shown on demand.');
    // Partials are a WARMTH TIER, not pipeline-grade money (Mark 2026-07-24):
    // a quick estimate for a still-deciding owner. They leave the valuation-
    // phase rungs and the branch; Engaged and Under LOI stay unified (signed
    // is signed — the path stops mattering once they're on market).
    const partials = mk('partials', 'Quick Estimates (partial)', 'Partial (quick-estimate) valuations delivered to owners deciding NOW — warmer than never-uploaded, cooler than a completed valuation. Commission = the floor-based estimates. A partial that ENGAGES moves into the ladder like anyone else; one parked for a strategic review or scheduled follow-up drops off the tiles entirely (not near-term).');

    const RUNG_BY_STAGE = { analysis_complete: 'analysis', val_meeting_set: 'analysis', awaiting_decision: 'awaiting', engaged: 'engaged' };
    const BRANCH_STAGES = ['strategic_review_set', 'considering_followup'];
    (pipelineProjects || []).forEach(p => {
      const vid = key(p.vista_id);
      if (vid && underLoiVistas.has(vid)) return; // counts in the Under LOI rung only
      const e = effective(p);
      const flags = { overridden: e.overridden, zeroed: e.zeroed, noVt: false };
      const rk = RUNG_BY_STAGE[p.workflow_stage];
      const isPartial = p.path === 'partial';
      // Partials parked on a clock (strategic review / follow-up) appear in NO
      // tile (Mark 2026-07-22 eve): those stages mean "not ready to do anything
      // near term" — Quick Estimates means deciding NOW, and Future Pipeline
      // stays pipeline-grade (full valuations only, the 07-24 split's point).
      // The review cadence + the pipeline table still own them.
      if (isPartial && BRANCH_STAGES.includes(p.workflow_stage)) return;
      // The Meeting column is contextual per stage: Meeting Set → the scheduled
      // valuation meeting; Awaiting Decision → when the valuation meeting
      // HAPPENED (stage entry = the decision clock's start); Follow-up
      // Scheduled → the promised next touch; else the next meeting if any.
      const meetingDate = p.workflow_stage === 'awaiting_decision'
        ? (p.stage_entered_at ? String(p.stage_entered_at).slice(0, 10) : null)
        : p.workflow_stage === 'considering_followup'
          ? (p.snooze_until || p.next_meeting_date || null)
          : (p.next_meeting_date || null);
      const dm = dmByVista[vid] || null;
      const extra = { lead: p.lead || null, meetingDate, daysInStage: p.daysInStage ?? null, value: Number(p.value_provided_high) || null,
        valuationDate: p.valuation_date || null,
        marketDate: dm ? (dm.market_date || null) : null, ioiDeadline: dm ? (dm.ioi_deadline || null) : null, loiDeadline: dm ? (dm.loi_deadline || null) : null,
        buyers: dm ? (dm.active_buyers ?? null) : null, ioiCount: dm ? (dm.ioi_count ?? null) : null, loiCount: dm ? (dm.loi_count ?? null) : null };
      if (isPartial && rk && rk !== 'engaged') {
        addRow(partials, p.company_name, p.account_manager, e.value, flags, extra);
      }
      else if (rk) addRow(rungs[rk], p.company_name, p.account_manager, e.value, flags, extra);
      else if (BRANCH_STAGES.includes(p.workflow_stage)) addRow(branch, p.company_name, p.account_manager, e.value, flags, extra);
      else if (p.workflow_stage === 'val_complete_inactive') addRow(inactive, p.company_name, p.account_manager, e.value, flags, extra);
    });
    dmRows.filter(r => LOI_RUNG_STATUSES.includes(r.status)).forEach(r => {
      const match = vtByVista[key(r.vista_id)] || null;
      const c = commissionWithOverride(r, match);
      // AM: VT's wins when a VT record exists; DM's account_manager column is
      // the fallback for legacy no-VT-record listings (migration DM-003).
      addRow(rungs.underLoi, r.name, (match && match.account_manager) || r.account_manager || null, c.value,
        { overridden: c.overridden, zeroed: c.zeroed, noVt: c.noVt, negotiating: r.status === 'Contract Pending' || r.status === 'In Negotiation' },
        { lead: (match && match.lead) || r.lead || null, meetingDate: null, daysInStage: null, value: match ? (Number(match.value_provided_high) || null) : null,
          marketDate: r.market_date || null, ioiDeadline: r.ioi_deadline || null, loiDeadline: r.loi_deadline || null,
          buyers: r.active_buyers ?? null, ioiCount: r.ioi_count ?? null, loiCount: r.loi_count ?? null,
          buyer: r.loi_buyer || null, loiPrice: r.loi_price ?? null,
          signedLoi: r.signed_loi_date || null, projectedClose: r.projected_close_date || null });
    });
    rungs.underLoi.negotiatingCount = rungs.underLoi.rows.filter(r => r.negotiating).length;
    // Incl. DM's 'IOI Round'/'Round 2' (2026-07-27: a DM-only listing in an
    // IOI round previously landed in no rung at all).
    dmRows.filter(r => r.status === 'In Market' || r.status === 'Paused' || r.status === 'IOI Round' || r.status === 'Round 2').forEach(r => {
      if (vtByVista[key(r.vista_id)]) return; // already counted via its VT row
      const c = commissionWithOverride(r, null);
      addRow(rungs.engaged, r.name, r.account_manager || null, c.value, { overridden: c.overridden, zeroed: c.zeroed, noVt: true },
        { lead: r.lead || null, meetingDate: null, daysInStage: null, value: null,
          marketDate: r.market_date || null, ioiDeadline: r.ioi_deadline || null, loiDeadline: r.loi_deadline || null,
          buyers: r.active_buyers ?? null, ioiCount: r.ioi_count ?? null, loiCount: r.loi_count ?? null });
    });
    return { rungs: [rungs.analysis, rungs.awaiting, rungs.engaged, rungs.underLoi], branch, inactive, partials, dmDown: dmListings === null };
  }, [pipelineProjects, dmListings]);

  const pipelineRows = useMemo(() => {
    let rows = pipelineProjects.slice();
    if (filterStage.length) rows = rows.filter(p => filterStage.includes(p.workflow_stage));
    if (filterLead  !== 'all') rows = rows.filter(p => (p.lead || '') === filterLead);
    if (filterAM    !== 'all') rows = rows.filter(p => (p.account_manager || '') === filterAM);
    if (filterOwner !== 'all') rows = rows.filter(p => p.responsibility === filterOwner);
    rows.sort((a,b) => {
      // The Stage column sorts by lifecycle order (first→last), not the raw
      // stage string (which would be alphabetical). Everything else compares
      // its value directly.
      let av, bv;
      if (sortBy === 'workflow_stage') {
        av = STAGE_RANK[a.workflow_stage]; bv = STAGE_RANK[b.workflow_stage];
        if (av == null) av = 999;
        if (bv == null) bv = 999;
        // Inside Awaiting Decision (Mark 09-28): agreement out → deciding now →
        // deciding later, likeliest first — the staff meeting's reading order.
        if (av === bv && a.workflow_stage === 'awaiting_decision') {
          const ga = decidingGroup(a).rank, gb = decidingGroup(b).rank;
          if (ga !== gb) return ga - gb;
          return (Number(b.likelihood_pct) || 0) - (Number(a.likelihood_pct) || 0);
        }
      } else {
        av = a[sortBy]; bv = b[sortBy];
      }
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return rows;
  }, [pipelineProjects, filterStage, filterLead, filterAM, filterOwner, sortBy, sortDir]);

  // Stage distribution across the full funnel (all stages present).
  const stageDistribution = useMemo(() => {
    const d = {};
    pipelineProjects.forEach(p => { d[p.workflow_stage] = (d[p.workflow_stage] || 0) + 1; });
    return d;
  }, [pipelineProjects]);

  const uniqueLeads  = useMemo(() => Array.from(new Set(pipelineProjects.map(p => p.lead).filter(Boolean))).sort(), [pipelineProjects]);
  const uniqueAMs    = useMemo(() => Array.from(new Set(pipelineProjects.map(p => p.account_manager).filter(Boolean))).sort(), [pipelineProjects]);
  const uniqueOwners = useMemo(() => Array.from(new Set(pipelineProjects.map(p => p.responsibility).filter(Boolean))).sort(), [pipelineProjects]);

  const toggleSort = (col) => {
    if (sortBy === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortBy(col); setSortDir('desc'); }
  };

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Shared shell (consolidation Phase 2): same topnav/nav-tab classes
          as Deal Manager, so the two apps read as one product. */}
      <div className="topnav">
        <div className="logo">
          <img src="/public/logo.jpg" alt="" style={{ height: 40 }} />
          <div className="ln">Vista <span>Dashboard{myName ? ` · ${viewAs ? `${myName} → viewing ${viewAs}` : myName}` : ''}</span></div>
        </div>
        <nav className="nav-tabs">
          <button className="nav-tab on">🏠 Dashboard</button>
          <button onClick={onGoToClientList} className="nav-tab">📁 Clients</button>
          {/* SE stays owner-bookmark-only until the serving go-live flag
              flips; marketing (Scott) has his own lane already. */}
          {(canViewAs || SE_SERVING_TEAM_LIVE
            || (STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()] || {}).role === 'marketing') && (
            <a href="/sales-engine" className="nav-tab">📤 Sales Engine</a>
          )}
          {/* Module links follow the staff table's modules — a database
              row, not a rebuild. New tab: separate apps, no shared URLs yet. */}
          {(() => {
            const me = STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()];
            return !!(me && Array.isArray(me.modules) && me.modules.includes('dm'));
          })() && (
            <a href="https://app.vistabusinessgroup.com" target="_blank" rel="noopener" className="nav-tab">🏢 Deal Manager ↗</a>
          )}
          {(() => {
            const me = STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()];
            return !!(me && Array.isArray(me.modules) && me.modules.includes('cim'));
          })() && (
            <a href="/cim-generator" target="_blank" rel="noopener" className="nav-tab">📄 CIM Generator ↗</a>
          )}
          {/* Live playbooks (ROADMAP #13): everyone has one — role-resolved
              server-side, always current, doubles as the help button. */}
          <a href="/playbook" target="_blank" rel="noopener" className="nav-tab">📖 My Playbook</a>
        </nav>
        <div className="nav-right">
          {userEmail && (
            <React.Fragment>
              <span className="text-xs truncate max-w-[200px]" style={{ color: 'var(--muted)' }} title={userEmail}>{userEmail}</span>
              {!hasMfa && (
                <button onClick={onEnrollMfa} className="px-2 py-1 rounded text-xs font-semibold bg-amber-100 text-amber-700 hover:bg-amber-200">Set up 2FA</button>
              )}
              {hasMfa && <span className="text-xs" style={{ color: 'var(--green)' }}>✓ 2FA</span>}
              <button onClick={onSignOut} className="nav-tab" style={{ border: '1px solid var(--border)' }}>Sign Out</button>
            </React.Fragment>
          )}
        </div>
      </div>
      <div style={{ background: 'var(--s1)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-6 py-2 nav-tabs">
          {[
            ['mywork', 'My Work'], ['pipeline', `Pipeline (${pipelineProjects.length})`],
            ['staffmeeting', 'Staff Meeting'], ['timeline', 'Deal Flow'],
            ['closeddeals', 'Closed Deals'], ['committee', 'Committee'],
          ].map(([id, label]) => (
            <button key={id} onClick={() => setTab(id)} className={`nav-tab ${tab === id ? 'on' : ''}`}>{label}</button>
          ))}
        </div>
      </div>

      {/* Body */}
      <div className="max-w-7xl mx-auto px-6 py-6">
        {loading && <div className="text-center text-gray-400 py-12">Loading dashboard…</div>}
        {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded p-3 mb-4 text-sm">{error}</div>}

        {!loading && !error && tab === 'mywork' && (
          <React.Fragment>
            {/* Vacation coverage banner — the backup's whole interface: one
                click into the away person's plate, one click back. Shows for
                the covering person only, until out_until passes. */}
            {coveringFor.map(c => (
              <div key={c.name} className="mb-4 flex flex-wrap items-center gap-2 bg-amber-50 border border-amber-300 rounded px-3 py-2">
                <span className="text-sm text-amber-900">🌴 <strong>{c.name} is out</strong> through {new Date(c.until + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'short', month: 'numeric', day: 'numeric' })} — you're covering.</span>
                {viewAs === c.name ? (
                  <button className="text-xs bg-white border border-amber-400 rounded px-2 py-1 font-semibold text-amber-800 hover:bg-amber-100" onClick={() => setViewAs('')}>← Back to your own plate</button>
                ) : (
                  <button className="text-xs bg-amber-600 text-white rounded px-2 py-1 font-semibold hover:bg-amber-700" onClick={() => setViewAs(c.name)}>Open {c.name}'s plate</button>
                )}
                <span className="text-xs text-amber-700">Their cards, Sort Queue, and reminders — anything you do there is logged as you.</span>
              </div>
            ))}
            {lookOnly && (
              <div className="mb-2 bg-gray-800 text-white rounded px-3 py-2 text-xs font-semibold">
                👁 Look-only account (Claude). Every screen opens; saving, sending and deleting are blocked.
              </div>
            )}
            {(myRole === 'owner' || lookOnly) && (
              <div className="mb-4 flex flex-wrap items-center gap-2 bg-indigo-50 border border-indigo-200 rounded px-3 py-2">
                <span className="text-xs font-semibold text-indigo-700">👁 View as</span>
                <select
                  value={viewAs}
                  onChange={(e) => setViewAs(e.target.value)}
                  className="text-sm border border-indigo-300 rounded px-2 py-1 bg-white"
                >
                  <option value="">Myself ({myName || 'Mark'})</option>
                  {VIEW_AS_NAMES.map(n => <option key={n} value={n}>{n}</option>)}
                </select>
                {viewAs && (
                  <span className="text-xs text-indigo-600">Showing <strong>{viewAs}</strong>'s My Work — their queue + their reminders, exactly as they see it.</span>
                )}
              </div>
            )}
            <FindBusinessBox onPick={openOutcomeFor} onOpenVt={(id) => onOpenValuation({ id })} />
            <TombstoneSection myName={effectiveName} myEmail={userEmail} isOwner={myRole === 'owner' && !viewAs} />
            <ClaudeAskSection myName={viewAs ? null : effectiveName} />
            <ClaudeSqlSection myName={effectiveName} isOwner={myRole === 'owner' && !viewAs} />
            <ReportApprovalSection myName={effectiveName} isOwner={myRole === 'owner' && !viewAs} />
            <ListingApprovalSection myName={effectiveName} myEmail={userEmail} isOwner={myRole === 'owner' && !viewAs} />
            {plateTieOut && (
              <TieOutModal company={plateTieOut.p.company_name || 'this deal'} target={plateTieOut.to === 'analysis_complete' ? 'the Lead' : 'Colleen'}
                result={plateTieOut.result} onCancel={() => setPlateTieOut(null)} onConfirm={(res) => plateHandOff(plateTieOut.p, plateTieOut.to, res)}
                onMarkNotProvided={(doc, note) => plateMarkNotProvided(plateTieOut.p, doc, note)} />
            )}
            <MyWorkView tieOverrides={tieOverrides} onTieOverrideSeen={tieOverrideSeen} onInviteLiveCall={inviteLiveCall} onInviteCallbackChase={inviteCallbackChase} buckets={myWorkBuckets} myName={effectiveName} role={effectiveRole} dmSignals={dmSignalsView} canOpenDm={canOpenDm} sortQueue={sortQueue} showSortQueue={effectiveRole === 'document_mgmt'} onResolveSortQueue={resolveSortQueueItem} onOpenValuation={onOpenValuation} onDismissReminder={dismissReminder} presenceByValuation={presenceByValuation} onSetFollowUp={setFollowUpDate} onClearFollowUp={clearFollowUp} onLogOutreach={logOutreach} onReEngage={reEngageProject} onMarkDead={markOwnerDead} onRecordOutcome={plateRecordOutcome} onDataEntered={plateDataEntered} onUploadWaiting={plateUploadWaiting} seMyReminders={seMyReminders} onSeMyReminder={myReminderAct} onAgreementOut={plateAgreementOut} onSetLikelihood={plateSetLikelihood} onMarkReviewed={plateMarkReviewed} onWarmMissed={warmMissedReschedule} onWarmAwait={warmAwaitReply} onWarmStrategy={(p) => setWarmStrategyTarget(p)} onWarmQualify={(p) => setWarmQualifyTarget(p)} onSendWarmIntro={openWarmIntro} onActivateWarm={(p) => setWarmActivateTarget(p)} onReviewedPortalUpdate={reviewedPortalUpdate} onDismissRevalueDocs={dismissRevalueDocsCard} seServing={seServing} seServingMode={seServingMode} seIdeasGate={seServingData ? (seServingData.overdueGate || 0) : 0} onSeLog={(o) => setSeOutcomeTarget(o)} onSeReached={seQuickReached} onSeSnooze={seSnooze} onSeFetchNext={seFetchNext} onSeCadenceSent={seCadenceAdvance} onSeReplied={() => setSeTick(t => t + 1)} onSeNoReply={seNoReplyNeeded} onSeRemind={seRemindMe} seNewReminder={seNewReminderProps} onSeAwait={seAwaitReply} onSeHandOff={seHandOff} onSeDropDate={seDropDate} seFetchLocked={seFetchLocked} seTeamOverdue={seTeamOverdue} partialDecisions={partialDecisionCards} onPartialDecision={partialDecisionSet} closingEscalations={closingEscalations} onClosingStall={closingStallSave} stagedSends={stagedSendCards} onStagedSendAct={stagedSendAct} onStagedSendBulk={stagedSendBulk} onLinkedInPosted={linkedInPosted} onContactGoneSold={contactGoneSold} onBounceChoose={openBounceCard} mtToday={mtToday} mtPrep={mtPrep} mtClassify={mtClassify} mtClassifyBuyers={mtClassifyBuyers} onMeetingClassify={seMeetingClassify} onMeetingClassifyDismiss={seMeetingClassifyDismiss} onMeetingClassifyHandOff={seMeetingClassifyHandOff} meetingTruth={meetingTruth} onMeetingHeld={seMeetingHeld} onMeetingHeldAll={seMeetingHeldAll} onMeetingNoShow={seMeetingNoShow} onMeetingTypeChange={seMeetingSetType} onMeetingHandOff={seMeetingSetHolder} onMeetingRemind={meetingRemindMe} buyerReviews={buyerReviewCards} onBuyerReviewAct={buyerReviewAct} buyerReviewShowHolder={effectiveRole === 'owner'} buysidePool={effectiveRole !== 'owner' && ['Adam', 'Zac', 'Thatcher'].includes(effectiveName) ? buysideRouting.pool : null} onBuysideClaim={buyerClaim} buysideClaimGate={effectiveRole === 'account_manager' && (seServingData ? (seServingData.overdueGate || 0) : 0) > 0} scottAsk={effectiveName === 'Scott' ? buysideRouting.scottAsk : null} onScottAsked={scottQualsAsked} wagonCards={buysideRouting.wagons.filter(w => w.holder === effectiveName)} onWagonHandled={wagonHandled} buysideRadar={effectiveRole === 'owner' ? buysideRouting.radar : null} buyerFollow={buyerFollowCards} onBuyerFollowAct={buyerFollowAct} onBuysideStep={buysideStepFor} buysideNewMatch={buysideNewMatchProps} onTieBuyer={buysideTieFromCard} buysideBoard={buysideBoard} onRevivalResume={revivalResume} onRevivalDismiss={revivalDismiss} listedKeys={listedKeys} reviewOutcomes={effectiveRole === 'analysis' || effectiveRole === 'owner' ? reviewOutcomes : null} onReviewOutcome={reviewOutcomeAct} onOwnerWaitingDismiss={ownerWaitingDismiss} onOwnerWaitingDefer={ownerWaitingDefer} onSetReviewDate={setReviewDateAct} inviteChecks={inviteCheckCards} amHandoffs={amHandoffCards} onAmHandoffDone={amHandoffDone} onRequestFinancialUpdate={requestFinancialUpdate} onPauseFinancialReminders={pauseFinancialReminders} onAdvanceAsOf={advanceAsOf} onHoldAsOf={holdAsOf} onDiscoveryNudge={sendDiscoveryNudge} onFirstMileTouch={sendFirstMileTouch} onFirstMileWaive={firstMileWaive} onSetStars={setPriorityStars} seBuysideMatches={seBuysideMatches} seFinish={seFinishShown} onSeFinishPick={(owner, note) => { setSeOutcomePrefill({ note: note || '', ftt: true }); setSeOutcomeTarget({ ...owner, _why: 'Finish the thought — your note is below; it just needs the pick.' }); }} />
          </React.Fragment>
        )}
        {seOutcomeTarget && (
          <SEOutcomeModal
            target={seOutcomeTarget}
            vtActive={!!(seOutcomeTarget.vt_client_id && (seOutcomeTarget.tier === 'client' || (projects || []).some(p => p.client_id === seOutcomeTarget.vt_client_id)))}
            initialNote={seOutcomePrefill ? seOutcomePrefill.note : undefined}
            onClose={() => { setSeOutcomeTarget(null); setSeOutcomePrefill(null); setMtHeldPending(null); }}
            onSave={(fields) => seLogOutcome(seOutcomeTarget, seOutcomePrefill && seOutcomePrefill.ftt ? { ...fields, ftt: true } : fields)}
            onBuysideRecord={buysidePairRecord}
            onEmailDead={async (o) => {
              const addr = (o.emails && o.emails[0]) || '';
              if (!window.confirm(`${addr} bounced or the person left?

OK marks this address dead: nothing sends to it again (Mailchimp included) and ${o.company_name || 'the business'} stays a prospect.
Know a new address? Add it in Sales Engine (✏ Edit contact) afterwards.`)) return;
              try {
                const { error } = await supabaseClient.from('se_owners').update({ email_validation: 'invalid', validated_at: new Date().toISOString().slice(0, 10), updated_at: new Date().toISOString() }).eq('id', o.id);
                if (error) throw error;
                let chimp = '';
                try {
                  const { data: { session } } = await supabaseClient.auth.getSession();
                  const r = await fetch('/api/se/chimp-optout', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) }, body: JSON.stringify({ kind: 'owner', id: o.id, first_only: true }) });
                  const d = await r.json().catch(() => ({}));
                  chimp = !r.ok || !d.ok ? ' · Mailchimp not updated' : d.skipped ? '' : d.unsubscribed ? ' · unsubscribed in Mailchimp' : ' · not in Mailchimp';
                } catch (e2) { chimp = ' · Mailchimp not updated'; }
                await supabaseClient.from('se_touches').insert({ owner_id: o.id, kind: 'opt_out', channel: 'se', actor: effectiveName, subject: `Email dead (bounced / person left) — ${addr} marked invalid${chimp}` });
                // Warm = there's still a follow-up hanging on this business (an open reminder this person may retire, or
                // a due follow-up date). Mark 10-26: a bounce on a warm account is a decision for the AM, not an
                // ending: find a good address, call the owner, or stop. Cold ones close as before.
                const todayIso = new Date().toISOString().slice(0, 10);
                const { data: openRows } = await supabaseClient.from('se_commitments').select('id, created_by')
                  .eq('owner_id', o.id).eq('status', 'open');
                const openIds = (openRows || []).filter(c => seRetirableBy(c, effectiveName)).map(c => c.id);
                // Fresh read: Log outcome can open from the Find-a-business search, whose rows carry no phone / dates.
                const { data: fresh } = await supabaseClient.from('se_owners').select('contact_name, phone, emails, next_touch_at').eq('id', o.id).maybeSingle();
                const ow = { ...o, ...(fresh || {}) };
                const dateDue = !!(ow.next_touch_at && ow.next_touch_at <= todayIso);
                setSeOutcomeTarget(null); setSeOutcomePrefill(null);
                if (openIds.length || dateDue) setSeBounceChoice({ owner: ow, addr, openIds });
                else setSeTick(t => t + 1);
              } catch (e) { window.alert('Could not mark the email dead: ' + (e?.message || '')); }
            }}
            onBuysideTie={(o) => { setSeOutcomeTarget(null); setSeOutcomePrefill(null); buysideTieFromCard(o); }}
            onBuysideFollowUp={async (o, months, buyerName) => {
              const due = new Date(Date.now() + months * 30 * 86400000).toISOString().slice(0, 10);
              const { error } = await supabaseClient.from('se_commitments').insert({ owner_id: o.id, due, created_by: effectiveName,
                note: `Buyside project with ${buyerName} ended — check back: discovery meeting, or another buyside client?` });
              if (error) { window.alert('Could not set the follow-up: ' + error.message); return false; }
              return true;
            }}
          />
        )}
        {seBounceChoice && (() => {
          const { owner: o, addr, openIds, cardRow } = seBounceChoice;
          const phone = String(o.phone || '').trim();
          const who = String(o.contact_name || '').trim() || 'the owner';
          const nowIso = new Date().toISOString(), todayIso = nowIso.slice(0, 10);
          // decided = a choice was saved: an automatic 📪 card (step 2) that opened this window is done too.
          const finish = (decided) => { setSeBounceChoice(null); setSeTick(t => t + 1); if (decided === true && cardRow) stagedSendAct(cardRow, 'done'); };
          const retireOpen = async () => {
            if (openIds.length) {
              const { error } = await supabaseClient.from('se_commitments').update({ status: 'cancelled' }).in('id', openIds);
              if (error) throw error;
            }
          };
          const newAddress = async () => {
            const next = (window.prompt(`New email address for ${who} at ${o.company_name || 'this business'}?`) || '').trim();
            if (!next) return;
            if (!/^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/.test(next)) { window.alert('That doesn\'t look like an email address.'); return; }
            try {
              // Same rule as ✏ Edit contact (Scott playbook, Oct 8): the new address goes FIRST, the old one stays after it.
              const emails = [next, ...(o.emails || []).filter(e => String(e).toLowerCase() !== next.toLowerCase())];
              const { error } = await supabaseClient.from('se_owners').update({ emails, email_validation: null, validated_at: null, updated_at: nowIso }).eq('id', o.id);
              if (error) throw error;
              await supabaseClient.from('se_touches').insert({ owner_id: o.id, kind: 'note', channel: 'se', actor: effectiveName,
                subject: `Email bounced (${addr}) — new address ${next}; the follow-up stays` });
              finish(true);
            } catch (e) { window.alert('Could not save the new address: ' + (e?.message || '')); }
          };
          const callOwner = async () => {
            // Two business days out: long enough to make the call, short enough not to lose the thread.
            const d = new Date(); let added = 0;
            while (added < 2) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
            const due = d.toISOString().slice(0, 10);
            try {
              const { error } = await supabaseClient.from('se_commitments').insert({ owner_id: o.id, due, created_by: effectiveName,
                note: `📞 Call: the email to ${addr} bounced. Call ${who}${phone ? ` at ${phone}` : ' (no phone on record: find one)'} for a working address, or ask them to mark our emails as not spam.` });
              if (error) throw error;
              await retireOpen();
              if (o.next_touch_at && o.next_touch_at <= todayIso) {
                const { error: nErr } = await supabaseClient.from('se_owners').update({ next_touch_at: due, updated_at: nowIso }).eq('id', o.id);
                if (nErr) throw nErr;
              }
              await supabaseClient.from('se_touches').insert({ owner_id: o.id, kind: 'note', channel: 'se', actor: effectiveName,
                subject: `Email bounced (${addr}) — call reminder set for ${due}${openIds.length ? `; retired ${openIds.length} open reminder${openIds.length === 1 ? '' : 's'}` : ''}` });
              finish(true);
            } catch (e) { window.alert('Could not set the call reminder: ' + (e?.message || '')); }
          };
          const stop = async () => {
            try {
              await retireOpen();
              if (o.next_touch_at && o.next_touch_at <= todayIso) {
                const { error: nErr } = await supabaseClient.from('se_owners').update({ next_touch_at: null, updated_at: nowIso }).eq('id', o.id);
                if (nErr) throw nErr;
              }
              await supabaseClient.from('se_touches').insert({ owner_id: o.id, kind: 'note', channel: 'se', actor: effectiveName,
                subject: `Email bounced (${addr}) — follow-up stopped${openIds.length ? `; closed ${openIds.length} open reminder${openIds.length === 1 ? '' : 's'}` : ''}. The business stays a prospect.` });
              finish(true);
            } catch (e) { window.alert('Could not close the follow-up: ' + (e?.message || '')); }
          };
          return (
            <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={finish}>
              <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-5" onClick={e => e.stopPropagation()}>
                <h3 className="font-bold text-gray-800 mb-1">📪 The email bounced — what next?</h3>
                <p className="text-sm text-gray-600 mb-3">{addr} is marked dead (nothing sends to it again). You're still following up with {who} at {o.company_name || 'this business'}, so pick one:</p>
                <div className="space-y-2">
                  <button type="button" onClick={newAddress} className="w-full text-left px-3 py-2 rounded border border-gray-300 hover:bg-gray-50 text-sm">
                    <b>✏ I have a new address</b><div className="text-xs text-gray-500">Type it in. Your follow-up stays as it is.</div></button>
                  <button type="button" onClick={callOwner} className="w-full text-left px-3 py-2 rounded border border-gray-300 hover:bg-gray-50 text-sm">
                    <b>📞 Call the owner</b><div className="text-xs text-gray-500">{phone ? `A reminder to call ${phone} in 2 business days` : 'A reminder in 2 business days (no phone on record: find one)'}: get a working address, or ask them to mark our emails as not spam. This card clears until then.</div></button>
                  <button type="button" onClick={stop} className="w-full text-left px-3 py-2 rounded border border-gray-300 hover:bg-gray-50 text-sm">
                    <b>✕ Stop following up</b><div className="text-xs text-gray-500">No way to reach them. The card clears; the business stays in Sales Engine as a prospect.</div></button>
                </div>
                <div className="text-right mt-3"><button type="button" onClick={finish} className="text-xs text-gray-500 hover:text-gray-700">Decide later</button></div>
              </div>
            </div>
          );
        })()}
        {warmIntroTarget && (
          <IntroEmailModal
            {...warmIntroTarget}
            actorEmail={userEmail}
            onClose={() => setWarmIntroTarget(null)}
            onSent={() => { setWarmIntroTarget(null); setReloadTick(t => t + 1); }}
          />
        )}
        {/* "Owner answered" corner toasts — stay until opened or dismissed
            (Colleen may be away from the desk; nothing auto-expires). */}
        {answerToasts.length > 0 && (
          <div className="fixed bottom-4 right-4 z-50 space-y-2 w-80 max-w-full">
            {answerToasts.map(t => (
              <div key={t.id} className="bg-white border border-blue-300 shadow-lg rounded-lg p-3 flex items-start gap-2">
                <span className="text-lg" aria-hidden="true">📥</span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-gray-800 truncate" title={t.company}>{t.company}</div>
                  <div className="text-xs text-gray-600 mt-0.5">Owner answered your questions — ready to review &amp; accept</div>
                  <button
                    onClick={() => { setAnswerToasts(prev => prev.filter(x => x.id !== t.id)); onOpenValuation({ id: t.id, name: t.name }); }}
                    className="mt-1.5 px-2.5 py-1 text-xs font-semibold rounded bg-blue-600 text-white hover:bg-blue-700">
                    Review
                  </button>
                </div>
                <button onClick={() => setAnswerToasts(prev => prev.filter(x => x.id !== t.id))} className="text-gray-400 hover:text-gray-600 text-sm leading-none" title="Dismiss">✕</button>
              </div>
            ))}
          </div>
        )}
        {warmQualifyTarget && (
          <QualificationModal project={warmQualifyTarget} onClose={() => setWarmQualifyTarget(null)} onSave={warmQualifySave} onTooSmall={warmTooSmall} />
        )}
        {warmStrategyTarget && (
          <WarmStrategyModal project={warmStrategyTarget} onClose={() => setWarmStrategyTarget(null)} onSave={warmStrategyPick} />
        )}
        {warmActivateTarget && (
          <ActivatePassModal
            project={warmActivateTarget}
            initial={warmActivateTarget._activateInitial}
            onClose={() => setWarmActivateTarget(null)}
            onActivate={activateWarm}
            onPass={passWarm}
            onReturnToAm={returnWarmToAm}
          />
        )}

        {pendingEmail && (
          <EmailReviewModal {...pendingEmail} onClose={() => setPendingEmail(null)} />
        )}

        {!loading && !error && tab === 'pipeline' && funnelStats && (
          <div className="mb-4 bg-white border rounded-lg p-4">
            <div className="flex items-baseline justify-between mb-2">
              <h3 className="font-bold text-gray-800">🚰 First-Mile Funnel — discovery → complete upload</h3>
              <span className="text-[11px] text-gray-400">Baseline for the touch system (spec § First-Mile Cadence). Goal: discovery → valuation meeting in 14 days.</span>
            </div>
            <table className="text-sm w-full max-w-3xl">
              <thead><tr className="text-left text-xs text-gray-500 border-b">
                <th className="py-1 pr-4"></th>
                <th className="py-1 pr-4">Last 90 days</th>
                <th className="py-1 pr-4">Prior 90 days</th>
                <th className="py-1">All time</th>
              </tr></thead>
              <tbody>
                {[
                  ['Discovery meetings', s => s.n],
                  ['Reached upload complete', s => s.pct == null ? '—' : `${s.converted} (${s.pct}%)`],
                  ['Median days → first upload', s => s.medFirstUpload == null ? '—' : `${s.medFirstUpload}d`],
                  ['Median days → valuation delivered', s => s.medToValuation == null ? '—' : `${s.medToValuation}d`],
                  ['Median days last upload → valued', s => s.medUploadToVal == null ? '—' : `${s.medUploadToVal}d`],
                  ['Valued within 14 days', s => s.within14 == null ? '—' : `${s.within14}%`],
                  ['Still in upload phase', s => s.inFlight],
                ].map(([label, fn], i) => (
                  <tr key={i} className="border-b border-gray-50">
                    <td className="py-1 pr-4 text-gray-600">{label}</td>
                    <td className="py-1 pr-4 font-semibold text-gray-800">{fn(funnelStats.last90)}</td>
                    <td className="py-1 pr-4 text-gray-600">{fn(funnelStats.prior90)}</td>
                    <td className="py-1 text-gray-600">{fn(funnelStats.allTime)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="text-[11px] text-gray-400 mt-2">Conversion counts deals whose stage passed Upload Complete (or that were valued). Recent discoveries still in the upload phase appear in "Still in upload phase" — they haven't failed, they're in flight.</p>
          </div>
        )}
        {!loading && !error && tab === 'pipeline' && (
          <PipelineView
            rows={pipelineRows}
            gauges={gauges}
            canEditTargets={myRole === 'owner'}
            onSaveTarget={saveTarget}
            stageFlow={stageFlow}
            ladder={ladder}
            stageDistribution={stageDistribution}
            uniqueLeads={uniqueLeads}
            uniqueAMs={uniqueAMs}
            uniqueOwners={uniqueOwners}
            filterStage={filterStage} setFilterStage={setFilterStage}
            filterLead={filterLead} setFilterLead={setFilterLead}
            filterAM={filterAM} setFilterAM={setFilterAM}
            filterOwner={filterOwner} setFilterOwner={setFilterOwner}
            sortBy={sortBy} sortDir={sortDir} toggleSort={toggleSort}
            hiddenColumns={hiddenColumns} onToggleColumn={toggleColumn}
            views={pipelineViews} onSaveView={savePipelineView} onApplyView={applyPipelineView} onDeleteView={deletePipelineView}
            onOpenValuation={onOpenValuation}
            presenceByValuation={presenceByValuation}
          />
        )}

        {!loading && !error && tab === 'staffmeeting' && (
          <StaffMeetingView dmListings={dmListings} pipelineProjects={pipelineProjects} buysideLoi={buysideLoiPairs} actor={effectiveName} cpPlans={cpPlansAll} onCpChanged={() => setCpPlansTick(t => t + 1)} health={closingHealth} />
        )}

        {!loading && !error && tab === 'timeline' && (
          <ProjectTimelineView dmListings={dmListings} dmClosings={dmClosings} dmStatusLog={dmStatusLog} dmSheetHistory={dmSheetHistory} dmDateOverrides={dmDateOverrides} pipelineProjects={pipelineProjects} stageEvents={stageEvents} ownerEngagement={ownerEngagement} />
        )}

        {!loading && !error && tab === 'closeddeals' && (
          <ClosedDealsView dmClosings={dmClosings} pipelineProjects={pipelineProjects} dmListings={dmListings} />
        )}

        {!loading && !error && tab === 'committee' && (
          <CommitteeView metricSnapshots={metricSnapshots} targets={targets} dmListings={dmListings} dmClosings={dmClosings} valuationHistory={valuationHistory} importedEvents={importedEvents} loiSignings={loiSignings} stageEvents={stageEvents} buyersByMonth={dmBuyersByMonth} seMeetings={seMeetingsAll} bsStocks={bsStocks} onSaveTarget={saveTarget} canEditTargets={myRole === 'owner'} />
        )}
      </div>
    </div>
  );
};

// ─── Shared DM commission-override rule (#6 A1/A2) ──────────────
// DM `listings.estimated_commission` is an OVERRIDE of VT's computed figure:
// null = use VT's captured estimate; any number INCLUDING 0 = the lead's DM
// figure wins (leads zero a shaky/paused deal so the pipeline isn't
// overstated). Works from either direction: pass the DM row (may be absent)
// and the matched VT project (may be absent). ONE place for this rule — the
// ladder and the staff-meeting tables must never disagree.
function commissionWithOverride(dmRow, vtRow) {
  const overridden = !!dmRow && dmRow.estimated_commission !== null && dmRow.estimated_commission !== undefined;
  const value = overridden
    ? Number(dmRow.estimated_commission) || 0
    : (vtRow ? Number(vtRow.estimated_commission) || 0 : 0);
  return { value, overridden, zeroed: overridden && value === 0, noVt: !vtRow };
}

// Marker badges for override-rule flags — shared by the ladder breakdown and
// the staff-meeting tables.
const CommissionMarkers = ({ r }) => (
  <span className="ml-2 inline-flex gap-1">
    {r.negotiating && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-purple-100 text-purple-700" title="Contract Pending — pre-signature exclusive negotiation (LOI being negotiated; new CAs held). Not yet under signed LOI. Before the LOI deadline the badge counts down to offers-due; after it, offers are in — contract pending.">contract pending{r.daysToLoiDeadline != null && r.daysToLoiDeadline >= 0 ? ` · offers in ${r.daysToLoiDeadline}d` : ''}</span>}
    {r.ioiStatus && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-indigo-100 text-indigo-700" title="Buyers are submitting/reviewing Indications of Interest — still on market, IOI process underway in Deal Manager.">{r.ioiStatus}</span>}
    {r.prep && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-blue-100 text-blue-700" title="Engagement signed; CIM and marketing prep underway in VT — no Deal Manager listing yet. Counts as listed money (the listing agreement is signed); goes on market when marketing starts.">marketing prep</span>}
    {r.zeroed && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-red-100 text-red-700" title="The lead zeroed this deal's commission in Deal Manager — at risk / paused, kept out of the pipeline total on purpose.">zeroed</span>}
    {r.overridden && !r.zeroed && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-amber-100 text-amber-700" title="Commission set by the lead in Deal Manager (overrides VT's computed figure).">DM override</span>}
    {r.noVt && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-gray-100 text-gray-500" title="No VT client record (pre-VT business) — data comes from Deal Manager only.">no VT record</span>}
  </span>
);

// ─── Staff-Meeting Opener (#6 A2) ───────────────────────────────
// The two tables reviewed at the start of every staff meeting (previously
// read from Zoho): 1) Under LOI — soonest projected close first; 2) Listed
// (In Market / Paused, not yet under LOI) — longest on market first. DM is
// the source of truth for status + LOI/market dates; VT supplies the AM and
// computed commission (subject to the DM override rule). Rows carry a
// `source` tag so #8's buy-side rows can UNION into the Under-LOI table
// later without rework.
// ─── Closing Engine slice 2: the closing plan (Mark 09-02) ───
// The milestone catalog is a straight transcription of Zac's
// Vista_LOI_to_Close_Timeline.xlsx (S:\Forms\Meeting Agenda, 08/2026 —
// canonical per req ⑪c). Anchors: 'loi' = business days AFTER LOI signed;
// 'close' = business days BEFORE target close. crit = critical path
// (slipping it moves the close; non-crit yellows). inc = default-included;
// the four default-off optionals get offered as toggles at kickoff.
const CP_CATALOG = [
  { key: 'loi_exec', name: 'LOI Executed', owner: 'Seller', anchor: 'loi', start: 0, due: 0, crit: true, inc: true },
  { key: 'kickoff', name: 'Kickoff Call', owner: 'All Parties', anchor: 'loi', start: 1, due: 2, crit: false, inc: true },
  { key: 'dd_list', name: 'Diligence Request List Provided', owner: 'Buyer', anchor: 'loi', start: 1, due: 3, crit: true, inc: true },
  { key: 'dd_folders', name: 'Data Room Diligence Folders Built', owner: 'Vista', anchor: 'loi', start: 2, due: 5, crit: false, inc: true },
  { key: 'dd_upload', name: 'Priority Diligence Responses Uploaded', owner: 'Seller', anchor: 'loi', start: 4, due: 9, crit: true, inc: true },
  { key: 'dd_period', name: 'Buyer Diligence Period', owner: 'Buyer', anchor: 'close', start: 31, due: 13, crit: true, inc: true },
  { key: 'qoe', name: 'Quality of Earnings / Fin. Diligence', owner: 'Buyer', anchor: 'loi', start: 5, due: 10, crit: true, inc: true },
  { key: 'appraisal', name: 'Appraisal / Third-Party Valuation', owner: 'Lender', anchor: 'close', start: 30, due: 18, crit: false, inc: false },
  { key: 'wc_method', name: 'Working Capital Methodology Agreed', owner: 'Buyer/Seller', anchor: 'close', start: 27, due: 19, crit: false, inc: true },
  { key: 'consent_list', name: 'Third-Party Consent List Identified', owner: 'Vista/Seller', anchor: 'close', start: 31, due: 25, crit: false, inc: true },
  { key: 'dd_qa', name: 'Diligence Q&A Substantially Complete', owner: 'Buyer/Seller', anchor: 'close', start: 13, due: 11, crit: true, inc: false },
  { key: 'fin_app', name: 'Financing Application Submitted', owner: 'Buyer', anchor: 'loi', start: 6, due: 14, crit: true, inc: true },
  // Zac's baseline corrections (09-03): commitment letter 45 calendar days
  // before close (≈32 bd), not 2 weeks; PA draft delivered 30 calendar days
  // before close (≈21 bd) — his own Workstate sheet (PA 9/30 vs close 10/30)
  // already ran on these rules; the first transcription was tighter than
  // his practice. Underwriting pulled ahead so approval precedes the letter.
  { key: 'underwriting', name: 'Underwriting / Credit Approval', owner: 'Lender/Buyer', anchor: 'close', start: 40, due: 33, crit: true, inc: true },
  { key: 'commitment', name: 'Financing Commitment Letter Issued', owner: 'Lender', anchor: 'close', start: 33, due: 32, crit: true, inc: true },
  { key: 'pa_draft', name: 'Purchase Agreement Drafted', owner: 'Buyer Counsel', anchor: 'close', start: 27, due: 22, crit: true, inc: true },
  { key: 'pa_delivered', name: 'PA Draft Delivered to Seller', owner: 'Buyer', anchor: 'close', start: 22, due: 21, crit: true, inc: true },
  { key: 'disclosures', name: 'Disclosure Schedules Prepared', owner: 'Seller Counsel', anchor: 'close', start: 12, due: 6, crit: true, inc: true },
  { key: 'pa_redlines', name: 'PA Negotiation / Redlines', owner: 'Buyer/Seller', anchor: 'close', start: 12, due: 5, crit: true, inc: true },
  { key: 'pa_final', name: 'Purchase Agreement Finalized', owner: 'Buyer/Seller', anchor: 'close', start: 5, due: 3, crit: true, inc: true },
  { key: 'consents', name: 'Third-Party Consents Secured', owner: 'Seller', anchor: 'close', start: 15, due: 4, crit: true, inc: true },
  { key: 'landlord', name: 'Landlord Consent / Lease Assignment', owner: 'Seller', anchor: 'close', start: 17, due: 4, crit: false, inc: false },
  { key: 'liens', name: 'Lien Search & Payoff Letters', owner: 'Buyer/Seller', anchor: 'close', start: 14, due: 7, crit: false, inc: true },
  { key: 'ppa', name: 'Purchase Price Allocation Agreed', owner: 'Buyer/Seller', anchor: 'close', start: 8, due: 3, crit: false, inc: false },
  { key: 'transition', name: 'Transition Plan Finalized', owner: 'Buyer/Seller', anchor: 'close', start: 7, due: 1, crit: false, inc: true },
  { key: 'funds_flow', name: 'Funds Flow / Closing Statement Final', owner: 'Buyer/Seller', anchor: 'close', start: 2, due: 1, crit: true, inc: true },
  { key: 'close', name: 'Close', owner: 'Buyer/Seller', anchor: 'close', start: 0, due: 0, crit: true, inc: true },
];
// Holiday calendar from the template's Inputs sheet (through 2027).
const CP_HOLIDAYS = new Set(['2026-01-01', '2026-01-19', '2026-02-16', '2026-05-25', '2026-06-19', '2026-07-03', '2026-09-07', '2026-10-12', '2026-11-11', '2026-11-26', '2026-11-27', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18', '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-11-26', '2027-12-24']);
const cpIsBusDay = (d) => { const wd = d.getUTCDay(); return wd !== 0 && wd !== 6 && !CP_HOLIDAYS.has(d.toISOString().slice(0, 10)); };
// n business days from dateIso in direction dir (+1 forward, -1 back);
// n=0 snaps to the nearest business day in that direction.
const cpAddBusDays = (dateIso, n, dir) => {
  if (!dateIso) return null;
  const d = new Date(dateIso + 'T00:00:00Z');
  if (n === 0) { while (!cpIsBusDay(d)) d.setUTCDate(d.getUTCDate() + dir); return d.toISOString().slice(0, 10); }
  let left = n;
  while (left > 0) { d.setUTCDate(d.getUTCDate() + dir); if (cpIsBusDay(d)) left--; }
  return d.toISOString().slice(0, 10);
};
// Benchmark close for a new plan (Mark 09-03: "a 90-day close should be
// the benchmark" — not the 10-week Workstate example the first default
// copied): LOI + 90 calendar days, snapped forward to a business day.
// Only a fallback — a projected close from the deal always wins.
const cpDefaultClose = (loiIso) => {
  const d = new Date((loiIso || new Date().toISOString().slice(0, 10)) + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + 90);
  return cpAddBusDays(d.toISOString().slice(0, 10), 0, 1);
};
const cpBusDaysBetween = (aIso, bIso) => {
  if (!aIso || !bIso) return null;
  let [a, b] = aIso <= bIso ? [aIso, bIso] : [bIso, aIso];
  const d = new Date(a + 'T00:00:00Z'); const end = new Date(b + 'T00:00:00Z');
  let n = 0;
  while (d < end) { d.setUTCDate(d.getUTCDate() + 1); if (cpIsBusDay(d)) n++; }
  return aIso <= bIso ? n : -n;
};
// Compute baseline dates for one milestone from the plan's anchors.
const cpBaseline = (m, loiIso, closeIso) => m.anchor === 'loi'
  ? { start: cpAddBusDays(loiIso, m.start, 1), due: cpAddBusDays(loiIso, m.due, 1) }
  : { start: cpAddBusDays(closeIso, m.start, -1), due: cpAddBusDays(closeIso, m.due, -1) };
// Fresh milestone set from the catalog for a new plan.
const cpFreshMilestones = (loiIso, closeIso) => CP_CATALOG.map(c => ({
  key: c.key, name: c.name, owner: c.owner, include: c.inc, anchor: c.anchor,
  start_bd: c.start, due_bd: c.due, crit: c.crit,
  ...(() => { const b = cpBaseline(c, loiIso, closeIso); return { baseline_start: b.start, baseline_due: b.due }; })(),
  committed_due: null, committed_by: null, status: c.key === 'loi_exec' ? 'complete' : '', done_at: null, custom: false,
}));
// On-pace math (the catch-up-or-move law, req ⑪): a crit-path milestone
// whose effective due (committed wins over baseline) is past with no
// completion pushes the earliest honest close out by its overdue business
// days. Non-crit slips yellow but never move the close.
const cpPace = (plan) => {
  const today = new Date().toISOString().slice(0, 10);
  let worstCrit = 0, softLate = 0;
  (plan.milestones || []).forEach(m => {
    if (!m.include || m.status === 'complete' || m.status === 'na') return;
    const due = m.committed_due || m.baseline_due;
    if (due && due < today) {
      const over = cpBusDaysBetween(due, today);
      if (m.crit) worstCrit = Math.max(worstCrit, over); else softLate++;
    }
  });
  const honestClose = worstCrit > 0 ? cpAddBusDays(plan.target_close, worstCrit, 1) : plan.target_close;
  return { behindBd: worstCrit, softLate, honestClose };
};
// The stage the deal is heading INTO — the next incomplete CRITICAL milestone
// with its effective due date (a committed date wins over the baseline), so the
// slip card and the staff-meeting row read "here is the stage we're at / owe
// next" instead of a bare quiet count (Mark 09-15). Falls back to the next
// incomplete included milestone of any kind when no critical ones remain; null
// when nothing is open (plan effectively done).
const cpNextStage = (plan) => {
  if (!plan || !Array.isArray(plan.milestones)) return null;
  const today = new Date().toISOString().slice(0, 10);
  const dueOf = (m) => m.committed_due || m.baseline_due || null;
  const open = plan.milestones.filter(m => m.include && m.status !== 'complete' && m.status !== 'na');
  const pick = (arr) => {
    const dated = arr.filter(dueOf).sort((a, b) => (dueOf(a) < dueOf(b) ? -1 : 1));
    return dated[0] || arr[0] || null;
  };
  const m = pick(open.filter(x => x.crit)) || pick(open);
  if (!m) return null;
  const due = dueOf(m);
  return { name: m.name, due, crit: !!m.crit, overdueBd: (due && due < today) ? cpBusDaysBetween(due, today) : 0 };
};

// Sold together (Zac 10-29: Dental Design Systems closes with Digital Dental Solutions). The latest 'sold_with'
// amendment names the partner listing whose plan this one follows; null = its own deal again.
const cpSoldWith = (plan) => {
  const a = [...((plan && plan.amendments) || [])].reverse().find(x => x.kind === 'sold_with');
  return a && a.vista_id ? String(a.vista_id).trim() : null;
};

// The kickoff screen (req ⑪): screen-shareable closing plan shaped like
// Zac's Excel — milestones, party lanes, baseline vs COMMITTED dates, mini
// Gantt bars, the pace banner running the catch-up-or-move math live.
// Lock stamps agreement; post-lock saves demand an amendment note.
const ClosingPlanModal = ({ target, actor, onClose, onSaved, partners = [] }) => {
  const seed = target.plan || null;
  const [plan, setPlan] = useState(() => seed ? JSON.parse(JSON.stringify(seed)) : {
    vista_id: target.vistaId || null, buyer_id: target.buyerId || null, owner_id: target.ownerId || null,
    deal_name: target.name, side: target.side || 'sellside',
    loi_signed: target.loiSigned || new Date().toISOString().slice(0, 10),
    target_close: target.projectedClose || cpDefaultClose(target.loiSigned),
    status: 'draft', locked_at: null, locked_by: null,
    milestones: cpFreshMilestones(target.loiSigned || new Date().toISOString().slice(0, 10), target.projectedClose || cpDefaultClose(target.loiSigned)),
    amendments: [], participants: [],
  });
  const [ptName, setPtName] = useState('');
  const [ptEmail, setPtEmail] = useState('');
  const [ptRole, setPtRole] = useState('buyer');
  const [saving, setSaving] = useState(false);
  const [custName, setCustName] = useState('');
  const [custOwner, setCustOwner] = useState('Buyer/Seller');
  const [custDue, setCustDue] = useState('');
  const fmtD = (d) => d ? new Date(d + 'T12:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '—';
  const upd = (patch) => setPlan(p => ({ ...p, ...patch }));
  const updMs = (i, patch) => setPlan(p => ({ ...p, milestones: p.milestones.map((m, j) => j === i ? { ...m, ...patch } : m) }));
  // Re-anchoring: changing LOI or target close recomputes every non-custom
  // baseline; committed dates (the parties' own words) are never touched.
  const reAnchor = (loi, close) => setPlan(p => ({
    ...p, loi_signed: loi, target_close: close,
    milestones: p.milestones.map(m => m.custom ? m : { ...m, ...(() => { const b = cpBaseline({ anchor: m.anchor, start: m.start_bd, due: m.due_bd }, loi, close); return { baseline_start: b.start, baseline_due: b.due }; })() }),
  }));
  const pace = cpPace(plan);
  const included = plan.milestones.filter(m => m.include);
  const doneN = included.filter(m => m.status === 'complete').length;
  const workDays = cpBusDaysBetween(plan.loi_signed, plan.target_close);
  const daysLeft = cpBusDaysBetween(new Date().toISOString().slice(0, 10), plan.target_close);
  const today = new Date().toISOString().slice(0, 10);
  const span = Math.max(1, cpBusDaysBetween(plan.loi_signed, plan.target_close) || 1);
  const barPos = (m) => {
    const s = m.baseline_start || plan.loi_signed, e = m.committed_due || m.baseline_due || plan.target_close;
    const a = Math.max(0, Math.min(1, (cpBusDaysBetween(plan.loi_signed, s) || 0) / span));
    const b = Math.max(a + 0.02, Math.min(1, (cpBusDaysBetween(plan.loi_signed, e) || 0) / span));
    return { left: (a * 100).toFixed(1) + '%', width: ((b - a) * 100).toFixed(1) + '%' };
  };
  const save = async () => {
    if (saving) return;
    let amendments = plan.amendments || [];
    if (plan.status === 'locked' && seed) {
      const note = window.prompt('This plan is LOCKED (both sides agreed). Saving changes requires an amendment note — what changed and why? It goes on the record and should be re-agreed at the next weekly.');
      if (note === null) return;
      amendments = [...amendments, { at: new Date().toISOString(), by: actor || null, note: note || '(no note)' }];
    }
    setSaving(true);
    try {
      const row = { ...plan, amendments, updated_at: new Date().toISOString() };
      const { data, error } = seed && seed.id
        ? await supabaseClient.from('closing_plans').update(row).eq('id', seed.id).select('id').single()
        : await supabaseClient.from('closing_plans').insert(row).select('id').single();
      if (error) throw error;
      if (onSaved) onSaved();
      onClose();
    } catch (e) { window.alert('Save failed: ' + (e?.message || e) + (/closing_plans/.test(String(e?.message)) ? ' — has migration 068 been applied?' : '')); }
    setSaving(false);
  };
  const lock = () => {
    if (!window.confirm('Lock the plan? This stamps both-sides agreement — later changes become amendments that go on the record. The ground rule to state out loud: "If we fall behind, we catch up that week or the close date moves — you\'ll hear it the week it happens."')) return;
    upd({ status: 'locked', locked_at: new Date().toISOString(), locked_by: actor || null });
  };
  // ── The meeting-reader (Zac 09-03: "plug in meeting notes and have AI
  // do all the dates for me"). AI PROPOSES, THE LEAD APPROVES: the server
  // reads pasted notes (or the latest Fireflies transcript when the box is
  // left blank) against the plan and returns a proposal diff; only TICKED
  // proposals edit the plan, and only locally — Save stays the commit
  // point, amendment-note flow included. Wrong dates in a commitment
  // ledger cost more than one tick per item.
  const [aiPanel, setAiPanel] = useState(false);
  const [aiNotes, setAiNotes] = useState('');
  const [aiBusy, setAiBusy] = useState(false);
  const [aiResult, setAiResult] = useState(null); // { source, title, close_date, items, new_milestones, checked }
  const aiRead = async () => {
    if (aiBusy) return;
    if (!seed || !seed.id) { window.alert('Save the plan once first — the reader works from the saved plan.'); return; }
    setAiBusy(true); setAiResult(null);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const at = session && session.access_token;
      if (!at) throw new Error('Session expired — reload and sign in again.');
      const r = await fetch('/api/closing/read-meeting', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
        body: JSON.stringify({ plan_id: seed.id, notes: aiNotes }),
      });
      const d = await r.json();
      if (!r.ok || !d.ok) throw new Error(d.error || ('HTTP ' + r.status));
      const checked = {};
      (d.items || []).forEach((_, i) => { checked['i' + i] = true; });
      (d.new_milestones || []).forEach((_, i) => { checked['n' + i] = true; });
      if (d.close_date) checked.close = true;
      setAiResult({ ...d, checked });
    } catch (e) { window.alert('Meeting read failed: ' + (e.message || e)); }
    setAiBusy(false);
  };
  const aiToggle = (k) => setAiResult(r => r ? { ...r, checked: { ...r.checked, [k]: !r.checked[k] } } : r);
  const aiApply = () => {
    const r = aiResult; if (!r) return;
    const now = new Date().toISOString();
    setPlan(p => {
      let ms = p.milestones.map(m => ({ ...m }));
      (r.items || []).forEach((it, idx) => {
        if (!r.checked['i' + idx]) return;
        const m = ms.find(x => x.key === it.key); if (!m) return;
        if (it.action === 'commit') { m.committed_due = it.date; m.committed_by = (m.owner || '') + ' (from the meeting)'; }
        else if (it.action === 'complete') { m.status = 'complete'; m.done_at = now; }
        else if (it.action === 'in_progress') { if (m.status !== 'complete') m.status = 'in_progress'; }
        else if (it.action === 'na') { m.status = 'na'; }
      });
      (r.new_milestones || []).forEach((n, idx) => {
        if (!r.checked['n' + idx]) return;
        const nm = { key: 'custom_' + Date.now() + '_' + idx, name: n.name, owner: n.owner || 'Buyer/Seller', include: true, anchor: 'close', start_bd: 0, due_bd: 0, crit: false, baseline_start: n.due || p.target_close, baseline_due: n.due || p.target_close, committed_due: null, committed_by: null, status: '', done_at: null, custom: true };
        ms = [...ms.slice(0, -1), nm, ms[ms.length - 1]];
      });
      return { ...p, milestones: ms };
    });
    if (r.close_date && r.checked.close) reAnchor(plan.loi_signed, r.close_date);
    setAiResult(null); setAiNotes(''); setAiPanel(false);
  };
  const AI_ACTION_LABEL = { commit: '🗣 committed date', complete: '✓ complete', in_progress: '▶ in progress', na: 'N/A for this deal' };
  // ── Seller-facing PDF export (Zac 09-03: "sellers appreciate when we
  // provide it via PDF") — reproduces his Excel timeline's look (stat
  // header, milestone table, week-grid Gantt, confidential footer) from
  // the LIVE plan, so the chart is never a second thing to maintain.
  // Opens a print-ready window; the browser's Save-as-PDF does the rest.
  const exportPdf = () => {
    const escH = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const rows = plan.milestones.filter(m => m.include && m.status !== 'na');
    const D = (iso) => new Date(iso + 'T12:00:00');
    const fmtL = (iso) => iso ? `${D(iso).getMonth() + 1}/${String(D(iso).getDate()).padStart(2, '0')}/${String(D(iso).getFullYear()).slice(2)}` : '';
    const fmtS = (iso) => iso ? `${D(iso).getMonth() + 1}/${D(iso).getDate()}` : '';
    // Week grid: Monday of the LOI week through the week holding the last due date.
    const gs = D(plan.loi_signed); gs.setDate(gs.getDate() - ((gs.getDay() + 6) % 7));
    const lastIso = rows.reduce((mx, m) => { const e = m.committed_due || m.baseline_due; return e && e > mx ? e : mx; }, plan.target_close || plan.loi_signed);
    const weeks = []; for (const d = new Date(gs); d <= D(lastIso); d.setDate(d.getDate() + 7)) weeks.push(new Date(d));
    if (!weeks.length) weeks.push(new Date(gs));
    const g0 = gs.getTime(), g1 = weeks[weeks.length - 1].getTime() + 7 * 86400000;
    const pct = (iso) => Math.max(0, Math.min(100, (D(iso).getTime() - g0) / (g1 - g0) * 100));
    const MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const wkHead = weeks.map((w, i) => `<div style="flex:1;border-left:1px solid #dfe7df;padding-left:3px"><div style="color:#1f4d3d;font-weight:bold;height:11px">${(i === 0 || w.getMonth() !== weeks[i - 1].getMonth()) ? MON[w.getMonth()] : ''}</div><div style="color:#8a998a">${w.getDate()}</div></div>`).join('');
    const grid = `repeating-linear-gradient(to right, #e7ede7 0, #e7ede7 1px, transparent 1px, transparent ${(100 / weeks.length).toFixed(3)}%)`;
    const body = rows.map(m => {
      const eff = m.committed_due || m.baseline_due;
      const a = pct(m.baseline_start || plan.loi_signed), b = Math.max(a + 1.5, pct(eff || plan.target_close));
      const done = m.status === 'complete';
      const bar = `<div style="position:absolute;top:2px;height:12px;border-radius:2px;left:${a.toFixed(1)}%;width:${(b - a).toFixed(1)}%;background:${done ? '#3f6b52' : '#b7cbb5'}"></div><span style="position:absolute;top:2px;left:${b.toFixed(1)}%;transform:translateX(${b > 90 ? '-104%' : '3px'});font-size:7px;font-weight:bold;color:${b > 90 && done ? '#fff' : '#1f4d3d'};line-height:12px">${fmtS(eff)}</span>`;
      return `<tr><td style="padding:2.5px 6px;border-bottom:1px solid #eef2ee;font-weight:600;color:#222;white-space:nowrap">${escH(m.name)}</td><td class="dim">${escH(m.owner)}</td><td class="dim">${fmtL(m.baseline_start)}</td><td style="padding:2.5px 6px;border-bottom:1px solid #eef2ee;font-weight:bold;white-space:nowrap">${fmtL(eff)}</td><td class="dim">${done ? 'Complete' : m.status === 'in_progress' ? 'In progress' : ''}</td><td style="border-bottom:1px solid #eef2ee;width:46%"><div style="position:relative;height:16px;background:${grid}">${bar}</div></td></tr>`;
    }).join('');
    const stat = (l, v) => `<div><div style="font-size:7.5px;letter-spacing:1px;color:#8a998a">${l}</div><div style="font-size:13px;font-weight:bold;color:#222;margin-top:2px">${v}</div></div>`;
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>LOI to Close Timeline — ${escH(plan.deal_name)}</title><style>
      @page { size: letter landscape; margin: 0.35in; }
      /* Force background graphics in print/Save-as-PDF (Zac 09-15: the Gantt
         bars, week-grid stripes, and header rules were dropping on export —
         Chrome omits backgrounds by default without this). Matches the other
         print exports in this app. */
      html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      body { font-family: Arial, Helvetica, sans-serif; font-size: 9px; color: #333; margin: 0; }
      td.dim, td[class=dim] { padding: 2.5px 6px; border-bottom: 1px solid #eef2ee; color: #8a998a; white-space: nowrap; }
      table { border-collapse: collapse; width: 100%; }
    </style></head><body>
      <div style="font-size:19px;font-weight:bold;color:#1f4d3d;font-family:Georgia,serif">LOI to Close Timeline</div>
      <div style="color:#9aa79a;font-size:10px;margin:2px 0 8px">${escH(plan.deal_name)}</div>
      <div style="border-top:3px solid #1f4d3d;margin-bottom:10px"></div>
      <div style="display:flex;gap:56px;margin-bottom:14px">
        ${stat('LOI SIGNED', fmtL(plan.loi_signed))}${stat('TARGET CLOSE', fmtL(plan.target_close))}${stat('WORKING DAYS', workDays == null ? '—' : workDays)}${stat('DAYS REMAINING', daysLeft == null ? '—' : daysLeft)}${stat('MILESTONES', `${doneN} of ${included.length}`)}
      </div>
      <table>
        <tr style="border-bottom:2px solid #1f4d3d">
          <th style="text-align:left;padding:3px 6px;color:#1f4d3d;font-size:8.5px">Milestone</th>
          <th style="text-align:left;padding:3px 6px;color:#1f4d3d;font-size:8.5px">Owner</th>
          <th style="text-align:left;padding:3px 6px;color:#1f4d3d;font-size:8.5px">Start</th>
          <th style="text-align:left;padding:3px 6px;color:#1f4d3d;font-size:8.5px">Due</th>
          <th style="text-align:left;padding:3px 6px;color:#1f4d3d;font-size:8.5px">Status</th>
          <th style="padding:3px 0"><div style="display:flex;font-size:7.5px;text-align:left">${wkHead}</div></th>
        </tr>
        ${body}
      </table>
      <div style="display:flex;justify-content:space-between;margin-top:18px;font-size:7.5px;color:#8a998a">
        <div>Vista Business Group &nbsp;·&nbsp; Confidential</div>
        <div>${new Date().toLocaleDateString()}</div>
      </div>
      <script>window.onload = function () { setTimeout(function () { window.print(); }, 250); };<\/script>
    </body></html>`;
    const w = window.open('', '_blank');
    if (!w) { window.alert('Pop-up blocked — allow pop-ups for this site to export the PDF.'); return; }
    w.document.write(html); w.document.close();
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center overflow-y-auto p-4" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl my-4">
        <div className="px-5 py-4 border-b flex items-center gap-3 flex-wrap sticky top-0 bg-white rounded-t-xl z-10">
          <div className="text-lg font-bold text-gray-800">📋 {plan.deal_name}</div>
          <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${plan.side === 'buyside' ? 'bg-violet-100 text-violet-700' : 'bg-blue-100 text-blue-700'}`}>{plan.side}</span>
          {plan.status === 'locked'
            ? <span className="text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded px-2 py-0.5" title={`Locked ${(plan.locked_at || '').slice(0, 10)} by ${plan.locked_by || '—'}${(plan.amendments || []).length ? ` · ${plan.amendments.length} amendment(s)` : ''}`}>🔒 locked — both sides agreed{(plan.amendments || []).length ? ` · ${plan.amendments.length} amendment${plan.amendments.length === 1 ? '' : 's'}` : ''}</span>
            : <button type="button" onClick={lock} className="text-xs px-2.5 py-1 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700" title="Stamp both-sides agreement — the locked plan becomes the baseline the movement detector measures against.">✓ Both sides agreed — lock the plan</button>}
          <div className="ml-auto flex items-center gap-2">
            <button type="button" onClick={() => setAiPanel(v => !v)} className={`text-xs px-2.5 py-1.5 rounded border font-semibold ${aiPanel ? 'border-violet-600 bg-violet-600 text-white' : 'border-violet-500 text-violet-700 hover:bg-violet-50'}`} title="AI reads the meeting — pasted notes, or the latest Fireflies transcript — and PROPOSES plan updates: committed dates heard, milestones done, new items, a moved close. You tick what's right, Apply, then Save. It never writes anything on its own.">🪄 Read the meeting</button>
            <button type="button" onClick={exportPdf} className="text-xs px-2.5 py-1.5 rounded border border-emerald-600 text-emerald-700 font-semibold hover:bg-emerald-50" title="Seller-facing timeline chart (Zac's Excel look) built from this live plan — a print window opens; choose Save as PDF. Committed dates print as the due dates, excluded/N-A rows stay off.">📄 Export PDF</button>
            <button type="button" disabled={saving} onClick={save} className="text-xs px-3 py-1.5 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700">{saving ? 'Saving…' : 'Save'}</button>
            <button type="button" onClick={onClose} className="text-xs px-2.5 py-1.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">Close</button>
          </div>
        </div>
        <div className="px-5 py-3 flex items-center gap-5 flex-wrap border-b bg-gray-50 text-sm">
          <label className="flex items-center gap-1.5 text-gray-600">LOI signed
            <input type="date" value={plan.loi_signed || ''} onChange={e => reAnchor(e.target.value, plan.target_close)} className="border border-gray-300 rounded px-1.5 py-0.5 text-sm" />
          </label>
          <label className="flex items-center gap-1.5 text-gray-600">Target close
            <input type="date" value={plan.target_close || ''} onChange={e => reAnchor(plan.loi_signed, e.target.value)} className="border border-gray-300 rounded px-1.5 py-0.5 text-sm" />
          </label>
          {plan.side === 'sellside' && partners.length > 0 && (
            <label className="flex items-center gap-1.5 text-gray-600" title="Two listings sold to the same buyer in one deal: this one follows the other's plan. It shows that deal's movement and never raises its own sliding card, so you update one plan, not two.">Sold together with
              <select value={cpSoldWith(plan) || ''} onChange={e => upd({ amendments: [...(plan.amendments || []), { at: new Date().toISOString(), by: actor || null, kind: 'sold_with', vista_id: e.target.value || null }] })}
                className="border border-gray-300 rounded px-1.5 py-0.5 text-sm">
                <option value="">— its own deal —</option>
                {partners.map(p => <option key={p.vista_id} value={p.vista_id}>{p.name} ({p.vista_id})</option>)}
              </select>
            </label>
          )}
          <span className="text-gray-500">{workDays == null ? '—' : workDays} working days · <b className={daysLeft != null && daysLeft < 10 ? 'text-amber-600' : 'text-gray-700'}>{daysLeft == null ? '—' : daysLeft} left</b> · milestones <b>{doneN} of {included.length}</b></span>
          <span className={`ml-auto text-xs font-semibold rounded px-2.5 py-1 ${pace.behindBd > 0 ? 'bg-amber-100 text-amber-800 border border-amber-300' : 'bg-emerald-50 text-emerald-700 border border-emerald-200'}`}
            title="The catch-up-or-move law: a critical-path milestone past due pushes the earliest honest close out by its overdue business days. Non-critical slips are noted but never move the close.">
            {pace.behindBd > 0
              ? `⚠ ${pace.behindBd} business day${pace.behindBd === 1 ? '' : 's'} behind — catch up this week or the close moves to ${fmtD(pace.honestClose)}`
              : `✓ on pace for ${fmtD(plan.target_close)}${pace.softLate ? ` · ${pace.softLate} non-critical item${pace.softLate === 1 ? '' : 's'} late` : ''}`}
          </span>
        </div>
        {aiPanel && (
          <div className="px-5 py-3 border-b bg-violet-50/60">
            {!aiResult && (
              <div>
                <div className="text-xs text-violet-800 font-semibold mb-1.5">🪄 Read the meeting — paste notes below, or leave blank to read the latest Fireflies transcript for this deal's participants (last 14 days).</div>
                <textarea value={aiNotes} onChange={e => setAiNotes(e.target.value)} rows={3} placeholder="Paste meeting notes here (optional)" className="w-full border border-violet-200 rounded px-2 py-1.5 text-sm bg-white" />
                <button type="button" disabled={aiBusy} onClick={aiRead} className="mt-1.5 text-xs px-3 py-1.5 rounded bg-violet-600 text-white font-semibold hover:bg-violet-700 disabled:opacity-50">{aiBusy ? 'Reading…' : aiNotes.trim() ? 'Read these notes' : 'Read the latest Fireflies transcript'}</button>
              </div>
            )}
            {aiResult && (
              <div>
                <div className="text-xs text-violet-800 font-semibold mb-2">Proposed from {aiResult.source === 'fireflies' ? `Fireflies${aiResult.title ? ` — "${aiResult.title}"` : ''}${aiResult.meeting_date ? ` · ${new Date(aiResult.meeting_date).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}` : ''}` : 'your notes'} — tick what's right, then Apply. Nothing saves until you click Save. {aiResult.source === 'fireflies' && <span className="font-normal text-violet-600">Check the meeting date is the one you mean — a call just ended takes Fireflies ~15-30 min to process, so the latest available transcript can be an earlier meeting.</span>}</div>
                {(aiResult.items || []).length === 0 && (aiResult.new_milestones || []).length === 0 && !aiResult.close_date && (
                  <div className="text-sm text-gray-600">The meeting established nothing new for the plan — no dates committed, nothing completed. That itself is worth knowing.</div>
                )}
                <div className="space-y-1.5">
                  {aiResult.close_date && (
                    <label className="flex items-start gap-2 text-sm bg-amber-50 border border-amber-300 rounded px-2 py-1.5">
                      <input type="checkbox" checked={!!aiResult.checked.close} onChange={() => aiToggle('close')} className="mt-0.5" />
                      <span><b>Target close moves to {aiResult.close_date}</b> — re-anchors every non-custom baseline.</span>
                    </label>
                  )}
                  {(aiResult.items || []).map((it, i) => {
                    const m = plan.milestones.find(x => x.key === it.key) || {};
                    return (
                      <label key={'i' + i} className="flex items-start gap-2 text-sm bg-white border border-violet-200 rounded px-2 py-1.5">
                        <input type="checkbox" checked={!!aiResult.checked['i' + i]} onChange={() => aiToggle('i' + i)} className="mt-0.5" />
                        <span><b>{m.name || it.key}</b> — {AI_ACTION_LABEL[it.action] || it.action}{it.date ? <b className="text-violet-700"> {it.date}</b> : ''}{it.evidence && <span className="block text-xs text-gray-500 italic">"{it.evidence}"</span>}</span>
                      </label>
                    );
                  })}
                  {(aiResult.new_milestones || []).map((n, i) => (
                    <label key={'n' + i} className="flex items-start gap-2 text-sm bg-white border border-violet-200 rounded px-2 py-1.5">
                      <input type="checkbox" checked={!!aiResult.checked['n' + i]} onChange={() => aiToggle('n' + i)} className="mt-0.5" />
                      <span><b>New milestone: {n.name}</b> ({n.owner}{n.due ? `, due ${n.due}` : ''}){n.evidence && <span className="block text-xs text-gray-500 italic">"{n.evidence}"</span>}</span>
                    </label>
                  ))}
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <button type="button" onClick={aiApply} className="text-xs px-3 py-1.5 rounded bg-violet-600 text-white font-semibold hover:bg-violet-700">Apply ticked → then review &amp; Save</button>
                  <button type="button" onClick={() => setAiResult(null)} className="text-xs px-2.5 py-1.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">Discard</button>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
              <th className="px-2 py-2 text-center" title="Include this milestone for this deal — not every deal needs every row.">In</th>
              <th className="px-2 py-2 text-left">Milestone</th>
              <th className="px-2 py-2 text-left">Whose court</th>
              <th className="px-2 py-2 text-left" title="Back-scheduled from the anchors (business days, holidays skipped).">Baseline due</th>
              <th className="px-2 py-2 text-left" title="THEIR stated date — 'I will perform and here is the date.' Wins over baseline everywhere.">Committed due</th>
              <th className="px-2 py-2 text-left">Status</th>
              <th className="px-2 py-2 text-left w-48">Timeline</th>
            </tr></thead>
            <tbody>
              {plan.milestones.map((m, i) => {
                const effDue = m.committed_due || m.baseline_due;
                const late = m.include && m.status !== 'complete' && m.status !== 'na' && effDue && effDue < today;
                return (
                  <tr key={m.key || i} className={`border-b border-gray-100 ${!m.include ? 'opacity-40' : ''} ${late ? (m.crit ? 'bg-red-50/60' : 'bg-amber-50/60') : ''}`}>
                    <td className="px-2 py-1.5 text-center"><input type="checkbox" checked={!!m.include} onChange={e => updMs(i, { include: e.target.checked })} /></td>
                    <td className="px-2 py-1.5 font-medium text-gray-800">{m.name}{m.crit && <span className="ml-1 text-red-500" title="Critical path — slipping this moves the close.">●</span>}{m.custom && <span className="ml-1 text-[10px] text-gray-400">(custom)</span>}</td>
                    <td className="px-2 py-1.5 text-gray-600 whitespace-nowrap">{m.owner}</td>
                    <td className="px-2 py-1.5 text-gray-500 whitespace-nowrap">{fmtD(m.baseline_due)}</td>
                    <td className="px-2 py-1.5 whitespace-nowrap">
                      <input type="date" value={m.committed_due || ''} onChange={e => updMs(i, { committed_due: e.target.value || null, committed_by: e.target.value ? (m.committed_by || m.owner) : null })}
                        className={`border rounded px-1 py-0.5 text-xs ${m.committed_due ? 'border-violet-300 bg-violet-50 font-semibold' : 'border-gray-200'}`}
                        title="The party's own committed date — asked and answered before the kickoff; wins over the baseline." />
                    </td>
                    <td className="px-2 py-1.5">
                      <select value={m.status || ''} onChange={e => updMs(i, { status: e.target.value, done_at: e.target.value === 'complete' ? new Date().toISOString() : m.done_at })}
                        className="border border-gray-200 rounded px-1 py-0.5 text-xs bg-white">
                        <option value="">Not started</option><option value="in_progress">In progress</option><option value="complete">✓ Complete</option><option value="na">N/A</option>
                      </select>
                    </td>
                    <td className="px-2 py-1.5">
                      <div className="relative h-3 bg-gray-100 rounded">
                        {m.include && <div className={`absolute h-3 rounded ${m.status === 'complete' ? 'bg-emerald-400' : late ? (m.crit ? 'bg-red-400' : 'bg-amber-400') : m.status === 'in_progress' ? 'bg-sky-400' : 'bg-gray-300'}`} style={barPos(m)} />}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="px-5 py-2.5 border-t bg-white flex items-center gap-2 flex-wrap">
          <span className="text-xs text-gray-500 font-medium" title="Who the weekly cadence emails go to — the T-2 agenda-items request and the T-1 agenda land in the Lead's staged sends addressed to these people.">📧 Participants:</span>
          {(plan.participants || []).map((p, i) => (
            <span key={i} className={`text-[11px] px-1.5 py-0.5 rounded border inline-flex items-center gap-1 ${p.role === 'buyer' ? 'bg-violet-50 border-violet-200 text-violet-800' : p.role === 'seller' ? 'bg-blue-50 border-blue-200 text-blue-800' : 'bg-gray-50 border-gray-200 text-gray-700'}`} title={p.email}>
              {p.name || p.email} <i className="not-italic opacity-60">({p.role})</i>
              <button type="button" className="text-gray-400 hover:text-red-600" onClick={() => setPlan(pl => ({ ...pl, participants: pl.participants.filter((_, j) => j !== i) }))}>×</button>
            </span>
          ))}
          <select value={ptRole} onChange={e => setPtRole(e.target.value)} className="border border-gray-300 rounded px-1 py-0.5 text-xs bg-white">
            <option value="buyer">buyer</option><option value="seller">seller</option><option value="other">other</option>
          </select>
          <input value={ptName} onChange={e => setPtName(e.target.value)} placeholder="Name" className="border border-gray-300 rounded px-2 py-0.5 text-xs w-28" />
          <input value={ptEmail} onChange={e => setPtEmail(e.target.value)} placeholder="Email" className="border border-gray-300 rounded px-2 py-0.5 text-xs w-44" />
          <button type="button" className="text-xs px-2 py-0.5 rounded bg-gray-600 text-white font-semibold hover:bg-gray-700"
            onClick={() => {
              if (!ptEmail.includes('@')) { window.alert('Participant needs a valid email.'); return; }
              setPlan(pl => ({ ...pl, participants: [...(pl.participants || []), { role: ptRole, name: ptName.trim() || null, email: ptEmail.trim().toLowerCase() }] }));
              setPtName(''); setPtEmail('');
            }}>+ Add</button>
        </div>
        <div className="px-5 py-3 border-t bg-gray-50 flex items-center gap-2 flex-wrap rounded-b-xl">
          <span className="text-xs text-gray-500 font-medium" title="The standing kickoff question — anything typed here becomes a milestone on this plan.">Anything this deal needs that isn't on the list?</span>
          <input value={custName} onChange={e => setCustName(e.target.value)} placeholder="e.g. Real estate appraisal" className="border border-gray-300 rounded px-2 py-1 text-xs w-52" />
          <select value={custOwner} onChange={e => setCustOwner(e.target.value)} className="border border-gray-300 rounded px-1 py-1 text-xs bg-white">
            {['Buyer', 'Seller', 'Buyer/Seller', 'Vista', 'Lender', 'Buyer Counsel', 'Seller Counsel', 'All Parties'].map(o => <option key={o}>{o}</option>)}
          </select>
          <input type="date" value={custDue} onChange={e => setCustDue(e.target.value)} className="border border-gray-300 rounded px-1 py-1 text-xs" />
          <button type="button" className="text-xs px-2.5 py-1 rounded bg-gray-700 text-white font-semibold hover:bg-gray-800"
            onClick={() => {
              if (!custName.trim() || !custDue) { window.alert('Custom milestone needs a name and a due date.'); return; }
              setPlan(p => ({ ...p, milestones: [...p.milestones.slice(0, -1), { key: 'custom_' + Date.now(), name: custName.trim(), owner: custOwner, include: true, anchor: 'close', start_bd: 0, due_bd: 0, crit: false, baseline_start: custDue, baseline_due: custDue, committed_due: null, committed_by: null, status: '', done_at: null, custom: true }, p.milestones[p.milestones.length - 1]] }));
              setCustName(''); setCustDue('');
            }}>+ Add</button>
        </div>
      </div>
    </div>
  );
};

const StaffMeetingView = ({ dmListings, pipelineProjects, buysideLoi = [], actor = null, cpPlans = undefined, onCpChanged = null, health = {} }) => {
  const key = (v) => String(v || '').trim();
  // Closing plans (slice 2, lifted to the parent in slice 3 so the movement
  // detector shares them): badge the Under LOI rows with pace + movement,
  // open the kickoff screen from the row. Non-fatal pre-migration-068.
  const [cpTarget, setCpTarget] = useState(null);
  const setCpTick = () => { if (onCpChanged) onCpChanged(); };
  // Movement chip (slice 3): both sides' quiet-days at a glance. Green
  // under 7, amber 7-13, red 14+ — a side with no signal at all reads ∅.
  const MoveChip = ({ h }) => {
    if (!h) return null;
    const cls = h.level === 'red' ? 'bg-red-100 text-red-700 border-red-300' : h.level === 'amber' ? 'bg-amber-100 text-amber-800 border-amber-300' : 'bg-emerald-50 text-emerald-700 border-emerald-200';
    const q = (n) => n == null ? '∅' : n + 'd';
    const ns = h.nextStage;
    return (
      <>
        <span className={`ml-1 text-[10px] font-semibold px-1.5 py-0.5 rounded border whitespace-nowrap ${cls}`}
          title={`Movement detector: days since each side last moved (milestone checked off, meeting held, or mail in the vault). Seller ${q(h.qSeller)} · Buyer ${q(h.qBuyer)}. Quiet 7+ days ambers, 14+ reds — a stalled week is the biggest predictor of a dead deal.${h.stall ? ` Stall reason on record (${(h.stall.at || '').slice(0, 10)}): ${h.stall.reason}.` : ''}`}>
          {h.level === 'red' ? '🔴' : h.level === 'amber' ? '🟡' : '🟢'} S:{q(h.qSeller)} B:{q(h.qBuyer)}
        </span>
        {h.soldWith && <span className="ml-1 text-[10px] text-gray-500 whitespace-nowrap" title="Sold together: this listing follows that deal's closing plan (set on 📋 Plan).">↔ with {h.soldWith}</span>}
        {ns && (
          <span className={`ml-1 text-[10px] font-semibold px-1.5 py-0.5 rounded border whitespace-nowrap ${ns.overdueBd > 0 ? 'bg-red-50 text-red-700 border-red-300' : 'bg-gray-50 text-gray-600 border-gray-300'}`}
            title={`Next ${ns.crit ? 'critical ' : ''}milestone on the closing plan: ${ns.name}${ns.due ? ' — due ' + ns.due : ' — no date set'}${ns.overdueBd > 0 ? ' (' + ns.overdueBd + ' business days overdue)' : ''}.${ns.crit ? '' : ' No critical steps remain; the next included step is shown.'}`}>
            ▶ {ns.name}{ns.due ? ` · ${ns.due}` : ''}{ns.overdueBd > 0 ? ` (${ns.overdueBd}bd late)` : ''}
          </span>
        )}
      </>
    );
  };
  const cpFor = (r) => (cpPlans || []).find(p => r.source === 'dm-sellside'
    ? (p.side === 'sellside' && p.vista_id && p.vista_id === r.vistaId)
    : (p.side === 'buyside' && p.buyer_id === (r.buyer && r.buyer.id) && p.owner_id === (r.owner && r.owner.id)));
  const CpButton = ({ r, seed }) => {
    if (cpPlans === null) return <span className="text-[10px] text-gray-300" title="Closing plans need migration 068 applied.">📋</span>;
    const p = cpFor(r);
    if (!p) return (
      <button type="button" onClick={() => setCpTarget({ ...seed })}
        className="text-[11px] px-1.5 py-0.5 rounded border border-gray-300 text-gray-500 hover:bg-gray-50 whitespace-nowrap"
        title="Start this deal's closing plan — Zac's LOI-to-Close timeline, back-scheduled from the target close. Current deals get the mid-flight version: mark what's done, commit the rest.">📋 Plan</button>
    );
    const pc = cpPace(p);
    return (
      <button type="button" onClick={() => setCpTarget({ plan: p })}
        className={`text-[11px] px-1.5 py-0.5 rounded font-semibold whitespace-nowrap ${pc.behindBd > 0 ? 'bg-red-100 text-red-700 border border-red-300' : 'bg-emerald-50 text-emerald-700 border border-emerald-200'}`}
        title={pc.behindBd > 0 ? `${pc.behindBd} business day(s) behind on the critical path — catch up or the close moves to ${pc.honestClose}. Open the plan.` : `On pace${p.status === 'locked' ? ' · plan locked (both sides agreed)' : ' · plan not yet locked'}. Open the plan.`}>
        📋 {pc.behindBd > 0 ? `${pc.behindBd}d behind` : 'on pace'}{p.status !== 'locked' ? ' ·unlocked' : ''}</button>
    );
  };
  // Follow-ups-sent memo (RECOGNITION SLICE, Mark's exact ask 2026-08-03):
  // per-person owner-directed outbound email over the last 7 days, observed
  // straight from the synced mailboxes — effort visible to the room without
  // anyone logging anything. Non-fatal pre-migration-050.
  const [followUps, setFollowUps] = useState(undefined);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return undefined;
    (async () => {
      try {
        const since = new Date(Date.now() - 7 * 86400000).toISOString();
        const { data, error } = await supabaseClient.from('se_emails')
          .select('mailbox, valuation_id, owner_id')
          .eq('direction', 'outbound').gte('sent_at', since).limit(3000);
        if (error) throw error;
        const by = {};
        (data || []).forEach(r => {
          if (!r.valuation_id && !r.owner_id) return; // owner-directed only
          const b = by[r.mailbox] = by[r.mailbox] || { n: 0, who: new Set() };
          b.n++; b.who.add(r.valuation_id || r.owner_id);
        });
        if (!cancelled) setFollowUps(Object.entries(by)
          .map(([name, b]) => ({ name, n: b.n, owners: b.who.size }))
          .sort((a, b) => b.n - a.n));
      } catch (e) {
        console.warn('Staff-meeting follow-up memo skipped:', e?.message || e);
        if (!cancelled) setFollowUps(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);
  const fmtMoney = (n) => '$' + Math.round(Number(n) || 0).toLocaleString();
  const fmtDate = (d) => {
    if (!d) return '—';
    const dt = new Date(d + 'T00:00:00');
    return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString();
  };
  const todayMs = new Date(new Date().toISOString().slice(0, 10) + 'T00:00:00').getTime();
  const daysUntil = (d) => {
    if (!d) return null;
    const t = new Date(d + 'T00:00:00').getTime();
    return isNaN(t) ? null : Math.round((t - todayMs) / (24 * 60 * 60 * 1000));
  };

  if (dmListings === null) {
    return <div className="bg-red-50 border border-red-200 text-red-700 rounded p-4 text-sm">⚠ Deal Manager data unavailable — the staff-meeting tables read DM's listings. Reload, or check the server logs.</div>;
  }
  const dmRows = dmListings || [];
  const vtByVista = {};
  (pipelineProjects || []).forEach(p => { const k = key(p.vista_id); if (k && !vtByVista[k]) vtByVista[k] = p; });

  // Signed LOIs ONLY. Negotiating (pre-signature) deals sit in the LISTED
  // table below — Mark 2026-07-22: "not signed" belongs with what's still on
  // market; the first design grouped them here and it read wrong at the
  // meeting. The ladder still counts negotiating in its Under-LOI rung — the
  // money is genuinely late-stage; this is a table-placement call, not a
  // commission-stage change.
  const underLoi = dmRows.filter(r => r.status === 'Under LOI').map(r => {
    const match = vtByVista[key(r.vista_id)] || null;
    return {
      source: 'dm-sellside', vistaId: key(r.vista_id), name: r.name,
      signedLoi: r.signed_loi_date, projectedClose: r.projected_close_date,
      daysToClose: daysUntil(r.projected_close_date), clockDate: r.projected_close_date,
      lead: r.lead || (match && match.lead) || null,
      am: (match && match.account_manager) || r.account_manager || null,
      ...commissionWithOverride(r, match),
    };
  }).sort((a, b) => {
    if (!a.clockDate && !b.clockDate) return 0;
    if (!a.clockDate) return 1;
    if (!b.clockDate) return -1;
    return a.clockDate < b.clockDate ? -1 : 1;
  });

  // The LOI DEADLINE on negotiating rows is a Round-2 process date (set after
  // IOI review; the shortlist submits LOI offers by it — Mark 2026-07-24):
  // before it the badge counts down to offers-in; after it, offers are in
  // hand and the deal simply reads "negotiating" — no "past due" nag.
  // Every still-on-market DM status belongs here — incl. DM's newer 'IOI
  // Round'/'Round 2' (found 2026-07-27: those fell through BOTH tables and
  // the committee snapshot, so a deal in an IOI round vanished from the
  // meeting view entirely).
  const LISTED_STATUSES = ['In Market', 'Paused', 'IOI Round', 'Round 2', 'Contract Pending', 'In Negotiation'];
  const listed = dmRows.filter(r => LISTED_STATUSES.includes(r.status)).map(r => {
    const match = vtByVista[key(r.vista_id)] || null;
    const d = daysUntil(r.market_date);
    const negotiating = r.status === 'Contract Pending' || r.status === 'In Negotiation';
    return {
      source: 'dm-sellside', vistaId: key(r.vista_id), name: r.name,
      marketDate: r.market_date, daysOnMarket: d == null ? null : -d,
      paused: r.status === 'Paused',
      pauseReason: r.pause_reason || null, pauseNote: r.pause_note || null, pausedSince: r.paused_since || null, waiting: r.waiting || null,
      ioiStatus: (r.status === 'IOI Round' || r.status === 'Round 2') ? r.status : null,
      ioiDeadline: r.ioi_deadline,
      // Buyer-interest counts, live from DM (Mark 2026-07-27: "the amount of
      // interest we are generating" belongs on the meeting screen).
      buyers: r.active_buyers ?? null, ioiCount: r.ioi_count ?? null, loiCount: r.loi_count ?? null,
      negotiating, loiDeadline: r.loi_deadline,
      daysToLoiDeadline: negotiating ? daysUntil(r.loi_deadline) : null,
      lead: r.lead || (match && match.lead) || null,
      am: (match && match.account_manager) || r.account_manager || null,
      ...commissionWithOverride(r, match),
    };
  }).sort((a, b) => (a.marketDate || '9999') < (b.marketDate || '9999') ? -1 : 1);

  // Engaged-in-VT deals with NO DM listing row yet: engagement signed, CIM /
  // marketing prep underway (Mark 2026-07-27: Midwest H&C was invisible on
  // this tab). They render at the BOTTOM of the Listed table as MARKETING
  // PREP rows, and their commission COUNTS in the Listed total — Mark, same
  // day, reconciling against the Zoho report: "when they sign a listing
  // agreement they are listed… it doesn't matter that we haven't started to
  // market it." The CRM (and the imported committee-sheet history) always
  // counted all engaged clients, and the server's commission_pipeline
  // snapshot includes these deals too, so the identity keeps holding.
  const dmVistaIds = new Set(dmRows.map(r => key(r.vista_id)).filter(Boolean));
  const marketingPrep = (pipelineProjects || [])
    .filter(p => p.workflow_stage === 'engaged' && !dmVistaIds.has(key(p.vista_id)))
    .map(p => ({
      source: 'vt-engaged', vistaId: key(p.vista_id), name: p.company_name,
      prep: true, daysInStage: p.daysInStage || 0,
      lead: p.lead || null, am: p.account_manager || null,
      ...commissionWithOverride(null, p),
    }))
    .sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));

  const CloseIn = ({ d }) => {
    if (d == null) return <span className="text-gray-400">—</span>;
    if (d < 0) return <span className="font-semibold text-red-600">{-d}d past</span>;
    if (d <= 14) return <span className="font-semibold text-amber-600">in {d}d</span>;
    return <span className="text-gray-500">in {d}d</span>;
  };
  // Deadline cell (IOI/LOI columns, Mark 2026-07-27): the date plus a compact
  // countdown while it's still ahead. A PAST deadline is normal process state
  // (offers are in), not an alarm — so no red, just the date.
  const DeadlineDate = ({ d }) => {
    if (!d) return <span className="text-gray-400">—</span>;
    const days = daysUntil(d);
    return <span>{fmtDate(d)}{days != null && days >= 0 && <span className={`ml-1 text-xs font-semibold ${days <= 7 ? 'text-amber-600' : 'text-gray-400'}`}>in {days}d</span>}</span>;
  };
  // "How much interest are we generating" — buyers/IOIs/LOIs from DM.
  const interestStr = (r) => {
    const parts = [];
    if (r.buyers != null) parts.push(`${r.buyers} buyer${r.buyers === 1 ? '' : 's'}`);
    if (r.ioiCount > 0) parts.push(`${r.ioiCount} IOI${r.ioiCount === 1 ? '' : 's'}`);
    if (r.loiCount > 0) parts.push(`${r.loiCount} LOI${r.loiCount === 1 ? '' : 's'}`);
    return parts.length ? parts.join(' · ') : null;
  };
  const Th = ({ children, numeric }) => <th className={`px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 ${numeric ? 'text-right' : 'text-left'}`}>{children}</th>;
  const total = (rows) => rows.reduce((s, r) => s + (r.value || 0), 0);

  return (
    <div>
      <div className="text-xs text-gray-500 mb-4">The two tables that open every staff meeting. Deal Manager is the source of truth for status and dates; commission follows the DM-override rule (VT's figure unless the lead set one — 0 means deliberately zeroed).</div>
      {followUps && followUps.length > 0 && (
        <div className="mb-4 text-xs bg-emerald-50 border border-emerald-200 rounded px-3 py-2 text-emerald-800">
          📧 <strong>Owner follow-up emails sent, last 7 days</strong> (observed from the synced mailboxes — nobody logged anything):{' '}
          {followUps.map(f => `${f.name} ${f.n} (${f.owners} owner${f.owners === 1 ? '' : 's'})`).join(' · ')}
        </div>
      )}
      {/* 🚧 Stuck cards — auto-agenda (SE front ⑤, 2026-08-04): every active
          deal at ≥2× its stage target — the same threshold that copies Mark
          on the 7:30 nudge — lists itself for the meeting. No one compiles
          it, no one can forget it. Snoozed deals excluded: a set follow-up
          date is a plan, not stuck. */}
      {(() => {
        const now = new Date();
        const stuck = (pipelineProjects || [])
          .filter(p => OVERDUE_RADAR_STAGES.has(p.workflow_stage))
          .filter(p => !(p.snooze_until && new Date(p.snooze_until) > now))
          .map(p => { const clk = overdueClock(p, stageTargetDays(p.workflow_stage)); return { ...p, _t: clk.target, _clockDays: clk.days, _clockSince: clk.since }; })
          .filter(p => p._t != null && p._clockDays != null && p._clockDays >= 2 * p._t)
          .sort((a, b) => (b._clockDays / b._t) - (a._clockDays / a._t));
        if (!stuck.length) return null;
        return (
          <div className="bg-white border border-red-200 rounded-lg mb-6 overflow-hidden">
            <div className="px-4 py-3 border-b bg-red-50 flex items-baseline gap-2 flex-wrap">
              <div className="text-sm font-bold text-gray-800">🚧 Stuck cards — auto-agenda</div>
              <div className="text-xs text-gray-500">{stuck.length} deal{stuck.length === 1 ? '' : 's'} at twice the stage target or worse — the meeting's job is naming the blocker and the unstick, not discovering the list.</div>
            </div>
            <table className="w-full text-sm">
              <thead><tr className="border-b bg-gray-50"><Th>Business</Th><Th>Stage</Th><Th>Clock</Th><Th>Whose plate</Th><Th>Last contact (observed)</Th></tr></thead>
              <tbody>
                {stuck.map(p => (
                  <tr key={p.id} className="border-b last:border-0">
                    <td className="px-4 py-2 font-medium text-gray-800">{p.company_name}{p.path === 'partial' ? <span className="ml-1 text-[10px] text-blue-600">(partial)</span> : null}</td>
                    <td className="px-4 py-2 text-xs">{stageLabel(p.workflow_stage)}</td>
                    <td className="px-4 py-2 text-xs"><span className="font-bold text-red-600">{p._clockDays}d</span><span className="text-gray-400">{p._clockSince ? ` past the follow-up date (${p._clockSince}) · grace ${p._t}d` : ` · target ${p._t}d · ${(p._clockDays / p._t).toFixed(1)}×`}</span></td>
                    <td className="px-4 py-2 text-xs">{p.responsibility || p.lead || p.account_manager || '—'}</td>
                    <td className="px-4 py-2 text-xs text-gray-500">
                      {p.emailTruth && (p.emailTruth.lastOut || p.emailTruth.lastIn)
                        ? <span className={p.emailTruth.lastIn && (!p.emailTruth.lastOut || p.emailTruth.lastIn > p.emailTruth.lastOut) ? 'text-amber-700' : 'text-emerald-700'}>
                            📧 {p.emailTruth.lastIn && (!p.emailTruth.lastOut || p.emailTruth.lastIn > p.emailTruth.lastOut)
                              ? `owner wrote ${formatRelativeDate(p.emailTruth.lastIn)} — awaiting reply`
                              : `${p.emailTruth.lastOutBy || 'we'} emailed ${formatRelativeDate(p.emailTruth.lastOut)}`}
                          </span>
                        : p.interactionAt
                          ? `${p.interactionActor || ''} ${formatRelativeDate(p.interactionAt)}`.trim()
                          : <span className="text-gray-300">none recorded</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })()}

      <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
        <div className="px-4 py-3 border-b bg-yellow-50 flex items-baseline gap-2 flex-wrap">
          <div className="text-sm font-bold text-gray-800">🤝 Under LOI</div>
          <div className="text-xs text-gray-500">{underLoi.length} sellside{buysideLoi.length > 0 ? ` + ${buysideLoi.length} buyside` : ''} · <span className="font-semibold text-emerald-700">{fmtMoney(total(underLoi) + buysideLoi.reduce((s, p) => s + (p.estCommission || 0), 0))}</span> est. commission</div>
        </div>
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-gray-50"><Th>Business</Th><Th>Signed LOI</Th><Th>Projected Close</Th><Th>Clock</Th><Th>Lead</Th><Th>AM</Th><Th numeric>Est. Commission</Th></tr></thead>
          <tbody>
            {underLoi.length === 0 && buysideLoi.length === 0 && <tr><td colSpan={7} className="px-3 py-4 text-center text-gray-400 text-xs">Nothing under LOI.</td></tr>}
            {underLoi.map((r, i) => (
              <tr key={r.vistaId || i} className="border-b border-gray-100">
                <td className="px-3 py-2 font-medium text-gray-800">{r.name}<CommissionMarkers r={r} /> <CpButton r={r} seed={{ vistaId: r.vistaId, name: r.name, side: 'sellside', loiSigned: r.signedLoi, projectedClose: r.projectedClose }} /><MoveChip h={health['ss|' + r.vistaId]} /></td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{fmtDate(r.signedLoi)}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{fmtDate(r.projectedClose)}</td>
                <td className="px-3 py-2 whitespace-nowrap" title="Days to the projected close">
                  <CloseIn d={r.daysToClose} />
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{r.lead || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{r.am || '—'}</td>
                <td className={`px-3 py-2 text-right whitespace-nowrap font-medium ${r.value > 0 ? 'text-emerald-700' : 'text-gray-400'}`}>{fmtMoney(r.value)}</td>
              </tr>
            ))}
            {/* 🟣 Buyside under LOI (Closing Engine slice 1, Mark 09-02): live
                mandate pairs whose latest action is 🏁 LOI. Commission comes
                from the LOI record's prompt; projected close arrives with the
                slice-2 closing plans. */}
            {buysideLoi.map((p, i) => (
              <tr key={`bs-${i}`} className="border-b border-gray-100 bg-violet-50/40">
                <td className="px-3 py-2 font-medium text-gray-800">
                  {(p.owner && p.owner.company_name) || 'Business'}
                  <span className="text-gray-500 font-normal"> ← {(p.buyer && (p.buyer.contact_name || p.buyer.company_name)) || 'buyer'}</span>
                  <span className="ml-2 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-violet-100 text-violet-700" title="Buyside mandate under LOI — our client is the buyer.">buyside</span>
                  {' '}<CpButton r={{ source: 'se-buyside', buyer: p.buyer, owner: p.owner }} seed={{ buyerId: p.buyer && p.buyer.id, ownerId: p.owner && p.owner.id, name: `${(p.owner && p.owner.company_name) || 'Business'} ← ${(p.buyer && (p.buyer.contact_name || p.buyer.company_name)) || 'buyer'}`, side: 'buyside', loiSigned: p.loiAt && p.loiAt.slice(0, 10), projectedClose: null }} />
                  <MoveChip h={health['bs|' + (p.buyer && p.buyer.id) + '|' + (p.owner && p.owner.id)]} />
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{fmtDate(p.loiAt && p.loiAt.slice(0, 10))}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400" title="Closing plan (and its clock) arrives with the Closing Engine's next slice.">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400" title="Buyside: no listing lead — the credit is the introducer, in the AM column.">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600" title={p.credit ? `Buyside credit — ${p.credit.name}: ${BUYSIDE_CREDIT_WHY[p.credit.source] || p.credit.source}${p.credit.reason ? ' — ' + p.credit.reason : ''}` : ''}>{p.holder || '—'}<span className="ml-1 text-[10px] text-violet-700">intro</span></td>
                <td className={`px-3 py-2 text-right whitespace-nowrap font-medium ${p.estCommission > 0 ? 'text-emerald-700' : 'text-gray-400'}`} title={p.estCommission > 0 ? 'From the 🏁 LOI record' : 'No commission entered when the LOI was recorded — re-record the LOI to set it.'}>{fmtMoney(p.estCommission || 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b bg-green-50 flex items-baseline gap-2">
          <div className="text-sm font-bold text-gray-800">🏷 Listed Businesses</div>
          <div className="text-xs text-gray-500">{listed.length} listing{listed.length === 1 ? '' : 's'}{(() => { const n = listed.filter(r => r.negotiating).length; return n ? ` (${n} contract pending)` : ''; })()}{marketingPrep.length > 0 && <span> + {marketingPrep.length} in marketing prep</span>} · <span className="font-semibold text-emerald-700">{fmtMoney(total(listed) + total(marketingPrep))}</span> est. commission · longest on market first</div>
        </div>
        <table className="w-full text-sm">
          {/* Vista ID dropped, IOI/LOI deadline dates added — Mark 2026-07-27:
              the auction clocks matter at the meeting, the join key doesn't. */}
          <thead><tr className="border-b bg-gray-50"><Th>Business</Th><Th>Marketing Date</Th><Th>On Market</Th><Th>IOI Deadline</Th><Th>LOI Deadline</Th><Th>Interest</Th><Th>Lead</Th><Th>AM</Th><Th numeric>Est. Commission</Th></tr></thead>
          <tbody>
            {listed.length === 0 && marketingPrep.length === 0 && <tr><td colSpan={9} className="px-3 py-4 text-center text-gray-400 text-xs">Nothing in market.</td></tr>}
            {listed.map((r, i) => (
              <tr key={r.vistaId || i} className="border-b border-gray-100">
                <td className="px-3 py-2 font-medium text-gray-800">
                  {r.name}
                  {r.paused && <PausedBadge r={r} />}
                  <CommissionMarkers r={r} />
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{fmtDate(r.marketDate)}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-500">{r.daysOnMarket == null ? '—' : `${r.daysOnMarket}d`}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600"><DeadlineDate d={r.ioiDeadline} /></td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600"><DeadlineDate d={r.loiDeadline} /></td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600" title="Active buyers · IOIs · LOIs — live from Deal Manager.">{interestStr(r) || <span className="text-gray-400">—</span>}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{r.lead || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{r.am || '—'}</td>
                <td className={`px-3 py-2 text-right whitespace-nowrap font-medium ${r.value > 0 ? 'text-emerald-700' : 'text-gray-400'}`}>{fmtMoney(r.value)}</td>
              </tr>
            ))}
            {/* Engaged, pre-DM-listing (marketing prep) — the listing agreement
                is signed, so these count as listed money (Mark 2026-07-27);
                days-in-stage shows instead of days-on-market. */}
            {marketingPrep.map((r, i) => (
              <tr key={r.vistaId || `prep-${i}`} className="border-b border-gray-100 bg-blue-50/40">
                <td className="px-3 py-2 font-medium text-gray-800">
                  {r.name}
                  <CommissionMarkers r={r} />
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-500" title="Days since the engagement was signed (deal is in CIM/marketing prep, not yet on market).">{r.daysInStage ? `${r.daysInStage}d engaged` : 'in prep'}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400">—</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{r.lead || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{r.am || '—'}</td>
                <td className={`px-3 py-2 text-right whitespace-nowrap font-medium ${r.value > 0 ? 'text-emerald-700' : 'text-gray-400'}`}>{fmtMoney(r.value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {cpTarget && (
        <ClosingPlanModal target={cpTarget} actor={actor}
          partners={(cpPlans || []).filter(p => p.side === 'sellside' && p.vista_id && key(p.vista_id) !== key(cpTarget.vistaId || (cpTarget.plan && cpTarget.plan.vista_id))).map(p => ({ vista_id: key(p.vista_id), name: p.deal_name }))}
          onClose={() => setCpTarget(null)} onSaved={() => setCpTick()} />
      )}
    </div>
  );
};

// ─── Project Timeline (Mark's "Active Projects" sheet, computed) ─
// One row per DM listing, monthly columns, stage-colored segments — the
// hand-kept deals×months grid rebuilt from data. Segment sources, in order:
// listing dates (created_at→Listed, market_date→Marketing, ioi_deadline→LOI
// Stage, signed_loi_date→Due Diligence), the closing record (Sold month via
// vista_id), and listing_status_log for Paused / In Negotiation / returns to
// market (log born 2026-07-22 — pauses before that can't render; the LIVE
// status always paints the current month so today is never wrong). Monthly
// cells rather than the spec's weekly: at 2+ years of history weekly is
// noise at a glance — revisit if short stages get lost.
// hex mirrors the Tailwind bg class — used for split-month gradient cells
// (a mid-month stage change renders half/half, e.g. Listed|Marketing).
const TIMELINE_STAGES = {
  listed:      { label: 'Listed',        cls: 'bg-gray-300 text-gray-800',   hex: '#d1d5db' },
  marketing:   { label: 'Marketing',     cls: 'bg-yellow-300 text-gray-900', hex: '#fde047' },
  ioi:         { label: 'IOI Stage',     cls: 'bg-amber-200 text-gray-900',  hex: '#fde68a' },
  loi:         { label: 'LOI Stage',     cls: 'bg-orange-300 text-gray-900', hex: '#fdba74' },
  negotiating: { label: 'Contract Pending', cls: 'bg-orange-200 text-gray-800', hex: '#fed7aa' },
  dd:          { label: 'Due Diligence', cls: 'bg-green-300 text-gray-900',  hex: '#86efac' },
  paused:      { label: 'Pause',         cls: 'bg-blue-300 text-gray-900',   hex: '#93c5fd' },
  sold:        { label: 'Sold',          cls: 'bg-purple-600 text-white',    hex: '#9333ea' },
  dead:        { label: 'Dead',          cls: 'bg-gray-500 text-white',      hex: '#6b7280' },
};
// 'Contract Pending' = DM's rename of 'In Negotiation' (2026-07-23; legacy
// string kept). 'IOI Round' / 'Round 2' = DM's newer in-market sub-statuses.
const TIMELINE_LIVE_STATUS = { 'In Market': 'marketing', 'IOI Round': 'ioi', 'Round 2': 'loi', 'Paused': 'paused', 'Contract Pending': 'negotiating', 'In Negotiation': 'negotiating', 'Under LOI': 'dd', 'Sold': 'sold' };
// Name normalization for the sheet↔DM join (no shared id: the sheet predates
// Vista IDs in DM). Aliases patch known typos on either side; an unmatched
// sheet deal renders as its own row (safe failure = duplicate, never lost).
// Values must be in post-strip form (the alias applies AFTER suffix stripping).
const TIMELINE_NAME_ALIAS = {
  intelligentvisibliity: 'intelligentvisibility', // sheet typo
  kinzittehcnologies: 'kinzit',                   // DM typo ("Tehcnologies" dodges the suffix strip)
  mbtech: 'mb',                                   // sheet "MB Tech" vs DM "MB Technology"
};
const timelineNameKey = (s) => {
  const n = String(s || '').toLowerCase().replace(/\b(llc|inc|corp|co|group|solutions|technologies|technology)\b/g, '').replace(/[^a-z0-9]/g, '');
  return TIMELINE_NAME_ALIAS[n] || n;
};
// First-pass stage expectations for the "Now" chip (days before a deal reads
// as stuck): marketing per the stated 30–45d window; LOI ≈ the IOI+14d round
// plus negotiation; DD generously past the 90d minimum. Tune with Mark.
const TIMELINE_EXPECTED_DAYS = { marketing: 45, loi: 45, dd: 150 };

// ─── Funnel Velocity (redesigned with Mark, 2026-07-24) ─────────
// Goal · Last 5 · Last 10 · Last 20 · All-time — MEDIANS, cohorted by DEALS
// (not calendar windows: at ~20 closes a year, "last 30 days" is 1–2 deals of
// noise). Goals only where the clock is VISTA'S (rows 3/4/6); owner- and
// market-clock rows track without judgment. Rows 1–4 draw from COMPLETED FULL
// VALUATIONS ONLY (partials + stale deals never muddy the data — Mark);
// rows 5–8 from closings ∪ live listings, overlaid by the corrected-dates
// report. Lives on the TIMELINE tab (the same journey, aggregated) — Closed
// Deals keeps money and history only. Canonical goals table: workflow spec
// "Funnel-velocity goals".
const FunnelVelocityCard = ({ pipelineProjects, stageEvents, dmListings, dmClosings, dmDateOverrides }) => {
  const iso = (d) => (d ? String(d).slice(0, 10) : null);
  const days = (a, b) => {
    if (!a || !b) return null;
    const d = (new Date(b + 'T00:00:00') - new Date(a + 'T00:00:00')) / 86400000;
    return isNaN(d) || d < 0 ? null : Math.round(d);
  };
  const median = (xs) => {
    if (!xs.length) return null;
    const s = [...xs].sort((x, y) => x - y);
    return s.length % 2 ? s[(s.length - 1) / 2] : Math.round((s[s.length / 2 - 1] + s[s.length / 2]) / 2);
  };

  // Rows 1–4 source: completed FULL valuations, newest first.
  const vals = (pipelineProjects || []).filter(p => p.path === 'full_valuation' && p.valuation_date);
  // Discovery-based rows use only UNINTERRUPTED first cycles: a re-engaged or
  // revalued deal's discovery date belongs to an earlier chapter, and mixing
  // it with the new cycle's upload dates was painting 100+ day "collection"
  // medians (Mark's catch on the live card). Upload-to-upload and
  // upload-to-meeting rows keep every cycle — re-collection is real work.
  const stalledEver = new Set();
  (stageEvents || []).forEach(e => { if (e.metadata && e.metadata.to === 'stalled_returned_to_am') stalledEver.add(e.project_id); });
  const cleanVals = vals.filter(p => !p.has_prior_cycles && !stalledEver.has(p.id));
  // Analysis-complete date per project — latest stage_changed→analysis_complete
  // (activity-log era only; the row grows with every valuation).
  const analysisAt = {};
  (stageEvents || []).forEach(e => {
    if (e.metadata && e.metadata.to === 'analysis_complete') {
      const d = iso(e.at);
      if (!analysisAt[e.project_id] || d > analysisAt[e.project_id]) analysisAt[e.project_id] = d;
    }
  });

  // Rows 5–8 source: one record per deal — closings (closed) ∪ live listings,
  // report dates authoritative wherever present.
  const MONTHS = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };
  const usDate = (s) => {
    const m = /^(\w{3})\w* (\d{1,2}), (\d{4})$/.exec(String(s || '').trim());
    return (m && MONTHS[m[1]]) ? `${m[3]}-${MONTHS[m[1]]}-${String(m[2]).padStart(2, '0')}` : null;
  };
  const valuationByVista = {}, valuationByKey = {};
  (pipelineProjects || []).forEach(p => {
    if (!p.valuation_date || p.path !== 'full_valuation') return;
    const vk = String(p.vista_id || '').trim();
    if (vk && !valuationByVista[vk]) valuationByVista[vk] = iso(p.valuation_date);
    const nk = timelineNameKey(p.company_name);
    if (nk && !valuationByKey[nk]) valuationByKey[nk] = iso(p.valuation_date);
  });
  const records = {};
  const rec = (nameKey) => (records[nameKey] = records[nameKey] || {});
  (dmListings || []).forEach(l => {
    const r = rec(timelineNameKey(l.name));
    r.vista = String(l.vista_id || '').trim() || r.vista;
    r.marketing = iso(l.market_date) || r.marketing;
    r.signedLoi = iso(l.signed_loi_date) || r.signedLoi;
  });
  (dmClosings || []).forEach(c => {
    const r = rec(timelineNameKey(c.business_name));
    const imp = c.import_data || {};
    r.vista = String(c.vista_id || '').trim() || r.vista;
    r.listed = usDate(imp['Listing Date']) || r.listed;
    r.marketing = iso(c.marketing_date) || r.marketing;
    r.signedLoi = iso(c.signed_loi_date) || r.signedLoi;
    r.close = iso(c.closing_date) || r.close;
  });
  (((dmDateOverrides && dmDateOverrides.deals) || [])).forEach(od => {
    const r = rec(timelineNameKey(od.name));
    if (od.listed) r.listed = od.listed;       // the report is the truth where present
    if (od.marketing) r.marketing = od.marketing;
    if (od.signedLoi) r.signedLoi = od.signedLoi;
    if (od.valuationDate) r.reportValuation = od.valuationDate;
  });
  const marketDeals = Object.entries(records).map(([k, r]) => ({
    ...r, valuationDate: (r.vista && valuationByVista[r.vista]) || valuationByKey[k] || r.reportValuation || null,
  }));

  // Historical collection dates from the report (v3, 2026-07-24): deals with
  // no VT record contribute to the upload/meeting hops — VT wins on overlap.
  // Deliberately NOT fed to row 1 (the report has no discovery date) nor to
  // the CONVERSION gates (the report only contains listed/sold deals —
  // survivor bias would flatter every rate).
  const vtKeys = new Set((pipelineProjects || []).map(p => timelineNameKey(p.company_name)));
  const reportColl = (((dmDateOverrides && dmDateOverrides.deals) || []))
    .filter(od => !vtKeys.has(timelineNameKey(od.name)));

  // Hop definitions: [label, goalDays|null, samples [{d, end}]].
  const sample = (a, b) => (a && b && days(a, b) != null ? { d: days(a, b), end: b } : null);
  const hops = [
    ['Discovery meeting → Upload started', null, [
      ...cleanVals.map(p => sample(iso(p.discovery_meeting_date), iso(p.upload_started_date))),
      ...reportColl.map(od => sample(od.discovery, od.uploadStarted)),
    ]],
    ['Upload started → Upload complete', null, [
      ...vals.map(p => sample(iso(p.upload_started_date), iso(p.upload_complete_date))),
      ...reportColl.map(od => sample(od.uploadStarted, od.uploadComplete)),
    ]],
    ['Discovery meeting → Upload complete (whole collection)', null, [
      ...cleanVals.map(p => sample(iso(p.discovery_meeting_date), iso(p.upload_complete_date))),
      ...reportColl.map(od => sample(od.discovery, od.uploadComplete)),
    ]],
    ['Upload complete → Valuation meeting', 7, [
      ...vals.map(p => sample(iso(p.upload_complete_date), iso(p.valuation_date))),
      ...reportColl.map(od => sample(od.uploadComplete, od.valuationDate)),
    ]],
    ['Valuation complete → Valuation meeting', 2, vals.map(p => sample(analysisAt[p.id], iso(p.valuation_date)))],
    ['Valuation meeting → Listing', null, marketDeals.map(r => sample(r.valuationDate, r.listed))],
    ['Listing → Marketing', 7, marketDeals.map(r => sample(r.listed, r.marketing))],
    ['Marketing → Signed LOI', null, marketDeals.map(r => sample(r.marketing, r.signedLoi))],
    ['Signed LOI → Close', null, marketDeals.map(r => sample(r.signedLoi, r.close))],
  ].map(([label, goal, ss]) => {
    const samples = ss.filter(Boolean).sort((a, b) => (a.end > b.end ? -1 : 1)); // newest first
    // A cohort only exists when there are MORE deals than its window —
    // otherwise it silently equals All-time and reads as a broken column
    // (Mark's catch: identical Last 10 / Last 20 everywhere).
    const cohort = (n) => (samples.length > n ? median(samples.slice(0, n).map(s => s.d)) : null);
    return { label, goal, n: samples.length, last5: cohort(5), last10: cohort(10), last20: cohort(20), all: median(samples.map(s => s.d)) };
  }).map(h => {
    // One trend verdict per row (Mark 2026-07-24): newest cohort vs LAST 20
    // (Mark's call — recent-vs-recent beats recent-vs-decade; all-time is the
    // fallback base while a hop is thin), ±10% dead zone so noise doesn't flap.
    const cur = h.last5 != null ? h.last5 : h.last10 != null ? h.last10 : h.last20;
    const base = h.last20 != null ? h.last20 : h.all;
    const baseName = h.last20 != null ? 'Last 20' : 'all-time';
    let trend = null;
    if (cur != null && base != null && base > 0 && cur !== base) {
      const rel = (cur - base) / base;
      if (Math.abs(rel) < 0.1) trend = { t: 'steady', txt: '→ steady', baseName };
      else if (cur < base) trend = { t: 'good', txt: `▼ ${base - cur}d faster`, baseName };
      else trend = { t: 'bad', txt: `▲ ${cur - base}d slower`, baseName };
    } else if (cur != null && base != null) {
      trend = { t: 'steady', txt: '→ steady', baseName };
    }
    return { ...h, trend };
  });

  const cell = (v, extra = '') => (v == null ? <span className="text-gray-300">—</span> : <span className={extra}>{v}</span>);
  const verdict = (h) => {
    if (h.goal == null || h.last5 == null) return '';
    if (h.last5 <= h.goal) return 'text-emerald-700 font-bold';
    if (h.last5 <= h.goal * 1.5) return 'text-amber-600 font-bold';
    return 'text-red-600 font-bold';
  };
  const Th = ({ children, numeric }) => <th className={`px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 ${numeric ? 'text-right' : 'text-left'}`}>{children}</th>;
  return (
    <div className="bg-white border border-gray-200 rounded-lg mt-6 overflow-hidden">
      <div className="px-4 py-3 border-b bg-gray-50 flex items-baseline gap-2 flex-wrap">
        <div className="text-sm font-bold text-gray-800">⏱ Funnel velocity</div>
        <div className="text-xs text-gray-500">median days per hop, cohorted by deals (newest first) · completed full valuations only — partials and stale deals never muddy the data · goals only where the clock is Vista's</div>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="border-b bg-gray-50"><Th>Hop</Th><Th numeric>Goal</Th><Th numeric>Last 5</Th><Th numeric>Last 10</Th><Th numeric>Last 20</Th><Th numeric>All-time</Th><Th>Trend</Th></tr></thead>
        <tbody>
          {hops.map(h => (
            <tr key={h.label} className="border-b border-gray-100" title={`${h.n} deal${h.n === 1 ? '' : 's'} carry both dates for this hop`}>
              <td className="px-3 py-2 text-gray-700">{h.label}</td>
              <td className={`px-3 py-2 text-right whitespace-nowrap ${h.goal != null ? 'font-semibold text-gray-800' : 'text-gray-300'}`}>{h.goal != null ? `${h.goal}d` : 'track'}</td>
              <td className="px-3 py-2 text-right">{cell(h.last5, verdict(h))}</td>
              <td className="px-3 py-2 text-right text-gray-700">{cell(h.last10)}</td>
              <td className="px-3 py-2 text-right text-gray-700">{cell(h.last20)}</td>
              <td className="px-3 py-2 text-right text-gray-500">{h.all == null ? <span className="text-gray-300">—</span> : <span>{h.all}<span className="text-[10px] text-gray-400"> · {h.n} deal{h.n === 1 ? '' : 's'}</span></span>}</td>
              <td className="px-3 py-2 whitespace-nowrap text-xs font-semibold">
                {h.trend == null ? <span className="text-gray-300">—</span>
                  : <span className={h.trend.t === 'good' ? 'text-emerald-700' : h.trend.t === 'bad' ? 'text-red-600' : 'text-gray-400'} title={`Newest cohort vs ${h.trend.baseName} (±10% reads as steady)`}>{h.trend.txt}</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="px-4 py-2 text-[11px] text-gray-400 border-t bg-gray-50">Read a row left-to-right: falling numbers = getting faster. The colored Last-5 cell judges against the goal (green ≤ goal · amber ≤ 1.5× · red beyond). "Valuation complete → meeting" starts thin — its dates come from the stage log, which began with VT.</div>
    </div>
  );
};

// ─── Funnel Conversion (Mark 2026-07-24: "add them all") ────────
// Velocity measures the SPEED of deals that made it; this measures WHO MAKES
// IT — each gate as a pass %, plus the recovery/outcome/engagement metrics
// from the same design session. MATURITY GUARD: a deal only counts against a
// gate once its entry is >60 days old (or it passed) — otherwise every fresh
// deal reads as a failure. Cohorts by deals, newest first, like velocity.
const FunnelConversionCard = ({ pipelineProjects, stageEvents, ownerEngagement, dmListings, dmClosings, dmSheetHistory }) => {
  const iso = (d) => (d ? String(d).slice(0, 10) : null);
  const todayIso = new Date().toISOString().slice(0, 10);
  const daysAgo = (d) => Math.round((new Date(todayIso + 'T00:00:00') - new Date(d + 'T00:00:00')) / 86400000);
  const MATURITY = 60;

  // Stage-event derived sets: ever-engaged, stalled entries, re-engaged after.
  const ACTIVE_AFTER_STALL = new Set(['awaiting_upload', 'upload_started', 'upload_complete', 'data_entry_complete', 'adjustments_entered', 'analysis_complete', 'val_meeting_set', 'awaiting_decision', 'engaged']);
  const engagedEver = new Set();
  const stallEntry = {};
  (stageEvents || []).forEach(e => {
    const to = e.metadata && e.metadata.to;
    if (to === 'engaged') engagedEver.add(e.project_id);
    if (to === 'stalled_returned_to_am' && !stallEntry[e.project_id]) stallEntry[e.project_id] = iso(e.at);
  });
  const reengaged = new Set();
  (stageEvents || []).forEach(e => {
    const to = e.metadata && e.metadata.to;
    if (stallEntry[e.project_id] && to && ACTIVE_AFTER_STALL.has(to) && iso(e.at) > stallEntry[e.project_id]) reengaged.add(e.project_id);
  });
  (pipelineProjects || []).forEach(p => { if (p.workflow_stage === 'engaged') engagedEver.add(p.id); });

  // Zoho-imported valued-active deals (version 'zoho-import') are EXCLUDED:
  // they carry discovery/valuation dates but their uploads and engagements
  // happened outside VT — they'd sit in the gates as false failures. Worse,
  // that import deliberately contains only the NOT-engaged cohort, so the
  // decision gate would inherit a built-in downward bias. (Mark's audit
  // question, 2026-07-24.)
  const fulls = (pipelineProjects || []).filter(p => p.path === 'full_valuation' && p.version !== 'zoho-import');
  const partials = (pipelineProjects || []).filter(p => p.path === 'partial' && p.version !== 'zoho-import');

  // A gate sample: {entry, passed}; immature un-passed deals are excluded.
  const gate = (rows, entryF, passF) => rows
    .map(r => {
      const entry = entryF(r);
      if (!entry) return null;
      const passed = !!passF(r);
      if (!passed && daysAgo(entry) < MATURITY) return null;
      return { entry, passed };
    })
    .filter(Boolean)
    .sort((a, b) => (a.entry > b.entry ? -1 : 1));
  const pct = (samples, n) => {
    // A cohort only exists when there are more deals than its window —
    // otherwise it equals All-time and reads as a broken column.
    if (n && samples.length <= n) return null;
    const s = n ? samples.slice(0, n) : samples;
    if (s.length === 0) return null;
    return { p: Math.round((100 * s.filter(x => x.passed).length) / s.length), n: s.length };
  };

  // Listing outcomes — RESOLVED listings only (sold or dead): sheet history
  // (30 deads live there) + closings + any DM listing now marked Dead.
  const outcomeSamples = (() => {
    const out = [];
    const seen = new Set();
    (((dmSheetHistory && dmSheetHistory.deals) || [])).forEach(sd => {
      const cells = Object.values(sd.cells);
      const sold = cells.includes('sold'), dead = cells.includes('dead');
      if (!sold && !dead) return;
      const months = Object.keys(sd.cells).sort();
      out.push({ entry: months[months.length - 1] + '-28', passed: sold });
      seen.add(timelineNameKey(sd.name));
    });
    (dmClosings || []).forEach(c => {
      const k = timelineNameKey(c.business_name);
      if (c.closing_date && !seen.has(k)) { out.push({ entry: iso(c.closing_date), passed: true }); seen.add(k); }
    });
    (dmListings || []).forEach(l => {
      const k = timelineNameKey(l.name);
      if (l.status === 'Dead' && !seen.has(k)) { out.push({ entry: todayIso, passed: false }); seen.add(k); }
    });
    return out.sort((a, b) => (a.entry > b.entry ? -1 : 1));
  })();

  // Signed-LOI outcomes — the fall-through rate (loi_signed import,
  // 2026-07-27; replaces the placeholder row). One sample per signing with a
  // KNOWN outcome: closed (passed) vs fell back to market / died (failed).
  // Current under-LOI deals are unresolved and deliberately absent. In the
  // sheet's language a SIGNED LOI = entry into 'dd' (Due Diligence) — 'loi'
  // is the pre-signature offer round. Sources dedupe by name + date
  // proximity, day precision first:
  //  · closings with signed_loi_date → passed (they closed);
  //  · DM listings with a signed LOI now marked Dead → failed;
  //  · sheet dd-run starts → outcome = the next non-dd, non-pause stage
  //    (sold → passed; marketing/listed/ioi/loi/dead → failed); a trailing
  //    dd at the sheet freeze resolves via closings or stays out.
  const loiOutcomeSamples = (() => {
    const out = [];
    const byKey = {};
    const near = (k, d, days) => (byKey[k] || []).some(x => Math.abs(new Date(x) - new Date(d)) / 86400000 <= days);
    const push = (k, entry, passed) => { out.push({ entry, passed }); (byKey[k] = byKey[k] || []).push(entry); };
    const closedKeys = new Set((dmClosings || []).map(c => timelineNameKey(c.business_name)));
    (dmClosings || []).forEach(c => {
      if (!c.signed_loi_date) return;
      push(timelineNameKey(c.business_name), iso(c.signed_loi_date), true);
    });
    (dmListings || []).forEach(l => {
      if (!l.signed_loi_date || l.status !== 'Dead') return;
      const k = timelineNameKey(l.name);
      if (!near(k, iso(l.signed_loi_date), 75)) push(k, iso(l.signed_loi_date), false);
    });
    (((dmSheetHistory && dmSheetHistory.deals) || [])).forEach(sd => {
      const k = timelineNameKey(sd.name);
      const months = Object.keys(sd.cells).sort();
      let prev = null;
      months.forEach((m, i) => {
        const s = sd.cells[m];
        if (s === 'dd' && prev !== 'dd') {
          let outcome = null;
          for (let j = i + 1; j < months.length; j++) {
            const st = sd.cells[months[j]];
            if (st !== 'dd' && st !== 'paused') { outcome = st; break; }
          }
          if (outcome == null && closedKeys.has(k)) outcome = 'sold';
          const entry = m + '-15';
          if (outcome != null && !near(k, entry, 75)) push(k, entry, outcome === 'sold');
        }
        prev = s;
      });
    });
    return out.sort((a, b) => (a.entry > b.entry ? -1 : 1));
  })();

  const rows = [
    { group: 'Collection', label: 'Discovery held → started uploading', s: gate(fulls, p => iso(p.discovery_meeting_date), p => p.upload_started_date) },
    { group: 'Collection', label: 'Started uploading → completed (the go-stale gate)', s: gate(fulls, p => iso(p.upload_started_date), p => p.upload_complete_date) },
    { group: 'Collection', label: 'Upload complete → valuation meeting held', s: gate(fulls, p => iso(p.upload_complete_date), p => p.valuation_date) },
    { group: 'Decision', label: 'Valuation meeting → engaged (full valuations)', s: gate(fulls, p => iso(p.valuation_date), p => engagedEver.has(p.id)) },
    { group: 'Decision', label: 'Valuation meeting → engaged (partials / quick estimates)', s: gate(partials, p => iso(p.valuation_date), p => engagedEver.has(p.id)) },
    { group: 'Recovery & outcomes', label: 'Stalled → later re-engaged', s: gate(Object.entries(stallEntry).map(([id, d]) => ({ id, d })), r => r.d, r => reengaged.has(r.id)) },
    { group: 'Recovery & outcomes', label: 'Listed → sold (of resolved listings)', s: outcomeSamples },
    { group: 'Recovery & outcomes', label: 'Signed LOI → closed (fall-through rate)', s: loiOutcomeSamples },
  ];

  // Owner-engagement latency: intro email → first portal activity.
  const latency = (() => {
    if (!ownerEngagement) return null;
    const ds = [];
    let quiet = 0, quietDen = 0;
    Object.entries(ownerEngagement.intro).forEach(([pid, at]) => {
      const sent = iso(at);
      const resp = ownerEngagement.firstResp[pid] ? iso(ownerEngagement.firstResp[pid]) : null;
      if (resp && resp >= sent) ds.push({ end: resp, d: Math.round((new Date(resp + 'T00:00:00') - new Date(sent + 'T00:00:00')) / 86400000) });
      if (daysAgo(sent) >= 30) { quietDen++; if (!resp) quiet++; }
    });
    ds.sort((a, b) => (a.end > b.end ? -1 : 1));
    const med = (xs) => { if (!xs.length) return null; const s = [...xs].sort((x, y) => x - y); return s.length % 2 ? s[(s.length - 1) / 2] : Math.round((s[s.length / 2 - 1] + s[s.length / 2]) / 2); };
    return { med10: med(ds.slice(0, 10).map(x => x.d)), medAll: med(ds.map(x => x.d)), n: ds.length, quietPct: quietDen ? Math.round((100 * quiet) / quietDen) : null, quietDen };
  })();

  const cell = (v) => (v == null ? <span className="text-gray-300">—</span> : <span title={`${v.n} deal${v.n === 1 ? '' : 's'} in this cohort`}>{v.p}%</span>);
  const Th = ({ children, numeric }) => <th className={`px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 ${numeric ? 'text-right' : 'text-left'}`}>{children}</th>;
  let lastGroup = null;
  return (
    <div className="bg-white border border-gray-200 rounded-lg mt-6 overflow-hidden">
      <div className="px-4 py-3 border-b bg-gray-50 flex items-baseline gap-2 flex-wrap">
        <div className="text-sm font-bold text-gray-800">🚪 Funnel conversion</div>
        <div className="text-xs text-gray-500">who makes it through each gate — velocity's companion · a deal only counts once its gate entry is &gt;{MATURITY} days old (or it passed), so fresh deals never read as failures</div>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="border-b bg-gray-50"><Th>Gate</Th><Th numeric>Last 10</Th><Th numeric>Last 20</Th><Th numeric>All-time</Th><Th>Trend</Th></tr></thead>
        <tbody>
          {rows.map(r => {
            const groupRow = r.group !== lastGroup
              ? <tr key={'g' + r.group}><td colSpan={5} className="px-3 pt-2 pb-1 text-[10px] font-bold uppercase tracking-wide text-gray-400 bg-gray-50">{r.group}</td></tr>
              : null;
            lastGroup = r.group;
            // Newest existing cohort vs Last 20 (all-time fallback while
            // thin); ±5 points reads as steady.
            const cur = pct(r.s, 10);
            const base = pct(r.s, 20) || pct(r.s);
            let trend = null;
            if (cur && base) {
              const d = cur.p - base.p;
              if (Math.abs(d) < 5) trend = { t: 'steady', txt: '→ steady' };
              else if (d > 0) trend = { t: 'good', txt: `▲ +${d} pts` };
              else trend = { t: 'bad', txt: `▼ ${d} pts` };
            }
            return (
              <React.Fragment key={r.label}>
                {groupRow}
                <tr className="border-b border-gray-100">
                  <td className="px-3 py-2 text-gray-700">{r.label}</td>
                  <td className="px-3 py-2 text-right font-medium">{cell(pct(r.s, 10))}</td>
                  <td className="px-3 py-2 text-right text-gray-700">{cell(pct(r.s, 20))}</td>
                  <td className="px-3 py-2 text-right text-gray-500">{(() => { const v = pct(r.s); return v == null ? <span className="text-gray-300">—</span> : <span>{v.p}%<span className="text-[10px] text-gray-400"> · {v.n} deal{v.n === 1 ? '' : 's'}</span></span>; })()}</td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs font-semibold">
                    {trend == null ? <span className="text-gray-300">—</span>
                      : <span className={trend.t === 'good' ? 'text-emerald-700' : trend.t === 'bad' ? 'text-red-600' : 'text-gray-400'} title="Newest cohort vs all-time (±5 points reads as steady)">{trend.txt}</span>}
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
          <tr><td colSpan={5} className="px-3 pt-2 pb-1 text-[10px] font-bold uppercase tracking-wide text-gray-400 bg-gray-50">Owner engagement</td></tr>
          <tr className="border-b border-gray-100">
            <td className="px-3 py-2 text-gray-700">Intro email → first portal activity</td>
            {latency && latency.n > 0 ? (
              <React.Fragment>
                <td className="px-3 py-2 text-right font-medium" title={`${Math.min(10, latency.n)} most recent responders`}>{latency.med10 != null ? `${latency.med10}d` : '—'}</td>
                <td className="px-3 py-2 text-right text-gray-500" title={`${latency.n} responders all-time`}>{latency.medAll != null ? `${latency.medAll}d` : '—'}</td>
                <td className="px-3 py-2 text-right text-gray-500" title={`of ${latency.quietDen} intros sent 30+ days ago`}>{latency.quietPct != null ? `${latency.quietPct}% quiet` : '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap text-xs font-semibold">
                  {(latency.med10 != null && latency.medAll != null && latency.n > 10)
                    ? <span className={latency.med10 < latency.medAll ? 'text-emerald-700' : latency.med10 > latency.medAll ? 'text-red-600' : 'text-gray-400'}>{latency.med10 < latency.medAll ? '▼ faster' : latency.med10 > latency.medAll ? '▲ slower' : '→ steady'}</span>
                    : <span className="text-gray-300">—</span>}
                </td>
              </React.Fragment>
            ) : (
              <td colSpan={4} className="px-3 py-2 text-right text-gray-300">— fills as intro sends accumulate (logged since 2026-06-24)</td>
            )}
          </tr>
        </tbody>
      </table>
      <div className="px-4 py-2 text-[11px] text-gray-400 border-t bg-gray-50">Collection + decision gates: completed-path deals of each type; stalls and deaths are the failures — that's the point. "Listed → sold" and "Signed LOI → closed" count resolved outcomes only (sold/closed or fell through; still-active deals aren't judged — current under-LOI deals appear once they resolve). Hover any cell for its sample size. The latency row shows median days to first portal activity (Last 10 · All) and the share of owners still silent 30+ days after their intro.</div>
    </div>
  );
};
// Same-date tiebreaker for breakpoint sorting: when a listing's row was
// created the SAME DAY marketing started (the DM norm), an unstable sort put
// Listed after Marketing and painted the stages out of order.
const TIMELINE_STAGE_RANK = { listed: 0, marketing: 1, ioi: 2, loi: 3, negotiating: 4, dd: 5, paused: 6, sold: 7, dead: 8 };
const ProjectTimelineView = ({ dmListings, dmClosings, dmStatusLog, dmSheetHistory, dmDateOverrides, pipelineProjects, stageEvents, ownerEngagement }) => {
  const [showAll, setShowAll] = React.useState(false);
  const [sortMode, setSortMode] = React.useState('start'); // 'start' = oldest listing first (Mark's default — the sheet's read) | 'stuck' = longest-in-stage first
  const [showEnded, setShowEnded] = React.useState(false);
  // Default the horizontal scroll to the RIGHT edge (now), not 2017. Second
  // pass after a beat: the sticky column + table can widen after first paint,
  // which would leave the first scroll short of the true right edge.
  const scrollRef = React.useRef(null);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollLeft = el.scrollWidth;
    const t = setTimeout(() => { el.scrollLeft = el.scrollWidth; }, 60);
    return () => clearTimeout(t);
  }, [showAll, dmListings, dmSheetHistory, dmDateOverrides]);
  if (dmListings === null) {
    return <div className="bg-red-50 border border-red-200 text-red-700 rounded p-4 text-sm">⚠ Deal Manager data unavailable — the timeline reads DM's listings. Reload, or check the server logs.</div>;
  }
  const iso = (d) => (d ? String(d).slice(0, 10) : null);
  const todayIso = new Date().toISOString().slice(0, 10);
  const thisMonth = todayIso.slice(0, 7);
  // Month arithmetic on 'YYYY-MM' keys.
  const monthAdd = (ym, n) => {
    const y = Number(ym.slice(0, 4)), m = Number(ym.slice(5, 7)) - 1 + n;
    const d = new Date(y, m, 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  };
  const monthEnd = (ym) => {
    const y = Number(ym.slice(0, 4)), m = Number(ym.slice(5, 7));
    return `${ym}-${String(new Date(y, m, 0).getDate()).padStart(2, '0')}`;
  };
  const monthLabel = (ym) => new Date(ym + '-01T00:00:00').toLocaleDateString('en-US', { month: 'short' }) + '-' + ym.slice(2, 4);

  const closeByVista = {};
  (dmClosings || []).forEach(c => { const k = String(c.vista_id || '').trim(); if (k && c.closing_date && !closeByVista[k]) closeByVista[k] = iso(c.closing_date); });
  const logByListing = {};
  (dmStatusLog || []).forEach(r => { (logByListing[r.listing_id] = logByListing[r.listing_id] || []).push(r); });

  // Sheet history: the hand-kept Active Projects grid (2017 → 2026-02), the
  // AUTHORITY for the months it covers. Matched to DM listings by normalized
  // name (exact, then contains); DM-computed breakpoints only apply AFTER the
  // deal's last sheet month, so bad DM backfill dates can't repaint history.
  const sheetDeals = (dmSheetHistory && dmSheetHistory.deals) || [];
  const sheetByKey = {};
  sheetDeals.forEach(sd => { sheetByKey[timelineNameKey(sd.name)] = sd; });
  const usedSheetKeys = new Set();
  const findSheet = (name) => {
    const k = timelineNameKey(name);
    if (sheetByKey[k]) { usedSheetKeys.add(k); return sheetByKey[k]; }
    if (k.length >= 6) {
      const hit = Object.keys(sheetByKey).find(sk => sk.length >= 6 && (sk.includes(k) || k.includes(sk)));
      if (hit) { usedSheetKeys.add(hit); return sheetByKey[hit]; }
    }
    return null;
  };
  const sheetBreakpoints = (sd) => {
    const ms = Object.keys(sd.cells).sort();
    const bp = [];
    let prev = null;
    ms.forEach(m => { const s = sd.cells[m]; if (s !== prev) { bp.push({ d: m + '-01', s }); prev = s; } });
    return { bp, firstMonth: ms[0], lastMonth: ms[ms.length - 1], lastStage: sd.cells[ms[ms.length - 1]] };
  };

  // Mark's correct-dates report (2026-07-24): the AUTHORITATIVE breakpoint
  // skeleton wherever it covers a deal — it outranks both the sheet and the
  // listing's own dates (DM's created_at is app-onboarding, not listing).
  const ovDeals = (dmDateOverrides && dmDateOverrides.deals) || [];
  const ovByKey = {};
  ovDeals.forEach(od => { ovByKey[timelineNameKey(od.name)] = od; });
  const usedOvKeys = new Set();
  const findOverride = (name) => {
    const k = timelineNameKey(name);
    if (ovByKey[k]) { usedOvKeys.add(k); return ovByKey[k]; }
    if (k.length >= 6) {
      const hit = Object.keys(ovByKey).find(ok => ok.length >= 6 && (ok.includes(k) || k.includes(ok)));
      if (hit) { usedOvKeys.add(hit); return ovByKey[hit]; }
    }
    return null;
  };
  // Report dates → breakpoints, mapped to the two-round process: marketing
  // runs to the IOI deadline, IOI review/mgmt meetings to the LOI deadline,
  // Round-2 LOIs to signature, diligence after.
  const overrideBreakpoints = (od) => {
    const bp = [];
    if (od.listed) bp.push({ d: od.listed, s: 'listed' });
    if (od.marketing) bp.push({ d: od.marketing, s: 'marketing' });
    if (od.ioi) bp.push({ d: od.ioi, s: 'ioi' });
    if (od.loiDeadline) bp.push({ d: od.loiDeadline, s: 'loi' });
    if (od.signedLoi) bp.push({ d: od.signedLoi, s: 'dd' });
    return bp;
  };

  const listingRows = (dmListings || []).map(l => {
    const ov = findOverride(l.name);
    // Always consume the sheet key (even when the report outranks it) so the
    // deal's sheet history can't render as a duplicate row below.
    const sheetDeal = findSheet(l.name);
    const sh = (!ov && sheetDeal) ? sheetBreakpoints(sheetDeal) : null;
    const dmStart = iso(l.created_at) || iso(l.market_date);
    if (!ov && !sh && !dmStart) return null; // nothing datable anywhere
    const soldDate = closeByVista[String(l.vista_id || '').trim()]
      || (l.status === 'Sold' ? (iso(l.projected_close_date) || iso(l.signed_loi_date) || todayIso) : null);
    let bp, cutoff;
    if (ov) {
      bp = overrideBreakpoints(ov);
      cutoff = bp.length ? bp[bp.length - 1].d : '0000'; // log/live refinements only after the report's coverage
    } else {
      // DM-computed breakpoints — only the ones dated after the sheet's coverage.
      cutoff = sh ? monthEnd(sh.lastMonth) : '0000';
      bp = sh ? [...sh.bp] : [];
      const pushDm = (d, s) => { if (d && d > cutoff) bp.push({ d, s }); };
      pushDm(iso(l.market_date), 'marketing');
      pushDm(iso(l.ioi_deadline), 'loi');
      pushDm(iso(l.signed_loi_date), 'dd');
      // The 'Listed' start (DM row creation) only counts when it PRECEDES every
      // real date — the DM row is often created long after the deal actually
      // listed (the app went live 2026-03), and a late created_at would paint a
      // bogus "Listed" flip over real marketing/LOI months.
      if (!sh && dmStart) {
        const earliest = bp.length ? bp.reduce((m, b) => (b.d < m ? b.d : m), '9999') : null;
        if (!earliest || dmStart <= earliest) bp.push({ d: dmStart, s: 'listed' });
      }
    }
    (logByListing[l.id] || []).forEach(r => {
      const s = TIMELINE_LIVE_STATUS[r.to_status];
      if (s && s !== 'sold' && iso(r.changed_at) > cutoff) bp.push({ d: iso(r.changed_at), s });
    });
    if (soldDate) bp.push({ d: soldDate, s: 'sold' });
    // Same-date breakpoints order by stage progression — when the row was
    // created the SAME DAY marketing started (the DM norm), the old unstable
    // sort could put Listed after Marketing and paint the stages backwards.
    // (No dedupe beyond this: the sheet has genuine re-listings — a deal
    // pulled back from market to Listed is real history, not noise.)
    bp.sort((a, b) => (a.d !== b.d ? (a.d < b.d ? -1 : 1) : (TIMELINE_STAGE_RANK[a.s] || 0) - (TIMELINE_STAGE_RANK[b.s] || 0)));
    if (!bp.length) return null;
    const start = bp[0].d;
    return {
      key: 'l' + l.id, name: l.name, lead: l.lead, status: l.status, vistaId: l.vista_id, live: true,
      soldDate, bp, startMonth: start.slice(0, 7), endMonth: (soldDate || todayIso).slice(0, 7),
    };
  }).filter(Boolean);

  // Sheet-only deals (no DM listing matched): history rows — sold, dead, or
  // deals whose DM name didn't match (those show truncated at the sheet's
  // last month; add a TIMELINE_NAME_ALIAS entry to merge them).
  const sheetOnlyRows = sheetDeals.filter(sd => !usedSheetKeys.has(timelineNameKey(sd.name))).map(sd => {
    const sh = sheetBreakpoints(sd);
    return {
      key: 's' + sd.name, name: sd.name, lead: null, status: 'sheet history', vistaId: null, live: false,
      soldDate: null, bp: sh.bp, startMonth: sh.firstMonth, endMonth: sh.lastMonth,
    };
  });

  // Report deals with no DM listing and no sheet row (e.g. brand-new listings
  // DM hasn't onboarded, or post-sheet solds with no listing) still render,
  // from the report's dates alone.
  const overrideOnlyRows = ovDeals.filter(od => {
    const k = timelineNameKey(od.name);
    if (usedOvKeys.has(k)) return false;
    if (sheetByKey[k]) return false; // sheet history covers it
    if (k.length >= 6 && Object.keys(sheetByKey).some(sk => sk.length >= 6 && (sk.includes(k) || k.includes(sk)))) return false;
    return true;
  }).map(od => {
    const bp = overrideBreakpoints(od);
    if (!bp.length) return null;
    const sold = od.status === 'Sold by Vista';
    return {
      key: 'o' + od.name, name: od.name, lead: null, status: od.status + ' (report)', vistaId: null,
      live: false, reportActive: !sold, soldDate: null, bp,
      startMonth: bp[0].d.slice(0, 7),
      endMonth: sold ? bp[bp.length - 1].d.slice(0, 7) : thisMonth,
    };
  }).filter(Boolean);

  const baseRows = [...listingRows, ...sheetOnlyRows, ...overrideOnlyRows].sort((a, b) => (a.startMonth < b.startMonth ? -1 : 1));
  if (baseRows.length === 0) {
    return <div className="text-sm text-gray-500 py-8 text-center">No datable listings yet — the timeline needs a created/marketing date on the DM listing.</div>;
  }

  // "Now" info per row: current stage, when its run began (walking the trailing
  // run of same-stage breakpoints), days in it. Ended = sold/dead/sheet-frozen.
  const rows = baseRows.map(r => {
    const lastBp = r.bp[r.bp.length - 1];
    let cur = lastBp ? lastBp.s : null;
    if (r.live && !r.soldDate) cur = TIMELINE_LIVE_STATUS[r.status] || cur;
    let since = null;
    if (lastBp && cur === lastBp.s) {
      let i = r.bp.length - 1;
      while (i > 0 && r.bp[i - 1].s === cur) i--;
      since = r.bp[i].d;
    }
    const ended = (!r.live && !r.reportActive) || !!r.soldDate || cur === 'sold' || cur === 'dead';
    const daysInStage = (!ended && since)
      ? Math.round((new Date(todayIso + 'T00:00:00') - new Date(since + 'T00:00:00')) / 86400000)
      : null;
    return { ...r, currentStage: cur, daysInStage, ended };
  });

  // Column range: everything, or the last 36 months (default).
  const globalFirst = rows.reduce((m, r) => (r.startMonth < m ? r.startMonth : m), thisMonth);
  const floorMonth = monthAdd(thisMonth, -36);
  const firstMonth = showAll ? globalFirst : (globalFirst < floorMonth ? floorMonth : globalFirst);
  const months = [];
  for (let m = firstMonth; m <= thisMonth; m = monthAdd(m, 1)) months.push(m);

  // Active book on top (default: longest-in-current-stage first — the "stuck"
  // read this chart exists for); Sold/Dead/history collapsed below.
  const activeRows = rows.filter(r => !r.ended && r.endMonth >= firstMonth);
  if (sortMode === 'stuck') activeRows.sort((a, b) => (b.daysInStage || 0) - (a.daysInStage || 0));
  const endedRows = rows.filter(r => r.ended && r.endMonth >= firstMonth).sort((a, b) => (a.endMonth > b.endMonth ? -1 : 1));

  // A month cell has an opening stage and a closing stage. Equal → solid
  // cell; different (a real mid-month transition) → split half/half (Mark's
  // ask: list + market in one month shows half gray, half yellow). Sheet-era
  // breakpoints sit on the 1st (the sheet's grain IS the month), so they
  // count as month-OPENING transitions and those months stay solid.
  const stagesFor = (r, ym) => {
    if (ym < r.startMonth || ym > r.endMonth) return null;
    const mStart = ym + '-01';
    const end = monthEnd(ym);
    let atStart = null, atEnd = null;
    r.bp.forEach(b => {
      if (b.d <= mStart) atStart = b.s;
      if (b.d <= end) atEnd = b.s;
    });
    // Row begins this month: the first breakpoint inside the month opens it.
    if (!atStart) {
      const first = r.bp.find(b => b.d >= mStart && b.d <= end);
      atStart = first ? first.s : atEnd;
    }
    // The live DM status always wins for the current month, so a missing log
    // row or date can't paint "today" wrong.
    if (ym === thisMonth && r.live && !r.soldDate) atEnd = TIMELINE_LIVE_STATUS[r.status] || atEnd;
    return { a: atStart, b: atEnd };
  };

  return (
    <div>
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-3">
        <div className="text-xs text-gray-500">One row per deal, oldest first. Months through {dmSheetHistory ? monthLabel(dmSheetHistory.lastMonth) : 'the sheet era'} come from the hand-kept Active Projects sheet (imported 2026-07-23, now frozen); Deal Manager dates, the closing record, and the status log paint everything after. The current month always shows the live DM status.</div>
        <div className="flex items-center gap-2 flex-wrap">
          {Object.values(TIMELINE_STAGES).map(s => (
            <span key={s.label} className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${s.cls}`}>{s.label}</span>
          ))}
          <button type="button" onClick={() => setShowAll(v => !v)}
            className="text-xs font-semibold px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-100">
            {showAll ? '↔ Last 3 years' : `↔ Everything (${(dmSheetHistory && dmSheetHistory.firstMonth) ? monthLabel(dmSheetHistory.firstMonth) + ' →' : 'all history'})`}
          </button>
          <button type="button" onClick={() => setSortMode(m => (m === 'stuck' ? 'start' : 'stuck'))}
            className="text-xs font-semibold px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-100"
            title="Sort the active book">
            {sortMode === 'stuck' ? '⇅ Longest in stage first' : '⇅ Oldest first'}
          </button>
        </div>
      </div>
      <div ref={scrollRef} className="bg-white border border-gray-200 rounded-lg overflow-x-auto">
        <table className="text-sm" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
          <thead>
            <tr>
              <th className="sticky left-0 bg-gray-50 border-b px-3 py-2 text-left text-xs font-bold uppercase tracking-wide text-gray-600 whitespace-nowrap z-10">Business</th>
              {months.map(m => (
                <th key={m} className={`border-b px-1 py-2 text-[10px] font-bold whitespace-nowrap ${m.slice(5, 7) === '01' ? 'text-gray-800 bg-gray-100' : 'text-gray-500 bg-gray-50'}`}>{monthLabel(m)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(() => {
              const nowChip = (r) => {
                if (!r.currentStage || r.ended) return null;
                const st = TIMELINE_STAGES[r.currentStage];
                const exp = TIMELINE_EXPECTED_DAYS[r.currentStage];
                const over = exp && r.daysInStage != null && r.daysInStage > exp;
                return (
                  <span className={`ml-1.5 text-[10px] font-semibold px-1.5 py-0.5 rounded ${over ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600'}`}
                    title={over ? `${st ? st.label : r.currentStage} for ${r.daysInStage} days — past the ~${exp}d expectation` : `Current stage${r.daysInStage != null ? ` for ${r.daysInStage} days` : ''}`}>
                    {st ? st.label : r.currentStage}{r.daysInStage != null ? ` · ${r.daysInStage}d` : ''}
                  </span>
                );
              };
              const renderRow = (r) => (
                <tr key={r.key}>
                  <td className="sticky left-0 bg-white border-b border-gray-100 px-3 py-1 font-medium text-gray-800 whitespace-nowrap z-10" title={`${r.name} — ${r.status}${r.lead ? ' · Lead: ' + r.lead : ''}${r.vistaId ? ' · ' + r.vistaId : ''}`}>
                    {r.name}
                    {r.lead && <span className="ml-1.5 text-xs font-normal text-gray-400">{r.lead}</span>}
                    {nowChip(r)}
                  </td>
                  {months.map((m, i) => {
                    const info = stagesFor(r, m);
                    const prevInfo = i > 0 ? stagesFor(r, months[i - 1]) : null;
                    const prevEnd = prevInfo ? prevInfo.b : null;
                    if (!info || !info.b) {
                      return <td key={m} className="border-b border-gray-100 px-1 h-8 min-w-[58px]" />;
                    }
                    const stA = TIMELINE_STAGES[info.a] || null;
                    const stB = TIMELINE_STAGES[info.b];
                    const split = stA && info.a !== info.b;
                    const darkHalf = info.b === 'sold' || info.b === 'dead';
                    const label = info.b !== prevEnd ? stB.label : '';
                    return (
                      <td key={m}
                        className={`border-b border-gray-100 px-1 h-8 min-w-[58px] text-[10px] font-semibold whitespace-nowrap ${split ? (darkHalf ? 'text-white text-right' : 'text-gray-900 text-right') : stB.cls}`}
                        style={split ? { background: `linear-gradient(90deg, ${stA.hex} 50%, ${stB.hex} 50%)` } : undefined}
                        title={split ? `${r.name} — ${stA.label} → ${stB.label}, ${monthLabel(m)}` : `${r.name} — ${stB.label}, ${monthLabel(m)}`}>
                        {label}
                      </td>
                    );
                  })}
                </tr>
              );
              return (
                <React.Fragment>
                  {activeRows.map(renderRow)}
                  {endedRows.length > 0 && (
                    <tr>
                      <td colSpan={months.length + 1} className="px-3 py-2 bg-gray-50 border-b border-gray-200">
                        <button type="button" onClick={() => setShowEnded(v => !v)} className="text-xs font-semibold text-gray-600 hover:text-gray-900">
                          {showEnded ? '▾' : '▸'} Sold, dead &amp; history ({endedRows.length})
                        </button>
                      </td>
                    </tr>
                  )}
                  {showEnded && endedRows.map(renderRow)}
                </React.Fragment>
              );
            })()}
          </tbody>
        </table>
      </div>
      {/* The same journey, aggregated — moved here from Closed Deals (Mark
          2026-07-24: the card spans the whole funnel, not just closings). */}
      <FunnelVelocityCard pipelineProjects={pipelineProjects} stageEvents={stageEvents}
        dmListings={dmListings} dmClosings={dmClosings} dmDateOverrides={dmDateOverrides} />
      <FunnelConversionCard pipelineProjects={pipelineProjects} stageEvents={stageEvents}
        ownerEngagement={ownerEngagement} dmListings={dmListings} dmClosings={dmClosings}
        dmSheetHistory={dmSheetHistory} />
    </div>
  );
};

// ─── Ended without a sale (ROADMAP #22, Mark 10-22: "understand why they are dead, so we can learn and improve… did we
// bring the buyers and offers, but the owner flaked? Or did the business stumble or did we fail to find buyers") ───
// Every DM listing marked Dead with its reason (the required Dead form), the Lead's note, would they come back, and the
// facts recorded at that moment: buyers who got the CIM, IOIs, LOIs, best offers vs our valuation, days since first out.
// The counts line answers "owner, market, the business, or us?" at a glance.
const DEAD_REASON_LABEL = {
  owner_after_offers: ['Owner withdrew after offers', 'owner'], owner_before_offers: ['Owner withdrew before offers', 'owner'],
  price_gap: ["No offers met the owner's price", 'market'], no_buyers: ['Too few buyers / no offers', 'us'],
  business_declined: ['Business stumbled during the sale', 'business'], post_loi_fell_through: ['Fell apart after the LOI', 'buyer'],
  sold_outside: ['Sold outside our process', 'lost'], other: ['Other', 'other'],
};
const EndedWithoutSale = ({ dmListings }) => {
  const rows = (Array.isArray(dmListings) ? dmListings : []).filter(l => l.status === 'Dead')
    .sort((x, y) => String(y.dead_at || '').localeCompare(String(x.dead_at || '')));
  if (!rows.length) return null;
  const m = (n) => (n == null || !Number(n) ? '—' : Number(n) >= 1e6 ? '$' + (Number(n) / 1e6).toFixed(2).replace(/\.?0+$/, '') + 'M' : '$' + Math.round(Number(n) / 1000) + 'K');
  const byWho = {};
  rows.forEach(l => { const w = (DEAD_REASON_LABEL[l.dead_reason] || ['', 'not recorded'])[1]; byWho[w] = (byWho[w] || 0) + 1; });
  return (
    <div className="mt-8">
      <h3 className="text-sm font-bold text-gray-700 mb-1">🏁 Ended without a sale <span className="font-normal text-gray-400">({rows.length})</span></h3>
      <div className="text-xs text-gray-500 mb-2">Why each listing ended, recorded when it was marked Dead in Deal Manager. By cause: {Object.entries(byWho).map(([k, v]) => k + ' ' + v).join(' · ')}</div>
      <div className="overflow-x-auto bg-white border border-gray-200 rounded-lg">
        <table className="w-full text-xs">
          <thead className="bg-gray-50 text-gray-500"><tr>
            <th className="text-left px-2 py-1.5">Business</th><th className="text-left px-2 py-1.5">Ended</th><th className="text-left px-2 py-1.5">Why</th>
            <th className="text-left px-2 py-1.5">What happened</th><th className="text-left px-2 py-1.5">Come back?</th>
            <th className="text-right px-2 py-1.5">Buyers (CIM)</th><th className="text-right px-2 py-1.5">IOIs (top)</th><th className="text-right px-2 py-1.5">LOIs (top)</th>
            <th className="text-right px-2 py-1.5">Our valuation</th><th className="text-right px-2 py-1.5">Days out</th>
          </tr></thead>
          <tbody>
            {rows.map(l => { const s = l.dead_snapshot || {}; const v = s.valuation || null; const lab = DEAD_REASON_LABEL[l.dead_reason]; return (
              <tr key={l.id} className="border-t border-gray-100 align-top">
                <td className="px-2 py-1.5 font-semibold text-gray-800">{l.name} <span className="text-gray-400 font-normal">#{l.vista_id}</span><div className="text-[10px] text-gray-400 font-normal">Lead {l.lead || '—'}</div></td>
                <td className="px-2 py-1.5 whitespace-nowrap">{l.dead_at ? new Date(l.dead_at).toLocaleDateString() : '—'}</td>
                <td className="px-2 py-1.5">{lab ? lab[0] : <span className="text-amber-700">Reason not recorded yet</span>}</td>
                <td className="px-2 py-1.5 text-gray-600 max-w-xs">{l.dead_note || '—'}</td>
                <td className="px-2 py-1.5">{l.dead_relist || '—'}</td>
                <td className="px-2 py-1.5 text-right">{s.buyers_reached != null ? s.buyers_reached : '—'}</td>
                <td className="px-2 py-1.5 text-right">{s.ioi_count != null ? s.ioi_count + (s.top_ioi ? ' (' + m(s.top_ioi) + ')' : '') : '—'}</td>
                <td className="px-2 py-1.5 text-right">{s.loi_count != null ? s.loi_count + (s.top_loi ? ' (' + m(s.top_loi) + ')' : '') : '—'}</td>
                <td className="px-2 py-1.5 text-right">{v ? m(v.low) + (v.high && v.high !== v.low ? '–' + m(v.high) : '') : '—'}</td>
                <td className="px-2 py-1.5 text-right">{s.days_on_market != null ? s.days_on_market : '—'}</td>
              </tr>); })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ─── Closed Deals (#6 B1) ───────────────────────────────────────
// The closed-deal surface over DM's `closings` table: card-captured closings
// + the Zoho sold-history import (107 deals to 2011). Money = total vs
// collected-at-close (the cash-portion basis Vista pays on). AM attribution:
// `managed_by` from the import, else VT's account_manager via the vista_id
// join (card rows carry no AM). Velocity reads Listing/Upload dates out of
// import_data where the export had them.
const ClosedDealsView = ({ dmClosings, pipelineProjects, dmListings }) => {
  const [yearFilter, setYearFilter] = React.useState('all');
  const [typeFilter, setTypeFilter] = React.useState('all');
  const [sectorFilter, setSectorFilter] = React.useState('all'); // MSPs are the focus — one pick isolates an industry across the whole tab
  // Canonical umbrellas (sector audit, 08-27): the dropdown groups the
  // historical Zoho strings under their canonical taxonomy name via the
  // alias bridge — "IT - Managed Services" and its twins all count and
  // filter as "IT Managed Services Provider (MSP)". Stored data untouched;
  // unmapped values keep their verbatim entry. New card closings write the
  // canonical name directly (DM prefill), so old and new group together.
  const [taxAlias, setTaxAlias] = React.useState(null); // lowercase name/alias → canonical name
  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch('/api/industry-taxonomy');
        const t = await r.json();
        const m = new Map();
        (t.groups || []).forEach(g => (g.sectors || []).forEach(s => {
          m.set(s.name.toLowerCase(), s.name);
          (s.aliases || []).forEach(a => m.set(String(a).toLowerCase(), s.name));
        }));
        if (!cancelled) setTaxAlias(m);
      } catch (_) { /* taxonomy optional — dropdown falls back to raw values */ }
    })();
    return () => { cancelled = true; };
  }, []);
  const canonicalOf = (s) => (taxAlias && taxAlias.get(String(s).trim().toLowerCase())) || null;
  const fmtMoney = (n) => '$' + Math.round(Number(n) || 0).toLocaleString();
  const fmtDate = (d) => {
    if (!d) return '—';
    const dt = new Date(d + 'T00:00:00');
    return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString();
  };
  const MONTHS = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };
  const usDate = (s) => { // "Nov 12, 2025" (Zoho export format inside import_data) → ISO
    const m = /^(\w{3})\w* (\d{1,2}), (\d{4})$/.exec(String(s || '').trim());
    return (m && MONTHS[m[1]]) ? `${m[3]}-${MONTHS[m[1]]}-${String(m[2]).padStart(2, '0')}` : null;
  };
  const daysBetween = (a, b) => {
    if (!a || !b) return null;
    const d = (new Date(b + 'T00:00:00') - new Date(a + 'T00:00:00')) / 86400000;
    return isNaN(d) || d < 0 ? null : Math.round(d);
  };
  const avg = (xs) => xs.length ? xs.reduce((s, x) => s + x, 0) / xs.length : null;
  const median = (xs) => {
    if (!xs.length) return null;
    const s = [...xs].sort((a, b) => a - b);
    return s.length % 2 ? s[(s.length - 1) / 2] : (s[s.length / 2 - 1] + s[s.length / 2]) / 2;
  };

  if (dmClosings === null) {
    return <div className="bg-red-50 border border-red-200 text-red-700 rounded p-4 text-sm">⚠ Deal Manager data unavailable — the Closed Deals tab reads DM's closings. Reload, or check the server logs.</div>;
  }

  const vtByVista = {};
  (pipelineProjects || []).forEach(p => { const k = String(p.vista_id || '').trim(); if (k && !vtByVista[k]) vtByVista[k] = p; });
  // DM listing join for card-era closings of deals that never lived in VT
  // (Loyal IT 2026-07-29): the listing still knows the AM.
  const listingById = {};
  (dmListings || []).forEach(l => { if (l && l.id) listingById[l.id] = l; });

  const rows = (dmClosings || []).map(c => {
    const vt = vtByVista[String(c.vista_id || '').trim()] || null;
    const listing = (c.listing_id && listingById[c.listing_id]) || null;
    const imp = c.import_data || {};
    return {
      ...c,
      year: c.closing_date ? c.closing_date.slice(0, 4) : null,
      am: c.managed_by || (vt ? vt.account_manager : null) || (listing ? listing.account_manager : null),
      // The LEAD (person) — a commission-calc input (Mark 08-25). The closings
      // table never carried it; the listing knows it for sellside, the VT
      // record covers the rest. Zoho-import closings with neither (MBA
      // Marketing) can carry a hand-stamped import_data.Lead. Buyside
      // closings with none of the three show "—".
      leadJoined: (listing ? listing.lead : null) || (vt ? vt.lead : null) || imp['Lead'] || null,
      // Commission cash basis (Mark 08-25: "cash collected at close INCLUDES
      // the retainer" — Zoho-era rows summed both into cash_commissions; the
      // current DM close card fills collected+retainer and often leaves the
      // combined field empty; Ciracom filled ONLY the combined field). Basis =
      // collected + retainer when present, else the combined field; both
      // present and disagreeing gets a ⚠ instead of a silent pick.
      ...(() => {
        const collected = Number(c.commissions_collected_at_close) || 0;
        const retainer = Number(c.retainer_paid) || 0;
        const combined = Number(c.cash_commissions) || 0;
        const total = Number(c.total_commissions) || 0;
        // Ambiguity guard (Loyal IT 08-25, caught against Mark's Zoho report):
        // some closings entered "collected at close" ALREADY including the
        // retainer (Zoho style: 245,140 + 6,860 typed as 252,000), others
        // entered it excluding (Novusys: 69,600, retainer separate). When
        // collected + retainer would EXCEED the deal's total commissions,
        // the retainer is provably already inside — use collected alone.
        const sum = collected + retainer;
        const retainerInside = total > 0 && retainer > 0 && sum > total + 1;
        const split = retainerInside ? collected : sum;
        const cashBasis = split > 0 ? split : combined;
        let cashBasisNote = null;
        if (retainerInside) cashBasisNote = 'retainer already inside collected-at-close (sum would exceed total commissions) — counted once';
        else if (split > 0 && combined > 0 && Math.abs(split - combined) > 1) cashBasisNote = `⚠ split fields say $${Math.round(split).toLocaleString()} but the combined field says $${Math.round(combined).toLocaleString()} — fix in DM`;
        else if (split === 0 && combined === 0) cashBasisNote = '⚠ no cash recorded';
        else if (split === 0 && combined > 0) cashBasisNote = 'from the combined field only (retainer not split out)';
        return { cashBasis, cashBasisNote };
      })(),
      // Pay month = closing month + 1 (Novusys closed 4/30 → Paid May).
      // Day pinned to 1 BEFORE the month bump: Jan 31 + 1 month would
      // otherwise roll through Feb 31 into March.
      payKey: c.closing_date ? (() => { const d = new Date(c.closing_date + 'T00:00:00'); d.setDate(1); d.setMonth(d.getMonth() + 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; })() : null,
      // Zoho's historical field first; VT's client marketing_source covers
      // card-era closings (the Zoho field doesn't exist for those).
      srcJoined: c.lead_source || (vt ? vt.marketing_source : null),
      isIT: /\bIT\b/.test(c.sector || ''),
      sectorList: (c.sector || '').split(';').map(s => s.trim()).filter(Boolean),
      listingDate: usDate(imp['Listing Date']),
      // Collection-phase dates come from the VT record (vista_id join) — the
      // Zoho import only ever had Upload Complete. Pre-VT closings leave these
      // null and simply drop out of those hops (the n column shows it).
      discoveryDate: (vt && vt.discovery_meeting_date) || null,
      uploadStartDate: (vt && vt.upload_started_date) || null,
      uploadDate: (vt && vt.upload_complete_date) || usDate(imp['Upload Complete Date']),
      valuationDate: c.valuation_date || (vt && vt.valuation_date) || null,
      // Card-captured closings don't carry Vista's valuation (it's a VT fact,
      // not a closing fact — the DM card never asks for it). Join it from the
      // VT record so the Valuation-vs-outcome chart sees card-era deals
      // (Loyal IT 2026-07-29: $6.8M LOI on a $3.4M valuation was invisible).
      value_provided: c.value_provided || (vt ? vt.value_provided_high : null),
      // multiples above 100 are data errors (e.g. EBITDA keyed as $1) — shown
      // in tables verbatim, excluded from every average
      plausibleMultiple: c.multiple != null && c.multiple > 0 && c.multiple <= 100 ? Number(c.multiple) : null,
    };
  });

  const years = [...new Set(rows.map(r => r.year).filter(Boolean))].sort().reverse();
  // Industries from the multi-valued sector field ("A; B"), grouped under
  // canonical umbrellas (alias bridge), most-closed first so the MSP
  // umbrella sits on top. Pre-taxonomy: raw distinct values as before.
  const sectors = (() => {
    const m = {};
    rows.forEach(r => r.sectorList.forEach(s => { const k = canonicalOf(s) || s; m[k] = (m[k] || 0) + 1; }));
    return Object.entries(m).sort((a, b) => b[1] - a[1]);
  })();
  const sectorMatches = (r) => sectorFilter === 'all'
    || r.sectorList.some(s => s === sectorFilter || canonicalOf(s) === sectorFilter);
  const typed = rows.filter(r => (typeFilter === 'all' || r.transaction_type === typeFilter)
    && sectorMatches(r));
  const filtered = typed.filter(r => yearFilter === 'all' || r.year === yearFilter);

  const sum = (xs, k) => xs.reduce((s, r) => s + (Number(r[k]) || 0), 0);
  const tiles = [
    { label: `Closed commissions${yearFilter === 'all' ? ' (lifetime)' : ' ' + yearFilter}`, value: fmtMoney(sum(filtered, 'total_commissions')) },
    { label: 'Collected at close', value: fmtMoney(sum(filtered, 'commissions_collected_at_close')), hint: 'The cash-portion basis Vista is paid on — blank rows count $0 here, not their total.' },
    { label: 'Deals closed', value: String(filtered.length), sub: `${filtered.filter(r => r.transaction_type === 'sellside').length} sell · ${filtered.filter(r => r.transaction_type === 'buyside').length} buy` },
    { label: 'Avg multiple', value: (() => { const m = avg(filtered.map(r => r.plausibleMultiple).filter(x => x != null)); return m == null ? '—' : m.toFixed(2) + '×'; })(), hint: 'Stated/derived multiple of EBITDA; implausible values (>100×) excluded.' },
  ];

  const byYear = years.map(y => {
    const ys = typed.filter(r => r.year === y);
    return {
      year: y, count: ys.length,
      total: sum(ys, 'total_commissions'), collected: sum(ys, 'commissions_collected_at_close'),
      avgMultiple: avg(ys.map(r => r.plausibleMultiple).filter(x => x != null)),
      avgEbitda: avg(ys.map(r => Number(r.ebitda)).filter(x => x > 1)),
      it: ys.filter(r => r.isIT).length,
    };
  });

  const byAm = (() => {
    const m = {};
    filtered.forEach(r => { const k = r.am || '—'; (m[k] = m[k] || []).push(r); });
    return Object.entries(m).map(([am, rs]) => ({ am, count: rs.length, total: sum(rs, 'total_commissions'), collected: sum(rs, 'commissions_collected_at_close') }))
      .sort((a, b) => b.total - a.total);
  })();

  const bySource = (() => {
    const m = {};
    filtered.forEach(r => { const k = r.srcJoined || '—'; (m[k] = m[k] || []).push(r); });
    return Object.entries(m).map(([src, rs]) => ({ src, count: rs.length, total: sum(rs, 'total_commissions') }))
      .sort((a, b) => b.total - a.total);
  })();

  // Funnel velocity moved to the Timeline tab 2026-07-24 (it spans the whole
  // funnel — completed valuations + live listings — not just closings).

  const accuracy = filtered.filter(r => r.value_provided > 0 && r.loi_price > 0)
    .map(r => ({ ...r, ratio: r.loi_price / r.value_provided }))
    .sort((a, b) => (b.closing_date || '') < (a.closing_date || '') ? -1 : 1);
  const medianRatio = median(accuracy.map(r => r.ratio));

  const allSorted = [...filtered].sort((a, b) => (b.closing_date || '') < (a.closing_date || '') ? -1 : 1);

  const Th = ({ children, numeric }) => <th className={`px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 ${numeric ? 'text-right' : 'text-left'}`}>{children}</th>;
  const Td = ({ children, numeric, className = '' }) => <td className={`px-3 py-2 whitespace-nowrap ${numeric ? 'text-right' : ''} ${className}`}>{children}</td>;
  const Card = ({ title, sub, children }) => (
    <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
      <div className="px-4 py-3 border-b bg-gray-50 flex items-baseline gap-2 flex-wrap">
        <div className="text-sm font-bold text-gray-800">{title}</div>
        {sub && <div className="text-xs text-gray-500">{sub}</div>}
      </div>
      {children}
    </div>
  );

  return (
    <div>
      <div className="text-xs text-gray-500 mb-4">Every closed engagement — captured by the Closing Information card going forward, seeded by the Zoho sold history (107 deals, 2011→today). Money shows total commissions vs collected-at-close (the cash-portion basis Vista is paid on).</div>

      <div className="flex gap-3 mb-4">
        <select value={yearFilter} onChange={e => setYearFilter(e.target.value)} className="border border-gray-300 rounded px-2 py-1 text-sm">
          <option value="all">All years</option>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} className="border border-gray-300 rounded px-2 py-1 text-sm">
          <option value="all">Sell + buy side</option>
          <option value="sellside">Sell-side</option>
          <option value="buyside">Buy-side</option>
        </select>
        <select value={sectorFilter} onChange={e => setSectorFilter(e.target.value)} className="border border-gray-300 rounded px-2 py-1 text-sm">
          <option value="all">All industries</option>
          {sectors.map(([s, n]) => <option key={s} value={s}>{s} ({n})</option>)}
        </select>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {tiles.map(t => (
          <div key={t.label} className="bg-white border border-gray-200 rounded-lg p-4" title={t.hint || undefined}>
            <div className="text-xs text-gray-500 mb-1">{t.label}</div>
            <div className="text-xl font-bold text-gray-800">{t.value}</div>
            {t.sub && <div className="text-xs text-gray-400 mt-0.5">{t.sub}</div>}
          </div>
        ))}
      </div>

      {/* 💵 Monthly commission inputs (Mark 08-25): the four calc inputs per
          closing, grouped by PAY month (= closing month + 1), for the monthly
          commission worksheet. Inputs only — percentages and payouts stay in
          Mark's confidential sheet. Ignores the filters above on purpose:
          payroll must never miss a row to a forgotten filter. */}
      <Card title="💵 Monthly commission inputs" sub="pay month = closing month + 1 · cash basis = collected at close + retainer · latest 6 pay months · unaffected by the filters above">
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-gray-50"><Th>Pay Month</Th><Th>Business</Th><Th>Type</Th><Th>AM</Th><Th>Lead</Th><Th numeric>Cash Basis</Th><Th>Notes</Th></tr></thead>
          <tbody>
            {(() => {
              const payKeys = [...new Set(rows.map(r => r.payKey).filter(Boolean))].sort().reverse().slice(0, 6);
              return payKeys.map(pk => {
                const monthRows = rows.filter(r => r.payKey === pk)
                  .sort((a, b) => (a.closing_date || '') < (b.closing_date || '') ? -1 : 1);
                const label = new Date(pk + '-01T00:00:00').toLocaleString('en-US', { month: 'long', year: 'numeric' });
                const subtotal = monthRows.reduce((s, r) => s + r.cashBasis, 0);
                return (
                  <React.Fragment key={pk}>
                    {monthRows.map((r, i) => (
                      <tr key={r.id || (pk + i)} className="border-b border-gray-100">
                        <Td className="font-medium text-gray-800">{i === 0 ? 'Pay ' + label : ''}</Td>
                        <Td>{r.business_name || '—'}<span className="text-gray-400 text-xs ml-1">closed {fmtDate(r.closing_date)}</span></Td>
                        <Td><span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${r.transaction_type === 'buyside' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}`}>{r.transaction_type === 'buyside' ? 'BS' : 'SS'}</span></Td>
                        <Td>{r.am || '—'}</Td>
                        <Td>{r.leadJoined || <span className="text-amber-600" title="No Lead on the closing, its listing, or the VT record — fill by hand on the worksheet.">—</span>}</Td>
                        <Td numeric className="font-medium text-emerald-700">{fmtMoney(r.cashBasis)}</Td>
                        <Td className="text-xs text-amber-700">{r.cashBasisNote || ''}</Td>
                      </tr>
                    ))}
                    <tr className="border-b bg-gray-50">
                      <td className="px-3 py-2 text-xs text-gray-500" colSpan={5}>{label} total ({monthRows.length} deal{monthRows.length === 1 ? '' : 's'})</td>
                      <td className="px-3 py-2 text-right font-bold text-gray-800 whitespace-nowrap">{fmtMoney(subtotal)}</td>
                      <td className="px-3 py-2"></td>
                    </tr>
                  </React.Fragment>
                );
              });
            })()}
          </tbody>
        </table>
      </Card>

      <Card title="📅 By year" sub={[typeFilter !== 'all' ? typeFilter + ' only' : null, sectorFilter !== 'all' ? sectorFilter : null].filter(Boolean).join(' · ') || undefined}>
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-gray-50"><Th>Year</Th><Th numeric>Deals</Th><Th numeric>Total Commissions</Th><Th numeric>Collected at Close</Th><Th numeric>Avg Multiple</Th><Th numeric>Avg EBITDA</Th><Th numeric>IT Deals</Th></tr></thead>
          <tbody>
            {byYear.map(y => (
              <tr key={y.year} className="border-b border-gray-100">
                <Td className="font-medium text-gray-800">{y.year}</Td>
                <Td numeric>{y.count}</Td>
                <Td numeric className="font-medium text-emerald-700">{fmtMoney(y.total)}</Td>
                <Td numeric>{fmtMoney(y.collected)}</Td>
                <Td numeric>{y.avgMultiple == null ? '—' : y.avgMultiple.toFixed(2) + '×'}</Td>
                <Td numeric>{y.avgEbitda == null ? '—' : fmtMoney(y.avgEbitda)}</Td>
                <Td numeric>{y.it}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <div className="grid md:grid-cols-2 gap-6">
        <Card title="👤 By account manager" sub="managed_by from Zoho history; VT AM for card-captured rows">
          <table className="w-full text-sm">
            <thead><tr className="border-b bg-gray-50"><Th>AM</Th><Th numeric>Deals</Th><Th numeric>Total</Th><Th numeric>Collected</Th></tr></thead>
            <tbody>
              {byAm.map(a => (
                <tr key={a.am} className="border-b border-gray-100">
                  <Td className="font-medium text-gray-800">{a.am}</Td>
                  <Td numeric>{a.count}</Td>
                  <Td numeric className="font-medium text-emerald-700">{fmtMoney(a.total)}</Td>
                  <Td numeric>{fmtMoney(a.collected)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

        <Card title="⏱ Funnel velocity" sub="moved to the Deal Flow tab (2026-07-24)">
          <div className="px-4 py-6 text-sm text-gray-500">This card now lives on the <strong>Deal Flow</strong> tab — it measures the whole funnel (completed valuations + live listings), not just closings, with per-hop goals and deal-cohort trends.</div>
        </Card>
      </div>

      {/* ROADMAP #7 (valuation accuracy feedback loop) — number kept out of the
          staff-visible title (Mark 2026-07-23). */}
      <Card title="🎯 Valuation vs outcome" sub={`deals with both a Vista valuation and an LOI price · median LOI/valuation ${medianRatio == null ? '—' : (medianRatio * 100).toFixed(0) + '%'}`}>
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-gray-50"><Th>Business</Th><Th>Closed</Th><Th numeric>Value Provided</Th><Th numeric>LOI Price</Th><Th numeric>LOI / Valuation</Th><Th numeric>Multiple</Th></tr></thead>
          <tbody>
            {accuracy.length === 0 && <tr><td colSpan={6} className="px-3 py-4 text-center text-gray-400 text-xs">No deals in this filter carry both figures.</td></tr>}
            {accuracy.map((r, i) => (
              <tr key={i} className="border-b border-gray-100">
                <Td className="font-medium text-gray-800">{r.business_name}</Td>
                <Td className="text-gray-600">{fmtDate(r.closing_date)}</Td>
                <Td numeric>{fmtMoney(r.value_provided)}</Td>
                <Td numeric>{fmtMoney(r.loi_price)}</Td>
                <Td numeric className={r.ratio >= 1 ? 'text-emerald-700 font-medium' : 'text-amber-600 font-medium'}>{(r.ratio * 100).toFixed(0)}%</Td>
                <Td numeric>{r.plausibleMultiple == null ? '—' : r.plausibleMultiple.toFixed(2) + '×'}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <div className="grid md:grid-cols-2 gap-6">
        <Card title="📣 By lead source" sub="closed-deal yield per channel (early Family-3 read)">
          <table className="w-full text-sm">
            <thead><tr className="border-b bg-gray-50"><Th>Source</Th><Th numeric>Deals</Th><Th numeric>Total Commissions</Th></tr></thead>
            <tbody>
              {bySource.map(s => (
                <tr key={s.src} className="border-b border-gray-100">
                  <Td className="text-gray-700">{s.src}</Td>
                  <Td numeric>{s.count}</Td>
                  <Td numeric className="font-medium text-emerald-700">{fmtMoney(s.total)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

        <Card title="📋 All closed deals" sub="newest first">
          <div className="max-h-96 overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-gray-50"><tr className="border-b"><Th>Business</Th><Th>Closed</Th><Th>Type</Th><Th numeric>Total</Th><Th numeric>Multiple</Th></tr></thead>
              <tbody>
                {allSorted.map((r, i) => (
                  <tr key={i} className="border-b border-gray-100">
                    <Td className="font-medium text-gray-800">{r.business_name}{r.source === 'card' && <span className="ml-2 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-blue-100 text-blue-700" title="Captured by the Closing Information card (not the Zoho import).">card</span>}</Td>
                    <Td className="text-gray-600">{fmtDate(r.closing_date)}</Td>
                    <Td className="text-gray-500">{r.transaction_type === 'buyside' ? 'buy' : 'sell'}</Td>
                    <Td numeric className="font-medium text-emerald-700">{fmtMoney(r.total_commissions)}</Td>
                    <Td numeric>{r.multiple == null ? '—' : Number(r.multiple) > 100 ? <span className="text-red-500" title="Implausible — source data error (excluded from averages).">{Number(r.multiple).toLocaleString()}×</span> : Number(r.multiple).toFixed(2) + '×'}</Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
      <EndedWithoutSale dmListings={dmListings} />
    </div>
  );
};

// ─── Committee (#6 B2) ──────────────────────────────────────────
// The Marketing Committee Tracking sheet, computed instead of hand-keyed.
// PURPOSE (Mark): a behavioral mirror — meetings-set → meetings-held →
// discovery → uploads → valuations, visible weekly so an AM can't drift a
// week unseen. Adam keeps PRESENTING it at staff meeting; VT does the
// gathering. Data: metric_snapshots (Monday 6am cron + the imported ~4yr
// committee-sheet history) + live DM listings/closings for the market block.
// Baselines: trailing 12-wk avg + same-week-last-year; optional CAPACITY
// ceiling from the targets table (goal-as-floor retired, Mark 2026-07-22).
// 🎯 VALUATION → DECISION (Mark 10-19: "the close rate from valuation meeting to signing was always ~25%; last
// year it drifted well below"; the 6-month strategic review is new data he couldn't track before). From VT's
// stage log (history starts May '26): presented = → awaiting_decision (once per deal per month), engaged = the
// first → engaged per deal, strategic = → strategic_review_set, and each engagement's path: AFTER a review /
// follow-up when the deal passed a post-valuation "not now" stage first, else at the first decision.
const DECISION_NOT_NOW = ['strategic_review_set', 'considering_followup', 'val_complete_inactive', 'val_complete_dead'];
const valDecisionStats = (stageEvents) => {
  const out = { presented: {}, engaged: {}, strategic: {}, engagedFirst: {}, engagedAfter: {} };
  const byP = {};
  (stageEvents || []).forEach(e => { if (e && e.project_id && e.at && e.metadata && e.metadata.to) (byP[e.project_id] = byP[e.project_id] || []).push(e); });
  const add = (k, ym) => { out[k][ym] = (out[k][ym] || 0) + 1; };
  Object.values(byP).forEach(list => {
    list.sort((a, b) => (a.at < b.at ? -1 : 1));
    const seen = new Set();
    let notNow = false, engagedDone = false;
    list.forEach(e => {
      const to = e.metadata.to;
      const ym = String(e.at).slice(0, 7);
      if (to === 'awaiting_decision' && !seen.has('p' + ym)) { seen.add('p' + ym); add('presented', ym); }
      if (to === 'strategic_review_set' && !seen.has('s' + ym)) { seen.add('s' + ym); add('strategic', ym); }
      if (to === 'engaged' && !engagedDone) { engagedDone = true; add('engaged', ym); add(notNow ? 'engagedAfter' : 'engagedFirst', ym); }
      if (DECISION_NOT_NOW.includes(to)) notNow = true;
    });
  });
  return out;
};

const CommitteeView = ({ metricSnapshots, targets, dmListings, dmClosings, valuationHistory, importedEvents = [], loiSignings = [], stageEvents = [], buyersByMonth = null, seMeetings = null, bsStocks = null, onSaveTarget = null, canEditTargets = false }) => {
  const [hoverIdx, setHoverIdx] = React.useState(null);
  const fmtMoney = (n) => '$' + Math.round(Number(n) || 0).toLocaleString();
  const fmtMoneyShort = (n) => {
    const v = Number(n) || 0;
    return v >= 1e6 ? '$' + (v / 1e6).toFixed(1) + 'M' : v >= 1e3 ? '$' + Math.round(v / 1e3) + 'k' : '$' + v;
  };
  const mondayISO = (d) => {
    const x = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
    x.setUTCDate(x.getUTCDate() - ((x.getUTCDay() + 6) % 7));
    return x.toISOString().slice(0, 10);
  };
  const addDays = (iso, n) => {
    const x = new Date(iso + 'T00:00:00Z');
    x.setUTCDate(x.getUTCDate() + n);
    return x.toISOString().slice(0, 10);
  };
  const thisMonday = mondayISO(new Date());

  if (metricSnapshots === null) {
    return <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded p-4 text-sm">⚠ Metric snapshots unavailable — migration 036 not applied yet, or the fetch failed. The Committee tab reads <code>metric_snapshots</code>; apply 036 (+ the 036b history import), redeploy, and the first snapshot captures on boot.</div>;
  }

  // key → { weekISO → value }
  const byKey = {};
  (metricSnapshots || []).forEach(s => { (byKey[s.metric_key] = byKey[s.metric_key] || {})[s.week_of] = Number(s.value); });
  const val = (key, week) => { const v = byKey[key] && byKey[key][week]; return (v === undefined || v === null || isNaN(v)) ? null : v; };

  // Live-derived weekly series (no snapshot needed — these have dates):
  // listings marketed that week (DM market_date) and closings that week.
  const weekOfDate = (iso) => iso ? mondayISO(new Date(iso + 'T00:00:00Z')) : null;
  const marketedByWeek = {}; (dmListings || []).forEach(l => { const w = weekOfDate(l.market_date); if (w) marketedByWeek[w] = (marketedByWeek[w] || 0) + 1; });
  const soldByWeek = {}; (dmClosings || []).forEach(c => { const w = weekOfDate(c.closing_date); if (w) soldByWeek[w] = (soldByWeek[w] || 0) + 1; });
  // Discovery meetings are a FLOW, not a stock (Mark 2026-07-22 late): the
  // committee number is meetings HAPPENING that week, computed live from
  // discovery dates (deduped by client+date) — not the count of warm deals
  // with a meeting pending. History reaches as far as VT + imported records
  // carry discovery dates (~2025+); older weeks under-count.
  // HONEST COUNTS (Mark 10-28, TCS: Gabriel declined the 9/30 invite, the deal kept 9/30 as its discovery date and it
  // counted as a meeting). A discovery date whose calendar meeting the owner declined, or that was marked no-show,
  // is not a meeting: it drops out here. Matched by business + ET day. VT's date is still the truth for everything else.
  const etDayC = (iso) => { try { return new Date(iso).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }); } catch (e) { return null; } };
  const ownerDeclined = (mt) => {
    const ext = (mt.attendees || []).filter(a => a && a.email && !/@vistabusinessgroup\.com$/i.test(a.email));
    return ext.length > 0 && ext.every(a => a.response === 'declined');
  };
  const clientOfVal = new Map((valuationHistory || []).filter(p => p.id).map(p => [p.id, p.client_id]));
  const notAMeeting = new Set();   // client_id|YYYY-MM-DD
  (seMeetings || []).forEach(mt => {
    if (!(mt.outcome === 'no_show' || ownerDeclined(mt))) return;
    const cid = (mt.owner && mt.owner.vt_client_id) || (mt.valuation_id && clientOfVal.get(mt.valuation_id));
    const d = mt.starts_at ? etDayC(mt.starts_at) : null;
    if (cid && d) notAMeeting.add(cid + '|' + d);
  });
  const discByWeek = {};
  {
    const seen = new Set();
    (valuationHistory || []).forEach(p => {
      if (!p.discovery_meeting_date) return;
      const k = (p.client_id || '') + '|' + p.discovery_meeting_date;
      if (seen.has(k) || notAMeeting.has(k)) return;
      seen.add(k);
      const w = weekOfDate(p.discovery_meeting_date);
      if (w) discByWeek[w] = (discByWeek[w] || 0) + 1;
    });
  }

  // ── Meetings weekly maps (ROADMAP #12 wiring, 2026-08-06) — live from
  // se_meetings, bucketed by ET day. Booked = the leading indicator; held =
  // Fireflies-verified or confirmed via the did-this-happen cards; no-show
  // comes only from those cards, so the gap is honest, not assumed.
  const bookedByWeek = {}, heldByWeek = {}, noShowByWeek = {};
  // Valuation meetings from STAGE TRUTH (Mark 09-02: "those dates are in the
  // VT" — the calendar type is new, but a deal leaving val_meeting_set IS
  // the valuation meeting having happened). Same logic as discByWeek's use
  // of discovery_meeting_date.
  // 09-28 (Mark: "use the valuation date in VT"): counting stage EXITS double-
  // counted any deal that left val_meeting_set twice (Canitan, 6 minutes
  // apart → last week read 5, truth 4). The count is now one per deal, on its
  // VT Valuation Date (stamped whenever a meeting outcome is recorded); the
  // calendar's held valuation meetings stay as the cross-check (valMeetCal).
  const valMeetByWeek = {};
  (valuationHistory || []).forEach(p => {
    const w = weekOfDate(p.valuation_date ? String(p.valuation_date).slice(0, 10) : null);
    if (w) valMeetByWeek[w] = (valMeetByWeek[w] || 0) + 1;
  });
  // Merge two weekly maps taking the max per week — the same event often
  // exists in both sources (a typed calendar meeting AND the VT date), so
  // max counts it once while missing neither source's exclusives.
  const mergeMax = (a, b) => { const out = { ...a }; Object.entries(b || {}).forEach(([w, v]) => { out[w] = Math.max(out[w] || 0, v); }); return out; };
  // THE FUNNEL SPLIT (Mark 09-01, settled with the meeting taxonomy): the
  // committee's meetings report mirrors his tracking spreadsheet, split into
  // a SELLSIDE funnel (first-time → listing → re-engage) and a BUYSIDE funnel
  // (services pitch → BSC owner-vet → intro). Post-intro follow-ups live on
  // the buyer↔owner pair (the Closing Engine's lane), not in these counts.
  // Never-counted types (buyer-only, vendor, personal, post-LOI deal_process)
  // stay out of every committee number — deliberate ignores, not gaps.
  // Funnel order = Mark's narrative (09-01 v2): SELLSIDE — owner shows
  // interest → 1st-time OR re-engage → discovery → valuation meeting →
  // listed / strategic meeting / back to AM / stalled. BUYSIDE — outreach
  // to fitting owners → BSC owner vet → buyside intro → follow-ups →
  // under LOI or not. Legacy 'listing'-typed meetings fold into 1st-time
  // (a listing discussion IS the first-time meeting). The pitch row sits
  // apart — client acquisition, not mandate execution.
  const SELL_FUNNEL = [
    ['first_time', '1st-time — owner interested in selling (marketing / outreach)'],
    ['reengage', 'Re-engage — worked back to the table'],
    ['discovery', 'Discovery meetings'],
    ['valuation_meeting', 'Valuation meetings — results presented'],
    // Strategic reviews below the funnel steps (Mark 09-02) — the ongoing
    // review lane, visible but downstream of the funnel proper.
    ['strategic_review', 'Strategic review meetings'],
  ];
  const BUY_FUNNEL = [
    ['bsc_interest', 'BSC owner vets — "we have a client with interest"'],
    ['buyside_intro', 'Buyside intros (client ↔ owner)'],
    ['buyside_call', 'Buyside services pitches (client acquisition)'],
  ];
  // "Meetings Booked" = ONLY what we track (Mark 09-01: "the totals aren't
  // tracking" — booked must reconcile to the funnel rows). Untyped meetings
  // sit on holder cards until classified; strategic reviews and 'other' are
  // deliberately outside the funnel.
  const MT_TRACKED = new Set(['first_time', 'listing', 'reengage', 'discovery', 'valuation_meeting', 'strategic_review', 'bsc_interest', 'buyside_intro', 'buyside_call']);
  const sellWeeks = {}, buyWeeks = {};
  SELL_FUNNEL.forEach(([k]) => { sellWeeks[k] = {}; });
  BUY_FUNNEL.forEach(([k]) => { buyWeeks[k] = {}; });
  const prospectiveNextMeeting = new Set();
  const nowIsoC = new Date().toISOString();
  (seMeetings || []).forEach(mt => {
    if (mt.status !== 'booked') return;
    const type = mt.meeting_type === 'listing' ? 'first_time' : mt.meeting_type;
    if (!MT_TRACKED.has(mt.meeting_type)) return;
    if (ownerDeclined(mt)) return;   // every outside guest declined: it was never on (honest counts, Mark 10-28)
    // A buyside INTRO is client ↔ owner — both parties matched (Mark
    // 09-14: buyer-only listing calls inflated this row to 11+/wk).
    if (type === 'buyside_intro' && !(mt.buyer_id && (mt.owner_id || mt.valuation_id))) return;
    let d = null; try { d = new Date(mt.starts_at).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }); } catch (e) { /* bad date — skip */ }
    const w = d ? weekOfDate(d) : null;
    if (!w) return;
    if (mt.outcome === 'held') heldByWeek[w] = (heldByWeek[w] || 0) + 1;
    if (mt.outcome === 'no_show') noShowByWeek[w] = (noShowByWeek[w] || 0) + 1;
    if (sellWeeks[type]) sellWeeks[type][w] = (sellWeeks[type][w] || 0) + 1;
    if (buyWeeks[type]) buyWeeks[type][w] = (buyWeeks[type][w] || 0) + 1;
    // "Prospective with Next Meeting Set (not review or pre)" — Mark's old
    // sheet stock: distinct businesses with a FUTURE funnel meeting booked.
    if (mt.owner_id && mt.starts_at > nowIsoC && type !== 'strategic_review') prospectiveNextMeeting.add(mt.owner_id);
  });
  // VT TRUTH (Mark 09-28, "use the valuation date in VT … same with the other
  // meetings we want to track"): discovery + valuation meetings count from the
  // deal dates in VT. The calendar-typed count is kept as the CROSS-CHECK —
  // shown beside the number when the two disagree, never merged into it (the
  // 09-02 max-merge let a mistyped invite inflate the count).
  const calCross = { discovery: { ...sellWeeks.discovery }, valuation_meeting: { ...sellWeeks.valuation_meeting } };
  sellWeeks.discovery = { ...discByWeek };
  sellWeeks.valuation_meeting = { ...valMeetByWeek };
  // Meetings Booked = the SUM of the funnel rows, by definition — so the
  // header row always reconciles to the tables below it (Mark 09-02).
  [...SELL_FUNNEL.map(([k]) => sellWeeks[k]), ...BUY_FUNNEL.map(([k]) => buyWeeks[k])].forEach(map => {
    Object.entries(map || {}).forEach(([w, v]) => { bookedByWeek[w] = (bookedByWeek[w] || 0) + v; });
  });

  const currentTarget = (metricKey) => {
    const today = new Date().toISOString().slice(0, 10);
    const rows = (targets || []).filter(t => t.metric_key === metricKey && t.period === 'week'
      && t.effective_from <= today && (!t.effective_to || t.effective_to >= today));
    if (!rows.length) return null;
    rows.sort((a, b) => (b.effective_from + (b.created_at || '')).localeCompare(a.effective_from + (a.created_at || '')));
    return Number(rows[0].value);
  };

  // ── Commission Pipeline chart: trailing 52 weeks vs the same weeks a year earlier ──
  const weeksAsc = []; for (let i = 51; i >= 0; i--) weeksAsc.push(addDays(thisMonday, -7 * i));
  // The imported sheet skipped some weeks — connect the dots with linear
  // interpolation across interior gaps (Mark 2026-07-22). Estimated points
  // are flagged and say "(est.)" in the tooltip; leading/trailing gaps stay open.
  const interpolate = (series) => {
    const out = series.slice(); const est = new Array(series.length).fill(false);
    let i = 0;
    while (i < out.length) {
      if (out[i] != null) { i++; continue; }
      const start = i - 1;
      let j = i; while (j < out.length && out[j] == null) j++;
      if (start >= 0 && j < out.length) {
        const a = out[start], b = out[j], span = j - start;
        for (let k = i; k < j; k++) { out[k] = a + (b - a) * (k - start) / span; est[k] = true; }
      }
      i = j;
    }
    return { out, est };
  };
  const curI = interpolate(weeksAsc.map(w => val('commission_pipeline', w)));
  const priorI = interpolate(weeksAsc.map(w => val('commission_pipeline', addDays(w, -364))));
  const cur = curI.out, prior = priorI.out;
  const allVals = [...cur, ...prior].filter(v => v != null);
  const yMax = allVals.length ? Math.max(...allVals) * 1.08 : 1;
  const W = 720, H = 200, PAD_L = 44, PAD_R = 10, PAD_T = 8, PAD_B = 20;
  const x = (i) => PAD_L + (i / 51) * (W - PAD_L - PAD_R);
  const y = (v) => PAD_T + (1 - v / yMax) * (H - PAD_T - PAD_B);
  const pathOf = (series) => series.map((v, i) => v == null ? null : `${series[i - 1] == null ? 'M' : 'L'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).filter(Boolean).join(' ');
  const latestCur = [...cur].reverse().find(v => v != null);
  const samePrior = prior[51] != null ? prior[51] : [...prior].reverse().find(v => v != null);
  const monthTicks = weeksAsc.map((w, i) => ({ w, i })).filter(({ w }, idx, arr) => idx === 0 || w.slice(0, 7) !== arr[idx - 1].w.slice(0, 7)).filter((_, k) => k % 2 === 0);
  const CUR_COLOR = '#059669', PRIOR_COLOR = '#2563eb';

  // ── Weekly blocks ──
  const cols = [0, 1, 2, 3].map(i => addDays(thisMonday, -7 * i)); // this wk, −1, −2, −3
  const trailing12 = (key, live) => {
    const vs = [];
    for (let i = 1; i <= 12; i++) { const w = addDays(thisMonday, -7 * i); const v = live ? (live[w] || 0) : val(key, w); if (v != null) vs.push(v); }
    return vs.length ? vs.reduce((s, v) => s + v, 0) / vs.length : null;
  };
  const fmtCount = (v) => v == null ? '—' : Math.round(v * 10) / 10;
  const Block = ({ title, tone, rows }) => {
    const anyCapacity = rows.some(r => currentTarget(r.key) != null);
    const fmt = fmtCount;
    return (
      <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
        <div className={`px-4 py-3 border-b ${tone} flex items-baseline gap-2`}>
          <div className="text-sm font-bold text-gray-800">{title}</div>
        </div>
        <table className="w-full text-sm table-fixed">
          <thead><tr className="border-b bg-gray-50">
            <th className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-left" style={{ width: '44%' }}>Metric</th>
            {cols.map((w, i) => <th key={w} className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-right">{i === 0 ? 'This wk' : `−${i}wk`}</th>)}
            <th className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-right" title="Average of the 12 weeks before this one">12-wk avg</th>
            <th className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-right" title="The same Monday one year earlier">Yr ago</th>
            {anyCapacity && <th className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-right" title="Capacity ceiling from the targets table (set via the 🎯 editor lineage — optional per metric)">Capacity</th>}
          </tr></thead>
          <tbody>
            {rows.map(r => {
              const cap = currentTarget(r.key);
              const thisWk = r.live ? (r.live[thisMonday] || 0) : val(r.key, thisMonday);
              const overCap = cap != null && thisWk != null && thisWk > cap;
              return (
                <tr key={r.key} className="border-b border-gray-100">
                  <td className="px-3 py-2 font-medium text-gray-800">{r.label}</td>
                  {cols.map((w, i) => {
                    const v = r.live ? (r.live[w] || 0) : val(r.key, w);
                    // Calendar cross-check (Mark 09-28): shown only when it disagrees with the VT count.
                    const cv = r.cross ? (r.cross[w] || 0) : null;
                    return <td key={w} className={`px-3 py-2 text-right whitespace-nowrap ${i === 0 ? 'font-semibold text-gray-800' : 'text-gray-600'}`}>
                      {fmt(v)}{cv != null && cv !== v && <span className="ml-1 text-[10px] font-normal text-amber-600" title={`VT dates say ${v}; the calendar shows ${cv} meeting(s) typed this way that week. Check for a missing VT date or a mistyped invite.`}>(cal {cv})</span>}
                    </td>;
                  })}
                  <td className="px-3 py-2 text-right whitespace-nowrap text-gray-500">{fmt(trailing12(r.key, r.live))}</td>
                  <td className="px-3 py-2 text-right whitespace-nowrap text-gray-500">{fmt(r.live ? (r.live[addDays(thisMonday, -364)] || 0) : val(r.key, addDays(thisMonday, -364)))}</td>
                  {anyCapacity && <td className={`px-3 py-2 text-right whitespace-nowrap ${overCap ? 'font-semibold text-amber-600' : 'text-gray-400'}`} title={overCap ? 'Above capacity' : undefined}>{cap == null ? '—' : fmt(cap)}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div>
      <div className="text-xs text-gray-500 mb-4">The weekly committee scorecard, computed instead of hand-keyed — snapshots capture every Monday ~6am (history imported from the committee spreadsheet back to Aug 2022). Baselines are the trailing 12-week average and the same week last year; capacity ceilings come from the targets table where set.</div>

      <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
        <div className="px-4 py-3 border-b bg-emerald-50 flex items-baseline gap-3 flex-wrap">
          <div className="text-sm font-bold text-gray-800">💰 Commission Pipeline</div>
          <div className="text-xs text-gray-500">Listed + Under LOI est. commission (both sides — buyside LOIs count since 09/26), weekly</div>
          <div className="ml-auto flex items-baseline gap-4">
            <div className="text-lg font-bold text-emerald-700">{latestCur == null ? '—' : fmtMoney(latestCur)}</div>
            {latestCur != null && samePrior != null && (
              <div className={`text-xs font-semibold ${latestCur >= samePrior ? 'text-emerald-700' : 'text-amber-600'}`} title={`Same week last year: ${fmtMoney(samePrior)}`}>
                {latestCur >= samePrior ? '▲' : '▼'} {fmtMoneyShort(Math.abs(latestCur - samePrior))} vs yr ago
              </div>
            )}
          </div>
        </div>
        <div className="p-3">
          <div className="flex items-center gap-4 mb-1 text-xs text-gray-600">
            <span className="inline-flex items-center gap-1.5"><span className="inline-block w-4 h-0.5 rounded" style={{ background: CUR_COLOR }} /> Trailing 52 weeks</span>
            <span className="inline-flex items-center gap-1.5"><svg width="16" height="2"><line x1="0" y1="1" x2="16" y2="1" stroke={PRIOR_COLOR} strokeWidth="2" strokeDasharray="4 3" /></svg> Same weeks, prior year</span>
            <span className="text-gray-400" title="The hand-kept committee sheet skipped some weeks — missing points are linearly estimated between their neighbors and marked (est.) in the tooltip.">· gaps estimated</span>
          </div>
          <div className="relative">
            <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ maxHeight: 240 }}
              onMouseMove={e => {
                const r = e.currentTarget.getBoundingClientRect();
                const px = (e.clientX - r.left) / r.width * W;
                const idx = Math.round((px - PAD_L) / (W - PAD_L - PAD_R) * 51);
                setHoverIdx(idx >= 0 && idx <= 51 ? idx : null);
              }}
              onMouseLeave={() => setHoverIdx(null)}>
              {[0.25, 0.5, 0.75, 1].map(f => (
                <g key={f}>
                  <line x1={PAD_L} x2={W - PAD_R} y1={y(yMax * f)} y2={y(yMax * f)} stroke="#f3f4f6" strokeWidth="1" />
                  <text x={PAD_L - 5} y={y(yMax * f) + 3} textAnchor="end" fontSize="9" fill="#9ca3af">{fmtMoneyShort(yMax * f)}</text>
                </g>
              ))}
              <line x1={PAD_L} x2={W - PAD_R} y1={H - PAD_B} y2={H - PAD_B} stroke="#e5e7eb" strokeWidth="1" />
              {monthTicks.map(({ w, i }) => (
                <text key={w} x={x(i)} y={H - 6} textAnchor="middle" fontSize="9" fill="#9ca3af">{new Date(w + 'T00:00:00').toLocaleDateString(undefined, { month: 'short', year: '2-digit' })}</text>
              ))}
              <path d={pathOf(prior)} fill="none" stroke={PRIOR_COLOR} strokeWidth="2" strokeDasharray="5 4" strokeLinejoin="round" />
              <path d={pathOf(cur)} fill="none" stroke={CUR_COLOR} strokeWidth="2" strokeLinejoin="round" />
              {hoverIdx != null && (
                <g>
                  <line x1={x(hoverIdx)} x2={x(hoverIdx)} y1={PAD_T} y2={H - PAD_B} stroke="#d1d5db" strokeWidth="1" />
                  {cur[hoverIdx] != null && <circle cx={x(hoverIdx)} cy={y(cur[hoverIdx])} r="4" fill={CUR_COLOR} stroke="#fff" strokeWidth="2" />}
                  {prior[hoverIdx] != null && <circle cx={x(hoverIdx)} cy={y(prior[hoverIdx])} r="4" fill={PRIOR_COLOR} stroke="#fff" strokeWidth="2" />}
                </g>
              )}
            </svg>
            {hoverIdx != null && (cur[hoverIdx] != null || prior[hoverIdx] != null) && (
              <div className="absolute top-1 pointer-events-none bg-white border border-gray-200 rounded shadow-sm px-2.5 py-1.5 text-xs" style={{ left: `${(x(hoverIdx) / W) * 100}%`, transform: hoverIdx > 34 ? 'translateX(-105%)' : 'translateX(8px)' }}>
                <div className="font-semibold text-gray-700 mb-0.5">wk of {new Date(weeksAsc[hoverIdx] + 'T00:00:00').toLocaleDateString()}</div>
                {cur[hoverIdx] != null && <div className="text-gray-800"><span className="inline-block w-2 h-2 rounded-full mr-1" style={{ background: CUR_COLOR }} />{fmtMoney(cur[hoverIdx])}{curI.est[hoverIdx] && <span className="text-gray-400"> (est.)</span>}</div>}
                {prior[hoverIdx] != null && <div className="text-gray-600"><span className="inline-block w-2 h-2 rounded-full mr-1" style={{ background: PRIOR_COLOR }} />{fmtMoney(prior[hoverIdx])} <span className="text-gray-400">yr ago{priorI.est[hoverIdx] ? ' (est.)' : ''}</span></div>}
              </div>
            )}
          </div>
          <details className="mt-1">
            <summary className="text-[11px] text-gray-400 cursor-pointer select-none">table view</summary>
            <table className="text-xs mt-1">
              <thead><tr><th className="pr-3 text-left text-gray-500">Week</th><th className="pr-3 text-right text-gray-500">Pipeline</th><th className="text-right text-gray-500">Yr ago</th></tr></thead>
              <tbody>{weeksAsc.slice(-12).map((w, k) => { const i = 40 + k; return (
                <tr key={w}><td className="pr-3 text-gray-600">{w}</td><td className="pr-3 text-right">{cur[i] == null ? '—' : fmtMoney(cur[i])}</td><td className="text-right text-gray-500">{prior[i] == null ? '—' : fmtMoney(prior[i])}</td></tr>
              ); })}</tbody>
            </table>
          </details>
        </div>
      </div>

      {seMeetings && seMeetings.length > 0 && (
        <Block title="📅 Meetings — booked vs held (calendar truth)" tone="bg-sky-50" rows={[
          { key: 'meetings_booked', label: 'Meetings Booked (tracked funnel meetings — reconciles to the funnels below)', live: bookedByWeek },
          { key: 'meetings_held', label: 'Meetings Held ✓ (Fireflies-verified or confirmed)', live: heldByWeek },
          { key: 'meetings_no_show', label: 'Didn’t Happen ✗ (confirmed no-shows)', live: noShowByWeek },
        ]} />
      )}

      {seMeetings && seMeetings.length > 0 && (
        <React.Fragment>
          <Block title="🔵 Sellside Funnel — meetings by week" tone="bg-blue-50" rows={
            SELL_FUNNEL.map(([k, label]) => ({ key: 'meetings_' + k, label, live: sellWeeks[k], cross: calCross[k] || null }))
          } />
          <Block title="🟣 Buyside Funnel — meetings by week" tone="bg-violet-50" rows={
            BUY_FUNNEL.map(([k, label]) => ({ key: 'meetings_' + k, label, live: buyWeeks[k] }))
          } />
          <div className="flex flex-wrap items-center gap-2 -mt-3 mb-6 text-xs text-gray-600">
            <span className="bg-white border border-gray-200 rounded px-2.5 py-1" title="Distinct businesses with a FUTURE funnel meeting on the calendar (strategic reviews and never-counted types excluded) — Mark's old sheet's 'Prospective with Next Meeting Set' column, live.">
              Prospective w/ next meeting set: <span className="font-semibold">{prospectiveNextMeeting.size}</span>
            </span>
            {bsStocks && (
              <React.Fragment>
                <span className="bg-white border border-gray-200 rounded px-2.5 py-1" title="Buyers whose buyside status is Engaged — paying buyside clients.">
                  Engaged BS clients: <span className="font-semibold">{bsStocks.engaged}</span>
                </span>
                <span className="bg-white border border-gray-200 rounded px-2.5 py-1" title="Buyers marked Active or Very Active on buyside status — the working pool behind the pitches.">
                  Active buyside prospects: <span className="font-semibold">{bsStocks.active}</span>
                </span>
              </React.Fragment>
            )}
            <span className="text-gray-400">Post-intro follow-ups are tracked on the buyer↔owner pair (Closing Engine lane), not counted here. Buyer-only, vendor, and personal meetings are excluded by rule.</span>
          </div>
        </React.Fragment>
      )}

      {(() => {
        // ── 📅 Monthly Meetings chart (ROADMAP #12 wiring, 2026-08-06) — the
        // committee meeting chart, born with the sheet's history: booked
        // totals under monthly_meetings_* (imported 2020–2025; live from
        // Aug 2026 via the calendar-sync cron writing the SAME keys). The
        // sheet died mid-2026, so Jan–Jul 2026 stays an honest gap in the
        // line — pathing skips nulls rather than interpolating across it.
        const mAsc = [];
        { const now = new Date(); for (let i = 24; i >= 0; i--) { const dt = new Date(now.getFullYear(), now.getMonth() - i, 1); mAsc.push(`${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-01`); } }
        const tot = mAsc.map(mo => val('monthly_meetings_total', mo));
        if (!tot.some(v => v != null)) return null;
        const MW = 760, MH = 150, MPL = 30, MPR = 10, MPT = 12, MPB = 20;
        const mMax = Math.max(1, ...tot.filter(v => v != null)) * 1.08;
        const mx = (i) => MPL + i * (MW - MPL - MPR) / (mAsc.length - 1);
        const my = (v) => MPT + (MH - MPT - MPB) * (1 - v / mMax);
        const mPath = tot.map((v, i) => v == null ? null : `${tot[i - 1] == null ? 'M' : 'L'}${mx(i).toFixed(1)},${my(v).toFixed(1)}`).filter(Boolean).join(' ');
        const curMonth = mAsc[mAsc.length - 1];
        const curTot = val('monthly_meetings_total', curMonth);
        const yTicks = [0, Math.ceil(mMax / 2 / 1.08), Math.round(mMax / 1.08)];
        const typeChips = [
          ['Sellside 1st-time', 'monthly_meetings_first_time'], ['Re-engage', 'monthly_meetings_reengage'],
          ['Discovery', 'monthly_meetings_discovery'], ['Valuation mtg', 'monthly_meetings_valuation_meeting'],
          ['Strategic review', 'monthly_meetings_strategic_review'],
          ['BSC interest', 'monthly_meetings_bsc_interest'], ['Buyside intro', 'monthly_meetings_buyside_intro'],
          ['Buyside pitch', 'monthly_meetings_buyside_call'], ['Listing (legacy)', 'monthly_meetings_listing'],
        ];
        return (
          <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
            <div className="px-4 py-3 border-b bg-sky-50 flex items-baseline gap-3 flex-wrap">
              <div className="text-sm font-bold text-gray-800">📅 Monthly Meetings</div>
              <div className="text-xs text-gray-500">booked meeting totals — sheet history (2020–Dec '25, narrower basket) · Jan–Jul '26 partially reconstructed from VT records · Aug '26 onward live from the calendar sync on the full funnel definition; meeting volume is the first indicator of success</div>
              <div className="ml-auto text-lg font-bold text-sky-700">{curTot == null ? '—' : curTot}<span className="text-xs font-normal text-gray-500 ml-1">this month</span></div>
            </div>
            <svg viewBox={`0 0 ${MW} ${MH}`} className="w-full" style={{ maxHeight: 170 }}>
              {yTicks.map(v => (
                <g key={v}>
                  <line x1={MPL} x2={MW - MPR} y1={my(v)} y2={my(v)} stroke="#f1f5f9" strokeWidth="1" />
                  <text x={MPL - 4} y={my(v) + 3} textAnchor="end" fontSize="8" fill="#94a3b8">{v}</text>
                </g>
              ))}
              {mAsc.map((mo, i) => (i % 3 === 0 ? <text key={mo} x={mx(i)} y={MH - 6} textAnchor="middle" fontSize="8" fill="#94a3b8">{new Date(mo + 'T00:00:00').toLocaleDateString(undefined, { month: 'short', year: '2-digit' })}</text> : null))}
              <path d={mPath} fill="none" stroke="#0284c7" strokeWidth="2" />
              {tot.map((v, i) => v == null ? null : <circle key={i} cx={mx(i)} cy={my(v)} r="2.5" fill="#0284c7" />)}
            </svg>
            <div className="px-4 pb-3 flex flex-wrap items-center gap-2 text-xs text-gray-600">
              {typeChips.map(([label, k]) => (
                <span key={k} className="bg-gray-50 border border-gray-200 rounded px-2 py-0.5">{label}: <span className="font-semibold">{val(k, curMonth) == null ? 0 : val(k, curMonth)}</span></span>
              ))}
              <span className="text-gray-400 ml-auto">this month by type — unclassified meetings count once the SE confirm queue types them</span>
            </div>
          </div>
        );
      })()}

      <Block title="📊 Pipeline Report" tone="bg-blue-50" rows={[
        { key: 'listed_not_marketed', label: 'Listed, Yet to be Marketed (CIM in build)' },
        { key: 'valued_awaiting_decision', label: 'Valued (awaiting decision + valuation meeting set)' },
        { key: 'uploaded_for_valuation', label: 'Uploaded for Valuation (upload complete → analysis)' },
      ]} />

      <Block title="🔽 Valuation Funnel" tone="bg-purple-50" rows={[
        { key: 'discovery_completed', label: 'Discovery Meetings Completed (dated that week)', live: discByWeek },
        { key: 'still_uploading', label: 'Requested Valuation (discovery had, uploading)' },
        { key: 'revalue_requested', label: 'Revalue Requested' },
      ]} />

      <Block title="🏷 Market Activity" tone="bg-green-50" rows={[
        { key: 'newly_marketed', label: 'Newly Marketed Listings', live: marketedByWeek },
        { key: 'sold_closed', label: 'Sold (closings)', live: soldByWeek },
      ]} />

      {(() => {
        // ── B3 Monthly Scorecard (METRICS-SPEC ★ PHASE B; built 2026-07-27) —
        // the live successor to the Lead-Gen sheet's monthly rows. Last 13
        // months from live systems: DM buyers · VT discovery/valuations
        // (+ imported Zoho valuation events) · DM market dates · signed LOIs
        // (live log + imported history) · weekly commission_pipeline month-end
        // · closings. Goal figures come from the targets table's 30d rows
        // (≈ a month). Deeper history lives in Annual History below —
        // deliberately different keys are NOT written here; the monthly_*
        // series stays import-only until live data needs to extend it.
        const monthKey = (d) => String(d || '').slice(0, 7);
        const months = [];
        { const now = new Date(); for (let i = 0; i < 13; i++) { const dt = new Date(now.getFullYear(), now.getMonth() - i, 1); months.push(`${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`); } }
        const zero = () => ({ buyers: null, discovery: 0, vals: 0, valSum: 0, valN: 0, listings: 0, lois: 0, sold: 0, cash: 0, engaged: 0, pipeEnd: null, pipeEndWeek: '' });
        const by = {}; months.forEach(m => { by[m] = zero(); });
        const bump = (m, k, v = 1) => { if (by[m]) by[m][k] += v; };
        const seenDisc = new Set();
        (valuationHistory || []).forEach(v => {
          if (v.discovery_meeting_date) {
            const k = `${v.client_id}|${v.discovery_meeting_date}`;
            if (!seenDisc.has(k)) { seenDisc.add(k); bump(monthKey(v.discovery_meeting_date), 'discovery'); }
          }
          if (v.valuation_date) {
            const m = monthKey(v.valuation_date);
            bump(m, 'vals');
            const val = Number(v.value_provided_high) || 0;
            if (val > 0) { bump(m, 'valSum', val); bump(m, 'valN'); }
          }
        });
        (importedEvents || []).forEach(e => {
          if (!e.event_date) return;
          if (e.kind === 'valuation') {
            const m = monthKey(e.event_date);
            bump(m, 'vals');
            const val = Number(e.value) || 0;
            if (val > 0) { bump(m, 'valSum', val); bump(m, 'valN'); }
          }
          if (e.kind === 'loi_signed') bump(monthKey(e.event_date), 'lois');
        });
        (Array.isArray(loiSignings) ? loiSignings : []).forEach(s => { const d = typeof s === 'string' ? s : s && s.d; if (d) bump(monthKey(d), 'lois'); });
        (dmListings || []).forEach(l => { if (l.market_date) bump(monthKey(l.market_date), 'listings'); });
        (dmClosings || []).forEach(c => {
          if (!c.closing_date) return;
          const m = monthKey(c.closing_date);
          bump(m, 'sold');
          bump(m, 'cash', Number(c.cash_commissions != null ? c.cash_commissions : c.commissions_collected_at_close) || 0);
        });
        (stageEvents || []).forEach(e => { if (e.metadata && e.metadata.to === 'engaged') bump(monthKey(e.at), 'engaged'); });
        (metricSnapshots || []).forEach(r => {
          if (r.metric_key !== 'commission_pipeline') return;
          const m = monthKey(r.week_of);
          if (by[m] && r.week_of > by[m].pipeEndWeek) { by[m].pipeEnd = Number(r.value) || 0; by[m].pipeEndWeek = r.week_of; }
        });
        if (buyersByMonth) months.forEach(m => { by[m].buyers = buyersByMonth[m] || 0; });
        // Monthly goal ≈ the 30d target (current effective row).
        const todayIso2 = new Date().toISOString().slice(0, 10);
        const goal30 = (key) => {
          const rows = (targets || [])
            .filter(t => t.metric_key === key && t.period === '30d' && t.effective_from <= todayIso2 && (!t.effective_to || t.effective_to >= todayIso2))
            .sort((a, b) => (a.effective_from < b.effective_from ? 1 : -1));
          return rows.length ? Number(rows[0].value) : null;
        };
        const gDisc = goal30('discovery_meetings'), gVals = goal30('valuations');
        const mLabel = (m, i) => { const dt = new Date(m + '-01T00:00:00'); const s = dt.toLocaleDateString(undefined, { month: 'short', year: '2-digit' }); return i === 0 ? `${s} (MTD)` : s; };
        const num = (v) => (v == null ? <span className="text-gray-300">—</span> : v);
        const Thm = ({ children, title }) => <th className="px-2.5 py-2 text-[11px] font-bold uppercase tracking-wide text-gray-600 text-right whitespace-nowrap" title={title || ''}>{children}</th>;
        // Engaged/Sold monthly line chart (12 full months, ascending).
        const chartMonths = [...months].reverse();
        const engSeries = chartMonths.map(m => by[m].engaged);
        const soldSeries = chartMonths.map(m => by[m].sold);
        const CW = 760, CH = 130, PL = 26, PR = 10, PT = 12, PB = 20;
        const maxV = Math.max(1, ...engSeries, ...soldSeries);
        const cx = (i) => PL + i * (CW - PL - PR) / (chartMonths.length - 1);
        const cy = (v) => PT + (CH - PT - PB) * (1 - v / maxV);
        const pathOfM = (arr) => arr.map((v, i) => `${i ? 'L' : 'M'}${cx(i).toFixed(1)},${cy(v).toFixed(1)}`).join(' ');
        return (
          <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
            <div className="px-4 py-3 border-b bg-indigo-50 flex items-baseline gap-2 flex-wrap">
              <span className="text-sm font-bold text-gray-800">📅 Monthly Scorecard</span>
              <span className="text-xs text-gray-500">last 13 months, live from VT + DM + closings — the Lead-Gen sheet's successor (older years: Annual History below)</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="border-b bg-gray-50">
                  <th className="px-2.5 py-2 text-[11px] font-bold uppercase tracking-wide text-gray-600 text-left">Month</th>
                  <Thm title="New buyers created in Deal Manager that month.">New Buyers</Thm>
                  <Thm title="Discovery meetings held (deduped per client per date). VT-native — months before VT under-count.">Discovery</Thm>
                  <Thm title="Valuations completed: VT valuation dates + the imported Zoho history.">Valuations</Thm>
                  <Thm title="Sum of value-provided (top of range) for that month's valuations, where known.">Valued $</Thm>
                  <Thm title="Average value-provided per valuation with a known value.">Avg Size</Thm>
                  <Thm title="Listings whose marketing started that month (DM market dates).">New Listings</Thm>
                  <Thm title="LOIs signed: DM's live status log + the imported loi_signed history.">LOIs Signed</Thm>
                  <Thm title="Listed + Under-LOI est. commission at month end (latest weekly snapshot in the month).">Listed/LOI $ </Thm>
                  <Thm title="Deals closed that month (closings record).">Sold</Thm>
                  <Thm title="Cash commissions on that month's closings.">Cash Comm.</Thm>
                </tr></thead>
                <tbody>
                  {(gDisc != null || gVals != null || canEditTargets) && (
                    <tr className="border-b border-gray-100 bg-emerald-50/50">
                      <td className="px-2.5 py-1.5 text-xs font-semibold text-emerald-800 whitespace-nowrap">Goal (30d targets)
                        {/* Owner-only goal editing lives HERE now — the gauges are
                            deliberately trend-not-quota (07-22), so the old 🎯
                            editor was unreachable; the scorecard is where goals
                            actually display. Writes effective-dated target rows. */}
                        {canEditTargets && onSaveTarget && (
                          <button type="button" className="ml-1.5 text-emerald-600 hover:text-emerald-800" title="Edit the 30-day goals (writes a new effective-dated row to the targets table — lineage preserved)." onClick={async () => {
                            const d = window.prompt('Discovery meetings goal (per 30 days):', gDisc != null ? String(gDisc) : '');
                            if (d !== null && String(d).trim() !== '' && !isNaN(Number(d))) await onSaveTarget('discovery_meetings', '30d', Number(d));
                            const v = window.prompt('Valuations completed goal (per 30 days):', gVals != null ? String(gVals) : '');
                            if (v !== null && String(v).trim() !== '' && !isNaN(Number(v))) await onSaveTarget('valuations', '30d', Number(v));
                          }}>✎</button>
                        )}
                      </td>
                      <td className="px-2.5 py-1.5 text-right text-xs text-gray-400">—</td>
                      <td className="px-2.5 py-1.5 text-right text-xs font-semibold text-emerald-800">{gDisc != null ? gDisc : '—'}</td>
                      <td className="px-2.5 py-1.5 text-right text-xs font-semibold text-emerald-800">{gVals != null ? gVals : '—'}</td>
                      <td colSpan={7} className="px-2.5 py-1.5 text-right text-xs text-gray-400">other goals live in the targets table when set</td>
                    </tr>
                  )}
                  {months.map((m, i) => {
                    const r = by[m];
                    return (
                      <tr key={m} className="border-b border-gray-100">
                        <td className="px-2.5 py-1.5 font-medium text-gray-800 whitespace-nowrap">{mLabel(m, i)}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-700">{num(r.buyers)}</td>
                        <td className={`px-2.5 py-1.5 text-right ${gDisc != null && r.discovery >= gDisc ? 'text-emerald-700 font-semibold' : 'text-gray-700'}`}>{r.discovery}</td>
                        <td className={`px-2.5 py-1.5 text-right ${gVals != null && r.vals >= gVals ? 'text-emerald-700 font-semibold' : 'text-gray-700'}`}>{r.vals}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-700">{r.valSum > 0 ? fmtMoneyShort(r.valSum) : <span className="text-gray-300">—</span>}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-500">{r.valN > 0 ? fmtMoneyShort(r.valSum / r.valN) : <span className="text-gray-300">—</span>}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-700">{r.listings}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-700">{r.lois}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-700">{r.pipeEnd != null ? fmtMoneyShort(r.pipeEnd) : <span className="text-gray-300">—</span>}</td>
                        <td className={`px-2.5 py-1.5 text-right ${r.sold > 0 ? 'text-emerald-700 font-semibold' : 'text-gray-500'}`}>{r.sold}</td>
                        <td className="px-2.5 py-1.5 text-right text-gray-700">{r.cash > 0 ? fmtMoneyShort(r.cash) : <span className="text-gray-300">—</span>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="px-4 pt-3 pb-1 flex items-center gap-4 text-xs text-gray-500">
              <span className="font-semibold text-gray-700">Engaged & Sold by month</span>
              <span><span className="inline-block w-3 h-0.5 bg-indigo-500 align-middle mr-1"></span>Engaged <span className="text-gray-400">(stage log since May '26)</span></span>
              <span><span className="inline-block w-3 h-0.5 bg-emerald-600 align-middle mr-1"></span>Sold</span>
            </div>
            <svg viewBox={`0 0 ${CW} ${CH}`} className="w-full" style={{ maxHeight: 150 }}>
              {[0, Math.ceil(maxV / 2), maxV].map(v => (
                <g key={v}>
                  <line x1={PL} x2={CW - PR} y1={cy(v)} y2={cy(v)} stroke="#f1f5f9" strokeWidth="1" />
                  <text x={PL - 4} y={cy(v) + 3} textAnchor="end" fontSize="8" fill="#94a3b8">{v}</text>
                </g>
              ))}
              {chartMonths.map((m, i) => (i % 2 === 0 ? <text key={m} x={cx(i)} y={CH - 6} textAnchor="middle" fontSize="8" fill="#94a3b8">{new Date(m + '-01T00:00:00').toLocaleDateString(undefined, { month: 'short' })}</text> : null))}
              <path d={pathOfM(soldSeries)} fill="none" stroke="#059669" strokeWidth="2" />
              <path d={pathOfM(engSeries)} fill="none" stroke="#6366f1" strokeWidth="2" />
              {soldSeries.map((v, i) => <circle key={`s${i}`} cx={cx(i)} cy={cy(v)} r="2.5" fill="#059669" />)}
              {engSeries.map((v, i) => <circle key={`e${i}`} cx={cx(i)} cy={cy(v)} r="2.5" fill="#6366f1" />)}
            </svg>
          </div>
        );
      })()}

      {(() => {
        // ── 🎯 Valuation → Decision (Mark 10-19) — see valDecisionStats.
        const ds = valDecisionStats(stageEvents);
        const allM = [...new Set(Object.values(ds).flatMap(o => Object.keys(o)))].sort();
        if (!allM.length) return null;
        const since = allM[0];
        const months = [];
        { const now = new Date(); for (let i = 0; i < 13; i++) { const dt = new Date(now.getFullYear(), now.getMonth() - i, 1); months.push(`${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`); } }
        const g = (f, m) => ds[f][m] || 0;
        const tot = (f) => Object.values(ds[f]).reduce((a, b) => a + b, 0);
        const pct = (a, b) => (b > 0 ? `${Math.round(a / b * 100)}%` : '—');
        const label = (m) => new Date(m + '-01T00:00:00').toLocaleDateString(undefined, { month: 'short', year: '2-digit' });
        const th = 'px-2.5 py-2 text-[11px] font-bold uppercase tracking-wide text-gray-600 text-right whitespace-nowrap';
        const td = 'px-2.5 py-1.5 text-right text-gray-700';
        const row = (key, lab, p, e, st, ef, ea, bold) => (
          <tr key={key} className={`border-b border-gray-100 ${bold ? 'bg-violet-50 font-semibold' : ''}`}>
            <td className="px-2.5 py-1.5 text-gray-800 whitespace-nowrap">{lab}</td>
            <td className={td}>{p}</td><td className={td}>{e}</td><td className={td}>{st}</td>
            <td className={`${td} font-semibold text-violet-800`}>{pct(e, p)}</td>
            <td className={td}>{ef}</td><td className={td}>{ea}</td>
          </tr>
        );
        return (
          <div className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
            <div className="px-4 py-3 border-b bg-violet-50 flex items-baseline gap-2 flex-wrap">
              <span className="text-sm font-bold text-gray-800">🎯 Valuation → Decision</span>
              <span className="text-xs text-gray-500">what owners do after the valuation meeting, live from VT's stage log (since {label(since)}). The yearly close rate back to 2020 is in Annual History below.</span>
            </div>
            <div className="overflow-x-auto"><table className="w-full text-sm">
              <thead><tr className="border-b bg-gray-50">
                <th className="px-2.5 py-2 text-[11px] font-bold uppercase tracking-wide text-gray-600 text-left">Month</th>
                <th className={th} title="Valuations presented: deals moved to Awaiting decision (once per deal per month).">Presented</th>
                <th className={th} title="Signed the engagement agreement (the first time a deal reaches Engaged).">Engaged</th>
                <th className={th} title="The owner chose the plan: moved to the 6-month strategic review.">→ Strategic review</th>
                <th className={th} title="Engaged ÷ presented in the same period. Owners often decide a month or more later, so single months swing; read the total.">Close rate</th>
                <th className={th} title="Engaged with no earlier 'not now' in VT: no strategic review, considering, or inactive stage before signing.">Engaged: first decision</th>
                <th className={th} title="Engaged after a strategic review, 'considering, follow up', or an inactive spell. VT stages only: a review meeting with no stage change isn't counted here.">Engaged: after review / follow-up</th>
              </tr></thead>
              <tbody>
                {months.filter(m => m >= since).map(m => row(m, label(m), g('presented', m), g('engaged', m), g('strategic', m), g('engagedFirst', m), g('engagedAfter', m)))}
                {row('tot', `Since ${label(since)}`, tot('presented'), tot('engaged'), tot('strategic'), tot('engagedFirst'), tot('engagedAfter'), true)}
              </tbody>
            </table></div>
          </div>
        );
      })()}

      {(() => {
        // ── Annual History (Mark 2026-07-23): the Monthly Activity sheet's
        // series preserved and surfaced YEARLY — viewed periodically, so
        // collapsed. Flows sum across the year; stocks (pipeline $, listed
        // count) show the year's monthly average. Outbound volumes resume
        // live when the Sales Engine lands, continuing these same series.
        const monthly = {};
        (metricSnapshots || []).forEach(s => {
          if (!String(s.metric_key).startsWith('monthly_')) return;
          const y = String(s.week_of).slice(0, 4);
          const k = s.metric_key;
          (monthly[k] = monthly[k] || {})[y] = (monthly[k][y] || []).concat(Number(s.value) || 0);
        });
        // 2026+ (Mark 10-19): the sheet's series ended Dec '25. Continue Valuations Completed + New Listings live
        // (the Monthly Scorecard's sources) for years past the last imported one, and add the VT decision series.
        {
          const lastV = Object.keys(monthly.monthly_valuations_completed || {}).sort().pop() || '0';
          const lastL = Object.keys(monthly.monthly_new_listings || {}).sort().pop() || '0';
          const addY = (key, y, n) => { const m = (monthly[key] = monthly[key] || {}); m[y] = [((m[y] && m[y][0]) || 0) + n]; };
          (valuationHistory || []).forEach(v => { const y = String(v.valuation_date || '').slice(0, 4); if (y && y > lastV) addY('monthly_valuations_completed', y, 1); });
          (importedEvents || []).forEach(e => { const y = String(e.event_date || '').slice(0, 4); if (e.kind === 'valuation' && y && y > lastV) addY('monthly_valuations_completed', y, 1); });
          (dmListings || []).forEach(l => { const y = String(l.market_date || '').slice(0, 4); if (y && y > lastL) addY('monthly_new_listings', y, 1); });
          const ds = valDecisionStats(stageEvents);
          [['vt_presented', 'presented'], ['vt_engaged', 'engaged'], ['vt_strategic', 'strategic'], ['vt_engaged_after', 'engagedAfter']]
            .forEach(([k, f]) => Object.entries(ds[f]).forEach(([ym, n]) => addY(k, ym.slice(0, 4), n)));
        }
        const HIST_ROWS = [
          ['— Lead Generation —', null, null],
          ['New Prospective Businesses', 'monthly_new_prospective', 'sum'],
          ['New Buyers', 'monthly_new_buyers', 'sum'],
          ['Pre-Value Meetings', 'monthly_prevalue_meetings', 'sum'],
          // Meeting-type series (added 2026-07-27 — the sheet's skipped columns,
          // fed by Mark's calendar-naming-convention report; the Calendar sync
          // will continue these live under the same keys).
          ['Meetings — First-Time with Vista', 'monthly_meetings_first_time', 'sum'],
          ['Meetings — BSC Interest', 'monthly_meetings_bsc_interest', 'sum'],
          ['Meetings — Buyside Intro', 'monthly_meetings_buyside_intro', 'sum'],
          ['Meetings — Listing Discussion', 'monthly_meetings_listing', 'sum'],
          ['Meetings — Re-Engage', 'monthly_meetings_reengage', 'sum'],
          ['Meetings — Total', 'monthly_meetings_total', 'sum'],
          ['First-Time Buyside Calls', 'monthly_meetings_buyside_call', 'sum'],
          ['Valuations Completed', 'monthly_valuations_completed', 'sum'],
          ['Valued Pipeline $ (yr avg)', 'monthly_valued_pipeline', 'avgMoney'],
          ['New Listings', 'monthly_new_listings', 'sum'],
          ['Close Rate (New Listings ÷ Valuations)', 'pct:monthly_new_listings/monthly_valuations_completed', 'pct'],
          ['Listed/Under-LOI (yr avg)', 'monthly_listed_loi_count', 'avg'],
          ['Listed/LOI Pipeline $ (yr avg)', 'monthly_listed_loi_pipeline', 'avgMoney'],
          ['Sold', 'monthly_sold', 'sum'],
          ['Cash Commissions $', 'monthly_cash_commissions', 'sumMoney'],
          ['— Valuation → Decision (VT stage log, from May 2026) —', null, null],
          ['Valuations Presented', 'vt_presented', 'sum'],
          ['Engaged (signed)', 'vt_engaged', 'sum'],
          ['· after a strategic review / follow-up', 'vt_engaged_after', 'sum'],
          ['Moved to Strategic Review', 'vt_strategic', 'sum'],
          ['Close Rate (Engaged ÷ Presented)', 'pct:vt_engaged/vt_presented', 'pct'],
          ['— Outbound (Sales Engine continues these) —', null, null],
          ['Direct-Mail Letters Sent', 'monthly_direct_mail_sent', 'sum'],
          ['· to New Prospects', 'monthly_direct_mail_new', 'sum'],
          ['Sell-Side Emails Sent', 'monthly_sellside_emails', 'sum'],
          ['Buyside Letters Delivered', 'monthly_buyside_letters', 'sum'],
          ['· to New Prospects', 'monthly_buyside_letters_new', 'sum'],
          ['InMails Sent', 'monthly_inmails', 'sum'],
          ['· to New Prospects', 'monthly_inmails_new', 'sum'],
        ];
        const years = [...new Set(Object.values(monthly).flatMap(m => Object.keys(m)))].sort();
        if (!years.length) return null;
        const agg = (key, y, mode) => {
          if (mode === 'pct') {
            const [a, b] = key.slice(4).split('/');
            const sum = (k) => ((monthly[k] || {})[y] || []).reduce((p, q) => p + q, 0);
            const sb = sum(b);
            return sb > 0 ? `${Math.round(sum(a) / sb * 100)}%` : null;
          }
          const vs = (monthly[key] || {})[y];
          if (!vs || !vs.length) return null;
          const s = vs.reduce((a, b) => a + b, 0);
          const v = mode.startsWith('avg') ? s / vs.length : s;
          return mode.endsWith('Money') ? fmtMoneyShort(v) : Math.round(v * 10) / 10;
        };
        return (
          <details className="bg-white border border-gray-200 rounded-lg mb-6 overflow-hidden">
            <summary className="px-4 py-3 border-b bg-amber-50 cursor-pointer select-none">
              <span className="text-sm font-bold text-gray-800">📚 Annual History</span>
              <span className="text-xs text-gray-500 ml-2">the Monthly Activity spreadsheet's series ({years[0]}–{years[years.length - 1]}), preserved — periodic viewing, not weekly business</span>
            </summary>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="border-b bg-gray-50">
                  <th className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-left">Metric</th>
                  {years.map(y => <th key={y} className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-right">{y}</th>)}
                </tr></thead>
                <tbody>
                  {HIST_ROWS.map(([label, key, mode], i) => key === null
                    ? <tr key={i} className="border-b bg-gray-50"><td colSpan={years.length + 1} className="px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-gray-400">{label}</td></tr>
                    : (
                      <tr key={i} className="border-b border-gray-100">
                        <td className="px-3 py-1.5 text-gray-700">{label}</td>
                        {years.map(y => { const v = agg(key, y, mode); return <td key={y} className="px-3 py-1.5 text-right whitespace-nowrap text-gray-600">{v == null ? '—' : (typeof v === 'number' ? v.toLocaleString() : v)}</td>; })}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </details>
        );
      })()}

    </div>
  );
};

const CadenceQueueSection = ({ items, onCompose, listedKeys = null }) => {
  if (!items || items.length === 0) return null;
  const fmtDate = (d) => {
    if (!d) return '—';
    const dt = new Date(d + 'T00:00:00');
    return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString();
  };
  const deEnt = (s) => String(s || '')
    .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
    .replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ');
  // The glance rule, extended to the reminder queue (Konnie/Nimbus Net 09-14:
  // Thatcher's first-mile "Almost there" went out at 7:54 and the FINAL card
  // sat on her plate the same morning with no hint — she had to ask). The card
  // shows the last correspondence either direction, and shouts when a teammate
  // emailed the owner in the last 3 days so she can space or fold the reminder.
  const corrGlance = (p) => {
    const m = p.emailTruth && p.emailTruth.lastMsg;
    if (!m) return null;
    const days = Math.floor((Date.now() - new Date(m.at).getTime()) / 86400000);
    const d = new Date(m.at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    const recentVista = m.vistaFrom && days <= 3;
    return (
      <div className={`text-[11px] rounded px-2 py-1 mb-3 ${recentVista ? 'bg-amber-50 border border-amber-300 text-amber-800' : 'text-gray-500'}`} title={`${deEnt(m.subject)}\n${deEnt(m.snippet)}`}>
        {recentVista
          ? <>⚠ <b>{m.who} emailed the owner {days === 0 ? 'today' : days === 1 ? 'yesterday' : days + 'd ago'}</b> (“{deEnt(String(m.subject || '')).slice(0, 60)}”) — two nudges in one breath overwhelm; space this reminder or fold it into that thread.</>
          : <>💬 Last: {d} ({days}d ago), {m.vistaFrom ? `${m.who} → owner` : 'THE OWNER wrote'} — “{deEnt(String(m.snippet || m.subject)).replace(/\s+/g, ' ').slice(0, 80)}”</>}
      </div>
    );
  };
  const finalCount = items.filter(i => i.cadence.cadenceFinal).length;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-emerald-700">
        📨 Reminder queue <span className="text-gray-400 font-normal">({items.length})</span>
        {finalCount > 0 && (
          <span className="ml-2 text-[10px] font-bold text-red-700 bg-red-50 border border-red-200 rounded px-1.5 py-0.5 align-middle">
            {finalCount} final
          </span>
        )}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => {
          const isFinal = !!p.cadence.cadenceFinal;
          const variant = isFinal ? 'cadence-final' : 'cadence-weekly';
          const daysPastTarget = p._cadenceDaysPast != null ? p._cadenceDaysPast : 0;
          const lastUploadLine = p.cadence.lastUploadAt
            ? `Last upload ${new Date(p.cadence.lastUploadAt).toLocaleDateString()}`
            : 'No uploads yet';
          const lastReminderLine = p.cadence.lastReminderAt
            ? `Last reminder ${new Date(p.cadence.lastReminderAt).toLocaleDateString()}`
            : 'No prior reminder';
          const docsLine = p.docsTotal > 0 ? `${p.docsDone} of ${p.docsTotal} docs received` : 'Docs not tracked';
          return (
            <div
              key={p.id}
              className={`bg-white border rounded-lg p-4 ${isFinal ? 'border-red-300' : 'border-emerald-200'}`}
            >
              <div className="flex items-start justify-between gap-2 mb-1">
                <div className="flex items-center gap-2 min-w-0"><div className="font-semibold text-gray-800 truncate">{p.company_name}</div><ProvenanceChip p={p} /></div>
                <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap ${isFinal ? 'bg-red-100 text-red-700' : 'bg-emerald-100 text-emerald-700'}`}>
                  {isFinal ? 'Final follow-up' : 'Weekly check-in'}
                </span>
              </div>
              <div className="text-xs text-gray-500 mb-2">
                Target {fmtDate(p.cadence.targetDate)} · {daysPastTarget}d past
                {p.path === 'partial' && <span className="ml-1 text-blue-600">· Partial</span>}
              </div>
              <div className="text-xs text-gray-600 mb-1">{docsLine}</div>
              <div className="text-xs text-gray-400 mb-3">{lastUploadLine} · {lastReminderLine}</div>
              {corrGlance(p)}
              <ProjectChainToolbar p={p} />
              {/* ⚠ Listed awareness (Konnie/TechClarity 09-09): the owner is
                  mid-deal — the docs are usually wanted FOR the deal, so the
                  send stays; only the framing changes. */}
              {listedKeys && ((p.vista_id && listedKeys.vistas.has(String(p.vista_id).trim())) || listedKeys.names.has(listedKeys.norm(p.company_name))) && (
                <div className="text-[11px] bg-amber-50 border border-amber-300 rounded px-2 py-1 mb-3 text-amber-800">
                  ⚠ <b>This business is LISTED</b> — the owner is mid-deal. The documents are usually wanted <em>for</em> the deal, so send — but edit the email's frame to "keeping your buyer package current for diligence," not "completing your valuation." Loop the Lead if unsure.
                </div>
              )}
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => onCompose({ id: p.id, name: p.name, autoAction: variant })}
                  className={`px-3 py-1 text-xs font-semibold rounded ${isFinal ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-emerald-600 text-white hover:bg-emerald-700'}`}
                >
                  {isFinal ? 'Compose final' : 'Compose'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Revalue doc-curation: a revalue just started, so the docs gate is closed and
// Konnie needs to review the file, check the boxes for what this cycle needs,
// and release the curated list (which emails the owner). Amber theme. Opening a
// card takes her into the valuation, where the Setup tab's "Release document
// list to owner" CTA appears.
// Monthly financial-update cards for ENGAGED (on-market) deals — shown to
// Konnie AND the deal's Lead (Mark 2026-07-20: "the lead also needs to be
// made aware that financial data is out of date"). A listing's data must run
// through the last closed month; card fires from the 8th. Request → editable
// owner email; Pause → due diligence/closing (updates stop entering VT).
// Pre-discovery nudge cards (Mark 2026-07-23): the Lead's discovery meeting
// is inside 48h and the owner hasn't answered the portal questions — one
// click sends the check-in, as the Lead.
// First-Mile touches T2–T4 (spec § FIRST-MILE CADENCE): activity-gated
// informal check-ins during the quiet stretch discovery → first upload.
// One touch per deal, prewritten, sends as the Lead via the review modal.
const FirstMileSection = ({ items, onTouch, onOpen, onSetStars, onWaive, actor }) => {
  const COLORS = { T2: 'text-sky-700 bg-sky-100', T3: 'text-amber-700 bg-amber-100', T4: 'text-green-700 bg-green-100', T4b: 'text-red-700 bg-red-100', T5: 'text-purple-700 bg-purple-100' };
  // Snippets arrive with HTML entities baked in (Zac 09-11: "text is a bit
  // wonky" — I&#39;m rendering literally). Decode for display.
  const deEnt = (s) => String(s || '')
    .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
    .replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ');
  // The glance rule (Mark 09-11): every card shows the LAST CORRESPONDENCE
  // either direction, so the read is instant — silence → send the nudge;
  // a live exchange ("Konnie wrote, owner said on it") → waive and let
  // Konnie's cadence carry it. This section is the LEAD'S voice about the
  // DATE the owner chose; Konnie's weekly list email is a different job.
  const lastLine = (p) => {
    const m = p.emailTruth && p.emailTruth.lastMsg;
    if (!m) return <span className="text-xs font-semibold text-red-600">✂ No correspondence on record (60 days) — the nudge is overdue.</span>;
    const d = new Date(m.at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    const days = Math.floor((Date.now() - new Date(m.at).getTime()) / 86400000);
    return (
      <span className={`text-xs ${days >= 7 ? 'text-amber-700' : 'text-gray-600'}`} title={`${deEnt(m.subject)}\n${deEnt(m.snippet)}`}>
        💬 Last: {d} ({days}d ago), {m.vistaFrom ? `${m.who} → owner` : 'THE OWNER wrote'} — “{deEnt(String(m.snippet || m.subject)).replace(/\s+/g, ' ').slice(0, 90)}”
      </span>
    );
  };
  return (
    <div className="bg-white border border-sky-200 rounded-lg mb-4 overflow-hidden">
      <div className="px-4 py-2.5 bg-sky-50 border-b border-sky-200">
        <span className="text-sm font-bold text-sky-800">🏃 First mile — defend the owner's date</span>
        <span className="text-xs text-sky-600 ml-2">Konnie's weekly email is the LIST of missing items; these are YOUR voice about the DATE they chose ("progress is putting your date at risk"). Glance at the last correspondence: silence → send; a live exchange → waive and let Konnie's cadence carry it. Each fires once. ★ and likelihood order the queue.</span>
      </div>
      {items.map(p => (
        <div key={`${p.id}-${p.touch}`} className="px-4 py-2.5 border-b border-gray-100">
          <div className="flex items-center gap-3 flex-wrap">
            <StarRating p={p} onSet={onSetStars} />
            <button type="button" className="font-medium text-blue-700 hover:underline text-sm" onClick={() => onOpen && onOpen(p)}>{p.company_name}</button>
            <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${COLORS[p.touch] || 'text-gray-600 bg-gray-100'}`}>{p.touchLabel}</span>
            {(p.likelihood_pct || 0) >= 90 && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-800" title="Your own likelihood call — your best deals earn the personal touch first.">🔥 {p.likelihood_pct}%</span>}
            <span className="text-xs text-gray-500">{p.touchWhy}</span>
            {p.commPref === 'text' && <span className="text-xs font-semibold text-emerald-700">📱 prefers text{p.commPrefPhone ? ` · ${p.commPrefPhone}` : ''}</span>}
            {p.lead && <span className="text-xs text-gray-400">{p.lead}'s deal</span>}
            <span className="ml-auto flex items-center gap-1.5">
              <button type="button" className="px-2 py-1 rounded text-xs font-semibold border border-gray-300 text-gray-600 hover:bg-gray-50"
                title="Stand down: the correspondence shows this owner is engaged, so Konnie's weekly cadence carries it. Logged; this touch won't re-card."
                onClick={() => onWaive && onWaive(p)}>🤝 Konnie's cadence has it</button>
              <button type="button" className="px-3 py-1 rounded text-xs font-semibold bg-sky-600 text-white hover:bg-sky-700" onClick={() => onTouch(p)}>✉ Review &amp; send</button>
            </span>
          </div>
          <div className="mt-1 pl-1 flex items-center gap-2 flex-wrap">
            {/* 🧵 the judgment door (Zac 09-11: "If we could pull the email
                thread up to see, that would be helpful") — same toolbar as
                the owner-waiting card: Thread opens the full exchange. */}
            <CardToolbar valuationId={p.id} companyName={p.company_name} actor={actor} />
            {lastLine(p)}
          </div>
        </div>
      ))}
    </div>
  );
};

const DiscoveryPrepSection = ({ items, onNudge, onOpen, canNudge = true }) => {
  const fmtD = (d) => new Date(d + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  const todayIso = new Date().toISOString().slice(0, 10);
  return (
    <div className="bg-white border border-violet-200 rounded-lg mb-4 overflow-hidden">
      <div className="px-4 py-2.5 bg-violet-50 border-b border-violet-200">
        <span className="text-sm font-bold text-violet-800">🗓 Discovery prep — owner hasn't answered the questions</span>
        <span className="text-xs text-violet-600 ml-2">meeting within 24h; a quick check-in usually fixes it</span>
      </div>
      {items.map(p => (
        <div key={p.id} className="px-4 py-2.5 border-b border-gray-100 flex items-center gap-3 flex-wrap">
          <button type="button" className="font-medium text-blue-700 hover:underline text-sm" onClick={() => onOpen && onOpen(p)}>{p.company_name}</button>
          <span className={`text-xs font-semibold ${p.discovery_meeting_date === todayIso ? 'text-red-600' : 'text-amber-600'}`}>
            meeting {p.discovery_meeting_date === todayIso ? 'TODAY' : fmtD(p.discovery_meeting_date)}
          </span>
          {p.lead && <span className="text-xs text-gray-400">{p.lead}'s meeting</span>}
          <span className="text-xs text-gray-500">{p.discoveryAnswerCount ? `only ${p.discoveryAnswerCount} answered so far` : 'portal questions not answered'}</span>
          {/* The owner's other portal signals, so the check-in decision has
              full context (Mark 2026-07-24). */}
          {p.owner_target_valuation_date && <span className="text-xs text-green-700">🎯 wants value by {new Date(p.owner_target_valuation_date + 'T00:00:00').toLocaleDateString()}</span>}
          {(p.owner_intent || p.owner_priority) && (
            <span className="text-xs text-blue-700">
              💬 {[{ planning_ahead: 'planning ahead', selling_soon: 'selling soon', quick_estimate: 'quick estimate' }[p.owner_intent], { price: 'price', timing: 'timing', add_value: 'add value' }[p.owner_priority]].filter(Boolean).join(' · ')}
            </span>
          )}
          {/* The check-in is a relationship email that sends AS the Lead, so
              the AM's card is view-only — they see the gap and can call the
              owner or flag the Lead, not fire mail in the Lead's name. */}
          {canNudge ? (
            <button type="button" className="ml-auto px-3 py-1 rounded text-xs font-semibold bg-violet-600 text-white hover:bg-violet-700" onClick={() => onNudge(p)}>✉ Send check-in</button>
          ) : (
            <span className="ml-auto text-xs text-gray-400">the check-in email sends as {p.lead || 'the Lead'} — worth a call from you meanwhile</span>
          )}
        </div>
      ))}
    </div>
  );
};

const FinancialUpdatesSection = ({ items, onRequest, onPause, onOpen }) => {
  if (!items || items.length === 0) return null;
  const my = (iso) => new Date(iso).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-red-700">
        📉 On market — financials out of date <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => (
          <div key={p.id} className="bg-white border border-red-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
              <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap ${p._monthsBehind > 1 ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                {p._monthsBehind > 1 ? `${p._monthsBehind} months behind` : '1 month behind'}
              </span>
            </div>
            <p className="text-xs text-gray-600 mb-3">
              Data runs through <strong>{my(p._dataEndIso)}</strong>; buyers expect it through <strong>{my(p._needMonthIso)}</strong>.
              Request the updated TTM P&amp;L, Balance Sheet, and AR/AP aging — then re-enter, re-export, and refresh the listing's Financial Summary.
            </p>
            <ProjectChainToolbar p={p} />
            <div className="flex items-center justify-end gap-2">
              <button type="button" onClick={() => onPause(p)} className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-500 hover:text-gray-700" title="Stop these reminders for this deal — use when due diligence / closing has taken over and monthly updates are no longer entered into VT.">
                Pause (DD/closing)
              </button>
              <button type="button" onClick={() => onOpen({ id: p.id, name: p.name })} className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800">
                Open
              </button>
              <button type="button" onClick={() => onRequest(p)} className="px-3 py-1 text-xs font-semibold rounded bg-red-600 text-white hover:bg-red-700">
                📨 Request updated financials
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// AS-OF Advance decision prompt (increment 4): a LOCKED collection ≥2 months
// behind its target. Never auto-advances — the card computes the re-request
// cost and the staff decide (Mark: "depends on the deal and circumstances").
const AsOfAdvanceSection = ({ items, onAdvance, onHold, onOpen }) => {
  if (!items || items.length === 0) return null;
  const my = (iso) => new Date(iso).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-orange-700">
        📆 Collection date falling behind <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => {
          const rr = (p._dateSensitiveDocs || []).filter(d => d.received);
          return (
            <div key={p.id} className="bg-white border border-orange-200 rounded-lg p-4">
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
                <span className="text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap bg-orange-100 text-orange-700">{p._monthsBehind} months behind</span>
              </div>
              <p className="text-xs text-gray-600 mb-2">
                Collecting as of <strong>{my(p._effIso)}</strong>; books are closed through <strong>{my(p._targetIso)}</strong>.
                Advancing would request updated versions of <strong>{rr.length}</strong> received date-sensitive doc{rr.length === 1 ? '' : 's'}{rr.length ? ` (${rr.map(d => d.name).join(', ')})` : ''} — annuals and tax returns are unaffected.
              </p>
              <ProjectChainToolbar p={p} />
              <div className="flex items-center justify-end gap-2">
                <button type="button" onClick={() => onHold(p)} className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-500 hover:text-gray-700" title="Keep collecting to the current date — ask again in a month. Right when the collection is nearly done.">Hold 1 month</button>
                <button type="button" onClick={() => onOpen({ id: p.id, name: p.name })} className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800">Open</button>
                <button type="button" onClick={() => onAdvance(p)} className="px-3 py-1 text-xs font-semibold rounded bg-orange-600 text-white hover:bg-orange-700" title="Roll the anchor forward: updates the requested ranges, re-opens the received date-sensitive docs for updated versions, and preps the owner email.">📆 Advance to {my(p._targetIso)}</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const RevalueDocsReviewSection = ({ items, onOpen, onDismiss }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-amber-700">
        📋 Review docs required — revalue <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => (
          <div key={p.id} className="bg-white border border-amber-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex items-center gap-2 min-w-0"><div className="font-semibold text-gray-800 truncate">{p.company_name}</div><ProvenanceChip p={p} /></div>
              <span className="text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap bg-amber-100 text-amber-700">
                Curate &amp; release
              </span>
            </div>
            <p className="text-xs text-gray-600 mb-3">
              Revalue started — review the file, check the documents this cycle needs, then release the list to the owner's portal.
            </p>
            <ProjectChainToolbar p={p} />
            <div className="flex items-center justify-end gap-2">
              <button
                type="button"
                onClick={() => onDismiss && onDismiss(p)}
                className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-500 hover:text-gray-700"
                title="This cycle doesn't need a curated portal release — clear the card. The owner's document list stays as it is."
              >
                ✕ Not needed
              </button>
              <button
                type="button"
                onClick={() => onOpen({ id: p.id, name: p.name })}
                className="px-3 py-1 text-xs font-semibold rounded bg-amber-600 text-white hover:bg-amber-700"
              >
                Open to curate
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// #8/#9: owner self-service portal updates awaiting Konnie's review — the owner
// marked "I've uploaded everything" and/or flagged a document "doesn't apply."
// Previously these only showed inside the portal / an editor badge, so she'd miss
// them unless she looked. "✓ Reviewed" clears the signals for the deal.
const OwnerPortalReviewSection = ({ items, onOpen, onReviewed }) => {
  if (!items || items.length === 0) return null;
  const fmtDate = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    return isNaN(dt.getTime()) ? '' : dt.toLocaleDateString();
  };
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-teal-700">
        📬 Owner portal updates — review <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => {
          const na = Array.isArray(p.ownerNaItems) ? p.ownerNaItems : [];
          return (
            <div key={p.id} className="bg-white border border-teal-200 rounded-lg p-4">
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
                <span className="text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap bg-teal-100 text-teal-700">
                  Owner update
                </span>
              </div>
              {p.ownerUploadsDone && (
                <div className="text-xs text-gray-700 mb-1">
                  ✅ <strong>Owner marked finished uploading</strong>{fmtDate(p.ownerUploadsDone) ? ` — ${fmtDate(p.ownerUploadsDone)}` : ''}
                  {p.docsTotal > 0 && <span className="text-gray-400"> · {p.docsDone} of {p.docsTotal} received</span>}
                </div>
              )}
              {na.length > 0 && (
                <div className="text-xs text-gray-700 mb-1">
                  {na.map((n, i) => (
                    <div key={i} className="mb-0.5">
                      🚩 <strong>Flagged “doesn’t apply”:</strong> {n.name}
                      {n.note ? <span className="text-gray-500"> — “{n.note}”</span> : ''}
                    </div>
                  ))}
                </div>
              )}
              <div className="mt-2"><ProjectChainToolbar p={p} /></div>
              <div className="flex justify-end gap-2 mt-3">
                <button
                  type="button"
                  onClick={() => onReviewed(p)}
                  className="px-3 py-1 text-xs font-semibold rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
                  title="Clears this update from your list. Handle the actual documents in the deal."
                >
                  ✓ Reviewed
                </button>
                <button
                  type="button"
                  onClick={() => onOpen({ id: p.id, name: p.name })}
                  className="px-3 py-1 text-xs font-semibold rounded bg-teal-600 text-white hover:bg-teal-700"
                >
                  Open
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Stage C: documents an owner uploaded to ShareFile that were auto-classified
// and marked Received, but Konnie hasn't entered into VT yet (no "Data Entered"
// check). The gap between the automatic Received signal and her manual entry —
// "received, awaiting entry." Opening a card takes her into the valuation to
// paste the data and check the box. Sky theme to distinguish from the emerald
// owner-chase reminder queue.
const ReceivedWorklistSection = ({ items, onOpen }) => {
  if (!items || items.length === 0) return null;
  const totalDocs = items.reduce((n, p) => n + (p.sfAwaiting ? p.sfAwaiting.length : 0), 0);
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-sky-700">
        📥 Received — awaiting entry <span className="text-gray-400 font-normal">({items.length})</span>
        <span className="ml-2 text-[10px] font-bold text-sky-700 bg-sky-50 border border-sky-200 rounded px-1.5 py-0.5 align-middle">
          {totalDocs} doc{totalDocs === 1 ? '' : 's'}
        </span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => (
          <div key={p.id} className="bg-white border border-sky-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
              <span className="text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap bg-sky-100 text-sky-700">
                {p.sfAwaiting.length} to enter
              </span>
            </div>
            <ul className="text-xs text-gray-600 mb-3 space-y-1">
              {p.sfAwaiting.slice(0, 6).map((it, i) => (
                <li key={i} className="flex items-start gap-1">
                  <span className="text-sky-500">←</span>
                  <span className="flex-1">
                    {it.fileName && <span className="font-medium text-gray-800">📄 {it.fileName}<span className="text-gray-400 font-normal"> → filed as </span></span>}
                    {it.name || `Item ${it.itemKey}`}
                    <span className="text-gray-400">
                      {' · '}{new Date(it.receivedAt).toLocaleDateString()}
                      {typeof it.confidence === 'number' ? ` · ${Math.round(it.confidence * 100)}%` : ''}
                    </span>
                  </span>
                </li>
              ))}
              {p.sfAwaiting.length > 6 && (
                <li className="text-gray-400">+{p.sfAwaiting.length - 6} more</li>
              )}
            </ul>
            <p className="text-[11px] text-gray-400 mb-2">The card clears when <b>that</b> checklist item is marked Complete or Partial.</p>
            <ProjectChainToolbar p={p} />
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => onOpen({ id: p.id, name: p.name })}
                className="px-3 py-1 text-xs font-semibold rounded bg-sky-600 text-white hover:bg-sky-700"
              >
                Open to enter
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Stage C: one Sort Queue row — a ShareFile upload AI couldn't confidently
// classify (or couldn't map to a project). Konnie picks the right checklist
// item (defaulting to the AI's guess) and confirms, or dismisses it.
const SortQueueRow = ({ item, onResolve }) => {
  const [sel, setSel] = useState(item.ai_item_id && item.ai_item_id > 0 ? String(item.ai_item_id) : '');
  const [busy, setBusy] = useState(false);
  const guess = DEFAULT_DOCUMENT_CHECKLIST.find(d => d.id === item.ai_item_id);
  const linked = !!item.engagement_id;
  const go = async (id) => { setBusy(true); try { await onResolve(item, id); } finally { setBusy(false); } };
  return (
    <div className="bg-white border border-amber-200 rounded-lg p-4">
      <div className="flex items-start justify-between gap-2 mb-1">
        <div className="font-semibold text-gray-800 truncate">{linked ? item.company_name : '⚠ Unlinked folder'}</div>
        <span className="text-[10px] font-bold px-2 py-0.5 rounded whitespace-nowrap bg-amber-100 text-amber-700">
          {item.ai_confidence != null ? `${Math.round(item.ai_confidence * 100)}%` : '—'}
        </span>
      </div>
      <div className="text-xs text-gray-700 mb-1 break-all">📄 {item.file_name || '(unnamed file)'}</div>
      <div className="text-xs text-gray-400 mb-2">
        AI: {guess ? guess.name : 'no confident match'}
        {item.ai_rationale ? ` — ${item.ai_rationale}` : ''}
      </div>
      <div className="flex items-center gap-2">
        <select
          value={sel}
          onChange={e => setSel(e.target.value)}
          disabled={busy || !linked}
          className="flex-1 text-xs border rounded px-2 py-1 disabled:bg-gray-50"
        >
          <option value="">— pick checklist item —</option>
          {DEFAULT_DOCUMENT_CHECKLIST.map(d => <option key={d.id} value={String(d.id)}>{d.name}</option>)}
        </select>
        <button
          type="button"
          disabled={busy || !sel || !linked}
          onClick={() => go(Number(sel))}
          className="px-3 py-1 text-xs font-semibold rounded bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-40"
        >
          Confirm
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={() => go(null)}
          className="px-2 py-1 text-xs rounded border text-gray-500 hover:bg-gray-50"
        >
          Dismiss
        </button>
      </div>
      {!linked && (
        <div className="text-[10px] text-red-600 mt-1">Folder not linked to a VT project — dismiss, or link the folder first.</div>
      )}
    </div>
  );
};

const SortQueueSection = ({ items, onResolve }) => {
  // Bulk-confirm (backlog item, 2026-07-21): the 0.85 auto-stamp threshold
  // means real financials (~0.55–0.82) mostly land here — 43 manual confirms
  // for one client. This accepts every AI suggestion in one confirmed click;
  // rows with no suggestion or an unlinked folder are untouched.
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkProgress, setBulkProgress] = useState('');
  const confirmable = items.filter(i => i.engagement_id && i.ai_item_id > 0);
  const bulkConfirm = async () => {
    const names = confirmable.map(i => {
      const g = DEFAULT_DOCUMENT_CHECKLIST.find(d => d.id === i.ai_item_id);
      return `• ${i.file_name || '(unnamed)'} → ${g ? g.name : `item ${i.ai_item_id}`}`;
    }).join('\n');
    if (!window.confirm(`Accept the AI's suggestion for ${confirmable.length} file(s)?\n\n${names}\n\nEach stamps its checklist item Received, exactly like confirming the row by hand.`)) return;
    setBulkBusy(true);
    let done = 0;
    try {
      for (const item of confirmable) {
        setBulkProgress(`${done + 1}/${confirmable.length}…`);
        await onResolve(item, item.ai_item_id);
        done += 1;
      }
    } catch (e) {
      window.alert(`Stopped after ${done} of ${confirmable.length}: ${e?.message || 'unknown error'}\nThe rest are still in the queue — nothing was lost.`);
    } finally {
      setBulkBusy(false);
      setBulkProgress('');
    }
  };
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-amber-700 flex items-center gap-3 flex-wrap">
        🗂 Sort Queue <span className="text-gray-400 font-normal">({items.length})</span>
        {confirmable.length > 1 && (
          <button
            type="button"
            disabled={bulkBusy}
            onClick={bulkConfirm}
            className="px-3 py-1 text-xs font-semibold rounded bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-50 normal-case tracking-normal"
            title="Accept the AI's suggested checklist item for every linked row that has one — same effect as clicking Confirm on each. Rows with no suggestion or an unlinked folder are left for hand-sorting."
          >
            {bulkBusy ? `Confirming ${bulkProgress}` : `✔ Confirm all AI suggestions (${confirmable.length})`}
          </button>
        )}
        <span className="ml-2 text-[10px] font-normal text-gray-400">uploads needing manual classification</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(it => <SortQueueRow key={it.id} item={it} onResolve={onResolve} />)}
      </div>
    </div>
  );
};

// Warm-account cards on My Work (Warm → Active onboarding). `mode` switches the
// action: 'am' gets Send/Resend intro (their one write) + a follow-up nudge for
// no-shows; 'lead' gets Activate-or-pass after the meeting. (2026-06-16)
const WarmSection = ({ title, items, mode, note, onOpenValuation, onSendWarmIntro, onActivateWarm, onWarmMissed, onWarmAwait, onWarmStrategy, onWarmQualify }) => {
  if (!items || items.length === 0) return null;
  const fmt = (s) => s ? new Date(s + 'T00:00:00').toLocaleDateString() : null;
  // Lead self-generated the account and acts as its own AM (lead === AM by
  // first name). Mirrors amIsLead in IntroEmailModal; used to surface the
  // intro (re)send on the Lead's card when no separate AM exists.
  const leadIsAlsoAm = (p) => {
    const first = (s) => (s || '').trim().split(/\s+/)[0].toLowerCase();
    return !!first(p.lead) && first(p.lead) === first(p.account_manager);
  };
  // Role-aware headline. The generic computeNextAction copy is AM-centric
  // ("send intro…") — wrong on the Lead's card. The intro meeting date lives in
  // discovery_meeting_date.
  // Truth-aware copy (Mark 09-11, KC Heating + Sierra Mountain: "it should
  // not say meeting was 8/27, as that made me think that the meeting
  // happened"). Past-date cards read the actual meeting record — held /
  // no-show / never-logged are three different jobs, said plainly, with
  // the days elapsed so the urgency is visible.
  const cardMsg = (p) => {
    const md = p.discovery_meeting_date ? new Date(p.discovery_meeting_date + 'T00:00:00') : null;
    const today0 = new Date(); today0.setHours(0, 0, 0, 0);
    // introSentAt: timestamp = sent · null = known NOT sent · undefined = unknown
    const notSent = p.introSentAt === null;
    const days = md ? Math.floor((today0 - md) / 86400000) : 0;
    const mt = p.meetingTruth2;
    const pastMsg = () => {
      const d = fmt(p.discovery_meeting_date);
      if (mt && mt.rebookedTo) {
        return `📅 Already rebooked: a new meeting is on the calendar for ${fmt(mt.rebookedTo)}${mt.declined ? ` (the owner declined the ${d} invite)` : ''}. Click ✓ Move to ${fmt(mt.rebookedTo)} so the deal shows the right date.`;
      }
      if (mt && mt.declined && !mt.outcome) {
        return `📭 The owner declined the ${d} invite, so it didn't happen. Get a new meeting on the calendar, then ↩ Owner missed it and set the new date.`;
      }
      if (mt && mt.outcome === 'no_show') {
        return mode === 'lead'
          ? `⚠ The ${d} meeting was a NO-SHOW (logged) — ${days}d ago and no new meeting is booked. Rebook with the owner, or pass.`
          : `⚠ The ${d} meeting was a NO-SHOW (logged) — ${days}d and nobody rebooked. Chasing no-shows is yours: get a new meeting on the calendar.`;
      }
      if (mt && (mt.outcome === 'held' || mt.outcome)) {
        return mode === 'lead'
          ? `Meeting HELD ${d} — activation is ${days}d overdue. Activate (committal + docs) or pass.`
          : `Meeting held ${d} — the Lead hasn't activated in ${days}d. Chase them today; the owner is waiting.`;
      }
      return mode === 'lead'
        ? `A meeting was scheduled for ${d} — nobody recorded whether it happened (${days}d ago). Log it (✓ held / ✗ no-show); if it didn't happen, rebook.`
        : `A meeting was scheduled for ${d} — either it wasn't logged or it didn't happen (${days}d, nothing since). Find out which; if it didn't happen, rebook the owner.`;
    };
    if (mode === 'lead') {
      if (md && md >= today0) return `Intro meeting ${fmt(p.discovery_meeting_date)} — activate after`;
      if (md && md < today0) return pastMsg();
      return 'Awaiting the introductory meeting';
    }
    if (notSent) return 'Send the intro — the owner has no portal link yet';
    if (md && md >= today0) return `Intro sent · meeting ${fmt(p.discovery_meeting_date)}`;
    if (md && md < today0) return pastMsg();
    return 'Intro sent — awaiting the meeting (resend if needed)';
  };
  // A past meeting date with no forward motion is the section's loudest
  // state — the border escalates with it.
  const cardTone = (p) => {
    const md = p.discovery_meeting_date ? new Date(p.discovery_meeting_date + 'T00:00:00') : null;
    const today0 = new Date(); today0.setHours(0, 0, 0, 0);
    if (!md || md >= today0) return 'border-orange-200';
    const days = Math.floor((today0 - md) / 86400000);
    return days >= 5 ? 'border-2 border-red-500' : 'border-amber-400';
  };
  // 🎯 Three rebook emails after a missed meeting, no answer → the AM picks the strategy (Mark 10-15).
  const needsStrategy = (p) => {
    if (mode !== 'am' || !p.discovery_meeting_date || (p._attempts || 0) < 3) return false;
    if (new Date(p.discovery_meeting_date + 'T00:00:00') >= new Date(new Date().toDateString())) return false;
    if (p.meetingTruth2 && p.meetingTruth2.outcome === 'held') return false;
    if (p._pickLive) return false;   // already picked (the card can still show while the qualification is missing — Adam 10-16, Lew)
    return p._watch !== 'replied' && !(p._pick && !p._pickLive);
  };
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-orange-700">
        {title} <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      {note && <p className="text-xs text-gray-500 mb-3">{note}</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(p => (
          <div key={p.id} className={`${cardTone(p)} rounded-lg bg-white p-3`}>
            <div className="flex items-center justify-between gap-2">
              <span className="font-semibold text-gray-800 truncate" title={p.company_name}>{p.company_name}</span>
              <span className="text-[10px] font-semibold uppercase tracking-wide bg-orange-100 text-orange-700 rounded px-1.5 py-0.5 whitespace-nowrap">Warm</span>
            </div>
            <div className="text-xs text-gray-600 mt-1">{cardMsg(p)}</div>
            {/* 📋 The size screen (Mark + Zac 10-16): what the Lead walks in with. Missing = the AM's job isn't done. */}
            {p._qual
              ? <div className="text-xs text-gray-700 mt-1 bg-indigo-50 border border-indigo-100 rounded px-2 py-1">
                  <div>📋 <b>{qualSummary(p._qual)}</b>{p._qual.whatTheyDo ? ` · ${p._qual.whatTheyDo}` : ''}</div>
                  <div className="text-gray-600">Why: {p._qual.why} · When: {p._qual.timing}</div>
                  {p._qual.belowFloor && <div className="text-amber-800 font-semibold">⚠ {Number(p._qual.ebitda) <= 0 ? `Not profitable (${qualMoney(Number(p._qual.ebitda))} ${qualProfitLabel(p._qual)})` : `Below the ${p._qual.floorLabel} floor (${qualMoney(p._qual.floor)} EBITDA)`}. Proceeding because: {p._qual.proceedReason}</div>}
                </div>
              : <div className="text-[11px] font-semibold text-red-700 mt-1">📋 Not qualified yet: {mode === 'lead' ? `${p.account_manager || 'the AM'} hasn't recorded size, motivation or timing.` : 'size, motivation, timing. This card stays on your plate until it\'s done.'}</div>}
            {mode === 'am' && p._watch === 'replied' && <div className="text-xs font-semibold text-emerald-700 mt-1">✉ The owner replied — rebook the meeting (↩ reschedule with the date).</div>}
            {mode === 'am' && p._pick && !p._pickLive && <div className="text-xs font-semibold text-emerald-700 mt-1">✉ The owner wrote back after your strategy pick — rebook the meeting (↩ reschedule with the date).</div>}
            {/* No phone follow-up unless the owner asked for a call (Mark 10-15) — email, then the strategy. */}
            {needsStrategy(p)
              ? <div className="text-xs font-semibold text-violet-700 mt-1">🎯 {p._attempts} emails since the missed meeting, no reply. Time to set the strategy: monthly marketing takes over, with or without a reminder to follow up.</div>
              : mode === 'am' && p._watch === 'silent' && !p._pickLive && <div className="text-xs font-semibold text-amber-700 mt-1">⏳ Your 2-day watch ran out — no reply. Email again and ⏳, or ↩ rebook if they answered.</div>}
            {mode === 'am' && p._pickLive && !p._qual && <div className="text-xs font-semibold text-violet-700 mt-1">🎯 Strategy set: {p._pick.disposition === 'strategy_followup' ? `marketing + your follow-up ${p._pick.due || ''}` : 'monthly marketing takes over'}. The card stays only for 📋 Finish the qualification.</div>}
            {mode === 'lead' && p._pick && (
              <div className="text-[11px] text-violet-700 mt-1">{p._pick.notNow ? '⏸ Owner said not now ·' : '🎯'} {p.account_manager || 'The AM'}'s strategy ({String(p._pick.at || '').slice(0, 10)}){p._pick.notNow && p._pick.why ? ' — ' + String(p._pick.why).slice(0, 120) : ''}: {p._pick.disposition === 'strategy_followup' ? `marketing + personal follow-up ${p._pick.due || ''}` : 'monthly marketing took over'}{p._pickLive ? '' : ' · the owner has written back since'}</div>
            )}
            {/* Known never-sent (no warm_intro outreach row): the account exists
                but the owner was never handed the portal link — loud on BOTH the
                AM's and the Lead's card (Mark 2026-07-24, after a silent skip).
                Buyside deals get zero owner outreach, so neither chip applies. */}
            {!p.buyside && p.introSentAt === null && (
              <div className="mt-1"><span className="inline-block text-[11px] font-semibold text-red-700 bg-red-50 border border-red-200 rounded px-1.5 py-0.5">⚠ Intro not sent — owner has no portal link</span></div>
            )}
            {/* Questionnaire status — permanent, no time window (Mark 2026-07-24:
                owners "normally answer all or none", so the states that matter
                are done / started / untouched). Hidden while the intro is
                known-unsent: no link means no answers, and the red chip above
                already owns that case. */}
            {!p.buyside && p.introSentAt !== null && (
              p.discoveryQuestionsDone
                ? <div className="mt-1"><span className="inline-block text-[11px] font-semibold text-green-700 bg-green-50 border border-green-200 rounded px-1.5 py-0.5">✓ Questionnaire complete</span></div>
                : (p.discoveryAnswerCount || 0) > 0
                  ? <div className="mt-1"><span className="inline-block text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-1.5 py-0.5">Questionnaire: {p.discoveryAnswerCount} answered so far</span></div>
                  : <div className="mt-1"><span className="inline-block text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-1.5 py-0.5">Questionnaire not started</span></div>
            )}
            <div className="text-[11px] text-gray-400 mt-1">
              Lead: {p.lead || '—'} · AM: {p.account_manager || '—'}<InheritedAmBadge am={p.account_manager} />
              {p.discovery_meeting_date ? ` · Intro ${fmt(p.discovery_meeting_date)}` : ''}
            </div>
            {p.owner_target_valuation_date && (
              <div className="text-[11px] font-semibold text-green-700 mt-1">🎯 Owner wants to discuss by {fmt(p.owner_target_valuation_date)}</div>
            )}
            <div className="mt-2 flex flex-wrap gap-2">
              {/* Send/resend intro is the AM's action. But when the Lead self-
                  generated the account and is also the AM (lead === AM), no
                  separate AM exists to send it — so surface it on the Lead's
                  card too, otherwise the intro can't be (re)sent from their
                  view. Mirrors the amIsLead concept in IntroEmailModal. */}
              {(mode === 'am' || (mode === 'lead' && leadIsAlsoAm(p))) && (
                <button onClick={() => onSendWarmIntro(p)} className={`px-2.5 py-1 text-xs font-semibold rounded text-white ${p.introSentAt === null ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'}`}>{p.introSentAt === null ? '✉ Send intro now' : '✉ Send / resend intro'}</button>
              )}
              {mode === 'lead' && (
                <button onClick={() => onActivateWarm(p)} className="px-2.5 py-1 text-xs font-semibold rounded bg-green-600 text-white hover:bg-green-700">Activate or pass</button>
              )}
              {/* The owner missed the intro (Adam 09-22): correct the meeting
                  record to no-show and move the date, from the card. Shows once
                  the scheduled meeting date is in the past. */}
              {onWarmMissed && p.meetingTruth2 && p.meetingTruth2.rebookedTo && p.discovery_meeting_date && new Date(p.discovery_meeting_date + 'T00:00:00') <= new Date() && (
                <button onClick={() => onWarmMissed({ ...p, _rebookTo: p.meetingTruth2.rebookedTo })} className="px-2.5 py-1 text-xs font-semibold rounded bg-emerald-600 text-white hover:bg-emerald-700"
                  title="The new meeting is already on the calendar: one click marks the old one didn't-happen and moves the deal's meeting date to it.">✓ Move to {fmt(p.meetingTruth2.rebookedTo)}</button>
              )}
              {onWarmMissed && p.discovery_meeting_date && new Date(p.discovery_meeting_date + 'T00:00:00') <= new Date() && (
                <button onClick={() => onWarmMissed(p)} className="px-2.5 py-1 text-xs font-semibold rounded border border-amber-400 text-amber-800 bg-amber-50 hover:bg-amber-100"
                  title="The owner didn't make the meeting — marks it a no-show on the record (even if Fireflies stamped it held) and lets you set the new date.">↩ Owner missed it — reschedule</button>
              )}
              {mode === 'am' && !p._qual && onWarmQualify && (
                <button onClick={() => onWarmQualify(p)} className="px-2.5 py-1 text-xs font-semibold rounded bg-indigo-600 text-white hover:bg-indigo-700"
                  title="The size screen from the playbook: revenue, EBITDA, employees, what they do, why selling, when. The Lead needs it before the meeting.">📋 Finish the qualification</button>
              )}
              {needsStrategy(p) && onWarmStrategy && (
                <button onClick={() => onWarmStrategy(p)} className="px-2.5 py-1 text-xs font-semibold rounded bg-violet-600 text-white hover:bg-violet-700"
                  title="Three emails, no reply: pick the play. Monthly marketing takes over, or marketing + a dated reminder to follow up. The card leaves your plate until the owner writes back.">🎯 Pick the strategy</button>
              )}
              {mode === 'am' && onWarmStrategy && !needsStrategy(p) && !p._pickLive && (
                <button onClick={() => onWarmStrategy({ ...p, _notNow: true })} className="px-2.5 py-1 text-xs font-semibold rounded border border-violet-300 text-violet-700 hover:bg-violet-50"
                  title="The owner told you they want to pause or wait. Marketing takes over (with a follow-up date if you want one); the card leaves your plate, the Lead sees it, and the owner's reply brings it back.">⏸ Owner says not now</button>
              )}
              {mode === 'am' && onWarmAwait && !needsStrategy(p) && !p._pickLive && p.discovery_meeting_date && new Date(p.discovery_meeting_date + 'T00:00:00') <= new Date() && (
                <button onClick={() => onWarmAwait(p)} className="px-2.5 py-1 text-xs font-semibold rounded border border-sky-300 text-sky-700 hover:bg-sky-50"
                  title="You reached out to rebook — the card steps aside for 2 business days. The owner's reply brings it back sooner; silence brings it back saying so.">⏳ Waiting on reply</button>
              )}
              <button onClick={() => onOpenValuation({ id: p.id, name: p.name })} className="px-2.5 py-1 text-xs font-semibold rounded bg-gray-100 text-gray-700 hover:bg-gray-200">Open</button>
            </div>
            {mode === 'am' && p.discovery_meeting_date && new Date(p.discovery_meeting_date + 'T00:00:00') <= new Date() && (
              <div className="text-[11px] text-gray-500 mt-1.5 leading-snug">
                <b className="text-gray-600">Where this card goes:</b>{' '}
                {p.meetingTruth2 && p.meetingTruth2.rebookedTo ? <span>✓ Move → the card stays and shows the new date; the day after that meeting it asks how it went. </span> : null}
                <span>↩ Owner missed it → you set the new date; the card waits for that meeting. </span>
                <span>⏳ Waiting on reply → the card steps aside 2 business days, then comes back (sooner if they reply). It does NOT move the meeting date. </span>
                <span>⏸ Not now → the card leaves; marketing keeps in touch and the owner’s reply brings it back.</span>
              </div>
            )}
            {/* Universal toolbar (Adam 08-24, KC Heating: he took the owner's
                call minutes after creating the account and had no door to
                write the notes — warm cards never got the 08-21 toolbar). */}
            <CardToolbar className="mt-2" valuationId={p.id}
              ownerId={p.client_id ? (SE_OWNER_BY_CLIENT.get(p.client_id) || null) : null}
              companyName={p.company_name} actor={CARD_ACTOR_NAME} />
          </div>
        ))}
      </div>
    </div>
  );
};

// ===== 📋 QUALIFICATION — the AM's size screen (Mark + Zac 10-16, Pro Door & Trim) =====
// The AM playbook (Stage 2) already says it: gather the facts, ask revenue / profit / EBITDA early, and
// stop when they're too small. The tool never asked for any of it, so a call that came straight into the
// office reached the Lead with nothing ("that 5 minute call... my daughter could do that" — Zac). These
// are the answers the Lead needs. They save to the business's SE record (its profile), and a warm account
// without them stays on the AM's plate until they're in. Structured on purpose: free-text notes drift
// into "owner was nice" (Mark 10-16).
const QUAL_FLOORS = [
  { key: 'most', label: 'Most industries (IT / MSP, software, services, manufacturing, distribution, HVAC)', floor: 200000 },
  { key: 'construction', label: 'Construction / contracting', floor: 750000 },
  { key: 'retail', label: 'Retail', floor: 1000000 },
  { key: 'restaurant_single', label: 'Restaurant, single location', floor: 1000000 },
  { key: 'restaurant_franchise', label: 'Franchise restaurant', floor: 500000 },
  { key: 'internet_retail', label: 'Internet retail', floor: 500000 },
];
const QUAL_TIMING = ['Now / within 6 months', '6–12 months', '1–2 years', '3+ years', 'Exploring value — no plan yet'];
// EBITDA OR NET PROFIT (Zac 10-16): interchangeable, since many owners don't know their EBITDA, but REQUIRED and
// it must be positive. No "owner wouldn't say" on this one (both early qualifications skipped it, which also
// skipped the floor check). profitKind says which number it is; zero or a loss counts as below the floor.
// The floor for a business from its SE record (Mark 10-19: the reminder on first-time meeting cards). HVAC is
// Most industries ($200K, Mark 10-19); other trades and contractors follow the playbook's construction row.
const qualFloorKeyFor = (o) => {
  const t = [o && o.sector, o && o.industry, o && o.business_type].filter(Boolean).join(' ');
  if (!t) return null;
  if (/hvac|heating|cooling|air condition/i.test(t)) return 'most';
  if (/restaurant|food service|cafe|\bbar\b|pizza|diner/i.test(t)) return /franchise/i.test(t) ? 'restaurant_franchise' : 'restaurant_single';
  if (/internet retail|e-?commerce|online retail|online store/i.test(t)) return 'internet_retail';
  if (/retail/i.test(t)) return 'retail';
  if (/construction|contract(or|ing)|roofing|plumbing|electrical|carpentry|remodel|concrete|excavat|paving|framing|drywall|stucco|plaster|masonry|landscap/i.test(t)) return 'construction';
  return 'most';
};
const emptyQual = () => ({ revenue: '', revenueUnknown: false, ebitda: '', ebitdaUnknown: false, profitKind: '', employees: '', employeesUnknown: false,
  whatTheyDo: '', why: '', timing: '', floorKey: '', proceedReason: '' });
const qualNum = (v) => { const n = Number(String(v == null ? '' : v).replace(/[$,\s]/g, '')); return isFinite(n) && n > 0 ? n : null; };
const qualProfit = (v) => { const t = String(v == null ? '' : v).replace(/[$,\s]/g, '').replace(/^\((.*)\)$/, '-$1'); if (t === '' || t === '-') return null; const n = Number(t); return isFinite(n) ? n : null; };
const qualProfitLabel = (q) => (q && q.profitKind === 'net' ? 'net profit' : 'EBITDA');
const qualFloor = (q) => QUAL_FLOORS.find(f => f.key === (q && q.floorKey)) || null;
const qualBelowFloor = (q) => { const f = qualFloor(q); const e = qualProfit(q && q.ebitda); if (!q || q.ebitdaUnknown || e == null) return false; return e <= 0 || !!(f && e < f.floor); };
const qualError = (q) => {
  if (!q) return 'The size screen is required.';
  if (!q.revenueUnknown && qualNum(q.revenue) == null) return 'Revenue: enter it, or tick "refused before a CA is signed".';
  if (!q.ebitdaUnknown && qualProfit(q.ebitda) == null) return 'EBITDA or net profit: enter it (owners who don\'t know EBITDA usually know their profit), or tick "refused before a CA is signed".';
  if (!q.ebitdaUnknown && !q.profitKind) return 'Say whether that number is EBITDA or net profit.';
  if (!q.employeesUnknown && qualNum(q.employees) == null) return 'Employees: enter it, or tick "owner wouldn\'t say".';
  if (!String(q.whatTheyDo || '').trim()) return 'What they do is required.';
  if (!String(q.why || '').trim()) return 'Why they\'re selling is required.';
  if (!q.timing) return 'Pick when they want to sell.';
  if (!q.floorKey) return 'Pick the size floor that fits the business.';
  if (qualBelowFloor(q) && !String(q.proceedReason || '').trim()) return 'Below the size floor: say why we\'re proceeding, or don\'t book it and log it Too small in the Sales Engine.';
  return '';
};
const qualMoney = (n) => (n == null ? '?' : n < 0 ? `-${qualMoney(-n)}` : n >= 1000000 ? `$${(n / 1000000).toFixed(n % 1000000 ? 1 : 0)}M` : `$${Math.round(n / 1000)}K`);
const qualSummary = (q) => [
  q.revenueUnknown ? 'revenue: refused before a CA' : `${qualMoney(qualNum(q.revenue))} revenue`,
  q.ebitdaUnknown ? 'profit: refused before a CA' : `${qualMoney(qualProfit(q.ebitda))} ${qualProfitLabel(q)}`,
  q.employeesUnknown ? 'employees not given' : `${qualNum(q.employees)} employees`,
].join(' · ');
// Writes the record (deal history, kind 'qualification') + the business's SE profile. Numbers the AM gave
// overwrite (they're the freshest); text fields fill blanks only, so a richer Fireflies answer survives.
async function saveQualification(sb, { valuationId, clientId, ownerEmail, actorEmail, actorName, q }) {
  const f = qualFloor(q);
  const below = qualBelowFloor(q);
  const meta = { ...q, revenue: q.revenueUnknown ? null : qualNum(q.revenue), ebitda: q.ebitdaUnknown ? null : qualProfit(q.ebitda),
    employees: q.employeesUnknown ? null : qualNum(q.employees), floor: f ? f.floor : null, floorLabel: f ? f.label : null, belowFloor: below };
  const note = `📋 Qualified: ${qualSummary(q)}. Does: ${String(q.whatTheyDo).trim()}. Why: ${String(q.why).trim()}. When: ${q.timing}.`
    + (below ? ` Below the ${f.label} floor (${qualMoney(f.floor)} EBITDA); proceeding because: ${String(q.proceedReason).trim()}` : '');
  const { error } = await sb.from('project_activity_log').insert({ project_id: valuationId, actor_email: actorEmail || 'unknown',
    actor_name: actorName || null, kind: 'qualification', note, metadata: meta });
  if (error) throw error;
  try {
    let oid = null;
    if (clientId) { const { data } = await sb.from('se_owners').select('id').eq('vt_client_id', clientId).limit(1); oid = (data && data[0] && data[0].id) || null; }
    if (!oid && ownerEmail) { const { data } = await sb.from('se_owners').select('id').contains('emails', [String(ownerEmail).trim().toLowerCase()]).limit(1); oid = (data && data[0] && data[0].id) || null; }
    if (!oid) return;
    const { data: cur } = await sb.from('se_owners').select('description, sale_motivation, target_sale_timing').eq('id', oid).single();
    const upd = { updated_at: new Date().toISOString() };
    if (meta.revenue) upd.size_revenue = meta.revenue;
    if (meta.ebitda != null) { if (q.profitKind === 'net') upd.net_profit = meta.ebitda; else upd.ebitda = meta.ebitda; }
    if (meta.employees) upd.size_employees = Math.round(meta.employees);
    if (meta.revenue || meta.ebitda != null) { upd.financials_source = `AM first call (${actorName || 'AM'})`; upd.financials_as_of = new Date().toISOString().slice(0, 10); }
    if (!cur || !String(cur.description || '').trim()) upd.description = String(q.whatTheyDo).trim();
    if (!cur || !String(cur.sale_motivation || '').trim()) upd.sale_motivation = String(q.why).trim();
    if (!cur || !String(cur.target_sale_timing || '').trim()) upd.target_sale_timing = q.timing;
    await sb.from('se_owners').update(upd).eq('id', oid);
    await sb.from('se_touches').insert({ owner_id: oid, kind: 'note', channel: 'se', actor: actorName || null,
      subject: note.slice(0, 180), meta: note.length > 180 ? { content: note } : null });
  } catch (e) { console.warn('Qualification saved on the deal; the SE profile update failed:', e && e.message); }
}
const QualificationFields = ({ q, setQ, inputCls, hints }) => {
  const set = (k, v) => setQ(prev => ({ ...prev, [k]: v }));
  const cls = inputCls || 'w-full px-2 py-1.5 border border-gray-300 rounded text-sm';
  const f = qualFloor(q);
  const below = qualBelowFloor(q);
  const lbl = (t) => <label className="block text-[11px] font-semibold text-gray-600 mb-1">{t} <span className="text-red-500">*</span></label>;
  const num = (k, uk, label, ph, why) => (
    <div>
      {lbl(label)}
      <input type="text" inputMode="numeric" value={q[uk] ? '' : q[k]} disabled={!!q[uk]} onChange={e => set(k, e.target.value)} placeholder={ph} className={cls} />
      <label className="flex items-center gap-1 text-[11px] text-gray-500 mt-0.5"><input type="checkbox" checked={!!q[uk]} onChange={e => set(uk, e.target.checked)} /> {why || "owner wouldn't say"}</label>
    </div>
  );
  return (
    <div className="border border-indigo-200 bg-indigo-50 rounded p-3 space-y-2">
      <div className="text-xs font-semibold text-indigo-800">📋 The size screen <span className="font-normal text-gray-500">— what the Lead needs before the meeting (playbook, Stage 2)</span></div>
      <div className="grid grid-cols-3 gap-3">
        {num('revenue', 'revenueUnknown', 'Annual revenue ($)', 'e.g. 2,400,000', 'refused before a CA is signed')}
        <div>
          {lbl('EBITDA or net profit ($)')}
          <input type="text" inputMode="numeric" value={q.ebitdaUnknown ? '' : q.ebitda} disabled={!!q.ebitdaUnknown} onChange={e => set('ebitda', e.target.value)} placeholder="e.g. 350,000" className={cls} />
          <label className="flex items-center gap-1 text-[11px] text-gray-500 mt-0.5"><input type="checkbox" checked={!!q.ebitdaUnknown} onChange={e => set('ebitdaUnknown', e.target.checked)} /> refused before a CA is signed</label>
          {!q.ebitdaUnknown && <div className="flex gap-3 text-[11px] text-gray-600 mt-0.5">
            <label className="flex items-center gap-1"><input type="radio" name="qual-profit-kind" checked={q.profitKind === 'ebitda'} onChange={() => set('profitKind', 'ebitda')} /> EBITDA</label>
            <label className="flex items-center gap-1"><input type="radio" name="qual-profit-kind" checked={q.profitKind === 'net'} onChange={() => set('profitKind', 'net')} /> Net profit</label>
          </div>}
        </div>
        {num('employees', 'employeesUnknown', 'Employees', 'e.g. 14')}
      </div>
      <div>{lbl('What they do')}<input type="text" value={q.whatTheyDo} onChange={e => set('whatTheyDo', e.target.value)} placeholder="e.g. Residential door & trim installation for builders, Denver metro" className={cls} /></div>
      <div>{lbl('Why they\'re selling')}<input type="text" value={q.why} onChange={e => set('why', e.target.value)} placeholder="e.g. Owner is 64 and wants to retire; no family successor" className={cls} />
        {hints && hints.why && <div className="text-[11px] text-gray-500 mt-0.5">On record: {hints.why}</div>}</div>
      <div className="grid grid-cols-2 gap-3">
        <div>{lbl('When')}<select value={q.timing} onChange={e => set('timing', e.target.value)} className={cls}>
          <option value="">Pick…</option>{QUAL_TIMING.map(t => <option key={t} value={t}>{t}</option>)}</select>
          {hints && hints.timing && <div className="text-[11px] text-gray-500 mt-0.5">On record: {hints.timing}</div>}</div>
        <div>{lbl('Size floor: which group is the business in?')}<select value={q.floorKey} onChange={e => set('floorKey', e.target.value)} className={cls}>
          <option value="">Pick the industry type…</option>{QUAL_FLOORS.map(x => <option key={x.key} value={x.key}>{x.label}: {qualMoney(x.floor)}+</option>)}</select></div>
      </div>
      {below && (
        <div className="bg-amber-50 border border-amber-300 rounded p-2 text-xs text-amber-900">
          ⚠ {qualProfit(q.ebitda) <= 0 ? <>Not profitable ({qualMoney(qualProfit(q.ebitda))} {qualProfitLabel(q)}): we need a positive number.</> : <>{qualMoney(qualProfit(q.ebitda))} {qualProfitLabel(q)} is below the {f ? f.label : ''} floor ({f ? qualMoney(f.floor) : ''}).</>} The playbook: if they're too small, stop here and log it <b>Too small today</b> in the Sales Engine (a recheck comes back in 24 months). Proceeding anyway? Say why; the Lead sees it.
          <input type="text" value={q.proceedReason} onChange={e => set('proceedReason', e.target.value)} placeholder="Why we're proceeding" className={cls + ' mt-1'} />
        </div>
      )}
    </div>
  );
};
// 📋 Finish the qualification — from the AM's warm card. Prefills from the SE record (Fireflies / Zoho /
// earlier answers) so the AM confirms rather than retypes.
const QualificationModal = ({ project, onClose, onSave, onTooSmall }) => {
  const [q, setQ] = useState(emptyQual());
  // 🚫 Too small (Mark 10-19, Lew Plumbing: ~$1M CAD, one employee — booked anyway, then chased for weeks).
  const [smallWhy, setSmallWhy] = useState('');
  const [hints, setHints] = useState(null);
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!supabaseClient || !project || !project.client_id) return;
        const { data } = await supabaseClient.from('se_owners')
          .select('size_revenue, ebitda, net_profit, size_employees, description, sale_motivation, target_sale_timing')
          .eq('vt_client_id', project.client_id).limit(1);
        const r = data && data[0];
        if (!r || cancelled) return;
        setQ(prev => ({ ...prev,
          revenue: r.size_revenue ? String(r.size_revenue) : prev.revenue,
          ebitda: (r.ebitda || r.net_profit) ? String(r.ebitda || r.net_profit) : prev.ebitda,
          profitKind: r.ebitda ? 'ebitda' : (r.net_profit ? 'net' : prev.profitKind),
          employees: r.size_employees ? String(r.size_employees) : prev.employees,
          whatTheyDo: r.description && String(r.description).length < 160 ? String(r.description) : prev.whatTheyDo,
        }));
        setHints({ why: r.sale_motivation ? String(r.sale_motivation).slice(0, 220) : null, timing: r.target_sale_timing ? String(r.target_sale_timing).slice(0, 160) : null });
      } catch (e) { /* the form still works empty */ }
    })();
    return () => { cancelled = true; };
  }, [project && project.id]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (!project) return null;
  const save = async () => {
    const e = qualError(q);
    if (e) { setErr(e); return; }
    setSaving(true);
    const ok = await onSave(project, q);
    setSaving(false);
    if (ok === false) setErr('Could not save. Try again.');
  };
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-5 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <h3 className="font-bold text-gray-800 mb-1">📋 Finish the qualification — {project.company_name}</h3>
        <p className="text-xs text-gray-500 mb-3">The Lead walks into the meeting with these answers. They go on the business's record.</p>
        <QualificationFields q={q} setQ={setQ} hints={hints} />
        {err && <div className="text-xs text-red-700 font-semibold mt-2">{err}</div>}
        {onTooSmall && (
          <div className="mt-3 border border-gray-200 rounded p-2 bg-gray-50">
            <div className="text-xs font-semibold text-gray-700">🚫 Too small to work with? <span className="font-normal text-gray-500">Logs "too small today" (marketing pauses, a recheck comes back in 24 months) and closes this warm account, so nobody keeps chasing it.</span></div>
            <div className="flex gap-2 mt-1">
              <input type="text" value={smallWhy} onChange={e => setSmallWhy(e.target.value)} placeholder="Why: e.g. ~$1M CAD revenue, one employee" className="flex-1 px-2 py-1 border border-gray-300 rounded text-xs" />
              <button type="button" disabled={!smallWhy.trim() || saving} onClick={async () => { setSaving(true); const ok = await onTooSmall(project, q, smallWhy.trim()); setSaving(false); if (ok === false) setErr('Could not save. Try again.'); }}
                className="px-2.5 py-1 text-xs font-semibold rounded bg-gray-700 text-white hover:bg-gray-800 disabled:opacity-40">Log too small + close</button>
            </div>
          </div>
        )}
        <div className="flex justify-end gap-2 mt-3">
          <button type="button" onClick={onClose} className="px-3 py-1.5 text-sm rounded border border-gray-300 text-gray-600">Cancel</button>
          <button type="button" disabled={saving} onClick={save} className="px-3 py-1.5 text-sm font-semibold rounded bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-40">{saving ? 'Saving…' : 'Save the qualification'}</button>
        </div>
      </div>
    </div>
  );
};

// 🎯 Pick the strategy — warm no-show, 3 emails, no reply (Mark 10-15). The two AM plays from the Sales
// Engine, nothing new: monthly marketing takes over, or marketing + a dated personal follow-up. The note is
// required — the WHY (size, type, what the owner said on the first call) is what makes the date right.
const WarmStrategyModal = ({ project, onClose, onSave }) => {
  const [disposition, setDisposition] = useState('');
  const [due, setDue] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  if (!project) return null;
  const plus = (months) => { const d = new Date(); d.setMonth(d.getMonth() + months); return d.toISOString().slice(0, 10); };
  const todayIso = new Date().toISOString().slice(0, 10);
  const ok = note.trim() && (disposition === 'strategy_marketing' || (disposition === 'strategy_followup' && /^\d{4}-\d{2}-\d{2}$/.test(due) && due > todayIso));
  const save = async () => {
    if (!ok || saving) return;
    setSaving(true);
    await onSave(project, { disposition, due: disposition === 'strategy_followup' ? due : null, note: note.trim() });
    setSaving(false);
  };
  const opt = (key, label, hint) => (
    <label className={`flex items-start gap-2 text-xs p-2 rounded cursor-pointer border ${disposition === key ? 'border-violet-400 bg-violet-50' : 'border-gray-200'}`}>
      <input type="radio" name="warm-strategy" className="mt-0.5" checked={disposition === key} onChange={() => setDisposition(key)} />
      <span><span className="font-semibold text-gray-800">{label}</span><br /><span className="text-gray-500">{hint}</span></span>
    </label>
  );
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg p-5 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <h3 className="font-bold text-gray-800 mb-1">{project._notNow ? '⏸ Owner says not now' : '🎯 Pick the strategy'} — {project.company_name}</h3>
        <p className="text-xs text-gray-500 mb-3">{project._notNow
          ? 'The owner wants to pause or wait. Pick how they\'re handled until then: the card leaves your plate, the Lead sees your pick, and their reply brings it back.'
          : `Missed the ${project.discovery_meeting_date} meeting · ${project._attempts || 0} emails since, no reply. We don't call unless the owner asks, so pick how this owner is handled from here.`}</p>
        <div className="grid grid-cols-1 gap-2 mb-3">
          {opt('strategy_marketing', 'Let monthly marketing take over', 'Your personal follow-up ends here; the monthly emails keep them warm. Their reply brings the card back.')}
          {opt('strategy_followup', 'Marketing takes over + a reminder to follow up', 'The monthly emails keep running, and a reminder comes back on your plate on the date you pick.')}
        </div>
        {disposition === 'strategy_followup' && (
          <div className="mb-3">
            <div className="flex flex-wrap gap-2 mb-1">
              {[[1, '1 month'], [3, '3 months'], [6, '6 months']].map(([m, l]) => (
                <button key={m} type="button" onClick={() => setDue(plus(m))}
                  className={`px-2 py-0.5 text-xs rounded border ${due === plus(m) ? 'border-violet-500 bg-violet-50 text-violet-700 font-semibold' : 'border-gray-300 text-gray-600'}`}>{l}</button>
              ))}
              <input type="date" value={due} min={todayIso} onChange={e => setDue(e.target.value)} className="text-xs border rounded px-1.5 py-0.5" />
            </div>
          </div>
        )}
        <textarea value={note} onChange={e => setNote(e.target.value)} rows={3}
          placeholder={project._notNow ? 'What the owner said and why this timing. Required.' : 'Why this play? Required. Business size and type, what you heard on the first call, why this timing.'}
          className="w-full p-2 border rounded text-sm mb-3" />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-3 py-1.5 text-sm rounded border border-gray-300 text-gray-600">Cancel</button>
          <button type="button" disabled={!ok || saving} onClick={save}
            className="px-3 py-1.5 text-sm font-semibold rounded bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-40">{saving ? 'Saving…' : 'Save the strategy'}</button>
        </div>
      </div>
    </div>
  );
};

// Activate-or-Pass modal (Lead, post-meeting). Activate: committal + path
// (+ partial doc picker) + likelihood → Warm → Active + release docs. Pass:
// short reason → Warm → Dead. (2026-06-16)
const ActivatePassModal = ({ project, initial, onClose, onActivate, onPass, onReturnToAm }) => {
  const [mode, setMode] = useState('activate');
  // `initial` = the Lead's prior entries, passed when the docs-ready email's
  // "← Back" reopens this modal so a date fix doesn't cost the whole form
  // (Zac 2026-07-17 — he cancelled the email to fix the committal date and
  // lost everything).
  const [committal, setCommittal] = useState(initial?.committal || '');
  // Discovery/intro meeting date — defaults to today (this modal IS the post-
  // meeting moment). Stamps discovery_meeting_date, which drives the future
  // revalue Lead-meeting rule (newer of discovery_meeting_date / valuation_date).
  const [discoveryDate, setDiscoveryDate] = useState(() => initial?.discoveryDate || new Date().toLocaleDateString('en-CA'));
  const [path, setPath] = useState(initial?.path || project.path || 'full_valuation');
  const [likelihood, setLikelihood] = useState(initial?.likelihood != null && initial.likelihood !== '' ? String(initial.likelihood) : (project.likelihood_pct != null ? String(project.likelihood_pct) : ''));
  const [plannedIds, setPlannedIds] = useState(Array.isArray(initial?.plannedIds) && initial.plannedIds.length ? initial.plannedIds : DEFAULT_DOCUMENT_CHECKLIST.filter(d => d.tier === 'minimum').map(d => d.id));
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const inputCls = "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-400";
  const togglePlanned = (id) => setPlannedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const doActivate = async () => {
    if (!committal) { setErr('Set the committal date — it starts the cadence and releases the documents.'); return; }
    if (!path) { setErr('Choose a path.'); return; }
    if (!discoveryDate) { setErr('Set the discovery / intro meeting date — it times any future revalue.'); return; }
    // Likelihood is required to activate, mirroring the create modal — a deal
    // entering the active funnel must carry a near-term seriousness read (it
    // prefills from the value the AM set at create; the Lead confirms/updates it).
    {
      const n = Number(likelihood);
      if (likelihood === '' || likelihood == null || isNaN(n) || n < 0 || n > 100) {
        setErr('Enter a likelihood from 0 to 100 — how seriously the owner is considering selling in the next ~30 days.');
        return;
      }
    }
    setErr(''); setSaving(true);
    await onActivate(project, { committal, path, likelihood, discoveryDate, plannedIds: path === 'partial' ? plannedIds : [], revision: !!initial });
    setSaving(false);
  };
  const doPass = async () => {
    setSaving(true);
    await onPass(project, reason.trim());
    setSaving(false);
  };
  const doReturn = async () => {
    setSaving(true);
    await onReturnToAm(project, reason.trim());
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[92vh] flex flex-col">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">{project.company_name}</h2>
          <p className="text-xs text-gray-500 mt-0.5">After the introductory meeting — activate the account, pass if it's not a fit, or hand back to the AM if the owner missed it and couldn't reschedule.</p>
        </div>
        <div className="px-6 pt-3">
          <div className="flex gap-1 border-b">
            <button onClick={() => setMode('activate')} className={`px-3 py-2 text-sm font-semibold border-b-2 ${mode === 'activate' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500'}`}>Activate</button>
            <button onClick={() => setMode('pass')} className={`px-3 py-2 text-sm font-semibold border-b-2 ${mode === 'pass' ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500'}`}>Pass — not a fit</button>
            {onReturnToAm && <button onClick={() => setMode('noshow')} className={`px-3 py-2 text-sm font-semibold border-b-2 ${mode === 'noshow' ? 'border-amber-500 text-amber-600' : 'border-transparent text-gray-500'}`}>No-show → AM</button>}
          </div>
        </div>
        <div className="px-6 py-4 overflow-y-auto space-y-4">
          {mode === 'activate' ? (
            <React.Fragment>
              {(() => {
                // Soft path-lean from the owner's portal onboarding taps (Stage 3
                // chips) — helps the Lead set Path/Likelihood. Not a commitment.
                const intentLabel = { planning_ahead: 'Planning ahead', selling_soon: 'Thinking of selling soon', quick_estimate: 'Wants a quick estimate' }[project.owner_intent] || '';
                const priorityLabel = { price: 'The right price', timing: 'The right timing', add_value: 'Strategy to add value' }[project.owner_priority] || '';
                if (!intentLabel && !priorityLabel) return null;
                let lean = '';
                if (project.owner_intent === 'quick_estimate') lean = 'Leans Quick Estimation (Partial)';
                else if (project.owner_priority === 'add_value' || project.owner_intent === 'planning_ahead') lean = 'Leans Strategic Review — value now, then grow it';
                else if (project.owner_intent === 'selling_soon') lean = 'Leans Full Valuation / engage';
                return (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 text-xs">
                    <div className="font-semibold text-blue-800">Owner's portal signals</div>
                    <div className="text-gray-700 mt-0.5">{[intentLabel, priorityLabel].filter(Boolean).join('  ·  ')}</div>
                    {lean && <div className="text-blue-700 mt-0.5">{lean}</div>}
                    <div className="text-[10px] text-gray-400 mt-1">A soft read from their onboarding taps — not a commitment.</div>
                  </div>
                );
              })()}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-semibold text-amber-700 mb-1">Upload Committal Date <span className="text-red-500">*</span></label>
                  <input type="date" value={committal} onChange={(e) => setCommittal(e.target.value)} className={`${inputCls} border-amber-300`} />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Likelihood % <span className="text-red-500">*</span></label>
                  <input type="number" min="0" max="100" value={likelihood} onChange={(e) => setLikelihood(e.target.value)} placeholder="0–100" className={inputCls} />
                </div>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Discovery / intro meeting date <span className="text-red-500">*</span></label>
                <input type="date" value={discoveryDate} onChange={(e) => setDiscoveryDate(e.target.value)} className={inputCls} />
                <p className="text-[11px] text-gray-400 mt-1">When you met — defaults to today. Times any future revalue (a re-engagement within 12 months on a full valuation can skip the Lead meeting).</p>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Path <span className="text-red-500">*</span></label>
                <select value={path} onChange={(e) => setPath(e.target.value)} className={inputCls}>
                  <option value="full_valuation">Full Valuation</option>
                  <option value="partial">Partial</option>
                </select>
              </div>
              {path === 'partial' && (
                <div className="border-t pt-3">
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Items the owner plans to provide <span className="font-normal text-gray-400">— drives "X of Y"</span></label>
                  <div className="border border-gray-200 rounded p-2 max-h-44 overflow-y-auto space-y-1">
                    {DEFAULT_DOCUMENT_CHECKLIST.map(d => (
                      <label key={d.id} className="flex items-start gap-2 text-xs cursor-pointer hover:bg-gray-50 rounded px-1 py-0.5">
                        <input type="checkbox" checked={plannedIds.includes(d.id)} onChange={() => togglePlanned(d.id)} className="mt-0.5" />
                        <span className="text-gray-700">{d.name}</span>
                      </label>
                    ))}
                  </div>
                  <p className="text-[11px] text-gray-400 mt-1">{plannedIds.length} selected (minimum docs pre-checked).</p>
                </div>
              )}
              <div className="text-[11px] text-gray-500 bg-green-50 border border-green-200 rounded p-2">
                Setting the committal date flips this account to <strong>Active</strong> and <strong>releases the documents</strong> to the owner's portal — one action.
              </div>
            </React.Fragment>
          ) : mode === 'pass' ? (
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Reason <span className="font-normal text-gray-400">— optional; for the history</span></label>
              <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} className={inputCls} placeholder="e.g. Too small for our model / not a fit." />
              <p className="text-[11px] text-gray-400 mt-1">Marks the account Dead and removes it from your plate. The record + ShareFile folder are kept.</p>
            </div>
          ) : (
            <div>
              <div className="text-[11px] text-gray-600 bg-amber-50 border border-amber-200 rounded p-2 mb-3">
                Use this when the owner <strong>missed the introductory meeting</strong> and you couldn't get them to reschedule. It's <strong>not a pass</strong> — the account goes back to the AM's <strong>"Owners to follow up"</strong> plate to keep nurturing, and they can re-engage it later (which sends a fresh intro).
              </div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Note for the AM <span className="font-normal text-gray-400">— optional; for the history</span></label>
              <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} className={inputCls} placeholder="e.g. No-show twice, stopped replying — try again in a month." />
            </div>
          )}
          {err && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2">{err}</div>}
        </div>
        <div className="flex justify-end gap-2 px-6 py-4 border-t">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800">Cancel</button>
          {mode === 'activate' ? (
            <button onClick={doActivate} disabled={saving} className="px-4 py-2 bg-green-600 text-white rounded text-sm font-semibold hover:bg-green-700 disabled:bg-gray-300">{saving ? 'Activating…' : 'Activate & release docs'}</button>
          ) : mode === 'pass' ? (
            <button onClick={doPass} disabled={saving} className="px-4 py-2 bg-red-600 text-white rounded text-sm font-semibold hover:bg-red-700 disabled:bg-gray-300">{saving ? 'Saving…' : 'Pass — mark dead'}</button>
          ) : (
            <button onClick={doReturn} disabled={saving} className="px-4 py-2 bg-amber-500 text-white rounded text-sm font-semibold hover:bg-amber-600 disabled:bg-gray-300">{saving ? 'Saving…' : 'Return to AM'}</button>
          )}
        </div>
      </div>
    </div>
  );
};

// Team-overdue radar (owner only, Mark 2026-07-27): every actionable plate
// item past its stage target across ALL staff, grouped by the responsible
// person, worst first. Companion to the server's overdue-nudge emails —
// this is the management view; the emails are the self-service poke.
const TeamOverdueSection = ({ items, onOpen }) => {
  const byPerson = {};
  items.forEach(p => { const k = p.responsibility || '—'; (byPerson[k] = byPerson[k] || []).push(p); });
  const people = Object.entries(byPerson).sort((a, b) => (b[1][0].daysOver || 0) - (a[1][0].daysOver || 0));
  return (
    <div className="bg-white border border-red-200 rounded-lg mb-4 overflow-hidden">
      <div className="px-4 py-2.5 bg-red-50 border-b border-red-200">
        <span className="text-sm font-bold text-red-800">🔥 Overdue across the team</span>
        <span className="text-xs text-red-600 ml-2">{items.length} plate item{items.length === 1 ? '' : 's'} past target — each person's My Work shows these too; this is the radar for when they don't look</span>
      </div>
      {people.map(([person, rows]) => (
        <div key={person} className="border-b border-gray-100 last:border-b-0">
          <div className="px-4 pt-2 text-xs font-bold uppercase tracking-wide text-gray-600">{person} <span className="text-gray-400 font-normal">({rows.length})</span></div>
          {rows.map(p => (
            <div key={p.id} className="px-4 py-1.5 flex items-center gap-3 flex-wrap text-sm">
              <button type="button" className="font-medium text-blue-700 hover:underline" onClick={() => onOpen && onOpen({ id: p.id, name: p.name })}>{p.company_name}</button>
              <span className={`text-[11px] font-semibold px-1.5 py-0.5 rounded ${(WORKFLOW_STAGES[p.workflow_stage] || {}).color || 'bg-gray-100 text-gray-600'}`}>{(WORKFLOW_STAGES[p.workflow_stage] || {}).label || p.workflow_stage}</span>
              <InheritedAmBadge am={p.account_manager} />
              <span className="text-xs font-semibold text-red-600">{p.daysOver}d over</span>
              <span className="text-xs text-gray-400">{p._clockSince ? `(follow-up date ${p._clockSince} passed ${p._clockDays}d ago · grace ${p.targetDays}d)` : `(${p.daysInStage}d in stage · target ${p.targetDays}d)`}</span>
              {p.path === 'partial' && <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-blue-100 text-blue-700" title="Partial valuation — momentum deal, meant to move fast.">partial</span>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

// ===== Sales Engine serving (P2, SALES-ENGINE-SPEC.md) =====
// The slide-22 follow-up menu — the OWNER picks these on a call, so every
// next_touch_at is owner-consented ("you asked us to check in today").
// days = default clock; the modal lets the AM override the date.
const SE_DISPOSITIONS = [
  { key: 'valuation_meeting', label: 'Wants a valuation meeting', days: 2, hint: 'hand to VT — 2-day check that the meeting got set' },
  // Adam 09-18 (RAM Computer Services → IT Partners): the owner agreed to
  // meet our buyside client. The record belongs on the PAIR, not the touch
  // cadence — this pick writes the "coordinating meeting" step there (or
  // opens the tie-a-buyer door when no pair exists yet), and the buyside
  // engine's own card carries the follow-up. No personal next-touch date.
  { key: 'meet_bsc', label: 'Wants to meet the buyside client (BSC)', days: null,
    hint: 'recorded on the buyer pair — a "coordinating meeting" card returns in 5 days; no pair yet → the tie-a-buyer door opens' },
  { key: 'email_7d', label: 'Email again in a week', days: 7 },
  { key: 'email_30d', label: 'Email again in a month', days: 30 },
  { key: 'review_6mo', label: 'Review meeting in 6 months', days: 183 },
  { key: 'review_12mo', label: 'Review meeting in 12 months', days: 365 },
  { key: 'owner_reaches_out', label: 'Owner will reach out', days: 365, hint: 'parked — annual sanity check' },
  { key: 'not_ready', label: 'Not ready (say why in the note)', days: 180 },
  // The size-minimums screen from Mark's meeting strategy, split two ways
  // (Mark 08-05): too-small businesses can GROW into fits — pause marketing
  // and recheck; wrong-industry/unsellable is permanent. Both dispositions
  // exclude the owner from marketing waves (the "really bad businesses
  // respond repeatedly" problem).
  { key: 'not_a_fit_small', label: 'Not a fit — too small today (recheck in 24 months)', days: 730,
    hint: 'marketing OFF for the pause; a recheck card returns in 24 months — set a date below for 36' },
  { key: 'not_a_fit', label: 'Not a fit — industry / unsellable (permanent)', days: null,
    hint: 'terminal: out of marketing for good, no follow-up ever; say why in the note' },
  // Lost deals are their own truth (Mark 08-11, Everbase: "we actually
  // closed the deal on June 1") — terminal like not_a_fit, but separately
  // countable: how often owners we were talking to sell without us.
  { key: 'sold_elsewhere', label: 'Sold — closed with someone else (terminal)', days: null,
    hint: 'terminal: the business sold without us; who/when in the note' },
  // Adam 10-09 (Baseline Creative): a friend who emailed a referral — not a seller, so no sales cadence and
  // no cards. Marketing waves still reach them (Mark can switch that off later).
  { key: 'not_a_seller', label: 'Not a seller — friend, referral source or other contact', days: null,
    hint: 'no follow-up and no cards; they stay in the monthly marketing; say who they are in the note' },
];

const SE_BAND_META = {
  0: { label: '📧 REPLY DUE', cls: 'bg-rose-100 text-rose-700' },
  1: { label: 'DUE', cls: 'bg-red-100 text-red-700' },
  2: { label: 'PROMISED', cls: 'bg-amber-100 text-amber-700' },
  3: { label: 'IDEA', cls: 'bg-blue-100 text-blue-700' },
  4: { label: '🎯 PICK THE PLAY', cls: 'bg-violet-100 text-violet-700' },
};

// AM-side strategy plays (Mark 2026-08-04, "every send resolves"): shown in
// the outcome modal ALONGSIDE the owner-consented slide-22 menu — seeing the
// options is the coaching. Any pick (strategy or disposition) retires the
// owner's other stacked reminders.
const SE_STRATEGIES = [
  { key: 'strategy_marketing', label: 'Let monthly marketing take over', clearTouch: true,
    hint: 'personal cadence ends deliberately — the monthly waves keep them warm' },
  { key: 'strategy_followup', label: 'Marketing takes over + timed personal follow-up', days: 183,
    hint: 'Mark 08-05: waves keep running and pause automatically ~60 days before your date — pick it in the commitment row, and put the WHY in the note' },
  { key: 'strategy_buyside', label: 'Buyside-leverage play — park with a date', days: 183, buysideNote: true,
    hint: 'the honest "Active": ~6-month default (or pick YOUR date in the commitment row) + the WHY in the note — the card comes back wearing both' },
  // THE THREE-PLAY PICKER (Mark 09-02, Adam's Tektonic ask — "Zoho-Active"
  // refused on purpose: a status with no clock is a graveyard with a green
  // label. When a buyside intro dies, the strategy menu belongs ON the
  // screen at the decision moment, coach-not-cop style. A buyer's no is not
  // the market's no — the owner TAKING the intro is the signal that counts.)
  { key: 'strategy_buyside_next', label: 'Buyer passed → shop to the NEXT matching buyer', days: 3, buysideNote: true,
    noteText: (co) => `Buyer passed — shop ${co} to the next matching buyside client: open the 🤝 matches on the SE page, pick the best remaining fit, record 📤 Shared. One buyer's no is not the market's no — this owner just proved they'll take the meeting.`,
    hint: '3-day card: open the 🤝 match list and approach the next-best fit while the owner is warm' },
  { key: 'strategy_buyside_pivot', label: 'Buyer passed → pivot to sellside, book the VBG call', days: 3, buysideNote: true,
    noteText: (co) => `Pivot to sellside while warm: ${co} just experienced real buyer interest — book the VBG listing call ("let's find out what the whole market would pay, not one buyer"). Peak receptivity is NOW, not in 6 months.`,
    hint: '3-day card to get the listing call booked while the buyer interest is fresh — peak receptivity' },
  // 🛠 Service touch (Mark 09-02, Colleen's Dental Design "none of the
  // responses apply" — helping pull reports for a revalue is not a sales
  // conversation). Shown ONLY when the owner is linked to an active VT
  // engagement — that guard is what keeps Mark's law intact: this is not
  // "no clock" (the Zoho-Active graveyard), it's "the clock lives in VT."
  // Unlinked prospects never see it, so it can't become the lazy pick.
  { key: 'strategy_service_touch', label: '🛠 Working session — active client (no pipeline change)', vtOnly: true, noTouchChange: true,
    hint: 'service help on a live VT engagement (report pulls, revalue support) — the VT pipeline owns this relationship\'s clock; logs the touch, changes nothing else' },
];

// Per-person serving modes (Mark 2026-07-28 walkthrough — "lobster in
// boiling water"): Adam is the only true AM. He gets IDEAS — auto-ramped,
// friendly-framed, never escalated — layered on top of due promises.
// Zac/Thatcher (Leads) get ONLY their own due promises, no quota, no ideas.
// caps[] = ideas per weekday by week since rampStart (last entry repeats).
// Promise cards (due commitments + arrived follow-up dates) always show for
// everyone — UNCAPPED, oldest first (Mark 08-14: the plate should be clean
// each day; a cap just hides the backlog the nudge email shows anyway).
const SE_SERVING_CONFIG = {
  Adam:     { mode: 'ideas', rampStart: '2026-08-27', caps: [2, 2, 4, 4, 6] },
  Zac:      { mode: 'promises' },
  Thatcher: { mode: 'promises' },
  Scott:    { mode: 'promises' },  // the response desk: scheduling cadence cards
};
// (SE_PROMISES_CAP removed 08-14 — Mark: the plate shows EVERY due promise,
// clean-by-end-of-day is the standard; the old 5/day cap hid Adam's 19-item
// backlog while the nudge email showed all of it.)

// ===== ROUTING B–D SECTIONS (built 08-27, BUYSIDE-OUTLINE) =====
// B — the shared claim pool: "🆕 Buyside interest — last 7 days", collapsed,
// for Adam/Zac/Thatcher. Opportunity, not obligation: claiming takes a
// 7-day exclusive hold; the claimer's task is the vetting conversation
// (tier decision + grade-at-vet + log) via the normal review-card buttons.
const searchCrumbs = (s) => [
  s.sectors, (s.geo_states || []).join(', ') || null, s.geo_notes,
  (s.revenue_min != null || s.revenue_max != null) ? 'Rev range set' : null,
  (s.ebitda_min != null || s.ebitda_max != null) ? 'EBITDA range set' : null,
  (s.meta && s.meta.add_on) ? '🧩 add-on' : null,
].filter(Boolean).join(' · ');
const BuysidePoolSection = ({ items, onClaim, claimGate, actor }) => {
  if (!items || items.length === 0) return null;
  return (
    <details className="mb-6 bg-white border border-teal-200 rounded-lg px-4 py-3">
      <summary className="cursor-pointer text-sm font-bold uppercase tracking-wide text-teal-700">
        🆕 Buyside interest — last 7 days <span className="text-gray-400 font-normal">({items.length} unclaimed)</span>
      </summary>
      <p className="text-xs text-gray-400 my-2">Opportunity, not obligation — new buyers nobody holds yet. <b>Claim</b> = your exclusive 7-day hold: have the vetting conversation, pick the tier, grade them, log it (the card moves to your plate with the normal buttons). No logged decision in 7 days and it returns here wearing a badge; ~10 days unclaimed puts one line on Mark's radar.</p>
      <div className="space-y-1.5">
        {items.map(({ s, ageDays, returned, returnedBy }) => {
          const b = s.buyer || {};
          return (
            <div key={s.id} className="flex items-center gap-2 flex-wrap border-t border-gray-100 pt-1.5 text-xs">
              <span className="font-semibold text-gray-800">{b.company_name || b.contact_name || (b.emails && b.emails[0]) || '(unnamed buyer)'}</span>
              {b.meta && b.meta.flagged_suspicious && <span className="text-[10px] font-bold bg-red-100 text-red-700 rounded px-1.5 py-0.5" title={`🚩 Flagged: inbound from this buyer matched the phishing-buyer pattern — ${(b.meta.flagged_suspicious.reason || '').slice(0, 200)}. Warn-only: we send the links, they don't.`}>🚩 flagged</span>}
              {b.buyer_type && <span className="text-[10px] font-bold uppercase bg-gray-100 text-gray-600 rounded px-1.5 py-0.5">{b.buyer_type}</span>}
              <span className="text-gray-500 truncate max-w-[40%]">{s.label || 'Search'}{searchCrumbs(s) ? ` · ${searchCrumbs(s)}` : ''}</span>
              <span className={`${ageDays > 10 ? 'text-rose-600 font-semibold' : 'text-gray-400'}`}>{Math.floor(ageDays)}d in pool</span>
              {returned && <span className="text-[10px] font-bold bg-amber-100 text-amber-800 rounded px-1.5 py-0.5" title={`Claimed by ${returnedBy || 'someone'}, no logged decision in 7 days — returned to the pool.`}>↩ returned{returnedBy ? ` (${returnedBy})` : ''}</span>}
              <span className="ml-auto flex items-center gap-1.5">
                <CardToolbar buyer={{ id: b.id, emails: b.emails, dm_buyer_id: b.dm_buyer_id }} companyName={b.company_name || b.contact_name || 'Buyer'} actor={actor} />
                <button type="button" disabled={!!claimGate}
                  className={`text-xs px-2.5 py-1 rounded font-semibold ${claimGate ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-teal-600 text-white hover:bg-teal-700'}`}
                  title={claimGate ? 'The clean-plate gate: fresh buyside claims resume the moment nothing on your plate is overdue (due-today doesn\'t count against you).' : 'Take the 7-day exclusive hold — the card moves to your plate for the vetting conversation.'}
                  onClick={() => onClaim(s)}>✋ Claim</button>
              </span>
            </div>
          );
        })}
      </div>
    </details>
  );
};

// C — Scott's same-day lane: active-search requests with no qualification
// answers yet. Scott responds + sends the portal questions; answers return
// or don't (non-response self-filters — Zac's own rule); once answers land
// the search cards Zac (Thatcher backup) as a loaded 20-minute decision.
const ScottActiveAskSection = ({ items, onAsked, actor }) => {
  if (!items || items.length === 0) return null;
  const copyLink = async (b) => {
    if (!b.portal_token) { window.alert('No portal link minted yet for this buyer — send it from the SE page (✉), which mints one.'); return; }
    try { await navigator.clipboard.writeText(`${location.origin}/buyer-portal?t=${b.portal_token}`); window.alert('Portal link copied — paste it into your same-day reply.'); }
    catch (e) { window.prompt('Copy the portal link:', `${location.origin}/buyer-portal?t=${b.portal_token}`); }
  };
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-teal-700">
        ⭐ Active-search requests — respond same-day <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">A buyer asked about the active-search service and hasn't answered the qualification questions yet. Your job, today: a warm reply + their portal link (the About-you questions live there). Answers return or don't — non-response self-filters. The moment answers land, this cards Zac for the accept/decline; you never make that call.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(({ s, ageDays, askedAt }) => {
          const b = s.buyer || {};
          const askedDays = askedAt ? Math.floor((Date.now() - new Date(askedAt).getTime()) / 86400000) : null;
          return (
            <div key={s.id} className="bg-white border border-teal-300 rounded-lg p-3">
              <div className="font-semibold text-gray-800 text-sm truncate">{b.company_name || b.contact_name || '(unnamed buyer)'}
                {b.buyer_type && <span className="ml-1.5 text-[10px] font-bold uppercase bg-gray-100 text-gray-600 rounded px-1.5 py-0.5">{b.buyer_type}</span>}
                <span className="ml-1.5 text-[10px] font-bold bg-teal-600 text-white rounded px-1.5 py-0.5">⭐ wants active search</span>
              </div>
              <div className="text-xs text-gray-600 mt-0.5">{s.label || 'Search'}{searchCrumbs(s) ? ` · ${searchCrumbs(s)}` : ''}</div>
              {s.description && <div className="text-xs text-gray-400 mt-0.5 line-clamp-2" title={s.description}>“{s.description}”</div>}
              <div className="text-xs mt-0.5 text-gray-500">{askedDays != null
                ? <span className="text-amber-700 font-semibold">questions sent {askedDays}d ago — waiting on their answers{askedDays >= 7 ? ' (self-filtering: silence is an answer too)' : ''}</span>
                : <span className={ageDays >= 1 ? 'text-rose-600 font-semibold' : ''}>arrived {Math.floor(ageDays)}d ago — same-day reply is the standard</span>}</div>
              <div className="flex flex-wrap justify-end gap-2 mt-2">
                <CardToolbar className="mr-auto" buyer={{ id: b.id, emails: b.emails, dm_buyer_id: b.dm_buyer_id }} companyName={b.company_name || b.contact_name || 'Buyer'} actor={actor} />
                <button type="button" className="text-xs px-2 py-1 rounded border border-teal-300 text-teal-700 hover:bg-teal-50" onClick={() => copyLink(b)}>📋 Copy portal link</button>
                {askedDays == null && <button type="button" className="text-xs px-2 py-1 rounded bg-teal-600 text-white hover:bg-teal-700" title="You replied and sent the questions — logged; the card waits here until answers arrive (then it cards Zac)." onClick={() => onAsked(s)}>✓ Replied — questions sent</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// D — the wagon on the holder's plate: a RARE buyer ask matched YOUR
// warm/valued business. Route by the match, never rotate — the relationship
// holder decides whether "buyer in hand" changes the owner's conversation.
const WagonHolderSection = ({ items, onHandled, actor }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-rose-700">
        🚩 Buyer in hand — call your owner? <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">A rare buyer ask matched a warm/valued business YOU hold — an inventory alarm, not a chore. You decide: does a real buyer in hand change this owner's conversation? Call or don't — then ✓ so it stops flagging (sitting a few days puts it on Mark's radar).</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(({ s, hit, ageDays }) => {
          const b = s.buyer || {};
          const im = (s.meta && s.meta.instant_match) || {};
          return (
            <div key={s.id} className="bg-white border border-rose-300 rounded-lg p-3">
              <div className="font-semibold text-gray-800 text-sm truncate">{hit.company} <span className="text-gray-400 font-normal">← wanted by</span> {b.company_name || b.contact_name || '(buyer)'}</div>
              <div className="text-xs text-gray-600 mt-0.5">match {hit.pct}% · {im.full || 0} full / {im.one_away || 0} one-away in the whole book (that's the rarity) · logged {Math.floor(ageDays)}d ago{ageDays > 3 ? ' ⚠' : ''}</div>
              {s.description && <div className="text-xs text-gray-400 mt-0.5 line-clamp-2" title={s.description}>the ask: “{s.description}”</div>}
              <div className="flex flex-wrap justify-end gap-2 mt-2">
                <CardToolbar className="mr-auto" ownerId={hit.id} buyer={{ id: b.id, emails: b.emails, dm_buyer_id: b.dm_buyer_id }} companyName={hit.company} actor={actor} />
                <button type="button" className="text-xs px-2 py-1 rounded bg-rose-600 text-white hover:bg-rose-700" title="You made the call — or decided not to. Either is a decision; log the details on the owner (📞 outcome / 🗒 note) as usual." onClick={() => onHandled(s)}>✓ Handled</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ⏸ PAUSED, WITH THE WHY AND WHO'S WAITING (Mark 10-12 staff meeting + the DM session's brief). The reason
// comes from DM (set when the listing is paused); "waiting" = everyone held since the pause (new inquiries +
// CAs signed during it), one per email — people we told "we'll reach out when that changes". Dormant with 10+
// new in 30 days is the signal Mark wants (buyers keep arriving on a listing we don't expect to sell).
const PAUSE_LABEL = {
  enough_buyers: { label: 'paused · enough buyers', cls: 'bg-emerald-100 text-emerald-800' },
  fell_through: { label: 'paused · fell through', cls: 'bg-amber-100 text-amber-800' },   // same three words as DM (10-12)
  dormant: { label: 'paused · dormant', cls: 'bg-gray-200 text-gray-700' },
};
const PausedBadge = ({ r }) => {
  const meta = PAUSE_LABEL[r.pauseReason] || { label: 'paused', cls: 'bg-amber-100 text-amber-700' };
  const w = r.waiting || { count: 0, last30: 0, people: [] };
  const since = r.pausedSince ? new Date(r.pausedSince).toLocaleDateString() : null;
  const hot = r.pauseReason === 'dormant' && w.last30 >= 10;
  const tip = [r.pauseNote, since ? 'Paused since ' + since : null, r.pauseReason ? null : 'No reason set in Deal Manager yet'].filter(Boolean).join(' · ');
  return (
    <span className="ml-2 inline-flex flex-col align-top">
      <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${meta.cls}`} title={tip}>{meta.label}</span>
      {w.count > 0 && (
        <details className="mt-0.5 text-[11px] font-normal">
          <summary className={`cursor-pointer ${hot ? 'text-red-700 font-bold' : r.pauseReason === 'enough_buyers' ? 'text-gray-400' : 'text-gray-600'}`}
            title="Everyone held since the pause: new inquiries + CAs signed during it. They were told we'd reach out when that changes.">
            {hot ? '🔔 ' : ''}{w.count} waiting{w.last30 !== w.count ? ` (${w.last30} in 30 days)` : ''}
          </summary>
          <div className="mt-1 max-h-48 overflow-y-auto bg-white border rounded p-1.5 space-y-0.5">
            {(w.people || []).map((p, i) => (
              <div key={i} className="text-gray-700">
                {p.name || p.email}{p.company ? ` · ${p.company}` : ''}{p.email && p.name ? <span className="text-gray-400"> · {p.email}</span> : ''}
                <span className="text-gray-400"> · {p.kind === 'ca' ? 'CA signed' : (p.source || 'inquiry')} {p.at ? String(p.at).slice(0, 10) : ''}</span>
              </div>
            ))}
          </div>
        </details>
      )}
    </span>
  );
};

// Mark's exception radar — one line each for pool items unclaimed 10+ days
// and wagons unhandled 3+ days. Exceptions only, never the full worklist.
const BuysideRadarSection = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6 bg-amber-50 border border-amber-300 rounded-lg px-4 py-3">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-amber-800">📡 Buyside routing — aging exceptions <span className="text-gray-500 font-normal">({items.length})</span></h2>
      <div className="space-y-1 text-xs text-gray-700">
        {items.map(({ kind, s, holder, ageDays }) => {
          const b = s.buyer || {};
          const name = b.company_name || b.contact_name || '(buyer)';
          return kind === 'wagon'
            ? <div key={s.id}>🚩 <b>{name}</b>'s rare ask matched a warm business on <b>{holder}</b>'s plate — unhandled {Math.floor(ageDays)}d.</div>
            : <div key={s.id}>🆕 <b>{name}</b> ({b.buyer_type || 'buyer'}) — {Math.floor(ageDays)}d in the claim pool, nobody's picked it up.</div>;
        })}
      </div>
    </div>
  );
};

// Buyside review cards (outline C+M, 2026-08-07): new/changed buyer search
// criteria land here for the reviewer's decision — Mark's bones ②③ plus
// Zac's vetting stage. Active-search requests surface loudly; standing
// 'review' (vetting) cards persist until accepted or declined.
const BuysideReviewSection = ({ items, onAct, showHolder, actor }) => {
  if (!items || items.length === 0) return null;
  const money = (n) => n == null ? null : (n >= 1e6 ? '$' + (n / 1e6).toFixed(n % 1e6 ? 1 : 0) + 'M' : '$' + Math.round(n / 1e3) + 'k');
  const range = (lo, hi, label) => (lo == null && hi == null) ? null : `${label} ${lo != null ? money(lo) : '…'}–${hi != null ? money(hi) : '…'}`;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-teal-700">
        🤝 Buyer criteria — review new &amp; changed <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">Every buyer's new or changed search lands here before matching runs against it — list-only buyers included (the 💰/BSA/⭐ badges mark the actually-buyside ones; accepted active searches live in Mandates). Review the criteria and pick the path — everything stays on record either way.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(s => {
          const b = s.buyer || {};
          const retired = s.status === 'retired';
          const vetting = s.status === 'review' && !s.needs_review;
          const wantsActive = s.service_level === 'active_search';
          const crumbs = [
            s.sectors, (s.geo_states || []).join(', ') || null, s.geo_notes,
            range(s.revenue_min, s.revenue_max, 'Rev'), range(s.ebitda_min, s.ebitda_max, 'EBITDA'),
            // Add-on flag (Mark 08-25): the matcher waives this search's
            // EBITDA floor — the reviewer should see that's in play.
            (s.meta && s.meta.add_on) ? '🧩 add-on — EBITDA floor waived' : null,
          ].filter(Boolean).join(' · ');
          return (
            <div key={s.id} className={`bg-white border rounded-lg p-3 ${retired ? 'border-gray-300' : wantsActive ? 'border-teal-400' : 'border-teal-200'}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold text-gray-800 text-sm truncate">{b.company_name || b.contact_name || (b.emails && b.emails[0]) || '(unnamed buyer)'}
                    {b.buyer_type && <span className="ml-1.5 text-[10px] font-bold uppercase bg-gray-100 text-gray-600 rounded px-1.5 py-0.5">{b.buyer_type}</span>}
                    {b.willing_buyside_fees && b.bsa_signed && <span className="ml-1 text-[10px] font-bold bg-emerald-100 text-emerald-700 rounded px-1.5 py-0.5" title="Would pay a buyside fee — and a signed BSA is on file.">💰 fees · BSA ✒</span>}
                    {b.willing_buyside_fees && !b.bsa_signed && <span className="ml-1 text-[10px] font-bold bg-amber-100 text-amber-800 rounded px-1.5 py-0.5" title="Will pay buyside fees, but needs to sign an agreement before we introduce them to an owner.">💰 fees · 🔒 BSA needed</span>}
                    {!b.willing_buyside_fees && b.bsa_signed && <span className="ml-1 text-[10px] font-bold bg-emerald-100 text-emerald-700 rounded px-1.5 py-0.5" title="A signed BSA is on file.">BSA ✒</span>}
                    {b.meta && b.meta.retained_search_interest && <span className="ml-1 text-[10px] font-bold bg-teal-100 text-teal-800 rounded px-1.5 py-0.5" title="Checked the retained-active-search interest box — someone should start that conversation.">⭐ retained?</span>}
                  </div>
                  <div className="text-xs text-gray-600 mt-0.5">{s.label || 'Search'}{s.created_via ? <span className="text-gray-400"> · via {s.created_via}</span> : ''}{showHolder && s._holder ? <span className="text-gray-400"> · → {s._holder}</span> : ''}
                    {s._claimed && <span className="ml-1.5 text-[10px] font-bold bg-teal-100 text-teal-800 rounded px-1.5 py-0.5" title="Your pool claim — an exclusive hold while you vet. A decision below (Let's talk / Reviewed / Not a fit) settles it; no decision and it returns to the pool.">✋ your claim · {s._claimed.daysLeft}d left</span>}
                    {s._preQualified && <span className="ml-1.5 text-[10px] font-bold bg-indigo-100 text-indigo-800 rounded px-1.5 py-0.5" title="Routing C: the buyer answered the portal qualification questions — this is the loaded 20-minute accept/decline, Zac's call (Thatcher backup). The 📋 answers are on the buyer record.">📋 pre-qualified → your decision</span>}
                  </div>
                  {crumbs && <div className="text-xs text-gray-500 mt-0.5">{crumbs}</div>}
                  {s.description && <div className="text-xs text-gray-400 mt-0.5 line-clamp-2" title={s.description}>“{s.description}”</div>}
                  {/* The full-record door (routing build, 08-27 — "today only
                      the free-text quote shows"): every structured field in
                      place, plus the SE deep link for the record + 🎯. */}
                  <details className="text-xs text-gray-500 mt-0.5" onClick={e => e.stopPropagation()}>
                    <summary className="cursor-pointer text-gray-400 hover:text-gray-600">full record ▾</summary>
                    <div className="mt-1 space-y-0.5 bg-gray-50 border border-gray-100 rounded p-2">
                      {[['Sectors', s.sectors], ['Keywords', s.keywords], ['States', (s.geo_states || []).join(', ')], ['Geo notes', s.geo_notes],
                        ['Revenue', (s.revenue_min != null || s.revenue_max != null) ? `${s.revenue_min != null ? '$' + Number(s.revenue_min).toLocaleString() : '…'} – ${s.revenue_max != null ? '$' + Number(s.revenue_max).toLocaleString() : '…'}` : null],
                        ['EBITDA', (s.ebitda_min != null || s.ebitda_max != null) ? `${s.ebitda_min != null ? '$' + Number(s.ebitda_min).toLocaleString() : '…'} – ${s.ebitda_max != null ? '$' + Number(s.ebitda_max).toLocaleString() : '…'}${s.meta && s.meta.add_on ? ' (🧩 add-on — floor waived)' : ''}` : null],
                        ['Service', s.service_level === 'active_search' ? '⭐ active search requested' : 'list only'],
                        ['Arrived', `${String(s.created_at || '').slice(0, 10)} via ${s.created_via || '?'}`],
                        ['Buyer emails', (b.emails || []).join(', ')]]
                        .filter(([, v]) => v).map(([k, v]) => <div key={k}><span className="font-semibold text-gray-600">{k}:</span> {v}</div>)}
                      {s.description && <div><span className="font-semibold text-gray-600">In their words:</span> {s.description}</div>}
                      <a className="inline-block text-teal-700 underline" href={`/sales-engine?buyer=${encodeURIComponent(b.id)}`} target="_blank" rel="noopener" onClick={e => e.stopPropagation()}>↗ open in SE — record, other searches, 🎯 targets</a>
                    </div>
                  </details>
                  {s.meta && s.meta.red_wagon && s.meta.instant_match && (() => {
                    const im = s.meta.instant_match;
                    const hits = im.full != null ? im.full : (im.strong || 0);
                    const isWagon = hits >= 1 && hits <= 5;   // rarity IS the wagon test
                    const stats = im.full != null
                      ? `${im.full} full · ${im.one_away} one-answer-away${im.top_gap ? ` (${im.top_gap})` : ''} of ${im.total}${im.capped ? '+' : ''}`
                      : `${im.strong} strong match${im.strong === 1 ? '' : 'es'} of ${im.total}`;
                    return (
                      <div className={`text-xs mt-0.5 ${isWagon ? 'font-semibold text-rose-700' : 'text-gray-500'}`} title={(im.top || []).map(t => `${t.company} (${t.tier}, ${t.pct}%)`).join(' · ') || 'Instant match ran at log time'}>
                        {isWagon
                          ? <span>🚩 RED WAGON — {stats}{im.warm ? <span className="text-rose-800"> · {im.warm} WARM</span> : ''} — call the owner?</span>
                          : <span>matches at log time: {stats}{im.warm ? ` · ${im.warm} warm` : ''}</span>}
                      </div>
                    );
                  })()}
                  {s.meta && s.meta.red_wagon && !s.meta.instant_match && <div className="text-xs font-semibold mt-0.5 text-rose-700">🚩 red wagon inquiry</div>}
                </div>
                <span className={`text-[10px] font-bold uppercase tracking-wide rounded px-1.5 py-0.5 whitespace-nowrap ${retired ? 'bg-gray-100 text-gray-500' : vetting ? 'bg-amber-100 text-amber-800' : wantsActive ? 'bg-teal-600 text-white' : 'bg-teal-100 text-teal-800'}`}>
                  {retired ? 'buyer removed' : vetting ? 'vetting' : wantsActive ? '⭐ active search' : s.needs_review && s.status !== 'new' ? 'changed' : 'new'}
                </span>
              </div>
              <div className="flex flex-wrap justify-end gap-2 mt-2">
                <CardToolbar className="mr-auto" buyer={{ id: b.id, emails: b.emails, dm_buyer_id: b.dm_buyer_id }} companyName={b.company_name || b.contact_name || 'Buyer'} actor={actor} />
                {retired ? (
                  <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" onClick={() => onAct(s, 'ack')}>✓ Acknowledge</button>
                ) : vetting ? (
                  <React.Fragment>
                    <button type="button" className="text-xs px-2 py-1 rounded bg-teal-600 text-white hover:bg-teal-700" title="Vetting passed — the active search goes live (the mandate)." onClick={() => onAct(s, 'accept')}>✓ Accept active search</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="Vetting says no — decline politely; everything stays on record." onClick={() => onAct(s, 'decline')}>✗ Not a fit — decline</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="Not a paid search, but keep matching them against the list." onClick={() => onAct(s, 'ok')}>On the list instead</button>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {s._claimed && <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-500 hover:bg-gray-50" title="Hand the claim back to the pool early — no harm, someone else picks it up." onClick={() => onAct(s, 'release')}>↩ Release</button>}
                    <button type="button" className="text-xs px-2 py-1 rounded bg-teal-600 text-white hover:bg-teal-700" title="Criteria look fine — matching runs against them from now on." onClick={() => onAct(s, 'ok')}>👀 Reviewed — on the list</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-teal-300 text-teal-700 hover:bg-teal-50" title="Interesting (or they asked for an active search) — start the vetting conversation. Card stays with you until accept/decline." onClick={() => onAct(s, 'talk')}>🗣 Let's talk — vet</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="Not a good candidate for a successful search right now — kept on record." onClick={() => onAct(s, 'decline')}>✗ Not a fit right now</button>
                  </React.Fragment>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// G: shared-with-buyer SLA + post-IOI clocks. Two card types: a share with
// no buyer feedback after 48h (N's SLA — silence = assumed pass, told to
// the client) and an IOI-active pair silent a week+ (Mark's
// lead-by-ignoring rule: the nag replaces the blind reminder).
// 📋 The buyside board (Mark 09-04): "not a to-do section, but a here is
// what's happening section." One row per live buyer-×-business pair —
// stage, last movement, next meeting. Purely ambient: every action still
// happens through the clock cards or the 🤝 match window (the row's link).
// ── ➕ THE ONE DOOR + its step picker (Mark 09-17). The curated buyside step
// list: every real path has a home, and each waiting-state knows whom we're
// waiting on so the clock cards chase the right party. Kinds are the BE
// ledger (se_buyer_touches.kind); the starred ones are new.
// 🤝 BUYSIDE CREDIT — THE INTRODUCER (Mark 09-23, Allevia × IT Partners:
// Adam read "Managed by: Thatcher" on the owner record as the commissioned
// AM. On a buyside deal the credit goes to whoever made the introduction to
// our buyside client — always the intro, never the owner-relationship
// holder, never the last person to touch the pair. Rule: a recorded
// override (a 'note' touch carrying meta.credit_to, with a reason) wins;
// else the staff member who logged 🤝 Intro set / Intro held; else who
// shared the business; else the last staff actor; else the owner's AM.
// Names only ever reach staff surfaces — never amounts or rates.
const buysideStaffActor = (t) => !!(t && t.actor && t.actor !== 'system' && t.actor !== 'buyer' && t.actor !== 'dm');
const buysideIntroCredit = (touches, owner) => {
  const ts = touches || [];
  const ov = [...ts].reverse().find(t => t.meta && t.meta.credit_to);
  if (ov) return { name: ov.meta.credit_to, source: 'override', reason: ov.meta.credit_reason || '', by: ov.actor, at: ov.at };
  const intro = ts.find(t => (t.kind === 'intro_set' || t.kind === 'intro_held') && buysideStaffActor(t));
  if (intro) return { name: intro.actor, source: 'intro', at: intro.at };
  const shared = ts.find(t => t.kind === 'shared' && buysideStaffActor(t));
  if (shared) return { name: shared.actor, source: 'shared', at: shared.at };
  const last = [...ts].reverse().find(buysideStaffActor);
  if (last) return { name: last.actor, source: 'last', at: last.at };
  return { name: (owner && owner.assigned_to) || 'Zac', source: 'assigned' };
};
const BUYSIDE_CREDIT_WHY = {
  override: 'set by hand', intro: 'made the introduction', shared: 'shared the business (no intro logged yet)',
  last: 'last to touch the pair (no intro logged yet)', assigned: "the owner's AM (nothing logged on the pair yet)",
};
// 💲 The offer price on an IOI or LOI (Adam 10-21, ITPartners -> ASI Networks: "no way to input the transaction price").
// Asked when the step is recorded: one number or a range (3000000-3500000, $3.2M, 3.2m-3.5m). Cancel = no price,
// blank = none given. Rides the touch meta (price_low / price_high) and the subject, so the board and history show it.
const buysideAskPrice = (what, buyerName, bizName) => {
  const raw = window.prompt(`${what} from ${buyerName} on ${bizName}: the offer price?

One number or a range, e.g. 3200000 or 3.2m-3.5m. Leave blank if they didn't give one.`, '');
  if (raw === null || !String(raw).trim()) return null;
  const num = (t) => { const m = String(t).trim().toLowerCase().replace(/[$,\s]/g, '').match(/^([\d.]+)(k|m)?$/); if (!m) return null; const n = Number(m[1]) * (m[2] === 'm' ? 1e6 : m[2] === 'k' ? 1e3 : 1); return isFinite(n) && n > 0 ? Math.round(n) : null; };
  const parts = String(raw).split(/\s*(?:-|–|to)\s*/i).filter(Boolean);
  const lo = num(parts[0]); const hi = parts[1] ? num(parts[1]) : lo;
  if (lo == null || hi == null) { window.alert('Could not read that price, so it was left off. Use numbers like 3200000 or 3.2m-3.5m.'); return null; }
  const fmt = (n) => n >= 1e6 ? `$${(n / 1e6).toFixed(n % 1e6 ? 2 : 0).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')}M` : `$${Math.round(n / 1000)}K`;
  return { price_low: Math.min(lo, hi), price_high: Math.max(lo, hi), label: lo === hi ? fmt(lo) : `${fmt(Math.min(lo, hi))}–${fmt(Math.max(lo, hi))}` };
};
const BUYSIDE_STEPS = [
  { kind: 'matched',              label: 'Owner interested — nothing sent yet',                       waits: 'us',    defaultDays: 3 },
  { kind: 'nda_sent',             label: 'NDA sent to buyer — waiting on signature',                  waits: 'buyer', defaultDays: 5 },
  // Adam 09-17 (Ignition): NDA executed, now waiting on the SELLER to open the
  // data room — sat between "NDA sent" and "shared". That IS the awaiting-docs
  // state (the wait is on the owner for materials); the label just said
  // "financials / docs" and the list put it AFTER shared. Relabeled + moved.
  // Adam 09-29 (RAM → IT Partners): after an intro the owner agreed to upload — same wait, but
  // "NDA done" hid it from him. Label names both ways in.
  { kind: 'awaiting_docs',        label: 'Owner agreed to share (NDA done or intro went well) — waiting on OWNER to upload data room / financials', waits: 'owner', defaultDays: 7 },
  { kind: 'shared',               label: "Business shared / data room sent — waiting on buyer's answer", waits: 'buyer', defaultDays: 2 },
  { kind: 'coordinating_meeting', label: 'Coordinating buyer–seller meeting — waiting on scheduling', waits: 'both',  defaultDays: 5 },
  { kind: 'intro_set',            label: 'Intro meeting set',                                         waits: null,    defaultDays: null },
  { kind: 'intro_held',           label: 'Intro meeting conducted',                                   waits: null,    defaultDays: null },
  { kind: 'ioi',                  label: 'IOI received',                                              waits: null,    defaultDays: null },
  { kind: 'loi',                  label: 'LOI',                                                       waits: null,    defaultDays: null },
  { kind: 'passed',               label: 'Buyer passed',                                              waits: null,    defaultDays: null },
  // Adam 09-18 (Vintage IT → IT Partners Canada): the SELLER backed out, no
  // reason given. Not a buyer pass — a pass feeds the buyer's freshness loop
  // ("did your criteria change?") and the pass-rate metric, both wrong here.
  // Terminal for the pair like passed; counted apart; the buyer is not asked.
  { kind: 'owner_withdrew',       label: 'Owner backed out — withdrew from this buyer',               waits: null,    defaultDays: null },
  { kind: 'closed',               label: 'Closed',                                                    waits: null,    defaultDays: null },
];
const BuysideStepPicker = ({ initialKind = 'matched', onSave, onCancel }) => {
  const [kind, setKind] = useState(initialKind);
  const [waitingOn, setWaitingOn] = useState('');
  const [byDate, setByDate] = useState('');
  const S = BUYSIDE_STEPS.find(s => s.kind === kind) || BUYSIDE_STEPS[0];
  const plusDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
  const hint = S.waits === 'buyer' ? 'the buyer — what exactly?' : S.waits === 'owner' ? 'the owner — what exactly?' : S.waits === 'both' ? 'scheduling — whom?' : 'your next move';
  return (
    <div className="mt-2 p-2 rounded border border-violet-200 bg-violet-50 text-xs space-y-1.5">
      <div>
        <div className="text-gray-500 mb-0.5">Where is this deal right now?</div>
        <select value={kind} onChange={e => setKind(e.target.value)} className="w-full border border-gray-300 rounded px-2 py-1 text-xs bg-white">
          {BUYSIDE_STEPS.map(s => <option key={s.kind} value={s.kind}>{s.label}</option>)}
        </select>
      </div>
      {S.waits && (
        <div className="flex flex-wrap gap-2 items-center">
          <span className="text-gray-500">Waiting on</span>
          <input value={waitingOn} onChange={e => setWaitingOn(e.target.value)} placeholder={hint} className="flex-1 min-w-[160px] border border-gray-300 rounded px-2 py-1 text-xs" />
          <span className="text-gray-500">by</span>
          <input type="date" value={byDate} onChange={e => setByDate(e.target.value)} className="border border-gray-300 rounded px-2 py-1 text-xs" />
          {S.defaultDays ? <button type="button" className="text-[10px] text-violet-700 underline" onClick={() => setByDate(plusDays(S.defaultDays))}>+{S.defaultDays}d</button> : null}
        </div>
      )}
      <div className="flex gap-2 justify-end">
        {onCancel && <button type="button" onClick={onCancel} className="px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-white">Cancel</button>}
        <button type="button" onClick={() => onSave({ kind, label: S.label, waitingOn: waitingOn.trim() || null, byDate: byDate || null })} className="px-2 py-1 rounded bg-violet-600 text-white hover:bg-violet-700 font-semibold">Save step</button>
      </div>
    </div>
  );
};
// 🪦 TOMBSTONE SIGN-OFF (Mark 09-30): Scott drafts a sold listing's public tombstone in the Sales
// Engine; Zac approves it here (it goes live on the website's Sold page) or sends it back with a note.
// Self-sufficient: the whole tombstone is on the card. Scott sees his sent-back ones here too.
// 📊 REPORT REQUESTS TO APPROVE (Mark 10-22): a report asked for by Adam, Scott, Konnie or Thatcher waits for Zac's or
// Colleen's OK before Claude runs it. The whole request is on the card; Approve, or Not this time with a short note
// (the reporter sees the note). Zac and Colleen both see the same requests; the first to decide settles it.
const ReportApprovalSection = ({ myName, isOwner }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  const call = async (path, opts = {}) => {
    const { data: { session } } = await supabaseClient.auth.getSession();
    const r = await fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) } });
    return r.json().catch(() => ({}));
  };
  const load = async () => { if (!supabaseClient) return; const j = await call('/api/reports/approvals'); setItems(j.ok ? j.items : []); };
  useEffect(() => { if (['Zac', 'Colleen'].includes(myName) || isOwner) load(); }, [myName, isOwner]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (!items || !items.length) return null;
  const decide = async (x, ok) => {
    let note = '';
    if (!ok) { note = window.prompt('Not this time: a short note for ' + x.reporter + ' (why, or what to ask instead):') || ''; if (!note.trim()) return; }
    setBusy(x.id);
    const j = await call('/api/reports/' + x.id + '/approval', { method: 'POST', body: JSON.stringify({ ok, note }) });
    setBusy('');
    if (!j.ok) { window.alert('Could not save: ' + (j.error || 'unknown')); return; }
    setItems(prev => prev.filter(y => y.id !== x.id));
  };
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-gray-700">📊 Report requests to approve <span className="text-gray-400 font-normal">({items.length})</span></h2>
      <p className="text-xs text-gray-500 mb-2">Asked for through 🐞 by someone outside management. Approve and Claude runs it (the file lands in their ShareFile folder), or say why not.</p>
      <div className="bg-white border border-gray-200 rounded-lg p-3 space-y-3">
        {items.map(x => (
          <div key={x.id} className="border-t border-gray-100 pt-2 first:border-0 first:pt-0 text-xs">
            <div className="font-semibold text-gray-800">{x.reporter} <span className="text-gray-400 font-normal">· {new Date(x.created_at).toLocaleDateString()}{x.record_label ? ' · ' + x.record_label : ''}</span></div>
            <div className="text-gray-700 mt-0.5 whitespace-pre-wrap">{x.body}</div>
            <div className="flex gap-1.5 mt-1.5">
              <button type="button" disabled={busy === x.id} onClick={() => decide(x, true)} className="px-2 py-0.5 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">Approve ✓</button>
              <button type="button" disabled={busy === x.id} onClick={() => decide(x, false)} className="px-2 py-0.5 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">Not this time</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// 🤔 CLAUDE NEEDS YOUR CALL (Mark 10-22): Claude's question (options + note + Let's talk) or heads-up (Got it) for this
// person. Everything to decide is on the card. "Let's talk" = sit down at the office computer and say who you are.
const ClaudeAskSection = ({ myName }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  const [notes, setNotes] = useState({});
  const call = async (path, opts = {}) => {
    const { data: { session } } = await supabaseClient.auth.getSession();
    const r = await fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) } });
    return r.json().catch(() => ({}));
  };
  const load = async () => { if (!supabaseClient) return; const j = await call('/api/claude-asks'); setItems(j.ok ? (j.items || []) : []); };
  useEffect(() => { if (!myName) return undefined; load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, [myName]);   // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (items && items.length && window.location.hash === '#claude-ask') { const el = document.getElementById('claude-ask'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }, [items]);
  if (!items || !items.length) return null;
  const send = async (x, body) => {
    setBusy(x.id);
    const j = await call('/api/claude-asks/' + x.id + '/answer', { method: 'POST', body: JSON.stringify({ ...body, note: notes[x.id] || '' }) });
    setBusy('');
    if (!j.ok) { window.alert('Could not save: ' + (j.error || 'unknown')); }
    load();
  };
  return (
    <div id="claude-ask" className="mb-6">
      {items.map(x => (
        <div key={x.id} className={'rounded-lg border p-3 mb-3 text-xs ' + (x.kind === 'fyi' ? 'bg-sky-50 border-sky-300' : 'bg-violet-50 border-violet-300')}>
          <div className="font-bold text-sm text-gray-800">{x.kind === 'fyi' ? '📣 From Claude' : '🤔 Claude needs your call'} <span className="font-normal text-gray-400">· {new Date(x.created_at).toLocaleDateString()}</span></div>
          {/* Zac 10-23 on the first heads-up: "not really seeing a question, more of a comment" — say so up front. */}
          {x.kind === 'fyi' ? <div className="text-[11px] text-sky-800">A heads-up, nothing to decide: read it and click <b>Got it</b>. Add a note only if you want something handled differently.</div> : null}
          <div className="mt-1 font-semibold text-gray-900">{x.title}</div>
          <div className="mt-1 text-gray-700 whitespace-pre-wrap">{x.body}</div>
          {x.status === 'talk' ? (
            <div className="mt-2 text-violet-800 font-semibold">You chose Let's talk. Sit down at the office computer, open the Claude session and type: "{myName} here about: {x.title}".</div>
          ) : (
            <>
              {(x.options || []).length > 0 && (
                <div className="mt-2 space-y-1.5">
                  {x.options.map(o => (
                    <div key={o.key} className="flex items-start gap-2">
                      <button type="button" disabled={busy === x.id} onClick={() => send(x, { key: o.key })} className="shrink-0 px-2 py-1 rounded bg-violet-700 text-white font-semibold hover:bg-violet-800">{o.label}</button>
                      {o.effect ? <span className="text-gray-600 pt-1">{o.effect}</span> : null}
                    </div>
                  ))}
                </div>
              )}
              <textarea rows={2} value={notes[x.id] || ''} onChange={e => setNotes(p => ({ ...p, [x.id]: e.target.value }))} placeholder={x.kind === 'fyi' ? 'A note back to Claude (optional)' : 'A note, or your own answer'} className="mt-2 w-full border border-gray-300 rounded p-1.5 text-xs" />
              <div className="flex gap-1.5 mt-1.5">
                {x.kind === 'fyi'
                  ? <button type="button" disabled={busy === x.id} onClick={() => send(x, { seen: true })} className="px-2 py-1 rounded bg-sky-700 text-white font-semibold hover:bg-sky-800">Got it ✓</button>
                  : <button type="button" disabled={busy === x.id || !(notes[x.id] || '').trim()} onClick={() => send(x, {})} className="px-2 py-1 rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-50">Send my note as the answer</button>}
                {x.kind !== 'fyi' && <button type="button" disabled={busy === x.id} onClick={() => send(x, { talk: true })} className="px-2 py-1 rounded border border-violet-300 bg-white text-violet-800 hover:bg-violet-50">💬 Let's talk</button>}
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

// 🛠 CLAUDE'S SQL CARDS (Mark 10-22): a data fix Claude needs, run by Scott or Colleen (first "Ran it" settles it).
// Erasing data waits on Mark's card first ("🛑 Approve"), then reaches them. Everything to act is on the card.
const ClaudeSqlSection = ({ myName, isOwner }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  const [copied, setCopied] = useState('');
  const call = async (path, opts = {}) => {
    const { data: { session } } = await supabaseClient.auth.getSession();
    const r = await fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) } });
    return r.json().catch(() => ({}));
  };
  const load = async () => { if (!supabaseClient) return; const j = await call('/api/sql-requests'); setItems(j.ok ? (j.items || []) : []); };
  const runner = ['Scott', 'Colleen'].includes(myName);
  useEffect(() => {
    if (!runner && !isOwner) return undefined;
    load(); const t = setInterval(load, 120000);
    return () => clearInterval(t);
  }, [myName, isOwner]);   // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (items && items.length && window.location.hash === '#claude-sql') { const el = document.getElementById('claude-sql'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }, [items]);
  const mine = (items || []).filter(x => x.status === 'pending_approval' ? isOwner : runner);
  if (!mine.length) return null;
  const act = async (x, path, body) => {
    setBusy(x.id);
    const j = await call('/api/sql-requests/' + x.id + '/' + path, { method: 'POST', body: JSON.stringify(body || {}) });
    setBusy('');
    if (!j.ok) { window.alert((path === 'run' ? "Didn't run: " : 'Could not save: ') + (j.error || 'unknown')); load(); return; }
    if (path === 'run') window.alert(j.status === 'error' ? 'It showed an error, and nothing was changed:\n\n' + (j.error || '') + '\n\nClaude sees it within a few minutes and fixes the card.' : '✓ Done.\n\n' + (j.result || '') + '\n\nClaude checks it within a few minutes.');
    load();
  };
  const run = (x) => { if (window.confirm('Run "' + x.title + '" on the live database now?\n\nIt runs exactly as written on the card, all of it or none of it.')) act(x, 'run'); };
  const copy = async (x) => { try { await navigator.clipboard.writeText(x.sql); setCopied(x.id); setTimeout(() => setCopied(''), 2500); } catch (e) { window.prompt('Copy this (Ctrl+C):', x.sql); } };
  return (
    <div id="claude-sql" className="mb-6">
      {mine.map(x => {
        const approve = x.status === 'pending_approval';
        return (
          <div key={x.id} className={'rounded-lg border p-3 mb-3 text-xs ' + (approve ? 'bg-red-50 border-red-300' : x.urgent ? 'bg-red-50 border-red-500 border-2' : 'bg-amber-50 border-amber-300')}>
            <div className="font-bold text-sm text-gray-800">{approve ? '🛑 Claude wants to ERASE data: your approval first' : x.urgent ? '🔴 URGENT: Claude needs a SQL run now' : '🛠 Claude needs a SQL run'}{x.practice ? <span className="ml-2 px-1.5 py-0.5 rounded bg-blue-100 text-blue-800 text-[10px]">PRACTICE</span> : null}</div>
            <div className="mt-1 text-gray-800"><b>{x.title}</b>{x.rows_touched ? <span className="text-gray-500"> · {x.rows_touched}</span> : null}</div>
            {x.why ? <div className="mt-0.5 text-gray-600 whitespace-pre-wrap">{x.why}</div> : null}
            {x.status === 'error' ? <div className="mt-1 text-red-700">Last try showed an error ({x.ran_by}): {x.error_text}. Claude is fixing it.</div> : null}
            <pre className="mt-2 p-2 bg-white border border-gray-200 rounded font-mono text-[11px] whitespace-pre-wrap break-all">{x.sql}</pre>
            {approve ? (
              <div className="flex gap-1.5 mt-2">
                <button type="button" disabled={busy === x.id} onClick={() => act(x, 'approve', { ok: true })} className="px-2 py-1 rounded bg-red-600 text-white font-semibold hover:bg-red-700">Approve: send to Scott and Colleen</button>
                <button type="button" disabled={busy === x.id} onClick={() => { const n = window.prompt('Not this time: a short note for Claude (why):') || ''; if (n.trim()) act(x, 'approve', { ok: false, note: n }); }} className="px-2 py-1 rounded border border-gray-300 text-gray-700 bg-white hover:bg-gray-50">Not this time</button>
              </div>
            ) : (
              <>
                {!x.run_blocked && x.status !== 'error' && (
                  <div className="mt-2">
                    <button type="button" disabled={busy === x.id} onClick={() => run(x)} className="px-3 py-1.5 rounded bg-emerald-600 text-white font-bold text-sm hover:bg-emerald-700">{busy === x.id ? 'Running…' : '▶ Run it'}</button>
                    <span className="ml-2 text-gray-600">Runs from VT. No Supabase needed. Claude checks the result within a few minutes.</span>
                  </div>
                )}
                {x.run_blocked && <div className="mt-2 text-amber-800 font-semibold">VT won't run this one ({x.run_blocked}). Colleen or Mark runs it in Supabase:</div>}
                <details className="mt-2" open={!!x.run_blocked}>
                  <summary className="cursor-pointer text-gray-500">{x.run_blocked ? 'Supabase steps' : 'Or run it in Supabase (the old way)'}</summary>
                <ol className="mt-2 list-decimal ml-4 text-gray-700 space-y-0.5">
                  <li><button type="button" onClick={() => copy(x)} className="px-2 py-0.5 rounded bg-gray-800 text-white font-semibold">{copied === x.id ? '✓ Copied' : '📋 Copy the SQL'}</button></li>
                  <li>Chrome → <b>Supabase</b> → the Vista project → <b>SQL Editor</b> → <b>New query</b>.</li>
                  <li>Click in the editor, <b>Ctrl+V</b>, then <b>Run</b>. Green "Success" = done.</li>
                  <li>Come back here and click <b>✓ Ran it</b>. Claude checks it within a few minutes.</li>
                </ol>
                <div className="flex gap-1.5 mt-2">
                  <button type="button" disabled={busy === x.id || x.status === 'error'} onClick={() => { const r = window.prompt(x.practice ? 'Practice: type what Supabase showed (the number under the results, or "Success. No rows returned"):' : 'Optional: paste what Supabase showed (or leave blank):', ''); if (r === null) return; act(x, 'ran', { result: r }); }} className="px-2 py-1 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">✓ Ran it</button>
                  <button type="button" disabled={busy === x.id || x.status === 'error'} onClick={() => { const e = window.prompt('Paste the red error message from Supabase:', ''); if (e && e.trim()) act(x, 'error', { error: e }); }} className="px-2 py-1 rounded border border-gray-300 text-gray-700 bg-white hover:bg-gray-50">⚠ It showed an error</button>
                </div>
                </details>
                <div className="mt-1 text-[10px] text-gray-500">Scott and Colleen both see this; whoever is free runs it. It clears for both once someone runs it.</div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

const TombstoneSection = ({ myName, myEmail, isOwner }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  const call = async (path, opts = {}) => {
    const { data: { session } } = await supabaseClient.auth.getSession();
    const r = await fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) } });
    return r.json().catch(() => ({}));
  };
  const load = async () => { if (!supabaseClient) return; const j = await call('/api/website-tombstones/queue'); setItems(j.ok ? j.items : []); };
  useEffect(() => { load(); }, [myName]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (!items) return null;
  const reviewer = myName === 'Zac' || isOwner;
  const toReview = reviewer ? items.filter(x => x.status === 'submitted') : [];
  const mine = items.filter(x => x.status === 'returned' && String(x.submitted_by || '').toLowerCase() === String(myEmail || '').toLowerCase());
  if (!toReview.length && !mine.length) return null;
  const act = async (x, action) => {
    let note = '';
    if (action === 'return') { note = window.prompt('What should Scott change?') || ''; if (!note.trim()) return; }
    setBusy(x.vista_id);
    const j = await call('/api/website-tombstones/review', { method: 'POST', body: JSON.stringify({ vista_id: x.vista_id, action, note }) });
    setBusy('');
    if (!j.ok) window.alert(j.error || 'Could not save');
    load();
  };
  const Card = ({ x, children }) => (
    <div className="bg-white border border-gray-300 rounded-lg p-3 text-sm">
      {x.logo_data && <img src={x.logo_data} alt="" className="max-h-10 max-w-[140px] object-contain mb-1" />}
      <div className="text-[10px] font-bold uppercase tracking-wide text-emerald-700">Acquired by {x.buyer_type || '—'}</div>
      <div className="font-semibold text-gray-800">{x.industry || '(no industry)'}</div>
      {x.location && <div className="text-xs text-gray-500">{x.location}</div>}
      <p className="text-xs text-gray-700 mt-1">{x.blurb}</p>
      <div className="text-[11px] text-gray-400 mt-1">Sector page: {x.sector || '—'} · DM #{x.vista_id}</div>
      {children}
    </div>
  );
  return (
    <div className="mb-6">
      {toReview.length > 0 && (<>
        <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-emerald-700">🪦 Tombstones to approve <span className="text-gray-400 font-normal">({toReview.length})</span></h2>
        <p className="text-xs text-gray-400 mb-2">Scott wrote these for sold listings. Approve and it goes on the website's Sold page, exactly as shown. Check: no name, nothing that identifies the business, nothing the owner wouldn't want public.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
          {toReview.map(x => <Card key={x.vista_id} x={x}>
            <div className="flex gap-2 justify-end mt-2">
              <button type="button" disabled={busy === x.vista_id} onClick={() => act(x, 'return')} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">↩ Send back</button>
              <button type="button" disabled={busy === x.vista_id} onClick={() => act(x, 'approve')} className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700">✓ Approve &amp; publish</button>
            </div>
          </Card>)}
        </div>
      </>)}
      {mine.length > 0 && (<>
        <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-red-700">🪦 Tombstones sent back to you <span className="text-gray-400 font-normal">({mine.length})</span></h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {mine.map(x => <Card key={x.vista_id} x={x}>
            <div className="text-xs text-red-700 font-semibold mt-2">↩ {x.reviewed_by || 'Zac'}: {x.review_note}</div>
            <a href="/sales-engine" target="_blank" rel="noopener" className="inline-block mt-1 text-xs underline text-indigo-700">Fix it: Sales Engine → 🌐 Website listings → 🪦 Sold → tombstone</a>
          </Card>)}
        </div>
      </>)}
    </div>
  );
};
// 🌐 WEBSITE LISTING SIGN-OFF (Mark 09-30: "Scott adds, Lead approves, then it's published"). The
// listing's Lead (DM listings.lead) sees exactly what will go public — headline, region, size, teaser —
// and approves it live or sends it back. The CIM-builder teaser is already owner-approved; this is the
// careful second look. Scott sees his sent-back ones.
const ListingApprovalSection = ({ myName, myEmail, isOwner }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  const call = async (path, opts = {}) => {
    const { data: { session } } = await supabaseClient.auth.getSession();
    const r = await fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) } });
    return r.json().catch(() => ({}));
  };
  const load = async () => { if (!supabaseClient) return; const j = await call('/api/website-listings/queue'); setItems(j.ok ? j.items : []); };
  useEffect(() => { load(); }, [myName]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (!items) return null;
  const toReview = items.filter(x => x.review_status === 'submitted' && (isOwner || (x.listing && x.listing.lead === myName)));
  const mine = items.filter(x => x.review_status === 'returned' && String(x.submitted_by || '').toLowerCase() === String(myEmail || '').toLowerCase());
  if (!toReview.length && !mine.length) return null;
  const act = async (x, action) => {
    let note = '';
    if (action === 'return') { note = window.prompt('What should Scott change?') || ''; if (!note.trim()) return; }
    setBusy(x.vista_id);
    const j = await call('/api/website-listings/review', { method: 'POST', body: JSON.stringify({ vista_id: x.vista_id, action, note }) });
    setBusy('');
    if (!j.ok) window.alert(j.error || 'Could not save');
    load();
  };
  const Card = ({ x, children }) => {
    const p = x.proposed || {};
    return (
      <div className="bg-white border border-gray-300 rounded-lg p-3 text-sm">
        <div className="text-[11px] text-gray-500">{x.listing ? x.listing.name : 'DM #' + x.vista_id} · {x.listing ? x.listing.status : ''} <span className="text-gray-400">(the name is never shown)</span></div>
        <div className="font-semibold text-gray-800 mt-1">{p.headline}</div>
        <div className="text-xs text-gray-500">{[p.region, p.size_band].filter(Boolean).join(' · ')}</div>
        {p.teaser ? <p className="text-xs text-gray-700 mt-1 whitespace-pre-line">{p.teaser}</p> : <p className="text-xs text-gray-400 mt-1">(no teaser)</p>}
        {x.published && x.headline !== p.headline && <div className="text-[11px] text-gray-400 mt-1">Live now: {x.headline}</div>}
        {children}
      </div>
    );
  };
  return (
    <div className="mb-6">
      {toReview.length > 0 && (<>
        <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-indigo-700">🌐 Website listings to approve <span className="text-gray-400 font-normal">({toReview.length})</span></h2>
        <p className="text-xs text-gray-400 mb-2">Scott prepared these for the new website. Approve and it goes live exactly as shown (signed-in buyers see the teaser). Check it matches what the owner approved — location shown or hidden as agreed.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
          {toReview.map(x => <Card key={x.vista_id} x={x}>
            <div className="flex gap-2 justify-end mt-2">
              <button type="button" disabled={busy === x.vista_id} onClick={() => act(x, 'return')} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">↩ Send back</button>
              <button type="button" disabled={busy === x.vista_id} onClick={() => act(x, 'approve')} className="text-xs px-2 py-1 rounded bg-indigo-600 text-white hover:bg-indigo-700">✓ Approve &amp; publish</button>
            </div>
          </Card>)}
        </div>
      </>)}
      {mine.length > 0 && (<>
        <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-red-700">🌐 Website listings sent back to you <span className="text-gray-400 font-normal">({mine.length})</span></h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {mine.map(x => <Card key={x.vista_id} x={x}>
            <div className="text-xs text-red-700 font-semibold mt-2">↩ {x.reviewed_by || 'Lead'}: {x.review_note}</div>
            <a href="/sales-engine" target="_blank" rel="noopener" className="inline-block mt-1 text-xs underline text-indigo-700">Fix it: Sales Engine → 🌐 Website listings</a>
          </Card>)}
        </div>
      </>)}
    </div>
  );
};
// 🔎 FIND A BUSINESS (Adam 09-29: "Honorbound doesn't have a card — a box where we can type the name of
// the business and/or the owner, and/or their email"). A card is a reminder that comes and goes; the
// record is always there. This opens the record's Log-outcome form from My Work, card or not.
// ONE SEARCH, BOTH RECORDS (Colleen/Mark 10-01: "everyone is a little confused that VT and SE are
// separate records"). SE is the business (every owner, every touch); VT is the valuation file, only while
// we're valuing or selling it. Each SE hit shows its linked VT file (📁 opens it) or says "SE only"; a VT
// file with no SE record still turns up, so nobody hunts in two places.
const FindBusinessBox = ({ onPick, onOpenVt }) => {
  const [q, setQ] = useState('');
  const [hits, setHits] = useState(null);
  const [busy, setBusy] = useState(false);
  const [loose, setLoose] = useState(false);
  const [listing, setListing] = useState(null); // a Vista # query's listing (status), for staff without Deal Manager
  const search = async () => {
    const s = q.trim();
    if (!supabaseClient || s.length < 2) return;
    setBusy(true);
    setListing(null);
    try {
      const cols = 'id, company_name, contact_name, emails, city, state, tier, status, assigned_to, vt_client_id';
      const like = '%' + s.replace(/[%,()]/g, ' ') + '%';
      const reqs = [supabaseClient.from('se_owners').select(cols).ilike('company_name', like).limit(15), supabaseClient.from('se_owners').select(cols).ilike('contact_name', like).limit(10)];
      if (s.includes('@')) reqs.push(supabaseClient.from('se_owners').select(cols).overlaps('emails', [...new Set([s, s.toLowerCase()])]).limit(5));
      // VISTA NUMBER (Konnie 11-03: a buyer called asking if "705306" was still available): a 6-digit number
      // finds the business through its VT client's vista_id.
      // "705306", "#705306", "Vista 705306", "705-306" all count (Konnie 11-03: "it doesn't work").
      const vm = s.match(/^(?:vista|vbg)?[\s#:-]*(\d{3})[-\s]?(\d{3})$/i);
      const vnum = vm ? vm[1] + vm[2] : null;
      const byNumber = vnum ? ((await supabaseClient.from('clients').select('id, company_name').eq('vista_id', vnum).limit(3)).data || []) : [];
      // "Is it still available?" — the listing's status, right here (Konnie 11-03: "Where is Deal Manager" — not every
      // role has DM).
      if (vnum) {
        try {
          const { data: { session } } = await supabaseClient.auth.getSession();
          const r = await fetch('/api/dm/listing-by-vista/' + vnum, { headers: { Authorization: 'Bearer ' + (session && session.access_token) } });
          const d = await r.json().catch(() => ({}));
          setListing(r.ok && d.ok ? (d.listing || { none: true, vnum }) : null);
        } catch (le) { /* status line is a convenience */ }
      }
      if (byNumber.length) reqs.push(supabaseClient.from('se_owners').select(cols).in('vt_client_id', byNumber.map(c => c.id)).limit(5));
      const res = await Promise.all(reqs);
      const seen = new Set(); let rows = [];
      res.forEach(r => (r.data || []).forEach(o => { if (!seen.has(o.id)) { seen.add(o.id); rows.push(o); } }));
      // TYPO FALLBACK (Colleen 10-01: "logic tecnology" found nothing — one missing letter). When the whole
      // phrase misses, match ANY word of 3+ letters and rank by how many words hit, so "logic" still finds
      // Logic Technology Consulting Group.
      const words = [...new Set(s.toLowerCase().split(/[^a-z0-9&']+/).filter(w => w.length >= 3))].slice(0, 4);
      let wordHits = null;
      if (!rows.length && words.length) {
        // Candidates: every word's first 3 letters together, plus each word's first 4 letters — worked records
        // first ("logic" alone is 652 businesses). Then rank by SPELLING CLOSENESS per word (edit distance),
        // so "tecnology" ≈ "technology": Logic Technology Consulting Group beats MB Technology.
        const worked = (q, n) => q.order('last_touch_at', { ascending: false, nullsFirst: false }).limit(n);
        let allQ = supabaseClient.from('se_owners').select(cols);
        words.forEach(w => { allQ = allQ.ilike('company_name', '%' + w.slice(0, 3) + '%'); });
        const wr = await Promise.all([worked(allQ, 50), ...words.map(w => worked(supabaseClient.from('se_owners').select(cols).ilike('company_name', '%' + w.slice(0, 4) + '%'), 30))]);
        wr.forEach(r => (r.data || []).forEach(o => { if (!seen.has(o.id)) { seen.add(o.id); rows.push(o); } }));
        const lev = (a, b) => { const m = a.length, n = b.length; if (!m || !n) return m || n; let p = Array.from({ length: n + 1 }, (_, j) => j); for (let i = 1; i <= m; i++) { const c = [i]; for (let j = 1; j <= n; j++) c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); p = c; } return p[n]; };
        wordHits = (o) => { const toks = String(o.company_name || '').toLowerCase().split(/[^a-z0-9&']+/).filter(Boolean); return words.reduce((sum, w) => sum + Math.max(0, ...toks.map(tk => 1 - lev(w, tk) / Math.max(w.length, tk.length))), 0); };
        rows = rows.filter(o => wordHits(o) >= 0.6);
      }
      setLoose(!!wordHits && rows.length > 0);
      // Company-name matches lead ("anura" also hits owners named Anuradha); then people we've dealt with.
      const sl = s.toLowerCase();
      const nameRank = (o) => { const c = String(o.company_name || '').toLowerCase(); return c === sl ? 0 : c.startsWith(sl) ? 1 : c.includes(sl) ? 2 : ((o.emails || []).some(e => String(e).toLowerCase() === sl) ? 0 : 3); };
      const rank = (o) => (wordHits ? -wordHits(o) * 100 : 0) + nameRank(o) * 10 + (o.tier === 'client' ? 0 : o.tier === 'responder' ? 1 : 2) + (o.status === 'active' ? 0 : 3);
      const top = rows.sort((a, b) => rank(a) - rank(b)).slice(0, 12);
      // VT side: the files linked to these SE records, plus VT files matching the name with no SE record.
      const vcols = 'id, client_id, name, workflow_stage, updated_at';
      // The company name lives on the VT client (valuations are named "2026-07-16 Valuation").
      const { data: vtClients } = await supabaseClient.from('clients').select('id, company_name').ilike('company_name', like).limit(10);
      const clientName = new Map((vtClients || []).map(c => [c.id, c.company_name]));
      byNumber.forEach(c => clientName.set(c.id, c.company_name));
      const cids = [...new Set([...top.map(o => o.vt_client_id).filter(Boolean), ...clientName.keys()])];
      const [linked, byName] = await Promise.all([
        cids.length ? supabaseClient.from('valuations').select(vcols).in('client_id', cids) : Promise.resolve({ data: [] }),
        Promise.resolve({ data: [] }),
      ]);
      // One file per client: the most recently touched version.
      const latest = new Map();
      [...(linked.data || []), ...(byName.data || [])].forEach(v => {
        const cur = latest.get(v.client_id);
        if (!cur || String(v.updated_at || '') > String(cur.updated_at || '')) latest.set(v.client_id, v);
      });
      const out = top.map(o => ({ ...o, _vt: o.vt_client_id ? (latest.get(o.vt_client_id) || null) : null }));
      const covered = new Set(top.map(o => o.vt_client_id).filter(Boolean));
      const vtOnly = [...latest.values()].filter(v => !covered.has(v.client_id)).slice(0, 5)
        .map(v => ({ id: 'vt-' + v.id, _vtOnly: true, _vt: v, company_name: clientName.get(v.client_id) || v.name }));
      setHits([...out, ...vtOnly]);
    } catch (e) { setHits([]); }
    setBusy(false);
  };
  return (
    <div className="mb-4 p-2 bg-white border border-gray-200 rounded-lg">
      <div className="flex gap-2 items-center">
        <span className="text-sm">🔎</span>
        <input value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') search(); }}
          placeholder="Find a business — company, owner name, email or Vista # — then log what happened (no card needed)"
          className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm" />
        <button type="button" onClick={search} disabled={busy} className="px-3 py-1 text-sm rounded bg-indigo-600 text-white disabled:opacity-50">{busy ? '…' : 'Find'}</button>
        {hits && <button type="button" onClick={() => { setHits(null); setQ(''); setListing(null); }} className="text-xs text-gray-400">clear</button>}
      </div>
      {hits && (hits.length === 0
        ? (listing && !listing.none
          ? <div className="text-xs px-2 py-1 mt-1 text-gray-800">🏷 Listing {listing.vista_id} · {listing.name}: <b className={listing.status === 'In Market' ? 'text-green-700' : 'text-amber-700'}>{listing.status}</b>{listing.status === 'In Market' ? ' (available)' : ''} <span className="text-gray-400">· no SE or VT record matched</span></div>
          : <div className="text-xs text-gray-500 mt-1">No business matches "{q}". Try part of the company name, the owner's email, or the 6-digit Vista #.</div>)
        : <div className="mt-1 divide-y">
            {loose && <div className="text-[11px] text-amber-700 px-2 py-1">No exact match for "{q}" — closest matches by word:</div>}
            {listing && (listing.none
              ? <div className="text-xs px-2 py-1 text-gray-500">🏷 No Deal Manager listing for Vista # {listing.vnum}: it hasn't gone to market.</div>
              : <div className="text-xs px-2 py-1 text-gray-800">🏷 Listing {listing.vista_id} · {listing.name}: <b className={listing.status === 'In Market' ? 'text-green-700' : 'text-amber-700'}>{listing.status}</b>{listing.status === 'In Market' ? ' (available)' : ''}</div>)}
            {hits.map(o => {
              const vtStage = o._vt ? ((WORKFLOW_STAGES[o._vt.workflow_stage] && WORKFLOW_STAGES[o._vt.workflow_stage].label) || String(o._vt.workflow_stage || '').replace(/_/g, ' ')) : '';
              const vtBtn = o._vt && onOpenVt && (
                <button type="button" onClick={() => onOpenVt(o._vt.id)} title="Open the valuation file in VT"
                  className="px-1.5 py-0.5 rounded border border-emerald-300 text-emerald-800 hover:bg-emerald-50 font-semibold whitespace-nowrap">📁 VT file · {vtStage}</button>
              );
              if (o._vtOnly) return (
                <div key={o.id} className="px-2 py-1 text-xs flex flex-wrap gap-x-2 items-center">
                  <b className="text-gray-800">{o.company_name}</b>
                  <span className="text-gray-400">VT file only — no Sales Engine record</span>
                  <span className="ml-auto">{vtBtn}</span>
                </div>
              );
              return (
                <div key={o.id} className="px-2 py-1 text-xs flex flex-wrap gap-x-2 items-center hover:bg-indigo-50">
                  <b className="text-gray-800">{o.company_name}</b>
                  <span className="text-gray-600">{o.contact_name || ''}</span>
                  <span className="text-gray-400">{[o.city, o.state].filter(Boolean).join(', ')}</span>
                  <span className="text-gray-400">{(o.emails || [])[0] || ''}</span>
                  <span className="text-gray-400">{o.tier}{o.status !== 'active' ? ' · ' + o.status : ''}{o.assigned_to ? ' · ' + o.assigned_to : ''}</span>
                  <span className="ml-auto flex gap-2 items-center">
                    {vtBtn || <span className="text-gray-400 italic" title="This business has no valuation file in VT — the Sales Engine record is the whole story.">SE only — no VT file</span>}
                    <button type="button" onClick={() => onPick(o.id)} className="text-indigo-700 font-semibold whitespace-nowrap">📞 Log outcome →</button>
                  </span>
                </div>
              );
            })}
          </div>)}
    </div>
  );
};
// 🤝 The buyside door INSIDE the owner's Log-outcome form (Adam 09-29, RAM → IT Partners). The old
// link opened the SE match modal, which only has Shared / Intro set / Passed / IOI — the full step
// list lived on the Buyside board, so "owner agreed to upload" was nowhere he looked. Now the form
// shows this owner's buyer deals with their current step and opens the SAME full picker in place;
// no deal yet → Tie to a buyer.
const BuysideDealStrip = ({ owner, onRecord, onTie, onFollowUp }) => {
  const [pairs, setPairs] = useState(null);
  const [openFor, setOpenFor] = useState(null);
  const [done, setDone] = useState('');
  // After a punt the NEXT MOVE drives status (Mark 09-29): a discovery meeting, a follow-up a few
  // months out, or another buyside client for the business.
  const [nextFor, setNextFor] = useState(null);
  const [fuDone, setFuDone] = useState('');
  const load = async () => {
    if (!supabaseClient || !owner || !owner.id) { setPairs([]); return; }
    try {
      const { data } = await supabaseClient.from('se_buyer_touches')
        .select('buyer_id, kind, at, buyer:se_buyers(id, company_name, contact_name)')
        .eq('owner_id', owner.id).order('at', { ascending: false }).limit(60);
      const byBuyer = new Map();
      (data || []).forEach(r => {
        if (!r.buyer_id || byBuyer.has(r.buyer_id)) return;
        const step = BUYSIDE_STEPS.find(s => s.kind === r.kind);
        if (step) byBuyer.set(r.buyer_id, { buyer: r.buyer || { id: r.buyer_id }, step, at: r.at });
      });
      setPairs([...byBuyer.values()].slice(0, 4));
    } catch (e) { setPairs([]); }
  };
  useEffect(() => { load(); }, [owner && owner.id]);
  if (pairs === null) return null;
  const name = (b) => (b && (b.company_name || b.contact_name)) || 'buyer';
  return (
    <div className="text-[11px] bg-violet-50 border border-violet-200 rounded px-2 py-1.5 mb-3">
      <div className="font-semibold text-violet-800 mb-0.5">🤝 Buyside deals for this business</div>
      {pairs.length === 0 ? (
        <div className="text-violet-700">Not tied to a buyside client yet.{' '}
          {onTie && <button type="button" onClick={() => onTie(owner)} className="font-semibold underline">🤝 Tie to a buyer</button>}
          {' '}— then every step (NDA, owner uploading, shared, intro, IOI…) is recorded on that deal.</div>
      ) : pairs.map(p => (
        <div key={p.buyer.id} className="py-0.5">
          <span className="text-gray-700"><b>{name(p.buyer)}</b> — now: {p.step.label}</span>{' '}
          <span className="text-gray-400">({String(p.at).slice(0, 10)})</span>{' '}
          {onRecord && openFor !== p.buyer.id && <button type="button" onClick={() => { setOpenFor(p.buyer.id); setDone(''); }} className="ml-1 px-1.5 py-0.5 rounded bg-violet-600 text-white">⟳ Record the next step</button>}
          {openFor === p.buyer.id && (
            <BuysideStepPicker initialKind={p.step.kind} onCancel={() => setOpenFor(null)} onSave={async (step) => {
              const ok = await onRecord({ owner, buyer: p.buyer, step });
              if (ok !== false) {
                setOpenFor(null); setDone(`✓ ${name(p.buyer)}: ${step.label}`); load();
                if (step.kind === 'passed' || step.kind === 'owner_withdrew') { setNextFor(name(p.buyer)); setFuDone(''); }
              }
            }} />
          )}
        </div>
      ))}
      {done && <div className="text-green-700 font-semibold mt-0.5">{done} — recorded on the deal.</div>}
      {nextFor && (
        <div className="mt-1 p-1.5 rounded border border-violet-300 bg-white">
          <div className="font-semibold text-violet-900">The {nextFor} project is over — what's the next move with {owner.company_name || 'the owner'}?</div>
          <div className="mt-0.5">📅 <b>Discovery meeting</b> — book it on your calendar with the Lead and the owner; it shows up here on its own.</div>
          <div className="mt-0.5">⏰ <b>Follow up later</b> —{' '}
            {[3, 6].map(mo => <button key={mo} type="button" disabled={!onFollowUp || !!fuDone} onClick={async () => { const ok = await onFollowUp(owner, mo, nextFor); if (ok !== false) setFuDone(`✓ Follow-up set for ${mo} months out`); }} className="mx-0.5 px-1.5 py-0.5 rounded border border-violet-300 text-violet-700 disabled:opacity-50">in {mo} months</button>)}
            {fuDone && <span className="text-green-700 font-semibold ml-1">{fuDone}</span>}
          </div>
          <div className="mt-0.5">🎯 <b>Another buyside client</b> —{' '}
            <a href={`/sales-engine?owner=${encodeURIComponent(owner.id)}&match=1`} target="_blank" rel="noopener" className="underline text-violet-700">see the buyers that match this business</a>, then 🤝 Tie to a buyer.</div>
        </div>
      )}
      <div className="text-gray-500 mt-0.5">Deal steps live here (and on Dashboard → 📋 Buyside deals). The choices below are only your follow-up with the owner.</div>
    </div>
  );
};
// ⟳ Update-step control for a live pair (board row / clock card) — the same
// picker, so every later move is "now it's X, waiting on Y by [date]".
const BuysideStepButton = ({ p, onStep, label = '⟳ Update step' }) => {
  const [open, setOpen] = useState(false);
  if (!onStep) return null;
  return (
    <span className="inline-block align-top">
      <button type="button" onClick={() => setOpen(o => !o)} className="text-xs px-2 py-1 rounded border border-violet-300 text-violet-700 hover:bg-violet-50">{label}</button>
      {open && <div className="text-left w-72"><BuysideStepPicker onCancel={() => setOpen(false)} onSave={async (step) => { const ok = await onStep(p, step); if (ok !== false) setOpen(false); }} /></div>}
    </span>
  );
};
const BuysideNewMatchSection = ({ open, prefillOwner, onOpen, onClose, searchOwners, searchBuyers, onCreate, onMarkBsa }) => {
  const [ownerQ, setOwnerQ] = useState(''); const [ownerHits, setOwnerHits] = useState([]); const [owner, setOwner] = useState(null);
  const [buyerQ, setBuyerQ] = useState(''); const [buyerHits, setBuyerHits] = useState([]); const [buyer, setBuyer] = useState(null);
  const [busy, setBusy] = useState(false); const [done, setDone] = useState(null);
  const ref = React.useRef(null);
  useEffect(() => { if (prefillOwner) { setOwner(prefillOwner); setOwnerQ(''); setOwnerHits([]); } }, [prefillOwner]);
  useEffect(() => { if (open && ref.current) { try { ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* ignore */ } } }, [open]);
  const findOwners = async () => { setOwnerHits(await searchOwners(ownerQ)); };
  const findBuyers = async () => { setBuyerHits(await searchBuyers(buyerQ)); };
  const reset = () => { setOwner(null); setOwnerQ(''); setOwnerHits([]); setBuyer(null); setBuyerQ(''); setBuyerHits([]); };
  if (!open) {
    return (
      <div className="mb-4">
        <button type="button" onClick={() => { setDone(null); onOpen(); }} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border-2 border-violet-600 text-violet-700 text-sm font-semibold hover:bg-violet-50"
          title="An owner wants a buyer — tie them to one of our buyside clients right here, set where the deal is, and the engine tracks it from there.">➕ New buyside match</button>
        {done && <span className="ml-3 text-xs text-emerald-700 font-medium">✓ {done} — it's on your Buyside board.</span>}
      </div>
    );
  }
  const row = 'w-full text-left px-2 py-1 rounded hover:bg-violet-100';
  return (
    <div ref={ref} className="mb-4 bg-white border-2 border-violet-300 rounded-lg p-3 text-xs">
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-bold text-violet-800">➕ New buyside match</div>
        <button type="button" onClick={() => { reset(); onClose(); }} className="text-gray-400 hover:text-gray-600">✕</button>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <div>
          <div className="text-gray-500 mb-1">1 · The business owner</div>
          {owner ? (
            <div className="flex items-center justify-between bg-gray-50 border rounded px-2 py-1"><span className="font-medium text-gray-800">{owner.company_name}{owner.contact_name ? <span className="text-gray-400 font-normal"> · {owner.contact_name}</span> : ''}</span><button type="button" className="text-violet-700 underline" onClick={() => setOwner(null)}>change</button></div>
          ) : (
            <div>
              <div className="flex gap-1"><input value={ownerQ} onChange={e => setOwnerQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') findOwners(); }} placeholder="Company name…" className="flex-1 border border-gray-300 rounded px-2 py-1" /><button type="button" onClick={findOwners} className="px-2 py-1 rounded border border-gray-300 hover:bg-gray-50">Find</button></div>
              {ownerHits.length > 0 && <div className="mt-1 border rounded bg-white max-h-48 overflow-auto">{ownerHits.map(h => <button key={h.id} type="button" className={row} onClick={() => { setOwner(h); setOwnerHits([]); }}>{h.company_name}{h.contact_name ? ` · ${h.contact_name}` : ''}{h.city || h.state ? <span className="text-gray-400"> · {[h.city, h.state].filter(Boolean).join(', ')}</span> : ''}{h.tier || h.assigned_to ? <span className={h.tier === 'cold' ? 'text-gray-400' : 'text-violet-700'}> · {[h.tier, h.assigned_to].filter(Boolean).join(' · ')}</span> : ''}</button>)}</div>}
            </div>
          )}
        </div>
        <div>
          <div className="text-gray-500 mb-1">2 · Our buyside client</div>
          {buyer ? (
            <div className="flex items-center justify-between gap-2 bg-gray-50 border rounded px-2 py-1"><span className="font-medium text-gray-800">{buyer.company_name || buyer.contact_name}{buyer.bsa_signed ? <span className="text-emerald-600 font-normal"> · BSA ✓</span> : <span className="text-amber-700 font-normal"> · no BSA — intro locked until signed</span>}</span>
              <span className="flex items-center gap-2 whitespace-nowrap">
                {!buyer.bsa_signed && onMarkBsa && <button type="button" className="text-emerald-700 underline" title="They've signed the buyside agreement — record it (stamps the date, clears the 🔒 intro gate)." onClick={async () => { const ok = await onMarkBsa(buyer); if (ok) setBuyer({ ...buyer, bsa_signed: true }); }}>✒ Mark BSA signed</button>}
                <button type="button" className="text-violet-700 underline" onClick={() => setBuyer(null)}>change</button>
              </span></div>
          ) : (
            <div>
              <div className="flex gap-1"><input value={buyerQ} onChange={e => setBuyerQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') findBuyers(); }} placeholder="Buyer company or contact…" className="flex-1 border border-gray-300 rounded px-2 py-1" /><button type="button" onClick={findBuyers} className="px-2 py-1 rounded border border-gray-300 hover:bg-gray-50">Find</button></div>
              {buyerHits.length > 0 && <div className="mt-1 border rounded bg-white max-h-40 overflow-auto">{buyerHits.map(h => <button key={h.id} type="button" className={row} onClick={() => { setBuyer(h); setBuyerHits([]); }}>{h.company_name || h.contact_name}{h.company_name && h.contact_name ? ` · ${h.contact_name}` : ''}{h.buyside_status ? <span className="text-gray-400"> · {h.buyside_status}</span> : ''}{h.bsa_signed ? <span className="text-emerald-600"> · BSA ✓</span> : <span className="text-amber-700"> · no BSA</span>}</button>)}</div>}
            </div>
          )}
        </div>
      </div>
      {owner && buyer && (
        <div>
          <div className="text-gray-500 mt-2">3 · Where is it right now?</div>
          <BuysideStepPicker initialKind={(owner && owner._step) || 'matched'} onSave={async (step) => {
            setBusy(true);
            const ok = await onCreate({ owner, buyer, step });
            setBusy(false);
            if (ok) { const msg = `${owner.company_name} ↔ ${buyer.company_name || buyer.contact_name}`; reset(); setDone(msg); onClose(); }
          }} />
          {busy && <div className="text-gray-400 mt-1">saving…</div>}
        </div>
      )}
    </div>
  );
};
// ── ⏰ NEW REMINDER — the one door for a reminder with no card (Mark 09-17,
// Adam: "he doesn't have a card for these situations"). A phone call, a
// promised date, a cold outreach worth chasing — anything the email cards
// can't see. Type the owner, pick the date + type, say why; it comes back to
// the plate of whoever SET it (creator routing — same law as the went-quiet
// card and the scheduling chains), on that date. Reuses seRemindMe, so it
// retires stacked Zoho chains exactly like the card ⏰ does.
const SeNewReminderSection = ({ open, onOpen, onClose, searchOwners, onCreate }) => {
  const plusDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
  const [ownerQ, setOwnerQ] = useState(''); const [hits, setHits] = useState([]); const [owner, setOwner] = useState(null);
  const [due, setDue] = useState(plusDays(7));
  const [type, setType] = useState('followup');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false); const [done, setDone] = useState(null);
  const ref = React.useRef(null);
  useEffect(() => { if (open && ref.current) { try { ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* ignore */ } } }, [open]);
  const find = async () => { setHits(await searchOwners(ownerQ)); };
  const reset = () => { setOwner(null); setOwnerQ(''); setHits([]); setDue(plusDays(7)); setType('followup'); setNote(''); };
  if (!open) {
    return (
      <div className="mb-4">
        <button type="button" onClick={() => { setDone(null); onOpen(); }} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border-2 border-amber-500 text-amber-800 text-sm font-semibold hover:bg-amber-50"
          title="A phone call, a promised date, a cold outreach worth chasing — anything the email cards can't see. Set it here; it comes back to YOUR plate on that date.">⏰ New reminder</button>
        {done && <span className="ml-3 text-xs text-emerald-700 font-medium">✓ {done} — it'll come back to your plate on that date.</span>}
      </div>
    );
  }
  const row = 'w-full text-left px-2 py-1 rounded hover:bg-amber-100';
  return (
    <div ref={ref} className="mb-4 bg-white border-2 border-amber-300 rounded-lg p-3 text-xs">
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-bold text-amber-800">⏰ New reminder</div>
        <button type="button" onClick={() => { reset(); onClose(); }} className="text-gray-400 hover:text-gray-600">✕</button>
      </div>
      <div className="text-gray-500 mb-1">1 · The business owner</div>
      {owner ? (
        <div className="flex items-center justify-between bg-gray-50 border rounded px-2 py-1 mb-2"><span className="font-medium text-gray-800">{owner.company_name}{owner.contact_name ? <span className="text-gray-400 font-normal"> · {owner.contact_name}</span> : ''}</span><button type="button" className="text-amber-800 underline" onClick={() => setOwner(null)}>change</button></div>
      ) : (
        <div className="mb-2">
          <div className="flex gap-1"><input value={ownerQ} onChange={e => setOwnerQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') find(); }} placeholder="Company name…" className="flex-1 border border-gray-300 rounded px-2 py-1" /><button type="button" onClick={find} className="px-2 py-1 rounded border border-gray-300 hover:bg-gray-50">Find</button></div>
          {hits.length > 0 && <div className="mt-1 border rounded bg-white max-h-48 overflow-auto">{hits.map(h => <button key={h.id} type="button" className={row} onClick={() => { setOwner(h); setHits([]); }}>{h.company_name}{h.contact_name ? ` · ${h.contact_name}` : ''}{h.city || h.state ? <span className="text-gray-400"> · {[h.city, h.state].filter(Boolean).join(', ')}</span> : ''}{h.tier || h.assigned_to ? <span className={h.tier === 'cold' ? 'text-gray-400' : 'text-amber-800'}> · {[h.tier, h.assigned_to].filter(Boolean).join(' · ')}</span> : ''}</button>)}</div>}
        </div>
      )}
      {owner && (
        <div className="space-y-2">
          <div className="flex flex-wrap gap-2 items-center">
            <span className="text-gray-500">2 · When</span>
            <input type="date" value={due} onChange={e => setDue(e.target.value)} className="border border-gray-300 rounded px-2 py-1" />
            {[[7, '+1w'], [14, '+2w'], [30, '+1mo'], [90, '+3mo']].map(([n, l]) => <button key={n} type="button" className="text-[10px] text-amber-800 underline" onClick={() => setDue(plusDays(n))}>{l}</button>)}
            <span className="text-gray-500 ml-2">Type</span>
            <select value={type} onChange={e => setType(e.target.value)} className="border border-gray-300 rounded px-2 py-1 bg-white">
              <option value="followup">Follow-up — move it forward</option>
              <option value="checkin">Check-in — touch base</option>
              <option value="waiting">Waiting on them — ball's in their court</option>
            </select>
          </div>
          <div>
            <div className="text-gray-500 mb-0.5">3 · Why this date — what happens then (required)</div>
            <input value={note} onChange={e => setNote(e.target.value)} placeholder="e.g. promised to call back after their board meeting" className="w-full border border-gray-300 rounded px-2 py-1" />
          </div>
          <div className="flex justify-end">
            <button type="button" disabled={busy || !note.trim() || !due}
              onClick={async () => { setBusy(true); const ok = await onCreate({ owner, due, type, note: note.trim() }); setBusy(false); if (ok !== false) { const msg = `${owner.company_name} · ${due}`; reset(); setDone(msg); onClose(); } }}
              className={`px-3 py-1 rounded font-semibold ${busy || !note.trim() ? 'bg-gray-200 text-gray-400' : 'bg-amber-600 text-white hover:bg-amber-700'}`}>Set reminder</button>
          </div>
        </div>
      )}
    </div>
  );
};
const BuysideBoardSection = ({ rows, showHolder, onAct, onStep }) => {
  if (!rows || rows.length === 0) return null;
  const fd = (iso) => iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '—';
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-violet-700">
        📋 Buyside deals — what&rsquo;s happening <span className="text-gray-400 font-normal">({rows.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-2">Every live buyer × business pair at a glance — stage, last movement, next meeting. Nothing here asks for action: the clock cards and the 🤝 window handle that.</p>
      <div className="bg-white border rounded-lg overflow-x-auto">
        <table className="w-full text-xs">
          <thead><tr className="text-left text-gray-400 uppercase text-[10px]">
            <th className="px-3 py-2">Buyer → Business</th>
            <th className="px-3 py-2">Stage</th>
            <th className="px-3 py-2">Last movement</th>
            <th className="px-3 py-2">Next meeting</th>
            {showHolder && <th className="px-3 py-2">Holder</th>}
            <th className="px-3 py-2"></th>
          </tr></thead>
          <tbody>
            {rows.map((r, i) => {
              const b = r.p.buyer || {}; const o = r.p.owner || {};
              return (
                <tr key={i} className="border-t align-top">
                  <td className="px-3 py-2 font-medium text-gray-800 whitespace-nowrap">
                    {b.company_name || b.contact_name || '(buyer)'} <span className="text-gray-400">→</span> {o.company_name || '(business)'}
                    {b.willing_buyside_fees && !b.bsa_signed ? <span className="ml-1 text-[10px] font-bold bg-amber-100 text-amber-800 rounded px-1 py-0.5" title="No signed BSA on file — the intro button is locked until it is recorded.">🔒</span> : null}
                    {r.credit ? (
                      <div className="text-[10px] font-normal text-violet-700" title={`Buyside credit goes to whoever made the introduction to our client — ${r.credit.name}: ${BUYSIDE_CREDIT_WHY[r.credit.source] || r.credit.source}${r.credit.reason ? ' — ' + r.credit.reason : ''}`}>
                        🤝 Credit: <b>{r.credit.name}</b>
                        <span className="text-gray-400"> · {r.credit.source === 'override' ? 'set by hand' : r.credit.source === 'intro' ? 'made the intro' : 'no intro logged yet'}</span>
                        {onAct ? <button type="button" className="ml-1 text-gray-400 hover:text-violet-700 underline" title="Wrong person? Name who actually made the introduction, with a reason — it travels with the record." onClick={() => onAct({ p: r.p }, 'credit')}>change</button> : null}
                      </div>
                    ) : null}
                    {r.buyerStats && (r.buyerStats.medianH != null || r.buyerStats.passPct != null) ? (
                      <div className="text-[10px] text-gray-400 font-normal" title="This buyer's track record across every pair on file — use it to pick honest promise dates, and to spot a buyer who's burning our credibility.">
                        {r.buyerStats.medianH != null ? `responds ~${r.buyerStats.medianH < 48 ? Math.max(1, Math.round(r.buyerStats.medianH)) + 'h' : Math.round(r.buyerStats.medianH / 24) + 'd'}` : ''}
                        {r.buyerStats.medianH != null && r.buyerStats.passPct != null ? ' · ' : ''}
                        {r.buyerStats.passPct != null ? `passes ${r.buyerStats.passPct}%` : ''}
                      </div>
                    ) : null}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    <span className={`text-[10px] font-bold uppercase rounded px-1.5 py-0.5 ${r.stage[1]}`}>{r.stage[0]}</span>
                    <span className="ml-1 text-gray-400">{fd(r.stageAt)}</span>
                    {/* Post-LOI exits (Mark 09-11): LOI is the one stage with
                        no other home for its ending — the two verbs live on
                        the row. Every other stage's actions stay on cards. */}
                    {r.stage[0] === '🏁 LOI' && onAct ? (
                      <span className="ml-2 inline-flex gap-1">
                        <button type="button" className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-600 text-white hover:bg-emerald-700 font-semibold"
                          title="The deal closed — records the sale with the final commission and retires the pair." onClick={() => onAct({ p: r.p }, 'closed_won')}>🎉 Closed</button>
                        <button type="button" className="text-[10px] px-1.5 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50"
                          title="The LOI fell through — records why; the pair leaves the board." onClick={() => onAct({ p: r.p }, 'fell_through')}>✗ Fell through</button>
                      </span>
                    ) : null}
                  </td>
                  <td className="px-3 py-2 text-gray-600 max-w-[280px] truncate" title={r.lastSubject}>
                    {fd(r.lastAt)}
                    {r.quietDays >= 7 ? <span className={`ml-1 font-semibold ${r.quietDays >= 14 ? 'text-red-600' : 'text-amber-600'}`}>· quiet {r.quietDays}d</span> : null}
                    {r.ownerPromise ? <span className={`ml-1 font-semibold ${r.ownerPromise <= new Date().toISOString().slice(0, 10) ? 'text-red-600' : 'text-gray-500'}`} title="We told the owner we'd have an answer by this date — the reach-back card fires that day and clears only when they're told.">· 🤙 owner promised {fd(r.ownerPromise + 'T00:00:00')}</span> : null}
                    <span className="text-gray-400"> — {r.lastSubject}</span>
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    {r.nextMeeting
                      ? <span className="text-gray-700" title={r.nextMeeting.summary || ''}>📅 {new Date(r.nextMeeting.at).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</span>
                      : <span className="text-gray-300">—</span>}
                  </td>
                  {showHolder && <td className="px-3 py-2 text-gray-500">{r.holder}</td>}
                  <td className="px-3 py-2 whitespace-nowrap text-right">
                    <BuysideStepButton p={r.p} onStep={onStep} label="⟳ step" />
                    {o.id && <a className="ml-2 text-violet-700 underline" href={`/sales-engine?owner=${encodeURIComponent(o.id)}&match=1`} target="_blank" rel="noopener" title="Open this business's 🤝 match window in the SE.">🤝 open</a>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const BuysideFollowSection = ({ items, onAct, onStep, showHolder, actor }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-violet-700">
        ⏰ Buyside — a clock ran out <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">Silence is information: a shared business with no buyer feedback becomes an assumed pass the owner should hear about; an IOI quiet for a week needs a push or a verdict. A red 🤙 card is the owner-promise date arriving — the reach-back happens that day, whatever the buyer said (or didn't). An amber 📄 card is a live match waiting on the owner for documents — chase the owner, keyed to the date they promised.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((c, i) => {
          const b = c.p.buyer || {}; const o = c.p.owner || {};
          return (
            <div key={i} className={`bg-white rounded-lg p-3 ${c.type === 'owner_promise' || c.type === 'punt_check' ? 'border-2 border-red-500' : `border ${c.type === 'sla' ? 'border-amber-300' : ['awaiting_docs', 'nda_wait', 'coord_wait'].includes(c.type) ? 'border-amber-400' : 'border-violet-300'}`}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold text-gray-800 text-sm truncate">{o.company_name || '(business)'} <span className="text-gray-400 font-normal">↔</span> {b.company_name || b.contact_name || '(buyer)'}
                    {b.buyer_type && <span className="ml-1.5 text-[10px] font-bold uppercase bg-gray-100 text-gray-600 rounded px-1.5 py-0.5">{b.buyer_type}</span>}
                    {b.willing_buyside_fees && !b.bsa_signed && <span className="ml-1 text-[10px] font-bold bg-amber-100 text-amber-800 rounded px-1.5 py-0.5" title="Will pay buyside fees, but needs to sign an agreement before we introduce them to an owner.">🔒 BSA needed</span>}
                  </div>
                  <div className="text-xs text-gray-600 mt-0.5">
                    {c.type === 'punt_check'
                      ? <span className="text-red-700 font-semibold">{c.meeting.meeting_type === 'valuation_meeting' ? 'Valuation meeting' : 'Discovery meeting'} booked {new Date(c.meeting.starts_at).toLocaleDateString()} — but this buyside project is still open. We don't value a business with an open buyside project: which side punted?</span>
                      : c.type === 'owner_promise'
                      ? <span className="text-red-700 font-semibold">We promised the owner an answer by {new Date(c.promise + 'T00:00:00').toLocaleDateString()}{c.overdueDays > 0 ? ` — ${c.overdueDays}d past our word` : ' — that’s TODAY'}. Call or email them now, whatever the buyer news is.</span>
                      : c.type === 'awaiting_docs'
                      ? <span className="text-amber-800 font-semibold">Buyer's reviewing — waiting on the owner for documents{c.promisedBy ? `. They promised them by ${new Date(c.promisedBy + 'T00:00:00').toLocaleDateString()}${c.overdueDays > 0 ? ` — ${c.overdueDays}d overdue` : ' — that’s TODAY'}` : ` (no date promised — ${c.overdueDays}d since)`}. Chase the owner for the docs.</span>
                      : c.type === 'nda_wait'
                      ? <span className="text-amber-800 font-semibold">NDA sent — waiting on the buyer's signature{c.promisedBy ? ` (expected by ${new Date(c.promisedBy + 'T00:00:00').toLocaleDateString()}${c.overdueDays > 0 ? ` — ${c.overdueDays}d overdue` : ' — that’s TODAY'})` : ` — ${c.overdueDays}d and counting`}. Chase the buyer for the signed NDA.</span>
                      : c.type === 'coord_wait'
                      ? <span className="text-amber-800 font-semibold">Coordinating the buyer–seller meeting{c.waitingOn ? ` — waiting on ${c.waitingOn}` : ''}{c.promisedBy ? ` (by ${new Date(c.promisedBy + 'T00:00:00').toLocaleDateString()}${c.overdueDays > 0 ? ` — ${c.overdueDays}d overdue` : ' — TODAY'})` : ''}. Nudge the scheduling along.</span>
                      : c.type === 'matched_next'
                      ? <span className="text-violet-800 font-semibold">Tied to this buyer, nothing sent yet{c.waitingOn ? ` — next: ${c.waitingOn}` : ''}. What's the next step? Set it so the engine can chase it.</span>
                      : c.type === 'sla' ? `Shared ${c.ageH}h ago — no buyer feedback${c.promise ? ` (owner promised an answer by ${new Date(c.promise + 'T00:00:00').toLocaleDateString()} — chase the buyer NOW so we keep our word)` : ' (24–48h SLA)'}` : `IOI logged — quiet ${c.ageDays} days`}
                    {showHolder && c.holder ? <span className="text-gray-400"> · → {c.holder}</span> : ''}
                  </div>
                </div>
                <span className={`text-[10px] font-bold uppercase tracking-wide rounded px-1.5 py-0.5 whitespace-nowrap ${c.type === 'owner_promise' || c.type === 'punt_check' ? 'bg-red-600 text-white' : c.type === 'sla' || c.type === 'awaiting_docs' ? 'bg-amber-100 text-amber-800' : 'bg-violet-100 text-violet-800'}`}>
                  {c.type === 'punt_check' ? '🛑 who punted?' : c.type === 'owner_promise' ? '🤙 promise due' : c.type === 'awaiting_docs' ? '📄 docs due' : c.type === 'nda_wait' ? '📝 NDA due' : c.type === 'coord_wait' ? '📅 schedule' : c.type === 'matched_next' ? '➡ next step' : c.type === 'sla' ? '🕰 silence' : '📄 post-IOI'}
                </span>
              </div>
              <div className="flex flex-wrap justify-end gap-2 mt-2">
                {o.id && <CardToolbar className="mr-auto" ownerId={o.id} companyName={o.company_name || 'Business'} actor={actor} />}
                {c.type === 'punt_check' ? (
                  <React.Fragment>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="The buyside client is out — logs the pass on the pair." onClick={() => onStep(c.p, { kind: 'passed' })}>✗ Buyer passed</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="The owner chose not to go ahead with this buyer (e.g. wants their own valuation) — not a buyer pass." onClick={() => onStep(c.p, { kind: 'owner_withdrew' })}>↩ Owner backed out</button>
                  </React.Fragment>
                ) : c.type === 'owner_promise' ? (
                  <button type="button" className="text-xs px-2 py-1 rounded bg-red-600 text-white hover:bg-red-700"
                    title="Logs that the owner was told where things stand — the only thing that clears this card. A pass still counts; silence to the owner doesn't."
                    onClick={() => onAct(c, 'owner_told')}>✓ Owner told — promise kept</button>
                ) : c.type === 'awaiting_docs' ? (
                  <React.Fragment>
                    <button type="button" className="text-xs px-2 py-1 rounded bg-violet-600 text-white hover:bg-violet-700" title="Docs arrived and the buyer gave an IOI — advance the pair." onClick={() => onAct(c, 'ioi')}>📄 IOI received</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="You chased the owner again — log it and set the next promised date. The clock re-keys to it." onClick={() => onAct(c, 'awaiting_docs')}>🕰 Chased — new date</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="The buyer walked away — logs the pass." onClick={() => onAct(c, 'pass')}>✗ Buyer passed</button>
                  </React.Fragment>
                ) : ['nda_wait', 'coord_wait', 'matched_next'].includes(c.type) ? (
                  <React.Fragment>
                    <BuysideStepButton p={c.p} onStep={onStep} />
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="The buyer walked away — logs the pass." onClick={() => onAct(c, 'pass')}>✗ Buyer passed</button>
                  </React.Fragment>
                ) : c.type === 'sla' ? (
                  <React.Fragment>
                    <button type="button" className="text-xs px-2 py-1 rounded bg-amber-600 text-white hover:bg-amber-700" title="Silence = assumed pass (the SLA). Logs the pass — and tell the owner their business was seen." onClick={() => onAct(c, 'pass')}>✗ Assume pass — tell the owner</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" onClick={() => onAct(c, 'responded')}>✓ They responded</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" onClick={() => onAct(c, 'intro')}>🤝 Intro set</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-amber-400 text-amber-800 hover:bg-amber-50" title="The buyer's in and reviewing — the wait is on the OWNER for documents, not the buyer. Moves this off the buyer-silence clock and onto a doc-chase keyed to the owner's promised date." onClick={() => onAct(c, 'awaiting_docs')}>📋 Buyer reviewing — awaiting docs</button>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" title="Logs a check-in note — the clock resets for next week." onClick={() => onAct(c, 'moving')}>✓ Still moving</button>
                    <button type="button" className="text-xs px-2 py-1 rounded bg-violet-600 text-white hover:bg-violet-700" onClick={() => onAct(c, 'loi')}>🏁 LOI</button>
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50" onClick={() => onAct(c, 'dead')}>✗ It died</button>
                  </React.Fragment>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// 📲 An owner handed to you (Mark 10-28): the AM's side of Scott's "owner asked for a call / text / email" card.
// One plain line on what the owner asked for, in their words, and one click per way of reaching them.
const AmHandoffSection = ({ items, onDone, actor }) => {
  if (!items || items.length === 0) return null;
  const daysSince = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-orange-700">
        📲 Owners handed to you: reach them the way they asked <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-emerald-700 font-semibold mb-3">💰 These owners raised their hand. Each is a new deal waiting on you: reach them today, before they cool off or call someone else.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(c => {
          const days = c.created_at ? daysSince(c.created_at) : 0;
          return (
            <div key={c.id} className={`bg-white rounded-lg p-3 border ${days >= 2 ? 'border-2 border-red-500' : 'border-orange-300'}`}>
              <div className="text-sm font-medium text-gray-800">
                {(c.owner && c.owner.company_name) || 'Business'}{c.owner && c.owner.contact_name ? ` — ${c.owner.contact_name}` : ''}
              </div>
              <div className="text-xs text-gray-600 mt-0.5">
                {c.created_by || 'Scott'} talked to them {c.created_at ? new Date(c.created_at).toLocaleDateString() : c.due}
                {days >= 1 ? <span className="text-red-600 font-semibold"> · waiting on you {days} day{days === 1 ? '' : 's'}</span> : null}
              </div>
              {c.request && <div className="text-sm text-gray-800 mt-1">The owner asked: <span className="font-semibold">“{c.request}”</span></div>}
              {c.amEmail && <div className="text-xs text-gray-600 mt-1">✉ You emailed {new Date(c.amEmail.sent_at).toLocaleDateString()}{c.ownerReply ? `; they replied ${new Date(c.ownerReply.sent_at).toLocaleDateString()}` : '; no reply yet'}.</div>}
              {c.owner && c.owner.id && <CardToolbar className="mt-2" ownerId={c.owner.id} companyName={c.owner.company_name || 'Business'} actor={actor} />}
              {onDone && (
                <div className="flex flex-wrap gap-2 mt-2">
                  <button type="button" onClick={() => onDone(c, 'called')} className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700">✓ I called</button>
                  <button type="button" onClick={() => onDone(c, 'texted')} className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700">✓ I texted</button>
                  <button type="button" onClick={() => onDone(c, 'emailed')} className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700">✓ I emailed</button>
                </div>
              )}
              <div className="text-[11px] text-gray-500 mt-1.5 leading-snug">
                <b className="text-gray-600">Where this card goes:</b> any ✓ → it's logged on the business, this card leaves, and {c.created_by || 'Scott'}'s reminder clears too. Then 📝 on the toolbar: write what they said and set the next step, so the deal keeps moving. Not reached yet? Leave the card; it stays until you do.
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// The invite check: a logged first-time meeting with no calendar event to
// back it. Cards the booker; clears itself when the hourly sync sees the
// invite — informational by design (the action happens in Google Calendar).
const InviteCheckSection = ({ items, showHolder, actor, onLiveCall, onCallbackChase }) => {
  if (!items || items.length === 0) return null;
  const callbacks = items.filter(c => c.callback);
  items = items.filter(c => !c.callback);
  const daysSince = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));
  return (
    <>
    {callbacks.length > 0 && (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-orange-700">
        📞 Owner asked to be contacted (call, text or email) — waiting on the AM <span className="text-gray-400 font-normal">({callbacks.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">Stays yours until the AM logs it. The AM has the same owner on their own My Work with ✓ I called / texted / emailed, and an email the owner asked for counts by itself. Check with the AM: done → remind them to click it · not yet → nudge them · owner not answering → you chase the owner.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {callbacks.map(c => (
          <div key={c.id} className="bg-white border border-orange-300 rounded-lg p-3">
            <div className="text-sm font-medium text-gray-800">
              {(c.owner && c.owner.company_name) || 'Business'}{c.owner && c.owner.contact_name ? ` — ${c.owner.contact_name}` : ''}
            </div>
            <div className="text-xs text-gray-600 mt-0.5">
              Asked {c.created_at ? new Date(c.created_at).toLocaleDateString() : c.due}{c.am ? ` · ${c.am} to reach them` : ''} · <span className="text-red-600 font-semibold">not logged yet{c.created_at ? ` (${daysSince(c.created_at)} days)` : ''}</span>
              {showHolder && c.holder ? <span className="text-gray-400"> · → {c.holder}</span> : ''}
            </div>
            {c.request && <div className="text-xs text-gray-700 mt-1">The owner asked: <span className="italic">“{c.request}”</span></div>}
            {c.amEmail && <div className="text-xs text-gray-700 mt-1">✉ {c.am || 'AM'} emailed {new Date(c.amEmail.sent_at).toLocaleDateString()}: <span className="italic">"{String(c.amEmail.snippet || '').slice(0, 110)}"</span></div>}
            {c.amEmail && (c.ownerReply
              ? <div className="text-xs text-gray-700 mt-0.5">↩ Owner replied {new Date(c.ownerReply.sent_at).toLocaleDateString()}: <span className="italic">"{String(c.ownerReply.snippet || '').slice(0, 110)}"</span></div>
              : <div className="text-xs text-amber-700 mt-0.5">No reply from the owner yet — likely yours to chase. Remind {c.am || 'the AM'} to log the call.</div>)}
            {c.lastChase && <div className="text-xs text-gray-500 mt-1">Last: {String(c.lastChase.subject || '').replace(/^📞 Callback chase — /, '')} · {new Date(c.lastChase.at).toLocaleDateString()}</div>}
            {c.owner && c.owner.id && <CardToolbar className="mt-2" ownerId={c.owner.id} companyName={c.owner.company_name || 'Business'} actor={actor} />}
            {onCallbackChase && (
              <div className="flex flex-wrap gap-2 mt-2">
                <button type="button" onClick={() => onCallbackChase(c, 'am')} title={`Logged on the owner. The card stays until ${c.am || 'the AM'} logs the call.`}
                  className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">Nudged {c.am || 'the AM'}</button>
                <button type="button" onClick={() => onCallbackChase(c, 'owner')} title="The AM tried; the owner isn't answering. Logged on the owner — you're chasing the owner. The card stays until the call is logged."
                  className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">Owner not answering — I'm chasing</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    )}
    {items.length > 0 && (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-orange-700">
        📅 Meeting logged — no calendar invite found <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">A meeting was logged on the response desk, but the calendar has no matching event for that owner. Send the real Google invite (this card clears itself within the hour once the sync sees it) — or fix the date if it changed.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(c => (
          <div key={c.id} className={`bg-white border rounded-lg p-3 ${c.overdue ? 'border-red-300' : 'border-orange-300'}`}>
            <div className="text-sm font-medium text-gray-800">
              {(c.owner && c.owner.company_name) || 'Business'}{c.owner && c.owner.contact_name ? ` — ${c.owner.contact_name}` : ''}
            </div>
            <div className="text-xs text-gray-600 mt-0.5">
              Meeting {c.due}{c.am ? ` with ${c.am}` : ''} · logged by {c.created_by || '—'}
              {c.overdue && <span className="text-red-600 font-semibold"> · date passed, still no invite</span>}
              {showHolder && c.holder ? <span className="text-gray-400"> · → {c.holder}</span> : ''}
            </div>
            {c.owner && c.owner.id && <CardToolbar className="mt-2" ownerId={c.owner.id} companyName={c.owner.company_name || 'Business'} actor={actor} />}
            {onLiveCall && (
              <button type="button" onClick={() => onLiveCall(c)} title="It was a phone call (transferred live / they called in), so there's no calendar invite to send. Clears this card."
                className="mt-2 text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">📞 Live call — no invite needed</button>
            )}
          </div>
        ))}
      </div>
    </div>
    )}
    </>
  );
};

// "No notes — did this meeting happen?" (ROADMAP #12; grace + no-show
// semantics settled 2026-08-06). A booked meeting whose ET day has passed
// with no Fireflies match, no logged touch, and no stage move cards the
// HOLDER's plate the next morning. Held-confirmations feed the committee
// meeting metrics so booked-but-ghosted meetings never inflate the counts.
// 📅 Today's meetings (Adam 08-31) — the day's schedule as cards, in
// Adam's own card format (company · contact · one line · ONE button).
// The button opens the standard outcome modal: note + pick, logged while
// it's fresh, and tomorrow's did-it-happen card never fires.
// ⚖ Partial review-decision cards (Mark 09-03, Colleen's NTi find): the
// Lead makes the quick-look-or-skip call with one click, right on the card.
const PartialDecisionSection = ({ items, onDecide, showHolder }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-blue-700">
        ⚖ Partials needing your call <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">These partial valuations have their documents in and no review decision set — and blank quietly defaults to a Colleen quick-look, putting them on her plate without anyone deciding. Make the routing call; the card clears itself. (Still collecting documents? That's the collection cadence's job, not this card.)</p>
      <div className="space-y-2">
        {items.map(p => (
          <div key={p.id} className="bg-white border border-blue-200 rounded-lg p-3 flex items-center gap-2 flex-wrap">
            <div className="min-w-0">
              <div className="font-semibold text-gray-800 text-sm">{p.company_name || p.name}
                <span className="ml-2 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-blue-100 text-blue-700">partial</span>
              </div>
              <div className="text-xs text-gray-500">{p.workflow_stage ? String(p.workflow_stage).replace(/_/g, ' ') : ''}{showHolder && p.lead ? ` · Lead: ${p.lead}` : ''}</div>
            </div>
            <span className="ml-auto flex items-center gap-1.5">
              <button type="button" onClick={() => onDecide(p, 'quick_look')}
                className="text-xs px-2.5 py-1 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700"
                title="Colleen glances at the numbers, then you set the valuation meeting.">👀 Quick-look</button>
              <button type="button" onClick={() => onDecide(p, 'skip')}
                className="text-xs px-2.5 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                title="Straight to you to set the valuation meeting — Colleen's plate never sees it.">⏭ Skip Colleen</button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

// 🚨 Closing escalations (slice 3, Mark + Zac only): ONE card per sliding
// under-LOI deal — the synthesis, not the raw facts (req ④). The card
// demands the stall reason (req ⑦); "cause unknown" that persists is
// itself the finding. Reasons map to plays (req ⑦'s taxonomy).
const CE_STALL_REASONS = [
  ['buyer_financing', 'Buyer financing trouble'],
  ['buyer_distracted', 'Buyer distracted / other deals'],
  ['diligence_issue', 'Diligence issue surfaced'],
  ['seller_side', 'Seller-side delay'],
  ['price_renegotiation', 'Price / terms renegotiation'],
  ['unknown', "Don't know yet — finding out"],
];
// The plays (req ⑩ — coach, not cop): keyed to the stall reason; shown the
// moment a reason exists, with a one-click AI draft of the move (reviewed
// and sent by a human, never by the system).
const CE_PLAYS = {
  buyer_financing: 'Get the lender timeline IN WRITING: commitment-letter date or the close moves.',
  buyer_distracted: 'Close-or-get-off-the-pot: state the deadline, prep the re-market in parallel.',
  diligence_issue: 'Name it, quantify it, propose the bridge (price adj · holdback · rep) in writing this week.',
  seller_side: 'Call the seller today; find the real blocker; reset THEIR committed date on the plan.',
  price_renegotiation: 'Relay terms verbatim + your recommendation; counter with exactly what they would accept.',
  unknown: '48-hour fact-find: call both sides today; the weekly agenda says "status unknown" out loud.',
};
// 📮 Staged cadence sends (slice 5): the sweep drafted these; the Lead
// reviews and clicks send (from their own Gmail) or discards. The system
// never emails a client on its own — this card IS the review gate.
// 🔄 The buyer criteria check (Mark 10-21): ONE batch card for the day's still-current asks, not 50 cards.
// Everything ticked by default; untick or ✗ anyone you'd rather not ask; Send = one email each from your mailbox.
const FreshnessBatchCard = ({ items, onAct, onBulk, showHolder }) => {
  const [skip, setSkip] = useState({});
  const [preview, setPreview] = useState(false);
  const [busy, setBusy] = useState(false);
  const picked = items.filter(s => !skip[s.id]);
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-teal-700">
        🔄 Buyer criteria check <span className="text-gray-400 font-normal">({items.length} ready)</span>
      </h2>
      <p className="text-xs text-gray-500 mb-2">Buyers who showed interest in a business that just went under LOI (or whose criteria are 6+ months old). Each gets one short email from you: <i>are your acquisition criteria still current?</i> with a link to review them. Untick anyone you'd rather not ask, then send. Each goes out separately from your mailbox.</p>
      <div className="bg-white border border-teal-200 rounded-lg p-3">
        <div className="flex items-center gap-2 flex-wrap mb-2">
          <button type="button" onClick={() => setPreview(p => !p)} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">{preview ? 'Hide the email' : 'Preview the email'}</button>
          <button type="button" onClick={() => setSkip(Object.fromEntries(items.map(s => [s.id, false])))} className="text-xs text-gray-500 underline">tick all</button>
          <button type="button" onClick={() => setSkip(Object.fromEntries(items.map(s => [s.id, true])))} className="text-xs text-gray-500 underline">untick all</button>
          {showHolder && items[0] && items[0].holder && <span className="text-[10px] text-gray-400">→ {items[0].holder}</span>}
          <button type="button" disabled={busy || !picked.length}
            onClick={async () => { if (!window.confirm(`Send the criteria check to ${picked.length} buyer${picked.length === 1 ? '' : 's'}, one email each, from YOUR mailbox?`)) return; setBusy(true); try { await onBulk(picked); } finally { setBusy(false); } }}
            className="ml-auto text-xs px-3 py-1.5 rounded bg-teal-600 text-white font-semibold hover:bg-teal-700 disabled:opacity-50">{busy ? 'Sending…' : `✓ Send ${picked.length} checked`}</button>
        </div>
        {preview && items[0] && (
          <div className="mb-2 border border-gray-200 rounded p-3 text-sm bg-gray-50">
            <div className="text-xs text-gray-500 mb-1">To {items[0].to_emails} · Subject: <b>{items[0].subject}</b> (each buyer gets their own name and link)</div>
            <div dangerouslySetInnerHTML={{ __html: items[0].body_html }} />
          </div>
        )}
        <div className="max-h-72 overflow-y-auto divide-y divide-gray-100">
          {items.map(s => (
            <label key={s.id} className="flex items-center gap-2 py-1 text-xs cursor-pointer">
              <input type="checkbox" checked={!skip[s.id]} onChange={e => setSkip(k => ({ ...k, [s.id]: !e.target.checked }))} />
              <span className="font-semibold text-gray-800">{(s.meta && s.meta.company) || (s.meta && s.meta.contact) || s.to_emails}</span>
              {s.meta && s.meta.contact && s.meta.company && <span className="text-gray-600">{s.meta.contact}</span>}
              <span className="text-gray-400">{s.to_emails}</span>
              {s.meta && s.meta.reason && <span className="text-gray-400 italic">· {s.meta.reason}</span>}
              <button type="button" onClick={e => { e.preventDefault(); onAct(s, 'discard'); }} className="ml-auto text-gray-400 hover:text-red-600 px-1" title="Don't ask this buyer (they won't be asked again for 90 days)">✗</button>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

// 📣 LinkedIn (Mark 10-21): Scott's draft card (from the weekly email) + everyone's 30-second like + repost card.
const LinkedInCards = ({ items, onAct, onPosted, showHolder }) => {
  const [text, setText] = useState({});
  const [copied, setCopied] = useState(null);
  const posts = items.filter(s => s.kind === 'linkedin_post');
  const engage = items.filter(s => s.kind === 'linkedin_engage');
  return (
    <div className="mb-6">
      {posts.map(s => {
        const t = text[s.id] != null ? text[s.id] : ((s.meta && s.meta.post) || '');
        return (
          <div key={s.id} className="bg-white border border-sky-200 rounded-lg p-3 mb-2">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-sm font-bold text-sky-800">📣 LinkedIn post for the Vista company page</span>
              <span className="text-xs text-gray-500">from the email “{(s.meta && s.meta.title) || ''}”</span>
              {showHolder && s.holder && <span className="text-[10px] text-gray-400">→ {s.holder}</span>}
            </div>
            <p className="text-xs text-gray-500 mt-1">Drafted from this week's email. Edit it if you like, Copy, post it on the Vista company page and click Notify employees. Then click Posted and paste the post's link: everyone gets a like + repost reminder.</p>
            <textarea value={t} onChange={e => setText(x => ({ ...x, [s.id]: e.target.value }))} rows={9} className="w-full mt-2 text-sm border border-gray-200 rounded p-2" />
            <div className="flex gap-2 mt-1 flex-wrap">
              <button type="button" onClick={async () => { try { await navigator.clipboard.writeText(t); setCopied(s.id); setTimeout(() => setCopied(null), 2000); } catch (e) { window.alert('Copy failed: select the text and press Ctrl+C.'); } }}
                className="text-xs px-2.5 py-1 rounded bg-sky-600 text-white font-semibold hover:bg-sky-700">{copied === s.id ? '✓ Copied' : 'Copy text'}</button>
              <button type="button" onClick={() => {
                const url = window.prompt("Paste the link to the post (on the post: the … menu → Copy link to post):");
                if (!url) return;
                if (/^https?:\/\/([a-z]+\.)?linkedin\.com\//i.test(url.trim())) onPosted(s, url.trim());
                else window.alert('That does not look like a LinkedIn link. On the post: the … menu → Copy link to post.');
              }} className="text-xs px-2.5 py-1 rounded border border-sky-300 text-sky-800 font-semibold hover:bg-sky-50">Posted ✓</button>
              <button type="button" onClick={() => onAct(s, 'discard')} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-500 hover:bg-gray-50" title="Skip this one">✗</button>
            </div>
          </div>
        );
      })}
      {engage.map(s => (
        <div key={s.id} className="bg-white border border-sky-200 rounded-lg p-3 mb-2 flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-sky-800">📣 New Vista post: like + repost</span>
          <span className="text-xs text-gray-500">30 seconds, and all of your connections see it.{s.meta && s.meta.posted_by ? ` Posted by ${s.meta.posted_by}.` : ''}</span>
          <span className="ml-auto flex items-center gap-1.5">
            <a href={(s.meta && s.meta.post_url) || '#'} target="_blank" rel="noopener noreferrer" className="text-xs px-2.5 py-1 rounded bg-sky-600 text-white font-semibold hover:bg-sky-700">Open the post</a>
            <button type="button" onClick={() => onAct(s, 'done')} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">Done ✓</button>
          </span>
        </div>
      ))}
    </div>
  );
};

// 👋 Contact gone (Mark 10-21): "no longer with the company" / "retired" auto-replies, one batch card for Scott.
// A buyer's (PE group, strategic) usually names the replacement → update the buyer. An owner's often means the
// business sold → Sold / closed, or update the contact. Vacation and out-of-office notes never get here.
const ContactGoneCard = ({ items, onAct, onSold, showHolder }) => {
  const unent = (t) => String(t || '').replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-teal-700">👋 Contact gone <span className="text-gray-400 font-normal">({items.length})</span></h2>
      <p className="text-xs text-gray-500 mb-2">"No longer with the company" or "retired" auto-replies to our emails. A buyer's usually names the new contact: update the buyer. An owner's often means the business sold: Sold / closed stops all marketing to it, or update the contact if someone new runs it.</p>
      <div className="bg-white border border-teal-200 rounded-lg p-3 space-y-2">
        {items.map(s => {
          const m = s.meta || {};
          const link = m.who === 'owner' ? (m.owner_id ? '/sales-engine?owner=' + m.owner_id : null) : (m.buyer_id ? '/sales-engine?buyer=' + m.buyer_id : null);
          return (
            <div key={s.id} className="border-t border-gray-100 pt-2 first:border-0 first:pt-0 text-xs">
              <div className="flex items-center gap-2 flex-wrap">
                <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${m.who === 'owner' ? 'bg-blue-100 text-blue-700' : 'bg-violet-100 text-violet-700'}`}>{m.who === 'owner' ? 'owner' : (m.buyer_type || 'buyer')}</span>
                <span className="font-semibold text-gray-800">{m.company || m.contact || m.from}</span>
                {m.contact && m.company && <span className="text-gray-600">{m.contact}</span>}
                <span className="text-gray-400">{m.from}{m.at ? ' · ' + new Date(m.at).toLocaleDateString() : ''}{showHolder && m.mailbox ? ' · to ' + m.mailbox : ''}</span>
                {showHolder && s.holder && <span className="text-[10px] text-gray-400">→ {s.holder}</span>}
              </div>
              <div className="text-gray-700 mt-0.5 italic">“{unent(m.text).slice(0, 400)}”</div>
              <div className="flex gap-1.5 mt-1 flex-wrap">
                {m.who === 'owner' && m.owner_id && (
                  <button type="button" onClick={() => { if (window.confirm('Mark ' + (m.company || 'this business') + ' sold / closed? It leaves every marketing list and the follow-up rotation.')) onSold(s); }}
                    className="px-2 py-0.5 rounded border border-red-300 text-red-700 font-semibold hover:bg-red-50">Sold / closed</button>
                )}
                {link && <a href={link} target="_blank" rel="noopener noreferrer" className="px-2 py-0.5 rounded border border-teal-300 text-teal-800 font-semibold hover:bg-teal-50">Open the {m.who === 'owner' ? 'record' : 'buyer'} to update</a>}
                <button type="button" onClick={() => onAct(s, 'done')} className="px-2 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">Updated ✓</button>
                <button type="button" onClick={() => onAct(s, 'discard')} className="px-2 py-0.5 rounded border border-gray-300 text-gray-500 hover:bg-gray-50" title="Nothing to change">✕</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// 📭 Vendor pitch (Mark 10-21): a contact-form message the AI check read as someone selling TO us. No owner record was
// made; Scott glances, clicks Not a lead, or adds the owner by hand if the check got it wrong.
const VendorPitchCard = ({ items, onAct, showHolder }) => (
  <div className="mb-6">
    <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-gray-600">📭 Contact form: looks like a vendor pitch <span className="text-gray-400 font-normal">({items.length})</span></h2>
    <p className="text-xs text-gray-500 mb-2">Someone selling to us or offering a partnership, not a seller. No owner record was made. If it really is an owner, add them in Sales Engine (➕ Add owner).</p>
    <div className="bg-white border border-gray-200 rounded-lg p-3 space-y-2">
      {items.map(s => { const m = s.meta || {}; return (
        <div key={s.id} className="border-t border-gray-100 pt-2 first:border-0 first:pt-0 text-xs">
          <div className="flex items-center gap-2 flex-wrap"><span className="font-semibold text-gray-800">{m.company || m.name || m.email}</span>
            {m.name && m.company && <span className="text-gray-600">{m.name}</span>}<span className="text-gray-400">{m.email}{s.staged_at ? ' · ' + new Date(s.staged_at).toLocaleDateString() : ''}</span>
            {showHolder && s.holder && <span className="text-[10px] text-gray-400">→ {s.holder}</span>}</div>
          <div className="text-gray-700 mt-0.5 italic">“{String(m.message || '').slice(0, 300)}{String(m.message || '').length > 300 ? '…' : ''}”</div>
          {m.reason && <div className="text-gray-400 mt-0.5">Why it looked like a pitch: {m.reason}</div>}
          <div className="flex gap-1.5 mt-1">
            <button type="button" onClick={() => onAct(s, 'done')} className="px-2 py-0.5 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50">Not a lead ✓</button>
            <a href="/sales-engine" target="_blank" rel="noopener noreferrer" onClick={() => onAct(s, 'done')} className="px-2 py-0.5 rounded border border-emerald-300 text-emerald-700 hover:bg-emerald-50">It's a real seller: add them</a>
          </div>
        </div>); })}
    </div>
  </div>
);

// 🏁 Listing ended (Mark 10-22): Deal Manager stages one per manager (Mark, Zac, Colleen) when a listing is marked Dead
// with its reason. The whole report is on the card: why, the Lead's note, would they come back, and what we delivered
// (buyers, IOIs, LOIs, best offers) against our valuation. Read it, then Got it.
const ListingEndedCard = ({ items, onAct }) => (
  <div className="mb-6">
    <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-gray-700">🏁 Listing ended without a sale <span className="text-gray-400 font-normal">({items.length})</span></h2>
    <p className="text-xs text-gray-500 mb-2">Why it ended and what we delivered, recorded when it was marked Dead. For the review: owner, market, the business, or us?</p>
    <div className="bg-white border border-gray-200 rounded-lg p-3 space-y-3">
      {items.map(s => { const m = s.meta || {}; return (
        <div key={s.id} className="border-t border-gray-100 pt-2 first:border-0 first:pt-0 text-xs">
          <div className="font-semibold text-gray-800 text-sm">{m.name} <span className="text-gray-400 font-normal">#{m.vista_id}{s.staged_at ? ' · ' + new Date(s.staged_at).toLocaleDateString() : ''}</span></div>
          {(m.lines || []).map((l, i) => <div key={i} className={i === 0 ? 'text-gray-800 mt-0.5' : 'text-gray-600 mt-0.5'}>{l}</div>)}
          <div className="mt-1.5"><button type="button" onClick={() => onAct(s, 'done')} className="px-2 py-0.5 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50">Got it ✓</button></div>
        </div>); })}
    </div>
  </div>
);

// 📪 Email bounced (step 2, Mark 10-27): the server saw a bounce (staff Gmail or Mailchimp) on a warm account's sending
// address and already flagged it, so nothing sends there again. The AM decides: new address, call, or stop.
const EmailBouncedCard = ({ items, onChoose, onAct, showHolder }) => (
  <div className="mb-6">
    <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-rose-700">📪 Email bounced: what next? <span className="text-gray-400 font-normal">({items.length})</span></h2>
    <p className="text-xs text-gray-500 mb-2">An email to an owner you're still following up with bounced. The address is already marked dead, so nothing sends to it again. Pick one: a new address, a call, or stop.</p>
    <div className="bg-white border border-rose-200 rounded-lg p-3 space-y-2">
      {items.map(s => { const m = s.meta || {}; return (
        <div key={s.id} className="border-t border-gray-100 pt-2 first:border-0 first:pt-0 text-xs">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-gray-800">{m.company || m.addr}</span>
            {m.contact && <span className="text-gray-600">{m.contact}</span>}
            <span className="text-gray-400">{m.addr}{m.at ? ' · ' + new Date(m.at).toLocaleDateString() : ''} · {m.source === 'gmail' ? `bounce-back in ${m.mailbox || 'a team'} Gmail` : 'Mailchimp stopped sending to it'}</span>
            {showHolder && s.holder && <span className="text-[10px] text-gray-400">→ {s.holder}</span>}
          </div>
          {m.text && <div className="text-gray-600 mt-0.5 italic">“{String(m.text).slice(0, 220)}”</div>}
          <div className="flex gap-1.5 mt-1 flex-wrap">
            <button type="button" onClick={() => onChoose(s)} className="px-2 py-0.5 rounded bg-rose-600 text-white font-semibold hover:bg-rose-700">📪 Choose: new address · call · stop</button>
            {m.owner_id && <a href={'/sales-engine?owner=' + m.owner_id} target="_blank" rel="noopener noreferrer" className="px-2 py-0.5 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">↗ Account</a>}
          </div>
        </div>); })}
    </div>
  </div>
);

// part: 'cards' = the action cards (LinkedIn, bounces, freshness…) plus readiness / skip-ahead sends, in place;
// 'drafts' = the weekly-meeting drafts (T-2 / T-1), parked at the bottom of My Work and collapsed
// (Zac 11-03: "mostly noise, park it at the bottom … a drop down").
const StagedSendsSection = ({ items: allItems, onAct, onBulk, onLinkedInPosted, onContactGoneSold, onBounceChoose, showHolder, part }) => {
  const [openFor, setOpenFor] = useState(null);
  const [listOpen, setListOpen] = useState(false);
  const LI_KINDS = ['linkedin_post', 'linkedin_engage', 'contact_gone', 'vendor_pitch', 'listing_ended', 'email_bounced'];
  const fresh = (allItems || []).filter(s => s.kind === 'freshness_ask');
  const li = (allItems || []).filter(s => LI_KINDS.includes(s.kind));
  const MEETING_KINDS = ['agenda_items', 'weekly_agenda'];
  const items = (allItems || []).filter(s => s.kind !== 'freshness_ask' && !LI_KINDS.includes(s.kind)
    && (part === 'drafts' ? MEETING_KINDS.includes(s.kind) : part === 'cards' ? !MEETING_KINDS.includes(s.kind) : true));
  const collapsible = part === 'drafts';
  if (!fresh.length && !items.length && !li.length) return null;
  const extras = (<>
    {li.some(x => x.kind === 'linkedin_post' || x.kind === 'linkedin_engage') && <LinkedInCards items={li.filter(x => x.kind === 'linkedin_post' || x.kind === 'linkedin_engage')} onAct={onAct} onPosted={onLinkedInPosted} showHolder={showHolder} />}
    {li.some(x => x.kind === 'email_bounced') && onBounceChoose && <EmailBouncedCard items={li.filter(x => x.kind === 'email_bounced')} onChoose={onBounceChoose} onAct={onAct} showHolder={showHolder} />}
    {li.some(x => x.kind === 'listing_ended') && <ListingEndedCard items={li.filter(x => x.kind === 'listing_ended')} onAct={onAct} />}
    {li.some(x => x.kind === 'vendor_pitch') && <VendorPitchCard items={li.filter(x => x.kind === 'vendor_pitch')} onAct={onAct} showHolder={showHolder} />}
    {li.some(x => x.kind === 'contact_gone') && <ContactGoneCard items={li.filter(x => x.kind === 'contact_gone')} onAct={onAct} onSold={onContactGoneSold} showHolder={showHolder} />}
    {fresh.length > 0 && <FreshnessBatchCard items={fresh} onAct={onAct} onBulk={onBulk} showHolder={showHolder} />}
  </>);
  if (!items.length) return part === 'drafts' ? null : <div>{extras}</div>;
  const KIND = { agenda_items: ['T-2 · agenda items request', 'Asks both sides for their agenda items, two business days ahead.'], weekly_agenda: ['T-1 · weekly agenda + timeline', 'The all-parties agenda: plan snapshot, on-pace banner, Fireflies recap.'],
    skip_followup: ["⏭ Skip ahead: started, didn't finish",'The owner skipped ahead on the website and gave us some information, but no meeting is booked after 2 business days. Read it, then send it from your mailbox. If they want to talk first, set the meeting as usual.'],
    readiness_report: ['🌐 Readiness results', 'An owner took the sale-readiness checklist on the website and asked for a copy. Read it, then send it from your mailbox: it doubles as your first touch.'] };
  return (
    <div className="mb-6">
      {part !== 'drafts' && extras}
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-teal-700">
        {collapsible ? (
          <button type="button" onClick={() => setListOpen(o => !o)} className="uppercase font-bold tracking-wide hover:underline" aria-expanded={listOpen}>
            {listOpen ? '▾' : '▸'} 📮 Weekly-meeting drafts — review &amp; send <span className="text-gray-400 font-normal">({items.length})</span>
          </button>
        ) : <>📮 Staged sends — review &amp; send <span className="text-gray-400 font-normal">({items.length})</span></>}
      </h2>
      {(listOpen || !collapsible) && <p className="text-xs text-gray-400 mb-3">Drafted for you: weekly-meeting emails for your deals, and website readiness results owners asked for. Read it, then send it from your own mailbox, or discard. Nothing sends without your click.</p>}
      {(listOpen || !collapsible) && <div className="space-y-2">
        {items.map(s => (
          <div key={s.id} className="bg-white border border-teal-200 rounded-lg p-3">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-teal-100 text-teal-800" title={(KIND[s.kind] || ['', ''])[1]}>{(KIND[s.kind] || [s.kind])[0]}</span>
              <span className="font-semibold text-gray-800 text-sm">{s.subject}</span>
              {showHolder && s.holder && <span className="text-[10px] text-gray-400">→ {s.holder}</span>}
              <span className="ml-auto flex items-center gap-1.5">
                <button type="button" onClick={() => setOpenFor(openFor === s.id ? null : s.id)} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">{openFor === s.id ? 'Hide' : 'Review'}</button>
                <button type="button" onClick={() => { if (window.confirm(`Send to: ${s.to_emails || '(no recipients!)'} — from YOUR mailbox?`)) onAct(s, 'send'); }}
                  className="text-xs px-2.5 py-1 rounded bg-teal-600 text-white font-semibold hover:bg-teal-700">✓ Send</button>
                <button type="button" onClick={() => onAct(s, 'discard')} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-500 hover:bg-gray-50" title="Not this week — discard the draft (the sweep stages a fresh one next meeting).">✗</button>
              </span>
            </div>
            {s.kind === 'readiness_report' && s.meta && <div className="text-xs text-gray-700 mt-0.5"><b>{s.meta.company || s.meta.contact || s.to_emails}</b>{s.meta.company && s.meta.contact ? ' · ' + s.meta.contact : ''}{s.meta.reason ? ' — ' + s.meta.reason : ''}</div>}
            <div className="text-xs text-gray-500 mt-0.5">To: {s.to_emails || <span className="text-amber-600 font-semibold">no participants on the plan yet — add them via 📋 Plan on the Staff Meeting tab</span>}{s.meeting_date ? ` · meeting ${s.meeting_date}` : ''}</div>
            {openFor === s.id && (
              <div className="mt-2 border border-gray-200 rounded p-3 text-sm bg-gray-50 max-h-80 overflow-y-auto" dangerouslySetInnerHTML={{ __html: s.body_html }} />
            )}
          </div>
        ))}
      </div>}
    </div>
  );
};

const ClosingEscalationSection = ({ items, onStallSave }) => {
  const [reasonFor, setReasonFor] = useState({});
  const [noteFor, setNoteFor] = useState({});
  const [draft, setDraft] = useState(null); // { name, play, text, ai } | { loading }
  const draftMove = async (h, reason) => {
    if (!h.plan) { window.alert('The draft is composed from the closing plan — start one from the Staff Meeting tab first.'); return; }
    setDraft({ loading: true, name: h.name });
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const at = session && session.access_token;
      if (!at) throw new Error('Session expired — reload and sign in again.');
      const r = await fetch('/api/closing/coach-draft', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
        body: JSON.stringify({ plan_id: h.plan.id, reason }),
      });
      const d = await r.json();
      if (!r.ok || !d.ok) throw new Error(d.error || ('HTTP ' + r.status));
      setDraft({ name: h.name, play: d.play, text: d.draft, ai: d.ai });
    } catch (e) { setDraft(null); window.alert('Draft failed: ' + (e.message || e)); }
  };
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-red-700">
        🚨 Closing deals sliding <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">The movement detector's synthesis — a side quiet two weeks, or quiet plus behind the closing plan. A deal that stops moving every week goes from a high chance of closing to a very low one; these need to be put back on track. Record the stall reason — the play differs by cause, and "unknown" for two weeks is its own finding.</p>
      <div className="space-y-2">
        {items.map(h => (
          <div key={h.key} className="bg-white border border-red-300 rounded-lg p-3">
            <div className="flex items-start justify-between gap-2 flex-wrap">
              <div className="min-w-0">
                <div className="font-semibold text-gray-800">{h.name}
                  <span className={`ml-2 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${h.key.startsWith('bs|') ? 'bg-violet-100 text-violet-700' : 'bg-blue-100 text-blue-700'}`}>{h.key.startsWith('bs|') ? 'buyside' : 'sellside'}</span>
                  {h.alsoCloses && h.alsoCloses.length > 0 && <span className="ml-2 text-xs font-normal text-gray-500">· sold together with {h.alsoCloses.join(', ')}</span>}
                </div>
                <div className="text-xs text-gray-600 mt-0.5">
                  Seller quiet <b>{h.qSeller == null ? '—' : h.qSeller + 'd'}</b> · Buyer quiet <b>{h.qBuyer == null ? '—' : h.qBuyer + 'd'}</b>
                  {h.behindBd > 0 && <span className="text-red-700 font-semibold"> · {h.behindBd} business day{h.behindBd === 1 ? '' : 's'} behind plan — honest close {h.honestClose}</span>}
                  {!h.plan && <span className="text-amber-700"> · no closing plan yet — start one from the Staff Meeting tab</span>}
                </div>
                {h.nextStage && (
                  <div className="text-xs mt-0.5">
                    <span className="font-semibold text-gray-700">▶ Next: {h.nextStage.name}</span>
                    {h.nextStage.due
                      ? <span className="text-gray-500"> — due {h.nextStage.due}{h.nextStage.overdueBd > 0 && <span className="text-red-700 font-semibold"> · {h.nextStage.overdueBd} business day{h.nextStage.overdueBd === 1 ? '' : 's'} overdue</span>}</span>
                      : <span className="text-gray-400"> — no date set</span>}
                    {!h.nextStage.crit && <span className="text-gray-400"> (no critical steps left)</span>}
                  </div>
                )}
                {h.stall && <div className="text-xs text-gray-500 mt-0.5">Stall reason on record ({(h.stall.at || '').slice(0, 10)}): <b>{(CE_STALL_REASONS.find(([k]) => k === h.stall.reason) || [null, h.stall.reason])[1]}</b>{h.stall.note ? ` — ${h.stall.note}` : ''}</div>}
                {(() => {
                  const activeReason = reasonFor[h.key] || (h.stall && h.stall.reason);
                  if (!activeReason || !CE_PLAYS[activeReason]) return null;
                  return (
                    <div className="text-xs text-red-800 bg-red-50 border border-red-200 rounded px-2 py-1 mt-1 flex items-center gap-2 flex-wrap">
                      <span><b>The play:</b> {CE_PLAYS[activeReason]}</span>
                      <button type="button" onClick={() => draftMove(h, activeReason)}
                        className="text-[11px] px-2 py-0.5 rounded bg-red-600 text-white font-semibold hover:bg-red-700 whitespace-nowrap"
                        title="AI-drafts the email that executes the play from this deal's own record (plan, late milestones, recent mail). You review, edit, and send it yourself — nothing sends automatically.">✍ Draft the move</button>
                    </div>
                  );
                })()}
              </div>
              <div className="flex items-center gap-1.5 flex-wrap">
                <select value={reasonFor[h.key] || ''} onChange={e => setReasonFor(s => ({ ...s, [h.key]: e.target.value }))}
                  className="text-xs border border-gray-300 rounded px-1.5 py-1 bg-white">
                  <option value="">Why is it stalled…</option>
                  {CE_STALL_REASONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                </select>
                <input value={noteFor[h.key] || ''} onChange={e => setNoteFor(s => ({ ...s, [h.key]: e.target.value }))}
                  placeholder="note (optional)" className="text-xs border border-gray-300 rounded px-2 py-1 w-40" />
                <button type="button" disabled={!reasonFor[h.key]}
                  className={`text-xs px-2.5 py-1 rounded font-semibold ${reasonFor[h.key] ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-gray-200 text-gray-400'}`}
                  onClick={() => { onStallSave(h, reasonFor[h.key], noteFor[h.key]); setReasonFor(s => ({ ...s, [h.key]: '' })); setNoteFor(s => ({ ...s, [h.key]: '' })); }}>Record</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {draft && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={e => { if (e.target === e.currentTarget) setDraft(null); }}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl p-5">
            <div className="flex items-center gap-2 mb-2">
              <div className="text-sm font-bold text-gray-800">✍ The move — {draft.name}</div>
              {draft.ai === false && <span className="text-[10px] font-bold uppercase bg-amber-100 text-amber-700 rounded px-1.5 py-0.5" title="AI drafting unavailable — this is the play template; write it in your own words.">template</span>}
              <button type="button" onClick={() => setDraft(null)} className="ml-auto text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50">Close</button>
            </div>
            {draft.loading ? (
              <div className="text-sm text-gray-400 py-8 text-center">Composing from the deal's own record…</div>
            ) : (
              <React.Fragment>
                {draft.play && <div className="text-xs text-red-800 bg-red-50 border border-red-200 rounded px-2 py-1 mb-2"><b>The play:</b> {draft.play}</div>}
                <textarea readOnly value={draft.text || ''} className="w-full h-72 border border-gray-300 rounded p-3 text-sm font-mono" />
                <div className="flex items-center gap-2 mt-2">
                  <button type="button" className="text-xs px-3 py-1.5 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700"
                    onClick={async () => { try { await navigator.clipboard.writeText(draft.text || ''); window.alert('Copied — paste into Gmail, edit, and send it yourself.'); } catch (e) { /* select manually */ } }}>📋 Copy draft</button>
                  <span className="text-[11px] text-gray-400">You review, edit, and send — the system never sends for you.</span>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// The full classification vocabulary (Mark's taxonomy, settled 09-01) —
// mirrors the SE page's MEETING_TYPES exactly, tooltips included.
const MT_CLASSIFY_TYPES = [
  ['first_time', 'Sellside 1st-time — owner interested in selling', 'Owner came via sellside marketing or LinkedIn outreach — their first meeting about selling with Vista.'],
  ['reengage', 'Sellside re-engage — back to the table', 'A stale owner worked back to the table (marketing, cards, or follow-up reminders).'],
  ['discovery', 'Discovery meeting', 'The discovery call — the funnel step between the first meeting and the valuation.'],
  ['valuation_meeting', 'Valuation meeting — results presented', 'The valuation is presented; the owner picks a path (list · strategic meeting · back to AM · stalled).'],
  ['bsc_interest', 'BSC interest — owner vet', 'We HAVE a buyside client with interest; this is the first meeting with the business OWNER to vet the fit before any intro.'],
  ['buyside_intro', 'Buyside intro', 'Introducing our buyside client to the business owner — both parties in the room.'],
  ['buyside_call', 'Buyside services pitch', 'First-time call with a potential buyside CLIENT — a buyer, discussing hiring our buyside services.'],
  ['strategic_review', 'Strategic review', 'Recurring valuation review meeting — the strategic review lane, not a funnel step.'],
  ['deal_process', 'Deal process (post-LOI)', 'Under-LOI working meeting (weekly buyer/seller cadence). Excluded from committee counts.'],
  ['buyer_relationship', 'Buyer meeting — not tracked', 'Buyer-only meeting with no active listing tie. Never counted.'],
  ['vendor', 'Vendor / pitch', 'Someone selling US something. Never counted.'],
  ['personal', 'Personal', 'Personal calendar item that synced. Never counted.'],
  ['other', 'Other', ''],
];
// Buyer-context picks that trigger the role-cross prompt on a seller-only match.
const MT_BUYER_CONTEXT = new Set(['buyside_call', 'buyer_relationship']);

// 🗂 One classify card = one relationship (weekly series classify once).
// Variant Ⓐ (matched, untyped): pick the purpose. Variant Ⓑ (nobody in SE):
// add them + categorize, with the automation lesson. Variant Ⓒ: buyer-type
// pick on a seller-only match offers "also add as buyer".
const MeetingClassifyCard = ({ card, buyers = {}, onSave, onDismiss, onHandOff, actor }) => {
  const rep = card.rep;
  const matched = !!rep.owner_id && rep.owner;
  // An attendee who's already a BUYER in the system (Mark 09-17): recognize
  // them so we attach the meeting to that buyer instead of creating a duplicate.
  const existingBuyer = !matched
    ? ((rep.external_emails || []).map(e => buyers[String(e).toLowerCase()]).find(Boolean) || null)
    : null;
  const firstExt = (rep.external_emails || [])[0] || '';
  const [type, setType] = useState('');
  const [side, setSide] = useState('seller');
  const [company, setCompany] = useState('');
  const [contact, setContact] = useState('');
  const [email, setEmail] = useState(firstExt);
  const [buyerType, setBuyerType] = useState('individual');
  const [alsoBuyer, setAlsoBuyer] = useState(false);
  const [busy, setBusy] = useState(false);
  const fmtWhen = (iso) => new Date(iso).toLocaleString(undefined, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  const crossOffer = matched && MT_BUYER_CONTEXT.has(type);
  const canSave = type && (matched || existingBuyer || side === 'none' || (side === 'buyer' ? (contact || company) : company));
  const save = async () => {
    if (!canSave || busy) return;
    setBusy(true);
    await onSave(card, existingBuyer
      ? { type, attachSeBuyer: { id: existingBuyer.id, dm_buyer_id: existingBuyer.dm_buyer_id || null, name: existingBuyer.company_name || existingBuyer.contact_name || 'buyer' } }
      : matched
      ? { type, alsoBuyer: crossOffer && alsoBuyer }
      : { type, addSide: side, company: side === 'buyer' && !company ? null : company, contact, email });
    setBusy(false);
  };
  return (
    <div className="bg-white border border-violet-200 rounded-lg p-3">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-gray-800 text-sm truncate">{matched ? rep.owner.company_name : (rep.summary || 'Meeting')}</div>
          <div className="text-xs text-gray-500">
            {fmtWhen(rep.starts_at)}{card.count > 1 ? ` · recurring ×${card.count} — one save covers the series` : ''}
            {matched && rep.summary ? <span className="text-gray-400 italic"> · “{rep.summary}”</span> : null}
          </div>
          <div className="text-xs text-gray-400 mt-0.5 truncate" title={(rep.external_emails || []).join(', ')}>{(rep.external_emails || []).join(', ') || 'no external attendees'}</div>
        </div>
        {onHandOff && (
          <select value="" onChange={e => { if (e.target.value) onHandOff(card, e.target.value); }}
            className="text-[11px] border border-gray-200 rounded px-1 py-0.5 text-gray-500 bg-white shrink-0"
            title="Not your meeting? Hand the card to whoever ran it.">
            <option value="">↷ not mine…</option>
            {MT_HOLDER_NAMES.filter(n => n !== actor).map(n => <option key={n} value={n}>hand to {n}</option>)}
          </select>
        )}
      </div>
      {existingBuyer && (
        <div className="mt-2 text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 rounded px-2 py-1">
          🤝 Existing buyer in the system: <b>{existingBuyer.company_name || existingBuyer.contact_name || 'buyer'}</b>{existingBuyer.contact_name && existingBuyer.company_name ? ` — ${existingBuyer.contact_name}` : ''}. Just pick the meeting type — it attaches to this buyer (no new record).
        </div>
      )}
      {!matched && !existingBuyer && (
        <div className="mt-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1">
          None of these participants are in the system. If they're a new seller or buyer, add them below and categorize. If they're neither a seller nor a buyer prospect — a former/sold client, a partner, just a conversation — pick <b>"Neither — just a meeting"</b> and no record is created. (Participants added <b>before</b> booking classify automatically.)
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2 mt-2">
        {!matched && !existingBuyer && (
          <React.Fragment>
            <select value={side} onChange={e => setSide(e.target.value)} className="text-xs border border-gray-300 rounded px-1.5 py-1 bg-white"
              title="Seller/buyer prospect → we create the record. 'Neither — just a meeting' logs the meeting with no record (e.g. a sold client checking in on earnouts).">
              <option value="seller">Business (seller side)</option>
              <option value="buyer">Buyer</option>
              <option value="none">Neither — just a meeting</option>
            </select>
            {side !== 'none' && (
              <React.Fragment>
                <input value={company} onChange={e => setCompany(e.target.value)} placeholder={side === 'buyer' ? 'Company (optional)' : 'Company *'}
                  className="text-xs border border-gray-300 rounded px-2 py-1 w-40" />
                <input value={contact} onChange={e => setContact(e.target.value)} placeholder="Contact name"
                  className="text-xs border border-gray-300 rounded px-2 py-1 w-32" />
                <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"
                  className="text-xs border border-gray-300 rounded px-2 py-1 w-44" />
                {side === 'buyer' && (
                  <select value={buyerType} onChange={e => setBuyerType(e.target.value)} className="text-xs border border-gray-300 rounded px-1.5 py-1 bg-white">
                    <option value="individual">Individual</option><option value="pe">PE group</option><option value="strategic">Strategic</option>
                  </select>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        <select value={type} onChange={e => setType(e.target.value)} className="text-xs border border-violet-300 rounded px-1.5 py-1 bg-white"
          title="What kind of meeting is this? Feeds the committee metrics.">
          <option value="">Type…</option>
          {MT_CLASSIFY_TYPES.map(([k, l, tip]) => <option key={k} value={k} title={tip}>{l}</option>)}
        </select>
        <button type="button" disabled={!canSave || busy} onClick={save}
          className={`text-xs px-3 py-1 rounded font-semibold ${canSave && !busy ? 'bg-violet-600 text-white hover:bg-violet-700' : 'bg-gray-200 text-gray-400'}`}>Save</button>
        <button type="button" onClick={() => onDismiss(card)}
          className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-500 hover:bg-gray-50"
          title="Not a business meeting — hide it (never counted).">Dismiss</button>
      </div>
      {crossOffer && (
        <label className="flex items-center gap-1.5 mt-2 text-xs text-violet-700">
          <input type="checkbox" checked={alsoBuyer} onChange={e => setAlsoBuyer(e.target.checked)} />
          {rep.owner.company_name} is logged only as a seller — also add them as a <b>buyer</b> (both roles kept)
        </label>
      )}
    </div>
  );
};

const MeetingsClassifySection = ({ items, buyers = {}, onSave, onDismiss, onHandOff, actor }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-violet-700">
        🗂 Meetings needing your call <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">Meetings from your calendar the system couldn't fully file — say what they are so tracking, follow-ups, and the committee numbers work. Participants added to the system <b>before</b> a meeting is booked skip this entirely.</p>
      <div className="space-y-2">
        {items.map(card => (
          <MeetingClassifyCard key={card.key} card={card} buyers={buyers} onSave={onSave} onDismiss={onDismiss} onHandOff={onHandOff} actor={actor} />
        ))}
      </div>
    </div>
  );
};

// 📅 MEETING PREP (Mark 09-16): today's + tomorrow's meetings, each carrying
// the context you'd otherwise dig for mid-call — where the deal stands, the
// value we delivered, what we said last time, what we owe them, plus the
// Fireflies recap on demand. Informational: it never needs clearing (it falls
// off after the day). A meeting that's already happened still offers an
// optional log so tomorrow's "did it happen?" card doesn't fire.
const MEETING_TYPE_LABEL = { first_time: 'Sellside 1st-time', reengage: 'Sellside re-engage', discovery: 'Discovery', valuation_meeting: 'Valuation meeting', listing: 'Listing (legacy)', buyside_intro: 'Buyside intro', buyside_call: 'Buyside pitch', buyer_relationship: 'Buyer relationship', bsc_interest: 'BSC interest', strategic_review: 'Strategic review', deal_process: 'Deal process', other: 'Meeting' };
// Types a person can pick when fixing a mis-categorized meeting on the prep card.
const MT_TYPE_OPTIONS = [
  ['first_time', 'Sellside 1st-time'], ['reengage', 'Sellside re-engage'],
  ['discovery', 'Discovery'], ['valuation_meeting', 'Valuation meeting'],
  ['bsc_interest', 'BSC interest'], ['buyside_intro', 'Buyside intro'], ['buyside_call', 'Buyside pitch'],
  ['buyer_relationship', 'Buyer relationship'], ['strategic_review', 'Strategic review'],
  ['deal_process', 'Deal process'], ['other', 'Other'],
];
// PROJECT-BASED INDUSTRIES (Zac 10-08, Workstate review P1): "this isn't recurring revenue. They run on
// project cycles regardless of how they bill. It may feel like it, and even be under contract, but they
// are projects at the end of the day." In these industries a line classified Contracted – Defined (or
// recurring contract) SCORES as project revenue for contracted clients — revenue mix, MRR, contract
// coverage, growth quality. The classification itself is untouched. Grandfathered: valuations scored
// 'legacy' (presented before the change) keep the old scoring until they revalue.
const PROJECT_BASED_INDUSTRIES = new Set(['it-dev']);

// ── ANNUAL ↔ TTM BALANCE SHEET MATCHING (shared by the Sync button and its
// reconciliation chip — the chip flags exactly what Sync would do).
// Colleen 10-07, Initial IT: the annual BS came from PDFs WITH QuickBooks account
// numbers ("106 Accounts Receivable"), the TTM BS without ("Accounts Receivable").
// Name-only matching paired nothing, so Sync zeroed the real A/R (the A/R aging
// check then read $0) and appended a numberless duplicate — 15 accounts — and the
// TTM file's equity rows, filed under Long-Term Liabilities, landed there too.
//  1. exact name  2. account-number-blind name, only when unique on both sides
//  3. 6-char prefix on the number-blind name (the old fuzzy pass)
//  4. across sections, number-blind + unique (equity filed as liabilities)
// A named annual row with NO year history whose number-blind name matches a row
// WITH history is a duplicate a previous Sync created: Sync merges it away (listed
// in its confirmation first) and the chip flags it.
const bsNameNorm = (n) => String(n || '').toLowerCase().replace(/[^a-z0-9]/g, '');
const bsNameBare = (n) => bsNameNorm(String(n || '').replace(/^\s*\d[\d.\-]*\s*[·:\-–—]?\s*/, ''));
const bsRowHasHistory = (a) => ['year1', 'year2', 'year3'].some(k => (Number(a && a[k]) || 0) !== 0);
function bsPlanTtmSync(sections) {
  const histKeys = new Set();
  sections.forEach(sec => (sec.annual || []).forEach(a => { if (a && a.name && bsRowHasHistory(a)) histKeys.add(bsNameBare(a.name)); }));
  const plan = sections.map(sec => {
    const keep = [], dupes = [];
    (sec.annual || []).forEach(a => {
      const named = a && a.name && String(a.name).trim();
      if (named && !bsRowHasHistory(a) && bsNameBare(a.name) && histKeys.has(bsNameBare(a.name))) dupes.push(a); else keep.push(a);
    });
    return { ...sec, ttm: sec.ttm || [], annual: keep, dupes, matches: new Array(keep.length).fill(null), claimed: new Set() };
  });
  plan.forEach((p, si) => {
    const A = p.annual, T = p.ttm;
    const set = (ai, ti) => { p.matches[ai] = { secIdx: si, ttmIdx: ti }; p.claimed.add(ti); };
    // 1. exact
    A.forEach((a, ai) => {
      const n = bsNameNorm(a.name); if (!n) return;
      for (let i = 0; i < T.length; i++) { if (!p.claimed.has(i) && bsNameNorm(T[i].name) === n) { set(ai, i); break; } }
    });
    // 2. number-blind, unique on both sides
    A.forEach((a, ai) => {
      if (p.matches[ai]) return;
      const b = bsNameBare(a.name); if (!b) return;
      if (A.filter((x, j) => !p.matches[j] && bsNameBare(x.name) === b).length !== 1) return;
      const c = []; T.forEach((t, i) => { if (!p.claimed.has(i) && bsNameBare(t.name) === b) c.push(i); });
      if (c.length === 1) set(ai, c[0]);
    });
    // 3. 6-char prefix on number-blind names
    A.forEach((a, ai) => {
      if (p.matches[ai]) return;
      const b = bsNameBare(a.name); if (!b) return;
      let best = 0, bi = -1;
      for (let i = 0; i < T.length; i++) {
        if (p.claimed.has(i)) continue;
        const t = bsNameBare(T[i].name); let c = 0;
        while (c < b.length && c < t.length && b[c] === t[c]) c++;
        if (c >= 6 && c > best) { best = c; bi = i; }
      }
      if (bi >= 0) set(ai, bi);
    });
  });
  // 4. across sections (number-blind, unique)
  plan.forEach((p, si) => p.ttm.forEach((t, ti) => {
    if (p.claimed.has(ti)) return;
    const b = bsNameBare(t.name); if (!b) return;
    const hits = [];
    plan.forEach((q, qi) => { if (qi !== si) q.annual.forEach((a, ai) => { if (!q.matches[ai] && bsNameBare(a.name) === b) hits.push([qi, ai]); }); });
    if (hits.length !== 1) return;
    const [qi, ai] = hits[0];
    plan[qi].matches[ai] = { secIdx: si, ttmIdx: ti, cross: true };
    p.claimed.add(ti);
  }));
  return plan;
}

// 📊 KEY METRIC TILE (Mark 10-07, Concise CFO): every tile on the owner
// presentation answers its own next question — the PERIOD and SOURCE under the
// number, and an ⓘ with a plain-English answer: what it is · this business's
// numbers behind it · good or bad. Owner-safe wording only (it's screen-shared).
// Values are never computed here — the tile only explains keyMetrics.
const MetricTile = ({ label, value, valueClass = 'text-gray-800', short = null, sub = null, period, source, explain, align = 'center', tone = 'bg-gray-50', labelTitle }) => {
  const [open, setOpen] = useState(false);
  const pos = align === 'left' ? 'left-0' : align === 'right' ? 'right-0' : 'left-1/2 -translate-x-1/2';
  return (
    <div className={`relative text-center p-2 rounded ${tone}`}>
      <div className="text-xs font-bold text-gray-800 flex items-center justify-center gap-1" title={labelTitle}>
        <span>{label}</span>
        {explain && (
          <button type="button" onClick={() => setOpen(o => !o)} className="text-gray-400 hover:text-gray-700 leading-none" title="What is this? How is it calculated?" aria-label={`Explain ${label}`}>ⓘ</button>
        )}
      </div>
      <div className={`text-lg font-bold ${valueClass}`}>{value}</div>
      {short && <div className="text-[10px] text-gray-600 leading-tight">{short}</div>}
      {sub}
      {period && <div className="text-[10px] text-gray-400 leading-tight mt-0.5">{period}</div>}
      {source && <div className="text-[10px] text-gray-400 leading-tight italic">Source: {source}</div>}
      {open && explain && (
        <div className={`absolute top-full mt-1 ${pos} z-30 w-80 text-left bg-white border border-gray-300 rounded-lg shadow-lg p-3 text-xs text-gray-700`}>
          <div className="flex justify-between items-start mb-1">
            <span className="font-semibold text-gray-800">{label}</span>
            <button type="button" onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-700 ml-2">✕</button>
          </div>
          {explain.what && <p className="mb-1.5"><b>What it is:</b> {explain.what}</p>}
          {explain.here && <p className="mb-1.5"><b>This business:</b> {explain.here}</p>}
          {explain.good && <p className="mb-1.5"><b>Good or bad:</b> {explain.good}</p>}
          {(period || source) && <p className="text-gray-500"><b>Period:</b> {period || '—'}{source ? <> · <b>Source:</b> {source}</> : null}</p>}
        </div>
      )}
    </div>
  );
};

// ⏰ Reminders you set — Colleen/Konnie (10-07). Self-sufficient card: the
// business, the contact + phone/email, who holds it, your note, one row of buttons.
const MyRemindersSection = ({ items, onAct }) => (
  <div className="mb-6">
    <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-indigo-700">
      ⏰ Reminders you set <span className="text-gray-400 font-normal">({items.length})</span>
    </h2>
    <p className="text-xs text-gray-400 mb-3">Due today or earlier. Done → ✓ · someone else should do it → ↪ Hand to them · not yet → ⏰ New date · not worth it → ✕ Drop. New ones: ⏰ Set reminder on any Sales Engine record.</p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {items.map(c => {
        const o = c.se_owners || {};
        const email = Array.isArray(o.emails) ? o.emails[0] : null;
        const days = Math.floor((Date.now() - new Date(c.due + 'T00:00:00').getTime()) / 86400000);
        return (
          <div key={c.id} className="bg-white border border-indigo-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-2">
              <div className="font-semibold text-gray-800">{o.company_name}</div>
              <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded whitespace-nowrap ${days > 0 ? 'bg-red-50 text-red-700' : 'bg-indigo-50 text-indigo-700'}`}>{days > 0 ? `${days}d overdue` : 'due today'}</span>
            </div>
            <div className="text-xs text-gray-600 mt-1">
              {o.contact_name || 'No contact name'}
              {o.phone && <> · <a href={`tel:${o.phone}`} className="text-indigo-700">{o.phone}</a></>}
              {email && <> · <a href={`mailto:${email}`} className="text-indigo-700">{email}</a></>}
              {o.assigned_to && <span className="text-gray-400"> · held by {o.assigned_to}</span>}
            </div>
            <div className="text-sm text-gray-800 mt-2">📌 {c.note || 'Reach out'}</div>
            {(() => {
              // Did anyone follow up? (oversight reminders — Mark 10-07)
              const last = [o.last_outbound_at, o.last_touch_at, o.last_meeting_at].filter(Boolean).sort().pop();
              const since = last && last >= c.created_at;
              return <div className={`text-xs mt-1 ${since ? 'text-emerald-700' : 'text-amber-700'}`}>{last ? `Last contact with the owner: ${String(last).slice(0, 10)}${since ? ' (after you set this)' : ' — nothing since you set this'}` : 'No contact with the owner on record'}</div>;
            })()}
            <div className="text-[11px] text-gray-400 mt-1">Set {String(c.created_at).slice(0, 10) < '2026-07-29' ? 'in Zoho (imported)' : String(c.created_at).slice(0, 10)} · due {c.due}</div>
            <div className="flex flex-wrap gap-2 mt-3">
              <button type="button" onClick={() => onAct(c, 'done')} className="px-2 py-1 text-xs font-semibold rounded bg-indigo-600 text-white hover:bg-indigo-700">✓ Done</button>
              <button type="button" onClick={() => onAct(c, 'handoff')} className="px-2 py-1 text-xs font-semibold rounded border border-indigo-300 text-indigo-700 hover:bg-indigo-50" title="Pick Adam, Thatcher or Zac — it lands on their My Work today with your note, and yours closes.">↪ Hand to {['Adam', 'Thatcher', 'Zac'].includes(o.assigned_to) ? o.assigned_to : '…'}</button>
              <button type="button" onClick={() => onAct(c, 'later')} className="px-2 py-1 text-xs font-semibold rounded border border-gray-300 text-gray-700 hover:bg-gray-50">⏰ New date</button>
              <button type="button" onClick={() => onAct(c, 'drop')} className="px-2 py-1 text-xs font-semibold rounded border border-gray-300 text-gray-500 hover:bg-gray-50">✕ Drop</button>
              <a href={`/sales-engine#owner=${o.id}`} target="_blank" rel="noreferrer" className="px-2 py-1 text-xs text-gray-500 hover:text-gray-700">Open record ↗</a>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

const MeetingsTodaySection = ({ items, prep, onLog, onTypeChange, onOpenValuation, onTieBuyer, actor }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-sky-700">
        📅 Meeting prep — today <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">Everything you need to walk in — the deal or the buyer across the table, what we said last time, what we owe them, and the Fireflies recap on demand. <span className="text-gray-500">ℹ️ Informational only — nothing to clear; it falls off after today.</span> Log the outcome after a meeting that's already happened.</p>
      <div className="space-y-2">
        {items.map(mt => (
          <MeetingPrepCard key={mt.id} mt={mt} pr={(prep && prep[mt.id]) || null} onLog={onLog} onTypeChange={onTypeChange} onOpenValuation={onOpenValuation} onTieBuyer={onTieBuyer} />
        ))}
      </div>
    </div>
  );
};

// Held meetings collapse (Adam, parked 09-22 → Mark's go 09-28): once a
// meeting has ENDED its prep card shrinks to one grey line — the plate stays
// about what's still ahead. One click brings the full card back (logging lives
// there, and in "No notes — did this meeting happen").
const MeetingPrepCard = (props) => {
  const { mt, pr } = props;
  const [open, setOpen] = useState(false);
  const endMs = mt.ends_at ? new Date(mt.ends_at).getTime() : new Date(mt.starts_at).getTime() + 60 * 60000;
  const ended = mt._day !== 'tomorrow' && endMs <= Date.now();
  if (!ended || open) return <MeetingPrepCardFull {...props} />;
  const o = mt.owner || {};
  const who = o.company_name || (pr && pr.buyer && pr.buyer.name) || mt.summary || 'Meeting';
  const t = new Date(mt.starts_at).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  const outcome = mt.outcome === 'held' ? '✓ held' : mt.outcome === 'no_show' ? 'no-show' : 'ended';
  return (
    <button type="button" onClick={() => setOpen(true)} title="Meeting is over — click to show the prep card"
      className="w-full text-left text-xs text-gray-400 bg-gray-50 border border-gray-200 rounded px-3 py-1.5 hover:bg-gray-100">
      {t} · {who} — {outcome} <span className="text-gray-300">· show prep ▸</span>
    </button>
  );
};

const MeetingPrepCardFull = ({ mt, pr, onLog, onTypeChange, onOpenValuation, onTieBuyer }) => {
  // Strategic reviews open the Fireflies recap inline by default (Mark 09-16) —
  // the prior plan + action items are the whole point of walking in prepared.
  // Other meeting types keep it one click, so the plate stays fast.
  const isStrategicType = mt.meeting_type === 'strategic_review';
  // Notes start HIDDEN (Mark 09-17) — the recap is one click when you want it,
  // not clutter on every card. (autoExpandFirst still opens the recap on reviews
  // once you reveal the panel.)
  const [showNotes, setShowNotes] = useState(false);
  // Show how the system categorized this meeting, with a one-click fix if it's
  // wrong (Mark 09-17). Doubles as the running categorization audit.
  const [fixType, setFixType] = useState(false);
  const [showAllQA, setShowAllQA] = useState(false);   // discovery answers: first 5, then all
  const o = mt.owner || {};
  const fmtTime = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  const money = (n) => (n == null || n === '' || isNaN(Number(n))) ? null : '$' + Math.round(Number(n)).toLocaleString();
  const fmtDate = (d) => d ? new Date(String(d).length === 10 ? d + 'T00:00:00' : d).toLocaleDateString() : null;
  const started = new Date(mt.starts_at).getTime() <= Date.now();
  const isFuture = mt._day === 'tomorrow' || !started;   // pure prep — no log affordance
  const emails = (mt.external_emails || []).filter(Boolean);
  const val = pr && pr.val;
  const note = pr && pr.note;
  const owe = (pr && pr.owe) || [];
  const buyer = pr && pr.buyer;   // the buyer across the table (buyside/deal meetings)
  const dqa = pr && pr.discoveryQA;   // the owner's discovery-questionnaire answers (discovery meetings)
  const isStrategic = isStrategicType;
  const where = [];
  if (val) {
    if (val.workflow_stage) where.push(stageLabel(val.workflow_stage));
    if (val.path) where.push(val.path === 'full_valuation' ? 'Full' : val.path === 'partial' ? 'Partial' : val.path);
  } else {
    if (o.tier) where.push(o.tier);
    if (o.disposition) where.push(o.disposition);
  }
  // A blank/zero value_provided means "not recorded," never a real $0 valuation
  // — don't surface a misleading "$0" (Mark 09-16, Smart Technology had 0).
  const pos = (n) => (n != null && n !== '' && !isNaN(Number(n)) && Number(n) > 0) ? Number(n) : null;
  const valLo = val && pos(val.value_provided_low);
  const valHi = val && pos(val.value_provided_high);
  const valueLine = valHi ? ((valLo && valLo !== valHi) ? `${money(valLo)}–${money(valHi)}` : money(valHi)) : null;
  // Strategic-review prep (Mark 09-17): show WHEN we last valued (even if the
  // amount wasn't recorded), and the review cadence (months from that valuation
  // to this review) — the "did we agree to revalue at 6 or 12 months?" answer.
  const monthsBetween = (a, b) => { if (!a || !b) return null; const d1 = new Date(a), d2 = new Date(b); if (isNaN(d1) || isNaN(d2)) return null; const m = (d2.getFullYear() - d1.getFullYear()) * 12 + (d2.getMonth() - d1.getMonth()); return m > 0 ? m : null; };
  const cadenceMo = isStrategicType && val ? monthsBetween(val.valuation_date, mt.starts_at) : null;
  // Log outcome writes an se_touch keyed on the owner — only offer it when the
  // meeting is matched to a seller record (a buyer/deal meeting has no owner).
  const doLog = (onLog && o.id) ? () => onLog({ ...o, _why: `${mt._day === 'today' ? "Today's" : "Tomorrow's"} ${MEETING_TYPE_LABEL[mt.meeting_type] || ''} meeting at ${fmtTime(mt.starts_at)} — log it while it's fresh.` }) : null;
  const logged = o.last_touch_at && o.last_touch_at >= mt.starts_at;
  // 📏 Size-floor reminder, first-time meetings only (Mark 10-19): the playbook's "ask revenue / profit early,
  // stop if they're too small", with what the record already says.
  const floorLine = (() => {
    if (mt.meeting_type !== 'first_time' || !o.id) return null;
    const f = QUAL_FLOORS.find(x => x.key === (qualFloorKeyFor(o) || 'most'));
    const rev = pos(o.size_revenue), eb = o.ebitda != null && o.ebitda !== '' ? Number(o.ebitda) : null, np = o.net_profit != null && o.net_profit !== '' ? Number(o.net_profit) : null;
    const profit = eb != null ? eb : np;
    const known = [rev ? `${qualMoney(rev)} revenue` : null, eb != null ? `${qualMoney(eb)} EBITDA` : (np != null ? `${qualMoney(np)} net profit` : null), pos(o.size_employees) ? `${o.size_employees} employees` : null].filter(Boolean);
    const under = profit != null && profit < f.floor;
    return { f, known, under, noProfit: profit == null };
  })();
  return (
    <div className={`bg-white border rounded-lg p-3 ${mt._day === 'today' ? 'border-sky-200' : 'border-gray-200'}`}>
      {floorLine && (
        <div className={`text-xs mb-1.5 rounded px-2 py-1 border ${floorLine.under ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-indigo-50 border-indigo-100 text-indigo-900'}`}>
          📏 <b>Size floor: {qualMoney(floorLine.f.floor)} EBITDA</b> <span className="text-gray-500">({floorLine.f.label.replace(/ \(.*\)$/, '')})</span>
          {' · '}{floorLine.known.length ? <>On record: {floorLine.known.join(', ')}</> : 'Nothing on record'}
          {floorLine.under ? <b> · ⚠ under the floor: confirm early</b> : floorLine.noProfit ? <span> · ask revenue and profit early</span> : null}
        </div>
      )}
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          {/* The owner's name: the VT file wins once a valuation is linked (Adam
              09-24, HonorBound: the SE record still carried "Alan Herberger" from
              the Zoho import while Setup said Greg Fyn — staff maintain the VT
              name, the import doesn't). SE contact is the fallback. */}
          <div className="text-sm font-medium text-gray-800">{o.company_name || mt.summary || 'Meeting'}{(() => {
            const vtName = val && [val.owner_first_name, val.owner_last_name].filter(Boolean).join(' ').trim();
            const who = vtName || o.contact_name;
            return o.company_name && who ? <span className="text-gray-400 font-normal"> · {who}</span> : null;
          })()}</div>
          <div className="text-xs text-gray-500 mt-0.5">
            <span className={`font-semibold ${mt._day === 'today' ? 'text-sky-700' : 'text-gray-500'}`}>{mt._day === 'today' ? 'Today' : 'Tomorrow'}</span> {fmtTime(mt.starts_at)} · <span className="font-bold text-gray-700">Meeting type:</span> {onTypeChange && fixType ? (
              <select value={MT_TYPE_OPTIONS.some(([k]) => k === mt.meeting_type) ? mt.meeting_type : 'other'}
                autoFocus onBlur={() => setFixType(false)}
                onChange={e => { onTypeChange(mt, e.target.value); setFixType(false); }}
                className="text-xs border border-violet-300 rounded px-1 py-0.5">
                {MT_TYPE_OPTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            ) : (
              <span><span className="font-bold text-gray-700">{MEETING_TYPE_LABEL[mt.meeting_type] || 'Meeting'}</span>{onTypeChange && (
                <button type="button" onClick={() => setFixType(true)} className="ml-1 text-[10px] text-violet-600 underline font-normal" title="Not the right type? Fix how this meeting was categorized.">fix</button>
              )}</span>
            )}
            {mt.summary && o.company_name ? <span className="text-gray-400 italic"> · “{mt.summary}”</span> : null}
          </div>
        </div>
        {logged && !isFuture && <span className="text-[10px] font-bold uppercase bg-emerald-50 text-emerald-700 border border-emerald-200 rounded px-1.5 py-0.5 whitespace-nowrap" title="Activity was logged after this meeting started.">✓ logged</span>}
      </div>
      <div className="mt-2 space-y-1 text-xs">
        {where.length > 0 && <div><span className="text-gray-400">Where we are:</span> <span className="text-gray-700">{where.join(' · ')}</span></div>}
        {pr && (pr.selfBooked || pr.web) && (() => {
          const w = (pr.web && pr.web.meta) || {};
          const pa = w.portal_answers || {};
          const bits = [
            w.description && ['What they do', w.description],
            w.revenue && ['Revenue', w.revenue],
            pa[1] && ['Why selling / timeline', pa[1]],
            pa[17] && ['Exit or stay', pa[17]],
            w.message && ['Their message', w.message],
            w.readiness && ['Readiness checklist', (w.readiness.worth_a_look || []).length ? 'worth a look: ' + w.readiness.worth_a_look.join(', ') : 'nothing flagged'],
            w.website && ['Website', w.website],
          ].filter(Boolean);
          return (
            <div className="bg-sky-50 border border-sky-200 rounded px-2 py-1.5">
              {pr.selfBooked && <div className="font-bold text-sky-800">📅 Self-booked online by the owner{pr.web ? ' after a website ' + (w.form === 'worth' ? 'valuation request' : 'form') : ''}: no email chain, so here is what they told us.</div>}
              {pr.web && <div className="text-gray-500">🌐 From the website{pr.web.at ? ', ' + new Date(pr.web.at).toLocaleDateString() : ''}{w.source && w.source.campaign ? ' (from the email “' + w.source.campaign + '”)' : ''}:</div>}
              {bits.map(([k, v]) => <div key={k}><span className="text-gray-400">{k}:</span> <span className="text-gray-800">{String(v).slice(0, 400)}</span></div>)}
            </div>
          );
        })()}
        {buyer && (
          <div><span className="text-gray-400">Buyer:</span> <span className="text-gray-800 font-medium">{buyer.company_name || buyer.contact_name || '—'}</span>
            {buyer.company_name && buyer.contact_name ? <span className="text-gray-500"> · {buyer.contact_name}</span> : ''}
            {buyer.bsa_signed ? <span className="text-emerald-600"> · BSA ✓</span> : <span className="text-red-600 font-semibold"> · ⚠ no BSA</span>}
            {buyer.willing_buyside_fees ? <span className="text-gray-400"> · fees ✓</span> : ''}
            {pr && pr.pair && (() => { const S = BUYSIDE_STEPS.find(x => x.kind === pr.pair.kind); return <div className="text-violet-700 mt-0.5"><span className="text-gray-400">Buyside pair:</span> {S ? S.label : pr.pair.kind}{pr.pair.at ? <span className="text-gray-400"> · {fmtDate(pr.pair.at)}</span> : null} <span className="text-gray-400">— tracked on your Buyside board</span></div>; })()}
            {buyer.qualifications ? <div className="text-gray-500 mt-0.5"><span className="text-gray-400">Hunting:</span> {String(buyer.qualifications).slice(0, 160)}</div> : null}</div>
        )}
        {mt.meeting_type === 'discovery' && dqa && (
          <div className="mt-1 border border-sky-100 bg-sky-50/60 rounded px-2 py-1.5">
            <div className="flex items-center justify-between">
              <span className="font-semibold text-sky-800">📋 Discovery answers <span className="font-normal text-gray-500">({dqa.answered.length} of {dqa.total})</span></span>
              {dqa.answered.length > 5 && <button type="button" onClick={() => setShowAllQA(s => !s)} className="text-[10px] text-sky-700 underline">{showAllQA ? 'show fewer' : `show all ${dqa.answered.length}`}</button>}
            </div>
            {dqa.answered.length === 0
              ? <div className="text-gray-500 mt-0.5">Questionnaire not started — nothing to read yet.</div>
              : <div className="mt-1 space-y-1">
                  {(showAllQA ? dqa.answered : dqa.answered.slice(0, 5)).map(q => (
                    <div key={q.id} title={`${q.question}\n\n${q.answer}`}>
                      <div className="text-gray-500 leading-tight">{q.question}</div>
                      <div className="text-gray-800 leading-snug">{q.answer.length > 180 ? q.answer.slice(0, 180) + '…' : q.answer}</div>
                    </div>
                  ))}
                </div>}
          </div>
        )}
        {isStrategic && val && val.valuation_date && (
          <div><span className="text-gray-400">Last valued:</span> <span className="text-gray-800 font-medium">{fmtDate(val.valuation_date)}</span>
            {valueLine ? <span className="text-gray-700"> · {valueLine}</span> : <span className="text-gray-400"> · amount not recorded</span>}
            {cadenceMo ? <span className="text-gray-400"> · {cadenceMo} mo ago</span> : ''}</div>
        )}
        {note && <div><span className="text-gray-400">{isStrategic ? 'Prior plan:' : 'Last time:'}</span> <span className="text-gray-700">{note.subject}</span> <span className="text-gray-400">· {fmtDate(note.at)}</span></div>}
        {owe.length > 0 && <div><span className="text-amber-600 font-semibold">You owe:</span> <span className="text-gray-700">{owe.map(c => `${c.note || 'follow-up'}${c.due ? ` (${fmtDate(c.due)})` : ''}`).join('; ')}</span></div>}
        {emails.length > 0 && <div><span className="text-gray-400">In the room:</span> <span className="text-gray-600">{emails.join(', ')}</span></div>}
        {/* The two outcomes that count (Mark 09-21: the Lead forgets to set the
            review while he has the owner on the line) — last thing read before
            the dial. */}
        {mt.meeting_type === 'valuation_meeting' && <div className="text-amber-800 font-semibold bg-amber-50 border border-amber-200 rounded px-2 py-1">Close the call with one of two things: an engagement, or a strategic-review date on the calendar. Nothing else counts as done.</div>}
        {isStrategic && <div className="text-gray-400 italic">Confirm: their sell timing / price target, and the next revalue window (6 or 12 mo) — details in the recap below.</div>}
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-2">
        {/* A valued client preps from the VT deal record, not the SE prospect page
            (Mark 09-17). Opens the deal in a NEW tab via the ?valuation deep link. */}
        {val && val.id && (
          <a href={`/?valuation=${encodeURIComponent(val.id)}`} target="_blank" rel="noopener" className="text-xs px-2 py-1 rounded bg-violet-600 text-white hover:bg-violet-700">📂 Open in VT ↗</a>
        )}
        {o.id && <a className="text-xs text-violet-700 underline" href={`/sales-engine?owner=${encodeURIComponent(o.id)}`} target="_blank" rel="noopener">{val && val.id ? 'SE record' : 'Open record'}</a>}
        {/* The universal toolbar (Adam 09-25, Halo Global: "how do I add notes
            to this card?" — the prep card had Fireflies notes and links but no
            🗒 Notes / 🧵 Thread / ↗ Account of its own). */}
        {(o.id || (val && val.id)) && <CardToolbar ownerId={o.id || null} valuationId={(val && val.id) || null} companyName={o.company_name || mt.summary || 'this business'} actor={CARD_ACTOR_NAME} />}
        {/* Path 2 of the one door (Mark 09-17): the owner said "bring me a buyer" in
            this meeting — tie them to a buyside client from here, owner pre-filled. */}
        {o.id && onTieBuyer && !isFuture && !(pr && pr.pair) && (
          <button type="button" onClick={() => onTieBuyer({ id: o.id, company_name: o.company_name, contact_name: o.contact_name })} className="text-xs px-2 py-1 rounded border border-violet-300 text-violet-700 hover:bg-violet-50" title="They want a buyer — tie this owner to one of our buyside clients (opens the New buyside match form with this business filled in).">🤝 Tie to a buyer</button>
        )}
        {emails.length > 0 && (
          <button type="button" onClick={() => setShowNotes(s => !s)} className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">🎙 {showNotes ? 'Hide notes' : 'Meeting notes'}</button>
        )}
        {!isFuture && doLog && (
          <button type="button" onClick={doLog} className={`ml-auto text-xs px-2 py-1 rounded ${logged ? 'border border-gray-300 text-gray-600 hover:bg-gray-50' : 'bg-sky-600 text-white hover:bg-sky-700'}`}>{logged ? 'Adjust log' : 'Log outcome'}</button>
        )}
      </div>
      {showNotes && emails.length > 0 && (
        <div className="mt-2"><FirefliesNotesPanel ownerEmail={emails[0]} additionalEmails={emails.slice(1)} autoExpandFirst={isStrategic} overviewOnly={true} /></div>
      )}
    </div>
  );
};

const MT_HOLDER_NAMES = ['Mark', 'Zac', 'Thatcher', 'Adam', 'Colleen'];
const MeetingTruthSection = ({ items, onHeld, onHeldAll, onNoShow, onTypeChange, onHandOff, onRemind, actor }) => {
  // ⏰ inline reminder — set a date right on the card (Mark 09-15) instead of
  // opening the deal to do it. Defaults to +7 days. (Hooks before any early
  // return — Rules of Hooks.)
  const [remindId, setRemindId] = React.useState(null);
  const [remindDate, setRemindDate] = React.useState('');
  const plusDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
  if (!items || items.length === 0) return null;
  const fmtWhen = (iso) => new Date(iso).toLocaleString(undefined, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  const typeLabel = { first_time: 'Sellside 1st-time', bsc_interest: 'BSC interest', buyside_intro: 'Buyside intro', listing: 'Listing (legacy)', reengage: 'Sellside re-engage', buyside_call: 'Buyside pitch', buyer_relationship: 'Buyer relationship', discovery: 'Discovery', valuation_meeting: 'Valuation meeting', strategic_review: 'Strategic review', other: 'Meeting' };
  // The confirm moment is the one place a human who was IN the meeting
  // touches the record (Mark 08-12) — so the category gets confirmed here
  // too. The auto-guess only knows first-time/re-engage/buyside-intro;
  // BSC-interest and listing meetings only exist when a human says so.
  const TYPE_OPTIONS = [
    ['first_time', 'Sellside 1st-time'], ['reengage', 'Sellside re-engage'],
    ['discovery', 'Discovery'], ['valuation_meeting', 'Valuation meeting'],
    ['bsc_interest', 'BSC interest'], ['buyside_intro', 'Buyside intro'], ['buyside_call', 'Buyside pitch'],
    // 'listing' retired 09-01 (a listing discussion IS the 1st-time meeting);
    // kept selectable so legacy-typed rows display honestly.
    ['listing', 'Listing (legacy)'],
    // strategic_review (08-27): the valuation department's review calls —
    // attributed and carded, deliberately NOT a lead-gen metrics series.
    ['strategic_review', 'Strategic review'],
    // Deal process (Zac 09-22: a buyer under LOI on Workstate typed "Sellside
    // 1st-time"; the 10th QNS–K12MT buyside call typed "BSC interest") — pick
    // it and the card clears; the server's series heal retypes the siblings.
    ['deal_process', 'Deal process — buyer/seller meeting on a listing or buyside deal'],
    ['other', 'Other'],
  ];
  // GROUPED BY RELATIONSHIP (Mark 09-18, Zac's plate: three NIC meetings
  // were three cards asking one question). One card per owner / deal; each
  // meeting is its own row with its own type + held / didn't-happen, and
  // "All held" confirms the lot and opens the outcome modal ONCE.
  const groups = [];
  const byKey = new Map();
  items.forEach(mt => {
    // The DEAL is the relationship when there is one (09-22: NIC's three
    // meetings sat on two owner records + one deal-only row and never grouped).
    const key = mt.valuation_id || mt.owner_id || mt.id;
    let g = byKey.get(key);
    if (!g) { g = { key, mts: [] }; byKey.set(key, g); groups.push(g); }
    g.mts.push(mt);
  });
  const isNoOutcomeType = (mt) => mt.meeting_type === 'buyside_intro' || mt.meeting_type === 'buyside_call' || mt.meeting_type === 'strategic_review';
  // The type control, labelled in bold so it can't be missed (Mark 09-18:
  // "did this happen AND is the meeting type correct").
  const renderType = (mt) => onTypeChange ? (
    <select value={TYPE_OPTIONS.some(([k]) => k === mt.meeting_type) ? mt.meeting_type : 'other'}
      onChange={e => onTypeChange(mt, e.target.value)}
      className="text-xs border border-amber-300 rounded px-1 py-0.5 text-gray-700 bg-amber-50 font-semibold"
      title="Meeting category — feeds the committee's monthly meeting metrics. The system auto-guessed; correct it here while you're confirming.">
      {TYPE_OPTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
    </select>
  ) : <span className="font-semibold">{typeLabel[mt.meeting_type] || 'Meeting'}</span>;
  const heldLabel = (mt) => isNoOutcomeType(mt) ? '✓ Held' : '✓ Held — log outcome';
  const heldTitle = (mt) => (mt.meeting_type === 'buyside_intro' || mt.meeting_type === 'buyside_call')
    ? 'Buyside meeting — confirms it held, with an optional note to the owner\'s history. (Full buyside outcome tracking arrives with the mandate build.)'
    : mt.meeting_type === 'strategic_review'
    ? 'Strategic review — confirms it held and asks for the outcome in ONE required sentence (what came of it, what\'s next). No disposition pick: review outcomes are valuation-workflow vocabulary, and the sentence is the record.'
    : 'It happened — mark held and log the outcome. The outcome is YOUR part (the transcript is Fireflies\'s, when it was on the call); phone-handoff meetings with no Fireflies count this way too.';
  return (
    <div className="mb-6">
      <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-amber-700">
        🗓 No notes — did this meeting happen, and is the type right? <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      <p className="text-xs text-gray-400 mb-3">Booked meetings whose time passed with no transcript matched, no outcome logged, and no stage change. <b className="text-gray-600">Two things per card:</b> <b className="text-gray-600">① check the Meeting type</b> — the system guessed it, and the committee's meeting numbers come from it — fix it first; <b className="text-gray-600">② say whether it happened.</b> <span className="text-gray-500">Fireflies owns the transcript when it's on the call — never retype what it heard. Your part is the <b>outcome</b> (what you decided, what's next) plus anything the mic couldn't catch.</span></p>
      <p className="text-xs text-emerald-700 font-semibold mb-3">💰 Why this matters: each card is an owner you already got a meeting with. Closing it out sets the next step, so the deal keeps moving toward a listing and your commission instead of slipping.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {groups.map(g => {
          const first = g.mts[0];
          const multi = g.mts.length > 1;
          const company = (first.owner && first.owner.company_name) || first.summary || 'Meeting';
          const place = first.owner && (first.owner.city || first.owner.state) ? [first.owner.city, first.owner.state].filter(Boolean).join(', ') : '';
          const remindable = onRemind && (first.valuation_id || (first.owner && first.owner.id));
          return (
          <div key={g.key} className="bg-white border border-amber-300 rounded-lg p-3">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-semibold text-gray-800 text-sm truncate">{company}{place ? <span className="font-normal text-gray-400"> · {place}</span> : null}</div>
                {multi && <div className="text-xs text-amber-700 mt-0.5">{g.mts.length} meetings with no notes — confirm each row, or all at once below.</div>}
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className="text-[10px] font-bold uppercase tracking-wide bg-amber-100 text-amber-800 rounded px-1.5 py-0.5 whitespace-nowrap">No notes{multi ? ` ×${g.mts.length}` : ''}</span>
                {onHandOff && (
                  <select value="" onChange={e => { if (e.target.value) g.mts.forEach(mt => onHandOff(mt, e.target.value)); }}
                    className="text-[11px] border border-gray-200 rounded px-1 py-0.5 text-gray-500 bg-white"
                    title={multi ? 'Someone else was in these meetings? Hand the whole card to them — it moves off your plate onto theirs.' : 'Someone else was in this meeting? Hand the card to them — it moves off your plate onto theirs, permanently for this meeting.'}>
                    <option value="">↷ not mine…</option>
                    {MT_HOLDER_NAMES.filter(n => n !== actor).map(n => <option key={n} value={n}>hand to {n}</option>)}
                  </select>
                )}
              </div>
            </div>
            <div className={multi ? 'mt-2 border border-amber-100 rounded divide-y divide-amber-100' : 'mt-1'}>
              {g.mts.map(mt => (
                <div key={mt.id} className={multi ? 'px-2 py-1.5' : ''}>
                  <div className="text-xs text-gray-600 flex items-center gap-1.5 flex-wrap">
                    <span className="font-bold text-gray-700">Meeting type:</span>
                    {renderType(mt)}
                    <span className="text-gray-500">· {fmtWhen(mt.starts_at)}</span>
                    {multi && (
                      <span className="ml-auto flex items-center gap-1">
                        <button type="button" className="text-[11px] px-1.5 py-0.5 rounded bg-emerald-600 text-white hover:bg-emerald-700" title={heldTitle(mt)} onClick={() => onHeld(mt)}>{heldLabel(mt)}</button>
                        <button type="button" className="text-[11px] px-1.5 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50" title="This one didn't happen — recorded for the meeting metrics." onClick={() => onNoShow(mt, null)}>✗ Didn’t happen</button>
                      </span>
                    )}
                  </div>
                  {mt.owner && mt.summary && <div className="text-xs text-gray-400 mt-0.5 truncate" title={mt.summary}>“{mt.summary}”</div>}
                  {mt._declined && <div className="text-xs text-red-700 font-semibold mt-0.5">📭 The owner declined this invite, so it most likely didn’t happen.</div>}
                  {mt._rebooked && <div className="text-xs text-emerald-700 font-semibold mt-0.5">📅 Already rebooked: {fmtWhen(mt._rebooked.starts_at)}{multi ? <button type="button" className="ml-2 text-[11px] px-1.5 py-0.5 rounded bg-emerald-600 text-white hover:bg-emerald-700" onClick={() => onNoShow(mt, 'rebooked')}>✓ Didn’t happen, already rebooked</button> : null}</div>}
                </div>
              ))}
            </div>
            <div className="flex flex-wrap justify-end gap-2 mt-2">
              {(first.owner || first.valuation_id) && <CardToolbar className="mr-auto" ownerId={first.owner ? first.owner.id : null} valuationId={first.valuation_id || null} companyName={company} actor={actor} />}
              {multi ? (
                <button type="button" className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700"
                  title="All of these happened — confirms every meeting on this card and opens the outcome form once (nothing is written until you save it)."
                  onClick={() => (onHeldAll ? onHeldAll(g.mts) : g.mts.forEach(mt => onHeld(mt)))}>✓ All {g.mts.length} held — log outcome once</button>
              ) : (
                <React.Fragment>
                  {first._rebooked && (
                    <button type="button" className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700 font-semibold"
                      title="Records this one as didn't happen and keeps the new meeting. No reschedule email goes out; the deal's discovery date moves to the new day."
                      onClick={() => onNoShow(first, 'rebooked')}>✓ Didn’t happen, already rebooked for {new Date(first._rebooked.starts_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}</button>
                  )}
                  <button type="button" className={first._rebooked || first._declined ? 'text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50' : 'text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700'} title={heldTitle(first)} onClick={() => onHeld(first)}>{heldLabel(first)}</button>
                  {first.owner && !isNoOutcomeType(first) ? (
                    <React.Fragment>
                      <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                        title={"No-show, still worth chasing — send the reschedule note now (that's email 1) and the scheduling cadence takes over: tomorrow, then 1d → 7d → 30d."}
                        onClick={() => onNoShow(first, 'rebook')}>↩ Didn’t happen — rebook</button>
                      <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                        title={"Done chasing (several misses, or not a fit): \"You didn't make the meeting — please let me know if you'd like to reschedule.\" Parks the owner; the ball is in their court."}
                        onClick={() => onNoShow(first, 'release')}>🕊 Didn’t happen — release</button>
                    </React.Fragment>
                  ) : (
                    <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                      title="No-show — recorded for the meeting metrics."
                      onClick={() => onNoShow(first, null)}>✗ Didn’t happen</button>
                  )}
                </React.Fragment>
              )}
              {remindable && (
                <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50"
                  title="Not now — set a reminder to come back to this, without leaving the card."
                  onClick={() => { setRemindId(remindId === g.key ? null : g.key); setRemindDate(plusDays(7)); }}>⏰ Remind me</button>
              )}
              {/* Zac 10-29: a buyer's catch-up on a sellside deal (Quandary) carded as an owner meeting. One click
                  types it Deal process, which never cards here and never counts in the committee numbers. */}
              {onTypeChange && (
                <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50"
                  title="Not an owner meeting: a buyer or deal-process call on a listing or buyside deal. Sets Meeting type to Deal process; the card leaves and it never counts in the committee meeting numbers."
                  onClick={() => g.mts.forEach(mt => onTypeChange(mt, 'deal_process'))}>🤝 Buyer / deal meeting</button>
              )}
            </div>
            <div className="text-[11px] text-gray-500 mt-1.5 leading-snug">
              <b className="text-gray-600">Where this card goes:</b>{' '}
              {onTypeChange ? <span>🤝 Buyer / deal meeting → not an owner meeting; the card leaves and it isn't counted. </span> : null}
              {first._rebooked ? <span>✓ already rebooked → the card leaves; the new meeting shows on 📅 Today’s meetings that morning. </span> : null}
              <span>✓ Held → the outcome form opens; the card leaves when you save, and your next step comes back as its own card. </span>
              {!multi && first.owner && !isNoOutcomeType(first) ? <span>↩ Rebook → the card leaves; a follow-up card comes back tomorrow until they book. 🕊 Release → the card leaves; the owner is parked until they reach out. </span> : <span>✗ Didn’t happen → the card leaves. </span>}
              {remindable ? <span>⏰ Remind me → the card leaves and comes back on the date you pick. </span> : null}
              <span>The business itself never goes away: 🔎 Find a business at the top of My Work.</span>
            </div>
            {remindId === g.key && (
              <div className="flex flex-wrap items-center justify-end gap-2 mt-2 bg-gray-50 border border-gray-200 rounded px-2 py-1.5">
                <span className="text-[11px] text-gray-500 mr-auto">Remind me on:</span>
                <button type="button" className="text-[11px] px-1.5 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-white" onClick={() => setRemindDate(plusDays(3))}>+3d</button>
                <button type="button" className="text-[11px] px-1.5 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-white" onClick={() => setRemindDate(plusDays(7))}>+1wk</button>
                <button type="button" className="text-[11px] px-1.5 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-white" onClick={() => setRemindDate(plusDays(30))}>+1mo</button>
                <input type="date" value={remindDate} onChange={e => setRemindDate(e.target.value)}
                  className="text-[11px] border border-gray-300 rounded px-1 py-0.5" />
                <button type="button" disabled={!remindDate}
                  className="text-[11px] px-2 py-0.5 rounded bg-gray-700 text-white font-semibold hover:bg-gray-800 disabled:bg-gray-300"
                  onClick={() => { onRemind(first, remindDate); setRemindId(null); }}>Set</button>
              </div>
            )}
          </div>
          );
        })}
      </div>
    </div>
  );
};

// ✉ The card's email = the address the conversation actually uses (Adam 10-30, ProCirrus: the card showed the first
// of three on file, dan@, but every synced email was dan.shelton@). One-address owners skip the lookup. Otherwise the
// newest synced email for the business picks the on-file address it went to or came from (cached per page load);
// none on file in the mail → the first address, as before.
const _ownerEmailPick = new Map();
const OwnerEmailLink = ({ owner, fallback }) => {
  const list = Array.isArray(owner && owner.emails) ? owner.emails.filter(Boolean) : [];
  const [em, setEm] = useState(() => _ownerEmailPick.get(owner && owner.id) || fallback);
  useEffect(() => {
    if (!supabaseClient || !owner || !owner.id || list.length < 2) return;
    if (_ownerEmailPick.has(owner.id)) { setEm(_ownerEmailPick.get(owner.id)); return; }
    let gone = false;
    (async () => {
      try {
        const { data } = await supabaseClient.from('se_emails').select('external_emails, sent_at')
          .eq('owner_id', owner.id).order('sent_at', { ascending: false }).limit(25);
        const onFile = new Map(list.map(a => [String(a).trim().toLowerCase(), a]));
        let pick = null;
        for (const m of (data || [])) {
          const hit = (m.external_emails || []).map(a => String(a).trim().toLowerCase()).find(a => onFile.has(a));
          if (hit) { pick = onFile.get(hit); break; }
        }
        _ownerEmailPick.set(owner.id, pick || fallback);
        if (!gone && pick) setEm(pick);
      } catch (e) { /* keep the first address */ }
    })();
    return () => { gone = true; };
  }, [owner && owner.id]);
  return (
    <span className="whitespace-nowrap">
      <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(em)}`} target="_blank" rel="noopener noreferrer" className="text-indigo-700 underline" title="Open a new Gmail draft to this address (the one your emails with them use)" onClick={e => e.stopPropagation()}>✉ {em}</a>
      <button type="button" title="Copy the email address" className="ml-1 text-gray-400 hover:text-gray-700" onClick={e => { e.stopPropagation(); const btn = e.currentTarget; Promise.resolve().then(() => navigator.clipboard.writeText(em)).then(() => { btn.textContent = '✓'; setTimeout(() => { btn.textContent = '⧉'; }, 1500); }).catch(() => window.prompt('Copy the address:', em)); }}>⧉</button>
    </span>
  );
};

// 📁 The listing's ShareFile data room (CIM) link, read from Deal Manager by Vista ID (Zac 10-29: ShareFile doesn't
// keep the link once it's made, so it has to live somewhere we can find it). Set or change it on the DM listing.
const DataRoomLink = ({ vistaId }) => {
  const [st, setSt] = useState(null);   // null = not looked up · { listing } after
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    let off = false; setSt(null);
    if (!supabaseClient || !/^\d{6}$/.test(vistaId || '')) return undefined;
    (async () => {
      try {
        const { data: { session } } = await supabaseClient.auth.getSession();
        const r = await fetch('/api/dm/listing-by-vista/' + vistaId, { headers: { Authorization: 'Bearer ' + (session && session.access_token) } });
        const d = await r.json().catch(() => ({}));
        if (!off) setSt(r.ok && d.ok ? { listing: d.listing } : { error: true });
      } catch (e) { if (!off) setSt({ error: true }); }
    })();
    return () => { off = true; };
  }, [vistaId]);
  if (!st || st.error) return null;
  const l = st.listing;
  if (!l) return <span className="text-xs text-gray-400 whitespace-nowrap" title="No Deal Manager listing has this Vista ID yet. Once the listing is created and its Data Room Link is set there, it shows here.">📁 no listing yet</span>;
  const link = String(l.data_room_link || '').trim();
  if (!/^https?:\/\//i.test(link)) return <span className="text-xs text-amber-700 whitespace-nowrap" title={`Deal Manager listing "${l.name}" has ${link ? `"${link}" instead of a link` : 'no Data Room Link'}. Set it on the listing in Deal Manager.`}>📁 no data room link in Deal Manager</span>;
  return (
    <span className="flex items-center gap-1 text-xs whitespace-nowrap">
      <a href={link} target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:underline font-medium" title={`The buyer CIM data room for ${l.name}, from the Deal Manager listing (change it there): ${link}`}>📁 Data room (CIM)</a>
      <button type="button" className="px-1.5 py-0.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50"
        onClick={() => { try { navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch (e) { window.prompt('Copy the link:', link); } }}>{copied ? '✓ Copied' : 'Copy'}</button>
    </span>
  );
};

// Gmail snippets arrive HTML-escaped ("that&#39;s", "&lt;zac@…&gt;"); decode before showing or reading them.
const seDecodeEnt = (s) => String(s || '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
  .replace(/&#39;|&#x27;/g, "'").replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
// A courtesy close needs no answer (Zac 10-29, Concise: "Perfect, thanks Zac!" carded as reply due). Only the
// owner's own words count (the quoted "On … wrote:" thread is cut off): short, opens with thanks/perfect/sounds
// good/…, and asks nothing (no "?", no please / can you / let me know / send / need…). Anything else still cards.
const SE_COURTESY_RX = /^(perfect|great|thanks?|thank you|thx|ty|awesome|sounds good|sounds great|got it|ok(ay)?|will do|appreciate|excellent|wonderful|cool|noted|received|much appreciated|you too)\b/i;
const SE_ASK_RX = /\?|\b(please|pls|can you|could you|would you|will you|let me know|lmk|need|send|when|what|how|call me|question|confirm|(do|does|did|are|is|should|shall|can|could|would) (you|we|i|they)|want to|wondering|any update)\b/i;
const seCourtesyClose = (snippet) => {
  const top = seDecodeEnt(snippet).split(/\bOn\s.{5,140}?\bwrote:|-{2,}\s*Original Message|\bFrom:\s/i)[0].replace(/\s+/g, ' ').trim();
  if (!top || top.length > 160) return false;
  return SE_COURTESY_RX.test(top) && !SE_ASK_RX.test(top);
};

const SE_SECTION_COPY = {
  // Reply-due is its OWN section (Mark 08-11: "These cards are more urgent
  // than Ideas!") — owners waiting on us never sit under the lobster tank.
  replydue: {
    title: '📬 Sales Engine — owners waiting on a reply',
    sub: 'The owner emailed and nothing has gone back. Answer (↩ clears the card), dismiss (✕ nothing’s hanging), or set the date (⏰).',
  },
  ideas: {
    title: '💡 Sales Engine — ideas worth a call',
    sub: 'No obligations here: businesses the system flags as worth resurrecting, and no-response strategy picks — good odds, your call whether today’s the day.',
  },
  valued: {
    title: '🔁 Sales Engine — valued, no review on the books',
    sub: 'Owners we valued who never came back for a review — highest value first. The card carries the valuation date and value, their last note, Thread and Account. 📞 Log the outcome or ⏰ set a date, and it clears. Adam: three a day, 🎯 for more. Leads: one a week.',
  },
  promises: {
    title: '⏰ Sales Engine — reminders you set',
    sub: 'Every reminder you set lands here — whether to follow up or just to check on something. (Older Zoho-import reminders show too, labeled as such.) Log the outcome or pick a new date, and the card clears.',
  },
};

// 🏷 Reminder TYPES (Mark 09-16): a reminder isn't always a follow-up — tagging
// it at creation lets the card show what KIND of touch it is at a glance. The
// type is stored as a natural-language prefix on the commitment note
// ("Check-in: …"), so it reads fine everywhere even where it isn't parsed. The
// ⏳ reply-watch ("Awaiting reply…") maps to the same Waiting chip for
// consistency.
const REMINDER_TYPES = [
  { key: 'followup', label: 'Follow-up',       cls: 'bg-indigo-100 text-indigo-700', desc: 'Reach back out to move it forward.' },
  { key: 'checkin',  label: 'Check-in',        cls: 'bg-sky-100 text-sky-700',       desc: 'Touch base or check on something — no hard ask.' },
  { key: 'waiting',  label: 'Waiting on them', cls: 'bg-amber-100 text-amber-800',   desc: 'The ball is in their court by this date — chase if it passes.' },
];
const REMINDER_TYPE_LABELS = REMINDER_TYPES.map(t => t.label);
// One-click reasons for ⏰ Remind me (Adam 10-30: typing a note every time wasted time, so he typed "reach").
// Mark's 08-13 rule still holds (no clearing without a stated strategy); a click states it.
const REMINDER_QUICK_NOTES = ['Reach out', 'Follow up on my email', 'Check back if no reply', 'Waiting on their documents', 'Not ready yet, circle back'];
// Detect the type from a stored note; returns { chip, cls, text } or null.
const reminderTypeOf = (note) => {
  const n = String(note || '');
  for (const t of REMINDER_TYPES) {
    const re = new RegExp('^' + t.label.replace(/[-]/g, '\\-') + ':\\s*', 'i');
    if (re.test(n)) return { chip: t.label, cls: t.cls, text: n.replace(re, '').trim() };
  }
  if (/^Awaiting reply/i.test(n)) return { chip: 'Waiting on reply', cls: 'bg-amber-100 text-amber-800', text: n };
  return null;
};

// ── 🤝 Buyside-match scoring (Mark 09-01, scenario 3: "he sees a card,
// needs a strategic decision — how many buyside clients match, and has
// enough time passed since we last reached out buyside"). A faithful port
// of the SE page's matcher (docs/se.html scoreSearch — THE MATCHING LAW):
// a KNOWN mismatch on sector, geography, revenue, or EBITDA ELIMINATES the
// match entirely; unknown fields count against the % and become the
// conditional; keywords stay a soft ranking dimension. Same taxonomy alias
// bridge, same 10% size grace, same add-on EBITDA waiver — the chip's
// numbers agree with the SE page's 🤝 badges by construction.
const SE_MATCH_STATES = { alabama:'AL',alaska:'AK',arizona:'AZ',arkansas:'AR',california:'CA',colorado:'CO',connecticut:'CT',delaware:'DE',florida:'FL',georgia:'GA',hawaii:'HI',idaho:'ID',illinois:'IL',indiana:'IN',iowa:'IA',kansas:'KS',kentucky:'KY',louisiana:'LA',maine:'ME',maryland:'MD',massachusetts:'MA',michigan:'MI',minnesota:'MN',mississippi:'MS',missouri:'MO',montana:'MT',nebraska:'NE',nevada:'NV','new hampshire':'NH','new jersey':'NJ','new mexico':'NM','new york':'NY','north carolina':'NC','north dakota':'ND',ohio:'OH',oklahoma:'OK',oregon:'OR',pennsylvania:'PA','rhode island':'RI','south carolina':'SC','south dakota':'SD',tennessee:'TN',texas:'TX',utah:'UT',vermont:'VT',virginia:'VA',washington:'WA','west virginia':'WV',wisconsin:'WI',wyoming:'WY','washington dc':'DC','district of columbia':'DC' };
const SE_MATCH_CODES = new Set(Object.values(SE_MATCH_STATES));
const seMatchStateCode = (v) => {
  const s = String(v || '').trim();
  if (!s) return '';
  if (s.length === 2 && SE_MATCH_CODES.has(s.toUpperCase())) return s.toUpperCase();
  return SE_MATCH_STATES[s.toLowerCase()] || '';
};
const seScoreSearch = (s, biz) => {
  if (s.buyer && s.buyer.owner_id && s.buyer.owner_id === biz.id) return null;
  let specified = 0, matched = 0;
  const gaps = [];
  const band = (v, lo, hi) => ((lo == null || v >= lo * 0.9) && (hi == null || v <= hi * 1.1));
  if (s._sec.length) {
    specified++;
    const b = String(biz.sector || '').toLowerCase();
    if (!b) gaps.push('sector');
    else if (s._sec.some(t => b.includes(t) || t.includes(b))) matched++;
    else return null;
  }
  if (s._geo.size || (s._cities || []).length) {
    specified++;
    const st = seMatchStateCode(biz.state);
    const ct = String(biz.city || '').toLowerCase();
    if (!st && !ct) gaps.push('location');
    else if ((st && s._geo.has(st)) || (ct && (s._cities || []).some(t => ct.includes(t) || t.includes(ct)))) matched++;
    else if (st) return null;
    else gaps.push('location');
  }
  if (s.revenue_min != null || s.revenue_max != null) {
    specified++;
    const v = biz.size_revenue;
    if (v == null) gaps.push('revenue');
    else if (band(v, s.revenue_min, s.revenue_max)) matched++;
    else return null;
  }
  const ebMin = (s.meta && s.meta.add_on) ? null : s.ebitda_min;
  if (ebMin != null || s.ebitda_max != null) {
    specified++;
    const v = biz.ebitda;
    if (v == null) gaps.push('EBITDA');
    else if (band(v, ebMin, s.ebitda_max)) matched++;
    else return null;
  }
  if (s._kw.length) {
    specified++;
    const blob = ((biz.company_name || '') + ' ' + (biz.sector || '') + ' ' + (biz.keywords || '') + ' ' + (biz.description || '')).toLowerCase();
    if (blob.trim().length < 3) gaps.push('keywords');
    else if (s._kw.some(t => blob.includes(t))) matched++;
  }
  if (!specified) return null;
  const pct = Math.round(100 * matched / specified);
  const condPct = Math.round(100 * (matched + gaps.length) / specified);
  return { s, pct, condPct };
};

const SEServingSection = ({ items, mode = 'promises', onLog, onReached, onSnooze, onFetchNext, fetchLocked, onCadenceSent, onReplied, onNoReply, onRemind, onAwait, onHandOff, onDropDate, actor, gateCount = 0, buysideMatches = null }) => {
  // ⏰ Remind-me popover state (UpTime 08-11).
  const [remindFor, setRemindFor] = useState(null);
  const [remindNote, setRemindNote] = useState('');
  const [remindDate, setRemindDate] = useState('');
  const [remindErr, setRemindErr] = useState(false);
  const [remindType, setRemindType] = useState('followup');
  // 🧭 THE JOURNEY LINE (Mark 10-20, ROADMAP #17): what the owner did before this card, from the nightly
  // Mailchimp activity (link-checker clicks left out) and recognized website visits. Six months, one line.
  const [journeyBy, setJourneyBy] = useState({});
  const journeyKey = (items || []).map(o => o.id).join(',');
  // 🗒 LAST NOTE on the card (Mark 10-27, Zoho weaning: "I'd guess for most cards that would be helpful"; Adam 08-28:
  // a card that lands = company + contact + his own last note + one button). The newest note a PERSON wrote: call
  // notes, logged outcomes, owner responses, qualification, Zoho notes. Automatic ledger lines (reminder set/kept,
  // strategy chains, watches, bookings, links) are skipped so the line never wastes the space.
  const [lastNoteBy, setLastNoteBy] = useState({});
  useEffect(() => {
    const ids = [...new Set((items || []).map(o => o.id).filter(Boolean))];
    if (!ids.length || !supabaseClient) return;
    let cancelled = false;
    const AUTO = /^(⏰ )?Reminder (set|kept)|^Strategy set|^⏳|^Linked to the VT deal|^Booked:|^First-time meeting|^Scheduling follow-up sent|^Reached out \(no answer|^SE record minted|^No reply needed|^Fireflies:|^Retired from the seller book/;
    const plain = (h) => String(h || '').replace(/<br\s*\/?>|<\/(p|div|li)>/gi, '\n').replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&').trim();
    (async () => {
      try {
        const out = {};
        for (let i = 0; i < ids.length; i += 50) {
          const rows = await fetchAllRows(() => supabaseClient.from('se_touches')
            .select('owner_id, at, kind, channel, actor, subject, meta')
            .in('owner_id', ids.slice(i, i + 50)).in('kind', ['note', 'call', 'email', 'email_in'])
            .order('at', { ascending: false }));
          (rows || []).forEach(t => {
            if (out[t.owner_id] || t.actor === 'system') return;
            // A Fireflies digest saved as a Zoho note opens with Title/Date/Participants/links: start at its Overview.
            const content = t.meta && t.meta.content ? plain(t.meta.content).replace(/^Title:[\s\S]*?\n(?=Overview)/, '') : '';
            const subj = String(t.subject || '').trim();
            if (!content && (!subj || AUTO.test(subj))) return;
            // Zoho imports titled the note with its own first words, so a title that opens the text is dropped.
            const lead = subj.replace(/…$/, '').replace(/\s+/g, ' ').trim().toLowerCase();
            const text = !content ? subj
              : (!subj || /^call notes:?$/i.test(subj) || content.replace(/\s+/g, ' ').toLowerCase().startsWith(lead)) ? content
              : subj + ': ' + content;
            out[t.owner_id] = { at: t.at, who: t.actor, text };
          });
        }
        if (!cancelled) setLastNoteBy(out);
      } catch (e) { /* the line is a convenience; the card stands without it */ }
    })();
    return () => { cancelled = true; };
  }, [journeyKey]);
  useEffect(() => {
    const ids = [...new Set((items || []).map(o => o.id).filter(Boolean))];
    if (!ids.length || !supabaseClient) return;
    let cancelled = false;
    (async () => {
      try {
        const since = new Date(Date.now() - 183 * 86400000).toISOString();
        const out = {};
        const slot = (id) => out[id] || (out[id] = { opened: 0, clicked: 0, lastClick: null, visits: 0, lastVisit: null });
        for (let i = 0; i < ids.length; i += 100) {
          const chunk = ids.slice(i, i + 100);
          const [{ data: a }, { data: v }] = await Promise.all([
            supabaseClient.from('se_email_activity').select('owner_id, opens, clicks, scanner, first_click, sent_at').in('owner_id', chunk).gte('sent_at', since),
            supabaseClient.from('se_web_visits').select('owner_id, at, path, referrer').in('owner_id', chunk).gte('at', since),
          ]);
          (a || []).forEach(x => {
            const j = slot(x.owner_id);
            if (x.opens > 0) j.opened++;
            if (x.clicks > 0 && !x.scanner) { j.clicked++; const t = x.first_click || x.sent_at; if (!j.lastClick || t > j.lastClick) j.lastClick = t; }
          });
          // Link-scanner visits (Mark 10-21, the non-IT wave: 239 "readers", ~19 people): company mail security opens every link
          // in an email in a real browser, so the hits look like visits. The signature: two or more hits on the email-link pages
          // (/ or /go/...) within 10 seconds (often both links, twice, in half a second; referrer empty, EdgePilot or our own
          // site), and no real browsing in the next 30 minutes. Those bursts are hidden from the journey (the rows stay in
          // se_web_visits); anything a person did afterwards still shows.
          const dropScannerVisits = (vs) => {
            const landing = (p) => { const x = String(p || '').split('?')[0]; return x === '/' || x.startsWith('/go/'); };
            const host = (r) => { try { return new URL(r).host; } catch (e) { return ''; } };
            const a = (vs || []).slice().sort((x, y) => (x.at < y.at ? -1 : 1));
            const drop = new Set();
            for (let i = 0; i < a.length; i++) {
              if (drop.has(i) || !landing(a[i].path)) continue;
              const t0 = Date.parse(a[i].at);
              const burst = [i];
              for (let k = i + 1; k < a.length && Date.parse(a[k].at) - t0 <= 10000; k++) if (landing(a[k].path)) burst.push(k);
              const edge = burst.some(k => host(a[k].referrer) === 'link.edgepilot.com');
              const browsed = a.some((x, k) => !burst.includes(k) && !landing(x.path) && Date.parse(x.at) >= t0 && Date.parse(x.at) - t0 <= 1800000);
              if ((burst.length >= 2 || edge) && !browsed) burst.forEach(k => drop.add(k));
            }
            return a.filter((_, k) => !drop.has(k));
          };
          const byOwner = {};
          (v || []).forEach(x => { (byOwner[x.owner_id] = byOwner[x.owner_id] || []).push(x); });
          Object.entries(byOwner).forEach(([oid, list]) => dropScannerVisits(list).forEach(x => { const j = slot(oid); j.visits++; if (!j.lastVisit || x.at > j.lastVisit) j.lastVisit = x.at; }));
        }
        if (!cancelled) setJourneyBy(out);
      } catch (e) { /* journey tables not there yet: no line */ }
    })();
    return () => { cancelled = true; };
  }, [journeyKey]);
  // 🎯 The editable action item (Adam 08-18: Zoho's action box, reborn —
  // "the ability to edit that section regardless of what type of card it
  // is, and regardless of any actions taken"). Editing NEVER clears a card
  // — it's the standing where-this-stands note, and every edit is logged.
  const [editingAction, setEditingAction] = useState(null);
  const [actionDraft, setActionDraft] = useState('');
  const saveAction = async (o) => {
    const val = actionDraft.trim();
    try {
      const { error } = await supabaseClient.from('se_owners')
        .update({ action_item: val || null, updated_at: new Date().toISOString() }).eq('id', o.id);
      if (error) throw error;
      await supabaseClient.from('se_touches').insert({
        owner_id: o.id, kind: 'note', channel: 'se', actor: actor || null,
        subject: val ? `Action item updated — ${val.slice(0, 180)}` : 'Action item cleared',
      });
      o.action_item = val || null;
      setEditingAction(null);
    } catch (e) { window.alert('Could not save the action item: ' + (e?.message || '')); }
  };
  // Reason REQUIRED before any date fires (Mark 08-13: no clearing without
  // action or explained strategy) — the note is the strategy statement.
  const remindGo = (due) => {
    if (!remindNote.trim()) { setRemindErr(true); return; }
    onRemind(remindFor, due, remindNote, mode, remindType);
    setRemindFor(null); setRemindErr(false);
  };
  const remindDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
  const [threadFor, setThreadFor] = useState(null); // owner whose 🧵 thread is open
  const [notesFor, setNotesFor] = useState(null);   // owner whose 🗒 notes are open
  // ↩ Reply in thread straight from the card (Adam-plate punch list (d),
  // 08-11): /api/se/thread-reply sends from the CALLER's own Gmail, threads
  // both ends, and bumps last_outbound_at — which is exactly what clears the
  // reply-due card. onReplied lets the parent reload the serving data.
  const [replyFor, setReplyFor] = useState(null);
  const [replyBody, setReplyBody] = useState('');
  const [replyStatus, setReplyStatus] = useState('');
  const sendReply = async () => {
    const body = replyBody.trim();
    if (!body) { setReplyStatus('Write the reply first.'); return; }
    setReplyStatus('Sending from your mailbox…');
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const at = session && session.access_token;
      if (!at) throw new Error('Session expired — reload and sign in again.');
      const r = await fetch('/api/se/thread-reply', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
        body: JSON.stringify({ owner_id: replyFor.id, body }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || ('HTTP ' + r.status));
      setReplyStatus(`✓ Sent to ${d.to}${d.threaded ? ' — threaded into the existing chain' : ''}. This card clears itself.`);
      setReplyBody('');
      setTimeout(() => { setReplyFor(null); setReplyStatus(''); if (onReplied) onReplied(); }, 1800);
    } catch (e) { setReplyStatus('Send failed: ' + (e.message || e)); }
  };
  const hasButton = mode === 'ideas' && !!onFetchNext;
  if ((!items || items.length === 0) && !hasButton) return null;
  const copy = SE_SECTION_COPY[mode] || SE_SECTION_COPY.promises;
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 mb-1 flex-wrap">
        <h2 className="text-sm font-bold uppercase tracking-wide text-indigo-700">
          {copy.title} <span className="text-gray-400 font-normal">({(items || []).length})</span>
        </h2>
        {hasButton && gateCount > 0 && (
          <span className="text-xs font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1" title="The clean-plate rule: fresh leads — automatic and the button — resume the moment nothing on your plate is overdue. Due-today items don't count against you; older ones do.">
            🔒 Fresh leads resume when the plate is clean — {gateCount} overdue item{gateCount === 1 ? '' : 's'} above
          </span>
        )}
        {hasButton && gateCount === 0 && (
          <button
            type="button"
            onClick={onFetchNext}
            className={`px-3 py-1 text-xs font-semibold rounded ${fetchLocked ? 'bg-gray-200 text-gray-500' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`}
            title={fetchLocked
              ? 'Log the outcome on the lead you already fetched, then grab the next one.'
              : 'Caught up? The system hands you the single next most important lead to work.'}
          >
            🎯 Give me the next one
          </button>
        )}
      </div>
      <p className="text-xs text-gray-400 mb-3">{copy.sub}</p>
      {(!items || items.length === 0) && hasButton && (
        <div className="text-sm text-gray-400 italic mb-3">Nothing scheduled right now — the 🎯 button pulls the next most important lead whenever you're ready.</div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {(items || []).map(o => {
          const band = o._fetched ? { label: '🎯 FETCHED', cls: 'bg-indigo-100 text-indigo-700' } : (SE_BAND_META[o._band] || SE_BAND_META[3]);
          // Instant feedback after "Reached out today" — without this the
          // button looks dead and gets mashed (Adam ×4, day one).
          const touchedToday = o.last_touch_at
            && new Date(o.last_touch_at).toDateString() === new Date().toDateString();
          return (
            <div key={o.id} className="bg-white border border-indigo-200 rounded-lg p-4">
              <div className="flex items-start justify-between gap-2 mb-1">
                <div className="font-semibold text-gray-800 truncate">{o.company_name}</div>
                <span className="flex items-center gap-1">
                  {touchedToday && <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-emerald-100 text-emerald-700 whitespace-nowrap">✓ touched today</span>}
                  <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded whitespace-nowrap ${band.cls}`}>{band.label}</span>
                </span>
              </div>
              <div className="text-xs text-gray-500 mb-1">
                {[o.city && o.state ? `${o.city}, ${o.state}` : (o.state || o.city), o.sector].filter(Boolean).join(' · ')}
              </div>
              {/* Contact + phone up top (Mark 09-16): a "check on something"
                  reminder is often just a call — the person and number should
                  be a glance away, not a click into the record. */}
              {/* …and the email (Adam 10-16, CSP Networks: he copied it by opening Account and scrolling, for a
                  new Gmail draft). The address opens a Gmail draft to the owner; ⧉ copies it. The ✓ flips
                  back to ⧉ after 1.5s (Adam 10-29: it stayed ✓ for good, so the copy looked gone). */}
              {(() => {
                const em = Array.isArray(o.emails) ? (o.emails.find(Boolean) || null) : null;
                if (!o.contact_name && !o.phone && !em) return null;
                const parts = [];
                if (o.contact_name) parts.push(<span key="n" className="font-medium">{o.contact_name}</span>);
                if (o.phone) parts.push(<a key="p" href={`tel:${o.phone}`} className="text-indigo-700 underline" onClick={e => e.stopPropagation()}>📞 {o.phone}</a>);
                if (em) parts.push(<OwnerEmailLink key="e" owner={o} fallback={em} />);
                return <div className="text-xs text-gray-700 mb-1 flex flex-wrap items-center gap-x-1">{parts.map((el, i) => <React.Fragment key={i}>{i > 0 ? <span className="text-gray-400">·</span> : null}{el}</React.Fragment>)}</div>;
              })()}
              {buysideMatches && buysideMatches[o.id] && buysideMatches[o.id].count > 0 && (() => {
                // Scenario-3 chip (Mark 09-01): the strategic-decision line —
                // buyside demand for THIS business + whether the buyside
                // quiet-time (90d) has passed. Same matcher law as the SE
                // page; the buyer list rides the tooltip.
                const bm = buysideMatches[o.id];
                return (
                  <div className="text-[11px] mb-1 flex items-center gap-2 flex-wrap">
                    <span className="inline-flex items-center gap-1 bg-violet-50 border border-violet-200 text-violet-800 rounded px-2 py-0.5 font-medium"
                      title={`Buyside clients whose search fits this business (known mismatches on sector/geo/size already eliminated; % counts unknowns against the match):\n${bm.top.join('\n')}`}>
                      🤝 {bm.count} buyside {bm.count === 1 ? 'client fits' : 'clients fit'} · best {bm.best}%
                    </span>
                    {bm.unsigned > 0 && (
                      <span className="inline-flex items-center gap-1 bg-amber-50 border border-amber-300 text-amber-800 rounded px-2 py-0.5 font-semibold"
                        title="These fitting buyers have NOT signed a buyside agreement — some only said they'd pay fees. No owner introduction until the BSA is signed; the fit is real, the paper isn't.">
                        🔒 {bm.unsigned} unsigned
                      </span>
                    )}
                    {bm.cooldown
                      ? <span className="text-amber-600 font-medium" title="We hold 90 days between buyside approaches to a business — this one was touched recently.">⏳ cooldown — {Math.max(1, 90 - bm.quiet)}d left</span>
                      : <span className="text-emerald-700 font-medium" title="No touch inside the 90-day window — clear for a buyside approach.">✓ quiet {bm.quiet >= 9999 ? '∞' : bm.quiet + 'd'} — clear to approach</span>}
                  </div>
                );
              })()}
              {/* 📌 The reminder itself, at a glance (Mark 09-16): the note
                  you wrote — follow-up OR "check on something" — as the
                  headline, with the due date, overdue-ness, and who set it.
                  The prose _why below adds the framing (Zoho import / reply
                  watch / chain warnings). */}
              {o._commitment && (() => {
                const due = o._commitment.due;
                const overdueD = due ? Math.floor((Date.now() - new Date(due + 'T00:00:00').getTime()) / 86400000) : null;
                const setWhen = o._commitment.created_at ? new Date(o._commitment.created_at).toLocaleDateString() : null;
                const imported = o._commitment.created_at && String(o._commitment.created_at) < '2026-07-29';
                const rt = reminderTypeOf(o._commitment.note);
                const noteText = rt ? (rt.text || 'Reach out') : (o._commitment.note || 'Reach out');
                return (
                  <div className="mb-1 bg-amber-50 border border-amber-200 rounded px-2 py-1.5">
                    <div className="text-sm font-semibold text-gray-800 flex items-start gap-1.5 flex-wrap">
                      {rt && <span className={`text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded ${rt.cls}`}>{rt.chip}</span>}
                      <span className="whitespace-pre-line">📌 {noteText}</span>
                    </div>
                    <div className="text-[11px] text-gray-500 mt-0.5">
                      {due ? <>Due {new Date(due + 'T00:00:00').toLocaleDateString()}{overdueD > 0 ? <span className="text-amber-700 font-semibold"> · {overdueD}d overdue</span> : overdueD === 0 ? <span className="text-amber-700 font-semibold"> · today</span> : null}</> : 'No date'}
                      {/^🌐 Website/.test(o._commitment.note || '') ? ' · from the website form' : o._commitment.created_by ? ` · set by ${o._commitment.created_by}` : ''}{setWhen ? ` ${setWhen}` : ''}{imported ? ' · from the Zoho import' : ''}
                    </div>
                    {/* Scott 10-20 ("how do I get to the message?"): website requests send no email; say so on the card. */}
                    {/^🌐 Website/.test(o._commitment.note || '') && (
                      <div className="text-[11px] text-sky-900 bg-sky-50 border border-sky-200 rounded px-2 py-1 mt-1">
                        🌐 This is how website requests arrive: <b>this card is the whole message</b>, everything they typed is above. No email comes. They're already in Sales Engine as a responder (the website added or matched them): <b>no ➕ Add owner</b>. Reply with <b>✉ their email</b> on this card, then <b>📨 Log response / set meeting</b>.
                      </div>
                    )}
                  </div>
                );
              })()}
              {(() => {
                const j = journeyBy[o.id];
                if (!j || !(j.opened || j.clicked || j.visits)) return null;
                const d = (t) => new Date(t).toLocaleDateString();
                return (
                  <div className="text-[11px] text-sky-900 mb-1" title="Last 6 months, from Mailchimp and our website. Opens are approximate (Apple Mail opens every email). Clicks from company link-checkers are left out. Full detail: Sales Engine → open the owner → History.">
                    🧭 <b>Journey</b> (6 mo): opened {j.opened} of our emails · {j.clicked ? <>clicked <b>{j.clicked}</b> (latest {d(j.lastClick)})</> : 'no clicks'} · {j.visits ? <>visited <b>{j.visits}</b> website page{j.visits === 1 ? '' : 's'} (latest {d(j.lastVisit)})</> : 'no recognized website visits'}
                  </div>
                );
              })()}
              <p className="text-xs text-gray-700 mb-1 font-medium">{o._why}</p>
              {lastNoteBy[o.id] && (() => {
                const n = lastNoteBy[o.id];
                const ageD = Math.floor((Date.now() - new Date(n.at).getTime()) / 86400000);
                const long = n.text.length > 220;
                return (
                  <details className="text-[11px] text-gray-700 bg-gray-50 border border-gray-200 rounded px-2 py-1 mb-1" title="The newest note a person wrote on this business. Full history: 🗒 Notes.">
                    <summary className="cursor-pointer list-none">
                      🗒 <b>Last note · {new Date(n.at).toLocaleDateString()}{ageD > 60 ? ` (${Math.round(ageD / 30)} mo ago)` : ''}{n.who ? ` · ${n.who}` : ''}:</b>{' '}
                      <span className="whitespace-pre-line">{long ? n.text.slice(0, 220).trim() + '…' : n.text}</span>
                      {long && <span className="text-indigo-600 font-semibold"> ▸ more</span>}
                    </summary>
                    {long && <div className="whitespace-pre-line mt-1 pt-1 border-t border-gray-200 max-h-60 overflow-y-auto">{n.text}</div>}
                  </details>
                );
              })()}
              {/* 🧾 THE RECEIPTS (Mark 09-08, GHPBuysHouses: Adam was "fairly
                  certain" he'd worked a card whose pick was sitting right in
                  the ledger — "the facts should be staring at him." Whatever
                  play is on record shows HERE, dated, so memory is never the
                  source of truth again.) */}
              {o.disposition && (() => {
                const d = [...SE_DISPOSITIONS, ...SE_STRATEGIES].find(x => x.key === o.disposition);
                const when = o.last_touch_at ? new Date(o.last_touch_at).toLocaleDateString() : null;
                return (
                  <div className="text-[11px] text-indigo-700 bg-indigo-50 border border-indigo-200 rounded px-2 py-1 mb-1">
                    🧾 Last play on record: <b>{d ? d.label : String(o.disposition).replace(/_/g, ' ')}</b>{when ? ` · logged ${when}` : ''} — your note is on 🗒 Notes. If this card contradicts that play, trust this line and flag it.
                  </div>
                );
              })()}
              {(() => {
                // Recognition credit ON the card (Adam's Cohesive pushback
                // 08-20: his 8/14 email was synced AND his quick-touch
                // logged, but the card looked identical — reading as "the
                // tool thinks I did nothing"). Mirrors the nudge email's
                // recognition-credit line.
                if (mode === 'replydue') return null;
                const days = (d) => Math.floor((Date.now() - new Date(d).getTime()) / 86400000);
                const outD = o.last_outbound_at ? days(o.last_outbound_at) : null;
                const touchD = o.last_touch_at ? days(o.last_touch_at) : null;
                const bits = [];
                if (outD !== null && outD >= 0 && outD <= 10) bits.push(`📧 your email to them ${outD === 0 ? 'today' : outD + 'd ago'} is logged`);
                else if (touchD !== null && touchD >= 0 && touchD <= 10 && !touchedToday) bits.push(`📞 touch logged ${touchD === 0 ? 'today' : touchD + 'd ago'}`);
                // Meetings count as activity too (Adam's Logic TCG 08-24:
                // Colleen ran the review call, his follow-up card read as
                // "nothing's happening"). Recognition only — a meeting might
                // not be what this follow-up promised, so the human picks.
                const meetD = o.last_meeting_at ? Math.floor((Date.now() - new Date(o.last_meeting_at + (o.last_meeting_at.length === 10 ? 'T12:00:00' : '')).getTime()) / 86400000) : null;
                if (meetD !== null && meetD >= 0 && meetD <= 7) bits.push(`📅 ${o.last_meeting_type || 'meeting'} held ${meetD === 0 ? 'today' : meetD + 'd ago'} is on the record — whoever ran it, the history's on 🗒/🧵`);
                else if (o.next_meeting_at && o.next_meeting_at > new Date().toISOString().slice(0, 10)) bits.push(`📅 ${o.next_meeting_type || 'meeting'} booked for ${o.next_meeting_at}`);
                if (!bits.length) return null;
                return (
                  <div className="text-[11px] text-emerald-700 bg-emerald-50 border border-emerald-200 rounded px-2 py-1 mb-1">
                    {/* A reminder answered by an email closes itself at the next hourly sweep (seSweepKeptReminders,
                        :50 past the hour). Scott 10-22, Aristech: the old line said "pick the outcome" and he
                        filed a report; the card had already been kept. */}
                    ✓ {bits.join(' · ')} — {o._commitment && outD !== null && outD <= 3
                      ? 'that answers this reminder: it closes itself within the hour. Nothing else to do.'
                      : 'the card clears when you pick the outcome or a new date.'}
                  </div>
                );
              })()}
              {o._lastInbound && o._lastInbound.suspicious && (
                <div className="text-xs bg-red-50 border border-red-300 rounded p-2 mb-1 text-red-800">
                  <span className="font-bold">🚩 Matches the phishing-buyer pattern:</span> {o._lastInbound.suspicious_reason || 'verification-refusal / caller-controlled link tells'}.{' '}
                  <span className="font-semibold">Don't join their links or open attachments — we send the links, they don't. Forward to Scott if unsure.</span>
                </div>
              )}
              {o._lastInbound && (
                <div className="text-xs bg-amber-50 border border-amber-200 rounded p-2 mb-1">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-amber-800 truncate">✉ {o._lastInbound.subject || '(no subject)'}</span>
                    <span className="text-gray-400 whitespace-nowrap">{new Date(o._lastInbound.sent_at).toLocaleDateString()}</span>
                  </div>
                  {o._lastInbound.snippet && <div className="text-gray-600 mt-0.5">{seDecodeEnt(o._lastInbound.snippet)}</div>}
                </div>
              )}
              {/* 🎯 The action item — Zoho's box, editable on every card,
                  every state (Adam 08-18). Editing never clears the card. */}
              <div className="text-[11px] mb-1">
                {editingAction === o.id ? (
                  <span className="flex items-center gap-1">
                    <input value={actionDraft} onChange={e => setActionDraft(e.target.value)} autoFocus
                      onKeyDown={e => { if (e.key === 'Enter') saveAction(o); if (e.key === 'Escape') setEditingAction(null); }}
                      placeholder="The current play, in your words — rides every card for this business"
                      className="flex-1 border border-indigo-300 rounded px-1.5 py-0.5 text-[11px]" />
                    <button type="button" onClick={() => saveAction(o)} className="text-emerald-700 font-bold px-1">✓</button>
                    <button type="button" onClick={() => setEditingAction(null)} className="text-gray-400 px-1">✕</button>
                  </span>
                ) : (
                  /* The bare ✏ glyph was gray-on-gray at 11px — functionally
                     invisible (Adam 09-02, Vintage IT: "there's no pencil
                     icon"). The whole line now opens the editor, and the
                     affordance is a real bordered chip that says "edit". */
                  <span className="text-gray-700 cursor-pointer group" onClick={() => { setEditingAction(o.id); setActionDraft(o.action_item || ''); }}
                    title="Edit the action item — your standing note on this business (Zoho's action box). Editable any time, on any card; it never clears anything, it just remembers.">
                    🎯 {o.action_item
                      ? <span className="font-medium">{o.action_item}</span>
                      : <span className="text-gray-400 italic">add an action note</span>}
                    <span className="ml-1.5 px-1.5 py-0.5 rounded border border-indigo-300 text-indigo-600 text-[10px] font-semibold group-hover:bg-indigo-50">✏ edit</span>
                  </span>
                )}
              </div>
              {(() => {
                // 📝 The rest of the at-a-glance record context (Adam's
                // MySmartPlans point, 08-13); the action item lives above
                // as its own editable line since 08-18.
                const onRecord = [
                  o.not_ready_reason ? `Last outcome: ${o.not_ready_reason}` : null,
                  o.notes || null,
                  o.description || null,
                ].filter(Boolean).join(' · ');
                return onRecord ? (
                  <div className="text-[11px] text-gray-600 mb-1" title={onRecord}>
                    📝 {onRecord.length > 220 ? onRecord.slice(0, 220) + '…' : onRecord}
                  </div>
                ) : null;
              })()}
              <div className="text-[11px] text-gray-400 mb-2">
                {[
                  o.zoho_status ? `Zoho: ${o.zoho_status}` : null,
                  o.size_revenue ? `$${(Math.round(Number(o.size_revenue) / 1e5) / 10).toLocaleString()}M revenue` : null,
                  o.ebitda ? `$${(Math.round(Number(o.ebitda) / 1e5) / 10).toLocaleString()}M EBITDA` : null,
                  o.size_employees ? `${o.size_employees} employees` : null,
                  o.business_type || null,
                  // Valued-or-not, explicitly (Adam's 3rd ask): the Zoho
                  // valuation stamp when there is one; VT-linked counts as
                  // valued/managed there; otherwise say so plainly.
                  o.zoho_valuation_date
                    ? `💰 valued ${o.zoho_valuation_date}${o.zoho_value_provided ? ` ≈$${(Math.round(Number(o.zoho_value_provided) / 1e5) / 10).toLocaleString()}M` : ''}`
                    : (o.vt_client_id ? '💰 VT client' : '💰 no valuation on record'),
                  o.last_meeting_at ? `last meeting ${o.last_meeting_at}${o.last_meeting_type ? ` (${o.last_meeting_type})` : ''}` : null,
                  o.phone || null,
                ].filter(Boolean).join(' · ')}
                {o.website && <span> · <a href={o.website} target="_blank" rel="noopener" className="underline" onClick={e => e.stopPropagation()}>site ↗</a></span>}
                {o.linkedin_url && <span> · <a href={o.linkedin_url} target="_blank" rel="noopener" className="underline" onClick={e => e.stopPropagation()}>LinkedIn ↗</a></span>}
              </div>
              <div className="flex items-center justify-end gap-2 flex-wrap">
                {o._lastInbound && (
                  <button type="button" onClick={() => { setReplyFor(o); setReplyBody(''); setReplyStatus(''); }}
                    className="px-2 py-1 text-[11px] font-semibold rounded bg-amber-500 text-white hover:bg-amber-600"
                    title="Reply inside the existing email chain, from YOUR Gmail — sending clears this card.">
                    ↩ Reply
                  </button>
                )}
                {o._lastInbound && onNoReply && (
                  <button type="button" onClick={() => onNoReply(o)}
                    className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                    title="Nothing's hanging — intro chatter, courtesy note. Clears the card; a NEW email from the owner brings it back.">
                    ✕ No reply needed
                  </button>
                )}
                {onRemind && (
                  <button type="button" onClick={() => { setRemindFor(o); setRemindNote(''); setRemindDate(''); setRemindType('followup'); }}
                    className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                    title="Pick what kind of reminder, when it comes back, and a strategy note to your future self.">
                    ⏰ Remind me
                  </button>
                )}
                {onAwait && mode !== 'replydue' && (
                  <button type="button" onClick={() => onAwait(o)}
                    className="px-2 py-1 text-[11px] font-semibold rounded border border-sky-300 text-sky-700 hover:bg-sky-50"
                    title="Just reached out? Arms a 2-business-day watch: their reply retires it automatically; silence brings back one card asking for the play. No date to guess — the ball is in their court.">
                    ⏳ Waiting on reply
                  </button>
                )}
                {onHandOff && mode === 'promises' && (
                  <button type="button" onClick={() => onHandOff(o)}
                    className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                    title="Someone else is working this business — the record moves to them and this card clears (logged). No card for them.">
                    ↪ Someone else has it
                  </button>
                )}
                {onDropDate && mode === 'promises' && (o._commitment
                  ? (o._commitment.created_at && String(o._commitment.created_at) < '2026-07-29')
                  : (o.next_touch_at && !o.disposition)) && (
                  <button type="button" onClick={() => onDropDate(o)}
                    className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                    title="Imported Zoho date — nobody picked it in SE. Drop it with one line on why; no new date needed.">
                    ✕ Drop this date
                  </button>
                )}
                <button type="button" onClick={() => setThreadFor(o)}
                  className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                  title="Read the full email thread — every synced mailbox, right here. No Gmail digging.">
                  🧵 Emails
                </button>
                <button type="button" onClick={() => setNotesFor(o)}
                  className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                  title="The touch history — what people logged about this business.">
                  🗒 Notes
                </button>
                <a href={`/sales-engine?owner=${encodeURIComponent(o.id)}`} target="_blank" rel="noopener"
                  className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800"
                  title="Open this business on the Sales Engine page — full history, contacts, actions.">
                  ↗ Account
                </a>
                {/* Buyside shortcut (Mark 09-04, Adam's batch: "he does
                    everything else on his plate" — the card is the flow, the
                    book hunt was the flaw): one click = this business's 🤝
                    buyer-match modal, already open. */}
                <a href={`/sales-engine?owner=${encodeURIComponent(o.id)}&match=1`} target="_blank" rel="noopener"
                  className="px-2 py-1 text-[11px] font-semibold rounded border border-violet-300 text-violet-700 hover:bg-violet-50"
                  title="Buyside: opens this business's 🤝 buyer-match window directly — record 📤 Shared / 🤝 Intro / 📄 IOI / ✗ Passed on a buyer pair. If your buyer isn't in the list or Intro shows 🔒, note it and tell Mark — that's missing data, not a wrong click.">
                  🤝 Buyers
                </a>
                {onCadenceSent && o._commitment && /^Scheduling follow-up/.test(o._commitment.note || '') && (
                  <button type="button" onClick={() => onCadenceSent(o)}
                    className="px-3 py-1 text-xs font-semibold rounded bg-emerald-600 text-white hover:bg-emerald-700"
                    title="Closes this step and books the next follow-up on the cadence (1d → 1d → 7d → 30d). After email 5 you'll pick the park.">
                    ✉ Sent it — next per cadence
                  </button>
                )}
                {/* Snooze lives on IDEAS only now (Mark 09-16): on a reminder
                    card it duplicated ⏰ Remind me → 1 mo. */}
                {mode === 'ideas' && (
                  <button type="button" onClick={() => onSnooze(o, mode)} className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-500 hover:text-gray-700" title="Push this owner 30 days — someone else fills the slot tomorrow.">
                    Snooze 30d
                  </button>
                )}
                {/* "Reached out today" is off reminder cards (Mark 09-16): a
                    touch that changes no date leaves the reminder open, so it
                    read as resolving the card without doing so. On reminders
                    the resolves are Log outcome / ⏳ Waiting on reply / ⏰
                    Remind me. Kept on reply-due + ideas, where logging progress
                    is the point. */}
                {mode !== 'promises' && (
                  <button type="button" onClick={() => onReached(o)} className="px-2 py-1 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800" title="Log a touch (voicemail, quick email) without changing any dates.">
                    Reached out today
                  </button>
                )}
                <button type="button" onClick={() => onLog(o)} className="px-3 py-1 text-xs font-semibold rounded bg-indigo-600 text-white hover:bg-indigo-700">
                  📞 Log outcome
                </button>
              </div>
            </div>
          );
        })}
      </div>
      {threadFor && (
        <ThreadModal ownerId={threadFor.id} companyName={threadFor.company_name}
          onClose={() => setThreadFor(null)} />
      )}
      {notesFor && (
        <NotesModal ownerId={notesFor.id} companyName={notesFor.company_name}
          actor={actor} onClose={() => setNotesFor(null)} />
      )}
      {remindFor && ReactDOM.createPortal(
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
          onClick={() => setRemindFor(null)}>
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-5" onClick={(e) => e.stopPropagation()}>
            <div className="font-semibold text-gray-800 mb-1">⏰ Remind me — {remindFor.company_name}</div>
            <p className="text-xs text-gray-500 mb-2">{mode === 'replydue'
              ? 'This clears the reply-due card — picking a date is deciding not to answer today. It comes back as a card on the date with your note, or sooner if the owner emails again.'
              : mode === 'promises'
                ? 'Moves this reminder to the new date — the card returns then, with your note and type on it.'
                : 'Comes back as a card on the date, with your note on it.'}</p>
            {/* 🏷 Type picker (Mark 09-16): what KIND of reminder — it shows as a
                chip on the card so the nature is clear at a glance. */}
            <div className="mb-2">
              <div className="flex flex-wrap gap-1.5">
                {REMINDER_TYPES.map(t => (
                  <button key={t.key} type="button" onClick={() => setRemindType(t.key)} title={t.desc}
                    className={`px-2.5 py-1 text-xs font-semibold rounded border ${remindType === t.key ? `${t.cls} border-transparent ring-1 ring-inset ring-current` : 'bg-white text-gray-500 border-gray-300 hover:bg-gray-50'}`}>
                    {t.label}
                  </button>
                ))}
              </div>
              <div className="text-[11px] text-gray-400 mt-1">{(REMINDER_TYPES.find(t => t.key === remindType) || {}).desc}</div>
            </div>
            <input type="text" value={remindNote} onChange={e => { setRemindNote(e.target.value); if (e.target.value.trim()) setRemindErr(false); }}
              placeholder="Why this date? Click a reason below, or type your own."
              className={`w-full text-sm border rounded px-2 py-1.5 text-gray-700 mb-1.5 ${remindErr ? 'border-red-500 bg-red-50' : ''}`} />
            <div className="flex flex-wrap gap-1 mb-2">
              {REMINDER_QUICK_NOTES.map(q => (
                <button key={q} type="button" onClick={() => { setRemindNote(q); setRemindErr(false); }}
                  className={`px-2 py-0.5 text-[11px] rounded-full border ${remindNote === q ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>{q}</button>
              ))}
            </div>
            {remindErr && <div className="text-xs text-red-600 mb-2">Pick a reason above (one click) or type one, then pick the date.</div>}
            <div className="flex flex-wrap items-center gap-1.5">
              {[['1 wk', 7], ['1 mo', 30], ['3 mo', 90], ['6 mo', 180]].map(([lbl, days]) => (
                <button key={lbl} type="button"
                  onClick={() => remindGo(remindDays(days))}
                  className="px-3 py-1.5 text-sm rounded bg-blue-50 hover:bg-blue-100 text-blue-800 font-medium">{lbl}</button>
              ))}
              <input type="date" value={remindDate} onChange={e => setRemindDate(e.target.value)}
                className="text-sm border rounded px-2 py-1 text-gray-600" />
              {remindDate && (
                <button type="button" onClick={() => remindGo(remindDate)}
                  className="px-3 py-1.5 text-sm font-semibold rounded bg-blue-600 text-white hover:bg-blue-700">✓ Set</button>
              )}
              <button type="button" onClick={() => setRemindFor(null)}
                className="px-3 py-1.5 text-sm rounded border border-gray-300 text-gray-600 ml-auto">Cancel</button>
            </div>
          </div>
        </div>,
        document.body
      )}
      {replyFor && ReactDOM.createPortal(
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
          onClick={() => { setReplyFor(null); setReplyStatus(''); }}>
          <div className="bg-white rounded-lg shadow-xl w-full max-w-lg p-5" onClick={(e) => e.stopPropagation()}>
            <div className="font-semibold text-gray-800 mb-1">↩ Reply — {replyFor.company_name}</div>
            {replyFor._lastInbound && replyFor._lastInbound.suspicious && (
              <div className="text-xs bg-red-50 border border-red-300 rounded p-2 mb-2 text-red-800">
                <span className="font-bold">🚩 Matches the phishing-buyer pattern:</span> {replyFor._lastInbound.suspicious_reason || 'verification-refusal / caller-controlled link tells'}.{' '}
                <span className="font-semibold">Don't join their links or open attachments — we send the links, they don't. Forward to Scott if unsure.</span>
              </div>
            )}
            {replyFor._lastInbound && (
              <div className="text-xs bg-amber-50 border border-amber-200 rounded p-2 mb-2">
                <span className="font-semibold text-amber-800">✉ {replyFor._lastInbound.subject || '(no subject)'}</span>
                <span className="text-gray-400 ml-2">{new Date(replyFor._lastInbound.sent_at).toLocaleDateString()}</span>
                {replyFor._lastInbound.snippet && <div className="text-gray-600 mt-0.5">{replyFor._lastInbound.snippet}</div>}
              </div>
            )}
            <p className="text-xs text-gray-500 mb-2">Sends from YOUR Gmail, threaded into the existing chain (prior messages quoted). Sending logs the reply and clears this card.</p>
            <textarea value={replyBody} onChange={e => setReplyBody(e.target.value)} rows={5} autoFocus
              placeholder="Write the reply…" className="w-full text-sm border rounded px-2 py-1.5 text-gray-800 mb-2" />
            <div className="flex items-center gap-2">
              <button type="button" onClick={sendReply}
                className="px-4 py-1.5 text-sm font-semibold rounded bg-amber-500 text-white hover:bg-amber-600">Send</button>
              <button type="button" onClick={() => { setReplyFor(null); setReplyStatus(''); }}
                className="px-3 py-1.5 text-sm rounded border border-gray-300 text-gray-600">Cancel</button>
              <span className="text-xs text-gray-500">{replyStatus}</span>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

// ── 🧠 Finish the thought (Mark 08-28): outcome logs that never got a
// strategy pick (the stale-tab era) drip back at 3/day. Each card shows the
// actor's OWN note — the gentlest teacher — and asks only "what happens next
// for this owner?". Resolves through the standard outcome modal, prefilled.
const SEFinishSection = ({ data, onPick }) => {
  if (!data || !data.items.length) return null;
  const show = data.items.slice(0, data.remaining);
  return (
    <div className="mb-6">
      <h3 className="text-sm font-bold text-gray-700 mb-1">🧠 Finish the thought <span className="font-normal text-gray-400">— {data.items.length} of your logged outcomes never got a strategy pick. Three a day until they're all parked; most just need "marketing takes over".</span></h3>
      {show.length === 0 ? (
        <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded p-3">Done for today — {data.items.length} left, they'll be back tomorrow. 👏</div>
      ) : (
        <div className="space-y-2">
          {show.map(({ touch, owner }) => (
            <div key={touch.id} className="bg-white border border-violet-200 rounded-lg p-3 flex items-start gap-3">
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-gray-800">{owner.company_name}{owner.contact_name ? <span className="text-gray-400 font-normal"> · {owner.contact_name}</span> : null}</div>
                <div className="text-xs text-gray-600 mt-0.5 italic">"{touch.subject}" <span className="text-gray-400 not-italic">— you, {new Date(touch.created_at).toLocaleDateString()}</span></div>
                <div className="text-[11px] text-gray-400 mt-0.5">No pick was saved, so this owner is off every radar. Your note may already say the answer — a date goes in the follow-up field, "too cold" is the marketing play.</div>
              </div>
              <button type="button" onClick={() => onPick(owner, touch.subject)}
                className="px-3 py-1.5 text-xs font-semibold rounded bg-violet-600 text-white hover:bg-violet-700 whitespace-nowrap">Pick the strategy</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Outcome modal: contact method + note + the owner's slide-22 pick + an
// optional explicit commitment ("call me on <date>").
const SEOutcomeModal = ({ target, onClose, onSave, initialNote, vtActive, onBuysideRecord, onBuysideTie, onBuysideFollowUp, onEmailDead }) => {
  const [kind, setKind] = useState('call');
  const [note, setNote] = useState(initialNote || '');
  const [disposition, setDisposition] = useState('');
  const [commitDue, setCommitDue] = useState('');
  const [commitNote, setCommitNote] = useState('');
  const [saving, setSaving] = useState(false);
  if (!target) return null;
  const d = SE_DISPOSITIONS.find(x => x.key === disposition);
  const strat = SE_STRATEGIES.find(x => x.key === disposition);
  const nextDate = d ? new Date(Date.now() + d.days * 86400000).toISOString().slice(0, 10)
    : (strat && strat.days) ? new Date(Date.now() + strat.days * 86400000).toISOString().slice(0, 10) : null;
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg p-5 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <h3 className="font-bold text-gray-800 mb-1">Log outcome — {target.company_name}</h3>
        <p className="text-xs text-gray-400 mb-3">{target._why}</p>
        {/* The buyside door, stated where Adam looked for it (09-04: he
            hunted these radios for a "buyside client deal" button — deal
            progress lives on the PAIR, not the touch cadence). */}
        <BuysideDealStrip owner={target} onRecord={onBuysideRecord} onTie={onBuysideTie} onFollowUp={onBuysideFollowUp} />
        {/* 📪 The address is dead (Adam 10-21, ExtendoBed: an email bounced and Log outcome had no way to say so; only the Sales
            Engine list had it). Same write as SE's 'Email dead': that address is marked invalid, nothing sends to it again,
            the business stays a prospect. */}
        {onEmailDead && target.emails && target.emails[0] && (
          <div className="mb-3 text-xs">
            <button type="button" onClick={() => onEmailDead(target)} className="px-2.5 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
              title="The ADDRESS is dead (bounced / blocked / person left) but the business is still real: nothing sends to it again and the business stays a prospect.">📪 Email bounced / person left</button>
            <span className="text-gray-400 ml-2">{target.emails[0]}</span>
          </div>
        )}
        <div className="flex gap-2 mb-3">
          {[['call', '📞 Call'], ['email', '✉️ Email'], ['linkedin', '💼 LinkedIn'], ['other', 'Other']].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setKind(k)}
              className={`px-2.5 py-1 text-xs rounded border ${kind === k ? 'border-indigo-500 bg-indigo-50 text-indigo-700 font-semibold' : 'border-gray-300 text-gray-500'}`}>{l}</button>
          ))}
        </div>
        {/* Note is REQUIRED (Mark 2026-07-28): an outcome is a record, not a
            click — the sentence shows on every future card for this owner. */}
        <textarea value={note} onChange={e => setNote(e.target.value)} rows={2} placeholder="What happened? Required — this shows on every future card for this owner."
          className="w-full p-2 border rounded text-sm mb-3" />
        {/* The WHY, stated once, in the actor's own interest (Mark 08-28 —
            "gently teach him to think"): the label sells the pick. */}
        <p className="text-[11px] text-gray-400 mb-2">No pick = the tool forgets this owner. A pick = they come back at the right time, without you having to remember anything.</p>
        <div className="text-xs font-semibold text-gray-600 mb-1">What did the owner choose?</div>
        <div className="grid grid-cols-1 gap-1 mb-2">
          {SE_DISPOSITIONS.map(x => (
            <label key={x.key} className={`flex items-center gap-2 text-xs p-1.5 rounded cursor-pointer ${disposition === x.key ? 'bg-indigo-50' : ''}`}>
              <input type="radio" name="se-disposition" checked={disposition === x.key} onChange={() => setDisposition(x.key)} />
              <span>{x.label}</span>
              <span className="text-gray-400">{x.hint ? `— ${x.hint}` : ''}</span>
            </label>
          ))}
        </div>
        {/* AM-side plays (Mark 2026-08-04): no owner input needed — seeing
            the options is the coaching. Any pick retires stacked reminders. */}
        <div className="text-xs font-semibold text-violet-700 mb-1">Or your play — no owner input needed:</div>
        <div className="grid grid-cols-1 gap-1 mb-3">
          {SE_STRATEGIES.filter(x => !x.vtOnly || vtActive).map(x => (
            <label key={x.key} className={`flex items-center gap-2 text-xs p-1.5 rounded cursor-pointer ${disposition === x.key ? 'bg-violet-50' : ''}`}>
              <input type="radio" name="se-disposition" checked={disposition === x.key} onChange={() => setDisposition(x.key)} />
              <span>{x.label}</span>
              <span className="text-gray-400">{x.hint ? `— ${x.hint}` : ''}</span>
            </label>
          ))}
        </div>
        {nextDate && <p className="text-xs text-gray-500 mb-3">Next touch: <strong>{nextDate}</strong>{d ? " — owner-consented, it'll come back on the serving that day." : ' — your play, it comes back on the serving that day (set a different date in the commitment row).'}</p>}
        {strat && strat.clearTouch && <p className="text-xs text-emerald-700 mb-3">Personal cadence ends deliberately — the owner becomes wave-eligible and the monthly marketing keeps them warm. Any stacked reminders retire.</p>}
        <div className="border-t pt-2 mb-3">
          {/* Renamed 08-06 (Adam, day one: "can you add a field for a custom
              follow-up date? I want to follow up in December" — the field
              existed right here, but "Specific commitment?" didn't say so). */}
          <div className="text-xs font-semibold text-gray-600 mb-1">📅 Follow up on a specific date <span className="font-normal text-gray-400">("call me in December", "the 15th") — becomes a card on your plate that day; beats the preset above whenever the owner named a time</span></div>
          <div className="grid grid-cols-3 gap-2">
            <input type="date" value={commitDue} onChange={e => setCommitDue(e.target.value)} className="p-1.5 border rounded text-xs" />
            <input type="text" value={commitNote} onChange={e => setCommitNote(e.target.value)} placeholder="What was promised" className="col-span-2 p-1.5 border rounded text-xs" />
          </div>
        </div>
        <div className="flex justify-end gap-2 items-center">
          {/* The PICK is required, not just the note (Mark's law, enforced
              here 08-17 — the 08-13 audit assumed this modal already
              complied, but Save only demanded the note): an outcome with no
              disposition, no strategy, and no dated commitment is a touch
              wearing an outcome's clothes — and it can't clear the card,
              because there's no decision to point to. */}
          {!disposition && !commitDue && <span className="text-xs text-amber-700 mr-auto">Pick what the owner chose, your play, or a specific date — the outcome IS the pick.</span>}
          <button type="button" onClick={onClose} className="px-3 py-1.5 text-xs rounded border border-gray-300 text-gray-600">Cancel</button>
          <button type="button" disabled={saving || !note.trim() || (!disposition && !commitDue)}
            title={!note.trim() ? 'Write a sentence about what happened first.' : (!disposition && !commitDue) ? 'Pick a disposition, a strategy play, or set a specific follow-up date.' : undefined}
            onClick={async () => { setSaving(true); await onSave({ kind, note: note.trim(), disposition, commitDue, commitNote }); setSaving(false); }}
            className="px-4 py-1.5 text-xs font-semibold rounded bg-indigo-600 text-white hover:bg-indigo-700 disabled:bg-gray-300">
            Save
          </button>
          {/* Why Save is grey, in plain text (Adam 09-24, Flexsim: he typed the
              note and saw "no way to save it" — the reason lived only in a
              hover tooltip). */}
          {(!note.trim() || (!disposition && !commitDue)) && (
            <div className="w-full text-[11px] text-amber-700 mt-1">
              {!note.trim() ? 'Write a sentence about what happened, then ' : 'Now '}pick what the owner chose, a strategy play, or a follow-up date — the note saves with the pick.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// ===== DM cards on My Work (consolidation Phase 1, 2026-08-05) =====
// Deal Manager reminders computed by /api/dm/my-work from DM's own
// triage/Q&A rules, attributed per person. Cards deep-link into DM for
// people with the dm module; everyone else sees the signal as a plain
// card (Adam's cards tell him what's owed without needing DM access).
const DM_PAGE_HASH = { triage: '#triage', qa: '#qa', listings: '#listings' };
const DMSignalsSection = ({ view, canOpenDm }) => {
  if (!view) return null;
  const Card = ({ i }) => {
    const inner = (
      <React.Fragment>
        <div className="text-sm font-medium text-gray-800">{i.title}</div>
        <div className="text-xs text-gray-500 mt-0.5">
          {i.sub}
          {i.alert && i.age_days != null && <span className="text-red-600 font-semibold"> · stuck {i.age_days}d</span>}
          {canOpenDm ? ' · opens Deal Manager ↗' : ''}
        </div>
      </React.Fragment>
    );
    return canOpenDm ? (
      <a href={`https://app.vistabusinessgroup.com/${DM_PAGE_HASH[i.dm_page] || ''}`} target="_blank" rel="noopener"
        className={`block bg-white border rounded-lg p-3 hover:shadow-md transition ${i.alert ? 'border-red-300' : 'border-gray-200'}`}>{inner}</a>
    ) : (
      <div className={`bg-white border rounded-lg p-3 ${i.alert ? 'border-red-300' : 'border-gray-200'}`}>{inner}</div>
    );
  };
  const grid = (items) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{items.map((i, n) => <Card key={n} i={i} />)}</div>
  );
  const count = view.mine ? view.mine.length : Object.values(view.grouped).reduce((s, a) => s + a.length, 0);
  const radar = !view.mine; // owner's exception view
  return (
    <div className="mb-6">
      <h2 className={`text-sm font-bold uppercase tracking-wide ${radar ? 'mb-1 text-red-700' : 'mb-3 text-gray-600'}`}>
        {radar ? '🔥 Deal Manager — needs attention' : '🏢 Deal Manager'} <span className="text-gray-400 font-normal">({count})</span>
      </h2>
      {radar && <p className="text-xs text-gray-400 mb-3">Only items stuck a week-plus (owner answers: 3d+ · deadlines inside 3d) — the full queues live in DM.</p>}
      {view.mine ? grid(view.mine) : (
        Object.entries(view.grouped).map(([who, items]) => (
          <div key={who} className="mb-3">
            <div className="text-xs font-bold text-gray-500 uppercase mb-2">{who} ({items.length})</div>
            {grid(items)}
          </div>
        ))
      )}
    </div>
  );
};

// ── Valuation-meeting outcome card (Mark 09-21: everything on the card, the
// decision recorded from the card). Three states: meeting ahead → prep
// reminder with ✓ Reviewed (parks until the meeting day); meeting passed /
// still deciding → the decision picker; circle-back without a review date →
// the same picker, minus "still deciding".
const VO_DECISIONS = [
  ['engaged',               '✅ Engaged — agreement signed',                          true],
  ['strategic_review_set',  '📅 Strategic review meeting — date required',           true],
  ['considering_followup',  'Still deciding — follow up on a date + why (stays Awaiting Decision; 3+ months out = Considering)', false],
  ['val_complete_inactive', 'Not ready — inactive (leave-off note)',                 false],
  ['val_complete_dead',     'Not for sale — why',                                    false],
  ['awaiting_decision',     'Still deciding — why',                                  false],
];
const ValuationOutcomeCard = ({ p, onRecord, onAgreementOut, onSetLikelihood, onReviewed, onOpen, viewers = [] }) => {
  const [open, setOpen] = useState(false);
  const [decision, setDecision] = useState('');
  const [date, setDate] = useState('');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const today0 = new Date(new Date().toISOString().slice(0, 10) + 'T00:00:00');
  const md = p.next_meeting_date ? new Date(p.next_meeting_date + 'T00:00:00') : null;
  const meetingAhead = p.workflow_stage === 'val_meeting_set' && md && md >= today0;
  const meetingPassed = p.workflow_stage === 'val_meeting_set' && md && md < today0;
  const deciding = p.workflow_stage === 'awaiting_decision';
  const circleBack = p.workflow_stage === 'considering_followup';
  const fmtD = (d) => d ? new Date(String(d).length === 10 ? d + 'T00:00:00' : d).toLocaleDateString() : null;
  const money = (n) => (n == null || n === '' || isNaN(Number(n)) || !Number(n)) ? null : '$' + Math.round(Number(n)).toLocaleString();
  const daysSince = (d) => d ? Math.floor((Date.now() - new Date(String(d).length === 10 ? d + 'T00:00:00' : d).getTime()) / 86400000) : null;
  const overdue = !!p.stageOverdue || meetingPassed || circleBack;
  const border = overdue ? 'border-amber-300' : 'border-gray-200';
  const options = VO_DECISIONS.filter(([k]) => !(circleBack && (k === 'awaiting_decision' || k === 'considering_followup')));
  const needsDate = decision === 'strategic_review_set' || decision === 'considering_followup';
  const needsReason = ['considering_followup', 'val_complete_dead', 'awaiting_decision', 'val_complete_inactive'].includes(decision);
  const canSave = !!decision && (!needsDate || !!date) && (!needsReason || !!reason.trim());
  const ai = p.ai_status && typeof p.ai_status === 'object' ? p.ai_status : null;
  const t = p.emailTruth;
  const awaitingUs = t && t.lastIn && (!t.lastOut || t.lastIn > t.lastOut);
  const headline = meetingAhead
    ? `Review the valuation — meeting ${fmtD(p.next_meeting_date)}`
    : meetingPassed ? 'Record the valuation meeting outcome'
    : deciding && p.agreementOutAt ? '📝 Agreement out — get it signed'
    : deciding ? 'Get the owner\'s decision'
    : 'Get a review date on the calendar';
  const waitingOn = meetingAhead
    ? 'Nothing to clear — prep, then ✓ Reviewed parks this until the meeting morning.'
    : meetingPassed ? `Meeting was ${fmtD(p.next_meeting_date)} · ${daysSince(p.next_meeting_date)}d ago · no decision recorded`
    : deciding && p.agreementOutAt ? `Agreement sent ${fmtD(p.agreementOutAt)} · ${daysSince(p.agreementOutAt)}d — record ✅ Engaged when it's signed`
    : deciding ? `Still deciding since ${fmtD(p.stage_entered_at)} · ${daysSince(p.stage_entered_at)}d${p.snooze_until ? ' · follow up ' + fmtD(p.snooze_until) : ''}`
    : `Circle-back ${p.snooze_until ? 'on ' + fmtD(p.snooze_until) : 'date not set'} · closed ${daysSince(p.stage_entered_at)}d ago${p._nagWhy ? ' — ' + p._nagWhy : ' without a review date'}`;
  return (
    <div className={`bg-white border ${border} rounded-lg p-4 w-full`}>
      <div className="flex items-start justify-between gap-2 mb-1">
        <div className="font-semibold text-gray-800 truncate">{p.company_name}{p.owner_first_name ? <span className="text-gray-400 font-normal"> · {p.owner_first_name}</span> : null}</div>
        <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded ${stageColor(p.workflow_stage)} whitespace-nowrap`}>{stageLabel(p.workflow_stage)}</span>
      </div>
      {viewers.length > 0 && <div className="text-xs font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 mb-2">👁 {viewers.join(', ')} {viewers.length === 1 ? 'has' : 'have'} this file open</div>}
      <div className="text-sm text-gray-800 font-medium">▸ {headline}</div>
      <div className={`text-xs mb-2 ${overdue ? 'text-amber-800' : 'text-gray-500'}`}>{waitingOn}</div>
      <div className="text-xs text-gray-700 space-y-0.5 mb-2">
        <div><span className="text-gray-400">Value on record:</span> {money(p.value_provided_high) ? <span className="font-medium">{money(p.value_provided_high)}</span> : <span className="text-gray-400">not captured yet</span>}{p.valuation_date ? <span className="text-gray-400"> · valued {fmtD(p.valuation_date)}</span> : null}</div>
        {ai && ai.last && <div><span className="text-gray-400">Last known:</span> {ai.last}</div>}
        {ai && ai.next && <div><span className="text-gray-400">Next:</span> {ai.next}</div>}
        {p.interactionNote && !ai && <div className="text-gray-500 line-clamp-2"><span className="text-gray-400">Last note:</span> {p.interactionNote}</div>}
        {t && (t.lastOut || t.lastIn) && (
          <div className={awaitingUs ? 'text-amber-700' : 'text-emerald-700'}>📧 {awaitingUs
            ? `owner emailed ${formatRelativeDate(t.lastIn)} — awaiting our reply`
            : `${t.lastOutBy || 'we'} emailed the owner ${formatRelativeDate(t.lastOut)}${t.lastIn ? ` · owner last wrote ${formatRelativeDate(t.lastIn)}` : ''}`}</div>
        )}
      </div>
      {!meetingAhead && <div className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1 mb-2">The two outcomes that count: an <b>engagement</b>, or a <b>strategic-review date</b> on the calendar. Until one is recorded this deal is invisible to follow-ups, the review cadence and the pipeline.</div>}
      {open && (
        <div className="border border-emerald-200 bg-emerald-50 rounded p-2 mb-2 text-xs space-y-1.5">
          <div className="font-semibold text-gray-700">Owner's decision</div>
          {options.map(([k, l, big]) => (
            <label key={k} className={`flex items-center gap-2 rounded px-2 py-1 cursor-pointer border ${decision === k ? 'border-emerald-500 bg-white' : big ? 'border-emerald-200 bg-white/60' : 'border-transparent text-gray-500'} ${big ? 'font-semibold text-gray-800' : ''}`}>
              <input type="radio" name={`vo-${p.id}`} checked={decision === k} onChange={() => setDecision(k)} /><span>{l}</span>
            </label>
          ))}
          {needsDate && <div className="flex items-center gap-2"><span className="text-gray-600">{decision === 'strategic_review_set' ? 'Review meeting date' : 'Circle-back date'} <span className="text-red-500">*</span></span><input type="date" value={date} onChange={e => setDate(e.target.value)} className="border border-gray-300 rounded px-1.5 py-0.5" /></div>}
          {needsReason && <input type="text" value={reason} onChange={e => setReason(e.target.value)} placeholder={decision === 'val_complete_inactive' ? 'Where did it leave off? (required)' : 'Why not an engagement or a review date? (required)'} className="w-full border border-gray-300 rounded px-2 py-1" />}
          <div className="flex justify-end gap-2">
            <button type="button" className="px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-white" onClick={() => setOpen(false)}>Cancel</button>
            <button type="button" disabled={!canSave || busy} className="px-2.5 py-1 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700 disabled:opacity-40"
              onClick={async () => { setBusy(true); const ok = await onRecord(p, { decision, date, reason }); setBusy(false); if (ok) setOpen(false); }}>{busy ? 'Saving…' : 'Record outcome'}</button>
          </div>
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        {meetingAhead ? (
          onReviewed && <button type="button" className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700" title="Parks this card until the meeting morning — it comes back next to Meeting Prep that day." onClick={() => onReviewed(p)}>✓ Reviewed — hide until the meeting</button>
        ) : (
          !open && <button type="button" className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700" onClick={() => setOpen(true)}>📝 Record the outcome</button>
        )}
        {(deciding || circleBack) && !p.agreementOutAt && onAgreementOut && <button type="button" className="text-xs px-2 py-1 rounded border border-emerald-400 text-emerald-800 hover:bg-emerald-50" title="The owner asked for the engagement agreement and it went out — the deal moves to the top of Awaiting Decision until it's signed." onClick={() => onAgreementOut(p)}>📝 Agreement out</button>}
        {p.owner_email && <button type="button" className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-50" onClick={() => setShowNotes(v => !v)}>{showNotes ? 'Hide notes' : '🎙 Meeting notes'}</button>}
        <button type="button" className="text-xs px-2 py-1 rounded border border-violet-300 text-violet-700 hover:bg-violet-50 ml-auto" onClick={onOpen}>📂 Open in VT</button>
      </div>
      {(deciding || circleBack) && onSetLikelihood && (
        <div className="flex items-center gap-1.5 mt-2 text-xs" title="Your read on this owner — the staff meeting sorts Awaiting Decision by it.">
          <span className="text-gray-400">Likely to engage?</span>
          {LIKELIHOOD_MARKS.map(([m, label, pct]) => {
            const on = likelihoodMark(p.likelihood_pct) === m;
            return <button key={m} type="button" title={label} onClick={() => onSetLikelihood(p, pct)}
              className={`px-1.5 py-0.5 rounded border ${on ? 'border-emerald-500 bg-emerald-50 font-semibold' : 'border-gray-200 hover:bg-gray-50'}`}>{m} {label}</button>;
          })}
        </div>
      )}
      {showNotes && p.owner_email && <div className="mt-2"><FirefliesNotesPanel ownerEmail={p.owner_email} overviewOnly={true} /></div>}
    </div>
  );
};

const MyWorkView = ({ amHandoffs = null, onAmHandoffDone = null, tieOverrides = [], onTieOverrideSeen, onInviteLiveCall, onInviteCallbackChase, buckets, myName, role, dmSignals, canOpenDm, sortQueue = [], showSortQueue = false, onResolveSortQueue, onOpenValuation, onDismissReminder, presenceByValuation = {}, onSetFollowUp, onClearFollowUp, onLogOutreach, onReEngage, onMarkDead, onSendWarmIntro, onActivateWarm, onReviewedPortalUpdate, onDismissRevalueDocs, seServing, seServingMode, seIdeasGate = 0, onSeLog, onSeReached, onSeSnooze, onSeFetchNext, onSeCadenceSent, onSeReplied, onSeNoReply, onSeRemind, onSeAwait, onSeHandOff, onSeDropDate, seFetchLocked, seTeamOverdue, partialDecisions, onPartialDecision, closingEscalations, onClosingStall, stagedSends, onStagedSendAct, onStagedSendBulk, onLinkedInPosted, onContactGoneSold, onBounceChoose, mtToday, mtPrep = {}, mtClassify, mtClassifyBuyers = {}, onMeetingClassify, onMeetingClassifyDismiss, onMeetingClassifyHandOff, meetingTruth, onMeetingHeld, onMeetingHeldAll, onMeetingNoShow, onMeetingTypeChange, onMeetingHandOff, onMeetingRemind, buyerReviews, onBuyerReviewAct, buyerReviewShowHolder, buyerFollow, onBuyerFollowAct, onBuysideStep, buysideNewMatch, onTieBuyer, seNewReminder, buysideBoard = null, onRevivalResume, onRevivalDismiss, listedKeys = null, reviewOutcomes = null, onReviewOutcome, onOwnerWaitingDismiss, onOwnerWaitingDefer, onSetReviewDate, inviteChecks, onRequestFinancialUpdate, onPauseFinancialReminders, onAdvanceAsOf, onHoldAsOf, onDiscoveryNudge, onFirstMileTouch, onFirstMileWaive, onSetStars, buysidePool, onBuysideClaim, buysideClaimGate, scottAsk, onScottAsked, wagonCards, onWagonHandled, buysideRadar, seBuysideMatches = null, seFinish, onSeFinishPick, onRecordOutcome, onDataEntered, onUploadWaiting, seMyReminders = [], onSeMyReminder, onAgreementOut, onSetLikelihood, onMarkReviewed, onWarmMissed, onWarmAwait, onWarmStrategy, onWarmQualify }) => {
  // Universal toolbar plumbing: the client → SE-row map every VT card reads
  // (one query, a few hundred rows) + who's clicking (for ＋ Add a note).
  const [, bumpToolbar] = useState(0);
  useEffect(() => { CARD_ACTOR_NAME = myName || null; }, [myName]);
  useEffect(() => {
    let cancelled = false;
    if (!supabaseClient) return;
    (async () => {
      try {
        const rows = await fetchAllRows(() => supabaseClient.from('se_owners')
          .select('id, vt_client_id').not('vt_client_id', 'is', null).order('id', { ascending: true }));
        if (cancelled) return;
        (rows || []).forEach(r => { if (r.vt_client_id && !SE_OWNER_BY_CLIENT.has(r.vt_client_id)) SE_OWNER_BY_CLIENT.set(r.vt_client_id, r.id); });
        bumpToolbar(t => t + 1);
      } catch (e) { console.warn('SE-row map for card toolbars skipped:', e?.message || e); }
    })();
    return () => { cancelled = true; };
  }, [buckets]);
  // A STABLE section component (Zac 10-23 🐞: "when my dashboard updates, every 20 seconds or so, it cancels all progress
  // I make on a card"). Section used to be defined right here as a new component on every render, so each Dashboard
  // redraw (the 20-second 'who has this deal open' check) made React unmount and rebuild every card, losing typed notes
  // and open forms. Now the component type is created once; it always draws with the latest render function.
  const sectionRenderRef = useRef(null);
  sectionRenderRef.current = ({ title, items, tone, emptyHint, note, outcome = false }) => (
    <div className="mb-6">
      <h2 className={`text-sm font-bold uppercase tracking-wide ${note ? 'mb-1' : 'mb-3'} ${tone === 'red' ? 'text-red-700' : tone === 'amber' ? 'text-amber-700' : 'text-gray-600'}`}>
        {title} <span className="text-gray-400 font-normal">({items.length})</span>
      </h2>
      {note && <p className="text-xs text-gray-400 mb-3">{note}</p>}
      {items.length === 0 ? (
        <div className="text-sm text-gray-400 italic">{emptyHint}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map(p => (
            (outcome && onRecordOutcome && (p.workflow_stage === 'val_meeting_set' || p.workflow_stage === 'awaiting_decision' || p.workflow_stage === 'considering_followup'))
              ? <ValuationOutcomeCard key={p.id} p={p} onRecord={onRecordOutcome} onAgreementOut={onAgreementOut} onSetLikelihood={onSetLikelihood} onReviewed={onMarkReviewed} viewers={presenceByValuation[p.id] || []} onOpen={() => onOpenValuation({ id: p.id, name: p.name, openTarget: p.openTarget })} />
              : (p.workflow_stage === 'upload_complete' && onDataEntered && role === 'document_mgmt')
                ? <div key={p.id} className="flex flex-col gap-1">
                    <ProjectCard project={p} tone={tone} viewers={presenceByValuation[p.id] || []} onOpen={() => onOpenValuation({ id: p.id, name: p.name, openTarget: p.openTarget })} />
                    <div className="flex flex-wrap gap-2">
                      <button type="button" className="text-xs px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700" title="All received data is entered — hands the deal to Colleen." onClick={() => onDataEntered(p)}>✓ Data entered — hand to Colleen</button>
                      {onUploadWaiting && (
                        <button type="button" className="text-xs px-2 py-1 rounded border border-amber-300 bg-white text-amber-800 hover:bg-amber-50" title="You entered what's in and asked the owner for what's missing — parks the card (and the 7:30 email) until your check-back date." onClick={() => onUploadWaiting(p)}>⏳ Waiting on the owner</button>
                      )}
                    </div>
                  </div>
                : <ProjectCard key={p.id} project={p} tone={tone} viewers={presenceByValuation[p.id] || []} onOpen={() => onOpenValuation({ id: p.id, name: p.name, openTarget: p.openTarget })} />
          ))}
        </div>
      )}
    </div>
  );
  const Section = useMemo(() => function MyWorkSection(props) { return sectionRenderRef.current(props); }, []);
  return (
    <div>
      {/* WHY THE CARDS EXIST, said every time (Mark 10-28: "remind Adam at every opportunity, that the reason for the
          cards is to increase his deal flow, his commissions, and make sure he doesn't forget to follow up or drops
          the ball"). Account managers' plates open with it. */}
      {role === 'account_manager' && (
        <div className="mb-4 text-xs bg-emerald-50 border border-emerald-200 rounded px-3 py-2 text-emerald-800">
          💰 <strong>Your cards are your deal flow.</strong> Each one is a follow-up VT is holding for you so no owner slips. Work them top to bottom: every card you close out moves an owner toward a listing, and toward your commission.
        </div>
      )}
      {/* 📅 Meeting prep sits at the very top of the plate (Mark 09-16) — the
          first thing you reach for when a meeting's coming up. */}
      {seMyReminders && seMyReminders.length > 0 && (
        <MyRemindersSection items={seMyReminders} onAct={onSeMyReminder} />
      )}
      {mtToday && mtToday.length > 0 && (
        <MeetingsTodaySection items={mtToday} prep={mtPrep} onLog={onSeLog} onTypeChange={onMeetingTypeChange} onOpenValuation={onOpenValuation} onTieBuyer={onTieBuyer} actor={myName} />
      )}
      {role === 'owner' && seTeamOverdue && seTeamOverdue.length > 0 && (
        <div className="mb-4 text-xs bg-indigo-50 border border-indigo-200 rounded px-3 py-2 text-indigo-800">
          📞 <strong>Sales Engine — follow-ups a week-plus overdue:</strong>{' '}
          {seTeamOverdue.map(t => `${t.name} ${t.count}${t.unanswered ? ` (+${t.unanswered} 📧 unanswered)` : ''}`).join(' · ')}
          <span className="text-indigo-500"> — each also lands in that person's 7:30 nudge email.</span>
        </div>
      )}
      {role === 'owner' && buckets.teamOverdue && buckets.teamOverdue.length > 0 && (
        <TeamOverdueSection items={buckets.teamOverdue} onOpen={onOpenValuation} />
      )}
      {!myName && (
        <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded p-4 text-sm">
          Your login isn't in the staff directory yet, so My Work can't personalize project assignments. Switch to Pipeline for the full list. Reminders above are still yours.
        </div>
      )}
      {/* ── Follow up — deals waiting on you ── */}
      {myName && <div className="mt-2 mb-3 pt-2 border-t border-gray-200 text-[10px] font-bold uppercase tracking-widest text-gray-400">Follow up — deals waiting on you<span className="normal-case font-normal tracking-normal text-gray-400"> — do these first; empty means your pipeline is moving</span></div>}
      {/* 🧰 "On your plate" — the VT work you can clear — sits right under
          Meeting Prep (Zac 09-17: "it's at the bottom of my page but the most
          important"). Was buried in the VT block near the bottom. Never
          populated for an AM (their work routes through the follow-up
          sections), so it stays suppressed on their view. */}
      {myName && role !== 'account_manager' && (
        <Section title="On your plate" items={buckets.onYourPlate} tone="neutral" emptyHint="Inbox zero — nicely done." outcome />
      )}
      {buckets.noReviewDate && buckets.noReviewDate.length > 0 && (
        <Section title="⚠ Left without a review date" items={buckets.noReviewDate} tone="amber" outcome
          note="A circle-back whose date has passed, or that has no reason on record — no engagement, no review meeting on the calendar. Record the outcome here and this clears. A circle-back with a future date AND a written reason is a plan and doesn't card." />
      )}
      {buckets.leadFollowUpDue && buckets.leadFollowUpDue.length > 0 && (
        <AmFollowUpSection
          title="⏰ Circle-back dates arrived — owner said 'check back with me'"
          items={buckets.leadFollowUpDue} outcome
          collapsed={false}
          note="Owners who asked us to circle back, and the date has arrived. Reach out, then push the date or record their decision."
          onOpenValuation={onOpenValuation}
          onSetFollowUp={onSetFollowUp}
          onClearFollowUp={onClearFollowUp}
          onLogOutreach={onLogOutreach}
        />
      )}
      {/* ⚠ OWNER WAITING ON YOU — the loudest section on the plate, first
          by design (Mark 09-10, Concise: a ready-to-sign owner's email sat
          six days). Recipient-routed: it appears on the plate of whoever's
          mailbox received the email, whatever the tier or assignment. */}
      {buckets.ownerWaiting && buckets.ownerWaiting.length > 0 && (
        <div className="mb-6">
          <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-red-700">
            ⚠ Owner waiting on YOU <span className="text-gray-400 font-normal">({buckets.ownerWaiting.length})</span>
          </h2>
          <p className="text-xs text-gray-500 mb-3">Their last email came after our last one, and a business day has passed. The system only knows <i>who wrote last</i> — whether it needs an answer is <b>your</b> call: reply from 🧵 (↩ sends from your own mailbox), or if it was answered by phone or meeting, is an FYI, or closed the conversation, click <b>✕ No reply needed</b> and it's gone until they write again. The standard for real questions is <b>one business day</b>.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {buckets.ownerWaiting.map(p => (
              <div key={p.id} className={`bg-white border-2 rounded-lg p-3 ${p._waitDays >= 2 ? 'border-red-500' : 'border-red-300'}`}>
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2 min-w-0">
                    <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
                    <ProvenanceChip p={p} />
                  </div>
                  <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded whitespace-nowrap ${p._waitDays >= 2 ? 'bg-red-600 text-white' : 'bg-red-100 text-red-700'}`}>
                    {p._waitDays}d waiting
                  </span>
                </div>
                <div className="text-xs text-gray-600 mt-1">
                  Owner emailed {p._waitMailbox ? <b>{p._waitMailbox === myName ? 'you' : p._waitMailbox}</b> : 'us'} {new Date(p._waitSince).toLocaleString()} — no reply from anyone at Vista since. {(WORKFLOW_STAGES[p.workflow_stage] || {}).label || p.workflow_stage}{p.lead ? ` · Lead ${p.lead}` : ''}
                </div>
                {/* 💬 the glance (Mark 09-14): the owner's words on the card;
                    🧵 for the full thread. Same mechanic as first-mile. */}
                {p._lastMsg && p._lastMsg.snippet ? (
                  <div className="text-xs text-gray-700 mt-1 bg-gray-50 border border-gray-200 rounded px-2 py-1"
                    title={`${p._lastMsg.subject || ''}\n${p._lastMsg.snippet || ''}`}>
                    💬 “{String(p._lastMsg.snippet).replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n))).replace(/&amp;/g, '&').replace(/\s+/g, ' ').slice(0, 110)}”
                  </div>
                ) : null}
                {p._defer && p._defer.until ? (
                  <div className="text-[11px] font-semibold text-amber-700 mt-1">⏰ You scheduled this answer for {new Date(p._defer.until + 'T00:00:00').toLocaleDateString()}{p._deferCount > 1 ? ` — deferred ${p._deferCount}× now` : ''}. Today's the day.</div>
                ) : null}
                <div className="flex items-center justify-between gap-2 mt-2">
                  <CardToolbar valuationId={p.id} companyName={p.company_name} actor={myName} />
                  <div className="flex gap-2">
                    <button type="button" onClick={() => onOwnerWaitingDefer && onOwnerWaitingDefer(p)}
                      title="The reply is real but not today's — pick the date you'll answer. The card hides until then and returns that morning showing the deferral. One business day stays the default."
                      className="px-2 py-1 text-xs font-semibold rounded border border-amber-300 text-amber-700 hover:bg-amber-50">⏰ Answering on…</button>
                    <button type="button" onClick={() => onOwnerWaitingDismiss && onOwnerWaitingDismiss(p)}
                      title="This email doesn't need an emailed reply — answered by phone or meeting, an FYI, or a conversation closer. Logged with your note; a NEWER email from the owner cards again."
                      className="px-2 py-1 text-xs font-semibold rounded border border-gray-300 text-gray-600 hover:bg-gray-50">✕ No reply needed</button>
                    <button type="button" onClick={() => onOpenValuation({ id: p.id, name: p.name })}
                      className="px-3 py-1 text-xs font-semibold rounded bg-red-600 text-white hover:bg-red-700">Open deal</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <AmFollowUpSection
        title="Owners to follow up"
        items={buckets.amFollowUp}
        collapsed={false}
        onOpenValuation={onOpenValuation}
        onSetFollowUp={onSetFollowUp}
        onClearFollowUp={onClearFollowUp}
        onLogOutreach={onLogOutreach}
        onRevivalResume={onRevivalResume}
        onRevivalDismiss={onRevivalDismiss}
        onReEngage={onReEngage}
        onMarkDead={onMarkDead}
      />
      {/* AM-specific empty state: their plate is the follow-up list, so when
          both AM buckets are empty give them a tailored "all clear" rather
          than the generic Konnie/Colleen "Inbox zero" plate below. */}
      {role === 'account_manager' && (buckets.amFollowUp?.length || 0) === 0 && (buckets.amLater?.length || 0) === 0 && (
        <div className="text-sm text-gray-400 italic mb-6">No owners need follow-up right now — stalled owners and post-valuation re-engagements will appear here when they're handed to you.</div>
      )}
      <WarmSection
        title="Warm — sent for intro / awaiting the meeting"
        items={buckets.amWarm}
        mode="am"
        note="Warm accounts you created. Send or resend the owner's intro + portal link, and follow up on any that haven't moved."
        onOpenValuation={onOpenValuation}
        onSendWarmIntro={onSendWarmIntro}
        onActivateWarm={onActivateWarm} onWarmMissed={onWarmMissed} onWarmAwait={onWarmAwait} onWarmStrategy={onWarmStrategy} onWarmQualify={onWarmQualify}
      />
      {buckets.upcomingReviews && buckets.upcomingReviews.length > 0 && (
        <Section title="Strategic reviews — this week" items={buckets.upcomingReviews} tone="neutral" emptyHint="" />
      )}
      {/* Warm accounts (Warm → Active onboarding). Lead's: activate or pass
          after the meeting. AM's: send/resend the intro + chase no-shows. */}
      <WarmSection
        title="Warm — activate after the meeting"
        items={buckets.leadWarm}
        mode="lead"
        note="Accounts you'll lead, set up pre-meeting. After the introductory meeting, activate (sets the committal date + releases documents) or pass if it's not a fit."
        onOpenValuation={onOpenValuation}
        onSendWarmIntro={onSendWarmIntro}
        onActivateWarm={onActivateWarm} onWarmMissed={onWarmMissed}
      />
      {buckets.toReview && buckets.toReview.length > 0 && (
        <Section title="To review — analysis complete" items={buckets.toReview} tone="neutral" emptyHint="" />
      )}
      {buckets.needsSetup && buckets.needsSetup.length > 0 && (
        <NeedsSetupSection items={buckets.needsSetup} onOpenValuation={onOpenValuation} presenceByValuation={presenceByValuation} />
      )}
      {/* Owner questions (Colleen) — a dedicated nudge so flagged-but-unsent
          and sent-but-unanswered questions can't slip. Prominent (amber),
          above the plate. Cards show the 📤 to-send / ⏳ awaiting / ⏰ indicators. */}
      {role === 'analysis' && (buckets.ownerQuestions?.length || 0) > 0 && (
        <Section
          title="Owner questions — send & follow up"
          items={buckets.ownerQuestions}
          tone="amber"
          note="📤 ready to send — the owner isn't notified until you hit “Send owner questions.”  ⏳ sent, awaiting a reply.  ⏰ after 3 days — open it and re-send to nudge."
        />
      )}
      {/* Portal-form reviews (Konnie — Mark 2026-08-04): the owner finished
          a portal form; review & accept applies it to the deal's data. */}
      {role === 'document_mgmt' && (buckets.formReviews?.length || 0) > 0 && (
        <Section
          title="Portal forms — review & accept"
          items={buckets.formReviews}
          tone="amber"
          note="The owner marked a form finished. Open the deal — the green banner (Revenue & COGS for Revenue Classification, Sales Analysis for Client Detail) shows their answers with an Accept button. An empty form gets an amber “Acknowledge — nothing to apply.”"
        />
      )}
      {buckets.receivedWorklist && buckets.receivedWorklist.length > 0 && (
        <ReceivedWorklistSection items={buckets.receivedWorklist} onOpen={onOpenValuation} />
      )}
      {(role === 'lead' || role === 'owner') && buckets.firstMileTouches && buckets.firstMileTouches.length > 0 && (
        <FirstMileSection items={buckets.firstMileTouches} onTouch={onFirstMileTouch} onWaive={onFirstMileWaive} onOpen={onOpenValuation} onSetStars={onSetStars} actor={myName} />
      )}
      {partialDecisions && partialDecisions.length > 0 && (
        <PartialDecisionSection items={partialDecisions} onDecide={onPartialDecision} showHolder={role === 'owner'} />
      )}
      {/* ⚠ Ties to the source — overrides (Mark 10-12): a deal went to Colleen without its numbers
          matching the owner's statements. Owner radar only; everything to judge it is on the card. */}
      {tieOverrides && tieOverrides.length > 0 && (
        <div className="mb-6 bg-amber-50 border border-amber-300 rounded-lg px-4 py-3">
          <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-amber-800">⚠ Handed on without matching the statements <span className="text-gray-500 font-normal">({tieOverrides.length})</span></h2>
          {tieOverrides.map(r => (
            <div key={r.id} className="text-sm text-gray-800 py-1.5 border-t border-amber-200">
              <b>{(r.metadata && r.metadata.company) || 'A deal'}</b> · {r.actor_name || 'staff'}: “{r.metadata && r.metadata.tie_out && r.metadata.tie_out.override}”
              {r.metadata && r.metadata.tie_out && (r.metadata.tie_out.bad || []).length > 0 && (
                <div className="text-xs text-red-700 mt-0.5">{r.metadata.tie_out.bad.slice(0, 4).join(' · ')}</div>
              )}
              {r.metadata && r.metadata.tie_out && r.metadata.tie_out.unticked > 0 && (
                <div className="text-xs text-amber-800 mt-0.5">{r.metadata.tie_out.unticked} number(s) not checked against the statement</div>
              )}
              <div className="mt-1 flex gap-3 text-xs">
                <button type="button" className="underline text-indigo-700" onClick={() => onOpenValuation({ id: r.project_id })}>Open</button>
                {onTieOverrideSeen && <button type="button" className="underline text-gray-600" onClick={() => onTieOverrideSeen(r.id)}>✓ Seen</button>}
              </div>
            </div>
          ))}
        </div>
      )}
      {closingEscalations && closingEscalations.length > 0 && (
        <ClosingEscalationSection items={closingEscalations} onStallSave={onClosingStall} />
      )}
      {stagedSends && stagedSends.length > 0 && (
        <StagedSendsSection part="cards" items={stagedSends} onAct={onStagedSendAct} onBulk={onStagedSendBulk} onLinkedInPosted={onLinkedInPosted} onContactGoneSold={onContactGoneSold} onBounceChoose={onBounceChoose} showHolder={role === 'owner'} />
      )}
      {buckets.discoveryPrep && buckets.discoveryPrep.length > 0 && (
        <DiscoveryPrepSection items={buckets.discoveryPrep} onNudge={onDiscoveryNudge} onOpen={onOpenValuation} canNudge={role !== 'account_manager'} />
      )}
      {/* 📋 Review-outcome cards (Mark 09-10 "Go": a held strategic review
          asks for its decision until one is on the record — the SE side's
          Log-Outcome discipline, brought to the review cadence. Start
          Revalue happens IN the deal (the archive machinery lives there),
          so that button opens it; the card self-clears when the
          revalue_started log lands. The other three write directly.) */}
      {reviewOutcomes && reviewOutcomes.length > 0 && (
        <div className="mb-6">
          <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-indigo-700">
            📋 Review call held — record the decision <span className="text-gray-400 font-normal">({reviewOutcomes.length})</span>
          </h2>
          <p className="text-xs text-gray-400 mb-3">You held the review; the record doesn't know what was decided yet. One click writes it — a held call with no recorded outcome is how work evaporates.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {reviewOutcomes.map((c, i) => (
              <div key={i} className="bg-white border border-indigo-300 rounded-lg p-3">
                <div className="flex items-center gap-2 min-w-0">
                  <div className="font-semibold text-gray-800 truncate">{c.p.company_name}</div>
                  <ProvenanceChip p={c.p} />
                </div>
                <div className="text-xs text-gray-500 mt-0.5">Strategic review held {new Date(c.meetingAt).toLocaleDateString()}{c.p.lead ? ` · Lead ${c.p.lead}` : ''}</div>
                <div className="flex flex-wrap justify-end gap-1.5 mt-2">
                  <button type="button" className="text-[11px] px-2 py-1 rounded bg-amber-600 text-white hover:bg-amber-700 font-semibold"
                    title="They want an updated valuation: opens the deal — press ↻ Start Revalue on the Setup tab with the committal date from your call. This card clears itself when the revalue starts."
                    onClick={() => onOpenValuation({ id: c.p.id, name: c.p.name })}>▶ Start Revalue (opens deal)</button>
                  <button type="button" className="text-[11px] px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                    title="Staying on the review cadence: sets the next strategic review date."
                    onClick={() => onReviewOutcome && onReviewOutcome(c, 'date')}>⏰ New review date</button>
                  <button type="button" className="text-[11px] px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                    title="The owner is weighing options: moves the deal to Considering with your follow-up date."
                    onClick={() => onReviewOutcome && onReviewOutcome(c, 'considering')}>🤔 Considering</button>
                  <button type="button" className="text-[11px] px-2 py-1 rounded border border-gray-300 text-gray-500 hover:bg-gray-50"
                    title="The relationship is going quiet: moves the deal to Inactive with your one-line why."
                    onClick={() => onReviewOutcome && onReviewOutcome(c, 'inactive')}>🏁 Inactive</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* 🗓 Review promised, no date (Mark 09-10, Partners Data). The stage
          says a review is SET; the date field says nothing is. The Lead's
          "Schedule the strategic review" card existed since 7/24 and three
          deals still sat dateless — this is the escalation, with the one
          verb that pays the debt. */}
      {buckets.datelessReviews && buckets.datelessReviews.length > 0 && (
        <div className="mb-6">
          <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-amber-700">
            🗓 Review promised — no date set <span className="text-gray-400 font-normal">({buckets.datelessReviews.length})</span>
          </h2>
          <p className="text-xs text-gray-500 mb-3">These deals wear "Strategic Review Set" but the date field is empty — the owner was promised a review that isn't on any calendar. Set the date from the last conversation, or open the deal if the stage itself is wrong.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {buckets.datelessReviews.map(p => (
              <div key={p.id} className="bg-white border border-amber-400 rounded-lg p-3">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2 min-w-0">
                    <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
                    <ProvenanceChip p={p} />
                  </div>
                  <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded whitespace-nowrap bg-amber-100 text-amber-700">
                    dateless {p.daysInStage != null ? `${p.daysInStage}d` : ''}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-0.5">In Strategic Review Set since {p.stage_entered_at ? new Date(p.stage_entered_at).toLocaleDateString() : '?'}{p.lead ? ` · Lead ${p.lead}` : ''}{p.account_manager ? ` · AM ${p.account_manager}` : ''}</div>
                <div className="flex items-center justify-end gap-2 mt-2">
                  <button type="button" onClick={() => onSetReviewDate && onSetReviewDate(p)}
                    className="px-3 py-1 text-xs font-semibold rounded bg-amber-600 text-white hover:bg-amber-700">📅 Set review date</button>
                  <button type="button" onClick={() => onOpenValuation({ id: p.id, name: p.name })}
                    className="px-3 py-1 text-xs font-semibold rounded border border-gray-300 text-gray-700 hover:bg-gray-50">Open deal</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* ── Follow up — Sales Engine ── */}
      {myName && <div className="mt-2 mb-3 pt-2 border-t border-gray-200 text-[10px] font-bold uppercase tracking-widest text-gray-400">Follow up — Sales Engine<span className="normal-case font-normal tracking-normal text-gray-400"> — owners waiting on you, reminders you set</span></div>}
      {seServing && seServing.some(o => o._band === 0 && !o._fetched) && (
        <SEServingSection items={seServing.filter(o => o._band === 0 && !o._fetched)} mode="replydue" buysideMatches={seBuysideMatches} onLog={onSeLog} onReached={onSeReached} onSnooze={onSeSnooze} onCadenceSent={onSeCadenceSent} onReplied={onSeReplied} onNoReply={onSeNoReply} onRemind={onSeRemind} onAwait={onSeAwait} actor={myName} />
      )}
      {/* ⏰ The one door for a reminder with no card (Mark 09-17) — always
          visible on an SE plate, even when it's clean; that's exactly when
          the owner you just phoned has no card to hang a ⏰ on. */}
      {seNewReminder && seServing && <SeNewReminderSection {...seNewReminder} />}
      {/* Promised follow-ups are REMINDERS, never "ideas" (Mark 08-12, Peak
          Solutions) — their own section, honest heading. Ideas keeps only
          the true ideas: resurrection flags + pick-the-play (Faster Planet). */}
      {seServing && seServing.some(o => (o._band === 1 || o._band === 2) && !o._fetched) && (
        <SEServingSection items={seServing.filter(o => (o._band === 1 || o._band === 2) && !o._fetched)} mode="promises" buysideMatches={seBuysideMatches} onLog={onSeLog} onReached={onSeReached} onSnooze={onSeSnooze} onCadenceSent={onSeCadenceSent} onReplied={onSeReplied} onNoReply={onSeNoReply} onRemind={onSeRemind} onAwait={onSeAwait} onHandOff={onSeHandOff} onDropDate={onSeDropDate} actor={myName} />
      )}
      {seServing && seServing.some(o => o._band === 5 && !o._fetched) && (
        <SEServingSection items={seServing.filter(o => o._band === 5 && !o._fetched)} mode="valued" buysideMatches={seBuysideMatches} onLog={onSeLog} onReached={onSeReached} onSnooze={onSeSnooze} onCadenceSent={onSeCadenceSent} onReplied={onSeReplied} onNoReply={onSeNoReply} onRemind={onSeRemind} onAwait={onSeAwait} actor={myName} />
      )}
      {seServing && (seServing.some(o => o._band === 3 || o._band === 4 || o._fetched) || seServingMode === 'ideas') && (
        <SEServingSection items={seServing.filter(o => o._band === 3 || o._band === 4 || o._fetched)} mode="ideas" buysideMatches={seBuysideMatches} onLog={onSeLog} onReached={onSeReached} onSnooze={onSeSnooze} onFetchNext={seServingMode === 'ideas' ? onSeFetchNext : undefined} fetchLocked={seFetchLocked} gateCount={seIdeasGate} onCadenceSent={onSeCadenceSent} onReplied={onSeReplied} onNoReply={onSeNoReply} onRemind={onSeRemind} onAwait={onSeAwait} actor={myName} />
      )}
      {seFinish && <SEFinishSection data={seFinish} onPick={onSeFinishPick} />}
      {/* ── Clean-up ── */}
      {myName && <div className="mt-2 mb-3 pt-2 border-t border-gray-200 text-[10px] font-bold uppercase tracking-widest text-gray-400">Clean-up<span className="normal-case font-normal tracking-normal text-gray-400"> — keep the record honest</span></div>}
      {meetingTruth && meetingTruth.length > 0 && (
        <MeetingTruthSection items={meetingTruth} onHeld={onMeetingHeld} onHeldAll={onMeetingHeldAll} onNoShow={onMeetingNoShow} onTypeChange={onMeetingTypeChange} onHandOff={onMeetingHandOff} onRemind={onMeetingRemind} actor={myName} />
      )}
      {mtClassify && mtClassify.length > 0 && (
        <MeetingsClassifySection items={mtClassify} buyers={mtClassifyBuyers} onSave={onMeetingClassify} onDismiss={onMeetingClassifyDismiss} onHandOff={onMeetingClassifyHandOff} actor={myName} />
      )}
      <AmHandoffSection items={amHandoffs} onDone={onAmHandoffDone} actor={myName} />
      {inviteChecks && inviteChecks.length > 0 && (
        <InviteCheckSection items={inviteChecks} showHolder={buyerReviewShowHolder} actor={myName} onLiveCall={onInviteLiveCall} onCallbackChase={onInviteCallbackChase} />
      )}
      {buckets.dueReminders && buckets.dueReminders.length > 0 && (
        <RemindersSection items={buckets.dueReminders} onOpen={onOpenValuation} onDismiss={onDismissReminder} />
      )}
      {buckets.cadenceQueue && buckets.cadenceQueue.length > 0 && (
        <CadenceQueueSection items={buckets.cadenceQueue} onCompose={onOpenValuation} listedKeys={listedKeys} />
      )}
      {buckets.financialUpdates && buckets.financialUpdates.length > 0 && (
        <FinancialUpdatesSection items={buckets.financialUpdates} onRequest={onRequestFinancialUpdate} onPause={onPauseFinancialReminders} onOpen={onOpenValuation} />
      )}
      {buckets.asOfAdvance && buckets.asOfAdvance.length > 0 && (
        <AsOfAdvanceSection items={buckets.asOfAdvance} onAdvance={onAdvanceAsOf} onHold={onHoldAsOf} onOpen={onOpenValuation} />
      )}
      {buckets.revalueDocsReview && buckets.revalueDocsReview.length > 0 && (
        <RevalueDocsReviewSection items={buckets.revalueDocsReview} onOpen={onOpenValuation} onDismiss={onDismissRevalueDocs} />
      )}
      {buckets.ownerPortalReview && buckets.ownerPortalReview.length > 0 && (
        <OwnerPortalReviewSection items={buckets.ownerPortalReview} onOpen={onOpenValuation} onReviewed={onReviewedPortalUpdate} />
      )}
      {/* 🌱 Stall-revival replies now live ON the AM's stalled cards (Mark
          09-09: "once a business stalls it goes back to the AM. Konnie's
          job is to enter data and send reminder emails" — the separate
          Konnie section built 09-08 was a misassignment and lasted one
          day; a post-stall reply is the AM's to read, so it surfaces
          their card through the grace window instead). */}
      {showSortQueue && sortQueue.length > 0 && (
        <SortQueueSection items={sortQueue} onResolve={onResolveSortQueue} />
      )}
      {buckets.docsNotSent && buckets.docsNotSent.length > 0 && (
        <div className="mb-6">
          <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-amber-700">📧 Activated — document list not sent yet <span className="text-gray-400 font-normal">({buckets.docsNotSent.length})</span></h2>
          <p className="text-xs text-gray-500 mb-3">Activate shows the docs-ready email for you to review — the document list releases to the owner's portal only when that email actually sends. These were activated but the email was never sent (window closed?), so the owner has nothing yet. Open the deal → Setup → <strong>Release document list</strong> → review → Send.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {buckets.docsNotSent.map(p => (
              <div key={p.id} className="bg-white border border-amber-300 rounded-lg p-3">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-800 text-sm truncate">{p.company_name || p.name}</div>
                    <div className="text-xs text-gray-600 mt-0.5">Activated {p.stage_entered_at ? formatRelativeDate(p.stage_entered_at) : ''}{p.committed_upload_date ? ` · committal ${p.committed_upload_date}` : ''}{p.owner_email ? ` · ${p.owner_email}` : ' · no owner email on file'}</div>
                    <div className="text-xs text-amber-800 mt-1 font-medium">Owner hasn't received the portal/document email. Nothing is released.</div>
                  </div>
                  <button type="button" onClick={() => onOpenValuation(p)} className="px-3 py-1 text-xs font-semibold bg-amber-600 text-white rounded hover:bg-amber-700 whitespace-nowrap">Open → Setup → Release</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {dmSignals && <DMSignalsSection view={dmSignals} canOpenDm={canOpenDm} />}
      {/* ── Monitors ── */}
      {myName && <div className="mt-2 mb-3 pt-2 border-t border-gray-200 text-[10px] font-bold uppercase tracking-widest text-gray-400">Monitors<span className="normal-case font-normal tracking-normal text-gray-400"> — nothing to clear — the ball is with someone else</span></div>}
      {buckets.leadFollowUpLater && buckets.leadFollowUpLater.length > 0 && (
        <AmFollowUpSection
          title="Considering — following up later"
          items={buckets.leadFollowUpLater}
          collapsed={true}
          note="Owners considering a sale who asked us to circle back on a date — they return to your follow-ups when the date arrives."
          onOpenValuation={onOpenValuation}
          onSetFollowUp={onSetFollowUp}
          onClearFollowUp={onClearFollowUp}
          onLogOutreach={onLogOutreach}
        />
      )}
      <AmFollowUpSection
        title="Following up later"
        items={buckets.amLater}
        collapsed={true}
        note="Owners with a next-touch date set — they return to your list when the date arrives."
        onOpenValuation={onOpenValuation}
        onSetFollowUp={onSetFollowUp}
        onClearFollowUp={onClearFollowUp}
        onLogOutreach={onLogOutreach}
        onReEngage={onReEngage}
        onMarkDead={onMarkDead}
      />
      {/* "On your plate" moved to the TOP of the plate, right under Meeting
          Prep (Zac 09-17: "it's at the bottom of my page but the most
          important") — see the render just after MeetingsTodaySection. */}
      <MonitorSection
        title="Awaiting owner answers"
        items={buckets.awaitingAnswers}
        note="Questions sent — waiting on the owner to reply. A ⏰ means it's been 3 days; open it and re-send to nudge."
        onOpenValuation={onOpenValuation}
        presenceByValuation={presenceByValuation}
      />
      <MonitorSection
        title="Following — businesses you analyzed"
        items={buckets.following}
        note="Past you and with the Lead now (valuation meeting set, owner deciding, or considering with a follow-up scheduled). Here to watch — set yourself a reminder if you're chasing the follow-up."
        onOpenValuation={onOpenValuation}
        presenceByValuation={presenceByValuation}
      />
      <MonitorSection
        title="Waiting on owners"
        items={buckets.waitingOnOwners}
        note="Reminders are going out on these — nothing for you to do until they upload. Expand to see when the last one went."
        onOpenValuation={onOpenValuation}
        presenceByValuation={presenceByValuation}
      />
      <MonitorSection
        title="Snoozed"
        items={buckets.snoozed}
        note="Parked until their snooze date — they return to your plate when the snooze lapses."
        onOpenValuation={onOpenValuation}
        presenceByValuation={presenceByValuation}
      />
      {/* 🧭 BUYSIDE — grouped at the bottom of the plate (Mark 09-16), out of
          the middle of the sellside flow. The divider only shows when there's
          buyside work (or the hunt button for AMs/Leads). */}
      {((role === 'account_manager' || role === 'lead')
        || (buysideRadar && buysideRadar.length > 0) || (wagonCards && wagonCards.length > 0)
        || (scottAsk && scottAsk.length > 0) || (buyerReviews && buyerReviews.length > 0)
        || (buysidePool && buysidePool.length > 0) || (buyerFollow && buyerFollow.length > 0)
        || (buysideBoard && buysideBoard.length > 0)) && (
        <div className="mt-8 pt-4 border-t-2 border-violet-200">
          <div className="text-xs font-bold uppercase tracking-wide text-violet-400 mb-3">🧭 Buyside</div>
          {buysideRadar && buysideRadar.length > 0 && (
            <BuysideRadarSection items={buysideRadar} />
          )}
          {wagonCards && wagonCards.length > 0 && (
            <WagonHolderSection items={wagonCards} onHandled={onWagonHandled} actor={myName} />
          )}
          {scottAsk && scottAsk.length > 0 && (
            <ScottActiveAskSection items={scottAsk} onAsked={onScottAsked} actor={myName} />
          )}
          {buyerReviews && buyerReviews.length > 0 && (
            <BuysideReviewSection items={buyerReviews} onAct={onBuyerReviewAct} showHolder={buyerReviewShowHolder} actor={myName} />
          )}
          {buysidePool && buysidePool.length > 0 && (
            <BuysidePoolSection items={buysidePool} onClaim={onBuysideClaim} claimGate={buysideClaimGate} actor={myName} />
          )}
          {/* 🎯 The focused buyside surface (Mark 09-14): one button, one job —
              the SE page's matcher in a distraction-free panel. */}
          {(role === 'account_manager' || role === 'lead') && (
            <div className="mb-4">
              <a href="/sales-engine?hunt=1" target="_blank" rel="noopener"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700"
                title="Type your buyside client → see + sharpen their criteria → the ranked list of matching businesses, each with approach clocks and a tailored one-click approach email.">
                🎯 Find businesses for a buyside client
              </a>
            </div>
          )}
          {/* ➕ The one door (Mark 09-17): tie an owner to an existing buyside
              client from here — no SE trip — and the engine takes over. */}
          {buysideNewMatch && (role === 'account_manager' || role === 'lead' || role === 'owner') && (
            <BuysideNewMatchSection {...buysideNewMatch} />
          )}
          <BuysideBoardSection rows={buysideBoard} showHolder={buyerReviewShowHolder} onAct={onBuyerFollowAct} onStep={onBuysideStep} />
          {buyerFollow && buyerFollow.length > 0 && (
            <BuysideFollowSection items={buyerFollow} onAct={onBuyerFollowAct} onStep={onBuysideStep} showHolder={buyerReviewShowHolder} actor={myName} />
          )}
        </div>
      )}
      {stagedSends && stagedSends.length > 0 && (
        <StagedSendsSection part="drafts" items={stagedSends} onAct={onStagedSendAct} onBulk={onStagedSendBulk} showHolder={role === 'owner'} />
      )}
    </div>
  );
};

const RemindersSection = ({ items, onOpen, onDismiss }) => (
  <div className="mb-6">
    <h2 className="text-sm font-bold uppercase tracking-wide mb-3 text-purple-700">
      🔔 Reminders due / overdue <span className="text-gray-400 font-normal">({items.length})</span>
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {items.map(r => (
        <div key={r.id} className="bg-white border border-purple-200 rounded-lg p-4 flex items-start gap-3">
          <button
            type="button"
            onClick={() => onOpen({ id: r.project_id, name: r.company_name })}
            className="flex-1 text-left min-w-0"
          >
            <div className="font-semibold text-gray-800 truncate">{r.company_name}</div>
            <div className="text-xs text-purple-700 mt-0.5">
              {r.daysOverdue === 0 ? 'Due today' : `${r.daysOverdue}d overdue`}
              <span className="text-gray-400"> · {new Date(r.remind_at + 'T00:00:00').toLocaleDateString()}</span>
            </div>
            {r.note && <div className="text-sm text-gray-700 mt-1 italic">{r.note}</div>}
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onDismiss(r.id); }}
            className="px-2 py-1 text-xs font-semibold rounded bg-green-100 text-green-700 hover:bg-green-200 whitespace-nowrap"
          >
            ✓ Done
          </button>
        </div>
      ))}
    </div>
  </div>
);

/* In-tool email thread viewer (Colleen's Concise bug, 2026-08-04). The old
   "thread ↗" link searched the VIEWER'S OWN Gmail for the newest message id —
   a dead end whenever the conversation lives in a teammate's mailbox. The
   sync already stores every matched message from all six mailboxes, so the
   thread renders right here for everyone; each message still deep-links to
   Gmail for anyone whose mailbox holds a copy (the "via" chips say whose). */
// Works for a VT deal (valuationId) or an SE business (ownerId) — same table,
// different match key (step 2 of the Adam-plate plan, 08-11).
// Three doors into the same vault (universal toolbar, Mark 08-21): a VT deal
// (valuationId), an SE business (ownerId) — both at once = the union, since
// a VT-linked business can have mail matched either way — or a BUYER
// ({ id, emails, dm_buyer_id }): three keys so nothing hides — the SE-book
// link (migration 063), the DM soft ref, raw address overlap (falls back to
// the last two pre-063).
const ThreadModal = ({ valuationId, ownerId, buyer, companyName, actor, onClose }) => {
  const [msgs, setMsgs] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [expandedIds, setExpandedIds] = useState(null); // null until msgs load
  // SELF-HEALING OWNER RESOLUTION (Adam 09-08, E2E: "add the ability for me
  // to reply in the thread" — the button EXISTED but was gated on ownerId,
  // and the surface he opened from passed only valuationId, so the whole
  // reply UI silently vanished). Every live VT deal has a linked SE record;
  // resolve it here so the reply works from EVERY door, not just the ones
  // that remembered to pass ownerId.
  const [resolvedOwnerId, setResolvedOwnerId] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (ownerId || !valuationId || buyer || !supabaseClient) return undefined;
    (async () => {
      try {
        const { data: v } = await supabaseClient.from('valuations').select('client_id').eq('id', valuationId).limit(1);
        const cid = v && v[0] && v[0].client_id;
        if (!cid) return;
        const { data: o } = await supabaseClient.from('se_owners').select('id').eq('vt_client_id', cid).limit(1);
        if (!cancelled && o && o[0]) setResolvedOwnerId(o[0].id);
      } catch (_) { /* no SE record — reply stays hidden, viewer unaffected */ }
    })();
    return () => { cancelled = true; };
  }, [valuationId, ownerId, buyer]);
  const effOwnerId = ownerId || resolvedOwnerId;
  // Viewer's mailbox name for the per-message Gmail-link logic. The actor
  // prop wins (respects view-as); otherwise derive from the signed-in
  // session with the server's own email→mailbox rule, so every mount gets
  // the right behavior without prop-threading.
  const [viewerBox, setViewerBox] = useState(actor || null);
  useEffect(() => {
    if (actor || !supabaseClient) return;
    supabaseClient.auth.getSession().then(({ data: { session } }) => {
      const local = String((session && session.user && session.user.email) || '').split('@')[0].toLowerCase();
      if (local) setViewerBox(local === 'adamborst' ? 'Adam' : local.charAt(0).toUpperCase() + local.slice(1));
    }).catch(() => {});
  }, [actor]);
  // ↩ Reply in THIS chain (Mark 08-27, the Adam/Twin Oaks ask — Zoho's
  // jump-into-a-colleague's-chain, SE-native): sends from the CLICKER's own
  // connected mailbox, In-Reply-To/References the clicked message's chain
  // (so the owner's mail client stitches it into their existing
  // conversation — works even when our only copies live in a departed
  // colleague's vaulted mail), last messages quoted underneath. Owner
  // threads only — buyer reply machinery arrives with the mandate build.
  const [replyForId, setReplyForId] = useState(null);
  const [replyBody, setReplyBody] = useState('');
  const [replyTo, setReplyTo] = useState('');
  const [replyStatus, setReplyStatus] = useState('');
  const sendChainReply = async (m) => {
    const body = replyBody.trim();
    if (!body) { setReplyStatus('Write the reply first.'); return; }
    setReplyStatus('Sending from your mailbox…');
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const at = session && session.access_token;
      if (!at) throw new Error('Session expired — reload and sign in again.');
      const r = await fetch('/api/se/thread-reply', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
        // Anchor to THIS message's RFC id, or fall back to the thread's newest
        // available one (Adam/Cloudify 09-11: in-app-sent messages get a gmail
        // id but no rfc_message_id, so the NEWEST message had no reply button —
        // only an older one did. Threading via any message-id in the same
        // conversation stitches correctly in Gmail, so a reply from the top
        // still lands in the chain).
        body: JSON.stringify({ owner_id: effOwnerId, body, reply_to_id: m.rfc_message_id || (msgs || []).map(x => x.rfc_message_id).find(Boolean) || undefined, to: replyTo || undefined }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || ('HTTP ' + r.status));
      setReplyStatus(`✓ Sent to ${d.to} as you${d.threaded ? ' — the owner sees it inside this conversation' : ''}. It joins this record within minutes.`);
      setReplyBody('');
      setTimeout(() => { setReplyForId(null); setReplyStatus(''); }, 3500);
    } catch (e) { setReplyStatus('Send failed: ' + (e.message || e)); }
  };
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!supabaseClient) throw new Error('Not connected.');
        const SEL = 'id, direction, mailbox, rfc_message_id, from_email, to_emails, cc_emails, subject, snippet, body_text, sent_at';
        const query = (extraOr) => supabaseClient.from('se_emails').select(SEL).or(extraOr)
          // Newest on top (Mark 08-21) — the thread reads like an inbox, not a log.
          .order('sent_at', { ascending: false });
        let rows;
        if (buyer) {
          const addrs = [...new Set((buyer.emails || []).map(e => String(e || '').toLowerCase().trim()).filter(Boolean))];
          const keys = [];
          if (buyer.dm_buyer_id) keys.push(`buyer_id.eq.${buyer.dm_buyer_id}`);
          if (addrs.length) keys.push(`external_emails.ov.{${addrs.map(a => '"' + a.replace(/["{}]/g, '') + '"').join(',')}}`);
          try {
            rows = await fetchAllRows(() => query([`se_buyer_id.eq.${buyer.id}`, ...keys].join(',')));
          } catch (e063) {
            if (!keys.length) throw e063;
            rows = await fetchAllRows(() => query(keys.join(',')));   // migration 063 not applied yet
          }
        } else {
          const keys = [];
          if (valuationId) keys.push(`valuation_id.eq.${valuationId}`);
          // effOwnerId, not ownerId (10-27): doors that pass only the deal missed
          // mail stamped to the owner alone (a second deal, an owner-level thread).
          if (effOwnerId) keys.push(`owner_id.eq.${effOwnerId}`);
          rows = await fetchAllRows(() => query(keys.join(',')));
        }
        // The same message lands once per synced mailbox — collapse copies on
        // Message-ID, remembering every mailbox that holds one (that's whose
        // Gmail the per-message link will work in).
        const byId = new Map();
        (rows || []).forEach(r => {
          const key = r.rfc_message_id || r.id;
          const prev = byId.get(key);
          if (prev) {
            if (!prev.mailboxes.includes(r.mailbox)) prev.mailboxes.push(r.mailbox);
          } else {
            byId.set(key, { ...r, mailboxes: [r.mailbox] });
          }
        });
        const deduped = [...byId.values()];
        if (!cancelled) {
          setMsgs(deduped);
          // Newest message (now first) opens expanded; the rest start as one-line rows.
          setExpandedIds(new Set(deduped.length ? [deduped[0].id] : []));
        }
      } catch (e) {
        if (!cancelled) setLoadError(e.message || String(e));
      }
    })();
    return () => { cancelled = true; };
  }, [valuationId, effOwnerId, buyer && buyer.id]);
  const toggle = (id) => setExpandedIds(prev => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id); else next.add(id);
    return next;
  });
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
      onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="bg-gray-50 rounded-lg shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b bg-white rounded-t-lg">
          <div className="font-semibold text-gray-800 text-sm truncate">
            📧 {buyer ? 'Buyer' : 'Owner'} email thread — {companyName}
            {msgs && <span className="text-gray-400 font-normal ml-2">({msgs.length} message{msgs.length === 1 ? '' : 's'}, all synced mailboxes, newest first)</span>}
          </div>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none px-1">×</button>
        </div>
        <div className="overflow-y-auto p-4 space-y-2">
          {loadError && <div className="text-sm text-red-600">Couldn't load the thread: {loadError}</div>}
          {!loadError && !msgs && <div className="text-sm text-gray-400 italic">Loading…</div>}
          {msgs && msgs.length === 0 && (
            <div className="text-sm text-gray-500">
              {/* Adam 10-28, Magnesite: "Why don't you have emails for this?" when nobody had emailed the owner. Say
                  what the empty box means, and where marketing emails show instead. */}
              No emails with this owner in the last 3 years (as far back as VT reads Gmail): nobody at Vista has emailed them from Gmail, and they haven't emailed us. Older history and Zoho notes are under 🗒 Notes.
              Marketing emails (Mailchimp) never show here; see the card's 🧭 Journey line for those. Email them from
              your Gmail and the thread shows up within 15 minutes.
            </div>
          )}
          {msgs && msgs.map((m) => {
            const inbound = m.direction === 'inbound';
            const open = expandedIds && expandedIds.has(m.id);
            return (
              <div key={m.id} className={`border rounded-lg bg-white ${inbound ? 'border-amber-300' : 'border-gray-200'}`}>
                <button type="button" onClick={() => toggle(m.id)} className="w-full text-left px-3 py-2">
                  <div className="flex items-center justify-between gap-2 text-xs">
                    <span className={`font-semibold truncate ${inbound ? 'text-amber-700' : 'text-emerald-700'}`}>
                      {inbound ? '◂ ' : '▸ '}{m.from_email || '(unknown sender)'}
                      <span className="text-gray-400 font-normal"> → {(m.to_emails || []).join(', ') || '—'}</span>
                    </span>
                    <span className="text-gray-400 whitespace-nowrap">{new Date(m.sent_at).toLocaleString()}</span>
                  </div>
                  <div className="flex items-center justify-between gap-2 mt-0.5">
                    <span className="text-xs text-gray-600 truncate">{m.subject || '(no subject)'}</span>
                    <span className="text-[10px] text-gray-400 whitespace-nowrap">via {m.mailboxes.join(', ')}</span>
                  </div>
                  {!open && m.snippet && <div className="text-xs text-gray-400 truncate mt-0.5">{m.snippet}</div>}
                </button>
                {open && (
                  <div className="px-3 pb-3">
                    {/* Selectable addresses (Adam 10-30: the ones in the header sit inside the expand button, so
                        right-click → Copy never worked). Plain text here + ⧉ copies one click. */}
                    <div className="text-xs text-gray-600 border-t pt-2 mb-1 select-text flex flex-wrap items-center gap-x-1.5 gap-y-0.5">
                      {[['From', m.from_email ? [m.from_email] : []], ['To', m.to_emails || []], ['Cc', m.cc_emails || []]].filter(([, l]) => l.length).map(([lbl, l]) => (
                        <span key={lbl} className="inline-flex flex-wrap items-center gap-x-1">
                          <span className="text-gray-400">{lbl}:</span>
                          {l.map(a => (
                            <span key={a} className="whitespace-nowrap">{a}
                              <button type="button" title="Copy this address" className="ml-0.5 text-gray-400 hover:text-gray-700"
                                onClick={e => { const btn = e.currentTarget; Promise.resolve().then(() => navigator.clipboard.writeText(a)).then(() => { btn.textContent = '✓'; setTimeout(() => { btn.textContent = '⧉'; }, 1500); }).catch(() => window.prompt('Copy the address:', a)); }}>⧉</button>
                            </span>
                          ))}
                        </span>
                      ))}
                    </div>
                    <div className="text-sm text-gray-800 whitespace-pre-wrap pt-1 max-h-72 overflow-y-auto">
                      {m.body_text || m.snippet || (/^(accepted|declined|tentative(ly accepted)?|updated invitation|invitation)\b/i.test(m.subject || '') ? '📅 Calendar reply — this message has no text; it only records the invite response.' : '(this email has no text)')}
                    </div>
                    <div className="flex items-center gap-3 mt-2 flex-wrap">
                      {/* The Gmail deep link only works in a mailbox that HOLDS
                          the message. Adam 09-08 (E2E): clicking it for a
                          Thatcher/Konnie-only message opened a blank page — so
                          when the viewer's mailbox isn't on the message, the
                          link becomes plain text instead of a dead end. */}
                      {m.rfc_message_id && (viewerBox && !m.mailboxes.includes(viewerBox) ? (
                        <span className="text-xs text-gray-400"
                          title="This message only exists in those mailboxes — a Gmail link would open a blank search for you. Reply right here instead: ↩ sends from YOUR mailbox, threaded into their conversation.">
                          in {m.mailboxes.join(', ')}'s Gmail only
                        </span>
                      ) : (
                        <a href={`https://mail.google.com/mail/#search/rfc822msgid:${encodeURIComponent(String(m.rfc_message_id).replace(/[<>]/g, ''))}`}
                          target="_blank" rel="noopener" className="text-xs underline text-gray-500"
                          title={`Works in ${m.mailboxes.join('/')}'s Gmail — the message only exists in the mailboxes that sent or received it.`}>
                          open in Gmail ↗ ({m.mailboxes.join(', ')})
                        </a>
                      ))}
                      {effOwnerId && !buyer && replyForId !== m.id && (m.rfc_message_id || (msgs || []).some(x => x.rfc_message_id)) && (
                        <button type="button" className="text-xs px-2 py-1 rounded border border-indigo-300 text-indigo-700 hover:bg-indigo-50"
                          title="Continue THIS conversation as yourself — sends from YOUR mailbox, threaded so the owner reads it inside the chain they already have (with the recent messages quoted underneath). Works on colleagues' and departed staff's chains — that's the point."
                          onClick={() => {
                            // Default recipient = the server's own rule, mirrored:
                            // the newest INBOUND external in this chain (never a
                            // colleague's inbox copy). Adam 08-31: "I can't see or
                            // control who the reply is going to" — now both.
                            const isInternal = (e) => /@vistabusinessgroup\.com$/i.test(String(e || ''));
                            const chainKey = (x) => String(x.subject || '').replace(/^\s*((re|fw|fwd)\s*:\s*)+/i, '').trim().toLowerCase();
                            const chain = (msgs || []).filter(x => chainKey(x) === chainKey(m));
                            const lastIn = chain.find(x => x.direction === 'inbound' && !isInternal(x.from_email))
                              || (msgs || []).find(x => x.direction === 'inbound' && !isInternal(x.from_email));
                            setReplyTo((lastIn && lastIn.from_email) || '');
                            setReplyForId(m.id); setReplyBody(''); setReplyStatus('');
                          }}>↩ Reply in this chain — as you</button>
                      )}
                    </div>
                    {replyForId === m.id && (
                      <div className="mt-2 border-t pt-2">
                        <div className="flex items-center gap-2 mb-1.5 text-xs">
                          <span className="font-semibold text-gray-600">To:</span>
                          <select value={replyTo} onChange={e => setReplyTo(e.target.value)}
                            className="border border-gray-300 rounded px-1.5 py-1 text-xs text-gray-700 bg-white max-w-[280px]"
                            title="Who receives your reply. Defaults to the person who last wrote in this chain — never a colleague. Other addresses from this record's correspondence are listed if you need a different one.">
                            {[...new Set([replyTo, ...(msgs || []).flatMap(x => [x.from_email, ...(x.to_emails || []), ...(x.cc_emails || [])])
                              .map(e => String(e || '').toLowerCase().trim())
                              .filter(e => e && !/@vistabusinessgroup\.com$/i.test(e))])].filter(Boolean)
                              .map(e => <option key={e} value={e}>{e}</option>)}
                          </select>
                          <span className="text-gray-400">— sends from YOUR mailbox, threaded into their conversation</span>
                        </div>
                        <textarea value={replyBody} onChange={e => setReplyBody(e.target.value)} rows={4}
                          placeholder={'Your message — sent from YOUR mailbox, into this conversation. Taking over an account? Say it plainly ("J.C. has moved on; I\'ve taken over your account") — the quoted history under your text does the rest.'}
                          className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm" />
                        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                          <button type="button" className="text-xs px-3 py-1.5 rounded bg-indigo-600 text-white hover:bg-indigo-700 font-semibold"
                            onClick={() => sendChainReply(m)}>Send as me</button>
                          <button type="button" className="text-xs px-2 py-1.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50"
                            onClick={() => { setReplyForId(null); setReplyStatus(''); }}>Cancel</button>
                          <span className="text-xs text-gray-500">{replyStatus}</span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
};

// ── THE UNIVERSAL CARD TOOLBAR (Mark 08-21: "most of the staff would find
// most of those features valuable on their cards so they don't have to go
// digging"). The three doors Adam's cards got — 🧵 Thread · 🗒 Notes ·
// ↗ Account — as ONE component every card type mounts. Works on any mix of
// ids: a VT deal (valuationId), an SE business (ownerId — today every live
// VT deal has one, the direct-to-Lead mint), or a buyer. Every click stops
// propagation so it never opens the card underneath.
const CardToolbar = ({ valuationId, ownerId, buyer, companyName, actor, className = '' }) => {
  const [threadOpen, setThreadOpen] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  const btn = 'px-2 py-0.5 text-[11px] font-semibold rounded border border-gray-300 text-gray-600 hover:text-gray-800 hover:bg-gray-50 bg-white';
  const canNotes = !!(valuationId || ownerId);
  return (
    <span className={`inline-flex items-center gap-1.5 flex-wrap ${className}`} onClick={stop} onKeyDown={(e) => e.stopPropagation()}>
      <button type="button" className={btn} onClick={(e) => { stop(e); setThreadOpen(true); }}
        title="Every email with them across every synced team mailbox, newest first — no Gmail digging.">🧵 Emails</button>
      {canNotes && (
        <button type="button" className={btn} onClick={(e) => { stop(e); setNotesOpen(true); }}
          title={ownerId ? 'Notes & history — what people wrote down, plus meetings. ＋ Add a note (never clears a card).' : 'Activity history — what people wrote down, plus meetings.'}>🗒 Notes</button>
      )}
      {ownerId && (
        <a href={`/sales-engine?owner=${encodeURIComponent(ownerId)}`} target="_blank" rel="noopener" className={btn} onClick={(e) => e.stopPropagation()}
          title="Open this business on the Sales Engine page — full record, contacts, actions.">↗ Account</a>
      )}
      {threadOpen && (
        <ThreadModal valuationId={valuationId} ownerId={ownerId} buyer={buyer} companyName={companyName} actor={actor} onClose={() => setThreadOpen(false)} />
      )}
      {notesOpen && (
        <NotesModal valuationId={valuationId} ownerId={ownerId} companyName={companyName} actor={actor} onClose={() => setNotesOpen(false)} />
      )}
    </span>
  );
};
// The same three doors on the hand-built deal cards (Konnie 10-27, weaning off
// Zoho: "email chains … are more complete than on my cards" — Received, Reminder
// queue, Portal updates, Revalue, Financials, Collection date had no 🧵).
const ProjectChainToolbar = ({ p, className = 'mb-3' }) => (
  <div className={className}>
    <CardToolbar valuationId={p.id} ownerId={p.client_id ? (SE_OWNER_BY_CLIENT.get(p.client_id) || null) : null} companyName={p.company_name} actor={CARD_ACTOR_NAME} />
  </div>
);

// 🗒 The human notes — activity log for a VT deal (valuationId) or the touch
// ledger for an SE business (ownerId). Complements 🧵 (emails): this is what
// PEOPLE wrote down. (Adam-plate punch list (b), 08-11.)
const NotesModal = ({ valuationId, ownerId, companyName, actor, onClose }) => {
  const [rows, setRows] = useState(null);
  // ＋ Add note (Adam 08-20): additive by law — never clears a card, never
  // sets a date. Date-shaped text gets pointed at ⏰.
  const [noteDraft, setNoteDraft] = useState('');
  const [noteStatus, setNoteStatus] = useState('');
  const saveNote = async () => {
    const text = noteDraft.trim();
    if (!text || (!ownerId && !valuationId)) { setNoteStatus(text ? '' : 'Write the note first.'); return; }
    try {
      if (ownerId) {
        const { error } = await supabaseClient.from('se_touches').insert({
          owner_id: ownerId, kind: 'note', channel: 'se', actor: actor || null,
          subject: text.slice(0, 180),
          meta: text.length > 180 ? { content: text } : null,
        });
        if (error) throw error;
      } else {
        // No SE row yet (a brand-new account's row mints at the next hourly
        // sync — Adam/KC Heating 08-24: the owner called minutes after
        // create and the fresh notes had nowhere to go). The VT activity log
        // is the same merged timeline, so the note lands in the identical
        // place either way.
        const { data: u } = await supabaseClient.auth.getUser();
        const email = (u && u.user && u.user.email) || 'unknown';
        const { error } = await supabaseClient.from('project_activity_log').insert({
          project_id: valuationId, kind: 'note', note: text,
          actor_email: email, actor_name: actor || email.split('@')[0],
        });
        if (error) throw error;
      }
      setRows(prev => [{ at: new Date().toISOString(), kind: 'note', text, who: actor || 'me' }, ...(prev || [])]);
      setNoteDraft('');
      setNoteStatus(/\b(nov|dec|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|month|next week|tomorrow|reach (?:out |back )?in)\b/i.test(text)
        ? '✓ saved — that sounds like a date: notes never come back on their own, set a ⏰ on the card too.'
        : '✓ saved to the record');
      setTimeout(() => setNoteStatus(''), 6000);
    } catch (e) { setNoteStatus('Failed: ' + (e.message || e)); }
  };
  const [aiStatus, setAiStatus] = useState(null);
  // 📇 What the record already says (Zac 10-15: "what I liked about Zoho is there were always some notes").
  // The Zoho-imported notes/description + size live on the SE row; until 10-16 they showed only on the SE
  // page and the AM's SE cards, never in this modal, so a Lead on a warm card never saw them.
  const [onRecord, setOnRecord] = useState(null);
  const [loadError, setLoadError] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!supabaseClient) throw new Error('Not connected.');
        try {
          let oid = ownerId;
          if (!oid && valuationId) {   // the card had no SE link loaded yet: find it through the deal's client
            const { data: vv } = await supabaseClient.from('valuations').select('client_id').eq('id', valuationId).single();
            if (vv && vv.client_id) {
              const { data: so } = await supabaseClient.from('se_owners').select('id').eq('vt_client_id', vv.client_id).limit(1);
              oid = (so && so[0] && so[0].id) || null;
            }
          }
          if (oid) {
            const { data: rec } = await supabaseClient.from('se_owners')
              .select('notes, description, action_item, not_ready_reason, size_revenue, size_employees, ebitda, website, business_type, sector, zoho_last_activity')
              .eq('id', oid).single();
            if (!cancelled && rec) setOnRecord(rec);
          }
        } catch (e) { /* the timeline still renders without it */ }
        let data;
        if (valuationId) {
          ({ data } = await supabaseClient.from('project_activity_log')
            .select('at, kind, note, actor_name')
            .eq('project_id', valuationId).order('at', { ascending: false }).limit(150));
          data = (data || []).map(r => ({ at: r.at, kind: r.kind, text: r.note, who: r.actor_name }));
          // 🤖 the AI read of transcripts + email — pinned up top (Z6:
          // "meeting notes would also be helpful in understanding the
          // situation" — this IS the meeting digest we hold).
          try {
            const { data: v } = await supabaseClient.from('valuations')
              .select('ai_status').eq('id', valuationId).single();
            if (!cancelled && v && v.ai_status) setAiStatus(v.ai_status);
          } catch (e) { /* older deals may have none */ }
        }
        // The SE touch ledger — alone for an SE business, MERGED in for a
        // VT deal that has its SE row (universal toolbar, Mark 08-21: one
        // business, one history — Adam's card note and Konnie's activity
        // line land in the same timeline).
        if (ownerId) {
          const { data: tch } = await supabaseClient.from('se_touches')
            .select('at, kind, actor, subject, meta')
            .eq('owner_id', ownerId).order('at', { ascending: false }).limit(150);
          // Imported Zoho notes carry Zoho's HTML (<span style=…>): flatten to plain text (Adam 10-27, Shamrock).
          const plain = (h) => String(h).replace(/<br\s*\/?>|<\/(p|div|li)>/gi, '\n').replace(/<[^>]+>/g, '')
            .replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&').trim();
          const tRows = (tch || []).map(r => ({ at: r.at, kind: r.kind, text: (r.meta && r.meta.content) ? plain(r.meta.content) : r.subject, who: r.actor }));
          data = valuationId ? [...(data || []), ...tRows].sort((a, b) => (a.at < b.at ? 1 : -1)) : tRows;
        }
        // 📅 Meetings join the timeline (Z6) — booked/held/no-show, with
        // the Fireflies recording length when a transcript matched.
        try {
          const { data: mts } = await supabaseClient.from('se_meetings')
            .select('summary, starts_at, meeting_type, outcome, calendar_owner, raw')
            .eq(valuationId ? 'valuation_id' : 'owner_id', valuationId || ownerId)
            .order('starts_at', { ascending: false }).limit(50);
          const mtRows = (mts || []).map(m => ({
            at: m.starts_at, kind: '📅 meeting', who: m.calendar_owner,
            text: `${m.summary || '(untitled)'} — ${String(m.meeting_type || 'meeting').replace(/_/g, ' ')}`
              + (m.outcome ? ` · ${String(m.outcome).replace(/_/g, ' ').toUpperCase()}` : ' · booked')
              + (m.raw && m.raw.fireflies_duration_min ? ` · ${m.raw.fireflies_duration_min} min recorded` : ''),
          }));
          data = [...(data || []), ...mtRows].sort((a, b) => (a.at < b.at ? 1 : -1));
        } catch (e) { /* meetings table optional — timeline still renders */ }
        if (!cancelled) setRows(data);
      } catch (e) { if (!cancelled) setLoadError(e.message || String(e)); }
    })();
    return () => { cancelled = true; };
  }, [valuationId, ownerId]);
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
      onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="bg-gray-50 rounded-lg shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b bg-white rounded-t-lg">
          <div className="font-semibold text-gray-800 text-sm truncate">
            🗒 Notes &amp; history — {companyName}
            {rows && <span className="text-gray-400 font-normal ml-2">({rows.length} newest first)</span>}
          </div>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none px-1">×</button>
        </div>
        <div className="overflow-y-auto p-4 space-y-1.5">
          {(ownerId || valuationId) && (
            <div className="bg-white border border-gray-200 rounded px-3 py-2">
              <div className="flex items-start gap-2">
                <textarea value={noteDraft} onChange={e => setNoteDraft(e.target.value)} rows={1}
                  placeholder="＋ Add a note — context worth keeping (research, third-party color)"
                  title="Notes are additive: they never clear a card and never come back on their own. A date or promise ('reach out in November') belongs in ⏰ Remind me — that one actually returns."
                  className="flex-1 border border-gray-300 rounded px-2 py-1.5 text-xs resize-y" />
                <button type="button" onClick={saveNote}
                  className="px-3 py-1.5 text-xs font-semibold rounded bg-indigo-600 text-white hover:bg-indigo-700">Save note</button>
              </div>
              <div className="text-[11px] text-gray-400 mt-1">Notes never clear a card and never come back on their own — a date or a promise belongs in the card's <b>⏰ Remind me</b>.{noteStatus ? <span className="text-emerald-700 font-semibold ml-2">{noteStatus}</span> : null}</div>
            </div>
          )}
          {aiStatus && (aiStatus.last || aiStatus.next || aiStatus.waiting_on) && (
            <div className="bg-indigo-50 border border-indigo-200 rounded px-3 py-2 text-xs text-gray-700"
              title={`AI summary from transcripts + email${aiStatus.generated_at ? ` · ${new Date(aiStatus.generated_at).toLocaleDateString()}` : ''}`}>
              <div className="font-semibold text-indigo-800 mb-0.5">🤖 Where things stand (from meetings + email)</div>
              {aiStatus.last && <div><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">Last</span>{aiStatus.last}</div>}
              {aiStatus.next && <div className="mt-0.5"><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">Next</span>{aiStatus.next}</div>}
              {aiStatus.waiting_on && <div className="mt-0.5"><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">Waiting on</span>{aiStatus.waiting_on}</div>}
            </div>
          )}
          {onRecord && (() => {
            const r = onRecord;
            const money = (n) => (n == null || n === '' || isNaN(Number(n))) ? null : '$' + Math.round(Number(n)).toLocaleString();
            const facts = [
              money(r.size_revenue) ? `Revenue ${money(r.size_revenue)}` : null,
              money(r.ebitda) ? `EBITDA ${money(r.ebitda)}` : null,
              r.size_employees ? `${r.size_employees} employees` : null,
              r.business_type || r.sector || null,
              r.website || null,
            ].filter(Boolean);
            const texts = [
              r.notes ? ['Notes', plainNoteText(r.notes)] : null,
              r.description ? ['Description', plainNoteText(r.description)] : null,
              r.action_item ? ['Action item', plainNoteText(r.action_item)] : null,
              r.not_ready_reason ? ['Last outcome', plainNoteText(r.not_ready_reason)] : null,
            ].filter(Boolean);
            if (!facts.length && !texts.length) return null;
            return (
              <div className="bg-amber-50 border border-amber-200 rounded px-3 py-2 text-xs text-gray-700">
                <div className="font-semibold text-amber-800 mb-0.5">📇 On record{r.zoho_last_activity ? ` (incl. Zoho, last activity ${r.zoho_last_activity})` : ''}</div>
                {facts.length > 0 && <div className="text-gray-600">{facts.join(' · ')}</div>}
                {texts.map(([k, v]) => (
                  <div key={k} className="mt-0.5 whitespace-pre-wrap"><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">{k}</span>{v}</div>
                ))}
              </div>
            );
          })()}
          {loadError && <div className="text-sm text-red-600">Couldn't load the history: {loadError}</div>}
          {!loadError && !rows && <div className="text-sm text-gray-400 italic">Loading…</div>}
          {rows && rows.length === 0 && <div className="text-sm text-gray-500">Nothing recorded yet.</div>}
          {rows && rows.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded px-3 py-2 text-xs">
              <div className="flex items-center justify-between gap-2 text-gray-400">
                <span className="font-semibold text-gray-500">{String(r.kind || '').replace(/_/g, ' ')}{r.who ? ` · ${r.who}` : ''}</span>
                <span className="whitespace-nowrap">{r.at ? new Date(r.at).toLocaleString() : ''}</span>
              </div>
              <div className="text-gray-700 mt-0.5 whitespace-pre-wrap">{plainNoteText(r.text) || '(no note)'}</div>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

// A textarea that sizes itself to its text (Colleen 10-16, Blue Spruce: long Research Item questions and
// answers were cut off at a fixed 28/60px, and her manual resize was lost every time she reopened the
// file). Grows on open and as she types; the drag handle still works for a one-off resize.
const AutoGrowTextarea = ({ value, minHeight = 28, maxHeight = 480, style, ...rest }) => {
  const ref = useRef(null);
  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(maxHeight, Math.max(minHeight, el.scrollHeight + 2)) + 'px';
  }, [value, minHeight, maxHeight]);
  return <textarea ref={ref} value={value} style={{ minHeight: minHeight + 'px', overflowY: 'auto', ...(style || {}) }} {...rest} />;
};

// Zoho-imported notes can be raw HTML source (Adam's Cornerstone 08-31:
// a 5/9 note rendered as a wall of <ul style=...> markup). Display-only
// cleanup — the stored note is untouched: structural tags become line
// breaks, the rest strip, entities decode, whitespace collapses.
const plainNoteText = (s) => {
  const t = String(s || '');
  if (!/<[a-z!/][^>]*>/i.test(t)) return t;   // no markup — leave verbatim (preserves owner-typed line breaks)
  return t
    .replace(/<(style|script)[^>]*>[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<\/(p|div|li|ul|ol|h[1-6]|tr)>/gi, '\n')
    .replace(/<(br|hr)\s*\/?>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"').replace(/&#0?39;/g, "'").replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
    .replace(/[ \t]+/g, ' ')
    .replace(/\s*\n\s*/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

// Universal toolbar plumbing (Mark 08-21): VT cards reach their SE row
// through client → se_owners.vt_client_id (every live deal has one since
// the direct-to-Lead mint). MyWorkView fills this map once; cards read it
// at render. Module-level on purpose — ProjectCard is mounted by five
// different sections and threading two props through each was the worse
// trade.
const SE_OWNER_BY_CLIENT = new Map();
// Phone from the owner's own email signature (Adam 09-28: 9 of 49 follow-up
// cards had a phone on file; 28 more carry one in the owner's signature).
// Only the owner's OWN words — text above the quoted reply — and never a Vista
// number (the office line + staff lines ride in every quoted signature).
const VISTA_PHONES = new Set(['9139442285', '9134330062', '7855310974', '9134330058']);
const phoneFromEmailBody = (body) => {
  const own = String(body || '').split(/\n\s*(?:On .{0,120}wrote:|From:\s|-{3,}\s*Original Message|_{5,})/i)[0];
  const re = /(?:\+?1[\s.-]?)?\(?([2-9]\d{2})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})\b/g;
  for (const m of own.matchAll(re)) {
    const digits = m[1] + m[2] + m[3];
    if (!VISTA_PHONES.has(digits)) return `${m[1]}-${m[2]}-${m[3]}`;
  }
  return null;
};
let CARD_ACTOR_NAME = null;

// Provenance chip on CARDS (Konnie 09-09: "once I set them up they are not
// showing as 'Revalue'" — the Pipeline table has carried these badges since
// the returning-client spec's Phase 2, but the CARDS never did, and cards
// are where Konnie lives). ↻ Revalue = archived prior VT cycles;
// ↻ Returning = pre-VT client re-engaged via the Returning-client create —
// this cycle UPDATES an old-system valuation, not a fresh prospect.
const ProvenanceChip = ({ p }) => p?.has_prior_cycles
  ? <span className="flex-shrink-0 text-[10px] font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded px-1.5 py-0.5 whitespace-nowrap" title="Revalue — this deal has at least one archived prior valuation cycle in VT.">↻ Revalue</span>
  : p?.account_type === 'returning'
    ? <span className="flex-shrink-0 text-[10px] font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded px-1.5 py-0.5 whitespace-nowrap" title="Returning client — valued in the old (pre-VT) system and re-engaged; this cycle updates that old valuation.">↻ Returning</span>
    : null;

const ProjectCard = ({ project, tone: toneIn, onOpen, viewers = [] }) => {
  const seOwnerId = project.client_id ? (SE_OWNER_BY_CLIENT.get(project.client_id) || null) : null;
  // A neutral plate card past its stage target reads AMBER, not just first
  // (Mark 09-21, the On-your-plate review: a partial sat 10 days at
  // analysis-complete against a 1-day target and looked like every other card).
  const tone = (toneIn === 'neutral' && project.stageOverdue) ? 'amber' : toneIn;
  const borderColor = tone === 'red' ? 'border-red-300' : tone === 'amber' ? 'border-amber-300' : 'border-gray-200';
  // Secondary urgency line — kept beneath the headline next-action so the
  // card still shows "how stuck" / "next meeting when" at a glance.
  const urgency = tone === 'red'
    ? `${project.daysPastCommitted}d past committed${project.isSnoozed ? ' (snoozed)' : ''}`
    : tone === 'amber'
      ? `${project.daysInStage}d in stage · target ${project.targetDays}d`
      : project.next_meeting_date
        ? `Next: ${project.next_meeting_type || 'meeting'} ${new Date(project.next_meeting_date).toLocaleDateString()}`
        : `${project.daysInStage == null ? 0 : project.daysInStage}d in stage`;
  const intLabel = project.interactionKind ? (INTERACTION_KINDS[project.interactionKind] || {}).label : null;
  return (
    // A div-as-button (not <button>): the toolbar inside it has its own
    // buttons, and nested <button>s are invalid HTML that browsers unwrap.
    <div
      role="button" tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(); } }}
      className={`text-left bg-white border ${borderColor} rounded-lg p-4 hover:shadow-md transition w-full cursor-pointer`}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <div className="font-semibold text-gray-800 truncate">{project.company_name}</div>
          <ProvenanceChip p={project} />
          <InheritedAmBadge am={project.account_manager} />
          {project.myReminderCount > 0 && (
            <span
              className="flex-shrink-0 text-[10px] font-bold bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded whitespace-nowrap"
              title={`${project.myReminderCount} reminder${project.myReminderCount === 1 ? '' : 's'} set on this project`}
            >
              🔔 {project.myReminderCount}
            </span>
          )}
        </div>
        <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded ${stageColor(project.workflow_stage)} whitespace-nowrap`}>
          {stageLabel(project.workflow_stage)}
        </span>
      </div>
      {viewers.length > 0 && (
        <div className="text-xs font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 mb-2">
          👁 {viewers.join(', ')} {viewers.length === 1 ? 'has' : 'have'} this file open
        </div>
      )}
      {project.nextAction && (
        <div className="text-sm text-gray-800 font-medium mb-1">▸ {project.nextAction}</div>
      )}
      {/* The stage exit everything downstream hangs on (Mark 09-21): a valued
          deal parked at val_meeting_set after the meeting is invisible to the
          follow-up sections, the review cadence and the commission pipeline. */}
      {project.workflow_stage === 'val_meeting_set' && project.next_meeting_date
        && new Date(project.next_meeting_date + 'T00:00:00') < new Date(new Date().toISOString().slice(0, 10) + 'T00:00:00') && (
        <div className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1 mb-1">Until the outcome is recorded, this deal is invisible to follow-ups, the review cadence and the pipeline. Open it → record engaged / considering / inactive.</div>
      )}
      <div className="text-xs text-gray-500 mb-2">{urgency}</div>
      {intLabel && (
        <div className="text-xs text-gray-600">
          <span className="font-semibold">{intLabel}</span>
          {project.interactionAt && <span className="text-gray-400"> · {formatRelativeDate(project.interactionAt)}</span>}
          {project.interactionEmailUnverified && (
            <span className="ml-1 text-[10px] font-bold px-1.5 py-0.5 rounded bg-rose-100 text-rose-700" title="This outreach claimed an email, but no matching sent email was found in the mailbox within the grace window.">⚠ no matching sent email</span>
          )}
          {project.interactionNote && <span className="block text-gray-400 line-clamp-2">{project.interactionNote}</span>}
        </div>
      )}
      {/* Observed email truth (recognition slice): what the synced mailboxes
          actually saw — effort shows without anyone logging anything. */}
      {project.emailTruth && (project.emailTruth.lastOut || project.emailTruth.lastIn) && (() => {
        const t = project.emailTruth;
        const awaitingUs = t.lastIn && (!t.lastOut || t.lastIn > t.lastOut);
        return (
          <div className={`text-xs mt-0.5 ${awaitingUs ? 'text-amber-700' : 'text-emerald-700'}`}>
            📧 {awaitingUs
              ? `owner emailed ${formatRelativeDate(t.lastIn)} — awaiting our reply${t.lastOut ? ` (we last wrote ${formatRelativeDate(t.lastOut)})` : ''}`
              : `${t.lastOutBy || 'we'} emailed the owner ${formatRelativeDate(t.lastOut)}${t.lastIn ? ` · owner last wrote ${formatRelativeDate(t.lastIn)}` : ''}`}
          </div>
        );
      })()}
      {/* AI "where we are" (ROADMAP #4, 2026-08-06): the glanceable line —
          the agreed next step, synthesized from transcripts + the email
          thread. Hover shows the full Last / Next / Waiting-on. */}
      {project.ai_status && (project.ai_status.next || project.ai_status.waiting_on || project.ai_status.last) && (
        <div className="text-xs text-indigo-700 mt-0.5 line-clamp-2"
          title={`AI summary · ${project.ai_status.generated_at ? new Date(project.ai_status.generated_at).toLocaleDateString() : ''}\nLast: ${project.ai_status.last || '—'}\nNext: ${project.ai_status.next || '—'}\nWaiting on: ${project.ai_status.waiting_on || '—'}`}>
          🤖 {project.ai_status.next || project.ai_status.waiting_on || project.ai_status.last}
        </div>
      )}
      {project.docsTotal > 0 && (
        <div className="mt-3 text-xs text-gray-400">
          {project.docsDone}/{project.docsTotal} docs{project.usePlanned ? ' planned' : ''}
          {/* "Needs verify" is a Stage-C signal (AI auto-classify → Konnie
              confirms → verified_at). Pre-Stage-C verified_at is never written,
              so it always equals every complete doc — meaningless noise. Hidden
              until Stage C. (2026-06-08) */}
        </div>
      )}
      {/* Open-items categories (2026-06-08) — Colleen's card reflects the Open
          Items tab: flags to review, owner questions to send, and questions
          awaiting an answer (with a follow-up nudge once a week passes). */}
      {((project.openItemsOpen != null && project.openItemsOpen > 0) || (project.questionsToSend || 0) > 0 || (project.questionsAwaiting || 0) > 0 || project.ownerAnswerUnreviewed) && (
        <div className="mt-2 text-xs flex flex-wrap gap-x-3 gap-y-0.5">
          {project.ownerAnswerUnreviewed && <span className="text-sky-700 font-semibold bg-sky-50 border border-sky-200 rounded px-1.5">📥 answered — review &amp; accept</span>}
          {project.openItemsOpen > 0 && <span className="text-amber-700 font-medium">✎ {project.openItemsOpen} to review</span>}
          {(project.questionsToSend || 0) > 0 && <span className="text-emerald-700 font-medium">📤 {project.questionsToSend} to send</span>}
          {(project.questionsAwaiting || 0) > 0 && !project.ownerAnswerUnreviewed && (
            <span className="text-gray-500">⏳ {project.questionsAwaiting} awaiting{project.daysSinceQuestionsSent != null ? ` · asked ${project.daysSinceQuestionsSent}d ago` : ''}</span>
          )}
          {(project.questionsAwaiting || 0) > 0 && !project.ownerAnswerUnreviewed && project.daysSinceQuestionsSent != null && project.daysSinceQuestionsSent >= 3 && (
            <span className="text-red-600 font-semibold">⏰ follow up</span>
          )}
        </div>
      )}
      {/* Universal toolbar (Mark 08-21): the three doors every card gets. */}
      <CardToolbar className="mt-3" valuationId={project.id} ownerId={seOwnerId} companyName={project.company_name} actor={CARD_ACTOR_NAME} />
    </div>
  );
};

// "Needs setup" — the top, most-actionable My Work block. Projects missing a
// field the tool needs to function (committed date, owner email, path, etc.).
// These fail silently otherwise, so they get their own loud amber treatment
// and spell out exactly what to add. (2026-06-08)
const NeedsSetupSection = ({ items, onOpenValuation, presenceByValuation = {} }) => (
  <div className="mb-6">
    <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-amber-700">
      ⚠ Needs setup <span className="text-gray-400 font-normal">({items.length})</span>
    </h2>
    <p className="text-xs text-gray-500 mb-3">
      Missing details the tool needs before it can work these — e.g. without a committed date the reminder cadence can't run.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {items.map(p => {
        const viewers = presenceByValuation[p.id] || [];
        return (
          <button
            key={p.id}
            onClick={() => onOpenValuation({ id: p.id, name: p.name })}
            className="text-left bg-amber-50 border border-amber-300 rounded-lg p-4 hover:shadow-md transition w-full"
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="font-semibold text-gray-800 truncate">{p.company_name}</div>
              <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded ${stageColor(p.workflow_stage)} whitespace-nowrap`}>
                {stageLabel(p.workflow_stage)}
              </span>
            </div>
            {viewers.length > 0 && (
              <div className="text-xs font-semibold text-amber-700 bg-amber-100 border border-amber-200 rounded px-2 py-1 mb-2">
                👁 {viewers.join(', ')} {viewers.length === 1 ? 'has' : 'have'} this file open
              </div>
            )}
            <div className="text-sm text-amber-800 font-medium mb-1">▸ Add: {p.setupIssues.join(', ')}</div>
            <div className="text-xs text-gray-500">Open the project's Setup tab to fill these in.</div>
          </button>
        );
      })}
    </div>
  </div>
);

// Collapsed "monitor" section — a calm, expandable list of projects where the
// ball is NOT in the viewer's court (waiting on owners; snoozed). Collapsed by
// default so it doesn't read as a to-do; expand for the detail (last email
// sent, etc.). Renders nothing when empty. (2026-06-08)
const MonitorSection = ({ title, items, note, onOpenValuation, presenceByValuation = {} }) => {
  const [open, setOpen] = useState(false);
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-6">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-gray-500 hover:text-gray-700"
      >
        <span className="text-gray-400">{open ? '▾' : '▸'}</span>
        <span>{title}</span>
        <span className="text-gray-400 font-normal">({items.length})</span>
      </button>
      {note && <p className="text-xs text-gray-400 mt-1 ml-5">{note}</p>}
      {open && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
          {items.map(p => (
            <ProjectCard
              key={p.id}
              project={p}
              tone="neutral"
              viewers={presenceByValuation[p.id] || []}
              onOpen={() => onOpenValuation({ id: p.id, name: p.name })}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// AM follow-up card (2026-06-09) — the Account Manager works entirely from
// here, no file access: schedule the next touch (presets + a date picker),
// log an outreach, or bring a parked owner back. Tailored + simple per Mark.
const AmFollowUpCard = ({ project, onSetFollowUp, onClearFollowUp, onLogOutreach, onReEngage, onMarkDead, onOpen, onRevivalResume, onRevivalDismiss }) => {
  const [logged, setLogged] = useState(false);
  const [note, setNote] = useState('');
  const [pickDate, setPickDate] = useState('');
  const [threadOpen, setThreadOpen] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  // Step 3 (Adam-plate plan 08-11, Mark: HARD-require): logging a touch on a
  // due card forces the next-touch pick — no dismissing, same discipline as
  // the SE outcome modal. A touch without a next step is how owners dangle.
  const [pickOpen, setPickOpen] = useState(false);
  const addDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
  // '2 mo' (Adam 10-13, Berkman: owners say "a month or two" — with no preset he
  // reached for the date picker, which needs ✓ Set).
  const presets = [['1 wk', 7], ['1 mo', 30], ['2 mo', 60], ['3 mo', 90], ['6 mo', 180]];
  const parked = !!project.snooze_until && project.isSnoozed;
  // Most recent contact note (suppress the generic auto-text so only real notes show).
  const lastNote = (project.interactionNote || '').trim();
  const showLast = lastNote && lastNote !== 'Reached out to the owner';
  const lastNoteDate = project.interactionAt ? new Date(project.interactionAt).toLocaleDateString() : '';
  // Surface the Lead-meeting verdict UP FRONT, while the AM is on the call —
  // a read-out of the exact rule reEngageProject applies after the click, so the
  // AM can tell the owner whether re-engaging needs a fresh Lead meeting or can
  // go straight to uploads. Only meaningful where re-engage is available.
  const reengage = onReEngage ? computeReengageRouting(project) : null;
  const reengageVerdict = (() => {
    if (!reengage) return null;
    const m = reengage.months;
    const spoke = m == null ? null : (m <= 0 ? 'last spoke this month' : `last spoke ${m} mo ago`);
    if (reengage.skipMeeting) {
      return { ok: true, label: 'Re-engage: no Lead meeting needed',
        detail: ['Full valuation', spoke].filter(Boolean).join(' · ') };
    }
    const reasons = [];
    if (!reengage.isFull) reasons.push(project.path === 'partial' ? 'Partial valuation' : 'not a Full valuation');
    if (m == null) reasons.push('no prior meeting on record');
    else if (m > REENGAGE_SKIP_MONTHS) reasons.push(`last spoke ${m} mo ago (>${REENGAGE_SKIP_MONTHS} mo)`);
    return { ok: false, label: 'Re-engage: needs a fresh Lead meeting', detail: reasons.join(' · ') };
  })();
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-start justify-between gap-2 mb-1">
        <button type="button" onClick={onOpen} className="font-semibold text-gray-800 truncate text-left hover:underline" title="Open the project">{project.company_name}</button>
        <InheritedAmBadge am={project.account_manager} />
        <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${stageColor(project.workflow_stage)} whitespace-nowrap`}>{stageLabel(project.workflow_stage)}</span>
      </div>
      <div className="text-sm text-gray-800 mb-1">▸ {project.nextAction}</div>
      {/* The contact, ON the card (Adam 09-28 — he left for the account page
          just to get the number). Click to call / email. */}
      {project.contact && (project.contact.name || project.contact.phone || project.contact.email) && (
        <div className="text-xs text-gray-700 mb-2 flex flex-wrap items-center gap-x-3 gap-y-0.5">
          {project.contact.name && <span className="font-medium">👤 {project.contact.name}</span>}
          {project.contact.phone && <a href={'tel:' + String(project.contact.phone).replace(/[^\d+]/g, '')} className="text-blue-700 hover:underline" title={project.contact.phoneFromEmail ? "Read from the owner's own email signature — not yet on the record" : undefined}>📞 {project.contact.phone}{project.contact.phoneFromEmail ? <span className="text-gray-400"> (from their email)</span> : null}</a>}
          {project.contact.email && <a href={'mailto:' + project.contact.email} className="text-blue-700 hover:underline truncate">✉ {project.contact.email}</a>}
        </div>
      )}
      {/* 🌱 The owner beat the card (Mark 09-08, E2E: Kamal answered the
          final reminder 8 minutes after it made this card — by the time the
          AM read it, its advice was stale). When that happens the card says
          so and asks for NOTHING: Konnie confirms the new date from her
          conversation, the clock restarts, and this card clears itself. */}
      {/* 🌱 The post-stall reply, ON the AM's card (Mark 09-09: stalled =
          the AM's; Konnie only enters data and sends reminders). The
          system knows the owner REPLIED — what it means is the AM's read:
          back in motion → Resume (deal returns to Konnie's cadence with
          the new date, this card clears); brush-off → Not re-engaging
          (logged; this follow-up stays yours; a newer reply cards again).
          Out-of-office auto-replies never reach here. */}
      {project._revival && (
        <div className="text-xs rounded p-2 mb-2 border bg-emerald-50 border-emerald-300 text-emerald-800">
          <div><span className="font-semibold">🌱 Owner replied after the final reminder</span> ({new Date(project._revival.replyAt).toLocaleDateString()}) — your read:</div>
          {project._revival.replySnippet && <div className="italic text-gray-700 bg-white border border-emerald-200 rounded p-1.5 mt-1">"{project._revival.replySnippet}"</div>}
          {/* Adam 09-25 (Focus IT): "he'll re-engage soon, I'll touch base in a
              month or two — I just want a reminder." That read had no door: the
              only "no" said "Not re-engaging", and he read Reschedule as
              starting the process. Reschedule only sets when this card comes
              back; the "no for now" door is named for what it is. */}
          <div className="text-[11px] text-emerald-900 mt-1">Just want to check back later? Pick a <span className="font-semibold">Reschedule</span> date below — that answers the reply and the card clears until then; it starts nothing. (No date needed? <span className="font-semibold">✕ Not now</span>.)</div>
          <div className="flex justify-end gap-2 mt-1.5">
            <button type="button" className="text-[11px] px-2 py-1 rounded border border-gray-300 text-gray-600 bg-white hover:bg-gray-50"
              title="Not a restart right now — a deferral (&quot;soon&quot;, &quot;a month or two&quot;), a brush-off, or noise. Logged with your note; nothing starts; the follow-up stays on your plate on its current date. Want a specific date? Just pick Reschedule instead — that answers the reply on its own. A newer reply from the owner cards again."
              onClick={() => onRevivalDismiss && onRevivalDismiss(project._revival)}>✕ Not now</button>
            <button type="button" className="text-[11px] px-2.5 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700 font-semibold"
              title="They're genuinely back: prompts for the new committed upload date (from their reply or your conversation), moves the deal to Awaiting Upload, and Konnie's reminder cadence takes it from there — this card clears."
              onClick={() => onRevivalResume && onRevivalResume(project._revival)}>▶ Resume — new committal date</button>
          </div>
        </div>
      )}
      {reengageVerdict && !project._revival && (
        <div className={`text-xs rounded p-2 mb-2 border ${reengageVerdict.ok
          ? 'bg-emerald-50 border-emerald-200 text-emerald-800'
          : 'bg-amber-50 border-amber-200 text-amber-800'}`}
          title="What happens if you re-engage now — the system decides; it's not the AM's call">
          <span className="font-semibold">{reengageVerdict.ok ? '✓ ' : '↻ '}{reengageVerdict.label}</span>
          {reengageVerdict.detail ? <span className="opacity-90"> — {reengageVerdict.detail}</span> : null}
        </div>
      )}
      {parked && (
        <div className="text-xs text-gray-500 mb-2">
          Following up {new Date(project.snooze_until + 'T00:00:00').toLocaleDateString()}
          <button type="button" onClick={() => onClearFollowUp(project.id)} className="ml-2 text-blue-600 hover:underline">bring back now</button>
        </div>
      )}
      {/* Step 2 (Adam-plate plan 08-11): the card carries the valuation
          context so the AM never leaves to learn how the call went. */}
      {project.leaveOff && (
        <div className="text-xs bg-yellow-50 border border-yellow-300 rounded p-2 mb-2 text-gray-700">
          <span className="font-semibold text-yellow-800">📌 Where it left off{project.leaveOff.at ? ` · ${new Date(project.leaveOff.at).toLocaleDateString()}` : ''}{project.leaveOff.who ? ` · ${project.leaveOff.who}` : ''}:</span> {project.leaveOff.note}
        </div>
      )}
      {(project.valuation_date || project.value_provided_high) && (
        <div className="text-xs text-gray-500 mb-2">
          💰 Valuation{project.valuation_date ? ` ${new Date(project.valuation_date + 'T00:00:00').toLocaleDateString()}` : ''}
          {project.value_provided_high ? ` · value delivered ≈ $${Math.round(Number(project.value_provided_high)).toLocaleString()}` : ''}
        </div>
      )}
      {project.ai_status && (project.ai_status.last || project.ai_status.next || project.ai_status.waiting_on) && (
        <div className="text-xs bg-indigo-50 border border-indigo-100 rounded p-2 mb-2 text-gray-700"
          title={`AI summary from transcripts + email${project.ai_status.generated_at ? ` · ${new Date(project.ai_status.generated_at).toLocaleDateString()}` : ''}`}>
          {project.ai_status.last && <div><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">Last</span>{project.ai_status.last}</div>}
          {project.ai_status.next && <div className="mt-0.5"><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">Next</span>{project.ai_status.next}</div>}
          {project.ai_status.waiting_on && <div className="mt-0.5"><span className="font-semibold text-gray-500 text-[10px] uppercase tracking-wide mr-1.5">Waiting on</span>{project.ai_status.waiting_on}</div>}
        </div>
      )}
      {showLast && (
        <div className="text-xs bg-gray-50 border border-gray-200 rounded p-2 mb-2 text-gray-600">
          <span className="font-semibold text-gray-500">🗒 Last note{lastNoteDate ? ` · ${lastNoteDate}` : ''}:</span> {lastNote}
        </div>
      )}
      <input type="text" value={note} onChange={e => setNote(e.target.value)}
        placeholder="Add a note about this contact (optional)…"
        className="w-full text-xs border rounded px-2 py-1 mb-2 text-gray-700" />
      <div className="flex flex-wrap items-center gap-1.5 mb-2">
        <span className="text-xs text-gray-500">{parked ? 'Reschedule:' : 'Follow up in:'}</span>
        {presets.map(([lbl, days]) => (
          <button key={lbl} type="button" onClick={() => { onSetFollowUp(project.id, addDays(days), note, project._revival || null); setNote(''); }}
            className="px-2 py-0.5 text-xs rounded bg-gray-100 hover:bg-gray-200 text-gray-700">{lbl}</button>
        ))}
        {/* Explicit ✓ confirm — the native input's spinner arrows fill in a full
            date on first press, and committing on that onChange parked cards the
            moment someone touched an arrow (Adam, 2026-07-23). */}
        <input type="date" value={pickDate} onChange={e => setPickDate(e.target.value)}
          className="text-xs border rounded px-1 py-0.5 text-gray-600" title="Pick a date, then confirm with ✓" />
        {pickDate && (
          <button type="button" onClick={() => { onSetFollowUp(project.id, pickDate, note, project._revival || null); setPickDate(''); setNote(''); }}
            className="px-2 py-0.5 text-xs font-semibold rounded bg-blue-600 text-white hover:bg-blue-700">✓ Set</button>
        )}
        {pickDate && <span className="text-[11px] text-amber-700">not saved until ✓ Set</span>}
      </div>
      {/* The three outreach outcomes: reschedule the next touch (presets above),
          re-engage (owner moving forward), or mark dead. "Reached out today"
          logs a contact (with the note above) that didn't change anything. */}
      <div className="flex flex-wrap items-center gap-2">
        {/* Every touch asks for the next date — parked cards too (Adam 10-13,
            Berkman Tech: he replied to the owner on a card already parked for
            the 12th, the touch logged, no date was asked for, and "a month or
            two" never got recorded — the card came back on the old date). */}
        <button type="button" onClick={() => { onLogOutreach(project.id, note); setLogged(true); setNote(''); setPickOpen(true); }}
          className={`px-2 py-1 text-xs font-medium rounded ${logged ? 'bg-green-500 text-white' : 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'}`}>
          {logged ? '✓ Logged outreach' : 'Reached out today'}
        </button>
        {onReEngage && (
          <button type="button" onClick={() => onReEngage(project)}
            title="Owner is moving forward — start a new valuation cycle (the system decides whether a Lead meeting is needed)"
            className="px-2 py-1 text-xs font-semibold rounded bg-amber-100 text-amber-800 hover:bg-amber-200">
            ▶ Moving forward — re-engage
          </button>
        )}
        {onMarkDead && (
          <button type="button" onClick={() => onMarkDead(project)}
            title="Owner isn't moving forward — mark the project dead"
            className="px-2 py-1 text-xs font-semibold rounded bg-gray-100 text-gray-600 hover:bg-red-100 hover:text-red-700">
            ✕ Mark dead
          </button>
        )}
        {/* The universal toolbar (Adam 09-28): 🧵 Thread · 🗒 Notes · ↗ Account —
            same doors as every other card; replaces this card's own two buttons. */}
        <CardToolbar valuationId={project.id} ownerId={(project.contact && project.contact.seOwnerId) || SE_OWNER_BY_CLIENT.get(project.client_id) || null}
          companyName={project.company_name} actor={CARD_ACTOR_NAME} />
      </div>

      {pickOpen && ReactDOM.createPortal(
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-5">
            <div className="font-semibold text-gray-800 mb-1">✓ Touch logged — {project.company_name}</div>
            <p className="text-sm text-gray-600 mb-3">When does this owner come back on your plate? Pick one — a touch without a next step is how owners fall through.</p>
            <div className="flex flex-wrap items-center gap-1.5 mb-3">
              {presets.map(([lbl, days]) => (
                <button key={lbl} type="button"
                  onClick={() => { onSetFollowUp(project.id, addDays(days), '', project._revival || null); setPickOpen(false); }}
                  className="px-3 py-1.5 text-sm rounded bg-blue-50 hover:bg-blue-100 text-blue-800 font-medium">{lbl}</button>
              ))}
              <input type="date" value={pickDate} onChange={e => setPickDate(e.target.value)}
                className="text-sm border rounded px-2 py-1 text-gray-600" />
              {pickDate && (
                <button type="button" onClick={() => { onSetFollowUp(project.id, pickDate, '', project._revival || null); setPickDate(''); setPickOpen(false); }}
                  className="px-3 py-1.5 text-sm font-semibold rounded bg-blue-600 text-white hover:bg-blue-700">✓ Set</button>
              )}
            </div>
            {/* Already parked: keeping the date is a pick too, one click. */}
            {parked && (
              <div className="mb-3 -mt-1">
                <button type="button" onClick={() => { setPickDate(''); setPickOpen(false); }}
                  className="text-xs text-gray-600 hover:underline">
                  Keep {new Date(project.snooze_until + 'T00:00:00').toLocaleDateString()} — nothing changed
                </button>
              </div>
            )}
            <div className="flex flex-wrap items-center gap-2 border-t pt-3">
              {onReEngage && (
                <button type="button" onClick={() => { setPickOpen(false); onReEngage(project); }}
                  className="px-2 py-1 text-xs font-semibold rounded bg-amber-100 text-amber-800 hover:bg-amber-200">
                  ▶ They're moving forward — re-engage
                </button>
              )}
              {onMarkDead && (
                <button type="button" onClick={() => { setPickOpen(false); onMarkDead(project); }}
                  className="px-2 py-1 text-xs font-semibold rounded bg-gray-100 text-gray-600 hover:bg-red-100 hover:text-red-700">
                  ✕ Not moving forward — mark dead
                </button>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

// Section wrapper for the AM follow-up lists (active = expanded; parked =
// collapsed monitor), rendering AmFollowUpCards. (2026-06-09)
const AmFollowUpSection = ({ title, items, note, collapsed, onOpenValuation, onSetFollowUp, onClearFollowUp, onLogOutreach, onReEngage, onMarkDead, onRevivalResume, onRevivalDismiss }) => {
  const [open, setOpen] = useState(!collapsed);
  if (!items || items.length === 0) return null;
  const cards = (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
      {items.map(p => (
        <AmFollowUpCard key={p.id} project={p}
          onSetFollowUp={onSetFollowUp} onClearFollowUp={onClearFollowUp} onLogOutreach={onLogOutreach}
          onReEngage={onReEngage} onMarkDead={onMarkDead}
          onRevivalResume={onRevivalResume} onRevivalDismiss={onRevivalDismiss}
          onOpen={() => onOpenValuation({ id: p.id, name: p.name })} />
      ))}
    </div>
  );
  if (!collapsed) {
    return (
      <div className="mb-6">
        <h2 className="text-sm font-bold uppercase tracking-wide mb-1 text-gray-600">{title} <span className="text-gray-400 font-normal">({items.length})</span></h2>
        {note && <p className="text-xs text-gray-400 mb-1">{note}</p>}
        {cards}
      </div>
    );
  }
  return (
    <div className="mb-6">
      <button type="button" onClick={() => setOpen(o => !o)} className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-gray-500 hover:text-gray-700">
        <span className="text-gray-400">{open ? '▾' : '▸'}</span><span>{title}</span><span className="text-gray-400 font-normal">({items.length})</span>
      </button>
      {note && <p className="text-xs text-gray-400 mt-1 ml-5">{note}</p>}
      {open && cards}
    </div>
  );
};

const ColumnsMenu = ({ hiddenColumns, onToggle }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);
  const total = PIPELINE_COLUMNS.length;
  const visible = total - PIPELINE_COLUMNS.filter(c => hiddenColumns.has(c.key)).length;
  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1.5 bg-gray-100 hover:bg-gray-200 rounded px-2 py-1 text-gray-700"
        title="Show or hide columns"
      >
        <span className="text-gray-500 font-semibold uppercase tracking-wide text-[10px]">⚙ Columns</span>
        <span className="text-[11px] text-gray-500">{visible}/{total}</span>
      </button>
      {open && (
        <div className="absolute z-20 mt-1 bg-white border border-gray-200 rounded shadow-lg p-1.5 min-w-[180px] text-left">
          {PIPELINE_COLUMNS.map(c => {
            const checked = !hiddenColumns.has(c.key);
            return (
              <label
                key={c.key}
                className={`flex items-center gap-2 px-2 py-1 text-xs rounded ${c.required ? 'opacity-60 cursor-default' : 'cursor-pointer hover:bg-gray-50'}`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={!!c.required}
                  onChange={() => onToggle(c.key)}
                />
                <span className="text-gray-700">{c.label}</span>
                {c.required && <span className="text-[9px] text-gray-400 ml-auto uppercase tracking-wide">always</span>}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

// Multi-select stage filter. `selected` is an array of stage keys ([] = all).
// Checkbox dropdown so the user can show several stages at once (e.g. both
// Valuation Complete — Inactive and — Dead). Mirrors ColumnsMenu's pattern.
const StageFilterMenu = ({ selected, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);
  const stages = Object.keys(WORKFLOW_STAGES);
  const toggle = (s) => onChange(selected.includes(s) ? selected.filter(x => x !== s) : [...selected, s]);
  const label = selected.length === 0 ? 'All stages' : `${selected.length} stage${selected.length === 1 ? '' : 's'}`;
  return (
    <div className="relative" ref={ref}>
      <div className="flex items-center gap-1.5 bg-gray-100 rounded px-2 py-1">
        <span className="text-gray-500 font-semibold uppercase tracking-wide text-[10px]">Stage</span>
        <button type="button" onClick={() => setOpen(o => !o)} className="text-xs text-gray-700 hover:text-gray-900 flex items-center gap-1">
          {label} <span className="text-[9px] text-gray-400">▾</span>
        </button>
      </div>
      {open && (
        <div className="absolute z-20 mt-1 bg-white border border-gray-200 rounded shadow-lg p-1.5 min-w-[230px] text-left max-h-[60vh] overflow-y-auto">
          <div className="flex items-center justify-between px-2 py-1 border-b mb-1">
            <span className="text-[10px] uppercase tracking-wide text-gray-400">Show stages</span>
            {selected.length > 0 && (
              <button type="button" onClick={() => onChange([])} className="text-[11px] text-blue-600 hover:underline">Clear</button>
            )}
          </div>
          {stages.map(s => (
            <label key={s} className="flex items-center gap-2 px-2 py-1 text-xs rounded cursor-pointer hover:bg-gray-50">
              <input type="checkbox" checked={selected.includes(s)} onChange={() => toggle(s)} />
              <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${stageColor(s)}`}>{stageLabel(s)}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const PipelineView = ({ rows, gauges, canEditTargets, onSaveTarget, stageFlow, ladder, stageDistribution, uniqueLeads, uniqueAMs, uniqueOwners, filterStage, setFilterStage, filterLead, setFilterLead, filterAM, setFilterAM, filterOwner, setFilterOwner, sortBy, sortDir, toggleSort, hiddenColumns, onToggleColumn, onOpenValuation, presenceByValuation = {}, views = {}, onSaveView, onApplyView, onDeleteView }) => {
  // Saved-views picker (Zac): apply on pick; 💾 prompts a name (reusing the
  // picked name pre-filled = quick "update this view").
  const [activeView, setActiveView] = useState('');
  // Stage Flow section open/closed (#6 A4) — collapsed by default; it's the
  // deep-dive table, not the at-a-glance row.
  const [stageFlowOpen, setStageFlowOpen] = useState(false);
  // Commission-ladder UI state (#6 A1): which rung's breakdown is open, and
  // whether the usually-excluded Valued Inactive side-view is shown.
  const [expandedRung, setExpandedRung] = useState(null);
  const [showInactive, setShowInactive] = useState(false);
  // Targets editor state (#6 A3, owner-only).
  const [editTargetsOpen, setEditTargetsOpen] = useState(false);
  const [targetDrafts, setTargetDrafts] = useState({});
  const [savingTargets, setSavingTargets] = useState(false);
  const openTargetEditor = () => {
    const drafts = {};
    (gauges || []).forEach(g => { drafts[g.key + '|' + g.period] = g.target == null ? '' : String(g.target); });
    setTargetDrafts(drafts);
    setEditTargetsOpen(true);
  };
  const saveTargetDrafts = async () => {
    setSavingTargets(true);
    try {
      for (const g of (gauges || [])) {
        const raw = targetDrafts[g.key + '|' + g.period];
        if (raw == null || String(raw).trim() === '') continue;
        const num = Number(String(raw).replace(/,/g, ''));
        if (isNaN(num) || num < 0) continue;
        if (g.target != null && Number(g.target) === num) continue; // unchanged
        await onSaveTarget(g.key, g.period, num);
      }
      setEditTargetsOpen(false);
    } finally {
      setSavingTargets(false);
    }
  };
  const totalActive = Object.values(stageDistribution).reduce((sum, n) => sum + (n || 0), 0);
  const isVisible = (key) => !hiddenColumns.has(key);
  const fmtMoney = (n) => (n == null || n === '' || isNaN(Number(n))) ? '—' : '$' + Math.round(Number(n)).toLocaleString();
  // Totals across the currently-filtered rows — answers "how full is the book."
  const totalValue = rows.reduce((s, p) => s + (Number(p.value_provided_high) || 0), 0);
  const totalCommission = rows.reduce((s, p) => s + (Number(p.estimated_commission) || 0), 0);
  const SortHeader = ({ col, children, numeric }) => (
    <th
      onClick={() => toggleSort(col)}
      className={`px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 cursor-pointer select-none ${numeric ? 'text-right' : 'text-left'}`}
    >
      {children} {sortBy === col && <span className="text-blue-600">{sortDir === 'asc' ? '↑' : '↓'}</span>}
    </th>
  );
  const fmtDate = (d) => {
    if (!d) return '—';
    const dt = new Date(d);
    return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString();
  };
  return (
    <div>
      {/* Commission ladder (#6 A1) — the post-valuation pipeline in Mark's
          finalized buckets, full-funnel (unaffected by the filters below).
          Replaces the v1 "Active Valued"/"Listed" tiles. Click a rung for
          the per-AM breakdown + business list. */}
      {ladder && (() => {
        const fmtK = (n) => '$' + Math.round(Number(n) || 0).toLocaleString();
        const allBuckets = [ladder.partials, ...ladder.rungs, ladder.branch, ladder.inactive];
        const expanded = allBuckets.find(b => b.key === expandedRung) || null;
        const RungTile = ({ b, arrow, accent }) => (
          <button type="button" onClick={() => setExpandedRung(x => x === b.key ? null : b.key)} title={b.tip}
            className={`text-left rounded-lg border p-3 transition ${expandedRung === b.key ? 'border-blue-400 bg-blue-50' : 'bg-white border-gray-200 hover:border-gray-300'}`}>
            <div className="text-[11px] font-bold uppercase tracking-wide text-gray-500 mb-1">{arrow ? '→ ' : ''}{b.label}</div>
            <div className={`text-xl font-bold ${accent || 'text-emerald-700'}`}>{fmtK(b.commission)}</div>
            <div className="text-xs text-gray-500 mt-0.5">{b.count} business{b.count === 1 ? '' : 'es'}{b.negotiatingCount ? ` · ${b.negotiatingCount} contract pending` : ''}</div>
          </button>
        );
        return (
          <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
            <div className="flex items-baseline justify-between flex-wrap gap-2 mb-3">
              <div className="text-xs font-bold uppercase tracking-wide text-gray-500">📈 Commission Pipeline</div>
              <div className="flex items-center gap-3">
                {ladder.dmDown && <span className="text-[11px] font-semibold text-red-600" title="The Deal Manager listings fetch failed — Under LOI numbers are missing and Engaged may be incomplete. Reload, or check the server logs.">⚠ Deal Manager data unavailable</span>}
                <button type="button" onClick={() => { setShowInactive(s => !s); if (expandedRung === 'inactive') setExpandedRung(null); }}
                  className="text-[11px] text-blue-600 hover:underline">
                  {showInactive ? 'Hide' : 'Show'} Valued Inactive ({ladder.inactive.count})
                </button>
              </div>
            </div>
            <div className={`grid grid-cols-2 gap-3 ${showInactive ? 'md:grid-cols-7' : 'md:grid-cols-6'}`}>
              <RungTile b={ladder.partials} accent="text-sky-600" />
              {ladder.rungs.map((b, i) => <RungTile key={b.key} b={b} arrow={i > 0} />)}
              <RungTile b={ladder.branch} accent="text-teal-700" />
              {showInactive && <RungTile b={ladder.inactive} accent="text-gray-500" />}
            </div>
            {expanded && (
              <div className="mt-3 border-t pt-3">
                <div className="flex items-baseline gap-2 mb-2">
                  <div className="text-sm font-bold text-gray-700">{expanded.label}</div>
                  <div className="text-xs text-gray-500">{expanded.count} business{expanded.count === 1 ? '' : 'es'} · {fmtK(expanded.commission)}</div>
                </div>
                <div className="flex flex-wrap gap-2 mb-2">
                  {Object.entries(expanded.byAm).sort((a, b) => b[1].commission - a[1].commission).map(([am, t]) => (
                    <span key={am} className="text-xs bg-gray-50 border border-gray-200 rounded px-2 py-1">
                      <span className="font-semibold text-gray-700">{am}</span>
                      <span className="text-gray-500"> · {t.count} · </span>
                      <span className="font-semibold text-emerald-700">{fmtK(t.commission)}</span>
                    </span>
                  ))}
                </div>
                <div className="max-h-56 overflow-y-auto">
                  {(() => {
                    // Three layouts: Under LOI gets deal columns (buyer, price,
                    // dates, clock); Engaged gets market columns; valuation
                    // rungs keep the meeting/stage columns.
                    const isMarket = expanded.key === 'engaged';
                    const isLoi = expanded.key === 'underLoi';
                    const isBranch = expanded.key === 'branch';
                    const fmtD = (d) => d ? new Date(d + 'T00:00:00').toLocaleDateString() : '—';
                    const onMkt = (d) => { if (!d) return null; const n = Math.floor((Date.now() - new Date(d + 'T00:00:00').getTime()) / 86400000); return n >= 0 ? n : null; };
                    const daysTo = (d) => { if (!d) return null; return Math.ceil((new Date(d + 'T00:00:00').getTime() - Date.now()) / 86400000); };
                    const Clock = ({ r }) => {
                      if (r.negotiating) {
                        const dl = daysTo(r.loiDeadline);
                        return dl == null ? <span className="text-gray-400">—</span>
                          : dl < 0 ? <span className="text-purple-700 font-medium">contract pending</span>
                          : <span className="font-semibold text-amber-600">offers in {dl}d</span>;
                      }
                      const dc = daysTo(r.projectedClose);
                      return dc == null ? <span className="text-gray-400">—</span>
                        : dc < 0 ? <span className="font-semibold text-red-600">{-dc}d past</span>
                        : dc <= 14 ? <span className="font-semibold text-amber-600">in {dc}d</span>
                        : <span className="text-gray-500">in {dc}d</span>;
                    };
                    return (
                      <table className="w-full text-xs">
                        <thead className="sticky top-0 bg-white">
                          <tr className="text-[10px] font-bold uppercase tracking-wide text-gray-500">
                            <th className="py-1 pr-2 text-left">Business</th>
                            <th className="py-1 pr-2 text-left">Lead</th>
                            <th className="py-1 pr-2 text-left">AM</th>
                            {isBranch ? (<>
                              <th className="py-1 pr-2 text-right" title="The valuation delivered (value provided, high)">Last Value</th>
                              <th className="py-1 pr-2 text-left" title="When the last valuation was delivered">Valued</th>
                              <th className="py-1 pr-2 text-left" title="Strategic Review rows: the next scheduled review. Follow-up rows: the promised next touch. Overdue dates show red — chase or reschedule. Blank = the 'Schedule the strategic review' card is chasing it.">Next Review</th>
                              <th className="py-1 pr-2 text-right" title="Days since entering the review/follow-up loop">In Loop</th>
                            </>) : isLoi ? (<>
                              <th className="py-1 pr-2 text-left" title="The winning LOI's buyer (active LOI on file in DM)">Buyer</th>
                              <th className="py-1 pr-2 text-right" title="The winning LOI's price (extracted EV)">LOI Price</th>
                              <th className="py-1 pr-2 text-left" title="Signed LOI date — negotiating deals show 'not signed'">Signed</th>
                              <th className="py-1 pr-2 text-left" title="Projected close date">Proj. Close</th>
                              <th className="py-1 pr-2 text-left" title="Signed: countdown to the projected close (past due red). Negotiating: countdown to the LOI (offers-due) deadline, then simply 'negotiating'.">Clock</th>
                            </>) : isMarket ? (<>
                              <th className="py-1 pr-2 text-left" title="DM marketing date — blank means engaged but not yet marketed (CIM in build)">Marketed</th>
                              <th className="py-1 pr-2 text-right" title="Days on market">On Mkt</th>
                              <th className="py-1 pr-2 text-left" title="IOI deadline set in DM">IOI Deadl.</th>
                              <th className="py-1 pr-2 text-left" title="LOI deadline (Round-2 offers-due date) set in DM">LOI Deadl.</th>
                              <th className="py-1 pr-2 text-right" title="Active buyers in DM (deal not dead/declined/closed)">Buyers</th>
                              <th className="py-1 pr-2 text-right" title="Deals with an extracted IOI on file">IOIs</th>
                              <th className="py-1 pr-2 text-right" title="Deals with an extracted LOI on file">LOIs</th>
                            </>) : (<>
                              <th className="py-1 pr-2 text-left" title="Meeting Set: the scheduled valuation meeting. Awaiting Decision: when the valuation meeting happened (the decision clock's start). Follow-up Scheduled: the promised next touch.">Meeting</th>
                              <th className="py-1 pr-2 text-right" title="Days in the current stage">In Stage</th>
                              <th className="py-1 pr-2 text-right" title="The valuation delivered (value provided, high)">Value</th>
                            </>)}
                            <th className="py-1 text-right">Est. Commission</th>
                          </tr>
                        </thead>
                        <tbody>
                          {expanded.rows.slice().sort((a, b) => b.commission - a.commission).map((r, i) => (
                            <tr key={i} className="border-t border-gray-100">
                              <td className="py-1 pr-2 text-gray-800">{r.name}<CommissionMarkers r={r} /></td>
                              <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{r.lead || '—'}</td>
                              <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{r.am || '—'}</td>
                              {isBranch ? (<>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-600">{r.value ? fmtK(r.value) : '—'}</td>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{fmtD(r.valuationDate)}</td>
                                <td className="py-1 pr-2 whitespace-nowrap">{(() => {
                                  const d = daysTo(r.meetingDate);
                                  return r.meetingDate
                                    ? <span className={d != null && d < 0 ? 'font-semibold text-red-600' : 'text-gray-600'} title={d != null && d < 0 ? `${-d}d overdue` : undefined}>{fmtD(r.meetingDate)}</span>
                                    : <span className="text-amber-600" title="No review scheduled — the 'Schedule the strategic review' card is chasing this.">none set</span>;
                                })()}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-500">{r.daysInStage != null ? r.daysInStage + 'd' : '—'}</td>
                              </>) : isLoi ? (<>
                                <td className="py-1 pr-2 text-gray-600 whitespace-nowrap">{r.buyer || '—'}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-600">{r.loiPrice ? fmtK(r.loiPrice) : '—'}</td>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{r.negotiating ? <span className="italic text-gray-400">not signed</span> : fmtD(r.signedLoi)}</td>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{fmtD(r.projectedClose)}</td>
                                <td className="py-1 pr-2 whitespace-nowrap"><Clock r={r} /></td>
                              </>) : isMarket ? (<>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{r.marketDate ? fmtD(r.marketDate) : <span className="text-amber-600" title="Engaged but not yet marketed — CIM in build">pre-mkt</span>}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-500">{onMkt(r.marketDate) != null ? onMkt(r.marketDate) + 'd' : '—'}</td>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{fmtD(r.ioiDeadline)}</td>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{fmtD(r.loiDeadline)}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-600">{r.buyers ?? '—'}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-600">{r.ioiCount ?? '—'}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-600">{r.loiCount ?? '—'}</td>
                              </>) : (<>
                                <td className="py-1 pr-2 text-gray-500 whitespace-nowrap">{fmtD(r.meetingDate)}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-500">{r.daysInStage != null ? r.daysInStage + 'd' : '—'}</td>
                                <td className="py-1 pr-2 text-right whitespace-nowrap text-gray-600">{r.value ? fmtK(r.value) : '—'}</td>
                              </>)}
                              <td className={`py-1 text-right whitespace-nowrap font-medium ${r.commission > 0 ? 'text-emerald-700' : 'text-gray-400'}`}>{fmtK(r.commission)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    );
                  })()}
                </div>
              </div>
            )}
          </div>
        );
      })()}
      {/* Activity gauges (#6 A3): actual vs TARGET vs prior period — both
          baselines are peers (Family-2 amendment). Owner can edit targets;
          edits are effective-dated so the goal lineage survives. */}
      {gauges && gauges.length > 0 && (
        <div className="mb-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {gauges.map(g => {
              const hasTarget = !g.noTarget && g.target != null;
              const tgt = hasTarget ? Number(g.target) : null;
              const pct = hasTarget && tgt > 0 ? Math.min(100, Math.round(g.actual / tgt * 100)) : null;
              const delta = g.actual - g.prior;
              return (
                <div key={g.key + '|' + g.period} className="bg-white border border-gray-200 rounded-lg p-4" title={g.tip}>
                  <div className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-1">📅 {g.label}</div>
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <div className="text-2xl font-bold text-gray-800">{g.actual}</div>
                    {hasTarget && <div className="text-sm text-gray-500">/ {tgt} target</div>}
                    {g.baselines ? g.baselines.map(b => {
                      if (b.value == null) return (
                        <span key={b.label} className="text-xs font-semibold text-gray-300" title={`${b.label}: no history yet — the window predates this gauge's data source`}>
                          • {b.label} —
                        </span>
                      );
                      const d = g.actual - b.value;
                      return (
                        <span key={b.label} className={`text-xs font-semibold ${d > 0 ? 'text-emerald-600' : d < 0 ? 'text-red-600' : 'text-gray-400'}`} title={`${b.label}: ${b.value} — the standing goal is beating every prior period`}>
                          {d > 0 ? '▲' : d < 0 ? '▼' : '•'} {b.label} {b.value}
                        </span>
                      );
                    }) : (
                      <span className={`text-xs font-semibold ${delta > 0 ? 'text-emerald-600' : delta < 0 ? 'text-red-600' : 'text-gray-400'}`} title="vs the preceding period">
                        {delta > 0 ? '▲' : delta < 0 ? '▼' : '•'} prev {g.prior}
                      </span>
                    )}
                    {g.lookbacks && g.lookbacks.map(w => {
                      if (w.prior == null) return (
                        <span key={w.label} className="text-xs font-semibold text-gray-400" title={`Rolling ${w.label} lookback — no comparable prior window yet`}>
                          {w.label} {w.value}
                        </span>
                      );
                      const d = w.value - w.prior;
                      return (
                        <span key={w.label} className={`text-xs font-semibold ${d > 0 ? 'text-emerald-600' : d < 0 ? 'text-red-600' : 'text-gray-400'}`} title={`Rolling ${w.label} lookback: ${w.value} vs ${w.prior} in the preceding ${w.label}`}>
                          {w.label} {w.value} {d > 0 ? '▲' : d < 0 ? '▼' : '•'}
                        </span>
                      );
                    })}
                  </div>
                  {hasTarget && (
                    <React.Fragment>
                      <div className="mt-2 h-2 bg-gray-100 rounded overflow-hidden">
                        <div className={`h-2 ${g.actual >= tgt ? 'bg-emerald-500' : 'bg-blue-500'}`} style={{ width: (pct || 0) + '%' }}></div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1">{g.actual >= tgt ? `✓ target met${g.actual > tgt ? ` (+${g.actual - tgt})` : ''}` : `${tgt - g.actual} to go`}</div>
                    </React.Fragment>
                  )}
                  {!hasTarget && !g.noTarget && <div className="text-xs text-gray-400 mt-1">no target set</div>}
                  {g.ytd && (
                    <div className="text-xs mt-0.5">
                      <span className="text-gray-500">YTD <span className="font-semibold text-gray-700">{g.ytd.cur}</span></span>
                      {g.ytd.prior != null
                        ? <span className={`ml-1 font-semibold ${g.ytd.cur > g.ytd.prior ? 'text-emerald-600' : g.ytd.cur < g.ytd.prior ? 'text-red-600' : 'text-gray-400'}`} title="Same span last year">{g.ytd.cur > g.ytd.prior ? '▲' : g.ytd.cur < g.ytd.prior ? '▼' : '•'} vs {g.ytd.prior} last yr</span>
                        : <span className="ml-1 text-gray-300">· no prior-year history yet</span>}
                    </div>
                  )}
                  {g.avgValue != null && <div className="text-xs text-gray-500 mt-0.5">${Math.round(g.avgValue).toLocaleString()} avg value <span className="text-gray-400">({g.avgValueN} with a value)</span></div>}
                  {g.partialNote && <div className="text-xs text-gray-400 mt-0.5">{g.partialNote}</div>}
                  {g.splitNote && <div className="text-xs text-gray-500 mt-0.5">{g.splitNote}</div>}
                </div>
              );
            })}
          </div>
          {canEditTargets && gauges.some(g => !g.noTarget) && (
            <div className="text-right mt-1">
              <button type="button" className="text-[11px] text-blue-600 hover:underline" onClick={openTargetEditor}>🎯 Edit targets</button>
            </div>
          )}
        </div>
      )}
      {editTargetsOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={(e) => { if (e.target === e.currentTarget) setEditTargetsOpen(false); }}>
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="px-4 py-3 border-b flex items-center justify-between">
              <div className="text-sm font-bold text-gray-800">🎯 Edit Targets</div>
              <button type="button" className="text-gray-400 hover:text-gray-600 text-lg" onClick={() => setEditTargetsOpen(false)}>×</button>
            </div>
            <div className="p-4 space-y-3">
              <div className="text-xs text-gray-500">Changes take effect today; the previous goal is closed out, not overwritten, so the goal history survives.</div>
              {(gauges || []).filter(g => !g.noTarget).map(g => (
                <div key={g.key + '|' + g.period} className="flex items-center justify-between gap-3">
                  <div className="text-sm text-gray-700">{g.label}</div>
                  <input
                    type="number" min="0"
                    className="w-24 border border-gray-300 rounded px-2 py-1 text-sm text-right"
                    value={targetDrafts[g.key + '|' + g.period] ?? ''}
                    onChange={(e) => setTargetDrafts(d => ({ ...d, [g.key + '|' + g.period]: e.target.value }))}
                  />
                </div>
              ))}
            </div>
            <div className="px-4 py-3 border-t flex justify-end gap-2">
              <button type="button" className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200" onClick={() => setEditTargetsOpen(false)}>Cancel</button>
              <button type="button" disabled={savingTargets} className="px-3 py-1.5 rounded text-sm font-semibold bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50" onClick={saveTargetDrafts}>{savingTargets ? 'Saving…' : 'Save'}</button>
            </div>
          </div>
        </div>
      )}
      {/* Stage Flow (#6 A4): weekly stage entries + cohort conversion vs
          history — the operational "measure so we can improve" table.
          Collapsed by default. */}
      {stageFlow && (
        <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
          <button type="button" className="w-full flex items-center justify-between gap-2 flex-wrap" onClick={() => setStageFlowOpen(o => !o)}>
            <span className="text-xs font-bold uppercase tracking-wide text-gray-500">📊 Stage Flow — weekly entries & conversion vs history</span>
            <span className="text-xs text-gray-400">{stageFlowOpen ? '▾ hide' : '▸ show'} · history since {stageFlow.since.toLocaleDateString()} · {stageFlow.totalEvents} transitions</span>
          </button>
          {stageFlowOpen && (
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <div className="text-xs font-semibold text-gray-600 mb-1">Deals entering each stage, by trailing week</div>
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b bg-gray-50">
                      <th className="px-2 py-1 text-left font-bold uppercase tracking-wide text-gray-600">Stage</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600" title="The last 7 days">This wk</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600">−1 wk</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600">−2 wk</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600">−3 wk</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600" title={`Average of the ${stageFlow.typBlocks} weeks before the four shown`}>Typical</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stageFlow.entryRows.map(r => {
                      const typ = r.typical;
                      const thisWkClass = typ == null ? 'text-gray-800'
                        : r.w[0] >= typ ? 'text-emerald-700 font-semibold'
                        : r.w[0] < typ / 2 ? 'text-red-600 font-semibold'
                        : 'text-gray-800';
                      return (
                        <tr key={r.stage} className="border-b border-gray-100">
                          <td className="px-2 py-1"><span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${stageColor(r.stage)}`}>{stageLabel(r.stage)}</span></td>
                          <td className={`px-2 py-1 text-right ${thisWkClass}`}>{r.w[0]}</td>
                          <td className="px-2 py-1 text-right text-gray-600">{r.w[1]}</td>
                          <td className="px-2 py-1 text-right text-gray-600">{r.w[2]}</td>
                          <td className="px-2 py-1 text-right text-gray-600">{r.w[3]}</td>
                          <td className="px-2 py-1 text-right text-gray-500">{typ == null ? '—' : typ.toFixed(1)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {stageFlow.typBlocks === 0 && <div className="text-[11px] text-gray-400 mt-1">Not enough history yet for a "typical week" baseline — it appears once the log is 5+ weeks deep.</div>}
              </div>
              <div>
                <div className="text-xs font-semibold text-gray-600 mb-1">Forward conversion, by cohort</div>
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b bg-gray-50">
                      <th className="px-2 py-1 text-left font-bold uppercase tracking-wide text-gray-600">Hop</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600" title="Deals that entered the first stage in the last 90 days — still maturing, so this % naturally trails">Last 90d</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600" title="Entered 90–180 days ago">Prior 90d</th>
                      <th className="px-2 py-1 text-right font-bold uppercase tracking-wide text-gray-600" title="Everything earlier">Older</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stageFlow.conversions.map(c => {
                      const cell = (co) => co.n === 0 ? '—' : `${co.pct}% (${co.converted}/${co.n})`;
                      return (
                        <tr key={c.from + '>' + c.to} className="border-b border-gray-100">
                          <td className="px-2 py-1 text-gray-700 whitespace-nowrap">{stageLabel(c.from)} → {stageLabel(c.to)}</td>
                          <td className="px-2 py-1 text-right text-gray-800">{cell(c.current)}</td>
                          <td className="px-2 py-1 text-right text-gray-600">{cell(c.prior)}</td>
                          <td className="px-2 py-1 text-right text-gray-500">{cell(c.older)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="text-[11px] text-gray-400 mt-1">The last-90d cohort is still maturing — deals in it haven't had time to convert yet, so its % naturally trails the older cohorts.</div>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Stage distribution + filters */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
        <div className="flex items-baseline gap-3 mb-3 flex-wrap">
          <div className="text-2xl font-bold text-gray-800">{totalActive}</div>
          <div className="text-sm text-gray-500">project{totalActive === 1 ? '' : 's'}</div>
          {totalCommission > 0 && (
            <div className="text-sm text-gray-500 ml-2">· est. commission <span className="font-semibold text-emerald-700">{fmtMoney(totalCommission)}</span></div>
          )}
        </div>
        <div className="flex gap-1 mb-3">
          {Object.keys(WORKFLOW_STAGES).filter(s => (stageDistribution[s] || 0) > 0).map(s => {
            const n = stageDistribution[s] || 0;
            if (n === 0) return null;
            const pct = totalActive > 0 ? (n / totalActive * 100) : 0;
            return (
              <div key={s} className="flex flex-col items-stretch min-w-0" style={{flexBasis: `${pct}%`}}>
                <div className={`h-2 rounded ${stageColor(s).split(' ')[0]}`} title={`${stageLabel(s)}: ${n}`}></div>
                <div className="text-[10px] text-gray-500 mt-1 truncate">{stageLabel(s)} · {n}</div>
              </div>
            );
          })}
        </div>
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <StageFilterMenu selected={filterStage} onChange={setFilterStage} />
          <FilterSelect label="Lead"  value={filterLead}  onChange={setFilterLead}  options={[['all','All leads'],  ...uniqueLeads.map(l => [l, l])]} />
          <FilterSelect label="AM"    value={filterAM}    onChange={setFilterAM}    options={[['all','All AMs'],    ...uniqueAMs.map(a => [a, a])]} />
          <FilterSelect label="Resp." value={filterOwner} onChange={setFilterOwner} options={[['all','All'],        ...uniqueOwners.map(o => [o, o])]} />
          <ColumnsMenu hiddenColumns={hiddenColumns} onToggle={onToggleColumn} />
          <span className="text-gray-300">|</span>
          <select
            value={activeView}
            onChange={(e) => { const n = e.target.value; setActiveView(n); if (n) onApplyView && onApplyView(n); }}
            className="border border-gray-300 rounded px-2 py-1 bg-white"
            title="Saved views — one click restores that view's filters, sort, and columns."
          >
            <option value="">Views…</option>
            {Object.keys(views).sort().map(n => <option key={n} value={n}>{n}</option>)}
          </select>
          <button
            type="button"
            onClick={() => {
              const n = window.prompt('Save the current filters, sort, and columns as…', activeView || '');
              if (n && n.trim()) { onSaveView && onSaveView(n); setActiveView(n.trim()); }
            }}
            className="px-2 py-1 rounded border border-gray-300 text-gray-600 hover:text-gray-800 font-semibold"
            title="Save what you're looking at right now as a named view (e.g. “My view”, “Staff meeting”)."
          >💾 Save view</button>
          {activeView && views[activeView] && (
            <button
              type="button"
              onClick={() => { if (window.confirm(`Delete the saved view "${activeView}"?`)) { onDeleteView && onDeleteView(activeView); setActiveView(''); } }}
              className="px-1.5 py-1 rounded border border-gray-300 text-gray-400 hover:text-red-600"
              title="Delete this saved view"
            >✕</button>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto">
        {rows.length === 0 ? (
          <div className="text-center text-gray-400 py-12 text-sm">
            No projects match the current filters.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b">
              <tr>
                {isVisible('company_name')      && <SortHeader col="company_name">Business</SortHeader>}
                {isVisible('workflow_stage')    && <SortHeader col="workflow_stage">Stage</SortHeader>}
                {isVisible('path')              && <SortHeader col="path">Path</SortHeader>}
                {isVisible('owner_target_valuation_date') && <SortHeader col="owner_target_valuation_date">🎯 Owner Target</SortHeader>}
                {isVisible('likelihood_pct')    && <SortHeader col="likelihood_pct" numeric>%</SortHeader>}
                {isVisible('lead')              && <SortHeader col="lead">Lead</SortHeader>}
                {isVisible('account_manager')   && <SortHeader col="account_manager">AM</SortHeader>}
                {isVisible('responsibility')    && <SortHeader col="responsibility">Resp.</SortHeader>}
                {isVisible('daysPastCommitted') && <SortHeader col="daysPastCommitted" numeric>Committal</SortHeader>}
                {isVisible('docsOutstanding')   && <SortHeader col="docsOutstanding" numeric>Docs</SortHeader>}
                {isVisible('openItemsOpen')     && <SortHeader col="openItemsOpen" numeric>Open</SortHeader>}
                {isVisible('value_provided_high')  && <SortHeader col="value_provided_high" numeric>Valuation</SortHeader>}
                {isVisible('estimated_commission') && <SortHeader col="estimated_commission" numeric>Est. Commission</SortHeader>}
                {isVisible('nextAction')        && <th className="px-3 py-2 text-xs font-bold uppercase tracking-wide text-gray-600 text-left">Next Action</th>}
                {isVisible('interactionAt')     && <SortHeader col="interactionAt">Last</SortHeader>}
              </tr>
            </thead>
            <tbody>
              {rows.map(p => {
                const viewers = presenceByValuation[p.id] || [];
                const committalTone = p.daysPastCommitted != null && p.daysPastCommitted > 0
                  ? (p.isSnoozed ? 'text-blue-600' : 'text-red-600 font-semibold')
                  : 'text-gray-500';
                const stageTone = p.stageOverdue
                  ? (p.isSnoozed ? 'text-blue-600' : 'text-red-600 font-semibold')
                  : 'text-gray-500';
                const intMeta = p.interactionKind ? (INTERACTION_KINDS[p.interactionKind] || {}) : null;
                const arrow = intMeta ? (intMeta.dir === 'out' ? '→ ' : intMeta.dir === 'in' ? '← ' : '') : '';
                return (
                  <tr
                    key={p.id}
                    onClick={() => onOpenValuation({ id: p.id, name: p.name })}
                    className="border-b hover:bg-blue-50 cursor-pointer"
                  >
                    {isVisible('company_name') && (
                      <td className="px-3 py-2 font-semibold text-gray-800 whitespace-nowrap">
                        {p.company_name}
                        {/* Provenance badge (returning-client spec Phase 2):
                            ↻ Revalue = has archived prior cycles in VT;
                            Returning = old-system client re-engaged (created
                            via the Returning-client path). New = no badge. */}
                        {p.has_prior_cycles ? (
                          <span className="ml-2 text-[10px] font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded px-1.5 py-0.5" title="Revalue — this deal has at least one archived prior valuation cycle in VT.">↻ Revalue</span>
                        ) : p.account_type === 'returning' ? (
                          <span className="ml-2 text-[10px] font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded px-1.5 py-0.5" title="Returning client — valued in the old (pre-VT) system; re-engaged organically and onboarded via the Returning-client path.">Returning</span>
                        ) : null}
                        {viewers.length > 0 && (
                          <span className="ml-2 text-[10px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-1.5 py-0.5" title={`${viewers.join(', ')} ${viewers.length === 1 ? 'has' : 'have'} this file open`}>
                            👁 {viewers.join(', ')}
                          </span>
                        )}
                      </td>
                    )}
                    {isVisible('workflow_stage') && (
                      <td className="px-3 py-2 whitespace-nowrap">
                        <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${stageColor(p.workflow_stage)}`}>{stageLabel(p.workflow_stage)}</span>
                        {p.daysInStage != null && (
                          <span className={`ml-2 text-xs ${stageTone}`} title={p.targetDays != null ? `target ${p.targetDays} biz days` : ''}>
                            {p.daysInStage}d
                          </span>
                        )}
                        {/* Awaiting Decision sub-group + the Lead's read (Mark 09-28) —
                            what the staff meeting needs to see: who is truly deciding. */}
                        {(() => {
                          const g = decidingGroup(p);
                          const m = (g || p.workflow_stage === 'considering_followup') ? likelihoodMark(p.likelihood_pct) : null;
                          if (!g && !m) return null;
                          return <div className="text-[11px] text-gray-600 mt-0.5">{m ? <span className="mr-1">{m}</span> : null}{g ? g.label : `circle back ${p.snooze_until ? String(p.snooze_until).slice(0, 10) : ''}`}</div>;
                        })()}
                      </td>
                    )}
                    {isVisible('path') && (
                      <td className="px-3 py-2 text-gray-600 text-xs">{p.path === 'partial' ? 'Partial' : p.path === 'full_valuation' ? 'Full' : '—'}</td>
                    )}
                    {isVisible('owner_target_valuation_date') && (
                      <td className="px-3 py-2 whitespace-nowrap text-xs">
                        {(() => {
                          if (!p.owner_target_valuation_date) return <span className="text-gray-300">—</span>;
                          // Red once the owner's own deadline has passed without a
                          // delivered valuation — the staff-meeting signal Mark wants.
                          const missed = p.owner_target_valuation_date < new Date().toISOString().slice(0, 10) && !p.valuation_date;
                          return <span className={missed ? 'font-semibold text-red-600' : 'text-green-700'} title={missed ? "The owner's requested discuss-by date has passed and the valuation hasn't been delivered." : 'The owner picked this date on their first portal visit — "wants to discuss value by."'}>{new Date(p.owner_target_valuation_date + 'T00:00:00').toLocaleDateString()}</span>;
                        })()}
                      </td>
                    )}
                    {isVisible('likelihood_pct') && (
                      <td className={`px-3 py-2 text-right ${p.likelihood_pct != null && p.likelihood_pct >= 75 ? 'text-green-700 font-semibold' : p.likelihood_pct != null && p.likelihood_pct >= 50 ? 'text-blue-700' : 'text-gray-500'}`}>
                        {p.likelihood_pct == null ? '—' : `${Number(p.likelihood_pct) % 1 === 0 ? Number(p.likelihood_pct).toFixed(0) : Number(p.likelihood_pct).toFixed(1)}%`}
                      </td>
                    )}
                    {isVisible('lead') && (
                      <td className="px-3 py-2 text-gray-600">{p.lead || '—'}</td>
                    )}
                    {isVisible('account_manager') && (
                      <td className="px-3 py-2 text-gray-600">{p.account_manager || '—'}</td>
                    )}
                    {isVisible('responsibility') && (
                      <td className="px-3 py-2 text-gray-600">{p.responsibility}</td>
                    )}
                    {isVisible('daysPastCommitted') && (
                      <td className={`px-3 py-2 text-right whitespace-nowrap ${committalTone}`}>
                        {p.committed_upload_date ? fmtDate(p.committed_upload_date) : '—'}
                        {p.daysPastCommitted != null && p.daysPastCommitted > 0 && <span className="ml-1">+{p.daysPastCommitted}</span>}
                      </td>
                    )}
                    {isVisible('docsOutstanding') && (
                      <td className="px-3 py-2 text-right text-gray-600"
                        title={p.docsMissing && p.docsMissing.length ? ['Still out:'].concat(p.docsMissing.map(x => '• ' + x)).join(String.fromCharCode(10)) : undefined}>
                        {p.docsTotal > 0
                          ? <span className={p.docsMissing && p.docsMissing.length ? 'underline decoration-dotted cursor-help' : ''}>{p.docsDone}/{p.docsTotal}</span>
                          : '—'}
                      </td>
                    )}
                    {isVisible('openItemsOpen') && (
                      <td className="px-3 py-2 text-right text-gray-600">
                        {p.path === 'partial'
                          ? <span className="text-gray-400">NA</span>
                          : p.openItemsOpen == null
                            ? '—'
                            : <span title={p.openItemsResolved != null ? `${p.openItemsResolved} resolved` : ''}>{p.openItemsOpen} open</span>}
                      </td>
                    )}
                    {isVisible('value_provided_high') && (
                      <td className="px-3 py-2 text-right text-gray-700 whitespace-nowrap">{fmtMoney(p.value_provided_high)}</td>
                    )}
                    {isVisible('estimated_commission') && (
                      <td className="px-3 py-2 text-right font-medium text-emerald-700 whitespace-nowrap">{fmtMoney(p.estimated_commission)}</td>
                    )}
                    {isVisible('nextAction') && (
                      <td className="px-3 py-2 text-sm text-gray-800 max-w-[280px]" title={p.nextAction || ''}>
                        <span className="line-clamp-2">{p.nextAction || '—'}</span>
                      </td>
                    )}
                    {isVisible('interactionAt') && (
                      <td className="px-3 py-2 text-xs text-gray-500">
                        {intMeta ? (
                          <React.Fragment>
                            <span className="font-semibold text-gray-600">{arrow}{intMeta.label}</span>
                            {p.interactionAt && <span className="text-gray-400"> · {formatRelativeDate(p.interactionAt)}</span>}
                            {p.interactionNote && <span className="block text-gray-400 truncate max-w-[220px]" title={p.interactionNote}>{p.interactionNote}</span>}
                          </React.Fragment>
                        ) : '—'}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
            {(isVisible('value_provided_high') || isVisible('estimated_commission')) && (
              <tfoot className="bg-gray-50 border-t-2 border-gray-200 font-semibold text-sm">
                <tr>
                  {isVisible('company_name')      && <td className="px-3 py-2 text-gray-700 whitespace-nowrap">Totals · {rows.length}</td>}
                  {isVisible('workflow_stage')    && <td></td>}
                  {isVisible('path')              && <td></td>}
                  {isVisible('owner_target_valuation_date') && <td></td>}
                  {isVisible('likelihood_pct')    && <td></td>}
                  {isVisible('lead')              && <td></td>}
                  {isVisible('account_manager')   && <td></td>}
                  {isVisible('responsibility')    && <td></td>}
                  {isVisible('daysPastCommitted') && <td></td>}
                  {isVisible('docsOutstanding')   && <td></td>}
                  {isVisible('openItemsOpen')     && <td></td>}
                  {isVisible('value_provided_high')  && <td className="px-3 py-2 text-right text-gray-700 whitespace-nowrap">{fmtMoney(totalValue)}</td>}
                  {isVisible('estimated_commission') && <td className="px-3 py-2 text-right text-emerald-700 whitespace-nowrap">{fmtMoney(totalCommission)}</td>}
                  {isVisible('nextAction')        && <td></td>}
                  {isVisible('interactionAt')     && <td></td>}
                </tr>
              </tfoot>
            )}
          </table>
        )}
      </div>
    </div>
  );
};

const FilterSelect =({ label, value, onChange, options }) => (
  <label className="flex items-center gap-1.5 bg-gray-100 rounded px-2 py-1 text-gray-700">
    <span className="text-gray-500 font-semibold uppercase tracking-wide text-[10px]">{label}</span>
    <select value={value} onChange={(e) => onChange(e.target.value)} className="bg-transparent outline-none text-xs">
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </label>
);

const VistaApp = ({ userEmail, hasMfa, onEnrollMfa, onSignOut }) => {
  // Flagged staff land on the new Dashboard. Everyone else lands on the
  // existing client list and never sees the dashboard nav items at all.
  const previewEnabled = isStaffPreview(userEmail);
  const [view, setView] = useState(previewEnabled ? 'dashboard' : 'list');
  const [currentValuation, setCurrentValuation] = useState(null);
  const [currentClient, setCurrentClient] = useState(null);
  const [pendingProjectSetup, setPendingProjectSetup] = useState(null);
  const [showNewClient, setShowNewClient] = useState(false);
  const [showImporter, setShowImporter] = useState(false);
  const [newClientIds, setNewClientIds] = useState([]);
  // 🐞 Report button context (ROADMAP #18, 10-20). Inside a valuation the tool sets the detail itself.
  useEffect(() => { if (view !== 'valuation') window.__vtReportContext = { page: view === 'dashboard' ? 'Dashboard' : 'Clients list' }; }, [view]);
  const [refreshKey, setRefreshKey] = useState(0);
  // Intro-email modal data (Warm → Active). Set after an AM creates a warm
  // account; the modal previews/sends the intro as the AM. Null = closed.
  const [introModal, setIntroModal] = useState(null);
  // Portal-invite email (returning client). Set after a returning-client create;
  // the shared EmailReviewModal previews/sends the organic invite. Null = closed.
  const [pendingInviteEmail, setPendingInviteEmail] = useState(null);

  // Warm-account create (AM flow). The AM is read-only in the valuation editor,
  // so the normal seed-autosave path can't persist the row — insert it directly
  // here with the default discovery questionnaire (so the portal shows questions
  // immediately) and the docs gate CLOSED. Then open the intro-email modal.
  const handleWarmCreated = async (client, projectSetup) => {
    if (!supabaseClient || !client) return;
    const openIntro = (engagementId) => setIntroModal({
      engagementId,
      ownerFirstName: projectSetup.owner_first_name || '',
      ownerEmail: projectSetup.owner_email || '',
      ownerAdditional: Array.isArray(projectSetup.owner_additional) ? projectSetup.owner_additional : [],
      leadName: projectSetup.lead || '',
      amName: projectSetup.account_manager || staffName(userEmail) || '',
      companyName: client.company_name || '',
      meetingDate: projectSetup.discovery_meeting_date || '',
    });
    try {
      const nowIso = new Date().toISOString();
      const data = {
        dealProfile: {
          companyName: client.company_name || '',
          city: client.city || '',
          state: client.state || '',
          vistaId: client.vista_id || '',
          ownerRole: projectSetup.owner_role || 'Owner',
        },
        // Default discovery questionnaire → the owner portal shows questions
        // the moment the warm account exists, before anyone opens the editor.
        sellerQA: DEFAULT_SELLER_QA,
      };
      const ownerAdditional = (projectSetup.owner_additional || [])
        .map(o => ({ name: (o.name || '').trim(), email: (o.email || '').trim() }))
        .filter(o => o.email);
      const row = {
        client_id: client.id,
        name: `${nowIso.split('T')[0]} Valuation`,
        version: 'v98-122-78',
        workflow_stage: 'warm',
        stage_entered_at: nowIso,
        portal_docs_released: false,
        lead: projectSetup.lead || null,
        account_manager: projectSetup.account_manager || null,
        owner_first_name: projectSetup.owner_first_name || null,
        owner_last_name: projectSetup.owner_last_name || null,
        owner_email: projectSetup.owner_email || null,
        owner_additional: ownerAdditional.length ? ownerAdditional : null,
        discovery_meeting_date: projectSetup.discovery_meeting_date || null,
        // The AM's initial likelihood read is required + captured at create;
        // persist it here (path/committal are intentionally Lead-set at
        // activation, but likelihood must carry through — it was being dropped).
        likelihood_pct: (projectSetup.likelihood_pct === '' || projectSetup.likelihood_pct == null)
          ? null : Number(projectSetup.likelihood_pct),
        data,
        created_at: nowIso,
        updated_at: nowIso,
      };
      const { data: inserted, error } = await supabaseClient
        .from('valuations').insert(row).select('id').single();
      if (error) throw error;
      // 📋 The size screen rides the deal history + the business's SE profile (Mark + Zac 10-16).
      if (inserted && inserted.id && projectSetup.qualification) {
        try {
          await saveQualification(supabaseClient, { valuationId: inserted.id, clientId: client.id, ownerEmail: projectSetup.owner_email,
            actorEmail: userEmail, actorName: staffName(userEmail) || (userEmail ? userEmail.split('@')[0] : null), q: projectSetup.qualification });
        } catch (e) { console.warn('Qualification not saved:', e && e.message); window.alert('The account was created, but the size screen did not save. Use 📋 Finish the qualification on the warm card.'); }
      }
      openIntro(inserted ? inserted.id : null);
    } catch (err) {
      console.error('Warm account create failed:', err);
      window.alert('The warm account was set up in ShareFile but saving it to the pipeline failed: ' + (err.message || 'unknown error') + '\n\nYou can still send the intro email; re-create the account if it doesn\'t appear on your My Work.');
      openIntro(null);
    }
  };

  // Returning-client create (old-system re-engagement). Persists the row ACTIVE
  // (awaiting_upload, no Lead meeting/activation) with the path/committal/likelihood
  // captured at create, then opens the organic portal-invite email so the owner
  // gets their portal link + how-it-works. Docs stay held until Konnie curates +
  // releases them (discovery first). See docs/RETURNING-CLIENT-SPEC.md.
  const handleReturningClientCreated = async (client, projectSetup) => {
    if (!supabaseClient || !client) return;
    try {
      const nowIso = new Date().toISOString();
      const data = {
        dealProfile: {
          companyName: client.company_name || '',
          city: client.city || '',
          state: client.state || '',
          vistaId: client.vista_id || '',
          ownerRole: projectSetup.owner_role || 'Owner',
        },
        // Default questionnaire → the portal shows discovery questions immediately.
        sellerQA: DEFAULT_SELLER_QA,
        // Marker so these read as returning (not fresh prospects) in future work.
        accountType: 'returning',
      };
      const ownerAdditional = (projectSetup.owner_additional || [])
        .map(o => ({ name: (o.name || '').trim(), email: (o.email || '').trim() }))
        .filter(o => o.email);
      const row = {
        client_id: client.id,
        name: `${nowIso.split('T')[0]} Valuation`,
        version: 'v98-122-78',
        workflow_stage: 'awaiting_upload',
        stage_entered_at: nowIso,
        // Docs released later (after discovery), same as a normal active deal.
        portal_docs_released: false,
        lead: projectSetup.lead || null,
        account_manager: projectSetup.account_manager || null,
        path: projectSetup.path || null,
        owner_first_name: projectSetup.owner_first_name || null,
        owner_last_name: projectSetup.owner_last_name || null,
        owner_email: projectSetup.owner_email || null,
        owner_additional: ownerAdditional.length ? ownerAdditional : null,
        discovery_meeting_date: projectSetup.discovery_meeting_date || null,
        committed_upload_date: projectSetup.committed_upload_date || null,
        likelihood_pct: (projectSetup.likelihood_pct === '' || projectSetup.likelihood_pct == null)
          ? null : Number(projectSetup.likelihood_pct),
        data,
        created_at: nowIso,
        updated_at: nowIso,
      };
      const { data: inserted, error } = await supabaseClient
        .from('valuations').insert(row).select('id').single();
      if (error) throw error;
      // Best-effort activity log (direct insert — logActivity lives in the editor).
      if (inserted && inserted.id) {
        try {
          await supabaseClient.from('project_activity_log').insert({
            project_id: inserted.id,
            actor_email: userEmail || 'unknown',
            actor_name: staffName(userEmail) || null,
            kind: 'stage_changed',
            note: 'Returning client (old-system) created — active; portal invite sent',
            metadata: { returning_client: true },
          });
        } catch (logErr) { console.warn('Returning-client activity log failed:', logErr); }
      }
      // Organic portal-invite email (review-and-send). Sent as the Lead, fallback
      // Konnie — the owner gets the portal link + how it works.
      const ownerEmail = (projectSetup.owner_email || '').trim();
      if (ownerEmail) {
        const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal'
          + '#e=' + encodeURIComponent(ownerEmail);
        const cc = ownerAdditional.map(o => o.email).filter(Boolean);
        setPendingInviteEmail({
          heading: 'Send: portal invite',
          to: ownerEmail, cc,
          subject: 'Your Vista Business Group secure portal',
          sender: leadGmailKey(projectSetup.lead) || 'konnie',
          defaultBody: portalInviteBodyText({ ownerFirstName: projectSetup.owner_first_name, companyName: client.company_name }),
          buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: (projectSetup.lead || '').trim() || 'Vista Business Group', portalUrl }),
        });
      } else {
        window.alert('Account created. No owner email was on file, so no portal invite was sent — add one on Setup and send them their portal link.');
      }
      setRefreshKey(k => k + 1);
    } catch (err) {
      console.error('Returning-client create failed:', err);
      window.alert('The returning-client account could not be saved: ' + (err.message || 'unknown error'));
    }
  };

  const handleOpenValuation = (v) => {
    setCurrentValuation(v);
    setCurrentClient(null);
    setPendingProjectSetup(null);
    setView('valuation');
  };

  // Deep link: /?valuation=<id> opens that deal directly (Mark 09-17 — backs the
  // Meeting-Prep "Open in VT ↗" link so a prep card opens the record in a new
  // tab). Runs once on mount; the editor hydrates the full row by id, and we
  // strip the param so a later refresh/back doesn't re-trigger it.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    let id = null;
    let view = null;
    try { const q = new URLSearchParams(window.location.search); id = q.get('valuation'); view = q.get('view'); } catch (e) { /* no params */ }
    if (!id) return;
    // A self-reload returns to the same deal AND tab (Colleen 09-30: a reload mid-presentation landed on the
    // dashboard and showed other clients' names). The editor picks the tab up on mount.
    if (view && /^[a-z_]+$/i.test(view)) window.__vtPendingView = view;
    handleOpenValuation({ id });
    try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* ignore */ }
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  const handleNewValuation = (client, projectSetup = null) => {
    setCurrentClient(client);
    setCurrentValuation(null);
    setPendingProjectSetup(projectSetup);
    setView('valuation');
  };

  const handleBackToList = () => {
    setView(previewEnabled ? 'dashboard' : 'list');
    setCurrentValuation(null);
    setCurrentClient(null);
    setPendingProjectSetup(null);
    setRefreshKey(k => k + 1);
  };

  const handleImportComplete = (createdIds) => {
    setNewClientIds(prev => [...prev, ...createdIds]);
    setRefreshKey(k => k + 1);
  };

  if (view === 'dashboard') {
    return (
      <Dashboard
        userEmail={userEmail}
        hasMfa={hasMfa}
        onEnrollMfa={onEnrollMfa}
        onSignOut={onSignOut}
        onOpenValuation={handleOpenValuation}
        onGoToClientList={() => setView('list')}
      />
    );
  }

  if (view === 'list') {
    return (
      <React.Fragment>
        <ClientList
          userEmail={userEmail}
          hasMfa={hasMfa}
          onEnrollMfa={onEnrollMfa}
          onSignOut={onSignOut}
          onOpenValuation={handleOpenValuation}
          onNewValuation={handleNewValuation}
          onNewClient={() => setShowNewClient(true)}
          onImport={() => setShowImporter(true)}
          newClientIds={newClientIds}
          refreshKey={refreshKey}
          onGoToDashboard={previewEnabled ? () => setView('dashboard') : null}
        />
        {showNewClient && (
          <NewClientModal
            creatorRole={(STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()] || {}).role || ''}
            creatorName={staffName(userEmail) || ''}
            onClose={() => setShowNewClient(false)}
            onCreated={(client, projectSetup) => {
              setShowNewClient(false);
              // Warm (AM) accounts persist directly + open the intro email;
              // returning clients persist active + open the portal-invite email;
              // everyone else opens the valuation editor as before.
              if (projectSetup && projectSetup.warm) handleWarmCreated(client, projectSetup);
              else if (projectSetup && projectSetup.returningClient) handleReturningClientCreated(client, projectSetup);
              else handleNewValuation(client, projectSetup);
            }}
          />
        )}
        {showImporter && (
          <JsonImporter
            onClose={() => setShowImporter(false)}
            onComplete={handleImportComplete}
          />
        )}
        {introModal && (
          <IntroEmailModal
            {...introModal}
            actorEmail={userEmail}
            mandatory={true}
            onClose={() => { setIntroModal(null); setRefreshKey(k => k + 1); }}
            onSent={() => { setIntroModal(null); setRefreshKey(k => k + 1); }}
          />
        )}
        {pendingInviteEmail && (
          <EmailReviewModal
            {...pendingInviteEmail}
            onClose={() => { setPendingInviteEmail(null); setRefreshKey(k => k + 1); }}
            onSent={() => { setPendingInviteEmail(null); setRefreshKey(k => k + 1); }}
          />
        )}
      </React.Fragment>
    );
  }

  return (
    <BusinessValuationTool
      key={currentValuation?.id || 'new'}
      userEmail={userEmail}
      hasMfa={hasMfa}
      onEnrollMfa={onEnrollMfa}
      onSignOut={onSignOut}
      currentValuation={currentValuation}
      currentClient={currentClient}
      projectSetup={pendingProjectSetup}
      onBackToList={handleBackToList}
    />
  );
};

// CIM sections a custom data group can render into. Keys MUST match the
// generator's SECTS keys (docs/cim-generate.html ~448) — buildCustomGroups
// routes each group by this key; an unknown key falls back to Business
// Overview rather than dropping the data.
const CIM_CUSTOM_GROUP_SECTIONS = [
  ['businessOverview', 'Business Overview + History'],
  ['productsServices', 'Products & Services'],
  ['pricing', 'Product / Service Pricing'],
  ['clients', 'Clients'],
  ['paymentCycle', 'Payment Cycle'],
  ['technologyStack', 'Technology Stack'],
  ['marketingSales', 'Marketing & Sales + Operational Flow'],
  ['growthOpportunities', 'Growth Opportunities'],
  ['employees', 'Employees'],
  ['trainingTransition', 'Training/Transition + Facility + FF&E'],
  ['legal', 'Non-Compete / Legal'],
  ['investmentConsiderations', 'Investment Considerations'],
  ['financialOverview', 'Financial Overview'],
];

const BusinessValuationTool = ({ userEmail = '', hasMfa = false, onEnrollMfa = () => {}, onSignOut = () => {}, currentValuation = null, currentClient = null, projectSetup = null, onBackToList = null }) => {
  // Calculate default years based on current date (Year 5 = prior year)
  const currentYear = new Date().getFullYear();
  const defaultYears = {
    year1: String(currentYear - 5),
    year2: String(currentYear - 4),
    year3: String(currentYear - 3),
    year4: String(currentYear - 2),
    year5: String(currentYear - 1)
  };
  
  const [viewMode, setViewMode] = useState(() => {
    // Opens on Setup → Deal Profile. The old default 'summary' is a retired view
    // with no page, so every open showed Setup highlighted over a BLANK body
    // until a tab was clicked (seen 10-05 on AVT).
    const v = (typeof window !== 'undefined' && window.__vtPendingView) || 'profile';
    if (typeof window !== 'undefined') window.__vtPendingView = null;
    return v;
  });
  // Where this tab is, for a self-reload to come back to (never the dashboard mid-call).
  useEffect(() => {
    window.__vtOpenDeal = currentValuation && currentValuation.id ? { id: currentValuation.id, view: viewMode } : null;
    return () => { window.__vtOpenDeal = null; };
  }, [currentValuation && currentValuation.id, viewMode]);   // eslint-disable-line react-hooks/exhaustive-deps
  const [discoverySubTab, setDiscoverySubTab] = useState('questions');
  const [showPasteAnswersModal, setShowPasteAnswersModal] = useState(false);
  const [pasteAnswersText, setPasteAnswersText] = useState('');
  const [pasteAnswersPreview, setPasteAnswersPreview] = useState([]);
  const [pasteAnswersSkipped, setPasteAnswersSkipped] = useState([]);
  
  // Helper function to calculate median (for outlier detection)
  const calcMedian = (arr) => {
    const filtered = arr.filter(v => v > 0); // Only non-zero values
    if (filtered.length === 0) return 0;
    const sorted = [...filtered].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
  };
  
  // ========== CLEAR/UNDO STATE ==========
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showRoadmapModal, setShowRoadmapModal] = useState(false);

  // ========== OIR DRAFT-EMAIL MODAL (Stage B4) ==========
  const [showOIRModal, setShowOIRModal] = useState(false);
  const [oirTo, setOirTo] = useState('');
  const [oirCc, setOirCc] = useState('');
  const [oirSubject, setOirSubject] = useState('');
  const [oirNote, setOirNote] = useState('');
  const [oirSending, setOirSending] = useState(false);
  const [oirSendResult, setOirSendResult] = useState(null); // { ok: bool, msg: string }
  // When the modal is launched from the Reminder Queue (Stage B5), the
  // variant routes the send through cadence-specific logging + stage flip.
  // '' = vanilla OIR send. 'weekly' / 'final-no-value' / 'final-meeting-offer'.
  const [oirCadenceVariant, setOirCadenceVariant] = useState('');
  // The send modal is shared between the OIR/cadence email (sent as Konnie)
  // and Colleen's owner-questions email (sent as Colleen). oirMode switches
  // the preview, title, and send path. '' / 'oir' = OIR/cadence; 'questions'
  // = owner questions. (2026-06-08)
  const [oirMode, setOirMode] = useState('oir');
  // How the owner is asked to answer Colleen's questions: 'portal' (default —
  // the new portal-first flow) or 'email' (reply-by-email, for legacy/existing
  // clients or anyone not comfortable with the portal). Colleen picks per send
  // in the owner-questions modal; defaults to portal each time it opens. The
  // email-reply variant drops the portal CTA and invites a numbered reply,
  // which Colleen then enters into the Resolution cell by hand. (2026-06-30)
  const [questionsAnswerMode, setQuestionsAnswerMode] = useState('portal');
  const cadenceAutoActionFiredRef = useRef(false);
  const [roadmapConfig, setRoadmapConfig] = useState({
    showValuation: true,
    showVerifications: false,
    showOpenItems: true,
    showAskOwner: true,
    showCompletedItems: false,
    customRequests: [] // { id, type: 'document'|'question', text }
  });
  const [showClientReportModal, setShowClientReportModal] = useState(false);
  const [clientReportSettings, setClientReportSettings] = useState({
    showValuation: true,
    showVerifications: false,
    showDiscoveryQuestions: false,
    customItems: ''
  });
  const [showCIMExportModal, setShowCIMExportModal] = useState(false);
  const [showReportRequestModal, setShowReportRequestModal] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  useEffect(() => {
    if (!userMenuOpen) return;
    const onDocClick = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) setUserMenuOpen(false);
    };
    const onEsc = (e) => { if (e.key === 'Escape') setUserMenuOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onEsc);
    };
  }, [userMenuOpen]);
  
  // CIM Data Collection - new sections for comprehensive CIM export
  const [cimTechStack, setCimTechStack] = useState({ rmm: '', psa: '', security: '', backup: '', cloud: '', microsoftTier: '', vendorPartners: '', keySoftware: '' });
  // Per-vendor technology table — matches Thatcher's "Needed" form (Technology |
  // Use | Contract Term | Monthly Cost). When present it drives the CIM's
  // Technology Stack section (with Term + Cost columns); the older category
  // buckets above stay as a fallback for deals entered before this. (2026-07-14)
  const [cimVendors, setCimVendors] = useState([]); // [{ id, technology, use, term, monthlyCost }]
  // Contract Snapshot (D6 "rate-card" feed) — master service-agreement mechanics
  // from the "Needed" form; renders as a key/value table in the CIM's Pricing
  // section. Optional (contract-based deals). (2026-07-14)
  const [cimContractTerms, setCimContractTerms] = useState({});
  // Phase-3 fold (2026-07-22): which TYPED structured panels are enabled for
  // this deal. The MSP vendor table + Contract Snapshot stay typed (the teaser's
  // names-only rule, roundMoney and the D6 rate-card feed depend on the shape),
  // but their PANELS no longer render hardcoded on every deal — they show when
  // the deal has data OR this list enables them (via the MSP preset's
  // __typedPanels sentinel, or the panel hint's Show action). Data home is
  // unchanged; only visibility is preset-driven.
  const [cimTypedPanels, setCimTypedPanels] = useState([]);
  const [cimEmployees, setCimEmployees] = useState([]);
  // Employees section policy (Zac/Thatcher 2026-07-14): disclosure mode (full
  // roster vs management-focus), management/non-management comp RANGES (Lead-
  // entered — no individual pay in the CIM), and profit-sharing/bonus disclosure.
  const [cimEmpDisclosure, setCimEmpDisclosure] = useState('full'); // 'full' | 'management'
  const [cimEmpComp, setCimEmpComp] = useState({}); // { mgmtLow, mgmtHigh, nonMgmtLow, nonMgmtHigh }
  const [cimEmpIncentives, setCimEmpIncentives] = useState('');
  // FF&E / Inventory (2026-07-15): item table + disclosure mode — in-CIM list
  // (short, e.g. MSPs) vs data-room addendum (long asset-heavy schedules where
  // age/hours drive the buyer's cap-ex). No individual value in the CIM.
  const [cimFFE, setCimFFE] = useState([]); // [{ id, item, category, year, hours, include, notes }]
  const [cimFFEDisclosure, setCimFFEDisclosure] = useState('cim'); // 'cim' | 'addendum'
  const [cimFFEImport, setCimFFEImport] = useState(''); // transient paste box for AI import
  const [cimFFEImporting, setCimFFEImporting] = useState(false);

  // FF&E AI import: the Lead pastes raw FF&E from any source (spreadsheet,
  // Word, email, depreciation schedule); one staff-gated relay call structures
  // it into rows appended to the FF&E table for curation. The long-list /
  // varied-format solver (Thatcher/Mark 2026-07-15). Must stay at component
  // level — the FF&E capture panel renders far above the CIM export modal.
  const importFFEWithAI = async () => {
    const raw = (cimFFEImport || '').trim();
    if (!raw) return;
    setCimFFEImporting(true);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) throw new Error('not signed in');
      const system = [
        'You extract Furniture, Fixtures & Equipment (FF&E) line items from pasted source data, which may be spreadsheet rows, a document, an email, or a depreciation schedule.',
        'Return STRICT JSON ONLY: an array of objects {"item": "...", "category": "...", "year": "...", "hours": "...", "notes": "..."}.',
        '"item" = the equipment/asset description. "category" = a short type (Vehicle, Machinery, Shop Equipment, Office/IT, Furniture, Tools, etc.). "year" = model or acquisition year if present, else "". "hours" = usage hours or mileage if present, else "". "notes" = condition, financed, or other relevant detail, else "".',
        'Skip rows that are not equipment (headers, subtotals, totals, blank rows, instructions). Do not invent values. No prose, no markdown, no code fences.'
      ].join('\n');
      const resp = await fetch('/api/cim/narrative', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ system, user: raw, maxTokens: 8000 })
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error((data && data.error) || ('HTTP ' + resp.status));
      if (data.refused) throw new Error('the model declined this request');
      let arr = [];
      const text = data.text || '';
      try { arr = JSON.parse(text); }
      catch (e) { const m = String(text).match(/\[[\s\S]*\]/); if (m) { try { arr = JSON.parse(m[0]); } catch (_) {} } }
      if (!Array.isArray(arr) || !arr.length) throw new Error('no items found in the pasted data');
      const rows = arr.filter(o => o && String(o.item || '').trim()).map(o => ({
        id: Date.now() + Math.random(),
        item: String(o.item || '').trim(),
        category: String(o.category || '').trim(),
        year: String(o.year || '').trim(),
        hours: String(o.hours || '').trim(),
        include: true,
        notes: String(o.notes || '').trim()
      }));
      setCimFFE(prev => [...prev, ...rows]);
      setCimFFEImport('');
      alert(`Added ${rows.length} item(s) from the pasted data. Review and curate below (uncheck any personal items).`);
    } catch (e) {
      alert('AI import failed: ' + e.message);
    } finally {
      setCimFFEImporting(false);
    }
  };

  const [cimFacility, setCimFacility] = useState({ address: '', ownedOrLeased: '', monthlyRate: '', leaseExpiration: '', renewalOptions: '', sqft: '', canOperateRemotely: '', sellerWillSellOrLease: '' });
  const [cimLegal, setCimLegal] = useState({ pendingLegalMatters: '', pendingLegalDetails: '', nonCompeteYears: '', nonCompeteScope: '', contractAssignability: '', multiYearVendorAgreements: '', vendorAgreementDetails: '' });
  const [cimGrowth, setCimGrowth] = useState([
    { id: 1, description: '', achievability: '', estimatedUpside: '' },
    { id: 2, description: '', achievability: '', estimatedUpside: '' },
    { id: 3, description: '', achievability: '', estimatedUpside: '' }
  ]);
  const [cimGrowthExtra, setCimGrowthExtra] = useState({ maTargets: '', untappedServices: '', geoExpansion: '' });
  // Generic builder Phase 1 (2026-07-20, spec `453a340`): Lead-defined data
  // GROUPS per deal — each a key/value list OR a table with Lead-named columns,
  // routed to a chosen CIM section. Captures business-specific data (HVAC KPIs,
  // staffing metrics, ...) without hardcoding per-industry fields. Presets
  // (save/load group-sets) are Phase 2.
  // [{ id, name, kind: 'kv'|'table', section, kv: [{k,v}], columns: [string], rows: [[string]] }]
  const [cimCustomGroups, setCimCustomGroups] = useState([]);
  // Per-client display ATTRIBUTE columns (generic builder, 2026-07-20 build
  // plan): Lead-named columns on the Client Detail grid (Endpoints, System
  // Age, Placements, …). Values live per client row in `attrs` (keyed by col
  // id) and flow to the CIM's client exhibit. Display-only — the typed engine
  // inputs (contract/status fields) stay hardcoded. [{ id, name }]
  const [cimClientAttrCols, setCimClientAttrCols] = useState([]);
  // Phase 2: staff-shared PRESETS (migration 029, /api/cim/group-presets).
  // A preset is group-set STRUCTURE only (labels/columns/sections — no deal
  // values): "new deal → load the closest preset → tweak". null = not fetched.
  const [cimGroupPresets, setCimGroupPresets] = useState(null);
  const [cimPresetSel, setCimPresetSel] = useState('');
  const [cimPresetBusy, setCimPresetBusy] = useState(false);

  const cimAuthedFetch = async (url, opts = {}) => {
    const { data: { session } } = await supabaseClient.auth.getSession();
    const accessToken = session && session.access_token;
    if (!accessToken) throw new Error('not signed in');
    const resp = await fetch(url, { ...opts, headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken, ...(opts.headers || {}) } });
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) throw new Error((data && data.error) || ('HTTP ' + resp.status));
    return data;
  };

  const fetchCimGroupPresets = async () => {
    try {
      const data = await cimAuthedFetch('/api/cim/group-presets');
      setCimGroupPresets(Array.isArray(data.presets) ? data.presets : []);
    } catch (e) {
      console.warn('Preset list failed:', e.message);
      setCimGroupPresets([]); // don't refetch-loop; toolbar shows none
    }
  };

  // Load = APPEND the preset's groups (fresh ids) — never replaces what the
  // Lead already entered, so loading a second preset or re-loading is safe.
  // A preset may carry per-client attribute COLUMN names as a sentinel entry
  // ({ __clientAttrCols: [names] }) inside its groups jsonb — those append to
  // cimClientAttrCols (skipping names the deal already has).
  const loadCimGroupPreset = () => {
    const p = (cimGroupPresets || []).find(x => x.name === cimPresetSel);
    if (!p) return;
    const sentinel = (p.groups || []).find(g => g && Array.isArray(g.__clientAttrCols));
    if (sentinel) {
      const existing = new Set((cimClientAttrCols || []).map(c => (c.name || '').trim().toLowerCase()));
      const add = sentinel.__clientAttrCols
        .map(n => String(n || '').trim()).filter(n => n && !existing.has(n.toLowerCase()))
        .map((n, i) => ({ id: 'a' + Date.now() + '_' + i, name: n }));
      if (add.length) setCimClientAttrCols(prev => [...(prev || []), ...add]);
    }
    // Phase-3 fold: a preset may enable TYPED structured panels (MSP vendor
    // table / Contract Snapshot) via a { __typedPanels: [keys] } sentinel —
    // visibility only; the data home stays typed.
    const typedSentinel = (p.groups || []).find(g => g && Array.isArray(g.__typedPanels));
    if (typedSentinel) {
      const valid = typedSentinel.__typedPanels.filter(k => k === 'techStack' || k === 'contractSnapshot');
      if (valid.length) {
        setCimTypedPanels(prev => Array.from(new Set([...(prev || []), ...valid])));
        alert('Structured sections enabled on this deal: ' + valid.map(k => k === 'techStack' ? 'Technology Stack' : 'Contract Snapshot').join(' + ') + ' (see the panels above the Custom Data Groups card).');
      }
    }
    const fresh = (p.groups || []).filter(g => g && !Array.isArray(g.__clientAttrCols) && !Array.isArray(g.__typedPanels)).map(g => ({
      id: Date.now() + Math.random(),
      name: g.name || '',
      kind: g.kind === 'table' ? 'table' : 'kv',
      section: g.section || 'businessOverview',
      kv: Array.isArray(g.kv) ? g.kv.map(r => ({ k: r.k || '', v: r.v || '' })) : [],
      columns: Array.isArray(g.columns) ? g.columns.slice() : [],
      rows: Array.isArray(g.rows) ? g.rows.map(r => (r || []).slice()) : []
    }));
    setCimCustomGroups(prev => [...prev, ...fresh]);
  };

  // Save = current groups as a named preset, STRUCTURE ONLY: kv labels kept,
  // values stripped; table columns kept, data rows dropped. Deal-specific
  // values must never leak into a staff-shared template.
  const saveCimGroupPreset = async () => {
    const named = (cimCustomGroups || []).filter(g => (g.name || '').trim());
    const attrNames = (cimClientAttrCols || []).map(c => (c.name || '').trim()).filter(Boolean);
    // Typed panels that are active on this deal (enabled or holding data) ride
    // along as a __typedPanels sentinel, so a Lead's "MSP-shaped" deal setup
    // round-trips through Save → Load. Names only — never the panel data.
    const typedPanels = [
      (Object.values(cimTechStack || {}).some(v => v) || (cimVendors || []).some(v => (v.technology || '').trim()) || (cimTypedPanels || []).includes('techStack')) && 'techStack',
      (Object.values(cimContractTerms || {}).some(v => v) || (cimTypedPanels || []).includes('contractSnapshot')) && 'contractSnapshot',
    ].filter(Boolean);
    if (!named.length && !attrNames.length && !typedPanels.length) { alert('Nothing to save — add at least one named data group or client-attribute column first.'); return; }
    const name = (prompt('Preset name (staff-shared; same name overwrites):', cimPresetSel || '') || '').trim();
    if (!name) return;
    const structure = named.map(g => ({
      name: g.name.trim(),
      kind: (g.kind || 'kv') === 'table' ? 'table' : 'kv',
      section: g.section || 'businessOverview',
      kv: (g.kv || []).filter(r => (r.k || '').trim()).map(r => ({ k: r.k.trim(), v: '' })),
      columns: (g.columns || []).map(c => (c || '').trim()),
      rows: []
    }));
    // Per-client attribute COLUMN names ride inside groups jsonb as a sentinel
    // entry — no server/schema change; load filters it back out. Names only,
    // never values (values are deal data).
    if (attrNames.length) structure.push({ __clientAttrCols: attrNames });
    if (typedPanels.length) structure.push({ __typedPanels: typedPanels });
    setCimPresetBusy(true);
    try {
      await cimAuthedFetch('/api/cim/group-presets', { method: 'POST', body: JSON.stringify({ name, groups: structure }) });
      await fetchCimGroupPresets();
      setCimPresetSel(name);
      alert(`Preset "${name}" saved (structure only — values stay with this deal).`);
    } catch (e) {
      alert('Preset save failed: ' + e.message);
    } finally {
      setCimPresetBusy(false);
    }
  };
  const [cimExportOptions, setCimExportOptions] = useState({
    incomeStatement: true,
    balanceSheet: true,
    normalizedEbitda: true,
    taxReconciliation: true,
    workingCapital: true,
    revenueByClient: true,
    keyMetrics: true,
    businessSummary: true,
    // Detail/analysis sheets — previously always exported (no checkbox), which is
    // why "2 checked, 8 pulled" (Zac 2026-07-15). Now individually selectable.
    opexDetail: true,
    revenueBreakdown: true,
    monthlyTrend: true,
    retentionChurn: true,
    arApQuality: true,
    sellerQA: true,
    strengthsRisks: true,
    anonymizeClients: true
  });
  const [cimExporting, setCimExporting] = useState(false);
  const [cimValidationWarnings, setCimValidationWarnings] = useState([]);
  const [cimBlockingErrors, setCimBlockingErrors] = useState([]);
  const [copySuccess, setCopySuccess] = useState(false);
  const [exportOptions, setExportOptions] = useState({
    presentationPackage: true,
    valueEnhancement: false,
    blueprintReport: false,
    analysisPackage: false,
    proFormaReport: false,
    sbaReport: false
  });
  const [showBasisTools, setShowBasisTools] = useState(false);
  const [pasteModal, setPasteModal] = useState({ show: false, section: null, categoryId: null, categoryName: '' });
  const [pasteData, setPasteData] = useState('');
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const MAX_UNDO_LEVELS = 10;
  
  // Read-only viewer guard. Account Managers (Adam / J.C.) get the valuation
  // editor for *visibility* only — they open projects from their follow-up
  // cards to read context, but must never persist a change (no role lock
  // existed before, so an AM's edits would have autosaved). Computed from the
  // REAL logged-in user (not View-as), so Mark-as-owner is never blocked.
  // Every editor write path checks this; the Save buttons disable; a banner
  // explains it. Their actual writes (follow-up dates, outreach) live on the
  // Dashboard's My Work handlers, which are unaffected.
  const isReadOnlyViewer = useMemo(
    () => (STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()] || {}).role === 'account_manager',
    [userEmail]
  );
  // Staff display name for ledger attribution (the 🗒 note toolbar in the
  // read-only view — Adam/Sierra Mountain 08-27: he typed his call notes into
  // Deal Notes, which never persists for AMs, and the 🗒 vehicle only existed
  // on My Work cards this deal wasn't on).
  const viewerStaffName = useMemo(
    () => (STAFF_DIRECTORY[String(userEmail || '').trim().toLowerCase()] || {}).name || null,
    [userEmail]
  );

  // Auto-save functionality
  const [autoSaveStatus, setAutoSaveStatus] = useState(''); // '', 'saving', 'saved'
  const [lastAutoSave, setLastAutoSave] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // Published for the stale-version auto-reload (08-20): a reload is only
  // ever taken when this is false. Autosave-on-hidden + the localStorage
  // backup cover the transition anyway; this flag is the belt to that
  // suspenders.
  useEffect(() => {
    window.__vtHasUnsavedChanges = hasUnsavedChanges;
    return () => { window.__vtHasUnsavedChanges = false; };
  }, [hasUnsavedChanges]);
  const AUTO_SAVE_KEY = 'msp_valuation_autosave';

  // Supabase cloud persistence state
  const cloudMode = !!supabaseClient;
  // Initialized to null (NOT currentValuation.id) so the cadence autoAction
  // useEffect doesn't fire on mount before the load completes. The load
  // function calls setCurrentValuationId AFTER setWorkflow, so the effect's
  // post-load run sees workflow with the row's values. (Bug observed
  // 2026-05-27 — diagnostic confirmed workflowRef.current was empty at
  // prefill time because the effect was firing before the load batch.)
  const [currentValuationId, setCurrentValuationId] = useState(null);
  const [valuationName, setValuationName] = useState(currentValuation?.name || '');
  const [cloudSaveError, setCloudSaveError] = useState('');
  const hasHydratedRef = useRef(false);
  const lastSyncedClientNameRef = useRef(currentClient?.company_name || '');
  const lastSyncedVistaIdRef = useRef(currentClient?.vista_id || '');

  // Concurrent-edit safety: presence (who else is in this file) + save-time conflict detection
  // (refuse the write if updated_at moved since we loaded). The migration in
  // migrations/001_add_valuation_presence.sql must be applied to Supabase for this to work.
  const loadedUpdatedAtRef = useRef(null);
  // Before a direct write on the OPEN file (Mark 10-12, Blue Spruce): adopt the new updated_at only if this tab
  // was current. Adopting it unconditionally told an OUT-OF-DATE tab it was current, so its next save went
  // through and wrote old document statuses over newer ones (both portal forms reverted to Not received
  // after the hand-off; Client Detail had to be re-marked four times). A stale tab's next save is now refused.
  const tabIsCurrent = async () => {
    if (!supabaseClient || !currentValuationId || !loadedUpdatedAtRef.current) return true;
    try {
      const { data } = await supabaseClient.from('valuations').select('updated_at').eq('id', currentValuationId).single();
      return !data || data.updated_at === loadedUpdatedAtRef.current;
    } catch (e) { return false; }
  };
  // Serialize cloud saves (Colleen 2026-07-31: sporadic "file changed" with
  // nobody else in the file, work intact on reload — a manual save racing an
  // in-flight autosave. Both read the same loaded stamp; the first to land
  // bumped updated_at and the second conflicted against HER OWN save). One
  // save at a time; each builds its updated_at filter only after the prior
  // save has finished refreshing the ref.
  const saveLockRef = useRef(Promise.resolve());
  const runExclusiveSave = (fn) => {
    const run = saveLockRef.current.catch(() => {}).then(fn);
    saveLockRef.current = run.catch(() => {});
    return run;
  };
  // Data-loss guard (2026-07-02): stop a blank/half-loaded editor from clobbering
  // a saved discovery Q&A. `suppressQAGuardRef` = one-shot bypass set by the
  // intentional "Clear Deal". `qaGuardEmptyOkRef` caches the valuation id whose DB
  // Q&A we've confirmed empty, so the guard's re-read costs nothing on genuinely
  // unanswered deals. See the guard block in saveDeal + the autosave.
  const suppressQAGuardRef = useRef(false);
  const qaGuardEmptyOkRef = useRef(null);
  const [otherViewers, setOtherViewers] = useState([]); // [{ user_id, user_email, last_seen }]
  const otherViewersRef = useRef([]); // mirror of otherViewers, readable from interval closures
  const [saveConflict, setSaveConflict] = useState(false);
  const isHydratingRef = useRef(true); // true until initial load completes; suppresses phantom hasUnsavedChanges
  const pendingSeedSaveRef = useRef(false); // set when a New Project seed needs an immediate persist
  const PRESENCE_TTL_MS = 90 * 1000;       // a viewer is "active" if heartbeat within this window
  const PRESENCE_HEARTBEAT_MS = 30 * 1000; // refresh our own last_seen this often
  const PRESENCE_POLL_MS = 15 * 1000;      // poll for other viewers this often
  const formatViewerName = (email) => {
    const local = (email || '').split('@')[0];
    if (!local) return 'Someone';
    return local.split(/[._-]+/).filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  };
  
  const [reviewSection, setReviewSection] = useState('financials');
  const [simEbitdaChange, setSimEbitdaChange] = useState(0);
  const [simContractTerms, setSimContractTerms] = useState('month-to-month');
  const [simOwnerDependency, setSimOwnerDependency] = useState('high');
  // Value Enhancement - Multiple improvement sliders
  const [simRecurringPct, setSimRecurringPct] = useState(null); // null = use current
  const [simRevenueGrowth, setSimRevenueGrowth] = useState(null);
  const [simRetentionRate, setSimRetentionRate] = useState(null);
  const [simTopCustomerPct, setSimTopCustomerPct] = useState(null);
  const [simClientCount, setSimClientCount] = useState(null);
  const [simMarginImprovement, setSimMarginImprovement] = useState(0); // percentage points improvement
  // Contract improvements checklist
  const [simContractImprovements, setSimContractImprovements] = useState({
    extendTerms: false,      // +0.2x - Extend to 24+ months
    addAutoRenewal: false,   // +0.1x
    addEscalators: false,    // +0.15x - 3-5% price escalators
    addTermPenalty: false    // +0.15x - Early termination penalty
  });
  // Acquisition target simulator
  const [simAcquisitionTargetEbitda, setSimAcquisitionTargetEbitda] = useState(300000);
  const [simTargetQualityAssumption, setSimTargetQualityAssumption] = useState(1.0);
  
  // Strategic Value Blueprint state
  const [blueprintTargetValuation, setBlueprintTargetValuation] = useState(null);
  const [blueprintTimelineYears, setBlueprintTimelineYears] = useState(null);
  const [blueprintTargetMargin, setBlueprintTargetMargin] = useState(null);

  // ========== DEAL PROFILE ==========
  const [dealProfile, setDealProfile] = useState({
    companyName: '',
    website: '',
    vistaId: '',  // 6-digit Zoho prospect ID; required before CIM export
    dealStage: 'initial',
    assignedAnalyst: '',
    initialMeetingDate: '',
    valuationMeetingDate: '',
    targetCloseDate: '',
    dealNotes: '',
    // Location fields
    city: '',
    state: '',
    yearEstablished: '',
    legalStatus: '',
    locationType: 'suburban', // 'major_metro', 'suburban', 'small_city', 'rural'
    // CIM Business Details fields (Zac 2026-07-27: the CIM section was missing
    // what Vista normally provides). All optional free text; blank = the CIM
    // drops the row. Ownership stays free text (e.g. "Jane 60% · John 40%") —
    // a structured owner/% model isn't worth it for a display-only line.
    dbaName: '',
    stateOfIncorporation: '',
    ownershipText: '',
    hoursOfOperation: '',
    industryMix: '',
    // Contract defaults
    typicalContractMonths: null, // Company-level default contract length in months
    // Fiscal year setting (1-12, where 12 = December = calendar year)
    fiscalYearEndMonth: 12,
    // Primary contact role — the principal isn't always "Owner" (sometimes CEO,
    // President, etc.). Set at AM warm-account creation; labels the owner contact.
    ownerRole: '',
    // Additional professional contacts (accountant, attorney, etc.) — managed on
    // the Setup tab, not the create modal. [{ name, email, role }]. Stored in the
    // data blob (no extra columns). Display/context only for now. (2026-06-16)
    professionalContacts: []
  });
  // 🐞 Report button context (ROADMAP #18, 10-20): the tab and the deal the reporter is on. Placed AFTER dealProfile:
  // an existing valuation opens with currentClient null, so the company name comes from the deal's own profile
  // (10-21: Colleen's and later reports arrived with only the valuation id). Declared-before-use rule (10-02 outage).
  useEffect(() => {
    window.__vtReportContext = { page: 'Valuation · ' + viewMode, record_type: 'valuation', record_id: currentValuationId || null,
      record_label: (dealProfile.companyName && dealProfile.companyName.trim()) || (currentClient && (currentClient.company_name || currentClient.name)) || null };
  }, [viewMode, currentValuationId, currentClient, dealProfile.companyName]);

  // ========== WORKFLOW STATE (migration 004/005 columns) ==========
  // These live as real columns on the valuations row (NOT in the data
  // JSONB blob). They power the new dashboard. Loaded from the row on
  // mount, saved back as part of valuationRow in saveDeal / autosave.
  const [workflow, setWorkflow] = useState({
    workflow_stage: 'awaiting_upload',
    path: '',
    buyside: false,
    colleen_review_decision: '',
    lead: '',
    account_manager: '',
    likelihood_pct: '',
    first_meeting_date: '',
    discovery_meeting_date: '',
    committed_upload_date: '',
    owner_target_valuation_date: '', // owner-set "discuss my valuation by" date (portal)
    upload_started_date: '',
    upload_complete_date: '',
    valuation_date: '',
    next_meeting_date: '',
    next_meeting_type: '',
    snooze_until: '',
    snooze_reason: '',
    as_of_date: '',
    books_lag_months: 1,
    stage_entered_at: null,
    owner_first_name: '',
    owner_last_name: '',
    owner_email: '',
    owner_additional: [],   // [{ name, email }] — CC'd on OIR / cadence sends
    portal_docs_released: false,  // owner portal: documents/upload hidden until released (post-discovery)
  });
  // Tracks the workflow_stage value at load time, so a save can tell
  // whether the stage actually changed (and stamp stage_entered_at).
  const loadedWorkflowStageRef = useRef('awaiting_upload');

  // Mirror of `workflow` updated synchronously every render. The cadence
  // auto-open flow defers via setTimeout(200ms) after the load completes;
  // when the timeout fires, the openCadenceReminderModal closure (and the
  // inner prefillOwnerRecipients / buildCadenceEmailNote closures) read
  // from this ref to guarantee they see the *latest* workflow values
  // rather than whatever the closure captured at definition time. Fixes
  // the "To / CC blank, body says 'Your account manager'" bug observed
  // on Michaels Sheet Metal 2026-05-27 even though workflow loaded fine.
  const workflowRef = useRef({});
  workflowRef.current = workflow;

  // Stage Engine — "set the valuation meeting" modal, shown on exit when a
  // project is analysis-complete with no meeting date set yet.
  const [showMeetingDateModal, setShowMeetingDateModal] = useState(false);
  const [meetingDateInput, setMeetingDateInput] = useState('');
  // Calendar write side (ROADMAP #2 remainder, 2026-08-06): optional time +
  // create-the-invite checkbox on the set-the-meeting modal. Time empty =
  // all-day event; invite goes to the owner as a normal Google invite.
  const [meetingTimeInput, setMeetingTimeInput] = useState('');
  const [meetingCreateInvite, setMeetingCreateInvite] = useState(true);
  // Reactivate (un-stall) prompt — captures a fresh committed upload date so
  // the cadence engine doesn't immediately re-flag the project final-due
  // against the stale past date (known sharp edge, fixed 2026-06-12).
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  const [reactivateDateInput, setReactivateDateInput] = useState('');
  // Pipeline-value capture (2026-06-08) — on exit from a project whose
  // valuation meeting is set (but not yet delivered), prompt to record the
  // top value + estimated commission for pipeline tracking. Re-prompts every
  // exit (the number keeps changing) until the valuation is delivered, then
  // locks. Captured figures: value_provided_high + estimated_commission.
  const [showPipelineCaptureModal, setShowPipelineCaptureModal] = useState(false);
  const [pipelineCaptureBusy, setPipelineCaptureBusy] = useState(false);
  // Consolidated post-meeting wrap-up (full valuations, 2026-06-09): one modal
  // for valuation date + final value/commission lock + owner decision (stage)
  // + strategic-review date. Replaces four scattered actions so nothing's
  // forgotten. Decision = a workflow_stage key, or 'awaiting_decision' for
  // "still deciding."
  const [showOutcomeModal, setShowOutcomeModal] = useState(false);
  // Soft outcomes need a reason (Mark 09-21) — inactive already prompts its
  // leave-off note; the rest carry this one line into the activity log.
  const [outcomeReason, setOutcomeReason] = useState('');
  // Value-drift prompt (Mark 09-21): asked once per deal + engine value per session.
  const valueDriftAskedRef = useRef(null);
  const [outcomeDateInput, setOutcomeDateInput] = useState('');
  const [outcomeDecision, setOutcomeDecision] = useState('');
  const [outcomeReviewDate, setOutcomeReviewDate] = useState('');
  const [outcomeBusy, setOutcomeBusy] = useState(false);

  // Stage Engine — "owner opted for strategic review" modal. Captures the
  // strategic-review meeting date as the project's next meeting.
  const [showStrategicReviewModal, setShowStrategicReviewModal] = useState(false);
  const [strategicReviewDateInput, setStrategicReviewDateInput] = useState('');
  // Considering — follow-up-later decision modal (owner strongly considering,
  // asked us to circle back on a date). The date is the follow-up date.
  const [showFollowupModal, setShowFollowupModal] = useState(false);
  const [followupDateInput, setFollowupDateInput] = useState('');

  // Revalue — "Start Revalue" modal (archives the prior valuation and
  // resets the project for a new cycle).
  const [showRevalueModal, setShowRevalueModal] = useState(false);
  const [revalueDateInput, setRevalueDateInput] = useState('');
  const [revalueBusy, setRevalueBusy] = useState(false);
  // 'now' = archive + reset into the upload flow; 'later' = just set a reminder,
  // leave the deal dormant (Mark 09-16, Charter: Start Revalue was clicked before
  // the owner was ready, dropping it into Konnie's upload pipeline months early).
  const [revalueMode, setRevalueMode] = useState('now');
  // Revalue doc-curation (piece 2): true between Start Revalue and Konnie
  // releasing the curated list. Server-owned column; gates the in-editor
  // "Release document list" CTA. Loaded from the row on open.
  const [revalueDocsPending, setRevalueDocsPending] = useState(false);
  const [revalueReviewPending, setRevalueReviewPending] = useState(false);
  const [revalueDocsReleasing, setRevalueDocsReleasing] = useState(false);
  // Review-and-send payload for the formerly-auto-sent owner emails (docs-ready
  // on release, revalue-review on a skip-path revalue). Null = closed.
  const [pendingEmail, setPendingEmail] = useState(null);

  // Stalled — "Returned to AM" checkbox. The reason is captured in the
  // activity-log entry at toggle time; it's not persisted as a separate
  // column on the valuation row.
  const [stalledReasonInput, setStalledReasonInput] = useState('');

  // Personal reminders for this project + current user. Distinct from
  // cadence reminders (B5/B6 — owner-facing) and Snooze Until (project-
  // level pause). When remind_at arrives, the reminder surfaces on this
  // user's My Work view.
  const [projectReminders, setProjectReminders] = useState([]);
  const [newReminderDate, setNewReminderDate] = useState('');
  const [newReminderNote, setNewReminderNote] = useState('');

  // Reload this user's open reminders for this project whenever the
  // valuation context or the logged-in user changes.
  useEffect(() => {
    if (!supabaseClient || !currentValuationId || !userEmail) {
      setProjectReminders([]);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabaseClient
          .from('project_reminders')
          .select('id, remind_at, note, created_at')
          .eq('project_id', currentValuationId)
          .eq('actor_email', userEmail)
          .is('completed_at', null)
          .order('remind_at', { ascending: true });
        if (error) throw error;
        if (!cancelled) setProjectReminders(data || []);
      } catch (e) {
        if (!cancelled) console.warn('Reminder load failed:', e);
      }
    })();
    return () => { cancelled = true; };
  }, [currentValuationId, userEmail]);

  // Add a personal reminder for this user on this project.
  const addProjectReminder = async () => {
    if (!supabaseClient || !currentValuationId || !userEmail) return;
    const remindAt = (newReminderDate || '').trim();
    if (!remindAt) return;
    try {
      const { data, error } = await supabaseClient
        .from('project_reminders')
        .insert({
          project_id: currentValuationId,
          actor_email: userEmail,
          remind_at: remindAt,
          note: (newReminderNote || '').trim() || null,
        })
        .select('id, remind_at, note, created_at')
        .single();
      if (error) throw error;
      setProjectReminders(prev =>
        [...prev, data].sort((a, b) => (a.remind_at || '').localeCompare(b.remind_at || ''))
      );
      setNewReminderDate('');
      setNewReminderNote('');
    } catch (e) {
      console.error('Add reminder failed:', e);
      window.alert('Failed to add reminder: ' + (e?.message || 'unknown error'));
    }
  };

  // Mark a reminder done — sets completed_at, removes from the local list.
  const dismissProjectReminder = async (reminderId) => {
    if (!supabaseClient || !reminderId) return;
    try {
      const { error } = await supabaseClient
        .from('project_reminders')
        .update({ completed_at: new Date().toISOString() })
        .eq('id', reminderId);
      if (error) throw error;
      setProjectReminders(prev => prev.filter(r => r.id !== reminderId));
    } catch (e) {
      console.error('Dismiss reminder failed:', e);
      window.alert('Failed to dismiss: ' + (e?.message || 'unknown error'));
    }
  };

  // Generic field updater for the Workflow section on the Setup tab.
  // Marks unsaved so the autosave persists workflow-field edits — the
  // `workflow` state is not in the unsaved-changes tracker on its own.
  const updateWorkflow = (field, value) => {
    setWorkflow(w => {
      const next = { ...w, [field]: value };
      // Filling the Valuation Date means the valuation was delivered, so the
      // valuation meeting is now in the past. Clear it out of Next Meeting
      // Date — that field stays reserved for a genuine upcoming meeting
      // (e.g. a strategic review). Only clears a Valuation-type meeting.
      if (field === 'valuation_date' && value && /val/i.test(w.next_meeting_type || '')) {
        next.next_meeting_date = '';
        next.next_meeting_type = '';
      }
      return next;
    });
    // Filling the Valuation Date IS the "value delivered / locked" moment
    // (the stage derives to awaiting_decision from it) — snapshot the
    // commission if none is captured yet. This Setup-tab delivery path
    // bypassed every capture prompt AND the decision-transition backstop
    // (Mark 2026-07-24: Secured Retail reached Awaiting Decision at $0
    // while the Fee Calculator showed $218k on screen).
    if (field === 'valuation_date' && value) ensureCommissionSnapshot('awaiting_decision');
    setHasUnsavedChanges(true);
  };

  // Owner contact — additional (CC'd) owners list helpers.
  const addOwnerContact = () =>
    updateWorkflow('owner_additional', [...(workflow.owner_additional || []), { name: '', email: '' }]);
  const updateOwnerContact = (idx, field, value) =>
    updateWorkflow('owner_additional',
      (workflow.owner_additional || []).map((o, i) => i === idx ? { ...o, [field]: value } : o));
  const removeOwnerContact = (idx) =>
    updateWorkflow('owner_additional', (workflow.owner_additional || []).filter((_, i) => i !== idx));

  // Additional professional contacts (accountant, attorney, etc.) — stored in
  // the data blob (dealProfile.professionalContacts), edited on the Setup tab.
  // [{ name, email, role }]. Display/context for staff; not wired into cadence.
  const addProfessionalContact = () =>
    setDealProfile(prev => ({ ...prev, professionalContacts: [...(prev.professionalContacts || []), { name: '', email: '', role: 'Accountant' }] }));
  const updateProfessionalContact = (idx, field, value) =>
    setDealProfile(prev => ({ ...prev, professionalContacts: (prev.professionalContacts || []).map((c, i) => i === idx ? { ...c, [field]: value } : c) }));
  const removeProfessionalContact = (idx) =>
    setDealProfile(prev => ({ ...prev, professionalContacts: (prev.professionalContacts || []).filter((_, i) => i !== idx) }));

  // Record-a-fact: the only human-input transitions are the owner's
  // decision after the valuation meeting. recordOwnerDecision records that
  // decision and advances the stage as a consequence — there is no manual
  // stage-clicking; the collection-through-analysis spine is derived (see
  // deriveWorkflowStage). It stamps stage_entered_at, logs the event, and
  // marks unsaved so the autosave persists it (workflow state is not in the
  // unsaved-changes tracker on its own).
  // Commission-capture BACKSTOP (the ISS gap, 2026-07-24): the exit prompts
  // only cover val_meeting_set, so a deal advanced into a post-valuation
  // stage by any other path (partials especially) landed with
  // estimated_commission null and showed $0 in the commission ladder.
  // Silent + engine-computed (same figures capturePipelineValue snapshots);
  // reads the row first and NEVER overwrites an existing commission or a
  // delivered value. Fire-and-forget from every decision transition.
  const POST_VALUATION_STAGES = ['awaiting_decision', 'strategic_review_set', 'considering_followup', 'engaged', 'val_complete_inactive'];
  const ensureCommissionSnapshot = async (newStage) => {
    try {
      if (!POST_VALUATION_STAGES.includes(newStage)) return;
      if (!supabaseClient || !currentValuationId) return;
      const top = Math.round(multipleEngineCalcs?.valuationMarketHigh || 0);
      if (!top) return; // no engine value on this deal — nothing to snapshot
      const { data: row } = await supabaseClient.from('valuations')
        .select('estimated_commission, value_provided_high').eq('id', currentValuationId).single();
      if (!row || Number(row.estimated_commission) > 0) return; // already captured — hands off
      const commission = Math.round(computeCommission(top));
      const nowIso = new Date().toISOString();
      const upd = { estimated_commission: commission, updated_at: nowIso };
      if (!Number(row.value_provided_high)) {
        upd.value_provided_high = top;
        upd.value_provided_low = top;
        upd.value_provided_snapshot_at = nowIso;
      }
      const tabWasCurrent = await tabIsCurrent();
      const { data: ret } = await supabaseClient.from('valuations').update(upd)
        .eq('id', currentValuationId).select('updated_at').single();
      if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
      setWorkflow(w => ({ ...w, ...upd }));
    } catch (e) { console.warn('Commission backstop skipped:', e); }
  };

  const recordOwnerDecision = (newStage, label, extra = {}) => {
    if (isReadOnlyViewer) { window.alert("Read-only view — Account Managers can't change project state."); return; }
    const oldStage = workflow.workflow_stage;
    if (!newStage || newStage === oldStage) return;
    // REQUIRED leave-off note when parking to Inactive (Mark 08-11, the
    // Adam-plate round): this line greets whoever picks the relationship up
    // months later — 📌 on the re-engage card.
    let leaveOff = null;
    if (newStage === 'val_complete_inactive') {
      leaveOff = (window.prompt('Where did it leave off? (required — this line shows on the follow-up card months from now)\n\nExample: "Value felt light to the owner — revisit after their busy season."') || '').trim();
      if (!leaveOff) { window.alert('The leave-off note is required — one sentence on where the conversation ended.'); return; }
    }
    // Guard (Mark 2026-07-29, the ISS card): the end states are invisible to
    // the strategic-review radar and every chase mechanism, so a future
    // meeting left on the card would be silently forgotten. Warn, point at
    // the decision that keeps the date monitored, and clear the field if
    // they proceed anyway — never strand it.
    const END_STATES = ['val_complete_inactive', 'val_complete_dead'];
    const todayIso = new Date().toISOString().slice(0, 10);
    const futureMeeting = END_STATES.includes(newStage)
      && workflow.next_meeting_date && workflow.next_meeting_date >= todayIso;
    if (futureMeeting) {
      const mtg = `${workflow.next_meeting_type || 'a meeting'} on ${workflow.next_meeting_date}`;
      if (!window.confirm(`Record "${label}"?\n\nThis card has ${mtg} scheduled. "${stageLabel(newStage)}" is an end state that no reminder or radar watches, so that meeting will be CLEARED with this move.\n\nIf the owner actually agreed to a strategic review or a later follow-up, cancel and use that button instead — it keeps the date on the radar.`)) return;
    } else if (!window.confirm(`Record "${label}"?\n\nThis moves the project to "${stageLabel(newStage)}".`)) return;
    ensureCommissionSnapshot(newStage);
    // `extra` lets a transition clear stale fields — e.g. a re-engaging owner
    // moving back to Awaiting Decision drops the parked follow-up date.
    setWorkflow(w => ({ ...w, workflow_stage: newStage, stage_entered_at: new Date().toISOString(),
      ...(['val_meeting_set', 'awaiting_decision'].includes(oldStage) ? valuationDateOnOutcome(w) : {}),
      // Leaving the active funnel resets the near-30-day likelihood to 0.
      ...(stageZeroesLikelihood(newStage) ? { likelihood_pct: 0 } : {}), ...extra,
      ...(futureMeeting ? { next_meeting_date: null, next_meeting_type: null } : {}) }));
    setHasUnsavedChanges(true);
    if (currentValuationId) {
      // logActivity is defined later in the component body; it's in scope
      // by closure at call time. Fire-and-forget — non-fatal if it errors.
      logActivity(currentValuationId, 'stage_changed',
        label + (futureMeeting ? ` — cleared scheduled ${workflow.next_meeting_type || 'meeting'} ${workflow.next_meeting_date}` : ''),
        { from: oldStage, to: newStage, reason: leaveOff || null });
      if (leaveOff) logActivity(currentValuationId, 'leave_off', leaveOff, { stage: newStage });
    }
  };

  // Record-a-fact: owner opted for a strategic review cadence. Advances to
  // strategic_review_set and — because that outcome has a genuine next
  // meeting — captures the strategic-review meeting date into the Next
  // Meeting fields. The date is optional; it may not be scheduled yet.
  const recordStrategicReview = () => {
    const oldStage = workflow.workflow_stage;
    const nowIso = new Date().toISOString();
    ensureCommissionSnapshot('strategic_review_set');
    setWorkflow(w => ({
      ...w,
      workflow_stage: 'strategic_review_set',
      stage_entered_at: nowIso,
      ...(['val_meeting_set', 'awaiting_decision'].includes(oldStage) ? valuationDateOnOutcome(w) : {}),
      likelihood_pct: 0, // parked into a review cadence — no longer a near-term seller
      ...(strategicReviewDateInput
        ? { next_meeting_date: strategicReviewDateInput, next_meeting_type: 'Strategic Review' }
        : {}),
    }));
    setHasUnsavedChanges(true);
    if (currentValuationId) {
      logActivity(currentValuationId, 'stage_changed',
        'Owner opted for a strategic review cadence',
        { from: oldStage, to: 'strategic_review_set' });
    }
    setShowStrategicReviewModal(false);
  };

  // Record-a-fact: owner is strongly considering and asked us to follow up on
  // a date. Advances to considering_followup (valuation-active, Lead-owned)
  // and stores the follow-up date in snooze_until — the same "next-touch"
  // field the AM bucket uses, so a future date parks it until due. The date
  // is required here (the whole point is a dated circle-back).
  const recordConsideringFollowup = () => {
    if (!followupDateInput) { window.alert('Pick a follow-up date.'); return; }
    const oldStage = workflow.workflow_stage;
    const nowIso = new Date().toISOString();
    // Awaiting Decision rule (Mark 09-28): within DECIDING_WINDOW_DAYS the deal
    // STAYS Awaiting Decision and the date is a reminder; only a longer
    // circle-back parks it in Considering.
    const target = followupStage(followupDateInput);
    const stays = target === 'awaiting_decision';
    ensureCommissionSnapshot(target);
    setWorkflow(w => ({
      ...w,
      workflow_stage: target,
      ...(stays && oldStage === 'awaiting_decision' ? {} : { stage_entered_at: nowIso }),
      snooze_until: followupDateInput,
      ...(['val_meeting_set', 'awaiting_decision'].includes(oldStage) ? valuationDateOnOutcome(w) : {}),
      ...(stays ? {} : { likelihood_pct: 0 }), // a long circle-back is not near-term; a dated reminder keeps the Lead's read
    }));
    setHasUnsavedChanges(true);
    if (currentValuationId) {
      logActivity(currentValuationId, stays && oldStage === 'awaiting_decision' ? 'note' : 'stage_changed',
        stays ? `Still deciding — follow up ${followupDateInput} (stays in Awaiting Decision)` : `Owner considering — follow up ${followupDateInput}`,
        { from: oldStage, to: target, followup_date: followupDateInput });
    }
    setShowFollowupModal(false);
  };

  // 📝 Agreement out (Mark 09-28, Assura) — the owner asked for the engagement
  // agreement and it went out: back into Awaiting Decision (reminder cleared),
  // top of the staff-meeting group until ✓ Engagement signed.
  const recordAgreementOut = () => {
    if (!window.confirm('The engagement agreement went out to the owner?\n\nThe deal shows as "📝 Agreement out" at the top of Awaiting Decision until you record ✓ Engagement signed.')) return;
    const oldStage = workflow.workflow_stage;
    const nowIso = new Date().toISOString();
    setWorkflow(w => ({
      ...w,
      workflow_stage: 'awaiting_decision',
      ...(oldStage === 'awaiting_decision' ? {} : { stage_entered_at: nowIso }),
      ...(['val_meeting_set', 'awaiting_decision'].includes(oldStage) ? valuationDateOnOutcome(w) : {}),
      snooze_until: '',
      likelihood_pct: Math.max(Number(w.likelihood_pct) || 0, 80),
    }));
    setHasUnsavedChanges(true);
    if (currentValuationId) {
      if (oldStage !== 'awaiting_decision') logActivity(currentValuationId, 'stage_changed', 'Owner asked for the engagement agreement — back to Awaiting Decision', { from: oldStage, to: 'awaiting_decision', reason: 'agreement-out' });
      logActivity(currentValuationId, 'agreement_out', '📝 Engagement agreement sent to the owner', {});
    }
  };

  // Record-a-fact: project is stalled; the AM handles the relationship
  // until the owner re-engages. Checking sets workflow_stage to
  // stalled_returned_to_am with the reason captured in the activity log.
  // Unchecking resets the stage to awaiting_upload so the engine
  // re-derives the right stage from current data on the next save.
  const handleStalledToggle = async (newChecked) => {
    if (isReadOnlyViewer) return; // read-only viewers can't change stalled state
    if (!currentValuationId) return;
    const oldStage = workflow.workflow_stage;
    if (newChecked === (oldStage === 'stalled_returned_to_am')) return;
    // Reactivating (unchecking) → prompt for a fresh committed upload date.
    // Without it the cadence engine would immediately re-flag the project as
    // final-due against the stale past date (the known sharp edge). The actual
    // stage change happens in confirmReactivate once a date is chosen.
    if (!newChecked) {
      setReactivateDateInput('');
      setShowReactivateModal(true);
      return;
    }
    // Stalling (checking) → Returned to AM. Reason is REQUIRED (Mark 08-11):
    // it becomes the 📌 "where it left off" line on the AM's re-engage card.
    const nowIso = new Date().toISOString();
    let reason = (stalledReasonInput || '').trim();
    if (!reason) {
      reason = (window.prompt('Where did it leave off? (required — this line shows on the AM\'s follow-up card)\n\nExample: "Owner went quiet after the doc request — three chases, no reply."') || '').trim();
      if (!reason) { window.alert('The leave-off note is required when returning a project to the AM.'); return; }
    }
    setWorkflow(w => ({ ...w, workflow_stage: 'stalled_returned_to_am', stage_entered_at: nowIso, likelihood_pct: 0 }));
    setStalledReasonInput('');
    setHasUnsavedChanges(true);
    logActivity(currentValuationId, 'stage_changed',
      `Returned to AM — ${reason}`,
      { from: oldStage, to: 'stalled_returned_to_am', reason });
    logActivity(currentValuationId, 'leave_off', reason, { stage: 'stalled_returned_to_am' });

    // Persist the stage change directly so the dashboard sees it on the
    // next load — don't wait for the 60s autosave (which would leave a
    // cadence card visible if Konnie navigates back before the tick).
    // Bug observed 2026-05-27 with Worldwide Services.
    if (supabaseClient) {
      try {
        const { data: rows, error } = await supabaseClient
          .from('valuations')
          .update({ workflow_stage: 'stalled_returned_to_am', stage_entered_at: nowIso, likelihood_pct: 0, updated_at: nowIso })
          .eq('id', currentValuationId)
          .select('updated_at');
        if (error) throw error;
        // Keep autosave's conflict detection in sync with our direct write.
        if (rows && rows[0]) loadedUpdatedAtRef.current = rows[0].updated_at;
      } catch (e) {
        console.warn('Stalled toggle direct save failed (autosave will retry on next tick):', e);
      }
    }
  };

  // Reactivate (un-stall) with a fresh committed upload date. Resets the stage
  // to awaiting_upload so the engine re-derives from current data on the next
  // save, and stamps the new commit date so cadence restarts from today rather
  // than re-firing against the old past date. (2026-06-12)
  const confirmReactivate = async () => {
    if (isReadOnlyViewer) return;
    if (!currentValuationId) return;
    const newDate = (reactivateDateInput || '').trim();
    if (!newDate) return;
    const oldStage = workflow.workflow_stage;
    const nowIso = new Date().toISOString();
    setWorkflow(w => ({ ...w, workflow_stage: 'awaiting_upload', stage_entered_at: nowIso, committed_upload_date: newDate }));
    setHasUnsavedChanges(true);
    logActivity(currentValuationId, 'stage_changed',
      `Reactivated — new committed upload date ${newDate}`,
      { from: oldStage, to: 'awaiting_upload', committed_upload_date: newDate });
    if (supabaseClient) {
      try {
        const { data: rows, error } = await supabaseClient
          .from('valuations')
          .update({ workflow_stage: 'awaiting_upload', stage_entered_at: nowIso, committed_upload_date: newDate, updated_at: nowIso })
          .eq('id', currentValuationId)
          .select('updated_at');
        if (error) throw error;
        if (rows && rows[0]) loadedUpdatedAtRef.current = rows[0].updated_at;
      } catch (e) {
        console.warn('Reactivate direct save failed (autosave will retry on next tick):', e);
      }
    }
    setShowReactivateModal(false);
  };

  // Stage Engine — partial confirm-on-exit + the meeting-date prompt.
  // Leaving a partial that's mid-collection/adjustments asks whether it's
  // finished; confirming advances it to analysis_complete. Then, for any
  // project now at analysis_complete with no meeting date (a partial just
  // confirmed, or a full val auto-derived there at 100% accuracy), the
  // set-the-meeting-date modal opens — its own buttons handle the exit.
  const handleBackToList = async () => {
    // Read-only viewers (AMs) just leave — no stage-engine prompts, modals, or
    // direct writes fire on their exit.
    if (isReadOnlyViewer) { if (onBackToList) onBackToList(); return; }
    let effectiveStage = workflow.workflow_stage;

    const isPartialInProgress = workflow.path === 'partial'
      && (workflow.workflow_stage === 'data_entry_complete'
          || workflow.workflow_stage === 'adjustments_entered')
      && !!currentValuationId;
    if (isPartialInProgress) {
      const finished = window.confirm(
        'This is a partial valuation.\n\n' +
        'If your quick review is finished, VT will mark the analysis complete ' +
        'and hand it to the Lead to set the valuation meeting.\n\n' +
        'OK = finished.   Cancel = still working (VT will ask again next time).'
      );
      if (!finished) { if (onBackToList) onBackToList(); return; }
      const nowIso = new Date().toISOString();
      try {
        if (supabaseClient) {
          const tabWasCurrent = await tabIsCurrent();
          const { data: ret } = await supabaseClient.from('valuations')
            .update({ workflow_stage: 'analysis_complete', stage_entered_at: nowIso, updated_at: nowIso })
            .eq('id', currentValuationId).select('updated_at').single();
          if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
        }
      } catch (e) { console.warn('Partial-complete stage advance failed:', e); }
      logActivity(currentValuationId, 'stage_changed',
        'Partial valuation marked finished — analysis complete; Lead to set the valuation meeting',
        { from: workflow.workflow_stage, to: 'analysis_complete' });
      // Partials (2026-06-08): the Lead sets the meeting, so don't prompt the
      // analyst for a date — just hand off. It now sits on the Lead's My Work.
      if (onBackToList) onBackToList();
      return;
    }

    // Meeting-date prompt — full valuations only (partials hand off to the
    // Lead above). Analysis complete, no meeting date yet; the goal is the
    // valuation meeting set within 24 hours of completion, ASAP.
    const needsMeetingDate = workflow.path === 'full_valuation'
      && effectiveStage === 'analysis_complete'
      && !workflow.next_meeting_date
      && !!currentValuationId;
    if (needsMeetingDate) {
      setMeetingDateInput('');
      setShowMeetingDateModal(true);
      return;
    }

    // Valuation-meeting exit prompts (val_meeting_set, not yet delivered):
    //  • Full val whose meeting date has PASSED → the consolidated post-meeting
    //    outcome wrap-up (date + value/commission + decision + review date).
    //  • Otherwise (pre-meeting, or partials) → the running value/commission
    //    capture (re-prompts each exit, locks when delivered). (2026-06-09)
    if (workflow.workflow_stage === 'val_meeting_set' && !workflow.valuation_date && currentValuationId) {
      const md = workflow.next_meeting_date ? new Date(workflow.next_meeting_date + 'T00:00:00') : null;
      const today0 = new Date(); today0.setHours(0, 0, 0, 0);
      const meetingPassed = md && md < today0;
      if (workflow.path === 'full_valuation' && meetingPassed) {
        setOutcomeDateInput(new Date().toISOString().slice(0, 10));
        setOutcomeDecision('');
        setOutcomeReviewDate('');
        setShowOutcomeModal(true);
        return;
      }
      setShowPipelineCaptureModal(true);
      return;
    }

    if (onBackToList) onBackToList();
  };

  // Snapshot the top value + estimated commission for pipeline tracking, then
  // exit. Reuses the value_provided_* columns + estimated_commission. The
  // figures are VT's own (top value = multipleEngineCalcs.valuationMarketHigh;
  // commission via the shared tiered schedule), captured as-is — no manual entry.
  const capturePipelineValue = async () => {
    if (isReadOnlyViewer) { setShowPipelineCaptureModal(false); if (onBackToList) onBackToList(); return; }
    const top = Math.round(multipleEngineCalcs?.valuationMarketHigh || 0);
    const commission = Math.round(computeCommission(top));
    const nowIso = new Date().toISOString();
    setPipelineCaptureBusy(true);
    try {
      if (supabaseClient && currentValuationId) {
        const tabWasCurrent = await tabIsCurrent();
        const { data: ret } = await supabaseClient.from('valuations')
          .update({
            value_provided_high: top,
            value_provided_low: top,
            estimated_commission: commission,
            value_provided_snapshot_at: nowIso,
            updated_at: nowIso,
          })
          .eq('id', currentValuationId).select('updated_at').single();
        if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
      }
    } catch (e) { console.warn('Pipeline-value capture failed:', e); }
    setPipelineCaptureBusy(false);
    setShowPipelineCaptureModal(false);
    if (onBackToList) onBackToList();
  };

  const skipPipelineCapture = () => {
    setShowPipelineCaptureModal(false);
    if (onBackToList) onBackToList();
  };

  // Open the consolidated post-meeting outcome modal (full vals, val_meeting_set).
  const openOutcomeModal = () => {
    setOutcomeDateInput(workflow.valuation_date || new Date().toISOString().slice(0, 10));
    setOutcomeDecision('');
    setOutcomeReviewDate('');
    setOutcomeReason('');
    setShowOutcomeModal(true);
  };

  // Record the valuation meeting outcome in one shot: valuation date + final
  // value/commission (locked) + the owner decision (which sets the stage) +
  // the strategic-review date if applicable. Writes directly to Supabase and
  // local state, logs, then exits. (2026-06-09)
  const saveValuationOutcome = async (exitAfter = true) => {
    if (isReadOnlyViewer) return;
    if (!outcomeDateInput || !outcomeDecision) return;
    // REQUIRED leave-off note when the outcome parks to Inactive (Mark
    // 08-11) — it becomes the 📌 line on the AM's re-engage card.
    let leaveOff = null;
    if (outcomeDecision === 'val_complete_inactive') {
      leaveOff = (window.prompt('Where did it leave off? (required — this line shows on the follow-up card months from now)\n\nExample: "Value felt light to the owner — revisit after their busy season."') || '').trim();
      if (!leaveOff) { window.alert('The leave-off note is required — one sentence on where the conversation ended.'); return; }
    }
    const nowIso = new Date().toISOString();
    const top = Math.round(multipleEngineCalcs?.valuationMarketHigh || 0);
    const commission = Math.round(computeCommission(top));
    const oldStage = workflow.workflow_stage;
    const isFollowup = outcomeDecision === 'considering_followup';
    // Awaiting Decision rule (Mark 09-28): a dated follow-up inside the window
    // stays Awaiting Decision with the date as its reminder.
    const newStage = isFollowup ? followupStage(outcomeReviewDate) : outcomeDecision; // a workflow_stage key
    const isReview = newStage === 'strategic_review_set';
    const updates = {
      valuation_date: outcomeDateInput,
      value_provided_high: top,
      value_provided_low: top,
      estimated_commission: commission,
      value_provided_snapshot_at: nowIso,
      workflow_stage: newStage,
      stage_entered_at: nowIso,
      // The valuation meeting is now past: either replace Next Meeting with the
      // strategic-review meeting, or clear it.
      next_meeting_date: (isReview && outcomeReviewDate) ? outcomeReviewDate : null,
      next_meeting_type: (isReview && outcomeReviewDate) ? 'Strategic Review' : null,
      // A "considering — follow up later" outcome parks the follow-up date in
      // snooze_until (the next-touch field), so it surfaces as due on the date.
      ...(isFollowup ? { snooze_until: outcomeReviewDate } : {}),
    };
    setOutcomeBusy(true);
    try {
      if (supabaseClient && currentValuationId) {
        const tabWasCurrent = await tabIsCurrent();
        const { data: ret } = await supabaseClient.from('valuations')
          .update({ ...updates, updated_at: nowIso }).eq('id', currentValuationId)
          .select('updated_at').single();
        if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
      }
    } catch (e) { console.warn('Outcome save failed:', e); }
    setWorkflow(w => ({ ...w, ...updates }));
    setHasUnsavedChanges(true);
    // 📌 The figure we gave the owner — fixed from here on, whatever later TTM updates do.
    takeEbitdaSnapshot('presented', 'valuation meeting ' + (outcomeDateInput || new Date().toISOString().slice(0, 10)));
    if (currentValuationId) {
      logActivity(currentValuationId, 'stage_changed',
        `Valuation meeting outcome recorded — ${stageLabel(newStage)}`,
        { from: oldStage, to: newStage, reason: 'meeting-outcome' });
      if (leaveOff) logActivity(currentValuationId, 'leave_off', leaveOff, { stage: newStage });
      if (outcomeReason.trim()) logActivity(currentValuationId, 'note', `Outcome reason — ${outcomeReason.trim()}`, { stage: newStage, reason: 'meeting-outcome' });
    }
    setOutcomeBusy(false);
    setShowOutcomeModal(false);
    if (exitAfter && onBackToList) onBackToList();
  };

  // Stage Engine — write the valuation meeting date from the exit modal,
  // advance to val_meeting_set, then leave the file.
  const saveMeetingDateAndExit = async () => {
    if (isReadOnlyViewer) return;
    if (!meetingDateInput) return;
    const nowIso = new Date().toISOString();
    try {
      if (supabaseClient && currentValuationId) {
        const tabWasCurrent = await tabIsCurrent();
        const { data: ret } = await supabaseClient.from('valuations')
          .update({
            next_meeting_date: meetingDateInput,
            next_meeting_type: 'Valuation',
            workflow_stage: 'val_meeting_set',
            stage_entered_at: nowIso,
            updated_at: nowIso,
          })
          .eq('id', currentValuationId).select('updated_at').single();
        if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
      }
    } catch (e) { console.warn('Meeting-date save failed:', e); }
    // Calendar write side (ROADMAP #2, 2026-08-06): put the real event on
    // the Lead's calendar with the owner invited. Non-fatal by design — the
    // date is saved either way; a failure just means booking by hand.
    const calStaff = workflow.lead || workflow.account_manager;
    if (meetingCreateInvite && calStaff && supabaseClient) {
      try {
        const { data: sess } = await supabaseClient.auth.getSession();
        const at = sess && sess.session && sess.session.access_token;
        const r = await fetch('/api/se/calendar-event', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + at },
          body: JSON.stringify({
            staffName: calStaff,
            date: meetingDateInput,
            time: meetingTimeInput || null,
            title: `Valuation meeting — ${dealProfile.companyName || 'Vista Business Group'}`,
            ownerEmail: workflow.owner_email || null,
            ownerName: workflow.owner_first_name || null,
            valuationId: currentValuationId,
            inviteOwner: !!workflow.owner_email,
            // Co-owners with portal access join the invite (Adam's CanITan
            // ask 08-11: both owners on the meeting).
            extraAttendees: (Array.isArray(workflow.owner_additional) ? workflow.owner_additional : [])
              .filter(o => o && o.email).map(o => ({ email: o.email, name: o.name || null })),
          }),
        });
        const out = await r.json().catch(() => ({}));
        if (!r.ok || !out.ok) {
          window.alert(`Date saved — but the calendar invite could not be created (${out.error || 'HTTP ' + r.status}).\n\nPlease create the event on ${calStaff}'s calendar by hand this time.`);
        }
      } catch (e) {
        window.alert(`Date saved — but the calendar invite could not be created (${e?.message || e}).\n\nPlease create the event on ${calStaff}'s calendar by hand this time.`);
      }
    }
    if (currentValuationId) {
      logActivity(currentValuationId, 'stage_changed',
        'Valuation meeting date set — advanced to Valuation Meeting Set',
        { from: 'analysis_complete', to: 'val_meeting_set' });
    }
    setShowMeetingDateModal(false);
    if (onBackToList) onBackToList();
  };

  // Full-valuation "set the meeting anyway" escape hatch (2026-06-08).
  // A full val may carry lingering open items that keep the accuracy gauge
  // under 100%, so it never auto-advances to analysis_complete (analysisDone
  // requires gauge>=100 AND zero extraOpenFlags). When Colleen judges the
  // analysis done anyway — "sometimes there are lingering items, but we have
  // the meeting" — this records analysis_complete and opens the set-the-
  // meeting modal. We update local workflow state (so autosave's forward-only
  // derive keeps analysis_complete rather than re-deriving the lower stage)
  // AND write directly to Supabase (so it persists even if she picks "I'll
  // schedule with the owner," which exits without a save).
  const markAnalysisCompleteAndSetMeeting = async () => {
    if (isReadOnlyViewer) return;
    const oldStage = workflow.workflow_stage;
    if (oldStage !== 'analysis_complete') {
      if (!window.confirm(
        'Mark the analysis complete and schedule the valuation meeting?\n\n' +
        'Any remaining open items stay on the Open Items tab — you can still ' +
        'address them before the meeting.'
      )) return;
      takeEbitdaSnapshot('handoff', 'analysis complete → Lead');
      runAiReview('analysis complete');
      const nowIso = new Date().toISOString();
      setWorkflow(w => ({ ...w, workflow_stage: 'analysis_complete', stage_entered_at: nowIso }));
      setHasUnsavedChanges(true);
      try {
        if (supabaseClient && currentValuationId) {
          const tabWasCurrent = await tabIsCurrent();
          const { data: ret } = await supabaseClient.from('valuations')
            .update({ workflow_stage: 'analysis_complete', stage_entered_at: nowIso, updated_at: nowIso })
            .eq('id', currentValuationId).select('updated_at').single();
          if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
        }
      } catch (e) { console.warn('Mark-analysis-complete failed:', e); }
      if (currentValuationId) {
        logActivity(currentValuationId, 'stage_changed',
          'Analysis marked complete with open items remaining — scheduling valuation meeting',
          { from: oldStage, to: 'analysis_complete', reason: 'manual-analysis-complete' });
      }
    }
    setMeetingDateInput('');
    setShowMeetingDateModal(true);
  };

  // Visible twin of the partial confirm-on-exit prompt (Konnie 2026-07-27:
  // the prompt only fires when LEAVING the deal, so "what triggers Analysis
  // Complete on a partial?" was invisible — Air Compressor Equipment advanced
  // and nobody knew why). Same action, same semantics: mark complete, hand
  // to the Lead's plate to set the valuation meeting. Renders in the Data
  // Entered banner where Konnie works; the exit prompt stays as the catch-all.
  const markPartialAnalysisComplete = async () => {
    if (isReadOnlyViewer || !currentValuationId) return;
    if (!window.confirm(
      'Finish this partial valuation?\n\n' +
      `VT will mark the analysis complete and hand it to ${(workflow.lead || 'the Lead')} ` +
      'to set the valuation meeting.'
    )) return;
    takeEbitdaSnapshot('handoff', 'partial analysis complete → Lead');
    runAiReview('partial analysis complete');
    const oldStage = workflow.workflow_stage;
    const nowIso = new Date().toISOString();
    setWorkflow(w => ({ ...w, workflow_stage: 'analysis_complete', stage_entered_at: nowIso }));
    setHasUnsavedChanges(true);
    try {
      if (supabaseClient) {
        const tabWasCurrent = await tabIsCurrent();
        const { data: ret } = await supabaseClient.from('valuations')
          .update({ workflow_stage: 'analysis_complete', stage_entered_at: nowIso, updated_at: nowIso })
          .eq('id', currentValuationId).select('updated_at').single();
        if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
      }
    } catch (e) { console.warn('Partial-complete stage advance failed:', e); }
    logActivity(currentValuationId, 'stage_changed',
      'Partial valuation marked finished — analysis complete; Lead to set the valuation meeting',
      { from: oldStage, to: 'analysis_complete' });
  };

  // Email the owner that it's time to refresh + review their carried-forward
  // answers — sent as the Lead (server falls back to Konnie if the Lead's Gmail
  // isn't connected). The document list follows separately once Konnie curates
  // and releases it. Reads owner/lead from workflowRef so it sees the latest
  // values even when fired right after a state reset. Best-effort — never blocks.
  // (Lives in the editor component, alongside startRevalue, which calls it.)
  const sendRevalueReviewEmail = async () => {
    const w = workflowRef.current || {};
    if (!supabaseClient || !w.owner_email) return;
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) return;
      const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
      const html = buildRevalueReviewEmailHtml({
        ownerFirstName: w.owner_first_name || '',
        leadName: w.lead || '',
        companyName: (dealProfile && dealProfile.companyName) || '',
        portalUrl,
      });
      const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : [])
        .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
      await fetch('/api/gmail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({
          to: w.owner_email.trim(),
          cc: cc.length ? cc.join(', ') : undefined,
          subject: 'Continuing your Vista Business Group valuation',
          body: html,
          sender: leadGmailKey(w.lead) || 'konnie',
        }),
      });
    } catch (e) { console.warn('Revalue review email failed (non-fatal):', e); }
  };

  // Revalue — archive the current valuation, then reset the project for a
  // new cycle. The archive MUST succeed before anything is reset; if it
  // fails the function aborts with nothing changed (no data loss).
  // Data-completeness gate for revalue (Mark 2026-06-23): a revalue must not
  // start with the same gaps that left 31 projects without owner emails. Returns
  // the required fields still blank ([] = complete). Mirrors the create modal's
  // required set (owner contact + role, Lead, AM, Path, Likelihood, City/State).
  const revalueMissingFields = () => {
    const m = [];
    if (!String(workflow.owner_first_name || '').trim()) m.push('Owner first name');
    if (!String(workflow.owner_last_name || '').trim()) m.push('Owner last name');
    if (!String(workflow.owner_email || '').trim()) m.push('Owner email');
    if (!String((dealProfile && dealProfile.ownerRole) || '').trim()) m.push('Owner role');
    if (!String(workflow.lead || '').trim()) m.push('Lead');
    if (!String(workflow.account_manager || '').trim()) m.push('Account Manager');
    if (!String(workflow.path || '').trim()) m.push('Path');
    if (workflow.likelihood_pct === '' || workflow.likelihood_pct == null) m.push('Likelihood %');
    if (!String((dealProfile && dealProfile.city) || '').trim()) m.push('City');
    if (!String((dealProfile && dealProfile.state) || '').trim()) m.push('State');
    return m;
  };
  // Hard block: alerts + returns true when the project isn't complete enough to
  // revalue. Used both when opening the Start-Revalue modal and on confirm.
  const revalueBlockedByMissing = () => {
    const missing = revalueMissingFields();
    if (missing.length) {
      window.alert(
        "This project is missing required information and can't be revalued until it's complete:\n\n• "
        + missing.join('\n• ')
        + '\n\nFill it in on the Setup tab, save, then start the revalue.'
      );
      return true;
    }
    return false;
  };

  // ── Revalue: clear the current-period data (Mark 08-20 — "there would
  // be no reason to retain TTM or OLD current information; end of year yes
  // retain"). Positional TTM data under a moved cutoff isn't just stale,
  // it's misassigned; and Konnie re-pastes the full new window anyway.
  const resetCurrentPeriodData = () => {
    const zeroTtm = (cats) => (Array.isArray(cats) ? cats : []).map(c => ({
      ...c,
      cash: c.cash ? { ...c.cash, ttm: 0, ytd: 0 } : c.cash,
      accrual: c.accrual ? { ...c.accrual, ttm: 0, ytd: 0 } : c.accrual,
    }));
    setRevenueCategories(zeroTtm);
    setCogsCategories(zeroTtm);
    setOpexCategories(zeroTtm);
    setOtherIncomeCategories(zeroTtm);
    setOtherExpenseCategories(zeroTtm);
    // THE START-REVALUE BLANK SCREEN, ROOT CAUSE (Mojo 09-09, AT Technology
    // 09-10 — both Colleen): diatCategories is an OBJECT ({depreciation,
    // interest, amortization, taxes}), and zeroTtm's Array.isArray guard
    // returned [] for it — every reader of prev.depreciation.accrual then
    // hit undefined and React unmounted. The DB always stayed healthy (the
    // blob writes bypass this state), which is why reload recovered and
    // the bug looked "transient." Diat gets its own shape-preserving zero.
    setDiatCategories(prev => {
      if (!prev || Array.isArray(prev)) return prev;   // unexpected shape — leave untouched
      const z = (e) => e ? {
        ...e,
        cash: e.cash ? { ...e.cash, ttm: 0, ytd: 0 } : e.cash,
        accrual: e.accrual ? { ...e.accrual, ttm: 0, ytd: 0 } : e.accrual,
      } : e;
      return { ...prev, depreciation: z(prev.depreciation), interest: z(prev.interest), amortization: z(prev.amortization), taxes: z(prev.taxes) };
    });
    setMonthlyTtmRevenue({});
    setMonthlyTtmCogs({});
    setMonthlyTtmOpex({});
    setMonthlyTtmOtherIncome({});
    setMonthlyTtmOtherExpense({});
    setMonthlyTtmNotes({});
    setMonthlyTtmDiat({
      depreciation: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
      interest: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
      amortization: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
      taxes: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
    });
    setTtmMonthlyData({
      revenue: Array.from({ length: 12 }, (_, i) => ({ month: 'Month ' + (i + 1), amount: 0 })),
      ebitda: Array.from({ length: 12 }, (_, i) => ({ month: 'Month ' + (i + 1), amount: 0 })),
      revenueReviewNotes: '',
      ebitdaReviewNotes: '',
    });
    setTtmBsMonthLabels(() => {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const now = new Date();
      const startMonth = now.getMonth();
      let year = now.getFullYear() - 1;
      const labels = [];
      for (let i = 0; i < 12; i++) {
        const monthIdx = (startMonth + i) % 12;
        if (i > 0 && monthIdx === 0) year++;
        labels.push(monthNames[monthIdx] + ' ' + year);
      }
      return labels;
    });
    setTtmBsCurrentAssets([
      { id: 1, name: 'Cash', included: false, values: Array(12).fill(0) },
      { id: 2, name: 'Accounts Receivable', included: true, values: Array(12).fill(0) },
      { id: 3, name: 'Inventory', included: true, values: Array(12).fill(0) },
      { id: 4, name: 'Prepaid Expenses', included: true, values: Array(12).fill(0) },
    ]);
    setTtmBsFixedAssets([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsOtherAssets([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsCurrentLiabilities([
      { id: 1, name: 'Accounts Payable', included: true, values: Array(12).fill(0) },
      { id: 2, name: 'Accrued Expenses', included: true, values: Array(12).fill(0) },
      { id: 3, name: 'Short-term Debt', included: false, values: Array(12).fill(0) },
      { id: 4, name: 'Deferred Revenue', included: true, values: Array(12).fill(0) },
    ]);
    setTtmBsLongTermLiabilities([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsEquity([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setWcCustomMonths([]);
    setArAgingLineItems([{ id: 1, customerName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }]);
    setArAgingBucketLabels({ current: 'Current', days31to60: '0-30', days61to90: '31-60', days91to120: '61-90', days120plus: '91+', pastDueStartColumn: 2 });
    setArAgingData({ current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0, negativeBalances: 0, reportDate: '', totalRevenueTTM: 0, notes: '' });
    setArAgingNotes({});
    setArReviewChecklist({
      notApplicable: false,
      reportDateMatches: { checked: false, notes: '' },
      totalTiesToBS: { checked: false, notes: '' },
      noNegativeBalances: { checked: false, notes: '' },
      agingDistributionReasonable: { checked: false, notes: '' },
      noCustomerMultipleBuckets: { checked: false, notes: '' },
      over120LessThanAllowance: { checked: false, notes: '' },
      concentrationAcceptable: { checked: false, notes: '' },
      reportReviewed: false, reviewedBy: '', reviewDate: '',
    });
    setApAnalysis({ postsAPRegularly: 'unknown', totalAP: 0, reportDate: '', notes: '', trackingMode: 'notTracked' });
    setApAgingLineItems([{ id: 1, vendorName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }]);
    setApAgingBucketLabels({ current: 'Current', days31to60: '0-30', days61to90: '31-60', days91to120: '61-90', days120plus: '91+' });
    setApReviewChecklist({
      reportDateMatches: { checked: false, notes: '' },
      totalTiesToBS: { checked: false, notes: '' },
      noOldPayables: { checked: false, notes: '' },
      noConcentration: { checked: false, notes: '' },
      reportReviewed: false, reviewedBy: '', reviewDate: '',
    });
    setMonthlySalesData({});
    setCustomerSalesCash(prev => (Array.isArray(prev) ? prev : []).map(r => ({ ...r, ttm: 0 })));
    setCustomerSalesAccrual(prev => (Array.isArray(prev) ? prev : []).map(r => ({ ...r, ttm: 0 })));
    setReconVarianceStatus({});
    setReconQualityChecklist({});
    setBsVarianceStatus({});
    setIncomeVarianceStatus({});
  };

  const startRevalue = async () => {
    if (isReadOnlyViewer) { window.alert("Read-only view — Account Managers can't start a revalue."); return; }
    if (revalueBlockedByMissing()) return;
    if (!currentValuationId || !supabaseClient || !revalueDateInput) return;
    // Same Lead-meeting rule as the AM Re-engage button: a partial or cold
    // (>12mo) revalue can't skip the Lead — route it to Warm for a fresh intro
    // meeting instead of straight into the upload flow. Full + recent → light.
    const heldSynced = await fetchLastHeldMeeting(supabaseClient, currentValuationId, currentClient?.id || currentValuation?.client_id);
    const routing = computeReengageRouting({ ...workflow, last_held_meeting: heldSynced });
    // KEEP THE NEW TTM (Colleen 10-26, ComRes: "When I click start re-value, is it going to clear out the TTM data we
    // have already added as of 8/31/2026? If so, is there a way to keep it in place?"). A revalue normally clears the
    // current period for fresh numbers; when TTM figures are already entered, ask. Keep = the current period stays and
    // the AS-OF date pins to the TTM's month-end. The archive holds a full copy either way.
    const ttmEntered = [revenueCategories, cogsCategories, opexCategories].some(cats => (cats || []).some(c => (Number(c?.[selectedValuationBasis]?.ttm || c?.accrual?.ttm || c?.cash?.ttm || 0) || 0) !== 0));
    const ttmEndIso = (() => { const y = Number(monthlyTtmConfig?.endYear), m = Number(monthlyTtmConfig?.endMonth); if (!y || isNaN(m)) return ''; const d = new Date(Date.UTC(y, m + 1, 0)); return d.toISOString().slice(0, 10); })();
    let keepTtm = false;
    if (ttmEntered) {
      keepTtm = window.confirm(`This valuation already has TTM figures entered${ttmEndIso ? ' (through ' + new Date(ttmEndIso + 'T00:00:00').toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' }) + ')' : ''}.\n\nOK = KEEP them for this revalue (the new cycle starts from these numbers, as of that date).\nCancel = clear them, so the new cycle starts with an empty current period.\n\nEither way, the current valuation is archived first.`);
    }
    setRevalueBusy(true);
    try {
      // 1. Read the prior valuation to archive.
      const { data: priorRow, error: readErr } = await supabaseClient
        .from('valuations')
        .select('data, valuation_date, value_provided_low, value_provided_high')
        .eq('id', currentValuationId)
        .single();
      if (readErr || !priorRow) throw readErr || new Error('Could not read the valuation to archive.');

      // 2. Archive it — must succeed before any reset happens.
      const { error: archiveErr } = await supabaseClient
        .from('valuation_revisions')
        .insert({
          valuation_id: currentValuationId,
          valued_date: priorRow.valuation_date || null,
          value_low: multipleEngineCalcs?.valuationTypical ?? priorRow.value_provided_low ?? null,
          value_high: multipleEngineCalcs?.valuationMarketHigh ?? priorRow.value_provided_high ?? null,
          data: priorRow.data,
        });
      if (archiveErr) throw archiveErr;
      setCapexMethodSaved('fcf');   // a revalue moves to the free-cash-flow basis (10-20)
      setGrowthTestSaved('ttm');    // and to the TTM growth test (10-21)
      setPayrollTaxMethodSaved('wage_base');   // and to the accurate payroll tax (10-22)
      setSpikeMathSaved('consistent');   // and to the consistent spike math (10-28)
      setRevenueScoringSaved('mrr');   // archived → this revalue leaves the grandfathered (legacy) revenue scoring (Mark 10-06)

      // 3. Archive succeeded — reset the progress signals for the new cycle.
      // adjustmentItems and sellerQA intentionally carry forward (revised
      // 2026-05-27). A revalue often lands within 30 days; the prior add-
      // backs are often substantially valid and re-deriving them is real
      // work — Colleen reviews/edits or clears as needed. Q&A answers
      // carry forward so the owner reviews their prior answers rather than
      // starting from scratch. adjustmentsStatus reset to not_started is
      // the dashboard's "needs review" signal even when data remains.
      // A new cycle gets the CURRENT document template, not a status-reset of
      // whatever list the file carried (Konnie 08-20, Forward Slash: a
      // legacy-JSON import kept its old-era checklist through the revalue —
      // wrong items to curate). Fresh statuses, no planned flags — her
      // curation pass decides what this cycle needs.
      setDocumentChecklist(DEFAULT_DOCUMENT_CHECKLIST.map(d => ({ ...d })));
      if (!keepTtm) resetCurrentPeriodData();
      // Stage C: clear the prior cycle's ShareFile "Received" stamps on the
      // checklist table. These columns aren't written by the normal save, so
      // without this they'd linger into the new cycle as stale Received badges /
      // worklist entries. New uploads (or staff re-checking) re-stamp them.
      try {
        await supabaseClient.from('engagement_checklist_items')
          .update({ sharefile_received_at: null, sharefile_file_id: null, ai_classification_confidence: null })
          .eq('engagement_id', currentValuationId);
      } catch (e) { console.warn('Revalue: clearing ShareFile received signals failed:', e); }
      // Portal-driven revalue flags (both server-owned). Written directly, NOT
      // via the workflow-column autosave map, so a parallel staff save — e.g.
      // Konnie curating docs — can never resurrect a flag just cleared:
      //   • revalue_review_pending → portal shows "refresh, review & update" +
      //     expanded answers; cleared in /api/portal/questions-done.
      //   • revalue_docs_pending → Konnie's "Review docs required" card; cleared
      //     when she releases the curated list (which sends the docs-ready email).
      const flagsIso = new Date().toISOString();
      try {
        const { data: flagRet } = await supabaseClient.from('valuations')
          .update({
            revalue_review_pending: true, revalue_docs_pending: routing.skipMeeting,
            // The stage move + cycle reset write DIRECTLY too (Secured
            // Retail 08-31: the archive and flags persisted but this batch
            // rode the autosave and never landed — tab closed too soon —
            // leaving a flagged revalue stuck at val_complete_inactive,
            // invisible everywhere). A critical transition never rides the
            // autosave; the setWorkflow below only keeps the open page in
            // sync.
            workflow_stage: routing.skipMeeting ? 'awaiting_upload' : 'warm',
            stage_entered_at: flagsIso,
            committed_upload_date: routing.skipMeeting ? revalueDateInput : null,
            portal_docs_released: false,
            upload_started_date: null, upload_complete_date: null,
            valuation_date: null, next_meeting_date: null, next_meeting_type: null,
            as_of_date: keepTtm && ttmEndIso ? ttmEndIso : null,   // kept TTM → pinned to its month-end (10-26)
            updated_at: flagsIso,
          })
          .eq('id', currentValuationId)
          .select('updated_at')
          .single();
        // Keep the conflict-detection baseline current so the autosave that
        // follows (workflow reset) doesn't see this write as a foreign edit.
        if (flagRet?.updated_at) loadedUpdatedAtRef.current = flagRet.updated_at;
      } catch (e) { console.warn('Revalue: setting review/docs-pending flags failed:', e); }
      setAdjustmentsStatus('not_started');
      setRevalueReviewPending(true);
      const nowIso = new Date().toISOString();
      setWorkflow(w => ({
        ...w,
        // Skip-eligible → straight into the upload flow. Meeting-required (partial
        // or cold) → Warm, where the intro→activate lifecycle runs (the committal
        // date is set later, at activation).
        workflow_stage: routing.skipMeeting ? 'awaiting_upload' : 'warm',
        stage_entered_at: nowIso,
        committed_upload_date: routing.skipMeeting ? revalueDateInput : '',
        // Docs gate CLOSED until Konnie curates + releases the new cycle's list
        // (revalue docs are tailored, not the full first-time checklist).
        portal_docs_released: false,
        upload_started_date: '',
        upload_complete_date: '',
        valuation_date: '',
        next_meeting_date: '',
        next_meeting_type: '',
        // New cycle → the AS-OF anchor resets to fully-automatic (auto-advance
        // resumes until this cycle's first upload); books lag carries over —
        // how fast they close books is a fact about the business, not a cycle.
        as_of_date: keepTtm && ttmEndIso ? ttmEndIso : '',
      }));
      setHasUnsavedChanges(true);
      logActivity(currentValuationId, 'revalue_started',
        routing.skipMeeting
          ? 'Revalue started — prior valuation archived, project reset for a new cycle'
          : 'Re-engagement started — archived; routed to a new introductory meeting (Warm)',
        { committed_upload_date: routing.skipMeeting ? revalueDateInput : null, skip_meeting: routing.skipMeeting });
      setShowRevalueModal(false);
      // Skip path: open the review-and-send modal for the "review your answers"
      // email (staff see + can edit it). Meeting path: the AM sends the intro
      // from the Warm section instead.
      if (routing.skipMeeting) {
        const w = workflowRef.current || {};
        if (w.owner_email) {
          const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
          const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : [])
            .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
          setPendingEmail({
            heading: 'Send: review your answers',
            to: w.owner_email.trim(), cc,
            subject: 'Continuing your Vista Business Group valuation',
            sender: leadGmailKey(w.lead) || 'konnie',
            defaultBody: revalueReviewBodyText({ ownerFirstName: w.owner_first_name, companyName: (dealProfile && dealProfile.companyName) || '' }),
            buildHtml: (b, signer) => buildRevalueReviewEmailHtml({ leadName: signer || w.lead, portalUrl, bodyText: b }),
          });
        }
      } else {
        window.alert('This is a partial or cold (>12 months) re-engagement, so it needs a fresh introductory meeting. It has been moved to Warm — open the Warm section (as the AM) to send the intro email; the Lead activates after the meeting.');
      }
    } catch (e) {
      console.error('Start Revalue failed:', e);
      window.alert('Start Revalue failed — nothing was changed.\n\n' + (e?.message || ''));
    } finally {
      setRevalueBusy(false);
    }
  };

  // 🗓 Schedule the revalue for later (Mark 09-16): the "not yet" path. Sets a
  // reminder on the chosen date and changes NOTHING else — no archive, no reset,
  // no stage move — so the deal stays exactly where it is (e.g. strategic review
  // scheduled) and never drops into the document pipeline / Konnie's plate until
  // someone comes back and actually starts it. This is what Charter needed.
  const scheduleRevalue = async () => {
    if (isReadOnlyViewer) { window.alert("Read-only view — Account Managers can't schedule a revalue."); return; }
    if (!currentValuationId || !supabaseClient || !revalueDateInput) return;
    setRevalueBusy(true);
    try {
      const { error } = await supabaseClient.from('project_reminders').insert({
        project_id: currentValuationId,
        actor_email: userEmail || null,
        remind_at: revalueDateInput,
        note: 'Start the revalue — open Setup → ↻ Start Revalue (Start now) when the owner is ready to begin the cycle.',
      });
      if (error) throw error;
      logActivity(currentValuationId, 'revalue_scheduled',
        `Revalue scheduled for ${revalueDateInput} — reminder set; nothing started, deal left as-is (not in the document pipeline)`,
        { remind_at: revalueDateInput });
      setShowRevalueModal(false);
      window.alert(`Reminder set for ${revalueDateInput}. Nothing was archived or moved — the deal stays where it is and out of the document pipeline. You'll be reminded on that date to come back and Start now.`);
    } catch (e) {
      console.error('Schedule revalue failed:', e);
      window.alert('Could not set the reminder: ' + (e?.message || ''));
    } finally {
      setRevalueBusy(false);
    }
  };

  // Revalue doc-curation release (piece 2): after Konnie reviews the file and
  // checks the boxes for what this cycle needs, she releases the list. This
  // opens the owner's portal documents (portal_docs_released → true), clears the
  // pending flag (off her My-Work card), and emails the owner that the list is
  // ready — from the Lead (fallback Konnie), the same message activation sends.
  // Release the curated revalue doc list. Opens the review-and-send modal for the
  // docs-ready email; the actual release (open the portal docs + clear the flag)
  // commits in onSent, AFTER the email sends — so the owner is never given access
  // without the notification, and cancelling leaves the project re-releasable.
  // Open the owner's portal exactly as they see it. Hits the staff-gated
  // /api/portal/staff-preview (Bearer auth) which mints a short-lived READ-ONLY
  // portal session cookie, then opens /portal in a new tab. (Mark 2026-06-24)
  const viewOwnerPortal = async () => {
    if (!currentValuationId) return;
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const at = session && session.access_token;
      if (!at) { window.alert('Your session expired — reload and sign in again.'); return; }
      const resp = await fetch(`/api/portal/staff-preview?engagement=${encodeURIComponent(currentValuationId)}`, {
        headers: { Authorization: 'Bearer ' + at }, credentials: 'same-origin',
      });
      const r = await resp.json().catch(() => ({}));
      if (resp.ok && r.ok) { window.open('/portal', '_blank', 'noopener'); }
      else { window.alert('Could not open the owner portal preview: ' + (r.error || ('HTTP ' + resp.status))); }
    } catch (e) { window.alert('Could not open the preview: ' + (e?.message || '')); }
  };

  // Owner portal answers are pulled once on valuation OPEN (load), so a freshly
  // submitted answer won't appear until the deal is reopened. This re-fetches on
  // demand so staff can pull new answers without reloading. (Mark/Colleen 2026-06-29)
  const [refreshingOwnerAnswers, setRefreshingOwnerAnswers] = useState(false);
  const refreshOwnerAnswers = async () => {
    if (!currentValuationId || !supabaseClient) return;
    setRefreshingOwnerAnswers(true);
    try {
      const { data: oaRows } = await supabaseClient
        .from('owner_question_responses')
        .select('question_type, question_key, answer, answered_at')
        .eq('engagement_id', currentValuationId);
      setOwnerPortalAnswers(oaRows || []);
    } catch (e) {
      console.warn('Refresh owner answers failed:', e);
    } finally {
      setRefreshingOwnerAnswers(false);
    }
  };

  // Release the document list to the owner portal AND email them it's ready —
  // review-and-send (staff edit before it goes). Works for BOTH a first-time
  // release and a revalue-curated release; the only difference is the log wording
  // and clearing the revalue-pending gate. Replaces the old silent checkbox as the
  // primary release action so the owner always gets told. (2026-07-02)
  // ✉ RESEND PORTAL LINK (Colleen 10-23/10-26: "several requests from clients to have the link to the portal resent ...
  // Is Konnie the only one with access to resend those links?"). Anyone on staff, any stage: a short review-and-send
  // email with the portal button (the owner's email pre-filled), from the clicker's own mailbox by default.
  const resendPortalLink = () => {
    if (isReadOnlyViewer || !currentValuationId) return;
    const w = workflowRef.current || {};
    const to = String(w.owner_email || '').trim();
    if (!to) { window.alert('Add an owner email first.'); return; }
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal#e=' + encodeURIComponent(to);
    const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : []).map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    const fn = String(w.owner_first_name || '').trim();
    const me = String(userEmail || '').split('@')[0];
    const signer = me ? me.charAt(0).toUpperCase() + me.slice(1) : 'Vista Business Group';
    setPendingEmail({
      heading: 'Resend the portal link — review & send',
      to, cc,
      subject: 'Your secure Vista Business Group portal link',
      sender: me || 'konnie',
      defaultBody: (fn ? 'Hi ' + fn + ',' : 'Hello,') + '\n\nHere is your secure portal link. Click the button below and enter your email address (' + to + '); you will get a one-click sign-in link, no password needed.\n\nYou can upload anything new there, and see your document list and questions.\n\nThank you,',
      buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: signer, portalUrl }),
      onSent: async () => { try { logActivity(currentValuationId, 'outreach', 'Portal link resent to the owner', { kind: 'portal_link_resent' }); } catch (e) { /* the email went */ } },
    });
  };

  const releaseDocsToOwner = () => {
    if (isReadOnlyViewer) return;
    if (!currentValuationId || !supabaseClient) return;
    const w = workflowRef.current || {};
    if (!w.owner_email) { window.alert('Add an owner email before releasing — they need the portal link.'); return; }
    const isRevalue = !!revalueDocsPending;
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
    const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : [])
      .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    setPendingEmail({
      heading: 'Release documents — review & send',
      to: w.owner_email.trim(), cc,
      subject: 'Your Vista Business Group document list is ready',
      sender: 'konnie', senderFixed: true, // document-flow → Konnie; the body introduces her (2026-07-23)
      defaultBody: docsReadyBodyText({ ownerFirstName: w.owner_first_name, companyName: (dealProfile && dealProfile.companyName) || '', committalDate: w.committed_upload_date, leadName: w.lead }),
      buildHtml: (b) => buildDocsReadyEmailHtml({ leadName: w.lead, portalUrl, bodyText: b }),
      onSent: async () => {
        const nowIso = new Date().toISOString();
        try {
          const tabWasCurrent = await tabIsCurrent();
          const { data: ret } = await supabaseClient.from('valuations')
            .update({ portal_docs_released: true, revalue_docs_pending: false, updated_at: nowIso })
            .eq('id', currentValuationId).select('updated_at').single();
          if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
          setWorkflow(wf => ({ ...wf, portal_docs_released: true }));
          setRevalueDocsPending(false);
          logActivity(currentValuationId, 'stage_changed',
            isRevalue ? 'Revalue document list curated + released to the owner portal'
                      : 'Document list released to the owner portal + owner emailed',
            { released_docs: true, revalue: isRevalue });
        } catch (e) {
          console.error('Release after email failed:', e);
          window.alert('The email sent, but opening the documents failed: ' + (e?.message || '') + '\nFlip the “Release document list” toggle on Setup to finish.');
        }
      },
    });
  };

  // Revalue doc-review gate: clear WITHOUT releasing — this cycle's documents
  // are being handled outside the portal-release flow (Konnie 2026-07-28).
  // Restores the normal Setup release controls; nothing changes in the portal.
  const skipRevalueCuration = async () => {
    if (isReadOnlyViewer || !currentValuationId || !supabaseClient) return;
    if (!window.confirm('Clear the revalue doc-review gate without releasing? Use this when the cycle doesn\'t need a curated portal release. The owner\'s document list stays exactly as it is, and the normal release controls come back.')) return;
    const nowIso = new Date().toISOString();
    try {
      const tabWasCurrent = await tabIsCurrent();
      const { data: ret, error } = await supabaseClient.from('valuations')
        .update({ revalue_docs_pending: false, updated_at: nowIso })
        .eq('id', currentValuationId).select('updated_at').single();
      if (error) throw error;
      if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
      setRevalueDocsPending(false);
      logActivity(currentValuationId, 'stage_changed',
        'Revalue doc-review gate cleared — no curated release needed this cycle',
        { revalue_docs_pending_cleared: true, via: 'setup_tab' });
    } catch (e) {
      console.error('Skip revalue curation failed:', e);
      window.alert('Could not clear the gate: ' + (e?.message || 'unknown error'));
    }
  };

  // ===== Stage Engine — workflow_stage derived from real events =====
  // workflow_stage is a function of work staff already do (documents
  // received, data entered, adjustments added, meeting scheduled) — nobody
  // maintains it by hand. deriveWorkflowStage runs on every save and is
  // FORWARD-ONLY: it can advance a project but never pull it backward, which
  // protects CSV-imported projects whose stage was set by import rather than
  // derived from current checklist data.
  const AUTO_SPINE = [
    'awaiting_upload', 'upload_started', 'upload_complete',
    'data_entry_complete', 'adjustments_entered', 'analysis_complete',
    'val_meeting_set', 'awaiting_decision',
  ];

  // The owner-decision panel (engage / strategic review / not ready / not for
  // sale) shows on the active spine AND on the two inactive terminal states.
  // An owner who said "not now" or "not for sale" can come back and engage —
  // that reversal is exactly the kind of unobservable human decision these
  // buttons exist to record, so the panel stays reachable after the fact.
  const DECISION_PANEL_STAGES = [...AUTO_SPINE, 'considering_followup', 'val_complete_inactive', 'val_complete_dead'];
  // Engage / strategic-review / considering-follow-up all presuppose a
  // delivered valuation: the post-meeting stages, plus the active-considering
  // and inactive states reached after one.
  const OWNER_CHOICE_STAGES = ['val_meeting_set', 'awaiting_decision', 'considering_followup', 'val_complete_inactive', 'val_complete_dead'];

  // The furthest auto-spine stage the project's data proves it has reached.
  const deriveAutoSpineStage = () => {
    const checklist = Array.isArray(documentChecklist) ? documentChecklist : [];
    const planned = checklist.filter(d => d.planned);
    // Documents the owner was actually asked for: the planned subset if
    // Konnie marked one at discovery, otherwise the whole checklist.
    const relevant = planned.length > 0 ? planned : checklist;

    // The Discovery Questionnaire (id 13) is satisfied by answering the portal
    // questions, NOT by uploading a document (questions-done auto-marks it
    // 'complete'). It must not count as a received document, or finishing the
    // questions would falsely advance the project to upload_started before any
    // real upload. (Mark 2026-06-26)
    const anyReceived  = checklist.some(d => d.id !== 13 && d.status && d.status !== 'not_received');
    // "Not provided at this time" (Mark 09-16): an honest middle state that lets
    // a deal be made available to Colleen WITHOUT faking "Complete" on a doc the
    // owner hasn't sent. It satisfies the advancement gate (deal moves) but is
    // NOT 'complete', so it never counts as received — accuracy stays <100% until
    // the doc actually arrives. Guard: still require at least one real complete
    // doc so a deal never advances with nothing in.
    const resolvedForAdvance = (d) => d.status === 'complete' || d.status === 'not_provided';
    const uploadDone   = planned.length > 0 && planned.every(resolvedForAdvance) && planned.some(d => d.status === 'complete');
    // "Complete" on the docTracker dropdown means received + entered + verified
    // — staff mark it only after entering the data and confirming it works.
    // Pre-Stage-C there is no independent Received signal, so upload_complete
    // and data_entry_complete coincide; Stage C's ShareFile ingestion adds the
    // separate Received signal (data_entered_at, migration 007) and splits them.
    const allEntered   = relevant.length > 0 && relevant.every(resolvedForAdvance) && relevant.some(d => d.status === 'complete');
    // Explicit signal (Task 13): Colleen marks the Adjustments section
    // "Complete" on the Adjustments tab. Replaces the old
    // adjustmentItems.length heuristic — zero adjustments is legitimate,
    // and stale prior-cycle rows could derive a false adjustments_entered.
    const hasAdjust    = adjustmentsStatus === 'complete';
    // Full valuation: analysis is complete once the accuracy gauge reaches
    // 100% — that means all documents entered, all questions answered, and
    // all of Colleen's flagged items addressed. Partials have no gauge and
    // reach analysis_complete via the confirm-on-exit prompt instead.
    // Guard: also require zero open trend / roll-off flags. The accuracy
    // gauge currently undercounts those (it's computed before they exist —
    // see HANDOFF follow-up), so this backstops a false 100%.
    const analysisDone = workflow.path === 'full_valuation'
      && Math.round(accuracyGauge?.overallScore || 0) >= 100
      && extraOpenFlags.length === 0
      // CapEx gate (Zac 2026-07-31, option C): an open CapEx Investigation on
      // an asset-heavy deal blocks analysis-complete — it must be resolved or
      // deliberately waived (with the required written reason) first.
      && (() => { try {
        return !(outstandingAnalysis.unacknowledgedFlags || []).some(f => f.key === 'capex-investigation');
      } catch (e) { return true; } })()
      // OPEN RESEARCH ITEMS block it (Colleen 10-19, Initial IT: 8 questions out to the owner since 10-13, the
      // gauge read 100% anyway and the deal jumped to Analysis complete on 10-16). The gauge doesn't count
      // questions awaiting the owner, so check the same "open" list her Research Items table shows.
      && (researchItems || []).filter(r => r.status !== 'complete' && !r.reviewerNote).length === 0;
    // The Valuation Date field being filled is the signal that the valuation
    // was delivered — the project is past the valuation meeting and the owner
    // is now deciding. next_meeting_type is free text; "val" matches
    // "Valuation" / "Val Mtg".
    // BACKDATED-DATE GUARD (Konnie/Blue Spruce 09-09: porting a returning
    // client's history, she briefly entered the 2025 Zoho valuation date —
    // the ratchet read it as THIS cycle's delivery and jumped the fresh
    // revalue to awaiting_decision; clearing the date couldn't undo it,
    // because the ratchet is forward-only by design). A valuation date
    // from BEFORE this deal was created is imported history, not a
    // delivery — it never drives the spine.
    const createdDay = workflow.created_at ? String(workflow.created_at).slice(0, 10) : null;
    const hasValuationDate    = !!workflow.valuation_date
      && (!createdDay || workflow.valuation_date >= createdDay);
    const valMeetingScheduled = !!workflow.next_meeting_date && /val/i.test(workflow.next_meeting_type || '');

    // Skip partials (2026-06-08): no Colleen review, no analyst-side analysis
    // — once everything's entered it's ready for the Lead to set the valuation
    // meeting, so it jumps past the Colleen stages straight to analysis_complete.
    const isPartialSkip = workflow.path === 'partial' && workflow.colleen_review_decision === 'skip';

    if (hasValuationDate)        return 'awaiting_decision';
    if (valMeetingScheduled)     return 'val_meeting_set';
    if (analysisDone)            return 'analysis_complete';
    // KONNIE'S DATA-ENTRY STEP (Mark 09-28, Forward Slash): every requested
    // doc marked Complete means the documents are IN — Konnie marks Complete
    // on receipt — not that the data is entered. Since July all 28 deals
    // jumped straight to data_entry_complete (Colleen's plate) and none ever
    // stopped here. The deal now waits at Upload Complete (Konnie's plate)
    // until she clicks ✓ Data entered, which advances it by hand (partial
    // skips → analysis_complete). Colleen marking Adjustments Complete still
    // advances past it (entry is evidently done).
    if (hasAdjust)               return 'adjustments_entered';
    if (allEntered)              return 'upload_complete';
    if (uploadDone)          return 'upload_complete';
    if (anyReceived)         return 'upload_started';
    return 'awaiting_upload';
  };

  // Forward-only ratchet: returns the derived stage only when it is strictly
  // ahead of the current stage on the spine. Terminal / human-event stages
  // (engaged, strategic_review_set, considering_followup, val_complete_*,
  // stalled_returned_to_am) are never auto-derived — recorded as facts elsewhere.
  const deriveWorkflowStage = (currentStage) => {
    if (!AUTO_SPINE.includes(currentStage)) return currentStage;
    const derived = deriveAutoSpineStage();
    return AUTO_SPINE.indexOf(derived) > AUTO_SPINE.indexOf(currentStage)
      ? derived : currentStage;
  };

  // Returns the workflow columns to merge into valuationRow on save.
  const buildWorkflowColumns = () => {
    const blankToNull = (v) => (v === '' || v === undefined ? null : v);
    // Open-items counts for the dashboard "Open Items" column. The canonical
    // VT open-items state is outstandingAnalysis (declared later in the
    // component body — in scope by closure at save time). We exclude
    // category 'Document' flags because documents are tracked separately
    // via the checklist / Docs Outstanding column.
    let openItemsOpen = null, openItemsResolved = null;
    try {
      if (outstandingAnalysis && Array.isArray(outstandingAnalysis.unacknowledgedFlags)) {
        // Include the trend / roll-off flags (extraOpenFlags) — none are
        // 'Document' category, so all count toward the non-document total.
        openItemsOpen = outstandingAnalysis.unacknowledgedFlags.filter(f => f.category !== 'Document').length
          + (Array.isArray(extraOpenFlags) ? extraOpenFlags.length : 0);
        openItemsResolved = (outstandingAnalysis.acknowledgedFlagsList || []).filter(f => f.category !== 'Document').length;
      }
    } catch (e) { /* leave null — non-fatal */ }

    // Owner-question counts for Colleen's My Work cards (2026-06-08).
    // to-send = Ask-Owner items not yet emailed; awaiting = emailed (sentAt
    // stamped by sendOwnerQuestions) but not yet resolved/answered.
    let questionsToSend = null, questionsAwaiting = null;
    // Owner-answer signal: an Ask-Owner question the owner has ANSWERED in the
    // portal but Colleen hasn't accepted yet (still-open research item + a
    // matching portal answer with content). The server sets this true when a
    // fresh answer lands; here we recompute on save so accepting the answer
    // (which marks the item complete) clears it. (2026-06-24)
    let ownerAnswerUnreviewed = false;
    try {
      const oq = (researchItems || []).filter(r => (r.askOwner || r.status === 'ask_owner') && r.status !== 'complete');
      questionsToSend   = oq.filter(r => !r.sentAt).length;
      questionsAwaiting = oq.filter(r => !!r.sentAt).length;
      ownerAnswerUnreviewed = oq.some(r => (ownerPortalAnswers || []).some(a =>
        a.question_type === 'adhoc'
        && String(a.question_key) === String(r.id)
        && a.answer != null && String(a.answer).trim()));
    } catch (e) { /* leave defaults — non-fatal */ }

    // Stage Engine: derive workflow_stage from real events. Forward-only —
    // advances a project but never regresses it. On an advance, stamp a
    // fresh stage_entered_at and log the transition.
    const currentStage = workflow.workflow_stage || 'awaiting_upload';
    const derivedStage = deriveWorkflowStage(currentStage);
    const stageAdvanced = derivedStage !== currentStage;
    const stageEnteredAt = stageAdvanced
      ? new Date().toISOString()
      : (workflow.stage_entered_at || new Date().toISOString());
    if (stageAdvanced) {
      // Sync local state so the UI and subsequent saves see the new stage.
      setWorkflow(w => ({ ...w, workflow_stage: derivedStage, stage_entered_at: stageEnteredAt }));
      if (currentValuationId) {
        logActivity(currentValuationId, 'stage_changed', null,
          { from: currentStage, to: derivedStage, derived: true });
      }
    }

    return {
      workflow_stage: derivedStage,
      path: blankToNull(workflow.path),
      buyside: !!workflow.buyside,
      colleen_review_decision: blankToNull(workflow.colleen_review_decision),
      lead: blankToNull(workflow.lead),
      account_manager: blankToNull(workflow.account_manager),
      likelihood_pct: (workflow.likelihood_pct === '' || workflow.likelihood_pct == null) ? null : Number(workflow.likelihood_pct),
      first_meeting_date: blankToNull(workflow.first_meeting_date),
      discovery_meeting_date: blankToNull(workflow.discovery_meeting_date),
      committed_upload_date: blankToNull(workflow.committed_upload_date),
      owner_target_valuation_date: blankToNull(workflow.owner_target_valuation_date),
      upload_started_date: blankToNull(workflow.upload_started_date),
      upload_complete_date: blankToNull(workflow.upload_complete_date),
      valuation_date: blankToNull(workflow.valuation_date),
      // #3 remainder (2026-08-06): signature + CIM-finish record dates.
      // Requires migration 055 — apply BEFORE deploying this build.
      engagement_signed_date: blankToNull(workflow.engagement_signed_date),
      cim_complete_date: blankToNull(workflow.cim_complete_date),
      next_meeting_date: blankToNull(workflow.next_meeting_date),
      next_meeting_type: blankToNull(workflow.next_meeting_type),
      snooze_until: blankToNull(workflow.snooze_until),
      snooze_reason: blankToNull(workflow.snooze_reason),
      as_of_date: blankToNull(workflow.as_of_date),
      books_lag_months: Math.max(1, Math.min(6, Number(workflow.books_lag_months) || 1)),
      stage_entered_at: stageEnteredAt,
      open_items_open: openItemsOpen,
      open_items_resolved: openItemsResolved,
      questions_to_send: questionsToSend,
      questions_awaiting: questionsAwaiting,
      owner_answer_unreviewed: ownerAnswerUnreviewed,
      owner_first_name: blankToNull(workflow.owner_first_name),
      owner_last_name: blankToNull(workflow.owner_last_name),
      owner_email: blankToNull(workflow.owner_email),
      // Persist only complete {name,email}-or-email rows; [] saves as null.
      owner_additional: (() => {
        const cleaned = (workflow.owner_additional || [])
          .map(o => ({ name: (o.name || '').trim(), email: (o.email || '').trim() }))
          .filter(o => o.email);
        return cleaned.length > 0 ? cleaned : null;
      })(),
      // Owner portal: snapshot the live confidence gauge + the docs-released
      // gate so the portal can read them without re-deriving (closure captures
      // accuracyGauge, which is initialized by save time).
      accuracy_pct: (accuracyGauge && accuracyGauge.overallScore != null) ? Math.round(accuracyGauge.overallScore) : null,
      accuracy_tier: (accuracyGauge && accuracyGauge.tier) || null,
      portal_docs_released: !!workflow.portal_docs_released,
    };
  };

  // Fiscal Year Formatting Helpers
  const fiscalYearHelpers = useMemo(() => {
    const fyEndMonth = dealProfile?.fiscalYearEndMonth || 12;
    const isCalendarYear = fyEndMonth === 12;
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthNamesFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    // For a fiscal year ending in month M, the fiscal year "FY2024" runs from 
    // Month M+1 of 2023 through Month M of 2024
    // e.g., June year-end: FY2024 = Jul 2023 - Jun 2024
    const getFiscalYearRange = (year) => {
      if (!year) return { start: '', end: '', label: year || '', fullLabel: year || '' };
      const yearNum = parseInt(year);
      if (isNaN(yearNum)) return { start: '', end: '', label: String(year), fullLabel: String(year) };
      
      if (isCalendarYear) {
        return { 
          start: `Jan ${yearNum}`, 
          end: `Dec ${yearNum}`, 
          label: String(yearNum),
          fullLabel: String(yearNum)
        };
      }
      
      const startMonth = fyEndMonth % 12; // Month after FY end is start of next FY
      const startYear = yearNum - 1;
      const endYear = yearNum;
      
      return {
        start: `${monthNames[startMonth] || 'Jan'} ${String(startYear).slice(-2)}`,
        end: `${monthNames[(fyEndMonth - 1 + 12) % 12] || 'Dec'} ${String(endYear).slice(-2)}`,
        label: `FY${yearNum}`,
        fullLabel: `FY${yearNum} (${monthNames[startMonth] || 'Jan'} ${String(startYear).slice(-2)} - ${monthNames[(fyEndMonth - 1 + 12) % 12] || 'Dec'} ${String(endYear).slice(-2)})`
      };
    };
    
    // Format a year label with fiscal year context
    const formatYearLabel = (year, options = {}) => {
      if (!year) return year;
      const { showRange = false, compact = false } = options;
      if (year === 'TTM' || year === 'YTD') return year;
      
      const range = getFiscalYearRange(year);
      if (isCalendarYear) return String(year);
      
      if (compact) return range.label;
      if (showRange) return range.fullLabel;
      return range.label;
    };
    
    // Get the fiscal year period description
    const getFiscalPeriodDesc = () => {
      if (isCalendarYear) return 'Calendar Year (Jan - Dec)';
      return `Fiscal Year (${monthNamesFull[(fyEndMonth - 1 + 12) % 12] || 'December'} year-end)`;
    };
    
    return {
      isCalendarYear,
      fyEndMonth,
      monthNames,
      getFiscalYearRange,
      formatYearLabel,
      getFiscalPeriodDesc
    };
  }, [dealProfile?.fiscalYearEndMonth]);

  // ========== MARKET CONDITION ADJUSTMENT ==========
  const [marketCondition, setMarketCondition] = useState({
    name: 'Normal Market (2024)',
    adjustment: 0,
    notes: 'Current market conditions'
  });

  // ========== BUSINESS MODEL ==========
  const [businessModel, setBusinessModel] = useState({
    businessType: '',
    productService: '',
    salesChannel: '',
    customerType: '',
    industriesServed: '',
    geographicScope: '',
    geographicDetail: '',
    descriptionOverride: ''
  });

  // ========== EDITABLE BASE MULTIPLE TABLE ==========
  const [baseMultipleTable, setBaseMultipleTable] = useState([
    { ebitda: 50000, multiple: 1.0 },
    { ebitda: 100000, multiple: 1.5 },
    { ebitda: 150000, multiple: 2.0 },
    { ebitda: 200000, multiple: 2.5 },
    { ebitda: 300000, multiple: 3.0 },
    { ebitda: 500000, multiple: 3.5 },
    { ebitda: 750000, multiple: 4.25 },
    { ebitda: 1000000, multiple: 5.0 },
    { ebitda: 1500000, multiple: 5.5 },
    { ebitda: 2000000, multiple: 6.0 },
    { ebitda: 3000000, multiple: 7.0 },
    { ebitda: 4000000, multiple: 8.0 },
    { ebitda: 5000000, multiple: 9.0 },
    { ebitda: 7500000, multiple: 10.0 },
    { ebitda: 10000000, multiple: 11.0 }
  ]);
  
  // Industry base multiple adjustment (hidden from client view)
  const [industryMultipleAdjustment, setIndustryMultipleAdjustment] = useState(0.75);
  const [showInternalControls, setShowInternalControls] = useState(true);
  
  // Location adjustment (calculated from location type and EBITDA)
  const [locationMultipleAdjustment, setLocationMultipleAdjustment] = useState(0);

  // ========== INDUSTRY SECTORS & INDUSTRIES DATABASE ==========
  const industrySectors = [
    {
      id: 'technology',
      name: 'Technology & IT Services',
      industries: [
        { id: 'it-msp', name: 'IT Managed Services Provider (MSP)', adjustment: 0.75, benchmarks: { recurringRevenuePct: 65, revenueYoYVariance: 8, customerRetentionRate: 92, ebitdaMargin: 18, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 8.5 } },
        { id: 'it-mssp', name: 'Managed Security Services (MSSP)', adjustment: 0.50, benchmarks: { recurringRevenuePct: 75, revenueYoYVariance: 10, customerRetentionRate: 94, ebitdaMargin: 22, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 10, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 12 } },
        { id: 'it-var', name: 'IT Value Added Reseller (VAR)', adjustment: 0, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 15, customerRetentionRate: 78, ebitdaMargin: 8, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 3.5 } },
        { id: 'it-staffing', name: 'IT Staffing / Recruiting', adjustment: -0.15, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 18, customerRetentionRate: 75, ebitdaMargin: 6, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 25, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 4 } },
        { id: 'it-staff-aug', name: 'IT Staff Augmentation', adjustment: 0.10, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 12, customerRetentionRate: 82, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 7 } },
        // adjustment -0.50 (Zac 10-08, Workstate review P5: dev shops trade below MSPs; AI-era enterprise
        // budget tightening). adjustmentLegacy = what valuations presented before the change keep.
        { id: 'it-dev', name: 'IT Development / Consulting', adjustment: -0.50, adjustmentLegacy: 0, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 12, customerRetentionRate: 80, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 5 } },
        { id: 'it-niche', name: 'Niche / Vertical IT Services', adjustment: 0.15, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 10, customerRetentionRate: 88, ebitdaMargin: 16, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 6 } },
        { id: 'it-telecom', name: 'Telecom / ISP / CLEC / WISP', adjustment: 0.50, benchmarks: { recurringRevenuePct: 85, revenueYoYVariance: 8, customerRetentionRate: 90, ebitdaMargin: 22, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 10, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 6 } },
        { id: 'it-hosting', name: 'Managed Hosting / Data Center / Colocation', adjustment: 0.60, benchmarks: { recurringRevenuePct: 90, revenueYoYVariance: 8, customerRetentionRate: 92, ebitdaMargin: 25, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 10, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 12 } },
        { id: 'saas', name: 'SaaS / Software Products', adjustment: 0.50, benchmarks: { recurringRevenuePct: 90, revenueYoYVariance: 8, customerRetentionRate: 90, ebitdaMargin: 25, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 10, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 15 } },
        { id: 'healthcare-it', name: 'Healthcare IT Services', adjustment: 0.35, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 8, customerRetentionRate: 93, ebitdaMargin: 18, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 10 } },
        { id: 'healthcare-rcm', name: 'Healthcare RCM / Tech-Enabled BPO', adjustment: 0.45, benchmarks: { recurringRevenuePct: 78, revenueYoYVariance: 10, customerRetentionRate: 94, ebitdaMargin: 20, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 13 } }
      ]
    },
    {
      id: 'healthcare',
      name: 'Healthcare & Medical',
      industries: [
        { id: 'healthcare-dental', name: 'Dental Practices (DSO target)', adjustment: 0.35, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 6, customerRetentionRate: 85, ebitdaMargin: 20, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 10, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 6 } },
        { id: 'healthcare-veterinary', name: 'Veterinary Practices', adjustment: 0.35, benchmarks: { recurringRevenuePct: 65, revenueYoYVariance: 6, customerRetentionRate: 88, ebitdaMargin: 18, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 10, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 7 } },
        { id: 'healthcare-dermatology', name: 'Dermatology / Med Spa', adjustment: 0.25, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 10, customerRetentionRate: 75, ebitdaMargin: 22, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 8 } },
        { id: 'healthcare-pt', name: 'Physical Therapy Clinics', adjustment: 0.25, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 8, customerRetentionRate: 80, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 6 } },
        { id: 'healthcare-optometry', name: 'Optometry Practices', adjustment: 0.25, benchmarks: { recurringRevenuePct: 45, revenueYoYVariance: 8, customerRetentionRate: 82, ebitdaMargin: 18, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 5 } },
        { id: 'healthcare-primary', name: 'Primary Care / Urgent Care', adjustment: 0.10, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 8, customerRetentionRate: 78, ebitdaMargin: 12, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 5 } },
        { id: 'healthcare-home', name: 'Home Health - Medical / Skilled (Medicare-Certified)', adjustment: 0.25, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 8, customerRetentionRate: 80, ebitdaMargin: 12, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 8 } },
        { id: 'healthcare-home-nonmedical', name: 'Home Care - Non-Medical (Companion / Personal Care)', adjustment: 0.15, benchmarks: { recurringRevenuePct: 65, revenueYoYVariance: 10, customerRetentionRate: 72, ebitdaMargin: 11, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 14, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 7 } },
        { id: 'healthcare-behavioral', name: 'Behavioral / Mental Health', adjustment: 0.25, benchmarks: { recurringRevenuePct: 65, revenueYoYVariance: 10, customerRetentionRate: 75, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 10 } },
        { id: 'healthcare-pharmacy', name: 'Pharmacy - Independent', adjustment: 0, benchmarks: { recurringRevenuePct: 75, revenueYoYVariance: 5, customerRetentionRate: 85, ebitdaMargin: 8, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 8, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 2 } }
      ]
    },
    {
      id: 'professional',
      name: 'Professional Services',
      industries: [
        { id: 'prof-accounting', name: 'Accounting / CPA Firms', adjustment: 0.25, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 6, customerRetentionRate: 92, ebitdaMargin: 25, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 8, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 5 } },
        { id: 'prof-wealth', name: 'Wealth Management / RIA', adjustment: 0.35, benchmarks: { recurringRevenuePct: 85, revenueYoYVariance: 8, customerRetentionRate: 95, ebitdaMargin: 30, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 8 } },
        { id: 'prof-insurance', name: 'Insurance Agencies', adjustment: 0.25, benchmarks: { recurringRevenuePct: 80, revenueYoYVariance: 6, customerRetentionRate: 90, ebitdaMargin: 20, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 8, topCustomerConcentration: 5, top5CustomerConcentration: 18, industryGrowthRate: 4 } },
        { id: 'prof-legal', name: 'Law Firms', adjustment: 0.10, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 12, customerRetentionRate: 80, ebitdaMargin: 25, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 4 } },
        { id: 'prof-engineering', name: 'Engineering Firms', adjustment: 0, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 12, customerRetentionRate: 82, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 4 } },
        { id: 'prof-architecture', name: 'Architecture Firms', adjustment: 0, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 15, customerRetentionRate: 80, ebitdaMargin: 15, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 3 } },
        { id: 'prof-marketing', name: 'Marketing / Ad Agencies', adjustment: 0, benchmarks: { recurringRevenuePct: 45, revenueYoYVariance: 15, customerRetentionRate: 78, ebitdaMargin: 18, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 4 } },
        { id: 'prof-staffing', name: 'Staffing / Recruiting (General)', adjustment: 0, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 18, customerRetentionRate: 75, ebitdaMargin: 8, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 25, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 3 } },
        { id: 'prof-staff-aug', name: 'Staff Augmentation (General)', adjustment: 0, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 15, customerRetentionRate: 78, ebitdaMargin: 8, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 4 } },
        { id: 'prof-hr', name: 'HR / PEO Services', adjustment: 0.10, benchmarks: { recurringRevenuePct: 75, revenueYoYVariance: 8, customerRetentionRate: 88, ebitdaMargin: 12, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 6 } }
      ]
    },
    {
      id: 'home-services',
      name: 'Home Services',
      industries: [
        // recurringRevenuePct 45→20 (Mark ruled 09-10, market research 09-09:
        // typical HVAC runs ~10-25% recurring via maintenance agreements —
        // the old 45% anchor made a NORMAL shop eat the max −0.75x penalty.
        // At 20: typical ≈ neutral, agreement-heavy books earn the premium
        // the market pays (≤25% rec trades 3-5x EBITDA, 25-40% 5-7x, >40%
        // 7-10x; ~0.3-0.5x per 10pts — our 0.025/pt slope matches), and a
        // genuinely agreement-free install shop takes a BOUNDED minus
        // (0% → −0.5x; Mark: "minus", not floor — install-only really does
        // trade lower).
        { id: 'home-hvac', name: 'HVAC Services', adjustment: 0.35, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 10, customerRetentionRate: 80, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 6 } },
        { id: 'home-plumbing', name: 'Plumbing Services', adjustment: 0.25, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 12, customerRetentionRate: 75, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 5 } },
        { id: 'home-electrical', name: 'Electrical Services', adjustment: 0.25, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 12, customerRetentionRate: 75, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 8, top5CustomerConcentration: 20, industryGrowthRate: 5 } },
        { id: 'home-roofing-res', name: 'Roofing - Residential', adjustment: 0.10, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 20, customerRetentionRate: 60, ebitdaMargin: 12, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 25, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 4 } },
        { id: 'home-roofing-com', name: 'Roofing - Commercial', adjustment: 0.10, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 15, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 4 } },
        { id: 'home-pest', name: 'Pest Control', adjustment: 0.35, benchmarks: { recurringRevenuePct: 75, revenueYoYVariance: 6, customerRetentionRate: 85, ebitdaMargin: 18, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 10, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 6 } },
        { id: 'home-landscaping', name: 'Landscaping / Lawn Care', adjustment: 0.10, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 10, customerRetentionRate: 80, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 5 } },
        { id: 'home-pool', name: 'Pool Services', adjustment: 0.10, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 8, customerRetentionRate: 82, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 5 } },
        { id: 'home-garage', name: 'Garage Door Services', adjustment: 0.10, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 12, customerRetentionRate: 70, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 5 } },
        { id: 'home-cleaning', name: 'Residential Cleaning', adjustment: 0, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 12, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 18, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 4 } },
        { id: 'home-restoration', name: 'Restoration / Remediation', adjustment: 0.10, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 25, customerRetentionRate: 65, ebitdaMargin: 15, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 30, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 5 } }
      ]
    },
    {
      id: 'business-services',
      name: 'Business Services',
      industries: [
        { id: 'biz-security', name: 'Security Services (Physical)', adjustment: 0.25, benchmarks: { recurringRevenuePct: 75, revenueYoYVariance: 8, customerRetentionRate: 85, ebitdaMargin: 12, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 5 } },
        { id: 'biz-cleaning', name: 'Commercial Cleaning / Janitorial', adjustment: 0.10, benchmarks: { recurringRevenuePct: 80, revenueYoYVariance: 8, customerRetentionRate: 80, ebitdaMargin: 10, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 4 } },
        { id: 'biz-waste', name: 'Waste Management / Recycling', adjustment: 0.25, benchmarks: { recurringRevenuePct: 85, revenueYoYVariance: 6, customerRetentionRate: 90, ebitdaMargin: 18, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 8, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 4 } },
        { id: 'biz-printing', name: 'Commercial Printing', adjustment: -0.25, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 15, customerRetentionRate: 75, ebitdaMargin: 8, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: -2 } },
        { id: 'biz-signage', name: 'Signage / Graphics', adjustment: 0, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 15, customerRetentionRate: 75, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 3 } },
        { id: 'biz-courier', name: 'Courier / Last-Mile Delivery', adjustment: 0, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 12, customerRetentionRate: 78, ebitdaMargin: 10, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 5 } }
      ]
    },
    {
      id: 'manufacturing',
      name: 'Manufacturing',
      industries: [
        { id: 'mfg-general', name: 'Manufacturing - General', adjustment: 0, benchmarks: { recurringRevenuePct: 15, revenueYoYVariance: 12, customerRetentionRate: 82, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 2.8 } },
        { id: 'mfg-aerospace', name: 'Manufacturing - Aerospace', adjustment: 0.10, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 10, customerRetentionRate: 90, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 25, top5CustomerConcentration: 60, industryGrowthRate: 4 } },
        { id: 'mfg-medical', name: 'Manufacturing - Medical Device', adjustment: 0.25, benchmarks: { recurringRevenuePct: 45, revenueYoYVariance: 8, customerRetentionRate: 92, ebitdaMargin: 18, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 6 } },
        { id: 'mfg-food', name: 'Manufacturing - Food & Beverage', adjustment: 0.10, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 8, customerRetentionRate: 85, ebitdaMargin: 12, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 4 } },
        { id: 'mfg-precision', name: 'Manufacturing - Precision / CNC', adjustment: 0.10, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 12, customerRetentionRate: 85, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 22, top5CustomerConcentration: 55, industryGrowthRate: 3 } },
        { id: 'mfg-plastics', name: 'Manufacturing - Plastics / Injection', adjustment: 0, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 12, customerRetentionRate: 82, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 2 } },
        { id: 'mfg-metal', name: 'Manufacturing - Metal Fabrication', adjustment: 0, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 15, customerRetentionRate: 80, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 22, top5CustomerConcentration: 55, industryGrowthRate: 2 } },
        { id: 'mfg-packaging', name: 'Manufacturing - Packaging', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 8, customerRetentionRate: 85, ebitdaMargin: 12, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 5 } },
        { id: 'mfg-electronics', name: 'Manufacturing - Electronics / PCB', adjustment: 0.10, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 12, customerRetentionRate: 85, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 4 } },
        { id: 'mfg-apparel-deco', name: 'Manufacturing - Apparel Decoration / Screen Printing', adjustment: 0, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 15, customerRetentionRate: 80, ebitdaMargin: 13, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 2 } },
        { id: 'mfg-textiles', name: 'Manufacturing - Textiles / Garment', adjustment: -0.10, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 15, customerRetentionRate: 78, ebitdaMargin: 10, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 22, top5CustomerConcentration: 55, industryGrowthRate: 1 } }
      ]
    },
    {
      id: 'distribution',
      name: 'Distribution & Wholesale',
      industries: [
        { id: 'dist-general', name: 'Distribution - General', adjustment: 0, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 10, customerRetentionRate: 82, ebitdaMargin: 8, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 3 } },
        { id: 'dist-industrial', name: 'Distribution - Industrial / MRO', adjustment: 0.10, benchmarks: { recurringRevenuePct: 65, revenueYoYVariance: 8, customerRetentionRate: 88, ebitdaMargin: 10, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 4 } },
        { id: 'dist-hvac', name: 'Distribution - HVAC / Plumbing', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 10, customerRetentionRate: 85, ebitdaMargin: 10, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 5 } },
        { id: 'dist-electrical', name: 'Distribution - Electrical', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 10, customerRetentionRate: 85, ebitdaMargin: 10, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 5 } },
        { id: 'dist-food', name: 'Distribution - Food Service', adjustment: 0, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 8, customerRetentionRate: 85, ebitdaMargin: 5, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 3 } },
        { id: 'dist-beverage', name: 'Distribution - Beverage / Beer', adjustment: 0.10, benchmarks: { recurringRevenuePct: 80, revenueYoYVariance: 6, customerRetentionRate: 90, ebitdaMargin: 8, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 10, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 3 } },
        { id: 'dist-auto', name: 'Distribution - Auto Parts', adjustment: 0, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 10, customerRetentionRate: 82, ebitdaMargin: 8, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 2 } }
      ]
    },
    {
      id: 'construction',
      name: 'Construction & Trades',
      industries: [
        { id: 'const-general', name: 'Construction - General Contractor', adjustment: -0.15, benchmarks: { recurringRevenuePct: 10, revenueYoYVariance: 25, customerRetentionRate: 70, ebitdaMargin: 8, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 30, topCustomerConcentration: 25, top5CustomerConcentration: 55, industryGrowthRate: 2 } },
        { id: 'const-commercial', name: 'Construction - Commercial', adjustment: -0.15, benchmarks: { recurringRevenuePct: 15, revenueYoYVariance: 22, customerRetentionRate: 72, ebitdaMargin: 8, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 28, topCustomerConcentration: 22, top5CustomerConcentration: 50, industryGrowthRate: 2.5 } },
        { id: 'const-residential', name: 'Construction - Residential', adjustment: -0.25, benchmarks: { recurringRevenuePct: 8, revenueYoYVariance: 30, customerRetentionRate: 65, ebitdaMargin: 8, marginStabilityStdDev: 5.5, ebitdaYoYVariance: 35, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 1.5 } },
        // recurring 25 → 15 (Mark 2026-08-25, Totally Wired Electric review —
        // same law as const-low-voltage: trade subs are project businesses;
        // 15% = mostly projects, modest service tail).
        { id: 'const-specialty', name: 'Construction - Specialty Trade', adjustment: 0, benchmarks: { recurringRevenuePct: 15, revenueYoYVariance: 18, customerRetentionRate: 75, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 22, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 3 } },
        // recurring 30 → 15 (Mark 2026-08-25, Proximity Wireless review): the
        // trade is overwhelmingly project work — 15% says "mostly projects,
        // modest service/monitoring tail," so a pure-project shop isn't
        // punished as if recurring contracts were the norm here.
        { id: 'const-low-voltage', name: 'Low-Voltage Contractor / Structured Cabling', adjustment: 0.10, benchmarks: { recurringRevenuePct: 15, revenueYoYVariance: 12, customerRetentionRate: 80, ebitdaMargin: 13, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 5 } },
        { id: 'const-infrastructure', name: 'Construction - Infrastructure', adjustment: 0.10, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 15, customerRetentionRate: 80, ebitdaMargin: 10, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 30, top5CustomerConcentration: 60, industryGrowthRate: 5 } },
        { id: 'const-solar', name: 'Solar Installation', adjustment: 0.10, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 20, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 25, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 15 } }
      ]
    },
    {
      id: 'automotive',
      name: 'Automotive',
      industries: [
        { id: 'auto-repair', name: 'Auto Repair - General', adjustment: 0, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 10, customerRetentionRate: 75, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 3 } },
        { id: 'auto-collision', name: 'Auto Body / Collision', adjustment: 0.10, benchmarks: { recurringRevenuePct: 45, revenueYoYVariance: 10, customerRetentionRate: 78, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 3 } },
        { id: 'auto-dealer', name: 'Auto Dealership', adjustment: 0, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 15, customerRetentionRate: 70, ebitdaMargin: 5, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 2 } },
        { id: 'auto-tire', name: 'Tire & Service Centers', adjustment: 0.10, benchmarks: { recurringRevenuePct: 45, revenueYoYVariance: 10, customerRetentionRate: 78, ebitdaMargin: 12, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 4 } },
        { id: 'auto-wash', name: 'Car Wash', adjustment: 0.25, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 8, customerRetentionRate: 75, ebitdaMargin: 25, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 8 } },
        { id: 'auto-transmission', name: 'Transmission / Specialty Repair', adjustment: 0, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 12, customerRetentionRate: 72, ebitdaMargin: 15, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 18, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 0 } }
      ]
    },
    {
      id: 'food-beverage',
      name: 'Food & Beverage',
      industries: [
        { id: 'food-restaurant-full', name: 'Restaurant - Full Service', adjustment: -0.25, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 15, customerRetentionRate: 65, ebitdaMargin: 8, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 25, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 2 } },
        { id: 'food-restaurant-qsr', name: 'Restaurant - QSR / Fast Casual', adjustment: -0.15, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 12, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 3 } },
        { id: 'food-franchise', name: 'Restaurant - Franchise (Multi-unit)', adjustment: 0, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 10, customerRetentionRate: 75, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 4 } },
        { id: 'food-catering', name: 'Catering / Events', adjustment: -0.15, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 20, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 28, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 3 } },
        { id: 'food-bakery', name: 'Bakery - Commercial', adjustment: 0, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 10, customerRetentionRate: 82, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 3 } },
        { id: 'food-beverage-mfg', name: 'Beverage Manufacturing', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 10, customerRetentionRate: 85, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 5 } }
      ]
    },
    {
      id: 'retail',
      name: 'Retail',
      industries: [
        { id: 'retail-brick', name: 'Retail - Brick & Mortar General', adjustment: -0.25, benchmarks: { recurringRevenuePct: 20, revenueYoYVariance: 15, customerRetentionRate: 65, ebitdaMargin: 8, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 22, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 0 } },
        { id: 'retail-ecommerce', name: 'Retail - E-commerce', adjustment: -0.15, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 18, customerRetentionRate: 60, ebitdaMargin: 10, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 25, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 5 } },
        { id: 'retail-specialty', name: 'Retail - Specialty / Niche', adjustment: 0, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 12, customerRetentionRate: 72, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 18, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 3 } },
        { id: 'retail-convenience', name: 'Convenience Stores', adjustment: 0, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 8, customerRetentionRate: 78, ebitdaMargin: 8, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 2 } },
        { id: 'retail-liquor', name: 'Liquor Stores', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 6, customerRetentionRate: 80, ebitdaMargin: 12, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 10, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 3 } },
        { id: 'retail-auto-parts', name: 'Auto Parts Retail', adjustment: -0.15, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 10, customerRetentionRate: 72, ebitdaMargin: 8, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 1 } }
      ]
    },
    {
      id: 'transportation',
      name: 'Transportation & Logistics',
      industries: [
        { id: 'transport-trucking', name: 'Trucking - General Freight', adjustment: -0.15, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 15, customerRetentionRate: 75, ebitdaMargin: 8, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 22, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 2 } },
        { id: 'transport-specialized', name: 'Trucking - Specialized / Hazmat', adjustment: 0, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 12, customerRetentionRate: 82, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 3 } },
        { id: 'transport-logistics', name: 'Logistics / 3PL', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 10, customerRetentionRate: 85, ebitdaMargin: 10, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 5 } },
        { id: 'transport-moving', name: 'Moving & Storage', adjustment: 0, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 15, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 3 } },
        { id: 'transport-courier', name: 'Courier / Delivery', adjustment: 0, benchmarks: { recurringRevenuePct: 50, revenueYoYVariance: 12, customerRetentionRate: 78, ebitdaMargin: 10, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 4 } },
        { id: 'transport-taxi', name: 'Taxi / Limo / Black Car', adjustment: -0.35, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 20, customerRetentionRate: 60, ebitdaMargin: 8, marginStabilityStdDev: 5.5, ebitdaYoYVariance: 28, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: -5 } },
        { id: 'transport-school-bus', name: 'School Bus / Transit', adjustment: 0.10, benchmarks: { recurringRevenuePct: 85, revenueYoYVariance: 6, customerRetentionRate: 92, ebitdaMargin: 10, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 8, topCustomerConcentration: 40, top5CustomerConcentration: 70, industryGrowthRate: 3 } }
      ]
    },
    {
      id: 'energy',
      name: 'Energy & Utilities',
      industries: [
        { id: 'energy-oilgas', name: 'Oil & Gas Services', adjustment: -0.25, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 35, customerRetentionRate: 70, ebitdaMargin: 12, marginStabilityStdDev: 6.0, ebitdaYoYVariance: 40, topCustomerConcentration: 25, top5CustomerConcentration: 55, industryGrowthRate: 0 } },
        { id: 'energy-solar', name: 'Solar Services', adjustment: 0.10, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 18, customerRetentionRate: 75, ebitdaMargin: 15, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 22, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 12 } },
        { id: 'energy-electrical', name: 'Electrical Contractor', adjustment: 0.10, benchmarks: { recurringRevenuePct: 35, revenueYoYVariance: 15, customerRetentionRate: 78, ebitdaMargin: 12, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 6 } },
        { id: 'energy-propane', name: 'Propane Distribution', adjustment: 0.10, benchmarks: { recurringRevenuePct: 80, revenueYoYVariance: 10, customerRetentionRate: 88, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 15, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 2 } },
        { id: 'energy-generator', name: 'Generator Sales & Service', adjustment: 0.10, benchmarks: { recurringRevenuePct: 45, revenueYoYVariance: 20, customerRetentionRate: 78, ebitdaMargin: 15, marginStabilityStdDev: 4.5, ebitdaYoYVariance: 25, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 6 } }
      ]
    },
    {
      id: 'real-estate',
      name: 'Real Estate Services',
      industries: [
        { id: 're-pm-residential', name: 'Property Management - Residential', adjustment: 0.15, benchmarks: { recurringRevenuePct: 85, revenueYoYVariance: 8, customerRetentionRate: 88, ebitdaMargin: 15, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 12, topCustomerConcentration: 12, top5CustomerConcentration: 35, industryGrowthRate: 4 } },
        { id: 're-pm-commercial', name: 'Property Management - Commercial', adjustment: 0.25, benchmarks: { recurringRevenuePct: 90, revenueYoYVariance: 6, customerRetentionRate: 92, ebitdaMargin: 20, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 10, topCustomerConcentration: 18, top5CustomerConcentration: 45, industryGrowthRate: 3 } },
        { id: 're-pm-hoa', name: 'Property Management - HOA / Association', adjustment: 0.25, benchmarks: { recurringRevenuePct: 92, revenueYoYVariance: 5, customerRetentionRate: 90, ebitdaMargin: 18, marginStabilityStdDev: 2.0, ebitdaYoYVariance: 8, topCustomerConcentration: 10, top5CustomerConcentration: 30, industryGrowthRate: 5 } },
        { id: 're-pm-mixed', name: 'Property Management - Mixed Portfolio', adjustment: 0.20, benchmarks: { recurringRevenuePct: 88, revenueYoYVariance: 7, customerRetentionRate: 89, ebitdaMargin: 17, marginStabilityStdDev: 2.5, ebitdaYoYVariance: 11, topCustomerConcentration: 14, top5CustomerConcentration: 38, industryGrowthRate: 4 } },
        { id: 're-brokerage', name: 'Real Estate Brokerage', adjustment: -0.15, benchmarks: { recurringRevenuePct: 15, revenueYoYVariance: 25, customerRetentionRate: 65, ebitdaMargin: 10, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 30, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: 2 } },
        { id: 're-appraisal', name: 'Real Estate Appraisal / Inspection', adjustment: 0, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 18, customerRetentionRate: 75, ebitdaMargin: 20, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 22, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: 2 } }
      ]
    },
    {
      id: 'other',
      name: 'Other Industries',
      industries: [
        { id: 'other-travel', name: 'Travel Agency', adjustment: -0.25, benchmarks: { recurringRevenuePct: 30, revenueYoYVariance: 20, customerRetentionRate: 65, ebitdaMargin: 10, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 28, topCustomerConcentration: 8, top5CustomerConcentration: 25, industryGrowthRate: -2 } },
        { id: 'other-drycleaning', name: 'Dry Cleaning', adjustment: -0.25, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 8, customerRetentionRate: 75, ebitdaMargin: 12, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: -3 } },
        { id: 'other-print-media', name: 'Print Media / Publishing', adjustment: -0.35, benchmarks: { recurringRevenuePct: 40, revenueYoYVariance: 15, customerRetentionRate: 70, ebitdaMargin: 8, marginStabilityStdDev: 5.0, ebitdaYoYVariance: 25, topCustomerConcentration: 15, top5CustomerConcentration: 40, industryGrowthRate: -8 } },
        { id: 'other-fitness', name: 'Fitness / Gyms', adjustment: 0, benchmarks: { recurringRevenuePct: 70, revenueYoYVariance: 12, customerRetentionRate: 65, ebitdaMargin: 15, marginStabilityStdDev: 4.0, ebitdaYoYVariance: 20, topCustomerConcentration: 2, top5CustomerConcentration: 5, industryGrowthRate: 4 } },
        { id: 'other-education', name: 'Education / Tutoring', adjustment: 0.10, benchmarks: { recurringRevenuePct: 55, revenueYoYVariance: 12, customerRetentionRate: 75, ebitdaMargin: 18, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 18, topCustomerConcentration: 5, top5CustomerConcentration: 15, industryGrowthRate: 5 } },
        { id: 'other-childcare', name: 'Childcare / Daycare', adjustment: 0.10, benchmarks: { recurringRevenuePct: 80, revenueYoYVariance: 8, customerRetentionRate: 80, ebitdaMargin: 15, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 12, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 4 } },
        { id: 'other-pet', name: 'Pet Services (Non-Vet)', adjustment: 0.10, benchmarks: { recurringRevenuePct: 60, revenueYoYVariance: 10, customerRetentionRate: 78, ebitdaMargin: 15, marginStabilityStdDev: 3.5, ebitdaYoYVariance: 15, topCustomerConcentration: 3, top5CustomerConcentration: 10, industryGrowthRate: 6 } },
        { id: 'custom', name: 'Custom / Other (Manual)', adjustment: 0, benchmarks: { recurringRevenuePct: 25, revenueYoYVariance: 15, customerRetentionRate: 80, ebitdaMargin: 12, marginStabilityStdDev: 3.0, ebitdaYoYVariance: 18, topCustomerConcentration: 20, top5CustomerConcentration: 50, industryGrowthRate: 3 } }
      ]
    }
  ];

  // State for selected sector and industry. NO DEFAULT since 08-27 (the
  // fix-batch force-a-pick, shipped with the sector audit): 'it-msp' as a
  // born-in default was indistinguishable from a human choice, and TWO
  // downstream systems trusted it — the SE mint stamped Airmerica's row
  // "IT Managed Services Provider (MSP)" and DM's closing prefill would
  // write "IT - Managed Services", both from a field nobody ever touched.
  // Empty = honest. Math falls back to the generic profile (see
  // currentBenchmarks); the mint and DM prefill carry NOTHING until a
  // human picks.
  const [selectedSector, setSelectedSector] = useState('');
  const [selectedIndustry, setSelectedIndustry] = useState('');
  
  // Get industries for selected sector
  const currentSectorIndustries = useMemo(() => {
    const sector = industrySectors.find(s => s.id === selectedSector);
    return sector ? sector.industries : [];
  }, [selectedSector]);
  
  // Get selected industry object
  const selectedIndustryObj = useMemo(() => {
    for (const sector of industrySectors) {
      const found = sector.industries.find(i => i.id === selectedIndustry);
      if (found) return found;
    }
    return null;
  }, [selectedIndustry]);
  
  // Legacy industryBenchmarks for compatibility - now derived from industrySectors
  const industryBenchmarks = useMemo(() => {
    const all = [];
    for (const sector of industrySectors) {
      for (const ind of sector.industries) {
        all.push({ id: ind.id, name: ind.name, benchmarks: ind.benchmarks });
      }
    }
    return all;
  }, []);

  // ========== REVENUE TYPES ==========
  // v2.6: Split project_contracted into service projects (0.50) and hardware (0.25)
  // v2.7: Revenue Quality Engine Improvements (Fixes 1-4)
  //   Fix 1: Auto-detect misclassified hardware as project_contracted, show reclassification banner with one-click fix
  //   Fix 2: A5 Revenue Growth Quality sub-factor — penalizes when YoY growth is driven by non-recurring sources
  //   Fix 3: Project Revenue Stability Damper — reduces weight of project/hardware revenue with extreme YoY spikes
  //   Fix 4: A6 Customer Revenue Spike Detection — flags when single customer spike drives disproportionate growth
  // v2.8: Balance Sheet Parser Fixes (3 bugs)
  //   Bug 1: Duplicate account names (e.g. "Chase Ink for Business" at two QB hierarchy levels) — second overwrote first
  //          Fix: Track parent hierarchy, disambiguate with parent name suffix (e.g. "Chase Ink for Business (Credit Cards)")
  //   Bug 2: "Other Current Assets" QB sub-header was misrouted to BS "Other Assets" section
  //          Fix: Removed from otherAssets patterns, added qbSubSectionHeaders skip list for QB intermediate grouping headers
  //   Bug 3: Loading a second year (e.g. 2024) wiped the first year (e.g. 2025) data with zeroes
  //          Fix: Only write active year keys from pasted data, leave other year columns untouched
  // v2.9: Sales Grid Paste — QB Desktop Hierarchical Format Support
  //   Bug: QB Desktop "Sales by Customer" report pasted as all zeros (3 sub-issues):
  //     1. Customer names at col 1-2 (not col 0) → every row skipped by "if (!name) continue"
  //     2. 2-digit year headers ("Jan - Dec 21") didn't match /20\d{2}/ → no year columns detected
  //     3. "TOTAL" column caused all year columns to be skipped even in 5-year reports
  //   Fix: Added QB Desktop hierarchical format detection with two-pass customer aggregation
  //        (Total rows for multi-item customers, direct rows for single-line customers),
  //        2-digit year conversion (21→2021), and multi-year Total column handling
  // v2.10: Revenue & COGS Analysis — Fix mislabeled summary cards
  //   Cards 3-4 were labeled "NWC (Excl. Cash)" and "Current Ratio" (balance sheet metrics)
  //   but computed Revenue - COGS and (Rev-COGS)/Rev. Relabeled to "Gross Profit (TTM)" and "Gross Margin"
  // v2.11: CapEx Analysis — Fixed Assets showing gross instead of net balance
  //   Math.max() across years zeroed out Accumulated Depreciation (negative values):
  //     Math.max(-80000, 0, 0, 0) = 0 → depreciation disappeared → showed gross assets
  //   Fix: Use latest-year fallback (interim || year3 || year2 || year1) which preserves negatives
  //   Also: renamed label "Total Fixed Assets" → "Net Fixed Assets (net of depreciation)"
  // v2.12: Adjustments — "Owner Benefits" category ignored for Owner Comp grouping
  //   Classification used keyword matching only (owner, salary, health, etc.)
  //   but never checked the explicit category field (adjCategory / adj.category)
  //   Fix: Check category === 'Owner Benefits' first at all 5 classification sites
  //   (2 in analysis export, 3 in presentation view)
  // v2.13: Owner Comp — Market Replacement Rate justification/rationale field
  //   Added "Rationale" display to both presentation views (live + export HTML)
  //   Upgraded entry UI from single-line text to labeled textarea with guidance placeholder
  //   Field already existed in state (marketReplacementNotes) but was never shown in output
  // v2.14: Overview Tab — Complete redesign as supervisor intelligence brief
  //   Panel 1: Dark header with company info + valuation range at a glance
  //   Panel 2: Executive Snapshot — 6 KPI cards with traffic-light indicators benchmarked to industry
  //   Panel 3: Strengths & Risks — Auto-detected from data with severity (15+ detection rules)
  //   Panel 4: Open Items & Resolutions — Outstanding flags (critical/warning) + collapsible resolved
  //   Panel 5: Deal Readiness — 6 progress bars (Discovery, Financials, Sales, BS, Adjustments, Docs)
  //   Panel 6: Discovery Notes — Collapsible section with condensed Q&A organized by topic
  // v2.15: Sales Grid — Client Detail Template Excel Export/Import
  //   Export: Generates Excel with client names, dropdown validations, industry-specific defaults,
  //     color-coded priority columns (Required/Important)
  //   Import: Reads completed template back, matches by name, applies values
  //   Status field upgraded from atRisk boolean to Active/At Risk/Lost dropdown
  //   Added 'lost' field to data model, lost client flag in outstanding analysis
  // Rationale: Hardware/product sales to contracted clients are still fundamentally lumpy
  // and variable. Service projects have better recurrence patterns but are still not MRR.
  // Old project_contracted at 0.75 was inflating weighted recurring % by 20-30 points
  // in deals with significant hardware/project revenue.
  // Descriptions rewritten industry-neutral 2026-08-18 (Colleen's
  // project-business review — Totally Wired, Proximity: owners picked
  // Contracted-Defined because a one-time project "is technically under
  // contract"; the MSP-era wording invited it and inflated recurring %).
  // THE TEST everywhere: "does it repeat by agreement?" — not "is it
  // under contract?". Weights untouched — copy fix only, Mark-approved.
  const revenueTypes = [
    {
      id: 'contracted_defined',
      label: 'Contracted - Defined Revenue',
      isRecurring: true,
      weight: 1.0,
      tooltip: 'A written agreement obligates REPEATING payments of a set amount — monthly, quarterly, or annual — until the contract ends. NOT one-time project contracts, even signed ones.',
      examples: 'Service-plan monthly fees, maintenance & monitoring agreements, your own subscription or membership plans (resold software subscriptions are type 6), annual retainers'
    },
    {
      id: 'project_contracted',
      label: 'Service Projects - Contracted Client',
      isRecurring: true,
      weight: 0.50,
      tooltip: 'Project or labor work for a client who ALSO has an ongoing service agreement with you — each project is one-time, but the relationship is contractual and recurring.',
      examples: 'An install for a maintenance-plan customer, upgrade work for an MSA client, projects for clients on your service plan'
    },
    {
      id: 'hardware_contracted',
      label: 'Hardware/Product - Contracted Client',
      isRecurring: true,
      weight: 0.25,
      tooltip: 'Equipment, hardware, or materials sold to clients under an ongoing agreement — lumpy and unpredictable even in good relationships.',
      examples: 'Equipment purchases, workstation rollouts, materials sold to service-plan clients'
    },
    {
      id: 'repeat_uncontracted',
      label: 'Repeat - Uncontracted',
      isRecurring: true,
      weight: 0.25,
      tooltip: 'Clients who come back again and again with NO ongoing agreement — a two-plus-year pattern, no legal protection.',
      examples: "A contractor's repeat commercial customers, property managers who call every season, break/fix regulars"
    },
    {
      id: 'transactional',
      label: 'Transactional / New',
      isRecurring: false,
      weight: 0,
      tooltip: 'One-time work and new customers — INCLUDING signed one-time project contracts (a construction job, a wiring project, an install). Contracted ≠ recurring.',
      examples: 'A home build, a wiring or AV project, a one-time install, first job for a new client'
    },
    // RECURRING LICENSING / SUBSCRIPTION RESALE (Colleen 09-23, ITCS: a monthly
    // Microsoft 365 or SentinelOne seat billed under the MSA is a "subscription"
    // per type 1's wording AND a "software licensing resale" per type 3's — the
    // engine forced it to 1.0 or 0.25. It renews by agreement every month
    // without a sale, so it earns recurring credit; it is thin-margin, vendor-
    // controlled and can be direct-billed away, so not full credit. One-time
    // perpetual licenses stay Hardware.) WEIGHT 0.50 — Zac 10-06 (was a 0.75
    // placeholder; on Concise that one reclassification moved 7.55x → 7.83x).
    {
      id: 'recurring_licensing',
      label: 'Recurring Licensing / Subscription Resale',
      isRecurring: true,
      weight: 0.50,
      tooltip: 'Software subscriptions and licenses you resell that renew by agreement — monthly or annual — for clients under an ongoing service relationship. Predictable and sticky, but thin-margin and vendor-controlled. One-time / perpetual license sales are Hardware/Product.',
      examples: 'Microsoft 365 seats, security-agent and backup subscriptions, per-seat SaaS billed monthly or annually under the MSA'
    },
    // Legacy mappings for backward compatibility with saved files
    { id: 'recurring_contract', label: 'Contracted - Defined Revenue', isRecurring: true, weight: 1.0, legacy: true },
    { id: 'recurring_switching', label: 'Service Projects - Contracted Client', isRecurring: true, weight: 0.50, legacy: true },
    { id: 'recurring_mtm', label: 'Repeat - Uncontracted', isRecurring: true, weight: 0.25, legacy: true },
    { id: 'project_services', label: 'Transactional / New', isRecurring: false, weight: 0, legacy: true },
    { id: 'product', label: 'Transactional / New', isRecurring: false, weight: 0, legacy: true }
  ];
  
  // State for revenue type definitions help panel
  const [showRevenueTypeHelp, setShowRevenueTypeHelp] = useState(false);
  
  // State for revenue split editor modal
  const [splitEditorCategory, setSplitEditorCategory] = useState(null);
  
  // Helper function to calculate effective weight for a category considering splits
  const getCategoryEffectiveWeight = (cat) => {
    // If category has typeSplits defined, calculate weighted average
    if (cat.typeSplits && Object.keys(cat.typeSplits).length > 0) {
      const totalPct = Object.values(cat.typeSplits).reduce((sum, pct) => sum + (pct || 0), 0);
      if (totalPct > 0) {
        let weightedSum = 0;
        Object.entries(cat.typeSplits).forEach(([typeId, pct]) => {
          const typeWeight = revenueTypes.find(t => t.id === typeId)?.weight || 0;
          weightedSum += (pct / 100) * typeWeight;
        });
        return weightedSum;
      }
    }
    // Fall back to single type weight
    return revenueTypes.find(t => t.id === cat.revenueType)?.weight || 0;
  };

  // ========== REVENUE CATEGORIES (from P&L) ==========
  // Each category stores values for all three bases (cash, accrual, tax)
  const [revenueCategories, setRevenueCategories] = useState([
    { id: 1, name: '', revenueType: 'contracted_defined', isVerified: false,
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }
  ]);

  // ── Portal forms (migration 034): owner-submitted responses for this deal ──
  // The portal writes owner_form_responses per field; staff review-and-accept
  // applies them here (Decision 2 — the portal never writes deal data). null =
  // not fetched. Fetched per valuation; cheap (a handful of rows).
  const [ownerFormResponses, setOwnerFormResponses] = useState(null);
  const [showOwnerFormReview, setShowOwnerFormReview] = useState(false);
  useEffect(() => {
    setOwnerFormResponses(null);
    setShowOwnerFormReview(false);
    if (!supabaseClient || !currentValuationId) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await supabaseClient.from('owner_form_responses')
          .select('form_key, row_key, field, value, answered_at')
          .eq('engagement_id', currentValuationId);
        if (!cancelled) setOwnerFormResponses(data || []);
      } catch (e) { console.warn('Owner form responses fetch failed:', e); }
    })();
    return () => { cancelled = true; };
  }, [currentValuationId]);

  // Deep-link from the My Work form-review card (Konnie 08-05: the card's
  // instructions said "Revenue section" while the Client Detail banner
  // lives on Data Entry → Sales — nobody should need to know which tab
  // holds which banner). Opened with openTarget 'ownerFormReview', we land
  // directly on the tab whose banner is waiting, decided from the actual
  // pending (completed-but-unaccepted) responses once they load.
  const ownerFormTargetConsumed = React.useRef(false);
  useEffect(() => {
    if (ownerFormTargetConsumed.current) return;
    if (!(currentValuation && currentValuation.openTarget === 'ownerFormReview')) return;
    if (!Array.isArray(ownerFormResponses)) return; // wait for the fetch
    ownerFormTargetConsumed.current = true;
    const pending = ownerFormPendingKeys(ownerFormResponses);
    const anyKeys = new Set(ownerFormResponses.map(r => r.form_key));
    const pick = (k) => pending.includes(k) || (pending.length === 0 && anyKeys.has(k));
    const FORM_TAB = { client_detail: 'customers', revenue_classification: 'revenueanalysis', tech_stack: 'profile', facility: 'profile' };
    const key = ['client_detail', 'revenue_classification', 'tech_stack', 'facility'].find(pick);
    setViewMode(FORM_TAB[key] || 'customers');
  }, [ownerFormResponses, currentValuation]);

  // Revenue Classification responses, shaped for review: rows keyed by the
  // portal's row_key (the category id at form-build time; name as fallback).
  const ownerRevClassRows = useMemo(() => {
    if (!Array.isArray(ownerFormResponses)) return null;
    const rows = {};
    let done = false;
    ownerFormResponses.forEach(r => {
      if (r.form_key !== 'revenue_classification') return;
      // row_key '' rows are markers (__done, __accepted), never answers —
      // letting __accepted through created a phantom row: "21 lines
      // answered" on a 20-line P&L (Colleen, Concise 2026-08-03), and one
      // extra false orphan in the accept warning.
      if (r.row_key === '') {
        if (r.field === '__done') done = r.value === 'true';
        return;
      }
      (rows[r.row_key] = rows[r.row_key] || {})[r.field] = r.value;
    });
    return (Object.keys(rows).length || done) ? { rows, done } : null;
  }, [ownerFormResponses]);

  // Owner's 1–5 numbers → revenueType ids (inverse of the spreadsheet
  // generator's typeToNumber — keep the maps in sync).
  const NUM_TO_REV_TYPE = { '1': 'contracted_defined', '2': 'project_contracted', '3': 'hardware_contracted', '4': 'repeat_uncontracted', '5': 'transactional', '6': 'recurring_licensing' };
  const ownerRespForCat = (c) => ownerRevClassRows
    && (ownerRevClassRows.rows[String(c.id)] || ownerRevClassRows.rows[String((c.name || '').trim())]
      // the same line under a QB heading prefix or without it (Mark 10-12, Blue Spruce)
      || ownerRevClassRows.rows[plLineKey(c.name)]
      || Object.entries(ownerRevClassRows.rows).find(([k]) => plLineKey(k) === plLineKey(c.name))?.[1]);

  // Per-form accepted-state: acceptance writes an (row_key='', field='__accepted')
  // marker; a form is PENDING when its __done is newer than any __accepted.
  // The valuations.owner_form_unreviewed flag = "any form pending", so
  // accepting one form doesn't hide another that's still waiting.
  const ownerFormPendingKeys = (rows) => {
    const byForm = {};
    (rows || []).forEach(r => {
      if (r.row_key === '' && (r.field === '__done' || r.field === '__accepted')) {
        (byForm[r.form_key] = byForm[r.form_key] || {})[r.field] = r;
      }
    });
    return Object.keys(byForm).filter(k => {
      const d = byForm[k].__done, a = byForm[k].__accepted;
      return d && d.value === 'true' && (!a || new Date(a.answered_at) < new Date(d.answered_at));
    });
  };
  const markOwnerFormAccepted = async (formKey) => {
    if (!supabaseClient || !currentValuationId) return;
    const nowIso = new Date().toISOString();
    try {
      await supabaseClient.from('owner_form_responses').upsert({
        engagement_id: currentValuationId, form_key: formKey, row_key: '', field: '__accepted',
        value: 'true', answered_at: nowIso,
      }, { onConflict: 'engagement_id,form_key,row_key,field' });
    } catch (e) { console.warn('Owner form accepted-marker failed:', e); }
    const updated = [
      ...(ownerFormResponses || []).filter(r => !(r.form_key === formKey && r.row_key === '' && r.field === '__accepted')),
      { form_key: formKey, row_key: '', field: '__accepted', value: 'true', answered_at: nowIso },
    ];
    setOwnerFormResponses(updated);
    try {
      // House pattern (save-conflict guard): any direct write that bumps
      // updated_at on the OPEN file must hand the new stamp back to
      // loadedUpdatedAtRef — otherwise the next auto/manual save filters on
      // the stale stamp, matches zero rows, and reports "someone else saved"
      // (Colleen, Concise, 2026-08-03: acknowledge → save blocked).
      const tabWasCurrent = await tabIsCurrent();
      const { data: ret } = await supabaseClient.from('valuations')
        .update({ owner_form_unreviewed: ownerFormPendingKeys(updated).length > 0, updated_at: nowIso })
        .eq('id', currentValuationId).select('updated_at').single();
      if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
    } catch (e) { console.warn('Updating owner_form_unreviewed failed:', e); }
  };

  // Accept: apply the owner's types into the table (same effect as the
  // spreadsheet import — type + Verified; notes are shown for staff judgment,
  // never auto-applied since they often describe splits), then clear the
  // dashboard review flag + log.
  const acceptOwnerRevenueClassification = async () => {
    if (!ownerRevClassRows) return;
    captureUndoState('Accept owner Revenue Classification');
    let applied = 0;
    const next = revenueCategories.map(c => {
      const resp = ownerRespForCat(c);
      const typeId = resp && NUM_TO_REV_TYPE[String(resp.type || '').trim()];
      if (!typeId) return c;
      applied++;
      return { ...c, revenueType: typeId, typeSplits: {}, isVerified: true, verifiedAt: new Date().toLocaleDateString() };
    });
    setRevenueCategories(next);
    const matchedKeys = new Set();
    revenueCategories.forEach(c => {
      if (ownerRevClassRows.rows[String(c.id)]) matchedKeys.add(String(c.id));
      if (ownerRevClassRows.rows[String((c.name || '').trim())]) matchedKeys.add(String((c.name || '').trim()));
    });
    const orphans = Object.keys(ownerRevClassRows.rows).filter(k => !matchedKeys.has(k));
    await markOwnerFormAccepted('revenue_classification');
    if (supabaseClient && currentValuationId) {
      try {
        await supabaseClient.from('project_activity_log').insert({
          project_id: currentValuationId,
          actor_email: userEmail || 'unknown',
          actor_name: userEmail ? userEmail.split('@')[0] : null,
          kind: 'owner_form_accepted',
          note: `Revenue Classification: ${applied} line type${applied === 1 ? '' : 's'} accepted from the owner's portal form`,
          metadata: { form_key: 'revenue_classification', applied, orphans: orphans.length },
        });
      } catch (e) { console.warn('Owner form accept log failed:', e); }
    }
    setShowOwnerFormReview(false);
    alert(`✅ Applied ${applied} owner classification${applied === 1 ? '' : 's'} (marked Verified).`
      + (orphans.length ? `\n\n⚠️ ${orphans.length} owner answer${orphans.length === 1 ? '' : 's'} didn't match a current revenue line (the P&L may have been re-imported since the owner answered) — open Review to check.` : '')
      + `\n\nOwner notes are shown in the review panel — apply any split guidance by hand.`);
  };

  // CIM-prep portal forms (Tech Stack vendor rows + Facility specifics),
  // shaped for the review banner in the CIM Data Collection panel.
  const ownerCimPrep = useMemo(() => {
    if (!Array.isArray(ownerFormResponses)) return null;
    const vFields = ['technology', 'use', 'term', 'monthlyCost'];
    const tech = {}; const fac = {};
    let techDone = false, facDone = false;
    ownerFormResponses.forEach(r => {
      if (r.form_key === 'tech_stack') {
        if (r.row_key === '' && r.field === '__done') techDone = r.value === 'true';
        else if (r.row_key !== '' && vFields.includes(r.field)) (tech[r.row_key] = tech[r.row_key] || {})[r.field] = r.value;
      } else if (r.form_key === 'facility') {
        if (r.row_key === '' && r.field === '__done') facDone = r.value === 'true';
        else if (r.row_key === '' && r.field !== '__accepted') fac[r.field] = r.value;
      }
    });
    const techRows = Object.keys(tech).map(k => ({ key: k, ...tech[k] }))
      .filter(r => vFields.some(f => String(r[f] || '').trim()));
    const facFields = Object.keys(fac).filter(f => String(fac[f] || '').trim());
    if (!techRows.length && !facFields.length && !techDone && !facDone) return null;
    return { techRows, fac, facFields, techDone, facDone };
  }, [ownerFormResponses]);

  // Accept Tech Stack: merge owner vendor rows into cimVendors — 'v<id>' rows
  // update the matching staff row (owner value wins per field), 'o…' rows
  // append as new vendors.
  const acceptOwnerTechStack = async () => {
    if (!ownerCimPrep) return;
    if (!ownerCimPrep.techRows.length) {
      if (ownerCimPrep.techDone) await acknowledgeEmptyOwnerForm('tech_stack', 'Technology Stack');
      return;
    }
    captureUndoState('Accept owner Tech Stack form');
    const existingIds = new Set((cimVendors || []).map(x => 'v' + x.id));
    setCimVendors(prev => {
      const next = (prev || []).map(x => {
        const r = ownerCimPrep.techRows.find(t => t.key === 'v' + x.id);
        if (!r) return x;
        return {
          ...x,
          technology: r.technology != null ? r.technology : x.technology,
          use: r.use != null ? r.use : x.use,
          term: r.term != null ? r.term : x.term,
          monthlyCost: r.monthlyCost != null ? r.monthlyCost : x.monthlyCost,
        };
      });
      ownerCimPrep.techRows.filter(t => !existingIds.has(t.key)).forEach((t, i) => {
        next.push({ id: Date.now() + i, technology: t.technology || '', use: t.use || '', term: t.term || '', monthlyCost: t.monthlyCost || '' });
      });
      return next;
    });
    await markOwnerFormAccepted('tech_stack');
    if (supabaseClient && currentValuationId) {
      try {
        await supabaseClient.from('project_activity_log').insert({
          project_id: currentValuationId,
          actor_email: userEmail || 'unknown',
          actor_name: userEmail ? userEmail.split('@')[0] : null,
          kind: 'owner_form_accepted',
          note: `Technology Stack: ${ownerCimPrep.techRows.length} vendor row${ownerCimPrep.techRows.length === 1 ? '' : 's'} accepted from the owner's portal form`,
          metadata: { form_key: 'tech_stack', rows: ownerCimPrep.techRows.length },
        });
      } catch (e) { console.warn('Owner form accept log failed:', e); }
    }
    alert(`✅ Merged ${ownerCimPrep.techRows.length} vendor row${ownerCimPrep.techRows.length === 1 ? '' : 's'} into the Technology Stack table.`);
  };

  // Accept Facility: apply the owner's specifics into cimFacility (only the
  // five portal-asked fields; owned/leased + rate + sell-vs-lease stay with
  // Q22 / the staff panel per the Zac de-dup split).
  const acceptOwnerFacility = async () => {
    if (!ownerCimPrep) return;
    if (!ownerCimPrep.facFields.length) {
      if (ownerCimPrep.facDone) await acknowledgeEmptyOwnerForm('facility', 'Facility');
      return;
    }
    captureUndoState('Accept owner Facility form');
    const allowed = ['address', 'sqft', 'leaseExpiration', 'renewalOptions', 'canOperateRemotely'];
    setCimFacility(prev => {
      const next = { ...prev };
      allowed.forEach(f => { if (ownerCimPrep.fac[f] != null && String(ownerCimPrep.fac[f]).trim()) next[f] = ownerCimPrep.fac[f]; });
      return next;
    });
    await markOwnerFormAccepted('facility');
    if (supabaseClient && currentValuationId) {
      try {
        await supabaseClient.from('project_activity_log').insert({
          project_id: currentValuationId,
          actor_email: userEmail || 'unknown',
          actor_name: userEmail ? userEmail.split('@')[0] : null,
          kind: 'owner_form_accepted',
          note: `Facility: ${ownerCimPrep.facFields.length} field${ownerCimPrep.facFields.length === 1 ? '' : 's'} accepted from the owner's portal form`,
          metadata: { form_key: 'facility', fields: ownerCimPrep.facFields },
        });
      } catch (e) { console.warn('Owner form accept log failed:', e); }
    }
    alert(`✅ Applied ${ownerCimPrep.facFields.length} facility field${ownerCimPrep.facFields.length === 1 ? '' : 's'}.`);
  };

  // ── Client Detail (item 29) owner responses + the any-format AI import ──
  const CLIENT_DETAIL_FORM_FIELDS = ['customerType', 'hasContract', 'effectiveDate', 'contractMonths', 'autoRenewal', 'renewedContractMonths', 'assignable', 'priceEscalator', 'escalatorPercent', 'earlyTermPenalty', 'billingFrequency', 'industry', 'tenure'];
  const ownerClientDetail = useMemo(() => {
    if (!Array.isArray(ownerFormResponses)) return null;
    const rows = {};
    let done = false;
    ownerFormResponses.forEach(r => {
      if (r.form_key !== 'client_detail') return;
      if (r.row_key === '' && r.field === '__done') { done = r.value === 'true'; return; }
      if (r.row_key !== '' && CLIENT_DETAIL_FORM_FIELDS.includes(r.field)) {
        (rows[r.row_key] = rows[r.row_key] || {})[r.field] = r.value;
      }
    });
    const filled = Object.keys(rows).filter(k => CLIENT_DETAIL_FORM_FIELDS.some(f => String(rows[k][f] || '').trim()));
    if (!filled.length && !done) return null;
    const shaped = {};
    filled.forEach(k => { shaped[k] = rows[k]; });
    return { rows: shaped, done };
  }, [ownerFormResponses]);

  // Marking Client Detail (item 29) complete HIDES the form from the owner's portal (Colleen 10-02, Blue
  // Spruce: marked complete 9/30 with zero portal answers — the owner could no longer see or fill it).
  // When the owner entered nothing in the portal, say so before it's hidden.
  const confirmClientDetailComplete = (doc, newStatus) => {
    if (!doc || doc.id !== 29 || newStatus !== 'complete' || doc.status === 'complete') return true;
    if (ownerClientDetail && Object.keys(ownerClientDetail.rows).length > 0) return true;
    return window.confirm('The owner has NOT entered anything in the portal Client Detail form.\n\nMarking it complete hides the form from their portal — they can no longer see or fill it.\n\nOK = mark complete anyway (e.g. they sent the details another way). Cancel = leave it open for the owner.');
  };
  // Apply detail rows into the sales grids (both bases, matched by NAME — the
  // detail fields aren't basis-specific). rows = [{ nameOrKey, fields }].
  // Blank values are SKIPPED (blank = not answered, never "No"); Yes/No parse;
  // months/percent parse a leading number. Returns { applied, orphans }.
  const applyOwnerClientDetailRows = (rowsIn, undoLabel) => {
    // Match against BOTH grids (RVS 2026-08-04: accrual-only deals have an
    // empty cash grid — matching cash-only orphaned every answer).
    const cashById = {}; const namesByLower = {};
    [...(customerSalesCash || []), ...(customerSalesAccrual || [])].forEach(c => {
      if (!(String(c.id) in cashById)) cashById[String(c.id)] = c;
      if (c.name && c.name.trim() && !namesByLower[c.name.trim().toLowerCase()]) namesByLower[c.name.trim().toLowerCase()] = c.name.trim();
    });
    const boolParse = (s) => { const t = String(s).trim().toLowerCase(); if (['yes', 'y', 'true', '1'].includes(t)) return true; if (['no', 'n', 'false', '0'].includes(t)) return false; return null; };
    const numParse = (s) => { const m = String(s).match(/-?\d+(\.\d+)?/); return m ? Number(m[0]) : null; };
    const byName = {}; const orphans = [];
    rowsIn.forEach(r => {
      const viaId = cashById[String(r.nameOrKey)];
      const name = viaId && viaId.name ? viaId.name.trim() : namesByLower[String(r.nameOrKey).trim().toLowerCase()];
      if (!name) { orphans.push(String(r.nameOrKey)); return; }
      byName[name.toLowerCase()] = r.fields;
    });
    const applyTo = (row) => {
      const f = row.name && byName[row.name.trim().toLowerCase()];
      if (!f) return row;
      const next = { ...row };
      CLIENT_DETAIL_FORM_FIELDS.forEach(field => {
        const raw = f[field];
        if (raw == null || !String(raw).trim()) return; // blank = not answered
        if (['hasContract', 'autoRenewal', 'assignable', 'priceEscalator', 'earlyTermPenalty'].includes(field)) {
          const b = boolParse(raw);
          if (b !== null) next[field] = b; // "Unsure" etc. stays untouched
          // An explicit contract answer (Yes OR No — incl. the Y/N sweep) is
          // observed data: the engine scores it instead of treating the row
          // as un-asked (top-20 fix, contractAnswered).
          if (field === 'hasContract' && b !== null) next.contractAnswered = true;
        } else if (['contractMonths', 'renewedContractMonths', 'escalatorPercent'].includes(field)) {
          const n = numParse(raw);
          if (n !== null) next[field] = n;
        } else if (field === 'customerType') {
          // The owner types words ("Business", "residential"); the grid's types are B2B / Residential /
          // Government / Non-Profit — "Business" stored as-is fell out of the B2B count (Blue Spruce 10-02).
          next[field] = normalizeOwnerClientType(raw);
        } else {
          next[field] = String(raw).trim();
        }
      });
      return next;
    };
    captureUndoState(undoLabel);
    setCustomerSalesCash(prev => (prev || []).map(applyTo));
    setCustomerSalesAccrual(prev => (prev || []).map(applyTo));
    return { applied: Object.keys(byName).length, orphans };
  };

  // Owner clicked "mark complete" without entering any data (Colleen,
  // Concise Computer Consulting 2026-08-03): with a rows-required guard the
  // accept was a silent no-op, so the review flag could never clear — a
  // stuck card. Any empty-done form gets acknowledge-and-clear instead.
  const acknowledgeEmptyOwnerForm = async (formKey, label) => {
    await markOwnerFormAccepted(formKey);
    if (supabaseClient && currentValuationId) {
      try {
        await supabaseClient.from('project_activity_log').insert({
          project_id: currentValuationId,
          actor_email: userEmail || 'unknown',
          actor_name: userEmail ? userEmail.split('@')[0] : null,
          kind: 'owner_form_accepted',
          note: `${label}: owner marked the form complete without entering data — acknowledged, nothing to apply`,
          metadata: { form_key: formKey, applied: 0, empty: true },
        });
      } catch (e) { console.warn('Owner form accept log failed:', e); }
    }
    alert(`The owner marked the ${label} form complete without entering any data.\n\nAcknowledged — the review flag is cleared. If you expected data, ask them to fill the form.`);
  };

  // ⬇ OWNER'S ANSWERS (Excel) — exactly what the owner submitted in the portal, one row per client,
  // plus whether that client's detail is in the grid right now (Colleen 10-05, Blue Spruce: 123 submitted
  // answers sat in storage while the grid was empty; seeing the submission would have shown it at once).
  const downloadOwnerClientDetail = () => {
    if (!ownerClientDetail || typeof XLSX === 'undefined') return;
    // Row keys are the grid row ids at form time — same lookup the Accept uses (cash first, then accrual).
    const byId = {};
    [...(customerSalesCash || []), ...(customerSalesAccrual || [])].forEach(c => { if (!(String(c.id) in byId)) byId[String(c.id)] = c; });
    const gridByName = {};
    [...(customerSalesAccrual || []), ...(customerSalesCash || [])].forEach(c => { if (c.name && c.name.trim()) gridByName[c.name.trim().toLowerCase()] = gridByName[c.name.trim().toLowerCase()] || c; });
    const inGrid = (g) => !!g && (g.hasContract === true || g.contractAnswered === true
      || (g.contractMonths !== null && g.contractMonths !== undefined && g.contractMonths !== 0)
      || g.autoRenewal || g.assignable || g.priceEscalator || g.earlyTermPenalty
      || ['effectiveDate', 'billingFrequency', 'industry', 'tenure'].some(k => g[k] && String(g[k]).trim()));
    const LABELS = { customerType: 'Customer type', hasContract: 'Under contract?', effectiveDate: 'Contract effective date',
      contractMonths: 'Original length (months)', autoRenewal: 'Auto-renews?', renewedContractMonths: 'Renewal term (months)',
      assignable: 'Transfers in a sale?', priceEscalator: 'Price increases?', escalatorPercent: 'Increase % / yr',
      earlyTermPenalty: 'Early-termination penalty?', billingFrequency: 'Billing frequency', industry: 'Client industry', tenure: 'Years as client' };
    const header = ['Client', 'TTM revenue', ...CLIENT_DETAIL_FORM_FIELDS.map(k => LABELS[k] || k), 'In VT grid now?'];
    const rows = Object.keys(ownerClientDetail.rows).map(k => {
      const g = byId[k];
      const name = g && g.name ? g.name.trim() : '(row ' + k + ' — not found in the grid)';
      const ans = ownerClientDetail.rows[k];
      const gridRow = g && g.name ? gridByName[g.name.trim().toLowerCase()] : null;
      return { ttm: Number((g && (g.ttm || g.year5)) || 0), row: [name, Number((g && (g.ttm || g.year5)) || 0),
        ...CLIENT_DETAIL_FORM_FIELDS.map(f => ans[f] == null ? '' : String(ans[f])), inGrid(gridRow) ? 'Yes' : 'No'] };
    }).sort((a, b) => b.ttm - a.ttm).map(r => r.row);
    const company = dealProfile.companyName || 'Owner';
    const ws = XLSX.utils.aoa_to_sheet([
      [`${company} — Client Detail as submitted by the owner (portal)`],
      [`${ownerClientDetail.done ? 'Submitted as complete' : 'In progress'} · ${rows.length} client${rows.length === 1 ? '' : 's'} answered · downloaded ${new Date().toLocaleDateString()}`],
      [],
      header, ...rows,
    ]);
    ws['!cols'] = header.map((h, i) => ({ wch: i === 0 ? 34 : Math.max(12, Math.min(26, h.length + 2)) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Owner answers');
    XLSX.writeFile(wb, `${company.replace(/[^a-zA-Z0-9]/g, '_')}_Owner_Client_Detail_Answers.xlsx`);
  };
  const acceptOwnerClientDetail = async () => {
    if (!ownerClientDetail) return;
    if (!Object.keys(ownerClientDetail.rows).length) {
      await acknowledgeEmptyOwnerForm('client_detail', 'Client Detail');
      return;
    }
    const rowsIn = Object.keys(ownerClientDetail.rows).map(k => ({ nameOrKey: k, fields: ownerClientDetail.rows[k] }));
    const { applied, orphans } = applyOwnerClientDetailRows(rowsIn, 'Accept owner Client Detail form');
    await markOwnerFormAccepted('client_detail');
    if (supabaseClient && currentValuationId) {
      try {
        await supabaseClient.from('project_activity_log').insert({
          project_id: currentValuationId,
          actor_email: userEmail || 'unknown',
          actor_name: userEmail ? userEmail.split('@')[0] : null,
          kind: 'owner_form_accepted',
          note: `Client Detail: ${applied} client${applied === 1 ? '' : 's'} accepted from the owner's portal form`,
          metadata: { form_key: 'client_detail', applied, orphans: orphans.length },
        });
      } catch (e) { console.warn('Owner form accept log failed:', e); }
    }
    alert(`✅ Applied owner detail for ${applied} client${applied === 1 ? '' : 's'}.`
      + (orphans.length ? `\n\n⚠️ ${orphans.length} answered client${orphans.length === 1 ? '' : 's'} no longer match${orphans.length === 1 ? 'es' : ''} a grid row (sales re-pasted since?).` : ''));
  };

  // Path (c) of the 2026-07-22 three-path amendment: the owner sent their
  // client info in SOME other format (contract list, CRM export, email) —
  // AI-map it onto the grid, keyed on matching client names. Mirrors the
  // FF&E AI import (same /api/cim/narrative endpoint + strict-JSON contract).
  const [showClientAIImport, setShowClientAIImport] = useState(false);
  const [clientAIText, setClientAIText] = useState('');
  const [clientAIBusy, setClientAIBusy] = useState(false);
  const importClientDetailWithAI = async () => {
    const raw = (clientAIText || '').trim();
    if (!raw) return;
    setClientAIBusy(true);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) throw new Error('not signed in');
      const clientNames = (customerSalesCash || []).map(c => (c.name || '').trim()).filter(Boolean);
      const system = [
        'You map pasted client/contract information (any format: contract lists, CRM exports, emails, notes) onto a known client list for a business valuation.',
        'Return STRICT JSON ONLY: an array of objects {"client": "<name from the KNOWN CLIENT LIST>", "customerType": "", "hasContract": "Yes|No|", "effectiveDate": "", "contractMonths": "", "autoRenewal": "Yes|No|", "renewedContractMonths": "", "assignable": "Yes|No|", "priceEscalator": "Yes|No|", "escalatorPercent": "", "earlyTermPenalty": "Yes|No|", "billingFrequency": "", "industry": "", "tenure": ""}.',
        '"client" MUST be an exact name from the KNOWN CLIENT LIST (match case-insensitively, tolerate minor punctuation/suffix differences like LLC/Inc). If a row in the source does not confidently match a known client, SKIP it.',
        'Leave any field you cannot determine as "". Do not invent values. Months/percent fields are plain numbers. No prose, no markdown, no code fences.'
      ].join('\n');
      const user = 'KNOWN CLIENT LIST:\n' + clientNames.join('\n') + '\n\nSOURCE DATA:\n' + raw;
      const resp = await fetch('/api/cim/narrative', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ system, user, maxTokens: 12000 })
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error((data && data.error) || ('HTTP ' + resp.status));
      if (data.refused) throw new Error('the model declined this request');
      let arr = [];
      try { arr = JSON.parse(String(data.text || '').replace(/^```json?\s*|```\s*$/g, '')); } catch (e) { throw new Error('could not parse the AI response as JSON'); }
      if (!Array.isArray(arr) || !arr.length) throw new Error('no client rows recognized in the pasted data');
      const rowsIn = arr.filter(r => r && r.client).map(r => {
        const fields = {};
        CLIENT_DETAIL_FORM_FIELDS.forEach(f => { if (r[f] != null) fields[f] = String(r[f]); });
        return { nameOrKey: String(r.client), fields };
      });
      const { applied, orphans } = applyOwnerClientDetailRows(rowsIn, 'AI import client details');
      if (supabaseClient && currentValuationId) {
        try {
          await supabaseClient.from('project_activity_log').insert({
            project_id: currentValuationId,
            actor_email: userEmail || 'unknown',
            actor_name: userEmail ? userEmail.split('@')[0] : null,
            kind: 'owner_form_accepted',
            note: `Client Detail: ${applied} client${applied === 1 ? '' : 's'} filled via AI import of owner-provided data`,
            metadata: { form_key: 'client_detail', source: 'ai_import', applied, orphans: orphans.length },
          });
        } catch (e) { console.warn('AI import log failed:', e); }
      }
      setShowClientAIImport(false);
      setClientAIText('');
      alert(`🤖 AI import complete: detail applied for ${applied} client${applied === 1 ? '' : 's'}.`
        + (orphans.length ? `\n\n⚠️ ${orphans.length} row${orphans.length === 1 ? '' : 's'} didn't match a grid client and ${orphans.length === 1 ? 'was' : 'were'} skipped.` : '')
        + `\n\nSpot-check the grid — AI mapping is a first pass, not gospel.`);
    } catch (e) {
      alert('AI import failed: ' + (e?.message || 'unknown error'));
    } finally {
      setClientAIBusy(false);
    }
  };

  // ========== COGS CATEGORIES (from P&L) ==========
  const [cogsCategories, setCogsCategories] = useState([
    { id: 1, name: '', 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }
  ]);

  // ========== VALUATION BASIS SELECTION ==========
  // 📌 Saved EBITDA snapshots (persisted in the deal's data) + archived revalue valuations (compare points).
  // Declared early: the then-vs-now memo and the snapshot checks read them further down.
  const [ebitdaSnapshots, setEbitdaSnapshots] = useState([]);
  // Ties to the source (Mark 10-12): the statements' own totals each paste captured, by period label —
  // and the ✓ Data entered check that compares them (computeTieOut / TieOutModal).
  const [sourceTotals, setSourceTotals] = useState({});
  const [handoffCheck, setHandoffCheck] = useState(null);
  const recordSourceTotals = (part, basis, byLabel, clearFirst) => {
    const at = new Date().toISOString();
    setSourceTotals(prev => {
      const p = prev && typeof prev === 'object' ? prev : {};
      const stamp = (base) => {
        const cur = clearFirst ? {} : { ...(base || {}) };
        Object.entries(byLabel || {}).forEach(([lbl, v]) => { cur[lbl] = { ...v, at }; });
        return cur;
      };
      return part === 'pl' ? { ...p, pl: { ...(p.pl || {}), [basis]: stamp(p.pl && p.pl[basis]) } } : { ...p, bs: stamp(p.bs) };
    });
  };
  const editorHandOff = (to, res) => {
    setHandoffCheck(null);
    const who = to === 'analysis_complete' ? 'the Lead' : 'Colleen';
    setWorkflow(w => ({ ...w, workflow_stage: to, stage_entered_at: new Date().toISOString() }));
    setHasUnsavedChanges(true);
    takeEbitdaSnapshot('handoff', 'data entered → ' + (to === 'analysis_complete' ? 'Lead' : 'Colleen'));
    if (currentValuationId) logActivity(currentValuationId, 'stage_changed', tieOutNote(who, res),
      { from: 'upload_complete', to, via: 'data_entered', tie_out: tieOutMeta(res), company: (dealProfile && dealProfile.companyName) || '' });
  };
  // From inside the check (Mark 10-12): a missing document gets "Not provided (yet)" + its reason right there.
  const editorMarkNotProvided = (doc, note) => {
    const list = documentChecklist.map(x => x.id === doc.id ? { ...x, status: 'not_provided', pendingNotes: note } : x);
    setDocumentChecklist(list);
    setHasUnsavedChanges(true);
    if (currentValuationId) logActivity(currentValuationId, 'document_not_provided', doc.name + ' marked not provided at this time — ' + note,
      { item_key: String(doc.id), display_name: doc.name, via: 'data_entered_check' });
    setHandoffCheck(h => (h ? { ...h, result: computeTieOut({ ...buildDealData(), documentChecklist: list }) } : h));
  };
  // REVENUE SCORING VERSION (Mark 10-06): 'mrr' = revenue mix scored on strict contract revenue vs the MRR
  // benchmark (+ small mix nudge), resold licensing not contracted, only contract growth is recurring growth;
  // 'legacy' = the pre-10-06 rules (weighted mix vs benchmark). Valuations already PRESENTED keep legacy until
  // their next revalue, so an owner deciding never sees their number move. Saved per valuation.
  const [revenueScoringSaved, setRevenueScoringSaved] = useState(null);
  // 💵 FREE-CASH-FLOW BASIS (Mark/Zac 10-20, Aeroform; ROADMAP #20). 'fcf': the multiple applies to EBITDA after
  // maintenance capex (= free cash flow), the multiple TIER is picked from EBITDA before capex (no double hit), and
  // catch-up capex (equipment already past due) comes off the price once. 'legacy': valuations delivered before
  // 10-20 keep the old math until revalued or switched on purpose (WC & CapEx tab).
  const [capexMethodSaved, setCapexMethodSaved] = useState(null);
  // 📉 GROWTH TEST (Mark + Zac 10-21, Aeroform: TTM down 18% but scored "growing" because 2024→2025 grew).
  // 'ttm': when there is a separate TTM, revenue counts as growing only if the TTM beat the last full year (the
  // period we value, and the first thing a buyer reads); no separate TTM → the last full year decides.
  // 'either': the old test (either period grew) for valuations presented before 10-21, until their next revalue.
  const [growthTestSaved, setGrowthTestSaved] = useState(null);
  // 🧾 Payroll tax method (10-22): 'wage_base' (accurate) | 'flat' (presented before 10-22, until revalued).
  const [payrollTaxMethodSaved, setPayrollTaxMethodSaved] = useState(null);
  // 📈 SPIKE MATH (Colleen 10-28 🐞, Forward Slash; Mark: "if its a bug, we'd always fix it"). 'consistent': a customer's
  // share of company growth compares the same two periods on both sides. 'mixed': the old math, which measured company
  // growth from the TTM total while comparing customers Year 4 to Year 5 when TTM ≈ Year 5. Presented before 10-28 keeps
  // 'mixed' until revalued (11 valuations, −0.01x to −0.07x).
  const [spikeMathSaved, setSpikeMathSaved] = useState(null);
  const [capexCatchUp, setCapexCatchUp] = useState({ amount: 0, note: '' });
  const capexMethod = useMemo(() => capexMethodSaved || (REV_SCORING_LEGACY_STAGES.has(workflow && workflow.workflow_stage) ? 'legacy' : 'fcf'), [capexMethodSaved, workflow && workflow.workflow_stage]);
  const growthTest = useMemo(() => growthTestSaved || (REV_SCORING_LEGACY_STAGES.has(workflow && workflow.workflow_stage) ? 'either' : 'ttm'), [growthTestSaved, workflow && workflow.workflow_stage]);
  const payrollTaxMethod = useMemo(() => payrollTaxMethodSaved || (REV_SCORING_LEGACY_STAGES.has(workflow && workflow.workflow_stage) ? 'flat' : 'wage_base'), [payrollTaxMethodSaved, workflow && workflow.workflow_stage]);
  const spikeMath = useMemo(() => spikeMathSaved || (REV_SCORING_LEGACY_STAGES.has(workflow && workflow.workflow_stage) ? 'mixed' : 'consistent'), [spikeMathSaved, workflow && workflow.workflow_stage]);
  const revenueScoringMode = useMemo(() => revenueScoringSaved || (REV_SCORING_LEGACY_STAGES.has(workflow && workflow.workflow_stage) ? 'legacy' : 'mrr'), [revenueScoringSaved, workflow && workflow.workflow_stage]);   // eslint-disable-line react-hooks/exhaustive-deps
  const [priorRevisionSnaps, setPriorRevisionSnaps] = useState([]);
  const [aiReviews, setAiReviews] = useState([]);           // 🤖 last AI reviews (persisted, max 5)
  const [aiReviewBusy, setAiReviewBusy] = useState(false);
  const [selectedValuationBasis, setSelectedValuationBasis] = useState('cash'); // which basis to use for valuation

  // ========== TAX RETURN TOTALS (simplified - no line items) ==========
  const [taxReturnTotals, setTaxReturnTotals] = useState({
    revenue: { year3: 0, year4: 0, year5: 0 },
    cogs: { year3: 0, year4: 0, year5: 0 },
    expenses: { year3: 0, year4: 0, year5: 0 }
  });

  // ========== REVENUE STREAM PROFITABILITY MATCHING ==========
  const [revenueStreams, setRevenueStreams] = useState([]);
  const [newStreamForm, setNewStreamForm] = useState({ name: '', revenueIds: [], cogsIds: [] });

  // ========== TTM MONTHLY DATA (Enhanced) ==========
  // Configuration for monthly TTM tab
  const [monthlyTtmConfig, setMonthlyTtmConfig] = useState({
    endMonth: new Date().getMonth(), // 0-11 (current month)
    endYear: new Date().getFullYear(),
    showArchive: false,
    useMonthlyForTtm: true, // when true, monthly sums override P&L Entry TTM
    useMonthlyForYtd: true, // when true, monthly sums override P&L Entry YTD
    varianceThreshold: 20, // percentage threshold for monthly highlighting
    annVsTtmVarianceThreshold: 15, // percentage threshold for Ann vs TTM highlighting
    annVsTtmMaterialityThreshold: 1000, // ignore items below this $ amount for variance highlighting
    monthlyMaterialityThreshold: 500, // ignore monthly items below this $ amount
    yoyCompareMode: 'prior', // 'prior' for YoY comparison, 'average' for avg comparison
    bsVarianceThreshold: 25, // percentage threshold for balance sheet highlighting
    bsMaterialityThreshold: 5000 // ignore BS items below this $ amount
  });
  
  // Variance notes for TTM monthly items { [categoryId_section]: 'note text' }
  const [monthlyTtmNotes, setMonthlyTtmNotes] = useState({});
  
  // Review flags for highlighting items that need attention
  // Structure: { [flagKey]: { note: string, created: timestamp, type: 'review'|'client'|'resolved' } }
  const [reviewFlags, setReviewFlags] = useState({});
  
  // Manual review flags for user-flagged items (questions, trends, etc.)
  // Structure: { [noteKey]: { flagged: boolean, type: 'question'|'trend'|'research'|'client', created: timestamp } }
  const [manualReviewFlags, setManualReviewFlags] = useState({});
  
  // ========== TTM BALANCE SHEET (Working Capital Analysis) ==========
  const [ttmBsMonthLabels, setTtmBsMonthLabels] = useState(() => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const now = new Date();
    const startMonth = now.getMonth();
    let year = now.getFullYear() - 1;
    const labels = [];
    for (let i = 0; i < 12; i++) {
      const monthIdx = (startMonth + i) % 12;
      if (i > 0 && monthIdx === 0) year++;
      labels.push(monthNames[monthIdx] + ' ' + year);
    }
    return labels;
  });
  const [ttmBsCurrentAssets, setTtmBsCurrentAssets] = useState([
    { id: 1, name: 'Cash', included: false, values: Array(12).fill(0) },
    { id: 2, name: 'Accounts Receivable', included: true, values: Array(12).fill(0) },
    { id: 3, name: 'Inventory', included: true, values: Array(12).fill(0) },
    { id: 4, name: 'Prepaid Expenses', included: true, values: Array(12).fill(0) }
  ]);
  const [ttmBsFixedAssets, setTtmBsFixedAssets] = useState([
    { id: 1, name: '', included: false, values: Array(12).fill(0) }
  ]);
  const [ttmBsOtherAssets, setTtmBsOtherAssets] = useState([
    { id: 1, name: '', included: false, values: Array(12).fill(0) }
  ]);
  const [ttmBsCurrentLiabilities, setTtmBsCurrentLiabilities] = useState([
    { id: 1, name: 'Accounts Payable', included: true, values: Array(12).fill(0) },
    { id: 2, name: 'Accrued Expenses', included: true, values: Array(12).fill(0) },
    { id: 3, name: 'Short-term Debt', included: false, values: Array(12).fill(0) },
    { id: 4, name: 'Deferred Revenue', included: true, values: Array(12).fill(0) }
  ]);
  const [ttmBsLongTermLiabilities, setTtmBsLongTermLiabilities] = useState([
    { id: 1, name: '', included: false, values: Array(12).fill(0) }
  ]);
  const [ttmBsEquity, setTtmBsEquity] = useState([
    { id: 1, name: '', included: false, values: Array(12).fill(0) }
  ]);
  const [wcPegMethodology, setWcPegMethodology] = useState('average');
  const [wcCustomMonths, setWcCustomMonths] = useState([]);
  const [wcShowOperating, setWcShowOperating] = useState(true);
  const [ttmBsCurrentAssetsExpanded, setTtmBsCurrentAssetsExpanded] = useState(false);
  const [ttmBsFixedAssetsExpanded, setTtmBsFixedAssetsExpanded] = useState(false);
  const [ttmBsOtherAssetsExpanded, setTtmBsOtherAssetsExpanded] = useState(false);
  const [ttmBsCurrentLiabilitiesExpanded, setTtmBsCurrentLiabilitiesExpanded] = useState(false);
  const [ttmBsLongTermLiabilitiesExpanded, setTtmBsLongTermLiabilitiesExpanded] = useState(false);
  const [ttmBsEquityExpanded, setTtmBsEquityExpanded] = useState(false);
  const [ttmBsDetailExpanded, setTtmBsDetailExpanded] = useState(false);
  const [showTtmBsPasteModal, setShowTtmBsPasteModal] = useState(false);
  const [ttmBsPasteData, setTtmBsPasteData] = useState('');
  
  // Roll-Off Risk Analysis state
  const [rollOffExpanded, setRollOffExpanded] = useState(true);
  const [rollOffProjectedMonths, setRollOffProjectedMonths] = useState([null, null, null, null]); // Next 4 months (null = use average)
  const [rollOffAcknowledged, setRollOffAcknowledged] = useState({ reviewed: false, reviewDate: '', notes: '' });
  
  // Generate month labels based on end month/year
  // Index 0-11 = TTM months (oldest to newest): 12 months ago through current
  // Index 12-23 = Archive months (oldest to newest): 24 months ago through 13 months ago
  const monthlyTtmLabels = useMemo(() => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const labels = [];
    
    // Calculate starting point: 11 months before end month (for TTM index 0)
    let month = monthlyTtmConfig.endMonth - 11;
    let year = monthlyTtmConfig.endYear;
    if (month < 0) {
      month += 12;
      year--;
    }
    
    // Generate TTM months (index 0-11): from 12 months ago to current
    for (let i = 0; i < 12; i++) {
      labels.push(`${monthNames[month]} '${year.toString().slice(-2)}`);  // apostrophe: 'Aug 26' read as the 26th (Colleen 08-19) — 'Aug '26' can't
      month++;
      if (month > 11) {
        month = 0;
        year++;
      }
    }
    
    // Calculate starting point for archive: 23 months before end month (for archive index 12)
    month = monthlyTtmConfig.endMonth - 23;
    year = monthlyTtmConfig.endYear;
    while (month < 0) {
      month += 12;
      year--;
    }
    
    // Generate Archive months (index 12-23): from 24 months ago to 13 months ago
    for (let i = 0; i < 12; i++) {
      labels.push(`${monthNames[month]} '${year.toString().slice(-2)}`);  // apostrophe: 'Aug 26' read as the 26th (Colleen 08-19) — 'Aug '26' can't
      month++;
      if (month > 11) {
        month = 0;
        year++;
      }
    }
    
    return labels;
  }, [monthlyTtmConfig.endMonth, monthlyTtmConfig.endYear]);
  
  // Formatted TTM label with date range derived from monthly TTM config
  const ttmLabel = useMemo(() => {
    // monthlyTtmLabels[0] = oldest month (start of TTM), monthlyTtmLabels[11] = newest (end of TTM)
    if (monthlyTtmLabels.length >= 12) {
      return `TTM (${monthlyTtmLabels[0]} - ${monthlyTtmLabels[11]})`;
    }
    return 'TTM';
  }, [monthlyTtmLabels]);
  
  // Formatted YTD label with date range - shows only months in the current year from the TTM period
  const ytdLabel = useMemo(() => {
    const endMonth = monthlyTtmConfig.endMonth;
    const endYear = monthlyTtmConfig.endYear;
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    // Build the TTM month map
    let m = endMonth - 11;
    let y = endYear;
    if (m < 0) { m += 12; y--; }
    
    const monthMap = [];
    for (let i = 0; i < 12; i++) {
      monthMap.push({ month: m, year: y });
      m++;
      if (m > 11) { m = 0; y++; }
    }
    
    // Find months in the current year (endYear)
    const ytdMonths = monthMap.filter(x => x.year === endYear);
    if (ytdMonths.length === 0) return 'YTD';
    
    const firstYtdMonth = ytdMonths[0];
    const lastYtdMonth = ytdMonths[ytdMonths.length - 1];
    
    return `YTD (${monthNames[firstYtdMonth.month]}'${String(firstYtdMonth.year).slice(-2)} - ${monthNames[lastYtdMonth.month]}'${String(lastYtdMonth.year).slice(-2)})`;
  }, [monthlyTtmConfig.endMonth, monthlyTtmConfig.endYear]);
  
  // Working Capital Calculations
  const wcCalculations = useMemo(() => {
    const monthlyData = ttmBsMonthLabels.map((label, idx) => {
      const operatingCA = ttmBsCurrentAssets.filter(a => a.included).reduce((sum, acct) => sum + (acct.values[idx] || 0), 0);
      const operatingCL = ttmBsCurrentLiabilities.filter(a => a.included).reduce((sum, acct) => sum + (acct.values[idx] || 0), 0);
      const totalCA = ttmBsCurrentAssets.reduce((sum, acct) => sum + (acct.values[idx] || 0), 0);
      const totalCL = ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[idx] || 0), 0);
      return { label, operatingCA, operatingCL, operatingNWC: operatingCA - operatingCL, totalCA, totalCL, totalNWC: totalCA - totalCL };
    });
    
    const validMonths = monthlyData.filter(m => m.operatingCA > 0 || m.operatingCL > 0);
    const hasData = validMonths.length > 0;
    const operatingNWCs = validMonths.map(m => m.operatingNWC);
    const sorted = [...operatingNWCs].sort((a, b) => a - b);
    
    let wcPeg = 0, wcPegLabel = '';
    if (hasData) {
      const avg = operatingNWCs.reduce((a, b) => a + b, 0) / operatingNWCs.length;
      if (wcPegMethodology === 'average') { wcPeg = avg; wcPegLabel = `${validMonths.length}-Month Average`; }
      else if (wcPegMethodology === 'excludeHighLow' && sorted.length >= 3) { const trimmed = sorted.slice(1, -1); wcPeg = trimmed.reduce((a, b) => a + b, 0) / trimmed.length; wcPegLabel = 'Avg (Excl. High/Low)'; }
      else if (wcPegMethodology === 'median') { const mid = Math.floor(sorted.length / 2); wcPeg = sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid]; wcPegLabel = 'Median'; }
      else if (wcPegMethodology === 'custom' && wcCustomMonths.length > 0) { const customVals = wcCustomMonths.map(idx => monthlyData[idx]?.operatingNWC || 0); wcPeg = customVals.reduce((a, b) => a + b, 0) / customVals.length; wcPegLabel = `${wcCustomMonths.length}-Month Custom`; }
      else { wcPeg = avg; wcPegLabel = `${validMonths.length}-Month Average`; }
    }
    
    const anomalies = [];
    for (let i = 1; i < monthlyData.length; i++) {
      const prev = monthlyData[i - 1].operatingNWC, curr = monthlyData[i].operatingNWC;
      if (prev !== 0) { const pctChange = ((curr - prev) / Math.abs(prev)) * 100; if (Math.abs(pctChange) > 25) anomalies.push({ fromMonth: monthlyData[i - 1].label, toMonth: monthlyData[i].label, change: curr - prev, pctChange }); }
    }
    
    return {
      monthlyData, validMonths: validMonths.length, hasData, wcPeg, wcPegLabel,
      operatingAvgNWC: hasData ? operatingNWCs.reduce((a, b) => a + b, 0) / operatingNWCs.length : 0,
      operatingAvgCA: hasData ? validMonths.reduce((s, m) => s + m.operatingCA, 0) / validMonths.length : 0,
      operatingAvgCL: hasData ? validMonths.reduce((s, m) => s + m.operatingCL, 0) / validMonths.length : 0,
      totalAvgNWC: hasData ? validMonths.reduce((s, m) => s + m.totalNWC, 0) / validMonths.length : 0,
      stats: { min: sorted[0] || 0, max: sorted[sorted.length - 1] || 0, range: (sorted[sorted.length - 1] || 0) - (sorted[0] || 0), minMonth: hasData ? monthlyData.find(m => m.operatingNWC === sorted[0])?.label : '', maxMonth: hasData ? monthlyData.find(m => m.operatingNWC === sorted[sorted.length - 1])?.label : '' },
      anomalies
    };
  }, [ttmBsCurrentAssets, ttmBsCurrentLiabilities, ttmBsMonthLabels, wcPegMethodology, wcCustomMonths]);
  
  // Monthly values per category - keyed by category ID
  // Structure: { [categoryId]: { cash: [24 numbers], accrual: [24 numbers] } }
  const [monthlyTtmRevenue, setMonthlyTtmRevenue] = useState({});
  const [monthlyTtmCogs, setMonthlyTtmCogs] = useState({});
  const [monthlyTtmOpex, setMonthlyTtmOpex] = useState({});
  const [monthlyTtmOtherIncome, setMonthlyTtmOtherIncome] = useState({});
  const [monthlyTtmOtherExpense, setMonthlyTtmOtherExpense] = useState({});
  const [monthlyTtmDiat, setMonthlyTtmDiat] = useState({
    depreciation: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
    interest: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
    amortization: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
    taxes: { cash: Array(24).fill(0), accrual: Array(24).fill(0) }
  });
  // Rows manually surfaced on the TTM Monthly tab (Colleen 08-18: a line
  // added on the P&L Entry tab is INVISIBLE here until it has monthly data —
  // and it can't get monthly data while invisible, so there was no way to
  // hand-enter a new line's months). Ids parked here render despite the
  // no-data filter; once a row has values the normal filter keeps it, so
  // session-only state is enough.
  const [ttmManualRows, setTtmManualRows] = useState([]);
  // The "＋ Add line…" picker on each TTM monthly section header: surfaces
  // an existing P&L Entry row that's hidden here (no monthly data on the
  // current basis), or creates a brand-new line on BOTH tabs.
  const ttmAddLineSelect = (sectionKey) => {
    const cfg = {
      revenue: { cats: revenueCategories, setCats: setRevenueCategories, monthly: monthlyTtmRevenue },
      cogs: { cats: cogsCategories, setCats: setCogsCategories, monthly: monthlyTtmCogs },
      opex: { cats: opexCategories, setCats: setOpexCategories, monthly: monthlyTtmOpex },
    }[sectionKey];
    const hidden = cfg.cats.filter(cat => cat.name
      && !(cfg.monthly[cat.id]?.[selectedValuationBasis] || []).some(v => v !== 0)
      && !ttmManualRows.includes(String(cat.id)));
    return (
      <select
        value=""
        onChange={e => {
          const v = e.target.value;
          if (!v) return;
          if (v === '__new__') {
            const name = window.prompt('Name the new line (it will appear on the P&L Entry tab too):');
            if (!name || !name.trim()) return;
            captureUndoState('Add TTM line');
            const id = Date.now();
            cfg.setCats(prev => [...prev, {
              id, name: name.trim(),
              ...(sectionKey === 'opex' && { plLine: 'Other', addbackPct: 0, diatFlag: null, adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true }),
              cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
              accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
              tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
            }]);
            setTtmManualRows(prev => [...prev, String(id)]);
          } else {
            setTtmManualRows(prev => [...prev, v]);
          }
        }}
        onClick={e => e.stopPropagation()}
        className="text-xs font-normal border border-gray-300 rounded px-1 py-0.5 bg-white cursor-pointer"
        title="Add a line to this tab: pick a P&L Entry line that isn't showing here yet (it has no monthly data on this basis), or create a brand-new line on both tabs."
      >
        <option value="">＋ Add line…</option>
        {hidden.map(c => <option key={c.id} value={String(c.id)}>{c.name} (from P&L Entry)</option>)}
        <option value="__new__">➕ New line…</option>
      </select>
    );
  };

  // Legacy TTM monthly data (kept for backwards compatibility)
  const [ttmMonthlyData, setTtmMonthlyData] = useState({
    revenue: [
      { month: 'Month 1', amount: 0 }, { month: 'Month 2', amount: 0 }, { month: 'Month 3', amount: 0 },
      { month: 'Month 4', amount: 0 }, { month: 'Month 5', amount: 0 }, { month: 'Month 6', amount: 0 },
      { month: 'Month 7', amount: 0 }, { month: 'Month 8', amount: 0 }, { month: 'Month 9', amount: 0 },
      { month: 'Month 10', amount: 0 }, { month: 'Month 11', amount: 0 }, { month: 'Month 12', amount: 0 }
    ],
    ebitda: [
      { month: 'Month 1', amount: 0 }, { month: 'Month 2', amount: 0 }, { month: 'Month 3', amount: 0 },
      { month: 'Month 4', amount: 0 }, { month: 'Month 5', amount: 0 }, { month: 'Month 6', amount: 0 },
      { month: 'Month 7', amount: 0 }, { month: 'Month 8', amount: 0 }, { month: 'Month 9', amount: 0 },
      { month: 'Month 10', amount: 0 }, { month: 'Month 11', amount: 0 }, { month: 'Month 12', amount: 0 }
    ],
    revenueReviewNotes: '',
    ebitdaReviewNotes: ''
  });

  // ========== KEYBOARD SHORTCUTS ==========
  // Ctrl+Z for undo, Ctrl+Y / Ctrl+Shift+Z for redo
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only trigger if not focused on an input/textarea
      const activeEl = document.activeElement;
      const isInputFocused = activeEl && (
        activeEl.tagName === 'INPUT' || 
        activeEl.tagName === 'TEXTAREA' ||
        activeEl.tagName === 'SELECT' ||   // a dropdown just changed: Ctrl+Z means "undo that pick", never a whole-file rollback (Blue Spruce 09-30)
        activeEl.contentEditable === 'true'
      );
      if (isInputFocused) return;
      
      // Ctrl+Shift+Z or Ctrl+Y = Redo
      if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
        if (redoStack.length > 0) {
          e.preventDefault();
          performRedo();
        }
      }
      // Ctrl+Z = Undo
      else if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
        if (undoStack.length > 0) {
          e.preventDefault();
          performUndo();
        }
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [undoStack.length, redoStack.length]);

  // ========== AUTO-SAVE TO CLOUD / LOCAL ==========
  // Ref-based pattern: the save function is recreated each render (so it
  // closes over current state), but the interval and visibility listener are
  // created ONCE per mount and invoke whatever's in the ref.
  //
  // Why: the previous version put `dealProfile`, `adjustmentItems`, etc. in
  // the effect's dep array, which tore down and re-created the 60s interval
  // on every keystroke. If a user typed continuously (e.g. entering a batch
  // of addbacks), the timer kept resetting and the auto-save never fired.
  // Colleen lost a long addback session this way 2026-05-25.
  // The persisted deal blob — EVERY key both save paths write. A closure over
  // current state, read at call time. saveDeal + autosave spread it; nothing
  // else should hand-list payload keys (see the drift notes inside).
  const buildDealData = () => ({
      version: '2.5',
      dealProfile,
      marketCondition,
      businessModel,
      selectedSector,
      selectedIndustry,
      revenueCategories,
      cogsCategories,
      opexCategories,
      otherIncomeCategories,
      otherExpenseCategories,
      diatCategories,
      revenueStreams,
      ttmMonthlyData,
      valuationBasis,
      addbacks,
      ownerCompensation,
      adjustmentItems,
      adjustmentsStatus,
      valuationInputs,
      documentChecklist,
      sellerQA,
      researchItems,
      acknowledgedFlags,
      multipleAdjustments,
      // New sales-data format (independent per-basis arrays)
      customerSalesCash,
      customerSalesAccrual,
      salesViewBasis,
      // Old-format mirror — written so a code revert can still read the file. Drop after stable.
      customerSalesData: customerSalesCash,
      customerSalesDataAlt: customerSalesAccrual,
      customerSalesBasis: 'cash',
      monthlySalesData,
      proFormaItems,
      proFormaValuationBasis,
      // Portfolio Consolidation rides with the deal (Colleen 10-16, Aeroform + AF Realty: it vanished on
      // every reopen and had to be reloaded from the downloaded .json).
      portfolio: { entities: portfolioEntities, assessment: portfolioAssessment, settings: portfolioSettings },
      customerYearLabels,
      salesTtmConfig,
      arAgingData,
      arAgingLineItems,
      arAgingBucketLabels,
      arReviewChecklist,
      arAgingNotes,
      salesDetailNotes,
      apAnalysis,
      apAgingLineItems,
      apAgingBucketLabels,
      apReviewChecklist,
      bsYearLabels,
      bsBasis,
      bsCurrentAssets,
      bsFixedAssets,
      bsOtherAssets,
      bsCurrentLiabilities,
      bsLongTermLiabilities,
      bsEquity,
      bsRecognitionNotes,
      bsIssueNotes,
      custRevenueNotes,
      industryMultipleAdjustment,
      basisComparisonData,
      taxFilingBasis,
      taxReturnTotals,
      selectedValuationBasis,
      basisYearLabels,
      monthlyTtmConfig,
      monthlyTtmRevenue,
      monthlyTtmCogs,
      monthlyTtmOpex,
      monthlyTtmOtherIncome,
      monthlyTtmOtherExpense,
      monthlyTtmDiat,
      monthlyTtmNotes,
      reviewFlags,
      manualReviewFlags,
      reconVarianceStatus,
      reconQualityChecklist,
      scheduleM1,
      bsVarianceStatus,
      incomeVarianceStatus,
      ttmBsMonthLabels,
      ttmBsCurrentAssets,
      ttmBsFixedAssets,
      ttmBsOtherAssets,
      ttmBsCurrentLiabilities,
      ttmBsLongTermLiabilities,
      ttmBsEquity,
      wcPegMethodology,
      wcCustomMonths,
      rollOffAcknowledged,
      // Analysis thresholds — also persisted by saveDeal; must be mirrored here
      // or each auto-save tick silently reverts them to defaults on reopen.
      varianceThreshold,
      reconMaterialityThreshold,
      arMaterialityThreshold,
      // CIM data collection — same: omitted here previously, so auto-save dropped it.
      cimTechStack,
      cimVendors,
      cimContractTerms,
      cimEmployees,
      cimEmpDisclosure,
      cimEmpComp,
      cimEmpIncentives,
      cimFFE,
      cimFFEDisclosure,
      cimFacility,
      cimLegal,
      cimGrowth,
      cimGrowthExtra,
      cimCustomGroups,
      cimClientAttrCols,
      cimTypedPanels,
      ebitdaSnapshots,
      sourceTotals,
      aiReviews,
      revenueScoring: revenueScoringMode,
      capexMethod, capexCatchUp, growthTest, payrollTaxMethod, spikeMath,
      // Payload-drift sweep (2026-07-27, found while fixing Colleen's vanishing
      // Schedule M-1): these keys were in saveDeal's payload but MISSING here,
      // so every 60-second autosave tick wrote a blob without them — silently
      // stripping whatever a manual Save had persisted. Same class as the two
      // comment-documented incidents above. REAL FIX QUEUED ON BOARD: one
      // shared buildDealData() for both save paths, so drift is impossible.
      dealStructure,
      sbaParams,
      baseMultipleTable,
      industryBenchmarks,
      blueprintTargetValuation,
      blueprintTimelineYears,
      blueprintTargetMargin,
      expandedSections,
      showInternalControls,
      showAllYears,
      incomeStmtViewMode,
      basisYearTab
    });
  const performAutoSaveRef = useRef(null);
  performAutoSaveRef.current = async () => {
    if (isReadOnlyViewer) return; // Account Managers are read-only — never persist
    if (!hasUnsavedChanges) return;
    // If anyone else is in this file, skip the auto-save tick. A silent background save
    // would advance updated_at and block the other viewer's legitimate save. Only manual
    // Save clicks are allowed when others are present (the conflict modal still nets them).
    if (cloudMode && otherViewersRef.current.length > 0) {
      setAutoSaveStatus('paused');
      return;
    }

    setAutoSaveStatus('saving');

    const autoSaveData = {
      ...buildDealData(),
      autoSavedAt: new Date().toISOString(),
    };

    // ── Q&A data-loss guard (2026-07-02) — MIRRORED in saveDeal; keep in sync ──
    // Never overwrite a saved, non-empty discovery Q&A with a blank one. A save
    // can run while `sellerQA` is still the blank default (deal not fully loaded,
    // or the load migration blanked it) and the conflict check only compares
    // updated_at, not content — so a blank editor could clobber real answers (this
    // wiped Netdemics + Mayfront on a revalue). Intentional "Clear Deal" bypasses
    // via suppressQAGuardRef; the DB re-read is cached per-deal so it costs nothing
    // on genuinely unanswered deals.
    {
      const qaAnswered = Array.isArray(autoSaveData.sellerQA)
        ? autoSaveData.sellerQA.filter(q => q && String(q.answer || '').trim()).length : 0;
      if (qaAnswered > 0) {
        qaGuardEmptyOkRef.current = null;
      } else if (suppressQAGuardRef.current) {
        suppressQAGuardRef.current = false;
      } else if (cloudMode && currentValuationId && supabaseClient
                 && qaGuardEmptyOkRef.current !== currentValuationId) {
        try {
          const { data: guardRow } = await supabaseClient
            .from('valuations').select('data').eq('id', currentValuationId).single();
          const dbQA = guardRow && guardRow.data && guardRow.data.sellerQA;
          const dbAnswered = Array.isArray(dbQA)
            ? dbQA.filter(q => q && String(q.answer || '').trim()).length : 0;
          if (dbAnswered > 0) {
            console.warn('[save-guard] Preserved ' + dbAnswered + ' saved Q&A answers — refused to overwrite with a blank set (autosave).');
            autoSaveData.sellerQA = dbQA;
            setSellerQA(dbQA);
          } else {
            qaGuardEmptyOkRef.current = currentValuationId;
          }
        } catch (guardErr) {
          console.warn('[save-guard] Q&A re-read failed; proceeding (autosave):', guardErr);
        }
      }
    }

    // Write a localStorage backup BEFORE attempting cloud save. Guarantees the
    // current edits survive even if cloud throws or the tab is killed before
    // the next tick. Keyed by valuation ID; pending-new files (no ID yet) skip.
    // Cleared on successful cloud save below.
    const fallbackKey = cloudMode && currentValuationId
      ? `vt_unsaved_backup_${currentValuationId}`
      : null;
    if (fallbackKey) {
      try {
        localStorage.setItem(fallbackKey, JSON.stringify({
          savedAt: autoSaveData.autoSavedAt,
          valuationName,
          data: autoSaveData
        }));
      } catch (storageErr) {
        console.warn('localStorage backup write failed:', storageErr);
      }
    }

    try {
      if (cloudMode) {
        const valuationRow = {
          name: valuationName || `${new Date().toISOString().split('T')[0]} Valuation`,
          version: 'v98-122-78',
          data: autoSaveData,
          updated_at: new Date().toISOString(),
          // Workflow columns (migration 004/005) — saved alongside the blob.
          ...buildWorkflowColumns()
        };
        if (currentValuationId) {
          // Conflict-detection: only update if updated_at still matches what we loaded.
          // If someone else saved in the meantime, the filter excludes the row and we
          // get back zero rows — surface that as a conflict instead of overwriting.
          // Runs under the save lock so it can never race the manual save path.
          const conflicted = await runExclusiveSave(async () => {
            let updateBuilder = supabaseClient
              .from('valuations')
              .update(valuationRow)
              .eq('id', currentValuationId);
            if (loadedUpdatedAtRef.current) {
              updateBuilder = updateBuilder.eq('updated_at', loadedUpdatedAtRef.current);
            }
            const { data: updRows, error: updErr } = await updateBuilder.select('updated_at');
            if (updErr) throw updErr;
            if (!updRows || updRows.length === 0) return true;
            loadedUpdatedAtRef.current = updRows[0].updated_at;
            return false;
          });
          if (conflicted) {
            setSaveConflict(true);
            setAutoSaveStatus('');
            setCloudSaveError('Save blocked: another user has saved changes to this file.');
            return;
          }
          // Mirror checklist to engagement_checklist_items on autosave too (Stage A).
          syncChecklistToTable(currentValuationId);
        } else {
          if (!currentClient?.id) {
            setAutoSaveStatus('');
            return;
          }
          const { data: inserted, error: insErr } = await supabaseClient
            .from('valuations')
            .insert({ ...valuationRow, client_id: currentClient.id, created_at: new Date().toISOString() })
            .select()
            .single();
          if (insErr) throw insErr;
          if (inserted) {
            setCurrentValuationId(inserted.id);
            loadedUpdatedAtRef.current = inserted.updated_at || valuationRow.updated_at;
            syncChecklistToTable(inserted.id);
          }
        }
        // Propagate Setup-tab rename to clients.company_name so ClientList search/display stay current.
        const trimmedName = dealProfile.companyName?.trim();
        const clientIdForSync = currentClient?.id || currentValuation?.client_id;
        if (trimmedName && clientIdForSync && trimmedName !== lastSyncedClientNameRef.current) {
          try {
            const { error: clientUpdErr } = await supabaseClient
              .from('clients')
              .update({ company_name: trimmedName })
              .eq('id', clientIdForSync);
            if (clientUpdErr) throw clientUpdErr;
            lastSyncedClientNameRef.current = trimmedName;
          } catch (clientErr) {
            console.warn('Client name sync failed:', clientErr);
          }
        }
        // Mirror Vista ID to clients.vista_id so a future valuation for
        // the same client picks it up automatically.
        const vistaIdToSync = (dealProfile.vistaId || '').trim();
        if (clientIdForSync && vistaIdToSync !== lastSyncedVistaIdRef.current) {
          try {
            const { error: vidErr } = await supabaseClient
              .from('clients')
              .update({ vista_id: vistaIdToSync || null })
              .eq('id', clientIdForSync);
            if (vidErr) throw vidErr;
            lastSyncedVistaIdRef.current = vistaIdToSync;
          } catch (vidSyncErr) {
            console.warn('Vista ID sync failed:', vidSyncErr);
          }
        }
        setHasUnsavedChanges(false);
        setCloudSaveError('');
        // Cloud save succeeded — clear the local backup; cloud is now the source of truth.
        if (fallbackKey) {
          try { localStorage.removeItem(fallbackKey); } catch (e) {}
        }
      } else {
        sessionStorage.setItem(AUTO_SAVE_KEY, JSON.stringify(autoSaveData));
      }
      setLastAutoSave(new Date());
      setAutoSaveStatus('saved');
      setTimeout(() => setAutoSaveStatus(''), 2000);
    } catch (err) {
      console.error('Auto-save failed:', err);
      setAutoSaveStatus('');
      if (cloudMode) setCloudSaveError(err.message || 'Save failed');
      // The localStorage backup was already written above, so work is safe
      // and will be offered for restore on the next open of this valuation.
    }
  };

  // 60-second tick. Created ONCE per mount; invokes whatever's in the ref.
  // No state deps — never tears down on edit (that's what caused the bug).
  useEffect(() => {
    const autoSaveInterval = setInterval(() => {
      performAutoSaveRef.current?.();
    }, 60000);
    return () => clearInterval(autoSaveInterval);
  }, []);

  // Save immediately when the tab becomes hidden — catches close/switch faster
  // than the next 60s tick. Important when the browser suppresses beforeunload
  // (no recent user gesture, tab-discard scenarios).
  useEffect(() => {
    const onVisChange = () => {
      if (document.hidden) {
        performAutoSaveRef.current?.();
      }
    };
    document.addEventListener('visibilitychange', onVisChange);
    return () => document.removeEventListener('visibilitychange', onVisChange);
  }, []);

  // One-shot persist for a freshly-seeded New Project (Stage 1.5). The seed
  // flips hasUnsavedChanges true (reliably, regardless of which fields were
  // filled); on that transition we insert the row so the project lands in
  // the DB + dashboard immediately rather than waiting for the 60s tick or
  // the exit save. Guarded by the ref so it fires exactly once.
  useEffect(() => {
    if (!pendingSeedSaveRef.current || !hasUnsavedChanges) return;
    pendingSeedSaveRef.current = false;
    const t = setTimeout(() => { performAutoSaveRef.current?.(); }, 300);
    return () => clearTimeout(t);
  }, [hasUnsavedChanges]);

  // Track unsaved changes - mark as changed when key data updates
  // Suppressed during initial hydration so loading a file doesn't falsely flag it as edited
  // (which would otherwise trigger a phantom auto-save and clobber other viewers' work).
  useEffect(() => {
    if (isHydratingRef.current) return;
    setHasUnsavedChanges(true);
  }, [dealProfile, revenueCategories, cogsCategories, opexCategories, adjustmentItems, adjustmentsStatus, ownerCompensation, sellerQA, researchItems, documentChecklist, customerSalesData, proFormaItems, arAgingLineItems, arAgingBucketLabels, apAgingLineItems, apAgingBucketLabels, bsCurrentAssets, bsFixedAssets, bsOtherAssets, bsCurrentLiabilities, bsLongTermLiabilities, bsEquity, taxReturnTotals, otherIncomeCategories, otherExpenseCategories, scheduleM1, ttmBsCurrentAssets, ttmBsCurrentLiabilities, ttmBsMonthLabels, selectedIndustry, selectedSector]);

  // Mirror otherViewers into a ref so the auto-save interval can read fresh values
  // without forcing the interval to be torn down on every poll cycle.
  useEffect(() => { otherViewersRef.current = otherViewers; }, [otherViewers]);

  // Warn before leaving page if there are unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return e.returnValue;
      }
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  // Check for auto-saved data on mount
  useEffect(() => {
    if (cloudMode) return; // Cloud mode uses Supabase load; skip sessionStorage prompt
    try {
      const autoSaved = sessionStorage.getItem(AUTO_SAVE_KEY);
      if (autoSaved) {
        const data = JSON.parse(autoSaved);
        const savedDate = new Date(data.autoSavedAt);
        const hoursSince = (Date.now() - savedDate.getTime()) / (1000 * 60 * 60);
        
        // Only offer to restore if saved within last 24 hours
        if (hoursSince < 24 && data.dealProfile?.companyName) {
          const restore = window.confirm(
            `Found auto-saved data for "${data.dealProfile.companyName}" from ${savedDate.toLocaleString()}.\n\nWould you like to restore it?`
          );
          
          if (restore) {
            // Restore the data
            // Pre-Setup-tab files (Colleen 08-19, Forward Slash Technology: the
            // editor showed 'New Deal - Enter company name' while the client list
            // knew the name). The client record backfills company/city/state into
            // an existing valuation's Deal Profile wherever they're blank — the
            // saved value always wins when present.
            if (data.dealProfile) setDealProfile(prev => ({
              ...prev, ...data.dealProfile,
              ...(currentClient && !String(data.dealProfile.companyName || '').trim() ? { companyName: currentClient.company_name || '' } : {}),
              ...(currentClient && !String(data.dealProfile.city || '').trim() ? { city: currentClient.city || '' } : {}),
              ...(currentClient && !String(data.dealProfile.state || '').trim() ? { state: currentClient.state || '' } : {}),
            }));
            if (data.marketCondition) setMarketCondition(data.marketCondition);
            if (data.businessModel) setBusinessModel(data.businessModel);
            if (data.selectedSector) setSelectedSector(data.selectedSector);
            if (data.selectedIndustry) setSelectedIndustry(data.selectedIndustry);
            // Migration: ensure tax property exists on categories from older saves
            const ensureTaxProp = (cats) => cats?.map(cat => ({
              ...cat,
              tax: cat.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
            }));
            // Migration: ensure addback fields exist on expense categories from older saves
            const ensureAddbackFields = (cats) => cats?.map(cat => ({
              ...cat,
              tax: cat.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 },
              addbackPct: cat.addbackPct || 0,
              adjCategory: cat.adjCategory || '',
              adjDescription: cat.adjDescription || '',
              adjVerSource: cat.adjVerSource || '',
              adjDocRef: cat.adjDocRef || '',
              adjIncluded: cat.adjIncluded !== undefined ? cat.adjIncluded : true
            }));
            if (data.revenueCategories) setRevenueCategories(ensureTaxProp(data.revenueCategories));
            if (data.cogsCategories) setCogsCategories(ensureTaxProp(data.cogsCategories));
            if (data.opexCategories) setOpexCategories(ensureAddbackFields(data.opexCategories));
            if (data.otherIncomeCategories) setOtherIncomeCategories(ensureAddbackFields(ensureTaxProp(data.otherIncomeCategories)));
            if (data.otherExpenseCategories) setOtherExpenseCategories(ensureAddbackFields(data.otherExpenseCategories));
            if (data.diatCategories) setDiatCategories(data.diatCategories);
            if (data.revenueStreams) setRevenueStreams(data.revenueStreams);
            if (data.ownerCompensation) {
              const oc = { ...data.ownerCompensation };
              // Auto-verify when embedded in wages with no separate salary — nothing to verify
              if (oc.embeddedInWages && (!oc.ttm?.salary || oc.ttm.salary === 0) && (!oc.marketReplacement || oc.marketReplacement === 0) && oc.ttm) {
                oc.ttm = { ...oc.ttm, verified: true };
              }
              setOwnerCompensation(oc);
            }
            if (data.adjustmentItems) setAdjustmentItems(data.adjustmentItems);
            if (data.valuationInputs) setValuationInputs(data.valuationInputs);
            if (data.documentChecklist) {
              // Migration: Remove id 6 (TTM Sales Report by Customer) which was removed from the tool
              // Migration: Convert old 'received' boolean to new 'status' field
              // Migration: Add document 27 (Cash P&L) if it doesn't exist (for old saves)
              let migratedChecklist = data.documentChecklist.filter(d => d.id !== 6).map(d => {
                // If already has status field, keep as is; otherwise migrate from received boolean
                if (d.status) { if (d.received === undefined) return d; const { received, ...rest } = d; return rest; } // status is the truth — drop the legacy boolean so it can never shadow it again (Forward Slash 08-21)
                return {
                  ...d,
                  status: d.received ? 'complete' : 'not_received',
                  receivedNotes: d.receivedNotes || '',
                  pendingNotes: d.pendingNotes || ''
                };
              });
              // Add Cash P&L (id 27) if missing
              if (!migratedChecklist.find(d => d.id === 27)) {
                const insertIdx = migratedChecklist.findIndex(d => d.id === 2);
                const newDoc = { id: 27, name: 'P&L Statements (3 years) - Cash - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' };
                if (insertIdx >= 0) {
                  migratedChecklist.splice(insertIdx, 0, newDoc);
                } else {
                  migratedChecklist.push(newDoc);
                }
              }
              // Add Revenue Classification Form (id 28) if missing — VT-generated after P&Ls received
              if (!migratedChecklist.find(d => d.id === 28)) {
                const insertIdx = migratedChecklist.findIndex(d => d.id === 27);
                const newDoc = { id: 28, name: 'Revenue Classification Form', status: 'not_received', dateProvided: '', notes: 'VT-generated after P&Ls are entered; owner classifies revenue lines and returns', receivedNotes: '', pendingNotes: '', tier: 'full', unlockedBy: [1, 27] };
                if (insertIdx >= 0) {
                  migratedChecklist.splice(insertIdx + 1, 0, newDoc);
                } else {
                  migratedChecklist.push(newDoc);
                }
              }
              // Add Client Detail Form (id 29) if missing — VT-generated after Sales Report received
              if (!migratedChecklist.find(d => d.id === 29)) {
                const insertIdx = migratedChecklist.findIndex(d => d.id === 26);
                const newDoc = { id: 29, name: 'Client Detail Form', status: 'not_received', dateProvided: '', notes: 'VT-generated after Sales Report is entered; owner provides additional client info and returns', receivedNotes: '', pendingNotes: '', tier: 'full', unlockedBy: [5, 26] };
                if (insertIdx >= 0) {
                  migratedChecklist.splice(insertIdx + 1, 0, newDoc);
                } else {
                  migratedChecklist.push(newDoc);
                }
              }
              // Update document 1 name if it's the old combined name
              migratedChecklist = migratedChecklist.map(d => {
                if (d.id === 1 && d.name.includes('Cash & Accrual')) {
                  return { ...d, name: 'P&L Statements (3 years) - Accrual - Excel' };
                }
                return d;
              });
              setDocumentChecklist(migratedChecklist);
            }
            if (data.sellerQA) {
              // Merge auto-saved answers into current question structure
              // (same merge logic as main file load — preserves answers even if question list changed)
              setSellerQA(prev => prev.map(defQ => {
                const saved = data.sellerQA.find(q => q.id === defQ.id);
                if (saved) {
                  return {
                    ...defQ,
                    answer: saved.answer || '',
                    status: saved.status || 'pending',
                    numericValue: saved.numericValue !== undefined ? saved.numericValue : defQ.numericValue,
                    numericValue2: saved.numericValue2 !== undefined ? saved.numericValue2 : defQ.numericValue2,
                    ...(Array.isArray(saved.positions) ? { positions: saved.positions } : {}),
                    followUps: saved.followUps || []
                  };
                }
                return defQ;
              }));
            }
            if (data.researchItems) setResearchItems(data.researchItems);
            if (data.acknowledgedFlags) setAcknowledgedFlags(data.acknowledgedFlags);
            if (data.multipleAdjustments) {
              // Merge with defaults to ensure new fields exist in old saves
              setMultipleAdjustments(prev => ({
                ...prev,
                ...data.multipleAdjustments,
                workingCapitalQuality: {
                  arPastDueOverride: null, arPastDueNotes: '', arPastDueReviewed: false,
                  arSeriousOverride: null, arSeriousNotes: '', arSeriousReviewed: false,
                  negativeBalancesOverride: null, negativeBalancesNotes: '', negativeBalancesReviewed: false,
                  ...(data.multipleAdjustments.workingCapitalQuality || {})
                }
              }));
            }
            // Sales data — prefer new format (customerSalesCash/customerSalesAccrual); fall back
            // to migrating from the old format (data/dataAlt + customerSalesBasis flag).
            if (data.customerSalesCash) {
              setCustomerSalesCash(deduplicateCustomers(data.customerSalesCash));
              setCustomerSalesAccrual(data.customerSalesAccrual ? deduplicateCustomers(data.customerSalesAccrual) : []);
            } else if (data.customerSalesData) {
              const oldBasis = data.customerSalesBasis || 'cash';
              const primary = deduplicateCustomers(data.customerSalesData);
              const alt = data.customerSalesDataAlt ? deduplicateCustomers(data.customerSalesDataAlt) : [];
              if (oldBasis === 'cash') { setCustomerSalesCash(primary); setCustomerSalesAccrual(alt); }
              else { setCustomerSalesAccrual(primary); setCustomerSalesCash(alt); }
            }
            if (data.monthlySalesData) setMonthlySalesData(data.monthlySalesData);
            if (data.salesViewBasis) setSalesViewBasis(data.salesViewBasis);
            else if (data.customerSalesBasis) setSalesViewBasis(data.customerSalesBasis);
            if (data.blueprintTargetValuation != null) setBlueprintTargetValuation(data.blueprintTargetValuation);
            else setBlueprintTargetValuation(null);
            if (data.blueprintTimelineYears != null) setBlueprintTimelineYears(data.blueprintTimelineYears);
            else setBlueprintTimelineYears(null);
            if (data.blueprintTargetMargin != null) setBlueprintTargetMargin(data.blueprintTargetMargin);
            else setBlueprintTargetMargin(null);
            if (data.proFormaItems) setProFormaItems(data.proFormaItems);
            if (data.proFormaValuationBasis) setProFormaValuationBasis(data.proFormaValuationBasis);
            restorePortfolio(data.portfolio);
            if (data.customerYearLabels) setCustomerYearLabels(data.customerYearLabels);
            if (data.salesTtmConfig) setSalesTtmConfig({ ...data.salesTtmConfig, useMonthlyForTtm: true }); else if (data.monthlyTtmConfig) setSalesTtmConfig({ endMonth: data.monthlyTtmConfig.endMonth, endYear: data.monthlyTtmConfig.endYear });
            if (data.arAgingData) setArAgingData(data.arAgingData);
            if (data.arAgingLineItems) setArAgingLineItems(data.arAgingLineItems);
            if (data.arAgingBucketLabels) setArAgingBucketLabels(data.arAgingBucketLabels);
            if (data.arReviewChecklist) setArReviewChecklist(data.arReviewChecklist);
            if (data.arAgingNotes) setArAgingNotes(data.arAgingNotes);
            if (data.salesDetailNotes) setSalesDetailNotes(data.salesDetailNotes);
            if (data.apAnalysis) setApAnalysis(data.apAnalysis);
            if (data.apAgingLineItems) setApAgingLineItems(data.apAgingLineItems);
            if (data.apAgingBucketLabels) setApAgingBucketLabels(data.apAgingBucketLabels);
            if (data.apReviewChecklist) setApReviewChecklist(data.apReviewChecklist);
            if (data.bsYearLabels) setBsYearLabels(data.bsYearLabels);
            if (data.bsBasis) setBsBasis(data.bsBasis);
            if (data.bsCurrentAssets) setBsCurrentAssets(data.bsCurrentAssets);
            if (data.bsFixedAssets) setBsFixedAssets(data.bsFixedAssets);
            if (data.bsOtherAssets) setBsOtherAssets(data.bsOtherAssets);
            if (data.bsCurrentLiabilities) setBsCurrentLiabilities(data.bsCurrentLiabilities);
            if (data.bsLongTermLiabilities) setBsLongTermLiabilities(data.bsLongTermLiabilities);
            if (data.bsEquity) setBsEquity(data.bsEquity);
            if (data.bsRecognitionNotes) setBsRecognitionNotes(data.bsRecognitionNotes);
            if (data.bsIssueNotes) setBsIssueNotes(data.bsIssueNotes);
            if (data.custRevenueNotes) setCustRevenueNotes(data.custRevenueNotes);
            if (data.industryMultipleAdjustment) setIndustryMultipleAdjustment(data.industryMultipleAdjustment);
            if (data.basisComparisonData) setBasisComparisonData(data.basisComparisonData);
            if (data.taxFilingBasis) setTaxFilingBasis(data.taxFilingBasis);
            if (data.taxReturnTotals) {
              // Migrate old year1/year2/year3 to year3/year4/year5 if needed
              // Use nullish coalescing (??) to preserve 0 values, only fall back if undefined/null
              const t = data.taxReturnTotals;
              const hasNewSchema = t.revenue?.year5 !== undefined || t.revenue?.year4 !== undefined;
              const migratedTotals = {
                revenue: {
                  year3: t.revenue?.year3 ?? (hasNewSchema ? 0 : (t.revenue?.year1 ?? 0)),
                  year4: t.revenue?.year4 ?? (hasNewSchema ? 0 : (t.revenue?.year2 ?? 0)),
                  year5: t.revenue?.year5 ?? 0
                },
                cogs: {
                  year3: t.cogs?.year3 ?? (hasNewSchema ? 0 : (t.cogs?.year1 ?? 0)),
                  year4: t.cogs?.year4 ?? (hasNewSchema ? 0 : (t.cogs?.year2 ?? 0)),
                  year5: t.cogs?.year5 ?? 0
                },
                expenses: {
                  year3: t.expenses?.year3 ?? 0,
                  year4: t.expenses?.year4 ?? 0,
                  year5: t.expenses?.year5 ?? 0
                }
              };
              setTaxReturnTotals(migratedTotals);
            }
            if (data.selectedValuationBasis) setSelectedValuationBasis(data.selectedValuationBasis);
            if (data.basisYearLabels) setBasisYearLabels(data.basisYearLabels);
            if (data.monthlyTtmConfig) setMonthlyTtmConfig(data.monthlyTtmConfig);
            if (data.monthlyTtmRevenue) setMonthlyTtmRevenue(data.monthlyTtmRevenue);
            if (data.monthlyTtmCogs) setMonthlyTtmCogs(data.monthlyTtmCogs);
            if (data.monthlyTtmOpex) setMonthlyTtmOpex(data.monthlyTtmOpex);
            if (data.monthlyTtmOtherIncome) setMonthlyTtmOtherIncome(data.monthlyTtmOtherIncome);
            if (data.monthlyTtmOtherExpense) setMonthlyTtmOtherExpense(data.monthlyTtmOtherExpense);
            if (data.monthlyTtmDiat) setMonthlyTtmDiat(data.monthlyTtmDiat);
            if (data.monthlyTtmNotes) setMonthlyTtmNotes(data.monthlyTtmNotes);
            if (data.reviewFlags) setReviewFlags(data.reviewFlags);
            if (data.manualReviewFlags) setManualReviewFlags(data.manualReviewFlags);
            if (data.reconVarianceStatus) setReconVarianceStatus(data.reconVarianceStatus);
            if (data.reconQualityChecklist) setReconQualityChecklist(data.reconQualityChecklist);
            if (data.scheduleM1) setScheduleM1(data.scheduleM1);
            if (data.bsVarianceStatus) setBsVarianceStatus(data.bsVarianceStatus);
            if (data.incomeVarianceStatus) setIncomeVarianceStatus(data.incomeVarianceStatus);
            if (data.ttmBsMonthLabels) setTtmBsMonthLabels(data.ttmBsMonthLabels);
            if (data.ttmBsCurrentAssets) setTtmBsCurrentAssets(data.ttmBsCurrentAssets);
            if (data.ttmBsFixedAssets) setTtmBsFixedAssets(data.ttmBsFixedAssets);
            if (data.ttmBsOtherAssets) setTtmBsOtherAssets(data.ttmBsOtherAssets);
            if (data.ttmBsCurrentLiabilities) setTtmBsCurrentLiabilities(data.ttmBsCurrentLiabilities);
            if (data.ttmBsLongTermLiabilities) setTtmBsLongTermLiabilities(data.ttmBsLongTermLiabilities);
            if (data.ttmBsEquity) setTtmBsEquity(data.ttmBsEquity);
            if (data.wcPegMethodology) setWcPegMethodology(data.wcPegMethodology);
            if (data.wcCustomMonths) setWcCustomMonths(data.wcCustomMonths);
            if (data.rollOffAcknowledged) setRollOffAcknowledged(data.rollOffAcknowledged);
            if (data.cimTechStack) setCimTechStack(data.cimTechStack);
            if (data.cimVendors) setCimVendors(data.cimVendors);
            if (data.cimContractTerms) setCimContractTerms(data.cimContractTerms);
            if (data.cimEmployees) setCimEmployees(data.cimEmployees);
            if (data.cimEmpDisclosure) setCimEmpDisclosure(data.cimEmpDisclosure);
            if (data.cimEmpComp) setCimEmpComp(data.cimEmpComp);
            if (data.cimEmpIncentives != null) setCimEmpIncentives(data.cimEmpIncentives);
            if (data.cimFFE) setCimFFE(data.cimFFE);
            if (data.cimFFEDisclosure) setCimFFEDisclosure(data.cimFFEDisclosure);
            if (Array.isArray(data.cimCustomGroups)) setCimCustomGroups(data.cimCustomGroups);
            if (Array.isArray(data.cimClientAttrCols)) setCimClientAttrCols(data.cimClientAttrCols);
            if (Array.isArray(data.cimTypedPanels)) setCimTypedPanels(data.cimTypedPanels);
            setEbitdaSnapshots(Array.isArray(data.ebitdaSnapshots) ? data.ebitdaSnapshots : []);
            setSourceTotals(data.sourceTotals && typeof data.sourceTotals === 'object' ? data.sourceTotals : {});
            setRevenueScoringSaved(data.revenueScoring === 'legacy' || data.revenueScoring === 'mrr' ? data.revenueScoring : null);
            setCapexMethodSaved(data.capexMethod === 'legacy' || data.capexMethod === 'fcf' ? data.capexMethod : null);
            setGrowthTestSaved(data.growthTest === 'either' || data.growthTest === 'ttm' ? data.growthTest : null); setPayrollTaxMethodSaved(data.payrollTaxMethod === 'flat' || data.payrollTaxMethod === 'wage_base' ? data.payrollTaxMethod : null); setSpikeMathSaved(data.spikeMath === 'mixed' || data.spikeMath === 'consistent' ? data.spikeMath : null);
            setCapexCatchUp(data.capexCatchUp && typeof data.capexCatchUp === 'object' ? { amount: Number(data.capexCatchUp.amount) || 0, note: String(data.capexCatchUp.note || '') } : { amount: 0, note: '' });
            setAiReviews(Array.isArray(data.aiReviews) ? data.aiReviews : []);
            if (data.cimFacility) setCimFacility(data.cimFacility);
            if (data.cimLegal) setCimLegal(data.cimLegal);
            if (data.cimGrowth) setCimGrowth(data.cimGrowth);
            if (data.cimGrowthExtra) setCimGrowthExtra(data.cimGrowthExtra);
            if (data.varianceThreshold !== undefined) setVarianceThreshold(data.varianceThreshold);
            if (data.reconMaterialityThreshold !== undefined) setReconMaterialityThreshold(data.reconMaterialityThreshold);
            if (data.arMaterialityThreshold !== undefined) setArMaterialityThreshold(data.arMaterialityThreshold);
            
            setHasUnsavedChanges(false);
          } else {
            // User declined - clear auto-save
            sessionStorage.removeItem(AUTO_SAVE_KEY);
          }
        }
      }
    } catch (err) {
      console.error('Error checking auto-save:', err);
    }
  }, []);

  // ========== SUPABASE LOAD ON MOUNT (cloud mode) ==========
  // If opened from ClientList with an existing valuation, fetch its data and apply it.
  // If opened as "New Valuation" with a client, pre-populate dealProfile from the client.
  useEffect(() => {
    if (!cloudMode) return;
    if (hasHydratedRef.current) return; // Only hydrate once per mount
    hasHydratedRef.current = true;
    (async () => {
      try {
        if (currentValuation?.id) {
          // Load existing valuation
          const { data: row, error } = await supabaseClient
            .from('valuations')
            .select('*')
            .eq('id', currentValuation.id)
            .single();
          if (error) throw error;
          if (row?.data) {
            applyLoadedData(row.data);
          }
          if (row?.name) setValuationName(row.name);
          // Populate workflow state from the row's dedicated columns
          // (these are NOT in the data JSONB blob — migration 004/005).
          // IMPORTANT: this must run BEFORE setCurrentValuationId below.
          // setCurrentValuationId is the trigger for the cadence
          // autoAction useEffect (deps: [currentValuationId]); React 17
          // does not batch setStates after an await, so if currentValuationId
          // were set first, the autoAction effect would fire on a render
          // where workflow still holds initial-blank values — buildCadenceEmailNote's
          // closure would freeze "Your account manager" / blank lead etc.
          // into the cadence body. Set workflow first so the autoAction
          // effect captures the loaded state. (Observed 2026-05-27.)
          setWorkflow({
            workflow_stage: row.workflow_stage || 'awaiting_upload',
            path: row.path || '',
            colleen_review_decision: row.colleen_review_decision || '',
            buyside: !!row.buyside,
            lead: row.lead || '',
            account_manager: row.account_manager || '',
            likelihood_pct: row.likelihood_pct == null ? '' : String(row.likelihood_pct),
            first_meeting_date: row.first_meeting_date || '',
            discovery_meeting_date: row.discovery_meeting_date || '',
            committed_upload_date: row.committed_upload_date || '',
            owner_target_valuation_date: row.owner_target_valuation_date || '',
            upload_started_date: row.upload_started_date || '',
            upload_complete_date: row.upload_complete_date || '',
            valuation_date: row.valuation_date || '',
            engagement_signed_date: row.engagement_signed_date || '',
            cim_complete_date: row.cim_complete_date || '',
            next_meeting_date: row.next_meeting_date || '',
            next_meeting_type: row.next_meeting_type || '',
            snooze_until: row.snooze_until || '',
            snooze_reason: row.snooze_reason || '',
            as_of_date: row.as_of_date || '',
            books_lag_months: row.books_lag_months || 1,
            stage_entered_at: row.stage_entered_at || null,
            // For the auto-spine's backdated-date guard (Blue Spruce 09-09):
            // a valuation_date from BEFORE the deal existed is imported
            // history, never this cycle's delivery.
            created_at: row.created_at || null,
            owner_first_name: row.owner_first_name || '',
            owner_last_name: row.owner_last_name || '',
            owner_email: row.owner_email || '',
            owner_additional: Array.isArray(row.owner_additional) ? row.owner_additional : [],
            portal_docs_released: !!row.portal_docs_released,
            // Owner's portal onboarding signals — surfaced on the Discovery tab
            // so the Lead has them DURING the call (Mark 2026-07-24, from
            // covering Baxter: they only showed after the meeting, in the
            // Activate modal).
            owner_intent: row.owner_intent || '',
            owner_priority: row.owner_priority || '',
            // AI "where we are" (ROADMAP #4) — read-only, server-maintained.
            ai_status: row.ai_status || null,
          });
          setRevalueDocsPending(!!row.revalue_docs_pending);
          setRevalueReviewPending(!!row.revalue_review_pending);
          loadedWorkflowStageRef.current = row.workflow_stage || 'awaiting_upload';
          // Set this LAST so the autoAction effect captures the just-set
          // workflow state in its closure (see comment above).
          setCurrentValuationId(row.id);
          // Snapshot updated_at so save-time conflict detection can refuse the write
          // if anyone else has saved since we loaded.
          loadedUpdatedAtRef.current = row?.updated_at || null;
          setHasUnsavedChanges(false);
          // Stage C: pull the ShareFile auto-Received signal for this engagement
          // so the Data Entered blocks can badge items the owner already uploaded.
          // Keyed by item_key (= String(doc.id)); only rows with a receipt are kept.
          try {
            const { data: sfRows } = await supabaseClient
              .from('engagement_checklist_items')
              .select('item_key, sharefile_received_at, ai_classification_confidence, sharefile_file_id')
              .eq('engagement_id', row.id)
              .not('sharefile_received_at', 'is', null);
            const sfMap = {};
            (sfRows || []).forEach(r => {
              sfMap[String(r.item_key)] = {
                receivedAt: r.sharefile_received_at,
                confidence: r.ai_classification_confidence,
                fileId: r.sharefile_file_id,
              };
            });
            setSharefileReceived(sfMap);
          } catch (sfErr) {
            console.warn('ShareFile received-signal fetch failed:', sfErr);
            setSharefileReceived({});
          }
          // #8: items the owner flagged "I don't have this / doesn't apply" via
          // the portal (owner-flags / staff-decides). Surface the reason on the
          // data-entry row so Konnie can confirm + drop the item or follow up.
          try {
            const { data: naRows } = await supabaseClient
              .from('engagement_checklist_items')
              .select('item_key, owner_na_note')
              .eq('engagement_id', row.id).eq('owner_na', true);
            const naMap = {};
            (naRows || []).forEach(r => { naMap[String(r.item_key)] = r.owner_na_note || ''; });
            setOwnerNaMap(naMap);
          } catch (naErr) {
            console.warn('Owner N/A fetch failed:', naErr);
            setOwnerNaMap({});
          }
          // Stage D1: pull owner answers submitted via the portal so staff can
          // accept them into the Q&A (discovery → sellerQA, ad-hoc → researchItems).
          try {
            const { data: oaRows } = await supabaseClient
              .from('owner_question_responses')
              .select('question_type, question_key, answer, answered_at')
              .eq('engagement_id', row.id);
            setOwnerPortalAnswers(oaRows || []);
          } catch (oaErr) {
            console.warn('Owner portal answers fetch failed:', oaErr);
            setOwnerPortalAnswers([]);
          }
          // Check for a localStorage backup newer than the cloud row. This
          // happens when the previous session's cloud save failed (network,
          // auth expiry, etc.) and the tab was closed before recovery. If we
          // find one, offer to restore. Otherwise clean it up.
          try {
            const backupRaw = localStorage.getItem(`vt_unsaved_backup_${row.id}`);
            if (backupRaw) {
              const backup = JSON.parse(backupRaw);
              const backupTime = new Date(backup.savedAt).getTime();
              const cloudTime = row.updated_at ? new Date(row.updated_at).getTime() : 0;
              if (backupTime > cloudTime + 1000) { // +1s grace for clock skew
                const restore = window.confirm(
                  `Unsaved local backup found for this file — the previous session's cloud save likely failed.\n\n` +
                  `Local backup: ${new Date(backup.savedAt).toLocaleString()}\n` +
                  `Cloud version: ${row.updated_at ? new Date(row.updated_at).toLocaleString() : 'unknown'}\n\n` +
                  `Restore the local backup? It will be re-saved to cloud on the next auto-save.`
                );
                if (restore) {
                  applyLoadedData(backup.data);
                  setHasUnsavedChanges(true);
                } else {
                  localStorage.removeItem(`vt_unsaved_backup_${row.id}`);
                }
              } else {
                // Cloud is newer — backup is stale, clean up.
                localStorage.removeItem(`vt_unsaved_backup_${row.id}`);
              }
            }
          } catch (backupErr) {
            console.warn('Local backup check failed:', backupErr);
          }
        } else if (currentClient) {
          // New valuation — pre-populate from client record
          setDealProfile(prev => ({
            ...prev,
            companyName: currentClient.company_name || prev.companyName || '',
            city: currentClient.city || prev.city || '',
            state: currentClient.state || prev.state || '',
            vistaId: currentClient.vista_id || prev.vistaId || ''
          }));
          setValuationName(`${new Date().toISOString().split('T')[0]} Valuation`);
          // Seed the Stage 1.5 fields captured in the New Project modal so
          // the cadence + OIR work immediately, without a Setup-tab trip.
          if (projectSetup) {
            // AM warm flow: the account starts in the 'warm' stage (pre-meeting,
            // off the active pipeline) with the portal docs gate CLOSED — the
            // Lead opens it at activation. Everyone else starts on the normal
            // spine (awaiting_upload, the workflow default).
            const isWarm = !!projectSetup.warm;
            setWorkflow(prev => ({
              ...prev,
              ...(isWarm ? { workflow_stage: 'warm', portal_docs_released: false } : {}),
              path: projectSetup.path || '',
              lead: projectSetup.lead || '',
              account_manager: projectSetup.account_manager || '',
              committed_upload_date: projectSetup.committed_upload_date || '',
              discovery_meeting_date: projectSetup.discovery_meeting_date || '',
              likelihood_pct: projectSetup.likelihood_pct === '' || projectSetup.likelihood_pct == null
                ? '' : String(projectSetup.likelihood_pct),
              owner_first_name: projectSetup.owner_first_name || '',
              owner_last_name: projectSetup.owner_last_name || '',
              owner_email: projectSetup.owner_email || '',
              owner_additional: Array.isArray(projectSetup.owner_additional) ? projectSetup.owner_additional : [],
            }));
            // Primary-contact role lives in the data blob (dealProfile.ownerRole).
            if (projectSetup.owner_role) {
              setDealProfile(prev => ({ ...prev, ownerRole: projectSetup.owner_role }));
            }
            // Partial: mark the planned subset on the default checklist so
            // the OIR / cadence "X of Y" tracks only what the owner agreed
            // to provide. Empty selection = track all 18 (no planned flags).
            if (Array.isArray(projectSetup.plannedIds) && projectSetup.plannedIds.length > 0) {
              const plannedSet = new Set(projectSetup.plannedIds);
              setDocumentChecklist(prev => prev.map(d => ({ ...d, planned: plannedSet.has(d.id) })));
            }
            // Persist immediately so the project lands in the DB + dashboard
            // even if the user closes the tab without further edits. The
            // ref-based autosave handles the insert (currentClient.id is set).
            pendingSeedSaveRef.current = true;
            setHasUnsavedChanges(true);
          } else {
            setHasUnsavedChanges(false);
          }
        }
      } catch (err) {
        console.error('Cloud load failed:', err);
        setCloudSaveError(err.message || 'Failed to load valuation');
      } finally {
        // Wait one tick so any state updates from applyLoadedData / setDealProfile have flushed
        // through React's batching and triggered the dep-tracking effect once (which we want to
        // ignore). After this, real user edits will correctly flip hasUnsavedChanges=true.
        setTimeout(() => { isHydratingRef.current = false; }, 0);
      }
    })();
  }, []);

  // For local (non-cloud) mode there's no async load — release the hydration gate immediately.
  useEffect(() => {
    if (cloudMode) return;
    setTimeout(() => { isHydratingRef.current = false; }, 0);
  }, []);

  // ========== PRESENCE: claim, heartbeat, poll, release ==========
  // Lightweight self-coordination: every open file upserts a row keyed by (valuation_id, user_id)
  // with a rolling last_seen timestamp. Polling shows everyone whose last_seen is within
  // PRESENCE_TTL_MS so crashed/closed tabs naturally drop off without explicit cleanup.
  useEffect(() => {
    // Read-only viewers (AMs) don't claim presence — they never edit, so they
    // shouldn't pause an active editor's autosave or trigger the "coordinate
    // before editing" warning. They observe invisibly.
    if (!cloudMode || !currentValuationId || isReadOnlyViewer) return;

    let cancelled = false;
    let heartbeatTimer = null;
    let pollTimer = null;
    let claimedUserId = null;
    let claimedAccessToken = null;

    const claimAndPoll = async () => {
      const { data: { session } } = await supabaseClient.auth.getSession();
      if (!session || cancelled) return;
      claimedUserId = session.user.id;
      claimedAccessToken = session.access_token;
      const myEmail = session.user.email || '';

      const upsertHeartbeat = async () => {
        try {
          // supabase-js v2 returns errors in the resolved object, NOT as thrown
          // exceptions — bare `await` would swallow them silently. Destructure
          // and log so RLS / schema issues surface in the console immediately.
          const { error } = await supabaseClient.from('valuation_presence').upsert({
            valuation_id: currentValuationId,
            user_id: claimedUserId,
            user_email: myEmail,
            last_seen: new Date().toISOString()
          }, { onConflict: 'valuation_id,user_id' });
          if (error) console.error('Presence heartbeat upsert error:', error);
        } catch (e) {
          console.error('Presence heartbeat exception:', e);
        }
      };

      const pollViewers = async () => {
        try {
          const cutoff = new Date(Date.now() - PRESENCE_TTL_MS).toISOString();
          const { data, error } = await supabaseClient
            .from('valuation_presence')
            .select('user_id, user_email, last_seen')
            .eq('valuation_id', currentValuationId)
            .gte('last_seen', cutoff);
          if (error) { console.error('Presence poll error:', error); return; }
          if (cancelled) return;
          setOtherViewers((data || []).filter(p => p.user_id !== claimedUserId));
        } catch (e) {
          console.error('Presence poll exception:', e);
        }
      };

      await upsertHeartbeat();
      await pollViewers();
      heartbeatTimer = setInterval(upsertHeartbeat, PRESENCE_HEARTBEAT_MS);
      pollTimer = setInterval(pollViewers, PRESENCE_POLL_MS);
    };

    claimAndPoll();

    // Best-effort release if the tab is closed. keepalive lets the request finish after unload.
    // Uses the user's access token (not the anon key) so the row-level security policy
    // restricting deletes to auth.uid() = user_id is satisfied.
    const releaseBeacon = () => {
      if (!claimedUserId || !claimedAccessToken) return;
      try {
        const url = `${SUPABASE_URL}/rest/v1/valuation_presence?valuation_id=eq.${currentValuationId}&user_id=eq.${claimedUserId}`;
        fetch(url, {
          method: 'DELETE',
          headers: {
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${claimedAccessToken}`
          },
          keepalive: true
        });
      } catch (e) { /* best effort */ }
    };
    window.addEventListener('beforeunload', releaseBeacon);

    return () => {
      cancelled = true;
      window.removeEventListener('beforeunload', releaseBeacon);
      if (heartbeatTimer) clearInterval(heartbeatTimer);
      if (pollTimer) clearInterval(pollTimer);
      if (claimedUserId) {
        // Async release on normal unmount (back-to-list, sign-out, etc.)
        supabaseClient.from('valuation_presence')
          .delete()
          .eq('valuation_id', currentValuationId)
          .eq('user_id', claimedUserId)
          .then(() => {}, (e) => console.warn('Presence release failed:', e));
      }
    };
  }, [currentValuationId, cloudMode, isReadOnlyViewer]);

  // ========== SYNC MONTHLY SALES TO CUSTOMER TTM ==========
  // Auto-sync removed: use Resync TTM button to explicitly sync monthly sales to TTM.
  // Auto-sync caused basis bleed — pasting Cash would overwrite Accrual TTM values.
  // The Resync button respects the current basis and is the authoritative sync trigger.

  // ========== SYNC MONTHLY TTM TO P&L ENTRY ==========
  // When useMonthlyForTtm is enabled, sum monthly data and update P&L Entry TTM fields
  useEffect(() => {
    if (!monthlyTtmConfig.useMonthlyForTtm) return;
    
    // Helper to sum first 12 months (TTM period) - keep full precision
    const sumTtm = (arr) => (arr || []).slice(0, 12).reduce((sum, v) => sum + (v || 0), 0);
    
    // Check if any monthly revenue data exists
    const hasMonthlyRevenue = Object.keys(monthlyTtmRevenue).length > 0;
    const hasMonthlyCogs = Object.keys(monthlyTtmCogs).length > 0;
    const hasMonthlyOpex = Object.keys(monthlyTtmOpex).length > 0;
    const hasMonthlyDiat = ['depreciation', 'interest', 'amortization', 'taxes'].some(type => 
      sumTtm(monthlyTtmDiat[type]?.cash) > 0 || sumTtm(monthlyTtmDiat[type]?.accrual) > 0
    );
    
    // Update Revenue TTM
    if (hasMonthlyRevenue) {
      setRevenueCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmRevenue[cat.id];
        if (!monthlyData) return cat;
        const cashTtm = sumTtm(monthlyData.cash);
        const accrualTtm = sumTtm(monthlyData.accrual);
        // Only update if there's actual monthly data
        if (cashTtm === 0 && accrualTtm === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ttm: cashTtm },
          accrual: { ...cat.accrual, ttm: accrualTtm }
        };
      }));
    }
    
    // Update COGS TTM
    if (hasMonthlyCogs) {
      setCogsCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmCogs[cat.id];
        if (!monthlyData) return cat;
        const cashTtm = sumTtm(monthlyData.cash);
        const accrualTtm = sumTtm(monthlyData.accrual);
        if (cashTtm === 0 && accrualTtm === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ttm: cashTtm },
          accrual: { ...cat.accrual, ttm: accrualTtm }
        };
      }));
    }
    
    // Update OpEx TTM
    if (hasMonthlyOpex) {
      setOpexCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmOpex[cat.id];
        if (!monthlyData) return cat;
        const cashTtm = sumTtm(monthlyData.cash);
        const accrualTtm = sumTtm(monthlyData.accrual);
        if (cashTtm === 0 && accrualTtm === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ttm: cashTtm },
          accrual: { ...cat.accrual, ttm: accrualTtm }
        };
      }));
    }
    
    // Update DIAT TTM
    if (hasMonthlyDiat) {
      setDiatCategories(prev => ({
        depreciation: {
          ...prev.depreciation,
          cash: { ...prev.depreciation.cash, ttm: sumTtm(monthlyTtmDiat.depreciation?.cash) },
          accrual: { ...prev.depreciation.accrual, ttm: sumTtm(monthlyTtmDiat.depreciation?.accrual) }
        },
        interest: {
          ...prev.interest,
          cash: { ...prev.interest.cash, ttm: sumTtm(monthlyTtmDiat.interest?.cash) },
          accrual: { ...prev.interest.accrual, ttm: sumTtm(monthlyTtmDiat.interest?.accrual) }
        },
        amortization: {
          ...prev.amortization,
          cash: { ...prev.amortization.cash, ttm: sumTtm(monthlyTtmDiat.amortization?.cash) },
          accrual: { ...prev.amortization.accrual, ttm: sumTtm(monthlyTtmDiat.amortization?.accrual) }
        },
        taxes: {
          ...prev.taxes,
          cash: { ...prev.taxes.cash, ttm: sumTtm(monthlyTtmDiat.taxes?.cash) },
          accrual: { ...prev.taxes.accrual, ttm: sumTtm(monthlyTtmDiat.taxes?.accrual) }
        }
      }));
    }
    
    // Update Other Income TTM
    const hasMonthlyOtherIncome = Object.keys(monthlyTtmOtherIncome).length > 0;
    if (hasMonthlyOtherIncome) {
      setOtherIncomeCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmOtherIncome[cat.id];
        if (!monthlyData) return cat;
        const cashTtm = sumTtm(monthlyData.cash);
        const accrualTtm = sumTtm(monthlyData.accrual);
        if (cashTtm === 0 && accrualTtm === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ttm: cashTtm },
          accrual: { ...cat.accrual, ttm: accrualTtm }
        };
      }));
    }
    
    // Update Other Expense TTM
    const hasMonthlyOtherExpense = Object.keys(monthlyTtmOtherExpense).length > 0;
    if (hasMonthlyOtherExpense) {
      setOtherExpenseCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmOtherExpense[cat.id];
        if (!monthlyData) return cat;
        const cashTtm = sumTtm(monthlyData.cash);
        const accrualTtm = sumTtm(monthlyData.accrual);
        if (cashTtm === 0 && accrualTtm === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ttm: cashTtm },
          accrual: { ...cat.accrual, ttm: accrualTtm }
        };
      }));
    }
  }, [monthlyTtmConfig.useMonthlyForTtm, monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmDiat, monthlyTtmOtherIncome, monthlyTtmOtherExpense]);

  // ========== SYNC MONTHLY YTD TO P&L ENTRY ==========
  // When useMonthlyForYtd is enabled, sum monthly data for current year and update P&L Entry YTD fields
  useEffect(() => {
    if (!monthlyTtmConfig.useMonthlyForYtd) return;
    
    // Calculate YTD indices (months in current calendar year within TTM period)
    const endMonth = monthlyTtmConfig.endMonth;
    const endYear = monthlyTtmConfig.endYear;
    let m = endMonth - 11;
    let y = endYear;
    if (m < 0) { m += 12; y--; }
    
    const ytdIndices = [];
    for (let i = 0; i < 12; i++) {
      if (y === endYear) ytdIndices.push(i);
      m++;
      if (m > 11) { m = 0; y++; }
    }
    
    // Helper to sum YTD months
    const sumYtd = (arr) => {
      if (!arr || arr.length === 0) return 0;
      return ytdIndices.reduce((sum, idx) => sum + (arr[idx] || 0), 0);
    };
    
    // Check if any monthly data exists
    const hasMonthlyRevenue = Object.keys(monthlyTtmRevenue).length > 0;
    const hasMonthlyCogs = Object.keys(monthlyTtmCogs).length > 0;
    const hasMonthlyOpex = Object.keys(monthlyTtmOpex).length > 0;
    const hasMonthlyDiat = ['depreciation', 'interest', 'amortization', 'taxes'].some(type => 
      sumYtd(monthlyTtmDiat[type]?.cash) > 0 || sumYtd(monthlyTtmDiat[type]?.accrual) > 0
    );
    
    // Update Revenue YTD
    if (hasMonthlyRevenue) {
      setRevenueCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmRevenue[cat.id];
        if (!monthlyData) return cat;
        const cashYtd = sumYtd(monthlyData.cash);
        const accrualYtd = sumYtd(monthlyData.accrual);
        if (cashYtd === 0 && accrualYtd === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ytd: cashYtd },
          accrual: { ...cat.accrual, ytd: accrualYtd }
        };
      }));
    }
    
    // Update COGS YTD
    if (hasMonthlyCogs) {
      setCogsCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmCogs[cat.id];
        if (!monthlyData) return cat;
        const cashYtd = sumYtd(monthlyData.cash);
        const accrualYtd = sumYtd(monthlyData.accrual);
        if (cashYtd === 0 && accrualYtd === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ytd: cashYtd },
          accrual: { ...cat.accrual, ytd: accrualYtd }
        };
      }));
    }
    
    // Update OpEx YTD
    if (hasMonthlyOpex) {
      setOpexCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmOpex[cat.id];
        if (!monthlyData) return cat;
        const cashYtd = sumYtd(monthlyData.cash);
        const accrualYtd = sumYtd(monthlyData.accrual);
        if (cashYtd === 0 && accrualYtd === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ytd: cashYtd },
          accrual: { ...cat.accrual, ytd: accrualYtd }
        };
      }));
    }
    
    // Update DIAT YTD
    if (hasMonthlyDiat) {
      setDiatCategories(prev => ({
        depreciation: {
          ...prev.depreciation,
          cash: { ...prev.depreciation.cash, ytd: sumYtd(monthlyTtmDiat.depreciation?.cash) },
          accrual: { ...prev.depreciation.accrual, ytd: sumYtd(monthlyTtmDiat.depreciation?.accrual) }
        },
        interest: {
          ...prev.interest,
          cash: { ...prev.interest.cash, ytd: sumYtd(monthlyTtmDiat.interest?.cash) },
          accrual: { ...prev.interest.accrual, ytd: sumYtd(monthlyTtmDiat.interest?.accrual) }
        },
        amortization: {
          ...prev.amortization,
          cash: { ...prev.amortization.cash, ytd: sumYtd(monthlyTtmDiat.amortization?.cash) },
          accrual: { ...prev.amortization.accrual, ytd: sumYtd(monthlyTtmDiat.amortization?.accrual) }
        },
        taxes: {
          ...prev.taxes,
          cash: { ...prev.taxes.cash, ytd: sumYtd(monthlyTtmDiat.taxes?.cash) },
          accrual: { ...prev.taxes.accrual, ytd: sumYtd(monthlyTtmDiat.taxes?.accrual) }
        }
      }));
    }
    
    // Update Other Income YTD
    const hasMonthlyOtherIncome = Object.keys(monthlyTtmOtherIncome).length > 0;
    if (hasMonthlyOtherIncome) {
      setOtherIncomeCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmOtherIncome[cat.id];
        if (!monthlyData) return cat;
        const cashYtd = sumYtd(monthlyData.cash);
        const accrualYtd = sumYtd(monthlyData.accrual);
        if (cashYtd === 0 && accrualYtd === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ytd: cashYtd },
          accrual: { ...cat.accrual, ytd: accrualYtd }
        };
      }));
    }
    
    // Update Other Expense YTD
    const hasMonthlyOtherExpense = Object.keys(monthlyTtmOtherExpense).length > 0;
    if (hasMonthlyOtherExpense) {
      setOtherExpenseCategories(prev => prev.map(cat => {
        const monthlyData = monthlyTtmOtherExpense[cat.id];
        if (!monthlyData) return cat;
        const cashYtd = sumYtd(monthlyData.cash);
        const accrualYtd = sumYtd(monthlyData.accrual);
        if (cashYtd === 0 && accrualYtd === 0) return cat;
        return {
          ...cat,
          cash: { ...cat.cash, ytd: cashYtd },
          accrual: { ...cat.accrual, ytd: accrualYtd }
        };
      }));
    }
  }, [monthlyTtmConfig.useMonthlyForYtd, monthlyTtmConfig.endMonth, monthlyTtmConfig.endYear, monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmDiat, monthlyTtmOtherIncome, monthlyTtmOtherExpense]);

  // ========== AUTO-INJECT DETAILED CLIENT FORM DOC ==========
  // When customer sales data has named entries, add the form to the document checklist
  useEffect(() => {
    const hasNamedClients = customerSalesData.some(c => c.name && c.name.trim());
    if (hasNamedClients) {
      setDocumentChecklist(prev => {
        if (prev.some(d => d.id === 28)) return prev; // Already exists
        const salesIdx = prev.findIndex(d => d.id === 26);
        const insertIdx = salesIdx >= 0 ? salesIdx + 1 : prev.length;
        const newDoc = { id: 28, name: 'Detailed Client Form (completed by seller)', status: 'not_received', dateProvided: '', notes: 'Export from Sales Analysis → send to seller → import completed form', receivedNotes: '', pendingNotes: '', tier: 'full' };
        const updated = [...prev];
        updated.splice(insertIdx, 0, newDoc);
        return updated;
      });
    }
  }, [customerSalesData]);

  // ========== HELPER FUNCTIONS (must be defined before useMemos that use them) ==========
  
  // Fix duplicate IDs on mount - runs once to ensure all category IDs are unique
  React.useEffect(() => {
    const fixDuplicateIds = (categories, setter, monthlyData, monthlyDataSetter) => {
      const seenIds = new Set();
      let hasChanges = false;
      const idMapping = {}; // old id -> [new ids]
      
      const fixedCategories = categories.map(cat => {
        if (seenIds.has(cat.id)) {
          const newId = Date.now() + Math.random();
          if (!idMapping[cat.id]) idMapping[cat.id] = [];
          idMapping[cat.id].push(newId);
          hasChanges = true;
          console.warn(`Fixed duplicate ID: ${cat.id} -> ${newId} for "${cat.name}"`);
          return { ...cat, id: newId };
        }
        seenIds.add(cat.id);
        return cat;
      });
      
      if (hasChanges) {
        setter(fixedCategories);
        // Copy monthly data to new IDs
        if (Object.keys(idMapping).length > 0) {
          monthlyDataSetter(prev => {
            const updated = { ...prev };
            Object.entries(idMapping).forEach(([oldId, newIds]) => {
              if (prev[oldId]) {
                newIds.forEach(newId => {
                  updated[newId] = JSON.parse(JSON.stringify(prev[oldId]));
                });
              }
            });
            return updated;
          });
        }
      }
    };
    
    fixDuplicateIds(revenueCategories, setRevenueCategories, monthlyTtmRevenue, setMonthlyTtmRevenue);
    fixDuplicateIds(cogsCategories, setCogsCategories, monthlyTtmCogs, setMonthlyTtmCogs);
    fixDuplicateIds(opexCategories, setOpexCategories, monthlyTtmOpex, setMonthlyTtmOpex);
    fixDuplicateIds(otherIncomeCategories, setOtherIncomeCategories, monthlyTtmOtherIncome, setMonthlyTtmOtherIncome);
    fixDuplicateIds(otherExpenseCategories, setOtherExpenseCategories, monthlyTtmOtherExpense, setMonthlyTtmOtherExpense);
  }, []); // Run once on mount
  
  const formatCurrency = (num) => {
    if (num === null || num === undefined || isNaN(num)) return '$0';
    try {
      // Round to nearest integer for display (not truncate, which loses value)
      const rounded = Math.round(num);
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(rounded);
    } catch (e) {
      return '$0';
    }
  };
  
  // Format with cents for totals (shows .00 when exact, otherwise shows cents)
  const formatCurrencyExact = (num) => {
    if (num === null || num === undefined || isNaN(num)) return '$0.00';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
    } catch (e) {
      return '$0.00';
    }
  };

  // ========== DOCUMENT TRACKER HELPER ==========
  // Maps viewMode to relevant document IDs for context-aware tracking
  const docTrackerMapping = {
    accrualpl: [1],            // Accrual P&L Statements (Annual)
    cashpl: [27],              // Cash P&L Statements (Annual)
    taxreturns: [8],           // Tax Returns
    ttmmonthly: [2],           // TTM P&L monthly
    balancesheet: [3],         // Balance Sheets
    ttmbalsheet: [4],          // TTM Balance Sheet
    customers: [5, 26, 29],    // Sales Reports by Customer (5yr, TTM) + Client Detail Form (round 2)
    revenueanalysis: [28],     // Revenue Classification Form (round 2; gated by P&Ls)
    arap: [15, 16],            // AR/AP Aging Reports
    discovery: [13]            // Discovery Questionnaire
  };

  // Short display names for documents
  const docShortNames = {
    1: 'Accrual P&L (3yr)',
    27: 'Cash P&L (3yr)',
    2: 'TTM P&L (Monthly)',
    3: 'Balance Sheet (3yr + Interim)',
    4: 'TTM Balance Sheet (Monthly)',
    5: 'Sales by Customer (5yr)',
    26: 'Sales by Customer (TTM)',
    7: 'Sales by Product/Service',
    8: 'Tax Returns (3yr)',
    9: 'Owner Salary & Benefits',
    10: 'Payroll Report (TTM)',
    13: 'Discovery Questionnaire',
    15: 'AR Aging Report',
    16: 'AP Aging Report',
    28: 'Revenue Classification Form',
    29: 'Client Detail Form'
  };
  
  // Wrong-doc re-requests accumulate here so marking several docs sends ONE
  // combined owner email (Konnie 2026-07-23: one email per click spammed the
  // owner, and skipping clicks to avoid that left the portal unmarked). Each
  // click marks the doc immediately (portal truth first), then opens the
  // review modal listing EVERYTHING flagged so far — cancel it, keep
  // marking, send once at the end. Cleared on send or deal switch; the
  // tracker banner below is the safety net for an unsent batch.
  // Entries: { id, name, note }.
  const [pendingReRequests, setPendingReRequests] = useState([]);
  useEffect(() => { setPendingReRequests([]); }, [currentValuationId]);

  const openReRequestEmail = (entries) => {
    if (!entries || entries.length === 0) return;
    const w = workflowRef.current || {};
    if (!w.owner_email) {
      window.alert(`${entries.length > 1 ? 'The documents are' : 'The document is'} re-opened as still-needed. No owner email is on file, so no notification was sent — add one on Setup to email the owner.`);
      return;
    }
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
    const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : [])
      .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    const fn = (w.owner_first_name || '').trim();
    const single = entries.length === 1;
    const body = single
      ? `Hi${fn ? ' ' + fn : ''},\n\nThank you for sending the ${entries[0].name}. We weren't able to use this version for your valuation${entries[0].note ? ` — ${entries[0].note}.` : '.'}\n\nWhen you get a chance, could you re-send the correct version? You can upload it in your secure portal using the button below. Just reply if you have any questions.`
      : `Hi${fn ? ' ' + fn : ''},\n\nThank you for the documents you've sent. A few of them we weren't able to use for your valuation:\n\n${entries.map(e => `• ${e.name}${e.note ? ` — ${e.note}` : ''}`).join('\n')}\n\nWhen you get a chance, could you re-send corrected versions? You can upload them in your secure portal using the button below — the reason each one needs another pass is listed there too. Just reply if you have any questions.`;
    setPendingEmail({
      heading: single ? `Re-request "${entries[0].name}" — review & send` : `Re-request ${entries.length} documents — review & send`,
      // Batching taught IN the modal (Colleen 09-02, TLG: "would be nice to
      // send one email for multiple reports" — it already IS one email;
      // Cancel keeps the batch and each ↩ adds to it, but nothing said so).
      hint: single
        ? 'More documents to flag on this deal? Cancel this — your flag is KEPT, each ↩ wrong doc adds to this same email, and you send it once after the last one.'
        : `One combined email for all ${entries.length} flagged documents. More to flag? Cancel — the batch keeps growing; send once at the end.`,
      to: w.owner_email.trim(), cc,
      subject: single ? 'A document for your valuation needs to be re-sent' : 'A few documents for your valuation need to be re-sent',
      sender: 'konnie', // document-flow → Konnie (Thatcher 2026-07-23: doc replies were landing with the Lead)
      defaultBody: body,
      buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: 'Konnie', portalUrl }),
      onSent: () => {
        if (currentValuationId) entries.forEach(e => logActivity(currentValuationId, 'document_rerequested', `Owner notified to re-send "${e.name}"${e.note ? ': ' + e.note : ''}`));
        setPendingReRequests([]);
      },
    });
  };

  // Render inline document tracker for a given viewMode
  // Accept the owner's portal "doesn't apply" flag: none-to-provide, with their own note as the reason
  // (Colleen 2026-07-28). Used by the data-entry strips AND the Document Checklist grid (Konnie 10-12).
  const confirmOwnerNaFlag = (doc) => {
    const ownerNote = ownerNaMap[String(doc.id)] || '';
    const note = `Owner via portal${ownerNote ? `: ${ownerNote}` : ' — flagged as not applicable'}`;
    setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {
      ...d, status: 'complete', naReason: note,
      dateProvided: d.dateProvided || new Date().toLocaleDateString(),
    } : d));
    setHasUnsavedChanges(true);
    if (currentValuationId) logActivity(currentValuationId, 'document_received',
      `${doc.name} — owner's doesn't-apply flag confirmed; marked NONE TO PROVIDE`,
      { item_key: String(doc.id), display_name: doc.name, none_to_provide: true, source: 'owner_portal_flag' });
  };
  const renderDocTracker = (currentViewMode) => {
    const relevantDocIds = docTrackerMapping[currentViewMode] || [];
    if (relevantDocIds.length === 0) return null;
    
    const relevantDocs = documentChecklist.filter(d => relevantDocIds.includes(d.id));
    if (relevantDocs.length === 0) return null;
    
    const allEntered = relevantDocs.every(d => d.status === 'complete');

    return (
      <div className={`mb-3 p-2 rounded-lg border text-xs ${allEntered ? 'bg-green-50 border-green-200' : 'bg-amber-50 border-amber-200'}`}>
        {/* Unsent wrong-doc batch — the safety net so a cancelled review
            modal can't strand marked-wrong docs with no owner email. */}
        {pendingReRequests.length > 0 && (
          <div className="mb-2 flex items-center justify-between gap-2 bg-red-50 border border-red-200 rounded px-2 py-1.5 flex-wrap">
            <span className="text-red-700 font-medium">⚠ {pendingReRequests.length} document{pendingReRequests.length === 1 ? '' : 's'} marked wrong — the owner hasn't been emailed yet</span>
            <button type="button" className="font-semibold text-blue-700 underline whitespace-nowrap" onClick={() => openReRequestEmail(pendingReRequests)}>✉ Review & send one email</button>
          </div>
        )}
        <div className="flex items-center gap-2 mb-1">
          <span className="font-semibold text-gray-700">📁 Data Entered:</span>
          {allEntered && <span className="text-green-600 font-medium">✓ All entered</span>}
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-1">
          {relevantDocs.map(doc => (
            <div key={doc.id} className="flex items-center gap-2">
              <select
                value={doc.status || 'not_received'}
                onChange={e => {
                  const newStatus = e.target.value;
                  if (!confirmClientDetailComplete(doc, newStatus)) return;
                  const wasComplete = doc.status === 'complete';
                  const nowComplete = newStatus === 'complete';
                  // "Not provided at this time" carries a required note (why it's
                  // not here / when it's expected) so Colleen knows what she's
                  // working without and when to expect it. It never counts as
                  // received — accuracy stays <100% until the doc actually lands.
                  let npatNote = doc.pendingNotes || '';
                  if (newStatus === 'not_provided') {
                    const n = window.prompt(`${doc.name}: mark "Not provided at this time".\n\nThe deal can move to Colleen, but this document stays NOT received — accuracy stays below 100% until it arrives. One line: why it's not here yet / when you expect it:`, doc.pendingNotes || '');
                    if (n === null) return;                       // cancelled — leave status unchanged
                    npatNote = (n || '').trim();
                    if (!npatNote) { window.alert('A short note is required — Colleen needs to know what she\'s waiting on.'); return; }
                  }
                  setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {
                    ...d,
                    status: newStatus,
                    pendingNotes: newStatus === 'not_provided' ? npatNote : d.pendingNotes,
                    dateProvided: newStatus === 'complete' && !d.dateProvided ? new Date().toLocaleDateString() : d.dateProvided
                  } : d));
                  // Log a document_received event so the dashboard's Last
                  // Interaction column surfaces uploads alongside outreach
                  // (Mark's request 2026-05-26). Fire only on the transition
                  // into 'complete' — pre-Stage-C "Complete" already means
                  // received + entered + verified.
                  if (!wasComplete && nowComplete && currentValuationId) {
                    logActivity(currentValuationId, 'document_received',
                      `${doc.name} marked complete`,
                      { item_key: String(doc.id), display_name: doc.name });
                  }
                  if (newStatus === 'not_provided' && currentValuationId) {
                    logActivity(currentValuationId, 'document_not_provided',
                      `${doc.name} marked not provided at this time${npatNote ? ' — ' + npatNote : ''}`,
                      { item_key: String(doc.id), display_name: doc.name });
                  }
                }}
                className={`text-xs px-1 py-0.5 border rounded ${
                  doc.status === 'complete' ? 'bg-green-100 text-green-700' :
                  doc.status === 'not_provided' ? 'bg-orange-100 text-orange-700' :
                  doc.status === 'partial' ? 'bg-amber-100 text-amber-700' :
                  doc.status === 'requested' ? 'bg-purple-100 text-purple-700' :
                  'bg-gray-100 text-gray-600'
                }`}
              >
                <option value="not_received">Not Recv</option>
                <option value="requested">Requested</option>
                <option value="partial">Partial</option>
                <option value="complete">Complete</option>
                <option value="not_provided">Not provided (yet)</option>
              </select>
              <span className="text-gray-700">{docShortNames[doc.id] || doc.name}</span>
              {/* "None to provide" (Colleen 2026-07-28, Spotlink): Complete-because-
                  received and Complete-because-none-exist looked identical, so
                  "owner confirmed there are none" evaporated and she re-asked
                  answered questions. naReason rides ON TOP of status 'complete'
                  (stage engine/gauges/cadence untouched) and displays loudly. */}
              {doc.naReason && doc.status === 'complete' && (
                <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-indigo-100 text-indigo-800 font-medium" title={`Marked "none to provide" — no document exists for this item, and that's confirmed, not missing. ${doc.naReason}`}>
                  Ⓝ none to provide — {doc.naReason}
                </span>
              )}
              {/* Not-provided-yet note (Mark 09-16): shows Colleen exactly what
                  she's working without and when it's expected. This item is NOT
                  received — it holds accuracy below 100% until it lands. */}
              {doc.status === 'not_provided' && (
                <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-orange-100 text-orange-800 font-medium" title={`Not provided at this time — NOT received; accuracy stays below 100% until it arrives. ${doc.pendingNotes || ''}`}>
                  ⏳ not provided yet{doc.pendingNotes ? ` — ${doc.pendingNotes}` : ''}
                </span>
              )}
              {doc.status !== 'complete' && !isReadOnlyViewer && (
                <button
                  type="button"
                  className="text-xs text-indigo-600 hover:text-indigo-800 underline ml-1"
                  title='Mark this item "none to provide / N.A." — e.g. the owner confirmed there are no personal or non-recurring items. Records who confirmed and why, counts the item as satisfied, and shows a Ⓝ badge so nobody re-asks.'
                  onClick={() => {
                    const reason = window.prompt(
                      `Mark "${docShortNames[doc.id] || doc.name}" as NONE TO PROVIDE.\n\nWho confirmed and how? (e.g. "Owner confirmed on 7/28 call — no personal items run through the business")`,
                      doc.pendingNotes || ''
                    );
                    if (reason === null || !String(reason).trim()) return;
                    const note = String(reason).trim();
                    setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {
                      ...d, status: 'complete', naReason: note,
                      dateProvided: d.dateProvided || new Date().toLocaleDateString(),
                    } : d));
                    setHasUnsavedChanges(true);
                    if (currentValuationId) logActivity(currentValuationId, 'document_received',
                      `${doc.name} — marked NONE TO PROVIDE: ${note}`,
                      { item_key: String(doc.id), display_name: doc.name, none_to_provide: true });
                  }}
                >Ⓝ none</button>
              )}
              {(() => {
                // Stage C: badge items the owner already uploaded to ShareFile
                // but that aren't entered yet — tells Konnie what's waiting to
                // be keyed in. Suppressed once the item is 'complete' (entered).
                const sf = sharefileReceived[String(doc.id)];
                if (!sf || doc.status === 'complete') return null;
                const when = sf.receivedAt
                  ? new Date(sf.receivedAt).toLocaleDateString()
                  : null;
                const lowConf = typeof sf.confidence === 'number' && sf.confidence < 0.85;
                return (
                  <span
                    className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-sky-100 text-sky-700 font-medium"
                    title={lowConf
                      ? `Auto-classified with low confidence (${Math.round((sf.confidence || 0) * 100)}%) — confirm this is the right document.`
                      : 'Received via ShareFile — awaiting entry.'}
                  >
                    📥 received via ShareFile{when ? ` ${when}` : ''}{lowConf ? ' ⚠' : ''}
                  </span>
                );
              })()}
              {/* Stage C: re-request a wrong/unusable upload. Clears the ShareFile
                  receipt (so it leaves Konnie's "Received — awaiting entry"
                  worklist) and re-opens the item as still-needed, with an optional
                  note on what's needed. The file itself stays in the data room. */}
              {(() => {
                const sf = sharefileReceived[String(doc.id)];
                // Show the bounce on ANY row holding a file OR marked
                // complete (TLG 09-02, Colleen covering: the wrong-format
                // files were exactly the ones already marked complete, and
                // the old sf-only gate hid the one lever that fixes them —
                // "complete" is a claim, not proof the file was right).
                if (!sf && doc.status !== 'complete') return null;
                return (
                  <button
                    type="button"
                    title="The uploaded file is wrong or unusable — clear it from your worklist, re-open this item as still-needed, and note what you need so the owner can re-send. The file stays in the data room."
                    onClick={async () => {
                      const docName = docShortNames[doc.id] || doc.name;
                      const reason = window.prompt(
                        `Re-request "${docName}" from the owner.\n\nWhat was wrong / what do you still need? (shows on the owner's portal list and seeds the email)`,
                        doc.pendingNotes || ''
                      );
                      if (reason === null) return; // cancelled
                      const note = (reason || '').trim();
                      try {
                        if (currentValuationId) {
                          await supabaseClient.from('engagement_checklist_items')
                            .update({ sharefile_received_at: null, sharefile_file_id: null, ai_classification_confidence: null, status: 'not_received', rerequest_note: note || null })
                            .eq('engagement_id', currentValuationId).eq('item_key', String(doc.id));
                        }
                      } catch (e) { console.warn('Re-request: clearing receipt failed:', e); }
                      setSharefileReceived(prev => { const n = { ...prev }; delete n[String(doc.id)]; return n; });
                      setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? { ...d, status: 'not_received', pendingNotes: note } : d));
                      setHasUnsavedChanges(true);
                      if (currentValuationId) logActivity(currentValuationId, 'document_rerequested', `Re-requested "${doc.name}"${note ? ': ' + note : ''}`);
                      // Notify the owner — ONE combined email for the whole batch
                      // (Konnie 2026-07-23). The doc joins the pending batch and the
                      // review modal reopens listing everything flagged so far:
                      // cancel it to keep marking more, send once at the end. The
                      // marking above already happened, so the portal shows every
                      // flagged doc regardless of when the email goes out.
                      const entry = { id: doc.id, name: docName, note };
                      const nextEntries = [...pendingReRequests.filter(e => e.id !== doc.id), entry];
                      setPendingReRequests(nextEntries);
                      openReRequestEmail(nextEntries);
                    }}
                    className="text-xs text-red-600 hover:text-red-800 underline ml-1"
                  >↩ wrong doc</button>
                );
              })()}
              {/* Persistent indicator after a wrong-doc re-request: shows what was
                  flagged so the row isn't ambiguous once the receipt is cleared.
                  Same note surfaces on the owner's portal + the notification email. */}
              {doc.pendingNotes && doc.status === 'not_received' && (
                <span
                  className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 font-medium"
                  title="You sent this document back to the owner as wrong/unusable. This reason shows on their portal and was used in the re-send email."
                >⚠ re-requested: {doc.pendingNotes}</span>
              )}
              {/* #8: the owner flagged this item "doesn't apply / don't have it"
                  via the portal. Owner-flags / staff-decides — Konnie confirms
                  (set the item complete or leave it) or follows up. */}
              {ownerNaMap[String(doc.id)] !== undefined && doc.status !== 'complete' && (
                <React.Fragment>
                  <span
                    className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-orange-100 text-orange-800 font-medium"
                    title="The owner flagged this as not applicable / something they don't have, via the portal. Confirm and update the item's status, or follow up."
                  >🚩 owner: doesn't apply{ownerNaMap[String(doc.id)] ? ` — ${ownerNaMap[String(doc.id)]}` : ''}</span>
                  {/* One-click resolution of the owner's flag into the durable
                      "none to provide" record — the owner's own portal note
                      becomes the reason, so the provenance survives (Colleen
                      2026-07-28: "save me asking a repeat question"). */}
                  {!isReadOnlyViewer && (
                    <button
                      type="button"
                      className="text-xs font-semibold text-indigo-700 hover:text-indigo-900 underline"
                      title="Accept the owner's flag: mark this item none-to-provide, keeping their explanation as the recorded reason."
                      onClick={() => confirmOwnerNaFlag(doc)}
                    >✓ confirm none</button>
                  )}
                </React.Fragment>
              )}
              {doc.status === 'partial' && (
                <div className="flex items-center gap-1">
                  <span className="text-green-600">Have:</span>
                  <input
                    type="text"
                    value={doc.receivedNotes || ''}
                    onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, receivedNotes: e.target.value} : d))}
                    placeholder="e.g., 2021, 2022, 2023"
                    className="w-36 px-1 py-0.5 border rounded text-xs bg-green-50"
                  />
                  <span className="text-amber-600 ml-1">Need:</span>
                  <input
                    type="text"
                    value={doc.pendingNotes || ''}
                    onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, pendingNotes: e.target.value} : d))}
                    placeholder="e.g., 2024 TTM"
                    className="w-36 px-1 py-0.5 border rounded text-xs bg-amber-50"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        {/* Partial workflow, made visible (Konnie 2026-07-27): the on-screen
            twin of the confirm-on-exit prompt, plus the "then what" answer
            once the stage advances. Full valuations keep their own escape
            hatch on the Analysis tab. */}
        {!isReadOnlyViewer && workflow.path === 'partial'
          && ['data_entry_complete', 'adjustments_entered'].includes(workflow.workflow_stage) && (
          <div className="mt-2 flex items-center justify-between gap-2 bg-indigo-50 border border-indigo-200 rounded px-2 py-1.5 flex-wrap">
            <span className="text-indigo-800"><span className="font-semibold">Partial finished?</span> Marking the analysis complete hands it to <span className="font-semibold">{workflow.lead || 'the Lead'}</span> to set the valuation meeting. (Leaving the deal asks the same question.)</span>
            <button type="button" onClick={markPartialAnalysisComplete} className="px-2.5 py-1 rounded text-xs font-semibold bg-indigo-600 text-white hover:bg-indigo-700 whitespace-nowrap">✓ Mark analysis complete</button>
          </div>
        )}
        {workflow.path === 'partial' && workflow.workflow_stage === 'analysis_complete' && (
          <div className="mt-2 bg-indigo-50 border border-indigo-200 rounded px-2 py-1.5 text-indigo-800">
            ✓ Analysis complete — waiting on <span className="font-semibold">{workflow.lead || 'the Lead'}</span> to set the valuation meeting (it's on their My Work with a 1-day target).
          </div>
        )}
      </div>
    );
  };

  // ========== ACTIVE CATEGORIES (derived from selected valuation basis) ==========
  // These extract values for the selected basis and are used by all calculations
  const activeRevenueCategories = useMemo(() => {
    return revenueCategories.map(cat => {
      const safeNum = (val) => {
        if (val === null || val === undefined) return 0;
        const num = typeof val === 'number' ? val : parseFloat(val);
        return isNaN(num) ? 0 : num;
      };
      return {
        ...cat,
        year1: safeNum(cat[selectedValuationBasis]?.year1),
        year2: safeNum(cat[selectedValuationBasis]?.year2),
        year3: safeNum(cat[selectedValuationBasis]?.year3),
        year4: safeNum(cat[selectedValuationBasis]?.year4),
        year5: safeNum(cat[selectedValuationBasis]?.year5),
        ttm: safeNum(cat[selectedValuationBasis]?.ttm)
      };
    });
  }, [revenueCategories, selectedValuationBasis]);

  const activeCogsCategories = useMemo(() => {
    return cogsCategories.map(cat => {
      const safeNum = (val) => {
        if (val === null || val === undefined) return 0;
        const num = typeof val === 'number' ? val : parseFloat(val);
        return isNaN(num) ? 0 : num;
      };
      return {
        ...cat,
        year1: safeNum(cat[selectedValuationBasis]?.year1),
        year2: safeNum(cat[selectedValuationBasis]?.year2),
        year3: safeNum(cat[selectedValuationBasis]?.year3),
        year4: safeNum(cat[selectedValuationBasis]?.year4),
        year5: safeNum(cat[selectedValuationBasis]?.year5),
        ttm: safeNum(cat[selectedValuationBasis]?.ttm)
      };
    });
  }, [cogsCategories, selectedValuationBasis]);

  // Calculate totals
  const cogsAnalysis = useMemo(() => ({
    totals: {
      year1: activeCogsCategories.reduce((sum, cat) => sum + cat.year1, 0),
      year2: activeCogsCategories.reduce((sum, cat) => sum + cat.year2, 0),
      year3: activeCogsCategories.reduce((sum, cat) => sum + cat.year3, 0),
      year4: activeCogsCategories.reduce((sum, cat) => sum + cat.year4, 0),
      year5: activeCogsCategories.reduce((sum, cat) => sum + cat.year5, 0),
      ttm: activeCogsCategories.reduce((sum, cat) => sum + cat.ttm, 0)
    }
  }), [activeCogsCategories]);


  // DECLARATION ORDER (09-09, Colleen's RDS blank screen — the afternoon's
  // adjusted-trend change made this memo read adjustmentItems and
  // basisYearLabels, which were declared ~1,100 lines BELOW it. A useMemo
  // body runs at its call position, so both read as undefined (compiled
  // const→var turns the TDZ into plain undefined) → "Cannot read
  // properties of undefined (reading 'year1')" → every valuation open
  // blanked. Hook order among unconditional useStates is free, so the two
  // declarations live here now, above every reader. Same failure class as
  // the seCalendarLimiter boot crash: invisible to node --check AND babel.)
  const [basisYearLabels, setBasisYearLabels] = useState({
    year1: defaultYears.year1, year2: defaultYears.year2, year3: defaultYears.year3, year4: defaultYears.year4, year5: defaultYears.year5,
    ttmStartMonth: '', ttmStartYear: '', ttmEndMonth: '', ttmEndYear: ''
  });
  const [adjustmentItems, setAdjustmentItems] = useState([]);

  const revenueAnalysis = useMemo(() => {
    // P1 (Zac 10-08): project-based industries score "contracted" lines as project revenue.
    const _projectBiz = PROJECT_BASED_INDUSTRIES.has(selectedIndustry) && revenueScoringMode !== 'legacy';
    const _asProject = (t) => (t === 'contracted_defined' || t === 'recurring_contract') ? 'project_contracted' : t;
    const _revCats = !_projectBiz ? activeRevenueCategories : activeRevenueCategories.map(c => {
      const sp = c.typeSplits && typeof c.typeSplits === 'object' && Object.keys(c.typeSplits).length
        ? Object.entries(c.typeSplits).reduce((o, [t, p]) => { const k = _asProject(t); o[k] = (o[k] || 0) + (Number(p) || 0); return o; }, {})
        : c.typeSplits;
      return { ...c, revenueType: _asProject(c.revenueType), typeSplits: sp };
    });
    // Base totals (raw P&L values - adjustments applied separately in calculations useMemo)
    const baseTotals = { 
      year1: _revCats.reduce((sum, cat) => sum + cat.year1, 0), 
      year2: _revCats.reduce((sum, cat) => sum + cat.year2, 0), 
      year3: _revCats.reduce((sum, cat) => sum + cat.year3, 0), 
      year4: _revCats.reduce((sum, cat) => sum + cat.year4, 0), 
      year5: _revCats.reduce((sum, cat) => sum + cat.year5, 0), 
      ttm: _revCats.reduce((sum, cat) => sum + cat.ttm, 0) 
    };
    
    // totals = baseTotals for now (adjustments applied in calculations useMemo)
    const totals = { ...baseTotals };

    // ADJUSTED-TREND TOTALS (Mark 09-09, the hurricane case: a remediation
    // revenue spike made the following year read as DECLINE — the A2
    // stability grade, revCAGR, and revenueGrowingYoY all read RAW revenue,
    // so even a properly entered one-time revenue adjustment never reached
    // the trend math, and "really it's an increase" graded as bad revenue.
    // Trend is measured on ADJUSTED revenue — one-time revenue excluded,
    // same year-scoped matching as calcYear — while every displayed P&L
    // total stays raw.)
    const revAdjByYear = {};
    ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'].forEach(yk => {
      const label = yk === 'ttm' ? 'TTM' : basisYearLabels[yk];
      const match = (item) => item.included
        && (item.plLine === 'Revenue' || String(item.plLine || '').startsWith('Revenue: '))
        && (item.year === 'All Years' || item.year === label);
      const adds = (adjustmentItems || []).filter(i => match(i) && i.type === 'add').reduce((s, i) => s + i.amount, 0);
      const deds = (adjustmentItems || []).filter(i => match(i) && i.type === 'deduct').reduce((s, i) => s + i.amount, 0);
      revAdjByYear[yk] = adds - deds;
    });
    const adjTotals = {};
    Object.keys(baseTotals).forEach(yk => { adjTotals[yk] = baseTotals[yk] + (revAdjByYear[yk] || 0); });
    
    const weightedRecurring = { 
      year1: _revCats.reduce((sum, cat) => sum + (cat.year1 * getCategoryEffectiveWeight(cat)), 0), 
      year2: _revCats.reduce((sum, cat) => sum + (cat.year2 * getCategoryEffectiveWeight(cat)), 0), 
      year3: _revCats.reduce((sum, cat) => sum + (cat.year3 * getCategoryEffectiveWeight(cat)), 0), 
      year4: _revCats.reduce((sum, cat) => sum + (cat.year4 * getCategoryEffectiveWeight(cat)), 0), 
      year5: _revCats.reduce((sum, cat) => sum + (cat.year5 * getCategoryEffectiveWeight(cat)), 0), 
      ttm: _revCats.reduce((sum, cat) => sum + (cat.ttm * getCategoryEffectiveWeight(cat)), 0) 
    };
    
    // ===== FIX 3: Project Revenue Stability Damper =====
    // When project_contracted or hardware_contracted revenue has extreme YoY growth,
    // dampen its weight because the spike is likely non-recurring
    // This produces a "dampened" weighted recurring that's more conservative
    const getEffectiveWeight = (cat, yearKey) => {
      const baseWeight = getCategoryEffectiveWeight(cat);
      // Only dampen if primary type is project_contracted or hardware_contracted (and no splits defined)
      const hasSplits = cat.typeSplits && Object.keys(cat.typeSplits).length > 0;
      if (hasSplits || !['project_contracted', 'hardware_contracted'].includes(cat.revenueType)) return baseWeight;
      if (baseWeight === 0) return 0;
      
      // Compare current year to prior year
      const priorYearMap = { year2: 'year1', year3: 'year2', year4: 'year3', year5: 'year4', ttm: 'year5' };
      const priorKey = priorYearMap[yearKey];
      if (!priorKey) return baseWeight;
      
      const current = cat[yearKey] || 0;
      const prior = cat[priorKey] || 0;
      
      if (prior <= 0 || current <= 0) return baseWeight;
      const growthPct = ((current - prior) / prior) * 100;
      
      // Dampen weight based on growth rate
      if (growthPct <= 50) return baseWeight;           // Normal growth - full weight
      if (growthPct <= 100) return baseWeight * 0.80;   // 50-100% growth - slight damper
      if (growthPct <= 200) return baseWeight * 0.60;   // 100-200% growth - moderate damper
      return baseWeight * 0.40;                          // >200% growth - heavy damper
    };
    
    const dampenedWeightedRecurring = {
      year1: _revCats.reduce((sum, cat) => sum + (cat.year1 * getEffectiveWeight(cat, 'year1')), 0),
      year2: _revCats.reduce((sum, cat) => sum + (cat.year2 * getEffectiveWeight(cat, 'year2')), 0),
      year3: _revCats.reduce((sum, cat) => sum + (cat.year3 * getEffectiveWeight(cat, 'year3')), 0),
      year4: _revCats.reduce((sum, cat) => sum + (cat.year4 * getEffectiveWeight(cat, 'year4')), 0),
      year5: _revCats.reduce((sum, cat) => sum + (cat.year5 * getEffectiveWeight(cat, 'year5')), 0),
      ttm: _revCats.reduce((sum, cat) => sum + (cat.ttm * getEffectiveWeight(cat, 'ttm')), 0)
    };
    const dampenedRecurringPct = {
      year3: totals.year3 > 0 ? (dampenedWeightedRecurring.year3 / totals.year3) * 100 : 0,
      year4: totals.year4 > 0 ? (dampenedWeightedRecurring.year4 / totals.year4) * 100 : 0,
      year5: totals.year5 > 0 ? (dampenedWeightedRecurring.year5 / totals.year5) * 100 : 0,
      ttm: totals.ttm > 0 ? (dampenedWeightedRecurring.ttm / totals.ttm) * 100 : 0
    };
    const dampenedYearsWithData = [
      { pct: dampenedRecurringPct.year3, hasData: totals.year3 > 0 },
      { pct: dampenedRecurringPct.year4, hasData: totals.year4 > 0 },
      { pct: dampenedRecurringPct.year5, hasData: totals.year5 > 0 },
      { pct: dampenedRecurringPct.ttm, hasData: totals.ttm > 0 }
    ].filter(y => y.hasData);
    const avgDampenedRecurringPct = dampenedYearsWithData.length > 0 ? dampenedYearsWithData.reduce((s, y) => s + y.pct, 0) / dampenedYearsWithData.length : 0;
    // Damper active if gap between raw and dampened is meaningful (>2 points)
    const damperActive = Math.abs(avgWeightedRecurringPct - avgDampenedRecurringPct) > 2;
    
    // ===== FIX 1: Reclassification Suggestions =====
    // Detect revenue categories where name suggests a different type than what's assigned
    const reclassificationSuggestions = [];
    const hardwarePatterns = /hardware|equipment|server|workstation|firewall|device|product\s*sale|product\s*income|software\s*sale/i;
    _revCats.forEach(cat => {
      if (cat.revenueType === 'project_contracted' && hardwarePatterns.test(cat.name)) {
        reclassificationSuggestions.push({
          id: cat.id,
          name: cat.name,
          currentType: 'project_contracted',
          suggestedType: 'hardware_contracted',
          reason: 'Name suggests hardware/product — weight should be 0.25 not 0.50'
        });
      }
    });
    
    // ===== FIX 2: Revenue Growth Quality Analysis =====
    // Analyze what TYPES of revenue are driving YoY growth
    // Used by A5 factor in multiple engine
    // Determine basis year from available data (latest year with revenue)
    const basisYearForGrowth = totals.ttm > 0 ? 'ttm' : totals.year5 > 0 ? 'year5' : 'year4';
    const priorYearMapGrowth = { year2: 'year1', year3: 'year2', year4: 'year3', year5: 'year4', ttm: 'year5' };
    const priorYearForGrowth = priorYearMapGrowth[basisYearForGrowth] || 'year4';
    
    const growthByType = {};
    let totalGrowth = 0;
    let nonRecurringGrowth = 0;
    // "Recurring revenue is definitive" (Zac 10-06): only contract revenue is recurring growth — resold
    // licensing and uncontracted repeat work are not.
    const nonRecurringTypes = ['project_contracted', 'hardware_contracted', 'transactional', 'recurring_licensing', 'repeat_uncontracted', 'recurring_mtm', 'recurring_switching', 'project_services', 'product'];
    
    _revCats.forEach(cat => {
      const current = cat[basisYearForGrowth] || 0;
      const prior = cat[priorYearForGrowth] || 0;
      const delta = current - prior;
      const rtype = cat.revenueType || 'transactional';
      
      if (!growthByType[rtype]) growthByType[rtype] = { growth: 0, currentTotal: 0, priorTotal: 0 };
      growthByType[rtype].growth += delta;
      growthByType[rtype].currentTotal += current;
      growthByType[rtype].priorTotal += prior;
      totalGrowth += delta;
      
      if (nonRecurringTypes.includes(rtype)) nonRecurringGrowth += delta;
    });
    
    const nonRecurringGrowthPct = totalGrowth > 0 ? (nonRecurringGrowth / totalGrowth) * 100 : 0;
    const recurringGrowthAmt = totalGrowth - nonRecurringGrowth;
    // Legacy growth split (pre-10-06 types) for grandfathered valuations.
    const legacyNonRecTypes = ['project_contracted', 'hardware_contracted', 'transactional'];
    const nonRecurringGrowthLegacy = Object.entries(growthByType).reduce((a, [t, g]) => a + (legacyNonRecTypes.includes(t) ? g.growth : 0), 0);
    const nonRecurringGrowthPctLegacy = totalGrowth > 0 ? (nonRecurringGrowthLegacy / totalGrowth) * 100 : 0;
    const recurringGrowthAmtLegacy = totalGrowth - nonRecurringGrowthLegacy;
    const recurringGrowthPct = totalGrowth > 0 ? (recurringGrowthAmt / totalGrowth) * 100 : 0;
    const weightedRecurringPct = { 
      year1: totals.year1 > 0 ? (weightedRecurring.year1 / totals.year1) * 100 : 0, 
      year2: totals.year2 > 0 ? (weightedRecurring.year2 / totals.year2) * 100 : 0, 
      year3: totals.year3 > 0 ? (weightedRecurring.year3 / totals.year3) * 100 : 0, 
      year4: totals.year4 > 0 ? (weightedRecurring.year4 / totals.year4) * 100 : 0, 
      year5: totals.year5 > 0 ? (weightedRecurring.year5 / totals.year5) * 100 : 0, 
      ttm: totals.ttm > 0 ? (weightedRecurring.ttm / totals.ttm) * 100 : 0 
    };
    // Use most recent 3 years + TTM for average — only count years with actual revenue
    const recurringYearsWithData = [
      { pct: weightedRecurringPct.year3, hasData: totals.year3 > 0 },
      { pct: weightedRecurringPct.year4, hasData: totals.year4 > 0 },
      { pct: weightedRecurringPct.year5, hasData: totals.year5 > 0 },
      { pct: weightedRecurringPct.ttm, hasData: totals.ttm > 0 }
    ].filter(y => y.hasData);
    const avgWeightedRecurringPct = recurringYearsWithData.length > 0 ? recurringYearsWithData.reduce((s, y) => s + y.pct, 0) / recurringYearsWithData.length : 0;
    
    // Check if Year5 and TTM are essentially the same period (within 2%)
    // Use BASE revenue (before adjustments) to detect same period
    const year5TtmSame = baseTotals.year5 > 0 && baseTotals.ttm > 0 && 
      Math.abs(baseTotals.ttm - baseTotals.year5) / baseTotals.year5 < 0.02;
    
    // YoY changes - return null for years without data
    const calcYoYChange = (curr, prev) => {
      if (!prev || prev <= 0 || !curr || curr <= 0) return null;
      return ((curr - prev) / prev) * 100;
    };
    
    // YoY on ADJUSTED revenue (see the hurricane note above) — a one-time
    // spike properly adjusted out no longer manufactures decline years.
    const yoyChanges = {
      year1to2: calcYoYChange(adjTotals.year2, adjTotals.year1),
      year2to3: calcYoYChange(adjTotals.year3, adjTotals.year2),
      year3to4: calcYoYChange(adjTotals.year4, adjTotals.year3),
      year4to5: calcYoYChange(adjTotals.year5, adjTotals.year4),
      year5toTTM: calcYoYChange(adjTotals.ttm, adjTotals.year5)
    };
    
    // For variance calculation, only use years with actual data
    // Skip year5toTTM if they're the same period
    const validChanges = [];
    if (yoyChanges.year1to2 !== null) validChanges.push(yoyChanges.year1to2);
    if (yoyChanges.year2to3 !== null) validChanges.push(yoyChanges.year2to3);
    if (yoyChanges.year3to4 !== null) validChanges.push(yoyChanges.year3to4);
    if (yoyChanges.year4to5 !== null) validChanges.push(yoyChanges.year4to5);
    if (yoyChanges.year5toTTM !== null && !year5TtmSame) validChanges.push(yoyChanges.year5toTTM);
    
    // Calculate variance (standard deviation) only from valid changes
    let yoyVariance = 0;
    let avgChange = 0;
    if (validChanges.length >= 2) {
      avgChange = validChanges.reduce((a, b) => a + b, 0) / validChanges.length;
      yoyVariance = Math.sqrt(validChanges.reduce((sum, c) => sum + Math.pow(c - avgChange, 2), 0) / validChanges.length);
    } else if (validChanges.length === 1) {
      avgChange = validChanges[0];
      yoyVariance = 0; // No variance with only one data point
    }
    
    // Check for monthly data - use monthlyTtmRevenue (the actual data source) not the legacy ttmMonthlyData
    const basisKey = selectedValuationBasis === 'tax' ? 'cash' : selectedValuationBasis;
    const hasMonthlyData = Object.keys(monthlyTtmRevenue).length > 0 && 
      Object.values(monthlyTtmRevenue).some(catData => {
        const basisData = catData?.[basisKey] || [];
        return basisData.slice(0, 12).some(v => v > 0);
      });
    
    // Calculate monthly stats from actual monthly revenue data
    let monthlyCV = 0;
    let monthlyAvg = 0;
    let monthlyStdDev = 0;
    let monthlyTotals = Array(12).fill(0);
    let monthsBelowAvg = 0;
    let monthsAboveAvg = 0;
    let monthsSignificantlyBelow = 0; // >15% below average
    let monthsSignificantlyAbove = 0; // >15% above average
    
    if (hasMonthlyData) {
      // Sum all categories for each of the 12 TTM months
      Object.values(monthlyTtmRevenue).forEach(catData => {
        const data = catData?.[basisKey] || [];
        for (let i = 0; i < 12; i++) {
          monthlyTotals[i] += (data[i] || 0);
        }
      });
      
      monthlyAvg = monthlyTotals.reduce((a, b) => a + b, 0) / 12;
      monthlyStdDev = Math.sqrt(monthlyTotals.reduce((sum, m) => sum + Math.pow(m - monthlyAvg, 2), 0) / 12);
      monthlyCV = monthlyAvg > 0 ? (monthlyStdDev / monthlyAvg) * 100 : 0;
      
      // Count months above/below average with significance threshold
      const significanceThreshold = 0.15; // 15% deviation
      monthlyTotals.forEach(m => {
        if (monthlyAvg > 0) {
          const deviation = (m - monthlyAvg) / monthlyAvg;
          if (deviation < 0) {
            monthsBelowAvg++;
            if (deviation < -significanceThreshold) monthsSignificantlyBelow++;
          } else if (deviation > 0) {
            monthsAboveAvg++;
            if (deviation > significanceThreshold) monthsSignificantlyAbove++;
          }
        }
      });
    }
    
    // Pure contracted recurring % — only contracted_defined (weight=1.0) revenue, no partial credit for projects/hardware.
    // TYPE SPLITS HONORED (Mark 09-22, ITCS: two $6M/$3M lines split 50% contracted /
    // 10% project / 40% hardware read as 0% contracted here — only a line's PRIMARY
    // type counted, so the ledger said "3% under contract" against per-client
    // answers of 98%. The recurring % already honored splits; this one now does too:
    // a split line contributes its contracted share, an unsplit line all or nothing.)
    // Resold licensing is NOT contracted MRR (Zac 10-06: "more attractive than product sales, less than
    // projects") — it counts with the contracted-client projects/products below, not here.
    const contractedOnlyIds = ['contracted_defined', 'recurring_contract'];
    const contractedShareOf = (c) => {
      const sp = c.typeSplits && typeof c.typeSplits === 'object' ? c.typeSplits : null;
      if (sp && Object.keys(sp).length) return contractedOnlyIds.reduce((acc, id) => acc + (Number(sp[id]) || 0), 0) / 100;
      return contractedOnlyIds.includes(c.revenueType) ? 1 : 0;
    };
    const contractedOnly = {
      year3: _revCats.reduce((sum, c) => sum + c.year3 * contractedShareOf(c), 0),
      year4: _revCats.reduce((sum, c) => sum + c.year4 * contractedShareOf(c), 0),
      year5: _revCats.reduce((sum, c) => sum + c.year5 * contractedShareOf(c), 0),
      ttm: _revCats.reduce((sum, c) => sum + c.ttm * contractedShareOf(c), 0)
    };
    // Revenue from clients UNDER AGREEMENT (Colleen 10-02): agreement fees PLUS projects and hardware sold to
    // those same clients. What an owner means by "all our clients are under contract" — shown beside the
    // recurring-agreement figure, never in its place (the multiple uses the recurring figure).
    const clientContractedIds = [...contractedOnlyIds, 'recurring_licensing', 'project_contracted', 'recurring_switching', 'hardware_contracted'];
    const clientShareOf = (c) => {
      const sp = c.typeSplits && typeof c.typeSplits === 'object' ? c.typeSplits : null;
      if (sp && Object.keys(sp).length) return clientContractedIds.reduce((acc, id) => acc + (Number(sp[id]) || 0), 0) / 100;
      return clientContractedIds.includes(c.revenueType) ? 1 : 0;
    };
    const clientContractedPct = {};
    ['year3', 'year4', 'year5', 'ttm'].forEach(k => {
      clientContractedPct[k] = totals[k] > 0 ? _revCats.reduce((s, c) => s + c[k] * clientShareOf(c), 0) / totals[k] * 100 : 0;
    });
    // LEGACY strict % (pre-10-06: resold licensing counted as contracted) — only grandfathered valuations' scoring reads it.
    const legacyStrictIds = [...contractedOnlyIds, 'recurring_licensing'];
    const contractedOnlyPctLegacy = {};
    ['year3', 'year4', 'year5', 'ttm'].forEach(k => {
      contractedOnlyPctLegacy[k] = totals[k] > 0 ? _revCats.reduce((s2, c) => {
        const sp = c.typeSplits && typeof c.typeSplits === 'object' && Object.keys(c.typeSplits).length ? c.typeSplits : null;
        const sh = sp ? legacyStrictIds.reduce((a, id) => a + (Number(sp[id]) || 0), 0) / 100 : (legacyStrictIds.includes(c.revenueType) ? 1 : 0);
        return s2 + c[k] * sh;
      }, 0) / totals[k] * 100 : 0;
    });
    const contractedOnlyPct = {
      year3: totals.year3 > 0 ? (contractedOnly.year3 / totals.year3) * 100 : 0,
      year4: totals.year4 > 0 ? (contractedOnly.year4 / totals.year4) * 100 : 0,
      year5: totals.year5 > 0 ? (contractedOnly.year5 / totals.year5) * 100 : 0,
      ttm: totals.ttm > 0 ? (contractedOnly.ttm / totals.ttm) * 100 : 0
    };
    const contractedYearsWithData = [
      { pct: contractedOnlyPct.year3, hasData: totals.year3 > 0 },
      { pct: contractedOnlyPct.year4, hasData: totals.year4 > 0 },
      { pct: contractedOnlyPct.year5, hasData: totals.year5 > 0 },
      { pct: contractedOnlyPct.ttm, hasData: totals.ttm > 0 }
    ].filter(y => y.hasData);
    const avgContractedOnlyPct = contractedYearsWithData.length > 0 ? contractedYearsWithData.reduce((s, y) => s + y.pct, 0) / contractedYearsWithData.length : 0;

    return { 
      totals, baseTotals, adjTotals, revAdjByYear, weightedRecurring, weightedRecurringPct, avgWeightedRecurringPct, yoyChanges, yoyVariance, avgChange,
      validChanges, year5TtmSame,
      monthlyCV, monthlyAvg, monthlyStdDev, hasMonthlyData, monthlyTotals,
      monthsBelowAvg, monthsAboveAvg, monthsSignificantlyBelow, monthsSignificantlyAbove,
      // Fix 3: Dampened recurring
      dampenedWeightedRecurring, dampenedRecurringPct, avgDampenedRecurringPct, damperActive,
      // Fix 1: Reclassification suggestions
      reclassificationSuggestions,
      // Fix 2: Growth quality
      growthByType, totalGrowth, nonRecurringGrowth, nonRecurringGrowthPct, recurringGrowthAmt, recurringGrowthPct, nonRecurringGrowthPctLegacy, recurringGrowthAmtLegacy,
      // Pure contracted recurring (for owner presentation)
      contractedOnly, contractedOnlyPct, avgContractedOnlyPct, clientContractedPct, contractedOnlyPctLegacy
    };
  }, [activeRevenueCategories, ttmMonthlyData, monthlyTtmRevenue, selectedValuationBasis, adjustmentItems, basisYearLabels, selectedIndustry, revenueScoringMode]);

  // YTD and Annualized calculations from monthly TTM data
  const ytdAnnualized = useMemo(() => {
    // Calculate which months in the TTM period fall in the current calendar year
    // TTM indices 0-11: oldest to newest (index 11 = end month)
    const endMonth = monthlyTtmConfig.endMonth; // 0-11 (Jan=0, Dec=11)
    const endYear = monthlyTtmConfig.endYear;
    
    // Build an array of {index, month, year} for the 12 TTM months
    const monthMap = [];
    let m = endMonth - 11;
    let y = endYear;
    if (m < 0) { m += 12; y--; }
    
    for (let i = 0; i < 12; i++) {
      monthMap.push({ index: i, month: m, year: y });
      m++;
      if (m > 11) { m = 0; y++; }
    }
    
    // Find indices that belong to the current year (endYear)
    const ytdIndices = monthMap.filter(x => x.year === endYear).map(x => x.index);
    const ytdMonthCount = ytdIndices.length;
    
    // Helper to sum YTD values from an array of 24 numbers (indices 0-11 are TTM)
    const sumYtd = (arr) => {
      if (!arr || arr.length === 0) return 0;
      return ytdIndices.reduce((sum, idx) => sum + (arr[idx] || 0), 0);
    };
    
    // Sum TTM (all 12 months) - keep full precision
    const sumTtm = (arr) => (arr || []).slice(0, 12).reduce((sum, v) => sum + (v || 0), 0);
    
    // Calculate YTD/Annualized for Revenue
    const revenueYtd = {};
    const revenueAnnualized = {};
    Object.keys(monthlyTtmRevenue).forEach(catId => {
      const basisKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
      const ytdVal = sumYtd(monthlyTtmRevenue[catId]?.[basisKey]);
      revenueYtd[catId] = ytdVal;
      revenueAnnualized[catId] = ytdMonthCount > 0 ? (ytdVal / ytdMonthCount) * 12 : 0;
    });
    const totalRevenueYtd = Object.values(revenueYtd).reduce((s, v) => s + v, 0);
    const totalRevenueAnnualized = ytdMonthCount > 0 ? (totalRevenueYtd / ytdMonthCount) * 12 : 0;
    
    // Calculate YTD/Annualized for COGS
    const cogsYtd = {};
    const cogsAnnualized = {};
    const ytdExistingCogsIds = new Set(cogsCategories.map(c => String(c.id)));
    Object.keys(monthlyTtmCogs).forEach(catId => {
      if (ytdExistingCogsIds.size === 0 || !ytdExistingCogsIds.has(catId)) return; // Skip orphaned
      const basisKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
      const ytdVal = sumYtd(monthlyTtmCogs[catId]?.[basisKey]);
      cogsYtd[catId] = ytdVal;
      cogsAnnualized[catId] = ytdMonthCount > 0 ? (ytdVal / ytdMonthCount) * 12 : 0;
    });
    const totalCogsYtd = Object.values(cogsYtd).reduce((s, v) => s + v, 0);
    const totalCogsAnnualized = ytdMonthCount > 0 ? (totalCogsYtd / ytdMonthCount) * 12 : 0;
    
    // Calculate YTD/Annualized for OpEx
    const opexYtd = {};
    const opexAnnualized = {};
    Object.keys(monthlyTtmOpex).forEach(catId => {
      const basisKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
      const ytdVal = sumYtd(monthlyTtmOpex[catId]?.[basisKey]);
      opexYtd[catId] = ytdVal;
      opexAnnualized[catId] = ytdMonthCount > 0 ? (ytdVal / ytdMonthCount) * 12 : 0;
    });
    const totalOpexYtd = Object.values(opexYtd).reduce((s, v) => s + v, 0);
    const totalOpexAnnualized = ytdMonthCount > 0 ? (totalOpexYtd / ytdMonthCount) * 12 : 0;
    
    // Calculate YTD/Annualized for Other Income
    const otherIncomeYtd = {};
    const otherIncomeAnnualized = {};
    Object.keys(monthlyTtmOtherIncome).forEach(catId => {
      const basisKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
      const ytdVal = sumYtd(monthlyTtmOtherIncome[catId]?.[basisKey]);
      otherIncomeYtd[catId] = ytdVal;
      otherIncomeAnnualized[catId] = ytdMonthCount > 0 ? (ytdVal / ytdMonthCount) * 12 : 0;
    });
    const totalOtherIncomeYtd = Object.values(otherIncomeYtd).reduce((s, v) => s + v, 0);
    const totalOtherIncomeAnnualized = ytdMonthCount > 0 ? (totalOtherIncomeYtd / ytdMonthCount) * 12 : 0;
    
    // Calculate YTD/Annualized for Other Expense
    const otherExpenseYtd = {};
    const otherExpenseAnnualized = {};
    Object.keys(monthlyTtmOtherExpense).forEach(catId => {
      const basisKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
      const ytdVal = sumYtd(monthlyTtmOtherExpense[catId]?.[basisKey]);
      otherExpenseYtd[catId] = ytdVal;
      otherExpenseAnnualized[catId] = ytdMonthCount > 0 ? (ytdVal / ytdMonthCount) * 12 : 0;
    });
    const totalOtherExpenseYtd = Object.values(otherExpenseYtd).reduce((s, v) => s + v, 0);
    const totalOtherExpenseAnnualized = ytdMonthCount > 0 ? (totalOtherExpenseYtd / ytdMonthCount) * 12 : 0;
    
    // Calculate YTD/Annualized for DIAT
    const basisKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
    const diatYtd = {
      depreciation: sumYtd(monthlyTtmDiat.depreciation?.[basisKey]),
      interest: sumYtd(monthlyTtmDiat.interest?.[basisKey]),
      amortization: sumYtd(monthlyTtmDiat.amortization?.[basisKey]),
      taxes: sumYtd(monthlyTtmDiat.taxes?.[basisKey])
    };
    const diatAnnualized = {
      depreciation: ytdMonthCount > 0 ? (diatYtd.depreciation / ytdMonthCount) * 12 : 0,
      interest: ytdMonthCount > 0 ? (diatYtd.interest / ytdMonthCount) * 12 : 0,
      amortization: ytdMonthCount > 0 ? (diatYtd.amortization / ytdMonthCount) * 12 : 0,
      taxes: ytdMonthCount > 0 ? (diatYtd.taxes / ytdMonthCount) * 12 : 0
    };
    const totalDiatYtd = diatYtd.depreciation + diatYtd.interest + diatYtd.amortization + diatYtd.taxes;
    const totalDiatAnnualized = ytdMonthCount > 0 ? (totalDiatYtd / ytdMonthCount) * 12 : 0;
    
    // Gross Profit
    const grossProfitYtd = totalRevenueYtd - totalCogsYtd;
    const grossProfitAnnualized = totalRevenueAnnualized - totalCogsAnnualized;
    
    // Net Income (before DIAT)
    const netIncomeYtd = grossProfitYtd - totalOpexYtd + totalOtherIncomeYtd - totalOtherExpenseYtd;
    const netIncomeAnnualized = grossProfitAnnualized - totalOpexAnnualized + totalOtherIncomeAnnualized - totalOtherExpenseAnnualized;
    
    // EBITDA = Net Income + DIAT
    const ebitdaYtd = netIncomeYtd + totalDiatYtd;
    const ebitdaAnnualized = netIncomeAnnualized + totalDiatAnnualized;
    
    // TTM from monthly data for comparison
    const ttmFromMonthly = {
      revenue: Object.keys(monthlyTtmRevenue).reduce((sum, catId) => {
        const bKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
        return sum + sumTtm(monthlyTtmRevenue[catId]?.[bKey]);
      }, 0),
      cogs: Object.keys(monthlyTtmCogs).filter(catId => ytdExistingCogsIds.size > 0 && ytdExistingCogsIds.has(catId)).reduce((sum, catId) => {
        const bKey = selectedValuationBasis === 'cash' ? 'cash' : 'accrual';
        return sum + sumTtm(monthlyTtmCogs[catId]?.[bKey]);
      }, 0)
    };
    
    return {
      ytdMonthCount,
      ytdYear: endYear,
      revenue: { ytd: revenueYtd, annualized: revenueAnnualized, totalYtd: totalRevenueYtd, totalAnnualized: totalRevenueAnnualized },
      cogs: { ytd: cogsYtd, annualized: cogsAnnualized, totalYtd: totalCogsYtd, totalAnnualized: totalCogsAnnualized },
      opex: { ytd: opexYtd, annualized: opexAnnualized, totalYtd: totalOpexYtd, totalAnnualized: totalOpexAnnualized },
      otherIncome: { ytd: otherIncomeYtd, annualized: otherIncomeAnnualized, totalYtd: totalOtherIncomeYtd, totalAnnualized: totalOtherIncomeAnnualized },
      otherExpense: { ytd: otherExpenseYtd, annualized: otherExpenseAnnualized, totalYtd: totalOtherExpenseYtd, totalAnnualized: totalOtherExpenseAnnualized },
      diat: { ytd: diatYtd, annualized: diatAnnualized, totalYtd: totalDiatYtd, totalAnnualized: totalDiatAnnualized },
      grossProfit: { ytd: grossProfitYtd, annualized: grossProfitAnnualized },
      netIncome: { ytd: netIncomeYtd, annualized: netIncomeAnnualized },
      ebitda: { ytd: ebitdaYtd, annualized: ebitdaAnnualized },
      ttmFromMonthly
    };
  }, [monthlyTtmConfig, monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmOtherIncome, monthlyTtmOtherExpense, monthlyTtmDiat, selectedValuationBasis, cogsCategories]);

  const streamProfitability = useMemo(() => revenueStreams.map(stream => {
    const revTotal = stream.revenueIds.reduce((sum, id) => sum + (activeRevenueCategories.find(c => c.id === id)?.ttm || 0), 0);
    const cogsTotal = stream.cogsIds.reduce((sum, id) => sum + (activeCogsCategories.find(c => c.id === id)?.ttm || 0), 0);
    const grossProfit = revTotal - cogsTotal;
    const grossMargin = revTotal > 0 ? (grossProfit / revTotal) * 100 : 0;
    return { ...stream, revTotal, cogsTotal, grossProfit, grossMargin, flag: grossMargin < 0 ? 'negative' : grossMargin < 10 ? 'low' : null, revenueNames: stream.revenueIds.map(id => activeRevenueCategories.find(c => c.id === id)?.name).filter(Boolean), cogsNames: stream.cogsIds.map(id => activeCogsCategories.find(c => c.id === id)?.name).filter(Boolean) };
  }), [revenueStreams, activeRevenueCategories, activeCogsCategories]);

  const ebitdaMonthlyAnalysis = useMemo(() => {
    // Check if we have monthly data from any source
    const basisKey = selectedValuationBasis === 'tax' ? 'cash' : selectedValuationBasis;
    
    const hasMonthlyRevenue = Object.keys(monthlyTtmRevenue).length > 0 && 
      Object.values(monthlyTtmRevenue).some(catData => (catData?.[basisKey] || []).slice(0, 12).some(v => v > 0));
    
    if (!hasMonthlyRevenue) {
      return { monthlyAvg: 0, monthlyStdDev: 0, monthlyCV: 0, hasMonthlyData: false, negativeMonths: 0, monthlyEbitda: Array(12).fill(0), monthlyEbitdaActual: Array(12).fill(0) };
    }
    
    // Calculate monthly totals for each category (actuals from P&L)
    const monthlyRevenue = Array(12).fill(0);
    const monthlyCogs = Array(12).fill(0);
    const monthlyOpex = Array(12).fill(0);
    const monthlyOtherIncome = Array(12).fill(0);
    const monthlyOtherExpense = Array(12).fill(0);
    const monthlyEbitdaActual = Array(12).fill(0);
    
    // Add revenue
    Object.values(monthlyTtmRevenue).forEach(catData => {
      const data = catData?.[basisKey] || [];
      for (let i = 0; i < 12; i++) {
        monthlyRevenue[i] += (data[i] || 0);
        monthlyEbitdaActual[i] += (data[i] || 0);
      }
    });
    
    // Subtract COGS (only for categories that still exist — orphaned monthly data is ignored)
    const existingCogsIds = new Set(cogsCategories.map(c => String(c.id)));
    Object.entries(monthlyTtmCogs).forEach(([catId, catData]) => {
      if (existingCogsIds.size === 0 || !existingCogsIds.has(catId)) return; // Skip orphaned
      const data = catData?.[basisKey] || [];
      for (let i = 0; i < 12; i++) {
        monthlyCogs[i] += (data[i] || 0);
        monthlyEbitdaActual[i] -= (data[i] || 0);
      }
    });
    
    // Subtract OpEx
    Object.values(monthlyTtmOpex).forEach(catData => {
      const data = catData?.[basisKey] || [];
      for (let i = 0; i < 12; i++) {
        monthlyOpex[i] += (data[i] || 0);
        monthlyEbitdaActual[i] -= (data[i] || 0);
      }
    });
    
    // Add Other Income
    Object.values(monthlyTtmOtherIncome).forEach(catData => {
      const data = catData?.[basisKey] || [];
      for (let i = 0; i < 12; i++) {
        monthlyOtherIncome[i] += (data[i] || 0);
        monthlyEbitdaActual[i] += (data[i] || 0);
      }
    });
    
    // Subtract Other Expense
    Object.values(monthlyTtmOtherExpense).forEach(catData => {
      const data = catData?.[basisKey] || [];
      for (let i = 0; i < 12; i++) {
        monthlyOtherExpense[i] += (data[i] || 0);
        monthlyEbitdaActual[i] -= (data[i] || 0);
      }
    });
    
    // Calculate gross profit
    const monthlyGrossProfit = monthlyRevenue.map((rev, i) => rev - monthlyCogs[i]);
    
    // Count negative EBITDA months (ACTUAL - will be overridden by normalized version)
    const negativeMonths = monthlyEbitdaActual.filter(e => e < 0).length;
    
    const hasMonthlyData = monthlyEbitdaActual.some(v => v !== 0);
    const monthlyAvg = monthlyEbitdaActual.reduce((a, b) => a + b, 0) / 12;
    const monthlyStdDev = Math.sqrt(monthlyEbitdaActual.reduce((sum, m) => sum + Math.pow(m - monthlyAvg, 2), 0) / 12);
    const monthlyCV = monthlyAvg !== 0 ? Math.abs((monthlyStdDev / monthlyAvg) * 100) : 0;
    
    return { 
      monthlyAvg, monthlyStdDev, monthlyCV, hasMonthlyData, negativeMonths,
      monthlyRevenue, monthlyCogs, monthlyGrossProfit, monthlyOpex, 
      monthlyOtherIncome, monthlyOtherExpense, monthlyEbitda: monthlyEbitdaActual, monthlyEbitdaActual
    };
  }, [monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmOtherIncome, monthlyTtmOtherExpense, selectedValuationBasis, cogsCategories]);

  // ========== BALANCE SHEET ==========
  // ========== BALANCE SHEET (Flexible Structure) ==========
  const [bsYearLabels, setBsYearLabels] = useState({
    year1: defaultYears.year3, year2: defaultYears.year4, year3: defaultYears.year5, interim: 'Interim', interimDate: ''
  });
  const [bsBasis, setBsBasis] = useState('accrual'); // 'cash' or 'accrual'
  
  const [bsCurrentAssets, setBsCurrentAssets] = useState([
    { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 },
    { id: 99, name: 'Prepaid Expenses', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true }
  ]);
  
  const [bsFixedAssets, setBsFixedAssets] = useState([
    { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }
  ]);
  
  const [bsOtherAssets, setBsOtherAssets] = useState([
    { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }
  ]);
  
  const [bsCurrentLiabilities, setBsCurrentLiabilities] = useState([
    { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 },
    { id: 97, name: 'Accrued Expenses', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true },
    { id: 98, name: 'Customer Deposits', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true },
    { id: 99, name: 'Deferred Revenue', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true }
  ]);
  
  const [bsLongTermLiabilities, setBsLongTermLiabilities] = useState([
    { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 },
    { id: 99, name: 'Deferred Revenue (LT)', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true }
  ]);
  
  const [bsEquity, setBsEquity] = useState([
    { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }
  ]);
  
  // Balance Sheet Deferred Account Notes
  const [bsRecognitionNotes, setBsRecognitionNotes] = useState({
    deferredRevenue: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
    prepaidExpenses: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
    accruedExpenses: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
    customerDeposits: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
    unearnedRevenue: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' }
  });
  
  // Balance Sheet Issue Notes (for negative equity, stale data, negative balances)
  const [bsIssueNotes, setBsIssueNotes] = useState({});
  const [custRevenueNotes, setCustRevenueNotes] = useState({}); // For tracking customer revenue variance review status

  // Balance Sheet Calculations
  const balanceSheetCalcs = useMemo(() => {
    const sumCategory = (items, yearKey) => items.reduce((sum, item) => sum + (item[yearKey] || 0), 0);
    
    const calcYear = (yearKey) => {
      const totalCurrentAssets = sumCategory(bsCurrentAssets, yearKey);
      const totalFixedAssets = sumCategory(bsFixedAssets, yearKey);
      const totalOtherAssets = sumCategory(bsOtherAssets, yearKey);
      const totalAssets = totalCurrentAssets + totalFixedAssets + totalOtherAssets;
      
      const totalCurrentLiabilities = sumCategory(bsCurrentLiabilities, yearKey);
      const totalLTLiabilities = sumCategory(bsLongTermLiabilities, yearKey);
      const totalLiabilities = totalCurrentLiabilities + totalLTLiabilities;
      
      const totalEquity = sumCategory(bsEquity, yearKey);
      
      // Get specific accounts for ratios
      const cash = bsCashTotal(bsCurrentAssets, yearKey);
      const accountsReceivable = bsTradeAR(bsCurrentAssets, yearKey);
      const inventory = bsCurrentAssets.find(a => a.name.toLowerCase().includes('inventory'))?.[yearKey] || 0;
      const accountsPayable = bsCurrentLiabilities.find(a => a.name.toLowerCase().includes('accounts payable'))?.[yearKey] || 0;
      const longTermDebt = bsLongTermLiabilities.find(a => a.name.toLowerCase().includes('long-term debt'))?.[yearKey] || 0;
      
      // Recognition accounts - SUM ALL matching accounts (not just first)
      // Multiple prepaid/accrued accounts may exist (e.g., Prepaid Insurance, Prepaid Subscriptions, etc.)
      const deferredRevenue = bsCurrentLiabilities.filter(a => 
        a.name.toLowerCase().includes('deferred') || 
        a.name.toLowerCase().includes('unearned') ||
        a.name.toLowerCase().includes('customer deposit')
      ).reduce((sum, a) => sum + (a[yearKey] || 0), 0) +
      bsLongTermLiabilities.filter(a => 
        a.name.toLowerCase().includes('deferred')
      ).reduce((sum, a) => sum + (a[yearKey] || 0), 0);
      
      // Sum ALL prepaid expense accounts
      const prepaidExpenses = bsCurrentAssets.filter(a => 
        a.name.toLowerCase().includes('prepaid')
      ).reduce((sum, a) => sum + (a[yearKey] || 0), 0);
      
      // Sum ALL accrued expense accounts
      const accruedExpenses = bsCurrentLiabilities.filter(a => 
        a.name.toLowerCase().includes('accrued')
      ).reduce((sum, a) => sum + (a[yearKey] || 0), 0);
      
      // Sum ALL customer deposit accounts
      const customerDeposits = bsCurrentLiabilities.filter(a => 
        a.name.toLowerCase().includes('customer deposit') || 
        (a.name.toLowerCase().includes('deposit') && !a.name.toLowerCase().includes('security'))
      ).reduce((sum, a) => sum + (a[yearKey] || 0), 0);
      
      // Sum ALL unearned revenue accounts
      const unearnedRevenue = bsCurrentLiabilities.filter(a => 
        a.name.toLowerCase().includes('unearned')
      ).reduce((sum, a) => sum + (a[yearKey] || 0), 0);
      
      const netWorkingCapital = totalCurrentAssets - totalCurrentLiabilities;
      const netWorkingCapitalExCash = (totalCurrentAssets - cash) - totalCurrentLiabilities;
      const currentRatio = totalCurrentLiabilities > 0 ? totalCurrentAssets / totalCurrentLiabilities : 0;
      const quickRatio = totalCurrentLiabilities > 0 ? (totalCurrentAssets - inventory) / totalCurrentLiabilities : 0;
      
      return {
        totalCurrentAssets, totalFixedAssets, totalOtherAssets, totalAssets,
        totalCurrentLiabilities, totalLTLiabilities, totalLiabilities,
        totalEquity, netWorkingCapital, netWorkingCapitalExCash, currentRatio, quickRatio,
        cash, accountsReceivable, inventory, accountsPayable, longTermDebt,
        deferredRevenue, prepaidExpenses, accruedExpenses, customerDeposits, unearnedRevenue,
        year: bsYearLabels[yearKey]
      };
    };
    
    return {
      year1: calcYear('year1'),
      year2: calcYear('year2'),
      year3: calcYear('year3'),
      interim: calcYear('interim')
    };
  }, [bsCurrentAssets, bsFixedAssets, bsOtherAssets, bsCurrentLiabilities, bsLongTermLiabilities, bsEquity, bsYearLabels]);

  const [valuationBasis, setValuationBasis] = useState('accrual');
  const [varianceThresholdPct] = useState(5);

  // Schedule M-1 reconciliation data
  const [scheduleM1Data] = useState({
    year1: { year: '2022', netIncomePerBooks: 125000, federalIncomeTax: 45000, excessCapitalLosses: 0, incomeSubjectToTax: 0, expensesNotDeductible: 12000, depreciationDifference: -10000, otherDeductions: -5000, taxableIncomePerReturn: 167000 },
    year2: { year: '2023', netIncomePerBooks: 142000, federalIncomeTax: 52000, excessCapitalLosses: 0, incomeSubjectToTax: 0, expensesNotDeductible: 14000, depreciationDifference: -10000, otherDeductions: -6000, taxableIncomePerReturn: 192000 },
    year3: { year: '2024', netIncomePerBooks: 158000, federalIncomeTax: 58000, excessCapitalLosses: 0, incomeSubjectToTax: 0, expensesNotDeductible: 15000, depreciationDifference: -10000, otherDeductions: -7000, taxableIncomePerReturn: 214000 }
  });

  const [opexCategories, setOpexCategories] = useState([
    { id: 1, name: '', plLine: 'Other', addbackPct: 0, diatFlag: null,
      adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }
  ]);

  // Other Income (below operating income - interest income, gain on sale, etc.)
  const [otherIncomeCategories, setOtherIncomeCategories] = useState([
    { id: 1, name: '', addbackPct: 0,
      adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }
  ]);

  // Other Expense (below operating income - interest expense, loss on sale, etc.)
  const [otherExpenseCategories, setOtherExpenseCategories] = useState([
    { id: 1, name: '', addbackPct: 0,
      adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }
  ]);

  // D/I/A/T always shown separately for add-back tracking
  const [diatCategories, setDiatCategories] = useState({
    depreciation: { 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    },
    interest: { 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    },
    amortization: { 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    },
    taxes: { 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0, ytd: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }
  });

  const [addbacks, setAddbacks] = useState({ depreciation: true, interest: true, amortization: true, taxes: true });

  const activeOpexCategories = useMemo(() => {
    const safeNum = (val) => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : parseFloat(val);
      return isNaN(num) ? 0 : num;
    };
    return opexCategories.map(cat => ({
      ...cat,
      year1: safeNum(cat[selectedValuationBasis]?.year1),
      year2: safeNum(cat[selectedValuationBasis]?.year2),
      year3: safeNum(cat[selectedValuationBasis]?.year3),
      year4: safeNum(cat[selectedValuationBasis]?.year4),
      year5: safeNum(cat[selectedValuationBasis]?.year5),
      ttm: safeNum(cat[selectedValuationBasis]?.ttm)
    }));
  }, [opexCategories, selectedValuationBasis]);

  const activeOtherIncomeCategories = useMemo(() => {
    const safeNum = (val) => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : parseFloat(val);
      return isNaN(num) ? 0 : num;
    };
    return otherIncomeCategories.map(cat => ({
      ...cat,
      year1: safeNum(cat[selectedValuationBasis]?.year1),
      year2: safeNum(cat[selectedValuationBasis]?.year2),
      year3: safeNum(cat[selectedValuationBasis]?.year3),
      year4: safeNum(cat[selectedValuationBasis]?.year4),
      year5: safeNum(cat[selectedValuationBasis]?.year5),
      ttm: safeNum(cat[selectedValuationBasis]?.ttm)
    }));
  }, [otherIncomeCategories, selectedValuationBasis]);

  const activeOtherExpenseCategories = useMemo(() => {
    const safeNum = (val) => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : parseFloat(val);
      return isNaN(num) ? 0 : num;
    };
    return otherExpenseCategories.map(cat => ({
      ...cat,
      year1: safeNum(cat[selectedValuationBasis]?.year1),
      year2: safeNum(cat[selectedValuationBasis]?.year2),
      year3: safeNum(cat[selectedValuationBasis]?.year3),
      year4: safeNum(cat[selectedValuationBasis]?.year4),
      year5: safeNum(cat[selectedValuationBasis]?.year5),
      ttm: safeNum(cat[selectedValuationBasis]?.ttm)
    }));
  }, [otherExpenseCategories, selectedValuationBasis]);

  const otherIncomeAnalysis = useMemo(() => ({
    totals: {
      year1: activeOtherIncomeCategories.reduce((sum, cat) => sum + cat.year1, 0),
      year2: activeOtherIncomeCategories.reduce((sum, cat) => sum + cat.year2, 0),
      year3: activeOtherIncomeCategories.reduce((sum, cat) => sum + cat.year3, 0),
      year4: activeOtherIncomeCategories.reduce((sum, cat) => sum + cat.year4, 0),
      year5: activeOtherIncomeCategories.reduce((sum, cat) => sum + cat.year5, 0),
      ttm: activeOtherIncomeCategories.reduce((sum, cat) => sum + cat.ttm, 0)
    }
  }), [activeOtherIncomeCategories]);

  const otherExpenseAnalysis = useMemo(() => ({
    totals: {
      year1: activeOtherExpenseCategories.reduce((sum, cat) => sum + cat.year1, 0),
      year2: activeOtherExpenseCategories.reduce((sum, cat) => sum + cat.year2, 0),
      year3: activeOtherExpenseCategories.reduce((sum, cat) => sum + cat.year3, 0),
      year4: activeOtherExpenseCategories.reduce((sum, cat) => sum + cat.year4, 0),
      year5: activeOtherExpenseCategories.reduce((sum, cat) => sum + cat.year5, 0),
      ttm: activeOtherExpenseCategories.reduce((sum, cat) => sum + cat.ttm, 0)
    }
  }), [activeOtherExpenseCategories]);

  const activeDiatCategories = useMemo(() => {
    const safeNum = (val) => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : parseFloat(val);
      return isNaN(num) ? 0 : num;
    };
    return {
    depreciation: {
      year1: safeNum(diatCategories.depreciation[selectedValuationBasis]?.year1),
      year2: safeNum(diatCategories.depreciation[selectedValuationBasis]?.year2),
      year3: safeNum(diatCategories.depreciation[selectedValuationBasis]?.year3),
      year4: safeNum(diatCategories.depreciation[selectedValuationBasis]?.year4),
      year5: safeNum(diatCategories.depreciation[selectedValuationBasis]?.year5),
      ttm: safeNum(diatCategories.depreciation[selectedValuationBasis]?.ttm)
    },
    interest: {
      year1: safeNum(diatCategories.interest[selectedValuationBasis]?.year1),
      year2: safeNum(diatCategories.interest[selectedValuationBasis]?.year2),
      year3: safeNum(diatCategories.interest[selectedValuationBasis]?.year3),
      year4: safeNum(diatCategories.interest[selectedValuationBasis]?.year4),
      year5: safeNum(diatCategories.interest[selectedValuationBasis]?.year5),
      ttm: safeNum(diatCategories.interest[selectedValuationBasis]?.ttm)
    },
    amortization: {
      year1: safeNum(diatCategories.amortization[selectedValuationBasis]?.year1),
      year2: safeNum(diatCategories.amortization[selectedValuationBasis]?.year2),
      year3: safeNum(diatCategories.amortization[selectedValuationBasis]?.year3),
      year4: safeNum(diatCategories.amortization[selectedValuationBasis]?.year4),
      year5: safeNum(diatCategories.amortization[selectedValuationBasis]?.year5),
      ttm: safeNum(diatCategories.amortization[selectedValuationBasis]?.ttm)
    },
    taxes: {
      year1: safeNum(diatCategories.taxes[selectedValuationBasis]?.year1),
      year2: safeNum(diatCategories.taxes[selectedValuationBasis]?.year2),
      year3: safeNum(diatCategories.taxes[selectedValuationBasis]?.year3),
      year4: safeNum(diatCategories.taxes[selectedValuationBasis]?.year4),
      year5: safeNum(diatCategories.taxes[selectedValuationBasis]?.year5),
      ttm: safeNum(diatCategories.taxes[selectedValuationBasis]?.ttm)
    }
  }; }, [diatCategories, selectedValuationBasis]);

  // ========== BASIS COMPARISON DATA ==========
  // For comparing Cash P&L, Accrual P&L, and Tax Returns BEFORE adjustments
  const [basisComparisonData, setBasisComparisonData] = useState({
    cash: {
      year1: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      year2: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      year3: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      ttm: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 }
    },
    accrual: {
      year1: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      year2: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      year3: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      ttm: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 }
    },
    tax: {
      year1: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      year2: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
      year3: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 }
    }
  });
  const [taxFilingBasis, setTaxFilingBasis] = useState('cash'); // 'cash' or 'accrual'
  // (basisYearLabels moved above the revenueAnalysis memo — 09-09 blank-screen fix)
  
  // Display year labels - formats basisYearLabels with fiscal year awareness
  const displayYearLabels = useMemo(() => {
    try {
      const { formatYearLabel, isCalendarYear } = fiscalYearHelpers;
      return {
        year1: formatYearLabel(basisYearLabels.year1) || basisYearLabels.year1,
        year2: formatYearLabel(basisYearLabels.year2) || basisYearLabels.year2,
        year3: formatYearLabel(basisYearLabels.year3) || basisYearLabels.year3,
        year4: formatYearLabel(basisYearLabels.year4) || basisYearLabels.year4,
        year5: formatYearLabel(basisYearLabels.year5) || basisYearLabels.year5,
        ttm: 'TTM',
        isCalendarYear,
        // Full labels with date ranges for headers/exports
        year1Full: formatYearLabel(basisYearLabels.year1, { showRange: true }) || basisYearLabels.year1,
        year2Full: formatYearLabel(basisYearLabels.year2, { showRange: true }) || basisYearLabels.year2,
        year3Full: formatYearLabel(basisYearLabels.year3, { showRange: true }) || basisYearLabels.year3,
        year4Full: formatYearLabel(basisYearLabels.year4, { showRange: true }) || basisYearLabels.year4,
        year5Full: formatYearLabel(basisYearLabels.year5, { showRange: true }) || basisYearLabels.year5
      };
    } catch (e) {
      console.error('displayYearLabels error:', e);
      return {
        year1: basisYearLabels.year1,
        year2: basisYearLabels.year2,
        year3: basisYearLabels.year3,
        year4: basisYearLabels.year4,
        year5: basisYearLabels.year5,
        ttm: 'TTM',
        isCalendarYear: true,
        year1Full: basisYearLabels.year1,
        year2Full: basisYearLabels.year2,
        year3Full: basisYearLabels.year3,
        year4Full: basisYearLabels.year4,
        year5Full: basisYearLabels.year5
      };
    }
  }, [basisYearLabels, fiscalYearHelpers]);
  
  const [showAllYears, setShowAllYears] = useState(false); // Toggle for 3-year vs 5-year view
  const [showReviewFlags, setShowReviewFlags] = useState(true); // Toggle review flags panel
  const [showManualReviewPanel, setShowManualReviewPanel] = useState(true); // Toggle manual review items panel
  const [incomeStmtViewMode, setIncomeStmtViewMode] = useState('full'); // 'full' | 'actuals' | 'normalized'
  const [basisYearTab, setBasisYearTab] = useState('year5'); // Which year tab is active in Basis entry
  const [reconYearTab, setReconYearTab] = useState('year5'); // Which year is shown in Reconciliation tab
  const [varianceThreshold, setVarianceThreshold] = useState(10); // % threshold for flagging variances
  const [reconMaterialityThreshold, setReconMaterialityThreshold] = useState(1000); // $ minimum to flag
  const [arMaterialityThreshold, setArMaterialityThreshold] = useState(1000); // $ minimum to flag AR aging items
  const [reconCashVsAccrualExpanded, setReconCashVsAccrualExpanded] = useState(false);
  const [reconTaxVsPLExpanded, setReconTaxVsPLExpanded] = useState(false);
  const [reconSalesVsPLExpanded, setReconSalesVsPLExpanded] = useState(true); // Default open - important check
  const [reconArBsExpanded, setReconArBsExpanded] = useState(true); // Default open - AR to BS reconciliation
  const [reconM1Expanded, setReconM1Expanded] = useState(false); // Schedule M-1 reconciliation
  const [reconQualityExpanded, setReconQualityExpanded] = useState(true); // Quality of earnings issues
  const [bsFlagsExpanded, setBsFlagsExpanded] = useState(true);
  const [salesFlagsExpanded, setSalesFlagsExpanded] = useState(true);
  const [arapFlagsExpanded, setArapFlagsExpanded] = useState(true);
  
  // Quick Note floating button state
  const [showQuickNote, setShowQuickNote] = useState(false);
  const [quickNoteText, setQuickNoteText] = useState('');
  const [quickNotePriority, setQuickNotePriority] = useState('medium');
  const [quickNoteAskOwner, setQuickNoteAskOwner] = useState(false);
  const [quickNoteReviewer, setQuickNoteReviewer] = useState(false);
  
  // Track which analyst flag is being resolved (for inline resolution input)
  const [resolvingFlagKey, setResolvingFlagKey] = useState(null);
  const [resolutionText, setResolutionText] = useState('');

  // Reconciliation Variance Status & Notes
  // Key format: [section]_[id]_[year] e.g., 'rev_1_year5', 'cogs_total_year5', 'opex_5_year4'
  // status: 'unreviewed' | 'reviewing' | 'explained' | 'adjustment' | 'waived'
  const [reconVarianceStatus, setReconVarianceStatus] = useState({});
  
  // Quality of Earnings review checklist (for auto-flagged aggregate issues)
  // Key format: qoe_[type] e.g., 'qoe_cash_accrual_ebitda', 'qoe_tax_net_income', 'qoe_sales_revenue', 'qoe_ar_bs'
  const [reconQualityChecklist, setReconQualityChecklist] = useState({});
  
  // Balance Sheet variance/stale account status tracking
  // Key format: bs_[section]_[id]_[period] e.g., 'bs_ca_1_year2', 'bs_stale_fa_3'
  const [bsVarianceStatus, setBsVarianceStatus] = useState({});
  
  // Income Statement variance status tracking (TTM vs Annualized, YoY, etc.)
  // Key format: is_[type]_[category]_[id] e.g., 'is_ttm_rev_1', 'is_yoy_opex_5'
  const [incomeVarianceStatus, setIncomeVarianceStatus] = useState({});

  // Schedule M-1 Items (Book-to-Tax Adjustments)
  const [scheduleM1, setScheduleM1] = useState({
    year3: {
      mealsEntertainment: { book: 0, tax: 0, notes: '' },
      depreciation: { book: 0, tax: 0, notes: '' },
      badDebt: { book: 0, tax: 0, notes: '' },
      officerLifeInsurance: { book: 0, tax: 0, notes: '' },
      finesPenalties: { book: 0, tax: 0, notes: '' },
      taxExemptInterest: { book: 0, tax: 0, notes: '' },
      section179: { book: 0, tax: 0, notes: '' },
      other1: { description: '', book: 0, tax: 0, notes: '' },
      other2: { description: '', book: 0, tax: 0, notes: '' }
    },
    year4: {
      mealsEntertainment: { book: 0, tax: 0, notes: '' },
      depreciation: { book: 0, tax: 0, notes: '' },
      badDebt: { book: 0, tax: 0, notes: '' },
      officerLifeInsurance: { book: 0, tax: 0, notes: '' },
      finesPenalties: { book: 0, tax: 0, notes: '' },
      taxExemptInterest: { book: 0, tax: 0, notes: '' },
      section179: { book: 0, tax: 0, notes: '' },
      other1: { description: '', book: 0, tax: 0, notes: '' },
      other2: { description: '', book: 0, tax: 0, notes: '' }
    },
    year5: {
      mealsEntertainment: { book: 0, tax: 0, notes: '' },
      depreciation: { book: 0, tax: 0, notes: '' },
      badDebt: { book: 0, tax: 0, notes: '' },
      officerLifeInsurance: { book: 0, tax: 0, notes: '' },
      finesPenalties: { book: 0, tax: 0, notes: '' },
      taxExemptInterest: { book: 0, tax: 0, notes: '' },
      section179: { book: 0, tax: 0, notes: '' },
      other1: { description: '', book: 0, tax: 0, notes: '' },
      other2: { description: '', book: 0, tax: 0, notes: '' }
    }
  });

  // Compute totals from opex categories for calculations
  const opexTotals = useMemo(() => {
    const sumByYear = (year) => activeOpexCategories.reduce((sum, cat) => sum + (cat[year] || 0), 0);
    return {
      year1: sumByYear('year1'),
      year2: sumByYear('year2'),
      year3: sumByYear('year3'),
      year4: sumByYear('year4'),
      year5: sumByYear('year5'),
      ttm: sumByYear('ttm')
    };
  }, [activeOpexCategories]);

  // Create financial data structure expected by calculations
  const activeFinancialData = useMemo(() => {
    const buildYear = (yearKey) => {
      // Sum all OpEx categories directly instead of trying to match by plLine
      const opexTotal = activeOpexCategories.reduce((sum, c) => sum + (c[yearKey] || 0), 0);
      return {
        year: yearKey === 'ttm' ? 'TTM' : basisYearLabels[yearKey] || yearKey,
        // Put all OpEx in 'other' since we have custom line items
        salaries: 0,
        rent: 0,
        utilities: 0,
        insurance: 0,
        marketing: 0,
        maintenance: 0,
        professional: 0,
        other: opexTotal,
        depreciation: activeDiatCategories.depreciation[yearKey] || 0,
        interest: activeDiatCategories.interest[yearKey] || 0,
        amortization: activeDiatCategories.amortization[yearKey] || 0,
        taxes: activeDiatCategories.taxes[yearKey] || 0
      };
    };
    return {
      year1: buildYear('year1'),
      year2: buildYear('year2'),
      year3: buildYear('year3'),
      year4: buildYear('year4'),
      year5: buildYear('year5'),
      ttm: buildYear('ttm')
    };
  }, [activeOpexCategories, activeDiatCategories, basisYearLabels]);

  // ========== BASIS VARIANCE ANALYSIS ==========
  const basisVarianceAnalysis = useMemo(() => {
    const calcVariance = (val1, val2) => {
      if (val1 === 0 && val2 === 0) return { diff: 0, pct: 0, material: false };
      const diff = val1 - val2;
      const pct = val2 !== 0 ? (diff / Math.abs(val2)) * 100 : (val1 !== 0 ? 100 : 0);
      const material = Math.abs(diff) > 10000 || Math.abs(pct) > 5; // Material if >$10K or >5%
      return { diff, pct, material };
    };
    
    const analyzeYear = (yearKey) => {
      const cash = basisComparisonData.cash[yearKey] || {};
      const accrual = basisComparisonData.accrual[yearKey] || {};
      const tax = basisComparisonData.tax[yearKey] || {};
      const comparePL = taxFilingBasis === 'cash' ? cash : accrual;
      
      return {
        cashVsAccrual: {
          revenue: calcVariance(cash.revenue, accrual.revenue),
          cogs: calcVariance(cash.cogs, accrual.cogs),
          grossProfit: calcVariance(cash.grossProfit, accrual.grossProfit),
          opex: calcVariance(cash.opex, accrual.opex),
          netIncome: calcVariance(cash.netIncome, accrual.netIncome)
        },
        taxVsPL: {
          revenue: calcVariance(tax.revenue, comparePL.revenue),
          cogs: calcVariance(tax.cogs, comparePL.cogs),
          grossProfit: calcVariance(tax.grossProfit, comparePL.grossProfit),
          opex: calcVariance(tax.opex, comparePL.opex),
          netIncome: calcVariance(tax.netIncome, comparePL.netIncome)
        }
      };
    };
    
    const variances = {
      year1: analyzeYear('year1'),
      year2: analyzeYear('year2'),
      year3: analyzeYear('year3')
    };
    
    // Count material variances
    const countMaterial = (yearVar) => {
      let count = 0;
      Object.values(yearVar.cashVsAccrual).forEach(v => { if (v.material) count++; });
      Object.values(yearVar.taxVsPL).forEach(v => { if (v.material) count++; });
      return count;
    };
    
    const totalMaterialVariances = countMaterial(variances.year1) + countMaterial(variances.year2) + countMaterial(variances.year3);
    
    return { variances, totalMaterialVariances };
  }, [basisComparisonData, taxFilingBasis]);

  // ========== OWNER COMPENSATION ==========
  const [ownerCompensation, setOwnerCompensation] = useState({
    year1: { salary: 0, source: 'qa', verified: false, verificationDoc: '' },
    year2: { salary: 0, source: 'qa', verified: false, verificationDoc: '' },
    year3: { salary: 0, source: 'qa', verified: false, verificationDoc: '' },
    year4: { salary: 0, source: 'qa', verified: false, verificationDoc: '' },
    year5: { salary: 0, source: 'qa', verified: false, verificationDoc: '' },
    ttm: { salary: 0, source: 'qa', verified: false, verificationDoc: '' },
    embeddedInWages: true,
    marketReplacement: 0,
    marketReplacementNotes: '',
    payrollTaxRate: 7.65,
    includePayrollTax: true
  });
  // 🧾 The owner payroll-tax adjustment for one period (10-22): + = more expense. Each period's own wage base.
  const payrollTaxYear = (period) => {
    if (period === 'ttm') return monthlyTtmConfig.endYear;
    const m = String((basisYearLabels && basisYearLabels[period]) || '').match(/(19|20)\d\d/);
    return m ? Number(m[0]) : monthlyTtmConfig.endYear;
  };
  const ownerTaxAdj = (salary, market, period) => ownerPayrollTaxDiff(ownerCompensation, salary, ocHasMarketFor(ownerCompensation, period) ? ocMarketFor(ownerCompensation, period) : market, payrollTaxYear(period), payrollTaxMethod, period);
  const mkFor = (period) => ocMarketFor(ownerCompensation, period);
  const payrollTaxYears = { year3: payrollTaxYear('year3'), year4: payrollTaxYear('year4'), year5: payrollTaxYear('year5'), ttm: payrollTaxYear('ttm') };
  const payrollTaxLabel = payrollTaxMethod === 'flat' ? ((Number(ownerCompensation.payrollTaxRate) || 7.65).toFixed(2) + '%') : 'Social Security to the wage base + Medicare';
  const payrollTaxDesc = payrollTaxDescribe(ownerCompensation, payrollTaxMethod);

  // ========== ADJUSTMENTS (Add-backs & Deductions) ==========
  // Type: 'add' increases the line item, 'deduct' decreases the line item
  // (adjustmentItems moved above the revenueAnalysis memo — 09-09 blank-screen fix)
  // Explicit Stage Engine signal (Task 13): 'not_started' | 'in_progress' | 'complete'.
  // 'complete' is what derives adjustments_entered — replaces the old
  // adjustmentItems.length heuristic (a project can legitimately have zero
  // adjustments, and stale prior-cycle rows could derive a false stage).
  const [adjustmentsStatus, setAdjustmentsStatus] = useState('not_started');
  const [adjustmentSort, setAdjustmentSort] = useState({ column: null, direction: 'asc' }); // Sort state for adjustments table

  const [newAdjustment, setNewAdjustment] = useState({ type: 'deduct', category: '', plLine: '', description: '', amount: 0, included: true, source: '', verificationDoc: '', year: 'All Years', ttmMonth: 'spread' });
  const [adjustmentWarning, setAdjustmentWarning] = useState('');
  const [plLineSearch, setPlLineSearch] = useState('');
  const [plLineDropdownOpen, setPlLineDropdownOpen] = useState(false);
  const [copyMenuOpen, setCopyMenuOpen] = useState({ id: null, x: 0, y: 0, item: null, selectedYears: [] });

  // Helper function to get account balance for a P&L line
  const getLineBalance = (plLine, year) => {
    if (!plLine) return Infinity;
    
    // Map year label to yearKey
    const yearMap = {
      [basisYearLabels.year1]: 'year1',
      [basisYearLabels.year2]: 'year2', 
      [basisYearLabels.year3]: 'year3',
      [basisYearLabels.year4]: 'year4',
      [basisYearLabels.year5]: 'year5',
      'TTM': 'ttm',
      'All Years': 'all'
    };
    const yearKey = yearMap[year] || 'all';
    
    // Determine which years have actual P&L data (total revenue > 0)
    const activeYearKeys = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'].filter(yk => {
      const yearRevenue = revenueCategories.reduce((sum, cat) => sum + Math.abs(cat[selectedValuationBasis]?.[yk] || 0), 0);
      return yearRevenue > 0;
    });
    
    // Helper to sum across years if "All Years" - only active years
    const getYearValue = (dataObj) => {
      if (yearKey === 'all') {
        const activeValues = activeYearKeys.map(yk => dataObj?.[yk] || 0);
        return activeValues.length > 0 ? Math.min(...activeValues) : 0;
      }
      return dataObj?.[yearKey] || 0;
    };
    
    // Check Revenue lines
    if (plLine === 'Revenue') {
      let total = revenueCategories.reduce((sum, cat) => sum + getYearValue(cat[selectedValuationBasis]), 0);
      if (total === 0 && yearKey === 'ttm') {
        total = revenueCategories.reduce((sum, cat) => {
          const monthly = monthlyTtmRevenue?.[cat.id]?.[selectedValuationBasis];
          return sum + (monthly ? monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0) : 0);
        }, 0);
      }
      return total;
    }
    if (plLine.startsWith('Revenue: ')) {
      const lineName = plLine.replace('Revenue: ', '');
      const cat = revenueCategories.find(c => c.name === lineName);
      if (!cat) return 0;
      let val = getYearValue(cat[selectedValuationBasis]);
      if (val === 0 && yearKey === 'ttm') {
        const monthly = monthlyTtmRevenue?.[cat.id]?.[selectedValuationBasis];
        if (monthly) val = monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
      }
      return val;
    }
    
    // Check COGS lines
    if (plLine === 'COGS') {
      let total = cogsCategories.reduce((sum, cat) => sum + getYearValue(cat[selectedValuationBasis]), 0);
      // Also check monthly COGS data if annual is empty for TTM
      if (total === 0 && yearKey === 'ttm') {
        total = cogsCategories.reduce((sum, cat) => {
          const monthly = monthlyTtmCogs?.[cat.id]?.[selectedValuationBasis];
          return sum + (monthly ? monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0) : 0);
        }, 0);
      }
      return total;
    }
    if (plLine.startsWith('COGS: ')) {
      const lineName = plLine.replace('COGS: ', '');
      const cat = cogsCategories.find(c => c.name === lineName);
      if (!cat) return 0;
      let val = getYearValue(cat[selectedValuationBasis]);
      // Check monthly data if annual shows $0 for TTM
      if (val === 0 && yearKey === 'ttm') {
        const monthly = monthlyTtmCogs?.[cat.id]?.[selectedValuationBasis];
        if (monthly) val = monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
      }
      return val;
    }
    
    // Check OpEx lines
    if (plLine === 'Other OpEx') {
      let total = opexCategories.reduce((sum, cat) => sum + getYearValue(cat[selectedValuationBasis]), 0);
      if (total === 0 && yearKey === 'ttm') {
        total = opexCategories.reduce((sum, cat) => {
          const monthly = monthlyTtmOpex?.[cat.id]?.[selectedValuationBasis];
          return sum + (monthly ? monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0) : 0);
        }, 0);
      }
      return total;
    }
    if (plLine.startsWith('OpEx: ')) {
      const lineName = plLine.replace('OpEx: ', '');
      const cat = opexCategories.find(c => c.name === lineName);
      if (!cat) return 0;
      let val = getYearValue(cat[selectedValuationBasis]);
      if (val === 0 && yearKey === 'ttm') {
        const monthly = monthlyTtmOpex?.[cat.id]?.[selectedValuationBasis];
        if (monthly) val = monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
      }
      return val;
    }
    
    // Check Other Income lines
    if (plLine === 'Other Income') {
      let total = otherIncomeCategories.reduce((sum, cat) => sum + getYearValue(cat[selectedValuationBasis]), 0);
      if (total === 0 && yearKey === 'ttm') {
        total = otherIncomeCategories.reduce((sum, cat) => {
          const monthly = monthlyTtmOtherIncome?.[cat.id]?.[selectedValuationBasis];
          return sum + (monthly ? monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0) : 0);
        }, 0);
      }
      return total;
    }
    if (plLine.startsWith('OtherIncome: ')) {
      const lineName = plLine.replace('OtherIncome: ', '');
      const cat = otherIncomeCategories.find(c => c.name === lineName);
      if (!cat) return 0;
      let val = getYearValue(cat[selectedValuationBasis]);
      if (val === 0 && yearKey === 'ttm') {
        const monthly = monthlyTtmOtherIncome?.[cat.id]?.[selectedValuationBasis];
        if (monthly) val = monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
      }
      return val;
    }
    
    // Check Other Expense lines
    if (plLine === 'Other Expense') {
      let total = otherExpenseCategories.reduce((sum, cat) => sum + getYearValue(cat[selectedValuationBasis]), 0);
      if (total === 0 && yearKey === 'ttm') {
        total = otherExpenseCategories.reduce((sum, cat) => {
          const monthly = monthlyTtmOtherExpense?.[cat.id]?.[selectedValuationBasis];
          return sum + (monthly ? monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0) : 0);
        }, 0);
      }
      return total;
    }
    if (plLine.startsWith('OtherExpense: ')) {
      const lineName = plLine.replace('OtherExpense: ', '');
      const cat = otherExpenseCategories.find(c => c.name === lineName);
      if (!cat) return 0;
      let val = getYearValue(cat[selectedValuationBasis]);
      if (val === 0 && yearKey === 'ttm') {
        const monthly = monthlyTtmOtherExpense?.[cat.id]?.[selectedValuationBasis];
        if (monthly) val = monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
      }
      return val;
    }
    
    // Check D/I/A/T lines
    if (plLine === 'Depreciation') return getYearValue(diatCategories.depreciation?.[selectedValuationBasis]);
    if (plLine === 'Amortization') return getYearValue(diatCategories.amortization?.[selectedValuationBasis]);
    if (plLine === 'Interest') return getYearValue(diatCategories.interest?.[selectedValuationBasis]);
    if (plLine === 'Taxes') return getYearValue(diatCategories.taxes?.[selectedValuationBasis]);
    
    // CapEx, Rent (Market Adj), and other special lines - no limit
    return Infinity;
  };

  // Get total existing deductions for a P&L line
  const getExistingDeductions = (plLine, year, excludeId = null) => {
    return adjustmentItems
      .filter(a => a.included && a.type === 'deduct' && a.plLine === plLine && a.id !== excludeId)
      .filter(a => year === 'All Years' || a.year === 'All Years' || a.year === year)
      .reduce((sum, a) => sum + a.amount, 0);
  };

  // Validate if a deduction amount is allowed
  const validateDeduction = (plLine, year, amount, excludeId = null) => {
    if (!plLine || amount <= 0) return { valid: true, message: '' };
    
    const balance = getLineBalance(plLine, year);
    const existingDeductions = getExistingDeductions(plLine, year, excludeId);
    const totalAfterDeduction = existingDeductions + amount;
    
    if (balance !== Infinity && totalAfterDeduction > balance) {
      const available = Math.max(0, balance - existingDeductions);
      return {
        valid: false,
        message: `Cannot deduct $${amount.toLocaleString()} from "${plLine}" - only $${available.toLocaleString()} available (balance: $${balance.toLocaleString()}, existing deductions: $${existingDeductions.toLocaleString()})`
      };
    }
    return { valid: true, message: '' };
  };

  // Helper functions for adjustments
  const updateAdjustment = (id, field, value) => {
    const item = adjustmentItems.find(a => a.id === id);
    if (!item) return;
    
    // If updating amount or plLine on a deduction, validate
    if (item.type === 'deduct' || (field === 'type' && value === 'deduct')) {
      const newAmount = field === 'amount' ? value : item.amount;
      const newPlLine = field === 'plLine' ? value : item.plLine;
      const newYear = field === 'year' ? value : item.year;
      const newType = field === 'type' ? value : item.type;
      
      if (newType === 'deduct') {
        const validation = validateDeduction(newPlLine, newYear, newAmount, id);
        if (!validation.valid) {
          setAdjustmentWarning(validation.message);
          setTimeout(() => setAdjustmentWarning(''), 5000);
          return; // Don't update
        }
      }
    }
    
    setAdjustmentWarning('');
    // Track when source documentation is added
    if (field === 'source' && value) {
      setAdjustmentItems(adjustmentItems.map(item => item.id === id ? { ...item, [field]: value, sourceAddedAt: new Date().toLocaleDateString() } : item));
    } else {
      setAdjustmentItems(adjustmentItems.map(item => item.id === id ? { ...item, [field]: value } : item));
    }
  };
  
  const deleteAdjustment = (id) => {
    captureUndoState('Delete Adjustment');
    setAdjustmentItems(adjustmentItems.filter(item => item.id !== id));
  };
  
  const addNewAdjustment = () => {
    // Require P&L Line
    if (!newAdjustment.plLine) {
      setAdjustmentWarning('P&L Line is required for all adjustments');
      setTimeout(() => setAdjustmentWarning(''), 5000);
      return;
    }
    
    // Require description
    if (!newAdjustment.description || newAdjustment.description.trim() === '') {
      setAdjustmentWarning('Description is required for all adjustments');
      setTimeout(() => setAdjustmentWarning(''), 5000);
      return;
    }
    
    // Validate deductions don't exceed account balance
    if (newAdjustment.type === 'deduct' && newAdjustment.amount > 0) {
      const validation = validateDeduction(newAdjustment.plLine, newAdjustment.year, newAdjustment.amount);
      if (!validation.valid) {
        setAdjustmentWarning(validation.message);
        setTimeout(() => setAdjustmentWarning(''), 5000);
        return; // Don't add
      }
    }
    
    setAdjustmentWarning('');
    setAdjustmentItems([...adjustmentItems, { ...newAdjustment, id: Date.now() }]);
    setNewAdjustment({ type: 'deduct', category: '', plLine: '', description: '', amount: 0, included: true, source: '', verificationDoc: '', year: 'All Years', ttmMonth: 'spread' });
    setPlLineSearch('');
  };

  const [valuationInputs, setValuationInputs] = useState({ 
    multipleMin: 3.5, 
    multipleMax: 4.5, 
    weightingMethod: 'ttm',
    includeYear1: true,
    includeYear2: true,
    includeYear3: true,
    weightYear1: 1,
    weightYear2: 2,
    weightYear3: 3
  });

  // ========== DEAL STRUCTURE SLIDERS ==========
  // Base structure assumes 90% cash / 10% seller note
  // Risk premium multipliers per 10% shift from base:
  // - Seller Note: +2.5% (lowest risk - just deferred payment)
  // - Equity: +6% (medium risk - tied to buyer success, has upside)
  // - Earnout: +10% (highest risk - tied to targets, buyer can manipulate)
  const [dealStructure, setDealStructure] = useState({
    sellerNote: 10,  // Base 10%
    earnout: 0,
    equity: 0
  });

  // ========== SBA ANALYSIS ==========
  const [sbaParams, setSbaParams] = useState({
    downPaymentPct: 10,
    sellerNotePct: 10,
    sellerNoteRate: 5.0,
    sellerNoteTerm: 10,
    sbaLoanRate: 10.0,
    sbaLoanTerm: 10,
    // 🏢 Real estate in the sale (Mark 10-20, Aeroform + AF Realty): off by default
    reIncluded: false, reValue: 0, reRent: 0, reDownPct: 10, reRate: 7.0, reTerm: 25, reRentAddedBack: false
  });
  // The financing page goes in the export by itself once real estate is in the sale (Colleen 10-20).
  useEffect(() => { if (sbaParams.reIncluded) setExportOptions(prev => ({ ...prev, sbaReport: true })); }, [sbaParams.reIncluded]);

  // ========== DOCUMENT CHECKLIST ==========
  const [documentChecklist, setDocumentChecklist] = useState(
    DEFAULT_DOCUMENT_CHECKLIST.map(d => ({ ...d }))
  );
  // Stage C: ShareFile auto-Received signal for the open valuation, keyed by
  // item_key (= String(doc.id)). Populated on load from engagement_checklist_items'
  // sharefile_* columns — those columns are NOT in the data JSONB blob and are
  // never written by syncChecklistToTable, so they survive every save. Used to
  // badge "📥 received via ShareFile" on items the owner uploaded but Konnie
  // hasn't entered yet (status !== 'complete').
  const [sharefileReceived, setSharefileReceived] = useState({});
  // #8: owner-flagged "doesn't apply / don't have it" per checklist item_key →
  // reason note. Fetched on valuation load; badged on the data-entry doc row.
  const [ownerNaMap, setOwnerNaMap] = useState({});
  // Stage D1: owner answers submitted via the portal (owner_question_responses
  // rows). Staff accept them into the Q&A from the Discovery tab.
  const [ownerPortalAnswers, setOwnerPortalAnswers] = useState([]);

  // ── Second-round forms unlock email (Konnie/Mark 2026-07-29) ──
  // Entering the P&Ls / sales report unlocks Revenue Classification (28) and
  // Client Detail (29) in the portal SILENTLY — the owner won't know until the
  // next cadence reminder. This banner + review-and-send email IS the unlock
  // notification: Konnie edits/sends it the moment she finishes entering.
  // unlockEmailSentAt on the checklist item keeps the banner from nagging.
  // (Declared after documentChecklist's useState — the filter runs eagerly at
  // render, so it must not sit above the declaration.)
  const formsUnlockLabel = (d) => d.id === 28 ? 'Revenue Classification' : 'Client Detail Report';
  const formsToAnnounce = documentChecklist.filter(d => {
    if (d.id !== 28 && d.id !== 29) return false;
    if (d.status === 'complete' || d.unlockEmailSentAt) return false;
    if (!Array.isArray(d.unlockedBy) || d.unlockedBy.length === 0) return false;
    return d.unlockedBy.some(id => documentChecklist.find(x => x.id === id)?.status === 'complete');
  });
  // Konnie 2026-07-30: the Client Detail form's top-20 re-ranks when the OTHER
  // sales report lands (TTM beats the 5-year fallback), so announcing it while
  // one report is still pending invites the owner to fill rows that later drop
  // out of view. Answers are name-keyed and survive (accept flags orphans),
  // but the banner warns so she enters both first and sends ONE email.
  const clientDetailSalesPending = formsToAnnounce.some(d => d.id === 29)
    && (() => {
      const anyPlanned = documentChecklist.some(d => d.planned);
      return documentChecklist.some(d => (d.id === 5 || d.id === 26)
        && (!anyPlanned || d.planned) && d.status !== 'complete');
    })();
  const sendFormsUnlockedEmail = () => {
    if (isReadOnlyViewer) return;
    const w = workflowRef.current || {};
    if (!w.owner_email) { window.alert('Add an owner email first — they need the portal link.'); return; }
    const names = formsToAnnounce.map(formsUnlockLabel);
    const ids = formsToAnnounce.map(d => d.id);
    const to = w.owner_email.trim();
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal'
      + '#e=' + encodeURIComponent(to);
    const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : [])
      .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
    const first = (w.owner_first_name || '').trim();
    const greeting = first ? `Hi ${first},` : 'Hello,';
    // Per-form tone (Mark 2026-07-29): Revenue Classification is a few
    // minutes of tagging — never tell the owner it's "a lot of data". That
    // framing (plus the three completion paths) belongs to Client Detail only.
    const revOnly = ids.length === 1 && ids[0] === 28;
    const detailOnly = ids.length === 1 && ids[0] === 29;
    const defaultBody = revOnly ? `${greeting}

Good news — I've received and entered your P&L statements. That unlocked a quick next step: the Revenue Classification form is now ready in your secure portal.

It's straightforward — your revenue lines are already listed there from your own P&Ls; you just tag each one so we understand the structure of your sales. It usually takes only a few minutes.

If you'd rather work in Excel, reply to this email and I'll send it as a spreadsheet instead.

Questions welcome any time — just reply to this email.` : detailOnly ? `${greeting}

Good news — I've received and entered your sales report. That unlocked the next step: the Client Detail Report is now ready in your secure portal.

I know it's a lot of data, so pick whichever way is easiest for you:

• Fill it out right in the portal — it saves as you go, and your client list is already pre-filled from your own reports.
• Prefer a spreadsheet? Reply to this email and I'll send it as an Excel file you can complete and send back.
• Already have this information in another format? Send me what you have — I can usually use it to fill in the report for you.

Questions welcome any time — just reply to this email.` : `${greeting}

Good news — I've received and entered your reports. That unlocked the next two steps, both ready now in your secure portal:

• The Revenue Classification form — a quick one: your revenue lines are already listed from your own P&Ls; you just tag each so we understand the structure of your sales. A few minutes.
• The Client Detail Report — this one's more data, so pick whichever way is easiest: fill it out in the portal (it saves as you go, and your client list is pre-filled), reply and I'll send it as an Excel file, or send me the information in any format you already have and I can usually fill in the report for you.

Questions welcome any time — just reply to this email.`;
    setPendingEmail({
      heading: 'Next forms are ready — review & send',
      to, cc,
      subject: `Next step for your valuation — ${names.join(' + ')} ready in your portal`,
      sender: 'konnie', // document-flow → Konnie
      defaultBody,
      buildHtml: (b) => buildPortalEmailHtml({ bodyText: b, signerName: 'Konnie Budreau', portalUrl }),
      onSent: () => {
        const nowIso = new Date().toISOString();
        setDocumentChecklist(prev => prev.map(d => ids.includes(d.id) ? { ...d, unlockEmailSentAt: nowIso } : d));
        setHasUnsavedChanges(true);
        if (currentValuationId) {
          logActivity(currentValuationId, 'outreach',
            `Second-round forms email sent to ${to} (${names.join(', ')})`,
            { kind: 'forms_unlocked', items: ids });
        }
      },
    });
  };

  // ========== SELLER Q&A ==========
  // Cloned from the module-scope DEFAULT_SELLER_QA (single source of truth,
  // shared with the warm-account direct insert so the owner portal shows the
  // same discovery questionnaire). Fresh followUps array per instance so no
  // component mutates the shared template.
  const [sellerQA, setSellerQA] = useState(() => DEFAULT_SELLER_QA.map(q => ({ ...q, followUps: [] })));

  const [newFollowUp, setNewFollowUp] = useState({ qaId: null, question: '' });
  const addFollowUp = (qaId) => {
    if (newFollowUp.question && newFollowUp.qaId === qaId) {
      setSellerQA(sellerQA.map(qa => qa.id === qaId ? {...qa, followUps: [...qa.followUps, { id: Date.now(), question: newFollowUp.question, answer: '', status: 'pending' }]} : qa));
      setNewFollowUp({ qaId: null, question: '' });
    }
  };

  // ========== AR REVIEW CHECKLIST ==========
  const [arReviewChecklist, setArReviewChecklist] = useState({
    notApplicable: false, // For businesses without AR (retail, etc.)
    reportDateMatches: { checked: false, notes: '' },
    totalTiesToBS: { checked: false, notes: '' },
    noNegativeBalances: { checked: false, notes: '' },
    agingDistributionReasonable: { checked: false, notes: '' },
    noCustomerMultipleBuckets: { checked: false, notes: '' },
    over120LessThanAllowance: { checked: false, notes: '' },
    concentrationAcceptable: { checked: false, notes: '' },
    reportReviewed: false,
    reviewedBy: '',
    reviewDate: ''
  });

  // ========== CUSTOMER SALES DATA ==========
  // Two independent arrays, one per accounting basis — modeled like P&L (which has
  // cash and accrual fields per category). NOT tied to selectedValuationBasis: this
  // is just data, and we get both reports from clients to analyze and compare.
  // The Sales tab dropdown is a pure view selector — switching it shows the other
  // basis's array, never swaps anything around.
  const defaultEmptyCustomerRow = () => ({
    id: 1, name: '', year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0,
    customerType: '', atRisk: false, lost: false,
    hasContract: false, effectiveDate: '', contractMonths: null, autoRenewal: false, renewedContractMonths: null,
    assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
    billingFrequency: '', tenure: '', notes: '',
    contractStart: '', contractEnd: '', industry: '', endpoints: 0,
    // Lead-defined display-attribute values, keyed by cimClientAttrCols id
    // (generic-builder per-client attributes, 2026-07-20). CIM-facing only —
    // never read by keyMetrics or factor scoring.
    attrs: {}
  });
  const [customerSalesCash, setCustomerSalesCash] = useState([defaultEmptyCustomerRow()]);
  const [customerSalesAccrual, setCustomerSalesAccrual] = useState([]);
  // Monthly sales data: { [customerId]: { cash: [m1..m12], accrual: [m1..m12] } } oldest→newest
  const [monthlySalesData, setMonthlySalesData] = useState({});
  const [showMonthlySalesPasteModal, setShowMonthlySalesPasteModal] = useState(false);
  const [showTtmNoData, setShowTtmNoData] = useState(false); // TTM tab: show customers with no monthly data
  const [monthlySalesPasteData, setMonthlySalesPasteData] = useState('');
  const [monthlySalesPastePreview, setMonthlySalesPastePreview] = useState(null);
  const [monthlySalesClearFirst, setMonthlySalesClearFirst] = useState(false);
  // Which basis the Sales tab dropdown is currently viewing/editing.
  const [salesViewBasis, setSalesViewBasis] = useState('cash');
  // Computed: which array to display/edit based on dropdown. Pure selection — no swaps.
  const activeSalesData = salesViewBasis === 'cash' ? customerSalesCash : customerSalesAccrual;
  const setActiveSalesData = salesViewBasis === 'cash' ? setCustomerSalesCash : setCustomerSalesAccrual;

  // Backward-compat aliases — let unmigrated read sites keep working without a sweeping rename.
  // Two distinct concerns intentionally separated:
  //   - activeSalesData / setActiveSalesData  → follows the Sales-tab dropdown (UI editing target)
  //   - customerSalesData / setCustomerSalesData → follows the VALUATION basis (analysis target)
  // This mirrors how P&L works: data is stored with both bases (revenueCategories.cash + .accrual),
  // and downstream computations pick the one matching selectedValuationBasis.
  const valuationBasisForSales = (selectedValuationBasis === 'tax' ? 'cash' : (selectedValuationBasis || 'cash'));
  const customerSalesData = valuationBasisForSales === 'cash' ? customerSalesCash : customerSalesAccrual;
  const customerSalesDataAlt = valuationBasisForSales === 'cash' ? customerSalesAccrual : customerSalesCash;
  const customerSalesBasis = valuationBasisForSales;
  const setCustomerSalesData = valuationBasisForSales === 'cash' ? setCustomerSalesCash : setCustomerSalesAccrual;
  const setCustomerSalesDataAlt = valuationBasisForSales === 'cash' ? setCustomerSalesAccrual : setCustomerSalesCash;

  // (Removed: the auto-swap useEffect that tied customerSalesBasis to selectedValuationBasis.
  // Sales data is now independent data input — analysts paste both cash and accrual reports
  // and the recon panel compares each like-for-like, same as P&L. Valuation basis affects
  // which P&L drives the income statement, but not how the sales-by-customer data is stored.)

  // Pro Forma Adjustments (for acquisitions, new clients, etc.)
  const [proFormaItems, setProFormaItems] = useState([]);
  const [proFormaValuationBasis, setProFormaValuationBasis] = useState('historical'); // 'historical', 'weighted', 'proforma'
  // Pro forma item structure: { id, type: 'acquisition'|'newclient'|'other', name, effectiveDate, annualRevenue, annualEbitda, ebitdaMargin, useMargin, retentionPct, notes }
  
  // ========== PORTFOLIO CONSOLIDATION ==========
  // Portfolio entities - each is a loaded valuation file
  const [portfolioEntities, setPortfolioEntities] = useState([]);
  // Portfolio entity structure: { id, name, fileName, ttmPeriod, revenue, ebitda, adjustedEbitda, customerCount, topCustomerPct, topCustomerAmt, multiple, valuation, discoveryAnswers, loadedAt }
  
  // Portfolio combined assessment (manually entered by user)
  const [portfolioAssessment, setPortfolioAssessment] = useState({
    pctB2B: '',
    contractCoverage: '',
    ownerDependency: '',
    managementDepth: '',
    growthTrajectory: '',
    techStack: '',
    customerConcentrationRisk: '',
    notes: ''
  });
  
  // Portfolio work is pure in-memory — file-loaded entities plus typed
  // assessment — so a reload vaporizes it, and the editor's unsaved flag
  // never knew (Colleen 09-04, the deploy-burst morning: "Claude is still
  // refreshing my tool while I have unsaved data"). Published as its own
  // dirty flag; the stale-version reloader treats it exactly like unsaved
  // editor changes: banner waits, tab never self-heals over it.
  // SAVED WITH THE DEAL since 10-16 (Colleen), so a portfolio change is an ordinary unsaved change: the
  // editor's own flag + autosave carry it, and the stale-version reloader already waits on that flag.
  // (The separate __vtPortfolioDirty flag above is retired: it stayed true whenever a portfolio existed.)
  const portfolioFirstRunRef = useRef(true);
  useEffect(() => {
    if (portfolioFirstRunRef.current) { portfolioFirstRunRef.current = false; return; }
    if (isHydratingRef.current) return;
    setHasUnsavedChanges(true);
  }, [portfolioEntities, portfolioAssessment, portfolioSettings]);   // eslint-disable-line react-hooks/exhaustive-deps

  // Portfolio settings
  const [portfolioSettings, setPortfolioSettings] = useState({
    allocationMethod: 'value', // 'value' or 'ebitda'
    portfolioName: 'Combined Portfolio'
  });
  // Put a deal's saved portfolio back (or clear it when the deal has none). Called by both load paths.
  const restorePortfolio = (p) => {
    setPortfolioEntities(p && Array.isArray(p.entities) ? p.entities : []);
    setPortfolioAssessment({ pctB2B: '', contractCoverage: '', ownerDependency: '', managementDepth: '', growthTrajectory: '',
      techStack: '', customerConcentrationRisk: '', notes: '', ...((p && p.assessment) || {}) });
    setPortfolioSettings({ allocationMethod: 'value', portfolioName: 'Combined Portfolio', ...((p && p.settings) || {}) });
  };
  
  const [salesDetailsExpanded, setSalesDetailsExpanded] = useState(false);
  const [salesDataExpanded, setSalesDataExpanded] = useState(false);
  const [showPasteColumnModal, setShowPasteColumnModal] = useState(false);
  const [pasteColumnTarget, setPasteColumnTarget] = useState('name');
  const [pasteColumnData, setPasteColumnData] = useState('');
  
  // P&L Entry Paste Column state
  const [showPLPasteModal, setShowPLPasteModal] = useState(false);
  const [plPasteSection, setPlPasteSection] = useState('revenue'); // revenue, cogs, opex, otherIncome, otherExpense
  const [plPasteTarget, setPlPasteTarget] = useState('name'); // name, cash, accrual, tax
  const [plPasteData, setPlPasteData] = useState('');
  
  // Balance Sheet Paste Grid state
  const [showBSGridPasteModal, setShowBSGridPasteModal] = useState(false);
  const [bsGridPasteSection, setBsGridPasteSection] = useState('currentAssets');
  const [bsGridPasteData, setBsGridPasteData] = useState('');
  const [bsGridPastePreview, setBsGridPastePreview] = useState(null);
  
  // Annual P&L Paste Grid state
  const [showAnnualGridPasteModal, setShowAnnualGridPasteModal] = useState(false);
  const [annualGridPasteSection, setAnnualGridPasteSection] = useState('revenue');
  const [annualGridPasteBasis, setAnnualGridPasteBasis] = useState('cash');
  const [annualGridPasteData, setAnnualGridPasteData] = useState('');
  const [annualGridPastePreview, setAnnualGridPastePreview] = useState(null);
  
  // Full P&L Paste Modal state (for new P&L entry tabs)
  const [showFullPLPasteModal, setShowFullPLPasteModal] = useState(false);
  const [fullPLPasteBasis, setFullPLPasteBasis] = useState('cash');
  const [fullPLPasteData, setFullPLPasteData] = useState('');
  const [fullPLPastePreview, setFullPLPastePreview] = useState(null);
  const [annualPasteClearFirst, setAnnualPasteClearFirst] = useState(false);
  const [annualPasteClearTtmOnly, setAnnualPasteClearTtmOnly] = useState(false);
  
  // Full Monthly P&L Paste Modal state (for TTM Monthly tab)
  const [showFullMonthlyPasteModal, setShowFullMonthlyPasteModal] = useState(false);
  const [fullMonthlyPasteData, setFullMonthlyPasteData] = useState('');
  const [fullMonthlyPastePreview, setFullMonthlyPastePreview] = useState(null);
  const [monthlyPasteClearFirst, setMonthlyPasteClearFirst] = useState(false); // Clear existing data before paste (for annual reviews)
  
  // Full Balance Sheet Paste Modal state (for Balance Sheet tab)
  const [showFullBSPasteModal, setShowFullBSPasteModal] = useState(false);
  const [fullBSPasteData, setFullBSPasteData] = useState('');
  const [fullBSPastePreview, setFullBSPastePreview] = useState(null);
  const [bsPasteClearFirst, setBsPasteClearFirst] = useState(false);
  const [bsPasteClearInterimOnly, setBsPasteClearInterimOnly] = useState(false);
  
  // Interim Balance Sheet Paste Modal state (for Balance Sheet tab)
  const [showInterimBSPasteModal, setShowInterimBSPasteModal] = useState(false);
  const [interimBSPasteData, setInterimBSPasteData] = useState('');
  const [interimBSPastePreview, setInterimBSPastePreview] = useState(null);
  const [interimBSPasteClearFirst, setInterimBSPasteClearFirst] = useState(false);
  
  // Full TTM Balance Sheet Paste Modal state (for TTM Balance Sheet tab)
  const [showFullTtmBSPasteModal, setShowFullTtmBSPasteModal] = useState(false);
  const [fullTtmBSPasteData, setFullTtmBSPasteData] = useState('');
  const [fullTtmBSPasteClearFirst, setFullTtmBSPasteClearFirst] = useState(false);
  const [fullTtmBSPastePreview, setFullTtmBSPastePreview] = useState(null);
  
  // Client Detail Import Modal state
  const [showClientImportModal, setShowClientImportModal] = useState(false);
  const [clientImportFile, setClientImportFile] = useState(null);
  const [clientImportOverwrite, setClientImportOverwrite] = useState(true); // Overwrite existing values
  
  // Sales Grid Paste state
  const [showSalesGridPasteModal, setShowSalesGridPasteModal] = useState(false);
  const [salesGridPasteData, setSalesGridPasteData] = useState('');
  const [salesGridPastePreview, setSalesGridPastePreview] = useState(null);
  const [salesGridClearReplace, setSalesGridClearReplace] = useState(false);
  const [salesGridClearTtmOnly, setSalesGridClearTtmOnly] = useState(false);
  
  // Client Details Paste Grid state
  const [showClientDetailsPasteModal, setShowClientDetailsPasteModal] = useState(false);
  const [clientDetailsPasteData, setClientDetailsPasteData] = useState('');
  const [clientDetailsPastePreview, setClientDetailsPastePreview] = useState(null);
  const [clientDetailsColumnMap, setClientDetailsColumnMap] = useState('auto'); // auto, basic, contract, full
  // Re-paste REPLACES by default (Colleen 10-05, Concise: client numbers changed, the re-paste only touched
  // the rows it named, and old contract detail stayed on rows it didn't). Untick = merge (old behaviour).
  const [clientPasteReplaceAll, setClientPasteReplaceAll] = useState(true);
  
  // Client Notes Expansion Modal
  const [expandedNoteCustomer, setExpandedNoteCustomer] = useState(null); // { id, name, notes }
  
  // Balance Sheet Paste Column state
  const [showBSPasteModal, setShowBSPasteModal] = useState(false);
  const [bsPasteSection, setBsPasteSection] = useState('currentAssets'); // currentAssets, fixedAssets, otherAssets, currentLiabilities, longTermLiabilities, equity
  const [bsPasteTarget, setBsPasteTarget] = useState('name'); // name, year1, year2, year3, interim
  const [bsPasteData, setBsPasteData] = useState('');
  const [salesSortBy, setSalesSortBy] = useState('entry'); // entry, ttm, name, pct, growth
  const [salesSortDir, setSalesSortDir] = useState('desc'); // asc, desc
  const [showSalesExportModal, setShowSalesExportModal] = useState(false);
  const [salesExportText, setSalesExportText] = useState('');
  
  const [customerYearLabels, setCustomerYearLabels] = useState({
    year1: defaultYears.year1, year2: defaultYears.year2, year3: defaultYears.year3, year4: defaultYears.year4, year5: defaultYears.year5, ttm: 'TTM'
  });
  
  // Separate TTM config for Sales tab (decoupled from Monthly P&L TTM config)
  const [salesTtmConfig, setSalesTtmConfig] = useState({
    endMonth: new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1,
    endYear: new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(),
    basis: 'cash',
    useMonthlyForTtm: true
  });

  // The TTM Monthly Sales tab follows its OWN basis selector (salesTtmConfig.basis), independent
  // of the global valuation basis. monthlySalesData entries are keyed by the id of the customer in
  // THIS basis's array — parse-matching and apply both run against salesTtmConfig.basis. After the
  // cash/accrual decouple a customer can have different ids in the two arrays, so the grid must
  // read its rows from the same array the monthly data is keyed to. Reading customerSalesData (the
  // valuation-basis array) instead drops any customer whose id differs across the two arrays — the
  // row renders but monthlySalesData[id] misses, so its months show blank and its TTM is lost.
  const ttmSalesBasis = salesTtmConfig?.basis || 'cash';
  const ttmBasisCustomers = ttmSalesBasis === 'cash' ? customerSalesCash : customerSalesAccrual;
  const setTtmBasisCustomers = ttmSalesBasis === 'cash' ? setCustomerSalesCash : setCustomerSalesAccrual;

  // Sales TTM label (independent of P&L TTM label)
  const salesTtmLabel = useMemo(() => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const endM = salesTtmConfig.endMonth;
    const endY = salesTtmConfig.endYear;
    let startM = endM - 11;
    let startY = endY;
    if (startM < 0) { startM += 12; startY--; }
    return `TTM (${monthNames[startM]} ${String(startY).slice(-2)} - ${monthNames[endM]} ${String(endY).slice(-2)})`;
  }, [salesTtmConfig.endMonth, salesTtmConfig.endYear]);

  // Generate 12 month labels for monthly sales tab (oldest → newest)
  const monthlySalesMonthLabels = useMemo(() => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const endM = salesTtmConfig.endMonth;
    const endY = salesTtmConfig.endYear;
    const labels = [];
    for (let i = 11; i >= 0; i--) {
      let m = endM - i;
      let y = endY;
      if (m < 0) { m += 12; y--; }
      labels.push(`${monthNames[m]} ${String(y).slice(-2)}`);
    }
    return labels; // [oldest...newest]
  }, [salesTtmConfig.endMonth, salesTtmConfig.endYear]);

  // Reconciliation: compares Sales tab TTM column against TTM Monthly tab totals for the selected basis.
  // Sales data is stored in two basis-specific arrays (customerSalesCash, customerSalesAccrual).
  // Pick the array matching salesTtmConfig.basis directly — no swapping, no primary/alt confusion.
  // Three failure modes: (A) Sales row exists but no monthly data, (B) monthly data exists but no Sales row, (C) both exist with mismatched values.
  const salesTtmReconciliation = useMemo(() => {
    const basis = salesTtmConfig?.basis || 'cash';
    const targetSalesArray = basis === 'cash' ? customerSalesCash : customerSalesAccrual;

    const monthlyKeys = Object.keys(monthlySalesData || {});
    const hasMonthlyData = monthlyKeys.length > 0;
    const monthlyByCustomer = {};
    let monthlyTotal = 0;
    for (const key of monthlyKeys) {
      const raw = monthlySalesData[key];
      const arr = (raw && !Array.isArray(raw)) ? (raw[basis] || []) : (raw || []);
      const sum = arr.slice(0, 12).reduce((s, v) => s + (Number(v) || 0), 0);
      monthlyByCustomer[key] = sum;
      monthlyTotal += sum;
    }
    const salesIds = new Set();
    let salesTtmTotal = 0;
    const noMonthlyButHasTtm = [];
    const mismatched = [];
    for (const c of (targetSalesArray || [])) {
      if (!c.name) continue;
      const idKey = String(c.id);
      salesIds.add(idKey);
      const ttm = Number(c.ttm) || 0;
      salesTtmTotal += ttm;
      if (Object.prototype.hasOwnProperty.call(monthlyByCustomer, idKey)) {
        const mSum = monthlyByCustomer[idKey];
        if (Math.abs(ttm - mSum) > 0.01) {
          mismatched.push({ id: c.id, name: c.name, salesTtm: ttm, monthlySum: mSum, diff: ttm - mSum });
        }
      } else if (ttm !== 0) {
        noMonthlyButHasTtm.push({ id: c.id, name: c.name, salesTtm: ttm });
      }
    }
    const orphanMonthly = [];
    for (const key of monthlyKeys) {
      if (!salesIds.has(key) && monthlyByCustomer[key] !== 0) {
        orphanMonthly.push({ id: key, monthlySum: monthlyByCustomer[key] });
      }
    }
    const difference = salesTtmTotal - monthlyTotal;
    const inSync = Math.abs(difference) < 0.01 && noMonthlyButHasTtm.length === 0 && orphanMonthly.length === 0 && mismatched.length === 0;
    return {
      hasMonthlyData,
      inSync,
      salesTtmTotal,
      monthlyTotal,
      difference,
      noMonthlyButHasTtm,
      orphanMonthly,
      mismatched,
    };
  }, [customerSalesCash, customerSalesAccrual, monthlySalesData, salesTtmConfig]);

  const [showSalesReconModal, setShowSalesReconModal] = useState(false);

  // P&L Reconciliation: compares P&L Entry TTM column against TTM Monthly tab totals per category, per basis (cash & accrual).
  // Mirrors the Sales reconciliation but adapted for P&L's per-line-item, per-basis structure.
  // Only active when monthlyTtmConfig.useMonthlyForTtm is on (otherwise TTM is intentionally manual).
  const pnlTtmReconciliation = useMemo(() => {
    if (!monthlyTtmConfig?.useMonthlyForTtm) {
      return { active: false, inSync: true, issues: [], totalIssues: 0 };
    }
    const sumTtm = (arr) => (arr || []).slice(0, 12).reduce((s, v) => s + (Number(v) || 0), 0);
    const sections = [
      { name: 'Revenue', categories: revenueCategories, monthly: monthlyTtmRevenue },
      { name: 'COGS', categories: cogsCategories, monthly: monthlyTtmCogs },
      { name: 'Operating Expenses', categories: opexCategories, monthly: monthlyTtmOpex },
      { name: 'Other Income', categories: otherIncomeCategories, monthly: monthlyTtmOtherIncome },
      { name: 'Other Expense', categories: otherExpenseCategories, monthly: monthlyTtmOtherExpense },
    ];
    const issues = [];
    // Orphan monthly entries (monthly data with no matching P&L Entry category) accumulate from past
    // paste workflows where IDs got regenerated. They aren't actionable from the chip — there's no UI
    // to clean them — so we collect them separately for future cleanup tooling but don't count them
    // as "out of sync" issues. The user's expectation: chip is green if matched-account sync is clean.
    const orphans = [];
    const bases = ['cash', 'accrual'];
    for (const section of sections) {
      const monthlyMap = section.monthly || {};
      const monthlyKeys = Object.keys(monthlyMap);
      const seenCatIds = new Set();
      for (const cat of (section.categories || [])) {
        if (!cat.name || !String(cat.name).trim()) continue;
        const idKey = String(cat.id);
        seenCatIds.add(idKey);
        const monthlyData = monthlyMap[idKey];
        for (const basis of bases) {
          const ttm = Number(cat[basis]?.ttm) || 0;
          if (!monthlyData) {
            if (ttm !== 0) issues.push({ section: section.name, name: cat.name, basis, type: 'no_monthly', ttm, monthlySum: 0, diff: ttm });
          } else {
            const mSum = sumTtm(monthlyData[basis]);
            if (Math.abs(ttm - mSum) > 0.01) {
              issues.push({ section: section.name, name: cat.name, basis, type: 'mismatch', ttm, monthlySum: mSum, diff: ttm - mSum });
            }
          }
        }
      }
      // Orphan monthly: monthly data for a category id that no longer exists in P&L Entry.
      // Tracked but excluded from the chip's "out of sync" count — see comment above.
      for (const key of monthlyKeys) {
        if (seenCatIds.has(key)) continue;
        for (const basis of bases) {
          const mSum = sumTtm(monthlyMap[key]?.[basis]);
          if (mSum !== 0) {
            orphans.push({ section: section.name, name: `(orphan id ${key})`, basis, type: 'orphan_monthly', ttm: 0, monthlySum: mSum, diff: -mSum });
          }
        }
      }
    }
    // DIAT — fixed types, only check value mismatches (no add/remove)
    const diatTypes = ['depreciation', 'interest', 'amortization', 'taxes'];
    const diatLabels = { depreciation: 'Depreciation', interest: 'Interest', amortization: 'Amortization', taxes: 'Taxes' };
    for (const type of diatTypes) {
      for (const basis of bases) {
        const ttm = Number(diatCategories?.[type]?.[basis]?.ttm) || 0;
        const mSum = sumTtm(monthlyTtmDiat?.[type]?.[basis]);
        if (Math.abs(ttm - mSum) > 0.01) {
          issues.push({ section: 'DIAT', name: diatLabels[type], basis, type: 'mismatch', ttm, monthlySum: mSum, diff: ttm - mSum });
        }
      }
    }
    const cashIssues = issues.filter(i => i.basis === 'cash').length;
    const accrualIssues = issues.filter(i => i.basis === 'accrual').length;
    return {
      active: true,
      inSync: issues.length === 0,
      issues,
      totalIssues: issues.length,
      cashIssues,
      accrualIssues,
      orphans,
      orphanCount: orphans.length,
    };
  }, [monthlyTtmConfig, revenueCategories, cogsCategories, opexCategories, otherIncomeCategories, otherExpenseCategories, diatCategories, monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmOtherIncome, monthlyTtmOtherExpense, monthlyTtmDiat]);

  const [showPnlReconModal, setShowPnlReconModal] = useState(false);

  // Balance Sheet Reconciliation: compares Annual BS interim values against the matched TTM BS account's last-month value.
  // Mirrors the sync logic in syncInterimFromTtmBS() — same two-pass matching (exact then fuzzy 6-char prefix against unclaimed TTM only) —
  // so what the chip flags is exactly what the sync would (or wouldn't) produce. Equity is included because the sync now handles it
  // (required for the BS to balance: A − L − E).
  // Hidden when TTM BS is fully empty (e.g., client only sent the current BS, pasted directly into Annual).
  // Three failure modes flagged: (1) matched-but-mismatched, (2) unsynced TTM accounts, (3) annual accounts with non-zero interim
  // but no TTM match (year-over-year stale carryovers from prior valuations). Clicking Sync will resolve all three.
  const bsTtmReconciliation = useMemo(() => {
    const sections = [
      { name: 'Current Assets', ttm: ttmBsCurrentAssets, annual: bsCurrentAssets },
      { name: 'Fixed Assets', ttm: ttmBsFixedAssets, annual: bsFixedAssets },
      { name: 'Other Assets', ttm: ttmBsOtherAssets, annual: bsOtherAssets },
      { name: 'Current Liabilities', ttm: ttmBsCurrentLiabilities, annual: bsCurrentLiabilities },
      { name: 'Long-Term Liabilities', ttm: ttmBsLongTermLiabilities, annual: bsLongTermLiabilities },
      { name: 'Equity', ttm: ttmBsEquity, annual: bsEquity },
    ];
    // Find the last month with any non-zero TTM data — same algorithm as syncInterimFromTtmBS
    const allTtm = sections.flatMap(s => s.ttm || []);
    let lastMonthIdx = -1;
    for (let i = 11; i >= 0; i--) {
      if (allTtm.some(a => (a?.values?.[i] || 0) !== 0)) { lastMonthIdx = i; break; }
    }
    if (lastMonthIdx === -1) {
      return { active: false, inSync: true, totalIssues: 0, issues: [], lastMonthLabel: '', lastMonthIdx: -1 };
    }
    const normalize = (str) => (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const lastMonthLabel = ttmBsMonthLabels?.[lastMonthIdx] || '';
    const issues = [];
    // Same plan the Sync button applies (bsPlanTtmSync — account-number-blind, cross-section, duplicate merge).
    const plan = bsPlanTtmSync(sections);
    plan.forEach(p => {
      p.dupes.forEach(a => issues.push({ section: p.name, name: a.name, ttmName: '', interim: Number(a.interim) || 0, ttmVal: 0, type: 'duplicate', diff: Number(a.interim) || 0 }));
      p.annual.forEach((annualAcct, aIdx) => {
        if (!annualAcct.name || !String(annualAcct.name).trim()) return;
        const m = p.matches[aIdx];
        const interim = Number(annualAcct.interim) || 0;
        if (!m) {
          if (interim !== 0) issues.push({ section: p.name, name: annualAcct.name, ttmName: '', interim, ttmVal: 0, type: 'no_TTM_match', diff: interim });
          return;
        }
        const match = plan[m.secIdx].ttm[m.ttmIdx];
        const ttmVal = Number(match.values?.[lastMonthIdx]) || 0;
        if (Math.abs(interim - ttmVal) > 0.01) issues.push({ section: p.name, name: annualAcct.name, ttmName: match.name, interim, ttmVal, type: 'mismatch', diff: interim - ttmVal });
      });
      p.ttm.forEach((t, i) => {
        if (p.claimed.has(i)) return;
        if (!t.name || !String(t.name).trim()) return;
        const ttmVal = Number(t.values?.[lastMonthIdx]) || 0;
        if (ttmVal === 0) return;
        issues.push({ section: p.name, name: t.name, ttmName: t.name, interim: 0, ttmVal, type: 'unsynced_ttm', diff: -ttmVal });
      });
    });
    return {
      active: true,
      inSync: issues.length === 0,
      totalIssues: issues.length,
      issues,
      lastMonthLabel,
      lastMonthIdx,
    };
  }, [bsCurrentAssets, bsFixedAssets, bsOtherAssets, bsCurrentLiabilities, bsLongTermLiabilities, bsEquity, ttmBsCurrentAssets, ttmBsFixedAssets, ttmBsOtherAssets, ttmBsCurrentLiabilities, ttmBsLongTermLiabilities, ttmBsEquity, ttmBsMonthLabels]);

  const [showBsReconModal, setShowBsReconModal] = useState(false);

  // Display customer year labels - formats with fiscal year awareness
  const displayCustomerYearLabels = useMemo(() => {
    try {
      const { formatYearLabel } = fiscalYearHelpers;
      return {
        year1: formatYearLabel(customerYearLabels.year1) || customerYearLabels.year1,
        year2: formatYearLabel(customerYearLabels.year2) || customerYearLabels.year2,
        year3: formatYearLabel(customerYearLabels.year3) || customerYearLabels.year3,
        year4: formatYearLabel(customerYearLabels.year4) || customerYearLabels.year4,
        year5: formatYearLabel(customerYearLabels.year5) || customerYearLabels.year5,
        ttm: 'TTM'
      };
    } catch (e) {
      console.error('displayCustomerYearLabels error:', e);
      return {
        year1: customerYearLabels.year1,
        year2: customerYearLabels.year2,
        year3: customerYearLabels.year3,
        year4: customerYearLabels.year4,
        year5: customerYearLabels.year5,
        ttm: 'TTM'
      };
    }
  }, [customerYearLabels, fiscalYearHelpers]);

  // ========== AR/AP ANALYSIS ==========
  // AR Aging Line Items (individual customer/invoice rows)
  const [arAgingLineItems, setArAgingLineItems] = useState([
    { id: 1, customerName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }
  ]);
  
  // AR Aging bucket labels (customizable to match different report formats)
  const [arAgingBucketLabels, setArAgingBucketLabels] = useState({
    // Default headings = the QuickBooks past-due layout (Konnie 10-19; still editable per deal). Same five
    // columns underneath: the paste maps Current / 1-30 / 31-60 / 61-90 / >90 into them in this order.
    current: 'Current',
    days31to60: '0-30',
    days61to90: '31-60',
    days91to120: '61-90',
    days120plus: '91+',
    // Which column is the FIRST past due column? (1=current, 2=col2, 3=col3, 4=col4, 5=col5)
    pastDueStartColumn: 2  // Default: column 2 (days31to60) is first past due
  });
  
  // AR Aging metadata (report date, notes) - buckets now calculated from line items
  const [arAgingData, setArAgingData] = useState({
    current: 0,        // Legacy - now calculated
    days31to60: 0,     // Legacy - now calculated
    days61to90: 0,     // Legacy - now calculated
    days91to120: 0,    // Legacy - now calculated
    days120plus: 0,    // Legacy - now calculated
    negativeBalances: 0, // Legacy - now calculated
    reportDate: '',
    totalRevenueTTM: 0,  // For DSO calculation
    notes: ''
  });
  
  // AR Aging Line Item Notes (keyed by item id, like monthlyTtmNotes pattern)
  const [arAgingNotes, setArAgingNotes] = useState({});
  // Expanded state for AR Detail section on Analysis tab
  const [arDetailExpanded, setArDetailExpanded] = useState(false);
  const [arChecklistExpanded, setArChecklistExpanded] = useState(true); // Default open
  
  // Customer Sales Detail Notes (keyed by customer id, for Sales Analysis tab)
  const [salesDetailNotes, setSalesDetailNotes] = useState({});
  // Expanded state for Customer Sales Detail section on Sales Analysis tab
  const [salesDetailExpanded, setSalesDetailExpanded] = useState(false);
  const [monthlySalesAnalysisExpanded, setMonthlySalesAnalysisExpanded] = useState(false);
  
  // Calculated AR aging totals from line items
  const arAgingCalcs = useMemo(() => {
    const totals = {
      current: 0,
      days31to60: 0,
      days61to90: 0,
      days91to120: 0,
      days120plus: 0,
      negativeBalances: 0,
      negativeAccountCount: 0,
      totalAR: 0,
      pastDue: 0,
      seriouslyPastDue: 0
    };
    
    try {
      if (!arAgingLineItems || !Array.isArray(arAgingLineItems)) {
        return totals;
      }
      
      arAgingLineItems.forEach((item) => {
        if (!item) return;
        const current = typeof item.current === 'number' && !isNaN(item.current) ? item.current : 0;
        const d31to60 = typeof item.days31to60 === 'number' && !isNaN(item.days31to60) ? item.days31to60 : 0;
        const d61to90 = typeof item.days61to90 === 'number' && !isNaN(item.days61to90) ? item.days61to90 : 0;
        const d91to120 = typeof item.days91to120 === 'number' && !isNaN(item.days91to120) ? item.days91to120 : 0;
        const d120plus = typeof item.days120plus === 'number' && !isNaN(item.days120plus) ? item.days120plus : 0;
        
        totals.current += current;
        totals.days31to60 += d31to60;
        totals.days61to90 += d61to90;
        totals.days91to120 += d91to120;
        totals.days120plus += d120plus;
        
        // Track ALL negative values (individual cells OR negative line totals)
        const lineTotal = current + d31to60 + d61to90 + d91to120 + d120plus;
        if (lineTotal < 0) totals.negativeAccountCount++;
        if (current < 0) totals.negativeBalances += current;
        if (d31to60 < 0) totals.negativeBalances += d31to60;
        if (d61to90 < 0) totals.negativeBalances += d61to90;
        if (d91to120 < 0) totals.negativeBalances += d91to120;
        if (d120plus < 0) totals.negativeBalances += d120plus;
      });
      
      totals.totalAR = totals.current + totals.days31to60 + totals.days61to90 + totals.days91to120 + totals.days120plus;
      
      // Calculate pastDue based on which column is the FIRST past due column
      // pastDueStartColumn: 1=col1(current), 2=col2, 3=col3, 4=col4, 5=col5
      const startCol = arAgingBucketLabels.pastDueStartColumn || 2;
      const columnValues = [0, totals.current, totals.days31to60, totals.days61to90, totals.days91to120, totals.days120plus];
      
      totals.pastDue = 0;
      for (let i = startCol; i <= 5; i++) {
        totals.pastDue += columnValues[i];
      }
      
      // Seriously past due = last 2 columns (91-120 and 120+) OR columns 4-5 from startCol perspective
      // Keep this as columns 4 and 5 regardless of pastDueStartColumn
      totals.seriouslyPastDue = totals.days91to120 + totals.days120plus;
    } catch (error) {
      console.error('AR Calcs Error:', error);
    }
    
    return totals;
  }, [arAgingLineItems, arAgingBucketLabels.pastDueStartColumn]);
  
  // AR Aging Paste state
  const [showARPasteModal, setShowARPasteModal] = useState(false);
  const [arPasteTarget, setArPasteTarget] = useState('customerName'); // customerName, current, days31to60, etc.
  const [arPasteData, setArPasteData] = useState('');
  
  // AR Aging Grid Paste state
  const [showARGridPasteModal, setShowARGridPasteModal] = useState(false);
  const [arGridPasteData, setArGridPasteData] = useState('');
  const [arGridPastePreview, setArGridPastePreview] = useState(null);
  const [arGridPasteClearReplace, setArGridPasteClearReplace] = useState(false);
  const [arGridColumnMap, setArGridColumnMap] = useState('5col'); // 5col, 4col, 3col
  
  const [apAnalysis, setApAnalysis] = useState({
    postsAPRegularly: 'unknown',  // 'yes', 'no', 'unknown'
    totalAP: 0,
    reportDate: '',
    notes: '',
    trackingMode: 'notTracked' // 'notTracked' or 'tracked'
  });

  // AP Aging Line Items (individual vendor/invoice rows) - similar to AR
  const [apAgingLineItems, setApAgingLineItems] = useState([
    { id: 1, vendorName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }
  ]);
  
  // AP Aging bucket labels (customizable to match different report formats)
  const [apAgingBucketLabels, setApAgingBucketLabels] = useState({
    current: 'Current',
    days31to60: '0-30',
    days61to90: '31-60',
    days91to120: '61-90',
    days120plus: '91+'
  });
  
  // AP Paste Column state
  const [showAPPasteModal, setShowAPPasteModal] = useState(false);
  const [apPasteTarget, setApPasteTarget] = useState('vendorName');
  const [apPasteData, setApPasteData] = useState('');
  
  // AP Grid Paste state (paste entire aging report at once)
  const [showAPGridPasteModal, setShowAPGridPasteModal] = useState(false);
  const [apGridPasteData, setApGridPasteData] = useState('');
  const [apGridPastePreview, setApGridPastePreview] = useState(null);
  const [apGridPasteClearReplace, setApGridPasteClearReplace] = useState(false);
  const [apGridColumnMap, setApGridColumnMap] = useState('5col');
  
  // AP Review Checklist
  const [apReviewChecklist, setApReviewChecklist] = useState({
    reportDateMatches: { checked: false, notes: '' },
    totalTiesToBS: { checked: false, notes: '' },
    noOldPayables: { checked: false, notes: '' },
    noConcentration: { checked: false, notes: '' },
    reportReviewed: false,
    reviewedBy: '',
    reviewDate: ''
  });

  // Calculated AP aging totals from line items
  const apAgingCalcs = useMemo(() => {
    const totals = {
      current: 0,
      days31to60: 0,
      days61to90: 0,
      days91to120: 0,
      days120plus: 0,
      totalAP: 0,
      pastDue: 0,
      oldPayables: 0 // 91+ days
    };
    
    try {
      if (!apAgingLineItems || !Array.isArray(apAgingLineItems)) {
        return totals;
      }
      
      apAgingLineItems.forEach((item) => {
        if (!item) return;
        const current = typeof item.current === 'number' && !isNaN(item.current) ? item.current : 0;
        const d31to60 = typeof item.days31to60 === 'number' && !isNaN(item.days31to60) ? item.days31to60 : 0;
        const d61to90 = typeof item.days61to90 === 'number' && !isNaN(item.days61to90) ? item.days61to90 : 0;
        const d91to120 = typeof item.days91to120 === 'number' && !isNaN(item.days91to120) ? item.days91to120 : 0;
        const d120plus = typeof item.days120plus === 'number' && !isNaN(item.days120plus) ? item.days120plus : 0;
        
        totals.current += current;
        totals.days31to60 += d31to60;
        totals.days61to90 += d61to90;
        totals.days91to120 += d91to120;
        totals.days120plus += d120plus;
      });
      
      totals.totalAP = totals.current + totals.days31to60 + totals.days61to90 + totals.days91to120 + totals.days120plus;
      totals.pastDue = totals.days31to60 + totals.days61to90 + totals.days91to120 + totals.days120plus;
      totals.oldPayables = totals.days91to120 + totals.days120plus;
    } catch (error) {
      console.error('AP Calcs Error:', error);
    }
    
    return totals;
  }, [apAgingLineItems]);

  // ========== RESEARCH ITEMS ==========
  const [researchItems, setResearchItems] = useState([]);

  const [newResearchItem, setNewResearchItem] = useState({ item: '', priority: 'medium', notes: '', askOwner: false });
  const addResearchItem = () => {
    if (newResearchItem.item) {
      setResearchItems([...researchItems, { ...newResearchItem, id: Math.max(...researchItems.map(i => i.id), 0) + 1, status: 'open' }]);
      setNewResearchItem({ item: '', priority: 'medium', notes: '', askOwner: false });
    }
  };

  // ========== ACKNOWLEDGED FLAGS ==========
  const [acknowledgedFlags, setAcknowledgedFlags] = useState({});
  const [showAcknowledged, setShowAcknowledged] = useState(false);
  // Collapsible sections for Issues & Flags
  const [issuesSections, setIssuesSections] = useState({
    dataFlags: false,
    reconVariances: false,
    discovery: false,
    research: false,
    reviewerNotes: true,  // Start expanded so analyst sees reviewer comments immediately
    analystFlags: true,  // Start expanded since these are user-created
    resolved: false      // Start collapsed
  });
  const [issuesSeverityFilter, setIssuesSeverityFilter] = useState('all'); // 'all', 'critical', 'warning', 'info'
  const [issuesCombinedView, setIssuesCombinedView] = useState(true); // true = show all in one list, false = by section
  const toggleIssuesSection = (section) => setIssuesSections(prev => ({...prev, [section]: !prev[section]}));
  
  const acknowledgeFlag = (flagKey, resolution) => {
    // CapEx can't be one-click waived (Zac 2026-07-31, option C): dismissing
    // the investigation on an asset-heavy deal must be a deliberate, recorded
    // decision — a written reason is required and saved with the flag.
    if (flagKey === 'capex-investigation' && (!resolution || resolution === 'Waived')) {
      const note = window.prompt(
        'CapEx Investigation — a written reason is required to dismiss this flag.\n\n' +
        'Why is no maintenance-CapEx adjustment needed on this deal?\n' +
        '(e.g. "assets are standard office equipment, replacement cycle immaterial" · ' +
        '"adjustment entered on the WC & CapEx tab" · "verification form reconciled, growth CapEx only")');
      if (!note || !note.trim()) return;
      resolution = 'Waived: ' + note.trim();
    }
    // VWTC flags (Mark 09-28): waivable, but only with a written reason — the
    // reason IS the record of why this business is different (size, buyer type).
    const VWTC_WAIVE = {
      'owner-billable-two-roles': 'Why doesn\'t this deal need a second replacement role? (e.g. "small business; an owner-operator buyer does both")',
      'concentration-no-customers': 'Why is there no customer list? (e.g. "retail walk-in trade, no customer ledger")',
      'owner-payroll-by-person': 'How were the add-backs verified instead? (e.g. "single owner on payroll; W-2 matches")',
      'owner-hours-above-normal': 'Why no extra replacement for the hours? (e.g. "small business; buyer will work it themselves")',
    };
    if (VWTC_WAIVE[flagKey] && (!resolution || resolution === 'Waived' || resolution === 'Acknowledged')) {
      const note = window.prompt('A written reason is required to waive this.\n\n' + VWTC_WAIVE[flagKey]);
      if (!note || !note.trim()) return;
      resolution = 'Waived: ' + note.trim();
    }
    setAcknowledgedFlags({...acknowledgedFlags, [flagKey]: { acknowledged: true, resolution, date: new Date().toLocaleDateString() }});
  };
  
  const unacknowledgeFlag = (flagKey) => {
    const updated = {...acknowledgedFlags};
    delete updated[flagKey];
    setAcknowledgedFlags(updated);
  };

  // ========== OUTSTANDING ITEMS CALCULATION ==========
  const outstandingAnalysis = useMemo(() => {
    const flags = [];
    
    // 1. Undocumented adjustments (no source selected)
    const undocumentedAdjustments = adjustmentItems.filter(a => a.included && !a.source);
    undocumentedAdjustments.forEach(a => {
      flags.push({ key: `adjustment-${a.id}`, category: 'Adjustment', severity: 'warning', item: `Undocumented: ${a.description}`, detail: `$${a.amount.toLocaleString()} (${a.year}) - needs source documentation`, action: 'Select documentation source', canResolveAt: 'Adjustments tab → Select Source', resolveTab: 'adjustments' });
    });

    // What the addback is FOR (e.g. "meals", "travel") — surface the
    // description (or category) so the Outstanding Items report shows the
    // purpose, not just the P&L account name (e.g. a lumped "Owner
    // Discretionary" line reads as "Owner Discretionary — meals & travel").
    const addbackPurpose = (cat) => {
      const desc = (cat.adjDescription || '').trim();
      if (desc) return desc;
      return cat.adjCategory || '';
    };

    // 1b. Line-based expense adjustments needing verification source (OpEx)
    const needsVerificationLineAdjustments = opexCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && !cat.adjVerSource);
    needsVerificationLineAdjustments.forEach(cat => {
      const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
      const ttmAddback = ttmValue * ((cat.addbackPct || 0) / 100);
      const purpose = addbackPurpose(cat);
      flags.push({
        key: `line-adj-${cat.id}`,
        category: 'Line Adjustment',
        severity: 'warning',
        item: `Undocumented: ${cat.name}${purpose ? ` — ${purpose}` : ''} (${cat.addbackPct}% addback)`,
        detail: `$${ttmAddback.toLocaleString()} (TTM) - needs source documentation`,
        action: 'Select documentation source', 
        canResolveAt: 'Adjustments tab → Line-Based Adjustments', 
        resolveTab: 'adjustments' 
      });
    });
    
    // 1c. Line-based Other Expense adjustments needing verification source
    const needsVerificationOEAdjustments = otherExpenseCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && !cat.adjVerSource);
    needsVerificationOEAdjustments.forEach(cat => {
      const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
      const ttmAddback = ttmValue * ((cat.addbackPct || 0) / 100);
      const purpose = addbackPurpose(cat);
      flags.push({
        key: `line-adj-oe-${cat.id}`,
        category: 'Line Adjustment',
        severity: 'warning',
        item: `Undocumented: ${cat.name}${purpose ? ` — ${purpose}` : ''} (${cat.addbackPct}% addback)`,
        detail: `$${ttmAddback.toLocaleString()} (TTM) - needs source documentation`,
        action: 'Select documentation source', 
        canResolveAt: 'Adjustments tab → Line-Based Adjustments (Other Expense)', 
        resolveTab: 'adjustments' 
      });
    });

    // 1d. Line-based Other Income adjustments needing verification source
    const needsVerificationOIAdjustments = otherIncomeCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && !cat.adjVerSource);
    needsVerificationOIAdjustments.forEach(cat => {
      const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
      const ttmDeduction = ttmValue * ((cat.addbackPct || 0) / 100);
      const purpose = addbackPurpose(cat);
      flags.push({
        key: `line-adj-oi-${cat.id}`,
        category: 'Line Adjustment',
        severity: 'warning',
        item: `Undocumented: ${cat.name}${purpose ? ` — ${purpose}` : ''} (${cat.addbackPct}% deduction)`,
        detail: `-$${ttmDeduction.toLocaleString()} (TTM) - needs source documentation`,
        action: 'Select documentation source', 
        canResolveAt: 'Adjustments tab → Line-Based Adjustments (Other Income)', 
        resolveTab: 'adjustments' 
      });
    });

    // 1e. TTM Monthly Sync disabled warning
    // If monthly data exists but sync is turned off, TTM values won't flow to the Income Statement
    if (!monthlyTtmConfig.useMonthlyForTtm) {
      const hasMonthlyData = Object.values(monthlyTtmRevenue).some(v => v?.[selectedValuationBasis]?.some(val => val !== 0)) ||
        Object.values(monthlyTtmCogs).some(v => v?.[selectedValuationBasis]?.some(val => val !== 0)) ||
        Object.values(monthlyTtmOpex).some(v => v?.[selectedValuationBasis]?.some(val => val !== 0));
      if (hasMonthlyData) {
        flags.push({
          key: 'ttm-sync-disabled',
          category: 'Income Statement',
          severity: 'critical',
          item: 'TTM P&L Sync is disabled',
          detail: 'Monthly P&L data exists but "Use Monthly for TTM" is turned off. TTM values on the Income Statement may be $0 or stale.',
          action: 'Enable sync on TTM P&L tab → check "Use Monthly for TTM"',
          canResolveAt: 'TTM P&L tab → toggle "Use Monthly for TTM"',
          resolveTab: 'ttmmonthly'
        });
      }
    }

    // 1f. TTM owner salary silently falling back to the latest full year
    // (Zac 2026-07-27: the CIM's normalization table showed IDENTICAL
    // latest-year and TTM figures on the salary-removal and employer-tax
    // rows). getTtmSalary() reuses year5 when ttm.salary is blank — a
    // reasonable estimate, but it must be loud, not silent: the same
    // fallback flows into the engine, the Norm-EBITDA view AND the CIM,
    // so every surface agrees while all being unverified.
    if (ownerCompensation?.embeddedInWages && !(ownerCompensation?.ttm?.salary > 0) && (ownerCompensation?.year5?.salary > 0)) {
      flags.push({
        key: 'owner-comp-ttm-fallback',
        category: 'Owner Compensation',
        severity: 'warning',
        item: 'TTM owner salary not entered — reusing the latest full year',
        detail: 'The owner salary-removal and employer-tax adjustment rows show the SAME figure for the latest year and TTM because the TTM salary field is blank. If the owner\'s pay changed, the normalization table (and the CIM) is overstating or understating TTM EBITDA.',
        action: 'Enter the actual TTM owner salary',
        canResolveAt: 'Adjustments tab → Owner Compensation (TTM column)',
        resolveTab: 'adjustments'
      });
    }

    // 1g. Manual adjustment pairs where the TTM entry reuses a full year's
    // amount verbatim (Zac 2026-07-27, Midwest: the owner's discretionary
    // list was annual, so the TTM twins were keyed with the same dollars —
    // the CIM then shows identical year/TTM normalization rows). Identical
    // CAN be legitimate (steady spend); the flag asks for confirmation, it
    // doesn't accuse. Pairs are grouped by description exactly like the
    // normalization model groups rows.
    {
      const byDesc = {};
      adjustmentItems.filter(a => a.included && (a.description || '').trim()).forEach(a => {
        const d = (a.description || '').trim().toLowerCase();
        (byDesc[d] = byDesc[d] || []).push(a);
      });
      const reused = Object.values(byDesc).filter(list => {
        const yearly = list.find(a => a.year !== 'TTM' && a.year !== 'All Years' && (a.amount || 0) !== 0);
        const ttmTwin = list.find(a => a.year === 'TTM');
        return yearly && ttmTwin && Math.abs((yearly.amount || 0) - (ttmTwin.amount || 0)) < 0.005;
      }).map(list => list[0].description);
      if (reused.length > 0) {
        flags.push({
          key: 'adj-ttm-amount-reused',
          category: 'Adjustments',
          severity: 'info',
          item: `${reused.length} adjustment${reused.length === 1 ? '' : 's'} reuse${reused.length === 1 ? 's' : ''} the annual amount for TTM`,
          detail: `Same dollar amount entered for a full year and for TTM: ${reused.slice(0, 4).join(' · ')}${reused.length > 4 ? ` (+${reused.length - 4} more)` : ''}. Fine if the spend genuinely repeats — but if the TTM actuals were never tallied, the normalization table shows annual figures as TTM.`,
          action: 'Confirm the TTM amounts against the TTM-window actuals',
          canResolveAt: 'Adjustments tab → the TTM-tagged rows',
          resolveTab: 'adjustments'
        });
      }
    }

    // 2. Missing documents
    const missingDocs = documentChecklist.filter(d => d.status !== 'complete');
    missingDocs.forEach(d => {
      flags.push({ key: `doc-${d.id}`, category: 'Document', severity: 'info', item: `Missing: ${d.name}`, detail: d.notes || 'Not yet received', action: 'Request from seller', canResolveAt: 'Check received below' });
    });

    // 3. Pending Seller Q&A
    const pendingQA = sellerQA.filter(qa => qa.status === 'pending');
    pendingQA.forEach(qa => {
      flags.push({ key: `qa-${qa.id}`, category: 'Discovery', severity: 'info', item: `Pending: ${qa.question.substring(0, 50)}...`, detail: qa.notes || 'Awaiting response', action: 'Follow up with seller', canResolveAt: 'Discovery tab' });
    });

    // 4. Q&A needing follow-up
    const followUpQA = sellerQA.filter(qa => qa.status === 'follow-up');
    followUpQA.forEach(qa => {
      flags.push({ key: `qa-followup-${qa.id}`, category: 'Discovery', severity: 'warning', item: `Follow-up needed: ${qa.question.substring(0, 40)}...`, detail: qa.answer ? `Answer: ${qa.answer.substring(0, 50)}...` : '', action: 'Clarify with seller', canResolveAt: 'Discovery tab' });
    });

    // 4b. Contingent liabilities (Mark 09-26, replaces the SBA / PG gate): a
    // disclosed contingent liability is CRITICAL until Colleen has quantified
    // it — value can't be certified with an unassessed guarantee or claim over
    // the assets (a critical flag zeroes the gauge's Flags factor). 'Not sure'
    // is a follow-up question, not a hold. Free-text portal answers that didn't
    // map to an option are read by their opening words.
    const clQ = sellerQA.find(q => q.id === 34);
    if (clQ) {
      const txt = String(clQ.answer || '');
      const saidYes = clQ.numericValue === 1 || (clQ.numericValue == null && /^\s*(yes|we (have|do)|there (is|are))\b/i.test(txt));
      const unsure = clQ.numericValue === 2 || (clQ.numericValue == null && /not sure|unsure|don'?t know|no idea/i.test(txt));
      if (saidYes) {
        flags.push({
          key: 'contingent-liability-unassessed', category: 'Discovery', severity: 'critical',
          item: 'Contingent liability disclosed — not yet quantified',
          detail: `Owner answered: ${txt || '(no detail)'}`,
          action: 'Colleen: get the document (guarantee, claim, notice), size the exposure, and decide how it is handled at a sale (released, paid from proceeds, or indemnified). Update the answer once it is quantified.',
          canResolveAt: 'Discovery tab → update the answer',
          resolveTab: 'discovery',
        });
      } else if (unsure) {
        flags.push({
          key: 'contingent-liability-unsure', category: 'Discovery', severity: 'warning',
          item: 'Contingent liabilities — owner not sure',
          detail: `Owner answered: ${txt || '(no detail)'}`,
          action: 'Walk the examples with the owner on the next call (guarantees for anyone else, claims, tax notices, LCs); record yes or no.',
          canResolveAt: 'Discovery tab → update the answer',
          resolveTab: 'discovery',
        });
      }
    }
    // 4a. Pending follow-up sub-questions within Q&A
    const qaDisplayNums = discoveryDisplayNumbers(sellerQA);
    sellerQA.forEach(qa => {
      if (qa.followUps && qa.followUps.length > 0) {
        qa.followUps.filter(fu => fu.status === 'pending' || fu.status === 'Pending').forEach(fu => {
          flags.push({ 
            key: `qa-fu-${qa.id}-${fu.id}`, 
            category: 'Discovery', 
            severity: 'warning', 
            item: `Follow-up Q: ${fu.question.substring(0, 45)}...`, 
            detail: `Re: Q${qaDisplayNums[qa.id] || '?'} - ${qa.question.substring(0, 35)}...`, 
            action: 'Get answer from seller', 
            canResolveAt: 'Discovery tab',
            isFollowUpQuestion: true,
            parentQuestionId: qa.id
          });
        });
      }
    });

    // 4b. Revenue Streams needing review or owner confirmation
    revenueStreams.forEach(stream => {
      if (stream.status === 'needs_review') {
        flags.push({ 
          key: `stream-review-${stream.id}`, 
          category: 'Rev/COGS Matching', 
          severity: 'warning', 
          item: `Needs Review: ${stream.name}`, 
          detail: 'Revenue-to-COGS matching needs verification', 
          action: 'Verify COGS allocation is correct',
          canResolveAt: 'Rev & COGS tab → Change status to Confirmed',
          resolveTab: 'revenueanalysis'
        });
      } else if (stream.status === 'ask_owner') {
        flags.push({ 
          key: `stream-ask-${stream.id}`, 
          category: 'Rev/COGS Matching', 
          severity: 'info', 
          item: `Ask Owner: ${stream.name}`, 
          detail: 'Revenue-to-COGS matching needs owner confirmation', 
          action: 'Confirm with owner that COGS allocation is accurate',
          canResolveAt: 'Rev & COGS tab → Change status to Confirmed',
          resolveTab: 'revenueanalysis'
        });
      }
    });

    // 4c. Unverified Owner Salary amounts
    const ownerSalaryPeriods = [
      { key: 'year3', label: basisYearLabels?.year3 || 'Year 3' },
      { key: 'year4', label: basisYearLabels?.year4 || 'Year 4' },
      { key: 'year5', label: basisYearLabels?.year5 || 'Year 5' },
      { key: 'ttm', label: ttmLabel }
    ];
    ownerSalaryPeriods.forEach(period => {
      const comp = ownerCompensation[period.key];
      if (comp && comp.salary > 0 && !comp.verified) {
        flags.push({ 
          key: `owner-salary-${period.key}`, 
          category: 'Owner Compensation', 
          severity: 'warning', 
          item: `Unverified Owner Salary: ${period.label}`, 
          detail: `$${comp.salary.toLocaleString()} - needs verification`,
          action: 'Verify salary amount with supporting documentation',
          canResolveAt: 'Adjustments tab → Owner section → Check Verified',
          resolveTab: 'adjustments'
        });
      }
    });

    // 4d. Embedded in Wages checked but no deduction adjustment created for each period
    if (ownerCompensation.embeddedInWages) {
      const salaryLineNames = opexCategories.filter(c => c.name && (c.name.toLowerCase().includes('salar') || c.name.toLowerCase().includes('payroll'))).map(c => c.name);
      const periodsToCheck = [
        { key: 'year1', label: basisYearLabels?.year1 || 'Year 1', adjYear: basisYearLabels?.year1 || 'Year 1' },
        { key: 'year2', label: basisYearLabels?.year2 || 'Year 2', adjYear: basisYearLabels?.year2 || 'Year 2' },
        { key: 'year3', label: basisYearLabels?.year3 || 'Year 3', adjYear: basisYearLabels?.year3 || 'Year 3' },
        { key: 'year4', label: basisYearLabels?.year4 || 'Year 4', adjYear: basisYearLabels?.year4 || 'Year 4' },
        { key: 'year5', label: basisYearLabels?.year5 || 'Year 5', adjYear: basisYearLabels?.year5 || 'Year 5' },
        { key: 'ttm', label: ttmLabel, adjYear: 'TTM' }
      ];
      
      periodsToCheck.forEach(period => {
        const salary = ownerCompensation[period.key]?.salary || 0;
        if (salary > 0) {
          // Check if there's a matching deduction for this period
          const hasMatchingAdj = adjustmentItems.some(a => {
            if (!a.included || a.type !== 'deduct') return false;
            // Check if amount matches (within 10%)
            const amountMatch = a.amount >= salary * 0.9 && a.amount <= salary * 1.1;
            // Check if year matches (All Years counts for any period)
            const yearMatch = a.year === 'All Years' || a.year === period.adjYear || a.year === period.label;
            // Check if it's on a salary-related line (be more permissive)
            const salaryLineMatch = salaryLineNames.some(name => 
              a.plLine === `OpEx: ${name}` || a.plLine === name
            ) || a.plLine === 'Salaries' || a.plLine === 'Salaries & Wages' || 
               (a.plLine && (a.plLine.toLowerCase().includes('salar') || a.plLine.toLowerCase().includes('payroll'))) ||
               (a.description && a.description.toLowerCase().includes('owner') && a.description.toLowerCase().includes('salar'));
            return amountMatch && yearMatch && salaryLineMatch;
          });
          
          if (!hasMatchingAdj) {
            flags.push({ 
              key: `owner-salary-embedded-no-adj-${period.key}`, 
              category: 'Owner Compensation', 
              severity: 'warning', 
              item: `Owner Salary Embedded - ${period.label} Adjustment Needed`, 
              detail: `Owner salary ($${salary.toLocaleString()}) for ${period.label} is included in Salaries but no matching deduction found`,
              action: `Add a Deduction adjustment for $${salary.toLocaleString()} on your Salaries/Wages OpEx line for ${period.label}`,
              canResolveAt: 'Adjustments tab → Add deduction for owner salary amount',
              resolveTab: 'adjustments'
            });
          }
        }
      });
    }

    // 5a. Negative Revenue (should always be positive)
    const yearLabels = { year1: 'Year 1', year2: 'Year 2', year3: 'Year 3', ttm: 'TTM' };
    revenueCategories.forEach(cat => {
      ['year1', 'year2', 'year3', 'ttm'].forEach(yearKey => {
        if (cat[yearKey] < 0) {
          flags.push({ 
            key: `negrev-${cat.id}-${yearKey}`, 
            category: 'Income Statement', 
            severity: 'critical', 
            item: `Negative Revenue: ${cat.name}`, 
            detail: `${yearLabels[yearKey]}: $${cat[yearKey].toLocaleString()}`, 
            action: 'Revenue should not be negative - verify data entry or investigate credit/refund',
            resolveTab: 'detailed'
          });
        }
      });
    });

    // 5b. Negative COGS (unusual - could be credits/rebates but needs review)
    cogsCategories.forEach(cat => {
      ['year1', 'year2', 'year3', 'ttm'].forEach(yearKey => {
        if (cat[yearKey] < 0) {
          flags.push({ 
            key: `negcogs-${cat.id}-${yearKey}`, 
            category: 'Income Statement', 
            severity: 'warning', 
            item: `Negative COGS: ${cat.name}`, 
            detail: `${yearLabels[yearKey]}: $${cat[yearKey].toLocaleString()}`, 
            action: 'COGS typically positive - verify if vendor credit/rebate or data error',
            resolveTab: 'detailed'
          });
        }
      });
    });

    // 5b2. Unverified Revenue Categories (estimates reduce valuation accuracy)
    revenueCategories.forEach(cat => {
      if (cat.name && !cat.isVerified) {
        const hasTTMData = (cat[selectedValuationBasis]?.ttm || 0) !== 0;
        if (hasTTMData) {
          flags.push({ 
            key: `unverified-rev-${cat.id}`, 
            category: 'Revenue Estimate', 
            severity: 'info', 
            item: `Unverified Revenue: ${cat.name}`, 
            detail: `TTM: ${formatCurrency(cat[selectedValuationBasis]?.ttm || 0)} - breakdown not verified against source documents`,
            action: 'Verify revenue breakdown from sales reports, PSA exports, or accounting records',
            canResolveAt: 'Revenue & COGS tab → Toggle to Verified',
            resolveTab: 'revenueanalysis'
          });
        }
      }
    });

    // 5c. Negative Operating Expenses (unusual - could be refunds but needs review)
    opexCategories.forEach(cat => {
      ['year1', 'year2', 'year3', 'ttm'].forEach(yearKey => {
        if (cat[yearKey] < 0) {
          flags.push({ 
            key: `negopex-${cat.id}-${yearKey}`, 
            category: 'Income Statement', 
            severity: 'warning', 
            item: `Negative Expense: ${cat.name}`, 
            detail: `${yearLabels[yearKey]}: $${cat[yearKey].toLocaleString()}`, 
            action: 'Expenses typically positive - verify if refund/credit or data error',
            resolveTab: 'detailed'
          });
        }
      });
    });

    // 6. Balance sheet - stale data (no change year over year)
    const checkStaleData = (items, categoryName) => {
      items.forEach(item => {
        if (item.year1 === item.year2 && item.year2 === item.year3 && item.year1 !== 0) {
          const flagKey = `stale-${categoryName}-${item.id}`;
          // Check if this flag has been reviewed
          if (!bsIssueNotes[flagKey]?.reviewed) {
            flags.push({ key: flagKey, category: 'Stale Balance Sheet', severity: 'critical', item: `${item.name}: No change 3 years`, detail: `All years show $${item.year1.toLocaleString()}`, action: 'Verify accounting is current - possible bookkeeping issue', canResolveAt: 'Balance Sheet Analysis → Add explanation note', resolveTab: 'bsanalysis' });
          }
        }
      });
    };
    checkStaleData(bsCurrentAssets, 'ca');
    checkStaleData(bsFixedAssets, 'fa');
    checkStaleData(bsOtherAssets, 'oa');
    checkStaleData(bsCurrentLiabilities, 'cl');
    checkStaleData(bsLongTermLiabilities, 'ltl');
    checkStaleData(bsEquity, 'eq');

    // 5. Negative equity
    const equityYears = [
      { year: bsYearLabels.year1, period: 'year1', equity: balanceSheetCalcs.year1.totalEquity },
      { year: bsYearLabels.year2, period: 'year2', equity: balanceSheetCalcs.year2.totalEquity },
      { year: bsYearLabels.year3, period: 'year3', equity: balanceSheetCalcs.year3.totalEquity },
      { year: bsYearLabels.interim, period: 'interim', equity: balanceSheetCalcs.interim.totalEquity }
    ];
    equityYears.forEach(({ year, period, equity }) => {
      if (equity < 0) {
        const flagKey = `negequity-${period}`;
        // Check if this flag has been reviewed
        if (!bsIssueNotes[flagKey]?.reviewed) {
          flags.push({ key: flagKey, category: 'Balance Sheet', severity: 'critical', item: `Negative Equity: ${year}`, detail: `Total Equity: $${equity.toLocaleString()}`, action: 'Investigate - may indicate insolvency or heavy debt', canResolveAt: 'Balance Sheet Analysis → Add explanation note', resolveTab: 'bsanalysis' });
        }
      }
    });

    // 6. Negative asset balances (assets should be positive, except accumulated depreciation, allowances, and contra accounts)
    const checkNegativeAssets = (items, yearKey, yearLabel) => {
      items.forEach(item => {
        const val = item[yearKey] || 0;
        const nameLower = (item.name || '').toLowerCase();
        const isContraAccount = nameLower.includes('accumulated') || nameLower.includes('depreciation') || nameLower.includes('allowance');
        if (val < 0 && !isContraAccount) {
          const flagKey = `negasset-${yearKey}-${item.id}`;
          if (!bsIssueNotes[flagKey]?.reviewed) {
            flags.push({ key: flagKey, category: 'Balance Sheet', severity: 'critical', item: `Negative Asset: ${item.name}`, detail: `${yearLabel}: $${val.toLocaleString()}`, action: 'Data error or misclassification - investigate', canResolveAt: 'Balance Sheet Analysis → Add explanation note', resolveTab: 'bsanalysis' });
          }
        }
      });
    };
    ['year1', 'year2', 'year3', 'interim'].forEach(yearKey => {
      const yearLabel = bsYearLabels[yearKey];
      checkNegativeAssets(bsCurrentAssets, yearKey, yearLabel);
      checkNegativeAssets(bsFixedAssets, yearKey, yearLabel);
      checkNegativeAssets(bsOtherAssets, yearKey, yearLabel);
    });

    // 7. Negative liability balances (liabilities should be positive)
    const checkNegativeLiabilities = (items, yearKey, yearLabel) => {
      items.forEach(item => {
        const val = item[yearKey] || 0;
        if (val < 0) {
          const flagKey = `negliab-${yearKey}-${item.id}`;
          if (!bsIssueNotes[flagKey]?.reviewed) {
            flags.push({ key: flagKey, category: 'Balance Sheet', severity: 'critical', item: `Negative Liability: ${item.name}`, detail: `${yearLabel}: $${val.toLocaleString()}`, action: 'Data error - liabilities should be positive', canResolveAt: 'Balance Sheet Analysis → Add explanation note', resolveTab: 'bsanalysis' });
          }
        }
      });
    };
    ['year1', 'year2', 'year3', 'interim'].forEach(yearKey => {
      const yearLabel = bsYearLabels[yearKey];
      checkNegativeLiabilities(bsCurrentLiabilities, yearKey, yearLabel);
      checkNegativeLiabilities(bsLongTermLiabilities, yearKey, yearLabel);
    });
    
    // 8. Recognition account review - consolidated into single Open Item
    // Only flag items above materiality threshold ($25,000 or 2% of TTM revenue)
    // Note: Compute TTM revenue from revenueCategories since calculations is defined later
    const ttmRevenueForThreshold = revenueCategories
      .filter(cat => cat.name)
      .reduce((sum, cat) => sum + (cat[selectedValuationBasis]?.ttm || cat.ttm || 0), 0);
    const recognitionThreshold = Math.max(25000, ttmRevenueForThreshold * 0.02);
    
    const prepaidAccounts = bsCurrentAssets.filter(a => a.name.toLowerCase().includes('prepaid') && (a.interim || 0) !== 0);
    const accruedAccounts = bsCurrentLiabilities.filter(a => a.name.toLowerCase().includes('accrued') && (a.interim || 0) !== 0);
    const deferredAccounts = [...bsCurrentLiabilities, ...bsLongTermLiabilities].filter(a => 
      (a.name.toLowerCase().includes('deferred') || a.name.toLowerCase().includes('unearned')) && (a.interim || 0) !== 0
    );
    const depositAccounts = bsCurrentLiabilities.filter(a => 
      (a.name.toLowerCase().includes('customer deposit') || (a.name.toLowerCase().includes('deposit') && !a.name.toLowerCase().includes('security'))) && (a.interim || 0) !== 0
    );
    
    // Build list of material recognition items needing review
    const recognitionItems = [];
    if (balanceSheetCalcs.interim.deferredRevenue >= recognitionThreshold) {
      recognitionItems.push({ key: 'deferredRevenue', label: 'Deferred Revenue', balance: balanceSheetCalcs.interim.deferredRevenue, reviewed: bsRecognitionNotes.deferredRevenue?.reviewed });
    }
    if (balanceSheetCalcs.interim.prepaidExpenses >= recognitionThreshold) {
      recognitionItems.push({ key: 'prepaidExpenses', label: 'Prepaid Expenses', balance: balanceSheetCalcs.interim.prepaidExpenses, reviewed: bsRecognitionNotes.prepaidExpenses?.reviewed });
    }
    if (balanceSheetCalcs.interim.accruedExpenses >= recognitionThreshold) {
      recognitionItems.push({ key: 'accruedExpenses', label: 'Accrued Expenses', balance: balanceSheetCalcs.interim.accruedExpenses, reviewed: bsRecognitionNotes.accruedExpenses?.reviewed });
    }
    if (balanceSheetCalcs.interim.customerDeposits >= recognitionThreshold) {
      recognitionItems.push({ key: 'customerDeposits', label: 'Customer Deposits', balance: balanceSheetCalcs.interim.customerDeposits, reviewed: bsRecognitionNotes.customerDeposits?.reviewed });
    }
    if (balanceSheetCalcs.interim.unearnedRevenue >= recognitionThreshold) {
      recognitionItems.push({ key: 'unearnedRevenue', label: 'Unearned Revenue', balance: balanceSheetCalcs.interim.unearnedRevenue, reviewed: bsRecognitionNotes.unearnedRevenue?.reviewed });
    }
    
    // Single consolidated flag if any material items need review
    const pendingRecognitionItems = recognitionItems.filter(i => !i.reviewed);
    if (pendingRecognitionItems.length > 0) {
      const totalPending = pendingRecognitionItems.reduce((sum, i) => sum + i.balance, 0);
      const itemList = pendingRecognitionItems.map(i => i.label).join(', ');
      flags.push({ 
        key: 'recognition-review', 
        category: 'Balance Sheet', 
        severity: 'warning', 
        item: 'Recognition Items Pending Review', 
        detail: `${pendingRecognitionItems.length} item${pendingRecognitionItems.length !== 1 ? 's' : ''} totaling $${totalPending.toLocaleString()} (${itemList})`, 
        action: 'Review each item and check off when verified', 
        canResolveAt: 'Balance Sheet Analysis → Recognition Review checklist', 
        resolveTab: 'bsanalysis' 
      });
    }

    // 8b. Balance Sheet issues marked as "Adjustment Needed"
    const adjustmentNeededIssues = Object.entries(bsIssueNotes).filter(([key, data]) => data.ebitdaImpact === 'needed');
    adjustmentNeededIssues.forEach(([key, data]) => {
      flags.push({ 
        key: `bs-adj-needed-${key}`, 
        category: 'Balance Sheet', 
        severity: 'warning', 
        item: 'EBITDA Adjustment Needed', 
        detail: `Balance sheet issue requires adjustment: ${data.notes || key}`,
        action: 'Add EBITDA adjustment on Adjustments tab, then update status to "Adjustment Added"',
        canResolveAt: 'Balance Sheet Analysis → Change EBITDA dropdown to "Adjustment Added"',
        resolveTab: 'bsanalysis'
      });
    });

    // 9. (Removed - Now handled via manual flagging in Sales Analysis → Revenue Reconciliation)
    
    const fmtCurrency = (num) => `$${num.toLocaleString()}`;

    // 9b. AR Review Issues
    const totalAR = arAgingCalcs.totalAR;
    const pastDue = arAgingCalcs.pastDue;
    const pastDuePct = totalAR > 0 ? (pastDue / totalAR * 100) : 0;
    const days120PlusPct = totalAR > 0 ? (arAgingCalcs.days120plus / totalAR * 100) : 0;
    const seriouslyPastDuePct = totalAR > 0 ? ((arAgingCalcs.days91to120 + arAgingCalcs.days120plus) / totalAR * 100) : 0;
    
    // Flag for missing AR aging report date
    if (!arReviewChecklist.notApplicable && totalAR > 0 && !arAgingData.reportDate) {
      flags.push({
        key: 'ar-missing-date',
        category: 'AR Quality',
        severity: 'warning',
        item: 'AR Aging Report Date Missing',
        detail: `AR aging entered (${fmtCurrency(totalAR)}) but no report date specified`,
        action: 'Enter the date of the AR aging report',
        canResolveAt: 'AR/AP tab → Report Date field',
        resolveTab: 'arap'
      });
    }
    
    // Count how many AR issues exist and how many are resolved
    const arIssueKeys = [];
    if (pastDuePct > 25) arIssueKeys.push('ar-pastdue-high');
    if (seriouslyPastDuePct > 10) arIssueKeys.push('ar-91plus-high');
    if (days120PlusPct > 3) arIssueKeys.push('ar-120plus-high');
    if (arAgingCalcs.negativeBalances !== 0) arIssueKeys.push('ar-negative-balances');
    
    const arIssuesResolved = arIssueKeys.filter(k => arReviewChecklist[k]?.reviewed).length;
    const allArIssuesResolved = arIssueKeys.length > 0 && arIssuesResolved === arIssueKeys.length;
    
    // AR Report Review flag - shows until all issues are resolved (or no issues exist)
    if (!arReviewChecklist.notApplicable && totalAR > 0 && arIssueKeys.length > 0 && !allArIssuesResolved) {
      flags.push({
        key: 'ar-report-review',
        category: 'AR Quality',
        severity: 'warning',
        item: 'AR Aging Report Not Reviewed',
        detail: `AR aging entered (${fmtCurrency(totalAR)}) - ${arIssueKeys.length - arIssuesResolved} issue(s) need review`,
        action: 'Review AR aging report for issues',
        canResolveAt: 'AR/AP Analysis → Review and resolve issues in Issues & Flags section',
        resolveTab: 'arapanalysis'
      });
    }
    
    // Individual AR issue flags - only show if not yet reviewed in Issues & Flags section
    if (totalAR > 0) {
      // High past due - aggregate warning
      if (pastDuePct > 25 && !arReviewChecklist['ar-pastdue-high']?.reviewed) {
        flags.push({
          key: 'ar-highpastdue',
          category: 'AR Quality',
          severity: 'critical',
          item: 'Very High Past Due AR',
          detail: `${pastDuePct.toFixed(1)}% past due (>25%) - significant collection risk`,
          action: 'Assess collectibility and consider EBITDA adjustment',
          canResolveAt: 'AR/AP Analysis → Mark "Past Due" as reviewed in Issues & Flags',
          resolveTab: 'arapanalysis'
        });
      } else if (pastDuePct > 15 && !arReviewChecklist['ar-pastdue-high']?.reviewed) {
        flags.push({
          key: 'ar-elevatedpastdue',
          category: 'AR Quality',
          severity: 'warning',
          item: 'Elevated Past Due AR',
          detail: `${pastDuePct.toFixed(1)}% past due (>15%) - review collection practices`,
          action: 'Discuss collection practices with seller',
          canResolveAt: 'AR/AP Analysis → Mark "Past Due" as reviewed in Issues & Flags',
          resolveTab: 'arapanalysis'
        });
      }
      
      // High 120+ days warning — worded with the aging report's own last bucket (Colleen 11-02, HPT:
      // its oldest tier is "91+", and the flag said "over 120 days").
      if (days120PlusPct > 3 && !arReviewChecklist['ar-120plus-high']?.reviewed) {
        const oldestLabel = arAgingBucketLabels?.days120plus || '120+';
        flags.push({
          key: 'ar-high120',
          category: 'AR Quality',
          severity: 'warning',
          item: `High ${oldestLabel} Day AR`,
          detail: `${days120PlusPct.toFixed(1)}% in the ${oldestLabel} day bucket (${fmtCurrency(arAgingCalcs.days120plus)}) - often uncollectible`,
          action: 'Verify bad debt allowance is adequate',
          canResolveAt: `AR/AP Analysis → Mark "${oldestLabel} Days" as reviewed in Issues & Flags`,
          resolveTab: 'arapanalysis'
        });
      }
      
      // Negative balances warning
      if (arAgingCalcs.negativeBalances !== 0 && !arReviewChecklist['ar-negative-balances']?.reviewed) {
        flags.push({
          key: 'ar-negbalances',
          category: 'AR Quality',
          severity: 'critical',
          item: 'Negative AR Balances Detected',
          detail: `${fmtCurrency(arAgingCalcs.negativeBalances)} in negative balances - potential accounting errors`,
          action: 'Investigate negative balances with seller',
          canResolveAt: 'AR/AP Analysis → Mark "Negative Balance" as reviewed in Issues & Flags',
          resolveTab: 'arapanalysis'
        });
      }
    }

    // 9b2. Charge-Off / Bad Debt Detection
    // Scan P&L lines for charge-off related accounts and flag patterns
    const chargeOffKeywords = [
      /bad\s*debt/i, /charge[\s-]?off/i, /write[\s-]?off/i, /uncollect/i, 
      /doubtful\s*account/i, /allowance.*doubtful/i, /provision.*bad/i,
      /provision.*doubtful/i, /credit\s*loss/i, /debt\s*expense/i
    ];
    
    const chargeOffLines = [];
    const basis = selectedValuationBasis || 'cash';
    const yearKeys = ['year3', 'year4', 'year5', 'ttm'];
    
    // Scan OpEx and Other Expense categories
    [...opexCategories, ...otherExpenseCategories].forEach(cat => {
      if (!cat.name) return;
      const isMatch = chargeOffKeywords.some(rx => rx.test(cat.name));
      if (!isMatch) return;
      
      const values = {};
      let hasAnyValue = false;
      yearKeys.forEach(yr => {
        const val = cat[basis]?.[yr] || 0;
        values[yr] = val;
        if (val > 0) hasAnyValue = true;
      });
      
      if (hasAnyValue) {
        chargeOffLines.push({ name: cat.name, values, id: cat.id });
      }
    });
    
    if (chargeOffLines.length > 0) {
      // Get TTM revenue for percentage calculation
      const ttmRevenue = revenueCategories.reduce((sum, cat) => sum + (cat[basis]?.ttm || 0), 0);
      
      chargeOffLines.forEach(line => {
        // Count years with meaningful amounts (>$500 or >0.1% of revenue)
        const materialThreshold = Math.max(500, ttmRevenue * 0.001);
        const yearsWithChargeOffs = ['year3', 'year4', 'year5'].filter(yr => line.values[yr] > materialThreshold);
        const ttmAmount = line.values.ttm || 0;
        const ttmPctOfRev = ttmRevenue > 0 ? (ttmAmount / ttmRevenue * 100) : 0;
        const isMaterial = ttmAmount >= 5000 || ttmPctOfRev >= 0.5;
        const isRecurring = yearsWithChargeOffs.length >= 2;
        
        if (isRecurring && isMaterial) {
          // Recurring charge-offs - critical flag
          const yearLabels = yearsWithChargeOffs.map(yr => basisYearLabels?.[yr] || yr).join(', ');
          flags.push({
            key: `chargeoff-recurring-${line.id}`,
            category: 'Revenue Quality',
            severity: 'critical',
            item: `Recurring Charge-Offs: ${line.name}`,
            detail: `Present in ${yearsWithChargeOffs.length} years (${yearLabels}). TTM: ${fmtCurrency(ttmAmount)} (${ttmPctOfRev.toFixed(1)}% of revenue). Recurring bad debt suggests systemic collection issues — consider EBITDA adjustment as ongoing cost of business.`,
            action: 'Investigate collection practices, AR aging quality, and customer creditworthiness',
            canResolveAt: 'AR/AP Analysis tab',
            resolveTab: 'arapanalysis'
          });
        } else if (isMaterial) {
          // One-time large charge-off - warning
          flags.push({
            key: `chargeoff-onetime-${line.id}`,
            category: 'Revenue Quality',
            severity: 'warning',
            item: `Charge-Off Detected: ${line.name}`,
            detail: `TTM: ${fmtCurrency(ttmAmount)} (${ttmPctOfRev.toFixed(1)}% of revenue). Appears to be a one-time event — discuss with owner to understand circumstances.`,
            action: 'Ask owner what caused the charge-off and if it is expected to recur',
            canResolveAt: 'Adjustments tab',
            resolveTab: 'adjustments'
          });
        }
      });
    }

    // 9c. Quality of Earnings - Reconciliation Auto-Flags
    // These check total-level variances that indicate potential quality issues
    // Fixed thresholds (not configurable) as percentages don't scale with business size
    
    // Helper to calculate variance percentage
    const calcVariancePct = (val1, val2) => {
      if (val1 === 0 && val2 === 0) return 0;
      if (val1 === 0) return val2 !== 0 ? 100 : 0;
      return Math.abs((val2 - val1) / val1) * 100;
    };
    
    // 9c1. Cash vs Accrual EBITDA variance >15% (using TTM)
    const checkYear = 'ttm'; // Check TTM for quality issues
    const cashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
    const accrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
    const cashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
    const accrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
    const cashOpex = opexCategories.reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
    const accrualOpex = opexCategories.reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
    // Add back D/I/A/T to get true EBITDA
    // Source 1: Dedicated DIAT fields
    const cashDIAT = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
      sum + (diatCategories?.[key]?.cash?.[checkYear] || 0), 0);
    const accrualDIAT = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
      sum + (diatCategories?.[key]?.accrual?.[checkYear] || 0), 0);
    // Source 2: OpEx/OE line items categorized as DIAT (e.g., Interest Expense in OpEx)
    const diatKeywords = /depreci|interest|amortiz|income\s*tax|tax\s*expense/i;
    const isDiatLine = (cat) => ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) || diatKeywords.test(cat.name || '');
    const cashOpexDIAT = [...opexCategories, ...otherExpenseCategories].filter(cat => cat.name && isDiatLine(cat))
      .reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
    const accrualOpexDIAT = [...opexCategories, ...otherExpenseCategories].filter(cat => cat.name && isDiatLine(cat))
      .reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
    const cashEbitda = cashRev - cashCogs - cashOpex + cashDIAT + cashOpexDIAT;
    const accrualEbitda = accrualRev - accrualCogs - accrualOpex + accrualDIAT + accrualOpexDIAT;
    
    if (cashEbitda !== 0 && accrualEbitda !== 0) {
      const ebitdaVariancePct = calcVariancePct(cashEbitda, accrualEbitda);
      if (ebitdaVariancePct > 15 && !reconQualityChecklist['qoe_cash_accrual_ebitda']?.reviewed) {
        flags.push({
          key: 'qoe_cash_accrual_ebitda',
          category: 'Quality of Earnings',
          severity: 'warning',
          item: 'Cash vs Accrual EBITDA Variance >15%',
          detail: `TTM EBITDA — Cash: ${fmtCurrency(cashEbitda)} vs Accrual: ${fmtCurrency(accrualEbitda)} (${ebitdaVariancePct.toFixed(1)}% variance)`,
          action: 'Large timing differences may hide earnings quality issues - investigate',
          canResolveAt: 'Reconciliation → Issues & Flags section',
          resolveTab: 'reconciliation'
        });
      }
    }
    
    // 9c2. Tax vs P&L Net Income variance >10% (find most recent year with tax data)
    const taxCheckYear = ['year5', 'year4', 'year3'].find(yr => 
      (taxReturnTotals?.revenue?.[yr] || 0) !== 0 || (taxReturnTotals?.cogs?.[yr] || 0) !== 0
    );
    if (taxCheckYear) {
    const taxRev = taxReturnTotals?.revenue?.[taxCheckYear] || 0;
    const taxCogs = taxReturnTotals?.cogs?.[taxCheckYear] || 0;
    const taxOpex = taxReturnTotals?.expenses?.[taxCheckYear] || 0;
    // Include Other Income/Expense from tax-basis category data (Form 1120 lines 4-9)
    const taxOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat.tax?.[taxCheckYear] || 0), 0);
    const taxOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat.tax?.[taxCheckYear] || 0), 0);
    const taxNetIncome = taxRev - taxCogs - taxOpex + taxOI - taxOE;
    
    // Get P&L values for same year to compare apples-to-apples with tax returns
    // Net Income = Rev - COGS - OpEx - DIAT + OtherIncome - OtherExpense
    const yrCashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[taxCheckYear] || 0), 0);
    const yrAccrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[taxCheckYear] || 0), 0);
    const yrCashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[taxCheckYear] || 0), 0);
    const yrAccrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[taxCheckYear] || 0), 0);
    const yrCashOpex = opexCategories.reduce((sum, cat) => sum + (cat.cash?.[taxCheckYear] || 0), 0);
    const yrAccrualOpex = opexCategories.reduce((sum, cat) => sum + (cat.accrual?.[taxCheckYear] || 0), 0);
    // Include DIAT (Depreciation, Interest, Amortization, Taxes) if entered separately
    const taxNiBasis = taxFilingBasis || 'cash';
    const yrDiat = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
      sum + (diatCategories?.[key]?.[taxNiBasis]?.[taxCheckYear] || 0), 0);
    // Include Other Income and Other Expense
    const yrOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat?.[taxNiBasis]?.[taxCheckYear] || 0), 0);
    const yrOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat?.[taxNiBasis]?.[taxCheckYear] || 0), 0);
    const basisNetIncome = taxFilingBasis === 'cash' ? 
      (yrCashRev - yrCashCogs - yrCashOpex - yrDiat + yrOI - yrOE) : (yrAccrualRev - yrAccrualCogs - yrAccrualOpex - yrDiat + yrOI - yrOE);
    
    if (taxNetIncome !== 0 && basisNetIncome !== 0) {
      const taxVariancePct = calcVariancePct(basisNetIncome, taxNetIncome);
      if (taxVariancePct > 10 && !reconQualityChecklist['qoe_tax_net_income']?.reviewed) {
        const yearLabel = basisYearLabels?.[taxCheckYear] || taxCheckYear;
        flags.push({
          key: 'qoe_tax_net_income',
          category: 'Quality of Earnings',
          severity: 'critical',
          item: `Tax Return vs P&L Net Income Variance >10% (${yearLabel})`,
          detail: `${taxNiBasis === 'cash' ? 'Cash' : 'Accrual'} P&L: ${fmtCurrency(basisNetIncome)} vs Tax: ${fmtCurrency(taxNetIncome)} (${taxVariancePct.toFixed(1)}% variance). Comparing to ${taxNiBasis === 'cash' ? 'Cash' : 'Accrual'} P&L based on Tax Filing Basis setting (set on Tax Returns entry tab).`,
          action: 'Lenders require tax-to-books reconciliation - document differences',
          canResolveAt: 'Reconciliation → Issues & Flags section',
          resolveTab: 'reconciliation'
        });
      }
    }
    }
    
    // 9c3. Sales vs P&L Revenue variance >5% (using TTM) — was 10% until Mark 09-30 (Blue Spruce's 8.2% / $673K slipped under)
    const salesTotal = customerSalesData.reduce((sum, c) => sum + (c[checkYear] || 0), 0);
    const plRevenue = selectedValuationBasis === 'cash' ? cashRev : accrualRev;
    
    if (salesTotal > 0 && plRevenue > 0) {
      const salesVariancePct = calcVariancePct(plRevenue, salesTotal);
      if (salesVariancePct > 5 && !reconQualityChecklist['qoe_sales_revenue']?.reviewed) {
        flags.push({
          key: 'qoe_sales_revenue',
          category: 'Quality of Earnings',
          severity: 'warning',
          item: 'Sales vs P&L Revenue Variance >5% (TTM)',
          detail: `${selectedValuationBasis === 'cash' ? 'Cash' : 'Accrual'} P&L Revenue: ${fmtCurrency(plRevenue)} vs Sales Total: ${fmtCurrency(salesTotal)} (${salesVariancePct.toFixed(1)}% variance). Comparing Sales to ${selectedValuationBasis === 'cash' ? 'Cash' : 'Accrual'} P&L (the selected valuation basis).`,
          action: 'Revenue sources don\'t reconcile - potential missing/unreported revenue',
          canResolveAt: 'Reconciliation → Issues & Flags section',
          resolveTab: 'reconciliation'
        });
      }
    }
    
    // 9c3b. Sales vs Tax Return Revenue variance >10% (use most recent year with tax data)
    const salesTaxCheckYear = ['year5', 'year4', 'year3'].find(yr => 
      (taxReturnTotals?.revenue?.[yr] || 0) !== 0
    );
    if (salesTaxCheckYear) {
    const salesTaxYearTotal = customerSalesData.reduce((sum, c) => sum + (c[salesTaxCheckYear] || 0), 0);
    const taxReturnRevenue = taxReturnTotals?.revenue?.[salesTaxCheckYear] || 0;
    
    if (salesTaxYearTotal > 0 && taxReturnRevenue > 0) {
      const salesTaxVariancePct = calcVariancePct(taxReturnRevenue, salesTaxYearTotal);
      if (salesTaxVariancePct > 10 && !reconQualityChecklist['qoe_sales_tax_revenue']?.reviewed) {
        const yearLabel = basisYearLabels?.[salesTaxCheckYear] || salesTaxCheckYear;
        flags.push({
          key: 'qoe_sales_tax_revenue',
          category: 'Quality of Earnings',
          severity: 'warning',
          item: `Sales vs Tax Return Revenue Variance >10% (${yearLabel})`,
          detail: `Tax Return: ${fmtCurrency(taxReturnRevenue)} vs Sales: ${fmtCurrency(salesTaxYearTotal)} (${salesTaxVariancePct.toFixed(1)}% variance)`,
          action: 'Customer sales should match tax return revenue - investigate unreported revenue or missing customers',
          canResolveAt: 'Reconciliation → Issues & Flags section',
          resolveTab: 'reconciliation'
        });
      }
    }
    }
    
    // 9c4. AR Aging vs Balance Sheet variance >5%
    const bsAR = bsTradeAR(bsCurrentAssets, 'interim');
    const agingAR = arAgingCalcs.totalAR || 0;
    
    if ((bsAR > 0 || agingAR > 0) && bsAR !== agingAR) {
      const arBsVariancePct = calcVariancePct(bsAR, agingAR);
      if (arBsVariancePct > 5 && !reconQualityChecklist['qoe_ar_bs']?.reviewed) {
        flags.push({
          key: 'qoe_ar_bs',
          category: 'Quality of Earnings',
          severity: 'warning',
          item: 'AR Aging vs Balance Sheet Variance >5%',
          detail: `Balance Sheet AR: ${fmtCurrency(bsAR)} vs Aging Report: ${fmtCurrency(agingAR)} (${arBsVariancePct.toFixed(1)}% variance)`,
          action: 'AR reports should tie - check report dates or posting timing',
          canResolveAt: 'Reconciliation → Issues & Flags section',
          resolveTab: 'reconciliation'
        });
      }
    }

    // 10. Open research items
    researchItems.filter(r => r.status === 'open').forEach(r => {
      flags.push({ key: `research-${r.id}`, category: 'Research', severity: r.priority === 'high' ? 'warning' : 'info', item: r.item, detail: r.notes || '', action: 'Complete research', canResolveAt: 'Change status below' });
    });

    // 11. Manual review flags from Analysis tabs (Analyst-flagged items)
    Object.entries(manualReviewFlags).forEach(([key, flag]) => {
      if (flag?.flagged) {
        // Determine flag type for notes and routing
        const isArAgingFlag = key.startsWith('ar-aging-');
        const isSalesDetailFlag = key.startsWith('sales-detail-');
        // Get the appropriate notes based on flag type
        const noteText = isArAgingFlag ? arAgingNotes[key] : isSalesDetailFlag ? salesDetailNotes[key] : monthlyTtmNotes[key];
        
        // Determine resolve location
        let canResolveAt = 'Analysis tab or Issues & Flags → Unflag';
        let resolveTab = 'analysis';
        if (isArAgingFlag) {
          canResolveAt = 'AR/AP Analysis → AR Aging Detail';
          resolveTab = 'arapanalysis';
        } else if (isSalesDetailFlag) {
          canResolveAt = 'Sales Analysis → Customer Sales Detail';
          resolveTab = 'salesanalysis';
        }
        
        flags.push({ 
          key: `analyst-${key}`, 
          category: 'Analyst Flag', 
          severity: 'warning', 
          item: flag.item || key, 
          detail: noteText || 'No notes added',
          action: 'Review and unflag when resolved',
          canResolveAt,
          resolveTab,
          isAnalystFlag: true,
          originalKey: key,
          section: flag.section || 'Analysis'
        });
      }
    });

    // 12. Sales Analysis Flags - Customer concentration, retention, at-risk
    if (customerSalesData && customerSalesData.length > 0) {
      const totalTTMRevenue = customerSalesData.reduce((s, c) => s + (c.ttm || 0), 0);
      const totalYear5Revenue = customerSalesData.reduce((s, c) => s + (c.year5 || 0), 0);
      
      // Determine which period to use: TTM preferred, Year5 fallback
      const concentrationPeriod = totalTTMRevenue > 0 ? 'ttm' : (totalYear5Revenue > 0 ? 'year5' : 'ttm');
      const concentrationTotal = concentrationPeriod === 'ttm' ? totalTTMRevenue : totalYear5Revenue;
      const concentrationSource = totalTTMRevenue > 0 ? 'TTM' : (totalYear5Revenue > 0 ? 'Year5' : 'TTM');
      
      // Remainder-aware (top-20 fix): "All Others" stays in totals, never
      // ranks or counts. Coverage flag unified to REVENUE-weighted over the
      // detail ask-set — the same math the engine scores on, so the flag and
      // the factor can never disagree again.
      const sortedByConcentration = customerSalesData.filter(c => !isRemainderRow(c)).sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0));
      const top1Pct = concentrationTotal > 0 ? ((sortedByConcentration[0]?.[concentrationPeriod] || 0) / concentrationTotal * 100) : 0;
      const currentCustomers = customerSalesData.filter(c => (c[concentrationPeriod] || 0) > 0 && !isRemainderRow(c));
      const atRiskClients = currentCustomers.filter(c => c.atRisk);
      const atRiskRevenue = atRiskClients.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
      const atRiskPct = concentrationTotal > 0 ? (atRiskRevenue / concentrationTotal * 100) : 0;

      // Contract coverage — revenue-weighted over the detail ask-set (≤40
      // named → all; else top 20 + explicit answers), matching keyMetrics.
      const fSorted = [...currentCustomers].sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0));
      const fAskSet = currentCustomers.length <= 40 ? currentCustomers : fSorted.slice(0, 20);
      const fAskIds = new Set(fAskSet.map(c => c.id));
      const fDetailed = [...fAskSet, ...currentCustomers.filter(c => !fAskIds.has(c.id) && (c.hasContract === true || c.contractAnswered === true))];
      const fDetailedRev = fDetailed.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
      const contractedPct = fDetailedRev > 0
        ? (fDetailed.filter(c => c.hasContract).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / fDetailedRev * 100) : 0;
      
      // Concentration Risk
      if (top1Pct > 25 && !custRevenueNotes['concentration-top1-high']?.reviewed) {
        flags.push({
          key: 'concentration-top1-high',
          category: 'Sales Analysis',
          severity: 'critical',
          item: `Concentration Risk: Top customer ${top1Pct.toFixed(1)}%${concentrationSource !== 'TTM' ? ` (${concentrationSource})` : ''}`,
          detail: `${sortedByConcentration[0]?.name || 'Top customer'} exceeds 25% threshold - significant key-man risk`,
          action: 'Review customer dependency and mitigation strategies',
          canResolveAt: 'Sales Analysis → Issues & Flags',
          resolveTab: 'salesanalysis'
        });
      } else if (top1Pct > 20 && !custRevenueNotes['concentration-top1-sba']?.reviewed) {
        flags.push({
          key: 'concentration-top1-sba',
          category: 'Sales Analysis',
          severity: 'warning',
          item: `SBA Concern: Top customer ${top1Pct.toFixed(1)}%${concentrationSource !== 'TTM' ? ` (${concentrationSource})` : ''}`,
          detail: `Exceeds SBA 20% threshold - may require personal guarantee from customer`,
          action: 'Discuss SBA implications with buyer',
          canResolveAt: 'Sales Analysis → Issues & Flags',
          resolveTab: 'salesanalysis'
        });
      }
      
      // Retention Issue (revenue-weighted GRR, matching keyMetrics formula)
      const calcGRR = (prevYear, currYear) => {
        const prev = customerSalesData.filter(c => (c[prevYear] || 0) > 0 && !isRemainderRow(c));
        const retained = prev.reduce((s, c) => {
          if (c.lost && currYear === 'ttm') return s;
          return s + Math.min(c[prevYear] || 0, c[currYear] || 0);
        }, 0);
        const total = prev.reduce((s, c) => s + (c[prevYear] || 0), 0);
        return total > 0 ? (retained / total * 100) : null;
      };
      const grr3to4 = calcGRR('year3', 'year4');
      const grr4to5 = calcGRR('year4', 'year5');
      const grr5toTTM = calcGRR('year5', 'ttm');
      const grrValues = [grr3to4, grr4to5, grr5toTTM].filter(r => r !== null);
      const avg3YrRetention = grrValues.length > 0 ? grrValues.reduce((a, b) => a + b, 0) / grrValues.length : null;
      
      if (avg3YrRetention !== null && avg3YrRetention < 80 && !custRevenueNotes['retention-low']?.reviewed) {
        flags.push({
          key: 'retention-low',
          category: 'Sales Analysis',
          severity: avg3YrRetention < 70 ? 'critical' : 'warning',
          item: `Retention Issue: 3yr retention ${avg3YrRetention.toFixed(1)}%`,
          detail: `Below 80% benchmark - investigate churn causes`,
          action: 'Analyze churn patterns and document reasons',
          canResolveAt: 'Sales Analysis → Issues & Flags',
          resolveTab: 'salesanalysis'
        });
      }
      
      // At-Risk Clients
      if (atRiskClients.length > 0 && !custRevenueNotes['at-risk-clients']?.reviewed) {
        flags.push({
          key: 'at-risk-clients',
          category: 'Sales Analysis',
          severity: atRiskPct > 10 ? 'critical' : 'warning',
          item: `At Risk: ${atRiskClients.length} at-risk clients`,
          detail: `$${atRiskRevenue.toLocaleString()} (${atRiskPct.toFixed(1)}%) revenue at risk`,
          action: 'Address at-risk customer issues',
          canResolveAt: 'Sales Analysis → Issues & Flags',
          resolveTab: 'salesanalysis'
        });
      }
      
      // Lost Clients (explicitly marked)
      const lostClients = currentCustomers.filter(c => c.lost);
      const lostRevenue = lostClients.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
      const lostPct = concentrationTotal > 0 ? (lostRevenue / concentrationTotal * 100) : 0;
      if (lostClients.length > 0 && !custRevenueNotes['lost-clients']?.reviewed) {
        flags.push({
          key: 'lost-clients',
          category: 'Sales Analysis',
          severity: lostPct > 10 ? 'critical' : 'warning',
          item: `Lost: ${lostClients.length} clients marked as lost`,
          detail: `$${lostRevenue.toLocaleString()} (${lostPct.toFixed(1)}%) revenue from lost clients still in data`,
          action: 'Verify TTM revenue excludes lost client revenue or adjust accordingly',
          canResolveAt: 'Sales Analysis → Issues & Flags',
          resolveTab: 'salesanalysis'
        });
      }
      
      // Low Contract Coverage — revenue-weighted over the detail ask-set,
      // same math as the engine (the count-vs-revenue disagreement is dead).
      // Only fires when there IS detail to judge; no detail = no verdict.
      if (fDetailedRev > 0 && contractedPct < 50 && currentCustomers.length >= 5 && !custRevenueNotes['low-contract-coverage']?.reviewed) {
        const m2mRev = fDetailed.filter(c => !c.hasContract).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
        flags.push({
          key: 'low-contract-coverage',
          category: 'Sales Analysis',
          severity: contractedPct < 30 ? 'critical' : 'warning',
          item: `Contract Risk: Only ${contractedPct.toFixed(0)}% of detailed revenue under contract`,
          detail: `$${Math.round(m2mRev).toLocaleString()} of the revenue with contract detail is month-to-month - higher churn risk. (Detail covers the top clients; the whole-book figure comes from the Revenue Classification.)`,
          action: 'Document contract strategy and renewal rates',
          canResolveAt: 'Sales Analysis → Issues & Flags',
          resolveTab: 'salesanalysis'
        });
      }
    }

    // 13. CapEx Investigation Required - triggered by Balance Sheet assets or Q&A response
    // Calculate Fixed Assets and Depreciation from Balance Sheet
    const totalFixedAssets = bsFixedAssets.reduce((sum, a) => sum + (a.interim || a.year3 || a.year2 || a.year1 || 0), 0);
    const depreciationTTM = diatCategories?.depreciation?.[selectedValuationBasis]?.ttm || diatCategories?.depreciation?.accrual?.ttm || 0;
    const depreciationYear5 = diatCategories?.depreciation?.[selectedValuationBasis]?.year5 || diatCategories?.depreciation?.accrual?.year5 || 0;
    // + depreciation entered as a manual adjustment with the Depreciation category (buried in COGS, 10-14 / review 10-20)
    const manualDepreciation = adjustmentItems.filter(a => a.included && a.category === 'Depreciation' && (a.year === 'All Years' || a.year === 'TTM'))
      .reduce((sum, a) => sum + (Number(a.amount) || 0), 0);
    const depreciation = Math.max(depreciationTTM, depreciationYear5) + manualDepreciation;
    
    // Get TTM revenue for percentage calculation
    const ttmRevenue = revenueCategories.reduce((sum, cat) => sum + (cat[selectedValuationBasis]?.ttm || cat.accrual?.ttm || 0), 0);
    const fixedAssetsPctOfRevenue = ttmRevenue > 0 ? (totalFixedAssets / ttmRevenue * 100) : 0;
    
    // Check Q&A response for CapEx question (id 25)
    const capexQA = sellerQA.find(q => q.id === 25);
    const capexAnswer = capexQA?.answer?.toLowerCase() || '';
    const capexAnswered = capexQA?.status === 'answered';
    
    // Detection triggers
    const hasSignificantFixedAssets = totalFixedAssets > 50000 || fixedAssetsPctOfRevenue > 15;
    const hasSignificantDepreciation = depreciation > 10000;
    const bsTrigger = hasSignificantFixedAssets || hasSignificantDepreciation;
    
    // Q&A trigger: owner says "none/nothing" but BS shows assets, OR owner lists significant items
    const ownerSaysNone = capexAnswered && (capexAnswer.includes('none') || capexAnswer.includes('nothing') || capexAnswer.includes('n/a') || capexAnswer.trim() === '');
    const discrepancyDetected = ownerSaysNone && bsTrigger;
    
    // Keywords that suggest significant CapEx items were purchased
    const capexKeywords = ['vehicle', 'truck', 'van', 'car', 'equipment', 'machinery', 'computer', 'server', 'renovation', 'improvement', 'hvac', 'roof', 'lease', 'financed'];
    const ownerListedItems = capexKeywords.some(kw => capexAnswer.includes(kw));
    
    // Flag if: (BS shows significant assets) OR (owner listed items) OR (discrepancy between BS and answer)
    // Resolved by the decision itself (review 10-20): a Maintenance CapEx / CapEx adjustment on the deal clears the flag.
    const capexDecided = adjustmentItems.some(a => a.included && (a.category === 'Maintenance CapEx' || a.plLine === 'CapEx') && (Number(a.amount) || 0) > 0);
    const capexInvestigationNeeded = (bsTrigger || ownerListedItems || discrepancyDetected) && !acknowledgedFlags['capex-investigation'] && !capexDecided;
    
    if (capexInvestigationNeeded) {
      let detail = '';
      let severity = 'warning';
      
      if (discrepancyDetected) {
        detail = `Owner reported no major purchases, but Balance Sheet shows $${totalFixedAssets.toLocaleString()} in Fixed Assets and $${depreciation.toLocaleString()} depreciation - investigate discrepancy`;
        severity = 'critical';
      } else if (ownerListedItems) {
        detail = `Owner reported equipment/vehicle purchases - send CapEx Verification Form to document details for potential maintenance CapEx adjustment`;
      } else if (bsTrigger) {
        detail = `Fixed Assets: $${totalFixedAssets.toLocaleString()} (${fixedAssetsPctOfRevenue.toFixed(1)}% of revenue), Depreciation: $${depreciation.toLocaleString()}/year - may require maintenance CapEx adjustment`;
      }
      
      flags.push({
        key: 'capex-investigation',
        category: 'CapEx Analysis',
        severity,
        item: 'CapEx Investigation Required',
        detail,
        action: 'Send CapEx Verification Form, reconcile to Balance Sheet, determine maintenance CapEx adjustment',
        canResolveAt: 'WC & CapEx tab → CapEx Investigation section',
        resolveTab: 'wcanalysis'
      });
    }

    // Customer Revenue Spike Detection (mirrors keyMetrics spike logic)
    // Flags when a single customer's revenue spike drives >25% of total company growth AND customer grew >100%
    const safeCustDataForSpike = customerSalesData || [];
    if (safeCustDataForSpike.length > 0) {
      const y5TotalSpk = safeCustDataForSpike.reduce((s, c) => s + (c.year5 || 0), 0);
      const ttmTotalSpk = safeCustDataForSpike.reduce((s, c) => s + (c.ttm || 0), 0);
      const y4TotalSpk = safeCustDataForSpike.reduce((s, c) => s + (c.year4 || 0), 0);
      const ttmEqY5Spk = y5TotalSpk > 0 && ttmTotalSpk > 0 && 
        (Math.abs(y5TotalSpk - ttmTotalSpk) / Math.max(y5TotalSpk, ttmTotalSpk) < 0.05 || y5TotalSpk === ttmTotalSpk);
      const spkPriorKey = ttmEqY5Spk ? 'year4' : 'year5';
      const spkCurrentKey = ttmEqY5Spk ? 'year5' : 'ttm';
      const spkCurrentTotal = safeCustDataForSpike.reduce((s, c) => s + (c[spkCurrentKey] || 0), 0);
      const spkPriorTotal = safeCustDataForSpike.reduce((s, c) => s + (c[spkPriorKey] || 0), 0);
      const spkCompanyGrowth = spkCurrentTotal - spkPriorTotal;
      
      if (spkCompanyGrowth > 0) {
        safeCustDataForSpike.forEach(c => {
          const spkCurr = c[spkCurrentKey] || 0;
          const spkPri = c[spkPriorKey] || 0;
          const spkCustGrowth = spkCurr - spkPri;
          const spkCustGrowthPct = spkPri > 0 ? ((spkCurr - spkPri) / spkPri) * 100 : (spkCurr > 0 ? 999 : 0);
          const spkShareOfGrowth = spkCompanyGrowth > 0 ? (spkCustGrowth / spkCompanyGrowth) * 100 : 0;
          
          if (spkShareOfGrowth > 25 && spkCustGrowthPct > 100 && spkCustGrowth > 10000) {
            flags.push({
              key: 'customer-spike-' + (c.name || 'unknown').replace(/\s+/g, '-').toLowerCase(),
              category: 'Revenue Analysis',
              severity: 'critical',
              item: 'Customer Revenue Spike: ' + (c.name || 'Unknown'),
              detail: '$' + (spkPri/1000).toFixed(0) + 'K → $' + (spkCurr/1000).toFixed(0) + 'K (' + (spkCustGrowthPct > 500 ? '>500' : spkCustGrowthPct.toFixed(0)) + '% growth) — drives ' + spkShareOfGrowth.toFixed(0) + '% of total revenue growth',
              action: 'Verify spike sustainability — is this a one-time project/hardware sale or recurring growth? Review contract status.',
              canResolveAt: 'Multiple Engine → Revenue Quality section',
              resolveTab: 'multipleengine'
            });
          }
        });
      }
    }

    // Separate acknowledged vs unacknowledged
    // ── VWTC LESSONS (Mark 09-28; buyer QoE on VWTC came in $234k below VT, all of it
    // owner-replacement cost). Each is a prompt, never an automatic charge, and each
    // is WAIVABLE WITH A WRITTEN REASON (acknowledgeFlag) — a small business's owner
    // wears many hats, and so may an individual buyer. Business size rides the text.
    {
      const qa = (id) => (sellerQA || []).find(q => q.id === id);
      const ttmRev = revenueCategories.reduce((sum, cat) => sum + (cat[selectedValuationBasis]?.ttm || cat.accrual?.ttm || 0), 0);
      const sizeNote = ttmRev > 0 ? ` (TTM revenue ~$${Math.round(ttmRev / 1000).toLocaleString()}k)` : '';
      const roles = Array.isArray(ownerCompensation?.replacementRoles) ? ownerCompensation.replacementRoles.filter(r => r && (Number(r.salary) || 0) > 0) : [];
      // ⓪ Payroll tax caps per person (Mark 10-23, Arakyta: 3 owners, 3 hires): above the wage base, the head count
      // changes the employer-tax adjustment. Ask once; entering the count (even 1) or splitting into roles clears it.
      if (payrollTaxMethod !== 'flat' && ownerCompensation?.includePayrollTax !== false) {
        const wb = ssWageBase(monthlyTtmConfig.endYear);
        const ownPay = ownerCompensation?.ttm?.salary || (ownerCompensation?.embeddedInWages ? (ownerCompensation?.year5?.salary || 0) : 0);
        const needOwners = ownPay > wb && ownerCompensation?.ownerCount == null;
        const needRep = (Number(ownerCompensation?.marketReplacement) || 0) > wb && !roles.length && ownerCompensation?.replacementCount == null;
        if (needOwners || needRep) flags.push({
          key: 'owner-payroll-tax-people', category: 'Owner Compensation', severity: 'warning',
          item: 'Payroll tax: how many people do the owner salary and the replacement cover?',
          detail: 'Social Security tax stops at $' + wb.toLocaleString() + ' per person. ' + (needOwners ? 'The owner salary ($' + Math.round(ownPay).toLocaleString() + ') is above that: one owner or several? ' : '') + (needRep ? 'The replacement ($' + Math.round(Number(ownerCompensation.marketReplacement)).toLocaleString() + ') is above it: one hire or several?' : ''),
          action: 'Owner comp → payroll tax box: enter "People in the owner salary" and "People the replacement covers" (or split the replacement into roles). Enter 1 if it is one person.',
          canResolveAt: 'Adjustments tab → Owner section → payroll tax box', resolveTab: 'adjustments', waivable: false,
        });
      }
      // ② Billable owner → a second replacement role.
      const rolesText = [qa(16)?.answer, qa(15)?.answer, ownerCompensation?.marketReplacementNotes].filter(Boolean).join(' ');
      if (/\b(bill(s|ed|able|ing)?\b|technician|tech work|engineer|field work|installs?|service calls?|hands[- ]on|on[- ]site|does the work|billable)/i.test(rolesText) && roles.length < 2) {
        flags.push({
          key: 'owner-billable-two-roles', category: 'Owner Compensation', severity: 'warning',
          item: 'Owner appears to do billable work — one replacement salary may be light',
          detail: `The owner answers mention billable / hands-on work${sizeNote}. A buyer may need two hires: a manager AND a billable tech (VWTC's QoE charged the second role).`,
          action: 'Owner comp → + Add a role for the second role (benefits the way you handle them for this company) — or waive with a reason (e.g. "small business; an owner-operator buyer does both").',
          canResolveAt: 'Adjustments tab → Owner section → Replacement roles', resolveTab: 'adjustments', waivable: true,
        });
      }
      // ③ Concentration can't be judged without a customer list.
      const hasCustomers = [customerSalesData, customerSalesCash, customerSalesAccrual].some(list => (list || []).some(c => (c?.ttm || 0) > 0));
      if (ttmRev >= 1000000 && !hasCustomers) {
        flags.push({
          key: 'concentration-no-customers', category: 'Customer Concentration', severity: 'critical',
          item: 'No customer list on a $1M+ business — concentration is unknown',
          detail: `TTM revenue ~$${Math.round(ttmRev / 1000).toLocaleString()}k and no customer sales rows entered. A buyer's first diligence question; the value can't be defended without it.`,
          action: 'Get the Sales by Customer report and paste it (Revenue → Customers) — or waive with a reason (e.g. "retail walk-in trade, no customer ledger exists").',
          canResolveAt: 'Revenue tab → Customers', resolveTab: 'revenue', waivable: true,
        });
      }
      // ④ Tie owner add-backs to payroll person by person.
      // Real multi-owner / family payroll only (a comma or "and" in the answer fired on 16 of 42 deals):
      // two+ ownership percentages in Q2, or "yes" to family working in the business (Q12).
      const multiOwner = (String(qa(2)?.answer || '').match(/\d{1,3}\s*%/g) || []).length >= 2 || /^\s*yes/i.test(String(qa(12)?.answer || ''));
      if ((ownerCompensation?.ttm?.salary || 0) > 0 && multiOwner) {
        flags.push({
          key: 'owner-payroll-by-person', category: 'Owner Compensation', severity: 'info',
          item: 'Tie owner / family add-backs to the payroll report by person',
          detail: 'More than one owner or family member on payroll. On VWTC the add-backs tied to the QoE payroll database to the dollar only when matched name by name — that is what makes them hold up in diligence.',
          action: 'Match each person\'s add-back to their payroll-report line and note the source — or waive with a reason.',
          canResolveAt: 'Adjustments tab → Owner section', resolveTab: 'adjustments', waivable: true,
        });
      }
      // ⑤ Owner hours above a normal work week.
      const hrs = Number(qa(15)?.numericValue) || (() => { const m = String(qa(15)?.answer || '').match(/(\d{2,3})\s*(\+|plus)?\s*(hrs?|hours)/i); return m ? Number(m[1]) : 0; })();
      if (hrs > 50) {
        flags.push({
          key: 'owner-hours-above-normal', category: 'Owner Compensation', severity: 'warning',
          item: `Owner works ~${hrs} hrs/week — above a normal 40–50`,
          detail: `A replacement hired at 40–50 hours won't cover ${hrs}${sizeNote}. VWTC's QoE priced the extra hours into the replacement.`,
          action: 'Raise the replacement (Owner comp — adjust a role\'s salary or + Add a role) — or waive with a reason (e.g. "small business; buyer will be an owner-operator").',
          canResolveAt: 'Adjustments tab → Owner section', resolveTab: 'adjustments', waivable: true,
        });
      }
    }
    // ── Cash vs accrual customer names don't line up (Mark 09-30, Concise Computer: the owner's two
    // exports numbered customers independently — "CUSTOMER 128" in cash was "CUSTOMER 126" in accrual —
    // so every name-joined field (client detail, contract terms) landed on the wrong company). Detect by
    // AMOUNTS: a big customer whose 5-year total appears in the other report under a different name.
    {
      const cashL = customerSalesCash || [], accL = customerSalesAccrual || [];
      // Only NUMBERED exports ("CUSTOMER 128", "Client #12"): a number can't be trusted across two files.
      // Real names aren't flagged — equal totals are common (customers on identical contracts).
      const numbered = (L) => L.length > 0 && L.filter(r => /^(customer|client|cust|account)\s*#?\s*\d+\s*$/i.test(String(r.name || '').trim())).length / L.length >= 0.8;
      if (numbered(cashL) && numbered(accL)) {
        const yrs = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
        const total = (r) => yrs.reduce((s, k) => s + (Number(r[k]) || 0), 0);
        const nm = (r) => String(r.name || '').trim().toLowerCase();
        const cashTotals = cashL.map(r => ({ n: nm(r), t: total(r) })).filter(x => x.t > 0);
        const bigAcc = accL.filter(r => total(r) > 0).sort((a, b) => total(b) - total(a)).slice(0, 15);
        const close = (x, y) => Math.abs(x - y) / Math.max(x, y) <= 0.02;
        // Renamed = no same-named cash row with this amount, but a differently-named one has it — and that
        // one isn't simply its own customer (its name isn't in accrual at the same amount). The last test
        // stops customers on identical contracts (equal totals) from looking like renames.
        const accTotals = accL.map(r => ({ n: nm(r), t: total(r) }));
        const renamed = bigAcc.filter(a => {
          const t = total(a);
          if (cashTotals.some(c => c.n === nm(a) && close(c.t, t))) return false;
          return cashTotals.some(c => c.n !== nm(a) && close(c.t, t) && !accTotals.some(x => x.n === c.n && close(x.t, c.t)));
        });
        if (renamed.length >= 2) {
          const eg = renamed.slice(0, 2).map(a => {
            const t = total(a);
            const twin = cashL.find(c => Math.abs(total(c) - t) / Math.max(total(c), t) <= 0.02);
            return `"${a.name}" (accrual) = "${twin ? twin.name : '?'}" (cash)`;
          }).join('; ');
          flags.push({
            key: 'sales-names-mismatch', category: 'Customer Sales', severity: 'critical',
            item: `Cash and accrual customer reports name the same customers differently (${renamed.length} of the top 15)`,
            detail: `Same amounts, different names — e.g. ${eg}. Numbered exports ("CUSTOMER N") are usually numbered separately per report. Client detail and contract terms join by NAME, so they land on the wrong company.`,
            action: 'Ask the owner for both reports with real names or their customer IDs (VT anonymizes for the CIM), and re-load — before entering client detail.',
            canResolveAt: 'Sales tab → customer reports', resolveTab: 'salesanalysis', waivable: true,
          });
        }
      }
    }
    // ── The same customer on more than one row of the report the valuation runs on (Mark 09-30, found on
    // MB Technology's accrual report: NCI Group ×3). Concentration reads rows, so a split customer looks
    // smaller than it is. Only names where 2+ rows carry sales count (a $0 duplicate is harmless).
    {
      const grid = customerSalesData || [];
      const yrs = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
      const hasSales = (r) => yrs.some(k => (Number(r[k]) || 0) !== 0);
      const groups = new Map();
      grid.forEach(r => { const k = String(r.name || '').trim().toLowerCase(); if (k) (groups.get(k) || groups.set(k, []).get(k)).push(r); });
      const dups = [...groups.values()].filter(g => g.filter(hasSales).length > 1)
        .map(g => ({ name: String(g[0].name).trim(), n: g.length, ttm: g.reduce((s, r) => s + (Number(r.ttm) || 0), 0) }))
        .sort((a, b) => b.ttm - a.ttm);
      if (dups.length) {
        flags.push({
          key: 'sales-duplicate-names', category: 'Customer Sales', severity: 'warning',
          item: `${dups.length} customer${dups.length > 1 ? 's appear' : ' appears'} on more than one row of the sales report`,
          detail: dups.slice(0, 3).map(d => `${d.name} ×${d.n}`).join(' · ') + (dups.length > 3 ? ` · +${dups.length - 3} more` : '') + '. Concentration counts rows, so a split customer looks smaller than it is.',
          action: 'Merge each customer into one row (add the rows together), or confirm they really are different customers and acknowledge.',
          canResolveAt: 'Sales tab → customer report', resolveTab: 'salesanalysis', waivable: true,
        });
      }
    }
    // ── Positions in the period (Zac 09-29, Midwest H&C). Q10 shows hiring or departures but
    // nobody said whether any role is net new / vacated → prompt; rows not yet in Adjustments → prompt.
    {
      const q10 = (sellerQA || []).find(q => q.id === 10);
      const rows = Array.isArray(q10?.positions) ? q10.positions : [];
      const txt = String(q10?.answer || '');
      // A "no change" answer is not a hiring signal (Concise 10-02: "Nobody joined nor left" fired on "joined").
      const noChange = /\b(nobody|no one|no-one|no new|no (changes?|turnover|hires?)|none|stayed the same|unchanged|same team|hasn'?t changed|no one (joined|left))\b/i.test(txt);
      const signal = (!noChange && /\b(hire[sd]?|hiring|joined|new (roles?|positions?|hires?|employees?)|added|brought on|onboarded)\b/i.test(txt)) || (Number(q10?.numericValue2) || 0) > 0;
      if (signal && rows.length === 0) {
        flags.push({
          key: 'positions-in-period', category: 'Adjustments', severity: 'warning',
          item: 'Q10 shows hiring or turnover — any net-new or vacated positions?',
          detail: `Q10: "${txt.slice(0, 160) || ((q10?.numericValue2 || 0) + ' departures')}". A net-new hire with only part of a year on the P&L understates go-forward expense; a buyer flagged exactly this on Midwest H&C.`,
          action: 'Discovery → Q10 → 👥 Positions: one row per net-new or vacated role (pay, months on the P&L) → ＋ Create adjustment. All replacements? Acknowledge.',
          canResolveAt: 'Discovery tab → Q10', resolveTab: 'discovery', waivable: true,
        });
      }
      const pending = rows.filter(r => r.kind !== 'replacement' && positionAdjAmount(r) > 0 && !(adjustmentItems || []).some(a => a.id === r.adjId && a.amount === positionAdjAmount(r) && a.year === r.year));
      if (pending.length) {
        flags.push({
          key: 'positions-not-adjusted', category: 'Adjustments', severity: 'warning',
          item: `${pending.length} position${pending.length > 1 ? 's' : ''} in Q10 not yet in Adjustments`,
          detail: pending.map(r => `${r.role || 'Unnamed'} (${r.kind === 'new' ? 'net new' : 'vacated'}, ${r.year})`).join(' · '),
          action: 'Discovery → Q10 → 👥 Positions → ＋ Create / ⟳ Update adjustment.',
          canResolveAt: 'Discovery tab → Q10', resolveTab: 'discovery', waivable: true,
        });
      }
    }
    const unacknowledgedFlags = flags.filter(f => !acknowledgedFlags[f.key]);
    const acknowledgedFlagsList = flags.filter(f => acknowledgedFlags[f.key]).map(f => ({...f, ...acknowledgedFlags[f.key]}));

    return {
      flags,
      unacknowledgedFlags,
      acknowledgedFlagsList,
      criticalCount: unacknowledgedFlags.filter(f => f.severity === 'critical').length,
      warningCount: unacknowledgedFlags.filter(f => f.severity === 'warning').length,
      infoCount: unacknowledgedFlags.filter(f => f.severity === 'info').length,
      acknowledgedCount: acknowledgedFlagsList.length,
      documentsReceived: documentChecklist.filter(d => d.status === 'complete').length,
      documentsTotal: documentChecklist.length,
      qaAnswered: sellerQA.filter(qa => qa.status === 'answered').length,
      qaTotal: sellerQA.length
    };
  }, [adjustmentItems, documentChecklist, sellerQA, opexCategories, bsCurrentAssets, bsFixedAssets, bsOtherAssets, bsCurrentLiabilities, bsLongTermLiabilities, bsEquity, bsYearLabels, balanceSheetCalcs, researchItems, acknowledgedFlags, revenueCategories, cogsCategories, valuationBasis, revenueStreams, ownerCompensation, basisYearLabels, bsRecognitionNotes, bsIssueNotes, customerSalesData, customerYearLabels, custRevenueNotes, arAgingCalcs, arAgingData, arReviewChecklist, arAgingBucketLabels, selectedValuationBasis, manualReviewFlags, monthlyTtmNotes, arAgingNotes, salesDetailNotes, otherIncomeCategories, otherExpenseCategories, reconQualityChecklist, incomeVarianceStatus, taxFilingBasis, taxReturnTotals, varianceThreshold, reconMaterialityThreshold, monthlyTtmConfig, ttmLabel, diatCategories, customerSalesCash, customerSalesAccrual, payrollTaxMethod]);

  // Unpicked industry: math falls back to the FIRST profile (it-msp) so the
  // engine never NaNs — identical numbers to the old silent default, but
  // the blob now stores '' so the mint/DM/CIM all KNOW nobody picked
  // (08-27 force-a-pick; the Setup banner + CIM block carry the warning).
  const currentBenchmarks = useMemo(() => industryBenchmarks.find(i => i.id === selectedIndustry)?.benchmarks || industryBenchmarks[0].benchmarks, [selectedIndustry, industryBenchmarks]);

  // Get current section name for Quick Note auto-tagging
  const currentSectionName = useMemo(() => {
    const sectionMap = {
      'summary': 'Summary',
      'plentry': 'Data Entry → P&L Entry',
      'ttmmonthly': 'Data Entry → TTM P&L',
      'accrualpl': 'Data Entry → Accrual P&L',
      'cashpl': 'Data Entry → Cash P&L',
      'taxreturns': 'Data Entry → Tax Returns',
      'balancesheet': 'Data Entry → Balance Sheet',
      'adjustments': 'Data Entry → Adjustments',
      'revenueanalysis': 'Data Entry → Rev & COGS',
      'analysis': `Analysis → Income Statement (${incomeStmtViewMode === 'full' ? 'Full' : incomeStmtViewMode === 'actuals' ? 'Actuals' : incomeStmtViewMode === 'normalized' ? 'Normalized' : 'Monthly'})`,
      'bsanalysis': 'Analysis → Balance Sheet',
      'reconciliation': 'Analysis → Reconciliation',
      'discovery': 'Discovery',
      'outstanding': 'Open Items',
      'benchmarks': 'Benchmarks',
      'valuation': 'Valuation',
      'sales': 'Sales & Customer Analysis',
      'presentation': 'Presentation'
    };
    return sectionMap[viewMode] || viewMode;
  }, [viewMode, incomeStmtViewMode]);

  // Keyboard shortcut for Quick Note (Ctrl+Q)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'q') {
        e.preventDefault();
        setShowQuickNote(prev => !prev);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // ========== INDUSTRY MULTIPLE ADJUSTMENT (AUTO-SET) ==========
  // Now reads from industrySectors data structure - adjustment is part of each industry
  useEffect(() => {
    if (selectedIndustryObj) {
      // Grandfathered valuations keep the adjustment they were presented with (Zac 10-08 — e.g. IT Development).
      const legacyAdj = revenueScoringMode === 'legacy' && selectedIndustryObj.adjustmentLegacy != null ? selectedIndustryObj.adjustmentLegacy : null;
      setIndustryMultipleAdjustment(legacyAdj != null ? legacyAdj : (selectedIndustryObj.adjustment || 0));
    }
  }, [selectedIndustry, selectedIndustryObj, revenueScoringMode]);
  
  // When sector changes, auto-select first industry in that sector
  // Only resets if the current industry genuinely doesn't exist in the new sector
  // AND doesn't exist in any other sector (i.e. it's a stale/unknown ID).
  // This prevents clobbering valid industries during the load sequence where
  // sector is set first and industry follows via setTimeout.
  useEffect(() => {
    const sector = industrySectors.find(s => s.id === selectedSector);
    if (sector && sector.industries.length > 0) {
      const currentInSector = sector.industries.find(i => i.id === selectedIndustry);
      if (!currentInSector) {
        // Only reset if this industry ID doesn't exist anywhere in the industry list
        // (truly unknown ID). If it exists in another sector, the user or load path
        // will reconcile the sector separately — don't overwrite a valid industry.
        const existsAnywhere = industrySectors.some(s => s.industries.some(i => i.id === selectedIndustry));
        if (!existsAnywhere) {
          setSelectedIndustry(sector.industries[0].id);
        }
      }
    }
  }, [selectedSector]);

  // ========== LOCATION MULTIPLE ADJUSTMENT ==========
  // Location impact scales inversely with EBITDA size
  // Larger businesses care less about location (national buyer pool)
  const locationTypeAdjustments = {
    'major_metro': 0.25,    // Top 25 MSA, 1M+ population - more buyers, growth potential
    'suburban': 0,          // Suburban metro or mid-size city - baseline
    'small_city': -0.25,    // 50K-250K population - limited buyer pool
    'rural': -0.5           // Under 50K - significant buyer limitation
  };
  
  const locationTypeLabels = {
    'major_metro': 'Major Metro (Top 25 MSA, 1M+ pop)',
    'suburban': 'Suburban / Mid-size City (250K-1M)',
    'small_city': 'Small City (50K-250K)',
    'rural': 'Rural (Under 50K)'
  };
  
  // US States for dropdown
  const usStates = [
    { code: '', name: 'Select State' },
    { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }, { code: 'DC', name: 'Washington DC' }
  ];

  // Canadian provinces/territories for dropdown
  const canadianProvinces = [
    { code: 'AB', name: 'Alberta' }, { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' }, { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' }, { code: 'NS', name: 'Nova Scotia' },
    { code: 'NT', name: 'Northwest Territories' }, { code: 'NU', name: 'Nunavut' },
    { code: 'ON', name: 'Ontario' }, { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' }, { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon' }
  ];

  // ========== MULTIPLE ENGINE STATE ==========
  const [multipleAdjustments, setMultipleAdjustments] = useState({
    revenueQuality: { useWeightedCalculation: true, monthlyReviewed: false, monthlyManualAdjustment: 0,
      // Customer type quality (B2B vs Residential) - B2B is baseline, residential has higher churn
      customerType: 'b2b_only', // 'b2b_only', 'b2b_majority', 'mixed', 'residential_majority', 'residential_only'
      customerTypeNotes: ''
    },
    ebitdaQuality: { monthlyReviewed: false, monthlyManualAdjustment: 0, negativeMonthsReviewed: false, negativeMonthsOverride: null, negativeMonthsNotes: '' },
    customerRetention: { 
      year1: { retentionRate: 0, verified: false },
      year2: { retentionRate: 0, verified: false },
      year3: { retentionRate: 0, verified: false },
      avgRetentionRate: 0,
      notes: '' 
    },
    clientChurn: {
      ttmLostClientRevenue: 0,
      ttmNewClientRevenue: 0,
      ttmPriorRevenue: 0,
      verified: false,
      notes: ''
    },
    contractTerms: { avgContractLength: 0, transferability: 'unknown', hasInflationClauses: false, hasExitClauses: false, 
      // NEW: Contract quality details - calibrated from Company C (5% escalators) vs Company B (M2M)
      hasAutoRenewal: false,
      hasPriceEscalators: false,
      escalatorPercent: 0,
      hasEarlyTermPenalty: false,
      notes: '' 
    },
    concentration: { topCustomerPct: 0, top5CustomersPct: 0, topVendorPct: 0, vendorNotes: '',
      clientIndustries: [],
      industryConcentrationAdjustment: 0, industryConcentrationNotes: '',
      // NEW: Client diversification - calibrated from Company A (242 clients) vs Company B (40)
      totalClientCount: 0,
      // NEW: Top customer contract status - calibrated from Company B (21% M2M = bad) vs Company A (22% contracted = ok)
      topCustomerContracted: 'unknown' // 'unknown', 'mtm', 'annual', 'multi_year'
    },
    // Owner continuity - simplified (owners staying = premium)
    ownerTransition: {
      ownersStaying: 'unknown', // 'yes', 'no', 'unknown'
      notes: ''
    },
    // Owner dependency - how critical is owner to operations and revenue
    ownerDependency: {
      involvementLevel: 'unknown', // 'board', 'management', 'operations', 'primary_revenue', 'sole_revenue'
      hoursPerWeek: null,
      revenueGenerationPct: null,
      manualAdjustment: 0, // reviewer override (±), additive on top of auto score, final bounded ±1.50
      notes: ''
    },
    // Other adjustments - for unusual/rare situations
    otherAdjustments: [],  // Array of { id, description, adjustment, notes }
    // A/R & Collections Quality (factor G) overrides
    workingCapitalQuality: {
      arPastDueOverride: null,      // null = use auto, number = override
      arPastDueNotes: '',
      arPastDueReviewed: false,
      arSeriousOverride: null,
      arSeriousNotes: '',
      arSeriousReviewed: false,
      negativeBalancesOverride: null,
      negativeBalancesNotes: '',
      negativeBalancesReviewed: false
    },
    // Franchise Information
    franchise: {
      isFranchise: false,
      franchiseName: '',
      royaltyRate: 0,           // % of revenue
      marketingFundRate: 0,     // % of revenue
      transferFee: 0,           // one-time dollar amount
      remainingTermYears: null, // years left on franchise agreement
      franchisorApproval: false, // buyer must be approved
      territoryExclusive: false, // exclusive territory
      territoryNotes: '',
      notes: ''
    }
  });

  const [expandedSections, setExpandedSections] = useState({ sizeFactor: false, industryFactor: false, locationFactor: false, marketFactor: false, revenueQuality: false, ebitdaQuality: false, customerRetention: false, contractTerms: false, concentration: false, ownerTransition: false, ownerDependency: false, otherAdjustments: false, workingCapital: false, franchise: false, lineAddbacks: false, overviewDiscovery: true, overviewResolved: false });

  // ========== FILE INPUT REF ==========
  const fileInputRef = useRef(null);

  // ========== CHECKLIST SYNC TO TABLE (Stage A) ==========
  // Mirrors the in-memory documentChecklist to the normalized
  // engagement_checklist_items table whenever a valuation is saved to
  // Supabase. The JSONB blob in valuations.data remains the source of
  // truth for VT itself; the table is a queryable projection for the
  // new dashboard. Errors are non-fatal — a sync failure must not block
  // the user's save.
  const syncChecklistToTable = async (valuationId) => {
    if (isReadOnlyViewer) return; // read-only viewers never write the checklist table
    if (!supabaseClient || !valuationId || !Array.isArray(documentChecklist) || documentChecklist.length === 0) return;
    try {
      const parseProvidedDate = (s) => {
        if (!s) return null;
        const t = String(s).trim();
        if (!t) return null;
        if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t;
        const us = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
        if (us) {
          let [, m, d, y] = us;
          if (y.length === 2) y = '20' + y;
          return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        const dt = new Date(t);
        return isNaN(dt.getTime()) ? null : dt.toISOString().slice(0, 10);
      };
      const rows = documentChecklist.map((d, i) => ({
        engagement_id: valuationId,
        item_key: String(d.id),
        display_name: d.name,
        tier: d.tier === 'minimum' ? 'minimum' : 'full',
        // EXPLICIT STATUS WINS (Forward Slash 08-21: the imported January-era
        // JSON carried the legacy `received: true` boolean on every item; the
        // revalue reset `status` but not that flag, and this OR made every
        // not_received/partial item sync as complete — the owner portal
        // "filed" the four docs Konnie had just asked for and asked for
        // nothing). The legacy boolean is a fallback ONLY when no status exists.
        status: d.status === 'complete'  ? 'complete'
              : d.status === 'partial'   ? 'partial'
              : d.status === 'requested' ? 'requested'
              : d.status                 ? 'not_received'
              : d.received === true      ? 'complete'
              : 'not_received',
        date_received: parseProvidedDate(d.dateProvided),
        notes: d.notes || null,
        // Partial "Have"/"Need" breakdown → the owner portal reads these to show
        // a partial item on its "Still needed" list with what's in vs. still owed
        // (migration 025). Only meaningful when status === 'partial'.
        received_notes: d.receivedNotes || null,
        pending_notes: d.pendingNotes || null,
        planned: d.planned === true,
        sort_order: i,
        updated_at: new Date().toISOString(),
      }));
      const { error } = await supabaseClient
        .from('engagement_checklist_items')
        .upsert(rows, { onConflict: 'engagement_id,item_key' });
      if (error) throw error;
    } catch (err) {
      // Intentionally non-fatal — checklist sync failures must never
      // break the primary save path. Logged for diagnostics only.
      console.warn('Checklist sync to engagement_checklist_items failed:', err);
    }
  };

  // ========== ACTIVITY LOG INSERT (Stage A) ==========
  // Records a structured event on a project. Used by the activity log
  // composer (Konnie's freeform notes), and by automatic system events
  // (stage changes, document received via Stage C ingestion, etc.).
  const logActivity = async (projectId, kind, note = null, metadata = null) => {
    if (isReadOnlyViewer) return; // read-only viewers don't write activity rows
    if (!supabaseClient || !projectId || !kind) return;
    try {
      const row = {
        project_id: projectId,
        actor_email: userEmail || 'unknown',
        actor_name: userEmail ? userEmail.split('@')[0] : null,
        kind,
        note,
        metadata,
      };
      const { error } = await supabaseClient.from('project_activity_log').insert(row);
      if (error) throw error;
    } catch (err) {
      console.warn('Activity log insert failed:', err);
    }
  };

  // ========== SAVE/LOAD FUNCTIONS ==========
  const saveDeal = async (options = {}) => {
    if (isReadOnlyViewer) return; // read-only viewers (AMs) can't persist or export
    // ONE payload builder for both save paths (Mark 09-28 — the drift class:
    // three incidents where a key lived in one path and not the other, so the
    // 60s autosave silently stripped what a manual Save had written). Add new
    // persisted state to buildDealData() ONLY; the paths add just their own
    // timestamp (+ calculatedValues, which only the manual Save computes).
    const dealData = {
      ...buildDealData(),
      savedAt: new Date().toISOString(),
      calculatedValues: {
        ttmRevenue: calculations?.years?.[5]?.revenue || 0,
        ttmEbitda: calculations?.years?.[5]?.ebitda || 0,
        ttmAdjustedEbitda: calculations?.years?.[5]?.adjustedEbitda || 0,
        // This is the actual EBITDA used for valuation (may be weighted/averaged)
        valuationMetric: calculations?.valuation?.metric || 0,
        valuationMin: calculations?.valuation?.valuationMin || 0,
        valuationMax: calculations?.valuation?.valuationMax || 0,
        valuationMid: calculations?.valuation?.valuationMid || 0,
        weightingMethod: valuationInputs?.weightingMethod || 'ttm',
        // Multiple Engine calculated values (for Portfolio Consolidation)
        // These are the actual engine-computed multiples, NOT the manual valuationInputs
        multipleEngine: {
          // The EBITDA actually used by the engine (may be pro-forma adjusted)
          adjustedEbitda: multipleEngineCalcs?.adjustedEbitda || 0,
          // Raw base multiple from EBITDA size lookup (no adjustments)
          rawBaseMultiple: multipleEngineCalcs?.rawBaseMultiple || 3.0,
          // Base multiple = rawBase + industry + location + market condition
          baseMultiple: multipleEngineCalcs?.baseMultiple || 3.0,
          // Total quality factor adjustments (A through G factors)
          totalAdjustment: multipleEngineCalcs?.totalAdjustment || 0,
          // Final calculated multiple = baseMultiple + totalAdjustment
          adjustedMultiple: multipleEngineCalcs?.adjustedMultiple || 3.0,
          // Typical (85% of market high) and Market High multiples
          typicalMultiple: multipleEngineCalcs?.typicalMultiple || 2.55,
          marketHighMultiple: multipleEngineCalcs?.marketHighMultiple || 3.0,
          // Valuation outputs
          valuationTypical: multipleEngineCalcs?.valuationTypical || 0,
          valuationMarketHigh: multipleEngineCalcs?.valuationMarketHigh || 0,
          // Location adjustment detail (for transparency)
          scaledLocationAdj: multipleEngineCalcs?.scaledLocationAdj || 0
        }
      },
    };
    
    // Log what we're saving for debugging
    console.log('Saving calculatedValues:', dealData.calculatedValues);
    console.log('Saving multipleEngine:', dealData.calculatedValues?.multipleEngine);

    // ── Q&A data-loss guard (2026-07-02) — MIRRORED in the autosave; keep in sync ──
    // See the autosave copy for the full rationale: refuse to overwrite a saved,
    // non-empty discovery Q&A with a blank one (this wiped Netdemics + Mayfront on
    // a revalue). Clear Deal bypasses via suppressQAGuardRef; re-read cached per-deal.
    {
      const qaAnswered = Array.isArray(dealData.sellerQA)
        ? dealData.sellerQA.filter(q => q && String(q.answer || '').trim()).length : 0;
      if (qaAnswered > 0) {
        qaGuardEmptyOkRef.current = null;
      } else if (suppressQAGuardRef.current) {
        suppressQAGuardRef.current = false;
      } else if (cloudMode && currentValuationId && supabaseClient
                 && qaGuardEmptyOkRef.current !== currentValuationId) {
        try {
          const { data: guardRow } = await supabaseClient
            .from('valuations').select('data').eq('id', currentValuationId).single();
          const dbQA = guardRow && guardRow.data && guardRow.data.sellerQA;
          const dbAnswered = Array.isArray(dbQA)
            ? dbQA.filter(q => q && String(q.answer || '').trim()).length : 0;
          if (dbAnswered > 0) {
            console.warn('[save-guard] Preserved ' + dbAnswered + ' saved Q&A answers — refused to overwrite with a blank set (saveDeal).');
            dealData.sellerQA = dbQA;
            setSellerQA(dbQA);
          } else {
            qaGuardEmptyOkRef.current = currentValuationId;
          }
        } catch (guardErr) {
          console.warn('[save-guard] Q&A re-read failed; proceeding (saveDeal):', guardErr);
        }
      }
    }

    // Cloud mode: upsert to Supabase (unless explicitly forcing download)
    if (cloudMode && !options.forceDownload) {
      setAutoSaveStatus('saving');
      try {
        // VALUE DRIFT (Mark 09-21, RDS: Colleen corrected the multiple after the
        // meeting; the value on record — what the pipeline and the outcome
        // form show — stayed at the 9/9 snapshot, and nothing asked). Past the
        // valuation meeting, a manual save that finds the engine >3% away from
        // the value on record asks once (per deal + engine value) to re-lock.
        let valueDriftPatch = {};
        try {
          const stg = workflow.workflow_stage;
          if (['val_meeting_set', 'awaiting_decision', 'strategic_review_set', 'considering_followup', 'engaged'].includes(stg)) {
            const onRecord = Math.round(Number(workflow.value_provided_high) || 0);
            const engineTop = Math.round(multipleEngineCalcs?.valuationMarketHigh || 0);
            const key = `${currentValuationId}:${engineTop}`;
            if (onRecord && engineTop && Math.abs(engineTop - onRecord) / onRecord > 0.03 && valueDriftAskedRef.current !== key) {
              valueDriftAskedRef.current = key;
              if (window.confirm(`Value on record is $${onRecord.toLocaleString()} — the engine now says $${engineTop.toLocaleString()}.\n\nUpdate the value on record (and the estimated commission) to match what the owner will see?`)) {
                valueDriftPatch = {
                  value_provided_high: engineTop, value_provided_low: engineTop,
                  estimated_commission: Math.round(computeCommission(engineTop)),
                  value_provided_snapshot_at: new Date().toISOString(),
                };
                setWorkflow(w => ({ ...w, ...valueDriftPatch }));
              }
            }
          }
        } catch (_) { /* the prompt is a courtesy — the save proceeds regardless */ }
        const valuationRow = {
          name: valuationName || `${new Date().toISOString().split('T')[0]} Valuation`,
          version: 'v98-122-78',
          data: dealData,
          ...valueDriftPatch,
          updated_at: new Date().toISOString(),
          // Workflow columns (migration 004/005) — saved alongside the blob.
          ...buildWorkflowColumns()
        };
        if (currentValuationId) {
          // Conflict-detection: same pattern as auto-save — refuse to overwrite if updated_at
          // moved since load. Runs under the save lock: a Save-Now click while the
          // autosave debounce is mid-flight WAITS for it and then filters on the
          // fresh stamp instead of conflicting against our own save.
          const conflicted = await runExclusiveSave(async () => {
            let updateBuilder = supabaseClient
              .from('valuations').update(valuationRow).eq('id', currentValuationId);
            if (loadedUpdatedAtRef.current) {
              updateBuilder = updateBuilder.eq('updated_at', loadedUpdatedAtRef.current);
            }
            const { data: updRows, error: updErr } = await updateBuilder.select('updated_at');
            if (updErr) throw updErr;
            if (!updRows || updRows.length === 0) return true;
            loadedUpdatedAtRef.current = updRows[0].updated_at;
            return false;
          });
          if (conflicted) {
            setSaveConflict(true);
            setAutoSaveStatus('');
            setCloudSaveError('Save blocked: another user has saved changes to this file.');
            return;
          }
          // Mirror checklist to normalized table for the new dashboard (Stage A).
          // Non-blocking — runs after the primary save commit.
          syncChecklistToTable(currentValuationId);
        } else {
          if (!currentClient?.id) {
            throw new Error('Cannot create a new valuation without a client context.');
          }
          const { data: inserted, error: insErr } = await supabaseClient
            .from('valuations')
            .insert({ ...valuationRow, client_id: currentClient.id, created_at: new Date().toISOString() })
            .select()
            .single();
          if (insErr) throw insErr;
          if (inserted) {
            setCurrentValuationId(inserted.id);
            loadedUpdatedAtRef.current = inserted.updated_at || valuationRow.updated_at;
            // Same checklist mirror for newly created valuations.
            syncChecklistToTable(inserted.id);
          }
        }
        // Propagate Setup-tab rename to clients.company_name so ClientList search/display stay current.
        const trimmedName = dealProfile.companyName?.trim();
        const clientIdForSync = currentClient?.id || currentValuation?.client_id;
        if (trimmedName && clientIdForSync && trimmedName !== lastSyncedClientNameRef.current) {
          try {
            const { error: clientUpdErr } = await supabaseClient
              .from('clients')
              .update({ company_name: trimmedName })
              .eq('id', clientIdForSync);
            if (clientUpdErr) throw clientUpdErr;
            lastSyncedClientNameRef.current = trimmedName;
          } catch (clientErr) {
            console.warn('Client name sync failed:', clientErr);
          }
        }
        // Mirror Vista ID to clients.vista_id so a future valuation for
        // the same client picks it up automatically.
        const vistaIdToSync = (dealProfile.vistaId || '').trim();
        if (clientIdForSync && vistaIdToSync !== lastSyncedVistaIdRef.current) {
          try {
            const { error: vidErr } = await supabaseClient
              .from('clients')
              .update({ vista_id: vistaIdToSync || null })
              .eq('id', clientIdForSync);
            if (vidErr) throw vidErr;
            lastSyncedVistaIdRef.current = vistaIdToSync;
          } catch (vidSyncErr) {
            console.warn('Vista ID sync failed:', vidSyncErr);
          }
        }
        setHasUnsavedChanges(false);
        setLastAutoSave(new Date());
        setAutoSaveStatus('saved');
        setCloudSaveError('');
        setTimeout(() => setAutoSaveStatus(''), 2000);
        // Manual save succeeded — clear any localStorage backup left by a
        // previously-failed auto-save tick (cloud is now the source of truth).
        if (currentValuationId) {
          try { localStorage.removeItem(`vt_unsaved_backup_${currentValuationId}`); } catch (e) {}
        }
      } catch (err) {
        console.error('Cloud save failed:', err);
        setAutoSaveStatus('');
        setCloudSaveError(err.message || 'Save failed');
        alert('Save failed: ' + (err.message || 'unknown error'));
      }
      return;
    }

    // Local mode or explicit download: JSON file
    const json = JSON.stringify(dealData, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const fileName = dealProfile.companyName 
      ? `${dealProfile.companyName.replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().toISOString().split('T')[0]}.json`
      : `Deal_${new Date().toISOString().split('T')[0]}.json`;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    // Also save to sessionStorage so data persists on reload (local mode only)
    if (!cloudMode) {
      try {
        const autoSaveData = {
          ...dealData,
          autoSavedAt: new Date().toISOString()
        };
        sessionStorage.setItem(AUTO_SAVE_KEY, JSON.stringify(autoSaveData));
      } catch (e) {
        console.error('Failed to update sessionStorage after save:', e);
      }
    }
    
    setHasUnsavedChanges(false);
    setLastAutoSave(new Date());
  };

  // Generate CapEx Verification Form as Excel
  const generateCapExForm = () => {
    const companyName = dealProfile.companyName || 'Company';
    const wb = XLSX.utils.book_new();
    
    // ========== SHEET 1: INSTRUCTIONS ==========
    const instructionsData = [
      ['CAPITAL EXPENDITURE VERIFICATION FORM'],
      [''],
      [`Company: ${companyName}`],
      [`Date: ${new Date().toLocaleDateString()}`],
      [''],
      ['PURPOSE'],
      ['This form helps us accurately document capital expenditures (CapEx) for business valuation.'],
      ['Buyers and lenders need to understand ongoing capital requirements to maintain operations.'],
      [''],
      ['WHAT IS A CAPITAL EXPENDITURE?'],
      ['Capital expenditures are purchases of assets with a useful life greater than one year.'],
      ['Examples include:'],
      ['  • Equipment and machinery'],
      ['  • Vehicles (trucks, vans, cars used for business)'],
      ['  • Computers, servers, and IT infrastructure'],
      ['  • Leasehold improvements and renovations'],
      ['  • Furniture and fixtures (if significant)'],
      [''],
      ['NOT Capital Expenditures:'],
      ['  • Repairs and maintenance (fixing existing items)'],
      ['  • Software subscriptions (monthly SaaS fees)'],
      ['  • Supplies and consumables'],
      [''],
      ['HOW TO COMPLETE THIS FORM'],
      ["1. Sheet 'Capital Purchases' - List ALL equipment/vehicles purchased in last 3 years"],
      ["2. Sheet 'Future Needs' - List items that will need replacement in next 3-5 years"],
      ["3. Sheet 'Leased Equipment' - List any equipment you lease (not own)"],
      [''],
      ['Please be thorough - this information directly impacts valuation accuracy.'],
      ['If unsure whether something qualifies, include it with a note.'],
      [''],
      ['Questions? Contact your M&A advisor.']
    ];
    const wsInstructions = XLSX.utils.aoa_to_sheet(instructionsData);
    wsInstructions['!cols'] = [{ wch: 80 }];
    XLSX.utils.book_append_sheet(wb, wsInstructions, 'Instructions');
    
    // ========== SHEET 2: CAPITAL PURCHASES ==========
    const purchasesData = [
      ['Item Description', 'Category', 'Date Purchased', 'Purchase Price', 'Financed?', 'Monthly Payment', 'Remaining Balance', 'Expected Life (Years)', 'Notes'],
      ['Example: Box Truck', 'Vehicle', '01/15/2023', 45000, 'Yes', 850, 28000, 7, 'Financed through dealer'],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', ''],
      ['TOTAL', '', '', { t: 'n', f: 'SUM(D3:D22)' }, '', { t: 'n', f: 'SUM(F3:F22)' }, { t: 'n', f: 'SUM(G3:G22)' }, '', '']
    ];
    const wsPurchases = XLSX.utils.aoa_to_sheet(purchasesData);
    wsPurchases['!cols'] = [
      { wch: 35 }, { wch: 18 }, { wch: 14 }, { wch: 15 }, { wch: 12 }, { wch: 15 }, { wch: 16 }, { wch: 18 }, { wch: 30 }
    ];
    XLSX.utils.book_append_sheet(wb, wsPurchases, 'Capital Purchases');
    
    // ========== SHEET 3: FUTURE NEEDS ==========
    const futureData = [
      ['Item Description', 'Estimated Replacement Year', 'Estimated Cost', 'Critical to Operations?', 'Notes'],
      ['Example: Production equipment', '2026', 75000, 'Yes', 'Main CNC machine showing wear'],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['TOTAL ESTIMATED', '', { t: 'n', f: 'SUM(C3:C12)' }, '', '']
    ];
    const wsFuture = XLSX.utils.aoa_to_sheet(futureData);
    wsFuture['!cols'] = [
      { wch: 35 }, { wch: 22 }, { wch: 15 }, { wch: 20 }, { wch: 40 }
    ];
    XLSX.utils.book_append_sheet(wb, wsFuture, 'Future Needs');
    
    // ========== SHEET 4: LEASED EQUIPMENT ==========
    const leasedData = [
      ['Item Description', 'Monthly Lease Cost', 'Annual Cost', 'Lease Expiration', 'Purchase Option?', 'Purchase Price', 'Notes'],
      ['Example: Copier/Printer', 350, { t: 'n', f: 'B2*12' }, '12/31/2025', 'Yes', 2500, 'Fair market value option'],
      ['', '', { t: 'n', f: 'B3*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B4*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B5*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B6*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B7*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B8*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B9*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B10*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B11*12' }, '', '', '', ''],
      ['', '', { t: 'n', f: 'B12*12' }, '', '', '', ''],
      ['TOTAL', { t: 'n', f: 'SUM(B3:B12)' }, { t: 'n', f: 'SUM(C3:C12)' }, '', '', '', '']
    ];
    const wsLeased = XLSX.utils.aoa_to_sheet(leasedData);
    wsLeased['!cols'] = [
      { wch: 35 }, { wch: 18 }, { wch: 14 }, { wch: 16 }, { wch: 15 }, { wch: 14 }, { wch: 35 }
    ];
    XLSX.utils.book_append_sheet(wb, wsLeased, 'Leased Equipment');
    
    // ========== SHEET 5: DEPRECIATION SCHEDULE ==========
    const depData = [
      ['DEPRECIATION SCHEDULE REQUEST'],
      [''],
      ['Please attach or paste your depreciation schedule from your accountant or tax preparer.'],
      [''],
      ['This document shows all assets currently being depreciated and their book values.'],
      ['It helps us verify the capital assets owned by the business.'],
      [''],
      ['If you don\'t have a formal depreciation schedule, please list:'],
      ['  • All major equipment currently owned'],
      ['  • Approximate purchase date'],
      ['  • Original cost'],
      ['  • Estimated remaining useful life'],
      [''],
      ['You can paste or type information below:'],
      [''],
      [''],
      [''],
      [''],
      [''],
      ['']
    ];
    const wsDepreciation = XLSX.utils.aoa_to_sheet(depData);
    wsDepreciation['!cols'] = [{ wch: 80 }];
    XLSX.utils.book_append_sheet(wb, wsDepreciation, 'Depreciation Schedule');
    
    // Generate filename and download
    const safeCompanyName = companyName.replace(/[^a-zA-Z0-9]/g, '_');
    const filename = `${safeCompanyName}_CapEx_Verification_Form.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  // Generate Client Detail Entry Template as Excel
  const generateClientDetailTemplate = () => {
    const companyName = dealProfile.companyName || 'Company';
    const wb = XLSX.utils.book_new();

    // Industry-specific defaults
    const industryDefaults = {
      'it-msp':      { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'No', assignable: 'Yes' },
      'it-mssp':     { customerType: 'B2B', hasContract: 'Yes', contractLength: '24 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'No', assignable: 'Yes' },
      'it-var':      { customerType: 'B2B', hasContract: 'No',  contractLength: '',          autoRenewal: 'No',  billing: 'Monthly', escalator: 'No', assignable: '' },
      'it-staffing': { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'No',  billing: 'Monthly', escalator: 'No', assignable: 'Yes' },
      'it-dev':      { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'No',  billing: 'Monthly', escalator: 'No', assignable: 'Yes' },
      'it-saas':     { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'Yes', assignable: 'Yes' },
      'it-telecom':  { customerType: 'B2B', hasContract: 'Yes', contractLength: '24 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'Yes', assignable: 'Yes' },
      'it-hosting':  { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'Yes', assignable: 'Yes' },
      'healthcare-rcm': { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'No', assignable: 'Yes' },
      'it-niche':       { customerType: 'B2B', hasContract: 'Yes', contractLength: '12 Months', autoRenewal: 'Yes', billing: 'Monthly', escalator: 'No', assignable: 'Yes' },
    };
    const defaults = industryDefaults[selectedIndustry] || industryDefaults['it-msp'];

    // Get clients with revenue — BASIS FALLBACK (Konnie, RVS Computers
    // 2026-08-04): an accrual-only deal keeps its clients in the alt grid
    // while the valuation basis points at the empty cash one. Export
    // whichever grid actually has names.
    let activeClients = customerSalesData.filter(c => c.name && c.name.trim());
    if (activeClients.length === 0) activeClients = (customerSalesDataAlt || []).filter(c => c.name && c.name.trim());

    if (activeClients.length === 0) {
      alert('No client names found in the Sales Grid (either basis). Please enter client names or paste sales data first.');
      return;
    }

    // ========== STYLING DEFINITIONS (Vista Green Theme) ==========
    const styles = {
      headerMain: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 14 }, alignment: { horizontal: "center", vertical: "center" } },
      greenHeader: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 10 }, alignment: { horizontal: "center", vertical: "center" } },
      yellowHeader: { fill: { fgColor: { rgb: "F9A825" } }, font: { color: { rgb: "000000" }, bold: true, sz: 10 }, alignment: { horizontal: "center", vertical: "center" } },
      grayHeader: { fill: { fgColor: { rgb: "78909C" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 10 }, alignment: { horizontal: "center", vertical: "center" } },
      colHeaderName: { fill: { fgColor: { rgb: "CFD8DC" } }, font: { bold: true, sz: 9 }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      colHeaderRequired: { fill: { fgColor: { rgb: "C8E6C9" } }, font: { bold: true, sz: 9 }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      colHeaderImportant: { fill: { fgColor: { rgb: "FFF9C4" } }, font: { bold: true, sz: 9 }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      colHeaderOptional: { font: { bold: true, sz: 9 }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      subHeader: { font: { sz: 8, color: { rgb: "666666" }, italic: true }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      descRow: { font: { sz: 7, color: { rgb: "888888" }, italic: true }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      defaultRow: { fill: { fgColor: { rgb: "E8F5E9" } }, font: { bold: true, sz: 9 }, alignment: { horizontal: "center", vertical: "center" } },
      defaultRowName: { fill: { fgColor: { rgb: "E8F5E9" } }, font: { bold: true, sz: 9 }, alignment: { horizontal: "left", vertical: "center" } },
      clientName: { font: { bold: true, sz: 10 }, alignment: { vertical: "center" } },
      clientCell: { font: { sz: 10 }, alignment: { horizontal: "center", vertical: "center" } },
      // Instructions sheet styles
      instrTitle: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 16 }, alignment: { vertical: "center", horizontal: "center" } },
      instrSubtitle: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, sz: 11 }, alignment: { vertical: "center", horizontal: "center" } },
      instrSection: { fill: { fgColor: { rgb: "E8F5E9" } }, font: { bold: true, sz: 11, color: { rgb: "2E7D32" } }, alignment: { vertical: "center" } },
      instrBody: { font: { sz: 10 }, alignment: { vertical: "top", wrapText: true } },
      instrBold: { font: { sz: 10, bold: true }, alignment: { vertical: "top", wrapText: true } },
      instrNote: { font: { sz: 10, italic: true, color: { rgb: "666666" } }, alignment: { vertical: "top", wrapText: true } },
    };

    // ========== SHEET 1: INSTRUCTIONS ==========
    const instrData = [
      ['CLIENT DETAIL FORM'],
      [companyName],
      [''],
      ['ABOUT THIS FORM'],
      [''],
      ['This form helps us understand the quality and structure of your client relationships. The information you provide here directly impacts the accuracy of our business valuation.'],
      [''],
      ['Please complete as much as you can. The more detail you provide, the more precise our analysis will be. If certain fields are not readily available, leave them blank and we will work with what you have.'],
      [''],
      ['If you are exploring an initial estimate of value and this form is a heavy lift right now, let us know. We can provide a preliminary valuation using just your financial data. However, if you decide to move forward and engage our services, we will need this information to deliver a comprehensive valuation and marketing package.'],
      [''],
      ['HOW TO COMPLETE'],
      [''],
      ['1.  Go to the "Client Details" tab (next tab)'],
      ['2.  Your client names are pre-populated in Column A — do not edit these'],
      ['3.  Fill in the details for each client using the values shown in Row 4'],
      ['4.  Leave cells blank if you are unsure — do not guess'],
      ['5.  Save the file and return it to your Vista advisor'],
      [''],
      ['COLUMN GUIDE'],
      [''],
      ['Customer Type — Is this client a business (B2B), residential consumer, government entity, or non-profit?'],
      ['Status — Is this client currently active, at risk of leaving, or already lost?'],
      ['Has Contract — Does a signed service agreement exist with this client?'],
      ['Effective Date — When did the current contract begin? (MM/DD/YYYY)'],
      ['Original Contract Length — The initial term (Month-to-Month, 12 Months, 24 Months, etc.)'],
      ['Auto-Renewal — Does the contract automatically renew at the end of the term?'],
      ['Renewed Contract Length — If auto-renewing, what is the renewal term length?'],
      ['Assignable — Can this contract be transferred to a new owner if the business is sold? Check your agreement for assignment language.'],
      ['Price Escalator — Does the contract include a built-in annual price increase? This is common in multi-year agreements.'],
      ['Escalator % — If yes, what is the annual increase percentage? (e.g., 3 for 3%)'],
      ['Early Termination Penalty — Does the contract include a penalty if the client cancels early?'],
      ['Billing — How often is this client invoiced? (Monthly, Quarterly, Annually)'],
      ['Industry — What industry does this client operate in? (e.g., Healthcare, Legal, Manufacturing)'],
      ['Tenure — Approximately how many years has this client been with you?'],
      [''],
      ['VALID VALUES REFERENCE'],
      [''],
      ['Customer Type: B2B, Residential, Government, Non-Profit'],
      ['Status: Active, At Risk, Lost'],
      ['Yes/No fields: Yes, No'],
      ['Contract Length: Month-to-Month, 6 Months, 12 Months, 24 Months, 36 Months, 48 Months, 60 Months'],
      ['Billing: Monthly, Quarterly, Semi-Annually, Annually'],
      [''],
      ['Please use these exact values for the best results when we import your data.'],
    ];
    
    const wsInstr = XLSX.utils.aoa_to_sheet(instrData);
    wsInstr['!cols'] = [{ wch: 110 }];
    wsInstr['!rows'] = [
      { hpt: 32 }, { hpt: 22 }, { hpt: 12 },
      { hpt: 24 }, { hpt: 8 },
      { hpt: 30 }, { hpt: 8 }, { hpt: 30 }, { hpt: 8 }, { hpt: 42 }, { hpt: 8 },
      { hpt: 24 }, { hpt: 8 },
      ...Array(6).fill({ hpt: 18 }), { hpt: 8 },
      { hpt: 24 }, { hpt: 8 },
      ...Array(14).fill({ hpt: 28 }), { hpt: 8 },
      { hpt: 24 }, { hpt: 8 },
      ...Array(5).fill({ hpt: 24 }), { hpt: 8 },
      { hpt: 24 },
    ];
    // Apply styles
    if (wsInstr['A1']) wsInstr['A1'].s = styles.instrTitle;
    if (wsInstr['A2']) wsInstr['A2'].s = styles.instrSubtitle;
    ['A4', 'A12', 'A20', 'A37'].forEach(ref => { if (wsInstr[ref]) wsInstr[ref].s = styles.instrSection; });
    for (let i = 5; i <= instrData.length; i++) {
      const ref = `A${i+1}`;
      if (wsInstr[ref] && !wsInstr[ref].s) wsInstr[ref].s = styles.instrBody;
    }
    
    XLSX.utils.book_append_sheet(wb, wsInstr, 'Instructions');

    // ========== SHEET 2: CLIENT DETAILS ==========
    // Column definitions with descriptions
    const colDefs = [
      { header: 'Client Name',              sub: '(do not edit)',                              desc: '',                                                      width: 28, priority: 'name' },
      { header: 'Customer Type',            sub: 'B2B, Residential, Government, Non-Profit',   desc: 'Business, consumer, or government?',                    width: 16, priority: 'requested' },
      { header: 'Status',                   sub: 'Active, At Risk, Lost',                      desc: 'Current relationship status',                           width: 14, priority: 'requested' },
      { header: 'Has Contract?',            sub: 'Yes, No',                                    desc: 'Is a signed agreement in place?',                       width: 13, priority: 'requested' },
      { header: 'Effective Date',           sub: 'MM/DD/YYYY',                                 desc: 'When did the contract start?',                          width: 14, priority: 'if_available' },
      { header: 'Original Contract Length', sub: 'Month-to-Month, 12 Months, 24 Months, etc.', desc: 'Initial term of the agreement',                         width: 20, priority: 'if_available' },
      { header: 'Auto-Renewal?',            sub: 'Yes, No',                                    desc: 'Does it renew automatically?',                          width: 14, priority: 'if_available' },
      { header: 'Renewed Contract Length',  sub: 'Month-to-Month, 12 Months, 24 Months, etc.', desc: 'Term length upon renewal',                              width: 20, priority: 'if_available' },
      { header: 'Assignable?',              sub: 'Yes, No',                                    desc: 'Can this transfer to a new owner?',                     width: 13, priority: 'if_available' },
      { header: 'Price Escalator?',         sub: 'Yes, No',                                    desc: 'Built-in annual price increase?',                       width: 15, priority: 'if_available' },
      { header: 'Escalator %',              sub: 'Number (e.g. 3)',                            desc: 'Annual increase percentage',                            width: 12, priority: 'if_available' },
      { header: 'Early Term Penalty?',      sub: 'Yes, No',                                    desc: 'Penalty for early cancellation?',                       width: 16, priority: 'if_available' },
      { header: 'Billing',                  sub: 'Monthly, Quarterly, Annually',               desc: 'How often are they invoiced?',                          width: 13, priority: 'if_available' },
      { header: 'Industry',                 sub: 'e.g. Healthcare, Legal, Manufacturing',      desc: 'Client\'s business sector',                             width: 18, priority: 'if_available' },
      { header: 'Tenure (Yrs)',             sub: 'Number (e.g. 5)',                            desc: 'Years as your client',                                  width: 13, priority: 'if_available' },
      { header: 'Notes',                    sub: 'Comments/details',                           desc: 'Anything else we should know',                          width: 30, priority: 'if_available' },
    ];

    // Build data array
    const data = [];
    
    // Row 1: Main header + category labels
    const row1 = [`CLIENT DETAILS — ${companyName}`, 'REQUESTED', '', '', 'IF AVAILABLE', '', '', '', '', '', '', '', '', '', '', ''];
    data.push(row1);
    
    // Row 2: Column headers
    const row2 = colDefs.map(c => c.header);
    data.push(row2);
    
    // Row 3: Descriptions (plain language)
    const row3 = colDefs.map(c => c.desc);
    data.push(row3);
    
    // Row 4: Valid values
    const row4 = colDefs.map(c => c.sub);
    data.push(row4);
    
    // Row 5+: Client data
    activeClients.forEach(client => {
      const leftData = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
      leftData[0] = client.name || '';
      leftData[1] = client.customerType || '';
      if (client.lost) leftData[2] = 'Lost';
      else if (client.atRisk) leftData[2] = 'At Risk';
      else leftData[2] = '';
      leftData[3] = client.hasContract === true ? 'Yes' : '';
      leftData[4] = client.effectiveDate || client.contractStart || '';
      if (client.contractMonths === 1) leftData[5] = 'Month-to-Month';
      else if (client.contractMonths) leftData[5] = `${client.contractMonths} Months`;
      else leftData[5] = '';
      leftData[6] = client.autoRenewal === true ? 'Yes' : '';
      if (client.renewedContractMonths === 1) leftData[7] = 'Month-to-Month';
      else if (client.renewedContractMonths) leftData[7] = `${client.renewedContractMonths} Months`;
      else leftData[7] = '';
      leftData[8] = client.assignable === true ? 'Yes' : '';
      leftData[9] = client.priceEscalator === true ? 'Yes' : '';
      leftData[10] = client.escalatorPercent ? String(client.escalatorPercent) : '';
      leftData[11] = client.earlyTermPenalty === true ? 'Yes' : '';
      leftData[12] = client.billingFrequency || '';
      leftData[13] = client.industry || '';
      leftData[14] = client.tenure ? String(client.tenure) : '';
      leftData[15] = client.notes || '';
      data.push(leftData);
    });

    const ws = XLSX.utils.aoa_to_sheet(data);
    
    // Column widths
    ws['!cols'] = colDefs.map(c => ({ wch: c.width }));
    
    // Row heights
    ws['!rows'] = [
      { hpt: 28 },  // Row 1 - main header
      { hpt: 30 },  // Row 2 - column headers
      { hpt: 22 },  // Row 3 - descriptions
      { hpt: 18 },  // Row 4 - valid values
    ];
    for (let i = 0; i < activeClients.length; i++) {
      ws['!rows'].push({ hpt: 20 });
    }
    
    // Merge cells for category headers
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } },
      { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
      { s: { r: 0, c: 4 }, e: { r: 0, c: 15 } },
    ];
    
    // Apply styles
    if (ws['A1']) ws['A1'].s = styles.headerMain;
    if (ws['B1']) ws['B1'].s = styles.greenHeader;
    if (ws['E1']) ws['E1'].s = styles.yellowHeader;
    
    // Row 2 header styles
    colDefs.forEach((col, idx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 1, c: idx });
      if (ws[cellRef]) {
        if (col.priority === 'name') ws[cellRef].s = styles.colHeaderName;
        else if (col.priority === 'requested') ws[cellRef].s = styles.colHeaderRequired;
        else ws[cellRef].s = styles.colHeaderImportant;
      }
    });
    
    // Row 3 description styles
    colDefs.forEach((col, idx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 2, c: idx });
      if (ws[cellRef]) ws[cellRef].s = styles.descRow;
    });
    
    // Row 4 valid values styles
    colDefs.forEach((col, idx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: idx });
      if (ws[cellRef]) ws[cellRef].s = styles.subHeader;
    });
    
    // Data rows styling
    for (let i = 0; i < activeClients.length; i++) {
      const rowNum = 4 + i;
      const nameRef = XLSX.utils.encode_cell({ r: rowNum, c: 0 });
      if (ws[nameRef]) ws[nameRef].s = styles.clientName;
      for (let col = 1; col < colDefs.length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: col });
        if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
        ws[cellRef].s = styles.clientCell;
      }
    }
    
    // Freeze panes: freeze rows 1-4 and column A
    ws['!freeze'] = { xSplit: 1, ySplit: 4 };
    
    XLSX.utils.book_append_sheet(wb, ws, 'Client Details');

    // Download (no Lookups tab)
    const safeCompanyName = companyName.replace(/[^a-zA-Z0-9]/g, '_');
    XLSX.writeFile(wb, `${safeCompanyName}_Client_Detail_Form.xlsx`);
  };

  // Import completed Client Detail Form Excel
  const importClientDetailTemplate = (event, overwrite = true) => {
    const file = event?.target?.files?.[0] || clientImportFile;
    if (!file) return;
    if (event?.target) event.target.value = '';
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: 'array' });
        
        // Find Client Details sheet
        const sheetName = wb.SheetNames.find(n => n.toLowerCase().includes('client') || n.toLowerCase().includes('sales')) || wb.SheetNames[0];
        const ws = wb.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
        
        if (rows.length < 5) {
          alert('File appears empty or incorrectly formatted. Expected at least 5 rows.');
          return;
        }
        
        // Parse helpers
        const yesNo = (v) => { const s = String(v || '').trim().toLowerCase(); return s === 'yes' || s === 'y' || s === 'true' || s === 'n' && false; };
        const yesNoStrict = (v) => { const s = String(v || '').trim().toLowerCase(); return s === 'yes' || s === 'y' || s === 'true'; };
        const str = (v) => String(v || '').trim();
        // Owners write "n/a" where they mean blank (RVS 08-13: n/a in the
        // Billing/Escalator/Early-Term columns would land verbatim in the
        // grid) — field values treat it as empty; client names keep str().
        const fieldStr = (v) => { const s = str(v); return /^n\s*[\/.]?\s*a\.?$/i.test(s) ? '' : s; };
        const num = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
        // Excel stores dates as day-number serials (45597 = 2024-11-01) and
        // raw sheet reads hand them over verbatim (Konnie's RVS import,
        // 08-18: the Effective Date column filled with 45597s). Convert
        // plausible serials to MM/DD/YYYY; anything else passes through.
        const excelDate = (v) => {
          const s = str(v);
          if (!/^\d{4,6}(\.0+)?$/.test(s)) return null;
          const n = parseFloat(s);
          if (n < 20000 || n > 80000) return null; // outside 1954–2118 = not a date serial
          const d = new Date(Math.round((n - 25569) * 86400000));
          return `${String(d.getUTCMonth() + 1).padStart(2, '0')}/${String(d.getUTCDate()).padStart(2, '0')}/${d.getUTCFullYear()}`;
        };
        // Owners answer Type in their own words ("Business", "Home User")
        // while the grid dropdown speaks B2B/Residential/Government/
        // Non-Profit (Konnie's RVS follow-up, 08-18). Normalize the common
        // synonyms; anything unrecognized passes through verbatim rather
        // than being silently dropped.
        const normalizeType = (v) => {
          const raw = str(v);
          const s = raw.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (!s) return '';
          if (/^(b2b|business(es)?|commercial|company|corporate|biz)$/.test(s)) return 'B2B';
          if (/^(residential|homeuser(s)?|home|consumer(s)?|individual(s)?|b2c)$/.test(s)) return 'Residential';
          if (/^(government|gov|municipal|city|county|state|publicsector|public)$/.test(s)) return 'Government';
          if (/^(nonprofit(s)?|notforprofit|charity|church|501c3?)$/.test(s)) return 'Non-Profit';
          return raw;
        };
        
        // Normalize name for fuzzy matching - only handles formatting differences
        const normalizeName = (name) => {
          return String(name || '').toLowerCase()
            .replace(/\s+/g, ' ')           // Collapse multiple spaces
            .replace(/[()[\]]/g, ' ')        // Replace brackets with space
            .replace(/\s*-\s*/g, ' ')        // Replace " - " with space  
            .replace(/\s*,\s*/g, ' ')        // Replace ", " with space
            .replace(/\./g, '')              // Remove periods
            .replace(/\s+/g, ' ')            // Collapse spaces again
            .trim();
        };
        
        // Find customer by name (with fuzzy matching fallback)
        // Only matches if names are equal after normalization - no partial/substring matching
        const ambiguousNames = [];
        const prefixClaimed = new Set();
        const findCustomerIndex = (name, customers) => {
          const nameLower = name.toLowerCase().trim();
          // First try exact match (case-insensitive)
          let idx = customers.findIndex(c => c.name && c.name.toLowerCase().trim() === nameLower);
          if (idx !== -1) return idx;
          // Fallback to normalized match (handles formatting differences like parentheses vs dashes)
          const nameNorm = normalizeName(name);
          idx = customers.findIndex(c => c.name && normalizeName(c.name) === nameNorm);
          if (idx !== -1) return idx;
          // UNIQUE-PREFIX fallback (RVS Computers 08-13: the returned form
          // carried QuickBooks-truncated names — "Agri", "Alle", 2–5 chars —
          // against a grid of full names, so 124 owner-answered rows matched
          // nothing). A truncated name that is the prefix of EXACTLY ONE grid
          // client is safe to take; two-or-more candidates stay unmatched and
          // get reported as ambiguous rather than guessed.
          if (nameNorm.length >= 3) {
            const hits = [];
            customers.forEach((c, i) => {
              if (c.name && normalizeName(c.name).startsWith(nameNorm)) hits.push(i);
            });
            if (hits.length === 1) {
              // Two truncated dupes ("Alle" ×2 = two DIFFERENT clients) must
              // not both land on one grid row — first claim wins, the second
              // is reported instead of silently overwriting.
              if (prefixClaimed.has(hits[0])) {
                ambiguousNames.push(`${name} (duplicate truncated name — already matched to "${customers[hits[0]].name}")`);
                return -1;
              }
              prefixClaimed.add(hits[0]);
              return hits[0];
            }
            if (hits.length > 1) ambiguousNames.push(`${name} (${hits.length} grid clients start with this)`);
          }
          return -1;
        };
        
        // Detect format: OLD format has year columns (2021, 2022, etc.) in positions 1-5
        // Look for year values in row 5 (0-indexed) which is the header row in old format
        const isOldFormat = rows.some(row => {
          if (!row) return false;
          // Check if columns 1-5 contain year values like 2021, 2022, etc.
          const hasYears = [1,2,3,4,5].some(i => {
            const val = row[i];
            return val && (String(val).match(/^20\d{2}(\.0+)?$/) || val === 2021 || val === 2022 || val === 2023 || val === 2024 || val === 2025);
          });
          return hasYears;
        });
        
        let matched = 0, unmatched = 0, unmatchedNames = [], matchedPairs = [];
        // Match against the grid the user is LOOKING AT (Konnie's RVS case
        // 08-18: 330 identical names on screen, "0 matched" — the import
        // read the VALUATION-basis array while the grid renders the VIEW
        // basis, and only the export ever had the fall-to-the-other-basis
        // logic). Same fallback as the export: if the view basis has no
        // named clients, target the other one.
        const viewHasClients = activeSalesData.some(c => c.name && c.name.trim());
        const targetIsCash = viewHasClients ? (salesViewBasis === 'cash') : (salesViewBasis !== 'cash');
        // OVERWRITE now means the whole slate (Zac 10-05, Concise: the corrected spreadsheet left old detail on
        // every client it didn't name). Clear every client's detail on both bases first; Merge keeps the old way.
        const updatedCustomers = (targetIsCash ? customerSalesCash : customerSalesAccrual).map(c => overwrite ? clearDetail(c) : c);
        
        if (isOldFormat) {
          // OLD FORMAT: Sales Report with year columns
          // Column 0: Name, 1-5: Years, 6: Contract, 7: Start, 8: End, 9: Length, 10: AutoRenew, 11: Assignable, 12: Escalator, 13: Billing, 14: Tenure, 15: Industry, 16: Endpoints, 17: Type, 18: AtRisk
          // Data starts at row 6 (0-indexed)
          
          for (let r = 6; r < rows.length; r++) {
            const row = rows[r];
            const name = str(row[0]);
            if (!name) continue;
            
            const custIdx = findCustomerIndex(name, updatedCustomers);
            
            if (custIdx === -1) {
              unmatched++;
              unmatchedNames.push(name);
              continue;
            }
            
            matched++;
            const cust = { ...updatedCustomers[custIdx] };
            // Track if names differ (fuzzy match)
            if (cust.name !== name) {
              matchedPairs.push({ excel: name, grid: cust.name });
            }
            
            // Map old format columns
            const hasContractVal = str(row[6]);
            if (hasContractVal) { cust.hasContract = yesNoStrict(hasContractVal); cust.contractAnswered = true; }
            
            const contractLength = num(row[9]);
            if (contractLength > 0) cust.contractMonths = contractLength;
            
            const autoRenewVal = str(row[10]);
            if (autoRenewVal) cust.autoRenewal = yesNoStrict(autoRenewVal);
            
            const assignableVal = str(row[11]);
            if (assignableVal) cust.assignable = yesNoStrict(assignableVal);
            
            const escalatorVal = str(row[12]);
            if (escalatorVal) cust.priceEscalator = yesNoStrict(escalatorVal);
            
            const billing = str(row[13]);
            if (billing) {
              // Convert M/Q/A to Monthly/Quarterly/Annual
              const b = billing.toUpperCase();
              if (b === 'M') cust.billingFrequency = 'Monthly';
              else if (b === 'Q') cust.billingFrequency = 'Quarterly';
              else if (b === 'A') cust.billingFrequency = 'Annual';
              else cust.billingFrequency = billing;
            }
            
            const tenure = num(row[14]);
            if (tenure > 0) cust.tenure = tenure;
            
            const industry = str(row[15]);
            if (industry) cust.industry = industry;
            
            const endpoints = num(row[16]);
            if (endpoints > 0) cust.endpoints = endpoints;
            
            const type = normalizeType(str(row[17]));
            if (type) cust.customerType = type;
            
            const atRisk = str(row[18]);
            if (atRisk) {
              cust.atRisk = yesNoStrict(atRisk);
              cust.lost = false;
            }
            
            updatedCustomers[custIdx] = cust;
          }
        } else {
          // NEW FORMAT: Client Detail Form
          // Updated column mapping (0-indexed) to match current Excel template:
          // A=0 Name, B=1 Type, C=2 Status, D=3 Contract, E=4 EffectiveDate, F=5 OrigLength, 
          // G=6 AutoRenew, H=7 RenewedLength, I=8 Assignable, J=9 Escalator, K=10 Esc%, 
          // L=11 EarlyTerm, M=12 Billing, N=13 Industry, O=14 Tenure, P=15 Notes
          
          // Parse contract length to months
          const lengthToMonths = (v) => {
            const s = str(v).toLowerCase();
            if (s.includes('month-to-month') || s.includes('m-to-m') || s === 'mtm') return 1;
            const numMatch = s.match(/(\d+)/);
            if (numMatch) return parseInt(numMatch[1]);
            return null;
          };
          
          // Data starts at row 4 or 5 depending on template version
          // New format (v88+) has a description row, so data starts at row 5 (index 4)
          // Old format had data starting at row 4 (index 3)
          // Detect by checking if row 4 (index 3) has a valid client name vs description text
          const row3Name = str(rows[3]?.[0]);
          const dataStartIdx = (row3Name && !row3Name.includes('do not edit') && !row3Name.includes('(') && row3Name.length > 1) ? 3 : 4;
          for (let r = dataStartIdx; r < rows.length; r++) {
            const row = rows[r];
            const name = str(row[0]);
            if (!name || name.startsWith('⬇') || name.toLowerCase().includes('default')) continue;
            
            // Find matching customer by name (with fuzzy matching fallback)
            const custIdx = findCustomerIndex(name, updatedCustomers);
            
            if (custIdx === -1) {
              unmatched++;
              unmatchedNames.push(name);
              continue;
            }
            
            matched++;
            const cust = { ...updatedCustomers[custIdx] };
            // Track if names differ (fuzzy match)
            if (cust.name !== name) {
              matchedPairs.push({ excel: name, grid: cust.name });
            }
            
            // Apply fields - set value if present, else skip (or clear if overwrite mode)
            const type = normalizeType(fieldStr(row[1]));
            if (type) cust.customerType = type;
            else if (overwrite) cust.customerType = '';
            
            const status = fieldStr(row[2]);
            if (status) {
              cust.atRisk = status.toLowerCase() === 'at risk';
              cust.lost = status.toLowerCase() === 'lost';
            }
            
            const hasContractVal = fieldStr(row[3]);
            if (hasContractVal) { cust.hasContract = yesNoStrict(hasContractVal); cust.contractAnswered = true; }
            else if (overwrite) cust.hasContract = false;
            
            // Column 4 = Effective Date (Excel serial → MM/DD/YYYY)
            let effectiveDateVal = fieldStr(row[4]);
            const serialDate = excelDate(effectiveDateVal);
            if (serialDate) effectiveDateVal = serialDate;
            if (effectiveDateVal) {
              cust.effectiveDate = effectiveDateVal;
              cust.contractStart = effectiveDateVal;
            }
            
            // Column 5 = Original Contract Length
            const length = fieldStr(row[5]);
            if (length) {
              const months = lengthToMonths(length);
              if (months !== null) cust.contractMonths = months;
            } else if (overwrite) cust.contractMonths = null;
            
            // Column 6 = Auto-Renewal
            const autoRenewVal = fieldStr(row[6]);
            if (autoRenewVal) cust.autoRenewal = yesNoStrict(autoRenewVal);
            else if (overwrite) cust.autoRenewal = false;
            
            // Column 7 = Renewed Contract Length
            const renewedLength = fieldStr(row[7]);
            if (renewedLength) {
              const renewedMonths = lengthToMonths(renewedLength);
              if (renewedMonths !== null) cust.renewedContractMonths = renewedMonths;
            }
            
            // Column 8 = Assignable
            const assignableVal = fieldStr(row[8]);
            if (assignableVal) cust.assignable = yesNoStrict(assignableVal);
            else if (overwrite) cust.assignable = false;
            
            // Column 9 = Price Escalator
            const escalatorVal = fieldStr(row[9]);
            if (escalatorVal) cust.priceEscalator = yesNoStrict(escalatorVal);
            else if (overwrite) cust.priceEscalator = false;
            
            // Column 10 = Escalator %
            const escPct = num(row[10]);
            if (escPct > 0) cust.escalatorPercent = escPct;
            else if (overwrite) cust.escalatorPercent = 0;
            
            // Column 11 = Early Term Penalty
            const earlyTermVal = fieldStr(row[11]);
            if (earlyTermVal) cust.earlyTermPenalty = yesNoStrict(earlyTermVal);
            else if (overwrite) cust.earlyTermPenalty = false;
            
            // Column 12 = Billing
            const billing = fieldStr(row[12]);
            if (billing) cust.billingFrequency = billing;
            else if (overwrite) cust.billingFrequency = '';
            
            // Column 13 = Industry
            const industry = fieldStr(row[13]);
            if (industry) cust.industry = industry;
            else if (overwrite) cust.industry = '';
          
            // Column 14 = Tenure
            const tenureVal = num(row[14]);
            if (tenureVal > 0) cust.tenure = tenureVal;
            else if (overwrite) cust.tenure = 0;
            
            // Column 15 = Notes
            const notes = str(row[15]);
            if (notes) cust.notes = notes;
            else if (overwrite) cust.notes = '';
          
            updatedCustomers[custIdx] = cust;
          }
        }
        
        captureUndoState('Import Client Detail Form');
        (targetIsCash ? setCustomerSalesCash : setCustomerSalesAccrual)(updatedCustomers);
        // Mirror the imported detail fields onto the OTHER basis' rows by
        // name — client attributes (contracts, tenure, industry…) are
        // properties of the client, not of an accounting basis, so both
        // lenses must agree after an import.
        {
          const DETAIL_FIELDS = ['customerType', 'atRisk', 'lost', 'hasContract', 'contractAnswered', 'effectiveDate', 'contractStart', 'contractMonths', 'autoRenewal', 'renewedContractMonths', 'assignable', 'priceEscalator', 'escalatorPercent', 'earlyTermPenalty', 'billingFrequency', 'industry', 'tenure', 'endpoints', 'notes'];
          const byName = new Map(updatedCustomers.filter(c => c.name && c.name.trim()).map(c => [c.name.toLowerCase().trim(), c]));
          (targetIsCash ? setCustomerSalesAccrual : setCustomerSalesCash)(prev => (prev || []).map(row0 => {
            const row = overwrite ? clearDetail(row0) : row0;
            const m = row.name && byName.get(row.name.toLowerCase().trim());
            if (!m) return row;
            const patch = {};
            DETAIL_FIELDS.forEach(f => { if (m[f] !== undefined) patch[f] = m[f]; });
            return { ...row, ...patch };
          }));
        }
        setHasUnsavedChanges(true);
        setShowClientImportModal(false);
        setClientImportFile(null);
        
        const formatType = isOldFormat ? 'Old Sales Report format' : 'New Client Detail format';
        let msg = `✅ Client Detail Import Complete (${formatType})\n\n${matched} clients matched and updated`;
        if (!isOldFormat) {
          if (overwrite) msg += '\n(Overwrite mode: empty cells cleared existing values)';
          else msg += '\n(Merge mode: empty cells kept existing values)';
        }
        if (matchedPairs.length > 0) {
          msg += `\n\n⚠️ ${matchedPairs.length} fuzzy matches (names differ slightly):\n${matchedPairs.slice(0, 5).map(p => `  Excel: "${p.excel}" → Grid: "${p.grid}"`).join('\n')}`;
          if (matchedPairs.length > 5) msg += `\n  ... and ${matchedPairs.length - 5} more`;
        }
        if (ambiguousNames.length > 0) {
          msg += `\n\n⚠️ ${ambiguousNames.length} truncated names matched MORE than one grid client (fill these by hand):\n${ambiguousNames.slice(0, 10).map(n => `  • ${n}`).join('\n')}`;
          if (ambiguousNames.length > 10) msg += `\n  ... and ${ambiguousNames.length - 10} more`;
        }
        if (unmatched > 0) {
          msg += `\n\n${unmatched} names not matched:\n${unmatchedNames.slice(0, 10).map(n => `  • ${n}`).join('\n')}`;
          if (unmatchedNames.length > 10) msg += `\n  ... and ${unmatchedNames.length - 10} more`;
        }

        alert(msg);
        
      } catch (err) {
        console.error('Client detail import error:', err);
        alert('Error importing file: ' + err.message);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // ========== REVENUE CATEGORY FORM EXPORT/IMPORT ==========
  // Generate Revenue Category Classification Form as Excel
  const generateRevenueCategoryForm = () => {
    const companyName = dealProfile.companyName || 'Company';
    const wb = XLSX.utils.book_new();

    // Get revenue categories with names
    const activeRevCats = revenueCategories.filter(c => c.name && c.name.trim());
    
    if (activeRevCats.length === 0) {
      alert('No revenue categories found. Please enter P&L data first.');
      return;
    }

    // ========== STYLING DEFINITIONS (Vista Green Theme) ==========
    const styles = {
      headerMain: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 14 }, alignment: { horizontal: "center", vertical: "center" } },
      colHeader: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 10 }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
      colHint: { font: { sz: 8, color: { rgb: "666666" }, italic: true }, alignment: { horizontal: "center", vertical: "center" } },
      revName: { font: { bold: true, sz: 10 }, alignment: { vertical: "center" } },
      amount: { font: { sz: 10 }, alignment: { horizontal: "right", vertical: "center" }, numFmt: '"$"#,##0' },
      typeCell: { fill: { fgColor: { rgb: "FFF9C4" } }, font: { sz: 12, bold: true }, alignment: { horizontal: "center", vertical: "center" } },
      instrHeader: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 12 }, alignment: { vertical: "center" } },
      instrText: { font: { sz: 10 }, alignment: { vertical: "top", wrapText: true } },
      instrBold: { font: { sz: 10, bold: true }, alignment: { vertical: "top", wrapText: true } },
      typeHeader: { fill: { fgColor: { rgb: "E8F5E9" } }, font: { bold: true, sz: 10, color: { rgb: "2E7D32" } }, alignment: { vertical: "center" } },
      typeName: { fill: { fgColor: { rgb: "F1F8E9" } }, font: { bold: true, sz: 10 }, alignment: { vertical: "center" } },
      typeDesc: { font: { sz: 9, color: { rgb: "555555" } }, alignment: { vertical: "top", wrapText: true } },
      whyHeader: { fill: { fgColor: { rgb: "DCFCE7" } }, font: { bold: true, sz: 10, color: { rgb: "166534" } }, alignment: { vertical: "center" } },
      whyText: { font: { sz: 9, color: { rgb: "166534" } }, alignment: { vertical: "top", wrapText: true } },
    };

    // Map revenueType IDs to numbers
    const typeToNumber = {
      'contracted_defined': 1,
      'project_contracted': 2,
      'hardware_contracted': 3,
      'repeat_uncontracted': 4,
      'transactional': 5,
      'recurring_licensing': 6,
      // Legacy mappings
      'recurring_contract': 1,
      'recurring_switching': 2,
      'recurring_mtm': 4,
      'project_services': 5,
      'product': 5,
    };

    // ========== BUILD DATA ARRAY ==========
    const data = [];
    
    // Build right-side content (instructions + legend + why it matters)
    const rightContent = [
      { text: '3. Use the legend below to select the right number', style: 'instr' },
      { text: '4. Add notes if helpful (e.g., "contract ends 12/25")', style: 'instr' },
      { text: '5. Save and return this file when complete', style: 'instr' },
      { text: '', style: 'spacer' },
      { text: '⚠️ MIXED REVENUE? (multiple types in one line)', style: 'whyHeader' },
      { text: 'If a line has mixed types, enter the main type and', style: 'why' },
      { text: 'add split details in Notes. Example:', style: 'why' },
      { text: 'Type: 2, Notes: "60% projects (2), 40% break/fix (5)"', style: 'why' },
      { text: '', style: 'spacer' },
      { text: '📚 REVENUE TYPE LEGEND (enter 1-6)', style: 'typeHeader' },
      { text: 'THE TEST: does it repeat by agreement? "Under contract"', style: 'why' },
      { text: 'is not the test — a signed one-time project is still one-time.', style: 'why' },
      { text: '', style: 'spacer' },
      { text: '1 = CONTRACTED - DEFINED REVENUE', style: 'typeName' },
      { text: 'A written agreement obligates REPEATING payments (monthly/', style: 'typeDesc' },
      { text: 'quarterly/annual). NOT one-time project contracts.', style: 'typeDesc' },
      { text: 'Ex: service-plan fees, maintenance agreements, retainers', style: 'typeEx' },
      { text: '', style: 'spacer' },
      { text: '2 = SERVICE PROJECTS - CONTRACTED CLIENT', style: 'typeName' },
      { text: 'Project work for a client who ALSO has an ongoing service', style: 'typeDesc' },
      { text: 'agreement with you — the relationship recurs, projects vary.', style: 'typeDesc' },
      { text: 'Ex: an install or upgrade for a maintenance-plan customer', style: 'typeEx' },
      { text: '', style: 'spacer' },
      { text: '3 = HARDWARE/PRODUCT - CONTRACTED CLIENT', style: 'typeName' },
      { text: 'Equipment/materials sold to clients under an ongoing', style: 'typeDesc' },
      { text: 'agreement. Lumpy even in good relationships.', style: 'typeDesc' },
      { text: 'Ex: equipment purchases, materials for service-plan clients', style: 'typeEx' },
      { text: '', style: 'spacer' },
      { text: '4 = REPEAT - UNCONTRACTED', style: 'typeName' },
      { text: 'Clients who come back again and again with NO ongoing', style: 'typeDesc' },
      { text: 'agreement — a 2+ year pattern.', style: 'typeDesc' },
      { text: 'Ex: repeat commercial customers, seasonal property managers', style: 'typeEx' },
      { text: '', style: 'spacer' },
      { text: '5 = TRANSACTIONAL / NEW', style: 'typeName' },
      { text: 'One-time work and new customers — INCLUDING signed', style: 'typeDesc' },
      { text: 'one-time project contracts. Contracted ≠ recurring.', style: 'typeDesc' },
      { text: 'Ex: a build, a wiring or install project, first job for a new client', style: 'typeEx' },
      { text: '', style: 'spacer' },
      { text: '6 = SOFTWARE SUBSCRIPTIONS / LICENSES YOU RESELL', style: 'typeName' },
      { text: 'Software your clients pay for through you that renews on its', style: 'typeDesc' },
      { text: 'own (monthly/annual) under an ongoing agreement. Lifetime license = 3.', style: 'typeDesc' },
      { text: 'Ex: Microsoft 365 seats, security or backup subscriptions per user', style: 'typeEx' },
      { text: '', style: 'spacer' },
      { text: '💡 WHY THIS MATTERS', style: 'whyHeader' },
      { text: 'Revenue classification directly impacts your valuation.', style: 'why' },
      { text: 'Contracted recurring revenue commands the highest', style: 'why' },
      { text: 'multiples because it\'s predictable and protected.', style: 'why' },
      { text: 'Accurate classification builds buyer confidence and', style: 'why' },
      { text: 'avoids surprises during due diligence.', style: 'why' },
    ];
    
    // Row 1: Headers
    data.push([
      `📊 REVENUE CLASSIFICATION — ${companyName}`, '', '', '', '', '', '',
      '',
      '📋 HOW TO COMPLETE THIS FORM'
    ]);
    
    // Row 2: Column headers + Instructions
    data.push([
      'Revenue Line Item', displayYearLabels.year3, displayYearLabels.year4, displayYearLabels.year5, ttmLabel, 'Type', 'Notes',
      '',
      '1. Review each revenue line item on the left'
    ]);
    
    // Row 3: Hints + Instructions
    data.push([
      '(from your P&L)', '', '', '', '', '(1-6)', '(optional)',
      '',
      '2. In the yellow "Type" column, enter 1, 2, 3, 4, 5, or 6'
    ]);
    
    // Determine how many rows we need
    const numRevRows = activeRevCats.length;
    const totalDataRows = Math.max(numRevRows, rightContent.length);
    
    // Build data rows
    for (let i = 0; i < totalDataRows; i++) {
      const revCat = activeRevCats[i];
      
      let revData = ['', '', '', '', '', '', ''];
      if (revCat) {
        const basisData = revCat[selectedValuationBasis] || revCat.cash || {};
        // Look up the type number, default to empty string if not categorized yet
        const typeNum = revCat.revenueType ? (typeToNumber[revCat.revenueType] || '') : '';
        revData = [
          revCat.name,
          basisData.year3 || 0,
          basisData.year4 || 0,
          basisData.year5 || 0,
          basisData.ttm || 0,
          typeNum,
          ''
        ];
      }
      
      const rightItem = rightContent[i];
      const rightText = rightItem ? rightItem.text : '';
      
      data.push([...revData, '', rightText]);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    
    // Column widths
    ws['!cols'] = [
      { wch: 32 },  // A: Revenue Line Item
      { wch: 11 },  // B: Year 3
      { wch: 11 },  // C: Year 4
      { wch: 11 },  // D: Year 5
      { wch: 13 },  // E: TTM
      { wch: 8 },   // F: Type (narrow - just a number)
      { wch: 28 },  // G: Notes
      { wch: 2 },   // H: Spacer
      { wch: 52 },  // I: Instructions/Legend
    ];
    
    // Row heights
    ws['!rows'] = [{ hpt: 28 }]; // Row 1 header taller
    
    // Merges
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },  // Revenue header A1:G1
    ];
    
    // Apply styles
    // Row 1 headers
    if (ws['A1']) ws['A1'].s = styles.headerMain;
    if (ws['I1']) ws['I1'].s = styles.instrHeader;
    
    // Row 2 column headers
    ['A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'G2'].forEach(ref => {
      if (ws[ref]) ws[ref].s = styles.colHeader;
    });
    if (ws['I2']) ws['I2'].s = styles.instrText;
    
    // Row 3 hints
    ['A3', 'B3', 'C3', 'D3', 'E3', 'F3', 'G3'].forEach(ref => {
      if (ws[ref]) ws[ref].s = styles.colHint;
    });
    if (ws['I3']) ws['I3'].s = styles.instrText;
    
    // Data rows styling
    for (let i = 0; i < totalDataRows; i++) {
      const rowNum = 3 + i; // 0-indexed (row 4+ in Excel)
      const revCat = activeRevCats[i];
      const rightItem = rightContent[i];
      
      if (revCat) {
        // Revenue name
        const nameRef = XLSX.utils.encode_cell({ r: rowNum, c: 0 });
        if (ws[nameRef]) ws[nameRef].s = styles.revName;
        
        // Amount columns
        [1, 2, 3, 4].forEach(col => {
          const ref = XLSX.utils.encode_cell({ r: rowNum, c: col });
          if (ws[ref]) ws[ref].s = styles.amount;
        });
        
        // Type column (yellow, bold number)
        const typeRef = XLSX.utils.encode_cell({ r: rowNum, c: 5 });
        if (ws[typeRef]) ws[typeRef].s = styles.typeCell;
      }
      
      // Right side styling (column I)
      const rightRef = XLSX.utils.encode_cell({ r: rowNum, c: 8 });
      if (ws[rightRef] && rightItem) {
        if (rightItem.style === 'instr') ws[rightRef].s = styles.instrText;
        else if (rightItem.style === 'typeHeader') ws[rightRef].s = styles.typeHeader;
        else if (rightItem.style === 'typeName') ws[rightRef].s = styles.typeName;
        else if (rightItem.style === 'typeDesc') ws[rightRef].s = styles.typeDesc;
        else if (rightItem.style === 'typeEx') ws[rightRef].s = { font: { sz: 9, italic: true, color: { rgb: "666666" } } };
        else if (rightItem.style === 'whyHeader') ws[rightRef].s = styles.whyHeader;
        else if (rightItem.style === 'why') ws[rightRef].s = styles.whyText;
      }
    }
    
    // Freeze header rows
    ws['!freeze'] = { xSplit: 0, ySplit: 3 };
    
    XLSX.utils.book_append_sheet(wb, ws, 'Revenue Classification');
    
    // ========== SHEET 2: Type Lookup ==========
    const lookupData = [
      ['Type # — Copy into Column F'],
      ['1 = Contracted - Defined Revenue'],
      ['2 = Service Projects - Contracted Client'],
      ['3 = Hardware/Product - Contracted Client'],
      ['4 = Repeat - Uncontracted'],
      ['5 = Transactional / New'],
    ];
    const wsLookup = XLSX.utils.aoa_to_sheet(lookupData);
    wsLookup['!cols'] = [{ wch: 38 }];
    if (wsLookup['A1']) wsLookup['A1'].s = { font: { bold: true }, fill: { fgColor: { rgb: "E8F5E9" } } };
    XLSX.utils.book_append_sheet(wb, wsLookup, 'Type Lookup');

    // Download
    const safeCompanyName = companyName.replace(/[^a-zA-Z0-9]/g, '_');
    XLSX.writeFile(wb, `${safeCompanyName}_Revenue_Classification.xlsx`);
  };

  // Import completed Revenue Category Form Excel
  const importRevenueCategoryForm = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = '';
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: 'array' });
        
        // Find Revenue Categories sheet
        const sheetName = wb.SheetNames.find(n => n.toLowerCase().includes('revenue')) || wb.SheetNames[0];
        const ws = wb.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
        
        if (rows.length < 5) {
          alert('File appears empty or incorrectly formatted.');
          return;
        }
        
        // Map numbers to type IDs
        const numberToTypeId = {
          '1': 'contracted_defined',
          '2': 'project_contracted',
          '3': 'hardware_contracted',
          '4': 'repeat_uncontracted',
          '5': 'transactional',
          '6': 'recurring_licensing',
          1: 'contracted_defined',
          2: 'project_contracted',
          3: 'hardware_contracted',
          4: 'repeat_uncontracted',
          5: 'transactional',
          6: 'recurring_licensing',
        };
        
        // Also support text labels for backward compatibility
        const textToTypeId = {
          'contracted - defined revenue': 'contracted_defined',
          'contracted-defined revenue': 'contracted_defined',
          'service projects - contracted client': 'project_contracted',
          'hardware/product - contracted client': 'hardware_contracted',
          'repeat - uncontracted': 'repeat_uncontracted',
          'transactional / new': 'transactional',
          'transactional': 'transactional',
          'recurring licensing / subscription resale': 'recurring_licensing',
          'recurring licensing': 'recurring_licensing',
        };
        
        // Get current categories for matching
        const currentCats = [...revenueCategories];
        
        // Parse data rows (starting from row 4, index 3)
        let matched = 0;
        let updated = 0;
        const unmatched = [];
        const unreadableTypes = [];
        const mixedTypes = [];
        const updates = {};

        for (let i = 3; i < rows.length; i++) {
          const row = rows[i];
          const name = String(row[0] || '').trim();
          const typeValue = row[5];

          if (!name) continue;
          // Skip hint rows and instruction text
          if (name.startsWith('(') || name.startsWith('↳') || name.startsWith('→')) continue;

          // Find matching category by name (case-insensitive, trim whitespace)
          const catIdx = currentCats.findIndex(c => c.name && c.name.trim().toLowerCase() === name.toLowerCase());

          if (catIdx >= 0) {
            matched++;

            // Try to map the type value (number or text). The Type Lookup
            // sheet tells owners to COPY its rows into column F, so the cell
            // often arrives as the full string "1 = Contracted - Defined
            // Revenue" (RVS Computers 08-13: every row imported, zero types
            // applied) — a leading digit or a "N = " prefix must both read.
            //
            // A cell can also carry MORE THAN ONE type (RVS Computers 08-24:
            // their largest line held "2 = Service Projects…" and "1 =
            // Contracted…" stacked in one cell — a blended category). Picking
            // one silently misstates revenue quality, so collect every
            // readable type first and refuse to choose when there are two:
            // blends belong in the % split editor, not a coin flip.
            const s = typeValue == null ? '' : String(typeValue).trim();
            const typesInCell = new Set();
            for (const m of s.matchAll(/(?:^|[\s,;\/&+])(\d)(?=\s*(?:[=\-–:.)]|[\s,;]|$))/g)) {
              if (numberToTypeId[m[1]]) typesInCell.add(numberToTypeId[m[1]]);
            }
            for (const seg of s.split(/\r?\n|;/)) {
              const t = seg.trim().toLowerCase().replace(/^\d\s*[=\-–:.)]\s*/, '').trim();
              if (textToTypeId[t]) typesInCell.add(textToTypeId[t]);
            }

            let typeId = null;
            if (typesInCell.size === 1) {
              typeId = typesInCell.values().next().value;
            } else if (typesInCell.size === 0 && s) {
              typeId = numberToTypeId[typeValue];
              const mNum = s.match(/^(\d)\s*(?:[=\-–:.)]|$)/);
              if (!typeId && mNum) typeId = numberToTypeId[mNum[1]];
              if (!typeId) typeId = textToTypeId[s.toLowerCase().replace(/^\d\s*[=\-–:.)]\s*/, '').trim()];
              if (!typeId) typeId = textToTypeId[s.toLowerCase()];
            }

            if (typesInCell.size > 1) {
              const noteText = String(row[6] || '').trim();
              mixedTypes.push(`${name}: "${s.replace(/\s*\r?\n\s*/g, '  +  ').slice(0, 90)}"${noteText ? ` — notes: "${noteText.slice(0, 60)}"` : ''}`);
            } else if (typeId) {
              updates[currentCats[catIdx].id] = { typeId, changed: currentCats[catIdx].revenueType !== typeId };
              if (currentCats[catIdx].revenueType !== typeId) updated++;
            } else if (s) {
              unreadableTypes.push(`${name}: "${s.slice(0, 40)}"`);
            }
          } else {
            // Track unmatched for feedback
            if (typeValue) unmatched.push(name);
          }
        }
        
        if (matched === 0 && unmatched.length > 0) {
          // Show what we found in Excel vs what's in the tool
          const toolNames = currentCats.filter(c => c.name).map(c => c.name).slice(0, 5);
          alert(`⚠️ No categories matched!\n\nExcel has: ${unmatched.slice(0, 3).join(', ')}${unmatched.length > 3 ? '...' : ''}\n\nTool has: ${toolNames.join(', ')}${toolNames.length > 5 ? '...' : ''}\n\nMake sure this Excel was exported from this same deal.`);
          return;
        }
        
        // Now apply updates
        captureUndoState('Import Revenue Classification');
        
        setRevenueCategories(prev => prev.map(c => {
          if (updates[c.id]) {
            return { ...c, revenueType: updates[c.id].typeId, isVerified: true };
          }
          return c;
        }));
        
        let msg = `✅ Revenue Classification Import Complete\n\n${matched} categories matched\n${updated} types updated`;
        if (mixedTypes.length > 0) {
          msg += `\n\n🔀 ${mixedTypes.length} line${mixedTypes.length === 1 ? ' lists' : 's list'} MORE THAN ONE type — blended revenue. No type was applied; ask the owner for the % breakout, then enter it with the line's % split button:\n${mixedTypes.slice(0, 5).join('\n')}`;
          if (mixedTypes.length > 5) msg += `\n...and ${mixedTypes.length - 5} more`;
        }
        if (unmatched.length > 0) {
          msg += `\n\n⚠️ ${unmatched.length} rows in Excel not found in tool:\n${unmatched.slice(0, 5).join('\n')}`;
          if (unmatched.length > 5) msg += `\n...and ${unmatched.length - 5} more`;
        }
        if (unreadableTypes.length > 0) {
          msg += `\n\n⚠️ ${unreadableTypes.length} rows had a Type we couldn't read (expected 1–6 or a type name):\n${unreadableTypes.slice(0, 5).join('\n')}`;
          if (unreadableTypes.length > 5) msg += `\n...and ${unreadableTypes.length - 5} more`;
        }
        msg += `\n\nEvery category with a single readable Type was marked "Verified"`;
        
        alert(msg);
        
      } catch (err) {
        console.error('Revenue classification import error:', err);
        alert('Error importing file: ' + err.message);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const applyLoadedData = (data) => {
    // Applying data is a fresh start - don't capture undo state
    try {
        
        // Restore all state
        // Merge dealProfile with defaults for backward compatibility (new fields: city, state, locationType, fiscalYearEndMonth)
        if (data.dealProfile) setDealProfile({
          companyName: '', dealStage: 'initial', assignedAnalyst: '', initialMeetingDate: '',
          valuationMeetingDate: '', targetCloseDate: '', dealNotes: '', city: '', state: '', locationType: 'suburban',
          fiscalYearEndMonth: 12,
          ...data.dealProfile
        });
        if (data.marketCondition) setMarketCondition(data.marketCondition);
        if (data.businessModel) setBusinessModel(data.businessModel);
        // baseMultipleTable - always use current defaults (revised Feb 2026)
        // Do not load from saved data to ensure all projects use updated scale
        // industryBenchmarks is now derived from industrySectors, skip loading old version
        
        // Migration map for old industry IDs to new ones
        const industryIdMigration = {
          'manufacturing-general': 'mfg-general',
          'manufacturing-aerospace': 'mfg-aerospace',
          'manufacturing-medical': 'mfg-medical',
          'manufacturing-food': 'mfg-food',
          'manufacturing-precision': 'mfg-precision',
          'manufacturing-plastics': 'mfg-plastics',
          'manufacturing-metal': 'mfg-metal',
          'manufacturing-packaging': 'mfg-packaging',
          'manufacturing-electronics': 'mfg-electronics'
        };
        
        // Determine final industry ID (with migration). A saved deal with
        // no industry stays EMPTY (was: silently became 'it-msp' — the
        // Airmerica default-carry; 08-27 force-a-pick).
        const migratedIndustryId = data.selectedIndustry ?
          (industryIdMigration[data.selectedIndustry] || data.selectedIndustry) : '';

        // Find correct sector for this industry (may differ from saved sector if migrated)
        let finalSector = data.selectedSector || '';
        for (const sector of industrySectors) {
          if (sector.industries.find(i => i.id === migratedIndustryId)) {
            finalSector = sector.id;
            break;
          }
        }
        
        // Set sector FIRST, then industry synchronously — no setTimeout needed
        // because the useEffect only resets industry for truly unknown IDs now
        setSelectedSector(finalSector);
        setSelectedIndustry(migratedIndustryId);
        
        // Helper function to ensure unique IDs in category arrays and fix monthly data
        const ensureUniqueIds = (categories, monthlyDataKey) => {
          if (!categories || categories.length === 0) return categories;
          const seenIds = new Set();
          const idMapping = {}; // old id -> new id for duplicates
          const fixedCategories = categories.map(cat => {
            // Ensure tax property exists (migration for older saves)
            const withTax = {
              ...cat,
              tax: cat.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
            };
            if (seenIds.has(withTax.id)) {
              // Duplicate ID found - assign a new unique ID
              const newId = Date.now() + Math.random();
              idMapping[withTax.id] = idMapping[withTax.id] || []; // Track all new IDs for this old ID
              idMapping[withTax.id].push(newId);
              console.log(`Fixed duplicate category ID: ${withTax.id} -> ${newId} for "${withTax.name}"`);
              return { ...withTax, id: newId };
            }
            seenIds.add(withTax.id);
            return withTax;
          });
          
          // If we had duplicates, update the monthly data in the loaded data object
          if (Object.keys(idMapping).length > 0 && data[monthlyDataKey]) {
            const monthlyData = data[monthlyDataKey];
            Object.entries(idMapping).forEach(([oldId, newIds]) => {
              if (monthlyData[oldId]) {
                // Copy data to each new ID
                newIds.forEach(newId => {
                  monthlyData[newId] = JSON.parse(JSON.stringify(monthlyData[oldId]));
                });
              }
            });
          }
          
          return fixedCategories;
        };
        
        // Helper for expense categories - adds addback fields migration
        const ensureExpenseUniqueIds = (categories, monthlyDataKey) => {
          if (!categories || categories.length === 0) return categories;
          const seenIds = new Set();
          const idMapping = {}; // old id -> new id for duplicates
          const fixedCategories = categories.map(cat => {
            // Ensure tax property and addback fields exist (migration for older saves)
            const withFields = {
              ...cat,
              tax: cat.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 },
              addbackPct: cat.addbackPct || 0,
              adjCategory: cat.adjCategory || '',
              adjDescription: cat.adjDescription || '',
              adjVerSource: cat.adjVerSource || '',
              adjDocRef: cat.adjDocRef || '',
              adjIncluded: cat.adjIncluded !== undefined ? cat.adjIncluded : true
            };
            if (seenIds.has(withFields.id)) {
              // Duplicate ID found - assign a new unique ID
              const newId = Date.now() + Math.random();
              idMapping[withFields.id] = idMapping[withFields.id] || [];
              idMapping[withFields.id].push(newId);
              console.log(`Fixed duplicate category ID: ${withFields.id} -> ${newId} for "${withFields.name}"`);
              return { ...withFields, id: newId };
            }
            seenIds.add(withFields.id);
            return withFields;
          });
          
          // If we had duplicates, update the monthly data in the loaded data object
          if (Object.keys(idMapping).length > 0 && data[monthlyDataKey]) {
            const monthlyData = data[monthlyDataKey];
            Object.entries(idMapping).forEach(([oldId, newIds]) => {
              if (monthlyData[oldId]) {
                newIds.forEach(newId => {
                  monthlyData[newId] = JSON.parse(JSON.stringify(monthlyData[oldId]));
                });
              }
            });
          }
          
          return fixedCategories;
        };
        
        if (data.revenueCategories) setRevenueCategories(ensureUniqueIds(data.revenueCategories, 'monthlyTtmRevenue'));
        if (data.cogsCategories) setCogsCategories(ensureUniqueIds(data.cogsCategories, 'monthlyTtmCogs'));
        if (data.opexCategories) setOpexCategories(ensureExpenseUniqueIds(data.opexCategories, 'monthlyTtmOpex'));
        if (data.otherIncomeCategories) setOtherIncomeCategories(ensureExpenseUniqueIds(data.otherIncomeCategories, 'monthlyTtmOtherIncome'));
        if (data.otherExpenseCategories) setOtherExpenseCategories(ensureExpenseUniqueIds(data.otherExpenseCategories, 'monthlyTtmOtherExpense'));
        if (data.diatCategories) setDiatCategories(data.diatCategories);
        if (data.revenueStreams) setRevenueStreams(data.revenueStreams);
        if (data.ttmMonthlyData) setTtmMonthlyData(data.ttmMonthlyData);
        if (data.valuationBasis) setValuationBasis(data.valuationBasis);
        if (data.addbacks) setAddbacks(data.addbacks);
        // Migrate ownerCompensation to ensure all periods exist
        if (data.ownerCompensation) {
          const defaultPeriod = { salary: 0, source: 'qa', verified: false, verificationDoc: '' };
          setOwnerCompensation({
            year1: data.ownerCompensation.year1 || defaultPeriod,
            year2: data.ownerCompensation.year2 || defaultPeriod,
            year3: data.ownerCompensation.year3 || defaultPeriod,
            year4: data.ownerCompensation.year4 || defaultPeriod,
            year5: data.ownerCompensation.year5 || defaultPeriod,
            ttm: (() => {
              const t = data.ownerCompensation.ttm || defaultPeriod;
              // Auto-verify when embedded in wages with no separate salary — nothing to verify
              if (data.ownerCompensation.embeddedInWages && (!t.salary || t.salary === 0) && (!data.ownerCompensation.marketReplacement || data.ownerCompensation.marketReplacement === 0)) {
                return { ...t, verified: true };
              }
              return t;
            })(),
            marketReplacement: data.ownerCompensation.marketReplacement || 0,
            marketReplacementNotes: data.ownerCompensation.marketReplacementNotes || '',
            replacementRoles: Array.isArray(data.ownerCompensation.replacementRoles) ? data.ownerCompensation.replacementRoles : [],
            ownerCount: data.ownerCompensation.ownerCount != null ? data.ownerCompensation.ownerCount : null,
            replacementCount: data.ownerCompensation.replacementCount != null ? data.ownerCompensation.replacementCount : null,
            embeddedInWages: data.ownerCompensation.embeddedInWages !== undefined ? data.ownerCompensation.embeddedInWages : true,
            payrollTaxRate: data.ownerCompensation.payrollTaxRate !== undefined ? data.ownerCompensation.payrollTaxRate : 7.65,
            includePayrollTax: data.ownerCompensation.includePayrollTax !== undefined ? data.ownerCompensation.includePayrollTax : true
          });
        }
        if (data.adjustmentItems) setAdjustmentItems(data.adjustmentItems);
        if (data.adjustmentsStatus) setAdjustmentsStatus(data.adjustmentsStatus);
        if (data.valuationInputs) setValuationInputs(data.valuationInputs);
        if (data.dealStructure) setDealStructure(data.dealStructure);
        if (data.sbaParams) setSbaParams(data.sbaParams);
        if (data.documentChecklist) {
          // Migration: Remove id 6 (TTM Sales Report by Customer) which was removed from the tool
          // Migration: Convert old 'received' boolean to new 'status' field
          // Migration: Add document 27 (Cash P&L) if it doesn't exist (for old saves)
          let migratedChecklist = data.documentChecklist.filter(d => d.id !== 6).map(d => {
            if (d.status) { if (d.received === undefined) return d; const { received, ...rest } = d; return rest; } // status is the truth — drop the legacy boolean so it can never shadow it again (Forward Slash 08-21)
            return {
              ...d,
              status: d.received ? 'complete' : 'not_received',
              receivedNotes: d.receivedNotes || '',
              pendingNotes: d.pendingNotes || ''
            };
          });
          // Add Cash P&L (id 27) if missing
          if (!migratedChecklist.find(d => d.id === 27)) {
            const insertIdx = migratedChecklist.findIndex(d => d.id === 2);
            const newDoc = { id: 27, name: 'P&L Statements (3 years) - Cash - Excel', status: 'not_received', dateProvided: '', notes: '', receivedNotes: '', pendingNotes: '', tier: 'full' };
            if (insertIdx >= 0) {
              migratedChecklist.splice(insertIdx, 0, newDoc);
            } else {
              migratedChecklist.push(newDoc);
            }
          }
          // Add Revenue Classification Form (id 28) if missing — VT-generated after P&Ls received
          if (!migratedChecklist.find(d => d.id === 28)) {
            const insertIdx = migratedChecklist.findIndex(d => d.id === 27);
            const newDoc = { id: 28, name: 'Revenue Classification Form', status: 'not_received', dateProvided: '', notes: 'VT-generated after P&Ls are entered; owner classifies revenue lines and returns', receivedNotes: '', pendingNotes: '', tier: 'full', unlockedBy: [1, 27] };
            if (insertIdx >= 0) {
              migratedChecklist.splice(insertIdx + 1, 0, newDoc);
            } else {
              migratedChecklist.push(newDoc);
            }
          }
          // Add Client Detail Form (id 29) if missing — VT-generated after Sales Report received
          if (!migratedChecklist.find(d => d.id === 29)) {
            const insertIdx = migratedChecklist.findIndex(d => d.id === 26);
            const newDoc = { id: 29, name: 'Client Detail Form', status: 'not_received', dateProvided: '', notes: 'VT-generated after Sales Report is entered; owner provides additional client info and returns', receivedNotes: '', pendingNotes: '', tier: 'full', unlockedBy: [5, 26] };
            if (insertIdx >= 0) {
              migratedChecklist.splice(insertIdx + 1, 0, newDoc);
            } else {
              migratedChecklist.push(newDoc);
            }
          }
          // Update document 1 name if it's the old combined name
          migratedChecklist = migratedChecklist.map(d => {
            if (d.id === 1 && d.name.includes('Cash & Accrual')) {
              return { ...d, name: 'P&L Statements (3 years) - Accrual - Excel' };
            }
            return d;
          });
          setDocumentChecklist(migratedChecklist);
        }
        
        // Migrate sellerQA - use new question structure
        if (data.sellerQA) {
          // Re-sync to DEFAULT_SELLER_QA (the single source of truth) so newly
          // added questions appear on existing valuations and none are silently
          // dropped. This was previously a duplicated inline copy of the question
          // list that drifted from DEFAULT_SELLER_QA and stripped question id 30
          // (ownership designations) on every load — do NOT reintroduce a second
          // copy of the list here; add questions to DEFAULT_SELLER_QA only.
          const defaultQA = DEFAULT_SELLER_QA;
          // Merge: keep answers/status/numericValue from loaded data, use new question structure
          const mergedQA = defaultQA.map(defQ => {
            const loaded = data.sellerQA.find(q => q.id === defQ.id);
            if (loaded) {
              return { 
                ...defQ, 
                answer: loaded.answer || '', 
                status: loaded.status || 'pending', 
                numericValue: loaded.numericValue !== undefined ? loaded.numericValue : defQ.numericValue,
                numericValue2: loaded.numericValue2 !== undefined ? loaded.numericValue2 : defQ.numericValue2,
                ...(Array.isArray(loaded.positions) ? { positions: loaded.positions } : {}),
                followUps: loaded.followUps || [] 
              };
            }
            return defQ;
          });
          // Fix: match text answers to select options for questions that were answered before dropdown existed
          const fixedQA = mergedQA.map(qa => {
            if (qa.selectOptions && qa.answer && qa.numericValue == null) {
              const answerLower = qa.answer.toLowerCase().trim();
              let matched = qa.selectOptions.find(opt => opt.label.toLowerCase() === answerLower);
              if (!matched) matched = qa.selectOptions.find(opt => answerLower.includes(opt.label.toLowerCase()) || opt.label.toLowerCase().includes(answerLower));
              if (!matched) {
                const pctMatch = answerLower.match(/(\d+)\s*[-–]\s*(\d+)|(\d+)\s*%/);
                if (pctMatch) {
                  const pctVal = pctMatch[3] ? parseInt(pctMatch[3]) : (parseInt(pctMatch[1]) + parseInt(pctMatch[2])) / 2;
                  matched = qa.selectOptions.find(opt => {
                    const rangeMatch = opt.label.match(/(\d+)\s*[-–]\s*(\d+)/);
                    if (rangeMatch) return pctVal >= parseInt(rangeMatch[1]) && pctVal <= parseInt(rangeMatch[2]);
                    return false;
                  });
                }
              }
              if (matched) return { ...qa, numericValue: matched.value, answer: matched.label };
            }
            return qa;
          });
          setSellerQA(fixedQA);
        }
        
        if (data.researchItems) setResearchItems(data.researchItems);
        if (data.acknowledgedFlags) setAcknowledgedFlags(data.acknowledgedFlags);
        
        // Migrate multipleAdjustments - merge old structure with new fields
        if (data.multipleAdjustments) {
          const defaultMA = {
            revenueQuality: { useWeightedCalculation: true, monthlyReviewed: false, monthlyManualAdjustment: 0, customerType: 'b2b_only', customerTypeNotes: '' },
            ebitdaQuality: { monthlyReviewed: false, monthlyManualAdjustment: 0, negativeMonthsReviewed: false, negativeMonthsOverride: null, negativeMonthsNotes: '' },
            customerRetention: { year1: { retentionRate: 0, verified: false }, year2: { retentionRate: 0, verified: false }, year3: { retentionRate: 0, verified: false }, avgRetentionRate: 0, notes: '' },
            clientChurn: { ttmLostClientRevenue: 0, ttmNewClientRevenue: 0, ttmPriorRevenue: 0, verified: false, notes: '' },
            contractTerms: { avgContractLength: 0, transferability: 'unknown', hasInflationClauses: false, hasExitClauses: false, hasAutoRenewal: false, hasPriceEscalators: false, escalatorPercent: 0, hasEarlyTermPenalty: false, notes: '' },
            concentration: { topCustomerPct: 0, top5CustomersPct: 0, topVendorPct: 0, vendorNotes: '', clientIndustries: [], industryConcentrationAdjustment: 0, industryConcentrationNotes: '', totalClientCount: 0, topCustomerContracted: 'unknown' },
            ownerTransition: { ownersStaying: 'unknown', notes: '' },
            otherAdjustments: [],
            ownerDependency: { involvementLevel: 'unknown', hoursPerWeek: null, revenueGenerationPct: null, manualAdjustment: 0, notes: '' },
            workingCapitalQuality: { arPastDueOverride: null, arPastDueNotes: '', arPastDueReviewed: false, arSeriousOverride: null, arSeriousNotes: '', arSeriousReviewed: false, negativeBalancesOverride: null, negativeBalancesNotes: '', negativeBalancesReviewed: false },
            franchise: { isFranchise: false, franchiseName: '', royaltyRate: 0, marketingFundRate: 0, transferFee: 0, remainingTermYears: null, franchisorApproval: false, territoryExclusive: false, territoryNotes: '', notes: '' }
          };
          // Deep merge: for each section, merge loaded values with defaults
          // Special handling for array fields
          const arrayFields = ['otherAdjustments'];
          const migratedMA = {};
          for (const key of Object.keys(defaultMA)) {
            if (arrayFields.includes(key)) {
              // Array fields: use loaded array if it's an array, otherwise use default
              migratedMA[key] = Array.isArray(data.multipleAdjustments[key]) ? data.multipleAdjustments[key] : defaultMA[key];
            } else if (data.multipleAdjustments[key]) {
              migratedMA[key] = { ...defaultMA[key], ...data.multipleAdjustments[key] };
            } else {
              migratedMA[key] = defaultMA[key];
            }
          }
          setMultipleAdjustments(migratedMA);
        }
        
        // Don't restore expandedSections from saved files - always start with sections closed
        // Exception: overviewDiscovery should be expanded by default for supervisor review
        setExpandedSections({ 
          sizeFactor: false, industryFactor: false, locationFactor: false, marketFactor: false,
          revenueQuality: false, ebitdaQuality: false, 
          customerRetention: false, contractTerms: false, concentration: false, 
          ownerTransition: false, ownerDependency: false, otherAdjustments: false, workingCapital: false, franchise: false,
          overviewDiscovery: true, overviewResolved: false, lineAddbacks: false
        });
        
        // Sales data — prefer new format; fall back to migrating from old format.
        if (data.customerSalesCash) {
          setCustomerSalesCash(deduplicateCustomers(data.customerSalesCash));
          setCustomerSalesAccrual(data.customerSalesAccrual ? deduplicateCustomers(data.customerSalesAccrual) : []);
        } else if (data.customerSalesData) {
          const oldBasis = data.customerSalesBasis || 'cash';
          const primary = deduplicateCustomers(data.customerSalesData);
          const alt = data.customerSalesDataAlt ? deduplicateCustomers(data.customerSalesDataAlt) : [];
          if (oldBasis === 'cash') { setCustomerSalesCash(primary); setCustomerSalesAccrual(alt); }
          else { setCustomerSalesAccrual(primary); setCustomerSalesCash(alt); }
        }
        if (data.monthlySalesData) setMonthlySalesData(data.monthlySalesData);
        if (data.salesViewBasis) setSalesViewBasis(data.salesViewBasis);
        else if (data.customerSalesBasis) setSalesViewBasis(data.customerSalesBasis);
        setBlueprintTargetValuation(data.blueprintTargetValuation != null ? data.blueprintTargetValuation : null);
        setBlueprintTimelineYears(data.blueprintTimelineYears != null ? data.blueprintTimelineYears : null);
        setBlueprintTargetMargin(data.blueprintTargetMargin != null ? data.blueprintTargetMargin : null);
        if (data.proFormaItems) setProFormaItems(data.proFormaItems);
        if (data.proFormaValuationBasis) setProFormaValuationBasis(data.proFormaValuationBasis);
        restorePortfolio(data.portfolio);
        if (data.customerYearLabels) setCustomerYearLabels(data.customerYearLabels);
        if (data.salesTtmConfig) setSalesTtmConfig({ ...data.salesTtmConfig, useMonthlyForTtm: true }); else if (data.monthlyTtmConfig) setSalesTtmConfig({ endMonth: data.monthlyTtmConfig.endMonth, endYear: data.monthlyTtmConfig.endYear });
        if (data.arAgingData) setArAgingData(data.arAgingData);
        if (data.arAgingLineItems) setArAgingLineItems(data.arAgingLineItems);
        if (data.arAgingBucketLabels) setArAgingBucketLabels(data.arAgingBucketLabels);
        if (data.arReviewChecklist) setArReviewChecklist(data.arReviewChecklist);
        if (data.arAgingNotes) setArAgingNotes(data.arAgingNotes);
        if (data.salesDetailNotes) setSalesDetailNotes(data.salesDetailNotes);
        if (data.apAnalysis) setApAnalysis(data.apAnalysis);
        if (data.apAgingLineItems) setApAgingLineItems(data.apAgingLineItems);
        if (data.apAgingBucketLabels) setApAgingBucketLabels(data.apAgingBucketLabels);
        if (data.apReviewChecklist) setApReviewChecklist(data.apReviewChecklist);
        if (data.bsYearLabels) setBsYearLabels(data.bsYearLabels);
        if (data.bsBasis) setBsBasis(data.bsBasis);
        if (data.bsCurrentAssets) setBsCurrentAssets(data.bsCurrentAssets);
        if (data.bsFixedAssets) setBsFixedAssets(data.bsFixedAssets);
        if (data.bsOtherAssets) setBsOtherAssets(data.bsOtherAssets);
        if (data.bsCurrentLiabilities) setBsCurrentLiabilities(data.bsCurrentLiabilities);
        if (data.bsLongTermLiabilities) setBsLongTermLiabilities(data.bsLongTermLiabilities);
        if (data.bsEquity) setBsEquity(data.bsEquity);
        if (data.bsRecognitionNotes) setBsRecognitionNotes(data.bsRecognitionNotes);
        if (data.bsIssueNotes) setBsIssueNotes(data.bsIssueNotes);
        if (data.custRevenueNotes) setCustRevenueNotes(data.custRevenueNotes);
        // Note: industryMultipleAdjustment is now derived from selectedIndustry, not loaded from save
        // This ensures it always matches the current industry's adjustment value
        if (data.showInternalControls !== undefined) setShowInternalControls(data.showInternalControls);
        if (data.basisComparisonData) setBasisComparisonData(data.basisComparisonData);
        if (data.taxFilingBasis) setTaxFilingBasis(data.taxFilingBasis);
        if (data.taxReturnTotals) {
          // Migrate old year1/year2/year3 to year3/year4/year5 if needed
          // Use nullish coalescing (??) to preserve 0 values, only fall back if undefined/null
          const t = data.taxReturnTotals;
          const hasNewSchema = t.revenue?.year5 !== undefined || t.revenue?.year4 !== undefined;
          const migratedTotals = {
            revenue: {
              year3: t.revenue?.year3 ?? (hasNewSchema ? 0 : (t.revenue?.year1 ?? 0)),
              year4: t.revenue?.year4 ?? (hasNewSchema ? 0 : (t.revenue?.year2 ?? 0)),
              year5: t.revenue?.year5 ?? 0
            },
            cogs: {
              year3: t.cogs?.year3 ?? (hasNewSchema ? 0 : (t.cogs?.year1 ?? 0)),
              year4: t.cogs?.year4 ?? (hasNewSchema ? 0 : (t.cogs?.year2 ?? 0)),
              year5: t.cogs?.year5 ?? 0
            },
            expenses: {
              year3: t.expenses?.year3 ?? 0,
              year4: t.expenses?.year4 ?? 0,
              year5: t.expenses?.year5 ?? 0
            }
          };
          setTaxReturnTotals(migratedTotals);
        }
        if (data.selectedValuationBasis) setSelectedValuationBasis(data.selectedValuationBasis);
        if (data.basisYearLabels) setBasisYearLabels(data.basisYearLabels);
        if (data.showAllYears !== undefined) setShowAllYears(data.showAllYears);
        if (data.incomeStmtViewMode) setIncomeStmtViewMode(data.incomeStmtViewMode);
        if (data.basisYearTab) setBasisYearTab(data.basisYearTab);
        if (data.monthlyTtmConfig) {
          // Merge with defaults to handle new properties added after file was saved
          setMonthlyTtmConfig({
            endMonth: data.monthlyTtmConfig.endMonth ?? new Date().getMonth(),
            endYear: data.monthlyTtmConfig.endYear ?? new Date().getFullYear(),
            showArchive: data.monthlyTtmConfig.showArchive ?? false,
            useMonthlyForTtm: data.monthlyTtmConfig.useMonthlyForTtm ?? true,
            varianceThreshold: data.monthlyTtmConfig.varianceThreshold ?? 20,
            annVsTtmVarianceThreshold: data.monthlyTtmConfig.annVsTtmVarianceThreshold ?? 15,
            annVsTtmMaterialityThreshold: data.monthlyTtmConfig.annVsTtmMaterialityThreshold ?? 1000,
            monthlyMaterialityThreshold: data.monthlyTtmConfig.monthlyMaterialityThreshold ?? 500,
            yoyCompareMode: data.monthlyTtmConfig.yoyCompareMode ?? 'prior',
            bsVarianceThreshold: data.monthlyTtmConfig.bsVarianceThreshold ?? 25,
            bsMaterialityThreshold: data.monthlyTtmConfig.bsMaterialityThreshold ?? 5000
          });
        }
        if (data.monthlyTtmRevenue) setMonthlyTtmRevenue(data.monthlyTtmRevenue);
        if (data.monthlyTtmCogs) setMonthlyTtmCogs(data.monthlyTtmCogs);
        if (data.monthlyTtmOpex) setMonthlyTtmOpex(data.monthlyTtmOpex);
        if (data.monthlyTtmOtherIncome) setMonthlyTtmOtherIncome(data.monthlyTtmOtherIncome);
        if (data.monthlyTtmOtherExpense) setMonthlyTtmOtherExpense(data.monthlyTtmOtherExpense);
        if (data.monthlyTtmDiat) setMonthlyTtmDiat(data.monthlyTtmDiat);
        if (data.monthlyTtmNotes) setMonthlyTtmNotes(data.monthlyTtmNotes);
        if (data.reviewFlags) setReviewFlags(data.reviewFlags);
        if (data.manualReviewFlags) setManualReviewFlags(data.manualReviewFlags);
        if (data.reconVarianceStatus) setReconVarianceStatus(data.reconVarianceStatus);
        if (data.reconQualityChecklist) setReconQualityChecklist(data.reconQualityChecklist);
        if (data.scheduleM1) setScheduleM1(data.scheduleM1);
        if (data.bsVarianceStatus) setBsVarianceStatus(data.bsVarianceStatus);
        if (data.incomeVarianceStatus) setIncomeVarianceStatus(data.incomeVarianceStatus);
        if (data.ttmBsMonthLabels) setTtmBsMonthLabels(data.ttmBsMonthLabels);
        if (data.ttmBsCurrentAssets) setTtmBsCurrentAssets(data.ttmBsCurrentAssets);
        if (data.ttmBsFixedAssets) setTtmBsFixedAssets(data.ttmBsFixedAssets);
        if (data.ttmBsOtherAssets) setTtmBsOtherAssets(data.ttmBsOtherAssets);
        if (data.ttmBsCurrentLiabilities) setTtmBsCurrentLiabilities(data.ttmBsCurrentLiabilities);
        if (data.ttmBsLongTermLiabilities) setTtmBsLongTermLiabilities(data.ttmBsLongTermLiabilities);
        if (data.ttmBsEquity) setTtmBsEquity(data.ttmBsEquity);
        if (data.wcPegMethodology) setWcPegMethodology(data.wcPegMethodology);
        if (data.wcCustomMonths) setWcCustomMonths(data.wcCustomMonths);
        if (data.rollOffAcknowledged) setRollOffAcknowledged(data.rollOffAcknowledged);
        if (data.cimTechStack) setCimTechStack(data.cimTechStack);
        if (data.cimVendors) setCimVendors(data.cimVendors);
        if (data.cimContractTerms) setCimContractTerms(data.cimContractTerms);
        if (data.cimEmployees) setCimEmployees(data.cimEmployees);
        if (data.cimEmpDisclosure) setCimEmpDisclosure(data.cimEmpDisclosure);
        if (data.cimEmpComp) setCimEmpComp(data.cimEmpComp);
        if (data.cimEmpIncentives != null) setCimEmpIncentives(data.cimEmpIncentives);
        if (data.cimFFE) setCimFFE(data.cimFFE);
        if (data.cimFFEDisclosure) setCimFFEDisclosure(data.cimFFEDisclosure);
        if (Array.isArray(data.cimCustomGroups)) setCimCustomGroups(data.cimCustomGroups);
        if (Array.isArray(data.cimClientAttrCols)) setCimClientAttrCols(data.cimClientAttrCols);
        if (Array.isArray(data.cimTypedPanels)) setCimTypedPanels(data.cimTypedPanels);
        setRevenueScoringSaved(data.revenueScoring === 'legacy' || data.revenueScoring === 'mrr' ? data.revenueScoring : null);
        setCapexMethodSaved(data.capexMethod === 'legacy' || data.capexMethod === 'fcf' ? data.capexMethod : null);
        setGrowthTestSaved(data.growthTest === 'either' || data.growthTest === 'ttm' ? data.growthTest : null); setPayrollTaxMethodSaved(data.payrollTaxMethod === 'flat' || data.payrollTaxMethod === 'wage_base' ? data.payrollTaxMethod : null); setSpikeMathSaved(data.spikeMath === 'mixed' || data.spikeMath === 'consistent' ? data.spikeMath : null);
        setCapexCatchUp(data.capexCatchUp && typeof data.capexCatchUp === 'object' ? { amount: Number(data.capexCatchUp.amount) || 0, note: String(data.capexCatchUp.note || '') } : { amount: 0, note: '' });
        setEbitdaSnapshots(Array.isArray(data.ebitdaSnapshots) ? data.ebitdaSnapshots : []);   // always reset — never inherit another deal's
        setSourceTotals(data.sourceTotals && typeof data.sourceTotals === 'object' ? data.sourceTotals : {});
        setAiReviews(Array.isArray(data.aiReviews) ? data.aiReviews : []);
        if (data.cimFacility) setCimFacility(data.cimFacility);
        if (data.cimLegal) setCimLegal(data.cimLegal);
        if (data.cimGrowth) setCimGrowth(data.cimGrowth);
        if (data.cimGrowthExtra) setCimGrowthExtra(data.cimGrowthExtra);
        if (data.varianceThreshold !== undefined) setVarianceThreshold(data.varianceThreshold);
        if (data.reconMaterialityThreshold !== undefined) setReconMaterialityThreshold(data.reconMaterialityThreshold);
        if (data.arMaterialityThreshold !== undefined) setArMaterialityThreshold(data.arMaterialityThreshold);
        
        // Recalculate industry adjustment from selected industry (not from saved value)
        // This ensures the adjustment always matches the current industry definition
        if (data.selectedIndustry) {
          // Use migrated industry ID
          const migratedId = industryIdMigration[data.selectedIndustry] || data.selectedIndustry;
          for (const sector of industrySectors) {
            const foundIndustry = sector.industries.find(i => i.id === migratedId);
            if (foundIndustry) {
              setIndustryMultipleAdjustment(foundIndustry.adjustment || 0);
              break;
            }
          }
        }
        
        alert(`Loaded: ${data.dealProfile?.companyName || 'Deal'}\nSaved: ${data.savedAt ? new Date(data.savedAt).toLocaleString() : 'Unknown'}`);
        
        // Clear auto-save since we just loaded fresh data
        sessionStorage.removeItem(AUTO_SAVE_KEY);
        setHasUnsavedChanges(false);
        
        // Clear undo/redo stacks - loading a file is a fresh start
        setUndoStack([]);
        setRedoStack([]);
      } catch (err) {
        alert('Error loading data: ' + err.message);
      }
  };

  const loadDeal = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        applyLoadedData(data);
      } catch (err) {
        alert('Error parsing file: ' + err.message);
      }
    };
    reader.readAsText(file);
    event.target.value = '';
  };

  // ========== PORTFOLIO ENTITY LOADING ==========
  // Load a valuation file as a portfolio entity
  const loadPortfolioEntity = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    
    Array.from(files).forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);
          
          // Extract key metrics from the loaded file
          const companyName = data.dealProfile?.companyName || file.name.replace('.json', '');
          
          // Get TTM period label
          const ttmConfig = data.monthlyTtmConfig || { endMonth: 11, endYear: 2025 };
          const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const endMonth = monthNames[ttmConfig.endMonth];
          const endYear = ttmConfig.endYear;
          const startMonth = monthNames[(ttmConfig.endMonth + 1) % 12];
          const startYear = ttmConfig.endMonth === 11 ? ttmConfig.endYear : ttmConfig.endYear - 1;
          const ttmPeriod = `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
          
          // Check if pre-calculated values are available (from newer save format)
          const preCalc = data.calculatedValues;
          let revenue = 0, ebitda = 0, adjustedEbitda = 0;
          let usedPreCalc = false;
          
          if (preCalc && (preCalc.valuationMetric > 0 || preCalc.ttmAdjustedEbitda > 0)) {
            // Use pre-calculated values from save file
            // valuationMetric is the EBITDA actually used for valuation (may be weighted/averaged)
            // This matches what's shown in the Valuation Summary as "Normalized EBITDA"
            revenue = preCalc.ttmRevenue || 0;
            ebitda = preCalc.ttmEbitda || 0;
            adjustedEbitda = preCalc.valuationMetric || preCalc.ttmAdjustedEbitda || 0;
            usedPreCalc = true;
            console.log(`Portfolio: Using pre-calculated values for ${companyName}: Adj EBITDA = $${adjustedEbitda.toLocaleString()} (method: ${preCalc.weightingMethod || 'ttm'})`);
          }
          
          // If we got good pre-calc values, use them
          if (usedPreCalc && adjustedEbitda > 0) {
            const valuationInputs = data.valuationInputs || {};
            const engineCalcs = preCalc.multipleEngine || {};
            
            // Use engine-calculated multiples if available, fall back to manual valuationInputs
            let multipleMin, multipleMax, avgMultiple, valuation;
            
            if (engineCalcs.adjustedMultiple > 0) {
              // NEW: Use the actual engine-calculated multiples
              // adjustedEbitda from engine may differ (pro-forma adjusted)
              adjustedEbitda = engineCalcs.adjustedEbitda || adjustedEbitda;
              multipleMin = engineCalcs.typicalMultiple || 2.55;
              multipleMax = engineCalcs.marketHighMultiple || engineCalcs.adjustedMultiple || 3.0;
              // Use marketHighMultiple as the entity's "multiple" because it's the direct output
              // of Base + Adjustments, which lets the portfolio calc back-calculate adjustments exactly
              avgMultiple = multipleMax;
              valuation = engineCalcs.valuationMarketHigh || (adjustedEbitda * multipleMax);
              console.log(`Portfolio: Using engine-calculated multiples for ${companyName}: ${multipleMin.toFixed(2)}x typical / ${multipleMax.toFixed(2)}x market high (total adj: ${engineCalcs.totalAdjustment >= 0 ? '+' : ''}${engineCalcs.totalAdjustment?.toFixed(2)}x)`);
            } else {
              // LEGACY: Fall back to manual valuationInputs for older files
              multipleMin = valuationInputs.multipleMin || 3.0;
              multipleMax = valuationInputs.multipleMax || 4.0;
              avgMultiple = (multipleMin + multipleMax) / 2;
              valuation = preCalc.valuationMid || (adjustedEbitda * avgMultiple);
              console.log(`Portfolio: Using manual multiples for ${companyName} (no engine data): ${multipleMin.toFixed(2)}x - ${multipleMax.toFixed(2)}x`);
            }
            
            // Get customer data
            const customerSalesData = ((data.customerSalesData && data.customerSalesData.some(c => c && c.name)) ? data.customerSalesData : data.customerSalesDataAlt) || [];
            const customerCount = customerSalesData.filter(c => c.name && (c.ttm > 0 || c.year5 > 0)).length;
            const customerRevenues = customerSalesData.map(c => c.ttm || c.year5 || 0).filter(v => v > 0);
            const totalCustomerRevenue = customerRevenues.reduce((a, b) => a + b, 0);
            const topCustomerAmt = customerRevenues.length > 0 ? Math.max(...customerRevenues) : 0;
            const topCustomerPct = totalCustomerRevenue > 0 ? (topCustomerAmt / totalCustomerRevenue) * 100 : 0;
            
            const entity = {
              id: Date.now() + Math.random(),
              name: companyName,
              fileName: file.name,
              ttmPeriod,
              revenue,
              ebitda,
              adjustedEbitda,
              customerCount,
              topCustomerPct,
              topCustomerAmt,
              multipleMin,
              multipleMax,
              multiple: avgMultiple,
              valuation,
              // Engine-calculated data for portfolio consolidation
              engineData: engineCalcs.adjustedMultiple > 0 ? {
                rawBaseMultiple: engineCalcs.rawBaseMultiple || 0,
                baseMultiple: engineCalcs.baseMultiple || 0,
                totalAdjustment: engineCalcs.totalAdjustment || 0,
                adjustedMultiple: engineCalcs.adjustedMultiple || 0,
                typicalMultiple: engineCalcs.typicalMultiple || 0,
                marketHighMultiple: engineCalcs.marketHighMultiple || 0,
                scaledLocationAdj: engineCalcs.scaledLocationAdj || 0
              } : null,
              discoveryAnswers: data.discoveryAnswers || {},
              loadedAt: new Date().toISOString(),
              usedPreCalc: true,
              usedEngineCalcs: engineCalcs.adjustedMultiple > 0
            };
            
            setPortfolioEntities(prev => {
              const filtered = prev.filter(e => e.fileName !== file.name);
              return [...filtered, entity];
            });
            return;
          }
          
          // Fall back to calculating from raw data (for older save files without calculatedValues)
          console.log(`Portfolio: No pre-calc values for ${companyName}`, preCalc);
          console.log(`Portfolio: Calculating from raw data for ${companyName}...`);
          
          // Get valuation basis
          const basis = data.selectedValuationBasis || 'cash';
          
          // Calculate revenue from categories (use TTM, fallback to year5)
          const revenueCategories = data.revenueCategories || [];
          revenueCategories.forEach(cat => {
            if (cat.name && cat[basis]) {
              revenue += parseFloat(cat[basis].ttm) || parseFloat(cat[basis].year5) || 0;
            }
          });
          
          // Calculate COGS (use TTM, fallback to year5)
          let cogs = 0;
          const cogsCategories = data.cogsCategories || [];
          cogsCategories.forEach(cat => {
            if (cat.name && cat[basis]) {
              cogs += parseFloat(cat[basis].ttm) || parseFloat(cat[basis].year5) || 0;
            }
          });
          
          // Calculate OpEx (use TTM, fallback to year5)
          let opex = 0;
          const opexCategories = data.opexCategories || [];
          opexCategories.forEach(cat => {
            if (cat.name && cat[basis]) {
              opex += parseFloat(cat[basis].ttm) || parseFloat(cat[basis].year5) || 0;
            }
          });
          
          // Calculate Other Income (use TTM, fallback to year5)
          let otherIncome = 0;
          const otherIncomeCategories = data.otherIncomeCategories || [];
          otherIncomeCategories.forEach(cat => {
            if (cat.name && cat[basis]) {
              otherIncome += parseFloat(cat[basis].ttm) || parseFloat(cat[basis].year5) || 0;
            }
          });
          
          // Calculate Other Expense (use TTM, fallback to year5)
          let otherExpense = 0;
          const otherExpenseCategories = data.otherExpenseCategories || [];
          otherExpenseCategories.forEach(cat => {
            if (cat.name && cat[basis]) {
              otherExpense += parseFloat(cat[basis].ttm) || parseFloat(cat[basis].year5) || 0;
            }
          });
          
          // Calculate EBITDA = Revenue - COGS - OpEx + Other Income - Other Expense
          ebitda = revenue - cogs - opex + otherIncome - otherExpense;
          
          // Calculate adjustments
          let totalAdjustments = 0;
          const adjustmentItems = data.adjustmentItems || [];
          adjustmentItems.forEach(adj => {
            if (adj.included !== false) {
              const amt = parseFloat(adj.amount) || 0;
              if (adj.type === 'add') totalAdjustments += amt;
              else totalAdjustments -= amt;
            }
          });
          
          // Add owner compensation adjustment
          const ownerComp = data.ownerCompensation || {};
          const ownerSalary = ownerComp.ttm?.salary || ownerComp.year5?.salary || 0;
          const marketReplacement = ocMarketFor(ownerComp, 'ttm');
          if (marketReplacement > 0 && ownerSalary > marketReplacement) {
            // Owner is paid more than market replacement = add back the excess
            totalAdjustments += (ownerSalary - marketReplacement);
          } else if (marketReplacement > 0 && ownerSalary < marketReplacement) {
            // Owner is paid less than market = deduct the shortfall
            totalAdjustments -= (marketReplacement - ownerSalary);
          }
          
          // Add line-item addbacks from OpEx categories (percentage-based)
          opexCategories.forEach(cat => {
            if (cat.addbackPct && cat.addbackPct > 0 && cat.adjIncluded !== false) {
              const lineValue = parseFloat(cat[basis]?.ttm) || parseFloat(cat[basis]?.year5) || 0;
              totalAdjustments += lineValue * cat.addbackPct / 100;
            }
          });
          
          // Add line-item addbacks from Other Expense categories (percentage-based)
          otherExpenseCategories.forEach(cat => {
            if (cat.addbackPct && cat.addbackPct > 0 && cat.adjIncluded !== false) {
              const lineValue = parseFloat(cat[basis]?.ttm) || parseFloat(cat[basis]?.year5) || 0;
              totalAdjustments += lineValue * cat.addbackPct / 100;
            }
          });
          
          // Deduct line-item adjustments from Other Income categories (removes non-operating income)
          otherIncomeCategories.forEach(cat => {
            if (cat.addbackPct && cat.addbackPct > 0 && cat.adjIncluded !== false) {
              const lineValue = parseFloat(cat[basis]?.ttm) || parseFloat(cat[basis]?.year5) || 0;
              totalAdjustments -= lineValue * cat.addbackPct / 100;
            }
          });
          
          // Add back D/I/A/T if applicable (use TTM, fallback to year5)
          const diat = data.diatCategories || {};
          const addBackD = data.addBackDepreciation !== false;
          const addBackI = data.addBackInterest !== false;
          const addBackA = data.addBackAmortization !== false;
          const addBackT = data.addBackTaxes !== false;
          
          if (addBackD && diat.depreciation?.[basis]) totalAdjustments += parseFloat(diat.depreciation[basis].ttm) || parseFloat(diat.depreciation[basis].year5) || 0;
          if (addBackI && diat.interest?.[basis]) totalAdjustments += parseFloat(diat.interest[basis].ttm) || parseFloat(diat.interest[basis].year5) || 0;
          if (addBackA && diat.amortization?.[basis]) totalAdjustments += parseFloat(diat.amortization[basis].ttm) || parseFloat(diat.amortization[basis].year5) || 0;
          if (addBackT && diat.taxes?.[basis]) totalAdjustments += parseFloat(diat.taxes[basis].ttm) || parseFloat(diat.taxes[basis].year5) || 0;
          
          adjustedEbitda = ebitda + totalAdjustments;
          
          // Get customer data
          const customerSalesData = ((data.customerSalesData && data.customerSalesData.some(c => c && c.name)) ? data.customerSalesData : data.customerSalesDataAlt) || [];
          const customerCount = customerSalesData.filter(c => c.name && (c.ttm > 0 || c.year5 > 0)).length;
          
          // Calculate customer concentration
          const customerRevenues = customerSalesData.map(c => c.ttm || c.year5 || 0).filter(v => v > 0);
          const totalCustomerRevenue = customerRevenues.reduce((a, b) => a + b, 0);
          const topCustomerAmt = customerRevenues.length > 0 ? Math.max(...customerRevenues) : 0;
          const topCustomerPct = totalCustomerRevenue > 0 ? (topCustomerAmt / totalCustomerRevenue) * 100 : 0;
          
          // Get multiple and valuation from saved inputs
          const valuationInputs = data.valuationInputs || {};
          const multipleMin = valuationInputs.multipleMin || 3.0;
          const multipleMax = valuationInputs.multipleMax || 4.0;
          const avgMultiple = (multipleMin + multipleMax) / 2;
          const valuation = adjustedEbitda * avgMultiple;
          
          // Get discovery answers for reference
          const discoveryAnswers = data.discoveryAnswers || {};
          
          // Create entity object
          const entity = {
            id: Date.now() + Math.random(),
            name: companyName,
            fileName: file.name,
            ttmPeriod,
            revenue,
            ebitda,
            adjustedEbitda,
            customerCount,
            topCustomerPct,
            topCustomerAmt,
            multipleMin,
            multipleMax,
            multiple: avgMultiple,
            valuation,
            discoveryAnswers,
            loadedAt: new Date().toISOString()
          };
          
          // Add to portfolio (avoid duplicates by fileName)
          setPortfolioEntities(prev => {
            const filtered = prev.filter(e => e.fileName !== file.name);
            return [...filtered, entity];
          });
          
        } catch (err) {
          console.error('Error loading portfolio entity:', err);
          alert(`Error loading ${file.name}: ${err.message}`);
        }
      };
      reader.readAsText(file);
    });
    
    event.target.value = '';
  };
  
  // Save portfolio as JSON
  const savePortfolio = () => {
    const portfolioData = {
      portfolioName: portfolioSettings.portfolioName,
      savedAt: new Date().toISOString(),
      entities: portfolioEntities,
      assessment: portfolioAssessment,
      settings: portfolioSettings,
      calculatedValues: {
        sumOfPartsValue: portfolioCalcs.sumOfPartsValue,
        combinedMultiple: portfolioCalcs.combinedMultiple,
        combinedTypicalMultiple: portfolioCalcs.combinedTypicalMultiple,
        combinedValuation: portfolioCalcs.combinedValuation,
        combinedTypicalValuation: portfolioCalcs.combinedTypicalValuation,
        premium: portfolioCalcs.premium,
        premiumPct: portfolioCalcs.premiumPct,
        hasEngineData: portfolioCalcs.hasEngineData
      }
    };
    
    const blob = new Blob([JSON.stringify(portfolioData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${portfolioSettings.portfolioName.replace(/[^a-zA-Z0-9]/g, '_')}_Portfolio.json`;
    a.click();
    URL.revokeObjectURL(url);
  };
  
  // Load saved portfolio
  const loadPortfolio = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        
        if (data.entities) setPortfolioEntities(data.entities);
        if (data.assessment) setPortfolioAssessment(data.assessment);
        if (data.settings) setPortfolioSettings(data.settings);
        
        alert(`Loaded portfolio: ${data.portfolioName || 'Unnamed'}\nEntities: ${data.entities?.length || 0}`);
      } catch (err) {
        alert('Error loading portfolio: ' + err.message);
      }
    };
    reader.readAsText(file);
    event.target.value = '';
  };

  // Show clear confirmation modal
  const clearDeal = () => {
    setShowClearConfirm(true);
  };

  // Actually perform the clear (called from modal)
  const confirmClearDeal = async () => {
    if (isReadOnlyViewer) { setShowClearConfirm(false); return; }
    // Save current state for in-session undo
    captureUndoState('Clear Deal');

    // If there's a saved valuation, archive the current DB row to
    // valuation_revisions BEFORE the in-memory reset — so the data
    // survives a tab close + later save, not just the in-memory undo.
    // Mirrors Start Revalue's archive safety: if the archive fails,
    // abort the clear (no data loss).
    if (currentValuationId && supabaseClient) {
      try {
        const { data: priorRow, error: readErr } = await supabaseClient
          .from('valuations')
          .select('data, valuation_date, value_provided_low, value_provided_high')
          .eq('id', currentValuationId)
          .single();
        if (readErr) throw readErr;
        if (priorRow?.data) {
          const { error: archiveErr } = await supabaseClient
            .from('valuation_revisions')
            .insert({
              valuation_id: currentValuationId,
              valued_date: priorRow.valuation_date || null,
              value_low: multipleEngineCalcs?.valuationTypical ?? priorRow.value_provided_low ?? null,
              value_high: multipleEngineCalcs?.valuationMarketHigh ?? priorRow.value_provided_high ?? null,
              data: priorRow.data,
            });
          if (archiveErr) throw archiveErr;
          logActivity(currentValuationId, 'stage_changed',
            'Project data cleared — prior data archived to revision history',
            { action: 'clear_deal' });
        }
      } catch (e) {
        console.error('Pre-clear archive failed:', e);
        window.alert('Clear aborted — could not archive the current data.\n\n' + (e?.message || ''));
        return;
      }
    }

    // Perform the clear. This is an INTENTIONAL blank of the whole deal (Q&A
    // included), so bypass the Q&A data-loss guard for the resulting save — the
    // prior data was already archived above.
    suppressQAGuardRef.current = true;
    setDealProfile({ companyName: '', website: '', dealStage: 'initial', assignedAnalyst: '', initialMeetingDate: '', valuationMeetingDate: '', targetCloseDate: '', dealNotes: '', city: '', state: '', locationType: '', fiscalYearEndMonth: 12 });
    setMarketCondition({ name: 'Normal Market (2024)', adjustment: 0, notes: 'Current market conditions' });
    setBusinessModel({ businessType: '', productService: '', salesChannel: '', customerType: '', industriesServed: '', geographicScope: '', geographicDetail: '', descriptionOverride: '' });
    // Clear sector and industry to unset state
    setSelectedSector('');
    setSelectedIndustry('');
    setRevenueCategories([{ id: 1, name: '', revenueType: 'contracted_defined', 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }]);
    setCogsCategories([{ id: 1, name: '', 
      cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
      accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
      tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
    }]);
    setRevenueStreams([]);
    setOwnerCompensation({ year1: { salary: 0, source: 'qa', verified: false, verificationDoc: '' }, year2: { salary: 0, source: 'qa', verified: false, verificationDoc: '' }, year3: { salary: 0, source: 'qa', verified: false, verificationDoc: '' }, year4: { salary: 0, source: 'qa', verified: false, verificationDoc: '' }, year5: { salary: 0, source: 'qa', verified: false, verificationDoc: '' }, ttm: { salary: 0, source: 'qa', verified: false, verificationDoc: '' }, marketReplacement: 0, embeddedInWages: true, payrollTaxRate: 7.65, includePayrollTax: true });
    setAdjustmentItems([]);
    setEbitdaSnapshots([]);
    setSourceTotals({});
    setRevenueScoringSaved(null);
    setCapexMethodSaved(null);
    setGrowthTestSaved(null);
    setPayrollTaxMethodSaved(null);
    setCapexCatchUp({ amount: 0, note: '' });
    setAiReviews([]);
    setAdjustmentsStatus('not_started');
    setValuationInputs({ multipleMin: 3.5, multipleMax: 4.5, weightingMethod: 'ttm', includeYear1: true, includeYear2: true, includeYear3: true, weightYear1: 1, weightYear2: 2, weightYear3: 3 });
    setDealStructure({ sellerNote: 10, earnout: 0, equity: 0 });
    // Reset document checklist to default list (removes any old items like id 6 TTM Sales)
    setDocumentChecklist([
      { id: 1, name: 'P&L Statements (3 years) - Accrual - Excel', received: false, dateProvided: '', notes: '', tier: 'full' },
      { id: 27, name: 'P&L Statements (3 years) - Cash - Excel', received: false, dateProvided: '', notes: '', tier: 'full' },
      { id: 2, name: 'TTM P&L (monthly breakdown) - Cash & Accrual - Excel', received: false, dateProvided: '', notes: '', tier: 'minimum' },
      { id: 3, name: 'Balance Sheets (3 years + Interim) - Accrual - Excel', received: false, dateProvided: '', notes: '', tier: 'full' },
      { id: 4, name: 'TTM Balance Sheet (monthly breakdown) - Accrual - Excel', received: false, dateProvided: '', notes: '', tier: 'minimum' },
      { id: 5, name: 'Sales Report by Customer (5 years) - Cash & Accrual', received: false, dateProvided: '', notes: 'For concentration and retention analysis', tier: 'full' },
      { id: 26, name: 'Sales Report by Customer (TTM) - Cash & Accrual', received: false, dateProvided: '', notes: 'Current period customer breakdown', tier: 'minimum' },
      { id: 7, name: 'Sales Report by Product/Service (5 years)', received: false, dateProvided: '', notes: 'If applicable', tier: 'full' },
      { id: 8, name: 'Tax Returns (3 years)', received: false, dateProvided: '', notes: '', tier: 'full' },
      { id: 9, name: 'Salary & Benefits for Owner (3 years + TTM)', received: false, dateProvided: '', notes: '', tier: 'full' },
      { id: 10, name: 'Payroll Report (TTM)', received: false, dateProvided: '', notes: 'All employees (owners included): payroll summary, used to verify owner pay and total staffing cost', tier: 'full' },
      { id: 11, name: 'List of Non-Recurring Business Expenses (3 years + TTM)', received: false, dateProvided: '', notes: 'If any - addbacks', tier: 'full' },
      { id: 12, name: 'List of Nonbusiness Related Expenses (3 years + TTM)', received: false, dateProvided: '', notes: 'If any - addbacks', tier: 'full' },
      { id: 13, name: 'Discovery Questionnaire', received: false, dateProvided: '', notes: 'See Discovery tab', tier: 'minimum' },
      { id: 15, name: 'Current Accounts Receivable Aging Report - Excel', received: false, dateProvided: '', notes: 'As of same date as current Balance Sheet', tier: 'full' },
      { id: 16, name: 'Current Accounts Payable Aging Report - Excel', received: false, dateProvided: '', notes: 'As of same date as current Balance Sheet', tier: 'full' }
    ]);
    setSellerQA(prev => prev.map(item => ({ ...item, status: 'pending', answer: '', numericValue: null, numericValue2: null, followUps: [] })));
    setResearchItems([]);
    setAcknowledgedFlags({});
    setAddbacks({ depreciation: true, interest: true, amortization: true, taxes: true });
    setCustomerSalesCash([defaultEmptyCustomerRow()]);
    setCustomerSalesAccrual([]);
    setSalesDetailsExpanded(false);
    setSalesDataExpanded(false);
    setShowPasteColumnModal(false);
    setPasteColumnTarget('name');
    setPasteColumnData('');
    setSalesSortBy('entry');
    setSalesSortDir('desc');
    setShowSalesExportModal(false);
    setSalesExportText('');
    setCustomerYearLabels({ year1: defaultYears.year1, year2: defaultYears.year2, year3: defaultYears.year3, year4: defaultYears.year4, year5: defaultYears.year5, ttm: 'TTM' });
    setSalesTtmConfig({ endMonth: new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1, endYear: new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(), basis: 'cash', useMonthlyForTtm: true });
    setMonthlySalesData({});
    setMonthlySalesPasteData('');
    setMonthlySalesPastePreview(null);
    setMonthlySalesClearFirst(false);
    setArAgingData({ current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0, negativeBalances: 0, reportDate: '', totalRevenueTTM: 0, notes: '' });
    setArReviewChecklist({
      reportDateMatches: { checked: false, notes: '' },
      totalTiesToBS: { checked: false, notes: '' },
      noNegativeBalances: { checked: false, notes: '' },
      agingDistributionReasonable: { checked: false, notes: '' },
      noCustomerMultipleBuckets: { checked: false, notes: '' },
      over120LessThanAllowance: { checked: false, notes: '' },
      concentrationAcceptable: { checked: false, notes: '' },
      reportReviewed: false,
      reviewedBy: '',
      reviewDate: ''
    });
    setApAnalysis({ postsAPRegularly: 'unknown', totalAP: 0, reportDate: '', notes: '' });
    setBsYearLabels({ year1: defaultYears.year3, year2: defaultYears.year4, year3: defaultYears.year5, interim: 'Interim', interimDate: '' });
    setBsBasis('accrual');
    setBsCurrentAssets([
      { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 },
      { id: 99, name: 'Prepaid Expenses', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true }
    ]);
    setBsFixedAssets([
      { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }
    ]);
    setBsOtherAssets([
      { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }
    ]);
    setBsCurrentLiabilities([
      { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 },
      { id: 97, name: 'Accrued Expenses', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true },
      { id: 98, name: 'Customer Deposits', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true },
      { id: 99, name: 'Deferred Revenue', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true }
    ]);
    setBsLongTermLiabilities([
      { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 },
      { id: 99, name: 'Deferred Revenue (LT)', year1: 0, year2: 0, year3: 0, interim: 0, isDeferredAccount: true }
    ]);
    setBsEquity([
      { id: 1, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }
    ]);
    setBsRecognitionNotes({
      deferredRevenue: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
      prepaidExpenses: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
      accruedExpenses: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
      customerDeposits: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' },
      unearnedRevenue: { reviewed: false, notes: '', reviewedBy: '', reviewDate: '' }
    });
    setBsIssueNotes({});
    setCustRevenueNotes({});
    setIndustryMultipleAdjustment(0);
    setShowInternalControls(true);
    // Reset TTM monthly data
    setTtmMonthlyData({
      revenue: [
        { month: 'Month 1', amount: 0 }, { month: 'Month 2', amount: 0 }, { month: 'Month 3', amount: 0 },
        { month: 'Month 4', amount: 0 }, { month: 'Month 5', amount: 0 }, { month: 'Month 6', amount: 0 },
        { month: 'Month 7', amount: 0 }, { month: 'Month 8', amount: 0 }, { month: 'Month 9', amount: 0 },
        { month: 'Month 10', amount: 0 }, { month: 'Month 11', amount: 0 }, { month: 'Month 12', amount: 0 }
      ],
      ebitda: [
        { month: 'Month 1', amount: 0 }, { month: 'Month 2', amount: 0 }, { month: 'Month 3', amount: 0 },
        { month: 'Month 4', amount: 0 }, { month: 'Month 5', amount: 0 }, { month: 'Month 6', amount: 0 },
        { month: 'Month 7', amount: 0 }, { month: 'Month 8', amount: 0 }, { month: 'Month 9', amount: 0 },
        { month: 'Month 10', amount: 0 }, { month: 'Month 11', amount: 0 }, { month: 'Month 12', amount: 0 }
      ],
      revenueReviewNotes: '',
      ebitdaReviewNotes: ''
    });
    // Reset valuation basis
    setValuationBasis('accrual');
    // Reset SBA params to defaults
    setSbaParams({
      downPaymentPct: 10,
      sellerNotePct: 10,
      sellerNoteRate: 5.0,
      sellerNoteTerm: 10,
      sbaLoanRate: 10.0,
      sbaLoanTerm: 10,
      reIncluded: false, reValue: 0, reRent: 0, reDownPct: 10, reRate: 7.0, reTerm: 25, reRentAddedBack: false
    });
    // Reset multiple adjustments
    setMultipleAdjustments({
      revenueQuality: { useWeightedCalculation: true, monthlyReviewed: false, monthlyManualAdjustment: 0 },
      ebitdaQuality: { monthlyReviewed: false, monthlyManualAdjustment: 0, negativeMonthsReviewed: false, negativeMonthsOverride: null, negativeMonthsNotes: '' },
      customerRetention: { 
        year1: { retentionRate: 0, verified: false },
        year2: { retentionRate: 0, verified: false },
        year3: { retentionRate: 0, verified: false },
        avgRetentionRate: 0,
        notes: '' 
      },
      clientChurn: {
        ttmLostClientRevenue: 0,
        ttmNewClientRevenue: 0,
        ttmPriorRevenue: 0,
        verified: false,
        notes: ''
      },
      contractTerms: { avgContractLength: 0, transferability: 'unknown', hasInflationClauses: false, hasExitClauses: false, notes: '' },
      concentration: { topCustomerPct: 0, top5CustomersPct: 0, topVendorPct: 0, vendorNotes: '',
        clientIndustries: [],
        industryConcentrationAdjustment: 0, industryConcentrationNotes: '' },
      ownerTransition: { ownersStaying: 'unknown', notes: '' },
      ownerDependency: { involvementLevel: 'unknown', hoursPerWeek: null, revenueGenerationPct: null, manualAdjustment: 0, notes: '' },
      otherAdjustments: [],
      workingCapitalQuality: { arPastDueOverride: null, arPastDueNotes: '', arPastDueReviewed: false, arSeriousOverride: null, arSeriousNotes: '', arSeriousReviewed: false, negativeBalancesOverride: null, negativeBalancesNotes: '', negativeBalancesReviewed: false },
      franchise: { isFranchise: false, franchiseName: '', royaltyRate: 0, marketingFundRate: 0, transferFee: 0, remainingTermYears: null, franchisorApproval: false, territoryExclusive: false, territoryNotes: '', notes: '' }
    });
    // Reset OpEx categories - start with one blank line (user adds to match P&L)
    setOpexCategories([
      { id: 1, name: '', plLine: 'Other',
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      }
    ]);
    // Reset Other Income categories
    setOtherIncomeCategories([
      { id: 1, name: '', addbackPct: 0,
        adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      }
    ]);
    // Reset Other Expense categories
    setOtherExpenseCategories([
      { id: 1, name: '', addbackPct: 0,
        adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      }
    ]);
    // Reset D/I/A/T (always needed for EBITDA calculation)
    setDiatCategories({
      depreciation: { 
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      },
      interest: { 
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      },
      amortization: { 
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      },
      taxes: { 
        cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
        tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
      }
    });
    // Reset basis comparison data - no longer needed, using line-item categories
    setBasisComparisonData({
      cash: {
        year1: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        year2: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        year3: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        ttm: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 }
      },
      accrual: {
        year1: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        year2: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        year3: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        ttm: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 }
      },
      tax: {
        year1: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        year2: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 },
        year3: { revenue: 0, cogs: 0, grossProfit: 0, opex: 0, otherIncome: 0, otherExpense: 0, netIncome: 0 }
      }
    });
    setTaxFilingBasis('cash');
    setTaxReturnTotals({
      revenue: { year3: 0, year4: 0, year5: 0 },
      cogs: { year3: 0, year4: 0, year5: 0 },
      expenses: { year3: 0, year4: 0, year5: 0 }
    });
    setSelectedValuationBasis('cash');
    setBasisYearLabels({ 
      year1: defaultYears.year1, year2: defaultYears.year2, year3: defaultYears.year3, year4: defaultYears.year4, year5: defaultYears.year5,
      ttmStartMonth: '', ttmStartYear: '', ttmEndMonth: '', ttmEndYear: ''
    });
    setShowAllYears(false);
    setIncomeStmtViewMode('full');
    setBasisYearTab('year5');
    // Reset monthly TTM data
    setMonthlyTtmRevenue({});
    setMonthlyTtmCogs({});
    setMonthlyTtmOpex({});
    setMonthlyTtmOtherIncome({});
    setMonthlyTtmOtherExpense({});
    setMonthlyTtmDiat({
      depreciation: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
      interest: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
      amortization: { cash: Array(24).fill(0), accrual: Array(24).fill(0) },
      taxes: { cash: Array(24).fill(0), accrual: Array(24).fill(0) }
    });
    setMonthlyTtmNotes({});
    setMonthlyTtmConfig({
      endMonth: new Date().getMonth(),
      endYear: new Date().getFullYear(),
      useMonthlyForTtm: false,
      showArchive: false,
      varianceThreshold: 20
    });
    // Reset AR/AP line items
    setArAgingLineItems([{ id: 1, name: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0, hasContract: false, industry: '', notes: '' }]);
    setArAgingBucketLabels({ current: 'Current', days31to60: '31-60', days61to90: '61-90', days91to120: '91-120', days120plus: '120+', pastDueStartColumn: 2 });
    setArAgingNotes({});
    setApAgingLineItems([{ id: 1, name: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0, notes: '' }]);
    setApAgingBucketLabels({ current: 'Current', days31to60: '31-60', days61to90: '61-90', days91to120: '91-120', days120plus: '120+' });
    setApReviewChecklist({});
    // Reset review flags
    setReviewFlags({});
    setManualReviewFlags({});
    // Reset variance status tracking
    setReconVarianceStatus({});
    setBsVarianceStatus({});
    setIncomeVarianceStatus({});
    // Reset Working Capital Analysis settings
    setWcPegMethodology('average');
    setWcCustomMonths([]);
    setWcShowOperating(true);
    // Reset Roll-Off Risk acknowledgment
    setRollOffAcknowledged({ reviewed: false, reviewDate: '', notes: '' });
    // Reset TTM Balance Sheet data (for WC Analysis)
    // Reset month labels to current TTM period
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const now = new Date();
    const startMonth = now.getMonth();
    let labelYear = now.getFullYear() - 1;
    const newLabels = [];
    for (let i = 0; i < 12; i++) {
      const monthIdx = (startMonth + i) % 12;
      if (i > 0 && monthIdx === 0) labelYear++;
      newLabels.push(monthNames[monthIdx] + ' ' + labelYear);
    }
    setTtmBsMonthLabels(newLabels);
    setTtmBsCurrentAssets([
      { id: 1, name: 'Cash', included: false, values: Array(12).fill(0) },
      { id: 2, name: 'Accounts Receivable', included: true, values: Array(12).fill(0) },
      { id: 3, name: 'Inventory', included: true, values: Array(12).fill(0) },
      { id: 4, name: 'Prepaid Expenses', included: true, values: Array(12).fill(0) }
    ]);
    setTtmBsCurrentLiabilities([
      { id: 1, name: 'Accounts Payable', included: true, values: Array(12).fill(0) },
      { id: 2, name: 'Accrued Expenses', included: true, values: Array(12).fill(0) },
      { id: 3, name: 'Short-term Debt', included: false, values: Array(12).fill(0) },
      { id: 4, name: 'Deferred Revenue', included: true, values: Array(12).fill(0) }
    ]);
    setTtmBsFixedAssets([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsOtherAssets([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsLongTermLiabilities([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsEquity([{ id: 1, name: '', included: false, values: Array(12).fill(0) }]);
    setTtmBsCurrentAssetsExpanded(false);
    setTtmBsCurrentLiabilitiesExpanded(false);
    setTtmBsFixedAssetsExpanded(false);
    setTtmBsOtherAssetsExpanded(false);
    setTtmBsLongTermLiabilitiesExpanded(false);
    setTtmBsEquityExpanded(false);
    setTtmBsDetailExpanded(false);
    setProFormaItems([]);
    restorePortfolio(null);
    // Clear auto-save
    sessionStorage.removeItem(AUTO_SAVE_KEY);
    setHasUnsavedChanges(false);
    setShowClearConfirm(false);
  };

  // Capture current state for undo
  // pruneZeroRows: remove orphaned rows that have no name and all-zero values across every basis/period
  // Applied after every paste to eliminate rows left behind by partial pastes or Clear & Replace
  const pruneZeroRows = (categories) => {
    if (!categories || categories.length === 0) return categories;
    return categories.filter(cat => {
      // Always keep rows that have a non-empty name (user-named rows matter even if zero)
      if (cat.name && cat.name.trim()) {
        // But still prune if it has a name AND all values are zero across all bases and periods
        const bases = ['cash', 'accrual', 'tax'];
        const periods = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
        const hasAnyValue = bases.some(b => periods.some(p => {
          const v = cat[b]?.[p];
          return v !== undefined && v !== null && v !== 0 && v !== '';
        }));
        // Also check monthly data arrays
        const hasMonthly = bases.some(b => Array.isArray(cat[b]) && cat[b].some(v => v !== 0));
        return hasAnyValue || hasMonthly;
      }
      // Unnamed rows: only keep if they have at least one non-zero value
      const bases = ['cash', 'accrual', 'tax'];
      const periods = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
      return bases.some(b => periods.some(p => {
        const v = cat[b]?.[p];
        return v !== undefined && v !== null && v !== 0 && v !== '';
      }));
    });
  };

  const captureUndoState = (label) => {
    const snapshot = {
      label,
      timestamp: new Date().toLocaleTimeString(),
      dealProfile,
      marketCondition,
      businessModel,
      selectedSector,
      selectedIndustry,
      revenueCategories,
      cogsCategories,
      revenueStreams,
      ownerCompensation,
      adjustmentItems,
      valuationInputs,
      documentChecklist,
      sellerQA,
      researchItems,
      acknowledgedFlags,
      addbacks,
      // Snapshot both basis arrays for undo/redo
      customerSalesCash,
      customerSalesAccrual,
      salesViewBasis,
      // Old-format mirror for snapshots taken before the refactor that may still be on the undo stack
      customerSalesData: customerSalesCash,
      proFormaItems,
      proFormaValuationBasis,
      customerYearLabels,
      salesTtmConfig,
      arAgingData,
      arAgingLineItems,
      arAgingBucketLabels,
      arReviewChecklist,
      arAgingNotes,
      salesDetailNotes,
      apAnalysis,
      apAgingLineItems,
      apAgingBucketLabels,
      apReviewChecklist,
      bsYearLabels,
      bsBasis,
      bsCurrentAssets,
      bsFixedAssets,
      bsOtherAssets,
      bsCurrentLiabilities,
      bsLongTermLiabilities,
      bsEquity,
      bsRecognitionNotes,
      bsIssueNotes,
      custRevenueNotes,
      industryMultipleAdjustment,
      showInternalControls,
      ttmMonthlyData,
      valuationBasis,
      sbaParams,
      capexMethod, capexCatchUp, growthTest, payrollTaxMethod, spikeMath,
      multipleAdjustments,
      opexCategories,
      otherIncomeCategories,
      otherExpenseCategories,
      diatCategories,
      basisComparisonData,
      taxFilingBasis,
      selectedValuationBasis,
      taxReturnTotals,
      basisYearLabels,
      showAllYears,
      basisYearTab,
      monthlyTtmRevenue,
      monthlyTtmCogs,
      monthlyTtmOpex,
      monthlyTtmOtherIncome,
      monthlyTtmOtherExpense,
      monthlyTtmDiat,
      monthlyTtmNotes,
      monthlyTtmConfig,
      reviewFlags,
      manualReviewFlags,
      reconVarianceStatus,
      reconQualityChecklist,
      bsVarianceStatus,
      incomeVarianceStatus,
      ttmBsMonthLabels,
      ttmBsCurrentAssets,
      ttmBsFixedAssets,
      ttmBsOtherAssets,
      ttmBsCurrentLiabilities,
      ttmBsLongTermLiabilities,
      ttmBsEquity,
      wcPegMethodology,
      wcCustomMonths,
      rollOffAcknowledged
    };
    setUndoStack(prev => {
      const newStack = [snapshot, ...prev].slice(0, MAX_UNDO_LEVELS);
      return newStack;
    });
    setRedoStack([]); // New action invalidates redo history
  };

  // Perform undo - restore most recent state
  const performUndo = (skipConfirm = false) => {
    if (undoStack.length === 0) return;
    const [snapshot, ...rest] = undoStack;
    
    // If this is a major undo (like undoing a clear), confirm with user
    // Undoing an OWNER-FORM ACCEPT rolls the owner's answers back out of the grid (Blue Spruce 09-30: 123
    // clients' Client Detail accepted at 19:45, gone two minutes later, item 29 re-marked complete at 19:47).
    // Never silently: say what it removes and that the answers stay re-acceptable from the green banner.
    if (!skipConfirm && /^Accept owner/.test(snapshot.label || '')) {
      if (!confirm(`Undo "${snapshot.label}"?

This removes the owner's portal answers from the grid. They stay saved — you can accept them again from the green 📥 banner.`)) return;
    }
    if (!skipConfirm && snapshot.label === 'Clear Deal') {
      if (!confirm(`Undo "${snapshot.label}"? This will restore the previous state and may remove significant data.`)) {
        return;
      }
    }
    
    setDealProfile(snapshot.dealProfile);
    setMarketCondition(snapshot.marketCondition);
    setBusinessModel(snapshot.businessModel);
    if (snapshot.selectedSector) setSelectedSector(snapshot.selectedSector);
    setSelectedIndustry(snapshot.selectedIndustry);
    setRevenueCategories(snapshot.revenueCategories);
    setCogsCategories(snapshot.cogsCategories);
    setRevenueStreams(snapshot.revenueStreams);
    setOwnerCompensation(snapshot.ownerCompensation);
    setAdjustmentItems(snapshot.adjustmentItems);
    setValuationInputs(snapshot.valuationInputs);
    setDocumentChecklist(snapshot.documentChecklist);
    setSellerQA(snapshot.sellerQA);
    setResearchItems(snapshot.researchItems);
    setAcknowledgedFlags(snapshot.acknowledgedFlags);
    setAddbacks(snapshot.addbacks);
    // Restore sales arrays — prefer new format, fall back to old single-array snapshot.
    if (snapshot.customerSalesCash !== undefined) {
      setCustomerSalesCash(snapshot.customerSalesCash);
      setCustomerSalesAccrual(snapshot.customerSalesAccrual || []);
    } else if (snapshot.customerSalesData !== undefined) {
      setCustomerSalesCash(snapshot.customerSalesData);
    }
    if (snapshot.salesViewBasis) setSalesViewBasis(snapshot.salesViewBasis);
    if (snapshot.monthlySalesData !== undefined) setMonthlySalesData(snapshot.monthlySalesData);
    if (snapshot.proFormaItems) setProFormaItems(snapshot.proFormaItems);
    if (snapshot.proFormaValuationBasis) setProFormaValuationBasis(snapshot.proFormaValuationBasis);
    setCustomerYearLabels(snapshot.customerYearLabels);
    if (snapshot.salesTtmConfig) setSalesTtmConfig(snapshot.salesTtmConfig);
    setArAgingData(snapshot.arAgingData);
    if (snapshot.arAgingLineItems) setArAgingLineItems(snapshot.arAgingLineItems);
    if (snapshot.arAgingBucketLabels) setArAgingBucketLabels(snapshot.arAgingBucketLabels);
    if (snapshot.arReviewChecklist) setArReviewChecklist(snapshot.arReviewChecklist);
    if (snapshot.arAgingNotes) setArAgingNotes(snapshot.arAgingNotes);
    setApAnalysis(snapshot.apAnalysis);
    if (snapshot.apAgingLineItems) setApAgingLineItems(snapshot.apAgingLineItems);
    if (snapshot.apAgingBucketLabels) setApAgingBucketLabels(snapshot.apAgingBucketLabels);
    if (snapshot.apReviewChecklist) setApReviewChecklist(snapshot.apReviewChecklist);
    setBsYearLabels(snapshot.bsYearLabels);
    if (snapshot.bsBasis) setBsBasis(snapshot.bsBasis);
    setBsCurrentAssets(snapshot.bsCurrentAssets);
    setBsFixedAssets(snapshot.bsFixedAssets);
    setBsOtherAssets(snapshot.bsOtherAssets);
    setBsCurrentLiabilities(snapshot.bsCurrentLiabilities);
    setBsLongTermLiabilities(snapshot.bsLongTermLiabilities);
    setBsEquity(snapshot.bsEquity);
    if (snapshot.bsRecognitionNotes) setBsRecognitionNotes(snapshot.bsRecognitionNotes);
    if (snapshot.bsIssueNotes) setBsIssueNotes(snapshot.bsIssueNotes);
    if (snapshot.custRevenueNotes) setCustRevenueNotes(snapshot.custRevenueNotes);
    setIndustryMultipleAdjustment(snapshot.industryMultipleAdjustment);
    setShowInternalControls(snapshot.showInternalControls);
    if (snapshot.ttmMonthlyData) setTtmMonthlyData(snapshot.ttmMonthlyData);
    if (snapshot.valuationBasis) setValuationBasis(snapshot.valuationBasis);
    if (snapshot.sbaParams) setSbaParams(snapshot.sbaParams);
    if (snapshot.multipleAdjustments) setMultipleAdjustments(snapshot.multipleAdjustments);
    if (snapshot.opexCategories) setOpexCategories(snapshot.opexCategories);
    if (snapshot.otherIncomeCategories) setOtherIncomeCategories(snapshot.otherIncomeCategories);
    if (snapshot.otherExpenseCategories) setOtherExpenseCategories(snapshot.otherExpenseCategories);
    if (snapshot.diatCategories) setDiatCategories(snapshot.diatCategories);
    if (snapshot.basisComparisonData) setBasisComparisonData(snapshot.basisComparisonData);
    if (snapshot.taxFilingBasis) setTaxFilingBasis(snapshot.taxFilingBasis);
    if (snapshot.taxReturnTotals) setTaxReturnTotals(snapshot.taxReturnTotals);
    if (snapshot.selectedValuationBasis) setSelectedValuationBasis(snapshot.selectedValuationBasis);
    if (snapshot.basisYearLabels) setBasisYearLabels(snapshot.basisYearLabels);
    if (snapshot.showAllYears !== undefined) setShowAllYears(snapshot.showAllYears);
    if (snapshot.basisYearTab) setBasisYearTab(snapshot.basisYearTab);
    if (snapshot.monthlyTtmRevenue) setMonthlyTtmRevenue(snapshot.monthlyTtmRevenue);
    if (snapshot.monthlyTtmCogs) setMonthlyTtmCogs(snapshot.monthlyTtmCogs);
    if (snapshot.monthlyTtmOpex) setMonthlyTtmOpex(snapshot.monthlyTtmOpex);
    if (snapshot.monthlyTtmOtherIncome) setMonthlyTtmOtherIncome(snapshot.monthlyTtmOtherIncome);
    if (snapshot.monthlyTtmOtherExpense) setMonthlyTtmOtherExpense(snapshot.monthlyTtmOtherExpense);
    if (snapshot.monthlyTtmDiat) setMonthlyTtmDiat(snapshot.monthlyTtmDiat);
    if (snapshot.monthlyTtmNotes) setMonthlyTtmNotes(snapshot.monthlyTtmNotes);
    if (snapshot.reviewFlags) setReviewFlags(snapshot.reviewFlags);
    if (snapshot.manualReviewFlags) setManualReviewFlags(snapshot.manualReviewFlags);
    if (snapshot.monthlyTtmConfig) setMonthlyTtmConfig(snapshot.monthlyTtmConfig);
    if (snapshot.reconVarianceStatus) setReconVarianceStatus(snapshot.reconVarianceStatus);
    if (snapshot.reconQualityChecklist) setReconQualityChecklist(snapshot.reconQualityChecklist);
    if (snapshot.bsVarianceStatus) setBsVarianceStatus(snapshot.bsVarianceStatus);
    if (snapshot.incomeVarianceStatus) setIncomeVarianceStatus(snapshot.incomeVarianceStatus);
    if (snapshot.ttmBsMonthLabels) setTtmBsMonthLabels(snapshot.ttmBsMonthLabels);
    if (snapshot.ttmBsCurrentAssets) setTtmBsCurrentAssets(snapshot.ttmBsCurrentAssets);
    if (snapshot.ttmBsFixedAssets) setTtmBsFixedAssets(snapshot.ttmBsFixedAssets);
    if (snapshot.ttmBsOtherAssets) setTtmBsOtherAssets(snapshot.ttmBsOtherAssets);
    if (snapshot.ttmBsCurrentLiabilities) setTtmBsCurrentLiabilities(snapshot.ttmBsCurrentLiabilities);
    if (snapshot.ttmBsLongTermLiabilities) setTtmBsLongTermLiabilities(snapshot.ttmBsLongTermLiabilities);
    if (snapshot.ttmBsEquity) setTtmBsEquity(snapshot.ttmBsEquity);
    if (snapshot.wcPegMethodology) setWcPegMethodology(snapshot.wcPegMethodology);
    if (snapshot.wcCustomMonths) setWcCustomMonths(snapshot.wcCustomMonths);
    if (snapshot.rollOffAcknowledged) setRollOffAcknowledged(snapshot.rollOffAcknowledged);
    
    // Save current state to redo stack before restoring
    const currentState = {
      label: snapshot.label,
      timestamp: new Date().toLocaleTimeString(),
      dealProfile, marketCondition, businessModel, selectedSector, selectedIndustry,
      revenueCategories, cogsCategories, revenueStreams, ownerCompensation, adjustmentItems,
      valuationInputs, documentChecklist, sellerQA, researchItems, acknowledgedFlags, addbacks,
      customerSalesData, proFormaItems, proFormaValuationBasis, customerYearLabels, salesTtmConfig,
      arAgingData, arAgingLineItems, arAgingBucketLabels, arReviewChecklist, arAgingNotes,
      salesDetailNotes, apAnalysis, apAgingLineItems, apAgingBucketLabels, apReviewChecklist,
      bsYearLabels, bsBasis, bsCurrentAssets, bsFixedAssets, bsOtherAssets,
      bsCurrentLiabilities, bsLongTermLiabilities, bsEquity, bsRecognitionNotes, bsIssueNotes,
      custRevenueNotes, industryMultipleAdjustment, showInternalControls, ttmMonthlyData,
      valuationBasis, sbaParams, multipleAdjustments, opexCategories, otherIncomeCategories,
      otherExpenseCategories, diatCategories, basisComparisonData, taxFilingBasis,
      selectedValuationBasis, taxReturnTotals, basisYearLabels, showAllYears, basisYearTab,
      monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmOtherIncome,
      monthlyTtmOtherExpense, monthlyTtmDiat, monthlyTtmNotes, monthlyTtmConfig,
      reviewFlags, manualReviewFlags, reconVarianceStatus, reconQualityChecklist,
      bsVarianceStatus, incomeVarianceStatus, ttmBsMonthLabels, ttmBsCurrentAssets,
      ttmBsFixedAssets, ttmBsOtherAssets, ttmBsCurrentLiabilities, ttmBsLongTermLiabilities,
      ttmBsEquity, wcPegMethodology, wcCustomMonths, rollOffAcknowledged
    };
    setRedoStack(prev => [currentState, ...prev].slice(0, MAX_UNDO_LEVELS));
    
    setUndoStack(rest);
  };

  // Perform redo - restore most recently undone state
  const performRedo = () => {
    if (redoStack.length === 0) return;
    const [snapshot, ...rest] = redoStack;
    
    // Save current state to undo stack
    const currentState = {
      label: snapshot.label,
      timestamp: new Date().toLocaleTimeString(),
      dealProfile, marketCondition, businessModel, selectedSector, selectedIndustry,
      revenueCategories, cogsCategories, revenueStreams, ownerCompensation, adjustmentItems,
      valuationInputs, documentChecklist, sellerQA, researchItems, acknowledgedFlags, addbacks,
      customerSalesData, proFormaItems, proFormaValuationBasis, customerYearLabels, salesTtmConfig,
      arAgingData, arAgingLineItems, arAgingBucketLabels, arReviewChecklist, arAgingNotes,
      salesDetailNotes, apAnalysis, apAgingLineItems, apAgingBucketLabels, apReviewChecklist,
      bsYearLabels, bsBasis, bsCurrentAssets, bsFixedAssets, bsOtherAssets,
      bsCurrentLiabilities, bsLongTermLiabilities, bsEquity, bsRecognitionNotes, bsIssueNotes,
      custRevenueNotes, industryMultipleAdjustment, showInternalControls, ttmMonthlyData,
      valuationBasis, sbaParams, multipleAdjustments, opexCategories, otherIncomeCategories,
      otherExpenseCategories, diatCategories, basisComparisonData, taxFilingBasis,
      selectedValuationBasis, taxReturnTotals, basisYearLabels, showAllYears, basisYearTab,
      monthlyTtmRevenue, monthlyTtmCogs, monthlyTtmOpex, monthlyTtmOtherIncome,
      monthlyTtmOtherExpense, monthlyTtmDiat, monthlyTtmNotes, monthlyTtmConfig,
      reviewFlags, manualReviewFlags, reconVarianceStatus, reconQualityChecklist,
      bsVarianceStatus, incomeVarianceStatus, ttmBsMonthLabels, ttmBsCurrentAssets,
      ttmBsFixedAssets, ttmBsOtherAssets, ttmBsCurrentLiabilities, ttmBsLongTermLiabilities,
      ttmBsEquity, wcPegMethodology, wcCustomMonths, rollOffAcknowledged
    };
    setUndoStack(prev => [currentState, ...prev]);
    
    // Restore the redo snapshot (same restore logic as performUndo)
    setDealProfile(snapshot.dealProfile);
    setMarketCondition(snapshot.marketCondition);
    setBusinessModel(snapshot.businessModel);
    if (snapshot.selectedSector) setSelectedSector(snapshot.selectedSector);
    setSelectedIndustry(snapshot.selectedIndustry);
    setRevenueCategories(snapshot.revenueCategories);
    setCogsCategories(snapshot.cogsCategories);
    setRevenueStreams(snapshot.revenueStreams);
    setOwnerCompensation(snapshot.ownerCompensation);
    setAdjustmentItems(snapshot.adjustmentItems);
    setValuationInputs(snapshot.valuationInputs);
    setDocumentChecklist(snapshot.documentChecklist);
    setSellerQA(snapshot.sellerQA);
    setResearchItems(snapshot.researchItems);
    setAcknowledgedFlags(snapshot.acknowledgedFlags);
    setAddbacks(snapshot.addbacks);
    // Restore sales arrays — prefer new format, fall back to old single-array snapshot.
    if (snapshot.customerSalesCash !== undefined) {
      setCustomerSalesCash(snapshot.customerSalesCash);
      setCustomerSalesAccrual(snapshot.customerSalesAccrual || []);
    } else if (snapshot.customerSalesData !== undefined) {
      setCustomerSalesCash(snapshot.customerSalesData);
    }
    if (snapshot.salesViewBasis) setSalesViewBasis(snapshot.salesViewBasis);
    if (snapshot.monthlySalesData !== undefined) setMonthlySalesData(snapshot.monthlySalesData);
    if (snapshot.proFormaItems) setProFormaItems(snapshot.proFormaItems);
    if (snapshot.proFormaValuationBasis) setProFormaValuationBasis(snapshot.proFormaValuationBasis);
    setCustomerYearLabels(snapshot.customerYearLabels);
    if (snapshot.salesTtmConfig) setSalesTtmConfig(snapshot.salesTtmConfig);
    setArAgingData(snapshot.arAgingData);
    if (snapshot.arAgingLineItems) setArAgingLineItems(snapshot.arAgingLineItems);
    if (snapshot.arAgingBucketLabels) setArAgingBucketLabels(snapshot.arAgingBucketLabels);
    if (snapshot.arReviewChecklist) setArReviewChecklist(snapshot.arReviewChecklist);
    if (snapshot.arAgingNotes) setArAgingNotes(snapshot.arAgingNotes);
    setApAnalysis(snapshot.apAnalysis);
    if (snapshot.apAgingLineItems) setApAgingLineItems(snapshot.apAgingLineItems);
    if (snapshot.apAgingBucketLabels) setApAgingBucketLabels(snapshot.apAgingBucketLabels);
    if (snapshot.apReviewChecklist) setApReviewChecklist(snapshot.apReviewChecklist);
    setBsYearLabels(snapshot.bsYearLabels);
    if (snapshot.bsBasis) setBsBasis(snapshot.bsBasis);
    setBsCurrentAssets(snapshot.bsCurrentAssets);
    setBsFixedAssets(snapshot.bsFixedAssets);
    setBsOtherAssets(snapshot.bsOtherAssets);
    setBsCurrentLiabilities(snapshot.bsCurrentLiabilities);
    setBsLongTermLiabilities(snapshot.bsLongTermLiabilities);
    setBsEquity(snapshot.bsEquity);
    if (snapshot.bsRecognitionNotes) setBsRecognitionNotes(snapshot.bsRecognitionNotes);
    if (snapshot.bsIssueNotes) setBsIssueNotes(snapshot.bsIssueNotes);
    if (snapshot.custRevenueNotes) setCustRevenueNotes(snapshot.custRevenueNotes);
    setIndustryMultipleAdjustment(snapshot.industryMultipleAdjustment);
    setShowInternalControls(snapshot.showInternalControls);
    if (snapshot.ttmMonthlyData) setTtmMonthlyData(snapshot.ttmMonthlyData);
    if (snapshot.valuationBasis) setValuationBasis(snapshot.valuationBasis);
    if (snapshot.sbaParams) setSbaParams(snapshot.sbaParams);
    if (snapshot.multipleAdjustments) setMultipleAdjustments(snapshot.multipleAdjustments);
    if (snapshot.opexCategories) setOpexCategories(snapshot.opexCategories);
    if (snapshot.otherIncomeCategories) setOtherIncomeCategories(snapshot.otherIncomeCategories);
    if (snapshot.otherExpenseCategories) setOtherExpenseCategories(snapshot.otherExpenseCategories);
    if (snapshot.diatCategories) setDiatCategories(snapshot.diatCategories);
    if (snapshot.basisComparisonData) setBasisComparisonData(snapshot.basisComparisonData);
    if (snapshot.taxFilingBasis) setTaxFilingBasis(snapshot.taxFilingBasis);
    if (snapshot.taxReturnTotals) setTaxReturnTotals(snapshot.taxReturnTotals);
    if (snapshot.selectedValuationBasis) setSelectedValuationBasis(snapshot.selectedValuationBasis);
    if (snapshot.basisYearLabels) setBasisYearLabels(snapshot.basisYearLabels);
    if (snapshot.showAllYears !== undefined) setShowAllYears(snapshot.showAllYears);
    if (snapshot.basisYearTab) setBasisYearTab(snapshot.basisYearTab);
    if (snapshot.monthlyTtmRevenue) setMonthlyTtmRevenue(snapshot.monthlyTtmRevenue);
    if (snapshot.monthlyTtmCogs) setMonthlyTtmCogs(snapshot.monthlyTtmCogs);
    if (snapshot.monthlyTtmOpex) setMonthlyTtmOpex(snapshot.monthlyTtmOpex);
    if (snapshot.monthlyTtmOtherIncome) setMonthlyTtmOtherIncome(snapshot.monthlyTtmOtherIncome);
    if (snapshot.monthlyTtmOtherExpense) setMonthlyTtmOtherExpense(snapshot.monthlyTtmOtherExpense);
    if (snapshot.monthlyTtmDiat) setMonthlyTtmDiat(snapshot.monthlyTtmDiat);
    if (snapshot.monthlyTtmNotes) setMonthlyTtmNotes(snapshot.monthlyTtmNotes);
    if (snapshot.reviewFlags) setReviewFlags(snapshot.reviewFlags);
    if (snapshot.manualReviewFlags) setManualReviewFlags(snapshot.manualReviewFlags);
    if (snapshot.monthlyTtmConfig) setMonthlyTtmConfig(snapshot.monthlyTtmConfig);
    if (snapshot.reconVarianceStatus) setReconVarianceStatus(snapshot.reconVarianceStatus);
    if (snapshot.reconQualityChecklist) setReconQualityChecklist(snapshot.reconQualityChecklist);
    if (snapshot.bsVarianceStatus) setBsVarianceStatus(snapshot.bsVarianceStatus);
    if (snapshot.incomeVarianceStatus) setIncomeVarianceStatus(snapshot.incomeVarianceStatus);
    if (snapshot.ttmBsMonthLabels) setTtmBsMonthLabels(snapshot.ttmBsMonthLabels);
    if (snapshot.ttmBsCurrentAssets) setTtmBsCurrentAssets(snapshot.ttmBsCurrentAssets);
    if (snapshot.ttmBsFixedAssets) setTtmBsFixedAssets(snapshot.ttmBsFixedAssets);
    if (snapshot.ttmBsOtherAssets) setTtmBsOtherAssets(snapshot.ttmBsOtherAssets);
    if (snapshot.ttmBsCurrentLiabilities) setTtmBsCurrentLiabilities(snapshot.ttmBsCurrentLiabilities);
    if (snapshot.ttmBsLongTermLiabilities) setTtmBsLongTermLiabilities(snapshot.ttmBsLongTermLiabilities);
    if (snapshot.ttmBsEquity) setTtmBsEquity(snapshot.ttmBsEquity);
    if (snapshot.wcPegMethodology) setWcPegMethodology(snapshot.wcPegMethodology);
    if (snapshot.wcCustomMonths) setWcCustomMonths(snapshot.wcCustomMonths);
    if (snapshot.rollOffAcknowledged) setRollOffAcknowledged(snapshot.rollOffAcknowledged);
    
    setRedoStack(rest);
  };
  const handleBasisTabKey = (e, tableId, rowIndex, colIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const table = document.getElementById(tableId);
      if (!table) return;
      
      const rows = table.querySelectorAll('tbody tr');
      const numRows = rows.length;
      
      // Enter: go down one cell in same column
      const nextRow = rowIndex + 1;
      if (nextRow < numRows) {
        const targetInput = rows[nextRow]?.querySelectorAll('input')[colIndex];
        if (targetInput) targetInput.focus();
      }
    }
    
    if (e.key === 'Tab') {
      e.preventDefault();
      const table = document.getElementById(tableId);
      if (!table) return;
      
      const inputs = table.querySelectorAll('input');
      const inputArray = Array.from(inputs);
      
      // Find inputs in same column
      const rows = table.querySelectorAll('tbody tr');
      const numRows = rows.length;
      const numCols = rows[0]?.querySelectorAll('input').length || 0;
      
      if (e.shiftKey) {
        // Shift+Tab: go up
        const nextRow = rowIndex - 1;
        if (nextRow >= 0) {
          const targetInput = rows[nextRow]?.querySelectorAll('input')[colIndex];
          if (targetInput) targetInput.focus();
        } else {
          // Go to previous column, last row
          const prevCol = colIndex - 1;
          if (prevCol >= 0) {
            const targetInput = rows[numRows - 1]?.querySelectorAll('input')[prevCol];
            if (targetInput) targetInput.focus();
          }
        }
      } else {
        // Tab: go down
        const nextRow = rowIndex + 1;
        if (nextRow < numRows) {
          const targetInput = rows[nextRow]?.querySelectorAll('input')[colIndex];
          if (targetInput) targetInput.focus();
        } else {
          // Go to next column, first row
          const nextCol = colIndex + 1;
          if (nextCol < numCols) {
            const targetInput = rows[0]?.querySelectorAll('input')[nextCol];
            if (targetInput) targetInput.focus();
          }
        }
      }
    }
  };

  // Helper function to parse currency values from pasted data
  // Handles: $1,234.56, (1,234.56), -1234.56, etc.
  const parseCurrencyValue = (str) => {
    if (!str || str.trim() === '') return 0;
    const trimmed = str.trim();
    
    // Check if negative (parentheses format)
    const isParenNegative = trimmed.startsWith('(') && trimmed.endsWith(')');
    
    // Remove $, commas, parentheses, spaces
    const cleaned = trimmed.replace(/[$,() ]/g, '');
    
    // Parse the number
    const num = parseFloat(cleaned);
    
    // Return 0 if not a valid number
    if (isNaN(num)) return 0;
    
    // Apply negative if was in parentheses and number is positive
    if (isParenNegative && num > 0) {
      return -num;
    }
    
    return num;
  };

  // P&L Paste Column - Apply function
  const applyPLPaste = () => {
    try {
      // Capture state before paste
      captureUndoState(`Paste P&L ${plPasteSection}`);
      
      const values = plPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
      if (values.length === 0 || (values.length === 1 && values[0].trim() === '')) {
        return;
      }
      
      // Get the appropriate setter and current data based on section
      const sectionConfig = {
        revenue: { 
          data: revenueCategories, 
          setter: setRevenueCategories,
          newRow: (name) => {
            // Auto-detect revenue type from account name
            const nl = (name || '').toLowerCase();
            let autoType = 'contracted_defined';
            if (/(microsoft\s*(365|cloud)|office\s*365|\bm365\b|\bo365\b|azure|google\s*workspace|\bcsp\b)/i.test(nl) && !/one.?time|perpetual/i.test(nl)) autoType = 'recurring_licensing';
            else if (/hardware|equipment|server|workstation|firewall|device|product\s*sale|product\s*income/i.test(nl)) autoType = 'hardware_contracted';
            else if (/project|implementation|migration|install|upgrade|setup|deployment/i.test(nl)) autoType = 'project_contracted';
            else if (/msp|managed|agreement|subscription|recurring|monthly|retainer|maintenance|backup|monitoring|saas|license|commission/i.test(nl)) autoType = 'contracted_defined';
            else if (/support|break.*fix|hourly|t&m|time.*material/i.test(nl)) autoType = 'repeat_uncontracted';
            else if (/freight|shipping|uncategorized|unapplied|other\s*(revenue|service|income)/i.test(nl)) autoType = 'transactional';
            else if (/(subscription|licens|microsoft\s*365|m365|office\s*365|saas)/i.test(nl) && !/one.?time|perpetual/i.test(nl)) autoType = 'recurring_licensing';
            else if (/software\s*sale/i.test(nl)) autoType = 'hardware_contracted';
            return {
              id: Date.now() + Math.random(), name: name || '', revenueType: autoType,
              cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
              accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
              tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
            };
          }
        },
        cogs: { 
          data: cogsCategories, 
          setter: setCogsCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        opex: { 
          data: opexCategories, 
          setter: setOpexCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '', plLine: 'Other', addbackPct: 0,
            adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        otherIncome: { 
          data: otherIncomeCategories, 
          setter: setOtherIncomeCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        otherExpense: { 
          data: otherExpenseCategories, 
          setter: setOtherExpenseCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        }
      };
      
      const config = sectionConfig[plPasteSection];
      if (!config) {
        console.error('Invalid P&L paste section:', plPasteSection);
        return;
      }
      
      let updatedData = [...(config.data || [])];
      
      // Ensure we have enough rows
      while (updatedData.length < values.length) {
        updatedData.push(config.newRow());
      }
      
      // Parse and update values
      values.forEach((val, idx) => {
        if (idx < updatedData.length) {
          const trimmedVal = val.trim();
          
          if (plPasteTarget === 'name') {
            // Account name - text field
            updatedData[idx] = { ...updatedData[idx], name: trimmedVal };
            // Auto-detect revenue type when pasting names into revenue section
            if (plPasteSection === 'revenue' && trimmedVal) {
              const nl = trimmedVal.toLowerCase();
              let autoType = 'contracted_defined';
              if (/(microsoft\s*(365|cloud)|office\s*365|\bm365\b|\bo365\b|azure|google\s*workspace|\bcsp\b)/i.test(nl) && !/one.?time|perpetual/i.test(nl)) autoType = 'recurring_licensing';
              else if (/hardware|equipment|server|workstation|firewall|device|product\s*sale|product\s*income/i.test(nl)) autoType = 'hardware_contracted';
              else if (/project|implementation|migration|install|upgrade|setup|deployment/i.test(nl)) autoType = 'project_contracted';
              else if (/msp|managed|agreement|subscription|recurring|monthly|retainer|maintenance|backup|monitoring|saas|license|commission/i.test(nl)) autoType = 'contracted_defined';
              else if (/support|break.*fix|hourly|t&m|time.*material/i.test(nl)) autoType = 'repeat_uncontracted';
              else if (/freight|shipping|uncategorized|unapplied|other\s*(revenue|service|income)/i.test(nl)) autoType = 'transactional';
              else if (/(subscription|licens|microsoft\s*365|m365|office\s*365|saas)/i.test(nl) && !/one.?time|perpetual/i.test(nl)) autoType = 'recurring_licensing';
              else if (/software\s*sale/i.test(nl)) autoType = 'hardware_contracted';
              updatedData[idx] = { ...updatedData[idx], revenueType: autoType };
            }
          } else {
            // Cash, Accrual, or Tax - numeric, goes into the current year tab
            const parsed = parseCurrencyValue(trimmedVal);
            const safeVal = typeof parsed === 'number' && !isNaN(parsed) ? parsed : 0;
            
            // Ensure the target object exists
            const existingTarget = updatedData[idx][plPasteTarget] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
            
            updatedData[idx] = {
              ...updatedData[idx],
              [plPasteTarget]: {
                ...existingTarget,
                [basisYearTab]: safeVal
              }
            };
          }
        }
      });
      
      config.setter(updatedData);
      setShowPLPasteModal(false);
      setPlPasteData('');
    } catch (error) {
      console.error('P&L Paste Error:', error);
      alert('Error pasting data: ' + error.message);
      setShowPLPasteModal(false);
      setPlPasteData('');
    }
  };

  // Helper to open P&L paste modal for a section
  const openPLPasteModal = (section) => {
    setPlPasteSection(section);
    setPlPasteTarget('name'); // Default to account names
    setPlPasteData('');
    setShowPLPasteModal(true);
  };

  // ========== BALANCE SHEET PASTE GRID ==========
  // Parse Balance Sheet grid paste (Name, Year3, Year4, Year5, Interim)
  const parseBSGridPaste = (section) => {
    const sectionConfig = {
      currentAssets: { data: bsCurrentAssets, setter: setBsCurrentAssets },
      fixedAssets: { data: bsFixedAssets, setter: setBsFixedAssets },
      otherAssets: { data: bsOtherAssets, setter: setBsOtherAssets },
      currentLiabilities: { data: bsCurrentLiabilities, setter: setBsCurrentLiabilities },
      longTermLiabilities: { data: bsLongTermLiabilities, setter: setBsLongTermLiabilities },
      equity: { data: bsEquity, setter: setBsEquity }
    };
    
    const config = sectionConfig[section];
    if (!config) return null;
    
    // Include ALL items (including deferred accounts) in matching
    // Deferred accounts (Prepaid, Accrued, Customer Deposits, Deferred Revenue) should be matched if pasted
    const existingItems = config.data.filter(item => item.name);
    
    // Parse the pasted data - expect tab-separated: Name, Year3, Year4, Year5, Interim
    const lines = bsGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    
    // Detect if first row is a header
    let dataStartRow = 0;
    if (lines.length > 0) {
      const firstRowLower = lines[0].toLowerCase();
      if (firstRowLower.includes('account') || firstRowLower.includes('name') || firstRowLower.includes('year') || firstRowLower.includes('202')) {
        dataStartRow = 1;
      }
    }
    
    const parsed = [];
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      if (cells.length < 2) continue;
      
      const name = cells[0].trim();
      if (!name) continue;
      
      // Skip total/summary rows
      if (name.toLowerCase().includes('total')) continue;
      
      // Parse year values (columns 1-4: Year3, Year4, Year5, Interim)
      const yearValues = { year1: 0, year2: 0, year3: 0, interim: 0 };
      const yearKeys = ['year1', 'year2', 'year3', 'interim'];
      for (let y = 1; y <= 4 && y < cells.length; y++) {
        let val = cells[y] || '';
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) {
          val = '-' + val.slice(1, -1);
        }
        const num = parseFloat(val);
        yearValues[yearKeys[y - 1]] = isNaN(num) ? 0 : num;
      }
      
      parsed.push({ name, yearValues, originalRow: lines[i] });
    }
    
    // Match parsed rows to existing items
    const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    
    const matched = [];
    const newRows = [];
    const matchedExistingIds = new Set();
    
    parsed.forEach(row => {
      let match = existingItems.find(item => item.name === row.name);
      if (!match) {
        const normalizedPasted = normalizeForMatch(row.name);
        match = existingItems.find(item => normalizeForMatch(item.name) === normalizedPasted);
      }
      // Removed aggressive substring matching that caused false positives
      // Cross-format matching: "Parent > Child" ↔ "Child"
      // Pass 3: flat-name account-code-stripped match
      // Handles stored names like "4024 - Maintenance w/out Help Desk" vs plain "Maintenance w/out Help Desk"
      const stripAcct2 = (s) => s.replace(/^\d[\d-]*\s*-?\s+/, '').trim();
      if (!match && !row.name.includes(' > ')) {
        const normalizedRow2 = normalizeForMatch(row.name);
        match = existingItems.find(item => {
          if (!item.name || item.name.includes(' > ')) return false;
          return normalizeForMatch(stripAcct2(item.name)) === normalizedRow2;
        });
      }
      // Pass 4: cross-format "Parent > Child" ↔ "Child" with account code stripping
      if (!match && row.name.includes(' > ')) {
        const childPart = row.name.split(' > ').pop().trim();
        const normalizedChild2 = normalizeForMatch(childPart);
        const normalizedChildStripped2 = normalizeForMatch(stripAcct2(childPart));
        match = existingItems.find(item =>
          normalizeForMatch(item.name) === normalizedChild2 ||
          normalizeForMatch(item.name) === normalizedChildStripped2
        );
      }
      if (!match && !row.name.includes(' > ')) {
        const normalizedRow = normalizeForMatch(row.name);
        match = existingItems.find(item => {
          if (!item.name || !item.name.includes(' > ')) return false;
          const existingChild2 = item.name.split(' > ').pop().trim();
          return normalizeForMatch(existingChild2) === normalizedRow ||
                 normalizeForMatch(stripAcct2(existingChild2)) === normalizedRow;
        });
      }
      
      if (match && !matchedExistingIds.has(match.id)) {
        matched.push({ ...row, matchedTo: match, matchType: row.name === match.name ? 'exact' : 'fuzzy' });
        matchedExistingIds.add(match.id);
      } else if (match && matchedExistingIds.has(match.id)) {
        // Match already used - treat as new row instead of silently dropping
        newRows.push(row);
      } else if (!match) {
        newRows.push(row);
      }
    });
    
    const noData = existingItems.filter(item => !matchedExistingIds.has(item.id));
    
    return { matched, newRows, noData, parsed };
  };
  
  // Apply Balance Sheet grid paste
  const applyBSGridPaste = () => {
    if (!bsGridPastePreview) return;
    
    try {
      captureUndoState(`Paste Grid Balance Sheet ${bsGridPasteSection}`);
      
      const sectionConfig = {
        currentAssets: { data: bsCurrentAssets, setter: setBsCurrentAssets },
        fixedAssets: { data: bsFixedAssets, setter: setBsFixedAssets },
        otherAssets: { data: bsOtherAssets, setter: setBsOtherAssets },
        currentLiabilities: { data: bsCurrentLiabilities, setter: setBsCurrentLiabilities },
        longTermLiabilities: { data: bsLongTermLiabilities, setter: setBsLongTermLiabilities },
        equity: { data: bsEquity, setter: setBsEquity }
      };
      
      const config = sectionConfig[bsGridPasteSection];
      if (!config) return;
      
      // Keep track of which deferred items were matched (so we keep unmatched ones)
      const matchedDeferredIds = new Set();
      bsGridPastePreview.matched.forEach(row => {
        if (row.matchedTo.isDeferredAccount) {
          matchedDeferredIds.add(row.matchedTo.id);
        }
      });
      
      // Start with all items (will update matched ones)
      let updatedItems = config.data.map(item => ({ ...item }));
      
      // Update matched rows
      bsGridPastePreview.matched.forEach(row => {
        const idx = updatedItems.findIndex(item => item.id === row.matchedTo.id);
        if (idx !== -1) {
          updatedItems[idx] = {
            ...updatedItems[idx],
            year1: row.yearValues.year1,
            year2: row.yearValues.year2,
            year3: row.yearValues.year3,
            interim: row.yearValues.interim
          };
        }
      });
      
      // Create new rows
      bsGridPastePreview.newRows.forEach(row => {
        const maxId = Math.max(...config.data.map(i => i.id || 0), 0);
        updatedItems.push({
          id: maxId + 1 + Math.random(),
          name: row.name,
          year1: row.yearValues.year1,
          year2: row.yearValues.year2,
          year3: row.yearValues.year3,
          interim: row.yearValues.interim
        });
      });
      
      // Apply updates (deferred items are now included in updatedItems and updated if matched)
      config.setter(updatedItems);
      
      // Close modal and reset
      setShowBSGridPasteModal(false);
      setBsGridPasteData('');
      setBsGridPastePreview(null);
      
    } catch (error) {
      console.error('BS Grid Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== ANNUAL P&L PASTE GRID ==========
  // Parse Annual P&L grid paste (Name, Year3, Year4, Year5, TTM)
  const parseAnnualGridPaste = (section, basis) => {
    const sectionConfig = {
      revenue: { data: revenueCategories, setter: setRevenueCategories },
      cogs: { data: cogsCategories, setter: setCogsCategories },
      opex: { data: opexCategories, setter: setOpexCategories },
      otherIncome: { data: otherIncomeCategories, setter: setOtherIncomeCategories },
      otherExpense: { data: otherExpenseCategories, setter: setOtherExpenseCategories }
    };
    
    const config = sectionConfig[section];
    if (!config) return null;
    
    const existingItems = config.data.filter(cat => cat.name);
    
    // Parse the pasted data
    const lines = annualGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length === 0) return { matched: [], newRows: [], noData: [], parsed: [], yearMatchInfo: [], detectedYears: [] };
    
    // Detect header row and extract year columns
    let dataStartRow = 0;
    let detectedYears = [];
    let headerCells = [];
    
    if (lines.length > 0) {
      headerCells = lines[0].split('\t');
      const firstRowLower = lines[0].toLowerCase();
      
      // Check if first row is a header
      if (firstRowLower.includes('account') || firstRowLower.includes('name') || firstRowLower.includes('year') || 
          /20\d{2}/.test(lines[0]) || firstRowLower.includes('ttm') || firstRowLower.includes('total')) {
        dataStartRow = 1;
        
        // Extract years from header (skip first column which is account name)
        for (let i = 1; i < headerCells.length; i++) {
          const cell = headerCells[i].trim();
          // Check for 4-digit year
          const yearMatch = cell.match(/20\d{2}/);
          if (yearMatch) {
            detectedYears.push({ col: i, year: yearMatch[0], label: cell });
          } else if (/ttm|trailing|l12m|ltm/i.test(cell)) {
            detectedYears.push({ col: i, year: 'TTM', label: cell });
          }
        }
      }
    }
    
    // Build year mapping using Smart Year Matching
    const existingYearMap = {
      [basisYearLabels.year1]: 'year1',
      [basisYearLabels.year2]: 'year2',
      [basisYearLabels.year3]: 'year3',
      [basisYearLabels.year4]: 'year4',
      [basisYearLabels.year5]: 'year5',
      'TTM': 'ttm'
    };
    
    const yearMatchInfo = [];
    let columnToYearKey = {}; // Maps column index to yearKey (year1, year2, etc.)
    
    if (detectedYears.length > 0) {
      // Check for exact matches first
      let hasExactMatches = false;
      detectedYears.forEach(dy => {
        if (existingYearMap[dy.year]) {
          hasExactMatches = true;
        }
      });
      
      if (hasExactMatches) {
        // Use exact matching
        detectedYears.forEach(dy => {
          const yearKey = existingYearMap[dy.year];
          if (yearKey) {
            columnToYearKey[dy.col] = yearKey;
            yearMatchInfo.push({
              detected: dy.year,
              label: dy.label,
              mappedTo: yearKey,
              currentLabel: dy.year === 'TTM' ? 'TTM' : basisYearLabels[yearKey],
              matchType: 'exact'
            });
          } else {
            // New year not in grid - map based on chronological position
            const numericYear = parseInt(dy.year);
            const existingYears = [
              { key: 'year1', val: parseInt(basisYearLabels.year1) || 0 },
              { key: 'year2', val: parseInt(basisYearLabels.year2) || 0 },
              { key: 'year3', val: parseInt(basisYearLabels.year3) || 0 },
              { key: 'year4', val: parseInt(basisYearLabels.year4) || 0 },
              { key: 'year5', val: parseInt(basisYearLabels.year5) || 0 }
            ].filter(y => y.val > 0);
            
            if (numericYear > Math.max(...existingYears.map(y => y.val))) {
              columnToYearKey[dy.col] = 'year5';
              yearMatchInfo.push({
                detected: dy.year,
                label: dy.label,
                mappedTo: 'year5',
                currentLabel: basisYearLabels.year5,
                matchType: 'new',
                warning: `Year ${dy.year} not in grid (currently ${basisYearLabels.year5}) - will update Year 5 label`
              });
            } else {
              columnToYearKey[dy.col] = 'year1';
              yearMatchInfo.push({
                detected: dy.year,
                label: dy.label,
                mappedTo: 'year1',
                currentLabel: basisYearLabels.year1,
                matchType: 'new',
                warning: `Year ${dy.year} not in grid - will update Year 1 label`
              });
            }
          }
        });
      } else {
        // No exact matches - use position-based mapping
        const numDataCols = detectedYears.length;
        let positionKeys;
        if (numDataCols === 1) {
          // Single column - find the chronologically correct slot
          const singleYear = detectedYears[0].year;
          if (singleYear === 'TTM') {
            positionKeys = ['ttm'];
          } else {
            // Try to find the right slot based on existing year labels
            const pastedYear = parseInt(singleYear);
            const existingSlots = [
              { key: 'year1', val: parseInt(basisYearLabels.year1) || 0 },
              { key: 'year2', val: parseInt(basisYearLabels.year2) || 0 },
              { key: 'year3', val: parseInt(basisYearLabels.year3) || 0 },
              { key: 'year4', val: parseInt(basisYearLabels.year4) || 0 },
              { key: 'year5', val: parseInt(basisYearLabels.year5) || 0 }
            ];
            const exactSlot = existingSlots.find(s => s.val === pastedYear);
            if (exactSlot) {
              positionKeys = [exactSlot.key];
            } else {
              const filledSlots = existingSlots.filter(s => s.val > 0);
              if (filledSlots.length > 0) {
                const allYears = filledSlots.map(s => s.val).sort((a, b) => a - b);
                if (pastedYear > allYears[allYears.length - 1]) positionKeys = ['year5'];
                else if (pastedYear < allYears[0]) positionKeys = [existingSlots.find(s => s.val === 0)?.key || 'year1'];
                else positionKeys = ['year5']; // Between years, default to year5
              } else {
                positionKeys = ['year5']; // No labels set, default to year5
              }
            }
          }
        } else if (numDataCols === 2) {
          positionKeys = ['year5', 'ttm'];
        } else if (numDataCols === 3) {
          positionKeys = ['year3', 'year4', 'year5'];
        } else if (numDataCols === 4) {
          positionKeys = ['year3', 'year4', 'year5', 'ttm'];
        } else if (numDataCols === 5) {
          positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5'];
        } else {
          positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
        }
        
        detectedYears.forEach((dy, idx) => {
          const yearKey = positionKeys[idx] || 'ttm';
          columnToYearKey[dy.col] = yearKey;
          const currentLabel = yearKey === 'ttm' ? 'TTM' : basisYearLabels[yearKey];
          const willOverwrite = dy.year !== 'TTM' && dy.year !== currentLabel;
          yearMatchInfo.push({
            detected: dy.year,
            label: dy.label,
            mappedTo: yearKey,
            currentLabel: currentLabel,
            matchType: 'position',
            warning: willOverwrite ? `Will update ${yearKey} label to ${dy.year}` : null
          });
        });
      }
    } else {
      // No header detected - use column count based mapping
      const numDataCols = headerCells.length - 1;
      let positionKeys;
      if (numDataCols === 1) {
        positionKeys = ['year5']; // Single column defaults to year5
      } else if (numDataCols === 2) {
        positionKeys = ['year5', 'ttm'];
      } else if (numDataCols === 3) {
        positionKeys = ['year3', 'year4', 'year5'];
      } else if (numDataCols === 4) {
        positionKeys = ['year3', 'year4', 'year5', 'ttm'];
      } else if (numDataCols === 5) {
        positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5'];
      } else {
        positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
      }
      
      for (let i = 1; i <= numDataCols && i <= positionKeys.length; i++) {
        columnToYearKey[i] = positionKeys[i - 1];
        yearMatchInfo.push({
          detected: `Column ${i}`,
          label: `Column ${i}`,
          mappedTo: positionKeys[i - 1],
          currentLabel: positionKeys[i - 1] === 'ttm' ? 'TTM' : basisYearLabels[positionKeys[i - 1]],
          matchType: 'assumed'
        });
      }
    }
    
    // Parse data rows
    const parsed = [];
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      if (cells.length < 2) continue;
      
      const name = cells[0].trim();
      if (!name) continue;
      
      // Skip total/summary rows
      if (name.toLowerCase().includes('total') || name.toLowerCase().includes('gross profit') || 
          name.toLowerCase().includes('net income') || name.toLowerCase().includes('ebitda')) continue;
      
      // Parse year values based on column mappings
      const yearValues = {};
      const yearsPresent = new Set(); // Track which years actually have data
      
      for (let colIdx = 1; colIdx < cells.length; colIdx++) {
        const yearKey = columnToYearKey[colIdx];
        if (yearKey) {
          let val = cells[colIdx] || '';
          val = val.replace(/[$,]/g, '').trim();
          if (val.startsWith('(') && val.endsWith(')')) {
            val = '-' + val.slice(1, -1);
          }
          const num = parseFloat(val);
          if (!isNaN(num)) {
            yearValues[yearKey] = num;
            yearsPresent.add(yearKey);
          }
        }
      }
      
      parsed.push({ name, yearValues, yearsPresent: Array.from(yearsPresent), originalRow: lines[i] });
    }
    
    // Match parsed rows to existing items
    const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    
    const matched = [];
    const newRows = [];
    const matchedExistingIds = new Set();
    
    parsed.forEach(row => {
      let match = existingItems.find(item => item.name === row.name);
      if (!match) {
        const normalizedPasted = normalizeForMatch(row.name);
        match = existingItems.find(item => normalizeForMatch(item.name) === normalizedPasted);
      }
      // Removed aggressive substring matching that caused false positives
      // Cross-format matching: "Parent > Child" ↔ "Child"
      // Pass 3: flat-name account-code-stripped match
      // Handles stored names like "4024 - Maintenance w/out Help Desk" vs plain "Maintenance w/out Help Desk"
      const stripAcct2 = (s) => s.replace(/^\d[\d-]*\s*-?\s+/, '').trim();
      if (!match && !row.name.includes(' > ')) {
        const normalizedRow2 = normalizeForMatch(row.name);
        match = existingItems.find(item => {
          if (!item.name || item.name.includes(' > ')) return false;
          return normalizeForMatch(stripAcct2(item.name)) === normalizedRow2;
        });
      }
      // Pass 4: cross-format "Parent > Child" ↔ "Child" with account code stripping
      if (!match && row.name.includes(' > ')) {
        const childPart = row.name.split(' > ').pop().trim();
        const normalizedChild2 = normalizeForMatch(childPart);
        const normalizedChildStripped2 = normalizeForMatch(stripAcct2(childPart));
        match = existingItems.find(item =>
          normalizeForMatch(item.name) === normalizedChild2 ||
          normalizeForMatch(item.name) === normalizedChildStripped2
        );
      }
      if (!match && !row.name.includes(' > ')) {
        const normalizedRow = normalizeForMatch(row.name);
        match = existingItems.find(item => {
          if (!item.name || !item.name.includes(' > ')) return false;
          const existingChild2 = item.name.split(' > ').pop().trim();
          return normalizeForMatch(existingChild2) === normalizedRow ||
                 normalizeForMatch(stripAcct2(existingChild2)) === normalizedRow;
        });
      }
      
      if (match && !matchedExistingIds.has(match.id)) {
        matched.push({ ...row, matchedTo: match, matchType: row.name === match.name ? 'exact' : 'fuzzy' });
        matchedExistingIds.add(match.id);
      } else if (match && matchedExistingIds.has(match.id)) {
        // Match already used - treat as new row instead of silently dropping
        newRows.push(row);
      } else if (!match) {
        newRows.push(row);
      }
    });
    
    const noData = existingItems.filter(item => !matchedExistingIds.has(item.id));
    
    return { matched, newRows, noData, parsed, yearMatchInfo, detectedYears, columnToYearKey };
  };
  
  // Apply Annual P&L grid paste
  const applyAnnualGridPaste = () => {
    if (!annualGridPastePreview) return;
    
    try {
      captureUndoState(`Paste Grid Annual P&L ${annualGridPasteSection} ${annualGridPasteBasis}`);
      
      const sectionConfig = {
        revenue: { 
          data: revenueCategories, 
          setter: setRevenueCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '', revenueType: 'contracted_defined',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        cogs: { 
          data: cogsCategories, 
          setter: setCogsCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        opex: { 
          data: opexCategories, 
          setter: setOpexCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '', plLine: 'Other', addbackPct: 0, diatFlag: null,
            adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true,
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        otherIncome: { 
          data: otherIncomeCategories, 
          setter: setOtherIncomeCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        },
        otherExpense: { 
          data: otherExpenseCategories, 
          setter: setOtherExpenseCategories,
          newRow: () => ({ 
            id: Date.now() + Math.random(), name: '',
            cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
            tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
          })
        }
      };
      
      const config = sectionConfig[annualGridPasteSection];
      if (!config) return;
      
      // DEEP COPY - must copy nested cash/accrual/tax objects to avoid mutation
      let updatedItems = config.data.map(item => ({ 
        ...item,
        cash: { ...(item.cash || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
        accrual: { ...(item.accrual || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
        tax: { ...(item.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }) }
      }));
      const basis = annualGridPasteBasis;
      
      // Update matched rows - ONLY update years that are present in the paste
      annualGridPastePreview.matched.forEach(row => {
        const idx = updatedItems.findIndex(item => item.id === row.matchedTo.id);
        if (idx !== -1) {
          const currentBasisData = { ...(updatedItems[idx][basis] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) };
          
          // Only update years that are actually present in the pasted data
          if (row.yearsPresent && row.yearsPresent.length > 0) {
            row.yearsPresent.forEach(yearKey => {
              if (row.yearValues[yearKey] !== undefined) {
                currentBasisData[yearKey] = row.yearValues[yearKey];
              }
            });
          }
          
          updatedItems[idx] = {
            ...updatedItems[idx],
            [basis]: currentBasisData
          };
        }
      });
      
      // Create new rows
      annualGridPastePreview.newRows.forEach(row => {
        const newItem = config.newRow();
        newItem.name = row.name;
        
        // Auto-detect revenue type for new revenue rows
        if (annualGridPasteSection === 'revenue' && row.name) {
          const nl = row.name.toLowerCase();
          if (/(microsoft\s*(365|cloud)|office\s*365|\bm365\b|\bo365\b|azure|google\s*workspace|\bcsp\b)/i.test(nl) && !/one.?time|perpetual/i.test(nl)) newItem.revenueType = 'recurring_licensing';
          else if (/hardware|equipment|server|workstation|firewall|device|product\s*sale|product\s*income/i.test(nl)) newItem.revenueType = 'hardware_contracted';
          else if (/project|implementation|migration|install|upgrade|setup|deployment/i.test(nl)) newItem.revenueType = 'project_contracted';
          else if (/msp|managed|agreement|subscription|recurring|monthly|retainer|maintenance|backup|monitoring|saas|license|commission/i.test(nl)) newItem.revenueType = 'contracted_defined';
          else if (/support|break.*fix|hourly|t&m|time.*material/i.test(nl)) newItem.revenueType = 'repeat_uncontracted';
          else if (/freight|shipping|uncategorized|unapplied|other\s*(revenue|service|income)/i.test(nl)) newItem.revenueType = 'transactional';
          else if (/(subscription|licens|microsoft\s*365|m365|office\s*365|saas)/i.test(nl) && !/one.?time|perpetual/i.test(nl)) newItem.revenueType = 'recurring_licensing';
          else if (/software\s*sale/i.test(nl)) newItem.revenueType = 'hardware_contracted';
        }
        
        // Only set years that are present
        const newBasisData = { ...(newItem[basis] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) };
        if (row.yearsPresent && row.yearsPresent.length > 0) {
          row.yearsPresent.forEach(yearKey => {
            if (row.yearValues[yearKey] !== undefined) {
              newBasisData[yearKey] = row.yearValues[yearKey];
            }
          });
        }
        newItem[basis] = newBasisData;
        
        updatedItems.push(newItem);
      });
      
      config.setter(updatedItems);
      
      // Auto-update year labels if detected years differ from current labels
      if (annualGridPastePreview.yearMatchInfo && annualGridPastePreview.yearMatchInfo.length > 0) {
        const newLabels = { ...basisYearLabels };
        let labelsChanged = false;
        
        annualGridPastePreview.yearMatchInfo.forEach(info => {
          if (info.detected && info.detected !== 'TTM' && info.mappedTo !== 'ttm') {
            const yearMatch = info.detected.match(/20\d{2}/);
            if (yearMatch && newLabels[info.mappedTo] !== yearMatch[0]) {
              newLabels[info.mappedTo] = yearMatch[0];
              labelsChanged = true;
            }
          }
        });
        
        if (labelsChanged) {
          setBasisYearLabels(newLabels);
        }
      }
      
      // Close modal and reset
      setShowAnnualGridPasteModal(false);
      setAnnualGridPasteData('');
      setAnnualGridPastePreview(null);
      
    } catch (error) {
      console.error('Annual Grid Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== FULL P&L PASTE (for new P&L entry tabs) ==========
  // Parses entire P&L at once, auto-detecting sections and year columns
  const parseFullPLPaste = () => {
    const lines = fullPLPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Subtotal patterns to skip
    const subtotalPatterns = [
      /^total\s/i, /\stotal$/i, /^total$/i, /^gross\s*(profit|margin)\b/i, /^net\s*(income|profit|loss)\b/i, /^profit(\s*[\/&]\s*loss)?$/i,
      /^net\s+ordinary\s*(income|profit|loss)/i, /^net\s+other\s*(income|expense)/i,
      /^operating\s*(income|profit|loss)/i, /^net\s*operating/i, /^ebitda/i,
      /^income\s*\(\s*loss\s*\)/i, /^(net\s+)?(income|profit|earnings|loss)\b.*\bfrom\s+operations\s*$/i,   // Aeroform 10-06: result lines, not accounts (not "Net cash from operations")
      /^expenses?$/i,
      /^total\s*for\s/i, /^total\s*(income|expense|revenue|other|cogs|cost)/i
    ];
    // A row named exactly "Total" (no trailing label) is a section subtotal, not an
    // account — some P&Ls (e.g. PRI Global's) label the Income and COGS subtotals just
    // "Total". Without this they'd be imported as line items and double-count the section.
    const isSubtotal = (name) => subtotalPatterns.some(p => p.test(name.trim()));
    
    // Section header patterns - used to detect section changes
    // IMPORTANT: otherIncome/otherExpense patterns must be specific to avoid false positives
    // on account names like "Other Revenue/Commissions" or "Other Expense Category"
    const sectionPatterns = {
      revenue: [/^income$/i, /^revenue$/i, /^ordinary income/i, /^operating\s+income$/i],
      cogs: [/^cost\s*of\s*(goods|sales)/i, /^cogs$/i, /^direct\s*cost/i],
      opex: [/^expense/i, /^operating\s*expense/i, /^overhead/i, /^general\s*&?\s*admin/i, /\bexpenses?\s*$/i, /^administrative/i, /^payroll/i],
      otherIncome: [/^other\s+incomes?\s*$/i, /^other\s+incomes?\s*[\/(\-]/i, /^other\s+revenue\s*$/i, /^non[\s-]?operating\s*income/i, /^non[\s-]?operating\s+items?\s*$/i],
      otherExpense: [/^other\s+expenses?\s*$/i, /^other\s+expenses?\s*[\/(\-]/i, /^non[\s-]?operating\s*expenses?/i]
    };
    
    // Try to detect year columns from header row
    // SCAN multiple rows (not just row 0) to find the year header
    // Non-QB formats often have title rows, company name, date range, etc. before the header
    let headerRowIdx = -1;
    let headerCells = [];
    let yearColumns = {};
    let yearMatchInfo = []; // Track year matching for preview warnings
    let dataStartRow = 0;
    
    const scanLimit = Math.min(lines.length, 15); // Check first 15 non-empty lines
    // First pass: find the row where the MOST non-name columns have year/TTM values
    // This reliably finds the column header row even when title rows contain keywords
    // A cell "looks like a year header" only when the year stands alone (Konnie
    // 09-23, Blue Spruce annual accrual: the QB header reads "Jan - Dec '23" —
    // no 4-digit year — so it scored 0, and a DATA row whose amounts happened
    // to contain "2021…" won the header slot; everything above it, revenue
    // included, was thrown away and the preview showed nothing). Amounts
    // never count: a 4-digit year inside a longer number is not a year, and
    // a month-range / "'23" / "Dec 31, 25" header now counts.
    const looksLikeYearHeaderCell = (t) =>
      /(^|[^\d.,])20\d{2}(?![\d.,])/.test(t)
      || /\b\d{2}\/\d{2}\/\d{2,4}\b/.test(t)
      || /\bttm\b|\bltm\b|trailing|\bytd\b/i.test(t)
      || /'\d{2}\b/.test(t)
      || (/\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\b/i.test(t) && /[,\s]\d{2}\s*$/.test(t));
    let bestHeaderRow = -1;
    let bestYearCount = 0;
    for (let r = 0; r < scanLimit; r++) {
      const cells = lines[r].split('\t');
      let yearCellCount = 0;
      cells.forEach((cell, idx) => {
        if (idx === 0) return;
        const t = cell.trim();
        if (looksLikeYearHeaderCell(t)) yearCellCount++;
      });
      if (yearCellCount >= 2 && yearCellCount > bestYearCount) {
        bestYearCount = yearCellCount;
        bestHeaderRow = r;
      }
    }
    if (bestHeaderRow >= 0) {
      headerRowIdx = bestHeaderRow;
      headerCells = lines[bestHeaderRow].split('\t');
      dataStartRow = bestHeaderRow + 1;
    } else {
    // Fallback: keyword-based header detection
    for (let r = 0; r < scanLimit; r++) {
      const rowLower = lines[r].toLowerCase();
      const cells = lines[r].split('\t');
      let yearCellCount = 0;
      cells.forEach((cell, idx) => {
        if (idx === 0) return;
        const t = cell.trim();
        if (looksLikeYearHeaderCell(t)) yearCellCount++;
      });
      const hasMultipleYears = yearCellCount >= 2;
      const col0Lower = (cells[0] || '').toLowerCase();
      const nonNameText = cells.slice(1).join(' ').toLowerCase();
      const hasYearKeywords = nonNameText.includes('202') || nonNameText.includes('201') || nonNameText.includes('year') || 
                              nonNameText.includes('ttm') || /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(nonNameText);
      const hasLabelKeywords = col0Lower.includes('account') || col0Lower.includes('name') || col0Lower.includes('description') || col0Lower.includes('distribution');
      if (hasMultipleYears || (hasYearKeywords && hasLabelKeywords) || (hasYearKeywords && yearCellCount >= 1)) {
        headerRowIdx = r;
        headerCells = cells;
        dataStartRow = r + 1;
        break;
      }
    }
    }
    
    // If no explicit header found, fall back to checking line 0 with original looser criteria
    if (headerRowIdx === -1) {
      const firstRowLower = lines[0].toLowerCase();
      if (firstRowLower.includes('202') || firstRowLower.includes('201') || firstRowLower.includes('year') || 
          firstRowLower.includes('ttm') || firstRowLower.includes('account') || firstRowLower.includes('name') || 
          firstRowLower.includes('total') || /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(firstRowLower)) {
        headerRowIdx = 0;
        headerCells = lines[0].split('\t');
        dataStartRow = 1;
      }
    }
    
    if (headerRowIdx >= 0) {
      // dataStartRow was already set in the scanning loop above
      
      // Measure the span (in months) of a "Month - Month" date range, so a
      // partial/YTD stub column can be told apart from a full year. Returns null
      // when the cell isn't a month range. Wrapping fiscal years are handled:
      // "Jul - Jun" spans 12, "Jan - Dec" spans 12, "Jan - Feb" spans 2.
      const MONTH_NUM = { jan:1,feb:2,mar:3,apr:4,may:5,jun:6,jul:7,aug:8,sep:9,oct:10,nov:11,dec:12 };
      const monthRangeSpan = (text) => {
        const found = [];
        const re = /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\b/gi;
        let m;
        while ((m = re.exec(text)) !== null) found.push(MONTH_NUM[m[1].toLowerCase()]);
        if (found.length < 2) return null; // single month or none → not a range
        const start = found[0], end = found[found.length - 1];
        return ((end - start + 12) % 12) + 1;
      };

      // First pass: extract all years found in header cells
      const foundYears = [];
      headerCells.forEach((cell, idx) => {
        if (idx === 0) return; // Skip name column
        const cellText = cell.trim();

        // Partial/YTD guard: a stub column like "Jan - Feb 26" spans fewer than 12
        // months. Never map it to an annual slot — doing so imports a partial total
        // as a full year AND pushes the real years out of position (every figure
        // lands under the wrong year). TTM/YTD data comes from the monthly P&L tab.
        // A genuine 12-month fiscal year (e.g. "Jul - Jun 25") is kept.
        const span = monthRangeSpan(cellText);
        if (span !== null && span < 12) return;

        // Look for 4-digit year anywhere in cell
        // NOTE: Never remap a year column to TTM based on header text alone.
        // TTM data comes from the TTM P&L tab, not the annual paste.
        let yearMatch = cellText.match(/20\d{2}/);
        if (yearMatch) {
          foundYears.push({ idx, year: parseInt(yearMatch[0]), cell: cellText });
        } else {
          // Try abbreviated year formats: "Dec 31, 25", "'25", "12/31/25", etc.
          // Look for 2-digit year at the END of the string or after a comma/slash
          let shortYear = null;
          
          // Pattern 1: Year at end after comma or space: "Dec 31, 25" -> "25"
          const endMatch = cellText.match(/[,\s](\d{2})\s*$/);
          if (endMatch) {
            shortYear = parseInt(endMatch[1]);
          }
          // Pattern 2: Year after slash at end: "12/31/25" -> "25"
          else {
            const slashMatch = cellText.match(/\/(\d{2})\s*$/);
            if (slashMatch) {
              shortYear = parseInt(slashMatch[1]);
            }
          }
          // Pattern 3: Standalone '25 format
          if (shortYear === null) {
            const quoteMatch = cellText.match(/'(\d{2})\b/);
            if (quoteMatch) {
              shortYear = parseInt(quoteMatch[1]);
            }
          }
          
          if (shortYear !== null) {
            const fullYear = shortYear <= 50 ? 2000 + shortYear : 1900 + shortYear;
            foundYears.push({ idx, year: fullYear, cell: cellText });
          } else if (/ttm|trailing|l12m|ltm/i.test(cellText)) {
            foundYears.push({ idx, year: 'ttm', cell: cellText });
          } else if (/ytd/i.test(cellText)) {
            foundYears.push({ idx, year: 'ytd', cell: cellText });
          }
        }
      });
      
      // Sort numeric years to determine mapping
      const numericYears = foundYears.filter(y => typeof y.year === 'number').sort((a, b) => a.year - b.year);
      const specialCols = foundYears.filter(y => typeof y.year === 'string');
      
      // SMART YEAR MATCHING: First try to match detected years to existing basisYearLabels
      const existingYearMap = {
        [basisYearLabels.year1]: 'year1',
        [basisYearLabels.year2]: 'year2',
        [basisYearLabels.year3]: 'year3',
        [basisYearLabels.year4]: 'year4',
        [basisYearLabels.year5]: 'year5'
      };

      // NOTE: no local yearMatchInfo — a `const` redeclaration shadowed the outer
      // `let` and silently discarded every year-mapping warning pushed in this
      // block (the preview never showed them). Same bug family as the BS parser
      // (Little Bird 08-24).
      let hasExactMatches = false;
      
      if (numericYears.length > 0) {
        // First pass: try exact matching to existing year labels
        numericYears.forEach(y => {
          const yearStr = String(y.year);
          if (existingYearMap[yearStr]) {
            yearColumns[y.idx] = existingYearMap[yearStr];
            yearMatchInfo.push({
              detected: yearStr,
              mappedTo: existingYearMap[yearStr],
              label: yearStr,
              matchType: 'exact',
              isNew: false
            });
            hasExactMatches = true;
          }
        });
        
        // If we found exact matches, use them; otherwise fall back to position-based
        if (!hasExactMatches) {
          // Position-based mapping
          // For single year: try to find the best chronological slot rather than defaulting to year5
          if (numericYears.length === 1) {
            const pastedYear = numericYears[0].year;
            // Check all existing year labels for the closest match
            const existingSlots = [
              { key: 'year1', val: parseInt(basisYearLabels.year1) || 0 },
              { key: 'year2', val: parseInt(basisYearLabels.year2) || 0 },
              { key: 'year3', val: parseInt(basisYearLabels.year3) || 0 },
              { key: 'year4', val: parseInt(basisYearLabels.year4) || 0 },
              { key: 'year5', val: parseInt(basisYearLabels.year5) || 0 }
            ];
            const filledSlots = existingSlots.filter(s => s.val > 0);
            
            let targetKey = 'year5'; // Default
            if (filledSlots.length > 0) {
              // Find exact year match first
              const exactSlot = filledSlots.find(s => s.val === pastedYear);
              if (exactSlot) {
                targetKey = exactSlot.key;
              } else {
                // Find chronological position among existing years
                const allYearVals = filledSlots.map(s => s.val).sort((a, b) => a - b);
                if (pastedYear < allYearVals[0]) {
                  // Before all existing years - find earliest empty slot
                  targetKey = existingSlots.find(s => s.val === 0)?.key || 'year1';
                } else if (pastedYear > allYearVals[allYearVals.length - 1]) {
                  // After all existing years - use year5 or last empty slot
                  targetKey = 'year5';
                } else {
                  // Between existing years - find the slot it would go in
                  for (let si = 0; si < existingSlots.length; si++) {
                    if (existingSlots[si].val === 0 || existingSlots[si].val === pastedYear || 
                        (si > 0 && existingSlots[si - 1].val < pastedYear && existingSlots[si].val > pastedYear)) {
                      targetKey = existingSlots[si].key;
                      break;
                    }
                  }
                }
              }
            }
            
            yearColumns[numericYears[0].idx] = targetKey;
            const existingLabel = basisYearLabels[targetKey];
            yearMatchInfo.push({
              detected: String(pastedYear),
              mappedTo: targetKey,
              label: existingLabel,
              matchType: existingLabel === String(pastedYear) ? 'exact' : 'position',
              isNew: existingLabel !== String(pastedYear),
              willOverwrite: existingLabel !== String(pastedYear) && existingLabel && existingLabel !== '0'
            });
          } else {
            // Multiple years: use standard position-based mapping
            // If 5 years, map to year1-year5
            // If 4 years, map to year2-year5
            // If 3 years, map to year3-year5
            const startYearKey = Math.max(1, 6 - numericYears.length);
            numericYears.forEach((y, i) => {
              const yearKey = `year${startYearKey + i}`;
              if (startYearKey + i <= 5) {
                yearColumns[y.idx] = yearKey;
                const existingLabel = basisYearLabels[yearKey];
                yearMatchInfo.push({
                  detected: String(y.year),
                  mappedTo: yearKey,
                  label: existingLabel,
                  matchType: existingLabel === String(y.year) ? 'exact' : 'position',
                  isNew: existingLabel !== String(y.year),
                  willOverwrite: existingLabel !== String(y.year)
                });
              }
            });
          }
        } else {
          // We had exact matches - check for any unmatched years (new years not in grid)
          numericYears.forEach(y => {
            const yearStr = String(y.year);
            if (!existingYearMap[yearStr] && !yearColumns[y.idx]) {
              // This year doesn't exist in current labels - find next available slot
              // or map to position based on chronological order
              const allYears = [
                parseInt(basisYearLabels.year1) || 0,
                parseInt(basisYearLabels.year2) || 0,
                parseInt(basisYearLabels.year3) || 0,
                parseInt(basisYearLabels.year4) || 0,
                parseInt(basisYearLabels.year5) || 0
              ];
              
              // Find where this year would fit chronologically
              let targetSlot = 'year5'; // Default to most recent
              
              // If this unmatched year comes alongside 3+ exact-matched years,
              // it's almost certainly a partial/YTD period (e.g. "Jan 1 - Mar 22 2026")
              // not a full year — skip it entirely rather than overwriting any slot.
              const isLikelyPartialYear = hasExactMatches && 
                Object.keys(yearColumns).length >= 3 &&
                (/\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(y.cell) ||
                 y.cell.includes(' - ') || y.cell.toLowerCase().includes('through') || 
                 y.cell.toLowerCase().includes('ytd'));
              
              if (isLikelyPartialYear) {
                // Skip — partial/YTD columns are ignored; TTM comes from the monthly tab
                yearMatchInfo.push({
                  detected: String(y.year),
                  mappedTo: null,
                  label: null,
                  matchType: 'skipped_partial',
                  isNew: false,
                  warning: `Column "${y.cell}" appears to be a partial/YTD period and will be ignored. TTM comes from the monthly P&L tab.`
                });
                return; // Don't add to yearColumns
              } else if (y.year > Math.max(...allYears)) {
                targetSlot = 'year5'; // Newer than all existing - goes to year5
              } else if (y.year < Math.min(...allYears.filter(yr => yr > 0))) {
                targetSlot = 'year1'; // Older than all existing
              }
              
              yearColumns[y.idx] = targetSlot;
              yearMatchInfo.push({
                detected: yearStr,
                mappedTo: targetSlot,
                label: basisYearLabels[targetSlot],
                matchType: 'new',
                isNew: true,
                willOverwrite: true,
                warning: `Year ${yearStr} not found in grid (currently ${basisYearLabels[targetSlot]}) - will overwrite ${targetSlot.replace('year', 'Year ')}`
              });
            }
          });
        }
      }
      
      // Map TTM/YTD columns
      specialCols.forEach(y => {
        if (y.year === 'ttm') {
          yearColumns[y.idx] = 'ttm';
          yearMatchInfo.push({
            detected: 'TTM',
            mappedTo: 'ttm',
            label: 'TTM',
            matchType: 'exact',
            isNew: false
          });
        } else if (y.year === 'ytd') {
          yearColumns[y.idx] = 'ttm'; // Treat YTD as TTM
          yearMatchInfo.push({
            detected: 'YTD',
            mappedTo: 'ttm',
            label: 'TTM',
            matchType: 'ytd_as_ttm',
            isNew: false,
            warning: 'YTD will be imported as TTM'
          });
        }
      });
    }
    
    // ONE-YEAR STATEMENT (Colleen 10-10, Aeroform AFA exports): no year in the column header —
    // "Current Period" | "YTD" — the year lives in a "Period: 01/01/23..12/31/23" line above. The position
    // fallback below read the two columns as 2023 AND 2024 (the same year twice). A full Jan 1 – Dec 31
    // period line maps the YTD column (else the first amount column) to that year's slot; a year not on the grid falls through.
    if (Object.keys(yearColumns).length === 0) {
      for (let r = 0; r < scanLimit; r++) {
        const pm = lines[r].match(/(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})\s*(?:\.\.+|-|–|—|to|through|thru)\s*(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})/i);
        if (!pm) continue;
        const yr = (t) => (t.length === 2 ? 2000 + parseInt(t) : parseInt(t));
        if (!(+pm[1] === 1 && +pm[2] === 1 && +pm[4] === 12 && +pm[5] === 31 && yr(pm[3]) === yr(pm[6]))) break;
        const fullYear = String(yr(pm[3]));
        const slot = ['year1', 'year2', 'year3', 'year4', 'year5'].find(k => String(basisYearLabels[k]) === fullYear);
        let colIdx = 1, hdr = -1;
        for (let h = r; h < scanLimit; h++) {
          const hc = lines[h].split('\t');
          const ytd = hc.findIndex((c, i) => i > 0 && /^\s*(ytd|year\s*to\s*date)\s*$/i.test(c));
          if (ytd > 0 || hc.some((c, i) => i > 0 && /^\s*current\s+period\s*$/i.test(c))) { hdr = h; if (ytd > 0) colIdx = ytd; break; }
        }
        if (slot) {
          yearColumns = { [colIdx]: slot };
          if (hdr >= 0) { headerRowIdx = hdr; dataStartRow = hdr + 1; }
          yearMatchInfo = [{ detected: 'Period ' + pm[0], mappedTo: slot, label: basisYearLabels[slot], matchType: 'statement_period', isNew: false }];
        }
        break;
      }
    }

    // If no years detected, assume columns are Year3, Year4, Year5, TTM
    if (Object.keys(yearColumns).length === 0) {
      yearColumns = { 1: 'year3', 2: 'year4', 3: 'year5', 4: 'ttm' };
      yearMatchInfo = [
        { detected: 'Column 1', mappedTo: 'year3', label: basisYearLabels.year3, matchType: 'assumed', warning: 'No years detected in header - using position-based mapping' },
        { detected: 'Column 2', mappedTo: 'year4', label: basisYearLabels.year4, matchType: 'assumed' },
        { detected: 'Column 3', mappedTo: 'year5', label: basisYearLabels.year5, matchType: 'assumed' },
        { detected: 'Column 4', mappedTo: 'ttm', label: 'TTM', matchType: 'assumed' }
      ];
    }
    
    // Parse all lines, tracking current section
    let currentSection = 'revenue'; // Default
    let currentSectionIndent = -1; // Indent depth of the row that established currentSection (hierarchical QB exports)
    const incomeHeaderIndents = []; // open "Income" headers, for closesNestedIncome
    let plGroup = [], plGroupSection = null;   // lines since the last header — a row equal to their sum is a subtotal (10-06)
    let belowBottomLine = false;   // past the statement's Net Income (10-12)
    let plSectionLines = [];       // every line of the current section, blank rows don't reset it (10-12)
    let currentSubSection = ''; // Track QB sub-headers like "Payroll", "Payroll-Officers'"
    // A sub-section is SCOPED BY INDENT (Colleen 09-22, Mojo Back Office: a
    // value-less "New mojoTools Hosted Environment" row on a flat statement
    // became a sub-header and prefixed the 40 unrelated rows below it until a
    // subtotal reset it). A header at depth N only prefixes rows deeper than N
    // and ends at the next row at N or above. On a flat paste (every row at
    // depth 0) that means a value-less row never prefixes anything — it is an
    // account with no activity, not a parent.
    let currentSubSectionIndent = -1;
    let opexEnteredViaBroadHeader = false; // Track if opex was entered via "Expenses" (broad) vs "Operating Expenses" (specific)
    let inCombinedOtherSection = false; // Track if inside a combined "Other Income/(Expenses)" section
    const seenNamesPerSection = {}; // Track duplicate names within each section
    const parsed = {
      revenue: [],
      cogs: [],
      opex: [],
      otherIncome: [],
      otherExpense: []
    };
    const skipped = [];
    const detectedYears = [...new Set(Object.values(yearColumns))];
    
    // Find the first (leftmost) value column index - needed for hierarchical QB format
    const valueColIndices = Object.keys(yearColumns).map(k => parseInt(k));
    const firstValueCol = valueColIndices.length > 0 ? Math.min(...valueColIndices) : 1;
    
    // Helper to extract account name from hierarchical QB format
    // QB exports can have names spread across columns 0-N based on indent level
    // The account name is the last non-empty text cell BEFORE the value columns
    const extractAccountInfo = (cells) => {
      // First try cells[0] (standard / flat format) — indent depth 0
      if ((cells[0] || '').trim()) {
        return { name: (cells[0] || '').trim(), indent: 0 };
      }
      // For hierarchical QB format, scan columns 0 to firstValueCol-1
      // Find the LAST non-empty cell (deepest indent level = actual account).
      // Its column index is the indent depth — used to tell a nested
      // sub-group header apart from a real section boundary.
      let name = '';
      let indent = 0;
      const scanLimit = Math.min(firstValueCol, cells.length);
      for (let c = 0; c < scanLimit; c++) {
        const cellVal = (cells[c] || '').trim();
        // Skip cells that look like numbers (values in wrong column)
        if (cellVal && !/^[\d,.$()-]+$/.test(cellVal)) {
          name = cellVal;
          indent = c;
        }
      }
      return { name, indent };
    };

    // True P&L section labels — names that genuinely denote a section, as
    // opposed to account-group names that merely match a broad section
    // keyword (e.g. "Payroll Taxes" matches /^payroll/ but is a sub-group
    // inside COGS, not the start of OpEx). Keeps real section headers from
    // ever being mistaken for nested sub-groups.
    const isTrueSectionLabel = (nm) => {
      const t = (nm || '').trim();
      return /^(revenues?|sales\s+revenue)\s*$/i.test(t) ||
             /^income\s*$/i.test(t) ||
             /^ordinary\s+income(\s*\/\s*expenses?)?\s*$/i.test(t) ||
             /^cost\s+of\s+(goods\s+)?(sold|sales)\s*$/i.test(t) ||
             /^cogs\s*$/i.test(t) ||
             /^direct\s+costs?\s*$/i.test(t) ||
             /^gross\s+(profit|margin)\s*$/i.test(t) ||
             /^(operating\s+)?expenses?\s*$/i.test(t) ||
             /^overhead\s*$/i.test(t) ||
             /^(general\s*&?\s*admin\w*|g\s*&\s*a|sg\s*&\s*a|administrative)(\s+expenses?)?\s*$/i.test(t) ||
             /^other\s+(income|revenue|expenses?)\s*$/i.test(t) ||
             /^other\s+income\s*\/\s*\(?\s*expenses?\)?\s*$/i.test(t) ||
             /^non[\s-]?operating\s+(income|expenses?|items?)(\s*\/\s*\(?\s*expenses?\)?)?\s*$/i.test(t);
    };
    
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      const { name, indent } = extractAccountInfo(cells);
      if (!name) continue;
      if (belowBottomLine) { skipped.push({ name, section: currentSection, reason: 'Below the bottom line (after Net Income)' }); continue; }

      const prevSection = currentSection; // Track for subsection reset
      
      // First, check if this row has any values (needed to determine if it's a real account or section header)
      let rowHasValue = false;
      let rowHasExplicitZero = false;   // explicit zeros are accounts, not headers (Hawver 09-22)
      Object.keys(yearColumns).forEach(colIdx => {
        let val = cells[parseInt(colIdx)] || '';
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
        if (parseFloat(val)) rowHasValue = true;
        else if (/^-?0*(\.0+)?$/.test(val) && val !== '' || val === '-') rowHasExplicitZero = true;
      });
      
      // Check if this looks like a section header
      let foundSection = null;
      for (const [section, patterns] of Object.entries(sectionPatterns)) {
        if (patterns.some(p => p.test(name))) {
          foundSection = section;
          break;
        }
      }
      
      // Guard: account names containing "COGS" should not trigger a switch to
      // non-COGS sections — e.g. "Payroll Job Labor - COGS" matches /^payroll/
      // but must stay in COGS, not switch to opex.
      // Exception: allow switching TO cogs (e.g. "Cost of Goods Sold" header is correct).
      if (foundSection && foundSection !== 'cogs' && /cogs/i.test(name)) {
        foundSection = null;
      }
      
      // Enforce forward-only section transitions (P&L flows: revenue → cogs → opex → otherIncome → otherExpense)
      // Prevents QB sub-categories like "Other Revenue" (under Revenue) from triggering jump to otherIncome
      const sectionOrder = { revenue: 0, cogs: 1, opex: 2, otherIncome: 3, otherExpense: 4 };
      if (foundSection && sectionOrder[foundSection] > sectionOrder[currentSection] + 1) {
        foundSection = null; // Reject: would skip intermediate sections
      }
      if (foundSection && sectionOrder[foundSection] < sectionOrder[currentSection]) {
        // Backward match — re-scan for a forward-compatible section
        // e.g., "Other Expenses" matches opex but we're already past opex, try otherExpense
        foundSection = null;
        for (const [section, patterns] of Object.entries(sectionPatterns)) {
          if (sectionOrder[section] >= sectionOrder[currentSection] && patterns.some(p => p.test(name))) {
            foundSection = section;
            break;
          }
        }
      }
      
      // Indent-aware section-boundary detection (hierarchical QB exports).
      // A value-less row that matches a section pattern is only a real
      // section boundary when it sits at or above the current section's
      // indent depth. Rows nested DEEPER are sub-groups within the section
      // (e.g. "Payroll Taxes" several levels inside COGS) — treating them
      // as boundaries drags every line below, including Depreciation, into
      // the wrong section. Rows matching the SAME section are a more-
      // specific header (QB nests "Income"/"Cost of Goods Sold"/"Expense"
      // under "Ordinary Income/Expense") and refine the tracked depth.
      if (foundSection && !rowHasValue) {
        const acctSub = name.match(/^\d{3,6}(?:\.\d+)?\s*[·•.:\-–—]\s*(.+)$/);
        if (acctSub && !isTrueSectionLabel(acctSub[1])) {
          // QB account-numbered group header ("5120 · Software Expense") =
          // a sub-group INSIDE the current section, never a boundary —
          // unless the post-code name is a true section label ("5000 ·
          // Cost of Goods Sold"). Colleen's Concise Computer catch 08-19:
          // on the FLAT template sheet (uniform indent) the first value-
          // less COGS parent ending in "Expense" flipped the parser to
          // OpEx and dragged the rest of COGS (~$350k/yr) with it — the
          // indent guard below can't help when every row has equal indent.
          foundSection = null;
        } else if (foundSection === currentSection && (isTrueSectionLabel(name) || currentSectionIndent < 0 || indent <= currentSectionIndent)) {   // a DEEPER keyword-named group ("Payroll-Officers'" inside Expense) falls through to the sub-group branch below (Fabkom 10-05)
          // Re-declared section header (e.g. "Income" nested under "Ordinary
          // Income/Expense"). Only a genuine section label may refine the
          // tracked depth — a sub-group that merely matches a broad keyword
          // (e.g. "Payroll- Admin & office") must not claim section depth.
          if (isTrueSectionLabel(name)) currentSectionIndent = indent;
        } else if (currentSectionIndent >= 0 && indent > currentSectionIndent && !isTrueSectionLabel(name)) {
          foundSection = null;
        } else {
          currentSectionIndent = indent;
        }
      }

      if (foundSection) {
        if (!rowHasValue) {
          // No values → definite section header, change section and skip row
          if (foundSection === 'revenue' && PL_INCOME_HEADER_RX.test(name)) incomeHeaderIndents.push(indent);
          // Track if opex entered via broad "Expenses" header (vs specific "Operating Expenses")
          if (foundSection === 'opex') {
            const isOperatingExpense = /^operating\s*expense/i.test(name.trim());
            if (!isOperatingExpense) {
              opexEnteredViaBroadHeader = true; // "Expenses" is broad — "Operating Expenses" within it is a subsection
            }
          }
          // Track combined "Other Income/(Expenses)" sections — sign ambiguous, NET row is authoritative
          if (foundSection === 'otherIncome' && /income\s*\/\s*\(\s*expense|income\s*\(\s*expense/i.test(name)) {
            inCombinedOtherSection = true;
          } else if (foundSection !== 'otherIncome' && foundSection !== 'otherExpense') {
            inCombinedOtherSection = false;
          }
          currentSection = foundSection;
          currentSubSection = ''; // Always clear subsection when entering a new section
          plGroup = [];
          continue;
        } else {
          // Has values AND matches a section pattern
          // Only change section for COGS (QB has "Cost of Goods Sold" as both header and data row)
          // Don't change for ambiguous matches like "Other Revenue/Commissions" or "Sales"
          if (foundSection === 'cogs') {
            currentSection = foundSection;
          }
          // Fall through to add data row to current section
        }
      }
      
      // A ratio line ("Net Revenue (%)") is never an amount (Colleen 10-10, Aeroform).
      if (isPlPercentRow(name)) {
        skipped.push({ name, section: currentSection, reason: 'Percentage line (not an amount)' });
        continue;
      }

      // Check if this is a subtotal row
      if (isSubtotal(name)) {
        // Extract the subtotal value for verification
        const vals = {};
        Object.entries(yearColumns).forEach(([colIdx, yearKey]) => {
          let val = cells[parseInt(colIdx)] || '';
          val = val.replace(/[$,]/g, '').trim();
          if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
          vals[yearKey] = (vals[yearKey] || 0) + (parseFloat(val) || 0);   // accumulate like the accounts do (P&L-by-Month: 12 columns, one year)
        });
        skipped.push({ name, section: currentSection, values: vals, reason: 'Subtotal' });
        if (PL_BOTTOM_LINE_RX.test(name.trim()) && ['opex', 'otherIncome', 'otherExpense'].includes(currentSection)) belowBottomLine = true;
        
        // Reset subsection header when its subtotal appears (e.g., "Total Payroll Taxes" clears "Payroll Taxes" subsection)
        if (currentSubSection) {
          const subLower = currentSubSection.toLowerCase();
          const totalLower = name.toLowerCase();
          if (totalLower.includes(subLower) || totalLower.replace(/^total\s*(for\s*)?/i, '').trim().startsWith(subLower)) {
            currentSubSection = '';
          }
        }
        
        // SUBTOTAL-BASED SECTION TRANSITIONS
        // When section headers live in a column not included in the paste,
        // use subtotal rows as section boundary markers
        const nameLower = name.trim().toLowerCase();
        // Anchor to the GRAND total only (\s*$) — same fix as the monthly
        // parser (Konnie/Canitan 09-15): without it, a nested sub-group
        // subtotal like "Total for Income - Other" flips revenue→COGS early
        // and dumps every income category below it into COGS. A bare "Total
        // for Income"/"Total Income" is the section end; "Total for Income - X"
        // is a sub-total, not a boundary.
        if (/^total\s*(for\s*)?(income|revenue|operating\s+income)\s*$/i.test(nameLower) || /^(income|revenue)\s*-?\s*total\s*$/i.test(nameLower)) {
          // After Total Income → COGS section — unless it closes an "Income"
          // group nested inside the real one (Epic Electric 11-02)
          if (currentSection === 'revenue' && !closesNestedIncome(incomeHeaderIndents, indent)) {
            currentSection = 'cogs';
          }
        } else if (/^gross\s*(profit|margin)/i.test(nameLower) || /^total\s*(cost\s*of\s*(goods|sales)(\s*sold)?|cogs)\s*$/i.test(nameLower)) {
          // After Gross Profit or Total COGS / Total Cost of Goods Sold → OpEx section
          // NOTE: "Total Cost of Services Sold" intentionally does NOT match — it's a COGS
          // sub-total, and more COGS line items may follow it (e.g. "5000 · Cost of Goods Sold")
          if (currentSection === 'cogs' || currentSection === 'revenue') {
            currentSection = 'opex';
          }
        } else if (/^total\s*(for\s*)?operating\s*expense/i.test(nameLower) || /^operating\s*(income|profit|loss)/i.test(nameLower) || /^(net\s+)?(income|profit|earnings|loss)\b.*\bfrom\s+operations\s*$/i.test(nameLower)) {
          // After Total OpEx or Operating Income → Other Income section
          // BUT: if opex was entered via broad "Expenses" header, "Total for Operating Expenses" is just a subcategory
          if (currentSection === 'opex') {
            if (/^operating\s*(income|profit|loss)/i.test(nameLower) || /^(net\s+)?(income|profit|earnings|loss)\b.*\bfrom\s+operations\s*$/i.test(nameLower)) {
              currentSection = 'otherIncome'; // Operating Income line always triggers transition
            } else if (!opexEnteredViaBroadHeader) {
              currentSection = 'otherIncome'; // Only transition if "Operating Expenses" was the top-level header
            }
            // If opexEnteredViaBroadHeader, skip — this is a subcategory total, real end comes later
          }
        } else if (/^total\s*(for\s*)?expenses?\s*$/i.test(nameLower)) {
          // "Total for Expenses" or "Total Expenses" — the broad end of ALL expenses
          if (currentSection === 'opex') {
            currentSection = 'otherIncome';
          }
        } else if (/^total\s*(for\s*)?(other\s+income|other\s+revenue|non[\s-]?operating\s*income)\s*$/i.test(nameLower)) {
          // After Total Other Income → Other Expense section
          if (currentSection === 'otherIncome') {
            currentSection = 'otherExpense';
          }
        } else if (inCombinedOtherSection && (/^net\s+other\s*(income|expense)/i.test(nameLower) || /^total\s+other\s+income\s*[\/(]/i.test(nameLower))) {
          // "NET OTHER INCOME / (EXPENSES)" — combined section net total.
          // QB combined sections have ambiguous sign conventions on individual items
          // (e.g., a credit on an expense account shows as negative but ADDS to income).
          // The NET row is the authoritative sign-adjusted total.
          // Replace any individual items captured from this combined section with one
          // canonical entry: positive NET → otherIncome, negative NET → otherExpense.
          //
          // IMPORTANT: Only do canonical replacement if there are actually combined-tagged items.
          // When QB exports have explicit "Other Income" and "Other Expense" sub-sections
          // (like "Other Income/Expense" → "Other Income" → items → "Other Expense" → items),
          // the individual items are correctly classified already. In that case, the NET row
          // should be skipped as a regular subtotal — not used to replace the individual items.
          const hasCombinedItems = parsed.otherIncome.some(r => r._fromCombinedSection) ||
                                    parsed.otherExpense.some(r => r._fromCombinedSection);
          if (hasCombinedItems) {
            const netVals = {};
            let hasNetValue = false;
            Object.entries(yearColumns).forEach(([colIdx, yearKey]) => {
              let val = cells[parseInt(colIdx)] || '';
              val = val.replace(/[$,]/g, '').trim();
              if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
              const num = parseFloat(val) || 0;
              netVals[yearKey] = num;
              if (num !== 0) hasNetValue = true;
            });
            if (hasNetValue && !resolveCombinedOtherSigns(parsed, netVals, 'yearValues')) {
              // Remove individual items from combined section (they had ambiguous signs)
              parsed.otherIncome = parsed.otherIncome.filter(r => !r._fromCombinedSection);
              parsed.otherExpense = parsed.otherExpense.filter(r => !r._fromCombinedSection);
              // Add single canonical entry with correct sign
              const posVals = {}, negVals = {};
              let hasPos = false, hasNeg = false;
              Object.entries(netVals).forEach(([yk, v]) => {
                if (v > 0) { posVals[yk] = v; hasPos = true; } else { posVals[yk] = 0; }
                if (v < 0) { negVals[yk] = Math.abs(v); hasNeg = true; } else { negVals[yk] = 0; }
              });
              if (hasPos) parsed.otherIncome.push({ name: 'Other Income / (Expenses)', yearValues: posVals, yearsPresent: detectedYears, _netCombined: true });
              if (hasNeg) parsed.otherExpense.push({ name: 'Other Income / (Expenses)', yearValues: negVals, yearsPresent: detectedYears, _netCombined: true });
            }
          }
          // If no combined items, treat as regular subtotal (individual items already parsed correctly)
        }
        
        continue;
      }
      
      // Parse year values - ONLY include years that were detected in the paste
      const yearValues = {};
      const yearsPresent = []; // Track which years actually have data
      Object.entries(yearColumns).forEach(([colIdx, yearKey]) => {
        let val = cells[parseInt(colIdx)] || '';
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
        const numVal = parseFloat(val) || 0;
        // ACCUMULATE, don't overwrite. A "P&L by Month" export has 12 single-month
        // columns that all carry the same year (e.g. "Jan 2024" … "Dec 2024"), so they
        // all map to the same year slot — summing yields the annual figure. For a normal
        // report each year maps to exactly one column, so this is identical to assignment.
        yearValues[yearKey] = (yearValues[yearKey] || 0) + numVal;
        yearsPresent.push(yearKey); // Track that this year was in the paste
      });
      
      // Only add if there's at least some non-zero value (skip parent category rows with no data)
      const hasValue = Object.values(yearValues).some(v => v !== 0);
      if (hasValue && plGroupSection !== currentSection) { plGroup = []; plSectionLines = []; plGroupSection = currentSection; }
      if (hasValue && currentSection === 'revenue' && endsRevenueSection(name, yearValues, parsed.revenue, 'yearValues')) {
        skipped.push({ name, section: currentSection, reason: 'Subtotal (revenue total, costs follow)', values: { ...yearValues } });
        currentSection = 'cogs'; plGroup = [];
        continue;
      }
      if (hasValue && (equalsGroupSum(yearValues, plGroup, Object.keys(yearColumns).length === 1 && /^(net|total)\b/i.test(name) ? 1 : 2)
          || (/^(net|total)\b/i.test(name) && equalsSectionTail(yearValues, plSectionLines, Object.keys(yearColumns).length === 1 ? 1 : 2)))) {
        skipped.push({ name, section: currentSection, reason: 'Subtotal (equals the lines above)', values: { ...yearValues } });
        continue;
      }
      if (hasValue) {
        plGroup.push({ ...yearValues });
        plSectionLines.push({ ...yearValues });
        // Reset subsection tracker when main section changes
        if (currentSection !== prevSection) currentSubSection = '';
        
        // Prefix with subsection header for P&L context (e.g., "Federal Taxes" → "Payroll Taxes > Federal Taxes")
        if (currentSubSection && indent <= currentSubSectionIndent) currentSubSection = '';   // back at the parent's depth — the group is over
        let finalName = name;
        if (currentSubSection && !name.toLowerCase().startsWith(currentSubSection.toLowerCase())) {
          finalName = `${currentSubSection} > ${name}`;
        }
        
        // Disambiguate duplicate names within same section
        if (!seenNamesPerSection[currentSection]) seenNamesPerSection[currentSection] = {};
        if (seenNamesPerSection[currentSection][finalName.toLowerCase()]) {
          const count = seenNamesPerSection[currentSection][finalName.toLowerCase()] + 1;
          finalName = `${finalName} (${count})`;
        }
        seenNamesPerSection[currentSection][finalName.toLowerCase()] = (seenNamesPerSection[currentSection][finalName.toLowerCase()] || 0) + 1;
        
        const _rt = otherSectionReroute(currentSection, finalName, yearValues);
        parsed[_rt.section].push({ name: finalName, yearValues: _rt.values, yearsPresent, originalRow: lines[i], _fromCombinedSection: inCombinedOtherSection && (currentSection === 'otherIncome' || currentSection === 'otherExpense'),
          ...(_rt.section !== currentSection ? { _rerouteFrom: { section: currentSection, values: yearValues } } : {}) });
      } else if (!foundSection && !rowHasExplicitZero) {
        // No values in mapped columns — but check ALL columns before treating as subsection header.
        // If any column (including skipped YTD/Total columns) has a non-zero value,
        // this is a data row intentionally skipped — NOT a subsection header.
        const hasValueInAnyCol = cells.slice(1).some(c => {
          const v = (c || '').replace(/[$,()]/g, '').trim();
          const n = parseFloat(v);
          return !isNaN(n) && n !== 0;
        });
        if (!hasValueInAnyCol) {
          // Only set as subsection header if it's a real account group, not a section label.
          // Section labels (REVENUES, COST OF GOODS SOLD, OPERATING EXPENSES, etc.) should
          // never become prefixes — they are structural dividers, not account parents.
          // This applies whether accounts are numbered (5000-Auto) or named (Auto Expenses).
          const isSectionLabel = (
            /^(revenues?|income|ordinary\s+income|sales\s+revenue)\s*$/i.test(name) ||
            /^cost\s+of\s+(goods\s+)?sold\s*$/i.test(name) ||
            /^cogs\s*$/i.test(name) ||
            /^gross\s*(profit|margin)\s*$/i.test(name) ||
            /^operating\s+expenses?\s*$/i.test(name) ||
            /^(other\s+income|other\s+expense|other\s+revenue)\s*$/i.test(name) ||
            /^non[\s-]?operating\s+(items?|income|expenses?)\s*$/i.test(name) ||
            /^(expenses?|income|revenue)\s*$/i.test(name) ||
            /^(total|subtotal)/i.test(name)
          );
          // Numbered account rows (e.g. '5004 - Cost of Goods: Labor') are QB grouping
          // artifacts, not true sub-account parents. Only named groups (e.g. 'Payroll',
          // 'Auto', 'Benefits') should become subsection prefixes — whether accounts are
          // numbered or not, the PREFIX itself must be a plain name, not an account number.
          const isNumberedAccount = /^\d{3,}[\s\-]/.test(name);
          if (!isSectionLabel && !isNumberedAccount) {
            currentSubSection = name;
          plGroup = [];
            currentSubSectionIndent = indent;
          }
        }
        // If hasValueInAnyCol: row had data only in skipped columns — silently skip it
      }
    }
    
    // POST-PROCESSING: Remove parent rows that are duplicated by their children
    // QB exports sometimes have both a parent total row AND child detail rows.
    // E.g., "5470 Sales Travel" ($8,086) AND "5470 Sales Travel > 5471..." ($7,355) + "5470 Sales Travel > 5472..." ($731)
    // The parent is just a sum of the children — keeping both double-counts.
    Object.entries(parsed).forEach(([section, rows]) => {
      // Find all parent names that appear as prefixes in "Parent > Child" rows
      const parentPrefixes = new Set();
      rows.forEach(row => {
        const gtIdx = row.name.indexOf(' > ');
        if (gtIdx > 0) {
          parentPrefixes.add(row.name.substring(0, gtIdx).toLowerCase());
        }
      });
      
      if (parentPrefixes.size > 0) {
        // Remove standalone parent rows whose name matches a prefix
        parsed[section] = rows.filter(row => {
          const nameLC = row.name.toLowerCase();
          if (parentPrefixes.has(nameLC)) {
            // This is a parent row with children — remove it (children have the detail)
            return false;
          }
          return true;
        });
      }
    });
    
    // DEBUG: Show parse results summary
    Object.entries(parsed).forEach(([section, rows]) => {
    });
    
    undoReroutesAgainstStatement(parsed, skipped, 'yearValues');
    // Build verification totals
    const verification = {};
    Object.entries(parsed).forEach(([section, rows]) => {
      verification[section] = { calculated: {}, count: rows.length };
      detectedYears.forEach(yr => {
        verification[section].calculated[yr] = rows.reduce((sum, r) => sum + (r.yearValues[yr] || 0), 0);
      });
    });
    
    // Match QB subtotals to sections by subtotal NAME (not currentSection)
    const subtotalToSection = {
      revenue: [/total\s*(income|revenue|sales)/i, /^income\s*-\s*total/i],
      cogs: [/total\s*(cost\s*of|cogs|direct)/i, /cost\s*of\s*(goods|sales).*total/i],
      opex: [/total\s*expense/i, /^expense.*total/i, /operating\s*expense.*total/i],
      otherIncome: [/total\s*(for\s*)?other\s*income/i],
      otherExpense: [/total\s*(for\s*)?other\s*expenses?/i]
    };
    
    skipped.forEach(s => {
      const nameLower = s.name.toLowerCase();
      // Find which section this subtotal belongs to based on its name
      // Use LAST match (not first) because QB can have duplicate subtotal names
      // e.g., "Total Other Income" appears as both a revenue sub-category total AND the actual Other Income section total
      // The actual section total always comes later in P&L order
      for (const [section, patterns] of Object.entries(subtotalToSection)) {
        if (patterns.some(p => p.test(s.name))) {
          if (verification[section]) {
            verification[section].qbSubtotal = s.values;
          }
          break;
        }
      }
    });
    
    return {
      parsed,
      skipped,
      verification,
      detectedYears,
      yearColumns,
      yearMatchInfo,
      basisYearLabels: { ...basisYearLabels }, // Include current labels for preview
      totalRows: Object.values(parsed).reduce((sum, arr) => sum + arr.length, 0)
    };
  };
  
  // Apply Full P&L Paste
  const applyFullPLPaste = () => {
    if (!fullPLPastePreview) return;
    
    try {
      snapshotBeforePaste('annual P&L paste');
      captureUndoState(`Paste Full P&L (${fullPLPasteBasis})${annualPasteClearFirst ? ' - Clear & Replace' : ''}`);
      const basis = fullPLPasteBasis;
      const { parsed, yearMatchInfo } = fullPLPastePreview;
      recordSourceTotals('pl', basis, plStmtByLabel(fullPLPastePreview, basisYearLabels), annualPasteClearFirst);
      
      // Update year labels if we detected years that differ from current labels
      if (yearMatchInfo && yearMatchInfo.length > 0) {
        const newLabels = { ...basisYearLabels };
        let labelsChanged = false;
        
        yearMatchInfo.forEach(info => {
          if (info.mappedTo && info.mappedTo !== 'ttm' && info.detected) {
            // If detected year is a numeric year (like "2024") and differs from current label
            const detectedYear = info.detected;
            if (/^\d{4}$/.test(detectedYear)) {
              const currentLabel = newLabels[info.mappedTo];
              if (currentLabel !== detectedYear) {
                newLabels[info.mappedTo] = detectedYear;
                labelsChanged = true;
              }
            }
          }
        });
        
        if (labelsChanged) {
          setBasisYearLabels(newLabels);
        }
      }
      
      // Check if we need to roll forward existing data (new year being added that's newer than year5)
      let needsRollForward = false;
      let rollForwardNewYear = null;
      if (yearMatchInfo && yearMatchInfo.length > 0) {
        yearMatchInfo.forEach(info => {
          if (info.isNew && info.willOverwrite && info.mappedTo === 'year5') {
            const detectedYear = parseInt(info.detected);
            const currentYear5 = parseInt(basisYearLabels.year5);
            if (!isNaN(detectedYear) && !isNaN(currentYear5) && detectedYear > currentYear5) {
              needsRollForward = true;
              rollForwardNewYear = info.detected;
            }
          }
        });
      }
      
      // If roll-forward needed, shift all existing data first
      if (needsRollForward) {
        console.log('Roll-forward detected: shifting data for new year', rollForwardNewYear);
        
        // Shift data in all categories for the selected basis
        const shiftCategoryData = (categories, setter) => {
          const shifted = categories.map(item => {
            const basisData = item[basis] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
            const shiftedBasis = {
              year1: basisData.year2 || 0,
              year2: basisData.year3 || 0,
              year3: basisData.year4 || 0,
              year4: basisData.year5 || 0,
              year5: 0, // Will be filled by the paste
              ttm: basisData.ttm || 0
            };
            return {
              ...item,
              cash: basis === 'cash' ? shiftedBasis : { ...(item.cash || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
              accrual: basis === 'accrual' ? shiftedBasis : { ...(item.accrual || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
              tax: basis === 'tax' ? { ...shiftedBasis, ttm: undefined } : { ...(item.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }) }
            };
          });
          setter(shifted);
          return shifted;
        };
        
        // Shift all categories
        // If Clear & Replace is checked, skip the shift and start fresh — no orphaned rows survive
        const shiftedRevenue = annualPasteClearFirst ? [] : shiftCategoryData(revenueCategories, setRevenueCategories);
        const shiftedCogs = annualPasteClearFirst ? [] : shiftCategoryData(cogsCategories, setCogsCategories);
        const shiftedOpex = annualPasteClearFirst ? [] : shiftCategoryData(opexCategories, setOpexCategories);
        const shiftedOtherIncome = annualPasteClearFirst ? [] : shiftCategoryData(otherIncomeCategories, setOtherIncomeCategories);
        const shiftedOtherExpense = annualPasteClearFirst ? [] : shiftCategoryData(otherExpenseCategories, setOtherExpenseCategories);
        // If clearing, explicitly reset React state to empty (shiftCategoryData setters didn't fire)
        if (annualPasteClearFirst) {
          setRevenueCategories([]); setCogsCategories([]); setOpexCategories([]);
          setOtherIncomeCategories([]); setOtherExpenseCategories([]);
          setMonthlyTtmRevenue({}); setMonthlyTtmCogs({}); setMonthlyTtmOpex({});
          setMonthlyTtmOtherIncome({}); setMonthlyTtmOtherExpense({});
        }
        // Update year labels: shift and add new year
        const shiftedLabels = {
          ...basisYearLabels,
          year1: basisYearLabels.year2,
          year2: basisYearLabels.year3,
          year3: basisYearLabels.year4,
          year4: basisYearLabels.year5,
          year5: rollForwardNewYear
        };
        setBasisYearLabels(shiftedLabels);
        
        // Counter to ensure unique IDs when creating new rows
        let shiftIdCounter = 0;
        
        // Now apply the paste to the shifted data
        const updateCategoryAfterShift = (shifted, newRows, setter) => {
          const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
          let updated = shifted.map(item => ({
            ...item,
            cash: { ...(item.cash || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
            accrual: { ...(item.accrual || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
            tax: { ...(item.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }) }
          }));
          
          newRows.forEach(row => {
            let matchIdx = updated.findIndex(item => item.name === row.name);
            if (matchIdx === -1) {
              const normalizedNew = normalizeForMatch(row.name);
              matchIdx = updated.findIndex(item => normalizeForMatch(item.name || '') === normalizedNew);
            }
            
            if (matchIdx !== -1) {
              const currentBasisData = { ...(updated[matchIdx][basis] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) };
              if (row.yearsPresent && row.yearsPresent.length > 0) {
                row.yearsPresent.forEach(yearKey => {
                  if (row.yearValues[yearKey] !== undefined) {
                    currentBasisData[yearKey] = row.yearValues[yearKey];
                  }
                });
              }
              updated[matchIdx] = { ...updated[matchIdx], [basis]: currentBasisData };
            } else {
              const newBasisData = { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
              if (row.yearsPresent && row.yearsPresent.length > 0) {
                row.yearsPresent.forEach(yearKey => {
                  if (row.yearValues[yearKey] !== undefined) {
                    newBasisData[yearKey] = row.yearValues[yearKey];
                  }
                });
              }
              updated.push({
                id: Date.now() + (++shiftIdCounter) + Math.random(),
                name: row.name,
                cash: basis === 'cash' ? newBasisData : { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
                accrual: basis === 'accrual' ? newBasisData : { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
                tax: basis === 'tax' ? newBasisData : { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
              });
            }
          });
          
          setter(pruneZeroRows(updated));
        };
        
        // Apply paste to shifted data
        if (parsed.revenue.length > 0) updateCategoryAfterShift(shiftedRevenue, parsed.revenue, setRevenueCategories);
        if (parsed.cogs.length > 0) updateCategoryAfterShift(shiftedCogs, parsed.cogs, setCogsCategories);
        if (parsed.opex.length > 0) updateCategoryAfterShift(shiftedOpex, parsed.opex, setOpexCategories);
        if (parsed.otherIncome.length > 0) updateCategoryAfterShift(shiftedOtherIncome, parsed.otherIncome, setOtherIncomeCategories);
        if (parsed.otherExpense.length > 0) updateCategoryAfterShift(shiftedOtherExpense, parsed.otherExpense, setOtherExpenseCategories);
        
        // Close modal and return
        setShowFullPLPasteModal(false);
        setFullPLPasteData('');
        setFullPLPastePreview(null);
        setAnnualPasteClearFirst(false);
      setAnnualPasteClearTtmOnly(false);
        return;
      }
      
      // Helper to update a category - DEEP COPY and only update years present in paste
      // Counter ensures unique IDs when creating multiple new rows
      let updateCategoryIdCounter = 0;
      const updateCategory = (existing, newRows, setter, prior) => {
        const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
        
        // DEEP COPY - must copy nested cash/accrual/tax objects to avoid mutation
        let updated = existing.map(item => ({
          ...item,
          cash: { ...(item.cash || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
          accrual: { ...(item.accrual || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) },
          tax: { ...(item.tax || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }) }
        }));
        const identityUsed = new Set(updated.map(u => u.id));   // ids still on the list can't be re-taken (10-12)
        
        // Track which existing indices have been matched to prevent two paste rows
        // claiming the same existing category (e.g. two "Parent > Officer Salary" rows)
        const matchedIndices = new Set();
        // Track original length — cross-format matching must ONLY search within pre-existing rows.
        // Newly pushed rows (added earlier in this same paste) must not be re-matched by
        // subsequent paste rows, or values get overwritten (e.g. "Health Insurance" $21k added
        // as new row, then "Company Contributions > Health Insurance" $1.4k overwrites it via
        // cross-format child match because matchedIndices doesn't cover newly-added rows).
        const originalLength = updated.length;
        const pasteOrderIdx = [];   // where each paste row landed — used to lay them out in report order

        const dupPre = preassignDuplicateChildren(newRows, updated.slice(0, originalLength), normalizeForMatch);
        newRows.forEach((row, ri) => {
          // Helper: strip QB account code prefix (e.g. "4001 - ", "4013-7 ", "4024 - ")
          // Handles both "NNNN - Name" and "NNNN-N Name" (with or without " - " separator)
          const stripAcctCode = (s) => s.replace(/^\d[\d-]*\s*-?\s+/, '').trim();
          const normalizedNew = normalizeForMatch(row.name);

          // Pass 1: exact match
          let matchIdx = updated.findIndex((item, idx) => !matchedIndices.has(idx) && item.name === row.name);

          // Pass 2: normalized match (strips punctuation/case)
          if (matchIdx === -1) {
            matchIdx = updated.findIndex((item, idx) => !matchedIndices.has(idx) && normalizeForMatch(item.name || '') === normalizedNew);
          }

          // Pass 2b: duplicate child names resolved by heading (Fabkom) — the pasted name wins.
          if (matchIdx === -1 && dupPre.has(ri) && !matchedIndices.has(dupPre.get(ri))) {
            matchIdx = dupPre.get(ri);
            updated[matchIdx] = { ...updated[matchIdx], name: row.name };
          }

          // Pass 3: account-code-stripped match for FLAT names (no " > ")
          // Handles QB-stored names like "4024 - Maintenance w/out Help Desk" vs plain "Maintenance w/out Help Desk"
          // These never reach the cross-format block because neither name contains " > "
          // Restricted to originalLength — must not match rows added by earlier paste rows in this same call
          if (matchIdx === -1) {
            matchIdx = updated.findIndex((item, idx) => {
              if (idx >= originalLength || matchedIndices.has(idx) || !item.name || item.name.includes(' > ')) return false;
              return normalizeForMatch(stripAcctCode(item.name)) === normalizedNew;
            });
            if (matchIdx !== -1) {
              // Rename stored name to the clean version from the paste
              updated[matchIdx] = { ...updated[matchIdx], name: row.name };
            }
          }

          // Pass 4: cross-format matching: "Parent > Child" ↔ "Child"
          // Handles re-pastes after subcategory fix created "Parent > Child" names.
          // Also corrects previously-stored bad names (e.g. "do not use (deleted) > Account")
          // back to the clean parsed name.
          if (matchIdx === -1 && row.name.includes(' > ')) {
            // New row is "Parent > Child" — try matching just the child portion to existing
            // Also try stripping account code prefix from child (e.g. "4001 - Consulting Service" → "Consulting Service")
            const childPart = row.name.split(' > ').pop().trim();
            const normalizedChild = normalizeForMatch(childPart);
            const normalizedChildStripped = normalizeForMatch(stripAcctCode(childPart));
            // Only match if the child name is unique in this paste batch
            const childCountInPaste = newRows.filter(r => r.name.includes(' > ') && (
              normalizeForMatch(r.name.split(' > ').pop().trim()) === normalizedChild ||
              normalizeForMatch(stripAcctCode(r.name.split(' > ').pop().trim())) === normalizedChildStripped
            )).length;
            if (childCountInPaste <= 1) {
              // Restrict to originalLength — must not match rows added by earlier paste rows in this same call
              matchIdx = updated.findIndex((item, idx) => idx < originalLength && !matchedIndices.has(idx) && (
                normalizeForMatch(item.name || '') === normalizedChild ||
                normalizeForMatch(item.name || '') === normalizedChildStripped
              ));
              // The PASTE's name wins (Colleen 10-05, Blue Spruce) — "Sensilla > Payroll" replaces a stored "Payroll".
              if (matchIdx !== -1) updated[matchIdx] = { ...updated[matchIdx], name: row.name };
            }
          }
          if (matchIdx === -1 && !row.name.includes(' > ')) {
            // New row is plain "Child" — try matching against existing "Parent > Child" names
            // Also strips account code from existing child part to handle QB hierarchy names
            // e.g. existing "REVENUES > 4001 - Consulting Service" matches new "Consulting Service"
            // Restricted to originalLength — must not match rows added by earlier paste rows in this same call
            const normalizedNew = normalizeForMatch(row.name);
            matchIdx = updated.findIndex((item, idx) => {
              if (idx >= originalLength || matchedIndices.has(idx) || !item.name || !item.name.includes(' > ')) return false;
              const existingChild = item.name.split(' > ').pop().trim();
              if (normalizeForMatch(existingChild) === normalizedNew) return true;
              return normalizeForMatch(stripAcctCode(existingChild)) === normalizedNew;
            });
            // If found, correct the stored name to the clean version from the paste
            if (matchIdx !== -1) {
              updated[matchIdx] = { ...updated[matchIdx], name: row.name };
            }
          }
          
          if (matchIdx !== -1) matchedIndices.add(matchIdx);
          
          if (matchIdx !== -1) {
            // Update existing row - ONLY update years that were present in the paste
            const currentBasisData = { ...(updated[matchIdx][basis] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }) };
            
            // Only update years that were actually in the pasted data
            if (row.yearsPresent && row.yearsPresent.length > 0) {
              row.yearsPresent.forEach(yearKey => {
                if (row.yearValues[yearKey] !== undefined) {
                  currentBasisData[yearKey] = row.yearValues[yearKey];
                }
              });
            }
            
            updated[matchIdx] = {
              ...updated[matchIdx],
              [basis]: currentBasisData
            };
            pasteOrderIdx.push(matchIdx);
          } else {
            // Add new row - initialize with zeros, then set only years present
            const newBasisData = { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
            if (row.yearsPresent && row.yearsPresent.length > 0) {
              row.yearsPresent.forEach(yearKey => {
                if (row.yearValues[yearKey] !== undefined) {
                  newBasisData[yearKey] = row.yearValues[yearKey];
                }
              });
            }
            
            updated.push(inheritLineIdentity({
              id: Date.now() + (++updateCategoryIdCounter) + Math.random(),
              name: row.name,
              cash: basis === 'cash' ? newBasisData : { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
              accrual: basis === 'accrual' ? newBasisData : { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
              tax: basis === 'tax' ? newBasisData : { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }
            }, prior, identityUsed));
            pasteOrderIdx.push(updated.length - 1);
          }
        });

        // Report order (Colleen 10-05): pasted lines go back into their own slots in the order the report lists them.
        {
          const seen = new Set(); const idx = pasteOrderIdx.filter(i => !seen.has(i) && seen.add(i));
          const slots = [...idx].sort((a, b) => a - b);
          const rowsInOrder = idx.map(i => updated[i]);
          slots.forEach((slot, k) => { updated[slot] = rowsInOrder[k]; });
        }
        setter(pruneZeroRows(updated));
      };
      
      // Build the source array for updateCategory atomically:
      // - Clear & Replace: empty array (all rows come fresh from paste)
      // - Clear Annual Only: zero year1-5 in-memory BEFORE passing to updateCategory
      //   (avoids React state timing race — a separate setState call fires async and
      //    updateCategory would read stale closure values, making the clear a no-op)
      // - Default: pass categories as-is (paste merges into existing)
      const getSourceCleared = (categories) => {
        if (annualPasteClearFirst) return [];
        if (annualPasteClearTtmOnly) return categories.map(cat => ({
          ...cat,
          [basis]: { ...(cat[basis] || { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }), year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }
        }));
        return categories;
      };
      
      // Apply to each section
      // When clearing: sections with 0 parsed rows get emptied too (removes stale data)
      if (annualPasteClearFirst || annualPasteClearTtmOnly || parsed.revenue.length > 0) updateCategory(getSourceCleared(revenueCategories), parsed.revenue, setRevenueCategories, revenueCategories);
      if (annualPasteClearFirst || annualPasteClearTtmOnly || parsed.cogs.length > 0) updateCategory(getSourceCleared(cogsCategories), parsed.cogs, setCogsCategories, cogsCategories);
      if (annualPasteClearFirst || annualPasteClearTtmOnly || parsed.opex.length > 0) updateCategory(getSourceCleared(opexCategories), parsed.opex, setOpexCategories, opexCategories);
      if (annualPasteClearFirst || annualPasteClearTtmOnly || parsed.otherIncome.length > 0) updateCategory(getSourceCleared(otherIncomeCategories), parsed.otherIncome, setOtherIncomeCategories, otherIncomeCategories);
      if (annualPasteClearFirst || annualPasteClearTtmOnly || parsed.otherExpense.length > 0) updateCategory(getSourceCleared(otherExpenseCategories), parsed.otherExpense, setOtherExpenseCategories, otherExpenseCategories);
      // Always prune zero-value orphan rows after paste
      if (annualPasteClearFirst) {
        setRevenueCategories(prev => pruneZeroRows(prev));
        setCogsCategories(prev => pruneZeroRows(prev));
        setOpexCategories(prev => pruneZeroRows(prev));
        setOtherIncomeCategories(prev => pruneZeroRows(prev));
        setOtherExpenseCategories(prev => pruneZeroRows(prev));
      }
      
      // When clearing, also clear monthly TTM data — category IDs change on clear,
      // so old monthly data becomes orphaned and shows stale values on analysis tab
      if (annualPasteClearFirst) {
        if (parsed.revenue.length > 0 || parsed.revenue.length === 0) setMonthlyTtmRevenue({});
        if (parsed.cogs.length === 0) setMonthlyTtmCogs({}); // Always clear COGS monthly if no COGS in new paste
        else setMonthlyTtmCogs({}); // IDs changed, old monthly data is orphaned
        setMonthlyTtmOpex({});
        setMonthlyTtmOtherIncome({});
        setMonthlyTtmOtherExpense({});
      }
      
      setShowFullPLPasteModal(false);
      setFullPLPasteData('');
      setFullPLPastePreview(null);
      setAnnualPasteClearFirst(false);
      setAnnualPasteClearTtmOnly(false);
      
    } catch (error) {
      console.error('Full P&L Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== FULL MONTHLY P&L PASTE (for TTM Monthly tab) ==========
  // Parses entire monthly P&L at once, auto-detecting months and sections
  const parseFullMonthlyPLPaste = () => {
    const lines = fullMonthlyPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Subtotal patterns to skip
    const subtotalPatterns = [
      /^total\s/i, /\stotal$/i, /^total$/i, /^gross\s*(profit|margin)\b/i, /^net\s*(income|profit|loss)\b/i, /^profit(\s*[\/&]\s*loss)?$/i,
      /^net\s+ordinary\s*(income|profit|loss)/i, /^net\s+other\s*(income|expense)/i,
      /^operating\s*(income|profit|loss)/i, /^net\s*operating/i, /^ebitda/i,
      /^income\s*\(\s*loss\s*\)/i, /^(net\s+)?(income|profit|earnings|loss)\b.*\bfrom\s+operations\s*$/i,   // Aeroform 10-06: result lines, not accounts (not "Net cash from operations")
      /^expenses?$/i,
      /^total\s*for\s/i, /^total\s*(income|expense|revenue|other|cogs|cost)/i
    ];
    // A row named exactly "Total" (no trailing label) is a section subtotal, not an
    // account — some P&Ls (e.g. PRI Global's) label the Income and COGS subtotals just
    // "Total". Without this they'd be imported as line items and double-count the section.
    const isSubtotal = (name) => subtotalPatterns.some(p => p.test(name.trim()));
    
    // Section header patterns - tightened to avoid false positives on account names
    const sectionPatterns = {
      revenue: [/^income$/i, /^revenue$/i, /^ordinary income/i, /^operating\s+income$/i],
      cogs: [/^cost\s*of\s*(goods|sales)/i, /^cogs$/i, /^direct\s*cost/i],
      opex: [/^expense/i, /^operating\s*expense/i, /^overhead/i, /^general\s*&?\s*admin/i, /\bexpenses?\s*$/i, /^administrative/i, /^payroll/i],
      otherIncome: [/^other\s+incomes?\s*$/i, /^other\s+incomes?\s*[\/(\-]/i, /^other\s+revenue\s*$/i, /^non[\s-]?operating\s*income/i, /^non[\s-]?operating\s+items?\s*$/i],
      otherExpense: [/^other\s+expenses?\s*$/i, /^other\s+expenses?\s*[\/(\-]/i, /^non[\s-]?operating\s*expenses?/i]
    };
    
    // Month detection patterns - use word boundary or start, not just ^
    const monthPatterns = [
      { pattern: /\bjan/i, index: 0 },
      { pattern: /\bfeb/i, index: 1 },
      { pattern: /\bmar/i, index: 2 },
      { pattern: /\bapr/i, index: 3 },
      { pattern: /\bmay/i, index: 4 },
      { pattern: /\bjun/i, index: 5 },
      { pattern: /\bjul/i, index: 6 },
      { pattern: /\baug/i, index: 7 },
      { pattern: /\bsep/i, index: 8 },
      { pattern: /\boct/i, index: 9 },
      { pattern: /\bnov/i, index: 10 },
      { pattern: /\bdec/i, index: 11 }
    ];
    
    // Try to detect month columns from the header row. QB "P&L by Month" exports put
    // company-name / title / date-range rows above the actual column header, so scan the
    // first several rows for the one with the most month-name cells rather than assuming
    // row 0 (the old behavior — it treated the report title as the header and detected
    // zero months, so nothing imported).
    let headerRowIdx = 0;
    let bestMonthCount = 0;
    for (let r = 0; r < Math.min(10, lines.length); r++) {
      const cells = lines[r].split('\t');
      let mc = 0;
      cells.forEach((cell, ci) => {
        if (ci === 0) return;
        const t = cell.trim();
        if (t && monthPatterns.some(mp => mp.pattern.test(t))) mc++;
      });
      if (mc > bestMonthCount) { bestMonthCount = mc; headerRowIdx = r; }
    }
    const firstRow = lines[headerRowIdx];
    const headerCells = firstRow.split('\t');
    let monthColumns = {}; // { colIdx: monthIndex (0-11) }
    let dataStartRow = 0;
    let detectedTtmEnd = null; // report's own TTM end (newest month) — used to sync the config

    // Check if the chosen row looks like a header
    const headerLower = firstRow.toLowerCase();
    const looksLikeHeader = bestMonthCount >= 3 || monthPatterns.some(m => m.pattern.test(headerLower)) ||
                           headerLower.includes('total') || headerLower.includes('account') || headerLower.includes('month');

    if (looksLikeHeader) {
      dataStartRow = headerRowIdx + 1;
      
      // First pass: collect all detected months with their column indices and year info
      const detectedCols = [];
      headerCells.forEach((cell, colIdx) => {
        if (colIdx === 0) return; // Skip name column
        const cellText = cell.trim();
        
        for (const mp of monthPatterns) {
          if (mp.pattern.test(cellText)) {
            // Try to extract year from header (e.g., "February 2025", "Feb 25", "Feb-25", "Feb '25")
            const yearMatch = cellText.match(/20(\d{2})|[''](\d{2})\b|[\s\-,.](\d{2})\s*$/);
            let year = monthlyTtmConfig.endYear; // Default to TTM end year
            if (yearMatch) {
              const digits = yearMatch[1] || yearMatch[2] || yearMatch[3];
              year = digits ? 2000 + parseInt(digits) : monthlyTtmConfig.endYear;
            }
            detectedCols.push({ colIdx, calMonth: mp.index, year });
            break;
          }
        }
      });
      
      // Sort detected columns by their column index (left-to-right order in spreadsheet)
      // This preserves the original order for year inference
      detectedCols.sort((a, b) => a.colIdx - b.colIdx);
      
      // Infer years when headers lack year info (e.g., bare "Mar", "Apr"... "Jan", "Feb")
      const allLackYear = detectedCols.length >= 6 && detectedCols.every(c => {
        const cellText = (headerCells[c.colIdx] || '').trim();
        return !cellText.match(/20\d{2}|['']\d{2}\b|[\s\-,.]\d{2}\s*$/);
      });
      
      if (allLackYear && detectedCols.length >= 10) {
        // No years in any header — assign years based on sequence
        // The columns are in chronological order left-to-right
        // Use TTM config: last column = endMonth/endYear, work backwards
        const endMonth = monthlyTtmConfig.endMonth; // 0-indexed (0=Jan, 1=Feb, etc.)
        const endYear = monthlyTtmConfig.endYear;
        
        // Last detected column should be the end month
        // Assign years working backwards from the last column
        for (let i = detectedCols.length - 1; i >= 0; i--) {
          const monthsBack = detectedCols.length - 1 - i;
          let assignMonth = endMonth - monthsBack;
          let assignYear = endYear;
          while (assignMonth < 0) { assignMonth += 12; assignYear--; }
          detectedCols[i].calMonth = assignMonth;
          detectedCols[i].year = assignYear;
        }
      } else {
        // Have year info in some headers — use chronological sort
        detectedCols.sort((a, b) => {
          if (a.year !== b.year) return a.year - b.year;
          return a.calMonth - b.calMonth;
        });
      }
      
      // Detect QBO 2-column format: headers at every-other column (e.g., col 6, 8, 10...)
      // In this format, the header is in the first column of a pair, but the value is in the second
      let dataColOffset = 0;
      if (detectedCols.length >= 3) {
        const gaps = [];
        for (let g = 1; g < detectedCols.length; g++) {
          gaps.push(detectedCols[g].colIdx - detectedCols[g-1].colIdx);
        }
        const avgGap = gaps.reduce((a, b) => a + b, 0) / gaps.length;
        
        if (avgGap >= 1.8 && avgGap <= 2.2) {
          // Likely 2-column format. Check first few data rows to see if values 
          // are at header column or header column + 1
          let valuesAtHeader = 0;
          let valuesAtOffset = 0;
          const sampleRows = Math.min(10, lines.length - dataStartRow);
          
          for (let r = dataStartRow; r < dataStartRow + sampleRows; r++) {
            const sampleCells = lines[r].split('\t');
            for (const col of detectedCols.slice(0, 4)) {
              const atHeader = (sampleCells[col.colIdx] || '').replace(/[$,\s]/g, '');
              const atNext = (sampleCells[col.colIdx + 1] || '').replace(/[$,\s]/g, '');
              const headerIsNum = !isNaN(parseFloat(atHeader)) && parseFloat(atHeader) !== 0;
              const nextIsNum = !isNaN(parseFloat(atNext)) && parseFloat(atNext) !== 0;
              if (headerIsNum) valuesAtHeader++;
              if (nextIsNum) valuesAtOffset++;
            }
          }
          
          // If significantly more values are at offset+1, shift all column mappings
          if (valuesAtOffset > valuesAtHeader * 2) {
            dataColOffset = 1;
          }
        }
      }
      
      // Anchor TTM positions to the REPORT'S OWN months, not monthlyTtmConfig. A pasted
      // "P&L by Month" defines its own trailing-12 period; if the tool's configured end
      // month doesn't match it, mapping through the config drops or misplaces every
      // column and nothing imports (that was the failure). Sort the detected months
      // chronologically: the most recent 12 fill TTM positions 0..11 (oldest→newest),
      // the 12 before fill archive 12..23 (oldest→newest). detectedTtmEnd is returned so
      // apply can sync the tool's TTM period (month labels) to the report.
      const chrono = [...detectedCols].sort((a, b) => (a.year !== b.year ? a.year - b.year : a.calMonth - b.calMonth));
      const nCols = chrono.length;
      const ttmPositionMap = {};
      chrono.forEach((col, i) => {
        const fromNewest = nCols - 1 - i; // 0 = newest month
        const key = `${col.year}-${col.calMonth}`;
        if (fromNewest < 12) ttmPositionMap[key] = 11 - fromNewest;
        else if (fromNewest < 24) ttmPositionMap[key] = 23 - (fromNewest - 12);
      });
      const newestCol = chrono[nCols - 1];
      if (newestCol) detectedTtmEnd = { endMonth: newestCol.calMonth, endYear: newestCol.year };

      detectedCols.forEach((col) => {
        const key = `${col.year}-${col.calMonth}`;
        const ttmPos = ttmPositionMap[key];
        if (ttmPos !== undefined) {
          monthColumns[col.colIdx + dataColOffset] = ttmPos;
        }
        // Columns outside TTM+archive range are silently skipped
      });
    }
    
    // If no months detected, assume columns 1-12 are months 0-11
    if (Object.keys(monthColumns).length === 0) {
      for (let i = 1; i <= 12 && i < headerCells.length; i++) {
        monthColumns[i] = i - 1;
      }
    }
    
    // Parse all lines, tracking current section
    let currentSection = 'revenue'; // Default
    let currentSectionIndent = -1; // Indent depth of the row that established currentSection (hierarchical QB exports)
    const incomeHeaderIndents = []; // open "Income" headers, for closesNestedIncome
    let opexEnteredViaBroadHeader = false;
    const parsed = {
      revenue: [],
      cogs: [],
      opex: [],
      otherIncome: [],
      otherExpense: []
    };
    const skipped = [];
    const detectedMonths = [...new Set(Object.values(monthColumns))].sort((a, b) => a - b);
    let plGroup = [], plGroupSection = null;
    let belowBottomLine = false;   // past the statement's Net Income (10-12)
    let plSectionLines = [];       // every line of the current section, blank rows don't reset it (10-12)
    let inCombinedOtherSection = false, combinedOtherTotal = null;   // lines since the last header — a row equal to their sum is a subtotal (10-06)
    let currentSubSection = ''; // Track QB sub-headers like "Payroll", "Payroll-Officers'"
    // A sub-section is SCOPED BY INDENT (Colleen 09-22, Mojo Back Office: a
    // value-less "New mojoTools Hosted Environment" row on a flat statement
    // became a sub-header and prefixed the 40 unrelated rows below it until a
    // subtotal reset it). A header at depth N only prefixes rows deeper than N
    // and ends at the next row at N or above. On a flat paste (every row at
    // depth 0) that means a value-less row never prefixes anything — it is an
    // account with no activity, not a parent.
    let currentSubSectionIndent = -1;
    const seenNamesPerSection = {}; // Track duplicate names within each section
    
    // Debug info
    const debugInfo = {
      totalLines: lines.length,
      linesWithNames: 0,
      linesWithValues: 0,
      sectionHeaders: 0,
      subtotals: 0,
      added: 0
    };
    
    // Find the first (leftmost) value column index - needed for hierarchical QB format
    const valueColIndices = Object.keys(monthColumns).map(k => parseInt(k));
    const firstValueCol = valueColIndices.length > 0 ? Math.min(...valueColIndices) : 1;
    
    // Helper to extract account name from hierarchical QB format
    // QB exports can have names spread across columns 0-N based on indent level
    const extractAccountInfo = (cells) => {
      // First try cells[0] (standard / flat format) — indent depth 0
      if ((cells[0] || '').trim()) {
        return { name: (cells[0] || '').trim(), indent: 0 };
      }
      // For hierarchical QB format, scan columns 0 to firstValueCol-1
      // Find the LAST non-empty cell (deepest indent level = actual account).
      // Its column index is the indent depth — used to tell a nested
      // sub-group header apart from a real section boundary.
      let name = '';
      let indent = 0;
      const scanLimit = Math.min(firstValueCol, cells.length);
      for (let c = 0; c < scanLimit; c++) {
        const cellVal = (cells[c] || '').trim();
        // Skip cells that look like numbers (values in wrong column)
        if (cellVal && !/^[\d,.$()-]+$/.test(cellVal)) {
          name = cellVal;
          indent = c;
        }
      }
      // Fallback: if no name found in expected columns, scan ALL columns before values
      if (!name && cells.length > firstValueCol) {
        for (let c = 0; c < Math.min(10, cells.length); c++) {
          const cellVal = (cells[c] || '').trim();
          if (cellVal && !/^[\d,.$()-]+$/.test(cellVal) && cellVal.length > 1) {
            name = cellVal;
            indent = c;
          }
        }
      }
      return { name, indent };
    };

    // True P&L section labels — names that genuinely denote a section, as
    // opposed to account-group names that merely match a broad section
    // keyword (e.g. "Payroll Taxes" matches /^payroll/ but is a sub-group
    // inside COGS, not the start of OpEx). Keeps real section headers from
    // ever being mistaken for nested sub-groups.
    const isTrueSectionLabel = (nm) => {
      const t = (nm || '').trim();
      return /^(revenues?|sales\s+revenue)\s*$/i.test(t) ||
             /^income\s*$/i.test(t) ||
             /^ordinary\s+income(\s*\/\s*expenses?)?\s*$/i.test(t) ||
             /^cost\s+of\s+(goods\s+)?(sold|sales)\s*$/i.test(t) ||
             /^cogs\s*$/i.test(t) ||
             /^direct\s+costs?\s*$/i.test(t) ||
             /^gross\s+(profit|margin)\s*$/i.test(t) ||
             /^(operating\s+)?expenses?\s*$/i.test(t) ||
             /^overhead\s*$/i.test(t) ||
             /^(general\s*&?\s*admin\w*|g\s*&\s*a|sg\s*&\s*a|administrative)(\s+expenses?)?\s*$/i.test(t) ||
             /^other\s+(income|revenue|expenses?)\s*$/i.test(t) ||
             /^other\s+income\s*\/\s*\(?\s*expenses?\)?\s*$/i.test(t) ||
             /^non[\s-]?operating\s+(income|expenses?|items?)(\s*\/\s*\(?\s*expenses?\)?)?\s*$/i.test(t);
    };
    
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      const { name, indent } = extractAccountInfo(cells);
      if (!name) continue;
      if (belowBottomLine) { skipped.push({ name, section: currentSection, reason: 'Below the bottom line (after Net Income)' }); continue; }
      debugInfo.linesWithNames++;
      
      // First, check if this row has any values
      let rowHasValue = false;
      // An EXPLICIT zero ("0", "-", "$-", "0.00") is an account row with no
      // activity, not a header (Konnie 09-22, Hawver: "Supplies", "Interest
      // Income" etc. were all-zero rows that became sub-headers and prefixed
      // every row below — "Supplies > Rent Expense"). Header rows are blank.
      let rowHasExplicitZero = false;
      Object.keys(monthColumns).forEach(colIdx => {
        const idx = parseInt(colIdx);
        if (idx < cells.length) {
          let val = cells[idx] || '';
          val = val.replace(/[$,]/g, '').trim();
          if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
          const numVal = parseFloat(val);
          if (!isNaN(numVal) && numVal !== 0) rowHasValue = true;
          else if (/^-?0*(\.0+)?$/.test(val) && val !== '' || val === '-') rowHasExplicitZero = true;
        }
      });
      
      if (rowHasValue) debugInfo.linesWithValues++;
      
      // Check if this looks like a section header
      let foundSection = null;
      for (const [section, patterns] of Object.entries(sectionPatterns)) {
        if (patterns.some(p => p.test(name))) {
          foundSection = section;
          break;
        }
      }
      // Enforce forward-only section transitions (P&L flows: revenue → cogs → opex → otherIncome → otherExpense)
      // Prevents QB sub-categories like "Other Revenue" (under Revenue) from triggering jump to otherIncome
      const sectionOrder = { revenue: 0, cogs: 1, opex: 2, otherIncome: 3, otherExpense: 4 };
      if (foundSection && sectionOrder[foundSection] > sectionOrder[currentSection] + 1) {
        foundSection = null; // Reject: would skip intermediate sections
      }
      if (foundSection && sectionOrder[foundSection] < sectionOrder[currentSection]) {
        foundSection = null;
        for (const [section, patterns] of Object.entries(sectionPatterns)) {
          if (sectionOrder[section] >= sectionOrder[currentSection] && patterns.some(p => p.test(name))) {
            foundSection = section;
            break;
          }
        }
      }
      // Indent-aware section-boundary detection (hierarchical QB exports).
      // A value-less row matching a section pattern is only a real section
      // boundary when it sits at/above the current section's indent depth.
      // Rows nested DEEPER are sub-groups within the section (e.g. "Payroll
      // Taxes" several levels inside COGS) — treating them as boundaries
      // drags every line below, including Depreciation, into the wrong
      // section. Rows matching the SAME section are a more-specific header
      // (QB nests "Income"/"Cost of Goods Sold"/"Expense" under "Ordinary
      // Income/Expense") and refine the tracked depth.
      if (foundSection && !rowHasValue) {
        const acctSub = name.match(/^\d{3,6}(?:\.\d+)?\s*[·•.:\-–—]\s*(.+)$/);
        if (acctSub && !isTrueSectionLabel(acctSub[1])) {
          // QB account-numbered group header ("5120 · Software Expense") =
          // a sub-group INSIDE the current section, never a boundary —
          // unless the post-code name is a true section label ("5000 ·
          // Cost of Goods Sold"). Colleen's Concise Computer catch 08-19:
          // on the FLAT template sheet (uniform indent) the first value-
          // less COGS parent ending in "Expense" flipped the parser to
          // OpEx and dragged the rest of COGS (~$350k/yr) with it — the
          // indent guard below can't help when every row has equal indent.
          foundSection = null;
        } else if (foundSection === currentSection && (isTrueSectionLabel(name) || currentSectionIndent < 0 || indent <= currentSectionIndent)) {   // a DEEPER keyword-named group ("Payroll-Officers'" inside Expense) falls through to the sub-group branch below (Fabkom 10-05)
          // Re-declared section header — only a genuine section label may
          // refine the tracked depth; a sub-group matching a broad keyword
          // (e.g. "Payroll- Admin & office") must not claim section depth.
          if (isTrueSectionLabel(name)) currentSectionIndent = indent;
        } else if (currentSectionIndent >= 0 && indent > currentSectionIndent && !isTrueSectionLabel(name)) {
          foundSection = null;
        } else {
          currentSectionIndent = indent;
        }
      }

      // Only change section on header rows (no values)
      if (foundSection && !rowHasValue) {
        debugInfo.sectionHeaders++;
        if (foundSection === 'revenue' && PL_INCOME_HEADER_RX.test(name)) incomeHeaderIndents.push(indent);
        if (foundSection === 'opex') {
          const isOperatingExpense = /^operating\s*expense/i.test(name.trim());
          if (!isOperatingExpense) {
            opexEnteredViaBroadHeader = true;
          }
        }
        if (foundSection === 'otherIncome' && /income\s*\/\s*\(\s*expense|income\s*\(\s*expense/i.test(name)) inCombinedOtherSection = true;
        else if (foundSection !== 'otherIncome' && foundSection !== 'otherExpense') inCombinedOtherSection = false;
        currentSection = foundSection;
        currentSubSection = '';
        plGroup = [];
        continue;
      }
      // If row has values AND matches COGS pattern, change section but keep data (QB compat)
      if (foundSection && rowHasValue && foundSection === 'cogs') {
        currentSection = foundSection;
      }
      
      // A ratio line ("Net Revenue (%)") is never an amount (Colleen 10-10, Aeroform).
      if (isPlPercentRow(name)) {
        skipped.push({ name, section: currentSection, reason: 'Percentage line (not an amount)' });
        continue;
      }

      // Check if this is a subtotal row
      if (isSubtotal(name)) {
        skipped.push({ name, section: currentSection, reason: 'Subtotal', values: (() => {
          const mv = Array(24).fill(0);
          Object.entries(monthColumns).forEach(([ci, mi]) => {
            let v = (cells[parseInt(ci)] || '').replace(/[$,]/g, '').trim();
            if (v.startsWith('(') && v.endsWith(')')) v = '-' + v.slice(1, -1);
            mv[mi] = parseFloat(v) || 0;
          });
          return mv;
        })() });
        if (PL_BOTTOM_LINE_RX.test(name.trim()) && ['opex', 'otherIncome', 'otherExpense'].includes(currentSection)) belowBottomLine = true;
        if (inCombinedOtherSection && /^(total|net)\s+other\s+income/i.test(name.trim())) {
          combinedOtherTotal = Array(24).fill(0);
          Object.entries(monthColumns).forEach(([colIdx, monthIdx]) => {
            let v = (cells[parseInt(colIdx)] || '').replace(/[$,]/g, '').trim();
            if (v.startsWith('(') && v.endsWith(')')) v = '-' + v.slice(1, -1);
            combinedOtherTotal[monthIdx] = parseFloat(v) || 0;
          });
          inCombinedOtherSection = false;
        }
        debugInfo.subtotals++;
        currentSubSection = ''; // Reset subsection after subtotal
        
        // SUBTOTAL-BASED SECTION TRANSITIONS
        // When section headers live in a column not included in the paste,
        // use subtotal rows as section boundary markers
        const nameLower = name.trim().toLowerCase();
        // Anchor these subtotal-based transitions to the GRAND total only (\s*$).
        // Without the end-anchor, a nested sub-group subtotal like "Total for
        // Income - Other" tripped the revenue→COGS flip 34 rows early, dumping
        // every income category below it (IT Services, Managed Services,
        // Security, VoIP — $823k for Canitan) into COGS (Konnie 09-15). The real
        // boundary is the bare "Total for Income" / "Total Income"; a qualified
        // "Total for Income - X" is a sub-total, not the section end.
        if (/^total\s*(for\s*)?(income|revenue|operating\s+income)\s*$/i.test(nameLower) || /^(income|revenue)\s*-?\s*total\s*$/i.test(nameLower)) {
          if (currentSection === 'revenue' && !closesNestedIncome(incomeHeaderIndents, indent)) currentSection = 'cogs';
        } else if (/^gross\s*(profit|margin)/i.test(nameLower) || /^total\s*(cost\s*of\s*(goods|sales)(\s*sold)?|cogs)\s*$/i.test(nameLower)) {
          if (currentSection === 'cogs' || currentSection === 'revenue') currentSection = 'opex';
        } else if (/^total\s*(for\s*)?operating\s*expense/i.test(nameLower) || /^operating\s*(income|profit|loss)/i.test(nameLower) || /^(net\s+)?(income|profit|earnings|loss)\b.*\bfrom\s+operations\s*$/i.test(nameLower)) {
          if (currentSection === 'opex') {
            if (/^operating\s*(income|profit|loss)/i.test(nameLower) || /^(net\s+)?(income|profit|earnings|loss)\b.*\bfrom\s+operations\s*$/i.test(nameLower)) {
              currentSection = 'otherIncome';
            } else if (!opexEnteredViaBroadHeader) {
              currentSection = 'otherIncome';
            }
          }
        } else if (/^total\s*(for\s*)?expenses?\s*$/i.test(nameLower)) {
          if (currentSection === 'opex') currentSection = 'otherIncome';
        } else if (/^total\s*(for\s*)?(other\s+income|other\s+revenue|non[\s-]?operating\s*income)\s*$/i.test(nameLower)) {
          if (currentSection === 'otherIncome') currentSection = 'otherExpense';
        }
        
        continue;
      }
      
      // Parse month values (24-element array: 0-11 = TTM months, 12-23 = archive)
      const monthValues = Array(24).fill(0);
      Object.entries(monthColumns).forEach(([colIdx, monthIdx]) => {
        const idx = parseInt(colIdx);
        if (idx < cells.length) {
          let val = cells[idx] || '';
          val = val.replace(/[$,]/g, '').trim();
          if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
          monthValues[monthIdx] = parseFloat(val) || 0;
        }
      });
      
      // Only add if there's at least some non-zero value (skip parent category rows with no data)
      const hasValue = monthValues.some(v => v !== 0);
      if (hasValue && plGroupSection !== currentSection) { plGroup = []; plSectionLines = []; plGroupSection = currentSection; }
      if (hasValue && currentSection === 'revenue' && endsRevenueSection(name, monthValues, parsed.revenue, 'monthValues')) {
        skipped.push({ name, section: currentSection, reason: 'Subtotal (revenue total, costs follow)', values: monthValues.slice() });
        debugInfo.subtotals++;
        currentSection = 'cogs'; plGroup = [];
        continue;
      }
      if (hasValue && (equalsGroupSum(monthValues, plGroup) || (/^(net|total)\b/i.test(name) && equalsSectionTail(monthValues, plSectionLines)))) {
        skipped.push({ name, section: currentSection, reason: 'Subtotal (equals the lines above)', values: monthValues.slice() });
        debugInfo.subtotals++;
        continue;
      }
      if (hasValue) {
        plGroup.push(monthValues.slice());
        plSectionLines.push(monthValues.slice());
        // Prefix with subsection header for P&L context
        if (currentSubSection && indent <= currentSubSectionIndent) currentSubSection = '';   // back at the parent's depth — the group is over
        let finalName = name;
        if (currentSubSection && !name.toLowerCase().startsWith(currentSubSection.toLowerCase())) {
          finalName = `${currentSubSection} > ${name}`;
        }
        
        // Disambiguate duplicate names within same section
        if (!seenNamesPerSection[currentSection]) seenNamesPerSection[currentSection] = {};
        if (seenNamesPerSection[currentSection][finalName.toLowerCase()]) {
          const count = seenNamesPerSection[currentSection][finalName.toLowerCase()] + 1;
          finalName = `${finalName} (${count})`;
        }
        seenNamesPerSection[currentSection][finalName.toLowerCase()] = (seenNamesPerSection[currentSection][finalName.toLowerCase()] || 0) + 1;
        
        const _rt = otherSectionReroute(currentSection, finalName, monthValues);
        parsed[_rt.section].push({ name: finalName, monthValues: _rt.values, originalRow: lines[i], _fromCombinedSection: inCombinedOtherSection && (currentSection === 'otherIncome' || currentSection === 'otherExpense'),
          ...(_rt.section !== currentSection ? { _rerouteFrom: { section: currentSection, values: monthValues } } : {}) });
        debugInfo.added++;
      } else if (!foundSection && !rowHasExplicitZero) {
        // No values, not a section header, not a subtotal → likely a QB sub-section header (e.g., "Payroll", "Pension")
        // Only set as subsection if it's not a broad section label (REVENUES, COGS, etc.)
        const isSectionLabel = (
          /^(revenues?|income|ordinary\s+income|sales\s+revenue)\s*$/i.test(name) ||
          /^cost\s+of\s+(goods\s+)?sold\s*$/i.test(name) ||
          /^cogs\s*$/i.test(name) ||
          /^gross\s*(profit|margin)\s*$/i.test(name) ||
          /^operating\s+expenses?\s*$/i.test(name) ||
          /^(other\s+income|other\s+expense|other\s+revenue)\s*$/i.test(name) ||
          /^non[\s-]?operating\s+(items?|income|expenses?)\s*$/i.test(name) ||
          /^(expenses?|income|revenue)\s*$/i.test(name) ||
          /^(total|subtotal)/i.test(name)
        );
        const isNumberedAccount = /^\d{3,}[\s\-]/.test(name);
        if (!isSectionLabel && !isNumberedAccount) {
          currentSubSection = name;
          plGroup = [];
          currentSubSectionIndent = indent;
        }
      }
    }
    
    if (combinedOtherTotal) resolveCombinedOtherSigns(parsed, combinedOtherTotal, 'monthValues');
    undoReroutesAgainstStatement(parsed, skipped, 'monthValues');
    // Build verification totals (sum of months 0-11 for each section)
    const verification = {};
    Object.entries(parsed).forEach(([section, rows]) => {
      const ttmTotal = rows.reduce((sum, r) => {
        const rowTtm = r.monthValues.slice(0, 12).reduce((s, v) => s + v, 0);
        return sum + rowTtm;
      }, 0);
      verification[section] = { count: rows.length, ttmTotal };
    });
    
    return {
      parsed,
      skipped,
      verification,
      detectedMonths,
      monthColumns,
      detectedTtmEnd,
      totalRows: Object.values(parsed).reduce((sum, arr) => sum + arr.length, 0),
      debugInfo
    };
  };
  
  // Apply Full Monthly P&L Paste
  const applyFullMonthlyPLPaste = () => {
    if (!fullMonthlyPastePreview) return;
    
    try {
      snapshotBeforePaste('monthly P&L paste');
      captureUndoState(`Paste Full Monthly P&L (${selectedValuationBasis})${monthlyPasteClearFirst ? ' - Clear & Replace' : ''}`);
      const basis = selectedValuationBasis; // cash or accrual
      const { parsed } = fullMonthlyPastePreview;
      recordSourceTotals('pl', basis, { TTM: stmtPick(fullMonthlyPastePreview.skipped, PL_STMT_KEYS, v => (Array.isArray(v) ? v.slice(0, 12).reduce((a, x) => a + (Number(x) || 0), 0) : 0)) }, false);

      // Sync the tool's TTM period to the pasted report's own end month, so the monthly
      // column LABELS line up with the data (which is now positioned by the report's own
      // months, not the config). Only when the report defined a clear end month.
      const _ttmEnd = fullMonthlyPastePreview.detectedTtmEnd;
      if (_ttmEnd && Number.isInteger(_ttmEnd.endMonth) && Number.isInteger(_ttmEnd.endYear)) {
        setMonthlyTtmConfig(prev => ({ ...prev, endMonth: _ttmEnd.endMonth, endYear: _ttmEnd.endYear }));
      }
      
      // Build the starting monthly data objects — either cleared or current state
      // IMPORTANT: Do NOT call setMonthly* here for the clear step, because React state
      // updates are asynchronous. updateMonthlySection reads the state variables directly,
      // so calling set* before it runs has no effect — the closure still sees old values.
      // Instead, build the cleared objects locally and pass them directly.
      let startingRevenue = monthlyTtmRevenue;
      let startingCogs = monthlyTtmCogs;
      let startingOpex = monthlyTtmOpex;
      let startingOtherIncome = monthlyTtmOtherIncome;
      let startingOtherExpense = monthlyTtmOtherExpense;
      
      if (monthlyPasteClearFirst) {
        // Build zeroed copies locally — these will be passed into updateMonthlySection
        // so old values don't bleed through for accounts not in the new paste.
        // Only zero the basis being pasted; the OTHER basis must be preserved (basis bleed prevention).
        // Without this guard, pasting cash with Clear & Replace would wipe accrual data and vice versa.
        const clearBasis = (existingMap) => Object.fromEntries(
          Object.keys(existingMap).map(id => {
            const existing = existingMap[id] || {};
            return [id, {
              cash: basis === 'cash' ? Array(24).fill(0) : (Array.isArray(existing.cash) ? existing.cash : Array(24).fill(0)),
              accrual: basis === 'accrual' ? Array(24).fill(0) : (Array.isArray(existing.accrual) ? existing.accrual : Array(24).fill(0))
            }];
          })
        );
        startingRevenue = clearBasis(monthlyTtmRevenue);
        startingCogs = clearBasis(monthlyTtmCogs);
        startingOpex = clearBasis(monthlyTtmOpex);
        startingOtherIncome = clearBasis(monthlyTtmOtherIncome);
        startingOtherExpense = clearBasis(monthlyTtmOtherExpense);
      }
      
      // Helper to normalize names for matching
      const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      
      // Helper to update monthly data for a section
      const updateMonthlySection = (existingCategories, newRows, monthlyData, setMonthlyData, setCategories) => {
        // Paste order (Colleen 10-05, Blue Spruce): the P&L follows the pasted report's order, so a heading's
        // lines stay together ("Sensilla > …" next to "Sensilla-Licenses"). Each paste row records the
        // category id it landed on; afterwards those categories are laid back into their own slots in paste order.
        const pasteOrderIds = [];
        const updatedMonthly = { ...monthlyData };
        const updatedCategories = [...existingCategories];

        // Use a counter to ensure unique IDs even when processing many rows in same millisecond
        let idCounter = 0;
        const baseTimestamp = Date.now();

        // Track which existing categories have been claimed by this paste so two paste rows can't both
        // match the same existing category. Without this, an Excel with duplicate names in different
        // sub-sections (e.g. "Meals > General" and "Travel > General") would have both rows collapse
        // onto a single existing "General" category via cross-format matching — second overwrites first,
        // first row's monthly data is silently lost. This is the same pattern annual P&L paste uses.
        const claimedExistingIds = new Set();
        const stripAcct3 = (s) => s.replace(/^\d[\d-]*\s*-?\s+/, '').trim();

        // Pre-compute child-name occurrences within this paste batch. Cross-format matching
        // ("Parent > Child" → existing "Child") is unsafe when multiple paste rows share the same child,
        // because they'd all collapse onto one existing row. Only allow cross-format match if the child
        // name appears once in the batch.
        const childOccurrences = {};
        newRows.forEach(r => {
          if (!r.name.includes(' > ')) return;
          const child = r.name.split(' > ').pop().trim();
          const normChild = normalizeForMatch(child);
          const normChildStripped = normalizeForMatch(stripAcct3(child));
          childOccurrences[normChild] = (childOccurrences[normChild] || 0) + 1;
          if (normChildStripped !== normChild) {
            childOccurrences[normChildStripped] = (childOccurrences[normChildStripped] || 0) + 1;
          }
        });

        const dupPre = preassignDuplicateChildren(newRows, existingCategories, normalizeForMatch);
        newRows.forEach((row, ri) => {
          const normalizedNew = normalizeForMatch(row.name);

          // Pass 1: exact name match (skip already-claimed)
          let matchedCat = existingCategories.find(cat => !claimedExistingIds.has(cat.id) && cat.name === row.name);

          // Pass 2: normalized match
          if (!matchedCat) {
            matchedCat = existingCategories.find(cat => !claimedExistingIds.has(cat.id) && normalizeForMatch(cat.name || '') === normalizedNew);
          }

          // Pass 2b: duplicate child names resolved by heading (Fabkom) — the pasted name wins.
          if (!matchedCat && dupPre.has(ri)) {
            const ec = existingCategories[dupPre.get(ri)];
            if (ec && !claimedExistingIds.has(ec.id)) {
              const at = updatedCategories.indexOf(ec);
              matchedCat = at !== -1 ? (updatedCategories[at] = { ...ec, name: row.name }) : ec;
            }
          }

          // Pass 3: account-code-stripped match for flat names
          if (!matchedCat && !row.name.includes(' > ')) {
            matchedCat = existingCategories.find(cat => {
              if (claimedExistingIds.has(cat.id) || !cat.name || cat.name.includes(' > ')) return false;
              return normalizeForMatch(stripAcct3(cat.name)) === normalizedNew;
            });
          }

          // Pass 4: cross-format Parent > Child matching — only when child name is unique in this batch
          if (!matchedCat) {
            if (row.name.includes(' > ')) {
              const childPart = row.name.split(' > ').pop().trim();
              const normalizedChild3 = normalizeForMatch(childPart);
              const normalizedChildStripped3 = normalizeForMatch(stripAcct3(childPart));
              const childIsUnique = (childOccurrences[normalizedChild3] || 0) <= 1 && (childOccurrences[normalizedChildStripped3] || 0) <= 1;
              if (childIsUnique) {
                matchedCat = existingCategories.find(cat =>
                  !claimedExistingIds.has(cat.id) && (
                    normalizeForMatch(cat.name || '') === normalizedChild3 ||
                    normalizeForMatch(cat.name || '') === normalizedChildStripped3
                  )
                );
                if (!matchedCat) {
                  matchedCat = updatedCategories.find(cat =>
                    !existingCategories.includes(cat) && (
                      normalizeForMatch(cat.name || '') === normalizedChild3 ||
                      normalizeForMatch(cat.name || '') === normalizedChildStripped3
                    )
                  );
                }
              }
            } else {
              // Plain name → look for existing prefixed match
              matchedCat = existingCategories.find(cat => {
                if (claimedExistingIds.has(cat.id) || !cat.name || !cat.name.includes(' > ')) return false;
                const existingChild3 = cat.name.split(' > ').pop().trim();
                return normalizeForMatch(existingChild3) === normalizedNew ||
                       normalizeForMatch(stripAcct3(existingChild3)) === normalizedNew;
              });
            }
            // The PASTE's name wins on a cross-format match (Colleen 10-05, Blue Spruce): "Sensilla > Payroll"
            // matched a stored plain "Payroll" and the old rule kept "Payroll", so the heading was lost on every
            // re-paste (and Clear & Replace strips prefixes before matching, which re-created the plain name).
            if (matchedCat && row.name.includes(' > ') && matchedCat.name !== row.name) {
              const at = updatedCategories.indexOf(matchedCat);
              if (at !== -1) { matchedCat = { ...matchedCat, name: row.name }; updatedCategories[at] = matchedCat; }
            }
          }

          // Also check updatedCategories for rows we just added (avoid duplicate within same paste)
          if (!matchedCat) {
            matchedCat = updatedCategories.find(cat => cat.name === row.name && !existingCategories.includes(cat));
          }

          if (matchedCat) {
            // Mark existing-cat matches as claimed (newly-added cats are already protected by !existingCategories.includes)
            if (existingCategories.includes(matchedCat)) {
              claimedExistingIds.add(matchedCat.id);
            }
            pasteOrderIds.push(matchedCat.id);
            const existingMonthly = updatedMonthly[matchedCat.id] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
            updatedMonthly[matchedCat.id] = {
              ...existingMonthly,
              [basis]: [...row.monthValues]
            };
          } else {
            // Create new category — keep the full row.name (with prefix) so duplicates remain distinct
            const newId = baseTimestamp + (++idCounter) + Math.random();
            const newCat = {
              id: newId,
              name: row.name,
              cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
              accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
              tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }
            };
            updatedCategories.push(newCat);
            pasteOrderIds.push(newId);
            updatedMonthly[newId] = {
              cash: basis === 'cash' ? [...row.monthValues] : Array(24).fill(0),
              accrual: basis === 'accrual' ? [...row.monthValues] : Array(24).fill(0)
            };
          }
        });

        setMonthlyData(updatedMonthly);
        // Lay the pasted lines into their own slots in paste order (untouched lines don't move).
        let orderChanged = false;
        {
          const seen = new Set(); const ids = pasteOrderIds.filter(id => !seen.has(id) && seen.add(id));
          const slots = ids.map(id => updatedCategories.findIndex(c => c.id === id)).filter(i => i !== -1).sort((a, b) => a - b);
          const inOrder = ids.map(id => updatedCategories.find(c => c.id === id)).filter(Boolean);
          if (slots.length === inOrder.length) {
            slots.forEach((slot, k) => { if (updatedCategories[slot] !== inOrder[k]) { orderChanged = true; updatedCategories[slot] = inOrder[k]; } });
          }
        }
        // Persist if new categories were added OR if any existing category name was upgraded OR the order changed
        const anyNameChanged = updatedCategories.some((cat) => {
          const orig = existingCategories.find(c => c.id === cat.id);
          return orig && orig.name !== cat.name;
        });
        if (updatedCategories.length > existingCategories.length || anyNameChanged || orderChanged) {
          setCategories(updatedCategories);
        }
      };
      
      // On Clear & Replace: fix any bad prefixed names in existing categories first.
      // A category named 'Parent > Child' gets renamed to just 'Child' so that
      // the paste matcher finds and updates it correctly with the clean name.
      if (monthlyPasteClearFirst) {
        const fixPrefixedNames = (cats, setter) => {
          const fixed = cats.map(cat => {
            if (cat.name && cat.name.includes(' > ')) {
              return { ...cat, name: cat.name.split(' > ').pop().trim() };
            }
            return cat;
          });
          const anyChanged = fixed.some((cat, i) => cat.name !== cats[i].name);
          if (anyChanged) setter(fixed);
          return fixed;
        };
        // Fix names in-place before running updateMonthlySection
        const fixedRevenue = fixPrefixedNames(revenueCategories, setRevenueCategories);
        const fixedCogs = fixPrefixedNames(cogsCategories, setCogsCategories);
        const fixedOpex = fixPrefixedNames(opexCategories, setOpexCategories);
        const fixedOtherIncome = fixPrefixedNames(otherIncomeCategories, setOtherIncomeCategories);
        const fixedOtherExpense = fixPrefixedNames(otherExpenseCategories, setOtherExpenseCategories);
        if (parsed.revenue.length > 0) updateMonthlySection(fixedRevenue, parsed.revenue, startingRevenue, setMonthlyTtmRevenue, setRevenueCategories);
        else setMonthlyTtmRevenue({});
        if (parsed.cogs.length > 0) updateMonthlySection(fixedCogs, parsed.cogs, startingCogs, setMonthlyTtmCogs, setCogsCategories);
        else setMonthlyTtmCogs({});
        if (parsed.opex.length > 0) updateMonthlySection(fixedOpex, parsed.opex, startingOpex, setMonthlyTtmOpex, setOpexCategories);
        else setMonthlyTtmOpex({});
        if (parsed.otherIncome.length > 0) updateMonthlySection(fixedOtherIncome, parsed.otherIncome, startingOtherIncome, setMonthlyTtmOtherIncome, setOtherIncomeCategories);
        else setMonthlyTtmOtherIncome({});
        if (parsed.otherExpense.length > 0) updateMonthlySection(fixedOtherExpense, parsed.otherExpense, startingOtherExpense, setMonthlyTtmOtherExpense, setOtherExpenseCategories);
        else setMonthlyTtmOtherExpense({});
      } else {
        // Merge mode: update monthly data for existing accounts, add new ones
        if (parsed.revenue.length > 0) updateMonthlySection(revenueCategories, parsed.revenue, startingRevenue, setMonthlyTtmRevenue, setRevenueCategories);
        if (parsed.cogs.length > 0) updateMonthlySection(cogsCategories, parsed.cogs, startingCogs, setMonthlyTtmCogs, setCogsCategories);
        if (parsed.opex.length > 0) updateMonthlySection(opexCategories, parsed.opex, startingOpex, setMonthlyTtmOpex, setOpexCategories);
        if (parsed.otherIncome.length > 0) updateMonthlySection(otherIncomeCategories, parsed.otherIncome, startingOtherIncome, setMonthlyTtmOtherIncome, setOtherIncomeCategories);
        if (parsed.otherExpense.length > 0) updateMonthlySection(otherExpenseCategories, parsed.otherExpense, startingOtherExpense, setMonthlyTtmOtherExpense, setOtherExpenseCategories);
      }
      
      // Clear & Replace: handled above in buildFreshSection block
      
      // Close modal and reset state
      setShowFullMonthlyPasteModal(false);
      setFullMonthlyPasteData('');
      setFullMonthlyPastePreview(null);
      setMonthlyPasteClearFirst(false); // Reset for next use
      
    } catch (error) {
      console.error('Full Monthly P&L Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== FULL BALANCE SHEET PASTE (for Balance Sheet tab) ==========
  // Parses entire annual balance sheet at once
  const parseFullBSPaste = () => {
    const lines = fullBSPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Check if this looks like monthly data (should use TTM Monthly BS paste instead)
    const firstRowLower = lines[0].toLowerCase();
    const monthPatterns = [/\bjan/i, /\bfeb/i, /\bmar/i, /\bapr/i, /\bmay/i, /\bjun/i, /\bjul/i, /\baug/i, /\bsep/i, /\boct/i, /\bnov/i, /\bdec/i];
    const monthsFound = monthPatterns.filter(p => p.test(firstRowLower)).length;
    const looksLikeMonthlyData = monthsFound >= 3;
    
    // Subtotal patterns to skip
    const subtotalPatterns = [
      /^total\s/i, /\stotal$/i, /^total\s*(assets|liabilities|equity)/i,
      /^total\s*(current|fixed|other)\s*(assets|liabilities)/i,
      /^total\s*long[- ]?term/i, /^net\s*(assets|worth)/i
    ];
    const isSubtotal = (name) => subtotalPatterns.some(p => p.test(name.trim()));
    
    // Section header patterns for balance sheet
    // These should be STRICT patterns for section headers, not account names
    // NOTE: "Other Current Assets" is a QB sub-header under Current Assets, NOT the BS "Other Assets" section
    const sectionPatterns = {
      currentAssets: [/^current\s*assets$/i, /^assets$/i],
      fixedAssets: [/^fixed\s*assets$/i, /^property.*equipment$/i, /^property,?\s*plant.*equipment$/i, /^pp&e$/i, /^long[- ]?term\s*assets$/i, /^other\s*long[- ]?term\s*assets$/i],
      otherAssets: [/^other\s*assets$/i, /^intangible\s*assets$/i],
      currentLiabilities: [/^current\s*liabilities$/i, /^liabilities$/i, /^liabilities\s*(and|&)\s*(stockholder|shareholder|owner)/i],
      longTermLiabilities: [/^long[- ]?term\s*liabilities$/i, /^long[- ]?term\s*debt$/i, /^non[- ]?current\s*liabilities$/i],
      equity: [/^equity$/i, /^stockholder'?s?\s*equity$/i, /^shareholder'?s?\s*equity$/i, /^owner'?s?\s*equity$/i, /^members?\s*equity$/i, /^net\s*assets$/i]
    };
    
    // QB sub-section headers to skip (no section switch, just skip the row)
    // These are intermediate grouping headers within a section that don't map to our BS sections
    const qbSubSectionHeaders = [
      /^other\s*current\s*assets$/i,        // Sub-header under Current Assets (NOT "Other Assets")
      /^checking\s*\/?\s*savings$/i,         // Sub-header under Current Assets
      /^credit\s*cards?$/i,                  // Sub-header under Current Liabilities
      /^other\s*current\s*liabilities$/i,    // Sub-header under Current Liabilities
      /^banks?$/i,                           // Sub-header under Checking/Savings
      /^vehicle\s*loans?$/i,                 // Sub-header under Long Term Liabilities
    ];
    
    // Account name patterns that indicate we should switch sections
    // These are for accounts that strongly indicate a section, even with values
    // Use carefully - only for unambiguous indicators
    const accountSectionIndicators = {
      fixedAssets: [/^accumulated\s*depreciation/i, /^depreciation/i, /^buildings?$/i, /^land$/i, /^leasehold\s*improvements?/i, /^furniture.*fixtures?/i, /^equipment$/i, /^vehicles?$/i, /^machinery/i],
      currentLiabilities: [/^accounts\s*payable/i, /^accrued\s*(expenses?|liabilities)/i, /^payroll\s*(liabilities|payable)/i, /^sales\s*tax\s*payable/i, /^credit\s*cards?\s*payable/i, /^current\s*portion.*long[- ]?term/i, /^deferred\s*revenue/i, /^unearned\s*revenue/i],
      longTermLiabilities: [/^long[- ]?term\s*(debt|notes?|loan)/i, /^notes?\s*payable\s*-?\s*long/i, /^mortgage/i, /^bonds?\s*payable/i],
      equity: [/^common\s*stock/i, /^preferred\s*stock/i, /^retained\s*earnings/i, /^additional\s*paid[- ]?in\s*capital/i, /^owner'?s?\s*(draws?|distributions?|capital|equity)/i, /^member'?s?\s*(draws?|distributions?|capital)/i, /^treasury\s*stock/i, /^accumulated\s*other\s*comprehensive/i, /^opening\s*balance\s*equity/i, /^partner.*capital/i]
    };
    
    // If it looks like monthly data, return early with a warning
    if (looksLikeMonthlyData) {
      return {
        parsed: { currentAssets: [], fixedAssets: [], otherAssets: [], currentLiabilities: [], longTermLiabilities: [], equity: [] },
        skipped: [],
        verification: {},
        detectedYears: [],
        yearColumns: {},
        yearMatchInfo: [],
        bsYearLabels: { ...bsYearLabels },
        totalRows: 0,
        monthlyDataWarning: true,
        monthsDetected: monthsFound
      };
    }
    
    // Try to detect year columns from header row
    const firstRow = lines[0];
    const headerCells = firstRow.split('\t');
    let yearColumns = {}; // { colIdx: yearKey }
    let yearMatchInfo = []; // Track year matching for preview warnings
    let dataStartRow = 0;
    
    // Check if first row looks like a header - also handle date formats like "Dec 31, 25"
    const headerLower = firstRow.toLowerCase();
    const looksLikeHeader = /20\d{2}|year|total|interim|account/i.test(headerLower) ||
                           /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(headerLower);
    
    if (looksLikeHeader) {
      dataStartRow = 1;
      
      // Check if the "header" is actually just a title row (company name / report title)
      // with no year/month values in columns 1+. This happens when QB exports have
      // a title row (e.g. "MTC INC — Balance Sheet | Feb 2025 – Jan 2026") on lines[0]
      // and the actual column headers (Feb 2025, Mar 2025...) are on lines[1].
      const headerHasYearCols = headerCells.slice(1).some(c => {
        const t = (c || '').trim();
        return /20\d{2}/.test(t) || /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(t) ||
               /interim|current|latest/i.test(t);
      });
      if (!headerHasYearCols && lines.length > 1) {
        const nextCells = lines[1].split('\t');
        const nextLower = lines[1].toLowerCase();
        const nextHasYears = /20\d{2}/.test(nextLower) || /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(nextLower);
        if (nextHasYears) {
          headerCells.splice(0, headerCells.length, ...nextCells);
          dataStartRow = 2;
        }
      }
      
      // Extract years and map to year1, year2, year3, interim
      const foundYears = [];
      headerCells.forEach((cell, colIdx) => {
        if (colIdx === 0) return;
        const cellText = cell.trim();
        
        // Try full 4-digit year first
        let yearMatch = cellText.match(/20\d{2}/);
        if (yearMatch) {
          foundYears.push({ idx: colIdx, year: parseInt(yearMatch[0]), cell: cellText });
        } else {
          // Try abbreviated year formats: "Dec 31, 25", "'25", "12/31/25", etc.
          // Look for 2-digit year at the END of the string or after a comma/slash
          // Be careful not to match day of month (01-31)
          let shortYear = null;
          
          // Pattern 1: Year at end after comma or space: "Dec 31, 25" -> "25"
          const endMatch = cellText.match(/[,\s](\d{2})\s*$/);
          if (endMatch) {
            shortYear = parseInt(endMatch[1]);
          }
          // Pattern 2: Year after slash at end: "12/31/25" -> "25"
          else {
            const slashMatch = cellText.match(/\/(\d{2})\s*$/);
            if (slashMatch) {
              shortYear = parseInt(slashMatch[1]);
            }
          }
          // Pattern 3: Standalone '25 format
          if (shortYear === null) {
            const quoteMatch = cellText.match(/'(\d{2})\b/);
            if (quoteMatch) {
              shortYear = parseInt(quoteMatch[1]);
            }
          }
          
          if (shortYear !== null) {
            // Convert 2-digit to 4-digit: 00-50 -> 2000-2050, 51-99 -> 1951-1999
            const fullYear = shortYear <= 50 ? 2000 + shortYear : 1900 + shortYear;
            foundYears.push({ idx: colIdx, year: fullYear, cell: cellText });
          } else if (/interim|current|latest/i.test(cellText)) {
            foundYears.push({ idx: colIdx, year: 'interim', cell: cellText });
          }
        }
      });
      
      // Sort and map years - SMART YEAR MATCHING first
      // MONTHLY BALANCE SHEET SERIES DETECTION: if 8+ columns all within 2 consecutive years,
      // this is a monthly snapshot series — only use the last (most recent) column as interim
      let numericYears = foundYears.filter(y => typeof y.year === 'number').sort((a, b) => {
        if (a.year !== b.year) return a.year - b.year;
        return a.idx - b.idx;
      });
      const interimCol = foundYears.find(y => y.year === 'interim');
      const _uniqueBSYears = [...new Set(numericYears.map(y => y.year))].sort();
      const _isMonthlySeriesBS = numericYears.length >= 8 && _uniqueBSYears.length <= 2 &&
        (_uniqueBSYears.length === 1 || (_uniqueBSYears.length === 2 && _uniqueBSYears[1] - _uniqueBSYears[0] <= 1));
      if (_isMonthlySeriesBS) {
        // Use only the last column as interim — most recent month-end snapshot
        const _lastBSCol = numericYears[numericYears.length - 1];
        yearColumns[_lastBSCol.idx] = 'interim';
        yearMatchInfo.push({
          detected: _lastBSCol.cell,
          mappedTo: 'interim',
          label: 'Interim',
          matchType: 'monthly_series',
          isNew: false,
          warning: `Monthly balance sheet series detected (${numericYears.length} months). Using most recent month (${_lastBSCol.cell}) as the Interim balance sheet. Other months are ignored.`
        });
        numericYears = []; // Clear so the normal year-matching block below skips
      }
      
      // Build existing year map from bsYearLabels
      const existingYearMap = {
        [bsYearLabels.year1]: 'year1',
        [bsYearLabels.year2]: 'year2',
        [bsYearLabels.year3]: 'year3'
      };

      // NOTE: no local yearMatchInfo here — a `const` redeclaration shadowed the
      // outer `let`, discarding every year-mapping warning pushed below AND putting
      // the monthly-series push above into its temporal dead zone (ReferenceError =
      // parse crash on 8+-month BS pastes). Found tracing Little Bird 08-24.
      let hasExactMatches = false;
      
      if (numericYears.length > 0) {
        // First pass: try exact matching to existing year labels
        numericYears.forEach(y => {
          const yearStr = String(y.year);
          if (existingYearMap[yearStr]) {
            yearColumns[y.idx] = existingYearMap[yearStr];
            yearMatchInfo.push({
              detected: yearStr,
              mappedTo: existingYearMap[yearStr],
              label: yearStr,
              matchType: 'exact',
              isNew: false
            });
            hasExactMatches = true;
          }
        });
        
        // If we found exact matches, use them; otherwise use SMART slot assignment
        if (!hasExactMatches) {
          // SMART YEAR SLOT ASSIGNMENT (v61 fix)
          // Instead of blindly using position-based mapping, find the right slot
          // considering existing data in other year columns
          
          const existingSlots = {
            year1: bsYearLabels.year1,
            year2: bsYearLabels.year2,
            year3: bsYearLabels.year3
          };
          
          // Check which slots have actual year data (not empty/default)
          const isSlotEmpty = (label) => !label || !/^\d{4}$/.test(label);
          const emptySlots = ['year1', 'year2', 'year3'].filter(s => isSlotEmpty(existingSlots[s]));
          const occupiedSlots = ['year1', 'year2', 'year3'].filter(s => !isSlotEmpty(existingSlots[s]));
          
          if (numericYears.length >= 3) {
            // 3+ years in file — use position-based (these files have all years)
            yearColumns[numericYears[numericYears.length - 3].idx] = 'year1';
            yearColumns[numericYears[numericYears.length - 2].idx] = 'year2';
            yearColumns[numericYears[numericYears.length - 1].idx] = 'year3';
            yearMatchInfo.push(
              { detected: String(numericYears[numericYears.length - 3].year), mappedTo: 'year1', label: bsYearLabels.year1, matchType: 'position', willOverwrite: bsYearLabels.year1 !== String(numericYears[numericYears.length - 3].year) },
              { detected: String(numericYears[numericYears.length - 2].year), mappedTo: 'year2', label: bsYearLabels.year2, matchType: 'position', willOverwrite: bsYearLabels.year2 !== String(numericYears[numericYears.length - 2].year) },
              { detected: String(numericYears[numericYears.length - 1].year), mappedTo: 'year3', label: bsYearLabels.year3, matchType: 'position', willOverwrite: bsYearLabels.year3 !== String(numericYears[numericYears.length - 1].year) }
            );
          } else {
            // 1-2 years in file — smart placement
            numericYears.forEach(y => {
              const yearStr = String(y.year);
              const yearNum = y.year;
              
              // Get all occupied year numbers for chronological sorting
              const occupiedYearNums = occupiedSlots.map(s => ({ slot: s, year: parseInt(existingSlots[s]) }));
              
              let targetSlot = null;
              
              // First: try to find an empty slot in the right chronological position
              if (emptySlots.length > 0) {
                // Build a picture of all years (existing + new) to determine correct order
                const allYearEntries = [...occupiedYearNums, { slot: null, year: yearNum }]
                  .sort((a, b) => a.year - b.year);
                
                // Find where the new year falls in order
                const newYearPosition = allYearEntries.findIndex(e => e.slot === null);
                
                // Map position to slot preference
                // With 3 slots (year1=oldest, year3=newest), position 0=year1, 1=year2, 2=year3
                const slotsByPosition = ['year1', 'year2', 'year3'];
                const preferredSlot = slotsByPosition[newYearPosition] || 'year3';
                
                if (emptySlots.includes(preferredSlot)) {
                  targetSlot = preferredSlot;
                } else {
                  // Preferred slot is occupied — use closest empty slot
                  const prefIdx = slotsByPosition.indexOf(preferredSlot);
                  const emptyByDistance = emptySlots.sort((a, b) => 
                    Math.abs(slotsByPosition.indexOf(a) - prefIdx) - Math.abs(slotsByPosition.indexOf(b) - prefIdx)
                  );
                  targetSlot = emptyByDistance[0];
                }
              } else {
                // No empty slots — find the best slot to overwrite
                // Overwrite the slot whose year is closest to the new year
                const slotsByDiff = occupiedSlots
                  .map(s => ({ slot: s, diff: Math.abs(parseInt(existingSlots[s]) - yearNum) }))
                  .sort((a, b) => a.diff - b.diff);
                targetSlot = slotsByDiff[0]?.slot || 'year3';
              }
              
              // Remove the used slot from empty list so second year doesn't reuse it
              const emptyIdx = emptySlots.indexOf(targetSlot);
              if (emptyIdx > -1) emptySlots.splice(emptyIdx, 1);
              
              yearColumns[y.idx] = targetSlot;
              const willOverwrite = !isSlotEmpty(existingSlots[targetSlot]) && existingSlots[targetSlot] !== yearStr;
              yearMatchInfo.push({
                detected: yearStr,
                mappedTo: targetSlot,
                label: existingSlots[targetSlot] || '(empty)',
                matchType: willOverwrite ? 'position' : 'smart',
                isNew: isSlotEmpty(existingSlots[targetSlot]),
                willOverwrite
              });
            });
          }
        } else {
          // Had exact matches - check for unmatched years
          numericYears.forEach(y => {
            const yearStr = String(y.year);
            if (!existingYearMap[yearStr] && !yearColumns[y.idx]) {
              // This year doesn't exist - find appropriate slot using smart assignment
              const allYears = [
                { slot: 'year1', year: parseInt(bsYearLabels.year1) || 0 },
                { slot: 'year2', year: parseInt(bsYearLabels.year2) || 0 },
                { slot: 'year3', year: parseInt(bsYearLabels.year3) || 0 }
              ];
              
              // Check which slots are already claimed by yearColumns
              const claimedSlots = new Set(Object.values(yearColumns));
              const availableSlots = allYears.filter(s => !claimedSlots.has(s.slot));
              
              // Find empty slots (no year label)
              const emptyAvailable = availableSlots.filter(s => s.year === 0);
              
              let targetSlot;
              if (emptyAvailable.length > 0) {
                // Place in the correct chronological position among empty slots
                const occupiedYears = allYears.filter(s => s.year > 0 && !claimedSlots.has(s.slot)).map(s => s.year);
                const allSorted = [...occupiedYears, y.year].sort((a, b) => a - b);
                const pos = allSorted.indexOf(y.year);
                const slotOrder = ['year1', 'year2', 'year3'];
                const emptySlotNames = emptyAvailable.map(s => s.slot);
                targetSlot = emptySlotNames[Math.min(pos, emptySlotNames.length - 1)] || emptyAvailable[0].slot;
              } else {
                // No empty slots - overwrite the closest year
                const byDiff = availableSlots
                  .map(s => ({ slot: s.slot, diff: Math.abs(s.year - y.year) }))
                  .sort((a, b) => a.diff - b.diff);
                targetSlot = byDiff[0]?.slot || 'year3';
              }
              
              yearColumns[y.idx] = targetSlot;
              yearMatchInfo.push({
                detected: yearStr,
                mappedTo: targetSlot,
                label: bsYearLabels[targetSlot],
                matchType: 'new',
                isNew: true,
                willOverwrite: allYears.find(s => s.slot === targetSlot)?.year > 0,
                warning: allYears.find(s => s.slot === targetSlot)?.year > 0 
                  ? `Year ${yearStr} not found in grid (currently ${bsYearLabels[targetSlot]}) - will overwrite`
                  : `Year ${yearStr} placed in empty slot ${targetSlot}`
              });
            }
          });
        }
      }
      
      if (interimCol) {
        yearColumns[interimCol.idx] = 'interim';
        yearMatchInfo.push({
          detected: 'Interim',
          mappedTo: 'interim',
          label: bsYearLabels.interim || 'Interim',
          matchType: 'exact',
          isNew: false
        });
      }
    }
    
    // If no years detected, assume columns are year1, year2, year3, interim
    if (Object.keys(yearColumns).length === 0) {
      yearColumns = { 1: 'year1', 2: 'year2', 3: 'year3', 4: 'interim' };
      yearMatchInfo = [
        { detected: 'Column 1', mappedTo: 'year1', label: bsYearLabels.year1, matchType: 'assumed', warning: 'No years detected - using position-based mapping' },
        { detected: 'Column 2', mappedTo: 'year2', label: bsYearLabels.year2, matchType: 'assumed' },
        { detected: 'Column 3', mappedTo: 'year3', label: bsYearLabels.year3, matchType: 'assumed' },
        { detected: 'Column 4', mappedTo: 'interim', label: bsYearLabels.interim || 'Interim', matchType: 'assumed' }
      ];
    }
    
    // Parse all lines, tracking current section
    let currentSection = 'currentAssets';
    const parsed = {
      currentAssets: [],
      fixedAssets: [],
      otherAssets: [],
      currentLiabilities: [],
      longTermLiabilities: [],
      equity: []
    };
    const skipped = [];
    const detectedYears = [...new Set(Object.values(yearColumns))];
    
    // Find the first (leftmost) value column index - needed for hierarchical QB format
    const valueColIndices = Object.keys(yearColumns).map(k => parseInt(k));
    const firstValueCol = valueColIndices.length > 0 ? Math.min(...valueColIndices) : 1;
    
    // Helper to extract account name AND indent level from hierarchical QB format
    // QB exports can have names spread across columns 0-N based on indent level
    // The account name is the last non-empty text cell BEFORE the value columns
    const extractAccountInfo = (cells) => {
      // First try cells[0] (standard format)
      if ((cells[0] || '').trim()) {
        return { name: (cells[0] || '').trim(), indentLevel: 0 };
      }
      // For hierarchical QB format, scan columns 0 to firstValueCol-1
      // Find the LAST non-empty cell (deepest indent level = actual account)
      let name = '';
      let indentLevel = 0;
      const scanLimit = Math.min(firstValueCol, cells.length);
      for (let c = 0; c < scanLimit; c++) {
        const cellVal = (cells[c] || '').trim();
        // Skip cells that look like numbers (values in wrong column)
        if (cellVal && !/^[\d,.$()-]+$/.test(cellVal)) {
          name = cellVal;
          indentLevel = c;
        }
      }
      return { name, indentLevel };
    };
    
    // Track parent names at each indent level for deduplication
    const parentStack = {};
    // Open QB sub-group tracking (Konnie 08-24, Little Bird): between a QB
    // sub-group header ("Other Current Liabilities") and its "Total for" row,
    // every line is BY CONSTRUCTION an account of the current section — a
    // zero-balance account named like a section ("Owner's Equity" parked
    // under Other Current Liabilities) must not switch sections there. Any
    // Total row closes the group (QB always ends groups with one).
    let openQbSubGroup = null;

    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      const { name: rawName, indentLevel } = extractAccountInfo(cells);
      if (!rawName) continue;

      // Update parent stack - current name becomes the parent at this level
      parentStack[indentLevel] = rawName;
      // Clear deeper levels (they're no longer valid parents)
      for (let d = indentLevel + 1; d < 20; d++) delete parentStack[d];

      // Skip QB sub-section headers (intermediate grouping headers without values)
      const isQbSubHeader = qbSubSectionHeaders.some(p => p.test(rawName.trim()));
      
      // First, check if this row has any values (needed to determine if it's a real account or section header)
      let rowHasValue = false;
      const yearValues = { year1: 0, year2: 0, year3: 0, interim: 0 };
      Object.entries(yearColumns).forEach(([colIdx, yearKey]) => {
        let val = cells[parseInt(colIdx)] || '';
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
        const parsed = parseFloat(val) || 0;
        yearValues[yearKey] = parsed;
        if (parsed !== 0) rowHasValue = true;
      });
      
      // Skip QB sub-section headers that have no values
      if (isQbSubHeader && !rowHasValue) {
        openQbSubGroup = rawName.trim();
        continue;
      }

      // Check if this is a section header (strict patterns, typically NO values)
      let foundSectionHeader = null;
      for (const [section, patterns] of Object.entries(sectionPatterns)) {
        if (patterns.some(p => p.test(rawName))) {
          foundSectionHeader = section;
          break;
        }
      }

      // Inside an open QB sub-group, a section-named row is an ACCOUNT of the
      // current section, never a boundary (the Little Bird "Owner's Equity"
      // account under Other Current Liabilities).
      if (openQbSubGroup && foundSectionHeader && foundSectionHeader !== currentSection) {
        foundSectionHeader = null;
      }
      
      // "Intangible Assets" WITH values is an ACCOUNT row, not a section
      // boundary (Konnie 08-11, TechClarity: QB Desktop lists intangibles as
      // an account inside Fixed Assets — the boundary switch+skip below was
      // silently dropping the value). A bare no-value header still starts
      // the Other Assets section.
      if (foundSectionHeader === 'otherAssets' && rowHasValue && /^intangible/i.test(rawName)) {
        foundSectionHeader = null;
      }

      // If it's a section header WITHOUT values, switch section and skip
      if (foundSectionHeader && !rowHasValue) {
        currentSection = foundSectionHeader;
        continue;
      }

      // If it's a section header WITH values:
      // - If it CHANGES the current section (boundary marker), switch section and skip.
      //   QB parent group headers show subtotal values duplicated by child accounts.
      //   Example: "Fixed Assets" group header (value=$82,643) appears before child
      //   "Fixed Assets" account (same value=$82,643) — skipping the boundary row
      //   prevents double-counting.
      // - If the section DOESN'T change (already in this section), treat as a real
      //   account row and add it (e.g., a "Fixed Assets" account inside fixedAssets section).
      if (foundSectionHeader && rowHasValue) {
        if (foundSectionHeader !== currentSection) {
          currentSection = foundSectionHeader;
          continue; // Section boundary — skip the row, children carry the values
        }
        // Already in this section — fall through and add as a data row
        currentSection = foundSectionHeader;
      }
      
      // Check if this account name indicates we should switch sections
      // This handles cases where QB doesn't export section headers but account names are clear.
      // VALUED ROWS ONLY (Konnie 08-24, Little Bird): a zero-balance account named
      // "Owner's Equity" parked inside Other Current Liabilities flipped the section
      // to equity and dragged "Sales Tax Agency Payable" with it — L and E were both
      // wrong but the sheet still balanced. A row carrying no values classifies
      // nothing and must never hijack the section. Same suppression inside an
      // open QB sub-group — the group's own section is the truth there.
      if (!foundSectionHeader && rowHasValue && !openQbSubGroup) {
        for (const [section, patterns] of Object.entries(accountSectionIndicators)) {
          // A 'current portion' / 'current maturities' row is a CURRENT liability
          // whatever it starts with (Konnie 09-23, Hebbian/AVT audited BS:
          // 'Long-term debt, current portion' switched the section to Long-Term
          // and dragged 'Operating lease liability, current portion' with it).
          if (patterns.some(p => p.test(rawName)) && !(section === 'longTermLiabilities' && /current\s*(portion|maturit)/i.test(rawName))) {
            // Only switch if we're not already in this section or a "later" section
            // Order: currentAssets < fixedAssets < otherAssets < currentLiabilities < longTermLiabilities < equity
            const sectionOrder = ['currentAssets', 'fixedAssets', 'otherAssets', 'currentLiabilities', 'longTermLiabilities', 'equity'];
            const currentIdx = sectionOrder.indexOf(currentSection);
            const newIdx = sectionOrder.indexOf(section);
            
            // Only switch forward in the natural BS order, or to an adjacent section
            if (newIdx > currentIdx || (newIdx >= currentIdx - 1 && newIdx !== currentIdx)) {
              currentSection = section;
            }
            break;
          }
        }
      }
      
      // Check if this is a subtotal row
      if (isSubtotal(rawName)) {
        openQbSubGroup = null;   // every QB sub-group ends with a Total row
        skipped.push({ name: rawName, section: currentSection, reason: 'Subtotal', values: { ...yearValues } });
        continue;
      }
      
      // Only add if there's at least some value
      if (rowHasValue) {
        // Deduplicate: if this name already exists in the current section, disambiguate
        const existingNames = parsed[currentSection].map(r => r.name);
        let finalName = rawName;
        if (existingNames.includes(rawName)) {
          // Try to disambiguate using parent context from QB hierarchy
          // Walk up the parentStack to find a useful (non-generic) parent name
          let parentName = null;
          for (let pl = indentLevel - 1; pl >= 0; pl--) {
            const candidate = parentStack[pl];
            if (candidate && candidate !== rawName) {
              // Skip generic section headers that don't help disambiguate
              const isGenericParent = qbSubSectionHeaders.some(p => p.test(candidate.trim()));
              if (!isGenericParent) {
                parentName = candidate;
                break;
              }
            }
          }
          
          if (parentName) {
            // Use a short version of the parent for cleaner names
            // Strip QB account number prefixes like "24000 · " for readability
            const shortParent = parentName.replace(/^\d+\s*·\s*/, '');
            finalName = `${rawName} (${shortParent})`;
          }
          // If still a duplicate (or no useful parent found), append a number
          if (existingNames.includes(finalName)) {
            let n = 2;
            while (existingNames.includes(`${rawName} (${n})`)) n++;
            finalName = `${rawName} (${n})`;
          }
        }
        const _rt = otherSectionReroute(currentSection, finalName, yearValues);
        parsed[_rt.section].push({ name: finalName, yearValues: _rt.values });
      }
    }
    
    // Build verification totals
    const verification = {};
    Object.entries(parsed).forEach(([section, rows]) => {
      verification[section] = { count: rows.length };
      detectedYears.forEach(yr => {
        verification[section][yr] = rows.reduce((sum, r) => sum + (r.yearValues[yr] || 0), 0);
      });
    });
    
    return {
      parsed,
      skipped,
      verification,
      detectedYears,
      yearColumns,
      yearMatchInfo,
      bsYearLabels: { ...bsYearLabels }, // Include current labels for preview
      totalRows: Object.values(parsed).reduce((sum, arr) => sum + arr.length, 0)
    };
  };
  
  // Apply Full Balance Sheet Paste
  const applyFullBSPaste = () => {
    if (!fullBSPastePreview) return;
    
    try {
      captureUndoState(`Paste Full Balance Sheet${bsPasteClearFirst ? ' - Clear & Replace' : bsPasteClearInterimOnly ? ' - Clear Interim' : ''}`);
      const { parsed, yearMatchInfo } = fullBSPastePreview;
      recordSourceTotals('bs', null, bsStmtByLabel(fullBSPastePreview, bsYearLabels), bsPasteClearFirst);
      
      // Update year labels if we detected years that differ from current labels
      if (yearMatchInfo && yearMatchInfo.length > 0) {
        const newLabels = { ...bsYearLabels };
        let labelsChanged = false;
        
        yearMatchInfo.forEach(info => {
          if (info.mappedTo && info.mappedTo !== 'interim' && info.detected) {
            const detectedYear = info.detected;
            if (/^\d{4}$/.test(detectedYear)) {
              const currentLabel = newLabels[info.mappedTo];
              if (currentLabel !== detectedYear) {
                newLabels[info.mappedTo] = detectedYear;
                labelsChanged = true;
              }
            }
          }
        });
        
        if (labelsChanged) {
          setBsYearLabels(newLabels);
        }
      }
      
      const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      // Strip dedup suffixes like "(Credit Cards)", "(2)", "(Current Liabilities)" to get base name
      const getBaseName = (str) => str.replace(/\s*\([^)]*\)\s*$/, '').trim();
      const normalizeBase = (str) => normalizeForMatch(getBaseName(str));
      
      // Determine which year keys are actually present in the pasted data
      // Only these keys should be written; other years should be left untouched
      const activeYearKeys = new Set(Object.values(fullBSPastePreview.yearColumns || {}));
      
      // Helper to update a BS section
      const updateBSSection = (existing, newRows, setter) => {
        let updated = [...existing];
        const matchedIndices = new Set(); // Track which existing items have been matched
        
        // Multi-pass matching to handle dedup suffixes across different years
        const matchResults = newRows.map(row => {
          // Pass 1: exact name match
          let matchIdx = updated.findIndex((item, idx) => !matchedIndices.has(idx) && item.name === row.name);
          
          // Pass 2: normalized match (strips all non-alphanumeric)
          if (matchIdx === -1) {
            const normalizedNew = normalizeForMatch(row.name);
            matchIdx = updated.findIndex((item, idx) => !matchedIndices.has(idx) && normalizeForMatch(item.name || '') === normalizedNew);
          }
          
          // Pass 3: base-name match (strips dedup suffixes like "(Credit Cards)" or "(2)")
          // This handles when 2025 produces "Chase Ink for Business (Credit Cards)" 
          // but 2024 produces "Chase Ink for Business (2)" or vice versa
          if (matchIdx === -1) {
            const baseNew = normalizeBase(row.name);
            matchIdx = updated.findIndex((item, idx) => !matchedIndices.has(idx) && normalizeBase(item.name || '') === baseNew);
          }
          
          if (matchIdx !== -1) matchedIndices.add(matchIdx);
          return { row, matchIdx };
        });
        
        // Apply matches
        matchResults.forEach(({ row, matchIdx }) => {
          if (matchIdx !== -1) {
            // IMPORTANT: Only merge year keys that are actually in the pasted data
            // This prevents loading 2024 data from wiping 2025 data with zeroes
            const merged = { ...updated[matchIdx] };
            Object.entries(row.yearValues).forEach(([yearKey, val]) => {
              if (activeYearKeys.has(yearKey)) {
                merged[yearKey] = val;
              }
            });
            updated[matchIdx] = merged;
          } else {
            // New row - only set active year keys, leave others as 0
            const newItem = {
              id: Date.now() + Math.random(),
              name: row.name,
              year1: 0, year2: 0, year3: 0, interim: 0
            };
            Object.entries(row.yearValues).forEach(([yearKey, val]) => {
              if (activeYearKeys.has(yearKey)) {
                newItem[yearKey] = val;
              }
            });
            updated.push(newItem);
          }
        });
        
        setter(updated);
      };
      
      // If clear & replace, start with empty arrays so only new rows are created
      const getBS = (categories) => bsPasteClearFirst ? [] : categories;
      
      // Clear Interim Only: zero the interim column on all existing rows first
      if (bsPasteClearInterimOnly) {
        const clearInterim = (setter, categories) => setter(categories.map(row => ({ ...row, interim: 0 })));
        clearInterim(setBsCurrentAssets, bsCurrentAssets);
        clearInterim(setBsFixedAssets, bsFixedAssets);
        clearInterim(setBsOtherAssets, bsOtherAssets);
        clearInterim(setBsCurrentLiabilities, bsCurrentLiabilities);
        clearInterim(setBsLongTermLiabilities, bsLongTermLiabilities);
        clearInterim(setBsEquity, bsEquity);
      }
      
      // Apply to each section
      if (bsPasteClearFirst || parsed.currentAssets.length > 0) updateBSSection(getBS(bsCurrentAssets), parsed.currentAssets, setBsCurrentAssets);
      if (bsPasteClearFirst || parsed.fixedAssets.length > 0) updateBSSection(getBS(bsFixedAssets), parsed.fixedAssets, setBsFixedAssets);
      if (bsPasteClearFirst || parsed.otherAssets.length > 0) updateBSSection(getBS(bsOtherAssets), parsed.otherAssets, setBsOtherAssets);
      if (bsPasteClearFirst || parsed.currentLiabilities.length > 0) updateBSSection(getBS(bsCurrentLiabilities), parsed.currentLiabilities, setBsCurrentLiabilities);
      if (bsPasteClearFirst || parsed.longTermLiabilities.length > 0) updateBSSection(getBS(bsLongTermLiabilities), parsed.longTermLiabilities, setBsLongTermLiabilities);
      if (bsPasteClearFirst || parsed.equity.length > 0) updateBSSection(getBS(bsEquity), parsed.equity, setBsEquity);
      
      // Close modal
      setShowFullBSPasteModal(false);
      setFullBSPasteData('');
      setFullBSPastePreview(null);
      setBsPasteClearFirst(false);
      setBsPasteClearInterimOnly(false);
      
    } catch (error) {
      console.error('Full BS Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== INTERIM BALANCE SHEET PASTE (for Balance Sheet tab) ==========
  // Parses a single-period balance sheet and puts values in interim column
  const parseInterimBSPaste = () => {
    const lines = interimBSPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Subtotal patterns to skip
    const subtotalPatterns = [
      /^total\s/i, /\stotal$/i, /^total\s*(assets|liabilities|equity)/i,
      /^total\s*(current|fixed|other)\s*(assets|liabilities)/i,
      /^total\s*long[- ]?term/i, /^net\s*(assets|worth)/i
    ];
    const isSubtotal = (name) => subtotalPatterns.some(p => p.test(name.trim()));
    
    // Section header patterns for balance sheet
    // These should be STRICT patterns for section headers, not account names
    // NOTE: "Other Current Assets" is a QB sub-header under Current Assets, NOT the BS "Other Assets" section
    const sectionPatterns = {
      currentAssets: [/^current\s*assets$/i, /^assets$/i],
      fixedAssets: [/^fixed\s*assets$/i, /^property.*equipment$/i, /^property,?\s*plant.*equipment$/i, /^pp&e$/i, /^long[- ]?term\s*assets$/i, /^other\s*long[- ]?term\s*assets$/i],
      otherAssets: [/^other\s*assets$/i, /^intangible\s*assets$/i],
      currentLiabilities: [/^current\s*liabilities$/i, /^liabilities$/i, /^liabilities\s*(and|&)\s*(stockholder|shareholder|owner)/i],
      longTermLiabilities: [/^long[- ]?term\s*liabilities$/i, /^long[- ]?term\s*debt$/i, /^non[- ]?current\s*liabilities$/i],
      equity: [/^equity$/i, /^stockholder'?s?\s*equity$/i, /^shareholder'?s?\s*equity$/i, /^owner'?s?\s*equity$/i, /^members?\s*equity$/i, /^net\s*assets$/i]
    };
    
    // QB sub-section headers to skip
    const qbSubSectionHeaders = [
      /^other\s*current\s*assets$/i, /^checking\s*\/?\s*savings$/i, /^accounts\s*receivable$/i,
      /^credit\s*cards?$/i, /^other\s*current\s*liabilities$/i, /^banks?$/i, /^vehicle\s*loans?$/i,
    ];
    
    // Account name patterns that indicate we should switch sections
    const accountSectionIndicators = {
      fixedAssets: [/^accumulated\s*depreciation/i, /^depreciation/i, /^buildings?$/i, /^land$/i, /^leasehold\s*improvements?/i, /^furniture.*fixtures?/i, /^equipment$/i, /^vehicles?$/i, /^machinery/i],
      currentLiabilities: [/^accounts\s*payable/i, /^accrued\s*(expenses?|liabilities)/i, /^payroll\s*(liabilities|payable)/i, /^sales\s*tax\s*payable/i, /^credit\s*cards?\s*payable/i, /^current\s*portion.*long[- ]?term/i, /^deferred\s*revenue/i, /^unearned\s*revenue/i],
      longTermLiabilities: [/^long[- ]?term\s*(debt|notes?|loan)/i, /^notes?\s*payable\s*-?\s*long/i, /^mortgage/i, /^bonds?\s*payable/i],
      equity: [/^common\s*stock/i, /^preferred\s*stock/i, /^retained\s*earnings/i, /^additional\s*paid[- ]?in\s*capital/i, /^owner'?s?\s*(draws?|distributions?|capital|equity)/i, /^member'?s?\s*(draws?|distributions?|capital)/i, /^treasury\s*stock/i, /^accumulated\s*other\s*comprehensive/i, /^opening\s*balance\s*equity/i, /^partner.*capital/i]
    };
    
    // Detect header row and value column
    // Scan up to first 10 non-blank lines — QBO exports often have company name / title rows before the real header
    let valueColumn = 1; // Default to second column
    let dataStartRow = 0;
    let headerCells = lines[0].split('\t');
    
    const scanLimit = Math.min(lines.length, 10);
    for (let r = 0; r < scanLimit; r++) {
      const rowLower = lines[r].toLowerCase();
      const cells = lines[r].split('\t');
      // A real header row contains a year, date, "total", "balance", or "account" keyword
      // AND has at least one non-name cell (i.e., more than 1 cell or has a keyword not in col 0)
      const looksLikeHeader = /20\d{2}|total|balance|as\s*of|account/i.test(rowLower) ||
                              /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(rowLower);
      if (looksLikeHeader) {
        headerCells = cells;
        dataStartRow = r + 1;
        // Find value column: scan for year, date, "total", or "balance" keyword
        for (let i = 1; i < cells.length; i++) {
          const cell = cells[i].trim();
          if (!cell) continue;
          // Full 4-digit year
          if (/20\d{2}/.test(cell)) { valueColumn = i; break; }
          // Abbreviated year: "Dec 31, 25", "12/31/25", "'25"
          if (/[,\/\s'](2[0-9])\s*$/.test(cell)) { valueColumn = i; break; }
          // "Total", "Balance", or month name
          if (/\b(total|balance)\b/i.test(cell) || /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(cell)) {
            valueColumn = i; break;
          }
        }
        break;
      }
    }
    
    // Data-probe: if valueColumn is 1 but most data rows have empty col 1,
    // find the real value column by scanning the first few data rows
    if (valueColumn === 1) {
      let emptyAt1 = 0, probedRows = 0;
      let probeValueCol = 1;
      for (let r = dataStartRow; r < Math.min(dataStartRow + 15, lines.length); r++) {
        const pcells = lines[r].split('\t');
        const col1val = (pcells[1] || '').replace(/[$,]/g, '').trim();
        const col1num = parseFloat(col1val);
        if (!isNaN(col1num) && col1num !== 0) { probedRows++; break; } // col1 has real data — keep valueColumn=1
        if (col1val === '' || isNaN(col1num)) emptyAt1++;
        probedRows++;
        if (probedRows >= 10) break;
      }
      if (emptyAt1 >= 5 && probedRows > 0) {
        // col1 is mostly empty — find the first column index that consistently has numeric data
        for (let r = dataStartRow; r < Math.min(dataStartRow + 15, lines.length); r++) {
          const pcells = lines[r].split('\t');
          for (let ci = 2; ci < pcells.length; ci++) {
            const v = (pcells[ci] || '').replace(/[$,]/g, '').trim();
            const n = parseFloat(v);
            if (!isNaN(n) && n !== 0) { probeValueCol = ci; break; }
          }
          if (probeValueCol > 1) break;
        }
        if (probeValueCol > 1) valueColumn = probeValueCol;
      }
    }
    
    // Parse all lines, tracking current section
    let currentSection = 'currentAssets';
    const parsed = {
      currentAssets: [],
      fixedAssets: [],
      otherAssets: [],
      currentLiabilities: [],
      longTermLiabilities: [],
      equity: []
    };
    const skipped = [];
    
    // Helper to extract account name AND indent level from hierarchical QB format
    const extractAccountInfo = (cells) => {
      if ((cells[0] || '').trim()) {
        return { name: (cells[0] || '').trim(), indentLevel: 0 };
      }
      let name = '';
      let indentLevel = 0;
      const scanLimit = Math.min(valueColumn, cells.length);
      for (let c = 0; c < scanLimit; c++) {
        const cellVal = (cells[c] || '').trim();
        if (cellVal && !/^[\d,.$()-]+$/.test(cellVal)) {
          name = cellVal;
          indentLevel = c;
        }
      }
      return { name, indentLevel };
    };
    
    // Track parent names at each indent level for deduplication
    const parentStack = {};
    // Open QB sub-group tracking (Konnie 08-24, Little Bird) — see parseFullBSPaste.
    let openQbSubGroup = null;

    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      const { name: rawName, indentLevel } = extractAccountInfo(cells);
      if (!rawName) continue;

      // Update parent stack
      parentStack[indentLevel] = rawName;
      for (let d = indentLevel + 1; d < 20; d++) delete parentStack[d];
      
      // Skip QB sub-section headers without values
      const isQbSubHeader = qbSubSectionHeaders.some(p => p.test(rawName.trim()));
      
      // Parse the value first - try the detected column, then scan other columns
      let value = 0;
      let val = cells[valueColumn] || '';
      val = val.replace(/[$,]/g, '').trim();
      if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
      value = parseFloat(val) || 0;
      
      // If no value found in expected column, scan other columns
      if (value === 0) {
        for (let c = valueColumn; c < cells.length; c++) {
          let tryVal = (cells[c] || '').replace(/[$,]/g, '').trim();
          if (tryVal.startsWith('(') && tryVal.endsWith(')')) tryVal = '-' + tryVal.slice(1, -1);
          const parsedVal = parseFloat(tryVal);
          if (!isNaN(parsedVal) && parsedVal !== 0) {
            value = parsedVal;
            break;
          }
        }
      }
      
      const rowHasValue = value !== 0;

      if (isQbSubHeader && !rowHasValue) { openQbSubGroup = rawName.trim(); continue; }

      // Check if this is a section header
      let foundSectionHeader = null;
      for (const [section, patterns] of Object.entries(sectionPatterns)) {
        if (patterns.some(p => p.test(rawName))) {
          foundSectionHeader = section;
          break;
        }
      }

      // Inside an open QB sub-group, a section-named row is an ACCOUNT of the
      // current section, never a boundary (Little Bird's "Owner's Equity"
      // account under Other Current Liabilities) — see parseFullBSPaste.
      if (openQbSubGroup && foundSectionHeader && foundSectionHeader !== currentSection) {
        foundSectionHeader = null;
      }

      // "Intangible Assets" WITH values is an ACCOUNT row, not a section
      // boundary (Konnie 08-11, TechClarity) — see parseFullBSPaste.
      if (foundSectionHeader === 'otherAssets' && rowHasValue && /^intangible/i.test(rawName)) {
        foundSectionHeader = null;
      }

      if (foundSectionHeader && !rowHasValue) {
        currentSection = foundSectionHeader;
        continue;
      }
      
      if (foundSectionHeader && rowHasValue) {
        if (foundSectionHeader !== currentSection) {
          currentSection = foundSectionHeader;
          continue;
        }
        currentSection = foundSectionHeader;
      }
      
      // VALUED ROWS ONLY (Konnie 08-24, Little Bird — see the annual BS parser):
      // a zero-balance indicator-named row must never hijack the section; nor
      // may anything inside an open QB sub-group.
      if (!foundSectionHeader && rowHasValue && !openQbSubGroup) {
        for (const [section, patterns] of Object.entries(accountSectionIndicators)) {
          // A 'current portion' / 'current maturities' row is a CURRENT liability
          // whatever it starts with (Konnie 09-23, Hebbian/AVT audited BS:
          // 'Long-term debt, current portion' switched the section to Long-Term
          // and dragged 'Operating lease liability, current portion' with it).
          if (patterns.some(p => p.test(rawName)) && !(section === 'longTermLiabilities' && /current\s*(portion|maturit)/i.test(rawName))) {
            const sectionOrder = ['currentAssets', 'fixedAssets', 'otherAssets', 'currentLiabilities', 'longTermLiabilities', 'equity'];
            const currentIdx = sectionOrder.indexOf(currentSection);
            const newIdx = sectionOrder.indexOf(section);
            if (newIdx > currentIdx || (newIdx >= currentIdx - 1 && newIdx !== currentIdx)) {
              currentSection = section;
            }
            break;
          }
        }
      }

      if (isSubtotal(rawName)) {
        openQbSubGroup = null;   // every QB sub-group ends with a Total row
        skipped.push({ name: rawName, section: currentSection, reason: 'Subtotal', values: { interim: value } });
        continue;
      }
      
      if (rowHasValue) {
        // Deduplicate using parent context
        const existingNames = parsed[currentSection].map(r => r.name);
        let finalName = rawName;
        if (existingNames.includes(rawName)) {
          const parentName = parentStack[indentLevel - 1];
          if (parentName && parentName !== rawName) {
            finalName = `${rawName} (${parentName})`;
          }
          if (existingNames.includes(finalName)) {
            let n = 2;
            while (existingNames.includes(`${rawName} (${n})`)) n++;
            finalName = `${rawName} (${n})`;
          }
        }
        parsed[currentSection].push({ name: finalName, value });
      }
    }
    
    // Build verification totals
    const verification = {};
    Object.entries(parsed).forEach(([section, rows]) => {
      verification[section] = {
        count: rows.length,
        total: rows.reduce((sum, r) => sum + (r.value || 0), 0)
      };
    });
    
    return {
      parsed,
      skipped,
      verification,
      totalRows: Object.values(parsed).reduce((sum, arr) => sum + arr.length, 0)
    };
  };
  
  // Apply Interim Balance Sheet Paste
  const applyInterimBSPaste = () => {
    if (!interimBSPastePreview) return;
    
    try {
      captureUndoState('Paste Interim Balance Sheet');
      const { parsed } = interimBSPastePreview;
      recordSourceTotals('bs', null, { interim: stmtPick(interimBSPastePreview.skipped, BS_STMT_KEYS, v => (v ? v.interim : 0)) }, false);
      
      const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      
      // Helper to update a BS section's interim column only
      const updateBSInterim = (existing, newRows, setter) => {
        // If clear first: zero out all existing interim values before applying
        let updated = interimBSPasteClearFirst
          ? existing.map(row => ({ ...row, interim: 0 }))
          : [...existing];
        
        newRows.forEach(row => {
          let matchIdx = updated.findIndex(item => item.name === row.name);
          if (matchIdx === -1) {
            const normalizedNew = normalizeForMatch(row.name);
            matchIdx = updated.findIndex(item => normalizeForMatch(item.name || '') === normalizedNew);
          }
          
          if (matchIdx !== -1) {
            updated[matchIdx] = { ...updated[matchIdx], interim: row.value };
          } else {
            updated.push({
              id: Date.now() + Math.random(),
              name: row.name,
              year1: 0,
              year2: 0,
              year3: 0,
              interim: row.value
            });
          }
        });
        
        setter(updated);
      };
      
      // Apply to each section
      if (parsed.currentAssets.length > 0) updateBSInterim(bsCurrentAssets, parsed.currentAssets, setBsCurrentAssets);
      if (parsed.fixedAssets.length > 0) updateBSInterim(bsFixedAssets, parsed.fixedAssets, setBsFixedAssets);
      if (parsed.otherAssets.length > 0) updateBSInterim(bsOtherAssets, parsed.otherAssets, setBsOtherAssets);
      if (parsed.currentLiabilities.length > 0) updateBSInterim(bsCurrentLiabilities, parsed.currentLiabilities, setBsCurrentLiabilities);
      if (parsed.longTermLiabilities.length > 0) updateBSInterim(bsLongTermLiabilities, parsed.longTermLiabilities, setBsLongTermLiabilities);
      if (parsed.equity.length > 0) updateBSInterim(bsEquity, parsed.equity, setBsEquity);
      
      // Close modal
      setShowInterimBSPasteModal(false);
      setInterimBSPasteData('');
      setInterimBSPastePreview(null);
      setInterimBSPasteClearFirst(false);
      
    } catch (error) {
      console.error('Interim BS Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== FULL TTM BALANCE SHEET PASTE (for TTM Balance Sheet tab) ==========
  const parseFullTtmBSPaste = () => {
    const lines = fullTtmBSPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Derive TTM end month/year from the BS tab's own labels (not monthlyTtmConfig)
    const bsMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const lastBsLabel = ttmBsMonthLabels[11] || '';
    const bsLabelParts = lastBsLabel.split(' ');
    const bsEndMonth = bsMonthNames.indexOf(bsLabelParts[0]);
    const bsEndYear = parseInt(bsLabelParts[1]) || new Date().getFullYear();
    
    // Subtotal patterns to skip
    const subtotalPatterns = [
      /^total\s/i, /\stotal$/i, /^total\s*(current|assets|liabilities|equity)/i,
      /^total\s*(fixed|other|long[- ]?term)/i, /^net\s*(assets|worth)/i,
      /^total\s*(checking|savings|credit\s*cards|other)/i
    ];
    const isSubtotal = (name) => subtotalPatterns.some(p => p.test(name.trim()));
    
    // Section patterns for all 6 BS sections
    // These should be STRICT patterns for section headers, not account names
    // Updated to handle QB Desktop naming conventions
    const sectionPatterns = {
      currentAssets: [/^current\s*assets$/i, /^assets$/i, /^checking\/savings$/i, /^accounts\s*receivable$/i, /^other\s*current\s*assets$/i],
      fixedAssets: [/^fixed\s*assets$/i, /^property.*equipment$/i, /^property,?\s*plant.*equipment$/i, /^pp&e$/i, /^long[- ]?term\s*assets$/i, /^other\s*long[- ]?term\s*assets$/i],
      otherAssets: [/^other\s*assets$/i, /^intangible\s*assets$/i],
      currentLiabilities: [/^current\s*liabilities$/i, /^liabilities$/i, /^liabilities\s*(&|and)\s*equity$/i, /^credit\s*cards$/i, /^other\s*current\s*liabilities$/i],
      longTermLiabilities: [/^long[- ]?term\s*liabilities$/i, /^long[- ]?term\s*debt$/i, /^non[- ]?current\s*liabilities$/i],
      equity: [/^equity$/i, /^stockholder'?s?\s*equity$/i, /^shareholder'?s?\s*equity$/i, /^owner'?s?\s*equity$/i, /^members?\s*equity$/i, /^net\s*assets$/i]
    };
    
    // Account name patterns that indicate we should switch sections
    const accountSectionIndicators = {
      fixedAssets: [/^accumulated\s*depreciation/i, /^depreciation/i, /^buildings?$/i, /^land$/i, /^leasehold\s*improvements?/i, /^furniture.*fixtures?/i, /^equipment$/i, /^vehicles?$/i, /^machinery/i],
      currentLiabilities: [/^accounts\s*payable/i, /^accrued\s*(expenses?|liabilities)/i, /^payroll\s*(liabilities|payable)/i, /^sales\s*tax\s*payable/i, /^credit\s*cards?$/i, /^current\s*portion.*long[- ]?term/i, /^deferred\s*revenue/i, /^unearned\s*revenue/i],
      longTermLiabilities: [/^long[- ]?term\s*(debt|notes?|loan)/i, /^notes?\s*payable\s*-?\s*long/i, /^mortgage/i, /^bonds?\s*payable/i],
      equity: [/^common\s*stock/i, /^preferred\s*stock/i, /^retained\s*earnings/i, /^additional\s*paid[- ]?in\s*capital/i, /^owner'?s?\s*(draws?|distributions?|capital|equity)/i, /^member'?s?\s*(draws?|distributions?|capital)/i, /^treasury\s*stock/i, /^accumulated\s*other\s*comprehensive/i, /^opening\s*balance\s*equity/i, /^partner.*capital/i, /^personal$/i, /^net\s*income$/i]
    };
    
    // Month detection patterns - enhanced to handle QB Desktop date formats like "Jan 31, 25"
    const monthPatterns = [
      { pattern: /\bjan/i, index: 0 },
      { pattern: /\bfeb/i, index: 1 },
      { pattern: /\bmar/i, index: 2 },
      { pattern: /\bapr/i, index: 3 },
      { pattern: /\bmay/i, index: 4 },
      { pattern: /\bjun/i, index: 5 },
      { pattern: /\bjul/i, index: 6 },
      { pattern: /\baug/i, index: 7 },
      { pattern: /\bsep/i, index: 8 },
      { pattern: /\boct/i, index: 9 },
      { pattern: /\bnov/i, index: 10 },
      { pattern: /\bdec/i, index: 11 }
    ];
    
    // Try to detect month columns from header row
    // Check first few rows in case header isn't on row 1
    let monthColumns = {};
    let dataStartRow = 0;
    let headerRowIdx = -1;
    
    // Search first 3 rows for month headers
    for (let rowIdx = 0; rowIdx < Math.min(6, lines.length); rowIdx++) {
      const rowCells = lines[rowIdx].split('\t');
      let monthsFoundInRow = 0;
      const detectedCols = []; // Collect columns with month+year info for chronological sorting
      
      rowCells.forEach((cell, colIdx) => {
        const cellText = cell.trim();
        if (!cellText) return;
        
        for (const mp of monthPatterns) {
          if (mp.pattern.test(cellText)) {
            // Extract year from header (e.g., "February 2025", "Feb 25", "Jan 31, 25", "Feb-25")
            const yearMatch = cellText.match(/20(\d{2})|[''](\d{2})\b|[\s\-,.](\d{2})\s*$/);
            let year = bsEndYear; // Default
            if (yearMatch) {
              const yearDigits = yearMatch[1] || yearMatch[2] || yearMatch[3];
              year = yearDigits ? 2000 + parseInt(yearDigits) : year;
            }
            detectedCols.push({ colIdx, calMonth: mp.index, year });
            monthsFoundInRow++;
            break;
          }
        }
      });
      
      // If we found multiple months in this row, it's likely the header
      if (monthsFoundInRow >= 3) {
        // Sort columns by column index (left-to-right order in spreadsheet)
        detectedCols.sort((a, b) => a.colIdx - b.colIdx);
        
        // Infer years when headers lack year info (e.g., bare "Mar", "Apr"... "Jan", "Feb")
        const allLackYear = detectedCols.length >= 6 && detectedCols.every(c => {
          const cellText = (rowCells[c.colIdx] || '').trim();
          return !cellText.match(/20\d{2}|['']\d{2}\b|[\s\-,.]\d{2}\s*$/);
        });
        
        if (allLackYear && detectedCols.length >= 10) {
          // No years in any header — assign years working backwards from last column
          const endMonth = bsEndMonth;
          const endYear = bsEndYear;
          for (let i = detectedCols.length - 1; i >= 0; i--) {
            const monthsBack = detectedCols.length - 1 - i;
            let assignMonth = endMonth - monthsBack;
            let assignYear = endYear;
            while (assignMonth < 0) { assignMonth += 12; assignYear--; }
            detectedCols[i].calMonth = assignMonth;
            detectedCols[i].year = assignYear;
          }
        } else {
          // Have year info — use chronological sort
          detectedCols.sort((a, b) => {
            if (a.year !== b.year) return a.year - b.year;
            return a.calMonth - b.calMonth;
          });
        }
        
        // Detect QBO 2-column format: headers at every-other column (e.g., col 6, 8, 10...)
        let dataColOffset = 0;
        if (detectedCols.length >= 3) {
          const gaps = [];
          for (let g = 1; g < detectedCols.length; g++) {
            gaps.push(detectedCols[g].colIdx - detectedCols[g-1].colIdx);
          }
          const avgGap = gaps.reduce((a, b) => a + b, 0) / gaps.length;
          
          if (avgGap >= 1.8 && avgGap <= 2.2) {
            // Check data rows to see if values are at header column or header+1
            let valuesAtHeader = 0;
            let valuesAtOffset = 0;
            const checkStart = rowIdx + 1;
            const sampleRows = Math.min(10, lines.length - checkStart);
            
            for (let r = checkStart; r < checkStart + sampleRows; r++) {
              const sampleCells = lines[r].split('\t');
              for (const col of detectedCols.slice(0, 4)) {
                const atHeader = (sampleCells[col.colIdx] || '').replace(/[$,\s]/g, '');
                const atNext = (sampleCells[col.colIdx + 1] || '').replace(/[$,\s]/g, '');
                if (!isNaN(parseFloat(atHeader)) && parseFloat(atHeader) !== 0) valuesAtHeader++;
                if (!isNaN(parseFloat(atNext)) && parseFloat(atNext) !== 0) valuesAtOffset++;
              }
            }
            
            if (valuesAtOffset > valuesAtHeader * 2) {
              dataColOffset = 1;
            }
          }
        }
        
        // Assign TTM array positions by mapping calendar month/year to actual TTM positions
        const ttmPositionMap = {};
        let mapM = bsEndMonth - 11;
        let mapY = bsEndYear;
        if (mapM < 0) { mapM += 12; mapY--; }
        for (let i = 0; i < 12; i++) {
          ttmPositionMap[`${mapY}-${mapM}`] = i;
          mapM++;
          if (mapM > 11) { mapM = 0; mapY++; }
        }
        // Archive positions 12-23
        mapM = bsEndMonth - 23;
        mapY = bsEndYear;
        while (mapM < 0) { mapM += 12; mapY--; }
        for (let i = 0; i < 12; i++) {
          ttmPositionMap[`${mapY}-${mapM}`] = i + 12;
          mapM++;
          if (mapM > 11) { mapM = 0; mapY++; }
        }
        
        detectedCols.forEach((col) => {
          const key = `${col.year}-${col.calMonth}`;
          const ttmPos = ttmPositionMap[key];
          if (ttmPos !== undefined) {
            monthColumns[col.colIdx + dataColOffset] = ttmPos;
          }
        });
        
        headerRowIdx = rowIdx;
        dataStartRow = rowIdx + 1;
        break;
      }
    }
    
    // If no header found, try to detect value columns by scanning for numeric patterns
    if (Object.keys(monthColumns).length === 0) {
      // Scan a data row to find columns with numeric values
      const sampleRow = lines[Math.min(4, lines.length - 1)]; // Use row 5 as sample
      const sampleCells = sampleRow.split('\t');
      const numericCols = [];
      
      sampleCells.forEach((cell, colIdx) => {
        const val = cell.replace(/[$,]/g, '').trim();
        if (val && !isNaN(parseFloat(val))) {
          numericCols.push(colIdx);
        }
      });
      
      // If we found 12 numeric columns, assume they're months 0-11
      if (numericCols.length >= 12) {
        numericCols.slice(0, 12).forEach((colIdx, monthIdx) => {
          monthColumns[colIdx] = monthIdx;
        });
      } else if (numericCols.length > 0) {
        // Use whatever numeric columns we found
        numericCols.forEach((colIdx, i) => {
          if (i < 12) monthColumns[colIdx] = i;
        });
      }
    }
    
    // Fallback: assume standard consecutive columns
    if (Object.keys(monthColumns).length === 0) {
      const firstRow = lines[0];
      const headerCells = firstRow.split('\t');
      for (let i = 1; i <= 12 && i < headerCells.length; i++) {
        monthColumns[i] = i - 1;
      }
    }
    
    // Parse all lines
    let currentSection = 'currentAssets';
    const parsed = {
      currentAssets: [],
      fixedAssets: [],
      otherAssets: [],
      currentLiabilities: [],
      longTermLiabilities: [],
      equity: []
    };
    const skipped = [];
    // Section headers with values that crossed a section boundary — held back as
    // potential rollups. If the target section ends empty (no detail accounts
    // followed), the rollup IS the only data and gets restored after parsing.
    const sectionRollupCandidates = [];
    const detectedMonths = [...new Set(Object.values(monthColumns))].sort((a, b) => a - b);

    // Find the first (leftmost) value column index - needed for hierarchical QB format
    const valueColIndices = Object.keys(monthColumns).map(k => parseInt(k));
    const firstValueCol = valueColIndices.length > 0 ? Math.min(...valueColIndices) : 1;
    
    // Helper to extract account name AND indent level from hierarchical QB format
    // QB Desktop exports can have names spread across columns 0-N based on indent level (up to 5+ levels)
    const extractAccountInfo = (cells) => {
      let name = '';
      let indentLevel = 0;
      const scanLimit = Math.min(firstValueCol, cells.length);
      for (let c = 0; c < scanLimit; c++) {
        const cellVal = (cells[c] || '').trim();
        // Skip cells that look like numbers or currency values
        if (cellVal && !/^[\d,.$()+-]+$/.test(cellVal) && !/^=/.test(cellVal)) {
          name = cellVal;
          indentLevel = c;
        }
      }
      return { name, indentLevel };
    };
    
    // Track parent names at each indent level for deduplication
    const parentStack = {};
    // Track where each group header appeared (by item count) to detect empty groups
    const groupItemCounts = {};
    // Open QB sub-group tracking (Konnie 08-24, Little Bird) — see parseFullBSPaste.
    // This parser doesn't skip sub-headers (orphan rescue needs them), so the
    // group state is set in-flow and cleared at any subtotal row.
    const qbSubGroupHeaders = [
      /^other\s*current\s*assets$/i, /^checking\s*\/?\s*savings$/i, /^credit\s*cards?$/i,
      /^other\s*current\s*liabilities$/i, /^banks?$/i, /^vehicle\s*loans?$/i,
    ];
    let openQbSubGroup = null;
    
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      const { name: rawName, indentLevel } = extractAccountInfo(cells);
      if (!rawName) continue;
      
      // Update parent stack
      parentStack[indentLevel] = rawName;
      for (let d = indentLevel + 1; d < 20; d++) delete parentStack[d];
      
      // Parse month values first (needed to check if row has values)
      const monthValues = Array(12).fill(0);
      let rowHasValue = false;
      Object.entries(monthColumns).forEach(([colIdx, monthIdx]) => {
        let val = cells[parseInt(colIdx)] || '';
        // Skip Excel formulas
        if (val.trim().startsWith('=')) {
          return;
        }
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
        const parsed = parseFloat(val) || 0;
        monthValues[monthIdx] = parsed;
        if (parsed !== 0) rowHasValue = true;
      });
      
      // Check if this is a section header (strict patterns, typically NO values)
      let foundSectionHeader = null;
      for (const [section, patterns] of Object.entries(sectionPatterns)) {
        if (patterns.some(p => p.test(rawName))) {
          foundSectionHeader = section;
          break;
        }
      }
      
      // "Intangible Assets" WITH values is an ACCOUNT row, not a section
      // boundary (Konnie 08-11, TechClarity) — see parseFullBSPaste.
      if (foundSectionHeader === 'otherAssets' && rowHasValue && /^intangible/i.test(rawName)) {
        foundSectionHeader = null;
      }

      // Open/suppress QB sub-groups (Konnie 08-24, Little Bird): inside a
      // sub-group ("Other Current Liabilities" … its Total row), a
      // section-named row is an ACCOUNT, never a boundary — "Owner's Equity"
      // parked there must not switch the section. See parseFullBSPaste.
      if (!rowHasValue && qbSubGroupHeaders.some(p => p.test(rawName.trim()))) {
        openQbSubGroup = rawName.trim();
      }
      if (openQbSubGroup && foundSectionHeader && foundSectionHeader !== currentSection) {
        foundSectionHeader = null;
      }

      // If it's a section header WITHOUT values, switch section and skip
      if (foundSectionHeader && !rowHasValue) {
        currentSection = foundSectionHeader;
        continue;
      }

      // If it's a section header WITH values:
      // - Boundary row (changes section): switch section, hold the row as a
      //   rollup candidate. Usually it's a duplicate of children that will
      //   follow, but when no children follow (e.g. summary BS where Fixed
      //   Assets / Other Assets / Equity are single rollup lines), we restore
      //   it after the loop so the data isn't lost.
      // - Already in section: treat as real account row, add it
      if (foundSectionHeader && rowHasValue) {
        if (foundSectionHeader !== currentSection) {
          const candidateIncluded = ['currentAssets', 'currentLiabilities'].includes(foundSectionHeader);
          sectionRollupCandidates.push({
            section: foundSectionHeader,
            name: rawName,
            monthValues,
            included: candidateIncluded
          });
          currentSection = foundSectionHeader;
          continue;
        }
        currentSection = foundSectionHeader;
      }
      
      // Check if this account name indicates we should switch sections
      // VALUED ROWS ONLY (Konnie 08-24, Little Bird — see the annual BS parser):
      // a zero-balance indicator-named row must never hijack the section; nor
      // may anything inside an open QB sub-group.
      if (!foundSectionHeader && rowHasValue && !openQbSubGroup) {
        for (const [section, patterns] of Object.entries(accountSectionIndicators)) {
          // A 'current portion' / 'current maturities' row is a CURRENT liability
          // whatever it starts with (Konnie 09-23, Hebbian/AVT audited BS:
          // 'Long-term debt, current portion' switched the section to Long-Term
          // and dragged 'Operating lease liability, current portion' with it).
          if (patterns.some(p => p.test(rawName)) && !(section === 'longTermLiabilities' && /current\s*(portion|maturit)/i.test(rawName))) {
            const sectionOrder = ['currentAssets', 'fixedAssets', 'otherAssets', 'currentLiabilities', 'longTermLiabilities', 'equity'];
            const currentIdx = sectionOrder.indexOf(currentSection);
            const newIdx = sectionOrder.indexOf(section);
            if (newIdx > currentIdx || (newIdx >= currentIdx - 1 && newIdx !== currentIdx)) {
              currentSection = section;
            }
            break;
          }
        }
      }
      
      // Track group headers (rows with names but no values) for orphan subtotal rescue
      if (!rowHasValue && !isSubtotal(rawName)) {
        groupItemCounts[rawName.toLowerCase().trim()] = (parsed[currentSection] || []).length;
      }
      
      // Skip subtotals — BUT rescue "Total for X" rows when no child items had values
      // E.g., "Cash" header → "Petty Cash" (no values) → "Total for Cash" ($500) → rescue as "Cash"
      if (isSubtotal(rawName)) {
        openQbSubGroup = null;   // every QB sub-group ends with a Total row
        const totalForMatch = rawName.match(/^total\s+(?:for\s+)?(.+)/i);
        if (totalForMatch && rowHasValue) {
          const groupName = totalForMatch[1].trim();
          const groupKey = groupName.toLowerCase().trim();
          const itemCountWhenGroupSeen = groupItemCounts[groupKey];
          const currentItemCount = (parsed[currentSection] || []).length;
          
          // If we tracked this group AND zero items were added since the group header
          if (itemCountWhenGroupSeen !== undefined && currentItemCount === itemCountWhenGroupSeen) {
            const defaultIncluded = ['currentAssets', 'currentLiabilities'].includes(currentSection);
            const existingNames = (parsed[currentSection] || []).map(r => r.name);
            let finalName = groupName;
            if (existingNames.includes(finalName)) {
              let n = 2;
              while (existingNames.includes(`${finalName} (${n})`)) n++;
              finalName = `${finalName} (${n})`;
            }
            parsed[currentSection].push({ name: finalName, monthValues, included: defaultIncluded });
            continue; // Rescued — don't skip
          }
        }
        // Section boundary via subtotal. Some balance sheets (especially exports
        // rearranged by hand) omit the "Other/Fixed Assets" and "Long-Term
        // Liabilities" section headers and rely on the "Total Current Assets/
        // Liabilities" subtotal to mark where non-current items begin. Without this,
        // accounts like Fixed Assets, Investment, Shareholder Loan and long-term
        // leases get lumped into the current sections, distorting working capital.
        const subLower = rawName.toLowerCase();
        if (currentSection === 'currentAssets' && /\btotal\b[\s\S]*\bcurrent\s+assets\b/.test(subLower)) {
          currentSection = 'fixedAssets';
        } else if (currentSection === 'currentLiabilities' && /\btotal\b[\s\S]*\bcurrent\s+liab/.test(subLower)) {
          currentSection = 'longTermLiabilities';
        }
        skipped.push({ name: rawName, reason: 'Subtotal', values: monthValues.slice() });
        continue;
      }

      // Default included to true for current assets/liabilities (WC), false for others
      const defaultIncluded = ['currentAssets', 'currentLiabilities'].includes(currentSection);
      
      // Only add if there's a value
      if (rowHasValue) {
        // Deduplicate using parent context from QB hierarchy
        const existingNames = parsed[currentSection].map(r => r.name);
        let finalName = rawName;
        if (existingNames.includes(rawName)) {
          const parentName = parentStack[indentLevel - 1];
          if (parentName && parentName !== rawName) {
            finalName = `${rawName} (${parentName})`;
          }
          if (existingNames.includes(finalName)) {
            let n = 2;
            while (existingNames.includes(`${rawName} (${n})`)) n++;
            finalName = `${rawName} (${n})`;
          }
        }
        parsed[currentSection].push({ name: finalName, monthValues, included: defaultIncluded });
      }
    }

    // Restore rollup candidates whose target section ended up empty.
    // Summary BS exports often list Fixed Assets / Other Assets / Equity as a
    // single line with values and no detail accounts; without this the row
    // would be dropped as a duplicate group header.
    const restoredSections = new Set();
    sectionRollupCandidates.forEach(c => {
      if (parsed[c.section].length === 0 && !restoredSections.has(c.section)) {
        parsed[c.section].push({ name: c.name, monthValues: c.monthValues, included: c.included });
        restoredSections.add(c.section);
      }
    });

    // Verification
    const verification = {};
    Object.entries(parsed).forEach(([section, rows]) => {
      const avg = rows.reduce((sum, r) => {
        const nz = r.monthValues.filter(v => v !== 0);
        return sum + (nz.length > 0 ? nz.reduce((a, b) => a + b, 0) / nz.length : 0);
      }, 0);
      verification[section] = { count: rows.length, avgTotal: avg };
    });
    
    return {
      parsed,
      skipped,
      verification,
      detectedMonths,
      monthColumns,
      totalRows: Object.values(parsed).reduce((sum, arr) => sum + arr.length, 0)
    };
  };
  
  // Apply Full TTM Balance Sheet Paste
  const applyFullTtmBSPaste = () => {
    if (!fullTtmBSPastePreview) return;
    
    try {
      captureUndoState(`Paste Full TTM Balance Sheet${fullTtmBSPasteClearFirst ? ' - Clear & Replace' : ''}`);
      const { parsed } = fullTtmBSPastePreview;
      recordSourceTotals('bs', null, { ['ttmbs:' + ((ttmBsMonthLabels || [])[11] || '')]: stmtPick(fullTtmBSPastePreview.skipped, BS_STMT_KEYS, v => (Array.isArray(v) ? v[11] : 0)) }, false);
      
      const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      
      // Helper to update TTM BS section
      const updateTtmBSSection = (existing, newRows, setter) => {
        let updated = fullTtmBSPasteClearFirst ? [] : [...existing];
        // Rows present before this paste. The fuzzy (normalized) fallback below may
        // only match against THESE — never against rows added during this same paste.
        const preExistingCount = updated.length;

        newRows.forEach(row => {
          // Exact-name match first (handles idempotent re-paste of the same export).
          let matchIdx = updated.findIndex(item => item.name === row.name);
          if (matchIdx === -1) {
            // Fuzzy fallback, restricted to pre-existing rows. QuickBooks splits one
            // account across separator variants — e.g. "11000 - Accounts Receivable"
            // (real balance) and "11000 · Accounts Receivable" (a rounding sub-line) —
            // which normalize identically. Matching a sibling added earlier in THIS
            // paste would let the rounding line clobber the real balance, so the
            // search stops at preExistingCount and the two stay distinct rows.
            const normalizedNew = normalizeForMatch(row.name);
            for (let i = 0; i < preExistingCount; i++) {
              if (normalizeForMatch(updated[i].name || '') === normalizedNew) { matchIdx = i; break; }
            }
          }

          if (matchIdx !== -1) {
            updated[matchIdx] = { ...updated[matchIdx], values: row.monthValues };
          } else {
            updated.push({
              id: Date.now() + Math.random(),
              name: row.name,
              included: row.included,
              values: row.monthValues
            });
          }
        });
        
        setter(updated);
      };
      
      if (parsed.currentAssets.length > 0) updateTtmBSSection(ttmBsCurrentAssets, parsed.currentAssets, setTtmBsCurrentAssets);
      if (parsed.fixedAssets.length > 0) updateTtmBSSection(ttmBsFixedAssets, parsed.fixedAssets, setTtmBsFixedAssets);
      if (parsed.otherAssets.length > 0) updateTtmBSSection(ttmBsOtherAssets, parsed.otherAssets, setTtmBsOtherAssets);
      if (parsed.currentLiabilities.length > 0) updateTtmBSSection(ttmBsCurrentLiabilities, parsed.currentLiabilities, setTtmBsCurrentLiabilities);
      if (parsed.longTermLiabilities.length > 0) updateTtmBSSection(ttmBsLongTermLiabilities, parsed.longTermLiabilities, setTtmBsLongTermLiabilities);
      if (parsed.equity.length > 0) updateTtmBSSection(ttmBsEquity, parsed.equity, setTtmBsEquity);
      
      // Close modal
      setShowFullTtmBSPasteModal(false);
      setFullTtmBSPasteData('');
      setFullTtmBSPastePreview(null);
      
    } catch (error) {
      console.error('Full TTM BS Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // Parse Sales Grid Paste with Smart Year Matching
  const parseSalesGridPaste = () => {
    const existingCustomers = activeSalesData.filter(c => c.name);
    
    // Parse the pasted data
    const lines = salesGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length === 0) return { matched: [], newRows: [], noData: [], parsed: [], yearMatchInfo: [], detectedYears: [] };
    
    // Detect header row and extract year columns
    let dataStartRow = 0;
    let detectedYears = [];
    let headerCells = [];
    let totalColumnIndex = -1; // Track "Total" column for TTM mapping
    
    if (lines.length > 0) {
      headerCells = lines[0].split('\t');
      const firstRowLower = lines[0].toLowerCase();
      
      // Check if first row is a header
      // Enhanced: also detect QB Desktop month-range headers like "Jan - Dec 21"
      const hasMonthRange = /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i.test(lines[0]);
      if (firstRowLower.includes('customer') || firstRowLower.includes('name') || firstRowLower.includes('client') || 
          firstRowLower.includes('year') || /20\d{2}/.test(lines[0]) || firstRowLower.includes('ttm') || 
          firstRowLower.includes('total') || hasMonthRange) {
        dataStartRow = 1;
        
        // If the detected header row has no year columns in positions 1+, scan forward
        // for a row that has multiple year values — common in QB reports with multi-line
        // headers (report title, company name, date range, then actual column headers).
        const headerYearCount = lines[0].split('\t').slice(1).filter(c => /20\d{2}/.test(c.trim())).length;
        if (headerYearCount === 0) {
          for (let hi = 1; hi < Math.min(6, lines.length); hi++) {
            const hiCells = lines[hi].split('\t');
            const hiYearCount = hiCells.slice(1).filter(c => /20\d{2}/.test(c.trim())).length;
            if (hiYearCount >= 2) {
              // This row is the real column header
              headerCells = hiCells;
              dataStartRow = hi + 1;
              break;
            }
          }
        }
        
        // Extract years from header (skip first column which is customer name)
        for (let i = 1; i < headerCells.length; i++) {
          const cell = headerCells[i].trim();
          if (!cell) continue; // Skip empty columns (QB Desktop has gaps)
          // Check for "Total" column - map to TTM
          if (/^total$/i.test(cell)) {
            totalColumnIndex = i;
          }
          // Check for 4-digit year
          else {
            const yearMatch = cell.match(/(20\d{2})/);
            if (yearMatch) {
              detectedYears.push({ col: i, year: yearMatch[1], label: cell });
            } 
            // Check for 2-digit year (QB Desktop: "Jan - Dec 21", "Jan - Dec 22", etc.)
            else {
              const twoDigitMatch = cell.match(/\b(\d{2})\b/);
              if (twoDigitMatch && parseInt(twoDigitMatch[1]) >= 15 && parseInt(twoDigitMatch[1]) <= 40) {
                const fullYear = '20' + twoDigitMatch[1];
                detectedYears.push({ col: i, year: fullYear, label: cell });
              } else if (/ttm|trailing|l12m|ltm/i.test(cell)) {
                detectedYears.push({ col: i, year: 'TTM', label: cell });
              }
            }
          }
        }
      }
    }
    
    // Build year mapping using Smart Year Matching
    // Priority 1: Exact match to existing customerYearLabels
    // Priority 2: Position-based fallback
    const existingYearMap = {
      [customerYearLabels.year1]: 'year1',
      [customerYearLabels.year2]: 'year2',
      [customerYearLabels.year3]: 'year3',
      [customerYearLabels.year4]: 'year4',
      [customerYearLabels.year5]: 'year5',
      'TTM': 'ttm'
    };
    
    const yearMatchInfo = [];
    let columnToYearKey = {}; // Maps column index to yearKey (year1, year2, etc.)
    
    // A monthly TTM report ("Sales by Client" by month) has many SINGLE-month columns
    // — "Feb 2025", "Mar 2025" ... "Jan 2026" — plus a Total. Each month header carries
    // a 4-digit year, so detectedYears counts them as "years"; but they are months, and
    // the Total column holds the real TTM value per client. Distinguish this from a
    // genuine multi-YEAR report (annual columns like "2025", or full-year ranges like
    // "Jan - Dec 25" which carry TWO month tokens, not one).
    const monthTokenCount = (s) => (String(s).match(/\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/gi) || []).length;
    const singleMonthColCount = detectedYears.filter(dy => monthTokenCount(dy.label) === 1).length;
    const isMonthlyTtmReport = singleMonthColCount >= 6; // more than a 5-year grid could hold

    // If we have a Total column, map it to TTM
    if (totalColumnIndex > 0) {
      columnToYearKey[totalColumnIndex] = 'ttm';
      yearMatchInfo.push({
        detected: 'Total',
        label: 'Total',
        mappedTo: 'ttm',
        currentLabel: 'TTM',
        matchType: 'exact'
      });

      if (isMonthlyTtmReport || detectedYears.length <= 1) {
        // TTM report — either a monthly breakdown or a single data column. The Total
        // IS the TTM value; skip the individual month/partial columns so sub-annual
        // data is never imported as years.
        detectedYears.forEach(dy => {
          yearMatchInfo.push({
            detected: dy.year,
            label: dy.label,
            mappedTo: null,
            currentLabel: null,
            matchType: 'skipped',
            warning: isMonthlyTtmReport
              ? `${dy.label} skipped (monthly column — TTM taken from Total)`
              : `${dy.year} skipped (partial year data - use Total for TTM)`
          });
        });
        // Clear detectedYears so no year columns are processed
        detectedYears = [];
      } else if (detectedYears.length >= 2) {
        // Genuine multi-year report: the Total is just a sum of the years — skip it.
        // TTM comes from the TTM Sales tab.
        delete columnToYearKey[totalColumnIndex];
        yearMatchInfo.pop();
        yearMatchInfo.push({ detected: 'Total', label: 'Total', mappedTo: null, currentLabel: null, matchType: 'skipped', warning: 'Total column skipped — sum of years, not TTM. TTM comes from TTM Sales tab.' });
        totalColumnIndex = -1;
      }
      // Otherwise keep detectedYears intact — they'll be mapped below
    }
    
    if (detectedYears.length > 0) {
      // Check for exact matches first
      let hasExactMatches = false;
      detectedYears.forEach(dy => {
        if (existingYearMap[dy.year]) {
          hasExactMatches = true;
        }
      });
      
      // Get existing year values for comparison
      const existingYearValues = [
        { key: 'year1', val: parseInt(customerYearLabels.year1) || 0 },
        { key: 'year2', val: parseInt(customerYearLabels.year2) || 0 },
        { key: 'year3', val: parseInt(customerYearLabels.year3) || 0 },
        { key: 'year4', val: parseInt(customerYearLabels.year4) || 0 },
        { key: 'year5', val: parseInt(customerYearLabels.year5) || 0 }
      ].filter(y => y.val > 0);
      const maxExistingYear = existingYearValues.length > 0 ? Math.max(...existingYearValues.map(y => y.val)) : 0;
      
      if (hasExactMatches) {
        // Use exact matching
        detectedYears.forEach(dy => {
          const yearKey = existingYearMap[dy.year];
          if (yearKey) {
            columnToYearKey[dy.col] = yearKey;
            yearMatchInfo.push({
              detected: dy.year,
              label: dy.label,
              mappedTo: yearKey,
              currentLabel: dy.year === 'TTM' ? 'TTM' : customerYearLabels[yearKey],
              matchType: 'exact'
            });
          } else {
            // Year not in grid - check if it's a future year in a TTM report
            const numericYear = parseInt(dy.year);
            
            // If we have a Total column with only 0-1 year columns (TTM report) AND this year is newer than all existing years,
            // skip mapping it (the Total column will provide the TTM value)
            if (totalColumnIndex > 0 && detectedYears.length <= 1 && numericYear > maxExistingYear) {
              yearMatchInfo.push({
                detected: dy.year,
                label: dy.label,
                mappedTo: null,
                currentLabel: null,
                matchType: 'skipped',
                warning: `${dy.year} partial year data skipped (Total column used for TTM)`
              });
            } else if (numericYear > maxExistingYear) {
              // Newer than all existing, no Total column - map to year5
              columnToYearKey[dy.col] = 'year5';
              yearMatchInfo.push({
                detected: dy.year,
                label: dy.label,
                mappedTo: 'year5',
                currentLabel: customerYearLabels.year5,
                matchType: 'new',
                warning: `Year ${dy.year} not found in grid (currently ${customerYearLabels.year5}) - will overwrite Year 5`
              });
            } else {
              // Older - map to year1
              columnToYearKey[dy.col] = 'year1';
              yearMatchInfo.push({
                detected: dy.year,
                label: dy.label,
                mappedTo: 'year1',
                currentLabel: customerYearLabels.year1,
                matchType: 'new',
                warning: `Year ${dy.year} not found in grid - will overwrite Year 1`
              });
            }
          }
        });
      } else {
        // No exact matches - use position-based mapping
        const numDataCols = detectedYears.length;
        let positionKeys;
        if (numDataCols === 1) {
          positionKeys = ['ttm']; // Single column = TTM
        } else if (numDataCols === 2) {
          // If we have a Total column, these 2 years are partial years - map to year4, year5
          positionKeys = totalColumnIndex > 0 ? ['year4', 'year5'] : ['year5', 'ttm'];
        } else if (numDataCols === 3) {
          positionKeys = ['year3', 'year4', 'year5'];
        } else if (numDataCols === 4) {
          positionKeys = ['year3', 'year4', 'year5', 'ttm'];
        } else if (numDataCols === 5) {
          positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5'];
        } else {
          positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
        }
        
        detectedYears.forEach((dy, idx) => {
          const yearKey = positionKeys[idx] || 'ttm';
          columnToYearKey[dy.col] = yearKey;
          const currentLabel = yearKey === 'ttm' ? 'TTM' : customerYearLabels[yearKey];
          const willOverwrite = dy.year !== 'TTM' && dy.year !== currentLabel;
          yearMatchInfo.push({
            detected: dy.year,
            label: dy.label,
            mappedTo: yearKey,
            currentLabel: currentLabel,
            matchType: 'position',
            warning: willOverwrite ? `Will overwrite ${currentLabel}` : null
          });
        });
      }
    } else if (Object.keys(columnToYearKey).length === 0) {
      // No header AND nothing mapped yet — fall back to column-count position mapping.
      // Guard on the empty mapping so a TTM report (where the Total column was already
      // mapped to 'ttm' and the month/partial columns were intentionally skipped) does
      // NOT get its columns re-mapped to year slots, which would clobber the Total with
      // a single month's value.
      const numDataCols = headerCells.length - 1;
      let positionKeys;
      if (numDataCols === 1) {
        positionKeys = ['ttm']; // Single column = TTM
      } else if (numDataCols === 2) {
        positionKeys = ['year5', 'ttm'];
      } else if (numDataCols === 3) {
        positionKeys = ['year3', 'year4', 'year5'];
      } else if (numDataCols === 4) {
        positionKeys = ['year3', 'year4', 'year5', 'ttm'];
      } else if (numDataCols === 5) {
        positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5'];
      } else {
        positionKeys = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
      }
      
      for (let i = 1; i <= numDataCols && i <= positionKeys.length; i++) {
        columnToYearKey[i] = positionKeys[i - 1];
        yearMatchInfo.push({
          detected: `Column ${i}`,
          label: `Column ${i}`,
          mappedTo: positionKeys[i - 1],
          currentLabel: positionKeys[i - 1] === 'ttm' ? 'TTM' : customerYearLabels[positionKeys[i - 1]],
          matchType: 'assumed'
        });
      }
    }
    
    // Parse data rows
    const parsed = [];
    
    // Detect QB Desktop hierarchical format: cells[0] always empty, names in cells[1-2]
    const sampleDataRows = lines.slice(dataStartRow, Math.min(dataStartRow + 10, lines.length));
    const isQBDesktopHierarchical = sampleDataRows.length > 0 && sampleDataRows.every(line => {
      const cells = line.split('\t');
      return !cells[0].trim() || /^total$/i.test(cells[0].trim());
    });
    
    if (isQBDesktopHierarchical) {
      // QB Desktop Sales by Customer format:
      // - Customer header: name in cells[1], no values (has sub-items below)
      // - Service detail: name in cells[2], values in mapped columns
      // - "Total X" row: "Total CustomerName" in cells[1], values = customer totals
      // - Single-line customer: name in cells[1], values present (no sub-items)
      // - Grand total: "TOTAL" in cells[0]
      //
      // Strategy: Use "Total X" rows for multi-item customers, direct rows for single-line customers.
      // Skip service detail rows since the Sales Grid tracks customer-level data.
      
      // First pass: identify which customers have "Total X" rows (i.e. have sub-items)
      const totalRowCustomers = new Set();
      for (let i = dataStartRow; i < lines.length; i++) {
        const cells = lines[i].split('\t');
        const col1 = (cells[1] || '').trim();
        if (col1.match(/^Total\s+/i) && !col1.match(/^Total$/i)) {
          const custName = col1.replace(/^Total\s+/i, '');
          totalRowCustomers.add(custName.toLowerCase());
        }
      }
      
      // Second pass: extract customer-level data
      for (let i = dataStartRow; i < lines.length; i++) {
        const cells = lines[i].split('\t');
        
        // Skip grand total (TOTAL in cells[0])
        if ((cells[0] || '').trim().toUpperCase() === 'TOTAL') continue;
        
        const col1 = (cells[1] || '').trim();
        const col2 = (cells[2] || '').trim();
        
        // Determine row type and extract name
        let customerName = null;
        
        if (col1) {
          if (col1.match(/^Total\s+/i) && !col1.match(/^Total$/i)) {
            // "Total X" row — this is the customer total for a multi-item customer
            customerName = col1.replace(/^Total\s+/i, '');
          } else if (!totalRowCustomers.has(col1.toLowerCase())) {
            // Name in col1 with no matching "Total" row — single-line customer
            // Check if this row has any values
            let hasVal = false;
            for (const colIdx of Object.keys(columnToYearKey)) {
              const v = (cells[parseInt(colIdx)] || '').replace(/[$,]/g, '').trim();
              if (v && parseFloat(v) !== 0 && !isNaN(parseFloat(v))) { hasVal = true; break; }
            }
            if (hasVal) {
              customerName = col1;
            }
            // If no values, this is a customer header for sub-items — skip
          }
          // If col1 matches a known total-row customer but doesn't start with "Total",
          // it's the header row — skip it
        }
        // else if col2 has text: service detail row — skip
        
        if (!customerName) continue;
        
        // Skip summary labels
        if (/grand\s*total/i.test(customerName) || /^all$/i.test(customerName) || /^summary$/i.test(customerName)) continue;
        
        const yearValues = { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
        
        // Apply column mappings
        for (let colIdx = 1; colIdx < cells.length; colIdx++) {
          const yearKey = columnToYearKey[colIdx];
          if (yearKey) {
            let val = cells[colIdx] || '';
            val = val.replace(/[$,]/g, '').trim();
            if (val.startsWith('(') && val.endsWith(')')) {
              val = '-' + val.slice(1, -1);
            }
            const num = parseFloat(val);
            yearValues[yearKey] = isNaN(num) ? 0 : num; // Allow negative values (refunds, credits)
          }
        }
        
        parsed.push({ name: customerName, yearValues, originalRow: lines[i] });
      }
    } else {
      // Standard format: customer name in cells[0]
      // DETECT: Does this data have "Total for X" rows? (indicates sub-item detail per client)
      const totalForCustomers = new Map(); // Maps normalized customer name → "Total for" row text
      for (let i = dataStartRow; i < lines.length; i++) {
        const cells = lines[i].split('\t');
        const name = (cells[0] || '').trim();
        const totalMatch = name.match(/^Total\s+(?:for\s+)?(.+)/i);
        if (totalMatch) {
          const custName = totalMatch[1].trim();
          totalForCustomers.set(custName.toLowerCase(), custName);
        }
      }
      // A real QB subtotal row ("Total X") only exists when its bare parent
      // header row "X" is ALSO in the paste — QB always prints the parent line
      // above the sub-items. A customer merely NAMED "Total X" has no parent
      // row: it's a company (real MSPs are named "Total Computer Solutions",
      // "Total Cover IT"…) and must parse as a customer, under its full name.
      // Without this check, such names flipped the whole paste into sub-item
      // mode and its SERVICE/CONTRACT skip dropped real customers
      // (CyberGuard360, 2026-07-24: "Service Provider Partners" $869 — the
      // 2022-only discrepancy Konnie chased).
      {
        const bareNames = new Set();
        for (let i = dataStartRow; i < lines.length; i++) {
          const nm = ((lines[i].split('\t'))[0] || '').trim();
          if (nm && !/^Total\s+/i.test(nm)) bareNames.add(nm.toLowerCase());
        }
        for (const key of [...totalForCustomers.keys()]) {
          if (!bareNames.has(key)) totalForCustomers.delete(key);
        }
      }
      
      const hasSubItemFormat = totalForCustomers.size > 0;
      let skipUntilTotalFor = null; // Track when we're inside a sub-item group
      // Normalized full names of clients that have a "Total for" row — used to catch
      // sub-item rows ("<Client> - Contract", "<Client>-HW.SW", "<Client> - Project …")
      // when the client has NO bare-name parent line to trigger the skip below.
      const normLocal = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const totalForNormList = [...totalForCustomers.keys()].map(normLocal).filter(Boolean);
      
      for (let i = dataStartRow; i < lines.length; i++) {
        const cells = lines[i].split('\t');
        if (cells.length < 2) continue;
        
        const name = cells[0].trim();
        if (!name) continue;
        
        // Check if this is a "Total for X" row
        const totalMatch = name.match(/^Total\s+(?:for\s+)?(.+)/i);

        if (totalMatch && (
          /grand\s*total/i.test(totalMatch[1]) || /^all$/i.test(totalMatch[1].trim()) ||
          /^(income|revenue|expense|cost|operating)/i.test(totalMatch[1].trim())
        )) continue; // grand total / section totals — never customers

        if (totalMatch && totalForCustomers.has(totalMatch[1].trim().toLowerCase())) {
          const custName = totalMatch[1].trim();

          // Skip intermediate subtotals inside a parent group
          if (skipUntilTotalFor && custName.toLowerCase() !== skipUntilTotalFor) continue;

          // This is a client total — use it
          skipUntilTotalFor = null; // Reset the skip tracker
          
          const yearValues = { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
          for (let colIdx = 1; colIdx < cells.length; colIdx++) {
            const yearKey = columnToYearKey[colIdx];
            if (yearKey) {
              let val = cells[colIdx] || '';
              val = val.replace(/[$,]/g, '').trim();
              if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
              const num = parseFloat(val);
              yearValues[yearKey] = isNaN(num) ? 0 : num;
            }
          }
          
          parsed.push({ name: custName, yearValues, originalRow: lines[i] });
          continue;
        }
        
        // Not a Total row — check if we should skip (sub-item of a client with a Total row)
        if (hasSubItemFormat) {
          // Skip generic sub-item labels — EXACT labels only. A prefix test
          // dropped real customers ("Service Provider Partners", "Service By
          // George" — CyberGuard360 2026-07-24); QB's generic sub-item rows
          // are the bare label, not a phrase starting with it.
          if (/^(CONTRACT|HW[./]SW|HW\.SW|PROJECT|SERVICE)\s*:?\s*$/i.test(name)) continue;
          
          // Check if this name matches a customer that has a "Total for" row
          const nameLower = name.toLowerCase();
          let isSubItem = false;
          
          if (skipUntilTotalFor) {
            // We're inside a sub-item group — skip until we hit the matching Total
            isSubItem = true;
          } else {
            // Check if any "Total for" customer name exactly matches this name (case-insensitive).
            // Exact match only — prefix matching caused false positives where customers sharing
            // a common word (e.g. "American Luxury Limosines" matching "American Gunsmithing Institute"
            // via the shared "american" prefix) locked skipUntilTotalFor permanently after the
            // real Total for row had already been processed.
            let exactMatch = null;
            for (const [totalNameLower] of totalForCustomers) {
              if (totalNameLower === nameLower) {
                exactMatch = totalNameLower;
                break;
              }
            }
            const matchedTotal = exactMatch;
            if (matchedTotal) {
              skipUntilTotalFor = matchedTotal;
              isSubItem = true;
            } else {
              // No bare-name parent triggered the skip. Detect a sub-item directly:
              // its normalized name begins with a Total-for client's FULL normalized
              // name and is strictly longer (i.e. "<Client><suffix>"). Full-name (not
              // shared-word) matching avoids the "American …" false positives; the
              // client's own value comes from its "Total for" row, so the sub-item is
              // dropped. Not setting skipUntilTotalFor keeps each row evaluated on its
              // own, so a genuine standalone client is never swallowed by a group.
              // Require a dash in the row (QB sub-items are "<Client> - Type" / "<Client>-Type")
              // so a dash-less standalone client whose name merely starts with a multi-item
              // client's name (e.g. "Acme Trucking" vs "Acme") is never falsely dropped.
              const rowNorm = normLocal(name);
              const isSub = /[-–]/.test(name) && totalForNormList.some(tn =>
                rowNorm.length > tn.length && rowNorm.startsWith(tn));
              if (isSub) isSubItem = true;
            }
          }

          if (isSubItem) continue;
        }
        
        // Skip explicit total/summary rows (no sub-item format)
        if (/grand\s*total/i.test(name) || /^all$/i.test(name) || /^summary$/i.test(name) || /^total$/i.test(name)) continue;
        // Skip footer lines (date stamps, report metadata)
        if (/\b(basis|monday|tuesday|wednesday|thursday|friday|saturday|sunday)\b.*\d{4}/i.test(name)) continue;
        // Skip rows that are pure totals (start with "Total" then whitespace then something, or "Total (USD)" etc.)
        // BUT preserve real customer names that happen to start with "Total" like "Total Highspeed"
        // Rule: skip if "Total" is followed by a non-alpha character or is the whole word at end
        // e.g. skip "Total (USD)", "Total Revenue", but keep "Total Highspeed", "Total Network Services"
        if (!hasSubItemFormat && /^total\b/i.test(name) && !/^total\b\s+(?!for\b)[a-zA-Z]/i.test(name)) continue;
        const yearValues = { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
        for (let colIdx = 1; colIdx < cells.length; colIdx++) {
          const yearKey = columnToYearKey[colIdx];
          if (yearKey) {
            let val = cells[colIdx] || '';
            val = val.replace(/[$,]/g, '').trim();
            if (val.startsWith('(') && val.endsWith(')')) val = '-' + val.slice(1, -1);
            const num = parseFloat(val);
            yearValues[yearKey] = isNaN(num) ? 0 : num;
          }
        }
        
        parsed.push({ name, yearValues, originalRow: lines[i] });
      }
    }
    
    // Match parsed rows to existing customers
    const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    
    const matched = [];
    const newRows = [];
    const matchedExistingIds = new Set();
    
    parsed.forEach(row => {
      let match = existingCustomers.find(c => c.name === row.name);
      if (!match) {
        const normalizedPasted = normalizeForMatch(row.name);
        match = existingCustomers.find(c => normalizeForMatch(c.name) === normalizedPasted);
      }
      // Removed aggressive substring matching that caused false positives
      // (e.g., "DREAM Charter School" incorrectly matching "American Dream Charter School")
      
      if (match && !matchedExistingIds.has(match.id)) {
        matched.push({ ...row, matchedTo: match, matchType: row.name === match.name ? 'exact' : 'fuzzy' });
        matchedExistingIds.add(match.id);
      } else if (match && matchedExistingIds.has(match.id)) {
        // Match already used by another row - treat this as a new row instead of silently dropping
        newRows.push(row);
      } else if (!match) {
        newRows.push(row);
      }
    });
    
    const noData = existingCustomers.filter(c => !matchedExistingIds.has(c.id));
    
    return { matched, newRows, noData, parsed, yearMatchInfo, detectedYears };
  };
  
  // Apply Sales Grid Paste
  const applySalesGridPaste = () => {
    if (!salesGridPastePreview) return;
    
    try {
      captureUndoState('Paste Grid Sales');
      
      if (salesGridClearReplace) {
        // Clear & Replace mode: wipe existing data, only use pasted rows
        const allPastedRows = [...salesGridPastePreview.matched, ...salesGridPastePreview.newRows];
        const freshCustomers = allPastedRows.map((row, idx) => ({
          id: idx + 1,
          name: row.name,
          year1: row.yearValues.year1 || 0,
          year2: row.yearValues.year2 || 0,
          year3: row.yearValues.year3 || 0,
          year4: row.yearValues.year4 || 0,
          year5: row.yearValues.year5 || 0,
          ttm: row.yearValues.ttm || 0,
          hasContract: false, contractStart: '', contractEnd: '', autoRenewal: false,
          assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
          billingFrequency: '', tenure: '', industry: '', endpoints: 0, customerType: '', atRisk: false, lost: false, notes: ''
        }));
        setActiveSalesData(deduplicateCustomers(freshCustomers));
      } else if (salesGridClearTtmOnly) {
        // Clear Annual Only mode: zero year1-5 on all existing customers, preserve TTM
        // TTM is owned by the TTM Sales Entry tab — annual paste must not touch it
        let updatedCustomers = activeSalesData.map(c => ({ ...c, year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 }));

        // Apply annual columns from matched rows (TTM left untouched)
        salesGridPastePreview.matched.forEach(row => {
          const idx = updatedCustomers.findIndex(c => c.id === row.matchedTo.id);
          if (idx !== -1) {
            updatedCustomers[idx] = {
              ...updatedCustomers[idx],
              year1: row.yearValues.year1 || 0,
              year2: row.yearValues.year2 || 0,
              year3: row.yearValues.year3 || 0,
              year4: row.yearValues.year4 || 0,
              year5: row.yearValues.year5 || 0
            };
          }
        });

        // Add new customers from paste (TTM only — year values included if present)
        salesGridPastePreview.newRows.forEach(row => {
          const maxId = Math.max(...updatedCustomers.map(c => c.id), 0);
          updatedCustomers.push({
            id: maxId + 1,
            name: row.name,
            year1: row.yearValues.year1 || 0,
            year2: row.yearValues.year2 || 0,
            year3: row.yearValues.year3 || 0,
            year4: row.yearValues.year4 || 0,
            year5: row.yearValues.year5 || 0,
            ttm: row.yearValues.ttm || 0,
            hasContract: false, contractStart: '', contractEnd: '', autoRenewal: false,
            assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
            billingFrequency: '', tenure: '', industry: '', endpoints: 0, customerType: '', atRisk: false, lost: false, notes: ''
          });
        });

        setActiveSalesData(updatedCustomers);
      } else {
        // Default merge mode
        let updatedCustomers = activeSalesData.map(c => ({ ...c }));
      
      // Update matched rows
      salesGridPastePreview.matched.forEach(row => {
        const idx = updatedCustomers.findIndex(c => c.id === row.matchedTo.id);
        if (idx !== -1) {
          updatedCustomers[idx] = {
            ...updatedCustomers[idx],
            year1: row.yearValues.year1 || updatedCustomers[idx].year1,
            year2: row.yearValues.year2 || updatedCustomers[idx].year2,
            year3: row.yearValues.year3 || updatedCustomers[idx].year3,
            year4: row.yearValues.year4 || updatedCustomers[idx].year4,
            year5: row.yearValues.year5 || updatedCustomers[idx].year5,
            ttm: row.yearValues.ttm || updatedCustomers[idx].ttm
          };
        }
      });
      
      // Add new rows
      salesGridPastePreview.newRows.forEach(row => {
        const maxId = Math.max(...updatedCustomers.map(c => c.id), 0);
        updatedCustomers.push({
          id: maxId + 1,
          name: row.name,
          year1: row.yearValues.year1,
          year2: row.yearValues.year2,
          year3: row.yearValues.year3,
          year4: row.yearValues.year4,
          year5: row.yearValues.year5,
          ttm: row.yearValues.ttm,
          hasContract: false, contractStart: '', contractEnd: '', autoRenewal: false,
          assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
          billingFrequency: '', tenure: '', industry: '', endpoints: 0, customerType: '', atRisk: false, lost: false, notes: ''
        });
      });
      
      setActiveSalesData(updatedCustomers);
      } // end merge mode
      
      // Auto-update year labels if detected years differ from current labels
      if (salesGridPastePreview.yearMatchInfo && salesGridPastePreview.yearMatchInfo.length > 0) {
        const newLabels = { ...customerYearLabels };
        let labelsChanged = false;
        
        salesGridPastePreview.yearMatchInfo.forEach(info => {
          if (info.detected && info.detected !== 'TTM' && info.mappedTo !== 'ttm') {
            const yearMatch = info.detected.match(/20\d{2}/);
            if (yearMatch && newLabels[info.mappedTo] !== yearMatch[0]) {
              newLabels[info.mappedTo] = yearMatch[0];
              labelsChanged = true;
            }
          }
        });
        
        if (labelsChanged) {
          setCustomerYearLabels(newLabels);
        }
      }
      
      // Close modal and reset
      setShowSalesGridPasteModal(false);
      setSalesGridPasteData('');
      setSalesGridPastePreview(null);
      setSalesGridClearReplace(false);
      setSalesGridClearTtmOnly(false);
      
    } catch (error) {
      console.error('Sales Grid Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // ========== MONTHLY SALES PASTE PARSER ==========
  // QB SUMMARY ROWS SAY "X Total" (Konnie 09-11→09-14, Assura/DSO: her
  // roster came from the annual QB report whose rows read "Aterra
  // Solutions, LLC Total" while the monthly TTM export says "Aterra
  // Solutions, LLC" — every name differed by one word, 0 of 27 matched,
  // and the empty-roster fallback rightly never fired because both
  // rosters were full). The matcher's normalize now strips a trailing
  // "Total" on BOTH sides before comparing.
  const parseMonthlySalesPaste = () => {
    const lines = monthlySalesPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
    const nonEmpty = lines.filter(l => l.trim());
    if (nonEmpty.length === 0) return null;

    // Trailing "Total" stripped for MATCHING only — stored names unchanged.
    const normalize = (s) => (s || '').toLowerCase().replace(/\s+total\s*$/i, '').replace(/[^a-z0-9]/g, '');

    // Detect header row — find first row with 3+ cells containing month-like text
    const monthPat = /\b(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|june?|july?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\b/i;
    // Also detect YYYY-MM format (e.g. "2025-03")
    const isYyyyMm = (s) => /^20\d{2}-(0[1-9]|1[0-2])$/.test((s || '').trim());
    let headerIdx = -1;
    let monthColumns = {}; // colIdx → monthSlot 0-11

    for (let r = 0; r < Math.min(8, nonEmpty.length); r++) {
      const cells = nonEmpty[r].split('\t');
      const monthCells = cells.filter((c, i) => i > 0 && (monthPat.test(c) || isYyyyMm(c)));
      if (monthCells.length >= 3) {
        headerIdx = r;
        const detected = [];
        const monthNames = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
        const fullMonthPat = /\b(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|june?|july?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\b/i;
        cells.forEach((cell, idx) => {
          if (idx === 0) return;
          const trimmed = cell.trim();
          // Handle YYYY-MM format (e.g. "2025-03") explicitly
          const yyyyMmMatch = trimmed.match(/^(20\d{2})-(0[1-9]|1[0-2])$/);
          if (yyyyMmMatch) {
            const year = parseInt(yyyyMmMatch[1]);
            const monthIdx = parseInt(yyyyMmMatch[2]) - 1; // 0-indexed
            detected.push({ idx, label: trimmed, month: monthIdx, year });
            return;
          }
          if (!monthPat.test(trimmed) && !/\d{2,4}/.test(trimmed)) return;
          // Parse month and year from cell label
          // Handle both 4-digit (2025) and 2-digit (25) year formats
          const yearMatch4 = trimmed.match(/\b(20\d{2})\b/);
          const yearMatch2 = trimmed.match(/\b(\d{2})\b/);
          const monMatch = trimmed.match(fullMonthPat);
          let monthIdx = -1;
          if (monMatch) {
            const m = monMatch[1].toLowerCase().substring(0, 3);
            monthIdx = monthNames.indexOf(m);
          }
          let year = null;
          if (yearMatch4) {
            year = parseInt(yearMatch4[1]);
          } else if (yearMatch2) {
            // 2-digit year: assume 2000s (e.g. "25" → 2025)
            year = 2000 + parseInt(yearMatch2[1]);
          }
          detected.push({ idx, label: trimmed, month: monthIdx, year });
        });
        
        // A monthly report already defines its own TTM period. Use the most recent 12
        // month columns PRESENT IN THE REPORT — do NOT filter against the tool's
        // configured TTM window (salesTtmConfig). A stale/mismatched config would
        // silently drop the report's months and understate every customer's total.
        // A longer report (e.g. 24 months) still yields its latest 12; a shorter one
        // (e.g. a partial year) uses whatever months it has. Columns whose month/year
        // couldn't be parsed (e.g. a "Total" column) are excluded.
        const dated = detected.filter(d => d.month >= 0 && d.year !== null);
        dated.sort((a, b) => (a.year !== b.year ? a.year - b.year : a.month - b.month));
        const take = dated.length > 12 ? dated.slice(-12) : dated;
        take.forEach((d, slot) => { monthColumns[d.idx] = slot; });
        break;
      }
    }

    if (headerIdx === -1 || Object.keys(monthColumns).length === 0) {
      return { error: 'Could not detect month columns. Paste the full monthly report with month headers.' };
    }

    // Detect QB two-column format: header has "Customer ID" in col 1 (col 0 = "Customer", blank in data rows)
    // QB Online/export sometimes splits customer name and ID into two columns
    const headerCells = nonEmpty[headerIdx].split('\t');
    const isTwoColumnQB = /customer\s*id/i.test(headerCells[1] || '');

    // Detect QB Desktop sub-item format: col 0 is always empty, names in col 1
    // (only fires when NOT the two-column format)
    const sampleRows = nonEmpty.slice(headerIdx + 1, Math.min(headerIdx + 10, nonEmpty.length));
    const isQBDesktop = !isTwoColumnQB && sampleRows.length > 0 && sampleRows.every(line => {
      const cells = line.split('\t');
      return !cells[0].trim();
    });

    const detectedMonthCount = Object.keys(monthColumns).length;
    const parsed = [];

    // Helper to read month values for a row using the monthColumns mapping
    const readMonthValues = (cells) => {
      const monthValues = Array(12).fill(0);
      let hasValue = false;
      Object.entries(monthColumns).forEach(([colIdx, slot]) => {
        const ci = parseInt(colIdx);
        if (ci < cells.length) {
          let v = (cells[ci] || '').replace(/[$,]/g, '').trim();
          if (v.startsWith('(') && v.endsWith(')')) v = '-' + v.slice(1, -1);
          const num = parseFloat(v) || 0;
          monthValues[slot] = num;
          if (num !== 0) hasValue = true;
        }
      });
      return { monthValues, hasValue };
    };

    if (isTwoColumnQB) {
      // QB two-column format: col0 = Customer (company name, may be blank), col1 = Customer ID
      // Month data starts at col2 (monthColumns already mapped correctly from header detection)
      // Use col1 as the customer name — it holds the actual identifier
      for (let r = headerIdx + 1; r < nonEmpty.length; r++) {
        const cells = nonEmpty[r].split('\t');
        const rawName = (cells[1] || '').trim(); // Customer ID column
        if (!rawName) continue;
        if (/^total\b|^grand\s*total|^net\s|^subtotal/i.test(rawName)) continue;
        const { monthValues, hasValue } = readMonthValues(cells);
        if (hasValue) {
          // The report's own summary row ("TOTAL" / "Grand Total") is not a
          // customer — without this it becomes one, carrying the whole TTM.
          if (/^(grand\s+)?total$/i.test(rawName.trim())) continue;
          parsed.push({ name: rawName, monthValues, ttmTotal: monthValues.reduce((s, v) => s + v, 0) });
        }
      }
    } else if (isQBDesktop) {
      // QB Desktop format: col 1 = customer name or "Total X", col 2 = sub-service detail (text only)
      // Strategy: use "Total X" rows for customers with sub-items, direct rows otherwise
      // Build set of customers that have "Total X" rows
      const totalRowCustomers = new Set();
      for (let r = headerIdx + 1; r < nonEmpty.length; r++) {
        const cells = nonEmpty[r].split('\t');
        const col1 = (cells[1] || '').trim();
        const totalMatch = col1.match(/^Total\s+(.+)/i);
        if (totalMatch) totalRowCustomers.add(totalMatch[1].trim().toLowerCase());
      }

      for (let r = headerIdx + 1; r < nonEmpty.length; r++) {
        const cells = nonEmpty[r].split('\t');
        const col1 = (cells[1] || '').trim();
        const col2 = (cells[2] || '').trim();

        if (!col1) continue; // blank row
        if (/^grand\s*total/i.test(col1) || /^total$/i.test(col1)) continue;

        // "Total X" row — customer total
        const totalMatch = col1.match(/^Total\s+(.+)/i);
        if (totalMatch) {
          const custName = totalMatch[1].trim();
          if (/^(income|expense|revenue|cost)/i.test(custName)) continue; // section total
          const { monthValues, hasValue } = readMonthValues(cells);
          if (hasValue || monthValues.some(v => v !== 0)) {
            parsed.push({ name: custName, monthValues, ttmTotal: monthValues.reduce((s, v) => s + v, 0) });
          }
          continue;
        }

        // Sub-service detail row: col2 must be NON-NUMERIC text (a service/item name)
        // If col2 is a number it's the first month value, not a sub-item label
        const col2IsText = col2 && isNaN(parseFloat(col2.replace(/[$,]/g, '')));
        if (col2IsText) continue;

        // Direct single-line customer (no "Total" row for this customer)
        if (!totalRowCustomers.has(col1.toLowerCase())) {
          const { monthValues, hasValue } = readMonthValues(cells);
          if (hasValue) {
            parsed.push({ name: col1, monthValues, ttmTotal: monthValues.reduce((s, v) => s + v, 0) });
          }
        }
        // else: parent header row for a customer with sub-items — skip, wait for Total row
      }
    } else {
      // Standard format: name in col 0
      // First pass: detect "Total for X" rows so we can collapse sub-items into parent clients
      // This mirrors the annual paste logic — e.g. "Chemical Abstracts Service" sub-items
      // get collapsed into a single "Chemical Abstracts Service" row using the "Total for" row
      const totalForCustomersMonthly = new Map(); // normalized name → original name
      for (let r = headerIdx + 1; r < nonEmpty.length; r++) {
        const cells = nonEmpty[r].split('\t');
        const name = (cells[0] || '').trim();
        const totalMatch = name.match(/^Total\s+(?:for\s+)?(.+)/i);
        if (totalMatch) {
          const custName = totalMatch[1].trim();
          if (!/^(grand\s*total|all$|income|revenue|expense|cost|operating)/i.test(custName)) {
            totalForCustomersMonthly.set(custName.toLowerCase(), custName);
          }
        }
      }
      // Same discriminator as the annual paste: a real QB subtotal only exists
      // when its bare parent row is also present. A customer NAMED "Total X"
      // (Total Guard Cyber Security) must keep its full name — renaming it
      // broke the name-sync to the Sales tab. (CyberGuard360, 2026-07-24)
      {
        const bareNamesMonthly = new Set();
        for (let r = headerIdx + 1; r < nonEmpty.length; r++) {
          const nm = ((nonEmpty[r].split('\t'))[0] || '').trim();
          if (nm && !/^Total\s+/i.test(nm)) bareNamesMonthly.add(nm.toLowerCase());
        }
        for (const key of [...totalForCustomersMonthly.keys()]) {
          if (!bareNamesMonthly.has(key)) totalForCustomersMonthly.delete(key);
        }
      }
      const hasSubItemFormatMonthly = totalForCustomersMonthly.size > 0;
      let skipUntilTotalForMonthly = null;
      // A group whose "Total for" row has been consumed can never re-arm the
      // skip (Konnie 09-25, Dem360: QuickBooks printed a stray "Trulieve -
      // Lorain, OH" AFTER "Total for Trulieve"; the 8-letter prefix match
      // read it as a new Trulieve parent and skipped every customer after it
      // — Vidi through Zips, the "last 10 clients" — waiting for a total that
      // never came). Exact match only, same lesson the annual paste learned
      // on 07-24; a row after its group is a customer in its own right.
      const consumedTotalsMonthly = new Set();

      for (let r = headerIdx + 1; r < nonEmpty.length; r++) {
        const cells = nonEmpty[r].split('\t');
        const rawName = (cells[0] || '').trim();
        if (!rawName) continue;
        // Skip summary/total rows — but preserve customer names like "Total Highspeed", "Total Network Services"
        // Rule: skip if "total" alone, "grand total", or followed by non-letter (parens, colon etc.)
        // Keep: "Total Highspeed" — "for" excluded via negative lookahead
        // "Net …" must name a SUMMARY CONCEPT to be skipped — a bare /^net\s/
        // dropped real customers ("Net Effects, LLC" at $199/mo was the whole
        // ~$200/month TTM discrepancy on CyberGuard360, 2026-07-24).
        if (/^grand total|^net\s+(income|revenue|sales|profit|total)\b|^subtotal/i.test(rawName)) continue;

        // Handle "Total for X" rows — use as the canonical value for multi-item clients
        const totalMatchMonthly = rawName.match(/^Total\s+(?:for\s+)?(.+)/i);
        if (totalMatchMonthly && /^(grand\s*total|all$)/i.test(totalMatchMonthly[1].trim())) continue;
        if (totalMatchMonthly && totalForCustomersMonthly.has(totalMatchMonthly[1].trim().toLowerCase())) {
          const custName = totalMatchMonthly[1].trim();
          // If we were skipping sub-items for this client, this is the payoff row
          if (skipUntilTotalForMonthly && custName.toLowerCase() !== skipUntilTotalForMonthly) continue;
          skipUntilTotalForMonthly = null;
          consumedTotalsMonthly.add(custName.toLowerCase());
          // Read monthly values from this total row
          const monthValues = Array(12).fill(0);
          let hasValue = false;
          Object.entries(monthColumns).forEach(([colIdx, slot]) => {
            const c = parseInt(colIdx);
            if (c < cells.length) {
              let v = (cells[c] || '').replace(/[$,]/g, '').trim();
              if (v.startsWith('(') && v.endsWith(')')) v = '-' + v.slice(1, -1);
              const num = parseFloat(v) || 0;
              monthValues[slot] = num;
              if (num !== 0) hasValue = true;
            }
          });
          if (hasValue) {
            parsed.push({ name: custName, monthValues, ttmTotal: monthValues.reduce((s, v) => s + v, 0) });
          }
          continue;
        }

        // If currently skipping sub-items, continue until we hit the Total row
        if (skipUntilTotalForMonthly) continue;

        // Skip non-Total rows that start with "total" (e.g. "Total (USD)")
        if (/^total\b/i.test(rawName) && !/^total\b\s+(?!for\b)[a-zA-Z]/i.test(rawName)) continue;

        // Check if this is a parent header for a multi-item client
        if (hasSubItemFormatMonthly) {
          const nameLower = rawName.toLowerCase();
          let exactMatch = null;
          for (const [totalNameLower] of totalForCustomersMonthly) {
            if (totalNameLower === nameLower) { exactMatch = totalNameLower; break; }
          }
          const matchedTotal = exactMatch && !consumedTotalsMonthly.has(exactMatch) ? exactMatch : null;
          if (matchedTotal) {
            skipUntilTotalForMonthly = matchedTotal;
            continue; // Skip the parent header, wait for Total row
          }
          // A row after its group's total ("Trulieve - Lorain, OH", $970) is a
          // REAL customer outside the group — its revenue is not in the
          // total. It parses on its own; nothing here drops it.
        }

        const monthValues = Array(12).fill(0);
        let hasValue = false;
        Object.entries(monthColumns).forEach(([colIdx, slot]) => {
          const c = parseInt(colIdx);
          if (c < cells.length) {
            let v = (cells[c] || '').replace(/[$,]/g, '').trim();
            if (v.startsWith('(') && v.endsWith(')')) v = '-' + v.slice(1, -1);
            const num = parseFloat(v) || 0;
            monthValues[slot] = num;
            if (num !== 0) hasValue = true;
          }
        });
        if (hasValue) {
          // The report's own summary row ("TOTAL" / "Grand Total") is not a
          // customer — without this it becomes one, carrying the whole TTM.
          if (/^(grand\s+)?total$/i.test(rawName.trim())) continue;
          parsed.push({ name: rawName, monthValues, ttmTotal: monthValues.reduce((s, v) => s + v, 0) });
        }
      }
    }

    // Match against existing customers
    // Track matched IDs so duplicate-named customers (e.g. same name different case)
    // each get their own match rather than both hitting the same existing row
    // Match against the roster for the basis being PASTED (salesTtmConfig.basis), not the
    // valuation-basis roster. applyMonthlySalesPaste writes to the salesTtmConfig.basis array,
    // so matching must read the same array — otherwise pasting a Cash report while the
    // valuation basis is Accrual checks against the wrong roster and flags real customers as
    // "new" (and keys their monthly data to the wrong basis's IDs).
    const pasteBasis = salesTtmConfig?.basis || 'cash';
    // FALL TO THE OTHER BASIS when the paste-basis roster is EMPTY (Konnie
    // 09-11, Assura: the accrual TTM-by-client paste created all 28
    // customers as NEW rows — her roster lived entirely on the cash side,
    // so matching against the empty accrual array missed everyone. Same
    // rule the annual grid paste gained 08-18; this modal never got it.)
    // The monthly data still stores under the PASTED basis key — only the
    // roster we match/create against falls through.
    const pasteRosterRaw = pasteBasis === 'cash' ? customerSalesCash : customerSalesAccrual;
    const rosterHasClients = pasteRosterRaw.some(c => c.name && c.name.trim());
    const effRosterIsCash = rosterHasClients ? (pasteBasis === 'cash') : (pasteBasis !== 'cash');
    const existing = (effRosterIsCash ? customerSalesCash : customerSalesAccrual).filter(c => c.name);
    const matched = [];
    const newCustomers = [];
    const matchedExistingIds = new Set();

    parsed.forEach(row => {
      const normRow = normalize(row.name);
      // Exact normalized match only — no substring/partial matching.
      // Substring matching caused false positives where one customer's normalized name is a
      // substring of another's (e.g. "Customer 1" ⊂ "Customer 149"), silently merging a real
      // customer's monthly data into the wrong row so it appeared "skipped". The collision
      // varied by basis because the cash and accrual rosters differ. This mirrors the annual
      // Sales paste (findCustomerIndex), which also matches on exact normalized name only.
      const match = existing.find(c => !matchedExistingIds.has(c.id) && normalize(c.name) === normRow);
      if (match) {
        matchedExistingIds.add(match.id);
        matched.push({ ...row, customerId: match.id, matchedName: match.name });
      } else {
        newCustomers.push(row);
      }
    });

    const ttmTotal = parsed.reduce((s, r) => s + r.ttmTotal, 0);

    return {
      parsed, matched, newCustomers, unmatched: [],
      detectedMonthCount,
      ttmTotal,
      monthColumns
    };
  };

  // Apply Monthly Sales Paste
  // Deduplicate customer sales list — merges rows with the same CUST-XXX base number.
  // Happens after any paste and on JSON load. Keeps the row with the most complete name,
  // merges year1-5 and ttm across duplicates (taking max for each field).
  const deduplicateCustomers = (customers) => {
    const normalize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    // Extract CUST-XXX base (first CUST-NNN portion, ignoring suffix like "-Customer Name Change")
    const custBase = (name) => {
      const m = (name || '').match(/^(cust[-]?\d+)/i);
      return m ? m[1].toUpperCase().replace(/\s/g, '').replace(/-/g, '-') : null;
    };

    const grouped = new Map(); // base → [customer, ...]
    const noBase = [];
    customers.forEach(c => {
      const base = custBase(c.name);
      if (!base) { noBase.push(c); return; }
      if (!grouped.has(base)) grouped.set(base, []);
      grouped.get(base).push(c);
    });

    const merged = [];
    grouped.forEach((group, base) => {
      if (group.length === 1) { merged.push(group[0]); return; }
      // Multiple rows for same CUST-XXX — merge them
      // Primary: prefer the clean exact name (shortest / no suffix), then most data
      group.sort((a, b) => {
        const aClean = (a.name || '').match(/^CUST-\d+$/i) ? 0 : 1;
        const bClean = (b.name || '').match(/^CUST-\d+$/i) ? 0 : 1;
        if (aClean !== bClean) return aClean - bClean;
        // Prefer row with more non-zero data
        const aData = ['year1','year2','year3','year4','year5','ttm'].filter(k => (a[k] || 0) !== 0).length;
        const bData = ['year1','year2','year3','year4','year5','ttm'].filter(k => (b[k] || 0) !== 0).length;
        return bData - aData;
      });
      const primary = { ...group[0] };
      // Merge data from all duplicates — take max non-zero value for each year/ttm field
      ['year1','year2','year3','year4','year5','ttm','ttmCash','ttmAccrual'].forEach(field => {
        const best = Math.max(...group.map(c => c[field] || 0));
        if (best !== 0) primary[field] = best;
      });
      // Preserve owner-set status/contract flags across duplicates — if ANY row in
      // the group has the flag set, keep it. Without this, a flag set on a non-primary
      // row (e.g. a renamed "CUST-001-..." duplicate) was silently dropped on every
      // load, making a Lost client appear to revert. (Colleen, 2026-06)
      ['lost','atRisk','hasContract','autoRenewal','assignable','priceEscalator','earlyTermPenalty'].forEach(field => {
        if (group.some(c => c[field])) primary[field] = true;
      });
      // Backfill scalar metadata the primary is missing from any duplicate that has it.
      ['customerType','billingFrequency','tenure','industry','endpoints','contractMonths','renewedContractMonths','effectiveDate','contractStart','contractEnd','escalatorPercent','notes'].forEach(field => {
        if (primary[field] === undefined || primary[field] === null || primary[field] === '' || primary[field] === 0) {
          const found = group.find(c => c[field] !== undefined && c[field] !== null && c[field] !== '' && c[field] !== 0);
          if (found) primary[field] = found[field];
        }
      });
      merged.push(primary);
    });

    const result = [...merged, ...noBase];

    // De-collide IDs: two customers must never share an id. Monthly sales data is
    // keyed by customer id, so a collision makes one customer's pasted TTM bleed into
    // the other — e.g. Doug Carr (id 50) and Petra Title (id 50) on the accrual roster,
    // where pasting Doug's report also populated Petra (who isn't even in the report),
    // throwing the accrual total off by Doug's amount. The first occurrence keeps the
    // id and its monthly data; any later collision gets a fresh id with its cached TTM
    // cleared (that data belonged to the first occurrence and will repopulate on the
    // next paste/resync if the row is real). Plain-name duplicates above only merge
    // CUST-#### rows, so this is the safety net for everything else.
    const seenIds = new Set();
    let maxId = Math.max(0, ...result.map(c => (typeof c.id === 'number' ? c.id : 0)));
    for (let i = 0; i < result.length; i++) {
      const c = result[i];
      if (c.id === undefined || c.id === null || seenIds.has(c.id)) {
        result[i] = { ...c, id: ++maxId, ttm: 0, ttmCash: 0, ttmAccrual: 0 };
      } else {
        seenIds.add(c.id);
      }
    }

    return result;
  };

  const applyMonthlySalesPaste = () => {
    if (!monthlySalesPastePreview || monthlySalesPastePreview.error) return;
    try {
      captureUndoState('Paste Monthly Sales' + (monthlySalesClearFirst ? ' - Clear & Replace' : ''));
      const { matched, newCustomers } = monthlySalesPastePreview;
      const normalize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

      // Build new monthlySalesData
      const basis = salesTtmConfig.basis || 'cash';
      const otherBasis = basis === 'cash' ? 'accrual' : 'cash';
      let newMonthly;
      if (monthlySalesClearFirst) {
        // Clear only the current basis — preserve the other basis data
        newMonthly = {};
        Object.entries(monthlySalesData).forEach(([id, data]) => {
          if (data && !Array.isArray(data) && data[otherBasis]) {
            newMonthly[id] = { [otherBasis]: data[otherBasis] };
          }
          // If data is a flat legacy array, just drop it on clear
        });
      } else {
        newMonthly = { ...monthlySalesData };
      }

      // Store monthly data under the correct basis key {cash: [] or accrual: []}
      // Preserve any existing data for the OTHER basis
      matched.forEach(row => {
        const raw = newMonthly[String(row.customerId)];
        // Normalize legacy flat arrays to {cash, accrual} structure before merging
        const existing = (raw && !Array.isArray(raw)) ? raw : { cash: Array.isArray(raw) ? raw : [], accrual: Array.isArray(raw) ? raw : [] };
        newMonthly[String(row.customerId)] = { ...existing, [basis]: row.monthValues };
      });

      // Monthly paste targets the roster the PREVIEW matched against — the
      // pasted basis's roster, falling to the other basis when it's empty
      // (Konnie 09-11, Assura — must mirror parseMonthlySalesPaste exactly
      // or matched IDs would write into the wrong array).
      const rosterHasClients0 = (basis === 'cash' ? customerSalesCash : customerSalesAccrual).some(c => c.name && c.name.trim());
      const effRosterIsCash0 = rosterHasClients0 ? (basis === 'cash') : (basis !== 'cash');
      const targetSourceArr = effRosterIsCash0 ? customerSalesCash : customerSalesAccrual;
      const setTargetSourceArr = effRosterIsCash0 ? setCustomerSalesCash : setCustomerSalesAccrual;
      let updatedCustomers = [...targetSourceArr];
      // Use maxId + counter for guaranteed unique IDs — Date.now()+Math.random() loses
      // float precision when 44+ customers are created in the same millisecond, causing
      // ID collisions that overwrite one customer's monthly data with another's
      let maxId = Math.max(0, ...updatedCustomers.map(c => typeof c.id === 'number' ? c.id : 0));
      newCustomers.forEach((row, pasteIdx) => {
        const newId = ++maxId;
        updatedCustomers.push({
          id: newId, name: row.name, year1: 0, year2: 0, year3: 0, year4: 0, year5: 0,
          ttm: row.ttmTotal, customerType: '', atRisk: false, lost: false,
          hasContract: false, effectiveDate: '', contractMonths: null, autoRenewal: false,
          renewedContractMonths: null, assignable: false, priceEscalator: false,
          escalatorPercent: 0, earlyTermPenalty: false, billingFrequency: '',
          tenure: '', notes: '', contractStart: '', contractEnd: '', industry: '', endpoints: 0
        });
        const existing = newMonthly[String(newId)] || {};
        newMonthly[String(newId)] = { ...existing, [basis]: row.monthValues };
      });

      // Re-sort customers to match the paste order (matched first in paste order, then new)
      const pasteOrderMap = new Map();
      const allPasteRows = [...(monthlySalesPastePreview.matched || []), ...(monthlySalesPastePreview.newCustomers || [])];
      allPasteRows.forEach((row, idx) => {
        const name = (row.matchedName || row.name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        pasteOrderMap.set(name, idx);
      });
      updatedCustomers.sort((a, b) => {
        const an = (a.name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        const bn = (b.name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        const ai = pasteOrderMap.has(an) ? pasteOrderMap.get(an) : 99999;
        const bi = pasteOrderMap.has(bn) ? pasteOrderMap.get(bn) : 99999;
        return ai - bi;
      });

      // After paste: always sync TTM for all customers from the pasted monthly data
      // This is the whole purpose of the TTM paste — the checkbox state must not block it
      updatedCustomers = updatedCustomers.map(customer => {
          const mData = newMonthly[String(customer.id)];
          if (!mData) return customer;
          if (Array.isArray(mData)) {
            const total = mData.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
            return { ...customer, ttm: total, ttmCash: total, ttmAccrual: total };
          }
          const cashTotal = (mData.cash || []).slice(0, 12).reduce((s, v) => s + (v || 0), 0);
          const accrualTotal = (mData.accrual || []).slice(0, 12).reduce((s, v) => s + (v || 0), 0);
          const ttm = basis === 'cash' ? cashTotal : accrualTotal;
          return { ...customer, ttm, ttmCash: cashTotal, ttmAccrual: accrualTotal };
        });

      // NOTE: TTM paste never deletes customers from the list.
      // "Clear & Replace" here means clear/replace the monthly TTM data only.
      // Customer list and annual year data are managed exclusively by the annual Sales paste.

      setMonthlySalesData(newMonthly);
      // Update only the basis-matching array. The other basis's annual data and customer list
      // are intentionally untouched — sales reports are independent per basis (just like P&L).
      setTargetSourceArr(deduplicateCustomers(updatedCustomers));
      // Switch the Sales-tab view to the pasted basis so the user sees their work land.
      setSalesViewBasis(basis);
      setShowMonthlySalesPasteModal(false);
      setMonthlySalesPasteData('');
      setMonthlySalesPastePreview(null);
      setMonthlySalesClearFirst(false);
    } catch (err) {
      console.error('Monthly sales paste error:', err);
      alert('Error applying paste: ' + err.message);
    }
  };

  // Parse Client Details Grid Paste
  const parseClientDetailsPaste = () => {
    const existingCustomers = customerSalesData.filter(c => c.name);
    
    // Parse the pasted data
    const lines = clientDetailsPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length === 0) return { matched: [], notFound: [], headers: [] };
    
    // Detect header row index - skip title rows that start with emoji or contain "CLIENT DETAILS"
    let headerRowIndex = 0;
    const firstRowLower = lines[0].toLowerCase();
    if (lines[0].startsWith('📋') || 
        lines[0].startsWith('🟢') || 
        firstRowLower.includes('client details') ||
        firstRowLower.includes('customer details') ||
        !firstRowLower.includes('name') && !firstRowLower.includes('client') && !firstRowLower.includes('customer')) {
      // First row is likely a title row, check if second row looks like headers
      if (lines.length > 1) {
        const secondRowLower = lines[1].toLowerCase();
        if (secondRowLower.includes('name') || secondRowLower.includes('client') || secondRowLower.includes('customer')) {
          headerRowIndex = 1;
        }
      }
    }
    
    // Parse header row to detect columns
    const headerRow = lines[headerRowIndex].split('\t');
    const headerLower = headerRow.map(h => h.toLowerCase().trim());
    
    // Auto-detect column mappings - more flexible matching
    const columnMap = {};
    headerLower.forEach((h, idx) => {
      // Customer/Client name - must be exact match or include "name"
      if (h === 'client name' || h === 'customer name' || h === 'name' || h === 'company' || h === 'client' || h === 'customer') columnMap.name = idx;
      // Customer type (B2B/B2C) - but not "contract type"
      else if ((h.includes('type') && !h.includes('contract')) || h === 'customer type') columnMap.customerType = idx;
      // Status (Active/At Risk/Lost)
      else if (h === 'status' || h.includes('status')) columnMap.status = idx;
      // Billing frequency
      else if (h.includes('billing') || h.includes('frequency') || h.includes('bill') || h === 'freq' || h === 'billing freq') columnMap.billingFrequency = idx;
      // Endpoints/Users/Devices/Seats
      else if (h.includes('endpoint') || h.includes('device') || h.includes('seat') || h.includes('user') || h.includes('license') || h === 'count' || h === '#' || h.includes('qty') || h.includes('quantity')) columnMap.endpoints = idx;
      // Industry/Vertical
      else if (h.includes('industry') || h.includes('vertical') || h.includes('sector') || h.includes('market')) columnMap.industry = idx;
      // Tenure/Years as customer
      else if (h.includes('tenure') || h.includes('since') || h === 'years' || h.includes('customer since') || h.includes('started')) columnMap.tenure = idx;
      // Has contract (generic contract column - but not "contract length" or "renewed contract")
      else if ((h.includes('contract') && !h.includes('start') && !h.includes('end') && !h.includes('length') && !h.includes('term') && !h.includes('renew') && !h.includes('original')) || h === 'contracted' || h === 'msa' || h === 'has contract' || h === 'has contract?') columnMap.hasContract = idx;
      // Original Contract length/term/duration (not renewed)
      else if ((h.includes('original') && h.includes('length')) || (h.includes('length') && !h.includes('renew')) || h.includes('duration') || (h.includes('term') && !h.includes('penalty') && !h.includes('early')) || h === 'period' || h === 'len' || h === 'contract length') columnMap.contractLength = idx;
      // Renewed Contract Length
      else if (h.includes('renew') && h.includes('length')) columnMap.renewedContractLength = idx;
      // Contract start date / Effective date - be specific to avoid matching instruction text like "Start with..."
      else if (h === 'effective date' || h === 'start date' || h === 'contract start' || 
               (h.includes('effective') && !h.includes('row')) || 
               (h.includes('start') && h.includes('date')) ||
               h.includes('begin') || h.includes('commenced')) columnMap.effectiveDate = idx;
      // Contract end date
      else if (h.includes('end') || h.includes('expir') || h.includes('terminat') || h.includes('renewal date')) columnMap.contractEnd = idx;
      // Auto renewal
      else if (h.includes('auto') && h.includes('renew')) columnMap.autoRenewal = idx;
      // Assignable
      else if (h.includes('assign') || h.includes('transfer')) columnMap.assignable = idx;
      // Price escalator (the checkbox column, not the % column)
      else if ((h.includes('price') && h.includes('escalator')) || h === 'escalator' || h === 'price escalator?' || h === 'escalator?') columnMap.priceEscalator = idx;
      // Escalator percent
      else if (h.includes('escalator %') || h === 'esc %' || h === 'escalator%') columnMap.escalatorPercent = idx;
      // Early termination penalty
      else if (h.includes('penalty') || h.includes('termination') || h.includes('cancel') || h.includes('etp') || h.includes('early term')) columnMap.earlyTermPenalty = idx;
      // At risk (legacy - also handled by status)
      else if (h.includes('risk') || h.includes('churn') || h.includes('at-risk') || h.includes('atrisk')) columnMap.atRisk = idx;
      // Notes
      else if (h.includes('note') || h.includes('comment') || h.includes('remark')) columnMap.notes = idx;
    });
    
    // If no name column found, assume first column is name
    if (columnMap.name === undefined) columnMap.name = 0;
    
    // Detected headers for preview
    const detectedHeaders = Object.entries(columnMap).map(([field, idx]) => ({ field, header: headerRow[idx] }));
    
    // Parse boolean values - ENHANCED to recognize Y/N, Yes/No, etc.
    const parseBoolean = (val) => {
      if (!val) return false;
      const v = val.toString().toLowerCase().trim();
      // Check for positive values
      if (v === 'yes' || v === 'y' || v === 'true' || v === '1' || v === 'x' || v === '✓' || v === '✔') return true;
      return false;
    };
    
    // Check if value is explicitly negative (N, No, etc.)
    const isExplicitNo = (val) => {
      if (!val) return false;
      const v = val.toString().toLowerCase().trim();
      return v === 'no' || v === 'n' || v === 'false' || v === '0';
    };
    
    // Smart parse for contract dates - handles multiple formats
    const parseContractDate = (val) => {
      if (!val) return '';
      const v = val.toString().trim();
      
      // Already in mm/yy or mm/yyyy format - pass through
      if (/^\d{1,2}\/\d{2,4}$/.test(v)) return v;
      
      // yyyy format (just year) - convert to 01/yy
      if (/^(19|20)\d{2}$/.test(v)) {
        const year = v.slice(-2); // Get last 2 digits
        return `01/${year}`;
      }
      
      // yyyy-mm or mm-yyyy format
      const dashMatch = v.match(/^(\d{4})-(\d{1,2})$|^(\d{1,2})-(\d{4})$/);
      if (dashMatch) {
        if (dashMatch[1]) { // yyyy-mm
          return `${dashMatch[2].padStart(2, '0')}/${dashMatch[1].slice(-2)}`;
        } else { // mm-yyyy
          return `${dashMatch[3].padStart(2, '0')}/${dashMatch[4].slice(-2)}`;
        }
      }
      
      // Full date formats - extract month/year
      const fullDateMatch = v.match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})/);
      if (fullDateMatch) {
        const month = fullDateMatch[1].padStart(2, '0');
        const year = fullDateMatch[3].slice(-2);
        return `${month}/${year}`;
      }
      
      // Pass through as-is if can't parse
      return v;
    };
    
    // Smart parse for auto-renewal - dates mean Yes
    const parseAutoRenewal = (val) => {
      if (!val) return { hasAutoRenewal: false, renewalDate: null };
      const v = val.toString().trim();
      // Check for explicit Y/N first
      if (parseBoolean(v)) return { hasAutoRenewal: true, renewalDate: null };
      if (v.toLowerCase() === 'no' || v.toLowerCase() === 'n') return { hasAutoRenewal: false, renewalDate: null };
      // Check for date patterns: MM/YYYY, YYYY-MM, MM-YYYY, YYYY/MM, or just MM/YY
      const datePattern = /(\d{1,2})[\/\-](\d{2,4})|(\d{4})[\/\-](\d{1,2})/;
      if (datePattern.test(v)) {
        return { hasAutoRenewal: true, renewalDate: v };
      }
      return { hasAutoRenewal: false, renewalDate: null };
    };
    
    // Smart parse for escalator - percentages mean Yes, extract rate
    const parseEscalator = (val) => {
      if (!val) return { hasEscalator: false, escalatorPercent: 0 };
      const v = val.toString().trim();
      // Check for explicit Y/N first
      if (v.toLowerCase() === 'no' || v.toLowerCase() === 'n') return { hasEscalator: false, escalatorPercent: 0 };
      if (parseBoolean(v) && !v.includes('%')) return { hasEscalator: true, escalatorPercent: 0 };
      // Extract percentage(s) - take the first/primary one
      const pctMatches = v.match(/(\d+(?:\.\d+)?)\s*%/g);
      if (pctMatches && pctMatches.length > 0) {
        const firstPct = parseFloat(pctMatches[0].replace('%', ''));
        return { hasEscalator: true, escalatorPercent: firstPct };
      }
      // If there's any numeric value, assume it's a percentage
      const numMatch = v.match(/(\d+(?:\.\d+)?)/);
      if (numMatch) {
        return { hasEscalator: true, escalatorPercent: parseFloat(numMatch[1]) };
      }
      return { hasEscalator: false, escalatorPercent: 0 };
    };
    
    // Smart parse for tenure - year means calculate from current year
    const parseTenure = (val) => {
      if (!val) return null;
      const v = val.toString().trim();
      // If it's already a number of years
      const yearsMatch = v.match(/^(\d{1,2})$/);
      if (yearsMatch && parseInt(yearsMatch[1]) < 50) {
        return parseInt(yearsMatch[1]);
      }
      // If it's a 4-digit year (like 2011, 2019, etc.)
      const yearMatch = v.match(/((?:19|20)\d{2})/);
      if (yearMatch) {
        const startYear = parseInt(yearMatch[1]);
        const currentYear = new Date().getFullYear();
        return Math.max(0, currentYear - startYear);
      }
      // Check for "YYYY (Audit)" or similar patterns
      const yearWithNoteMatch = v.match(/((?:19|20)\d{2})\s*\(/);
      if (yearWithNoteMatch) {
        const startYear = parseInt(yearWithNoteMatch[1]);
        const currentYear = new Date().getFullYear();
        return Math.max(0, currentYear - startYear);
      }
      return null;
    };
    
    // Smart parse for contract length - handle "12 Months", "Month-to-Month", "3+2" style, etc.
    // Returns: number of months, or 'mtm' for month-to-month, or null if can't parse
    const parseContractLength = (val) => {
      if (!val) return null;
      const v = val.toString().trim().toLowerCase();
      if (!v) return null;
      
      // Month-to-Month variations (check first before other patterns)
      if (v === 'month-to-month' || v === 'm-t-m' || v === 'mtm' || v === 'm2m' || v.includes('month to month') || v.includes('month-to-month')) return 'mtm';
      
      // Pattern like "12 months", "24 Months" - extract the number (already in months)
      const monthsMatch = v.match(/(\d+)\s*months?/i);
      if (monthsMatch) {
        return parseInt(monthsMatch[1]);
      }
      
      // Pattern like "3+2", "5+3" - take the initial term (in years, convert to months)
      const plusMatch = v.match(/(\d+)\s*\+\s*(\d+)/);
      if (plusMatch) {
        return parseInt(plusMatch[1]) * 12; // Convert years to months
      }
      
      // Simple number - if small (<13) assume years, otherwise months
      const numMatch = v.match(/^(\d+)$/);
      if (numMatch) {
        const num = parseInt(numMatch[1]);
        // If it's a round number like 12, 24, 36 - likely already months
        if (num % 12 === 0 && num <= 120) return num;
        // If small number, assume years and convert
        if (num <= 10) return num * 12;
        // Otherwise treat as months
        return num;
      }
      
      // "Annual", "Yearly" = 12 months
      if (v.includes('annual') || v.includes('yearly') || v === 'year' || v === 'yr' || v === '1 year') return 12;
      // "2 years", "3 year" etc
      const yearsMatch = v.match(/(\d+)\s*years?/i);
      if (yearsMatch) return parseInt(yearsMatch[1]) * 12;
      
      return null;
    };
    
    // Smart parse for hasContract based on contract type column
    const parseHasContract = (val) => {
      if (!val) return null; // Unknown
      const v = val.toString().toLowerCase().trim();
      // Explicit negatives
      if (v === 'no' || v === 'n' || v.includes('project') || v.includes('t&m') || v.includes('time and material')) {
        return false;
      }
      // Explicit positives
      if (v === 'yes' || v === 'y' || parseBoolean(val)) return true;
      // If there's any substantive content (like "5+3", "Annual", dates), assume contracted
      if (v.match(/\d/) || v.includes('annual') || v.includes('year')) return true;
      return null;
    };
    
    // Smart parse for billing frequency - normalize various formats
    const parseBillingFrequency = (val) => {
      if (!val) return '';
      const v = val.toString().toLowerCase().trim();
      // Monthly variations
      if (v === 'm' || v === 'monthly' || v === 'mo' || v === 'mth' || v === 'm or q or a') return 'Monthly';
      // Quarterly variations
      if (v === 'q' || v === 'quarterly' || v === 'qtr') return 'Quarterly';
      // Annual/Yearly variations
      if (v === 'a' || v === 'y' || v === 'annual' || v === 'annually' || v === 'yearly' || v === 'year' || v === 'yr') return 'Annual';
      // Semi-annual
      if (v === 'semi' || v === 'semi-annual' || v === 'semiannual' || v === 'bi-annual' || v === 'biannual') return 'Semi-Annual';
      // One-time / Project
      if (v === 'one-time' || v === 'onetime' || v === 'one time' || v === 'project' || v === 'proj') return 'One-Time';
      // Return original if no match (capitalize first letter)
      return val.trim().charAt(0).toUpperCase() + val.trim().slice(1).toLowerCase();
    };
    
    // Smart parse for customer type - normalize B2B/B2C variations
    const parseCustomerType = (val) => {
      if (!val) return '';
      const v = val.toString().toLowerCase().trim();
      // B2B variations
      if (v === 'b2b' || v === 'business' || v === 'commercial' || v === 'corp' || v === 'corporate' || v === 'enterprise') return 'B2B';
      // Residential variations (canonical value is 'Residential' — matches UI dropdown, filters, and "All Residential" button)
      if (v === 'residential' || v === 'res' || v === 'home' || v === 'personal' || v === 'b2c' || v === 'consumer') return 'Residential';
      // Government
      if (v === 'gov' || v === 'government' || v === 'public' || v === 'municipal' || v === 'city' || v === 'county' || v === 'state' || v === 'federal') return 'Government';
      // Non-profit
      if (v === 'nonprofit' || v === 'non-profit' || v === 'npo' || v === 'charity' || v === '501c3') return 'Non-Profit';
      // Return original if no match (capitalize)
      return val.trim();
    };
    
    // Parse data rows (skip header row and instruction rows)
    const matched = [];
    const notFound = [];
    const matchedIds = new Set(); // Track matched customer IDs to prevent duplicate matches
    
    // Start from headerRowIndex + 1 (row after headers)
    for (let i = headerRowIndex + 1; i < lines.length; i++) {
      const cols = lines[i].split('\t');
      const name = (cols[columnMap.name] || '').trim();
      if (!name) continue;
      
      // Skip header/instruction rows (Excel template rows that aren't actual customer data)
      const nameLowerCheck = name.toLowerCase();
      if (nameLowerCheck.includes('(do not edit)') || 
          nameLowerCheck.includes('do not edit') ||
          nameLowerCheck.startsWith('⬇') ||
          nameLowerCheck.includes('default') ||
          nameLowerCheck.includes('client name') ||
          nameLowerCheck.includes('customer name') ||
          nameLowerCheck.includes('b2b, residential') ||  // Skip the dropdown options row
          nameLowerCheck.includes('yes, no') ||  // Skip Yes/No instruction row
          nameLowerCheck.includes('active, at risk') ||  // Skip status options row
          name.startsWith('📋') ||
          name.startsWith('🟢') ||
          name.startsWith('🟡') ||
          name.startsWith('⬜')) continue;
      
      // Build data object from detected columns
      const data = { name };
      if (columnMap.customerType !== undefined) data.customerType = parseCustomerType(cols[columnMap.customerType]);
      if (columnMap.billingFrequency !== undefined) data.billingFrequency = parseBillingFrequency(cols[columnMap.billingFrequency]);
      if (columnMap.endpoints !== undefined) data.endpoints = parseInt((cols[columnMap.endpoints] || '').replace(/[^0-9]/g, '')) || 0;
      if (columnMap.industry !== undefined) data.industry = (cols[columnMap.industry] || '').trim();
      
      // Smart tenure parsing
      if (columnMap.tenure !== undefined) {
        const rawTenure = (cols[columnMap.tenure] || '').trim();
        const parsedTenure = parseTenure(rawTenure);
        data.tenure = parsedTenure !== null ? parsedTenure : rawTenure;
        data.tenureRaw = rawTenure; // Keep original for display
      }
      
      // Smart contract parsing
      if (columnMap.hasContract !== undefined) {
        const contractVal = parseHasContract(cols[columnMap.hasContract]);
        if (contractVal !== null) { data.hasContract = contractVal; data.contractAnswered = true; }
      }
      
      // Contract length - smart parse "3+2" style
      if (columnMap.contractLength !== undefined) {
        const rawLength = (cols[columnMap.contractLength] || '').trim();
        const parsedLength = parseContractLength(rawLength);
        if (parsedLength !== null) data.contractLength = parsedLength;
        data.contractLengthRaw = rawLength;
        // If we got a valid contract length (including M2M), assume they have a contract
        if (parsedLength !== null && data.hasContract === undefined) {
          data.hasContract = true;
        }
      }
      
      // Renewed contract length
      if (columnMap.renewedContractLength !== undefined) {
        const rawLength = (cols[columnMap.renewedContractLength] || '').trim();
        const parsedLength = parseContractLength(rawLength);
        if (parsedLength !== null) data.renewedContractLength = parsedLength;
      }
      
      // Effective date (was contractStart)
      if (columnMap.effectiveDate !== undefined) data.effectiveDate = parseContractDate(cols[columnMap.effectiveDate]);
      if (columnMap.contractEnd !== undefined) data.contractEnd = parseContractDate(cols[columnMap.contractEnd]);
      
      // Smart auto-renewal parsing - dates mean Yes
      if (columnMap.autoRenewal !== undefined) {
        const rawVal = (cols[columnMap.autoRenewal] || '').trim();
        const parsed = parseAutoRenewal(rawVal);
        data.autoRenewal = parsed.hasAutoRenewal;
        if (parsed.renewalDate) data.autoRenewalDate = parsed.renewalDate;
        data.autoRenewalRaw = rawVal;
      }
      
      if (columnMap.assignable !== undefined) {
        const rawVal = (cols[columnMap.assignable] || '').trim();
        if (rawVal) {
          data.assignable = parseBoolean(rawVal);
          data.assignableRaw = rawVal;
        }
      }
      
      // Smart escalator parsing - percentages mean Yes, extract rate
      if (columnMap.priceEscalator !== undefined) {
        const rawVal = (cols[columnMap.priceEscalator] || '').trim();
        const parsed = parseEscalator(rawVal);
        data.priceEscalator = parsed.hasEscalator;
        if (parsed.escalatorPercent > 0) data.escalatorPercent = parsed.escalatorPercent;
        data.escalatorRaw = rawVal;
      }
      
      if (columnMap.earlyTermPenalty !== undefined) data.earlyTermPenalty = parseBoolean(cols[columnMap.earlyTermPenalty]);
      
      // Status column (Active/At Risk/Lost) - preferred
      if (columnMap.status !== undefined) {
        const statusVal = String(cols[columnMap.status] || '').toLowerCase().trim();
        data.atRisk = statusVal === 'at risk' || statusVal === 'at-risk' || statusVal === 'atrisk';
        data.lost = statusVal === 'lost';
        data.statusRaw = cols[columnMap.status];
      }
      // Legacy atRisk column (if no status column)
      else if (columnMap.atRisk !== undefined) {
        const statusVal = String(cols[columnMap.atRisk] || '').toLowerCase().trim();
        data.atRisk = statusVal === 'at risk' || statusVal === 'at-risk' || statusVal === 'atrisk' || parseBoolean(cols[columnMap.atRisk]);
        data.lost = statusVal === 'lost';
      }
      
      // Separate escalator percent column (if exists)
      if (columnMap.escalatorPercent !== undefined) {
        const pctVal = parseFloat((cols[columnMap.escalatorPercent] || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(pctVal) && pctVal > 0) {
          data.escalatorPercent = pctVal;
          // If we have an escalator %, assume escalator is enabled
          if (data.priceEscalator === undefined) data.priceEscalator = true;
        }
      }
      
      if (columnMap.notes !== undefined) data.notes = (cols[columnMap.notes] || '').trim();
      
      // Match to existing customer using scoring system to find BEST match
      // Normalize special characters before comparison (handles different dash types, smart quotes, etc.)
      const normalizeChars = (s) => {
        return s
          .replace(/[\u2018\u2019\u201A\u201B\u0060\u00B4]/g, "'") // smart single quotes to apostrophe
          .replace(/[\u201C\u201D\u201E\u201F\u00AB\u00BB]/g, '"') // smart double quotes
          .replace(/[\u2010\u2011\u2012\u2013\u2014\u2015\u2212]/g, '-') // all dash types to hyphen
          .replace(/[\uFF08\u207D\u208D]/g, '(') // fullwidth/superscript/subscript open paren
          .replace(/[\uFF09\u207E\u208E]/g, ')') // fullwidth/superscript/subscript close paren
          .replace(/\s+/g, ' ') // normalize whitespace
          .trim();
      };
      
      const normalizedName = normalizeChars(name);
      const nameLower = normalizedName.toLowerCase().replace(/[^a-z0-9]/g, '');
      let match = null;
      
      // Score all potential matches and pick the best one
      const scoreCandidates = existingCustomers
        .filter(c => !matchedIds.has(c.id)) // Don't match same customer twice
        .map(c => {
          const normalizedExisting = normalizeChars(c.name || '');
          const existingLower = normalizedExisting.toLowerCase().replace(/[^a-z0-9]/g, '');
          let score = 0;
          
          // Exact match after normalization = highest score
          if (existingLower === nameLower) {
            score = 1000;
          }
          // Check if one contains the other (but penalize length difference)
          else if (existingLower.includes(nameLower) || nameLower.includes(existingLower)) {
            // Score based on how similar the lengths are (prefer closer matches)
            const lenDiff = Math.abs(existingLower.length - nameLower.length);
            score = 500 - lenDiff * 10; // Heavily penalize length differences
          }
          
          // If still no match, try with common suffixes stripped
          if (score === 0) {
            const stripVariations = (s) => s.replace(/inc|llc|corp|ltd|co|company/g, '').replace(/\s+/g, '');
            const nameStripped = stripVariations(nameLower);
            const existingStripped = stripVariations(existingLower);
            if (existingStripped === nameStripped && existingStripped.length > 5) {
              score = 800;
            }
          }
          
          return { customer: c, score, existingLower };
        })
        .filter(c => c.score > 0)
        .sort((a, b) => b.score - a.score); // Sort by score descending
      
      // Take the best match if we have one
      if (scoreCandidates.length > 0) {
        match = scoreCandidates[0].customer;
      }
      
      if (match) {
        matched.push({ ...data, matchedTo: match });
        matchedIds.add(match.id);
      } else {
        notFound.push(data);
      }
    }
    
    return { matched, notFound, headers: detectedHeaders, columnMap, debugInfo: { headerRow, columnMap, headerRowIndex } };
  };
  
  // Apply Client Details Grid Paste
  const CLIENT_DETAIL_CLEAR = {
    customerType: '', billingFrequency: '', endpoints: 0, industry: '', tenure: '',
    hasContract: false, contractAnswered: false, contractMonths: null, renewedContractMonths: null,
    effectiveDate: '', contractStart: '', contractEnd: '', autoRenewal: false, assignable: null,
    priceEscalator: false, escalatorPercent: null, earlyTermPenalty: false,
  };
  const clearDetail = (c) => ({ ...c, ...CLIENT_DETAIL_CLEAR });
  // 🧹 Clear all client detail on BOTH bases (Colleen 10-05) — undoable.
  const clearAllClientDetail = () => {
    if (!window.confirm('Clear ALL client detail (type, contract, dates, terms, billing, industry, tenure) for every client, on both cash and accrual?\n\nNames and revenue stay. You can Undo.')) return;
    captureUndoState('Clear all client detail');
    setCustomerSalesCash(prev => (prev || []).map(clearDetail));
    setCustomerSalesAccrual(prev => (prev || []).map(clearDetail));
    setHasUnsavedChanges(true);
  };
  const applyClientDetailsPaste = () => {
    if (!clientDetailsPastePreview) return;
    
    try {
      captureUndoState(clientPasteReplaceAll ? 'Paste Grid Client Details (replace all)' : 'Paste Grid Client Details');

      let updatedCustomers = customerSalesData.map(c => clientPasteReplaceAll ? clearDetail(c) : ({ ...c }));
      
      // Update matched rows
      clientDetailsPastePreview.matched.forEach(row => {
        const idx = updatedCustomers.findIndex(c => c.id === row.matchedTo.id);
        if (idx !== -1) {
          const updates = {};
          // Use explicit checks to allow empty strings and zeros
          if (row.customerType !== undefined && row.customerType !== '') updates.customerType = row.customerType;
          if (row.billingFrequency !== undefined && row.billingFrequency !== '') updates.billingFrequency = row.billingFrequency;
          if (row.endpoints !== undefined) updates.endpoints = row.endpoints;
          if (row.industry !== undefined && row.industry !== '') updates.industry = row.industry;
          if (row.tenure !== undefined && row.tenure !== null && row.tenure !== '') updates.tenure = row.tenure;
          if (row.hasContract !== undefined) {
            updates.hasContract = row.hasContract;
            // IMPORTANT: If hasContract is explicitly set to false, clear all contract-related fields
            if (row.hasContract === false) {
              updates.contractMonths = null;
              updates.renewedContractMonths = null;
              updates.effectiveDate = '';
              updates.contractStart = '';
              updates.contractEnd = '';
              updates.autoRenewal = false;
              updates.assignable = null;
              updates.priceEscalator = false;
              updates.escalatorPercent = null;
              updates.earlyTermPenalty = false;
            }
          }
          if (row.contractLength !== undefined && row.contractLength !== null) {
            // 'mtm' = month-to-month (1 month), otherwise the value is already in months from parseContractLength
            updates.contractMonths = row.contractLength === 'mtm' ? 1 : row.contractLength;
          }
          // Renewed contract length
          if (row.renewedContractLength !== undefined && row.renewedContractLength !== null) {
            updates.renewedContractMonths = row.renewedContractLength === 'mtm' ? 1 : row.renewedContractLength;
          }
          // Effective date (new) and legacy contractStart
          if (row.effectiveDate !== undefined && row.effectiveDate !== '') {
            updates.effectiveDate = row.effectiveDate;
            updates.contractStart = row.effectiveDate; // Also set legacy field
          }
          if (row.contractEnd !== undefined && row.contractEnd !== '') updates.contractEnd = row.contractEnd;
          if (row.autoRenewal !== undefined) updates.autoRenewal = row.autoRenewal;
          if (row.assignable !== undefined) updates.assignable = row.assignable;
          if (row.priceEscalator !== undefined) updates.priceEscalator = row.priceEscalator;
          if (row.escalatorPercent !== undefined && row.escalatorPercent > 0) updates.escalatorPercent = row.escalatorPercent;
          if (row.earlyTermPenalty !== undefined) updates.earlyTermPenalty = row.earlyTermPenalty;
          if (row.atRisk !== undefined) updates.atRisk = row.atRisk;
          if (row.lost !== undefined) updates.lost = row.lost;
          if (row.notes !== undefined && row.notes !== '') updates.notes = row.notes;
          
          updatedCustomers[idx] = { ...updatedCustomers[idx], ...updates };
        }
      });
      
      setCustomerSalesData(updatedCustomers);
      
      // Sync contract detail fields to alt basis array by name match
      if (customerSalesDataAlt.length > 0) {
        const detailFields = ['customerType', 'billingFrequency', 'endpoints', 'industry', 'tenure', 'hasContract', 'contractAnswered', 'contractMonths', 'renewedContractMonths', 'effectiveDate', 'contractStart', 'contractEnd', 'autoRenewal', 'assignable', 'priceEscalator', 'escalatorPercent', 'earlyTermPenalty', 'atRisk', 'lost', 'notes'];
        const updatedAlt = customerSalesDataAlt.map(altC0 => {
          const altC = clientPasteReplaceAll ? clearDetail(altC0) : altC0;
          if (!altC.name) return altC;
          const match = updatedCustomers.find(c => c.name && c.name.toLowerCase().trim() === altC.name.toLowerCase().trim());
          if (!match) return altC;
          const sync = {};
          detailFields.forEach(f => { if (match[f] !== undefined) sync[f] = match[f]; });
          return { ...altC, ...sync };
        });
        setCustomerSalesDataAlt(updatedAlt);
      }
      
      // Close modal and reset
      setShowClientDetailsPasteModal(false);
      setClientDetailsPasteData('');
      setClientDetailsPastePreview(null);
      
    } catch (error) {
      console.error('Client Details Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // Parse AR Aging Grid Paste
  const parseARGridPaste = () => {
    const existingCustomers = arAgingLineItems.filter(c => c.customerName);
    
    // Parse the pasted data
    const lines = arGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Detect if first row is a header and extract column positions
    let dataStartRow = 0;
    let customerNameCol = 0;
    let agingColumns = {}; // { colIdx: bucketKey }
    
    // Keywords for each aging bucket
    const bucketPatterns = [
      { key: 'current', patterns: [/^current$/i, /0\s*-?\s*30/i, /0-30/i] },
      { key: 'days1to30', patterns: [/^1\s*-?\s*30$/i, /1-30/i, /1 - 30/i] },
      { key: 'days31to60', patterns: [/31\s*-?\s*60/i, /31-60/i] },
      { key: 'days61to90', patterns: [/61\s*-?\s*90/i, /61-90/i] },
      { key: 'days91to120', patterns: [/91\s*-?\s*120/i, /91-120/i] },
      { key: 'days120plus', patterns: [/>\s*90/i, /90\s*\+/i, /over\s*90/i, />\s*120/i, /120\s*\+/i, /over\s*120/i, /91\s*and\s*over/i, /91\s*\+/i, />\s*91/i, /90\s*and\s*over/i, /\band\s*over\b/i] },
      { key: 'total', patterns: [/^total$/i] }
    ];
    const cellBucket = (t) => { for (const b of bucketPatterns) if (b.patterns.some(p => p.test(t))) return b.key; return null; };
    // A row is the column header when it names a customer/name column AND at least one
    // aging bucket (or two buckets on their own).
    const isHeaderRow = (cells) => {
      const joined = cells.join(' ').toLowerCase();
      const hasNameish = /customer|client|\bname\b/.test(joined);
      let bucketHits = 0;
      cells.forEach(c => { const t = (c || '').trim(); if (t && cellBucket(t)) bucketHits++; });
      return (hasNameish && bucketHits >= 1) || bucketHits >= 2;
    };

    // Scan the first several rows for the header — combined/QB exports put title and
    // subtitle rows above the actual column header, so it is rarely on row 0. (The old
    // code only checked row 0, so it treated the report title as the header and fell
    // back to position-based columns, reading the customer NUMBER as the name and the
    // name/region columns as aging buckets.)
    let headerCells = lines[0].split('\t');
    for (let r = 0; r < Math.min(10, lines.length); r++) {
      const cells = lines[r].split('\t');
      if (!isHeaderRow(cells)) continue;
      headerCells = cells;
      dataStartRow = r + 1;
      headerCells.forEach((cell, colIdx) => {
        const cellText = cell.trim();
        if (!cellText) return;
        const cellLower = cellText.toLowerCase();
        // Customer name column — prefer an explicit name over an ID column ("Customer No.")
        if (cellLower.includes('client name') || cellLower === 'name' ||
            (cellLower.includes('customer') && !/\bno\.?\b|number|\bid\b/.test(cellLower))) {
          customerNameCol = colIdx;
          return;
        }
        const b = cellBucket(cellText);
        if (b) agingColumns[colIdx] = b;
      });
      break;
    }
    
    // If no header detected or no aging columns found, fall back to position-based
    if (Object.keys(agingColumns).length === 0) {
      // Default column mappings based on user selection (consecutive columns after name)
      const columnMappings = {
        '5col': ['current', 'days31to60', 'days61to90', 'days91to120', 'days120plus'],
        '4col': ['current', 'days31to60', 'days61to90', 'days120plus'],
        '3col': ['current', 'days31to60', 'days120plus'],
        '6col': ['current', 'days31to60', 'days61to90', 'days91to120', 'days120plus', 'total']
      };
      const colKeys = columnMappings[arGridColumnMap] || columnMappings['5col'];
      colKeys.forEach((key, idx) => {
        agingColumns[customerNameCol + 1 + idx] = key;
      });
    }
    
    // Handle reports that have both "Current" AND "1-30" columns
    // In this case, map: Current->current, 1-30->days31to60, 31-60->days61to90, etc.
    const bucketKeys = Object.values(agingColumns);
    const hasCurrent = bucketKeys.includes('current');
    const has1to30 = bucketKeys.includes('days1to30');
    
    if (hasCurrent && has1to30) {
      // Both exist - shift 1-30 and all subsequent buckets up
      // 1-30 becomes days31to60, 31-60 becomes days61to90, etc.
      const newAgingColumns = {};
      Object.entries(agingColumns).forEach(([col, bucket]) => {
        if (bucket === 'current') {
          newAgingColumns[col] = 'current';
        } else if (bucket === 'days1to30') {
          newAgingColumns[col] = 'days31to60';
        } else if (bucket === 'days31to60') {
          newAgingColumns[col] = 'days61to90';
        } else if (bucket === 'days61to90') {
          newAgingColumns[col] = 'days91to120';
        } else if (bucket === 'days91to120' || bucket === 'days120plus') {
          newAgingColumns[col] = 'days120plus';
        } else {
          newAgingColumns[col] = bucket; // total stays total
        }
      });
      Object.keys(agingColumns).forEach(k => delete agingColumns[k]);
      Object.assign(agingColumns, newAgingColumns);
    } else if (has1to30 && !hasCurrent) {
      // Only 1-30 exists (no Current column) - treat 1-30 as current
      Object.keys(agingColumns).forEach(col => {
        if (agingColumns[col] === 'days1to30') agingColumns[col] = 'current';
      });
    }
    
    const parsed = [];
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      if (cells.length < 2) continue;
      
      // Get customer name from detected column
      let customerName = (cells[customerNameCol] || '').trim();
      
      // If customer name is empty, try adjacent columns (QB sometimes has ID in first col, name in second)
      if (!customerName && customerNameCol + 1 < cells.length) {
        customerName = (cells[customerNameCol + 1] || '').trim();
      }
      // Also try: if detected col is empty, scan for first non-empty non-numeric text
      if (!customerName) {
        for (let c = 0; c < Math.min(5, cells.length); c++) {
          const cellVal = (cells[c] || '').trim();
          if (cellVal && !/^[\d,.$()-]+$/.test(cellVal) && !/^(current|\btotal\b|days|\d)/i.test(cellVal)) {
            customerName = cellVal;
            break;
          }
        }
      }
      
      if (!customerName) continue;
      
      // Skip total/summary rows — use word boundary so "Totally..." customer names are preserved
      if (/\btotal\b/i.test(customerName) || /grand total/i.test(customerName) ||
          customerName.toLowerCase() === 'all' || customerName.toLowerCase().includes('summary')) continue;
      // Skip a repeated header row embedded mid-data (artifact of combining two reports —
      // e.g. "Customer No. | Name | Canada / US | 0 | 0 …").
      if (/^(name|customer|client name|customer no\.?|customer number|client)$/i.test(customerName.trim())) continue;
      
      const values = { current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 };
      
      // Extract values from detected column positions
      Object.entries(agingColumns).forEach(([colIdx, bucketKey]) => {
        if (bucketKey === 'total') return; // Skip total column
        
        const idx = parseInt(colIdx);
        if (idx >= cells.length) return;
        
        let val = cells[idx] || '';
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) {
          val = '-' + val.slice(1, -1);
        }
        const num = parseFloat(val);
        if (!isNaN(num) && values.hasOwnProperty(bucketKey)) {
          values[bucketKey] = num;
        }
      });
      
      // Calculate line total
      const lineTotal = values.current + values.days31to60 + values.days61to90 + values.days91to120 + values.days120plus;
      
      parsed.push({ customerName, values, lineTotal, originalRow: lines[i] });
    }
    
    // Match parsed rows to existing customers
    const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    
    const matched = [];
    const newRows = [];
    const matchedExistingIds = new Set();
    
    parsed.forEach(row => {
      let match = existingCustomers.find(c => c.customerName === row.customerName);
      if (!match) {
        const normalizedPasted = normalizeForMatch(row.customerName);
        match = existingCustomers.find(c => normalizeForMatch(c.customerName) === normalizedPasted);
      }
      // Removed aggressive substring matching that caused false positives
      
      if (match && !matchedExistingIds.has(match.id)) {
        matched.push({ ...row, matchedTo: match, matchType: row.customerName === match.customerName ? 'exact' : 'fuzzy' });
        matchedExistingIds.add(match.id);
      } else if (match && matchedExistingIds.has(match.id)) {
        // Match already used - treat as new row instead of silently dropping
        newRows.push(row);
      } else if (!match) {
        newRows.push(row);
      }
    });
    
    const noData = existingCustomers.filter(c => !matchedExistingIds.has(c.id));
    
    // Calculate totals for preview
    const totalAR = parsed.reduce((sum, row) => sum + row.lineTotal, 0);
    
    // Debug info for troubleshooting
    const debugInfo = {
      customerNameCol,
      agingColumns: { ...agingColumns },
      hasCurrent,
      has1to30,
      headerCells: headerCells.map((c, i) => c.trim() ? `${i}:'${c.trim()}'` : null).filter(Boolean)
    };
    
    return { matched, newRows, noData, parsed, totalAR, debugInfo };
  };
  
  // Apply AR Aging Grid Paste
  const applyARGridPaste = () => {
    if (!arGridPastePreview) return;
    
    try {
      captureUndoState(`Paste Grid AR Aging${arGridPasteClearReplace ? ' - Clear & Replace' : ''}`);
      
      // If clear & replace, start fresh with only pasted data
      let updatedItems = arGridPasteClearReplace ? [] : arAgingLineItems.map(item => ({ ...item }));
      
      if (!arGridPasteClearReplace) {
        // Update matched rows
        arGridPastePreview.matched.forEach(row => {
          const idx = updatedItems.findIndex(item => item.id === row.matchedTo.id);
          if (idx !== -1) {
            updatedItems[idx] = {
              ...updatedItems[idx],
              current: row.values.current,
              days31to60: row.values.days31to60,
              days61to90: row.values.days61to90,
              days91to120: row.values.days91to120,
              days120plus: row.values.days120plus
            };
          }
        });
      }
      
      // Add new rows (all rows when clearing, only unmatched when merging)
      const rowsToAdd = arGridPasteClearReplace 
        ? [...arGridPastePreview.matched.map(r => ({ customerName: r.customerName, ...r.values })), ...arGridPastePreview.newRows.map(r => ({ customerName: r.customerName, ...r.values }))]
        : arGridPastePreview.newRows.map(r => ({ customerName: r.customerName, ...r.values }));
      
      rowsToAdd.forEach(row => {
        const maxId = Math.max(...updatedItems.map(item => item.id), 0);
        updatedItems.push({
          id: maxId + 1,
          customerName: row.customerName,
          current: row.current || 0,
          days31to60: row.days31to60 || 0,
          days61to90: row.days61to90 || 0,
          days91to120: row.days91to120 || 0,
          days120plus: row.days120plus || 0
        });
      });
      
      setArAgingLineItems(updatedItems);
      
      // Close modal and reset
      setShowARGridPasteModal(false);
      setArGridPasteData('');
      setArGridPastePreview(null);
      setArGridPasteClearReplace(false);
      
    } catch (error) {
      console.error('AR Grid Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // AP Aging Grid Paste - Parse function (similar to AR)
  const parseAPGridPaste = () => {
    const existingVendors = apAgingLineItems.filter(v => v.vendorName);
    
    // Parse the pasted data
    const lines = apGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(line => line.trim());
    if (lines.length < 2) return null;
    
    // Detect if first row is a header and extract column positions
    let dataStartRow = 0;
    let vendorNameCol = 0;
    let agingColumns = {}; // { colIdx: bucketKey }
    
    const firstRowLower = lines[0].toLowerCase();
    const headerCells = lines[0].split('\t');
    
    // Check if first row looks like a header
    const looksLikeHeader = firstRowLower.includes('vendor') || firstRowLower.includes('name') || 
        firstRowLower.includes('current') || firstRowLower.includes('days') || 
        firstRowLower.includes('30') || firstRowLower.includes('60') || 
        firstRowLower.includes('90') || firstRowLower.includes('120') || firstRowLower.includes('total');
    
    if (looksLikeHeader) {
      dataStartRow = 1;
      
      // Scan header to find column positions
      const bucketPatterns = [
        { key: 'current', patterns: [/^current$/i, /0\s*-?\s*30/i, /0-30/i] },
        { key: 'days1to30', patterns: [/^1\s*-?\s*30$/i, /1-30/i, /1 - 30/i] },
        { key: 'days31to60', patterns: [/31\s*-?\s*60/i, /31-60/i] },
        { key: 'days61to90', patterns: [/61\s*-?\s*90/i, /61-90/i] },
        { key: 'days91to120', patterns: [/91\s*-?\s*120/i, /91-120/i] },
        { key: 'days120plus', patterns: [/>\s*90/i, /90\s*\+/i, /over\s*90/i, />\s*120/i, /120\s*\+/i, /over\s*120/i, /91\s*and\s*over/i, /91\s*\+/i, />\s*91/i, /90\s*and\s*over/i, /\band\s*over\b/i] },
        { key: 'total', patterns: [/^total$/i] }
      ];
      
      headerCells.forEach((cell, colIdx) => {
        const cellText = cell.trim();
        if (!cellText) return;
        const cellLower = cellText.toLowerCase();
        
        // Check for vendor name column
        if (cellLower.includes('vendor') || cellLower.includes('supplier') || 
            (cellLower === 'name' && vendorNameCol === 0)) {
          vendorNameCol = colIdx;
          return;
        }
        
        // Check for aging bucket columns
        for (const bucket of bucketPatterns) {
          if (bucket.patterns.some(p => p.test(cellText))) {
            agingColumns[colIdx] = bucket.key;
            break;
          }
        }
      });
    }
    
    // If no header detected or no aging columns found, fall back to position-based
    if (Object.keys(agingColumns).length === 0) {
      const columnMappings = {
        '5col': ['current', 'days31to60', 'days61to90', 'days91to120', 'days120plus'],
        '4col': ['current', 'days31to60', 'days61to90', 'days120plus'],
        '3col': ['current', 'days31to60', 'days120plus'],
        '6col': ['current', 'days31to60', 'days61to90', 'days91to120', 'days120plus', 'total']
      };
      const colKeys = columnMappings[apGridColumnMap] || columnMappings['5col'];
      colKeys.forEach((key, idx) => {
        agingColumns[vendorNameCol + 1 + idx] = key;
      });
    }
    
    // Handle reports that have both "Current" AND "1-30" columns
    const bucketKeys = Object.values(agingColumns);
    const hasCurrent = bucketKeys.includes('current');
    const has1to30 = bucketKeys.includes('days1to30');
    
    if (hasCurrent && has1to30) {
      const newAgingColumns = {};
      Object.entries(agingColumns).forEach(([col, bucket]) => {
        if (bucket === 'current') {
          newAgingColumns[col] = 'current';
        } else if (bucket === 'days1to30') {
          newAgingColumns[col] = 'days31to60';
        } else if (bucket === 'days31to60') {
          newAgingColumns[col] = 'days61to90';
        } else if (bucket === 'days61to90') {
          newAgingColumns[col] = 'days91to120';
        } else if (bucket === 'days91to120' || bucket === 'days120plus') {
          newAgingColumns[col] = 'days120plus';
        } else {
          newAgingColumns[col] = bucket;
        }
      });
      Object.keys(agingColumns).forEach(k => delete agingColumns[k]);
      Object.assign(agingColumns, newAgingColumns);
    } else if (has1to30 && !hasCurrent) {
      Object.keys(agingColumns).forEach(col => {
        if (agingColumns[col] === 'days1to30') agingColumns[col] = 'current';
      });
    }
    
    const parsed = [];
    for (let i = dataStartRow; i < lines.length; i++) {
      const cells = lines[i].split('\t');
      if (cells.length < 2) continue;
      
      // Get vendor name from detected column
      let vendorName = (cells[vendorNameCol] || '').trim();
      
      // If vendor name is empty, try adjacent columns
      if (!vendorName && vendorNameCol + 1 < cells.length) {
        vendorName = (cells[vendorNameCol + 1] || '').trim();
      }
      if (!vendorName) {
        for (let c = 0; c < Math.min(5, cells.length); c++) {
          const cellVal = (cells[c] || '').trim();
          if (cellVal && !/^[\d,.$()-]+$/.test(cellVal) && !/^(current|total|days|\d)/i.test(cellVal)) {
            vendorName = cellVal;
            break;
          }
        }
      }
      
      if (!vendorName) continue;
      
      // Skip total/summary rows
      if (vendorName.toLowerCase().includes('total') || vendorName.toLowerCase().includes('grand total') || 
          vendorName.toLowerCase() === 'all' || vendorName.toLowerCase().includes('summary')) continue;
      
      const values = { current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 };
      
      // Extract values from detected column positions
      Object.entries(agingColumns).forEach(([colIdx, bucketKey]) => {
        if (bucketKey === 'total') return;
        
        const idx = parseInt(colIdx);
        if (idx >= cells.length) return;
        
        let val = cells[idx] || '';
        val = val.replace(/[$,]/g, '').trim();
        if (val.startsWith('(') && val.endsWith(')')) {
          val = '-' + val.slice(1, -1);
        }
        const num = parseFloat(val);
        if (!isNaN(num) && values.hasOwnProperty(bucketKey)) {
          values[bucketKey] = num;
        }
      });
      
      const lineTotal = values.current + values.days31to60 + values.days61to90 + values.days91to120 + values.days120plus;
      
      parsed.push({ vendorName, values, lineTotal, originalRow: lines[i] });
    }
    
    // Match parsed rows to existing vendors
    const normalizeForMatch = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    
    const matched = [];
    const newRows = [];
    const matchedExistingIds = new Set();
    
    parsed.forEach(row => {
      let match = existingVendors.find(v => v.vendorName === row.vendorName);
      if (!match) {
        const normalizedPasted = normalizeForMatch(row.vendorName);
        match = existingVendors.find(v => normalizeForMatch(v.vendorName) === normalizedPasted);
      }
      // Removed aggressive substring matching that caused false positives
      
      if (match && !matchedExistingIds.has(match.id)) {
        matched.push({ ...row, matchedTo: match, matchType: row.vendorName === match.vendorName ? 'exact' : 'fuzzy' });
        matchedExistingIds.add(match.id);
      } else if (match && matchedExistingIds.has(match.id)) {
        // Match already used - treat as new row instead of silently dropping
        newRows.push(row);
      } else if (!match) {
        newRows.push(row);
      }
    });
    
    const noData = existingVendors.filter(v => !matchedExistingIds.has(v.id));
    
    const totalAP = parsed.reduce((sum, row) => sum + row.lineTotal, 0);
    
    // Debug info
    const debugInfo = {
      vendorNameCol,
      agingColumns: { ...agingColumns },
      hasCurrent,
      has1to30,
      headerCells: headerCells.map((c, i) => c.trim() ? `${i}:'${c.trim()}'` : null).filter(Boolean)
    };
    
    return { matched, newRows, noData, parsed, totalAP, debugInfo };
  };

  // Apply AP Aging Grid Paste
  const applyAPGridPaste = () => {
    if (!apGridPastePreview) return;
    
    try {
      captureUndoState(`Paste Grid AP Aging${apGridPasteClearReplace ? ' - Clear & Replace' : ''}`);
      
      let updatedItems = apGridPasteClearReplace ? [] : apAgingLineItems.map(item => ({ ...item }));
      
      if (!apGridPasteClearReplace) {
        // Update matched rows
        apGridPastePreview.matched.forEach(row => {
          const idx = updatedItems.findIndex(item => item.id === row.matchedTo.id);
          if (idx !== -1) {
            updatedItems[idx] = {
              ...updatedItems[idx],
              current: row.values.current,
              days31to60: row.values.days31to60,
              days61to90: row.values.days61to90,
              days91to120: row.values.days91to120,
              days120plus: row.values.days120plus
            };
          }
        });
      }
      
      // Add rows (all when clearing, only new when merging)
      const rowsToAdd = apGridPasteClearReplace
        ? [...apGridPastePreview.matched.map(r => ({ vendorName: r.vendorName, ...r.values })), ...apGridPastePreview.newRows.map(r => ({ vendorName: r.vendorName, ...r.values }))]
        : apGridPastePreview.newRows.map(r => ({ vendorName: r.vendorName, ...r.values }));
      
      rowsToAdd.forEach(row => {
        const maxId = Math.max(...updatedItems.map(item => item.id), 0);
        updatedItems.push({
          id: maxId + 1,
          vendorName: row.vendorName,
          current: row.current || 0,
          days31to60: row.days31to60 || 0,
          days61to90: row.days61to90 || 0,
          days91to120: row.days91to120 || 0,
          days120plus: row.days120plus || 0
        });
      });
      
      setApAgingLineItems(updatedItems);
      
      // Close modal and reset
      setShowAPGridPasteModal(false);
      setApGridPasteData('');
      setApGridPastePreview(null);
      setApGridPasteClearReplace(false);
      
    } catch (error) {
      console.error('AP Grid Paste Error:', error);
      alert('Error applying paste: ' + error.message);
    }
  };

  // Balance Sheet Paste Column - Apply function
  const applyBSPaste = () => {
    try {
      // Capture state before paste
      captureUndoState(`Paste Balance Sheet ${bsPasteSection}`);
      
      const values = bsPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
      if (values.length === 0 || (values.length === 1 && values[0].trim() === '')) {
        return;
      }
      
      // Get the appropriate setter and current data based on section
      const sectionConfig = {
        currentAssets: { data: bsCurrentAssets, setter: setBsCurrentAssets },
        fixedAssets: { data: bsFixedAssets, setter: setBsFixedAssets },
        otherAssets: { data: bsOtherAssets, setter: setBsOtherAssets },
        currentLiabilities: { data: bsCurrentLiabilities, setter: setBsCurrentLiabilities },
        longTermLiabilities: { data: bsLongTermLiabilities, setter: setBsLongTermLiabilities },
        equity: { data: bsEquity, setter: setBsEquity }
      };
      
      const config = sectionConfig[bsPasteSection];
      if (!config) {
        console.error('Invalid BS paste section:', bsPasteSection);
        return;
      }
      
      // Filter out deferred accounts - we only paste into regular accounts
      const regularItems = (config.data || []).filter(item => !item.isDeferredAccount);
      const deferredItems = (config.data || []).filter(item => item.isDeferredAccount);
      
      let updatedRegularItems = [...regularItems];
      
      // Ensure we have enough rows (only for regular items)
      while (updatedRegularItems.length < values.length) {
        const allIds = (config.data || []).map(i => i.id || 0);
        const maxId = allIds.length > 0 ? Math.max(...allIds, 0) : 0;
        updatedRegularItems.push({
          id: maxId + 1 + updatedRegularItems.length,
          name: '',
          year1: 0,
          year2: 0,
          year3: 0,
          interim: 0
        });
      }
      
      // Parse and update values
      values.forEach((val, idx) => {
        if (idx < updatedRegularItems.length) {
          const trimmedVal = val.trim();
          
          if (bsPasteTarget === 'name') {
            // Account name - text field
            updatedRegularItems[idx] = { ...updatedRegularItems[idx], name: trimmedVal };
          } else {
            // Year value - numeric
            const parsed = parseCurrencyValue(trimmedVal);
            const safeVal = typeof parsed === 'number' && !isNaN(parsed) ? parsed : 0;
            updatedRegularItems[idx] = {
              ...updatedRegularItems[idx],
              [bsPasteTarget]: safeVal
            };
          }
        }
      });
      
      // Combine regular items back with deferred items
      config.setter([...updatedRegularItems, ...deferredItems]);
      setShowBSPasteModal(false);
      setBsPasteData('');
    } catch (error) {
      console.error('BS Paste Error:', error);
      alert('Error pasting data: ' + error.message);
      setShowBSPasteModal(false);
      setBsPasteData('');
    }
  };

  // Helper to open BS paste modal for a section
  const openBSPasteModal = (section) => {
    setBsPasteSection(section);
    setBsPasteTarget('name'); // Default to account names
    setBsPasteData('');
    setShowBSPasteModal(true);
  };

  // AR Aging Paste Column - Apply function
  const applyARPaste = () => {
    try {
      // Capture state before paste
      captureUndoState(`Paste AR ${arPasteTarget}`);
      
      const values = arPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
      if (values.length === 0 || (values.length === 1 && values[0].trim() === '')) {
        return;
      }
      
      let updatedItems = [...arAgingLineItems];
      
      // Ensure we have enough rows
      while (updatedItems.length < values.length) {
        const maxId = updatedItems.length > 0 ? Math.max(...updatedItems.map(i => i.id || 0), 0) : 0;
        updatedItems.push({
          id: maxId + 1,
          customerName: '',
          current: 0,
          days31to60: 0,
          days61to90: 0,
          days91to120: 0,
          days120plus: 0
        });
      }
      
      // Parse and update values
      values.forEach((val, idx) => {
        if (idx < updatedItems.length) {
          const trimmedVal = val.trim();
          
          if (arPasteTarget === 'customerName') {
            updatedItems[idx] = { ...updatedItems[idx], customerName: trimmedVal };
          } else {
            // Numeric field - use helper, ensure it's a valid number
            const parsed = parseCurrencyValue(trimmedVal);
            const safeValue = typeof parsed === 'number' && !isNaN(parsed) ? parsed : 0;
            updatedItems[idx] = {
              ...updatedItems[idx],
              [arPasteTarget]: safeValue
            };
          }
        }
      });
      
      // Validate all items have required fields before setting state
      const validatedItems = updatedItems.map((item, idx) => ({
        id: item.id || idx + 1,
        customerName: item.customerName || '',
        current: typeof item.current === 'number' && !isNaN(item.current) ? item.current : 0,
        days31to60: typeof item.days31to60 === 'number' && !isNaN(item.days31to60) ? item.days31to60 : 0,
        days61to90: typeof item.days61to90 === 'number' && !isNaN(item.days61to90) ? item.days61to90 : 0,
        days91to120: typeof item.days91to120 === 'number' && !isNaN(item.days91to120) ? item.days91to120 : 0,
        days120plus: typeof item.days120plus === 'number' && !isNaN(item.days120plus) ? item.days120plus : 0
      }));
      
      setArAgingLineItems(validatedItems);
      setShowARPasteModal(false);
      setArPasteData('');
    } catch (error) {
      console.error('AR Paste Error:', error);
      alert('Error pasting data: ' + error.message);
      setShowARPasteModal(false);
      setArPasteData('');
    }
  };

  // Helper to open AR paste modal
  const openARPasteModal = () => {
    setArPasteTarget('customerName');
    setArPasteData('');
    setShowARPasteModal(true);
  };

  // AP Aging Paste Column - Apply function
  const applyAPPaste = () => {
    try {
      // Capture state before paste
      captureUndoState(`Paste AP ${apPasteTarget}`);
      
      const values = apPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
      if (values.length === 0 || (values.length === 1 && values[0].trim() === '')) {
        return;
      }
      
      let updatedItems = [...apAgingLineItems];
      
      // Ensure we have enough rows
      while (updatedItems.length < values.length) {
        const maxId = updatedItems.length > 0 ? Math.max(...updatedItems.map(i => i.id || 0), 0) : 0;
        updatedItems.push({
          id: maxId + 1,
          vendorName: '',
          current: 0,
          days31to60: 0,
          days61to90: 0,
          days91to120: 0,
          days120plus: 0
        });
      }
      
      // Parse and update values
      values.forEach((val, idx) => {
        if (idx < updatedItems.length) {
          const trimmedVal = val.trim();
          
          if (apPasteTarget === 'vendorName') {
            updatedItems[idx] = { ...updatedItems[idx], vendorName: trimmedVal };
          } else {
            // Numeric field - use helper, ensure it's a valid number
            const parsed = parseCurrencyValue(trimmedVal);
            const safeValue = typeof parsed === 'number' && !isNaN(parsed) ? parsed : 0;
            updatedItems[idx] = {
              ...updatedItems[idx],
              [apPasteTarget]: safeValue
            };
          }
        }
      });
      
      // Validate all items have required fields before setting state
      const validatedItems = updatedItems.map((item, idx) => ({
        id: item.id || idx + 1,
        vendorName: item.vendorName || '',
        current: typeof item.current === 'number' && !isNaN(item.current) ? item.current : 0,
        days31to60: typeof item.days31to60 === 'number' && !isNaN(item.days31to60) ? item.days31to60 : 0,
        days61to90: typeof item.days61to90 === 'number' && !isNaN(item.days61to90) ? item.days61to90 : 0,
        days91to120: typeof item.days91to120 === 'number' && !isNaN(item.days91to120) ? item.days91to120 : 0,
        days120plus: typeof item.days120plus === 'number' && !isNaN(item.days120plus) ? item.days120plus : 0
      }));
      
      setApAgingLineItems(validatedItems);
      setShowAPPasteModal(false);
      setApPasteData('');
    } catch (error) {
      console.error('AP Paste Error:', error);
      alert('Error pasting data: ' + error.message);
      setShowAPPasteModal(false);
      setApPasteData('');
    }
  };

  // Helper to open AP paste modal
  const openAPPasteModal = () => {
    setApPasteTarget('vendorName');
    setApPasteData('');
    setShowAPPasteModal(true);
  };

  // Roll Forward - shift years for annual clients
  const rollForward = () => {
    // Auto-generate new year label based on current year5 label
    const currentYear5 = basisYearLabels.year5 || '';
    let newYearLabel = '';
    
    // Try to parse as a year number and increment
    const yearMatch = currentYear5.match(/(\d{4})/);
    if (yearMatch) {
      newYearLabel = String(parseInt(yearMatch[1]) + 1);
    } else {
      // Default to current year + 1
      newYearLabel = String(new Date().getFullYear() + 1);
    }
    
    // Helper to shift year data within a basis object
    const shiftBasisYears = (basisData, includeTTM = true) => ({
      year1: basisData.year2 || 0,
      year2: basisData.year3 || 0,
      year3: basisData.year4 || 0,
      year4: basisData.year5 || 0,
      year5: 0, // New year starts blank
      ...(includeTTM ? { ttm: 0 } : {}) // Clear TTM for new period
    });

    // Shift revenue categories
    setRevenueCategories(prev => prev.map(cat => ({
      ...cat,
      cash: shiftBasisYears(cat.cash),
      accrual: shiftBasisYears(cat.accrual),
      tax: shiftBasisYears(cat.tax, false)
    })));

    // Shift COGS categories
    setCogsCategories(prev => prev.map(cat => ({
      ...cat,
      cash: shiftBasisYears(cat.cash),
      accrual: shiftBasisYears(cat.accrual),
      tax: shiftBasisYears(cat.tax, false)
    })));

    // Shift OpEx categories
    setOpexCategories(prev => prev.map(cat => ({
      ...cat,
      cash: shiftBasisYears(cat.cash),
      accrual: shiftBasisYears(cat.accrual),
      tax: shiftBasisYears(cat.tax, false)
    })));

    // Shift D/I/A/T
    setDiatCategories(prev => ({
      depreciation: {
        cash: shiftBasisYears(prev.depreciation.cash),
        accrual: shiftBasisYears(prev.depreciation.accrual),
        tax: shiftBasisYears(prev.depreciation.tax, false)
      },
      interest: {
        cash: shiftBasisYears(prev.interest.cash),
        accrual: shiftBasisYears(prev.interest.accrual),
        tax: shiftBasisYears(prev.interest.tax, false)
      },
      amortization: {
        cash: shiftBasisYears(prev.amortization.cash),
        accrual: shiftBasisYears(prev.amortization.accrual),
        tax: shiftBasisYears(prev.amortization.tax, false)
      },
      taxes: {
        cash: shiftBasisYears(prev.taxes.cash),
        accrual: shiftBasisYears(prev.taxes.accrual),
        tax: shiftBasisYears(prev.taxes.tax, false)
      }
    }));

    // Shift year labels
    setBasisYearLabels(prev => ({
      year1: prev.year2,
      year2: prev.year3,
      year3: prev.year4,
      year4: prev.year5,
      year5: newYearLabel,
      ttmStartMonth: '', ttmStartYear: '', ttmEndMonth: '', ttmEndYear: ''
    }));
  };

  // Balance Sheet Roll Forward - shift years for annual clients
  // Sync the Annual BS Interim column from the most recent TTM Monthly BS snapshot
  const syncInterimFromTtmBS = () => {
    // Find the last month index with any data — include equity in the scan
    const allTtmAccounts = [...ttmBsCurrentAssets, ...ttmBsFixedAssets, ...ttmBsOtherAssets, ...ttmBsCurrentLiabilities, ...ttmBsLongTermLiabilities, ...ttmBsEquity];
    let lastMonthIdx = -1;
    for (let i = 11; i >= 0; i--) {
      if (allTtmAccounts.some(a => (a.values[i] || 0) !== 0)) {
        lastMonthIdx = i;
        break;
      }
    }
    if (lastMonthIdx === -1) {
      alert('No TTM Monthly Balance Sheet data found. Enter data on the TTM Balance Sheet tab first.');
      return;
    }

    const normalize = (str) => (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const lastMonthLabel = ttmBsMonthLabels[lastMonthIdx] || '';

    // Account-number-blind, cross-section, duplicate-merging plan (bsPlanTtmSync — Colleen 10-07, Initial IT).
    const allSections = [
      { name: 'Current Assets', ttm: ttmBsCurrentAssets, annual: bsCurrentAssets, setter: setBsCurrentAssets },
      { name: 'Fixed Assets', ttm: ttmBsFixedAssets, annual: bsFixedAssets, setter: setBsFixedAssets },
      { name: 'Other Assets', ttm: ttmBsOtherAssets, annual: bsOtherAssets, setter: setBsOtherAssets },
      { name: 'Current Liabilities', ttm: ttmBsCurrentLiabilities, annual: bsCurrentLiabilities, setter: setBsCurrentLiabilities },
      { name: 'Long-Term Liabilities', ttm: ttmBsLongTermLiabilities, annual: bsLongTermLiabilities, setter: setBsLongTermLiabilities },
      { name: 'Equity', ttm: ttmBsEquity, annual: bsEquity, setter: setBsEquity },
    ];
    const plan = bsPlanTtmSync(allSections);
    const toZero = [], merged = [], crossed = [];
    plan.forEach(p => {
      p.dupes.forEach(a => merged.push({ section: p.name, name: a.name }));
      p.annual.forEach((a, i) => {
        const m = p.matches[i];
        if (m && m.cross) crossed.push({ section: p.name, name: a.name, from: plan[m.secIdx].name });
        if (m) return;
        if (!a.name || !String(a.name).trim()) return;
        const interim = Number(a.interim) || 0;
        if (interim === 0) return;
        toZero.push({ section: p.name, name: a.name, interim });
      });
    });

    // Confirm before anything is merged or zeroed — never silently destroy data.
    if (toZero.length > 0 || merged.length > 0) {
      const lines = [];
      if (merged.length) {
        lines.push(`${merged.length} duplicate row${merged.length === 1 ? '' : 's'} (no year history — added by an earlier sync) will be removed; the numbered original${merged.length === 1 ? '' : 's'} take${merged.length === 1 ? 's' : ''} the TTM balance:`);
        merged.slice(0, 10).forEach(c => lines.push(`  • ${c.section}: ${c.name}`));
        if (merged.length > 10) lines.push(`  …and ${merged.length - 10} more`);
      }
      if (toZero.length) {
        lines.push(`${toZero.length} interim value${toZero.length === 1 ? '' : 's'} will be set to $0 (no matching row on the TTM BS tab):`);
        toZero.slice(0, 10).forEach(c => lines.push(`  • ${c.section}: ${c.name} ($${Math.round(c.interim).toLocaleString()})`));
        if (toZero.length > 10) lines.push(`  …and ${toZero.length - 10} more`);
      }
      if (!window.confirm(`Sync will:\n\n${lines.join('\n')}\n\nContinue?`)) return;
    }

    captureUndoState('Sync Interim BS from TTM Monthly BS');

    // Apply: matched accounts get the TTM last-month value; unmatched named accounts are zeroed;
    // duplicates are dropped; unclaimed non-zero TTM accounts are added to their own section.
    plan.forEach(p => {
      const updated = p.annual.map((annualAcct, aIdx) => {
        const m = p.matches[aIdx];
        if (m) return { ...annualAcct, interim: plan[m.secIdx].ttm[m.ttmIdx].values[lastMonthIdx] || 0 };
        if (annualAcct.name && String(annualAcct.name).trim()) return { ...annualAcct, interim: 0 };
        return annualAcct;
      });
      const newRows = [];
      let nextId = Math.max(0, ...p.annual.map(a => typeof a.id === 'number' ? a.id : 0), ...p.dupes.map(a => typeof a.id === 'number' ? a.id : 0)) + 1;
      p.ttm.forEach((t, i) => {
        if (p.claimed.has(i)) return;
        if (!normalize(t.name)) return;
        if ((t.values[lastMonthIdx] || 0) === 0) return;
        newRows.push({ id: nextId++, name: t.name, year1: 0, year2: 0, year3: 0, interim: t.values[lastMonthIdx] || 0 });
      });
      p.setter([...updated, ...newRows]);
    });

    // Update the interim label to match the TTM month label
    if (lastMonthLabel) {
      setBsYearLabels(prev => ({ ...prev, interim: lastMonthLabel }));
    }

    const zeroedSuffix = (toZero.length > 0 ? `\n${toZero.length} unmatched interim value${toZero.length === 1 ? '' : 's'} set to $0.` : '')
      + (merged.length > 0 ? `\n${merged.length} duplicate row${merged.length === 1 ? '' : 's'} from an earlier sync merged into the numbered original${merged.length === 1 ? '' : 's'}.` : '')
      + (crossed.length > 0 ? `\n${crossed.length} account${crossed.length === 1 ? '' : 's'} matched across sections (e.g. ${crossed[0].name}: TTM ${crossed[0].from} → annual ${crossed[0].section}).` : '');
    alert(`Interim Balance Sheet synced from TTM Monthly BS (${lastMonthLabel}).${zeroedSuffix}`);
  };

  const rollForwardBalanceSheet = () => {
    // Auto-generate new year label based on current year3 label
    const currentYear3 = bsYearLabels.year3 || '';
    let newYearLabel = '';
    
    // Try to parse as a year number and increment
    const yearMatch = currentYear3.match(/(\d{4})/);
    if (yearMatch) {
      newYearLabel = String(parseInt(yearMatch[1]) + 1);
    } else {
      // Default to current year + 1
      newYearLabel = String(new Date().getFullYear() + 1);
    }
    
    // Helper to shift year data for balance sheet items
    const shiftBSYears = (item) => ({
      ...item,
      year1: item.year2 || 0,
      year2: item.year3 || 0,
      year3: 0, // New year starts blank
      interim: 0 // Clear interim for new period
    });

    // Shift all balance sheet categories
    setBsCurrentAssets(prev => prev.map(shiftBSYears));
    setBsFixedAssets(prev => prev.map(shiftBSYears));
    setBsOtherAssets(prev => prev.map(shiftBSYears));
    setBsCurrentLiabilities(prev => prev.map(shiftBSYears));
    setBsLongTermLiabilities(prev => prev.map(shiftBSYears));
    setBsEquity(prev => prev.map(shiftBSYears));

    // Shift year labels
    setBsYearLabels(prev => ({
      year1: prev.year2,
      year2: prev.year3,
      year3: newYearLabel,
      interim: 'Interim',
      interimDate: ''
    }));
  };

  // Customer Roll Forward - shift years for annual clients
  const rollForwardCustomers = () => {
    // Auto-generate new year label based on current year5 label
    const currentYear5 = customerYearLabels.year5 || '';
    let newYearLabel = '';
    
    // Try to parse as a year number and increment
    const yearMatch = currentYear5.match(/(\d{4})/);
    if (yearMatch) {
      newYearLabel = String(parseInt(yearMatch[1]) + 1);
    } else {
      newYearLabel = String(new Date().getFullYear() + 1);
    }
    
    // Shift customer sales data
    setCustomerSalesData(prev => prev.map(customer => ({
      ...customer,
      year1: customer.year2 || 0,
      year2: customer.year3 || 0,
      year3: customer.year4 || 0,
      year4: customer.year5 || 0,
      year5: 0, // New year starts blank
      ttm: 0 // Clear TTM for new period
    })));

    // Shift year labels
    setCustomerYearLabels(prev => ({
      year1: prev.year2,
      year2: prev.year3,
      year3: prev.year4,
      year4: prev.year5,
      year5: newYearLabel,
      ttm: 'TTM'
    }));
  };

  // Auto-name customers (Customer A, B, C, etc.)
  const autoNameCustomers = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    setCustomerSalesData(prev => prev.map((customer, idx) => ({
      ...customer,
      name: customer.name || `Customer ${idx < 26 ? letters[idx] : letters[Math.floor(idx / 26) - 1] + letters[idx % 26]}`
    })));
  };

  // Auto-name AR Aging customers (Customer A, B, C...)
  const autoNameARCustomers = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    setArAgingLineItems(prev => prev.map((item, idx) => ({
      ...item,
      customerName: item.customerName || `Customer ${idx < 26 ? letters[idx] : letters[Math.floor(idx / 26) - 1] + letters[idx % 26]}`
    })));
  };

  // Auto-name AP Aging vendors (Vendor A, B, C...)
  const autoNameAPVendors = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    setApAgingLineItems(prev => prev.map((item, idx) => ({
      ...item,
      vendorName: item.vendorName || `Vendor ${idx < 26 ? letters[idx] : letters[Math.floor(idx / 26) - 1] + letters[idx % 26]}`
    })));
  };

  const generateSalesExport = () => {
    // Determine which period to use: TTM preferred, Year5 fallback
    const totalTTMRevenue = customerSalesData.reduce((s, c) => s + (c.ttm || 0), 0);
    const totalYear5Revenue = customerSalesData.reduce((s, c) => s + (c.year5 || 0), 0);
    const concentrationPeriod = totalTTMRevenue > 0 ? 'ttm' : (totalYear5Revenue > 0 ? 'year5' : 'ttm');
    const concentrationTotal = concentrationPeriod === 'ttm' ? totalTTMRevenue : totalYear5Revenue;
    const concentrationSource = totalTTMRevenue > 0 ? 'TTM' : (totalYear5Revenue > 0 ? customerYearLabels.year5 : 'TTM');
    
    // Remainder-aware (top-20 fix): the "All Others" row stays in the totals
    // (honest denominators) but never ranks as a top client or counts as one.
    const currentCustomers = customerSalesData.filter(c => (c[concentrationPeriod] || 0) > 0 && !isRemainderRow(c));
    const sortedByPeriod = customerSalesData.filter(c => !isRemainderRow(c)).sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0));

    const top1Pct = concentrationTotal > 0 ? ((sortedByPeriod[0]?.[concentrationPeriod] || 0) / concentrationTotal * 100) : 0;
    const top5Revenue = sortedByPeriod.slice(0, 5).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const top5Pct = concentrationTotal > 0 ? (top5Revenue / concentrationTotal * 100) : 0;
    const top10Revenue = sortedByPeriod.slice(0, 10).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const top10Pct = concentrationTotal > 0 ? (top10Revenue / concentrationTotal * 100) : 0;

    // ARPC over NAMED clients only — basis stated per the Team CPT Class-H
    // rule (an "All Others" blob would poison both numerator and denominator).
    const namedCurrentRevenue = currentCustomers.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const arpc = currentCustomers.length > 0 ? namedCurrentRevenue / currentCustomers.length : 0;
    
    const clientsWithTenure = currentCustomers.filter(c => c.tenure && parseFloat(c.tenure) > 0);
    const avgTenure = clientsWithTenure.length > 0 ? clientsWithTenure.reduce((s, c) => s + parseFloat(c.tenure), 0) / clientsWithTenure.length : null;
    
    // B2B includes Non-Profit (similar organizational characteristics); Government left neutral.
    // Denominator = TYPED revenue only — blank type is unknown, not residential (Concise 08-19).
    const b2bRevenue = currentCustomers.filter(c => {
      const type = (c.customerType || '').toUpperCase();
      return type.includes('B2B') || type.includes('NON-PROFIT') || type.includes('NONPROFIT');
    }).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const resTypedRevenue = currentCustomers.filter(c => {
      const type = (c.customerType || '').toUpperCase();
      return type.includes('RESIDENTIAL') || type.includes('B2C') || type.includes('CONSUMER') || type.includes('HOME');
    }).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const b2bPct = (b2bRevenue + resTypedRevenue) > 0 ? (b2bRevenue / (b2bRevenue + resTypedRevenue) * 100) : 0;
    
    const year5Customers = customerSalesData.filter(c => (c.year5 || 0) > 0);
    const year5Revenue = year5Customers.reduce((s, c) => s + (c.year5 || 0), 0);
    const ttmFromYear5 = year5Customers.reduce((s, c) => s + (c.ttm || 0), 0);
    const nrr = year5Revenue > 0 ? (ttmFromYear5 / year5Revenue * 100) : null;
    
    const contractedClients = currentCustomers.filter(c => c.hasContract).length;
    const autoRenewalClients = currentCustomers.filter(c => c.autoRenewal).length;
    const assignableClients = currentCustomers.filter(c => c.assignable).length;
    const escalatorClients = currentCustomers.filter(c => c.priceEscalator).length;
    const termPenaltyClients = currentCustomers.filter(c => c.earlyTermPenalty).length;
    const avgEscalatorPercent = escalatorClients > 0 ? currentCustomers.filter(c => c.priceEscalator && c.escalatorPercent).reduce((s, c) => s + c.escalatorPercent, 0) / escalatorClients : 0;
    
    const industryRevenue = {};
    currentCustomers.forEach(c => {
      if (c.industry && c[concentrationPeriod] > 0) {
        industryRevenue[c.industry.trim()] = (industryRevenue[c.industry.trim()] || 0) + c[concentrationPeriod];
      }
    });
    const sortedIndustries = Object.entries(industryRevenue).sort((a, b) => b[1] - a[1]).slice(0, 5);
    
    const totalEndpoints = currentCustomers.reduce((s, c) => s + (c.endpoints || 0), 0);
    const revenuePerEndpoint = totalEndpoints > 0 ? concentrationTotal / totalEndpoints : null;
    
    const countByYear = {
      [customerYearLabels.year1]: customerSalesData.filter(c => (c.year1 || 0) > 0).length,
      [customerYearLabels.year2]: customerSalesData.filter(c => (c.year2 || 0) > 0).length,
      [customerYearLabels.year3]: customerSalesData.filter(c => (c.year3 || 0) > 0).length,
      [customerYearLabels.year4]: customerSalesData.filter(c => (c.year4 || 0) > 0).length,
      [customerYearLabels.year5]: customerSalesData.filter(c => (c.year5 || 0) > 0).length,
      'TTM': customerSalesData.filter(c => (c.ttm || 0) > 0).length
    };
    
    let text = 'CUSTOMER ANALYSIS SUMMARY\n';
    text += 'Generated: ' + new Date().toLocaleDateString() + '\n';
    text += 'Company: ' + (dealProfile.companyName || 'Not specified') + '\n\n';
    
    text += '===========================================\n';
    text += 'KEY METRICS\n';
    text += '===========================================\n';
    text += 'Current Customers: ' + currentCustomers.length + '\n';
    text += 'Total Revenue (' + concentrationSource + '): ' + formatCurrency(concentrationTotal) + '\n';
    text += 'Avg Revenue per Customer: ' + formatCurrency(Math.round(arpc)) + '\n';
    if (avgTenure) text += 'Average Tenure: ' + avgTenure.toFixed(1) + ' years\n';
    text += 'B2B Revenue: ' + b2bPct.toFixed(1) + '% (' + formatCurrency(b2bRevenue) + ')\n';
    if (nrr) text += 'Net Revenue Retention: ' + nrr.toFixed(1) + '%\n';
    text += '\n';
    
    text += '===========================================\n';
    text += 'CUSTOMER CONCENTRATION (' + concentrationSource + ')\n';
    text += '===========================================\n';
    text += 'Top Customer: ' + top1Pct.toFixed(1) + '%' + (top1Pct > 20 ? ' (Exceeds SBA 20% limit)' : '') + '\n';
    text += 'Top 5 Customers: ' + top5Pct.toFixed(1) + '%\n';
    text += 'Top 10 Customers: ' + top10Pct.toFixed(1) + '%\n';
    text += '\n';
    
    text += '===========================================\n';
    text += 'CUSTOMER COUNT TREND\n';
    text += '===========================================\n';
    Object.entries(countByYear).forEach(function(entry) {
      text += entry[0] + ': ' + entry[1] + ' customers\n';
    });
    text += '\n';
    
    text += '===========================================\n';
    text += 'CONTRACTS\n';
    text += '===========================================\n';
    text += 'Under Contract: ' + contractedClients + ' of ' + currentCustomers.length + ' (' + (currentCustomers.length > 0 ? Math.round(contractedClients/currentCustomers.length*100) : 0) + '%)\n';
    text += 'Auto-Renewal: ' + autoRenewalClients + ' customers\n';
    text += 'Assignable: ' + assignableClients + ' customers (' + (currentCustomers.length > 0 ? Math.round(assignableClients/currentCustomers.length*100) : 0) + '%)\n';
    text += 'Price Escalators: ' + escalatorClients + ' customers' + (avgEscalatorPercent > 0 ? ' (avg ' + avgEscalatorPercent.toFixed(1) + '%)' : '') + '\n';
    text += 'Early Term Penalty: ' + termPenaltyClients + ' customers\n';
    text += '\n';
    
    if (sortedIndustries.length > 0) {
      text += '===========================================\n';
      text += 'TOP INDUSTRIES\n';
      text += '===========================================\n';
      sortedIndustries.forEach(function(entry, idx) {
        text += (idx + 1) + '. ' + entry[0] + ': ' + (concentrationTotal > 0 ? (entry[1] / concentrationTotal * 100).toFixed(1) : 0) + '% (' + formatCurrency(entry[1]) + ')\n';
      });
      text += '\n';
    }
    
    if (totalEndpoints > 0) {
      text += '===========================================\n';
      text += 'ENDPOINTS/USERS\n';
      text += '===========================================\n';
      text += 'Total Endpoints: ' + totalEndpoints.toLocaleString() + '\n';
      if (revenuePerEndpoint) text += 'Revenue per Endpoint: ' + formatCurrency(Math.round(revenuePerEndpoint)) + '\n';
      text += '\n';
    }
    
    text += '===========================================\n';
    text += 'TOP 10 CUSTOMERS BY REVENUE (' + concentrationSource + ')\n';
    text += '===========================================\n';
    sortedByPeriod.filter(c => c[concentrationPeriod] > 0).slice(0, 10).forEach(function(c, idx) {
      var pct = concentrationTotal > 0 ? (c[concentrationPeriod] / concentrationTotal * 100).toFixed(1) : 0;
      text += (idx + 1) + '. ' + (c.name || 'Unnamed') + ': ' + formatCurrency(c[concentrationPeriod]) + ' (' + pct + '%)\n';
    });
    
    setSalesExportText(text);
    setShowSalesExportModal(true);
  };

  const calculations = useMemo(() => {
    const calcYear = (yearData, yearKey) => {
      const periodMap = { year1: 'year1', year2: 'year2', year3: 'year3', year4: 'year4', year5: 'year5', ttm: 'ttm' };
      // Use actual year labels for adjustment matching
      const yearMap = { 
        year1: basisYearLabels.year1, 
        year2: basisYearLabels.year2, 
        year3: basisYearLabels.year3, 
        year4: basisYearLabels.year4, 
        year5: basisYearLabels.year5, 
        ttm: 'TTM' 
      };
      const period = periodMap[yearKey];
      
      // Revenue adjustments: add increases revenue, deduct decreases revenue
      const revenueAdds = adjustmentItems.filter(item => item.included && item.type === 'add' && (item.plLine === 'Revenue' || item.plLine.startsWith('Revenue: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const revenueDeducts = adjustmentItems.filter(item => item.included && item.type === 'deduct' && (item.plLine === 'Revenue' || item.plLine.startsWith('Revenue: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const revenueAdjustment = revenueAdds - revenueDeducts;
      
      const baseRevenue = revenueAnalysis.totals[yearKey] || 0;
      const adjustedRevenue = baseRevenue + revenueAdjustment;
      
      const cogs = cogsAnalysis.totals[yearKey] || 0;
      // COGS adjustments
      const cogsAdds = adjustmentItems.filter(item => item.included && item.type === 'add' && (item.plLine === 'COGS' || item.plLine.startsWith('COGS: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const cogsDeducts = adjustmentItems.filter(item => item.included && item.type === 'deduct' && (item.plLine === 'COGS' || item.plLine.startsWith('COGS: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const cogsAdjustment = cogsAdds - cogsDeducts;
      const adjustedCogs = cogs + cogsAdjustment;
      
      const grossProfit = adjustedRevenue - adjustedCogs;
      
      // OpEx from activeOpexCategories (matches Full View)
      const opExFromCategories = activeOpexCategories.reduce((sum, cat) => sum + (cat[yearKey] || 0), 0);
      
      // OpEx line-item add-backs (percentage-based from P&L Entry)
      const opexLineAddbacks = opexCategories.reduce((sum, cat) => {
        if (!cat.addbackPct || cat.addbackPct <= 0 || cat.adjIncluded === false) return sum;
        const lineValue = cat[selectedValuationBasis]?.[yearKey] || 0;
        return sum + (lineValue * cat.addbackPct / 100);
      }, 0);
      
      // Other Expense line-item add-backs (percentage-based from P&L Entry)
      const otherExpenseLineAddbacks = otherExpenseCategories.reduce((sum, cat) => {
        if (!cat.addbackPct || cat.addbackPct <= 0 || cat.adjIncluded === false) return sum;
        const lineValue = cat[selectedValuationBasis]?.[yearKey] || 0;
        return sum + (lineValue * cat.addbackPct / 100);
      }, 0);
      
      // Combined line addbacks
      const totalLineAddbacks = opexLineAddbacks + otherExpenseLineAddbacks;
      
      // Other Income line-item deductions (percentage-based from P&L Entry - removes non-operating income)
      const otherIncomeLineDeductions = otherIncomeCategories.reduce((sum, cat) => {
        if (!cat.addbackPct || cat.addbackPct <= 0 || cat.adjIncluded === false) return sum;
        const lineValue = cat[selectedValuationBasis]?.[yearKey] || 0;
        return sum + (lineValue * cat.addbackPct / 100);
      }, 0);
      
      // OpEx adjustments (including Rent Market Adj and CapEx)
      const opexAdds = adjustmentItems.filter(item => item.included && item.type === 'add' && (item.plLine === 'OpEx' || item.plLine.startsWith('OpEx: ') || item.plLine === 'Rent (Market Adj)' || item.plLine === 'CapEx') && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const opexDeducts = adjustmentItems.filter(item => item.included && item.type === 'deduct' && (item.plLine === 'OpEx' || item.plLine.startsWith('OpEx: ') || item.plLine === 'Rent (Market Adj)' || item.plLine === 'CapEx') && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const opexAdjustment = opexAdds - opexDeducts - opexLineAddbacks;
      
      // Owner market replacement (adds market to OpEx)
      const ownerCompPeriod = ownerCompensation[period];
      const marketReplacement = ocMarketFor(ownerCompensation, period);   // per-year owners/replacement (Colleen 10-26)
      // TTM salary: if not explicitly set and embeddedInWages, fall back to year5 salary
      const ownerSalary = ownerCompPeriod?.salary ||
        (period === 'ttm' && ownerCompensation.embeddedInWages ? (ownerCompensation.year5?.salary || 0) : 0);
      // Always calculate salary diff if market replacement is set, even if owner took $0 salary
      const ownerSalaryDiff = marketReplacement > 0 ? (ownerSalary - marketReplacement) : 0;
      const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
      // Payroll tax adjustment: (market - salary) * rate
      // Positive when market > salary (need to pay more taxes on replacement)
      // Negative when market < salary (tax savings from lower replacement cost)
      const ownerPayrollTaxAdj = ownerTaxAdj(ownerSalary, marketReplacement, period);
      // Always apply market replacement if set, regardless of whether owner took salary
      const ownerMarketAdj = marketReplacement;
      
      // Total OpEx adjustment including owner market and payroll tax
      const totalOpExAdjustment = opexAdjustment + ownerMarketAdj + ownerPayrollTaxAdj;
      const adjustedOpex = opExFromCategories + totalOpExAdjustment;
      
      // Other Income/Expense
      const otherIncome = otherIncomeAnalysis.totals[yearKey] || 0;
      const otherExpense = otherExpenseAnalysis.totals[yearKey] || 0;
      
      // Other Income adjustments
      const oiAdds = adjustmentItems.filter(item => item.included && item.type === 'add' && (item.plLine === 'Other Income' || item.plLine.startsWith('OtherIncome: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const oiDeducts = adjustmentItems.filter(item => item.included && item.type === 'deduct' && (item.plLine === 'Other Income' || item.plLine.startsWith('OtherIncome: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const oiAdjustment = oiAdds - oiDeducts - otherIncomeLineDeductions;
      const adjustedOtherIncome = otherIncome + oiAdjustment;
      
      // Other Expense adjustments
      const oeAdds = adjustmentItems.filter(item => item.included && item.type === 'add' && (item.plLine === 'Other Expense' || item.plLine.startsWith('OtherExpense: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const oeDeducts = adjustmentItems.filter(item => item.included && item.type === 'deduct' && (item.plLine === 'Other Expense' || item.plLine.startsWith('OtherExpense: ')) && (item.year === 'All Years' || item.year === yearMap[yearKey])).reduce((sum, item) => sum + item.amount, 0);
      const oeAdjustment = oeAdds - oeDeducts - otherExpenseLineAddbacks;
      const adjustedOtherExpense = otherExpense + oeAdjustment;
      
      // D/I/A/T totals from activeDiatCategories
      const diat = (activeDiatCategories.depreciation[yearKey] || 0) + (activeDiatCategories.interest[yearKey] || 0) + (activeDiatCategories.amortization[yearKey] || 0) + (activeDiatCategories.taxes[yearKey] || 0);
      
      // Total OpEx including D/I/A/T (for reference) - using old fields for compatibility
      const totalOpEx = opExFromCategories + diat;
      const opExWithoutDiat = opExFromCategories;
      
      // EBITDA = Gross Profit - OpEx (no owner) + Other Income - Other Expense (all from P&L actuals)
      const ebitda = (baseRevenue - cogs) - opExFromCategories + otherIncome - otherExpense;
      
      // Adjusted/Normalized EBITDA = using adjusted values
      // Note: EBITDA already excludes D/I/A/T, so no addbacks needed here
      const adjustedEbitda = grossProfit - adjustedOpex + adjustedOtherIncome - adjustedOtherExpense;
      
      // Net Income = EBITDA - D/I/A/T
      const netIncome = ebitda - diat;
      
      // Legacy fields for compatibility
      const expenseAdds = opexAdds + cogsAdds + oeAdds;
      const expenseDeducts = opexDeducts + cogsDeducts + oeDeducts + totalLineAddbacks;
      // Owner salary adjustment is JUST the salary difference (not combined with payroll tax)
      const ownerSalaryAdjustment = ownerSalaryDiff;
      // Maintenance capex already inside this year's adjustments (FCF basis, 10-20): category 'Maintenance CapEx' or the
      // CapEx line, on whatever expense line it was booked. Positive = it lowered EBITDA.
      const maintCapex = adjustmentItems.filter(item => item.included && (item.category === 'Maintenance CapEx' || item.plLine === 'CapEx') && (item.year === 'All Years' || item.year === yearMap[yearKey]))
        .reduce((sum, item) => sum + (item.type === 'add' ? 1 : -1) * (Number(item.amount) || 0), 0);
      
      return { 
        maintCapex,
        revenue: baseRevenue, 
        revenueAdjustment,
        adjustedRevenue,
        cogs,
        cogsAdjustment,
        adjustedCogs,
        grossProfit, 
        grossMargin: adjustedRevenue > 0 ? (grossProfit / adjustedRevenue) * 100 : 0, 
        totalOpEx,
        opex: opExFromCategories,
        opExWithoutDiat,
        opexAdjustment: totalOpExAdjustment,
        opexLineAddbacks,
        otherExpenseLineAddbacks,
        otherIncomeLineDeductions,
        totalLineAddbacks,
        adjustedOpex,
        otherIncome,
        otherExpense,
        adjustedOtherIncome,
        adjustedOtherExpense,
        diat,
        ebitda, 
        ebitdaMargin: baseRevenue > 0 ? (ebitda / baseRevenue) * 100 : 0,
        netIncome,
        netIncomeMargin: baseRevenue > 0 ? (netIncome / baseRevenue) * 100 : 0,
        expenseAdds,
        expenseDeducts,
        ownerSalaryAdjustment,
        ownerPayrollTaxAdj,
        adjustedEbitda, 
        adjustedEbitdaMargin: adjustedRevenue > 0 ? (adjustedEbitda / adjustedRevenue) * 100 : 0, 
        ...yearData 
      };
    };
    const y1 = calcYear(activeFinancialData.year1, 'year1');
    const y2 = calcYear(activeFinancialData.year2, 'year2');
    const y3 = calcYear(activeFinancialData.year3, 'year3');
    const y4 = calcYear(activeFinancialData.year4, 'year4');
    const y5 = calcYear(activeFinancialData.year5, 'year5');
    const ttm = calcYear(activeFinancialData.ttm, 'ttm');
    
    // Check if Year5 and TTM are the same period (use revenueAnalysis detection based on base revenue)
    const ebitdaYear5TtmSame = revenueAnalysis?.year5TtmSame || false;
    
    // YoY changes - return null for years without data
    const calcEbitdaYoY = (curr, prev) => {
      if (!prev || prev <= 0 || !curr) return null;
      return ((curr - prev) / prev) * 100;
    };
    
    const ebitdaYoYChanges = { 
      year3to4: calcEbitdaYoY(y4.adjustedEbitda, y3.adjustedEbitda), 
      year4to5: calcEbitdaYoY(y5.adjustedEbitda, y4.adjustedEbitda), 
      year5toTTM: calcEbitdaYoY(ttm.adjustedEbitda, y5.adjustedEbitda) 
    };
    
    // For variance calculation, only use years with actual data
    // Skip year5toTTM if they're the same period
    const validEbitdaChanges = [];
    if (ebitdaYoYChanges.year3to4 !== null) validEbitdaChanges.push(ebitdaYoYChanges.year3to4);
    if (ebitdaYoYChanges.year4to5 !== null) validEbitdaChanges.push(ebitdaYoYChanges.year4to5);
    if (ebitdaYoYChanges.year5toTTM !== null && !ebitdaYear5TtmSame) validEbitdaChanges.push(ebitdaYoYChanges.year5toTTM);
    
    // Calculate variance only from valid changes
    let ebitdaYoYVariance = 0;
    let avgEbitdaChange = 0;
    if (validEbitdaChanges.length >= 2) {
      avgEbitdaChange = validEbitdaChanges.reduce((a, b) => a + b, 0) / validEbitdaChanges.length;
      ebitdaYoYVariance = Math.sqrt(validEbitdaChanges.reduce((sum, c) => sum + Math.pow(c - avgEbitdaChange, 2), 0) / validEbitdaChanges.length);
    } else if (validEbitdaChanges.length === 1) {
      avgEbitdaChange = validEbitdaChanges[0];
      ebitdaYoYVariance = 0;
    }
    
    // Calculate valuation metric based on weighting method - uses most recent 3 years (y3, y4, y5)
    let valuationMetric;
    const ebitdaValues = { year1: y1.adjustedEbitda, year2: y2.adjustedEbitda, year3: y3.adjustedEbitda, year4: y4.adjustedEbitda, year5: y5.adjustedEbitda, ttm: ttm.adjustedEbitda };
    
    // 3-Year calculations using most recent 3 calendar years (y3, y4, y5)
    const includedYears = [
      valuationInputs.includeYear1 ? ebitdaValues.year3 : null,
      valuationInputs.includeYear2 ? ebitdaValues.year4 : null,
      valuationInputs.includeYear3 ? ebitdaValues.year5 : null
    ].filter(v => v !== null);
    const avg3Year = includedYears.length > 0 ? includedYears.reduce((a, b) => a + b, 0) / includedYears.length : y5.adjustedEbitda;
    
    // Weighted calculation using custom weights
    const w1 = valuationInputs.includeYear1 ? valuationInputs.weightYear1 : 0;
    const w2 = valuationInputs.includeYear2 ? valuationInputs.weightYear2 : 0;
    const w3 = valuationInputs.includeYear3 ? valuationInputs.weightYear3 : 0;
    const totalWeight = w1 + w2 + w3;
    const weighted3Year = totalWeight > 0 ? (ebitdaValues.year3 * w1 + ebitdaValues.year4 * w2 + ebitdaValues.year5 * w3) / totalWeight : y5.adjustedEbitda;
    
    switch (valuationInputs.weightingMethod) {
      case 'ttm': valuationMetric = ttm.adjustedEbitda; break;
      case 'lastYear': valuationMetric = y5.adjustedEbitda; break;
      case 'average': valuationMetric = avg3Year; break;
      case 'weighted': valuationMetric = weighted3Year; break;
      default: valuationMetric = ttm.adjustedEbitda;
    }
    // Maintenance capex inside the valuation metric (FCF basis): same period and weighting as the metric itself.
    let metricCapex;
    {
      const cv = { year3: y3.maintCapex || 0, year4: y4.maintCapex || 0, year5: y5.maintCapex || 0 };
      const inc = [valuationInputs.includeYear1 ? cv.year3 : null, valuationInputs.includeYear2 ? cv.year4 : null, valuationInputs.includeYear3 ? cv.year5 : null].filter(v => v !== null);
      switch (valuationInputs.weightingMethod) {
        case 'lastYear': metricCapex = cv.year5; break;
        case 'average': metricCapex = inc.length ? inc.reduce((a, b) => a + b, 0) / inc.length : cv.year5; break;
        case 'weighted': metricCapex = totalWeight > 0 ? (cv.year3 * w1 + cv.year4 * w2 + cv.year5 * w3) / totalWeight : cv.year5; break;
        default: metricCapex = ttm.maintCapex || 0;
      }
    }
    
    return { 
      years: [y1, y2, y3, y4, y5, ttm], 
      ebitdaYoYChanges, 
      ebitdaYoYVariance,
      ebitdaYear5TtmSame,
      ebitdaValues, 
      ebitdaOptions: { ttm: ttm.adjustedEbitda, lastYear: y5.adjustedEbitda, average: avg3Year, weighted: weighted3Year }, 
      valuation: { maintCapex: metricCapex, metricBeforeCapex: valuationMetric + metricCapex, valuationMin: valuationMetric * valuationInputs.multipleMin, valuationMax: valuationMetric * valuationInputs.multipleMax, valuationMid: valuationMetric * (valuationInputs.multipleMin + valuationInputs.multipleMax) / 2, metric: valuationMetric } 
    };
  }, [activeFinancialData, addbacks, valuationInputs, adjustmentItems, ownerCompensation, revenueAnalysis, cogsAnalysis, otherIncomeAnalysis, otherExpenseAnalysis, basisYearLabels, activeOpexCategories, activeDiatCategories]);

  // ========== NORMALIZED MONTHLY EBITDA (for negative months count) ==========
  const normalizedEbitdaMonthly = useMemo(() => {
    if (!ebitdaMonthlyAnalysis.hasMonthlyData) {
      return { ...ebitdaMonthlyAnalysis };
    }
    
    // Get monthly labels for matching (first 12 are TTM months)
    const monthLabels = monthlyTtmLabels.slice(0, 12);
    
    // Get the authoritative total TTM adjustment from calculations
    const totalTtmAdjustment = (calculations?.years?.[5]?.adjustedEbitda || 0) - (calculations?.years?.[5]?.ebitda || 0);
    
    // Get TTM-applicable adjustments with month-specific attribution
    const ttmAdjustments = adjustmentItems.filter(adj => 
      adj.included && (adj.year === 'TTM' || adj.year === 'All Years')
    );
    
    // Identify month-specific adjustments
    const monthSpecificAdjs = ttmAdjustments.filter(adj => adj.ttmMonth && adj.ttmMonth !== 'spread');
    
    // Calculate month-specific amounts per month
    const monthSpecificByMonth = {};
    let monthSpecificTotal = 0;
    monthLabels.forEach(label => { monthSpecificByMonth[label] = 0; });
    
    // EBITDA impact of an adjustment, matching the annual model's per-P&L-line sign:
    //   income lines (Revenue, Other Income): add raises EBITDA, deduct lowers it
    //   expense lines (COGS, OpEx, Rent Market Adj, CapEx, Other Expense): add lowers EBITDA, deduct raises it
    // Unrecognized lines contribute 0, same as the annual filters that wouldn't match them.
    const ebitdaImpactOf = (adj) => {
      const pl = adj.plLine || '';
      const sign = adj.type === 'add' ? 1 : -1;
      const amt = adj.amount || 0;
      if (pl === 'Revenue' || pl.startsWith('Revenue: ')) return sign * amt;
      if (pl === 'Other Income' || pl.startsWith('OtherIncome: ')) return sign * amt;
      if (pl === 'COGS' || pl.startsWith('COGS: ')) return -sign * amt;
      if (pl === 'OpEx' || pl.startsWith('OpEx: ') || pl === 'Rent (Market Adj)' || pl === 'CapEx') return -sign * amt;
      if (pl === 'Other Expense' || pl.startsWith('OtherExpense: ')) return -sign * amt;
      return 0;
    };

    monthSpecificAdjs.forEach(adj => {
      const monthLabel = adj.ttmMonth;
      if (monthSpecificByMonth.hasOwnProperty(monthLabel)) {
        const impact = ebitdaImpactOf(adj);
        monthSpecificByMonth[monthLabel] += impact;
        monthSpecificTotal += impact;
      }
    });
    
    // Calculate spread adjustment: total minus month-specific amounts, divided by 12
    const spreadTotal = totalTtmAdjustment - monthSpecificTotal;
    const monthlySpreadAdjustment = spreadTotal / 12;
    
    // Apply adjustments to get NORMALIZED monthly EBITDA
    const monthlyEbitdaNormalized = (ebitdaMonthlyAnalysis.monthlyEbitdaActual || []).map((e, idx) => {
      const monthLabel = monthLabels[idx];
      const specificAdj = monthSpecificByMonth[monthLabel] || 0;
      return e + monthlySpreadAdjustment + specificAdj;
    });
    
    // Count negative EBITDA months using NORMALIZED values
    const negativeMonths = monthlyEbitdaNormalized.filter(e => e < 0).length;
    
    // Recalculate stats with normalized values
    const monthlyAvg = monthlyEbitdaNormalized.reduce((a, b) => a + b, 0) / 12;
    const monthlyStdDev = Math.sqrt(monthlyEbitdaNormalized.reduce((sum, m) => sum + Math.pow(m - monthlyAvg, 2), 0) / 12);
    const monthlyCV = monthlyAvg !== 0 ? Math.abs((monthlyStdDev / monthlyAvg) * 100) : 0;
    
    return {
      ...ebitdaMonthlyAnalysis,
      monthlyEbitda: monthlyEbitdaNormalized,
      negativeMonths,
      monthlyAvg,
      monthlyStdDev,
      monthlyCV,
      totalAdjustment: totalTtmAdjustment,
      monthlyAdjustment: monthlySpreadAdjustment,
      hasMonthSpecificAdj: monthSpecificAdjs.length > 0,
      monthSpecificTotal
    };
  }, [ebitdaMonthlyAnalysis, calculations, adjustmentItems, monthlyTtmLabels]);

  // ========== YTD TREND ANALYSIS FLAGS ==========
  const ytdTrendFlags = useMemo(() => {
    const flags = [];
    const fmtCurrency = (num) => `$${num.toLocaleString()}`;
    
    // Flag if annualized EBITDA significantly differs from TTM
    const annualizedEbitda = ytdAnnualized.ebitda.annualized;
    const ttmEbitda = calculations.years[5].ebitda;
    
    if (ytdAnnualized.ytdMonthCount >= 3 && annualizedEbitda > 0 && ttmEbitda > 0) {
      const ytdVsTtmPct = ((annualizedEbitda - ttmEbitda) / ttmEbitda) * 100;
      if (ytdVsTtmPct > 15) {
        flags.push({
          key: 'ytd-outpacing-ttm',
          category: 'Trend Analysis',
          severity: 'info',
          item: 'YTD EBITDA Outpacing TTM',
          detail: `Annualized EBITDA (${fmtCurrency(annualizedEbitda)}) is ${ytdVsTtmPct.toFixed(1)}% higher than TTM (${fmtCurrency(ttmEbitda)})`,
          action: 'Investigate: Is this sustainable growth, seasonality, or a one-time event?',
          canResolveAt: 'Income Stmt tab → Review Actuals view',
          resolveTab: 'detailed'
        });
      } else if (ytdVsTtmPct < -15) {
        flags.push({
          key: 'ytd-lagging-ttm',
          category: 'Trend Analysis',
          severity: 'warning',
          item: 'YTD EBITDA Lagging TTM',
          detail: `Annualized EBITDA (${fmtCurrency(annualizedEbitda)}) is ${Math.abs(ytdVsTtmPct).toFixed(1)}% lower than TTM (${fmtCurrency(ttmEbitda)})`,
          action: 'Investigate: Is business declining, seasonal, or facing temporary issues?',
          canResolveAt: 'Income Stmt tab → Review Actuals view',
          resolveTab: 'detailed'
        });
      }
    }
    return flags;
  }, [ytdAnnualized, calculations]);

  // ========== KEY METRICS ==========
  const keyMetrics = useMemo(() => {
    try {
    // Ensure customerSalesData is always an array
    const safeCustomerSalesData = customerSalesData || [];
    // Named clients vs the "All Others" remainder row: remainder counts in
    // every TOTAL (honest denominators) and in nothing per-client.
    const namedCustomers = safeCustomerSalesData.filter(c => !isRemainderRow(c));

    // Parse employee count from Q&A (id: 10 - "How many employees does the company have?")
    const employeeQA = sellerQA.find(q => q.id === 10);
    // Use numericValue if available, otherwise try to parse from answer text
    const employeeCount = employeeQA?.numericValue || (employeeQA?.answer?.match(/\d+/) ? parseInt(employeeQA.answer.match(/\d+/)[0]) : null);
    
    // Revenue per employee (using TTM, index 5)
    const revenuePerEmployee = employeeCount && employeeCount > 0 ? calculations.years[5].revenue / employeeCount : null;
    
    // Customer concentration (calculated from customerSalesData)
    // Smart fallback: Use TTM if available, otherwise Year5
    const customerTotals = { ttm: 0, year5: 0 };
    safeCustomerSalesData.forEach(c => {
      customerTotals.ttm += c.ttm || 0;
      customerTotals.year5 += c.year5 || 0;
    });
    
    // Determine which period to use for concentration: TTM preferred, Year5 fallback
    const concentrationPeriod = customerTotals.ttm > 0 ? 'ttm' : (customerTotals.year5 > 0 ? 'year5' : 'ttm');
    const concentrationTotal = concentrationPeriod === 'ttm' ? customerTotals.ttm : customerTotals.year5;
    const concentrationSource = customerTotals.ttm > 0 ? 'TTM' : (customerTotals.year5 > 0 ? 'Year5' : null);
    
    // Sort by the active concentration period — NAMED clients only (the
    // remainder row must never rank as "the top customer"), but percentages
    // divide by the full-book total including the remainder.
    const sortedByConcentration = [...namedCustomers].sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0));
    const topCustomerPct = concentrationTotal > 0 ? ((sortedByConcentration[0]?.[concentrationPeriod] || 0) / concentrationTotal * 100) : 0;
    const top5CustomersPct = concentrationTotal > 0 ? (sortedByConcentration.slice(0, 5).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / concentrationTotal * 100) : 0;
    const top10CustomersPct = concentrationTotal > 0 ? (sortedByConcentration.slice(0, 10).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / concentrationTotal * 100) : 0;

    // Residential/consumer revenue share — only EXPLICITLY typed clients count
    // (untyped books must not read as residential; the transactional-book test
    // in the retention factor has a separate concentration-signature path).
    // Feeds the Zac-approved 2026-07-21 transactional-book classification.
    const residentialRevenue = safeCustomerSalesData.filter(c => {
      const type = (c.customerType || '').toUpperCase();
      return type.includes('RESIDENTIAL') || type.includes('CONSUMER') || type.includes('B2C');
    }).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const residentialPct = concentrationTotal > 0 ? (residentialRevenue / concentrationTotal * 100) : 0;

    // Also keep sortedByTTM for backward compatibility with other code
    const sortedByTTM = [...namedCustomers].sort((a, b) => (b.ttm || 0) - (a.ttm || 0));
    
    // Contract quality metrics (from Sales tab) - use concentration period for "current" customers
    // ── Top-20 engine fix (Mark 2026-08-04, "exact or nothing — DD exposes
    // every number"): detail is only COLLECTED for the ask-set (all clients
    // on small books, top 20 above that), so detail metrics are scored over
    // the revenue the detail actually covers — never extrapolated to the
    // un-asked tail, and the tail is never punished as month-to-month for
    // paperwork nobody requested. Coverage is disclosed everywhere.
    const currentCustomers = namedCustomers.filter(c => (c[concentrationPeriod] || 0) > 0);
    const totalCurrentRevenue = currentCustomers.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const remainderCurrentRevenue = safeCustomerSalesData.filter(c => isRemainderRow(c))
      .reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const totalBookRevenue = totalCurrentRevenue + remainderCurrentRevenue;
    // Ask-set mirrors the collection rule: ≤40 named clients → all of them;
    // above → top 20 by revenue. Plus any row with an explicit answer outside
    // the set (hand-entered detail today; the yes/no sweep's contractAnswered
    // flag when the ask-side slice ships).
    const ASK_ALL_MAX = 40, ASK_TOP_N = 20;
    const askSet = currentCustomers.length <= ASK_ALL_MAX
      ? currentCustomers
      : [...currentCustomers].sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0)).slice(0, ASK_TOP_N);
    const askSetIds = new Set(askSet.map(c => c.id));
    // UN-ASKED ≠ answered-no (Concise Computer 08-19, the A4 law's D twin:
    // the owner filled only his current clients; every untouched row sat in
    // the denominators voting "no" on every term feature). A row with NO
    // owner-provided detail at all — nothing beyond name + revenue — is
    // un-asked and counts NEITHER way. A row that WAS touched (any detail
    // field set) with unchecked contract boxes remains an honest "no".
    // detailCoveragePct below now reports true answered coverage, and the
    // D card already prints it.
    const rowTouched = (c) => !!(
      c.hasContract === true || c.contractAnswered === true
      || (c.contractMonths !== null && c.contractMonths !== undefined)
      || c.contractStart || c.contractEnd
      || c.assignable || c.priceEscalator || c.earlyTermPenalty || c.autoRenewal
      || (c.billingFrequency && String(c.billingFrequency).trim())
      || (c.tenure && parseFloat(c.tenure) > 0)
      || (c.customerType && String(c.customerType).trim())
      || (c.industry && String(c.industry).trim())
    );
    const detailedRows = [...askSet.filter(rowTouched), ...currentCustomers.filter(c => !askSetIds.has(c.id) && (c.hasContract === true || c.contractAnswered === true))];
    const detailedRevenue = detailedRows.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const detailCoveragePct = totalBookRevenue > 0 ? (detailedRevenue / totalBookRevenue * 100) : 0;
    // Active clients the owner skipped (Colleen 09-30, Concise: "some of his active clients he didn't
    // check"). They count neither way in the %, so staff see how many and how much revenue to confirm.
    const detailedIds = new Set(detailedRows.map(c => c.id));
    const unansweredActive = currentCustomers.filter(c => !detailedIds.has(c.id));
    const unansweredActiveCount = unansweredActive.length;
    // Client-count view of the owner's answers (Mark 09-30): "32 of 42 clients, owner-reported" — a
    // count, never a revenue claim. The revenue claim is contractCoveragePct (the books).
    const agreementClientCount = detailedRows.filter(c => c.hasContract).length;
    const activeClientCount = currentCustomers.length;
    const unansweredActivePct = totalBookRevenue > 0 ? (unansweredActive.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / totalBookRevenue * 100) : 0;
    const remainderRevPct = totalBookRevenue > 0 ? (remainderCurrentRevenue / totalBookRevenue * 100) : 0;

    // Revenue-weighted contract metrics — % of DETAILED revenue covered by
    // each feature (quality-of-known; the coverage line says how much of the
    // book that is). More meaningful than client count: 5 of 12 clients
    // contracted at 80% of revenue is fundamentally different from 5 small
    // clients at 15% of revenue.
    const revOf = (filter) => detailedRows.filter(filter).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const detailedContractedRev = revOf(c => c.hasContract);
    const detailedContractedPct = detailedRevenue > 0 ? (detailedContractedRev / detailedRevenue * 100) : 0;
    // SWEEP ROWS ANSWERED ONE QUESTION (Colleen/Mark 09-29, Mojo): clients outside
    // the ask-set get only the one-tap "under contract?" — so they count toward
    // contracted % above, but NOT in the term features below, which they were
    // never asked. Their blank auto-renew / assignable / escalator / penalty
    // boxes (defaults false) were voting "no": Mojo's 93 sweep clients held
    // auto-renew and assignable at 52% when every client actually asked said
    // yes. Same law as the un-asked rows above, applied per feature.
    const featureAsked = (c) => askSetIds.has(c.id)
      || c.autoRenewal || c.assignable || c.priceEscalator || c.earlyTermPenalty
      || (c.contractMonths !== null && c.contractMonths !== undefined);
    const featureRows = detailedRows.filter(featureAsked);
    const featureRevenue = featureRows.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const revOfF = (filter) => featureRows.filter(filter).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const assignablePct = featureRevenue > 0 ? (revOfF(c => c.assignable) / featureRevenue * 100) : 0;
    const escalatorPct = featureRevenue > 0 ? (revOfF(c => c.priceEscalator) / featureRevenue * 100) : 0;
    const avgEscalatorRate = featureRows.filter(c => c.priceEscalator && c.escalatorPercent).length > 0
      ? featureRows.filter(c => c.priceEscalator && c.escalatorPercent).reduce((s, c) => s + c.escalatorPercent, 0) / featureRows.filter(c => c.priceEscalator && c.escalatorPercent).length
      : 0;
    const termPenaltyPct = featureRevenue > 0 ? (revOfF(c => c.earlyTermPenalty) / featureRevenue * 100) : 0;
    const autoRenewalPct = featureRevenue > 0 ? (revOfF(c => c.autoRenewal) / featureRevenue * 100) : 0;
    
    // Calculate average contract length in months
    // Priority: 1) Direct entry (contractMonths), 2) Calculated from dates, 3) Company default
    // Note: contractMonths = 1 means month-to-month (M2M), null/undefined means unknown
    const getContractLength = (c) => {
      // Priority 1: Direct entry (including 0 for M2M)
      if (c.contractMonths !== null && c.contractMonths !== undefined) return c.contractMonths;
      // Priority 2: Calculate from dates
      if (c.contractStart && c.contractEnd) {
        const start = new Date(c.contractStart);
        const end = new Date(c.contractEnd);
        if (!isNaN(start) && !isNaN(end)) {
          const months = (end - start) / (1000 * 60 * 60 * 24 * 30.44);
          if (months > 0) return months;
        }
      }
      // Priority 3: Company default
      if (dealProfile.typicalContractMonths && dealProfile.typicalContractMonths > 0) {
        return dealProfile.typicalContractMonths;
      }
      return null;
    };
    
    const contractedWithLength = detailedRows.filter(c => c.hasContract && getContractLength(c) !== null);
    // For average, treat M2M (0) as 1 month since they can cancel anytime
    const avgContractMonths = contractedWithLength.length > 0
      ? contractedWithLength.reduce((sum, c) => {
          const len = getContractLength(c);
          return sum + (len === 0 ? 1 : len); // M2M counted as 1 month
        }, 0) / contractedWithLength.length
      : null;

    // Revenue-weighted contract-length buckets. Factor D used to score the AVERAGE
    // length among contracted clients, which over-credited a base where only a few
    // top clients carried multiyear terms (the whole base wasn't multiyear — Zac,
    // Network PHD). These let D weight the length premium by the SHARE of revenue
    // actually under each term length, so partial coverage earns partial credit.
    // Denominator = rows whose length was asked (ask-set / explicit entry) or is
    // known (a company-default length covers sweep rows too). Sweep rows never
    // asked their length don't dilute the buckets (Mojo 09-29: 12-month terms on
    // every asked client, yet "annual" read 52% with the sweep in the base).
    const lengthRows = detailedRows.filter(c => featureAsked(c) || getContractLength(c) !== null);
    const lengthRevenue = lengthRows.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const revShare = (filter) => lengthRevenue > 0 ? (lengthRows.filter(filter).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / lengthRevenue * 100) : 0;
    const multiYearRevPct = revShare(c => c.hasContract && getContractLength(c) !== null && getContractLength(c) >= 36);
    const midTermRevPct   = revShare(c => c.hasContract && getContractLength(c) !== null && getContractLength(c) >= 24 && getContractLength(c) < 36);
    const annualRevPct    = revShare(c => c.hasContract && getContractLength(c) !== null && getContractLength(c) >= 12 && getContractLength(c) < 24);
    const shortTermRevPct = revShare(c => c.hasContract && getContractLength(c) !== null && getContractLength(c) < 12);

    // Near-term contract expirations — buyers discount a book whose protection lapses
    // within ~12 months even when an auto-renewal clause exists (Zac, UVS precedent:
    // top clients terming in-year drew heavy buyer concern). Derive an end date from
    // contractEnd, or contractStart + contractMonths.
    const _expNowMs = new Date().getTime();
    const _expYearMs = 365 * 24 * 60 * 60 * 1000;
    const contractEndMsOf = (c) => {
      if (c.contractEnd) { const d = new Date(c.contractEnd); if (!isNaN(d.getTime())) return d.getTime(); }
      if (c.contractStart && c.contractMonths) {
        const s = new Date(c.contractStart);
        if (!isNaN(s.getTime())) { const e = new Date(s); e.setMonth(e.getMonth() + c.contractMonths); return e.getTime(); }
      }
      return null;
    };
    const _expiringSoon = (c) => { if (!c.hasContract) return false; const e = contractEndMsOf(c); return e !== null && e <= _expNowMs + _expYearMs; };
    const nearTermExpiringRevPct = detailedRevenue > 0 ? (revOf(_expiringSoon) / detailedRevenue * 100) : 0;
    const hasExpirationData = detailedRows.some(c => c.hasContract && contractEndMsOf(c) !== null);
    
    // Margins (using TTM, index 5)
    const ebitdaMargin = calculations.years[5].adjustedEbitdaMargin;
    const grossMargin = calculations.years[5].grossMargin;
    
    // 3-year CAGRs (from year3 to year5, indices 2-4)
    // CAGR on ADJUSTED revenue (hurricane note in revenueAnalysis): a
    // one-time spike adjusted out of a year no longer poisons the trend.
    const revCAGR = calculations.years[2].adjustedRevenue > 0 ? (Math.pow(calculations.years[4].adjustedRevenue / calculations.years[2].adjustedRevenue, 0.5) - 1) * 100 : null;
    const ebitdaCAGR = calculations.years[2].adjustedEbitda > 0 ? (Math.pow(calculations.years[4].adjustedEbitda / calculations.years[2].adjustedEbitda, 0.5) - 1) * 100 : null;
    
    // Recurring revenue % — matches the valuation period, not a blind average
    // If valuing on TTM EBITDA, use TTM recurring %. If year5, use year5. etc.
    const recurringByPeriod = revenueAnalysis.weightedRecurringPct || {};
    const contractedByPeriod = revenueAnalysis.contractedOnlyPct || {};
    let recurringPct, contractedRecurringPct;
    switch (valuationInputs.weightingMethod) {
      case 'ttm': 
        recurringPct = recurringByPeriod.ttm || 0; 
        contractedRecurringPct = contractedByPeriod.ttm || 0;
        break;
      case 'lastYear': 
        recurringPct = recurringByPeriod.year5 || 0; 
        contractedRecurringPct = contractedByPeriod.year5 || 0;
        break;
      case 'average': {
        const incYears = [
          valuationInputs.includeYear1 && recurringByPeriod.year3 !== undefined ? recurringByPeriod.year3 : null,
          valuationInputs.includeYear2 && recurringByPeriod.year4 !== undefined ? recurringByPeriod.year4 : null,
          valuationInputs.includeYear3 && recurringByPeriod.year5 !== undefined ? recurringByPeriod.year5 : null
        ].filter(v => v !== null);
        recurringPct = incYears.length > 0 ? incYears.reduce((a, b) => a + b, 0) / incYears.length : (recurringByPeriod.ttm || 0);
        const incContract = [
          valuationInputs.includeYear1 ? contractedByPeriod.year3 : null,
          valuationInputs.includeYear2 ? contractedByPeriod.year4 : null,
          valuationInputs.includeYear3 ? contractedByPeriod.year5 : null
        ].filter(v => v !== null);
        contractedRecurringPct = incContract.length > 0 ? incContract.reduce((a, b) => a + b, 0) / incContract.length : (contractedByPeriod.ttm || 0);
        break;
      }
      case 'weighted': {
        const rw1 = valuationInputs.includeYear1 ? valuationInputs.weightYear1 : 0;
        const rw2 = valuationInputs.includeYear2 ? valuationInputs.weightYear2 : 0;
        const rw3 = valuationInputs.includeYear3 ? valuationInputs.weightYear3 : 0;
        const rwTotal = rw1 + rw2 + rw3;
        recurringPct = rwTotal > 0 ? ((recurringByPeriod.year3 || 0) * rw1 + (recurringByPeriod.year4 || 0) * rw2 + (recurringByPeriod.year5 || 0) * rw3) / rwTotal : (recurringByPeriod.ttm || 0);
        contractedRecurringPct = rwTotal > 0 ? ((contractedByPeriod.year3 || 0) * rw1 + (contractedByPeriod.year4 || 0) * rw2 + (contractedByPeriod.year5 || 0) * rw3) / rwTotal : (contractedByPeriod.ttm || 0);
        break;
      }
      default:
        recurringPct = recurringByPeriod.ttm || 0;
        contractedRecurringPct = contractedByPeriod.ttm || 0;
    }
    // Legacy strict % on the same period rule — grandfathered valuations' scoring only (Mark 10-06).
    const contractedRecurringPctLegacy = (() => {
      const o = revenueAnalysis.contractedOnlyPctLegacy || {};
      const wm = valuationInputs.weightingMethod;
      if (wm === 'lastYear') return o.year5 || 0;
      if (wm === 'average' || wm === 'weighted') {
        const w = [valuationInputs.includeYear1 ? (wm === 'weighted' ? valuationInputs.weightYear1 : 1) : 0,
          valuationInputs.includeYear2 ? (wm === 'weighted' ? valuationInputs.weightYear2 : 1) : 0,
          valuationInputs.includeYear3 ? (wm === 'weighted' ? valuationInputs.weightYear3 : 1) : 0];
        const wt = w[0] + w[1] + w[2];
        return wt > 0 ? ((o.year3 || 0) * w[0] + (o.year4 || 0) * w[1] + (o.year5 || 0) * w[2]) / wt : (o.ttm || 0);
      }
      return o.ttm || 0;
    })();
    // Same period rule, applied to "revenue from clients under agreement".
    const clientByPeriod = revenueAnalysis.clientContractedPct || {};
    const contractedClientRevPct = (() => {
      const wm = valuationInputs.weightingMethod;
      if (wm === 'lastYear') return clientByPeriod.year5 || 0;
      if (wm === 'average' || wm === 'weighted') {
        const w = [valuationInputs.includeYear1 ? (wm === 'weighted' ? valuationInputs.weightYear1 : 1) : 0,
          valuationInputs.includeYear2 ? (wm === 'weighted' ? valuationInputs.weightYear2 : 1) : 0,
          valuationInputs.includeYear3 ? (wm === 'weighted' ? valuationInputs.weightYear3 : 1) : 0];
        const wt = w[0] + w[1] + w[2];
        return wt > 0 ? ((clientByPeriod.year3 || 0) * w[0] + (clientByPeriod.year4 || 0) * w[1] + (clientByPeriod.year5 || 0) * w[2]) / wt : (clientByPeriod.ttm || 0);
      }
      return clientByPeriod.ttm || 0;
    })();

    // ── Whole-book "% under contract" — EXACT sources only (Mark 2026-08-04:
    // DD exposes every number; an estimate must never move the multiple).
    // LEDGER FIRST: the Revenue Classification types 100% of revenue and is
    // staff-verified — that IS the defensible whole-book figure. Fallback:
    // observed per-client answers over the whole book (numerator counts only
    // answered rows; the un-asked tail contributes nothing either way). ──
    const ledgerHasSignal = (contractedRecurringPct > 0 || recurringPct > 0);
    const contractCoveragePct = ledgerHasSignal
      ? contractedRecurringPct
      : (totalBookRevenue > 0 ? (detailedContractedRev / totalBookRevenue * 100) : 0);
    const contractCoverageSource = ledgerHasSignal ? 'ledger' : (detailedRevenue > 0 ? 'clients' : null);
    const contractCoveragePctLegacy = ledgerHasSignal
      ? contractedRecurringPctLegacy
      : (totalBookRevenue > 0 ? (detailedContractedRev / totalBookRevenue * 100) : 0);
    // Legacy consumers (display, exports) get the honest whole-book figure.
    const contractedPct = contractCoveragePct;

    // Adjustment documentation % (included adjustments only)
    const includedAdjustments = adjustmentItems.filter(a => a.included);
    const documentedAdjustments = includedAdjustments.filter(a => a.source);
    const verifiedPct = includedAdjustments.length > 0 ? (documentedAdjustments.length / includedAdjustments.length) * 100 : null;
    
    // Total adjustments / EBITDA % (shows how much normalization is happening) - using TTM
    const totalAdjustmentsAmt = calculations.years[5].expenseDeducts - calculations.years[5].expenseAdds + calculations.years[5].ownerSalaryAdjustment;
    const baseEbitda = calculations.years[5].ebitda;
    const adjustmentsToEbitdaPct = baseEbitda !== 0 ? (totalAdjustmentsAmt / Math.abs(baseEbitda)) * 100 : null;
    
    // Customer Retention (calculated from customerSalesData - 3yr average of year3→4, year4→5, year5→TTM)
    // If a customer is owner-flagged as 'lost', treat their current-period revenue as $0 for retention
    const calcRetention = (prevYear, currYear) => {
      const prevCustomers = namedCustomers.filter(c => (c[prevYear] || 0) > 0);
      const retainedRevenue = prevCustomers.reduce((s, c) => {
        // If customer is flagged lost AND currYear is TTM, treat as $0 retained
        if (c.lost && currYear === 'ttm') return s;
        return s + Math.min(c[prevYear] || 0, c[currYear] || 0);
      }, 0);
      const prevTotal = prevCustomers.reduce((s, c) => s + (c[prevYear] || 0), 0);
      return prevTotal > 0 ? (retainedRevenue / prevTotal * 100) : null;
    };
    const retention3to4 = calcRetention('year3', 'year4');
    const retention4to5 = calcRetention('year4', 'year5');
    const retention5toTTM = calcRetention('year5', 'ttm');
    const retentionValues = [retention3to4, retention4to5, retention5toTTM].filter(r => r !== null);
    const avgRetention = retentionValues.length > 0 ? retentionValues.reduce((a, b) => a + b, 0) / retentionValues.length : null;
    
    // Net Revenue Retention (NRR) - can exceed 100% if existing customers grow
    // If a customer is owner-flagged as 'lost', treat their current-period revenue as $0
    const calcNRR = (prevYear, currYear) => {
      if (namedCustomers.length === 0) return null;
      const prevCustomers = namedCustomers.filter(c => (c[prevYear] || 0) > 0);
      const currRevenueFromPrev = prevCustomers.reduce((s, c) => {
        if (c.lost && currYear === 'ttm') return s; // Flagged lost → $0
        return s + (c[currYear] || 0);
      }, 0);
      const prevTotal = prevCustomers.reduce((s, c) => s + (c[prevYear] || 0), 0);
      return prevTotal > 0 ? (currRevenueFromPrev / prevTotal * 100) : null;
    };
    const nrr4to5 = calcNRR('year4', 'year5');
    const nrr5toTTM = calcNRR('year5', 'ttm');
    const nrrValues = [nrr4to5, nrr5toTTM].filter(r => r !== null);
    const avgNRR = nrrValues.length > 0 ? nrrValues.reduce((a, b) => a + b, 0) / nrrValues.length : null;
    
    // Customer count by year (exclude owner-flagged 'lost' from TTM active count)
    const customerCount = {
      year3: namedCustomers.filter(c => (c.year3 || 0) > 0).length,
      year4: namedCustomers.filter(c => (c.year4 || 0) > 0).length,
      year5: namedCustomers.filter(c => (c.year5 || 0) > 0).length,
      ttm: namedCustomers.filter(c => (c.ttm || 0) > 0 && !c.lost).length
    };
    // Growth can only be CLAIMED against real prior-year data (Zac-approved
    // fix, 2026-07-21): a TTM-only client import has year5 = 0, and "grew from
    // 0 to N clients" was awarding a spurious +0.15x on the multiple.
    const customerCountGrowing = customerCount.year5 > 0 && (customerCount.ttm > customerCount.year5 || (customerCount.year5 > customerCount.year4 && customerCount.ttm >= customerCount.year5));
    
    // Revenue growth check (using revenueAnalysis) - with null safety
    const yc = revenueAnalysis?.yoyChanges || {};
    const separateTtm = yc.year5toTTM !== null && yc.year5toTTM !== undefined && !revenueAnalysis?.year5TtmSame;
    const revenueGrowingYoY = growthTest === 'either'
      ? (yc.year5toTTM || 0) > 0 || (yc.year4to5 || 0) > 0           // grandfathered (presented before 10-21)
      : (separateTtm ? yc.year5toTTM > 0 : (yc.year4to5 || 0) > 0);   // the most recent period decides
    
    // TTM Client Churn (calculated from customerSalesData)
    // Detect if Year5 and TTM have essentially the same data (same period)
    const year5Total = customerTotals.year5 || 0;
    const ttmTotal = customerTotals.ttm || 0;
    const year4Total = customerTotals.year4 || 0;
    
    // Check if Year5 and TTM are the same period:
    // 1. Both have data and are within 5% of each other, OR
    // 2. TTM total equals Year5 total exactly
    const ttmEqualsYear5 = year5Total > 0 && ttmTotal > 0 && 
      (Math.abs(year5Total - ttmTotal) / Math.max(year5Total, ttmTotal) < 0.05 || year5Total === ttmTotal);
    
    // If Year5 = TTM, compare TTM to Year4 instead
    const churnComparisonBase = ttmEqualsYear5 ? 'year4' : 'year5';
    const baseTotal = ttmEqualsYear5 ? year4Total : year5Total;
    
    // Only consider customers with a name OR any meaningful revenue data (exclude blank rows)
    const validCustomersForChurn = namedCustomers.filter(c =>
      c.name || (c.year3 || 0) > 0 || (c.year4 || 0) > 0 || (c.year5 || 0) > 0 || (c.ttm || 0) > 0
    );
    
    // Monthly sales data — use for precise timing if available
    const hasMonthlySales = monthlySalesData && Object.keys(monthlySalesData).length > 0;
    
    // Helper: get monthly array for a customer (12 values, oldest→newest)
    // A customer with NO monthly row (or an empty one) has no monthly evidence: return null so the annual rule
    // decides. Returning [] read as "zero all 12 months" and counted every such customer lost (Colleen's first
    // 🐞 report 10-21, Concise: 77 of 312 customers had monthly rows → 36 "lost", -$1.97M on the presentation
    // while Sales Analysis showed 4). One basis empty → use the other basis's months.
    const getMonthly = (c) => {
      if (!hasMonthlySales) return null;
      const _m = monthlySalesData[String(c.id)];
      if (!_m) return null;
      const basis = salesTtmConfig?.basis || 'cash';
      let m = Array.isArray(_m) ? _m : _m[basis];
      if (!Array.isArray(_m) && !(Array.isArray(m) && m.length)) m = _m[basis === 'cash' ? 'accrual' : 'cash'];
      return (Array.isArray(m) && m.length) ? m.slice(0, 12) : null;
    };
    
    // Helper: first and last active month index (0-based, -1 = none)
    const firstActiveMonth = (monthly) => monthly ? monthly.findIndex(v => v > 0) : -1;
    const lastActiveMonth = (monthly) => {
      if (!monthly) return -1;
      for (let i = 11; i >= 0; i--) if (monthly[i] > 0) return i;
      return -1;
    };

    // Check if ANY customer has a status set (lost or atRisk) — if so, owner is actively flagging
    const anyStatusSet = validCustomersForChurn.some(c => c.lost || c.atRisk);
    
    // Lost customers: Owner flag takes priority, revenue-based detection is fallback
    // With monthly data: also detect mid-period churn (last active month < month 10)
    const lostCustomers = validCustomersForChurn.filter(c => {
      if (c.lost) return true;
      const monthly = getMonthly(c);
      if (monthly) {
        const last = lastActiveMonth(monthly);
        // Had base period revenue AND stopped before end of TTM
        if ((c[churnComparisonBase] || 0) > 0 && last !== -1 && last < 9) return true;
        // Had base period revenue AND zero all 12 months
        if ((c[churnComparisonBase] || 0) > 0 && monthly.every(v => v === 0)) return true;
        return false;
      }
      if (anyStatusSet && !c.lost && !c.atRisk) {
        return (c[churnComparisonBase] || 0) > 0 && (c.ttm || 0) === 0;
      }
      return (c[churnComparisonBase] || 0) > 0 && (c.ttm || 0) === 0;
    });

    // New customers: no base period revenue, started during TTM
    // With monthly data: know which month they started
    const newCustomers = validCustomersForChurn.filter(c => {
      if (c.lost) return false;
      const monthly = getMonthly(c);
      if (monthly) {
        const first = firstActiveMonth(monthly);
        return (c[churnComparisonBase] || 0) === 0 && first > 0 && (c.ttm || 0) > 0; // started after month 0, and has TTM revenue (no $0 "new")
      }
      return (c[churnComparisonBase] || 0) === 0 && (c.ttm || 0) > 0;
    });

    // Enrich lost/new customers with monthly timing metadata when available
    const enrichWithTiming = (customers) => customers.map(c => {
      const monthly = getMonthly(c);
      if (!monthly) return c;
      const first = firstActiveMonth(monthly);
      const last = lastActiveMonth(monthly);
      return {
        ...c,
        _monthlyFirstActive: first,   // 0-based month index
        _monthlyLastActive: last,
        _monthlyAnnualized: first > 0 && last !== -1
          ? (monthly.reduce((s, v) => s + v, 0) / (last - first + 1)) * 12
          : null
      };
    });

    const lostCustomersEnriched = enrichWithTiming(lostCustomers);
    const newCustomersEnriched = enrichWithTiming(newCustomers);

    // Lost revenue: use the higher of base period or TTM
    const lostRevenue = lostCustomers.reduce((s, c) => s + Math.max(c[churnComparisonBase] || 0, c.ttm || 0), 0);
    const newRevenue = newCustomers.reduce((s, c) => s + (c.ttm || 0), 0);
    const churnNetChange = newRevenue - lostRevenue;
    const churnNetPct = baseTotal > 0 ? (churnNetChange / baseTotal * 100) : null;
    
    // AR Metrics
    const totalAR = arAgingCalcs.totalAR;
    const pastDue = arAgingCalcs.pastDue;
    const pastDuePct = totalAR > 0 ? (pastDue / totalAR * 100) : null;
    const seriouslyPastDuePct = totalAR > 0 ? (arAgingCalcs.seriouslyPastDue / totalAR * 100) : null;
    const ttmRevenue = calculations.years[5].revenue;
    const dso = ttmRevenue > 0 && totalAR > 0 ? (totalAR / ttmRevenue * 365) : null;
    const arTurnover = ttmRevenue > 0 && totalAR > 0 ? (ttmRevenue / totalAR) : null;
    
    // B2B Revenue % (calculated from customerSalesData customer types)
    // B2B includes Non-Profit (similar organizational characteristics)
    // Government is truly neutral — excluded from BOTH numerator and denominator
    // so government revenue doesn't drag down the B2B% and create a false residential classification
    const b2bRevenue = currentCustomers.filter(c => {
      const type = (c.customerType || '').toUpperCase();
      return type.includes('B2B') || type.includes('NON-PROFIT') || type.includes('NONPROFIT');
    }).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const govRevenue = currentCustomers.filter(c => {
      const type = (c.customerType || '').toUpperCase();
      return type.includes('GOV') || type.includes('GOVERNMENT') || type.includes('PUBLIC') ||
             type.includes('MUNICIPAL') || type.includes('CITY') || type.includes('COUNTY') ||
             type.includes('STATE') || type.includes('FEDERAL');
    }).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const totalCustomerRevenue = currentCustomers.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    // Blank type = UNKNOWN, never residential (Concise Computer 08-19: the
    // owner typed only his current clients — all B2B — and every untyped
    // row counted as residential, scoring an all-B2B book at 24% / -0.31x).
    // Unknown counts NEITHER way: the denominator is TYPED revenue only
    // (B2B/Non-Profit + explicit Residential; Government stays neutral and
    // out of both sides as before). b2bTypedPct = how much of the revenue
    // actually carries a type — the disclosure the score rides on.
    const resRevenue = currentCustomers.filter(c => {
      const type = (c.customerType || '').toUpperCase();
      return type.includes('RESIDENTIAL') || type.includes('B2C') || type.includes('CONSUMER') || type.includes('HOME');
    }).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
    const b2bDenominator = b2bRevenue + resRevenue;
    const b2bPct = b2bDenominator > 0 ? (b2bRevenue / b2bDenominator * 100) : null;
    const b2bTypedPct = totalCustomerRevenue > 0 ? Math.round((b2bDenominator + govRevenue) / totalCustomerRevenue * 100) : null;
    
    // ===== FIX 4: Customer Revenue Spike Detection =====
    // Flag when a single customer's revenue increase represents >25% of total company growth
    // AND the customer's revenue grew by >100% YoY
    const customerSpikes = [];
    const priorPeriod = ttmEqualsYear5 ? 'year4' : 'year5';
    const currentPeriod = ttmEqualsYear5 ? 'year5' : 'ttm';
    // Both sides on the same periods (10-28): the old 'mixed' math took TTM named-customer revenue as the current total
    // while each customer was compared on currentPeriod, which is Year 5 when TTM ≈ Year 5.
    const companyRevGrowth = (spikeMath === 'mixed' ? totalCustomerRevenue : safeCustomerSalesData.reduce((s, c) => s + (c[currentPeriod] || 0), 0))
      - safeCustomerSalesData.reduce((s, c) => s + (c[priorPeriod] || 0), 0);
    
    if (companyRevGrowth > 0) {
      safeCustomerSalesData.forEach(c => {
        const current = c[currentPeriod] || 0;
        const prior = c[priorPeriod] || 0;
        const custGrowth = current - prior;
        const custGrowthPct = prior > 0 ? ((current - prior) / prior) * 100 : (current > 0 ? 999 : 0);
        const shareOfGrowth = companyRevGrowth > 0 ? (custGrowth / companyRevGrowth) * 100 : 0;
        const custConcentration = totalCustomerRevenue > 0 ? (current / totalCustomerRevenue) * 100 : 0;
        
        // Flag if: customer drove >25% of total growth AND grew >100% themselves
        if (shareOfGrowth > 25 && custGrowthPct > 100 && custGrowth > 10000) {
          customerSpikes.push({
            name: c.name || 'Unknown',
            currentRevenue: current,
            priorRevenue: prior,
            growth: custGrowth,
            growthPct: custGrowthPct,
            shareOfGrowth: shareOfGrowth,
            concentration: custConcentration,
            hasContract: c.hasContract || false
          });
        }
      });
    }
    // Sort by share of growth descending
    customerSpikes.sort((a, b) => b.shareOfGrowth - a.shareOfGrowth);
    const hasCustomerSpike = customerSpikes.length > 0;
    const topSpikeShareOfGrowth = hasCustomerSpike ? customerSpikes[0].shareOfGrowth : 0;
    const topSpikeConcentration = hasCustomerSpike ? customerSpikes[0].concentration : 0;
    
    // Lost clients with residual TTM revenue — these inflate the TTM and need pro forma adjustment
    const lostWithResidualTTM = lostCustomersEnriched.filter(c => c.lost && (c.ttm || 0) > 0);
    const lostResidualRevenue = lostWithResidualTTM.reduce((s, c) => s + (c.ttm || 0), 0);
    
    return { retentionByPeriod: { y3to4: retention3to4, y4to5: retention4to5, y5toTTM: retention5toTTM }, nrrByPeriod: { y4to5: nrr4to5, y5toTTM: nrr5toTTM }, contractedRecurringPctLegacy, contractCoveragePctLegacy, residentialPct, employeeCount, revenuePerEmployee, topCustomerPct, top5CustomersPct, top10CustomersPct, concentrationSource, ebitdaMargin, grossMargin, revCAGR, ebitdaCAGR, recurringPct, contractedRecurringPct, verifiedPct, adjustmentsToEbitdaPct, totalAdjustmentsAmt, avgRetention, avgNRR, customerCount, customerCountGrowing, revenueGrowingYoY, churnNetPct, churnNetChange, churnComparisonBase, lostCustomers: lostCustomersEnriched, newCustomers: newCustomersEnriched, lostRevenue, newRevenue, lostWithResidualTTM, lostResidualRevenue, totalAR, pastDuePct, seriouslyPastDuePct, dso, arTurnover, contractedPct, contractCoveragePct, contractCoverageSource, detailCoveragePct, contractedClientRevPct, unansweredActiveCount, unansweredActivePct, agreementClientCount, activeClientCount, detailedContractedPct, remainderRevPct, assignablePct, escalatorPct, avgEscalatorRate, termPenaltyPct, autoRenewalPct, avgContractMonths, multiYearRevPct, midTermRevPct, annualRevPct, shortTermRevPct, nearTermExpiringRevPct, hasExpirationData, b2bPct, b2bTypedPct, customerSpikes, hasCustomerSpike, topSpikeShareOfGrowth, topSpikeConcentration, hasMonthlySales };
    } catch (err) {
      console.error('keyMetrics calculation error:', err);
      return { employeeCount: null, revenuePerEmployee: null, topCustomerPct: 0, top5CustomersPct: 0, top10CustomersPct: 0, concentrationSource: null, ebitdaMargin: 0, grossMargin: 0, revCAGR: null, ebitdaCAGR: null, recurringPct: 0, contractedRecurringPct: 0, verifiedPct: null, adjustmentsToEbitdaPct: null, totalAdjustmentsAmt: 0, avgRetention: null, avgNRR: null, customerCount: { year3: 0, year4: 0, year5: 0, ttm: 0 }, customerCountGrowing: false, revenueGrowingYoY: false, churnNetPct: null, churnNetChange: 0, churnComparisonBase: 'year5', lostCustomers: [], newCustomers: [], lostRevenue: 0, newRevenue: 0, lostWithResidualTTM: [], lostResidualRevenue: 0, totalAR: 0, pastDuePct: null, seriouslyPastDuePct: null, dso: null, arTurnover: null, contractedPct: 0, contractCoveragePct: 0, contractCoverageSource: null, detailCoveragePct: 0, detailedContractedPct: 0, remainderRevPct: 0, assignablePct: 0, escalatorPct: 0, avgEscalatorRate: 0, termPenaltyPct: 0, autoRenewalPct: 0, avgContractMonths: null, multiYearRevPct: 0, midTermRevPct: 0, annualRevPct: 0, shortTermRevPct: 0, nearTermExpiringRevPct: 0, hasExpirationData: false, b2bPct: null, customerSpikes: [], hasCustomerSpike: false, topSpikeShareOfGrowth: 0, topSpikeConcentration: 0 };
    }
  }, [calculations, sellerQA, customerSalesData, monthlySalesData, revenueAnalysis, adjustmentItems, arAgingCalcs, dealProfile, growthTest, spikeMath]);

  // ========== PRO FORMA CALCULATIONS ==========
  const proFormaCalcs = useMemo(() => {
    // Get TTM period end date from config
    const ttmEndMonth = monthlyTtmConfig.endMonth; // 0-11
    const ttmEndYear = monthlyTtmConfig.endYear;
    const ttmEndDate = new Date(ttmEndYear, ttmEndMonth + 1, 0); // Last day of end month
    const ttmStartDate = new Date(ttmEndYear - 1, ttmEndMonth + 1, 1); // First day 12 months prior
    
    // Calculate prorated contributions for each item
    const today = new Date();
    // One run-rate line only: the post-loss months already reflect EVERY client lost, so if several lost
    // lines pick it, the latest-dated loss carries the whole run-rate and the others add no EBITDA.
    const runrateOwnerId = (() => {
      const rr = proFormaItems.filter(p => p.type === 'lostclient' && p.ebitdaMode === 'runrate' && p.effectiveDate);
      return rr.length ? rr.sort((a, b) => String(b.effectiveDate).localeCompare(String(a.effectiveDate)))[0].id : null;
    })();
    // LOST CLIENT AMOUNT FROM THE SALES REPORT (Zac 10-06: "the tool should look up client names from the
    // TTM sales report and pull the exact amounts rather than rely on human input"). A lost-client line whose
    // name matches a customer in the TTM sales-by-customer data uses that customer's TTM revenue, removed in
    // full; a typed amount is only a deliberate override (salesSource: 'typed').
    const pfNameKey = (n) => String(n || '').toLowerCase().replace(/\(consolidated\)/g, ' ').replace(/&/g, ' and ')
      .replace(/\b(inc|llc|l\.l\.c|ltd|corp|corporation|co|company|the|pllc|pc|lp|llp)\b\.?/g, ' ').replace(/[^a-z0-9]+/g, '');
    const pfSalesByName = new Map();
    (customerSalesData || []).forEach(c => { if (c && c.name && !isRemainderRow(c)) { const k = pfNameKey(c.name); if (k && !pfSalesByName.has(k)) pfSalesByName.set(k, c); } });
    const itemCalcs = proFormaItems.map(item => {
      const salesMatch = item.type === 'lostclient' ? (pfSalesByName.get(pfNameKey(item.name)) || null) : null;
      const fromSales = !!(salesMatch && (Number(salesMatch.ttm) || 0) > 0 && item.salesSource !== 'typed');
      const annualRevenue = fromSales ? Number(salesMatch.ttm) : (parseFloat(item.annualRevenue) || 0);
      const retentionPct = (parseFloat(item.retentionPct) || 85) / 100;
      
      // If no revenue, return zeros
      if (!annualRevenue) {
        return { ...item, monthsInTTM: 0, proratedRevenue: 0, proratedEbitda: 0, adjustedRevenue: 0, adjustedEbitda: 0, valuationCredit: 100, autoValuationCredit: 100, monthsSeasoned: 0 };
      }
      
      // LOST CLIENT — two decisions every lost-revenue pro forma makes (Mark 10-06):
      //  1. REVENUE BASIS: 'ttm' = the client's ACTUAL revenue inside the TTM (what
      //     "Add lost clients" fills from customer detail) → remove all of it, the
      //     date doesn't prorate it again; 'annual' = a yearly run-rate → prorate by
      //     the months the client was in the TTM (TTM start → date lost). Lines the
      //     button made before this field existed carry its note text → 'ttm'.
      //  2. EBITDA IMPACT: 'flowthrough' (default) = overhead stays, the gross
      //     profit drops to the bottom line (TTM gross margin) — what a buyer's QoE
      //     assumes; 'margin' = costs come out with the revenue (EBITDA margin,
      //     i.e. staff/overhead cut); 'custom' = a dollar amount typed in.
      //  Both outcomes are computed so the card can show the range.
      const isLostItem = item.type === 'lostclient';
      const ttmGrossMargin = (calculations.years[5] && calculations.years[5].grossMargin) || 0;
      const ttmEbitdaMargin = (calculations.years[5] && calculations.years[5].adjustedEbitdaMargin) || 0;
      const revenueBasis = !isLostItem ? 'annual' : fromSales ? 'ttm'
        : (item.revenueBasis || (/^Owner confirmed lost\. TTM revenue:|Total TTM:/.test(item.notes || '') ? 'ttm' : 'annual'));
      const ebitdaMode = !isLostItem ? null
        : (item.ebitdaMode || (!item.useMargin && parseFloat(item.annualEbitda) ? 'custom' : 'flowthrough'));
      const lostMarginPct = item.ebitdaMargin !== '' && item.ebitdaMargin != null && !isNaN(parseFloat(item.ebitdaMargin))
        ? parseFloat(item.ebitdaMargin) : ttmEbitdaMargin;

      // Calculate EBITDA - either direct or from margin
      let annualEbitda;
      if (isLostItem && ebitdaMode === 'flowthrough') {
        annualEbitda = annualRevenue * (ttmGrossMargin / 100);
      } else if (isLostItem && ebitdaMode === 'margin') {
        annualEbitda = annualRevenue * (lostMarginPct / 100);
      } else if (isLostItem && ebitdaMode === 'custom') {
        annualEbitda = parseFloat(item.annualEbitda) || 0;
      } else if (item.useMargin && item.ebitdaMargin) {
        annualEbitda = annualRevenue * ((parseFloat(item.ebitdaMargin) || 0) / 100);
      } else {
        annualEbitda = parseFloat(item.annualEbitda) || 0;
      }
      
      // Calculate months seasoned (from effective date to today)
      let monthsSeasoned = 0;
      if (item.effectiveDate) {
        const effectiveDate = new Date(item.effectiveDate);
        monthsSeasoned = Math.max(0, (today.getFullYear() - effectiveDate.getFullYear()) * 12 + 
                        (today.getMonth() - effectiveDate.getMonth()) +
                        (today.getDate() >= effectiveDate.getDate() ? 0 : -1));
      }
      
      // Auto-calculate valuation credit based on type and seasoning
      let autoValuationCredit = 100;
      if (item.type === 'acquisition') {
        // Acquisitions get 100% - contracted revenue transfers
        autoValuationCredit = 100;
      } else if (item.type === 'lostclient') {
        // Lost clients are 100% certain - revenue is gone
        autoValuationCredit = 100;
      } else if (item.type === 'pricechange') {
        // Price changes: 90% if implemented, lower if not
        autoValuationCredit = monthsSeasoned >= 1 ? 90 : 50;
      } else {
        // New clients - credit based on seasoning
        if (monthsSeasoned >= 12) autoValuationCredit = 100;
        else if (monthsSeasoned >= 9) autoValuationCredit = 90;
        else if (monthsSeasoned >= 6) autoValuationCredit = 75;
        else if (monthsSeasoned >= 3) autoValuationCredit = 50;
        else if (monthsSeasoned >= 1) autoValuationCredit = 30;
        else autoValuationCredit = 15;
      }
      
      // Use manual override if set, otherwise use auto
      const valuationCredit = item.valuationCreditOverride !== undefined && item.valuationCreditOverride !== null 
        ? parseFloat(item.valuationCreditOverride) 
        : autoValuationCredit;
      
      // Calculate months in TTM period
      // If no effective date, default to full 12 months (include full run-rate)
      let monthsInTTM = 12; // Default to full year

      // LOST CLIENT (Colleen 10-05, AVC Tech / Affigent): the date is when the
      // revenue STOPPED, so the client's revenue inside the TTM is the stretch
      // from TTM start up to that date — not from the date to TTM end (that's the
      // new-client rule, and it removed the 8 months AFTER the loss instead of
      // the 4 months before it). Lost before the TTM → 0; lost after it → 12.
      // Parsed as a LOCAL date: new Date('2025-12-31') is UTC midnight = Dec 30
      // in US time, which shaved a day off every effective date.
      const localDate = (s) => { const [y, m, d] = String(s).slice(0, 10).split('-').map(Number); return new Date(y, (m || 1) - 1, d || 1); };
      if (isLostItem && revenueBasis === 'ttm') {
        monthsInTTM = 12;   // the amount IS the TTM revenue — remove it whole
      } else if (item.type === 'lostclient' && item.effectiveDate) {
        const lossDate = localDate(item.effectiveDate);
        if (lossDate < ttmStartDate) monthsInTTM = 0;
        else if (lossDate >= ttmEndDate) monthsInTTM = 12;
        else {
          const fullMonths = (lossDate.getFullYear() - ttmStartDate.getFullYear()) * 12 + (lossDate.getMonth() - ttmStartDate.getMonth());
          const daysInLossMonth = new Date(lossDate.getFullYear(), lossDate.getMonth() + 1, 0).getDate();
          monthsInTTM = Math.min(12, fullMonths + lossDate.getDate() / daysInLossMonth);
        }
      } else if (item.effectiveDate) {
        const effectiveDate = localDate(item.effectiveDate);
        monthsInTTM = 0;
        
        if (effectiveDate <= ttmEndDate) {
          // Item started before or during TTM period
          const startForCalc = effectiveDate > ttmStartDate ? effectiveDate : ttmStartDate;
          if (startForCalc <= ttmEndDate) {
            // Calculate full months + partial month
            const monthsDiff = (ttmEndDate.getFullYear() - startForCalc.getFullYear()) * 12 + 
                              (ttmEndDate.getMonth() - startForCalc.getMonth());
            // Add partial month for start month (days remaining / days in month)
            const daysInStartMonth = new Date(startForCalc.getFullYear(), startForCalc.getMonth() + 1, 0).getDate();
            const daysRemaining = daysInStartMonth - startForCalc.getDate() + 1;
            const partialMonth = daysRemaining / daysInStartMonth;
            monthsInTTM = Math.min(12, monthsDiff + partialMonth);
          }
        }
      }
      
      // Prorated amounts
      // For acquisitions/new clients: add the months NOT already in TTM to get full run-rate
      // For lost clients: SUBTRACT the months that ARE in TTM (this revenue is leaving)
      const isLostClient = item.type === 'lostclient';
      const monthsToAdd = 12 - monthsInTTM;
      
      let proratedRevenue, proratedEbitda;
      let runRate = null;
      if (isLostClient) {
        // Lost clients: remove their revenue from TTM (negative adjustment)
        proratedRevenue = -((annualRevenue / 12) * monthsInTTM);
        proratedEbitda = -((annualEbitda / 12) * monthsInTTM);
        // POST-LOSS RUN RATE (Zac 10-06, AVC/Affigent: "look at monthly EBITDA post-churn… a large enough
        // sample to review how the business is doing"): the ACTUAL normalized EBITDA in the full months
        // after the loss month, averaged × 12, vs TTM adjusted EBITDA. Evidence, not an assumption — needs
        // ≥ 6 post-loss months in the TTM; otherwise the line falls back to "overhead stays".
        const monthly = (normalizedEbitdaMonthly && normalizedEbitdaMonthly.hasMonthlyData && Array.isArray(normalizedEbitdaMonthly.monthlyEbitda))
          ? normalizedEbitdaMonthly.monthlyEbitda.slice(0, 12) : null;
        if (monthly && monthly.length === 12 && item.effectiveDate) {
          const ld = localDate(item.effectiveDate);
          const lossIdx = (ld.getFullYear() - ttmStartDate.getFullYear()) * 12 + (ld.getMonth() - ttmStartDate.getMonth());
          const startIdx = Math.max(0, lossIdx + 1);   // first FULL month after the loss month
          const post = startIdx <= 11 ? monthly.slice(startIdx) : [];
          const ttmAdj = (calculations.years[5] && calculations.years[5].adjustedEbitda) || 0;
          if (post.length) {
            const avg = post.reduce((a, b) => a + (Number(b) || 0), 0) / post.length;
            runRate = { months: post.length, avgMonthly: avg, annual: avg * 12, ttmAdjEbitda: ttmAdj, delta: avg * 12 - ttmAdj, ok: post.length >= 6 };
          }
        }
        if (ebitdaMode === 'runrate' && runrateOwnerId && item.id !== runrateOwnerId) {
          proratedEbitda = 0;   // covered by the run-rate line
        } else if (ebitdaMode === 'runrate') {
          if (runRate && runRate.ok) proratedEbitda = runRate.delta;
          else proratedEbitda = -(annualRevenue * (ttmGrossMargin / 100) / 12) * monthsInTTM;   // not enough months → overhead stays
        }
      } else {
        // New revenue: add months not yet in TTM
        proratedRevenue = (annualRevenue / 12) * monthsToAdd;
        proratedEbitda = (annualEbitda / 12) * monthsToAdd;
      }
      
      // Adjusted for retention (churn haircut for new rev, certainty for lost)
      const adjustedRevenue = proratedRevenue * retentionPct;
      const adjustedEbitda = proratedEbitda * retentionPct;
      
      // Weighted EBITDA (adjusted for valuation credit)
      const weightedEbitda = adjustedEbitda * (valuationCredit / 100);
      
      // Run-rate (full year with retention)
      // Lost clients: negative full-year impact
      const runRateRevenue = isLostClient ? -(annualRevenue * retentionPct) : (annualRevenue * retentionPct);
      const runRateEbitda = isLostClient ? -(annualEbitda * retentionPct) : (annualEbitda * retentionPct);
      
      return {
        ...item,
        monthsInTTM: Math.round(monthsInTTM * 10) / 10,
        monthsToAdd: Math.round(monthsToAdd * 10) / 10,
        // Lost-client decisions + both EBITDA outcomes on the revenue actually removed.
        revenueBasis, ebitdaMode, ttmGrossMargin, lostMarginPct, runRate, fromSales, salesMatchName: salesMatch ? salesMatch.name : null, salesMatchTtm: salesMatch ? (Number(salesMatch.ttm) || 0) : null, revenueUsed: annualRevenue, runrateCovered: ebitdaMode === 'runrate' && !!runrateOwnerId && item.id !== runrateOwnerId,
        flowEbitda: isLostItem ? proratedRevenue * (ttmGrossMargin / 100) : null,
        marginEbitda: isLostItem ? proratedRevenue * (lostMarginPct / 100) : null,
        monthsSeasoned,
        autoValuationCredit,
        valuationCredit,
        proratedRevenue,
        proratedEbitda,
        adjustedRevenue,
        adjustedEbitda,
        weightedEbitda,
        runRateRevenue,
        runRateEbitda,
        annualEbitdaCalc: annualEbitda,
        ebitdaMarginCalc: annualRevenue > 0 ? (annualEbitda / annualRevenue) * 100 : 0
      };
    });
    
    // Totals
    const totalProratedRevenue = itemCalcs.reduce((sum, item) => sum + (item.adjustedRevenue || 0), 0);
    const totalProratedEbitda = itemCalcs.reduce((sum, item) => sum + (item.adjustedEbitda || 0), 0);
    const totalRunRateRevenue = itemCalcs.reduce((sum, item) => sum + (item.runRateRevenue || 0), 0);
    const totalRunRateEbitda = itemCalcs.reduce((sum, item) => sum + (item.runRateEbitda || 0), 0);
    
    // Weighted totals (based on valuation credit %)
    const totalWeightedEbitda = itemCalcs.reduce((sum, item) => sum + (item.weightedEbitda || 0), 0);
    
    // Total annual figures (before proration/retention - for display)
    const totalAnnualRevenue = itemCalcs.reduce((sum, item) => sum + (parseFloat(item.annualRevenue) || 0), 0);
    const totalAnnualEbitda = itemCalcs.reduce((sum, item) => sum + (item.annualEbitdaCalc || 0), 0);
    
    // Historical values from calculations
    const historicalTTMRevenue = calculations.years[5]?.revenue || 0;
    const historicalTTMEbitda = calculations.years[5]?.adjustedEbitda || 0;
    
    // Pro forma combined values
    const proFormaTTMRevenue = historicalTTMRevenue + totalProratedRevenue;
    const proFormaTTMEbitda = historicalTTMEbitda + totalProratedEbitda;
    const proFormaRunRateRevenue = historicalTTMRevenue + totalRunRateRevenue;
    const proFormaRunRateEbitda = historicalTTMEbitda + totalRunRateEbitda;
    
    // Weighted combined values (based on valuation credit %)
    const weightedTTMEbitda = historicalTTMEbitda + totalWeightedEbitda;
    
    // Calculate base multiples using the baseMultipleTable (interpolated)
    const getBaseMultipleForEbitda = (ebitda) => {
      if (!baseMultipleTable || baseMultipleTable.length === 0) return 3.0;
      let baseM = baseMultipleTable[0]?.multiple || 3.0;
      for (let i = 0; i < baseMultipleTable.length - 1; i++) {
        if (ebitda >= baseMultipleTable[i].ebitda && ebitda < baseMultipleTable[i + 1].ebitda) {
          const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
          const multipleRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
          const progress = (ebitda - baseMultipleTable[i].ebitda) / range;
          baseM = baseMultipleTable[i].multiple + (multipleRange * progress);
          break;
        }
      }
      if (ebitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) {
        baseM = baseMultipleTable[baseMultipleTable.length - 1].multiple;
      }
      return Math.round(baseM * 100) / 100;
    };
    
    // Get base multiples for all scenarios
    const historicalBaseMultiple = getBaseMultipleForEbitda(historicalTTMEbitda);
    const weightedBaseMultiple = getBaseMultipleForEbitda(weightedTTMEbitda);
    const proFormaBaseMultiple = getBaseMultipleForEbitda(proFormaTTMEbitda);
    const runRateBaseMultiple = getBaseMultipleForEbitda(proFormaRunRateEbitda);
    
    return {
      items: itemCalcs,
      totalProratedRevenue,
      totalProratedEbitda,
      totalWeightedEbitda,
      totalRunRateRevenue,
      totalRunRateEbitda,
      totalAnnualRevenue,
      totalAnnualEbitda,
      historicalTTMRevenue,
      historicalTTMEbitda,
      weightedTTMEbitda,
      proFormaTTMRevenue,
      proFormaTTMEbitda,
      proFormaRunRateRevenue,
      proFormaRunRateEbitda,
      historicalBaseMultiple,
      weightedBaseMultiple,
      proFormaBaseMultiple,
      runRateBaseMultiple,
      ttmPeriod: {
        start: ttmStartDate,
        end: ttmEndDate,
        label: `${ttmStartDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })} - ${ttmEndDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`
      },
      hasProFormaData: proFormaItems.length > 0 && totalProratedEbitda !== 0
    };
  }, [proFormaItems, calculations, monthlyTtmConfig, baseMultipleTable, normalizedEbitdaMonthly, customerSalesData]);

  // ========== SELECTED BASIS CALCULATIONS (responds to toggle) ==========
  const selectedBasisCalcs = useMemo(() => {
    const basis = proFormaValuationBasis;
    
    // Return values based on selected basis
    if (basis === 'proforma' && proFormaCalcs.hasProFormaData) {
      return {
        basis: 'proforma',
        label: 'Pro Forma',
        ebitda: proFormaCalcs.proFormaTTMEbitda,
        baseMultiple: proFormaCalcs.proFormaBaseMultiple,
        description: 'Full credit for all pro forma adjustments'
      };
    } else if (basis === 'weighted' && proFormaCalcs.hasProFormaData) {
      return {
        basis: 'weighted',
        label: 'Weighted',
        ebitda: proFormaCalcs.weightedTTMEbitda,
        baseMultiple: proFormaCalcs.weightedBaseMultiple,
        description: 'Credit based on seasoning/confidence'
      };
    } else {
      return {
        basis: 'historical',
        label: 'Historical',
        ebitda: proFormaCalcs.historicalTTMEbitda,
        baseMultiple: proFormaCalcs.historicalBaseMultiple,
        description: 'Historical TTM only, no pro forma'
      };
    }
  }, [proFormaValuationBasis, proFormaCalcs]);

  // ========== PORTFOLIO CONSOLIDATION CALCULATIONS ==========
  const portfolioCalcs = useMemo(() => {
    if (portfolioEntities.length === 0) {
      return {
        entities: [],
        combined: { revenue: 0, ebitda: 0, adjustedEbitda: 0, customerCount: 0 },
        sumOfPartsValue: 0,
        individualBaseMultiple: 0,
        combinedBaseMultiple: 0,
        weightedAvgAdjustments: 0,
        sizeBenefit: 0,
        combinedMultiple: 0,
        combinedValuation: 0,
        combinedTypicalMultiple: 0,
        combinedTypicalValuation: 0,
        premium: 0,
        premiumPct: 0,
        allocation: [],
        ttmMismatch: false,
        ttmWarning: '',
        hasEngineData: false
      };
    }
    
    // Helper function to get base multiple from EBITDA using the baseMultipleTable
    const getBaseMultipleForEbitda = (ebitda) => {
      if (!baseMultipleTable || baseMultipleTable.length === 0) return 3.0;
      let baseM = baseMultipleTable[0]?.multiple || 3.0;
      for (let i = 0; i < baseMultipleTable.length - 1; i++) {
        if (ebitda >= baseMultipleTable[i].ebitda && ebitda < baseMultipleTable[i + 1].ebitda) {
          const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
          const multipleRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
          const progress = (ebitda - baseMultipleTable[i].ebitda) / range;
          baseM = baseMultipleTable[i].multiple + (multipleRange * progress);
          break;
        }
      }
      if (ebitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) {
        baseM = baseMultipleTable[baseMultipleTable.length - 1].multiple;
      }
      return baseM;
    };
    
    // Sum financials
    const combined = {
      revenue: portfolioEntities.reduce((sum, e) => sum + (e.revenue || 0), 0),
      ebitda: portfolioEntities.reduce((sum, e) => sum + (e.ebitda || 0), 0),
      adjustedEbitda: portfolioEntities.reduce((sum, e) => sum + (e.adjustedEbitda || 0), 0),
      customerCount: portfolioEntities.reduce((sum, e) => sum + (e.customerCount || 0), 0)
    };
    
    // Calculate largest single customer across all entities as % of combined revenue
    const largestCustomerAmt = Math.max(...portfolioEntities.map(e => e.topCustomerAmt || 0));
    const combinedConcentration = combined.revenue > 0 ? (largestCustomerAmt / combined.revenue) * 100 : 0;
    combined.topCustomerPct = combinedConcentration;
    combined.topCustomerAmt = largestCustomerAmt;
    
    // Sum of parts value (each entity's standalone valuation)
    const sumOfPartsValue = portfolioEntities.reduce((sum, e) => sum + (e.valuation || 0), 0);
    
    // For each entity, calculate: their adjustments = their multiple - base multiple for their size
    // Then weight-average those adjustments by EBITDA
    let weightedSumAdjustments = 0;
    let weightedSumIndividualBase = 0;
    
    portfolioEntities.forEach(entity => {
      const entityEbitda = entity.adjustedEbitda || 0;
      const entityMultiple = entity.multiple || 3.5;
      const entityBaseMultiple = getBaseMultipleForEbitda(entityEbitda);
      const entityAdjustments = entityMultiple - entityBaseMultiple;
      
      // Weight by EBITDA contribution
      const weight = combined.adjustedEbitda > 0 ? entityEbitda / combined.adjustedEbitda : 0;
      weightedSumAdjustments += entityAdjustments * weight;
      weightedSumIndividualBase += entityBaseMultiple * weight;
    });
    
    // Get base multiple for COMBINED EBITDA (this is where size benefit comes from)
    const combinedBaseMultiple = getBaseMultipleForEbitda(combined.adjustedEbitda);
    
    // The weighted average base multiple from individual entities (for comparison)
    const individualBaseMultiple = weightedSumIndividualBase;
    
    // Size benefit = difference between combined base and weighted individual base
    const sizeBenefit = combinedBaseMultiple - individualBaseMultiple;
    
    // Weighted average of quality/industry/location adjustments from individual files
    const weightedAvgAdjustments = weightedSumAdjustments;
    
    // Apply additional adjustments from Combined Assessment (for combined entity qualities)
    let combinedAssessmentAdj = 0;
    const pa = portfolioAssessment;
    
    // Only apply Combined Assessment adjustments if user has filled them in
    // B2B percentage adjustment
    const b2bPct = parseFloat(pa.pctB2B) || 0;
    if (b2bPct > 0) {
      if (b2bPct >= 90) combinedAssessmentAdj += 0.10;
      else if (b2bPct >= 70) combinedAssessmentAdj += 0.05;
      else if (b2bPct < 50) combinedAssessmentAdj -= 0.05;
    }
    
    // Contract coverage adjustment
    const contractPct = parseFloat(pa.contractCoverage) || 0;
    if (contractPct > 0) {
      if (contractPct >= 80) combinedAssessmentAdj += 0.10;
      else if (contractPct >= 60) combinedAssessmentAdj += 0.05;
      else if (contractPct < 40) combinedAssessmentAdj -= 0.05;
    }
    
    // Owner dependency adjustment
    if (pa.ownerDependency === 'low') combinedAssessmentAdj += 0.10;
    else if (pa.ownerDependency === 'high') combinedAssessmentAdj -= 0.10;
    
    // Management depth adjustment
    if (pa.managementDepth === 'strong') combinedAssessmentAdj += 0.10;
    else if (pa.managementDepth === 'weak') combinedAssessmentAdj -= 0.10;
    
    // Customer concentration improvement from combining (lower concentration = better)
    // Only add bonus if concentration improved vs individual entities
    const avgIndividualConcentration = portfolioEntities.reduce((sum, e) => sum + (e.topCustomerPct || 0), 0) / portfolioEntities.length;
    if (combinedConcentration < avgIndividualConcentration * 0.7) {
      combinedAssessmentAdj += 0.05; // Small bonus for significantly improved concentration
    }
    
    // COMBINED MULTIPLE = Base (for combined size) + Weighted Avg Adjustments + Combined Assessment Adj
    // This gives the Market High multiple (same basis as engine-calculated individual multiples)
    const combinedMultiple = Math.max(2.5, combinedBaseMultiple + weightedAvgAdjustments + combinedAssessmentAdj);
    const combinedValuation = combined.adjustedEbitda * combinedMultiple;
    
    // Typical range (85% of market high, same as individual valuation engine)
    const combinedTypicalMultiple = Math.max(2.0, combinedMultiple * 0.85);
    const combinedTypicalValuation = combined.adjustedEbitda * combinedTypicalMultiple;
    
    // Calculate premium (should be positive - that's the benefit of selling together)
    const premium = combinedValuation - sumOfPartsValue;
    const premiumPct = sumOfPartsValue > 0 ? (premium / sumOfPartsValue) * 100 : 0;
    
    // Calculate allocation
    const allocation = portfolioEntities.map(entity => {
      let pctOfTotal, shareOfPackage;
      
      if (portfolioSettings.allocationMethod === 'ebitda') {
        pctOfTotal = combined.adjustedEbitda > 0 ? (entity.adjustedEbitda / combined.adjustedEbitda) * 100 : 0;
      } else if (portfolioSettings.allocationMethod === 'equal') {
        // Equal split (Zac/Thatcher 09-04, the dental combination: the
        // owners may have asked for 50/50 — a business agreement, not a
        // math outcome, so it's an explicit picker choice with the other
        // two methods, never a default).
        pctOfTotal = 100 / portfolioEntities.length;
      } else {
        // Value-based allocation
        pctOfTotal = sumOfPartsValue > 0 ? (entity.valuation / sumOfPartsValue) * 100 : 0;
      }
      
      shareOfPackage = combinedValuation * (pctOfTotal / 100);
      const entityPremium = shareOfPackage - (entity.valuation || 0);
      
      return {
        ...entity,
        pctOfTotal,
        shareOfPackage,
        premium: entityPremium
      };
    });
    
    // Check TTM period mismatch
    const ttmPeriods = portfolioEntities.map(e => e.ttmPeriod).filter(Boolean);
    const uniquePeriods = [...new Set(ttmPeriods)];
    const ttmMismatch = uniquePeriods.length > 1;
    const ttmWarning = ttmMismatch ? `TTM periods differ: ${uniquePeriods.join(', ')}` : '';
    
    return {
      entities: portfolioEntities,
      combined,
      sumOfPartsValue,
      individualBaseMultiple,
      combinedBaseMultiple,
      sizeBenefit,
      weightedAvgAdjustments,
      combinedAssessmentAdj,
      combinedMultiple,
      combinedValuation,
      combinedTypicalMultiple,
      combinedTypicalValuation,
      premium,
      premiumPct,
      allocation,
      ttmMismatch,
      ttmWarning,
      hasEngineData: portfolioEntities.some(e => e.usedEngineCalcs)
    };
  }, [portfolioEntities, portfolioAssessment, portfolioSettings.allocationMethod, baseMultipleTable]);

  // ========== MULTIPLE ENGINE CALCULATIONS ==========
  const multipleEngineCalcs = useMemo(() => {
    try {
    // Piecewise-linear interpolation through [x,y] anchor points (ascending x), held
    // flat beyond the ends. Used to smooth factor scoring so a rounding-level input
    // change near a threshold doesn't jump the score (Tier 2 threshold-smoothing).
    const lerpAnchors = (x, pts) => {
      if (x <= pts[0][0]) return pts[0][1];
      const last = pts[pts.length - 1];
      if (x >= last[0]) return last[1];
      for (let i = 0; i < pts.length - 1; i++) {
        const [x0, y0] = pts[i], [x1, y1] = pts[i + 1];
        if (x >= x0 && x <= x1) return y0 + (y1 - y0) * (x - x0) / (x1 - x0);
      }
      return last[1];
    };
    // Use selected basis EBITDA if Pro Forma data exists and basis is not historical
    const historicalEbitda = calculations?.valuation?.metric || 0;
    const adjustedEbitda = (proFormaCalcs.hasProFormaData && proFormaValuationBasis !== 'historical') 
      ? selectedBasisCalcs.ebitda 
      : historicalEbitda;
    // 💵 FCF basis (10-20): adjustedEbitda above is AFTER maintenance capex = free cash flow; the multiple applies to it.
    // In 'fcf' mode the size TIER (base multiple, location scaling, floor) reads EBITDA BEFORE capex, so capex isn't
    // counted twice, and catch-up capex comes off the price once. 'legacy' = the pre-10-20 math, unchanged.
    const fcfMode = capexMethod === 'fcf';
    const maintCapexInValue = Math.max(0, Number(calculations?.valuation?.maintCapex) || 0);
    const tierEbitda = fcfMode ? adjustedEbitda + maintCapexInValue : adjustedEbitda;
    const catchUpCapex = fcfMode ? Math.max(0, Number(capexCatchUp && capexCatchUp.amount) || 0) : 0;
    const getBaseMultiple = (ebitda) => {
      let baseM = baseMultipleTable[0]?.multiple || 3.0;
      for (let i = 0; i < baseMultipleTable.length - 1; i++) {
        if (ebitda >= baseMultipleTable[i].ebitda && ebitda < baseMultipleTable[i + 1].ebitda) {
          const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
          const multipleRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
          const progress = (ebitda - baseMultipleTable[i].ebitda) / range;
          baseM = baseMultipleTable[i].multiple + (multipleRange * progress);
          break;
        }
      }
      if (ebitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) baseM = baseMultipleTable[baseMultipleTable.length - 1].multiple;
      
      // Calculate location adjustment (scales inversely with EBITDA)
      const baseLocationAdj = locationTypeAdjustments[dealProfile.locationType] || 0;
      let locationScaleFactor = 1.0; // 100% for small businesses
      if (ebitda >= 1000000) locationScaleFactor = 0.25;      // $1M+ EBITDA: 25% of location impact
      else if (ebitda >= 500000) locationScaleFactor = 0.5;   // $500K-$1M: 50% of location impact
      else if (ebitda >= 250000) locationScaleFactor = 0.75;  // $250K-$500K: 75% of location impact
      const scaledLocationAdj = baseLocationAdj * locationScaleFactor;
      
      // Apply market condition, industry adjustment, AND location adjustment
      // Market condition is now a direct multiple adjustment (e.g., +0.25 or -0.50)
      return baseM + industryMultipleAdjustment + scaledLocationAdj + (marketCondition?.adjustment || 0);
    };
    const baseMultiple = getBaseMultiple(tierEbitda);
    
    // Calculate scaled location adjustment for display
    const baseLocationAdj = locationTypeAdjustments[dealProfile.locationType] || 0;
    let locationScaleFactor = 1.0;
    if (tierEbitda >= 1000000) locationScaleFactor = 0.25;
    else if (tierEbitda >= 500000) locationScaleFactor = 0.5;
    else if (tierEbitda >= 250000) locationScaleFactor = 0.75;
    const scaledLocationAdj = baseLocationAdj * locationScaleFactor;
    
    // Calculate raw base (without adjustments) for display
    const getRawBaseMultiple = (ebitda) => {
      let baseM = baseMultipleTable[0].multiple;
      for (let i = 0; i < baseMultipleTable.length - 1; i++) {
        if (ebitda >= baseMultipleTable[i].ebitda && ebitda < baseMultipleTable[i + 1].ebitda) {
          const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
          const multipleRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
          const progress = (ebitda - baseMultipleTable[i].ebitda) / range;
          baseM = baseMultipleTable[i].multiple + (multipleRange * progress);
          break;
        }
      }
      if (ebitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) baseM = baseMultipleTable[baseMultipleTable.length - 1].multiple;
      return baseM;
    };
    const rawBaseMultiple = getRawBaseMultiple(tierEbitda);
    
    // Find current tier and next tier for educational display
    let currentTierIndex = 0;
    for (let i = 0; i < baseMultipleTable.length - 1; i++) {
      if (tierEbitda >= baseMultipleTable[i].ebitda && tierEbitda < baseMultipleTable[i + 1].ebitda) {
        currentTierIndex = i;
        break;
      }
      if (tierEbitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) {
        currentTierIndex = baseMultipleTable.length - 1;
      }
    }
    const currentTier = baseMultipleTable[currentTierIndex];
    const nextTier = currentTierIndex < baseMultipleTable.length - 1 ? baseMultipleTable[currentTierIndex + 1] : null;
    const ebitdaToNextTier = nextTier ? nextTier.ebitda - tierEbitda : 0;
    
    // Growth scenarios
    const growthScenarios = [
      { label: '+25%', factor: 1.25 },
      { label: '+50%', factor: 1.50 },
      { label: '+100%', factor: 2.00 }
    ].map(scenario => {
      const newEbitda = adjustedEbitda * scenario.factor;
      const newMultiple = getRawBaseMultiple(newEbitda);
      const currentValue = adjustedEbitda * rawBaseMultiple;
      const newValue = newEbitda * newMultiple;
      const valueGain = newValue - currentValue;
      const valueGainPct = (valueGain / currentValue) * 100;
      return { ...scenario, newEbitda, newMultiple, currentValue, newValue, valueGain, valueGainPct };
    });
    
    const factors = {};

    // A: Revenue Quality - CALIBRATED from real deals
    // Company A (48% recurring, 100% B2B) = 7.0x vs Company B (80% recurring, 20% B2B) = 2.5x
    // Key insight: Customer TYPE matters more than raw recurring %
    // v2.7: A1 now uses dampened recurring % when project/hardware spikes detected
    // Match the valuation period — same logic as keyMetrics
    const recurringByPeriodEng = revenueAnalysis.weightedRecurringPct || {};
    const dampenedByPeriodEng = revenueAnalysis.dampenedRecurringPct || {};
    let rawRecurringPct, dampenedRecurringPctVal;
    switch (valuationInputs.weightingMethod) {
      case 'ttm': rawRecurringPct = recurringByPeriodEng.ttm || 0; dampenedRecurringPctVal = dampenedByPeriodEng.ttm || 0; break;
      case 'lastYear': rawRecurringPct = recurringByPeriodEng.year5 || 0; dampenedRecurringPctVal = dampenedByPeriodEng.year5 || 0; break;
      case 'average': {
        const iy = [
          valuationInputs.includeYear1 ? recurringByPeriodEng.year3 : null,
          valuationInputs.includeYear2 ? recurringByPeriodEng.year4 : null,
          valuationInputs.includeYear3 ? recurringByPeriodEng.year5 : null
        ].filter(v => v !== null);
        rawRecurringPct = iy.length > 0 ? iy.reduce((a,b) => a+b, 0) / iy.length : (recurringByPeriodEng.ttm || 0);
        const idy = [
          valuationInputs.includeYear1 ? dampenedByPeriodEng.year3 : null,
          valuationInputs.includeYear2 ? dampenedByPeriodEng.year4 : null,
          valuationInputs.includeYear3 ? dampenedByPeriodEng.year5 : null
        ].filter(v => v !== null);
        dampenedRecurringPctVal = idy.length > 0 ? idy.reduce((a,b) => a+b, 0) / idy.length : (dampenedByPeriodEng.ttm || 0);
        break;
      }
      default: rawRecurringPct = recurringByPeriodEng.ttm || 0; dampenedRecurringPctVal = dampenedByPeriodEng.ttm || 0;
    }
    // If weighted method selected but no explicit case, apply weighted logic
    if (valuationInputs.weightingMethod === 'weighted') {
      const rw1 = valuationInputs.includeYear1 ? valuationInputs.weightYear1 : 0;
      const rw2 = valuationInputs.includeYear2 ? valuationInputs.weightYear2 : 0;
      const rw3 = valuationInputs.includeYear3 ? valuationInputs.weightYear3 : 0;
      const rwTotal = rw1 + rw2 + rw3;
      if (rwTotal > 0) {
        rawRecurringPct = ((recurringByPeriodEng.year3 || 0) * rw1 + (recurringByPeriodEng.year4 || 0) * rw2 + (recurringByPeriodEng.year5 || 0) * rw3) / rwTotal;
        dampenedRecurringPctVal = ((dampenedByPeriodEng.year3 || 0) * rw1 + (dampenedByPeriodEng.year4 || 0) * rw2 + (dampenedByPeriodEng.year5 || 0) * rw3) / rwTotal;
      }
    }
    const recurringPct = revenueAnalysis.damperActive ? dampenedRecurringPctVal : rawRecurringPct;
    const recurringDiff = recurringPct - currentBenchmarks.recurringRevenuePct;
    // A1: Recurring % - EXPANDED range ±0.75x (was ±0.5x)
    // Uses dampened % when project/hardware revenue has spiked (Fix 3)
    // Neutral override: if owner didn't return Export Class. Form, every row is still
    // unverified AND defaulted to "Transactional / New" with no custom splits, score 0
    // instead of worst-case -0.75x. Notes/callout already explain it's estimated.
    const _a1Cats = revenueCategories || [];
    const _a1AllDefaultTransactionalNew = _a1Cats.length > 0 &&
      _a1Cats.every(c => !c.isVerified) &&
      _a1Cats.every(c => {
        const hasSplits = c.typeSplits && Object.keys(c.typeSplits).length > 0;
        if (hasSplits) return false;
        // Coalesce missing/null revenueType to 'transactional' to match scoring (line 3702)
        const rtype = c.revenueType || 'transactional';
        const t = revenueTypes.find(rt => rt.id === rtype);
        // Treat unknown ids as default too (any unrecognized type behaves as transactional in scoring)
        return !t || t.label === 'Transactional / New';
      });
    // Smoothed: linear ramp through the same anchors (±10/±20/±30 → ±0.25/±0.50/±0.75)
    // instead of hard steps, so a business just over/under a threshold no longer jumps a
    // quarter-turn. Passes through every prior anchor; removes the old ±10 dead zone.
    // (threshold-smoothing Tier 1, 2026-07-10, Zac-approved)
    // MRR vs MRR (Mark/Zac/Colleen 10-06, Concise): the 65% industry benchmark is ACTUAL contract
    // revenue (MSP MRR), so A1 scores the STRICT contracted % against it on the same ramp. The weighted
    // mix (relationship credit for projects/products/licensing/repeat work) was being compared to that
    // MRR benchmark and over-credited every project-heavy business (Concise +0.59x vs +0.31x). Zac:
    // weighting is judgment, "shouldn't have material affect" → it survives only as a small positive
    // nudge: 0.005x per point the weighted mix sits above strict MRR, capped at +0.10x.
    const a1StrictMrrPct = keyMetrics?.contractedRecurringPct || 0;
    const a1MixNudge = Math.max(0, Math.min(0.10, (recurringPct - a1StrictMrrPct) * 0.005));
    const a1Legacy = revenueScoringMode === 'legacy';   // grandfathered: presented before 10-06, not yet revalued
    const a1Score = _a1AllDefaultTransactionalNew ? 0 : a1Legacy
      ? Math.max(-0.75, Math.min(0.75, 0.025 * recurringDiff))
      : Math.max(-0.75, Math.min(0.75, 0.025 * (a1StrictMrrPct - currentBenchmarks.recurringRevenuePct) + a1MixNudge));
    const a1DamperNote = revenueAnalysis.damperActive 
      ? ` (dampened from ${rawRecurringPct.toFixed(1)}% due to project/hardware spikes)` 
      : '';
    
    // A2: Revenue YoY Stability - now considers DIRECTION of growth, not just variance
    // Key insight: A company growing every year (even at varying rates) is different from one with declines
    const industryRevVar = currentBenchmarks.revenueYoYVariance || 15;
    const validYoYChanges = revenueAnalysis?.validChanges || [];
    const yoyVar = revenueAnalysis?.yoyVariance || 0;
    const allPositive = validYoYChanges.length > 0 && validYoYChanges.every(c => c > 0);
    const allNegative = validYoYChanges.length > 0 && validYoYChanges.every(c => c < 0);
    const hasDeclines = validYoYChanges.some(c => c < 0);
    const declineCount = validYoYChanges.filter(c => c < 0).length;
    
    let a2Score = 0;
    let a2Calculation = '';
    
    if (validYoYChanges.length === 0) {
      a2Score = 0;
      a2Calculation = 'Insufficient data';
    } else if (allPositive) {
      // All years positive - reward consistency, no penalty for varying growth rates
      if (yoyVar <= industryRevVar * 0.5) {
        a2Score = 0.25;  // Consistent strong growth
        a2Calculation = `All positive growth, low variance (${yoyVar.toFixed(1)}% vs ${industryRevVar}% benchmark)`;
      } else if (yoyVar <= industryRevVar) {
        a2Score = 0.15;  // All positive, moderate variance
        a2Calculation = `All positive growth, moderate variance (${yoyVar.toFixed(1)}% vs ${industryRevVar}% benchmark)`;
      } else {
        a2Score = 0;     // All positive but high variance - neutral, NOT penalized
        a2Calculation = `All positive growth, high variance (${yoyVar.toFixed(1)}% vs ${industryRevVar}% benchmark) - no penalty`;
      }
    } else if (allNegative) {
      // All years declining - this is concerning
      a2Score = -0.25;
      a2Calculation = `Consistent revenue decline (${yoyVar.toFixed(1)}% variance)`;
    } else {
      // Mixed - some growth, some decline
      if (declineCount === 1 && validYoYChanges.length >= 3) {
        // One bad year among several good ones - minor concern
        a2Score = yoyVar >= industryRevVar * 1.5 ? -0.10 : 0;
        a2Calculation = `1 decline year, ${validYoYChanges.length - 1} growth years (${yoyVar.toFixed(1)}% variance)`;
      } else {
        // Multiple declines - more concerning
        a2Score = yoyVar >= industryRevVar * 1.5 ? -0.25 : 
                  yoyVar >= industryRevVar * 1.2 ? -0.15 : -0.10;
        a2Calculation = `${declineCount} decline years, ${validYoYChanges.length - declineCount} growth years (${yoyVar.toFixed(1)}% variance)`;
      }
    }
    
    // P3 (Zac 10-08): one sharp year counts on its own — "should decline multiple but is more natural in
    // project businesses than recurring revenue businesses. Each should warrant a different change."
    // Any single year down 25%+ floors A2 at -0.40x for a recurring business, -0.20x for a project
    // business (project-based industry, or under 40% contracted recurring). Grandfathered like A1.
    if (revenueScoringMode !== 'legacy' && validYoYChanges.length) {
      const worstYoY = Math.min(...validYoYChanges);
      if (worstYoY <= -25) {
        const projectish = PROJECT_BASED_INDUSTRIES.has(selectedIndustry) || (keyMetrics?.contractedRecurringPct || 0) < 40;
        const floor = projectish ? -0.20 : -0.40;
        if (a2Score > floor) {
          a2Score = floor;
          a2Calculation += ` · one year fell ${Math.abs(worstYoY).toFixed(0)}% → ${floor.toFixed(2)}x floor (${projectish ? 'project' : 'recurring-revenue'} business)`;
        }
      }
    }

    // A3: Revenue Monthly Stability - asymmetric scoring (down months are worse than up)
    // Uses monthsSignificantlyBelow (>15% below average)
    // Calibrated: Real deals suggest original scoring was too aggressive
    let a3AutoScore = 0;
    let a3Calculation = 'No monthly data - enter in TTM P&L tab';
    let a3Flag = false;
    if (revenueAnalysis?.hasMonthlyData) {
      const downMonths = revenueAnalysis.monthsSignificantlyBelow || 0;
      const upMonths = revenueAnalysis.monthsSignificantlyAbove || 0;
      const monthlyCV = revenueAnalysis.monthlyCV || 0;
      // Scoring: down months penalize, but not too aggressively
      // Total swing: +0.10 to -0.15 (0.25x range)
      if (downMonths === 0) a3AutoScore = 0.10;           // Rock solid - no significant dips
      else if (downMonths <= 2) a3AutoScore = 0;          // Minor - 1-2 weak months acceptable
      else if (downMonths <= 4) a3AutoScore = -0.05;      // Concern - several weak months
      else a3AutoScore = -0.15;                            // Serious - 5+ months erratic
      
      a3Calculation = `${downMonths} month${downMonths !== 1 ? 's' : ''} significantly below avg, ${upMonths} above (CV: ${monthlyCV.toFixed(1)}%)`;
      a3Flag = downMonths >= 3; // Flag if 3+ months are significantly below
    }
    const a3Score = a3AutoScore + (multipleAdjustments.revenueQuality.monthlyManualAdjustment || 0);
    
    // A4: Customer Type (B2B vs Residential)
    // B2B is the baseline for MSP transactions - no bonus
    // Residential is riskier (higher churn, harder to service) - penalty
    const customerTypeScores = {
      'b2b_only': 0,            // Pure B2B MSP - baseline
      'b2b_majority': 0,        // >70% B2B - still baseline
      'mixed': -0.25,           // 50/50 mix - some residential risk
      'residential_majority': -0.5,  // >70% residential - significant risk
      'residential_only': -0.75      // Pure residential/consumer - high risk
    };
    
    let customerType = 'unknown';
    let b2bSource = 'none';
    let b2bPctUsed = null;
    
    // ONLY use Sales tab data
    const b2bPctValue = keyMetrics?.b2bPct;
    if (b2bPctValue !== null && b2bPctValue !== undefined && b2bPctValue > 0) {
      b2bSource = 'sales';
      b2bPctUsed = b2bPctValue;
      if (b2bPctValue >= 95) customerType = 'b2b_only';
      else if (b2bPctValue >= 70) customerType = 'b2b_majority';
      else if (b2bPctValue >= 30) customerType = 'mixed';
      else if (b2bPctValue >= 5) customerType = 'residential_majority';
      else customerType = 'residential_only';
    }
    
    // Smoothed: ramp through the same anchors (70%→0, 30%→-0.25, 5%→-0.50, 0%→-0.75)
    // instead of category steps, so 69% vs 71% B2B no longer differ by a quarter-turn.
    // customerType/customerTypeScores retained for labels only. (Tier 1, 2026-07-10, Zac)
    const a4Ramp = (b2b) => {
      if (b2b >= 70) return 0;
      if (b2b >= 30) return -0.25 * (70 - b2b) / 40;          // 0 → -0.25
      if (b2b >= 5)  return -0.25 - 0.25 * (30 - b2b) / 25;   // -0.25 → -0.50
      return -0.50 - 0.25 * (5 - Math.max(0, b2b)) / 5;       // -0.50 → -0.75 at 0%
    };
    const a4Score = (customerType !== 'unknown' && b2bPctUsed !== null) ? a4Ramp(b2bPctUsed) : 0;
    const customerTypeLabels = {
      'b2b_only': '100% B2B',
      'b2b_majority': '>70% B2B',
      'mixed': 'Mixed B2B/Residential',
      'residential_majority': '>70% Residential',
      'residential_only': '100% Residential',
      'unknown': 'No data'
    };
    const b2bSourceLabels = { sales: '📊 Sales', none: '⚠️ No Data' };
    
    // A5: Revenue Growth Quality (Fix 2)
    // Checks whether YoY revenue growth came from recurring or non-recurring sources
    // If majority of growth is from projects/hardware/transactional, that's lower quality growth
    let a5Score = 0;
    let a5Calculation = '';
    let a5Flag = false;
    const totalRevGrowth = revenueAnalysis.totalGrowth || 0;
    const nonRecGrowthPct = (revenueScoringMode === 'legacy' ? revenueAnalysis.nonRecurringGrowthPctLegacy : revenueAnalysis.nonRecurringGrowthPct) || 0;
    const recurringGrowthAmt = (revenueScoringMode === 'legacy' ? revenueAnalysis.recurringGrowthAmtLegacy : revenueAnalysis.recurringGrowthAmt) || 0;
    
    if (totalRevGrowth > 10000) {
      // Only score when there's meaningful growth to analyze
      if (nonRecGrowthPct >= 80) {
        a5Score = -0.25;  // Nearly all growth from non-recurring — very concerning
        a5Calculation = `${nonRecGrowthPct.toFixed(0)}% of growth from non-recurring sources`;
        a5Flag = true;
      } else if (nonRecGrowthPct >= 60) {
        a5Score = -0.15;  // Majority from non-recurring — concerning
        a5Calculation = `${nonRecGrowthPct.toFixed(0)}% of growth from non-recurring sources`;
        a5Flag = true;
      } else if (nonRecGrowthPct >= 40) {
        a5Score = -0.05;  // Significant non-recurring component — minor concern
        a5Calculation = `${nonRecGrowthPct.toFixed(0)}% of growth from non-recurring, ${(100 - nonRecGrowthPct).toFixed(0)}% recurring`;
      } else if (nonRecGrowthPct < 20 && recurringGrowthAmt > 0) {
        a5Score = 0.10;   // Growth driven primarily by recurring — healthy
        a5Calculation = `${(100 - nonRecGrowthPct).toFixed(0)}% of growth from recurring revenue`;
      } else {
        a5Score = 0;
        a5Calculation = `Mixed growth sources: ${nonRecGrowthPct.toFixed(0)}% non-recurring`;
      }
    } else if (totalRevGrowth <= 0) {
      a5Score = 0;
      a5Calculation = 'Revenue flat/declining — N/A';
    } else {
      a5Score = 0;
      a5Calculation = 'Minimal growth — insufficient to analyze';
    }
    
    // A6: Customer Revenue Spike Detection (Fix 4)
    // Penalizes when a single customer's revenue spike drives a disproportionate share of growth
    // This catches situations where headline growth is misleading
    let a6Score = 0;
    let a6Calculation = '';
    let a6Flag = false;
    const hasSpike = keyMetrics?.hasCustomerSpike || false;
    const spikeData = keyMetrics?.customerSpikes || [];
    
    if (hasSpike && spikeData.length > 0) {
      const topSpike = spikeData[0];
      const spikeShare = topSpike.shareOfGrowth;
      const spikeConc = topSpike.concentration;
      
      // Smoothed (option a): ramp the penalty on share-of-growth only — 25%→-0.10,
      // 75%→-0.35 — instead of the old 2-variable step gate. The spike DETECTION flag
      // (customer grew >100%, >$10K, >25% of growth) stays a yes/no gate upstream in
      // keyMetrics. (Tier 2 threshold-smoothing, 2026-07-10, Zac-approved)
      a6Score = lerpAnchors(spikeShare, [[25, -0.10], [75, -0.35]]);
      a6Flag = true;
      
      a6Calculation = `${topSpike.name}: ${spikeShare.toFixed(0)}% of growth, now ${spikeConc.toFixed(0)}% of revenue`;
      if (spikeData.length > 1) {
        a6Calculation += ` (+${spikeData.length - 1} more)`;
      }
    } else {
      a6Calculation = 'No customer revenue spikes detected';
    }
    
    factors.A = { name: 'Revenue Quality', subFactors: {
      A1: { name: 'Revenue Type Mix', score: a1Score, calculation: a1Legacy ? `${recurringPct.toFixed(1)}% weighted recurring vs ${currentBenchmarks.recurringRevenuePct}% industry${a1DamperNote} (scored on the rules in place when presented; the next revalue uses contract revenue)` : `${a1StrictMrrPct.toFixed(1)}% contracted recurring (MRR) vs ${currentBenchmarks.recurringRevenuePct}% industry MRR${a1MixNudge > 0.005 ? ` + ${a1MixNudge.toFixed(2)}x relationship mix (weighted ${recurringPct.toFixed(1)}%${a1DamperNote})` : ''}`, damperActive: revenueAnalysis.damperActive, rawPct: rawRecurringPct, dampenedPct: dampenedRecurringPctVal, reclassificationSuggestions: revenueAnalysis.reclassificationSuggestions || [] },
      A2: { name: 'Revenue YoY Stability', score: a2Score, calculation: a2Calculation, details: {
        year1to2: revenueAnalysis.yoyChanges.year1to2,
        year2to3: revenueAnalysis.yoyChanges.year2to3,
        year3to4: revenueAnalysis.yoyChanges.year3to4,
        year4to5: revenueAnalysis.yoyChanges.year4to5,
        year5toTTM: revenueAnalysis.year5TtmSame ? 'Same Period' : revenueAnalysis.yoyChanges.year5toTTM
      } },
      A3: { name: 'Revenue Monthly Stability', score: a3Score, calculation: a3Calculation, flag: a3Flag, flagReason: 'High monthly variance - review required', reviewed: multipleAdjustments.revenueQuality.monthlyReviewed, noData: !revenueAnalysis.hasMonthlyData },
      A4: { name: 'Customer Type (B2B vs Residential)', score: a4Score, calculation: b2bPctUsed !== null ? `${b2bPctUsed.toFixed(0)}% B2B/Non-Profit (excl. Government)${b2bSource === 'sales' && keyMetrics?.b2bTypedPct != null && keyMetrics.b2bTypedPct < 99 ? ` — Customer Type set on ${keyMetrics.b2bTypedPct}% of revenue; untyped rows count neither way` : ''}` : 'No data - set Customer Type in Sales tab', source: b2bSource, sourceLabel: b2bSourceLabels[b2bSource], calibrationNote: 'B2B and Non-Profit are baseline; residential has higher churn risk; Government is excluded from the B2B% calculation so it does not inflate the residential percentage' },
      A5: { name: 'Revenue Growth Quality', score: a5Score, calculation: a5Calculation, flag: a5Flag, flagReason: 'Growth driven by non-recurring revenue', growthByType: revenueAnalysis.growthByType },
      A6: { name: 'Customer Revenue Spike', score: a6Score, calculation: a6Calculation, flag: a6Flag, flagReason: 'Single customer driving disproportionate growth', customerSpikes: spikeData }
    }, adjustment: a1Score + a2Score + a3Score + a4Score + a5Score + a6Score };

    // B: EBITDA Quality - REVISED
    // Key changes:
    // 1. B1 now considers trend and has softer penalties above 10%
    // 2. B2 considers trend - consistently improving margins aren't "unstable"
    // 3. B3 (YoY Stability) REMOVED - was redundant with B2, causing double-penalty
    
    // Use TTM margin for current comparison
    const currentMargin = calculations.years[5].adjustedEbitdaMargin;
    const marginDiff = currentMargin - currentBenchmarks.ebitdaMargin;
    
    // Get margin trend from recent years
    const allMargins = calculations.years.map((y, i) => ({ margin: y.adjustedEbitdaMargin, hasData: y.revenue > 0, index: i }));
    const marginsWithData = allMargins.filter(m => m.hasData && m.index < 5); // Exclude TTM, use only Y1-Y5
    const recentMargins = marginsWithData.slice(-3).map(m => m.margin); // Get last 3 years with data
    
    // Determine margin trend
    let marginTrend = 'flat';
    let marginTrendScore = 0;
    if (recentMargins.length >= 2) {
      const isImproving = recentMargins.every((m, i) => i === 0 || m >= recentMargins[i-1] - 0.5); // Allow 0.5% tolerance
      const isDeclining = recentMargins.every((m, i) => i === 0 || m <= recentMargins[i-1] + 0.5);
      if (isImproving && recentMargins[recentMargins.length-1] > recentMargins[0] + 1) {
        marginTrend = 'improving';
        marginTrendScore = 0.15; // Bonus for improving margins
      } else if (isDeclining && recentMargins[recentMargins.length-1] < recentMargins[0] - 1) {
        marginTrend = 'declining';
        marginTrendScore = -0.15; // Penalty for declining margins
      }
    }
    
    // B1: EBITDA Margins - revised scoring
    // Key insight: Margins >10% = no penalty. Buyers see lower margins as opportunity to improve.
    let b1Score = 0;
    let b1Calculation = '';
    
    // Smoothed: ramp through the same anchors (bench+4→+0.25, bench+8→+0.50, 10%→0,
    // 5%→-0.25) instead of hard steps. Positive ramp starts at benchmark; neutral band
    // from 10% up to benchmark; below 10% ramps down to -0.50 at 0%. Kills the 10%-floor
    // and bench+8 cliffs. (threshold-smoothing Tier 1, 2026-07-10, Zac-approved)
    const _b1Bench = currentBenchmarks.ebitdaMargin;
    if (currentMargin >= _b1Bench + 8) {
      b1Score = 0.5;
      b1Calculation = `${currentMargin.toFixed(1)}% vs ${_b1Bench}% industry (well above)`;
    } else if (currentMargin >= _b1Bench) {
      b1Score = 0.0625 * (currentMargin - _b1Bench);   // 0 at benchmark → +0.50 at bench+8
      b1Calculation = `${currentMargin.toFixed(1)}% vs ${_b1Bench}% industry (above benchmark)`;
    } else if (currentMargin >= 10) {
      b1Score = 0;                                      // neutral band: below benchmark but ≥10%
      b1Calculation = `${currentMargin.toFixed(1)}% vs ${_b1Bench}% industry (below benchmark but ≥10% - buyer opportunity)`;
    } else if (currentMargin >= 0) {
      b1Score = -0.05 * (10 - currentMargin);           // 0 at 10% → -0.50 at 0%
      b1Calculation = `${currentMargin.toFixed(1)}% vs ${_b1Bench}% industry (below 10% - concerning)`;
    } else {
      b1Score = -0.50;
      b1Calculation = `${currentMargin.toFixed(1)}% vs ${_b1Bench}% industry (negative margin)`;
    }
    
    // B2: Margin Stability - revised to consider trend
    // Key insight: Consistently improving margins aren't "unstable" - they show positive trajectory
    let marginVariance = 0;
    let b2Score = 0;
    let b2Calculation = 'Need 2+ years';
    
    if (recentMargins.length >= 2) {
      const avgMargin = recentMargins.reduce((a, b) => a + b, 0) / recentMargins.length;
      marginVariance = Math.sqrt(recentMargins.reduce((sum, m) => sum + Math.pow(m - avgMargin, 2), 0) / recentMargins.length);
      
      // Smoothed: ramp std-dev within each trend instead of hard bands (Tier 3, 2026-07-10)
      if (marginTrend === 'improving') {
        // Improving trend - reward stability or neutralize variance (no penalty)
        b2Score = lerpAnchors(marginVariance, [[1, 0.25], [2, 0.15], [3, 0]]);
        b2Calculation = `Std dev: ${marginVariance.toFixed(2)}% (${recentMargins.length} years) - improving trend`;
      } else if (marginTrend === 'declining') {
        // Declining trend - concerning regardless of variance
        b2Score = lerpAnchors(marginVariance, [[2, -0.15], [4, -0.25]]);
        b2Calculation = `Std dev: ${marginVariance.toFixed(2)}% (${recentMargins.length} years) - declining trend`;
      } else {
        // Flat/volatile - standard variance scoring
        b2Score = lerpAnchors(marginVariance, [[1, 0.25], [2, 0.10], [3, -0.15], [5, -0.25]]);
        b2Calculation = `Std dev: ${marginVariance.toFixed(2)}% (${recentMargins.length} years)`;
      }
    }
    
    // B3: REMOVED - was redundant with B2 (both measured EBITDA volatility)
    // Previously: EBITDA YoY Stability scored variance of dollar changes
    // This double-penalized the same underlying issue as B2
    const b3Score = 0; // Kept as placeholder for backwards compatibility
    
    // B4: EBITDA Negative Months - auto-penalty with override (unchanged)
    // If raw EBITDA is positive all 12 months, no concern
    // If any negative months, auto-apply penalty (user can override)
    let b4AutoScore = 0;
    let b4Calculation = 'No monthly data - enter in TTM P&L tab';
    let b4Flag = false;
    const negMonths = normalizedEbitdaMonthly.negativeMonths || 0;
    
    if (normalizedEbitdaMonthly.hasMonthlyData) {
      // Auto-calculate penalty based on negative month count (using NORMALIZED values)
      if (negMonths === 0) b4AutoScore = 0;             // All months positive - no penalty
      else if (negMonths <= 2) b4AutoScore = -0.10;     // 1-2 negative months - minor concern
      else b4AutoScore = -0.25;                          // 3+ negative months - significant concern
      
      b4Calculation = negMonths === 0 
        ? 'All 12 months positive EBITDA ✓'
        : `${negMonths} month${negMonths !== 1 ? 's' : ''} with negative EBITDA (normalized)`;
      b4Flag = negMonths > 0 && !multipleAdjustments.ebitdaQuality.negativeMonthsReviewed;
    }
    
    // Apply override if user has reviewed and set one
    const b4Score = multipleAdjustments.ebitdaQuality.negativeMonthsOverride !== null 
      ? multipleAdjustments.ebitdaQuality.negativeMonthsOverride 
      : b4AutoScore;
    
    factors.B = { name: 'EBITDA Quality', subFactors: {
      B1: { name: 'EBITDA Margins', score: b1Score, calculation: b1Calculation, trend: marginTrend },
      B2: { name: 'Margin Stability', score: b2Score, calculation: b2Calculation, details: recentMargins, trend: marginTrend },
      B4: { name: 'EBITDA Negative Months', score: b4Score, autoScore: b4AutoScore, calculation: b4Calculation, flag: b4Flag, flagReason: `${negMonths} negative month${negMonths !== 1 ? 's' : ''} - verify timing/one-time items`, reviewed: multipleAdjustments.ebitdaQuality.negativeMonthsReviewed, noData: !normalizedEbitdaMonthly.hasMonthlyData, negativeMonths: negMonths }
    }, adjustment: b1Score + b2Score + b4Score };

    // C: Customer Retention & Growth - REWRITTEN
    // Key principle: Growing businesses shouldn't be penalized for retention metrics
    // What matters: Is the business growing? Are existing customers spending more or less?
    
    let cScore = 0;
    const hasCustomerData = customerSalesData && customerSalesData.length > 0 && customerSalesData.some(c => (c?.ttm || 0) > 0);
    const isGrowing = (keyMetrics?.revenueGrowingYoY || false) && (keyMetrics?.customerCountGrowing || false);
    const nrr = keyMetrics?.avgNRR ?? null;
    const revenueGrowing = keyMetrics?.revenueGrowingYoY || false;
    
    // Transactional/residential book detection (Zac-approved 2026-07-21):
    // year-over-year client retention is MEANINGLESS for a book of homeowners
    // or one-time buyers — a 2023 furnace customer who didn't buy in 2024 is
    // not churn. NRR math on such a book computes ~10-20% and fires the harsh
    // penalty branch; a TTM-only import of the same book faked a growth bonus.
    // Classified from data already in the tool: majority explicitly-typed
    // residential revenue, OR the transactional signature (hundreds+ active
    // clients, top-1 concentration under 5%). Untyped normal-shaped books are
    // untouched.
    const isTransactionalBook = hasCustomerData && (
      (keyMetrics?.residentialPct || 0) > 50 ||
      ((keyMetrics?.customerCount?.ttm || 0) >= 300 && (keyMetrics?.topCustomerPct || 0) > 0 && (keyMetrics?.topCustomerPct || 0) < 5)
    );

    // Determine the score based on growth + NRR
    // Smoothed: ramp NRR within each growth category instead of hard bands (Tier 3,
    // 2026-07-10, Zac-approved). The growth category itself (growing / rev-growing /
    // flat) stays a real categorical distinction. No NRR data → the old default score.
    if (hasCustomerData) {
      if (isTransactionalBook) {
        // NEUTRAL — no bonus, no penalty. Client-base strength for these books
        // is already credited through the concentration factor; scoring
        // retention here would double-count or (worse) miscount.
        cScore = 0;
      } else if (isGrowing) {
        // Growing business - reward, never penalize
        cScore = nrr === null ? 0.15 : lerpAnchors(nrr, [[90, 0.15], [100, 0.25], [110, 0.35]]);
      } else if (revenueGrowing) {
        // Revenue growing but customer count flat/down - still positive
        cScore = nrr === null ? 0 : lerpAnchors(nrr, [[80, 0], [90, 0.10], [100, 0.20]]);
      } else {
        // Revenue flat or declining - look more carefully at retention
        cScore = nrr === null ? 0 : lerpAnchors(nrr, [[70, -0.35], [80, -0.15], [90, 0], [100, 0.10]]);
      }
    }
    // No customer data = 0 (neutral, handled by accuracy gauge)

    // Build detailed calculation string
    let calcDetail = '';
    if (isTransactionalBook) {
      calcDetail = 'Residential/transactional book — year-over-year client retention doesn\'t apply; client-base strength is credited through the concentration factor';
    } else if (hasCustomerData) {
      const parts = [];
      const ttmChg = revenueAnalysis?.yoyChanges?.year5toTTM;
      if (revenueGrowing) parts.push(ttmChg !== null && ttmChg !== undefined && ttmChg < 0 ? `Revenue ↑ last full year, ↓${Math.abs(ttmChg).toFixed(0)}% TTM` : 'Revenue ↑');
      else parts.push('Revenue flat/↓');
      if (keyMetrics?.customerCountGrowing) parts.push('Customers ↑');
      if (nrr !== null) parts.push(`NRR ${nrr.toFixed(0)}%`);
      if (keyMetrics?.customerCount) {
        parts.push(`${keyMetrics.customerCount.year5 || 0}→${keyMetrics.customerCount.ttm || 0} clients`);
      }
      calcDetail = parts.join(', ');
    } else {
      calcDetail = 'No customer data - enter in Sales tab';
    }
    
    const retentionSourceLabels = { sales: '📊 Sales', none: '⚠️ No Data' };
    // Sub-factor scores DECOMPOSE the applied (smoothed) cScore so the
    // drill-down rows always sum to the factor (Mark 08-25, Proximity
    // Wireless: the NRR row still showed the pre-smoothing hard band -0.15x
    // while the smoothed adjustment was -0.03x — C2 was missed in the
    // Tier-3 cliff-smoothing pass). C1 = the categorical growth part;
    // C2 = whatever the NRR ramp added or removed on top of it.
    const c1Score = isTransactionalBook ? 0 : isGrowing ? 0.15 : revenueGrowing ? 0.1 : 0;
    const c2Score = isTransactionalBook || !hasCustomerData ? 0 : Math.round((cScore - c1Score) * 100) / 100;
    factors.C = {
      name: 'Customer Retention & Growth',
      subFactors: {
        C1: {
          name: 'Business Growth',
          score: c1Score,
          calculation: isTransactionalBook ? 'N/A — transactional/residential book' : isGrowing ? 'Revenue & customers growing' : revenueGrowing ? 'Revenue growing' : 'Flat/declining',
          source: hasCustomerData ? 'sales' : 'none',
          sourceLabel: retentionSourceLabels[hasCustomerData ? 'sales' : 'none']
        },
        C2: {
          name: 'Net Revenue Retention',
          score: c2Score,
          calculation: isTransactionalBook ? 'N/A — transactional/residential book' : nrr !== null ? `${nrr.toFixed(0)}% (existing customer revenue trend, smoothed ramp)` : 'No data',
          source: hasCustomerData ? 'sales' : 'none',
          sourceLabel: retentionSourceLabels[hasCustomerData ? 'sales' : 'none']
        }
      },
      adjustment: Math.round(cScore * 100) / 100,
      calculation: calcDetail,
      isGrowing: isGrowing,
      nrr: nrr,
      notes: '' 
    };

    // D: Contract Terms - CALIBRATED ±0.75x (was ±0.5x)
    // Use Sales tab data as PRIMARY source, fall back to manual only if no Sales data
    let dScore = 0;
    const hasSalesContractData = (keyMetrics?.contractedPct || 0) > 0 || (customerSalesData || []).some(c => c?.hasContract);
    
    // Determine data source and values
    const ct = multipleAdjustments.contractTerms || {};
    const avgContractLength = hasSalesContractData && keyMetrics?.avgContractMonths != null 
      ? (keyMetrics?.avgContractMonths || 0)
      : (ct.avgContractLength || 0);
    const assignablePctUsed = hasSalesContractData ? (keyMetrics?.assignablePct || 0) : 0;
    const escalatorPctUsed = hasSalesContractData ? (keyMetrics?.escalatorPct || 0) : 0;
    const avgEscalatorUsed = hasSalesContractData ? (keyMetrics?.avgEscalatorRate || 0) : (ct.escalatorPercent || 0);
    const termPenaltyPctUsed = hasSalesContractData ? (keyMetrics?.termPenaltyPct || 0) : 0;
    const autoRenewalPctUsed = hasSalesContractData ? (keyMetrics?.autoRenewalPct || 0) : 0;
    // Whole-book coverage — ledger-first (keyMetrics.contractCoveragePct):
    // works even with zero client detail, because the Revenue Classification
    // covers 100% of revenue. NOT gated on hasSalesContractData.
    const contractedPctUsed = revenueScoringMode === 'legacy' ? (keyMetrics?.contractCoveragePctLegacy || 0) : (keyMetrics?.contractCoveragePct || 0);
    // Revenue-weighted length buckets + near-term expirations (Sales-data path only)
    const multiYearRevPct = hasSalesContractData ? (keyMetrics?.multiYearRevPct || 0) : 0;
    const midTermRevPct   = hasSalesContractData ? (keyMetrics?.midTermRevPct || 0) : 0;
    const annualRevPct    = hasSalesContractData ? (keyMetrics?.annualRevPct || 0) : 0;
    const shortTermRevPct = hasSalesContractData ? (keyMetrics?.shortTermRevPct || 0) : 0;
    const nearTermExpiringRevPct = hasSalesContractData ? (keyMetrics?.nearTermExpiringRevPct || 0) : 0;
    const hasExpirationData = hasSalesContractData && (keyMetrics?.hasExpirationData || false);
    const top5Pct = keyMetrics?.top5CustomersPct || 0;

    // Manual fallbacks (only if no Sales data)
    const transferability = ct.transferability || 'unknown';
    const hasAutoRenewal = ct.hasAutoRenewal || false;
    const hasPriceEscalators = ct.hasPriceEscalators || false;
    const hasEarlyTermPenalty = ct.hasEarlyTermPenalty || false;
    const hasExitClauses = ct.hasExitClauses || false;
    
    // Contract coverage - NEW: reward having contracts at all
    if (contractedPctUsed >= 80) dScore += 0.15;      // 80%+ contracted
    else if (contractedPctUsed >= 50) dScore += 0.1;  // 50%+ contracted
    else if (contractedPctUsed > 0) dScore += 0.05;   // Some contracts
    // No-contracts penalty removed: when the owner doesn't return the Client Detail
    // Form, leave coverage neutral (0) instead of -0.35x worst-case. The yellow
    // "Owner Data Not Provided" callout explains the unknown. Manual entries below
    // (avgContractLength, transferability, etc.) still score normally if provided.
    
    // COVERAGE WEIGHTING (Mark approved 09-10; the RDS/Corkscrew exhibit —
    // one checkbox on 1% of revenue earned +0.15x): quality-of-known
    // credits scale with how much of the book is actually KNOWN.
    //   credit × min(1, detail coverage ÷ 50%)
    // At 3% coverage a "52% assignable" reading earns ~6% of its credit;
    // from 50% coverage up everything is full strength, exactly as before.
    // Applies to every sales-path term INCLUDING penalties (a thin sample
    // must not punish either); the whole-book ledger coverage credit above
    // and the manual-entry fallbacks are untouched. Sales-path terms
    // accumulate in dSales and are scaled once at the end.
    const covScale = Math.min(1, (keyMetrics?.detailCoveragePct || 0) / 50);
    let dSales = 0;

    // Contract length scoring
    // Sales path: weight the length premium by the SHARE of revenue under each term
    // length, so a base where only top clients are multiyear earns proportional —
    // not full — credit (Zac, PHD). A fully-multiyear base still reaches the old +0.30.
    if (hasSalesContractData) {
      dSales += 0.30 * (multiYearRevPct / 100)   // 3yr+ revenue
              + 0.20 * (midTermRevPct / 100)     // 2-3yr revenue
              + 0.10 * (annualRevPct / 100)      // 1-2yr revenue
              - 0.10 * (shortTermRevPct / 100);  // <1yr contracted revenue
    } else {
      // Manual fallback: per-client buckets unavailable, score the entered average
      if (avgContractLength >= 36) dScore += 0.3;      // 3+ years
      else if (avgContractLength >= 24) dScore += 0.2; // 2+ years
      else if (avgContractLength >= 12) dScore += 0.1; // Annual
      else if (avgContractLength > 0 && avgContractLength < 12) dScore -= 0.1; // Short term
    }
    
    // Assignability - from Sales tab or manual
    if (hasSalesContractData) {
      if (assignablePctUsed >= 80) dSales += 0.2;      // Most contracts assignable
      else if (assignablePctUsed >= 50) dSales += 0.1; // Majority assignable
      else if (assignablePctUsed > 0) dSales += 0.05;  // Some assignable
    } else {
      if (transferability === 'high') dScore += 0.2;
      else if (transferability === 'medium') dScore += 0.05;
      else if (transferability === 'low') dScore -= 0.25;
    }
    
    // Auto-renewal
    if (hasSalesContractData) {
      if (autoRenewalPctUsed >= 50) dSales += 0.1;
    } else if (hasAutoRenewal) {
      dScore += 0.1;
    }
    
    // Price escalators
    if (hasSalesContractData) {
      if (escalatorPctUsed >= 50 && avgEscalatorUsed >= 5) dSales += 0.2;
      else if (escalatorPctUsed >= 30 && avgEscalatorUsed >= 3) dSales += 0.15;
      else if (escalatorPctUsed > 0) dSales += 0.1;
    } else if (hasPriceEscalators) {
      if (avgEscalatorUsed >= 5) dScore += 0.2;
      else if (avgEscalatorUsed >= 3) dScore += 0.15;
      else dScore += 0.1;
    }
    
    // Early termination penalty
    if (hasSalesContractData) {
      if (termPenaltyPctUsed >= 50) dSales += 0.15;
      else if (termPenaltyPctUsed > 0) dSales += 0.1;
    } else if (hasEarlyTermPenalty) {
      dScore += 0.15;
    }
    
    // Exit clauses (negative - only from manual)
    if (!hasSalesContractData && hasExitClauses) dScore -= 0.15;

    // Near-term expiration penalty — protection lapsing within ~12 months concerns
    // buyers regardless of auto-renewal (Zac, UVS). Weight by concentration: a base
    // whose top 5 are a small slice (~20%) is light; a concentrated base (60%+) is
    // heavy. Only applies when per-client end dates are available.
    let dExpirationPenalty = 0;
    if (hasSalesContractData && hasExpirationData && nearTermExpiringRevPct > 0) {
      // Smoothed (Tier 2): ramp both drivers instead of stepping. concMult 0.25 at
      // top5≤20% → 1.0 at top5≥60%; expBase 0 at 0% expiring → 0.40 at ≥40% expiring.
      const concMult = lerpAnchors(top5Pct, [[20, 0.25], [60, 1.0]]);
      const expBase = lerpAnchors(nearTermExpiringRevPct, [[0, 0], [40, 0.40]]);
      dExpirationPenalty = -Math.min(0.40, expBase * concMult);
      dSales += dExpirationPenalty;
    }

    // Apply the coverage weight to everything the detailed sample claimed.
    dScore += dSales * covScale;

    // Build calculation description
    const contractDetails = [];
    // Coverage disclosure (Mark 2026-08-04): every reader sees how much is
    // observed vs assumed, and which exact source carries the whole-book %.
    if (contractedPctUsed > 0) {
      contractDetails.push(`${contractedPctUsed.toFixed(0)}% of revenue contracted (${keyMetrics?.contractCoverageSource === 'ledger' ? 'ledger: revenue classification' : 'per-client answers'})`);
    }
    if (hasSalesContractData && (keyMetrics?.detailCoveragePct || 0) > 0) {
      contractDetails.push(`contract detail covers ${keyMetrics.detailCoveragePct.toFixed(0)}% of revenue`);
      // The weighting shows its work (approved 09-10): thin samples say so.
      if (covScale < 1) contractDetails.push(`detail credits weighted ×${covScale.toFixed(2)} (full strength at 50% coverage)`);
      // Cross-check: ledger vs per-client answers should agree when detail
      // coverage is meaningful — a big gap means someone's numbers need
      // reconciling BEFORE a buyer finds it.
      if (keyMetrics?.contractCoverageSource === 'ledger' && keyMetrics.detailCoveragePct >= 60
          && Math.abs((keyMetrics.detailedContractedPct || 0) - contractedPctUsed) > 20) {
        contractDetails.push(`⚠ ledger says ${contractedPctUsed.toFixed(0)}% but client answers say ${(keyMetrics.detailedContractedPct || 0).toFixed(0)}% — reconcile`);
      }
    }
    if (hasSalesContractData) {
      if (multiYearRevPct > 0) contractDetails.push(`${multiYearRevPct.toFixed(0)}% rev multiyear`);
      if (assignablePctUsed > 0) contractDetails.push(`${assignablePctUsed.toFixed(0)}% assignable`);
      if (avgContractLength > 0) contractDetails.push(`${avgContractLength.toFixed(0)}mo avg term`);
      if (escalatorPctUsed > 0) contractDetails.push(`${escalatorPctUsed.toFixed(0)}% w/ escalators`);
      if (termPenaltyPctUsed > 0) contractDetails.push(`${termPenaltyPctUsed.toFixed(0)}% term penalty`);
      if (autoRenewalPctUsed > 0) contractDetails.push(`${autoRenewalPctUsed.toFixed(0)}% auto-renew`);
      if (dExpirationPenalty < 0) contractDetails.push(`${nearTermExpiringRevPct.toFixed(0)}% rev expiring <12mo (${dExpirationPenalty.toFixed(2)}x)`);
    } else {
      if (avgContractLength > 0) contractDetails.push(`${avgContractLength}mo avg term`);
      else contractDetails.push('M2M/No contracts');
      contractDetails.push(`${transferability} transferability`);
      if (hasPriceEscalators) contractDetails.push(`${avgEscalatorUsed}% escalators`);
      if (hasEarlyTermPenalty) contractDetails.push('early term penalty');
      if (hasAutoRenewal) contractDetails.push('auto-renew');
    }
    
    // Bound Contract Terms to +1.10x / -0.75x. A fully-contracted multiyear base with
    // every right term legitimately earns ~+1.0x (Zac); the earlier flat ±0.75x cap
    // wrongly clipped that. Length is now coverage-weighted, so a partial base self-
    // corrects below the ceiling without a blunt cap. (revised 2026-06-23)
    const dScoreCapped = Math.max(-0.75, Math.min(1.10, dScore));
    const dCapApplied = dScoreCapped !== dScore;
    if (dCapApplied) contractDetails.push(`bounded to ${dScoreCapped >= 0 ? '+' : ''}${dScoreCapped.toFixed(2)}x`);

    factors.D = {
      name: 'Contract Terms',
      calculation: contractDetails.join(', ') || 'No data',
      adjustment: Math.round(dScoreCapped * 100) / 100,
      capApplied: dCapApplied,
      uncappedScore: Math.round(dScore * 100) / 100,
      calibrationNote: 'Multi-year with escalators vs M2M',
      notes: ct.notes || '',
      source: hasSalesContractData ? 'sales' : 'manual',
      sourceLabel: hasSalesContractData ? '📊 Sales' : '✏️ Manual'
    };

    // E: Concentration Risk - CALIBRATED with client diversification
    // Company A (242 clients, 22% top but contracted) = 7.0x
    // Company B (40 MSP clients, 21% top on M2M) = 2.5x
    // Company D (18 clients) = 5.87x (lower despite strong metrics)
    const conc = multipleAdjustments.concentration || {};
    
    // Get Discovery estimates (Q4 = client count, Q5 = top customer %)
    const discoveryClientCount = sellerQA.find(q => q.id === 4)?.numericValue || null;
    const discoveryTopCustomerPct = sellerQA.find(q => q.id === 5)?.numericValue || null;
    
    // Priority: Sales tab > Manual entry > Discovery estimate
    let topCustomerPct = 0;
    let topCustomerSource = 'none';
    if ((keyMetrics?.topCustomerPct || 0) > 0) {
      topCustomerPct = keyMetrics?.topCustomerPct || 0;
      topCustomerSource = 'sales';
    } else if (conc.topCustomerPct > 0) {
      topCustomerPct = conc.topCustomerPct;
      topCustomerSource = 'manual';
    } else if (discoveryTopCustomerPct !== null) {
      topCustomerPct = discoveryTopCustomerPct;
      topCustomerSource = 'discovery';
    }
    
    const top5CustomersPct = (keyMetrics?.top5CustomersPct || 0) > 0 ? (keyMetrics?.top5CustomersPct || 0) : (conc.top5CustomersPct || 0);
    const topVendorPct = conc.topVendorPct || 0; // No Sales tab equivalent
    
    // Count clients: Sales tab > Manual entry > Discovery estimate
    const salesTabClientCount = (customerSalesData || []).filter(c => (c?.ttm || 0) > 0).length;
    let totalClientCount = 0;
    let clientCountSource = 'none';
    if (salesTabClientCount > 0) {
      totalClientCount = salesTabClientCount;
      clientCountSource = 'sales';
    } else if (conc.totalClientCount > 0) {
      totalClientCount = conc.totalClientCount;
      clientCountSource = 'manual';
    } else if (discoveryClientCount !== null) {
      totalClientCount = discoveryClientCount;
      clientCountSource = 'discovery';
    }
    
    // Get contract status for top 5 customers from Sales tab.
    // Period first: sorting by raw TTM on a book that runs on year-5 data
    // mis-IDENTIFIES the top 5 (Concise 08-19) — pick the same period the
    // rest of concentration uses.
    const _eConcPeriod = (customerSalesData || []).reduce((s, c) => s + (c.ttm || 0), 0) > 0 ? 'ttm' : 'year5';
    const sortedCustomers = (customerSalesData || []).filter(c => !isRemainderRow(c)).sort((a, b) => (b?.[_eConcPeriod] || 0) - (a?.[_eConcPeriod] || 0));
    const top5Customers = sortedCustomers.slice(0, 5).filter(c => (c?.[_eConcPeriod] || 0) > 0);
    // UN-ASKED ≠ M2M (the A4/D law's E twin, Concise 08-19): a top-5 row
    // the owner never touched must not vote "no contract" into the
    // concentration-mitigation score. Touched = any owner-provided detail
    // beyond name + revenue. Fewer than 3 of the top 5 touched → the
    // top-5 read is a guess, so it abstains (null → top-1 fallback path).
    const _eRowTouched = (c) => !!(
      c.hasContract === true || c.contractAnswered === true
      || (c.contractMonths !== null && c.contractMonths !== undefined)
      || c.contractStart || c.contractEnd
      || c.assignable || c.priceEscalator || c.earlyTermPenalty || c.autoRenewal
      || (c.billingFrequency && String(c.billingFrequency).trim())
      || (c.tenure && parseFloat(c.tenure) > 0)
      || (c.customerType && String(c.customerType).trim())
      || (c.industry && String(c.industry).trim())
    );
    const top5Touched = top5Customers.filter(_eRowTouched);
    const top5Revenue = top5Touched.reduce((s, c) => s + (c?.[_eConcPeriod] || 0), 0);
    const top5ContractedRevenue = top5Touched.filter(c => c?.hasContract).reduce((s, c) => s + (c?.[_eConcPeriod] || 0), 0);
    const top5ContractedPct = (top5Touched.length >= 3 && top5Revenue > 0) ? (top5ContractedRevenue / top5Revenue * 100) : null;
    
    // Check if top customer has contract from Sales tab
    // Only auto-populate from Sales tab if the client detail form has been returned and imported.
    // Signal: any customer has assignable/autoRenewal/earlyTermPenalty/priceEscalator explicitly set —
    // these fields are only populated by the detail form import, never by the revenue paste.
    const topCustomer = sortedCustomers[0];
    const detailFormImported = (customerSalesData || []).some(c => 
      c.assignable === true || c.assignable === false ||
      c.autoRenewal === true || c.autoRenewal === false ||
      c.earlyTermPenalty === true || c.earlyTermPenalty === false ||
      c.priceEscalator === true || c.priceEscalator === false
    );
    let topCustomerContracted = conc.topCustomerContracted || 'unknown';
    const _topConcentrationPeriod = _eConcPeriod;
    if (detailFormImported && topCustomer && _eRowTouched(topCustomer) && (topCustomer[_topConcentrationPeriod] || topCustomer.ttm) > 0) {
      if (topCustomer.hasContract) {
        // Check contract length from contractEnd if available
        const hasLongContract = topCustomer.contractEnd && (() => {
          const parts = topCustomer.contractEnd.split('/');
          if (parts.length === 2) {
            const endYear = parseInt(parts[1]) < 100 ? 2000 + parseInt(parts[1]) : parseInt(parts[1]);
            const endDate = new Date(endYear, parseInt(parts[0]) - 1, 1);
            const monthsRemaining = (endDate - new Date()) / (1000 * 60 * 60 * 24 * 30);
            return monthsRemaining > 12;
          }
          return false;
        })();
        // Also check contract length from contractMonths
        const contractLen = topCustomer.contractMonths || 0;
        topCustomerContracted = (hasLongContract || contractLen >= 24) ? 'multi_year' : contractLen >= 12 ? 'annual' : 'annual';
      } else {
        topCustomerContracted = 'mtm';
      }
    }
    // If detail form not yet imported, leave topCustomerContracted as manual dropdown value
    
    const industryConcentrationAdjustment = conc.industryConcentrationAdjustment || 0;
    
    let e1Score = 0;
    
    // REVISED: Customer % concentration - more conservative scoring
    // Only give bonus for truly diversified (each client small %)
    // IMPORTANT: Only score if there is an actual data source — 0% with no source
    // means 'no data', NOT 'perfectly diversified'. Zero must not trigger a bonus.
    // Smoothed: ramp through the same anchors instead of hard bands. (Tier 2, 2026-07-10)
    if (topCustomerSource !== 'none') {
      // Top customer %: 5→+0.15, 10→+0.10, 15→0, 25→-0.10, 35→-0.20, 45→-0.35
      e1Score += lerpAnchors(topCustomerPct, [[5, 0.15], [10, 0.10], [15, 0], [25, -0.10], [35, -0.20], [45, -0.35]]);
      // Top 5 %: 20→+0.15, 30→+0.10, 40→0, 50→-0.05, 60→-0.10, 70→-0.20, 80→-0.35
      e1Score += lerpAnchors(top5CustomersPct, [[20, 0.15], [30, 0.10], [40, 0], [50, -0.05], [60, -0.10], [70, -0.20], [80, -0.35]]);
    }
    
    // REVISED: Top 5 contract status - looks at ALL top 5, not just #1
    // Risk scales with how much of top 5 is NOT under contract
    // BUT: only penalize if Contract Terms (Factor D) is already neutral/positive
    // If contracts are weak across the board (dScore < 0), D already covers it —
    // E1b should only flag the concentration-specific risk when contracts generally exist
    let e1bScore = 0;
    const hasTop5Data = top5Customers.length > 0;
    const isTop5Concentrated = top5CustomersPct > 40;
    const contractTermsAlreadyNegative = dScore < -0.05; // D is already penalizing for weak contracts
    
    if (hasTop5Data && top5ContractedPct !== null) {
      if (top5ContractedPct >= 80) {
        e1bScore = 0.1;  // Most top customers contracted - reduced risk (always reward)
      } else if (top5ContractedPct >= 50) {
        e1bScore = 0;    // Neutral - mixed
      } else if (contractTermsAlreadyNegative) {
        e1bScore = 0;    // Don't double-penalize — D already covers weak contracts
      } else if (isTop5Concentrated) {
        // Top 5 is >40% of revenue AND <50% contracted AND contracts generally exist = real concentration risk
        e1bScore = top5CustomersPct >= 50 ? -0.25 : -0.15;
      } else {
        e1bScore = -0.05; // Some risk but not concentrated
      }
    } else {
      // Fall back to top customer contract status only
      if (contractTermsAlreadyNegative) {
        e1bScore = 0; // Don't double-penalize
      } else {
        const topCustContractScores = {
          'multi_year': 0.1,
          'annual': 0.05,
          'mtm': isTop5Concentrated ? -0.2 : -0.1,
          'unknown': 0
        };
        e1bScore = topCustContractScores[topCustomerContracted] || 0;
      }
    }
    
    const e2Score = industryConcentrationAdjustment;
    const e3Score = lerpAnchors(topVendorPct, [[30, 0], [40, -0.05], [55, -0.15]]); // smoothed (Tier 3)
    
    // Client diversification - REVISED
    // True diversification = many clients AND revenue spread evenly
    // If top 5 is concentrated (>40%), having lots of small clients doesn't help much
    let e4Score = 0;
    
    // Base score from client count — smoothed ramp through the same anchors:
    // 10→-0.25, 20→-0.10, 30→+0.05, 50→+0.15, 100→+0.30, 200→+0.40. (Tier 2, 2026-07-10)
    // count 0 = no data → 0 (guarded).
    let baseE4Score = 0;
    if (totalClientCount > 0) {
      baseE4Score = lerpAnchors(totalClientCount, [[10, -0.25], [20, -0.10], [30, 0.05], [50, 0.15], [100, 0.30], [200, 0.40]]);
    }

    // Diversification BONUS fades with concentration (30%→full, 50%→none); penalties
    // (too few clients) always apply in full. Smoothed gate replaces the hard >40% cutoff.
    if (baseE4Score > 0) {
      const e4Gate = lerpAnchors(top5CustomersPct, [[30, 1.0], [50, 0.0]]);
      e4Score = baseE4Score * e4Gate;
    } else {
      e4Score = baseE4Score;
    }
    
    // Build diversification display
    let e4Calculation = '';
    if (totalClientCount > 0) {
      e4Calculation = `${totalClientCount} clients`;
      if (baseE4Score > 0 && e4Score === 0) {
        e4Calculation += ` (bonus negated by ${top5CustomersPct.toFixed(0)}% top 5 concentration)`;
      } else if (baseE4Score > 0 && e4Score < baseE4Score) {
        e4Calculation += ` (reduced due to ${top5CustomersPct.toFixed(0)}% top 5)`;
      }
    } else {
      e4Calculation = 'Not entered';
    }
    
    // Build contract status display
    let contractStatusDisplay = '';
    if (hasTop5Data && top5ContractedPct !== null) {
      contractStatusDisplay = `Top 5: ${top5ContractedPct.toFixed(0)}% contracted`;
    } else {
      const topCustContractLabels = {
        'multi_year': 'Multi-year contract',
        'annual': 'Annual contract',
        'mtm': 'Month-to-month ⚠️',
        'unknown': 'Unknown'
      };
      contractStatusDisplay = topCustContractLabels[topCustomerContracted] || 'Not set';
    }
    
    const sourceLabels = { sales: '📊 Sales', manual: '✏️ Manual', discovery: '❓ Discovery', none: '' };
    factors.E = { name: 'Concentration Risk', subFactors: {
      E1: { name: 'Customer Concentration', score: Math.round(e1Score * 100) / 100, calculation: `Top: ${topCustomerPct.toFixed(1)}%, Top 5: ${top5CustomersPct.toFixed(1)}%`, source: topCustomerSource, sourceLabel: sourceLabels[topCustomerSource] },
      E1b: { name: 'Top 5 Contract Status', score: e1bScore, calculation: contractStatusDisplay, calibrationNote: 'Uncontracted concentrated revenue = elevated risk', source: hasTop5Data ? 'sales' : 'manual', top5ContractedPct: top5ContractedPct },
      E2: { name: 'Client Industry Concentration', score: e2Score, calculation: e2Score !== 0 ? `Manual: ${e2Score >= 0 ? '+' : ''}${e2Score.toFixed(2)}x` : 'Not assessed', industries: conc.clientIndustries || [], source: 'manual' },
      E3: { name: 'Vendor Concentration', score: e3Score, calculation: topVendorPct > 0 ? `Top vendor: ${topVendorPct}%` : 'Not entered', source: 'manual' },
      E4: { name: 'Client Diversification', score: e4Score, calculation: e4Calculation, calibrationNote: 'Bonus only if top 5 ≤ 40% of revenue', source: clientCountSource, sourceLabel: sourceLabels[clientCountSource] }
    }, adjustment: Math.round((e1Score + e1bScore + e2Score + e3Score + e4Score) * 100) / 100 };

    // H: Owner Transition - Simplified
    // Owner staying long-term = premium (buyer gets continuity)
    // Owner providing reasonable transition (30-90 days, 3-6 months) = neutral (normal expectation)
    // Owner leaving immediately = neutral (if salary adjusted properly)
    // Check Discovery Q17: "Do the owners want to exit post sale, or would any want to stay?"
    const ownerStayingQ = sellerQA.find(q => q.id === 17);
    const ownerStayingAnswer = (ownerStayingQ?.answer || '').toLowerCase();
    const ot = multipleAdjustments.ownerTransition || { ownersStaying: 'unknown', notes: '' };
    
    // Determine owner transition status from Discovery answer or manual override
    let ownersStayingStatus = ot.ownersStaying || 'unknown';
    let transitionDescription = '';
    
    // Parse the answer more intelligently
    if (ownerStayingAnswer) {
      // Check for long-term staying language
      if (ownerStayingAnswer.includes('stay') && (ownerStayingAnswer.includes('long') || ownerStayingAnswer.includes('permanent') || ownerStayingAnswer.includes('indefinite'))) {
        ownersStayingStatus = 'yes';
        transitionDescription = 'Owner staying long-term post-sale';
      }
      // Check for transition period language (months, days, weeks)
      else if (ownerStayingAnswer.match(/\d+\s*(month|day|week)/i) || 
               ownerStayingAnswer.includes('transition') || 
               ownerStayingAnswer.includes('train') ||
               ownerStayingAnswer.includes('hand off') ||
               ownerStayingAnswer.includes('handoff')) {
        ownersStayingStatus = 'transition';
        // Extract the time period if possible
        const timeMatch = ownerStayingAnswer.match(/(\d+[-–]\d+|\d+)\s*(month|day|week)s?/i);
        if (timeMatch) {
          transitionDescription = `${timeMatch[0]} transition period`;
        } else {
          transitionDescription = 'Transition period planned';
        }
      }
      // Check for immediate exit language
      else if (ownerStayingAnswer.includes('exit') || ownerStayingAnswer.includes('leave') || 
               ownerStayingAnswer.includes('retire') || ownerStayingAnswer.includes('no ') ||
               ownerStayingAnswer.includes('not stay') || ownerStayingAnswer.includes("won't stay")) {
        ownersStayingStatus = 'no';
        transitionDescription = 'Owner exiting at close';
      }
      // Check for staying language (but not long-term specified)
      else if (ownerStayingAnswer.includes('stay') || ownerStayingAnswer.includes('remain') || ownerStayingAnswer.includes('continue')) {
        ownersStayingStatus = 'yes';
        transitionDescription = 'Owner staying post-sale';
      }
      // If we have an answer but couldn't parse it, show what they said
      else {
        transitionDescription = ownerStayingAnswer.substring(0, 50) + (ownerStayingAnswer.length > 50 ? '...' : '');
      }
    }
    
    // NOTE: Owner Continuity (H) is scored AFTER Owner Dependency (J) below — its value
    // is conditional on the dependency level (Zac: continuity matters only when there is
    // a dependency problem to mitigate). ownersStayingStatus / transitionDescription are
    // computed above; factors.H is assigned in the H-after-J block following factor J.

    // I: Other Adjustments - for unusual/rare situations
    const otherAdj = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
    const otherAdjTotal = otherAdj.reduce((sum, item) => sum + (item?.adjustment || 0), 0);
    factors.I = {
      name: 'Other Adjustments',
      calculation: otherAdj.length > 0 ? otherAdj.map(item => `${item.description || 'Unnamed'}${item.relatedFactor && FACTOR_TAG_NAMES[item.relatedFactor] ? ` [→ ${FACTOR_TAG_NAMES[item.relatedFactor]}]` : ''}${item.adjustment ? ` (${item.adjustment >= 0 ? '+' : ''}${item.adjustment.toFixed(2)}x)` : ''}`).join(', ') : 'None',
      adjustment: Math.round(otherAdjTotal * 100) / 100,
      items: otherAdj,
      notes: ''
    };

    // J: Owner Dependency - How critical is owner to operations and revenue generation
    // This is DIFFERENT from Owner Continuity (H) - this measures operational risk
    // Q15: "How active are the owners in the business? Approximately how many hours per week?"
    // Q26: "What percentage of revenue comes from customer relationships the owner personally manages?" (dropdown)
    const ownerHoursQ = sellerQA.find(q => q.id === 15);
    const ownerRevenuePctQ = sellerQA.find(q => q.id === 26);
    const ownerHoursAnswer = ownerHoursQ?.numericValue || ownerHoursQ?.answer || '';
    
    // Parse owner hours from Discovery. The answer commonly lists MULTIPLE owners and/or
    // a RANGE, e.g. "Haney = 1-20 Cara = 40 Travis = 40". Dependency is driven by the
    // MOST-involved owner (the binding constraint on whether the business can run without
    // an owner), so take the MAX across all parsed values — not the first match, which
    // mis-read "1-20 ... 40 ... 40" as 1 hr/week. Filter to plausible weekly hours
    // (0–80) so stray years/dollar figures in the text don't hijack the score.
    // (fix 2026-06-24, Colleen — UNS)
    let parsedHours = null;
    let parsedHoursValues = [];
    if (ownerHoursAnswer || ownerHoursAnswer === 0) {
      const nums = String(ownerHoursAnswer).match(/\d+/g);
      if (nums) parsedHoursValues = nums.map(n => parseInt(n, 10)).filter(n => !isNaN(n) && n >= 0 && n <= 80);
      if (parsedHoursValues.length > 0) parsedHours = Math.max(...parsedHoursValues);
    }
    const multipleOwnersDetected = parsedHoursValues.length > 1;
    
    // Get revenue generation % from Q26 dropdown - default to 0 if not answered
    // This replaces the old text inference logic which was error-prone
    const q26Answered = ownerRevenuePctQ?.numericValue != null;
    let parsedRevenuePct = q26Answered ? ownerRevenuePctQ.numericValue : 0;
    let inferredStructure = null; // Only used if we had to infer (legacy)
    
    // Determine involvement level purely from Discovery data
    let involvementLevel = 'unknown';
    let jScore = 0;
    let jCalculation = '';
    
    if (parsedHours !== null || q26Answered) {
      // Two continuous axes (smoothed redesign, 2026-07-10, Zac-approved). Replaces the
      // old hours×revenue matrix, which was internally inconsistent (low-hours bands
      // ignored owner-revenue %, high-hours bands used it) and cliffed up to 1.00x at the
      // 20-hr boundary.
      //   • time axis (hours):                    0→+1.0, 15→+0.5, 25→0, 35→-0.5 (clamped)
      //   • relationship axis (Q26 owner-rev %):  0→+0.25, 25→0, 50→-0.25, 100→-0.75
      // Combined additively and clamped to ±1.0; owner-rev % now applies at EVERY hour
      // level. When only one input is present the other axis contributes 0.
      const jTimeAxis = (h) => {
        if (h <= 0) return 1.0;
        if (h <= 15) return 1.0 - (h / 15) * 0.5;           // +1.0 → +0.5
        if (h <= 25) return 0.5 - ((h - 15) / 10) * 0.5;    // +0.5 → 0
        if (h <= 35) return -((h - 25) / 10) * 0.5;         // 0 → -0.5
        return -0.5;
      };
      const jRelAxis = (r) => {
        if (r <= 0) return 0.25;
        if (r <= 25) return 0.25 - (r / 25) * 0.25;          // +0.25 → 0
        if (r <= 50) return -((r - 25) / 25) * 0.25;         // 0 → -0.25
        if (r <= 100) return -0.25 - ((r - 50) / 50) * 0.5;  // -0.25 → -0.75
        return -0.75;
      };
      const timeComponent = parsedHours !== null ? jTimeAxis(parsedHours) : 0;
      const relComponent = q26Answered ? jRelAxis(parsedRevenuePct) : 0;
      jScore = Math.round(Math.max(-1.0, Math.min(1.0, timeComponent + relComponent)) * 100) / 100;
      // Map the continuous score back to the existing involvement labels for display
      involvementLevel = jScore >= 0.5 ? 'board' : jScore >= 0.15 ? 'management'
                       : jScore > -0.15 ? 'operations' : jScore > -0.5 ? 'primary_revenue' : 'sole_revenue';
      const jHrsTxt = parsedHours !== null ? `${parsedHours} hrs/week` : 'hours n/a';
      const jRevTxt = q26Answered ? `~${parsedRevenuePct}% owner revenue` : 'owner-rev % not answered';
      jCalculation = `${jHrsTxt}, ${jRevTxt} → ${jScore >= 0 ? '+' : ''}${jScore.toFixed(2)}x`;
    } else {
      // No Discovery data - stay neutral (don't adjust multiple)
      jScore = 0;
      jCalculation = 'Not determined - answer Discovery Q15/Q26 (neutral until answered)';
    }
    
    // Owner Dependency is the primary owner-side lever and now scores symmetrically
    // to ±1.00 (high dependency hits as hard as independence rewards — Zac). The auto
    // score is bounded ±1.00; a reviewer can nudge beyond it for extreme cases the
    // metrics can't see (2 employees + $1M EBITDA is severe dependency on a hands-on
    // MSP but benign on a self-running SaaS, and hours alone can't tell them apart).
    // Manual adjustment is additive; the final result is bounded ±1.50. (2026-06-23)
    const jAutoScore = Math.max(-1.00, Math.min(1.00, jScore));
    const jManualAdj = Number(multipleAdjustments.ownerDependency?.manualAdjustment) || 0;
    const jScoreFinal = Math.max(-1.50, Math.min(1.50, jAutoScore + jManualAdj));
    if (jManualAdj !== 0) jCalculation += ` ${jManualAdj >= 0 ? '+' : ''}${jManualAdj.toFixed(2)}x manual = ${jScoreFinal >= 0 ? '+' : ''}${jScoreFinal.toFixed(2)}x`;

    factors.J = {
      name: 'Owner Dependency',
      calculation: jCalculation,
      adjustment: jScoreFinal,
      autoScore: jAutoScore,
      manualAdjustment: jManualAdj,
      source: (ownerHoursAnswer || q26Answered) ? 'discovery' : 'not_answered',
      sourceLabel: (ownerHoursAnswer || q26Answered) ? '✓ Discovery Q15/Q26' : '⚠️ Not answered',
      parsedHours,
      parsedHoursValues,
      multipleOwners: multipleOwnersDetected,
      parsedRevenuePct,
      inferredStructure,
      involvementLevel,
      q26Answered,
      notes: multipleAdjustments.ownerDependency?.notes || ''
    };

    // H (Owner Continuity) — scored AFTER J because its value is conditional on the
    // dependency level (Zac): keeping a load-bearing owner only PARTIALLY offsets a
    // dependency penalty (they may clash with the buyer and leave, become a key-man /
    // bus-factor risk, and staying usually raises the owner-comp adjustment, which
    // costs value elsewhere). When the business already runs without the owner,
    // continuity is largely irrelevant and earns ~nothing.
    let hScore = 0;
    let hCalculation = '';
    const ownerStaying = ownersStayingStatus === 'yes';
    if (ownerStaying && jAutoScore < 0) {
      // Partial mitigant only — offset half the AUTO dependency penalty, capped at
      // +0.35x. Keyed off jAutoScore (the data-driven dependency), NOT jScoreFinal, so
      // a reviewer's manual Owner Dependency adjustment moves J cleanly and is never
      // half-rebated by an automatic continuity bump it didn't ask for — and H no
      // longer shifts when you only change J's manual field. (2026-06-24)
      hScore = Math.min(0.35, -jAutoScore * 0.5);
      hCalculation = `${transitionDescription || 'Owner staying'} — partially offsets owner dependency (+${hScore.toFixed(2)}x)`;
    } else if (ownerStaying) {
      hScore = 0;
      hCalculation = `${transitionDescription || 'Owner staying'} (neutral — business not owner-dependent, continuity adds little)`;
    } else if (ownersStayingStatus === 'transition') {
      hScore = 0;
      hCalculation = transitionDescription + ' (neutral - standard transition)';
    } else if (ownersStayingStatus === 'no') {
      hScore = 0;
      hCalculation = transitionDescription + ' (neutral - salary normalized)';
    } else {
      const sortedQAh = [...sellerQA].sort((a, b) => a.id - b.id);
      const qNumsH = {};
      sortedQAh.forEach((q, idx) => { qNumsH[q.id] = idx + 1; });
      hCalculation = `Not determined - check Discovery Q${qNumsH[17] || 17}`;
    }

    factors.H = {
      name: 'Owner Continuity',
      calculation: hCalculation,
      adjustment: Math.round(hScore * 100) / 100,
      source: ownerStayingAnswer ? 'discovery' : 'manual',
      sourceLabel: ownerStayingAnswer ? '❓ Discovery' : '✏️ Manual',
      notes: ot.notes || ''
    };

    // G: A/R & Collections Quality (AR/AP) — RENAMED 08-27 (was "Working
    // Capital Quality"; Mark: the old name collided with the real Working
    // Capital Analysis section and misled Colleen — this factor scores
    // collections health, not NWC) - REVISED
    // Key changes:
    // 1. AR buckets are now EXCLUSIVE (moderate vs serious) to avoid double-counting
    // 2. Override capability added for each factor
    // 3. Respects pastDueStartColumn configuration
    // 4. Labels use actual bucket labels, not hardcoded day ranges
    let gScore = 0;
    const totalAR = arAgingCalcs.totalAR;
    
    // Get pastDueStartColumn setting (which column is first "past due")
    // Column indices: 1=current, 2=days31to60, 3=days61to90, 4=days91to120, 5=days120plus
    const startCol = arAgingBucketLabels?.pastDueStartColumn || 2;
    const columnKeys = ['', 'current', 'days31to60', 'days61to90', 'days91to120', 'days120plus'];
    const columnValues = [0, 
      arAgingCalcs.current || 0, 
      arAgingCalcs.days31to60 || 0, 
      arAgingCalcs.days61to90 || 0, 
      arAgingCalcs.days91to120 || 0, 
      arAgingCalcs.days120plus || 0
    ];
    
    // Past due columns = from startCol to 5
    // Split: moderate = startCol up to (but not including) last 2 columns
    //        serious = last 2 columns (4+5)
    // But if startCol >= 4, there's no "moderate" zone — everything past due is serious
    
    // Moderate past due = columns from pastDueStartColumn up to (but not including) column 4
    // These are "past due but not seriously past due"
    let moderatePastDue = 0;
    const moderateColIndices = [];
    for (let i = startCol; i <= 3; i++) {
      moderatePastDue += columnValues[i];
      moderateColIndices.push(i);
    }
    
    // Seriously past due = always columns 4+5 (the last two buckets)
    const seriouslyPastDue = (arAgingCalcs.days91to120 || 0) + (arAgingCalcs.days120plus || 0);
    const seriousColIndices = [4, 5];
    
    const moderatePastDuePct = totalAR > 0 ? (moderatePastDue / totalAR * 100) : 0;
    const seriouslyPastDuePct = totalAR > 0 ? (seriouslyPastDue / totalAR * 100) : 0;
    
    // Build labels from actual bucket labels
    const getColLabel = (colIdx) => arAgingBucketLabels?.[columnKeys[colIdx]] || `Col ${colIdx}`;
    const moderateLabel = moderateColIndices.length > 0 
      ? (moderateColIndices.length === 1 
          ? getColLabel(moderateColIndices[0])
          : `${getColLabel(moderateColIndices[0])}-${getColLabel(moderateColIndices[moderateColIndices.length - 1])}`)
      : 'N/A';
    const seriousLabel = `${getColLabel(4)}+`;
    
    // Negative balances - only flag if material (> $500 AND > 1% of AR)
    const negativeBalanceAmt = Math.abs(arAgingCalcs.negativeBalances || 0);
    const negativeBalancePct = totalAR > 0 ? (negativeBalanceAmt / totalAR * 100) : 0;
    const hasMaterialNegativeBalances = negativeBalanceAmt > 500 && negativeBalancePct > 1;
    
    // G1: AR Moderate Past Due - columns between pastDueStartColumn and serious (91+)
    // No bonus for empty bucket - neutral if clean, penalty if significant amounts
    let g1AutoScore = 0;
    if (totalAR > 0 && startCol <= 3 && moderatePastDue > 0) {
      // Only score if there's actually money in this bucket
      // Smoothed ramp: ≤10%→0, 20%→-0.05, ≥40%→-0.15 (Tier 3)
      g1AutoScore = lerpAnchors(moderatePastDuePct, [[10, 0], [20, -0.05], [40, -0.15]]);
    }
    // If moderatePastDue is 0, g1AutoScore stays at 0 (neutral)
    const wcq = multipleAdjustments.workingCapitalQuality || {};
    const g1Score = wcq.arPastDueOverride != null ? wcq.arPastDueOverride : g1AutoScore;
    
    // G2: AR Seriously Past Due (91+ days) - this is the more serious issue
    // Smoothed ramp through the same anchors: 5%→0, 10%→-0.10, 20%→-0.20, 30%→-0.30.
    let g2AutoScore = 0;
    if (totalAR > 0) {
      g2AutoScore = lerpAnchors(seriouslyPastDuePct, [[5, 0], [10, -0.10], [20, -0.20], [30, -0.30]]);
    }
    const g2Score = wcq.arSeriousOverride != null ? wcq.arSeriousOverride : g2AutoScore;
    
    // G3: Negative Balances
    let g3AutoScore = hasMaterialNegativeBalances ? -0.10 : 0;
    const g3Score = wcq.negativeBalancesOverride != null ? wcq.negativeBalancesOverride : g3AutoScore;
    
    // G4: AP quality - bonus if they track AP
    const g4Score = apAnalysis.postsAPRegularly === 'yes' ? 0.05 : 0;
    
    gScore = g1Score + g2Score + g3Score + g4Score;
    
    const arDataEntered = totalAR > 0;
    const negativeBalanceCalc = negativeBalanceAmt > 0 
      ? (hasMaterialNegativeBalances 
          ? `${formatCurrency(arAgingCalcs.negativeBalances)} (material)` 
          : `${formatCurrency(arAgingCalcs.negativeBalances)} (immaterial)`)
      : 'None';
    
    // Flags for items needing review
    const g1Flag = g1AutoScore < 0 && !wcq.arPastDueReviewed;
    const g2Flag = g2AutoScore < 0 && !wcq.arSeriousReviewed;
    const g3Flag = g3AutoScore < 0 && !wcq.negativeBalancesReviewed;
    
    factors.G = { 
      name: 'A/R & Collections Quality',
      subFactors: {
        G1: { 
          name: `AR Past Due (${moderateLabel})`, 
          score: g1Score, 
          autoScore: g1AutoScore,
          calculation: arDataEntered ? `${moderatePastDuePct.toFixed(1)}% (${moderateLabel})` : 'No AR data',
          flag: g1Flag,
          flagReason: `AR ${moderateLabel} past due - verify collectibility`,
          reviewed: wcq.arPastDueReviewed || false
        },
        G2: { 
          name: `AR Seriously Past Due (${seriousLabel})`, 
          score: g2Score, 
          autoScore: g2AutoScore,
          calculation: arDataEntered ? `${seriouslyPastDuePct.toFixed(1)}%` : 'No AR data',
          flag: g2Flag,
          flagReason: `AR ${seriousLabel} days past due - high risk of uncollectible`,
          reviewed: wcq.arSeriousReviewed || false
        },
        G3: { 
          name: 'Negative Balances', 
          score: g3Score, 
          autoScore: g3AutoScore,
          calculation: negativeBalanceCalc,
          flag: g3Flag,
          flagReason: 'Material negative AR balances - verify credits/prepayments',
          reviewed: wcq.negativeBalancesReviewed || false
        },
        G4: { name: 'AP Posting Quality', score: g4Score, calculation: apAnalysis.postsAPRegularly === 'yes' ? 'Posts regularly (+0.05x)' : 'Does not post (typical)' }
      },
      adjustment: Math.round(gScore * 100) / 100,
      dataEntered: arDataEntered
    };

    // K: Franchise Factor - structural adjustment for franchise businesses
    const franchise = multipleAdjustments.franchise || {};
    let kScore = 0;
    let kCalc = 'Not a franchise';
    let kDataEntered = franchise.isFranchise;
    
    if (franchise.isFranchise) {
      // Base penalty: franchisor approval limits buyer pool
      let basePenalty = franchise.franchisorApproval ? -0.20 : -0.10;
      
      // Remaining term adjustment
      let termAdj = 0;
      if (franchise.remainingTermYears != null && franchise.remainingTermYears > 0) {
        // Smoothed ramp: ≤3yr→-0.35, 5yr→-0.15, ≥10yr→0 (Tier 3)
        termAdj = lerpAnchors(franchise.remainingTermYears, [[3, -0.35], [5, -0.15], [10, 0]]);
      }
      
      // Territory: exclusive partially offsets restriction
      let territoryAdj = franchise.territoryExclusive ? 0.10 : 0;
      
      kScore = basePenalty + termAdj + territoryAdj;
      
      const parts = [];
      parts.push(`Base: ${basePenalty.toFixed(2)}x (${franchise.franchisorApproval ? 'buyer approval required' : 'standard franchise'})`);
      if (termAdj !== 0) parts.push(`Term: ${termAdj.toFixed(2)}x (${franchise.remainingTermYears} yrs remaining)`);
      if (territoryAdj !== 0) parts.push(`Territory: +${territoryAdj.toFixed(2)}x (exclusive)`);
      kCalc = parts.join(', ');
    }
    
    factors.K = {
      name: 'Franchise',
      adjustment: Math.round(kScore * 100) / 100,
      calculation: kCalc,
      dataEntered: kDataEntered
    };

    // L: Software Durability (Zac 11-03, a software buyer's view — Zac: "Build both"). SaaS-typed deals only, and
    // not presented / engaged ones (legacy scoring keeps the old rules, like the IT Dev change).
    // L1: buyers get excited about GRR above 90% faster than linearly (93-94% "super excited"), and it must hold
    //     across periods, so the premium rides the LOWEST period GRR VT has.
    // L2: AI disruption: deterministic (rule-based answers that must be exactly right) + highly verticalized.
    if (selectedIndustry === 'saas' && revenueScoringMode !== 'legacy') {
      const rbp = keyMetrics?.retentionByPeriod || {};
      const grrVals = [rbp.y3to4, rbp.y4to5, rbp.y5toTTM].filter(v => v !== null && v !== undefined);
      const minGrr = hasCustomerData && !isTransactionalBook && grrVals.length ? Math.min(...grrVals) : null;
      const l1Score = minGrr === null || minGrr < 90 ? 0
        : Math.round(lerpAnchors(minGrr, [[90, 0], [92, 0.15], [93, 0.30], [94, 0.50], [95, 0.60]]) * 100) / 100;
      const sd = multipleAdjustments.saasDurability || {};
      const answers = [sd.deterministic, sd.vertical];
      const bothAnswered = answers.every(a => a === 'yes' || a === 'no');
      const yesCount = answers.filter(a => a === 'yes').length;
      const l2Score = !bothAnswered ? 0 : yesCount === 2 ? 0.25 : yesCount === 0 ? -0.25 : 0;
      factors.L = {
        name: 'Software Durability (SaaS)',
        subFactors: {
          L1: {
            name: 'Gross Revenue Retention (lowest period)',
            score: l1Score,
            calculation: minGrr === null ? 'No client sales data' : `${minGrr.toFixed(1)}% lowest of ${grrVals.length} period${grrVals.length === 1 ? '' : 's'} (${grrVals.map(v => v.toFixed(1) + '%').join(' · ')}) — premium starts above 90%, steepest 92-94%, +0.60x cap at 95%`,
            source: minGrr === null ? 'none' : 'sales',
            sourceLabel: minGrr === null ? '⚠️ No Data' : '📊 Sales'
          },
          L2: {
            name: 'AI durability: deterministic + verticalized',
            score: l2Score,
            calculation: !bothAnswered ? 'Not answered yet: answer both questions below' : `Deterministic: ${sd.deterministic} · Verticalized: ${sd.vertical} → ${yesCount === 2 ? 'both yes' : yesCount === 0 ? 'neither' : 'one of two'}`,
            source: 'discovery',
            flag: !bothAnswered,
            flagReason: 'Ask the owner both questions below. Until both are answered this adds 0.',
            reviewed: false
          }
        },
        adjustment: Math.round((l1Score + l2Score) * 100) / 100,
        calculation: `GRR ${l1Score >= 0 ? '+' : ''}${l1Score.toFixed(2)}x · AI durability ${l2Score >= 0 ? '+' : ''}${l2Score.toFixed(2)}x`,
        notes: ''
      };
    }

    // Factor-tagged Other Adjustments (Colleen 08-19): hang each tagged
    // manual adjustment on its related factor for DISPLAY — the factor's
    // auto-score is untouched and the amount still totals under I.
    otherAdj.forEach(item => {
      const f = item.relatedFactor && factors[item.relatedFactor];
      if (f) (f.taggedAdjustments = f.taggedAdjustments || []).push(item);
    });

    const totalAdjustment = Object.values(factors).reduce((sum, f) => sum + f.adjustment, 0);
    const adjustedMultiple = baseMultiple + totalAdjustment;
    const flags = [];
    if (factors.A?.subFactors?.A3?.flag && !factors.A?.subFactors?.A3?.reviewed) flags.push({ factor: 'A3', message: 'Revenue monthly stability needs review' });
    if (factors.B?.subFactors?.B4?.flag && !factors.B?.subFactors?.B4?.reviewed) flags.push({ factor: 'B4', message: 'EBITDA monthly stability needs review' });

    // Valuation range - calibrated to highest offers (market high)
    // Our engine is calibrated to winning bids, so adjustedMultiple = Market High
    // Typical offers run ~15% below top bidder
    // Floor multiple: a business with positive EBITDA always has value
    // Small businesses (~$75K EBITDA) = 2.0x floor, scales up to 3.0x at $300K+
    const getFloorMultiple = (ebitda) => {
      if (ebitda <= 0) return 0;
      if (ebitda >= 300000) return 3.0;
      if (ebitda <= 75000) return 2.0;
      return 2.0 + ((ebitda - 75000) / (300000 - 75000)) * 1.0;
    };
    const floorMult = adjustedEbitda > 0 ? getFloorMultiple(tierEbitda) : 0;
    const marketHighMultiple = Math.max(floorMult, adjustedMultiple);
    const typicalMultiple = Math.max(floorMult * 0.85, marketHighMultiple * 0.85);
    const conservativeMultiple = Math.max(floorMult * 0.80, marketHighMultiple * 0.80);
    const floorApplied = adjustedMultiple < floorMult && adjustedEbitda > 0;
    
    const valuationMarketHigh = Math.max(0, adjustedEbitda * marketHighMultiple - catchUpCapex);
    const valuationTypical = Math.max(0, adjustedEbitda * typicalMultiple - catchUpCapex);
    const valuationConservative = Math.max(0, adjustedEbitda * conservativeMultiple - catchUpCapex);

    // ========== DATA PROVENANCE ==========
    // Track whether the owner returned the Export Class. Form (revenue categories) and
    // the Client Detail Form (per-client contract data). When data is missing we score
    // on defaults — surface this in the UI so reviewers and owners see what accurate
    // data would do to the multiple.
    const _revCats = revenueCategories || [];
    const _hasRevCats = _revCats.length > 0;
    const _revCatsAllEstimated = _hasRevCats && _revCats.every(c => !c.isVerified);
    const _revVerifiedCount = _revCats.filter(c => c.isVerified).length;
    const _customers = customerSalesData || [];
    // Tricky group (Auto-Renew/Assignable/Escalator/Term Penalty): if any of the four
    // is true on any client, owner answered (blanks = legitimate "no"). If all four
    // are entirely blank across all clients, owner skipped the section.
    const _trickyAnswered = _customers.some(c =>
      c.autoRenewal === true || c.assignable === true ||
      c.priceEscalator === true || c.earlyTermPenalty === true
    );
    const _contractBasicsAnswered = _customers.some(c =>
      c.hasContract === true || (c.contractMonths || 0) > 0
    );
    const _contractDataProvided = _trickyAnswered || _contractBasicsAnswered;
    const _hasCustomerTypeData = _customers.some(c => c.customerType && c.customerType !== '');
    // Swing ranges = full best-to-worst adjustment if data were verified.
    // A1 bounds: hardcoded ±0.75x (see a1Score calc above).
    // D bounds: plausible spread from D scoring rules above.
    const revenueTypeMixSwing = { min: -0.75, max: 0.75 };
    const contractTermsSwing = { min: -0.45, max: 1.10 };
    if (factors.A) {
      factors.A.dataProvenance = {
        revenueCategoriesEstimated: _revCatsAllEstimated,
        verifiedCount: _revVerifiedCount,
        totalCount: _revCats.length,
        swing: revenueTypeMixSwing,
      };
    }
    if (factors.D) {
      factors.D.dataProvenance = {
        contractDataProvided: _contractDataProvided,
        swing: contractTermsSwing,
      };
    }
    const dataProvenance = {
      revenueCategories: {
        hasCategories: _hasRevCats,
        allEstimated: _revCatsAllEstimated,
        verifiedCount: _revVerifiedCount,
        totalCount: _revCats.length,
        swing: revenueTypeMixSwing,
      },
      clientDetail: {
        contractDataProvided: _contractDataProvided,
        contractBasicsAnswered: _contractBasicsAnswered,
        trickyAnswered: _trickyAnswered,
        hasCustomerTypeData: _hasCustomerTypeData,
        swing: contractTermsSwing,
      },
    };

    return {
      baseMultiple, rawBaseMultiple, factors, totalAdjustment, adjustedMultiple,
      // New range model: typical to market high
      marketHighMultiple, typicalMultiple, conservativeMultiple,
      multipleMin: typicalMultiple, multipleMax: marketHighMultiple,
      adjustedEbitda,
      fcfMode, tierEbitda, maintCapexInValue, ebitdaBeforeCapex: adjustedEbitda + maintCapexInValue, catchUpCapex,
      valuationMarketHigh, valuationTypical, valuationConservative,
      valuationMin: valuationTypical, valuationMax: valuationMarketHigh, valuationMid: valuationMarketHigh,
      flags, currentTier, nextTier, currentTierIndex, ebitdaToNextTier, growthScenarios,
      scaledLocationAdj, locationScaleFactor, baseLocationAdj,
      floorApplied, floorMult, getFloorMultiple,
      dataProvenance
    };
    } catch (e) {
      console.error('multipleEngineCalcs error:', e);
      return {
        baseMultiple: 3.0, rawBaseMultiple: 3.0, factors: {}, totalAdjustment: 0, adjustedMultiple: 3.0,
        marketHighMultiple: 3.0, typicalMultiple: 2.55, conservativeMultiple: 2.4,
        multipleMin: 2.55, multipleMax: 3.0,
        adjustedEbitda: 0,
        valuationMarketHigh: 0, valuationTypical: 0, valuationConservative: 0,
        valuationMin: 0, valuationMax: 0, valuationMid: 0,
        flags: [], currentTier: null, nextTier: null, currentTierIndex: 0, ebitdaToNextTier: 0, growthScenarios: [],
        scaledLocationAdj: 0, locationScaleFactor: 1, baseLocationAdj: 0,
        dataProvenance: {
          revenueCategories: { hasCategories: false, allEstimated: false, verifiedCount: 0, totalCount: 0, swing: { min: -0.75, max: 0.75 } },
          clientDetail: { contractDataProvided: false, contractBasicsAnswered: false, trickyAnswered: false, hasCustomerTypeData: false, swing: { min: -0.45, max: 1.10 } }
        }
      };
    }
  }, [capexMethod, capexCatchUp, selectedIndustry, calculations, multipleAdjustments, revenueAnalysis, currentBenchmarks, baseMultipleTable, marketCondition, normalizedEbitdaMonthly, arAgingCalcs, apAnalysis, industryMultipleAdjustment, dealProfile.locationType, customerSalesData, revenueCategories, keyMetrics, sellerQA, proFormaCalcs, proFormaValuationBasis, selectedBasisCalcs, revenueScoringMode]);

  // ========== ROLL-OFF RISK ANALYSIS ==========
  const rollOffAnalysis = useMemo(() => {
    const monthlyEbitda = normalizedEbitdaMonthly?.monthlyEbitda || [];
    const hasData = monthlyEbitda.some(v => v !== 0);
    
    if (!hasData || monthlyEbitda.length < 12) {
      return { hasData: false, atRiskMonths: [], projections: [], currentTtmEbitda: 0 };
    }
    
    const currentTtmEbitda = monthlyEbitda.reduce((a, b) => a + b, 0);
    const monthlyAvg = currentTtmEbitda / 12;
    const multiple = multipleEngineCalcs?.adjustedMultiple || 3.0;
    
    // Identify at-risk months (significantly above average - >25%)
    const atRiskMonths = monthlyEbitda.map((ebitda, idx) => {
      const variance = monthlyAvg !== 0 ? ((ebitda - monthlyAvg) / Math.abs(monthlyAvg)) * 100 : 0;
      const monthsUntilRollOff = idx + 1; // Month 0 rolls off in 1 month, Month 1 in 2 months, etc.
      const atRiskAmount = ebitda > monthlyAvg ? ebitda - monthlyAvg : 0;
      return {
        monthIndex: idx,
        monthLabel: monthlyTtmLabels[idx] || `Month ${idx + 1}`,
        ebitda,
        variance,
        monthsUntilRollOff,
        atRiskAmount,
        isHighRisk: variance > 25,
        isLowRisk: variance < -25
      };
    });
    
    // Calculate forward projections (what happens as each month rolls off)
    const projections = [];
    let runningTtm = currentTtmEbitda;
    
    for (let i = 0; i < 4; i++) {
      const rollingOffMonth = atRiskMonths[i];
      const projectedReplacement = rollOffProjectedMonths[i] !== null ? rollOffProjectedMonths[i] : monthlyAvg;
      const newTtm = runningTtm - rollingOffMonth.ebitda + projectedReplacement;
      const change = newTtm - runningTtm;
      const changePct = runningTtm !== 0 ? (change / runningTtm) * 100 : 0;
      const currentValuation = runningTtm * multiple;
      const projectedValuation = newTtm * multiple;
      const valuationChange = projectedValuation - currentValuation;
      
      projections.push({
        monthsOut: i + 1,
        rollingOffMonth: rollingOffMonth.monthLabel,
        rollingOffEbitda: rollingOffMonth.ebitda,
        projectedReplacement,
        usingAverage: rollOffProjectedMonths[i] === null,
        previousTtm: runningTtm,
        newTtm,
        change,
        changePct,
        currentValuation,
        projectedValuation,
        valuationChange
      });
      
      runningTtm = newTtm;
    }
    
    // Calculate total at-risk amount (sum of excess EBITDA in high months rolling off in next 4 months)
    const nearTermAtRisk = atRiskMonths.slice(0, 4).filter(m => m.isHighRisk);
    const totalAtRiskEbitda = nearTermAtRisk.reduce((sum, m) => sum + m.atRiskAmount, 0);
    const totalAtRiskValuation = totalAtRiskEbitda * multiple;
    
    return {
      hasData: true,
      monthlyEbitda,
      monthlyAvg,
      currentTtmEbitda,
      multiple,
      atRiskMonths,
      projections,
      nearTermAtRisk,
      totalAtRiskEbitda,
      totalAtRiskValuation,
      currentValuation: currentTtmEbitda * multiple
    };
  }, [normalizedEbitdaMonthly, multipleEngineCalcs, monthlyTtmLabels, rollOffProjectedMonths]);

  // ========== ROLL-OFF RISK FLAGS ==========
  const rollOffFlags = useMemo(() => {
    const flags = [];
    const fmtCurrency = (num) => `$${Math.abs(num).toLocaleString()}`;
    
    // Skip if roll-off risk has been reviewed/acknowledged
    if (rollOffAcknowledged.reviewed) return flags;
    
    if (rollOffAnalysis.hasData && rollOffAnalysis.nearTermAtRisk.length > 0) {
      const totalAtRisk = rollOffAnalysis.totalAtRiskEbitda;
      const valuationAtRisk = rollOffAnalysis.totalAtRiskValuation;
      const highMonths = rollOffAnalysis.nearTermAtRisk.map(m => m.monthLabel).join(', ');
      
      // Check if projected decline is also significant
      const proj4 = rollOffAnalysis.projections?.[3];
      const hasDecline = proj4 && proj4.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9;
      const dropPct = hasDecline ? ((rollOffAnalysis.currentTtmEbitda - proj4.newTtm) / rollOffAnalysis.currentTtmEbitda * 100).toFixed(1) : null;
      
      flags.push({
        key: 'rolloff-risk',
        category: 'Roll-Off Risk',
        severity: hasDecline ? 'critical' : 'warning',
        item: hasDecline 
          ? `TTM EBITDA projected to decline ${dropPct}% — ${rollOffAnalysis.nearTermAtRisk.length} high month(s) rolling off`
          : `High-performing months rolling off soon`,
        detail: hasDecline
          ? `${rollOffAnalysis.nearTermAtRisk.length} month(s) with above-avg EBITDA rolling off (${highMonths}). At-risk EBITDA: ${fmtCurrency(totalAtRisk)}. TTM EBITDA projected to drop from ${fmtCurrency(rollOffAnalysis.currentTtmEbitda)} to ${fmtCurrency(proj4.newTtm)} in 4 months`
          : `${rollOffAnalysis.nearTermAtRisk.length} month(s) with above-avg EBITDA will roll off within 4 months (${highMonths}). At-risk EBITDA: ${fmtCurrency(totalAtRisk)} → Valuation impact: ${fmtCurrency(valuationAtRisk)}`,
        action: 'Review listing timing and check Roll-Off Risk Reviewed on analysis tab',
        canResolveAt: 'Income Statement → Analysis tab → Roll-Off Risk Analysis',
        resolveTab: 'detailed'
      });
    } else if (rollOffAnalysis.hasData && rollOffAnalysis.projections?.length > 0) {
      // Only the decline projection, no high months at risk
      const proj4 = rollOffAnalysis.projections[3];
      if (proj4 && proj4.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9) {
        const dropPct = ((rollOffAnalysis.currentTtmEbitda - proj4.newTtm) / rollOffAnalysis.currentTtmEbitda * 100).toFixed(1);
        flags.push({
          key: 'rolloff-risk',
          category: 'Roll-Off Risk',
          severity: 'critical',
          item: `TTM EBITDA projected to decline ${dropPct}%`,
          detail: `If upcoming months match average, TTM EBITDA will drop from ${fmtCurrency(rollOffAnalysis.currentTtmEbitda)} to ${fmtCurrency(proj4.newTtm)} in 4 months`,
          action: 'Review listing timing and check Roll-Off Risk Reviewed on analysis tab',
          canResolveAt: 'Income Statement → Analysis tab → Roll-Off Risk Analysis',
          resolveTab: 'detailed'
        });
      }
    }
    
    return flags;
  }, [rollOffAnalysis, rollOffAcknowledged.reviewed]);

  // Unacknowledged flags from the trend / roll-off analyzers — a flag source
  // separate from outstandingAnalysis. The Open Items list shows these, so
  // every count (header, filters, Pipeline open-items) must include them too.
  // 📌 Today's numbers in snapshot shape (TTM). Feeds the then-vs-now panel and the snapshot checks.
  const currentSnapshot = useMemo(() => {
    const y = (calculations && calculations.years && calculations.years[5]) || {};
    const me = multipleEngineCalcs || {};
    return {
      revenue: Number(y.revenue) || 0, reportedEbitda: Number(y.ebitda) || 0, adjustedEbitda: Number(y.adjustedEbitda) || 0,
      valuationEbitda: Number(me.adjustedEbitda) || 0, multiple: Number(me.adjustedMultiple) || 0,
      valueLow: Number(me.valuationTypical) || 0, valueHigh: Number(me.valuationMarketHigh) || 0,
      basis: selectedValuationBasis, ttmLabel: ttmLabel || '', asOf: (workflow && workflow.as_of_date) || '',
      lines: buildSnapLines({ revenueCategories, cogsCategories, opexCategories, otherIncomeCategories, otherExpenseCategories }, selectedValuationBasis),
      adj: buildSnapAdj(adjustmentItems),
    };
  }, [calculations, multipleEngineCalcs, selectedValuationBasis, ttmLabel, workflow, revenueCategories, cogsCategories, opexCategories, otherIncomeCategories, otherExpenseCategories, adjustmentItems]);

  // 🛡 SNAPSHOT CHECKS (Zac 10-03 Fabkom: EBITDA fell 670K→590K on a TTM update and nobody saw it until
  // the CIM). Compared to what we PRESENTED (or the baseline / prior valuation for older deals) — never to a
  // hand-off, so normal in-progress adjustment work doesn't trip them. Open items: the gauge, the Open Items
  // list and the analysis-complete gate all see them. Each is acknowledgeable with a written reason.
  const snapshotFlags = useMemo(() => {
    const flags = [];
    const all = [...(ebitdaSnapshots || []), ...(priorRevisionSnaps || [])].sort((a, b) => String(b.at || '').localeCompare(String(a.at || '')));
    const ref = all.find(s => ['presented', 'baseline', 'prior_valuation'].includes(s.kind) && s.adjustedEbitda);
    const fmt$ = (v) => '$' + Math.round(Math.abs(v)).toLocaleString();
    const cur = currentSnapshot;
    if (ref && cur.adjustedEbitda) {
      const chg = (cur.adjustedEbitda - ref.adjustedEbitda) / Math.abs(ref.adjustedEbitda);
      if (Math.abs(chg) > 0.10) {
        const movers = ref.lines ? snapLineMovers(ref.lines, cur.lines).slice(0, 4) : [];
        flags.push({
          key: `ebitda-moved-${ref.id}-${Math.round(cur.adjustedEbitda / 5000)}`, category: 'EBITDA Check', severity: 'critical', waivable: true,
          item: `Adjusted EBITDA moved ${chg >= 0 ? '+' : ''}${(chg * 100).toFixed(0)}% since ${(SNAP_KIND_LABEL[ref.kind] || ref.kind).toLowerCase()} (${ref.at ? new Date(ref.at).toLocaleDateString() : ''})`,
          detail: `TTM adjusted EBITDA ${fmt$(cur.adjustedEbitda)} now vs ${fmt$(ref.adjustedEbitda)} then${ref.ttmLabel && ref.ttmLabel !== cur.ttmLabel ? ` (${ref.ttmLabel} → ${cur.ttmLabel})` : ''}.${movers.length ? ' Biggest movers: ' + movers.map(m => `${m.name} ${m.effect >= 0 ? '+' : '−'}${fmt$(m.effect)}`).join(' · ') : ''}`,
          action: 'Presentation → 📊 Then vs now → Staff: what moved. Confirm each driver is real (not a paste/match error), then acknowledge with the reason.',
          canResolveAt: 'Presentation → Valuation Result → 📊 Then vs now', resolveTab: 'presentation',
        });
      }
      // An add-back line that carried money then and is $0 (or gone) now — Fabkom's officers' FICA.
      if (ref.lines) {
        const nowByKey = new Map(cur.lines.map(l => [l.s + '|' + snapNorm(l.n), l]));
        const nowByLeaf = {}; cur.lines.forEach(l => { const k = l.s + '|' + snapLeaf(l.n); (nowByLeaf[k] = nowByLeaf[k] || []).push(l); });
        ref.lines.filter(l => l.a > 0 && Math.abs(l.t) >= 1000).forEach(l => {
          const leaf = nowByLeaf[l.s + '|' + snapLeaf(l.n)] || [];
          const now = nowByKey.get(l.s + '|' + snapNorm(l.n)) || (leaf.length === 1 ? leaf[0] : null);
          if (!now || Math.abs(now.t) < 1) {
            flags.push({
              key: `addback-zeroed-${ref.id}-${snapNorm(l.n)}`, category: 'EBITDA Check', severity: 'warning', waivable: true,
              item: `Add-back line now $0: ${l.n}`,
              detail: `It had ${fmt$(l.t)} TTM with a ${l.a}% add-back at ${(SNAP_KIND_LABEL[ref.kind] || ref.kind).toLowerCase()}; now ${now ? '$0' : 'the line is gone'}. A re-paste may have put this money on a line without the add-back.`,
              action: 'Check where this money went on the P&L (Then vs now → what moved); move the add-back or fix the line, or acknowledge if the expense really stopped.',
              canResolveAt: 'Income Statement → expense lines', resolveTab: 'detailed',
            });
          }
        });
      }
    }
    // A dollar adjustment carried into a NEW TTM period unchanged — Fabkom's Accounting $3,895 / Dividends $177.
    const prevPeriod = all.find(s => s.ttmLabel && cur.ttmLabel && s.ttmLabel !== cur.ttmLabel && Array.isArray(s.adj));
    if (prevPeriod) {
      const prevTtm = new Map(prevPeriod.adj.filter(a => a.inc && a.y === 'TTM').map(a => [snapNorm(a.d) + '|' + snapNorm(a.l), a]));
      (adjustmentItems || []).filter(a => a.included !== false && a.year === 'TTM').forEach(a => {
        const p = prevTtm.get(snapNorm(a.description) + '|' + snapNorm(a.plLine));
        if (p && Math.abs((Number(a.amount) || 0) - p.amt) < 0.5) {
          flags.push({
            key: `carried-ttm-${a.id}-${snapNorm(cur.ttmLabel)}`, category: 'EBITDA Check', severity: 'warning', waivable: true,
            item: `Carried over unchanged into the new TTM: ${a.description || 'adjustment'} (${a.plLine})`,
            detail: `Same ${fmt$(a.amount)} as the ${prevPeriod.ttmLabel} TTM — the period is now ${cur.ttmLabel}. Re-confirm the amount for the new period.`,
            action: 'Adjustments tab → update the TTM amount (or acknowledge if it is genuinely the same).',
            canResolveAt: 'Adjustments tab', resolveTab: 'adjustments',
          });
        }
      });
    }
    // OVER-ADJUSTED, continuously (validateDeduction only ran at entry; a later TTM import that shrinks the line
    // never re-checked it — Fabkom: $3,895 against a $2,220 Accounting line).
    const seen = new Set();
    (adjustmentItems || []).filter(a => a.included !== false && a.type === 'deduct' && a.plLine && a.year).forEach(a => {
      const k = a.plLine + '|' + a.year; if (seen.has(k)) return; seen.add(k);
      const bal = getLineBalance(a.plLine, a.year);
      const tot = getExistingDeductions(a.plLine, a.year);
      if (bal !== Infinity && tot > bal + 0.5) {
        flags.push({
          key: `over-adjusted-${snapNorm(a.plLine)}-${a.year}-${Math.round(bal)}`, category: 'EBITDA Check', severity: 'critical', waivable: true,
          item: `Over-adjusted: ${a.plLine} (${a.year})`,
          detail: `Adjustments on this line total ${fmt$(tot)} but the line is only ${fmt$(bal)} for ${a.year}.`,
          action: 'Adjustments tab → reduce or remove the adjustment, or fix the P&L line.',
          canResolveAt: 'Adjustments tab', resolveTab: 'adjustments',
        });
      }
    });
    return flags;
  }, [ebitdaSnapshots, priorRevisionSnaps, currentSnapshot, adjustmentItems, revenueCategories, cogsCategories, opexCategories, otherIncomeCategories, otherExpenseCategories, selectedValuationBasis, basisYearLabels]);

  // 📌 Before a P&L paste is applied — the moment Fabkom broke. One per 10 minutes (cash + accrual back to back).
  const snapshotBeforePaste = (what) => {
    if (!currentSnapshot.revenue) return;
    const recent = (ebitdaSnapshots || []).some(s => s.kind === 'before_paste' && s.at && (Date.now() - new Date(s.at).getTime()) < 10 * 60000);
    if (!recent) takeEbitdaSnapshot('before_paste', what);
  };
  // 📌 Save a snapshot of today's numbers (presented / hand-off / manual / baseline).
  const takeEbitdaSnapshot = (kind, label) => {
    const snap = { ...currentSnapshot, id: 'snap-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6), kind, label: label || '', at: new Date().toISOString(), by: (userEmail || '').split('@')[0] };
    setEbitdaSnapshots(prev => [...(Array.isArray(prev) ? prev : []), snap].slice(-40));
    setHasUnsavedChanges(true);
    return snap;
  };

  // 🤖 AI REVIEW (Mark 10-05: "a way for AI to review and find these errors ahead of the valuation meeting, the
  // Lead discussion, CIM prep"). Runs when Colleen marks the analysis complete, and on demand. Advisory only —
  // never a gate (an AI false alarm must not block a hand-off). Uses the staff-gated Claude relay.
  const runAiReview = async (trigger) => {
    if (!supabaseClient || aiReviewBusy) return;
    setAiReviewBusy(true);
    try {
      const b = selectedValuationBasis === 'tax' ? 'cash' : (selectedValuationBasis || 'cash');
      const yl = [basisYearLabels.year3, basisYearLabels.year4, basisYearLabels.year5].map(x => x || '');
      const r0 = (v) => Math.round(Number(v) || 0);
      const sec = (title, cats) => (cats || []).filter(c => c && c.name).map(c => {
        const d = c[b] || {};
        return `${title} | ${c.name} | ${r0(d.year3)} | ${r0(d.year4)} | ${r0(d.year5)} | ${r0(d.ttm)} | ${Number(c.addbackPct) || 0}%`;
      }).join('\n');
      const pl = ['Section | Line | ' + yl.join(' | ') + ' | TTM | add-back %',
        sec('Revenue', revenueCategories), sec('COGS', cogsCategories), sec('OpEx', opexCategories), sec('Other income', otherIncomeCategories), sec('Other expense', otherExpenseCategories)].filter(Boolean).join('\n');
      // Monthly TTM figures (oldest → newest) — the only way to see single-month bookings / owner estimates.
      const mByCat = { Revenue: monthlyTtmRevenue, COGS: monthlyTtmCogs, OpEx: monthlyTtmOpex, 'Other income': monthlyTtmOtherIncome, 'Other expense': monthlyTtmOtherExpense };
      const msec = (title, cats) => (cats || []).filter(c => c && c.name).map(c => {
        const mv = mByCat[title] && mByCat[title][c.id]; const arr = mv && (mv[b] || mv.accrual || mv.cash);
        if (!Array.isArray(arr) || !arr.slice(0, 12).some(v => Number(v))) return null;
        return `${title} | ${c.name} | ${arr.slice(0, 12).map(r0).join(' | ')}`;
      }).filter(Boolean).join('\n');
      const monthly = [msec('Revenue', revenueCategories), msec('COGS', cogsCategories), msec('OpEx', opexCategories), msec('Other income', otherIncomeCategories), msec('Other expense', otherExpenseCategories)].filter(Boolean).join('\n');
      const adjs = (adjustmentItems || []).map(a => `${a.included === false ? '[excluded] ' : ''}${a.description || ''} | ${a.plLine || ''} | ${a.year || ''} | ${r0(a.amount)} | ${a.type || ''} | ${a.category || ''}`).join('\n') || '(none)';
      const all = [...(ebitdaSnapshots || []), ...(priorRevisionSnaps || [])].sort((x, y) => String(y.at || '').localeCompare(String(x.at || '')));
      const ref = all[0];
      const movers = ref && ref.lines ? snapLineMovers(ref.lines, currentSnapshot.lines).slice(0, 10).map(m => `${m.name}: ${r0(m.then)} → ${r0(m.now)} (EBITDA effect ${r0(m.effect)})`).join('\n') : '(no earlier snapshot)';
      const open = [...(outstandingAnalysis.unacknowledgedFlags || []), ...(extraOpenFlags || [])].slice(0, 25).map(fl => `[${fl.severity}] ${fl.item}`).join('\n') || '(none)';
      // The owner-comp lines the tool builds itself (Colleen 10-22 🐞, Arakyta: the review flagged "payroll taxes added
      // back 0%" because it never saw the automatic employer-tax line on the owner salary adjustment). Same math as the
      // engine's synthetic owner-comp lines: (owner salary − market replacement) × the payroll tax rate.
      const oc = ownerCompensation || {};
      const ocMarket = Number(oc.marketReplacement) || 0;
      const ocRate = oc.includePayrollTax !== false ? (Number(oc.payrollTaxRate) || 7.65) : 0;
      const ocSal = [oc.year3?.salary || 0, oc.year4?.salary || 0, oc.year5?.salary || 0, oc.ttm?.salary || (oc.embeddedInWages ? (oc.year5?.salary || 0) : 0)].map(Number);
      const ownerComp = ocSal.some(v => v) || ocMarket
        // Colleen 10-29 (Forward Slash): "Owner salary added back" read as an add-back, so the review flagged a
        // double count. The engine never adds this salary back; it only drives the market and payroll-tax lines.
        ? `Owner W2 salary (REFERENCE ONLY: the tool does NOT add this back; the salary add-back is the owner/officer P&L line % or an adjustment item, and this figure only drives the lines below) | ${ocSal.map(r0).join(' | ')}\nOwners in that salary | ${['year3', 'year4', 'year5', 'ttm'].map(p => ocOwnersFor(oc, p)).join(' | ')}\nLess market replacement (cost to hire, per year) | ${['year3', 'year4', 'year5', 'ttm'].map(p => r0(-ocMarketFor(oc, p))).join(' | ')}\nEmployer payroll tax on the salary adjustment, added AUTOMATICALLY by the tool (${payrollTaxLabel}) | ${ocSal.map((v, i) => r0(-ownerTaxAdj(v, ocMarket, ['year3', 'year4', 'year5', 'ttm'][i]))).join(' | ')}`
        : '(no owner compensation entered)';
      const user = `Company:${dealProfile.companyName || ''}\nBasis: ${b}\nTTM period: ${ttmLabel || ''}\nTTM revenue ${r0(currentSnapshot.revenue)}, reported EBITDA ${r0(currentSnapshot.reportedEbitda)}, adjusted EBITDA ${r0(currentSnapshot.adjustedEbitda)}${ref ? `\nAt the last saved point (${ref.kind}, ${ref.at ? ref.at.slice(0, 10) : ''}, ${ref.ttmLabel || ''}): adjusted EBITDA ${r0(ref.adjustedEbitda)}` : ''}\n\nP&L LINES:\n${pl}\n\nADJUSTMENTS (description | P&L line | year | amount | type | category):\n${adjs}\n\nOWNER COMPENSATION: the W2 salary the tool uses, then the ONLY lines it adds itself (market replacement, payroll tax). A 100% add-back on the officer salary line next to this W2 figure is NOT a double count (line | ${yl.join(' | ')} | TTM):\n${ownerComp}\n\nLINES THAT MOVED SINCE THE LAST SAVED POINT:\n${movers}\n\nMONTHLY TTM (${(monthlyTtmLabels || []).slice(0, 12).join(', ')}) — section | line | 12 months:\n${monthly || '(no monthly data entered)'}\n\nOPEN ITEMS ALREADY FLAGGED BY THE TOOL:\n${open}`;
      const system = 'You review a small-business valuation file for a business broker before it goes to the deal lead and the owner. Your job is to catch DATA and TOOL errors, not to judge the business. Look for: money that moved between lines across years (a line going to 0 while a similar line jumps; duplicate-looking lines like "X (2)"); add-back percentages that look wrong for the line (owner/officer payroll or payroll taxes not added back; ordinary employee costs added back 100%); dollar adjustments larger than their P&L line, or stale (same amount every period, or a TTM amount equal to an older year); revenue/expense lines whose TTM breaks sharply from their own history with no explanation; adjusted EBITDA swings vs the last saved point that the line moves do not explain. Also check these lessons from real misses:\n' + AI_REVIEW_LESSONS.map((l, i) => (i + 1) + '. ' + l).join('\n') + '\nThe tool itself adds the employer payroll tax on the owner salary adjustment (see OWNER COMPENSATION LINES): a payroll-tax P&L line at 0% add-back is CORRECT when that automatic line exists; flag payroll taxes only if owner salary is added back and that automatic line is missing or zero.\nDo NOT repeat the tool\'s open items unless you add something new. Be concrete: name the line and the numbers. Return ONLY a JSON array (no prose) of at most 12 objects: {"severity":"high"|"medium"|"low","line":"<P&L line or adjustment>","issue":"<one sentence with numbers>","check":"<what the analyst should verify>"}. Return [] if nothing looks wrong.';
      const { data: { session } } = await supabaseClient.auth.getSession();
      const resp = await fetch('/api/cim/narrative', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session && session.access_token) }, body: JSON.stringify({ system, user, maxTokens: 6000 }) });
      const j = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(j.error || ('HTTP ' + resp.status));
      const txt = String(j.text || '');
      const m = txt.match(/\[[\s\S]*\]/);
      let findings = [];
      try { findings = m ? JSON.parse(m[0]) : []; } catch (_) { findings = []; }
      findings = (Array.isArray(findings) ? findings : []).filter(x => x && x.issue).slice(0, 12);
      const rec = { at: new Date().toISOString(), trigger, by: (userEmail || '').split('@')[0], ttmLabel: ttmLabel || '', adjustedEbitda: currentSnapshot.adjustedEbitda, findings };
      setAiReviews(prev => [rec, ...(Array.isArray(prev) ? prev : [])].slice(0, 5));
      setHasUnsavedChanges(true);
      if (currentValuationId) logActivity(currentValuationId, 'ai_review', `🤖 AI review (${trigger}): ${findings.length} possible issue${findings.length === 1 ? '' : 's'}`, { findings: findings.length });
    } catch (e) {
      window.alert('AI review could not run: ' + (e && e.message ? e.message : e));
    } finally { setAiReviewBusy(false); }
  };

  // Archived revalue valuations become compare points (read-only, not persisted again).
  useEffect(() => {
    let cancelled = false;
    setPriorRevisionSnaps([]);
    if (!supabaseClient || !currentValuationId) return;
    (async () => {
      try {
        const { data } = await supabaseClient.from('valuation_revisions')
          .select('id, valued_date, value_low, value_high, archived_at, cv:data->calculatedValues, basis:data->selectedValuationBasis, rc:data->revenueCategories, cc:data->cogsCategories, oc:data->opexCategories, oic:data->otherIncomeCategories, oec:data->otherExpenseCategories, adj:data->adjustmentItems')
          .eq('valuation_id', currentValuationId).order('archived_at', { ascending: false }).limit(6);
        if (cancelled || !Array.isArray(data)) return;
        setPriorRevisionSnaps(data.map(r => {
          const cv = r.cv || {};
          return {
            id: 'rev-' + r.id, kind: 'prior_valuation', label: r.valued_date ? 'valued ' + r.valued_date : 'archived valuation',
            at: r.archived_at || r.valued_date, revenue: Number(cv.ttmRevenue) || 0, adjustedEbitda: Number(cv.ttmAdjustedEbitda) || 0,
            multiple: Number(cv.multipleEngine && cv.multipleEngine.adjustedMultiple) || 0,
            valueLow: Number(r.value_low) || 0, valueHigh: Number(r.value_high) || 0, ttmLabel: cv.ttmLabel || '',
            lines: buildSnapLines({ revenueCategories: r.rc, cogsCategories: r.cc, opexCategories: r.oc, otherIncomeCategories: r.oic, otherExpenseCategories: r.oec }, r.basis),
            adj: buildSnapAdj(r.adj),
          };
        }).filter(s => s.adjustedEbitda > 0 && s.revenue > 0));   // no saved EBITDA = not a fair compare point (an owner sees this screen)
      } catch (e) { /* compare points are optional */ }
    })();
    return () => { cancelled = true; };
  }, [currentValuationId]);   // eslint-disable-line react-hooks/exhaustive-deps

  // Baseline for deals already past presentation (they predate snapshots): one fixed point to compare future
  // TTM updates against. Taken once, after the deal has loaded; never for read-only viewers.
  const baselineTakenRef = useRef({});
  useEffect(() => {
    if (!currentValuationId || isReadOnlyViewer || !loadedUpdatedAtRef.current) return;
    // TTM UPDATE (month over month, Mark 10-05): the TTM period moved on since the newest saved point →
    // record the new period once (first open after the update was saved). Listed deals read as a trend.
    if ((ebitdaSnapshots || []).length > 0) {
      const newest = [...ebitdaSnapshots].sort((a, b) => String(b.at || '').localeCompare(String(a.at || '')))[0];
      const pkey = currentValuationId + '|' + currentSnapshot.ttmLabel;
      if (newest && newest.ttmLabel && currentSnapshot.ttmLabel && newest.ttmLabel !== currentSnapshot.ttmLabel && currentSnapshot.adjustedEbitda && !baselineTakenRef.current[pkey]) {
        const tmrP = setTimeout(() => { if (baselineTakenRef.current[pkey]) return; baselineTakenRef.current[pkey] = true; takeEbitdaSnapshot('period', currentSnapshot.ttmLabel); }, 4000);
        return () => clearTimeout(tmrP);
      }
      return;
    }
    if (baselineTakenRef.current[currentValuationId]) return;
    const past = !!(workflow && (workflow.valuation_date || ['awaiting_decision', 'strategic_review_set', 'considering_followup', 'engaged', 'val_complete_inactive'].includes(workflow.workflow_stage)));
    if (!past || !currentSnapshot.revenue || !currentSnapshot.adjustedEbitda) return;
    const id = currentValuationId;
    const tmr = setTimeout(() => {
      if (baselineTakenRef.current[id]) return;
      baselineTakenRef.current[id] = true;
      takeEbitdaSnapshot('baseline', 'numbers on file when snapshots began');
    }, 4000);
    return () => clearTimeout(tmr);
  }, [currentValuationId, ebitdaSnapshots, currentSnapshot.revenue, currentSnapshot.adjustedEbitda, currentSnapshot.ttmLabel, workflow]);   // eslint-disable-line react-hooks/exhaustive-deps

  // BOOKS vs OWNER CONTRACT ANSWERS (Mark 09-30 banner → Colleen 10-06 flag): the books' share of revenue
  // that is recurring agreement fees vs the share the owner's Client Detail answers put under contract
  // (revenue-weighted, answered clients). A 20-point gap is the first thing a buyer asks about.
  const contractReconcileFlags = useMemo(() => {
    const km = keyMetrics || {};
    const books = km.contractCoveragePct || 0, owner = km.detailedContractedPct || 0;
    if (km.contractCoverageSource !== 'ledger' || (km.detailCoveragePct || 0) < 60 || Math.abs(owner - books) <= 20) return [];
    return [{
      key: `contract-reconcile-${Math.round(books)}-${Math.round(owner)}`, category: 'Contract Check', severity: 'warning', waivable: true,
      item: `Books say ${books.toFixed(0)}% recurring agreement fees; the owner's client answers say ${owner.toFixed(0)}% under contract`,
      detail: `The value uses the books (Revenue Classification). The owner's figure comes from the Client Detail Form (each client's "under contract?" answer, weighted by revenue, answered clients only). Usual cause: projects, hardware or licensing billed outside the agreement, or a revenue line classified as the wrong type.`,
      action: 'Confirm with the owner: Open Items → the yellow reconcile note → 📧 Add as owner question. If a line is really billed under the agreement, fix its revenue type.',
      canResolveAt: 'Open Items', resolveTab: 'outstanding',
    }];
  }, [keyMetrics]);
  const extraOpenFlags = useMemo(() => [
    ...ytdTrendFlags.filter(f => !acknowledgedFlags[f.key]),
    ...rollOffFlags.filter(f => !acknowledgedFlags[f.key]),
    ...snapshotFlags.filter(f => !acknowledgedFlags[f.key]),
    ...contractReconcileFlags.filter(f => !acknowledgedFlags[f.key]),
  ], [ytdTrendFlags, rollOffFlags, snapshotFlags, contractReconcileFlags, acknowledgedFlags]);

  // ========== ACCURACY GAUGE ==========
  // Placed downstream of extraOpenFlags so the "Red Flags Resolved" factor
  // can include the trend / roll-off flags too — previously it counted only
  // outstandingAnalysis flags, inflating accuracy by up to 15 pts on
  // projects with open roll-off/trend issues (HANDOFF item 5; fixed 2026-05-27).
  const accuracyGauge = useMemo(() => {
    const factors = [];
    let totalWeight = 0;
    let earnedScore = 0;

    // Check if any financial data has been entered (using selected valuation basis)
    const hasAnyFinancialData = revenueCategories.some(r => {
      if (!r.name) return false;
      const basisData = r[selectedValuationBasis] || r.cash || {};
      return (basisData.year1 > 0 || basisData.year2 > 0 || basisData.year3 > 0 || basisData.year4 > 0 || basisData.year5 > 0 || basisData.ttm > 0);
    });

    // If no data entered at all, return 0%
    if (!hasAnyFinancialData) {
      return {
        overallScore: 0,
        tier: 'No Data',
        tierColor: 'red',
        factors: [{ name: 'Financial Data', weight: 100, score: 0, detail: 'Not entered', missing: 'Enter revenue and expense data' }],
        missingItems: ['Enter revenue and expense data to begin valuation']
      };
    }

    // 1. Company Setup (weight: 5) - Basic setup fields
    const setupItems = [
      { name: 'Company Name', filled: !!dealProfile.companyName },
      { name: 'Industry Sector', filled: !!selectedSector },
      { name: 'Industry', filled: !!selectedIndustry },
      { name: 'Location Type', filled: !!dealProfile.locationType },
      { name: 'City/State', filled: !!(dealProfile.city && dealProfile.state) }
    ];
    const setupFilled = setupItems.filter(s => s.filled).length;
    const setupTotal = setupItems.length;
    const setupPct = setupFilled / setupTotal;
    const setupMissing = setupItems.filter(s => !s.filled).map(s => s.name);
    factors.push({ name: 'Company Setup', weight: 5, score: setupPct * 100, detail: `${setupFilled}/${setupTotal}`, missing: setupPct < 1 ? `Set ${setupMissing.join(', ')}` : null });
    totalWeight += 5;
    earnedScore += setupPct * 5;

    // 2. Documents received (weight: 20)
    const docsReceived = documentChecklist.filter(d => d.status === 'complete').length;
    const docsTotal = documentChecklist.length;
    const docsPct = docsTotal > 0 ? docsReceived / docsTotal : 0;
    factors.push({ name: 'Documents Received', weight: 20, score: docsPct * 100, detail: `${docsReceived}/${docsTotal}`, missing: docsPct < 1 ? `${docsTotal - docsReceived} documents missing` : null });
    totalWeight += 20;
    earnedScore += docsPct * 20;

    // 3. Q&A Answered (weight: 15) - check both 'answered' and 'Answered' for compatibility
    const qaAnswered = sellerQA.filter(q => q.status === 'answered' || q.status === 'Answered').length;
    const qaTotal = sellerQA.length;
    const qaPct = qaTotal > 0 ? qaAnswered / qaTotal : 0;
    factors.push({ name: 'Discovery Answered', weight: 15, score: qaPct * 100, detail: `${qaAnswered}/${qaTotal}`, missing: qaPct < 1 ? `${qaTotal - qaAnswered} questions unanswered` : null });
    totalWeight += 15;
    earnedScore += qaPct * 15;

    // 4. Red Flags Resolved (weight: 15)
    // Count both outstandingAnalysis flags AND the trend / roll-off flags
    // (extraOpenFlags). They live on the same Open Items list and represent
    // the same "needs review" work, so the gauge must include both.
    const extraCritical = extraOpenFlags.filter(f => f.severity === 'critical').length;
    const extraWarning  = extraOpenFlags.filter(f => f.severity === 'warning' || f.severity === 'info').length;
    const criticalFlags = outstandingAnalysis.criticalCount + extraCritical;
    const warningFlags  = outstandingAnalysis.warningCount + extraWarning;
    const totalUnresolved = criticalFlags + warningFlags;
    const flagScore = totalUnresolved === 0 ? 100 : criticalFlags > 0 ? 0 : 50; // 0 if critical, 50 if only warnings
    // Only show the single consolidated count of items needing review
    factors.push({ name: 'Flags Resolved', weight: 15, score: flagScore, detail: `${criticalFlags} critical, ${warningFlags} warnings`, missing: totalUnresolved > 0 ? `${totalUnresolved} items need review` : null });
    totalWeight += 15;
    earnedScore += (flagScore / 100) * 15;

    // 5. Adjustments Documented (weight: 15)
    // Note: Undocumented adjustments are already counted as flags above, so don't add duplicate "missing" message
    const adjIncluded = adjustmentItems.filter(a => a.included);
    const adjDocumented = adjIncluded.filter(a => a.source).length;
    const adjTotal = adjIncluded.length;
    const adjPct = adjTotal > 0 ? adjDocumented / adjTotal : 1; // 100% if no adjustments entered (not penalized)
    factors.push({ name: 'Adjustments Documented', weight: 15, score: adjPct * 100, detail: adjTotal > 0 ? `${adjDocumented}/${adjTotal}` : 'None entered', missing: null });
    totalWeight += 15;
    earnedScore += adjPct * 15;

    // 6. Owner Comp Verified (weight: 10)
    // Consider verified if: any period explicitly marked verified, OR any period has a
    // documentary source (W-2, K-1, payroll, tax return) rather than Q&A estimate,
    // OR embedded in wages with no separate salary entered (nothing to verify)
    const ownerCompEmbeddedNoSalary = ownerCompensation.embeddedInWages &&
      (!ownerCompensation.ttm?.salary) && (!ownerCompensation.marketReplacement);
    const ownerPeriods = ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'];
    const anyPeriodVerified = ownerPeriods.some(p => ownerCompensation[p]?.verified);
    const anyDocSource = ownerPeriods.some(p => ownerCompensation[p]?.source && ownerCompensation[p].source !== 'qa');
    const ownerVerified = anyPeriodVerified || anyDocSource || ownerCompEmbeddedNoSalary;
    factors.push({ name: 'Owner Comp Verified', weight: 10, score: ownerVerified ? 100 : 0, detail: ownerVerified ? (ownerCompEmbeddedNoSalary ? 'Embedded in wages' : (ownerCompensation.ttm?.source || 'verified').toUpperCase()) : 'Not verified', missing: !ownerVerified ? 'Verify with W-2, K-1, or payroll' : null });
    totalWeight += 10;
    earnedScore += ownerVerified ? 10 : 0;

    // 7. Revenue Categories (weight: 5)
    // "Breakdown" means revenue has been classified and confirmed, not merely that there
    // are multiple P&L lines. A business with a single income account (e.g. Project Income)
    // has nothing more to split out — once that line is verified from source docs, the
    // breakdown is complete. So a verified single line counts the same as multiple categories.
    // Scored by the VERIFIED SHARE of TTM revenue (Mark 09-23, ITCS: 10 of 11
    // lines unverified — every big one — still read 99% because "more than one
    // category" scored 100 and the unverified-revenue flag is info-severity).
    // A verified single line is 100%; ten unverified lines are 0%; a business
    // with only Managed Services verified scores exactly that share.
    const namedRevCats = revenueCategories.filter(c => c.name && c.name.trim());
    const revTtmOf = (c) => Math.abs(Number((c[selectedValuationBasis] || {}).ttm) || 0);
    const revTtmTotal = namedRevCats.reduce((s, c) => s + revTtmOf(c), 0);
    const revTtmVerified = namedRevCats.filter(c => c.isVerified).reduce((s, c) => s + revTtmOf(c), 0);
    const revVerifiedCount = namedRevCats.filter(c => c.isVerified).length;
    // No TTM revenue yet: fall back to the count so an early-stage file is not
    // scored on money that is not entered.
    const revVerifiedPct = revTtmTotal > 0
      ? revTtmVerified / revTtmTotal
      : (namedRevCats.length > 0 ? revVerifiedCount / namedRevCats.length : 0);
    const revUnverified = namedRevCats.filter(c => !c.isVerified && (revTtmTotal <= 0 || revTtmOf(c) > 0));
    const revDetailLabel = namedRevCats.length === 0 ? 'No revenue lines'
      : `${revVerifiedCount}/${namedRevCats.length} lines verified · ${Math.round(revVerifiedPct * 100)}% of revenue`;
    factors.push({ name: 'Revenue Breakdown', weight: 5, score: revVerifiedPct * 100, detail: revDetailLabel,
      missing: revVerifiedPct < 1 ? `Verify ${revUnverified.length} revenue line${revUnverified.length === 1 ? '' : 's'} (${Math.round((1 - revVerifiedPct) * 100)}% of revenue unverified)` : null });
    totalWeight += 5;
    earnedScore += revVerifiedPct * 5;

    // 8. Multiple Years Data (weight: 10) - Check year3, year4, year5, TTM (indices 2, 3, 4, 5)
    const hasYear3 = calculations.years[2].revenue > 0;
    const hasYear4 = calculations.years[3].revenue > 0;
    const hasYear5 = calculations.years[4].revenue > 0;
    const hasTTM = calculations.years[5].revenue > 0;
    const yearsCount = [hasYear3, hasYear4, hasYear5, hasTTM].filter(Boolean).length;
    const yearsPct = yearsCount / 4;
    factors.push({ name: 'Historical Data', weight: 10, score: yearsPct * 100, detail: `${yearsCount}/4 periods`, missing: yearsPct < 1 ? `Add ${4 - yearsCount} more period(s)` : null });
    totalWeight += 10;
    earnedScore += yearsPct * 10;

    // 9. Customer Concentration Data (weight: 5) - Check both Sales tab (keyMetrics) and manual entry
    const salesTabTopCustomerPct = keyMetrics?.topCustomerPct || 0;
    const manualTopCustomerPct = multipleAdjustments.concentration?.topCustomerPct || 0;
    const hasConcentrationData = salesTabTopCustomerPct > 0 || manualTopCustomerPct > 0;
    const concentrationPct = salesTabTopCustomerPct > 0 ? salesTabTopCustomerPct : manualTopCustomerPct;
    const concentrationSource = salesTabTopCustomerPct > 0 ? 'Sales tab' : 'Manual';
    factors.push({ name: 'Customer Concentration', weight: 5, score: hasConcentrationData ? 100 : 0, detail: hasConcentrationData ? `${concentrationPct.toFixed(1)}% top customer (${concentrationSource})` : 'Not entered', missing: !hasConcentrationData ? 'Enter customer sales data or concentration %' : null });
    totalWeight += 5;
    earnedScore += hasConcentrationData ? 5 : 0;

    // 10. Balance Sheet Data (weight: 5)
    const hasBSData = balanceSheetCalcs.interim.totalAssets > 0 || balanceSheetCalcs.interim.cash > 0 || balanceSheetCalcs.interim.accountsReceivable > 0;
    factors.push({ name: 'Balance Sheet', weight: 5, score: hasBSData ? 100 : 0, detail: hasBSData ? 'Present' : 'Missing', missing: !hasBSData ? 'Enter balance sheet data' : null });
    totalWeight += 5;
    earnedScore += hasBSData ? 5 : 0;

    // 11. Monthly TTM Data (weight: 5) - Required for highest accuracy
    const hasMonthlyTtmData = Object.keys(monthlyTtmRevenue).length > 0 &&
      Object.values(monthlyTtmRevenue).some(catData => {
        const cashVals = catData?.cash || [];
        const accrualVals = catData?.accrual || [];
        return cashVals.slice(0, 12).some(v => v > 0) || accrualVals.slice(0, 12).some(v => v > 0);
      });
    factors.push({ name: 'Monthly TTM Data', weight: 5, score: hasMonthlyTtmData ? 100 : 0, detail: hasMonthlyTtmData ? 'Entered' : 'Missing', missing: !hasMonthlyTtmData ? 'Enter monthly TTM breakdown for trend analysis' : null });
    totalWeight += 5;
    earnedScore += hasMonthlyTtmData ? 5 : 0;

    const overallScore = totalWeight > 0 ? (earnedScore / totalWeight) * 100 : 0;

    // Determine tier
    let tier, tierColor;
    if (overallScore >= 90) { tier = 'High Confidence'; tierColor = 'green'; }
    else if (overallScore >= 75) { tier = 'Good Confidence'; tierColor = 'blue'; }
    else if (overallScore >= 50) { tier = 'Reasonable Estimate'; tierColor = 'yellow'; }
    else { tier = 'Preliminary Estimate'; tierColor = 'red'; }

    const missingItems = factors.filter(f => f.missing).map(f => f.missing);

    return { overallScore, tier, tierColor, factors, missingItems };
  }, [documentChecklist, sellerQA, adjustmentItems, ownerCompensation, revenueCategories, calculations, multipleAdjustments, balanceSheetCalcs, outstandingAnalysis, extraOpenFlags, dealProfile, selectedSector, selectedIndustry, keyMetrics, monthlyTtmRevenue]);

  // ========== SBA DEBT COVERAGE ANALYSIS ==========
  const sbaAnalysis = useMemo(() => {
    // PMT formula: PMT = P * (r * (1+r)^n) / ((1+r)^n - 1)
    const calcAnnualPayment = (principal, annualRate, years) => {
      if (principal <= 0 || years <= 0) return 0;
      const monthlyRate = annualRate / 100 / 12;
      const numPayments = years * 12;
      if (monthlyRate === 0) return principal / years;
      const monthlyPayment = principal * (monthlyRate * Math.pow(1 + monthlyRate, numPayments)) / (Math.pow(1 + monthlyRate, numPayments) - 1);
      return monthlyPayment * 12;
    };
    
    const dealValue = multipleEngineCalcs.valuationMarketHigh;
    const downPayment = dealValue * (sbaParams.downPaymentPct / 100);
    const sellerNote = dealValue * (sbaParams.sellerNotePct / 100);
    const sbaLoan = dealValue - downPayment - sellerNote;
    
    const sellerNotePayment = calcAnnualPayment(sellerNote, sbaParams.sellerNoteRate, sbaParams.sellerNoteTerm);
    const sbaLoanPayment = calcAnnualPayment(sbaLoan, sbaParams.sbaLoanRate, sbaParams.sbaLoanTerm);
    // 🏢 REAL ESTATE PACKAGE (Mark 10-20): when the property sells with the business, the buyer finances both and
    // stops paying rent. Cash available = free cash flow + the rent no longer paid (unless the rent was already
    // added back in Adjustments, in which case the value already includes the real estate: never count it twice).
    const reOn = !!sbaParams.reIncluded && (Number(sbaParams.reValue) || 0) > 0;
    const reValue = reOn ? Number(sbaParams.reValue) || 0 : 0;
    const reDown = reValue * ((sbaParams.reDownPct ?? 10) / 100);
    const reLoan = reValue - reDown;
    const reLoanPayment = reOn ? calcAnnualPayment(reLoan, sbaParams.reRate ?? 7.0, sbaParams.reTerm ?? 25) : 0;
    const reRentBack = reOn && !sbaParams.reRentAddedBack ? Math.max(0, Number(sbaParams.reRent) || 0) : 0;
    const totalPayments = sellerNotePayment + sbaLoanPayment + reLoanPayment;
    
    // Normalized EBITDA already includes owner salary at market replacement
    // This IS the cash available for debt service - no need to subtract owner salary again
    const adjustedEbitda = multipleEngineCalcs.adjustedEbitda;
    const ownerManager = ownerCompensation.marketReplacement;
    
    // Cash available = Normalized EBITDA (already accounts for market-rate owner salary)
    const cashAvailable = adjustedEbitda + reRentBack;
    const margin = cashAvailable - totalPayments;
    
    // TDCR: Cash available / Total debt payments
    const tdcr = totalPayments > 0 ? cashAvailable / totalPayments : null;
    
    return {
      dealValue,
      downPayment,
      sellerNote,
      sbaLoan,
      sellerNotePayment,
      sbaLoanPayment,
      totalPayments,
      adjustedEbitda,
      ownerManager,
      cashAvailable,
      margin,
      tdcr,
      reOn, reValue, reDown, reLoan, reLoanPayment, reRentBack,
      packageValue: dealValue + reValue,
      maintCapex: Number(multipleEngineCalcs.maintCapexInValue) || 0,
    };
  }, [multipleEngineCalcs, sbaParams, ownerCompensation]);

  const formatPercent = (num) => `${num.toFixed(1)}%`;
  
  // ========== PDF GENERATION (Download HTML) ==========
  const generateFinancialPDF = () => {
    // Calculate all values
    const periodKey = valuationInputs.weightingMethod === 'lastYear' ? 'year5' : 'ttm';
    const basisKey = selectedValuationBasis === 'tax' ? 'cash' : selectedValuationBasis;
    const rev3 = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0);
    const rev4 = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0);
    const rev5 = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0);
    const revTtm = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0);
    const cogs3 = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0);
    const cogs4 = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0);
    const cogs5 = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0);
    const cogsTtm = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0);
    const opex3 = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0);
    const opex4 = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0);
    const opex5 = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0);
    const opexTtm = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0);
    const gp3 = rev3 - cogs3, gp4 = rev4 - cogs4, gp5 = rev5 - cogs5, gpTtm = revTtm - cogsTtm;
    const ni3 = gp3 - opex3, ni4 = gp4 - opex4, ni5 = gp5 - opex5, niTtm = gpTtm - opexTtm;
    const diat3 = (diatCategories.interest?.[basisKey]?.year3 || 0) + (diatCategories.taxes?.[basisKey]?.year3 || 0) + (diatCategories.depreciation?.[basisKey]?.year3 || 0) + (diatCategories.amortization?.[basisKey]?.year3 || 0);
    const diat4 = (diatCategories.interest?.[basisKey]?.year4 || 0) + (diatCategories.taxes?.[basisKey]?.year4 || 0) + (diatCategories.depreciation?.[basisKey]?.year4 || 0) + (diatCategories.amortization?.[basisKey]?.year4 || 0);
    const diat5 = (diatCategories.interest?.[basisKey]?.year5 || 0) + (diatCategories.taxes?.[basisKey]?.year5 || 0) + (diatCategories.depreciation?.[basisKey]?.year5 || 0) + (diatCategories.amortization?.[basisKey]?.year5 || 0);
    const diatTtm = (diatCategories.interest?.[basisKey]?.ttm || 0) + (diatCategories.taxes?.[basisKey]?.ttm || 0) + (diatCategories.depreciation?.[basisKey]?.ttm || 0) + (diatCategories.amortization?.[basisKey]?.ttm || 0);
    const ebitda3 = ni3 + diat3, ebitda4 = ni4 + diat4, ebitda5 = ni5 + diat5, ebitdaTtm = niTtm + diatTtm;
    const totalAdj = adjustmentItems.reduce((sum, adj) => sum + (adj.amount || 0), 0);
    const normEbitdaTtm = ebitdaTtm + totalAdj;
    const interest = diatCategories.interest?.[basisKey]?.[periodKey] || 0;
    const taxes = diatCategories.taxes?.[basisKey]?.[periodKey] || 0;
    const depreciation = diatCategories.depreciation?.[basisKey]?.[periodKey] || 0;
    const amortization = diatCategories.amortization?.[basisKey]?.[periodKey] || 0;
    const valPeriodEbitda = niTtm + interest + taxes + depreciation + amortization;
    const basisLabel = selectedValuationBasis === 'cash' ? 'Cash' : selectedValuationBasis === 'accrual' ? 'Accrual' : 'Tax Return';
    const periodLabel = valuationInputs.weightingMethod === 'ttm' ? 'Trailing Twelve Months' : valuationInputs.weightingMethod === 'lastYear' ? (basisYearLabels.year5 || 'Year 5') : valuationInputs.weightingMethod === 'average' ? 'Multi-Year Average' : 'Weighted Average';
    const validAdj = adjustmentItems.filter(a => a.description && a.amount);
    const calcs = calculations; // Reference to calculated data
    const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
    const pct = (n, d) => d ? ((n/d)*100).toFixed(1) + '%' : '0.0%';
    
    // Tab name mapping for filename and title
    const tabDisplayNames = {
      'financials': 'Financial Review',
      'drivers': 'Valuation Drivers',
      'result': 'Valuation Result',
      'simulator': 'Value Enhancement Plan',
      'sba': 'SBA Analysis'
    };
    const tabFileNames = {
      'financials': 'Financial_Summary',
      'drivers': 'Valuation_Drivers',
      'result': 'Valuation_Result',
      'simulator': 'Value_Enhancement',
      'sba': 'SBA_Analysis'
    };
    const currentTabDisplay = tabDisplayNames[reviewSection] || 'Financial Review';
    const currentTabFile = tabFileNames[reviewSection] || 'Financial_Summary';
    
    const html = `<!DOCTYPE html>
<html>
<head>
  <title>${currentTabDisplay} - ${dealProfile.companyName || 'Business'}</title>
  <style>
    @media print { @page { margin: 0.5in; size: letter; } }
    body { font-family: Arial, sans-serif; font-size: 11px; color: #333; max-width: 8in; margin: 0 auto; padding: 20px; }
    h1 { text-align: center; font-size: 18px; margin-bottom: 5px; }
    h2 { font-size: 14px; margin-top: 25px; margin-bottom: 10px; border-bottom: 1px solid #ccc; padding-bottom: 5px; }
    .subtitle { text-align: center; color: #666; font-size: 10px; margin-bottom: 15px; }
    .basis-box { background: #EBF4FF; border: 1px solid #93C5FD; border-radius: 5px; padding: 8px; text-align: center; margin-bottom: 20px; }
    .basis-box strong { color: #1E3A8A; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
    th, td { border: 1px solid #ddd; padding: 6px 8px; text-align: right; }
    th { background: #f5f5f5; font-weight: bold; }
    td:first-child, th:first-child { text-align: left; }
    .row-gp { background: #FFFBEB; font-weight: 600; }
    .row-ni { background: #DBEAFE; font-weight: 600; }
    .row-ebitda { background: #FFEDD5; font-weight: 600; }
    .row-adj { background: #F3E8FF; color: #7E22CE; }
    .row-norm { background: #DCFCE7; font-weight: bold; color: #166534; }
    .row-margin { font-size: 10px; color: #666; font-style: italic; }
    .row-margin td:first-child { padding-left: 15px; }
    .red { color: #B91C1C; }
    .bridge { background: #fff; border: 1px solid #ddd; border-radius: 5px; padding: 15px; margin-bottom: 15px; }
    .bridge-row { display: flex; justify-content: space-between; padding: 4px 10px; }
    .bridge-row.header { background: #DBEAFE; border-radius: 3px; font-weight: 600; margin-bottom: 5px; }
    .bridge-row.ebitda { background: #FFEDD5; border-radius: 3px; font-weight: 600; margin: 8px 0; }
    .bridge-row.norm { background: #DCFCE7; border-radius: 3px; font-weight: bold; color: #166534; padding: 8px 10px; margin-top: 8px; }
    .bridge-row.indent { padding-left: 25px; color: #555; }
    .bridge-row.adj { color: #7E22CE; padding-left: 25px; }
    .bridge-section { font-size: 10px; color: #666; margin: 10px 0 5px 10px; }
    .footer { margin-top: 20px; padding-top: 10px; border-top: 1px solid #ddd; font-size: 9px; color: #999; display: flex; justify-content: space-between; }
    .adj-table th { background: #F3E8FF; color: #7E22CE; }
    .print-btn { background: #2563EB; color: white; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer; font-size: 14px; margin-bottom: 20px; }
    .print-btn:hover { background: #1D4ED8; }
    @media print { .no-print { display: none; } }
  </style>
</head>
<body>
  <div class="no-print" style="text-align:center;margin-bottom:20px;">
    <button class="print-btn" onclick="window.print()">🖨️ Print / Save as PDF</button>
    <p style="font-size:11px;color:#666;">Click above or use Ctrl+P (Cmd+P on Mac) to print or save as PDF</p>
  </div>
  
  <h1>${currentTabDisplay.toUpperCase()}</h1>
  <div class="subtitle">${dealProfile.companyName || 'Business Name'} - Confidential<br/>Prepared: ${new Date().toLocaleDateString()}</div>
  
  <div class="basis-box">
    <strong>Valuation Basis:</strong> ${basisLabel} &nbsp;|&nbsp; <strong>Period:</strong> ${periodLabel}
  </div>
  
  <h2>Historical P&L Summary</h2>
  <table>
    <tr><th>Line Item</th><th>${displayYearLabels.year3 || 'Year 3'}</th><th>${displayYearLabels.year4 || 'Year 4'}</th><th>${displayYearLabels.year5 || 'Year 5'}</th><th>${ttmLabel}</th></tr>
    <tr><td>Revenue</td><td>${fmt(rev3)}</td><td>${fmt(rev4)}</td><td>${fmt(rev5)}</td><td>${fmt(revTtm)}</td></tr>
    <tr><td class="red">COGS</td><td class="red">(${fmt(cogs3)})</td><td class="red">(${fmt(cogs4)})</td><td class="red">(${fmt(cogs5)})</td><td class="red">(${fmt(cogsTtm)})</td></tr>
    <tr class="row-gp"><td>Gross Profit</td><td>${fmt(gp3)}</td><td>${fmt(gp4)}</td><td>${fmt(gp5)}</td><td>${fmt(gpTtm)}</td></tr>
    <tr class="row-margin"><td>Gross Margin %</td><td>${pct(gp3,rev3)}</td><td>${pct(gp4,rev4)}</td><td>${pct(gp5,rev5)}</td><td>${pct(gpTtm,revTtm)}</td></tr>
    <tr><td class="red">Operating Expenses</td><td class="red">(${fmt(opex3)})</td><td class="red">(${fmt(opex4)})</td><td class="red">(${fmt(opex5)})</td><td class="red">(${fmt(opexTtm)})</td></tr>
    <tr class="row-ni"><td>Net Income</td><td>${fmt(ni3)}</td><td>${fmt(ni4)}</td><td>${fmt(ni5)}</td><td>${fmt(niTtm)}</td></tr>
    <tr class="row-margin"><td>Net Margin %</td><td>${pct(ni3,rev3)}</td><td>${pct(ni4,rev4)}</td><td>${pct(ni5,rev5)}</td><td>${pct(niTtm,revTtm)}</td></tr>
    <tr><td>+ Interest, Taxes, D&A</td><td>${fmt(diat3)}</td><td>${fmt(diat4)}</td><td>${fmt(diat5)}</td><td>${fmt(diatTtm)}</td></tr>
    <tr class="row-ebitda"><td>EBITDA</td><td>${fmt(ebitda3)}</td><td>${fmt(ebitda4)}</td><td>${fmt(ebitda5)}</td><td>${fmt(ebitdaTtm)}</td></tr>
    <tr class="row-margin"><td>EBITDA Margin %</td><td>${pct(ebitda3,rev3)}</td><td>${pct(ebitda4,rev4)}</td><td>${pct(ebitda5,rev5)}</td><td>${pct(ebitdaTtm,revTtm)}</td></tr>
    <tr class="row-adj"><td>+ Normalizing Adjustments</td><td>${fmt(calcs.years[2].adjustedEbitda - calcs.years[2].ebitda)}</td><td>${fmt(calcs.years[3].adjustedEbitda - calcs.years[3].ebitda)}</td><td>${fmt(calcs.years[4].adjustedEbitda - calcs.years[4].ebitda)}</td><td>${fmt(calcs.years[5].adjustedEbitda - calcs.years[5].ebitda)}</td></tr>
    <tr class="row-margin"><td>Adjustments as % of Revenue</td><td>${pct(calcs.years[2].adjustedEbitda - calcs.years[2].ebitda, rev3)}</td><td>${pct(calcs.years[3].adjustedEbitda - calcs.years[3].ebitda, rev4)}</td><td>${pct(calcs.years[4].adjustedEbitda - calcs.years[4].ebitda, rev5)}</td><td>${pct(calcs.years[5].adjustedEbitda - calcs.years[5].ebitda, revTtm)}</td></tr>
    <tr class="row-norm"><td>Normalized EBITDA</td><td>${fmt(calcs.years[2].adjustedEbitda)}</td><td>${fmt(calcs.years[3].adjustedEbitda)}</td><td>${fmt(calcs.years[4].adjustedEbitda)}</td><td>${fmt(calcs.years[5].adjustedEbitda)}</td></tr>
    <tr class="row-margin"><td style="color:#166534">Normalized EBITDA Margin %</td><td>${calcs.years[2].adjustedEbitdaMargin?.toFixed(1) || 0}%</td><td>${calcs.years[3].adjustedEbitdaMargin?.toFixed(1) || 0}%</td><td>${calcs.years[4].adjustedEbitdaMargin?.toFixed(1) || 0}%</td><td style="color:#166534">${calcs.years[5].adjustedEbitdaMargin?.toFixed(1) || 0}%</td></tr>
  </table>
  
  <h2>Normalizing Adjustments Review</h2>
  <p style="font-size:10px;color:#666;margin-bottom:10px;">${basisLabel} Basis, ${periodLabel}</p>
  
  <div class="bridge">
    <div class="bridge-row header"><span>EBITDA (TTM)</span><span>${fmt(calcs.years[5].ebitda)}</span></div>
    ${validAdj.filter(a => a.included).length > 0 ? `
    <div class="bridge-section" style="color:#7E22CE">Normalizing Adjustments:</div>
    ${validAdj.filter(a => a.included).map(a => `<div class="bridge-row adj"><span>${a.type === 'add' || a.type === 'deduct' ? '+' : '-'} ${a.description}</span><span>${fmt(a.amount)}</span></div>`).join('')}
    ` : '<div class="bridge-section" style="font-style:italic">No adjustments entered</div>'}
    <div class="bridge-row norm"><span>= Normalized EBITDA</span><span>${fmt(calcs.years[5].adjustedEbitda)} <small>(${calcs.years[5].adjustedEbitdaMargin?.toFixed(1) || 0}% margin)</small></span></div>
  </div>
  
  <div style="font-size:10px;color:#666;border-top:1px solid #ddd;padding-top:8px;display:flex;justify-content:space-between;">
    <span><strong>Total Normalizing Adjustments:</strong> ${fmt(calcs.years[5].adjustedEbitda - calcs.years[5].ebitda)}</span>
    <span><strong>Adjustments as % of Revenue:</strong> ${pct(calcs.years[5].adjustedEbitda - calcs.years[5].ebitda, revTtm)}</span>
  </div>
  
  ${validAdj.length > 0 ? `
  <h2>Adjustment Details</h2>
  <table class="adj-table">
    <tr><th>Description</th><th>Period</th><th>Status</th><th>Amount</th></tr>
    ${validAdj.map(a => `<tr style="${!a.included ? 'color:#999;text-decoration:line-through;' : ''}"><td>${a.description || '-'}</td><td>${a.year || 'TTM'}</td><td>${a.included ? '✓ Included' : '✕ Excluded'}</td><td style="color:${a.included ? '#7E22CE' : '#999'}">${a.type === 'add' || a.type === 'deduct' ? '+' : '-'}${fmt(a.amount)}</td></tr>`).join('')}
    <tr style="background:#F3E8FF;font-weight:bold"><td>Total Included</td><td></td><td></td><td style="color:#7E22CE">${fmt(calcs.years[5].adjustedEbitda - calcs.years[5].ebitda)}</td></tr>
  </table>
  ` : ''}
  
  <div class="footer">
    <span>Confidential</span>
    <span>${dealProfile.companyName || 'Business'} - ${currentTabDisplay}</span>
    <span>${new Date().toLocaleDateString()}</span>
  </div>
</body>
</html>`;
    
    // Download as HTML file
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${dealProfile.companyName || 'Business'}_${currentTabFile}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // ========== STRUCTURED EXPORT DATA ==========
  const getExportData = () => {
    const basisKey = selectedValuationBasis === 'tax' ? 'cash' : selectedValuationBasis;
    const basisLabel = selectedValuationBasis === 'cash' ? 'Cash' : selectedValuationBasis === 'accrual' ? 'Accrual' : 'Tax Return';
    
    // Revenue data by year
    const revenueByYear = {
      year3: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0),
      year4: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0),
      year5: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0),
      ttm: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0)
    };
    
    // COGS by year
    const cogsByYear = {
      year3: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0),
      year4: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0),
      year5: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0),
      ttm: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0)
    };
    
    // OpEx by year
    const opexByYear = {
      year3: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0),
      year4: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0),
      year5: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0),
      ttm: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0)
    };
    
    // Gross Profit
    const gpByYear = {
      year3: revenueByYear.year3 - cogsByYear.year3,
      year4: revenueByYear.year4 - cogsByYear.year4,
      year5: revenueByYear.year5 - cogsByYear.year5,
      ttm: revenueByYear.ttm - cogsByYear.ttm
    };
    
    // Other Income by year
    const oiByYear = {
      year3: otherIncomeAnalysis?.totals?.year3 || 0,
      year4: otherIncomeAnalysis?.totals?.year4 || 0,
      year5: otherIncomeAnalysis?.totals?.year5 || 0,
      ttm: otherIncomeAnalysis?.totals?.ttm || 0
    };
    
    // Other Expense by year
    const oeByYear = {
      year3: otherExpenseAnalysis?.totals?.year3 || 0,
      year4: otherExpenseAnalysis?.totals?.year4 || 0,
      year5: otherExpenseAnalysis?.totals?.year5 || 0,
      ttm: otherExpenseAnalysis?.totals?.ttm || 0
    };
    
    // Net Income = Gross Profit - OpEx + Other Income - Other Expense
    const niByYear = {
      year3: gpByYear.year3 - opexByYear.year3 + oiByYear.year3 - oeByYear.year3,
      year4: gpByYear.year4 - opexByYear.year4 + oiByYear.year4 - oeByYear.year4,
      year5: gpByYear.year5 - opexByYear.year5 + oiByYear.year5 - oeByYear.year5,
      ttm: gpByYear.ttm - opexByYear.ttm + oiByYear.ttm - oeByYear.ttm
    };
    
    // DIAT by year - includes BOTH dedicated D/I/A/T fields AND line-based adjustments with D/I/A/T categories
    const getDiat = (year) => {
      // From dedicated D/I/A/T category fields
      const fromDiatCategories = (diatCategories.interest?.[basisKey]?.[year] || 0) + 
             (diatCategories.taxes?.[basisKey]?.[year] || 0) + 
             (diatCategories.depreciation?.[basisKey]?.[year] || 0) + 
             (diatCategories.amortization?.[basisKey]?.[year] || 0);
      
      // From line-based expense adjustments with D/I/A/T categories (OpEx)
      const fromLineBasedOpex = opexCategories.reduce((sum, cat) => {
        if (!cat.addbackPct || cat.addbackPct <= 0) return sum;
        if (!['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory)) return sum;
        if (cat.adjIncluded === false) return sum;
        const lineValue = cat[selectedValuationBasis]?.[year] || 0;
        return sum + (lineValue * cat.addbackPct / 100);
      }, 0);
      
      // From line-based expense adjustments with D/I/A/T categories (Other Expense)
      const fromLineBasedOtherExp = otherExpenseCategories.reduce((sum, cat) => {
        if (!cat.addbackPct || cat.addbackPct <= 0) return sum;
        if (!['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory)) return sum;
        if (cat.adjIncluded === false) return sum;
        const lineValue = cat[selectedValuationBasis]?.[year] || 0;
        return sum + (lineValue * cat.addbackPct / 100);
      }, 0);
      
      // Manual D/I/A/T adjustments (depreciation inside COGS…) — the engine's period rule (basisYearLabels / 'TTM').
      const fromManual = manualDiatSum(adjustmentItems, null, a => a.year === 'All Years' || (year === 'ttm' ? a.year === 'TTM' : a.year === basisYearLabels[year]));
      return fromDiatCategories + fromLineBasedOpex + fromLineBasedOtherExp + fromManual;
    };

    const diatByYear = {
      year3: getDiat('year3'),
      year4: getDiat('year4'),
      year5: getDiat('year5'),
      ttm: getDiat('ttm')
    };
    
    // EBITDA
    const ebitdaByYear = {
      year3: niByYear.year3 + diatByYear.year3,
      year4: niByYear.year4 + diatByYear.year4,
      year5: niByYear.year5 + diatByYear.year5,
      ttm: niByYear.ttm + diatByYear.ttm
    };
    
    // Location type label
    const locationTypeLabels = {
      'major_metro': 'Major Metro',
      'secondary_city': 'Secondary City',
      'suburban': 'Suburban',
      'rural': 'Rural'
    };
    
    return {
      company: {
        name: dealProfile.companyName || 'Business',
        industry: industryBenchmarks.find(i => i.id === selectedIndustry)?.name || 'N/A',
        location: `${dealProfile.city || ''}, ${dealProfile.state || ''}`.trim() || 'N/A',
        locationType: locationTypeLabels[dealProfile.locationType] || dealProfile.locationType || 'Not specified',
        preparedDate: (() => {
          const endMonth = monthlyTtmConfig.endMonth;
          const endYear = monthlyTtmConfig.endYear;
          const lastDay = new Date(endYear, endMonth + 1, 0).getDate();
          return new Date(endYear, endMonth, lastDay).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        })()
      },
      basis: {
        label: basisLabel,
        key: selectedValuationBasis
      },
      yearLabels: basisYearLabels,
      ttmLabel: ttmLabel,
      financials: {
        revenue: revenueByYear,
        cogs: cogsByYear,
        grossProfit: gpByYear,
        opex: opexByYear,
        netIncome: niByYear,
        diat: diatByYear,
        ebitda: ebitdaByYear
      },
      calculations: calculations,
      adjustments: adjustmentItems.filter(a => a.included),
      adjustmentItems: adjustmentItems,
      totalAdjustments: adjustmentItems.reduce((sum, adj) => sum + (adj.included ? (adj.amount || 0) : 0), 0),
      normalizedEbitda: multipleEngineCalcs.adjustedEbitda,
      // 💵 FCF bridge for the exported reports (10-20, Aeroform: "we'll have a report that reflects both")
      maintCapex: Number(multipleEngineCalcs.maintCapexInValue) || 0,
      ebitdaBeforeCapex: Number(multipleEngineCalcs.ebitdaBeforeCapex) || multipleEngineCalcs.adjustedEbitda,
      tierEbitda: Number(multipleEngineCalcs.tierEbitda) || multipleEngineCalcs.adjustedEbitda,
      catchUpCapex: Number(multipleEngineCalcs.catchUpCapex) || 0,
      catchUpNote: (capexCatchUp && capexCatchUp.note) || '',
      valuation: {
        rawBaseMultiple: multipleEngineCalcs.rawBaseMultiple,
        baseMultiple: multipleEngineCalcs.rawBaseMultiple,
        industryAdjustment: industryMultipleAdjustment,
        locationAdjustment: multipleEngineCalcs.scaledLocationAdj || 0,
        marketAdjustment: marketCondition?.adjustment || 0,
        effectiveBase: multipleEngineCalcs.baseMultiple,
        factors: multipleEngineCalcs.factors,
        totalFactorAdjustment: multipleEngineCalcs.totalAdjustment,
        adjustedMultiple: multipleEngineCalcs.adjustedMultiple,
        finalMultiple: multipleEngineCalcs.adjustedMultiple,
        typicalMultiple: multipleEngineCalcs.typicalMultiple,
        marketHighMultiple: multipleEngineCalcs.marketHighMultiple,
        valuationLow: multipleEngineCalcs.valuationTypical,
        valuationHigh: multipleEngineCalcs.valuationMarketHigh
      },
      keyMetrics: keyMetrics,
      accuracy: accuracyGauge,
      sba: sbaAnalysis,
      sbaParams: sbaParams,
      ownerCompensation: ownerCompensation,
      enhancement: {
        ebitdaChange: simEbitdaChange,
        marginImprovement: simMarginImprovement,
        recurringTarget: simRecurringPct,
        growthTarget: simRevenueGrowth,
        retentionTarget: simRetentionRate,
        concentrationTarget: simTopCustomerPct,
        clientCountTarget: simClientCount,
        contractImprovements: simContractImprovements
      },
      // Deal structure for deal composition bar
      dealStructure: dealStructure,
      // Valuation inputs (weighting method, etc.)
      valuationInputs: valuationInputs,
      // Full calculations object for EBITDA breakdown
      calculations: calculations,
      // Sales/Customer data for sales reports
      sales: {
        customerSalesData,
        customerYearLabels,
        selectedIndustry,
        industryBenchmarks
      },
      // For Owner Questions report
      researchItems: researchItems,
      sellerQA: sellerQA,
      // Line-based addbacks from OpEx, Other Expense, AND Other Income.
      // Other Income values are NEGATED — these are non-operating income
      // items being removed from EBITDA, so they reduce the bridge total.
      // Without this, the breakdown overstates EBITDA by the sum of
      // otherIncome line addbacks (the engine's `otherIncomeLineDeductions`).
      lineBasedAdjustments: [
        ...opexCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false).map(cat => ({
          name: cat.name,
          source: 'OpEx',
          addbackPct: cat.addbackPct,
          category: cat.adjCategory || 'Other',
          description: cat.adjDescription || '',
          year3: (cat[selectedValuationBasis]?.year3 || 0) * ((cat.addbackPct || 0) / 100),
          year4: (cat[selectedValuationBasis]?.year4 || 0) * ((cat.addbackPct || 0) / 100),
          year5: (cat[selectedValuationBasis]?.year5 || 0) * ((cat.addbackPct || 0) / 100),
          ttm: (cat[selectedValuationBasis]?.ttm || 0) * ((cat.addbackPct || 0) / 100)
        })),
        ...otherExpenseCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false).map(cat => ({
          name: cat.name,
          source: 'Other Expense',
          addbackPct: cat.addbackPct,
          category: cat.adjCategory || 'Other',
          description: cat.adjDescription || '',
          year3: (cat[selectedValuationBasis]?.year3 || 0) * ((cat.addbackPct || 0) / 100),
          year4: (cat[selectedValuationBasis]?.year4 || 0) * ((cat.addbackPct || 0) / 100),
          year5: (cat[selectedValuationBasis]?.year5 || 0) * ((cat.addbackPct || 0) / 100),
          ttm: (cat[selectedValuationBasis]?.ttm || 0) * ((cat.addbackPct || 0) / 100)
        })),
        ...otherIncomeCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false).map(cat => ({
          name: cat.name,
          source: 'Other Income',
          addbackPct: cat.addbackPct,
          category: cat.adjCategory || 'Other',
          description: cat.adjDescription || '',
          year3: -((cat[selectedValuationBasis]?.year3 || 0) * ((cat.addbackPct || 0) / 100)),
          year4: -((cat[selectedValuationBasis]?.year4 || 0) * ((cat.addbackPct || 0) / 100)),
          year5: -((cat[selectedValuationBasis]?.year5 || 0) * ((cat.addbackPct || 0) / 100)),
          ttm:   -((cat[selectedValuationBasis]?.ttm   || 0) * ((cat.addbackPct || 0) / 100))
        }))
      ],
      // Individual D/I/A/T breakdown for presentation
      diatBreakdown: {
        depreciation: { year3: activeDiatCategories.depreciation.year3 || 0, year4: activeDiatCategories.depreciation.year4 || 0, year5: activeDiatCategories.depreciation.year5 || 0, ttm: activeDiatCategories.depreciation.ttm || 0 },
        interest: { year3: activeDiatCategories.interest.year3 || 0, year4: activeDiatCategories.interest.year4 || 0, year5: activeDiatCategories.interest.year5 || 0, ttm: activeDiatCategories.interest.ttm || 0 },
        amortization: { year3: activeDiatCategories.amortization.year3 || 0, year4: activeDiatCategories.amortization.year4 || 0, year5: activeDiatCategories.amortization.year5 || 0, ttm: activeDiatCategories.amortization.ttm || 0 },
        taxes: { year3: activeDiatCategories.taxes.year3 || 0, year4: activeDiatCategories.taxes.year4 || 0, year5: activeDiatCategories.taxes.year5 || 0, ttm: activeDiatCategories.taxes.ttm || 0 }
      }
    };
  };

  // ========== REPORT HTML GENERATORS ==========
  const generateReportStyles = () => `
    @media print { 
      @page { margin: 0.5in; size: letter; } 
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } 
      .no-print { display: none !important; }
      .section-header { page-break-after: avoid; }
      .metric-box, .step-box, .keep-together { page-break-inside: avoid; }
      table { page-break-inside: avoid; }
      tr { page-break-inside: avoid; }
      h2, h3, h4 { page-break-after: avoid; }
      .page-break { page-break-before: always; }
    }
    * { box-sizing: border-box; }
    body { 
      font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif; 
      font-size: 11px; 
      color: #374151; 
      max-width: 8in; 
      margin: 0 auto; 
      padding: 30px; 
      line-height: 1.5;
      background: #fff;
    }
    
    /* Vista branded header */
    .report-header { 
      display: flex; 
      justify-content: space-between; 
      align-items: flex-start; 
      margin-bottom: 25px; 
      padding-bottom: 20px; 
      border-bottom: 3px solid #3d5c35;
    }
    .logo-section { display: flex; align-items: center; gap: 15px; }
    .logo { height: 70px; width: auto; }
    .company-info h1 { font-size: 20px; color: #3d5c35; font-weight: 700; margin: 0 0 3px 0; }
    .company-info .tagline { font-size: 10px; color: #8b7355; font-style: italic; }
    .report-meta { text-align: right; }
    .report-meta .report-title { font-size: 15px; font-weight: 600; color: #3d5c35; margin-bottom: 5px; }
    .report-meta .client-name { font-size: 13px; color: #374151; margin-bottom: 3px; font-weight: 500; }
    .report-meta .date { font-size: 10px; color: #6b7280; }
    
    /* Section headers */
    .section-header {
      background: linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);
      color: white;
      padding: 12px 18px;
      border-radius: 6px 6px 0 0;
      font-size: 13px;
      font-weight: 600;
      margin-top: 25px;
    }
    .section-content {
      background: #f8faf7;
      border: 1px solid #d1d9cf;
      border-top: none;
      border-radius: 0 0 6px 6px;
      padding: 18px;
      margin-bottom: 20px;
    }
    .section-intro {
      font-size: 11px;
      color: #4b5563;
      margin-bottom: 15px;
      line-height: 1.6;
      background: #fff;
      padding: 12px;
      border-radius: 4px;
      border-left: 3px solid #3d5c35;
    }
    
    h2 { font-size: 14px; margin-top: 20px; margin-bottom: 10px; border-bottom: 2px solid #3d5c35; padding-bottom: 5px; color: #3d5c35; }
    h3 { font-size: 12px; margin-top: 15px; margin-bottom: 8px; color: #374151; }
    .subtitle { text-align: center; color: #666; font-size: 10px; margin-bottom: 20px; }
    .page-break { page-break-before: always; }
    
    /* Tables */
    table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
    th, td { border: 1px solid #d1d9cf; padding: 8px 10px; text-align: right; }
    th { background: linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%); color: white; font-weight: 600; }
    td:first-child, th:first-child { text-align: left; }
    .highlight-row { background: #e8ede6; font-weight: 600; }
    .total-row { background: #d4e0d1; font-weight: bold; }
    .negative { color: #dc2626; }
    .positive { color: #166534; }
    
    /* Metric boxes */
    .metric-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; margin-bottom: 15px; }
    .metric-box { background: #fff; border: 1px solid #d1d9cf; border-radius: 6px; padding: 12px; text-align: center; }
    .metric-label { font-size: 9px; color: #6b7280; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.3px; }
    .metric-value { font-size: 15px; font-weight: 700; color: #3d5c35; }
    
    /* Step boxes for multiple calculation */
    .step-box { 
      background: #fff; 
      border: 1px solid #d1d9cf; 
      border-radius: 6px; 
      padding: 15px; 
      margin-bottom: 12px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    }
    .step-header { display: flex; justify-content: space-between; align-items: center; }
    .step-number { 
      background: #3d5c35; 
      color: white; 
      width: 24px; 
      height: 24px; 
      border-radius: 50%; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      font-size: 12px; 
      font-weight: 600;
      margin-right: 10px;
    }
    .step-title { font-weight: 600; color: #3d5c35; font-size: 12px; }
    .step-value { font-size: 18px; font-weight: 700; color: #3d5c35; }
    .step-detail { font-size: 10px; color: #6b7280; margin-top: 8px; }
    
    /* Highlight boxes */
    .highlight-box {
      background: linear-gradient(135deg, #f0f4ef 0%, #e8ede6 100%);
      border: 2px solid #3d5c35;
      border-radius: 8px;
      padding: 20px;
      text-align: center;
      margin: 15px 0;
    }
    .highlight-label { font-size: 11px; color: #3d5c35; margin-bottom: 5px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
    .highlight-value { font-size: 28px; font-weight: 700; color: #3d5c35; }
    .highlight-subtext { font-size: 10px; color: #6b7280; margin-top: 5px; }
    
    .final-box { background: linear-gradient(135deg, #f0f4ef 0%, #e8ede6 100%); border: 2px solid #3d5c35; border-radius: 8px; padding: 15px; text-align: center; margin: 15px 0; }
    .final-label { font-size: 12px; color: #3d5c35; margin-bottom: 5px; font-weight: 600; }
    .final-value { font-size: 24px; font-weight: bold; color: #3d5c35; }
    
    /* Footer */
    .report-footer { 
      margin-top: 30px; 
      padding-top: 15px; 
      border-top: 2px solid #3d5c35; 
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .footer-logo { height: 40px; }
    .footer-text { font-size: 9px; color: #6b7280; text-align: right; }
    .footer-confidential { font-weight: 600; color: #3d5c35; }
    
    .print-btn { background: #3d5c35; color: white; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer; font-size: 14px; }
    .print-btn:hover { background: #4a6b42; }
    
    .checklist-item { display: flex; align-items: center; gap: 8px; padding: 5px 0; }
    .check-yes { color: #166534; font-weight: bold; }
    .check-no { color: #9ca3af; }
    
    /* Next steps section */
    .next-steps {
      background: linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);
      color: white;
      border-radius: 8px;
      padding: 20px;
      margin-top: 25px;
    }
    .next-steps h3 { color: white; margin: 0 0 12px 0; font-size: 14px; }
    .next-steps-list { list-style: none; padding: 0; margin: 0; }
    .next-steps-list li { padding: 8px 0; border-bottom: 1px solid rgba(255,255,255,0.2); display: flex; align-items: center; gap: 10px; }
    .next-steps-list li:last-child { border-bottom: none; }
    .step-icon { background: rgba(255,255,255,0.2); width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 11px; }
  `;

  const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);
  const pct = (n) => (n || 0).toFixed(1) + '%';

  // ========== CLIENT STATUS REPORT (for email) ==========
  // Vista Business Group Logo (base64 JPEG)
  const vistaLogoBase64 = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4UTKRXhpZgAATU0AKgAAAAgACwALAAIAAAAmAAAIngESAAMAAAABAAEAAAExAAIAAAAmAAAIxAEyAAIAAAAUAAAI6gMBAAUAAAABAAAI/gMDAAEAAAABAAAAAFEQAAEAAAABAQAAAFERAAQAAAABAAAXElESAAQAAAABAAAXEodpAAQAAAABAAAJBuocAAcAAAgMAAAAkgAAEYoc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFdpbmRvd3MgUGhvdG8gRWRpdG9yIDEwLjAuMTAwMTEuMTYzODQAV2luZG93cyBQaG90byBFZGl0b3IgMTAuMC4xMDAxMS4xNjM4NAAyMDE3OjAyOjA5IDE0OjQ2OjQxAAABhqAAALGPAAaQAwACAAAAFAAAEWCQBAACAAAAFAAAEXSSkQACAAAAAzAwAACSkgACAAAAAzAwAACgAQADAAAAAQABAADqHAAHAAAIDAAACVQAAAAAHOoAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAyMDEwOjA4OjE4IDA5OjU3OjE4ADIwMTA6MDg6MTggMDk6NTc6MTgAAAAABgEDAAMAAAABAAYAAAEaAAUAAAABAAAR2AEbAAUAAAABAAAR4AEoAAMAAAABAAIAAAIBAAQAAAABAAAR6AICAAQAAAABAAAy2gAAAAAAAABgAAAAAQAAAGAAAAAB/9j/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAEAAMsDASEAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+igAooAKKACigAooAKjmmit4JJpnWOKNSzuxwFA6k0AeC+Nvixf32rxxeHrh7eytJNwlXrOR3P8As+3fv7eneBPHdn4w07BKw6lCo8+DPX/aX1H8q5adbmm0zOM7s7Ciuo0CigAooAKKACigAooAKKACigAooAKKACigCOeeK1t5J55FiijUs7ucBQOpJrwTxp411Hx7q6eHvD0crWLPtCrw05H8R9FH/wBc1z152XKt2RN6WPSPBnw503w3o8kN3FFeXl0m25kdcjB/gX0H868y8ZeDtS+HutR67oUsgsd+Y3HJhP8Acb1B/WoqUuWCa3QpRsj1XwJ46tPGOnc7YdRhA8+DP/jy+x/SuvrohPnjcuLurhRVjCigAooAKKACigAooAKKACigAooAKiuLiG1t5J7iRYoY1LO7nAUDuaTA8E8ZeNNS8f6wnh/w/HKbFn2qq8Gc/wB5vRR1/U16f4E8B2fg/T9zbZtSlX9/Pjp/sr7fzrmp/vJubM46u5va/r1j4b0iXUtQcrBHgYUZZiegA9adBPp3iPRVlj8u6sLuPoRkMp7EV0XTfKX5HhfjDwfqfw81uPXdCllFiHzHIvJhJ/gb1H869X8C+OrLxhp38MOoxD9/b5/8eX1H8q56XuTcGRHR2OuorqNAooAKKACigAooAKKACigAooAKKAIrm4htLaS4uJVihjUs7ucBQO5rwPxj4y1P4g6ymgeH4pDYl8KqjBmI/ib0UVz15WXKt2RN6WPTvBHgzTvBVjGsskT6ndfLJMxALHGdiewwfyrsiQBkkACtYRUY2RUVZWPm/wCKXjI+JddNlaSZ06zYrGVPEjd2/oPal+Gnj1/C2o/Yb5y2lXDfNn/li394e3rXF7T97zGPN71z6HlitNTsGilSO4tZ0wVIyrqa8C8X+ENU+HeuR65oksosd+Y5F5MR/uP7H9a6K8brmW6NJrS56z4G8c2fjHTQQVh1CIDz7fP/AI8vqtdbWsJc0blJ3VwoqxhRQAUUAFFABRQAUUAFFABUNzcwWdtJc3MqxQRKWd3OAoHeh6AeB+MPGOp/EPWY9A0CKU2JfCoODMR/G3oo9K9I8N+GtH+Gvhua/vpUNwE3XN0Ryf8AZX29B3rlp+/N1HsjNavmZ4v4q8e6n4h8Rx6lFK9tFavm0jVv9Xg9T6k967TxH8Wk1DwJDb2RMWq3amK5C/8ALIDqR/vdvbNZKu/e8yVPc8igne3uY548b43DrkZGQc816lrvw7i8QaBb+KPCsQ/fxCSawXnDfxbPof4fy9KinHnTXUmKuix8K/H76dcJ4b1qRlhLbLaSTgxt/cOe3p6dK9qurS3v7SS2uokmglXa6OMhhXXQlzQszWDujwHxd4R1T4c65HrehyyfYd+Y5ByYj/cf1H869Y8DeObPxjpuRth1CIDz7fPT/aX1U1FJ8k3Bijo7HW0V1GgUUAFFABRQAUUAFFABRQBDdXUFlay3VzKkUESlndzgKBXgXi7xhqnxF1uPQdBik+wl8Ig4MpH8b+iiuevKy5VuyJvoeo+EvCOl+ANCluJ5IzcbN91dvxwOw9AP1rx7xt4v1Dx/r0en6ZFK1msm22t0HMh/vMPX+QqKvuQUETLRcqGeKfhnqXhfw5aapNKJmY7bmONeICenPcds+v1rhq5qkHB2ZElbQkggkubiOCIBpJGCKCQMk9OTXt/wc1C906S98M6nbTW00Z8+FJlKnHRgM9s4P41dC6nccNzc8efDOz8To9/YbLXVlGd44Wb2b0PvVb4e+Lr0XB8KeJFeDV7YbYml6zKPfuQO/cc1025Kl+jNPhZ6FeWlvf2ktpdRLLBKpV0YcEV4B4s8J6r8N9dj1vRJZPsO/Mco58vP8D+o/nRXjpzLdBNdT1vwP44svGOm70IivogPPtyeQfUeoNdXWsJc0blJ3VwoqxhRQAUUAFFABRQAVBd3dvY2kt1dSpDBEpZ3c4Cik3YDwPxb4t1T4j67HoWhRSfYN/yIOPM/239AK9V8GeDNP8E6QxLI92ybrm6bjpyQPRRXNT9+bm9jOOrueZ+MfE+p/EXXU8OeHI3exR+SOBKR1dj2Udv8eK9J8D+AbDwfZh/luNSkX97cEdP9lfQfzoprnm5vYI6u5558SvFl34r1lfCvh9ZLiFH2yeTnMzjt/uj8u9anhL4K28SLdeJZPOkI4tImwq/7zDkn6frU8ntajb2Fbmlc4nx78O7zwjcm7td8+lO3yTfxRn0f09j3r2D4b+JI/FPhi3kuNr39l+6lLAFs44YfUf1p0o8lRxYR0lY7WsHxN4SsPE1vGZt0F7AQ9teRD95EwORj1Ge1dMo8ysaNXJNCvb/y/wCz9ZRV1GFeZE+5cL/fX+o7H8K1Lu0t7+0ltbqFJoJV2vG4yGFC1WodD5/8WeFNV+G+vxa1ossn2HfmKUc+X/sP7fzr1zwP43svGGlh02xX0QAuLfPKn1HqDXPSfJNwZEdHY6uiuo0CigAooAKKACigCC8vLawtJbu7mSGCJdzyOcBRXgXivxXq3xJ16PQ9DikFhv8Akj6eZj+N/QD9K568tOVbsib6HrPgnwRY+DtNCRhZb6QDz7gjlj6D0WuQ8U6zqXxA1d/C/hhsafE3+nXw+4fbPp/M+1ElywUI9QasrI7vwt4S03wlpotbGPMjczTt9+Q+59PauR+K3jv+wrBtF06XGo3K/vHU8wof5E/yqptU6dkN+7HQ8I07UbrStTt9QtJClxA4dG9/8DX1R4T8SW3inQINStyAzDbLHnlHHUVhhZauJFN9DXubaG7tpLe4iSWGRdro4yGHuK8uj8Mz/Dfxaur6duk8P3ZEV2hJJtgTwx/2QT17AnNdFSOqkuhcl1PVQwZQykEEZBFcRqvxL0rTPGdtoDkMjZS4uM8RSH7q/wCPpke9VOagrsbdjtiqPtYgHHIPpWN4n8U6b4T0z7bqDnDNtjiQZeQ+gpykoq7BuyuS2t1pPizQfMiMV5YXSYZSMg+oI7EV4d4q8K6t8Ndej1rRZZDYl/3co52Z/gf1B/WsKyvFTj0JmtOZHrvgjxvZeMNM3oVivogBPbk8qfUeqmuqraElKNyk7oKKsYUUAFFABUF5eW+n2kt3dzJDBEpZ3c4AFJuwHgPinxTq3xL8QR6JokUgsA/7uPON+P439v5fWvW/BXgmw8H6Z5cQEt7KAZ7gjlj6D0HtXNSXPNzZnHV3Kmu3F/4supdB0aU29gjbNQ1Bf1ij9W9T0FdJouiWHh/TY7DToBFCn5se5J7mtoq8uYpb3Mzxr4ttvCOhSXchV7p8pbw55dvX6Dqa8V8IeDdT+IWtzatqkki2TSl55yOZW/ur/j2rGt781BEy1djsfGHwZtZ4Td+Gv3E6r81q7kpJ/uk9D9ePpXE+BPEd54D8VtZapFLb2szCO6ikXBQ9n/D+VRKHspqS2E1yu59Io6yIroQysMgjuKHRZEZHUMrDDKwyCK7TU4H4i+NofB+jLp+nso1KZNsSg58lOm4/0r53eO5mje9ZXdC+Hl6/MeeTXBiJXlyroYzd3Y9p8A/FGyh8LTW+u3GLnT4/3ZJy06dgPVu36+teXeKfFF54u11r29k8uInbFH1WJM/5z60VKvNBIJSurGtoOva78NtaUSxM1nOA7w5zHMh6Mh6Z9x9DXv8Ap2paP4z8PmWEx3VlcIUkjYcqe6sOxrWhJ25JFQfRniXinwtq3w08QRazo8shsS+Ypeu3/pm/qP516/4K8bWPjDTBJERFexACe3J5U+o9QaKT5JuDCOjsdTRXUaBRQAUUAV729ttPs5ru7mWG3hUs7seAK8B8UeJ9X+JviCPRdFikFgH/AHcfQNj/AJaOew/l9a568nbkW7Im+h694L8FWPg/TPKhAlvJADPcEcufQegFbV/BcXifZopGhif/AFsqnDY/ur6Z9e3bnkaxjyx5UUlZWJ7S0t7C1jtrWJYoYxhUUcCo9S1G10nTp7+8lEdvAhd2Pp/jVaJD2PGdO0XU/ix4mbWtTEltoULbYUycsoP3V+vdv8j2qzs7fT7OK0tIUhgiUKiIMAAVjRi9ZvqRFdSeue8U+DdI8W2flahBiZRiK5j4kT8e49jWsoqSsymrop+DrTVvD8P9gaoftMMAP2K8RTh4x/C391h6dx0zg1e8X+KrTwlokl/cENKflghzzI/p9PU1KbjDXoK9lqfM11qFzrutnVdY86WKecCaQZwB6KegwOgrtbzwrqvw91AanFCNW8P3C7Z125DRns69iOzdM1wxTd5GSu9STxB8MotQ0tPEPg1zdWEy+YbQn50HcL6454PP1rh9Am0201fyNesjLZSHy5uqyQ/7S45yPT9KJwUZJ9GDST8j6D07wPplz4TXRrycappuN9nM4xJEp6YYenYjHpivObrQ/Enwl1g6nprNe6O7ASDnDL6SAfdPo3/6q6JwcUpx6FtW1R6zo+s6L478PM8QWe2mXZPbyD5kPcEf1/EV4x4o8L6t8M/EEWs6NNIbEv8Aupeu31jcdx/OiquaKqR6BLVcyPX/AAT41svGOl+bFiK8iAFxbk8qfUeoPrXU1vCXNFMtO6uFFWMKr319babZS3l5MkNvEu53c4AFJuwHgPiXxLrHxP8AEMejaNFItgr/ALuPoDj/AJaSf54+teveC/Bdh4P0wQwgSXkgBnuCOXPoPRR2Fc1Jc83NmcdXc6iiuo0EPTmvPL+yn+I+rrEWeLwvZScsODeyDrj/AGB0z9fwzqa+73Jeuh31tawWdtHbW0SRQxKFREGAoHYCpq0KKcGp29xqd3p6N+/tQhkHoGGRVykncCnqepWmj6dPf3soit4F3Mx/kPc15FB4Z1f4pa7/AG3rHmWOiKcW0P8AG6f7PpnqW/Ksaq5moES10PVIfDejw6J/Y6afB/Z+3BgK5B9z6n361ctbGG0sI7JAWgjQRgSHdlcYwc9a1UUirGXpfhuDQtQmk0o+TZ3J3S2n8Cv/AHk9M9x0+nfG8afDfSvFkb3CAWmp4+W4ReHPo47/AF61EqaceUTimrHOeBNU1XwZqi+EvEqGOGRj9guScox/uhvQ9u4PFerSRpLG0ciK6OCGVhkEehopN8vK90EdrHmureBL/wANaq3iHwU2yTrcaax+SVe4X/D8vSun0bW9J8c6JPbzQDdjyryxnHzxt3BH1HBqYrkfJ0Ylo7HjnibwxrHwy8Qxaxo8shsS/wC6mxnA7xv9f1+texeCvGtj4x0sTQkRXkYAuLcnlD6j1B9aik+SbgxR0djp6K6jQrX9/a6ZZS3l7MkNvEu53c4AFeA+I/Eus/E/xDHo+jxSLYBsxxZwCB1kk7f4fWuevLRQW7Im+h6/4N8H6d4O0sQQlJLuQA3FweC59vQe1cxq/jg2vxe0/TFuF+wpEYJRnje/Ofrwo/OnJqnFJA7RVjs/C3iODxNpkt7AAAk8kRUHOADxn6jB/Gtytou6uWtihqdk+pQ/Y2dktX/1+04Lr/cB7Z7n0471bhiit4UhhRY40UKiKMAAdhRbW4Gb4g1uLQNPju5VDB7iKEAnH32Az+AyfwrVBBGR0PNF9bCueQfD3xAdT+KniJjJuW6UsnPVUbCj8jXsFZ0XeIoPQxdR0CPWr+KTUz5tnbtuhtM/Iz/33H8XsOgrZUBQAAAB0Aq0rO5SQtFUAUUAUtT0qy1iya0v7dJoW5w3VT6g9QfcVNaW7W1skLTPNsGA7/eI7Zx3pW1uHUnrn9Y8Mx3l8mradL9h1iIYW4QfLIP7si/xL+o7UpRuhNXJ42i1yxn0zWLJUmZSs1u/zKw6bkPceh6j2NeH+J/DWsfDHxFHq+jyyGxL/uZeoGf+Wcn+efrWFZNpTW6Jmup7F4L8Z2PjDSxPCwju4wBcW5PKH19wexrp63hLmjdFJ3R558V/C+reIdEjl0y4kcWuXksh0l9x6sPT8vfxLwrpz6rrH9lHWTpLTfLufcFdh/CcEc+ma460X7T1Mpp8x6YPgW8g/feJZGJ/6d8/zamt8BVAzH4gbd72v/2VX9WfcfsyBfhP4v0EtJ4f8RoOdxVJXgLH6DIP4mpE8c+PPBkyJ4q0s3dmePOCgEfR0+XPseaSVSjrugtKJ6p4f8Q6f4l0uPUNOl3xNwykYZG7hh2NcPL40I+M8elLMGsxB9lKg8CX72frn5a2nPRNdS29jH+OesPGdL0uKQryblwPXop/9CrtLvxID8LH10sI3ksARjs7DaP1NSp+/Im+rPDfhxftZfEHS5S2BJKY299wI/nivqOlhX7rCnsQXV5bWUDT3VxFBCv3pJXCqPxNcNq/xh8LaaWS3lnv5V4xbp8uf95sDH0zWs6sYblSkluchefHm7YEWOhwxns08xb9AB/OsKf40+LJWJQ2MI9I4M/+hE1yyxMuhm6j6ESfFvxsxyt1G/sLVef0q9B8ZfF9vjzrSymH/TS3YfyYUliKgc7Nqy+PLgqL/QlP95oJ8fkCP6112l/F3wnqRVJLqWykbjbdR4H/AH0Mgfia2hiU9JFKoup2ttd297Cs1rPFPE3R4nDA/iKmroTuaDHhSQqWUEqcqe4rjPiR4q0nQdAms72GO8uLtCsVo3Q/7TegH5+lTUajFtik7I80+EfhfVrzXY9dilks7CBiCw/5b/7AHce/tX0DWeHi1AmCsgryf4mfDQaisuu6HFtvV+ee3Qf671Yf7Xt3+vWq0OeI5K6K/wAN/iesqponiK4CToNsF3K2N+P4XJ6Eevf69eo1n4seFdHkaIXb3sy9VtF3j/vo4X8jWcK6ULy3JU9NTh7/AOPF4zsNO0WCNf4WuJS5P4Lj+dcvqXxY8W6krxm7t4IXBDRRWyFSD2O8Mf1rGeIk9ES6jZzmmeI9Y0Yzf2ZqE1p5xzIITtDEe1U/t93/AGh9v+0Sfa/N83zs/Nvzndn1zWHNK1iLsl1TV9Q1q7+1aldyXM+0LvkPOB2rSfxhqsnhNPDTvEbBHDL8p3jknGc9OfTtTU5Jt9wuzIsLt7DUba8j+/BKsq/VTn+le7av8YrFrK3g8NwSX+p3AACPEyrGfcfxH2HHvWtGpyJ9yoysjnP+FceOPGNzHd+JNSS3Q8hZX3sgP91F+UfmK6bTfgh4etXV766vL0jqm4Rofy5/WtY0HJ802WoN6yM74j+HfDHhHw3BPYaNbLcSXUaqXy52j5j94njgD8a9I0fTtHGn29xYadZQxyxq6mGBVHIz2FaQjFTaSGkr2GWmu2l14nv9EjC+dZxRyNx13Z/lx+dbO1f7o/KtVZlLUqXOlafegi6sLWcHr5sKtn8xWNcfD/wlc/6zQLIf9c4/L/8AQcUnCMt0DSZQj+GmkafcfadDvNR0ebv9luCVb/eV9wI9q6y0iuIbdUurhbiRRjzBHsLe5GSM/TFEYKOwJW2Ob8ceOLLwdpu9ts2oSj9xb56/7Teij9a8l8I+EdU+I2uya5rcsn2EvmSU8GYj+BfQdsjpWFV+0moIiXvOx9AWlpBY2sVrbRLFBEoVEUYCgVNXUlY0CuV8YeOLPwtHHbrE95qk4/0eziGWb3OOg/U1E5KKuJuyPJf+Fc+LvGWq3GrX1la6V9obeRINn5IMn88V1em/ArSokB1LVLq4fuIFEa/rk1yww7k+aRmoX1Z1Vj8MPB9gBt0aOZh1a4dpM/gTj9K14vCnh6DHl6Hpy46f6Mn+FdMaUFsi1FIvJplhHjZZWy46bYlGP0pz2VpIMPawsB/ejBq7Idkc9rdx4I01yNYGjRygfcliRnx/u4Jrz3WvFfwrZjHH4f8Atn+3bW/kj88qf0rCpKktyZOKOA1bUPCE5Y6boWo25I4zfjA/Aox/WubOM8dK4ZON9EYu3Q6fQfiF4k8PMotdReWBePIuP3iY9s8j8CK9W8OfGnSNRMcGswtp054Mo+aIn69V/H866KNdrSRcZ20Zz3xt1u2vjo9raTxzRGNrjzI2DKwY4HI/3TXcfCjV11HwDaq0gL2ZaB8n7oHT/wAdxWkJfvmUn755z4V8VLL8ZZ74sRBqE0kAJ7A/d/kB+Ne2rrUDeI5NFH+vS3W4Jz2JIx+g/OqoTun6jg9DToroLCuU8ceN7Lwdphdist/KP9Ht88n/AGj6KP1qJyUY3E3ZXPJPCXhLVPiPrkuua3LJ9h35kkPBlI/gT0A6e1e/2lpb2NrFa2sKQwRKFREGABWVCOnM+pMF1J6K6CwrPtdFsLO8mvY7dDdztukuHG6RvbPYew4pWTA0KKYBSEhQSSABySaAPPfE/wAXdC0Nmt7HOp3anBWFsRqfd+/4ZryrVPHfjLxhN9mt3uFjY8WunxsM+x2/MfxOK46tZt8sDKUr6ISw+FXjDUnDNp/2ZW5Ml1KF/Mct+ldLbfAjUmA+161aRnuIomf+eKiGHk99BKm2Xn+Cui6ZAZ9X8TPHCvVyiQgfixNc5f6R8LdPQga5rV7IP4bQJz+LIB+tOVKnD4mNxitzlb9/CvzDToNZ/wBk3E0X6hV/rWIcZ4zj3rnlboZu3QTNd34E8YweHNC8QWk7sHubfNsAOshBX+oP4VVOXLK44uzOMs7uSy1CC8j/ANZDKsq/UHNekeHPGkmofGNNS3Yt70/ZcHsmPl/HKiqpzs0vMIs9G+JfiuTwxp2mtAxWWa7Ut7xryw/HgV2sEyz28cyEFXUMCO4NdylebRsnrY5jxv43svB+mb3Ky38oP2e3z1P95vRf515H4U8Kar8Sdel1rWppPsO/MkpPMn+wnoB+lY1ffmoImWrsfQFnZ29haRWtrCkMEShURBgAVPXUlY0CigAooAKKAM/WdasNA02S/wBRnENvH36lj2AHc15bft42+JjGOyhbRvD7HAaYlWlX1I6t9Bge9Y1W37kSJNvRG7oXwb8O6WFkv/M1Occ/vTtjH0Uf1JrvrWytbGFYbS2hgiUYCRIFA/AU6dJQWg4xSKWueINL8O2Ju9Uu0gjH3QeWc+iqOTXjvib42X12Xt/D9uLOLOBcSgNIR7L0X9aitW5NFuKc7HnE1xrPiS+Lyve6ldN/vSt+A5xXQ6d8K/F+oxrINL+zo3Q3Mixn8VzuH5VxxhObuZJOR0Vn8Ctak5vNVsYB6RB5D+oWtIfATjnxFz7Wf/2dbrCvqy/ZkM3wFuQubfX4nb0ktiv6hjWJefBXxVb5MDWN0O3lzFSf++gP50nhpLYTps5HV/C2uaCT/aml3NuoOPMKZQn2YcfrWdZ3UljfW93CcSQSLIh9wciudpxdmRqnqdz8WPEI1vXrSOJ90EFqhAB43ONxP6gfhXYaB8TrDRPhjaNK4n1KAG2jts8kr0J9FwR/KuiNW05SLUrSZy/hTwtqvxK1+XWtalk+wh8yyHjzCP8AlmnoP5V9AWdnb2FpFa2sSxQRKFRFGAAK2oR053uy4LqT0V0FhRQAUUAFFAGJL4btL7VF1HVAL2WI/wCjxSDMUH+6vdv9o8+mK2gMVKVhWFrgvHnxLsvCiNZWYS61Uj/V/wAMXu3+FTUnyRuEnZHj9loPi74j6mb1xLMGODdXB2xIPQf4AV6h4e+C2h6eEl1aWTUZwOUyUiB+g5P4n8K5qVJzfNIzjG+rPQrDTLHSrYW9haQWsI52QoFGfXirddiSWxqV7m8htHt1lbaZ5fKT/ewT/Q1PQBUm1K3t9StbCR8TXKu0Y9duM/zq5QncDlPHvhW88XaLFp1texWqCUSSM6Ft2BwOPrXnH/Ch9Q/6Dlt/35b/ABrnq0HOV7mcoXdzm/GPw/XwhZpLe69BPcycRW6RNvYevJ4Ao+H3w+ufFt4Lm5Dw6TE37yToZT/dX+prnVL95ykcvvWPo6ysrfTrOK0tIVht4lCoijAAqxXoJWVjcKKYBRQAUUAFFABRQB5/8RfHUmgxpo2jgza1djaioNxiB6HHdj2H414vYRR6D4zj/wCEy02eVd++eOUndk8hz/eHfHeuKtK8vJGU3dn09p0tlPp1vLpxiNmyAxGHG3b2xirVditbQ1CoUuoZLmS2WVTNEAzoOqg9M/lTA84+KeuPp2seGLZH2r9tFxJ9AQB/Nq9LU7lDeozWcXeckSt2eLeMvE/2X4zaWfN/cWJSF8Hgb/vH8N36V6truu2nh/R5NSuyfJQqOOp3ED+ufwqKc9ZMSe5po4kRXU5VhkVzHjbxrZeDtLMsmJb2UEW9uDyx9T6KK0nJRjzFN2Vzx/wv4X1f4l+IJNY1mWT7CHzLL03/AOwnoP5V9A2VlbadZxWlpCkMEShURBgAVlQi7c73ZMF1LFFdBYUUAFFABRQAUUAFZXiHV/7F0mS5SJp7liI7eFRkySH7o/qfYGlJ2VwZg+D/AASNLnk1vWGF1r10S8srciLP8K/41Y8c+CLPxhpZRtsV/ECbefHQ/wB1vVT+lZ+zThysnl0seTeDvF+pfDvXZdC12OQWPmbZEPJhP99fVT/9ce/tes+IrPS/DFxrqyRz28cXmRlW4kz90A+5IrOjO0Wn0Ji9NS7peowatpdtf27ZhuIxIv4ivLfCPi/7f8X9ZiJ/cXgMcP8A2z4X8xmrnPWJTexyfxl1Q3njk2ynC2UKRgj1PzH+ePwr3PRNUS68LWWpzMFRrVZpG7AbcmopS/eSJi/eZ8razqD6lrt7qBJ3TztLn6nNd18RfGi67oGhWFvLkG3W4ulU9JCMAH6c/nXMp6S8yE9GdToHxRsNI+GlrJcP52pwA2yW+eXK9GP+zjHP4Vynhjwzq/xN8QSaxrE0gsQ/72Xpux/yzT0H8q1cva8sEU3zWR7/AGNjbabZRWdnCkNvEoVEUYAFWa7ErGoUUwCigAooAKKACigAqCS1iluY53XdJECEJ/hz1P1oAmpaAOP8eeBbTxjppK7YdShX9xPjr/st7H9K+f8AUNS13StLuPCd+zpBDOHMMnJRhnofQ5z+tcWIi4vmXUymrO52/wAPvHB0vwRrenSPiazhaa1Yn+8cYx7MQfxrgPDmrSaT4osNTDYMVwGc+qk4b9CazlO6j5EuWwvirVF1nxTqWoISY5p2ZM/3c8fpXunw+C+JPhTFp0kzx5je1d48blGSOM+2Kug7zfmOGrZnr8CtA/i1PUz9GjH/ALLXN+M/h94P8H6UZ59S1OW7kBFvbiSPLn1PycAetXOhCMbsbgkrnO+APAFz4vvvPmDw6VE372Xu5/ur/U9q+kLGxttNsobOzhWG3hUKiKOAKrDwsuZjpqyuWaK6TQKKACigAooAKz9au7yx0157G2FxMpHyH07nHepk2otoEcP/AMLD1IcfZLX8m/xo/wCFiaj/AM+lr+Tf41xfWpdjX2Z2fh/UrnVdLW6urfyXJIAAIBHYjNabttQtgnAzgdTXZCTcU2Zvc4ib4htBO8TaQysjFSGnwR9Rtq1pPjdtV1GK0XS3UOcF1l3bfcjaK51iby5bFcmlzr68z8b/AArPia/u9Wh1SUXroPKhkQeXwMBc9R9a3qw542MpK6PFbHSbaHxF/ZfiCWfT1D+XJIqAmNvcHt716knwJs5kWWHxHI0bjcpFsDkfXdXHTo897vVGcY3F/wCFCQf9DDJ/4CD/AOLrvPBPhAeDdKmsFvmu1klMoZo9m3gDHU+ldFOhySvcuMLO47xl4xsfB+km4uCJLmQEW9uDy7f0A7mvHPDnhzWPih4il1fV5nWwV/3kvQH/AKZx/wCePrU1XzzUEKWrse/2Fha6ZZRWdnCsNvEu1EUcAVZrpSsrGgUUwCigAooAKKACigDzrx5o0dtPHqNvGFWY7ZQOm7sfx/pXL6ZNFb6payzoHiWQF1IyMV5lWKjVNo6xPa0KsilcbSMinV6ZieZePpI315UUDckQD49ev8q7fw5pqaZotvEFAkZQ8hxyWNclJXrSZb+FENx4u0W1uJIJbsrJGxVh5THBH4VF/wAJroP/AD+N/wB+X/wrR4iCdhcrMHx94EtPGemLqNhsj1JI90UmMCZcZCt/Q1yXw28U6voDHR9bt5f7OUkRysctAR2x1K/yrOb9nUU+jM+V810epr4p0R4mkGoRYUZIOQT9AetZ3ibx1pfh3QE1IyCZ51/0aAHDSH+gHc1s60LXTKldK7PD7CO48d+Jm1TxHfNDZlvncKT8o/gQAcfX+te46f4l8L6XYw2VlMIbeFdqIsLgAflXNSqxi25bsmnBtcxZ/wCE10H/AJ/G/wC/L/4U6PxloUkioL3BY4BaNgPzIrf6xT7mnIzdUhlBUggjIIpa3JMq88R6TYXX2a5vFSUdV2k4+uBxWnHIksayRsGRhlWB4IqIzjJtIdh1FWIKKACigDM1/Txqei3Ftt3OV3R/7w6f4fjXjbAqxUjBHBrgxa95M1pvQ9Z8I6j/AGhoEO5syQ/u3/Dp+mK3WYKpZiAAMkmuym7wTM3ueVWwPiHxoHILRvMXOeyL6/oK9VAwMDtWOG1Tl3ZU+iOD+IlvDH9imSJFkcuGcDBbGMZ/OsXwXbQ3PiFFniWRVjZgGGRkY5rCcV7exSfunR+PNWktbeHT4HKGYbpNvHy9AP5/lXEWmh3+tWN8NLljW8hjDxpIOH56exore/V5RLSN0cXZeJZLSe4tdbilSaM4G2PBVgcEMvH5+3Sui0rwVJ461u3uhOw0iKMebKD15PyL7nv6VlCHNKxlzc8bPc9E0bwPEt3K9/bJHax/Jb26NxtHQnHt+PrTPGWhaZpuipPZ2qxSGZVLBieCD6n2rplRSptvc0T1SRzHhu0gvvEFpbXCb4XY7lJxn5Sa73UfBOlXNo62kIt58fI4Y4z7g9qihSU4O+5UpNM0fD1ve2mjw29/jzosqCGzlc8fpWjNKsMEkr/dRSx+grtjdRVzPqeJ31097fz3L/elcsa9K8EagbzQlhd8yW7eX77e36cfhXDhpfvPU0mtDpqK9AyCigAooAK8j8W6d/Z2vzBf9XN+9T8ev65rlxcbwuXDc0PAWo/ZtXe0b7lwvH+8P/rZrsfFd/8A2f4fuHU/PIPKX8ev6ZpUZWovyCS94574eWHN1ft/1yT+Z/pXeVrh1amhT3OG+I/+o0//AHn/AJLWN4D/AORkH/XFv6VzT/jopfCdL440SXULOO8to980AIZQOSv/ANb+tee2N9c6bdrc2shjlXv6j0PtU4hONTmQ46o0dQ0Xw/4/1K1nvZDpmpBgJmjUbblfTPZvf+deqadp9ppVhDZWMKQ28S7URRwK6aHLK81uZOHKy1XKfED/AJF2P/r4X+TVdb+Gxx3ON8If8jVY/wC83/oJr12ssJ8DKnuFc740vjZ+HpVVtrzsIx9O/wCn862qu0GyY7nEar4fOn6Dp99g75R+9B7E8j9P5VY8DagLTXPIY/Jcrt/4EOR/WuGK5KqNd0eo0V6RiFFABRQAVyXjzTTc6Sl3GuXtm+b/AHT/APXxWVZXpsqO55za3D2l1FcRnDxuGGPaun8aa3DqYsorWYSRhPMfaejHsfcf1rghO0HE0a1udv4csBp2hWsBXD7Nz/7x5NatelBWikZPc4b4j/6jT/8Aef8AktY/gP8A5GQf9cW/pXFP+Oi18J6jXL694NtNTLT2pFtdHkkD5H+o7fUV11aanGxEXZnnN/p91pl21vdRGOReR6EeoPcV3PgrxFJdj+zbty8qLmJyeWA7H3rioNwqcrNJaq52tcp8QP8AkXY/+vhf5NXZW/hszjucb4Q/5Gqx/wB5v/QTXrtZYT4GVPcK4bxKRrHiyx0tTlIfmlz0GeT+gFaV/ht3FHcu+INX0O90S5sxfRGQL8gAJ+YdMcfhXm9vM9tcxzxnDxsGU+4rkxEouScS4p2PbLG5S8sYbmM5WVAw/GrFegndXMgopgFFABUN3bpd2ktvIMpKpU/jSaurAeKXls9neTW0gIaNypBq74esTqOu2sH8Ife30HNeTGPvqJu3oexgYGKWvXMDhviP/qNP/wB5/wCS1jeA/wDkZB/1xb+lcE/94RqvhO21jxFHouoWsNxCfInB3TZ+7+HetiKaOeJZInV0YZDKcg12RmnJx7GbWlzkPiFFAdMtpWx54l2rzztxz/SuR8LiQ+JbHy/veZ+mDn9K4qv8ZWNI/Cew1ynxA/5F2P8A6+F/k1ddb+GzOO5xvhD/AJGqx/3m/wDQTXrtZYT4GVPcZLIsMTyOcKilifYVxPg9f7U1zUtVmALE7VHpnr+gFXU1nFCWzZtt4N0JpGc2XLHOBIwH86888SaYmk63NbRAiHho8+h7VjiKUYxuioSb0Oz8A6j9o0l7Nj89u3H+6ef8a66uii700TLcKK1JCigAooA4vxR4QudT1A3ti8e5wA6OccjuDVnwp4Wm0aaW5vHjaZhtQRkkKO/41yqg1V5uhfNpY6uiuog4bxHoXiHW705+zfZo2PkqHxwe59+lUNP8K+I9LvFurX7Osi8cyAgj0NcMqNVz5jRSVrHQeKdEvda0q12LGbyI5ZQ2AcjnBNYlt4V8T6bGTZ3sSZ5MccxH6EYq6lGbnzREpK1mVJ/C/ijU5g978zDgNLOCAPbBOK6vw34Vi0TM80glu2XBYD5VHoP8aVKjLm5pjlJWsjo647xPo+v6zceTEYPsSEMi7sEnHU1vWjKUbRJi0nqYlp4P8Q2N3Hc2/kJLGcqfMFei2ZuDaRG7CC42jzBH93PtWeHpzhdMcmmYPiex1zUlFrYGJLUr85L4Zj6H2rP8MaHr2i3uHFv9kkP70b8n8KUoVHV5ugXVrHYzeb5L+SFMu07N/TPbPtXnmpeFvEmq3bXN2YHc8DEmAB6CqrwnNWiEWkR2nhDxFYXK3Fq0Ucq9Csteh2X2r7HF9sEYuNvz+X93PtSoU5wupBJpliiukgKKACigCteahZafGJLy7gt0JwDLIFB/Oqdr4l0S9uBb22q2ksxOAiyjJPt61LnFOzYXNWiqAKKACigAooAKSgCld6zplhMsN3f20MrkBUkkAY59qug5GRSTTAWimAUUAFFABRQAUUAFQ3ULzwNGk8kBP8ceNwHtkGhgcl4g0nQ9B0ae/bTIr68YhIjeZnaSRuAMtn64Fcpd2Ph++vNN0x7jT7LUYHD3l1DthUHP+rUDALZ79sVyzjC9iT0m413T7LVbPSZJmN3cj92iqTwAeSe3SpBrmmNp02oC8iNpCSskueAQcEVvzx2KuZ1z4ohfwzcaraFYdrGOI3qsils4zgAsfpjP0q2mrxWFtp8Oq3cX226AVQiEB2xzgdQPrS5+vQRNaa7pl/FdS215G8VqxWaTOFQgZPJ4x71W0rxRpus3k1tZtK3lIH81oyqOuSMqT1GQeafPHTzC5Jp3iLT9Vu7iCzd5FgGWm2YjPJHDd8YPtRpfiKw1m7uYLFpJVgxmbYRG3JHynv0NCmmO5pySJFG0kjBUQEsxOABXLWupXfi65lFjJJa6LExRrhOJLk99h/hX36/SiT15UIzvFF14a0OFbZNCtdRvAQPL8sErnoXcgnJ/M10134i0zTYZBcXMazQQ+bJbowZ1Xjt+IqFKMW7AV7nxdp1loFvq115kS3Ee+KAr+8fjOAP69KbH4y0ltDs9VkkeOK7cRxxlcuWzgjA9DVe1jsFzTXV7BpbqMXcW+0UNOC3+rBGRn8qxtM8c6VqcuobS8FtZAFribCq4OcEd+3FDqJMLnQWd5b39pHdWsqywSDcjr0IqetFqMKKACigAooA43xQb0eKdHmfTLq70u3Jdjbp5hEhyASo7DjmrHiHQh4p0+KzS0+yRtIJJJ5UUOAM8Adcn3xWLTldNCOZn0DWv7b1u4WzkS3is2t7aYvligXog5JLYAz2ye9Q2lnqCeBLTQpfD97L9rSWQyqMeU+4lM+nbOccGsuWS6dxFu50nxCtl4Y066spb2O2bzbhY3GMr90Mx44H589a0L3RdW1rxkl3dWnkWNpahQAwYSsRkqD6ZOCcdB71SjLZ+QHM3ejeIofA8iR6fOst3etNcxxrlimBjKjnHt7V01peNa6Lcahb6dd6ncyiOGSGO2eJY4sY2oGGSBz0zyaUU4vVAU9HstV8NaJqQOk3V5ZXNzthswcyLE3DMQM447Vs+A9Gv9GsryK5V47Z5y9tFIcsqH19PpVQjJNeQ0WvHVlqWoeFbm20tN8zldyA4LJ3A9+lUPDlt4i/sG1017SPSIoYlRpt4klfHUheik+pz16VTUvaXQdTNljt7vxjaeG7GIC0snF3eSklnlkHTcx68kVbvdAvNb8eTzXFq0GlR2wgkckZuRkHAxyOe/tjvUcvNou4iomj3lr40uAukTT2cNoILDccwoCMHLMfrnqeTUN34U1OHWdBs7a1+0WdjEXMzMFjWUknOOvBwcd8UuR9uoWE0awXS9M8RXurWd7cRre7yNh3ThOQT6rnk9uKyvDM91qP9pTR6LeTXN9K7wSmEeRCG4LFmIyQCcD/E1OqsrAep6PpkWj6Tb2EJJSFAu49WPc/nV6utKysUFFMAooAKKACigAxRQAUUAFFABRQAUUAYOg+HF0i7v76abz7y+k3yOBgKM8KPbmt6pjHlVgCiqA53xrDqV14bmstKt2muLlhEcEDap5JOfpj8a2NOs0sNNtrRFwsMaoB9BUJPmuBaoqwCigD/2f/hMeRodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvADw/eHBhY2tldCBiZWdpbj0n77u/JyBpZD0nVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkJz8+DQo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIj48cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPjxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSJ1dWlkOmZhZjViZGQ1LWJhM2QtMTFkYS1hZDMxLWQzM2Q3NTE4MmYxYiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIj48eG1wOkNyZWF0ZURhdGU+MjAxMC0wOC0xOFQwOTo1NzoxODwveG1wOkNyZWF0ZURhdGU+PHhtcDpDcmVhdG9yVG9vbD5XaW5kb3dzIFBob3RvIEVkaXRvciAxMC4wLjEwMDExLjE2Mzg0PC94bXA6Q3JlYXRvclRvb2w+PC9yZGY6RGVzY3JpcHRpb24+PC9yZGY6UkRGPjwveDp4bXBtZXRhPg0KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPD94cGFja2V0IGVuZD0ndyc/Pv/bAEMAAwICAwICAwMDAwQDAwQFCAUFBAQFCgcHBggMCgwMCwoLCw0OEhANDhEOCwsQFhARExQVFRUMDxcYFhQYEhQVFP/bAEMBAwQEBQQFCQUFCRQNCw0UFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFP/AABEIAYkBOAMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AP1TooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAEoorB8ceN9D+G/he/8ReI9Rh0rR7FPMnuZmwB2AAHLMSQAoySSAASaltRV2A7xv400X4eeF9Q8Q+ItRh0vR7CMyz3Ux4UdgB1LE4AUZJJAAJr8v/GX/BSzxtefG218SeHovsvgmwZrePw5OQBewEje8zDOJjgFSMiPoNwL7/Nf2tv2ttb/AGlPFHkw+dpfgqwlJ07S93MhGR582OGkIzgdFBwOrM254X/4J+fEnxR8Ebjx9DbiHUSFuLHw3IhF1d2uCWkX+6x4KRkZYZ6HaG+bxGLq4ibjh9kcFSpKbtDofqj8GfjL4Z+Ongez8T+F7sT2kw2TW74E1rMB80Uq/wALDP0IIIJBBrua/Cz9n79oHxT+zb49Gs6MzyW7kRano9wSkV5GCcqw/hdedr4ypzwQWB/Zn4M/GTw18dPA9p4n8MXn2i0m+Sa3kwJrWYAFopV/hYZHsQQQSCDXp4PGLELllpJG9Kqp6Pc7qlpKWvTOgKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKTNLXN/EDx9oPww8Jah4l8SahFpmkWMfmTTynr6Ko6sxOAFHJJxUykoq7FsSePPHOh/DfwrqHiPxHqMWlaPYR+ZPczHgdgoHVmJwAoySSABX45/tYftY65+0t4rwvm6X4OsJD/ZmkFuc8jz5scNKRn1CA4GeWZP2rv2std/aW8UqMS6V4QsJD/Zuj7+c9PPmxw0hBPsgOB3Zvpb9hX9hXcNO+I/xH0/+7caNoN0n4rcTqR+Kofqewr5ytWqY6fsaPw9WcMpSrS5I7DP2G/2ERcR6f8AEX4k6eSny3GkeH7lPvd1nuEI6dCsZ+relfot24FKtJJIkahmZVGQuWOOScAfnXuUKEMPDlidkIKCsj4c/bo/Ydj+IFvffELwBYiPxTGDNqek26cako5Msagf64DqB9//AHvvfCP7Pv7Qfij9m/x4ut6MzTWshEWp6PM5WK8jBOUb+665JV8ZUnoQSD+6R7Y5r4W/bm/YXXx0t98Qvh5YhfEqgzapo0C4GojqZol/57dSV/5adR8+d/lYzByjL29DRnNVpO/PA+tPg78XvDfxv8D2XijwxeC5spxtlhbAltpQBuikX+FhkexBBGQQa7fvX4Yfs7/tE+J/2bfHS6vo7NPp8rCLVNHmYrFdxgng8fK65O18ZUnuCQf2Z+D/AMXvDXxw8D2fijwvei6sbgbZInwJraUAbopV/hdcj2IIIJBBPXg8ZHER5ZaSRpSqqpo9ztsUtJS16Z0BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAlJ3pa5n4jfEPw/8K/CGoeJvEuoR6bpFim+SVzyx7Ii9WZjwFHJJqZNRV2LYk+IPj7Qfhj4T1DxL4l1CPTNHsY/MmnkP5Ko6szHACjkkgV+OH7Vn7VmvftK+LC7+bpnhKxkb+zNH3cDjHmy44aUjPsoO0dyY/wBqb9qrxF+0t4s8ydpNN8KWcjHTNGDcJ282XH35SO/RQcL3J+qf2F/2Ezp7WHxG+JOnYuhtn0jQLpOYu6z3Cn+LusZ+7wTzgL85WrVMfU9jR0j1ZwylKs+SGw39hf8AYU+y/wBn/Ef4j6d/pB2z6PoN0n+r7rcTqf4uhVD04YjOAP0NUYpqSL5jJuG9QCVzyAc4OPwP5U/rXuUKEMPDkgdcIKCshG61+bP/AAUk/aknvdch+F3hbUJIIdMmjutZvLWTaWuFIeKBSD/yzO1z/thRwUNfWP7Yn7Rlt+zp8KbnULeSN/FGqB7TRrdsH97j5piO6Rghj6kqv8VfirfX1zql9cXl5PJdXdxK0s08zFnkdiSzMT1JJJJ968rMsVyL2MN+pz4ipy+6j9cf2G/2vofjz4ZXwz4kuI4vHulwjzC3yjUoF489R/fHAdR3ORwSF+rOeDX8+fhDxdq/gPxPpviDQL6TTdX0+ZZ7a5hPKMPUdCCMgqeCCQeDX7Q/sqftNaR+0p4BTUovKsfEliFi1fS1Y/uZD0kTPJjfBIPbBU8qa0y/Ge2Xsp/EiqNXmXK9zwH9ub9hhfHa33xC+HliF8SqDNqmjQLgaiOpliX/AJ7dSV/5adR8+d/w5+zv+0R4n/Zt8dLrGjs0+nysI9U0eZisV3GCeDx8rrk7XxlSe4JB/c018H/t2fsMnxn/AGh8Rvh7Y/8AFQYM2raLboP9Px1miX/nt3Zf48ZHz5354zByjL29DRomrSafPDc+vPg/8XvDXxv8EWfijwvei6sbgbZInwJraUAbopV/hcZHsQQQSCCe1zX4afs4ftG+JP2a/HQ1fSd11ptwVi1TR5WIju4gTxnHyyLklX6jkYIJB/Zr4S/Fnw38a/BNl4o8L3wvNOuRhkbiW3kAG6KVf4XXIyO+QQSCCezCYxYiNnpJGlKqqis9zshS0lLXpHQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAlJS1y3xK+JHh74S+Dr/wAT+Jr9NP0qzXLO3LSMfuxov8TseABUyairsWw/4jfETw/8KvCN/wCJfE2oR6ZpNkm55ZDy5/hRF6s7HgKOSa/G79qb9qbxB+0t4u86cyab4XsnYaXo4bIQdPNkxw0rDv0UHA7kxftQftQeIf2lvGX2q78yw8OWbsul6MrZWJTxvfs0rDqe33Rx1+u/2G/2D/7B/s74ifEewB1LC3Gk6Bcp/wAe3dZ7hT/y07qh+5wT83C/OVa1TH1PZUdI9ThlKVaXLHYZ+wt+wr/Y/wBg+I/xH0//AImHy3GkaFcp/wAe/dZ51P8AH3VD93qfmwF+rP2jv2hvD/7Ofw/m17VyLnUJt0OmaUrhZLybGcD0ReCzfwj1JUHc+M3xk8O/ArwHfeKvEtz5VpbjZDbpjzbqYg7Yox3Y4PsACTgAmvxW+Onxw8R/H/x9d+J/EU2Gb91aWMbExWcAOViT6ZyW6sSSeuK6a1Wnl9L2dP4mXOSoR5Y7nqPwe/bZ8X+D/wBoS5+IXiW+m1Sx1x1t9asY8+X9mz8ghQnCmLOUGc/eBPzEn9dG8caAvgs+Lv7Vtz4aFl/aP9pb/wB19n2b/Mz6befWv5+Pzr02P9onxmnwNk+FH9oZ8MNei7xz5qp9424OceUZMSbcZ3DrgkV5uFzCVFSU9bmFOty3TND9qL4/X/7RHxW1DxFMZIdHhJtdJsnP+otlJ2kj++/3m92xnCiuG+HGtaR4f8caPe+INNj1fQFnCajYyKT5ts/yyhcEEOEZirAghgpBBFc36UV5cqjnPnkc7k2+Zn05+1N+xTrHwUh/4SvwvLN4o+HV0qzQ6hGA81mj4KibA5UgjEg4OeQpIB8d+C3xk8QfAn4gaf4r8Oz7Li3Oye2cnyruAkb4ZB3U4/AhWHIr9O/+CdvxYh+K/wCz2vhrUyl5qHhg/wBlXEMwDiW0ZSYCwPVdm6PH/TI14h+19/wTrfT/ALb4x+E9k01t80174Xi+Zk7s9r/eH/TLqMfLnhR69TCvlWIw/wBx1SpOyqQPuX4KfGTw/wDHb4f6f4r8Ozbra4Gye2cjzbSYAb4pAOjAn6EEEcEV3R7V+I/7LH7Sms/sz/EQXoWa58PXjCDWdKzgyICRvUE8SpkkZxnlTgHj9ofB3i7SPHnhnTvEGg30epaRqEKz21zEfldT7dQQcgg8ggg4Ir2sHiliI66SR1UqntF5nxJ+3N+wuPF63/xE+HdgF15czatodugxfDq00K/89e7L/H1HzZ3/ABR+zf8AtH+Jf2a/HA1bSWa70q4ZY9U0aVysV1GD9PlkXJ2vjIyRyCQf3KbqK+Cv26/2Gl8VQ6h8Rvh5YbddXM+raJapxejq08Sj/lr3ZR9/kj58h+LGYOUZe3oaNGVWk0+eG59ifCT4teG/jV4JsfFPhe9F5p1yMOjYEtvIAN0Uq5+V1zyPcEEggnsc1+Gv7N/7SHiT9m3xuuraSTd6VcFY9U0aV8RXcYP/AI7IuTtcA49wSp/Zz4VfFPw58ZfBVj4o8MXy3um3S4I6SQSD70Ui/wALr3HuCMggnrweMWIjZ6SRrSqqordTrxS0lLXpm4UUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAlJ14pa5P4ofE7w78H/AAXf+KPE9+un6XZrkseXlc/djjX+J2PQfjwASJk1FXbE9NQ+KHxO8O/B/wAG33ijxRfrYaXZryeskrn7sca/xOx4AH6AEj8b/wBqD9qDxF+0t4yN3deZp/huzdl0vRlfKwqeN79mlbue3QcdYv2mf2mvEf7S3jX7dfeZZaFaOyaXoqOSkCH+Jv70rcZb8BgDFfZX7Dn7CKeFI9O+IfxHsN+unbPpWh3C8WXdZplPWXoVQ/c6n5+E+cq1amPqeyo6RW5wylKtLljsRfsL/sLf8I2un/Eb4i6fnVztuNI0O6T/AI9O6zzqf+WvQqh+51PzYCfa/wAQviFoXwt8H6l4n8R3yafpFjH5ksj8s3oir1ZmOAFHJJrR8ReJNM8I6Df61rN7FpulWMTT3F1cNtSJAOSf8OpJxX45ftgftZap+0l4w8i0aaw8EabIf7N09uGlbobiUZ5dhnA6KpwOSxbtqTp5fS5ILVm0nGhGyOb/AGnP2k9e/aS8ePq1+Xs9DtC0Wk6SGyltET949jI2Bub2A6KBXoP7If7EOtftA3cPiDX/ALRongKF+bkLtn1Ag8xwZHC54MhBAxgZOceg/sZ/sA3Pj4WPjf4lWktl4aO2ax0OTKS346iSXukXTA+8454XG79OLOztdIsIba1ghs7O3jEcUMKBI4kUYCgAYAA9K4sLgpV5e2xBjToub56h+Fn7Q3wT1T4A/FTV/CWo7poIW86wvGXAurVifLk+uAVYDgMrDtXm1fUX7fn7R2m/Hf4nWun6BHBL4f8ADfm2tvqSoPMvZGK+Y4b/AJ5AoAo78t/EAPBfhz8MfFPxa8RRaH4S0S61vUXxmO3UbY1/vyOcLGv+0xArx61OPtnClqjlnFc1onL1oaF4f1PxRqUem6PYXGp6hKrNHaWkRllkCqWbag5YhQTgZ4Br274//sV/ED9nvw5puu6wlrq+kXCBbu80vfJHYzE4EcmVB2nIAfGCeOOM+J+G/EWoeEfEOm65pNy9pqen3CXVtOnVJEYMp9+QOOnWs5U5U5ctRWJcXF2eh9CfsDfFyT4P/tFadYag72ul+ID/AGLexy5Hlysw8liD0IlCrk9A71+xxye9fO+g+B/hV+2p8K9B8a6t4atXv76AF720JgvrO4Q7XjEyYY7HBwGyCMHGDX0JZW5tbOKAzSXDRoqGabBd8DG5sADJxk4Ar6/BUpUYWvdbo9WlHlVuh8mftd/sG6N8bo7zxT4SWDQvHWC8i42W2pkDpLj7knpIBz0bPBX5W/ZG/aO8Qfsk/Ei8+HnxFtbvTfDNxc7Lu2vFIfSpzgCdR3jYY3YyCMOucYb9YWrxn9pD9ljwj+0l4eFvrEX9n69boRY67bRgzwHrtYceZHnqhPrgqeaithHz+2oaS/MmdN35obnsNndw31rFcW8qTwSqJI5omDI6kZDAjggjHNTNXw1+zL8SvF/7MPjS1+CHxfBj0u5k2eFvERYtbScgC3Ehx8hJG0HDIW2kYZdv3Kveu2jV9rG/Vbm0ZcyPgT9uj9hf/hJPt/xG+HOn41gbp9X0K2T/AI/O7TwqP+WvdkH3+o+bIf41/Zp/aW8Sfs1+NBqemFr3RLplTVNGkfEdzGD1H92Rckq2OOQcgkV+4jV8C/t0fsLf8JJ9v+I3w50/GsDdPq+hWyf8fndp4VH/AC17sg+/1HzZD+RjMHKEvb0NGctWk0+eB9nfCr4p+HPjJ4LsvFHhe/W+0y6HI6SQSD70Ui9Vdc8g+oIyCCetr8Ov2af2lvEf7NfjRdT0wte6JdMqapo0j4juoweo/uyLklWxxyDkEiv2X+FfxS8OfGTwXY+KPC9+t9pl0MEdJIJB96KRequueQfUEZBBPbg8ZHERs9JI1pVVU9Tr6WkFLXpG4UUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAIaTrS1yHxU+KXhz4N+C77xR4ov1sdMtRjHWSeQ/dijXqztjgD0JOACRMpKKuxN2V2HxV+Knhz4NeC77xR4ovlsdMtRgDrJNIR8sUa/xO2OB9SSACa/Gv8AaW/aa8S/tLeMxf6justEtWZdL0WJyY7dCcbm/vyMMbm/AYAxTf2lP2lPEv7THjf+0NQ32mjW7NHpWixOWS2QnqcffkbA3NjngDAAA+2f2Gf2F08Dx2XxC+Imnq/iRgJtL0W4XI04HpLKp/5bein/AFfX7/3PnKtWpj6nsqWkepwSlKtLljsV/wBhj9hYeD0sPiJ8RLANrxCzaTolwvFl3WaZT/y16FVP3OCfn4T7rvb2302zuLu7mjtbW3jaWWeZwiRooJZmY8AAAkk9MVMx2jJ4A569K/Mv9tP9q7Vfjp4pT4QfCwXGp6VJcC2u59OBd9WmB/1UZHWFcZLdGIz91ct6cnSwFJJf8Ozp92jGyOB/bY/a+vf2hPEo8H+EXmHgezuAkSxKfM1acNgSMvXZnGxMZ/iPOAvvP7Gf/BPuLw79h8c/FGySfVflm0/w3OoZLXuslwOjSekfRf4stwvon7Hf7C2lfA23tfFPi6O31jx667owMPBpeR92L+9J6yduQvGS31t+NYYfCSqT9viNX0XYiFNt889xBXwh/wAFGP2sj4T0uf4WeE73brV9F/xO7uF+bW3YcW4OeHkBy3ohx/Hke7ftg/tOWX7N/wAOXubdo7nxZqgeDSLNsH5gPmncf3EyDjuSo7kj8X9Y1e98QateanqV1LfajeTNcXFzO255ZGOWYnuSSazzHF+zXsYPV7k16vKuVH0D+xb+zJof7SnjTUbPW/Ev9lWulRpcSaXar/pl5GSQSjMNqKDgE/MfmAwM5r9b/hr8LfCvwj8Ox6H4R0S10TTkO5lt0+eVum+Rzlnb/aYk9ugr8MfhP8Tta+DnxA0fxdoMvl3+nTCTyySEnjPDxPj+F1JU/XIwQDX7lfCP4oaN8ZPh7o/i3QZvMsNRhD+WxBeCQcPE+P4lYFT9Mjgg1nlcqTi1b3hYZxatbU6TVtLstc0260/ULWG+sLqNop7a4jDxyowwVZTwQR2r8rf20P2E7z4Py3njLwLBNqHglmMlzZDLzaVn36tDzwx5Xo3Tcf1d/lTLiFLiN45FWSNwVZHGQwPUEelericLDExtLc6KlONRan5a/wDBMv4/f8IT8Qrr4datdFdH8SN5thvPyQ3yqeOuAJUG33ZIx3r9TF6Gvzb/AGwv2Fb3wDqMvxM+EkMsNtaS/brvRbIES2EitvFxagfwAjJQcpjK5XhftH9mT42Wvx8+DuieKoyi6gyfZdTgTjybtABIuOwOQ6/7LrXLgnOlfD1d1t6GdK8fckeq0e9DV4l+1X+0xpX7Nfw+bU5Uiv8AxFfbodJ0uRsCaQDl3xyI0BBYjrlVyCwNelOcacXKT0R0NqKuz0D4ofC3wz8YPCdz4d8VaZFqemTfMFbh4XAOJI3HKOMnDD1I5BIrB+Ftr4m8Bong/wAUXsviC1tht0fxLIP3t3ABxDdAdLhBxv6SKA3DbxV74G/GLRPjt8N9L8X6G+2C6XZcWrNl7WdeJIn91PfuCrDgiu9qYqM7VIiVnqho/WhhSn8q8lj/AGo/h3J8aJfhf/bsa+JkQdcfZ2nJObYSZx5wGDt99udwKipTjG3M9xtpbnyv+3Z+wy2uNqHxI+HdhnUvmn1jQ7ZP+Pju1xCoH+s6lkH3uSPmyG+P/wBmP9pnxD+zX41/tHT919oV4VTVNHZtqXCDoy/3ZFGdrfgeDX7g5r8/f26P2Ff7Y+3/ABG+HGn41D5p9X0K1T/X92ngUfx92Qfe5I+bIbxMXg5U5e3oaM5KtJp88D7Y+F/xO8O/F/wZY+KPC9+t/pd4uQRw8Tj70ci/wup6j8RkEE9XzX4ffsyftNeIv2a/Gi3+nl7/AEG7ZU1TRWfCXCD+Jf7sij7rfUHIr9lvhf8AE3w78YPBdj4n8L366hpd4uQ3R4nH3o5F/hdTwR9DyCCe7CYuOJjZ6SW5rSqqovM6wUtJS16JuFFFFABRRRQAUUUUAFFFFABRRRQAhpM0tcX8XPi54Z+CXgq78T+Kb8WdhANsca/NLcykErFEv8TnB46DBJIAJESkormYm7K7HfFv4teG/gr4JvvFPii9Fnp9sMIi4MtxIQdsUS5+Z2xwPYkkAEj8aP2jP2jfFP7THjr+0tS32+mROYtK0SBi8dshPHGPnkbjc+MngYAAUH7Rn7Rnif8AaY8eDU9S32+mwuYtK0SFi0dtGx4A/vyNxubGTwBgAKPuX9hr9hpPh3DY+P8A4gWSyeKnAl03SZ1yNNB6SSAjmcjoD9z/AHvu/OVatTMKnsqWkUcEpSry5Y7EH7Df7Cw8BrZfEL4h2AbxMcS6Xo06gjTh1WWUd5umF/5Z9T8/3Pujnv0pfWvm/wCPHxM8V/ELxFcfCL4SSeX4hkQf8JD4nBIt9At2/h3jrcOM7VHzAcjB+ZPahCnhafLFf8E64xjTVkeUftZftB+JfjB4wl+BHwZSTUdVuS0OvaratiOCMHEkPmDhEGcSP77Bkkivaf2V/wBkLw3+zboInHl6z4yuowL7WpE5UcZihB+5Hn8Wxk9lXr/gF+zx4U/Z58IjR/D1v5t7PtfUNWuADcX0oH3nPZRk7UHC5PUkk+n1NOg3L2tXWX5CjB35pbi+3auU+KXxM0L4Q+BdV8V+IroW2mafFvbGN8r9EjQHq7HAA9+cDJrprm4is7eWeeVIYY1LvJIwVVUDJJJ6AAda/Hn9uL9qqX9oLx1/ZOi3DDwNokzLZKMqLyUZVrph6HkIDyFJ4BY0YvErDwv1ewVKipq55H8cvjPrvx6+I2peLNekIedvLtbTdmO0twTshTPYAkk45JY8E16V4N/YP+Kfjn4Qt4807TYwJCJLPRp3Md5eW+CTMgIxjptBILjJH8O73b9h39g061/Z/wAQ/iVp5XTwVuNJ8P3Kf8fHdZrhT/B0KofvdWG3hv0k24wBwOn0rx8NgHXvUr9Tmp0ef3pn88moafd6TfXFjfW01leW7mOW3uIykkbg4KspGVIOeO1fVX/BPz9p7/hS/wAQP+EV1668vwd4imVGkkYhLK7OFSbngK3COfQKxOE5++v2kP2O/BP7RVjJc3luuieK1Tbb6/ZxjzOBgLMuQJU9jhgB8rL3/KX48fs2+Nv2ede+weKNOzYysVtNYtcvaXQH918DDYHKsAw64xg1yzw9bA1FUjqkZyhKjLmWx+6i06vj7/gnl+0//wALc8C/8IV4gu9/i3w7CqxyStl72yGFSTPd04Rj3+RskscfYAr6qjVjWgpx6noxkpK6Eb6V5f4O+Cdj8NfiVq/iHwps03RvEKl9Y0ReIPta8pdQgcIxBZHUYDZVuCpDeo1U1bVLTRNNutRv7mOzsbSJp7i4ncIkUajLMxPAAAyT6A1Uoxb5n0Hp1OZ+K/xS0H4N+A9U8WeI7n7Pp1jHnYvMk8h4SKMHq7HAH5kgAkfiX8dfjZr3x8+I1/4r16TY0x8u0slYtHZ24JKRJ64zknqSWPevSP2zv2qbv9o7x55GnSSweCNIdk0u2bK+e3Ia5kB/iYdAfurxgEsT418P/CMHjvxFDoJ1S30i/vf3djPfHbbPOfuxSP8A8s9/QOQQG2g4BLL8rjsW8RP2cPhX4nm1qjm+VHtX7Ef7T0v7PPxIW21Wd/8AhCtbdINSjPItmzhLlR6pnDY6qTwSFr9kbe4iu7eOaCRZYZVDxyRtuVlI4II6g+or+frxl4J174eeIrrQfEulXOjatanEtrdJtYehHZlPUMCQRyCc19Y/Aj/goZqnwl+AWp+Eb60l1fxFpyrB4cupfmiSJsgrMSc7YjyoGcghflC5rXA4z2KdKrsVRq8nuzPp/wDbq/bHi+CGhv4Q8KXSS+PNRh+eVSCNLhYf6xv+mrD7i9vvHjaG/Jpry5kvGu2uJXuzJ5puGcmQvnO8tn72ec56nNWvEHiDUvFWuX2saxezajql9M09zdTtueV2OSxP1/D0rvfgBofhDxt41Twh4ymfS7TXttpZa7CRv068J/dOwJw8TE7HU4+8rbl25rhxGIni6vZdDKdR1JH3N+xJ+3sni77B4A+JN8sWu4EOma9cMAt72WGdj0l7K/R+hw2N/wB4/rX4W/Hn9nHxn+zt4j/s/wAS2Jaxmc/YtYtQWtbpRz8rH7rAdUbDD0xg19ffsR/t8FTp/wAP/idqOV+WDTPEd0/4LDcsfwAlPsG/vV7GExkov2NfRnTTqte5UND9u79hldSj1D4k/DvT8Xy7p9Y0K1T/AF/driFB/H1LoPvckfNkN8ifsx/tOeI/2a/Ga6hp7Pf6BeMq6pozPhLhBxuX+7IozhvwOQTX7fjGB71+ev7dX7CpvP7Q+I/w40//AEj5rjWNBtk/1ndriBR/F3eMdeSBnIJi8JKnL2+H0YVKTT54H3J8M/iV4f8Ai14N0/xP4Zv01DSr1Nyupw8bfxRuv8LqeCD/ACxXUV+If7Lv7UPiD9mvxgLyzMmoeG7xlXVNHZ/lmUceYh/hkUdD36Hiv2U+GvxI8PfFrwdYeJ/DN+moaVeLlXXho2H3o3X+F1PBBruwmLjiY22kbUqqqLzOppaSlr0TcKKKKACiiigAooooAQ0nU0tcL8ZvjJ4Z+Bfge78T+J7z7PaQ/JDbx4M11KQSsUS92OD7AAkkAEiJSUVzSegm7K7JPjB8XvDXwQ8E3nijxRei1sYBtjiXBmuZSDtiiX+Jzg+wAJJABI/Gj9oX9obxT+0x4+/tXVBJHZRuYtK0W3YvHaxsQAqjHzyNxufGWPAwAFCftB/tDeKv2mPHg1XVQ8VpGxh0rRLdmeO1RiMKoxl5GONzYyx7ABVH3j+w5+w3H8MobLx74+s1m8XyKJNP0uUbl0xSOHcd5iP++P8Ae6fOVKlTMKns6ekEcEpSrvljsR/sP/sLp8N0sfH3j+0WbxWyrLp+kzLldMz0kcHgzYxj+5/vcr9vYPOKctKa96jRhQhyQR2xioKyOL8dXWu60G8PeFrj+zr2YYvNbaMOunREcmNTw9ww+4p+Vc7342rJd+Hfw70P4Y+HY9F0G0MFuHaaeaVzJPdTNy800h+aSRjyWPX6AAdLGgTO0AAnJwO560+teXW73Kt1G0h9qVh+dfN/7an7UkH7PPgE2ekzRzeOdZRotMt8Bjbr0a5dfReQoP3m4wQGxNSpGlBzlsKUlFXZ4F/wUe/azFrDc/CXwlekSsAPEN7bt91SARaK2ep6vjthO7AQ/sPfsG4+wfEP4mab/dn0nw9cr07rPcKfwKxn6t6VtfsVfsNz2t5b/E/4qWzXmuXLm8sNFvwXaJ2O77Tc7uspJ3BDnbnLfNwv3wvGa8ujh5V6n1iv8kc8YOb55ir9MU6kWlr2TqErH8VeFNG8b6Dd6Lr+m2+raVdoY57S6jDo4+h6EdQRyCMjGK2KOtJpPRh6n51fFD9iHxf+zr48sfif8DJbjVodMm+0P4flYvdRpyHjQ9Z4mUspX7+DxvPI+4vhD8UtJ+Mnw/0rxXo5ZILyPEtrIf3lrMvEkMg7MjZHvwRwRXYt7Vmab4b0zRtS1G+sLKKzudRdZbxoRtE8gGBIwHBfGAXxuIVQSQoxy0sOqMnybPoZxgovQ1G7V+Yn/BRD9rr/AITDUbn4XeD7wtoVjLt1q+gbi8nU/wCoUg8xow+Y/wATrjovze2f8FAf2uv+FUaDL4A8J3uPGOqQ/wCl3ULfNptsw9R0lcdO6qd3GVJ+Iv2Zf2P/ABh+0jqi3NujaJ4Rhk23WvXEZKEg8xwqf9a/0+UdyOAfMxuIlUf1ejq+pzVpuT9nA8h8DR6LN4y0SHxGJP8AhH5byKK/a3fZIluzBZHQngMqksMgjI5GOK9x/aa/Yl8Y/s+yT6vbBvE3gktmPWLWI7rcHoLhBnZ6bx8h45BO2vrj4v8A/BL/AMHax4OtU+Ht5PoPiSxg2b9QnaaDUWH8Ux6xuf7yDaOmzpj6Z+Aqa9cfBfw3p3jXTJLPxBZWf9malbXWHEjQ5iL55V1kVQ+QSDvrmo5c9adVeaaIjQ3Uj4u/Zr8YeCv22Ph2nwt+KsIn8baNbEaRrqsFvZ7YcZSUg5kTjcrZDgBiCQxHzj+0t+xp41/Z0vZL2aI694RaQiDXbOM7U5+VZ058pug5JUk8MTwPsb49fsAPY+IIfiF8DrkeGPFenzC9j0VWCW8kinOYGPEZPI8s/uyDj5R1+hPgL8XoPjt4GvbLxDow0rxVp3/Eu8SeG76HBglKkHKP1ikGSpOQRkZODW31T2q9lW0ktn3Rfs+b3ZLXufh3a3U1jcRXFvI0M8Lh45IzgqwOQQfXNfeHwa+CPwo/bf8Ah9Lc2qJ4A+KWlIqan/Y8Sra3PZLn7Lwm1sHIjKYfOeCuep/ak/4JqwX32vxN8JEW3uPmln8MSuFjc9T9mY/cP/TNjt9CMBa+Ifhr8QfFv7OHxWtdbsoLjSte0mYxXem3kbRGRMgSW8yHnBHryOCOQDXnKnLB1eWtG8WYKLpStNaH7LeEvhtf+I/g9D4K+LFtpviyeKL7Fc3A3PFfxr/q5yGAZJduMkchwSp6Gvzv/as/4J7678JftfibwItz4l8ILmWa1xvvdPXuWAH72Mf3lGQPvDALH9LPg58WtC+N3w/0vxb4en8yyvE/eQsR5ltMAN8MgHRlP5jBGQQa7NgK+iq4aliaa/BndKnGpE/Mj9iT9vSXwabDwB8SL5pvD/EGma7O25rHssMxxzF2VjynAPy/c/TOGaO4hSSN1kikUMjocqwIyCD3FfGf7V3/AATy0X4n/bfE/wAPkt/D3ixsyz6f9yy1Bup46RSH+8BtJ+8ASWrxD9lf9rrxJ+zR4mHwt+LdrfWug20gt4pLxCbjSCTgeu+A+2cA5XI4rko1amFl7LEbdGZxlKn7s9jtP26v2Fftn9ofEf4b6f8A6T81xrGg2yf6zu1xAo/i7vGOvJAzkH5Q/Zd/ai8Q/s1eMBeWZk1Dw3eOq6po7P8ALMo48xP7sqjoe/Q8V+2Wn6ha6vYW19ZXEV5Z3EazQ3EDh45UYZVlYcEEEEEetfnr+3b+wuZG1L4k/DqwJLbrjWdCt059WuIFH4lkA9SO4rPFYSUH9Yw+jIqU3F+0pn3Z8NfiT4f+LXg+w8T+Gb9NR0q8XKuvDRsPvRuv8LqeCD/9eunr8SP2Wf2o9e/Zp8ZG6tw+o+GL51XVNH3YEgHAkj7LKo6How4PqP2S+HXxE0D4reENP8TeGtQj1LSb5N0cqHlT/EjL1VlPBU8giu7CYuOJjbaSN6dRVF5nTUtJS16JsFFFFACUdaK4L41/Grwz8B/A914m8TXflW8fyW9rHgzXcxGViiXux/IDJJAGaiUlBc0nZCbsrsf8ZvjJ4a+Bfge78UeJ7zyLSH5IbePBmupiCViiX+Jjg+wAJJABNfjR8fvj54r/AGmPiANV1bzBDv8AI0rRbYl47VGIARBjLO3G58ZYgcABQGfHn49eLf2lvHw1XWWkZC/kaXotqS8dqjEARxgfedjjLdWOOwAH39+w/wDsOxfCq3s/Hfjq0SfxnKvmWWnSAMulqR1PrMQev8HQc5NfOVKlTMans6ekEcMpSrytHYb+xD+wzB8Lrex8d+PbNLjxlIBLY6bLhk0sEcMw6Gbn6J255r7OW+tzfNZ+fGbtIxM0O75whJAbHplSM+xqxzX59eDf2n/7Y/4KQalbfa/+KdvIX8I2+WygaIllYepa4WQA+ktetelgoxgurt/wTp92kkj9Blp1cJonxc0XXPi94k+HlvJnWND0+1v5/mByJi+VA7FV8lj/ANdl9K7oV3RkpbGt77C0mKWoby4js7aW4mkEUMSl3duiqBkmqGcd8ZPizovwV8A6h4p1t2aG3Ajt7SLma8uG4jgjHd2P5AEngGvnj9nv9mfWvGfj6f43fGaDz/GV9IJ9J8PyjMOkRDmLcp/5aKMbV/g5Zsufl9lsPhrL8QPiBaeOvGEDNFpTEeGtBmGUsc9byZehuX7A/wCqUAD59xr1dfSuV0/az5p7LZGbjzO7BadSelcvdfEHS7X4kaf4KaTOsXmmXGqquRgRRSxR4PuTKcf9c2robS3NDqM815p+0p8Qn+FfwI8beJ4JzbXlnpsi2koPKXEmIoSPpI6GvSfw4r4i/wCCq3j0aN8IvDfhSKTbPrupm4kUfxQW65YH/gcsJ/4DWGJqeypSmRUlyxbPsH4f+Jk8a+BfDviGLHl6tp1vfLt6YliVx/6FW/Xz1+wL4t/4S79lfwZI77rjT0m06QZzt8qZ1Qf9+/L/ADr6FrSlP2lOM+44u8UxrV4b+1l+0tp37OPw+a8jEd74q1LdBo2mnnzJOhlcDny0yCcdSVXjOR7D4j1htD0ie7isp9SuVGILK1AMs8h+6i5IAyerMQqjJYgAkeN/D/8AZxWf4gS/E/4kyW/iTx/MQLO3XL2GhwgkpDbK33mXJJlIBLEkBSTmKzm1y09317ClfaJ8ofs4/sE6/wDFfXn+I3xtkuwmoTG9GjTsy3V6zHO64PWJOfuDDY4+QDB/RjRdHsPD+l2um6ZZwafp9rGsUFraxiOOJAMBVUDAA9BVtVp1TQw8KC93V9xQpqC0ClpKWuo0Gt2rHn8J6ZceJLbxB9lWPWIImtxeQ/I7wnkxOR99M/MFbODyMGtqk70rXAaOe3HavE/2i/2S/BP7RmmFtWtf7L8RxJttdeskAuEx0WT/AJ6p/styOdpUnNe302onCNRcs1dCaUlZn5efCyf4gf8ABOr4uCw8aWsl78NdemWC41KzVpLQnnZcIcfJKozujIyy7sbsKR+nenahbatY297ZTx3VncxrNDPCwZJEYZVlI6gggg1U8TeF9J8ZaHdaNrmnW2raXdJsntLuISRyL7g/mD2IrjfhH8K3+DljceHdK1Ga98Gqxl0y0vXLz6buOWgVz9+HJJXcdycjLAjbzUKMsO+RO8fyM4x5NFseintXkv7QH7M/gz9ovw99i8RWfk6nChFjrVqAt1anrgN/EhPVGyOeMHBHrK/SnGumUI1FyzV0aNJ6H51fDzxv8Rf+CfHiyDwh8RYp/EXwkvrgpYa5aIzpZsxzlBklM8l4DzwzIW53/oJoOvad4o0Wz1bSb2HUtMvYlntrq2cPHKjDIZSOopnibwzpPjHQ7zRdc0631XSrxPLuLS6jEkci+4P5g9QQCK+X9N+Gni/9jTWrnUvBEV/4z+D9zKZdQ8KhjLf6PuPzT2meZUHJKfeI655cccYzwztvD8jKKdPToeO/t1fsKlf7R+JHw40/P3rjWNBtU/FriBQPxZB9R3FfL37LP7U2v/s0+MPtFv5mpeFr51GqaMXwJB082PPCygdD0YDB9R+zvhHxdo3jzw5Y694f1CHVNIvoxLb3UByrr6EdQQcgqQCCCCAa+Af27v2GhbrqHxK+HWnnblp9a0K1jzju1xAo7d3Qe7DvXn4rCyg/rOH3MalNxftKZ95/Dn4iaB8VPCOn+JvDOoR6lpF8m+OVOqnujr1VlPBU8giuk71+JP7K/wC1Pr/7NPi4T25k1LwtfOo1PR9/Eg6ebFnhZQO/RhwexH7KfD/x9oXxQ8J6f4l8N6hFqej3yCSGeI9PVWHVWByCp5BBBrvwmLjiY9pI2p1VUXmdHRRRXomxw3xp+MPh/wCBfgG+8WeI5nSytyI4oIhmW5mYHZEg/vHB68AAk4ANfi9+0B+0B4m/aI8cS6/r83lW0eY9P0uJiYLKEnhVHdjxuc8sR2AAH7g+MvB+jePvDV/4f8QafDqmj38RhuLWcZV1P6gg4IYYIIBBBFfjx+15+yHrP7NniT7Xaedqnge/lIsNUK5aFjk+RPjgOADg8BwMjBDKvgZpGq4px+HqcWIUrabFD9mb46eB/wBn3UZPFGoeCrrxn4xViLJri7S2trFehZPkkYyEfxlRgcDuT7zqH/BWfxZL5n2HwHo1twNn2i7ml2nvnAXP6dR+Pgv7JUfwc1rxwug/FzS5mtb91Sx1Vb+S3ghkPHlzhCuEbs4I2nrwdy/p5pP7EvwO0qFVt/h5pkqDBBuZJrgnA9ZHbP8AWuXBwxFSn+6mkv68jOkqko+6z4Z1j/gql8U76CaKz8P+FbFZIigk+z3MkiMQRuU+eBkZGMg8jv0r5E0HxFfeHfEmna7ZTsmp2F3HfQTMckSo4dWPqdw/zzX7ff8ADKXwcP8AzTPwx/4LIv8ACqt9+yD8F9QQJL8NvD6AZH7i0EJ590xW9TAYirZznexcqM5byPy4+FP7Wur+Bv2mNR+LWq2b6idWe5XUdOt5dhaCUZWJGIPEZSLGeojAOM5H3j4L/wCCm3we8TSRxao+teFpGO0vqNl5kWfZoWc4z3Kit/xF/wAE6/gZrkbiDwvc6NM3/LbT9SuAen92R3X/AMdrxrx3/wAEm9BuIXk8G+N9RsJxyINcgjuUf/Z3xiMqPfa30qoUsbhr8tpLcajWp7an254L+IHhn4iab/aHhjX9N1+yGA02n3KTBCezbSdp9jzW/IokUBlBGQefY5FfjP46/Zh+OH7Ker/8JHZRXsdva/N/wkXhe4eSJF6nzMAOi9M+YoU+9fWv7Gf7fz/FDVrTwP8AEVre18STkJp2sRARRXz9BFIg+VJT/CVwrdMK2N3XRx15qnWjyyNY1teWSsfchryzVvjrpml/tE6D8Km2fbtS0W41TzcnIkVx5cYHvHHcMf8AcX1r1EkbcntzX4t+Ov2j5739seb4qWs0k1nY67G1sqnl7GEiIIPTfCpyPVz65rXF4n6uo+bKqVOSx+0oxjFfmv4o+Pe//gp5pV2tznStPuo/CQ+bjDq0bg+wuZWP/AR6V+gvjHxxYeE/h7rHi6SVZ9M0/TZdS3o3EkaRmQYPfIAx65Ffgjc+JtRuvFEviF7hjq8l4dQa4XhvPMnmb/ru5rjzHEezdNLvcyrz5eU/oR/CvyS/4Kb+Pv8AhKv2iBocUm+28OadDalQeBNJ++c/Xa8Q+q4r9TfBnjC18X+A9E8URukdlqWmw6gGz8qpJGH6+wNfhN8WvGz/ABI+KHivxSxbbq2p3F3GrdVjeQlF/wCArtH4Us0q/uYxXUWIl7lj9DP+CTfi77b8OPG/hpn3Np2qRXyqeoWeLZx7Ztyce5r7vHevyn/4JX+Lf7H+Out6G77YdY0Zyq/3poZEZf8Axxpa/VcHqa6svnzYePloa0HeCFoprE5FcH8UPjr4D+DNmLjxj4nsdGLLujtpHL3Eg9UhQF2HuBivQlKMVduxs3bc73mgfSvgb4mf8FXNC0+WW18CeEbrWGUkC/1mUW0WR3WJdzMPqUPtXzV42/4KJ/GzxhI4t9ftfDVux/499FskQf8Afcm9/wAmFebUzKhT0Tv6HPLEQifsczCsXWfGvh7w6WGq67pmmbQSftl5HFgDqfmI9a/CbxN8aPH/AIy3f27428QasjfwXWpTOg+iFto+grjK4pZt/LAy+tdkfvPdftBfC7T5Al18SPCNs5GQsuu2qkj1wZKhX9pD4TMwUfE/wazHgAa/ac/+RK/CCKJ55FjiRpJGOFRQST9AK2LPwT4i1Df9l0HVLjZjd5NnI23PTOFrP+1aj2gL6zLsfvHpnxT8Ga3J5en+LdDv5MgbLbUoZDk+wY100M0c0avG6ujAMrKcgg9CK/n/AP8AhXHi3/oV9a/8F8v/AMTUWn3nifwXIbqyn1fQmDj99bvLbENnjkEYPA961jmk18dMaxD6o/oJ+lFfh/4R/bJ+NPglo/sHxC1e4SPjy9UkW+Uj0/fhzj6HjsRxXu/gn/gqv4+0l0j8T+GNF8Q269Xs2ksp2992XT/x0V0wzSjL4k0aLEQe+h+pNBr5N+Gv/BSr4SeNmit9Zmv/AAbfP8pXVIfMty3+zLFu493Cfyr6f8PeJNJ8WaXFqWiarZ6xp0wzHd2Fwk8T/R0JB/CvRp1qdXWDubxnGWzNMU1hinZxS1sWef8A/Cth4T8SXfiDwh5eny38nm6pox+Wzv3PBmAH+qn/AOmijD9HB+V07m3m+0QpIY3j3DJSQYYH0NSgVT1jV7Lw/pd3qWpXcNhp9pE01xdXEgSOKNRlmZjwAAM5NTZRQtEfnT+3l+w/DocGp/E7wBaxwWCBrrWtFjG1IR1a4hHZepZB0+8OMgfOP7Kf7Vmvfs1eLN6ebqfhK+kX+09H39e3mxZOFlUfgwGD0BXuP21P2073496pN4Y8MTTWHw/s5ehBSTVHU8SyjqIwRlIz6Bm+bAXV/Yj/AGI7n4zX1t408aWstr4Gt5N1vatlH1V1P3QeCIQRgsPvYwD1I+Vlapir4Tc81+9U/dn6oeFfElj4y8M6Tr+lytNpmq2kN9ayMhQtFIgdCVPIyrA4NFXNPsbfTbKCzs4I7W0t41ihghQIkaKMKqqOAAAAAO1FfWK9tT0kWaxPGPg/RvH/AIav/D/iDT4dU0i/iMNxazrlXU/qCDghhgggEEEVtUUNJ6Me5+L/AO11+yJrP7NniT7Xaedqnge/lIsNTZctC2CfImxwHAHDdHAJGCGC+5fsLft0nw2bD4c/EXUM6OSsGka7cv8A8enZYJ2P/LL+65+50Py4Kfop408GaN8QvC+o+HvENhFqej6hEYbi2mzhlPcEcgggEEcggEEEV+Mn7W/7Nc37NfxEXS4dSh1PRNRRrnTZWlQ3Kx5wUmjHIK8DfgK2MjByq/N4ijPA1PbUdjgnF0XzxP2zUjqDkHvVHXNf0zw1p8l/q2o2ul2MXMl1eTLFGn1ZiAK/G/wh+3n8XfA/wxt/BWlaxbLb2o8u21W5t/OvoIcACFXclNo7ZUsAcA4AA8W8YePvEvxC1JtQ8Ta9qWv3pJxNqFy0zL7LuOFHsMAYreWbQUVyRuy3iFbRH7AeOP2+/gl4JZ4j4uXXbpCR5OiQPdZ+kgAj/wDH68L8Vf8ABWnQLdmXw38P9S1Be0mq30doR9VRZf518D+FPgz4+8dLG/h/wXr2sRPyJrPTpZIse7hdo/E16roP7APx215VdfBTWER/5aX2oW0OOnVTIX7+nY9+K5HjcZV/hx/Ay9rVlsj0zXv+CqnxN1Dcml+HfDOmRN3lhnnkHHr5qr6/w18peN/iFqPjvxjN4nubax0rU5nWVv7HtltIxIv/AC0CrwGJGSRyTz1r6Z07/glx8Yb5A0174X08kZ23OoSkjnp+7hcf/W/Kuqs/+CTfjeSMm68baBA+eFhhnkGPqQtc86ONrfEmyXGrLdHhOrftv/HDW7O6tbvx9dvb3UTQyxx2lrFlGXaQNsQxx3GD+NeGCvvmz/4JKeIZA32r4h6ZCf4fJ06STP1y64/Wn3f/AAST19Iwbb4i6dNJnlZdMkjGPqJG/l+NKWDxlT4k2S6VWW58ual+1Z8VdX+GY+H954tln8JfZI7H7C1pb7vIj27E80R+ZgbVH3s4GCSOK8m7+lfdN5/wSb8bRwbrXxvoM039yaGeNT9SAx/SuY1D/glp8YLKHfDqXhW/fBPl299OG9vvwKMn6/Ws54XFy1kmxSp1HuY3gn9v3xH4Q/Z/n+GDeHre6UaTcaVaayt20c0CybwrFNjBiivgAEfdHNfK2K+h/EX/AAT/APjp4d3sfBZ1KBePN02/t5sn2XzA/wD47Xl3ij4I/ELwTlte8Ea/pUfTzbnTZVjP0fG0/nWdZYiSSqJ6eRMlN6SOw/Y38W/8IX+078PNQLbI5dTWwc54xcK0HPt+9z+Ga/Z7x38QPD3wy8M3fiHxPq1vo2kWq5kubhsAnsigcsx7KoJPYV/P3+P+fWtvWvHPiPxFpGn6Xq2v6nqmmaeSbOzvbuSWK2yACI0ZiE6DgV04TG/VYOHLc0p1vZpqx9g/tCf8FMvFPjKa50j4bRN4T0U5Q6pMqtqE46ZXqsIPtluM7h0r5+8H/s8fGH46Xz6tpvhbXNckvm819Y1ImKOYnqxuJyoc++4n616/+yx+018FvhX9kj8U/CaGPVo8Z8SWzfb5N39/ypzmIcdY2zz09f0v+F/x08B/GSxFz4P8T2GsMo3SWqOUuIx/twvh1+pGK66VJY13q1bvsaRj7XWUj8+vBP8AwSj8cap5cnijxbo2gRNhjFYxyXsqj0IPlrn6M31r3Twt/wAEsfhdpKo+s6v4h16cfeBuI7eI/wDAUTcP++6+zgaD2r1YYDDw+zf1OlUYLofmj+2/8GPhP+zLpXw6k8MeD7ddQu9aF3ci7uZrr7Va24UyQssrsu12kjBwB0x0yD94eEPhP8N7PS7K+8PeDPDdpZ3MKTQTWmlQR70YBlbITJyMHmvzn/4KneMDrPx00TQY5d0Gi6OjOn92aaRnb/xxYa+1P2DviAfiF+zD4Rklk8y80iNtHn/2TAdsY/79eUfxrlw8ofWp00lpt8jODj7RxPe7Wxt7GNkt7eK3QncViQKM9M4H0Fc78O/iFpXxK0vUb7Sm3R2GqXmkzDIP723neJiCOzBQw9mFO+KPjKP4d/DfxN4nmK7NI024vQG6MyRsyr+JAH418P8A/BKP4lS6hH4+8IX1w0tw08euQ+Ycs5ceXOx98rD/AN9V3zqxhVjS73N5TtJRP0I2j0pGUelLS11mhz2qfD/wxrSldQ8OaRfKRtIubGKQY645XpXA69+yT8G/Ee83nw48PozdWs7NbUn8Ytp7fzr16jFRKnCXxIlxT6Hyz4i/4Jr/AAP1uN1tNI1TQWb+PT9UlYjpyPOMg/TvXGab/wAE4bz4c6k2p/DL4weIfCd8DuAngWVZcdFk8to1YZ7MpHtX2xj3pa53hKDd1H7tCPZw7Hk3wzuPi9oDRab4/s9C8TQ5CR694fnMExH96e2lVVHuYnPslesLxRVTVtUtND0661HULqGysbWNpp7i4cJHEijLMzHgAAEkmumK5FuabC6tqlnoem3Oo6hdQ2VjaxtNPc3DhI4kUZZmY8AAAkk1+S/7bH7al38dtSn8J+FZpbPwBaS/M/KSarIp4kcdRGDyqHngMwzgIftr/trXnx01Kfwn4UnmsvANrLhn5STVZFPEjjqIweVQ+gZhnASx+xL+xLdfG7ULfxh4vt5rTwFbSZigbKSas6nlFPVYgRhnHU5VTncU+fxOJnip+wobdTiqVHUfJAX9iX9ie6+Nmo23jHxfbyWfgO1l3QwMCr6tIp5RfSIEYZ+pwVXncU/WHT7G302yt7OzgjtbS3jWKGCFAiRoowqqo4AAGAB0pNM0210nT7exsbeKzs7aNYYbeBAkcSKMKqqBgAAAACrXSvXwuFjho2W5006apqyFooorsNRKRj8tKa5v4geHNR8XeF7vRtN1ufw7JejyZ9Ss0BuYoT9/ySeEkI4DkHbnIBIFTJtK6A+QP2sf29rnwvrtz8PPhPB/bXi0uba51SGL7QttL0MUEYB82UHqcFVxjDHO35x8C/sC/Gz436tJ4g8XyHw79ufzZ9Q8STtJezZ6t5Iy272kKcD6Z/Sn4Sfs+eAPgjYC38JeHbWxuGXbLqEi+bdzeu+ZssQTn5chRngCvRhXmSwcq75q8vktjndJzd5s+Mvhz/wS3+GvhoQzeKdT1Xxhcr9+Iv8AYrVv+ARkyD/v5X0b4K/Z8+G3w7EZ8O+B9D0yaPhblLJGn/GVgXP4mvQc+9LXZTw9Gn8MUaRhGOyEUdeKdRRXSaBRSUjN0NAC5pM14t8av2vvhl8Clnt9e15b3WowT/YulAXF3nHRlB2x/wDbQrXwh8YP+CnvxA8YyT2fgqxtvBWmNlRcMBdXrjpnew2JkdghIOcNXBWxtGhu7sxnVhDdn6ka54i0rwzp73+salaaVYx/fur2dYY1+rMQB+deAePf+Cg3wU8CtJEniaTxHdJ1h0G3a4B+kp2xH8Hr8gvFfjbxB471JtR8R63qGu3zZ/0jULl5nGewLE4HsOOKxlVpGVVXczHAAHJPpXj1M2nLSnE5XiX0R+jni7/grVYxM8fhf4fXFwOi3Gr36w4+scavn/vsV5Lrf/BUj4uakz/YtN8M6VGeE8qylkdefV5SCfwH9a+cvD/wP+IvipUfRvAniTUonGVmtdKnePGMg7wuP1r0jQ/2C/jrryq8PgK4toycb729trcr152vIGx9Af5VyvEYyttf5Iz56stjlPiJ+0v45+KjTHxJLod+0uN0reHdPEw6ZxN5HmDPs1eWV9Y6f/wTJ+NN8gaaHQbAlQdtxqOTz2+RW6f5JrYt/wDglb8XJoVd9b8IQMescl9c5H/fNsR+tYSw2JnrKLIdOpLdHxtVnTdUu9Fvob6wu5rG8gbfFc20rRyRn1VgQQfcV9U+Jv8Agm7498H2rXGs+Nvh9pqKu4G91iaDI6Zy9uo/WvG/FnwJfwnCZD4/8CavjgrpOurcN1x2QfmO1YyoVaerViXCUT2j4L/8FJviV8O/s9j4o8vx3o8eF/09vKvVA9JwDu7/AOsDE+or77+B/wC2Z8M/jssFtpWsjSdfkwP7E1fbBcM3pHztl7/cJOOoFfinc272spjcoWH/ADzkWQfmpIqNWKsCpKsOQQcGuyjmFajo3deZrCvKPmevfteeLv8AhOP2lviHqav5ka6pJZRt2KW4ECkexEQ/Ovq3/gk18Qdl5458DzS53pFrNrHnuCIpz+O63/Kvz1kkeaR5JHMkjkszscliTyTXuX7EfxA/4V3+014KvJJNlpqF1/ZNwOgK3AMa5PYCQxt/wGssNW5cSqnd/mRTl+8Uj9AP+CmHjweFP2b59Hjl23XiLUILEKpw3lIfOdvp+6VT/v4718HfsF/ED/hX37T3hJ3k8qz1h30a4GcbhOMRD/v6IT+Fex/8FWvHv9rfE3wn4Sil3R6Ppz3koXoJbhwMH3CQqR/v18R6TqdzouqWeo2Uhhu7SZLiCReqSIQyn8CAa6cZXf1vmX2bGlWf72/Y/bv9qj44x/AD4Xw+IyR9ol1Wys4kI3b1aZXmGP8Arik344r16GRZ4VkjYOjgMrKcgg9CDX5a/wDBSD46W3xMtvhfpmlyf6DNoyeI5o1bIDXKgRK3+0io/H/TSvur9j7x5/wsT9mvwHqzSGW4j09bC4ZjljJbkwMze7eXu/4FXuUcSqteVNbJL/gnZGpzTaPZM0V89/tw/HC7+BPwbh1bSpfL1q81W0t7TDYPyyCaTI7qUiZD/vj1r3Hwv4gs/FnhzS9b0+TzdP1K1ivLeT+9HIgdD+RFdqqRc3Bbo15lexp0dKKqanqVrpOn3N9fXEVpZ20bTTXE7hI4kUZZmYnAAAJJNabK7KF1LUbXSdPub6+uIrOyto2mmuLhwkcaKMszMeAAASSa/Jr9tz9tS6+OGqT+EvCNzNa+ALST55RlH1WRTxI/cRAjKocHIDMM4CSfts/ttXXxu1Cfwf4QuJrTwFbSYlnXKSaq6nh2HVYgRlUPU4ZhnaFg/Yn/AGKbz46alB4s8WQTWXgG1lyqcpJqsinmND1EYPDOPQqpzkp87icTPFT9hQ27nDUqOo+SBN+xL+xNdfHC+g8YeLreW08A2sv7qE5R9WdTgop6iIEYZxyTlVOclP1h0zTbXSdPt7Gxt4rSzto1hht4UCRxIowqqoGAAAAAKTSdLs9E02107T7WGysbWNYYLe3QJHEijCqqjgAAAACrlethcLHDRstzpp01TVkLRSUtdpqFFFFABRRRQAUUUUAFFFFABSUjV8r/ALW37cOjfAVZfDXhuOHxD4/lAAtcloLDcPlabByWOciMEE9SVBG7GrVhRjzTZMpKKuz2z4wfHDwd8C/Dba14v1ePT4WyLe2X57i6cD7kUY5Y8j2GQSQOa/MT9oL/AIKIePvixLdaZ4Ymk8E+GGJVY7KQi9nT/ppOMFc/3Y8YzglutbPgv9i/42ftUeIm8Y/ELUJvD9vfkO+oa2ha6dOwhtRt2KM8K3lqB0r7Q+EH7A/wl+E6Q3Mmif8ACWazHydQ18CcBuuUhwI1wenylhj71eRN4rF6RXJE5X7SrotEfld8Mf2e/iR8arjd4U8K6jq0LOS+oOoitg2eczyEIT7ZJ9jX1d8O/wDglB4j1Dyp/GvjGx0eLq1npEDXUpH90yOUVT7gOP6fpbbwx20KRRRpFFGoVEQYCgDAAHYVLWlPLKMdZ6lRw8VvqfLXgf8A4Jv/AAW8I+W99pOoeKblOfN1m9Yrn/rnF5aEezA1754P+F/hDwBCE8NeF9H0IKMbtPsY4WP1Krk/U11DZrwP9oT9tD4f/s+LNZX142u+KAuV0LTWDSqccGV/uxDpwfmwchTXdyUMOuayRtaEFex722Bz0rxj4tftf/Cn4M+fb674pt7rVYcg6TpX+lXW4Z+RlTiM/wC+y/rX5ofHD9vT4ofGdbixi1H/AIRLw/Llf7M0V2jZ1PaWfh34OCBtU/3a+cK8itmqWlFfecssSlpFH3t8Tv8Agq14g1BprbwF4TtNHgJKrfay5uJiOzCJCqofYs4r5k8c/tZ/F/4iKya1491gwN963sZRZxEejJCFDD65rzjw54V1vxhqAsdB0fUNbviMi1022e4lP/AUBNe6eDP2Avjd4zEbjwj/AGLbP/y31m6jt8f70eTKP++K8t1cXiNrv0OfmqVD56nuJbqZ5ppHllc5Z5GLMT7k0yvvTwz/AMEl/FF4oPiHx9pOmN3XTbKW8/VzF/KvSNG/4JN+Cocf2r42169PGfscUFuDzz95ZMdv8mqjl+Jn0D2FR9D8w6K/WO1/4JZ/CCGELJqPiq4bP+skv4Q3/jsAH6UXP/BLX4PzQsiah4qt2PSSO/hLD6boCP0rT+y8R5FfV5n5OU+3uJbWeOeGRoZomDpJG21kYHIYEdCDzX6hal/wSf8Ah7Nn+zvF/ia2OR/x9G3m+udsSVwPiT/gknfxRs/h/wCI1vcv2g1LTDEPxdJH/wDQah5diY6pCdCofDXxA+IGv/FDxTc+I/E1+2p6zcpFHNdMqqXEcaxrwoAHyoM8cnJPWudr6f8AGn/BOH42eEMva6Pp/iiBRky6NfK2P+ATCNyfZQa8C8YfDvxP8Pb77J4o8O6poFwchY9QtXgLnHVSwww75GRxXHUo1YO9SLMpRmviRi3moXOoNG1zPJOYolhTzGJ2oowqj2A7V+lv/BKHx4dS8A+MvCE0u6TS7+PUIFY8+XOhVgvsGhz9Xr8yq+p/+Cbfj7/hDf2lLLTZpPLtPENjcac5Y4UOF86M/XMW0f79dGBqezrxbNKMuWaZ33/BVb4jf2z8TvDPg23l3QaHYNeXCqePPnIwpHqI40P0kNfTX/BN74l/8J5+zjY6XPL5l/4ZuZNMfccsYuJIT9Ar7B/1zNfmH+0J8RD8WPjZ4y8VrIZbfUNRkNq3f7On7uH8o0SvoT/gmP8AFi28C/F7XPD2p3sVlpWu6Y8pkmcJGk1sGlDFiQABEbgk+wrto4r/AGxzez0NI1P3zZ+rGoX1vptlPd3c8draW6NLLPM4RI0UZZmY8AAAkk1+Tn7bX7bVz8btQn8IeELiaz8A20mJZxlJNWdTw7DqsQPKoepAZhnaEn/bc/bcufjNfXPgzwZcy2ngW3k23F0uUk1V1PUjqIQRlVPLY3N2Vc79iX9i65+PGrR+KvFME9l4As5PlHKPqsinmKM8ERg8PIPTavzZK74nEzxU/q9DbqzSpUdR+zgO/Yp/YpvPjpqUHizxZBNZeAbWX5U5STVZFPMaHqIweGcehVTnJT9Z9J0u00TTbXTtPtYbKxtYlhgt7dAkcSKMKqqOAAAAAKXStLs9F02107T7WGysbWJYYLa3QJHEijCqqjgAAAACrdethcLDDRstzpp01TWgtFJS12moUUUUAFFFFABRRRQAUUUUAFI1LRQB5N8YtW8d6+p8I/DeOLT9UuF23/im+XNtpEZ/uLjM1wR91BwuQzlQV3YHwP8A2O/AfwWuv7ZW3k8UeMpXM0/iPWsTXLSsSWeMHIjJJPI+Y55Y17ue1J71g6UZS55asnlTd2C96dSClrcoQ1na/r2m+F9Hu9V1e/t9M0y0jMtxd3UgjiiQdSzHgCsn4lfEjw98J/CF94m8T6jHpuk2a5eR+Wdj91EUcs7HgKOTX4+/tUftfeJf2ktce33TaP4LtZN1loqP9/HSWcj78np/Cv8AD3ZvPxWLhhl59jGpVVNeZ7h+1J/wUk1PxQ954a+Fcs2j6PkxzeImBju7gdD5AP8AqV/2j85GMbDXwwFutWvgFE17e3Mn+1JJLIx/NmJ/E5r6a/Zx/YE8dfHGO11nVgfB/hKTDrfXkRNxdL/0xhyCQR/GxC85G7kV+lHwR/ZV+HXwDtUPhrQ0k1bbtk1rUMTXsnr8+AEB7qgUHHSvFjh8Rjnz1HZf10OT2c6rvLY/Nz4O/wDBOf4p/E5Yb3WLaPwNo8gDedrCn7Uyn+7bj5gfaQpxX2Z8Lf8Agmr8KfAvk3OvRXnjbUkwxfU5PKtg3tBGQMezl+tfWi0texRwFClra78zqjRhEyvDfhXRfCGmpp+haRY6LYJ9210+2SCJfoqACtakpa9FJJWRuFN3Ddgnk9KGrwPxF8WvsP7aXg7wJ5v7m48K30xjz1mkmR1+pCWb8dg59aic1C1+ugm7Hvo9KTpR3obpVjEV1LFQRuABI706vlD4T/H4eKv25Pin4Oa536fDplvaWSs3/LWzY+coHTJe5n/COvq7dWdOoqibj0JjLm2Bq+Dv+CpWt65q3h/wd4L0XStQ1FJriTVb1rO1eUKEHlwqSoPUvKcf7C195H0oIBHIqK9L21N072uKceaPKfz9/wDCt/Fv/Qr61/4L5v8A4mrek+D/ABzoOpW2o6f4f120vbZxJFNHYShkYdx8tfvxgd6r6hfW2l2c95eTxWtpbxtLLPM4RI0UZLMx4AABJJ9K8X+yYrXnOX6sl1P5/wC58A+KLO3luJ/DerwwRKXklksJVVVAySSV4A65PoawlYrkgkHpwevtmvsL9tz9tq4+M19c+DPBdzJa+Brd9txdLlH1V1PUjgiEEAhT97GT2Ayv2K/2LL3496pD4o8TQzWHw/s5cdSkmqOp5iiPURg8PIPQqvzZK+Q6CnV9lRd/M5eTmlaGofsWfsWX3x71SHxR4nimsfAFnL7pJqjqeYozwRGCMO49CqnOSv62aPo9loOl2mmabaQ2Gn2kSwQWtugSOKNRhVVQMAADoKNH0ey0HS7TTNNtIbDT7SJYbe1t4wkcUajCqqjgAAdKu/dr6zC4WOGjZbno06aprQKWkpa7TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKAENY3i7xZpPgXwzqPiDXb6LTtI0+Fp7m5mOFRR/Mk4AA5JIA5NbDV+cP7Vnj7xZ+2F8Z4/gx8Mx9p8O6NPnVL4MVtpJ1bDyyuP+WUR+UDqz7sBvkrlxFb2MLpXfRGc5cqPA/j98bvG37anxXg03w9pd/daVC7Jovh+1UuwQdZ5McbyOSx4UcZ4yfH/AAH4qvPhH8SNN1q40S1v7zRbzdNpOsWu6NmUlWR0YHawOcHGVIB6iv2X/Zt/Zh8K/s2+FvsOkRC+1y4Rf7R1yeMCe6Yc4HXZGD0QH6knmvFP25v2Jo/i9ZXPjrwVaLF42t0zd2UeFXVY1H5CYAcH+IDB7EeFWwNZx9te8tzjlRnbn+0fRfwJ+OPhv4/eA7XxN4cn+Vv3d3YyMDNZzAfNHIB+YPRgQRXon8q/Cj4D/HTxT+zX8RF1rSBICrfZ9T0e5LIl1GG+aKQfwsCDhsZUk9QSD+znwW+Mvhv47eA7LxR4auxNazDZPbOR51pMAC0Mq9mGR7EEEZBBr1MHi1iI8stJI6KVVTVnud3S01qq2Gq2epSXaWl1FcvaTG3uFicN5UgVWKNjoQGU49xXpnQW2qidXs11hNLNyn9oPAbkW+fnMSsFLY9NzAVdavgu7/aGH/DzS20tbkf2NHY/8IiTu+UyMvnnj+99p2x/8BFc9asqXLfq7ESly28z70b+tflj42+LX/Gzux1lZv8ARLHX7XQFO7iNTGtrKP8AvuSUn6mv1E1TUYNH0u7v7p/KtbWF55XP8KqCzH8ADX4Aat4xvtV8dXviovs1K51J9ULekrSmXP8A30a8zMqvs/Zpd7/cc+Ily8p/QUKxfG3ii18EeD9c8Q3xxZaTYzX03+5Ehdvxwpq14e1iHxDoOnarbc299bR3Uf8AuugYfoRXzT/wUi+IX/CF/s06hp0Umy88RXcOmR46hMmWQ49CsRU/74r061RU6TqeR0SlaPMfnT+zP8Vbrw3+1T4U8X6lcfvdQ1plv5ieCLtmjlY+w80t/wABr9ud1fzuJI0bK6MVdeQynkEf16V+3v8Aw0FZab+yrB8WLpkdRoEd+YycB7pkCiHjuZyE+prxMrrWjOMumpyYee9zX8BfHrRPH3xg8feAbIr9t8K/Z98m7IuC6nzdo/6ZvtQ+5r1Fa/FX9kf423ngH9qDRfE+rXrPFrt5JZ6vPIf9Yt0/zSMfQSlJD/umv2juruDT7Oa6uZo7a2hQySzSuFRFAyWZjwAAMkn0r08HifrEHJ9DelU51cW9vILG1murmaO2toUMks0zBURAMlmJ4AAGcn0r8o/23v23Ln4zX1z4L8GXMlt4Gt5NtxdLlX1Z1PU+kII+Vf4sAnsBL+29+29P8X7u58E+CLqS28EQvtur1co+qup/MQgjhT944J7Ac7+xd+xfqH7QGsReI/EUU2n/AA/s5cPJykmpOp5ii9F4wzjpyFOclfMxWJniZfV6G3cwqVHUfJAP2L/2MdQ+P2sReI/EUU1j4As5fnk5WTUnU8xRHqEzw8g6fdHzZK/rno2j2Wg6XaabptpDYafaRrBb2tugSOKNRhVVRwAAOlN0LQ7Dw3o9npWl2cOn6dZxLBb2tugSOKNRhVUDoAKv162FwscNCy37nRTpqmgpaKK7TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiikNAHkf7SXiTxNB4St/CXgRC3jbxS72NjcBiq2EIA+0Xrtj5ViVgAeu+SMAEkA2v2ef2ffDf7OvgWPQdDX7TdzETajqkqgTXs+MFm67VHIVASFHqSzH0ddNtl1J78Qr9seJYTN32AkhfYZYnirKisfZrn9o9/yI5deZjqa1OFFbFnw9+3V+w+vxHt7z4g+AbFU8VxKZdS0uFcf2moHMiAf8tgByP4x/tfe+EP2d/wBobxL+zb48XWtIJnspSIdT0eZisV3ED90/3HXkqwHBJ6gkH9z27V8G/t4fsP8A/CYR6h8SPh/Y/wDE+VTNq+i2yf8AH8By08Sj/lr3ZR9/GR8+d/hYzCSjL29DRo46tJ354bn1P4W/aC8HeNPg5d/ErS9SWbw/Z2Ut3dA4E1sYkLyQyL/DIBxjvkEZBBPwx/wT3/aavr748eKtA8R3HyeOrubVISz/ACxX43OVXPADx5X6xxgV8XaD8QvEfhXw54h8P6ZqtxZaPr8UcGpWan5J1Rw65GOCCMZHOGK5wSKy/D+u33hfXNP1jS7hrTUdPuI7q2uE+9HIjBlb8CBXnzzGUpwk18O5i67bT7H7/wDjDxNaeC/CWteINQO2x0uymvpz0+SNC7foK/BRvHmrN8RD40M+ddOqf2wZif8Al487zd2ev36/SH9rf9pix8Y/sOaVrukv5Fz44aGweBG+a3KMWuk9wGhaInuHB71+XZ/CrzKvzzjGL0Wo8RJNpI/aj9p74qWtv+xz4p8XafJtt9a0GNLRs84vVSNSPcCbP4Zr8V6+r/iB8cf+Ei/4J/8AgLwkbgtqVv4gm0+cM3LW9shlQY9ALm3A/wByvlD+tcuOr+2nFrsjOtPmaZ+337Gvir/hMf2X/h1fltzRaWtgxPXNuzW5z7/uq+J/+CrHxCGr/Ezwr4Phl3Q6NYNezKp6TXDYAYeoSJD/ANtK93/4Ja+KjrH7P+p6O75l0fWpo1T0ikSORT+LGT8q9E+Jv7DHww+LnjjU/FviSDVrnWNQKGZ4tQZEwiKihVA4AVRxXtzjPFYSMae7sdbTqU0on4vV7R4g/aGvNW/ZZ8LfCeNpFXTtYubu6fs9vkPAue48yackdvLSv0ds/wDgm38DbeLZJoOo3LZz5kuqzhv/AB1gP0p11/wTt+AllbSz3Hh65gt4lMkkkmsXKqigZJJMnAA6150cuxEE7NK5gqE0rJn48d+ODX018fP25PFfxm+Gvh3wXB5ulafBYQR63N5n7zVLlVAYsR0i3Ddt7k89ABw37S198KV8aNpPwm0SS00SwZo5tYmvJpzfPnkxq7ELGMcHGWznpiu//Yz/AGM9R/aG1qPXtejm07wBZS4mnGUfUHB5hhP93szjpyB83I4KUavO6NJ79jCKndwiyf8AYv8A2L9Q/aA1eLxH4iim0/wBZy4eTlJNSdTzFF6IMYZx05CnOSv646Dodh4b0ez0rS7OHT9Os4lgt7W3QJHEijAVQOgApvh/QdN8L6LZaRpFlDp2mWUSwW9rboEjjRRgKAK0a+rwuFjhoWW56dOmqaClooruNQooooAKKKKACiiigAooooAKKKKACiiigChrGtadoNp9q1O/tdOtQdpmu5liTJ6DcxArE/4Wp4L/AOhu0H/wZQ//ABVYfxt+Ecfxa8PwWy3sljf2bNJavkmJmIAKyL3BA4PVfcZB+HPFnhPVPBOuXGk6vata3kJ+63RlPRlPdT6j37ivGxmMq4WWkLx7nRTpqfU+/wD/AIWp4L/6G7Qf/BlD/wDFUf8AC1fBf/Q3aF/4Mof/AIqvzporzf7Yn/Ka/V13P0n0bxdofiWSVNI1nT9UeIAyLZXSTFAehIUnH41rjp7V8yfszfBfxH4Z8QR+KNXjGmWslq8cdpIT577sYLL/AAjjODz04r6bX+VfQYarOtT5qkbM5ZRUXZAaOKG7V8dftLfCnxRa+JtT8VyM2q6LMwImVyWtFyAqMvUKCeCoI9cE8rFV5YeHPGNwhFSdmz7FyKSvzB9K9D+GXwc8YePJItR0OBrG0jkwNTkl8pFYHnYQdzEZ/hHUEcV5NPNpVZKMKd36/wDAN3Q5Vds+/OKG7VHao0dvGjsZHVQC56sQOtS/hX0C2ucp+Nn7aHgHU9W/aH8Z6j4a8Aaxp+gi78o3UGmTiC6nVQJpgdu35pA/K8MAG6sSfmvn9f8AP4V/RIyivzq/bx/YdMf9o/Ev4d2BYEtca1olumcd2uYVHbqXQDvuHevmsXl8o3qw18jz6tFr3kfDdra+M/E3hGw0m1sNW1Pw9Z3U9zbRW9rJJDHNKsaykFR1IiTjPB7ZJzkTeFtagleOXSL+OVSQyPauCCOxGOK9j/ZP/ar1r9mvxeHPnan4PvpANT0kP17edFngSqPwYDaSOCv7JeCfGmi/ETwvp3iLw9fw6lo+oRCWC4hOQQeoI6qwOQVOCCCDyK5sNhIYpfHZroRTpxqLfU/As6HrbQrCdP1AwqzOsZhfaGIAJAxjJCrk98D0qNvDer4/5Bd7/wCA7/4V/QrtA7fpRxXd/ZC/n/A1+q+Z+cH/AASh1S+0jxR4/wDD95bXECXlpbX8QmjZRmJ3RsEjv5y5+gr9H19KXA7VHcTR28byyMI40BZmY4AA6kmvYw9H6vTVO97HVCPs42EuriK1geaaRYoo1LPI7YVQBkknsMV+W37cf7cknxNnvfAXgK8aPwhExj1DVITg6oR1RD2g/wDQ/wDd+9J+3T+2+/xJuLzwB4Bv2TwnGTFqWqW7YOpMDzGh/wCeI9f4/wDd+9wH7GP7G9/+0Rrw1vXUn0/wDYS4nuFyj38gPMER7D+846dBycjyMViZ4if1eh82c1So5v2cB37Gf7GepftC61Hr2vRzaf4AspcTT8pJqDqeYYj6dmcdOg+blf128PaBp3hfRbLSNIsodO0yyiWC3tbdAkcaKMBQBS+H9A03wvotlpGkWUOnaZZRLBb2tugSOJFGAoA9q0K9TC4WOGjZbnRTpqmgpaKK7TUKKKKACiiigAooooAKKKKACiiigAooooAKKKKAEPavK/2hvhzbeOvAF/cR2wfWNMia5tJEQmTCjc8YxydygjHrg9q9UprLuGDyD1rGrTjWg4S2ZUZcruj8wq0vDGrJoPiTSdTki8+Oyu4rlov74RwxX8cV0Pxi8FnwH8RNY0tY9lr5pntcLtHkv8ygfTJX6qelcZx1NfnsoulUs90eoveWh+nFjeQ6hZwXUDiSGZFkRx0ZSMg/kasV45+yx4xPib4ZQ2Uz77vR5DZtnHMf3ozgdgp2/wDADXsdfoNCoq1OM11PLkuV2EPUV55+0Bqsej/B/wASyyAt5lv9nVR/ekYID+G7P4V6G1fOP7Zfib7N4f0PQY3YSXdw11LtbA2RjaAw7gl8+mUz2FY4yoqVCcn2Kpq8kfLOk6XNrerWWnWoBuLudLeINwCzsFGfxIr9IPDOg2vhfw/YaTZJ5drZQrDGPYDqfc9T9a+OP2VPCreIPihFqEiE22kwtck448xgUQH/AL6Zv+AV9te1eXlFHlhKq+ptiJa8pna54k0nw3DFLq2qWelxSNtR7y4SFXOOgLEZNZH/AAtTwX/0N2hf+DKH/wCKrn/jH8FbD4uWtmZ72bT7+yVxbzRqHT5sZDKeoyo6EV8MeINHl8Pa9qWlTsrz2NzJayMucFkYqSPbIrfGY2rhZfDdMmnTVTqfoMfip4L/AOhu0L/wZQ//ABVa2i+JNJ8SQySaTqlnqkUbbXeyuEmVDjoSpOK/OPw/o8viHXtN0qBlSe+uY7WNmzgM7BQT7ZNfc3wd+Cmn/CK1u2hvZtQv7xUW4mcBE+XOAijoMk9SaMHjKuKl8Pu9xVKah11Ph39vD9h3/hHTqHxK+HungaT80+s6LbqR9lPVriFR/wAs+7IPu9R8udniP7G37U3iH9n3xcLEW13rng3UpVF/pUCmR4mOAJ4AOkg6EdHAAPIUr+jH7Q/7QE3gy4fw14fMZ1Vo83V0wDfZtwGFCkYLFTnnpkcHPHx3Db2umwOIYILKAEuyxIsSL3JIAAH8q8jGVKdDEc1B69fU544Pmlzp2P0n8N+OvD/i6zhutI1i0vopVVgsco3rkA4ZD8ytgjKsAR3Fauo6ha6TYz3l5cR2tpChklmlYKqKOSST0r8mJPjD4OjuDCdch3A44jcr/wB9BcfrXoLeJdVvNFt7Y6peT6RNGksMJuXaCSP+BlXO0j0I9OK6o5w+X3oanVGnGWkZH6SWup2t/p8V9bXMU9nLGJY7iNwUZCMhgemMd6/MX9ub9uZ/iJLffD/4f3zR+FkJi1LVoWw2pEHmOM/88c8E/wAf+797A/aG/aD8aaF8H9M+H2nXn2LQr6WYXd1ExE8sXykW+f4YyWYnH3gdvAyG8v8AgH+zhd/ETSb/AMa6/HJYeBdLfY0vKPqVxn5baE+mcb3H3RnvU4jHyxEFCnppqebW5+f2MNy9+yj+zXZfGbxNHqHi/W7Pwz4Ks2Dzy3d2lvNfkEjyoQxBxkHc/RcYHPT9a/DfjL4ceEdBsdG0bxB4c03SrKJYLe1t9QgVI0HQAbv/AK5718WfDH4O678SGe20C0t7exs1WNriU+VbxcYVBtB7fwqDj24r0SX9jvxpHGzDUNDcqM7VnmyfYfuutZ4SrWpQcqdK/mdsMPTpaN6n1F/wtTwX/wBDdoX/AIMof/iqP+FqeC/+hu0H/wAGUP8A8VX501teC/CN9478TWOhaaYlvbwsEaZtqDapYknB7KegzxWizepJ8qhqdHsI9z77/wCFqeC/+hv0LP8A2Eof/iq29I1zTvEFr9q0zULXUbbOBNaTLKmfTKkivkC6/Y/8b28LOt3o1yQMiOK5lBPsN0YH5muV8C+I9e+A/wASIk1KCew2usWo2UhyJYT/ABcZDEA7lYZ6YzyRXX9frU5JVqdk+pHs4te6z75oqOCVJo1kjbcjgMrDoQRUle6tVc5hGrK1DxRo+k3sNnfatY2d5N/qre4uUSR/opIJ/D1pPFuvxeFfDWqaxOpeKxtpLgqOrbVJCj3JwPxr84NW1a71zUrnUL+4kury5kMks0nJZjzn0/Dt0HavLxuN+q2SV2zanT9ofpnGyyKGUhlIyCDkGnYzXy7+xz43laXVvC1zMzIEF7aIxJ2c4lUc8ZLI2B/tHvX1COK68NiFiKaqIiceV2HUUlLXUQFFFFABRRRQAUUUUAFIaWigD5s/bG8Em60nSfFNvGPMtG+yXTBefLY5jJOeituHQ8yCvlKv0i8deFoPGnhHVdEuANl5A0aswzsfqj/VWCsPpX5x31nPpt9cWlzEYbm3kaKWNuqOpwV/Aivjs2o+zqqotmd9CV48p65+yz40Hhf4lR6fPL5dnrEf2UhiAvnA5iOfXOVA9Xr7cWvzHsb2fTb23vLaQxXNvIssUi9VdTlT+BFfo54F8UW/jTwjpWtW5BS8gWRgpztfo6/UMGH4V35PWvB0n0M8RHW5uN/+qvg79o7xYPFnxY1Zo2V7bT8afCwB/wCWed/X/poZOemPzr7S8f8AiiPwX4M1jW5Cv+hWzyIrttDyYwi5/wBpio/GvztsLO78Q61b2sbNPfX1wsStIxLPI7YGT6lj1ozao7Rox3YYdauT6H2B+yP4RGh/DubV5Y9txq85kBK4PlJlUH0zvI9mr3Oszw3osHhvw/p2lWwxBZW6W6fRVAz+lade1h6ao0owXQ5pS5m2I3Svzn+KX/JTfF3/AGGLz/0c9fow3Svzn+KX/JTfF3/YYvP/AEc9eNnHwR9ToofEHwt/5Kb4R/7DFn/6OSv0WbtX50/C3/kpvhH/ALDFn/6OSv0WPalk/wDDmFf4kfmn4k1ubxJ4g1HVZ93nXtxJcMGYtt3MTjPcDOPpXXfAWbTofi54dOqmEWTSyI32gDYWaJ1QHPHLlR9SKl+PHgG58B/ETUY3jb7BfStd2k2PlZWOSuemVJwR9D3Fed189LmoV7y1aZ16SgZv7dH7Eb/C+6uvH3gWykl8ITuZNQ06Fc/2W5P3lHXyCT/wA/7JGPmjwl8cvFng3wzH4dtLuG40aO6F1Hb3UCyGI870jcjdGrnDMqkAlQeuc/pL8K/2m5tJsU8P+NYf7Z0R4/s/2pkEkioeCsqniRcHB74B+9nFed3/APwTX8M+Pfixa+I/CniW0j+Fd4/2i5sLeRnuo3By0EJ2lQhPdzuTJG09a9OdGOK9/Dbvddv+AeFVw9SnPmgcf8D/AIJp+2Np+lXl5a3eleFbK/EmoXDIQZCikNBC/G4tuALD7ozkZwD91+OvgXonirwHo/hLTmHhzStKlja1hsoVKIigrt2/7rNznOTk55B7jwv4Y0rwX4fsdD0Owh0zSbGIQ21rbrtSNB2H8yTySSTya0+K93D4GnRp8ktb7nTd35nuYvg3wjpvgfw/baNpUHk2cA4ycs7HqzHuSa2z900UH7prv5VGPKthat6n5gV6f+zP/wAlu8N/9vP/AKTS15hXp/7M/wDyW7w3/wBvP/pNLXwOH/3iHqvzPUn8DPu9q4L4o/BzQfipZxLqKva30PEN9b48xRnlTnhh7Hp2rv6SvvpwjUXLNXR5idihoelRaDo1jp0DySQ2cEcCNM25yqqFBJ7nAq9S0jfSqSSVkI8I/a98VDSvh/aaNE6ibVbpQ6HOTFHhyR77/L/WvjivZP2pPE0nij4qyabb75otMjSzjjQZ3St8z4A5ySwX/gNQ/Hb4PD4Z6f4WubdN0c9kLe7cDg3S/M7E5/i3HA7bK+Mx3PiKs6kdo6HoU7Ril3OL+Fvi/wD4QXx9o2tMxWCCcLPjP+qYFX6dflJOPUCv0SjYOodSGUjII71+Ydfev7PPjD/hMfhZpUsknmXlkv2G4yxZt0eApJPUlChPuTXZk9bWVF+pniI/aPS6KSlr6k4wooooAKKKKACiiigAooooAa1fE37VXg0+G/iVJqMUZWz1iMXKtwB5owsgH/jrf8Dr7aNeQftReC/+Eq+GVzeRLm80d/tqHoTGBiRc+m35vqgrzMxo+2oO261NqUuWR8P19X/sdeNRd6Lqnhi4lzLZv9rtlJ/5Ztw4X2DYP/bSvk/2rtfg746Hw7+IGm6xMziyBMN2qDJMTDB474OG/wCA18ngq31evGT26ndUjzR0PoL9sbxcbDwzpHh6F2WTUJzcTBcYMceMKfqzAj/cNeWfsq+Ej4i+J0N9Iha20iFrkt28w/KgP4lm/wCAVzvx1+IFv8SPiFdanZMW06KKO2tGdCjFFBJJB6Zdn644I4r6M/ZH8IjQ/h3Lq8se251ecyAlcHykyqD6Z3kezV6kP9sx3Mtl+hg/3dOx7ktLSUtfVnEI3Svzn+KX/JTfF3/YYvP/AEc9fow3Svzn+KX/ACU3xd/2GLz/ANHPXz2cfBH1Oqh8QfC3/kpvhH/sMWf/AKOSv0YHavzn+Fv/ACU3wj/2GLP/ANHJX6MDtRk/8OQV9zm/H3gDR/iNoMmlaxBviPzRTJxJC+OHQ9j+h6EEV8WfFj4F6/8AC+4luJI2v9C3Yj1KIfKuTgLIP4Dn14JIweePvcioriGO4heKVFkjcFWRwCrAjkEHqK78VgaeKWuj7mUKjgfmJ1z6V1fw9+Jeu/DXWFvtIuSI2P7+zkJMM49GX19+o/E19D/F79lez1KG41bwai2d8o3tpR+WGX18s/wN7dPpXyjPbyWs0kM0bwzRsUeORdrKwOCCMcEHtXyVajVwVRN6dmd0ZRqKyP0E+FPxW0r4qaCL2yP2e9iwt3Yu2XgYj/x5Tg4bHOD0IIHb1+dfwz+IF98NfFlpq9mzGJWC3NuOk8JPzKffHIPYgGv0K0vUINW0+2vrWQTWtzEs0UinIZWAII/A19VgMX9ZhaXxI4qtPkehcpD900UH7pr05bMxPzAr0/8AZn/5Ld4b/wC3n/0mlrzCvT/2Z/8Akt3hv/t5/wDSaWvz/D/7xD1X5nqT+Bn3jRRRX6EeWJWf4g1iDw9oeoapdNttrKCS4lI67UUsce/FaNeI/tZeLv7A+G40uKTbc6xOsGFfa3lJh3IHUjIRSPR+fQ8+IqKlTlN9Cormdjwj4C6DP8SvjNFqd+vmJbzyavdFVO0yb9yj2BkYHB7AjkZr6c/aA8If8Jn8LNYt44vNu7NPttuAm5t0fJCjrll3L/wKvKP2erjTfhT8I9W8c6ysmy/uBHGIBveREJRVAOMEuZO4HA5rak/bI8Lurr/YerOh4+YRDI9/nrxMO6NLDONaVnPX7zpleUrx6HyJz7nmvoT9j3xl/ZvirUPDk8gEGow+fAC2P30fUAd8oSTz/wAs/wAvAbySGa8nkt4TbW7OzRwli5jXPC7iBnHTPfr3rU8F+JZvB/ivStahLb7G4SYhOrKD8y/ipI/GvAw1X6vWjNdH+B1TjzRsfpKtOqCxu4r+zguYHEkE0ayRuOjKRkH8qnr9BWqueUFFFFMAooooAKKKKACiiigAqC7to7y1lt5kEkMqFHRujKRgg1MaDSeugH5weP8AwpJ4H8Z6vochZvsc7IjN1aM8ox9yhU/jXP19K/tkeDRDfaN4ngQBZgbC5bvuALRn6ld4/AV81V+fYuj7CtKC2PVhLmimWtK02fWNUs9Ptl3XN1MkESnuzEKo/Miv0j8N6LB4b8P6dpVqMQWVulun0UAZ/SvjP9ljwmfEXxQgvXQm20mJrpjgY3n5UH1ySf8AgNfby19Dk9Llpuo+pyV5a2FopBS19CcojdK/Of4pf8lN8Xf9hi8/9HPX6G6rqlnotjLeX91DZWsQ3PNO4RFHuTX50ePtSg1jx14jv7V/MtbrUrmeJ/7yNKzKfyI/OvnM5kuSKv1OvD7lr4W/8lN8I/8AYYs//RyV+izemcV+b/gHUoNH8deHL+6fy7W11K2nmf8Auosqsx/IE/hX6LaZqtnrVjFeWF1Fe2soyk1u4dGHsRSyeSUJLqGI3TON+Hnxn8OfEvUdTsdKmdLmykIEc4CmePOPNjAJyufoRkZAyK739DX55+Nf7R+H/wAVtbaxml06+sdRleCSNtrKpYlD9CjDg9QcHrXufgL9sK3eFLXxbp0kcw4+3WABVuvLRk5Xt0Jz6Ct8PmUXJ06+jREqL3ifTGfWvif9rDQ7XR/it5ttGIzqFjFdzAdDJudCfbIjH45PevfLz9qb4e2to80Wp3N3IoyLeGzlDt7Deqr+or5R+LnxHm+KXjKfWZLf7LAsa29tATlkiUkgMfUlmJ/3sc1jmeIo1KSjFpsujCSlqcZX33+z3dXN58HPDMl0hSVYHjAII+RJHVDz6qqnPQ5yOK+GPDPhrUPF+uWmkaXAbi8uXCKozheeWY9lA6mv0V8J6BD4U8M6Xo0DGSKxt47cSMMF9qgbj7nr+Nc+T05c8p9LFV2rJGtSdjSmsfxR4r0vwfpE+patexWVrEpbdIwBYj+FR1Yn0HNfUSkoptnGfmxXp/7M/wDyW7w3/wBvP/pNLXl9d/8AAfxBYeF/i14f1HU7lbSyjeWN5n+6m+F0Un0G5hk9B1OBX5/h2liINvS6PUknyv0P0CoqG1uIry3SaCVJ4ZBuSSNgysPUEdRUpr9DPKEbtXxX+1P4ol8UfFEaRbb5otKjW1jjUZ3zPhnIxkknKLj1Tp6/UXxO+KWj/DHQ3vNQnVruRW+y2St+8nYeg9ASMnsPwFfDXhfXkuvidpGtavKixyaxDeXkzA7QDOHkY+3Wvn80rxfLRT3ep1UY7yPum3+G+j3Hw8sfCWo2ovdOgtY4GVyVLMoHz5XGGzzkY5NcTb/sn+AYbiWR7e/nV2yIpLshU4xgbQD78k9a9esbuC+t0ntp47mGQZWSJwysPUEcGpjx7V6zw9GaTlFOxz80l1Pjz9pL4J6L8OdK0nVtAjlt7WadraeKSQyfMVLIRnnor5/CvBP1r7Z/ag8TeH7X4a6jpF/er/ad0Yza2sLAy+YrqwYj+FcA5J7HA5Ir4m/lXyOZUoU61obP8D0KMnKOp9wfsueLz4o+FlrayyF7rSZGsn3AAlB80ZAHYKQv/AT9T6+tfBHwP+MD/CPXrqaW1a80u+RUuoYyBINpJV1zwSNzcHrk8ivt7wr4t0rxpo8Op6Pex3lpJ/Eh5U91YdVI9DX0OX4qNakoN+8jkqwcZX6GzS0lLXrmAUUUUAFFFFABRRRQAUUUUAYXjTwfpvjvw9c6Nq0LTWc+CdjbWVgcqynsQR9Ox4rwm4/Yt0xtQV4fE13HY4+aGS1V5T9JAwA7fw9q+kqT+dclbC0a7vUjcuM5R2OM+GPwo0L4V6bPbaQsks1wwae7uGDSy4ztBwAABk4AHc9812lFLXRCEacVGKsiW29WFIaWirEeXfGr4Jr8Xl0vOtS6S1iX4EHnI4bGfl3LhhjrnueK8u/4YoP/AEOX/lL/APt1fUVJXDUwVCtJznG7+ZpGpKKsmfLx/YnP/Q5f+Uv/AO3V6h8FfgmvwgXUyNal1V74p8vkeSiBc/w7myxz1z0A4r1GjmingqFGXPCNn8wlUlJWbPDPjH+zePiV4ys9asdQh03zQsWoB4yWdVGA6Y6vjC4JAwBzxg0bj9jTws0JFvrGsRz4+/I8Trn12hB/OvoEdaWiWBw8pOco3bD2kkrJnyLrH7GPiCGRRpev6bdxnO5rxZIGHpgKHz39K1NH/Yul86NtW8SoIv44rO2JY8dA7Nxz7H6V9TUlYLLMMne34le2n3ON+Hvwn8OfDKzaHRrMiaQYlvLgh55cDu2BgeygD2rsloFLXpQhGnHlirIybb1YjV498ZP2e1+LWu2eqDX5NKeC3+zmFrbz0IDFgQN67T8xz1zgelexUmKirShWjyTWgKTjqj5f/wCGJz/0OX/lL/8At1J/wxP/ANTl/wCUv/7dX1DSVxf2bhf5fxZr7afc4f4QfDIfCrwu+kDVZtWLztO0sieWikgDCJk7Rxnqckk+1dw2eMUtGa74QjTiox2Rle7ueA/EL9luf4geLtQ1ybxhLCLhsxwTWRmMK44RW80fKDnAwOv41zh/Yo/6nL/yl/8A26vqHvR9K4pZfh5tylHVmiqyWiZwfwd+Fa/Cbw7PpY1SXVWmnM7SPH5aLkAYVNzY6c88mu7alFGa7YwjTioxWhm227s+dPFn7Ia+JvE2p6qniyW3W8uHn8qax85kLHJG/wA1cjJ446Y+tZP/AAxP/wBTl/5S/wD7dX1DRzXDLL8NJ3cfxZoqs1omfL3/AAxOf+hy/wDKX/8Abq9E+DPwAX4S6ve6h/wkE+qPcw+QYVg8iHG4EMV3tuYYIBzxub1r12iqp4HD0pKcI2fqxOpKSs2C0tJS16BmFFFFABRRRQAUUUUAJVTVNUs9F0+4v9Qu4bCxt0Mk1zcyCOONR1ZmPAA9TVuszxB4Z0rxVYiy1nTrbVLMSJMILqMSJvU5VsHuDSd+gHi+tftSNrEz2nw08E658Q5lJQajBEbbTdwYqwFw4+YjGeBtORhvTzPxf8Rv2qF0y/1D/hE9C8LaZFG7tdNdWY+zpg/OzT3BXIHcgDjp2r7CjhSGNY40WNFGAqgAAemK+MvjZrDfHj9o+DwTLqLWXw+8Hw/bfEE7TbLZmUCSQyHO0gfJGNwyp80jivMxEZxjeU3fpbQzZxup/tKftD/BdrC88b2FvqOmXrqYpru1gMMqkbtqTWxChiuSM5PfBAxX2x8K/H1v8Uvh/ovim0tprOHUoPM+zzj5o2DFWHTkblOG6EYI618mfEj4yfD/APaW8Zaf4U1XxRZ+Gfh/ol39qeS4WRJ9VlVSiiJtuyKLa7DLNuOche4+sV8R+FPAXwzTWbS5tbfwfpliJYZrJhJD9nVfl8srndkYAxnOR3NThW1KXv3j57hHfc63nNLXkHwp/aW8O/FDwJ4i8XG3ufD+iaLcPDNNqBHKrGr7/lyM/NjaCTnHXIrvvBvjrRfHvhGz8T6NeCfRruNpY7hxswqsytuB6EFWBz0wa9CNWE1o9y7pnQ+tJnFeB+H/ANrrQfGfxe0zwX4b0e/1iwvJp7dvEC/Jbb4kDt5YwTIoyAW+XG5eoYGud/a8vdN8Ua54Q8DS+ONT0W41G4VJvD+i2Jnnv0ldYlZ38xFRAPM4YkHJO1tuKyliIcjnDW2gXPp8UZ9a4T4gfErwt8CfBdtqHiC8ktdPhCWdvGiNLLM4U7UUDqcKeTgepFc/48/ag8B/Dnw3oer6xe3IGtRRXNpYxQE3RhkAPmNGSNqgHJyexAyeK0dWEdJPYLnrfvRWH4i8Y6L4S8N3Gv6xqMOnaRDGJXurhtq4OAo55JJIAHUkgda8R8Dftk6T8QPiVofhvT/C2r2+ka01xHY67eKIo7h4gS2xMfMvBBO7KnAK+hKrCDUZPVhdH0V9KK85+MXxy8O/BfTbSXVjcX+p38gisNH09BJdXTkgfKuegJGSfYDJIBs/Br4pL8Wvhpp3i+XTH0KK6Eha3nl3hFRmUtv2rlTgnOBxT9rDn5L6jO970d68C8P/ALXWg+Mvi9pngzw3o9/q9hdzT27eIF+S13xRh28sYPmKMgFiVxuUjIYGvfB3p06kKl3B3EncXikbp7VFeXUNjay3M8qwQQoZJJJDhUUDJJPYACvj/W/ih4i/a6+IF34F8CX8+h/D6xw2s67b5We5jJI2of4VcghV7gMWyAVqKtZUklu3sgbse1+Iv2hLFtYvfD/gXSbr4heJrVT59ppUiJbWzZIAnuWIjjOVIxktweOK8m+IXif9qz7eG0bwzo9nZZWRRpckFwwGf9W5mfJJxyVQcNwR2+kfA/gXQfhn4ZttD0Cwi03TbZeFTqx7u7HlmPcmvl39pX9sXUNL06/074bKJre1nFlf+KDHughmYMRDb54eTCsS3OApIB+8OWs+WHNUm15ImW1z6x8L3mo6h4b0u61iyGm6tNaxSXlmsgkEExQF4ww4ba2RkdcVq15noXxLsfA/wt8J6j8RvENjpOr3WmQSXL3sqRPLP5StIFQH5mBPO0denWuD+IP7W1rovjrwH4Z8LaPJ4hk8TrZ3i3TExqLW4cqpVSN2/aC3zABRjOeQOl1oQirvt6lXPoikNed/GD45eGPgpo8V3rlw8l9dErY6XbDfcXTgdFXsM4BY8DIHUgHzz9l79qpPj7eazpeo6XFo+s2I+1RQwSl0ltywXPPO5WKgnodykY6BuvTjNU29WHMj6HorxvwL+094b+I3xe1XwHolrd3LafBNLJqmAIHaN0RlUdduWI3nAJHGcg12ngn4qeGPiJqWvWHh7U01G40O4W2vRGpARiDjBI+YZVhkcZU+lVGrCfwsLo7Civk34/ft0W3w91yfQvBum23iG8s5BHfahcO32WGTdzEoXBdsBwTuAUj+LBA9s8a/Hrwb8MNJ0q68YazDotzqESOlkEeeblcn5I1Zto5G4jHHXNZxxFKTkk9hcyPRqWoLG7h1C0hubeRZYJkEkci9GUjII9iCKnrqKCiiigAooooAKKKKACiiigAooooA434v/EG3+Fvw317xPcBXNhas8MbttEsx+WJP+BOVH414h+xV8P8ASNZ+C9/4h1qG21/UPF97PNqovokmWQJM6CN1IIIJDSYI6yfSvoDx54E0T4leGbrw/wCIbJb/AEu6wXiLFTlTlSGByCCK8l8Ffsc+Evh/eXcujeIvGFnb3L72s7bXHtohzwP3IRjgcfMxOB1zzXDUpzlVU7JpE63ON/bC+E/gHR/hDcQ6H4S0iw8XXV1bw6RDo2nxxXdxIZVLqqxKGceWJDjBHHrivEvi9pmufA39k/wv4A1q4aPWPEWpy6jcWJbeLW3TY3khhwPnMTnk/MXwcCvvfw94D0LwxMbmx09TftGsT6hdSPcXciLnAeeQtIwGTwW7n1rmvix8A/B3xquNHm8U2M102ls/kiG4eLcr43I208qSqnjBGOCMnONbCufNKFlJqwnG58OfF6aXQP2a/C/hfw7eW9x4asbmI63qlvLvj1DVJ0eb7PE6DbIkKg5Y/KCIxncmK+nPBMfg3T/2Z/Afw913W4tCm8Y6ItvaRrJiWSW4j81yvblpf4sAlgvJYA9n8XP2cfDvxW8A6P4QSR/DmkaZeR3UMemRIoCqroUAIwMq7c9jgnPIOT49/Y/8A/ED/hHTc/2rp0ug2UGnWs2n3m1vs8OfLjberdCSdwAb3rOOGq05NpX0S/zFytHz3+w14g1rwF8YvGXw4u5Fm0u3F1LcEDiG4t5FiaQHPCsOD16J0xzZ+AvjDQvif+0148+KHiDVLWz0vRoGOnfb5PLWOMnyo5BuI24jRsjH3pc9a+t/APwh8K/DSxv7fQtLWGXUGLX15cSNNc3bEkkyyuSzcsx5OOTxya4nwF+x/wDC/wCHuqnU7TQTqd+srSwy6rKbgQZYMoRD8g24GGKlhj7xOaUMLVgoRT0Tv/kCi9D53/bS8XP44+O3gnwZp1i3iCPTVjnfS7eT/j6nmYMIWH8OY1j+Y9FlJxjrzP7RnhUXfxa8A+AtRmFx4g1i5t59d1SBQC81zKsMcMRbOyKGMEIvTD5IJJJ+2rD4G+ENP+KF/wDEFdNabxRdgL9rnlaQQ/u1jJjUnCkquM9cEgHBIqj4i/Z58GeKvihb+PNWspr/AFm2iijhjlmIt42jLFZAgxlvm7kj5QcZ5JUwk6jlJ7t/gLlPkH9r34nw+LPjzongTVDNB4J0G9tEvYIFJaUvtMrgL8xIicooHP3sda+i/hb4bvfHHxAg8eapoX/CMeDvD1g2m+E9Iu4liljjZVEt0yY/dZVQijOQoPA6tY+K37H/AIQ+J/iqbxTHf6p4d8TySRzHUNNn48xFVUfawOCAinKFTkZzkmuj8N/BXUl0e8sfGnjrWvG0d5YS6fPbzBLO2Mci7XOyL5ixGQGZ2Iycc81VOhVVWUpK+ug7NM+UP2z5NF8TXHh34weCPEqaksF6NFmkt2JFvcwl5Y2TI+Xox9CNrDIbJ+lJfiB4f+I3wW8LaN401mHw/q/xA0lbWKGMmN5JpIvmMY5wpJGNxwdyryWwaXhH9if4a+E7h3e31LXLU3P2pdP1a88y0RwGAPlKFV8BmA37jgnnmtz4vfst+DPjPr2na1rLalY6nYxJBHcaXciItEjMyoQysAAXY5UBvenGjVi5VLK8ugJPc+bf2Ftc1zwP8ZvGHw1uG+06dD9pknCr/qrm3lWIyDnhWHynryE6Yr7yX0rjvh38JfC/wut7tPD+mi3uLx/MvL2aRprm6fJO6SVyWY5ZjycDccYya7Ja6sLSdGnyyZUVZWPlb/goV8Qr7wv8MNL8P2MrwHxBcvHcSIGGYIgrMm4cDczJnnkBhyM1g/sm/GL4Z/CX4B6cNT1+zs9curmea9soUaW7eQzNHGPLQFjmNY8cYwfrX0z8Tvhb4b+Lvh3+xPE2ni+s/MEsbKxSSJx0ZHHKnGR7gkHiub+Hf7NHw5+Ft0l5onhu3/tFDuS+vCbidDjHyM+dnBP3cdTWEqNX6x7WLVrfcKz5rnJalpvjP9pCM2t7bXngH4bSMPNglOzVtZiwDtZR/wAe8R5BU5Zh2wa8Z+KEnhf4nfF7wD8EvA9jBD4Y0LUnuNWW2hxCXjGZFyOpCCVWY9Wk6mvrH4w+PE+Gnwv8S+JXZRJYWbvAHIAacjbEvPq7KPxr5X/4J3/DqW6k8SfEPUVklnuHOnWk024tJkiSeTJ+9ltg3eocZ61nWjzVI0d29X6ClvY6/wD4KE3Hh21+E1hBeRWR8RTXaJprNEhuEiHzTFDjcqYChscZKg9RWL8Jf2e5fiZovgT4ma7qeoeGZdGtbRNKsLNkYjT7ZB5ZeTaCXkbfITjG2QDA7e+/Ez9nvwV8XPEGj6x4m02S8u9M+VFWYokqZzskUfeXPOOOvccV6ItvF9nEAiUQBdgjA+XbjGMemK2eG56zqT26D5bvU+D/ANmPUW+Pv7Rnib4k+KZ0a20O3M9pDcPiO0ViywgZO0KiCQ/7x3dea1vB0Nh8JfCfxw+KPhqybR/C1+gsfDQkyTI24xmVF7RGV1Kf7I7AV7Nof7FPwx0LxDfalHZX1za3Tq50i4uy1ku05C+WAC65wdshYDAwBXp/jz4aaD8SPBN14T1m1J0edEQRWzeUYthBQoR02lRgYxxggjisKeFqKPvfFr94uV2Pz/8AgLNL4T+B/je88NXkEnjTXba4Eskc2To2l20Zaa4kKDfG7lmVB1Y+WyggGvSf2JPAd74m+APj9NG1IaJqms6iumtqQUs8UKRxltuCCG2Ty7TnhmB7V9L6X+z/AOEPDXwz1vwToNh/Y+n6taTWlzdRHfcP5iFC7O+SxGeAeB0AArM8B/s/6F8Kfg3q3g2z1nUrW3vkmmv9ZhlEVxvZAryJwRHhUAAAOAOpPNTTwk6bi5dE/vBRZ8nftGWvhnSfiZ8MPhb4Rs7W907RZYhPaiVfLvLqeVF8u4YfxMEXcxBKiU4HavRv2hPhja6h4f0zwRpsFv4w+Kvi2+S7vdamQb7aGM5klDYbyIFysaxg/dLfebO7xP8AZp/Zd074/al4l1GW/wBS0nwpp8/kWbqI2uJmJLBWb7oZY9u7C4JcY6V9rfB/9lzwL8FLpb/RrO4vdZCNH/amoyiSYKc5CgBVXg4+VQSOueTWNClUrXk42UvyJSbPSPCHh+Hwl4V0fQ7Yk2+mWUNlGST92NAg6+wrYpq06vfS5UkjYKKKKYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBwvxi+FVn8ZPCKeHNSv7mx017qK4uRaYDzIhJ8vJ+7k7TnB+7XQeD/CGkeA/DdloOhWMenaVZJ5cFvFnAGckknkkkkkkkkkk8mthqVajkjzc9tQClooqwCiiigBDXlf7T0PiO++CniPTfCumzarrGpxpYLBAu5vLlcJKfpsLc9s57V6m1OrOceeLjfcDx79k/4Y6h8J/gvpWjaxZRWGtSSzXd7FGysd7udu5l4LCNYx1PTGeK9hoop04KnFQXQAoooqwCiiigAooooA//2Q==';

  const generateClientStatusReport = () => {
    const companyName = dealProfile.companyName || 'Your Business';
    const preparedDate = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    
    // Missing documents - filter by status (not_received, requested, or partial)
    const allMissingDocs = documentChecklist.filter(d => d.status !== 'complete');
    // Verification docs - check for isVerification flag OR keywords in name
    const verificationDocs = allMissingDocs.filter(d => 
      d.isVerification || 
      d.category === 'Verification' || 
      d.name?.toLowerCase().includes('verification') || 
      d.name?.toLowerCase().includes('verify') || 
      d.name?.toLowerCase().includes('proof of') ||
      d.name?.toLowerCase().includes('confirm') ||
      d.name?.toLowerCase().includes('insurance cert')
    );
    const nonVerificationDocs = allMissingDocs.filter(d => !verificationDocs.includes(d));
    // Show all missing docs (removed separate verification section)
    const missingDocs = allMissingDocs;
    const receivedDocs = documentChecklist.filter(d => d.status === 'complete');
    console.log('Roadmap Debug - Verification Docs:', verificationDocs.length, verificationDocs.map(d => d.name));
    
    // Custom document requests
    const customDocRequests = (roadmapConfig.customRequests || []).filter(r => r.type === 'document' && r.text);
    const customQuestionRequests = (roadmapConfig.customRequests || []).filter(r => r.type === 'question' && r.text);
    
    // Ask Owner items - these come from Research Items, not sellerQA
    // Check both the askOwner flag AND the status === 'ask_owner' value
    const askOwnerItems = (researchItems || []).filter(r => 
      (r.askOwner || r.status === 'ask_owner') && r.status !== 'complete'
    );
    
    // Open items that need owner input (flagged items from Verification & Review)
    // These are now included in the Questions section, controlled by showAskOwner
    const openItemsForOwner = Object.entries(manualReviewFlags || {})
      .filter(([key, val]) => val?.flagged && val?.notes)
      .map(([key, val]) => ({ key, ...val }));
    
    // Pending follow-up sub-questions from Discovery Q&A
    const pendingFollowUps = [];
    sellerQA.forEach(qa => {
      if (qa.followUps && qa.followUps.length > 0) {
        qa.followUps.filter(fu => fu.status === 'pending' || fu.status === 'Pending').forEach(fu => {
          pendingFollowUps.push({
            question: fu.question,
            parentQuestion: qa.question,
            parentId: qa.id
          });
        });
      }
    });
    
    // Items needing verification (from outstandingAnalysis) - these should show on roadmap
    const verificationItems = outstandingAnalysis.unacknowledgedFlags.filter(f => 
      f.severity === 'warning' && 
      (f.category === 'Line Adjustment' || f.category === 'Adjustment' || f.category === 'Owner Compensation')
    ).map(f => ({
      item: f.item,
      detail: f.detail,
      action: f.action
    }));
    
    console.log('Roadmap Debug - Research Items:', researchItems?.length || 0, 'Ask Owner Items:', askOwnerItems.length);
    console.log('Roadmap Debug - Ask Owner items detail:', askOwnerItems.map(r => ({ id: r.id, item: r.item, askOwner: r.askOwner, status: r.status })));
    console.log('Roadmap Debug - showAskOwner config:', roadmapConfig.showAskOwner);
    console.log('Roadmap Debug - Open Items for Owner:', openItemsForOwner.length, openItemsForOwner.map(i => i.notes));
    console.log('Roadmap Debug - Verification Items:', verificationItems.length);
    
    // Discovery questions progress (for stats)
    const unansweredQA = sellerQA.filter(qa => qa.status === 'pending' || qa.status === 'Pending');
    const answeredQA = sellerQA.filter(qa => qa.status === 'answered' || qa.status === 'Answered');
    
    // Accuracy score
    const accuracyScore = accuracyGauge.overallScore || 0;
    const accuracyTier = accuracyGauge.tier || 'Preliminary';
    
    // Valuation summary
    const valuationLow = multipleEngineCalcs.valuationTypical || 0;
    const valuationHigh = multipleEngineCalcs.valuationMarketHigh || 0;
    const normalizedEbitda = multipleEngineCalcs.adjustedEbitda || 0;
    const finalMultiple = multipleEngineCalcs.adjustedMultiple || 0;
    
    // Progress color
    let progressColor = '#dc2626';
    let progressBg = '#fef2f2';
    if (accuracyScore >= 90) { progressColor = '#16a34a'; progressBg = '#f0fdf4'; }
    else if (accuracyScore >= 75) { progressColor = '#2563eb'; progressBg = '#eff6ff'; }
    else if (accuracyScore >= 50) { progressColor = '#d97706'; progressBg = '#fffbeb'; }
    
    // Count total outstanding items (includes verification items that need attention)
    const totalOutstanding = missingDocs.length + customDocRequests.length + verificationItems.length + unansweredQA.length +
      (roadmapConfig.showAskOwner ? askOwnerItems.length + customQuestionRequests.length + openItemsForOwner.length + pendingFollowUps.length : 0);
    
    // Calculate completion percentage
    const totalItems = documentChecklist.length + sellerQA.length;
    const completedItems = receivedDocs.length + answeredQA.length;
    const completionPct = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;
    
    const html = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Information Request Status - ${companyName}</title>
  <style>
    @media print { 
      @page { margin: 0.5in; size: letter; } 
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } 
      .no-print { display: none !important; }
      .page-break { page-break-before: always; }
    }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { 
      font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif; 
      font-size: 11px; 
      color: #374151; 
      max-width: 8in; 
      margin: 0 auto; 
      padding: 30px; 
      line-height: 1.6;
      background: #fff;
    }
    
    /* Vista Header - matching Financial Summary */
    .vista-header {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 2px solid #3d5c35;
    }
    .vista-header img { height: 50px; }
    .vista-header-text { }
    .vista-header-text .name { font-size: 18px; font-weight: 700; color: #3d5c35; }
    .vista-header-text .tagline { font-size: 11px; color: #6b7280; }
    .vista-header-text .url { font-size: 10px; color: #3d5c35; }
    
    /* Executive Banner - matching Financial Summary */
    .exec-banner {
      background: linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);
      color: white;
      padding: 25px 30px;
      border-radius: 10px;
      margin-bottom: 25px;
    }
    .exec-banner-title {
      text-align: center;
      margin-bottom: 15px;
    }
    .exec-banner-title .label { font-size: 12px; text-transform: uppercase; letter-spacing: 1px; opacity: 0.9; margin-bottom: 5px; }
    .exec-banner-title .company { font-size: 28px; font-weight: 700; }
    .exec-banner-title .date { font-size: 11px; opacity: 0.8; margin-top: 5px; }
    .exec-banner-stats {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 15px;
      text-align: center;
    }
    .exec-stat {
      background: rgba(255,255,255,0.15);
      padding: 12px;
      border-radius: 8px;
    }
    .exec-stat .label { font-size: 9px; text-transform: uppercase; opacity: 0.9; margin-bottom: 4px; }
    .exec-stat .value { font-size: 20px; font-weight: 700; }
    .exec-stat .sub { font-size: 9px; opacity: 0.8; margin-top: 2px; }
    
    /* Important Notice Box */
    .notice-box {
      background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
      border: 2px solid #d97706;
      border-radius: 10px;
      padding: 20px 25px;
      margin-bottom: 25px;
    }
    .notice-box .title {
      font-size: 14px;
      font-weight: 700;
      color: #92400e;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .notice-box .content {
      color: #78350f;
      font-size: 11px;
      line-height: 1.7;
    }
    .notice-box .content p { margin-bottom: 10px; }
    .notice-box .content p:last-child { margin-bottom: 0; }
    .notice-box .highlight {
      background: rgba(255,255,255,0.6);
      padding: 2px 6px;
      border-radius: 3px;
      font-weight: 600;
    }
    
    /* Section styling */
    .section { margin-bottom: 20px; }
    .section-header {
      background: #3d5c35;
      color: white;
      padding: 12px 18px;
      border-radius: 8px 8px 0 0;
      font-size: 13px;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .section-header.amber { background: linear-gradient(135deg, #d97706 0%, #b45309 100%); }
    .section-header.complete { background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); }
    .section-count { 
      background: rgba(255,255,255,0.25); 
      padding: 3px 12px; 
      border-radius: 12px;
      font-size: 11px;
      font-weight: 500;
    }
    .section-intro {
      background: #f8faf7;
      border-left: 1px solid #e5e7eb;
      border-right: 1px solid #e5e7eb;
      padding: 12px 18px;
      font-size: 10px;
      color: #4b5563;
      font-style: italic;
    }
    .section-content {
      background: #fff;
      border: 1px solid #e5e7eb;
      border-top: none;
      border-radius: 0 0 8px 8px;
    }
    
    /* Checklist items */
    .checklist-item {
      padding: 12px 18px;
      border-bottom: 1px solid #f3f4f6;
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }
    .checklist-item:last-child { border-bottom: none; }
    .checklist-icon { 
      width: 20px; 
      height: 20px; 
      border: 2px solid #d1d5db; 
      border-radius: 4px;
      flex-shrink: 0;
      margin-top: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
    .checklist-icon.complete { 
      background: #3d5c35; 
      border-color: #3d5c35;
      color: white;
    }
    .checklist-text { flex: 1; }
    .checklist-text .main { font-weight: 500; color: #1f2937; }
    .checklist-text .note { font-size: 10px; color: #6b7280; margin-top: 3px; }
    .checklist-text .why { font-size: 9px; color: #9ca3af; margin-top: 2px; font-style: italic; }
    
    .empty-state { 
      text-align: center; 
      padding: 25px; 
      color: #16a34a;
      font-weight: 600;
      font-size: 13px;
    }
    
    /* Why This Matters boxes */
    .why-box {
      background: #f0fdf4;
      border: 1px solid #bbf7d0;
      border-radius: 8px;
      padding: 15px 18px;
      margin: 20px 0;
    }
    .why-box .title { font-size: 11px; font-weight: 600; color: #166534; margin-bottom: 8px; }
    .why-box .content { font-size: 10px; color: #15803d; line-height: 1.6; }
    
    /* Valuation box */
    .valuation-box {
      background: linear-gradient(135deg, #f8faf7 0%, #e8ede6 100%);
      border: 2px solid #3d5c35;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 25px;
      text-align: center;
    }
    .valuation-box .label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #6b7280; margin-bottom: 8px; }
    .valuation-box .range { font-size: 28px; font-weight: 700; color: #3d5c35; }
    .valuation-box .disclaimer { font-size: 10px; color: #92400e; margin-top: 12px; padding: 10px; background: #fffbeb; border-radius: 6px; font-style: italic; }
    
    /* Next steps */
    .next-steps {
      background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
      border: 1px solid #3b82f6;
      border-radius: 10px;
      padding: 20px;
      margin-top: 25px;
    }
    .next-steps .title { font-size: 13px; font-weight: 600; color: #1e40af; margin-bottom: 12px; }
    .next-steps ol { margin-left: 20px; color: #1e3a8a; }
    .next-steps li { margin-bottom: 8px; }
    
    /* Footer */
    .footer {
      margin-top: 30px;
      padding-top: 20px;
      border-top: 2px solid #e5e7eb;
      text-align: center;
    }
    .footer img { height: 35px; margin-bottom: 10px; }
    .footer .text { font-size: 10px; color: #6b7280; margin-bottom: 5px; }
    .footer .contact { font-size: 11px; color: #3d5c35; font-weight: 500; }
    
    /* Print button */
    .print-actions { 
      text-align: center; 
      margin-bottom: 20px;
      padding: 15px;
      background: #f9fafb;
      border-radius: 8px;
    }
    .print-btn { 
      background: #3d5c35; 
      color: white; 
      padding: 10px 24px; 
      border: none; 
      border-radius: 6px; 
      cursor: pointer; 
      font-size: 13px;
      font-weight: 500;
      margin: 0 5px;
    }
    .print-btn:hover { background: #2d4428; }
  </style>
</head>
<body>
  <div class="no-print print-actions">
    <button class="print-btn" onclick="window.print()">🖨️ Print / Save as PDF</button>
  </div>
  
  <!-- Vista Header -->
  <div class="vista-header">
    <img src="${vistaLogoBase64}" alt="Vista Business Group" onerror="this.style.display='none'">
    <div class="vista-header-text">
      <div class="name">Vista Business Group</div>
      <div class="tagline">Confidential Business Valuation</div>
      <div class="url">Vistabusinessgroup.com</div>
    </div>
  </div>
  
  <!-- Executive Banner -->
  <div class="exec-banner">
    <div class="exec-banner-title">
      <div class="label">Information Request Status</div>
      <div class="company">${companyName}</div>
      <div class="date">Prepared ${preparedDate}</div>
    </div>
    <div class="exec-banner-stats">
      <div class="exec-stat">
        <div class="label">Documents</div>
        <div class="value">${receivedDocs.length}/${documentChecklist.length}</div>
        <div class="sub">received</div>
      </div>
      <div class="exec-stat">
        <div class="label">Discovery Q&A</div>
        <div class="value">${answeredQA.length}/${sellerQA.length}</div>
        <div class="sub">answered</div>
      </div>
      <div class="exec-stat">
        <div class="label">Overall</div>
        <div class="value">${completionPct}%</div>
        <div class="sub">complete</div>
      </div>
      <div class="exec-stat">
        <div class="label">Confidence</div>
        <div class="value">${accuracyScore.toFixed(0)}%</div>
        <div class="sub">${accuracyTier}</div>
      </div>
    </div>
  </div>
  
  <!-- Important Notice -->
  <div class="notice-box">
    <div class="title">⚠️ Important: About Your Valuation Estimate</div>
    <div class="content">
      <p>Based on the information received so far, we have prepared a <span class="highlight">preliminary valuation estimate</span>. However, this estimate is subject to change—sometimes significantly—as we receive additional documentation and answers to our questions.</p>
      <p><strong>In our experience, the information we don't yet have often has the greatest impact on final value.</strong> Undisclosed liabilities, customer concentration issues, revenue recognition questions, and operational details frequently emerge during due diligence and can move the valuation up or down substantially.</p>
      <p>Until all documents are received and all questions are answered, this valuation should be considered <span class="highlight">directional only</span>. Completing the items below will increase our confidence and allow us to provide a more accurate, defensible valuation.</p>
    </div>
  </div>
  
  ${roadmapConfig.showValuation ? `
  <div class="valuation-box">
    <div class="label">Current Preliminary Valuation Range</div>
    <div class="range">${fmt(valuationLow)} — ${fmt(valuationHigh)}</div>
    <div class="disclaimer">⚠️ This range is preliminary and may change materially as additional information is received and analyzed. Do not rely on this estimate for financial decisions until the valuation is finalized.</div>
  </div>
  ` : ''}
  
  <!-- DOCUMENTS SECTION -->
  ${(missingDocs.length + customDocRequests.length) > 0 ? `
  <div class="section">
    <div class="section-header">
      <span>📁 Outstanding Documents</span>
      <span class="section-count">${missingDocs.length + customDocRequests.length} remaining</span>
    </div>
    <div class="section-intro">
      Financial documents allow us to verify the numbers and identify potential adjustments. Missing documents often delay the valuation process and can result in more conservative estimates.
    </div>
    <div class="section-content">
      ${missingDocs.map(doc => `
        <div class="checklist-item">
          <div class="checklist-icon">${doc.status === 'partial' ? '◐' : '☐'}</div>
          <div class="checklist-text">
            <div class="main">${doc.name}${doc.status === 'partial' ? ' <span style="color:#d97706;font-weight:500;">(Partial)</span>' : ''}</div>
            ${doc.status === 'partial' && doc.pendingNotes ? `<div class="note" style="color:#d97706;"><strong>Still need:</strong> ${doc.pendingNotes}</div>` : ''}
            ${doc.status === 'partial' && doc.receivedNotes ? `<div class="note" style="color:#059669;font-size:11px;">Already received: ${doc.receivedNotes}</div>` : ''}
            ${doc.status !== 'partial' && doc.notes ? `<div class="note">${doc.notes}</div>` : ''}
          </div>
        </div>
      `).join('')}
      ${customDocRequests.map(req => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${req.text}</div>
          </div>
        </div>
      `).join('')}
    </div>
  </div>
  ` : `
  <div class="section">
    <div class="section-header complete">
      <span>📁 Documents</span>
      <span class="section-count">Complete</span>
    </div>
    <div class="section-content">
      <div class="empty-state">✅ All documents received — thank you!</div>
    </div>
  </div>
  `}
  
  <!-- DISCOVERY QUESTIONS SECTION -->
  ${unansweredQA.length > 0 ? `
  <div class="section">
    <div class="section-header amber">
      <span>❓ Discovery Questions Awaiting Your Response</span>
      <span class="section-count">${unansweredQA.length} remaining</span>
    </div>
    <div class="section-intro">
      These questions help us understand your business operations, customer relationships, and key risks. Your answers directly impact how we calculate normalized earnings and assess risk factors that affect valuation multiples.
    </div>
    <div class="section-content">
      ${unansweredQA.map((qa, idx) => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${qa.question}</div>
            ${qa.notes ? `<div class="why">Why we ask: ${qa.notes}</div>` : ''}
          </div>
        </div>
      `).join('')}
    </div>
  </div>
  
  <div class="why-box">
    <div class="title">💡 Why Discovery Questions Matter</div>
    <div class="content">
      Buyers evaluate businesses based on risk and growth potential, not just financial numbers. Your answers help us identify strengths to highlight (like long-term contracts or recurring revenue) and address potential concerns proactively (like customer concentration or key-person dependency). Incomplete discovery often leads to lower valuations because buyers assume the worst when information is missing.
    </div>
  </div>
  ` : `
  <div class="section">
    <div class="section-header complete">
      <span>❓ Discovery Questions</span>
      <span class="section-count">Complete</span>
    </div>
    <div class="section-content">
      <div class="empty-state">✅ All discovery questions answered — thank you!</div>
    </div>
  </div>
  `}
  
  <!-- FOLLOW-UP QUESTIONS SECTION -->
  ${(pendingFollowUps.length + askOwnerItems.length + openItemsForOwner.length + customQuestionRequests.length) > 0 && roadmapConfig.showAskOwner ? `
  <div class="section">
    <div class="section-header amber">
      <span>🔍 Follow-Up Questions from Our Analysis</span>
      <span class="section-count">${pendingFollowUps.length + askOwnerItems.length + openItemsForOwner.length + customQuestionRequests.length} remaining</span>
    </div>
    <div class="section-intro">
      As we review your documents and financial data, these additional questions have come up. These clarifications help us accurately reflect your business in the valuation.
    </div>
    <div class="section-content">
      ${askOwnerItems.map(r => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${r.item}</div>
          </div>
        </div>
      `).join('')}
      ${pendingFollowUps.map(fu => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${fu.question}</div>
            <div class="note">Follow-up to: "${fu.parentQuestion.substring(0, 60)}${fu.parentQuestion.length > 60 ? '...' : ''}"</div>
          </div>
        </div>
      `).join('')}
      ${openItemsForOwner.map(item => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${item.notes}</div>
          </div>
        </div>
      `).join('')}
      ${customQuestionRequests.map(req => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${req.text}</div>
          </div>
        </div>
      `).join('')}
    </div>
  </div>
  ` : ''}
  
  <!-- VERIFICATION ITEMS SECTION -->
  ${verificationItems.length > 0 ? `
  <div class="section">
    <div class="section-header amber">
      <span>📋 Items Requiring Supporting Documentation</span>
      <span class="section-count">${verificationItems.length} remaining</span>
    </div>
    <div class="section-intro">
      To include certain add-backs in your normalized earnings, we need supporting documentation. Without verification, buyers and lenders may discount or reject these adjustments, resulting in a lower defensible valuation.
    </div>
    <div class="section-content">
      ${verificationItems.map(item => `
        <div class="checklist-item">
          <div class="checklist-icon">☐</div>
          <div class="checklist-text">
            <div class="main">${item.item}</div>
            <div class="note">${item.detail}</div>
          </div>
        </div>
      `).join('')}
    </div>
  </div>
  ` : ''}
  
  <!-- COMPLETED ITEMS SECTION -->
  ${roadmapConfig.showCompletedItems && (receivedDocs.length > 0 || answeredQA.length > 0) ? `
  <div class="section">
    <div class="section-header complete">
      <span>✅ Items Completed</span>
      <span class="section-count">${receivedDocs.length + answeredQA.length} received</span>
    </div>
    <div class="section-content">
      ${receivedDocs.slice(0, 8).map(doc => `
        <div class="checklist-item">
          <div class="checklist-icon complete">✓</div>
          <div class="checklist-text" style="color: #6b7280;">
            <div class="main" style="font-weight: 400;">${doc.name}</div>
          </div>
        </div>
      `).join('')}
      ${receivedDocs.length > 8 ? `<div style="padding: 10px 18px; color: #6b7280; font-style: italic; font-size: 10px;">...and ${receivedDocs.length - 8} more documents received</div>` : ''}
      ${answeredQA.length > 0 ? `<div style="padding: 10px 18px; color: #16a34a; font-size: 10px; background: #f0fdf4;">✓ ${answeredQA.length} discovery questions answered</div>` : ''}
    </div>
  </div>
  ` : ''}
  
  <!-- NEXT STEPS -->
  <div class="next-steps">
    <div class="title">📋 Next Steps</div>
    <ol>
      ${(missingDocs.length + customDocRequests.length) > 0 ? '<li>Please provide the <strong>outstanding documents</strong> listed above. Documents can be emailed directly or uploaded to our secure portal.</li>' : ''}
      ${unansweredQA.length > 0 ? '<li>Please respond to the <strong>discovery questions</strong> above. You can reply via email, and we will record your answers.</li>' : ''}
      ${(pendingFollowUps.length + askOwnerItems.length) > 0 && roadmapConfig.showAskOwner ? '<li>Please address the <strong>follow-up questions</strong> that arose during our analysis.</li>' : ''}
      ${verificationItems.length > 0 ? '<li>Please provide <strong>supporting documentation</strong> (W-2s, payroll records, invoices) for items requiring verification.</li>' : ''}
      <li>Once received, we will update our analysis. ${roadmapConfig.showValuation ? 'The valuation range will narrow as confidence increases.' : 'We will then be able to provide a preliminary valuation.'}</li>
      <li>We will schedule a call to review findings, discuss value drivers, and outline next steps.</li>
    </ol>
  </div>
  
  <!-- FOOTER -->
  <div class="footer">
    <img src="${vistaLogoBase64}" alt="Vista Business Group" onerror="this.style.display='none'">
    <div class="text">This status report reflects information received as of ${preparedDate}. Additional items may be identified as our analysis progresses.</div>
    <div class="contact">Questions? Contact your Vista Business Group advisor directly.</div>
  </div>
</body>
</html>`;
    
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');
    if (win) win.focus();
    URL.revokeObjectURL(url);
  };

  // ── OIR (Outstanding Items Report) — email-safe HTML generator ──────────
  // Stage B3. Renders the OIR as an inline-styled, table-based HTML email.
  // Gmail strips <style> blocks and most modern CSS, so every style is
  // inline and the layout is table-based. Three components: estimation of
  // value, % accuracy, outstanding items. Two modes — pre-data ("we need
  // your financials") and has-data (shows the range + the climbing %).
  // Reused by the Preview button and, later, B4's draft-email modal.
  const buildOIREmailHtml = (personalNote = '', options = {}) => {
    // options.cadenceVariant ∈ '' | 'weekly' | 'final-no-value' | 'final-meeting-offer'
    // In cadence mode the personal-note (cadence body) already covers
    // the "set a new target" and "QuickBooks help" prompts; rendering them
    // again would be redundant on weekly and actively wrong on final
    // (the close line invites a new target date while the final variant is
    // a handoff to the AM).
    const cadenceVariant = options.cadenceVariant || '';
    const isCadence = !!cadenceVariant;
    const company = (dealProfile.companyName || '').trim() || 'your business';
    const fmtMoney = (n) => '$' + Math.round(n || 0).toLocaleString();
    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const valuationLow = multipleEngineCalcs?.valuationTypical || 0;
    const valuationHigh = multipleEngineCalcs?.valuationMarketHigh || 0;
    const accuracyScore = Math.round(accuracyGauge?.overallScore || 0);
    const accuracyTier = accuracyGauge?.tier || 'Preliminary';
    const hasData = accuracyScore > 0 && valuationHigh > 0;
    // Partial valuations never show the value or accuracy in the OIR — the
    // value is the "answer" the owner wants and it's delivered in the
    // follow-up meeting, not by email (business rule, Mark 2026-05-21).
    // Full valuations show it only once there's a computed value; the
    // add-backs-entered gate is enforced by Konnie's judgment until the
    // Stage Engine makes it automatic (stage >= adjustments_entered).
    // Cadence variant flag retained for the close-line / QuickBooks-line
    // gating below; the value box is no longer rendered in any variant
    // (Mark 2026-05-27 — see informationCompleteBlock comment).
    const isPartial = (workflow.path === 'partial');
    const isFinalCadence = cadenceVariant === 'final-no-value' || cadenceVariant === 'final-meeting-offer';

    // Outstanding items: not yet complete AND unlocked. Prerequisite-gated
    // second-round items (Revenue Classification, Client Detail) stay hidden
    // until their prerequisite arrives — the owner sees a finite list, never
    // one that grows.
    const isUnlocked = (d) => {
      if (!Array.isArray(d.unlockedBy) || d.unlockedBy.length === 0) return true;
      return d.unlockedBy.some(id => {
        const pre = documentChecklist.find(x => x.id === id);
        return pre && pre.status === 'complete';
      });
    };
    // Documents the owner was actually asked for: the planned subset if
    // Konnie marked one at discovery, otherwise every currently-unlocked
    // item. The owner just sees "X of Y" — no tiers, no jargon.
    const plannedDocs = documentChecklist.filter(d => d.planned);
    const relevantDocs = plannedDocs.length > 0 ? plannedDocs : documentChecklist.filter(isUnlocked);
    const docsTotal = relevantDocs.length;
    // X-of-Y count includes partials (Mark 2026-05-27) — an owner who
    // sent 2 of 3 tax returns marked 'partial' deserves engagement
    // credit. The partial item still shows in the outstanding list
    // below with its "still need" note.
    // Stage C: an item the owner uploaded via ShareFile counts as received
    // from the owner's perspective even before Konnie enters it — so it adds
    // to "X of Y" and is dropped from "What We Still Need". Partials are kept
    // in the outstanding list regardless, since their "still need" note marks
    // a deliberate remaining gap.
    const sfReceived = (d) => !!sharefileReceived[String(d.id)];
    const docsDone = relevantDocs.filter(d => d.status === 'complete' || d.status === 'partial' || sfReceived(d)).length;
    const outstanding = relevantDocs.filter(d => d.status !== 'complete' && !(sfReceived(d) && d.status !== 'partial'));
    // Frozen document-request dates, anchored to the discovery/activation date so
    // the asked-for ranges match the original request and don't drift week to week.
    // Ranges anchor to the cycle's AS-OF date (increment 3): auto-advances
    // monthly until the first upload, legacy-faithful (discovery-derived) for
    // already-locked deals so in-flight owners never see their dates move.
    const docDates = computeDocRequestDates(asOfRangeAnchor(workflow));

const itemsBlock = outstanding.length === 0
      ? `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 0 4px;">
           <tr><td style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:14px 20px;font-size:14px;color:#15803d;">
             We have everything we need — thank you. No action is needed from you right now.
           </td></tr>
         </table>`
      : `<div style="font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#3d5c35;font-weight:700;margin-bottom:8px;">What We Still Need</div>
         <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
           ${outstanding.map(d => {
             // Partially-received documents spell out exactly what's still
             // needed (the "Need:" note) — the owner shouldn't have to guess,
             // and staff shouldn't have to hand-type it.
             const need = (d.status === 'partial' && d.pendingNotes && String(d.pendingNotes).trim())
               ? ` <span style="color:#b45309;">&mdash; still need: ${esc(String(d.pendingNotes).trim())}</span>`
               : '';
             // Format + frozen date range, so the owner knows exactly what to pull
             // (e.g. "each month its own column, not just a total").
             const detail = docRequestDetailLine(d.id, docDates);
             const detailHtml = detail
               ? `<div style="font-size:12px;color:#888888;margin-top:3px;">${esc(detail)}</div>`
               : '';
             return `<tr><td style="padding:7px 0;font-size:14px;color:#444444;border-bottom:1px solid #eeeeee;">&#9744;&nbsp;&nbsp;${esc(d.name)}${need}${detailHtml}</td></tr>`;
           }).join('')}
         </table>`;

    // Single intro for vanilla OIRs with no personal note. No longer
    // mentions a "preliminary estimate" because the dollar number is
    // never sent by email (Mark 2026-05-27). Cadence sends pass a
    // personal-note body, which replaces this line.
    const introLine = `Thank you for starting the valuation process for <strong>${company}</strong>. Here's what we need to get your estimate underway.`;

    // In cadence mode the personal-note (cadence body) already covers the
    // "set a new target" and "QuickBooks help" prompts — suppress both to
    // avoid redundancy on weekly, and to avoid the close line's "reply with
    // a new target date" sentiment on final variants (which are AM handoffs).
    const closeLine = isCadence
      ? ''
      : (outstanding.length > 0
        ? `We know schedules shift. <strong>If the timing we'd aimed for needs to change, just reply with a date that works for you</strong> — we'll adjust on our end.`
        : `We'll follow up shortly with the next step.`);

    // Help line — surfaced near the top, just below the intro, so the
    // QuickBooks offer is seen before the outstanding-items list.
    const quickbooksLine = (!isCadence && outstanding.length > 0)
      ? `<p style="font-size:14px;line-height:1.6;color:#444444;margin:0 0 22px;">Need help pulling your documents from <strong>QuickBooks</strong>? Just reply to this email and we'll resend the step-by-step instructions.</p>`
      : '';

    return `<!DOCTYPE html>
<html>
<head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;background:#f4f4f0;">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f4f4f0;padding:24px 0;">
<tr><td align="center">
<table role="presentation" width="600" cellpadding="0" cellspacing="0" style="width:600px;max-width:600px;background:#ffffff;border-radius:10px;overflow:hidden;font-family:'Segoe UI',Helvetica,Arial,sans-serif;">
  <tr><td style="background:#3d5c35;padding:22px 32px;">
    <div style="color:#ffffff;font-size:20px;font-weight:700;">Vista Business Group</div>
    <div style="color:#c9d6c3;font-size:13px;margin-top:2px;">Valuation Status Update</div>
  </td></tr>
  <tr><td style="padding:28px 32px;">
    <p style="margin:0 0 14px;font-size:15px;color:#1a1a1a;">Hello${(workflow.owner_first_name || '').trim() ? ' ' + esc((workflow.owner_first_name || '').trim()) : ''},</p>
    ${personalNote && personalNote.trim()
      ? `<p style="margin:0 0 22px;font-size:14px;line-height:1.6;color:#444444;white-space:pre-line;">${esc(personalNote.trim())}</p>`
      : `<p style="margin:0 0 22px;font-size:14px;line-height:1.6;color:#444444;">${introLine}</p>`}
    ${quickbooksLine}
    ${closeLine ? `<p style="font-size:14px;line-height:1.6;color:#444444;margin:0;">${closeLine}</p>` : ''}
    <p style="font-size:14px;color:#444444;margin:24px 0 0;">Thank you,</p>
    <p style="font-size:14px;color:#1a1a1a;margin:2px 0 0;font-weight:600;">Konnie Budreau</p>
    <p style="font-size:13px;color:#666666;margin:0;">Vista Business Group</p>
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:26px 0 22px;">
      <tr><td style="border-top:1px solid #ececec;font-size:0;line-height:0;">&nbsp;</td></tr>
    </table>
    ${itemsBlock}
  </td></tr>
  <tr><td style="background:#f4f4f0;padding:14px 32px;text-align:center;">
    <div style="font-size:11px;color:#999999;">Vista Business Group &middot; This message is confidential.</div>
  </td></tr>
</table>
</td></tr>
</table>
</body>
</html>`;
  };

  // Cadence reminder body — populates the OIR send modal's "Personal note"
  // field. Single dynamic template (Mark 2026-05-27); slots auto-fill from
  // current data so the wording is always true regardless of where the
  // project is in the weekly cadence. Three variants:
  //   • 'weekly'              — the every-7-days check-in
  //   • 'final-no-value'      — stop-date hit, VT has not computed a value
  //   • 'final-meeting-offer' — stop-date hit, VT has a value to discuss
  // Returns plain text (the modal renders white-space:pre-line, no markdown).
  // Konnie can edit freely in the modal before sending.
  // Open owner questions = the "Ask Owner" research items not yet resolved
  // (the Open Items → Research Items toggle). The combined owner-questions
  // email bundles all of these into one send (Mark 2026-06-08). `sentAt`
  // (stamped on send) distinguishes "to send" (no sentAt) from "awaiting
  // answer" (sentAt set, not complete).
  const openOwnerQuestions = useMemo(
    () => (researchItems || []).filter(r => (r.askOwner || r.status === 'ask_owner') && r.status !== 'complete'),
    [researchItems]
  );

  // Colleen's combined owner-questions email — same minimal house style as the
  // OIR (greeting + note + list + signature), but it lists the open Ask-Owner
  // questions and is signed by / sent as Colleen. No dollar value, no gauge.
  const buildOwnerQuestionsEmailHtml = (personalNote = '', answerMode = 'portal') => {
    const company = (dealProfile.companyName || '').trim() || 'your business';
    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
    const questions = openOwnerQuestions;
    const isEmailReply = answerMode === 'email';
    // The "how to answer" framing differs by mode: portal clients are pointed at
    // their secure portal; email-reply clients (legacy / not comfortable with the
    // portal) are asked to reply to the email with numbered answers.
    const introLine = isEmailReply
      ? `As we work through the valuation for <strong>${esc(company)}</strong>, a few questions came up that would help us sharpen the numbers. Just reply to this email with your answers whenever you get a chance — numbering them to match the list below is perfect.`
      : `As we work through the valuation for <strong>${esc(company)}</strong>, a few questions came up that would help us sharpen the numbers. The easiest way to answer is right in your secure portal — they're waiting for you there whenever you get a chance.`;
    const itemsBlock = questions.length === 0
      ? `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 0 4px;">
           <tr><td style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:14px 20px;font-size:14px;color:#15803d;">
             No open questions right now — thank you.
           </td></tr>
         </table>`
      : `<div style="font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#3d5c35;font-weight:700;margin-bottom:8px;">A Few Questions</div>
         <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
           ${questions.map((q, i) => `<tr><td style="padding:9px 0;font-size:14px;color:#444444;border-bottom:1px solid #eeeeee;vertical-align:top;"><strong style="color:#3d5c35;">${i + 1}.</strong>&nbsp;&nbsp;${esc(String(q.item || '').trim())}</td></tr>`).join('')}
         </table>`;
    // Call-to-action block: portal sign-in button (default) vs a plain reply-by-
    // email instruction. The email variant never mentions the portal or "don't
    // reply" — it asks for exactly the reply a legacy client would naturally send.
    const ctaBlock = isEmailReply
      ? `<p style="font-size:14px;line-height:1.6;color:#444444;margin:22px 0 24px;">Just reply to this email with your answers — numbering them to match the list above is all we need.</p>`
      : `<p style="margin:24px 0 8px;"><a href="${esc(portalUrl)}" style="background:#3d5c35;color:#ffffff;text-decoration:none;padding:12px 24px;border-radius:6px;font-weight:600;display:inline-block;font-size:14px;">Answer in your secure portal &rarr;</a></p>
         <p style="font-size:12px;color:#666666;margin:0 0 24px;">If you've used the portal in the last few days, the button takes you straight in. Otherwise, enter the email address this message was sent to and we'll send you a fresh sign-in link. Your answers save right there in the portal — no need to reply to this email.</p>`;
    return `<!DOCTYPE html>
<html>
<head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;background:#f4f4f0;">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f4f4f0;padding:24px 0;">
<tr><td align="center">
<table role="presentation" width="600" cellpadding="0" cellspacing="0" style="width:600px;max-width:600px;background:#ffffff;border-radius:10px;overflow:hidden;font-family:'Segoe UI',Helvetica,Arial,sans-serif;">
  <tr><td style="background:#3d5c35;padding:22px 32px;">
    <div style="color:#ffffff;font-size:20px;font-weight:700;">Vista Business Group</div>
    <div style="color:#c9d6c3;font-size:13px;margin-top:2px;">Questions on Your Valuation</div>
  </td></tr>
  <tr><td style="padding:28px 32px;">
    <p style="margin:0 0 14px;font-size:15px;color:#1a1a1a;">Hello${(workflow.owner_first_name || '').trim() ? ' ' + esc((workflow.owner_first_name || '').trim()) : ''},</p>
    ${personalNote && personalNote.trim()
      ? `<p style="margin:0 0 22px;font-size:14px;line-height:1.6;color:#444444;white-space:pre-line;">${esc(personalNote.trim())}</p>`
      : `<p style="margin:0 0 22px;font-size:14px;line-height:1.6;color:#444444;">${introLine}</p>`}
    ${itemsBlock}
    ${ctaBlock}
    <p style="font-size:14px;color:#444444;margin:0;">Thank you,</p>
    <p style="font-size:14px;color:#1a1a1a;margin:2px 0 0;font-weight:600;">Colleen</p>
    <p style="font-size:13px;color:#666666;margin:0;">Vista Business Group</p>
  </td></tr>
  <tr><td style="background:#f4f4f0;padding:14px 32px;text-align:center;">
    <div style="font-size:11px;color:#999999;">Vista Business Group &middot; This message is confidential.</div>
  </td></tr>
</table>
</td></tr>
</table>
</body>
</html>`;
  };

  const buildCadenceEmailNote = (variant) => {
    const fmtLongDate = (d) => {
      if (!d) return '';
      const dt = new Date(d + 'T00:00:00');
      if (isNaN(dt.getTime())) return '';
      return dt.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    };
    const bizDays = (from, to) => {
      if (!from) return null;
      const start = new Date(from + 'T00:00:00');
      const end = to ? new Date(to + 'T00:00:00') : new Date();
      start.setHours(0,0,0,0); end.setHours(0,0,0,0);
      if (isNaN(start.getTime())) return null;
      let count = 0;
      const cur = new Date(start);
      while (cur < end) {
        cur.setDate(cur.getDate() + 1);
        const dow = cur.getDay();
        if (dow !== 0 && dow !== 6) count++;
      }
      return count;
    };
    const plural = (n, s) => `${n} ${s}${n === 1 ? '' : 's'}`;

    // Read workflow via ref so the cadence body sees the loaded values
    // even when this runs from a setTimeout that captured an earlier
    // closure (e.g., from the autoAction effect's deferred trigger).
    const w = workflowRef.current || {};
    const targetDate = w.committed_upload_date;
    const todayIso = new Date().toISOString().slice(0, 10);
    const daysPastTarget = targetDate ? bizDays(targetDate, todayIso) : null;

    // Last upload: most recent dateReceived across the checklist.
    const receivedDates = (documentChecklist || [])
      .map(d => d.dateReceived)
      .filter(Boolean)
      .sort();
    const lastUploadDate = receivedDates.length ? receivedDates[receivedDates.length - 1] : null;
    const daysSinceLastUpload = lastUploadDate ? bizDays(lastUploadDate, todayIso) : null;

    // Items received counts — mirrors the OIR's planned-aware logic.
    const isUnlocked = (d) => {
      if (!Array.isArray(d.unlockedBy) || d.unlockedBy.length === 0) return true;
      return d.unlockedBy.some(id => {
        const pre = documentChecklist.find(x => x.id === id);
        return pre && pre.status === 'complete';
      });
    };
    const plannedDocs = (documentChecklist || []).filter(d => d.planned);
    const relevantDocs = plannedDocs.length > 0 ? plannedDocs : (documentChecklist || []).filter(isUnlocked);
    // Count includes partials so an owner who's sent 2 of 3 tax returns
    // (marked partial) gets engagement credit on that item (Mark 2026-05-27).
    // Stage C: also count items auto-Received via ShareFile (owner uploaded,
    // Konnie may not have entered yet) — otherwise the weekly "we've received
    // X of Y" tells someone who just uploaded that we haven't received it.
    const docsDone = relevantDocs.filter(d => d.status === 'complete' || d.status === 'partial' || !!sharefileReceived[String(d.id)]).length;
    const docsTotal = relevantDocs.length;
    const hasAnyUploads = docsDone > 0;

    const amName = (w.account_manager || '').trim() || 'Your account manager';

    if (variant === 'weekly') {
      // Mark 2026-05-27: dropped the "target date" framing entirely —
      // weekly emails are sent every 7 days until upload-complete, so a
      // running guilt-trip on the date isn't useful. Status sentence +
      // up to three response options.
      // "Press the pause button" maps onto the existing Snooze Until
      // mechanic — when an owner takes that option, Konnie sets snooze.
      const statusLine = hasAnyUploads
        ? `We've received ${docsDone} of the ${docsTotal} documents.`
        : `We haven't received any of the ${docsTotal} documents yet.`;
      // The "faster, less-complete valuation" bullet only makes sense
      // when VT actually has enough data to deliver one. Gate it on
      // (a) the engine having produced a value AND (b) at least one
      // doc received THIS cycle, so a fresh revalue doesn't offer to
      // discuss carried-forward stale numbers (Mark 2026-05-27).
      const accuracyScore = Math.round(accuracyGauge?.overallScore || 0);
      const valuationHigh = multipleEngineCalcs?.valuationMarketHigh || 0;
      const offerLessComplete = (accuracyScore > 0 && valuationHigh > 0) && docsDone > 0;
      const bullets = [
        '• If you\'d like help pulling any specific report, especially from QuickBooks, reply and I\'ll resend instructions.',
      ];
      if (offerLessComplete) {
        bullets.push('• If you\'d prefer a faster, less-complete valuation based on what we have so far, let me know.');
      }
      bullets.push('• If something has come up that needs your attention, let me know and we can press the pause button for a few days.');
      return [statusLine, '', ...bullets].join('\n');
    }

    if (variant === 'final-no-value') {
      return [
        `Wanted to send one final note. We haven't received the remaining items needed to complete your valuation, and I'd guess you've had more pressing things on your plate — completely understandable.`,
        '',
        `${amName} will reach back out in a few weeks to see where you're at. In the meantime if anything changes — if you'd like to resume, or if you've decided not to move forward — just reply and we'll take it from there.`,
      ].join('\n');
    }

    if (variant === 'final-meeting-offer') {
      return [
        `Wanted to send one final note. We haven't received all the items we originally needed, but you've provided enough that we have material worth discussing in person. If you'd like a preliminary call to walk through what we're seeing — including a working estimated-value range and what's still moving the number — just reply with a few times that work this week or next and I'll get it on the calendar. Otherwise ${amName} will reach back out in a few weeks.`,
      ].join('\n');
    }

    return '';
  };

  // Open the OIR in a new tab for review (Stage B3 preview; B4 adds sending).
  const previewOIR = () => {
    const html = buildOIREmailHtml();
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');
    if (win) win.focus();
    URL.revokeObjectURL(url);
  };

  // Pre-fill the To + CC from the stored owner contact (migration 010).
  // Reads from workflowRef so it always sees the latest values, even
  // when invoked from a setTimeout that captured an earlier closure.
  // Primary owner → To; additional owners → CC. For cadence sends
  // (Mark 2026-05-27), the project's AM + Lead are also CC'd. Konnie
  // can edit either field before sending.
  const prefillOwnerRecipients = (includeStaffCcs = false) => {
    const w = workflowRef.current || {};
    setOirTo((w.owner_email || '').trim());
    const emails = (w.owner_additional || [])
      .map(o => (o.email || '').trim())
      .filter(Boolean);
    if (includeStaffCcs) {
      const amEmail = staffEmailByName(w.account_manager);
      const leadEmail = staffEmailByName(w.lead);
      if (amEmail && !emails.includes(amEmail)) emails.push(amEmail);
      if (leadEmail && !emails.includes(leadEmail)) emails.push(leadEmail);
    }
    setOirCc(emails.join(', '));
  };

  // Open the OIR draft-email modal (Stage B4) — pre-fills the subject line.
  const openOIRModal = () => {
    setOirMode('oir');
    setOirSubject(`Valuation Status Update — ${(dealProfile.companyName || '').trim() || 'Your Business'}`);
    setOirNote('');
    setOirCadenceVariant(''); // vanilla OIR — not a cadence reminder
    prefillOwnerRecipients(false);
    setOirSendResult(null);
    setShowOIRModal(true);
  };

  // Open the combined owner-questions modal (Colleen's, sent as Colleen). To =
  // owner, CC = additional owners (no internal CC). The body lists all open
  // Ask-Owner questions; sending stamps each one and logs questions_sent.
  const openOwnerQuestionsModal = () => {
    setOirMode('questions');
    setQuestionsAnswerMode('portal'); // default to the portal-first wording
    setOirSubject(`A few questions on your valuation — ${(dealProfile.companyName || '').trim() || 'Your Business'}`);
    setOirNote('');
    setOirCadenceVariant('');
    prefillOwnerRecipients(false);
    setOirSendResult(null);
    setShowOIRModal(true);
  };

  // Open the modal with cadence-reminder pre-fill (Stage B5). Variant is
  // 'weekly' for the every-7-days check-in, 'final-no-value' / 'final-
  // meeting-offer' for the post-stop-date final email. Auto-CCs the
  // project's AM + Lead on FINAL variants only (the actual AM handoff
  // moment) — weekly check-ins skip the internal CC so AMs and Leads
  // don't get a per-project email every week (Mark 2026-05-27).
  const openCadenceReminderModal = (variant) => {
    setOirMode('oir');
    setOirSubject('Vista Business Group — Outstanding Items');
    setOirNote(buildCadenceEmailNote(variant));
    setOirCadenceVariant(variant);
    const isFinal = variant === 'final-no-value' || variant === 'final-meeting-offer';
    prefillOwnerRecipients(isFinal);
    setOirSendResult(null);
    setShowOIRModal(true);
  };

  // True when this valuation was opened from the Dashboard's Reminder Queue
  // (Compose), so closing the modal should drop the user back on My Work
  // rather than stranding them in the valuation editor they never meant to
  // sit in. Stable across renders (derived from the open-time prop).
  const openedForCadence = currentValuation?.autoAction === 'cadence-weekly'
    || currentValuation?.autoAction === 'cadence-final';

  // Close the OIR/cadence modal. If we got here via the Reminder Queue,
  // return straight to the Dashboard (skips the internal exit checks —
  // a cadence send never touches valuation data, so there's nothing to
  // confirm or save).
  const closeOIRModal = () => {
    setShowOIRModal(false);
    setOirMode('oir');
    if (openedForCadence && onBackToList) onBackToList();
  };

  // Auto-fire from the Dashboard's Reminder Queue. The dashboard passes
  // currentValuation.autoAction = 'cadence-weekly' | 'cadence-final'; we
  // resolve 'cadence-final' here (need loaded value/accuracy to pick the
  // sub-variant) and trigger the modal once the valuation is ready.
  useEffect(() => {
    if (cadenceAutoActionFiredRef.current) return;
    if (!currentValuationId) return; // wait for the row to land
    const auto = currentValuation?.autoAction;
    if (!auto) return;
    if (auto === 'cadence-weekly') {
      cadenceAutoActionFiredRef.current = true;
      setTimeout(() => openCadenceReminderModal('weekly'), 200);
    } else if (auto === 'cadence-final') {
      cadenceAutoActionFiredRef.current = true;
      setTimeout(() => {
        const accuracyScore = Math.round(accuracyGauge?.overallScore || 0);
        const valuationHigh = multipleEngineCalcs?.valuationMarketHigh || 0;
        const hasData = accuracyScore > 0 && valuationHigh > 0;
        openCadenceReminderModal(hasData ? 'final-meeting-offer' : 'final-no-value');
      }, 200);
    }
  }, [currentValuationId]);

  // Send the OIR via the B2 endpoint, then log it to the activity log.
  const sendOIR = async () => {
    if (isReadOnlyViewer) return; // read-only viewers (AMs) can't send email as staff
    if (!oirTo.trim() || !oirSubject.trim()) {
      setOirSendResult({ ok: false, msg: 'Recipient email and subject are both required.' });
      return;
    }
    setOirSending(true);
    setOirSendResult(null);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) throw new Error('Your session expired — reload the page and sign in again.');
      const body = buildOIREmailHtml(oirNote, { cadenceVariant: oirCadenceVariant });
      const ccTrimmed = (oirCc || '').trim();
      const resp = await fetch('/api/gmail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ to: oirTo.trim(), cc: ccTrimmed || undefined, subject: oirSubject.trim(), body }),
      });
      const result = await resp.json().catch(() => ({}));
      if (!resp.ok || !result.ok) throw new Error(result.error || `Send failed (HTTP ${resp.status})`);

      // Cadence-mode send (Stage B5): log reminder_sent + flip stage on
      // final variants. Vanilla OIR send: log oir_sent (existing behavior).
      const isCadence = !!oirCadenceVariant;
      const isFinal = oirCadenceVariant === 'final-no-value' || oirCadenceVariant === 'final-meeting-offer';

      if (currentValuationId) {
        if (isCadence) {
          await logActivity(currentValuationId, 'reminder_sent',
            `Cadence ${isFinal ? 'final' : 'weekly'} reminder emailed to ${oirTo.trim()}`,
            {
              to: oirTo.trim(),
              subject: oirSubject.trim(),
              variant: oirCadenceVariant,
              value_low: multipleEngineCalcs?.valuationTypical || 0,
              value_high: multipleEngineCalcs?.valuationMarketHigh || 0,
              accuracy_pct: Math.round(accuracyGauge?.overallScore || 0),
            });
        } else {
          await logActivity(currentValuationId, 'oir_sent', `OIR emailed to ${oirTo.trim()}`, {
            to: oirTo.trim(),
            subject: oirSubject.trim(),
            value_low: multipleEngineCalcs?.valuationTypical || 0,
            value_high: multipleEngineCalcs?.valuationMarketHigh || 0,
            accuracy_pct: Math.round(accuracyGauge?.overallScore || 0),
          });
        }
      }

      // Final-variant side effect: flip the project to stalled_returned_to_am
      // (Mark 2026-05-27 — clear out the noise; reinstate manually if owner
      // responds). Persist directly so the flip doesn't depend on the next
      // autosave cycle in case the user navigates away.
      if (isCadence && isFinal && currentValuationId && supabaseClient) {
        const oldStage = workflow.workflow_stage;
        const nowIso = new Date().toISOString();
        try {
          const tabWasCurrent = await tabIsCurrent();
          const { data: ret } = await supabaseClient.from('valuations')
            .update({ workflow_stage: 'stalled_returned_to_am', stage_entered_at: nowIso, likelihood_pct: 0, updated_at: nowIso })
            .eq('id', currentValuationId).select('updated_at').single();
          if (ret?.updated_at && tabWasCurrent) loadedUpdatedAtRef.current = ret.updated_at;
          setWorkflow(w => ({ ...w, workflow_stage: 'stalled_returned_to_am', stage_entered_at: nowIso, likelihood_pct: 0 }));
          await logActivity(currentValuationId, 'stage_changed',
            'Returned to AM — cadence final reminder sent',
            { from: oldStage, to: 'stalled_returned_to_am', reason: 'cadence-final' });
        } catch (e) {
          console.warn('Cadence final stage-flip failed (email already sent):', e);
        }
      }

      setOirSendResult({ ok: true, msg: isFinal
        ? 'Sent — project marked stalled and returned to AM.'
        : 'Sent — and logged to the activity log.' });
      setTimeout(() => closeOIRModal(), 1400);
    } catch (err) {
      setOirSendResult({ ok: false, msg: err.message || 'Send failed.' });
    } finally {
      setOirSending(false);
    }
  };

  // Send Colleen's combined owner-questions email (sent AS Colleen via the
  // multi-sender endpoint). On success: stamp `sentAt` on each included
  // Ask-Owner item (so it moves from "to send" to "awaiting answer") and log
  // a project-level `questions_sent` activity, which the question-cadence
  // keys off. (2026-06-08)
  const sendOwnerQuestions = async () => {
    if (isReadOnlyViewer) return; // read-only viewers (AMs) can't send email as staff
    if (!oirTo.trim() || !oirSubject.trim()) {
      setOirSendResult({ ok: false, msg: 'Recipient email and subject are both required.' });
      return;
    }
    if (openOwnerQuestions.length === 0) {
      setOirSendResult({ ok: false, msg: 'There are no open owner questions to send.' });
      return;
    }
    setOirSending(true);
    setOirSendResult(null);
    try {
      const { data: { session } } = await supabaseClient.auth.getSession();
      const accessToken = session && session.access_token;
      if (!accessToken) throw new Error('Your session expired — reload the page and sign in again.');
      // Persist the questions to the DB BEFORE the email goes out (#10). The
      // owner portal reads SAVED data, so without this the editor's autosave
      // debounce can lag behind the email and the owner clicks the link to an
      // empty list. Flushing here makes the question live the instant they open.
      try { await saveDeal(); } catch (e) { console.warn('Pre-send save (owner questions) failed:', e); }
      const body = buildOwnerQuestionsEmailHtml(oirNote, questionsAnswerMode);
      const ccTrimmed = (oirCc || '').trim();
      const resp = await fetch('/api/gmail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + accessToken },
        body: JSON.stringify({ to: oirTo.trim(), cc: ccTrimmed || undefined, subject: oirSubject.trim(), body, sender: 'colleen' }),
      });
      const result = await resp.json().catch(() => ({}));
      if (!resp.ok || !result.ok) throw new Error(result.error || `Send failed (HTTP ${resp.status})`);

      // Stamp sentAt on every question we just sent (refreshes the awaiting
      // clock for re-sends too) and persist via the normal autosave path.
      const nowIso = new Date().toISOString();
      const sentIds = new Set(openOwnerQuestions.map(q => q.id));
      setResearchItems(items => (items || []).map(r => sentIds.has(r.id) ? { ...r, sentAt: nowIso } : r));
      setHasUnsavedChanges(true);

      if (currentValuationId) {
        await logActivity(currentValuationId, 'questions_sent',
          `${sentIds.size} owner question${sentIds.size === 1 ? '' : 's'} emailed to ${oirTo.trim()}`,
          { to: oirTo.trim(), subject: oirSubject.trim(), count: sentIds.size });
      }

      setOirSendResult({ ok: true, msg: 'Sent — questions logged; they\'ll show as awaiting answers.' });
      setTimeout(() => closeOIRModal(), 1400);
    } catch (err) {
      setOirSendResult({ ok: false, msg: err.message || 'Send failed.' });
    } finally {
      setOirSending(false);
    }
  };

  const generateFinancialSummaryHTML = (data) => {
    const { company, basis, yearLabels, ttmLabel: exportTtmLabel, financials, adjustments, totalAdjustments, normalizedEbitda, calculations, adjustmentItems, valuation, ownerCompensation, lineBasedAdjustments, diatBreakdown } = data;
    const ttmLabelStr = exportTtmLabel || 'TTM';
    
    // Calculate margin percentages
    const gpMargin3 = financials.revenue.year3 ? ((financials.grossProfit.year3 / financials.revenue.year3) * 100).toFixed(1) : 0;
    const gpMargin4 = financials.revenue.year4 ? ((financials.grossProfit.year4 / financials.revenue.year4) * 100).toFixed(1) : 0;
    const gpMargin5 = financials.revenue.year5 ? ((financials.grossProfit.year5 / financials.revenue.year5) * 100).toFixed(1) : 0;
    const gpMarginTtm = financials.revenue.ttm ? ((financials.grossProfit.ttm / financials.revenue.ttm) * 100).toFixed(1) : 0;
    
    const niMargin3 = financials.revenue.year3 ? ((financials.netIncome.year3 / financials.revenue.year3) * 100).toFixed(1) : 0;
    const niMargin4 = financials.revenue.year4 ? ((financials.netIncome.year4 / financials.revenue.year4) * 100).toFixed(1) : 0;
    const niMargin5 = financials.revenue.year5 ? ((financials.netIncome.year5 / financials.revenue.year5) * 100).toFixed(1) : 0;
    const niMarginTtm = financials.revenue.ttm ? ((financials.netIncome.ttm / financials.revenue.ttm) * 100).toFixed(1) : 0;
    
    const ebitdaMargin3 = financials.revenue.year3 ? ((financials.ebitda.year3 / financials.revenue.year3) * 100).toFixed(1) : 0;
    const ebitdaMargin4 = financials.revenue.year4 ? ((financials.ebitda.year4 / financials.revenue.year4) * 100).toFixed(1) : 0;
    const ebitdaMargin5 = financials.revenue.year5 ? ((financials.ebitda.year5 / financials.revenue.year5) * 100).toFixed(1) : 0;
    const ebitdaMarginTtm = financials.revenue.ttm ? ((financials.ebitda.ttm / financials.revenue.ttm) * 100).toFixed(1) : 0;
    
    // Get normalized EBITDA for each year from calculations
    const normEbitda3 = calculations?.years?.[2]?.adjustedEbitda || financials.ebitda.year3;
    const normEbitda4 = calculations?.years?.[3]?.adjustedEbitda || financials.ebitda.year4;
    const normEbitda5 = calculations?.years?.[4]?.adjustedEbitda || financials.ebitda.year5;
    const normEbitdaTtm = calculations?.years?.[5]?.adjustedEbitda || normalizedEbitda;
    
    const normMargin3 = financials.revenue.year3 ? ((normEbitda3 / financials.revenue.year3) * 100).toFixed(1) : 0;
    const normMargin4 = financials.revenue.year4 ? ((normEbitda4 / financials.revenue.year4) * 100).toFixed(1) : 0;
    const normMargin5 = financials.revenue.year5 ? ((normEbitda5 / financials.revenue.year5) * 100).toFixed(1) : 0;
    const normMarginTtm = financials.revenue.ttm ? ((normEbitdaTtm / financials.revenue.ttm) * 100).toFixed(1) : 0;
    
    // Get per-period adjustments - calculate as difference between normalized and reported EBITDA
    // This ensures the math is always consistent: Reported + Adjustments = Normalized
    const adj3 = normEbitda3 - financials.ebitda.year3;
    const adj4 = normEbitda4 - financials.ebitda.year4;
    const adj5 = normEbitda5 - financials.ebitda.year5;
    const adjTtm = normEbitdaTtm - financials.ebitda.ttm;
    
    const adjPct3 = financials.revenue.year3 ? ((adj3 / financials.revenue.year3) * 100).toFixed(1) : 0;
    const adjPct4 = financials.revenue.year4 ? ((adj4 / financials.revenue.year4) * 100).toFixed(1) : 0;
    const adjPct5 = financials.revenue.year5 ? ((adj5 / financials.revenue.year5) * 100).toFixed(1) : 0;
    const adjPctTtm = financials.revenue.ttm ? ((adjTtm / financials.revenue.ttm) * 100).toFixed(1) : 0;
    
    return `
      <!-- Vista Header -->
      <div style="display:flex;align-items:center;gap:15px;margin-bottom:20px;padding-bottom:15px;border-bottom:2px solid #3d5c35;">
        <img src="${vistaLogoBase64}" alt="Vista Business Group" style="height:50px;" onerror="this.style.display='none'">
        <div>
          <div style="font-size:18px;font-weight:700;color:#3d5c35;">Vista Business Group</div>
          <div style="font-size:11px;color:#6b7280;">Confidential Business Valuation</div>
          <div style="font-size:10px;color:#3d5c35;">Vistabusinessgroup.com</div>
        </div>
      </div>
      
      <!-- Executive Summary Banner -->
      <div style="background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);color:white;padding:25px 30px;border-radius:10px;margin-bottom:25px;">
        <div style="text-align:center;margin-bottom:20px;">
          <div style="font-size:12px;text-transform:uppercase;letter-spacing:1px;opacity:0.9;margin-bottom:5px;">Business Valuation Summary</div>
          <div style="font-size:28px;font-weight:700;">${company.name}</div>
        </div>
        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:20px;text-align:center;">
          <div style="background:rgba(255,255,255,0.15);padding:15px;border-radius:8px;">
            <div style="font-size:10px;text-transform:uppercase;opacity:0.9;margin-bottom:5px;">Estimated Value Range</div>
            <div style="font-size:20px;font-weight:700;">${fmt(valuation?.valuationLow || 0)} - ${fmt(valuation?.valuationHigh || 0)}</div>
          </div>
          <div style="background:rgba(255,255,255,0.15);padding:15px;border-radius:8px;">
            <div style="font-size:10px;text-transform:uppercase;opacity:0.9;margin-bottom:5px;">${data.maintCapex > 0 ? 'Normalized EBITDA after capex' : 'Normalized EBITDA'}</div>
            <div style="font-size:20px;font-weight:700;">${fmt(normalizedEbitda)}</div>
          </div>
          <div style="background:rgba(255,255,255,0.15);padding:15px;border-radius:8px;">
            <div style="font-size:10px;text-transform:uppercase;opacity:0.9;margin-bottom:5px;">Valuation Multiple</div>
            <div style="font-size:20px;font-weight:700;">${valuation?.typicalMultiple?.toFixed(2) || '0.00'}x - ${valuation?.marketHighMultiple?.toFixed(2) || '0.00'}x</div>
          </div>
        </div>
      </div>
      
      <div class="page-break"></div>
      
      <!-- Section 1: Understanding Your Normalized Financials -->
      <div class="section-header">Understanding Your Normalized Financials</div>
      <div class="section-content">
        <div class="section-intro">
          <strong>What is "Normalized" EBITDA?</strong> When valuing a business, buyers look beyond reported financials to understand 
          the true economic earnings available to a new owner. Normalization adjusts for owner-specific expenses (like above-market 
          compensation), one-time items, and non-operating costs to reveal the sustainable cash flow a buyer can expect. This provides 
          an apples-to-apples comparison with other acquisition targets and is the foundation of your business valuation.
        </div>
        
        <div style="background:#fff;border:1px solid #d1d9cf;border-radius:6px;padding:12px;text-align:center;margin-bottom:18px;">
          <span style="color:#6b7280;font-size:10px;">VALUATION BASIS:</span> 
          <span style="color:#3d5c35;font-weight:600;margin-left:8px;">${basis.label}</span>
          <span style="margin:0 15px;color:#d1d9cf;">|</span>
          <span style="color:#6b7280;font-size:10px;">PERIOD:</span>
          <span style="color:#3d5c35;font-weight:600;margin-left:8px;">Trailing Twelve Months (TTM)</span>
        </div>
        
        <table style="width:100%;border-collapse:collapse;font-size:11px;">
          <thead>
            <tr>
              <th style="text-align:left;width:200px;">Line Item</th>
              <th style="text-align:center;width:100px;">${yearLabels.year3 || 'Year 3'}</th>
              <th style="text-align:center;width:100px;">${yearLabels.year4 || 'Year 4'}</th>
              <th style="text-align:center;width:100px;">${yearLabels.year5 || 'Year 5'}</th>
              <th style="text-align:center;width:100px;background:#2d4a27;">${ttmLabelStr}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="font-weight:500;">Revenue</td>
              <td style="text-align:right;">${fmt(financials.revenue.year3)}</td>
              <td style="text-align:right;">${fmt(financials.revenue.year4)}</td>
              <td style="text-align:right;">${fmt(financials.revenue.year5)}</td>
              <td style="text-align:right;font-weight:600;background:#f0f4ef;">${fmt(financials.revenue.ttm)}</td>
            </tr>
            <tr style="background:#fafafa;">
              <td style="font-weight:500;">COGS</td>
              <td style="text-align:right;color:#dc2626;">(${fmt(financials.cogs.year3)})</td>
              <td style="text-align:right;color:#dc2626;">(${fmt(financials.cogs.year4)})</td>
              <td style="text-align:right;color:#dc2626;">(${fmt(financials.cogs.year5)})</td>
              <td style="text-align:right;color:#dc2626;background:#f0f4ef;">(${fmt(financials.cogs.ttm)})</td>
            </tr>
            <tr class="highlight-row">
              <td style="font-weight:600;">Gross Profit</td>
              <td style="text-align:right;">${fmt(financials.grossProfit.year3)}</td>
              <td style="text-align:right;">${fmt(financials.grossProfit.year4)}</td>
              <td style="text-align:right;">${fmt(financials.grossProfit.year5)}</td>
              <td style="text-align:right;background:#e8ede6;">${fmt(financials.grossProfit.ttm)}</td>
            </tr>
            <tr style="font-size:10px;color:#6b7280;font-style:italic;">
              <td style="padding-left:20px;">Gross Margin %</td>
              <td style="text-align:right;">${gpMargin3}%</td>
              <td style="text-align:right;">${gpMargin4}%</td>
              <td style="text-align:right;">${gpMargin5}%</td>
              <td style="text-align:right;background:#f0f4ef;">${gpMarginTtm}%</td>
            </tr>
            <tr>
              <td style="font-weight:500;">Operating Expenses</td>
              <td style="text-align:right;color:#dc2626;">(${fmt(financials.opex.year3)})</td>
              <td style="text-align:right;color:#dc2626;">(${fmt(financials.opex.year4)})</td>
              <td style="text-align:right;color:#dc2626;">(${fmt(financials.opex.year5)})</td>
              <td style="text-align:right;color:#dc2626;background:#f0f4ef;">(${fmt(financials.opex.ttm)})</td>
            </tr>
            <tr class="highlight-row">
              <td style="font-weight:600;">Net Income</td>
              <td style="text-align:right;">${fmt(financials.netIncome.year3)}</td>
              <td style="text-align:right;">${fmt(financials.netIncome.year4)}</td>
              <td style="text-align:right;">${fmt(financials.netIncome.year5)}</td>
              <td style="text-align:right;background:#e8ede6;">${fmt(financials.netIncome.ttm)}</td>
            </tr>
            <tr style="font-size:10px;color:#6b7280;font-style:italic;">
              <td style="padding-left:20px;">Net Margin %</td>
              <td style="text-align:right;">${niMargin3}%</td>
              <td style="text-align:right;">${niMargin4}%</td>
              <td style="text-align:right;">${niMargin5}%</td>
              <td style="text-align:right;background:#f0f4ef;">${niMarginTtm}%</td>
            </tr>
            <tr style="background:#fafafa;">
              <td style="font-weight:500;color:#4b5563;">+ Interest, Taxes, D&A</td>
              <td style="text-align:right;color:#4b5563;">${fmt(financials.diat.year3)}</td>
              <td style="text-align:right;color:#4b5563;">${fmt(financials.diat.year4)}</td>
              <td style="text-align:right;color:#4b5563;">${fmt(financials.diat.year5)}</td>
              <td style="text-align:right;color:#4b5563;background:#f0f4ef;">${fmt(financials.diat.ttm)}</td>
            </tr>
            <tr class="highlight-row">
              <td style="font-weight:600;">Reported EBITDA</td>
              <td style="text-align:right;">${fmt(financials.ebitda.year3)}</td>
              <td style="text-align:right;">${fmt(financials.ebitda.year4)}</td>
              <td style="text-align:right;">${fmt(financials.ebitda.year5)}</td>
              <td style="text-align:right;background:#e8ede6;">${fmt(financials.ebitda.ttm)}</td>
            </tr>
            <tr style="font-size:10px;color:#6b7280;font-style:italic;">
              <td style="padding-left:20px;">EBITDA Margin %</td>
              <td style="text-align:right;">${ebitdaMargin3}%</td>
              <td style="text-align:right;">${ebitdaMargin4}%</td>
              <td style="text-align:right;">${ebitdaMargin5}%</td>
              <td style="text-align:right;background:#f0f4ef;">${ebitdaMarginTtm}%</td>
            </tr>
            <tr style="background:#f8faf7;">
              <td style="font-weight:500;color:#3d5c35;">+ Normalizing Adjustments</td>
              <td style="text-align:right;color:#3d5c35;">${fmt(adj3)}</td>
              <td style="text-align:right;color:#3d5c35;">${fmt(adj4)}</td>
              <td style="text-align:right;color:#3d5c35;">${fmt(adj5)}</td>
              <td style="text-align:right;color:#3d5c35;background:#e8ede6;">${fmt(adjTtm)}</td>
            </tr>
            <tr style="font-size:10px;color:#6b7280;font-style:italic;">
              <td style="padding-left:20px;">Adjustments as % of Revenue</td>
              <td style="text-align:right;">${adjPct3}%</td>
              <td style="text-align:right;">${adjPct4}%</td>
              <td style="text-align:right;">${adjPct5}%</td>
              <td style="text-align:right;background:#f0f4ef;">${adjPctTtm}%</td>
            </tr>
            <tr class="total-row">
              <td style="font-weight:700;">${data.maintCapex > 0 ? 'Normalized EBITDA after capex' : 'Normalized EBITDA'}</td>
              <td style="text-align:right;">${fmt(normEbitda3)}</td>
              <td style="text-align:right;">${fmt(normEbitda4)}</td>
              <td style="text-align:right;">${fmt(normEbitda5)}</td>
              <td style="text-align:right;background:#c8d9c3;">${fmt(normEbitdaTtm)}</td>
            </tr>
            <tr style="font-size:10px;color:#166534;font-style:italic;font-weight:500;">
              <td style="padding-left:20px;">${data.maintCapex > 0 ? 'Normalized EBITDA after capex margin %' : 'Normalized EBITDA Margin %'}</td>
              <td style="text-align:right;">${normMargin3}%</td>
              <td style="text-align:right;">${normMargin4}%</td>
              <td style="text-align:right;">${normMargin5}%</td>
              <td style="text-align:right;background:#e8ede6;">${normMarginTtm}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      ${adjustments.length > 0 || (lineBasedAdjustments && lineBasedAdjustments.length > 0) ? `
      <div class="page-break"></div>
      
      <!-- Section 2: How We Calculate Normalized EBITDA -->
      <div class="section-header">How We Calculate Normalized EBITDA</div>
      <div class="section-content">
        <div class="section-intro">
          <strong>Why Normalize EBITDA?</strong> Buyers don't just look at your reported earnings—they want to understand what they'll 
          actually earn as the new owner. We start with Net Income, add back non-cash and financing items (D/I/A/T), then adjust for 
          owner-specific items and non-recurring expenses. This "Normalized EBITDA" is the foundation of your valuation.
        </div>
        
        ${ownerCompensation?.marketReplacement > 0 ? `
        <div style="background:#f0f7ee;border:1px solid #a7c4a0;border-radius:6px;padding:12px;margin-bottom:15px;">
          <div style="font-weight:600;color:#2d5a27;font-size:11px;margin-bottom:8px;">Understanding Owner Compensation Adjustments</div>
          <div style="font-size:10px;color:#4b5563;line-height:1.5;">
            <p style="margin:0 0 8px 0;">
              <strong>Market Replacement Rate:</strong> ${fmt(ownerCompensation.marketReplacement)}/year
            </p>
            ${ownerCompensation.marketReplacementNotes ? `
            <p style="margin:0 0 8px 0;padding:6px 8px;background:#fff;border:1px solid #d1d5db;border-radius:4px;font-style:italic;color:#374151;">
              <strong style="font-style:normal;">Rationale:</strong> ${ownerCompensation.marketReplacementNotes}
            </p>
            ` : ''}
            <p style="margin:0;color:#6b7280;">
              This is the estimated cost to hire a professional manager to perform the owner's operational duties. 
              Owner compensation above this amount is added back because a buyer would not need to pay above-market 
              salaries. Benefits, perks, and personal expenses run through the business are also added back as they 
              represent owner discretionary spending rather than true business expenses.
            </p>
          </div>
        </div>
        ` : ''}
        
        ${(() => {
          // Build the canonical Norm EBITDA model — same helper used by the
          // CIM Excel export, so both views always agree.
          const m = buildNormalizedEbitdaModel({
            adjustments,
            lineBasedAdjustments,
            diatBreakdown,
            ownerCompensation,
            yearLabels,
            ttmLabel: ttmLabelStr,
            payrollTaxMethod, payrollTaxYears,
            netIncome: financials.netIncome,
            engineEbitda: {
              year3: calculations?.years?.[2]?.adjustedEbitda || 0,
              year4: calculations?.years?.[3]?.adjustedEbitda || 0,
              year5: calculations?.years?.[4]?.adjustedEbitda || 0,
              // TTM column must always be the genuine TTM EBITDA, not valuation.metric
              // (which holds the selected valuation period — TTM/last year/average/weighted).
              ttm:   calculations?.ebitdaOptions?.ttm || calculations?.years?.[5]?.adjustedEbitda || 0
            }
          });

          // Bind model output to the local variable names used by the
          // existing renderer below — keeps the JSX-style HTML untouched.
          const combinedDiat = m.diat;
          const diatTotal = m.diat.total;
          const groupedOwnerComp = Object.fromEntries(m.ownerCompRows.map((r, i) => [r.plLine + '|' + i, r]));
          const groupedOther     = Object.fromEntries(m.otherRows.map((r, i) => [r.plLine + '|' + i, r]));
          const ownerCompTotal = m.totals.ownerComp;
          const otherTotal     = m.totals.other;
          const ownerCompNetTotal = ownerCompTotal;
          const totalNormalizingAdj = m.totals.normalizing;
          const hasOwnerComp = m.ownerCompRows.length > 0;
          const hasOther     = m.otherRows.length > 0;
          const hasMarketReplacement = m.marketReplacement.amount > 0;
          const calcNormEbitda = {
            year3: m.adjustedEbitda.year3 || m.reconciliation.breakdownTotal.year3,
            year4: m.adjustedEbitda.year4 || m.reconciliation.breakdownTotal.year4,
            year5: m.adjustedEbitda.year5 || m.reconciliation.breakdownTotal.year5,
            ttm:   m.adjustedEbitda.ttm   || m.reconciliation.breakdownTotal.ttm
          };
          
          const generateRows = (grouped, sorted = false) => {
            let items = Object.values(grouped).filter(grp => grp.year3 !== 0 || grp.year4 !== 0 || grp.year5 !== 0 || grp.ttm !== 0);
            if (sorted) {
              items = items.sort((a, b) => (a.sortOrder || 99) - (b.sortOrder || 99));
            }
            return items.map(grp => {
              return '<tr>' +
                '<td style="font-weight:500;padding-left:15px;">' + (grp.plLine || '-') + '</td>' +
                '<td>' + grp.description + '</td>' +
                '<td style="text-align:right;color:' + (grp.year3 >= 0 ? '#166534' : '#dc2626') + ';">' + (grp.year3 !== 0 ? (grp.year3 >= 0 ? '+' : '') + fmt(grp.year3) : '-') + '</td>' +
                '<td style="text-align:right;color:' + (grp.year4 >= 0 ? '#166534' : '#dc2626') + ';">' + (grp.year4 !== 0 ? (grp.year4 >= 0 ? '+' : '') + fmt(grp.year4) : '-') + '</td>' +
                '<td style="text-align:right;color:' + (grp.year5 >= 0 ? '#166534' : '#dc2626') + ';">' + (grp.year5 !== 0 ? (grp.year5 >= 0 ? '+' : '') + fmt(grp.year5) : '-') + '</td>' +
                '<td style="text-align:right;color:' + (grp.ttm >= 0 ? '#166534' : '#dc2626') + ';background:#f0f4ef;">' + (grp.ttm !== 0 ? (grp.ttm >= 0 ? '+' : '') + fmt(grp.ttm) : '-') + '</td>' +
                '</tr>';
            }).join('');
          };
          
          let html = '<table style="width:100%;border-collapse:collapse;font-size:11px;">' +
            '<thead><tr style="background:#3d5c35;color:white;">' +
            '<th style="text-align:left;width:130px;padding:8px;">Category</th>' +
            '<th style="text-align:left;padding:8px;">Description</th>' +
            '<th style="text-align:right;width:85px;padding:8px;">' + (yearLabels.year3 || 'Year 3') + '</th>' +
            '<th style="text-align:right;width:85px;padding:8px;">' + (yearLabels.year4 || 'Year 4') + '</th>' +
            '<th style="text-align:right;width:85px;padding:8px;">' + (yearLabels.year5 || 'Year 5') + '</th>' +
            '<th style="text-align:right;width:85px;padding:8px;background:#2d4a27;">' + ttmLabelStr + '</th>' +
            '</tr></thead><tbody>';
          
          // Starting Point: Net Income
          html += '<tr style="background:#f8f9fa;border-bottom:2px solid #e5e7eb;">' +
            '<td colspan="2" style="padding:10px 8px;font-weight:700;color:#374151;">Reported Net Income</td>' +
            '<td style="text-align:right;padding:8px;font-weight:600;">' + fmt(financials.netIncome.year3) + '</td>' +
            '<td style="text-align:right;padding:8px;font-weight:600;">' + fmt(financials.netIncome.year4) + '</td>' +
            '<td style="text-align:right;padding:8px;font-weight:600;">' + fmt(financials.netIncome.year5) + '</td>' +
            '<td style="text-align:right;padding:8px;font-weight:600;background:#e8ede6;">' + fmt(financials.netIncome.ttm) + '</td>' +
            '</tr>';
          
          // D/I/A/T Section - use neutral gray styling
          html += '<tr style="background:#f1f5f9;">' +
            '<td colspan="6" style="padding:10px 8px 6px;font-weight:700;color:#475569;font-size:12px;border-bottom:2px solid #94a3b8;">' +
            'Add: Depreciation, Interest, Amortization & Taxes (D/I/A/T)' +
            '<div style="font-size:9px;font-weight:400;color:#64748b;margin-top:2px;">Non-cash and financing items added back to arrive at EBITDA</div>' +
            '</td></tr>';
          
          // Individual D/I/A/T rows - use combinedDiat which includes line-based adjustments
          if (combinedDiat.depreciation.ttm !== 0 || combinedDiat.depreciation.year3 !== 0 || combinedDiat.depreciation.year4 !== 0 || combinedDiat.depreciation.year5 !== 0) {
            const depItems = combinedDiat.depreciation.items.length > 0 ? combinedDiat.depreciation.items.map(i => i.name).join(', ') : 'Non-cash expense';
            html += '<tr style="background:#f8fafc;"><td style="padding-left:15px;">Depreciation</td><td style="font-size:10px;color:#64748b;">' + depItems + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.depreciation.year3) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.depreciation.year4) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.depreciation.year5) + '</td>' +
              '<td style="text-align:right;color:#166534;background:#e8ede6;">+' + fmt(combinedDiat.depreciation.ttm) + '</td></tr>';
          }
          if (combinedDiat.interest.ttm !== 0 || combinedDiat.interest.year3 !== 0 || combinedDiat.interest.year4 !== 0 || combinedDiat.interest.year5 !== 0) {
            const intItems = combinedDiat.interest.items.length > 0 ? combinedDiat.interest.items.map(i => i.name).join(', ') : 'Financing cost';
            html += '<tr style="background:#f8fafc;"><td style="padding-left:15px;">Interest Expense</td><td style="font-size:10px;color:#64748b;">' + intItems + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.interest.year3) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.interest.year4) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.interest.year5) + '</td>' +
              '<td style="text-align:right;color:#166534;background:#e8ede6;">+' + fmt(combinedDiat.interest.ttm) + '</td></tr>';
          }
          if (combinedDiat.amortization.ttm !== 0 || combinedDiat.amortization.year3 !== 0 || combinedDiat.amortization.year4 !== 0 || combinedDiat.amortization.year5 !== 0) {
            const amortItems = combinedDiat.amortization.items.length > 0 ? combinedDiat.amortization.items.map(i => i.name).join(', ') : 'Non-cash expense';
            html += '<tr style="background:#f8fafc;"><td style="padding-left:15px;">Amortization</td><td style="font-size:10px;color:#64748b;">' + amortItems + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.amortization.year3) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.amortization.year4) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.amortization.year5) + '</td>' +
              '<td style="text-align:right;color:#166534;background:#e8ede6;">+' + fmt(combinedDiat.amortization.ttm) + '</td></tr>';
          }
          if (combinedDiat.taxes.ttm !== 0 || combinedDiat.taxes.year3 !== 0 || combinedDiat.taxes.year4 !== 0 || combinedDiat.taxes.year5 !== 0) {
            const taxItems = combinedDiat.taxes.items.length > 0 ? combinedDiat.taxes.items.map(i => i.name).join(', ') : 'Tax expense';
            html += '<tr style="background:#f8fafc;"><td style="padding-left:15px;">Income Taxes</td><td style="font-size:10px;color:#64748b;">' + taxItems + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.taxes.year3) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.taxes.year4) + '</td>' +
              '<td style="text-align:right;color:#166534;">+' + fmt(combinedDiat.taxes.year5) + '</td>' +
              '<td style="text-align:right;color:#166534;background:#e8ede6;">+' + fmt(combinedDiat.taxes.ttm) + '</td></tr>';
          }
          
          // D/I/A/T Subtotal
          html += '<tr style="background:#e2e8f0;border-top:1px solid #94a3b8;">' +
            '<td colspan="2" style="font-weight:600;color:#475569;padding:8px;">Subtotal: D/I/A/T Add-backs</td>' +
            '<td style="text-align:right;color:#166534;font-weight:600;">+' + fmt(diatTotal.year3) + '</td>' +
            '<td style="text-align:right;color:#166534;font-weight:600;">+' + fmt(diatTotal.year4) + '</td>' +
            '<td style="text-align:right;color:#166534;font-weight:600;">+' + fmt(diatTotal.year5) + '</td>' +
            '<td style="text-align:right;color:#166534;font-weight:600;background:#cbd5e1;">+' + fmt(diatTotal.ttm) + '</td>' +
            '</tr>';
          
          // Reported EBITDA row
          html += '<tr style="background:#e5e7eb;border-top:2px solid #9ca3af;border-bottom:2px solid #9ca3af;">' +
            '<td colspan="2" style="padding:10px 8px;font-weight:700;color:#374151;">= Reported EBITDA</td>' +
            '<td style="text-align:right;padding:8px;font-weight:700;">' + fmt(financials.ebitda.year3) + '</td>' +
            '<td style="text-align:right;padding:8px;font-weight:700;">' + fmt(financials.ebitda.year4) + '</td>' +
            '<td style="text-align:right;padding:8px;font-weight:700;">' + fmt(financials.ebitda.year5) + '</td>' +
            '<td style="text-align:right;padding:8px;font-weight:700;background:#d1d5db;">' + fmt(financials.ebitda.ttm) + '</td>' +
            '</tr>';
          
          // Owner Compensation Section
          if (hasOwnerComp || hasMarketReplacement) {
            html += '<tr style="background:#e8f5e3;">' +
              '<td colspan="6" style="padding:10px 8px 6px;font-weight:700;color:#2d5a27;font-size:12px;border-bottom:2px solid #3d5c35;">' +
              'Add: Owner Compensation Adjustments' +
              '<div style="font-size:9px;font-weight:400;color:#4a7c59;margin-top:2px;">Normalizes owner pay to market rate. If owner was paid above market, EBITDA increases. If below market, EBITDA decreases.</div>' +
              '</td></tr>' +
              generateRows(groupedOwnerComp, true);
            
            // Market replacement is now included in the Owner Salary line (shows net: salary - market)
            // so no separate "Less: Market Replacement" line needed
            
            const netExplanation = ownerCompNetTotal.ttm >= 0 
              ? 'Adds to EBITDA (owner paid above market)' 
              : 'Reduces EBITDA (owner paid below market)';
            
            html += '<tr style="background:#d4e8cf;">' +
              '<td style="font-weight:600;color:#2d5a27;padding:8px;">Net Owner Compensation</td>' +
              '<td style="font-size:9px;color:#4a7c59;">' + netExplanation + '</td>' +
              '<td style="text-align:right;color:' + (ownerCompNetTotal.year3 >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;">' + (ownerCompNetTotal.year3 >= 0 ? '+' : '') + fmt(ownerCompNetTotal.year3) + '</td>' +
              '<td style="text-align:right;color:' + (ownerCompNetTotal.year4 >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;">' + (ownerCompNetTotal.year4 >= 0 ? '+' : '') + fmt(ownerCompNetTotal.year4) + '</td>' +
              '<td style="text-align:right;color:' + (ownerCompNetTotal.year5 >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;">' + (ownerCompNetTotal.year5 >= 0 ? '+' : '') + fmt(ownerCompNetTotal.year5) + '</td>' +
              '<td style="text-align:right;color:' + (ownerCompNetTotal.ttm >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;background:#c8d9c3;">' + (ownerCompNetTotal.ttm >= 0 ? '+' : '') + fmt(ownerCompNetTotal.ttm) + '</td>' +
              '</tr>';
          }
          
          // Other Add-backs Section
          if (hasOther) {
            html += '<tr style="background:#f0f4ef;">' +
              '<td colspan="6" style="padding:10px 8px 6px;font-weight:700;color:#4b5563;font-size:12px;border-bottom:2px solid #6b7280;' + ((hasOwnerComp || hasMarketReplacement) ? 'border-top:3px solid #e5e7eb;' : '') + '">' +
              'Add/Deduct: Other Normalizing Adjustments' +
              '<div style="font-size:9px;font-weight:400;color:#6b7280;margin-top:2px;">Non-recurring, discretionary, or non-operating items that won\'t continue under new ownership</div>' +
              '</td></tr>' +
              generateRows(groupedOther) +
              '<tr style="background:#e5e7eb;">' +
              '<td colspan="2" style="font-weight:600;color:#4b5563;padding:8px;">Subtotal: Other Adjustments</td>' +
              '<td style="text-align:right;color:' + (otherTotal.year3 >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;">' + (otherTotal.year3 >= 0 ? '+' : '') + fmt(otherTotal.year3) + '</td>' +
              '<td style="text-align:right;color:' + (otherTotal.year4 >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;">' + (otherTotal.year4 >= 0 ? '+' : '') + fmt(otherTotal.year4) + '</td>' +
              '<td style="text-align:right;color:' + (otherTotal.year5 >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;">' + (otherTotal.year5 >= 0 ? '+' : '') + fmt(otherTotal.year5) + '</td>' +
              '<td style="text-align:right;color:' + (otherTotal.ttm >= 0 ? '#166534' : '#dc2626') + ';font-weight:600;background:#d1d9cf;">' + (otherTotal.ttm >= 0 ? '+' : '') + fmt(otherTotal.ttm) + '</td>' +
              '</tr>';
          }
          
          // Total Normalizing Adjustments row
          html += '<tr style="background:#6b7280;color:white;border-top:2px solid #374151;">' +
            '<td colspan="2" style="font-weight:600;padding:8px;">Total Normalizing Adjustments</td>' +
            '<td style="text-align:right;font-weight:600;">' + (totalNormalizingAdj.year3 >= 0 ? '+' : '') + fmt(totalNormalizingAdj.year3) + '</td>' +
            '<td style="text-align:right;font-weight:600;">' + (totalNormalizingAdj.year4 >= 0 ? '+' : '') + fmt(totalNormalizingAdj.year4) + '</td>' +
            '<td style="text-align:right;font-weight:600;">' + (totalNormalizingAdj.year5 >= 0 ? '+' : '') + fmt(totalNormalizingAdj.year5) + '</td>' +
            '<td style="text-align:right;font-weight:600;background:#4b5563;">' + (totalNormalizingAdj.ttm >= 0 ? '+' : '') + fmt(totalNormalizingAdj.ttm) + '</td>' +
            '</tr>'; +
            '<td style="text-align:right;font-weight:600;">' + (totalNormalizingAdj.year3 >= 0 ? '+' : '') + fmt(totalNormalizingAdj.year3) + '</td>' +
            '<td style="text-align:right;font-weight:600;">' + (totalNormalizingAdj.year4 >= 0 ? '+' : '') + fmt(totalNormalizingAdj.year4) + '</td>' +
            '<td style="text-align:right;font-weight:600;">' + (totalNormalizingAdj.year5 >= 0 ? '+' : '') + fmt(totalNormalizingAdj.year5) + '</td>' +
            '<td style="text-align:right;font-weight:600;background:#4b5563;">' + (totalNormalizingAdj.ttm >= 0 ? '+' : '') + fmt(totalNormalizingAdj.ttm) + '</td>' +
            '</tr>';
          
          // Normalized EBITDA row
          html += '<tr style="background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);color:white;">' +
            '<td colspan="2" style="font-weight:700;padding:12px 8px;font-size:13px;">' + (data.maintCapex > 0 ? '= NORMALIZED EBITDA AFTER CAPEX (FREE CASH FLOW)' : '= NORMALIZED EBITDA') + '</td>' +
            '<td style="text-align:right;font-weight:700;font-size:12px;">' + fmt(calcNormEbitda.year3) + '</td>' +
            '<td style="text-align:right;font-weight:700;font-size:12px;">' + fmt(calcNormEbitda.year4) + '</td>' +
            '<td style="text-align:right;font-weight:700;font-size:12px;">' + fmt(calcNormEbitda.year5) + '</td>' +
            '<td style="text-align:right;font-weight:700;font-size:14px;background:#2d4a27;">' + fmt(calcNormEbitda.ttm) + '</td>' +
            '</tr></tbody></table>';
          
          // Verification box
          html += '<div style="margin-top:15px;background:#f8faf7;border:2px solid #3d5c35;border-radius:6px;padding:12px;">' +
            '<div style="font-size:11px;font-weight:600;color:#3d5c35;margin-bottom:8px;text-align:center;">✓ Calculation Verification (TTM)</div>' +
            '<table style="width:100%;font-size:10px;border-collapse:collapse;">' +
            '<tr><td style="padding:4px 0;">Reported Net Income</td><td style="text-align:right;">' + fmt(financials.netIncome.ttm) + '</td></tr>' +
            '<tr><td style="padding:4px 0;">+ D/I/A/T Add-backs</td><td style="text-align:right;color:#166534;">+' + fmt(diatTotal.ttm) + '</td></tr>' +
            '<tr style="border-bottom:1px solid #d1d9cf;"><td style="padding:4px 0;">= Reported EBITDA</td><td style="text-align:right;font-weight:600;">' + fmt(financials.netIncome.ttm + diatTotal.ttm) + '</td></tr>' +
            '<tr><td style="padding:4px 0;">+ Normalizing Adjustments</td><td style="text-align:right;color:#166534;">+' + fmt(totalNormalizingAdj.ttm) + '</td></tr>' +
            '<tr style="background:#e8ede6;font-weight:700;"><td style="padding:6px 0;">' + (data.maintCapex > 0 ? '= Normalized EBITDA after capex' : '= Normalized EBITDA') + '</td><td style="text-align:right;">' + fmt(calcNormEbitda.ttm) + '</td></tr>' +
            '</table></div>';
          
          return html;
        })()}
        
        <div style="background:#fff;border:1px solid #e5e7eb;border-radius:4px;padding:10px;margin-top:12px;font-size:10px;color:#6b7280;">
          <strong style="color:#3d5c35;">Documentation Note:</strong> All adjustments are subject to buyer due diligence verification. 
          We recommend maintaining supporting documentation (pay stubs, expense reports, invoices) for each adjustment.
        </div>
      </div>
      ` : ''}
      
      <!-- Section 3: EBITDA Used for Valuation -->
      ${(() => {
        const vi = data.valuationInputs || {};
        const calcs = calculations || {};
        const method = vi.weightingMethod || 'ttm';
        const methodLabels = {
          'ttm': 'Trailing Twelve Months (TTM)',
          'lastYear': 'Last Fiscal Year',
          'average': 'Simple Average',
          'weighted': 'Weighted Average'
        };
        const methodLabel = methodLabels[method] || 'TTM';
        const valuationMetric = calcs.valuation?.metric || normalizedEbitda;
        
        const y3Ebitda = calcs.years?.[2]?.adjustedEbitda || 0;
        const y4Ebitda = calcs.years?.[3]?.adjustedEbitda || 0;
        const y5Ebitda = calcs.years?.[4]?.adjustedEbitda || 0;
        const y3Label = yearLabels.year3 || 'Year 3';
        const y4Label = yearLabels.year4 || 'Year 4';
        const y5Label = yearLabels.year5 || 'Year 5';
        const w1 = vi.includeYear1 ? (vi.weightYear1 || 1) : 0;
        const w2 = vi.includeYear2 ? (vi.weightYear2 || 2) : 0;
        const w3 = vi.includeYear3 ? (vi.weightYear3 || 3) : 0;
        const totalWeight = w1 + w2 + w3;
        
        let methodExplanation = '';
        if (method === 'ttm') {
          methodExplanation = 'Using the most recent 12-month period provides the most current view of your business performance and is the standard approach for growing businesses.';
        } else if (method === 'lastYear') {
          methodExplanation = 'Using the last complete fiscal year provides a full annual picture of business performance.';
        } else if (method === 'average') {
          methodExplanation = 'A simple average smooths out year-to-year fluctuations to provide a balanced view of typical earnings.';
        } else if (method === 'weighted') {
          methodExplanation = 'Weighted averaging gives more emphasis to recent years while still considering historical performance, ideal for businesses with consistent growth trends.';
        }
        
        let breakdownHtml = '';
        if (method === 'average' || method === 'weighted') {
          let rows = '';
          if (vi.includeYear1) {
            rows += '<tr><td>' + y3Label + '</td><td style="text-align:right;">' + fmt(y3Ebitda) + '</td>';
            if (method === 'weighted') rows += '<td style="text-align:center;">' + w1 + 'x</td><td style="text-align:right;">' + fmt(y3Ebitda * w1) + '</td>';
            rows += '</tr>';
          }
          if (vi.includeYear2) {
            rows += '<tr><td>' + y4Label + '</td><td style="text-align:right;">' + fmt(y4Ebitda) + '</td>';
            if (method === 'weighted') rows += '<td style="text-align:center;">' + w2 + 'x</td><td style="text-align:right;">' + fmt(y4Ebitda * w2) + '</td>';
            rows += '</tr>';
          }
          if (vi.includeYear3) {
            rows += '<tr><td>' + y5Label + '</td><td style="text-align:right;">' + fmt(y5Ebitda) + '</td>';
            if (method === 'weighted') rows += '<td style="text-align:center;">' + w3 + 'x</td><td style="text-align:right;">' + fmt(y5Ebitda * w3) + '</td>';
            rows += '</tr>';
          }
          const numPeriods = [vi.includeYear1, vi.includeYear2, vi.includeYear3].filter(Boolean).length;
          breakdownHtml = '<table style="width:100%;border-collapse:collapse;font-size:10px;margin-top:12px;">' +
            '<thead><tr>' +
            '<th style="text-align:left;">Period</th>' +
            '<th style="text-align:right;">' + (data.maintCapex > 0 ? 'Normalized EBITDA after capex' : 'Normalized EBITDA') + '</th>' +
            (method === 'weighted' ? '<th style="text-align:center;">Weight</th><th style="text-align:right;">Weighted Value</th>' : '') +
            '</tr></thead><tbody>' + rows + '</tbody>' +
            '<tfoot><tr class="total-row">' +
            '<td>' + (method === 'weighted' ? 'Total ÷ ' + totalWeight : 'Average of ' + numPeriods + ' periods') + '</td>' +
            '<td style="text-align:right;color:#3d5c35;font-weight:700;">' + fmt(valuationMetric) + '</td>' +
            (method === 'weighted' ? '<td style="text-align:center;">' + totalWeight + 'x</td><td style="text-align:right;color:#3d5c35;font-weight:700;">' + fmt(valuationMetric) + '</td>' : '') +
            '</tr></tfoot></table>';
        }
        
        return `
        <div class="section-header">Valuation EBITDA Selection</div>
        <div class="section-content">
          <div class="section-intro">
            <strong>Which EBITDA Figure Do We Use?</strong> ${methodExplanation}
          </div>
          
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:15px;align-items:center;">
            <div>
              <div style="font-size:10px;color:#6b7280;margin-bottom:5px;">CALCULATION METHOD</div>
              <div style="font-size:14px;font-weight:600;color:#3d5c35;">${methodLabel}</div>
            </div>
            <div class="highlight-box" style="margin:0;">
              <div class="highlight-label">${data.maintCapex > 0 ? 'Normalized EBITDA after capex, for valuation' : 'Normalized EBITDA for Valuation'}</div>
              <div class="highlight-value">${fmt(valuationMetric)}</div>
              ${data.maintCapex > 0 ? `<div style="font-size:10px;color:#6b7280;">Normalized EBITDA before capex ${fmt(data.ebitdaBeforeCapex)} − maintenance capex ${fmt(data.maintCapex)}</div>` : ''}
            </div>
          </div>
          ${breakdownHtml}
        </div>`;
      })()}
    `
  };

  const generateValuationDriversHTML = (data) => {
    const { valuation, company } = data;
    const factors = valuation.factors || {};
    
    return `
      <div class="section-header">How We Calculated the Multiple</div>
      <div class="section-content">
        <div class="section-intro">
          The valuation multiple is determined through a systematic process that starts with company size, 
          applies industry and location factors, then adjusts for specific business characteristics.
        </div>
        
        <!-- Step 1: Base Multiple -->
        <div style="border:1px solid #d1d9cf;border-radius:8px;overflow:hidden;margin-bottom:12px;">
          <div style="padding:12px 15px;background:linear-gradient(to right, #f0f4ef, #e8ede6);display:flex;justify-content:space-between;align-items:center;">
            <div>
              <span style="font-weight:700;color:#3d5c35;">Step 1: Company Size → Base Multiple</span>
            </div>
            <span style="font-size:20px;font-weight:700;color:#3d5c35;">${valuation.rawBaseMultiple?.toFixed(2) || valuation.baseMultiple.toFixed(2)}x</span>
          </div>
          <div style="padding:12px 15px;background:white;">
            <div style="font-size:11px;color:#6b7280;margin-bottom:8px;">
              Your ${data.maintCapex > 0 ? 'EBITDA before capex' : 'Normalized EBITDA'} of <strong style="color:#3d5c35;">${fmt(data.maintCapex > 0 ? data.tierEbitda : data.normalizedEbitda)}</strong> places you in this multiple tier.
            </div>
            <div style="background:#f8faf7;padding:8px;border-radius:5px;font-size:10px;color:#5a7a50;border-left:3px solid #3d5c35;">
              <strong>Why size matters:</strong> Larger companies have more management depth, customer diversification, and operational stability—reducing buyer risk and commanding higher multiples.
            </div>
          </div>
        </div>
        
        <!-- Step 2: Industry -->
        <div style="border:1px solid #d1d9cf;border-radius:8px;overflow:hidden;margin-bottom:12px;">
          <div style="padding:12px 15px;background:linear-gradient(to right, #f8f9fa, #f1f3f5);display:flex;justify-content:space-between;align-items:center;">
            <span style="font-weight:700;color:#4b5563;">Step 2: Industry Adjustment</span>
            <span style="font-size:20px;font-weight:700;color:${valuation.industryAdjustment >= 0 ? '#3d5c35' : '#d97706'};">${valuation.industryAdjustment >= 0 ? '+' : ''}${valuation.industryAdjustment.toFixed(2)}x</span>
          </div>
          <div style="padding:12px 15px;background:white;">
            <div style="font-weight:500;color:#1f2937;">${company.industry}</div>
            <div style="font-size:10px;color:#6b7280;margin-top:4px;">Industry-specific adjustment based on market demand, deal activity, and sector growth trends</div>
          </div>
        </div>
        
        <!-- Step 3: Location & Market -->
        <div style="border:1px solid #d1d9cf;border-radius:8px;overflow:hidden;margin-bottom:12px;">
          <div style="padding:12px 15px;background:linear-gradient(to right, #f8f9fa, #f1f3f5);display:flex;justify-content:space-between;align-items:center;">
            <span style="font-weight:700;color:#4b5563;">Step 3: Location & Market Conditions</span>
            <span style="font-size:20px;font-weight:700;color:${valuation.locationAdjustment >= 0 ? '#3d5c35' : '#d97706'};">${valuation.locationAdjustment >= 0 ? '+' : ''}${valuation.locationAdjustment.toFixed(2)}x</span>
          </div>
          <div style="padding:12px 15px;background:white;">
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:15px;font-size:11px;">
              <div><span style="color:#6b7280;">Location Type:</span> <span style="font-weight:500;color:#1f2937;">${company.locationType || 'Not specified'}</span></div>
              <div><span style="color:#6b7280;">Market Condition:</span> <span style="font-weight:500;color:${valuation.marketAdjustment >= 0 ? '#3d5c35' : '#d97706'};">${valuation.marketAdjustment >= 0 ? '+' : ''}${(valuation.marketAdjustment || 0).toFixed(2)}x</span></div>
            </div>
          </div>
        </div>
        
        <!-- Effective Base Result -->
        <div style="background:#e8ede6;border:2px solid #3d5c35;border-radius:6px;padding:12px;margin-bottom:12px;">
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <div>
              <div style="font-weight:600;color:#3d5c35;font-size:12px;">= Effective Base Multiple</div>
              <div style="font-size:9px;color:#5a7a50;">
                Base (${valuation.rawBaseMultiple?.toFixed(2) || valuation.baseMultiple.toFixed(2)}x) + Industry (${valuation.industryAdjustment >= 0 ? '+' : ''}${valuation.industryAdjustment.toFixed(2)}x) + Location (${valuation.locationAdjustment >= 0 ? '+' : ''}${valuation.locationAdjustment.toFixed(2)}x)
              </div>
            </div>
            <span style="font-size:22px;font-weight:700;color:#3d5c35;">${valuation.effectiveBase.toFixed(2)}x</span>
          </div>
        </div>
        
        <!-- Step 4: Business Factors -->
        <div style="border:1px solid #d1d9cf;border-radius:8px;overflow:hidden;margin-bottom:12px;">
          <div style="padding:12px 15px;background:linear-gradient(to right, #f8f9fa, #f1f3f5);display:flex;justify-content:space-between;align-items:center;">
            <span style="font-weight:700;color:#4b5563;">Step 4: Business Quality Factors</span>
            <span style="font-size:20px;font-weight:700;color:${valuation.totalFactorAdjustment >= 0 ? '#3d5c35' : '#d97706'};">${valuation.totalFactorAdjustment >= 0 ? '+' : ''}${valuation.totalFactorAdjustment.toFixed(2)}x</span>
          </div>
          <div style="padding:15px;background:white;">
            <div style="font-size:10px;color:#6b7280;margin-bottom:10px;">Each factor reflects specific aspects of your business that impact buyer perception and risk:</div>
            <table style="width:100%;border-collapse:collapse;font-size:11px;">
              <thead>
                <tr style="background:#f8faf7;border-bottom:2px solid #d1d9cf;">
                  <th style="padding:8px;text-align:left;color:#3d5c35;">Factor</th>
                  <th style="padding:8px;text-align:left;color:#3d5c35;">Your Status</th>
                  <th style="padding:8px;text-align:right;color:#3d5c35;">Impact</th>
                </tr>
              </thead>
              <tbody>
                ${Object.entries(factors).map(([key, factor]) => `
                  <tr style="border-bottom:1px solid #e5e7eb;">
                    <td style="padding:8px;font-weight:500;">${factor.name}</td>
                    <td style="padding:8px;color:#6b7280;font-size:10px;">${factor.calculation || '-'}</td>
                    <td style="padding:8px;text-align:right;font-weight:700;color:${factor.adjustment > 0 ? '#3d5c35' : factor.adjustment < 0 ? '#d97706' : '#9ca3af'};">${factor.adjustment > 0 ? '+' : ''}${factor.adjustment.toFixed(2)}x</td>
                  </tr>
                `).join('')}
                <tr style="background:#f0f4ef;font-weight:700;">
                  <td style="padding:10px;color:#3d5c35;" colspan="2">Total Factor Adjustments</td>
                  <td style="padding:10px;text-align:right;color:${valuation.totalFactorAdjustment >= 0 ? '#3d5c35' : '#d97706'};">${valuation.totalFactorAdjustment >= 0 ? '+' : ''}${valuation.totalFactorAdjustment.toFixed(2)}x</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <!-- Final Multiple Result -->
        <div style="background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);border-radius:8px;padding:15px;text-align:center;">
          <div style="font-size:10px;color:rgba(255,255,255,0.9);margin-bottom:6px;">
            Effective Base (${valuation.effectiveBase.toFixed(2)}x) + Factor Adjustments (${valuation.totalFactorAdjustment >= 0 ? '+' : ''}${valuation.totalFactorAdjustment.toFixed(2)}x)
          </div>
          <div style="font-size:22px;font-weight:700;color:white;">
            Final Multiple: ${valuation.adjustedMultiple?.toFixed(2) || (valuation.effectiveBase + valuation.totalFactorAdjustment).toFixed(2)}x
          </div>
          <div style="font-size:13px;color:rgba(255,255,255,0.95);margin-top:4px;">
            Range: ${valuation.typicalMultiple.toFixed(2)}x (Typical) to ${valuation.marketHighMultiple.toFixed(2)}x (Market High)
          </div>
        </div>
      </div>
    `;
  };

  // 📊 KEY METRIC SPECS — the single source of wording for the Presentation
  // tiles and the owner's Valuation Result report (Mark 10-07: "we provide this
  // report to the owners — they need to understand it"). Names spelled out, a
  // one-line meaning, the period, "Source:", and the full explanation (what it
  // is · this business · good or bad). Plain strings only; never computes a value.
  const keyMetricSpecs = () => {
    const yl = basisYearLabels || {};
    const cl = displayCustomerYearLabels || {};
    const p1 = (v) => (v === null || v === undefined || isNaN(v)) ? 'n/a' : `${v.toFixed(1)}%`;
    // Whole-percent tiles never round UP to a false 100% (Concise 10-07: 99.8% showed as "100%").
    const p0 = (v) => (v >= 99.5 && v < 100) ? `${v.toFixed(1)}%` : `${v.toFixed(0)}%`;
    const indName = (industryBenchmarks.find(ix => ix.id === selectedIndustry) || {}).name || 'this industry';
    const vsBench = (v, b, higherBetter = true) => {
      if (v === null || v === undefined || !b) return '';
      const d = higherBetter ? v - b : b - v;
      return d >= 0 ? `At or better than the ${indName} benchmark of ${b}%.` : (Math.abs(d) <= 5 ? `Close to the ${indName} benchmark of ${b}%.` : `Below the ${indName} benchmark of ${b}%.`);
    };
    const basisTxt = (() => {
      const wm = valuationInputs.weightingMethod;
      if (wm === 'lastYear') return yl.year5;
      if (wm === 'average' || wm === 'weighted') {
        const ys = [valuationInputs.includeYear1 && yl.year3, valuationInputs.includeYear2 && yl.year4, valuationInputs.includeYear3 && yl.year5].filter(Boolean);
        return ys.length ? `${wm === 'weighted' ? 'weighted ' : ''}average of ${ys.join(', ')}` : ttmLabel;
      }
      return ttmLabel;
    })();
    const km = keyMetrics || {};
    const y = calculations.years || [];
    const ttmRev = y[5]?.revenue || 0, lastRev = y[4]?.revenue || 0;
    const rp = km.retentionByPeriod || {}, np = km.nrrByPeriod || {};
    const churnBaseK = km.churnComparisonBase || 'year5';
    const churnBaseLbl = cl[churnBaseK] || (churnBaseK === 'year4' ? 'Year 4' : 'Year 5');
    const lostN = km.lostCustomers?.length || 0, newN = km.newCustomers?.length || 0;
    const baseCount = (km.customerCount || {})[churnBaseK] || 0;
    const lostRev = km.lostRevenue || 0, newRev = km.newRevenue || 0;
    const salesSrc = 'sales-by-customer report';
    const plSrc = 'P&L provided';
    const concPeriod = km.concentrationSource && km.concentrationSource !== 'TTM' ? (cl.year5 || 'last full year') : salesTtmLabel;
    const tone3 = (v, g, w, higher = true) => v === null || v === undefined ? 'na' : higher ? (v >= g ? 'good' : v >= w ? 'warn' : 'bad') : (v > w ? 'bad' : v > g ? 'warn' : 'good');
    const hasDetail = (km.detailCoveragePct || 0) > 0;
    return [
      { key: 'rev', label: 'TTM Revenue', value: formatCurrency(ttmRev), tone: 'neutral', period: ttmLabel, source: plSrc,
        what: 'Total revenue for the most recent twelve months (TTM = trailing twelve months).',
        here: lastRev > 0 ? `${formatCurrency(ttmRev)} vs ${formatCurrency(lastRev)} in ${yl.year5} (${ttmRev >= lastRev ? '+' : ''}${((ttmRev / lastRev - 1) * 100).toFixed(1)}%).` : '',
        good: 'The starting point for every other metric; the trend versus the last full year matters more than the size.' },
      { key: 'margin', label: 'EBITDA Margin', value: `${(km.ebitdaMargin || 0).toFixed(1)}%`, tone: 'neutral', period: ttmLabel, source: plSrc + ', after adjustments',
        short: 'profit as a share of revenue',
        what: 'Adjusted EBITDA (earnings before interest, taxes, depreciation and amortization, after owner and one-time adjustments) as a share of revenue.',
        here: y[5]?.adjustedEbitda !== undefined ? `${formatCurrency(y[5].adjustedEbitda || 0)} of adjusted EBITDA on ${formatCurrency(ttmRev)} of revenue.` : '',
        good: vsBench(km.ebitdaMargin, currentBenchmarks.ebitdaMargin) || 'Higher means more of each revenue dollar reaches the owner as profit.' },
      { key: 'rpe', label: 'Revenue per Employee', value: km.revenuePerEmployee ? formatCurrency(km.revenuePerEmployee) : 'N/A', tone: km.revenuePerEmployee ? 'neutral' : 'na',
        period: ttmLabel, source: 'revenue ÷ employee count (questionnaire)',
        what: 'Revenue for the period divided by the number of employees.',
        here: km.employeeCount ? `${formatCurrency(ttmRev)} ÷ ${km.employeeCount} employees.` : 'Employee count not provided yet.',
        good: 'Shows how efficiently the team produces revenue; most useful compared year over year and against similar businesses.' },
      { key: 'clientrev', label: 'Revenue from Contracted Clients', value: (km.contractedClientRevPct || 0) > 0 ? p0(km.contractedClientRevPct) : 'N/A', tone: (km.contractedClientRevPct || 0) > 0 ? 'neutral' : 'na',
        short: 'all revenue from clients with an agreement', period: basisTxt, source: 'Revenue Classification + Client Detail',
        what: 'All revenue from clients who have a service agreement: their agreement fees plus the projects, products and licensing they buy.',
        here: (km.contractedClientRevPct || 0) > 0 ? `${p0(km.contractedClientRevPct)} of revenue comes from clients with an agreement.` : '',
        good: 'Clients on agreements tend to stay and buy more, so a higher share means a stickier client base. Only the agreement fees themselves count as recurring (see Contracted Recurring Revenue).' },
      { key: 'cagr', label: 'Revenue Growth Rate (3-yr CAGR)', value: km.revCAGR ? `${km.revCAGR > 0 ? '+' : ''}${km.revCAGR.toFixed(1)}%` : 'N/A',
        tone: km.revCAGR ? (km.revCAGR > 0 ? 'good' : km.revCAGR < 0 ? 'bad' : 'neutral') : 'na',
        short: 'average yearly growth', period: `${yl.year3} → ${yl.year5}`, source: plSrc + ', adjusted revenue',
        what: 'The average yearly revenue growth rate across three full years (compound annual growth rate, CAGR).',
        here: y[2]?.adjustedRevenue > 0 ? `${formatCurrency(y[2].adjustedRevenue)} in ${yl.year3} → ${formatCurrency(y[4]?.adjustedRevenue || 0)} in ${yl.year5}.` : '',
        good: currentBenchmarks.industryGrowthRate ? `The ${indName} industry grows about ${currentBenchmarks.industryGrowthRate}% a year.` : 'Positive and steady is what buyers look for.' },
      { key: 'recurring', label: 'Contracted Recurring Revenue', value: (km.contractCoveragePct || 0) > 0 ? p0(km.contractCoveragePct) : 'N/A', tone: (km.contractCoveragePct || 0) > 0 ? 'neutral' : 'na', highlight: 'green',
        short: 'agreement fees as a share of revenue', period: basisTxt,
        source: km.contractCoverageSource === 'ledger' ? 'agreement fees from the books' : km.contractCoverageSource ? 'client answers' : '',
        what: 'Revenue a signed agreement obligates the client to pay every month or year: the agreement fees only. Projects and hardware are not included, even for clients on agreements.',
        here: (km.contractCoveragePct || 0) > 0 ? `${p0(km.contractCoveragePct)} of revenue is contracted agreement fees.` : '',
        good: ((km.contractCoveragePct || 0) > 0 && vsBench(km.contractCoveragePct, currentBenchmarks.recurringRevenuePct)) || 'Buyers value this most: it repeats without being resold.' },
      { key: 'top1', label: `Top Customer${km.concentrationSource && km.concentrationSource !== 'TTM' ? ` (${km.concentrationSource})` : ''}`, value: `${(km.topCustomerPct || 0).toFixed(1)}%`,
        tone: tone3(km.topCustomerPct, 15, 20, false), short: 'share of revenue from the largest customer', period: concPeriod, source: salesSrc,
        what: 'The share of revenue that comes from the single largest customer.', here: '',
        good: vsBench(km.topCustomerPct, currentBenchmarks.topCustomerConcentration, false) || 'Lower is safer: losing one customer hurts less.' },
      { key: 'top5', label: 'Top 5 Customers', value: `${(km.top5CustomersPct || 0).toFixed(1)}%`,
        tone: tone3(km.top5CustomersPct, 40, 50, false), short: 'share of revenue from the five largest', period: concPeriod, source: salesSrc,
        what: 'The share of revenue that comes from the five largest customers combined.', here: '',
        good: vsBench(km.top5CustomersPct, currentBenchmarks.top5CustomerConcentration, false) || 'Lower means revenue is spread across more customers.' },
      { key: 'agree', label: 'Clients with Agreement', value: hasDetail ? `${km.agreementClientCount || 0} of ${km.activeClientCount || 0}` : 'N/A', tone: hasDetail ? 'neutral' : 'na',
        lines: hasDetail && (km.unansweredActiveCount || 0) > 0 ? [{ kind: 'warn', text: `${km.unansweredActiveCount} active client${km.unansweredActiveCount === 1 ? '' : 's'} not yet answered (${(km.unansweredActivePct || 0) < 1 ? '<1' : km.unansweredActivePct.toFixed(0)}% of revenue)` }] : [],
        short: 'active clients with a signed agreement', period: 'clients active in ' + salesTtmLabel, source: 'Client Detail form (owner-reported)',
        what: 'How many active clients have a signed service agreement, as reported on the Client Detail form.',
        here: hasDetail ? `${km.agreementClientCount || 0} of ${km.activeClientCount || 0} active clients have an agreement.` : '',
        good: 'A count of clients, not revenue: a client can have an agreement and still buy projects or hardware outside it.' },
      { key: 'grr', label: 'Gross Revenue Retention', value: km.avgRetention !== null && km.avgRetention !== undefined ? `${km.avgRetention.toFixed(1)}%` : 'N/A',
        tone: tone3(km.avgRetention, 85, 75), short: 'revenue kept from existing customers, growth not counted',
        period: `3-yr average: ${cl.year3}→${cl.year4}, ${cl.year4}→${cl.year5}, ${cl.year5}→TTM`, source: salesSrc,
        what: 'Of every $100 customers paid in one year, how much came back from those same customers the next year. Growth is not counted (a customer who spent more counts as 100%), and a customer marked Lost counts as $0.',
        here: `${cl.year3}→${cl.year4}: ${p1(rp.y3to4)} · ${cl.year4}→${cl.year5}: ${p1(rp.y4to5)} · ${cl.year5}→TTM: ${p1(rp.y5toTTM)}. The tile is the average.`,
        good: ((vsBench(km.avgRetention, currentBenchmarks.customerRetentionRate) || '') + ' The direction across the three periods matters as much as the average.').trim() },
      { key: 'nrr', label: 'Net Revenue Retention', value: km.avgNRR !== null && km.avgNRR !== undefined ? `${km.avgNRR.toFixed(1)}%` : 'N/A',
        tone: tone3(km.avgNRR, 100, 90), short: 'existing customers this year vs last, growth counted',
        period: `2-yr average: ${cl.year4}→${cl.year5}, ${cl.year5}→TTM`, source: salesSrc,
        what: 'What last year\'s customers paid this year, as a share of what they paid last year. Growth from existing customers counts; lost customers count as $0; new customers are not included.',
        here: `${cl.year4}→${cl.year5}: ${p1(np.y4to5)} · ${cl.year5}→TTM: ${p1(np.y5toTTM)}. The tile is the average.`,
        good: 'Over 100% means the customers who stayed grew by more than the ones who left took away; under 100% means losses outpaced growth.' },
      { key: 'churn', label: 'Customer Churn (TTM)', value: `${newN - lostN >= 0 ? '+' : ''}${newN - lostN} net`, tone: newN - lostN >= 0 ? 'good' : 'bad', highlight: lostN > 0 ? 'red' : null,
        lines: [{ kind: 'note', text: `${lostN} lost / ${newN} new customers` }, { kind: 'note', text: `Annual revenue: −${formatCurrency(lostRev)} lost / +${formatCurrency(newRev)} new` }],
        period: `${churnBaseLbl} customers → ${salesTtmLabel}`, source: salesSrc,
        what: `Customers who billed in ${churnBaseLbl}, compared with the trailing twelve months. Lost = stopped billing (no revenue in the last 3 months of the TTM) or marked Lost; new = no ${churnBaseLbl} revenue and started during the TTM. Dollar amounts are annual: each lost customer at their full-year revenue (the better of ${churnBaseLbl} or the TTM); new customers at what they billed in the TTM.`,
        here: `${lostN} of ${baseCount} ${churnBaseLbl} customers stopped${baseCount ? ` (${(lostN / baseCount * 100).toFixed(0)}%)` : ''}, worth ${formatCurrency(lostRev)} a year; ${newN} started, bringing ${formatCurrency(newRev)} in the TTM.`,
        good: 'Revenue matters more than the count: a few small accounts leaving is normal; watch the dollars and whether the largest customers stayed.' },
    ];
  };
  const KM_TONE_HEX = { good: '#3d5c35', warn: '#d97706', bad: '#dc2626', neutral: '#1f2937', na: '#9ca3af' };

  const generateValuationResultHTML = (data) => {
    const { valuation, keyMetrics, company, accuracy, dealStructure } = data;
    
    // Fee calculation
    const highValue = valuation.valuationHigh;
    const retainerRaw = data.normalizedEbitda * 0.01;
    const retainer = Math.min(20000, Math.max(5000, retainerRaw));
    let commission = 0;
    let remaining = highValue;
    const tiers = [
      { limit: 1000000, rate: 0.08 },
      { limit: 1000000, rate: 0.05 },
      { limit: 1000000, rate: 0.04 },
      { limit: 1000000, rate: 0.03 },
      { limit: Infinity, rate: 0.02 }
    ];
    for (const tier of tiers) {
      if (remaining <= 0) break;
      const tierAmount = Math.min(remaining, tier.limit);
      commission += tierAmount * tier.rate;
      remaining -= tierAmount;
    }
    commission = Math.max(40000, commission); // Minimum commission $40,000
    const minimumApplied = commission === 40000 && highValue > 0;
    const balanceAtClose = commission - retainer;
    const effectiveRate = highValue > 0 ? (commission / highValue) * 100 : 0;
    
    // Accuracy info
    const accuracyScore = accuracy?.overallScore || 0;
    const accuracyTier = accuracy?.tier || 'Unknown';
    const accuracyColor = accuracyScore >= 85 ? '#3d5c35' : accuracyScore >= 70 ? '#5a7d50' : accuracyScore >= 50 ? '#d97706' : '#dc2626';
    
    // Deal composition
    const sellerNotePct = dealStructure?.sellerNote || 10;
    const earnoutPct = dealStructure?.earnout || 0;
    const equityPct = dealStructure?.equity || 0;
    const cashPct = Math.max(0, 100 - sellerNotePct - earnoutPct - equityPct);
    const cashAmount = highValue * (cashPct / 100);
    const noteAmount = highValue * (sellerNotePct / 100);
    const earnoutAmount = highValue * (earnoutPct / 100);
    const equityAmount = highValue * (equityPct / 100);
    
    return `
      <div class="section-header">Valuation Result</div>
      <div class="section-content">
        
        <!-- Key Business Metrics -->
        <div style="margin-bottom:20px;">
          <div style="font-size:12px;font-weight:600;color:#3d5c35;margin-bottom:10px;">Key Business Metrics</div>
          ${(() => {
            const specs = keyMetricSpecs();
            const esc = (t) => String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            const tile = (t) => `<div style="background:${t.highlight === 'red' ? '#fef2f2' : t.highlight === 'green' ? '#f0fdf4' : '#f8faf7'};padding:10px;border-radius:6px;border:1px solid ${t.highlight === 'red' ? '#fecaca' : t.highlight === 'green' ? '#bbf7d0' : '#d1d9cf'};">
              <div style="font-size:9px;font-weight:700;color:#1f2937;margin-bottom:2px;">${esc(t.label)}</div>
              <div style="font-size:14px;font-weight:700;color:${KM_TONE_HEX[t.tone] || '#1f2937'};">${esc(t.value)}</div>
              ${t.short ? `<div style="font-size:8px;color:#4b5563;margin-top:1px;">${esc(t.short)}</div>` : ''}
              ${(t.lines || []).map(l => `<div style="font-size:8px;color:${l.kind === 'warn' ? '#b45309' : '#4b5563'};margin-top:1px;">${esc(l.text)}</div>`).join('')}
              <div style="font-size:7.5px;color:#9ca3af;margin-top:3px;">${esc(t.period)}</div>
              ${t.source ? `<div style="font-size:7.5px;color:#9ca3af;font-style:italic;">Source: ${esc(t.source)}</div>` : ''}
            </div>`;
            const rows = [specs.slice(0, 4), specs.slice(4, 8), specs.slice(8, 12)];
            return rows.map((r, k) => `<div style="display:grid;grid-template-columns:repeat(4, 1fr);gap:8px;${k ? 'margin-top:8px;' : ''}">${r.map(tile).join('')}</div>`).join('')
              + `<div style="margin-top:12px;padding:10px 12px;border:1px solid #d1d9cf;border-radius:6px;background:#fff;">
                  <div style="font-size:10px;font-weight:700;color:#3d5c35;margin-bottom:6px;">How to read these metrics</div>
                  <div style="display:grid;grid-template-columns:1fr 1fr;gap:6px 16px;">
                    ${specs.map(t => `<div style="font-size:8.5px;color:#374151;line-height:1.35;"><b>${esc(t.label)}</b>: ${esc(t.what)}${t.here ? ` <i>This business:</i> ${esc(t.here)}` : ''}${t.good ? ` ${esc(t.good)}` : ''}</div>`).join('')}
                  </div>
                </div>`;
          })()}
        </div>
        
        ${(() => {
          // Listing Timing section - only include if there's roll-off risk
          const hasRollOffRisk = rollOffAnalysis.hasData && (rollOffAnalysis.nearTermAtRisk.length > 0 || (rollOffAnalysis.projections?.[3]?.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9));
          if (!hasRollOffRisk) return '';
          
          const monthlyBars = rollOffAnalysis.atRiskMonths?.slice(0, 12).map((m, idx) => {
            const maxVal = Math.max(...rollOffAnalysis.monthlyEbitda.map(Math.abs));
            const height = maxVal > 0 ? Math.abs(m.ebitda) / maxVal * 100 : 0;
            const color = m.isHighRisk ? '#374151' : m.isLowRisk ? '#d1d5db' : '#3d5c35';
            return `<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;height:100%;">
              <div style="width:100%;background:${color};border-radius:2px 2px 0 0;height:${height}%;min-height:${m.ebitda !== 0 ? '2px' : '0'};"></div>
            </div>`;
          }).join('') || '';
          
          return `
        <!-- Listing Timing Considerations -->
        <div style="margin-bottom:20px;">
          <div style="background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);color:white;padding:12px 18px;border-radius:6px 6px 0 0;font-size:13px;font-weight:600;">Listing Timing Considerations</div>
          <div style="background:#f8faf7;border:1px solid #d1d9cf;border-top:none;border-radius:0 0 6px 6px;padding:18px;">
            <div style="font-size:11px;color:#4b5563;margin-bottom:15px;line-height:1.6;background:#fff;padding:12px;border-radius:4px;border-left:3px solid #3d5c35;">
              Based on monthly EBITDA trends, there are timing considerations that may impact your valuation. High-performing months that "roll off" the trailing twelve months can reduce TTM EBITDA and consequently lower the business valuation.
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;">
              <!-- Left: Monthly EBITDA Chart -->
              <div>
                <div style="font-size:10px;font-weight:600;color:#374151;margin-bottom:8px;">Monthly EBITDA Trend (TTM)</div>
                <div style="display:flex;align-items:flex-end;gap:2px;height:70px;background:white;padding:10px;border-radius:4px;border:1px solid #d1d9cf;">
                  ${monthlyBars}
                </div>
                <div style="display:flex;justify-content:space-between;font-size:8px;color:#6b7280;margin-top:4px;">
                  <span>← Rolling off first</span>
                  <span>Most recent →</span>
                </div>
                <div style="display:flex;gap:12px;margin-top:8px;font-size:8px;color:#4b5563;">
                  <span style="display:flex;align-items:center;gap:4px;"><span style="width:10px;height:10px;background:#374151;border-radius:2px;"></span> Above average</span>
                  <span style="display:flex;align-items:center;gap:4px;"><span style="width:10px;height:10px;background:#3d5c35;border-radius:2px;"></span> Normal</span>
                  <span style="display:flex;align-items:center;gap:4px;"><span style="width:10px;height:10px;background:#d1d5db;border-radius:2px;"></span> Below average</span>
                </div>
              </div>
              
              <!-- Right: Impact Analysis -->
              <div>
                <div style="font-size:10px;font-weight:600;color:#374151;margin-bottom:8px;">Impact Analysis</div>
                ${rollOffAnalysis.nearTermAtRisk.length > 0 ? `
                <div style="background:white;padding:12px;border-radius:4px;border:1px solid #d1d9cf;margin-bottom:10px;">
                  <div style="font-size:11px;font-weight:600;color:#374151;margin-bottom:6px;">${rollOffAnalysis.nearTermAtRisk.length} High-Performing Month${rollOffAnalysis.nearTermAtRisk.length > 1 ? 's' : ''} Rolling Off</div>
                  <div style="font-size:10px;color:#4b5563;line-height:1.5;">${rollOffAnalysis.nearTermAtRisk.map(m => m.monthLabel).join(', ')} will roll off within the next 4 months.</div>
                  <div style="font-size:10px;color:#374151;font-weight:500;margin-top:6px;padding-top:6px;border-top:1px solid #e5e7eb;">
                    EBITDA at risk: <span style="color:#3d5c35;font-weight:700;">${fmt(rollOffAnalysis.totalAtRiskEbitda)}</span> • 
                    Valuation impact: <span style="color:#3d5c35;font-weight:700;">${fmt(rollOffAnalysis.totalAtRiskValuation)}</span>
                  </div>
                </div>
                ` : ''}
                ${rollOffAnalysis.projections?.[3]?.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9 ? `
                <div style="background:white;padding:12px;border-radius:4px;border:1px solid #d1d9cf;margin-bottom:10px;">
                  <div style="font-size:11px;font-weight:600;color:#374151;margin-bottom:6px;">Projected TTM Decline</div>
                  <div style="font-size:10px;color:#4b5563;line-height:1.5;">If upcoming months match historical average, TTM EBITDA may decline from <strong>${fmt(rollOffAnalysis.currentTtmEbitda)}</strong> to <strong>${fmt(rollOffAnalysis.projections[3].newTtm)}</strong> <span style="color:#dc2626;font-weight:600;">(${((rollOffAnalysis.currentTtmEbitda - rollOffAnalysis.projections[3].newTtm) / rollOffAnalysis.currentTtmEbitda * 100).toFixed(0)}% decline)</span></div>
                </div>
                ` : ''}
                <div style="background:#e8ede6;padding:12px;border-radius:4px;border:1px solid #d1d9cf;">
                  <div style="font-size:10px;color:#3d5c35;line-height:1.5;"><span style="font-weight:600;">Recommendation:</span> Consider listing timing carefully. If upcoming months are expected to be average or below, accelerating the listing timeline may help capture a higher valuation.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        `;
        })()}
        
        <!-- Valuation Summary & Accuracy Side-by-Side -->
        <div style="display:grid;grid-template-columns:1.2fr 0.8fr;gap:15px;margin-bottom:20px;">
          <!-- Valuation Summary -->
          <div style="background:#f8faf7;padding:15px;border-radius:8px;border:1px solid #d1d9cf;">
            <div style="font-size:12px;font-weight:600;color:#3d5c35;margin-bottom:12px;">Valuation Summary</div>
            
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px;">
              <div style="background:white;padding:10px;border-radius:5px;border:1px solid #e5e7eb;">
                <div style="font-size:9px;color:#6b7280;margin-bottom:2px;">${data.maintCapex > 0 ? 'Normalized EBITDA after capex (valued)' : 'Normalized EBITDA'}</div>
                <div style="font-size:16px;font-weight:700;color:#3d5c35;">${fmt(data.normalizedEbitda)}</div>
                ${data.maintCapex > 0 ? `<div style="font-size:9px;color:#6b7280;margin-top:2px;">Before capex ${fmt(data.ebitdaBeforeCapex)} − maintenance capex ${fmt(data.maintCapex)}</div>` : ''}
              </div>
              <div style="background:white;padding:10px;border-radius:5px;border:1px solid #e5e7eb;">
                <div style="font-size:9px;color:#6b7280;margin-bottom:2px;">Multiple Range</div>
                <div style="font-size:16px;font-weight:700;color:#3d5c35;">${valuation.typicalMultiple.toFixed(2)}x - ${valuation.marketHighMultiple.toFixed(2)}x</div>
              </div>
            </div>
            
            <div style="text-align:center;background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);border-radius:6px;padding:15px;">
              <div style="font-size:10px;color:rgba(255,255,255,0.85);margin-bottom:4px;">Estimated Business Value</div>
              <div style="font-size:22px;font-weight:700;color:white;">${fmt(valuation.valuationLow)} – ${fmt(valuation.valuationHigh)}</div>
              ${data.catchUpCapex > 0 ? `<div style="font-size:9px;color:rgba(255,255,255,0.85);margin-top:4px;">after one-time catch-up equipment spending of ${fmt(data.catchUpCapex)}${data.catchUpNote ? ' (' + String(data.catchUpNote).replace(/</g, '&lt;') + ')' : ''}</div>` : ''}
            </div>
            
            <div style="font-size:10px;color:#4b5563;line-height:1.5;margin-top:12px;padding:10px;background:white;border-radius:5px;border:1px solid #e5e7eb;">
              The majority of offers you receive should fall within this range. Each offer will have a different structure—some may be 
              all-cash (typically lower) while others include seller financing or earnouts (often higher total value). When evaluating 
              offers, consider both the total amount and the deal structure.
            </div>
          </div>
          
          <!-- Valuation Accuracy -->
          <div style="background:#f8faf7;padding:15px;border-radius:8px;border:1px solid #d1d9cf;">
            <div style="font-size:12px;font-weight:600;color:#3d5c35;margin-bottom:12px;">Valuation Accuracy</div>
            
            <div style="position:relative;height:10px;background:#e5e7eb;border-radius:5px;margin-bottom:6px;overflow:hidden;">
              <div style="position:absolute;left:0;top:0;height:100%;border-radius:5px;background:${accuracyColor};width:${accuracyScore}%;"></div>
            </div>
            <div style="display:flex;justify-content:space-between;font-size:8px;color:#9ca3af;margin-bottom:10px;">
              <span>0%</span><span>50%</span><span>100%</span>
            </div>
            
            <div style="text-align:center;margin-bottom:10px;">
              <div style="font-size:28px;font-weight:700;color:${accuracyColor};">${accuracyScore.toFixed(0)}%</div>
              <div style="font-size:11px;font-weight:600;color:${accuracyColor};">${accuracyTier}</div>
            </div>
            
            ${accuracy?.missingItems?.length > 0 ? `
            <div style="background:white;border-radius:5px;padding:8px;border:1px solid #e5e7eb;">
              <div style="font-size:9px;font-weight:600;color:#6b7280;margin-bottom:4px;">To improve accuracy:</div>
              <ul style="font-size:9px;color:#6b7280;margin:0;padding-left:14px;">
                ${accuracy.missingItems.slice(0, 3).map(item => `<li style="margin-bottom:2px;">${item}</li>`).join('')}
              </ul>
            </div>
            ` : ''}
          </div>
        </div>
        
        <!-- Typical Deal Composition -->
        <div style="background:#f8faf7;padding:15px;border-radius:8px;border:1px solid #d1d9cf;margin-bottom:20px;">
          <div style="font-size:12px;font-weight:600;color:#3d5c35;margin-bottom:6px;">Historical Deal Structure</div>
          <div style="font-size:10px;color:#6b7280;margin-bottom:12px;">Average structure across 100+ completed transactions</div>
          
          <!-- Explanation box -->
          <div style="background:#fff;border:1px solid #d1d9cf;border-radius:6px;padding:10px;margin-bottom:12px;font-size:10px;color:#4b5563;line-height:1.5;">
            <strong style="color:#3d5c35;">What to Expect:</strong> Across our completed transactions, the average winning offer 
            has been approximately 90% cash at closing with a 10% seller note. Your actual offers will vary—some buyers submit 
            all-cash offers (typically lower total value), while others include seller financing, earnouts, or equity rollover 
            (often higher total value). The right offer for you depends on your priorities: certainty vs. maximum value.
          </div>
          
          <div style="height:22px;border-radius:5px;overflow:hidden;display:flex;margin-bottom:12px;">
            ${cashPct > 0 ? `<div style="background:#3d5c35;width:${cashPct}%;display:flex;align-items:center;justify-content:center;color:white;font-size:9px;font-weight:600;">${cashPct >= 15 ? cashPct + '%' : ''}</div>` : ''}
            ${sellerNotePct > 0 ? `<div style="background:#5a7d50;width:${sellerNotePct}%;display:flex;align-items:center;justify-content:center;color:white;font-size:9px;font-weight:600;">${sellerNotePct >= 10 ? sellerNotePct + '%' : ''}</div>` : ''}
            ${earnoutPct > 0 ? `<div style="background:#7a9d70;width:${earnoutPct}%;display:flex;align-items:center;justify-content:center;color:white;font-size:9px;font-weight:600;">${earnoutPct >= 10 ? earnoutPct + '%' : ''}</div>` : ''}
            ${equityPct > 0 ? `<div style="background:#9abd90;width:${equityPct}%;display:flex;align-items:center;justify-content:center;color:#3d5c35;font-size:9px;font-weight:600;">${equityPct >= 10 ? equityPct + '%' : ''}</div>` : ''}
          </div>
          
          <div style="display:grid;grid-template-columns:repeat(2, 1fr);gap:8px;">
            <div style="background:white;padding:10px;border-radius:5px;border:1px solid #d1d9cf;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
                <div style="font-size:10px;font-weight:600;color:#3d5c35;">Cash at Close</div>
                <div style="font-size:12px;font-weight:700;color:#3d5c35;">${fmt(cashAmount)} <span style="font-size:9px;font-weight:400;color:#6b7280;">(${cashPct}%)</span></div>
              </div>
              <div style="font-size:9px;color:#6b7280;line-height:1.4;">
                Money received at closing, typically funded through a combination of SBA loan proceeds and buyer's equity injection. This is your "day one" payout.
              </div>
            </div>
            <div style="background:white;padding:10px;border-radius:5px;border:1px solid #d1d9cf;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
                <div style="font-size:10px;font-weight:600;color:#5a7d50;">Seller Note</div>
                <div style="font-size:12px;font-weight:700;color:#5a7d50;">${fmt(noteAmount)} <span style="font-size:9px;font-weight:400;color:#6b7280;">(${sellerNotePct}%)</span></div>
              </div>
              <div style="font-size:9px;color:#6b7280;line-height:1.4;">
                A loan you provide to the buyer (our financing estimates use ${sbaParams.sellerNoteRate}% interest over ${sbaParams.sellerNoteTerm} years). Payments usually start after a short standby period. This "skin in the game" signals confidence in the business.
              </div>
            </div>
            <div style="background:white;padding:10px;border-radius:5px;border:1px solid #d1d9cf;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
                <div style="font-size:10px;font-weight:600;color:#7a9d70;">Earnout</div>
                <div style="font-size:12px;font-weight:700;color:#7a9d70;">${fmt(earnoutAmount)} <span style="font-size:9px;font-weight:400;color:#6b7280;">(${earnoutPct}%)</span></div>
              </div>
              <div style="font-size:9px;color:#6b7280;line-height:1.4;">
                Additional payments tied to future performance milestones (revenue, retention, etc.). Used to bridge valuation gaps or when growth projections factor into the price.
              </div>
            </div>
            <div style="background:white;padding:10px;border-radius:5px;border:1px solid #d1d9cf;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
                <div style="font-size:10px;font-weight:600;color:#64748b;">Equity Rollover</div>
                <div style="font-size:12px;font-weight:700;color:#64748b;">${fmt(equityAmount)} <span style="font-size:9px;font-weight:400;color:#6b7280;">(${equityPct}%)</span></div>
              </div>
              <div style="font-size:9px;color:#6b7280;line-height:1.4;">
                Retaining ownership stake in the business post-sale, common with private equity buyers. Allows participation in future upside if the business continues to grow.
              </div>
            </div>
          </div>
        </div>
        
        <!-- Advisory Fee Estimate -->
        <div style="background:#f8faf7;padding:15px;border-radius:8px;border:1px solid #d1d9cf;margin-bottom:20px;">
          <div style="font-size:12px;font-weight:600;color:#3d5c35;margin-bottom:10px;">Vista Advisory Fee Estimate</div>
          <div style="display:grid;grid-template-columns:2fr 1fr;gap:15px;align-items:start;">
            <table style="width:100%;border-collapse:collapse;font-size:11px;">
              <tbody>
                <tr style="border-bottom:1px solid #d1d9cf;background:#fff;">
                  <td style="padding:8px;">Deal Value (Market High)</td>
                  <td style="padding:8px;text-align:right;font-weight:700;color:#1f2937;">${fmt(highValue)}</td>
                </tr>
                <tr style="border-bottom:1px solid #d1d9cf;background:#e8ede6;">
                  <td style="padding:8px;">Retainer (upfront)</td>
                  <td style="padding:8px;text-align:right;font-weight:500;">${fmt(retainer)}</td>
                </tr>
                <tr style="border-bottom:1px solid #d1d9cf;background:#fff;">
                  <td style="padding:8px;">Balance at Close</td>
                  <td style="padding:8px;text-align:right;font-weight:500;">${fmt(balanceAtClose)}</td>
                </tr>
                <tr style="font-weight:700;background:#f0f4ef;">
                  <td style="padding:10px;">Total Fee${minimumApplied ? ' <span style="font-weight:400;font-size:9px;color:#d97706;">(minimum applied)</span>' : ''}</td>
                  <td style="padding:10px;text-align:right;color:#3d5c35;">${fmt(commission)}</td>
                </tr>
              </tbody>
            </table>
            <div style="background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);border-radius:8px;padding:12px;text-align:center;">
              <div style="font-size:9px;color:rgba(255,255,255,0.9);margin-bottom:4px;">Effective Rate</div>
              <div style="font-size:22px;font-weight:700;color:white;">${effectiveRate.toFixed(2)}%</div>
            </div>
          </div>
          <div style="font-size:9px;color:#6b7280;margin-top:10px;background:white;padding:8px;border-radius:5px;border:1px solid #d1d9cf;">
            <strong>Commission Schedule:</strong> 8% on first $1M, 5% $1-2M, 4% $2-3M, 3% $3-4M, 2% over $4M (minimum $40,000)<br/>
            <strong>Retainer:</strong> 1% of EBITDA (Min $5k / Max $20k) - Credited against success fee at close
          </div>
        </div>
      </div>
      
      <!-- The Vista Process Section -->
      <div class="section-header" style="background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);color:white;">The Vista Process</div>
      <div class="section-content" style="background:#f8faf7;">
        <div class="section-intro">
          <strong>Our Competitive Bidding Process</strong> is designed to generate multiple offers simultaneously, allowing you to choose 
          the best offer for your situation and leverage competing buyers against each other. For many businesses, we generate 50+ 
          interested parties through our extensive buyer network. The entire process typically takes <strong>6 months</strong> from 
          engagement to closing.
        </div>
        
        <!-- Two-Round Process Highlight -->
        <div style="background:white;border:2px solid #3d5c35;border-radius:8px;padding:15px;margin:15px 0;">
          <div style="font-size:12px;font-weight:700;color:#3d5c35;margin-bottom:12px;text-align:center;">Our Two-Round Offer Process</div>
          
          <div style="display:grid;grid-template-columns:1fr auto 1fr;gap:10px;align-items:center;">
            <!-- Round 1: IOI -->
            <div style="background:#e8ede6;padding:12px;border-radius:6px;">
              <div style="font-size:10px;font-weight:700;color:#3d5c35;margin-bottom:6px;">Round 1: Indications of Interest (IOI)</div>
              <div style="font-size:9px;color:#4b5563;line-height:1.4;">
                After 4-6 weeks of marketing, we set a deadline for all buyers to submit preliminary offers. 
                IOIs include a value range and proposed deal structure. We help you review all offers side-by-side 
                and select the <strong>top 5 buyers</strong> to advance.
              </div>
            </div>
            
            <!-- Arrow -->
            <div style="font-size:20px;color:#3d5c35;">→</div>
            
            <!-- Round 2: LOI -->
            <div style="background:#d4e8cf;padding:12px;border-radius:6px;">
              <div style="font-size:10px;font-weight:700;color:#3d5c35;margin-bottom:6px;">Round 2: Letters of Intent (LOI)</div>
              <div style="font-size:9px;color:#4b5563;line-height:1.4;">
                Selected buyers meet with you, receive detailed financials, and have 
                <strong>2 weeks</strong> to submit formal binding offers. We negotiate each LOI to maximize 
                your value and terms before you select your buyer.
              </div>
            </div>
          </div>
        </div>
        
        <!-- Process Timeline -->
        <div style="margin:15px 0;">
          <div style="display:flex;align-items:stretch;gap:0;">
            <!-- Phase 1: Preparation -->
            <div style="flex:1;background:#e8ede6;padding:12px;border-radius:8px 0 0 8px;border:1px solid #d1d9cf;border-right:none;">
              <div style="font-size:9px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;">Phase 1</div>
              <div style="font-size:11px;font-weight:700;color:#3d5c35;margin-bottom:6px;">Preparation</div>
              <div style="font-size:9px;color:#4b5563;line-height:1.4;">
                Sign engagement<br/>
                Gather documents<br/>
                Build memorandum
              </div>
              <div style="font-size:8px;color:#6b7280;margin-top:6px;font-weight:600;">1-3 weeks</div>
            </div>
            <!-- Phase 2: Marketing -->
            <div style="flex:1;background:#d4e8cf;padding:12px;border:1px solid #d1d9cf;border-right:none;">
              <div style="font-size:9px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;">Phase 2</div>
              <div style="font-size:11px;font-weight:700;color:#3d5c35;margin-bottom:6px;">Marketing</div>
              <div style="font-size:9px;color:#4b5563;line-height:1.4;">
                Confidential outreach<br/>
                NDA execution<br/>
                Distribute CIM
              </div>
              <div style="font-size:8px;color:#6b7280;margin-top:6px;font-weight:600;">4-6 weeks</div>
            </div>
            <!-- Phase 3: IOI Round -->
            <div style="flex:1;background:#c8d9c3;padding:12px;border:1px solid #d1d9cf;border-right:none;">
              <div style="font-size:9px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;">Phase 3</div>
              <div style="font-size:11px;font-weight:700;color:#3d5c35;margin-bottom:6px;">IOI Round</div>
              <div style="font-size:9px;color:#4b5563;line-height:1.4;">
                Collect all IOIs<br/>
                Select top 5 buyers<br/>
                Management meetings
              </div>
              <div style="font-size:8px;color:#6b7280;margin-top:6px;font-weight:600;">3-4 weeks</div>
            </div>
            <!-- Phase 4: LOI Round -->
            <div style="flex:1;background:#b8c9b3;padding:12px;border:1px solid #d1d9cf;border-right:none;">
              <div style="font-size:9px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;">Phase 4</div>
              <div style="font-size:11px;font-weight:700;color:#3d5c35;margin-bottom:6px;">LOI Round</div>
              <div style="font-size:9px;color:#4b5563;line-height:1.4;">
                2-week LOI deadline<br/>
                Negotiate terms<br/>
                Sign LOI
              </div>
              <div style="font-size:8px;color:#6b7280;margin-top:6px;font-weight:600;">2-3 weeks</div>
            </div>
            <!-- Phase 5: Close -->
            <div style="flex:1;background:#3d5c35;padding:12px;border-radius:0 8px 8px 0;color:white;">
              <div style="font-size:9px;opacity:0.8;text-transform:uppercase;margin-bottom:4px;">Phase 5</div>
              <div style="font-size:11px;font-weight:700;margin-bottom:6px;">Due Diligence & Close</div>
              <div style="font-size:9px;opacity:0.9;line-height:1.4;">
                Buyer verification<br/>
                Legal documentation<br/>
                Funds transfer
              </div>
              <div style="font-size:8px;opacity:0.8;margin-top:6px;font-weight:600;">8-12 weeks</div>
            </div>
          </div>
        </div>
        
        <!-- Why This Process Works -->
        <div style="background:white;border:1px solid #d1d9cf;border-radius:8px;padding:15px;margin-top:15px;">
          <div style="font-size:11px;font-weight:700;color:#3d5c35;margin-bottom:10px;">Why Our Competitive Process Works For You</div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            <div style="display:flex;gap:8px;align-items:flex-start;">
              <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">✓</div>
              <div>
                <div style="font-size:10px;font-weight:600;color:#3d5c35;">You Choose Your Buyer</div>
                <div style="font-size:9px;color:#6b7280;">Interview buyers and select the one that's right for you, your employees, and your business—not just the highest bidder.</div>
              </div>
            </div>
            <div style="display:flex;gap:8px;align-items:flex-start;">
              <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">✓</div>
              <div>
                <div style="font-size:10px;font-weight:600;color:#3d5c35;">See All Offers at Once</div>
                <div style="font-size:9px;color:#6b7280;">Compare every offer side-by-side. Know you're getting the best price without wondering if the next buyer would have offered more.</div>
              </div>
            </div>
            <div style="display:flex;gap:8px;align-items:flex-start;">
              <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">✓</div>
              <div>
                <div style="font-size:10px;font-weight:600;color:#3d5c35;">Maximum Leverage</div>
                <div style="font-size:9px;color:#6b7280;">With multiple competing buyers, we negotiate from a position of strength—pushing LOIs higher and securing better terms.</div>
              </div>
            </div>
            <div style="display:flex;gap:8px;align-items:flex-start;">
              <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">✓</div>
              <div>
                <div style="font-size:10px;font-weight:600;color:#3d5c35;">Built-In Backup Plan</div>
                <div style="font-size:9px;color:#6b7280;">If a deal falls through, we go to runner-up bidders immediately. No starting over. This is rare—Vista maintains a near 100% close rate.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Items to Consider Section -->
      <div class="section-header">Important Items to Consider</div>
      <div class="section-content">
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
          <div style="background:white;padding:12px;border-radius:6px;border:1px solid #d1d9cf;">
            <div style="font-size:10px;font-weight:600;color:#3d5c35;margin-bottom:6px;">Working Capital</div>
            <div style="font-size:9px;color:#6b7280;line-height:1.5;">
              Buyers require a normal level of working capital (Accounts Receivable + Inventory − Accounts Payable) 
              to remain with the business. Cash is typically excluded. The amount included is usually the trailing 
              12-month average. This is the "lifeblood" that allows the business to operate—without it, the buyer 
              would need to inject additional capital above the purchase price.
            </div>
          </div>
          <div style="background:white;padding:12px;border-radius:6px;border:1px solid #d1d9cf;">
            <div style="font-size:10px;font-weight:600;color:#3d5c35;margin-bottom:6px;">Due Diligence</div>
            <div style="font-size:9px;color:#6b7280;line-height:1.5;">
              After signing the LOI, the buyer verifies everything you've disclosed. Expect detailed requests 
              for financial records, contracts, employee information, and legal documents. This phase is 
              time-consuming but standard. The purpose is to confirm accuracy—not to renegotiate (though 
              material discrepancies can affect terms).
            </div>
          </div>
          <div style="background:white;padding:12px;border-radius:6px;border:1px solid #d1d9cf;">
            <div style="font-size:10px;font-weight:600;color:#3d5c35;margin-bottom:6px;">Escrow Holdback</div>
            <div style="font-size:9px;color:#6b7280;line-height:1.5;">
              For larger transactions, a portion of proceeds (typically 5-10%) may be held in escrow for 
              12-18 months as protection against undisclosed liabilities or misrepresentations. This is 
              standard practice and released to you after the holdback period if no claims arise.
            </div>
          </div>
          <div style="background:white;padding:12px;border-radius:6px;border:1px solid #d1d9cf;">
            <div style="font-size:10px;font-weight:600;color:#3d5c35;margin-bottom:6px;">Transition Period</div>
            <div style="font-size:9px;color:#6b7280;line-height:1.5;">
              You are key to a smooth handoff. Most deals include 30-90 days of transition support 
              (training the new owner, introducing key relationships, answering questions). This time 
              is included in the purchase price—extended support beyond the standard period can be 
              negotiated separately.
            </div>
          </div>
          <div style="background:white;padding:12px;border-radius:6px;border:1px solid #d1d9cf;">
            <div style="font-size:10px;font-weight:600;color:#3d5c35;margin-bottom:6px;">SBA Financing Requirements</div>
            <div style="font-size:9px;color:#6b7280;line-height:1.5;">
              Most buyers use SBA-backed loans, which require the seller to carry approximately 10% as 
              a seller note. SBA dictates the terms (typically on standby for 2 years, then amortizing). 
              This isn't negotiable when SBA is involved—it's designed to ensure seller commitment to 
              a successful transition.
            </div>
          </div>
          <div style="background:white;padding:12px;border-radius:6px;border:1px solid #d1d9cf;">
            <div style="font-size:10px;font-weight:600;color:#3d5c35;margin-bottom:6px;">Exclusivity Period</div>
            <div style="font-size:9px;color:#6b7280;line-height:1.5;">
              The LOI grants the buyer an exclusive period (typically 60-90 days) to complete due 
              diligence and secure financing. During this time, you cannot negotiate with other 
              buyers. This is reasonable—it allows the buyer to invest time and resources knowing 
              they have a clear path to closing.
            </div>
          </div>
        </div>
      </div>
      
      <!-- What's Next Section -->
      <div class="section-header" style="background:linear-gradient(135deg, #3d5c35 0%, #5a7d50 100%);color:white;">What's Next?</div>
      <div class="section-content" style="background:#f8faf7;">
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;">
          <!-- Ready to Sell -->
          <div style="background:white;padding:18px;border-radius:8px;border:2px solid #3d5c35;">
            <div style="font-size:13px;font-weight:700;color:#3d5c35;margin-bottom:10px;">Ready to Move Forward?</div>
            <div style="font-size:10px;color:#4b5563;line-height:1.5;margin-bottom:12px;">
              If you're ready to begin the sale process, we'll send you an Engagement Agreement for review. 
              Once signed and the retainer is received, we immediately begin preparing your Confidential 
              Information Memorandum.
            </div>
            <div style="background:#e8ede6;padding:10px;border-radius:5px;margin-bottom:10px;">
              <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;font-weight:700;">1</div>
                <div style="font-size:10px;color:#3d5c35;font-weight:600;">Review & Sign Engagement Agreement</div>
              </div>
              <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;font-weight:700;">2</div>
                <div style="font-size:10px;color:#3d5c35;font-weight:600;">Submit Retainer (credited at close)</div>
              </div>
              <div style="display:flex;align-items:center;gap:8px;">
                <div style="width:20px;height:20px;background:#3d5c35;border-radius:50%;color:white;font-size:10px;display:flex;align-items:center;justify-content:center;font-weight:700;">3</div>
                <div style="font-size:10px;color:#3d5c35;font-weight:600;">We Get Started Immediately</div>
              </div>
            </div>
            <div style="text-align:center;background:#3d5c35;color:white;padding:10px;border-radius:5px;font-size:11px;font-weight:600;">
              ~6 Months from Engagement to Close
            </div>
          </div>
          
          <!-- Not Ready Yet -->
          <div style="background:white;padding:18px;border-radius:8px;border:1px solid #d1d9cf;">
            <div style="font-size:13px;font-weight:700;color:#4b5563;margin-bottom:10px;">Not Ready to Sell Yet?</div>
            <div style="font-size:10px;color:#4b5563;line-height:1.5;margin-bottom:12px;">
              That's completely fine. Many owners use this valuation as a benchmark to track progress 
              toward their exit goals. We recommend staying connected so you're prepared when the time is right.
            </div>
            <div style="background:#f8f9fa;padding:10px;border-radius:5px;">
              <div style="display:flex;align-items:flex-start;gap:10px;margin-bottom:10px;padding-bottom:10px;border-bottom:1px solid #e5e7eb;">
                <div style="font-size:16px;">📅</div>
                <div>
                  <div style="font-size:10px;font-weight:600;color:#3d5c35;">6-Month Review Meetings</div>
                  <div style="font-size:9px;color:#6b7280;">We'll update you on M&A market conditions and discuss your business progress</div>
                </div>
              </div>
              <div style="display:flex;align-items:flex-start;gap:10px;">
                <div style="font-size:16px;">📊</div>
                <div>
                  <div style="font-size:10px;font-weight:600;color:#3d5c35;">Annual Valuation Updates</div>
                  <div style="font-size:9px;color:#6b7280;">Every 12 months we'll refresh your valuation to track how your value is changing</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Disclaimer -->
      <div style="margin-top:25px;padding:15px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:6px;">
        <div style="font-size:9px;color:#6b7280;line-height:1.5;text-align:center;">
          <strong>Disclaimer:</strong> This document represents an opinion of value based on information provided and is intended for informational 
          purposes only. This is not a formal appraisal and should not be used for legal, tax, or regulatory purposes. Actual transaction values 
          may vary based on market conditions, buyer motivations, deal structure, and other factors discovered during due diligence. 
          Vista Business Group makes no guarantees regarding final sale price or transaction completion.
        </div>
      </div>
    `;
  };

  const generateValueEnhancementHTML = (data) => {
    const { enhancement, valuation, keyMetrics } = data;
    const fmt = (n) => '$' + Math.round(n || 0).toLocaleString();
    const pct = (n) => (n || 0).toFixed(1) + '%';
    const companyName = dealProfile.companyName || 'Company';
    
    // Current metrics
    // The multiple's lever (Mark 10-06): contract revenue; grandfathered valuations still score the weighted mix.
    const currentRecurring = (revenueScoringMode === 'legacy' ? keyMetrics.recurringPct : keyMetrics.contractedRecurringPct) || 0;
    const currentGrowth = revenueAnalysis?.yoyChanges?.year5toTTM || 0;
    const currentRetention = keyMetrics.avgRetention || 0;
    const currentConc = keyMetrics?.topCustomerPct || multipleAdjustments.concentration?.topCustomerPct || 0;
    const currentClients = keyMetrics?.customerCount?.ttm || multipleAdjustments.concentration?.totalClientCount || 0;
    const currentEbitdaMargin = keyMetrics.ebitdaMargin || 0;
    const currentEbitda = data.normalizedEbitda || 0;
    const ttmRev = calculations.years?.[5]?.revenue || 0;
    
    // Target metrics (from sliders)
    const targetRecurring = enhancement.recurringTarget !== null ? enhancement.recurringTarget : currentRecurring;
    const targetGrowth = enhancement.growthTarget !== null ? enhancement.growthTarget : currentGrowth;
    const targetRetention = enhancement.retentionTarget !== null ? enhancement.retentionTarget : currentRetention;
    const targetConc = enhancement.concentrationTarget !== null ? enhancement.concentrationTarget : currentConc;
    const marginImprovement = enhancement.marginImprovement || 0;
    const ebitdaChange = enhancement.ebitdaChange || 0;
    const marginEbitdaGain = ttmRev * (marginImprovement / 100);
    const ebitdaGrowthGain = currentEbitda * (ebitdaChange / 100);
    const targetEbitda = currentEbitda + ebitdaGrowthGain + marginEbitdaGain;
    const targetMarginPct = ttmRev > 0 ? (targetEbitda / ttmRev * 100) : 0;
    
    // Multiple bonuses (same logic as simulator)
    const recurringDelta = targetRecurring - currentRecurring;
    const recurringBonus = recurringDelta > 0 ? Math.min(0.5, (recurringDelta / 20) * 0.25) : 0;
    let growthBonus = 0;
    if (targetGrowth >= 20 && currentGrowth < 20) growthBonus = 0.4;
    else if (targetGrowth >= 10 && currentGrowth < 10) growthBonus = 0.25;
    else if (targetGrowth > currentGrowth) growthBonus = Math.min(0.3, (targetGrowth - currentGrowth) * 0.02);
    const retentionBonus = (targetRetention - currentRetention) > 0 ? Math.min(0.5, ((targetRetention - currentRetention) / 10) * 0.25) : 0;
    let concBonus = 0;
    if (currentConc > 0 && targetConc > 0 && targetConc < currentConc) {
      if (targetConc <= 10 && currentConc > 10) concBonus = 0.2;
      else if (targetConc <= 15 && currentConc > 15) concBonus = 0.1;
      else concBonus = Math.min(0.2, (currentConc - targetConc) * 0.01);
    }
    const ci = enhancement.contractImprovements || {};
    const contractBonus = (ci.extendTerms ? 0.2 : 0) + (ci.addAutoRenewal ? 0.1 : 0) + (ci.addEscalators ? 0.15 : 0) + (ci.addTermPenalty ? 0.15 : 0) + (ci.reduceOwnerDependency ? 0.25 : 0) + (ci.improveAR ? 0.15 : 0);
    const totalMultipleBonus = recurringBonus + growthBonus + retentionBonus + concBonus + contractBonus;
    
    // Enhanced multiple with size tier
    let enhancedBase = baseMultipleTable[0]?.multiple || 3.0;
    for (let i = 0; i < baseMultipleTable.length - 1; i++) {
      if (targetEbitda >= baseMultipleTable[i].ebitda && targetEbitda < baseMultipleTable[i + 1].ebitda) {
        const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
        const mRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
        enhancedBase = baseMultipleTable[i].multiple + (mRange * ((targetEbitda - baseMultipleTable[i].ebitda) / range));
        break;
      }
      if (targetEbitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) enhancedBase = baseMultipleTable[baseMultipleTable.length - 1].multiple;
    }
    const sizeBonus = enhancedBase - multipleEngineCalcs.rawBaseMultiple;
    const enhancedMultiple = Math.max(0, multipleEngineCalcs.marketHighMultiple + sizeBonus + totalMultipleBonus);
    const enhancedTypical = Math.max(0, multipleEngineCalcs.typicalMultiple + sizeBonus + totalMultipleBonus);
    const currentValHigh = multipleEngineCalcs.valuationMarketHigh || 0;
    const enhancedValHigh = targetEbitda * enhancedMultiple;
    const enhancedValLow = targetEbitda * enhancedTypical;
    const valueIncrease = enhancedValHigh - currentValHigh;
    
    const hasChanges = ebitdaChange > 0 || marginImprovement > 0 || totalMultipleBonus > 0;
    const benchmarks = currentBenchmarks || {};
    
    // Build improvement rows
    const improvements = [];
    if (ebitdaChange > 0) improvements.push({ label: `EBITDA Growth +${ebitdaChange}%`, impact: fmt(ebitdaGrowthGain), type: 'ebitda' });
    if (marginImprovement > 0) improvements.push({ label: `Margin +${marginImprovement} pts`, impact: fmt(marginEbitdaGain), type: 'ebitda' });
    if (recurringBonus > 0) improvements.push({ label: `Recurring Revenue ${pct(currentRecurring)} → ${pct(targetRecurring)}`, impact: `+${recurringBonus.toFixed(2)}x`, type: 'multiple' });
    if (growthBonus > 0) improvements.push({ label: `Revenue Growth ${pct(currentGrowth)} → ${pct(targetGrowth)}`, impact: `+${growthBonus.toFixed(2)}x`, type: 'multiple' });
    if (retentionBonus > 0) improvements.push({ label: `Retention ${pct(currentRetention)} → ${pct(targetRetention)}`, impact: `+${retentionBonus.toFixed(2)}x`, type: 'multiple' });
    if (concBonus > 0) improvements.push({ label: `Concentration ${pct(currentConc)} → ${pct(targetConc)}`, impact: `+${concBonus.toFixed(2)}x`, type: 'multiple' });
    if (ci.extendTerms) improvements.push({ label: 'Extend contract terms to multi-year', impact: '+0.20x', type: 'multiple' });
    if (ci.addAutoRenewal) improvements.push({ label: 'Add auto-renewal clauses', impact: '+0.10x', type: 'multiple' });
    if (ci.addEscalators) improvements.push({ label: 'Add price escalator clauses', impact: '+0.15x', type: 'multiple' });
    if (ci.addTermPenalty) improvements.push({ label: 'Add early termination penalties', impact: '+0.15x', type: 'multiple' });
    if (ci.reduceOwnerDependency) improvements.push({ label: 'Reduce owner dependency', impact: '+0.25x', type: 'multiple' });
    if (ci.improveAR) improvements.push({ label: 'Improve AR collections', impact: '+0.15x', type: 'multiple' });
    if (sizeBonus > 0.01) improvements.push({ label: 'Size tier upgrade', impact: `+${sizeBonus.toFixed(2)}x`, type: 'multiple' });
    
    return `
      <div class="section-header">🚀 Value Enhancement Plan — ${companyName}</div>
      <div class="section-content">
        <div class="section-intro">
          This analysis models how specific, achievable improvements could impact the value of your business. 
          Each item below represents a measurable goal — your Vista advisor will track progress at every review meeting.
        </div>
        
        ${hasChanges ? `
        <!-- Current vs Enhanced -->
        <div style="display:grid;grid-template-columns:1fr auto 1fr;gap:15px;margin-bottom:20px;align-items:center;">
          <div style="background:#f8faf7;border:1px solid #d1d9cf;border-radius:8px;padding:15px;text-align:center;">
            <div style="font-size:10px;color:#6b7280;margin-bottom:5px;text-transform:uppercase;letter-spacing:0.5px;">Current Valuation</div>
            <div style="font-size:22px;font-weight:700;color:#374151;">${fmt(valuation.valuationLow)} — ${fmt(currentValHigh)}</div>
            <div style="font-size:10px;color:#6b7280;">${multipleEngineCalcs.typicalMultiple.toFixed(2)}x — ${multipleEngineCalcs.marketHighMultiple.toFixed(2)}x on ${fmt(currentEbitda)} EBITDA</div>
          </div>
          <div style="font-size:28px;color:#3d5c35;">→</div>
          <div style="background:linear-gradient(135deg, #f0f4ef 0%, #e8ede6 100%);border:2px solid #3d5c35;border-radius:8px;padding:15px;text-align:center;">
            <div style="font-size:10px;color:#3d5c35;margin-bottom:5px;text-transform:uppercase;letter-spacing:0.5px;font-weight:600;">Target Valuation</div>
            <div style="font-size:22px;font-weight:700;color:#3d5c35;">${fmt(enhancedValLow)} — ${fmt(enhancedValHigh)}</div>
            <div style="font-size:10px;color:#4a6b42;">${enhancedTypical.toFixed(2)}x — ${enhancedMultiple.toFixed(2)}x on ${fmt(targetEbitda)} EBITDA</div>
          </div>
        </div>
        
        ${valueIncrease > 0 ? `
        <div style="background:#3d5c35;color:white;border-radius:8px;padding:15px;text-align:center;margin-bottom:20px;">
          <div style="font-size:10px;opacity:0.8;text-transform:uppercase;letter-spacing:1px;">Potential Value Increase</div>
          <div style="font-size:28px;font-weight:700;">+${fmt(valueIncrease)}</div>
          <div style="font-size:11px;opacity:0.8;">${((valueIncrease / Math.max(1, currentValHigh)) * 100).toFixed(0)}% increase from current valuation</div>
        </div>` : ''}
        
        <!-- Improvement Details -->
        <h2 style="color:#3d5c35;border-color:#3d5c35;">Improvement Details</h2>
        <table>
          <thead><tr><th style="text-align:left;background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Improvement</th><th style="background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Impact</th><th style="text-align:center;background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Type</th></tr></thead>
          <tbody>
            ${improvements.map((imp, i) => `
              <tr style="background:${i % 2 === 0 ? '#fff' : '#f8faf7'};">
                <td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">${imp.label}</td>
                <td style="text-align:right;padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${imp.impact}</td>
                <td style="text-align:center;padding:8px;border:1px solid #d1d9cf;">
                  <span style="background:${imp.type === 'ebitda' ? '#dbeafe' : '#dcfce7'};color:${imp.type === 'ebitda' ? '#1e40af' : '#166534'};padding:2px 8px;border-radius:10px;font-size:9px;font-weight:600;">${imp.type === 'ebitda' ? 'EBITDA' : 'Multiple'}</span>
                </td>
              </tr>
            `).join('')}
            <tr style="background:#e8ede6;font-weight:700;">
              <td style="text-align:left;padding:10px;border:1px solid #d1d9cf;">Total EBITDA Impact</td>
              <td style="text-align:right;padding:10px;border:1px solid #d1d9cf;color:#3d5c35;">${fmt(targetEbitda - currentEbitda)}</td>
              <td style="text-align:center;padding:10px;border:1px solid #d1d9cf;font-size:10px;">${fmt(currentEbitda)} → ${fmt(targetEbitda)}</td>
            </tr>
            <tr style="background:#e8ede6;font-weight:700;">
              <td style="text-align:left;padding:10px;border:1px solid #d1d9cf;">Total Multiple Impact</td>
              <td style="text-align:right;padding:10px;border:1px solid #d1d9cf;color:#3d5c35;">+${(totalMultipleBonus + sizeBonus).toFixed(2)}x</td>
              <td style="text-align:center;padding:10px;border:1px solid #d1d9cf;font-size:10px;">${multipleEngineCalcs.marketHighMultiple.toFixed(2)}x → ${enhancedMultiple.toFixed(2)}x</td>
            </tr>
          </tbody>
        </table>
        
        <!-- Key Metrics Current vs Target -->
        <h2 style="color:#3d5c35;border-color:#3d5c35;">Key Metrics — Current vs Target</h2>
        <table>
          <thead><tr>
            <th style="text-align:left;background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Metric</th>
            <th style="background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Current</th>
            <th style="background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Target</th>
            <th style="background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);">Benchmark</th>
          </tr></thead>
          <tbody>
            <tr><td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">EBITDA</td><td style="padding:8px;border:1px solid #d1d9cf;">${fmt(currentEbitda)}</td><td style="padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${fmt(targetEbitda)}</td><td style="padding:8px;border:1px solid #d1d9cf;color:#6b7280;">—</td></tr>
            <tr style="background:#f8faf7;"><td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">EBITDA Margin</td><td style="padding:8px;border:1px solid #d1d9cf;">${pct(currentEbitdaMargin)}</td><td style="padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${pct(targetMarginPct)}</td><td style="padding:8px;border:1px solid #d1d9cf;color:#6b7280;">${pct(benchmarks.ebitdaMargin || 18)}</td></tr>
            <tr><td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">Recurring Revenue</td><td style="padding:8px;border:1px solid #d1d9cf;">${pct(currentRecurring)}</td><td style="padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${pct(targetRecurring)}</td><td style="padding:8px;border:1px solid #d1d9cf;color:#6b7280;">${pct(benchmarks.recurringRevenuePct || 65)}</td></tr>
            <tr style="background:#f8faf7;"><td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">Customer Retention</td><td style="padding:8px;border:1px solid #d1d9cf;">${pct(currentRetention)}</td><td style="padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${pct(targetRetention)}</td><td style="padding:8px;border:1px solid #d1d9cf;color:#6b7280;">${pct(benchmarks.customerRetentionRate || 90)}</td></tr>
            <tr><td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">Top Client Concentration</td><td style="padding:8px;border:1px solid #d1d9cf;">${pct(currentConc)}</td><td style="padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${pct(targetConc)}</td><td style="padding:8px;border:1px solid #d1d9cf;color:#6b7280;">${pct(benchmarks.topCustomerConcentration || 15)}</td></tr>
            <tr style="background:#f8faf7;"><td style="text-align:left;padding:8px;border:1px solid #d1d9cf;">Revenue Growth Rate</td><td style="padding:8px;border:1px solid #d1d9cf;">${pct(currentGrowth)}</td><td style="padding:8px;border:1px solid #d1d9cf;font-weight:600;color:#3d5c35;">${pct(targetGrowth)}</td><td style="padding:8px;border:1px solid #d1d9cf;color:#6b7280;">${pct(benchmarks.industryGrowthRate || 8)}</td></tr>
          </tbody>
        </table>
        ` : `
        <div style="text-align:center;padding:30px;color:#6b7280;">
          <div style="font-size:24px;margin-bottom:10px;">🚀</div>
          <div style="font-size:13px;font-weight:500;">No improvements modeled yet</div>
          <div style="font-size:11px;margin-top:5px;">Use the Value Enhancement Simulator sliders to model improvements and see their impact here.</div>
        </div>
        `}
      </div>
    `;
  };

  const generateBlueprintHTML = (data) => {
    const { valuation, keyMetrics } = data;
    const fmt = (n) => '$' + Math.round(n || 0).toLocaleString();
    const pct = (n) => (n || 0).toFixed(1) + '%';
    const companyName = dealProfile.companyName || 'Company';
    
    const targetVal = blueprintTargetValuation || 0;
    const timelineYrs = blueprintTimelineYears || 0;
    if (!targetVal || !timelineYrs) return '';
    
    const currentEbitda = multipleEngineCalcs.adjustedEbitda || 0;
    const currentRevenue = calculations.years?.[5]?.revenue || 0;
    const currentMultiple = multipleEngineCalcs.marketHighMultiple || 0;
    const currentValuation = multipleEngineCalcs.valuationMarketHigh || 0;
    const currentMargin = currentRevenue > 0 ? (currentEbitda / currentRevenue * 100) : 0;
    const targetMargin = blueprintTargetMargin || (currentMargin > 5 ? Math.min(25, Math.max(15, currentMargin + 5)) : 18);
    const recurringPctVal = keyMetrics?.recurringPct || 0;
    const currentFactors = multipleEngineCalcs.factors || {};
    const benchmarkMargin = currentBenchmarks?.ebitdaMargin || 18;
    const benchRecurring = currentBenchmarks?.recurringRevenuePct || 65;
    
    // Historical growth
    const revY3 = revenueCategories.reduce((s, c) => s + (c[selectedValuationBasis]?.year3 || 0), 0);
    const revY4 = revenueCategories.reduce((s, c) => s + (c[selectedValuationBasis]?.year4 || 0), 0);
    const revY5 = revenueCategories.reduce((s, c) => s + (c[selectedValuationBasis]?.year5 || 0), 0);
    const rates = [];
    if (revY3 > 0 && revY4 > 0) rates.push((revY4 - revY3) / revY3 * 100);
    if (revY4 > 0 && revY5 > 0) rates.push((revY5 - revY4) / revY4 * 100);
    const avgGrowth = rates.length > 0 ? rates.reduce((a, b) => a + b, 0) / rates.length : 0;
    
    // Slider targets
    const cRet = keyMetrics?.customerRetentionRate || keyMetrics?.revenueRetentionRate || 0;
    const cConc = keyMetrics?.topCustomerConcentration || multipleAdjustments.concentration?.topCustomerPct || 0;
    const tRec = simRecurringPct != null ? simRecurringPct : recurringPctVal;
    const tRet = simRetentionRate != null ? simRetentionRate : cRet;
    const tConc = simTopCustomerPct != null ? simTopCustomerPct : cConc;
    const ci = simContractImprovements || {};
    
    // Helpers
    const calcB1 = (m) => m >= benchmarkMargin + 8 ? 0.5 : m >= benchmarkMargin + 4 ? 0.25 : m >= benchmarkMargin - 4 ? 0 : m >= 10 ? 0 : m >= 5 ? -0.25 : -0.50;
    const calcE1 = (tp, t5) => { let s = 0; if (tp <= 5) s += 0.15; else if (tp <= 10) s += 0.1; else if (tp <= 15) s += 0; else if (tp <= 25) s -= 0.1; else if (tp <= 35) s -= 0.2; else s -= 0.35; if (t5 <= 20) s += 0.15; else if (t5 <= 30) s += 0.1; else if (t5 <= 40) s += 0; else if (t5 <= 50) s -= 0.05; else if (t5 <= 60) s -= 0.1; else if (t5 <= 70) s -= 0.2; else s -= 0.35; return s; };
    
    // Customer data
    const sortedClients = customerSalesData.filter(c => c.name && c.ttm > 0).sort((a, b) => b.ttm - a.ttm);
    const topCustRev = sortedClients[0]?.ttm || 0;
    const top5CustRev = sortedClients.slice(0, 5).reduce((s, c) => s + c.ttm, 0);
    const clientCount = sortedClients.length;
    const top5Pct = keyMetrics?.top5CustomerConcentration || (currentRevenue > 0 ? top5CustRev / currentRevenue * 100 : 0);
    
    // ===== FACTOR PROJECTIONS =====
    const fp = [];
    const bpGrowth = true; // Blueprint always implies growth
    const growthRate = Math.max(15, avgGrowth);
    
    // A: Revenue Quality
    const fA = currentFactors.A;
    if (fA) {
      const a1c = fA.subFactors?.A1?.score || 0;
      const projRecDiff = tRec - benchRecurring;
      const a1p = projRecDiff >= 30 ? 0.75 : projRecDiff >= 20 ? 0.5 : projRecDiff >= 10 ? 0.25 : projRecDiff <= -30 ? -0.75 : projRecDiff <= -20 ? -0.5 : projRecDiff <= -10 ? -0.25 : 0;
      const a2c = fA.subFactors?.A2?.score || 0; const a2p = 0.15;
      const a3c = fA.subFactors?.A3?.score || 0; const a3p = Math.max(a3c, 0);
      const a4c = fA.subFactors?.A4?.score || 0;
      const a5c = fA.subFactors?.A5?.score || 0; const a5p = (tRec >= 65 && growthRate > 5) ? 0.10 : (tRec >= 50 && growthRate > 5) ? 0 : a5c;
      const a6c = fA.subFactors?.A6?.score || 0; const a6p = growthRate > 10 ? 0 : a6c;
      const curA = fA.adjustment || 0; const projA = Math.round((a1p + a2p + a3p + a4c + a5p + a6p) * 100) / 100;
      const subs = [
        { name: 'Recurring Revenue', cur: a1c, proj: a1p, type: a1p !== a1c ? 'target' : 'static', note: a1p !== a1c ? `Recurring ${recurringPctVal.toFixed(0)}%→${tRec.toFixed(0)}%` : '' },
        { name: 'YoY Stability', cur: a2c, proj: a2p, type: a2p !== a2c ? 'auto' : 'static', note: 'Consistent growth' },
        { name: 'Monthly Distribution', cur: a3c, proj: a3p, type: a3p !== a3c ? 'auto' : 'static', note: 'Normalizes with scale' },
        { name: 'Customer Type', cur: a4c, proj: a4c, type: 'static', note: '' },
        { name: 'Growth Quality', cur: a5c, proj: a5p, type: a5p !== a5c ? 'auto' : 'static', note: 'Growth from recurring' },
        { name: 'Customer Spike', cur: a6c, proj: a6p, type: a6p !== a6c ? 'auto' : 'static', note: 'Diluted by growth' }
      ];
      fp.push({ key: 'A', name: 'Revenue Quality', cur: curA, proj: projA, imp: Math.round((projA - curA) * 100) / 100, timeline: 3, subs });
    }
    
    // B: EBITDA Quality
    const fB = currentFactors.B;
    if (fB) {
      const b1c = fB.subFactors?.B1?.score || 0; const b1p = calcB1(targetMargin);
      const b2c = fB.subFactors?.B2?.score || 0; const b2p = (targetMargin > currentMargin) ? 0.15 : Math.max(b2c, 0);
      const b4c = fB.subFactors?.B4?.score || 0; const b4p = targetMargin >= 10 ? 0 : b4c;
      const curB = fB.adjustment || 0; const projB = Math.round((b1p + b2p + b4p) * 100) / 100;
      const subs = [
        { name: 'EBITDA Margins', cur: b1c, proj: b1p, type: b1p !== b1c ? 'auto' : 'static', note: `Margin ${currentMargin.toFixed(0)}%→${targetMargin}%` },
        { name: 'Margin Stability', cur: b2c, proj: b2p, type: b2p !== b2c ? 'auto' : 'static', note: 'Improving trend' },
        { name: 'Negative Months', cur: b4c, proj: b4p, type: b4p !== b4c ? 'auto' : 'static', note: 'Eliminated at target margin' }
      ];
      fp.push({ key: 'B', name: 'EBITDA Quality', cur: curB, proj: projB, imp: Math.round((projB - curB) * 100) / 100, timeline: 3, subs });
    }
    
    // C: Customer Retention
    const curC = currentFactors.C?.adjustment || 0;
    const retBonus = tRet > cRet ? Math.min(0.5, (tRet - cRet) / 10 * 0.25) : 0;
    fp.push({ key: 'C', name: 'Customer Retention', cur: curC, proj: Math.round((curC + retBonus) * 100) / 100, imp: Math.round(retBonus * 100) / 100, timeline: 2 });
    
    // D: Contract Terms
    const curD = currentFactors.D?.adjustment || 0;
    const dBonus = (ci.extendTerms ? 0.2 : 0) + (ci.addAutoRenewal ? 0.1 : 0) + (ci.addEscalators ? 0.15 : 0) + (ci.addTermPenalty ? 0.15 : 0);
    const dActions = [];
    if (ci.extendTerms) dActions.push('Extend contract terms to multi-year');
    if (ci.addAutoRenewal) dActions.push('Add auto-renewal clauses');
    if (ci.addEscalators) dActions.push('Add annual price escalators');
    if (ci.addTermPenalty) dActions.push('Add early termination penalties');
    fp.push({ key: 'D', name: 'Contract Terms', cur: curD, proj: Math.round((curD + dBonus) * 100) / 100, imp: Math.round(dBonus * 100) / 100, timeline: 1, note: dActions.length > 0 ? dActions.join('; ') : '' });
    
    // E: Concentration Risk
    const fE = currentFactors.E;
    const curE = fE?.adjustment || 0;
    let projE = curE;
    let eNote = '';
    const estTgtRev = targetMargin > 0 ? (targetVal / 4) / (targetMargin / 100) : currentRevenue * 3;
    if (currentRevenue > 0 && topCustRev > 0) {
      const autoTopPct = estTgtRev > currentRevenue ? (topCustRev / estTgtRev) * 100 : cConc;
      const autoTop5Pct = estTgtRev > currentRevenue ? (top5CustRev / estTgtRev) * 100 : top5Pct;
      const fTopPct = (tConc > 0 && tConc < cConc) ? Math.min(autoTopPct, tConc) : autoTopPct;
      const fTop5Pct = (tConc > 0 && tConc < cConc) ? Math.min(autoTop5Pct, tConc * 3) : autoTop5Pct;
      const e1p = calcE1(fTopPct, fTop5Pct);
      const e1bp = (dBonus > 0 || curD >= 0) ? Math.max(fE?.subFactors?.E1b?.score || 0, 0) : (fE?.subFactors?.E1b?.score || 0);
      const e2 = fE?.subFactors?.E2?.score || 0;
      const e3 = fE?.subFactors?.E3?.score || 0;
      const pCount = Math.round(clientCount * Math.pow(Math.max(estTgtRev, currentRevenue) / currentRevenue, 0.5));
      const e4p = pCount >= 200 ? 0.2 : pCount >= 100 ? 0.15 : pCount >= 50 ? 0.1 : pCount >= 20 ? 0.05 : (fE?.subFactors?.E4?.score || 0);
      const ge4p = fTop5Pct <= 40 ? e4p : Math.min(e4p, 0);
      projE = Math.round((e1p + e1bp + e2 + e3 + ge4p) * 100) / 100;
      eNote = `As revenue grows from ${fmt(currentRevenue)} to ${fmt(estTgtRev)}, new customer acquisition naturally dilutes top client concentration from ${cConc.toFixed(0)}% to ${fTopPct.toFixed(0)}%. This assumes growth comes primarily from new clients and expanding smaller existing accounts, not from increasing dependence on current top clients.`;
    }
    fp.push({ key: 'E', name: 'Concentration Risk', cur: curE, proj: projE, imp: Math.round((projE - curE) * 100) / 100, timeline: 4, note: eNote });
    
    // H: Owner Continuity
    fp.push({ key: 'H', name: 'Owner Continuity', cur: currentFactors.H?.adjustment || 0, proj: currentFactors.H?.adjustment || 0, imp: 0, timeline: 0 });
    
    // J: Owner Dependency
    const curJ = currentFactors.J?.adjustment || 0;
    const jData = currentFactors.J || {};
    let projJ = curJ;
    let jNote = '';
    if (ci.reduceOwnerDependency) { 
      projJ = curJ <= -0.50 ? 0 : curJ <= -0.25 ? 0.25 : curJ < 0.50 ? 0.50 : curJ;
      const hrs = jData.parsedHours;
      const revPct = jData.parsedRevenuePct;
      jNote = 'Reducing owner dependency is typically a 2-3 year process: ';
      jNote += 'Year 1 — Hire an operations manager or service delivery lead to handle day-to-day client needs. ';
      jNote += 'Year 2 — Transition key client relationships to the management team; reduce owner hours from ' + (hrs ? `${hrs}` : 'full-time') + ' to 20 hrs/week. ';
      jNote += 'Year 3 — Owner in strategic/advisory role only' + (revPct > 30 ? `; owner-dependent revenue reduced from ${revPct}% to under 30%` : '') + '.';
    }
    fp.push({ key: 'J', name: 'Owner Dependency', cur: curJ, proj: projJ, imp: Math.round((projJ - curJ) * 100) / 100, timeline: 3, note: jNote });
    
    // G: A/R & Collections
    const curG = currentFactors.G?.adjustment || 0;
    const gImp = ci.improveAR ? 0.15 : 0;
    fp.push({ key: 'G', name: 'A/R & Collections', cur: curG, proj: Math.round((curG + gImp) * 100) / 100, imp: Math.round(gImp * 100) / 100, timeline: 1 });
    
    // Totals
    const totalCurQ = fp.reduce((s, f) => s + f.cur, 0);
    const totalProjQ = fp.reduce((s, f) => s + f.proj, 0);
    const totalImp = Math.round((totalProjQ - totalCurQ) * 100) / 100;
    
    // Year-aware quality
    const getQAtYear = (yr) => fp.reduce((s, f) => {
      if (f.timeline <= 0 || f.imp === 0) return s + f.cur;
      return s + f.cur + (f.imp * Math.min(1, yr / f.timeline));
    }, 0);
    
    // Multiple estimation - floor applies in early years, NOT at exit
    const getFloor = (ebitda) => ebitda <= 0 ? 0 : ebitda >= 300000 ? 3.0 : ebitda <= 75000 ? 2.0 : 2.0 + ((ebitda - 75000) / 225000);
    const estMult = (ebitda, yr = null, noFloor = false) => {
      let m = baseMultipleTable[0]?.multiple || 3.0;
      for (let i = 0; i < baseMultipleTable.length - 1; i++) {
        if (ebitda >= baseMultipleTable[i].ebitda && ebitda < baseMultipleTable[i + 1].ebitda) {
          const r = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
          const mr = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
          m = baseMultipleTable[i].multiple + (mr * ((ebitda - baseMultipleTable[i].ebitda) / r));
          break;
        }
        if (ebitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) m = baseMultipleTable[baseMultipleTable.length - 1].multiple;
      }
      const calculated = m + (yr !== null ? getQAtYear(yr) : totalProjQ);
      if (noFloor) return Math.max(0, calculated);
      return Math.max(getFloor(ebitda), calculated);
    };
    
    // Solve uses exit quality, no floor
    let reqEbitda = targetVal / 5;
    for (let it = 0; it < 20; it++) { const em = estMult(reqEbitda, null, true); if (em <= 0) break; const ne = targetVal / em; if (Math.abs(ne - reqEbitda) < 1000) break; reqEbitda = (reqEbitda + ne) / 2; }
    reqEbitda = Math.round(reqEbitda);
    const projMult = estMult(reqEbitda, null, true); // Exit = no floor, show calculated
    const reqRev = targetMargin > 0 ? Math.round(reqEbitda / (targetMargin / 100)) : 0;
    const revCAGR = (currentRevenue > 0 && reqRev > 0 && timelineYrs > 0) ? (Math.pow(reqRev / currentRevenue, 1 / timelineYrs) - 1) * 100 : 0;
    
    // Year-by-year projections
    const projections = [];
    for (let y = 0; y <= timelineYrs; y++) {
      const p = timelineYrs > 0 ? y / timelineYrs : 0;
      const rev = currentRevenue * Math.pow(reqRev / Math.max(1, currentRevenue), p);
      const margin = currentMargin + (targetMargin - currentMargin) * p;
      const ebitda = rev * (margin / 100);
      const mult = estMult(ebitda, y, y >= timelineYrs); // Exit year = no floor, show earned multiple
      projections.push({ year: y, revenue: Math.round(rev), margin: Math.round(margin * 10) / 10, ebitda: Math.round(ebitda), multiple: Math.round(mult * 100) / 100, valuation: Math.round(ebitda * mult) });
    }
    
    const tiers = (baseMultipleTable || []).filter(t => t.ebitda > currentEbitda && t.ebitda <= reqEbitda * 1.2).slice(-3);
    const trajEnd = currentRevenue * Math.pow(1 + avgGrowth / 100, timelineYrs);
    const trajEbitda = trajEnd * (currentMargin / 100);
    const trajVal = trajEbitda * estMult(trajEbitda, timelineYrs);
    const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    
    // ===== HTML OUTPUT =====
    return `
      <!-- COVER PAGE -->
      <div style="text-align:center;padding:60px 40px;min-height:500px;display:flex;flex-direction:column;justify-content:center;align-items:center;">
        <div style="font-size:11px;color:#6b7280;letter-spacing:3px;text-transform:uppercase;margin-bottom:20px;">Vista Business Group</div>
        <h1 style="font-size:32px;color:#3d5c35;margin:0 0 10px 0;font-weight:800;">Strategic Value Blueprint</h1>
        <div style="width:60px;height:3px;background:#3d5c35;margin:15px auto;"></div>
        <h2 style="font-size:22px;color:#374151;margin:15px 0 5px 0;font-weight:600;">${companyName}</h2>
        <div style="font-size:14px;color:#6b7280;margin:10px 0;">Target Exit Valuation: <strong style="color:#3d5c35;">${fmt(targetVal)}</strong></div>
        <div style="font-size:14px;color:#6b7280;">${timelineYrs}-Year Strategic Plan</div>
        <div style="font-size:12px;color:#9ca3af;margin-top:30px;">Prepared ${today}</div>
        <div style="font-size:10px;color:#9ca3af;margin-top:5px;">CONFIDENTIAL</div>
      </div>
      
      <div class="page-break"></div>
      
      <!-- EXECUTIVE SUMMARY -->
      <h2 style="color:#3d5c35;border-bottom:2px solid #3d5c35;padding-bottom:5px;margin-bottom:15px;">Executive Summary</h2>
      <div style="font-size:11px;line-height:1.6;color:#374151;margin-bottom:15px;">
        <p style="margin-bottom:10px;">${companyName} currently generates ${fmt(currentRevenue)} in annual revenue with ${fmt(currentEbitda)} in normalized EBITDA (${currentMargin.toFixed(1)}% margin), yielding an estimated business value of ${fmt(currentValuation)}. The target is to achieve a ${fmt(targetVal)} exit valuation within ${timelineYrs} years.</p>
        <p style="margin-bottom:10px;">This plan requires growing revenue to ${fmt(reqRev)} while improving EBITDA margins to ${targetMargin}%, producing ${fmt(reqEbitda)} in EBITDA at a projected ${projMult.toFixed(2)}x multiple. The quality improvement roadmap identifies <strong>${fp.filter(f => f.imp > 0.001).length} factors</strong> where strategic improvements will increase the business multiple from a ${totalCurQ.toFixed(2)}x quality adjustment today to ${totalProjQ >= 0 ? '+' : ''}${totalProjQ.toFixed(2)}x at exit.</p>
      </div>
      
      <!-- Requirements Grid -->
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:15px;">
        <div style="background:#f8faf7;border:1px solid #d1d9cf;border-radius:6px;padding:10px;text-align:center;"><div style="font-size:9px;color:#6b7280;">Required EBITDA</div><div style="font-size:16px;font-weight:700;">${fmt(reqEbitda)}</div><div style="font-size:9px;color:#9ca3af;">from ${fmt(currentEbitda)}</div></div>
        <div style="background:#f8faf7;border:1px solid #d1d9cf;border-radius:6px;padding:10px;text-align:center;"><div style="font-size:9px;color:#6b7280;">Required Revenue</div><div style="font-size:16px;font-weight:700;">${fmt(reqRev)}</div><div style="font-size:9px;color:#9ca3af;">from ${fmt(currentRevenue)}</div></div>
        <div style="background:#f8faf7;border:1px solid #d1d9cf;border-radius:6px;padding:10px;text-align:center;"><div style="font-size:9px;color:#6b7280;">Projected Exit Multiple</div><div style="font-size:16px;font-weight:700;">${projMult.toFixed(2)}x</div><div style="font-size:9px;color:#9ca3af;">from ${currentMultiple.toFixed(2)}x</div></div>
        <div style="background:#f8faf7;border:1px solid #d1d9cf;border-radius:6px;padding:10px;text-align:center;"><div style="font-size:9px;color:#6b7280;">Required Revenue CAGR</div><div style="font-size:16px;font-weight:700;">${revCAGR.toFixed(1)}%</div><div style="font-size:9px;color:#9ca3af;">historical: ${avgGrowth.toFixed(1)}%</div></div>
      </div>
      
      ${avgGrowth > 0 ? `
      <div style="background:#fef3c7;border:1px solid #f59e0b;border-radius:6px;padding:12px;margin-bottom:15px;">
        <div style="font-size:11px;font-weight:600;color:#92400e;margin-bottom:6px;">⚠️ Current Trajectory Without This Plan</div>
        <div style="font-size:11px;color:#78350f;">At your historical growth rate of ${avgGrowth.toFixed(1)}% with no margin improvement, you'll reach ${fmt(trajVal)} in ${timelineYrs} years — <strong>${fmt(targetVal - trajVal)} short</strong> of your goal. The gap must come from faster growth, higher margins, or both.</div>
      </div>` : ''}
      
      <div class="page-break"></div>
      
      <!-- QUALITY FACTOR ROADMAP -->
      <h2 style="color:#3d5c35;border-bottom:2px solid #3d5c35;padding-bottom:5px;margin-bottom:10px;">Quality Factor Roadmap</h2>
      <p style="font-size:10px;color:#6b7280;margin-bottom:10px;">Each factor affects your valuation multiple. <span style="background:#dbeafe;padding:1px 4px;border-radius:2px;font-size:9px;">📈 auto</span> = improves with growth. <span style="background:#dcfce7;padding:1px 4px;border-radius:2px;font-size:9px;">🎯 target</span> = requires action.</p>
      
      <table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:15px;">
        <thead><tr style="background:#374151;color:white;">
          <th style="padding:6px 8px;text-align:left;">Factor</th>
          <th style="padding:6px 8px;text-align:right;width:65px;">Current</th>
          <th style="padding:6px 8px;text-align:right;width:65px;">Target</th>
          <th style="padding:6px 8px;text-align:right;width:65px;">Change</th>
          <th style="padding:6px 8px;text-align:center;width:55px;">Timeline</th>
        </tr></thead>
        <tbody>
          ${fp.filter(f => f.cur !== 0 || f.proj !== 0 || f.imp !== 0).map(f => {
            const subRows = (f.subs || []).filter(s => Math.abs(s.proj - s.cur) > 0.001).map(s => `
              <tr style="background:#f8faf7;font-size:10px;">
                <td style="padding:3px 8px 3px 24px;border:1px solid #e5e7eb;">
                  ${s.name} ${s.type === 'auto' ? '<span style="background:#dbeafe;padding:0 3px;border-radius:2px;font-size:8px;">📈 auto</span>' : s.type === 'target' ? '<span style="background:#dcfce7;padding:0 3px;border-radius:2px;font-size:8px;">🎯 target</span>' : ''}
                  ${s.note ? `<span style="color:#9ca3af;margin-left:4px;">${s.note}</span>` : ''}
                </td>
                <td style="padding:3px 8px;border:1px solid #e5e7eb;text-align:right;font-family:monospace;color:${s.cur < 0 ? '#dc2626' : s.cur > 0 ? '#166534' : '#9ca3af'};">${s.cur >= 0 ? '+' : ''}${s.cur.toFixed(2)}</td>
                <td style="padding:3px 8px;border:1px solid #e5e7eb;text-align:right;font-family:monospace;color:${s.proj < 0 ? '#dc2626' : s.proj > 0 ? '#166534' : '#9ca3af'};">${s.proj >= 0 ? '+' : ''}${s.proj.toFixed(2)}</td>
                <td style="padding:3px 8px;border:1px solid #e5e7eb;text-align:right;font-family:monospace;color:#166534;font-weight:600;">+${(s.proj - s.cur).toFixed(2)}</td>
                <td style="padding:3px 8px;border:1px solid #e5e7eb;"></td>
              </tr>`).join('');
            return `
              <tr style="background:${f.imp > 0.001 ? '#f0fdf4' : '#f9fafb'};">
                <td style="padding:6px 8px;border:1px solid #d1d9cf;font-weight:600;">${f.name}</td>
                <td style="padding:6px 8px;border:1px solid #d1d9cf;text-align:right;font-family:monospace;color:${f.cur < 0 ? '#dc2626' : f.cur > 0 ? '#166534' : '#6b7280'};">${f.cur >= 0 ? '+' : ''}${f.cur.toFixed(2)}x</td>
                <td style="padding:6px 8px;border:1px solid #d1d9cf;text-align:right;font-family:monospace;color:${f.proj < 0 ? '#dc2626' : f.proj > 0 ? '#166534' : '#6b7280'};">${f.proj >= 0 ? '+' : ''}${f.proj.toFixed(2)}x</td>
                <td style="padding:6px 8px;border:1px solid #d1d9cf;text-align:right;font-family:monospace;font-weight:700;color:${f.imp > 0.001 ? '#166534' : '#9ca3af'};">${f.imp > 0 ? '+' : ''}${f.imp !== 0 ? f.imp.toFixed(2) + 'x' : '—'}</td>
                <td style="padding:6px 8px;border:1px solid #d1d9cf;text-align:center;font-size:10px;">${f.timeline > 0 ? 'Yr ' + f.timeline : '—'}</td>
              </tr>${subRows}${f.note ? `
              <tr style="background:#fefce8;"><td colspan="5" style="padding:4px 8px 4px 24px;border:1px solid #e5e7eb;font-size:9px;color:#78350f;line-height:1.4;"><em>${f.note}</em></td></tr>` : ''}`;
          }).join('')}
          <tr style="background:#374151;color:white;font-weight:700;">
            <td style="padding:8px;">Total Quality Adjustment</td>
            <td style="padding:8px;text-align:right;font-family:monospace;">${totalCurQ >= 0 ? '+' : ''}${totalCurQ.toFixed(2)}x</td>
            <td style="padding:8px;text-align:right;font-family:monospace;">${totalProjQ >= 0 ? '+' : ''}${totalProjQ.toFixed(2)}x</td>
            <td style="padding:8px;text-align:right;font-family:monospace;">${totalImp > 0 ? '+' : ''}${totalImp.toFixed(2)}x</td>
            <td style="padding:8px;"></td>
          </tr>
        </tbody>
      </table>
      
      <div class="page-break"></div>
      
      <!-- YEAR-BY-YEAR MILESTONES -->
      <h2 style="color:#3d5c35;border-bottom:2px solid #3d5c35;padding-bottom:5px;margin-bottom:15px;">Year-by-Year Milestones — Target Path</h2>
      <table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:15px;">
        <thead><tr style="background:#374151;color:white;">
          <th style="padding:8px;text-align:left;">Year</th>
          <th style="padding:8px;text-align:right;">Revenue</th>
          <th style="padding:8px;text-align:right;">EBITDA Margin</th>
          <th style="padding:8px;text-align:right;">EBITDA</th>
          <th style="padding:8px;text-align:right;">Multiple</th>
          <th style="padding:8px;text-align:right;">Estimated Value</th>
          <th style="padding:8px;text-align:center;">Milestone</th>
        </tr></thead>
        <tbody>
          ${projections.map((p, idx) => {
            const isToday = idx === 0;
            const isExit = idx === projections.length - 1;
            const tierHit = tiers.filter(t => idx > 0 && p.ebitda >= t.ebitda && projections[idx - 1].ebitda < t.ebitda).pop();
            const bg = isToday ? '#f3f4f6' : isExit ? '#f0fdf4' : idx % 2 === 0 ? '#fff' : '#f8faf7';
            const label = isToday ? 'Today' : isExit ? `Year ${p.year} (Exit)` : `Year ${p.year}`;
            const ms = isToday ? 'Starting point' : isExit ? '🎯 Target' : tierHit ? `📈 ${fmt(tierHit.ebitda)} → ${tierHit.multiple.toFixed(1)}x base` : '';
            return `<tr style="background:${bg};${isToday || isExit ? 'font-weight:600;' : ''}">
              <td style="padding:8px;border:1px solid #d1d9cf;">${label}</td>
              <td style="padding:8px;border:1px solid #d1d9cf;text-align:right;">${fmt(p.revenue)}</td>
              <td style="padding:8px;border:1px solid #d1d9cf;text-align:right;">${p.margin.toFixed(1)}%</td>
              <td style="padding:8px;border:1px solid #d1d9cf;text-align:right;">${fmt(p.ebitda)}</td>
              <td style="padding:8px;border:1px solid #d1d9cf;text-align:right;">${p.multiple.toFixed(2)}x</td>
              <td style="padding:8px;border:1px solid #d1d9cf;text-align:right;${isExit ? 'color:#166534;' : ''}">${fmt(p.valuation)}</td>
              <td style="padding:8px;border:1px solid #d1d9cf;text-align:center;font-size:10px;${isExit ? 'color:#166534;font-weight:700;' : tierHit ? 'color:#3d5c35;' : 'color:#9ca3af;'}">${ms}</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
      
      <!-- Key Metrics -->
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:15px;">
        <div style="background:#fff;border:1px solid #d1d9cf;border-radius:6px;padding:12px;">
          <div style="font-size:12px;font-weight:700;margin-bottom:8px;">📈 Revenue Growth Targets</div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Annual growth needed</span><span style="font-weight:600;">${revCAGR.toFixed(1)}%</span></div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">New revenue/year (avg)</span><span style="font-weight:600;">${fmt(timelineYrs > 0 ? (reqRev - currentRevenue) / timelineYrs : 0)}</span></div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Historical growth</span><span style="font-weight:600;color:${avgGrowth >= revCAGR ? '#166534' : '#d97706'};">${avgGrowth.toFixed(1)}%</span></div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Current recurring</span><span style="font-weight:600;">${recurringPctVal.toFixed(0)}%</span></div>
        </div>
        <div style="background:#fff;border:1px solid #d1d9cf;border-radius:6px;padding:12px;">
          <div style="font-size:12px;font-weight:700;margin-bottom:8px;">💰 Margin Targets</div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Current margin</span><span style="font-weight:600;">${currentMargin.toFixed(1)}%</span></div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Target margin</span><span style="font-weight:600;color:#166534;">${targetMargin}%</span></div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Improvement needed</span><span style="font-weight:600;color:#166534;">+${(targetMargin - currentMargin).toFixed(1)} pts</span></div>
          <div style="display:flex;justify-content:space-between;font-size:11px;padding:3px 0;"><span style="color:#6b7280;">Industry benchmark</span><span style="font-weight:600;">${benchmarkMargin}%</span></div>
        </div>
      </div>
      
      <!-- REVIEW SCOREBOARD -->
      <div style="background:linear-gradient(135deg, #3d5c35 0%, #4a6b42 100%);border-radius:8px;padding:16px;color:white;margin-bottom:15px;">
        <div style="font-size:13px;font-weight:700;margin-bottom:4px;">📊 Review Scoreboard — Year 1 Targets</div>
        <div style="font-size:10px;opacity:0.8;margin-bottom:12px;">Track at every 6-month review and 12-month revaluation</div>
        <div style="display:grid;grid-template-columns:repeat(5,1fr);gap:8px;text-align:center;">
          ${['Revenue', 'EBITDA Margin', 'EBITDA', 'Top Client %', 'Recurring %'].map((m, i) => {
            const yr1 = projections[1];
            const vals = yr1 ? [fmt(yr1.revenue), yr1.margin.toFixed(1)+'%', fmt(yr1.ebitda), '<15%', `>${benchRecurring}%`] : ['—','—','—','—','—'];
            return `<div style="background:rgba(255,255,255,0.1);border-radius:6px;padding:8px;"><div style="font-size:9px;opacity:0.7;">${m}</div><div style="font-size:15px;font-weight:700;color:#86efac;">${vals[i]}</div><div style="font-size:8px;opacity:0.5;">Year 1</div></div>`;
          }).join('')}
        </div>
      </div>
      
      <!-- IMPORTANT CONSIDERATIONS -->
      <div style="background:#fffbeb;border:2px solid #f59e0b;border-radius:8px;padding:16px;margin-top:20px;">
        <div style="font-size:13px;font-weight:700;color:#92400e;margin-bottom:10px;">Important Considerations for Planning Your Exit Strategy</div>
        <div style="font-size:11px;color:#78350f;line-height:1.7;">
          <p style="margin-bottom:10px;">The valuation multiples used in this plan reflect current market conditions — but markets don't stand still. Economic shifts, rising or falling interest rates, changes in buyer demand, and industry-specific trends all influence what buyers are willing to pay. These forces can move gradually over years or shift quickly in response to economic events.</p>
          <p style="margin-bottom:10px;"><strong>What this means for your plan:</strong> The strategic improvements outlined here — growing revenue, improving margins, reducing concentration, strengthening contracts, and building a management team — will make your business stronger and more valuable regardless of market conditions. A well-run, growing business with diversified revenue always commands a premium. However, the specific multiple a buyer offers at exit will depend on the market environment at that time, not today's conditions.</p>
          <p style="margin-bottom:10px;">In the current economic environment, there is meaningful risk that acquisition multiples could compress over the next 5-10 years due to higher interest rates, tighter lending conditions, or shifts in buyer appetite. This makes it even more important to focus on the factors within your control — the quality improvements in this plan — because a business with strong fundamentals will always find buyers, even in a down market.</p>
          <p style="margin-bottom:0;"><strong>Our recommendation:</strong> Revisit this plan every 6-12 months to update projections based on your actual performance and evolving market conditions. The roadmap is the strategy; the numbers will be refined along the way.</p>
        </div>
      </div>
    `;
  };

  // ========== PRO FORMA REPORT ==========
  const generateProFormaReportHTML = (data) => {
    const fmt = (n) => '$' + (n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 });
    const fmtPct = (n) => (n || 0).toFixed(1) + '%';
    
    const items = proFormaCalcs.items || [];
    const hasItems = items.filter(i => i.name).length > 0;
    
    return `
      <div class="section" style="page-break-before: always;">
        <div style="text-align:center;margin-bottom:30px;">
          <h1 style="color:#166534;margin-bottom:5px;">Pro Forma Financial Summary</h1>
          <div style="font-size:14px;color:#666;">${data.company.name} • Combined Entity Analysis</div>
          <div style="font-size:12px;color:#888;">TTM Period: ${proFormaCalcs.ttmPeriod?.label || 'N/A'}</div>
        </div>
        
        <div style="display:flex;gap:20px;margin-bottom:30px;">
          <div style="flex:1;background:linear-gradient(135deg,#f0fdf4,#dcfce7);border:2px solid #86efac;border-radius:10px;padding:20px;text-align:center;">
            <div style="font-size:12px;color:#166534;text-transform:uppercase;letter-spacing:1px;">Pro Forma TTM Revenue</div>
            <div style="font-size:28px;font-weight:bold;color:#166534;margin:10px 0;">${fmt(proFormaCalcs.proFormaTTMRevenue)}</div>
            <div style="font-size:11px;color:#15803d;">
              Historical: ${fmt(proFormaCalcs.historicalTTMRevenue)} 
              <span style="color:#22c55e;">+${fmt(proFormaCalcs.totalProratedRevenue)}</span>
            </div>
          </div>
          <div style="flex:1;background:linear-gradient(135deg,#f0fdf4,#dcfce7);border:2px solid #86efac;border-radius:10px;padding:20px;text-align:center;">
            <div style="font-size:12px;color:#166534;text-transform:uppercase;letter-spacing:1px;">Pro Forma TTM EBITDA</div>
            <div style="font-size:28px;font-weight:bold;color:#166534;margin:10px 0;">${fmt(proFormaCalcs.proFormaTTMEbitda)}</div>
            <div style="font-size:11px;color:#15803d;">
              Historical: ${fmt(proFormaCalcs.historicalTTMEbitda)} 
              <span style="color:#22c55e;">+${fmt(proFormaCalcs.totalProratedEbitda)}</span>
            </div>
          </div>
        </div>
        
        <h2 style="color:#374151;border-bottom:2px solid #e5e7eb;padding-bottom:5px;margin-bottom:15px;">Pro Forma Adjustments</h2>
        <table style="width:100%;border-collapse:collapse;margin-bottom:30px;font-size:11px;">
          <thead>
            <tr style="background:#f3f4f6;">
              <th style="border:1px solid #d1d5db;padding:8px;text-align:left;">Description</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:center;">Type</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:center;">Effective Date</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:right;">Annual Revenue</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:right;">Annual EBITDA</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:center;">Retention</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:center;">Months in TTM</th>
              <th style="border:1px solid #d1d5db;padding:8px;text-align:right;background:#dcfce7;">TTM Contribution</th>
            </tr>
          </thead>
          <tbody>
            ${items.filter(i => i.name).map((item, idx) => `
              <tr style="background:${idx % 2 === 0 ? '#fff' : '#f9fafb'};">
                <td style="border:1px solid #d1d5db;padding:8px;font-weight:500;">${item.name}</td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:center;">
                  <span style="padding:2px 8px;border-radius:10px;font-size:10px;${
                    item.type === 'acquisition' ? 'background:#f3e8ff;color:#7e22ce;' :
                    item.type === 'newclient' ? 'background:#dbeafe;color:#1d4ed8;' :
                    'background:#f3f4f6;color:#4b5563;'
                  }">
                    ${item.type === 'acquisition' ? 'Acquisition' : item.type === 'newclient' ? 'New Client' : item.type === 'lostclient' ? 'Lost Client' : item.type === 'pricechange' ? 'Price Change' : 'Other'}
                  </span>
                </td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:center;">${item.effectiveDate ? new Date(item.effectiveDate).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '—'}</td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:right;">${fmt(item.annualRevenue || 0)}</td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:right;">${fmt(item.annualEbitdaCalc || 0)}</td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:center;">${item.retentionPct}%</td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:center;">${item.monthsInTTM} mo</td>
                <td style="border:1px solid #d1d5db;padding:8px;text-align:right;background:#dcfce7;color:#166534;font-weight:600;">+${fmt(item.adjustedEbitda || 0)}</td>
              </tr>
            `).join('')}
          </tbody>
          <tfoot>
            <tr style="background:#e5e7eb;font-weight:bold;">
              <td colspan="7" style="border:1px solid #d1d5db;padding:8px;text-align:right;">Total Pro Forma EBITDA Additions</td>
              <td style="border:1px solid #d1d5db;padding:8px;text-align:right;background:#bbf7d0;color:#166534;">+${fmt(proFormaCalcs.totalProratedEbitda)}</td>
            </tr>
          </tfoot>
        </table>
        
        <h2 style="color:#374151;border-bottom:2px solid #e5e7eb;padding-bottom:5px;margin-bottom:15px;">Valuation Comparison</h2>
        <table style="width:100%;border-collapse:collapse;margin-bottom:20px;font-size:11px;">
          <thead>
            <tr style="background:#f3f4f6;">
              <th style="border:1px solid #d1d5db;padding:10px;text-align:left;">Basis</th>
              <th style="border:1px solid #d1d5db;padding:10px;text-align:right;">EBITDA</th>
              <th style="border:1px solid #d1d5db;padding:10px;text-align:right;">Change vs Historical</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border:1px solid #d1d5db;padding:10px;font-weight:500;">Historical TTM</td>
              <td style="border:1px solid #d1d5db;padding:10px;text-align:right;">${fmt(proFormaCalcs.historicalTTMEbitda)}</td>
              <td style="border:1px solid #d1d5db;padding:10px;text-align:right;color:#6b7280;">—</td>
            </tr>
            <tr style="background:#f0fdf4;">
              <td style="border:1px solid #d1d5db;padding:10px;font-weight:600;color:#166534;">Pro Forma TTM</td>
              <td style="border:1px solid #d1d5db;padding:10px;text-align:right;font-weight:600;color:#166534;">${fmt(proFormaCalcs.proFormaTTMEbitda)}</td>
              <td style="border:1px solid #d1d5db;padding:10px;text-align:right;font-weight:600;color:${proFormaCalcs.proFormaTTMEbitda >= proFormaCalcs.historicalTTMEbitda ? '#166534' : '#dc2626'};">${proFormaCalcs.proFormaTTMEbitda >= proFormaCalcs.historicalTTMEbitda ? '+' : ''}${fmt(proFormaCalcs.proFormaTTMEbitda - proFormaCalcs.historicalTTMEbitda)}</td>
            </tr>
            <tr style="background:#eff6ff;">
              <td style="border:1px solid #d1d5db;padding:10px;font-weight:500;color:#1d4ed8;">Run-Rate (Full Year)</td>
              <td style="border:1px solid #d1d5db;padding:10px;text-align:right;color:#1d4ed8;">${fmt(proFormaCalcs.proFormaRunRateEbitda)}</td>
              <td style="border:1px solid #d1d5db;padding:10px;text-align:right;color:${proFormaCalcs.proFormaRunRateEbitda >= proFormaCalcs.historicalTTMEbitda ? '#1d4ed8' : '#dc2626'};">${proFormaCalcs.proFormaRunRateEbitda >= proFormaCalcs.historicalTTMEbitda ? '+' : ''}${fmt(proFormaCalcs.proFormaRunRateEbitda - proFormaCalcs.historicalTTMEbitda)}</td>
            </tr>
          </tbody>
        </table>
        
        <div style="background:#fef3c7;border:1px solid #fcd34d;border-radius:5px;padding:15px;margin-bottom:20px;">
          <div style="font-weight:600;color:#92400e;margin-bottom:5px;">⚠️ Important Considerations</div>
          <ul style="font-size:11px;color:#78350f;margin:0;padding-left:20px;">
            <li>Pro forma valuations include projected, unproven revenue from recent additions</li>
            <li>Buyers may apply a discount to the multiple for pro forma adjustments</li>
            <li>Historical basis remains the most defensible valuation for financing purposes</li>
            <li>Retention adjustments applied based on industry averages (acquisitions: 85%, new clients: 90%)</li>
          </ul>
        </div>
        
        <div style="background:#f3f4f6;border:1px solid #d1d5db;border-radius:5px;padding:15px;">
          <div style="font-weight:600;color:#374151;margin-bottom:5px;">📋 Assumptions & Notes</div>
          <ul style="font-size:10px;color:#4b5563;margin:0;padding-left:20px;">
            <li>TTM Period: ${proFormaCalcs.ttmPeriod?.label}</li>
            <li>Pro forma additions are prorated based on effective date within TTM period</li>
            <li>EBITDA contributions calculated using stated margin or direct EBITDA input</li>
            ${items.filter(i => i.notes).map(item => `<li>${item.name}: ${item.notes}</li>`).join('')}
          </ul>
        </div>
      </div>
    `;
  };

  // ========== OWNER QUESTIONS REPORT ==========
  const generateOwnerQuestionsHTML = (data) => {
    const { researchItems: research, sellerQA: qa } = data;
    const fmt = (n) => '$' + (n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 });
    
    // Get all items marked as "Ask Owner" that are still open
    const ownerQuestions = (research || []).filter(item => item.askOwner && item.status !== 'complete');
    
    // Get unanswered discovery questions - must be pending AND have no answer
    const unansweredDiscovery = (qa || []).filter(q => q.status === 'pending');
    
    // Group research items by source/section
    const groupedBySource = {};
    ownerQuestions.forEach(item => {
      const source = item.source || 'General';
      if (!groupedBySource[source]) groupedBySource[source] = [];
      groupedBySource[source].push(item);
    });
    
    // Group discovery questions by section
    const groupedDiscovery = {};
    unansweredDiscovery.forEach(q => {
      const section = q.section || 'general';
      const sectionLabel = {
        'ownership': 'Ownership & Structure',
        'operations': 'Operations',
        'customers': 'Customers & Sales',
        'financial': 'Financial',
        'legal': 'Legal & Compliance',
        'transition': 'Transition Planning',
        'general': 'General'
      }[section] || section;
      if (!groupedDiscovery[sectionLabel]) groupedDiscovery[sectionLabel] = [];
      groupedDiscovery[sectionLabel].push(q);
    });
    
    const hasQuestions = ownerQuestions.length > 0 || unansweredDiscovery.length > 0;
    const totalQuestions = ownerQuestions.length + unansweredDiscovery.length;
    
    let questionNumber = 1;
    
    return `
      <h2>📧 Outstanding Questions for Business Owner</h2>
      <p style="color:#4b5563;margin-bottom:20px;font-size:12px;">
        The following questions have been identified during our analysis and require your input. 
        Please provide detailed responses to help us complete your valuation accurately.
      </p>
      
      ${!hasQuestions ? `
        <div style="background:#dcfce7;border:2px solid #86efac;border-radius:8px;padding:20px;text-align:center;">
          <div style="font-size:36px;margin-bottom:10px;">✅</div>
          <div style="font-size:16px;font-weight:700;color:#166534;margin-bottom:8px;">No Outstanding Questions</div>
          <p style="color:#15803d;margin:0;">All questions have been answered. The analysis is complete.</p>
        </div>
      ` : `
      
      <!-- Summary Header -->
      <div style="background:linear-gradient(135deg, #ea580c 0%, #f97316 100%);border-radius:12px;padding:20px;margin-bottom:25px;color:white;">
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <div>
            <div style="font-size:24px;font-weight:700;">${totalQuestions} Questions</div>
            <div style="font-size:12px;opacity:0.9;">Requiring your response</div>
          </div>
          <div style="text-align:right;">
            <div style="font-size:12px;opacity:0.8;">From Analysis: ${ownerQuestions.length}</div>
            <div style="font-size:12px;opacity:0.8;">Discovery Questions: ${unansweredDiscovery.length}</div>
          </div>
        </div>
      </div>
      
      <!-- Analysis Questions by Section -->
      ${ownerQuestions.length > 0 ? `
        <h3 style="color:#ea580c;margin-bottom:15px;border-bottom:2px solid #fed7aa;padding-bottom:8px;">
          📋 Questions from Financial Analysis
        </h3>
        
        ${Object.entries(groupedBySource).map(([source, items]) => `
          <div style="margin-bottom:20px;">
            <div style="background:#fff7ed;padding:8px 12px;border-radius:6px 6px 0 0;border:1px solid #fed7aa;border-bottom:none;">
              <span style="font-weight:600;color:#c2410c;">📍 ${source}</span>
            </div>
            <div style="border:1px solid #fed7aa;border-radius:0 0 6px 6px;">
              ${items.map(item => `
                <div style="padding:15px;border-bottom:1px solid #fed7aa;">
                  <div style="display:flex;gap:12px;">
                    <div style="background:#ea580c;color:white;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;flex-shrink:0;">
                      ${questionNumber++}
                    </div>
                    <div style="flex:1;">
                      <div style="font-weight:600;color:#1f2937;margin-bottom:6px;">${item.item}</div>
                      ${item.notes ? `<div style="font-size:11px;color:#6b7280;font-style:italic;">Context: ${item.notes}</div>` : ''}
                      <div style="margin-top:10px;padding-top:10px;border-top:1px dashed #e5e7eb;">
                        <div style="font-size:10px;color:#9ca3af;margin-bottom:4px;">YOUR RESPONSE:</div>
                        <div style="min-height:50px;border:1px solid #d1d5db;border-radius:4px;background:#f9fafb;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              `).join('')}
            </div>
          </div>
        `).join('')}
      ` : ''}
      
      <!-- Discovery Questions -->
      ${unansweredDiscovery.length > 0 ? `
        <h3 style="color:#1d4ed8;margin-bottom:15px;border-bottom:2px solid #bfdbfe;padding-bottom:8px;margin-top:30px;">
          📝 Discovery Questions
        </h3>
        
        ${Object.entries(groupedDiscovery).map(([section, questions]) => `
          <div style="margin-bottom:20px;">
            <div style="background:#eff6ff;padding:8px 12px;border-radius:6px 6px 0 0;border:1px solid #bfdbfe;border-bottom:none;">
              <span style="font-weight:600;color:#1e40af;">📁 ${section}</span>
            </div>
            <div style="border:1px solid #bfdbfe;border-radius:0 0 6px 6px;">
              ${questions.map(q => `
                <div style="padding:15px;border-bottom:1px solid #bfdbfe;">
                  <div style="display:flex;gap:12px;">
                    <div style="background:#1d4ed8;color:white;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;flex-shrink:0;">
                      ${questionNumber++}
                    </div>
                    <div style="flex:1;">
                      <div style="font-weight:600;color:#1f2937;margin-bottom:6px;">${q.question}</div>
                      ${q.selectOptions ? `<div style="font-size:11px;color:#1d4ed8;margin-bottom:6px;"><strong>Please select one:</strong> ${q.selectOptions.map(opt => opt.label).join('  |  ')}</div>` : ''}
                      ${q.notes ? `<div style="font-size:11px;color:#6b7280;font-style:italic;">Why we're asking: ${q.notes}</div>` : ''}
                      <div style="margin-top:10px;padding-top:10px;border-top:1px dashed #e5e7eb;">
                        <div style="font-size:10px;color:#9ca3af;margin-bottom:4px;">YOUR RESPONSE:</div>
                        <div style="min-height:50px;border:1px solid #d1d5db;border-radius:4px;background:#f9fafb;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              `).join('')}
            </div>
          </div>
        `).join('')}
      ` : ''}
      
      <!-- Response Instructions -->
      <div style="background:#f3f4f6;border:1px solid #d1d5db;border-radius:8px;padding:15px;margin-top:25px;">
        <h4 style="margin:0 0 10px 0;color:#374151;font-size:12px;">📌 Response Instructions</h4>
        <ul style="margin:0;padding-left:20px;font-size:11px;color:#4b5563;">
          <li style="margin-bottom:5px;">Please provide detailed responses - more context helps us provide an accurate valuation</li>
          <li style="margin-bottom:5px;">If you need to reference documents, please indicate which documents support your response</li>
          <li style="margin-bottom:5px;">For numerical questions, please be as precise as possible</li>
          <li>If a question doesn't apply, please explain why rather than leaving it blank</li>
        </ul>
      </div>
      
      <!-- Contact -->
      <div style="text-align:center;margin-top:25px;padding-top:20px;border-top:1px solid #e5e7eb;">
        <p style="font-size:11px;color:#6b7280;margin:0;">
          Questions about these items? Contact us to discuss.
        </p>
        <p style="font-size:12px;font-weight:600;color:#1e3a8a;margin:5px 0 0 0;">
          Vista Business Group
        </p>
      </div>
      `}
    `;
  };

  // ========== MAIN EXPORT FUNCTION ==========
  const exportReports = () => {
    const data = getExportData();
    const companyName = data.company.name.replace(/[^a-zA-Z0-9]/g, '_');
    
    let htmlContent = `<!DOCTYPE html>
<html>
<head>
  <title>Valuation Report - ${data.company.name}</title>
  <style>${generateReportStyles()}</style>
</head>
<body>
  <div class="no-print" style="text-align:center;margin-bottom:20px;padding:15px;background:#f8fafc;border-radius:8px;">
    <button class="print-btn" onclick="window.print()" style="padding:10px 25px;font-size:14px;background:#3d5c35;color:white;border:none;border-radius:6px;cursor:pointer;">🖨️ Print / Save as PDF</button>
    <p style="font-size:11px;color:#666;margin-top:10px;">Click above or use Ctrl+P (Cmd+P on Mac) to print or save as PDF</p>
    <p style="font-size:10px;color:#999;margin-top:5px;"><strong>Tip:</strong> In your print dialog, disable "Headers and footers" to remove the URL and date from pages</p>
  </div>
  
  <div style="text-align:center;margin-bottom:30px;padding-bottom:20px;border-bottom:3px solid #3d5c35;">
    <h1 style="font-size:28px;color:#3d5c35;margin:0 0 8px 0;font-weight:700;">${data.company.name}</h1>
    <div style="font-size:14px;color:#4a6b42;font-weight:500;margin-bottom:8px;">CONFIDENTIAL VALUATION REPORT</div>
    <div style="font-size:11px;color:#6b7280;">Financial Data Through ${data.company.preparedDate}</div>
  </div>
`;
    
    let fileName = companyName;
    const sections = [];
    
    if (exportOptions.presentationPackage) {
      htmlContent += generateFinancialSummaryHTML(data);
      htmlContent += generateValuationDriversHTML(data);
      htmlContent += generateValuationResultHTML(data);
      sections.push('Presentation');
    }
    
    if (exportOptions.valueEnhancement) {
      if (sections.length > 0) htmlContent += '<div class="page-break"></div>';
      htmlContent += generateValueEnhancementHTML(data);
      sections.push('Enhancement');
    }
    
    if (exportOptions.blueprintReport) {
      if (sections.length > 0) htmlContent += '<div class="page-break"></div>';
      htmlContent += generateBlueprintHTML(data);
      sections.push('Blueprint');
    }
    
    if (exportOptions.analysisPackage) {
      if (sections.length > 0) htmlContent += '<div class="page-break"></div>';
      htmlContent += `
        <h2>📊 Detailed Analysis</h2>
        <p style="color:#666;">Income Statement views and detailed analysis available in the tool's Analysis tab.</p>
        <p style="font-style:italic;color:#999;">Full analysis export coming soon.</p>
      `;
      sections.push('Analysis');
    }
    
    if (exportOptions.sbaReport) {
      // 🏦 Financing check (Colleen 10-20): can the business carry the purchase (and the real estate, when it sells too)?
      const a = sbaAnalysis, pf = (n) => '$' + Math.round(n || 0).toLocaleString('en-US');   // own formatter: exportReports has no fmt
      const row = (l, v, b) => '<tr' + (b ? ' style="font-weight:700;background:#e8ede6;"' : '') + '><td style="padding:5px 8px;">' + l + '</td><td style="padding:5px 8px;text-align:right;">' + v + '</td></tr>';
      if (sections.length > 0) htmlContent += '<div class="page-break"></div>';
      htmlContent += '<div class="section"><h2>🏦 Financing Check: can the business carry the purchase?</h2>' +
        '<p style="font-size:11px;color:#4b5563;">How a buyer would typically finance this purchase' + (a.reOn ? ', including the real estate,' : '') + ' and whether the business\'s cash flow covers the payments. Lenders look for at least 1.25× coverage.</p>' +
        '<table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:12px;">' +
        row('Business value (high)', pf(a.dealValue)) +
        (a.reOn ? row('+ Real estate at market value', pf(a.reValue)) + row('= Package price', pf(a.packageValue), true) : '') +
        row('Buyer down payment (' + sbaParams.downPaymentPct + '%)', pf(a.downPayment)) +
        row('Seller note (' + sbaParams.sellerNotePct + '%)', pf(a.sellerNote)) +
        row('SBA business loan', pf(a.sbaLoan)) +
        (a.reOn ? row('Real estate down payment (' + (sbaParams.reDownPct ?? 10) + '%)', pf(a.reDown)) + row('Real estate loan', pf(a.reLoan)) : '') +
        '</table><table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:12px;">' +
        row('SBA business loan, ' + sbaParams.sbaLoanRate + '% over ' + sbaParams.sbaLoanTerm + ' yrs', pf(a.sbaLoanPayment) + '/yr') +
        row('Seller note, ' + sbaParams.sellerNoteRate + '% over ' + sbaParams.sellerNoteTerm + ' yrs', pf(a.sellerNotePayment) + '/yr') +
        (a.reOn ? row('Real estate loan, ' + (sbaParams.reRate ?? 7) + '% over ' + (sbaParams.reTerm ?? 25) + ' yrs', pf(a.reLoanPayment) + '/yr') : '') +
        row('Total annual payments', pf(a.totalPayments), true) +
        '</table><table style="width:100%;border-collapse:collapse;font-size:11px;">' +
        row(a.maintCapex > 0 ? 'Normalized EBITDA after capex (free cash flow)' : 'Normalized EBITDA', pf(a.adjustedEbitda)) +
        (a.reRentBack > 0 ? row('+ Rent no longer paid (the buyer owns the real estate)', pf(a.reRentBack)) : '') +
        row('= Cash available for debt service', pf(a.cashAvailable), true) +
        row('− Total annual payments', '(' + pf(a.totalPayments) + ')') +
        row('Coverage (TDCR)', (a.tdcr ? a.tdcr.toFixed(2) + '×' : 'n/a') + (a.tdcr >= 1.25 ? ' ✓ meets the 1.25× lender requirement' : a.tdcr >= 1 ? ' marginal' : ' below requirement'), true) +
        '</table></div>';
      sections.push('Financing');
    }
    if (exportOptions.proFormaReport && proFormaCalcs.hasProFormaData) {
      if (sections.length > 0) htmlContent += '<div class="page-break"></div>';
      htmlContent += generateProFormaReportHTML(data);
      sections.push('ProForma');
    }
    
    // Costs outside our fee (Zac 09-25) — on the report so the owner hears
    // them here as well as on the valuation call and in the Selling Guide.
    htmlContent += `
  <div class="section">
    <h2>💵 Costs to plan for at a sale</h2>
    <p><strong>Your attorney:</strong> plan on 0.5%–1.5% of enterprise value for deal counsel — the purchase agreement, disclosure schedules and the closing.</p>
    <p><strong>A "tail" insurance policy:</strong> depending on the industry, buyers ask the seller to carry an extended-reporting policy on professional or product liability after closing, typically one to three years. Ask your broker what a sufficient policy costs for your industry before going to market.</p>
  </div>
  <div class="footer">
    <span>Confidential</span>
    <span>${data.company.name}</span>
    <span>${data.company.preparedDate}</span>
  </div>
</body>
</html>`;
    
    fileName += '_' + sections.join('_');
    
    // Download
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    setShowExportModal(false);
  };

  const toggleSection = (section, event) => {
    // Prevent scroll jump when toggling sections
    if (event) {
      const clickedElement = event.currentTarget;
      const scrollY = window.scrollY;
      
      setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
      
      // Restore scroll position after React re-render
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    } else {
      setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    }
  };
  const updateStreamStatus = (id, status) => setRevenueStreams(revenueStreams.map(s => s.id === id ? { 
    ...s, 
    status,
    confirmedAt: status === 'confirmed' ? new Date().toLocaleDateString() : s.confirmedAt
  } : s));

  // ========== FACTOR SECTION COMPONENT ==========
  // Held behind a stable wrapper so its component identity does not change between
  // renders. Without this, React saw a new function reference on every render and
  // unmounted the entire subtree — which erased any uncontrolled input (e.g.
  // "Reason for override" notes) whenever an ambient timer fired mid-typing.
  const factorSectionImplRef = useRef(null);
  factorSectionImplRef.current = ({ factorKey, factor, children, hasSubFactors = false }) => {
    const isExpanded = expandedSections[factorKey];
    if (!factor) return null;
    const adjustmentColor = factor.adjustment > 0 ? 'text-green-600' : factor.adjustment < 0 ? 'text-red-600' : 'text-gray-600';
    const hasFlags = hasSubFactors && factor.subFactors && Object.values(factor.subFactors).some(sf => sf.flag && !sf.reviewed);
    const hasSalesTabData = hasSubFactors && factor.subFactors && Object.values(factor.subFactors).some(sf => sf.fromSalesTab || sf.source === 'sales');
    const hasDiscoveryData = hasSubFactors && factor.subFactors && Object.values(factor.subFactors).some(sf => sf.source === 'discovery');
    
    // Get source color/styling
    const getSourceStyle = (source) => {
      if (source === 'sales') return { bg: 'bg-blue-50 border-blue-200', badge: 'bg-blue-200 text-blue-700', label: '📊' };
      if (source === 'discovery') return { bg: 'bg-amber-50 border-amber-200', badge: 'bg-amber-200 text-amber-700', label: '❓' };
      return { bg: 'bg-gray-50', badge: '', label: '' };
    };
    
    return (
      <div className="border rounded-lg mb-2 overflow-hidden">
        <button type="button" onClick={(e) => toggleSection(factorKey, e)} className="w-full p-3 bg-gray-50 hover:bg-gray-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="font-semibold">{factor.name}</span>
            {hasFlags && <AlertTriangle className="w-4 h-4 text-orange-500" />}
            {hasSalesTabData && <span className="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded">📊 Sales</span>}
            {hasDiscoveryData && !hasSalesTabData && <span className="text-xs px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded">❓ Discovery</span>}
          </div>
          <div className="flex items-center gap-3">
            <span className={`font-bold ${adjustmentColor}`}>{factor.adjustment >= 0 ? '+' : ''}{factor.adjustment.toFixed(2)}x</span>
            {isExpanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
          </div>
        </button>
        {isExpanded && (
          <div className="p-4 border-t bg-white">
            {hasSubFactors && factor.subFactors ? (
              <div className="space-y-3">
                {Object.entries(factor.subFactors).map(([key, sf]) => {
                  const style = getSourceStyle(sf.source);
                  return (
                  <div key={key} className={`p-3 rounded border ${sf.flag && !sf.reviewed ? 'bg-amber-50 border-amber-300' : sf.source ? style.bg : sf.fromSalesTab ? 'bg-blue-50 border-blue-200' : 'bg-gray-50'}`}>
                    <div className="flex justify-between items-start mb-1">
                      <div className="flex items-center gap-2">
                        <span className="font-medium text-sm">{sf.name}</span>
                        {sf.flag && !sf.reviewed && <AlertTriangle className="w-4 h-4 text-orange-500" />}
                        {sf.sourceLabel && <span className={`text-xs px-1 py-0.5 rounded ${style.badge}`}>{sf.sourceLabel}</span>}
                        {!sf.sourceLabel && sf.fromSalesTab && <span className="text-xs px-1 py-0.5 bg-blue-200 text-blue-700 rounded">📊 Sales</span>}
                      </div>
                      <span className={`font-bold text-sm ${sf.score > 0 ? 'text-green-600' : sf.score < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                        {sf.score >= 0 ? '+' : ''}{sf.score.toFixed(2)}x
                      </span>
                    </div>
                    <div className="text-xs text-gray-600">{sf.calculation}</div>
                    {sf.details && (
                      <div className="text-xs text-gray-500 mt-1">
                        {typeof sf.details === 'object' && !Array.isArray(sf.details) ? 
                          Object.entries(sf.details).filter(([k, v]) => v !== null && v !== undefined).map(([k, v]) => <span key={k} className="mr-3">{k}: {typeof v === 'number' ? formatPercent(v) : v}</span>) :
                          Array.isArray(sf.details) ? sf.details.filter(d => d !== null && d !== undefined).map((d, i) => <span key={i} className="mr-2">{typeof d === 'number' ? formatPercent(d) : d}</span>) : null}
                      </div>
                    )}
                    {sf.flag && <div className="mt-2 p-2 bg-amber-100 rounded text-xs"><div className="font-medium text-amber-800">{sf.flagReason}</div></div>}
                  </div>
                );})}
              </div>
            ) : (
              <div className="text-sm text-gray-600 mb-3"><strong>Calculation:</strong> {factor.calculation}</div>
            )}
            {factor.taggedAdjustments && factor.taggedAdjustments.length > 0 && (
              <div className="mt-3 p-2 bg-teal-50 border border-teal-200 rounded text-xs text-teal-900">
                <div className="font-semibold mb-1">Manual adjustments related to this factor — applied under Other Adjustments, not part of the auto-score above:</div>
                {factor.taggedAdjustments.map((a, i) => (
                  <div key={i}>· {(Number(a.adjustment) || 0) >= 0 ? '+' : ''}{(Number(a.adjustment) || 0).toFixed(2)}x — {a.description || 'Unnamed'}{a.notes ? ` (${a.notes})` : ''}</div>
                ))}
              </div>
            )}
            {factor.notes && <div className="text-sm text-gray-500 mt-2"><strong>Notes:</strong> {factor.notes}</div>}
            {children}
          </div>
        )}
      </div>
    );
  };
  const FactorSection = useMemo(() => (props) => factorSectionImplRef.current(props), []);

  return (
    <div className="w-full max-w-7xl mx-auto p-4 bg-gray-50">
      {isReadOnlyViewer && (
        <div className="mb-3 px-4 py-2.5 rounded-lg border border-indigo-300 bg-indigo-50 flex items-center gap-2 text-sm text-indigo-900 flex-wrap">
          <span className="text-base">👁</span>
          <span className="flex-1 min-w-[280px]"><span className="font-semibold">Read-only view.</span> As an Account Manager you can open and review any valuation, but edits here are not saved. To put a note on the record, use <span className="font-semibold">🗒 Notes</span> (right here) — it saves to the deal's permanent activity log. Follow-ups and outreach live on your <span className="font-semibold">My Work</span> tab.</span>
          {currentValuationId && (
            <CardToolbar valuationId={currentValuationId} companyName={(dealProfile && dealProfile.companyName) || valuationName || 'this deal'} actor={viewerStaffName} />
          )}
        </div>
      )}
      {cloudSaveError && (
        <div className="mb-3 px-4 py-3 rounded-lg border-2 border-red-500 bg-red-50 flex items-start gap-3">
          <AlertTriangle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0 text-sm">
            <div className="font-bold text-red-900">Auto-save is failing — your recent work may not be in the cloud yet.</div>
            <div className="text-red-800 mt-0.5 break-words">{cloudSaveError}</div>
            <div className="text-red-700 text-xs mt-1">
              {lastAutoSave
                ? <>Last successful save: <strong>{lastAutoSave.toLocaleString()}</strong>. A local backup of your edits is being kept and will be offered for restore the next time you open this file.</>
                : <>No successful save yet this session. A local backup of your edits is being kept.</>}
            </div>
          </div>
          <div className="flex flex-col items-end gap-1 flex-shrink-0">
            <button
              onClick={() => saveDeal()}
              className="px-3 py-1 bg-red-600 text-white rounded text-xs font-semibold hover:bg-red-700"
              title="Retry saving to the cloud now"
            >
              Save Now
            </button>
            <button
              onClick={() => setCloudSaveError('')}
              className="text-xs text-red-700 hover:text-red-900 underline"
              title="Dismiss (will reappear if the next save attempt fails)"
            >
              Dismiss
            </button>
          </div>
        </div>
      )}
      {otherViewers.length > 0 && (
        <div className="mb-3 px-4 py-3 rounded-lg border border-amber-300 bg-amber-50 flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-amber-900">
            <span className="font-semibold">
              {otherViewers.map(v => formatViewerName(v.user_email)).join(', ')}
              {otherViewers.length === 1 ? ' is' : ' are'} also in this file.
            </span>{' '}
            Coordinate before editing — only one person should make changes at a time. If someone
            else saves first, your save will be blocked to prevent overwriting their work.
          </div>
        </div>
      )}
      {saveConflict && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <div className="flex items-start gap-3 mb-4">
              <AlertTriangle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
              <div>
                <h2 className="text-lg font-bold text-gray-800 mb-1">Save blocked — file changed</h2>
                <p className="text-sm text-gray-700">
                  This file changed in the cloud while you had it open. To prevent
                  overwriting that work, your save was not applied.
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  "Changed" can mean a teammate — but also the <strong>owner acting in their
                  portal</strong> (marking uploads done, answering questions, picking dates) or this
                  same file open in a second tab.
                </p>
                <p className="text-sm text-gray-700 mt-2">
                  Reload the file to see the current version. <strong>Any unsaved changes you've
                  made here will be lost.</strong>
                </p>
              </div>
            </div>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setSaveConflict(false)}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
              >
                Keep editing (cannot save)
              </button>
              <button
                onClick={() => { setSaveConflict(false); if (currentValuation && currentValuation.id) window.location.replace('/?valuation=' + encodeURIComponent(currentValuation.id) + '&view=' + encodeURIComponent(viewMode)); else window.location.reload(); }}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-red-600 text-white hover:bg-red-700"
              >
                Reload file
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── Revalue: Start Revalue modal ── */}
      {pendingEmail && (
        <EmailReviewModal {...pendingEmail} onClose={() => setPendingEmail(null)} />
      )}
      {showRevalueModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Start Revalue</h2>
            {/* Now vs. later (Mark 09-16): starting archives + reopens the whole
                cycle and moves it into the upload pipeline immediately. If the
                owner isn't ready yet, schedule it instead — a reminder, no
                changes to the deal. */}
            <div className="flex gap-2 mb-3">
              <button type="button" onClick={() => setRevalueMode('now')}
                className={`flex-1 px-3 py-2 rounded text-sm font-semibold border ${revalueMode === 'now' ? 'bg-amber-600 text-white border-amber-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>
                ▶ Start now
              </button>
              <button type="button" onClick={() => setRevalueMode('later')}
                className={`flex-1 px-3 py-2 rounded text-sm font-semibold border ${revalueMode === 'later' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>
                🗓 Schedule for later
              </button>
            </div>
            {revalueMode === 'now' ? (
              <React.Fragment>
                <p className="text-sm text-gray-600 mb-3">
                  This archives the current valuation of <strong>{dealProfile.companyName || 'this business'}</strong> and
                  resets the project for a new valuation cycle — documents, adjustments, and Seller Q&amp;A are cleared —
                  and moves it into the document-collection flow now. The current valuation is saved to the revision archive and stays recoverable.
                </p>
                {dealProfile.vistaId ? (
                  <div className="mb-3 px-3 py-2 rounded border border-sky-200 bg-sky-50 text-xs text-sky-900">
                    📎 <strong>ShareFile:</strong> make sure this client's Data Room folder name includes the Vista ID <strong>{dealProfile.vistaId}</strong> — that's how VT re-links the new cycle's uploads.
                  </div>
                ) : (
                  <div className="mb-3 px-3 py-2 rounded border border-amber-300 bg-amber-50 text-xs text-amber-900">
                    ⚠ <strong>No Vista ID set for this client.</strong> Add it on the Setup tab <em>and</em> to the ShareFile Data Room folder name — without it on both, this cycle's uploads won't auto-link.
                  </div>
                )}
                <label className="block text-xs font-medium text-gray-600 mb-1">New committed upload date</label>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p className="text-sm text-gray-600 mb-3">
                  Not starting yet — just set a reminder to begin the revalue later. <strong>Nothing is archived or reset</strong>, and <strong>{dealProfile.companyName || 'this business'}</strong> stays exactly where it is (out of the document pipeline / off the upload plate) until someone comes back and picks <em>Start now</em>.
                </p>
                <label className="block text-xs font-medium text-gray-600 mb-1">Remind me to start on</label>
              </React.Fragment>
            )}
            <input
              type="date"
              value={revalueDateInput}
              onChange={e => setRevalueDateInput(e.target.value)}
              className="w-full p-2 border rounded text-sm mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowRevalueModal(false)}
                disabled={revalueBusy}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-40"
              >
                Cancel
              </button>
              {revalueMode === 'now' ? (
                <button
                  onClick={startRevalue}
                  disabled={!revalueDateInput || revalueBusy}
                  className="px-3 py-1.5 rounded text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-40"
                >
                  {revalueBusy ? 'Working…' : 'Archive & Start Revalue'}
                </button>
              ) : (
                <button
                  onClick={scheduleRevalue}
                  disabled={!revalueDateInput || revalueBusy}
                  className="px-3 py-1.5 rounded text-sm font-semibold bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40"
                >
                  {revalueBusy ? 'Working…' : "Set reminder — don't start yet"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {/* ── Stage Engine: set-the-valuation-meeting modal ── */}
      {showMeetingDateModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Schedule the valuation meeting</h2>
            <p className="text-sm text-gray-600 mb-3">
              The analysis is complete. Next step — get the valuation meeting on
              the calendar, ideally within 24 hours. You'll usually need to email
              the owner for their availability first.
            </p>
            <label className="block text-xs font-medium text-gray-600 mb-1">Already have a date? Set it here:</label>
            <div className="flex gap-2 mb-2">
              <input
                type="date"
                value={meetingDateInput}
                onChange={e => setMeetingDateInput(e.target.value)}
                className="flex-1 p-2 border rounded text-sm"
              />
              <input
                type="time"
                value={meetingTimeInput}
                onChange={e => setMeetingTimeInput(e.target.value)}
                className="w-28 p-2 border rounded text-sm"
                title="Optional — leave blank for an all-day hold; set it for a real 1-hour slot."
              />
            </div>
            <label className="flex items-start gap-2 text-xs text-gray-600 mb-4 cursor-pointer">
              <input
                type="checkbox"
                checked={meetingCreateInvite}
                onChange={e => setMeetingCreateInvite(e.target.checked)}
                className="mt-0.5"
              />
              <span>📅 Create the calendar event on <strong>{workflow.lead || workflow.account_manager || 'the Lead'}</strong>'s calendar{workflow.owner_email ? ' and invite the owner' : ''} (no time = all-day hold; the calendar sync tracks it either way)</span>
            </label>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => { setShowMeetingDateModal(false); if (onBackToList) onBackToList(); }}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
              >
                I'll schedule with the owner
              </button>
              <button
                onClick={saveMeetingDateAndExit}
                disabled={!meetingDateInput}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-green-600 text-white hover:bg-green-700 disabled:opacity-40"
              >
                Save date &amp; exit
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── Reactivate (un-stall) modal — capture a fresh committed upload date ── */}
      {showReactivateModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Reactivate this project</h2>
            <p className="text-sm text-gray-600 mb-3">
              Bringing <strong>{dealProfile.companyName || 'this business'}</strong> back into the active
              pipeline. Set the new date the owner now plans to upload by — the document-chase cadence
              restarts from this date. Without a fresh date the project would immediately look overdue.
            </p>
            <label className="block text-xs font-medium text-gray-600 mb-1">New committed upload date:</label>
            <input
              type="date"
              value={reactivateDateInput}
              onChange={e => setReactivateDateInput(e.target.value)}
              className="w-full p-2 border rounded text-sm mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowReactivateModal(false)}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={confirmReactivate}
                disabled={!reactivateDateInput}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-green-600 text-white hover:bg-green-700 disabled:opacity-40"
              >
                Reactivate
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── Pipeline-value capture modal (on exit at val_meeting_set) ── */}
      {showPipelineCaptureModal && (() => {
        const top = Math.round(multipleEngineCalcs?.valuationMarketHigh || 0);
        const commission = Math.round(computeCommission(top));
        const fmt = (n) => '$' + (n || 0).toLocaleString();
        return (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
              <h2 className="text-lg font-bold text-gray-800 mb-1">Capture pipeline value</h2>
              <p className="text-sm text-gray-600 mb-3">
                Record the current figures for <strong>{dealProfile.companyName || 'this business'}</strong> so
                the pipeline stays accurate. These keep changing up to the meeting, so re-capture on each exit —
                after the valuation is delivered they lock in.
              </p>
              <div className="bg-gray-50 border rounded p-3 mb-4 text-sm">
                <div className="flex justify-between py-1"><span className="text-gray-600">Top valuation</span><span className="font-semibold text-gray-900">{fmt(top)}</span></div>
                <div className="flex justify-between py-1"><span className="text-gray-600">Estimated commission</span><span className="font-semibold text-emerald-700">{fmt(commission)}</span></div>
              </div>
              <div className="flex justify-end gap-2">
                <button onClick={skipPipelineCapture} disabled={pipelineCaptureBusy}
                  className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-40">Skip</button>
                <button onClick={capturePipelineValue} disabled={pipelineCaptureBusy}
                  className="px-3 py-1.5 rounded text-sm font-semibold bg-green-600 text-white hover:bg-green-700 disabled:opacity-40">
                  {pipelineCaptureBusy ? 'Saving…' : 'Save to pipeline'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
      {/* ── Consolidated post-meeting outcome wrap-up (full vals) ── */}
      {showOutcomeModal && (() => {
        const top = Math.round(multipleEngineCalcs?.valuationMarketHigh || 0);
        const commission = Math.round(computeCommission(top));
        const fmtM = (n) => '$' + (n || 0).toLocaleString();
        const decisions = [
          ['engaged',               'Engaged — agreement signed'],
          ['strategic_review_set',  'Active — agreed to a strategic review MEETING'],
          ['considering_followup',  'Active — circle back later (no meeting agreed)'],
          ['val_complete_inactive', 'Not ready — no review (inactive)'],
          ['val_complete_dead',     'Not for sale'],
          ['awaiting_decision',     'Still deciding — record later'],
        ];
        // BOTH dated outcomes require their date (Mark 09-10, the KGM/All
        // Quik/Partners Data audit: "reach back out in January" kept landing
        // in Strategic Review Set because the review date was optional — the
        // stage claimed meetings nobody agreed to. A review IS a meeting;
        // a circle-back is Considering. The date is what makes either true.)
        const SOFT_REASON = ['considering_followup', 'val_complete_dead', 'awaiting_decision'];
        const canSave = !!outcomeDateInput && !!outcomeDecision
          && (!['considering_followup', 'strategic_review_set'].includes(outcomeDecision) || !!outcomeReviewDate)
          && (!SOFT_REASON.includes(outcomeDecision) || !!outcomeReason.trim());
        return (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 max-h-[92vh] overflow-y-auto">
              <h2 className="text-lg font-bold text-gray-800 mb-1">Record the valuation meeting outcome</h2>
              <p className="text-sm text-gray-600 mb-4">
                One step for <strong>{dealProfile.companyName || 'this business'}</strong> — captures the value &amp; commission and records the owner's decision so nothing gets missed.
              </p>

              <label className="block text-xs font-semibold text-gray-600 mb-1">Valuation date (delivered)</label>
              <input type="date" value={outcomeDateInput} onChange={e => setOutcomeDateInput(e.target.value)}
                className="w-full p-2 border rounded text-sm mb-3" />

              <div className="bg-gray-50 border rounded p-3 mb-3 text-sm">
                <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1">Locked to the pipeline</div>
                <div className="flex justify-between py-0.5"><span className="text-gray-600">Top valuation</span><span className="font-semibold text-gray-900">{fmtM(top)}</span></div>
                <div className="flex justify-between py-0.5"><span className="text-gray-600">Estimated commission</span><span className="font-semibold text-emerald-700">{fmtM(commission)}</span></div>
              </div>

              {/* The two outcomes that count sit first and large; the soft ones
                  sit below, greyed, and each needs a reason (Mark 09-21). */}
              <label className="block text-xs font-semibold text-gray-600 mb-1">Owner's decision — <span className="text-emerald-700">the two that count</span></label>
              <div className="space-y-1.5 mb-2">
                {decisions.slice(0, 2).map(([val, lbl]) => (
                  <label key={val} className={`flex items-center gap-2 p-2.5 border-2 rounded text-sm font-semibold cursor-pointer ${outcomeDecision === val ? 'border-emerald-500 bg-emerald-50 text-emerald-900' : 'border-emerald-200 text-gray-800 hover:bg-emerald-50'}`}>
                    <input type="radio" name="outcome-decision" value={val} checked={outcomeDecision === val} onChange={() => setOutcomeDecision(val)} />
                    <span>{lbl}</span>
                  </label>
                ))}
              </div>
              <div className="text-[11px] text-gray-400 mb-1">Softer outcomes — say why:</div>
              <div className="space-y-1 mb-3">
                {decisions.slice(2).map(([val, lbl]) => (
                  <label key={val} className={`flex items-center gap-2 p-1.5 border rounded text-xs cursor-pointer ${outcomeDecision === val ? 'border-gray-400 bg-gray-100 text-gray-800' : 'border-gray-200 text-gray-500 hover:bg-gray-50'}`}>
                    <input type="radio" name="outcome-decision" value={val} checked={outcomeDecision === val} onChange={() => setOutcomeDecision(val)} />
                    <span>{lbl}</span>
                  </label>
                ))}
              </div>
              {SOFT_REASON.includes(outcomeDecision) && (
                <div className="mb-3">
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Why not an engagement or a review date? <span className="font-normal text-red-500">(required)</span></label>
                  <input type="text" value={outcomeReason} onChange={e => setOutcomeReason(e.target.value)} placeholder="One line — what the owner actually said"
                    className="w-full p-2 border rounded text-sm" />
                </div>
              )}

              {outcomeDecision === 'strategic_review_set' && (
                <div className="mb-3">
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Strategic review meeting date <span className="font-normal text-red-500">(required)</span></label>
                  <input type="date" value={outcomeReviewDate} onChange={e => setOutcomeReviewDate(e.target.value)}
                    className="w-full p-2 border rounded text-sm" />
                  <p className="text-[11px] text-gray-500 mt-1">This stage means a review <b>meeting</b> the owner agreed to. If they just want us to reach back out later — no meeting yet — pick <b>circle back later</b> above with that date instead; it returns to the Lead on the day.</p>
                </div>
              )}

              {outcomeDecision === 'considering_followup' && (
                <div className="mb-3">
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Follow-up date <span className="font-normal text-gray-400">(when the owner asked us to circle back)</span></label>
                  <input type="date" value={outcomeReviewDate} onChange={e => setOutcomeReviewDate(e.target.value)}
                    className="w-full p-2 border rounded text-sm" />
                </div>
              )}

              <div className="flex justify-end gap-2 pt-1">
                <button onClick={() => { setShowOutcomeModal(false); if (onBackToList) onBackToList(); }} disabled={outcomeBusy}
                  className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-40">
                  Not yet
                </button>
                <button onClick={() => saveValuationOutcome(true)} disabled={!canSave || outcomeBusy}
                  className="px-3 py-1.5 rounded text-sm font-semibold bg-green-600 text-white hover:bg-green-700 disabled:opacity-40">
                  {outcomeBusy ? 'Saving…' : 'Record outcome'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
      {/* ── Stage Engine: strategic-review decision modal ── */}
      {showStrategicReviewModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Owner opted for a strategic review</h2>
            <p className="text-sm text-gray-600 mb-3">
              Records the decision and moves the project to Strategic Review Set.
              This stage means a review <strong>meeting the owner agreed to</strong> —
              set its date and it becomes the project's next meeting. If the owner
              just wants a reach-back later (no meeting agreed), cancel and use
              <strong> Considering — follow up later</strong> with that date instead.
            </p>
            <label className="block text-xs font-medium text-gray-600 mb-1">Strategic review meeting date <span className="text-red-500">(required)</span>:</label>
            <input
              type="date"
              value={strategicReviewDateInput}
              onChange={e => setStrategicReviewDateInput(e.target.value)}
              className="w-full p-2 border rounded text-sm mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowStrategicReviewModal(false)}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={recordStrategicReview}
                disabled={!strategicReviewDateInput}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-40"
              >
                Record decision
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── Stage Engine: considering / follow-up-later decision modal ── */}
      {showFollowupModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Still deciding — follow up on a date</h2>
            <p className="text-sm text-gray-600 mb-3">
              Within 3 months the deal <b>stays in Awaiting Decision</b> — the date is a
              reminder: the card parks until then and comes back that morning, and the
              staff meeting still sees it. Further out, it parks in Considering. Colleen can also set herself a reminder.
            </p>
            <label className="block text-xs font-medium text-gray-600 mb-1">Follow-up date:</label>
            <input
              type="date"
              value={followupDateInput}
              onChange={e => setFollowupDateInput(e.target.value)}
              className="w-full p-2 border rounded text-sm mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowFollowupModal(false)}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={recordConsideringFollowup}
                disabled={!followupDateInput}
                className="px-3 py-1.5 rounded text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-40"
              >
                Record decision
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── OIR draft-email modal (Stage B4 + B5 cadence) ── */}
      {showOIRModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[92vh] flex flex-col">
            <div className="flex items-center justify-between px-5 py-3 border-b">
              <h2 className="text-lg font-bold text-gray-800">
                {oirMode === 'questions' && 'Send Owner Questions'}
                {oirMode !== 'questions' && oirCadenceVariant === 'weekly' && 'Send Weekly Reminder'}
                {oirMode !== 'questions' && oirCadenceVariant === 'final-no-value' && 'Send Final Follow-Up'}
                {oirMode !== 'questions' && oirCadenceVariant === 'final-meeting-offer' && 'Send Final Follow-Up — Meeting Offer'}
                {oirMode !== 'questions' && !oirCadenceVariant && 'Send Outstanding Items Report'}
              </h2>
              <button onClick={closeOIRModal} disabled={oirSending}
                className="text-gray-400 hover:text-gray-600 disabled:opacity-30 text-2xl leading-none">×</button>
            </div>
            <div className="px-5 py-4 overflow-y-auto">
              {(oirCadenceVariant === 'final-no-value' || oirCadenceVariant === 'final-meeting-offer') && (
                <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-300 text-sm text-red-900">
                  <strong>Heads up:</strong> sending this final reminder also flips the project to <strong>Stalled — Returned to AM</strong>. The Account Manager picks up the relationship; weekly reminders stop. Reactivate later by unchecking the box on Setup → Workflow &amp; Pipeline.
                </div>
              )}
              {oirMode === 'questions' ? (
                <>
                <div className="mb-3 p-3 rounded-lg bg-blue-50 border border-blue-300 text-sm text-blue-900">
                  <strong>Owner questions:</strong> sent <strong>as Colleen</strong>, this lists every open
                  “Ask Owner” question for this project ({openOwnerQuestions.length}). No value or accuracy
                  is shown. Sending marks them as awaiting an answer.
                </div>
                {/* How the owner answers — default portal, switch to reply-by-email
                    for legacy clients or anyone not comfortable with the portal. */}
                <div className="mb-4">
                  <label className="block text-xs font-semibold text-gray-600 mb-1">How should they answer?</label>
                  <div className="inline-flex rounded-lg border border-gray-300 overflow-hidden text-sm">
                    <button type="button" onClick={() => setQuestionsAnswerMode('portal')}
                      className={`px-3 py-1.5 font-medium ${questionsAnswerMode === 'portal' ? 'bg-emerald-700 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>
                      🔒 In the portal
                    </button>
                    <button type="button" onClick={() => setQuestionsAnswerMode('email')}
                      className={`px-3 py-1.5 font-medium border-l border-gray-300 ${questionsAnswerMode === 'email' ? 'bg-emerald-700 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>
                      ✉️ Reply by email
                    </button>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {questionsAnswerMode === 'portal'
                      ? 'Portal-first (default). The owner answers in their secure portal and the answers surface inline here.'
                      : 'For owners not using the portal. The email asks them to reply with numbered answers; enter their reply into the Resolution cell by hand.'}
                  </p>
                </div>
                </>
              ) : workflow.path === 'partial' ? (
                <div className="mb-4 p-3 rounded-lg bg-blue-50 border border-blue-300 text-sm text-blue-900">
                  <strong>Partial valuation:</strong> this OIR shows document progress only — no
                  estimated value or accuracy %. For partials, the value is shared when the owner
                  meets with you, not by email. Confirm received documents are entered before sending.
                </div>
              ) : (
                <div className="mb-4 p-3 rounded-lg bg-amber-50 border border-amber-300 text-sm text-amber-900">
                  <strong>⚠ Before you send:</strong> the value reflects only what's currently
                  <em> entered</em> in VT. <strong>Add-backs and adjustments are entered last and they
                  raise the value</strong> — if they aren't in yet, the owner sees an understated
                  number. Confirm data entry, including adjustments, is complete.
                </div>
              )}
              <label className="block text-xs font-semibold text-gray-600 mb-1">To — owner's email</label>
              <input type="email" value={oirTo} onChange={e => setOirTo(e.target.value)}
                placeholder="owner@example.com"
                className="w-full p-2 border rounded text-sm mb-3" />
              <label className="block text-xs font-semibold text-gray-600 mb-1">
                CC <span className="font-normal text-gray-400">(additional owners — comma-separated)</span>
              </label>
              <input type="text" value={oirCc} onChange={e => setOirCc(e.target.value)}
                placeholder="co-owner@example.com, partner@example.com"
                className="w-full p-2 border rounded text-sm mb-3" />
              <label className="block text-xs font-semibold text-gray-600 mb-1">Subject</label>
              <input type="text" value={oirSubject} onChange={e => setOirSubject(e.target.value)}
                className="w-full p-2 border rounded text-sm mb-3" />
              <label className="block text-xs font-semibold text-gray-600 mb-1">
                Personal note <span className="font-normal text-gray-400">(optional — appears at the top of the email)</span>
              </label>
              <textarea value={oirNote} onChange={e => setOirNote(e.target.value)} rows={3}
                placeholder="Hi John, great speaking with you today..."
                className="w-full p-2 border rounded text-sm mb-3" />
              <label className="block text-xs font-semibold text-gray-600 mb-1">Preview — exactly what the owner receives</label>
              <iframe title="OIR preview" srcDoc={oirMode === 'questions' ? buildOwnerQuestionsEmailHtml(oirNote, questionsAnswerMode) : buildOIREmailHtml(oirNote, { cadenceVariant: oirCadenceVariant })}
                className="w-full border rounded bg-gray-50" style={{ height: '380px' }} />
              {oirSendResult && (
                <div className={`mt-3 p-2 rounded text-sm ${oirSendResult.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
                  {oirSendResult.ok ? '✓ ' : '✕ '}{oirSendResult.msg}
                </div>
              )}
            </div>
            <div className="flex justify-end gap-2 px-5 py-3 border-t">
              <button onClick={closeOIRModal} disabled={oirSending}
                className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800 disabled:opacity-30">
                Cancel
              </button>
              <button onClick={oirMode === 'questions' ? sendOwnerQuestions : sendOIR} disabled={oirSending || (oirSendResult && oirSendResult.ok)}
                className="px-4 py-2 bg-emerald-700 text-white rounded text-sm font-semibold hover:bg-emerald-800 disabled:bg-gray-300">
                {oirSending ? 'Sending…' : '📨 Send to Owner'}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="bg-white rounded-lg shadow-lg p-4 mb-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <img src="/public/logo.jpg" alt="" style={{ height: 40 }} />
            <div>
              <h1 className="text-xl font-bold text-gray-800">Business Valuation Analysis</h1>
              <p className="text-sm text-gray-600">
                {dealProfile.companyName || 'New Deal - Enter company name in Deal Profile'}
                {workflow.path === 'full_valuation' && (
                  <span className="ml-2 px-2.5 py-0.5 bg-purple-100 text-purple-800 text-xs font-bold uppercase tracking-wide rounded">
                    Full Valuation
                  </span>
                )}
                {workflow.path === 'partial' && (
                  <span className="ml-2 px-2.5 py-0.5 bg-blue-100 text-blue-800 text-xs font-bold uppercase tracking-wide rounded">
                    Partial Valuation
                  </span>
                )}
                {!workflow.path && (
                  <span className="ml-2 px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded">
                    Path not set
                  </span>
                )}
                {workflow.workflow_stage && (
                  <span className={`ml-2 px-2.5 py-0.5 ${stageColor(workflow.workflow_stage)} text-xs font-bold uppercase tracking-wide rounded`}
                    title="Current workflow stage">
                    {stageLabel(workflow.workflow_stage)}
                  </span>
                )}
                {!fiscalYearHelpers.isCalendarYear && (
                  <span className="ml-2 px-2 py-0.5 bg-amber-100 text-amber-700 text-xs rounded">
                    FY ({['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][(dealProfile.fiscalYearEndMonth || 12) - 1]} year-end)
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {/* Back to Clients */}
            {onBackToList && (
              <button
                onClick={handleBackToList}
                className="px-2 py-1 rounded text-xs font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 border-r pr-3 mr-1 flex items-center gap-1"
                title="Back to client list"
              >
                ← Clients
              </button>
            )}
            {/* Save/Load Buttons (hidden for read-only Account Managers) */}
            <div className="flex gap-1 border-r pr-3 items-center">
              {isReadOnlyViewer ? (
                <span className="px-2 py-1 rounded text-xs font-semibold bg-indigo-100 text-indigo-700 flex items-center gap-1" title="Account Managers have read-only access — changes are not saved.">
                  👁 Read-only
                </span>
              ) : (
                <React.Fragment>
                  <button onClick={() => saveDeal()} className="px-2 py-1 rounded text-xs font-semibold bg-blue-100 text-blue-700 hover:bg-blue-200 flex items-center gap-1" title={cloudMode ? 'Save valuation to cloud' : 'Save deal to JSON file'}>
                    <Save className="w-3 h-3" /> Save
                  </button>
                  {cloudMode && (
                    <button onClick={() => saveDeal({ forceDownload: true })} className="px-2 py-1 rounded text-xs font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200 flex items-center gap-1" title="Download a JSON backup copy">
                      <FileText className="w-3 h-3" /> Backup
                    </button>
                  )}
                  {!cloudMode && (
                    <button onClick={() => fileInputRef.current?.click()} className="px-2 py-1 rounded text-xs font-semibold bg-blue-100 text-blue-700 hover:bg-blue-200 flex items-center gap-1" title="Load deal from JSON file">
                      <FolderOpen className="w-3 h-3" /> Load
                    </button>
                  )}
                  <button onClick={clearDeal} className="px-2 py-1 rounded text-xs font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200" title="Clear all data and start fresh">
                    Clear
                  </button>
                </React.Fragment>
              )}
              {undoStack.length > 0 && (
                <button
                  onClick={() => performUndo()}
                  className={`px-2 py-1 rounded text-xs font-semibold flex items-center gap-1 ${
                    undoStack[0]?.label === 'Clear Deal'
                      ? 'bg-red-100 text-red-700 hover:bg-red-200'
                      : 'bg-amber-100 text-amber-700 hover:bg-amber-200'
                  }`}
                  title={`Undo: ${undoStack[0]?.label || 'last action'}${undoStack.length > 1 ? ` (${undoStack.length} available)` : ''}`}
                >
                  <RotateCcw className="w-3 h-3" />
                  Undo
                </button>
              )}
              {redoStack.length > 0 && (
                <button 
                  onClick={() => performRedo()} 
                  className="px-2 py-1 rounded text-xs font-semibold flex items-center gap-1 bg-blue-100 text-blue-700 hover:bg-blue-200"
                  title={`Redo: ${redoStack[0]?.label || 'last undo'}${redoStack.length > 1 ? ` (${redoStack.length} available)` : ''}`}
                >
                  <RotateCw className="w-3 h-3" />
                  Redo
                  <span className="text-[10px] opacity-75">({redoStack.length})</span>
                </button>
              )}
              {/* Auto-save indicator */}
              {autoSaveStatus === 'saving' && (
                <span className="text-xs text-blue-500 animate-pulse ml-1">Saving...</span>
              )}
              {autoSaveStatus === 'saved' && (
                <span className="text-xs text-green-600 ml-1">✓ Auto-saved</span>
              )}
              {autoSaveStatus === 'paused' && (
                <span
                  className="text-xs text-amber-600 ml-1"
                  title="Auto-save paused while another user is viewing this file. Use Save to write changes manually."
                >
                  ⏸ Auto-save paused
                </span>
              )}
              {!isReadOnlyViewer && hasUnsavedChanges && !autoSaveStatus && (
                <span className="text-xs text-amber-600 ml-1" title={cloudMode ? 'Unsaved changes — auto-save runs every 60 seconds and on tab switch' : 'Unsaved changes — auto-save runs every 60 seconds'}>● Unsaved</span>
              )}
              {!hasUnsavedChanges && !autoSaveStatus && lastAutoSave && (
                <span
                  className="text-xs text-gray-500 ml-1"
                  title={`Last saved ${lastAutoSave.toLocaleString()}`}
                >
                  Saved {lastAutoSave.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
                </span>
              )}
              {/* Inline ⚠ removed — the loud banner at the top of the page is the visible
                  surface for cloudSaveError now (the inline icon was too easy to miss). */}
              <input type="file" ref={fileInputRef} onChange={loadDeal} accept=".json" className="hidden" />
            </div>
            
            {/* User menu (avatar dropdown) */}
            {userEmail && (
              <div className="relative border-r pr-3 mr-2" ref={userMenuRef}>
                <button
                  onClick={() => setUserMenuOpen(o => !o)}
                  className="relative w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center text-sm font-bold hover:bg-blue-700"
                  title={userEmail}
                  aria-label="Account menu"
                >
                  {userEmail.charAt(0).toUpperCase()}
                  {!hasMfa && (
                    <span
                      className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-amber-400 border border-white"
                      title="2FA not configured"
                    />
                  )}
                </button>
                {userMenuOpen && (
                  <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50 py-1 text-left">
                    <div className="px-3 py-2 border-b border-gray-100">
                      <div className="text-[10px] uppercase tracking-wide text-gray-400">Signed in as</div>
                      <div className="text-sm font-semibold text-gray-800 truncate" title={userEmail}>{userEmail}</div>
                    </div>
                    <div className="px-3 py-2 border-b border-gray-100">
                      {hasMfa ? (
                        <div className="text-xs text-green-600 font-medium">✓ Two-factor authentication enabled</div>
                      ) : (
                        <button
                          onClick={() => { setUserMenuOpen(false); onEnrollMfa && onEnrollMfa(); }}
                          className="text-xs font-semibold text-amber-700 hover:text-amber-900"
                        >
                          Set up 2FA →
                        </button>
                      )}
                    </div>
                    <button
                      onClick={() => { setUserMenuOpen(false); onSignOut && onSignOut(); }}
                      className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Sign Out
                    </button>
                    <div className="px-3 pt-2 pb-1 border-t border-gray-100 text-[10px] text-gray-400">
                      Vista Valuation Tool · v98-122-79
                    </div>
                  </div>
                )}
              </div>
            )}
            
            {/* Two-Tier Navigation */}
            {(() => {
              // Define navigation structure
              const navStructure = {
                setup: { label: '1. Setup', icon: '🏢', tabs: ['profile'] },
                entry: { label: '2. Data Entry', icon: '📝', tabs: ['accrualpl', 'cashpl', 'taxreturns', 'ttmmonthly', 'balancesheet', 'ttmbalsheet', 'customers', 'salesmonthly', 'arap', 'proforma', 'discovery'] },
                analysis: { label: '3. Analysis', icon: '🔍', tabs: ['detailed', 'revenueanalysis', 'salesanalysis', 'arapanalysis', 'bsanalysis', 'wcanalysis', 'adjustments', 'reconciliation', 'proformaanalysis', 'outstanding'] },
                valuation: { label: '4. Valuation', icon: '💰', tabs: ['multipleengine', 'overview', 'sba', 'benchmarks'] },
                presentation: { label: '5. Presentation', icon: '🎯', tabs: ['presentation', 'proformapres'] },
                portfolio: { label: '6. Portfolio', icon: '📁', tabs: ['portfolio'] }
              };
              
              const tabLabels = {
                profile: 'Deal Profile',
                discovery: 'Discovery',
                accrualpl: 'Accrual P&L',
                cashpl: 'Cash P&L',
                taxreturns: 'Tax Returns',
                ttmmonthly: 'TTM P&L',
                balancesheet: 'Balance Sheet',
                ttmbalsheet: 'TTM BS',
                customers: 'Sales',
                salesmonthly: 'TTM Sales',
                arap: 'AR/AP',
                proforma: 'Pro Forma',
                detailed: 'Income Statement',
                revenueanalysis: 'Revenue & COGS',
                salesanalysis: 'Sales Analysis',
                arapanalysis: 'AR/AP Analysis',
                bsanalysis: 'BS Analysis',
                wcanalysis: 'WC & CapEx',
                adjustments: 'Adjustments',
                reconciliation: 'Reconciliation',
                proformaanalysis: 'Pro Forma Analysis',
                outstanding: 'Open Items',
                overview: 'Overview',
                multipleengine: 'Multiple Engine',
                benchmarks: 'Benchmarks',
                sba: 'SBA Analysis',
                presentation: 'Presentation',
                proformapres: 'Pro Forma Summary',
                portfolio: 'Portfolio Consolidation'
              };
              
              // Find which primary section the current viewMode belongs to
              const getCurrentSection = () => {
                for (const [section, config] of Object.entries(navStructure)) {
                  if (config.tabs.includes(viewMode)) return section;
                }
                return 'setup';
              };
              const currentSection = getCurrentSection();
              const currentTabs = navStructure[currentSection].tabs;
              
              return (
                <div className="space-y-2">
                  {/* Primary Navigation */}
                  <div className="flex gap-1">
                    {Object.entries(navStructure).map(([section, config]) => {
                      const isActive = currentSection === section;
                      const hasIssues = section === 'analysis' && outstandingAnalysis.unacknowledgedFlags.filter(f => f.severity === 'critical').length > 0;
                      return (
                        <button 
                          key={section} 
                          onClick={() => setViewMode(config.tabs[0])} 
                          className={`px-4 py-2 rounded-t-lg font-semibold text-sm transition-all ${
                            isActive 
                              ? 'bg-blue-600 text-white shadow-md' 
                              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                          }`}
                        >
                          {config.icon} {config.label}
                          {hasIssues && <span className="ml-1 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full">{outstandingAnalysis.unacknowledgedFlags.filter(f => f.severity === 'critical').length}</span>}
                        </button>
                      );
                    })}
                  </div>
                  
                  {/* Secondary Navigation (Sub-tabs) */}
                  {currentTabs.length > 1 && (
                    <div className="flex gap-1 pl-2 border-l-4 border-blue-600">
                      {currentTabs.map(tab => (
                        <button 
                          key={tab} 
                          onClick={() => setViewMode(tab)} 
                          className={`px-3 py-1.5 rounded font-medium text-xs transition-all ${
                            viewMode === tab 
                              ? 'bg-blue-100 text-blue-800 border border-blue-300' 
                              : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'
                          }`}
                        >
                          {tabLabels[tab]}
                          {tab === 'outstanding' && outstandingAnalysis.unacknowledgedFlags.length > 0 && (
                            <span className={`ml-1 px-1.5 py-0.5 text-xs rounded-full ${outstandingAnalysis.unacknowledgedFlags.some(f => f.severity === 'critical') ? 'bg-red-500 text-white' : 'bg-amber-400 text-amber-900'}`}>
                              {outstandingAnalysis.unacknowledgedFlags.length}
                            </span>
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        </div>

        {/* ========== DEAL PROFILE ========== */}
        {viewMode === 'profile' ? (
          <div>
            <h2 className="text-lg font-bold mb-3">🏢 Deal Profile</h2>

            {/* 👤 Contact strip (Adam 08-31, the UNS follow-up: the owner's
                email lived four scrolls down in the workflow column and he
                went to Zoho for it — a semi-common miss). Display-only,
                always in sync with the workflow fields; works in the AM
                read-only view. */}
            {(workflow.owner_first_name || workflow.owner_last_name || workflow.owner_email || (workflow.owner_additional || []).some(o => o && (o.name || o.email))) && (
              <div className="bg-sky-50 border border-sky-200 rounded-lg px-4 py-2.5 mb-4 text-sm flex flex-wrap items-center gap-x-5 gap-y-1">
                <span className="font-semibold text-gray-700">👤 {[workflow.owner_first_name, workflow.owner_last_name].filter(Boolean).join(' ') || 'Owner'}</span>
                {workflow.owner_email && (
                  <a className="text-sky-700 underline" href={`mailto:${String(workflow.owner_email).trim()}`}>{String(workflow.owner_email).trim()}</a>
                )}
                {(workflow.owner_additional || []).filter(o => o && (o.name || o.email)).map((o, i) => (
                  <span key={i} className="text-gray-600">
                    {o.name || '—'}{o.email ? <> · <a className="text-sky-700 underline" href={`mailto:${String(o.email).trim()}`}>{String(o.email).trim()}</a></> : null}
                  </span>
                ))}
                {currentValuationId && (
                  <button type="button" className="text-xs px-2 py-0.5 rounded border border-sky-300 text-sky-800 bg-white hover:bg-sky-100"
                    title="Our confidentiality agreement for this business, already signed by Mark (the same one the owner gets in their portal). Download it and email it to the owner."
                    onClick={async () => {
                      try {
                        const { data: { session } } = await supabaseClient.auth.getSession();
                        const r = await fetch('/api/staff/ca/' + currentValuationId, { headers: { Authorization: 'Bearer ' + (session && session.access_token) } });
                        if (!r.ok) throw new Error('status ' + r.status);
                        const blob = await r.blob();
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url; link.download = (String(dealProfile.companyName || 'Vista').replace(/[^a-zA-Z0-9]/g, '_')) + '_Confidentiality_Agreement.docx';
                        document.body.appendChild(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 5000);
                      } catch (e) { window.alert('Could not download the agreement: ' + (e?.message || '')); }
                    }}>⬇ Our signed confidentiality agreement</button>
                )}
                <span className="text-xs text-gray-400 ml-auto">edit below under Workflow → 👤 Owner contact</span>
              </div>
            )}

            {/* Company & Deal Info */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3">Company Information</h3>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Company Name</label>
                    <input type="text" value={dealProfile.companyName} onChange={e => setDealProfile({...dealProfile, companyName: e.target.value})} placeholder="Enter company name" className="w-full p-2 border rounded text-lg font-semibold" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Website</label>
                    <input type="url" value={dealProfile.website || ''} onChange={e => setDealProfile({...dealProfile, website: e.target.value})} placeholder="https://www.example.com" className="w-full p-2 border rounded" />
                  </div>
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Year Established</label>
                      <input type="text" value={dealProfile.yearEstablished || ''} onChange={e => setDealProfile({...dealProfile, yearEstablished: e.target.value})} placeholder="e.g., 2005" className="w-full p-2 border rounded" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Legal Status</label>
                      <select value={dealProfile.legalStatus || ''} onChange={e => setDealProfile({...dealProfile, legalStatus: e.target.value})} className="w-full p-2 border rounded">
                        <option value="">Select...</option>
                        <option value="LLC">LLC</option>
                        <option value="S-Corp">S-Corp</option>
                        <option value="C-Corp">C-Corp</option>
                        <option value="Sole Proprietorship">Sole Proprietorship</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Fiscal Year End</label>
                      <select value={dealProfile.fiscalYearEndMonth || 12} onChange={e => setDealProfile({...dealProfile, fiscalYearEndMonth: parseInt(e.target.value)})} className="w-full p-2 border rounded">
                        {['January','February','March','April','May','June','July','August','September','October','November','December'].map((m, i) => (
                          <option key={i+1} value={i+1}>{m}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* CIM Business Details fields (Zac 2026-07-27) — all optional;
                      blank rows are dropped from the CIM's Business Details table. */}
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">DBA / Trade Name</label>
                      <input type="text" value={dealProfile.dbaName || ''} onChange={e => setDealProfile({...dealProfile, dbaName: e.target.value})} placeholder="e.g., WesTech" className="w-full p-2 border rounded" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">State of Incorporation</label>
                      <input type="text" value={dealProfile.stateOfIncorporation || ''} onChange={e => setDealProfile({...dealProfile, stateOfIncorporation: e.target.value})} placeholder="e.g., Kansas" className="w-full p-2 border rounded" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Ownership <span className="font-normal text-gray-400">— names + percentages, shown in the CIM</span></label>
                    <input type="text" value={dealProfile.ownershipText || ''} onChange={e => setDealProfile({...dealProfile, ownershipText: e.target.value})} placeholder="e.g., Jane Smith 60% · John Smith 40%" className="w-full p-2 border rounded" />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Hours of Operation</label>
                      <input type="text" value={dealProfile.hoursOfOperation || ''} onChange={e => setDealProfile({...dealProfile, hoursOfOperation: e.target.value})} placeholder="e.g., Mon–Fri 7:30–4:30" className="w-full p-2 border rounded" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Industry Mix</label>
                      <input type="text" value={dealProfile.industryMix || ''} onChange={e => setDealProfile({...dealProfile, industryMix: e.target.value})} placeholder="e.g., 98% residential / 2% commercial" className="w-full p-2 border rounded" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Customer Type</label>
                      <input type="text" value={businessModel.customerType || ''} onChange={e => setBusinessModel({...businessModel, customerType: e.target.value})} placeholder="e.g., SMB, Healthcare, Enterprise" className="w-full p-2 border rounded" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Industries Served</label>
                      <input type="text" value={businessModel.industriesServed || ''} onChange={e => setBusinessModel({...businessModel, industriesServed: e.target.value})} placeholder="e.g., Healthcare, Legal, Financial Services" className="w-full p-2 border rounded" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Geographic Scope</label>
                      <select value={businessModel.geographicScope || ''} onChange={e => setBusinessModel({...businessModel, geographicScope: e.target.value})} className="w-full p-2 border rounded">
                        <option value="">Select...</option>
                        <option value="Local">Local</option>
                        <option value="Regional">Regional</option>
                        <option value="National">National</option>
                        <option value="International">International</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Geographic Detail</label>
                      <input type="text" value={businessModel.geographicDetail || ''} onChange={e => setBusinessModel({...businessModel, geographicDetail: e.target.value})} placeholder="e.g., Dallas-Fort Worth metro, State of Texas" className="w-full p-2 border rounded" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Business Description</label>
                    <textarea value={businessModel.descriptionOverride || ''} onChange={e => setBusinessModel({...businessModel, descriptionOverride: e.target.value})} placeholder="1-2 sentences describing what the company does" className="w-full p-2 border rounded text-sm" rows={2} />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Industry Sector</label>
                      <select value={selectedSector} onChange={e => setSelectedSector(e.target.value)} className="w-full p-2 border rounded">
                        <option value="">-- Select Sector --</option>
                        {industrySectors.map(sector => (
                          <option key={sector.id} value={sector.id}>{sector.name}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Industry</label>
                      <select value={selectedIndustry} onChange={e => setSelectedIndustry(e.target.value)} className="w-full p-2 border rounded">
                        <option value="">-- Select Industry --</option>
                        {currentSectorIndustries.map(ind => (
                          <option key={ind.id} value={ind.id}>{ind.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {selectedIndustryObj && (
                    <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded flex items-center justify-between">
                      <span>Industry adjustment: <span className={selectedIndustryObj.adjustment > 0 ? 'text-green-600 font-semibold' : selectedIndustryObj.adjustment < 0 ? 'text-red-600 font-semibold' : 'text-gray-600'}>{selectedIndustryObj.adjustment >= 0 ? '+' : ''}{selectedIndustryObj.adjustment.toFixed(2)}x</span></span>
                      <span className="text-gray-400">Benchmark: {selectedIndustryObj.benchmarks.recurringRevenuePct}% recurring, {selectedIndustryObj.benchmarks.ebitdaMargin}% EBITDA margin</span>
                    </div>
                  )}
                  {!selectedIndustry && (
                    <div className="text-xs text-red-700 bg-red-50 border border-red-200 p-2 rounded font-medium">
                      ⚠ Pick the industry — benchmarks, the base multiple, and the industry factor all key off it. Until it's picked, factor math runs on the generic MSP profile, the CIM export is blocked, and nothing carries to the Sales Engine or Deal Manager. (Every valuation used to silently start as "MSP" — the Airmerica lesson, Aug 27.)
                    </div>
                  )}

                  {/* Location — folded in from the standalone block 2026-05-27 */}
                  <div className="border-t pt-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">City</label>
                        <input type="text" value={dealProfile.city || ''} onChange={e => setDealProfile({...dealProfile, city: e.target.value})} placeholder="City" className="w-full p-2 border rounded" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">State</label>
                        <select value={dealProfile.state || ''} onChange={e => setDealProfile({...dealProfile, state: e.target.value})} className="w-full p-2 border rounded">
                          <option value="">Select State / Province</option>
                          <optgroup label="United States">
                            {usStates.filter(st => st.code).map(st => (
                              <option key={`us-${st.code}`} value={st.code}>{st.name}</option>
                            ))}
                          </optgroup>
                          <optgroup label="Canada">
                            {canadianProvinces.map(pr => (
                              <option key={`ca-${pr.code}`} value={pr.code}>{pr.name}</option>
                            ))}
                          </optgroup>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Location Type (affects buyer pool)</label>
                    <select value={dealProfile.locationType || ''} onChange={e => setDealProfile({...dealProfile, locationType: e.target.value})} className="w-full p-2 border rounded">
                      <option value="">-- Select Location Type --</option>
                      <option value="major_metro">Major Metro (Top 25 MSA, 1M+ population)</option>
                      <option value="suburban">Suburban / Mid-size City (250K-1M)</option>
                      <option value="small_city">Small City (50K-250K)</option>
                      <option value="rural">Rural (Under 50K)</option>
                    </select>
                  </div>
                  <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded flex items-center justify-between">
                    <span>Location adjustment: <span className={(locationTypeAdjustments[dealProfile.locationType] || 0) > 0 ? 'text-green-600 font-semibold' : (locationTypeAdjustments[dealProfile.locationType] || 0) < 0 ? 'text-red-600 font-semibold' : 'text-gray-600'}>{(locationTypeAdjustments[dealProfile.locationType] || 0) >= 0 ? '+' : ''}{(locationTypeAdjustments[dealProfile.locationType] || 0).toFixed(2)}x base</span></span>
                    <span className="text-gray-400">(Scales down for larger businesses)</span>
                  </div>

                  {/* Non-calendar fiscal-year warning — folded in from the
                      old Financial Reporting block (the FYE selector itself
                      already lives above). */}
                  {(dealProfile.fiscalYearEndMonth || 12) !== 12 && (
                    <div className="text-xs text-amber-600 bg-amber-50 p-2 rounded">
                      <strong>Non-calendar fiscal year:</strong> Year labels show as "FY2024" format.
                      For a {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][(dealProfile.fiscalYearEndMonth || 12) - 1]} year-end,
                      FY2024 means {['Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','Jan'][(dealProfile.fiscalYearEndMonth || 12) - 1]} 2023 - {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][(dealProfile.fiscalYearEndMonth || 12) - 1]} 2024.
                    </div>
                  )}
                </div>
              </div>

              {isStaffPreview(userEmail) && (
              <div className="bg-white p-4 rounded-lg border border-blue-200">
                <h3 className="font-bold text-gray-800 mb-1">🧭 Workflow &amp; Pipeline</h3>
                <p className="text-xs text-gray-500 mb-3">Drives the dashboard. Stage, path, and dates here are what Konnie, Colleen, and management see.</p>
                <div className="space-y-3">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Workflow Stage</label>
                      <div className="w-full p-2 border rounded bg-gray-50 flex items-center gap-2">
                        <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded ${stageColor(workflow.workflow_stage)}`}>
                          {stageLabel(workflow.workflow_stage)}
                        </span>
                        <span className="text-xs text-gray-400">derived from project activity</span>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Path</label>
                      <select value={workflow.path} onChange={e => updateWorkflow('path', e.target.value)} className="w-full p-2 border rounded text-sm">
                        <option value="">— not set —</option>
                        <option value="full_valuation">Full Valuation</option>
                        <option value="partial">Partial Valuation</option>
                      </select>
                    </div>
                  </div>
                  <div className={`p-2.5 border rounded-lg ${workflow.buyside ? 'bg-purple-50 border-purple-300' : 'border-gray-200'}`}>
                    <label className="flex items-start gap-2 cursor-pointer">
                      <input type="checkbox" checked={!!workflow.buyside} onChange={e => updateWorkflow('buyside', e.target.checked)} className="mt-0.5" />
                      <span className="text-sm">
                        <span className="font-semibold text-purple-800">🛒 Buy-side engagement</span>
                        <span className="block text-xs text-gray-500 mt-0.5">Valuing this business for a buy-side client. Excluded from the pipeline and every metric; <strong>zero automated owner outreach</strong> (no reminder cadence, no as-of nags). Replaces the old "BS " name prefix. The full buy-side workflow is ROADMAP #8 — this flag is its first piece.</span>
                      </span>
                    </label>
                  </div>
                  {/* Mid-flight full→partial switches skip the activation modal's
                      planned-docs picker, and the portal falls back to ALL items
                      when nothing is planned (Thatcher 08-11) — say so right here. */}
                  {workflow.path === 'partial' && !(documentChecklist || []).some(d => d.planned) && (
                    <div className="p-2.5 bg-amber-50 border border-amber-300 rounded-lg text-xs text-amber-800">
                      <strong>⚠ No planned docs selected</strong> — the owner's portal is currently asking for <strong>ALL {(documentChecklist || []).length} documents</strong> (the full-valuation list). Tick <strong>Planned</strong> on the Documents checklist for the subset this partial actually needs — the portal trims to those as soon as you save.
                    </div>
                  )}
                  {workflow.path === 'partial' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Colleen Review Decision</label>
                      <select value={workflow.colleen_review_decision} onChange={e => updateWorkflow('colleen_review_decision', e.target.value)} className="w-full p-2 border rounded text-sm">
                        <option value="">— decision needed —</option>
                        <option value="quick_look">Quick-look — Colleen glances, then the Lead sets the meeting</option>
                        <option value="skip">Skip Colleen — straight to the Lead to set the meeting</option>
                      </select>
                      <p className="text-xs text-gray-400 mt-1">Partials are relationship-builders — minimal analysis. Either skip Colleen entirely or have her do a quick glance; either way the <strong>Lead</strong> sets the valuation meeting. Blank defaults to a Colleen quick-look.</p>
                    </div>
                  )}
                  {workflow.workflow_stage === 'upload_complete' && (
                    <div className="border-t pt-3">
                      <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg flex items-center justify-between gap-3">
                        <div className="text-sm text-emerald-900">
                          <span className="font-semibold">Docs are in — Konnie's data entry.</span> When every received document is entered, hand the deal on (Mark 09-28: marking a doc Complete no longer hands it off by itself).
                        </div>
                        <button type="button" disabled={isReadOnlyViewer}
                          onClick={() => {
                            const to = (workflow.path === 'partial' && workflow.colleen_review_decision === 'skip') ? 'analysis_complete' : 'data_entry_complete';
                            setHandoffCheck({ to, result: computeTieOut(buildDealData()) });
                          }}
                          className="flex-shrink-0 px-3 py-1.5 rounded text-sm font-semibold bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">
                          ✓ Data entered
                        </button>
                        {handoffCheck && (
                          <TieOutModal company={(dealProfile && dealProfile.companyName) || 'this deal'} target={handoffCheck.to === 'analysis_complete' ? 'the Lead' : 'Colleen'}
                            result={handoffCheck.result} onCancel={() => setHandoffCheck(null)} onConfirm={(res) => editorHandOff(handoffCheck.to, res)}
                            onMarkNotProvided={editorMarkNotProvided} />
                        )}
                      </div>
                    </div>
                  )}
                  {workflow.path === 'full_valuation' && workflow.workflow_stage === 'val_meeting_set' && (
                    <div className="border-t pt-3">
                      <div className="p-3 bg-indigo-50 border border-indigo-200 rounded-lg flex items-center justify-between gap-3">
                        <div className="text-sm text-indigo-800">
                          <span className="font-semibold">Valuation meeting done?</span> Record the outcome in one step — value &amp; commission, the owner's decision, and a review date if applicable.
                        </div>
                        <button type="button" onClick={openOutcomeModal}
                          className="flex-shrink-0 px-3 py-1.5 rounded text-sm font-semibold bg-indigo-600 text-white hover:bg-indigo-700">
                          📝 Record meeting outcome
                        </button>
                      </div>
                    </div>
                  )}
                  {DECISION_PANEL_STAGES.includes(workflow.workflow_stage) && (
                    <div className="border-t pt-3">
                      <label className="block text-sm font-medium text-gray-600 mb-1">Record Owner Decision</label>
                      <p className="text-xs text-gray-400 mb-2">Records the owner's decision and advances the stage as a consequence. <strong>Engagement can be recorded any time</strong> — an owner can sign before the valuation is finished (e.g. a returning or legacy client already heading to listing). Strategic Review and Follow-up Later become available once the valuation meeting is set, and all stay available if an inactive or closed project comes back and decides differently.</p>
                      <div className="flex flex-wrap gap-2">
                        {/* Re-engage path: a parked owner (follow-up scheduled,
                            inactive, or closed) comes back and wants to move
                            forward — pull them into the active Awaiting Decision
                            bucket the Lead watches for the signature. Clears the
                            stale follow-up date. (2026-06-22) */}
                        {['considering_followup', 'val_complete_inactive', 'val_complete_dead'].includes(workflow.workflow_stage) && (
                          <button type="button" onClick={() => recordOwnerDecision('awaiting_decision', 'Owner re-engaged — moving forward (engagement agreement requested)', { snooze_until: '', snooze_reason: '' })}
                            className="px-3 py-1.5 text-xs font-semibold rounded bg-blue-600 text-white hover:bg-blue-700">
                            ▶ Moving forward — Awaiting Decision
                          </button>
                        )}
                        {/* Engagement can be recorded any time on the active spine +
                            inactive states — an owner can sign before the valuation
                            is finished (e.g. a returning or legacy client already
                            heading to listing). The panel itself is gated to
                            DECISION_PANEL_STAGES, which never includes 'engaged'. */}
                        {['val_meeting_set', 'awaiting_decision', 'considering_followup'].includes(workflow.workflow_stage) && (
                          <button type="button" onClick={recordAgreementOut}
                            title="The owner asked for the engagement agreement and it went out — top of Awaiting Decision until it's signed."
                            className="px-3 py-1.5 text-xs font-medium rounded bg-emerald-50 text-emerald-800 border border-emerald-300 hover:bg-emerald-100">
                            📝 Agreement out
                          </button>
                        )}
                        <button type="button" onClick={() => recordOwnerDecision('engaged', 'Owner engaged — engagement agreement signed')}
                          className="px-3 py-1.5 text-xs font-medium rounded bg-green-100 text-green-700 hover:bg-green-200">
                          ✓ Engagement signed
                        </button>
                        {/* Strategic review + considering presuppose a delivered
                            valuation, so they stay gated to the post-meeting stages. */}
                        {OWNER_CHOICE_STAGES.includes(workflow.workflow_stage) && (
                          <>
                            <button type="button" onClick={() => { setStrategicReviewDateInput(''); setShowStrategicReviewModal(true); }}
                              className="px-3 py-1.5 text-xs font-medium rounded bg-teal-100 text-teal-700 hover:bg-teal-200">
                              Strategic review
                            </button>
                            {workflow.workflow_stage !== 'considering_followup' && (
                              <button type="button" onClick={() => { setFollowupDateInput(''); setShowFollowupModal(true); }}
                                className="px-3 py-1.5 text-xs font-medium rounded bg-amber-100 text-amber-800 hover:bg-amber-200">
                                Still deciding — follow up on a date
                              </button>
                            )}
                          </>
                        )}
                        {workflow.workflow_stage !== 'val_complete_inactive' && (
                          <button type="button" onClick={() => recordOwnerDecision('val_complete_inactive', 'Owner not ready — no review cadence set')}
                            className="px-3 py-1.5 text-xs font-medium rounded bg-gray-200 text-gray-600 hover:bg-gray-300">
                            Not ready (no cadence)
                          </button>
                        )}
                        {workflow.workflow_stage !== 'val_complete_dead' && (
                          <button type="button" onClick={() => recordOwnerDecision('val_complete_dead', 'Owner not selling')}
                            className="px-3 py-1.5 text-xs font-medium rounded bg-red-100 text-red-700 hover:bg-red-200">
                            Not for sale
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                  {(AUTO_SPINE.includes(workflow.workflow_stage) || workflow.workflow_stage === 'stalled_returned_to_am') && (
                    <div className="border-t pt-3">
                      <div className="flex items-start gap-2">
                        <input
                          type="checkbox"
                          checked={workflow.workflow_stage === 'stalled_returned_to_am'}
                          onChange={e => handleStalledToggle(e.target.checked)}
                          className="mt-0.5 w-4 h-4"
                          id="stalled-toggle"
                        />
                        <div className="flex-1">
                          <label htmlFor="stalled-toggle" className="text-sm font-medium text-gray-700 cursor-pointer">Returned to AM (stalled)</label>
                          <p className="text-xs text-gray-400 mb-2">Owner not moving forward; the AM handles the relationship until they re-engage. Drops off the active Pipeline. Uncheck to reactivate — the engine will re-derive the stage from current data.</p>
                          {workflow.workflow_stage !== 'stalled_returned_to_am' && (
                            <input
                              type="text"
                              value={stalledReasonInput}
                              onChange={e => setStalledReasonInput(e.target.value)}
                              placeholder="Reason (logged with the stage change; optional)"
                              className="w-full p-2 border rounded text-xs"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {!['awaiting_upload', 'upload_started', 'upload_complete'].includes(workflow.workflow_stage) && (
                    <div className="border-t pt-3">
                      <label className="block text-sm font-medium text-gray-600 mb-1">Revalue</label>
                      <p className="text-xs text-gray-400 mb-2">Re-engaging a previously-valued business — archives the current valuation and resets the project for a new cycle.</p>
                      <button type="button" onClick={() => { if (revalueBlockedByMissing()) return; setRevalueDateInput(''); setRevalueMode('now'); setShowRevalueModal(true); }}
                        className="px-3 py-1.5 text-xs font-medium rounded bg-amber-100 text-amber-800 hover:bg-amber-200">
                        ↻ Start Revalue
                      </button>
                    </div>
                  )}
                  {/* Resend the "review your answers" email (Secured Retail
                      08-31: the send modal opens only at the Start-Revalue
                      moment and died with the tab — the owner never got their
                      cue). Shown while the review flag is up; opens the same
                      staff-reviewed send modal. */}
                  {revalueReviewPending && (
                    <div className="border-t pt-3">
                      <button type="button" onClick={() => {
                        const w = workflowRef.current || {};
                        if (!w.owner_email) { window.alert('No owner email on the deal yet — set it above first.'); return; }
                        const portalUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/portal';
                        const cc = (Array.isArray(w.owner_additional) ? w.owner_additional : [])
                          .map(o => (o && o.email ? String(o.email).trim() : '')).filter(Boolean);
                        setPendingEmail({
                          heading: 'Send: review your answers',
                          to: w.owner_email.trim(), cc,
                          subject: 'Continuing your Vista Business Group valuation',
                          sender: leadGmailKey(w.lead) || 'konnie',
                          defaultBody: revalueReviewBodyText({ ownerFirstName: w.owner_first_name, companyName: (dealProfile && dealProfile.companyName) || '' }),
                          buildHtml: (b, signer) => buildRevalueReviewEmailHtml({ leadName: signer || w.lead, portalUrl, bodyText: b }),
                        });
                      }}
                        className="px-3 py-1.5 text-xs font-medium rounded bg-emerald-100 text-emerald-800 hover:bg-emerald-200"
                        title='A revalue is underway (review flag set). If the owner never received the "review your answers" email — e.g. the tab closed before it sent — this reopens the same reviewed send.'>
                        ✉ Send "review your answers" email
                      </button>
                    </div>
                  )}
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Lead</label>
                      <select value={workflow.lead} onChange={e => updateWorkflow('lead', e.target.value)} className="w-full p-2 border rounded text-sm">
                        <option value="">— not set —</option>
                        {STAFF_LEADS.map(n => <option key={n} value={n}>{n}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Account Manager</label>
                      <select value={workflow.account_manager} onChange={e => updateWorkflow('account_manager', e.target.value)} className="w-full p-2 border rounded text-sm">
                        <option value="">— not set —</option>
                        {/* Departed AM on an existing deal: keep the stored value
                            selectable so opening the picker can't silently drop it. */}
                        {workflow.account_manager && !STAFF_AMS.includes(workflow.account_manager) && (
                          <option value={workflow.account_manager}>{workflow.account_manager} (departed{AM_INHERITANCE[workflow.account_manager] ? ` — works from ${AM_INHERITANCE[workflow.account_manager]}'s plate` : ''})</option>
                        )}
                        {STAFF_AMS.map(n => <option key={n} value={n}>{n}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1" title="How seriously the owner is considering listing in the next 30 days. Mirrored from Zoho 'Likelihood'.">Likelihood %</label>
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.1"
                        value={workflow.likelihood_pct}
                        onChange={e => updateWorkflow('likelihood_pct', e.target.value)}
                        placeholder="0 – 100"
                        className="w-full p-2 border rounded text-sm"
                      />
                    </div>
                  </div>
                  {/* AI "where we are" (ROADMAP #4, 2026-08-06) — read-only,
                      regenerated by the server whenever a new transcript or
                      owner email lands. Labeled with its sources; never a
                      substitute for the activity log, just the glance. */}
                  {workflow.ai_status && (workflow.ai_status.last || workflow.ai_status.next || workflow.ai_status.waiting_on) && (
                    <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3 text-sm">
                      <div className="flex items-baseline gap-2 mb-1.5 flex-wrap">
                        <span className="font-bold text-indigo-800">🤖 Where we are</span>
                        <span className="text-[11px] text-indigo-400">
                          AI summary · {workflow.ai_status.generated_at ? new Date(workflow.ai_status.generated_at).toLocaleString() : ''}
                          {Array.isArray(workflow.ai_status.sources) && workflow.ai_status.sources.length > 0 && (
                            <> · from {workflow.ai_status.sources.filter(s => s.kind === 'meeting').length > 0 ? `${workflow.ai_status.sources.filter(s => s.kind === 'meeting').length} meeting${workflow.ai_status.sources.filter(s => s.kind === 'meeting').length === 1 ? '' : 's'}` : ''}{workflow.ai_status.sources.some(s => s.kind === 'meeting') && workflow.ai_status.sources.some(s => s.kind === 'email') ? ' + ' : ''}{workflow.ai_status.sources.filter(s => s.kind === 'email').length > 0 ? 'the email thread' : ''}</>
                          )}
                        </span>
                      </div>
                      {workflow.ai_status.last && <div className="text-gray-700"><span className="font-semibold text-gray-500 text-xs uppercase tracking-wide mr-1.5">Last</span>{workflow.ai_status.last}</div>}
                      {workflow.ai_status.next && <div className="text-gray-700 mt-0.5"><span className="font-semibold text-gray-500 text-xs uppercase tracking-wide mr-1.5">Next</span>{workflow.ai_status.next}</div>}
                      {workflow.ai_status.waiting_on && <div className="text-gray-700 mt-0.5"><span className="font-semibold text-gray-500 text-xs uppercase tracking-wide mr-1.5">Waiting on</span>{workflow.ai_status.waiting_on}</div>}
                    </div>
                  )}
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Discovery Meeting</label>
                      <input type="date" value={workflow.discovery_meeting_date} onChange={e => updateWorkflow('discovery_meeting_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">1st Meeting</label>
                      <input type="date" value={workflow.first_meeting_date} onChange={e => updateWorkflow('first_meeting_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1 text-amber-700">Upload Committal Date</label>
                      <input type="date" value={workflow.committed_upload_date} onChange={e => updateWorkflow('committed_upload_date', e.target.value)} className="w-full p-2 border border-amber-300 rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1 text-green-700">🎯 Owner's Target Valuation Date</label>
                      <input type="date" value={workflow.owner_target_valuation_date} onChange={e => updateWorkflow('owner_target_valuation_date', e.target.value)} className="w-full p-2 border border-green-300 rounded text-xs" />
                      <p className="text-[10px] text-gray-400 mt-0.5">When the owner said they'd like to be discussing their valuation. Set by them in the portal; schedule backward from it.</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Upload Started</label>
                      <input type="date" value={workflow.upload_started_date} onChange={e => updateWorkflow('upload_started_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Upload Complete</label>
                      <input type="date" value={workflow.upload_complete_date} onChange={e => updateWorkflow('upload_complete_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1 text-purple-700" title="The date the valuation was DELIVERED to the owner. Filling this moves the project to Awaiting Decision — it outranks every other stage signal. Leave blank until the valuation meeting has happened. Want the owner's hoped-for date instead? That's 🎯 Owner's Target Valuation Date, above.">✅ Valuation Delivered (date)</label>
                      <input type="date" value={workflow.valuation_date} onChange={e => updateWorkflow('valuation_date', e.target.value)} className="w-full p-2 border border-purple-300 rounded text-xs" />
                      <p className="text-[10px] text-gray-400 mt-0.5">Sets the stage to Awaiting Decision. Blank until delivered.</p>
                    </div>
                  </div>
                  {/* #3 remainder (2026-08-06): the two record dates Mark kept —
                      signature truth (backfilled from the stage log's engaged
                      click where known) and CIM finish (the build-time gap on
                      the Leads' 3-day CIM work). Plain records, no logic. */}
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1" title="When the listing agreement was actually signed. Backfilled from the stage log's engaged transition where known — correct it here if the signature date differs.">✍ Engagement Signed</label>
                      <input type="date" value={workflow.engagement_signed_date} onChange={e => updateWorkflow('engagement_signed_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1" title="When the CIM was finished (marketing start is DM's market date — this measures the build gap).">📘 CIM Complete</label>
                      <input type="date" value={workflow.cim_complete_date} onChange={e => updateWorkflow('cim_complete_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                  </div>
                  {/* AS-OF anchor (migration 031): the cycle's data anchor date.
                      Auto-advances monthly until the first upload; locks after.
                      Lag = how far behind this business closes its books. */}
                  {(() => {
                    const eff = asOfEffective(workflow);
                    return (
                      <div className="bg-indigo-50 border border-indigo-200 rounded p-2 mb-3">
                        <div className="flex flex-wrap items-center gap-3">
                          <div className="text-xs">
                            <span className="font-semibold text-indigo-800">📅 Collecting documents AS OF:</span>{' '}
                            <span className="font-bold text-gray-800">{asOfLabel(eff.date)}</span>{' '}
                            {eff.locked
                              ? <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded" title="Uploads have started — received documents are as-of this date, so it no longer auto-advances. Advancing now is a deliberate step (it re-requests the date-sensitive docs).">🔒 locked</span>
                              : <span className="text-[10px] font-bold uppercase px-1.5 py-0.5 bg-green-100 text-green-700 rounded" title="No uploads yet — this rolls forward automatically each month (respecting the books lag) until the first upload lands.">auto-advancing</span>}
                          </div>
                          <div className="flex items-center gap-1 text-xs">
                            <label className="text-gray-600">Books lag:</label>
                            <select value={workflow.books_lag_months || 1} onChange={e => updateWorkflow('books_lag_months', Number(e.target.value))} className="p-1 border rounded text-xs" title="How far behind this business closes its books. Most close within a week (1 month). A business 30-60 days behind gets 2-3 — the auto-advance and update reminders then only ask for months they can actually produce.">
                              {[1, 2, 3, 4, 5, 6].map(n => <option key={n} value={n}>{n} month{n > 1 ? 's' : ''}</option>)}
                            </select>
                          </div>
                          <div className="flex items-center gap-1 text-xs">
                            <label className="text-gray-600">Set date:</label>
                            <input type="date" value={workflow.as_of_date || ''} onChange={e => updateWorkflow('as_of_date', e.target.value)} className="p-1 border rounded text-xs" title="Manual anchor (month-end). Leave blank for fully automatic. Before uploads start, a date ahead of the auto target holds until the target passes it." />
                            {workflow.as_of_date && <button onClick={() => updateWorkflow('as_of_date', '')} className="text-gray-400 hover:text-gray-600" title="Clear — back to automatic">×</button>}
                          </div>
                        </div>
                        <p className="text-[10px] text-gray-500 mt-1">Requested document date ranges anchor to this date. It rolls forward monthly until the owner's first upload, then holds so the file stays internally consistent.</p>
                      </div>
                    );
                  })()}
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Next Meeting Date</label>
                      <input type="date" value={workflow.next_meeting_date} onChange={e => updateWorkflow('next_meeting_date', e.target.value)} className="w-full p-2 border rounded text-xs" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Next Meeting Type</label>
                      <input type="text" value={workflow.next_meeting_type} onChange={e => updateWorkflow('next_meeting_type', e.target.value)} placeholder="e.g., Valuation, Strategic Review" className="w-full p-2 border rounded text-xs" />
                    </div>
                  </div>
                  <div className="border-t pt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">👤 Owner contact <span className="text-gray-400 font-normal">— auto-fills the OIR / reminder recipient + greeting</span></label>
                    <div className="grid grid-cols-3 gap-3 mb-2">
                      <input
                        type="text"
                        value={workflow.owner_first_name}
                        onChange={e => updateWorkflow('owner_first_name', e.target.value)}
                        placeholder="First name (greeting)"
                        className="w-full p-2 border rounded text-xs"
                      />
                      <input
                        type="text"
                        value={workflow.owner_last_name}
                        onChange={e => updateWorkflow('owner_last_name', e.target.value)}
                        placeholder="Last name"
                        className="w-full p-2 border rounded text-xs"
                      />
                      <input
                        type="email"
                        value={workflow.owner_email}
                        onChange={e => updateWorkflow('owner_email', e.target.value)}
                        placeholder="Email (To)"
                        className="w-full p-2 border rounded text-xs"
                      />
                    </div>
                    <label className="block text-[11px] font-semibold text-gray-500 mb-1 mt-2">🔑 Portal access <span className="font-normal text-gray-400">— anyone else who should get into the portal (co-owner, CEO, etc.). Each signs in with their own email and is CC'd on portal emails. Accountants/attorneys you only correspond with go under Professional Contacts below instead.</span></label>
                    {(workflow.owner_additional || []).map((o, idx) => (
                      <div key={idx} className="grid grid-cols-12 gap-2 mb-2 items-center">
                        <input
                          type="text"
                          value={o.name || ''}
                          onChange={e => updateOwnerContact(idx, 'name', e.target.value)}
                          placeholder="Name"
                          className="col-span-5 w-full p-2 border rounded text-xs"
                        />
                        <input
                          type="email"
                          value={o.email || ''}
                          onChange={e => updateOwnerContact(idx, 'email', e.target.value)}
                          placeholder="Email"
                          className="col-span-6 w-full p-2 border rounded text-xs"
                        />
                        <button
                          type="button"
                          onClick={() => removeOwnerContact(idx)}
                          className="col-span-1 text-gray-400 hover:text-red-600 text-lg leading-none"
                          title="Remove"
                        >×</button>
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={addOwnerContact}
                      className="px-3 py-1.5 text-xs font-medium rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
                    >
                      + Add portal access
                    </button>
                    <div className="mt-3">
                      <label className="block text-[11px] font-semibold text-gray-500 mb-1">Primary contact role</label>
                      <select
                        value={dealProfile.ownerRole || 'Owner'}
                        onChange={e => setDealProfile(prev => ({ ...prev, ownerRole: e.target.value }))}
                        className="w-40 p-2 border rounded text-xs"
                      >
                        {['Owner', 'CEO', 'President', 'Partner', 'CFO', 'Other'].map(r => <option key={r} value={r}>{r}</option>)}
                      </select>
                    </div>
                  </div>
                  {/* Additional professional contacts (accountant, attorney, …).
                      Stored in the data blob; context for staff, not cadence. */}
                  <div className="border-t pt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">🧮 Professional contacts <span className="text-gray-400 font-normal">— accountant, attorney, etc. (reference only)</span></label>
                    {(dealProfile.professionalContacts || []).map((c, idx) => (
                      <div key={idx} className="grid grid-cols-12 gap-2 mb-2 items-center">
                        <input
                          type="text"
                          value={c.name || ''}
                          onChange={e => updateProfessionalContact(idx, 'name', e.target.value)}
                          placeholder="Name"
                          className="col-span-4 w-full p-2 border rounded text-xs"
                        />
                        <input
                          type="text"
                          value={c.role || ''}
                          onChange={e => updateProfessionalContact(idx, 'role', e.target.value)}
                          placeholder="Role (e.g. Accountant)"
                          className="col-span-3 w-full p-2 border rounded text-xs"
                        />
                        <input
                          type="email"
                          value={c.email || ''}
                          onChange={e => updateProfessionalContact(idx, 'email', e.target.value)}
                          placeholder="Email"
                          className="col-span-4 w-full p-2 border rounded text-xs"
                        />
                        <button
                          type="button"
                          onClick={() => removeProfessionalContact(idx)}
                          className="col-span-1 text-gray-400 hover:text-red-600 text-lg leading-none"
                          title="Remove this contact"
                        >×</button>
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={addProfessionalContact}
                      className="px-3 py-1.5 text-xs font-medium rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
                    >
                      + Add professional contact
                    </button>
                  </div>
                  {/* Manual release toggle — hidden during a revalue, where the
                      curate-and-release CTA below is the single release control
                      (avoids two buttons doing the same thing). Kept for the
                      non-revalue manual/fallback case. */}
                  {currentValuationId && (
                    <div className="border-t pt-3">
                      <button type="button" onClick={viewOwnerPortal}
                        className="px-3 py-1.5 text-xs font-semibold rounded bg-indigo-100 text-indigo-700 hover:bg-indigo-200">
                        👁 View owner portal
                      </button>
                      <button type="button" onClick={resendPortalLink} disabled={isReadOnlyViewer}
                        className="ml-2 px-3 py-1.5 text-xs font-semibold rounded bg-emerald-100 text-emerald-800 hover:bg-emerald-200 disabled:opacity-50">
                        ✉ Resend portal link
                      </button>
                      <p className="text-[11px] text-gray-400 mt-1">Opens the owner's portal exactly as they see it — read-only, in a new tab.</p>
                    </div>
                  )}
                  {!revalueDocsPending && (
                    <div className="border-t pt-3 space-y-2">
                      {!workflow.portal_docs_released && (
                        <div className="border border-emerald-300 bg-emerald-50 rounded-lg p-3">
                          <p className="text-xs text-emerald-900 mb-2">
                            After discovery, once the document set is decided, release the list to the owner's portal — this opens the documents there <strong>and emails the owner</strong> (from {workflow.lead || 'the Lead'}, fallback Konnie) that it's ready. You review &amp; edit the message before it sends.
                          </p>
                          <button
                            type="button"
                            onClick={releaseDocsToOwner}
                            disabled={isReadOnlyViewer}
                            className="px-3 py-1.5 text-xs font-semibold rounded bg-emerald-600 text-white hover:bg-emerald-700 disabled:bg-gray-300"
                          >
                            📨 Release document list to owner
                          </button>
                        </div>
                      )}
                      <label className="flex items-start gap-2 text-xs cursor-pointer">
                        <input
                          type="checkbox"
                          checked={!!workflow.portal_docs_released}
                          onChange={e => updateWorkflow('portal_docs_released', e.target.checked)}
                          className="mt-0.5"
                        />
                        <span className="text-gray-700">
                          <span className="font-semibold">🔓 Release document list to owner portal</span> — {workflow.portal_docs_released
                            ? 'released. Uncheck to hide the document list again.'
                            : 'or flip this to release WITHOUT emailing (the owner just sees the list next time they sign in).'} Until this is on, the owner's portal shows only the questions.
                        </span>
                      </label>
                    </div>
                  )}
                  {revalueDocsPending && (
                    <div className="border border-amber-300 bg-amber-50 rounded-lg p-3">
                      <div className="text-xs font-bold uppercase tracking-wide text-amber-800 mb-1">📋 Revalue — review docs required</div>
                      <p className="text-xs text-amber-900 mb-2">
                        This project just started a revalue. Review the file, check the boxes for the documents this cycle needs (on the Documents tab), then release the curated list — that opens the documents in the owner's portal and emails them (from {workflow.lead || 'the Lead'}) that it's ready.
                      </p>
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={releaseDocsToOwner}
                          disabled={revalueDocsReleasing || isReadOnlyViewer}
                          className="px-3 py-1.5 text-xs font-semibold rounded bg-amber-600 text-white hover:bg-amber-700 disabled:bg-gray-300"
                        >
                          {revalueDocsReleasing ? 'Releasing…' : '📨 Release document list to owner'}
                        </button>
                        <button
                          type="button"
                          onClick={skipRevalueCuration}
                          disabled={isReadOnlyViewer}
                          className="px-2 py-1.5 text-[11px] font-semibold rounded border border-amber-300 text-amber-700 hover:bg-amber-100 disabled:text-gray-400"
                          title="This cycle doesn't need a curated portal release — clear the gate and bring back the normal release controls."
                        >
                          Not needed this cycle
                        </button>
                      </div>
                    </div>
                  )}
                  <FirefliesNotesPanel
                    ownerEmail={workflow.owner_email}
                    additionalEmails={(workflow.owner_additional || []).map(o => o && o.email).filter(Boolean)}
                  />
                  <div className="border-t pt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">Snooze Until <span className="text-gray-400 font-normal">— owner unavailable; pauses the red flag, never the clock</span></label>
                    <div className="grid grid-cols-3 gap-3">
                      <input type="date" value={workflow.snooze_until} onChange={e => updateWorkflow('snooze_until', e.target.value)} className="w-full p-2 border rounded text-xs" />
                      <input type="text" value={workflow.snooze_reason} onChange={e => updateWorkflow('snooze_reason', e.target.value)} placeholder="Reason (e.g., owner on vacation)" className="col-span-2 w-full p-2 border rounded text-xs" />
                    </div>
                  </div>
                  <div className="border-t pt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">🔔 Reminders for yourself <span className="text-gray-400 font-normal">— pops up on your My Work view when due</span></label>
                    <div className="grid grid-cols-3 gap-3 mb-2">
                      <input
                        type="date"
                        value={newReminderDate}
                        onChange={e => setNewReminderDate(e.target.value)}
                        className="w-full p-2 border rounded text-xs"
                      />
                      <input
                        type="text"
                        value={newReminderNote}
                        onChange={e => setNewReminderNote(e.target.value)}
                        placeholder="What to do (e.g., follow up on engagement docs)"
                        className="col-span-2 w-full p-2 border rounded text-xs"
                      />
                    </div>
                    <button
                      type="button"
                      onClick={addProjectReminder}
                      disabled={!newReminderDate || !currentValuationId || !userEmail}
                      className="px-3 py-1.5 text-xs font-medium rounded bg-purple-100 text-purple-700 hover:bg-purple-200 disabled:opacity-40"
                    >
                      + Set reminder
                    </button>
                    {projectReminders.length > 0 && (
                      <div className="mt-3 space-y-1">
                        {projectReminders.map(r => (
                          <div key={r.id} className="flex items-center gap-2 text-xs bg-purple-50 border border-purple-200 rounded px-2 py-1">
                            <span className="font-medium text-purple-800 whitespace-nowrap">
                              {new Date(r.remind_at + 'T00:00:00').toLocaleDateString()}
                            </span>
                            <span className="flex-1 text-gray-700">{r.note || <span className="italic text-gray-400">no note</span>}</span>
                            <button
                              type="button"
                              onClick={() => dismissProjectReminder(r.id)}
                              className="px-2 py-0.5 text-xs font-medium rounded bg-green-100 text-green-700 hover:bg-green-200"
                            >
                              ✓ Done
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              )}

            </div>

            {/* Deal Notes. For read-only viewers (AMs) the box is locked with
                the 🗒 vehicle offered in its place — before 08-27 it accepted
                typing that silently never persisted (Adam's Sierra Mountain
                call notes went into it and vanished). */}
            <div className="bg-white p-4 rounded-lg border">
              <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
                <h3 className="font-bold text-gray-800">📝 Deal Notes {isReadOnlyViewer
                  ? <span className="text-[11px] font-normal text-amber-700">— locked in the read-only view (typing here wouldn't save). Use <b>🗒 Notes → ＋ Add a note</b> instead →</span>
                  : <span className="text-[11px] font-normal text-gray-400">— the running summary; saves automatically with the deal (watch for ✓ Auto-saved in the top bar). A call or a conversation goes in <b>🗒 Notes → ＋ Add a note</b> — dated, signed, and it rides the deal's cards.</span>}</h3>
                {/* 🗒 Notes for EVERYONE (Colleen 09-23, DDS Tech Pro: "how do I
                    add manual meeting notes?" — James called, she chatted, and
                    the only dated/attributed note door on the deal was gated to
                    read-only viewers since 08-27; her playbook already told
                    her to use 🗒 Notes, which she could not see here). */}
                {currentValuationId && (
                  <CardToolbar valuationId={currentValuationId} companyName={(dealProfile && dealProfile.companyName) || valuationName || 'this deal'} actor={viewerStaffName} />
                )}
              </div>
              <textarea
                value={dealProfile.dealNotes}
                onChange={e => { if (!isReadOnlyViewer) setDealProfile({...dealProfile, dealNotes: e.target.value}); }}
                readOnly={isReadOnlyViewer}
                title={isReadOnlyViewer ? "Read-only view — this scratchpad belongs to the deal's editors and nothing typed here saves. Your vehicle is 🗒 Notes → ＋ Add a note (saves to the permanent activity log)." : undefined}
                placeholder="Notes from meetings, key observations, items to follow up on..."
                className={`w-full p-3 border rounded text-sm h-32 ${isReadOnlyViewer ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''}`}
              />
            </div>

            {/* ========== CIM DATA COLLECTION ========== */}
            <div className="mt-6">
              <div className="flex items-center justify-between mb-3 gap-3">
                <h2 className="text-lg font-bold flex items-center gap-2">📋 CIM Data Collection <span className="text-sm font-normal text-gray-500">— Additional details for CIM export</span></h2>
                <div className="flex items-center gap-3">
                  {(() => {
                    const v = dealProfile.vistaId || '';
                    const showInvalid = v.length > 0 && !/^\d{6}$/.test(v);
                    return (
                      <div className="flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Vista ID</label>
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          value={v}
                          onChange={e => setDealProfile({ ...dealProfile, vistaId: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                          placeholder="6 digits"
                          title="Zoho prospect ID — required before CIM export"
                          className={`w-24 p-1.5 border rounded text-sm font-mono ${showInvalid ? 'border-red-400 bg-red-50' : 'border-gray-300'}`}
                        />
                        <DataRoomLink vistaId={v} />
                      </div>
                    );
                  })()}
                  <button
                    onClick={() => {
                      // Pre-flight: surface the Vista ID requirement the
                      // moment the modal opens, not only after the user
                      // clicks Generate. (validateCIMData itself lives
                      // inside the modal IIFE so we can't call it here.)
                      const vid = (dealProfile.vistaId || '').trim();
                      setCimBlockingErrors(
                        /^\d{6}$/.test(vid)
                          ? []
                          : ['Vista ID is required (6 digits from Zoho). Enter it next to the Export for CIM button on the page behind this modal.']
                      );
                      setCimValidationWarnings([]);
                      setShowCIMExportModal(true);
                    }}
                    className="px-3 py-1.5 rounded font-medium text-sm bg-green-600 text-white hover:bg-green-700 flex items-center gap-1.5 flex-shrink-0"
                    title="Export data for CIM (Confidential Information Memorandum)"
                  >
                    <FileText className="w-4 h-4" /> Export for CIM
                  </button>
                  {/* Open the CIM generator ON THIS ORIGIN — the generator reads
                      the staff session from same-origin localStorage, so a link
                      here can never hit the wrong-domain sign-in gotcha the way a
                      typed/bookmarked URL can. (CIM to-do #5, Mark 2026-07-14) */}
                  <a
                    href="/cim-generator"
                    target="_blank"
                    rel="noopener"
                    className="px-3 py-1.5 rounded font-medium text-sm border border-green-600 text-green-700 hover:bg-green-50 flex items-center gap-1.5 flex-shrink-0"
                    title="Open the CIM generator (drafts the memorandum from the export). Opens on this site, so your current sign-in just works."
                  >
                    📄 CIM Generator
                  </a>
                </div>
              </div>
              
              {/* Technology Stack — Phase-3 fold: renders only when the deal has
                  data or the panel is enabled (MSP preset / Show action). Data
                  home + export + teaser rules unchanged. */}
              {(Object.values(cimTechStack).some(v => v) || cimVendors.some(v => (v.technology || '').trim()) || cimTypedPanels.includes('techStack')) && (
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimTech: !prev.cimTech}))}>
                  <span>{expandedSections.cimTech ? '▼' : '▶'}</span>
                  💻 Technology Stack
                  {Object.values(cimTechStack).some(v => v) && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">Data entered</span>}
                  {!(Object.values(cimTechStack).some(v => v) || cimVendors.some(v => (v.technology || '').trim())) && cimTypedPanels.includes('techStack') &&
                    <button onClick={e => { e.stopPropagation(); setCimTypedPanels(prev => prev.filter(k => k !== 'techStack')); }} className="text-[10px] font-normal text-gray-400 hover:text-gray-600 ml-auto" title="Hide this section for this deal (no data entered; re-enable via the MSP preset or the Show link below)">hide</button>}
                </h3>
                {expandedSections.cimTech && (
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { key: 'rmm', label: 'RMM Tool', placeholder: 'e.g., NinjaRMM, ConnectWise Automate, Datto RMM' },
                      { key: 'psa', label: 'PSA Tool', placeholder: 'e.g., ConnectWise Manage, HaloPSA, Autotask' },
                      { key: 'security', label: 'Security Stack (EDR, Email, DNS)', placeholder: 'e.g., SentinelOne, Proofpoint, DNSFilter' },
                      { key: 'backup', label: 'Backup Solution', placeholder: 'e.g., Datto SIRIS, Veeam, Acronis' },
                      { key: 'cloud', label: 'Cloud Platforms', placeholder: 'e.g., Microsoft 365, Azure, Google Workspace' },
                      { key: 'microsoftTier', label: 'Microsoft Partner Tier', placeholder: 'e.g., Solutions Partner, Gold, Silver' },
                      { key: 'vendorPartners', label: 'Vendor Partner Relationships', placeholder: 'e.g., Cisco Select, Dell Preferred' },
                      { key: 'keySoftware', label: 'Key Software Subscriptions (COGS)', placeholder: 'Tools billed through to clients' }
                    ].map(field => (
                      <div key={field.key}>
                        <label className="block text-xs font-medium text-gray-600 mb-1">{field.label}</label>
                        <input type="text" value={cimTechStack[field.key] || ''} onChange={e => setCimTechStack({...cimTechStack, [field.key]: e.target.value})} placeholder={field.placeholder} className="w-full p-2 border rounded text-sm" />
                      </div>
                    ))}
                  </div>
                )}
                {expandedSections.cimTech && (
                  <div className="mt-4 border-t pt-3">
                    <label className="block text-xs font-semibold text-gray-700 mb-1">Vendor / Technology table <span className="font-normal text-gray-500">— per-vendor detail from the "Needed" form; drives the CIM's Technology Stack section. Term + Monthly Cost show in the CIM, never the teaser.</span></label>
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs border-collapse mb-2">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-1.5 border text-left">Technology</th>
                            <th className="p-1.5 border text-left">Use</th>
                            <th className="p-1.5 border text-left w-40">Contract Term</th>
                            <th className="p-1.5 border text-left w-28">Monthly Cost</th>
                            <th className="p-1.5 border w-6">×</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cimVendors.map((v, idx) => (
                            <tr key={v.id || idx}>
                              <td className="p-0.5 border"><input type="text" value={v.technology || ''} onChange={e => setCimVendors(prev => prev.map((r, i) => i === idx ? {...r, technology: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="e.g., Datto RMM" /></td>
                              <td className="p-0.5 border"><input type="text" value={v.use || ''} onChange={e => setCimVendors(prev => prev.map((r, i) => i === idx ? {...r, use: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="e.g., RMM" /></td>
                              <td className="p-0.5 border"><input type="text" value={v.term || ''} onChange={e => setCimVendors(prev => prev.map((r, i) => i === idx ? {...r, term: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="e.g., to 04/2027, or Month-to-month" /></td>
                              <td className="p-0.5 border"><input type="text" value={v.monthlyCost || ''} onChange={e => setCimVendors(prev => prev.map((r, i) => i === idx ? {...r, monthlyCost: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="e.g. 1800  (or a range: 1200-1600)" /></td>
                              <td className="p-0.5 border text-center"><button onClick={() => setCimVendors(prev => prev.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700">×</button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button onClick={() => setCimVendors(prev => [...prev, { id: Date.now(), technology: '', use: '', term: '', monthlyCost: '' }])} className="px-3 py-1.5 bg-blue-600 text-white rounded text-xs hover:bg-blue-700">+ Add vendor</button>
                    <p className="text-[11px] text-gray-400 mt-1">Monthly Cost: just the number is fine (the CIM rounds to the nearest dollar and adds "$1,755" formatting for you — a stray $ or cents is handled). A range like "1200-1600" is left as-is. When this table has rows it replaces the category fields above in the CIM; leave it empty to use those instead.</p>
                  </div>
                )}
              </div>
              )}

              {/* Contract Snapshot (D6 "rate-card" feed) — Phase-3 fold: same
                  visibility rule as Technology Stack above. */}
              {(Object.values(cimContractTerms).some(v => v) || cimTypedPanels.includes('contractSnapshot')) && (
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimContract: !prev.cimContract}))}>
                  <span>{expandedSections.cimContract ? '▼' : '▶'}</span>
                  📄 Contract Snapshot
                  {Object.values(cimContractTerms).some(v => v) && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">Data entered</span>}
                  {!Object.values(cimContractTerms).some(v => v) && cimTypedPanels.includes('contractSnapshot') &&
                    <button onClick={e => { e.stopPropagation(); setCimTypedPanels(prev => prev.filter(k => k !== 'contractSnapshot')); }} className="text-[10px] font-normal text-gray-400 hover:text-gray-600 ml-auto" title="Hide this section for this deal (no data entered; re-enable via the MSP preset or the Show link below)">hide</button>}
                </h3>
                {expandedSections.cimContract && (
                  <div>
                    <p className="text-[11px] text-gray-500 mb-2">Master service-agreement terms buyers ask about. Renders as a table in the CIM's Pricing section (never the teaser). Leave blank for non-contract deals.</p>
                    <div className="grid grid-cols-2 gap-3">
                      {[
                        { key: 'term', label: 'Contract Term', placeholder: 'e.g., Annual' },
                        { key: 'renewal', label: 'Renewal', placeholder: 'e.g., Automatic; 60-day notice to non-renew' },
                        { key: 'termConvenience', label: 'Termination for Convenience', placeholder: 'e.g., Not allowed — pay remaining balance' },
                        { key: 'termCause', label: 'Termination for Cause', placeholder: 'e.g., Immediate if material breach not cured in 30 days' },
                        { key: 'pricing', label: 'Pricing', placeholder: 'e.g., Per user — $X–$Y range' },
                        { key: 'priceIncrease', label: 'Price Increase', placeholder: 'e.g., 3% annually, built in' },
                        { key: 'assignability', label: 'Assignability', placeholder: 'e.g., Yes — without consent' },
                        { key: 'overageFees', label: 'Auto-scaling / Overage Fees', placeholder: 'e.g., $X per additional user or endpoint' },
                        { key: 'usageLimits', label: 'Usage Limits', placeholder: 'e.g., Unlimited' },
                        { key: 'paymentTerms', label: 'Payment Terms', placeholder: 'e.g., Net 30' },
                        { key: 'similarContracts', label: 'All clients on similar contracts?', placeholder: 'e.g., Yes — standard MSA' }
                      ].map(field => (
                        <div key={field.key}>
                          <label className="block text-xs font-medium text-gray-600 mb-1">{field.label}</label>
                          <input type="text" value={cimContractTerms[field.key] || ''} onChange={e => setCimContractTerms({...cimContractTerms, [field.key]: e.target.value})} placeholder={field.placeholder} className="w-full p-2 border rounded text-sm" />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              )}

              {/* Portal CIM-prep form responses (migration 034): the owner
                  filled Tech Stack / Facility in the portal — review & accept
                  merges them into the panels above. */}
              {ownerCimPrep && (
                <div className="mb-4 p-3 rounded border border-green-300 bg-green-50">
                  <div className="text-sm font-semibold text-green-800 mb-2">📥 Owner-submitted CIM prep from the portal</div>
                  {(ownerCimPrep.techRows.length > 0 || ownerCimPrep.techDone) && (
                    <div className="mb-2">
                      <div className="flex items-center gap-2 flex-wrap mb-1">
                        <span className="text-xs font-semibold text-gray-700">💻 Technology Stack — {ownerCimPrep.techRows.length} vendor row{ownerCimPrep.techRows.length === 1 ? '' : 's'}{ownerCimPrep.techDone ? ' (owner marked finished)' : ' (in progress)'}</span>
                        {ownerCimPrep.techRows.length > 0 ? (
                          <button onClick={acceptOwnerTechStack} className="px-2 py-0.5 text-xs font-semibold rounded bg-green-600 text-white hover:bg-green-700" title="Merge into the Technology Stack vendor table above (matching rows update, new rows append)">✓ Accept into the vendor table</button>
                        ) : (
                          <button onClick={acceptOwnerTechStack} className="px-2 py-0.5 text-xs font-semibold rounded bg-amber-500 text-white hover:bg-amber-600" title="The owner marked the form complete without entering rows — clears the review flag.">Acknowledge — nothing to apply</button>
                        )}
                      </div>
                      <table className="w-full text-xs border-collapse bg-white">
                        <thead><tr className="bg-green-100"><th className="text-left p-1 border">Technology</th><th className="text-left p-1 border">Use</th><th className="text-left p-1 border">Term</th><th className="text-left p-1 border">Monthly Cost</th></tr></thead>
                        <tbody>
                          {ownerCimPrep.techRows.map(r => (
                            <tr key={r.key}><td className="p-1 border">{r.technology || ''}</td><td className="p-1 border">{r.use || ''}</td><td className="p-1 border">{r.term || ''}</td><td className="p-1 border">{r.monthlyCost || ''}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {(ownerCimPrep.facFields.length > 0 || ownerCimPrep.facDone) && (
                    <div>
                      <div className="flex items-center gap-2 flex-wrap mb-1">
                        <span className="text-xs font-semibold text-gray-700">🏢 Facility — {ownerCimPrep.facFields.length} field{ownerCimPrep.facFields.length === 1 ? '' : 's'}{ownerCimPrep.facDone ? ' (owner marked finished)' : ' (in progress)'}</span>
                        {ownerCimPrep.facFields.length > 0 ? (
                          <button onClick={acceptOwnerFacility} className="px-2 py-0.5 text-xs font-semibold rounded bg-green-600 text-white hover:bg-green-700" title="Apply into the Facility panel above (address, sqft, lease specifics, remote-capable)">✓ Accept into Facility</button>
                        ) : (
                          <button onClick={acceptOwnerFacility} className="px-2 py-0.5 text-xs font-semibold rounded bg-amber-500 text-white hover:bg-amber-600" title="The owner marked the form complete without entering fields — clears the review flag.">Acknowledge — nothing to apply</button>
                        )}
                      </div>
                      <div className="text-xs text-gray-700 bg-white border rounded p-2">
                        {ownerCimPrep.facFields.map(f => (
                          <div key={f}><span className="font-semibold">{f}:</span> {String(ownerCimPrep.fac[f])}</div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Phase-3 fold: hint row for hidden typed panels — one line, one
                  click to enable; the MSP preset in Custom Data Groups does the
                  same (plus client-attr columns when that demotion lands). */}
              {(() => {
                const hidden = [
                  !(Object.values(cimTechStack).some(v => v) || cimVendors.some(v => (v.technology || '').trim()) || cimTypedPanels.includes('techStack')) && 'techStack',
                  !(Object.values(cimContractTerms).some(v => v) || cimTypedPanels.includes('contractSnapshot')) && 'contractSnapshot',
                ].filter(Boolean);
                if (!hidden.length) return null;
                return (
                  <div className="mb-4 px-4 py-2 rounded-lg border border-dashed border-gray-300 text-xs text-gray-500 flex items-center gap-2">
                    <span>
                      Hidden structured sections (MSP-shaped): {hidden.map(k => k === 'techStack' ? '💻 Technology Stack' : '📄 Contract Snapshot').join(' · ')} —
                      load the <strong>MSP / IT Services</strong> preset below, or
                    </span>
                    <button onClick={() => setCimTypedPanels(prev => Array.from(new Set([...prev, ...hidden])))} className="px-2 py-0.5 rounded border border-gray-300 text-gray-600 hover:text-gray-800 font-semibold">Show</button>
                  </div>
                );
              })()}

              {/* Employees */}
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimEmp: !prev.cimEmp}))}>
                  <span>{expandedSections.cimEmp ? '▼' : '▶'}</span>
                  👥 Employee Roster
                  {cimEmployees.length > 0 && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">{cimEmployees.length} employees</span>}
                </h3>
                {expandedSections.cimEmp && (
                  <div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs border-collapse mb-2">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-1.5 border text-left">Name/Role</th>
                            <th className="p-1.5 border text-left">Title</th>
                            <th className="p-1.5 border text-center w-12" title="Mark management-team members. Drives the CIM's management-focus disclosure mode.">Mgmt</th>
                            <th className="p-1.5 border text-center w-14">FT/PT</th>
                            <th className="p-1.5 border text-center w-20">Start Date</th>
                            <th className="p-1.5 border text-left">Role Description</th>
                            <th className="p-1.5 border text-left w-24">Certs</th>
                            <th className="p-1.5 border text-center w-14">W2/1099</th>
                            <th className="p-1.5 border text-center w-16">Comp Type</th>
                            <th className="p-1.5 border text-right w-20">Base Salary</th>
                            <th className="p-1.5 border text-left w-20">Commission</th>
                            <th className="p-1.5 border w-6">×</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cimEmployees.map((emp, idx) => (
                            <tr key={emp.id || idx}>
                              <td className="p-0.5 border"><input type="text" value={emp.name || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, name: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="Name" /></td>
                              <td className="p-0.5 border"><input type="text" value={emp.title || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, title: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="Title" /></td>
                              <td className="p-0.5 border text-center"><input type="checkbox" checked={!!emp.isManagement} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, isManagement: e.target.checked} : r))} /></td>
                              <td className="p-0.5 border"><select value={emp.ftpt || 'FT'} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, ftpt: e.target.value} : r))} className="w-full p-1 text-xs border-0"><option value="FT">FT</option><option value="PT">PT</option></select></td>
                              <td className="p-0.5 border"><input type="text" value={emp.startDate || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, startDate: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="MM/YYYY" /></td>
                              <td className="p-0.5 border"><input type="text" value={emp.roleDescription || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, roleDescription: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="Brief role description" /></td>
                              <td className="p-0.5 border"><input type="text" value={emp.certifications || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, certifications: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="Certs" /></td>
                              <td className="p-0.5 border"><select value={emp.w2or1099 || 'W2'} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, w2or1099: e.target.value} : r))} className="w-full p-1 text-xs border-0"><option value="W2">W2</option><option value="1099">1099</option></select></td>
                              <td className="p-0.5 border"><select value={emp.compType || 'Salary'} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, compType: e.target.value} : r))} className="w-full p-1 text-xs border-0"><option value="Salary">Salary</option><option value="Hourly">Hourly</option><option value="Commission">Commission</option></select></td>
                              <td className="p-0.5 border"><input type="number" value={emp.baseSalary || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, baseSalary: parseFloat(e.target.value) || 0} : r))} className="w-full p-1 text-xs border-0 text-right" placeholder="$0" /></td>
                              <td className="p-0.5 border"><input type="text" value={emp.commission || ''} onChange={e => setCimEmployees(prev => prev.map((r, i) => i === idx ? {...r, commission: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="Structure" /></td>
                              <td className="p-0.5 border text-center"><button onClick={() => setCimEmployees(prev => prev.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700">×</button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button onClick={() => setCimEmployees(prev => [...prev, { id: Date.now(), name: '', title: '', isManagement: false, ftpt: 'FT', startDate: '', roleDescription: '', certifications: '', w2or1099: 'W2', compType: 'Salary', baseSalary: 0, commission: '', recentChanges: '' }])} className="px-3 py-1.5 bg-blue-600 text-white rounded text-xs hover:bg-blue-700">+ Add Employee</button>
                    <div className="mt-3 pt-3 border-t space-y-3">
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1">CIM disclosure mode</label>
                        <select value={cimEmpDisclosure} onChange={e => setCimEmpDisclosure(e.target.value)} className="p-2 border rounded text-sm">
                          <option value="full">Full roster — list every role (smaller teams)</option>
                          <option value="management">Management focus — management team + summarize the rest (larger companies)</option>
                        </select>
                        <p className="text-[11px] text-gray-400 mt-1">Management focus shows only the roles marked <b>Mgmt</b> above, plus a "+N additional staff" line. Case-by-case — you pick per deal. No names or individual pay appear in the CIM either way.</p>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1">Compensation ranges <span className="font-normal text-gray-500">(rounded; no individual pay shows in the CIM)</span></label>
                        <div className="grid grid-cols-2 gap-3">
                          <div className="flex items-center gap-1 text-xs"><span className="w-24 text-gray-600">Management</span>
                            <input type="number" value={cimEmpComp.mgmtLow || ''} onChange={e => setCimEmpComp({...cimEmpComp, mgmtLow: e.target.value})} placeholder="low" className="w-24 p-1 border rounded" />
                            <span className="text-gray-400">to</span>
                            <input type="number" value={cimEmpComp.mgmtHigh || ''} onChange={e => setCimEmpComp({...cimEmpComp, mgmtHigh: e.target.value})} placeholder="high" className="w-24 p-1 border rounded" /></div>
                          <div className="flex items-center gap-1 text-xs"><span className="w-24 text-gray-600">Non-mgmt</span>
                            <input type="number" value={cimEmpComp.nonMgmtLow || ''} onChange={e => setCimEmpComp({...cimEmpComp, nonMgmtLow: e.target.value})} placeholder="low" className="w-24 p-1 border rounded" />
                            <span className="text-gray-400">to</span>
                            <input type="number" value={cimEmpComp.nonMgmtHigh || ''} onChange={e => setCimEmpComp({...cimEmpComp, nonMgmtHigh: e.target.value})} placeholder="high" className="w-24 p-1 border rounded" /></div>
                        </div>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1">Profit-sharing / bonus programs</label>
                        <textarea value={cimEmpIncentives} onChange={e => setCimEmpIncentives(e.target.value)} placeholder="Describe any profit-sharing, bonus, or incentive programs among the staff. Leave blank if none." className="w-full p-2 border rounded text-sm" style={{minHeight:'40px'}} />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* FF&E / Inventory */}
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimFFE: !prev.cimFFE}))}>
                  <span>{expandedSections.cimFFE ? '▼' : '▶'}</span>
                  🪑 FF&E / Inventory
                  {(cimFFE || []).some(f => (f.item || '').trim()) && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">{cimFFE.filter(f => (f.item || '').trim()).length} items</span>}
                </h3>
                {expandedSections.cimFFE && (
                  <div>
                    <p className="text-[11px] text-gray-500 mb-2">Furniture, fixtures & equipment included in the sale. For asset-heavy deals, Year and Hours/Usage drive the buyer's cap-ex. No individual value shows in the CIM.</p>
                    <div className="mb-2 bg-blue-50 border border-blue-200 rounded p-2">
                      <label className="block text-[11px] font-semibold text-gray-700 mb-1">📋 Paste FF&E from any source (spreadsheet, Word, email, depreciation schedule) — AI structures it into the table below</label>
                      <textarea value={cimFFEImport} onChange={e => setCimFFEImport(e.target.value)} placeholder="Paste the owner's equipment list / depreciation schedule here…" className="w-full p-2 border rounded text-xs" style={{minHeight:'44px'}} />
                      <button onClick={importFFEWithAI} disabled={cimFFEImporting || !cimFFEImport.trim()} className="mt-1 px-3 py-1.5 bg-green-600 text-white rounded text-xs hover:bg-green-700 disabled:bg-gray-300">{cimFFEImporting ? 'Structuring…' : '✨ Structure with AI'}</button>
                      <span className="text-[11px] text-gray-500 ml-2">Appends to the table; then curate (uncheck personal items).</span>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs border-collapse mb-2">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-1.5 border text-left">Item / Description</th>
                            <th className="p-1.5 border text-left w-32">Category</th>
                            <th className="p-1.5 border text-center w-16">Year</th>
                            <th className="p-1.5 border text-center w-20">Hours/Usage</th>
                            <th className="p-1.5 border text-center w-12" title="Uncheck to exclude a personal item (e.g. an owner's vehicle) from the CIM.">Incl.</th>
                            <th className="p-1.5 border text-left">Notes</th>
                            <th className="p-1.5 border w-6">×</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cimFFE.map((f, idx) => (
                            <tr key={f.id || idx}>
                              <td className="p-0.5 border"><input type="text" value={f.item || ''} onChange={e => setCimFFE(prev => prev.map((r, i) => i === idx ? {...r, item: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="e.g., 2023 Service van" /></td>
                              <td className="p-0.5 border"><input type="text" value={f.category || ''} onChange={e => setCimFFE(prev => prev.map((r, i) => i === idx ? {...r, category: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="Vehicle / Machinery / Office…" /></td>
                              <td className="p-0.5 border"><input type="text" value={f.year || ''} onChange={e => setCimFFE(prev => prev.map((r, i) => i === idx ? {...r, year: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="2023" /></td>
                              <td className="p-0.5 border"><input type="text" value={f.hours || ''} onChange={e => setCimFFE(prev => prev.map((r, i) => i === idx ? {...r, hours: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="e.g., 4,200 hrs" /></td>
                              <td className="p-0.5 border text-center"><input type="checkbox" checked={f.include !== false} onChange={e => setCimFFE(prev => prev.map((r, i) => i === idx ? {...r, include: e.target.checked} : r))} /></td>
                              <td className="p-0.5 border"><input type="text" value={f.notes || ''} onChange={e => setCimFFE(prev => prev.map((r, i) => i === idx ? {...r, notes: e.target.value} : r))} className="w-full p-1 text-xs border-0" placeholder="condition, financed, etc." /></td>
                              <td className="p-0.5 border text-center"><button onClick={() => setCimFFE(prev => prev.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700">×</button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button onClick={() => setCimFFE(prev => [...prev, { id: Date.now(), item: '', category: '', year: '', hours: '', include: true, notes: '' }])} className="px-3 py-1.5 bg-blue-600 text-white rounded text-xs hover:bg-blue-700">+ Add item</button>
                    <div className="mt-3 pt-3 border-t">
                      <label className="block text-xs font-semibold text-gray-700 mb-1">Where does the detail go in the CIM?</label>
                      <select value={cimFFEDisclosure} onChange={e => setCimFFEDisclosure(e.target.value)} className="p-2 border rounded text-sm">
                        <option value="cim">In the CIM — list the items (short lists, e.g. MSPs)</option>
                        <option value="addendum">Addendum — CIM shows a summary; full schedule to the data room (long asset-heavy lists)</option>
                      </select>
                      <p className="text-[11px] text-gray-400 mt-1">Addendum mode: the CIM shows a category summary + a pointer to the data room; generate the itemized schedule with "⬇ Equipment Schedule" in the CIM generator.</p>
                    </div>
                  </div>
                )}
              </div>

              {/* Facility */}
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimFac: !prev.cimFac}))}>
                  <span>{expandedSections.cimFac ? '▼' : '▶'}</span>
                  🏠 Facility
                  {cimFacility.address && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">Data entered</span>}
                </h3>
                {expandedSections.cimFac && (
                  <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-2">
                      <label className="block text-xs font-medium text-gray-600 mb-1">Physical Address</label>
                      <input type="text" value={cimFacility.address || ''} onChange={e => setCimFacility({...cimFacility, address: e.target.value})} placeholder="Full address" className="w-full p-2 border rounded text-sm" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Owned or Leased</label>
                      <select value={cimFacility.ownedOrLeased || ''} onChange={e => setCimFacility({...cimFacility, ownedOrLeased: e.target.value})} className="w-full p-2 border rounded text-sm">
                        <option value="">Select...</option><option value="Owned">Owned</option><option value="Leased">Leased</option><option value="Virtual/Remote">Virtual/Remote</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Square Footage</label>
                      <input type="text" value={cimFacility.sqft || ''} onChange={e => setCimFacility({...cimFacility, sqft: e.target.value})} placeholder="e.g., 2,500" className="w-full p-2 border rounded text-sm" />
                    </div>
                    {cimFacility.ownedOrLeased === 'Leased' && (<>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Monthly Lease Rate</label>
                        <input type="text" value={cimFacility.monthlyRate || ''} onChange={e => setCimFacility({...cimFacility, monthlyRate: e.target.value})} placeholder="$X,XXX/mo" className="w-full p-2 border rounded text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Lease Expiration</label>
                        <input type="text" value={cimFacility.leaseExpiration || ''} onChange={e => setCimFacility({...cimFacility, leaseExpiration: e.target.value})} placeholder="MM/YYYY" className="w-full p-2 border rounded text-sm" />
                      </div>
                      <div className="col-span-2">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Renewal Options</label>
                        <input type="text" value={cimFacility.renewalOptions || ''} onChange={e => setCimFacility({...cimFacility, renewalOptions: e.target.value})} placeholder="e.g., 2x 5-year renewal options" className="w-full p-2 border rounded text-sm" />
                      </div>
                    </>)}
                    {cimFacility.ownedOrLeased === 'Owned' && (
                      <div className="col-span-2">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Sell or Lease to Buyer?</label>
                        <select value={cimFacility.sellerWillSellOrLease || ''} onChange={e => setCimFacility({...cimFacility, sellerWillSellOrLease: e.target.value})} className="w-full p-2 border rounded text-sm">
                          <option value="">Select...</option><option value="Sell with business">Sell with business</option><option value="Lease to buyer">Lease to buyer</option><option value="TBD">To be determined</option>
                        </select>
                      </div>
                    )}
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Can Operate Remotely?</label>
                      <select value={cimFacility.canOperateRemotely || ''} onChange={e => setCimFacility({...cimFacility, canOperateRemotely: e.target.value})} className="w-full p-2 border rounded text-sm">
                        <option value="">Select...</option><option value="Yes">Yes</option><option value="No">No</option><option value="Partially">Partially</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Legal & Non-Compete */}
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimLegal: !prev.cimLegal}))}>
                  <span>{expandedSections.cimLegal ? '▼' : '▶'}</span>
                  ⚖️ Legal & Non-Compete
                  {(cimLegal.nonCompeteYears || cimLegal.contractAssignability) && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">Data entered</span>}
                </h3>
                {expandedSections.cimLegal && (
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Pending Legal Matters</label>
                      <select value={cimLegal.pendingLegalMatters || ''} onChange={e => setCimLegal({...cimLegal, pendingLegalMatters: e.target.value})} className="w-full p-2 border rounded text-sm">
                        <option value="">Select...</option><option value="No">No</option><option value="Yes">Yes</option>
                      </select>
                    </div>
                    {cimLegal.pendingLegalMatters === 'Yes' && (
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Legal Matter Details</label>
                        <input type="text" value={cimLegal.pendingLegalDetails || ''} onChange={e => setCimLegal({...cimLegal, pendingLegalDetails: e.target.value})} placeholder="Describe pending matters" className="w-full p-2 border rounded text-sm" />
                      </div>
                    )}
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Non-Compete (Years)</label>
                      <input type="text" value={cimLegal.nonCompeteYears || ''} onChange={e => setCimLegal({...cimLegal, nonCompeteYears: e.target.value})} placeholder="e.g., 3 years" className="w-full p-2 border rounded text-sm" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Non-Compete (Geographic Scope)</label>
                      <input type="text" value={cimLegal.nonCompeteScope || ''} onChange={e => setCimLegal({...cimLegal, nonCompeteScope: e.target.value})} placeholder="e.g., 50 mile radius, state of TX" className="w-full p-2 border rounded text-sm" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Contract Assignability Confirmed</label>
                      <select value={cimLegal.contractAssignability || ''} onChange={e => setCimLegal({...cimLegal, contractAssignability: e.target.value})} className="w-full p-2 border rounded text-sm">
                        <option value="">Select...</option><option value="Yes">Yes</option><option value="No">No</option><option value="Partial">Partial - some contracts</option><option value="TBD">Not yet confirmed</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Multi-Year Vendor Agreements</label>
                      <select value={cimLegal.multiYearVendorAgreements || ''} onChange={e => setCimLegal({...cimLegal, multiYearVendorAgreements: e.target.value})} className="w-full p-2 border rounded text-sm">
                        <option value="">Select...</option><option value="No">No</option><option value="Yes">Yes</option>
                      </select>
                    </div>
                    {cimLegal.multiYearVendorAgreements === 'Yes' && (
                      <div className="col-span-2">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Vendor Agreement Details</label>
                        <input type="text" value={cimLegal.vendorAgreementDetails || ''} onChange={e => setCimLegal({...cimLegal, vendorAgreementDetails: e.target.value})} placeholder="Describe key vendor agreements, terms, and expiration dates" className="w-full p-2 border rounded text-sm" />
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {/* Growth Opportunities */}
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => setExpandedSections(prev => ({...prev, cimGrowth: !prev.cimGrowth}))}>
                  <span>{expandedSections.cimGrowth ? '▼' : '▶'}</span>
                  🚀 Growth Opportunities
                  {cimGrowth.some(g => g.description) && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">Data entered</span>}
                </h3>
                {expandedSections.cimGrowth && (
                  <div>
                    {cimGrowth.map((opp, idx) => (
                      <div key={opp.id} className="mb-3 p-3 bg-gray-50 rounded border">
                        <div className="font-medium text-sm text-gray-700 mb-2">Growth Opportunity {idx + 1}</div>
                        <div className="grid grid-cols-3 gap-2">
                          <div>
                            <label className="block text-xs text-gray-500 mb-0.5">Description</label>
                            <input type="text" value={opp.description || ''} onChange={e => setCimGrowth(prev => prev.map((g, i) => i === idx ? {...g, description: e.target.value} : g))} placeholder="What is the opportunity?" className="w-full p-1.5 border rounded text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-500 mb-0.5">Why Achievable</label>
                            <input type="text" value={opp.achievability || ''} onChange={e => setCimGrowth(prev => prev.map((g, i) => i === idx ? {...g, achievability: e.target.value} : g))} placeholder="What makes this realistic?" className="w-full p-1.5 border rounded text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-500 mb-0.5">Estimated Upside</label>
                            <input type="text" value={opp.estimatedUpside || ''} onChange={e => setCimGrowth(prev => prev.map((g, i) => i === idx ? {...g, estimatedUpside: e.target.value} : g))} placeholder="$XXK revenue potential" className="w-full p-1.5 border rounded text-sm" />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="grid grid-cols-3 gap-3 mt-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">M&A Targets</label>
                        <input type="text" value={cimGrowthExtra.maTargets || ''} onChange={e => setCimGrowthExtra({...cimGrowthExtra, maTargets: e.target.value})} placeholder="Potential acquisition targets" className="w-full p-2 border rounded text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Untapped Service Lines</label>
                        <input type="text" value={cimGrowthExtra.untappedServices || ''} onChange={e => setCimGrowthExtra({...cimGrowthExtra, untappedServices: e.target.value})} placeholder="Services not yet offered" className="w-full p-2 border rounded text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Geographic Expansion</label>
                        <input type="text" value={cimGrowthExtra.geoExpansion || ''} onChange={e => setCimGrowthExtra({...cimGrowthExtra, geoExpansion: e.target.value})} placeholder="New markets or regions" className="w-full p-2 border rounded text-sm" />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Custom Data Groups — generic builder Phase 1 (spec 453a340).
                  Lead-defined, business-specific structured data: each group is
                  a facts list (kv) or a table with Lead-named columns, routed
                  to a chosen CIM section. Replaces the bespoke-Excel-per-deal
                  Leads build outside VT. Presets (save/load) are Phase 2. */}
              <div className="mb-4 bg-white p-4 rounded-lg border">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2 cursor-pointer select-none" onClick={() => { setExpandedSections(prev => ({...prev, cimCustomGroups: !prev.cimCustomGroups})); if (cimGroupPresets === null) fetchCimGroupPresets(); }}>
                  <span>{expandedSections.cimCustomGroups ? '▼' : '▶'}</span>
                  🧩 Custom Data Groups <span className="text-xs font-normal text-gray-400">(business-specific)</span>
                  {(cimCustomGroups || []).some(g => (g.name || '').trim()) && <span className="text-xs font-normal px-2 py-0.5 bg-green-100 text-green-700 rounded">{cimCustomGroups.filter(g => (g.name || '').trim()).length} group{cimCustomGroups.filter(g => (g.name || '').trim()).length === 1 ? '' : 's'}</span>}
                </h3>
                {expandedSections.cimCustomGroups && (
                  <div>
                    <p className="text-[11px] text-gray-500 mb-2">Data specific to THIS business that the fixed tabs don't capture — HVAC KPIs, material vendors with % of spend, pricing formulas, certifications. <strong>Where it flows:</strong> each group rides the CIM export and appears in the generated CIM as its own titled block, placed right after the section you pick on the group (the "→" dropdown). Facts without a value won't export.</p>
                    {/* Preset toolbar (Phase 2): load appends a staff-shared
                        structure; save shares this deal's group STRUCTURE. */}
                    <div className="flex flex-wrap items-center gap-2 mb-3 bg-blue-50 border border-blue-200 rounded p-2">
                      <span className="text-[11px] font-semibold text-gray-700">📦 Presets:</span>
                      <select value={cimPresetSel} onChange={e => setCimPresetSel(e.target.value)} className="p-1.5 border rounded text-xs">
                        <option value="">{cimGroupPresets === null ? 'loading…' : (cimGroupPresets.length ? '— choose —' : 'none saved yet')}</option>
                        {(cimGroupPresets || []).map(p => <option key={p.name} value={p.name}>{p.name}</option>)}
                      </select>
                      <button onClick={loadCimGroupPreset} disabled={!cimPresetSel} className="px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 disabled:bg-gray-300">Load (adds groups)</button>
                      <button onClick={saveCimGroupPreset} disabled={cimPresetBusy || !(cimCustomGroups || []).some(g => (g.name || '').trim())} className="px-2 py-1 bg-gray-600 text-white rounded text-xs hover:bg-gray-700 disabled:bg-gray-300">{cimPresetBusy ? 'Saving…' : '💾 Save groups as preset'}</button>
                      <span className="text-[11px] text-gray-500">Presets are staff-shared structure (labels/columns) — values stay with the deal.</span>
                    </div>
                    {(cimCustomGroups || []).map((g, gi) => (
                      <div key={g.id || gi} className="border rounded-lg p-3 mb-3 bg-gray-50">
                        <div className="flex flex-wrap items-center gap-2 mb-2">
                          <input type="text" value={g.name || ''} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, name: e.target.value} : x))} placeholder="Group name — e.g. Key Operating Metrics" className="flex-1 min-w-[180px] p-2 border rounded text-sm font-semibold" />
                          <select value={g.kind || 'kv'} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, kind: e.target.value} : x))} className="p-2 border rounded text-xs">
                            <option value="kv">Facts & figures</option>
                            <option value="table">Table</option>
                          </select>
                          <select value={g.section || 'businessOverview'} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, section: e.target.value} : x))} className="p-2 border rounded text-xs" title="Which CIM section this group renders into">
                            {CIM_CUSTOM_GROUP_SECTIONS.map(([k, label]) => <option key={k} value={k}>→ {label}</option>)}
                          </select>
                          <button onClick={() => { if (confirm(`Remove the group "${g.name || 'untitled'}" and its data?`)) setCimCustomGroups(prev => prev.filter((_, i) => i !== gi)); }} className="text-red-500 hover:text-red-700 px-1" title="Remove this group">×</button>
                        </div>
                        <p className="text-[10px] text-gray-400 mb-2 -mt-1">Appears in the CIM as "{(g.name || 'this group')}" right after the {(CIM_CUSTOM_GROUP_SECTIONS.find(([k]) => k === (g.section || 'businessOverview')) || [,'Business Overview'])[1]} section.</p>
                        {(g.kind || 'kv') === 'kv' ? (
                          <div>
                            {(g.kv || []).map((row, ri) => (
                              <div key={ri} className="flex gap-2 mb-1">
                                <input type="text" value={row.k || ''} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, kv: x.kv.map((r, j) => j === ri ? {...r, k: e.target.value} : r)} : x))} placeholder="Label — e.g. Gross profit per man-day" className="w-2/5 p-1.5 border rounded text-xs" />
                                <input type="text" value={row.v || ''} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, kv: x.kv.map((r, j) => j === ri ? {...r, v: e.target.value} : r)} : x))} placeholder="Value" className="flex-1 p-1.5 border rounded text-xs" />
                                <button onClick={() => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, kv: x.kv.filter((_, j) => j !== ri)} : x))} className="text-red-400 hover:text-red-600 px-1">×</button>
                              </div>
                            ))}
                            <button onClick={() => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, kv: [...(x.kv || []), { k: '', v: '' }]} : x))} className="mt-1 px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700">+ Add fact</button>
                          </div>
                        ) : (
                          <div>
                            <div className="overflow-x-auto">
                              <table className="w-full text-xs border-collapse mb-1">
                                <thead className="bg-gray-100">
                                  <tr>
                                    {(g.columns || []).map((c, ci) => (
                                      <th key={ci} className="p-0.5 border">
                                        <div className="flex items-center gap-1">
                                          <input type="text" value={c || ''} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, columns: x.columns.map((cc, j) => j === ci ? e.target.value : cc)} : x))} placeholder={`Column ${ci + 1}`} className="w-full p-1 text-xs font-semibold border-0 bg-transparent" />
                                          {(g.columns || []).length > 1 && <button onClick={() => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, columns: x.columns.filter((_, j) => j !== ci), rows: (x.rows || []).map(r => r.filter((_, j) => j !== ci))} : x))} className="text-red-400 hover:text-red-600" title="Remove column">×</button>}
                                        </div>
                                      </th>
                                    ))}
                                    <th className="p-0.5 border w-6"><button onClick={() => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, columns: [...(x.columns || []), ''], rows: (x.rows || []).map(r => [...r, ''])} : x))} className="text-blue-600 hover:text-blue-800 font-bold" title="Add column">+</button></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(g.rows || []).map((r, ri) => (
                                    <tr key={ri}>
                                      {(g.columns || []).map((_, ci) => (
                                        <td key={ci} className="p-0.5 border"><input type="text" value={r[ci] || ''} onChange={e => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, rows: x.rows.map((rr, j) => j === ri ? rr.map((cc, cj) => cj === ci ? e.target.value : cc) : rr)} : x))} className="w-full p-1 text-xs border-0" /></td>
                                      ))}
                                      <td className="p-0.5 border text-center"><button onClick={() => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, rows: x.rows.filter((_, j) => j !== ri)} : x))} className="text-red-400 hover:text-red-600">×</button></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            <button onClick={() => setCimCustomGroups(prev => prev.map((x, i) => i === gi ? {...x, rows: [...(x.rows || []), (x.columns || ['']).map(() => '')]} : x))} className="mt-1 px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700">+ Add row</button>
                          </div>
                        )}
                      </div>
                    ))}
                    <button onClick={() => setCimCustomGroups(prev => [...prev, { id: Date.now(), name: '', kind: 'kv', section: 'businessOverview', kv: [{ k: '', v: '' }], columns: ['', ''], rows: [] }])} className="px-3 py-1.5 bg-blue-600 text-white rounded text-xs hover:bg-blue-700">+ Add data group</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : viewMode === 'customers' ? (
          /* ========== SALES DATA ENTRY ========== */
          <div>
            {/* Basis Dropdown */}
            <div className="mb-4 flex items-center gap-4">
              <h2 className="text-lg font-bold">📊 Sales by Customer</h2>
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-gray-600">Basis:</label>
                <select 
                  value={salesViewBasis} 
                  onChange={e => setSalesViewBasis(e.target.value)} 
                  className="px-3 py-1.5 border rounded text-sm font-semibold bg-white"
                >
                  <option value="cash">Cash Basis</option>
                  <option value="accrual">Accrual Basis</option>
                </select>
                {/* Client count for the basis being viewed + drives-valuation hint */}
                <span className="text-xs text-gray-500 ml-1">
                  {activeSalesData.filter(c => c.name).length} client{activeSalesData.filter(c => c.name).length === 1 ? '' : 's'}
                </span>
                {salesViewBasis === valuationBasisForSales && (
                  <span className="text-xs px-2 py-0.5 bg-green-100 text-green-700 rounded font-medium" title="The valuation engine reads sales data from this basis (matches Setup → Valuation Basis)">Drives Valuation</span>
                )}
              </div>
            </div>
            {/* Empty-state hint when the viewed basis has no data entered */}
            {!activeSalesData.some(c => c.name) && (
              <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-start gap-2">
                <span className="text-amber-600 text-lg leading-none">ℹ️</span>
                <div className="text-sm text-amber-900">
                  <div className="font-semibold mb-0.5">
                    No {salesViewBasis === 'cash' ? 'cash' : 'accrual'} basis sales entered yet
                  </div>
                  <div className="text-amber-800">
                    Paste a {salesViewBasis === 'cash' ? 'cash' : 'accrual'} basis sales-by-customer report below, or start typing to add rows.
                    Cash and accrual reports are stored independently — entering data here does not affect the other basis.
                  </div>
                </div>
              </div>
            )}
            {/* Document Tracker */}
            {renderDocTracker('customers')}
            
            {/* Link to Analysis */}
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
              <div>
                <span className="font-semibold text-blue-800">📊 Sales Analysis</span>
                <span className="text-blue-600 text-sm ml-2">View concentration metrics, churn analysis, and benchmarks</span>
              </div>
              <button 
                onClick={() => setViewMode('salesanalysis')}
                className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
              >
                View Analysis →
              </button>
            </div>
            
            {/* Paste Column Modal */}
            {showPasteColumnModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-xl p-6 w-[500px] max-h-[80vh] overflow-auto">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">📋 Paste Column Data</h3>
                    <button onClick={() => { setShowPasteColumnModal(false); setPasteColumnData(''); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Column</label>
                    <select 
                      value={pasteColumnTarget}
                      onChange={e => setPasteColumnTarget(e.target.value)}
                      className="w-full px-3 py-2 border rounded-lg"
                    >
                      <optgroup label="Revenue Data">
                        <option value="name">Customer Name</option>
                        <option value="year1">{displayCustomerYearLabels.year1} Revenue</option>
                        <option value="year2">{displayCustomerYearLabels.year2} Revenue</option>
                        <option value="year3">{displayCustomerYearLabels.year3} Revenue</option>
                        <option value="year4">{displayCustomerYearLabels.year4} Revenue</option>
                        <option value="year5">{displayCustomerYearLabels.year5} Revenue</option>
                        <option value="ttm">TTM Revenue</option>
                      </optgroup>
                      <optgroup label="Client Details">
                        <option value="tenure">Tenure (Years)</option>
                        <option value="industry">Industry</option>
                        <option value="endpoints">Endpoints/Users</option>
                        <option value="billingFrequency">Billing (Monthly/Quarterly/Annually)</option>
                        <option value="customerType">Type (B2B/Residential)</option>
                        <option value="contractStart">Contract Start (MM/YY)</option>
                        <option value="contractEnd">Contract End (MM/YY)</option>
                        <option value="hasContract">Has Contract (Yes/No)</option>
                        <option value="autoRenewal">Auto-Renewal (Yes/No)</option>
                        <option value="assignable">Assignable (Yes/No)</option>
                        <option value="priceEscalator">Price Escalator (Yes/No)</option>
                        <option value="escalatorPercent">Escalator Percent</option>
                        <option value="earlyTermPenalty">Early Term Penalty (Yes/No)</option>
                        <option value="atRisk">Status (Active/At Risk/Lost)</option>
                        <option value="notes">Notes</option>
                      </optgroup>
                      {(cimClientAttrCols || []).filter(c => (c.name || '').trim()).length > 0 && (
                        <optgroup label="Custom Attributes (this deal)">
                          {cimClientAttrCols.filter(c => (c.name || '').trim()).map(col => <option key={col.id} value={'attr:' + col.id}>{col.name}</option>)}
                        </optgroup>
                      )}
                    </select>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Data Below <span className="text-gray-500 font-normal">(one value per line - blank lines = zero)</span>
                    </label>
                    <textarea 
                      value={pasteColumnData}
                      onChange={e => setPasteColumnData(e.target.value)}
                      placeholder="Copy column from Excel and paste here...&#10;Value 1&#10;&#10;Value 3&#10;(blank lines will be 0 for numbers)"
                      className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-sm"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = pasteColumnData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
                        const total = lines.length;
                        const nonEmpty = lines.filter(v => v.trim()).length;
                        const empty = total - nonEmpty;
                        return `${total} rows (${nonEmpty} with values, ${empty} blank → will be 0)`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-blue-800 mb-1">💡 Tips:</div>
                    <ul className="text-blue-700 text-xs space-y-1">
                      <li>• Copy a column from Excel (Ctrl+C) then paste here (Ctrl+V)</li>
                      <li>• <strong>Blank rows are preserved</strong> - they align with the correct customer row</li>
                      <li>• Blank cells → 0 for numbers, empty for text, No for checkboxes</li>
                      <li>• Currency formatting ($1,234.56) will be parsed automatically</li>
                      <li>• For Yes/No columns, accepts: Yes, Y, True, 1, X</li>
                      <li>• Rows will be added automatically if needed</li>
                    </ul>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowPasteColumnModal(false); setPasteColumnData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        // Capture state before paste
                        captureUndoState(`Paste Sales ${pasteColumnTarget}`);
                        
                        // Split preserving blank lines - handle both \r\n and \n
                        const values = pasteColumnData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
                        if (values.length === 0 || (values.length === 1 && values[0].trim() === '')) {
                          return;
                        }
                        // Ensure we have enough rows
                        let updatedData = [...activeSalesData];
                        while (updatedData.length < values.length) {
                          const maxId = Math.max(...updatedData.map(c => c.id), 0);
                          updatedData.push({
                            id: maxId + 1, name: '', year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0,
                            hasContract: false, contractStart: '', contractEnd: '', autoRenewal: false,
                            assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
                            billingFrequency: '', tenure: '', industry: '', endpoints: 0, customerType: '', atRisk: false, lost: false, notes: ''
                          });
                        }
                        // Parse and update values - blank lines become 0 for numbers, '' for text
                        values.forEach((val, idx) => {
                          if (idx < updatedData.length) {
                            const trimmedVal = val.trim();
                            let parsedVal;
                            // Parse numeric columns - treat blank as 0
                            if (['year1', 'year2', 'year3', 'year4', 'year5', 'ytd', 'ttm', 'endpoints'].includes(pasteColumnTarget)) {
                              if (trimmedVal === '') {
                                parsedVal = 0;
                              } else {
                                // If line contains tabs, take the last tab-separated value (common when copying name+value columns from Excel)
                                let valueStr = trimmedVal;
                                let namePortion = '';
                                if (trimmedVal.includes('\t')) {
                                  const tabs = trimmedVal.split('\t');
                                  valueStr = tabs[tabs.length - 1].trim();
                                  namePortion = tabs.slice(0, -1).join(' ').trim();
                                }
                                // Try direct parse (pure number or currency)
                                const directParse = parseFloat(valueStr.replace(/[$,]/g, ''));
                                if (!isNaN(directParse) && /^[\s$,.\d()-]+$/.test(valueStr)) {
                                  parsedVal = directParse;
                                } else {
                                  // Mixed text+number without tabs (e.g., "Visiting Angels 5,489.00")
                                  const numMatches = trimmedVal.match(/[\d,]+\.?\d*/g);
                                  if (numMatches && numMatches.length > 0) {
                                    const lastNum = numMatches[numMatches.length - 1].replace(/,/g, '');
                                    parsedVal = parseFloat(lastNum) || 0;
                                    if (!namePortion) namePortion = trimmedVal.replace(/[\d,.$()]+/g, '').trim();
                                  } else {
                                    parsedVal = 0;
                                  }
                                }
                                // If we extracted a name, try to match to existing client by name
                                if (namePortion && namePortion.length > 2) {
                                  const nameNorm = namePortion.toLowerCase().replace(/[^a-z0-9]/g, '');
                                  const matchIdx = updatedData.findIndex(c => c.name && c.name.toLowerCase().replace(/[^a-z0-9]/g, '') === nameNorm);
                                  if (matchIdx !== -1 && matchIdx !== idx) {
                                    updatedData[matchIdx] = { ...updatedData[matchIdx], [pasteColumnTarget]: parsedVal };
                                    return; // Matched by name — skip positional assignment
                                  }
                                }
                              }
                            }
                            // Parse boolean columns - blank = false
                            else if (['hasContract', 'autoRenewal', 'assignable', 'priceEscalator', 'earlyTermPenalty'].includes(pasteColumnTarget)) {
                              parsedVal = ['yes', 'y', 'true', '1', 'x'].includes(trimmedVal.toLowerCase());
                            }
                            // Parse Status column (atRisk) - Active/At Risk/Lost
                            else if (pasteColumnTarget === 'atRisk') {
                              const statusLower = trimmedVal.toLowerCase();
                              const isAtRisk = statusLower === 'at risk' || statusLower === 'at-risk' || statusLower === 'atrisk' || ['yes', 'y', 'true', '1'].includes(statusLower);
                              const isLost = statusLower === 'lost';
                              updatedData[idx] = { ...updatedData[idx], atRisk: isAtRisk, lost: isLost };
                              return; // Skip the generic assignment below
                            }
                            // Parse escalator percent as number
                            else if (pasteColumnTarget === 'escalatorPercent') {
                              parsedVal = trimmedVal === '' ? 0 : (parseFloat(trimmedVal.replace(/[%,]/g, '')) || 0);
                            }
                            // Lead-defined attribute column — value goes into the
                            // row's attrs map, not a top-level field.
                            else if (pasteColumnTarget.startsWith('attr:')) {
                              const colId = pasteColumnTarget.slice(5);
                              updatedData[idx] = { ...updatedData[idx], attrs: { ...(updatedData[idx].attrs || {}), [colId]: trimmedVal } };
                              return; // Skip the generic top-level assignment below
                            }
                            // Text columns - keep as is (blank = empty string)
                            else {
                              parsedVal = trimmedVal;
                            }
                            updatedData[idx] = { ...updatedData[idx], [pasteColumnTarget]: parsedVal };
                          }
                        });
                        setActiveSalesData(updatedData);
                        setShowPasteColumnModal(false);
                        setPasteColumnData('');
                      }}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                      disabled={pasteColumnData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').length === 0}
                    >
                      Apply to {pasteColumnData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').length} Rows
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold">📊 Sales Analysis</h2>
              <div className="flex items-center gap-2">
                <button 
                  onClick={() => {
                    setSalesGridPasteData('');
                    setSalesGridPastePreview(null);
                    setSalesGridClearReplace(false);
                    setShowSalesGridPasteModal(true);
                  }}
                  className="px-2 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700"
                  title="Paste entire sales report from Excel"
                >
                  📊 Paste Grid
                </button>
                <div className="flex items-center gap-1">
                  <span className="text-xs text-gray-500">Add</span>
                  <input 
                    type="number" 
                    min="1" 
                    max="200"
                    defaultValue="10"
                    id="addRowsCount"
                    className="w-14 px-1 py-1 border rounded text-xs text-center"
                  />
                  <button 
                    onClick={() => {
                      const count = parseInt(document.getElementById('addRowsCount').value) || 10;
                      const maxId = Math.max(...activeSalesData.map(c => c.id), 0);
                      const newRows = Array.from({ length: count }, (_, i) => ({
                        id: maxId + i + 1, name: '', year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0,
                        hasContract: false, contractStart: '', contractEnd: '', autoRenewal: false,
                        assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
                        billingFrequency: '', tenure: '', industry: '', endpoints: 0, customerType: '', atRisk: false, lost: false, notes: ''
                      }));
                      setActiveSalesData([...activeSalesData, ...newRows]);
                    }}
                    className="px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700"
                  >
                    + Rows
                  </button>
                </div>
                <button 
                  onClick={autoNameCustomers}
                  className="px-2 py-1 bg-gray-600 text-white text-xs rounded hover:bg-gray-700"
                  title="Automatically name unnamed customers (Customer A, B, C...)"
                >
                  🏷️ Auto-Name
                </button>
                <button 
                  onClick={rollForwardCustomers} 
                  className="px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700"
                  title="Shift years forward: Y2→Y1, Y3→Y2, Y4→Y3, Y5→Y4, New→Y5"
                >
                  ↻ Roll Forward
                </button>
                <button 
                  onClick={generateSalesExport} 
                  className="px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700"
                  title="Generate CIM-ready summary of customer metrics"
                >
                  📄 Export Summary
                </button>
              </div>
            </div>
            
            {/* Year Labels Configuration */}
            <div className="mb-4 p-3 bg-gray-100 rounded-lg">
              <div className="flex items-center gap-4 flex-wrap">
                <span className="text-sm font-semibold text-gray-700">Year Labels:</span>
                {['year1', 'year2', 'year3', 'year4', 'year5'].map(yr => (
                  <div key={yr} className="flex items-center gap-1">
                    <span className="text-xs text-gray-500">{yr.replace('year', 'Y')}:</span>
                    <input 
                      type="text" 
                      value={customerYearLabels[yr]} 
                      onChange={e => setCustomerYearLabels({...customerYearLabels, [yr]: e.target.value})}
                      className="w-16 px-1 py-0.5 border rounded text-xs text-center"
                    />
                  </div>
                ))}
                <div className="border-l pl-4 ml-2 flex items-center gap-2">
                  <span className="text-sm font-semibold text-gray-700">TTM Ending:</span>
                  <select 
                    value={salesTtmConfig.endMonth} 
                    onChange={e => setSalesTtmConfig({...salesTtmConfig, endMonth: parseInt(e.target.value)})} 
                    className="p-1 border rounded text-xs"
                  >
                    <option value={0}>Jan</option>
                    <option value={1}>Feb</option>
                    <option value={2}>Mar</option>
                    <option value={3}>Apr</option>
                    <option value={4}>May</option>
                    <option value={5}>Jun</option>
                    <option value={6}>Jul</option>
                    <option value={7}>Aug</option>
                    <option value={8}>Sep</option>
                    <option value={9}>Oct</option>
                    <option value={10}>Nov</option>
                    <option value={11}>Dec</option>
                  </select>
                  <input 
                    type="number" 
                    value={salesTtmConfig.endYear} 
                    onChange={e => setSalesTtmConfig({...salesTtmConfig, endYear: parseInt(e.target.value)})} 
                    className="w-16 p-1 border rounded text-xs text-center"
                    min={2020}
                    max={2030}
                  />
                  <span className="text-xs text-gray-500">({salesTtmLabel})</span>
                </div>
              </div>
            </div>
            
            {/* Sales Data Table */}
            <div className="bg-white rounded-lg border overflow-hidden">
              <div 
                onClick={() => setSalesDataExpanded(!salesDataExpanded)}
                className="p-3 bg-gray-100 border-b flex justify-between items-center cursor-pointer hover:bg-gray-200 transition-colors"
              >
                <h3 className="font-semibold text-gray-800">Sales Data (5 Years + TTM)</h3>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-gray-500">
                    {activeSalesData.filter(c => c.name).length} clients • {formatCurrency(activeSalesData.reduce((s, c) => s + (c.ttm || 0), 0))} TTM
                  </span>
                  <span className="text-gray-500">{salesDataExpanded ? '▼' : '▶'}</span>
                </div>
              </div>
              
              {salesDataExpanded && (
              <>
              {/* Reminder: Export Detailed Client Form */}
              {activeSalesData.some(c => c.name && c.name.trim()) && (() => {
                const clientFormDoc = documentChecklist.find(d => d.id === 28);
                const isReceived = clientFormDoc?.status === 'received' || clientFormDoc?.status === 'complete';
                if (isReceived) return null;
                const isPending = clientFormDoc?.status === 'pending';
                return (
                  <div className={`p-2 border-b flex items-center justify-between ${isPending ? 'bg-amber-50 border-amber-200' : 'bg-green-50 border-green-200'}`}>
                    <div className="flex items-center gap-2">
                      <span>{isPending ? '⏳' : '📋'}</span>
                      <span className="text-xs font-medium">
                        {isPending 
                          ? 'Client Detail Form sent — awaiting completed form from seller' 
                          : 'Sales data entered — export the Detailed Client Form and send to seller for completion'}
                      </span>
                    </div>
                    {!isPending && (
                      <button 
                        onClick={() => {
                          generateClientDetailTemplate();
                          // Auto-mark as pending
                          setDocumentChecklist(prev => prev.map(d => d.id === 28 ? { ...d, status: 'pending', pendingNotes: 'Exported ' + new Date().toLocaleDateString() } : d));
                        }}
                        className="px-2 py-1 bg-green-600 text-white rounded text-xs font-semibold hover:bg-green-700"
                      >
                        📥 Export & Mark Sent
                      </button>
                    )}
                  </div>
                );
              })()}
              <div className="p-2 bg-gray-50 border-b flex justify-between items-center gap-2 flex-wrap">
                {/* TTM Sync Status Chip — silent until monthly data is loaded, then loud if totals diverge */}
                <div className="flex items-center">
                  {salesTtmReconciliation.hasMonthlyData && (
                    salesTtmReconciliation.inSync ? (
                      <span
                        className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 border border-green-300 rounded text-xs font-medium"
                        title={`Sales TTM column matches TTM Monthly tab ($${Math.round(salesTtmReconciliation.salesTtmTotal).toLocaleString()})`}
                      >
                        ✓ TTM in sync with TTM Monthly
                      </span>
                    ) : (
                      <button
                        onClick={() => setShowSalesReconModal(true)}
                        className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-800 border border-red-400 rounded text-xs font-semibold hover:bg-red-200"
                        title="Click to see which customers don't reconcile"
                      >
                        ⚠ TTM out of sync — ${Math.abs(Math.round(salesTtmReconciliation.difference)).toLocaleString()} {salesTtmReconciliation.difference > 0 ? 'over' : 'under'} ({salesTtmReconciliation.noMonthlyButHasTtm.length + salesTtmReconciliation.orphanMonthly.length + salesTtmReconciliation.mismatched.length} customer{(salesTtmReconciliation.noMonthlyButHasTtm.length + salesTtmReconciliation.orphanMonthly.length + salesTtmReconciliation.mismatched.length) === 1 ? '' : 's'})
                      </button>
                    )
                  )}
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  {/* Sort Options */}
                  <div className="flex items-center gap-1">
                    <span className="text-xs text-gray-500">Sort:</span>
                    <select 
                      value={salesSortBy}
                      onChange={e => {
                        const newSort = e.target.value;
                        setSalesSortBy(newSort);
                        // Default to A-Z for name, highest-first for numeric sorts
                        if (newSort === 'name') {
                          setSalesSortDir('asc');
                        } else if (newSort !== 'entry') {
                          setSalesSortDir('desc');
                        }
                      }}
                      className={`px-1 py-0.5 border rounded text-xs ${salesSortBy !== 'entry' ? 'bg-blue-100 border-blue-400' : ''}`}
                    >
                      <option value="entry">Entry Order</option>
                      <option value="ttm">TTM Revenue</option>
                      <option value="name">Name</option>
                      <option value="pct">% of Total</option>
                      <option value="growth">Growth</option>
                    </select>
                    {salesSortBy !== 'entry' && (
                      <button 
                        onClick={() => setSalesSortDir(salesSortDir === 'desc' ? 'asc' : 'desc')}
                        className="px-1 py-0.5 border rounded text-xs hover:bg-gray-200"
                        title={salesSortBy === 'name' 
                          ? (salesSortDir === 'asc' ? 'A → Z (click for Z → A)' : 'Z → A (click for A → Z)')
                          : (salesSortDir === 'desc' ? 'High → Low (click for Low → High)' : 'Low → High (click for High → Low)')}
                      >
                        {salesSortBy === 'name' 
                          ? (salesSortDir === 'asc' ? 'A→Z' : 'Z→A')
                          : (salesSortDir === 'desc' ? '↓' : '↑')}
                      </button>
                    )}
                  </div>
                  {salesSortBy !== 'entry' && (
                    <span className="text-xs text-blue-700 bg-blue-100 px-1 rounded">⚠️ View only - reset for paste</span>
                  )}
                  <button 
                    onClick={() => { setSalesSortBy('entry'); setShowPasteColumnModal(true); }}
                    className="px-2 py-1 bg-blue-600 text-white rounded text-xs font-semibold hover:bg-blue-700 flex items-center gap-1"
                    title="Paste column data from Excel (resets sort to Entry Order)"
                  >
                    📋 Paste Column
                  </button>
                  <button 
                    onClick={generateClientDetailTemplate}
                    className="px-2 py-1 bg-green-600 text-white rounded text-xs font-semibold hover:bg-green-700 flex items-center gap-1"
                    title="Generate Excel template with client names and dropdowns to send to seller for client detail entry"
                  >
                    📥 Export Client Detail Form
                  </button>
                  <label className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-semibold hover:bg-green-200 flex items-center gap-1 cursor-pointer border border-green-300">
                    📤 Import Completed Form
                    <input type="file" accept=".xlsx,.xls" className="hidden" onChange={e => {
                      const file = e.target.files[0];
                      if (file) {
                        setClientImportFile(file);
                        setShowClientImportModal(true);
                      }
                      e.target.value = '';
                    }} />
                  </label>
                  <button
                    onClick={() => setShowClientAIImport(true)}
                    className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-semibold hover:bg-purple-200 flex items-center gap-1 border border-purple-300"
                    title="Owner sent client info in some other format (contract list, CRM export, email)? Paste it and AI maps it onto the grid by client name — the three-path amendment's path (c)."
                  >
                    🤖 AI Import
                  </button>
                  <button 
                    onClick={() => setActiveSalesData([...activeSalesData, { 
                      id: Math.max(...activeSalesData.map(c => c.id), 0) + 1, name: '', year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0,
                      hasContract: false, contractStart: '', contractEnd: '', autoRenewal: false,
                      assignable: false, priceEscalator: false, escalatorPercent: 0, earlyTermPenalty: false,
                      billingFrequency: '', tenure: '', industry: '', endpoints: 0, customerType: '', atRisk: false, lost: false, notes: ''
                    }])}
                    className="px-2 py-1 bg-blue-600 text-white rounded text-xs font-semibold hover:bg-blue-700 flex items-center gap-1"
                  >
                    <Plus className="w-3 h-3" /> Add Row
                  </button>
                </div>
              </div>
              {/* AI import modal — path (c): any-format owner data → grid. */}
              {showClientAIImport && (
                <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center p-4" onClick={() => !clientAIBusy && setShowClientAIImport(false)}>
                  <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-4" onClick={e => e.stopPropagation()}>
                    <h3 className="font-bold text-gray-800 mb-1">🤖 AI import client details</h3>
                    <p className="text-xs text-gray-600 mb-2">Paste whatever the owner sent — a contract list, CRM export, email, notes. AI maps it onto the grid <strong>by matching client names</strong>; rows that don't match a grid client are skipped, and blank fields never overwrite. Spot-check afterward.</p>
                    <textarea value={clientAIText} onChange={e => setClientAIText(e.target.value)} rows={12} className="w-full p-2 border rounded text-xs font-mono" placeholder="Paste the owner's client/contract information here…" />
                    <div className="flex justify-end gap-2 mt-3">
                      <button onClick={() => setShowClientAIImport(false)} disabled={clientAIBusy} className="px-3 py-1.5 text-sm rounded border border-gray-300 text-gray-600 hover:bg-gray-50">Cancel</button>
                      <button onClick={importClientDetailWithAI} disabled={clientAIBusy || !clientAIText.trim()} className="px-4 py-1.5 text-sm font-semibold rounded bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-50">{clientAIBusy ? 'Mapping…' : 'Map onto the grid'}</button>
                    </div>
                  </div>
                </div>
              )}
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-2 py-2 text-left font-semibold text-gray-600 w-48">Customer Name</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600">{displayCustomerYearLabels.year1}</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600">{displayCustomerYearLabels.year2}</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600">{displayCustomerYearLabels.year3}</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600">{displayCustomerYearLabels.year4}</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600">{displayCustomerYearLabels.year5}</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600 bg-blue-50" style={{minWidth:'110px'}}>{salesTtmLabel || 'TTM'}</th>
                      <th className="px-2 py-2 text-center font-semibold text-gray-600 w-12" title="Growth: TTM vs Year5">Δ</th>
                      <th className="px-2 py-2 text-right font-semibold text-gray-600">% TTM</th>
                      <th className="px-2 py-2 text-center font-semibold text-gray-600 w-12">Del</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const ttmTotal = activeSalesData.reduce((s, c) => s + (c.ttm || 0), 0);
                      
                      // Sort customers
                      const sortedCustomers = [...activeSalesData].sort((a, b) => {
                        let aVal, bVal;
                        switch (salesSortBy) {
                          case 'entry':
                            return 0; // Keep original order
                          case 'name':
                            aVal = (a.name || '').toLowerCase();
                            bVal = (b.name || '').toLowerCase();
                            return salesSortDir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
                          case 'pct':
                            aVal = ttmTotal > 0 ? (a.ttm || 0) / ttmTotal : 0;
                            bVal = ttmTotal > 0 ? (b.ttm || 0) / ttmTotal : 0;
                            break;
                          case 'growth':
                            aVal = (a.year5 || 0) > 0 ? ((a.ttm || 0) - (a.year5 || 0)) / (a.year5 || 1) : (a.ttm || 0) > 0 ? 1 : 0;
                            bVal = (b.year5 || 0) > 0 ? ((b.ttm || 0) - (b.year5 || 0)) / (b.year5 || 1) : (b.ttm || 0) > 0 ? 1 : 0;
                            break;
                          default: // ttm
                            aVal = a.ttm || 0;
                            bVal = b.ttm || 0;
                        }
                        if (salesSortBy !== 'name' && salesSortBy !== 'entry') {
                          return salesSortDir === 'asc' ? aVal - bVal : bVal - aVal;
                        }
                        return 0;
                      });
                      
                      return sortedCustomers.map((customer, idx) => {
                        const pctOfTTM = ttmTotal > 0 ? ((customer.ttm || 0) / ttmTotal * 100) : 0;
                        // Growth calculation
                        const year5 = customer.year5 || 0;
                        const ttm = customer.ttm || 0;
                        let growthIndicator = { icon: '→', color: 'text-gray-400', title: 'Flat' };
                        if (year5 > 0 && ttm > 0) {
                          const growthPct = ((ttm - year5) / year5) * 100;
                          if (growthPct > 5) {
                            growthIndicator = { icon: '↑', color: 'text-green-600', title: `+${growthPct.toFixed(1)}%` };
                          } else if (growthPct < -5) {
                            growthIndicator = { icon: '↓', color: 'text-red-600', title: `${growthPct.toFixed(1)}%` };
                          } else {
                            growthIndicator = { icon: '→', color: 'text-gray-500', title: `${growthPct >= 0 ? '+' : ''}${growthPct.toFixed(1)}%` };
                          }
                        } else if (year5 === 0 && ttm > 0) {
                          growthIndicator = { icon: '★', color: 'text-blue-600', title: 'New customer' };
                        } else if (year5 > 0 && ttm === 0) {
                          growthIndicator = { icon: '✗', color: 'text-red-600', title: 'Lost customer' };
                        }
                        
                        return (
                          <tr key={customer.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="px-2 py-1">
                              <input 
                                type="text" 
                                value={customer.name} 
                                onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, name: e.target.value} : c))}
                                className="w-full px-1 py-0.5 border rounded text-sm"
                                placeholder="Customer name"
                              />
                            </td>
                            {['year1', 'year2', 'year3', 'year4', 'year5'].map(yr => (
                              <td key={yr} className="px-2 py-1">
                                <CurrencyInput 
                                  value={customer[yr]} 
                                  onChange={val => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, [yr]: val} : c))}
                                  className="w-full px-1 py-0.5 border rounded text-sm text-right"
                              />
                            </td>
                          ))}
                          <td className="px-2 py-1 bg-blue-50">
                            <CurrencyInput 
                              value={customer.ttm || 0} 
                              onChange={val => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, ttm: val} : c))}
                              className="w-full px-1 py-0.5 border rounded text-sm text-right font-semibold"
                            />
                          </td>
                          <td className={`px-2 py-1 text-center ${growthIndicator.color}`} title={growthIndicator.title}>
                            <span className="text-lg font-bold">{growthIndicator.icon}</span>
                          </td>
                          <td className={`px-2 py-1 text-right font-medium ${pctOfTTM > 20 ? 'text-red-600' : pctOfTTM > 10 ? 'text-yellow-600' : 'text-gray-600'}`}>
                            {pctOfTTM.toFixed(1)}%
                          </td>
                          <td className="px-2 py-1 text-center">
                            <button 
                              onClick={() => {
                                captureUndoState('Delete Customer');
                                setActiveSalesData(activeSalesData.filter(c => c.id !== customer.id));
                              }}
                              className="text-red-500 hover:text-red-700"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </td>
                        </tr>
                      );
                    });
                    })()}
                    {/* Totals Row */}
                    <tr className="bg-gray-200 font-bold">
                      <td className="px-2 py-2">TOTAL</td>
                      {['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'].map(yr => (
                        <td key={yr} className={`px-2 py-2 text-right ${yr === 'ttm' ? 'bg-blue-100' : ''}`}>
                          {formatCurrency(activeSalesData.reduce((s, c) => s + (c[yr] || 0), 0))}
                        </td>
                      ))}
                      <td className="px-2 py-2 text-center">-</td>
                      <td className="px-2 py-2 text-right">100%</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="p-2 bg-gray-50 border-t text-xs text-gray-500">
                <span className="font-semibold">Tip:</span> Use "Paste Column" to paste data from Excel. Copy a column in Excel, click Paste Column, enter the column name. 
                Blank cells will be treated as zero. • <strong>Revenue reconciliation:</strong> Compare totals with P&L on the <button onClick={() => setViewMode('reconciliation')} className="text-blue-600 underline hover:text-blue-800">Reconciliation tab</button>.
              </div>
              </>
              )}
            </div>
            
            {/* Client Details Section - Collapsible */}
            <div className="mt-4 bg-white rounded-lg border overflow-hidden">
              <button 
                onClick={() => setSalesDetailsExpanded(!salesDetailsExpanded)}
                className="w-full p-3 bg-gray-100 border-b flex justify-between items-center hover:bg-gray-200 transition-colors"
              >
                <h3 className="font-semibold text-gray-800">📋 Client Details (Contract, Billing, Industry, Endpoints)</h3>
                <span className="text-gray-500">{salesDetailsExpanded ? '▼ Collapse' : '▶ Expand'}</span>
              </button>
              {/* Owner-form notices live with the client detail they fill (Colleen 10-02: moved down from the
                  5-year sales area). Outside the expand toggle so a waiting form is never hidden. */}
              <div className="px-2 pt-2 empty:hidden">
                {/* Owner's portal Client Detail responses (migration 034) —
                    review & accept applies them to the grid (both bases, by
                    name; blanks never overwrite). */}
                {!ownerClientDetail && (documentChecklist || []).some(d => d.id === 29 && d.status === 'complete') && (
                  <div className="mb-2 p-2 rounded border border-amber-300 bg-amber-50 text-xs text-amber-800">
                    📭 <strong>The owner entered nothing in the portal Client Detail form</strong> — and it's marked complete, so it's <strong>hidden from their portal</strong>. To ask them to fill it: Documents → <strong>Client Detail Form</strong> → set back to <strong>Not received</strong>; it reappears in their portal (anything already in the grid shows pre-filled).
                  </div>
                )}
                {ownerClientDetail && (
                  <div className="mb-2 p-3 rounded border border-green-300 bg-green-50">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-semibold text-green-800">
                        📥 Owner {ownerClientDetail.done ? 'completed' : 'has started'} the Client Detail form in the portal
                      </span>
                      {Object.keys(ownerClientDetail.rows).length > 0 ? (
                        <React.Fragment>
                          <span className="text-xs text-green-700">({Object.keys(ownerClientDetail.rows).length} client{Object.keys(ownerClientDetail.rows).length === 1 ? '' : 's'} answered)</span>
                          <button onClick={acceptOwnerClientDetail} className="px-3 py-1 text-xs font-semibold rounded bg-green-600 text-white hover:bg-green-700" title="Apply the owner's answers to the grid (blank answers never overwrite; Yes/No parsed; months/percent parsed as numbers)">✓ Accept into the grid</button>
                          <button onClick={downloadOwnerClientDetail} className="px-3 py-1 text-xs font-semibold rounded border border-green-600 text-green-800 bg-white hover:bg-green-100" title="Excel of exactly what the owner submitted — one row per client, plus whether it's in the grid now. Use it to review, or send it back to the owner with questions.">⬇ Owner's answers (Excel)</button>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <span className="text-xs text-amber-700 font-medium">— but entered no client rows (clicked complete on an empty form)</span>
                          <button onClick={acceptOwnerClientDetail} className="px-3 py-1 text-xs font-semibold rounded bg-amber-500 text-white hover:bg-amber-600" title="Clears the review flag. Nothing is applied — there's nothing to apply.">Acknowledge — nothing to apply</button>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              {salesDetailsExpanded && (
                <div>
                  {/* Bulk Actions Toolbar */}
                  <div className="p-2 bg-gray-50 border-b flex items-center gap-4 flex-wrap">
                    <span className="text-xs font-medium text-gray-600">Bulk Set:</span>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Type:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, customerType: 'B2B'})))}
                        className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
                      >
                        All B2B
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, customerType: 'Residential'})))}
                        className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
                      >
                        All Residential
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Billing:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, billingFrequency: 'Monthly'})))}
                        className="px-2 py-0.5 bg-slate-100 text-slate-700 rounded text-xs hover:bg-slate-200"
                      >
                        All Monthly
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, billingFrequency: 'Annually'})))}
                        className="px-2 py-0.5 bg-slate-100 text-slate-700 rounded text-xs hover:bg-slate-200"
                      >
                        All Annually
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Contract:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, hasContract: true})))}
                        className="px-2 py-0.5 bg-gray-200 text-gray-700 rounded text-xs hover:bg-gray-300"
                      >
                        All Yes
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, hasContract: false})))}
                        className="px-2 py-0.5 bg-gray-200 text-gray-700 rounded text-xs hover:bg-gray-300"
                      >
                        All No
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Auto-Renew:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, autoRenewal: true})))}
                        className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
                      >
                        All Yes
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, autoRenewal: false})))}
                        className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
                      >
                        All No
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Assignable:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, assignable: true})))}
                        className="px-2 py-0.5 bg-slate-200 text-slate-700 rounded text-xs hover:bg-slate-300"
                      >
                        All Yes
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, assignable: false})))}
                        className="px-2 py-0.5 bg-slate-200 text-slate-700 rounded text-xs hover:bg-slate-300"
                      >
                        All No
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Escalator:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, priceEscalator: true})))}
                        className="px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
                      >
                        All Yes
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, priceEscalator: false})))}
                        className="px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
                      >
                        All No
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Term Penalty:</span>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, earlyTermPenalty: true})))}
                        className="px-2 py-0.5 bg-slate-100 text-slate-700 rounded text-xs hover:bg-slate-200"
                      >
                        All Yes
                      </button>
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, earlyTermPenalty: false})))}
                        className="px-2 py-0.5 bg-slate-100 text-slate-700 rounded text-xs hover:bg-slate-200"
                      >
                        All No
                      </button>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-500">Length (mo):</span>
                      <input 
                        type="number"
                        value={dealProfile.typicalContractMonths || ''}
                        onChange={e => setDealProfile({...dealProfile, typicalContractMonths: e.target.value ? parseInt(e.target.value) : null})}
                        className="w-14 px-1 py-0.5 border rounded text-xs text-center"
                        placeholder="12"
                        min="1"
                        max="120"
                      />
                      <button 
                        onClick={() => setActiveSalesData(activeSalesData.map(c => ({...c, contractMonths: dealProfile.typicalContractMonths})))}
                        className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs hover:bg-green-200"
                        title="Apply contract length to all customers"
                      >
                        Apply All
                      </button>
                    </div>
                    <div className="ml-auto flex items-center gap-2">
                      <button onClick={clearAllClientDetail}
                        className="px-3 py-1 border border-red-300 text-red-700 bg-white rounded text-xs hover:bg-red-50"
                        title="Wipe every client's detail on both bases before a fresh paste (names and revenue stay). Undoable.">
                        🧹 Clear all detail
                      </button>
                      <button 
                        onClick={() => setShowClientDetailsPasteModal(true)}
                        className="px-3 py-1 bg-purple-600 text-white rounded text-xs hover:bg-purple-700 flex items-center gap-1"
                      >
                        📊 Paste Grid
                      </button>
                    </div>
                  </div>
                  {(() => {
                    // Zac 10-05: he counted 50+ ticked here vs 33 elsewhere — the ticks on former clients are why.
                    const live = activeSalesData.filter(c => (c.ttm || 0) > 0 && c.name);
                    const ticked = activeSalesData.filter(c => c.hasContract === true && c.name);
                    const former = ticked.filter(c => !((c.ttm || 0) > 0));
                    return (
                      <div className="px-2 py-1 text-xs text-gray-600 bg-white border-b">
                        <strong>{live.length}</strong> clients billed in the TTM · <strong>{ticked.length - former.length}</strong> of them ticked under contract
                        {former.length > 0 && <span className="text-gray-400"> · {former.length} more ticks are on former clients (greyed — no TTM revenue, not counted)</span>}
                      </div>
                    );
                  })()}
                  <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-2 py-2 text-left font-semibold text-gray-600 w-40 sticky left-0 bg-gray-50">Client</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-24">Type</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-20">Status</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Contract?</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-24">Effective Date</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-20">Orig. Length</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Auto-Renew</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-20">Renewed Len.</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Assignable</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Escalator</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Esc %</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Term Penalty</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-24">Billing</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-28">Industry</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-600 w-16">Tenure</th>
                        {/* Lead-defined display-attribute columns (generic builder).
                            Values flow to the CIM client exhibit only — never to
                            metrics/scoring. Rename inline; × removes the column
                            (and its values); + adds one. */}
                        {(cimClientAttrCols || []).map((col, ci) => (
                          <th key={col.id} className="px-1 py-1 text-center font-semibold text-gray-600 w-24 bg-blue-50">
                            <div className="flex items-center gap-0.5">
                              <input type="text" value={col.name || ''} onChange={e => setCimClientAttrCols(prev => prev.map((c, i) => i === ci ? {...c, name: e.target.value} : c))} placeholder={`Attr ${ci + 1}`} className="w-full px-1 py-0.5 border rounded text-xs font-semibold bg-white" title="Lead-defined client attribute — shows in the CIM client table (top-20 rows), not in metrics." />
                              <button onClick={() => { if (confirm(`Remove the "${col.name || 'untitled'}" column and its values on every client?`)) { setCimClientAttrCols(prev => prev.filter((_, i) => i !== ci)); setActiveSalesData(activeSalesData.map(c => { const a = {...(c.attrs || {})}; delete a[col.id]; return {...c, attrs: a}; })); } }} className="text-red-400 hover:text-red-600 text-xs" title="Remove column">×</button>
                            </div>
                          </th>
                        ))}
                        <th className="px-1 py-2 text-center w-8"><button onClick={() => setCimClientAttrCols(prev => [...(prev || []), { id: 'a' + Date.now(), name: '' }])} className="text-blue-600 hover:text-blue-800 font-bold" title="Add a Lead-defined attribute column (e.g. Endpoints, System Age) — renders in the CIM client table.">+</button></th>
                        <th className="px-2 py-2 text-left font-semibold text-gray-600">Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeSalesData.filter(c => c.name || c.ttm > 0).map((customer, idx) => (
                        <tr key={customer.id} className={`${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}${(customer.ttm || 0) > 0 ? '' : ' opacity-50'}`}
                          title={(customer.ttm || 0) > 0 ? undefined : 'Former client — no revenue in the last 12 months. Not counted in any client or contract figure.'}>
                          <td className="px-2 py-1 text-xs font-medium sticky left-0 bg-inherit">{customer.name || `Row ${idx + 1}`}{(customer.ttm || 0) > 0 ? null : <span className="ml-1 text-[10px] font-normal text-gray-500">· no TTM revenue</span>}</td>
                          <td className="px-2 py-1">
                            {(() => {
                              const unmatched = customer.customerType && !CLIENT_TYPES.includes(customer.customerType) ? customer.customerType : null;
                              return (
                            <select
                              value={customer.customerType || ''}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, customerType: e.target.value} : c))}
                              className={`w-full px-1 py-0.5 border rounded text-xs${unmatched ? ' border-amber-400 bg-amber-50 text-amber-800' : ''}`}
                              title={unmatched ? `The owner wrote "${unmatched}" — pick the type it belongs to` : undefined}
                            >
                              <option value="">—</option>
                              {unmatched && <option value={unmatched}>{unmatched} ?</option>}
                              <option value="B2B">B2B</option>
                              <option value="Residential">Residential</option>
                              <option value="Government">Government</option>
                              <option value="Non-Profit">Non-Profit</option>
                            </select>
                              );
                            })()}
                          </td>
                          <td className="px-2 py-1 text-center">
                            <select
                              value={customer.lost ? 'Lost' : customer.atRisk ? 'At Risk' : 'Active'}
                              onChange={e => {
                                const v = e.target.value;
                                setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, atRisk: v === 'At Risk', lost: v === 'Lost'} : c));
                              }}
                              className={`w-full px-1 py-0.5 border rounded text-xs ${customer.lost ? 'bg-red-50 text-red-700' : customer.atRisk ? 'bg-yellow-50 text-yellow-700' : ''}`}
                            >
                              <option value="Active">Active</option>
                              <option value="At Risk">At Risk</option>
                              <option value="Lost">Lost</option>
                            </select>
                          </td>
                          <td className="px-2 py-1 text-center">
                            <input 
                              type="checkbox" 
                              checked={customer.hasContract || false}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, hasContract: e.target.checked, contractAnswered: true} : c))}
                            />
                          </td>
                          <td className="px-2 py-1">
                            <input 
                              type="text" 
                              value={customer.effectiveDate || customer.contractStart || ''}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, effectiveDate: e.target.value} : c))}
                              className="w-full px-1 py-0.5 border rounded text-xs text-center"
                              placeholder="MM/DD/YY"
                            />
                          </td>
                          <td className="px-2 py-1">
                            <select
                              value={customer.contractMonths === 1 ? 'Month-to-Month' : customer.contractMonths === 12 ? '12 Months' : customer.contractMonths === 24 ? '24 Months' : customer.contractMonths === 36 ? '36 Months' : customer.contractMonths === 60 ? '60 Months' : customer.contractMonths > 1 ? `${customer.contractMonths} Months` : ''}
                              onChange={e => {
                                const val = e.target.value;
                                let months = null;
                                if (val === 'Month-to-Month') months = 1;
                                else if (val === '12 Months') months = 12;
                                else if (val === '24 Months') months = 24;
                                else if (val === '36 Months') months = 36;
                                else if (val === '60 Months') months = 60;
                                setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, contractMonths: months} : c));
                              }}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                            >
                              <option value="">—</option>
                              <option value="Month-to-Month">Month-to-Month</option>
                              <option value="12 Months">12 Months</option>
                              <option value="24 Months">24 Months</option>
                              <option value="36 Months">36 Months</option>
                              <option value="60 Months">60 Months</option>
                            </select>
                          </td>
                          <td className="px-2 py-1 text-center">
                            <input 
                              type="checkbox" 
                              checked={customer.autoRenewal || false}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, autoRenewal: e.target.checked} : c))}
                            />
                          </td>
                          <td className="px-2 py-1">
                            <select
                              value={customer.renewedContractMonths === 1 ? 'Month-to-Month' : customer.renewedContractMonths === 12 ? '12 Months' : customer.renewedContractMonths === 24 ? '24 Months' : customer.renewedContractMonths === 36 ? '36 Months' : customer.renewedContractMonths ? `${customer.renewedContractMonths} Months` : ''}
                              onChange={e => {
                                const val = e.target.value;
                                let months = null;
                                if (val === 'Month-to-Month') months = 1;
                                else if (val === '12 Months') months = 12;
                                else if (val === '24 Months') months = 24;
                                else if (val === '36 Months') months = 36;
                                setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, renewedContractMonths: months} : c));
                              }}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                            >
                              <option value="">—</option>
                              <option value="Month-to-Month">Month-to-Month</option>
                              <option value="12 Months">12 Months</option>
                              <option value="24 Months">24 Months</option>
                              <option value="36 Months">36 Months</option>
                            </select>
                          </td>
                          <td className="px-2 py-1 text-center">
                            <input 
                              type="checkbox" 
                              checked={customer.assignable || false}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, assignable: e.target.checked} : c))}
                            />
                          </td>
                          <td className="px-2 py-1 text-center">
                            <input 
                              type="checkbox" 
                              checked={customer.priceEscalator || false}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, priceEscalator: e.target.checked} : c))}
                            />
                          </td>
                          <td className="px-2 py-1">
                            <input 
                              type="number" 
                              value={customer.escalatorPercent || ''}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, escalatorPercent: parseFloat(e.target.value) || 0} : c))}
                              className="w-full px-1 py-0.5 border rounded text-xs text-right"
                              placeholder="%"
                              disabled={!customer.priceEscalator}
                            />
                          </td>
                          <td className="px-2 py-1 text-center">
                            <input 
                              type="checkbox" 
                              checked={customer.earlyTermPenalty || false}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, earlyTermPenalty: e.target.checked} : c))}
                            />
                          </td>
                          <td className="px-2 py-1">
                            <select
                              value={customer.billingFrequency || ''}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, billingFrequency: e.target.value} : c))}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                            >
                              <option value="">—</option>
                              <option value="Monthly">Monthly</option>
                              <option value="Quarterly">Quarterly</option>
                              <option value="Annually">Annually</option>
                            </select>
                          </td>
                          <td className="px-2 py-1">
                            <input 
                              type="text" 
                              value={customer.industry || ''}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, industry: e.target.value} : c))}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                              placeholder="Industry"
                            />
                          </td>
                          <td className="px-2 py-1">
                            <input
                              type="number"
                              value={customer.tenure || ''}
                              onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, tenure: parseFloat(e.target.value) || ''} : c))}
                              className="w-full px-1 py-0.5 border rounded text-xs text-center"
                              placeholder="Yrs"
                            />
                          </td>
                          {(cimClientAttrCols || []).map(col => (
                            <td key={col.id} className="px-1 py-1 bg-blue-50">
                              <input
                                type="text"
                                value={(customer.attrs || {})[col.id] || ''}
                                onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, attrs: {...(c.attrs || {}), [col.id]: e.target.value}} : c))}
                                className="w-full px-1 py-0.5 border rounded text-xs bg-white"
                              />
                            </td>
                          ))}
                          <td className="px-1 py-1"></td>
                          <td className="px-2 py-1">
                            <div className="flex items-center gap-1">
                              <input
                                type="text"
                                value={customer.notes || ''}
                                onChange={e => setActiveSalesData(activeSalesData.map(c => c.id === customer.id ? {...c, notes: e.target.value} : c))}
                                onDoubleClick={() => setExpandedNoteCustomer({ id: customer.id, name: customer.name, notes: customer.notes || '' })}
                                className="w-full px-1 py-0.5 border rounded text-xs"
                                placeholder="Double-click to expand"
                                title={customer.notes || 'Double-click to expand'}
                              />
                              {customer.notes && (
                                <button
                                  onClick={() => setExpandedNoteCustomer({ id: customer.id, name: customer.name, notes: customer.notes || '' })}
                                  className="text-gray-400 hover:text-gray-600 flex-shrink-0"
                                  title="Expand note"
                                >
                                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                </div>
              )}
            </div>

            {/* Sales TTM Reconciliation Detail Modal — duplicated here so the chip on the Sales tab can open it without switching viewMode */}
            {showSalesReconModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowSalesReconModal(false)}>
                <div className="bg-white rounded-lg shadow-xl p-6 w-[800px] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">⚠ TTM Sync Reconciliation</h3>
                    <button onClick={() => setShowSalesReconModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>
                  <div className="mb-4 grid grid-cols-3 gap-3 text-sm">
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Sales tab TTM</div><div className="font-bold">${Math.round(salesTtmReconciliation.salesTtmTotal).toLocaleString()}</div></div>
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">TTM Monthly total</div><div className="font-bold">${Math.round(salesTtmReconciliation.monthlyTotal).toLocaleString()}</div></div>
                    <div className={`p-2 rounded border ${salesTtmReconciliation.inSync ? 'bg-green-50' : 'bg-red-50'}`}><div className="text-gray-500 text-xs">Difference</div><div className={`font-bold ${salesTtmReconciliation.inSync ? 'text-green-700' : 'text-red-700'}`}>${Math.round(salesTtmReconciliation.difference).toLocaleString()}</div></div>
                  </div>
                  {salesTtmReconciliation.noMonthlyButHasTtm.length > 0 && (
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-1">Customers in Sales tab with no TTM Monthly row ({salesTtmReconciliation.noMonthlyButHasTtm.length})</div>
                      <div className="text-xs text-gray-600 mb-2">These customers have a TTM value on the Sales tab but no monthly data. Clicking <strong>Resync TTM</strong> will set their TTM to $0 (the TTM Monthly tab is the source of truth).</div>
                      <div className="overflow-auto max-h-64 border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0"><tr><th className="p-1.5 text-left">Customer</th><th className="p-1.5 text-right">Sales TTM</th></tr></thead>
                          <tbody>
                            {salesTtmReconciliation.noMonthlyButHasTtm.slice().sort((a,b) => b.salesTtm - a.salesTtm).map(c => (
                              <tr key={c.id} className="border-t"><td className="p-1.5">{c.name}</td><td className="p-1.5 text-right">${Math.round(c.salesTtm).toLocaleString()}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {salesTtmReconciliation.mismatched.length > 0 && (
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-1">Customers with mismatched values ({salesTtmReconciliation.mismatched.length})</div>
                      <div className="text-xs text-gray-600 mb-2">Both rows exist but their totals don't agree. Likely a manual edit on the Sales tab after the last Resync, or a basis switch. Clicking <strong>Resync TTM</strong> will overwrite Sales TTM with the monthly sum.</div>
                      <div className="overflow-auto max-h-64 border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0"><tr><th className="p-1.5 text-left">Customer</th><th className="p-1.5 text-right">Sales TTM</th><th className="p-1.5 text-right">Monthly Sum</th><th className="p-1.5 text-right">Diff</th></tr></thead>
                          <tbody>
                            {salesTtmReconciliation.mismatched.slice().sort((a,b) => Math.abs(b.diff) - Math.abs(a.diff)).map(c => (
                              <tr key={c.id} className="border-t"><td className="p-1.5">{c.name}</td><td className="p-1.5 text-right">${Math.round(c.salesTtm).toLocaleString()}</td><td className="p-1.5 text-right">${Math.round(c.monthlySum).toLocaleString()}</td><td className="p-1.5 text-right text-red-700">${Math.round(c.diff).toLocaleString()}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {salesTtmReconciliation.orphanMonthly.length > 0 && (
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-1">Monthly rows with no Sales tab customer ({salesTtmReconciliation.orphanMonthly.length})</div>
                      <div className="text-xs text-gray-600 mb-2">Monthly data exists for these customer IDs but they aren't in the Sales table. Their numbers are not contributing to the Sales TTM total.</div>
                      <div className="overflow-auto max-h-64 border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0"><tr><th className="p-1.5 text-left">Customer ID</th><th className="p-1.5 text-right">Monthly Sum</th></tr></thead>
                          <tbody>
                            {salesTtmReconciliation.orphanMonthly.slice().sort((a,b) => b.monthlySum - a.monthlySum).map(c => (
                              <tr key={c.id} className="border-t"><td className="p-1.5">{c.id}</td><td className="p-1.5 text-right">${Math.round(c.monthlySum).toLocaleString()}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  <div className="flex justify-end gap-2 pt-2 border-t">
                    <button onClick={() => setShowSalesReconModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm">Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'arap' ? (
          /* ========== AR/AP DATA ENTRY ========== */
          <div>
            <h2 className="text-lg font-bold mb-3">📋 AR/AP Data Entry</h2>
            
            {/* Document Tracker */}
            {renderDocTracker('arap')}
            
            {/* Link to Analysis */}
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
              <div>
                <span className="font-semibold text-blue-800">📊 AR/AP Analysis</span>
                <span className="text-blue-600 text-sm ml-2">View DSO, aging metrics, cash cycle, and benchmarks</span>
              </div>
              <button 
                onClick={() => setViewMode('arapanalysis')}
                className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
              >
                View Analysis →
              </button>
            </div>
            
            <div className="grid grid-cols-1 gap-4">
              {/* AR Aging Line Items Table */}
              <div className="bg-white rounded-lg border p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-4">
                    <h3 className="font-semibold text-gray-800">Accounts Receivable Aging</h3>
                    <label className="flex items-center gap-2 text-xs cursor-pointer">
                      <input 
                        type="checkbox" 
                        checked={arReviewChecklist.notApplicable}
                        onChange={e => setArReviewChecklist({...arReviewChecklist, notApplicable: e.target.checked})}
                        className="rounded"
                      />
                      <span className="text-gray-600">Not Applicable <span className="text-gray-400">(retail, cash business, etc.)</span></span>
                    </label>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-2">
                      <label className="text-xs text-gray-600">Report Date:</label>
                      <input 
                        type="date" 
                        value={arAgingData.reportDate} 
                        onChange={e => setArAgingData({...arAgingData, reportDate: e.target.value})}
                        className="px-2 py-1 border rounded text-xs"
                        disabled={arReviewChecklist.notApplicable}
                      />
                    </div>
                    <button 
                      onClick={() => {
                        setArGridPasteData('');
                        setArGridPastePreview(null);
                        setShowARGridPasteModal(true);
                      }}
                      className="text-xs px-2 py-1 bg-green-600 text-white rounded hover:bg-green-700 flex items-center gap-1"
                      title="Paste entire AR Aging report from Excel"
                      disabled={arReviewChecklist.notApplicable}
                    >
                      📊 Paste Grid
                    </button>
                    <button 
                      onClick={autoNameARCustomers}
                      className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 flex items-center gap-1"
                      title="Auto-name blank customers (A, B, C...)"
                      disabled={arReviewChecklist.notApplicable}
                    >
                      🏷️ Auto-Name
                    </button>
                    <button 
                      onClick={openARPasteModal}
                      className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 flex items-center gap-1"
                      title="Paste column data from Excel"
                      disabled={arReviewChecklist.notApplicable}
                    >
                      📋 Paste
                    </button>
                    <button 
                      onClick={() => setArAgingLineItems(prev => [...prev, { id: Math.max(...prev.map(i => i.id), 0) + 1, customerName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }])}
                      className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 flex items-center gap-1"
                      disabled={arReviewChecklist.notApplicable}
                    >
                      <Plus className="w-3 h-3" /> Add Row
                    </button>
                    <button 
                      onClick={() => {
                        if (window.confirm('Clear all AR aging data? This will remove all customer/invoice entries.')) {
                          captureUndoState('Clear AR Aging Data');
                          setArAgingLineItems([
                            { id: 1, customerName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 },
                            { id: 2, customerName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 },
                            { id: 3, customerName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }
                          ]);
                          setArAgingData({...arAgingData, reportDate: '', notes: ''});
                          setArReviewChecklist({
                            notApplicable: false,
                            reportDateMatches: { checked: false, notes: '' },
                            totalTiesToBS: { checked: false, notes: '' },
                            noNegativeBalances: { checked: false, notes: '' },
                            agingDistributionReasonable: { checked: false, notes: '' },
                            noCustomerMultipleBuckets: { checked: false, notes: '' },
                            over120LessThanAllowance: { checked: false, notes: '' },
                            concentrationAcceptable: { checked: false, notes: '' },
                            reportReviewed: false,
                            reviewedBy: '',
                            reviewDate: ''
                          });
                        }
                      }}
                      className="text-xs px-2 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200 flex items-center gap-1"
                      title="Clear all AR aging data"
                      disabled={arReviewChecklist.notApplicable}
                    >
                      <Trash2 className="w-3 h-3" /> Clear All
                    </button>
                  </div>
                </div>
                
                {arReviewChecklist.notApplicable ? (
                  <div className="p-6 bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg text-center">
                    <div className="text-gray-500 text-sm">
                      <span className="text-2xl">🏪</span>
                      <div className="mt-2 font-medium">AR Aging Not Applicable</div>
                      <div className="text-xs mt-1">This business operates without accounts receivable (retail, cash-based, etc.)</div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="text-xs text-gray-500 mb-2 flex items-center justify-between">
                      <div className="flex items-center gap-1">
                        <span>💡</span>
                        <span>Column headers are editable - click to match your aging report format</span>
                      </div>
                      <div className="flex items-center gap-2 bg-amber-50 px-2 py-1 rounded border border-amber-200">
                        <label className="text-amber-800 font-medium">Past due starts at:</label>
                        <select 
                          value={arAgingBucketLabels.pastDueStartColumn || 2}
                          onChange={e => setArAgingBucketLabels({...arAgingBucketLabels, pastDueStartColumn: parseInt(e.target.value)})}
                          className="text-xs border rounded px-1 py-0.5 bg-white"
                        >
                          <option value={1}>Column 1 ({arAgingBucketLabels.current})</option>
                          <option value={2}>Column 2 ({arAgingBucketLabels.days31to60})</option>
                          <option value={3}>Column 3 ({arAgingBucketLabels.days61to90})</option>
                          <option value={4}>Column 4 ({arAgingBucketLabels.days91to120})</option>
                          <option value={5}>Column 5 ({arAgingBucketLabels.days120plus})</option>
                        </select>
                      </div>
                    </div>
                
                <div className="overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="p-2 border text-left w-48">Customer/Invoice</th>
                        <th className="p-1 border text-right w-24 bg-blue-50 group cursor-text" title="Click to edit">
                          <input 
                            type="text" 
                            value={arAgingBucketLabels.current} 
                            onChange={e => setArAgingBucketLabels({...arAgingBucketLabels, current: e.target.value})}
                            className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                          />
                        </th>
                        <th className="p-1 border text-right w-24 bg-slate-100 cursor-text" title="Click to edit">
                          <input 
                            type="text" 
                            value={arAgingBucketLabels.days31to60} 
                            onChange={e => setArAgingBucketLabels({...arAgingBucketLabels, days31to60: e.target.value})}
                            className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                          />
                        </th>
                        <th className="p-1 border text-right w-24 bg-slate-200 cursor-text" title="Click to edit">
                          <input 
                            type="text" 
                            value={arAgingBucketLabels.days61to90} 
                            onChange={e => setArAgingBucketLabels({...arAgingBucketLabels, days61to90: e.target.value})}
                            className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                          />
                        </th>
                        <th className="p-1 border text-right w-24 bg-slate-300 cursor-text" title="Click to edit">
                          <input 
                            type="text" 
                            value={arAgingBucketLabels.days91to120} 
                            onChange={e => setArAgingBucketLabels({...arAgingBucketLabels, days91to120: e.target.value})}
                            className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                          />
                        </th>
                        <th className="p-1 border text-right w-24 bg-slate-400 cursor-text" title="Click to edit">
                          <input 
                            type="text" 
                            value={arAgingBucketLabels.days120plus} 
                            onChange={e => setArAgingBucketLabels({...arAgingBucketLabels, days120plus: e.target.value})}
                            className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                          />
                        </th>
                        <th className="p-2 border text-right w-24 bg-blue-50">Total</th>
                        <th className="p-2 border w-8"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {arAgingLineItems.map((item, idx) => {
                        const lineTotal = (item.current || 0) + (item.days31to60 || 0) + (item.days61to90 || 0) + (item.days91to120 || 0) + (item.days120plus || 0);
                        const isNegative = lineTotal < 0;
                        return (
                          <tr key={item.id} className={isNegative ? 'bg-amber-50' : ''}>
                            <td className="p-1 border">
                              <input 
                                type="text" 
                                value={item.customerName || ''} 
                                onChange={e => setArAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, customerName: e.target.value} : i))}
                                className="w-full px-1 py-0.5 border rounded text-xs"
                                placeholder="Customer name"
                              />
                            </td>
                            <td className="p-1 border bg-blue-50">
                              <CurrencyInput 
                                value={item.current || 0} 
                                onChange={val => setArAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, current: val} : i))}
                                className="w-full px-1 py-0.5 border rounded text-xs text-right"
                              />
                            </td>
                            <td className="p-1 border bg-slate-100">
                              <CurrencyInput 
                                value={item.days31to60 || 0} 
                                onChange={val => setArAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days31to60: val} : i))}
                                className="w-full px-1 py-0.5 border rounded text-xs text-right"
                              />
                            </td>
                            <td className="p-1 border bg-slate-100">
                              <CurrencyInput 
                                value={item.days61to90 || 0} 
                                onChange={val => setArAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days61to90: val} : i))}
                                className="w-full px-1 py-0.5 border rounded text-xs text-right"
                              />
                            </td>
                            <td className="p-1 border bg-slate-200">
                              <CurrencyInput 
                                value={item.days91to120 || 0} 
                                onChange={val => setArAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days91to120: val} : i))}
                                className="w-full px-1 py-0.5 border rounded text-xs text-right"
                              />
                            </td>
                            <td className="p-1 border bg-slate-300">
                              <CurrencyInput 
                                value={item.days120plus || 0} 
                                onChange={val => setArAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days120plus: val} : i))}
                                className="w-full px-1 py-0.5 border rounded text-xs text-right"
                              />
                            </td>
                            <td className={`p-1 border text-right font-medium ${isNegative ? 'bg-amber-100 text-amber-700' : 'bg-blue-50'}`}>
                              {formatCurrency(lineTotal)}
                              {isNegative && <span className="ml-1" title="Negative balance">⚠️</span>}
                            </td>
                            <td className="p-1 border text-center">
                              {arAgingLineItems.length > 1 && (
                                <button 
                                  onClick={() => {
                                    captureUndoState('Delete AR Line');
                                    setArAgingLineItems(prev => prev.filter(i => i.id !== item.id));
                                  }}
                                  className="text-red-400 hover:text-red-600"
                                  title="Delete row"
                                >
                                  <Trash2 className="w-3 h-3" />
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {/* Totals Row */}
                      <tr className="bg-gray-200 font-bold">
                        <td className="p-2 border">TOTAL</td>
                        <td className="p-2 border text-right bg-blue-100">{formatCurrency(arAgingCalcs.current)}</td>
                        <td className="p-2 border text-right bg-slate-100">{formatCurrency(arAgingCalcs.days31to60)}</td>
                        <td className="p-2 border text-right bg-slate-200">{formatCurrency(arAgingCalcs.days61to90)}</td>
                        <td className="p-2 border text-right bg-slate-200">{formatCurrency(arAgingCalcs.days91to120)}</td>
                        <td className="p-2 border text-right bg-slate-300">{formatCurrency(arAgingCalcs.days120plus)}</td>
                        <td className="p-2 border text-right bg-blue-100">{formatCurrency(arAgingCalcs.totalAR)}</td>
                        <td className="p-1 border"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                {/* Summary row below table */}
                <div className="mt-3 flex items-center gap-6 text-xs">
                  <div className="flex items-center gap-2">
                    <span className="text-gray-600">TTM Revenue:</span>
                    <span className="font-medium">{formatCurrency(calculations.years[5].revenue)}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-600">DSO:</span>
                    <span className="font-medium">{calculations.years[5].revenue > 0 ? (arAgingCalcs.totalAR / calculations.years[5].revenue * 365).toFixed(0) : 'N/A'} days</span>
                  </div>
                  {arAgingCalcs.negativeBalances !== 0 && (
                    <div className="flex items-center gap-2 text-red-600">
                      <span>⚠️ Negative Balances:</span>
                      <span className="font-medium">{formatCurrency(arAgingCalcs.negativeBalances)}</span>
                    </div>
                  )}
                </div>
                  </>
                )}
              </div>
              
              {/* AP Analysis - Full Width */}
              <div className="bg-white rounded-lg border p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-4">
                    <h3 className="font-semibold text-gray-800">Accounts Payable</h3>
                    <div className="flex items-center gap-2">
                      <label className="flex items-center gap-2 text-xs cursor-pointer">
                        <input 
                          type="radio" 
                          name="apTrackingMode"
                          checked={apAnalysis.trackingMode === 'notTracked'}
                          onChange={() => setApAnalysis({...apAnalysis, trackingMode: 'notTracked'})}
                        />
                        <span className="text-gray-600">Not Tracked <span className="text-gray-400">(most common)</span></span>
                      </label>
                      <label className="flex items-center gap-2 text-xs cursor-pointer">
                        <input 
                          type="radio"
                          name="apTrackingMode" 
                          checked={apAnalysis.trackingMode === 'tracked'}
                          onChange={() => setApAnalysis({...apAnalysis, trackingMode: 'tracked'})}
                        />
                        <span className="text-gray-600">Tracked <span className="text-gray-400">(has AP aging report)</span></span>
                      </label>
                    </div>
                  </div>
                  {apAnalysis.trackingMode === 'tracked' && (
                    <div className="flex items-center gap-2">
                      <label className="text-xs text-gray-600">Report Date:</label>
                      <input 
                        type="date" 
                        value={apAnalysis.reportDate} 
                        onChange={e => setApAnalysis({...apAnalysis, reportDate: e.target.value})}
                        className="px-2 py-1 border rounded text-xs"
                      />
                      <button 
                        onClick={autoNameAPVendors}
                        className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 flex items-center gap-1"
                        title="Auto-name blank vendors (A, B, C...)"
                      >
                        🏷️ Auto-Name
                      </button>
                      <button 
                        onClick={() => setShowAPGridPasteModal(true)}
                        className="text-xs px-2 py-1 bg-purple-100 text-purple-700 rounded hover:bg-purple-200 flex items-center gap-1"
                        title="Paste entire AP aging report at once"
                      >
                        📊 Paste Grid
                      </button>
                      <button 
                        onClick={openAPPasteModal}
                        className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 flex items-center gap-1"
                        title="Paste column data from Excel"
                      >
                        📋 Paste
                      </button>
                      <button 
                        onClick={() => setApAgingLineItems(prev => [...prev, { id: Math.max(...prev.map(i => i.id), 0) + 1, vendorName: '', current: 0, days31to60: 0, days61to90: 0, days91to120: 0, days120plus: 0 }])}
                        className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 flex items-center gap-1"
                      >
                        <Plus className="w-3 h-3" /> Add Row
                      </button>
                    </div>
                  )}
                </div>
                
                {apAnalysis.trackingMode === 'notTracked' ? (
                  <div className="p-6 bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg">
                    <div className="text-center text-gray-500 text-sm">
                      <span className="text-2xl">📝</span>
                      <div className="mt-2 font-medium">AP Not Tracked in Accounting System</div>
                      <div className="text-xs mt-1">This business records expenses at payment (no AP aging report available)</div>
                      <div className="mt-4 flex items-center justify-center gap-4">
                        <div className="flex items-center gap-2">
                          <label className="text-xs text-gray-600">Posts AP Regularly?</label>
                          <select 
                            value={apAnalysis.postsAPRegularly}
                            onChange={e => setApAnalysis({...apAnalysis, postsAPRegularly: e.target.value})}
                            className="px-2 py-1 border rounded text-xs"
                          >
                            <option value="unknown">Unknown</option>
                            <option value="yes">Yes</option>
                            <option value="no">No - Pay at invoice</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="text-xs text-gray-500 mb-1 flex items-center gap-1">
                      <span>💡</span>
                      <span>Column headers are editable - click to match your aging report format</span>
                    </div>
                    
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-2 border text-left w-48">Vendor/Invoice</th>
                            <th className="p-1 border text-right w-24 bg-blue-50 cursor-text" title="Click to edit">
                              <input 
                                type="text" 
                                value={apAgingBucketLabels.current} 
                                onChange={e => setApAgingBucketLabels({...apAgingBucketLabels, current: e.target.value})}
                                className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                              />
                            </th>
                            <th className="p-1 border text-right w-24 bg-slate-100 cursor-text" title="Click to edit">
                              <input 
                                type="text" 
                                value={apAgingBucketLabels.days31to60} 
                                onChange={e => setApAgingBucketLabels({...apAgingBucketLabels, days31to60: e.target.value})}
                                className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                              />
                            </th>
                            <th className="p-1 border text-right w-24 bg-slate-200 cursor-text" title="Click to edit">
                              <input 
                                type="text" 
                                value={apAgingBucketLabels.days61to90} 
                                onChange={e => setApAgingBucketLabels({...apAgingBucketLabels, days61to90: e.target.value})}
                                className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                              />
                            </th>
                            <th className="p-1 border text-right w-24 bg-slate-300 cursor-text" title="Click to edit">
                              <input 
                                type="text" 
                                value={apAgingBucketLabels.days91to120} 
                                onChange={e => setApAgingBucketLabels({...apAgingBucketLabels, days91to120: e.target.value})}
                                className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                              />
                            </th>
                            <th className="p-1 border text-right w-24 bg-slate-400 cursor-text" title="Click to edit">
                              <input 
                                type="text" 
                                value={apAgingBucketLabels.days120plus} 
                                onChange={e => setApAgingBucketLabels({...apAgingBucketLabels, days120plus: e.target.value})}
                                className="w-full text-right bg-transparent text-xs font-semibold focus:bg-white focus:outline-none border-b border-dashed border-gray-300 hover:border-gray-500 focus:border-blue-500"
                              />
                            </th>
                            <th className="p-2 border text-right w-24 bg-blue-50">Total</th>
                            <th className="p-2 border w-8"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {apAgingLineItems.map((item, idx) => {
                            const lineTotal = (item.current || 0) + (item.days31to60 || 0) + (item.days61to90 || 0) + (item.days91to120 || 0) + (item.days120plus || 0);
                            const hasOldPayables = (item.days91to120 || 0) + (item.days120plus || 0) > 0;
                            return (
                              <tr key={item.id} className={hasOldPayables ? 'bg-amber-50' : ''}>
                                <td className="p-1 border">
                                  <input 
                                    type="text" 
                                    value={item.vendorName || ''} 
                                    onChange={e => setApAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, vendorName: e.target.value} : i))}
                                    className="w-full px-1 py-0.5 border rounded text-xs"
                                    placeholder="Vendor name"
                                  />
                                </td>
                                <td className="p-1 border bg-blue-50">
                                  <CurrencyInput 
                                    value={item.current || 0} 
                                    onChange={val => setApAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, current: val} : i))}
                                    className="w-full px-1 py-0.5 border rounded text-xs text-right"
                                  />
                                </td>
                                <td className="p-1 border bg-slate-100">
                                  <CurrencyInput 
                                    value={item.days31to60 || 0} 
                                    onChange={val => setApAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days31to60: val} : i))}
                                    className="w-full px-1 py-0.5 border rounded text-xs text-right"
                                  />
                                </td>
                                <td className="p-1 border bg-slate-100">
                                  <CurrencyInput 
                                    value={item.days61to90 || 0} 
                                    onChange={val => setApAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days61to90: val} : i))}
                                    className="w-full px-1 py-0.5 border rounded text-xs text-right"
                                  />
                                </td>
                                <td className="p-1 border bg-slate-200">
                                  <CurrencyInput 
                                    value={item.days91to120 || 0} 
                                    onChange={val => setApAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days91to120: val} : i))}
                                    className="w-full px-1 py-0.5 border rounded text-xs text-right"
                                  />
                                </td>
                                <td className="p-1 border bg-slate-300">
                                  <CurrencyInput 
                                    value={item.days120plus || 0} 
                                    onChange={val => setApAgingLineItems(prev => prev.map(i => i.id === item.id ? {...i, days120plus: val} : i))}
                                    className="w-full px-1 py-0.5 border rounded text-xs text-right"
                                  />
                                </td>
                                <td className={`p-1 border text-right font-medium ${hasOldPayables ? 'bg-amber-100 text-amber-700' : 'bg-blue-50'}`}>
                                  {formatCurrency(lineTotal)}
                                  {hasOldPayables && <span className="ml-1" title="Old payables">⚠️</span>}
                                </td>
                                <td className="p-1 border text-center">
                                  {apAgingLineItems.length > 1 && (
                                    <button 
                                      onClick={() => {
                                        captureUndoState('Delete AP Line');
                                        setApAgingLineItems(prev => prev.filter(i => i.id !== item.id));
                                      }}
                                      className="text-red-400 hover:text-red-600"
                                      title="Delete row"
                                    >
                                      <Trash2 className="w-3 h-3" />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                          {/* Totals Row */}
                          <tr className="bg-gray-200 font-bold">
                            <td className="p-2 border">TOTAL</td>
                            <td className="p-2 border text-right bg-blue-100">{formatCurrency(apAgingCalcs.current)}</td>
                            <td className="p-2 border text-right bg-slate-100">{formatCurrency(apAgingCalcs.days31to60)}</td>
                            <td className="p-2 border text-right bg-slate-200">{formatCurrency(apAgingCalcs.days61to90)}</td>
                            <td className="p-2 border text-right bg-slate-200">{formatCurrency(apAgingCalcs.days91to120)}</td>
                            <td className="p-2 border text-right bg-slate-300">{formatCurrency(apAgingCalcs.days120plus)}</td>
                            <td className="p-2 border text-right bg-blue-100">{formatCurrency(apAgingCalcs.totalAP)}</td>
                            <td className="p-1 border"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    {/* AP Metrics Cards */}
                    {/* AP Notes */}
                    <div className="mt-3">
                      <textarea 
                        value={apAnalysis.notes} 
                        onChange={e => setApAnalysis({...apAnalysis, notes: e.target.value})}
                        placeholder="AP analysis notes - vendor disputes, payment terms, cash flow observations..."
                        className="w-full p-2 border rounded text-xs h-16"
                      />
                    </div>
                    
                    {/* Tip to view analysis */}
                    <div className="mt-2 text-xs text-gray-500 flex items-center gap-1">
                      <span>💡</span>
                      <span>AP metrics and analysis: </span>
                      <button 
                        onClick={() => setViewMode('arapanalysis')}
                        className="text-blue-600 hover:underline"
                      >
                        View on Analysis tab →
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
            
          </div>
        ) : viewMode === 'revenueanalysis' ? (
          <div>
            <div className="flex items-center justify-between mb-2">
              <div>
                <h2 className="text-lg font-bold">Revenue & COGS Analysis</h2>
                <p className="text-sm text-gray-600">Showing data from <strong>{selectedValuationBasis === 'cash' ? 'Cash' : selectedValuationBasis === 'accrual' ? 'Accrual' : 'Tax Return'}</strong> basis. Change on Income Statement tab.</p>
              </div>
              <button onClick={() => setViewMode('accrualpl')} className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300">
                ← Back to Entry
              </button>
            </div>

            {renderDocTracker('revenueanalysis')}

            {/* Summary Cards */}
            <div className="grid grid-cols-4 gap-3 mb-4">
              <div className="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500"><div className="text-xs text-blue-600 font-semibold">Total Revenue (TTM)</div><div className="text-xl font-bold text-blue-900">{formatCurrency(activeRevenueCategories.reduce((sum, c) => sum + (c.ttm || 0), 0))}</div></div>
              <div className="bg-slate-100 p-3 rounded-lg border-l-4 border-slate-400"><div className="text-xs text-slate-600 font-semibold">Total COGS (TTM)</div><div className="text-xl font-bold text-slate-900">{formatCurrency(activeCogsCategories.reduce((sum, c) => sum + (c.ttm || 0), 0))}</div></div>
              <div className="bg-green-50 p-3 rounded-lg border-l-4 border-green-500"><div className="text-xs text-green-600 font-semibold">Gross Profit (TTM)</div><div className="text-xl font-bold text-green-900">{formatCurrency(activeRevenueCategories.reduce((sum, c) => sum + (c.ttm || 0), 0) - activeCogsCategories.reduce((sum, c) => sum + (c.ttm || 0), 0))}</div></div>
              <div className="bg-green-50 p-3 rounded-lg border-l-4 border-green-400"><div className="text-xs text-green-600 font-semibold">Gross Margin</div><div className="text-xl font-bold text-green-900">{formatPercent(((activeRevenueCategories.reduce((sum, c) => sum + (c.ttm || 0), 0) - activeCogsCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)) / (activeRevenueCategories.reduce((sum, c) => sum + (c.ttm || 0), 0) || 1)) * 100)}</div></div>
            </div>

            {/* Revenue Categories - Display from P&L Entry, Type is editable */}
            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-bold text-gray-800"><span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs mr-2">FROM P&L ENTRY</span>Revenue Categories</h3>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={generateRevenueCategoryForm}
                    className="px-3 py-1.5 bg-purple-600 text-white rounded text-sm hover:bg-purple-700 flex items-center gap-1"
                    title="Export Excel form for owner to classify revenue types"
                  >
                    📤 Export Classification Form
                  </button>
                  <label className="px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700 flex items-center gap-1 cursor-pointer"
                    title="Import completed classification form">
                    📥 Import
                    <input type="file" accept=".xlsx,.xls" className="hidden" onChange={importRevenueCategoryForm} />
                  </label>
                  <button 
                    onClick={() => setShowRevenueTypeHelp(true)}
                    className="px-3 py-1.5 bg-gray-500 text-white rounded text-sm hover:bg-gray-600 flex items-center gap-1"
                    title="View revenue type definitions"
                  >
                    <HelpCircle className="w-4 h-4" /> Definitions
                  </button>
                </div>
              </div>
              <p className="text-xs text-gray-500 mb-2">💡 Set the Type for each revenue stream to calculate weighted recurring revenue. Toggle "Verified" when breakdown is confirmed from source documents.</p>
              {/* Portal form responses (migration 034): the owner classified
                  lines in the portal — review & accept applies them here. */}
              {ownerRevClassRows && (
                <div className="mb-2 p-3 rounded border border-green-300 bg-green-50">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-green-800">
                      📥 Owner {ownerRevClassRows.done ? 'completed' : 'has started'} the Revenue Classification in the portal
                    </span>
                    <span className="text-xs text-green-700">({Object.keys(ownerRevClassRows.rows).length} line{Object.keys(ownerRevClassRows.rows).length === 1 ? '' : 's'} answered)</span>
                    <button onClick={() => setShowOwnerFormReview(v => !v)} className="px-2 py-1 text-xs font-semibold rounded border border-green-600 text-green-700 hover:bg-green-100">{showOwnerFormReview ? 'Hide' : 'Review'}</button>
                    <button onClick={acceptOwnerRevenueClassification} className="px-3 py-1 text-xs font-semibold rounded bg-green-600 text-white hover:bg-green-700" title="Apply the owner's types to the table (marks lines Verified) and clear the review flag">✓ Accept into the table</button>
                  </div>
                  {showOwnerFormReview && (
                    <table className="w-full text-xs mt-2 border-collapse bg-white">
                      <thead><tr className="bg-green-100">
                        <th className="text-left p-1.5 border">Revenue line</th>
                        <th className="text-left p-1.5 border w-44">Owner's type</th>
                        <th className="text-left p-1.5 border">Owner notes</th>
                        <th className="text-left p-1.5 border w-44">Currently in the tool</th>
                      </tr></thead>
                      <tbody>
                        {revenueCategories.filter(c => c.name && ownerRespForCat(c)).map(c => {
                          const resp = ownerRespForCat(c);
                          const ownerTypeId = NUM_TO_REV_TYPE[String(resp.type || '').trim()];
                          const ownerLabel = ownerTypeId ? (revenueTypes.find(t => t.id === ownerTypeId)?.label || ownerTypeId) : '(no answer)';
                          const curLabel = revenueTypes.find(t => t.id === c.revenueType)?.label || c.revenueType || '—';
                          const differs = ownerTypeId && ownerTypeId !== c.revenueType;
                          return (
                            <tr key={c.id}>
                              <td className="p-1.5 border font-medium">{c.name}</td>
                              <td className={`p-1.5 border ${differs ? 'text-green-700 font-semibold' : ''}`}>{String(resp.type || '')} — {ownerLabel}</td>
                              <td className="p-1.5 border text-gray-600">{resp.notes || ''}</td>
                              <td className="p-1.5 border text-gray-500">{curLabel}{differs ? ' → will change' : ''}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
              <table className="w-full text-sm border-collapse">
                <thead><tr className="bg-blue-50">
                  <th className="text-left p-2 border">Category</th>
                  <th className="text-center p-2 border w-24">Status</th>
                  <th className="text-left p-2 border w-48">
                    <div className="flex items-center gap-1">
                      Type
                      <button 
                        onClick={() => setShowRevenueTypeHelp(true)}
                        className="text-blue-500 hover:text-blue-700 ml-1"
                        title="View revenue type definitions"
                      >
                        <HelpCircle className="w-4 h-4" />
                      </button>
                    </div>
                  </th>
                  <th className="text-right p-2 border" style={{width: '90px'}}>{displayYearLabels.year3}</th>
                  <th className="text-right p-2 border" style={{width: '90px'}}>{displayYearLabels.year4}</th>
                  <th className="text-right p-2 border" style={{width: '90px'}}>{displayYearLabels.year5}</th>
                  <th className="text-right p-2 border bg-blue-100" style={{width: '130px'}}>{ttmLabel}</th>
                </tr></thead>
                <tbody>
                  {revenueCategories.filter(cat => cat.name).map(cat => {
                    const basisData = cat[selectedValuationBasis] || {};
                    // Map legacy types to modern equivalents for dropdown
                    const legacyToModern = {
                      'recurring_contract': 'contracted_defined',
                      'recurring_switching': 'project_contracted',
                      'recurring_mtm': 'repeat_uncontracted',
                      'project_services': 'transactional',
                      'product': 'transactional'
                    };
                    const effectiveType = legacyToModern[cat.revenueType] || cat.revenueType || 'transactional';
                    const isRecurring = ['contracted_defined', 'project_contracted', 'hardware_contracted', 'repeat_uncontracted', 'recurring_licensing', 'recurring_contract', 'recurring_switching', 'recurring_mtm'].includes(cat.revenueType);
                    const isSplit = cat.isSplit === true;
                    return (
                      <tr key={cat.id} className={isSplit ? 'bg-amber-50' : (isRecurring ? 'bg-blue-50' : '')}>
                        <td className="p-2 border font-medium">
                          <div className="flex items-center gap-1">
                            {isSplit && <span className="text-amber-600">↳</span>}
                            <span className={isSplit ? 'text-amber-700' : ''}>{cat.name}</span>
                            {isSplit && (
                              <button
                                onClick={() => {
                                  if (confirm('Delete this split category?')) {
                                    captureUndoState('Delete Split');
                                    setRevenueCategories(prev => prev.filter(c => c.id !== cat.id));
                                  }
                                }}
                                className="ml-auto px-1 text-red-500 hover:text-red-700 text-xs"
                                title="Delete split"
                              >✕</button>
                            )}
                          </div>
                        </td>
                        <td className="p-1 border text-center">
                          <button
                            onClick={() => setRevenueCategories(prev => prev.map(c => c.id === cat.id ? {
                              ...c, 
                              isVerified: !c.isVerified,
                              verifiedAt: !c.isVerified ? new Date().toLocaleDateString() : null
                            } : c))}
                            className={`px-2 py-0.5 rounded text-xs font-medium transition-colors ${
                              cat.isVerified 
                                ? 'bg-green-100 text-green-700 hover:bg-green-200' 
                                : 'bg-amber-100 text-amber-700 hover:bg-amber-200'
                            }`}
                            title={cat.isVerified ? `Verified on ${cat.verifiedAt || 'unknown'} - Click to mark as estimate` : 'Click to mark as verified'}
                          >
                            {cat.isVerified ? '✓ Verified' : '⚠ Estimate'}
                          </button>
                        </td>
                        <td className="p-1 border">
                          <div className="flex items-center gap-1">
                            <select 
                              value={effectiveType} 
                              onChange={e => {
                                const newType = e.target.value;
                                setRevenueCategories(prev => prev.map(c => c.id === cat.id ? {...c, revenueType: newType, typeSplits: {}} : c));
                              }}
                              className={`flex-1 p-1 border rounded text-xs ${cat.typeSplits && Object.keys(cat.typeSplits).length > 0 ? 'bg-purple-100' : (isRecurring ? 'bg-blue-100' : 'bg-gray-100')}`}
                              title={cat.typeSplits && Object.keys(cat.typeSplits).length > 0 ? 'Split defined - click % to edit' : (revenueTypes.find(t => t.id === effectiveType)?.tooltip || '')}
                              disabled={cat.typeSplits && Object.keys(cat.typeSplits).length > 0}
                            >
                              {revenueTypes.filter(t => !t.legacy).map(type => (
                                <option key={type.id} value={type.id} title={type.tooltip}>{type.label}</option>
                              ))}
                            </select>
                            <button
                              onClick={() => setSplitEditorCategory({...cat})}
                              className={`px-1.5 py-0.5 rounded text-xs font-medium ${
                                cat.typeSplits && Object.keys(cat.typeSplits).length > 0 
                                  ? 'bg-purple-600 text-white hover:bg-purple-700' 
                                  : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                              }`}
                              title={cat.typeSplits && Object.keys(cat.typeSplits).length > 0 
                                ? `Split: ${Object.entries(cat.typeSplits).map(([k,v]) => `${v}% ${revenueTypes.find(t=>t.id===k)?.label.split(' ')[0]}`).join(', ')}`
                                : 'Define % split across multiple types'
                              }
                            >
                              {cat.typeSplits && Object.keys(cat.typeSplits).length > 0 ? '✓%' : '%'}
                            </button>
                          </div>
                        </td>
                        {isSplit ? (
                          <React.Fragment>
                            <td className="p-1 border"><input type="number" value={basisData.year3 || ''} onChange={e => setRevenueCategories(prev => prev.map(c => c.id === cat.id ? {...c, cash: {...c.cash, year3: parseFloat(e.target.value) || 0}, accrual: {...c.accrual, year3: parseFloat(e.target.value) || 0}} : c))} className="w-full p-1 border rounded text-right text-xs" placeholder="0" /></td>
                            <td className="p-1 border"><input type="number" value={basisData.year4 || ''} onChange={e => setRevenueCategories(prev => prev.map(c => c.id === cat.id ? {...c, cash: {...c.cash, year4: parseFloat(e.target.value) || 0}, accrual: {...c.accrual, year4: parseFloat(e.target.value) || 0}} : c))} className="w-full p-1 border rounded text-right text-xs" placeholder="0" /></td>
                            <td className="p-1 border"><input type="number" value={basisData.year5 || ''} onChange={e => setRevenueCategories(prev => prev.map(c => c.id === cat.id ? {...c, cash: {...c.cash, year5: parseFloat(e.target.value) || 0}, accrual: {...c.accrual, year5: parseFloat(e.target.value) || 0}} : c))} className="w-full p-1 border rounded text-right text-xs" placeholder="0" /></td>
                            <td className="p-1 border bg-amber-100"><input type="number" value={basisData.ttm || ''} onChange={e => setRevenueCategories(prev => prev.map(c => c.id === cat.id ? {...c, cash: {...c.cash, ttm: parseFloat(e.target.value) || 0}, accrual: {...c.accrual, ttm: parseFloat(e.target.value) || 0}} : c))} className="w-full p-1 border rounded text-right text-xs font-semibold" placeholder="0" /></td>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <td className="p-2 border text-right">{formatCurrency(basisData.year3 || 0)}</td>
                            <td className="p-2 border text-right">{formatCurrency(basisData.year4 || 0)}</td>
                            <td className="p-2 border text-right">{formatCurrency(basisData.year5 || 0)}</td>
                            <td className="p-2 border text-right bg-blue-100 font-semibold">{formatCurrency(basisData.ttm || 0)}</td>
                          </React.Fragment>
                        )}
                      </tr>
                    );
                  })}
                  {/* Total Row */}
                  <tr className="bg-blue-200 font-semibold">
                    <td className="p-2 border" colSpan="3">TOTAL REVENUE</td>
                    <td className="p-2 border text-right">{formatCurrency(revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0))}</td>
                    <td className="p-2 border text-right">{formatCurrency(revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0))}</td>
                    <td className="p-2 border text-right">{formatCurrency(revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0))}</td>
                    <td className="p-2 border text-right bg-blue-200">{formatCurrency(revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0))}</td>
                  </tr>
                  {/* Recurring Revenue Breakdown */}
                  {(() => {
                    const calcTypePct = (type, yearKey) => {
                      // Include legacy mappings for backward compatibility
                      const typeIds = {
                        'contracted_defined': ['contracted_defined', 'recurring_contract'],
                        'project_contracted': ['project_contracted', 'recurring_switching'],
                        'hardware_contracted': ['hardware_contracted'],
                        'recurring_licensing': ['recurring_licensing'],
                        'repeat_uncontracted': ['repeat_uncontracted', 'recurring_mtm'],
                        'transactional': ['transactional', 'project_services', 'product']
                      };
                      const ids = typeIds[type] || [type];
                      const typeTotal = revenueCategories.filter(c => ids.includes(c.revenueType)).reduce((sum, c) => sum + (c[selectedValuationBasis]?.[yearKey] || 0), 0);
                      const total = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.[yearKey] || 0), 0);
                      return total > 0 ? (typeTotal / total) * 100 : 0;
                    };
                    const calcTotalRecurringPct = (yearKey) => {
                      const recurringIds = ['contracted_defined', 'recurring_contract', 'project_contracted', 'recurring_switching', 'hardware_contracted', 'recurring_licensing', 'recurring_mtm', 'repeat_uncontracted'];
                      const recurringTotal = revenueCategories.filter(c => recurringIds.includes(c.revenueType)).reduce((sum, c) => sum + (c[selectedValuationBasis]?.[yearKey] || 0), 0);
                      const total = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.[yearKey] || 0), 0);
                      return total > 0 ? (recurringTotal / total) * 100 : 0;
                    };
                    const hasHardwareType = revenueCategories.some(c => c.revenueType === 'hardware_contracted');
                    const hasLicensingType = revenueCategories.some(c => c.revenueType === 'recurring_licensing' || (c.typeSplits && c.typeSplits.recurring_licensing));
                    return (
                      <>
                        <tr className="bg-blue-50 text-xs">
                          <td className="p-1 border pl-4 text-green-800" colSpan="3">↳ Contracted - Defined Revenue (100%)</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('contracted_defined', 'year3').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('contracted_defined', 'year4').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('contracted_defined', 'year5').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700 bg-blue-100">{calcTypePct('contracted_defined', 'ttm').toFixed(1)}%</td>
                        </tr>
                        <tr className="bg-blue-50 text-xs">
                          <td className="p-1 border pl-4 text-green-800" colSpan="3">↳ Service Projects - Contracted Client (50%)</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('project_contracted', 'year3').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('project_contracted', 'year4').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('project_contracted', 'year5').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700 bg-blue-100">{calcTypePct('project_contracted', 'ttm').toFixed(1)}%</td>
                        </tr>
                        {hasLicensingType && (
                        <tr className="bg-blue-50 text-xs">
                          <td className="p-1 border pl-4 text-green-800" colSpan="3">↳ Recurring Licensing / Subscription Resale (75%)</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('recurring_licensing', 'year3').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('recurring_licensing', 'year4').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('recurring_licensing', 'year5').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700 bg-blue-100">{calcTypePct('recurring_licensing', 'ttm').toFixed(1)}%</td>
                        </tr>
                        )}
                        {hasHardwareType && (
                        <tr className="bg-blue-50 text-xs">
                          <td className="p-1 border pl-4 text-amber-700" colSpan="3">↳ Hardware/Product - Contracted Client (25%)</td>
                          <td className="p-1 border text-right text-amber-600">{calcTypePct('hardware_contracted', 'year3').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-amber-600">{calcTypePct('hardware_contracted', 'year4').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-amber-600">{calcTypePct('hardware_contracted', 'year5').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-amber-600 bg-blue-100">{calcTypePct('hardware_contracted', 'ttm').toFixed(1)}%</td>
                        </tr>
                        )}
                        <tr className="bg-blue-50 text-xs">
                          <td className="p-1 border pl-4 text-green-800" colSpan="3">↳ Repeat - Uncontracted (25%)</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('repeat_uncontracted', 'year3').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('repeat_uncontracted', 'year4').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700">{calcTypePct('repeat_uncontracted', 'year5').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-700 bg-blue-100">{calcTypePct('repeat_uncontracted', 'ttm').toFixed(1)}%</td>
                        </tr>
                        <tr className="bg-blue-100 font-semibold text-sm">
                          <td className="p-1 border pl-4 text-green-900" colSpan="3">Total Recurring/Repeat Revenue</td>
                          <td className="p-1 border text-right text-green-900">{calcTotalRecurringPct('year3').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-900">{calcTotalRecurringPct('year4').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-900">{calcTotalRecurringPct('year5').toFixed(1)}%</td>
                          <td className="p-1 border text-right text-green-900 bg-blue-100">{calcTotalRecurringPct('ttm').toFixed(1)}%</td>
                        </tr>
                      </>
                    );
                  })()}
                </tbody>
              </table>
              <div className="mt-2 p-2 bg-amber-50 border border-amber-200 rounded flex items-center justify-between">
                <span className="text-xs text-amber-700">
                  <strong>✂️ Mixed Revenue?</strong> If a P&L line contains multiple types, add a split category with estimated amounts.
                </span>
                <button
                  onClick={() => {
                    const name = prompt('Enter split category name (e.g., "IT Services - Break/Fix"):');
                    if (name && name.trim()) {
                      captureUndoState('Add Split Category');
                      setRevenueCategories(prev => [...prev, {
                        id: 'rev_split_' + Date.now(),
                        name: name.trim(),
                        revenueType: 'transactional',
                        isVerified: false,
                        isSplit: true,
                        cash: { year3: 0, year4: 0, year5: 0, ttm: 0 },
                        accrual: { year3: 0, year4: 0, year5: 0, ttm: 0 }
                      }]);
                    }
                  }}
                  className="px-2 py-1 bg-amber-500 text-white text-xs rounded hover:bg-amber-600 whitespace-nowrap"
                >
                  + Add Split
                </button>
              </div>
              <div className="mt-2 text-xs text-gray-500">
                <span className="font-semibold">Weighted Recurring (for Multiple):</span> Contracted-Defined = 100%, Service Projects = 50%, Hardware/Product = 25%, Repeat-Uncontracted = 25%, Transactional/New = 0%
                <button 
                  onClick={() => setShowRevenueTypeHelp(true)}
                  className="ml-2 text-blue-500 hover:text-blue-700 underline"
                >
                  View full definitions
                </button>
              </div>
            </div>

            {/* COGS Categories - Display only from P&L Entry */}
            <div className="mb-6">
              <h3 className="font-bold text-gray-800 mb-2"><span className="bg-slate-200 text-slate-800 px-2 py-0.5 rounded text-xs mr-2">FROM P&L ENTRY</span>COGS Categories</h3>
              <table className="w-full text-sm border-collapse">
                <thead><tr className="bg-slate-100">
                  <th className="text-left p-2 border">Category</th>
                  <th className="text-right p-2 border" style={{width: '90px'}}>{displayYearLabels.year3}</th>
                  <th className="text-right p-2 border" style={{width: '90px'}}>{displayYearLabels.year4}</th>
                  <th className="text-right p-2 border" style={{width: '90px'}}>{displayYearLabels.year5}</th>
                  <th className="text-right p-2 border bg-slate-200" style={{width: '130px'}}>{ttmLabel}</th>
                </tr></thead>
                <tbody>
                  {cogsCategories.filter(cat => cat.name).map(cat => {
                    const basisData = cat[selectedValuationBasis] || {};
                    return (
                      <tr key={cat.id}>
                        <td className="p-2 border font-medium">{cat.name}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisData.year3 || 0)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisData.year4 || 0)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisData.year5 || 0)}</td>
                        <td className="p-2 border text-right bg-slate-100 font-semibold">{formatCurrency(basisData.ttm || 0)}</td>
                      </tr>
                    );
                  })}
                  <tr className="bg-slate-200 font-bold">
                    <td className="p-2 border">TOTAL COGS</td>
                    <td className="p-2 border text-right">{formatCurrency(cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0))}</td>
                    <td className="p-2 border text-right">{formatCurrency(cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0))}</td>
                    <td className="p-2 border text-right">{formatCurrency(cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0))}</td>
                    <td className="p-2 border text-right bg-slate-200">{formatCurrency(cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0))}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Revenue Stream Profitability Matching */}
            <div className="mb-6">
              <h3 className="font-bold text-gray-800 mb-2 flex items-center gap-2"><Link className="w-4 h-4" /> Revenue-to-COGS Matching (Gross Margin by Stream)</h3>
              <p className="text-xs text-gray-500 mb-3">Match revenue lines to their associated COGS to see gross margin for each revenue stream.</p>
              
              {/* Add New Stream */}
              <div className="bg-gray-50 p-3 rounded-lg mb-4 border">
                <div className="grid grid-cols-3 gap-3 mb-2">
                  <div>
                    <label className="text-xs font-medium text-gray-600">Stream Name</label>
                    <input 
                      type="text" 
                      value={newStreamForm.name}
                      onChange={e => setNewStreamForm({...newStreamForm, name: e.target.value})}
                      placeholder="e.g., Product Sales, Service Revenue"
                      className="w-full p-2 border rounded text-sm mt-1"
                    />
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-600">Revenue Lines (click to select)</label>
                    <div className="border rounded mt-1 p-2 bg-white max-h-24 overflow-y-auto">
                      {revenueCategories.filter(c => c.name).length === 0 ? (
                        <div className="text-xs text-gray-400 italic">No revenue categories</div>
                      ) : (
                        revenueCategories.filter(c => c.name).map(cat => (
                          <label key={cat.id} className="flex items-center gap-2 text-xs py-0.5 hover:bg-blue-50 cursor-pointer">
                            <input 
                              type="checkbox"
                              checked={newStreamForm.revenueIds.includes(cat.id)}
                              onChange={e => {
                                if (e.target.checked) {
                                  setNewStreamForm({...newStreamForm, revenueIds: [...newStreamForm.revenueIds, cat.id]});
                                } else {
                                  setNewStreamForm({...newStreamForm, revenueIds: newStreamForm.revenueIds.filter(id => id !== cat.id)});
                                }
                              }}
                              className="rounded"
                            />
                            <span className={newStreamForm.revenueIds.includes(cat.id) ? 'font-medium text-blue-700' : ''}>{cat.name}</span>
                          </label>
                        ))
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-600">COGS Lines (click to select)</label>
                    <div className="border rounded mt-1 p-2 bg-white max-h-24 overflow-y-auto">
                      {cogsCategories.filter(c => c.name).length === 0 ? (
                        <div className="text-xs text-gray-400 italic">No COGS categories</div>
                      ) : (
                        cogsCategories.filter(c => c.name).map(cat => (
                          <label key={cat.id} className="flex items-center gap-2 text-xs py-0.5 hover:bg-slate-50 cursor-pointer">
                            <input 
                              type="checkbox"
                              checked={newStreamForm.cogsIds.includes(cat.id)}
                              onChange={e => {
                                if (e.target.checked) {
                                  setNewStreamForm({...newStreamForm, cogsIds: [...newStreamForm.cogsIds, cat.id]});
                                } else {
                                  setNewStreamForm({...newStreamForm, cogsIds: newStreamForm.cogsIds.filter(id => id !== cat.id)});
                                }
                              }}
                              className="rounded"
                            />
                            <span className={newStreamForm.cogsIds.includes(cat.id) ? 'font-medium text-slate-700' : ''}>{cat.name}</span>
                          </label>
                        ))
                      )}
                    </div>
                  </div>
                </div>
                <button 
                  onClick={() => {
                    if (newStreamForm.name.trim() && (newStreamForm.revenueIds.length > 0 || newStreamForm.cogsIds.length > 0)) {
                      setRevenueStreams([...revenueStreams, { 
                        id: Date.now(), 
                        name: newStreamForm.name.trim(), 
                        revenueIds: newStreamForm.revenueIds, 
                        cogsIds: newStreamForm.cogsIds, 
                        status: 'ask_owner' 
                      }]);
                      setNewStreamForm({ name: '', revenueIds: [], cogsIds: [] });
                    }
                  }}
                  className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                >
                  + Add Stream
                </button>
              </div>

              {/* Stream Cards */}
              {revenueStreams.length === 0 ? (
                <div className="text-center py-6 text-gray-500 border rounded-lg bg-gray-50">
                  <p>No revenue streams defined yet.</p>
                  <p className="text-xs mt-1">Create a stream above to match revenue lines to their COGS and see gross margin.</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {revenueStreams.map(stream => {
                    const revCats = revenueCategories.filter(c => stream.revenueIds?.includes(c.id));
                    const cogsCats = cogsCategories.filter(c => stream.cogsIds?.includes(c.id));
                    
                    // Calculate for each period
                    const periods = ['year3', 'year4', 'year5', 'ttm'];
                    const periodLabels = { year3: basisYearLabels.year3, year4: basisYearLabels.year4, year5: basisYearLabels.year5, ttm: ttmLabel };
                    const periodData = periods.map(period => {
                      const rev = revCats.reduce((sum, c) => sum + (c[selectedValuationBasis]?.[period] || 0), 0);
                      const cogs = cogsCats.reduce((sum, c) => sum + (c[selectedValuationBasis]?.[period] || 0), 0);
                      const gp = rev - cogs;
                      const gpm = rev > 0 ? (gp / rev) * 100 : 0;
                      return { period, label: periodLabels[period], rev, cogs, gp, gpm };
                    });
                    
                    // Check for trend issues
                    const ttmGpm = periodData.find(p => p.period === 'ttm')?.gpm || 0;
                    const flag = ttmGpm < 0 ? 'negative' : ttmGpm < 20 ? 'low' : null;
                    
                    // Check GPM trend (declining?)
                    const gpmValues = periodData.filter(p => p.rev > 0).map(p => p.gpm);
                    const isDecline = gpmValues.length >= 2 && gpmValues[gpmValues.length - 1] < gpmValues[0] - 5;
                    
                    return (
                      <div key={stream.id} className={`rounded-lg border ${flag === 'negative' ? 'bg-amber-50 border-amber-300' : flag === 'low' ? 'bg-slate-50 border-slate-300' : 'bg-gray-50'}`}>
                        <div className="flex justify-between items-start p-3 border-b">
                          <div>
                            <div className="font-bold text-gray-800 flex items-center gap-2">
                              {stream.name}
                              {isDecline && <span className="text-xs bg-slate-200 text-orange-800 px-2 py-0.5 rounded">↓ Declining GPM</span>}
                            </div>
                            <div className="text-xs text-gray-600">
                              Revenue: {revCats.map(c => c.name).join(', ') || '(none)'} → 
                              COGS: {cogsCats.map(c => c.name).join(', ') || '(none)'}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <select 
                              value={stream.status} 
                              onChange={e => {
                                const newStatus = e.target.value;
                                setRevenueStreams(revenueStreams.map(s => s.id === stream.id ? {
                                  ...s, 
                                  status: newStatus,
                                  confirmedAt: newStatus === 'confirmed' ? new Date().toLocaleDateString() : s.confirmedAt
                                } : s));
                              }}
                              className="text-xs border rounded px-2 py-1"
                            >
                              <option value="confirmed">✓ Confirmed</option>
                              <option value="ask_owner">❓ Ask Owner</option>
                              <option value="needs_review">⚠️ Needs Review</option>
                            </select>
                            <button 
                              onClick={() => {
                                captureUndoState('Delete Revenue Stream');
                                setRevenueStreams(revenueStreams.filter(s => s.id !== stream.id));
                              }}
                              className="text-red-500 hover:text-red-700"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                        <table className="w-full text-sm table-fixed">
                          <thead>
                            <tr className="bg-gray-100 text-xs">
                              <th className="p-2 text-left w-24"></th>
                              {periodData.map(p => (
                                <th key={p.period} className={`p-2 text-right w-24 ${p.period === 'ttm' ? 'bg-blue-100' : ''}`}>{p.label}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="p-2 text-gray-600 font-medium">Revenue</td>
                              {periodData.map(p => (
                                <td key={p.period} className={`p-2 text-right ${p.period === 'ttm' ? 'bg-blue-50 font-semibold' : ''}`}>{formatCurrency(p.rev)}</td>
                              ))}
                            </tr>
                            <tr>
                              <td className="p-2 text-gray-600 font-medium">COGS</td>
                              {periodData.map(p => (
                                <td key={p.period} className={`p-2 text-right ${p.period === 'ttm' ? 'bg-blue-50 font-semibold' : ''}`}>{formatCurrency(p.cogs)}</td>
                              ))}
                            </tr>
                            <tr className="border-t">
                              <td className="p-2 text-gray-600 font-medium">Gross Profit</td>
                              {periodData.map(p => (
                                <td key={p.period} className={`p-2 text-right font-semibold ${p.gp < 0 ? 'text-red-600' : 'text-green-600'} ${p.period === 'ttm' ? 'bg-blue-50' : ''}`}>{formatCurrency(p.gp)}</td>
                              ))}
                            </tr>
                            <tr className="bg-gray-50 font-bold">
                              <td className="p-2 text-gray-800">GPM %</td>
                              {periodData.map(p => (
                                <td key={p.period} className={`p-2 text-right text-lg ${p.gpm < 0 ? 'text-red-600' : p.gpm < 20 ? 'text-yellow-600' : 'text-green-600'} ${p.period === 'ttm' ? 'bg-blue-100' : ''}`}>
                                  {p.rev > 0 ? formatPercent(p.gpm) : '-'}
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        ) : viewMode === 'overview' ? (
          /* ========== OVERVIEW TAB ========== */
          <div>
            {/* ===== COMPANY HEADER ===== */}
            <div className="bg-gradient-to-r from-slate-800 to-slate-700 p-4 rounded-lg mb-4 text-white">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-2xl font-bold">{dealProfile.companyName || 'Company Name Not Set'}</h2>
                  <p className="text-slate-300 mt-1">
                    {selectedIndustryObj ? selectedIndustryObj.name : 'Industry Not Set'}
                    <span className="mx-2 text-slate-500">|</span>
                    {dealProfile.city || 'City'}, {dealProfile.state || 'State'}
                    <span className="mx-2 text-slate-500">|</span>
                    {dealProfile.locationType === 'major_metro' ? 'Major Metro' : dealProfile.locationType === 'small_city' ? 'Small City' : dealProfile.locationType === 'rural' ? 'Rural' : dealProfile.locationType === 'suburban' ? 'Suburban' : '—'} Market
                  </p>
                </div>
                <div className="text-right">
                  <div className="text-sm text-slate-400">Valuation Range</div>
                  <div className="text-xl font-bold text-amber-300">{formatCurrency(multipleEngineCalcs.valuationTypical)} – {formatCurrency(multipleEngineCalcs.valuationMarketHigh)}</div>
                  <div className="text-xs text-slate-300 mt-1">
                    <span className="text-amber-200 font-medium">{formatCurrency(multipleEngineCalcs.adjustedEbitda)}</span>
                    <span className="text-slate-400"> TTM Adj. EBITDA</span>
                    <span className="mx-1 text-slate-500">×</span>
                    <span>{multipleEngineCalcs.typicalMultiple.toFixed(2)}x – {multipleEngineCalcs.marketHighMultiple.toFixed(2)}x</span>
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5">
                    Basis: {selectedValuationBasis === 'cash' ? 'Cash' : selectedValuationBasis === 'tax' ? 'Tax Return' : 'Accrual'}
                    <span className="mx-1">|</span>
                    {ttmLabel}
                  </div>
                </div>
              </div>
            </div>

            {/* ===== EXECUTIVE SNAPSHOT ===== */}
            {(() => {
              const ttmRev = calculations.years[5]?.revenue || 0;
              const prevRev = calculations.years[4]?.revenue || 0;
              const revGrowth = prevRev > 0 ? ((ttmRev - prevRev) / prevRev * 100) : null;
              const adjEbitda = calculations.valuation?.metric || 0;
              const ebitdaMargin = keyMetrics.ebitdaMargin || 0;
              const recurPct = keyMetrics.recurringPct || 0;
              const topCustPct = keyMetrics.topCustomerPct || 0;
              const top5Pct = keyMetrics.top5CustomersPct || 0;
              const retention = keyMetrics.avgRetention;
              const nrr = keyMetrics.avgNRR;
              const revCAGR = keyMetrics.revCAGR;
              const bench = currentBenchmarks;

              // Traffic light helper: returns [colorClass, label]
              const signal = (value, good, warn, invert) => {
                if (value === null || value === undefined) return ['text-gray-400', '—'];
                if (invert) { // lower is better (e.g. concentration)
                  if (value <= good) return ['text-green-600', '●'];
                  if (value <= warn) return ['text-yellow-600', '●'];
                  return ['text-red-600', '●'];
                } else { // higher is better
                  if (value >= good) return ['text-green-600', '●'];
                  if (value >= warn) return ['text-yellow-600', '●'];
                  return ['text-red-600', '●'];
                }
              };

              const cards = [
                {
                  label: 'TTM Revenue',
                  value: formatCurrency(ttmRev),
                  sub: revGrowth !== null ? `${revGrowth >= 0 ? '+' : ''}${revGrowth.toFixed(1)}% YoY` : 'No prior year',
                  signal: signal(revGrowth, 5, 0, false),
                  subColor: revGrowth !== null ? (revGrowth >= 0 ? 'text-green-600' : 'text-red-600') : 'text-gray-400'
                },
                {
                  label: 'Adj. EBITDA',
                  value: formatCurrency(adjEbitda),
                  sub: `${ebitdaMargin.toFixed(1)}% margin`,
                  signal: signal(ebitdaMargin, bench.ebitdaMargin, bench.ebitdaMargin * 0.7, false),
                  subColor: ebitdaMargin >= bench.ebitdaMargin ? 'text-green-600' : ebitdaMargin >= bench.ebitdaMargin * 0.7 ? 'text-yellow-600' : 'text-red-600',
                  bench: `Ind: ${bench.ebitdaMargin}%`
                },
                {
                  label: 'Rev/Employee',
                  value: keyMetrics.revenuePerEmployee ? formatCurrency(keyMetrics.revenuePerEmployee) : '—',
                  sub: keyMetrics.employeeCount ? `${keyMetrics.employeeCount} employees` : 'Need employee count',
                  signal: signal(keyMetrics.revenuePerEmployee, 200000, 150000, false),
                  subColor: keyMetrics.revenuePerEmployee ? (keyMetrics.revenuePerEmployee >= 200000 ? 'text-green-600' : keyMetrics.revenuePerEmployee >= 150000 ? 'text-yellow-600' : 'text-gray-500') : 'text-gray-400'
                },
                {
                  label: 'Recurring Rev.',
                  value: `${recurPct.toFixed(0)}%`,
                  sub: `Benchmark: ${bench.recurringRevenuePct}%`,
                  signal: signal(recurPct, bench.recurringRevenuePct, bench.recurringRevenuePct * 0.7, false),
                  subColor: recurPct >= bench.recurringRevenuePct ? 'text-green-600' : 'text-gray-500'
                },
                {
                  label: 'Top Customer',
                  value: `${topCustPct.toFixed(1)}%`,
                  sub: top5Pct > 0 ? `Top 5: ${top5Pct.toFixed(0)}%` : 'No sales data',
                  signal: signal(topCustPct, bench.topCustomerConcentration, bench.topCustomerConcentration * 1.5, true),
                  subColor: topCustPct <= bench.topCustomerConcentration ? 'text-green-600' : topCustPct <= bench.topCustomerConcentration * 1.5 ? 'text-yellow-600' : 'text-red-600',
                  bench: `Ind: <${bench.topCustomerConcentration}%`
                },
                {
                  label: 'Rev. Retention',
                  value: retention !== null ? `${retention.toFixed(0)}%` : '—',
                  sub: nrr !== null ? `Net Retention: ${nrr.toFixed(0)}%` : 'Need sales data',
                  signal: signal(retention, bench.customerRetentionRate, bench.customerRetentionRate * 0.9, false),
                  subColor: retention !== null && retention >= bench.customerRetentionRate ? 'text-green-600' : 'text-gray-500',
                  bench: retention !== null ? `Ind: ${bench.customerRetentionRate}%` : null
                },
                {
                  label: 'Rev. CAGR (2yr)',
                  value: revCAGR !== null ? `${revCAGR.toFixed(1)}%` : '—',
                  sub: revCAGR !== null ? (revCAGR >= bench.industryGrowthRate ? 'Above industry' : 'Below industry') : 'Need 3yr data',
                  signal: signal(revCAGR, bench.industryGrowthRate, 0, false),
                  subColor: revCAGR !== null && revCAGR >= bench.industryGrowthRate ? 'text-green-600' : 'text-gray-500',
                  bench: revCAGR !== null ? `Ind: ${bench.industryGrowthRate}%` : null
                }
              ];

              return (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Executive Snapshot</h3>
                  <div className="grid grid-cols-7 gap-2">
                    {cards.map((c, i) => (
                      <div key={i} className="bg-white border rounded-lg p-3">
                        <div className="flex items-center justify-between mb-1">
                          <span className="text-xs text-gray-500">{c.label}</span>
                          <span className={`text-sm ${c.signal[0]}`}>{c.signal[1]}</span>
                        </div>
                        <div className="text-lg font-bold text-gray-900">{c.value}</div>
                        <div className={`text-xs ${c.subColor}`}>{c.sub}</div>
                        {c.bench && <div className="text-xs text-gray-400 mt-0.5">{c.bench}</div>}
                      </div>
                    ))}
                  </div>

                  {/* Owner-Provided Data Heads-Up */}
                  {(() => {
                    const dp = multipleEngineCalcs.dataProvenance;
                    if (!dp) return null;
                    const items = [];
                    if (dp.revenueCategories.hasCategories && dp.revenueCategories.allEstimated) {
                      items.push('Revenue categories are estimated (Export Class. Form not provided)');
                    }
                    if (!dp.clientDetail.contractDataProvided) {
                      items.push('Client contract terms not provided (Client Detail Form not returned)');
                    }
                    if (items.length === 0) return null;
                    return (
                      <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <div className="flex items-start gap-2">
                          <span className="text-amber-600 text-lg leading-tight">⚠️</span>
                          <div className="text-sm text-amber-800">
                            <span className="font-semibold">Owner-provided data missing — multiple is running on defaults:</span>
                            <ul className="mt-1 ml-4 list-disc text-amber-700">
                              {items.map((m, i) => <li key={i}>{m}</li>)}
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Roll-Off Risk Alert */}
                  {rollOffAnalysis.hasData && rollOffAnalysis.nearTermAtRisk.length > 0 && (
                    <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-red-600 text-lg">⚠️</span>
                          <div>
                            <span className="font-semibold text-red-800">Roll-Off Risk: </span>
                            <span className="text-red-700">
                              {rollOffAnalysis.nearTermAtRisk.length} high-performing month{rollOffAnalysis.nearTermAtRisk.length > 1 ? 's' : ''} ({rollOffAnalysis.nearTermAtRisk.map(m => m.monthLabel).join(', ')}) will roll off within {Math.min(...rollOffAnalysis.nearTermAtRisk.map(m => m.monthsUntilRollOff))} month{Math.min(...rollOffAnalysis.nearTermAtRisk.map(m => m.monthsUntilRollOff)) !== 1 ? 's' : ''}
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-3">
                          <div className="text-right">
                            <div className="text-xs text-red-600">Valuation at Risk</div>
                            <div className="font-bold text-red-800">{formatCurrency(rollOffAnalysis.totalAtRiskValuation)}</div>
                          </div>
                          <button 
                            onClick={() => { setViewMode('detailed'); setIncomeStmtViewMode('monthly'); setRollOffExpanded(true); }} 
                            className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm rounded"
                          >
                            View Analysis →
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* AR Quality Alert - show if significant negative balances */}
                  {(() => {
                    const negAmt = Math.abs(arAgingCalcs.negativeBalances || 0);
                    const negCount = arAgingCalcs.negativeAccountCount || 0;
                    const totalAR = arAgingCalcs.totalAR || 0;
                    const pastDuePct = totalAR > 0 ? (arAgingCalcs.pastDue / totalAR * 100) : 0;
                    const seriousPct = totalAR > 0 ? (arAgingCalcs.seriouslyPastDue / totalAR * 100) : 0;
                    
                    // Show alert if: large negative amount (>$5K) OR many negative accounts (>3) OR high past due (>30%)
                    const hasSignificantNegatives = negAmt > 5000 || negCount > 3;
                    const hasHighPastDue = pastDuePct > 30 || seriousPct > 15;
                    
                    if (!hasSignificantNegatives && !hasHighPastDue) return null;
                    if (arReviewChecklist.notApplicable) return null;
                    if (totalAR === 0) return null;
                    
                    return (
                      <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <span className="text-amber-600 text-lg">⚠️</span>
                            <div>
                              <span className="font-semibold text-amber-800">AR Quality Issues: </span>
                              <span className="text-amber-700">
                                {hasSignificantNegatives && (
                                  <span>{negCount} negative account{negCount !== 1 ? 's' : ''} totaling {formatCurrency(negAmt)}</span>
                                )}
                                {hasSignificantNegatives && hasHighPastDue && ' • '}
                                {hasHighPastDue && (
                                  <span>{pastDuePct.toFixed(0)}% past due{seriousPct > 15 ? ` (${seriousPct.toFixed(0)}% seriously past due)` : ''}</span>
                                )}
                              </span>
                            </div>
                          </div>
                          <button 
                            onClick={() => setViewMode('arapanalysis')} 
                            className="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white text-sm rounded"
                          >
                            View Analysis →
                          </button>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              );
            })()}


            {/* ===== MONTHLY SALES ANALYSIS ===== */}
            {keyMetrics.hasMonthlySales && (() => {
              const customers = ttmBasisCustomers.filter(c => c.name);
              const monthLabels = monthlySalesMonthLabels;
              const churnBase = keyMetrics.churnComparisonBase || 'year5';
              return (
                <div className="border rounded-lg overflow-hidden mb-4">
                  <div
                    className="px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 bg-blue-100"
                    onClick={() => setMonthlySalesAnalysisExpanded(!monthlySalesAnalysisExpanded)}
                  >
                    <span className="flex items-center gap-2">
                      📅 Monthly Sales Analysis
                      <span className="px-2 py-0.5 rounded-full bg-blue-200 text-blue-700 text-xs font-normal">
                        {Object.keys(monthlySalesData).length} customers
                      </span>
                      {(() => {
                        const likelyLost = customers.filter(customer => {
                          const _mRaw = monthlySalesData[String(customer.id)];
                      const monthly = (_mRaw && !Array.isArray(_mRaw)) ? (_mRaw[salesTtmConfig?.basis || 'cash'] || Array(12).fill(0)) : (_mRaw || Array(12).fill(0));
                          const ttmTotal = monthly.slice(0,12).reduce((s,v) => s+(v||0), 0);
                          const baseVal = customer[churnBase] || 0;
                          return baseVal > 0 && ttmTotal > 0 && monthly.slice(9,12).every(v => (v||0) === 0) && !customer.lost;
                        });
                        return likelyLost.length > 0 ? (
                          <span className="px-2 py-0.5 rounded-full bg-orange-100 text-orange-700 text-xs font-normal">
                            ⚠️ {likelyLost.length} unconfirmed
                          </span>
                        ) : null;
                      })()}
                    </span>
                    <span>{monthlySalesAnalysisExpanded ? '▼' : '▶'}</span>
                  </div>
                  {monthlySalesAnalysisExpanded && (
                    <div className="p-3 bg-white">
                      <div className="overflow-x-auto">
                        <table className="w-full text-xs border-collapse">
                          <thead>
                            <tr className="bg-gray-800 text-white">
                              <th className="p-2 text-left border border-gray-600 sticky left-0 bg-gray-800 z-10" style={{minWidth:'180px'}}>Customer</th>
                              <th className="p-1.5 text-center border border-gray-600 w-20">Status</th>
                              {monthLabels.map((lbl, i) => (
                                <th key={i} className="p-1 text-right border border-gray-600 whitespace-nowrap" style={{minWidth:'62px'}}>{lbl}</th>
                              ))}
                              <th className="p-1.5 text-right border border-gray-600 bg-green-800 whitespace-nowrap" style={{minWidth:'80px'}}>TTM Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {customers.map((customer, idx) => {
                              const _mRaw = monthlySalesData[String(customer.id)];
                      const monthly = (_mRaw && !Array.isArray(_mRaw)) ? (_mRaw[salesTtmConfig?.basis || 'cash'] || Array(12).fill(0)) : (_mRaw || Array(12).fill(0));
                              const ttmTotal = monthly.slice(0,12).reduce((s,v) => s+(v||0), 0);
                              const fmt = v => v ? '$'+Math.round(v).toLocaleString() : '—';
                              const firstActive = monthly.findIndex(v => v > 0);
                              const baseVal = customer[churnBase] || 0;
                              const recentZero = baseVal > 0 && ttmTotal > 0 && monthly.slice(9,12).every(v => (v||0) === 0);
                              const isLikelyLost = recentZero && !customer.lost;
                              const rowBg = customer.lost ? 'bg-red-50' : isLikelyLost ? 'bg-orange-50' : customer.atRisk ? 'bg-amber-50' : firstActive > 0 ? 'bg-green-50' : idx % 2 === 0 ? 'bg-white' : 'bg-gray-50';
                              return (
                                <tr key={customer.id} className={rowBg}>
                                  <td className="p-1.5 border font-medium sticky left-0 bg-inherit z-10">
                                    {customer.name}
                                    {firstActive > 0 && <span className="ml-1 px-1 bg-green-200 text-green-800 rounded">New M{firstActive+1}</span>}
                                  </td>
                                  <td className="p-1 border text-center">
                                    {customer.lost ? <span className="text-red-600 font-medium">❌ Lost</span>
                                      : isLikelyLost ? <span className="text-orange-600 font-medium">⚠️ No Activity</span>
                                      : customer.atRisk ? <span className="text-amber-600 font-medium">⚠️ At Risk</span>
                                      : <span className="text-gray-300">—</span>}
                                  </td>
                                  {monthly.slice(0,12).map((v, mi) => (
                                    <td key={mi} className={`p-1 border text-right ${v > 0 ? 'text-gray-800' : 'text-gray-200'} ${mi >= 9 && (v||0) === 0 && baseVal > 0 && ttmTotal > 0 ? 'bg-red-50' : ''}`}>
                                      {fmt(v)}
                                    </td>
                                  ))}
                                  <td className={`p-1.5 border text-right font-semibold ${ttmTotal > 0 ? 'text-green-800 bg-green-50' : 'text-gray-400'}`}>{fmt(ttmTotal)}</td>
                                </tr>
                              );
                            })}
                            {(() => {
                              const mt = Array(12).fill(0);
                              customers.forEach(cust => { const _d=monthlySalesData[String(cust.id)]; const m=(_d&&!Array.isArray(_d))?(_d[salesTtmConfig?.basis||'cash']||[]):(_d||[]); m.slice(0,12).forEach((v,i)=>{ mt[i]+=(v||0); }); });
                              const gt = mt.reduce((s,v)=>s+v,0);
                              const fmt = v => v ? '$'+Math.round(v).toLocaleString() : '—';
                              return (
                                <tr className="bg-gray-800 text-white font-bold">
                                  <td className="p-1.5 border sticky left-0 bg-gray-800 z-10">Total</td>
                                  <td className="p-1 border"></td>
                                  {mt.map((v,i) => <td key={i} className="p-1 border text-right">{fmt(v)}</td>)}
                                  <td className="p-1.5 border text-right bg-green-800">{fmt(gt)}</td>
                                </tr>
                              );
                            })()}
                          </tbody>
                        </table>
                      </div>
                      {(() => {
                        const likelyLost = customers.filter(customer => {
                          const _mRaw = monthlySalesData[String(customer.id)];
                      const monthly = (_mRaw && !Array.isArray(_mRaw)) ? (_mRaw[salesTtmConfig?.basis || 'cash'] || Array(12).fill(0)) : (_mRaw || Array(12).fill(0));
                          const ttmTotal = monthly.slice(0,12).reduce((s,v) => s+(v||0), 0);
                          const baseVal = customer[churnBase] || 0;
                          return baseVal > 0 && ttmTotal > 0 && monthly.slice(9,12).every(v => (v||0) === 0) && !customer.lost;
                        });
                        if (likelyLost.length === 0) return null;
                        return (
                          <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                            <div className="font-semibold text-orange-800 mb-1">
                              ⚠️ {likelyLost.length} customer{likelyLost.length !== 1 ? 's' : ''} with no activity in last 3 months — not yet marked Lost
                            </div>
                            <div className="text-xs text-orange-700 mb-1">
                              {likelyLost.map((cust, i) => (
                                <span key={i}>{i > 0 ? ', ' : ''}{cust.name} ({formatCurrency(cust[churnBase] || 0)})</span>
                              ))}
                            </div>
                            <div className="text-xs text-orange-600">Review with owner — confirm if lost or still active. Mark status on the Sales tab.</div>
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* ===== CUSTOMER HEALTH ===== */}
            {(() => {
              const custCount = keyMetrics.customerCount?.ttm || 0;
              // Same base year the lost list uses (was year5 even when TTM = Year 5 switched the base to year4).
              const prevCount = keyMetrics.customerCount?.[keyMetrics.churnComparisonBase || 'year5'] || 0;
              const lost = keyMetrics.lostCustomers || [];
              const gained = keyMetrics.newCustomers || [];
              const lostRev = keyMetrics.lostRevenue || 0;
              const newRev = keyMetrics.newRevenue || 0;
              const netChange = gained.length - lost.length;
              const netRevChange = newRev - lostRev;
              const retention = keyMetrics.avgRetention;
              const nrr = keyMetrics.avgNRR;
              const atRisk = customerSalesData.filter(c => c.atRisk);
              const atRiskRev = atRisk.reduce((s, c) => s + (c.ttm || c.year5 || 0), 0);
              const ttmRev = calculations.years[5]?.revenue || 0;
              const atRiskPct = ttmRev > 0 ? (atRiskRev / ttmRev * 100) : 0;
              const b2bPct = keyMetrics.b2bPct;
              const bench = currentBenchmarks;
              const hasData = custCount > 0 || lost.length > 0 || gained.length > 0;
              const hasMonthlySales = keyMetrics.hasMonthlySales;
              const monthLabels = monthlySalesMonthLabels;
              if (!hasData) return null;
              // One-window framing (Mark 09-02: "over what period? sales
              // reports or the owner marking the lost box?" — the section
              // must answer its own questions). Everything below compares
              // ONE window: the last completed year vs the trailing twelve
              // months. Lost = owner-marked OR revenue stopped; still-billing
              // marked-lost rows get badged so the mix is visible.
              const churnBaseK = keyMetrics.churnComparisonBase || 'year5';
              const churnLbl = churnBaseK === 'year4' ? (customerYearLabels?.year4 || 'Year 4') : (customerYearLabels?.year5 || 'Year 5');
              const custChurnPct = prevCount > 0 ? (lost.length / prevCount * 100) : null;

              return (
                <div className="mb-4">
                  <div className="flex items-center justify-between mb-0.5">
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Customer Health</h3>
                    {hasMonthlySales && (
                      <span className="text-xs px-2 py-0.5 bg-blue-100 text-blue-700 rounded font-medium">
                        📅 Enhanced with monthly data
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-gray-400 mb-2">
                    One window: <b>{churnLbl} vs the trailing twelve months</b>. Lost = the owner marked them Lost <i>or</i> their revenue stopped in the sales reports; New = first revenue during the TTM. Both lists cover the same window.
                  </div>
                  <div className="grid grid-cols-4 gap-3">
                    {/* Customer Count & Growth */}
                    <div className="bg-white border rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1" title={`Customers with revenue in the trailing twelve months. The lines below compare against ${churnLbl}.`}>Active Customers</div>
                      <div className="text-2xl font-bold text-gray-900">{custCount}</div>
                      {prevCount > 0 && custCount !== prevCount && (
                        <div className={`text-xs mt-1 ${netChange >= 0 ? 'text-green-600' : 'text-red-600'}`} title={`Since ${churnLbl}: ${gained.length} customers started, ${lost.length} stopped or were marked Lost.`}>
                          {netChange >= 0 ? '+' : ''}{netChange} net vs {churnLbl} ({gained.length} started, {lost.length} stopped)
                        </div>
                      )}
                      {custChurnPct != null && (
                        <div className={`text-xs mt-0.5 font-medium ${custChurnPct > 20 ? 'text-red-600' : custChurnPct > 10 ? 'text-amber-600' : 'text-gray-500'}`}
                          title={`${lost.length} of ${churnLbl}'s ${prevCount} customers stopped (or were marked Lost) by the end of the TTM — the customer-count churn rate for this window.`}>
                          {custChurnPct.toFixed(0)}% customer churn vs {churnLbl}
                        </div>
                      )}
                    </div>

                    {/* Churn Summary */}
                    <div className="bg-white border rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1" title={`Revenue walking out vs walking in over the same ${churnLbl}→TTM window. The lost figure values each lost customer at their BEST year (${churnLbl} or TTM, whichever is higher) — so owner-marked customers still billing count at full weight, since that revenue is leaving. The yellow banner below shows how much of it is still in the TTM numbers.`}>TTM Revenue Churn</div>
                      <div className="flex items-baseline gap-2">
                        <span className="text-lg font-bold text-red-600" title="Revenue attached to lost customers (best-year value).">-{formatCurrency(lostRev)}</span>
                      </div>
                      <div className="text-xs text-green-600 mt-0.5" title="TTM revenue from customers who started during the window.">+{formatCurrency(newRev)} from new</div>
                      <div className={`text-xs mt-0.5 font-semibold ${netRevChange >= 0 ? 'text-green-700' : 'text-red-700'}`} title="Lost vs added — the revenue-replacement picture for the window.">
                        Net: {netRevChange >= 0 ? '+' : ''}{formatCurrency(netRevChange)}
                      </div>
                    </div>
                    
                    {/* Retention & NRR */}
                    <div className="bg-white border rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">Retention / NRR</div>
                      <div className="flex items-baseline gap-3">
                        <div>
                          <div className={`text-lg font-bold ${retention && retention >= bench.customerRetentionRate ? 'text-green-700' : retention && retention >= bench.customerRetentionRate * 0.9 ? 'text-yellow-600' : 'text-red-600'}`}>
                            {retention ? `${retention.toFixed(0)}%` : '—'}
                          </div>
                          <div className="text-xs text-gray-400">GRR</div>
                        </div>
                        <div>
                          <div className={`text-lg font-bold ${nrr && nrr >= 100 ? 'text-green-700' : nrr && nrr >= 90 ? 'text-yellow-600' : 'text-red-600'}`}>
                            {nrr ? `${nrr.toFixed(0)}%` : '—'}
                          </div>
                          <div className="text-xs text-gray-400">NRR</div>
                        </div>
                      </div>
                      {bench.customerRetentionRate && <div className="text-xs text-gray-400 mt-1">Benchmark: {bench.customerRetentionRate}% GRR</div>}
                    </div>
                    
                    {/* At Risk */}
                    <div className={`bg-white border rounded-lg p-3 ${atRisk.length > 0 ? 'border-red-200 bg-red-50' : ''}`}>
                      <div className="text-xs text-gray-500 mb-1">At Risk Clients</div>
                      {atRisk.length > 0 ? (
                        <>
                          <div className="text-2xl font-bold text-red-600">{atRisk.length}</div>
                          <div className="text-xs text-red-600">{formatCurrency(atRiskRev)} ({atRiskPct.toFixed(1)}% of rev)</div>
                        </>
                      ) : (
                        <>
                          <div className="text-2xl font-bold text-green-700">0</div>
                          <div className="text-xs text-gray-400">None flagged</div>
                        </>
                      )}
                    </div>
                  </div>
                  
                  {/* Lost & Gained Detail — enhanced with monthly timing when available */}
                  {(lost.length > 0 || gained.length > 0) && (() => {
                    const churnBase2 = keyMetrics.churnComparisonBase || 'year5';
                    const churnLabel = churnBase2 === 'year4'
                      ? (customerYearLabels?.year4 || 'Year 4')
                      : (customerYearLabels?.year5 || 'Year 5');
                    return (
                    <div className="mt-3 grid grid-cols-2 gap-3">
                      {/* Lost */}
                      {lost.length > 0 && (
                        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                          <div className="flex items-center justify-between mb-1">
                            <div className="text-xs font-semibold text-red-700 uppercase">Lost Customers ({lost.length})</div>
                            <div className="text-xs text-gray-400">{churnLabel} → TTM</div>
                          </div>
                          <div className="flex justify-between text-xs text-red-700 font-semibold border-b border-red-200 pb-1 mb-1">
                            <span>{churnLabel} Revenue</span>
                            <span>TTM Revenue</span>
                          </div>
                          {lost.slice(0, 8).map((c, i) => (
                            <div key={i} className="flex items-center justify-between text-xs py-0.5 border-b border-red-100 last:border-0">
                              <div className="flex items-center gap-1 min-w-0">
                                {hasMonthlySales && c._monthlyLastActive !== undefined && c._monthlyLastActive >= 0 && c._monthlyLastActive < 9 && (
                                  <span className="px-1 py-0.5 bg-red-200 text-red-800 rounded text-xs whitespace-nowrap flex-shrink-0">
                                    Last: {monthLabels[c._monthlyLastActive] || `M${c._monthlyLastActive + 1}`}
                                  </span>
                                )}
                                {c.lost && (c.ttm || 0) > 0 && (
                                  <span className="px-1 py-0.5 bg-amber-200 text-amber-900 rounded text-xs whitespace-nowrap flex-shrink-0" title="The owner marked this customer Lost, but they still show TTM revenue — it hasn't rolled off yet. This is why a 'lost' customer can show current revenue; the Pro Forma removes it.">
                                    marked lost · still billing
                                  </span>
                                )}
                                <span className="text-gray-700 truncate" title={c.name}>{c.name || 'Unnamed'}</span>
                              </div>
                              <div className="flex items-center gap-2 flex-shrink-0 ml-1">
                                <span className="text-gray-500">{formatCurrency(c[churnBase2] || 0)}</span>
                                <span className="text-red-600 font-medium w-14 text-right">{c.ttm ? formatCurrency(c.ttm) : '—'}</span>
                              </div>
                            </div>
                          ))}
                          {lost.length > 8 && <div className="text-xs text-red-500 mt-1">+{lost.length - 8} more</div>}
                          <div className="flex justify-between text-xs font-semibold text-red-700 border-t border-red-200 pt-1 mt-1">
                            <span>Total Lost</span>
                            <span>{formatCurrency(lostRev)}</span>
                          </div>
                        </div>
                      )}
                      {/* Gained */}
                      {gained.length > 0 && (
                        <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                          <div className="flex items-center justify-between mb-1">
                            <div className="text-xs font-semibold text-green-700 uppercase">New Customers ({gained.length})</div>
                            <div className="text-xs text-gray-400" title={`Same window as the Lost list: customers whose first revenue arrived during the trailing twelve months (none in ${churnLabel}).`}>{churnLabel} → TTM</div>
                          </div>
                          <div className="flex justify-between text-xs text-green-700 font-semibold border-b border-green-200 pb-1 mb-1">
                            <span>Customer</span>
                            <span>TTM Revenue</span>
                          </div>
                          {gained.slice(0, 8).map((c, i) => (
                            <div key={i} className="flex items-center justify-between text-xs py-0.5 border-b border-green-100 last:border-0">
                              <div className="flex items-center gap-1 min-w-0">
                                {hasMonthlySales && c._monthlyFirstActive !== undefined && c._monthlyFirstActive > 0 && (
                                  <span className="px-1 py-0.5 bg-green-200 text-green-800 rounded text-xs whitespace-nowrap flex-shrink-0">
                                    Started: {monthLabels[c._monthlyFirstActive] || `M${c._monthlyFirstActive + 1}`}
                                  </span>
                                )}
                                <span className="text-gray-700 truncate" title={c.name}>{c.name || 'Unnamed'}</span>
                              </div>
                              <div className="flex items-center gap-2 flex-shrink-0 ml-1">
                                {hasMonthlySales && c._monthlyAnnualized && (
                                  <span className="text-blue-600 text-xs whitespace-nowrap">~{formatCurrency(c._monthlyAnnualized)}/yr</span>
                                )}
                                <span className="text-green-700 font-medium w-14 text-right">{formatCurrency(c.ttm || 0)}</span>
                              </div>
                            </div>
                          ))}
                          {gained.length > 8 && <div className="text-xs text-green-500 mt-1">+{gained.length - 8} more</div>}
                          <div className="flex justify-between text-xs font-semibold text-green-700 border-t border-green-200 pt-1 mt-1">
                            <span>Total Added</span>
                            <span>{formatCurrency(newRev)}</span>
                          </div>
                        </div>
                      )}
                    </div>
                    );
                  })()}

                  {/* Monthly Sales CTA — if not yet entered */}
                  {!hasMonthlySales && (lost.length > 0 || gained.length > 0) && (
                    <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
                      <div className="text-sm text-blue-800">
                        <span className="font-medium">💡 Better churn timing available</span>
                        <span className="text-blue-600 ml-2">— Paste the monthly sales report to see exactly when customers were gained or lost.</span>
                      </div>
                      <button onClick={() => setViewMode('salesmonthly')} className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 whitespace-nowrap ml-3">
                        + Add Monthly →
                      </button>
                    </div>
                  )}
                  
                  {/* Pro Forma Alert — lost clients still inflating TTM */}
                  {(keyMetrics.lostWithResidualTTM?.length || 0) > 0 && (
                    <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-amber-600 text-lg">⚠️</span>
                          <div>
                            <span className="font-semibold text-amber-800">Lost Revenue Still in TTM: </span>
                            <span className="text-amber-700">
                              {keyMetrics.lostWithResidualTTM.length} client{keyMetrics.lostWithResidualTTM.length !== 1 ? 's' : ''} marked Lost still have <strong>{formatCurrency(keyMetrics.lostResidualRevenue)}</strong> in TTM revenue that will roll off
                            </span>
                          </div>
                        </div>
                        <button 
                          onClick={() => setViewMode('proforma')} 
                          className="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white text-sm rounded whitespace-nowrap"
                        >
                          Pro Forma →
                        </button>
                      </div>
                      <div className="mt-2 text-xs text-amber-700">
                        {keyMetrics.lostWithResidualTTM.slice(0, 5).map((c, i) => (
                          <span key={i}>{i > 0 ? ', ' : ''}{c.name || 'Unnamed'} ({formatCurrency(c.ttm || 0)})</span>
                        ))}
                        {keyMetrics.lostWithResidualTTM.length > 5 && <span> +{keyMetrics.lostWithResidualTTM.length - 5} more</span>}
                      </div>
                    </div>
                  )}

                  {/* Customer Industry Concentration Flag */}
                  {(() => {
                    const concentrationPd = customerSalesData.some(c => (c.ttm || 0) > 0) ? 'ttm' : 'year5';
                    const indRevenue = {};
                    customerSalesData.forEach(c => {
                      if (c.industry && c.industry.trim() && (c[concentrationPd] || 0) > 0) {
                        const ind = c.industry.trim();
                        indRevenue[ind] = (indRevenue[ind] || 0) + c[concentrationPd];
                      }
                    });
                    const totalRev = Object.values(indRevenue).reduce((s, v) => s + v, 0);
                    if (totalRev === 0) return null;
                    const sorted = Object.entries(indRevenue).sort((a, b) => b[1] - a[1]);
                    const topInd = sorted[0];
                    const topPct = totalRev > 0 ? (topInd[1] / totalRev * 100) : 0;
                    if (topPct < 60) return null;
                    const isVeryConcentrated = topPct >= 90;
                    return (
                      <div className={`mt-3 p-3 rounded-lg border ${isVeryConcentrated ? 'bg-amber-50 border-amber-200' : 'bg-blue-50 border-blue-200'}`}>
                        <div className="flex items-start gap-2">
                          <span className="text-lg">{isVeryConcentrated ? '⚠️' : 'ℹ️'}</span>
                          <div>
                            <div className="font-semibold text-sm text-gray-800">
                              Customer Industry Concentration: {topPct.toFixed(0)}% in {topInd[0]}
                            </div>
                            <div className="text-xs text-gray-600 mt-1">
                              {isVeryConcentrated
                                ? `Nearly all revenue comes from ${topInd[0]} clients. This amplifies exposure to sector-level downturns — if this industry softens, revenue could decline across the entire customer base simultaneously. Verify whether the sector is growing or contracting before finalizing the multiple.`
                                : `A majority of revenue is concentrated in the ${topInd[0]} sector. This creates both deep niche expertise and sector-level risk. Consider whether current industry tailwinds or headwinds should influence the multiple.`
                              }
                            </div>
                            {sorted.length > 1 && (
                              <div className="text-xs text-gray-500 mt-1">
                                {sorted.slice(0, 4).map(([ind, rev], i) => (
                                  <span key={i}>{i > 0 ? ' · ' : ''}{ind}: {totalRev > 0 ? (rev / totalRev * 100).toFixed(0) : 0}%</span>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              );
            })()}

            {/* ===== REVENUE & EBITDA TREND + REVENUE MIX ===== */}
            {(() => {
              const periods = [
                { label: basisYearLabels.year3, rev: calculations.years[2]?.revenue || 0, ebitda: calculations.years[2]?.adjustedEbitda || 0 },
                { label: basisYearLabels.year4, rev: calculations.years[3]?.revenue || 0, ebitda: calculations.years[3]?.adjustedEbitda || 0 },
                { label: basisYearLabels.year5, rev: calculations.years[4]?.revenue || 0, ebitda: calculations.years[4]?.adjustedEbitda || 0 },
                { label: 'TTM', rev: calculations.years[5]?.revenue || 0, ebitda: calculations.years[5]?.adjustedEbitda || 0, isTTM: true },
              ];
              const hasData = periods.some(p => p.rev > 0 || p.ebitda > 0);
              if (!hasData) return null;
              
              const maxRev = Math.max(...periods.map(p => Math.max(p.rev, 0)));
              if (maxRev === 0) return null;
              
              // Calculate YoY changes (skip TTM since it overlaps with Year5)
              const revChanges = periods.map((p, i) => {
                if (i === 0 || i === 3 || periods[i-1].rev === 0) return null;
                return ((p.rev - periods[i-1].rev) / periods[i-1].rev * 100);
              });
              const ebitdaChanges = periods.map((p, i) => {
                if (i === 0 || i === 3 || periods[i-1].ebitda <= 0) return null;
                if (p.ebitda <= 0) return -100; // Show as -100% if went negative
                return ((p.ebitda - periods[i-1].ebitda) / periods[i-1].ebitda * 100);
              });
              
              // Calculate 2-year CAGRs (Year3 to Year5)
              const firstRev = periods[0].rev;
              const lastYearRev = periods[2].rev;
              const revCagr = firstRev > 0 && lastYearRev > 0 ? ((Math.pow(lastYearRev / firstRev, 1/2) - 1) * 100) : null;
              
              const firstEbitda = periods[0].ebitda;
              const lastYearEbitda = periods[2].ebitda;
              const ebitdaCagr = firstEbitda > 0 && lastYearEbitda > 0 ? ((Math.pow(lastYearEbitda / firstEbitda, 1/2) - 1) * 100) : null;
              
              // Format to millions/thousands
              const formatCompact = (val) => {
                if (Math.abs(val) >= 1000000) return `$${(val / 1000000).toFixed(1)}M`;
                if (Math.abs(val) >= 1000) return `$${(val / 1000).toFixed(0)}K`;
                return `$${val.toFixed(0)}`;
              };
              
              // Revenue mix data from revenueAnalysis
              const revMix = revenueAnalysis?.categoryBreakdown || [];
              const ttmTotal = revenueAnalysis?.totals?.ttm || calculations.years[5]?.revenue || 0;
              const pieColors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];
              
              // Group revenue by TYPE instead of individual categories
              const typeGroups = {};
              activeRevenueCategories
                .filter(cat => cat.name && (cat.ttm || 0) > 0)
                .forEach(cat => {
                  const typeInfo = revenueTypes.find(t => t.id === cat.revenueType);
                  const typeLabel = typeInfo?.label || 'Transactional / New';
                  const typeId = typeInfo?.id || 'transactional';
                  if (!typeGroups[typeId]) {
                    typeGroups[typeId] = { 
                      name: typeLabel, 
                      value: 0, 
                      isRecurring: typeInfo?.isRecurring || false,
                      weight: typeInfo?.weight || 0
                    };
                  }
                  typeGroups[typeId].value += (cat.ttm || 0);
                });
              
              const revByType = Object.values(typeGroups)
                .map(t => ({
                  ...t,
                  pct: ttmTotal > 0 ? (t.value / ttmTotal * 100) : 0
                }))
                .sort((a, b) => b.weight - a.weight); // Sort by weight (quality) - best types first
              
              const barMaxHeight = 70;
              
              return (
                <div className="mb-4 grid grid-cols-3 gap-3">
                  {/* LEFT: Revenue Trend */}
                  <div className="bg-white border rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="text-xs font-semibold text-gray-500 uppercase">Revenue Trend</h4>
                      {revCagr !== null && (
                        <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${revCagr >= 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                          {revCagr >= 0 ? '+' : ''}{revCagr.toFixed(0)}% CAGR
                        </span>
                      )}
                    </div>
                    <div className="flex items-end justify-between gap-1">
                      {periods.slice(0, 3).map((p, i) => {
                        const h = maxRev > 0 ? Math.max((p.rev / maxRev) * barMaxHeight, 4) : 0;
                        const change = revChanges[i];
                        return (
                          <div key={i} className="flex-1 flex flex-col items-center">
                            {change !== null && (
                              <div className={`text-xs font-semibold mb-1 ${change >= 0 ? 'text-green-600' : 'text-red-500'}`}>
                                {change >= 0 ? '↑' : '↓'}{Math.abs(change).toFixed(0)}%
                              </div>
                            )}
                            {i === 0 && <div className="h-4"></div>}
                            <div className="w-full bg-blue-400 rounded-t" style={{height: h}} title={formatCurrency(p.rev)}></div>
                            <div className="text-xs text-gray-500 mt-1">{p.label}</div>
                            <div className="text-xs font-medium text-blue-700">{formatCompact(p.rev)}</div>
                          </div>
                        );
                      })}
                    </div>
                    {/* Gross Margin */}
                    <div className="mt-2 pt-2 border-t flex justify-between items-center">
                      <span className="text-xs text-gray-500">TTM Gross Margin</span>
                      <span className={`text-xs font-semibold ${keyMetrics.grossMargin >= 50 ? 'text-green-600' : keyMetrics.grossMargin >= 30 ? 'text-yellow-600' : 'text-red-600'}`}>
                        {keyMetrics.grossMargin?.toFixed(1) || '—'}%
                      </span>
                    </div>
                  </div>

                  {/* CENTER: EBITDA Trend */}
                  <div className="bg-white border rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="text-xs font-semibold text-gray-500 uppercase">EBITDA Trend</h4>
                      {ebitdaCagr !== null && (
                        <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${ebitdaCagr >= 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                          {ebitdaCagr >= 0 ? '+' : ''}{ebitdaCagr.toFixed(0)}% CAGR
                        </span>
                      )}
                    </div>
                    <div className="flex items-end justify-between gap-1">
                      {periods.slice(0, 3).map((p, i) => {
                        const maxE = Math.max(...periods.slice(0,3).map(x => Math.max(x.ebitda, 0)));
                        const h = maxE > 0 ? Math.max((Math.max(p.ebitda, 0) / maxE) * barMaxHeight, p.ebitda > 0 ? 4 : 0) : 0;
                        const change = ebitdaChanges[i];
                        return (
                          <div key={i} className="flex-1 flex flex-col items-center">
                            {change !== null && (
                              <div className={`text-xs font-semibold mb-1 ${change >= 0 ? 'text-green-600' : 'text-red-500'}`}>
                                {change >= 0 ? '↑' : '↓'}{Math.abs(change).toFixed(0)}%
                              </div>
                            )}
                            {i === 0 && <div className="h-4"></div>}
                            <div className={`w-full rounded-t ${p.ebitda >= 0 ? 'bg-emerald-400' : 'bg-red-300'}`} style={{height: Math.max(h, 4)}} title={formatCurrency(p.ebitda)}></div>
                            <div className="text-xs text-gray-500 mt-1">{p.label}</div>
                            <div className={`text-xs font-medium ${p.ebitda >= 0 ? 'text-emerald-700' : 'text-red-600'}`}>{formatCompact(p.ebitda)}</div>
                          </div>
                        );
                      })}
                    </div>
                    {/* EBITDA Margin */}
                    <div className="mt-2 pt-2 border-t flex justify-between items-center">
                      <span className="text-xs text-gray-500">TTM EBITDA Margin</span>
                      <span className={`text-xs font-semibold ${keyMetrics.ebitdaMargin >= 20 ? 'text-green-600' : keyMetrics.ebitdaMargin >= 10 ? 'text-yellow-600' : 'text-red-600'}`}>
                        {keyMetrics.ebitdaMargin?.toFixed(1) || '—'}%
                      </span>
                    </div>
                  </div>

                  {/* RIGHT: Revenue Mix Pie */}
                  <div className="bg-white border rounded-lg p-3">
                    <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2">TTM Revenue by Type</h4>
                    {revByType.length > 0 ? (
                      <div className="flex items-center gap-2">
                        {/* Simple pie using conic-gradient */}
                        <div className="relative" style={{width: 70, height: 70}}>
                          <div 
                            className="w-full h-full rounded-full"
                            style={{
                              background: (() => {
                                let gradient = 'conic-gradient(';
                                let cumulative = 0;
                                revByType.forEach((cat, i) => {
                                  const start = cumulative;
                                  cumulative += cat.pct;
                                  gradient += `${pieColors[i % pieColors.length]} ${start}% ${cumulative}%`;
                                  if (i < revByType.length - 1) gradient += ', ';
                                });
                                // Fill remainder if categories don't sum to 100%
                                if (cumulative < 100) {
                                  gradient += `, #e5e7eb ${cumulative}% 100%`;
                                }
                                return gradient + ')';
                              })()
                            }}
                          ></div>
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-8 h-8 bg-white rounded-full"></div>
                          </div>
                        </div>
                        {/* Legend */}
                        <div className="flex-1 text-xs space-y-0.5">
                          {revByType.map((cat, i) => (
                            <div key={i} className="flex items-center gap-1">
                              <span className="w-2 h-2 rounded-sm flex-shrink-0" style={{backgroundColor: pieColors[i % pieColors.length]}}></span>
                              <span className="text-gray-600 truncate" style={{maxWidth: '90px'}}>{cat.name.split(' - ')[0]}</span>
                              <span className={`font-medium ml-auto ${cat.isRecurring ? 'text-green-600' : 'text-gray-500'}`}>{cat.pct.toFixed(0)}%</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="text-xs text-gray-400 italic">Set revenue types in Data Entry</div>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* ===== STRENGTHS & RISKS ===== */}
            {(() => {
              const bench = currentBenchmarks;
              // Use Year5 vs Year4 for YoY (actual calendar years, not TTM which overlaps)
              const year5Rev = calculations.years[4]?.revenue || 0;
              const year4Rev = calculations.years[3]?.revenue || 0;
              const year3Rev = calculations.years[2]?.revenue || 0;
              const yoyRevGrowth = year4Rev > 0 ? ((year5Rev - year4Rev) / year4Rev * 100) : null;
              
              // Check for multi-year decline pattern
              const year5Decline = year4Rev > 0 && year5Rev < year4Rev;
              const year4Decline = year3Rev > 0 && year4Rev < year3Rev;
              const multiYearDecline = year5Decline && year4Decline;
              
              const ebitdaMargin = keyMetrics.ebitdaMargin || 0;
              const recurPct = keyMetrics.recurringPct || 0;
              const topCustPct = keyMetrics.topCustomerPct || 0;
              const top5Pct = keyMetrics.top5CustomersPct || 0;
              const retention = keyMetrics.avgRetention;
              const nrr = keyMetrics.avgNRR;
              const contractPct = keyMetrics.contractedPct || 0;
              const assignPct = keyMetrics.assignablePct || 0;
              const custGrowing = keyMetrics.customerCountGrowing;
              const revCAGR = keyMetrics.revCAGR;
              const ebitdaCAGR = keyMetrics.ebitdaCAGR;
              const empCount = keyMetrics.employeeCount;
              const revPerEmp = keyMetrics.revenuePerEmployee;
              const pastDuePct = keyMetrics.pastDuePct;
              const dso = keyMetrics.dso;
              const grossMargin = keyMetrics.grossMargin || 0;
              const adjustmentsToEbitdaPct = keyMetrics.adjustmentsToEbitdaPct;
              const hasSalesData = customerSalesData.some(c => (c.ttm || 0) > 0);

              // Owner dependency
              const ownerHoursQA = sellerQA.find(q => q.id === 15);
              const ownerHours = ownerHoursQA?.numericValue || null;
              const mgmtQA = sellerQA.find(q => q.id === 11);
              const hasMgmt = mgmtQA?.answer && mgmtQA.status === 'answered';

              // Turnover
              const empQA = sellerQA.find(q => q.id === 10);
              const turnoverPct = empQA?.numericValue > 0 && empQA?.numericValue2 > 0 ? (empQA.numericValue2 / empQA.numericValue * 100) : null;

              const strengths = [];
              const risks = [];

              // Revenue quality
              if (recurPct >= bench.recurringRevenuePct) {
                strengths.push({ text: `${recurPct.toFixed(0)}% recurring revenue`, detail: `exceeds ${bench.recurringRevenuePct}% industry benchmark` });
              } else if (recurPct > 0 && recurPct < bench.recurringRevenuePct * 0.7) {
                risks.push({ text: `Low recurring revenue (${recurPct.toFixed(0)}%)`, detail: `industry benchmark: ${bench.recurringRevenuePct}%`, severity: 'warning' });
              }

              // Revenue Growth/Decline - prioritize multi-year trend over single year
              if (multiYearDecline) {
                // Multi-year decline is always critical
                const declinePct = revCAGR !== null ? Math.abs(revCAGR).toFixed(1) : (year3Rev > 0 ? (((year5Rev / year3Rev) - 1) * 100).toFixed(1) : '?');
                risks.push({ text: `Revenue declining for 2+ years`, detail: `down ${declinePct}% overall — sustained negative trend`, severity: 'critical' });
              } else if (revCAGR !== null && revCAGR < -5) {
                // Significant CAGR decline
                risks.push({ text: `Revenue shrinking (${revCAGR.toFixed(1)}% CAGR)`, detail: 'negative growth trend impacts valuation', severity: 'critical' });
              } else if (yoyRevGrowth !== null && yoyRevGrowth < -10) {
                // Single year significant decline
                risks.push({ text: `Revenue dropped ${Math.abs(yoyRevGrowth).toFixed(0)}% last year`, detail: 'investigate cause — one-time or trend?', severity: 'warning' });
              } else if (revCAGR !== null && revCAGR >= bench.industryGrowthRate) {
                strengths.push({ text: `Strong revenue growth (${revCAGR.toFixed(1)}% CAGR)`, detail: `above ${bench.industryGrowthRate}% industry rate` });
              } else if (revCAGR !== null && revCAGR > 5) {
                strengths.push({ text: `Revenue growing (${revCAGR.toFixed(1)}% CAGR)`, detail: 'positive growth trajectory' });
              }

              // EBITDA margin
              if (ebitdaMargin >= bench.ebitdaMargin) {
                strengths.push({ text: `${ebitdaMargin.toFixed(1)}% EBITDA margin`, detail: `above ${bench.ebitdaMargin}% industry average` });
              } else if (ebitdaMargin > 0 && ebitdaMargin < bench.ebitdaMargin * 0.6) {
                risks.push({ text: `Below-market margins (${ebitdaMargin.toFixed(1)}%)`, detail: `industry average: ${bench.ebitdaMargin}%`, severity: 'warning' });
              }

              // EBITDA growth - severe decline is critical
              if (ebitdaCAGR !== null && ebitdaCAGR > 10) {
                strengths.push({ text: `EBITDA growing ${ebitdaCAGR.toFixed(0)}% CAGR`, detail: 'strong earnings trajectory' });
              } else if (ebitdaCAGR !== null && ebitdaCAGR < -20) {
                // Severe EBITDA decline (>20% CAGR) is critical
                risks.push({ text: `EBITDA declining (${ebitdaCAGR.toFixed(0)}% CAGR)`, detail: 'severe earnings deterioration — investigate', severity: 'critical' });
              } else if (ebitdaCAGR !== null && ebitdaCAGR < -5) {
                risks.push({ text: `EBITDA declining (${ebitdaCAGR.toFixed(0)}% CAGR)`, detail: 'earnings deterioration', severity: 'warning' });
              }

              // Concentration
              if (topCustPct > 0 && topCustPct <= bench.topCustomerConcentration) {
                strengths.push({ text: `Low customer concentration (${topCustPct.toFixed(1)}% top)`, detail: `within ${bench.topCustomerConcentration}% industry target` });
              } else if (topCustPct > 25) {
                risks.push({ text: `High concentration: top customer = ${topCustPct.toFixed(1)}%`, detail: 'key-person dependency risk for buyer', severity: 'critical' });
              } else if (topCustPct > bench.topCustomerConcentration) {
                risks.push({ text: `Elevated concentration (${topCustPct.toFixed(1)}% top customer)`, detail: `industry target: <${bench.topCustomerConcentration}%`, severity: 'warning' });
              }

              if (top5Pct > 50) {
                risks.push({ text: `Top 5 customers = ${top5Pct.toFixed(0)}% of revenue`, detail: 'narrow revenue base', severity: 'warning' });
              }

              // Customer Revenue Spike
              if (keyMetrics.hasCustomerSpike && keyMetrics.customerSpikes?.length > 0) {
                const topSpike = keyMetrics.customerSpikes[0];
                risks.push({ text: `Single customer spike driving ${topSpike.shareOfGrowth.toFixed(0)}% of revenue growth`, detail: `${topSpike.name}: $${(topSpike.priorRevenue/1000).toFixed(0)}K → $${(topSpike.currentRevenue/1000).toFixed(0)}K (${topSpike.growthPct > 500 ? '>500' : topSpike.growthPct.toFixed(0)}% growth) — buyers will investigate sustainability`, severity: 'critical' });
              }

              // Retention
              if (retention !== null && retention >= bench.customerRetentionRate) {
                strengths.push({ text: `${retention.toFixed(0)}% revenue retention`, detail: `exceeds ${bench.customerRetentionRate}% benchmark` });
              } else if (retention !== null && retention < bench.customerRetentionRate * 0.9) {
                risks.push({ text: `Low retention (${retention.toFixed(0)}%)`, detail: `benchmark: ${bench.customerRetentionRate}%`, severity: 'warning' });
              }

              // NRR
              if (nrr !== null && nrr >= 105) {
                strengths.push({ text: `${nrr.toFixed(0)}% net revenue retention`, detail: 'existing customers are expanding' });
              } else if (nrr !== null && nrr < 85) {
                risks.push({ text: `Low NRR (${nrr.toFixed(0)}%)`, detail: 'existing customers shrinking faster than growing', severity: 'warning' });
              }

              // Customer base growth
              if (custGrowing && hasSalesData) {
                strengths.push({ text: 'Growing customer count', detail: `${keyMetrics.customerCount?.ttm || 0} active clients` });
              }

              // Contracts
              if (contractPct >= 70 && hasSalesData) {
                strengths.push({ text: `${contractPct.toFixed(0)}% of clients under contract`, detail: assignPct >= 70 ? `${assignPct.toFixed(0)}% assignable` : 'review assignability' });
              } else if (contractPct > 0 && contractPct < 40 && hasSalesData) {
                risks.push({ text: `Only ${contractPct.toFixed(0)}% clients under contract`, detail: 'revenue at risk without binding agreements', severity: 'warning' });
              }

              // Owner dependency
              if (ownerHours !== null && ownerHours <= 20) {
                strengths.push({ text: `Low owner involvement (${ownerHours} hrs/wk)`, detail: 'business runs independently' });
              } else if (ownerHours !== null && ownerHours >= 50) {
                risks.push({ text: `High owner dependency (${ownerHours} hrs/wk)`, detail: 'transition risk — buyer will need to replace capacity', severity: 'warning' });
              }

              // Turnover
              if (turnoverPct !== null && turnoverPct > 25) {
                risks.push({ text: `High staff turnover (${turnoverPct.toFixed(0)}%)`, detail: 'may indicate culture or compensation issues', severity: 'warning' });
              }

              // AR
              if (pastDuePct !== null && pastDuePct > 30) {
                risks.push({ text: `${pastDuePct.toFixed(0)}% of AR past due`, detail: dso ? `DSO: ${dso.toFixed(0)} days` : 'review collection practices', severity: 'warning' });
              } else if (pastDuePct !== null && pastDuePct <= 10 && pastDuePct >= 0) {
                strengths.push({ text: 'Clean AR aging', detail: dso ? `DSO: ${dso.toFixed(0)} days, only ${pastDuePct.toFixed(0)}% past due` : `only ${pastDuePct.toFixed(0)}% past due` });
              }

              // Large adjustments
              if (adjustmentsToEbitdaPct !== null && adjustmentsToEbitdaPct > 50) {
                risks.push({ text: `Adjustments = ${adjustmentsToEbitdaPct.toFixed(0)}% of base EBITDA`, detail: 'heavy normalization may face buyer skepticism', severity: 'warning' });
              }

              // Monthly EBITDA stability - critical for understanding true profitability
              const negEbitdaMonths = normalizedEbitdaMonthly?.negativeMonths || 0;
              const hasMonthlyEbitda = normalizedEbitdaMonthly?.hasMonthlyData;
              if (hasMonthlyEbitda && negEbitdaMonths >= 6) {
                // Majority of months are negative - this is critical
                risks.push({ text: `${negEbitdaMonths}/12 months with negative EBITDA`, detail: 'serious cash flow concern — business may not be sustainably profitable', severity: 'critical' });
              } else if (hasMonthlyEbitda && negEbitdaMonths >= 3) {
                // Multiple negative months - significant concern
                risks.push({ text: `${negEbitdaMonths}/12 months with negative EBITDA`, detail: 'review timing of expenses and seasonality', severity: 'warning' });
              } else if (hasMonthlyEbitda && negEbitdaMonths === 0 && (normalizedEbitdaMonthly?.monthlyAvg || 0) > 0) {
                strengths.push({ text: 'Profitable every month', detail: 'consistent positive cash flow' });
              }

              // Revenue monthly stability
              const revMonthsBelowAvg = revenueAnalysis?.monthsSignificantlyBelow || 0;
              const revMonthlyCV = revenueAnalysis?.monthlyCV || 0;
              const hasMonthlyRev = revenueAnalysis?.hasMonthlyData;
              if (hasMonthlyRev && revMonthlyCV > 25) {
                risks.push({ text: `High revenue volatility (${revMonthlyCV.toFixed(0)}% CV)`, detail: `${revMonthsBelowAvg} months significantly below average — unpredictable cash flow`, severity: 'warning' });
              } else if (hasMonthlyRev && revMonthlyCV < 10) {
                strengths.push({ text: 'Stable monthly revenue', detail: `low volatility (${revMonthlyCV.toFixed(0)}% CV)` });
              }

              // Sort risks: critical first
              risks.sort((a, b) => (a.severity === 'critical' ? 0 : 1) - (b.severity === 'critical' ? 0 : 1));

              return (strengths.length > 0 || risks.length > 0) ? (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Strengths & Risks</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {/* Strengths */}
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                      <div className="text-sm font-bold text-green-800 mb-2 flex items-center gap-1">✅ Strengths ({strengths.length})</div>
                      {strengths.length > 0 ? (
                        <div className="space-y-1.5">
                          {strengths.map((s, i) => (
                            <div key={i} className="text-sm">
                              <span className="font-medium text-green-900">{s.text}</span>
                              <span className="text-green-600 text-xs ml-1">— {s.detail}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-sm text-green-600 italic">No notable strengths detected yet. Enter more data.</div>
                      )}
                    </div>
                    {/* Risks */}
                    <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                      <div className="text-sm font-bold text-red-800 mb-2 flex items-center gap-1">⚠️ Risks ({risks.length})</div>
                      {risks.length > 0 ? (
                        <div className="space-y-1.5">
                          {risks.map((r, i) => (
                            <div key={i} className="text-sm">
                              <span className={`font-medium ${r.severity === 'critical' ? 'text-red-900' : 'text-orange-800'}`}>
                                {r.severity === 'critical' ? '🔴 ' : '🟡 '}{r.text}
                              </span>
                              <span className="text-red-600 text-xs ml-1">— {r.detail}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-sm text-green-600 italic">No significant risks detected.</div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null;
            })()}

            {/* ===== OPEN ITEMS & RESOLUTIONS ===== */}
            {(() => {
              const { unacknowledgedFlags, acknowledgedFlagsList, criticalCount, warningCount } = outstandingAnalysis;
              const hasOpenItems = unacknowledgedFlags.length > 0;
              const hasResolved = acknowledgedFlagsList.length > 0;

              if (!hasOpenItems && !hasResolved) return null;

              return (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Open Items & Resolutions
                    {hasOpenItems && (
                      <span className="ml-2 text-xs font-normal">
                        {criticalCount > 0 && <span className="bg-red-100 text-red-700 px-1.5 py-0.5 rounded">{criticalCount} critical</span>}
                        {warningCount > 0 && <span className="bg-yellow-100 text-yellow-700 px-1.5 py-0.5 rounded ml-1">{warningCount} warning</span>}
                      </span>
                    )}
                  </h3>
                  
                  {/* Open flags */}
                  {hasOpenItems && (
                    <div className="bg-white border border-red-200 rounded-lg p-3 mb-2">
                      <div className="text-xs font-bold text-red-700 mb-2">OPEN ({unacknowledgedFlags.length})</div>
                      <div className="space-y-1">
                        {unacknowledgedFlags.slice(0, 8).map((f, i) => (
                          <div key={i} className="flex items-start gap-2 text-sm">
                            <span className={`mt-0.5 flex-shrink-0 ${f.severity === 'critical' ? 'text-red-500' : f.severity === 'warning' ? 'text-yellow-500' : 'text-blue-500'}`}>
                              {f.severity === 'critical' ? '🔴' : f.severity === 'warning' ? '🟡' : '🔵'}
                            </span>
                            <div className="min-w-0">
                              <span className="font-medium text-gray-800">{f.item}</span>
                              <span className="text-gray-500 text-xs ml-1.5">{f.category}</span>
                              {f.action && <div className="text-xs text-gray-500 truncate">Action: {f.action}</div>}
                            </div>
                          </div>
                        ))}
                        {unacknowledgedFlags.length > 8 && (
                          <div className="text-xs text-gray-500 pt-1">+ {unacknowledgedFlags.length - 8} more — see Summary tab</div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Resolved flags (collapsible) */}
                  {hasResolved && (
                    <div className="border border-green-200 rounded-lg overflow-hidden">
                      <button type="button" onClick={(e) => { e.preventDefault(); toggleSection('overviewResolved', e); }} className="w-full p-2 bg-green-50 hover:bg-green-100 flex items-center justify-between text-sm">
                        <span className="font-medium text-green-800">✅ Resolved ({acknowledgedFlagsList.length})</span>
                        {expandedSections.overviewResolved ? <ChevronUp className="w-4 h-4 text-green-600" /> : <ChevronDown className="w-4 h-4 text-green-600" />}
                      </button>
                      {expandedSections.overviewResolved && (
                        <div className="p-3 bg-white space-y-1">
                          {acknowledgedFlagsList.map((f, i) => (
                            <div key={i} className="flex items-start gap-2 text-sm">
                              <span className="text-green-500 mt-0.5 flex-shrink-0">✓</span>
                              <div className="min-w-0">
                                <span className="text-gray-700">{f.item}</span>
                                {f.resolution && <span className="text-green-700 text-xs ml-1.5">— {f.resolution}</span>}
                                {f.date && <span className="text-gray-400 text-xs ml-1">({f.date})</span>}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* ===== DEAL READINESS ===== */}
            {(() => {
              const discoveryTotal = sellerQA.length;
              const discoveryAnswered = sellerQA.filter(q => q.status === 'answered').length;
              const discoveryPct = discoveryTotal > 0 ? (discoveryAnswered / discoveryTotal * 100) : 0;

              const hasFinancials = revenueCategories.some(c => (c[selectedValuationBasis]?.ttm || 0) > 0);
              const hasCogs = cogsCategories.some(c => (c[selectedValuationBasis]?.ttm || 0) > 0);
              const hasOpex = opexCategories.some(c => (c[selectedValuationBasis]?.ttm || 0) > 0);
              // Don't penalize for no COGS if the business simply has none (service businesses, etc.)
              const cogsApplicable = cogsCategories.some(c => c.name); // Only count COGS if categories exist
              const financialChecks = [hasFinancials, hasOpex];
              if (cogsApplicable) financialChecks.push(hasCogs);
              const financialPct = financialChecks.length > 0 ? (financialChecks.filter(Boolean).length / financialChecks.length * 100) : 0;

              const hasSalesData = customerSalesData.some(c => (c.ttm || 0) > 0);
              const salesClientCount = customerSalesData.filter(c => (c.ttm || 0) > 0).length;
              const hasSalesDetail = customerSalesData.some(c => c.hasContract !== undefined || c.customerType);
              const salesPct = !hasSalesData ? 0 : hasSalesDetail ? 100 : 50;

              const hasBSData = bsCurrentAssets.some(a => a.year3 || a.interim);
              const bsPct = hasBSData ? 100 : 0;

              const includedAdj = adjustmentItems.filter(a => a.included);
              const documentedAdj = includedAdj.filter(a => a.source);
              const adjPct = includedAdj.length > 0 ? (documentedAdj.length / includedAdj.length * 100) : (hasFinancials ? 0 : null);

              const docsReceived = documentChecklist.filter(d => d.status === 'complete').length;
              const docsTotal = documentChecklist.length;
              const docsPct = docsTotal > 0 ? (docsReceived / docsTotal * 100) : 0;

              const tracks = [
                { label: 'Discovery', pct: discoveryPct, detail: `${discoveryAnswered}/${discoveryTotal} questions` },
                { label: 'Financials', pct: financialPct, detail: financialPct === 100 ? (cogsApplicable ? 'Rev + COGS + OpEx' : 'Rev + OpEx') : financialPct > 0 ? 'Partial' : 'Not started' },
                { label: 'Sales Data', pct: salesPct, detail: hasSalesData ? `${salesClientCount} clients${hasSalesDetail ? ' + detail' : ''}` : 'Not entered' },
                { label: 'Balance Sheet', pct: bsPct, detail: hasBSData ? 'Entered' : 'Not entered' },
                { label: 'Adjustments', pct: adjPct, detail: adjPct !== null ? `${documentedAdj.length}/${includedAdj.length} documented` : 'N/A' },
                { label: 'Documents', pct: docsPct, detail: `${docsReceived}/${docsTotal} received` }
              ];

              const overallPct = tracks.filter(t => t.pct !== null).reduce((s, t) => s + t.pct, 0) / tracks.filter(t => t.pct !== null).length;

              return (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Deal Readiness
                    <span className={`ml-2 text-xs font-bold px-2 py-0.5 rounded ${overallPct >= 80 ? 'bg-green-100 text-green-700' : overallPct >= 50 ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`}>
                      {overallPct.toFixed(0)}%
                    </span>
                  </h3>
                  <div className="bg-white border rounded-lg p-3">
                    <div className="grid grid-cols-6 gap-3">
                      {tracks.map((t, i) => (
                        <div key={i}>
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-xs font-medium text-gray-700">{t.label}</span>
                            <span className={`text-xs font-bold ${t.pct === null ? 'text-gray-400' : t.pct >= 80 ? 'text-green-600' : t.pct >= 40 ? 'text-yellow-600' : 'text-red-600'}`}>
                              {t.pct !== null ? `${t.pct.toFixed(0)}%` : '—'}
                            </span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-1.5">
                            <div className={`h-1.5 rounded-full transition-all ${t.pct === null ? 'bg-gray-300' : t.pct >= 80 ? 'bg-green-500' : t.pct >= 40 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{width: `${Math.max(t.pct || 0, 2)}%`}}></div>
                          </div>
                          <div className="text-xs text-gray-500 mt-0.5">{t.detail}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* ===== DISCOVERY NOTES (collapsible) ===== */}
            {(() => {
              const getQA = (id) => {
                const q = sellerQA.find(qa => qa.id === id);
                if (!q) return { answer: '', numeric: null, numeric2: null, status: 'pending', flagged: false };
                let flagged = false;
                if (q.id === 10 && q.numericValue > 0 && q.numericValue2 > 0 && (q.numericValue2 / q.numericValue) > 0.15) flagged = true;
                if (q.flagKeywords && q.answer && q.flagKeywords.some(kw => q.answer.toLowerCase().includes(kw.toLowerCase()))) flagged = true;
                return { answer: q.answer, numeric: q.numericValue, numeric2: q.numericValue2, status: q.status, flagged };
              };

              const answeredCount = sellerQA.filter(q => q.status === 'answered').length;

              // Build sections with condensed key points only
              const sections = [
                { icon: '🏪', title: 'Business Model', qaIds: [3, 4, 5, 6, 7, 8, 9, 23], format: (items) => {
                  const parts = [];
                  const q3 = getQA(3), q4 = getQA(4), q5 = getQA(5), q6 = getQA(6), q7 = getQA(7), q8 = getQA(8), q9 = getQA(9), q23 = getQA(23);
                  const hasSalesData = customerSalesData.some(c => (c.ttm || 0) > 0);
                  const salesClientCount = customerSalesData.filter(c => (c.ttm || 0) > 0).length;
                  if (q4.numeric || hasSalesData) parts.push(`${hasSalesData ? salesClientCount : q4.numeric} active clients`);
                  if (q3.numeric !== null || keyMetrics.b2bPct !== null) {
                    const b2b = keyMetrics.b2bPct !== null ? keyMetrics.b2bPct : q3.numeric;
                    if (b2b !== null) parts.push(b2b >= 90 ? 'virtually all B2B' : b2b >= 70 ? `${b2b.toFixed(0)}% B2B` : b2b >= 30 ? `${b2b.toFixed(0)}% B2B mix` : 'primarily residential');
                  }
                  if (q7.answer) parts.push(`Contracts: ${q7.answer.toLowerCase()}`);
                  if (q8.answer) parts.push(`Payment: ${q8.answer}`);
                  if (q9.answer) parts.push(`Seasonality: ${q9.answer}`);
                  if (q23.numeric > 0) parts.push(`${q23.numeric}% international`);
                  return parts;
                }},
                { icon: '⚙️', title: 'Operations', qaIds: [10, 11, 12, 13, 14, 24], format: () => {
                  const parts = [];
                  const q10 = getQA(10), q11 = getQA(11), q12 = getQA(12), q13 = getQA(13), q14 = getQA(14), q24 = getQA(24);
                  if (q10.numeric) {
                    let t = `${q10.numeric} employees`;
                    if (keyMetrics.revenuePerEmployee) t += ` (${formatCurrency(keyMetrics.revenuePerEmployee)}/emp)`;
                    if (q10.flagged && q10.numeric2) t += ` ⚠️ ${q10.numeric2} departures (${((q10.numeric2/q10.numeric)*100).toFixed(0)}% turnover)`;
                    parts.push(t);
                  }
                  if (q11.answer) parts.push(`Mgmt: ${q11.answer}`);
                  if (q12.answer) parts.push(`Family: ${q12.answer}${q12.flagged ? ' ⚠️' : ''}`);
                  if (q13.answer) parts.push(`Acq: ${q13.answer}`);
                  if (q14.answer) parts.push(`Vendors: ${q14.answer}`);
                  if (q24.answer) parts.push(`Intl workers: ${q24.answer}`);
                  return parts;
                }},
                { icon: '👤', title: 'Ownership & Transition', qaIds: [1, 2, 15, 16, 17, 18], format: () => {
                  const parts = [];
                  const q1 = getQA(1), q2 = getQA(2), q15 = getQA(15), q16 = getQA(16), q17 = getQA(17), q18 = getQA(18);
                  if (q1.answer) parts.push(`Why selling: ${q1.answer}`);
                  if (q2.answer) parts.push(`Ownership: ${q2.answer}`);
                  if (q15.numeric || q15.answer) parts.push(`Owner hours: ${q15.numeric || q15.answer}/wk`);
                  if (q16.answer) parts.push(`Roles: ${q16.answer}`);
                  if (q17.answer) parts.push(`Post-sale: ${q17.answer}`);
                  if (q18.answer) parts.push(`Stay comp: ${q18.answer}`);
                  return parts;
                }},
                { icon: '📊', title: 'Financial Practices', qaIds: [19, 20, 21], format: () => {
                  const parts = [];
                  const q19 = getQA(19), q20 = getQA(20), q21 = getQA(21);
                  if (q19.answer) parts.push(`Rev recognition: ${q19.answer}`);
                  if (q20.answer) parts.push(`Multi-yr vendors: ${q20.answer}`);
                  if (q21.answer) parts.push(`AP posting: ${q21.answer}`);
                  return parts;
                }},
                { icon: '🏠', title: 'Real Estate', qaIds: [22], format: () => {
                  const q22 = getQA(22);
                  return q22.answer ? [q22.answer] : [];
                }}
              ];

              return (
                <div className="border rounded-lg overflow-hidden">
                  <button type="button" onClick={(e) => { e.preventDefault(); toggleSection('overviewDiscovery', e); }} className="w-full p-3 bg-gray-50 hover:bg-gray-100 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-gray-700">📝 Discovery Notes</span>
                      <span className="text-xs text-gray-500">{answeredCount}/{sellerQA.length} questions answered</span>
                    </div>
                    {expandedSections.overviewDiscovery ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                  </button>
                  {expandedSections.overviewDiscovery && (
                    <div className="p-4 bg-white space-y-3">
                      {sections.map((sec, si) => {
                        const parts = sec.format();
                        const hasAnswers = sec.qaIds.some(id => getQA(id).status === 'answered');
                        return (
                          <div key={si} className="border-b border-gray-100 pb-2 last:border-0 last:pb-0">
                            <div className="text-sm font-semibold text-gray-700 mb-1">{sec.icon} {sec.title}</div>
                            {hasAnswers && parts.length > 0 ? (
                              <div className="text-sm text-gray-600 space-y-0.5">
                                {parts.map((p, pi) => <div key={pi}>• {p}</div>)}
                              </div>
                            ) : (
                              <div className="text-xs text-gray-400 italic">Not yet populated</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>

        ) : viewMode === 'multipleengine' ? (
          /* ========== MULTIPLE ENGINE ========== */
          <div>
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-lg font-bold flex items-center gap-2"><Calculator className="w-5 h-5" /> Multiple Calculation Engine</h2>
            </div>
            <p className="text-sm text-gray-600 mb-4">Using benchmarks: <strong>{industryBenchmarks.find(i => i.id === selectedIndustry)?.name}</strong></p>

            {/* Pro Forma Basis Toggle (only shows if there's Pro Forma data) */}
            {proFormaCalcs.hasProFormaData && (
              <div className="mb-4 p-3 bg-gradient-to-r from-gray-50 to-green-50 rounded-lg border border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="text-sm font-bold text-gray-700">📊 Pro Forma Valuation Basis</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                      proFormaValuationBasis === 'historical' ? 'bg-gray-200 text-gray-700' :
                      proFormaValuationBasis === 'weighted' ? 'bg-gray-200 text-gray-700' :
                      'bg-green-200 text-green-700'
                    }`}>
                      {selectedBasisCalcs.label}: {formatCurrency(selectedBasisCalcs.ebitda)} @ {multipleEngineCalcs.marketHighMultiple?.toFixed(1)}x
                    </span>
                  </div>
                  <div className="flex bg-white rounded-lg p-0.5 shadow-sm border">
                    <button
                      onClick={() => setProFormaValuationBasis('historical')}
                      className={`px-3 py-1 rounded text-xs font-medium transition-all ${
                        proFormaValuationBasis === 'historical' 
                          ? 'bg-gray-700 text-white' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Historical
                    </button>
                    <button
                      onClick={() => setProFormaValuationBasis('weighted')}
                      className={`px-3 py-1 rounded text-xs font-medium transition-all ${
                        proFormaValuationBasis === 'weighted' 
                          ? 'bg-gray-600 text-white' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Weighted
                    </button>
                    <button
                      onClick={() => setProFormaValuationBasis('proforma')}
                      className={`px-3 py-1 rounded text-xs font-medium transition-all ${
                        proFormaValuationBasis === 'proforma' 
                          ? 'bg-green-600 text-white' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Pro Forma
                    </button>
                  </div>
                </div>
                {proFormaValuationBasis !== 'historical' && (
                  <div className="mt-2 text-xs text-gray-600">
                    {proFormaValuationBasis === 'weighted' 
                      ? `Weighted EBITDA includes ${formatCurrency(proFormaCalcs.totalWeightedEbitda)} from pro forma (based on valuation credits)`
                      : `Pro Forma includes ${formatCurrency(proFormaCalcs.totalProratedEbitda)} from ${proFormaItems.length} adjustment(s)`
                    }
                  </div>
                )}
              </div>
            )}

            <div className="grid grid-cols-4 gap-3 mb-4">
              <div className="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500">
                <div className="text-xs text-blue-600 font-semibold">Adjusted EBITDA</div>
                <div className="text-xl font-bold text-blue-900">{formatCurrency(multipleEngineCalcs.adjustedEbitda)}</div>
                <div className="text-xs text-blue-600">{selectedValuationBasis.charAt(0).toUpperCase() + selectedValuationBasis.slice(1)} Basis • TTM</div>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg border-l-4 border-gray-500"><div className="text-xs text-gray-600 font-semibold">Base Multiple</div><div className="text-xl font-bold text-gray-900">{multipleEngineCalcs.baseMultiple.toFixed(2)}x</div><div className="text-xs text-gray-600">After market adj ({(marketCondition?.adjustment || 0) >= 0 ? '+' : ''}{(marketCondition?.adjustment || 0).toFixed(2)}x)</div></div>
              <div className={`p-3 rounded-lg border-l-4 ${multipleEngineCalcs.totalAdjustment >= 0 ? 'bg-blue-50 border-blue-500' : 'bg-amber-50 border-amber-500'}`}><div className={`text-xs font-semibold ${multipleEngineCalcs.totalAdjustment >= 0 ? 'text-blue-600' : 'text-amber-600'}`}>Total Adjustment</div><div className={`text-xl font-bold ${multipleEngineCalcs.totalAdjustment >= 0 ? 'text-blue-900' : 'text-amber-900'}`}>{multipleEngineCalcs.totalAdjustment >= 0 ? '+' : ''}{multipleEngineCalcs.totalAdjustment.toFixed(2)}x</div></div>
              <div className="bg-slate-100 p-3 rounded-lg border-l-4 border-slate-500"><div className="text-xs text-slate-600 font-semibold">Final Multiple</div><div className="text-xl font-bold text-slate-800">{multipleEngineCalcs.marketHighMultiple.toFixed(2)}x</div><div className="text-xs text-orange-600">Typical: {multipleEngineCalcs.typicalMultiple.toFixed(2)}x (85%)</div></div>
            </div>

            <div className="bg-gradient-to-r from-orange-50 to-yellow-50 p-3 rounded-lg mb-4 flex items-center justify-between border border-orange-200">
              <div className="text-sm text-orange-700">Valuation Range</div>
              <div className="text-xl font-bold text-orange-800">{formatCurrency(multipleEngineCalcs.valuationTypical)} - {formatCurrency(multipleEngineCalcs.valuationMarketHigh)}</div>
              <div className="text-xs text-orange-600">Typical ({multipleEngineCalcs.typicalMultiple.toFixed(2)}x) to Market High ({multipleEngineCalcs.marketHighMultiple.toFixed(2)}x)</div>
            </div>

            {/* ========== BASE MULTIPLE FACTORS ========== */}
            <h3 className="font-bold text-gray-800 mb-3 mt-6">Base Multiple Build-Up</h3>
            
            {/* Size Factor */}
            <div className="border rounded-lg mb-2 overflow-hidden">
              <button type="button" onClick={(e) => toggleSection('sizeFactor', e)} className="w-full p-3 bg-gray-50 hover:bg-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-semibold">📏 EBITDA Size Factor</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-bold text-blue-600">{multipleEngineCalcs.rawBaseMultiple.toFixed(2)}x</span>
                  {expandedSections.sizeFactor ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                </div>
              </button>
              {expandedSections.sizeFactor && (
                <div className="p-4 border-t bg-white">
                  <div className="text-sm text-gray-600 mb-3">
                    <strong>Calculation:</strong> {formatCurrency(multipleEngineCalcs.adjustedEbitda)} Adjusted EBITDA → {multipleEngineCalcs.rawBaseMultiple.toFixed(2)}x base multiple
                  </div>
                  <div className="text-xs text-gray-500 mb-3">
                    Larger companies command higher multiples due to reduced risk, management depth, and buyer pool. Multiple is interpolated between tiers.
                  </div>
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="p-2 text-left">EBITDA Tier</th>
                        <th className="p-2 text-right">Multiple</th>
                      </tr>
                    </thead>
                    <tbody>
                      {baseMultipleTable.map((row, idx) => {
                        const _tierE = multipleEngineCalcs.tierEbitda ?? multipleEngineCalcs.adjustedEbitda;
                        const isActive = _tierE >= row.ebitda && (idx === baseMultipleTable.length - 1 || _tierE < baseMultipleTable[idx + 1].ebitda);
                        return (
                          <tr key={idx} className={`border-b ${isActive ? 'bg-blue-100 font-semibold' : ''}`}>
                            <td className="p-2">{formatCurrency(row.ebitda)}+</td>
                            <td className="p-2 text-right">{row.multiple.toFixed(1)}x</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            
            {/* Industry Factor */}
            <div className="border rounded-lg mb-2 overflow-hidden">
              <button type="button" onClick={(e) => toggleSection('industryFactor', e)} className="w-full p-3 bg-gray-50 hover:bg-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-semibold">🏭 Industry Adjustment</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`font-bold ${industryMultipleAdjustment > 0 ? 'text-green-600' : industryMultipleAdjustment < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                    {industryMultipleAdjustment >= 0 ? '+' : ''}{industryMultipleAdjustment.toFixed(2)}x
                  </span>
                  {expandedSections.industryFactor ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                </div>
              </button>
              {expandedSections.industryFactor && (
                <div className="p-4 border-t bg-white">
                  <div className="text-sm text-gray-600 mb-3">
                    <strong>Selected Industry:</strong> {selectedIndustryObj?.name || 'Not Set'}
                  </div>
                  <div className="text-xs text-gray-500 mb-3">
                    Different industries have different risk profiles, growth prospects, and buyer demand. MSPs and recurring revenue businesses typically command premiums, while project-based or declining industries see discounts.
                  </div>
                  <div className="p-3 bg-gray-50 rounded mb-3">
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div>Sector: <span className="font-medium">{industrySectors.find(s => s.id === selectedSector)?.name || 'Not Set'}</span></div>
                      <div>Industry: <span className="font-medium">{selectedIndustryObj?.name || 'Not Set'}</span></div>
                      <div>Benchmark Recurring %: <span className="font-medium">{selectedIndustryObj?.benchmarks?.recurringRevenuePct || 0}%</span></div>
                      <div>Benchmark EBITDA Margin: <span className="font-medium">{selectedIndustryObj?.benchmarks?.ebitdaMargin || 0}%</span></div>
                    </div>
                  </div>
                  <div className="p-3 bg-blue-50 rounded border border-blue-200">
                    <label className="block text-xs font-medium text-blue-700 mb-1">Industry Multiple Adjustment</label>
                    <div className="flex items-center gap-3">
                      <input 
                        type="number" 
                        step="0.05" 
                        value={industryMultipleAdjustment} 
                        onChange={e => setIndustryMultipleAdjustment(Number(e.target.value))} 
                        className="w-24 p-2 border rounded text-sm text-center font-bold"
                      />
                      <span className="text-sm text-gray-600">x multiple adjustment</span>
                      <button 
                        onClick={() => setIndustryMultipleAdjustment(selectedIndustryObj?.adjustment || 0)}
                        className="text-xs text-blue-600 hover:underline ml-auto"
                      >
                        Reset to Industry Default ({selectedIndustryObj?.adjustment || 0}x)
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            {/* Location Factor */}
            <div className="border rounded-lg mb-2 overflow-hidden">
              <button type="button" onClick={(e) => toggleSection('locationFactor', e)} className="w-full p-3 bg-gray-50 hover:bg-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-semibold">📍 Location Adjustment</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`font-bold ${(multipleEngineCalcs.scaledLocationAdj || 0) > 0 ? 'text-green-600' : (multipleEngineCalcs.scaledLocationAdj || 0) < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                    {(multipleEngineCalcs.scaledLocationAdj || 0) >= 0 ? '+' : ''}{(multipleEngineCalcs.scaledLocationAdj || 0).toFixed(2)}x
                  </span>
                  {expandedSections.locationFactor ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                </div>
              </button>
              {expandedSections.locationFactor && (
                <div className="p-4 border-t bg-white">
                  <div className="text-xs text-gray-500 mb-3">
                    Location affects buyer pool and growth potential. Impact scales inversely with company size (larger companies have national buyer pools).
                  </div>
                  
                  {dealProfile.locationType ? (
                    <div className="p-3 bg-blue-50 rounded border border-blue-200 mb-3">
                      <div className="flex items-center gap-2 text-green-700 font-medium text-sm mb-2">
                        <span>📊</span> Data from Setup Tab
                      </div>
                      <div className="grid grid-cols-3 gap-4 text-sm">
                        <div>
                          <span className="text-gray-600">City:</span>
                          <span className="ml-2 font-bold">{dealProfile.city || 'Not set'}</span>
                        </div>
                        <div>
                          <span className="text-gray-600">State:</span>
                          <span className="ml-2 font-bold">{dealProfile.state || 'Not set'}</span>
                        </div>
                        <div>
                          <span className="text-gray-600">Type:</span>
                          <span className="ml-2 font-bold">
                            {dealProfile.locationType === 'major_metro' ? 'Major Metro' : 
                             dealProfile.locationType === 'suburban' ? 'Suburban' :
                             dealProfile.locationType === 'small_city' ? 'Small City' :
                             dealProfile.locationType === 'rural' ? 'Rural' : 'Not set'}
                          </span>
                        </div>
                      </div>
                      <div className="text-xs text-green-600 mt-2">
                        Edit location in the <strong>Setup</strong> tab → Company Profile section.
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 bg-amber-50 border border-amber-200 rounded mb-3">
                      <div className="flex items-center gap-2 text-amber-700 font-medium text-sm">
                        <AlertTriangle className="w-4 h-4" />
                        Location not set
                      </div>
                      <div className="text-xs text-amber-600 mt-1">
                        Set location in the <strong>Setup</strong> tab → Company Profile section to include location adjustment in valuation.
                      </div>
                    </div>
                  )}
                  
                  <div className="p-3 bg-gray-50 rounded space-y-2">
                    <div className="text-xs font-semibold text-gray-700 mb-2">Calculation:</div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div>Base Location Adjustment:</div>
                      <div className="font-medium">{(locationTypeAdjustments[dealProfile.locationType] || 0) >= 0 ? '+' : ''}{(locationTypeAdjustments[dealProfile.locationType] || 0).toFixed(2)}x</div>
                      <div>Scale Factor (based on EBITDA size):</div>
                      <div className="font-medium">{((multipleEngineCalcs.locationScaleFactor || 1) * 100).toFixed(0)}%</div>
                      <div>Scaled Location Adjustment:</div>
                      <div className="font-medium">{(multipleEngineCalcs.scaledLocationAdj || 0) >= 0 ? '+' : ''}{(multipleEngineCalcs.scaledLocationAdj || 0).toFixed(2)}x</div>
                    </div>
                    <div className="text-xs text-gray-500 border-t pt-2 mt-2">
                      Scale: Under $250K = 100% | $250K-$500K = 75% | $500K-$1M = 50% | $1M+ = 25%
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            {/* Market Condition Factor */}
            <div className="border rounded-lg mb-2 overflow-hidden">
              <button type="button" onClick={(e) => toggleSection('marketFactor', e)} className="w-full p-3 bg-gray-50 hover:bg-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-semibold">📈 Market Condition</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`font-bold ${(marketCondition?.adjustment || 0) > 0 ? 'text-green-600' : (marketCondition?.adjustment || 0) < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                    {(marketCondition?.adjustment || 0) >= 0 ? '+' : ''}{(marketCondition?.adjustment || 0).toFixed(2)}x
                  </span>
                  {expandedSections.marketFactor ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                </div>
              </button>
              {expandedSections.marketFactor && (
                <div className="p-4 border-t bg-white">
                  <div className="text-xs text-gray-500 mb-3">
                    M&A market conditions affect multiples. Hot markets see premium multiples; recessions see discounts. Applied as a direct adjustment to the base multiple.
                  </div>
                  
                  <div className="p-3 bg-blue-50 rounded border border-blue-200 mb-3">
                    <div className="grid grid-cols-3 gap-3">
                      <div>
                        <label className="block text-xs font-medium text-blue-700 mb-1">Market Name</label>
                        <input 
                          type="text" 
                          value={marketCondition.name || ''} 
                          onChange={e => setMarketCondition({...marketCondition, name: e.target.value})} 
                          className="w-full p-2 border rounded text-sm"
                          placeholder="e.g., Normal Market (2024)"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-blue-700 mb-1">Adjustment (x)</label>
                        <input 
                          type="number" 
                          step="0.05" 
                          value={marketCondition?.adjustment || 0} 
                          onChange={e => setMarketCondition({...marketCondition, adjustment: Number(e.target.value)})} 
                          className="w-full p-2 border rounded text-sm text-center font-bold"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-blue-700 mb-1">Notes</label>
                        <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} 
                          value={marketCondition.notes || ''} 
                          onChange={e => setMarketCondition({...marketCondition, notes: e.target.value})} 
                          className="w-full p-2 border rounded text-sm"
                          placeholder="Market notes..."
                        />
                      </div>
                    </div>
                    <div className="mt-2 text-xs text-gray-500">
                      Presets: 
                      <button type="button" onClick={() => setMarketCondition({name: 'Hot Market', adjustment: 0.50, notes: 'Strong buyer demand, multiple expansion'})} className="ml-2 text-blue-600 hover:underline">Hot (+0.50x)</button>
                      <button type="button" onClick={() => setMarketCondition({name: 'Normal Market', adjustment: 0, notes: 'Current market conditions'})} className="ml-2 text-blue-600 hover:underline">Normal (0x)</button>
                      <button type="button" onClick={() => setMarketCondition({name: 'Soft Market', adjustment: -0.50, notes: 'Reduced buyer activity, multiple compression'})} className="ml-2 text-blue-600 hover:underline">Soft (-0.50x)</button>
                      <button type="button" onClick={() => setMarketCondition({name: 'Recession', adjustment: -1.00, notes: 'Economic downturn, limited financing'})} className="ml-2 text-blue-600 hover:underline">Recession (-1.00x)</button>
                    </div>
                  </div>
                  
                  <div className="p-3 bg-gray-50 rounded">
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div>Market Adjustment:</div>
                      <div className="font-medium">{(marketCondition?.adjustment || 0) >= 0 ? '+' : ''}{(marketCondition?.adjustment || 0).toFixed(2)}x</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            {/* Base Multiple Summary */}
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-6">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-sm text-blue-700 font-medium">Base Multiple Calculation</div>
                  <div className="text-xs text-blue-600 mt-1">
                    Size ({multipleEngineCalcs.rawBaseMultiple.toFixed(2)}x) + Industry ({industryMultipleAdjustment >= 0 ? '+' : ''}{industryMultipleAdjustment.toFixed(2)}x) + Location ({(multipleEngineCalcs.scaledLocationAdj || 0) >= 0 ? '+' : ''}{(multipleEngineCalcs.scaledLocationAdj || 0).toFixed(2)}x) + Market ({(marketCondition?.adjustment || 0) >= 0 ? '+' : ''}{(marketCondition?.adjustment || 0).toFixed(2)}x)
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-blue-800">{multipleEngineCalcs.baseMultiple.toFixed(2)}x</div>
                  <div className="text-xs text-blue-600">Effective Base Multiple</div>
                </div>
              </div>
            </div>

            <h3 className="font-bold text-gray-800 mb-3">Quality Factors</h3>

            {/* A: Revenue Quality */}
            <FactorSection factorKey="revenueQuality" factor={multipleEngineCalcs.factors?.A} hasSubFactors={true}>
              {/* Data Provenance: Revenue Type Mix estimated */}
              {multipleEngineCalcs.factors?.A?.dataProvenance?.revenueCategoriesEstimated && (
                <div className="mb-3 p-3 bg-amber-50 border-2 border-amber-400 rounded-lg">
                  <div className="flex items-center gap-2 font-semibold text-amber-800 mb-1">
                    <AlertTriangle className="w-5 h-5" />
                    Revenue Type Mix — Estimated, Not Verified
                  </div>
                  <div className="text-sm text-amber-700">
                    The owner did not return the <strong>Export Class. Form</strong>, so all revenue categories default to <em>Transactional/New</em> (worst-case). The <strong>Revenue Type Mix</strong> sub-factor below is being scored on this estimate. Verified categories could swing this adjustment between {multipleEngineCalcs.factors.A.dataProvenance.swing.min >= 0 ? '+' : ''}{multipleEngineCalcs.factors.A.dataProvenance.swing.min.toFixed(2)}x and {multipleEngineCalcs.factors.A.dataProvenance.swing.max >= 0 ? '+' : ''}{multipleEngineCalcs.factors.A.dataProvenance.swing.max.toFixed(2)}x.
                  </div>
                </div>
              )}
              {/* Fix 1: Reclassification Suggestions Banner */}
              {(revenueAnalysis.reclassificationSuggestions || []).length > 0 && (
                <div className="mb-3 p-3 bg-amber-50 border-2 border-amber-400 rounded-lg">
                  <div className="flex items-center gap-2 font-semibold text-amber-800 mb-2">
                    <AlertTriangle className="w-5 h-5" />
                    Revenue Type Reclassification Suggested
                  </div>
                  <div className="text-sm text-amber-700 mb-2">
                    The following categories appear to be hardware/product sales but are classified as service projects (0.50 weight instead of 0.25):
                  </div>
                  {revenueAnalysis.reclassificationSuggestions.map(s => (
                    <div key={s.id} className="flex items-center justify-between p-2 bg-white rounded border border-amber-200 mb-1">
                      <div>
                        <span className="font-medium text-sm">{s.name}</span>
                        <span className="ml-2 text-xs text-gray-500">Currently: {s.currentType} (0.50) → Suggested: {s.suggestedType} (0.25)</span>
                      </div>
                      <button type="button" onClick={() => {
                        setRevenueCategories(prev => prev.map(c => c.id === s.id ? { ...c, revenueType: s.suggestedType } : c));
                      }} className="px-3 py-1 bg-amber-600 text-white text-xs rounded hover:bg-amber-700">
                        Reclassify →
                      </button>
                    </div>
                  ))}
                  <div className="text-xs text-amber-600 mt-2">
                    💡 Hardware pass-through revenue is weighted at 0.25 (not 0.50 like service projects) because it's fundamentally lumpy and unpredictable even with contracted relationships.
                  </div>
                </div>
              )}
              {/* Fix 4: Customer Revenue Spike Warning */}
              {(keyMetrics?.customerSpikes || []).length > 0 && (
                <div className="mb-3 p-3 bg-red-50 border-2 border-red-300 rounded-lg">
                  <div className="flex items-center gap-2 font-semibold text-red-800 mb-2">
                    <AlertTriangle className="w-5 h-5" />
                    Customer Revenue Spike Detected
                  </div>
                  <div className="text-sm text-red-700 mb-2">
                    Revenue growth is disproportionately driven by a single customer spike — buyers will discount this in diligence:
                  </div>
                  {keyMetrics.customerSpikes.map((spike, i) => (
                    <div key={i} className="p-2 bg-white rounded border border-red-200 mb-1 text-sm">
                      <div className="flex justify-between">
                        <span className="font-medium">{spike.name}</span>
                        <span className="text-red-600 font-bold">{spike.shareOfGrowth.toFixed(0)}% of total growth</span>
                      </div>
                      <div className="text-xs text-gray-600 mt-1">
                        {`$${(spike.priorRevenue/1000).toFixed(0)}K → $${(spike.currentRevenue/1000).toFixed(0)}K (${spike.growthPct > 500 ? '>500' : spike.growthPct.toFixed(0)}% growth) — Now ${spike.concentration.toFixed(1)}% of total revenue`}
                        {spike.hasContract ? ' ✓ Under contract' : ' ⚠️ No contract'}
                      </div>
                    </div>
                  ))}
                  <div className="text-xs text-red-600 mt-2">
                    ⚠️ Consider whether this spike is sustainable or a one-time project/hardware sale. The multiple engine has applied an automatic penalty of {multipleEngineCalcs.factors?.A?.subFactors?.A6?.score?.toFixed(2) || '0.00'}x.
                  </div>
                </div>
              )}
              <div className="mt-3 p-3 bg-gray-50 rounded space-y-3">
                {/* Customer Type - B2B vs Residential - DISPLAY ONLY from Sales Tab */}
                <div>
                  <label className="block text-xs font-medium mb-2">Customer Type (B2B vs Residential) <span className="text-blue-600">±1.0x impact</span></label>
                  {keyMetrics.b2bPct !== null && keyMetrics.b2bPct > 0 ? (
                    <div className="p-3 bg-blue-50 border border-blue-200 rounded">
                      <div className="flex items-center gap-2 text-green-700 font-medium text-sm mb-2">
                        <span>📊</span> Data from Sales Tab
                      </div>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <span className="text-gray-600" title="Includes Non-Profit customers">B2B/Non-Profit:</span>
                          <span className="ml-2 font-bold">{keyMetrics.b2bPct.toFixed(0)}%</span>
                        </div>
                        <div>
                          <span className="text-gray-600">Classification:</span>
                          <span className="ml-2 font-bold">
                            {keyMetrics.b2bPct >= 95 ? '100% B2B (baseline)' :
                             keyMetrics.b2bPct >= 70 ? '>70% B2B (baseline)' :
                             keyMetrics.b2bPct >= 30 ? 'Mixed (-0.25x)' :
                             keyMetrics.b2bPct >= 5 ? '>70% Residential (-0.5x)' :
                             '100% Residential (-0.75x)'}
                          </span>
                        </div>
                      </div>
                      <div className="text-xs text-gray-600 mt-2">
                        Calculated from Customer Type field in Sales tab. B2B and Non-Profit are baseline. Residential has higher churn risk. Government is excluded from the B2B% so it does not reduce the score.
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 bg-amber-50 border border-amber-200 rounded">
                      <div className="flex items-center gap-2 text-amber-700 font-medium text-sm">
                        <AlertTriangle className="w-4 h-4" />
                        No customer type data
                      </div>
                      <div className="text-xs text-amber-600 mt-1">
                        Set the <strong>Customer Type</strong> field (B2B/Residential) for each customer in the <strong>Sales</strong> tab to calculate this factor.
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* A3 Monthly Revenue Stability - show details if monthly data exists */}
              {revenueAnalysis.hasMonthlyData && (
                <div className={`mt-3 p-3 rounded border ${revenueAnalysis.monthsSignificantlyBelow >= 3 ? 'bg-amber-50 border-amber-300' : 'bg-gray-50 border-gray-200'}`}>
                  <h4 className="font-semibold text-gray-800 mb-2">📊 Monthly Revenue Stability</h4>
                  <div className="grid grid-cols-4 gap-3 text-sm">
                    <div className="p-2 bg-white rounded border">
                      <div className="text-xs text-gray-500">Months Below Avg</div>
                      <div className={`text-lg font-bold ${revenueAnalysis.monthsSignificantlyBelow >= 3 ? 'text-red-600' : 'text-gray-700'}`}>
                        {revenueAnalysis.monthsSignificantlyBelow}
                      </div>
                      <div className="text-xs text-gray-400">{`>`}15% below</div>
                    </div>
                    <div className="p-2 bg-white rounded border">
                      <div className="text-xs text-gray-500">Months Above Avg</div>
                      <div className="text-lg font-bold text-green-600">{revenueAnalysis.monthsSignificantlyAbove}</div>
                      <div className="text-xs text-gray-400">{`>`}15% above</div>
                    </div>
                    <div className="p-2 bg-white rounded border">
                      <div className="text-xs text-gray-500">Revenue CV</div>
                      <div className="text-lg font-bold">{revenueAnalysis.monthlyCV.toFixed(1)}%</div>
                      <div className="text-xs text-gray-400">Variability</div>
                    </div>
                    <div className="p-2 bg-white rounded border">
                      <div className="text-xs text-gray-500">Auto Score</div>
                      <div className={`text-lg font-bold ${(multipleEngineCalcs.factors?.A?.subFactors?.A3?.score || 0) > 0 ? 'text-green-600' : (multipleEngineCalcs.factors?.A?.subFactors?.A3?.score || 0) < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                        {(multipleEngineCalcs.factors?.A?.subFactors?.A3?.score || 0) >= 0 ? '+' : ''}{(multipleEngineCalcs.factors?.A?.subFactors?.A3?.score || 0).toFixed(2)}x
                      </div>
                      <div className="text-xs text-gray-400">
                        {revenueAnalysis.monthsSignificantlyBelow === 0 ? 'Rock solid' :
                         revenueAnalysis.monthsSignificantlyBelow <= 2 ? 'Acceptable' :
                         revenueAnalysis.monthsSignificantlyBelow <= 4 ? 'Some concern' : 'Erratic'}
                      </div>
                    </div>
                  </div>
                  <div className="text-xs text-gray-500 mt-2">
                    Scoring: 0 months below = +0.10x (rock solid), 1-2 months = 0x, 3-4 months = -0.05x, 5+ months = -0.15x. Down months penalize more than up months reward.
                  </div>
                  {revenueAnalysis.monthsSignificantlyBelow >= 3 && (
                    <div className="mt-3 pt-3 border-t border-orange-200">
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-medium mb-1">Review Notes</label>
                          <textarea 
                            key={ttmMonthlyData.revenueReviewNotes !== undefined ? 'rev-notes' : 'rev-notes-empty'}
                            defaultValue={ttmMonthlyData.revenueReviewNotes} 
                            onBlur={e => setTtmMonthlyData(prev => ({ ...prev, revenueReviewNotes: e.target.value }))} 
                            className="w-full p-2 border rounded text-sm" 
                            rows="2" 
                            placeholder="e.g., Q1 dip due to seasonal pattern"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium mb-1">Manual Adjustment</label>
                          <input 
                            type="number" 
                            step="0.05" 
                            defaultValue={multipleAdjustments.revenueQuality.monthlyManualAdjustment} 
                            onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, revenueQuality: { ...multipleAdjustments.revenueQuality, monthlyManualAdjustment: Number(e.target.value) } })} 
                            className="w-full p-2 border rounded text-sm" 
                          />
                          <label className="flex items-center gap-2 text-sm mt-2">
                            <input 
                              type="checkbox" 
                              checked={multipleAdjustments.revenueQuality.monthlyReviewed} 
                              onChange={e => setMultipleAdjustments({ ...multipleAdjustments, revenueQuality: { ...multipleAdjustments.revenueQuality, monthlyReviewed: e.target.checked } })} 
                            />
                            Mark as reviewed
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </FactorSection>

            {/* B: EBITDA Quality */}
            <FactorSection factorKey="ebitdaQuality" factor={multipleEngineCalcs.factors?.B} hasSubFactors={true}>
              {/* Show B4 review panel when there are negative months */}
              {normalizedEbitdaMonthly.hasMonthlyData && normalizedEbitdaMonthly.negativeMonths > 0 && (
                <div className={`mt-3 p-3 rounded border ${multipleAdjustments.ebitdaQuality.negativeMonthsReviewed ? 'bg-blue-50 border-blue-300' : 'bg-amber-50 border-amber-300'}`}>
                  <h4 className={`font-semibold mb-2 ${multipleAdjustments.ebitdaQuality.negativeMonthsReviewed ? 'text-green-800' : 'text-orange-800'}`}>
                    {multipleAdjustments.ebitdaQuality.negativeMonthsReviewed ? '✓ Reviewed:' : '⚠️'} {normalizedEbitdaMonthly.negativeMonths} Negative EBITDA Month{normalizedEbitdaMonthly.negativeMonths !== 1 ? 's' : ''} (normalized)
                  </h4>
                  <p className="text-xs text-gray-600 mb-3">
                    Auto-penalty applied: <strong className="text-red-600">{(multipleEngineCalcs.factors?.B?.subFactors?.B4?.autoScore || 0).toFixed(2)}x</strong>.
                    Review and override if negative months are due to timing/one-time items rather than operational issues.
                  </p>
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium mb-1">Override Adjustment</label>
                      <input 
                        type="number" 
                        step="0.05" 
                        defaultValue={multipleAdjustments.ebitdaQuality.negativeMonthsOverride ?? ''} 
                        onBlur={e => {
                          const val = e.target.value === '' ? null : Number(e.target.value);
                          setMultipleAdjustments(prev => ({ 
                            ...prev, 
                            ebitdaQuality: { 
                              ...prev.ebitdaQuality, 
                              negativeMonthsOverride: val 
                            } 
                          }));
                        }} 
                        placeholder={`Auto: ${(multipleEngineCalcs.factors?.B?.subFactors?.B4?.autoScore || 0).toFixed(2)}`}
                        className="w-full p-2 border rounded text-sm" 
                      />
                      <div className="text-xs text-gray-500 mt-1">Leave empty to use auto-penalty</div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1">Reason for Override</label>
                      <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} 
                        defaultValue={multipleAdjustments.ebitdaQuality.negativeMonthsNotes || ''} 
                        onBlur={e => {
                          const val = e.target.value;
                          setMultipleAdjustments(prev => ({ 
                            ...prev, 
                            ebitdaQuality: { 
                              ...prev.ebitdaQuality, 
                              negativeMonthsNotes: val 
                            } 
                          }));
                        }} 
                        placeholder="e.g., One-time bonus payment in March"
                        className="w-full p-2 border rounded text-sm" 
                      />
                    </div>
                    <div className="flex items-end">
                      <label className="flex items-center gap-2 text-sm p-2 bg-white rounded border cursor-pointer hover:bg-gray-50">
                        <input 
                          type="checkbox" 
                          checked={multipleAdjustments.ebitdaQuality.negativeMonthsReviewed} 
                          onChange={e => {
                            const val = e.target.checked;
                            setMultipleAdjustments(prev => ({ 
                              ...prev, 
                              ebitdaQuality: { 
                                ...prev.ebitdaQuality, 
                                negativeMonthsReviewed: val 
                              } 
                            }));
                          }} 
                        />
                        <span className="font-medium">Mark as Reviewed</span>
                      </label>
                    </div>
                  </div>
                  <div className="mt-2 text-xs">
                    <span className="text-gray-500">Current score: </span>
                    <span className={`font-bold ${(multipleEngineCalcs.factors?.B?.subFactors?.B4?.score || 0) < 0 ? 'text-red-600' : 'text-gray-700'}`}>
                      {(multipleEngineCalcs.factors?.B?.subFactors?.B4?.score || 0).toFixed(2)}x
                    </span>
                    {multipleAdjustments.ebitdaQuality.negativeMonthsOverride !== null && (
                      <span className="text-blue-600 ml-2">(overridden from {(multipleEngineCalcs.factors?.B?.subFactors?.B4?.autoScore || 0).toFixed(2)}x)</span>
                    )}
                  </div>
                </div>
              )}
            </FactorSection>

            {/* C: Customer Retention & Churn */}
            <FactorSection factorKey="customerRetention" factor={multipleEngineCalcs.factors?.C} hasSubFactors={true}>
              <div className="space-y-4">
                {(() => {
                  const custCount = keyMetrics?.customerCount;
                  const hasData = custCount && custCount.ttm > 0;
                  const factorC = multipleEngineCalcs.factors?.C;
                  const nrrValue = keyMetrics?.avgNRR;
                  
                  if (!hasData) {
                    return (
                      <div className="p-3 bg-amber-50 border border-amber-200 rounded">
                        <div className="flex items-center gap-2 text-amber-700 font-medium text-sm">
                          <AlertTriangle className="w-4 h-4" />
                          No customer data available
                        </div>
                        <div className="text-xs text-amber-600 mt-1">
                          Enter customer sales data in the <strong>Sales</strong> tab with year-over-year figures to calculate retention, NRR, and growth metrics automatically.
                        </div>
                      </div>
                    );
                  }
                  
                  const bgClass = factorC?.isGrowing ? 'bg-blue-50 border-blue-200' : 
                                  keyMetrics?.revenueGrowingYoY ? 'bg-blue-50 border-blue-200' : 
                                  'bg-gray-50 border-gray-200';
                  
                  return (
                    <div className={`p-3 rounded border ${bgClass}`}>
                      <div className="flex items-center gap-2 font-medium text-sm mb-3">
                        <span>📊</span> 
                        <span className={factorC?.isGrowing ? 'text-green-700' : 'text-gray-700'}>
                          {factorC?.isGrowing ? '✓ Growing Business' : keyMetrics?.revenueGrowingYoY ? 'Revenue Growing' : 'Flat/Declining'}
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-4 text-sm mb-3">
                        <div className="p-2 bg-white rounded border">
                          <div className="text-xs text-gray-500 mb-1">Customer Count Trend</div>
                          <div className="font-bold">
                            {(custCount.year4 || 0) > 0 && <span className="text-gray-500">{custCount.year4} → </span>}
                            {custCount.year5 || 0} → {custCount.ttm || 0}
                            <span className={`ml-2 ${keyMetrics?.customerCountGrowing ? 'text-green-600' : 'text-gray-600'}`}>
                              {keyMetrics?.customerCountGrowing ? '↑' : '→'}
                            </span>
                          </div>
                        </div>
                        <div className="p-2 bg-white rounded border">
                          <div className="text-xs text-gray-500 mb-1">Net Revenue Retention (NRR)</div>
                          <div className={`font-bold ${nrrValue == null ? 'text-gray-500' : nrrValue >= 100 ? 'text-green-600' : nrrValue >= 90 ? 'text-gray-700' : 'text-red-600'}`}>
                            {nrrValue != null ? `${nrrValue.toFixed(0)}%` : 'N/A'}
                          </div>
                          <div className="text-xs text-gray-500">
                            {nrrValue == null ? 'Need 2+ years data' : nrrValue >= 100 ? 'Existing customers expanding' : nrrValue >= 90 ? 'Normal retention' : 'Customer contraction'}
                          </div>
                        </div>
                      </div>
                      
                      <div className="text-xs text-gray-600 bg-white p-2 rounded border">
                        <strong>Logic:</strong> Growing businesses (revenue ↑ + customers ↑) receive a bonus. 
                        NRR measures whether existing customers spend more or less over time. 
                        Only declining businesses with poor NRR receive penalties.
                      </div>
                    </div>
                  );
                })()}
              </div>
            </FactorSection>

            {/* D: Contract Terms */}
            <FactorSection factorKey="contractTerms" factor={multipleEngineCalcs.factors?.D}>
              <div className="space-y-3">
                {/* Data Provenance: Client Detail Form not returned */}
                {multipleEngineCalcs.factors?.D?.dataProvenance && !multipleEngineCalcs.factors.D.dataProvenance.contractDataProvided && (
                  <div className="mb-1 p-3 bg-amber-50 border-2 border-amber-400 rounded-lg">
                    <div className="flex items-center gap-2 font-semibold text-amber-800 mb-1">
                      <AlertTriangle className="w-5 h-5" />
                      Contract Terms — Owner Data Not Provided
                    </div>
                    <div className="text-sm text-amber-700">
                      The owner did not return the <strong>Client Detail Form</strong>, so this adjustment is scored on defaults. Verified contract data (term length, assignability, auto-renew, escalators, term penalty) could swing this adjustment between {multipleEngineCalcs.factors.D.dataProvenance.swing.min >= 0 ? '+' : ''}{multipleEngineCalcs.factors.D.dataProvenance.swing.min.toFixed(2)}x and {multipleEngineCalcs.factors.D.dataProvenance.swing.max >= 0 ? '+' : ''}{multipleEngineCalcs.factors.D.dataProvenance.swing.max.toFixed(2)}x.
                    </div>
                  </div>
                )}
                {/* Sales Tab Data - PRIMARY SOURCE */}
                {(keyMetrics.contractedPct > 0 || customerSalesData.some(c => c.hasContract)) ? (
                  <div className="p-3 bg-blue-50 border border-blue-200 rounded">
                    <div className="flex items-center gap-2 text-green-700 font-medium text-sm mb-2">
                      <span>📊</span> Data from Sales Tab
                    </div>
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div>
                        <span className="text-gray-600">Contracted:</span>
                        <span className="ml-2 font-bold">{keyMetrics.contractedPct.toFixed(0)}%</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Assignable:</span>
                        <span className={`ml-2 font-bold ${keyMetrics.assignablePct >= 80 ? 'text-green-600' : ''}`}>{keyMetrics.assignablePct.toFixed(0)}%</span>
                      </div>
                      {keyMetrics.avgContractMonths !== null && (
                        <div>
                          <span className="text-gray-600">Avg Term:</span>
                          <span className="ml-2 font-bold">{keyMetrics.avgContractMonths.toFixed(0)} months</span>
                        </div>
                      )}
                      <div>
                        <span className="text-gray-600">Auto-Renewal:</span>
                        <span className="ml-2 font-bold">{keyMetrics.autoRenewalPct.toFixed(0)}%</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Price Escalators:</span>
                        <span className="ml-2 font-bold">{keyMetrics.escalatorPct.toFixed(0)}%</span>
                        {keyMetrics.avgEscalatorRate > 0 && <span className="text-gray-500 ml-1">({keyMetrics.avgEscalatorRate.toFixed(1)}% avg)</span>}
                      </div>
                      <div>
                        <span className="text-gray-600">Term Penalty:</span>
                        <span className="ml-2 font-bold">{keyMetrics.termPenaltyPct.toFixed(0)}%</span>
                      </div>
                    </div>
                    <div className="text-xs text-green-600 mt-2">
                      Contract quality is calculated automatically from Sales tab customer data.
                    </div>
                  </div>
                ) : (
                  <div className="p-3 bg-amber-50 border border-amber-200 rounded">
                    <div className="flex items-center gap-2 text-amber-700 font-medium text-sm">
                      <AlertTriangle className="w-4 h-4" />
                      No contract data in Sales tab
                    </div>
                    <div className="text-xs text-amber-600 mt-1 mb-3">
                      Enter customer details in the <strong>Sales</strong> tab (Has Contract, Assignable, etc.) for automatic contract quality scoring.
                    </div>
                    
                    {/* Manual fallback inputs */}
                    <div className="grid grid-cols-2 gap-4 pt-3 border-t border-amber-200">
                      <div>
                        <label className="block text-xs font-medium mb-1">Avg Contract Length (months)</label>
                        <input type="number" defaultValue={multipleAdjustments.contractTerms.avgContractLength} onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, avgContractLength: Number(e.target.value) } })} className="w-full p-2 border rounded text-sm" />
                        <div className="text-xs text-gray-500 mt-1">0=M2M, 12=Annual, 36+=3yr</div>
                      </div>
                      <div>
                        <label className="block text-xs font-medium mb-1">Contract Transferability</label>
                        <select value={multipleAdjustments.contractTerms.transferability} onChange={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, transferability: e.target.value } })} className="w-full p-2 border rounded text-sm">
                          <option value="unknown">Unknown</option>
                          <option value="low">Low (-0.25x)</option>
                          <option value="medium">Medium (+0.05x)</option>
                          <option value="high">High - Assignable (+0.2x)</option>
                        </select>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={multipleAdjustments.contractTerms.hasAutoRenewal} onChange={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, hasAutoRenewal: e.target.checked } })} />Auto-Renewal (+0.1x)</label>
                      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={multipleAdjustments.contractTerms.hasEarlyTermPenalty} onChange={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, hasEarlyTermPenalty: e.target.checked } })} />Early Term Penalty (+0.15x)</label>
                      <div className="col-span-2">
                        <label className="flex items-center gap-2 text-sm">
                          <input type="checkbox" checked={multipleAdjustments.contractTerms.hasPriceEscalators} onChange={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, hasPriceEscalators: e.target.checked } })} />
                          Price Escalators
                        </label>
                        {multipleAdjustments.contractTerms.hasPriceEscalators && (
                          <div className="flex items-center gap-2 mt-1 ml-5">
                            <input type="number" step="1" defaultValue={multipleAdjustments.contractTerms.escalatorPercent} onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, escalatorPercent: Number(e.target.value) } })} className="w-20 p-1 border rounded text-sm" />
                            <span className="text-xs">% annually</span>
                          </div>
                        )}
                      </div>
                      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={multipleAdjustments.contractTerms.hasExitClauses} onChange={e => setMultipleAdjustments({ ...multipleAdjustments, contractTerms: { ...multipleAdjustments.contractTerms, hasExitClauses: e.target.checked } })} />Has Exit Clauses (-0.15x)</label>
                    </div>
                  </div>
                )}
                
                <div className="text-xs text-blue-600 bg-blue-50 p-2 rounded">Multi-year contracts with escalators, assignability, and termination penalties command premium multiples vs month-to-month arrangements.</div>
              </div>
            </FactorSection>

            {/* E: Concentration Risk */}
            <FactorSection factorKey="concentration" factor={multipleEngineCalcs.factors?.E} hasSubFactors={true}>
              <div className="space-y-4 mt-3">
                {/* Customer Concentration - from Sales Tab */}
                <div className="p-3 bg-slate-50 rounded border border-slate-200">
                  <div className="flex items-center gap-2 mb-2">
                    <h4 className="font-semibold text-sm">Customer Concentration</h4>
                    <span className="text-xs px-1.5 py-0.5 bg-blue-200 text-blue-700 rounded">📊 From Sales Tab</span>
                  </div>
                  {(() => {
                    const salesTabClientCount = (customerSalesData || []).filter(c => (c?.ttm || 0) > 0).length;
                    const sortedCustomers = [...(customerSalesData || [])].sort((a, b) => (b?.ttm || 0) - (a?.ttm || 0));
                    const totalTTM = (customerSalesData || []).reduce((s, c) => s + (c?.ttm || 0), 0);
                    const top1Pct = totalTTM > 0 && sortedCustomers[0] ? ((sortedCustomers[0].ttm || 0) / totalTTM * 100) : 0;
                    const top5Pct = totalTTM > 0 ? (sortedCustomers.slice(0, 5).reduce((s, c) => s + (c?.ttm || 0), 0) / totalTTM * 100) : 0;
                    
                    if (salesTabClientCount === 0) {
                      return (
                        <div className="text-sm text-amber-600">
                          ⚠️ No customer data in Sales tab. <button type="button" onClick={() => setViewMode('customers')} className="text-blue-600 hover:underline">Go to Sales tab</button> to enter customer data.
                        </div>
                      );
                    }
                    
                    return (
                      <div className="grid grid-cols-4 gap-4">
                        <div className="bg-white p-2 rounded border">
                          <div className="text-xs text-gray-500">Total Clients</div>
                          <div className="text-xl font-bold text-indigo-700">{salesTabClientCount}</div>
                        </div>
                        <div className="bg-white p-2 rounded border">
                          <div className="text-xs text-gray-500">Top Customer</div>
                          <div className={`text-xl font-bold ${top1Pct > 20 ? 'text-red-600' : top1Pct > 15 ? 'text-amber-600' : 'text-green-600'}`}>{top1Pct.toFixed(1)}%</div>
                          {top1Pct > 20 && <div className="text-xs text-red-500">Exceeds SBA 20%</div>}
                        </div>
                        <div className="bg-white p-2 rounded border">
                          <div className="text-xs text-gray-500">Top 5 Customers</div>
                          <div className={`text-xl font-bold ${top5Pct > 50 ? 'text-amber-600' : 'text-gray-700'}`}>{top5Pct.toFixed(1)}%</div>
                        </div>
                        <div>
                          <label className="block text-xs font-medium mb-1">Top Customer Contract</label>
                          {(() => {
                            const detailImported = (customerSalesData || []).some(c =>
                              c.assignable === true || c.assignable === false ||
                              c.autoRenewal === true || c.autoRenewal === false ||
                              c.earlyTermPenalty === true || c.earlyTermPenalty === false ||
                              c.priceEscalator === true || c.priceEscalator === false
                            );
                            const _cp = ((customerSalesData || []).reduce((s, c) => s + (c.ttm || 0), 0) > 0) ? 'ttm' : 'year5';
                            const sortedForTop = [...(customerSalesData || [])].sort((a, b) => (b[_cp] || b.ttm || 0) - (a[_cp] || a.ttm || 0));
                            const topC = sortedForTop[0];
                            const hasTopRevenue = topC && ((topC[_cp] || topC.ttm || 0) > 0);
                            if (detailImported && hasTopRevenue) {
                              const autoVal = topC.hasContract
                                ? ((topC.contractMonths >= 24) ? 'Multi-Year' : 'Annual')
                                : 'Month-to-Month';
                              return (
                                <div className="flex items-center gap-1">
                                  <div className="flex-1 p-2 border rounded text-sm bg-blue-50 text-blue-800 font-medium">
                                    {autoVal}
                                  </div>
                                  <span className="text-xs text-blue-500" title="Auto-detected from Sales tab client detail data">📋</span>
                                </div>
                              );
                            }
                            return (
                              <select value={multipleAdjustments.concentration.topCustomerContracted} onChange={e => setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, topCustomerContracted: e.target.value } })} className="w-full p-2 border rounded text-sm">
                                <option value="unknown">Unknown</option>
                                <option value="mtm">Month-to-Month ⚠️</option>
                                <option value="annual">Annual</option>
                                <option value="multi_year">Multi-Year</option>
                              </select>
                            );
                          })()}
                        </div>
                      </div>
                    );
                  })()}
                </div>
                
                {/* Client Industry Concentration */}
                <div className="p-3 bg-gray-50 rounded">
                  <h4 className="font-semibold text-sm mb-2">Client Industry Concentration</h4>
                  <p className="text-xs text-gray-600 mb-2">Track what industries your clients operate in. High concentration in a single declining industry = risk.</p>
                  <table className="w-full text-xs mb-2">
                    <thead><tr className="bg-gray-200"><th className="p-1 text-left">Industry</th><th className="p-1 text-center">% of Rev</th><th className="p-1 text-center">Trend</th><th className="p-1 text-left">Notes</th><th className="p-1 w-8"></th></tr></thead>
                    <tbody>
                      {multipleAdjustments.concentration.clientIndustries.map((ind, idx) => (
                        <tr key={idx}>
                          <td className="p-1 border">
                            <input type="text" value={ind.industry} onChange={e => {
                              const updated = [...multipleAdjustments.concentration.clientIndustries];
                              updated[idx] = { ...updated[idx], industry: e.target.value };
                              setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, clientIndustries: updated } });
                            }} className="w-full p-1 border rounded text-xs" placeholder="e.g., Healthcare" />
                          </td>
                          <td className="p-1 border text-center">
                            <input type="number" value={ind.pct} onChange={e => {
                              const updated = [...multipleAdjustments.concentration.clientIndustries];
                              updated[idx] = { ...updated[idx], pct: Number(e.target.value) };
                              setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, clientIndustries: updated } });
                            }} className="w-16 p-1 border rounded text-xs text-center" />
                          </td>
                          <td className="p-1 border text-center">
                            <select value={ind.trend} onChange={e => {
                              const updated = [...multipleAdjustments.concentration.clientIndustries];
                              updated[idx] = { ...updated[idx], trend: e.target.value };
                              setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, clientIndustries: updated } });
                            }} className="p-1 border rounded text-xs">
                              <option value="stable">Stable</option>
                              <option value="growing">Growing</option>
                              <option value="declining">Declining</option>
                            </select>
                          </td>
                          <td className="p-1 border">
                            <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} defaultValue={ind.notes || ''} onBlur={e => {
                              const updated = [...multipleAdjustments.concentration.clientIndustries];
                              updated[idx] = { ...updated[idx], notes: e.target.value };
                              setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, clientIndustries: updated } });
                            }} className="w-full p-1 border rounded text-xs" placeholder="Notes" />
                          </td>
                          <td className="p-1 border text-center">
                            <button type="button" onClick={() => {
                              const updated = multipleAdjustments.concentration.clientIndustries.filter((_, i) => i !== idx);
                              setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, clientIndustries: updated } });
                            }} className="text-red-500 hover:text-red-700 text-xs">✕</button>
                          </td>
                        </tr>
                      ))}
                      {multipleAdjustments.concentration.clientIndustries.length === 0 && (
                        <tr><td colSpan="5" className="p-2 text-center text-gray-400 italic">No industries added yet</td></tr>
                      )}
                    </tbody>
                  </table>
                  <button type="button" onClick={() => {
                    const updated = [...multipleAdjustments.concentration.clientIndustries, { industry: '', pct: 0, trend: 'stable', notes: '' }];
                    setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, clientIndustries: updated } });
                  }} className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 mb-3">+ Add Industry</button>
                  
                  <div className="grid grid-cols-2 gap-3 mt-2 pt-2 border-t">
                    <div><label className="block text-xs font-medium mb-1">Industry Concentration Adjustment</label><input type="number" step="0.05" defaultValue={multipleAdjustments.concentration.industryConcentrationAdjustment} onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, industryConcentrationAdjustment: Number(e.target.value) } })} className="w-full p-2 border rounded text-sm" placeholder="e.g., -0.15" /><div className="text-xs text-gray-500 mt-1">Negative if concentrated in declining industries</div></div>
                    <div><label className="block text-xs font-medium mb-1">Assessment Notes</label><textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} defaultValue={multipleAdjustments.concentration.industryConcentrationNotes} onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, industryConcentrationNotes: e.target.value } })} className="w-full p-2 border rounded text-sm" placeholder="e.g., 60% in retail - declining sector" /></div>
                  </div>
                </div>
                
                {/* Vendor Concentration */}
                <div className="p-3 bg-amber-50 rounded border border-amber-200">
                  <h4 className="font-semibold text-sm mb-2">Vendor Concentration Risk</h4>
                  <p className="text-xs text-gray-600 mb-2">Dependence on a single vendor for critical services/products increases risk.</p>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium mb-1">Top Vendor % of Purchases</label>
                      <input type="number" defaultValue={multipleAdjustments.concentration.topVendorPct} onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, topVendorPct: Number(e.target.value) } })} className="w-full p-2 border rounded text-sm" />
                      <div className="text-xs text-gray-500 mt-1">
                        {multipleAdjustments.concentration.topVendorPct >= 40 ? '⚠️ 40%+ = -0.15x (high risk)' :
                         multipleAdjustments.concentration.topVendorPct >= 30 ? '⚡ 30-39% = -0.05x (moderate)' :
                         'No penalty if <30%'}
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1">Vendor Notes</label>
                      <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} defaultValue={multipleAdjustments.concentration.vendorNotes || ''} onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, concentration: { ...multipleAdjustments.concentration, vendorNotes: e.target.value } })} className="w-full p-2 border rounded text-sm" placeholder="e.g., Microsoft partner - locked in" />
                    </div>
                  </div>
                </div>
              </div>
            </FactorSection>

            {/* H: Owner Continuity */}
            <FactorSection factorKey="ownerTransition" factor={multipleEngineCalcs.factors?.H}>
              <div className="space-y-3 mt-3">
                {/* Check if Discovery Q17 has an answer */}
                {(() => {
                  const q17 = sellerQA.find(q => q.id === 17);
                  const q17DisplayNum = discoveryDisplayNumbers(sellerQA)[17] || '?';
                  const hasDiscoveryAnswer = q17?.answer && q17.answer.trim().length > 0;
                  return hasDiscoveryAnswer ? (
                    <div className="p-3 bg-blue-50 border border-blue-200 rounded">
                      <div className="flex items-center gap-2 text-green-700 font-medium text-sm mb-2">
                        <span>❓</span> From Discovery Q{q17DisplayNum}
                      </div>
                      <div className="text-sm text-gray-700 mb-2">
                        <span className="font-medium">Q: </span>Do the owners want to exit post sale, or would any want to stay?
                      </div>
                      <div className="text-sm font-medium text-gray-900 bg-white p-2 rounded border">
                        {q17.answer}
                      </div>
                      <div className="text-xs text-green-600 mt-2">
                        Owner continuity matters only when there's a dependency problem: staying partially offsets an Owner Dependency penalty (up to +0.35x). If the business already runs without the owner, continuity adds little.
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 bg-amber-50 border border-amber-200 rounded">
                      <div className="flex items-center gap-2 text-amber-700 font-medium text-sm">
                        <AlertTriangle className="w-4 h-4" />
                        Owner continuity not determined
                      </div>
                      <div className="text-xs text-amber-600 mt-1 mb-3">
                        Answer Discovery Q{q17DisplayNum} to determine if owners will stay post-sale, or set manually below.
                      </div>
                      <div>
                        <label className="block text-xs font-medium mb-1">Owners Staying Post-Sale?</label>
                        <select 
                          value={multipleAdjustments.ownerTransition.ownersStaying} 
                          onChange={e => setMultipleAdjustments({ ...multipleAdjustments, ownerTransition: { ...multipleAdjustments.ownerTransition, ownersStaying: e.target.value } })} 
                          className="w-full p-2 border rounded text-sm"
                        >
                          <option value="unknown">Not determined</option>
                          <option value="yes">Yes - Owners staying (offsets dependency, up to +0.35x)</option>
                          <option value="no">No - Owners exiting (0x with proper salary adj)</option>
                        </select>
                      </div>
                    </div>
                  );
                })()}
                
                <div>
                  <label className="block text-xs font-medium mb-1">Notes</label>
                  <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} 
                    defaultValue={multipleAdjustments.ownerTransition.notes || ''} 
                    onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, ownerTransition: { ...multipleAdjustments.ownerTransition, notes: e.target.value } })} 
                    className="w-full p-2 border rounded text-sm" 
                    placeholder="Notes about owner transition..." 
                  />
                </div>
                
                <div className="text-xs text-blue-600 bg-blue-50 p-2 rounded">
                  Owner continuity is a <strong>mitigant for owner dependency</strong>, not standalone credit. Keeping a load-bearing owner only partially offsets the dependency risk — they may clash with the buyer and leave, become a key-man/bus-factor risk, and staying usually raises the owner-comp adjustment (which costs value elsewhere). When the business isn't owner-dependent, continuity adds little. This score is derived from the engine's <strong>calculated</strong> dependency, so it won't shift when you enter a <em>manual</em> Owner Dependency adjustment.
                </div>
              </div>
            </FactorSection>

            {/* J: Owner Dependency */}
            <FactorSection factorKey="ownerDependency" factor={multipleEngineCalcs.factors?.J}>
              <div className="space-y-3 mt-3">
                {/* Display Discovery Q15/Q26 data */}
                {(() => {
                  const q15 = sellerQA.find(q => q.id === 15);
                  const q26 = sellerQA.find(q => q.id === 26);
                  const questionDisplayNumbers = discoveryDisplayNumbers(sellerQA);
                  const q15DisplayNum = questionDisplayNumbers[15] || '?';
                  const q26DisplayNum = questionDisplayNumbers[26] || '?';
                  const hasDiscoveryAnswer = (q15?.answer && q15.answer.trim().length > 0) || q15?.numericValue || q26?.numericValue != null;
                  // Get the label for selected Q26 option
                  const q26Label = q26?.numericValue != null && q26?.selectOptions ? 
                    q26.selectOptions.find(opt => opt.value === q26.numericValue)?.label || `${q26.numericValue}%` : null;
                  return hasDiscoveryAnswer ? (
                    <div className="p-3 bg-blue-50 border border-blue-200 rounded">
                      <div className="flex items-center gap-2 text-green-700 font-medium text-sm mb-2">
                        <span>✓</span> From Discovery Q{q15DisplayNum}/Q{q26DisplayNum}
                      </div>
                      {(q15?.answer || q15?.numericValue) && (
                        <div className="text-sm text-gray-700 mb-2">
                          <span className="font-medium">Q{q15DisplayNum}: </span>Hours per week: <span className="font-medium">{q15.numericValue || q15.answer}</span>
                        </div>
                      )}
                      {q26Label && (
                        <div className="text-sm text-gray-700 mb-2">
                          <span className="font-medium">Q{q26DisplayNum}: </span>Owner revenue: <span className="font-medium">{q26Label}</span>
                        </div>
                      )}
                      <div className="text-xs text-gray-500 mt-2">
                        Calculated: {multipleEngineCalcs.factors?.J?.parsedHours != null ? `${multipleEngineCalcs.factors.J.parsedHours} hrs/week` : 'hours unknown'}
                        {multipleEngineCalcs.factors?.J?.multipleOwners ? ` (highest of values read: ${multipleEngineCalcs.factors.J.parsedHoursValues.join('/')} hrs)` : ''},
                        {multipleEngineCalcs.factors?.J?.q26Answered ? ` ~${multipleEngineCalcs.factors.J.parsedRevenuePct}% revenue from owner` : ' revenue % not answered (assuming 0%)'}
                        {multipleEngineCalcs.factors?.J?.multipleOwners ? <div className="text-xs text-amber-600 mt-1">⚠️ Multiple hour values read from the answer — the score reflects the most-involved owner only. If several owners are full-time, review whether a manual adjustment is warranted (more owner labor to replace).</div> : null}
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 bg-amber-50 border border-amber-200 rounded">
                      <div className="flex items-center gap-2 text-amber-700 font-medium text-sm">
                        <AlertTriangle className="w-4 h-4" />
                        Owner dependency not determined - no multiple adjustment applied
                      </div>
                      <div className="text-xs text-amber-600 mt-1">
                        Answer Discovery Q{q15DisplayNum} (hours/week) and Q{q26DisplayNum} (owner revenue %) to enable this factor.
                      </div>
                    </div>
                  );
                })()}
                
                <div>
                  <label className="block text-xs font-medium mb-1">Manual Adjustment (x)</label>
                  <input
                    type="number"
                    step="0.05"
                    defaultValue={multipleAdjustments.ownerDependency?.manualAdjustment ?? 0}
                    onBlur={e => {
                      const v = parseFloat(e.target.value);
                      setMultipleAdjustments({ ...multipleAdjustments, ownerDependency: { ...multipleAdjustments.ownerDependency, manualAdjustment: isNaN(v) ? 0 : v } });
                    }}
                    className="w-full p-2 border rounded text-sm"
                    placeholder="0.00"
                  />
                  <div className="text-xs text-gray-500 mt-1">
                    Reviewer override for extreme cases the metrics can't see (e.g. a hands-on owner vs. a self-running business with the same headcount). Added on top of the auto score; final result bounded ±1.50x.
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium mb-1">Notes</label>
                  <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }}
                    defaultValue={multipleAdjustments.ownerDependency?.notes || ''}
                    onBlur={e => setMultipleAdjustments({ ...multipleAdjustments, ownerDependency: { ...multipleAdjustments.ownerDependency, notes: e.target.value } })}
                    className="w-full p-2 border rounded text-sm"
                    placeholder="Notes about owner dependency..."
                  />
                </div>
                
                <div className="text-xs text-blue-600 bg-blue-50 p-2 rounded">
                  <strong>Owner Dependency</strong> measures how critical the owner is to daily operations and revenue —
                  the primary owner-side lever, scored symmetrically to ±1.00x. A business that runs independently
                  commands a premium (up to +1.00x for board-level owners); a full-time owner generating most of the
                  revenue is a major risk (down to -1.00x). Use the manual adjustment for extreme cases.
                </div>
              </div>
            </FactorSection>

            {/* I: Other Adjustments - for unusual/rare situations */}
            <FactorSection factorKey="otherAdjustments" factor={multipleEngineCalcs.factors?.I}>
              <div className="space-y-3 mt-3">
                <div className="text-xs text-gray-600 mb-2">
                  Add adjustments for unusual situations not captured by standard factors (e.g., high owner % of workforce, pending litigation, unique assets).
                </div>
                
                {/* Existing adjustments */}
                {(Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : []).map((item, idx) => (
                  <div key={item.id} className="p-3 bg-gray-50 rounded border flex gap-3 items-start">
                    <div className="flex-1">
                      <input 
                        type="text" 
                        defaultValue={item.description || ''} 
                        onBlur={e => {
                          const current = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                          const updated = [...current];
                          updated[idx] = { ...updated[idx], description: e.target.value };
                          setMultipleAdjustments({ ...multipleAdjustments, otherAdjustments: updated });
                        }}
                        className="w-full p-2 border rounded text-sm mb-2" 
                        placeholder="Description (e.g., 3 of 4 employees are owners exiting)"
                      />
                      <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} 
                        defaultValue={item.notes || ''} 
                        onBlur={e => {
                          const current = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                          const updated = [...current];
                          updated[idx] = { ...updated[idx], notes: e.target.value };
                          setMultipleAdjustments({ ...multipleAdjustments, otherAdjustments: updated });
                        }}
                        className="w-full p-2 border rounded text-xs text-gray-600" 
                        placeholder="Notes/justification..."
                      />
                      <select
                        value={item.relatedFactor || ''}
                        onChange={e => {
                          const current = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                          const updated = [...current];
                          updated[idx] = { ...updated[idx], relatedFactor: e.target.value };
                          setMultipleAdjustments({ ...multipleAdjustments, otherAdjustments: updated });
                        }}
                        className="w-full p-2 border rounded text-xs text-gray-600 mt-2 bg-white"
                        title="Which quality factor does this adjustment really relate to? The factor's auto-score stays pure math — tagging makes the engine and report tell the story in the right section instead of a mystery offset here. Repeated same-factor tags = evidence the factor's math needs calibrating."
                      >
                        <option value="">Relates to: General — not factor-specific</option>
                        {Object.entries(FACTOR_TAG_NAMES).map(([k, v]) => (
                          <option key={k} value={k}>Relates to: {v} ({k})</option>
                        ))}
                      </select>
                    </div>
                    <div className="w-24">
                      <input 
                        type="number" 
                        step="0.05" 
                        defaultValue={item.adjustment || 0} 
                        onBlur={e => {
                          const current = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                          const updated = [...current];
                          updated[idx] = { ...updated[idx], adjustment: Number(e.target.value) };
                          setMultipleAdjustments({ ...multipleAdjustments, otherAdjustments: updated });
                        }}
                        className="w-full p-2 border rounded text-sm text-center font-bold" 
                      />
                      <div className="text-xs text-center text-gray-500 mt-1">adjustment</div>
                    </div>
                    <button 
                      type="button"
                      onClick={() => {
                        const sy = window.scrollY;
                        const current = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                        const updated = current.filter((_, i) => i !== idx);
                        setMultipleAdjustments({ ...multipleAdjustments, otherAdjustments: updated });
                        requestAnimationFrame(() => window.scrollTo(0, sy));
                      }}
                      className="p-2 text-slate-500 hover:bg-slate-50 rounded"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                ))}
                
                {/* Add new adjustment button */}
                <button 
                  type="button"
                  onClick={() => {
                    const sy = window.scrollY;
                    const newItem = { id: Date.now(), description: '', adjustment: 0, notes: '' };
                    const current = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                    setMultipleAdjustments({ 
                      ...multipleAdjustments, 
                      otherAdjustments: [...current, newItem] 
                    });
                    requestAnimationFrame(() => window.scrollTo(0, sy));
                  }}
                  className="w-full p-2 border-2 border-dashed border-gray-300 rounded text-sm text-gray-500 hover:border-blue-400 hover:text-blue-600 flex items-center justify-center gap-2"
                >
                  <Plus className="w-4 h-4" /> Add Adjustment
                </button>
                
                {(() => {
                  const adjArray = Array.isArray(multipleAdjustments?.otherAdjustments) ? multipleAdjustments.otherAdjustments : [];
                  if (adjArray.length === 0) return null;
                  const total = adjArray.reduce((s, i) => s + (i?.adjustment || 0), 0);
                  return (
                    <div className="p-2 bg-blue-50 rounded text-sm">
                      <span className="font-medium">Total Other Adjustments: </span>
                      <span className={`font-bold ${total >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                        {total >= 0 ? '+' : ''}{total.toFixed(2)}x
                      </span>
                    </div>
                  );
                })()}
              </div>
            </FactorSection>

            {/* G: A/R & Collections Quality */}
            <FactorSection factorKey="workingCapital" factor={multipleEngineCalcs.factors?.G} hasSubFactors={true}>
              {multipleEngineCalcs.factors?.G?.dataEntered ? (
                <div>
                  <div className="grid grid-cols-4 gap-2 mb-3">
                    {Object.entries(multipleEngineCalcs.factors?.G?.subFactors || {}).map(([key, sf]) => (
                      <div key={key} className={`p-2 rounded text-xs ${sf.score > 0 ? 'bg-blue-50' : sf.score < 0 ? 'bg-slate-100' : 'bg-gray-50'} ${sf.flag ? 'border-2 border-amber-400' : ''}`}>
                        <div className="font-medium text-gray-700">{sf.name} {sf.flag && <span className="text-amber-500">⚠</span>}</div>
                        <div className={`font-bold ${sf.score > 0 ? 'text-green-600' : sf.score < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                          {sf.score >= 0 ? '+' : ''}{sf.score.toFixed(2)}x
                        </div>
                        <div className="text-gray-500">{sf.calculation}</div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Override controls for AR items with penalties */}
                  {(multipleEngineCalcs.factors?.G?.subFactors?.G1?.autoScore < 0 || 
                    multipleEngineCalcs.factors?.G?.subFactors?.G2?.autoScore < 0 || 
                    multipleEngineCalcs.factors?.G?.subFactors?.G3?.autoScore < 0) && (
                    <div className="mt-3 space-y-3">
                      <div className="text-xs font-medium text-gray-600 border-b pb-1">Override AR Penalties (if justified)</div>
                      
                      {/* G1: Moderate past due override */}
                      {multipleEngineCalcs.factors?.G?.subFactors?.G1?.autoScore < 0 && (
                        <div className="p-3 bg-amber-50 rounded border border-amber-200">
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex-1">
                              <div className="font-medium text-amber-800 text-sm">⚠ {multipleEngineCalcs.factors?.G?.subFactors?.G1?.name || 'AR Past Due'}</div>
                              <div className="text-xs text-amber-700">Auto-penalty: {multipleEngineCalcs.factors?.G?.subFactors?.G1?.autoScore?.toFixed(2)}x. Override if customer has valid reason (e.g., timing, dispute resolution).</div>
                            </div>
                            <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                              <input type="checkbox" checked={multipleAdjustments.workingCapitalQuality?.arPastDueReviewed || false} onChange={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, arPastDueReviewed: e.target.checked}})} />
                              Mark as Reviewed
                            </label>
                          </div>
                          <div className="mt-2 flex items-center gap-3">
                            <div className="flex items-center gap-2">
                              <span className="text-xs text-gray-600">Override:</span>
                              <input type="number" step="0.05" min="-0.5" max="0.25" className="w-20 px-2 py-1 border rounded text-sm" placeholder={`Auto: ${multipleEngineCalcs.factors?.G?.subFactors?.G1?.autoScore?.toFixed(2)}`} defaultValue={multipleAdjustments.workingCapitalQuality?.arPastDueOverride ?? ''} onBlur={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, arPastDueOverride: e.target.value === '' ? null : Number(e.target.value)}})} />
                            </div>
                            <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} className="flex-1 px-2 py-1 border rounded text-sm" placeholder="Reason for override..." defaultValue={multipleAdjustments.workingCapitalQuality?.arPastDueNotes || ''} onBlur={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, arPastDueNotes: e.target.value}})} />
                          </div>
                        </div>
                      )}
                      
                      {/* G2: Seriously past due override */}
                      {multipleEngineCalcs.factors?.G?.subFactors?.G2?.autoScore < 0 && (
                        <div className="p-3 bg-amber-50 rounded border border-amber-200">
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex-1">
                              <div className="font-medium text-amber-800 text-sm">⚠ {multipleEngineCalcs.factors?.G?.subFactors?.G2?.name || 'AR Seriously Past Due'}</div>
                              <div className="text-xs text-amber-700">Auto-penalty: {multipleEngineCalcs.factors?.G?.subFactors?.G2?.autoScore?.toFixed(2)}x. Override if customer has valid reason (e.g., known payment delay, dispute being resolved).</div>
                            </div>
                            <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                              <input type="checkbox" checked={multipleAdjustments.workingCapitalQuality?.arSeriousReviewed || false} onChange={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, arSeriousReviewed: e.target.checked}})} />
                              Mark as Reviewed
                            </label>
                          </div>
                          <div className="mt-2 flex items-center gap-3">
                            <div className="flex items-center gap-2">
                              <span className="text-xs text-gray-600">Override:</span>
                              <input type="number" step="0.05" min="-0.5" max="0.25" className="w-20 px-2 py-1 border rounded text-sm" placeholder={`Auto: ${multipleEngineCalcs.factors?.G?.subFactors?.G2?.autoScore?.toFixed(2)}`} defaultValue={multipleAdjustments.workingCapitalQuality?.arSeriousOverride ?? ''} onBlur={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, arSeriousOverride: e.target.value === '' ? null : Number(e.target.value)}})} />
                            </div>
                            <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} className="flex-1 px-2 py-1 border rounded text-sm" placeholder="Reason for override..." defaultValue={multipleAdjustments.workingCapitalQuality?.arSeriousNotes || ''} onBlur={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, arSeriousNotes: e.target.value}})} />
                          </div>
                        </div>
                      )}
                      
                      {/* G3: Negative balances override */}
                      {multipleEngineCalcs.factors?.G?.subFactors?.G3?.autoScore < 0 && (
                        <div className="p-3 bg-amber-50 rounded border border-amber-200">
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex-1">
                              <div className="font-medium text-amber-800 text-sm">⚠ Negative AR Balances</div>
                              <div className="text-xs text-amber-700">Auto-penalty: {multipleEngineCalcs.factors?.G?.subFactors?.G3?.autoScore?.toFixed(2)}x. Override if explained (e.g., customer credits, prepayments).</div>
                            </div>
                            <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                              <input type="checkbox" checked={multipleAdjustments.workingCapitalQuality?.negativeBalancesReviewed || false} onChange={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, negativeBalancesReviewed: e.target.checked}})} />
                              Mark as Reviewed
                            </label>
                          </div>
                          <div className="mt-2 flex items-center gap-3">
                            <div className="flex items-center gap-2">
                              <span className="text-xs text-gray-600">Override:</span>
                              <input type="number" step="0.05" min="-0.5" max="0.25" className="w-20 px-2 py-1 border rounded text-sm" placeholder={`Auto: ${multipleEngineCalcs.factors?.G?.subFactors?.G3?.autoScore?.toFixed(2)}`} defaultValue={multipleAdjustments.workingCapitalQuality?.negativeBalancesOverride ?? ''} onBlur={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, negativeBalancesOverride: e.target.value === '' ? null : Number(e.target.value)}})} />
                            </div>
                            <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} className="flex-1 px-2 py-1 border rounded text-sm" placeholder="Reason for override..." defaultValue={multipleAdjustments.workingCapitalQuality?.negativeBalancesNotes || ''} onBlur={e => setMultipleAdjustments({...multipleAdjustments, workingCapitalQuality: {...multipleAdjustments.workingCapitalQuality, negativeBalancesNotes: e.target.value}})} />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  
                  <div className="text-xs text-gray-600 mt-3">
                    <button onClick={() => setViewMode('arap')} className="text-blue-600 hover:underline">View AR/AP Analysis →</button>
                  </div>
                </div>
              ) : (
                <div className="p-3 bg-amber-50 rounded text-sm text-amber-700">
                  <span className="font-semibold">No AR data entered.</span> Go to <button onClick={() => setViewMode('arap')} className="text-blue-600 hover:underline">AR/AP Analysis</button> to enter aging data.
                </div>
              )}
            </FactorSection>

            {/* K: Franchise */}
            <FactorSection factorKey="franchise" factor={multipleEngineCalcs.factors?.K}>
              <div className="space-y-3 mt-3">
                <div className="flex items-center gap-3">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input 
                      type="checkbox" 
                      checked={multipleAdjustments.franchise?.isFranchise || false}
                      onChange={e => { const v = e.target.checked; const sy = window.scrollY; setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, isFranchise: v } })); requestAnimationFrame(() => window.scrollTo(0, sy)); }}
                    />
                    <span className="font-medium text-sm">This is a franchise business</span>
                  </label>
                </div>
                
                {multipleAdjustments.franchise?.isFranchise && (
                  <div className="space-y-3 p-3 bg-gray-50 rounded border">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs font-medium mb-1">Franchise Name</label>
                        <input type="text" defaultValue={multipleAdjustments.franchise?.franchiseName || ''} onBlur={e => setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, franchiseName: e.target.value } }))} className="w-full p-2 border rounded text-sm" placeholder="e.g., TeamLogic IT" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium mb-1">Remaining Franchise Term (years)</label>
                        <input type="number" defaultValue={multipleAdjustments.franchise?.remainingTermYears ?? ''} onBlur={e => setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, remainingTermYears: e.target.value === '' ? null : Number(e.target.value) } }))} className="w-full p-2 border rounded text-sm" placeholder="e.g., 12" />
                        <div className="text-xs text-gray-500 mt-0.5">{(multipleAdjustments.franchise?.remainingTermYears || 0) <= 3 ? '⚠️ Short term — significant risk' : (multipleAdjustments.franchise?.remainingTermYears || 0) <= 5 ? '⚠️ Moderate term risk' : ''}</div>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-3 gap-3">
                      <div>
                        <label className="block text-xs font-medium mb-1">Royalty Rate (% of revenue)</label>
                        <input type="number" step="0.5" defaultValue={multipleAdjustments.franchise?.royaltyRate || ''} onBlur={e => setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, royaltyRate: Number(e.target.value) || 0 } }))} className="w-full p-2 border rounded text-sm" placeholder="e.g., 6" />
                        <div className="text-xs text-gray-500 mt-0.5">Already reflected in EBITDA</div>
                      </div>
                      <div>
                        <label className="block text-xs font-medium mb-1">Marketing Fund (% of revenue)</label>
                        <input type="number" step="0.5" defaultValue={multipleAdjustments.franchise?.marketingFundRate || ''} onBlur={e => setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, marketingFundRate: Number(e.target.value) || 0 } }))} className="w-full p-2 border rounded text-sm" placeholder="e.g., 2" />
                        <div className="text-xs text-gray-500 mt-0.5">Already reflected in EBITDA</div>
                      </div>
                      <div>
                        <label className="block text-xs font-medium mb-1">Transfer Fee ($)</label>
                        <input type="number" defaultValue={multipleAdjustments.franchise?.transferFee || ''} onBlur={e => setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, transferFee: Number(e.target.value) || 0 } }))} className="w-full p-2 border rounded text-sm" placeholder="e.g., 25000" />
                        <div className="text-xs text-gray-500 mt-0.5">One-time cost to buyer (not in multiple)</div>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-3">
                      <label className="flex items-center gap-2 p-2 bg-white rounded border cursor-pointer hover:bg-gray-50">
                        <input type="checkbox" checked={multipleAdjustments.franchise?.franchisorApproval || false} onChange={e => { const v = e.target.checked; const sy = window.scrollY; setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, franchisorApproval: v } })); requestAnimationFrame(() => window.scrollTo(0, sy)); }} />
                        <div>
                          <div className="text-sm font-medium">Franchisor Approval Required</div>
                          <div className="text-xs text-gray-500">Buyer must be approved by franchisor to complete sale</div>
                        </div>
                      </label>
                      <label className="flex items-center gap-2 p-2 bg-white rounded border cursor-pointer hover:bg-gray-50">
                        <input type="checkbox" checked={multipleAdjustments.franchise?.territoryExclusive || false} onChange={e => { const v = e.target.checked; const sy = window.scrollY; setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, territoryExclusive: v } })); requestAnimationFrame(() => window.scrollTo(0, sy)); }} />
                        <div>
                          <div className="text-sm font-medium">Exclusive Territory</div>
                          <div className="text-xs text-gray-500">Protected geographic territory with no competing franchisees</div>
                        </div>
                      </label>
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium mb-1">Territory / Franchise Notes</label>
                      <textarea rows={1} style={{ fieldSizing: 'content', minHeight: '2rem' }} defaultValue={multipleAdjustments.franchise?.notes || ''} onBlur={e => setMultipleAdjustments(prev => ({ ...prev, franchise: { ...prev.franchise, notes: e.target.value } }))} className="w-full p-2 border rounded text-sm" placeholder="Territory details, restrictions, renewal terms..." />
                    </div>
                  </div>
                )}
                
                <div className="text-xs text-blue-600 bg-blue-50 p-2 rounded">
                  <strong>Franchise</strong> businesses trade at a modest discount to comparable independents due to buyer pool restrictions (franchisor approval), 
                  royalty/fee drag on margins (already in EBITDA), and transfer limitations. Short remaining franchise terms increase risk significantly. 
                  Exclusive territory partially offsets restrictions. Transfer fees are a one-time buyer cost, not a multiple adjustment.
                </div>
              </div>
            </FactorSection>

            {/* L: Software Durability (SaaS only, not on presented deals — Zac 11-03) */}
            <FactorSection factorKey="saasDurability" factor={multipleEngineCalcs.factors?.L} hasSubFactors={true}>
              <div className="space-y-2 mt-3">
                {[
                  ['deterministic', 'Deterministic?', 'Does the product give rule-based answers that must be exactly right (compliance, calculations, order routing), rather than drafts or judgment work AI can replace?'],
                  ['vertical', 'Highly verticalized?', "Is it built around one industry's workflow or regulation?"],
                ].map(([k, label, help]) => (
                  <div key={k} className="flex items-start gap-3">
                    <select
                      value={(multipleAdjustments.saasDurability || {})[k] || ''}
                      onChange={e => { const v = e.target.value; const sy = window.scrollY; setMultipleAdjustments(prev => ({ ...prev, saasDurability: { ...(prev.saasDurability || {}), [k]: v } })); requestAnimationFrame(() => window.scrollTo(0, sy)); }}
                      className="px-2 py-1 border rounded text-sm"
                    >
                      <option value="">—</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    <div className="text-sm"><span className="font-medium">{label}</span> <span className="text-xs text-gray-500">{help}</span></div>
                  </div>
                ))}
                <div className="text-xs text-gray-500">Both yes +0.25x · neither −0.25x · one 0. GRR premium uses the lowest period from the Sales tab.</div>
              </div>
            </FactorSection>

            {/* Quality Factors Summary */}
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-sm text-green-700 font-medium">Total Quality Factor Adjustments</div>
                  <div className="text-xs text-green-600 mt-1">
                    {Object.entries(multipleEngineCalcs.factors || {}).map(([key, f], idx) => (
                      <span key={key}>{idx > 0 ? ' + ' : ''}{f.name.split(' ')[0]} ({f.adjustment >= 0 ? '+' : ''}{f.adjustment.toFixed(2)}x)</span>
                    ))}
                  </div>
                </div>
                <div className="text-right">
                  <div className={`text-2xl font-bold ${multipleEngineCalcs.totalAdjustment >= 0 ? 'text-green-800' : 'text-red-800'}`}>
                    {multipleEngineCalcs.totalAdjustment >= 0 ? '+' : ''}{multipleEngineCalcs.totalAdjustment.toFixed(2)}x
                  </div>
                  <div className="text-xs text-green-600">Quality Adjustments</div>
                </div>
              </div>
            </div>

            <div className="mt-4 p-4 bg-blue-50 rounded-lg flex items-center justify-between">
              <div><h4 className="font-bold text-blue-900">Apply Calculated Multiple?</h4><p className="text-sm text-blue-700">Updates multiple range in Summary.</p></div>
              <button onClick={() => { setValuationInputs({ ...valuationInputs, multipleMin: Math.round(multipleEngineCalcs.multipleMin * 10) / 10, multipleMax: Math.round(multipleEngineCalcs.multipleMax * 10) / 10 }); setViewMode('presentation'); }} className="px-4 py-2 bg-blue-600 text-white rounded font-semibold hover:bg-blue-700">Apply & Go to Presentation →</button>
            </div>
          </div>
        ) : viewMode === 'balancesheet' ? (
          /* ========== BALANCE SHEET (Editable) ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold">Balance Sheet</h2>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-gray-600 font-medium">Basis:</span>
                  <select
                    value={bsBasis}
                    onChange={e => setBsBasis(e.target.value)}
                    className={`px-2 py-1 border rounded text-xs font-medium ${bsBasis === 'cash' ? 'bg-slate-100 text-slate-800' : 'bg-blue-100 text-blue-800'}`}
                  >
                    <option value="cash">Cash Basis</option>
                    <option value="accrual">Accrual Basis</option>
                  </select>
                </div>
                {/* BS Sync Status Chip — only when TTM BS has data; shows mismatches between Annual interim and TTM last-month */}
                {bsTtmReconciliation.active && (
                  bsTtmReconciliation.inSync ? (
                    <span
                      className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 border border-green-300 rounded text-xs font-medium"
                      title={`Interim column matches TTM Monthly BS (${bsTtmReconciliation.lastMonthLabel || 'last month'})`}
                    >
                      ✓ Interim BS in sync with TTM
                    </span>
                  ) : (
                    <button
                      onClick={() => setShowBsReconModal(true)}
                      className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-800 border border-red-400 rounded text-xs font-semibold hover:bg-red-200"
                      title="Click to see which BS accounts don't reconcile"
                    >
                      ⚠ Interim BS out of sync — {bsTtmReconciliation.totalIssues} account{bsTtmReconciliation.totalIssues === 1 ? '' : 's'}
                    </button>
                  )
                )}
                <button
                  onClick={() => {
                    setFullBSPasteData('');
                    setFullBSPastePreview(null);
                    setShowFullBSPasteModal(true);
                  }}
                  className="px-3 py-1.5 bg-purple-600 text-white text-xs rounded hover:bg-purple-700 font-medium"
                >
                  📋 Paste Full Balance Sheet
                </button>
                <button 
                  onClick={() => {
                    setInterimBSPasteData('');
                    setInterimBSPastePreview(null);
                    setShowInterimBSPasteModal(true);
                  }}
                  className="px-3 py-1.5 bg-teal-600 text-white text-xs rounded hover:bg-teal-700 font-medium"
                  title="Paste a single-period Balance Sheet into the Interim column"
                >
                  📋 Paste Interim BS
                </button>
                <button 
                  onClick={rollForwardBalanceSheet} 
                  className="px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700"
                  title="Shift years forward: Year 2 → Year 1, Year 3 → Year 2, New Year → Year 3"
                >
                  ↻ Roll Forward
                </button>
                {(() => {
                  // Show sync button only when TTM Monthly BS has data
                  const hasTtmBsData = [...ttmBsCurrentAssets, ...ttmBsFixedAssets, ...ttmBsOtherAssets, ...ttmBsCurrentLiabilities, ...ttmBsLongTermLiabilities]
                    .some(a => a.values.some(v => v !== 0));
                  const hasInterimData = bsCurrentAssets.some(a => a.interim) || bsCurrentLiabilities.some(a => a.interim);
                  if (!hasTtmBsData) return null;
                  return (
                    <button
                      onClick={syncInterimFromTtmBS}
                      className={`px-3 py-1.5 text-xs rounded font-medium ${hasInterimData ? 'bg-amber-500 hover:bg-amber-600' : 'bg-green-600 hover:bg-green-700'} text-white`}
                      title="Copy the most recent TTM Monthly Balance Sheet snapshot into the Interim column"
                    >
                      ↑ Sync Interim from TTM BS{hasInterimData ? ' (overwrite)' : ''}
                    </button>
                  );
                })()}
              </div>
            </div>
            
            {/* Document Tracker */}
            {renderDocTracker('balancesheet')}
            
            {/* Link to Analysis Tab */}
            <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200 flex items-center justify-between">
              <div>
                <span className="font-medium text-blue-800">📊 Balance Sheet Analysis</span>
                <span className="text-sm text-blue-600 ml-2">Period comparisons, ratios, and issue review</span>
              </div>
              <button onClick={() => setViewMode('bsanalysis')} className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700">
                View Analysis →
              </button>
            </div>
            
            {/* Year Labels */}
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <div className="text-xs font-semibold text-gray-600 mb-2">Year Labels</div>
              <div className="flex gap-4 items-center">
                {['year1', 'year2', 'year3'].map(yearKey => (
                  <div key={yearKey} className="flex items-center gap-1">
                    <span className="text-xs text-gray-500">{yearKey.replace('year', 'Year ')}:</span>
                    <input type="text" value={bsYearLabels[yearKey]} onChange={e => setBsYearLabels({...bsYearLabels, [yearKey]: e.target.value})} className="w-16 px-1 py-0.5 border rounded text-xs text-center" />
                  </div>
                ))}
                <div className="flex items-center gap-1">
                  <span className="text-xs text-gray-500">Interim:</span>
                  <input type="text" value={bsYearLabels.interim} onChange={e => setBsYearLabels({...bsYearLabels, interim: e.target.value})} className="w-16 px-1 py-0.5 border rounded text-xs text-center" />
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-xs text-gray-500">As of:</span>
                  <input type="date" value={bsYearLabels.interimDate} onChange={e => setBsYearLabels({...bsYearLabels, interimDate: e.target.value})} className="px-1 py-0.5 border rounded text-xs" />
                </div>
              </div>
            </div>
            
            {/* Balance Sheet Table */}
            {(() => {
              // Handle Tab key to move down instead of right
              const handleBSTabKey = (e, sectionId, itemIndex, colIndex) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                  e.preventDefault();
                  // Find the next input in the same column
                  const table = document.getElementById('bs-table');
                  if (table) {
                    const inputs = Array.from(table.querySelectorAll(`[data-col="${colIndex}"]`));
                    const currentIndex = inputs.findIndex(inp => inp === e.target);
                    if (currentIndex >= 0 && currentIndex < inputs.length - 1) {
                      inputs[currentIndex + 1].focus();
                    } else if (inputs.length > 0) {
                      // Move to first input in next column
                      const nextColInputs = Array.from(table.querySelectorAll(`[data-col="${colIndex + 1}"]`));
                      if (nextColInputs.length > 0) {
                        nextColInputs[0].focus();
                      }
                    }
                  }
                } else if (e.key === 'Tab' && e.shiftKey) {
                  e.preventDefault();
                  // Find the previous input in the same column
                  const table = document.getElementById('bs-table');
                  if (table) {
                    const inputs = Array.from(table.querySelectorAll(`[data-col="${colIndex}"]`));
                    const currentIndex = inputs.findIndex(inp => inp === e.target);
                    if (currentIndex > 0) {
                      inputs[currentIndex - 1].focus();
                    } else if (colIndex > 0) {
                      // Move to last input in previous column
                      const prevColInputs = Array.from(table.querySelectorAll(`[data-col="${colIndex - 1}"]`));
                      if (prevColInputs.length > 0) {
                        prevColInputs[prevColInputs.length - 1].focus();
                      }
                    }
                  }
                }
              };
              
              const renderBSSection = (title, items, setItems, bgColor, totalCalcKey, isEquity = false, sectionKey = null) => {
                // Sort items: regular accounts first, deferred accounts at bottom
                const sortedItems = [...items].sort((a, b) => {
                  if (a.isDeferredAccount && !b.isDeferredAccount) return 1;
                  if (!a.isDeferredAccount && b.isDeferredAccount) return -1;
                  return 0;
                });
                
                const addItem = () => {
                  const newId = Math.max(...items.map(i => i.id), 0) + 1;
                  setItems([...items, { id: newId, name: '', year1: 0, year2: 0, year3: 0, interim: 0 }]);
                };
                const insertItemAfter = (index) => {
                  // Find the actual item at this sorted index
                  const sortedItem = sortedItems[index];
                  const actualIndex = items.findIndex(i => i.id === sortedItem.id);
                  const newId = Math.max(...items.map(i => i.id), 0) + 1;
                  const newItem = { id: newId, name: '', year1: 0, year2: 0, year3: 0, interim: 0 };
                  setItems([...items.slice(0, actualIndex + 1), newItem, ...items.slice(actualIndex + 1)]);
                };
                const updateItem = (id, field, value) => {
                  setItems(items.map(item => item.id === id ? { ...item, [field]: value } : item));
                };
                const deleteItem = (id) => {
                  // Don't allow deleting deferred accounts
                  const item = items.find(i => i.id === id);
                  if (item?.isDeferredAccount) return;
                  if (items.filter(i => !i.isDeferredAccount).length > 1) {
                    captureUndoState('Delete Balance Sheet Row');
                    setItems(items.filter(item => item.id !== id));
                  }
                };
                
                return (
                  <>
                    <tr className={`${bgColor} font-bold`}>
                      <td colSpan="6" className="p-2 border">
                        <div className="flex items-center justify-between">
                          <span>{title}</span>
                          <div className="flex items-center gap-2">
                            {sectionKey && (
                              <button 
                                onClick={() => openBSPasteModal(sectionKey)}
                                className="text-xs px-2 py-0.5 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 flex items-center gap-1"
                                title="Paste column data from Excel"
                              >
                                📋 Paste
                              </button>
                            )}
                            <button onClick={addItem} className="text-xs px-2 py-0.5 bg-white rounded hover:bg-gray-100 flex items-center gap-1"><Plus className="w-3 h-3" /> Add</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    {sortedItems.map((item, rowIdx) => (
                      <tr key={item.id} className={item.isDeferredAccount ? 'bg-amber-100 border-l-4 border-l-amber-500' : ''}>
                        <td className={`p-1 border ${item.isDeferredAccount ? 'bg-amber-100' : ''}`}>
                          <div className="flex items-center gap-1">
                            <input 
                              type="text" 
                              value={item.name} 
                              onChange={e => updateItem(item.id, 'name', e.target.value)} 
                              className={`flex-1 px-1 py-0.5 border rounded text-xs ${item.isDeferredAccount ? 'bg-amber-50 text-amber-800 font-medium italic cursor-not-allowed' : ''}`}
                              readOnly={item.isDeferredAccount}
                            />
                            {item.isDeferredAccount && <span className="text-amber-600 text-xs font-medium" title="Deferred Account - Requires Review">📋</span>}
                            {!item.isDeferredAccount && (
                              <div className="flex items-center gap-0.5">
                                <button 
                                  onClick={() => insertItemAfter(rowIdx)}
                                  className="text-green-500 hover:text-green-700 text-xs"
                                  title="Insert row below"
                                >
                                  +
                                </button>
                                <button 
                                  onClick={() => deleteItem(item.id)} 
                                  className="text-red-400 hover:text-red-600"
                                  title="Delete row"
                                >
                                  <Trash2 className="w-3 h-3" />
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                        {['year1', 'year2', 'year3', 'interim'].map(yearKey => (
                          <td key={yearKey} className={`p-1 border ${item.isDeferredAccount ? 'bg-amber-100' : yearKey === 'interim' ? 'bg-blue-50' : ''}`}>
                            <CurrencyInput value={item[yearKey]} onChange={val => updateItem(item.id, yearKey, val)} className={`w-full px-1 py-0.5 border rounded text-xs text-right ${item.isDeferredAccount ? 'bg-amber-50' : ''}`} />
                          </td>
                        ))}
                      </tr>
                    ))}
                    <tr className="bg-gray-100 font-semibold">
                      <td className="p-1 border text-xs">Total {title}</td>
                      {['year1', 'year2', 'year3', 'interim'].map(yearKey => (
                        <td key={yearKey} className={`p-1 border text-right text-xs ${yearKey === 'interim' ? 'bg-blue-100' : ''}`}>
                          {formatCurrency(balanceSheetCalcs[yearKey][totalCalcKey])}
                        </td>
                      ))}
                    </tr>
                  </>
                );
              };
              
              return (
                <table 
                  id="bs-table" 
                  className="w-full text-sm border-collapse"
                  onKeyDown={(e) => {
                    if (e.key === 'Tab' && e.target.tagName === 'INPUT') {
                      const table = e.currentTarget;
                      const allInputs = Array.from(table.querySelectorAll('input[type="text"]'));
                      const currentIndex = allInputs.indexOf(e.target);
                      
                      if (currentIndex === -1) return;
                      
                      // Determine column (0 = account name, 1-4 = year columns)
                      const row = e.target.closest('tr');
                      const cells = Array.from(row.querySelectorAll('td'));
                      let colIndex = -1;
                      cells.forEach((cell, idx) => {
                        if (cell.contains(e.target)) colIndex = idx;
                      });
                      
                      if (colIndex >= 0 && colIndex <= 4) { // All columns including labels
                        e.preventDefault();
                        // Find inputs in same column
                        const rows = Array.from(table.querySelectorAll('tbody tr'));
                        const inputsInColumn = [];
                        rows.forEach(r => {
                          const cells = Array.from(r.querySelectorAll('td'));
                          if (cells[colIndex]) {
                            const input = cells[colIndex].querySelector('input');
                            if (input) inputsInColumn.push(input);
                          }
                        });
                        
                        const indexInCol = inputsInColumn.indexOf(e.target);
                        if (!e.shiftKey && indexInCol < inputsInColumn.length - 1) {
                          inputsInColumn[indexInCol + 1].focus();
                        } else if (e.shiftKey && indexInCol > 0) {
                          inputsInColumn[indexInCol - 1].focus();
                        } else if (!e.shiftKey && colIndex < 4) {
                          // Move to next column, first row
                          const nextColInputs = [];
                          rows.forEach(r => {
                            const cells = Array.from(r.querySelectorAll('td'));
                            if (cells[colIndex + 1]) {
                              const input = cells[colIndex + 1].querySelector('input');
                              if (input) nextColInputs.push(input);
                            }
                          });
                          if (nextColInputs.length > 0) nextColInputs[0].focus();
                        }
                      }
                    }
                  }}
                >
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="text-left p-2 border w-1/3">Account</th>
                      <th className="text-right p-2 border w-1/6">{bsYearLabels.year1}</th>
                      <th className="text-right p-2 border w-1/6">{bsYearLabels.year2}</th>
                      <th className="text-right p-2 border w-1/6">{bsYearLabels.year3}</th>
                      <th className="text-right p-2 border w-1/6 bg-blue-100">{bsYearLabels.interim}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* ASSETS */}
                    <tr className="bg-blue-100 font-semibold"><td colSpan="5" className="p-2 border text-center">ASSETS</td></tr>
                    {renderBSSection('Current Assets', bsCurrentAssets, setBsCurrentAssets, 'bg-blue-100', 'totalCurrentAssets', false, 'currentAssets')}
                    {renderBSSection('Fixed Assets', bsFixedAssets, setBsFixedAssets, 'bg-blue-100', 'totalFixedAssets', false, 'fixedAssets')}
                    {renderBSSection('Other Assets', bsOtherAssets, setBsOtherAssets, 'bg-blue-100', 'totalOtherAssets', false, 'otherAssets')}
                    <tr className="bg-blue-300 font-bold">
                      <td className="p-2 border">TOTAL ASSETS</td>
                      {['year1', 'year2', 'year3', 'interim'].map(yearKey => (
                        <td key={yearKey} className={`p-2 border text-right ${yearKey === 'interim' ? 'bg-blue-400' : ''}`}>
                          {formatCurrency(balanceSheetCalcs[yearKey].totalAssets)}
                        </td>
                      ))}
                    </tr>
                    
                    {/* LIABILITIES */}
                    <tr className="bg-slate-300 font-bold"><td colSpan="5" className="p-2 border text-center">LIABILITIES</td></tr>
                    {renderBSSection('Current Liabilities', bsCurrentLiabilities, setBsCurrentLiabilities, 'bg-slate-100', 'totalCurrentLiabilities', false, 'currentLiabilities')}
                    {renderBSSection('Long-Term Liabilities', bsLongTermLiabilities, setBsLongTermLiabilities, 'bg-slate-100', 'totalLTLiabilities', false, 'longTermLiabilities')}
                    <tr className="bg-slate-300 font-bold">
                      <td className="p-2 border">TOTAL LIABILITIES</td>
                      {['year1', 'year2', 'year3', 'interim'].map(yearKey => (
                        <td key={yearKey} className={`p-2 border text-right ${yearKey === 'interim' ? 'bg-slate-400 text-white' : ''}`}>
                          {formatCurrency(balanceSheetCalcs[yearKey].totalLiabilities)}
                        </td>
                      ))}
                    </tr>
                    
                    {/* EQUITY */}
                    <tr className="bg-blue-200 font-bold"><td colSpan="5" className="p-2 border text-center">EQUITY</td></tr>
                    {renderBSSection('Equity', bsEquity, setBsEquity, 'bg-blue-50', 'totalEquity', true, 'equity')}
                    <tr className="bg-blue-200 font-bold">
                      <td className="p-2 border">TOTAL EQUITY</td>
                      {['year1', 'year2', 'year3', 'interim'].map(yearKey => (
                        <td key={yearKey} className={`p-2 border text-right ${yearKey === 'interim' ? 'bg-blue-300' : ''}`}>
                          {formatCurrency(balanceSheetCalcs[yearKey].totalEquity)}
                        </td>
                      ))}
                    </tr>
                    
                    {/* Balance Check */}
                    <tr className="bg-gray-200">
                      <td className="p-2 border font-semibold">Balance Check (Assets - Liab - Equity)</td>
                      {['year1', 'year2', 'year3', 'interim'].map(yearKey => {
                        const diff = balanceSheetCalcs[yearKey].totalAssets - balanceSheetCalcs[yearKey].totalLiabilities - balanceSheetCalcs[yearKey].totalEquity;
                        const isBalanced = Math.abs(diff) < 1;
                        return (
                          <td key={yearKey} className={`p-2 border text-right font-bold ${isBalanced ? 'text-blue-600 bg-blue-50' : 'text-red-600 bg-red-50'}`}>
                            {isBalanced ? '✓ Balanced' : formatCurrency(diff)}
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              );
            })()}
            
            {/* Link to TTM Balance Sheet */}
            <div className="mt-6 p-4 bg-slate-50 rounded-lg border border-slate-200">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-slate-700">📅 TTM Monthly Balance Sheet</h3>
                  <p className="text-xs text-slate-500">Enter 12 months of balance sheet data for working capital analysis</p>
                </div>
                <button onClick={() => setViewMode('ttmbalsheet')} className="px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700">Go to TTM Bal Sheet →</button>
              </div>
            </div>

            {/* BS Reconciliation Detail Modal */}
            {showBsReconModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowBsReconModal(false)}>
                <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">⚠ Interim BS Sync Reconciliation</h3>
                    <button onClick={() => setShowBsReconModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>
                  <div className="mb-3 text-xs text-gray-600">
                    Comparing the Annual Balance Sheet's Interim column against the most recent TTM Monthly BS snapshot
                    {bsTtmReconciliation.lastMonthLabel ? ` (${bsTtmReconciliation.lastMonthLabel})` : ''}.
                    <strong> Mismatch</strong> = matched account but values differ (sync stale or edited after sync).
                    <strong> Stale (no TTM source)</strong> = Annual interim has a value but no matching TTM account — typically a year-over-year carryover.
                    <strong> Unsynced TTM</strong> = TTM account has a value but no matching Annual row.
                    Clicking <strong>↑ Sync Interim from TTM BS</strong> on the Annual BS tab will resolve all three (with a confirmation listing what will be zeroed).
                  </div>
                  <div className="mb-4 p-2 bg-gray-50 rounded border text-sm">
                    <span className="text-gray-500 text-xs">Total issues:</span> <span className="font-bold ml-1">{bsTtmReconciliation.totalIssues}</span>
                  </div>
                  <div className="overflow-auto max-h-[55vh] border rounded">
                    <table className="w-full text-xs">
                      <thead className="bg-gray-100 sticky top-0">
                        <tr>
                          <th className="p-1.5 text-left">Section</th>
                          <th className="p-1.5 text-left">Account</th>
                          <th className="p-1.5 text-left">Issue</th>
                          <th className="p-1.5 text-right">Annual Interim</th>
                          <th className="p-1.5 text-right">TTM {bsTtmReconciliation.lastMonthLabel || 'Last Month'}</th>
                          <th className="p-1.5 text-right">Diff</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bsTtmReconciliation.issues.slice().sort((a,b) => Math.abs(b.diff) - Math.abs(a.diff)).map((iss, i) => {
                          const issueLabel = iss.type === 'mismatch' ? 'Mismatch' : iss.type === 'no_TTM_match' ? 'Stale (no TTM source)' : iss.type === 'duplicate' ? 'Duplicate (Sync merges it)' : 'Unsynced TTM';
                          const issueClass = iss.type === 'mismatch' ? 'bg-amber-100 text-amber-800' : iss.type === 'no_TTM_match' ? 'bg-orange-100 text-orange-800' : iss.type === 'duplicate' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800';
                          return (
                            <tr key={i} className="border-t">
                              <td className="p-1.5 text-gray-600">{iss.section}</td>
                              <td className="p-1.5 font-medium">{iss.name}{iss.type === 'mismatch' && iss.ttmName && iss.ttmName !== iss.name ? <span className="text-gray-400 text-[10px] ml-1">(TTM: {iss.ttmName})</span> : null}</td>
                              <td className="p-1.5"><span className={`px-1 rounded text-[10px] ${issueClass}`}>{issueLabel}</span></td>
                              <td className="p-1.5 text-right">${Math.round(iss.interim).toLocaleString()}</td>
                              <td className="p-1.5 text-right">${Math.round(iss.ttmVal).toLocaleString()}</td>
                              <td className="p-1.5 text-right text-red-700">${Math.round(iss.diff).toLocaleString()}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-end gap-2 pt-3 mt-2 border-t">
                    <button onClick={() => setShowBsReconModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm">Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'ttmbalsheet' ? (
          /* ========== TTM BALANCE SHEET ENTRY ========== */
          <div>
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="text-lg font-bold">📅 TTM Monthly Balance Sheet</h2>
                <p className="text-sm text-gray-500">Enter 12 months of balance sheet data for working capital peg analysis</p>
              </div>
              <div className="flex items-center gap-2">
                {/* BS Sync Status Chip — same indicator as Annual BS tab */}
                {bsTtmReconciliation.active && (
                  bsTtmReconciliation.inSync ? (
                    <span
                      className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 border border-green-300 rounded text-xs font-medium"
                      title={`Annual BS Interim column matches TTM Monthly BS (${bsTtmReconciliation.lastMonthLabel || 'last month'})`}
                    >
                      ✓ Interim BS in sync
                    </span>
                  ) : (
                    <button
                      onClick={() => setShowBsReconModal(true)}
                      className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-800 border border-red-400 rounded text-xs font-semibold hover:bg-red-200"
                      title="Click to see which BS accounts don't reconcile"
                    >
                      ⚠ Interim BS out of sync — {bsTtmReconciliation.totalIssues} account{bsTtmReconciliation.totalIssues === 1 ? '' : 's'}
                    </button>
                  )
                )}
                <button
                  onClick={() => {
                    setFullTtmBSPasteData('');
                    setFullTtmBSPastePreview(null);
                    setShowFullTtmBSPasteModal(true);
                  }}
                  className="px-3 py-1.5 bg-purple-600 text-white text-sm rounded hover:bg-purple-700 font-medium"
                >
                  📋 Paste Full Monthly BS
                </button>
                <button onClick={() => setViewMode('wcanalysis')} className="px-3 py-1 bg-purple-600 text-white text-sm rounded hover:bg-purple-700">WC & CapEx →</button>
              </div>
            </div>
            
            {/* Document Tracker */}
            {renderDocTracker('ttmbalsheet')}
            
            {/* Month Labels */}
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-sm font-semibold text-gray-600">TTM Ending:</span>
                <select 
                  className="px-2 py-1 border rounded text-xs"
                  value={(() => {
                    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const lastLabel = ttmBsMonthLabels[11] || '';
                    const monthPart = lastLabel.split(' ')[0];
                    return monthNames.includes(monthPart) ? monthPart : 'Dec';
                  })()}
                  onChange={e => {
                    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const endMonth = monthNames.indexOf(e.target.value);
                    const lastLabel = ttmBsMonthLabels[11] || '';
                    const yearPart = lastLabel.split(' ')[1];
                    let endYear = parseInt(yearPart) || new Date().getFullYear();
                    // Build 12 months ending at endMonth/endYear
                    let startMonth = endMonth - 11;
                    let startYear = endYear;
                    if (startMonth < 0) { startMonth += 12; startYear--; }
                    const newLabels = [];
                    let m = startMonth, y = startYear;
                    for (let i = 0; i < 12; i++) {
                      newLabels.push(monthNames[m] + ' ' + y);
                      m++;
                      if (m > 11) { m = 0; y++; }
                    }
                    setTtmBsMonthLabels(newLabels);
                  }}
                >
                  {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
                <input 
                  type="number" 
                  className="w-20 px-2 py-1 border rounded text-xs text-center"
                  value={(() => {
                    const lastLabel = ttmBsMonthLabels[11] || '';
                    const yearPart = lastLabel.split(' ')[1];
                    return parseInt(yearPart) || new Date().getFullYear();
                  })()}
                  onChange={e => {
                    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const lastLabel = ttmBsMonthLabels[11] || '';
                    const monthPart = lastLabel.split(' ')[0];
                    const endMonth = monthNames.includes(monthPart) ? monthNames.indexOf(monthPart) : 11;
                    let endYear = parseInt(e.target.value) || new Date().getFullYear();
                    let startMonth = endMonth - 11;
                    let startYear = endYear;
                    if (startMonth < 0) { startMonth += 12; startYear--; }
                    const newLabels = [];
                    let m = startMonth, y = startYear;
                    for (let i = 0; i < 12; i++) {
                      newLabels.push(monthNames[m] + ' ' + y);
                      m++;
                      if (m > 11) { m = 0; y++; }
                    }
                    setTtmBsMonthLabels(newLabels);
                  }}
                  placeholder="Year"
                />
                <span className="text-xs text-gray-400">→ auto-fills 12 months</span>
              </div>
              <div className="grid grid-cols-12 gap-1">
                {ttmBsMonthLabels.map((label, idx) => (
                  <div key={idx} className="px-1 py-1 bg-white border rounded text-xs text-center text-gray-600">{label}</div>
                ))}
              </div>
            </div>
            
            {/* Working Capital Guidance */}
            <div className="mb-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
              <div className="flex items-start gap-3">
                <span className="text-lg">💡</span>
                <div>
                  <div className="text-sm font-semibold text-amber-800 mb-1">Working Capital Account Selection Guide</div>
                  <div className="text-xs text-amber-700 space-y-1">
                    <p>The <strong>Inc</strong> checkbox determines which accounts are included in <strong>Operating Working Capital</strong> calculations.</p>
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div>
                        <div className="font-semibold text-green-700">✓ Typically INCLUDE:</div>
                        <ul className="ml-3 mt-1 space-y-0.5">
                          <li>• Accounts Receivable</li>
                          <li>• Inventory</li>
                          <li>• Prepaid Expenses</li>
                          <li>• Accounts Payable</li>
                          <li>• Accrued Expenses</li>
                          <li>• Deferred Revenue</li>
                        </ul>
                      </div>
                      <div>
                        <div className="font-semibold text-red-700">✗ Typically EXCLUDE:</div>
                        <ul className="ml-3 mt-1 space-y-0.5">
                          <li>• Cash and Cash Equivalents</li>
                          <li>• Short-term Debt / Lines of Credit</li>
                          <li>• Current Portion of Long-term Debt</li>
                          <li>• Notes Payable to Shareholders</li>
                          <li>• Intercompany Receivables/Payables</li>
                        </ul>
                      </div>
                    </div>
                    <p className="mt-2 text-amber-600 italic">Operating WC = Included Current Assets − Included Current Liabilities</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Current Assets Section */}
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-3 py-2 bg-blue-100 cursor-pointer hover:bg-blue-200" onClick={() => setTtmBsCurrentAssetsExpanded(!ttmBsCurrentAssetsExpanded)}>
                <h4 className="font-semibold text-blue-700 flex items-center gap-2">
                  <span>{ttmBsCurrentAssetsExpanded ? '▼' : '▶'}</span> Current Assets <span className="text-xs font-normal text-blue-500">({ttmBsCurrentAssets.filter(a => a.name).length} accounts)</span>
                </h4>
                <div className="flex items-center gap-2">
                  {ttmBsCurrentAssets.some(a => a.name) && <button onClick={(e) => { e.stopPropagation(); if(confirm('Clear all Current Asset accounts?')) setTtmBsCurrentAssets([{ id: Date.now(), name: '', included: true, values: Array(12).fill(0) }]); }} className="text-xs text-red-500 hover:underline">Clear</button>}
                  <button onClick={(e) => { e.stopPropagation(); setTtmBsCurrentAssets([...ttmBsCurrentAssets, { id: Date.now(), name: '', included: true, values: Array(12).fill(0) }]); setTtmBsCurrentAssetsExpanded(true); }} className="text-xs text-blue-600 hover:underline">+ Add</button>
                </div>
              </div>
              {ttmBsCurrentAssetsExpanded && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead><tr className="bg-blue-50">
                    <th className="p-1 border text-left" style={{width: '30px'}} title="Include in Operating WC">Inc</th>
                    <th className="p-1 border text-left" style={{minWidth: '150px'}}>Account</th>
                    {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-1 border text-center" style={{minWidth: '70px'}}>{label}</th>))}
                    <th className="p-1 border text-center bg-blue-100" style={{minWidth: '80px'}}>Avg</th>
                    <th className="p-1 border" style={{width: '30px'}}></th>
                  </tr></thead>
                  <tbody>
                    {ttmBsCurrentAssets.map((acct, idx) => {
                      const nonZeroVals = acct.values.filter(v => v !== 0);
                      const avg = nonZeroVals.length > 0 ? nonZeroVals.reduce((a, b) => a + b, 0) / nonZeroVals.length : 0;
                      return (
                        <tr key={acct.id} className={acct.included ? '' : 'bg-gray-100 opacity-60'}>
                          <td className="p-1 border text-center"><input type="checkbox" checked={acct.included} onChange={e => { setTtmBsCurrentAssets(ttmBsCurrentAssets.map((a, i) => i === idx ? { ...a, included: e.target.checked } : a)); }} /></td>
                          <td className="p-1 border"><input type="text" value={acct.name} onChange={e => { setTtmBsCurrentAssets(ttmBsCurrentAssets.map((a, i) => i === idx ? { ...a, name: e.target.value } : a)); }} className="w-full px-1 py-0.5 border-0 text-xs" placeholder="Account name..." /></td>
                          {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-0 border"><input type="text" value={val === 0 ? '' : val.toLocaleString()} onChange={e => { const newVal = parseFloat(e.target.value.replace(/[^0-9.-]/g, '')) || 0; setTtmBsCurrentAssets(ttmBsCurrentAssets.map((a, i) => i === idx ? { ...a, values: a.values.map((v, j) => j === mIdx ? newVal : v) } : a)); }} className="w-full px-1 py-1 text-xs text-right border-0" placeholder="0" /></td>))}
                          <td className="p-1 border text-right bg-blue-50 font-semibold">{formatCurrency(avg)}</td>
                          <td className="p-1 border text-center"><button onClick={() => setTtmBsCurrentAssets(ttmBsCurrentAssets.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700 text-xs">✕</button></td>
                        </tr>
                      );
                    })}
                    <tr className="bg-blue-100 font-semibold">
                      <td className="p-1 border"></td><td className="p-1 border">Total Current Assets</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsCurrentAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-blue-200">{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => ttmBsCurrentAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0));
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td className="p-1 border"></td>
                    </tr>
                    <tr className="bg-green-50 text-green-700">
                      <td className="p-1 border"></td><td className="p-1 border">Operating CA (Included)</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsCurrentAssets.filter(a => a.included).reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-green-100">{formatCurrency(wcCalculations.operatingAvgCA)}</td>
                      <td className="p-1 border"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              )}
            </div>
            
            {/* Fixed Assets Section */}
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-3 py-2 bg-slate-100 cursor-pointer hover:bg-slate-200" onClick={() => setTtmBsFixedAssetsExpanded(!ttmBsFixedAssetsExpanded)}>
                <h4 className="font-semibold text-slate-700 flex items-center gap-2">
                  <span>{ttmBsFixedAssetsExpanded ? '▼' : '▶'}</span> Fixed Assets <span className="text-xs font-normal text-slate-500">({ttmBsFixedAssets.filter(a => a.name).length} accounts)</span>
                </h4>
                <div className="flex items-center gap-2">
                  {ttmBsFixedAssets.some(a => a.name) && <button onClick={(e) => { e.stopPropagation(); if(confirm('Clear all Fixed Asset accounts?')) setTtmBsFixedAssets([{ id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); }} className="text-xs text-red-500 hover:underline">Clear</button>}
                  <button onClick={(e) => { e.stopPropagation(); setTtmBsFixedAssets([...ttmBsFixedAssets, { id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); setTtmBsFixedAssetsExpanded(true); }} className="text-xs text-slate-600 hover:underline">+ Add</button>
                </div>
              </div>
              {ttmBsFixedAssetsExpanded && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead><tr className="bg-slate-50">
                    <th className="p-1 border text-left" style={{minWidth: '150px'}}>Account</th>
                    {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-1 border text-center" style={{minWidth: '70px'}}>{label}</th>))}
                    <th className="p-1 border text-center bg-slate-100" style={{minWidth: '80px'}}>Avg</th>
                    <th className="p-1 border" style={{width: '30px'}}></th>
                  </tr></thead>
                  <tbody>
                    {ttmBsFixedAssets.map((acct, idx) => {
                      const nonZeroVals = acct.values.filter(v => v !== 0);
                      const avg = nonZeroVals.length > 0 ? nonZeroVals.reduce((a, b) => a + b, 0) / nonZeroVals.length : 0;
                      return (
                        <tr key={acct.id}>
                          <td className="p-1 border"><input type="text" value={acct.name} onChange={e => { setTtmBsFixedAssets(ttmBsFixedAssets.map((a, i) => i === idx ? { ...a, name: e.target.value } : a)); }} className="w-full px-1 py-0.5 border-0 text-xs" placeholder="Account name..." /></td>
                          {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-0 border"><input type="text" value={val === 0 ? '' : val.toLocaleString()} onChange={e => { const newVal = parseFloat(e.target.value.replace(/[^0-9.-]/g, '')) || 0; setTtmBsFixedAssets(ttmBsFixedAssets.map((a, i) => i === idx ? { ...a, values: a.values.map((v, j) => j === mIdx ? newVal : v) } : a)); }} className="w-full px-1 py-1 text-xs text-right border-0" placeholder="0" /></td>))}
                          <td className="p-1 border text-right bg-slate-50 font-semibold">{formatCurrency(avg)}</td>
                          <td className="p-1 border text-center"><button onClick={() => setTtmBsFixedAssets(ttmBsFixedAssets.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700 text-xs">✕</button></td>
                        </tr>
                      );
                    })}
                    <tr className="bg-slate-100 font-semibold">
                      <td className="p-1 border">Total Fixed Assets</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsFixedAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-slate-200">{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => ttmBsFixedAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0));
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td className="p-1 border"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              )}
            </div>
            
            {/* Other Assets Section */}
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-3 py-2 bg-gray-100 cursor-pointer hover:bg-gray-200" onClick={() => setTtmBsOtherAssetsExpanded(!ttmBsOtherAssetsExpanded)}>
                <h4 className="font-semibold text-gray-700 flex items-center gap-2">
                  <span>{ttmBsOtherAssetsExpanded ? '▼' : '▶'}</span> Other Assets <span className="text-xs font-normal text-gray-500">({ttmBsOtherAssets.filter(a => a.name).length} accounts)</span>
                </h4>
                <div className="flex items-center gap-2">
                  {ttmBsOtherAssets.some(a => a.name) && <button onClick={(e) => { e.stopPropagation(); if(confirm('Clear all Other Asset accounts?')) setTtmBsOtherAssets([{ id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); }} className="text-xs text-red-500 hover:underline">Clear</button>}
                  <button onClick={(e) => { e.stopPropagation(); setTtmBsOtherAssets([...ttmBsOtherAssets, { id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); setTtmBsOtherAssetsExpanded(true); }} className="text-xs text-gray-600 hover:underline">+ Add</button>
                </div>
              </div>
              {ttmBsOtherAssetsExpanded && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead><tr className="bg-gray-50">
                    <th className="p-1 border text-left" style={{minWidth: '150px'}}>Account</th>
                    {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-1 border text-center" style={{minWidth: '70px'}}>{label}</th>))}
                    <th className="p-1 border text-center bg-gray-100" style={{minWidth: '80px'}}>Avg</th>
                    <th className="p-1 border" style={{width: '30px'}}></th>
                  </tr></thead>
                  <tbody>
                    {ttmBsOtherAssets.map((acct, idx) => {
                      const nonZeroVals = acct.values.filter(v => v !== 0);
                      const avg = nonZeroVals.length > 0 ? nonZeroVals.reduce((a, b) => a + b, 0) / nonZeroVals.length : 0;
                      return (
                        <tr key={acct.id}>
                          <td className="p-1 border"><input type="text" value={acct.name} onChange={e => { setTtmBsOtherAssets(ttmBsOtherAssets.map((a, i) => i === idx ? { ...a, name: e.target.value } : a)); }} className="w-full px-1 py-0.5 border-0 text-xs" placeholder="Account name..." /></td>
                          {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-0 border"><input type="text" value={val === 0 ? '' : val.toLocaleString()} onChange={e => { const newVal = parseFloat(e.target.value.replace(/[^0-9.-]/g, '')) || 0; setTtmBsOtherAssets(ttmBsOtherAssets.map((a, i) => i === idx ? { ...a, values: a.values.map((v, j) => j === mIdx ? newVal : v) } : a)); }} className="w-full px-1 py-1 text-xs text-right border-0" placeholder="0" /></td>))}
                          <td className="p-1 border text-right bg-gray-50 font-semibold">{formatCurrency(avg)}</td>
                          <td className="p-1 border text-center"><button onClick={() => setTtmBsOtherAssets(ttmBsOtherAssets.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700 text-xs">✕</button></td>
                        </tr>
                      );
                    })}
                    <tr className="bg-gray-100 font-semibold">
                      <td className="p-1 border">Total Other Assets</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsOtherAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-gray-200">{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => ttmBsOtherAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0));
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td className="p-1 border"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              )}
            </div>
            
            {/* ===== TOTAL ASSETS ===== */}
            <div className="mb-4 p-3 bg-blue-100 rounded-lg border-2 border-blue-300">
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <tbody>
                    <tr className="font-bold text-blue-800">
                      <td className="p-2" style={{minWidth: '150px'}}>TOTAL ASSETS</td>
                      {ttmBsMonthLabels.map((_, mIdx) => {
                        const ca = ttmBsCurrentAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        const fa = ttmBsFixedAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        const oa = ttmBsOtherAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        return <td key={mIdx} className="p-2 text-right">{formatCurrency(ca + fa + oa)}</td>;
                      })}
                      <td className="p-2 text-right bg-blue-200" style={{minWidth: '80px'}}>{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => {
                          const ca = ttmBsCurrentAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          const fa = ttmBsFixedAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          const oa = ttmBsOtherAssets.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          return ca + fa + oa;
                        });
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td style={{width: '30px'}}></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Current Liabilities Section */}
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-3 py-2 bg-orange-100 cursor-pointer hover:bg-orange-200" onClick={() => setTtmBsCurrentLiabilitiesExpanded(!ttmBsCurrentLiabilitiesExpanded)}>
                <h4 className="font-semibold text-orange-700 flex items-center gap-2">
                  <span>{ttmBsCurrentLiabilitiesExpanded ? '▼' : '▶'}</span> Current Liabilities <span className="text-xs font-normal text-orange-500">({ttmBsCurrentLiabilities.filter(a => a.name).length} accounts)</span>
                </h4>
                <div className="flex items-center gap-2">
                  {ttmBsCurrentLiabilities.some(a => a.name) && <button onClick={(e) => { e.stopPropagation(); if(confirm('Clear all Current Liability accounts?')) setTtmBsCurrentLiabilities([{ id: Date.now(), name: '', included: true, values: Array(12).fill(0) }]); }} className="text-xs text-red-500 hover:underline">Clear</button>}
                  <button onClick={(e) => { e.stopPropagation(); setTtmBsCurrentLiabilities([...ttmBsCurrentLiabilities, { id: Date.now(), name: '', included: true, values: Array(12).fill(0) }]); setTtmBsCurrentLiabilitiesExpanded(true); }} className="text-xs text-orange-600 hover:underline">+ Add</button>
                </div>
              </div>
              {ttmBsCurrentLiabilitiesExpanded && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead><tr className="bg-orange-50">
                    <th className="p-1 border text-left" style={{width: '30px'}} title="Include in Operating WC">Inc</th>
                    <th className="p-1 border text-left" style={{minWidth: '150px'}}>Account</th>
                    {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-1 border text-center" style={{minWidth: '70px'}}>{label}</th>))}
                    <th className="p-1 border text-center bg-orange-100" style={{minWidth: '80px'}}>Avg</th>
                    <th className="p-1 border" style={{width: '30px'}}></th>
                  </tr></thead>
                  <tbody>
                    {ttmBsCurrentLiabilities.map((acct, idx) => {
                      const nonZeroVals = acct.values.filter(v => v !== 0);
                      const avg = nonZeroVals.length > 0 ? nonZeroVals.reduce((a, b) => a + b, 0) / nonZeroVals.length : 0;
                      return (
                        <tr key={acct.id} className={acct.included ? '' : 'bg-gray-100 opacity-60'}>
                          <td className="p-1 border text-center"><input type="checkbox" checked={acct.included} onChange={e => { setTtmBsCurrentLiabilities(ttmBsCurrentLiabilities.map((a, i) => i === idx ? { ...a, included: e.target.checked } : a)); }} /></td>
                          <td className="p-1 border"><input type="text" value={acct.name} onChange={e => { setTtmBsCurrentLiabilities(ttmBsCurrentLiabilities.map((a, i) => i === idx ? { ...a, name: e.target.value } : a)); }} className="w-full px-1 py-0.5 border-0 text-xs" placeholder="Account name..." /></td>
                          {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-0 border"><input type="text" value={val === 0 ? '' : val.toLocaleString()} onChange={e => { const newVal = parseFloat(e.target.value.replace(/[^0-9.-]/g, '')) || 0; setTtmBsCurrentLiabilities(ttmBsCurrentLiabilities.map((a, i) => i === idx ? { ...a, values: a.values.map((v, j) => j === mIdx ? newVal : v) } : a)); }} className="w-full px-1 py-1 text-xs text-right border-0" placeholder="0" /></td>))}
                          <td className="p-1 border text-right bg-orange-50 font-semibold">{formatCurrency(avg)}</td>
                          <td className="p-1 border text-center"><button onClick={() => setTtmBsCurrentLiabilities(ttmBsCurrentLiabilities.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700 text-xs">✕</button></td>
                        </tr>
                      );
                    })}
                    <tr className="bg-orange-100 font-semibold">
                      <td className="p-1 border"></td><td className="p-1 border">Total Current Liabilities</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-orange-200">{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0));
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td className="p-1 border"></td>
                    </tr>
                    <tr className="bg-green-50 text-green-700">
                      <td className="p-1 border"></td><td className="p-1 border">Operating CL (Included)</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsCurrentLiabilities.filter(a => a.included).reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-green-100">{formatCurrency(wcCalculations.operatingAvgCL)}</td>
                      <td className="p-1 border"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              )}
            </div>
            
            {/* Long-Term Liabilities Section */}
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-3 py-2 bg-red-100 cursor-pointer hover:bg-red-200" onClick={() => setTtmBsLongTermLiabilitiesExpanded(!ttmBsLongTermLiabilitiesExpanded)}>
                <h4 className="font-semibold text-red-700 flex items-center gap-2">
                  <span>{ttmBsLongTermLiabilitiesExpanded ? '▼' : '▶'}</span> Long-Term Liabilities <span className="text-xs font-normal text-red-500">({ttmBsLongTermLiabilities.filter(a => a.name).length} accounts)</span>
                </h4>
                <div className="flex items-center gap-2">
                  {ttmBsLongTermLiabilities.some(a => a.name) && <button onClick={(e) => { e.stopPropagation(); if(confirm('Clear all Long-Term Liability accounts?')) setTtmBsLongTermLiabilities([{ id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); }} className="text-xs text-red-500 hover:underline">Clear</button>}
                  <button onClick={(e) => { e.stopPropagation(); setTtmBsLongTermLiabilities([...ttmBsLongTermLiabilities, { id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); setTtmBsLongTermLiabilitiesExpanded(true); }} className="text-xs text-red-600 hover:underline">+ Add</button>
                </div>
              </div>
              {ttmBsLongTermLiabilitiesExpanded && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead><tr className="bg-red-50">
                    <th className="p-1 border text-left" style={{minWidth: '150px'}}>Account</th>
                    {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-1 border text-center" style={{minWidth: '70px'}}>{label}</th>))}
                    <th className="p-1 border text-center bg-red-100" style={{minWidth: '80px'}}>Avg</th>
                    <th className="p-1 border" style={{width: '30px'}}></th>
                  </tr></thead>
                  <tbody>
                    {ttmBsLongTermLiabilities.map((acct, idx) => {
                      const nonZeroVals = acct.values.filter(v => v !== 0);
                      const avg = nonZeroVals.length > 0 ? nonZeroVals.reduce((a, b) => a + b, 0) / nonZeroVals.length : 0;
                      return (
                        <tr key={acct.id}>
                          <td className="p-1 border"><input type="text" value={acct.name} onChange={e => { setTtmBsLongTermLiabilities(ttmBsLongTermLiabilities.map((a, i) => i === idx ? { ...a, name: e.target.value } : a)); }} className="w-full px-1 py-0.5 border-0 text-xs" placeholder="Account name..." /></td>
                          {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-0 border"><input type="text" value={val === 0 ? '' : val.toLocaleString()} onChange={e => { const newVal = parseFloat(e.target.value.replace(/[^0-9.-]/g, '')) || 0; setTtmBsLongTermLiabilities(ttmBsLongTermLiabilities.map((a, i) => i === idx ? { ...a, values: a.values.map((v, j) => j === mIdx ? newVal : v) } : a)); }} className="w-full px-1 py-1 text-xs text-right border-0" placeholder="0" /></td>))}
                          <td className="p-1 border text-right bg-red-50 font-semibold">{formatCurrency(avg)}</td>
                          <td className="p-1 border text-center"><button onClick={() => setTtmBsLongTermLiabilities(ttmBsLongTermLiabilities.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700 text-xs">✕</button></td>
                        </tr>
                      );
                    })}
                    <tr className="bg-red-100 font-semibold">
                      <td className="p-1 border">Total Long-Term Liabilities</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsLongTermLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-red-200">{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => ttmBsLongTermLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0));
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td className="p-1 border"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              )}
            </div>
            
            {/* ===== TOTAL LIABILITIES ===== */}
            <div className="mb-4 p-3 bg-orange-100 rounded-lg border-2 border-orange-300">
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <tbody>
                    <tr className="font-bold text-orange-800">
                      <td className="p-2" style={{minWidth: '150px'}}>TOTAL LIABILITIES</td>
                      {ttmBsMonthLabels.map((_, mIdx) => {
                        const cl = ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        const ltl = ttmBsLongTermLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        return <td key={mIdx} className="p-2 text-right">{formatCurrency(cl + ltl)}</td>;
                      })}
                      <td className="p-2 text-right bg-orange-200" style={{minWidth: '80px'}}>{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => {
                          const cl = ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          const ltl = ttmBsLongTermLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          return cl + ltl;
                        });
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td style={{width: '30px'}}></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Equity Section */}
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-3 py-2 bg-green-100 cursor-pointer hover:bg-green-200" onClick={() => setTtmBsEquityExpanded(!ttmBsEquityExpanded)}>
                <h4 className="font-semibold text-green-700 flex items-center gap-2">
                  <span>{ttmBsEquityExpanded ? '▼' : '▶'}</span> Equity <span className="text-xs font-normal text-green-500">({ttmBsEquity.filter(a => a.name).length} accounts)</span>
                </h4>
                <div className="flex items-center gap-2">
                  {ttmBsEquity.some(a => a.name) && <button onClick={(e) => { e.stopPropagation(); if(confirm('Clear all Equity accounts?')) setTtmBsEquity([{ id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); }} className="text-xs text-red-500 hover:underline">Clear</button>}
                  <button onClick={(e) => { e.stopPropagation(); setTtmBsEquity([...ttmBsEquity, { id: Date.now(), name: '', included: false, values: Array(12).fill(0) }]); setTtmBsEquityExpanded(true); }} className="text-xs text-green-600 hover:underline">+ Add</button>
                </div>
              </div>
              {ttmBsEquityExpanded && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead><tr className="bg-green-50">
                    <th className="p-1 border text-left" style={{minWidth: '150px'}}>Account</th>
                    {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-1 border text-center" style={{minWidth: '70px'}}>{label}</th>))}
                    <th className="p-1 border text-center bg-green-100" style={{minWidth: '80px'}}>Avg</th>
                    <th className="p-1 border" style={{width: '30px'}}></th>
                  </tr></thead>
                  <tbody>
                    {ttmBsEquity.map((acct, idx) => {
                      const nonZeroVals = acct.values.filter(v => v !== 0);
                      const avg = nonZeroVals.length > 0 ? nonZeroVals.reduce((a, b) => a + b, 0) / nonZeroVals.length : 0;
                      return (
                        <tr key={acct.id}>
                          <td className="p-1 border"><input type="text" value={acct.name} onChange={e => { setTtmBsEquity(ttmBsEquity.map((a, i) => i === idx ? { ...a, name: e.target.value } : a)); }} className="w-full px-1 py-0.5 border-0 text-xs" placeholder="Account name..." /></td>
                          {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-0 border"><input type="text" value={val === 0 ? '' : val.toLocaleString()} onChange={e => { const newVal = parseFloat(e.target.value.replace(/[^0-9.-]/g, '')) || 0; setTtmBsEquity(ttmBsEquity.map((a, i) => i === idx ? { ...a, values: a.values.map((v, j) => j === mIdx ? newVal : v) } : a)); }} className="w-full px-1 py-1 text-xs text-right border-0" placeholder="0" /></td>))}
                          <td className="p-1 border text-right bg-green-50 font-semibold">{formatCurrency(avg)}</td>
                          <td className="p-1 border text-center"><button onClick={() => setTtmBsEquity(ttmBsEquity.filter((_, i) => i !== idx))} className="text-red-500 hover:text-red-700 text-xs">✕</button></td>
                        </tr>
                      );
                    })}
                    <tr className="bg-green-100 font-semibold">
                      <td className="p-1 border">Total Equity</td>
                      {ttmBsMonthLabels.map((_, mIdx) => (<td key={mIdx} className="p-1 border text-right">{formatCurrency(ttmBsEquity.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0))}</td>))}
                      <td className="p-1 border text-right bg-green-200">{formatCurrency((() => {
                        // Calculate average of monthly totals (correct method)
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => ttmBsEquity.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0));
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td className="p-1 border"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              )}
            </div>
            
            {/* ===== TOTAL LIABILITIES + EQUITY + BALANCE CHECK ===== */}
            <div className="mb-4 p-3 bg-green-100 rounded-lg border-2 border-green-300">
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <tbody>
                    <tr className="font-bold text-green-800">
                      <td className="p-2" style={{minWidth: '150px'}}>TOTAL LIABILITIES + EQUITY</td>
                      {ttmBsMonthLabels.map((_, mIdx) => {
                        const cl = ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        const ltl = ttmBsLongTermLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        const eq = ttmBsEquity.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                        return <td key={mIdx} className="p-2 text-right">{formatCurrency(cl + ltl + eq)}</td>;
                      })}
                      <td className="p-2 text-right bg-green-200" style={{minWidth: '80px'}}>{formatCurrency((() => {
                        const monthlyTotals = ttmBsMonthLabels.map((_, mIdx) => {
                          const cl = ttmBsCurrentLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          const ltl = ttmBsLongTermLiabilities.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          const eq = ttmBsEquity.reduce((sum, acct) => sum + (acct.values[mIdx] || 0), 0);
                          return cl + ltl + eq;
                        });
                        const nonZeroTotals = monthlyTotals.filter(v => v !== 0);
                        return nonZeroTotals.length > 0 ? nonZeroTotals.reduce((a, b) => a + b, 0) / nonZeroTotals.length : 0;
                      })())}</td>
                      <td style={{width: '30px'}}></td>
                    </tr>
                    {/* Balance Check Row */}
                    {(() => {
                      const hasData = ttmBsMonthLabels.some((_, mIdx) => {
                        const a = ttmBsCurrentAssets.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsFixedAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsOtherAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        return a !== 0;
                      });
                      const allBalanced = hasData && ttmBsMonthLabels.every((_, mIdx) => {
                        const a = ttmBsCurrentAssets.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsFixedAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsOtherAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        const le = ttmBsCurrentLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsLongTermLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsEquity.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        return a === 0 && le === 0 ? true : Math.abs(a - le) < 1;
                      });
                      // ROUNDING, NOT IMBALANCE (Konnie 09-25, Hawver Display: a
                      // Claude-rearranged workbook DISPLAYED whole dollars over cells
                      // that carried cents; every row she copied was rounded while
                      // the totals were computed on the cents → $2–$13 off per
                      // month, red across the board). When every stored value is a
                      // whole dollar and the gap is within half a dollar per row,
                      // say "rounding" in amber and how to zero it. A real
                      // imbalance is bigger than that and stays red.
                      const ttmAllRows = [...ttmBsCurrentAssets, ...(ttmBsFixedAssets || []), ...(ttmBsOtherAssets || []), ...ttmBsCurrentLiabilities, ...ttmBsLongTermLiabilities, ...ttmBsEquity];
                      const wholeDollarPaste = ttmAllRows.length > 0 && ttmAllRows.every(ac => (ac.values || []).every(v => !v || Number.isInteger(Number(v))));
                      const roundingTol = 0.5 * ttmAllRows.length;
                      const isRoundingMonth = (mIdx) => {
                        const a = ttmBsCurrentAssets.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsFixedAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsOtherAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        const le = ttmBsCurrentLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsLongTermLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsEquity.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        return wholeDollarPaste && Math.abs(a - le) >= 1 && Math.abs(a - le) <= roundingTol;
                      };
                      const allRounding = hasData && !allBalanced && ttmBsMonthLabels.every((_, mIdx) => {
                        const a = ttmBsCurrentAssets.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsFixedAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsOtherAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        const le = ttmBsCurrentLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsLongTermLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsEquity.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                        return (a === 0 && le === 0) || Math.abs(a - le) < 1 || isRoundingMonth(mIdx);
                      });
                      const roundingTitle = `Rounding, not an imbalance: every value in this paste is a whole dollar, and each month's gap is within half a dollar per row (${ttmAllRows.length} rows). The source had cents — re-copy with two decimals showing (or ask Claude for two decimals) and it zeroes out.`;
                      return (
                        <tr className={`font-bold ${allBalanced ? 'bg-blue-50' : allRounding ? 'bg-amber-50' : hasData ? 'bg-red-50' : ''}`} title={allRounding ? roundingTitle : undefined}>
                          <td className="p-2 border-t border-green-300" style={{minWidth: '150px'}}>BALANCE CHECK (A − L − E){allRounding ? <span className="block text-[10px] font-normal text-amber-700">rounding only — whole-dollar paste; re-copy with cents to zero it</span> : null}</td>
                          {ttmBsMonthLabels.map((_, mIdx) => {
                            const totalAssets = ttmBsCurrentAssets.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsFixedAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + (ttmBsOtherAssets || []).reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                            const totalLE = ttmBsCurrentLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsLongTermLiabilities.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0) + ttmBsEquity.reduce((s, ac) => s + (ac.values[mIdx] || 0), 0);
                            const diff = totalAssets - totalLE;
                            const isBalanced = (totalAssets === 0 && totalLE === 0) || Math.abs(diff) < 1;
                            const rounding = !isBalanced && isRoundingMonth(mIdx);
                            return <td key={mIdx} title={rounding ? roundingTitle : undefined} className={`p-2 text-right border-t border-green-300 ${isBalanced ? 'text-blue-600' : rounding ? 'text-amber-700' : 'text-red-600'}`}>{totalAssets === 0 && totalLE === 0 ? '—' : isBalanced ? '✓' : (rounding ? '≈ ' : '') + formatCurrency(diff)}</td>;
                          })}
                          <td className="p-2 border-t border-green-300" style={{minWidth: '80px'}}></td>
                          <td className="border-t border-green-300" style={{width: '30px'}}></td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Link to WC Analysis */}
            <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="font-semibold text-purple-800">💰 Working Capital Analysis</h4>
                  <p className="text-xs text-purple-600 mt-1">View monthly Operating NWC calculations, peg methodology options, and trend analysis</p>
                  <p className="mt-2 text-sm text-purple-700">Current WC Peg: <strong className="text-purple-900">{formatCurrency(wcCalculations?.wcPeg || 0)}</strong></p>
                </div>
                <button onClick={() => setViewMode('wcanalysis')} className="px-4 py-2 bg-purple-600 text-white text-sm rounded hover:bg-purple-700">Go to WC & CapEx →</button>
              </div>
            </div>

            {/* BS Reconciliation Detail Modal — duplicated here so the chip on the TTM BS tab can open it without switching viewMode */}
            {showBsReconModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowBsReconModal(false)}>
                <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">⚠ Interim BS Sync Reconciliation</h3>
                    <button onClick={() => setShowBsReconModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>
                  <div className="mb-3 text-xs text-gray-600">
                    Comparing the Annual Balance Sheet's Interim column against the most recent TTM Monthly BS snapshot
                    {bsTtmReconciliation.lastMonthLabel ? ` (${bsTtmReconciliation.lastMonthLabel})` : ''}.
                    <strong> Mismatch</strong> = matched account but values differ (sync stale or edited after sync).
                    <strong> Stale (no TTM source)</strong> = Annual interim has a value but no matching TTM account — typically a year-over-year carryover.
                    <strong> Unsynced TTM</strong> = TTM account has a value but no matching Annual row.
                    Clicking <strong>↑ Sync Interim from TTM BS</strong> on the Annual BS tab will resolve all three (with a confirmation listing what will be zeroed).
                  </div>
                  <div className="mb-4 p-2 bg-gray-50 rounded border text-sm">
                    <span className="text-gray-500 text-xs">Total issues:</span> <span className="font-bold ml-1">{bsTtmReconciliation.totalIssues}</span>
                  </div>
                  <div className="overflow-auto max-h-[55vh] border rounded">
                    <table className="w-full text-xs">
                      <thead className="bg-gray-100 sticky top-0">
                        <tr>
                          <th className="p-1.5 text-left">Section</th>
                          <th className="p-1.5 text-left">Account</th>
                          <th className="p-1.5 text-left">Issue</th>
                          <th className="p-1.5 text-right">Annual Interim</th>
                          <th className="p-1.5 text-right">TTM {bsTtmReconciliation.lastMonthLabel || 'Last Month'}</th>
                          <th className="p-1.5 text-right">Diff</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bsTtmReconciliation.issues.slice().sort((a,b) => Math.abs(b.diff) - Math.abs(a.diff)).map((iss, i) => {
                          const issueLabel = iss.type === 'mismatch' ? 'Mismatch' : iss.type === 'no_TTM_match' ? 'Stale (no TTM source)' : iss.type === 'duplicate' ? 'Duplicate (Sync merges it)' : 'Unsynced TTM';
                          const issueClass = iss.type === 'mismatch' ? 'bg-amber-100 text-amber-800' : iss.type === 'no_TTM_match' ? 'bg-orange-100 text-orange-800' : iss.type === 'duplicate' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800';
                          return (
                            <tr key={i} className="border-t">
                              <td className="p-1.5 text-gray-600">{iss.section}</td>
                              <td className="p-1.5 font-medium">{iss.name}{iss.type === 'mismatch' && iss.ttmName && iss.ttmName !== iss.name ? <span className="text-gray-400 text-[10px] ml-1">(TTM: {iss.ttmName})</span> : null}</td>
                              <td className="p-1.5"><span className={`px-1 rounded text-[10px] ${issueClass}`}>{issueLabel}</span></td>
                              <td className="p-1.5 text-right">${Math.round(iss.interim).toLocaleString()}</td>
                              <td className="p-1.5 text-right">${Math.round(iss.ttmVal).toLocaleString()}</td>
                              <td className="p-1.5 text-right text-red-700">${Math.round(iss.diff).toLocaleString()}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-end gap-2 pt-3 mt-2 border-t">
                    <button onClick={() => setShowBsReconModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm">Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'bsanalysis' ? (
          /* ========== BALANCE SHEET ANALYSIS ========== */
          <div>
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-4">
                <h2 className="text-lg font-bold">📊 Balance Sheet Analysis</h2>
                <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-300">
                  <span className="text-xs text-gray-600">YoY Variance:</span>
                  <label className="flex items-center gap-1 text-xs" title="Highlight variances above this percentage">
                    <span>≥</span>
                    <input 
                      type="number" 
                      value={monthlyTtmConfig.bsVarianceThreshold || 25} 
                      onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, bsVarianceThreshold: parseInt(e.target.value) || 25})}
                      className="w-12 px-1 py-0.5 border rounded text-xs text-center"
                      min="1"
                      max="100"
                    />
                    <span>%</span>
                  </label>
                  <label className="flex items-center gap-1 text-xs" title="Ignore items below this dollar amount">
                    <span>Min $</span>
                    <input 
                      type="number" 
                      value={monthlyTtmConfig.bsMaterialityThreshold || 5000} 
                      onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, bsMaterialityThreshold: parseInt(e.target.value) || 5000})}
                      className="w-16 px-1 py-0.5 border rounded text-xs text-center"
                      min="0"
                      step="1000"
                    />
                  </label>
                </div>
              </div>
              <button onClick={() => setViewMode('balancesheet')} className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300">
                ← Back to Entry
              </button>
            </div>
            
            {/* Key Ratios Section */}
            <div className="grid grid-cols-6 gap-3 mb-4">
              <div className="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500">
                <div className="text-xs text-blue-600 font-semibold">Net Working Capital</div>
                <div className="text-xl font-bold text-blue-900">{formatCurrency(balanceSheetCalcs.interim.netWorkingCapital)}</div>
              </div>
              <div className="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500">
                <div className="text-xs text-blue-600 font-semibold">NWC (Excl. Cash)</div>
                <div className="text-xl font-bold text-blue-900">{formatCurrency(balanceSheetCalcs.interim.netWorkingCapitalExCash)}</div>
              </div>
              <div className="bg-slate-50 p-3 rounded-lg border-l-4 border-slate-400">
                <div className="text-xs text-slate-600 font-semibold">Current Ratio</div>
                <div className="text-xl font-bold text-slate-900">{balanceSheetCalcs.interim.currentRatio.toFixed(2)}</div>
                <div className="text-xs text-slate-500">{balanceSheetCalcs.interim.currentRatio >= 1.5 ? '✓ Healthy' : balanceSheetCalcs.interim.currentRatio >= 1.0 ? '⚠ Adequate' : '⚠ Low'}</div>
              </div>
              <div className="bg-slate-100 p-3 rounded-lg border-l-4 border-slate-500">
                <div className="text-xs text-slate-600 font-semibold">Final Multiple</div>
                <div className="text-xl font-bold text-slate-800">{balanceSheetCalcs.interim.quickRatio.toFixed(2)}</div>
                <div className="text-xs text-slate-500">{balanceSheetCalcs.interim.quickRatio >= 1.0 ? '✓ Healthy' : '⚠ Below 1.0'}</div>
              </div>
              <div className={`p-3 rounded-lg border-l-4 ${balanceSheetCalcs.interim.deferredRevenue > 0 ? 'bg-blue-100 border-blue-400' : 'bg-gray-50 border-gray-300'}`}>
                <div className={`text-xs font-semibold ${balanceSheetCalcs.interim.deferredRevenue > 0 ? 'text-blue-600' : 'text-gray-500'}`}>Deferred Revenue</div>
                <div className={`text-xl font-bold ${balanceSheetCalcs.interim.deferredRevenue > 0 ? 'text-blue-700' : 'text-gray-400'}`}>{formatCurrency(balanceSheetCalcs.interim.deferredRevenue)}</div>
              </div>
              <div className={`p-3 rounded-lg border-l-4 ${balanceSheetCalcs.interim.totalEquity >= 0 ? 'bg-green-50 border-green-400' : 'bg-red-50 border-red-400'}`}>
                <div className={`text-xs font-semibold ${balanceSheetCalcs.interim.totalEquity >= 0 ? 'text-green-600' : 'text-red-600'}`}>Total Equity</div>
                <div className={`text-xl font-bold ${balanceSheetCalcs.interim.totalEquity >= 0 ? 'text-green-700' : 'text-red-700'}`}>{formatCurrency(balanceSheetCalcs.interim.totalEquity)}</div>
              </div>
            </div>
            
            {/* Period Comparison Table */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div className="bg-slate-200 px-3 py-2 font-bold">📅 Period Comparison</div>
              <div className="text-xs text-gray-500 p-3 pb-0 bg-blue-50 border-b border-blue-200">
                <div className="font-medium text-gray-700 mb-1">📋 Line Item Review</div>
                Flag individual accounts for follow-up - flagged items appear in Open Items.
                <div className="mt-1 text-amber-700 font-medium">
                  ⚠️ Aggregate quality issues (negative equity, out of balance, stale data) automatically create Open Items and must be cleared in the <span className="underline">Issues & Flags section below</span>.
                </div>
              </div>
              {(() => {
                const periods = [
                  { key: 'year1', label: bsYearLabels.year1 || 'Year 1' },
                  { key: 'year2', label: bsYearLabels.year2 || 'Year 2' },
                  { key: 'year3', label: bsYearLabels.year3 || 'Year 3' },
                  { key: 'interim', label: bsYearLabels.interim || 'Interim' }
                ];
                
                const varianceThreshold = monthlyTtmConfig.bsVarianceThreshold || 25;
                const materialityThreshold = monthlyTtmConfig.bsMaterialityThreshold || 5000;
                
                const calcVariance = (current, prior) => {
                  if (prior === 0) return current === 0 ? 0 : 100;
                  return ((current - prior) / Math.abs(prior)) * 100;
                };
                
                const renderRow = (label, values, isTotal = false, indent = false, itemId = null, section = '', totalId = null) => {
                  const bgClass = isTotal ? 'bg-slate-100 font-semibold' : '';
                  
                  // Check if any variance exceeds threshold
                  let hasVariance = false;
                  periods.forEach((period, idx) => {
                    if (idx > 0) {
                      const val = values[period.key] || 0;
                      const priorVal = values[periods[idx - 1].key] || 0;
                      const variance = calcVariance(val, priorVal);
                      const varianceAbs = val - priorVal;
                      if (Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold) {
                        hasVariance = true;
                      }
                    }
                  });
                  
                  // Check if account is STALE (same non-zero value across all years)
                  const isStale = !isTotal && itemId && 
                    values.year1 !== 0 && 
                    values.year1 === values.year2 && 
                    values.year2 === values.year3;
                  const staleKey = isStale ? `stale-${section}-${itemId}` : null;
                  const isStaleReviewed = staleKey && bsIssueNotes[staleKey]?.reviewed;
                  
                  // Check if account has NEGATIVE values that shouldn't be negative
                  // Liabilities showing negative = unusual (credit balance on credit account)
                  // Assets showing negative = could be contra account but still flag
                  const isLiabilitySection = section === 'currentLiabilities' || section === 'longTermLiabilities';
                  const isAssetSection = section === 'currentAssets' || section === 'fixedAssets' || section === 'otherAssets';
                  const hasNegativeValue = !isTotal && itemId && (
                    (isLiabilitySection && (values.year1 < 0 || values.year2 < 0 || values.year3 < 0)) ||
                    (isAssetSection && values.year3 < 0) // Only flag current year negative assets
                  );
                  const negativeKey = hasNegativeValue ? `negative-${section}-${itemId}` : null;
                  const isNegativeReviewed = negativeKey && bsIssueNotes[negativeKey]?.reviewed;
                  
                  // For totals, use totalId; for line items, use itemId
                  const noteKey = isTotal && totalId ? `bs_total_${totalId}` : (itemId ? `bs_${section}_${itemId}` : null);
                  const isManuallyFlagged = noteKey && manualReviewFlags[noteKey]?.flagged;
                  
                  // Status tracking for variances only (not stale or negative - those resolve in Open Items)
                  const statusKey = noteKey;
                  const statusData = statusKey ? (bsVarianceStatus[statusKey] || { status: 'unreviewed', notes: '' }) : null;
                  // Only variance issues need the dropdown - stale and negative resolve in Open Items panel
                  const needsVarianceReview = hasVariance;
                  const hasAnyIssue = hasVariance || (isStale && !isStaleReviewed) || (hasNegativeValue && !isNegativeReviewed);
                  
                  // Handle note changes - also mark stale as reviewed if note is added
                  const handleNoteChange = (val) => {
                    setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}));
                    // If this is a stale account and a note is being added, mark it as reviewed
                    if (isStale && val && val.trim().length > 0) {
                      setBsIssueNotes(prev => ({
                        ...prev, 
                        [staleKey]: { 
                          ...prev[staleKey], 
                          reviewed: true, 
                          notes: val,
                          reviewedAt: new Date().toISOString(),
                          itemName: label,
                          issueType: 'Stale Account',
                          issueDetail: `No change for 3 years (all periods show $${values.year1?.toLocaleString() || 0})`
                        }
                      }));
                    }
                  };
                  
                  return (
                    <tr key={label} className={`${bgClass} ${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''} ${isStale && !isStaleReviewed ? 'border-l-4 border-l-orange-500 bg-orange-50' : ''} ${hasNegativeValue && !isNegativeReviewed ? 'border-l-4 border-l-red-500 bg-red-50' : ''}`}>
                      <td className={`p-1.5 border text-sm ${indent ? 'pl-6' : ''}`}>
                        {label}
                        {isStale && !isStaleReviewed && (
                          <span className="ml-2 px-1.5 py-0.5 text-xs bg-orange-200 text-orange-800 rounded" title="Same value for 3+ years - verify this is correct">⚠️ Stale</span>
                        )}
                        {isStale && isStaleReviewed && (
                          <span className="ml-2 px-1.5 py-0.5 text-xs bg-green-100 text-green-700 rounded" title="Stale account reviewed">✓</span>
                        )}
                        {hasNegativeValue && !isNegativeReviewed && (
                          <span className="ml-2 px-1.5 py-0.5 text-xs bg-red-200 text-red-800 rounded" title="Negative value detected - verify this is correct">🔻 Negative</span>
                        )}
                        {hasNegativeValue && isNegativeReviewed && (
                          <span className="ml-2 px-1.5 py-0.5 text-xs bg-green-100 text-green-700 rounded" title="Negative account reviewed">✓</span>
                        )}
                      </td>
                      {periods.map((period, idx) => {
                        const val = values[period.key] || 0;
                        const priorVal = idx > 0 ? (values[periods[idx - 1].key] || 0) : null;
                        const variance = priorVal !== null ? calcVariance(val, priorVal) : null;
                        const varianceAbs = priorVal !== null ? val - priorVal : null;
                        const showFlag = variance !== null && Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold;
                        return (
                          <React.Fragment key={period.key}>
                            <td className={`p-1.5 border text-right text-sm ${showFlag ? 'bg-amber-100' : ''}`}>{formatCurrency(val)}</td>
                            {idx > 0 && (
                              <td className={`p-1 border text-right text-xs ${showFlag ? 'bg-amber-100 font-semibold' : 'text-slate-500'}`}>
                                {variance !== null ? (variance > 0 ? '+' : '') + variance.toFixed(0) + '%' : '-'}
                              </td>
                            )}
                          </React.Fragment>
                        );
                      })}
                      <td className="p-1 border text-center">
                        {statusKey && needsVarianceReview ? (
                          <select 
                            value={statusData.status} 
                            onChange={e => setBsVarianceStatus(prev => ({...prev, [statusKey]: {...statusData, status: e.target.value}}))}
                            className={`text-xs p-1 rounded w-full ${statusData.status === 'explained' ? 'bg-blue-100' : statusData.status === 'waived' ? 'bg-gray-200' : statusData.status === 'adjustment' ? 'bg-amber-100' : statusData.status === 'reviewing' ? 'bg-slate-100' : 'bg-slate-50'}`}
                          >
                            <option value="unreviewed">⚪ Unreviewed</option>
                            <option value="reviewing">🔍 Reviewing</option>
                            <option value="explained">✅ Explained</option>
                            <option value="adjustment">⚠️ Needs Adj</option>
                            <option value="waived">🚫 Waived</option>
                          </select>
                        ) : hasAnyIssue ? '-' : '✓'}
                      </td>
                      {noteKey ? (
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={handleNoteChange}
                            hasVariance={hasAnyIssue}
                            placeholder={isStale && !isStaleReviewed ? 'Explain stale account...' : hasNegativeValue && !isNegativeReviewed ? 'Explain negative value...' : hasVariance ? 'Explain variance...' : ''}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Balance Sheet',
                                item: label
                              }
                            }))}
                            noteKey={noteKey}
                          resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      ) : (
                        <td className="p-1 border"></td>
                      )}
                    </tr>
                  );
                };
                
                const renderSection = (title, items, calcKey, bgColor, sectionKey) => {
                  const totals = {};
                  periods.forEach(p => {
                    totals[p.key] = items.reduce((sum, item) => sum + (item[p.key] || 0), 0);
                  });
                  
                  return (
                    <>
                      <tr className={`${bgColor} font-semibold`}>
                        <td colSpan={10} className="p-1.5 border text-sm">{title}</td>
                      </tr>
                      {items.filter(item => item.name).map(item => {
                        const values = {};
                        periods.forEach(p => { values[p.key] = item[p.key] || 0; });
                        return renderRow(item.name, values, false, true, item.id, sectionKey);
                      })}
                      {renderRow(`Total ${title}`, totals, true, false, null, '', sectionKey)}
                    </>
                  );
                };
                
                return (
                  <table className="w-full text-xs border-collapse">
                    <thead>
                      <tr className="bg-slate-100">
                        <th className="p-2 border text-left" style={{minWidth: '200px'}}>Account</th>
                        <th className="p-2 border text-center">{periods[0].label}</th>
                        <th className="p-2 border text-center">{periods[1].label}</th>
                        <th className="p-2 border text-center text-slate-600 bg-slate-50">Δ%</th>
                        <th className="p-2 border text-center">{periods[2].label}</th>
                        <th className="p-2 border text-center text-slate-600 bg-slate-50">Δ%</th>
                        <th className="p-2 border text-center bg-blue-100">{periods[3].label}</th>
                        <th className="p-2 border text-center text-slate-600 bg-blue-50">Δ%</th>
                        <th className="p-2 border text-center bg-gray-100" style={{width: '100px'}}>Status</th>
                        <th className="p-2 border text-center bg-gray-100" style={{minWidth: '150px'}}>Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* ASSETS */}
                      <tr className="bg-blue-100 font-bold">
                        <td colSpan={10} className="p-2 border">ASSETS</td>
                      </tr>
                      {renderSection('Current Assets', bsCurrentAssets, 'totalCurrentAssets', 'bg-blue-50', 'ca')}
                      {renderSection('Fixed Assets', bsFixedAssets, 'totalFixedAssets', 'bg-blue-50', 'fa')}
                      {renderSection('Other Assets', bsOtherAssets, 'totalOtherAssets', 'bg-blue-50', 'oa')}
                      {(() => {
                        const totalAssetsKey = 'bs_total_assets';
                        const statusData = bsVarianceStatus[totalAssetsKey] || { status: 'unreviewed' };
                        let hasVariance = false;
                        periods.forEach((period, idx) => {
                          if (idx > 0) {
                            const val = balanceSheetCalcs[period.key]?.totalAssets || 0;
                            const priorVal = balanceSheetCalcs[periods[idx - 1].key]?.totalAssets || 0;
                            const variance = calcVariance(val, priorVal);
                            const varianceAbs = val - priorVal;
                            if (Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold) {
                              hasVariance = true;
                            }
                          }
                        });
                        return (
                          <tr className="bg-blue-200 font-bold">
                            <td className="p-1.5 border">TOTAL ASSETS</td>
                            {periods.map((period, idx) => {
                              const val = balanceSheetCalcs[period.key]?.totalAssets || 0;
                              const priorVal = idx > 0 ? (balanceSheetCalcs[periods[idx - 1].key]?.totalAssets || 0) : null;
                              const variance = priorVal !== null ? calcVariance(val, priorVal) : null;
                              const varianceAbs = priorVal !== null ? val - priorVal : null;
                              const showFlag = variance !== null && Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold;
                              return (
                                <React.Fragment key={period.key}>
                                  <td className={`p-1.5 border text-right ${showFlag ? 'bg-amber-100' : ''}`}>{formatCurrency(val)}</td>
                                  {idx > 0 && (
                                    <td className={`p-1 border text-right text-xs ${showFlag ? 'bg-amber-100 font-semibold' : 'text-blue-700'}`}>
                                      {variance !== null ? (variance > 0 ? '+' : '') + variance.toFixed(0) + '%' : '-'}
                                    </td>
                                  )}
                                </React.Fragment>
                              );
                            })}
                            <td className="p-1 border text-center">
                              {hasVariance ? (
                                <select 
                                  value={statusData.status} 
                                  onChange={e => setBsVarianceStatus(prev => ({...prev, [totalAssetsKey]: {...statusData, status: e.target.value}}))}
                                  className={`text-xs p-1 rounded w-full ${statusData.status === 'explained' ? 'bg-blue-100' : statusData.status === 'waived' ? 'bg-gray-200' : statusData.status === 'adjustment' ? 'bg-amber-100' : statusData.status === 'reviewing' ? 'bg-slate-100' : 'bg-slate-50'}`}
                                >
                                  <option value="unreviewed">⚪ Unreviewed</option>
                                  <option value="reviewing">🔍 Reviewing</option>
                                  <option value="explained">✅ Explained</option>
                                  <option value="adjustment">⚠️ Needs Adj</option>
                                  <option value="waived">🚫 Waived</option>
                                </select>
                              ) : '✓'}
                            </td>
                            <td className="p-0 border">
                              {hasVariance && (
                                <input
                                  type="text"
                                  value={monthlyTtmNotes[totalAssetsKey] || ''}
                                  onChange={e => setMonthlyTtmNotes(prev => ({...prev, [totalAssetsKey]: e.target.value}))}
                                  className="w-full p-1 text-xs border-0"
                                  placeholder="Add note..."
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })()}
                      
                      {/* LIABILITIES */}
                      <tr className="bg-slate-200 font-bold">
                        <td colSpan={10} className="p-2 border">LIABILITIES</td>
                      </tr>
                      {renderSection('Current Liabilities', bsCurrentLiabilities, 'totalCurrentLiabilities', 'bg-slate-50', 'cl')}
                      {renderSection('Long-Term Liabilities', bsLongTermLiabilities, 'totalLongTermLiabilities', 'bg-slate-50', 'ltl')}
                      {(() => {
                        const totalLiabilitiesKey = 'bs_total_liabilities';
                        const statusData = bsVarianceStatus[totalLiabilitiesKey] || { status: 'unreviewed' };
                        let hasVariance = false;
                        periods.forEach((period, idx) => {
                          if (idx > 0) {
                            const val = balanceSheetCalcs[period.key]?.totalLiabilities || 0;
                            const priorVal = balanceSheetCalcs[periods[idx - 1].key]?.totalLiabilities || 0;
                            const variance = calcVariance(val, priorVal);
                            const varianceAbs = val - priorVal;
                            if (Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold) {
                              hasVariance = true;
                            }
                          }
                        });
                        return (
                          <tr className="bg-slate-300 font-bold">
                            <td className="p-1.5 border">TOTAL LIABILITIES</td>
                            {periods.map((period, idx) => {
                              const val = balanceSheetCalcs[period.key]?.totalLiabilities || 0;
                              const priorVal = idx > 0 ? (balanceSheetCalcs[periods[idx - 1].key]?.totalLiabilities || 0) : null;
                              const variance = priorVal !== null ? calcVariance(val, priorVal) : null;
                              const varianceAbs = priorVal !== null ? val - priorVal : null;
                              const showFlag = variance !== null && Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold;
                              return (
                                <React.Fragment key={period.key}>
                                  <td className={`p-1.5 border text-right ${showFlag ? 'bg-amber-100' : ''}`}>{formatCurrency(val)}</td>
                                  {idx > 0 && (
                                    <td className={`p-1 border text-right text-xs ${showFlag ? 'bg-amber-100 font-semibold' : 'text-slate-700'}`}>
                                      {variance !== null ? (variance > 0 ? '+' : '') + variance.toFixed(0) + '%' : '-'}
                                    </td>
                                  )}
                                </React.Fragment>
                              );
                            })}
                            <td className="p-1 border text-center">
                              {hasVariance ? (
                                <select 
                                  value={statusData.status} 
                                  onChange={e => setBsVarianceStatus(prev => ({...prev, [totalLiabilitiesKey]: {...statusData, status: e.target.value}}))}
                                  className={`text-xs p-1 rounded w-full ${statusData.status === 'explained' ? 'bg-blue-100' : statusData.status === 'waived' ? 'bg-gray-200' : statusData.status === 'adjustment' ? 'bg-amber-100' : statusData.status === 'reviewing' ? 'bg-slate-100' : 'bg-slate-50'}`}
                                >
                                  <option value="unreviewed">⚪ Unreviewed</option>
                                  <option value="reviewing">🔍 Reviewing</option>
                                  <option value="explained">✅ Explained</option>
                                  <option value="adjustment">⚠️ Needs Adj</option>
                                  <option value="waived">🚫 Waived</option>
                                </select>
                              ) : '✓'}
                            </td>
                            <td className="p-0 border">
                              {hasVariance && (
                                <input
                                  type="text"
                                  value={monthlyTtmNotes[totalLiabilitiesKey] || ''}
                                  onChange={e => setMonthlyTtmNotes(prev => ({...prev, [totalLiabilitiesKey]: e.target.value}))}
                                  className="w-full p-1 text-xs border-0"
                                  placeholder="Add note..."
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })()}
                      
                      {/* EQUITY */}
                      <tr className="bg-green-100 font-bold">
                        <td colSpan={10} className="p-2 border">EQUITY</td>
                      </tr>
                      {renderSection('Equity', bsEquity, 'totalEquity', 'bg-green-50', 'eq')}
                      {(() => {
                        const totalEquityKey = 'bs_total_equity';
                        const statusData = bsVarianceStatus[totalEquityKey] || { status: 'unreviewed' };
                        let hasVariance = false;
                        periods.forEach((period, idx) => {
                          if (idx > 0) {
                            const val = balanceSheetCalcs[period.key]?.totalEquity || 0;
                            const priorVal = balanceSheetCalcs[periods[idx - 1].key]?.totalEquity || 0;
                            const variance = calcVariance(val, priorVal);
                            const varianceAbs = val - priorVal;
                            if (Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold) {
                              hasVariance = true;
                            }
                          }
                        });
                        return (
                          <tr className="bg-green-200 font-bold">
                            <td className="p-1.5 border">TOTAL EQUITY</td>
                            {periods.map((period, idx) => {
                              const val = balanceSheetCalcs[period.key]?.totalEquity || 0;
                              const priorVal = idx > 0 ? (balanceSheetCalcs[periods[idx - 1].key]?.totalEquity || 0) : null;
                              const variance = priorVal !== null ? calcVariance(val, priorVal) : null;
                              const varianceAbs = priorVal !== null ? val - priorVal : null;
                              const showFlag = variance !== null && Math.abs(variance) >= varianceThreshold && Math.abs(varianceAbs) >= materialityThreshold;
                              const isNegative = val < 0;
                              return (
                                <React.Fragment key={period.key}>
                                  <td className={`p-1.5 border text-right ${isNegative ? 'text-red-700 bg-red-50' : ''} ${showFlag && !isNegative ? 'bg-amber-100' : ''}`}>{formatCurrency(val)}</td>
                                  {idx > 0 && (
                                    <td className={`p-1 border text-right text-xs ${showFlag ? 'bg-amber-100 font-semibold' : 'text-green-700'}`}>
                                      {variance !== null ? (variance > 0 ? '+' : '') + variance.toFixed(0) + '%' : '-'}
                                    </td>
                                  )}
                                </React.Fragment>
                              );
                            })}
                            <td className="p-1 border text-center">
                              {hasVariance ? (
                                <select 
                                  value={statusData.status} 
                                  onChange={e => setBsVarianceStatus(prev => ({...prev, [totalEquityKey]: {...statusData, status: e.target.value}}))}
                                  className={`text-xs p-1 rounded w-full ${statusData.status === 'explained' ? 'bg-blue-100' : statusData.status === 'waived' ? 'bg-gray-200' : statusData.status === 'adjustment' ? 'bg-amber-100' : statusData.status === 'reviewing' ? 'bg-slate-100' : 'bg-slate-50'}`}
                                >
                                  <option value="unreviewed">⚪ Unreviewed</option>
                                  <option value="reviewing">🔍 Reviewing</option>
                                  <option value="explained">✅ Explained</option>
                                  <option value="adjustment">⚠️ Needs Adj</option>
                                  <option value="waived">🚫 Waived</option>
                                </select>
                              ) : '✓'}
                            </td>
                            <td className="p-0 border">
                              {hasVariance && (
                                <input
                                  type="text"
                                  value={monthlyTtmNotes[totalEquityKey] || ''}
                                  onChange={e => setMonthlyTtmNotes(prev => ({...prev, [totalEquityKey]: e.target.value}))}
                                  className="w-full p-1 text-xs border-0"
                                  placeholder="Add note..."
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })()}
                      
                      {/* BALANCE CHECK */}
                      <tr className="bg-gray-100 font-bold">
                        <td className="p-1.5 border">LIABILITIES + EQUITY</td>
                        {periods.map((period, idx) => {
                          const val = (balanceSheetCalcs[period.key]?.totalLiabilities || 0) + (balanceSheetCalcs[period.key]?.totalEquity || 0);
                          const assets = balanceSheetCalcs[period.key]?.totalAssets || 0;
                          const isBalanced = Math.abs(val - assets) < 1;
                          return (
                            <React.Fragment key={period.key}>
                              <td className={`p-1.5 border text-right ${isBalanced ? '' : 'text-red-700 bg-red-50'}`}>
                                {formatCurrency(val)}
                                {!isBalanced && <span className="text-xs ml-1">⚠️</span>}
                              </td>
                              {idx > 0 && <td className="p-1 border"></td>}
                            </React.Fragment>
                          );
                        })}
                        <td className="p-1 border text-center">✓</td>
                        <td className="p-1 border"></td>
                      </tr>
                    </tbody>
                  </table>
                );
              })()}
            </div>
            
            {/* Balance Sheet Issues Review Section - Standard Flag Pattern */}
            {(() => {
              // Gather all potential balance sheet issues
              const bsIssues = [];
              
              // Negative equity issues
              [
                { year: bsYearLabels.year1, period: 'year1', equity: balanceSheetCalcs.year1.totalEquity },
                { year: bsYearLabels.year2, period: 'year2', equity: balanceSheetCalcs.year2.totalEquity },
                { year: bsYearLabels.year3, period: 'year3', equity: balanceSheetCalcs.year3.totalEquity },
                { year: bsYearLabels.interim, period: 'interim', equity: balanceSheetCalcs.interim.totalEquity }
              ].forEach(({ year, period, equity }) => {
                if (equity < 0) {
                  bsIssues.push({
                    key: `negequity-${period}`,
                    type: 'Negative Equity',
                    item: `${year}`,
                    detail: `Total Equity: ${formatCurrency(equity)}`,
                    severity: 'critical'
                  });
                }
              });
              
              // Balance check issues
              [
                { year: bsYearLabels.year1, period: 'year1' },
                { year: bsYearLabels.year2, period: 'year2' },
                { year: bsYearLabels.year3, period: 'year3' },
                { year: bsYearLabels.interim, period: 'interim' }
              ].forEach(({ year, period }) => {
                const assets = balanceSheetCalcs[period]?.totalAssets || 0;
                const liabEquity = (balanceSheetCalcs[period]?.totalLiabilities || 0) + (balanceSheetCalcs[period]?.totalEquity || 0);
                if (assets !== 0 && Math.abs(assets - liabEquity) >= 1) {
                  bsIssues.push({
                    key: `outofbalance-${period}`,
                    type: 'Out of Balance',
                    item: `${year}`,
                    detail: `Assets: ${formatCurrency(assets)} ≠ L+E: ${formatCurrency(liabEquity)} (Diff: ${formatCurrency(assets - liabEquity)})`,
                    severity: 'critical'
                  });
                }
              });
              
              // Stale data issues
              const checkStaleIssues = (items, categoryName, categoryLabel) => {
                items.forEach(item => {
                  if (item.year1 === item.year2 && item.year2 === item.year3 && item.year1 !== 0) {
                    bsIssues.push({
                      key: `stale-${categoryName}-${item.id}`,
                      type: 'Stale Data',
                      item: item.name,
                      detail: `All years show ${formatCurrency(item.year1)} - verify accounting is current`,
                      severity: 'warning'
                    });
                  }
                });
              };
              checkStaleIssues(bsCurrentAssets, 'ca', 'Current Assets');
              checkStaleIssues(bsFixedAssets, 'fa', 'Fixed Assets');
              checkStaleIssues(bsOtherAssets, 'oa', 'Other Assets');
              checkStaleIssues(bsCurrentLiabilities, 'cl', 'Current Liabilities');
              checkStaleIssues(bsLongTermLiabilities, 'ltl', 'Long-Term Liabilities');
              checkStaleIssues(bsEquity, 'eq', 'Equity');
              
              // Negative asset issues
              const checkNegativeIssues = (items, yearKey, yearLabel, type) => {
                items.forEach(item => {
                  const val = item[yearKey] || 0;
                  const nameLower = (item.name || '').toLowerCase();
                  const isContraAccount = nameLower.includes('accumulated') || nameLower.includes('depreciation') || nameLower.includes('allowance');
                  if (val < 0 && !isContraAccount) {
                    bsIssues.push({
                      key: `neg${type}-${yearKey}-${item.id}`,
                      type: type === 'asset' ? 'Negative Asset' : 'Negative Liability',
                      item: `${item.name} (${yearLabel})`,
                      detail: `${formatCurrency(val)} - data error or misclassification`,
                      severity: 'critical'
                    });
                  }
                });
              };
              ['year1', 'year2', 'year3', 'interim'].forEach(yearKey => {
                const yearLabel = bsYearLabels[yearKey];
                checkNegativeIssues(bsCurrentAssets, yearKey, yearLabel, 'asset');
                checkNegativeIssues(bsFixedAssets, yearKey, yearLabel, 'asset');
                checkNegativeIssues(bsOtherAssets, yearKey, yearLabel, 'asset');
              });
              ['year1', 'year2', 'year3', 'interim'].forEach(yearKey => {
                const yearLabel = bsYearLabels[yearKey];
                bsCurrentLiabilities.forEach(item => {
                  const val = item[yearKey] || 0;
                  if (val < 0) {
                    bsIssues.push({
                      key: `negliab-${yearKey}-${item.id}`,
                      type: 'Negative Liability',
                      item: `${item.name} (${yearLabel})`,
                      detail: `${formatCurrency(val)} - liabilities should be positive`,
                      severity: 'critical'
                    });
                  }
                });
                bsLongTermLiabilities.forEach(item => {
                  const val = item[yearKey] || 0;
                  if (val < 0) {
                    bsIssues.push({
                      key: `negliab-${yearKey}-${item.id}`,
                      type: 'Negative Liability',
                      item: `${item.name} (${yearLabel})`,
                      detail: `${formatCurrency(val)} - liabilities should be positive`,
                      severity: 'critical'
                    });
                  }
                });
              });
              
              // Count unresolved
              const unresolvedCount = bsIssues.filter(i => !bsIssueNotes[i.key]?.reviewed).length;
              const resolvedCount = bsIssues.filter(i => bsIssueNotes[i.key]?.reviewed).length;
              
              return (
                <div className="border rounded-lg overflow-hidden">
                  <div 
                    className={`px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 ${unresolvedCount > 0 ? 'bg-amber-100' : 'bg-slate-100'}`}
                    onClick={() => setBsFlagsExpanded(!bsFlagsExpanded)}
                  >
                    <span>🚩 Issues & Flags ({unresolvedCount} unresolved{resolvedCount > 0 ? `, ${resolvedCount} resolved` : ''})</span>
                    <span>{bsFlagsExpanded ? '▼' : '▶'}</span>
                  </div>
                  {bsFlagsExpanded && (
                    <div className="p-3">
                      <div className="text-xs text-amber-700 mb-3 p-2 bg-amber-50 rounded border border-amber-200">
                        ⚠️ <span className="font-medium">These aggregate quality issues automatically create Open Items.</span> Check each item as reviewed to clear from Open Items. Individual line items can be flagged separately in the Period Comparison table above.
                      </div>
                      {bsIssues.length === 0 ? (
                        <div className="text-center text-gray-500 py-4">
                          <span className="text-green-600 font-medium">✓ No issues detected</span>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          {bsIssues.map(issue => {
                            const isResolved = bsIssueNotes[issue.key]?.reviewed;
                            return (
                              <div key={issue.key} className={`p-3 rounded border ${isResolved ? 'bg-slate-50 border-slate-200 opacity-60' : 'bg-white border-amber-300'}`}>
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex items-center gap-2">
                                    <input 
                                      type="checkbox" 
                                      checked={isResolved || false}
                                      onChange={e => setBsIssueNotes({...bsIssueNotes, [issue.key]: {
                                        ...(bsIssueNotes[issue.key] || {}), 
                                        reviewed: e.target.checked, 
                                        reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : '',
                                        reviewedAt: e.target.checked ? new Date().toISOString() : '',
                                        itemName: issue.item,
                                        issueType: issue.type,
                                        issueDetail: issue.detail
                                      }})}
                                      className="w-4 h-4"
                                    />
                                    <span className={`text-xs px-2 py-0.5 rounded font-medium ${
                                      issue.severity === 'critical' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'
                                    }`}>{issue.type}</span>
                                    <span className={`font-medium ${isResolved ? 'line-through text-gray-400' : ''}`}>{issue.item}</span>
                                    {isResolved && <span className="text-green-600 text-xs font-medium">✓ Reviewed {bsIssueNotes[issue.key]?.reviewDate}</span>}
                                  </div>
                                  <span className="text-xs text-gray-500">{issue.detail}</span>
                                </div>
                                <div className="flex gap-2">
                                  <textarea 
                                    value={bsIssueNotes[issue.key]?.notes || ''}
                                    onChange={e => setBsIssueNotes({...bsIssueNotes, [issue.key]: {...(bsIssueNotes[issue.key] || {}), notes: e.target.value}})}
                                    placeholder="Resolution notes (optional) - explain findings, corrective actions taken..."
                                    className="flex-1 px-2 py-1 border rounded text-xs min-h-[40px]"
                                    rows={1}
                                  />
                                  <div className="flex items-center gap-1">
                                    <span className="text-xs text-gray-500">EBITDA Impact:</span>
                                    <select
                                      value={bsIssueNotes[issue.key]?.ebitdaImpact || 'none'}
                                      onChange={e => setBsIssueNotes({...bsIssueNotes, [issue.key]: {...(bsIssueNotes[issue.key] || {}), ebitdaImpact: e.target.value}})}
                                      className={`px-2 py-1 border rounded text-xs ${
                                        bsIssueNotes[issue.key]?.ebitdaImpact === 'needed' ? 'bg-amber-50 border-amber-300 text-amber-700' :
                                        bsIssueNotes[issue.key]?.ebitdaImpact === 'added' ? 'bg-blue-50 border-blue-300 text-blue-700' :
                                        'bg-gray-50'
                                      }`}
                                    >
                                      <option value="none">No Impact</option>
                                      <option value="added">Adjustment Added</option>
                                      <option value="needed">Adjustment Needed</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
            
            {/* Recognition Items Review Section */}
            {(() => {
              const ttmRevenue = calculations.years?.[5]?.revenue || 0;
              const recognitionThreshold = Math.max(25000, ttmRevenue * 0.02);
              
              const allItems = [
                { key: 'deferredRevenue', label: 'Deferred Revenue', balance: balanceSheetCalcs.interim.deferredRevenue, description: 'Revenue received but not yet earned' },
                { key: 'unearnedRevenue', label: 'Unearned Revenue', balance: balanceSheetCalcs.interim.unearnedRevenue, description: 'Payments received before service delivered' },
                { key: 'customerDeposits', label: 'Customer Deposits', balance: balanceSheetCalcs.interim.customerDeposits, description: 'Advance payments from customers' },
                { key: 'prepaidExpenses', label: 'Prepaid Expenses', balance: balanceSheetCalcs.interim.prepaidExpenses, description: 'Expenses paid in advance' },
                { key: 'accruedExpenses', label: 'Accrued Expenses', balance: balanceSheetCalcs.interim.accruedExpenses, description: 'Expenses incurred but not yet paid' }
              ];
              
              const materialItems = allItems.filter(acct => acct.balance >= recognitionThreshold);
              const reviewedCount = materialItems.filter(acct => bsRecognitionNotes[acct.key]?.reviewed).length;
              const totalCount = materialItems.length;
              const allReviewed = totalCount > 0 && reviewedCount === totalCount;
              
              // Only show section if there are material items
              if (materialItems.length === 0) return null;
              
              return (
                <div className={`mt-4 border rounded-lg overflow-hidden`}>
                  <div className={`px-3 py-2 font-bold ${allReviewed ? 'bg-green-100' : 'bg-blue-100'}`}>
                    <span>📋 Recognition Items for Review ({reviewedCount} of {totalCount} reviewed{allReviewed ? ' ✓' : ''})</span>
                  </div>
                  <div className="p-3">
                    <div className="text-xs text-blue-700 mb-3 p-2 bg-blue-50 rounded border border-blue-200">
                      Items above materiality threshold (${recognitionThreshold.toLocaleString()}) identified for review. 
                      Check each item once verified with accountant. Clears from Open Items when all reviewed.
                    </div>
                    <div className="space-y-2">
                      {materialItems.map(acct => (
                        <div key={acct.key} className={`p-3 rounded border ${bsRecognitionNotes[acct.key]?.reviewed ? 'bg-green-50 border-green-200' : 'bg-white border-slate-300'}`}>
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-2">
                              <input 
                                type="checkbox" 
                                checked={bsRecognitionNotes[acct.key]?.reviewed || false}
                                onChange={e => setBsRecognitionNotes({...bsRecognitionNotes, [acct.key]: {...bsRecognitionNotes[acct.key], reviewed: e.target.checked, reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''}})}
                                className="w-4 h-4"
                              />
                              <span className={`font-medium ${bsRecognitionNotes[acct.key]?.reviewed ? 'line-through text-gray-400' : ''}`}>{acct.label}</span>
                              <span className="text-sm text-gray-600">({formatCurrency(acct.balance)})</span>
                              {bsRecognitionNotes[acct.key]?.reviewed && (
                                <span className="text-green-600 text-xs font-medium">✓ Reviewed {bsRecognitionNotes[acct.key]?.reviewDate}</span>
                              )}
                            </div>
                            <span className="text-xs text-gray-500">{acct.description}</span>
                          </div>
                          <div className="flex gap-2">
                            <input 
                              type="text" 
                              value={bsRecognitionNotes[acct.key]?.reviewedBy || ''}
                              onChange={e => setBsRecognitionNotes({...bsRecognitionNotes, [acct.key]: {...bsRecognitionNotes[acct.key], reviewedBy: e.target.value}})}
                              placeholder="Reviewed by..."
                              className="flex-1 px-2 py-1 border rounded text-xs"
                            />
                            <input 
                              type="text" 
                              value={bsRecognitionNotes[acct.key]?.notes || ''}
                              onChange={e => setBsRecognitionNotes({...bsRecognitionNotes, [acct.key]: {...bsRecognitionNotes[acct.key], notes: e.target.value}})}
                              placeholder="Notes on recognition treatment..."
                              className="flex-[2] px-2 py-1 border rounded text-xs"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })()}
            
            {/* Link to WC Analysis */}
            <div className="mt-6 p-4 bg-purple-50 rounded-lg border border-purple-200">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-purple-700">💰 Working Capital Analysis</h3>
                  <p className="text-xs text-purple-500">View WC peg methodology, trend analysis, and anomaly detection</p>
                </div>
                <button onClick={() => setViewMode('wcanalysis')} className="px-4 py-2 bg-purple-600 text-white text-sm rounded hover:bg-purple-700">Go to WC & CapEx →</button>
              </div>
            </div>
            
          </div>
        ) : viewMode === 'wcanalysis' ? (
          /* ========== WORKING CAPITAL ANALYSIS ========== */
          <div>
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="text-lg font-bold">💰 Working Capital & CapEx Analysis</h2>
                <p className="text-sm text-gray-500">Determine working capital peg and evaluate capital expenditure requirements</p>
              </div>
              <button onClick={() => setViewMode('ttmbalsheet')} className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300">← Edit TTM Data</button>
            </div>
            
            {!wcCalculations.hasData ? (
              <div className="p-8 bg-gray-50 rounded-lg text-center">
                <div className="text-gray-500 mb-4">No TTM monthly balance sheet data entered</div>
                <button onClick={() => setViewMode('ttmbalsheet')} className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">Enter TTM Balance Sheet Data →</button>
              </div>
            ) : (
              <>
                {/* WC Peg Methodology Controls */}
                <div className="mb-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-6">
                      <div>
                        <label className="text-xs font-semibold text-purple-700 block mb-1">Peg Methodology</label>
                        <select value={wcPegMethodology} onChange={e => setWcPegMethodology(e.target.value)} className="px-3 py-2 border rounded text-sm bg-white">
                          <option value="average">{wcCalculations.validMonths}-Month Average</option>
                          <option value="excludeHighLow">Average (Excl. High/Low)</option>
                          <option value="median">Median</option>
                          <option value="custom">Custom Month Selection</option>
                        </select>
                      </div>
                      <div>
                        <label className="text-xs font-semibold text-purple-700 block mb-1">Show</label>
                        <select value={wcShowOperating ? 'operating' : 'total'} onChange={e => setWcShowOperating(e.target.value === 'operating')} className="px-3 py-2 border rounded text-sm bg-white">
                          <option value="operating">Operating WC</option>
                          <option value="total">Total WC</option>
                        </select>
                      </div>
                      {wcPegMethodology === 'custom' && (
                        <div>
                          <label className="text-xs font-semibold text-purple-700 block mb-1">Select Months</label>
                          <div className="flex gap-1 flex-wrap">
                            {ttmBsMonthLabels.map((label, idx) => (
                              <label key={idx} className="flex items-center gap-1 text-xs bg-white px-2 py-1 rounded border cursor-pointer hover:bg-purple-50">
                                <input type="checkbox" checked={wcCustomMonths.includes(idx)} onChange={e => { if (e.target.checked) setWcCustomMonths([...wcCustomMonths, idx]); else setWcCustomMonths(wcCustomMonths.filter(m => m !== idx)); }} />
                                {label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="text-right bg-white p-4 rounded-lg border border-purple-300">
                      <div className="text-xs text-purple-600 font-semibold">Working Capital Peg</div>
                      <div className="text-3xl font-bold text-purple-800">{formatCurrency(wcCalculations.wcPeg)}</div>
                      <div className="text-xs text-purple-500">{wcCalculations.wcPegLabel}</div>
                    </div>
                  </div>
                </div>
                
                {/* Key Metrics */}
                <div className="grid grid-cols-5 gap-3 mb-4">
                  <div className="bg-purple-100 p-3 rounded-lg border border-purple-200"><div className="text-xs text-purple-600 font-semibold">WC Peg</div><div className="text-xl font-bold text-purple-800">{formatCurrency(wcCalculations.wcPeg)}</div></div>
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-200"><div className="text-xs text-blue-600 font-semibold">Operating Avg</div><div className="text-xl font-bold text-blue-800">{formatCurrency(wcCalculations.operatingAvgNWC)}</div></div>
                  <div className="bg-green-50 p-3 rounded-lg border border-green-200"><div className="text-xs text-green-600 font-semibold">Maximum</div><div className="text-xl font-bold text-green-800">{formatCurrency(wcCalculations.stats.max)}</div><div className="text-xs text-green-500">{wcCalculations.stats.maxMonth}</div></div>
                  <div className="bg-amber-50 p-3 rounded-lg border border-amber-200"><div className="text-xs text-amber-600 font-semibold">Minimum</div><div className="text-xl font-bold text-amber-800">{formatCurrency(wcCalculations.stats.min)}</div><div className="text-xs text-amber-500">{wcCalculations.stats.minMonth}</div></div>
                  <div className="bg-slate-50 p-3 rounded-lg border border-slate-200"><div className="text-xs text-slate-600 font-semibold">Range</div><div className="text-xl font-bold text-slate-800">{formatCurrency(wcCalculations.stats.range)}</div></div>
                </div>
                
                {/* WC Trend Chart */}
                <div className="mb-4 p-4 bg-white rounded-lg border">
                  <h4 className="font-semibold text-gray-700 mb-3">Working Capital Trend</h4>
                  <div className="flex items-end gap-1 h-40">
                    {wcCalculations.monthlyData.map((m, idx) => {
                      const value = wcShowOperating ? m.operatingNWC : m.totalNWC;
                      const maxVal = Math.max(...wcCalculations.monthlyData.map(d => Math.abs(wcShowOperating ? d.operatingNWC : d.totalNWC)));
                      const height = maxVal > 0 ? Math.abs(value) / maxVal * 100 : 0;
                      return (
                        <div key={idx} className="flex-1 flex flex-col items-center">
                          <div className="w-full flex flex-col items-center justify-end h-32">
                            <div className={`w-full rounded-t ${value < 0 ? 'bg-red-400' : 'bg-purple-400'}`} style={{ height: `${height}%`, minHeight: value !== 0 ? '4px' : '0' }} title={`${ttmBsMonthLabels[idx]}: ${formatCurrency(value)}`}></div>
                          </div>
                          <div className="text-xs text-gray-500 mt-1 truncate w-full text-center">{ttmBsMonthLabels[idx].substring(0, 3)}</div>
                          <div className="text-xs text-gray-600 font-medium">{formatCurrency(value)}</div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="mt-2 pt-2 border-t flex items-center gap-2 text-xs text-gray-500">
                    <div className="w-4 h-0.5 bg-purple-600"></div>
                    <span>Average: {formatCurrency(wcShowOperating ? wcCalculations.operatingAvgNWC : wcCalculations.totalAvgNWC)}</span>
                  </div>
                </div>
                
                {/* Anomaly Detection */}
                {wcCalculations.anomalies && wcCalculations.anomalies.length > 0 && (
                  <div className="mb-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
                    <h4 className="font-semibold text-amber-700 mb-2">⚠️ Significant Month-over-Month Changes (&gt;25%)</h4>
                    <div className="space-y-1">
                      {wcCalculations.anomalies.map((a, idx) => (<div key={idx} className="text-sm text-amber-800">{a.fromMonth} → {a.toMonth}: {formatCurrency(a.change)} ({a.pctChange.toFixed(1)}%)</div>))}
                    </div>
                  </div>
                )}
                
                {/* Monthly Detail Table */}
                <div className="mb-4">
                  <div className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded" onClick={() => setTtmBsDetailExpanded(!ttmBsDetailExpanded)}>
                    <h4 className="font-semibold text-gray-700">Monthly Detail</h4>
                    <span>{ttmBsDetailExpanded ? '▼' : '▶'}</span>
                  </div>
                  {ttmBsDetailExpanded && (
                    <div className="mt-2 overflow-x-auto">
                      <table className="w-full text-xs border-collapse">
                        <thead><tr className="bg-gray-100">
                          <th className="p-2 border text-left">Account</th>
                          {ttmBsMonthLabels.map((label, idx) => (<th key={idx} className="p-2 border text-right">{label}</th>))}
                          <th className="p-2 border text-right bg-gray-200">Avg</th>
                        </tr></thead>
                        <tbody>
                          {ttmBsCurrentAssets.filter(a => a.name && a.included).map(acct => (
                            <tr key={acct.id} className="hover:bg-blue-50">
                              <td className="p-2 border text-blue-700">{acct.name}</td>
                              {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-2 border text-right">{formatCurrency(val)}</td>))}
                              <td className="p-2 border text-right bg-blue-50 font-semibold">{formatCurrency(acct.values.filter(v => v !== 0).length > 0 ? acct.values.reduce((a, b) => a + b, 0) / acct.values.filter(v => v !== 0).length : 0)}</td>
                            </tr>
                          ))}
                          <tr className="bg-blue-100 font-semibold">
                            <td className="p-2 border text-blue-800">Total Operating CA</td>
                            {wcCalculations.monthlyData.map((m, idx) => (<td key={idx} className="p-2 border text-right">{formatCurrency(m.operatingCA)}</td>))}
                            <td className="p-2 border text-right bg-blue-200">{formatCurrency(wcCalculations.operatingAvgCA)}</td>
                          </tr>
                          {ttmBsCurrentLiabilities.filter(a => a.name && a.included).map(acct => (
                            <tr key={acct.id} className="hover:bg-orange-50">
                              <td className="p-2 border text-orange-700">{acct.name}</td>
                              {acct.values.map((val, mIdx) => (<td key={mIdx} className="p-2 border text-right">{formatCurrency(val)}</td>))}
                              <td className="p-2 border text-right bg-orange-50 font-semibold">{formatCurrency(acct.values.filter(v => v !== 0).length > 0 ? acct.values.reduce((a, b) => a + b, 0) / acct.values.filter(v => v !== 0).length : 0)}</td>
                            </tr>
                          ))}
                          <tr className="bg-orange-100 font-semibold">
                            <td className="p-2 border text-orange-800">Total Operating CL</td>
                            {wcCalculations.monthlyData.map((m, idx) => (<td key={idx} className="p-2 border text-right">{formatCurrency(m.operatingCL)}</td>))}
                            <td className="p-2 border text-right bg-orange-200">{formatCurrency(wcCalculations.operatingAvgCL)}</td>
                          </tr>
                          <tr className="bg-purple-100 font-bold">
                            <td className="p-2 border text-purple-800">Operating NWC</td>
                            {wcCalculations.monthlyData.map((m, idx) => (<td key={idx} className={`p-2 border text-right ${m.operatingNWC < 0 ? 'text-red-600' : 'text-purple-800'}`}>{formatCurrency(m.operatingNWC)}</td>))}
                            <td className="p-2 border text-right bg-purple-200 text-purple-900">{formatCurrency(wcCalculations.operatingAvgNWC)}</td>
                          </tr>
                        </tbody>
                      </table>
                      {(ttmBsCurrentAssets.filter(a => a.name && !a.included).length > 0 || ttmBsCurrentLiabilities.filter(a => a.name && !a.included).length > 0) && (
                        <div className="mt-3 p-2 bg-gray-50 rounded text-xs text-gray-600">
                          <strong>Excluded from Operating WC:</strong> {[...ttmBsCurrentAssets.filter(a => a.name && !a.included).map(a => a.name), ...ttmBsCurrentLiabilities.filter(a => a.name && !a.included).map(a => a.name)].join(', ')}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                
                {/* CapEx Investigation Section */}
                <div className="mt-6 border rounded-lg overflow-hidden">
                  <div className="px-4 py-3 bg-amber-50 border-b border-amber-200">
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="font-bold text-amber-800">🔧 Capital Expenditure Analysis</h3>
                        <p className="text-xs text-amber-600">Determine if maintenance CapEx adjustment is needed</p>
                      </div>
                      {outstandingAnalysis.unacknowledgedFlags.find(f => f.key === 'capex-investigation') && (
                        <span className="px-2 py-1 bg-amber-200 text-amber-800 text-xs rounded-full font-semibold">⚠️ Investigation Required</span>
                      )}
                    </div>
                  </div>
                  <div className="p-4 bg-white">
                    {/* Balance Sheet Indicators */}
                    <div className="mb-4">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Balance Sheet Indicators</h4>
                      <div className="grid grid-cols-3 gap-3">
                        <div className="p-3 bg-gray-50 rounded border">
                          <div className="text-xs text-gray-500">Net Fixed Assets</div>
                          <div className="text-lg font-bold text-gray-800">{formatCurrency(bsFixedAssets.reduce((sum, a) => sum + (a.interim || a.year3 || a.year2 || a.year1 || 0), 0))}</div>
                          <div className="text-xs text-gray-500">from Balance Sheet (net of depreciation)</div>
                        </div>
                        <div className="p-3 bg-gray-50 rounded border">
                          <div className="text-xs text-gray-500">Annual Depreciation</div>
                          <div className="text-lg font-bold text-gray-800">{formatCurrency(Math.max(diatCategories?.depreciation?.[selectedValuationBasis]?.ttm || 0, diatCategories?.depreciation?.[selectedValuationBasis]?.year5 || 0))}</div>
                          <div className="text-xs text-gray-500">from P&L (TTM or Year 5)</div>
                        </div>
                        <div className="p-3 bg-gray-50 rounded border">
                          <div className="text-xs text-gray-500">Calculated CapEx</div>
                          <div className="text-lg font-bold text-gray-800">
                            {formatCurrency((() => {
                              // CapEx ≈ Δ Fixed Assets + Depreciation
                              const currentFA = bsFixedAssets.reduce((sum, a) => sum + (a.interim || a.year3 || 0), 0);
                              const priorFA = bsFixedAssets.reduce((sum, a) => sum + (a.year2 || a.year1 || 0), 0);
                              const dep = diatCategories?.depreciation?.[selectedValuationBasis]?.year5 || 0;
                              return Math.max(0, (currentFA - priorFA) + dep);
                            })())}
                          </div>
                          <div className="text-xs text-gray-500">Δ Fixed Assets + Depreciation</div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Action Items */}
                    <div className="mb-4 p-3 bg-blue-50 rounded border border-blue-200">
                      <h4 className="text-sm font-semibold text-blue-800 mb-2">📋 Next Steps</h4>
                      <ol className="text-sm text-blue-900 list-decimal list-inside space-y-1">
                        <li><strong>Ask.</strong> Check the owner's answer to the CapEx question (Discovery Q&amp;A, financial section). No answer yet? It goes out with the owner questions. For the detailed breakdown, send the <strong>CapEx Verification Form</strong> (button below).</li>
                        <li><strong>Reconcile.</strong> The form's items should roughly explain the Balance Sheet's fixed assets and the Calculated CapEx above (Δ Fixed Assets + Depreciation). Big gaps = missing items or personal assets on the books — ask.</li>
                        <li><strong>Split maintenance vs. growth.</strong> Maintenance = recurring spend just to keep today's revenue (replacement trucks, servers on a refresh cycle, wear-and-tear) — a real ongoing cost. Growth = one-time expansion (a second location's build-out, capacity added for new business) — not recurring.</li>
                        <li><strong>Adjust if material.</strong> Estimate the ANNUAL maintenance number (item cost ÷ replacement cycle, summed). If it's material relative to EBITDA, enter it on the Adjustments tab as a <strong>CapEx</strong> line (type: add). EBITDA minus it = <strong>free cash flow</strong>, and the multiple applies to free cash flow. Growth CapEx gets no adjustment.</li>
                        <li><strong>Catch-up.</strong> Equipment already past due (worn out now, not on a normal cycle) is a one-time cost: enter it below. It comes off the price once, not × the multiple.</li>
                        <li><strong>Or waive with a reason.</strong> If no adjustment is warranted, dismiss the flag — a written reason is required and saved on the deal.</li>
                      </ol>
                    </div>

                    {/* 💵 FREE CASH FLOW (Mark/Zac 10-20, Aeroform: "we look at both EBITDA and FCF"). The bridge the buyer
                        reads, the catch-up input, and the method switch for valuations delivered before 10-20. */}
                    <div className="mb-4 p-3 rounded border border-emerald-200 bg-emerald-50">
                      <h4 className="text-sm font-semibold text-emerald-900 mb-2">💵 Free cash flow: what the multiple applies to</h4>
                      {capexMethod === 'legacy' ? (
                        <div className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded p-2 mb-2">
                          This valuation was delivered before the free-cash-flow method (10-20) and keeps its original math: the size tier reads EBITDA after capex, and there's no catch-up line.{' '}
                          <button type="button" className="ml-1 px-2 py-0.5 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700"
                            onClick={() => { if (window.confirm('Switch this valuation to the free-cash-flow method? The numbers will change: the size tier reads EBITDA before capex, and any catch-up capex comes off the price. Save afterwards.')) setCapexMethodSaved('fcf'); }}>
                            Switch to the free-cash-flow method
                          </button>
                        </div>
                      ) : null}
                      <table className="text-sm w-full max-w-md">
                        <tbody>
                          <tr><td className="py-0.5 text-gray-700">Normalized EBITDA before capex</td><td className="py-0.5 text-right font-medium">{formatCurrency((multipleEngineCalcs.adjustedEbitda || 0) + (Number(calculations?.valuation?.maintCapex) || 0))}</td></tr>
                          <tr><td className="py-0.5 text-gray-700">− Normal maintenance capex</td><td className="py-0.5 text-right font-medium">{formatCurrency(Number(calculations?.valuation?.maintCapex) || 0)}</td></tr>
                          <tr className="border-t border-emerald-300"><td className="py-0.5 font-semibold text-emerald-900">= Normalized EBITDA after capex (free cash flow: the multiple applies to this)</td><td className="py-0.5 text-right font-bold text-emerald-900">{formatCurrency(multipleEngineCalcs.adjustedEbitda || 0)}</td></tr>
                          {capexMethod === 'fcf' && (multipleEngineCalcs.catchUpCapex || 0) > 0 && (
                            <tr><td className="py-0.5 text-gray-700">One-time catch-up capex (off the price)</td><td className="py-0.5 text-right font-medium">− {formatCurrency(multipleEngineCalcs.catchUpCapex)}</td></tr>
                          )}
                        </tbody>
                      </table>
                      <div className="text-[11px] text-gray-600 mt-1">
                        {capexMethod === 'fcf'
                          ? <>The size tier (base multiple, floor) reads EBITDA <b>before</b> capex, so capex isn't counted twice. Maintenance capex comes from Adjustments lines with category <b>Maintenance CapEx</b> or the <b>CapEx</b> line.</>
                          : <>Original math: the size tier reads EBITDA after capex.</>}
                      </div>
                      {capexMethod === 'fcf' && (
                        <div className="mt-2 flex flex-wrap gap-2 items-center text-sm">
                          <label className="text-gray-700">One-time catch-up capex $</label>
                          <input type="number" min="0" step="1000" className="w-32 border rounded px-2 py-1"
                            value={capexCatchUp.amount || ''} placeholder="0"
                            onChange={e => setCapexCatchUp({ ...capexCatchUp, amount: Math.max(0, Number(e.target.value) || 0) })} />
                          <input type="text" className="flex-1 min-w-[200px] border rounded px-2 py-1" placeholder="What it is (e.g. RIM line replacement, overdue)"
                            value={capexCatchUp.note || ''} onChange={e => setCapexCatchUp({ ...capexCatchUp, note: e.target.value.slice(0, 200) })} />
                        </div>
                      )}
                    </div>

                    {/* Generate Form Button */}
                    <div className="flex gap-3">
                      <button 
                        onClick={generateCapExForm}
                        className="px-4 py-2 bg-amber-600 text-white rounded hover:bg-amber-700 text-sm font-semibold"
                      >
                        📄 Generate CapEx Verification Form
                      </button>
                      <button 
                        onClick={() => setViewMode('discovery')}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-sm"
                      >
                        Go to Discovery →
                      </button>
                      <button 
                        onClick={() => setViewMode('adjustments')}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-sm"
                      >
                        Go to Adjustments →
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            
          </div>
        ) : viewMode === 'outstanding' ? (
          /* ========== OPEN ITEMS ========== */
          <div>
            {(() => {
              // Calculate totals for header — includes the trend / roll-off
              // flags (extraOpenFlags), which the Open Items list also shows.
              const extraCritical = extraOpenFlags.filter(f => f.severity === 'critical').length;
              const extraUnverified = extraOpenFlags.filter(f => f.severity === 'warning' || f.severity === 'info').length;
              const reviewCount = outstandingAnalysis.criticalCount + extraCritical;
              const unverifiedCount = outstandingAnalysis.warningCount + outstandingAnalysis.infoCount + extraUnverified;
              const totalOpen = reviewCount + unverifiedCount;
              const totalResolved = 
                Object.entries(bsIssueNotes).filter(([k, v]) => v.reviewed).length +
                Object.entries(bsRecognitionNotes).filter(([k, v]) => v.reviewed).length +
                Object.entries(custRevenueNotes).filter(([k, v]) => v.reviewed).length +
                outstandingAnalysis.acknowledgedCount;
              
              return (
                <>
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-bold flex items-center gap-2">
                      <AlertTriangle className="w-5 h-5 text-orange-600" /> 
                      Open Items
                      <span className={`ml-2 px-3 py-1 rounded-full text-sm font-bold ${
                        totalOpen === 0 ? 'bg-green-100 text-green-700' : 
                        outstandingAnalysis.criticalCount > 0 ? 'bg-red-100 text-red-700' : 
                        'bg-amber-100 text-amber-700'
                      }`}>
                        {totalOpen} remaining
                      </span>
                      {totalResolved > 0 && (
                        <span className="ml-2 px-2 py-1 rounded-full text-xs font-medium bg-green-50 text-green-600">
                          ✓ {totalResolved} resolved
                        </span>
                      )}
                    </h2>
                  </div>
                  
                  {/* Filter Buttons */}
                  <div className="mb-4 p-3 bg-white rounded-lg border flex items-center gap-2">
                    <span className="text-sm text-gray-600 font-medium">Filter:</span>
                    <button 
                      onClick={() => setIssuesSeverityFilter('all')}
                      className={`px-3 py-1.5 rounded text-sm font-medium transition-colors ${issuesSeverityFilter === 'all' ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
                    >
                      All ({totalOpen})
                    </button>
                    <button 
                      onClick={() => setIssuesSeverityFilter('critical')}
                      className={`px-3 py-1.5 rounded text-sm font-medium transition-colors ${issuesSeverityFilter === 'critical' ? 'bg-red-600 text-white' : 'bg-red-50 text-red-700 hover:bg-red-100'}`}
                    >
                      ⚠️ Flagged for Review ({reviewCount})
                    </button>
                    <button 
                      onClick={() => setIssuesSeverityFilter('warning')}
                      className={`px-3 py-1.5 rounded text-sm font-medium transition-colors ${issuesSeverityFilter === 'warning' ? 'bg-amber-500 text-white' : 'bg-amber-50 text-amber-700 hover:bg-amber-100'}`}
                    >
                      ○ Unverified ({unverifiedCount})
                    </button>
                  </div>
                </>
              );
            })()}

            {/* 📊 Staff then-vs-now: every saved point (hand-offs, before each P&L paste, TTM updates). */}
            {/* Moved from the Presentation tab (Mark 10-06: staff notices never show on the owner screen). */}
            {/* Books vs owner answers (Mark 09-30, Concise 77% vs 100%): the value uses the books; a big gap is
                the first thing a buyer asks about, so it shows here, not only in the Factor D detail. */}
            {keyMetrics.contractCoverageSource === 'ledger' && (keyMetrics.detailCoveragePct || 0) >= 60
              && Math.abs((keyMetrics.detailedContractedPct || 0) - (keyMetrics.contractCoveragePct || 0)) > 20 && (
              <div className="mb-5 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800">
                <span className="font-semibold">⚠ Reconcile before a buyer does:</span> the books say <strong>{keyMetrics.contractCoveragePct.toFixed(0)}%</strong> of revenue is recurring agreement fees{(keyMetrics.contractedClientRevPct || 0) > (keyMetrics.contractCoveragePct || 0) + 0.5 ? <> (<strong>{keyMetrics.contractedClientRevPct.toFixed(0)}%</strong> counting those clients' projects & hardware)</> : null}; the owner's answers say <strong>{(keyMetrics.detailedContractedPct || 0).toFixed(0)}%</strong> (revenue-weighted, answered clients). The value uses the books. Usual cause: projects, hardware or licensing billed outside the agreement. If a line is really billed under the agreement, fix its revenue type.
              
                    <div className="mt-2">
                      <button type="button" className="text-xs px-2 py-1 rounded border border-amber-300 bg-white text-amber-800 hover:bg-amber-100"
                        title="Adds a pre-written question to Open Items → Ask Owner; edit it there, then 📨 Send owner questions."
                        onClick={() => {
                          const q = `Your books show about ${(keyMetrics.contractCoveragePct || 0).toFixed(0)}% of revenue as recurring agreement fees, but the client detail you provided shows about ${(keyMetrics.detailedContractedPct || 0).toFixed(0)}% of revenue from clients under contract. Can you help us reconcile? For example, are projects, hardware or software licenses billed outside the agreements, or are some agreement fees recorded under a different revenue account?`;
                          if ((researchItems || []).some(r => r.item === q)) { window.alert('That question is already in Ask Owner.'); return; }
                          setResearchItems([...(researchItems || []), { item: q, priority: 'high', notes: 'From the books-vs-owner contract check', askOwner: true, id: Math.max(...(researchItems || []).map(r => r.id || 0), 0) + 1, status: 'open' }]);
                          window.alert('Added to Open Items → Ask Owner. Edit it there if needed, then 📨 Send owner questions.');
                        }}>📧 Add as owner question</button>
                    </div>
                  </div>
            )}

            {/* Pro Forma Alert — lost clients still inflating TTM */}
            {(keyMetrics.lostWithResidualTTM?.length || 0) > 0 && (
              <div className="mb-5 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-amber-600 text-lg">⚠️</span>
                    <div>
                      <span className="font-semibold text-amber-800">Lost Revenue Still in TTM: </span>
                      <span className="text-sm text-amber-700">
                        {keyMetrics.lostWithResidualTTM.length} client{keyMetrics.lostWithResidualTTM.length !== 1 ? 's' : ''} marked Lost still have <strong>{formatCurrency(keyMetrics.lostResidualRevenue)}</strong> in TTM revenue — consider a Pro Forma adjustment
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <PriorVsNowPanel snapshots={[...(ebitdaSnapshots || []), ...(priorRevisionSnaps || [])]} current={currentSnapshot} fmt={formatCurrency} />

            {/* 🤖 AI review — advisory findings (Mark 10-05). Auto at analysis complete; run any time. */}
            <div className="mb-4 p-3 bg-white border border-violet-200 rounded-lg">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-gray-800">🤖 AI review</span>
                <span className="text-xs text-gray-500">{aiReviews && aiReviews[0] ? `last run ${new Date(aiReviews[0].at).toLocaleString()} (${aiReviews[0].trigger}${aiReviews[0].by ? ', ' + aiReviews[0].by : ''})` : 'not run yet — it runs by itself when the analysis is marked complete'}</span>
                {!isReadOnlyViewer && <button type="button" disabled={aiReviewBusy} onClick={() => runAiReview('on demand')} className="ml-auto text-xs px-2 py-1 rounded bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-50">{aiReviewBusy ? 'Reviewing…' : 'Run AI review'}</button>}
              </div>
              {aiReviews && aiReviews[0] && (aiReviews[0].findings.length === 0
                ? <p className="text-xs text-green-700 mt-1">✓ Nothing obvious found.</p>
                : <ul className="mt-2 space-y-1">{aiReviews[0].findings.map((x, i) => (
                    <li key={i} className="text-sm">
                      <span className={`text-[10px] font-bold uppercase rounded px-1 mr-1 ${x.severity === 'high' ? 'bg-red-100 text-red-700' : x.severity === 'medium' ? 'bg-amber-100 text-amber-800' : 'bg-gray-100 text-gray-600'}`}>{x.severity || 'note'}</span>
                      <span className="font-medium">{x.line}</span> — {x.issue}{x.check ? <span className="text-gray-500"> · Check: {x.check}</span> : null}
                    </li>
                  ))}</ul>)}
              <p className="text-[11px] text-gray-400 mt-1">Advisory — AI can be wrong. Fix what's real; it never blocks a hand-off.</p>
            </div>

            {/* Full-val escape hatch — "set the meeting anyway" (2026-06-08).
                Lets Colleen close out a full valuation that's stuck under 100%
                with lingering open items and get the valuation meeting set. */}
            {workflow.path === 'full_valuation'
              && ['data_entry_complete', 'adjustments_entered', 'analysis_complete'].includes(workflow.workflow_stage)
              && !workflow.next_meeting_date && (
              <div className="mb-4 p-3 bg-indigo-50 border border-indigo-200 rounded-lg flex items-center justify-between gap-3">
                <div className="text-sm text-indigo-800">
                  <span className="font-semibold">Done analyzing?</span> If you're ready to meet — even with a few open items still outstanding — mark the analysis complete and get the valuation meeting on the calendar.
                </div>
                <button
                  onClick={markAnalysisCompleteAndSetMeeting}
                  className="flex-shrink-0 px-3 py-1.5 rounded text-sm font-semibold bg-indigo-600 text-white hover:bg-indigo-700"
                >
                  ✓ Analysis complete — schedule meeting
                </button>
              </div>
            )}

            {/* OPEN ITEMS BY SECTION */}
            {/* Verification & Review Items Table */}
            {(() => {
              const dataFlagCategories = ['Adjustment', 'Line Adjustment', 'Basis Variance', 'Stale Balance Sheet', 'Balance Sheet', 'Revenue Recognition', 'Income Statement', 'Rev/COGS Matching', 'Owner Compensation', 'Trend Analysis', 'AR Quality', 'Revenue Estimate', 'Roll-Off Risk', 'Quality of Earnings', 'Sales Analysis', 'CapEx Analysis', 'Revenue Analysis', 'Revenue Quality'];
              const allDataFlags = [
                // Everything the other sections DON'T show (Colleen 10-02, Concise: a warning in a category missing
                // from the old allow-list counted toward "1 item needs review" but appeared nowhere). Document /
                // Discovery, Research and Analyst Flags have their own sections below.
                ...outstandingAnalysis.unacknowledgedFlags.filter(f => dataFlagCategories.includes(f.category) || !['Document', 'Discovery', 'Research', 'Analyst Flag'].includes(f.category)),
                ...extraOpenFlags
              ];
              
              // Count by workflow type (review = critical, unverified = warning + info)
              const reviewCount = allDataFlags.filter(f => f.severity === 'critical').length;
              const unverifiedCount = allDataFlags.filter(f => f.severity === 'warning' || f.severity === 'info').length;
              
              // Apply filter - map old severity filter to new workflow filter
              const filteredFlags = issuesSeverityFilter === 'all' 
                ? allDataFlags 
                : issuesSeverityFilter === 'critical'
                  ? allDataFlags.filter(f => f.severity === 'critical')
                  : allDataFlags.filter(f => f.severity === 'warning' || f.severity === 'info');
              
              // Determine filter label for display
              const filterLabel = issuesSeverityFilter === 'critical' ? 'Flagged for Review' : 'Unverified';
              
              return (
                <div className="mb-4 border rounded-lg overflow-hidden">
                  <button 
                    onClick={() => toggleIssuesSection('dataFlags')}
                    className="w-full flex items-center justify-between p-3 bg-gray-100 hover:bg-gray-200 transition-colors"
                  >
                    <h3 className="font-bold text-gray-800 flex items-center gap-2">
                      <span className="text-lg">{issuesSections.dataFlags ? '▼' : '▶'}</span>
                      🔍 Verification & Review Items ({allDataFlags.length})
                      <span className="flex items-center gap-2 ml-3 text-sm font-normal">
                        {reviewCount > 0 && <span className="px-2 py-0.5 rounded-full bg-red-100 text-red-700">⚠️ {reviewCount} for review</span>}
                        {unverifiedCount > 0 && <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">○ {unverifiedCount} unverified</span>}
                      </span>
                    </h3>
                    <span className="text-sm text-gray-500">Items requiring investigation or confirmation</span>
                  </button>
                  {issuesSections.dataFlags && (
                  <div className="p-3 bg-white">
                  {issuesSeverityFilter !== 'all' && filteredFlags.length !== allDataFlags.length && (
                    <div className="mb-2 px-3 py-1.5 bg-gray-100 rounded text-sm text-gray-600">
                      Showing {filteredFlags.length} of {allDataFlags.length} items (filtered to {filterLabel} only)
                    </div>
                  )}
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs border-collapse">
                      <thead className="bg-gray-200">
                        <tr><th className="p-2 border w-6">Type</th><th className="p-2 border">Category</th><th className="p-2 border">Issue</th><th className="p-2 border">Detail</th><th className="p-2 border">How to Resolve</th><th className="p-2 border w-16">Action</th></tr>
                      </thead>
                      <tbody>
                        {filteredFlags.length === 0 ? (
                          <tr><td colSpan="6" className="p-3 text-center text-green-600 font-semibold">✓ {issuesSeverityFilter === 'all' ? 'No items requiring attention!' : `No ${filterLabel.toLowerCase()} items`}</td></tr>
                        ) : (
                          <>
                            {filteredFlags.map((flag, idx) => (
                              <tr key={flag.key || idx} className={flag.severity === 'critical' ? 'bg-red-50' : 'bg-amber-50'}>
                                <td className="p-1 border text-center" title={flag.severity === 'critical' ? 'Flagged for Review' : 'Needs Verification'}>{flag.severity === 'critical' ? '⚠️' : '○'}</td>
                                <td className="p-1 border font-medium">{flag.category}</td>
                                <td className="p-1 border">{flag.item}</td>
                                <td className="p-1 border text-gray-600">{flag.detail}</td>
                                <td className="p-1 border text-gray-700">{flag.canResolveAt || flag.action}</td>
                                <td className="p-1 border text-center">
                                  <div className="flex gap-1 justify-center">
                                    {flag.resolveTab && (
                                      <button onClick={() => {
                                        setViewMode(flag.resolveTab);
                                        // Auto-expand relevant sections and scroll after tab renders
                                        if (flag.resolveTab === 'salesanalysis') setSalesFlagsExpanded(true);
                                        if (flag.resolveTab === 'detailed') { setIncomeStmtViewMode('monthly'); setRollOffExpanded(true); }
                                        setTimeout(() => {
                                          const targetId = flag.key ? `resolve-${flag.key}` : null;
                                          const el = targetId && document.getElementById(targetId);
                                          if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
                                          else {
                                            // Fallback: scroll to Issues & Flags section by category
                                            const section = document.getElementById(`flags-${flag.resolveTab}`);
                                            if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                          }
                                        }, 300);
                                      }} className="px-2 py-0.5 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs">Go To</button>
                                    )}
                                    <button 
                                      onClick={() => acknowledgeFlag(flag.key, 'Waived')} 
                                      className="px-1.5 py-0.5 bg-gray-400 hover:bg-gray-500 text-white rounded text-xs"
                                      title="Waive - dismiss without resolving on analysis tab"
                                    >
                                      Waive
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                  </div>
                  )}
                </div>
              );
            })()}



            {/* Discovery & Documents Section */}
            {(() => {
              const discoveryFlags = outstandingAnalysis.unacknowledgedFlags.filter(f => ['Document', 'Discovery'].includes(f.category));
              
              // Count by severity
              const criticalCount = discoveryFlags.filter(f => f.severity === 'critical').length;
              const warningCount = discoveryFlags.filter(f => f.severity === 'warning').length;
              const infoCount = discoveryFlags.filter(f => f.severity === 'info').length;
              
              // Apply filter
              const filteredFlags = issuesSeverityFilter === 'all' 
                ? discoveryFlags 
                : discoveryFlags.filter(f => f.severity === issuesSeverityFilter);
              
              // If filter is active and no matching items, skip entire section
              if (issuesSeverityFilter !== 'all' && filteredFlags.length === 0) return null;
              
              return (
                <div className="mb-4 border rounded-lg overflow-hidden">
                  <button 
                    onClick={() => toggleIssuesSection('discovery')}
                    className="w-full flex items-center justify-between p-3 bg-indigo-100 hover:bg-indigo-200 transition-colors"
                  >
                    <h3 className="font-bold text-gray-800 flex items-center gap-2">
                      <span className="text-lg">{issuesSections.discovery ? '▼' : '▶'}</span>
                      📋 Discovery & Documents ({discoveryFlags.length})
                      <span className="flex items-center gap-2 ml-3 text-sm font-normal">
                        {criticalCount > 0 && <span className="px-2 py-0.5 rounded-full bg-red-100 text-red-700">🔴 {criticalCount}</span>}
                        {warningCount > 0 && <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">🟡 {warningCount}</span>}
                        {infoCount > 0 && <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">🔵 {infoCount}</span>}
                      </span>
                    </h3>
                    <span className="text-sm text-gray-500">Missing documents and pending Q&A</span>
                  </button>
                  {issuesSections.discovery && (
                  <div className="p-3 bg-white">
                  {issuesSeverityFilter !== 'all' && filteredFlags.length !== discoveryFlags.length && (
                    <div className="mb-2 px-3 py-1.5 bg-gray-100 rounded text-sm text-gray-600">
                      Showing {filteredFlags.length} of {discoveryFlags.length} items (filtered to {issuesSeverityFilter} only)
                    </div>
                  )}
                  
                  {/* Copy Buttons */}
                  <div className="mb-3 flex flex-wrap gap-2">
                    {/* Copy Missing Documents */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        const docsNeeded = documentChecklist.filter(d => d.status !== 'complete');
                        if (docsNeeded.length === 0) {
                          alert('All documents have been received!');
                          return;
                        }
                        let text = '';
                        docsNeeded.forEach((doc, idx) => {
                          text += `${idx + 1}. ${doc.name}`;
                          // Add pending notes if partial
                          if (doc.status === 'partial' && doc.pendingNotes) {
                            text += ` (Still need: ${doc.pendingNotes})`;
                          }
                          text += '\n';
                        });
                        navigator.clipboard.writeText(text.trim()).then(() => {
                          setCopySuccess('docs');
                          setTimeout(() => setCopySuccess(false), 2000);
                        }).catch(() => {
                          const textarea = document.createElement('textarea');
                          textarea.value = text.trim();
                          document.body.appendChild(textarea);
                          textarea.select();
                          document.execCommand('copy');
                          document.body.removeChild(textarea);
                          setCopySuccess('docs');
                          setTimeout(() => setCopySuccess(false), 2000);
                        });
                      }}
                      className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-1 ${
                        copySuccess === 'docs'
                          ? 'bg-green-500 text-white'
                          : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                      }`}
                    >
                      {copySuccess === 'docs' ? '✓ Copied!' : `📁 Copy Missing Docs (${documentChecklist.filter(d => d.status !== 'complete').length})`}
                    </button>
                    
                    {/* Copy Pending Questions */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        const unanswered = sellerQA.filter(q => q.status === 'pending');
                        if (unanswered.length === 0) {
                          alert('No pending questions to copy.');
                          return;
                        }
                        let text = '';
                        unanswered.forEach((q, idx) => {
                          text += `${idx + 1}. ${q.question}\n`;
                        });
                        navigator.clipboard.writeText(text.trim()).then(() => {
                          setCopySuccess('pending');
                          setTimeout(() => setCopySuccess(false), 2000);
                        }).catch(() => {
                          const textarea = document.createElement('textarea');
                          textarea.value = text.trim();
                          document.body.appendChild(textarea);
                          textarea.select();
                          document.execCommand('copy');
                          document.body.removeChild(textarea);
                          setCopySuccess('pending');
                          setTimeout(() => setCopySuccess(false), 2000);
                        });
                      }}
                      className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-1 ${
                        copySuccess === 'pending'
                          ? 'bg-green-500 text-white'
                          : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                      }`}
                    >
                      {copySuccess === 'pending' ? '✓ Copied!' : `❓ Copy Pending Q's (${sellerQA.filter(q => q.status === 'pending').length})`}
                    </button>
                    
                    {/* Copy Follow-up Questions */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        const followups = sellerQA.filter(q => q.status === 'follow-up');
                        if (followups.length === 0) {
                          alert('No follow-up questions to copy.');
                          return;
                        }
                        let text = '';
                        followups.forEach((q, idx) => {
                          text += `${idx + 1}. ${q.question}\n`;
                          if (q.answer) text += `   Previous answer: ${q.answer}\n`;
                          text += '\n';
                        });
                        navigator.clipboard.writeText(text.trim()).then(() => {
                          setCopySuccess('followup');
                          setTimeout(() => setCopySuccess(false), 2000);
                        }).catch(() => {
                          const textarea = document.createElement('textarea');
                          textarea.value = text.trim();
                          document.body.appendChild(textarea);
                          textarea.select();
                          document.execCommand('copy');
                          document.body.removeChild(textarea);
                          setCopySuccess('followup');
                          setTimeout(() => setCopySuccess(false), 2000);
                        });
                      }}
                      className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-1 ${
                        copySuccess === 'followup'
                          ? 'bg-green-500 text-white'
                          : 'bg-amber-100 text-amber-700 hover:bg-amber-200'
                      }`}
                    >
                      {copySuccess === 'followup' ? '✓ Copied!' : `🔄 Copy Follow-ups (${sellerQA.filter(q => q.status === 'follow-up').length})`}
                    </button>
                  </div>
                  
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs border-collapse">
                      <thead className="bg-gray-200">
                        <tr><th className="p-2 border w-6">⚠️</th><th className="p-2 border w-24">Type</th><th className="p-2 border">Item</th><th className="p-2 border">Detail</th><th className="p-2 border">How to Resolve</th><th className="p-2 border w-16">Action</th></tr>
                      </thead>
                      <tbody>
                        {filteredFlags.length === 0 ? (
                          <tr><td colSpan="6" className="p-3 text-center text-green-600 font-semibold">✓ All documents received and Q&A complete!</td></tr>
                        ) : (
                          filteredFlags.map((flag, idx) => (
                            <tr key={flag.key || idx} className={flag.severity === 'critical' ? 'bg-red-50' : flag.severity === 'warning' ? 'bg-amber-50' : 'bg-blue-50'}>
                              <td className="p-1 border text-center">{flag.severity === 'critical' ? '🔴' : flag.severity === 'warning' ? '🟡' : '🔵'}</td>
                              <td className="p-1 border font-medium">{flag.category}</td>
                              <td className="p-1 border">{flag.item}</td>
                              <td className="p-1 border text-gray-600">{flag.detail}</td>
                              <td className="p-1 border text-gray-700">{flag.canResolveAt || flag.action}</td>
                              <td className="p-1 border text-center">
                                <div className="flex gap-1 justify-center">
                                  <button onClick={() => setViewMode('discovery')} className="px-2 py-0.5 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs">Go To</button>
                                  <button 
                                    onClick={() => acknowledgeFlag(flag.key, 'Waived')} 
                                    className="px-1.5 py-0.5 bg-gray-400 hover:bg-gray-500 text-white rounded text-xs"
                                    title="Waive - dismiss without resolving on analysis tab"
                                  >
                                    Waive
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  </div>
                  )}
                </div>
              );
            })()}

            {/* Reviewer Notes */}
            {(() => {
              const reviewerItems = researchItems.filter(r => r.reviewerNote);
              const openReviewer = reviewerItems.filter(r => r.status !== 'complete');
              const resolvedReviewer = reviewerItems.filter(r => r.status === 'complete');
              
              if (reviewerItems.length === 0) return null;
              
              return (
                <div className="mb-4 border-2 border-indigo-300 rounded-lg overflow-hidden">
                  <button 
                    onClick={() => toggleIssuesSection('reviewerNotes')}
                    className="w-full flex items-center justify-between p-3 bg-indigo-100 hover:bg-indigo-200 transition-colors"
                  >
                    <h3 className="font-bold text-indigo-900 flex items-center gap-2">
                      <span className="text-lg">{issuesSections.reviewerNotes ? '▼' : '▶'}</span>
                      🔎 Reviewer Notes ({openReviewer.length} open{resolvedReviewer.length > 0 ? `, ${resolvedReviewer.length} resolved` : ''})
                    </h3>
                    <span className="text-sm text-indigo-600">Supervisor review comments & questions</span>
                  </button>
                  {issuesSections.reviewerNotes && (
                  <div className="p-3 bg-indigo-50">
                    {openReviewer.length === 0 && resolvedReviewer.length > 0 && (
                      <div className="text-center py-4 text-green-700 font-medium">✅ All reviewer notes have been addressed</div>
                    )}
                    {reviewerItems.map(item => (
                      <div key={item.id} className={`mb-3 p-3 rounded-lg border ${item.status === 'complete' ? 'bg-gray-50 border-gray-200 opacity-70' : 'bg-white border-indigo-200'}`}>
                        <div className="flex items-start justify-between gap-3">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                                item.priority === 'high' ? 'bg-red-100 text-red-700' : 
                                item.priority === 'medium' ? 'bg-amber-100 text-amber-700' : 
                                'bg-blue-100 text-blue-700'
                              }`}>
                                {item.priority === 'high' ? '🔴' : item.priority === 'medium' ? '🟡' : '🔵'} {item.priority}
                              </span>
                              <span className="text-xs text-gray-500">📍 {item.source || 'General'}</span>
                              <span className="text-xs text-gray-400">{item.createdAt}</span>
                              {item.askOwner && <span className="px-2 py-0.5 rounded-full text-xs bg-orange-100 text-orange-700">📧 Ask Owner</span>}
                            </div>
                            <div className={`font-medium ${item.status === 'complete' ? 'line-through text-gray-500' : 'text-gray-800'}`}>
                              {item.item}
                            </div>
                            {item.notes && item.notes !== `Added from: ${item.source}` && (
                              <div className="mt-1 text-xs text-gray-500 italic">{item.notes}</div>
                            )}
                          </div>
                          <div className="flex items-center gap-2">
                            <select
                              value={item.status || 'open'}
                              onChange={e => setResearchItems(prev => prev.map(r => r.id === item.id ? {...r, status: e.target.value, resolvedAt: e.target.value === 'complete' ? new Date().toLocaleDateString() : r.resolvedAt} : r))}
                              className={`text-xs border rounded px-2 py-1 ${
                                item.status === 'complete' ? 'bg-green-100 text-green-700' :
                                item.status === 'in-progress' ? 'bg-blue-100 text-blue-700' :
                                'bg-amber-100 text-amber-700'
                              }`}
                            >
                              <option value="open">Open</option>
                              <option value="in-progress">In Progress</option>
                              <option value="complete">Resolved</option>
                            </select>
                            <button
                              onClick={() => { if (confirm('Delete this reviewer note?')) setResearchItems(prev => prev.filter(r => r.id !== item.id)); }}
                              className="text-gray-400 hover:text-red-500 text-sm"
                              title="Delete"
                            >×</button>
                          </div>
                        </div>
                        {/* Response field for analyst */}
                        <div className="mt-2">
                          <input
                            type="text"
                            value={item.response || ''}
                            onChange={e => setResearchItems(prev => prev.map(r => r.id === item.id ? {...r, response: e.target.value} : r))}
                            placeholder="Analyst response..."
                            className="w-full px-3 py-1.5 border rounded text-sm bg-white"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  )}
                </div>
              );
            })()}

            {/* Research Items */}
            {(() => {
              const openResearch = researchItems.filter(r => r.status !== 'complete' && !r.reviewerNote);
              const highPriorityCount = openResearch.filter(r => r.priority === 'high').length;
              const mediumLowCount = openResearch.filter(r => r.priority !== 'high').length;
              const askOwnerCount = openResearch.filter(r => r.askOwner).length;
              
              // Filter based on severity - high priority = warning, medium/low = info
              const showSection = issuesSeverityFilter === 'all' || 
                (issuesSeverityFilter === 'warning' && highPriorityCount > 0) ||
                (issuesSeverityFilter === 'info' && mediumLowCount > 0);
              
              if (!showSection) return null;
              
              return (
                <div className="mb-4 border rounded-lg overflow-hidden">
                  <button 
                    onClick={() => toggleIssuesSection('research')}
                    className="w-full flex items-center justify-between p-3 bg-slate-100 hover:bg-slate-200 transition-colors"
                  >
                    <h3 className="font-bold text-gray-800 flex items-center gap-2">
                      <span className="text-lg">{issuesSections.research ? '▼' : '▶'}</span>
                      🔍 Research Items ({openResearch.length} open)
                      <span className="flex items-center gap-2 ml-3 text-sm font-normal">
                        {highPriorityCount > 0 && <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">🟡 {highPriorityCount} high priority</span>}
                        {mediumLowCount > 0 && <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">🔵 {mediumLowCount} med/low</span>}
                        {askOwnerCount > 0 && <span className="px-2 py-0.5 rounded-full bg-orange-100 text-orange-700">📧 {askOwnerCount} ask owner</span>}
                      </span>
                    </h3>
                    <span className="text-sm text-gray-500">Track research tasks and follow-ups</span>
                  </button>
                  {issuesSections.research && (
                  <div className="p-3 bg-white">
                  {/* Copy Ask Owner Button */}
                  {askOwnerCount > 0 && (
                    <div className="mb-3 flex justify-end gap-2">
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); refreshOwnerAnswers(); }}
                        disabled={refreshingOwnerAnswers}
                        className="px-3 py-1.5 rounded-lg text-sm font-medium bg-sky-100 text-sky-700 hover:bg-sky-200 disabled:opacity-50 flex items-center gap-1"
                        title="Owner answers load when the deal is opened — click to pull any newly-submitted portal answers without reloading"
                      >
                        {refreshingOwnerAnswers ? '⏳ Checking…' : '🔄 Check for new answers'}
                      </button>
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); openOwnerQuestionsModal(); }}
                        className="px-3 py-1.5 rounded-lg text-sm font-medium bg-emerald-600 text-white hover:bg-emerald-700 flex items-center gap-1"
                        title="Email all open Ask-Owner questions to the owner in one message (sent as Colleen)"
                      >
                        📨 Send owner questions ({askOwnerCount})
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          const askOwnerItems = researchItems.filter(r => r.askOwner && r.status !== 'complete');
                          if (askOwnerItems.length === 0) {
                            alert('No "Ask Owner" items to copy.');
                            return;
                          }
                          let text = '';
                          askOwnerItems.forEach((item, idx) => {
                            text += `${idx + 1}. ${item.item}\n`;
                          });
                          navigator.clipboard.writeText(text.trim()).then(() => {
                            setCopySuccess('askowner');
                            setTimeout(() => setCopySuccess(false), 2000);
                          }).catch(() => {
                            const textarea = document.createElement('textarea');
                            textarea.value = text.trim();
                            document.body.appendChild(textarea);
                            textarea.select();
                            document.execCommand('copy');
                            document.body.removeChild(textarea);
                            setCopySuccess('askowner');
                            setTimeout(() => setCopySuccess(false), 2000);
                          });
                        }}
                        className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-1 ${
                          copySuccess === 'askowner'
                            ? 'bg-green-500 text-white'
                            : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
                        }`}
                      >
                        {copySuccess === 'askowner' ? '✓ Copied!' : `📋 Copy "Ask Owner" (${askOwnerCount})`}
                      </button>
                    </div>
                  )}
                  <table className="w-full text-xs border-collapse mb-2">
                    <thead className="bg-slate-200">
                      <tr>
                        <th className="p-1 border w-24">Status</th>
                        <th className="p-1 border w-16">Priority</th>
                        <th className="p-1 border w-16">Ask Owner</th>
                        <th className="p-1 border" style={{minWidth: '150px'}}>Question</th>
                        <th className="p-1 border" style={{width: '100px'}}>Source/Notes</th>
                        <th className="p-1 border" style={{minWidth: '250px'}}>Resolution</th>
                        <th className="p-1 border w-6">×</th>
                      </tr>
                    </thead>
                    <tbody>
                      {researchItems.filter(item => {
                        if (item.reviewerNote) return false;
                        if (issuesSeverityFilter === 'all') return item.status !== 'complete';
                        if (issuesSeverityFilter === 'warning') return item.priority === 'high' && item.status !== 'complete';
                        if (issuesSeverityFilter === 'info') return item.priority !== 'high' && item.status !== 'complete';
                        return false;
                      }).map(item => (
                        <tr key={item.id} className={item.status === 'complete' ? 'bg-green-50' : item.priority === 'high' ? 'bg-amber-50' : 'bg-blue-50'}>
                          <td className="p-1 border text-center">
                            <select value={item.status} onChange={e => {
                              const newStatus = e.target.value;
                              if (newStatus === 'complete' && !item.resolution) {
                                // Prompt for resolution when marking complete
                                const resolution = prompt('Enter resolution/answer for this item:');
                                if (resolution) {
                                  setResearchItems(researchItems.map(r => r.id === item.id ? {
                                    ...r, 
                                    status: newStatus,
                                    resolution: resolution,
                                    completedAt: new Date().toLocaleDateString()
                                  } : r));
                                }
                              } else {
                                setResearchItems(researchItems.map(r => r.id === item.id ? {
                                  ...r, 
                                  status: newStatus,
                                  completedAt: newStatus === 'complete' ? new Date().toLocaleDateString() : r.completedAt
                                } : r));
                              }
                            }} className={`text-xs p-0.5 rounded ${item.status === 'complete' ? 'bg-green-200' : 'bg-slate-100'}`}>
                              <option value="open">Open</option>
                              <option value="in-progress">In Progress</option>
                              <option value="complete">Complete</option>
                            </select>
                          </td>
                          <td className="p-1 border text-center">
                            <div className="flex items-center gap-1 justify-center">
                              {item.priority === 'high' ? '🟡' : '🔵'}
                              <select value={item.priority} onChange={e => setResearchItems(researchItems.map(r => r.id === item.id ? {...r, priority: e.target.value} : r))} className={`text-xs p-0.5 rounded ${item.priority === 'high' ? 'bg-amber-200' : item.priority === 'medium' ? 'bg-blue-100' : 'bg-gray-200'}`}>
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                              </select>
                            </div>
                          </td>
                          <td className="p-1 border text-center">
                            <button 
                              onClick={() => setResearchItems(researchItems.map(r => r.id === item.id ? {...r, askOwner: !r.askOwner} : r))}
                              className={`px-2 py-1 rounded text-xs font-medium transition-all ${
                                item.askOwner 
                                  ? 'bg-orange-100 text-orange-700 border border-orange-300' 
                                  : 'bg-gray-100 text-gray-400 border border-gray-200 hover:bg-gray-200'
                              }`}
                            >
                              {item.askOwner ? '📧 Yes' : 'No'}
                            </button>
                          </td>
                          <td className="p-0 border">
                            {/* Editable question/item text. For Ask-Owner items this
                                is the exact wording sent to the owner (the questions
                                email + the portal both read `item`), so Colleen can
                                reword it before it goes out. Same inline-save pattern
                                as the other cells in this row. */}
                            <AutoGrowTextarea
                              value={item.item || ''}
                              onChange={e => setResearchItems(researchItems.map(r => r.id === item.id ? {...r, item: e.target.value} : r))}
                              className="w-full p-1 text-xs font-medium border-0 bg-transparent resize-vertical"
                              placeholder="Question / item…"
                              title={item.askOwner ? 'This wording is sent to the owner — edit it before sending' : 'Internal item'}
                            />
                            {/* Owner's portal answer surfaced right next to the question
                                Colleen wrote (she works here, not the Discovery tab). Ad-hoc
                                Ask-Owner answers match on question_type='adhoc' + question_key
                                = String(item.id). "Accept" drops the answer into the editable
                                Resolution cell so she can vet/reword it, then mark Resolved
                                herself — the review step is preserved. (Mark/Colleen 2026-06-29) */}
                            {(() => {
                              const oa = (ownerPortalAnswers || []).find(a =>
                                a && a.answer && a.question_type === 'adhoc' && String(a.question_key) === String(item.id));
                              if (!oa) return null;
                              return (
                                <div className="mx-1 mb-1 p-1.5 bg-sky-50 border border-sky-200 rounded">
                                  <div className="flex items-center gap-1 mb-0.5">
                                    <span className="px-1.5 py-0.5 rounded-full bg-sky-100 text-sky-700 text-[10px] font-semibold">📥 Owner answered</span>
                                    {oa.answered_at && <span className="text-[10px] text-gray-400">{new Date(oa.answered_at).toLocaleDateString()}</span>}
                                  </div>
                                  <div className="text-xs text-gray-800 whitespace-pre-line">“{oa.answer}”</div>
                                  {!item.resolution && (
                                    <button
                                      type="button"
                                      onClick={() => { setResearchItems(researchItems.map(r => String(r.id) === String(item.id) ? {...r, resolution: oa.answer} : r)); setHasUnsavedChanges(true); }}
                                      className="mt-1 px-2 py-0.5 bg-sky-600 text-white rounded text-[11px] font-medium hover:bg-sky-700"
                                      title="Copy the owner's answer into the Resolution cell to review/edit"
                                    >Accept into resolution →</button>
                                  )}
                                </div>
                              );
                            })()}
                          </td>
                          <td className="p-1 border text-gray-600 text-xs">{item.notes || item.source || '-'}</td>
                          <td className="p-0 border">
                            <AutoGrowTextarea
                              value={item.resolution || ''}
                              onChange={e => setResearchItems(researchItems.map(r => r.id === item.id ? {...r, resolution: e.target.value} : r))}
                              className="w-full p-1 text-xs border-0 bg-transparent resize-vertical"
                              placeholder="Enter answer/resolution..."
                            />
                          </td>
                          <td className="p-1 border text-center"><button onClick={() => { captureUndoState('Delete Research Item'); setResearchItems(researchItems.filter(r => r.id !== item.id)); }} className="text-red-600 hover:text-red-800">×</button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="flex gap-1">
                    <input type="text" value={newResearchItem.item} onChange={e => setNewResearchItem({...newResearchItem, item: e.target.value})} placeholder="New research item..." className="flex-1 p-1 border rounded text-xs" />
                    <select value={newResearchItem.priority} onChange={e => setNewResearchItem({...newResearchItem, priority: e.target.value})} className="p-1 border rounded text-xs">
                      <option value="high">High</option>
                      <option value="medium">Medium</option>
                      <option value="low">Low</option>
                    </select>
                    <button 
                      type="button"
                      onClick={() => setNewResearchItem({...newResearchItem, askOwner: !newResearchItem.askOwner})}
                      className={`px-2 py-1 rounded text-xs font-medium ${newResearchItem.askOwner ? 'bg-orange-100 text-orange-700 border border-orange-300' : 'bg-gray-100 text-gray-500 border'}`}
                    >
                      {newResearchItem.askOwner ? '📧 Ask' : '📧'}
                    </button>
                    <input type="text" value={newResearchItem.notes} onChange={e => setNewResearchItem({...newResearchItem, notes: e.target.value})} placeholder="Notes..." className="w-32 p-1 border rounded text-xs" />
                    <button onClick={addResearchItem} className="px-2 py-1 bg-blue-500 text-white rounded text-xs font-semibold">+ Add</button>
                  </div>
                  </div>
                  )}
                </div>
              );
            })()}
            
            {/* Analyst Flags - Items flagged from Analysis tabs */}
            {(() => {
              const flaggedItems = Object.entries(manualReviewFlags)
                .filter(([key, flag]) => flag?.flagged && !flag?.resolved)
                .map(([key, flag]) => ({
                  key,
                  section: flag.section || 'Analysis',
                  item: flag.item || key,
                  notes: monthlyTtmNotes[key] || '',
                  created: flag.created
                }))
                .sort((a, b) => (b.created || 0) - (a.created || 0));
              
              if (flaggedItems.length === 0) return null;
              
              // Analyst flags are all treated as warnings
              if (issuesSeverityFilter !== 'all' && issuesSeverityFilter !== 'warning') return null;
              
              const handleResolveFlag = (key) => {
                if (!resolutionText.trim()) {
                  alert('Please enter a resolution before marking as resolved.');
                  return;
                }
                setManualReviewFlags(prev => ({
                  ...prev, 
                  [key]: {
                    ...prev[key], 
                    flagged: false,
                    resolved: true,
                    resolution: resolutionText.trim(),
                    resolvedDate: new Date().toLocaleDateString()
                  }
                }));
                setResolvingFlagKey(null);
                setResolutionText('');
              };
              
              return (
                <div className="mb-4 border rounded-lg overflow-hidden border-purple-300">
                  <button 
                    onClick={() => toggleIssuesSection('analystFlags')}
                    className="w-full flex items-center justify-between p-3 bg-purple-100 hover:bg-purple-200 transition-colors"
                  >
                    <h3 className="font-bold text-purple-800 flex items-center gap-2">
                      <span className="text-lg">{issuesSections.analystFlags ? '▼' : '▶'}</span>
                      🚩 Analyst Flags ({flaggedItems.length} open)
                      <span className="px-2 py-0.5 rounded-full bg-purple-200 text-purple-700 text-sm font-normal ml-3">
                        Items flagged during financial review
                      </span>
                    </h3>
                    <span className="text-sm text-purple-600">Manual flags from Income Statement & Balance Sheet analysis</span>
                  </button>
                  {issuesSections.analystFlags && (
                    <div className="p-3 bg-white">
                      <table className="w-full text-xs border-collapse">
                        <thead className="bg-purple-50">
                          <tr>
                            <th className="p-2 border text-left w-28">Section</th>
                            <th className="p-2 border text-left" style={{minWidth: '120px'}}>Item</th>
                            <th className="p-2 border text-left" style={{minWidth: '180px'}}>Question/Note</th>
                            <th className="p-2 border text-left" style={{minWidth: '200px'}}>Resolution</th>
                            <th className="p-2 border text-center w-24">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {flaggedItems.map(item => (
                            <tr key={item.key} className="bg-purple-50 hover:bg-purple-100">
                              <td className="p-2 border text-gray-600">{item.section}</td>
                              <td className="p-2 border font-medium">{item.item}</td>
                              <td className="p-0 border">
                                <input 
                                  type="text"
                                  value={item.notes}
                                  onChange={e => setMonthlyTtmNotes(prev => ({...prev, [item.key]: e.target.value}))}
                                  className="w-full p-2 text-xs border-0 bg-transparent"
                                  placeholder="Add question/note..."
                                />
                              </td>
                              <td className="p-0 border">
                                {resolvingFlagKey === item.key ? (
                                  <input 
                                    type="text"
                                    value={resolutionText}
                                    onChange={e => setResolutionText(e.target.value)}
                                    onKeyDown={e => {
                                      if (e.key === 'Enter') handleResolveFlag(item.key);
                                      if (e.key === 'Escape') { setResolvingFlagKey(null); setResolutionText(''); }
                                    }}
                                    className="w-full p-2 text-xs border-2 border-green-400 bg-green-50"
                                    placeholder="Enter resolution/answer... (Enter to save)"
                                    autoFocus
                                  />
                                ) : (
                                  <div 
                                    className="w-full p-2 text-xs text-gray-400 cursor-pointer hover:bg-gray-50"
                                    onClick={() => { setResolvingFlagKey(item.key); setResolutionText(''); }}
                                  >
                                    Click to add resolution...
                                  </div>
                                )}
                              </td>
                              <td className="p-2 border text-center">
                                {resolvingFlagKey === item.key ? (
                                  <div className="flex gap-1 justify-center">
                                    <button 
                                      onClick={() => handleResolveFlag(item.key)}
                                      className="px-2 py-1 bg-green-500 hover:bg-green-600 text-white rounded text-xs"
                                    >
                                      ✓ Save
                                    </button>
                                    <button 
                                      onClick={() => { setResolvingFlagKey(null); setResolutionText(''); }}
                                      className="px-2 py-1 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded text-xs"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                ) : (
                                  <button 
                                    onClick={() => { setResolvingFlagKey(item.key); setResolutionText(''); }}
                                    className="px-2 py-1 bg-green-500 hover:bg-green-600 text-white rounded text-xs"
                                  >
                                    Resolve
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <p className="text-xs text-gray-500 mt-2 italic">
                        💡 Tip: Click "Resolve" to enter your answer/resolution. The question and answer will be preserved and visible at the original location.
                      </p>
                    </div>
                  )}
                </div>
              );
            })()}
            
            {/* Resolved Items - Collapsed by default */}
            {(() => {
              // Helper to get BS section name from key
              const getBsSectionName = (sectionKey) => {
                const sectionMap = { ca: 'Current Assets', fa: 'Fixed Assets', oa: 'Other Assets', cl: 'Current Liabilities', ltl: 'Long-Term Liabilities', eq: 'Equity' };
                return sectionMap[sectionKey] || 'Balance Sheet';
              };
              
              // Helper to find item name from BS arrays
              const findBsItemName = (sectionKey, itemId) => {
                const sectionMap = { ca: bsCurrentAssets, fa: bsFixedAssets, oa: bsOtherAssets, cl: bsCurrentLiabilities, ltl: bsLongTermLiabilities, eq: bsEquity };
                const items = sectionMap[sectionKey] || [];
                const item = items.find(i => String(i.id) === String(itemId));
                return item?.name || itemId;
              };
              
              const resolvedItems = [
                // Resolved Analyst Flags (with Q&A)
                ...Object.entries(manualReviewFlags)
                  .filter(([k, v]) => v?.resolved)
                  .map(([k, v]) => ({
                    key: `analyst-${k}`,
                    section: v.section || 'Analysis',
                    item: v.item || k,
                    question: monthlyTtmNotes[k] || 'No question recorded',
                    resolution: v.resolution || '',
                    resolvedDate: v.resolvedDate,
                    type: 'analyst'
                  })),
                // Completed Research Items (with Q&A)
                ...researchItems.filter(r => r.status === 'complete').map(r => ({
                  key: `research-${r.id}`,
                  section: r.source || 'Research',
                  item: r.item,
                  question: r.item,
                  resolution: r.resolution || r.notes || '',
                  resolvedDate: r.completedAt,
                  type: 'research'
                })),
                // Stale account items - with better descriptions
                ...Object.entries(bsIssueNotes).filter(([k, v]) => v.reviewed && k.startsWith('stale-')).map(([k, v]) => {
                  // Parse stale key: stale-{section}-{itemId}
                  const parts = k.split('-');
                  const sectionKey = parts[1];
                  const itemId = parts.slice(2).join('-');
                  return {
                    key: `bs-${k}`,
                    section: getBsSectionName(sectionKey),
                    item: v.itemName || findBsItemName(sectionKey, itemId),
                    issueType: v.issueType || 'Stale Account',
                    issueDetail: v.issueDetail || 'No change for 3+ years',
                    question: null,
                    resolution: v.notes,
                    resolvedDate: v.reviewedAt ? new Date(v.reviewedAt).toLocaleDateString() : v.reviewDate,
                    type: 'stale'
                  };
                }),
                // Other BS issue items (negative equity, etc)
                ...Object.entries(bsIssueNotes).filter(([k, v]) => v.reviewed && !k.startsWith('stale-')).map(([k, v]) => ({
                  key: `bs-${k}`,
                  section: 'Balance Sheet',
                  item: v.itemName || k,
                  issueType: v.issueType || 'Balance Sheet Issue',
                  issueDetail: v.issueDetail || '',
                  question: null,
                  resolution: v.notes,
                  resolvedDate: v.reviewedAt ? new Date(v.reviewedAt).toLocaleDateString() : v.reviewDate,
                  type: 'other'
                })),
                // Balance Sheet YoY variances resolved via status
                ...(() => {
                  const bsVarianceResolved = [];
                  const bsVarianceThreshold = monthlyTtmConfig.bsVarianceThreshold || 25;
                  const bsMaterialityThreshold = monthlyTtmConfig.bsMaterialityThreshold || 5000;
                  const bsPeriods = [
                    { key: 'year1', label: bsYearLabels.year1 || 'Year 1' },
                    { key: 'year2', label: bsYearLabels.year2 || 'Year 2' },
                    { key: 'year3', label: bsYearLabels.year3 || 'Year 3' },
                    { key: 'interim', label: bsYearLabels.interim || 'Interim' }
                  ];
                  const calcVar = (c, p) => p === 0 ? (c === 0 ? 0 : 100) : ((c - p) / Math.abs(p)) * 100;
                  
                  const checkSection = (items, sectionName, sectionKey) => {
                    items.filter(item => item.name).forEach(item => {
                      const noteKey = `bs_${sectionKey}_${item.id}`;
                      const statusData = bsVarianceStatus[noteKey] || { status: 'unreviewed' };
                      
                      // Check if item has been resolved (explained or waived)
                      if (statusData.status === 'explained' || statusData.status === 'waived') {
                        // Collect all variances for this item
                        const periodVariances = [];
                        bsPeriods.forEach((period, idx) => {
                          if (idx > 0) {
                            const val = item[period.key] || 0;
                            const priorVal = item[bsPeriods[idx - 1].key] || 0;
                            const variance = calcVar(val, priorVal);
                            const varianceAbs = val - priorVal;
                            if (Math.abs(variance) >= bsVarianceThreshold && Math.abs(varianceAbs) >= bsMaterialityThreshold) {
                              periodVariances.push(`${bsPeriods[idx-1].label}→${period.label}: ${variance > 0 ? '+' : ''}${variance.toFixed(0)}%`);
                            }
                          }
                        });
                        
                        // Check for stale
                        const isStale = item.year1 !== 0 && item.year1 === item.year2 && item.year2 === item.year3;
                        if (isStale) {
                          periodVariances.push(`Stale ($${item.year1?.toLocaleString() || 0})`);
                        }
                        
                        // Create ONE resolved entry if there were any issues
                        if (periodVariances.length > 0) {
                          bsVarianceResolved.push({
                            key: `bsvar-${noteKey}`,
                            section: sectionName,
                            item: item.name,
                            issueType: statusData.status === 'waived' ? 'Waived' : 'BS Variance',
                            issueDetail: periodVariances.join(', '),
                            resolution: monthlyTtmNotes[noteKey] || '',
                            resolvedDate: null,
                            type: 'bsvariance'
                          });
                        }
                      }
                    });
                  };
                  
                  checkSection(bsCurrentAssets, 'Current Assets', 'ca');
                  checkSection(bsFixedAssets, 'Fixed Assets', 'fa');
                  checkSection(bsOtherAssets, 'Other Assets', 'oa');
                  checkSection(bsCurrentLiabilities, 'Current Liabilities', 'cl');
                  checkSection(bsLongTermLiabilities, 'Long-Term Liabilities', 'ltl');
                  checkSection(bsEquity, 'Equity', 'eq');
                  
                  // Check grand totals
                  const checkGrandTotalResolved = (calcKey, label, noteKey) => {
                    const statusData = bsVarianceStatus[noteKey] || { status: 'unreviewed' };
                    if (statusData.status === 'explained' || statusData.status === 'waived') {
                      const periodVariances = [];
                      bsPeriods.forEach((period, idx) => {
                        if (idx > 0) {
                          const val = balanceSheetCalcs[period.key]?.[calcKey] || 0;
                          const priorVal = balanceSheetCalcs[bsPeriods[idx - 1].key]?.[calcKey] || 0;
                          const variance = calcVar(val, priorVal);
                          const varianceAbs = val - priorVal;
                          if (Math.abs(variance) >= bsVarianceThreshold && Math.abs(varianceAbs) >= bsMaterialityThreshold) {
                            periodVariances.push(`${bsPeriods[idx-1].label}→${period.label}: ${variance > 0 ? '+' : ''}${variance.toFixed(0)}%`);
                          }
                        }
                      });
                      if (periodVariances.length > 0) {
                        bsVarianceResolved.push({
                          key: `bsvar-${noteKey}`,
                          section: 'Totals',
                          item: label,
                          issueType: statusData.status === 'waived' ? 'Waived' : 'BS Variance',
                          issueDetail: periodVariances.join(', '),
                          resolution: monthlyTtmNotes[noteKey] || '',
                          resolvedDate: null,
                          type: 'bsvariance'
                        });
                      }
                    }
                  };
                  
                  checkGrandTotalResolved('totalAssets', 'TOTAL ASSETS', 'bs_total_assets');
                  checkGrandTotalResolved('totalLiabilities', 'TOTAL LIABILITIES', 'bs_total_liabilities');
                  checkGrandTotalResolved('totalEquity', 'TOTAL EQUITY', 'bs_total_equity');
                  
                  return bsVarianceResolved;
                })(),
                ...Object.entries(bsRecognitionNotes).filter(([k, v]) => v.reviewed).map(([k, v]) => ({
                  key: `rec-${k}`,
                  section: 'Revenue Recognition',
                  item: v.itemName || k,
                  issueType: v.issueType || 'Recognition Review',
                  issueDetail: v.issueDetail || '',
                  question: null,
                  resolution: v.notes,
                  resolvedDate: v.reviewDate,
                  type: 'other'
                })),
                ...Object.entries(custRevenueNotes).filter(([k, v]) => v.reviewed).map(([k, v]) => ({
                  key: `cust-${k}`,
                  section: 'Customer Revenue',
                  item: v.itemName || k,
                  issueType: v.issueType || 'Revenue Variance',
                  issueDetail: v.issueDetail || '',
                  question: null,
                  resolution: v.notes,
                  resolvedDate: v.reviewDate,
                  type: 'other'
                })),
                ...outstandingAnalysis.acknowledgedFlagsList.map(f => ({
                  key: f.key,
                  section: f.category,
                  item: f.item,
                  issueType: 'Dismissed',
                  issueDetail: f.detail || '',
                  question: null,
                  resolution: f.resolution,
                  resolvedDate: f.date,
                  type: 'other'
                }))
              ];
              
              if (resolvedItems.length === 0) return null;
              
              // Group by type for better organization
              const analystAndResearch = resolvedItems.filter(r => r.type === 'analyst' || r.type === 'research');
              const otherItems = resolvedItems.filter(r => r.type !== 'analyst' && r.type !== 'research');
              
              return (
                <div className="mb-4 border rounded-lg overflow-hidden border-green-200">
                  <button 
                    onClick={() => toggleIssuesSection('resolved')}
                    className="w-full flex items-center justify-between p-3 bg-green-50 hover:bg-green-100 transition-colors"
                  >
                    <h3 className="font-bold text-green-800 flex items-center gap-2">
                      <span className="text-lg">{issuesSections.resolved ? '▼' : '▶'}</span>
                      ✓ Resolved Items ({resolvedItems.length})
                    </h3>
                    <span className="text-sm text-green-600">Previously addressed questions and issues</span>
                  </button>
                  {issuesSections.resolved && (
                    <div className="p-3 bg-white max-h-96 overflow-y-auto">
                      {/* Analyst Flags & Research with Q&A format.
                          Rendered as stacked full-width blocks (not a narrow
                          multi-column table) so extensive questions AND answers
                          stay readable — owner answers via the portal are often
                          long, and a fixed Q/Resolution column would crush them.
                          The question text is shown ONCE (for research items the
                          old Item + Question columns were the same field). */}
                      {analystAndResearch.length > 0 && (
                        <div className="mb-4">
                          <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Questions & Answers</div>
                          <div className="space-y-2">
                            {analystAndResearch.map((item, idx) => (
                              <div key={item.key || idx} className={`rounded border p-2.5 ${item.type === 'analyst' ? 'bg-purple-50/50 border-purple-100' : 'bg-blue-50/50 border-blue-100'}`}>
                                <div className="flex items-center justify-between mb-1.5">
                                  <span className="text-xs text-gray-500 flex items-center gap-1">
                                    <span>{item.type === 'analyst' ? '🚩' : '🔍'}</span>
                                    {item.section}
                                  </span>
                                  <span className="text-xs text-green-600">{item.resolvedDate || '✓ Resolved'}</span>
                                </div>
                                <div className="text-xs text-gray-800 whitespace-pre-line break-words">
                                  <span className="font-semibold text-gray-400 mr-1">Q:</span>{item.question || item.item}
                                </div>
                                <div className="text-xs text-green-800 mt-1.5 whitespace-pre-line break-words">
                                  <span className="font-semibold text-green-600 mr-1">A:</span>{item.resolution || '—'}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      {/* Other resolved items */}
                      {otherItems.length > 0 && (
                        <div>
                          <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Reviewed & Resolved Items</div>
                          <table className="w-full text-xs border-collapse">
                            <thead className="bg-green-50">
                              <tr>
                                <th className="p-2 border text-left w-28">Section</th>
                                <th className="p-2 border text-left">Item</th>
                                <th className="p-2 border text-left w-24">Issue Type</th>
                                <th className="p-2 border text-left">Issue Detail</th>
                                <th className="p-2 border text-left">Resolution/Notes</th>
                                <th className="p-2 border text-center w-20">Resolved</th>
                              </tr>
                            </thead>
                            <tbody>
                              {otherItems.map((item, idx) => (
                                <tr key={item.key || idx} className={`${item.type === 'stale' ? 'bg-orange-50/50' : item.type === 'bsvariance' ? 'bg-blue-50/50' : 'bg-green-50/50'}`}>
                                  <td className="p-1 border text-gray-500">
                                    {item.type === 'stale' && <span className="mr-1">⚠️</span>}
                                    {item.type === 'bsvariance' && <span className="mr-1">📊</span>}
                                    {item.section}
                                  </td>
                                  <td className="p-1 border font-medium">{item.item}</td>
                                  <td className="p-1 border text-gray-600">{item.issueType || '-'}</td>
                                  <td className="p-1 border text-gray-600">{item.issueDetail || '-'}</td>
                                  <td className="p-1 border text-green-700">{item.resolution || '-'}</td>
                                  <td className="p-1 border text-center text-green-600">{item.resolvedDate || '✓'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        ) : viewMode === 'benchmarks' ? (
          <div>
            <h2 className="text-lg font-bold mb-2 flex items-center gap-2"><Database className="w-5 h-5" /> Industry Benchmarks Reference</h2>
            
            {/* Explanation */}
            <div className="mb-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <h3 className="font-semibold text-blue-800 mb-2">📖 How Benchmarks Are Used</h3>
              <p className="text-sm text-blue-700 mb-3">
                The Multiple Engine compares your company's actual performance against these industry benchmarks to calculate quality factor adjustments. 
                Better-than-benchmark performance earns positive adjustments; worse-than-benchmark performance results in negative adjustments.
              </p>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="bg-white p-3 rounded border">
                  <div className="font-semibold text-gray-700 mb-1">Metrics Compared:</div>
                  <ul className="text-gray-600 space-y-1">
                    <li>• <strong>Recurring Revenue %</strong> - vs your weighted recurring mix</li>
                    <li>• <strong>Customer Retention</strong> - vs your Net Revenue Retention</li>
                    <li>• <strong>EBITDA Margin</strong> - vs your normalized margins</li>
                    <li>• <strong>Revenue Growth</strong> - vs your YoY growth trajectory</li>
                  </ul>
                </div>
                <div className="bg-white p-3 rounded border">
                  <div className="font-semibold text-gray-700 mb-1">Industry Adjustment:</div>
                  <p className="text-gray-600 mb-2">
                    Each industry has a base multiple adjustment reflecting its relative attractiveness to buyers 
                    (growth potential, scalability, risk profile).
                  </p>
                  <div className="text-xs text-gray-500">
                    To change your industry, go to <strong>Setup → Deal Profile</strong>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Current Selection - Read Only */}
            <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-sm text-green-700">Currently Selected:</span>
                  <span className="ml-2 font-bold text-green-800 text-lg">{selectedIndustryObj?.name || 'None selected'}</span>
                </div>
                {selectedIndustryObj && (
                  <div className="text-right">
                    <div className="text-sm text-green-700">Industry Adjustment</div>
                    <div className={`text-xl font-bold ${selectedIndustryObj.adjustment > 0 ? 'text-green-600' : selectedIndustryObj.adjustment < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                      {selectedIndustryObj.adjustment >= 0 ? '+' : ''}{selectedIndustryObj.adjustment.toFixed(2)}x
                    </div>
                  </div>
                )}
              </div>
              {!selectedIndustryObj && (
                <p className="text-sm text-amber-600 mt-2">⚠️ No industry selected. Go to Setup → Deal Profile to select your industry.</p>
              )}
            </div>
            
            {/* Benchmark Tables - Read Only */}
            <div className="text-xs text-gray-500 mb-2">Reference: All industries and their benchmark values (your selected industry is highlighted)</div>
            {industrySectors.map(sector => (
              <div key={sector.id} className="mb-4">
                <h3 className="font-bold text-gray-700 mb-2 bg-gray-100 p-2 rounded">{sector.name}</h3>
                <table className="w-full text-sm border-collapse">
                  <thead><tr className="bg-gray-50"><th className="p-2 border text-left">Industry</th><th className="p-2 border text-center">Adjustment</th><th className="p-2 border text-center">Recurring %</th><th className="p-2 border text-center">Retention</th><th className="p-2 border text-center">EBITDA Margin</th><th className="p-2 border text-center">Growth</th></tr></thead>
                  <tbody>
                    {sector.industries.map(ind => (
                      <tr key={ind.id} className={selectedIndustry === ind.id ? 'bg-blue-100 border-l-4 border-l-blue-500' : 'hover:bg-gray-50'}>
                        <td className={`p-2 border ${selectedIndustry === ind.id ? 'font-bold' : 'font-semibold'}`}>
                          {ind.name}
                          {selectedIndustry === ind.id && <span className="ml-2 text-green-600 text-xs">← Selected</span>}
                        </td>
                        <td className={`p-2 border text-center font-bold ${ind.adjustment > 0 ? 'text-green-600' : ind.adjustment < 0 ? 'text-red-600' : ''}`}>{ind.adjustment >= 0 ? '+' : ''}{ind.adjustment.toFixed(2)}x</td>
                        <td className="p-2 border text-center">{ind.benchmarks.recurringRevenuePct}%</td>
                        <td className="p-2 border text-center">{ind.benchmarks.customerRetentionRate}%</td>
                        <td className="p-2 border text-center">{ind.benchmarks.ebitdaMargin}%</td>
                        <td className="p-2 border text-center">{ind.benchmarks.industryGrowthRate}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        ) : viewMode === 'proforma' ? (
          /* ========== PRO FORMA ENTRY TAB ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold flex items-center gap-2">📊 Pro Forma Adjustments</h2>
              <datalist id="pf-sales-customers">
                {(customerSalesData || []).filter(c => c && c.name && !isRemainderRow(c)).map(c => <option key={c.id || c.name} value={c.name} />)}
              </datalist>
              <button
                onClick={() => setProFormaItems([...proFormaItems, { 
                  id: Date.now(), 
                  type: 'acquisition', 
                  name: '', 
                  effectiveDate: '', 
                  annualRevenue: '', 
                  annualEbitda: '', 
                  ebitdaMargin: '', 
                  useMargin: false, 
                  retentionPct: 85, 
                  notes: '',
                  valuationCreditOverride: null
                }])}
                className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
              >
                + Add Adjustment
              </button>
            </div>
            
            {/* Auto-populate from Lost Clients */}
            {(() => {
              const residualLost = (keyMetrics.lostWithResidualTTM || []);
              const residualRev = keyMetrics.lostResidualRevenue || 0;
              if (residualLost.length === 0) return null;
              
              // Check if already populated (any existing lostclient items with matching names)
              const existingLostNames = proFormaItems.filter(p => p.type === 'lostclient').map(p => p.name.toLowerCase());
              const alreadyPopulated = residualLost.some(c => existingLostNames.includes((c.name || '').toLowerCase()));
              
              const margin = keyMetrics.ebitdaMargin || 0;
              const BIG_THRESHOLD = 25000; // Individual entry if > $25K TTM
              const bigClients = residualLost.filter(c => (c.ttm || 0) >= BIG_THRESHOLD).sort((a, b) => (b.ttm || 0) - (a.ttm || 0));
              const smallClients = residualLost.filter(c => (c.ttm || 0) < BIG_THRESHOLD);
              const smallTotal = smallClients.reduce((s, c) => s + (c.ttm || 0), 0);
              
              const handlePopulate = () => {
                const newItems = [];
                let idCounter = Date.now();
                
                // Individual entries for big clients
                bigClients.forEach(c => {
                  newItems.push({
                    id: idCounter++,
                    type: 'lostclient',
                    name: c.name || 'Lost Client',
                    effectiveDate: '',
                    annualRevenue: Math.round(c.ttm || 0).toString(),
                    annualEbitda: '',
                    ebitdaMargin: margin.toFixed(1),
                    useMargin: true,
                    revenueBasis: 'ttm', ebitdaMode: 'flowthrough',
                    retentionPct: 100,
                    notes: `Owner confirmed lost. TTM revenue: ${formatCurrency(c.ttm || 0)}`,
                    valuationCreditOverride: null
                  });
                });
                
                // One consolidated entry for smaller clients
                if (smallClients.length > 0 && smallTotal > 0) {
                  newItems.push({
                    id: idCounter++,
                    type: 'lostclient',
                    name: `${smallClients.length} smaller lost clients (consolidated)`,
                    effectiveDate: '',
                    annualRevenue: Math.round(smallTotal).toString(),
                    annualEbitda: '',
                    ebitdaMargin: margin.toFixed(1),
                    useMargin: true,
                    revenueBasis: 'ttm', ebitdaMode: 'flowthrough',
                    retentionPct: 100,
                    notes: `${smallClients.length} clients under ${formatCurrency(BIG_THRESHOLD)} each. Total TTM: ${formatCurrency(smallTotal)}`,
                    valuationCreditOverride: null
                  });
                }
                
                setProFormaItems([...proFormaItems, ...newItems]);
              };
              
              return (
                <div className="mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-amber-600 text-lg">⚠️</span>
                      <div>
                        <div className="font-semibold text-amber-800">
                          {residualLost.length} Lost Client{residualLost.length !== 1 ? 's' : ''} Still in TTM — {formatCurrency(residualRev)} to adjust
                        </div>
                        <div className="text-xs text-amber-700 mt-0.5">
                          {bigClients.length > 0 && <span>{bigClients.length} client{bigClients.length !== 1 ? 's' : ''} over {formatCurrency(BIG_THRESHOLD)} will get individual entries. </span>}
                          {smallClients.length > 0 && <span>{smallClients.length} smaller client{smallClients.length !== 1 ? 's' : ''} ({formatCurrency(smallTotal)}) consolidated into one entry. </span>}
                          EBITDA margin {margin.toFixed(1)}% applied.
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={handlePopulate}
                      disabled={alreadyPopulated}
                      className={`px-4 py-2 rounded text-sm font-semibold whitespace-nowrap ${alreadyPopulated ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-amber-600 hover:bg-amber-700 text-white'}`}
                    >
                      {alreadyPopulated ? '✓ Already Added' : `Populate ${bigClients.length + (smallClients.length > 0 ? 1 : 0)} Entries`}
                    </button>
                  </div>
                  {bigClients.length > 0 && (
                    <div className="mt-2 grid grid-cols-3 gap-x-4 gap-y-1 text-xs text-amber-700">
                      {bigClients.slice(0, 9).map((c, i) => (
                        <div key={i} className="flex justify-between">
                          <span className="truncate mr-2">{c.name || 'Unnamed'}</span>
                          <span className="font-medium">{formatCurrency(c.ttm || 0)}</span>
                        </div>
                      ))}
                      {bigClients.length > 9 && <div className="text-amber-500">+{bigClients.length - 9} more</div>}
                    </div>
                  )}
                </div>
              );
            })()}
            
            {/* Valuation Basis Toggle */}
            {proFormaItems.length > 0 && (
              <div className="mb-4 p-3 bg-gradient-to-r from-gray-100 to-green-50 rounded-lg border">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm font-bold text-gray-700">Valuation Basis</div>
                    <div className="text-xs text-gray-500">Choose how to value the combined entity</div>
                  </div>
                  <div className="flex bg-white rounded-lg p-1 shadow-sm border">
                    <button
                      onClick={() => setProFormaValuationBasis('historical')}
                      className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
                        proFormaValuationBasis === 'historical' 
                          ? 'bg-gray-700 text-white shadow-sm' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Historical
                    </button>
                    <button
                      onClick={() => setProFormaValuationBasis('weighted')}
                      className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
                        proFormaValuationBasis === 'weighted' 
                          ? 'bg-gray-600 text-white shadow-sm' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Weighted
                    </button>
                    <button
                      onClick={() => setProFormaValuationBasis('proforma')}
                      className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
                        proFormaValuationBasis === 'proforma' 
                          ? 'bg-green-600 text-white shadow-sm' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Pro Forma
                    </button>
                  </div>
                </div>
                <div className="mt-2 grid grid-cols-3 gap-4 text-xs">
                  <div className={`p-2 rounded ${proFormaValuationBasis === 'historical' ? 'bg-gray-200' : 'bg-white'}`}>
                    <div className="font-medium text-gray-700">Historical</div>
                    <div className="text-gray-500">EBITDA: {formatCurrency(proFormaCalcs.historicalTTMEbitda)}</div>
                  </div>
                  <div className={`p-2 rounded ${proFormaValuationBasis === 'weighted' ? 'bg-gray-200' : 'bg-white'}`}>
                    <div className="font-medium text-gray-700">Weighted</div>
                    <div className="text-gray-500">EBITDA: {formatCurrency(proFormaCalcs.weightedTTMEbitda)}</div>
                  </div>
                  <div className={`p-2 rounded ${proFormaValuationBasis === 'proforma' ? 'bg-green-100' : 'bg-white'}`}>
                    <div className="font-medium text-green-700">Pro Forma</div>
                    <div className="text-gray-500">EBITDA: {formatCurrency(proFormaCalcs.proFormaTTMEbitda)}</div>
                  </div>
                </div>
              </div>
            )}
            
            <div className="p-3 bg-blue-50 border border-blue-200 rounded mb-4">
              <div className="text-sm text-blue-800">
                <strong>📌 Purpose:</strong> Add recent acquisitions, new major clients, or other adjustments to create a pro forma run-rate view. 
                This keeps historical financials clean while showing the combined entity's projected performance.
              </div>
              <div className="text-xs text-blue-600 mt-2">
                TTM Period: <strong>{proFormaCalcs.ttmPeriod?.label || 'Not configured'}</strong> • 
                Effective dates within this period will be prorated automatically.
              </div>
            </div>
            
            {proFormaItems.length === 0 ? (
              <div className="p-8 text-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                <div className="text-gray-400 text-4xl mb-2">📊</div>
                <div className="text-gray-600 font-medium">No Pro Forma Adjustments</div>
                <div className="text-gray-500 text-sm mt-1">Click "+ Add Adjustment" to add an acquisition or new client</div>
              </div>
            ) : (
              <div className="space-y-4">
                {proFormaItems.map((item, idx) => {
                  const calc = proFormaCalcs.items?.find(c => c.id === item.id) || {};
                  return (
                    <div key={item.id} className="border rounded-lg overflow-hidden">
                      <div className="bg-gray-100 px-4 py-2 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <span className="font-bold text-gray-600">#{idx + 1}</span>
                          <select
                            value={item.type}
                            onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, type: e.target.value, retentionPct: e.target.value === 'acquisition' ? 85 : (e.target.value === 'lostclient' ? 100 : 90)} : p))}
                            className="p-1.5 border rounded text-sm font-medium"
                          >
                            <option value="acquisition">🏢 Acquisition</option>
                            <option value="newclient">👤 New Major Client</option>
                            <option value="lostclient">📉 Lost Client</option>
                            <option value="pricechange">💰 Price Change</option>
                            <option value="other">📋 Other</option>
                          </select>
                          <input
                            type="text"
                            value={item.name}
                            onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, name: e.target.value} : p))}
                            placeholder={item.type === 'acquisition' ? 'Acquired company name...' : item.type === 'newclient' ? 'Client name...' : item.type === 'lostclient' ? 'Pick the client from the sales report…' : 'Description...'}
                            list={item.type === 'lostclient' ? 'pf-sales-customers' : undefined}
                            className="p-1.5 border rounded text-sm w-64"
                          />
                        </div>
                        <button
                          onClick={() => setProFormaItems(proFormaItems.filter(p => p.id !== item.id))}
                          className="text-red-500 hover:text-red-700 text-sm"
                        >
                          ✕ Remove
                        </button>
                      </div>
                      
                      <div className="p-4">
                        <div className="grid grid-cols-5 gap-4 mb-4">
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">{item.type === 'lostclient' ? 'Date lost (last revenue)' : 'Effective Date'}</label>
                            <input
                              type="date"
                              value={item.effectiveDate}
                              onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, effectiveDate: e.target.value} : p))}
                              className="w-full p-2 border rounded text-sm"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">{item.type === 'lostclient' && calc.revenueBasis === 'ttm' ? 'Their revenue in the TTM' : 'Annual Revenue'}</label>
                            <div className="relative">
                              <span className="absolute left-2 top-2 text-gray-400">$</span>
                              <input
                                type="number"
                                value={calc.fromSales ? Math.round(calc.revenueUsed || 0) : item.annualRevenue}
                                readOnly={!!calc.fromSales}
                                onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, annualRevenue: e.target.value} : p))}
                                placeholder="0"
                                className={`w-full p-2 pl-5 border rounded text-sm text-right ${calc.fromSales ? 'bg-gray-100 text-gray-700' : ''}`}
                              />
                            </div>
                            {item.type === 'lostclient' && (
                              <div className="text-xs mt-0.5">
                                {calc.fromSales ? (
                                  <span className="text-green-700">From the TTM sales report · <button type="button" className="underline text-gray-500" onClick={() => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, salesSource: 'typed', annualRevenue: p.annualRevenue || String(Math.round(calc.revenueUsed || 0))} : p))}>type my own</button></span>
                                ) : calc.salesMatchName ? (
                                  <span className="text-amber-700">Typed (sales report: {formatCurrency(calc.salesMatchTtm || 0)}) · <button type="button" className="underline" onClick={() => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, salesSource: 'sales'} : p))}>use the sales report</button></span>
                                ) : (item.name || '').trim() ? (
                                  <span className="text-gray-500">Not in the TTM sales report — pick the name from the list to pull the exact amount</span>
                                ) : null}
                              </div>
                            )}
                            {item.type === 'lostclient' && !calc.fromSales && (
                              <select
                                value={calc.revenueBasis || 'annual'}
                                onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, revenueBasis: e.target.value} : p))}
                                className="w-full mt-1 p-1 border rounded text-xs"
                                title="TTM actual = what they billed inside the TTM (customer detail) — removed in full, no proration. Annual run-rate = a yearly amount, prorated TTM start → date lost."
                              >
                                <option value="ttm">TTM actual (from client detail)</option>
                                <option value="annual">Annual run-rate (prorate by date)</option>
                              </select>
                            )}
                          </div>
                          {item.type === 'lostclient' ? (
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">EBITDA impact</label>
                            <select
                              value={calc.ebitdaMode || 'flowthrough'}
                              onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, ebitdaMode: e.target.value} : p))}
                              className="w-full p-2 border rounded text-sm"
                              title="Overhead stays = techs, rent and admin don't drop on day one, so the gross profit falls to the bottom line (what a buyer's QoE assumes). Costs come out = staff/overhead cut with the revenue — say which in Notes."
                            >
                              <option value="flowthrough">Overhead stays — lose gross profit ({(calc.ttmGrossMargin || 0).toFixed(1)}%)</option>
                              <option value="margin">Costs come out — lose EBITDA margin</option>
                              <option value="runrate">Post-loss run rate (actual months since)</option>
                              <option value="custom">Custom $</option>
                            </select>
                            {calc.ebitdaMode === 'runrate' && (
                              <div className="text-xs mt-1 text-gray-600">{calc.runrateCovered ? 'Covered by the run-rate on the latest lost client' : calc.runRate && calc.runRate.ok ? `Avg ${formatCurrency(calc.runRate.avgMonthly)}/mo × ${calc.runRate.months} months since → ${formatCurrency(calc.runRate.annual)}/yr` : `Needs 6+ months after the date lost (has ${calc.runRate ? calc.runRate.months : 0}) — using overhead stays`}</div>
                            )}
                            {calc.ebitdaMode === 'margin' && (
                              <div className="relative mt-1">
                                <input type="number" value={item.ebitdaMargin}
                                  onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, ebitdaMargin: e.target.value} : p))}
                                  placeholder={(calc.lostMarginPct || 0).toFixed(1)}
                                  className="w-full p-1.5 border rounded text-sm text-right pr-6" />
                                <span className="absolute right-2 top-1.5 text-gray-400 text-sm">%</span>
                              </div>
                            )}
                            {calc.ebitdaMode === 'custom' && (
                              <div className="relative mt-1">
                                <span className="absolute left-2 top-1.5 text-gray-400 text-sm">$</span>
                                <input type="number" value={item.annualEbitda}
                                  onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, annualEbitda: e.target.value} : p))}
                                  placeholder="EBITDA lost per year"
                                  className="w-full p-1.5 pl-5 border rounded text-sm text-right" />
                              </div>
                            )}
                          </div>
                          ) : (
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1 flex items-center gap-2">
                              {item.useMargin ? 'EBITDA Margin %' : 'Annual EBITDA'}
                              <button
                                onClick={() => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, useMargin: !p.useMargin} : p))}
                                className="text-xs text-blue-600 hover:underline"
                              >
                                (use {item.useMargin ? '$' : '%'})
                              </button>
                            </label>
                            <div className="relative">
                              {!item.useMargin && <span className="absolute left-2 top-2 text-gray-400">$</span>}
                              <input
                                type="number"
                                value={item.useMargin ? item.ebitdaMargin : item.annualEbitda}
                                onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? 
                                  (p.useMargin ? {...p, ebitdaMargin: e.target.value} : {...p, annualEbitda: e.target.value}) : p))}
                                placeholder="0"
                                className={`w-full p-2 ${item.useMargin ? '' : 'pl-5'} border rounded text-sm text-right`}
                              />
                              {item.useMargin && <span className="absolute right-2 top-2 text-gray-400">%</span>}
                            </div>
                          </div>
                          )}
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Retention %</label>
                            <div className="relative">
                              <input
                                type="number"
                                value={item.retentionPct}
                                onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, retentionPct: e.target.value} : p))}
                                min="0"
                                max="100"
                                className="w-full p-2 border rounded text-sm text-right pr-6"
                              />
                              <span className="absolute right-2 top-2 text-gray-400">%</span>
                            </div>
                            <div className="text-xs text-gray-400 mt-0.5">Default: {item.type === 'acquisition' ? '85%' : '90%'}</div>
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Months in TTM</label>
                            <div className="p-2 bg-gray-100 rounded text-sm text-right font-medium">
                              {calc.monthsInTTM || 0} mo{!item.effectiveDate && calc.monthsInTTM === 12 && ' (Full Year)'}
                            </div>
                            <div className="text-xs text-gray-400 mt-0.5">
                              {item.type === 'lostclient' ? (calc.revenueBasis === 'ttm' ? 'TTM actual — removed in full (date not used)' : item.effectiveDate ? 'Their revenue in the TTM: TTM start → date lost' : 'No date = full year removed') : (item.effectiveDate ? 'Auto-calculated from date' : 'No date = full year included')}
                            </div>
                          </div>
                        </div>
                        
                        {/* Valuation Credit Section */}
                        <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded">
                          <div className="flex items-center justify-between">
                            <div>
                              <div className="text-xs font-medium text-amber-800 mb-1">⚖️ Valuation Credit (for Weighted basis)</div>
                              <div className="text-xs text-amber-600">
                                {item.type === 'acquisition' ? 'Acquisitions receive 100% credit (contracted revenue)' :
                                 item.type === 'lostclient' ? 'Lost clients receive 100% credit (certain impact)' :
                                 item.type === 'pricechange' ? `Price changes: ${calc.monthsSeasoned >= 1 ? '90%' : '50%'} based on implementation` :
                                 `Based on ${calc.monthsSeasoned || 0} months seasoned`}
                              </div>
                            </div>
                            <div className="flex items-center gap-3">
                              <div className="text-center">
                                <div className="text-xs text-gray-500 mb-1">Auto</div>
                                <div className={`px-3 py-1 rounded font-bold text-sm ${
                                  calc.autoValuationCredit === 100 ? 'bg-green-100 text-green-800' :
                                  calc.autoValuationCredit >= 75 ? 'bg-blue-100 text-blue-800' :
                                  calc.autoValuationCredit >= 50 ? 'bg-amber-100 text-amber-800' :
                                  'bg-red-100 text-red-800'
                                }`}>
                                  {calc.autoValuationCredit || 100}%
                                </div>
                              </div>
                              <div className="text-center">
                                <div className="text-xs text-gray-500 mb-1">Override</div>
                                <input
                                  type="number"
                                  value={item.valuationCreditOverride ?? ''}
                                  onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {
                                    ...p, 
                                    valuationCreditOverride: e.target.value === '' ? null : parseFloat(e.target.value)
                                  } : p))}
                                  placeholder="—"
                                  min="0"
                                  max="100"
                                  className="w-16 p-1 border rounded text-sm text-center"
                                />
                              </div>
                              <div className="text-center">
                                <div className="text-xs text-gray-500 mb-1">Used</div>
                                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded font-bold text-sm">
                                  {calc.valuationCredit || 100}%
                                </div>
                              </div>
                            </div>
                          </div>
                          {item.type !== 'acquisition' && item.type !== 'lostclient' && (
                            <div className="mt-2 text-xs text-amber-700 border-t border-amber-200 pt-2">
                              <strong>Seasoning guide:</strong> 12+ mo = 100% | 9-12 mo = 90% | 6-9 mo = 75% | 3-6 mo = 50% | 1-3 mo = 30% | &lt;1 mo = 15%
                            </div>
                          )}
                        </div>
                        
                        <div className="mb-3">
                          <label className="block text-xs font-medium text-gray-600 mb-1">Notes</label>
                          <input
                            type="text"
                            value={item.notes}
                            onChange={e => setProFormaItems(proFormaItems.map(p => p.id === item.id ? {...p, notes: e.target.value} : p))}
                            placeholder="Additional context about this adjustment..."
                            className="w-full p-2 border rounded text-sm"
                          />
                        </div>
                        
                        {/* Calculated Values Preview */}
                        {(calc.monthsToAdd > 0 || (calc.proratedEbitda || 0) !== 0) && (() => {
                          const isLost = item.type === 'lostclient';
                          const creditLabel = isLost ? 'Certainty' : 'Retention';
                          return (
                          <div className={`${isLost ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'} border rounded p-3`}>
                            <div className={`text-xs font-medium ${isLost ? 'text-red-800' : 'text-green-800'} mb-2`}>
                              {isLost ? '📉 Removed from TTM (lowers the valuation)' : '📊 Calculated Contribution'}
                            </div>
                            <div className="grid grid-cols-4 gap-4 text-sm">
                              <div>
                                <div className="text-xs text-gray-500">{isLost ? 'Revenue Removed' : 'Prorated Revenue'}</div>
                                <div className="font-medium">{formatCurrency(calc.proratedRevenue || 0)}</div>
                              </div>
                              <div>
                                <div className="text-xs text-gray-500">After {item.retentionPct}% {creditLabel}</div>
                                <div className={`font-medium ${isLost ? 'text-red-700' : 'text-green-700'}`}>{formatCurrency(calc.adjustedRevenue || 0)}</div>
                              </div>
                              <div>
                                <div className="text-xs text-gray-500">{isLost ? 'EBITDA Removed' : 'Prorated EBITDA'}</div>
                                <div className="font-medium">{formatCurrency(calc.proratedEbitda || 0)}</div>
                              </div>
                              <div>
                                <div className="text-xs text-gray-500">After {item.retentionPct}% {creditLabel}</div>
                                <div className={`font-medium ${isLost ? 'text-red-700' : 'text-green-700'}`}>{formatCurrency(calc.adjustedEbitda || 0)}</div>
                              </div>
                            </div>
                            {isLost && calc.flowEbitda != null && (
                              <div className="mt-2 pt-2 border-t border-red-200 text-xs text-gray-700">
                                <span className="font-medium">EBITDA lost, either way:</span>{' '}
                                <span className={calc.ebitdaMode === 'flowthrough' ? 'font-bold text-red-700' : ''}>Overhead stays {formatCurrency(calc.flowEbitda)} ({(calc.ttmGrossMargin || 0).toFixed(1)}% gross margin)</span>
                                {' · '}
                                <span className={calc.ebitdaMode === 'margin' ? 'font-bold text-red-700' : ''}>Costs come out {formatCurrency(calc.marginEbitda)} ({(calc.lostMarginPct || 0).toFixed(1)}% EBITDA margin)</span>
                                {calc.ebitdaMode === 'custom' && <span className="font-bold text-red-700">{' · '}Custom {formatCurrency(calc.proratedEbitda || 0)}</span>}
                                {calc.runRate && calc.runRate.ok && <span className={calc.ebitdaMode === 'runrate' ? 'font-bold text-red-700' : ''}>{' · '}Post-loss run rate {formatCurrency(calc.runRate.delta)} ({calc.runRate.months} mo actual: {formatCurrency(calc.runRate.annual)}/yr vs TTM {formatCurrency(calc.runRate.ttmAdjEbitda)})</span>}
                                <div className="text-gray-500 mt-0.5">Bold = used. State the assumption in the memorandum; "costs come out" needs the cut named in Notes. The run rate is actual post-loss performance (it reflects every change since, not only this client).</div>
                              </div>
                            )}
                          </div>
                          );
                        })()}
                      </div>
                    </div>
                  );
                })}
                
                {/* Summary */}
                {proFormaItems.length > 0 && (
                  <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <h3 className="font-bold text-blue-800 mb-3">Pro Forma Summary</h3>
                    <div className="grid grid-cols-2 gap-6">
                      <div>
                        <div className="text-sm font-medium text-gray-600 mb-2">TTM Contribution (Prorated)</div>
                        <table className="w-full text-sm">
                          <tbody>
                            <tr>
                              <td className="py-1">Historical TTM Revenue</td>
                              <td className="py-1 text-right font-medium">{formatCurrency(proFormaCalcs.historicalTTMRevenue)}</td>
                            </tr>
                            <tr className="text-green-700">
                              <td className="py-1">+ Pro Forma Additions</td>
                              <td className="py-1 text-right font-medium">+{formatCurrency(proFormaCalcs.totalProratedRevenue)}</td>
                            </tr>
                            <tr className="border-t font-bold">
                              <td className="py-1">Pro Forma TTM Revenue</td>
                              <td className="py-1 text-right">{formatCurrency(proFormaCalcs.proFormaTTMRevenue)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-gray-600 mb-2">EBITDA Impact</div>
                        <table className="w-full text-sm">
                          <tbody>
                            <tr>
                              <td className="py-1">Historical TTM EBITDA</td>
                              <td className="py-1 text-right font-medium">{formatCurrency(proFormaCalcs.historicalTTMEbitda)}</td>
                            </tr>
                            <tr className="text-green-700">
                              <td className="py-1">+ Pro Forma Additions</td>
                              <td className="py-1 text-right font-medium">+{formatCurrency(proFormaCalcs.totalProratedEbitda)}</td>
                            </tr>
                            <tr className="border-t font-bold">
                              <td className="py-1">Pro Forma TTM EBITDA</td>
                              <td className="py-1 text-right">{formatCurrency(proFormaCalcs.proFormaTTMEbitda)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    
                    <div className="mt-4 pt-3 border-t border-blue-200">
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-blue-700">View detailed analysis →</span>
                        <button
                          onClick={() => setViewMode('proformaanalysis')}
                          className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                        >
                          Go to Pro Forma Analysis
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            

          </div>
        ) : viewMode === 'discovery' ? (
          /* ========== DISCOVERY TAB ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold flex items-center gap-2">🔍 Discovery</h2>
              
              {/* Sub-tabs */}
              <div className="flex bg-gray-100 rounded-lg p-1">
                <button
                  onClick={() => setDiscoverySubTab('questions')}
                  className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${
                    discoverySubTab === 'questions' 
                      ? 'bg-white text-blue-700 shadow-sm' 
                      : 'text-gray-600 hover:text-gray-800'
                  }`}
                >
                  ❓ Questions ({outstandingAnalysis.qaTotal - outstandingAnalysis.qaAnswered} pending)
                </button>
                <button
                  onClick={() => setDiscoverySubTab('documents')}
                  className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${
                    discoverySubTab === 'documents' 
                      ? 'bg-white text-blue-700 shadow-sm' 
                      : 'text-gray-600 hover:text-gray-800'
                  }`}
                >
                  📁 Documents ({documentChecklist.filter(d => d.status !== 'complete').length} needed)
                </button>
              </div>
            </div>
            
            {/* Questions Sub-tab */}
            {discoverySubTab === 'questions' && (
            <>
            {/* Owner's portal signals — pinned ABOVE the questions so the Lead
                has them during the discovery call (Mark 2026-07-24): target
                date, intent/priority chips, and how far the owner got in the
                portal questionnaire. "No date given" is itself information. */}
            {(() => {
              const intentLabel = { planning_ahead: 'Planning ahead', selling_soon: 'Thinking of selling soon', quick_estimate: 'Wants a quick estimate' }[workflow.owner_intent] || '';
              const priorityLabel = { price: 'The right price', timing: 'The right timing', add_value: 'Strategy to add value' }[workflow.owner_priority] || '';
              let lean = '';
              if (workflow.owner_intent === 'quick_estimate') lean = 'leans Quick Estimation (Partial)';
              else if (workflow.owner_priority === 'add_value' || workflow.owner_intent === 'planning_ahead') lean = 'leans Strategic Review — value now, then grow it';
              else if (workflow.owner_intent === 'selling_soon') lean = 'leans Full Valuation / engage';
              const answered = (ownerPortalAnswers || []).filter(a => a && a.question_type === 'discovery' && String(a.answer || '').trim()).length;
              const targetD = workflow.owner_target_valuation_date
                ? new Date(workflow.owner_target_valuation_date + 'T00:00:00').toLocaleDateString()
                : null;
              return (
                <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="text-sm font-bold text-blue-800 mb-1.5">🧭 Owner's portal signals — before you talk</div>
                  <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-gray-700">
                    <span>🎯 <span className="font-semibold">{targetD ? `Wants to discuss value by ${targetD}` : 'No target date given'}</span>{!targetD && <span className="text-gray-400"> — worth asking about timing</span>}</span>
                    <span>💬 {intentLabel || priorityLabel
                      ? <span className="font-semibold">{[intentLabel, priorityLabel].filter(Boolean).join(' · ')}</span>
                      : <span className="text-gray-400">No intent/priority tapped in the portal</span>}
                      {lean && <span className="text-blue-700"> — {lean}</span>}</span>
                    <span>❓ <span className="font-semibold">{answered} of {sellerQA.length}</span> portal questions answered{answered === 0 && <span className="text-gray-400"> — expect to cover them live</span>}</span>
                  </div>
                  <div className="text-[10px] text-gray-400 mt-1">Soft reads from the owner's portal taps — not commitments. The lean mirrors the Activate modal's read.</div>
                </div>
              );
            })()}
            {/* Owner answers submitted via the portal — accept into the Q&A.
                DISCOVERY-questionnaire answers only; ad-hoc Ask-Owner answers now
                surface inline in the Research Items table (Analysis tab), right
                next to the question Colleen wrote, so they're intentionally
                excluded here to avoid showing them in two places. (2026-06-29) */}
            {(() => {
              const pending = (ownerPortalAnswers || []).filter(a => {
                if (!a || !a.answer) return false;
                if (a.question_type !== 'discovery') return false;
                if (!(a.answer != null && String(a.answer).trim())) return false;
                const qa = sellerQA.find(q => String(q.id) === String(a.question_key));
                if (!qa) return false;
                // Surface the owner's answer whenever it differs from what the
                // QA row carries — status alone must never hide their words
                // (Colleen 2026-07-31: questions sat "answered" with the portal
                // answer invisible anywhere in VT, so she re-asked questions the
                // owner had already answered). Also lets an owner's UPDATED
                // answer resurface for a fresh review-and-accept.
                return String(qa.answer || '').trim() !== String(a.answer).trim();
              });
              if (pending.length === 0) return null;
              return (
                <div className="mb-4 p-3 bg-sky-50 border border-sky-200 rounded-lg">
                  <div className="text-sm font-bold text-sky-800 mb-2">📥 Owner answered via the portal ({pending.length}) — review &amp; accept</div>
                  <div className="space-y-2">
                    {pending.map((a, i) => {
                      const isDisc = a.question_type === 'discovery';
                      const item = isDisc
                        ? sellerQA.find(q => String(q.id) === String(a.question_key))
                        : researchItems.find(r => String(r.id) === String(a.question_key));
                      const qText = isDisc ? (item && item.question) : (item && (item.item || item.question));
                      return (
                        <div key={i} className="bg-white border border-sky-100 rounded p-2 text-xs">
                          <div className="font-semibold text-gray-700">{qText || '(question)'}</div>
                          <div className="text-gray-800 mt-1 whitespace-pre-line">“{a.answer}”</div>
                          <div className="flex items-center gap-2 mt-1.5">
                            <button
                              onClick={() => {
                                if (isDisc) {
                                  setSellerQA(prev => prev.map(q => {
                                    if (String(q.id) !== String(a.question_key)) return q;
                                    const upd = { ...q, answer: a.answer, status: 'answered' };
                                    // Select-style questions DISPLAY via numericValue —
                                    // map the accepted text onto an option so the row
                                    // shows what the owner actually said (label match,
                                    // then containment, then percent-in-range).
                                    if (Array.isArray(q.selectOptions) && q.selectOptions.length) {
                                      const al = String(a.answer || '').toLowerCase().trim();
                                      let opt = q.selectOptions.find(o => o.label.toLowerCase() === al)
                                        || q.selectOptions.find(o => al.includes(o.label.toLowerCase()) || o.label.toLowerCase().includes(al));
                                      if (!opt) {
                                        const pm = al.match(/(\d+)\s*[-–]\s*(\d+)|(\d+)\s*%/);
                                        if (pm) {
                                          const pv = pm[3] ? parseInt(pm[3], 10) : (parseInt(pm[1], 10) + parseInt(pm[2], 10)) / 2;
                                          opt = q.selectOptions.find(o => {
                                            const rm = o.label.match(/(\d+)\s*[-–]\s*(\d+)/);
                                            return rm && pv >= parseInt(rm[1], 10) && pv <= parseInt(rm[2], 10);
                                          });
                                        }
                                      }
                                      if (opt) upd.numericValue = opt.value;
                                    }
                                    return upd;
                                  }));
                                } else {
                                  setResearchItems(prev => prev.map(r => String(r.id) === String(a.question_key) ? { ...r, response: a.answer, status: 'complete', resolvedAt: new Date().toLocaleDateString() } : r));
                                }
                                setHasUnsavedChanges(true);
                              }}
                              className="px-2 py-1 bg-sky-600 text-white rounded text-xs font-medium hover:bg-sky-700"
                            >Accept into {isDisc ? 'answer' : 'note'}</button>
                            <span className="text-gray-400">{a.answered_at ? new Date(a.answered_at).toLocaleDateString() : ''}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
            {/* Progress Summary */}
            <div className="mb-4 p-3 bg-blue-100 rounded-lg">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">{outstandingAnalysis.qaAnswered}</div>
                    <div className="text-xs text-gray-600">Answered</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-gray-600">{outstandingAnalysis.qaTotal - outstandingAnalysis.qaAnswered}</div>
                    <div className="text-xs text-gray-600">Pending</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-amber-600">{sellerQA.filter(q => q.status === 'follow-up').length}</div>
                    <div className="text-xs text-gray-600">Follow-up</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-gray-800">{outstandingAnalysis.qaTotal}</div>
                    <div className="text-xs text-gray-600">Total</div>
                  </div>
                </div>
                <div className="w-48 bg-gray-200 rounded-full h-3">
                  <div 
                    className="bg-blue-600 h-3 rounded-full transition-all" 
                    style={{ width: `${outstandingAnalysis.qaTotal > 0 ? (outstandingAnalysis.qaAnswered / outstandingAnalysis.qaTotal) * 100 : 0}%` }}
                  />
                </div>
              </div>
              
              {/* Copy Buttons Row */}
              <div className="flex gap-2 pt-2 border-t border-blue-200">
                {/* Copy Pending Questions */}
                <button
                  onClick={() => {
                    const unanswered = sellerQA.filter(q => q.status === 'pending');
                    if (unanswered.length === 0) {
                      alert('No pending questions to copy.');
                      return;
                    }
                    let text = '';
                    unanswered.forEach((q, idx) => {
                      text += `${idx + 1}. ${q.question}\n`;
                    });
                    navigator.clipboard.writeText(text.trim()).then(() => {
                      setCopySuccess('pending');
                      setTimeout(() => setCopySuccess(false), 2000);
                    }).catch(() => {
                      const textarea = document.createElement('textarea');
                      textarea.value = text.trim();
                      document.body.appendChild(textarea);
                      textarea.select();
                      document.execCommand('copy');
                      document.body.removeChild(textarea);
                      setCopySuccess('pending');
                      setTimeout(() => setCopySuccess(false), 2000);
                    });
                  }}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-1 ${
                    copySuccess === 'pending'
                      ? 'bg-green-500 text-white'
                      : 'bg-white text-blue-700 hover:bg-blue-50 border border-blue-300'
                  }`}
                >
                  {copySuccess === 'pending' ? '✓ Copied!' : `📋 Copy Pending Questions (${sellerQA.filter(q => q.status === 'pending').length})`}
                </button>
                
                {/* Copy Follow-up Questions */}
                <button
                  onClick={() => {
                    const followups = sellerQA.filter(q => q.status === 'follow-up');
                    if (followups.length === 0) {
                      alert('No follow-up questions to copy.');
                      return;
                    }
                    let text = '';
                    followups.forEach((q, idx) => {
                      text += `${idx + 1}. ${q.question}\n`;
                      if (q.answer) text += `   Previous answer: ${q.answer}\n`;
                      text += '\n';
                    });
                    navigator.clipboard.writeText(text.trim()).then(() => {
                      setCopySuccess('followup');
                      setTimeout(() => setCopySuccess(false), 2000);
                    }).catch(() => {
                      const textarea = document.createElement('textarea');
                      textarea.value = text.trim();
                      document.body.appendChild(textarea);
                      textarea.select();
                      document.execCommand('copy');
                      document.body.removeChild(textarea);
                      setCopySuccess('followup');
                      setTimeout(() => setCopySuccess(false), 2000);
                    });
                  }}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-1 ${
                    copySuccess === 'followup'
                      ? 'bg-green-500 text-white'
                      : 'bg-white text-amber-700 hover:bg-amber-50 border border-amber-300'
                  }`}
                >
                  {copySuccess === 'followup' ? '✓ Copied!' : `📋 Copy Follow-ups (${sellerQA.filter(q => q.status === 'follow-up').length})`}
                </button>
                
                <div className="ml-auto flex gap-2">
                  {/* Download Template */}
                  <button
                    onClick={() => {
                      // Section definitions
                      const sections = [
                        { id: 'foundational', label: '1. Foundational' },
                        { id: 'business_model', label: '2. Business Model' },
                        { id: 'operations', label: '3. Operations' },
                        { id: 'owner', label: '4. Owner Involvement' },
                        { id: 'financial', label: '5. Financial / Accounting Practices' },
                        { id: 'real_estate', label: '6. Real Estate' }
                      ];
                      
                      // RTF escape function — also converts non-ASCII (em-dash, smart quotes, etc.)
                      // to RTF unicode escapes so they don't render as mojibake under \ansi.
                      const rtfEscape = (str) => str
                        .replace(/\\/g, '\\\\')
                        .replace(/\{/g, '\\{')
                        .replace(/\}/g, '\\}')
                        .replace(/\n/g, '\\par ')
                        .replace(/[-￿]/g, (ch) => {
                          let code = ch.charCodeAt(0);
                          if (code > 32767) code -= 65536; // RTF uses signed 16-bit code points
                          return '\\u' + code + '?';
                        });
                      
                      // Build RTF document
                      let rtf = '{\\rtf1\\ansi\\deff0';
                      
                      // Font table
                      rtf += '{\\fonttbl{\\f0\\fswiss\\fcharset0 Arial;}}';
                      
                      // Color table (Vista green, gray, etc.)
                      rtf += '{\\colortbl;\\red61\\green92\\blue53;\\red102\\green102\\blue102;\\red245\\green245\\blue245;\\red255\\green255\\blue255;}';
                      
                      // Document formatting
                      rtf += '\\paperw12240\\paperh15840\\margl1440\\margr1440\\margt1440\\margb1440';
                      
                      // Title
                      rtf += '\\pard\\qc\\sb0\\sa200{\\f0\\fs36\\b\\cf1 Discovery Questionnaire}\\par';
                      rtf += '\\pard\\qc\\sb0\\sa400{\\f0\\fs22\\i\\cf2 Confidential Business Information}\\par';
                      
                      // Instructions
                      rtf += '\\pard\\sb200\\sa200\\box\\brdrs\\brdrw10\\brsp100\\cbpat3';
                      rtf += '{\\f0\\fs24\\b Instructions}\\par';
                      rtf += '{\\f0\\fs22 Please answer each question below. Your responses will help us understand your business and prepare an accurate valuation.}\\par';
                      rtf += '{\\f0\\fs22 Type your answer directly below each question. When complete, save the document and return it to your Vista Business Group representative.}\\par';
                      rtf += '\\pard\\sa300\\par';
                      
                      // Add each section with questions
                      let questionNum = 1;
                      sections.forEach((section, sectionIdx) => {
                        const sectionQuestions = sellerQA.filter(q => q.section === section.id).sort((a, b) => a.id - b.id);
                        
                        if (sectionQuestions.length > 0) {
                          // Section header (green background) - keep with next
                          rtf += '\\pard\\keepn\\sb300\\sa200\\cbpat1{\\f0\\fs26\\b\\cf4  ' + rtfEscape(section.label) + '}\\par';
                          
                          // Questions in this section
                          sectionQuestions.forEach(q => {
                            // Question - keepn keeps it with the answer box
                            rtf += '\\pard\\keepn\\sb200\\sa100{\\f0\\fs24\\b ' + questionNum + '. }{\\f0\\fs24 ' + rtfEscape(q.question) + '}\\par';
                            
                            if (q.inputType === 'select' && q.selectOptions && q.selectOptions.length > 0) {
                              // Multiple choice — list each option with a checkbox square
                              rtf += '\\pard\\keep\\sb100\\sa200\\box\\brdrs\\brdrw10\\brsp100\\cbpat3';
                              q.selectOptions.forEach(opt => {
                                rtf += '{\\f0\\fs22 \\u9744? ' + rtfEscape(opt.label || opt) + '}\\line';
                              });
                              rtf += '\\par';
                            } else {
                              // Answer box - keep prevents breaking within the box
                              rtf += '\\pard\\keep\\sb100\\sa200\\box\\brdrs\\brdrw10\\brsp100\\cbpat3';
                              rtf += '{\\f0\\fs22\\cf2 Answer: }\\line';
                              rtf += '\\line';
                              rtf += '\\line';
                              rtf += '\\par';
                            }
                            
                            questionNum++;
                          });
                        }
                      });
                      
                      // Thank you note
                      rtf += '\\pard\\sb400\\sa200\\box\\brdrs\\brdrw10\\brsp100';
                      rtf += '{\\f0\\fs24\\b Thank you! }{\\f0\\fs22 Your detailed responses help us provide the most accurate valuation and find the right buyer for your business. All information is kept strictly confidential.}\\par';
                      
                      // Footer
                      rtf += '\\pard\\sb400\\qc{\\f0\\fs24\\b\\cf1 Vista Business Group}\\par';
                      rtf += '\\pard\\qc{\\f0\\fs20\\cf2 Questions? Contact your Vista advisor.}\\par';
                      
                      rtf += '}';
                      
                      // Download as RTF (opens in Word)
                      const blob = new Blob([rtf], { type: 'application/rtf' });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = 'Vista-Discovery-Questionnaire.rtf';
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }}
                    className="px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-1 bg-purple-600 text-white hover:bg-purple-700"
                  >
                    📋 Download Questionnaire
                  </button>
                  
                  {/* Paste Answers from Word */}
                  <button
                    onClick={() => {
                      setPasteAnswersText('');
                      setPasteAnswersPreview([]);
                      setPasteAnswersSkipped([]);
                      setShowPasteAnswersModal(true);
                    }}
                    className="px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-1 bg-white text-green-700 hover:bg-green-50 border border-green-300"
                  >
                    📥 Paste Answers
                  </button>
                </div>
              </div>
            </div>
            
            {/* Section definitions */}
            {(() => {
              const sections = [
                { id: 'foundational', label: '1. Foundational / Why', icon: '🎯', color: 'indigo' },
                { id: 'business_model', label: '2. Business Model', icon: '📊', color: 'blue' },
                { id: 'operations', label: '3. Operations', icon: '⚙️', color: 'gray' },
                { id: 'owner', label: '4. Owner Involvement', icon: '👤', color: 'purple' },
                { id: 'financial', label: '5. Financial / Accounting', icon: '📑', color: 'green' },
                { id: 'real_estate', label: '6. Real Estate', icon: '🏢', color: 'orange' }
              ];
              
              const colorClasses = {
                indigo: { bg: 'bg-blue-50', border: 'border-blue-200', header: 'text-blue-800 border-blue-300' },
                blue: { bg: 'bg-blue-100', border: 'border-blue-300', header: 'text-blue-800 border-blue-400' },
                gray: { bg: 'bg-slate-50', border: 'border-slate-200', header: 'text-slate-800 border-slate-300' },
                purple: { bg: 'bg-slate-100', border: 'border-slate-300', header: 'text-slate-800 border-slate-400' },
                green: { bg: 'bg-blue-50', border: 'border-blue-200', header: 'text-blue-800 border-blue-300' },
                orange: { bg: 'bg-slate-100', border: 'border-slate-300', header: 'text-slate-700 border-slate-400' }
              };
              
              const questionDisplayNumbers = discoveryDisplayNumbers(sellerQA);
              
              return (
                <div className="space-y-4">
                  {sections.map(section => {
                    const sectionQuestions = sellerQA.filter(qa => qa.section === section.id).sort((a, b) => a.id - b.id);
                    if (sectionQuestions.length === 0) return null;
                    const colors = colorClasses[section.color];
                    
                    return (
                      <div key={section.id} className={`p-3 rounded-lg border ${colors.bg} ${colors.border}`}>
                        <h3 className={`font-bold mb-2 border-b pb-1 ${colors.header}`}>{section.icon} {section.label}</h3>
                        <div className="space-y-2">
                          {sectionQuestions.map((qa, idx) => (
                            <div key={qa.id} className={`p-2 rounded border ${qa.status === 'answered' ? 'bg-blue-100 border-blue-300' : qa.status === 'follow-up' ? 'bg-amber-50 border-amber-300' : 'bg-white border-gray-300'}`}>
                              <div className="flex items-start gap-2">
                                <select value={qa.status} onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, status: e.target.value} : q))} className={`text-xs p-1 rounded ${qa.status === 'answered' ? 'bg-blue-200' : qa.status === 'follow-up' ? 'bg-amber-200' : 'bg-gray-100'}`}>
                                  <option value="pending">Pending</option>
                                  <option value="answered">Answered</option>
                                  <option value="follow-up">Follow-up</option>
                                </select>
                                <div className="flex-1">
                                  <div className="font-medium text-sm text-gray-800">{questionDisplayNumbers[qa.id]}. {qa.question}</div>
                                  
                                  {/* Numeric input + text answer for questions with inputType */}
                                  {qa.inputType === 'select' && qa.selectOptions ? (
                                    <div className="flex gap-2 mt-1">
                                      <select
                                        value={qa.numericValue ?? ''}
                                        onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, numericValue: e.target.value !== '' ? parseFloat(e.target.value) : null} : q))}
                                        className="w-44 p-1.5 border rounded text-xs bg-white"
                                      >
                                        <option value="">Select...</option>
                                        {qa.selectOptions.map(opt => (
                                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                      </select>
                                      {/* The owner's full words land in answer (portal accept
                                          writes them there) — without this box the detail is
                                          stored but invisible (Colleen, Concise Computer
                                          Consulting: the select mapped, the elaboration lost). */}
                                      <textarea value={qa.answer} onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, answer: e.target.value} : q))} placeholder="Detail behind the selection (owner's words land here)..." className="flex-1 p-1 border rounded text-xs" rows={Math.max(2, (qa.answer || '').split('\n').length, Math.ceil((qa.answer || '').length / 70))} style={{resize: 'vertical', minHeight: '52px'}} />
                                    </div>
                                  ) : qa.inputType ? (
                                    <div className="flex gap-2 mt-1">
                                      <div className="flex items-center gap-1">
                                        {qa.inputLabel && <span className="text-xs text-gray-500">{qa.inputLabel}:</span>}
                                        <input 
                                          type="number" 
                                          value={qa.numericValue || ''} 
                                          onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, numericValue: e.target.value ? parseFloat(e.target.value) : null} : q))} 
                                          placeholder={qa.inputType === 'percent' ? '%' : '#'} 
                                          className="w-20 p-1 border rounded text-xs text-right"
                                        />
                                        {qa.inputType === 'percent' && <span className="text-xs text-gray-500">%</span>}
                                      </div>
                                      {/* Second numeric input if defined */}
                                      {qa.inputType2 && (
                                        <div className="flex items-center gap-1">
                                          {qa.inputLabel2 && <span className="text-xs text-gray-500">{qa.inputLabel2}:</span>}
                                          <input 
                                            type="number" 
                                            value={qa.numericValue2 || ''} 
                                            onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, numericValue2: e.target.value ? parseFloat(e.target.value) : null} : q))} 
                                            placeholder="#" 
                                            className="w-20 p-1 border rounded text-xs text-right"
                                          />
                                          {qa.inputType2 === 'percent' && <span className="text-xs text-gray-500">%</span>}
                                        </div>
                                      )}
                                      {/* Staff turnover flag for Q10 */}
                                      {qa.id === 10 && qa.numericValue > 0 && qa.numericValue2 > 0 && (qa.numericValue2 / qa.numericValue) > 0.15 && (
                                        <span className="text-xs text-amber-600 font-medium bg-amber-50 px-2 py-0.5 rounded">⚠️ {((qa.numericValue2 / qa.numericValue) * 100).toFixed(0)}% turnover</span>
                                      )}
                                      <textarea value={qa.answer} onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, answer: e.target.value} : q))} placeholder="Additional notes..." className="flex-1 p-1 border rounded text-xs" rows={Math.max(2, (qa.answer || '').split('\n').length, Math.ceil((qa.answer || '').length / 70))} style={{resize: 'vertical', minHeight: '52px'}} />
                                    </div>
                                  ) : (
                                    <textarea value={qa.answer} onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, answer: e.target.value} : q))} placeholder="Enter answer..." className="w-full mt-1 p-1 border rounded text-xs" rows={Math.max(3, (qa.answer || '').split('\n').length, Math.ceil((qa.answer || '').length / 70))} style={{resize: 'vertical', minHeight: '60px'}} />
                                  )}
                                  
                                  {qa.id === 10 && (() => {
                                    const yearOptions = [['year1', basisYearLabels.year1], ['year2', basisYearLabels.year2], ['year3', basisYearLabels.year3], ['year4', basisYearLabels.year4], ['year5', basisYearLabels.year5]]
                                      .filter(([yk, label]) => label && (revenueCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0) || opexCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0)))
                                      .map(([, label]) => String(label)).concat(['TTM']);
                                    const sal = opexCategories.find(c => c.name && /salar|wage|payroll/i.test(c.name));
                                    // WHICH PERIOD (Mark 10-07): the owner's answer is "today" + "last 12 months" as of the day they
                                    // answered; the positions table is per P&L period. When the valuation also uses earlier years,
                                    // the owner was never asked about those — offer the follow-up question.
                                    const oa10 = (ownerPortalAnswers || []).find(a => a && a.question_type === 'discovery' && String(a.question_key) === '10');
                                    const asOf = oa10 && oa10.answered_at ? new Date(oa10.answered_at).toLocaleDateString() : null;
                                    const wm = valuationInputs.weightingMethod;
                                    const usedYears = wm === 'lastYear' ? [basisYearLabels.year5]
                                      : (wm === 'average' || wm === 'weighted') ? [valuationInputs.includeYear1 && basisYearLabels.year3, valuationInputs.includeYear2 && basisYearLabels.year4, valuationInputs.includeYear3 && basisYearLabels.year5] : [];
                                    const yrs = usedYears.filter(Boolean).map(String);
                                    const followQ = yrs.length ? `Did you add or eliminate any roles during ${yrs.join(', ')}? For each, the role, the annual pay, and roughly when it started or ended.` : '';
                                    const asked = followQ && (researchItems || []).some(r => r.item === followQ);
                                    return (
                                      <>
                                      <div className="mt-1 text-[11px] text-gray-600">
                                        <b>Period:</b> Total Employees = headcount <b>today</b>; Departures = the <b>last 12 months</b>{asOf ? <> — as of <b>{asOf}</b>, when the owner answered</> : <> — as of the day the owner answers</>}. The table below is <b>by P&L period</b> (pick the year on each row).
                                      </div>
                                      {followQ && (
                                        <div className="mt-1 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1 flex items-center gap-2 flex-wrap">
                                          <span>The owner's answer covers only the last 12 months, but this valuation also uses <b>{yrs.join(', ')}</b>. A hire or departure in those years wouldn't show up.</span>
                                          {asked ? <span className="text-gray-500">✓ in Ask Owner</span> : (
                                            <button type="button" className="px-2 py-0.5 rounded border border-amber-300 bg-white hover:bg-amber-100"
                                              title="Adds the question to Open Items → Ask Owner; edit it there, then 📨 Send owner questions."
                                              onClick={() => { setResearchItems([...(researchItems || []), { item: followQ, priority: 'medium', notes: 'From Q13 (headcount): earlier P&L years', askOwner: true, id: Math.max(...(researchItems || []).map(r => r.id || 0), 0) + 1, status: 'open' }]); setHasUnsavedChanges(true); }}>
                                              📧 Add as owner question
                                            </button>
                                          )}
                                        </div>
                                      )}
                                      <PositionsInPeriod positions={qa.positions} yearOptions={yearOptions} salaryLine={sal ? `OpEx: ${sal.name}` : 'OpEx: Salaries & Wages'}
                                        adjustmentItems={adjustmentItems} setAdjustmentItems={setAdjustmentItems}
                                        onChange={(next) => setSellerQA(prev => prev.map(q => q.id === 10 ? { ...q, positions: next } : q))} />
                                      </>
                                    );
                                  })()}
                                  {/* Keyword-based flag for questions like Q12 (family members) */}
                                  {qa.flagKeywords && qa.answer && qa.flagKeywords.some(kw => qa.answer.toLowerCase().includes(kw.toLowerCase())) && (
                                    <div className="text-xs text-amber-600 font-medium bg-amber-50 px-2 py-0.5 rounded mt-1 inline-block">⚠️ Review: may need adjustment</div>
                                  )}
                                  
                                  {qa.notes && <div className="text-xs text-gray-500 mt-1">💡 {qa.notes}</div>}
                                  
                                  {/* Follow-up questions */}
                                  {qa.followUps && qa.followUps.length > 0 && (
                                    <div className="ml-4 mt-2 space-y-1">
                                      {/* Reminder when follow-ups have answers */}
                                      {qa.followUps.some(fu => fu.answer && fu.answer.trim()) && (
                                        <div className="bg-amber-50 border border-amber-200 rounded p-2 mb-2">
                                          <div className="flex items-center justify-between gap-2">
                                            <div className="text-xs text-amber-700">
                                              <span className="font-semibold">⚠️ Important:</span> Follow-up answers are for reference only. The valuation engine reads from the <strong>main answer</strong> above. Click "Consolidate" to merge follow-up Q&A into the main answer.
                                            </div>
                                            <button 
                                              onClick={() => {
                                                const followUpText = qa.followUps
                                                  .filter(fu => fu.answer && fu.answer.trim())
                                                  .map(fu => `\n\n[Follow-up: ${fu.question}]\n${fu.answer}`)
                                                  .join('');
                                                if (followUpText) {
                                                  const updatedAnswer = (qa.answer || '') + followUpText;
                                                  setSellerQA(sellerQA.map(q => q.id === qa.id ? {
                                                    ...q, 
                                                    answer: updatedAnswer,
                                                    followUps: q.followUps.map(fu => ({...fu, status: 'answered'}))
                                                  } : q));
                                                }
                                              }}
                                              className="px-2 py-1 bg-amber-500 text-white rounded text-xs font-medium hover:bg-amber-600 whitespace-nowrap"
                                            >
                                              📥 Consolidate
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                      {qa.followUps.map(fu => (
                                        <div key={fu.id} className={`p-1 rounded text-xs ${fu.answer && fu.answer.trim() ? 'bg-amber-50 border border-amber-200' : 'bg-gray-50'}`}>
                                          <div className="flex items-center gap-2">
                                            <span className="text-gray-600">↳</span>
                                            <span className="font-medium">{fu.question}</span>
                                            <select value={fu.status} onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, followUps: q.followUps.map(f => f.id === fu.id ? {...f, status: e.target.value} : f)} : q))} className="text-xs p-0.5 rounded bg-gray-100 ml-auto">
                                              <option value="pending">Pending</option>
                                              <option value="answered">Answered</option>
                                            </select>
                                          </div>
                                          <input type="text" value={fu.answer} onChange={e => setSellerQA(sellerQA.map(q => q.id === qa.id ? {...q, followUps: q.followUps.map(f => f.id === fu.id ? {...f, answer: e.target.value} : f)} : q))} placeholder="Answer..." className="w-full mt-1 p-0.5 border rounded text-xs" />
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  
                                  {/* Add follow-up */}
                                  <div className="flex gap-1 mt-1">
                                    <input type="text" value={newFollowUp.qaId === qa.id ? newFollowUp.question : ''} onChange={e => setNewFollowUp({ qaId: qa.id, question: e.target.value })} placeholder="Add follow-up question..." className="flex-1 p-0.5 border rounded text-xs" />
                                    <button onClick={() => addFollowUp(qa.id)} className="px-2 py-0.5 bg-blue-500 text-white rounded text-xs">+</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
            </>
            )}
            
            {/* Documents Sub-tab */}
            {discoverySubTab === 'documents' && (
            <div className="bg-slate-50 p-4 rounded-lg border">
              {/* Tiered Approach Explanation */}
              <div className="mb-4 p-4 bg-gradient-to-r from-blue-50 to-green-50 border border-blue-200 rounded-lg">
                <div className="flex items-start gap-4">
                  <div className="flex-1">
                    <h4 className="font-bold text-gray-800 mb-2">📊 Valuation Accuracy & Document Requirements</h4>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div className="bg-white p-3 rounded border border-green-300">
                        <div className="font-semibold text-green-700 flex items-center gap-1">
                          <span className="text-lg">⚡</span> Quick Estimation
                        </div>
                        <div className="text-gray-600 mt-1">Minimum required documents:</div>
                        <ul className="text-xs text-gray-600 mt-1 space-y-0.5">
                          <li>• TTM P&L (monthly breakdown)</li>
                          <li>• TTM Balance Sheet (monthly breakdown)</li>
                        </ul>
                        <div className="text-xs text-green-600 mt-2 font-medium">Provides preliminary range estimate</div>
                      </div>
                      <div className="bg-white p-3 rounded border border-blue-300">
                        <div className="font-semibold text-blue-700 flex items-center gap-1">
                          <span className="text-lg">🎯</span> Full & Complete Valuation
                        </div>
                        <div className="text-gray-600 mt-1">All documents listed below</div>
                        <div className="text-xs text-gray-500 mt-1">Including historical financials, tax returns, customer data, and aging reports</div>
                        <div className="text-xs text-blue-600 mt-2 font-medium">Highest accuracy & defensible valuation</div>
                      </div>
                    </div>
                    <div className="text-xs text-gray-500 mt-3 italic">
                      💡 The more information you provide, the more accurate our valuation estimate becomes. Items marked with <span className="bg-green-100 text-green-700 px-1 rounded">MIN</span> are required for any estimate.
                    </div>
                  </div>
                </div>
              </div>

              {formsToAnnounce.length > 0 && (
                <div className="mb-4 bg-violet-50 border border-violet-200 rounded-lg px-4 py-3 flex items-center justify-between gap-3">
                  <div className="text-sm text-violet-800">
                    <strong>{formsToAnnounce.map(formsUnlockLabel).join(' + ')}</strong> just unlocked in the owner portal — it appears silently, so the owner won't know it's waiting until told.
                    {clientDetailSalesPending && (
                      <div className="text-xs text-amber-700 mt-1">⚠ The other sales report (5-year or TTM) isn't entered yet — the Client Detail form's client list re-ranks when it lands. If it's expected, enter it first and send one email; answers aren't lost either way, but the owner sees the list reshuffle.</div>
                    )}
                  </div>
                  <button
                    onClick={sendFormsUnlockedEmail}
                    className="px-3 py-2 rounded-lg text-sm font-medium bg-violet-600 text-white hover:bg-violet-700 whitespace-nowrap"
                    title="Review & send the heads-up email (sends as Konnie, portal button included)"
                  >📨 Tell the owner</button>
                </div>
              )}
              <div className="flex items-center justify-between mb-4 pb-3 border-b border-slate-200">
                <div>
                  <h3 className="font-bold text-gray-800 flex items-center gap-2">
                    📋 Document Checklist
                  </h3>
                  <div className="text-sm text-gray-500 mt-1">
                    {documentChecklist.filter(d => d.status === 'complete').length} of {documentChecklist.length} received • {documentChecklist.filter(d => d.status !== 'complete').length} still needed
                  </div>
                </div>
                <div className="flex gap-2">
                  {/* Preview OIR Button (Stage B3) */}
                  <button
                    onClick={previewOIR}
                    className="px-3 py-2 rounded-lg text-sm font-medium bg-emerald-600 text-white hover:bg-emerald-700 flex items-center gap-2"
                    title="Preview the Outstanding Items Report email — value range, accuracy %, and what's still needed"
                  >
                    📧 Preview OIR
                  </button>
                  {/* Send OIR Button (Stage B4) */}
                  <button
                    onClick={openOIRModal}
                    className="px-3 py-2 rounded-lg text-sm font-medium bg-emerald-700 text-white hover:bg-emerald-800 flex items-center gap-2"
                    title="Compose and send the Outstanding Items Report to the owner"
                  >
                    📨 Send OIR
                  </button>
                  {/* Download Template Button */}
                  <button
                    onClick={() => {
                      let text = "DOCUMENT REQUEST LIST\n";
                      text += "Vista Business Group\n";
                      text += "=" .repeat(50) + "\n\n";

                      // Partition: gated items (sent to owner later) vs. first-round items
                      const firstRound = documentChecklist.filter(d => !Array.isArray(d.unlockedBy) || d.unlockedBy.length === 0);
                      const secondRound = documentChecklist.filter(d => Array.isArray(d.unlockedBy) && d.unlockedBy.length > 0);

                      // Minimum Required (first round only — gated items are never tier='minimum')
                      text += "⚡ MINIMUM REQUIRED (for Quick Estimation):\n";
                      text += "-".repeat(40) + "\n";
                      firstRound.filter(d => d.tier === 'minimum').forEach((doc, idx) => {
                        text += `☐ ${doc.name}\n`;
                        if (doc.notes) text += `   Note: ${doc.notes}\n`;
                      });
                      text += "\n";

                      // Full Valuation — first round
                      text += "🎯 ADDITIONAL DOCUMENTS (for Full Valuation):\n";
                      text += "-".repeat(40) + "\n";
                      firstRound.filter(d => d.tier !== 'minimum').forEach((doc, idx) => {
                        text += `☐ ${doc.name}\n`;
                        if (doc.notes) text += `   Note: ${doc.notes}\n`;
                      });
                      text += "\n";

                      // Second round — prerequisite-gated items (sent after first-round items arrive)
                      if (secondRound.length > 0) {
                        text += "🔁 SECOND ROUND — PLEASE DON'T SEND YET:\n";
                        text += "-".repeat(40) + "\n";
                        text += "We'll generate these from your data and send them to you to fill in,\n";
                        text += "after we receive and enter the prerequisite reports above.\n\n";
                        secondRound.forEach((doc) => {
                          const prereqNames = (doc.unlockedBy || [])
                            .map(id => documentChecklist.find(d => d.id === id)?.name)
                            .filter(Boolean);
                          text += `☐ ${doc.name}\n`;
                          if (prereqNames.length > 0) {
                            text += `   We'll send this after we receive: ${prereqNames.join(' or ')}\n`;
                          }
                          if (doc.notes) text += `   Note: ${doc.notes}\n`;
                        });
                        text += "\n";
                      }

                      text += "=" .repeat(50) + "\n";
                      text += "The more information provided, the more accurate our valuation.\n";

                      navigator.clipboard.writeText(text).then(() => {
                        setCopySuccess('template');
                        setTimeout(() => setCopySuccess(false), 2000);
                      });
                    }}
                    className={`px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
                      copySuccess === 'template'
                        ? 'bg-green-500 text-white'
                        : 'bg-blue-500 text-white hover:bg-blue-600'
                    }`}
                  >
                    {copySuccess === 'template' ? '✓ Copied!' : '📄 Copy Full List'}
                  </button>
                  {/* Download Template Button */}
                  <button
                    onClick={() => {
                      // Generate HTML document request template
                      // Calculate dates using same logic as QB Guide
                      const _drNow = new Date();
                      const _drPriorMonth = new Date(_drNow.getFullYear(), _drNow.getMonth(), 0);
                      const _drTtmStart = new Date(_drPriorMonth.getFullYear(), _drPriorMonth.getMonth() - 11, 1);
                      const _drFmt = (d) => d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                      const _drFmtMonYr = (d) => d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
                      const _drTtmStartFmt = _drFmt(_drTtmStart);
                      const _drTtmEndFmt = _drFmt(_drPriorMonth);
                      const _drTtmStartMonYr = _drFmtMonYr(_drTtmStart);
                      const _drTtmEndMonYr = _drFmtMonYr(_drPriorMonth);
                      const _drCurrentYear = _drNow.getFullYear();
                      const _drAnnualStartYear = _drCurrentYear - 3;
                      const _drAnnualStartFmt = `01/01/${_drAnnualStartYear}`;
                      const _drAnnualEndFmt = _drFmt(_drPriorMonth);
                      const _drCustStartYear = _drCurrentYear - 5;
                      const _drCustStartFmt = `01/01/${_drCustStartYear}`;
                      const _drCustEndYear = _drCurrentYear - 1;
                      const _drCustEndFmt = `12/31/${_drCustEndYear}`;
                      const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Document Request - Vista Business Group</title>
  <style>
    @page { margin: 0.75in; }
    body { font-family: 'Segoe UI', Calibri, Arial, sans-serif; max-width: 850px; margin: 0 auto; padding: 40px 20px; color: #1f2937; line-height: 1.5; background: #fff; }
    
    /* Header styling to match QB Guide */
    .header-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
    .header-table td { vertical-align: middle; padding: 0; }
    .logo-cell { width: 80px; }
    .logo-cell img { width: 70px; height: 88px; }
    .title-cell { text-align: right; padding-right: 10px; }
    .title-cell h1 { color: #3D5C35; margin: 0; font-size: 28px; font-weight: 700; }
    .title-cell .subtitle { color: #6b7280; font-size: 14px; margin-top: 4px; }
    .header-line { border: none; border-top: 3px solid #3D5C35; margin: 15px 0 25px 0; }
    
    .intro-box { background: linear-gradient(135deg, #f0f4ef 0%, #e8f5e9 100%); border-left: 4px solid #3D5C35; padding: 15px 20px; margin-bottom: 25px; border-radius: 0 8px 8px 0; }
    .intro-box p { margin: 0; font-size: 14px; }
    
    .key-points { background: #fffbeb; border: 1px solid #f59e0b; padding: 15px; border-radius: 8px; margin-bottom: 30px; }
    .key-points h4 { color: #b45309; margin: 0 0 10px 0; font-size: 15px; }
    .key-points p { margin: 5px 0; font-size: 13px; }
    .key-points-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-top: 12px; }
    .key-point-card { background: white; padding: 12px; border-radius: 6px; border: 1px solid #e5e7eb; }
    .key-point-card h5 { margin: 0 0 6px 0; color: #3D5C35; font-size: 13px; }
    .key-point-card ul { margin: 0; padding-left: 18px; font-size: 12px; }
    .key-point-card li { margin-bottom: 3px; }
    .key-point-card .card-note { font-size: 11px; color: #6b7280; font-style: italic; margin-top: 8px; }
    
    .section-divider { background: linear-gradient(135deg, #3D5C35 0%, #4a7041 100%); color: white; padding: 10px 15px; margin: 30px 0 20px 0; border-radius: 6px; font-size: 16px; font-weight: 600; }
    
    .doc-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 13px; }
    .doc-table th { background: linear-gradient(135deg, #3D5C35 0%, #4a7041 100%); color: white; padding: 10px 12px; text-align: left; border: 1px solid #3D5C35; font-weight: 600; }
    .doc-table td { padding: 10px 12px; border: 1px solid #e5e7eb; vertical-align: top; }
    .doc-table tr:nth-child(even) td { background: #f9fafb; }
    .doc-table .checkbox { width: 30px; text-align: center; font-size: 16px; }
    .doc-table .doc-name { font-weight: 600; color: #1f2937; }
    .doc-table .doc-notes { font-size: 12px; color: #6b7280; }
    .doc-table .doc-notes em { color: #3D5C35; font-style: normal; font-weight: 500; }
    
    .format-box { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; margin: 25px 0; }
    .format-box h3 { color: #3D5C35; margin: 0 0 10px 0; font-size: 15px; }
    .format-box p { margin: 8px 0; font-size: 13px; }
    .format-box ul { margin: 8px 0; padding-left: 20px; font-size: 13px; }
    .format-box li { margin-bottom: 4px; }
    
    .note-box { background: #fffbeb; border: 1px solid #f59e0b; border-radius: 6px; padding: 12px 15px; margin: 20px 0; font-size: 13px; }
    .note-box strong { color: #b45309; }
    
    .confidential-box { background: linear-gradient(135deg, #f0f4ef 0%, #e8f5e9 100%); border: 1px solid #3D5C35; border-radius: 6px; padding: 12px 15px; margin: 25px 0; font-size: 13px; }
    .confidential-box strong { color: #3D5C35; }
    
    .footer { border-top: 2px solid #3D5C35; padding-top: 15px; margin-top: 30px; text-align: center; }
    .footer-text { color: #3D5C35; font-weight: 600; font-size: 14px; }
    .footer-sub { color: #6b7280; font-size: 12px; margin-top: 5px; }
    
    @media print { 
      body { margin: 0; padding: 20px; }
    }
  </style>
</head>
<body>
  <table class="header-table">
    <tr>
      <td class="logo-cell">
        <img src="${vistaLogoBase64}" alt="Vista Business Group" />
      </td>
      <td class="title-cell">
        <h1>Document Request</h1>
        <div class="subtitle">Business Valuation</div>
      </td>
    </tr>
  </table>
  <hr class="header-line" />
  
  <div class="intro-box">
    <p>Thank you for choosing Vista Business Group. An accurate valuation is more than a number — it is the foundation for every strategic decision you make about your business. The more information you provide, the more precisely we can assess your current value, identify opportunities to increase it, and deliver a clear roadmap to help you reach your goals.</p>
  </div>

  <!-- ACCURACY METER -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px 28px; margin-bottom: 24px; box-shadow: 0 1px 4px rgba(0,0,0,0.06);">
    <div style="text-align: center; margin-bottom: 18px;">
      <div style="font-size: 15px; font-weight: 700; color: #1f2937; letter-spacing: -0.01em;">The More You Share, The More We Can Help</div>
      <div style="font-size: 12px; color: #6b7280; margin-top: 5px;">Document completeness directly determines how accurate your valuation is — and how specific our strategic guidance can be</div>
    </div>
    <!-- Gradient bar with % markers -->
    <div style="position: relative; margin: 0 8px 32px 8px;">
      <div style="height: 20px; border-radius: 10px; background: linear-gradient(to right, #bbf7d0, #4ade80, #16a34a, #3D5C35); box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);"></div>
      <!-- % markers -->
      <div style="position: absolute; left: 20%; top: 0; height: 20px; border-left: 2px solid rgba(0,0,0,0.25);"></div>
      <div style="position: absolute; left: 50%; top: 0; height: 20px; border-left: 2px solid rgba(0,0,0,0.25);"></div>
      <div style="position: absolute; left: 75%; top: 0; height: 20px; border-left: 2px solid rgba(0,0,0,0.25);"></div>
      <div style="position: absolute; right: 0; top: 0; height: 20px; border-left: 2px solid rgba(0,0,0,0.35);"></div>
      <!-- Labels below bar -->
      <div style="position: absolute; left: 0; top: 26px; font-size: 11px; color: #374151; font-weight: 600;">~40%</div>
      <div style="position: absolute; left: 16%; top: 26px; font-size: 10px; color: #6b7280;">Preliminary</div>
      <div style="position: absolute; left: 44%; top: 26px; font-size: 11px; color: #374151; font-weight: 600;">~70%</div>
      <div style="position: absolute; left: 60%; top: 26px; font-size: 10px; color: #6b7280; display: none;">Core</div>
      <div style="position: absolute; left: 70%; top: 26px; font-size: 11px; color: #374151; font-weight: 600;">~85%</div>
      <div style="position: absolute; right: 2px; top: 26px; font-size: 11px; color: #3D5C35; font-weight: 700;">100%</div>
    </div>
    <div style="padding: 12px 14px; background: #f9fafb; border-radius: 8px; border: 1px solid #e5e7eb; margin-top: 8px;">
      <p style="margin: 0; font-size: 12px; color: #374151; line-height: 1.6;">A preliminary valuation tells you where you stand today. A complete picture tells us <em>why</em> — which gives us the ability to show you specifically where value can be built, what changes will move the needle most, and what a realistic path to your goal looks like. We will work with whatever you can provide and tell you exactly what each additional document unlocks.</p>
    </div>
  </div>

  <div class="section-divider">⚡ Minimum Required</div>
  <p style="font-size: 13px; margin-bottom: 15px;">These 4 documents are all we need to get started. With these alone we can establish an initial value range and begin identifying opportunities.</p>

  <table class="doc-table">
    <tr><th class="checkbox">☐</th><th>Document</th><th>Details / Notes</th></tr>
    <tr>
      <td class="checkbox">☐</td>
      <td class="doc-name">TTM P&amp;L (monthly breakdown) — Cash &amp; Accrual</td>
      <td class="doc-notes">Trailing 12 months, month-by-month • Cash AND Accrual basis<br><em>Format: Excel (.xlsx)</em><br><em>Date range: ${_drTtmStartFmt} through ${_drTtmEndFmt}</em></td>
    </tr>
    <tr>
      <td class="checkbox">☐</td>
      <td class="doc-name">TTM Balance Sheet (monthly breakdown)</td>
      <td class="doc-notes">Trailing 12 months, month-by-month • Accrual basis<br><em>Format: Excel (.xlsx)</em><br><em>Date range: ${_drTtmStartFmt} through ${_drTtmEndFmt}</em></td>
    </tr>
    <tr>
      <td class="checkbox">☐</td>
      <td class="doc-name">Sales Report by Customer (TTM) (monthly breakdown) — Cash &amp; Accrual</td>
      <td class="doc-notes">Current period customer breakdown<br><em>Excel format required</em><br><em>Date range: ${_drTtmStartFmt} through ${_drTtmEndFmt}</em></td>
    </tr>
    <tr>
      <td class="checkbox">☐</td>
      <td class="doc-name">Discovery Questionnaire</td>
      <td class="doc-notes">See accompanying Discovery Questions document<br>Your answers help us understand operations, risks, and value drivers</td>
    </tr>
  </table>

  <div class="section-divider">📊 Core Financial History</div>
  <p style="font-size: 13px; margin-bottom: 15px;">These documents give us the historical context to understand trends, validate current performance, and identify specific drivers of value in your business.</p>
  
  <table class="doc-table">
    <tr><th class="checkbox">☐</th><th>Document</th><th>Details / Notes</th></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Accrual P&amp;L Statements (3 years)</td><td class="doc-notes">Accrual basis • Excel format<br><em>Date range: ${_drAnnualStartFmt} through ${_drAnnualEndFmt}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Cash P&amp;L Statements (3 years)</td><td class="doc-notes">Cash basis • Excel format<br><em>Date range: ${_drAnnualStartFmt} through ${_drAnnualEndFmt}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Balance Sheets (3 years + Interim)</td><td class="doc-notes">Accrual basis • Excel format<br><em>Date range: ${_drAnnualStartFmt} through ${_drAnnualEndFmt}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Tax Returns (3 years)</td><td class="doc-notes">Complete business tax returns with all schedules<br><em>${_drAnnualStartYear}, ${_drAnnualStartYear + 1}, ${_drAnnualStartYear + 2}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Sales Report by Customer (5 years) — Cash &amp; Accrual</td><td class="doc-notes">Customer concentration &amp; retention analysis<br><em>Date range: ${_drCustStartFmt} through ${_drCustEndFmt}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Sales Report by Product/Service (5 years)</td><td class="doc-notes">If applicable — for businesses with distinct product lines or service categories<br><em>Date range: ${_drCustStartFmt} through ${_drCustEndFmt}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Current Accounts Receivable Aging Report</td><td class="doc-notes">As of same date as current Balance Sheet</td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Current Accounts Payable Aging Report</td><td class="doc-notes">As of same date as current Balance Sheet</td></tr>
  </table>

  <div class="section-divider">💰 Owner Compensation &amp; Addbacks</div>
  <p style="font-size: 13px; margin-bottom: 15px;">These documents allow us to identify expenses that are personal or non-recurring in nature. Properly documenting these directly increases your calculated business value.</p>

  <table class="doc-table">
    <tr><th class="checkbox">☐</th><th>Document</th><th>Details / Notes</th></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Salary &amp; Benefits for Owner (3 years + TTM)</td><td class="doc-notes">All forms of owner compensation<br><em>Date range: ${_drAnnualStartFmt} through ${_drTtmEndFmt}</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">List of Non-Recurring Business Expenses</td><td class="doc-notes">Any one-time or unusual expenses over the period<br><em>Date range: ${_drAnnualStartFmt} through ${_drTtmEndFmt}</em><br><em>Use the Adjustments Template spreadsheet (provided separately)</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">List of Non-Business Related Expenses</td><td class="doc-notes">Personal expenses run through the business<br><em>Date range: ${_drAnnualStartFmt} through ${_drTtmEndFmt}</em><br><em>Use the Adjustments Template spreadsheet (provided separately)</em></td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Payroll Report (TTM)</td><td class="doc-notes">All employees (owners included): payroll summary, used to verify owner pay and total staffing cost<br><em>Date range: ${_drTtmStartFmt} through ${_drTtmEndFmt}</em></td></tr>
  </table>

  <div class="section-divider">🔁 Second Round — Please Don't Send These Yet</div>
  <p style="font-size: 13px; margin-bottom: 15px;">After we receive and enter the documents above, <strong>we will generate these two forms for you using your own data</strong> and send them back for you to complete. They're listed here so you know they're coming and can plan for them — but please don't try to provide them up front. The list ends here.</p>

  <table class="doc-table">
    <tr><th class="checkbox">☐</th><th>Document</th><th>Details / Notes</th></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Revenue Classification Form</td><td class="doc-notes"><em>We'll send this after we receive your P&amp;L Statements.</em><br>You classify each revenue line so we understand the quality and structure of your sales.</td></tr>
    <tr><td class="checkbox">☐</td><td class="doc-name">Client Detail Form</td><td class="doc-notes"><em>We'll send this after we receive your Sales Report by Customer.</em><br>You provide additional context on your top clients — contract terms, retention, key relationships.</td></tr>
  </table>


  <div class="confidential-box">
    🔒 <strong>Confidentiality:</strong> All documents and information provided will be treated as strictly confidential and used solely for the purpose of preparing your business valuation.
  </div>
  
  <div class="footer">
    <div class="footer-text">Vista Business Group</div>
    <div class="footer-sub">Questions? Contact your Vista advisor.</div>
  </div>
</body>
</html>`;
                      
                      const blob = new Blob([html], { type: 'text/html' });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = 'Vista-Document-Request.html';
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }}
                    className="px-3 py-2 rounded-lg text-sm font-medium bg-purple-600 text-white hover:bg-purple-700 flex items-center gap-2"
                  >
                    📋 Download Document Request
                  </button>
                  {/* Download QB Report Guide Button */}
                  <button
                    onClick={() => {
                      // Calculate dates based on current date
                      const now = new Date();
                      
                      // TTM: End of prior month, 12 complete months back
                      const priorMonth = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of prior month
                      const ttmStart = new Date(priorMonth.getFullYear(), priorMonth.getMonth() - 11, 1); // First day, 12 months back
                      const ttmEndStr = priorMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
                      const ttmStartStr = ttmStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
                      const ttmDateRange = `${ttmStartStr} through ${ttmEndStr}`;
                      
                      // Formatted dates for instructions (MM/DD/YYYY format)
                      const ttmStartFormatted = ttmStart.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                      const ttmEndFormatted = priorMonth.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                      
                      // Current year and prior years
                      const currentYear = now.getFullYear();
                      const ytdYear = currentYear; // For YTD column headers
                      const priorMonthEnd = priorMonth.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                      
                      // Annual reports: Start from Jan 1 of (currentYear - 3) through end of prior month
                      // This gives us 3 complete years + YTD
                      const annualStartYear = currentYear - 3;
                      const annualStartFormatted = `01/01/${annualStartYear}`;
                      const annualEndFormatted = priorMonthEnd; // End of prior month
                      
                      // Customer annual reports: 5 complete years ending Dec 31 of prior year
                      const customerStartYear = currentYear - 5;
                      const customerStartFormatted = `01/01/${customerStartYear}`;
                      const customerEndYear = currentYear - 1;
                      const customerEndFormatted = `12/31/${customerEndYear}`;
                      
                      // Export icon SVG (matches QBO interface)
                      const exportIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin: 0 3px; display: inline-block;"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>';
                      
                      // TTM example months (use actual TTM period months)
                      const ttmFirstMonth = ttmStart.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
                      const ttmSecondMonth = new Date(ttmStart.getFullYear(), ttmStart.getMonth() + 1, 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
                      const ttmThirdMonth = new Date(ttmStart.getFullYear(), ttmStart.getMonth() + 2, 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
                      const ttmLastMonth = priorMonth.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
                      
                      const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>QuickBooks Report Guide - Vista Business Group</title>
  <style>
    @page { margin: 0.75in; }
    body { font-family: 'Segoe UI', Calibri, Arial, sans-serif; max-width: 850px; margin: 0 auto; padding: 40px 20px; color: #1f2937; line-height: 1.5; background: #fff; }
    
    /* Header styling to match presentation package */
    .header-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
    .header-table td { vertical-align: middle; padding: 0; }
    .logo-cell { width: 80px; }
    .logo-cell img { width: 70px; height: 88px; }
    .title-cell { text-align: right; padding-right: 10px; }
    .title-cell h1 { color: #3D5C35; margin: 0; font-size: 28px; font-weight: 700; }
    .title-cell .subtitle { color: #6b7280; font-size: 14px; margin-top: 4px; }
    .header-line { border: none; border-top: 3px solid #3D5C35; margin: 15px 0 25px 0; }
    
    .intro-box { background: linear-gradient(135deg, #f0f4ef 0%, #e8f5e9 100%); border-left: 4px solid #3D5C35; padding: 15px 20px; margin-bottom: 25px; border-radius: 0 8px 8px 0; }
    .intro-box h3 { color: #3D5C35; margin: 0 0 8px 0; font-size: 16px; }
    .intro-box p { margin: 0; font-size: 14px; }
    
    .key-points { background: #fffbeb; border: 1px solid #f59e0b; padding: 15px; border-radius: 8px; margin-bottom: 30px; }
    .key-points h4 { color: #b45309; margin: 0 0 10px 0; font-size: 15px; }
    .key-points ul { margin: 0; padding-left: 20px; }
    .key-points li { margin-bottom: 5px; font-size: 13px; }
    
    .section-divider { background: #3D5C35; color: white; padding: 10px 15px; margin: 30px 0 20px 0; border-radius: 6px; font-size: 18px; font-weight: 600; }
    
    .report-section { border: 1px solid #d1d5db; border-radius: 8px; margin-bottom: 20px; overflow: hidden; page-break-inside: avoid; }
    .report-header { background: linear-gradient(135deg, #3D5C35 0%, #4a7041 100%); color: white; padding: 12px 15px; }
    .report-header h3 { margin: 0; font-size: 15px; font-weight: 600; }
    .report-body { padding: 15px; background: #fff; }
    
    .steps-box { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; padding: 12px 15px; margin-bottom: 12px; }
    .steps-box h5 { color: #374151; margin: 0 0 10px 0; font-size: 13px; font-weight: 600; }
    .steps-box ol { margin: 0; padding-left: 22px; font-size: 12px; }
    .steps-box li { margin-bottom: 5px; line-height: 1.4; }
    .steps-box li code { background: #e5e7eb; padding: 1px 5px; border-radius: 3px; font-family: 'Consolas', monospace; font-size: 11px; }
    .steps-box .step-note { color: #6b7280; font-style: italic; font-size: 11px; }
    
    .setting-row { display: flex; margin-bottom: 6px; font-size: 13px; }
    .setting-label { font-weight: 600; width: 130px; color: #4b5563; }
    .setting-value { flex: 1; }
    .setting-value code { background: #f3f4f6; padding: 2px 6px; border-radius: 3px; font-family: 'Consolas', monospace; font-size: 12px; }
    
    .example-box { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; margin-top: 12px; overflow: hidden; }
    .example-title { background: #e5e7eb; padding: 8px 12px; font-weight: 600; font-size: 12px; color: #374151; }
    .example-table { width: 100%; border-collapse: collapse; font-size: 11px; }
    .example-table th { background: #3D5C35; color: white; padding: 6px 8px; text-align: left; border: 1px solid #3D5C35; font-weight: 600; }
    .example-table td { padding: 5px 8px; border: 1px solid #e5e7eb; }
    .example-table tr:nth-child(even) td { background: #f9fafb; }
    .example-table .num { text-align: right; font-family: 'Consolas', monospace; }
    .example-table .total { font-weight: 600; background: #ecfdf5 !important; }
    .example-table .section-header { background: #f3f4f6; font-weight: 600; }
    
    .note-box { background: #fef3c7; border: 1px solid #f59e0b; border-radius: 6px; padding: 10px 12px; margin-top: 10px; font-size: 12px; }
    .note-box strong { color: #b45309; }
    
    .mistakes-box { background: #fef2f2; border: 1px solid #fecaca; border-radius: 6px; padding: 10px 12px; margin-top: 10px; }
    .mistakes-box h5 { color: #dc2626; margin: 0 0 6px 0; font-size: 12px; }
    .mistakes-box ul { margin: 0; padding-left: 16px; font-size: 12px; }
    .mistakes-box li { margin-bottom: 3px; color: #991b1b; }
    
    .tips-box { background: #eff6ff; border: 1px solid #93c5fd; border-radius: 6px; padding: 10px 12px; margin-top: 10px; }
    .tips-box h5 { color: #1d4ed8; margin: 0 0 6px 0; font-size: 12px; }
    .tips-box ul { margin: 0; padding-left: 16px; font-size: 12px; }
    .tips-box li { margin-bottom: 3px; }
    
    
    .footer { border-top: 2px solid #3D5C35; padding-top: 15px; margin-top: 30px; text-align: center; }
    .footer-logo { font-weight: 700; color: #3D5C35; font-size: 14px; }
    .footer-text { color: #6b7280; font-size: 12px; margin-top: 5px; }
    
    @media print { 
      body { margin: 0; padding: 20px; }
      .report-section { page-break-inside: avoid; }
      .section-divider { page-break-before: auto; }
    }
  </style>
</head>
<body>
  <!-- Header with Logo -->
  <table class="header-table">
    <tr>
      <td class="logo-cell">
        <img src="${vistaLogoBase64}" alt="Vista Business Group" />
      </td>
      <td class="title-cell">
        <h1>QuickBooks Report Guide</h1>
        <div class="subtitle">How to provide reports for your business valuation</div>
      </td>
    </tr>
  </table>
  <hr class="header-line" />
  
  <div class="intro-box">
    <h3>Why This Guide?</h3>
    <p>To provide an accurate valuation, we need financial reports in specific formats. This guide shows exactly what each report should look like when exported from QuickBooks Online. Following these examples will help us complete your valuation faster.</p>
  </div>
  
  <div class="key-points">
    <h4>⚡ Key Points for All Reports</h4>
    <ul>
      <li><strong>Always export to Excel</strong> (.xlsx) - not PDF. Click the Export icon → "Export to Excel"</li>
      <li><strong>Follow the exact date ranges as instructed</strong></li>
      <li><strong>Include ALL account detail</strong> - don't collapse or summarize rows</li>
      <li><strong>Provide both Cash and Accrual reports</strong> when instructed</li>
    </ul>
  </div>

  <!-- ==================== P&L REPORTS ==================== -->
  <div class="section-divider">📊 Profit & Loss Reports</div>

  <!-- REPORT 1: TTM P&L Monthly -->
  <div class="report-section">
    <div class="report-header">
      <h3>TTM Profit & Loss by Month</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box (top), type <code>Profit and Loss by Month</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${ttmStartFormatted}</code> To: <code>${ttmEndFormatted}</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Accrual</code></li>
          <li>Verify <strong>Display columns by</strong> is set to <code>Months</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon (top right) → <code>Export to Excel</code></li>
          <li><strong>REPEAT steps 5-8</strong> with Accounting method set to <code>Cash</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Profit and Loss by Month</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">${ttmDateRange}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Accounting Method:</div>
        <div class="setting-value"><strong>Run TWICE:</strong> Once as "Accrual" and once as "Cash"</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:180px;"></th>
            <th>${ttmFirstMonth}</th>
            <th>${ttmSecondMonth}</th>
            <th>${ttmThirdMonth}</th>
            <th>...</th>
            <th>${ttmLastMonth}</th>
            <th>Total</th>
          </tr>
          <tr class="section-header"><td colspan="7">Income</td></tr>
          <tr><td>Service Revenue</td><td class="num">45,000</td><td class="num">47,500</td><td class="num">46,200</td><td>...</td><td class="num">52,000</td><td class="num">580,000</td></tr>
          <tr class="total"><td>Total Income</td><td class="num">57,000</td><td class="num">59,000</td><td class="num">59,400</td><td>...</td><td class="num">66,000</td><td class="num">735,000</td></tr>
          <tr class="section-header"><td colspan="7">Expenses</td></tr>
          <tr><td>Rent</td><td class="num">3,500</td><td class="num">3,500</td><td class="num">3,500</td><td>...</td><td class="num">3,500</td><td class="num">42,000</td></tr>
        </table>
      </div>
      
      <div class="mistakes-box">
        <h5>❌ Common Mistakes</h5>
        <ul>
          <li>Using "Profit and Loss" instead of "Profit and Loss <strong>by Month</strong>"</li>
          <li>Exporting as PDF instead of Excel</li>
          <li>Only sending one basis (Cash) - we need BOTH Cash and Accrual</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- REPORT 2: Annual P&L -->
  <div class="report-section">
    <div class="report-header">
      <h3>Annual P&L Statements (3 Years)</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Profit and Loss</code></li>
          <li>Click on <code>Profit and Loss</code> to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${annualStartFormatted}</code> To: <code>${annualEndFormatted}</code></li>
          <li>Set <strong>Display columns by</strong> dropdown to <code>Years</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Accrual</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
          <li><strong>REPEAT</strong> with Accounting method set to <code>Cash</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Profit and Loss</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">Custom: ${annualStartFormatted} through ${annualEndFormatted}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Display columns by:</div>
        <div class="setting-value"><code>Years</code> (dropdown on report toolbar)</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Accounting Method:</div>
        <div class="setting-value"><strong>Run TWICE:</strong> Once as "Accrual" and once as "Cash"</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format (all years in ONE file)</div>
        <table class="example-table">
          <tr>
            <th style="width:180px;"></th>
            <th>${annualStartYear}</th>
            <th>${annualStartYear + 1}</th>
            <th>${annualStartYear + 2}</th>
            <th>${ytdYear}</th>
          </tr>
          <tr class="section-header"><td colspan="5">Income</td></tr>
          <tr><td>Service Revenue</td><td class="num">520,000</td><td class="num">580,000</td><td class="num">650,000</td><td class="num">340,000</td></tr>
          <tr class="total"><td>Total Income</td><td class="num">520,000</td><td class="num">580,000</td><td class="num">650,000</td><td class="num">340,000</td></tr>
        </table>
      </div>
      
      <div class="tips-box">
        <h5>💡 Tips</h5>
        <ul>
          <li>The <strong>Display columns by</strong> dropdown is on the report toolbar (between Report period and Accounting method)</li>
          <li>Setting it to "Years" automatically creates a column for each year in your date range</li>
          <li>If you only see "Total", change Display columns by from "Total Only" to "Years"</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- ==================== BALANCE SHEET REPORTS ==================== -->
  <div class="section-divider">📋 Balance Sheet Reports</div>

  <!-- REPORT 3: TTM Balance Sheet Monthly -->
  <div class="report-section">
    <div class="report-header">
      <h3>TTM Balance Sheet by Month</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Balance Sheet</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${ttmStartFormatted}</code> To: <code>${ttmEndFormatted}</code></li>
          <li>Set <strong>Display columns by</strong> to <code>Months</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Accrual</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon (top right) → <code>Export to Excel</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Balance Sheet</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">${ttmDateRange}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Display columns by:</div>
        <div class="setting-value"><code>Months</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Accounting Method:</div>
        <div class="setting-value">Accrual</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:200px;"></th>
            <th>${ttmFirstMonth}</th>
            <th>${ttmSecondMonth}</th>
            <th>...</th>
            <th>${ttmLastMonth}</th>
          </tr>
          <tr class="section-header"><td colspan="5">ASSETS</td></tr>
          <tr><td>Checking</td><td class="num">45,000</td><td class="num">52,000</td><td>...</td><td class="num">48,000</td></tr>
          <tr><td>Accounts Receivable</td><td class="num">85,000</td><td class="num">78,000</td><td>...</td><td class="num">92,000</td></tr>
          <tr class="total"><td>Total Current Assets</td><td class="num">135,000</td><td class="num">138,000</td><td>...</td><td class="num">148,000</td></tr>
        </table>
      </div>
      
      <div class="mistakes-box">
        <h5>❌ Common Mistakes</h5>
        <ul>
          <li>Forgetting to set <strong>Display columns by</strong> to "Months"</li>
          <li>Providing a single snapshot date instead of 12 monthly columns</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- REPORT 4: Annual Balance Sheets -->
  <div class="report-section">
    <div class="report-header">
      <h3>Annual Balance Sheets (3 Years + Interim)</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Balance Sheet</code></li>
          <li>Click on <code>Balance Sheet</code> to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${annualStartFormatted}</code> To: <code>${annualEndFormatted}</code></li>
          <li>Set <strong>Display columns by</strong> dropdown to <code>Years</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Accrual</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Balance Sheet</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">Custom: ${annualStartFormatted} through ${annualEndFormatted}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Display columns by:</div>
        <div class="setting-value"><code>Years</code> (dropdown on report toolbar)</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Accounting Method:</div>
        <div class="setting-value">Accrual</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:200px;"></th>
            <th>${annualStartYear}</th>
            <th>${annualStartYear + 1}</th>
            <th>${annualStartYear + 2}</th>
            <th>${ytdYear}</th>
          </tr>
          <tr class="section-header"><td colspan="5">ASSETS</td></tr>
          <tr><td>Cash</td><td class="num">35,000</td><td class="num">42,000</td><td class="num">48,000</td><td class="num">52,000</td></tr>
          <tr><td>Accounts Receivable</td><td class="num">65,000</td><td class="num">78,000</td><td class="num">92,000</td><td class="num">88,000</td></tr>
        </table>
      </div>
      
      <div class="tips-box">
        <h5>💡 Tips</h5>
        <ul>
          <li>The <strong>Display columns by</strong> dropdown is on the report toolbar</li>
          <li>Setting it to "Years" shows year-end balances for each year</li>
          <li>Balance Sheet is always Accrual basis - no need to run twice</li>
          <li>If you only see one column, change Display columns by from "Total Only" to "Years"</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- ==================== SALES REPORTS ==================== -->
  <div class="section-divider">👥 Sales & Customer Reports</div>

  <!-- REPORT 5: Sales by Customer (Annual) -->
  <div class="report-section">
    <div class="report-header">
      <h3>Sales by Customer Summary (5 Years) - Cash AND Accrual</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Sales by Customer Summary</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${customerStartFormatted}</code> To: <code>${customerEndFormatted}</code></li>
          <li>Set <strong>Display columns by</strong> dropdown to <code>Years</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Cash</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
          <li><strong>Change Accounting method</strong> to <code>Accrual</code> and export again</li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Sales by Customer Summary</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">Custom: ${customerStartFormatted} through ${customerEndFormatted}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Display columns by:</div>
        <div class="setting-value"><code>Years</code> (dropdown on report toolbar)</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Accounting Method:</div>
        <div class="setting-value"><strong>Both Cash AND Accrual</strong> (export each separately)</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:180px;">Customer</th>
            <th>${customerStartYear}</th>
            <th>${customerStartYear + 1}</th>
            <th>${customerStartYear + 2}</th>
            <th>${customerStartYear + 3}</th>
            <th>${customerStartYear + 4}</th>
          </tr>
          <tr><td>ABC Company</td><td class="num">42,000</td><td class="num">45,000</td><td class="num">52,000</td><td class="num">58,000</td><td class="num">62,000</td></tr>
          <tr><td>XYZ Corp</td><td class="num">35,000</td><td class="num">38,000</td><td class="num">41,000</td><td class="num">45,000</td><td class="num">48,000</td></tr>
          <tr class="total"><td>TOTAL</td><td class="num">480,000</td><td class="num">520,000</td><td class="num">580,000</td><td class="num">650,000</td><td class="num">720,000</td></tr>
        </table>
      </div>
      
      <div class="tips-box">
        <h5>💡 Why We Need This</h5>
        <ul>
          <li>Calculates customer concentration (% of revenue from top customers)</li>
          <li>Tracks customer retention year-over-year</li>
          <li>Identifies customer growth and churn patterns</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- REPORT 5b: Sales by Customer TTM -->
  <div class="report-section">
    <div class="report-header">
      <h3>Sales by Customer Summary (TTM) - Cash AND Accrual</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Sales by Customer Summary</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${ttmStartFormatted}</code> To: <code>${ttmEndFormatted}</code></li>
          <li>Set <strong>Display columns by</strong> dropdown to <code>Months</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Cash</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
          <li><strong>Change Accounting method</strong> to <code>Accrual</code> and export again</li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Sales by Customer Summary</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">Custom: ${ttmStartFormatted} through ${ttmEndFormatted} (trailing 12 months)</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Display columns by:</div>
        <div class="setting-value"><code>Months</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Accounting Method:</div>
        <div class="setting-value"><strong>Both Cash AND Accrual</strong> (export each separately)</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format (with monthly columns)</div>
        <table class="example-table">
          <tr>
            <th style="width:140px;">Customer</th>
            <th>Jan</th>
            <th>Feb</th>
            <th>Mar</th>
            <th>...</th>
            <th>Dec</th>
            <th>Total</th>
          </tr>
          <tr><td>ABC Company</td><td class="num">5,200</td><td class="num">5,400</td><td class="num">5,100</td><td class="num">...</td><td class="num">5,800</td><td class="num">65,000</td></tr>
          <tr><td>XYZ Corp</td><td class="num">4,100</td><td class="num">4,300</td><td class="num">4,200</td><td class="num">...</td><td class="num">4,500</td><td class="num">52,000</td></tr>
          <tr class="total"><td>TOTAL</td><td class="num">62,000</td><td class="num">65,000</td><td class="num">63,000</td><td class="num">...</td><td class="num">68,000</td><td class="num">780,000</td></tr>
        </table>
      </div>
      
      <div class="tips-box">
        <h5>💡 Why We Need This</h5>
        <ul>
          <li>Monthly breakdown reveals customer payment patterns and seasonality</li>
          <li>Helps identify customers trending up or down within TTM period</li>
          <li>Matches TTM P&L period for reconciliation</li>
          <li>Provides visibility into revenue timing for cash flow analysis</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- REPORT 5c: Sales by Product/Service (Optional) -->
  <div class="report-section">
    <div class="report-header">
      <h3>Sales by Product/Service Summary (5 Years) — <em style="font-weight:normal;">If Applicable</em></h3>
    </div>
    <div class="report-body">
      <div style="background: #fef3c7; border: 1px solid #f59e0b; border-radius: 6px; padding: 10px 12px; margin-bottom: 15px;">
        <strong>⚠️ When to Provide This Report:</strong>
        <ul style="margin: 8px 0 0 0; padding-left: 20px;">
          <li>You sell <strong>physical products</strong> or maintain inventory</li>
          <li>You're a <strong>manufacturing, retail, or distribution</strong> business</li>
          <li>You have <strong>distinct product/service lines</strong> you want analyzed separately</li>
        </ul>
        <p style="margin: 8px 0 0 0; font-size: 13px;"><em>Skip this report if you're a pure service business (e.g., IT services, consulting) where revenue categories on your P&L already show your service breakdown.</em></p>
      </div>
      
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Sales by Product/Service Summary</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${customerStartFormatted}</code> To: <code>${customerEndFormatted}</code></li>
          <li>Set <strong>Display columns by</strong> dropdown to <code>Years</code></li>
          <li>Set <strong>Accounting method</strong> to <code>Accrual</code></li>
          <li>The report will refresh automatically</li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Sales by Product/Service Summary</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">Custom: ${customerStartFormatted} through ${customerEndFormatted}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Display columns by:</div>
        <div class="setting-value"><code>Years</code></div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:180px;">Product/Service</th>
            <th>${customerStartYear}</th>
            <th>${customerStartYear + 1}</th>
            <th>${customerStartYear + 2}</th>
            <th>${customerStartYear + 3}</th>
            <th>${customerStartYear + 4}</th>
          </tr>
          <tr><td>Managed Services</td><td class="num">180,000</td><td class="num">210,000</td><td class="num">245,000</td><td class="num">280,000</td><td class="num">320,000</td></tr>
          <tr><td>Hardware Sales</td><td class="num">95,000</td><td class="num">110,000</td><td class="num">125,000</td><td class="num">140,000</td><td class="num">155,000</td></tr>
          <tr><td>Project Services</td><td class="num">65,000</td><td class="num">72,000</td><td class="num">85,000</td><td class="num">95,000</td><td class="num">105,000</td></tr>
          <tr class="total"><td>TOTAL</td><td class="num">340,000</td><td class="num">392,000</td><td class="num">455,000</td><td class="num">515,000</td><td class="num">580,000</td></tr>
        </table>
      </div>
      
      <div class="tips-box">
        <h5>💡 Why We Need This (When Applicable)</h5>
        <ul>
          <li>Shows revenue mix by product/service line over time</li>
          <li>Identifies which products are growing vs declining</li>
          <li>Helps classify revenue types for valuation weighting</li>
          <li>Useful for businesses with inventory or distinct product categories</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- ==================== AGING REPORTS ==================== -->
  <div class="section-divider">📅 Aging Reports</div>

  <!-- REPORT 6: AR Aging -->
  <div class="report-section">
    <div class="report-header">
      <h3>Accounts Receivable Aging Report</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Accounts Receivable Aging Summary</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → <code>${ttmEndFormatted}</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Accounts Receivable Aging Summary</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">As Of Date:</div>
        <div class="setting-value"><code>${ttmEndFormatted}</code> (must match TTM Balance Sheet end date)</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:150px;">Customer</th>
            <th>Current</th>
            <th>1-30 Days</th>
            <th>31-60 Days</th>
            <th>61-90 Days</th>
            <th>90+ Days</th>
            <th>Total</th>
          </tr>
          <tr><td>ABC Company</td><td class="num">12,000</td><td class="num">5,000</td><td class="num">-</td><td class="num">-</td><td class="num">-</td><td class="num">17,000</td></tr>
          <tr><td>XYZ Corp</td><td class="num">8,500</td><td class="num">2,500</td><td class="num">1,200</td><td class="num">-</td><td class="num">-</td><td class="num">12,200</td></tr>
          <tr class="total"><td>TOTAL</td><td class="num">68,000</td><td class="num">15,000</td><td class="num">5,200</td><td class="num">2,000</td><td class="num">3,500</td><td class="num">93,700</td></tr>
        </table>
      </div>
      
      <div class="note-box">
        <strong>Note:</strong> Your aging date ranges may differ from this example (e.g., 1-15, 16-30, etc.). That's fine - just export whatever aging buckets your QuickBooks is configured to use.
      </div>
      
      <div class="mistakes-box">
        <h5>❌ Common Mistakes</h5>
        <ul>
          <li>Running as of "today" instead of matching the Balance Sheet date</li>
          <li>Total doesn't match Accounts Receivable on Balance Sheet (timing mismatch)</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- REPORT 7: AP Aging -->
  <div class="report-section">
    <div class="report-header">
      <h3>Accounts Payable Aging Report</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Accounts Payable Aging Summary</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → <code>${ttmEndFormatted}</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
        </ol>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Accounts Payable Aging Summary</code></div>
      </div>
      <div class="setting-row">
        <div class="setting-label">As Of Date:</div>
        <div class="setting-value"><code>${ttmEndFormatted}</code> (must match TTM Balance Sheet end date)</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example Output Format</div>
        <table class="example-table">
          <tr>
            <th style="width:150px;">Vendor</th>
            <th>Current</th>
            <th>1-30 Days</th>
            <th>31-60 Days</th>
            <th>61-90 Days</th>
            <th>90+ Days</th>
            <th>Total</th>
          </tr>
          <tr><td>Supplier A</td><td class="num">8,000</td><td class="num">-</td><td class="num">-</td><td class="num">-</td><td class="num">-</td><td class="num">8,000</td></tr>
          <tr><td>Vendor B</td><td class="num">3,200</td><td class="num">1,500</td><td class="num">-</td><td class="num">-</td><td class="num">-</td><td class="num">4,700</td></tr>
          <tr class="total"><td>TOTAL</td><td class="num">22,000</td><td class="num">4,500</td><td class="num">1,200</td><td class="num">500</td><td class="num">-</td><td class="num">28,200</td></tr>
        </table>
      </div>
      
      <div class="note-box">
        <strong>Note:</strong> Your aging date ranges may differ from this example. That's fine - just export whatever aging buckets your QuickBooks is configured to use.
      </div>
    </div>
  </div>

  <!-- ==================== PAYROLL ==================== -->
  <div class="section-divider">💰 Payroll Reports</div>

  <!-- REPORT 8: Payroll -->
  <div class="report-section">
    <div class="report-header">
      <h3>Payroll Summary Report (TTM)</h3>
    </div>
    <div class="report-body">
      <div class="steps-box">
        <h5>📋 Step-by-Step Instructions</h5>
        <ol>
          <li>Click <code>Reports</code> in the left sidebar</li>
          <li>In the search box, type <code>Payroll Summary</code></li>
          <li>Click on the report name to open it</li>
          <li>Set <strong>Report period</strong>: Custom → From: <code>${ttmStartFormatted}</code> To: <code>${ttmEndFormatted}</code></li>
          <li>The report will refresh automatically <span class="step-note">(QBO Desktop: click Run report)</span></li>
          <li>Click the ${exportIcon} <strong>Export</strong> icon → <code>Export to Excel</code></li>
        </ol>
        <p style="margin-top:10px; font-size:11px; color:#6b7280;"><em>Note: If you use a third-party payroll provider (ADP, Gusto, Paychex, etc.), export the payroll summary from that system instead.</em></p>
      </div>
      
      <div class="setting-row">
        <div class="setting-label">QB Report Name:</div>
        <div class="setting-value"><code>Payroll Summary</code> or export from your payroll provider</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Date Range:</div>
        <div class="setting-value">${ttmDateRange}</div>
      </div>
      <div class="setting-row">
        <div class="setting-label">Purpose:</div>
        <div class="setting-value">Verify owner salary and total compensation</div>
      </div>
      
      <div class="example-box">
        <div class="example-title">✓ Example - What We Need to See</div>
        <table class="example-table">
          <tr>
            <th>Employee</th>
            <th>Gross Pay</th>
            <th>Employer Taxes</th>
            <th>Benefits</th>
            <th>Total Cost</th>
          </tr>
          <tr><td>John Smith (Owner)</td><td class="num">120,000</td><td class="num">9,180</td><td class="num">12,000</td><td class="num">141,180</td></tr>
          <tr><td>Jane Doe (Manager)</td><td class="num">75,000</td><td class="num">5,738</td><td class="num">8,000</td><td class="num">88,738</td></tr>
        </table>
      </div>
    </div>
  </div>

  <!-- ==================== ADJUSTMENTS ==================== -->
  <div class="footer">
    <div class="footer-logo">Vista Business Group</div>
    <div class="footer-text">Questions about these reports? Contact your Vista advisor for assistance.</div>
  </div>
</body>
</html>`;
                      
                      const blob = new Blob([html], { type: 'text/html' });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = 'Vista-QuickBooks-Report-Guide.html';
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }}
                    className="px-3 py-2 rounded-lg text-sm font-medium bg-purple-600 text-white hover:bg-purple-700 flex items-center gap-2"
                  >
                    📘 Download QB Guide
                  </button>
                  {/* Download Adjustments Template Button */}
                  <button
                    onClick={() => {
                      const companyName = dealProfile.companyName || 'Company';
                      const now = new Date();
                      const currentYear = now.getFullYear();
                      const wb = XLSX.utils.book_new();
                      
                      // ========== STYLING ==========
                      const styles = {
                        headerMain: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 14 }, alignment: { horizontal: "center", vertical: "center" } },
                        colHeader: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 10 }, alignment: { horizontal: "center", vertical: "center", wrapText: true } },
                        colHint: { font: { sz: 8, color: { rgb: "666666" }, italic: true }, alignment: { horizontal: "center", vertical: "center" } },
                        exampleRow: { fill: { fgColor: { rgb: "FEF3C7" } }, font: { sz: 10, italic: true, color: { rgb: "92400E" } }, alignment: { vertical: "center", wrapText: true } },
                        dataRow: { font: { sz: 10 }, alignment: { vertical: "center" } },
                        instrHeader: { fill: { fgColor: { rgb: "3D5C35" } }, font: { color: { rgb: "FFFFFF" }, bold: true, sz: 12 }, alignment: { vertical: "center" } },
                        instrText: { font: { sz: 10 }, alignment: { vertical: "top", wrapText: true } },
                        instrBold: { font: { sz: 10, bold: true }, alignment: { vertical: "top", wrapText: true } },
                        typeHeader: { fill: { fgColor: { rgb: "E3F2FD" } }, font: { bold: true, sz: 10, color: { rgb: "1565C0" } }, alignment: { vertical: "center" } },
                        typeDesc: { font: { sz: 9 }, alignment: { vertical: "top", wrapText: true } },
                        typeEx: { font: { sz: 9, italic: true, color: { rgb: "666666" } }, alignment: { vertical: "top", wrapText: true } },
                        ruleHeader: { fill: { fgColor: { rgb: "FEE2E2" } }, font: { bold: true, sz: 10, color: { rgb: "DC2626" } }, alignment: { vertical: "center" } },
                        ruleText: { font: { sz: 9, color: { rgb: "7F1D1D" } }, alignment: { vertical: "top", wrapText: true } },
                        whyHeader: { fill: { fgColor: { rgb: "DCFCE7" } }, font: { bold: true, sz: 10, color: { rgb: "166534" } }, alignment: { vertical: "center" } },
                        whyText: { font: { sz: 9, color: { rgb: "166534" } }, alignment: { vertical: "top", wrapText: true } },
                      };
                      
                      // ========== BUILD DATA ==========
                      const data = [];
                      
                      // Row 1: Main header
                      data.push([
                        `📝 ADJUSTMENTS & ADD-BACKS — ${companyName}`, '', '', '', '', '', '',
                        '',
                        '📋 HOW TO COMPLETE THIS FORM'
                      ]);
                      
                      // Row 2: Column headers
                      data.push([
                        'P&L Line Item', 'Description', 'Type', 'Year(s)', '$ Amount', '% of Line', 'Notes',
                        '',
                        '1. Delete the yellow example rows'
                      ]);
                      
                      // Row 3: Column hints
                      data.push([
                        '(must match your P&L)', '(what & why)', '(1-6)', '(which year?)', '(OR use %)', '(OR use $)', '(optional)',
                        '',
                        '2. Add your adjustments — one per row'
                      ]);
                      
                      // Build right-side content
                      const rightContent = [
                        { text: '3. For "Type" enter a number 1-6 (see legend below)', style: 'instr' },
                        { text: '4. Use EITHER $ Amount OR % — not both', style: 'instr' },
                        { text: '5. Save and return to your Vista advisor', style: 'instr' },
                        { text: '', style: 'spacer' },
                        { text: '📚 ADJUSTMENT TYPE LEGEND (enter 1-6)', style: 'typeHeader' },
                        { text: '1 = NON-RECURRING EXPENSE', style: 'typeName' },
                        { text: 'One-time costs: lawsuits, disaster repairs, severance', style: 'typeDesc' },
                        { text: '2 = NON-BUSINESS EXPENSE', style: 'typeName' },
                        { text: 'Personal expenses: vehicles, travel, owner life insurance', style: 'typeDesc' },
                        { text: '3 = REVENUE ADJUSTMENT', style: 'typeName' },
                        { text: 'Exclude unusual revenue: PPP, insurance settlements, asset sales', style: 'typeDesc' },
                        { text: '4 = EXPENSE INCREASE', style: 'typeName' },
                        { text: 'Future costs: new hires (partial year), upcoming rent increase', style: 'typeDesc' },
                        { text: '5 = OWNER DISCRETIONARY', style: 'typeName' },
                        { text: 'Perks new owner won\'t need: club dues, luxury car, donations', style: 'typeDesc' },
                        { text: '6 = ABOVE-MARKET COST', style: 'typeName' },
                        { text: 'Inflated costs to related parties: above-market rent, family salary', style: 'typeDesc' },
                        { text: '', style: 'spacer' },
                        { text: '⚠️ IMPORTANT RULES', style: 'ruleHeader' },
                        { text: '• P&L Line must exist on your financial statements', style: 'rule' },
                        { text: '• Adjustment cannot exceed the P&L line total', style: 'rule' },
                        { text: '• 100% = entire line; cannot exceed 100%', style: 'rule' },
                        { text: '• Multiple adjustments on one line? List separately', style: 'rule' },
                        { text: '', style: 'spacer' },
                        { text: '💡 WHY THIS MATTERS', style: 'whyHeader' },
                        { text: 'Adjustments show a buyer the true earning power of your', style: 'why' },
                        { text: 'business — what it earns without one-time or personal', style: 'why' },
                        { text: 'expenses. Complete, documented adjustments lead to', style: 'why' },
                        { text: 'stronger valuations and smoother due diligence.', style: 'why' },
                        { text: '', style: 'spacer' },
                        { text: 'Common adjustments include: owner salary above market,', style: 'why' },
                        { text: 'personal auto/travel, one-time legal fees, family member', style: 'why' },
                        { text: 'compensation, rent to self, discretionary perks.', style: 'why' },
                      ];
                      
                      // Example rows with better notes
                      const examples = [
                        ['Legal & Professional', 'Lawsuit settlement — one-time', '1', String(currentYear - 1), '$25,000', '', 'Settled employment dispute; will not recur'],
                        // Severance example (Zac 09-05, DDS QoE caught it / Loyal IT missed it:
                        // "if a company pays severance this should be included as an addback").
                        ['Payroll / Wages', 'Severance — eliminated role', '1', String(currentYear - 1), '$18,000', '', 'One-time severance for a role the buyer will not replace'],
                        ['Auto Expense', 'Personal vehicle through business', '2', 'All Years', '', '50%', 'Vehicle is 50% personal use per mileage log'],
                        ['Officer Compensation', 'Owner salary above market rate', '6', 'All Years', '$75,000', '', 'Market rate is ~$125K; owner takes $200K'],
                        ['Rent Expense', 'Rent to owner-owned building', '6', 'All Years', '$24,000', '', 'Paying $6K/mo; market rate is $4K/mo'],
                        ['Meals & Entertainment', 'Country club membership', '5', 'All Years', '', '100%', 'Entire amount is owner personal/discretionary'],
                        ['Insurance', 'Owner life insurance policy', '2', 'All Years', '$4,200', '', 'Personal policy paid by business annually'],
                      ];
                      
                      // Add example rows + blank rows, with right content alongside
                      const numExamples = examples.length;
                      const numBlankRows = 10;
                      const totalLeftRows = numExamples + numBlankRows;
                      const totalRows = Math.max(totalLeftRows, rightContent.length);
                      
                      for (let i = 0; i < totalRows; i++) {
                        let leftData = ['', '', '', '', '', '', ''];
                        
                        if (i < numExamples) {
                          leftData = examples[i];
                        }
                        // Blank rows for i >= numExamples && i < totalLeftRows are already empty
                        
                        const rightItem = rightContent[i];
                        const rightText = rightItem ? rightItem.text : '';
                        
                        data.push([...leftData, '', rightText]);
                      }
                      
                      const ws = XLSX.utils.aoa_to_sheet(data);
                      
                      // Column widths
                      ws['!cols'] = [
                        { wch: 22 },  // A: P&L Line Item
                        { wch: 32 },  // B: Description
                        { wch: 6 },   // C: Type (just a number)
                        { wch: 10 },  // D: Year(s)
                        { wch: 12 },  // E: $ Amount
                        { wch: 10 },  // F: % of Line
                        { wch: 38 },  // G: Notes
                        { wch: 2 },   // H: Spacer
                        { wch: 52 },  // I: Instructions
                      ];
                      
                      // Row heights
                      ws['!rows'] = [{ hpt: 28 }]; // Header row taller
                      
                      // Merge main header
                      ws['!merges'] = [
                        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }
                      ];
                      
                      // Apply styles
                      // Row 1 headers
                      if (ws['A1']) ws['A1'].s = styles.headerMain;
                      if (ws['I1']) ws['I1'].s = styles.instrHeader;
                      
                      // Row 2 column headers
                      ['A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'G2'].forEach(ref => {
                        if (ws[ref]) ws[ref].s = styles.colHeader;
                      });
                      if (ws['I2']) ws['I2'].s = styles.instrText;
                      
                      // Row 3 hints
                      ['A3', 'B3', 'C3', 'D3', 'E3', 'F3', 'G3'].forEach(ref => {
                        if (ws[ref]) ws[ref].s = styles.colHint;
                      });
                      if (ws['I3']) ws['I3'].s = styles.instrText;
                      
                      // Data rows
                      for (let i = 0; i < totalRows; i++) {
                        const rowNum = 3 + i; // 0-indexed
                        const isExample = i < numExamples;
                        
                        // Left side (entry form)
                        for (let col = 0; col <= 6; col++) {
                          const ref = XLSX.utils.encode_cell({ r: rowNum, c: col });
                          if (ws[ref]) {
                            ws[ref].s = isExample ? styles.exampleRow : styles.dataRow;
                          }
                        }
                        
                        // Right side (instructions/legend)
                        const rightRef = XLSX.utils.encode_cell({ r: rowNum, c: 8 });
                        const rightItem = rightContent[i];
                        if (ws[rightRef] && rightItem) {
                          if (rightItem.style === 'instr') ws[rightRef].s = styles.instrText;
                          else if (rightItem.style === 'typeHeader') ws[rightRef].s = styles.typeHeader;
                          else if (rightItem.style === 'typeName') ws[rightRef].s = styles.instrBold;
                          else if (rightItem.style === 'typeDesc') ws[rightRef].s = styles.typeDesc;
                          else if (rightItem.style === 'ruleHeader') ws[rightRef].s = styles.ruleHeader;
                          else if (rightItem.style === 'rule') ws[rightRef].s = styles.ruleText;
                          else if (rightItem.style === 'whyHeader') ws[rightRef].s = styles.whyHeader;
                          else if (rightItem.style === 'why') ws[rightRef].s = styles.whyText;
                        }
                      }
                      
                      // Freeze header rows
                      ws['!freeze'] = { xSplit: 0, ySplit: 3 };
                      
                      XLSX.utils.book_append_sheet(wb, ws, 'Adjustments');
                      
                      // ========== SHEET 2: Type Lookup ==========
                      const lookupData = [
                        ['Type # — Copy into Column C'],
                        ['1 = Non-Recurring Expense'],
                        ['2 = Non-Business Expense'],
                        ['3 = Revenue Adjustment'],
                        ['4 = Expense Increase'],
                        ['5 = Owner Discretionary'],
                        ['6 = Above-Market Cost'],
                      ];
                      const wsLookup = XLSX.utils.aoa_to_sheet(lookupData);
                      wsLookup['!cols'] = [{ wch: 35 }];
                      if (wsLookup['A1']) wsLookup['A1'].s = { font: { bold: true }, fill: { fgColor: { rgb: "E3F2FD" } } };
                      XLSX.utils.book_append_sheet(wb, wsLookup, 'Type Lookup');
                      
                      // Download
                      XLSX.writeFile(wb, (companyName.replace(/[^a-zA-Z0-9]/g, '_') || 'Company') + '_Adjustments_Template.xlsx');
                    }}
                    className="px-3 py-2 rounded-lg text-sm font-medium bg-green-600 text-white hover:bg-green-700 flex items-center gap-2"
                  >
                    📥 Download Adjustments Template
                  </button>
                  {/* Unsent wrong-doc batch, in THIS grid too (Colleen 09-02:
                      she works here, the strip only lived on the data-entry
                      views — flags with no visible batch looked per-item). */}
                  {pendingReRequests.length > 0 && (
                    <div className="mb-2 flex items-center justify-between gap-2 bg-red-50 border border-red-200 rounded px-2 py-1.5 flex-wrap text-xs">
                      <span className="text-red-700 font-medium">⚠ {pendingReRequests.length} document{pendingReRequests.length === 1 ? '' : 's'} flagged wrong — the owner hasn't been emailed yet. Keep flagging; it's ONE combined email.</span>
                      <button type="button" className="font-semibold text-blue-700 underline whitespace-nowrap" onClick={() => openReRequestEmail(pendingReRequests)}>✉ Review &amp; send the one email</button>
                    </div>
                  )}
                  {/* Copy Missing Documents Button */}
                  <button
                    onClick={() => {
                      const docsNeeded = documentChecklist.filter(d => d.status !== 'complete');
                      if (docsNeeded.length === 0) {
                        alert('All documents have been received!');
                        return;
                      }
                      let text = '';
                      docsNeeded.forEach((doc, idx) => {
                        text += `${idx + 1}. ${doc.name}`;
                        if (doc.status === 'partial' && doc.pendingNotes) {
                          text += ` (Still need: ${doc.pendingNotes})`;
                        }
                        text += '\n';
                      });
                      navigator.clipboard.writeText(text.trim()).then(() => {
                        setCopySuccess('docs');
                        setTimeout(() => setCopySuccess(false), 2000);
                      }).catch(() => {
                        const textarea = document.createElement('textarea');
                        textarea.value = text.trim();
                        document.body.appendChild(textarea);
                        textarea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textarea);
                        setCopySuccess('docs');
                        setTimeout(() => setCopySuccess(false), 2000);
                      });
                    }}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
                      copySuccess === 'docs'
                        ? 'bg-green-500 text-white'
                        : 'bg-orange-500 text-white hover:bg-orange-600'
                    }`}
                  >
                    {copySuccess === 'docs' ? '✓ Copied!' : `📋 Copy Missing (${documentChecklist.filter(d => d.status !== 'complete').length})`}
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead className="bg-slate-200">
                    <tr>
                      <th className="p-2 border w-28 text-center">Status</th>
                      <th className="p-2 border w-14 text-center">Tier</th>
                      <th className="p-2 border w-16 text-center" title="Documents the owner committed to providing at discovery. Upload Complete auto-advances when every planned item is received.">Planned</th>
                      <th className="p-2 border text-left">Document</th>
                      <th className="p-2 border w-28 text-left">Date</th>
                      <th className="p-2 border w-16 text-center" title="Mark as verification item (final stage)">Verify</th>
                      <th className="p-2 border text-left">Notes / Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentChecklist.map(doc => (
                      <tr key={doc.id} className={
                        doc.status === 'complete' ? 'bg-blue-50' : 
                        doc.status === 'partial' ? 'bg-amber-50' : 
                        doc.status === 'requested' ? 'bg-purple-50' :
                        doc.tier === 'minimum' ? 'bg-green-50' : 'bg-white'
                      }>
                        <td className="p-2 border text-center">
                          <select
                            value={doc.status || 'not_received'}
                            onChange={e => {
                              const newStatus = e.target.value;
                              if (!confirmClientDetailComplete(doc, newStatus)) return;
                              const wasComplete = doc.status === 'complete';
                              const nowComplete = newStatus === 'complete';
                              setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {
                                ...d,
                                status: newStatus,
                                dateProvided: newStatus === 'complete' && !d.dateProvided ? new Date().toLocaleDateString() : d.dateProvided
                              } : d));
                              // Log a document_received event so the dashboard's
                              // Last Interaction column surfaces uploads alongside
                              // outreach. Mirrors the per-tab docTracker logging.
                              if (!wasComplete && nowComplete && currentValuationId) {
                                logActivity(currentValuationId, 'document_received',
                                  `${doc.name} marked complete`,
                                  { item_key: String(doc.id), display_name: doc.name });
                              }
                            }}
                            className={`text-xs px-1 py-1 border rounded font-medium ${
                              doc.status === 'complete' ? 'bg-blue-100 text-blue-700' :
                              doc.status === 'partial' ? 'bg-amber-100 text-amber-700' :
                              doc.status === 'requested' ? 'bg-purple-100 text-purple-700' :
                              'bg-gray-100 text-gray-600'
                            }`}
                          >
                            <option value="not_received">Not Received</option>
                            <option value="requested">Requested</option>
                            <option value="partial">Partial</option>
                            <option value="complete">Complete</option>
                          </select>
                        </td>
                        <td className="p-2 border text-center">
                          {doc.tier === 'minimum' ? (
                            <span className="bg-green-100 text-green-700 px-1.5 py-0.5 rounded text-xs font-medium">MIN</span>
                          ) : (
                            <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded text-xs font-medium">FULL</span>
                          )}
                        </td>
                        <td className="p-2 border text-center">
                          <input
                            type="checkbox"
                            checked={doc.planned || false}
                            onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, planned: e.target.checked} : d))}
                            className="w-4 h-4"
                            title="Owner committed to providing this document"
                          />
                        </td>
                        <td className="p-2 border font-medium">
                          {doc.name}
                          {/* ↩ wrong doc, HERE too (Mark 09-02: "which tab has
                              the link? Not the Discovery tab?" — it only lived
                              on the data-entry doc-tracker strips, but THIS
                              grid is where the documents seat actually works).
                              Same handler as the tracker version: clears the
                              ShareFile receipt, reopens the item on the owner's
                              portal with the reason, batches the re-request
                              email. Shows on any row holding a received file
                              or already marked complete. */}
                          {(() => {
                            const sf = sharefileReceived[String(doc.id)];
                            if (!sf && doc.status !== 'complete') return null;
                            return (
                              <button
                                type="button"
                                title="The uploaded file is wrong or unusable — re-open this item as still-needed on the owner's portal, with a note on what you need. The file stays in the data room."
                                onClick={async () => {
                                  const docName = docShortNames[doc.id] || doc.name;
                                  const reason = window.prompt(
                                    `Re-request "${docName}" from the owner.\n\nWhat was wrong / what do you still need? (shows on the owner's portal list and seeds the email)`,
                                    doc.pendingNotes || ''
                                  );
                                  if (reason === null) return;
                                  const note = (reason || '').trim();
                                  try {
                                    if (currentValuationId) {
                                      await supabaseClient.from('engagement_checklist_items')
                                        .update({ sharefile_received_at: null, sharefile_file_id: null, ai_classification_confidence: null, status: 'not_received', rerequest_note: note || null })
                                        .eq('engagement_id', currentValuationId).eq('item_key', String(doc.id));
                                    }
                                  } catch (e) { console.warn('Re-request: clearing receipt failed:', e); }
                                  setSharefileReceived(prev => { const n = { ...prev }; delete n[String(doc.id)]; return n; });
                                  setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? { ...d, status: 'not_received', pendingNotes: note } : d));
                                  setHasUnsavedChanges(true);
                                  if (currentValuationId) logActivity(currentValuationId, 'document_rerequested', `Re-requested "${doc.name}"${note ? ': ' + note : ''}`);
                                  const entry = { id: doc.id, name: docName, note };
                                  const nextEntries = [...pendingReRequests.filter(en => en.id !== doc.id), entry];
                                  setPendingReRequests(nextEntries);
                                  openReRequestEmail(nextEntries);
                                }}
                                className="text-xs text-red-600 hover:text-red-800 underline ml-2 font-normal"
                              >↩ wrong doc</button>
                            );
                          })()}
                          {doc.pendingNotes && doc.status === 'not_received' && (
                            <span className="block text-xs text-amber-700 font-normal mt-0.5" title="Sent back to the owner as wrong/unusable — this reason shows on their portal.">⚠ re-requested: {doc.pendingNotes}</span>
                          )}
                        </td>
                        <td className="p-2 border">
                          <input
                            type="text"
                            value={doc.dateProvided || ''}
                            onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, dateProvided: e.target.value} : d))} 
                            placeholder="mm/dd/yy" 
                            className="w-full p-1 border rounded text-xs" 
                          />
                        </td>
                        <td className="p-2 border text-center">
                          <input 
                            type="checkbox" 
                            checked={doc.isVerification || false} 
                            onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, isVerification: e.target.checked} : d))} 
                            className="w-4 h-4"
                            title="Mark as verification item (final stage)"
                          />
                        </td>
                        <td className="p-2 border">
                          {/* Konnie 10-12: the owner's portal "not providing it" reason, here where she works
                              the checklist (it only showed on the data-entry strips). */}
                          {ownerNaMap[String(doc.id)] !== undefined && doc.status !== 'complete' && (
                            <div className="mb-1 text-xs text-orange-800 bg-orange-50 border border-orange-200 rounded px-1.5 py-1">
                              🚩 Owner (portal): not providing{ownerNaMap[String(doc.id)] ? ` — "${ownerNaMap[String(doc.id)]}"` : ''}
                              {!isReadOnlyViewer && (
                                <button type="button" onClick={() => confirmOwnerNaFlag(doc)}
                                  className="ml-2 font-semibold text-indigo-700 hover:text-indigo-900 underline"
                                  title="Accept the owner's flag: mark this item none-to-provide, keeping their explanation as the recorded reason.">✓ confirm none</button>
                              )}
                            </div>
                          )}
                          {doc.status === 'complete' && doc.naReason && (
                            <div className="mb-1 text-xs text-indigo-800">Ⓝ none to provide — {doc.naReason}</div>
                          )}
                          {doc.status === 'partial' ? (
                            <div className="space-y-1">
                              <div className="flex items-center gap-1">
                                <span className="text-xs text-green-600 font-medium whitespace-nowrap">✓ Have:</span>
                                <input 
                                  type="text" 
                                  value={doc.receivedNotes || ''} 
                                  onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, receivedNotes: e.target.value} : d))} 
                                  placeholder="e.g., 2023, 2024"
                                  className="flex-1 p-1 border rounded text-xs bg-green-50"
                                />
                              </div>
                              <div className="flex items-center gap-1">
                                <span className="text-xs text-amber-600 font-medium whitespace-nowrap">⏳ Need:</span>
                                <input 
                                  type="text" 
                                  value={doc.pendingNotes || ''} 
                                  onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, pendingNotes: e.target.value} : d))} 
                                  placeholder="e.g., 2025"
                                  className="flex-1 p-1 border rounded text-xs bg-amber-50"
                                />
                              </div>
                            </div>
                          ) : (
                            <input 
                              type="text" 
                              value={doc.notes || ''} 
                              onChange={e => setDocumentChecklist(documentChecklist.map(d => d.id === doc.id ? {...d, notes: e.target.value} : d))} 
                              placeholder="Add notes..."
                              className="w-full p-1 border rounded text-xs" 
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="text-xs text-gray-500 mt-2">
                <strong>Status:</strong> Not Received → Requested → <span className="bg-amber-100 text-amber-700 px-1 rounded">Partial</span> (use for incomplete - specify what's received and what's still needed) → <span className="bg-blue-100 text-blue-700 px-1 rounded">Complete</span>. 
                <span className="bg-green-100 text-green-700 px-1 rounded ml-2">MIN</span> = Required for Quick Estimation.
              </p>
            </div>
            )}
          </div>
        ) : viewMode === 'detailed' ? (
          /* ========== INCOME STATEMENT - REPORTED|ADJ|NORM FORMAT ========== */
          <>
          {/* Review Flags Panel */}
          {Object.keys(reviewFlags).length > 0 && (
            <div className="mb-4 border rounded-lg overflow-hidden">
              <div 
                className="bg-amber-100 px-3 py-2 flex items-center justify-between cursor-pointer hover:bg-amber-200"
                onClick={() => setShowReviewFlags(!showReviewFlags)}
              >
                <div className="font-bold flex items-center gap-2">
                  🚩 Review Flags
                  <span className="text-sm font-normal text-amber-700">
                    ({Object.keys(reviewFlags).filter(k => reviewFlags[k].type !== 'resolved').length} active)
                  </span>
                </div>
                <ChevronDown className={`w-4 h-4 transition-transform ${showReviewFlags ? 'rotate-180' : ''}`} />
              </div>
              {showReviewFlags && (
                <div className="p-3 bg-white max-h-64 overflow-y-auto">
                  <div className="flex gap-2 mb-2 text-xs">
                    <span className="px-2 py-0.5 bg-amber-200 text-amber-800 rounded">🔍 Review</span>
                    <span className="px-2 py-0.5 bg-purple-200 text-purple-800 rounded">👤 Client</span>
                    <span className="px-2 py-0.5 bg-green-200 text-green-800 rounded">✓ Resolved</span>
                  </div>
                  <table className="w-full text-xs border-collapse">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="p-1 border text-left">Location</th>
                        <th className="p-1 border text-left">Item</th>
                        <th className="p-1 border text-left" style={{minWidth: '200px'}}>Note</th>
                        <th className="p-1 border text-center w-20">Type</th>
                        <th className="p-1 border text-center w-16">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(reviewFlags).map(([key, flag]) => {
                        const parts = key.split('_');
                        const section = parts[0];
                        const item = parts.slice(1).join(' ');
                        return (
                          <tr key={key} className={flag.type === 'resolved' ? 'bg-green-50 opacity-60' : flag.type === 'client' ? 'bg-purple-50' : 'bg-amber-50'}>
                            <td className="p-1 border capitalize">{section}</td>
                            <td className="p-1 border font-medium">{item}</td>
                            <td className="p-0 border">
                              <input 
                                type="text"
                                value={flag.note || ''}
                                onChange={e => setReviewFlags(prev => ({...prev, [key]: {...prev[key], note: e.target.value}}))}
                                className="w-full p-1 text-xs border-0"
                                placeholder="Add note..."
                              />
                            </td>
                            <td className="p-1 border text-center">
                              <select 
                                value={flag.type}
                                onChange={e => setReviewFlags(prev => ({...prev, [key]: {...prev[key], type: e.target.value}}))}
                                className="text-xs p-0.5 border rounded"
                              >
                                <option value="review">🔍 Review</option>
                                <option value="client">👤 Client</option>
                                <option value="resolved">✓ Resolved</option>
                              </select>
                            </td>
                            <td className="p-1 border text-center">
                              <button 
                                onClick={() => {
                                  const newFlags = {...reviewFlags};
                                  delete newFlags[key];
                                  setReviewFlags(newFlags);
                                }}
                                className="text-red-500 hover:text-red-700"
                                title="Remove flag"
                              >
                                ✕
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="mt-2 flex gap-2">
                    <button 
                      onClick={() => {
                        const resolved = {};
                        Object.entries(reviewFlags).forEach(([k, v]) => {
                          if (v.type !== 'resolved') resolved[k] = v;
                        });
                        setReviewFlags(resolved);
                      }}
                      className="text-xs px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded"
                    >
                      Hide Resolved
                    </button>
                    <button 
                      onClick={() => setReviewFlags({})}
                      className="text-xs px-2 py-1 bg-red-100 hover:bg-red-200 text-red-700 rounded"
                    >
                      Clear All
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
          
          <div className="overflow-x-auto">
            <div className="flex justify-between items-center mb-3">
              <div className="flex items-center gap-4">
                <h2 className="text-lg font-bold">Income Statement - Quality of Earnings Format</h2>
                <button onClick={() => setViewMode('accrualpl')} className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300">
                  ← Back to Entry
                </button>
              </div>
              <div className="flex items-center gap-4">
                {/* View Mode Toggle */}
                <div className="flex items-center gap-1 bg-gray-100 p-1 rounded">
                  <button 
                    onClick={() => setIncomeStmtViewMode('full')}
                    className={`px-2 py-1 text-xs rounded ${incomeStmtViewMode === 'full' ? 'bg-white shadow font-semibold' : 'text-gray-600 hover:bg-gray-200'}`}
                  >
                    With Adjustments
                  </button>
                  <button 
                    onClick={() => setIncomeStmtViewMode('actuals')}
                    className={`px-2 py-1 text-xs rounded ${incomeStmtViewMode === 'actuals' ? 'bg-white shadow font-semibold' : 'text-gray-600 hover:bg-gray-200'}`}
                  >
                    Actuals
                  </button>
                  <button 
                    onClick={() => setIncomeStmtViewMode('normalized')}
                    className={`px-2 py-1 text-xs rounded ${incomeStmtViewMode === 'normalized' ? 'bg-white shadow font-semibold' : 'text-gray-600 hover:bg-gray-200'}`}
                  >
                    Normalized
                  </button>
                  <button 
                    onClick={() => setIncomeStmtViewMode('monthly')}
                    className={`px-2 py-1 text-xs rounded ${incomeStmtViewMode === 'monthly' ? 'bg-white shadow font-semibold' : 'text-gray-600 hover:bg-gray-200'}`}
                  >
                    Monthly
                  </button>
                </div>
                {incomeStmtViewMode !== 'monthly' && (
                  <label className="flex items-center gap-1 text-sm">
                    <input type="checkbox" checked={showAllYears} onChange={e => setShowAllYears(e.target.checked)} />
                    Show All 5 Years
                  </label>
                )}
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600">Basis:</span>
                  <span className="p-1 border rounded text-sm bg-gray-100 font-medium">{selectedValuationBasis === 'cash' ? 'Cash' : selectedValuationBasis === 'accrual' ? 'Accrual' : 'Tax Return'}</span>
                  <span className="text-xs text-gray-500">(set below)</span>
                </div>
                {incomeStmtViewMode === 'actuals' && (
                  <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-300">
                    <span className="text-xs text-gray-600">YoY Variance:</span>
                    <select
                      value={monthlyTtmConfig.yoyCompareMode || 'prior'}
                      onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, yoyCompareMode: e.target.value})}
                      className="px-1 py-0.5 border rounded text-xs"
                    >
                      <option value="prior">vs Prior Year</option>
                      <option value="average">vs Average</option>
                    </select>
                    <label className="flex items-center gap-1 text-xs" title="Highlight variances above this percentage">
                      <span>≥</span>
                      <input 
                        type="number" 
                        value={monthlyTtmConfig.annVsTtmVarianceThreshold} 
                        onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, annVsTtmVarianceThreshold: parseInt(e.target.value) || 15})}
                        className="w-12 px-1 py-0.5 border rounded text-xs text-center"
                        min="1"
                        max="100"
                      />
                      <span>%</span>
                    </label>
                    <label className="flex items-center gap-1 text-xs" title="Ignore items below this dollar amount">
                      <span>Min $</span>
                      <input 
                        type="number" 
                        value={monthlyTtmConfig.annVsTtmMaterialityThreshold} 
                        onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, annVsTtmMaterialityThreshold: parseInt(e.target.value) || 1000})}
                        className="w-16 px-1 py-0.5 border rounded text-xs text-center"
                        min="0"
                        step="100"
                      />
                    </label>
                  </div>
                )}
                {incomeStmtViewMode === 'normalized' && (
                  <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-300">
                    <span className="text-xs text-gray-600">YoY Variance:</span>
                    <select
                      value={monthlyTtmConfig.yoyCompareMode || 'prior'}
                      onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, yoyCompareMode: e.target.value})}
                      className="px-1 py-0.5 border rounded text-xs"
                    >
                      <option value="prior">vs Prior Year</option>
                      <option value="average">vs Average</option>
                    </select>
                    <label className="flex items-center gap-1 text-xs" title="Highlight variances above this percentage">
                      <span>≥</span>
                      <input 
                        type="number" 
                        value={monthlyTtmConfig.annVsTtmVarianceThreshold} 
                        onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, annVsTtmVarianceThreshold: parseInt(e.target.value) || 15})}
                        className="w-12 px-1 py-0.5 border rounded text-xs text-center"
                        min="1"
                        max="100"
                      />
                      <span>%</span>
                    </label>
                    <label className="flex items-center gap-1 text-xs" title="Ignore items below this dollar amount">
                      <span>Min $</span>
                      <input 
                        type="number" 
                        value={monthlyTtmConfig.annVsTtmMaterialityThreshold} 
                        onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, annVsTtmMaterialityThreshold: parseInt(e.target.value) || 1000})}
                        className="w-16 px-1 py-0.5 border rounded text-xs text-center"
                        min="0"
                        step="100"
                      />
                    </label>
                  </div>
                )}
                {incomeStmtViewMode === 'monthly' && (
                  <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-300">
                    <span className="text-xs text-gray-600">Monthly Variance:</span>
                    <label className="flex items-center gap-1 text-xs" title="Highlight variances above this percentage">
                      <span>≥</span>
                      <input 
                        type="number" 
                        value={monthlyTtmConfig.varianceThreshold || 20} 
                        onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, varianceThreshold: parseInt(e.target.value) || 20})}
                        className="w-12 px-1 py-0.5 border rounded text-xs text-center"
                        min="1"
                        max="100"
                      />
                      <span>%</span>
                    </label>
                    <label className="flex items-center gap-1 text-xs" title="Ignore items below this dollar amount">
                      <span>Min $</span>
                      <input 
                        type="number" 
                        value={monthlyTtmConfig.monthlyMaterialityThreshold || 500} 
                        onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, monthlyMaterialityThreshold: parseInt(e.target.value) || 500})}
                        className="w-16 px-1 py-0.5 border rounded text-xs text-center"
                        min="0"
                        step="100"
                      />
                    </label>
                  </div>
                )}
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              {incomeStmtViewMode === 'full' && 'Reported | Adjustment | Normalized format showing how adjustments map to P&L lines.'}
              {incomeStmtViewMode === 'actuals' && `Actual figures with ${ytdLabel} (${ytdAnnualized.ytdMonthCount} months) and Annualized projections for trend analysis.`}
              {incomeStmtViewMode === 'normalized' && 'Normalized (adjusted) figures only - clean view for valuation discussions.'}
              {incomeStmtViewMode === 'monthly' && 'Monthly TTM breakdown with estimated normalized EBITDA. Negative EBITDA months highlighted.'}
            </p>
            
            {/* Warning if no monthly data for actuals view */}
            {incomeStmtViewMode === 'actuals' && ytdAnnualized.revenue.totalYtd === 0 && (
              <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm">
                <strong>⚠️ No Monthly Data:</strong> YTD and Annualized columns require monthly data entry on the TTM P&L tab. 
                Currently showing $0 because no monthly breakdown exists.
              </div>
            )}
            
            {/* FULL VIEW - Actual | Adj | Normalized */}
            {incomeStmtViewMode === 'full' && (
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="text-left p-2 border-2 border-gray-400" rowSpan="2">Line Item</th>
                  {showAllYears && <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year1 || 'Year 1'}</th>}
                  {showAllYears && <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year2 || 'Year 2'}</th>}
                  <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year3 || 'Year 3'}</th>
                  <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year4 || 'Year 4'}</th>
                  <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year5 || 'Year 5'}</th>
                  <th className="text-center p-2 border-2 border-gray-400 bg-blue-100" colSpan="3">{ttmLabel}</th>
                </tr>
                <tr className="bg-gray-100">
                  {showAllYears && <><th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th></>}
                  {showAllYears && <><th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th></>}
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th>
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th>
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th>
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs bg-blue-50">Actual</th><th className="p-1 border text-xs bg-blue-50">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-200">Norm</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-blue-50 font-semibold"><td colSpan={showAllYears ? 19 : 13} className="p-1.5 border text-sm">REVENUE</td></tr>
                {activeRevenueCategories.map(cat => {
                  const getLineAdj = (yearLabel) => {
                    const yearAdjs = adjustmentItems.filter(a => 
                      a.included && 
                      (a.plLine === `Revenue: ${cat.name}`) && 
                      (a.year === 'All Years' || a.year === yearLabel)
                    );
                    const adds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                    const deducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                    return adds - deducts;
                  };
                  const adj1 = getLineAdj(basisYearLabels.year1);
                  const adj2 = getLineAdj(basisYearLabels.year2);
                  const adj3 = getLineAdj(basisYearLabels.year3);
                  const adj4 = getLineAdj(basisYearLabels.year4);
                  const adj5 = getLineAdj(basisYearLabels.year5);
                  const adjTTM = getLineAdj('TTM');
                  const formatAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  return (
                    <tr key={cat.id}>
                      <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                      {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year1)}</td><td className="p-1 border text-center">{formatAdj(adj1)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year1 + adj1)}</td></>}
                      {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year2)}</td><td className="p-1 border text-center">{formatAdj(adj2)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year2 + adj2)}</td></>}
                      <td className="p-1 border text-right">{formatCurrency(cat.year3)}</td><td className="p-1 border text-center">{formatAdj(adj3)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year3 + adj3)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.year4)}</td><td className="p-1 border text-center">{formatAdj(adj4)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year4 + adj4)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.year5)}</td><td className="p-1 border text-center">{formatAdj(adj5)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year5 + adj5)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.ttm)}</td><td className="p-1 border text-center">{formatAdj(adjTTM)}</td><td className="p-1 border text-right bg-blue-200">{formatCurrency(cat.ttm + adjTTM)}</td>
                    </tr>
                  );
                })}
                <tr className="font-bold">
                  {(() => {
                    const getYearRevAdj = (yearLabel) => {
                      const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Revenue' || a.plLine.startsWith('Revenue: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const revAdds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                      const revDeducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      return revAdds - revDeducts;
                    };
                    const revAdj1 = getYearRevAdj(basisYearLabels.year1);
                    const revAdj2 = getYearRevAdj(basisYearLabels.year2);
                    const revAdj3 = getYearRevAdj(basisYearLabels.year3);
                    const revAdj4 = getYearRevAdj(basisYearLabels.year4);
                    const revAdj5 = getYearRevAdj(basisYearLabels.year5);
                    const revAdjTTM = getYearRevAdj('TTM');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total Revenue</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.year1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(revAdj1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(revenueAnalysis.totals.year1 + revAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.year2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(revAdj2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(revenueAnalysis.totals.year2 + revAdj2)}</td></>}
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.year3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(revAdj3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(revenueAnalysis.totals.year3 + revAdj3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.year4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(revAdj4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(revenueAnalysis.totals.year4 + revAdj4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.year5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(revAdj5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(revenueAnalysis.totals.year5 + revAdj5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.ttm)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(revAdjTTM)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(revenueAnalysis.totals.ttm + revAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>
                <tr className="bg-slate-100 font-semibold"><td colSpan={showAllYears ? 19 : 13} className="p-1.5 border text-sm">COST OF GOODS SOLD</td></tr>
                {activeCogsCategories.map(cat => {
                  const getLineAdj = (yearLabel) => {
                    const yearAdjs = adjustmentItems.filter(a => 
                      a.included && 
                      (a.plLine === `COGS: ${cat.name}`) && 
                      (a.year === 'All Years' || a.year === yearLabel)
                    );
                    const adds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                    const deducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                    return adds - deducts;
                  };
                  const adj1 = getLineAdj(basisYearLabels.year1);
                  const adj2 = getLineAdj(basisYearLabels.year2);
                  const adj3 = getLineAdj(basisYearLabels.year3);
                  const adj4 = getLineAdj(basisYearLabels.year4);
                  const adj5 = getLineAdj(basisYearLabels.year5);
                  const adjTTM = getLineAdj('TTM');
                  const formatAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  return (
                    <tr key={cat.id}>
                      <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                      {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year1)}</td><td className="p-1 border text-center">{formatAdj(adj1)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year1 + adj1)}</td></>}
                      {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year2)}</td><td className="p-1 border text-center">{formatAdj(adj2)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year2 + adj2)}</td></>}
                      <td className="p-1 border text-right">{formatCurrency(cat.year3)}</td><td className="p-1 border text-center">{formatAdj(adj3)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year3 + adj3)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.year4)}</td><td className="p-1 border text-center">{formatAdj(adj4)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year4 + adj4)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.year5)}</td><td className="p-1 border text-center">{formatAdj(adj5)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year5 + adj5)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.ttm)}</td><td className="p-1 border text-center">{formatAdj(adjTTM)}</td><td className="p-1 border text-right bg-blue-200">{formatCurrency(cat.ttm + adjTTM)}</td>
                    </tr>
                  );
                })}
                <tr className="font-bold">
                  {(() => {
                    const getYearCOGSAdj = (yearLabel) => {
                      const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const cogsAdds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                      const cogsDeducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      return cogsAdds - cogsDeducts;
                    };
                    const cogsAdj1 = getYearCOGSAdj(basisYearLabels.year1);
                    const cogsAdj2 = getYearCOGSAdj(basisYearLabels.year2);
                    const cogsAdj3 = getYearCOGSAdj(basisYearLabels.year3);
                    const cogsAdj4 = getYearCOGSAdj(basisYearLabels.year4);
                    const cogsAdj5 = getYearCOGSAdj(basisYearLabels.year5);
                    const cogsAdjTTM = getYearCOGSAdj('TTM');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 bg-gray-50">Total COGS</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-gray-50">{formatCurrency(cogsAnalysis.totals.year1)}</td><td className="p-1 border border-t-2 border-b-2 border-gray-400 text-center bg-gray-50">{formatAdj(cogsAdj1)}</td><td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-blue-100">{formatCurrency(cogsAnalysis.totals.year1 + cogsAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-gray-50">{formatCurrency(cogsAnalysis.totals.year2)}</td><td className="p-1 border border-t-2 border-b-2 border-gray-400 text-center bg-gray-50">{formatAdj(cogsAdj2)}</td><td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-blue-100">{formatCurrency(cogsAnalysis.totals.year2 + cogsAdj2)}</td></>}
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-gray-50">{formatCurrency(cogsAnalysis.totals.year3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-center bg-gray-50">{formatAdj(cogsAdj3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-blue-100">{formatCurrency(cogsAnalysis.totals.year3 + cogsAdj3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-gray-50">{formatCurrency(cogsAnalysis.totals.year4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-center bg-gray-50">{formatAdj(cogsAdj4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-blue-100">{formatCurrency(cogsAnalysis.totals.year4 + cogsAdj4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-gray-50">{formatCurrency(cogsAnalysis.totals.year5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-center bg-gray-50">{formatAdj(cogsAdj5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-blue-100">{formatCurrency(cogsAnalysis.totals.year5 + cogsAdj5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-gray-50">{formatCurrency(cogsAnalysis.totals.ttm)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-center bg-gray-50">{formatAdj(cogsAdjTTM)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-gray-400 text-right bg-blue-200">{formatCurrency(cogsAnalysis.totals.ttm + cogsAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>
                <tr className="font-bold">
                  {(() => {
                    // Calculate combined Revenue and COGS adjustments for Gross Profit
                    const getGPAdj = (yearLabel) => {
                      const revAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Revenue' || a.plLine.startsWith('Revenue: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const revAdds = revAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                      const revDeducts = revAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const revAdj = revAdds - revDeducts;
                      
                      const cogsAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const cogsAdds = cogsAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                      const cogsDeducts = cogsAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const cogsAdj = cogsAdds - cogsDeducts;
                      
                      // GP adjustment: + rev adjustment, - cogs adjustment (since COGS increase reduces GP)
                      return revAdj - cogsAdj;
                    };
                    const gpAdj1 = getGPAdj(basisYearLabels.year1);
                    const gpAdj2 = getGPAdj(basisYearLabels.year2);
                    const gpAdj3 = getGPAdj(basisYearLabels.year3);
                    const gpAdj4 = getGPAdj(basisYearLabels.year4);
                    const gpAdj5 = getGPAdj(basisYearLabels.year5);
                    const gpAdjTTM = getGPAdj('TTM');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    const gpTotals = {
                      year1: revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1,
                      year2: revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2,
                      year3: revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3,
                      year4: revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4,
                      year5: revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5,
                      ttm: revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm
                    };
                    return (
                      <>
                        <td className="p-1 border bg-gray-50">Gross Profit</td>
                        {showAllYears && <><td className="p-1 border text-right bg-gray-50">{formatCurrency(gpTotals.year1)}</td><td className="p-1 border text-center bg-gray-50">{formatAdj(gpAdj1)}</td><td className="p-1 border text-right bg-blue-100">{formatCurrency(gpTotals.year1 + gpAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border text-right bg-gray-50">{formatCurrency(gpTotals.year2)}</td><td className="p-1 border text-center bg-gray-50">{formatAdj(gpAdj2)}</td><td className="p-1 border text-right bg-blue-100">{formatCurrency(gpTotals.year2 + gpAdj2)}</td></>}
                        <td className="p-1 border text-right bg-gray-50">{formatCurrency(gpTotals.year3)}</td>
                        <td className="p-1 border text-center bg-gray-50">{formatAdj(gpAdj3)}</td>
                        <td className="p-1 border text-right bg-blue-100">{formatCurrency(gpTotals.year3 + gpAdj3)}</td>
                        <td className="p-1 border text-right bg-gray-50">{formatCurrency(gpTotals.year4)}</td>
                        <td className="p-1 border text-center bg-gray-50">{formatAdj(gpAdj4)}</td>
                        <td className="p-1 border text-right bg-blue-100">{formatCurrency(gpTotals.year4 + gpAdj4)}</td>
                        <td className="p-1 border text-right bg-gray-50">{formatCurrency(gpTotals.year5)}</td>
                        <td className="p-1 border text-center bg-gray-50">{formatAdj(gpAdj5)}</td>
                        <td className="p-1 border text-right bg-blue-100">{formatCurrency(gpTotals.year5 + gpAdj5)}</td>
                        <td className="p-1 border text-right bg-gray-50">{formatCurrency(gpTotals.ttm)}</td>
                        <td className="p-1 border text-center bg-gray-50">{formatAdj(gpAdjTTM)}</td>
                        <td className="p-1 border text-right bg-blue-200">{formatCurrency(gpTotals.ttm + gpAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>
                <tr className="bg-slate-50 font-semibold"><td colSpan={showAllYears ? 19 : 13} className="p-1.5 border text-sm">OPERATING EXPENSES</td></tr>
                {/* Owner's Salary Line - memo line for adjustment visibility (not in totals) */}
                {(() => {
                  // Calculate adjustment for each period
                  // Now that salary deduction is shown on the Payroll line, this shows the full market replacement
                  const market = ownerCompensation.marketReplacement || 0;
                  const getOwnerAdj = (period) => {
                    // If embedded in wages, show market replacement as the adjustment (since deduction is on Payroll line)
                    // If NOT embedded, show the net (market - salary) since there's nothing to deduct
                    if (ownerCompensation.embeddedInWages) {
                      return mkFor(period) > 0 ? mkFor(period) : 0; // Full market replacement (per year, Colleen 10-26)
                    } else {
                      const salary = ownerCompensation[period]?.salary || 0;
                      return mkFor(period) > 0 ? -(salary - mkFor(period)) : 0; // Net: market - salary
                    }
                  };
                  const formatOwnerAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj < 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  // Show if there's salary data OR if market replacement is set
                  const hasSalary = ownerCompensation.year1?.salary || ownerCompensation.year2?.salary || ownerCompensation.year3?.salary || ownerCompensation.year4?.salary || ownerCompensation.year5?.salary || ownerCompensation.ttm?.salary;
                  if (!hasSalary && !market) return null;
                  
                  // Actual column: Show $0 if embedded (salary is in Payroll), otherwise show actual salary
                  const getActual = (period) => {
                    if (ownerCompensation.embeddedInWages) return 0; // Salary is in Payroll line
                    return ownerCompensation[period]?.salary || 0;
                  };
                  
                  return (
                    <tr>
                      <td className="p-1 border pl-4 font-medium">
                        Owner's Salary
                        <span className="text-xs text-gray-500 italic ml-1">(adj to market)</span>
                      </td>
                      {showAllYears && <>
                        <td className="p-1 border text-right">{formatCurrency(getActual('year1'))}</td>
                        <td className="p-1 border text-center">{formatOwnerAdj(getOwnerAdj('year1'))}</td>
                        <td className="p-1 border text-right bg-blue-50">{formatCurrency(mkFor('year1'))}</td>
                      </>}
                      {showAllYears && <>
                        <td className="p-1 border text-right">{formatCurrency(getActual('year2'))}</td>
                        <td className="p-1 border text-center">{formatOwnerAdj(getOwnerAdj('year2'))}</td>
                        <td className="p-1 border text-right bg-blue-50">{formatCurrency(mkFor('year2'))}</td>
                      </>}
                      <td className="p-1 border text-right">{formatCurrency(getActual('year3'))}</td>
                      <td className="p-1 border text-center">{formatOwnerAdj(getOwnerAdj('year3'))}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(mkFor('year3'))}</td>
                      <td className="p-1 border text-right">{formatCurrency(getActual('year4'))}</td>
                      <td className="p-1 border text-center">{formatOwnerAdj(getOwnerAdj('year4'))}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(mkFor('year4'))}</td>
                      <td className="p-1 border text-right">{formatCurrency(getActual('year5'))}</td>
                      <td className="p-1 border text-center">{formatOwnerAdj(getOwnerAdj('year5'))}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(mkFor('year5'))}</td>
                      <td className="p-1 border text-right">{formatCurrency(getActual('ttm'))}</td>
                      <td className="p-1 border text-center">{formatOwnerAdj(getOwnerAdj('ttm'))}</td>
                      <td className="p-1 border text-right bg-blue-200">{formatCurrency(mkFor('ttm'))}</td>
                    </tr>
                  );
                })()}
                {/* Employer Payroll Tax Adjustment - memo line showing tax impact of salary adjustment */}
                {(() => {
                  const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
                  if (payrollTaxRate === 0) return null;
                  
                  const market = ownerCompensation.marketReplacement || 0;
                  const getPayrollTaxAdj = (period) => {
                    const salary = period === 'ttm'
                      ? (ownerCompensation.ttm?.salary || (ownerCompensation.embeddedInWages ? (ownerCompensation.year5?.salary || 0) : 0))
                      : (ownerCompensation[period]?.salary || 0);
                    // (market - salary) * rate: Positive when market > salary (cost), Negative when market < salary (savings)
                    return ownerTaxAdj(salary, market, period);
                  };
                  const formatTaxAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj < 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  const formatTaxNorm = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj < 0 ? 'text-green-600' : 'text-red-600'}>{formatCurrency(adj)}</span>;
                  };
                  const hasSalary = ownerCompensation.year1?.salary || ownerCompensation.year2?.salary || ownerCompensation.year3?.salary || ownerCompensation.year4?.salary || ownerCompensation.year5?.salary || ownerCompensation.ttm?.salary;
                  if (!hasSalary && !market) return null;
                  return (
                    <tr className="text-gray-600">
                      <td className="p-1 border pl-6 text-xs italic">
                        Employer Payroll Tax ({payrollTaxLabel})
                      </td>
                      {showAllYears && <>
                        <td className="p-1 border text-right text-xs">-</td>
                        <td className="p-1 border text-center text-xs">{formatTaxAdj(getPayrollTaxAdj('year1'))}</td>
                        <td className="p-1 border text-right text-xs bg-blue-50">{formatTaxNorm(getPayrollTaxAdj('year1'))}</td>
                      </>}
                      {showAllYears && <>
                        <td className="p-1 border text-right text-xs">-</td>
                        <td className="p-1 border text-center text-xs">{formatTaxAdj(getPayrollTaxAdj('year2'))}</td>
                        <td className="p-1 border text-right text-xs bg-blue-50">{formatTaxNorm(getPayrollTaxAdj('year2'))}</td>
                      </>}
                      <td className="p-1 border text-right text-xs">-</td>
                      <td className="p-1 border text-center text-xs">{formatTaxAdj(getPayrollTaxAdj('year3'))}</td>
                      <td className="p-1 border text-right text-xs bg-blue-50">{formatTaxNorm(getPayrollTaxAdj('year3'))}</td>
                      <td className="p-1 border text-right text-xs">-</td>
                      <td className="p-1 border text-center text-xs">{formatTaxAdj(getPayrollTaxAdj('year4'))}</td>
                      <td className="p-1 border text-right text-xs bg-blue-50">{formatTaxNorm(getPayrollTaxAdj('year4'))}</td>
                      <td className="p-1 border text-right text-xs">-</td>
                      <td className="p-1 border text-center text-xs">{formatTaxAdj(getPayrollTaxAdj('year5'))}</td>
                      <td className="p-1 border text-right text-xs bg-blue-50">{formatTaxNorm(getPayrollTaxAdj('year5'))}</td>
                      <td className="p-1 border text-right text-xs">-</td>
                      <td className="p-1 border text-center text-xs">{formatTaxAdj(getPayrollTaxAdj('ttm'))}</td>
                      <td className="p-1 border text-right text-xs bg-blue-200">{formatTaxNorm(getPayrollTaxAdj('ttm'))}</td>
                    </tr>
                  );
                })()}
                {/* Other OpEx lines - dynamically rendered from opexCategories */}
                {activeOpexCategories.filter(cat => cat.name).map((cat) => {
                  // Calculate adjustments for each year - match by OpEx: name OR by plLine
                  // Also include line-based add-backs (addbackPct)
                  
                  const getYearAdj = (yearLabel, yearKey) => {
                    const yearAdjs = adjustmentItems.filter(a => 
                      a.included && 
                      (a.plLine === `OpEx: ${cat.name}` || a.plLine === cat.plLine || a.plLine === cat.name) && 
                      (a.year === 'All Years' || a.year === yearLabel)
                    );
                    const lineAdds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                    const lineDeducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                    // Add line-based add-back as negative adjustment (reduces expense)
                    const lineAddback = (cat.addbackPct || 0) > 0 ? -((cat[yearKey] || 0) * (cat.addbackPct / 100)) : 0;
                    
                    // NOTE: Owner salary deduction is handled ONLY via line-based adjustments
                    // (created via "Auto-Create Adjustments" button in Owner Compensation section)
                    // This prevents double-counting and makes the adjustment flow explicit
                    
                    return lineAdds - lineDeducts + lineAddback;
                  };
                  const adj1 = getYearAdj(basisYearLabels.year1, 'year1');
                  const adj2 = getYearAdj(basisYearLabels.year2, 'year2');
                  const adj3 = getYearAdj(basisYearLabels.year3, 'year3');
                  const adj4 = getYearAdj(basisYearLabels.year4, 'year4');
                  const adj5 = getYearAdj(basisYearLabels.year5, 'year5');
                  const adjTTM = getYearAdj('TTM', 'ttm');
                  const hasAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false;
                  const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                  const formatAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  return (
                    <tr key={cat.id} className={hasAddback ? (isDiat ? 'bg-amber-50' : 'bg-green-50') : ''}>
                      <td className="p-1 border pl-4">
                        {cat.name || '(unnamed)'}
                        {hasAddback && <span className={`ml-1 text-xs ${isDiat ? 'text-amber-600' : 'text-green-600'}`}>({cat.addbackPct}% {isDiat ? cat.adjCategory?.charAt(0) : 'add-back'})</span>}
                      </td>
                      {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year1)}</td><td className="p-1 border text-center">{formatAdj(adj1)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year1 + adj1)}</td></>}
                      {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year2)}</td><td className="p-1 border text-center">{formatAdj(adj2)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year2 + adj2)}</td></>}
                      <td className="p-1 border text-right">{formatCurrency(cat.year3)}</td>
                      <td className="p-1 border text-center">{formatAdj(adj3)}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year3 + adj3)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.year4)}</td>
                      <td className="p-1 border text-center">{formatAdj(adj4)}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year4 + adj4)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.year5)}</td>
                      <td className="p-1 border text-center">{formatAdj(adj5)}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year5 + adj5)}</td>
                      <td className="p-1 border text-right">{formatCurrency(cat.ttm)}</td>
                      <td className="p-1 border text-center">{formatAdj(adjTTM)}</td>
                      <td className="p-1 border text-right bg-blue-200">{formatCurrency(cat.ttm + adjTTM)}</td>
                    </tr>
                  );
                })}
                
                {/* Maintenance CapEx - shows if Depreciation or Amortization is being added back */}
                {(() => {
                  const capexAdjs = adjustmentItems.filter(a => a.included && a.plLine === 'CapEx');
                  // With new logic: 'add' adds to expense (shown as positive increase)
                  const capexAdds = capexAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                  const capexDeducts = capexAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                  const capexNetChange = capexAdds - capexDeducts; // Positive = expense increases
                  const hasCapexWarning = (addbacks.depreciation || addbacks.amortization) && capexNetChange === 0;
                  const formatAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  if (capexNetChange === 0 && !hasCapexWarning) return null; // Only show if has value or warning
                  return (
                    <tr>
                      <td className="p-1 border pl-4 font-medium">
                        Maintenance CapEx
                        <span className="text-xs text-gray-500 italic ml-1">(adj only)</span>
                        {hasCapexWarning && <span className="text-orange-600 text-xs ml-1">⚠️ review</span>}
                      </td>
                      {showAllYears && <><td className="p-1 border text-right text-gray-400">-</td><td className="p-1 border text-center">{formatAdj(capexNetChange)}</td><td className="p-1 border text-right bg-blue-50">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td></>}
                      {showAllYears && <><td className="p-1 border text-right text-gray-400">-</td><td className="p-1 border text-center">{formatAdj(capexNetChange)}</td><td className="p-1 border text-right bg-blue-50">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td></>}
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(capexNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-50">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td>
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(capexNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-50">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td>
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(capexNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-50">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td>
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(capexNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-200">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td>
                    </tr>
                  );
                })()}

                {/* Rent (Market Adj) - for owner-occupied or below-market rent situations */}
                {(() => {
                  const rentAdjs = adjustmentItems.filter(a => a.included && a.plLine === 'Rent (Market Adj)');
                  const rentAdds = rentAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                  const rentDeducts = rentAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                  const rentNetChange = rentAdds - rentDeducts;
                  const formatAdj = (adj) => {
                    if (adj === 0) return '-';
                    return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                  };
                  if (rentNetChange === 0) return null; // Only show if there's an adjustment
                  return (
                    <tr>
                      <td className="p-1 border pl-4 font-medium">
                        Rent
                        <span className="text-xs text-gray-500 italic ml-1">(adj to market)</span>
                      </td>
                      {showAllYears && <><td className="p-1 border text-right text-gray-400">-</td><td className="p-1 border text-center">{formatAdj(rentNetChange)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(rentNetChange)}</td></>}
                      {showAllYears && <><td className="p-1 border text-right text-gray-400">-</td><td className="p-1 border text-center">{formatAdj(rentNetChange)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(rentNetChange)}</td></>}
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(rentNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(rentNetChange)}</td>
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(rentNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(rentNetChange)}</td>
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(rentNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-50">{formatCurrency(rentNetChange)}</td>
                      <td className="p-1 border text-right text-gray-400">-</td>
                      <td className="p-1 border text-center">{formatAdj(rentNetChange)}</td>
                      <td className="p-1 border text-right bg-blue-200">{formatCurrency(rentNetChange)}</td>
                    </tr>
                  );
                })()}

                {/* Total Operating Expenses Row */}
                <tr className="font-bold">
                  {(() => {
                    // Get OpEx adjustments from adjustmentItems (including Rent Market Adj and CapEx)
                    const getYearOpExAdj = (yearLabel) => {
                      const yearAdjs = adjustmentItems.filter(a => a.included && 
                        (a.plLine === 'OpEx' || a.plLine.startsWith('OpEx: ') || a.plLine === 'Rent (Market Adj)' || a.plLine === 'CapEx') && 
                        (a.year === 'All Years' || a.year === yearLabel));
                      const opexAdds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                      const opexDeducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      return opexAdds - opexDeducts;
                    };
                    // Get owner market replacement for each period (adds market to Normalized OpEx)
                    const market = ownerCompensation.marketReplacement || 0;
                    const getOwnerAdj = (period) => {
                      return mkFor(period); // Always add market replacement to Normalized (per year, Colleen 10-26)
                    };
                    // Get payroll tax adjustment (market - salary) * rate
                    const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
                    const getPayrollTaxAdj = (period) => {
                      const salary = period === 'ttm'
                        ? (ownerCompensation.ttm?.salary || (ownerCompensation.embeddedInWages ? (ownerCompensation.year5?.salary || 0) : 0))
                        : (ownerCompensation[period]?.salary || 0);
                      return ownerTaxAdj(salary, market, period);
                    };
                    // Get line-based add-backs total (reduces OpEx and Other Expense)
                    const getLineAddbackAdj = (yearKey) => {
                      const opexAddbacks = opexCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum - ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      const oeAddbacks = otherExpenseCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum - ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      return opexAddbacks + oeAddbacks;
                    };
                    // Combined OpEx adjustments (regular + rent + market replacement + payroll tax + line add-backs) for Normalized column
                    const opexAdj1 = getYearOpExAdj(basisYearLabels.year1) + getOwnerAdj('year1') + getPayrollTaxAdj('year1') + getLineAddbackAdj('year1');
                    const opexAdj2 = getYearOpExAdj(basisYearLabels.year2) + getOwnerAdj('year2') + getPayrollTaxAdj('year2') + getLineAddbackAdj('year2');
                    const opexAdj3 = getYearOpExAdj(basisYearLabels.year3) + getOwnerAdj('year3') + getPayrollTaxAdj('year3') + getLineAddbackAdj('year3');
                    const opexAdj4 = getYearOpExAdj(basisYearLabels.year4) + getOwnerAdj('year4') + getPayrollTaxAdj('year4') + getLineAddbackAdj('year4');
                    const opexAdj5 = getYearOpExAdj(basisYearLabels.year5) + getOwnerAdj('year5') + getPayrollTaxAdj('year5') + getLineAddbackAdj('year5');
                    const opexAdjTTM = getYearOpExAdj('TTM') + getOwnerAdj('ttm') + getPayrollTaxAdj('ttm') + getLineAddbackAdj('ttm');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    // OpEx Actual totals - from P&L only, NO owner salary (matches P&L)
                    const opexTotals = {
                      year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                      year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                      year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                      year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                      year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                      ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                    };
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total Operating Expenses</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(opexTotals.year1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(opexAdj1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(opexTotals.year1 + opexAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(opexTotals.year2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(opexAdj2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(opexTotals.year2 + opexAdj2)}</td></>}
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(opexTotals.year3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(opexAdj3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(opexTotals.year3 + opexAdj3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(opexTotals.year4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(opexAdj4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(opexTotals.year4 + opexAdj4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(opexTotals.year5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(opexAdj5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(opexTotals.year5 + opexAdj5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(opexTotals.ttm)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(opexAdjTTM)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(opexTotals.ttm + opexAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>

                {/* Operating Income Row - Gross Profit minus OpEx */}
                <tr className="font-bold bg-blue-100">
                  {(() => {
                    const opexTotals = {
                      year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                      year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                      year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                      year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                      year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                      ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                    };
                    const actualOpInc = {
                      year1: (revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1) - opexTotals.year1,
                      year2: (revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2) - opexTotals.year2,
                      year3: (revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3) - opexTotals.year3,
                      year4: (revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4) - opexTotals.year4,
                      year5: (revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5) - opexTotals.year5,
                      ttm: (revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm) - opexTotals.ttm
                    };
                    // Calculate Op Inc adjustment (Rev adj - COGS adj - OpEx adj + line add-backs)
                    const getOpIncAdj = (yearLabel, yearKey) => {
                      const revAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Revenue' || a.plLine.startsWith('Revenue: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const revAdj = revAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - revAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const cogsAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const cogsAdj = cogsAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - cogsAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const opexAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'OpEx' || a.plLine.startsWith('OpEx: ') || a.plLine === 'Rent (Market Adj)' || a.plLine === 'CapEx') && (a.year === 'All Years' || a.year === yearLabel));
                      const opexAdj = opexAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - opexAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const salary = yearKey === 'ttm'
                        ? (ownerCompensation.ttm?.salary || (ownerCompensation.embeddedInWages ? (ownerCompensation.year5?.salary || 0) : 0))
                        : (ownerCompensation[yearKey]?.salary || 0);
                      const market = mkFor(yearKey);
                      const ownerAdj = market > 0 ? -market : 0; // Market replacement reduces Operating Income (regardless of salary)
                      // Payroll tax adjustment (tax on market − tax on salary) - reduces Operating Income
                      const payrollTaxAdj = ownerTaxAdj(salary, market, yearKey);
                      // Line-based add-backs increase Operating Income
                      const lineAddback = opexCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      const oeLineAddback = otherExpenseCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      const oiLineDeduction = otherIncomeCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      return revAdj - cogsAdj - opexAdj + ownerAdj - payrollTaxAdj + lineAddback + oeLineAddback - oiLineDeduction;
                    };
                    const opIncAdj1 = getOpIncAdj(basisYearLabels.year1, 'year1');
                    const opIncAdj2 = getOpIncAdj(basisYearLabels.year2, 'year2');
                    const opIncAdj3 = getOpIncAdj(basisYearLabels.year3, 'year3');
                    const opIncAdj4 = getOpIncAdj(basisYearLabels.year4, 'year4');
                    const opIncAdj5 = getOpIncAdj(basisYearLabels.year5, 'year5');
                    const opIncAdjTTM = getOpIncAdj('TTM', 'ttm');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 bg-blue-100">Operating Income</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-50">{formatCurrency(actualOpInc.year1)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-blue-50">{formatAdj(opIncAdj1)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualOpInc.year1 + opIncAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-50">{formatCurrency(actualOpInc.year2)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-blue-50">{formatAdj(opIncAdj2)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualOpInc.year2 + opIncAdj2)}</td></>}
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-50">{formatCurrency(actualOpInc.year3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-blue-50">{formatAdj(opIncAdj3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualOpInc.year3 + opIncAdj3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-50">{formatCurrency(actualOpInc.year4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-blue-50">{formatAdj(opIncAdj4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualOpInc.year4 + opIncAdj4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-50">{formatCurrency(actualOpInc.year5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-blue-50">{formatAdj(opIncAdj5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualOpInc.year5 + opIncAdj5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-50">{formatCurrency(actualOpInc.ttm)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-blue-50">{formatAdj(opIncAdjTTM)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-200">{formatCurrency(actualOpInc.ttm + opIncAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>

                {/* OTHER INCOME (Non-Operating) */}
                {activeOtherIncomeCategories.some(cat => cat.name) && (
                  <>
                    <tr className="bg-gray-100 font-medium"><td colSpan={showAllYears ? 19 : 13} className="p-1 border text-xs text-gray-600">Other Income (Non-Operating)</td></tr>
                    {activeOtherIncomeCategories.filter(cat => cat.name).map(cat => {
                      const getLineAdj = (yearLabel, yearKey) => {
                        // Explicit adjustment items for this line
                        const yearAdjs = adjustmentItems.filter(a => 
                          a.included && 
                          (a.plLine === `OtherIncome: ${cat.name}`) && 
                          (a.year === 'All Years' || a.year === yearLabel)
                        );
                        const adds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                        const deducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                        // Line-based percentage deduction (removes non-operating income)
                        const lineDeduct = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false
                          ? (cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)
                          : 0;
                        return adds - deducts - lineDeduct;
                      };
                      const adj1 = getLineAdj(basisYearLabels.year1, 'year1');
                      const adj2 = getLineAdj(basisYearLabels.year2, 'year2');
                      const adj3 = getLineAdj(basisYearLabels.year3, 'year3');
                      const adj4 = getLineAdj(basisYearLabels.year4, 'year4');
                      const adj5 = getLineAdj(basisYearLabels.year5, 'year5');
                      const adjTTM = getLineAdj('TTM', 'ttm');
                      const formatAdj = (adj) => {
                        if (adj === 0) return '-';
                        return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                      };
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border pl-4">{cat.name}</td>
                          {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year1)}</td><td className="p-1 border text-center">{formatAdj(adj1)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year1 + adj1)}</td></>}
                          {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year2)}</td><td className="p-1 border text-center">{formatAdj(adj2)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year2 + adj2)}</td></>}
                          <td className="p-1 border text-right">{formatCurrency(cat.year3)}</td><td className="p-1 border text-center">{formatAdj(adj3)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year3 + adj3)}</td>
                          <td className="p-1 border text-right">{formatCurrency(cat.year4)}</td><td className="p-1 border text-center">{formatAdj(adj4)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year4 + adj4)}</td>
                          <td className="p-1 border text-right">{formatCurrency(cat.year5)}</td><td className="p-1 border text-center">{formatAdj(adj5)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year5 + adj5)}</td>
                          <td className="p-1 border text-right">{formatCurrency(cat.ttm)}</td><td className="p-1 border text-center">{formatAdj(adjTTM)}</td><td className="p-1 border text-right bg-blue-200">{formatCurrency(cat.ttm + adjTTM)}</td>
                        </tr>
                      );
                    })}
                    <tr className="font-bold">
                      {(() => {
                        const getYearOIAdj = (yearLabel, yearKey) => {
                          const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Income' || a.plLine.startsWith('OtherIncome: ')) && (a.year === 'All Years' || a.year === yearLabel));
                          const oiAdds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                          const oiDeducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                          // Line-based percentage deductions
                          const lineDeducts = otherIncomeCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                            .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                          return oiAdds - oiDeducts - lineDeducts;
                        };
                        const oiAdj1 = getYearOIAdj(basisYearLabels.year1, 'year1');
                        const oiAdj2 = getYearOIAdj(basisYearLabels.year2, 'year2');
                        const oiAdj3 = getYearOIAdj(basisYearLabels.year3, 'year3');
                        const oiAdj4 = getYearOIAdj(basisYearLabels.year4, 'year4');
                        const oiAdj5 = getYearOIAdj(basisYearLabels.year5, 'year5');
                        const oiAdjTTM = getYearOIAdj('TTM', 'ttm');
                        const formatAdj = (adj) => {
                          if (adj === 0) return '-';
                          return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                        };
                        return (
                          <>
                            <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total Other Income</td>
                            {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherIncomeAnalysis.totals.year1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oiAdj1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherIncomeAnalysis.totals.year1 + oiAdj1)}</td></>}
                            {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherIncomeAnalysis.totals.year2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oiAdj2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherIncomeAnalysis.totals.year2 + oiAdj2)}</td></>}
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherIncomeAnalysis.totals.year3)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oiAdj3)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherIncomeAnalysis.totals.year3 + oiAdj3)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherIncomeAnalysis.totals.year4)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oiAdj4)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherIncomeAnalysis.totals.year4 + oiAdj4)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherIncomeAnalysis.totals.year5)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oiAdj5)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherIncomeAnalysis.totals.year5 + oiAdj5)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherIncomeAnalysis.totals.ttm)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oiAdjTTM)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(otherIncomeAnalysis.totals.ttm + oiAdjTTM)}</td>
                          </>
                        );
                      })()}
                    </tr>
                  </>
                )}

                {/* OTHER EXPENSE (Non-Operating) */}
                {activeOtherExpenseCategories.some(cat => cat.name) && (
                  <>
                    <tr className="bg-gray-100 font-medium"><td colSpan={showAllYears ? 19 : 13} className="p-1 border text-xs text-gray-600">Other Expense (Non-Operating)</td></tr>
                    {activeOtherExpenseCategories.filter(cat => cat.name).map(cat => {
                      const getLineAdj = (yearLabel, yearKey) => {
                        const yearAdjs = adjustmentItems.filter(a => 
                          a.included && 
                          (a.plLine === `OtherExpense: ${cat.name}`) && 
                          (a.year === 'All Years' || a.year === yearLabel)
                        );
                        const adds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                        const deducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                        // Add line-based add-back as negative adjustment (reduces expense)
                        const lineAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false ? -((cat[yearKey] || 0) * (cat.addbackPct / 100)) : 0;
                        return adds - deducts + lineAddback;
                      };
                      const adj1 = getLineAdj(basisYearLabels.year1, 'year1');
                      const adj2 = getLineAdj(basisYearLabels.year2, 'year2');
                      const adj3 = getLineAdj(basisYearLabels.year3, 'year3');
                      const adj4 = getLineAdj(basisYearLabels.year4, 'year4');
                      const adj5 = getLineAdj(basisYearLabels.year5, 'year5');
                      const adjTTM = getLineAdj('TTM', 'ttm');
                      const hasAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false;
                      const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                      const formatAdj = (adj) => {
                        if (adj === 0) return '-';
                        return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                      };
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border pl-4">
                            {cat.name}
                            {hasAddback && <span className={`ml-1 text-xs ${isDiat ? 'text-amber-600' : 'text-green-600'}`}>({cat.addbackPct}% {isDiat ? cat.adjCategory?.charAt(0) : 'add-back'})</span>}
                          </td>
                          {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year1)}</td><td className="p-1 border text-center">{formatAdj(adj1)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year1 + adj1)}</td></>}
                          {showAllYears && <><td className="p-1 border text-right">{formatCurrency(cat.year2)}</td><td className="p-1 border text-center">{formatAdj(adj2)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year2 + adj2)}</td></>}
                          <td className="p-1 border text-right">{formatCurrency(cat.year3)}</td><td className="p-1 border text-center">{formatAdj(adj3)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year3 + adj3)}</td>
                          <td className="p-1 border text-right">{formatCurrency(cat.year4)}</td><td className="p-1 border text-center">{formatAdj(adj4)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year4 + adj4)}</td>
                          <td className="p-1 border text-right">{formatCurrency(cat.year5)}</td><td className="p-1 border text-center">{formatAdj(adj5)}</td><td className="p-1 border text-right bg-blue-50">{formatCurrency(cat.year5 + adj5)}</td>
                          <td className="p-1 border text-right">{formatCurrency(cat.ttm)}</td><td className="p-1 border text-center">{formatAdj(adjTTM)}</td><td className="p-1 border text-right bg-blue-200">{formatCurrency(cat.ttm + adjTTM)}</td>
                        </tr>
                      );
                    })}
                    <tr className="font-bold">
                      {(() => {
                        const getYearOEAdj = (yearLabel, yearKey) => {
                          const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Expense' || a.plLine.startsWith('OtherExpense: ')) && (a.year === 'All Years' || a.year === yearLabel));
                          const oeAdds = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                          const oeDeducts = yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                          // Add line-based add-backs (reduces expense)
                          const lineAddbacks = otherExpenseCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                            .reduce((sum, cat) => sum - ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                          return oeAdds - oeDeducts + lineAddbacks;
                        };
                        const oeAdj1 = getYearOEAdj(basisYearLabels.year1, 'year1');
                        const oeAdj2 = getYearOEAdj(basisYearLabels.year2, 'year2');
                        const oeAdj3 = getYearOEAdj(basisYearLabels.year3, 'year3');
                        const oeAdj4 = getYearOEAdj(basisYearLabels.year4, 'year4');
                        const oeAdj5 = getYearOEAdj(basisYearLabels.year5, 'year5');
                        const oeAdjTTM = getYearOEAdj('TTM', 'ttm');
                        const formatAdj = (adj) => {
                          if (adj === 0) return '-';
                          return <span className={adj > 0 ? 'text-red-600' : 'text-green-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                        };
                        return (
                          <>
                            <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total Other Expense</td>
                            {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherExpenseAnalysis.totals.year1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oeAdj1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherExpenseAnalysis.totals.year1 + oeAdj1)}</td></>}
                            {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherExpenseAnalysis.totals.year2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oeAdj2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherExpenseAnalysis.totals.year2 + oeAdj2)}</td></>}
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherExpenseAnalysis.totals.year3)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oeAdj3)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherExpenseAnalysis.totals.year3 + oeAdj3)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherExpenseAnalysis.totals.year4)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oeAdj4)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherExpenseAnalysis.totals.year4 + oeAdj4)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherExpenseAnalysis.totals.year5)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oeAdj5)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherExpenseAnalysis.totals.year5 + oeAdj5)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(otherExpenseAnalysis.totals.ttm)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-center bg-gray-50">{formatAdj(oeAdjTTM)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(otherExpenseAnalysis.totals.ttm + oeAdjTTM)}</td>
                          </>
                        );
                      })()}
                    </tr>
                  </>
                )}

                {/* Net Income Row - calculated from underlying totals with adjustments */}
                <tr className="font-bold">
                  {(() => {
                    // Net Income adjustment includes line-based add-backs
                    const getNiAdj = (yearLabel, period) => {
                      const revAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Revenue' || a.plLine.startsWith('Revenue: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const revAdj = revAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - revAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const cogsAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const cogsAdj = cogsAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - cogsAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      // OpEx adjustments including Rent (Market Adj) and CapEx
                      const opexAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'OpEx' || a.plLine.startsWith('OpEx: ') || a.plLine === 'Rent (Market Adj)' || a.plLine === 'CapEx') && (a.year === 'All Years' || a.year === yearLabel));
                      const opexAdj = opexAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - opexAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      // Owner market replacement adjustment
                      const salary = ownerCompensation[period]?.salary || 0;
                      const market = mkFor(period);
                      const ownerAdj = market > 0 ? -market : 0; // Market replacement reduces Net Income (regardless of salary)
                      // Payroll tax adjustment: (market - salary) * rate - reduces Net Income
                      const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
                      const payrollTaxAdj = ownerTaxAdj(salary, market, period);
                      const oiAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Income' || a.plLine.startsWith('OtherIncome: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const oiAdj = oiAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - oiAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      const oeAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Expense' || a.plLine.startsWith('OtherExpense: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const oeAdj = oeAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - oeAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      // Line-based add-backs increase Net Income
                      const lineAddback = opexCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                      const oeLineAddback = otherExpenseCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                      const oiLineDeduction = otherIncomeCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                      return revAdj - cogsAdj - opexAdj + ownerAdj - payrollTaxAdj + oiAdj - oeAdj + lineAddback + oeLineAddback - oiLineDeduction;
                    };
                    const niAdj1 = getNiAdj(basisYearLabels.year1, 'year1');
                    const niAdj2 = getNiAdj(basisYearLabels.year2, 'year2');
                    const niAdj3 = getNiAdj(basisYearLabels.year3, 'year3');
                    const niAdj4 = getNiAdj(basisYearLabels.year4, 'year4');
                    const niAdj5 = getNiAdj(basisYearLabels.year5, 'year5');
                    const niAdjTTM = getNiAdj('TTM', 'ttm');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    // Calculate actual Net Income from P&L values
                    // Net Income = Rev - COGS - OpEx (which includes DIAT items) + OtherInc - OtherExp
                    const opexTotals = {
                      year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                      year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                      year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                      year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                      year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                      ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                    };
                    const actualNetIncome = {
                      year1: revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1 - opexTotals.year1 + otherIncomeAnalysis.totals.year1 - otherExpenseAnalysis.totals.year1,
                      year2: revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2 - opexTotals.year2 + otherIncomeAnalysis.totals.year2 - otherExpenseAnalysis.totals.year2,
                      year3: revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3 - opexTotals.year3 + otherIncomeAnalysis.totals.year3 - otherExpenseAnalysis.totals.year3,
                      year4: revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4 - opexTotals.year4 + otherIncomeAnalysis.totals.year4 - otherExpenseAnalysis.totals.year4,
                      year5: revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5 - opexTotals.year5 + otherIncomeAnalysis.totals.year5 - otherExpenseAnalysis.totals.year5,
                      ttm: revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm - opexTotals.ttm + otherIncomeAnalysis.totals.ttm - otherExpenseAnalysis.totals.ttm
                    };
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 bg-gray-50">Net Income</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(actualNetIncome.year1)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-gray-50">{formatAdj(niAdj1)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualNetIncome.year1 + niAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(actualNetIncome.year2)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-gray-50">{formatAdj(niAdj2)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualNetIncome.year2 + niAdj2)}</td></>}
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(actualNetIncome.year3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-gray-50">{formatAdj(niAdj3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualNetIncome.year3 + niAdj3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(actualNetIncome.year4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-gray-50">{formatAdj(niAdj4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualNetIncome.year4 + niAdj4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(actualNetIncome.year5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-gray-50">{formatAdj(niAdj5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(actualNetIncome.year5 + niAdj5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(actualNetIncome.ttm)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-center bg-gray-50">{formatAdj(niAdjTTM)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-200">{formatCurrency(actualNetIncome.ttm + niAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>

                {/* EBITDA Row - calculated from underlying totals with adjustments */}
                <tr className="font-bold bg-green-100">
                  {(() => {
                    // Calculate EBITDA adjustment from sum of all adjustments
                    const getEbitdaAdj = (yearLabel, period) => {
                      // Revenue adjustments (add = increases EBITDA)
                      const revAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Revenue' || a.plLine.startsWith('Revenue: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const revAdj = revAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - revAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      
                      // COGS adjustments (add = increases expense = decreases EBITDA)
                      const cogsAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const cogsAdj = cogsAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - cogsAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      
                      // OpEx adjustments including Rent (Market Adj) and CapEx (add = increases expense = decreases EBITDA)
                      const opexAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'OpEx' || a.plLine.startsWith('OpEx: ') || a.plLine === 'Rent (Market Adj)' || a.plLine === 'CapEx') && (a.year === 'All Years' || a.year === yearLabel));
                      const opexAdj = opexAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - opexAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      
                      // Owner market replacement adjustment (market added to OpEx = decreases EBITDA)
                      // The full salary is added back via line-based addbacks, so we subtract market here
                      const salary = ownerCompensation[period]?.salary || 0;
                      const market = mkFor(period);
                      const ownerAdj = market > 0 ? -market : 0; // Market replacement reduces EBITDA (regardless of salary)
                      
                      // Employer payroll tax adjustment on the salary difference
                      const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
                      // Payroll tax adj = (market - salary) * rate
                      // Positive when market > salary (need to pay more taxes), Negative when market < salary (tax savings)
                      const payrollTaxAdj = ownerTaxAdj(salary, market, period);
                      
                      // Other Income adjustments (add = increases EBITDA)
                      const oiAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Income' || a.plLine.startsWith('OtherIncome: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const oiAdj = oiAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - oiAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      
                      // Other Expense adjustments (add = increases expense = decreases EBITDA)
                      const oeAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Expense' || a.plLine.startsWith('OtherExpense: ')) && (a.year === 'All Years' || a.year === yearLabel));
                      const oeAdj = oeAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - oeAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                      
                      // EBITDA adjustment: +rev, -cogs, -opex, +ownerAdj, -payrollTax, +otherInc, -otherExp + non-DIAT line add-backs
                      // payrollTaxAdj follows display convention: negative when salary > market (tax savings shown as expense reduction)
                      // Non-DIAT line add-backs (from Line-Based Add-backs without D/I/A/T category) - includes both OpEx and Other Expense
                      const nonDiatAddbackOpex = opexCategories.filter(cat => cat.adjIncluded !== false && !['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) && (cat.addbackPct || 0) > 0)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                      const nonDiatAddbackOE = otherExpenseCategories.filter(cat => cat.adjIncluded !== false && !['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) && (cat.addbackPct || 0) > 0)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                      const nonDiatAddback = nonDiatAddbackOpex + nonDiatAddbackOE;
                      return revAdj - cogsAdj - opexAdj + ownerAdj - payrollTaxAdj + oiAdj - oeAdj + nonDiatAddback;
                    };
                    const ebitdaAdj1 = getEbitdaAdj(basisYearLabels.year1, 'year1');
                    const ebitdaAdj2 = getEbitdaAdj(basisYearLabels.year2, 'year2');
                    const ebitdaAdj3 = getEbitdaAdj(basisYearLabels.year3, 'year3');
                    const ebitdaAdj4 = getEbitdaAdj(basisYearLabels.year4, 'year4');
                    const ebitdaAdj5 = getEbitdaAdj(basisYearLabels.year5, 'year5');
                    const ebitdaAdjTTM = getEbitdaAdj('TTM', 'ttm');
                    const formatAdj = (adj) => {
                      if (adj === 0) return '-';
                      return <span className={adj > 0 ? 'text-green-600' : 'text-red-600'}>{adj > 0 ? '+' : ''}{formatCurrency(adj)}</span>;
                    };
                    // Calculate actual EBITDA from P&L values
                    // EBITDA = Net Income + DIAT add-backs (from Line-Based Add-backs with Category = D/I/A/T)
                    const opexTotals = {
                      year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                      year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                      year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                      year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                      year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                      ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                    };
                    // Calculate DIAT add-backs from OpEx and Other Expense items with DIAT adjCategory and addbackPct
                    const getDiatAddback = (yearKey) => {
                      const fromOpex = opexCategories.filter(cat => cat.adjIncluded !== false && ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) && (cat.addbackPct || 0) > 0)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      const fromOE = otherExpenseCategories.filter(cat => cat.adjIncluded !== false && ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) && (cat.addbackPct || 0) > 0)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      return fromOpex + fromOE;
                    };
                    const diatAddbacks = {
                      year1: getDiatAddback('year1'),
                      year2: getDiatAddback('year2'),
                      year3: getDiatAddback('year3'),
                      year4: getDiatAddback('year4'),
                      year5: getDiatAddback('year5'),
                      ttm: getDiatAddback('ttm')
                    };
                    // Net Income = Rev - COGS - OpEx + OtherInc - OtherExp
                    const netIncome = {
                      year1: revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1 - opexTotals.year1 + otherIncomeAnalysis.totals.year1 - otherExpenseAnalysis.totals.year1,
                      year2: revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2 - opexTotals.year2 + otherIncomeAnalysis.totals.year2 - otherExpenseAnalysis.totals.year2,
                      year3: revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3 - opexTotals.year3 + otherIncomeAnalysis.totals.year3 - otherExpenseAnalysis.totals.year3,
                      year4: revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4 - opexTotals.year4 + otherIncomeAnalysis.totals.year4 - otherExpenseAnalysis.totals.year4,
                      year5: revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5 - opexTotals.year5 + otherIncomeAnalysis.totals.year5 - otherExpenseAnalysis.totals.year5,
                      ttm: revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm - opexTotals.ttm + otherIncomeAnalysis.totals.ttm - otherExpenseAnalysis.totals.ttm
                    };
                    // EBITDA = Net Income + DIAT add-backs
                    const actualEbitda = {
                      year1: netIncome.year1 + diatAddbacks.year1,
                      year2: netIncome.year2 + diatAddbacks.year2,
                      year3: netIncome.year3 + diatAddbacks.year3,
                      year4: netIncome.year4 + diatAddbacks.year4,
                      year5: netIncome.year5 + diatAddbacks.year5,
                      ttm: netIncome.ttm + diatAddbacks.ttm
                    };
                    return (
                      <>
                        <td className="p-1 border border-b-2 border-b-gray-400 bg-green-100">EBITDA</td>
                        {showAllYears && <><td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-50">{formatCurrency(actualEbitda.year1)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-center bg-green-50">{formatAdj(ebitdaAdj1)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-100">{formatCurrency(actualEbitda.year1 + ebitdaAdj1)}</td></>}
                        {showAllYears && <><td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-50">{formatCurrency(actualEbitda.year2)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-center bg-green-50">{formatAdj(ebitdaAdj2)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-100">{formatCurrency(actualEbitda.year2 + ebitdaAdj2)}</td></>}
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-50">{formatCurrency(actualEbitda.year3)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-center bg-green-50">{formatAdj(ebitdaAdj3)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-100">{formatCurrency(actualEbitda.year3 + ebitdaAdj3)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-50">{formatCurrency(actualEbitda.year4)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-center bg-green-50">{formatAdj(ebitdaAdj4)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-100">{formatCurrency(actualEbitda.year4 + ebitdaAdj4)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-50">{formatCurrency(actualEbitda.year5)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-center bg-green-50">{formatAdj(ebitdaAdj5)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-100">{formatCurrency(actualEbitda.year5 + ebitdaAdj5)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-100">{formatCurrency(actualEbitda.ttm)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-center bg-green-100">{formatAdj(ebitdaAdjTTM)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-200">{formatCurrency(actualEbitda.ttm + ebitdaAdjTTM)}</td>
                      </>
                    );
                  })()}
                </tr>
              </tbody>
              <tfoot>
                <tr className="bg-gray-100">
                  <th className="text-left p-1 border-2 border-gray-400 text-xs">Line Item</th>
                  {showAllYears && <><th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th></>}
                  {showAllYears && <><th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th></>}
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th>
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th>
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs">Actual</th><th className="p-1 border text-xs">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-50">Norm</th>
                  <th className="p-1 border border-l-2 border-l-gray-400 text-xs bg-blue-50">Actual</th><th className="p-1 border text-xs bg-blue-50">Adj</th><th className="p-1 border border-r-2 border-r-gray-400 text-xs bg-blue-200">Norm</th>
                </tr>
                <tr className="bg-gray-200">
                  <th className="text-left p-2 border-2 border-gray-400">Line Item</th>
                  {showAllYears && <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year1 || 'Year 1'}</th>}
                  {showAllYears && <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year2 || 'Year 2'}</th>}
                  <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year3 || 'Year 3'}</th>
                  <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year4 || 'Year 4'}</th>
                  <th className="text-center p-2 border-2 border-gray-400" colSpan="3">{displayYearLabels.year5 || 'Year 5'}</th>
                  <th className="text-center p-2 border-2 border-gray-400 bg-blue-100" colSpan="3">{ttmLabel}</th>
                </tr>
              </tfoot>
            </table>
            )}
            
            {/* ACTUALS + TREND VIEW - Actual values with YTD and Annualized */}
            {incomeStmtViewMode === 'actuals' && (
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="text-left p-2 border" style={{minWidth: '180px'}}>Line Item</th>
                  {showAllYears && <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year1 || 'Year 1'}</th>}
                  {showAllYears && <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year2 || 'Year 2'}</th>}
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year3 || 'Year 3'}</th>
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year4 || 'Year 4'}</th>
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year5 || 'Year 5'}</th>
                  <th className="text-center p-2 border bg-blue-100" style={{minWidth: '80px', maxWidth: '90px'}}>{ttmLabel}</th>
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{ytdLabel}</th>
                  <th className="text-center p-2 border bg-slate-100" style={{minWidth: '80px', maxWidth: '90px'}}>Annualized</th>
                  <th className="text-center p-2 border bg-slate-200" style={{minWidth: '70px', maxWidth: '80px'}}>Ann vs TTM</th>
                  <th className="text-center p-2 border bg-gray-100" style={{minWidth: '150px'}}>Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-blue-50 font-semibold"><td colSpan={showAllYears ? 12 : 10} className="p-1.5 border text-sm">REVENUE</td></tr>
                {activeRevenueCategories.map(cat => {
                  const ytdVal = ytdAnnualized.revenue.ytd[cat.id] || 0;
                  const annVal = ytdAnnualized.revenue.annualized[cat.id] || 0;
                  const hasMonthlyData = annVal > 0 || ytdVal > 0;
                  const variance = (cat.ttm > 0 && hasMonthlyData) ? ((annVal - cat.ttm) / cat.ttm * 100) : 0;
                  const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                  const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                  const showVarianceHighlight = hasMonthlyData && Math.abs(variance) > varianceThreshold && cat.ttm >= materialityThreshold;
                  
                  // YoY variance calculation
                  const yoyMode = monthlyTtmConfig.yoyCompareMode || 'prior';
                  const years = [cat.year1, cat.year2, cat.year3, cat.year4, cat.year5, cat.ttm];
                  const avgAll = years.filter(v => v > 0).length > 0 ? years.filter(v => v > 0).reduce((a,b) => a+b, 0) / years.filter(v => v > 0).length : 0;
                  
                  const getYoYHighlight = (val, idx) => {
                    if (val < materialityThreshold) return '';
                    if (yoyMode === 'prior') {
                      const prior = idx === 0 ? 0 : years[idx - 1];
                      if (prior === 0) return '';
                      const pct = ((val - prior) / prior) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    } else {
                      if (avgAll === 0) return '';
                      const pct = ((val - avgAll) / avgAll) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    }
                  };
                  
                  const noteKey = `actuals_rev_${cat.id}`;
                  const hasVariance = showVarianceHighlight || years.some((v, i) => getYoYHighlight(v, i));
                  const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                  
                  return (
                    <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                      <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                      {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year1, 0)}`}>{formatCurrency(cat.year1)}</td>}
                      {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year2, 1)}`}>{formatCurrency(cat.year2)}</td>}
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year3, 2)}`}>{formatCurrency(cat.year3)}</td>
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year4, 3)}`}>{formatCurrency(cat.year4)}</td>
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year5, 4)}`}>{formatCurrency(cat.year5)}</td>
                      <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(cat.ttm, 5)}`}>{formatCurrency(cat.ttm)}</td>
                      <td className="p-1 border text-right">{formatCurrency(ytdVal)}</td>
                      <td className="p-1 border text-right bg-slate-50">{formatCurrency(annVal)}</td>
                      <td className={`p-1 border text-right ${showVarianceHighlight ? 'bg-amber-100 font-semibold' : ''}`}>
                        {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                      </td>
                      <td className="p-0 border">
                        <ExpandableNotes
                          value={monthlyTtmNotes[noteKey]}
                          onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                          hasVariance={hasVariance}
                          placeholder={hasVariance ? 'Explain variance...' : ''}
                          isFlagged={isManuallyFlagged}
                          onToggleFlag={() => setManualReviewFlags(prev => ({
                            ...prev, 
                            [noteKey]: { 
                              ...prev[noteKey], 
                              flagged: !prev[noteKey]?.flagged,
                              created: prev[noteKey]?.created || Date.now(),
                              section: 'Income Statement - Actuals',
                              item: `Revenue: ${cat.name}`
                            }
                          }))}
                          noteKey={noteKey}
                        resolvedData={manualReviewFlags[noteKey]}
                        />
                      </td>
                    </tr>
                  );
                })}
                <tr className="font-bold">
                  <td className="p-1 border border-t-2 border-t-gray-400">Total Revenue</td>
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(revenueAnalysis.totals.year1)}</td>}
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(revenueAnalysis.totals.year2)}</td>}
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(revenueAnalysis.totals.year3)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(revenueAnalysis.totals.year4)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(revenueAnalysis.totals.year5)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(revenueAnalysis.totals.ttm)}</td>
                  {(() => {
                    // Calculate YTD/Annualized from visible categories only
                    const visibleYtdTotal = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.ytd[cat.id] || 0), 0);
                    const visibleAnnTotal = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.annualized[cat.id] || 0), 0);
                    const hasMonthlyData = visibleAnnTotal > 0 || visibleYtdTotal > 0;
                    const variance = (revenueAnalysis.totals.ttm > 0 && hasMonthlyData) ? ((visibleAnnTotal - revenueAnalysis.totals.ttm) / revenueAnalysis.totals.ttm * 100) : 0;
                    const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                    const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                    const showHighlight = hasMonthlyData && Math.abs(variance) > varianceThreshold && revenueAnalysis.totals.ttm >= materialityThreshold;
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(visibleYtdTotal)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(visibleAnnTotal)}</td>
                        <td className={`p-1 border border-t-2 border-t-gray-400 text-right ${showHighlight ? 'bg-amber-100' : ''}`}>
                          {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                        </td>
                      </>
                    );
                  })()}
                  <td className="p-1 border border-t-2 border-t-gray-400"></td>
                </tr>
                
                {activeCogsCategories.length > 0 && (
                  <>
                <tr className="bg-slate-100 font-semibold"><td colSpan={showAllYears ? 12 : 10} className="p-1.5 border text-sm">COST OF GOODS SOLD</td></tr>
                {activeCogsCategories.map(cat => {
                  const ytdVal = ytdAnnualized.cogs.ytd[cat.id] || 0;
                  const annVal = ytdAnnualized.cogs.annualized[cat.id] || 0;
                  const hasMonthlyData = annVal > 0 || ytdVal > 0;
                  const variance = (cat.ttm > 0 && hasMonthlyData) ? ((annVal - cat.ttm) / cat.ttm * 100) : 0;
                  const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                  const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                  const showVarianceHighlight = hasMonthlyData && Math.abs(variance) > varianceThreshold && cat.ttm >= materialityThreshold;
                  
                  // YoY variance calculation
                  const yoyMode = monthlyTtmConfig.yoyCompareMode || 'prior';
                  const years = [cat.year1, cat.year2, cat.year3, cat.year4, cat.year5, cat.ttm];
                  const avgAll = years.filter(v => v > 0).length > 0 ? years.filter(v => v > 0).reduce((a,b) => a+b, 0) / years.filter(v => v > 0).length : 0;
                  
                  const getYoYHighlight = (val, idx) => {
                    if (val < materialityThreshold) return '';
                    if (yoyMode === 'prior') {
                      const prior = idx === 0 ? 0 : years[idx - 1];
                      if (prior === 0) return '';
                      const pct = ((val - prior) / prior) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    } else {
                      if (avgAll === 0) return '';
                      const pct = ((val - avgAll) / avgAll) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    }
                  };
                  
                  const noteKey = `actuals_cogs_${cat.id}`;
                  const hasVariance = showVarianceHighlight || years.some((v, i) => getYoYHighlight(v, i));
                  const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                  
                  return (
                    <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                      <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                      {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year1, 0)}`}>{formatCurrency(cat.year1)}</td>}
                      {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year2, 1)}`}>{formatCurrency(cat.year2)}</td>}
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year3, 2)}`}>{formatCurrency(cat.year3)}</td>
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year4, 3)}`}>{formatCurrency(cat.year4)}</td>
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year5, 4)}`}>{formatCurrency(cat.year5)}</td>
                      <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(cat.ttm, 5)}`}>{formatCurrency(cat.ttm)}</td>
                      <td className="p-1 border text-right">{formatCurrency(ytdVal)}</td>
                      <td className="p-1 border text-right bg-slate-50">{formatCurrency(annVal)}</td>
                      <td className={`p-1 border text-right ${showVarianceHighlight ? 'bg-amber-100 font-semibold' : ''}`}>
                        {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                      </td>
                      <td className="p-0 border">
                        <ExpandableNotes
                          value={monthlyTtmNotes[noteKey]}
                          onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                          hasVariance={hasVariance}
                          placeholder={hasVariance ? 'Explain variance...' : ''}
                          isFlagged={isManuallyFlagged}
                          onToggleFlag={() => setManualReviewFlags(prev => ({
                            ...prev, 
                            [noteKey]: { 
                              ...prev[noteKey], 
                              flagged: !prev[noteKey]?.flagged,
                              created: prev[noteKey]?.created || Date.now(),
                              section: 'Income Statement - Actuals',
                              item: `COGS: ${cat.name}`
                            }
                          }))}
                          noteKey={noteKey}
                        resolvedData={manualReviewFlags[noteKey]}
                        />
                      </td>
                    </tr>
                  );
                })}
                <tr className="font-bold">
                  <td className="p-1 border border-t-2 border-t-gray-400">Total COGS</td>
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[0].cogs)}</td>}
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[1].cogs)}</td>}
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[2].cogs)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[3].cogs)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[4].cogs)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(calculations.years[5].cogs)}</td>
                  {(() => {
                    const visibleYtdTotal = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.ytd[cat.id] || 0), 0);
                    const visibleAnnTotal = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.annualized[cat.id] || 0), 0);
                    const hasMonthlyData = visibleAnnTotal > 0 || visibleYtdTotal > 0;
                    const variance = (calculations.years[5].cogs > 0 && hasMonthlyData) ? ((visibleAnnTotal - calculations.years[5].cogs) / calculations.years[5].cogs * 100) : 0;
                    const showHighlight = hasMonthlyData && Math.abs(variance) > monthlyTtmConfig.annVsTtmVarianceThreshold && calculations.years[5].cogs >= monthlyTtmConfig.annVsTtmMaterialityThreshold;
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(visibleYtdTotal)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(visibleAnnTotal)}</td>
                        <td className={`p-1 border border-t-2 border-t-gray-400 text-right ${showHighlight ? 'bg-amber-100' : ''}`}>
                          {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                        </td>
                      </>
                    );
                  })()}
                  <td className="p-1 border border-t-2 border-t-gray-400"></td>
                </tr>
                  </>
                )}
                
                <tr className="font-bold">
                  <td className="p-1 border border-t-2 border-t-gray-400">Gross Profit</td>
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[0].revenue - calculations.years[0].cogs)}</td>}
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[1].revenue - calculations.years[1].cogs)}</td>}
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[2].revenue - calculations.years[2].cogs)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[3].revenue - calculations.years[3].cogs)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[4].revenue - calculations.years[4].cogs)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(calculations.years[5].revenue - calculations.years[5].cogs)}</td>
                  {(() => {
                    const revYtd = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.ytd[cat.id] || 0), 0);
                    const cogsYtd = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.ytd[cat.id] || 0), 0);
                    const revAnn = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.annualized[cat.id] || 0), 0);
                    const cogsAnn = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.annualized[cat.id] || 0), 0);
                    const gpYtd = revYtd - cogsYtd;
                    const gpAnn = revAnn - cogsAnn;
                    const hasMonthlyData = gpAnn !== 0 || gpYtd !== 0;
                    const variance = (calculations.years[5].grossProfit !== 0 && hasMonthlyData) ? ((gpAnn - calculations.years[5].grossProfit) / Math.abs(calculations.years[5].grossProfit) * 100) : 0;
                    const showHighlight = hasMonthlyData && Math.abs(variance) > monthlyTtmConfig.annVsTtmVarianceThreshold && Math.abs(calculations.years[5].grossProfit) >= monthlyTtmConfig.annVsTtmMaterialityThreshold;
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(gpYtd)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(gpAnn)}</td>
                        <td className={`p-1 border border-t-2 border-t-gray-400 text-right ${showHighlight ? 'bg-amber-100' : ''}`}>
                          {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                        </td>
                      </>
                    );
                  })()}
                  <td className="p-1 border border-t-2 border-t-gray-400"></td>
                </tr>
                
                <tr className="bg-slate-50 font-semibold"><td colSpan={showAllYears ? 12 : 10} className="p-1.5 border text-sm">OPERATING EXPENSES</td></tr>
                {activeOpexCategories.map(cat => {
                  const ytdVal = ytdAnnualized.opex.ytd[cat.id] || 0;
                  const annVal = ytdAnnualized.opex.annualized[cat.id] || 0;
                  const hasMonthlyData = annVal > 0 || ytdVal > 0;
                  const variance = (cat.ttm > 0 && hasMonthlyData) ? ((annVal - cat.ttm) / cat.ttm * 100) : 0;
                  const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                  const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                  const showVarianceHighlight = hasMonthlyData && Math.abs(variance) > varianceThreshold && cat.ttm >= materialityThreshold;
                  
                  // YoY variance calculation
                  const yoyMode = monthlyTtmConfig.yoyCompareMode || 'prior';
                  const years = [cat.year1, cat.year2, cat.year3, cat.year4, cat.year5, cat.ttm];
                  const avgAll = years.filter(v => v > 0).length > 0 ? years.filter(v => v > 0).reduce((a,b) => a+b, 0) / years.filter(v => v > 0).length : 0;
                  
                  const getYoYHighlight = (val, idx) => {
                    if (val < materialityThreshold) return '';
                    if (yoyMode === 'prior') {
                      const prior = idx === 0 ? 0 : years[idx - 1];
                      if (prior === 0) return '';
                      const pct = ((val - prior) / prior) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    } else {
                      if (avgAll === 0) return '';
                      const pct = ((val - avgAll) / avgAll) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    }
                  };
                  
                  const noteKey = `actuals_opex_${cat.id}`;
                  const hasVariance = showVarianceHighlight || years.some((v, i) => getYoYHighlight(v, i));
                  const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                  
                  return (
                    <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                      <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                      {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year1, 0)}`}>{formatCurrency(cat.year1)}</td>}
                      {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year2, 1)}`}>{formatCurrency(cat.year2)}</td>}
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year3, 2)}`}>{formatCurrency(cat.year3)}</td>
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year4, 3)}`}>{formatCurrency(cat.year4)}</td>
                      <td className={`p-1 border text-right ${getYoYHighlight(cat.year5, 4)}`}>{formatCurrency(cat.year5)}</td>
                      <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(cat.ttm, 5)}`}>{formatCurrency(cat.ttm)}</td>
                      <td className="p-1 border text-right">{formatCurrency(ytdVal)}</td>
                      <td className="p-1 border text-right bg-slate-50">{formatCurrency(annVal)}</td>
                      <td className={`p-1 border text-right ${showVarianceHighlight ? 'bg-amber-100 font-semibold' : ''}`}>
                        {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                      </td>
                      <td className="p-0 border">
                        <ExpandableNotes
                          value={monthlyTtmNotes[noteKey]}
                          onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                          hasVariance={hasVariance}
                          placeholder={hasVariance ? 'Explain variance...' : ''}
                          isFlagged={isManuallyFlagged}
                          onToggleFlag={() => setManualReviewFlags(prev => ({
                            ...prev, 
                            [noteKey]: { 
                              ...prev[noteKey], 
                              flagged: !prev[noteKey]?.flagged,
                              created: prev[noteKey]?.created || Date.now(),
                              section: 'Income Statement - Actuals',
                              item: `OpEx: ${cat.name}`
                            }
                          }))}
                          noteKey={noteKey}
                        resolvedData={manualReviewFlags[noteKey]}
                        />
                      </td>
                    </tr>
                  );
                })}
                <tr className="font-bold">
                  <td className="p-1 border border-t-2 border-t-gray-400">Total OpEx</td>
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[0].totalOpEx)}</td>}
                  {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[1].totalOpEx)}</td>}
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[2].totalOpEx)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[3].totalOpEx)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(calculations.years[4].totalOpEx)}</td>
                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(calculations.years[5].totalOpEx)}</td>
                  {(() => {
                    const visibleYtdTotal = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.ytd[cat.id] || 0), 0);
                    const visibleAnnTotal = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.annualized[cat.id] || 0), 0);
                    const hasMonthlyData = visibleAnnTotal > 0 || visibleYtdTotal > 0;
                    const variance = (calculations.years[5].totalOpEx > 0 && hasMonthlyData) ? ((visibleAnnTotal - calculations.years[5].totalOpEx) / calculations.years[5].totalOpEx * 100) : 0;
                    const showHighlight = hasMonthlyData && Math.abs(variance) > monthlyTtmConfig.annVsTtmVarianceThreshold && calculations.years[5].totalOpEx >= monthlyTtmConfig.annVsTtmMaterialityThreshold;
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(visibleYtdTotal)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(visibleAnnTotal)}</td>
                        <td className={`p-1 border border-t-2 border-t-gray-400 text-right ${showHighlight ? 'bg-amber-100' : ''}`}>
                          {hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                        </td>
                      </>
                    );
                  })()}
                  <td className="p-1 border border-t-2 border-t-gray-400"></td>
                </tr>
                
                {/* Operating Income Row */}
                <tr className="font-bold bg-blue-100">
                  <td className="p-1 border border-t-2 border-b-2 border-y-gray-400">Operating Income</td>
                  {showAllYears && <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(calculations.years[0].grossProfit - calculations.years[0].opex)}</td>}
                  {showAllYears && <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(calculations.years[1].grossProfit - calculations.years[1].opex)}</td>}
                  <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(calculations.years[2].grossProfit - calculations.years[2].opex)}</td>
                  <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(calculations.years[3].grossProfit - calculations.years[3].opex)}</td>
                  <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(calculations.years[4].grossProfit - calculations.years[4].opex)}</td>
                  <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-200">{formatCurrency(calculations.years[5].grossProfit - calculations.years[5].opex)}</td>
                  {(() => {
                    const revYtd = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.ytd[cat.id] || 0), 0);
                    const cogsYtd = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.ytd[cat.id] || 0), 0);
                    const opexYtd = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.ytd[cat.id] || 0), 0);
                    const revAnn = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.annualized[cat.id] || 0), 0);
                    const cogsAnn = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.annualized[cat.id] || 0), 0);
                    const opexAnn = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.annualized[cat.id] || 0), 0);
                    const opIncYtd = (revYtd - cogsYtd) - opexYtd;
                    const opIncAnn = (revAnn - cogsAnn) - opexAnn;
                    const ttmOpInc = calculations.years[5].grossProfit - calculations.years[5].opex;
                    const hasData = opIncAnn !== 0 || opIncYtd !== 0;
                    const variance = (ttmOpInc !== 0 && hasData) ? ((opIncAnn - ttmOpInc) / Math.abs(ttmOpInc) * 100) : 0;
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(opIncYtd)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-slate-100">{formatCurrency(opIncAnn)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{hasData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}</td>
                      </>
                    );
                  })()}
                  <td className="p-1 border border-t-2 border-b-2 border-y-gray-400"></td>
                </tr>
                
                {/* OTHER INCOME (Non-Operating) */}
                {activeOtherIncomeCategories.some(cat => cat.name) && (
                  <>
                    <tr className="bg-gray-100 font-medium"><td colSpan={showAllYears ? 12 : 10} className="p-1 border text-xs text-gray-600">Other Income (Non-Operating)</td></tr>
                    {activeOtherIncomeCategories.filter(cat => cat.name).map(cat => {
                      const ytdVal = ytdAnnualized.otherIncome?.ytd?.[cat.id] || 0;
                      const annVal = ytdAnnualized.otherIncome?.annualized?.[cat.id] || 0;
                      const hasMonthlyData = ytdVal > 0 || annVal > 0;
                      const variance = (cat.ttm > 0 && hasMonthlyData) ? ((annVal - cat.ttm) / cat.ttm * 100) : 0;
                      const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                      const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                      const showVarianceHighlight = hasMonthlyData && Math.abs(variance) > varianceThreshold && cat.ttm >= materialityThreshold;
                      
                      const yoyMode = monthlyTtmConfig.yoyCompareMode || 'prior';
                      const years = [cat.year1, cat.year2, cat.year3, cat.year4, cat.year5, cat.ttm];
                      const avgAll = years.filter(v => v > 0).length > 0 ? years.filter(v => v > 0).reduce((a,b) => a+b, 0) / years.filter(v => v > 0).length : 0;
                      const getYoYHighlight = (val, idx) => {
                        if (val < materialityThreshold) return '';
                        if (yoyMode === 'prior') {
                          const prior = idx === 0 ? 0 : years[idx - 1];
                          if (prior === 0) return '';
                          const pct = ((val - prior) / prior) * 100;
                          return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                        } else {
                          if (avgAll === 0) return '';
                          const pct = ((val - avgAll) / avgAll) * 100;
                          return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                        }
                      };
                      
                      const noteKey = `actuals_oi_${cat.id}`;
                      const hasVariance = showVarianceHighlight || years.some((v, i) => getYoYHighlight(v, i));
                      const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                      
                      return (
                        <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                          <td className="p-1 border pl-4">{cat.name}</td>
                          {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year1, 0)}`}>{formatCurrency(cat.year1)}</td>}
                          {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year2, 1)}`}>{formatCurrency(cat.year2)}</td>}
                          <td className={`p-1 border text-right ${getYoYHighlight(cat.year3, 2)}`}>{formatCurrency(cat.year3)}</td>
                          <td className={`p-1 border text-right ${getYoYHighlight(cat.year4, 3)}`}>{formatCurrency(cat.year4)}</td>
                          <td className={`p-1 border text-right ${getYoYHighlight(cat.year5, 4)}`}>{formatCurrency(cat.year5)}</td>
                          <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(cat.ttm, 5)}`}>{formatCurrency(cat.ttm)}</td>
                          <td className="p-1 border text-right">{hasMonthlyData ? formatCurrency(ytdVal) : '-'}</td>
                          <td className="p-1 border text-right bg-slate-50">{hasMonthlyData ? formatCurrency(annVal) : '-'}</td>
                          <td className={`p-1 border text-right ${showVarianceHighlight ? 'bg-amber-100 font-semibold' : ''}`}>{hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}</td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes[noteKey]}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                              hasVariance={hasVariance}
                              placeholder={hasVariance ? 'Explain variance...' : ''}
                              isFlagged={isManuallyFlagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                [noteKey]: { 
                                  ...prev[noteKey], 
                                  flagged: !prev[noteKey]?.flagged,
                                  created: prev[noteKey]?.created || Date.now(),
                                  section: 'Income Statement - Actuals',
                                  item: `Other Income: ${cat.name}`
                                }
                              }))}
                              noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    <tr className="font-bold">
                      <td className="p-1 border border-t-2 border-t-gray-400">Total Other Income</td>
                      {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherIncomeAnalysis.totals.year1)}</td>}
                      {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherIncomeAnalysis.totals.year2)}</td>}
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherIncomeAnalysis.totals.year3)}</td>
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherIncomeAnalysis.totals.year4)}</td>
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherIncomeAnalysis.totals.year5)}</td>
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherIncomeAnalysis.totals.ttm)}</td>
                      {(() => {
                        const visibleYtd = activeOtherIncomeCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherIncome?.ytd?.[cat.id] || 0), 0);
                        const visibleAnn = activeOtherIncomeCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherIncome?.annualized?.[cat.id] || 0), 0);
                        const hasData = visibleAnn > 0 || visibleYtd > 0;
                        const variance = (otherIncomeAnalysis.totals.ttm > 0 && hasData) ? ((visibleAnn - otherIncomeAnalysis.totals.ttm) / otherIncomeAnalysis.totals.ttm * 100) : 0;
                        return (
                          <>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(visibleYtd)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(visibleAnn)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right">{hasData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}</td>
                          </>
                        );
                      })()}
                      <td className="p-1 border border-t-2 border-t-gray-400"></td>
                    </tr>
                  </>
                )}

                {/* OTHER EXPENSE (Non-Operating) */}
                {activeOtherExpenseCategories.some(cat => cat.name) && (
                  <>
                    <tr className="bg-gray-100 font-medium"><td colSpan={showAllYears ? 10 : 8} className="p-1 border text-xs text-gray-600">Other Expense (Non-Operating)</td></tr>
                    {activeOtherExpenseCategories.filter(cat => cat.name).map(cat => {
                      const ytdVal = ytdAnnualized.otherExpense?.ytd?.[cat.id] || 0;
                      const annVal = ytdAnnualized.otherExpense?.annualized?.[cat.id] || 0;
                      const hasMonthlyData = ytdVal > 0 || annVal > 0;
                      const variance = (cat.ttm > 0 && hasMonthlyData) ? ((annVal - cat.ttm) / cat.ttm * 100) : 0;
                      const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                      const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                      const showVarianceHighlight = hasMonthlyData && Math.abs(variance) > varianceThreshold && cat.ttm >= materialityThreshold;
                      
                      const yoyMode = monthlyTtmConfig.yoyCompareMode || 'prior';
                      const years = [cat.year1, cat.year2, cat.year3, cat.year4, cat.year5, cat.ttm];
                      const avgAll = years.filter(v => v > 0).length > 0 ? years.filter(v => v > 0).reduce((a,b) => a+b, 0) / years.filter(v => v > 0).length : 0;
                      const getYoYHighlight = (val, idx) => {
                        if (val < materialityThreshold) return '';
                        if (yoyMode === 'prior') {
                          const prior = idx === 0 ? 0 : years[idx - 1];
                          if (prior === 0) return '';
                          const pct = ((val - prior) / prior) * 100;
                          return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                        } else {
                          if (avgAll === 0) return '';
                          const pct = ((val - avgAll) / avgAll) * 100;
                          return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                        }
                      };
                      
                      const noteKey = `actuals_oe_${cat.id}`;
                      const hasVariance = showVarianceHighlight || years.some((v, i) => getYoYHighlight(v, i));
                      const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                      
                      return (
                        <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                          <td className="p-1 border pl-4">{cat.name}</td>
                          {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year1, 0)}`}>{formatCurrency(cat.year1)}</td>}
                          {showAllYears && <td className={`p-1 border text-right ${getYoYHighlight(cat.year2, 1)}`}>{formatCurrency(cat.year2)}</td>}
                          <td className={`p-1 border text-right ${getYoYHighlight(cat.year3, 2)}`}>{formatCurrency(cat.year3)}</td>
                          <td className={`p-1 border text-right ${getYoYHighlight(cat.year4, 3)}`}>{formatCurrency(cat.year4)}</td>
                          <td className={`p-1 border text-right ${getYoYHighlight(cat.year5, 4)}`}>{formatCurrency(cat.year5)}</td>
                          <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(cat.ttm, 5)}`}>{formatCurrency(cat.ttm)}</td>
                          <td className="p-1 border text-right">{hasMonthlyData ? formatCurrency(ytdVal) : '-'}</td>
                          <td className="p-1 border text-right bg-slate-50">{hasMonthlyData ? formatCurrency(annVal) : '-'}</td>
                          <td className={`p-1 border text-right ${showVarianceHighlight ? 'bg-amber-100 font-semibold' : ''}`}>{hasMonthlyData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}</td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes[noteKey]}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                              hasVariance={hasVariance}
                              placeholder={hasVariance ? 'Explain variance...' : ''}
                              isFlagged={isManuallyFlagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                [noteKey]: { 
                                  ...prev[noteKey], 
                                  flagged: !prev[noteKey]?.flagged,
                                  created: prev[noteKey]?.created || Date.now(),
                                  section: 'Income Statement - Actuals',
                                  item: `Other Expense: ${cat.name}`
                                }
                              }))}
                              noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    <tr className="font-bold">
                      <td className="p-1 border border-t-2 border-t-gray-400">Total Other Expense</td>
                      {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherExpenseAnalysis.totals.year1)}</td>}
                      {showAllYears && <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherExpenseAnalysis.totals.year2)}</td>}
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherExpenseAnalysis.totals.year3)}</td>
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherExpenseAnalysis.totals.year4)}</td>
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(otherExpenseAnalysis.totals.year5)}</td>
                      <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(otherExpenseAnalysis.totals.ttm)}</td>
                      {(() => {
                        const visibleYtd = activeOtherExpenseCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherExpense?.ytd?.[cat.id] || 0), 0);
                        const visibleAnn = activeOtherExpenseCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherExpense?.annualized?.[cat.id] || 0), 0);
                        const hasData = visibleAnn > 0 || visibleYtd > 0;
                        const variance = (otherExpenseAnalysis.totals.ttm > 0 && hasData) ? ((visibleAnn - otherExpenseAnalysis.totals.ttm) / otherExpenseAnalysis.totals.ttm * 100) : 0;
                        return (
                          <>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right">{formatCurrency(visibleYtd)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(visibleAnn)}</td>
                            <td className="p-1 border border-t-2 border-t-gray-400 text-right">{hasData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}</td>
                          </>
                        );
                      })()}
                      <td className="p-1 border border-t-2 border-t-gray-400"></td>
                    </tr>
                  </>
                )}
                
                {/* Net Income */}
                <tr className="font-bold">
                  {(() => {
                    // Net Income = Rev - COGS - OpEx + OtherInc - OtherExp (matches With Adjustments Actual column)
                    const opexTotals = {
                      year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                      year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                      year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                      year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                      year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                      ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                    };
                    const netIncome = {
                      year1: revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1 - opexTotals.year1 + otherIncomeAnalysis.totals.year1 - otherExpenseAnalysis.totals.year1,
                      year2: revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2 - opexTotals.year2 + otherIncomeAnalysis.totals.year2 - otherExpenseAnalysis.totals.year2,
                      year3: revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3 - opexTotals.year3 + otherIncomeAnalysis.totals.year3 - otherExpenseAnalysis.totals.year3,
                      year4: revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4 - opexTotals.year4 + otherIncomeAnalysis.totals.year4 - otherExpenseAnalysis.totals.year4,
                      year5: revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5 - opexTotals.year5 + otherIncomeAnalysis.totals.year5 - otherExpenseAnalysis.totals.year5,
                      ttm: revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm - opexTotals.ttm + otherIncomeAnalysis.totals.ttm - otherExpenseAnalysis.totals.ttm
                    };
                    // YTD/Annualized calculations
                    const revYtd = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.ytd[cat.id] || 0), 0);
                    const cogsYtd = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.ytd[cat.id] || 0), 0);
                    const opexYtd = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.ytd[cat.id] || 0), 0);
                    const oiYtd = activeOtherIncomeCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherIncome?.ytd?.[cat.id] || 0), 0);
                    const oeYtd = activeOtherExpenseCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherExpense?.ytd?.[cat.id] || 0), 0);
                    const revAnn = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.annualized[cat.id] || 0), 0);
                    const cogsAnn = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.annualized[cat.id] || 0), 0);
                    const opexAnn = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.annualized[cat.id] || 0), 0);
                    const oiAnn = activeOtherIncomeCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherIncome?.annualized?.[cat.id] || 0), 0);
                    const oeAnn = activeOtherExpenseCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherExpense?.annualized?.[cat.id] || 0), 0);
                    const niYtd = (revYtd - cogsYtd) - opexYtd + oiYtd - oeYtd;
                    const niAnn = (revAnn - cogsAnn) - opexAnn + oiAnn - oeAnn;
                    const hasData = niAnn !== 0 || niYtd !== 0;
                    const variance = (netIncome.ttm !== 0 && hasData) ? ((niAnn - netIncome.ttm) / Math.abs(netIncome.ttm) * 100) : 0;
                    return (
                      <>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400">Net Income</td>
                        {showAllYears && <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(netIncome.year1)}</td>}
                        {showAllYears && <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(netIncome.year2)}</td>}
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(netIncome.year3)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(netIncome.year4)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(netIncome.year5)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-100">{formatCurrency(netIncome.ttm)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(niYtd)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-slate-100">{formatCurrency(niAnn)}</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{hasData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}</td>
                      </>
                    );
                  })()}
                </tr>
                
                <tr className="font-bold bg-green-100">
                  {(() => {
                    // EBITDA = Net Income + DIAT add-backs (from Line-Based Add-backs with Type = D/I/A/T)
                    // This matches the With Adjustments Actual column exactly
                    const opexTotals = {
                      year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                      year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                      year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                      year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                      year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                      ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                    };
                    // DIAT add-backs from OpEx and Other Expense items with DIAT adjCategory and addbackPct
                    const getDiatAddback = (yearKey) => {
                      const fromOpex = opexCategories.filter(cat => cat.adjIncluded !== false && ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) && (cat.addbackPct || 0) > 0)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      const fromOE = otherExpenseCategories.filter(cat => cat.adjIncluded !== false && ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) && (cat.addbackPct || 0) > 0)
                        .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                      return fromOpex + fromOE;
                    };
                    const diatAddbacks = {
                      year1: getDiatAddback('year1'),
                      year2: getDiatAddback('year2'),
                      year3: getDiatAddback('year3'),
                      year4: getDiatAddback('year4'),
                      year5: getDiatAddback('year5'),
                      ttm: getDiatAddback('ttm')
                    };
                    // Net Income = Rev - COGS - OpEx + OtherInc - OtherExp
                    const netIncome = {
                      year1: revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1 - opexTotals.year1 + otherIncomeAnalysis.totals.year1 - otherExpenseAnalysis.totals.year1,
                      year2: revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2 - opexTotals.year2 + otherIncomeAnalysis.totals.year2 - otherExpenseAnalysis.totals.year2,
                      year3: revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3 - opexTotals.year3 + otherIncomeAnalysis.totals.year3 - otherExpenseAnalysis.totals.year3,
                      year4: revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4 - opexTotals.year4 + otherIncomeAnalysis.totals.year4 - otherExpenseAnalysis.totals.year4,
                      year5: revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5 - opexTotals.year5 + otherIncomeAnalysis.totals.year5 - otherExpenseAnalysis.totals.year5,
                      ttm: revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm - opexTotals.ttm + otherIncomeAnalysis.totals.ttm - otherExpenseAnalysis.totals.ttm
                    };
                    // EBITDA = Net Income + DIAT add-backs
                    const actualEbitda = {
                      year1: netIncome.year1 + diatAddbacks.year1,
                      year2: netIncome.year2 + diatAddbacks.year2,
                      year3: netIncome.year3 + diatAddbacks.year3,
                      year4: netIncome.year4 + diatAddbacks.year4,
                      year5: netIncome.year5 + diatAddbacks.year5,
                      ttm: netIncome.ttm + diatAddbacks.ttm
                    };
                    // YTD/Annualized calculations
                    const revYtd = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.ytd[cat.id] || 0), 0);
                    const cogsYtd = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.ytd[cat.id] || 0), 0);
                    const opexYtd = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.ytd[cat.id] || 0), 0);
                    const oiYtd = activeOtherIncomeCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherIncome?.ytd?.[cat.id] || 0), 0);
                    const oeYtd = activeOtherExpenseCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherExpense?.ytd?.[cat.id] || 0), 0);
                    const revAnn = activeRevenueCategories.reduce((sum, cat) => sum + (ytdAnnualized.revenue.annualized[cat.id] || 0), 0);
                    const cogsAnn = activeCogsCategories.reduce((sum, cat) => sum + (ytdAnnualized.cogs.annualized[cat.id] || 0), 0);
                    const opexAnn = activeOpexCategories.reduce((sum, cat) => sum + (ytdAnnualized.opex.annualized[cat.id] || 0), 0);
                    const oiAnn = activeOtherIncomeCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherIncome?.annualized?.[cat.id] || 0), 0);
                    const oeAnn = activeOtherExpenseCategories.reduce((sum, cat) => sum + (ytdAnnualized.otherExpense?.annualized?.[cat.id] || 0), 0);
                    const niYtd = (revYtd - cogsYtd) - opexYtd + oiYtd - oeYtd;
                    const niAnn = (revAnn - cogsAnn) - opexAnn + oiAnn - oeAnn;
                    // Note: YTD/Ann DIAT addbacks would need monthly data - using same addbacks for now
                    const ebitdaYtd = niYtd + diatAddbacks.ttm;
                    const ebitdaAnn = niAnn + diatAddbacks.ttm;
                    const hasData = ebitdaAnn !== 0 || ebitdaYtd !== 0;
                    const variance = (actualEbitda.ttm !== 0 && hasData) ? ((ebitdaAnn - actualEbitda.ttm) / Math.abs(actualEbitda.ttm) * 100) : 0;
                    const showHighlight = hasData && Math.abs(variance) > monthlyTtmConfig.annVsTtmVarianceThreshold && Math.abs(actualEbitda.ttm) >= monthlyTtmConfig.annVsTtmMaterialityThreshold;
                    return (
                      <>
                        <td className="p-1 border border-b-2 border-b-gray-400">EBITDA</td>
                        {showAllYears && <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(actualEbitda.year1)}</td>}
                        {showAllYears && <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(actualEbitda.year2)}</td>}
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(actualEbitda.year3)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(actualEbitda.year4)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(actualEbitda.year5)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-200">{formatCurrency(actualEbitda.ttm)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(ebitdaYtd)}</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-slate-100">{formatCurrency(ebitdaAnn)}</td>
                        <td className={`p-1 border border-b-2 border-b-gray-400 text-right ${showHighlight ? 'bg-amber-100' : ''}`}>
                          {hasData ? `${variance > 0 ? '+' : ''}${variance.toFixed(1)}%` : '-'}
                        </td>
                      </>
                    );
                  })()}
                </tr>
              </tbody>
              <tfoot>
                <tr className="bg-gray-200">
                  <th className="text-left p-2 border" style={{minWidth: '180px'}}>Line Item</th>
                  {showAllYears && <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year1 || 'Year 1'}</th>}
                  {showAllYears && <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year2 || 'Year 2'}</th>}
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year3 || 'Year 3'}</th>
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year4 || 'Year 4'}</th>
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{displayYearLabels.year5 || 'Year 5'}</th>
                  <th className="text-center p-2 border bg-blue-100" style={{minWidth: '80px', maxWidth: '90px'}}>{ttmLabel}</th>
                  <th className="text-center p-2 border" style={{minWidth: '80px', maxWidth: '90px'}}>{ytdLabel}</th>
                  <th className="text-center p-2 border bg-slate-100" style={{minWidth: '80px', maxWidth: '90px'}}>Annualized</th>
                  <th className="text-center p-2 border bg-slate-200" style={{minWidth: '70px', maxWidth: '80px'}}>Ann vs TTM</th>
                  <th className="text-center p-1 border w-8">🚩</th>
                </tr>
              </tfoot>
            </table>
            )}
            
            {/* NORMALIZED ONLY VIEW - Clean normalized figures */}
            {incomeStmtViewMode === 'normalized' && (
            <table className="w-full text-xs border-collapse" style={{tableLayout: 'fixed'}}>
              <thead>
                <tr className="bg-gray-200">
                  <th className="text-left p-2 border" style={{width: '180px'}}>Line Item</th>
                  {showAllYears && <><th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year1 || 'Year 1'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th></>}
                  {showAllYears && <><th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year2 || 'Year 2'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th></>}
                  <th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year3 || 'Year 3'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year4 || 'Year 4'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year5 || 'Year 5'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border bg-blue-200" style={{width: '70px'}}>{ttmLabel}</th><th className="text-center p-2 border bg-blue-100 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border bg-gray-100" style={{width: '150px'}}>Notes</th>
                </tr>
              </thead>
              <tbody>
                {/* Helper function for % calculation */}
                {(() => {
                  const pctOf = (val, yearIdx) => {
                    const rev = calculations.years[yearIdx]?.adjustedRevenue || 0;
                    if (rev === 0) return '-';
                    return ((val / rev) * 100).toFixed(0) + '%';
                  };
                  const colSpanFull = showAllYears ? 14 : 10;
                  
                  // YoY variance helpers
                  const varianceThreshold = monthlyTtmConfig.annVsTtmVarianceThreshold || 15;
                  const materialityThreshold = monthlyTtmConfig.annVsTtmMaterialityThreshold || 1000;
                  const yoyMode = monthlyTtmConfig.yoyCompareMode || 'prior';
                  
                  const getYoYHighlight = (values, idx) => {
                    const val = values[idx];
                    if (Math.abs(val) < materialityThreshold) return '';
                    if (yoyMode === 'prior') {
                      const prior = idx === 0 ? 0 : values[idx - 1];
                      if (prior === 0) return '';
                      const pct = ((val - prior) / Math.abs(prior)) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    } else {
                      const nonZero = values.filter(v => v !== 0);
                      const avgAll = nonZero.length > 0 ? nonZero.reduce((a,b) => a+b, 0) / nonZero.length : 0;
                      if (avgAll === 0) return '';
                      const pct = ((val - avgAll) / Math.abs(avgAll)) * 100;
                      return Math.abs(pct) > varianceThreshold ? 'bg-amber-100' : '';
                    }
                  };
                  
                  return (
                    <>
                      {/* REVENUE */}
                      <tr className="bg-slate-50 font-semibold"><td colSpan={colSpanFull} className="p-1.5 border text-sm">REVENUE (Normalized)</td></tr>
                      {activeRevenueCategories.map(cat => {
                        const getAdj = (yearLabel) => {
                          const yearAdjs = adjustmentItems.filter(a => 
                            a.included && 
                            (a.plLine === `Revenue: ${cat.name}` || a.plLine === cat.plLine) && 
                            (a.year === 'All Years' || a.year === yearLabel)
                          );
                          return yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - 
                                 yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                        };
                        const v1 = (cat.year1 || 0) + getAdj(basisYearLabels.year1);
                        const v2 = (cat.year2 || 0) + getAdj(basisYearLabels.year2);
                        const v3 = (cat.year3 || 0) + getAdj(basisYearLabels.year3);
                        const v4 = (cat.year4 || 0) + getAdj(basisYearLabels.year4);
                        const v5 = (cat.year5 || 0) + getAdj(basisYearLabels.year5);
                        const vT = (cat.ttm || 0) + getAdj('TTM');
                        const values = [v1, v2, v3, v4, v5, vT];
                        const noteKey = `norm_rev_${cat.id}`;
                        const hasVariance = values.some((v, i) => getYoYHighlight(values, i));
                        const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                        
                        return (
                          <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                            <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                            {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 0)}`}>{formatCurrency(v1)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v1, 0)}</td></>}
                            {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 1)}`}>{formatCurrency(v2)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v2, 1)}</td></>}
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 2)}`}>{formatCurrency(v3)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v3, 2)}</td>
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 3)}`}>{formatCurrency(v4)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v4, 3)}</td>
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 4)}`}>{formatCurrency(v5)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v5, 4)}</td>
                            <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(values, 5)}`}>{formatCurrency(vT)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(vT, 5)}</td>
                            <td className="p-0 border">
                              <ExpandableNotes
                                value={monthlyTtmNotes[noteKey]}
                                onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                hasVariance={hasVariance}
                                placeholder={hasVariance ? 'Explain variance...' : ''}
                                isFlagged={isManuallyFlagged}
                                onToggleFlag={() => setManualReviewFlags(prev => ({
                                  ...prev, 
                                  [noteKey]: { 
                                    ...prev[noteKey], 
                                    flagged: !prev[noteKey]?.flagged,
                                    created: prev[noteKey]?.created || Date.now(),
                                    section: 'Income Statement - Normalized',
                                    item: `Revenue: ${cat.name}`
                                  }
                                }))}
                                noteKey={noteKey}
                              resolvedData={manualReviewFlags[noteKey]}
                              />
                            </td>
                          </tr>
                        );
                      })}
                      <tr className="font-bold">
                        <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total Revenue</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[0].adjustedRevenue)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-500 bg-slate-100 text-xs">100%</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[1].adjustedRevenue)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-500 bg-slate-100 text-xs">100%</td></>}
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[2].adjustedRevenue)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-500 bg-slate-100 text-xs">100%</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[3].adjustedRevenue)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-500 bg-slate-100 text-xs">100%</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[4].adjustedRevenue)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-500 bg-slate-100 text-xs">100%</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(calculations.years[5].adjustedRevenue)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-500 bg-blue-100 text-xs">100%</td>
                        <td className="p-1 border border-t-2 border-t-gray-400"></td>
                      </tr>
                      
                      {/* COGS */}
                      <tr className="bg-slate-100 font-semibold"><td colSpan={colSpanFull} className="p-1.5 border text-sm">COGS (Normalized)</td></tr>
                      {activeCogsCategories.map(cat => {
                        const getAdj = (yearLabel) => {
                          const yearAdjs = adjustmentItems.filter(a => 
                            a.included && 
                            (a.plLine === `COGS: ${cat.name}` || a.plLine === cat.plLine) && 
                            (a.year === 'All Years' || a.year === yearLabel)
                          );
                          return yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - 
                                 yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                        };
                        const v1 = (cat.year1 || 0) + getAdj(basisYearLabels.year1);
                        const v2 = (cat.year2 || 0) + getAdj(basisYearLabels.year2);
                        const v3 = (cat.year3 || 0) + getAdj(basisYearLabels.year3);
                        const v4 = (cat.year4 || 0) + getAdj(basisYearLabels.year4);
                        const v5 = (cat.year5 || 0) + getAdj(basisYearLabels.year5);
                        const vT = (cat.ttm || 0) + getAdj('TTM');
                        const values = [v1, v2, v3, v4, v5, vT];
                        const noteKey = `norm_cogs_${cat.id}`;
                        const hasVariance = values.some((v, i) => getYoYHighlight(values, i));
                        const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                        
                        return (
                          <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                            <td className="p-1 border pl-4">{cat.name || '(unnamed)'}</td>
                            {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 0)}`}>{formatCurrency(v1)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v1, 0)}</td></>}
                            {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 1)}`}>{formatCurrency(v2)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v2, 1)}</td></>}
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 2)}`}>{formatCurrency(v3)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v3, 2)}</td>
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 3)}`}>{formatCurrency(v4)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v4, 3)}</td>
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 4)}`}>{formatCurrency(v5)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v5, 4)}</td>
                            <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(values, 5)}`}>{formatCurrency(vT)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(vT, 5)}</td>
                            <td className="p-0 border">
                              <ExpandableNotes
                                value={monthlyTtmNotes[noteKey]}
                                onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                hasVariance={hasVariance}
                                placeholder={hasVariance ? 'Explain variance...' : ''}
                                isFlagged={isManuallyFlagged}
                                onToggleFlag={() => setManualReviewFlags(prev => ({
                                  ...prev, 
                                  [noteKey]: { 
                                    ...prev[noteKey], 
                                    flagged: !prev[noteKey]?.flagged,
                                    created: prev[noteKey]?.created || Date.now(),
                                    section: 'Income Statement - Normalized',
                                    item: `COGS: ${cat.name}`
                                  }
                                }))}
                                noteKey={noteKey}
                              resolvedData={manualReviewFlags[noteKey]}
                              />
                            </td>
                          </tr>
                        );
                      })}
                      <tr className="font-bold">
                        {(() => {
                          const getCogsAdj = (yearLabel) => {
                            const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                            return yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                          };
                          const c1 = calculations.years[0].cogs + getCogsAdj(basisYearLabels.year1);
                          const c2 = calculations.years[1].cogs + getCogsAdj(basisYearLabels.year2);
                          const c3 = calculations.years[2].cogs + getCogsAdj(basisYearLabels.year3);
                          const c4 = calculations.years[3].cogs + getCogsAdj(basisYearLabels.year4);
                          const c5 = calculations.years[4].cogs + getCogsAdj(basisYearLabels.year5);
                          const cT = calculations.years[5].cogs + getCogsAdj('TTM');
                          return (
                            <>
                              <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total COGS</td>
                              {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(c1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(c1, 0)}</td></>}
                              {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(c2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(c2, 1)}</td></>}
                              <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(c3)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(c3, 2)}</td>
                              <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(c4)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(c4, 3)}</td>
                              <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(c5)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(c5, 4)}</td>
                              <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(cT)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-blue-100 text-xs">{pctOf(cT, 5)}</td>
                              <td className="p-1 border border-t-2 border-t-gray-400"></td>
                            </>
                          );
                        })()}
                      </tr>
                      
                      {/* GROSS PROFIT */}
                      <tr className="font-bold">
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 bg-gray-50">Gross Profit</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[0].grossProfit)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[0].grossMargin.toFixed(0)}%</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[1].grossProfit)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[1].grossMargin.toFixed(0)}%</td></>}
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[2].grossProfit)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[2].grossMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[3].grossProfit)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[3].grossMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[4].grossProfit)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[4].grossMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-200">{formatCurrency(calculations.years[5].grossProfit)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-800 bg-blue-100 text-xs">{calculations.years[5].grossMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-t-2 border-t-gray-400"></td>
                      </tr>
                      
                      {/* OPERATING EXPENSES */}
                      <tr className="bg-slate-50 font-semibold"><td colSpan={colSpanFull} className="p-1.5 border text-sm">OPERATING EXPENSES (Normalized)</td></tr>
                      {/* Owner's Salary */}
                      {(() => {
                        const hasSalary = ownerCompensation.year1?.salary || ownerCompensation.year2?.salary || ownerCompensation.year3?.salary || ownerCompensation.year4?.salary || ownerCompensation.year5?.salary || ownerCompensation.ttm?.salary;
                        if (!hasSalary) return null;
                        const mkt = ownerCompensation.marketReplacement;
                        return (
                          <tr>
                            <td className="p-1 border pl-4 font-medium">Owner's Salary <span className="text-xs text-gray-500 italic">(market)</span></td>
                            {showAllYears && <><td className="p-1 border text-right">{formatCurrency(mkFor('year1'))}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(mkFor('year1'), 0)}</td></>}
                            {showAllYears && <><td className="p-1 border text-right">{formatCurrency(mkFor('year2'))}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(mkFor('year2'), 1)}</td></>}
                            <td className="p-1 border text-right">{formatCurrency(mkFor('year3'))}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(mkFor('year3'), 2)}</td>
                            <td className="p-1 border text-right">{formatCurrency(mkFor('year4'))}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(mkFor('year4'), 3)}</td>
                            <td className="p-1 border text-right">{formatCurrency(mkFor('year5'))}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(mkFor('year5'), 4)}</td>
                            <td className="p-1 border text-right bg-blue-50">{formatCurrency(mkFor('ttm'))}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(mkFor('ttm'), 5)}</td>
                            <td className="p-1 border"></td>
                          </tr>
                        );
                      })()}
                      {/* Employer Payroll Tax (normalized) - shows the adjustment amount */}
                      {(() => {
                        const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
                        if (payrollTaxRate === 0) return null;
                        const mkt = ownerCompensation.marketReplacement || 0;
                        const hasSalary = ownerCompensation.year1?.salary || ownerCompensation.year2?.salary || ownerCompensation.year3?.salary || ownerCompensation.year4?.salary || ownerCompensation.year5?.salary || ownerCompensation.ttm?.salary;
                        if (!hasSalary && !mkt) return null;
                        
                        // Payroll tax adjustment = (market - salary) * rate
                        // Positive when market > salary (cost), Negative when market < salary (savings)
                        const getPayrollTaxAdj = (period) => {
                          const salary = period === 'ttm'
                            ? (ownerCompensation.ttm?.salary || (ownerCompensation.embeddedInWages ? (ownerCompensation.year5?.salary || 0) : 0))
                            : (ownerCompensation[period]?.salary || 0);
                          return ownerTaxAdj(salary, mkt, period);
                        };
                        const adj1 = getPayrollTaxAdj('year1');
                        const adj2 = getPayrollTaxAdj('year2');
                        const adj3 = getPayrollTaxAdj('year3');
                        const adj4 = getPayrollTaxAdj('year4');
                        const adj5 = getPayrollTaxAdj('year5');
                        const adjT = getPayrollTaxAdj('ttm');
                        
                        const formatTaxAdj = (adj) => {
                          if (adj === 0) return '-';
                          return <span className={adj < 0 ? 'text-green-600' : 'text-red-600'}>{formatCurrency(adj)}</span>;
                        };
                        
                        return (
                          <tr className="text-gray-600">
                            <td className="p-1 border pl-6 text-xs italic">Employer Payroll Tax ({payrollTaxLabel})</td>
                            {showAllYears && <><td className="p-1 border text-right text-xs">{formatTaxAdj(adj1)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(adj1, 0)}</td></>}
                            {showAllYears && <><td className="p-1 border text-right text-xs">{formatTaxAdj(adj2)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(adj2, 1)}</td></>}
                            <td className="p-1 border text-right text-xs">{formatTaxAdj(adj3)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(adj3, 2)}</td>
                            <td className="p-1 border text-right text-xs">{formatTaxAdj(adj4)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(adj4, 3)}</td>
                            <td className="p-1 border text-right text-xs">{formatTaxAdj(adj5)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(adj5, 4)}</td>
                            <td className="p-1 border text-right text-xs bg-blue-50">{formatTaxAdj(adjT)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(adjT, 5)}</td>
                            <td className="p-1 border"></td>
                          </tr>
                        );
                      })()}
                      {activeOpexCategories.map(cat => {
                        const getAdj = (yearLabel, yearKey) => {
                          const yearAdjs = adjustmentItems.filter(a => 
                            a.included && 
                            (a.plLine === `OpEx: ${cat.name}` || a.plLine === cat.plLine || a.plLine === cat.name) && 
                            (a.year === 'All Years' || a.year === yearLabel)
                          );
                          const itemAdj = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - 
                                 yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                          // Add line-based add-back (reduces expense, shown as negative)
                          const lineAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false ? -((cat[yearKey] || 0) * (cat.addbackPct / 100)) : 0;
                          return itemAdj + lineAddback;
                        };
                        const v1 = (cat.year1 || 0) + getAdj(basisYearLabels.year1, 'year1');
                        const v2 = (cat.year2 || 0) + getAdj(basisYearLabels.year2, 'year2');
                        const v3 = (cat.year3 || 0) + getAdj(basisYearLabels.year3, 'year3');
                        const v4 = (cat.year4 || 0) + getAdj(basisYearLabels.year4, 'year4');
                        const v5 = (cat.year5 || 0) + getAdj(basisYearLabels.year5, 'year5');
                        const vT = (cat.ttm || 0) + getAdj('TTM', 'ttm');
                        const values = [v1, v2, v3, v4, v5, vT];
                        const noteKey = `norm_opex_${cat.id}`;
                        const hasVariance = values.some((v, i) => getYoYHighlight(values, i));
                        const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                        const hasAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false;
                        const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                        
                        return (
                          <tr key={cat.id} className={`${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''} ${hasAddback ? (isDiat ? 'bg-amber-50' : 'bg-green-50') : ''}`}>
                            <td className="p-1 border pl-4">
                              {cat.name || '(unnamed)'}
                              {hasAddback && <span className={`ml-1 text-xs ${isDiat ? 'text-amber-600' : 'text-green-600'}`}>({cat.addbackPct}% {isDiat ? cat.adjCategory?.charAt(0) : 'adj'})</span>}
                            </td>
                            {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 0)}`}>{formatCurrency(v1)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v1, 0)}</td></>}
                            {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 1)}`}>{formatCurrency(v2)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v2, 1)}</td></>}
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 2)}`}>{formatCurrency(v3)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v3, 2)}</td>
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 3)}`}>{formatCurrency(v4)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v4, 3)}</td>
                            <td className={`p-1 border text-right ${getYoYHighlight(values, 4)}`}>{formatCurrency(v5)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v5, 4)}</td>
                            <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(values, 5)}`}>{formatCurrency(vT)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(vT, 5)}</td>
                            <td className="p-0 border">
                              <ExpandableNotes
                                value={monthlyTtmNotes[noteKey]}
                                onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                hasVariance={hasVariance}
                                placeholder={hasVariance ? 'Explain variance...' : ''}
                                isFlagged={isManuallyFlagged}
                                onToggleFlag={() => setManualReviewFlags(prev => ({
                                  ...prev, 
                                  [noteKey]: { 
                                    ...prev[noteKey], 
                                    flagged: !prev[noteKey]?.flagged,
                                    created: prev[noteKey]?.created || Date.now(),
                                    section: 'Income Statement - Normalized',
                                    item: `OpEx: ${cat.name}`
                                  }
                                }))}
                                noteKey={noteKey}
                              resolvedData={manualReviewFlags[noteKey]}
                              />
                            </td>
                          </tr>
                        );
                      })}
                      
                      {/* Maintenance CapEx */}
                      {(() => {
                        const capexAdjs = adjustmentItems.filter(a => a.included && a.plLine === 'CapEx');
                        const capexAdds = capexAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                        const capexDeducts = capexAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                        const capexNetChange = capexAdds - capexDeducts;
                        const hasCapexWarning = (addbacks.depreciation || addbacks.amortization) && capexNetChange === 0;
                        if (capexNetChange === 0 && !hasCapexWarning) return null;
                        return (
                          <tr>
                            <td className="p-1 border pl-4 font-medium">
                              Maintenance CapEx
                              <span className="text-xs text-gray-500 italic ml-1">(adj)</span>
                              {hasCapexWarning && <span className="text-orange-600 text-xs ml-1">⚠️</span>}
                            </td>
                            {showAllYears && <><td className="p-1 border text-right">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{capexNetChange !== 0 ? pctOf(capexNetChange, 0) : '-'}</td></>}
                            {showAllYears && <><td className="p-1 border text-right">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{capexNetChange !== 0 ? pctOf(capexNetChange, 1) : '-'}</td></>}
                            <td className="p-1 border text-right">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{capexNetChange !== 0 ? pctOf(capexNetChange, 2) : '-'}</td>
                            <td className="p-1 border text-right">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{capexNetChange !== 0 ? pctOf(capexNetChange, 3) : '-'}</td>
                            <td className="p-1 border text-right">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{capexNetChange !== 0 ? pctOf(capexNetChange, 4) : '-'}</td>
                            <td className="p-1 border text-right bg-blue-50">{capexNetChange !== 0 ? formatCurrency(capexNetChange) : '-'}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{capexNetChange !== 0 ? pctOf(capexNetChange, 5) : '-'}</td>
                            <td className="p-1 border"></td>
                          </tr>
                        );
                      })()}
                      
                      {/* Rent (Market Adj) */}
                      {(() => {
                        const rentAdjs = adjustmentItems.filter(a => a.included && a.plLine === 'Rent (Market Adj)');
                        const rentAdds = rentAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0);
                        const rentDeducts = rentAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                        const rentNetChange = rentAdds - rentDeducts;
                        if (rentNetChange === 0) return null;
                        return (
                          <tr>
                            <td className="p-1 border pl-4 font-medium">Rent <span className="text-xs text-gray-500 italic">(adj to mkt)</span></td>
                            {showAllYears && <><td className="p-1 border text-right">{formatCurrency(rentNetChange)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(rentNetChange, 0)}</td></>}
                            {showAllYears && <><td className="p-1 border text-right">{formatCurrency(rentNetChange)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(rentNetChange, 1)}</td></>}
                            <td className="p-1 border text-right">{formatCurrency(rentNetChange)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(rentNetChange, 2)}</td>
                            <td className="p-1 border text-right">{formatCurrency(rentNetChange)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(rentNetChange, 3)}</td>
                            <td className="p-1 border text-right">{formatCurrency(rentNetChange)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(rentNetChange, 4)}</td>
                            <td className="p-1 border text-right bg-blue-50">{formatCurrency(rentNetChange)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(rentNetChange, 5)}</td>
                            <td className="p-1 border"></td>
                          </tr>
                        );
                      })()}
                      
                      <tr className="font-bold">
                        <td className="p-1 border border-t-2 border-t-gray-400 bg-gray-50">Total OpEx</td>
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[0].adjustedOpex)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(calculations.years[0].adjustedOpex, 0)}</td></>}
                        {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[1].adjustedOpex)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(calculations.years[1].adjustedOpex, 1)}</td></>}
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[2].adjustedOpex)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(calculations.years[2].adjustedOpex, 2)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[3].adjustedOpex)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(calculations.years[3].adjustedOpex, 3)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-gray-50">{formatCurrency(calculations.years[4].adjustedOpex)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(calculations.years[4].adjustedOpex, 4)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-200">{formatCurrency(calculations.years[5].adjustedOpex)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-blue-100 text-xs">{pctOf(calculations.years[5].adjustedOpex, 5)}</td>
                        <td className="p-1 border border-t-2 border-t-gray-400"></td>
                      </tr>
                      
                      {/* Operating Income Row */}
                      <tr className="font-bold bg-blue-100">
                        {(() => {
                          const opInc1 = calculations.years[0].grossProfit - calculations.years[0].adjustedOpex;
                          const opInc2 = calculations.years[1].grossProfit - calculations.years[1].adjustedOpex;
                          const opInc3 = calculations.years[2].grossProfit - calculations.years[2].adjustedOpex;
                          const opInc4 = calculations.years[3].grossProfit - calculations.years[3].adjustedOpex;
                          const opInc5 = calculations.years[4].grossProfit - calculations.years[4].adjustedOpex;
                          const opIncT = calculations.years[5].grossProfit - calculations.years[5].adjustedOpex;
                          return (
                            <>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400">Operating Income</td>
                              {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(opInc1)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(opInc1, 0)}</td></>}
                              {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(opInc2)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(opInc2, 1)}</td></>}
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(opInc3)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(opInc3, 2)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(opInc4)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(opInc4, 3)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right">{formatCurrency(opInc5)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(opInc5, 4)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-200">{formatCurrency(opIncT)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-blue-100 text-xs">{pctOf(opIncT, 5)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400"></td>
                            </>
                          );
                        })()}
                      </tr>
                      
                      {/* OTHER INCOME (Non-Operating) */}
                      {activeOtherIncomeCategories.some(cat => cat.name) && (
                        <>
                          <tr className="bg-gray-100 font-medium"><td colSpan={colSpanFull} className="p-1 border text-xs text-gray-600">Other Income (Non-Operating)</td></tr>
                          {activeOtherIncomeCategories.filter(cat => cat.name).map(cat => {
                            const getAdj = (yearLabel, yearKey) => {
                              const yearAdjs = adjustmentItems.filter(a => 
                                a.included && 
                                (a.plLine === `OtherIncome: ${cat.name}` || a.plLine === cat.plLine) && 
                                (a.year === 'All Years' || a.year === yearLabel)
                              );
                              const explicitAdj = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - 
                                     yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                              // Line-based percentage deduction
                              const lineDeduct = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false
                                ? (cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)
                                : 0;
                              return explicitAdj - lineDeduct;
                            };
                            const v1 = (cat.year1 || 0) + getAdj(basisYearLabels.year1, 'year1');
                            const v2 = (cat.year2 || 0) + getAdj(basisYearLabels.year2, 'year2');
                            const v3 = (cat.year3 || 0) + getAdj(basisYearLabels.year3, 'year3');
                            const v4 = (cat.year4 || 0) + getAdj(basisYearLabels.year4, 'year4');
                            const v5 = (cat.year5 || 0) + getAdj(basisYearLabels.year5, 'year5');
                            const vT = (cat.ttm || 0) + getAdj('TTM', 'ttm');
                            const values = [v1, v2, v3, v4, v5, vT];
                            const hasYoYVariance = values.some((v, i) => getYoYHighlight(values, i));
                            
                            const noteKey = `norm_oi_${cat.id}`;
                            const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                            
                            return (
                              <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                                <td className="p-1 border pl-4">{cat.name}</td>
                                {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 0)}`}>{formatCurrency(v1)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v1, 0)}</td></>}
                                {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 1)}`}>{formatCurrency(v2)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v2, 1)}</td></>}
                                <td className={`p-1 border text-right ${getYoYHighlight(values, 2)}`}>{formatCurrency(v3)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v3, 2)}</td>
                                <td className={`p-1 border text-right ${getYoYHighlight(values, 3)}`}>{formatCurrency(v4)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v4, 3)}</td>
                                <td className={`p-1 border text-right ${getYoYHighlight(values, 4)}`}>{formatCurrency(v5)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v5, 4)}</td>
                                <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(values, 5)}`}>{formatCurrency(vT)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(vT, 5)}</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes[noteKey]}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                    hasVariance={hasYoYVariance}
                                    placeholder={hasYoYVariance ? 'Explain variance...' : ''}
                                    isFlagged={isManuallyFlagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      [noteKey]: { 
                                        ...prev[noteKey], 
                                        flagged: !prev[noteKey]?.flagged,
                                        created: prev[noteKey]?.created || Date.now(),
                                        section: 'Income Statement - Normalized',
                                        item: `Other Income: ${cat.name}`
                                      }
                                    }))}
                                    noteKey={noteKey}
                                  resolvedData={manualReviewFlags[noteKey]}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="font-bold">
                            {(() => {
                              const getOIAdj = (yearLabel, yearKey) => {
                                const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Income' || a.plLine.startsWith('OtherIncome: ')) && (a.year === 'All Years' || a.year === yearLabel));
                                const explicitAdj = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                                const lineDeducts = otherIncomeCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                                  .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                                return explicitAdj - lineDeducts;
                              };
                              const o1 = otherIncomeAnalysis.totals.year1 + getOIAdj(basisYearLabels.year1, 'year1');
                              const o2 = otherIncomeAnalysis.totals.year2 + getOIAdj(basisYearLabels.year2, 'year2');
                              const o3 = otherIncomeAnalysis.totals.year3 + getOIAdj(basisYearLabels.year3, 'year3');
                              const o4 = otherIncomeAnalysis.totals.year4 + getOIAdj(basisYearLabels.year4, 'year4');
                              const o5 = otherIncomeAnalysis.totals.year5 + getOIAdj(basisYearLabels.year5, 'year5');
                              const oT = otherIncomeAnalysis.totals.ttm + getOIAdj('TTM', 'ttm');
                              return (
                                <>
                                  <td className="p-1 border border-t-2 border-t-gray-400">Total Other Income</td>
                                  {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(o1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(o1, 0)}</td></>}
                                  {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(o2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(o2, 1)}</td></>}
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(o3)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(o3, 2)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(o4)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(o4, 3)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(o5)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(o5, 4)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(oT)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-blue-100 text-xs">{pctOf(oT, 5)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400"></td>
                                </>
                              );
                            })()}
                          </tr>
                        </>
                      )}
                      
                      {/* OTHER EXPENSE (Non-Operating) */}
                      {activeOtherExpenseCategories.some(cat => cat.name) && (
                        <>
                          <tr className="bg-gray-100 font-medium"><td colSpan={colSpanFull} className="p-1 border text-xs text-gray-600">Other Expense (Non-Operating)</td></tr>
                          {activeOtherExpenseCategories.filter(cat => cat.name).map(cat => {
                            const getAdj = (yearLabel, yearKey) => {
                              const yearAdjs = adjustmentItems.filter(a => 
                                a.included && 
                                (a.plLine === `OtherExpense: ${cat.name}` || a.plLine === cat.plLine) && 
                                (a.year === 'All Years' || a.year === yearLabel)
                              );
                              const itemAdj = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - 
                                     yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                              // Add line-based add-back (reduces expense)
                              const lineAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false ? -((cat[yearKey] || 0) * (cat.addbackPct / 100)) : 0;
                              return itemAdj + lineAddback;
                            };
                            const v1 = (cat.year1 || 0) + getAdj(basisYearLabels.year1, 'year1');
                            const v2 = (cat.year2 || 0) + getAdj(basisYearLabels.year2, 'year2');
                            const v3 = (cat.year3 || 0) + getAdj(basisYearLabels.year3, 'year3');
                            const v4 = (cat.year4 || 0) + getAdj(basisYearLabels.year4, 'year4');
                            const v5 = (cat.year5 || 0) + getAdj(basisYearLabels.year5, 'year5');
                            const vT = (cat.ttm || 0) + getAdj('TTM', 'ttm');
                            const values = [v1, v2, v3, v4, v5, vT];
                            const hasYoYVariance = values.some((v, i) => getYoYHighlight(values, i));
                            const hasAddback = (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false;
                            const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                            
                            const noteKey = `norm_oe_${cat.id}`;
                            const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                            
                            return (
                              <tr key={cat.id} className={isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}>
                                <td className="p-1 border pl-4">
                                  {cat.name}
                                  {hasAddback && <span className={`ml-1 text-xs ${isDiat ? 'text-amber-600' : 'text-green-600'}`}>({cat.addbackPct}% {isDiat ? cat.adjCategory?.charAt(0) : 'adj'})</span>}
                                </td>
                                {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 0)}`}>{formatCurrency(v1)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v1, 0)}</td></>}
                                {showAllYears && <><td className={`p-1 border text-right ${getYoYHighlight(values, 1)}`}>{formatCurrency(v2)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v2, 1)}</td></>}
                                <td className={`p-1 border text-right ${getYoYHighlight(values, 2)}`}>{formatCurrency(v3)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v3, 2)}</td>
                                <td className={`p-1 border text-right ${getYoYHighlight(values, 3)}`}>{formatCurrency(v4)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v4, 3)}</td>
                                <td className={`p-1 border text-right ${getYoYHighlight(values, 4)}`}>{formatCurrency(v5)}</td><td className="p-1 border text-right text-slate-500 bg-slate-50 text-xs">{pctOf(v5, 4)}</td>
                                <td className={`p-1 border text-right bg-blue-50 ${getYoYHighlight(values, 5)}`}>{formatCurrency(vT)}</td><td className="p-1 border text-right text-slate-500 bg-blue-50 text-xs">{pctOf(vT, 5)}</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes[noteKey]}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                    hasVariance={hasYoYVariance}
                                    placeholder={hasYoYVariance ? 'Explain variance...' : ''}
                                    isFlagged={isManuallyFlagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      [noteKey]: { 
                                        ...prev[noteKey], 
                                        flagged: !prev[noteKey]?.flagged,
                                        created: prev[noteKey]?.created || Date.now(),
                                        section: 'Income Statement - Normalized',
                                        item: `Other Expense: ${cat.name}`
                                      }
                                    }))}
                                    noteKey={noteKey}
                                  resolvedData={manualReviewFlags[noteKey]}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="font-bold">
                            {(() => {
                              const getOEAdj = (yearLabel, yearKey) => {
                                const yearAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Expense' || a.plLine.startsWith('OtherExpense: ')) && (a.year === 'All Years' || a.year === yearLabel));
                                const itemAdj = yearAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - yearAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                                // Add line-based add-backs (reduces expense)
                                const lineAddbacks = otherExpenseCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                                  .reduce((sum, cat) => sum - ((cat[selectedValuationBasis]?.[yearKey] || 0) * (cat.addbackPct / 100)), 0);
                                return itemAdj + lineAddbacks;
                              };
                              const e1 = otherExpenseAnalysis.totals.year1 + getOEAdj(basisYearLabels.year1, 'year1');
                              const e2 = otherExpenseAnalysis.totals.year2 + getOEAdj(basisYearLabels.year2, 'year2');
                              const e3 = otherExpenseAnalysis.totals.year3 + getOEAdj(basisYearLabels.year3, 'year3');
                              const e4 = otherExpenseAnalysis.totals.year4 + getOEAdj(basisYearLabels.year4, 'year4');
                              const e5 = otherExpenseAnalysis.totals.year5 + getOEAdj(basisYearLabels.year5, 'year5');
                              const eT = otherExpenseAnalysis.totals.ttm + getOEAdj('TTM', 'ttm');
                              return (
                                <>
                                  <td className="p-1 border border-t-2 border-t-gray-400">Total Other Expense</td>
                                  {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(e1)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(e1, 0)}</td></>}
                                  {showAllYears && <><td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(e2)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(e2, 1)}</td></>}
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(e3)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(e3, 2)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(e4)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(e4, 3)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-slate-100">{formatCurrency(e5)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(e5, 4)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400 text-right bg-blue-100">{formatCurrency(eT)}</td><td className="p-1 border border-t-2 border-t-gray-400 text-right text-slate-600 bg-blue-100 text-xs">{pctOf(eT, 5)}</td>
                                  <td className="p-1 border border-t-2 border-t-gray-400"></td>
                                </>
                              );
                            })()}
                          </tr>
                        </>
                      )}
                      
                      {/* Net Income */}
                      <tr className="font-bold">
                        {(() => {
                          // Net Income Normalized = Actual Net Income + All Adjustments (matches With Adjustments Normalized column)
                          const getNiAdj = (yearLabel, period) => {
                            const revAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Revenue' || a.plLine.startsWith('Revenue: ')) && (a.year === 'All Years' || a.year === yearLabel));
                            const revAdj = revAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - revAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                            const cogsAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'COGS' || a.plLine.startsWith('COGS: ')) && (a.year === 'All Years' || a.year === yearLabel));
                            const cogsAdj = cogsAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - cogsAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                            const opexAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'OpEx' || a.plLine.startsWith('OpEx: ') || a.plLine === 'Rent (Market Adj)' || a.plLine === 'CapEx') && (a.year === 'All Years' || a.year === yearLabel));
                            const opexAdj = opexAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - opexAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                            const salary = ownerCompensation[period]?.salary || 0;
                            const market = mkFor(period);
                            const ownerAdj = market > 0 ? -market : 0; // Market replacement reduces income (regardless of salary)
                            // Payroll tax adjustment: (market - salary) * rate - reduces Net Income
                            const payrollTaxRate = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
                            const payrollTaxAdj = ownerTaxAdj(salary, market, period);
                            const oiAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Income' || a.plLine.startsWith('OtherIncome: ')) && (a.year === 'All Years' || a.year === yearLabel));
                            const oiAdj = oiAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - oiAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                            const oeAdjs = adjustmentItems.filter(a => a.included && (a.plLine === 'Other Expense' || a.plLine.startsWith('OtherExpense: ')) && (a.year === 'All Years' || a.year === yearLabel));
                            const oeAdj = oeAdjs.filter(a => a.type === 'add').reduce((sum, a) => sum + a.amount, 0) - oeAdjs.filter(a => a.type === 'deduct').reduce((sum, a) => sum + a.amount, 0);
                            const lineAddback = opexCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                              .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                            const oeLineAddback = otherExpenseCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                              .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                            const oiLineDeduction = otherIncomeCategories.filter(cat => (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                              .reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.[period] || 0) * (cat.addbackPct / 100)), 0);
                            return revAdj - cogsAdj - opexAdj + ownerAdj - payrollTaxAdj + oiAdj - oeAdj + lineAddback + oeLineAddback - oiLineDeduction;
                          };
                          // Actual Net Income from P&L
                          const opexTotals = {
                            year1: activeOpexCategories.reduce((sum, c) => sum + (c.year1 || 0), 0),
                            year2: activeOpexCategories.reduce((sum, c) => sum + (c.year2 || 0), 0),
                            year3: activeOpexCategories.reduce((sum, c) => sum + (c.year3 || 0), 0),
                            year4: activeOpexCategories.reduce((sum, c) => sum + (c.year4 || 0), 0),
                            year5: activeOpexCategories.reduce((sum, c) => sum + (c.year5 || 0), 0),
                            ttm: activeOpexCategories.reduce((sum, c) => sum + (c.ttm || 0), 0)
                          };
                          const actualNetIncome = {
                            year1: revenueAnalysis.totals.year1 - cogsAnalysis.totals.year1 - opexTotals.year1 + otherIncomeAnalysis.totals.year1 - otherExpenseAnalysis.totals.year1,
                            year2: revenueAnalysis.totals.year2 - cogsAnalysis.totals.year2 - opexTotals.year2 + otherIncomeAnalysis.totals.year2 - otherExpenseAnalysis.totals.year2,
                            year3: revenueAnalysis.totals.year3 - cogsAnalysis.totals.year3 - opexTotals.year3 + otherIncomeAnalysis.totals.year3 - otherExpenseAnalysis.totals.year3,
                            year4: revenueAnalysis.totals.year4 - cogsAnalysis.totals.year4 - opexTotals.year4 + otherIncomeAnalysis.totals.year4 - otherExpenseAnalysis.totals.year4,
                            year5: revenueAnalysis.totals.year5 - cogsAnalysis.totals.year5 - opexTotals.year5 + otherIncomeAnalysis.totals.year5 - otherExpenseAnalysis.totals.year5,
                            ttm: revenueAnalysis.totals.ttm - cogsAnalysis.totals.ttm - opexTotals.ttm + otherIncomeAnalysis.totals.ttm - otherExpenseAnalysis.totals.ttm
                          };
                          // Normalized = Actual + Adjustments
                          const n1 = actualNetIncome.year1 + getNiAdj(basisYearLabels.year1, 'year1');
                          const n2 = actualNetIncome.year2 + getNiAdj(basisYearLabels.year2, 'year2');
                          const n3 = actualNetIncome.year3 + getNiAdj(basisYearLabels.year3, 'year3');
                          const n4 = actualNetIncome.year4 + getNiAdj(basisYearLabels.year4, 'year4');
                          const n5 = actualNetIncome.year5 + getNiAdj(basisYearLabels.year5, 'year5');
                          const nT = actualNetIncome.ttm + getNiAdj('TTM', 'ttm');
                          return (
                            <>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 bg-gray-50">Net Income</td>
                              {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(n1)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(n1, 0)}</td></>}
                              {showAllYears && <><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(n2)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(n2, 1)}</td></>}
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(n3)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(n3, 2)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(n4)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(n4, 3)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-gray-50">{formatCurrency(n5)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-slate-100 text-xs">{pctOf(n5, 4)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right bg-blue-200">{formatCurrency(nT)}</td><td className="p-1 border border-t-2 border-b-2 border-y-gray-400 text-right text-slate-600 bg-blue-100 text-xs">{pctOf(nT, 5)}</td>
                              <td className="p-1 border border-t-2 border-b-2 border-y-gray-400"></td>
                            </>
                          );
                        })()}
                      </tr>
                      
                      {/* EBITDA */}
                      <tr className="font-bold bg-green-100">
                        <td className="p-1 border border-b-2 border-b-gray-400">EBITDA</td>
                        {showAllYears && <><td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(calculations.years[0].adjustedEbitda)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[0].adjustedEbitdaMargin.toFixed(0)}%</td></>}
                        {showAllYears && <><td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(calculations.years[1].adjustedEbitda)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[1].adjustedEbitdaMargin.toFixed(0)}%</td></>}
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(calculations.years[2].adjustedEbitda)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[2].adjustedEbitdaMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(calculations.years[3].adjustedEbitda)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[3].adjustedEbitdaMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right">{formatCurrency(calculations.years[4].adjustedEbitda)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right text-slate-700 bg-slate-100 text-xs">{calculations.years[4].adjustedEbitdaMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-b-2 border-b-gray-400 text-right bg-green-200">{formatCurrency(calculations.years[5].adjustedEbitda)}</td><td className="p-1 border border-b-2 border-b-gray-400 text-right text-slate-800 bg-green-100 text-xs font-bold">{calculations.years[5].adjustedEbitdaMargin.toFixed(0)}%</td>
                        <td className="p-1 border border-b-2 border-b-gray-400"></td>
                      </tr>
                    </>
                  );
                })()}
              </tbody>
              <tfoot>
                <tr className="bg-gray-200">
                  <th className="text-left p-2 border" style={{width: '180px'}}>Line Item</th>
                  {showAllYears && <><th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year1 || 'Year 1'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th></>}
                  {showAllYears && <><th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year2 || 'Year 2'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th></>}
                  <th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year3 || 'Year 3'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year4 || 'Year 4'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border" style={{width: '70px'}}>{displayYearLabels.year5 || 'Year 5'}</th><th className="text-center p-2 border bg-slate-50 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border bg-blue-200" style={{width: '70px'}}>{ttmLabel}</th><th className="text-center p-2 border bg-blue-100 text-slate-600 text-xs" style={{width: '35px'}}>%</th>
                  <th className="text-center p-2 border bg-gray-100" style={{width: '150px'}}>Notes</th>
                </tr>
              </tfoot>
            </table>
            )}
            
            {/* MONTHLY VIEW - TTM Monthly Breakdown */}
            {incomeStmtViewMode === 'monthly' && (
              <div className="overflow-x-auto">
                {!ebitdaMonthlyAnalysis.hasMonthlyData ? (
                  <div className="p-6 bg-slate-50 border border-slate-200 rounded-lg text-center">
                    <p className="text-yellow-800 font-medium">No monthly data available</p>
                    <p className="text-sm text-yellow-600 mt-1">Enter monthly data on the TTM Monthly tab to see this view</p>
                  </div>
                ) : (
                  <>
                    <table className="w-full text-xs border-collapse">
                      <thead>
                        <tr className="bg-gray-200">
                          <th className="text-left p-2 border" style={{minWidth: '140px'}}>Category</th>
                          {(() => {
                            // Generate month labels based on TTM end date
                            const months = [];
                            let month = monthlyTtmConfig.endMonth - 11;
                            let year = monthlyTtmConfig.endYear;
                            if (month < 0) { month += 12; year--; }
                            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                            for (let i = 0; i < 12; i++) {
                              const m = (month + i) % 12;
                              const y = month + i >= 12 ? year + 1 : year;
                              months.push(`${monthNames[m]} ${String(y).slice(-2)}`);
                            }
                            return months.map((m, i) => (
                              <th key={i} className="text-center p-2 border" style={{minWidth: '70px'}}>{m}</th>
                            ));
                          })()}
                          <th className="text-center p-2 border bg-blue-200 font-bold" style={{minWidth: '90px'}}>TTM Total</th>
                          <th className="text-center p-2 border bg-gray-100" style={{minWidth: '150px'}}>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Revenue with variance highlighting - uses median like data entry tab */}
                        {(() => {
                          const varianceThreshold = monthlyTtmConfig.varianceThreshold || 20;
                          const materialityThreshold = monthlyTtmConfig.monthlyMaterialityThreshold || 500;
                          
                          // Get revenue line items with monthly data
                          const revenueLineItems = revenueCategories.filter(cat => cat.name).map(cat => {
                            const monthlyData = monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || Array(12).fill(0);
                            const activeMonths = monthlyData.slice(0, 12);
                            const total = activeMonths.reduce((a, b) => a + (b || 0), 0);
                            const median = calcMedian(activeMonths);
                            return { ...cat, monthlyData: activeMonths, total, median };
                          }).filter(cat => Math.abs(cat.total) > 0 || cat.monthlyData.some(v => Math.abs(v) > 0));
                          
                          // Calculate total row data
                          const revTotal = ebitdaMonthlyAnalysis.monthlyRevenue.reduce((a,b) => a+b, 0);
                          const totalMedian = calcMedian(ebitdaMonthlyAnalysis.monthlyRevenue);
                          
                          return (
                            <>
                              {/* Revenue detail lines with cell-level variance highlighting */}
                              {revenueLineItems.map((cat, idx) => {
                                const hasVariance = cat.monthlyData.some((v, i) => {
                                  const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                  return Math.abs(medianVariance || 0) > varianceThreshold && v >= materialityThreshold;
                                });
                                const noteKey = `monthly_rev_${cat.id}`;
                                const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                const hasAnnualDataRev = ['year1','year2','year3','year4','year5'].some(y =>
                                  (cat.accrual?.[y] || 0) !== 0 || (cat.cash?.[y] || 0) !== 0
                                );
                                return (
                                  <tr key={cat.id} className={`text-gray-600 text-xs ${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}`}>
                                    <td className="p-1 pl-4 border">
                                      <div className="flex items-center gap-1 group">
                                        <span className="flex-1">{cat.name}</span>
                                        <button
                                          title={hasAnnualDataRev ? `Delete — also has historical annual data` : `Delete row`}
                                          onClick={() => {
                                            const msg = hasAnnualDataRev
                                              ? `Delete "${cat.name}"?\n\nThis account also has historical annual data. Deleting will remove it from all views.`
                                              : `Delete "${cat.name}" from the P&L?`;
                                            if (window.confirm(msg)) {
                                              captureUndoState(`Delete monthly revenue row: ${cat.name}`);
                                              setRevenueCategories(prev => prev.filter(c => c.id !== cat.id));
                                              setMonthlyTtmRevenue(prev => { const n = {...prev}; delete n[String(cat.id)]; return n; });
                                            }
                                          }}
                                          className="opacity-0 group-hover:opacity-100 text-red-400 hover:text-red-600 text-xs px-1 flex-shrink-0 transition-opacity"
                                        >✕</button>
                                      </div>
                                    </td>
                                    {cat.monthlyData.map((v, i) => {
                                      const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                      const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && v >= materialityThreshold;
                                      return (
                                        <td key={i} className={`p-1 border text-right ${isHighVariance ? 'bg-amber-100' : ''}`}>
                                          {formatCurrency(v || 0)}
                                        </td>
                                      );
                                    })}
                                    <td className="p-1 border text-right bg-gray-50">{formatCurrency(cat.total)}</td>
                                    <td className="p-0 border">
                                      <ExpandableNotes
                                        value={monthlyTtmNotes[noteKey]}
                                        onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                        hasVariance={hasVariance}
                                        placeholder={hasVariance ? 'Explain variance...' : ''}
                                        isFlagged={isManuallyFlagged}
                                        onToggleFlag={() => setManualReviewFlags(prev => ({
                                          ...prev, 
                                          [noteKey]: { 
                                            ...prev[noteKey], 
                                            flagged: !prev[noteKey]?.flagged,
                                            created: prev[noteKey]?.created || Date.now(),
                                            section: 'Income Statement - Monthly',
                                            item: `Revenue: ${cat.name}`
                                          }
                                        }))}
                                        noteKey={noteKey}
                                      resolvedData={manualReviewFlags[noteKey]}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                              {/* Revenue total row with cell-level variance highlighting */}
                              <tr className="bg-slate-50 font-semibold">
                                <td className="p-2 border">Revenue</td>
                                {ebitdaMonthlyAnalysis.monthlyRevenue.map((v, i) => {
                                  const medianVariance = totalMedian !== 0 ? ((v - totalMedian) / totalMedian) * 100 : null;
                                  const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && v >= materialityThreshold;
                                  return (
                                    <td key={i} className={`p-1.5 border text-right ${isHighVariance ? 'bg-amber-200' : ''}`}>
                                      {formatCurrency(v)}
                                    </td>
                                  );
                                })}
                                <td className="p-1.5 border text-right bg-gray-50 font-bold">{formatCurrencyExact(revTotal)}</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes['monthly_revenue_total']}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_revenue_total': val}))}
                                    hasVariance={false}
                                    placeholder="Notes on total revenue..."
                                    isFlagged={manualReviewFlags['monthly_revenue_total']?.flagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      'monthly_revenue_total': { 
                                        ...prev['monthly_revenue_total'], 
                                        flagged: !prev['monthly_revenue_total']?.flagged,
                                        created: prev['monthly_revenue_total']?.created || Date.now(),
                                        section: 'Income Statement - Monthly',
                                        item: 'Total Revenue'
                                      }
                                    }))}
                                    noteKey="monthly_revenue_total"
                                    resolvedData={manualReviewFlags['monthly_revenue_total']}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })()}
                        {/* COGS with variance highlighting */}
                        {(() => {
                          const varianceThreshold = monthlyTtmConfig.varianceThreshold || 20;
                          const materialityThreshold = monthlyTtmConfig.monthlyMaterialityThreshold || 500;
                          
                          // Get COGS line items with monthly data and median
                          const cogsLineItems = cogsCategories.filter(cat => cat.name).map(cat => {
                            const monthlyData = monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || Array(12).fill(0);
                            const activeMonths = monthlyData.slice(0, 12);
                            const total = activeMonths.reduce((a, b) => a + (b || 0), 0);
                            const median = calcMedian(activeMonths);
                            return { ...cat, monthlyData: activeMonths, total, median };
                          }).filter(cat => Math.abs(cat.total) > 0 || cat.monthlyData.some(v => Math.abs(v) > 0));
                          
                          // Calculate total row median
                          const totalMedian = calcMedian(ebitdaMonthlyAnalysis.monthlyCogs);
                          
                          return (
                            <>
                              {/* COGS detail lines with cell-level variance highlighting */}
                              {cogsLineItems.map((cat, idx) => {
                                const hasVariance = cat.monthlyData.some((v, i) => {
                                  const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                  return Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                });
                                const noteKey = `monthly_cogs_${cat.id}`;
                                const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                const hasAnnualDataCogs = ['year1','year2','year3','year4','year5'].some(y =>
                                  (cat.accrual?.[y] || 0) !== 0 || (cat.cash?.[y] || 0) !== 0
                                );
                                return (
                                  <tr key={cat.id} className={`text-gray-500 text-xs ${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}`}>
                                    <td className="p-1 pl-4 border">
                                      <div className="flex items-center gap-1 group">
                                        <span className="flex-1">{cat.name}</span>
                                        <button
                                          title={hasAnnualDataCogs ? `Delete — also has historical annual data` : `Delete row`}
                                          onClick={() => {
                                            const msg = hasAnnualDataCogs
                                              ? `Delete "${cat.name}"?\n\nThis account also has historical annual data. Deleting will remove it from all views.`
                                              : `Delete "${cat.name}" from the P&L?`;
                                            if (window.confirm(msg)) {
                                              captureUndoState(`Delete monthly COGS row: ${cat.name}`);
                                              setCogsCategories(prev => prev.filter(c => c.id !== cat.id));
                                              setMonthlyTtmCogs(prev => { const n = {...prev}; delete n[String(cat.id)]; return n; });
                                            }
                                          }}
                                          className="opacity-0 group-hover:opacity-100 text-red-400 hover:text-red-600 text-xs px-1 flex-shrink-0 transition-opacity"
                                        >✕</button>
                                      </div>
                                    </td>
                                    {cat.monthlyData.map((v, i) => {
                                      const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                      const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                      return (
                                        <td key={i} className={`p-1 border text-right ${isHighVariance ? 'bg-amber-100' : ''}`}>
                                          ({formatCurrency(Math.abs(v || 0))})
                                        </td>
                                      );
                                    })}
                                    <td className="p-1 border text-right bg-gray-50">({formatCurrency(Math.abs(cat.total))})</td>
                                    <td className="p-0 border">
                                      <ExpandableNotes
                                        value={monthlyTtmNotes[noteKey]}
                                        onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                        hasVariance={hasVariance}
                                        placeholder={hasVariance ? 'Explain variance...' : ''}
                                        isFlagged={isManuallyFlagged}
                                        onToggleFlag={() => setManualReviewFlags(prev => ({
                                          ...prev, 
                                          [noteKey]: { 
                                            ...prev[noteKey], 
                                            flagged: !prev[noteKey]?.flagged,
                                            created: prev[noteKey]?.created || Date.now(),
                                            section: 'Income Statement - Monthly',
                                            item: `COGS: ${cat.name}`
                                          }
                                        }))}
                                        noteKey={noteKey}
                                      resolvedData={manualReviewFlags[noteKey]}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                              {/* COGS total row with cell-level variance highlighting */}
                              <tr className="bg-slate-50">
                                <td className="p-2 border">COGS</td>
                                {ebitdaMonthlyAnalysis.monthlyCogs.map((v, i) => {
                                  const medianVariance = totalMedian !== 0 ? ((v - totalMedian) / totalMedian) * 100 : null;
                                  const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                  return (
                                    <td key={i} className={`p-1.5 border text-right text-slate-600 ${isHighVariance ? 'bg-amber-200' : ''}`}>
                                      ({formatCurrency(Math.abs(v))})
                                    </td>
                                  );
                                })}
                                <td className="p-1.5 border text-right bg-gray-50 text-slate-600">({formatCurrencyExact(Math.abs(ebitdaMonthlyAnalysis.monthlyCogs.reduce((a,b) => a+b, 0)))})</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes['monthly_cogs_total']}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_cogs_total': val}))}
                                    hasVariance={false}
                                    placeholder="Notes on total COGS..."
                                    isFlagged={manualReviewFlags['monthly_cogs_total']?.flagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      'monthly_cogs_total': { 
                                        ...prev['monthly_cogs_total'], 
                                        flagged: !prev['monthly_cogs_total']?.flagged,
                                        created: prev['monthly_cogs_total']?.created || Date.now(),
                                        section: 'Income Statement - Monthly',
                                        item: 'Total COGS'
                                      }
                                    }))}
                                    noteKey="monthly_cogs_total"
                                    resolvedData={manualReviewFlags['monthly_cogs_total']}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })()}
                        {/* Gross Profit */}
                        <tr className="font-semibold bg-gray-50">
                          <td className="p-2 border">Gross Profit</td>
                          {ebitdaMonthlyAnalysis.monthlyGrossProfit.map((v, i) => (
                            <td key={i} className={`p-1.5 border text-right ${v < 0 ? 'bg-amber-100 text-amber-700' : ''}`}>{formatCurrency(v)}</td>
                          ))}
                          <td className="p-1.5 border text-right bg-gray-100 font-bold">{formatCurrencyExact(ebitdaMonthlyAnalysis.monthlyGrossProfit.reduce((a,b) => a+b, 0))}</td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes['monthly_gross_profit']}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_gross_profit': val}))}
                              hasVariance={false}
                              placeholder="Notes on gross profit..."
                              isFlagged={manualReviewFlags['monthly_gross_profit']?.flagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                'monthly_gross_profit': { 
                                  ...prev['monthly_gross_profit'], 
                                  flagged: !prev['monthly_gross_profit']?.flagged,
                                  created: prev['monthly_gross_profit']?.created || Date.now(),
                                  section: 'Income Statement - Monthly',
                                  item: 'Gross Profit'
                                }
                              }))}
                              noteKey="monthly_gross_profit"
                              resolvedData={manualReviewFlags['monthly_gross_profit']}
                            />
                          </td>
                        </tr>
                        {/* OpEx with variance highlighting */}
                        {(() => {
                          const varianceThreshold = monthlyTtmConfig.varianceThreshold || 20;
                          const materialityThreshold = monthlyTtmConfig.monthlyMaterialityThreshold || 500;
                          
                          // Get OpEx line items with monthly data and median
                          const opexLineItems = opexCategories.filter(cat => cat.name).map(cat => {
                            const monthlyData = monthlyTtmOpex[cat.id]?.[selectedValuationBasis] || Array(12).fill(0);
                            const activeMonths = monthlyData.slice(0, 12);
                            const total = activeMonths.reduce((a, b) => a + (b || 0), 0);
                            const median = calcMedian(activeMonths);
                            return { ...cat, monthlyData: activeMonths, total, median };
                          }).filter(cat => Math.abs(cat.total) > 0 || cat.monthlyData.some(v => Math.abs(v) > 0));
                          
                          // Calculate total row median
                          const totalMedian = calcMedian(ebitdaMonthlyAnalysis.monthlyOpex);
                          
                          return (
                            <>
                              {/* OpEx detail lines with cell-level variance highlighting */}
                              {opexLineItems.map((cat, idx) => {
                                const hasVariance = cat.monthlyData.some((v, i) => {
                                  const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                  return Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                });
                                const noteKey = `monthly_opex_${cat.id}`;
                                const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                const hasAnnualData = ['year1','year2','year3','year4','year5'].some(y =>
                                  (cat.accrual?.[y] || 0) !== 0 || (cat.cash?.[y] || 0) !== 0
                                );
                                return (
                                  <tr key={cat.id} className={`text-gray-500 text-xs ${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}`}>
                                    <td className="p-1 pl-4 border">
                                      <div className="flex items-center gap-1 group">
                                        <span className="flex-1">{cat.name}</span>
                                        {(cat.addbackPct || 0) > 0 && (
                                          <span className="ml-1 text-green-600 text-xs">({cat.addbackPct}% add-back)</span>
                                        )}
                                        <button
                                          title={hasAnnualData ? `Delete — also has Year 3/Year 4 data, will remove from annual view too` : `Delete row`}
                                          onClick={() => {
                                            const msg = hasAnnualData
                                              ? `Delete "${cat.name}"?\n\nThis account also has historical data in the annual P&L view (Year 3/Year 4). Deleting will remove it from all views.`
                                              : `Delete "${cat.name}" from the P&L?`;
                                            if (window.confirm(msg)) {
                                              captureUndoState(`Delete monthly opex row: ${cat.name}`);
                                              setOpexCategories(prev => prev.filter(c => c.id !== cat.id));
                                              setMonthlyTtmOpex(prev => { const n = {...prev}; delete n[String(cat.id)]; return n; });
                                            }
                                          }}
                                          className="opacity-0 group-hover:opacity-100 text-red-400 hover:text-red-600 text-xs px-1 flex-shrink-0 transition-opacity"
                                        >✕</button>
                                      </div>
                                    </td>
                                    {cat.monthlyData.map((v, i) => {
                                      const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                      const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                      return (
                                        <td key={i} className={`p-1 border text-right ${isHighVariance ? 'bg-amber-100' : ''}`}>
                                          ({formatCurrency(Math.abs(v || 0))})
                                        </td>
                                      );
                                    })}
                                    <td className="p-1 border text-right bg-gray-50">({formatCurrency(Math.abs(cat.total))})</td>
                                    <td className="p-0 border">
                                      <ExpandableNotes
                                        value={monthlyTtmNotes[noteKey]}
                                        onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                        hasVariance={hasVariance}
                                        placeholder={hasVariance ? 'Explain variance...' : ''}
                                        isFlagged={isManuallyFlagged}
                                        onToggleFlag={() => setManualReviewFlags(prev => ({
                                          ...prev, 
                                          [noteKey]: { 
                                            ...prev[noteKey], 
                                            flagged: !prev[noteKey]?.flagged,
                                            created: prev[noteKey]?.created || Date.now(),
                                            section: 'Income Statement - Monthly',
                                            item: `OpEx: ${cat.name}`
                                          }
                                        }))}
                                        noteKey={noteKey}
                                      resolvedData={manualReviewFlags[noteKey]}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                              {/* OpEx total row with cell-level variance highlighting */}
                              <tr className="bg-slate-50">
                                <td className="p-2 border">Operating Expenses</td>
                                {ebitdaMonthlyAnalysis.monthlyOpex.map((v, i) => {
                                  const medianVariance = totalMedian !== 0 ? ((v - totalMedian) / totalMedian) * 100 : null;
                                  const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                  return (
                                    <td key={i} className={`p-1.5 border text-right text-slate-600 ${isHighVariance ? 'bg-amber-200' : ''}`}>
                                      ({formatCurrency(Math.abs(v))})
                                    </td>
                                  );
                                })}
                                <td className="p-1.5 border text-right bg-gray-50 text-slate-600">({formatCurrencyExact(Math.abs(ebitdaMonthlyAnalysis.monthlyOpex.reduce((a,b) => a+b, 0)))})</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes['monthly_opex_total']}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_opex_total': val}))}
                                    hasVariance={false}
                                    placeholder="Notes on total operating expenses..."
                                    isFlagged={manualReviewFlags['monthly_opex_total']?.flagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      'monthly_opex_total': { 
                                        ...prev['monthly_opex_total'], 
                                        flagged: !prev['monthly_opex_total']?.flagged,
                                        created: prev['monthly_opex_total']?.created || Date.now(),
                                        section: 'Income Statement - Monthly',
                                        item: 'Total Operating Expenses'
                                      }
                                    }))}
                                    noteKey="monthly_opex_total"
                                    resolvedData={manualReviewFlags['monthly_opex_total']}
                                  />
                                </td>
                              </tr>
                              {/* Operating Income row */}
                              <tr className="font-semibold bg-blue-100">
                                <td className="p-2 border">Operating Income</td>
                                {ebitdaMonthlyAnalysis.monthlyGrossProfit.map((gp, i) => {
                                  const opInc = gp - ebitdaMonthlyAnalysis.monthlyOpex[i];
                                  return (
                                    <td key={i} className={`p-1.5 border text-right ${opInc < 0 ? 'bg-amber-100 text-amber-700' : ''}`}>
                                      {opInc < 0 ? `(${formatCurrency(Math.abs(opInc))})` : formatCurrency(opInc)}
                                    </td>
                                  );
                                })}
                                <td className="p-1.5 border text-right bg-blue-200 font-bold">
                                  {formatCurrencyExact(ebitdaMonthlyAnalysis.monthlyGrossProfit.reduce((a,b) => a+b, 0) - ebitdaMonthlyAnalysis.monthlyOpex.reduce((a,b) => a+b, 0))}
                                </td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes['monthly_operating_income']}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_operating_income': val}))}
                                    hasVariance={false}
                                    placeholder="Notes on operating income..."
                                    isFlagged={manualReviewFlags['monthly_operating_income']?.flagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      'monthly_operating_income': { 
                                        ...prev['monthly_operating_income'], 
                                        flagged: !prev['monthly_operating_income']?.flagged,
                                        created: prev['monthly_operating_income']?.created || Date.now(),
                                        section: 'Income Statement - Monthly',
                                        item: 'Operating Income'
                                      }
                                    }))}
                                    noteKey="monthly_operating_income"
                                    resolvedData={manualReviewFlags['monthly_operating_income']}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })()}
                        {/* Other Income with variance highlighting */}
                        {(() => {
                          const hasOtherIncome = (ebitdaMonthlyAnalysis.monthlyOtherIncome || []).some(v => v > 0);
                          if (!hasOtherIncome) return null;
                          
                          const varianceThreshold = monthlyTtmConfig.varianceThreshold || 20;
                          const materialityThreshold = monthlyTtmConfig.monthlyMaterialityThreshold || 500;
                          
                          // Get Other Income line items with monthly data and median
                          const otherIncomeLineItems = otherIncomeCategories.filter(cat => cat.name).map(cat => {
                            const monthlyData = monthlyTtmOtherIncome[cat.id]?.[selectedValuationBasis] || Array(12).fill(0);
                            const activeMonths = monthlyData.slice(0, 12);
                            const total = activeMonths.reduce((a, b) => a + (b || 0), 0);
                            const median = calcMedian(activeMonths);
                            return { ...cat, monthlyData: activeMonths, total, median };
                          }).filter(cat => Math.abs(cat.total) > 0 || cat.monthlyData.some(v => Math.abs(v) > 0));
                          
                          // Calculate total row median
                          const totalMedian = calcMedian(ebitdaMonthlyAnalysis.monthlyOtherIncome || []);
                          
                          return (
                            <>
                              {/* Other Income detail lines with cell-level variance highlighting */}
                              {otherIncomeLineItems.map((cat, idx) => {
                                const hasVariance = cat.monthlyData.some((v, i) => {
                                  const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                  return Math.abs(medianVariance || 0) > varianceThreshold && v >= materialityThreshold;
                                });
                                const noteKey = `monthly_oi_${cat.id}`;
                                const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                return (
                                  <tr key={cat.id} className={`text-gray-500 text-xs ${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}`}>
                                    <td className="p-1 pl-4 border">{cat.name}</td>
                                    {cat.monthlyData.map((v, i) => {
                                      const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                      const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && v >= materialityThreshold;
                                      return (
                                        <td key={i} className={`p-1 border text-right ${isHighVariance ? 'bg-amber-100' : ''}`}>
                                          {formatCurrency(v || 0)}
                                        </td>
                                      );
                                    })}
                                    <td className="p-1 border text-right bg-gray-50">{formatCurrency(cat.total)}</td>
                                    <td className="p-0 border">
                                      <ExpandableNotes
                                        value={monthlyTtmNotes[noteKey]}
                                        onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                        hasVariance={hasVariance}
                                        placeholder={hasVariance ? 'Explain variance...' : ''}
                                        isFlagged={isManuallyFlagged}
                                        onToggleFlag={() => setManualReviewFlags(prev => ({
                                          ...prev, 
                                          [noteKey]: { 
                                            ...prev[noteKey], 
                                            flagged: !prev[noteKey]?.flagged,
                                            created: prev[noteKey]?.created || Date.now(),
                                            section: 'Income Statement - Monthly',
                                            item: `Other Income: ${cat.name}`
                                          }
                                        }))}
                                        noteKey={noteKey}
                                      resolvedData={manualReviewFlags[noteKey]}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                              {/* Other Income total row with cell-level variance highlighting */}
                              <tr className="bg-slate-50">
                                <td className="p-2 border">Other Income</td>
                                {ebitdaMonthlyAnalysis.monthlyOtherIncome.map((v, i) => {
                                  const medianVariance = totalMedian !== 0 ? ((v - totalMedian) / totalMedian) * 100 : null;
                                  const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && v >= materialityThreshold;
                                  return (
                                    <td key={i} className={`p-1.5 border text-right text-green-600 ${isHighVariance ? 'bg-amber-200' : ''}`}>
                                      {formatCurrency(v)}
                                    </td>
                                  );
                                })}
                                <td className="p-1.5 border text-right bg-gray-50 text-green-600">{formatCurrencyExact(ebitdaMonthlyAnalysis.monthlyOtherIncome.reduce((a,b) => a+b, 0))}</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes['monthly_other_income_total']}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_other_income_total': val}))}
                                    hasVariance={false}
                                    placeholder="Notes on total other income..."
                                    isFlagged={manualReviewFlags['monthly_other_income_total']?.flagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      'monthly_other_income_total': { 
                                        ...prev['monthly_other_income_total'], 
                                        flagged: !prev['monthly_other_income_total']?.flagged,
                                        created: prev['monthly_other_income_total']?.created || Date.now(),
                                        section: 'Income Statement - Monthly',
                                        item: 'Total Other Income'
                                      }
                                    }))}
                                    noteKey="monthly_other_income_total"
                                    resolvedData={manualReviewFlags['monthly_other_income_total']}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })()}
                        {/* Other Expense with variance highlighting */}
                        {(() => {
                          const hasOtherExpense = (ebitdaMonthlyAnalysis.monthlyOtherExpense || []).some(v => v > 0);
                          if (!hasOtherExpense) return null;
                          
                          const varianceThreshold = monthlyTtmConfig.varianceThreshold || 20;
                          const materialityThreshold = monthlyTtmConfig.monthlyMaterialityThreshold || 500;
                          
                          // Get Other Expense line items with monthly data and median
                          const otherExpenseLineItems = otherExpenseCategories.filter(cat => cat.name).map(cat => {
                            const monthlyData = monthlyTtmOtherExpense[cat.id]?.[selectedValuationBasis] || Array(12).fill(0);
                            const activeMonths = monthlyData.slice(0, 12);
                            const total = activeMonths.reduce((a, b) => a + (b || 0), 0);
                            const median = calcMedian(activeMonths);
                            return { ...cat, monthlyData: activeMonths, total, median };
                          }).filter(cat => Math.abs(cat.total) > 0 || cat.monthlyData.some(v => Math.abs(v) > 0));
                          
                          // Calculate total row median
                          const totalMedian = calcMedian(ebitdaMonthlyAnalysis.monthlyOtherExpense || []);
                          
                          return (
                            <>
                              {/* Other Expense detail lines with cell-level variance highlighting */}
                              {otherExpenseLineItems.map((cat, idx) => {
                                const hasVariance = cat.monthlyData.some((v, i) => {
                                  const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                  return Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                });
                                const noteKey = `monthly_oe_${cat.id}`;
                                const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                return (
                                  <tr key={cat.id} className={`text-gray-500 text-xs ${isManuallyFlagged ? 'border-l-4 border-l-purple-500 bg-purple-50' : ''}`}>
                                    <td className="p-1 pl-4 border">{cat.name}</td>
                                    {cat.monthlyData.map((v, i) => {
                                      const medianVariance = cat.median !== 0 ? ((v - cat.median) / cat.median) * 100 : null;
                                      const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                      return (
                                        <td key={i} className={`p-1 border text-right ${isHighVariance ? 'bg-amber-100' : ''}`}>
                                          ({formatCurrency(Math.abs(v || 0))})
                                        </td>
                                      );
                                    })}
                                    <td className="p-1 border text-right bg-gray-50">({formatCurrency(Math.abs(cat.total))})</td>
                                    <td className="p-0 border">
                                      <ExpandableNotes
                                        value={monthlyTtmNotes[noteKey]}
                                        onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                        hasVariance={hasVariance}
                                        placeholder={hasVariance ? 'Explain variance...' : ''}
                                        isFlagged={isManuallyFlagged}
                                        onToggleFlag={() => setManualReviewFlags(prev => ({
                                          ...prev, 
                                          [noteKey]: { 
                                            ...prev[noteKey], 
                                            flagged: !prev[noteKey]?.flagged,
                                            created: prev[noteKey]?.created || Date.now(),
                                            section: 'Income Statement - Monthly',
                                            item: `Other Expense: ${cat.name}`
                                          }
                                        }))}
                                        noteKey={noteKey}
                                      resolvedData={manualReviewFlags[noteKey]}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                              {/* Other Expense total row with cell-level variance highlighting */}
                              <tr className="bg-slate-50">
                                <td className="p-2 border">Other Expense</td>
                                {ebitdaMonthlyAnalysis.monthlyOtherExpense.map((v, i) => {
                                  const medianVariance = totalMedian !== 0 ? ((v - totalMedian) / totalMedian) * 100 : null;
                                  const isHighVariance = Math.abs(medianVariance || 0) > varianceThreshold && Math.abs(v) >= materialityThreshold;
                                  return (
                                    <td key={i} className={`p-1.5 border text-right text-red-600 ${isHighVariance ? 'bg-amber-200' : ''}`}>
                                      ({formatCurrency(Math.abs(v))})
                                    </td>
                                  );
                                })}
                                <td className="p-1.5 border text-right bg-gray-50 text-red-600">({formatCurrencyExact(Math.abs(ebitdaMonthlyAnalysis.monthlyOtherExpense.reduce((a,b) => a+b, 0)))})</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={monthlyTtmNotes['monthly_other_expense_total']}
                                    onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_other_expense_total': val}))}
                                    hasVariance={false}
                                    placeholder="Notes on total other expense..."
                                    isFlagged={manualReviewFlags['monthly_other_expense_total']?.flagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev, 
                                      'monthly_other_expense_total': { 
                                        ...prev['monthly_other_expense_total'], 
                                        flagged: !prev['monthly_other_expense_total']?.flagged,
                                        created: prev['monthly_other_expense_total']?.created || Date.now(),
                                        section: 'Income Statement - Monthly',
                                        item: 'Total Other Expense'
                                      }
                                    }))}
                                    noteKey="monthly_other_expense_total"
                                    resolvedData={manualReviewFlags['monthly_other_expense_total']}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })()}
                        {/* Net Income */}
                        <tr className="font-semibold bg-gray-50">
                          <td className="p-2 border">Net Income</td>
                          {ebitdaMonthlyAnalysis.monthlyEbitda.map((ebitda, i) => {
                            // Net Income = EBITDA - DIAT add-backs (since EBITDA = Net Income + DIAT)
                            // For monthly, we use raw EBITDA minus the DIAT component
                            const netIncome = ebitda - (ebitdaMonthlyAnalysis.monthlyDiatAddback?.[i] || 0);
                            return (
                              <td key={i} className={`p-1.5 border text-right ${netIncome < 0 ? 'bg-amber-100 text-amber-700' : ''}`}>
                                {netIncome < 0 ? `(${formatCurrency(Math.abs(netIncome))})` : formatCurrency(netIncome)}
                              </td>
                            );
                          })}
                          <td className="p-1.5 border text-right bg-gray-100 font-bold">
                            {(() => {
                              const totalDiat = (ebitdaMonthlyAnalysis.monthlyDiatAddback || []).reduce((a,b) => a+b, 0);
                              const totalEbitda = ebitdaMonthlyAnalysis.monthlyEbitda.reduce((a,b) => a+b, 0);
                              const totalNetIncome = totalEbitda - totalDiat;
                              return totalNetIncome < 0 ? `(${formatCurrencyExact(Math.abs(totalNetIncome))})` : formatCurrencyExact(totalNetIncome);
                            })()}
                          </td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes['monthly_net_income']}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_net_income': val}))}
                              hasVariance={false}
                              placeholder="Notes on net income..."
                              isFlagged={manualReviewFlags['monthly_net_income']?.flagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                'monthly_net_income': { 
                                  ...prev['monthly_net_income'], 
                                  flagged: !prev['monthly_net_income']?.flagged,
                                  created: prev['monthly_net_income']?.created || Date.now(),
                                  section: 'Income Statement - Monthly',
                                  item: 'Net Income'
                                }
                              }))}
                              noteKey="monthly_net_income"
                              resolvedData={manualReviewFlags['monthly_net_income']}
                            />
                          </td>
                        </tr>
                        {/* Raw EBITDA */}
                        <tr className="font-bold bg-green-100">
                          <td className="p-2 border">EBITDA (Unadjusted)</td>
                          {ebitdaMonthlyAnalysis.monthlyEbitda.map((v, i) => (
                            <td key={i} className={`p-1.5 border text-right ${v < 0 ? 'bg-amber-200 text-amber-800 font-bold' : ''}`}>
                              {v < 0 ? `(${formatCurrency(Math.abs(v))})` : formatCurrency(v)}
                            </td>
                          ))}
                          <td className="p-1.5 border text-right bg-green-200 font-bold">{formatCurrencyExact(ebitdaMonthlyAnalysis.monthlyEbitda.reduce((a,b) => a+b, 0))}</td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes['monthly_ebitda_unadjusted']}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_ebitda_unadjusted': val}))}
                              hasVariance={false}
                              placeholder="Notes on unadjusted EBITDA..."
                              isFlagged={manualReviewFlags['monthly_ebitda_unadjusted']?.flagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                'monthly_ebitda_unadjusted': { 
                                  ...prev['monthly_ebitda_unadjusted'], 
                                  flagged: !prev['monthly_ebitda_unadjusted']?.flagged,
                                  created: prev['monthly_ebitda_unadjusted']?.created || Date.now(),
                                  section: 'Income Statement - Monthly',
                                  item: 'EBITDA (Unadjusted)'
                                }
                              }))}
                              noteKey="monthly_ebitda_unadjusted"
                              resolvedData={manualReviewFlags['monthly_ebitda_unadjusted']}
                            />
                          </td>
                        </tr>
                        {/* Average Monthly Adjustment */}
                        <tr className="bg-green-50">
                          <td className="p-2 border text-gray-600">
                            {normalizedEbitdaMonthly.hasMonthSpecificAdj ? '+ Monthly Adjustments' : '+ Avg Monthly Adjustment'}
                            {normalizedEbitdaMonthly.hasMonthSpecificAdj && (
                              <span className="ml-1 text-purple-600 text-xs">(📌 month-specific)</span>
                            )}
                          </td>
                          {Array(12).fill(0).map((_, i) => {
                            // Use normalizedEbitdaMonthly for accurate per-month adjustments
                            const actualEbitda = ebitdaMonthlyAnalysis.monthlyEbitdaActual?.[i] || 0;
                            const normalizedEbitda = normalizedEbitdaMonthly.monthlyEbitda?.[i] || actualEbitda;
                            const monthAdj = normalizedEbitda - actualEbitda;
                            const spreadAdj = normalizedEbitdaMonthly.monthlyAdjustment || 0;
                            // Use tolerance for floating point comparison
                            const hasSpecificAdj = normalizedEbitdaMonthly.hasMonthSpecificAdj && Math.abs(monthAdj - spreadAdj) > 0.50;
                            return (
                              <td key={i} className={`p-1.5 border text-right ${hasSpecificAdj ? 'bg-purple-100 text-purple-700 font-medium' : 'text-green-600'}`} title={hasSpecificAdj ? `Month-specific adjustment: ${formatCurrency(monthAdj - spreadAdj)} applied` : ''}>
                                {monthAdj >= 0 ? '+' : ''}{formatCurrency(monthAdj)}
                              </td>
                            );
                          })}
                          <td className="p-1.5 border text-right bg-green-100 text-green-600">+{formatCurrencyExact(calculations.years[5].adjustedEbitda - calculations.years[5].ebitda)}</td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes['monthly_adj_total']}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_adj_total': val}))}
                              hasVariance={false}
                              placeholder="Notes on monthly adjustments..."
                              isFlagged={manualReviewFlags['monthly_adj_total']?.flagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                'monthly_adj_total': { 
                                  ...prev['monthly_adj_total'], 
                                  flagged: !prev['monthly_adj_total']?.flagged,
                                  created: prev['monthly_adj_total']?.created || Date.now(),
                                  section: 'Income Statement - Monthly',
                                  item: 'Monthly Adjustments'
                                }
                              }))}
                              noteKey="monthly_adj_total"
                              resolvedData={manualReviewFlags['monthly_adj_total']}
                            />
                          </td>
                        </tr>
                        {/* Normalized EBITDA */}
                        <tr className="font-bold bg-green-200">
                          <td className="p-2 border">Normalized EBITDA (Est.)</td>
                          {normalizedEbitdaMonthly.monthlyEbitda.map((normalized, i) => {
                            return (
                              <td key={i} className={`p-1.5 border text-right ${normalized < 0 ? 'bg-amber-200 text-amber-800' : ''}`}>
                                {normalized < 0 ? `(${formatCurrency(Math.abs(normalized))})` : formatCurrency(normalized)}
                              </td>
                            );
                          })}
                          <td className="p-1.5 border text-right bg-green-300 font-bold">{formatCurrencyExact(calculations.years[5].adjustedEbitda)}</td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes['monthly_normalized_ebitda']}
                              onChange={val => setMonthlyTtmNotes(prev => ({...prev, 'monthly_normalized_ebitda': val}))}
                              hasVariance={false}
                              placeholder="Notes on normalized EBITDA..."
                              isFlagged={manualReviewFlags['monthly_normalized_ebitda']?.flagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                'monthly_normalized_ebitda': { 
                                  ...prev['monthly_normalized_ebitda'], 
                                  flagged: !prev['monthly_normalized_ebitda']?.flagged,
                                  created: prev['monthly_normalized_ebitda']?.created || Date.now(),
                                  section: 'Income Statement - Monthly',
                                  item: 'Normalized EBITDA (Est.)'
                                }
                              }))}
                              noteKey="monthly_normalized_ebitda"
                              resolvedData={manualReviewFlags['monthly_normalized_ebitda']}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                    {/* Summary Stats */}
                    <div className="mt-4 grid grid-cols-4 gap-4">
                      <div className="p-3 bg-gray-50 rounded border">
                        <div className="text-xs text-gray-500">Negative EBITDA Months (Normalized)</div>
                        <div className={`text-xl font-bold ${normalizedEbitdaMonthly.negativeMonths > 0 ? 'text-red-600' : 'text-green-600'}`}>
                          {normalizedEbitdaMonthly.negativeMonths} / 12
                        </div>
                        {normalizedEbitdaMonthly.negativeMonths > 0 && (
                          <div className="text-xs text-red-500 mt-1">⚠️ Review for timing/one-time items</div>
                        )}
                        {ebitdaMonthlyAnalysis.negativeMonths !== normalizedEbitdaMonthly.negativeMonths && (
                          <div className="text-xs text-gray-400 mt-1">Actual: {ebitdaMonthlyAnalysis.negativeMonths}</div>
                        )}
                      </div>
                      <div className="p-3 bg-gray-50 rounded border">
                        <div className="text-xs text-gray-500">Revenue CV</div>
                        <div className="text-xl font-bold">{revenueAnalysis.monthlyCV.toFixed(1)}%</div>
                        <div className="text-xs text-gray-400">Lower = more stable</div>
                      </div>
                      <div className="p-3 bg-gray-50 rounded border">
                        <div className="text-xs text-gray-500">Months Below Avg Revenue</div>
                        <div className={`text-xl font-bold ${revenueAnalysis.monthsSignificantlyBelow >= 3 ? 'text-orange-600' : 'text-gray-700'}`}>
                          {revenueAnalysis.monthsSignificantlyBelow} significantly
                        </div>
                        <div className="text-xs text-gray-400">{`>`}15% below average</div>
                        <div className="text-xs text-blue-600 mt-1 font-medium">Avg: {formatCurrency(ebitdaMonthlyAnalysis.monthlyRevenue.reduce((a,b) => a+b, 0) / 12)}/mo</div>
                      </div>
                      <div className="p-3 bg-gray-50 rounded border">
                        <div className="text-xs text-gray-500">TTM Adjustment Spread</div>
                        <div className="text-xl font-bold text-blue-600">+{formatCurrency((calculations.years[5].adjustedEbitda - calculations.years[5].ebitda) / 12)}/mo</div>
                        <div className="text-xs text-gray-400">Estimate only - not month-specific</div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
          
          {/* Valuation EBITDA Selection */}
          <div className="mt-4 p-4 bg-gradient-to-r from-purple-50 to-orange-50 rounded-lg border border-purple-200">
            <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-purple-600" />
              Valuation EBITDA Selection
            </h3>
            
            <div className="grid grid-cols-2 gap-6">
              {/* Left: Basis & Method Selection */}
              <div>
                {/* Valuation Basis Selection */}
                <div className="mb-3">
                  <label className="block text-sm font-semibold mb-1">Valuation Basis</label>
                  <select 
                    value={selectedValuationBasis} 
                    onChange={e => setSelectedValuationBasis(e.target.value)}
                    className="w-full p-2 border rounded bg-white"
                  >
                    <option value="cash">Cash Basis</option>
                    <option value="accrual">Accrual Basis</option>
                    <option value="tax">Tax Return</option>
                  </select>
                  <div className="text-xs text-gray-500 mt-1">
                    Determines which P&L data flows to Income Statement and valuation
                  </div>
                </div>
                
                {/* Period/Method Selection */}
                <div className="mb-3">
                  <label className="block text-sm font-semibold mb-1">EBITDA Period</label>
                  <select 
                    value={valuationInputs.weightingMethod} 
                    onChange={e => setValuationInputs({...valuationInputs, weightingMethod: e.target.value})}
                    className="w-full p-2 border rounded bg-white"
                  >
                    <option value="ttm">TTM (Trailing 12 Months)</option>
                    <option value="lastYear">Last Calendar Year ({basisYearLabels.year5 || '2024'})</option>
                    <option value="average">Average of Selected Years</option>
                    <option value="weighted">Weighted Average</option>
                  </select>
                </div>
                
                {(valuationInputs.weightingMethod === 'average' || valuationInputs.weightingMethod === 'weighted') && (
                  <div className="bg-white p-3 rounded border">
                    <div className="text-sm font-semibold mb-2">Include Years & Weights</div>
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="border-b">
                          <th className="text-left p-1">Year</th>
                          <th className="text-right p-1">Adj. EBITDA</th>
                          <th className="text-center p-1">Include</th>
                          {valuationInputs.weightingMethod === 'weighted' && <th className="text-center p-1">Weight</th>}
                        </tr>
                      </thead>
                      <tbody>
                        <tr className={!valuationInputs.includeYear1 ? 'bg-gray-100 text-gray-400' : ''}>
                          <td className="p-1">{basisYearLabels.year3 || '2022'}</td>
                          <td className="p-1 text-right">{formatCurrency(calculations.ebitdaValues?.year3 || 0)}</td>
                          <td className="p-1 text-center">
                            <input type="checkbox" checked={valuationInputs.includeYear1} onChange={e => setValuationInputs({...valuationInputs, includeYear1: e.target.checked})} />
                          </td>
                          {valuationInputs.weightingMethod === 'weighted' && (
                            <td className="p-1 text-center">
                              <input type="number" min="0" max="10" step="1" value={valuationInputs.weightYear1} onChange={e => setValuationInputs({...valuationInputs, weightYear1: Number(e.target.value)})} className="w-12 p-1 border rounded text-center" disabled={!valuationInputs.includeYear1} />
                            </td>
                          )}
                        </tr>
                        <tr className={!valuationInputs.includeYear2 ? 'bg-gray-100 text-gray-400' : ''}>
                          <td className="p-1">{basisYearLabels.year4 || '2023'}</td>
                          <td className="p-1 text-right">{formatCurrency(calculations.ebitdaValues?.year4 || 0)}</td>
                          <td className="p-1 text-center">
                            <input type="checkbox" checked={valuationInputs.includeYear2} onChange={e => setValuationInputs({...valuationInputs, includeYear2: e.target.checked})} />
                          </td>
                          {valuationInputs.weightingMethod === 'weighted' && (
                            <td className="p-1 text-center">
                              <input type="number" min="0" max="10" step="1" value={valuationInputs.weightYear2} onChange={e => setValuationInputs({...valuationInputs, weightYear2: Number(e.target.value)})} className="w-12 p-1 border rounded text-center" disabled={!valuationInputs.includeYear2} />
                            </td>
                          )}
                        </tr>
                        <tr className={!valuationInputs.includeYear3 ? 'bg-gray-100 text-gray-400' : ''}>
                          <td className="p-1">{basisYearLabels.year5 || '2024'}</td>
                          <td className="p-1 text-right">{formatCurrency(calculations.ebitdaValues?.year5 || 0)}</td>
                          <td className="p-1 text-center">
                            <input type="checkbox" checked={valuationInputs.includeYear3} onChange={e => setValuationInputs({...valuationInputs, includeYear3: e.target.checked})} />
                          </td>
                          {valuationInputs.weightingMethod === 'weighted' && (
                            <td className="p-1 text-center">
                              <input type="number" min="0" max="10" step="1" value={valuationInputs.weightYear3} onChange={e => setValuationInputs({...valuationInputs, weightYear3: Number(e.target.value)})} className="w-12 p-1 border rounded text-center" disabled={!valuationInputs.includeYear3} />
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                    {valuationInputs.weightingMethod === 'weighted' && (
                      <div className="text-xs text-gray-500 mt-2">
                        Higher weight = more influence. Default: 1-2-3 (recent years weighted more)
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {/* Right: Result */}
              <div className="flex flex-col justify-center">
                <div className="bg-white p-4 rounded-lg border-2 border-purple-300 text-center">
                  <div className="text-sm text-gray-600 mb-1">Valuation EBITDA</div>
                  <div className="text-3xl font-bold text-purple-700">{formatCurrency(calculations.valuation.metric)}</div>
                  <div className="text-sm text-gray-500 mt-1">
                    {valuationInputs.weightingMethod === 'ttm' && 'Using TTM (most recent 12 months)'}
                    {valuationInputs.weightingMethod === 'lastYear' && `Using ${basisYearLabels.year5 || '2024'} calendar year`}
                    {valuationInputs.weightingMethod === 'average' && `Average of selected years`}
                    {valuationInputs.weightingMethod === 'weighted' && `Weighted average`}
                  </div>
                </div>
                
                <div className="mt-3 grid grid-cols-2 gap-2 text-center text-sm">
                  <div className="bg-gray-100 p-2 rounded">
                    <div className="text-gray-500">× Multiple</div>
                    <div className="font-semibold">{multipleEngineCalcs.typicalMultiple.toFixed(1)}x - {multipleEngineCalcs.marketHighMultiple.toFixed(1)}x</div>
                  </div>
                  <div className="bg-blue-100 p-2 rounded">
                    <div className="text-gray-500">= Valuation</div>
                    <div className="font-bold text-orange-700">{formatCurrency(multipleEngineCalcs.valuationTypical)} - {formatCurrency(multipleEngineCalcs.valuationMarketHigh)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Roll-Off Risk Analysis - Only show in Monthly view */}
          {incomeStmtViewMode === 'monthly' && rollOffAnalysis.hasData && (
            <div id="flags-detailed" className="mt-4 border rounded-lg overflow-hidden">
              <div 
                className="flex items-center justify-between px-4 py-3 bg-amber-100 cursor-pointer hover:bg-amber-200"
                onClick={() => setRollOffExpanded(!rollOffExpanded)}
              >
                <h4 className="font-semibold text-amber-800 flex items-center gap-2">
                  <span>{rollOffExpanded ? '▼' : '▶'}</span>
                  ⚠️ Roll-Off Risk Analysis
                  {rollOffAnalysis.nearTermAtRisk.length > 0 && (
                    <span className="ml-2 px-2 py-0.5 bg-red-500 text-white text-xs rounded-full">
                      {rollOffAnalysis.nearTermAtRisk.length} high month{rollOffAnalysis.nearTermAtRisk.length > 1 ? 's' : ''} at risk
                    </span>
                  )}
                </h4>
                <div className="text-sm text-amber-700">
                  Current TTM EBITDA: <span className="font-bold">{formatCurrency(rollOffAnalysis.currentTtmEbitda)}</span>
                </div>
              </div>
              
              {rollOffExpanded && (
                <div className="p-4 bg-amber-50">
                  {/* Explanation */}
                  <div className="mb-4 p-3 bg-white rounded border border-amber-200 text-sm text-gray-700">
                    <strong>Why this matters:</strong> Each month, the oldest month "rolls off" the TTM and is replaced by the new month. 
                    If a high-performing month rolls off and is replaced by an average month, TTM EBITDA—and valuation—will drop. 
                    This analysis helps identify that risk and plan listing timing.
                  </div>
                  
                  {/* Month-Specific Adjustment Indicator */}
                  {normalizedEbitdaMonthly.hasMonthSpecificAdj && (
                    <div className="mb-4 p-2 bg-purple-50 rounded border border-purple-200 text-sm text-purple-800 flex items-center gap-2">
                      <span className="text-lg">📌</span>
                      <span><strong>Month-Specific Adjustments Active:</strong> Some adjustments are applied to specific months rather than spread evenly. This provides more accurate normalized EBITDA by month.</span>
                    </div>
                  )}
                  
                  {/* Monthly EBITDA Chart with Roll-Off Timeline */}
                  <div className="mb-4">
                    <h5 className="font-semibold text-gray-700 mb-2">Monthly EBITDA & Roll-Off Timeline</h5>
                    <div className="bg-white p-3 rounded border">
                      <div className="flex items-end gap-1 h-32">
                        {rollOffAnalysis.atRiskMonths.map((m, idx) => {
                          const maxVal = Math.max(...rollOffAnalysis.monthlyEbitda.map(Math.abs));
                          const height = maxVal > 0 ? Math.abs(m.ebitda) / maxVal * 100 : 0;
                          const isNegative = m.ebitda < 0;
                          return (
                            <div key={idx} className="flex-1 flex flex-col items-center">
                              <div className="w-full flex flex-col items-center justify-end h-24">
                                <div 
                                  className={`w-full rounded-t transition-all ${
                                    m.isHighRisk ? 'bg-red-400 ring-2 ring-red-600' : 
                                    m.isLowRisk ? 'bg-blue-300' : 
                                    isNegative ? 'bg-red-300' : 'bg-green-400'
                                  }`}
                                  style={{ height: `${height}%`, minHeight: m.ebitda !== 0 ? '4px' : '0' }}
                                  title={`${m.monthLabel}: ${formatCurrency(m.ebitda)} (${m.variance > 0 ? '+' : ''}${m.variance.toFixed(0)}% vs avg)`}
                                ></div>
                              </div>
                              <div className="text-xs text-gray-500 mt-1">{m.monthLabel.substring(0, 3)}</div>
                              <div className={`text-xs font-medium ${m.isHighRisk ? 'text-red-600' : m.isLowRisk ? 'text-blue-600' : 'text-gray-600'}`}>
                                {formatCurrency(m.ebitda)}
                              </div>
                              <div className="text-xs text-gray-400">
                                {idx < 4 ? `↻ ${m.monthsUntilRollOff}mo` : ''}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="mt-2 pt-2 border-t flex items-center gap-4 text-xs">
                        <div className="flex items-center gap-1"><div className="w-3 h-3 bg-red-400 ring-1 ring-red-600 rounded"></div> High Risk (&gt;25% above avg)</div>
                        <div className="flex items-center gap-1"><div className="w-3 h-3 bg-green-400 rounded"></div> Normal</div>
                        <div className="flex items-center gap-1"><div className="w-3 h-3 bg-blue-300 rounded"></div> Below Avg (&gt;25% below)</div>
                        <div className="ml-auto text-gray-500">Avg: {formatCurrency(rollOffAnalysis.monthlyAvg)}/mo</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* At-Risk Summary */}
                  {rollOffAnalysis.nearTermAtRisk.length > 0 && (
                    <div className="mb-4 p-3 bg-red-50 rounded-lg border border-red-200">
                      <h5 className="font-semibold text-red-800 mb-2">⚠️ High Months Rolling Off Soon</h5>
                      <div className="grid grid-cols-2 gap-2 text-sm">
                        {rollOffAnalysis.nearTermAtRisk.map((m, idx) => (
                          <div key={idx} className="flex justify-between bg-white p-2 rounded border border-red-100">
                            <span className="text-red-700">{m.monthLabel} (in {m.monthsUntilRollOff}mo)</span>
                            <span className="font-semibold text-red-800">{formatCurrency(m.ebitda)} <span className="text-xs text-red-500">(+{m.variance.toFixed(0)}%)</span></span>
                          </div>
                        ))}
                      </div>
                      <div className="mt-2 pt-2 border-t border-red-200 text-sm">
                        <span className="text-red-700">Total At-Risk EBITDA:</span>
                        <span className="font-bold text-red-800 ml-2">{formatCurrency(rollOffAnalysis.totalAtRiskEbitda)}</span>
                        <span className="text-red-600 ml-2">→ Valuation at risk: {formatCurrency(rollOffAnalysis.totalAtRiskValuation)}</span>
                      </div>
                    </div>
                  )}
                  
                  {/* Acknowledge/Resolve Section */}
                  <div className={`mb-4 p-3 rounded-lg border ${rollOffAcknowledged.reviewed ? 'bg-green-50 border-green-300' : 'bg-white border-gray-300'}`}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <input 
                          type="checkbox" 
                          checked={rollOffAcknowledged.reviewed || false}
                          onChange={e => setRollOffAcknowledged({
                            ...rollOffAcknowledged, 
                            reviewed: e.target.checked, 
                            reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''
                          })}
                          className="w-4 h-4"
                        />
                        <span className={`font-medium ${rollOffAcknowledged.reviewed ? 'text-green-700' : 'text-gray-700'}`}>
                          Roll-Off Risk Reviewed
                        </span>
                        {rollOffAcknowledged.reviewed && (
                          <span className="text-green-600 text-xs">✓ Reviewed {rollOffAcknowledged.reviewDate}</span>
                        )}
                      </div>
                      <span className="text-xs text-gray-500">Check to clear from Open Items</span>
                    </div>
                    <div className="mt-2">
                      <input 
                        type="text" 
                        value={rollOffAcknowledged.notes || ''}
                        onChange={e => setRollOffAcknowledged({...rollOffAcknowledged, notes: e.target.value})}
                        placeholder="Notes on listing timing decision, risk mitigation..."
                        className="w-full px-2 py-1 border rounded text-xs"
                      />
                    </div>
                  </div>
                  
                  {/* Forward TTM Projection */}
                  <div className="mb-4">
                    <h5 className="font-semibold text-gray-700 mb-2">Forward TTM Projection (Next 4 Months)</h5>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm border-collapse bg-white rounded">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="p-2 border text-left">Scenario</th>
                            <th className="p-2 border text-center">Month Rolling Off</th>
                            <th className="p-2 border text-right">Rolling Off EBITDA</th>
                            <th className="p-2 border text-right">Replacement (Projected)</th>
                            <th className="p-2 border text-right">New TTM EBITDA</th>
                            <th className="p-2 border text-right">Change</th>
                            <th className="p-2 border text-right">Valuation Impact</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="bg-green-50 font-semibold">
                            <td className="p-2 border">Current</td>
                            <td className="p-2 border text-center">—</td>
                            <td className="p-2 border text-right">—</td>
                            <td className="p-2 border text-right">—</td>
                            <td className="p-2 border text-right">{formatCurrency(rollOffAnalysis.currentTtmEbitda)}</td>
                            <td className="p-2 border text-right">—</td>
                            <td className="p-2 border text-right">{formatCurrency(rollOffAnalysis.currentValuation)}</td>
                          </tr>
                          {rollOffAnalysis.projections.map((p, idx) => (
                            <tr key={idx} className={p.change < 0 ? 'bg-red-50' : p.change > 0 ? 'bg-green-50' : ''}>
                              <td className="p-2 border">+{p.monthsOut} month{p.monthsOut > 1 ? 's' : ''}</td>
                              <td className="p-2 border text-center">{p.rollingOffMonth}</td>
                              <td className="p-2 border text-right">{formatCurrency(p.rollingOffEbitda)}</td>
                              <td className="p-2 border text-right">
                                <input 
                                  type="text"
                                  value={rollOffProjectedMonths[idx] !== null ? rollOffProjectedMonths[idx].toLocaleString() : ''}
                                  onChange={e => {
                                    const val = parseFloat(e.target.value.replace(/[^0-9.-]/g, ''));
                                    const newProjected = [...rollOffProjectedMonths];
                                    newProjected[idx] = isNaN(val) ? null : val;
                                    setRollOffProjectedMonths(newProjected);
                                  }}
                                  placeholder={formatCurrency(rollOffAnalysis.monthlyAvg)}
                                  className="w-24 px-1 py-0.5 border rounded text-right text-xs"
                                  title="Enter expected EBITDA for the replacement month, or leave blank to use average"
                                />
                                {p.usingAverage && <span className="text-xs text-gray-400 ml-1">(avg)</span>}
                              </td>
                              <td className="p-2 border text-right font-semibold">{formatCurrency(p.newTtm)}</td>
                              <td className={`p-2 border text-right ${p.change < 0 ? 'text-red-600' : p.change > 0 ? 'text-green-600' : ''}`}>
                                {p.change >= 0 ? '+' : ''}{formatCurrency(p.change)} ({p.changePct >= 0 ? '+' : ''}{p.changePct.toFixed(1)}%)
                              </td>
                              <td className={`p-2 border text-right font-semibold ${p.valuationChange < 0 ? 'text-red-600' : p.valuationChange > 0 ? 'text-green-600' : ''}`}>
                                {formatCurrency(p.projectedValuation)}
                                <div className="text-xs">{p.valuationChange >= 0 ? '+' : ''}{formatCurrency(p.valuationChange)}</div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-2 text-xs text-gray-500">
                      💡 Enter expected EBITDA for upcoming months, or leave blank to assume average ({formatCurrency(rollOffAnalysis.monthlyAvg)}/mo). 
                      Multiple used: {rollOffAnalysis.multiple.toFixed(2)}x
                    </div>
                  </div>
                  
                  {/* Recommendations */}
                  <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <h5 className="font-semibold text-blue-800 mb-2">📋 Listing Timing Considerations</h5>
                    <ul className="text-sm text-blue-700 space-y-1">
                      {rollOffAnalysis.nearTermAtRisk.length > 0 && (
                        <li>• <strong>Warning:</strong> High-performing month(s) will roll off soon. If not replaced with equally strong months, valuation will drop.</li>
                      )}
                      {rollOffAnalysis.projections[3]?.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9 && (
                        <li>• <strong>Action:</strong> Consider listing sooner rather than later if projections show declining TTM EBITDA.</li>
                      )}
                      {rollOffAnalysis.projections[3]?.newTtm > rollOffAnalysis.currentTtmEbitda * 1.1 && (
                        <li>• <strong>Opportunity:</strong> Projections show improving TTM EBITDA—waiting may increase valuation.</li>
                      )}
                      <li>• Review these projections monthly as new P&L data comes in to reassess timing.</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          )}
          </>
        ) : viewMode === 'accrualpl' || viewMode === 'cashpl' || viewMode === 'taxreturns' ? (
          /* ========== P&L DATA ENTRY TABS (Accrual, Cash, Tax) ========== */
          (() => {
            const basisKey = viewMode === 'accrualpl' ? 'accrual' : viewMode === 'cashpl' ? 'cash' : 'tax';
            const basisLabel = viewMode === 'accrualpl' ? 'Accrual' : viewMode === 'cashpl' ? 'Cash' : 'Tax Return';
            const isValuationBasis = selectedValuationBasis === basisKey;
            
            // Static Tailwind class lookups for each basis
            const basisClasses = {
              accrual: {
                btn: 'bg-blue-600 hover:bg-blue-700',
                box: 'bg-blue-50 border-blue-200',
                header: 'bg-blue-100',
                headerTtm: 'bg-blue-200'
              },
              cash: {
                btn: 'bg-slate-600 hover:bg-slate-700',
                box: 'bg-slate-50 border-slate-200',
                header: 'bg-slate-100',
                headerTtm: 'bg-slate-200'
              },
              tax: {
                btn: 'bg-amber-600 hover:bg-amber-700',
                box: 'bg-amber-50 border-amber-200',
                header: 'bg-amber-100',
                headerTtm: 'bg-amber-200'
              }
            };
            const cls = basisClasses[basisKey];
            
            // Year columns to show - Tax Returns only has 3 years, no TTM
            const isTaxReturns = viewMode === 'taxreturns';
            const yearCols = isTaxReturns 
              ? ['year3', 'year4', 'year5']
              : showAllYears 
                ? ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm']
                : ['year3', 'year4', 'year5', 'ttm'];
            
            const yearHeaders = {
              year1: basisYearLabels.year1 || 'Year 1',
              year2: basisYearLabels.year2 || 'Year 2', 
              year3: basisYearLabels.year3 || 'Year 3',
              year4: basisYearLabels.year4 || 'Year 4',
              year5: basisYearLabels.year5 || 'Year 5',
              ttm: ttmLabel || 'TTM'
            };
            
            // Helper to format currency for display
            const fmtVal = (val) => {
              if (val === 0 || val === null || val === undefined) return '';
              return val.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            };
            
            // Helper to parse input value
            const parseVal = (str) => {
              if (!str || str.trim() === '') return 0;
              return parseFloat(str.replace(/[,$]/g, '')) || 0;
            };
            
            // Calculate section totals
            const calcTotal = (categories, yearKey) => {
              return categories.reduce((sum, cat) => sum + (cat[basisKey]?.[yearKey] || 0), 0);
            };
            
            // Render a section (Revenue, COGS, etc.)
            const renderSection = (title, categories, setCategories, bgColor, canAddRow = true) => {
              const total = {};
              yearCols.forEach(yr => { total[yr] = calcTotal(categories, yr); });
              
              // Determine if this is an expense category that needs addback fields
              const isExpenseCategory = title === 'Operating Expenses' || title === 'Other Expense';
              
              return (
                <div className="mb-4">
                  <div className={`flex items-center justify-between px-3 py-2 ${bgColor} rounded-t-lg`}>
                    <span className="font-semibold text-sm">{title}</span>
                    {canAddRow && (
                      <button
                        onClick={() => setCategories(prev => [...prev, { 
                          id: Date.now(), 
                          name: '', 
                          ...(isExpenseCategory && { addbackPct: 0, adjCategory: '', adjDescription: '', adjVerSource: '', adjDocRef: '', adjIncluded: true }),
                          cash: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
                          accrual: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 },
                          tax: { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 }
                        }])}
                        className="text-xs px-2 py-0.5 bg-white/50 hover:bg-white/80 rounded"
                      >
                        + Add Row
                      </button>
                    )}
                  </div>
                  <table className="w-full text-sm border-collapse">
                    <tbody>
                      {categories.map((cat, idx) => (
                        <tr key={cat.id || idx} className="border-b border-gray-200 hover:bg-gray-50">
                          <td className="py-1 px-2 w-64">
                            <input
                              type="text"
                              value={cat.name || ''}
                              onChange={e => {
                                const newName = e.target.value;
                                setCategories(prev => prev.map((c, i) => i === idx ? { ...c, name: newName } : c));
                              }}
                              className="w-full px-2 py-1 border-0 bg-transparent focus:bg-white focus:ring-1 focus:ring-blue-400"
                              placeholder="Line item name..."
                            />
                          </td>
                          {yearCols.map(yr => (
                            <td key={yr} className="py-1 px-1 w-28">
                              <input
                                type="text"
                                value={fmtVal(cat[basisKey]?.[yr] || 0)}
                                onChange={e => {
                                  const val = parseVal(e.target.value);
                                  setCategories(prev => prev.map((c, i) => i === idx ? {
                                    ...c,
                                    [basisKey]: { ...(c[basisKey] || {}), [yr]: val }
                                  } : c));
                                }}
                                onFocus={e => e.target.select()}
                                className="w-full px-2 py-1 text-right border-0 bg-transparent focus:bg-white focus:ring-1 focus:ring-blue-400"
                                placeholder="-"
                              />
                            </td>
                          ))}
                          <td className="py-1 px-1 w-10">
                            <button
                              onClick={() => setCategories(prev => prev.filter((_, i) => i !== idx))}
                              className="text-red-400 hover:text-red-600 text-xs"
                              title="Delete row"
                            >
                              ✕
                            </button>
                          </td>
                        </tr>
                      ))}
                      {/* Total Row */}
                      <tr className={`${bgColor} font-semibold`}>
                        <td className="py-2 px-2 w-64">Total {title}</td>
                        {yearCols.map(yr => (
                          <td key={yr} className="py-2 px-1 text-right w-28">{formatCurrency(total[yr])}</td>
                        ))}
                        <td className="w-10"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            };
            
            // Calculate Gross Profit - use taxReturnTotals for tax returns
            const grossProfit = {};
            yearCols.forEach(yr => {
              if (isTaxReturns) {
                grossProfit[yr] = (taxReturnTotals.revenue[yr] || 0) - (taxReturnTotals.cogs[yr] || 0);
              } else {
                grossProfit[yr] = calcTotal(revenueCategories, yr) - calcTotal(cogsCategories, yr);
              }
            });
            
            // Calculate Net Income - use taxReturnTotals for tax returns Revenue/COGS/Expenses
            const netIncome = {};
            yearCols.forEach(yr => {
              const rev = isTaxReturns ? (taxReturnTotals.revenue[yr] || 0) : calcTotal(revenueCategories, yr);
              const cogs = isTaxReturns ? (taxReturnTotals.cogs[yr] || 0) : calcTotal(cogsCategories, yr);
              const opex = isTaxReturns ? (taxReturnTotals.expenses?.[yr] || 0) : calcTotal(opexCategories, yr);
              const oi = calcTotal(otherIncomeCategories, yr);
              const oe = calcTotal(otherExpenseCategories, yr);
              // For P&L: subtract DIAT if entered separately (tax returns already include in Total Deductions)
              const diat = isTaxReturns ? 0 : ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                sum + (diatCategories?.[key]?.[basisKey]?.[yr] || 0), 0);
              netIncome[yr] = rev - cogs - opex - diat + oi - oe;
            });
            
            return (
              <div>
                {/* Header */}
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <h2 className="text-lg font-bold">{basisLabel} P&L Entry</h2>
                    {isValuationBasis ? (
                      <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-full">
                        ✓ Using for Valuation
                      </span>
                    ) : (
                      <button
                        onClick={() => setSelectedValuationBasis(basisKey)}
                        className="px-2 py-1 bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-700 text-xs rounded-full border"
                      >
                        Use for Valuation
                      </button>
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    {/* P&L TTM Sync Status Chip — only when sync mode is on and we're on a basis tab (not tax returns) */}
                    {!isTaxReturns && pnlTtmReconciliation.active && (
                      pnlTtmReconciliation.inSync ? (
                        <span
                          className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 border border-green-300 rounded text-xs font-medium"
                          title="P&L Entry TTM column matches TTM Monthly tab for both cash and accrual"
                        >
                          ✓ TTM in sync with TTM Monthly
                        </span>
                      ) : (
                        <button
                          onClick={() => setShowPnlReconModal(true)}
                          className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-800 border border-red-400 rounded text-xs font-semibold hover:bg-red-200"
                          title="Click to see which line items don't reconcile"
                        >
                          ⚠ TTM out of sync — {pnlTtmReconciliation.totalIssues} issue{pnlTtmReconciliation.totalIssues === 1 ? '' : 's'}
                          {pnlTtmReconciliation.cashIssues > 0 && pnlTtmReconciliation.accrualIssues > 0
                            ? ` (${pnlTtmReconciliation.cashIssues} cash, ${pnlTtmReconciliation.accrualIssues} accrual)`
                            : pnlTtmReconciliation.cashIssues > 0 ? ' (cash)' : ' (accrual)'}
                        </button>
                      )
                    )}
                    {!isTaxReturns && (
                      <label className="flex items-center gap-1 text-sm">
                        <input type="checkbox" checked={showAllYears} onChange={e => setShowAllYears(e.target.checked)} />
                        Show All 5 Years
                      </label>
                    )}
                    {!isTaxReturns && (
                      <button
                        onClick={() => {
                          setFullPLPasteBasis(basisKey);
                          setFullPLPasteData('');
                          setFullPLPastePreview(null);
                          setShowFullPLPasteModal(true);
                        }}
                        className={`px-3 py-1.5 ${cls.btn} text-white text-sm rounded font-medium`}
                      >
                        📋 Paste Full P&L
                      </button>
                    )}
                    <button onClick={() => setViewMode('detailed')} className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300">
                      View Analysis →
                    </button>
                  </div>
                </div>
                
                {/* Document Tracker */}
                {renderDocTracker(viewMode)}
                
                {/* Settings Row */}
                <div className="mb-3 p-3 bg-gray-100 rounded-lg">
                  <div className="flex flex-wrap gap-4 items-center">
                    {/* Tax Filing Basis - only for tax returns */}
                    {isTaxReturns && (
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">Filing Basis:</span>
                        <select 
                          value={taxFilingBasis} 
                          onChange={e => setTaxFilingBasis(e.target.value)}
                          className="p-1 border rounded text-sm bg-white font-medium"
                        >
                          <option value="cash">Cash</option>
                          <option value="accrual">Accrual</option>
                        </select>
                        <span className="text-xs text-gray-500">(Compare to {taxFilingBasis === 'cash' ? 'Cash' : 'Accrual'} P&L)</span>
                      </div>
                    )}
                    
                    {/* Year Labels */}
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-700">Year Labels:</span>
                      {isTaxReturns ? (
                        <>
                          <input type="text" value={basisYearLabels.year3} onChange={e => setBasisYearLabels({...basisYearLabels, year3: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y3" />
                          <input type="text" value={basisYearLabels.year4} onChange={e => setBasisYearLabels({...basisYearLabels, year4: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y4" />
                          <input type="text" value={basisYearLabels.year5} onChange={e => setBasisYearLabels({...basisYearLabels, year5: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y5" />
                        </>
                      ) : (
                        <>
                          {showAllYears && (
                            <>
                              <input type="text" value={basisYearLabels.year1} onChange={e => setBasisYearLabels({...basisYearLabels, year1: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y1" />
                              <input type="text" value={basisYearLabels.year2} onChange={e => setBasisYearLabels({...basisYearLabels, year2: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y2" />
                            </>
                          )}
                          <input type="text" value={basisYearLabels.year3} onChange={e => setBasisYearLabels({...basisYearLabels, year3: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y3" />
                          <input type="text" value={basisYearLabels.year4} onChange={e => setBasisYearLabels({...basisYearLabels, year4: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y4" />
                          <input type="text" value={basisYearLabels.year5} onChange={e => setBasisYearLabels({...basisYearLabels, year5: e.target.value})} className="w-14 p-1 border rounded text-xs text-center" placeholder="Y5" />
                          <span className="text-xs text-gray-500 ml-1">TTM: auto</span>
                        </>
                      )}
                    </div>
                    
                    {/* Roll Forward - not for tax returns */}
                    {!isTaxReturns && (
                      <button onClick={rollForward} className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 font-medium">
                        ↻ Roll Forward
                      </button>
                    )}
                    
                    {/* Show All Years - not for tax returns */}
                    {!isTaxReturns && (
                      <label className="flex items-center gap-1 text-sm">
                        <input type="checkbox" checked={showAllYears} onChange={e => setShowAllYears(e.target.checked)} />
                        Show All 5 Years
                      </label>
                    )}
                  </div>
                  
                  {/* Quick tip */}
                  <div className="mt-2 text-xs text-gray-500">
                    {isTaxReturns ? (
                      <><strong>Tip:</strong> Enter totals from tax returns. Revenue and COGS are single totals. Expense detail helps with reconciliation.</>
                    ) : (
                      <><strong>Tip:</strong> Click "Paste Full P&L" to import an entire P&L from Excel/QuickBooks. Subtotals auto-detected and skipped.</>
                    )}
                  </div>
                </div>
                
                {/* Column Headers */}
                <div className="mb-2">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className={cls.header}>
                        <th className="py-2 px-2 text-left w-64 font-semibold">Line Item</th>
                        {yearCols.map(yr => (
                          <th key={yr} className={`py-2 px-1 text-right w-28 font-semibold ${yr === 'ttm' ? cls.headerTtm : ''}`}>
                            {yearHeaders[yr]}
                          </th>
                        ))}
                        <th className="w-10"></th>
                      </tr>
                    </thead>
                  </table>
                </div>
                
                {/* Revenue Section */}
                {isTaxReturns ? (
                  /* Tax Returns: Simple Revenue Total */
                  <div className="mb-4">
                    <div className="flex items-center justify-between px-3 py-2 bg-green-100 rounded-t-lg">
                      <span className="font-semibold text-sm">Revenue (Total)</span>
                    </div>
                    <table className="w-full text-sm border-collapse">
                      <tbody>
                        <tr className="border-b border-gray-200 bg-green-50">
                          <td className="py-2 px-3 w-64 font-medium">Total Revenue</td>
                          {yearCols.map(yr => (
                            <td key={yr} className="py-1 px-1 w-28">
                              <input
                                type="text"
                                value={fmtVal(taxReturnTotals.revenue[yr] || 0)}
                                onChange={e => setTaxReturnTotals(prev => ({
                                  ...prev,
                                  revenue: { ...prev.revenue, [yr]: parseVal(e.target.value) }
                                }))}
                                onFocus={e => e.target.select()}
                                className="w-full px-2 py-1 text-right border rounded focus:ring-1 focus:ring-green-400"
                                placeholder="-"
                              />
                            </td>
                          ))}
                          <td className="w-10"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  renderSection('Revenue', revenueCategories, setRevenueCategories, 'bg-green-100')
                )}
                
                {/* COGS Section */}
                {isTaxReturns ? (
                  /* Tax Returns: Simple COGS Total */
                  <div className="mb-4">
                    <div className="flex items-center justify-between px-3 py-2 bg-orange-100 rounded-t-lg">
                      <span className="font-semibold text-sm">Cost of Goods Sold (Total)</span>
                    </div>
                    <table className="w-full text-sm border-collapse">
                      <tbody>
                        <tr className="border-b border-gray-200 bg-orange-50">
                          <td className="py-2 px-3 w-64 font-medium">Total COGS</td>
                          {yearCols.map(yr => (
                            <td key={yr} className="py-1 px-1 w-28">
                              <input
                                type="text"
                                value={fmtVal(taxReturnTotals.cogs[yr] || 0)}
                                onChange={e => setTaxReturnTotals(prev => ({
                                  ...prev,
                                  cogs: { ...prev.cogs, [yr]: parseVal(e.target.value) }
                                }))}
                                onFocus={e => e.target.select()}
                                className="w-full px-2 py-1 text-right border rounded focus:ring-1 focus:ring-orange-400"
                                placeholder="-"
                              />
                            </td>
                          ))}
                          <td className="w-10"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  renderSection('Cost of Goods Sold', cogsCategories, setCogsCategories, 'bg-orange-100')
                )}
                
                {/* Gross Profit Row */}
                <div className="mb-4 bg-green-200 rounded-lg">
                  <table className="w-full text-sm">
                    <tbody>
                      <tr className="font-bold text-green-900">
                        <td className="py-2 px-3 w-64">Gross Profit</td>
                        {yearCols.map(yr => (
                          <td key={yr} className={`py-2 px-1 text-right w-28 ${yr === 'ttm' ? 'bg-green-300' : ''}`}>
                            {formatCurrency(grossProfit[yr])}
                          </td>
                        ))}
                        <td className="w-10"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                {/* Operating Expenses Section */}
                {isTaxReturns ? (
                  /* Tax Returns: Simple OpEx Total */
                  <div className="mb-4">
                    <div className="flex items-center justify-between px-3 py-2 bg-red-100 rounded-t-lg">
                      <span className="font-semibold text-sm">Total Deductions / Operating Expenses</span>
                    </div>
                    <table className="w-full text-sm border-collapse">
                      <tbody>
                        <tr className="border-b border-gray-200 bg-red-50">
                          <td className="py-2 px-3 w-64 font-medium">Total Operating Expenses</td>
                          {yearCols.map(yr => (
                            <td key={yr} className="py-1 px-1 w-28">
                              <input
                                type="text"
                                value={fmtVal(taxReturnTotals.expenses?.[yr] || 0)}
                                onChange={e => setTaxReturnTotals(prev => ({
                                  ...prev,
                                  expenses: { ...(prev.expenses || {}), [yr]: parseVal(e.target.value) }
                                }))}
                                onFocus={e => e.target.select()}
                                className="w-full px-2 py-1 text-right border rounded focus:ring-1 focus:ring-red-400"
                                placeholder="-"
                              />
                            </td>
                          ))}
                          <td className="w-10"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  renderSection('Operating Expenses', opexCategories, setOpexCategories, 'bg-red-100')
                )}
                
                {/* Other Income Section */}
                {isTaxReturns && (
                  <div className="mb-2 p-3 bg-blue-50 border border-blue-200 rounded-lg text-xs">
                    <div className="font-semibold text-blue-800 mb-1">📋 Other Income — What belongs here?</div>
                    <div className="text-blue-700">
                      Enter income items from the tax return that are <strong>not included in Gross Receipts/Revenue</strong> above. Common examples:
                      <ul className="mt-1 ml-4 list-disc space-y-0.5">
                        <li>Interest income</li>
                        <li>Dividend income</li>
                        <li>Gain on sale of assets</li>
                        <li>Rental income (if not primary business)</li>
                        <li>Refunds, rebates, or recoveries</li>
                      </ul>
                      <div className="mt-1 text-blue-600 italic">Note: Pre-populated items come from your P&L "Other Income" section for easy comparison.</div>
                    </div>
                  </div>
                )}
                {renderSection('Other Income', otherIncomeCategories, setOtherIncomeCategories, 'bg-blue-100')}
                
                {/* Other Expense Section - Only show for Cash/Accrual P&L, not Tax Returns */}
                {/* Tax returns capture all expenses in Operating Expenses/Deductions - no separate "Other Expense" section */}
                {!isTaxReturns && (
                  <>
                    {renderSection('Other Expense', otherExpenseCategories, setOtherExpenseCategories, 'bg-purple-100')}
                  </>
                )}
                
                {/* Net Income Row */}
                <div className="mb-4 bg-gray-800 rounded-lg text-white">
                  <table className="w-full text-sm">
                    <tbody>
                      <tr className="font-bold">
                        <td className="py-3 px-3 w-64">Net Income</td>
                        {yearCols.map(yr => (
                          <td key={yr} className={`py-3 px-1 text-right w-28 ${yr === 'ttm' ? 'bg-gray-900' : ''}`}>
                            {formatCurrency(netIncome[yr])}
                          </td>
                        ))}
                        <td className="w-10"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                {/* Verification Summary */}
                {!isTaxReturns ? (
                  <div className="mt-4 p-3 bg-gray-100 rounded-lg text-sm">
                    <div className="font-semibold mb-2">Quick Verification (TTM)</div>
                    <div className="grid grid-cols-6 gap-3 text-xs">
                      <div>Revenue: <span className="font-mono">{formatCurrency(calcTotal(revenueCategories, 'ttm'))}</span></div>
                      <div>COGS: <span className="font-mono">{formatCurrency(calcTotal(cogsCategories, 'ttm'))}</span></div>
                      <div>OpEx: <span className="font-mono">{formatCurrency(calcTotal(opexCategories, 'ttm'))}</span></div>
                      <div>Other Inc: <span className="font-mono">{formatCurrency(calcTotal(otherIncomeCategories, 'ttm'))}</span></div>
                      <div>Other Exp: <span className="font-mono">{formatCurrency(calcTotal(otherExpenseCategories, 'ttm'))}</span></div>
                      <div>Net Inc: <span className="font-mono font-semibold">{formatCurrency(netIncome['ttm'])}</span></div>
                    </div>
                  </div>
                ) : (
                  <div className="mt-4 p-3 bg-amber-50 rounded-lg text-sm border border-amber-200">
                    <div className="font-semibold mb-2 text-amber-800">Quick Verification ({yearHeaders.year5 || 'Year 5'})</div>
                    <div className="grid grid-cols-5 gap-3 text-xs">
                      <div>Revenue: <span className="font-mono">{formatCurrency(taxReturnTotals.revenue.year5 || 0)}</span></div>
                      <div>COGS: <span className="font-mono">{formatCurrency(taxReturnTotals.cogs.year5 || 0)}</span></div>
                      <div>OpEx: <span className="font-mono">{formatCurrency(taxReturnTotals.expenses?.year5 || 0)}</span></div>
                      <div>Other Inc: <span className="font-mono">{formatCurrency(calcTotal(otherIncomeCategories, 'year5'))}</span></div>
                      <div>Net Inc: <span className="font-mono font-semibold">{formatCurrency(netIncome['year5'])}</span></div>
                    </div>
                  </div>
                )}

                {/* P&L TTM Reconciliation Detail Modal */}
                {showPnlReconModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowPnlReconModal(false)}>
                    <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                      <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-bold">⚠ P&L TTM Sync Reconciliation</h3>
                        <button onClick={() => setShowPnlReconModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                      </div>
                      <div className="mb-3 text-xs text-gray-600">
                        These line items have a P&L Entry TTM value that doesn't match the sum of their 12 months on the TTM Monthly tab. Investigate by re-pasting the missing data on the TTM Monthly tab, or by removing the stale value on the P&L Entry tab.
                      </div>
                      <div className="mb-4 grid grid-cols-3 gap-3 text-sm">
                        <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Total issues</div><div className="font-bold">{pnlTtmReconciliation.totalIssues}</div></div>
                        <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Cash basis</div><div className="font-bold">{pnlTtmReconciliation.cashIssues}</div></div>
                        <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Accrual basis</div><div className="font-bold">{pnlTtmReconciliation.accrualIssues}</div></div>
                      </div>
                      <div className="overflow-auto max-h-[55vh] border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0">
                            <tr>
                              <th className="p-1.5 text-left">Section</th>
                              <th className="p-1.5 text-left">Line Item</th>
                              <th className="p-1.5 text-center">Basis</th>
                              <th className="p-1.5 text-left">Issue</th>
                              <th className="p-1.5 text-right">P&L Entry TTM</th>
                              <th className="p-1.5 text-right">Monthly Sum</th>
                              <th className="p-1.5 text-right">Diff</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pnlTtmReconciliation.issues.slice().sort((a,b) => Math.abs(b.diff) - Math.abs(a.diff)).map((iss, i) => {
                              const issueLabel = iss.type === 'no_monthly' ? 'No monthly data' : 'Mismatch';
                              return (
                                <tr key={i} className="border-t">
                                  <td className="p-1.5 text-gray-600">{iss.section}</td>
                                  <td className="p-1.5 font-medium">{iss.name}</td>
                                  <td className="p-1.5 text-center"><span className={`px-1 rounded text-[10px] ${iss.basis === 'cash' ? 'bg-slate-100 text-slate-700' : 'bg-blue-100 text-blue-700'}`}>{iss.basis}</span></td>
                                  <td className="p-1.5 text-gray-700">{issueLabel}</td>
                                  <td className="p-1.5 text-right">${Math.round(iss.ttm).toLocaleString()}</td>
                                  <td className="p-1.5 text-right">${Math.round(iss.monthlySum).toLocaleString()}</td>
                                  <td className="p-1.5 text-right text-red-700">${Math.round(iss.diff).toLocaleString()}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="flex justify-end gap-2 pt-3 mt-2 border-t">
                        <button onClick={() => setShowPnlReconModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm">Close</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })()
        ) : viewMode === 'ttmmonthly' ? (
          /* ========== TTM P&L DETAIL ========== */
          <div>
            <div className="flex items-center justify-between mb-2">
              <div>
                <h2 className="text-lg font-bold">📅 TTM Monthly Detail</h2>
                <p className="text-sm text-gray-600">Enter monthly P&L data for TTM analysis. Data sums to TTM totals used in valuation.</p>
              </div>
              <div className="flex items-center gap-2">
                {/* P&L TTM Sync Status Chip — same indicator as P&L Entry tab; lights up when monthly totals don't match P&L Entry TTM */}
                {pnlTtmReconciliation.active && (
                  pnlTtmReconciliation.inSync ? (
                    <span
                      className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 border border-green-300 rounded text-xs font-medium"
                      title="TTM Monthly totals match P&L Entry TTM column for both cash and accrual"
                    >
                      ✓ P&L Entry TTM in sync
                    </span>
                  ) : (
                    <button
                      onClick={() => setShowPnlReconModal(true)}
                      className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-800 border border-red-400 rounded text-xs font-semibold hover:bg-red-200"
                      title="Click to see which line items don't reconcile"
                    >
                      ⚠ P&L Entry TTM out of sync — {pnlTtmReconciliation.totalIssues} issue{pnlTtmReconciliation.totalIssues === 1 ? '' : 's'}
                      {pnlTtmReconciliation.cashIssues > 0 && pnlTtmReconciliation.accrualIssues > 0
                        ? ` (${pnlTtmReconciliation.cashIssues} cash, ${pnlTtmReconciliation.accrualIssues} accrual)`
                        : pnlTtmReconciliation.cashIssues > 0 ? ' (cash)' : ' (accrual)'}
                    </button>
                  )
                )}
                <button
                  onClick={() => {
                    setFullMonthlyPasteData('');
                    setFullMonthlyPastePreview(null);
                    setShowFullMonthlyPasteModal(true);
                  }}
                  className="px-3 py-1.5 bg-purple-600 text-white text-sm rounded hover:bg-purple-700 font-medium"
                >
                  📋 Paste Full Monthly P&L
                </button>
                <button
                  title="Remove rows that have no monthly data across all 12 months (cleans up stale rows from old pastes)"
                  onClick={() => {
                    const hasMonthlyData = (monthly, id) => {
                      const e = monthly[String(id)] || {};
                      return [...(e.accrual || []), ...(e.cash || [])].some(v => v !== 0);
                    };
                    const revCount = revenueCategories.filter(c => c.name && !hasMonthlyData(monthlyTtmRevenue, c.id)).length;
                    const cogsCount = cogsCategories.filter(c => c.name && !hasMonthlyData(monthlyTtmCogs, c.id)).length;
                    const opexCount = opexCategories.filter(c => c.name && !hasMonthlyData(monthlyTtmOpex, c.id)).length;
                    const total = revCount + cogsCount + opexCount;
                    if (total === 0) { alert('No empty rows found.'); return; }
                    if (!window.confirm(`Remove ${total} row${total !== 1 ? 's' : ''} with no monthly data?\n(${revCount} revenue, ${cogsCount} COGS, ${opexCount} OpEx)\n\nThis is undoable.`)) return;
                    captureUndoState('Remove empty monthly rows');
                    setRevenueCategories(prev => prev.filter(c => !c.name || hasMonthlyData(monthlyTtmRevenue, c.id)));
                    setCogsCategories(prev => prev.filter(c => !c.name || hasMonthlyData(monthlyTtmCogs, c.id)));
                    setOpexCategories(prev => prev.filter(c => !c.name || hasMonthlyData(monthlyTtmOpex, c.id)));
                  }}
                  className="px-3 py-1.5 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300 font-medium"
                >
                  🧹 Remove Empty Rows
                </button>
                <button onClick={() => setViewMode('detailed')} className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700">
                  View Analysis →
                </button>
              </div>
            </div>
            
            {/* Document Tracker */}
            {renderDocTracker('ttmmonthly')}
            
            {/* Settings Row */}
            <div className="flex flex-wrap gap-3 mb-3 p-3 bg-gray-100 rounded-lg items-center">
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium">TTM Ending:</label>
                <select 
                  value={monthlyTtmConfig.endMonth} 
                  onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, endMonth: parseInt(e.target.value)})} 
                  className="p-1 border rounded text-sm"
                >
                  <option value={0}>January</option>
                  <option value={1}>February</option>
                  <option value={2}>March</option>
                  <option value={3}>April</option>
                  <option value={4}>May</option>
                  <option value={5}>June</option>
                  <option value={6}>July</option>
                  <option value={7}>August</option>
                  <option value={8}>September</option>
                  <option value={9}>October</option>
                  <option value={10}>November</option>
                  <option value={11}>December</option>
                </select>
                <input 
                  type="number" 
                  value={monthlyTtmConfig.endYear} 
                  onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, endYear: parseInt(e.target.value)})} 
                  className="w-20 p-1 border rounded text-sm text-center"
                  min={2020}
                  max={2030}
                />
              </div>
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium">Basis:</label>
                <select 
                  value={selectedValuationBasis} 
                  onChange={e => setSelectedValuationBasis(e.target.value)} 
                  className="p-1 border rounded text-sm font-bold text-blue-700"
                >
                  <option value="cash">Cash</option>
                  <option value="accrual">Accrual</option>
                </select>
              </div>
              <label className="flex items-center gap-1 text-sm">
                <input 
                  type="checkbox" 
                  checked={monthlyTtmConfig.showArchive} 
                  onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, showArchive: e.target.checked})} 
                />
                Show Archive (13-24 months)
              </label>
              <label className="flex items-center gap-1 text-sm" title="When checked: Monthly data (months 1-12) syncs to P&L Entry TTM tab. When unchecked: Enter TTM totals directly on P&L Entry tab.">
                <input 
                  type="checkbox" 
                  checked={monthlyTtmConfig.useMonthlyForTtm} 
                  onChange={e => setMonthlyTtmConfig({...monthlyTtmConfig, useMonthlyForTtm: e.target.checked})} 
                />
                <span>Sync to TTM</span>
                <span className={`text-xs px-1 rounded ${monthlyTtmConfig.useMonthlyForTtm ? 'bg-blue-200 text-blue-800' : 'bg-gray-200 text-gray-600'}`}>
                  {monthlyTtmConfig.useMonthlyForTtm ? 'Monthly → TTM' : 'Manual TTM'}
                </span>
              </label>
              <button 
                onClick={() => {
                  // Roll forward: shift all data left by 1 month, advance end month by 1
                  const shiftArray = (arr) => [...arr.slice(1), 0];
                  
                  // Advance end month by 1
                  setMonthlyTtmConfig(prev => {
                    let newMonth = prev.endMonth + 1;
                    let newYear = prev.endYear;
                    if (newMonth > 11) {
                      newMonth = 0;
                      newYear++;
                    }
                    return { ...prev, endMonth: newMonth, endYear: newYear };
                  });
                  
                  // Shift revenue data
                  setMonthlyTtmRevenue(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                      updated[id] = {
                        cash: shiftArray(prev[id]?.cash || Array(24).fill(0)),
                        accrual: shiftArray(prev[id]?.accrual || Array(24).fill(0))
                      };
                    });
                    return updated;
                  });
                  
                  // Shift COGS data
                  setMonthlyTtmCogs(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                      updated[id] = {
                        cash: shiftArray(prev[id]?.cash || Array(24).fill(0)),
                        accrual: shiftArray(prev[id]?.accrual || Array(24).fill(0))
                      };
                    });
                    return updated;
                  });
                  
                  // Shift OpEx data
                  setMonthlyTtmOpex(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                      updated[id] = {
                        cash: shiftArray(prev[id]?.cash || Array(24).fill(0)),
                        accrual: shiftArray(prev[id]?.accrual || Array(24).fill(0))
                      };
                    });
                    return updated;
                  });
                  
                  // Shift DIAT data
                  setMonthlyTtmDiat(prev => ({
                    depreciation: { cash: shiftArray(prev.depreciation?.cash || Array(24).fill(0)), accrual: shiftArray(prev.depreciation?.accrual || Array(24).fill(0)) },
                    interest: { cash: shiftArray(prev.interest?.cash || Array(24).fill(0)), accrual: shiftArray(prev.interest?.accrual || Array(24).fill(0)) },
                    amortization: { cash: shiftArray(prev.amortization?.cash || Array(24).fill(0)), accrual: shiftArray(prev.amortization?.accrual || Array(24).fill(0)) },
                    taxes: { cash: shiftArray(prev.taxes?.cash || Array(24).fill(0)), accrual: shiftArray(prev.taxes?.accrual || Array(24).fill(0)) }
                  }));
                }}
                className="px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700"
              >
                ↻ Roll Forward
              </button>
            </div>

            {/* TTM Period Info */}
            <div className="mb-3 p-2 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex justify-between items-start">
                <div className="text-sm">
                  <span className="font-medium">TTM Period:</span> {monthlyTtmLabels[0]} through {monthlyTtmLabels[11]} 
                  <span className="text-gray-500 ml-2">(← Oldest | Most Recent →)</span>
                  {monthlyTtmConfig.showArchive && (
                    <div className="text-xs text-gray-600 mt-1">
                      <span className="font-medium">Archive:</span> {monthlyTtmLabels[12]} through {monthlyTtmLabels[23]}
                    </div>
                  )}
                </div>
                <div className="flex gap-2">
                  {/* Cash/Accrual Tools Dropdown */}
                  <div className="relative">
                    <button
                      onClick={() => setShowBasisTools(!showBasisTools)}
                      className="px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 flex items-center gap-1"
                    >
                      ⚙️ Cash ↔ Accrual <ChevronDown className="w-3 h-3" />
                    </button>
                    {showBasisTools && (
                      <div className="absolute right-0 mt-1 w-48 bg-white border rounded-lg shadow-lg z-50">
                        <button
                          onClick={() => {
                            // Copy Cash to Accrual
                            setMonthlyTtmRevenue(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: [...(prev[id]?.cash || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmCogs(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: [...(prev[id]?.cash || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmOpex(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: [...(prev[id]?.cash || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherIncome(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: [...(prev[id]?.cash || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherExpense(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: [...(prev[id]?.cash || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmDiat(prev => ({
                              depreciation: { ...prev.depreciation, accrual: [...(prev.depreciation?.cash || Array(24).fill(0))] },
                              interest: { ...prev.interest, accrual: [...(prev.interest?.cash || Array(24).fill(0))] },
                              amortization: { ...prev.amortization, accrual: [...(prev.amortization?.cash || Array(24).fill(0))] },
                              taxes: { ...prev.taxes, accrual: [...(prev.taxes?.cash || Array(24).fill(0))] }
                            }));
                            setShowBasisTools(false);
                          }}
                          className="w-full px-3 py-2 text-left text-xs hover:bg-gray-100 border-b"
                        >
                          📋 Copy Cash → Accrual
                        </button>
                        <button
                          onClick={() => {
                            // Copy Accrual to Cash
                            setMonthlyTtmRevenue(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: [...(prev[id]?.accrual || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmCogs(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: [...(prev[id]?.accrual || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmOpex(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: [...(prev[id]?.accrual || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherIncome(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: [...(prev[id]?.accrual || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherExpense(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: [...(prev[id]?.accrual || Array(24).fill(0))] };
                              });
                              return updated;
                            });
                            setMonthlyTtmDiat(prev => ({
                              depreciation: { ...prev.depreciation, cash: [...(prev.depreciation?.accrual || Array(24).fill(0))] },
                              interest: { ...prev.interest, cash: [...(prev.interest?.accrual || Array(24).fill(0))] },
                              amortization: { ...prev.amortization, cash: [...(prev.amortization?.accrual || Array(24).fill(0))] },
                              taxes: { ...prev.taxes, cash: [...(prev.taxes?.accrual || Array(24).fill(0))] }
                            }));
                            setShowBasisTools(false);
                          }}
                          className="w-full px-3 py-2 text-left text-xs hover:bg-gray-100 border-b"
                        >
                          📋 Copy Accrual → Cash
                        </button>
                        <button
                          onClick={() => {
                            // Clear Cash Only
                            setMonthlyTtmRevenue(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmCogs(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmOpex(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherIncome(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherExpense(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], cash: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmDiat(prev => ({
                              depreciation: { ...prev.depreciation, cash: Array(24).fill(0) },
                              interest: { ...prev.interest, cash: Array(24).fill(0) },
                              amortization: { ...prev.amortization, cash: Array(24).fill(0) },
                              taxes: { ...prev.taxes, cash: Array(24).fill(0) }
                            }));
                            setShowBasisTools(false);
                          }}
                          className="w-full px-3 py-2 text-left text-xs hover:bg-gray-100 border-b text-red-600"
                        >
                          🗑️ Clear Cash Only
                        </button>
                        <button
                          onClick={() => {
                            // Clear Accrual Only
                            setMonthlyTtmRevenue(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmCogs(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmOpex(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherIncome(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmOtherExpense(prev => {
                              const updated = {};
                              Object.keys(prev).forEach(id => {
                                updated[id] = { ...prev[id], accrual: Array(24).fill(0) };
                              });
                              return updated;
                            });
                            setMonthlyTtmDiat(prev => ({
                              depreciation: { ...prev.depreciation, accrual: Array(24).fill(0) },
                              interest: { ...prev.interest, accrual: Array(24).fill(0) },
                              amortization: { ...prev.amortization, accrual: Array(24).fill(0) },
                              taxes: { ...prev.taxes, accrual: Array(24).fill(0) }
                            }));
                            setShowBasisTools(false);
                          }}
                          className="w-full px-3 py-2 text-left text-xs hover:bg-gray-100 text-red-600"
                        >
                          🗑️ Clear Accrual Only
                        </button>
                      </div>
                    )}
                  </div>
                  {/* Clear TTM & Resync Button */}
                  <button
                    onClick={() => {
                      if (!confirm('This will clear all TTM values and resync from monthly data. Continue?')) return;
                      
                      captureUndoState('Clear TTM & Resync');
                      
                      // Helper to sum first 12 months - keep full precision
                      const sumTtm = (arr) => (arr || []).slice(0, 12).reduce((sum, v) => sum + (v || 0), 0);
                      
                      // Clear and resync Revenue
                      setRevenueCategories(prev => prev.map(cat => {
                        const monthlyData = monthlyTtmRevenue[cat.id];
                        const cashTtm = monthlyData ? sumTtm(monthlyData.cash) : 0;
                        const accrualTtm = monthlyData ? sumTtm(monthlyData.accrual) : 0;
                        return {
                          ...cat,
                          cash: { ...cat.cash, ttm: cashTtm },
                          accrual: { ...cat.accrual, ttm: accrualTtm }
                        };
                      }));
                      
                      // Clear and resync COGS
                      setCogsCategories(prev => prev.map(cat => {
                        const monthlyData = monthlyTtmCogs[cat.id];
                        const cashTtm = monthlyData ? sumTtm(monthlyData.cash) : 0;
                        const accrualTtm = monthlyData ? sumTtm(monthlyData.accrual) : 0;
                        return {
                          ...cat,
                          cash: { ...cat.cash, ttm: cashTtm },
                          accrual: { ...cat.accrual, ttm: accrualTtm }
                        };
                      }));
                      
                      // Clear and resync OpEx
                      setOpexCategories(prev => prev.map(cat => {
                        const monthlyData = monthlyTtmOpex[cat.id];
                        const cashTtm = monthlyData ? sumTtm(monthlyData.cash) : 0;
                        const accrualTtm = monthlyData ? sumTtm(monthlyData.accrual) : 0;
                        return {
                          ...cat,
                          cash: { ...cat.cash, ttm: cashTtm },
                          accrual: { ...cat.accrual, ttm: accrualTtm }
                        };
                      }));
                      
                      // Clear and resync Other Income
                      setOtherIncomeCategories(prev => prev.map(cat => {
                        const monthlyData = monthlyTtmOtherIncome[cat.id];
                        const cashTtm = monthlyData ? sumTtm(monthlyData.cash) : 0;
                        const accrualTtm = monthlyData ? sumTtm(monthlyData.accrual) : 0;
                        return {
                          ...cat,
                          cash: { ...cat.cash, ttm: cashTtm },
                          accrual: { ...cat.accrual, ttm: accrualTtm }
                        };
                      }));
                      
                      // Clear and resync Other Expense
                      setOtherExpenseCategories(prev => prev.map(cat => {
                        const monthlyData = monthlyTtmOtherExpense[cat.id];
                        const cashTtm = monthlyData ? sumTtm(monthlyData.cash) : 0;
                        const accrualTtm = monthlyData ? sumTtm(monthlyData.accrual) : 0;
                        return {
                          ...cat,
                          cash: { ...cat.cash, ttm: cashTtm },
                          accrual: { ...cat.accrual, ttm: accrualTtm }
                        };
                      }));
                      
                      // Clear and resync DIAT
                      setDiatCategories(prev => ({
                        depreciation: {
                          ...prev.depreciation,
                          cash: { ...prev.depreciation?.cash, ttm: sumTtm(monthlyTtmDiat.depreciation?.cash) },
                          accrual: { ...prev.depreciation?.accrual, ttm: sumTtm(monthlyTtmDiat.depreciation?.accrual) }
                        },
                        interest: {
                          ...prev.interest,
                          cash: { ...prev.interest?.cash, ttm: sumTtm(monthlyTtmDiat.interest?.cash) },
                          accrual: { ...prev.interest?.accrual, ttm: sumTtm(monthlyTtmDiat.interest?.accrual) }
                        },
                        amortization: {
                          ...prev.amortization,
                          cash: { ...prev.amortization?.cash, ttm: sumTtm(monthlyTtmDiat.amortization?.cash) },
                          accrual: { ...prev.amortization?.accrual, ttm: sumTtm(monthlyTtmDiat.amortization?.accrual) }
                        },
                        taxes: {
                          ...prev.taxes,
                          cash: { ...prev.taxes?.cash, ttm: sumTtm(monthlyTtmDiat.taxes?.cash) },
                          accrual: { ...prev.taxes?.accrual, ttm: sumTtm(monthlyTtmDiat.taxes?.accrual) }
                        }
                      }));
                      
                      alert('TTM values cleared and resynced from monthly data.');
                    }}
                    className="px-2 py-1 bg-orange-600 text-white text-xs rounded hover:bg-orange-700 flex items-center gap-1"
                    title="Clear all TTM values and recalculate from monthly data"
                  >
                    🔄 Resync TTM
                  </button>
                </div>
              </div>
            </div>

            {/* Revenue Section */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div className="bg-blue-100 px-3 py-2 font-bold flex items-center justify-between"><span>📈 Revenue (Monthly)</span>{ttmAddLineSelect('revenue')}</div>
              <div className="overflow-x-auto">
                <table className="w-full text-xs min-w-max">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Line Item</th>
                      {monthlyTtmLabels.slice(0, monthlyTtmConfig.showArchive ? 24 : 12).map((label, idx) => (
                        <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                      ))}
                      <th className="p-1 border text-center w-20 font-bold">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {revenueCategories.filter(cat => cat.name && ((monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || []).some(v => v !== 0) || ttmManualRows.includes(String(cat.id)))).map(cat => {
                      const monthlyData = monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const activeMonths = monthlyData.slice(0, 12);
                      const total = activeMonths.reduce((sum, v) => sum + (v || 0), 0);
                      
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border font-medium sticky left-0 bg-white w-32 max-w-32 overflow-hidden">
                            <div className="flex items-center justify-between gap-1">
                              <span className="truncate">{cat.name}</span>
                              <button
                                onClick={() => {
                                  setPasteModal({ show: true, section: 'revenue', categoryId: cat.id, categoryName: cat.name });
                                  setPasteData('');
                                }}
                                className="text-gray-400 hover:text-blue-600 flex-shrink-0"
                                title="Paste row from Excel"
                              >
                                📋
                              </button>
                            </div>
                          </td>
                          {monthlyData.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-0 border ${idx >= 12 ? 'bg-gray-50' : ''}`}>
                                <CurrencyInput 
                                  value={val || 0}
                                  onChange={v => {
                                    setMonthlyTtmRevenue(prev => {
                                      const existing = prev[cat.id] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
                                      const newBasisData = [...(existing[selectedValuationBasis] || Array(24).fill(0))];
                                      newBasisData[idx] = v;
                                      return {
                                        ...prev,
                                        [cat.id]: { ...existing, [selectedValuationBasis]: newBasisData }
                                      };
                                    });
                                  }}
                                  className={`w-full p-1 text-xs text-right border-0 ${idx >= 12 ? 'bg-gray-50' : 'bg-transparent'}`}
                                />
                              </td>
                            );
                          })}
                          <td className="p-1 border text-right font-bold bg-blue-50">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })}
                    {/* Revenue Total Row */}
                    {(() => {
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const monthTotals = Array(24).fill(0);
                      revenueCategories.filter(cat => cat.name).forEach(cat => {
                        const monthlyData = monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                        monthlyData.forEach((v, idx) => { monthTotals[idx] += (v || 0); });
                      });
                      const total = monthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
                      
                      return (
                        <tr className="bg-blue-100 font-bold">
                          <td className="p-2 border sticky left-0 bg-blue-200 w-32 max-w-32">Total Revenue</td>
                          {monthTotals.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-blue-100' : ''}`}>{formatCurrency(val)}</td>
                            );
                          })}
                          <td className="p-2 border text-right bg-blue-300">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>

            {/* COGS Section */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div className="bg-slate-200 px-3 py-2 font-bold flex items-center justify-between"><span>📦 Cost of Goods Sold (Monthly)</span>{ttmAddLineSelect('cogs')}</div>
              <div className="overflow-x-auto">
                <table className="w-full text-xs min-w-max">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Line Item</th>
                      {monthlyTtmLabels.slice(0, monthlyTtmConfig.showArchive ? 24 : 12).map((label, idx) => (
                        <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                      ))}
                      <th className="p-1 border text-center w-20 bg-slate-200 font-bold">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cogsCategories.filter(cat => cat.name && ((monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || []).some(v => v !== 0) || ttmManualRows.includes(String(cat.id)))).map(cat => {
                      const monthlyData = monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const activeMonths = monthlyData.slice(0, 12);
                      const total = activeMonths.reduce((sum, v) => sum + (v || 0), 0);
                      
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border font-medium sticky left-0 bg-white w-32 max-w-32 overflow-hidden">
                            <div className="flex items-center justify-between gap-1">
                              <span className="truncate">{cat.name}</span>
                              <button
                                onClick={() => {
                                  setPasteModal({ show: true, section: 'cogs', categoryId: cat.id, categoryName: cat.name });
                                  setPasteData('');
                                }}
                                className="text-gray-400 hover:text-blue-600 flex-shrink-0"
                                title="Paste row from Excel"
                              >
                                📋
                              </button>
                            </div>
                          </td>
                          {monthlyData.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-0 border ${idx >= 12 ? 'bg-gray-50' : ''}`}>
                                <CurrencyInput 
                                  value={val || 0}
                                  onChange={v => {
                                    setMonthlyTtmCogs(prev => {
                                      const existing = prev[cat.id] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
                                      const newBasisData = [...(existing[selectedValuationBasis] || Array(24).fill(0))];
                                      newBasisData[idx] = v;
                                      return {
                                        ...prev,
                                        [cat.id]: { ...existing, [selectedValuationBasis]: newBasisData }
                                      };
                                    });
                                  }}
                                  className={`w-full p-1 text-xs text-right border-0 ${idx >= 12 ? 'bg-gray-50' : 'bg-transparent'}`}
                                />
                              </td>
                            );
                          })}
                          <td className="p-1 border text-right font-bold bg-slate-100">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })}
                    {/* COGS Total Row */}
                    {(() => {
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const monthTotals = Array(24).fill(0);
                      cogsCategories.filter(cat => cat.name).forEach(cat => {
                        const monthlyData = monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                        monthlyData.forEach((v, idx) => { monthTotals[idx] += (v || 0); });
                      });
                      const total = monthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
                      
                      return (
                        <tr className="bg-slate-300 font-bold">
                          <td className="p-2 border sticky left-0 bg-slate-300 w-32 max-w-32">Total COGS</td>
                          {monthTotals.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-slate-200' : ''}`}>{formatCurrency(val)}</td>
                            );
                          })}
                          <td className="p-2 border text-right bg-slate-400">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Gross Profit Summary */}
            {(() => {
              const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
              const revMonthTotals = Array(24).fill(0);
              const cogsMonthTotals = Array(24).fill(0);
              revenueCategories.filter(cat => cat.name).forEach(cat => {
                const monthlyData = monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                monthlyData.forEach((v, idx) => { revMonthTotals[idx] += (v || 0); });
              });
              cogsCategories.filter(cat => cat.name).forEach(cat => {
                const monthlyData = monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                monthlyData.forEach((v, idx) => { cogsMonthTotals[idx] += (v || 0); });
              });
              const gpMonthTotals = revMonthTotals.map((r, i) => r - cogsMonthTotals[i]);
              const gpTotal = gpMonthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
              
              return (
                <div className="border rounded-lg overflow-hidden mb-4">
                  <div className="bg-blue-200 px-3 py-2 font-bold">📊 Gross Profit</div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs min-w-max">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Item</th>
                          {monthlyTtmLabels.slice(0, displayMonths).map((label, idx) => (
                            <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                          ))}
                          <th className="p-1 border text-center w-20 bg-blue-200 font-bold">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="bg-blue-100 font-bold">
                          <td className="p-1 border font-bold sticky left-0 bg-blue-100 w-32 max-w-32 overflow-hidden">Gross Profit</td>
                          {gpMonthTotals.slice(0, displayMonths).map((val, idx) => (
                            <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-blue-100' : ''}`}>{formatCurrency(val)}</td>
                          ))}
                          <td className="p-1 border text-right font-bold bg-blue-200">{formatCurrency(gpTotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })()}

            {/* OpEx Section */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div className="bg-slate-100 px-3 py-2 font-bold flex items-center justify-between">
                <span>💰 Operating Expenses (Monthly)</span>
                {ttmAddLineSelect('opex')}
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-xs min-w-max">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Line Item</th>
                      {monthlyTtmLabels.slice(0, monthlyTtmConfig.showArchive ? 24 : 12).map((label, idx) => (
                        <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                      ))}
                      <th className="p-1 border text-center w-20 bg-gray-300 font-bold">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {opexCategories.filter(cat => cat.name && ((monthlyTtmOpex[cat.id]?.[selectedValuationBasis] || []).some(v => v !== 0) || ttmManualRows.includes(String(cat.id)))).map(cat => {
                      const monthlyData = monthlyTtmOpex[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const activeMonths = monthlyData.slice(0, 12);
                      const total = activeMonths.reduce((sum, v) => sum + (v || 0), 0);
                      
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border font-medium sticky left-0 bg-white w-32 max-w-32 overflow-hidden">
                            <div className="flex items-center justify-between gap-1">
                              <span className="truncate">{cat.name}</span>
                              <button
                                onClick={() => {
                                  setPasteModal({ show: true, section: 'opex', categoryId: cat.id, categoryName: cat.name });
                                  setPasteData('');
                                }}
                                className="text-gray-400 hover:text-blue-600 flex-shrink-0"
                                title="Paste row from Excel"
                              >
                                📋
                              </button>
                            </div>
                          </td>
                          {monthlyData.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-0 border ${idx >= 12 ? 'bg-gray-50' : ''}`}>
                                <CurrencyInput 
                                  value={val || 0}
                                  onChange={v => {
                                    setMonthlyTtmOpex(prev => {
                                      const existing = prev[cat.id] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
                                      const newBasisData = [...(existing[selectedValuationBasis] || Array(24).fill(0))];
                                      newBasisData[idx] = v;
                                      return {
                                        ...prev,
                                        [cat.id]: { ...existing, [selectedValuationBasis]: newBasisData }
                                      };
                                    });
                                  }}
                                  className={`w-full p-1 text-xs text-right border-0 ${idx >= 12 ? 'bg-gray-50' : 'bg-transparent'}`}
                                />
                              </td>
                            );
                          })}
                          <td className="p-1 border text-right font-bold bg-gray-100">
                            {formatCurrency(total)}
                          </td>
                        </tr>
                      );
                    })}
                    {/* OpEx Total Row */}
                    {(() => {
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const monthTotals = Array(24).fill(0);
                      opexCategories.filter(cat => cat.name).forEach(cat => {
                        const monthlyData = monthlyTtmOpex[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                        monthlyData.forEach((v, idx) => { monthTotals[idx] += (v || 0); });
                      });
                      const total = monthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
                      
                      return (
                        <tr className="bg-gray-300 font-bold">
                          <td className="p-2 border sticky left-0 bg-gray-300 w-32 max-w-32 overflow-hidden">Total OpEx</td>
                          {monthTotals.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-gray-200' : ''}`}>{formatCurrency(val)}</td>
                            );
                          })}
                          <td className="p-2 border text-right bg-gray-400">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Operating Income - Table format */}
            {(() => {
              const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
              const revMonthTotals = Array(24).fill(0);
              const cogsMonthTotals = Array(24).fill(0);
              const opexMonthTotals = Array(24).fill(0);
              
              revenueCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { revMonthTotals[idx] += (v || 0); });
              });
              cogsCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { cogsMonthTotals[idx] += (v || 0); });
              });
              // Include all OpEx items
              opexCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmOpex[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { opexMonthTotals[idx] += (v || 0); });
              });
              
              const opIncMonthTotals = revMonthTotals.map((r, i) => r - cogsMonthTotals[i] - opexMonthTotals[i]);
              const opIncTotal = opIncMonthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
              
              return (
                <div className="border rounded-lg overflow-hidden mb-4">
                  <div className="bg-blue-100 px-3 py-2 font-bold">📊 Operating Income</div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs min-w-max">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Item</th>
                          {monthlyTtmLabels.slice(0, displayMonths).map((label, idx) => (
                            <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                          ))}
                          <th className="p-1 border text-center w-20 bg-blue-100 font-bold">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="bg-blue-50 font-bold">
                          <td className="p-1 border font-bold sticky left-0 bg-blue-50 w-32 max-w-32 overflow-hidden">Operating Income</td>
                          {opIncMonthTotals.slice(0, displayMonths).map((val, idx) => (
                            <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-blue-100' : ''}`}>{formatCurrency(val)}</td>
                          ))}
                          <td className="p-1 border text-right font-bold bg-blue-200">{formatCurrency(opIncTotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })()}

            {/* Other Income (Monthly) */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div className="bg-blue-50 px-3 py-2 font-bold">📈 Other Income (Monthly)</div>
              <div className="overflow-x-auto">
                <table className="w-full text-xs min-w-max">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Line Item</th>
                      {monthlyTtmLabels.slice(0, monthlyTtmConfig.showArchive ? 24 : 12).map((label, idx) => (
                        <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                      ))}
                      <th className="p-1 border text-center w-20 bg-blue-50 font-bold">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {otherIncomeCategories.filter(cat => cat.name).map(cat => {
                      const monthlyData = monthlyTtmOtherIncome[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const activeMonths = monthlyData.slice(0, 12);
                      const total = activeMonths.reduce((sum, v) => sum + (v || 0), 0);
                      
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border font-medium sticky left-0 bg-white w-32 max-w-32 overflow-hidden">
                            <div className="flex items-center justify-between gap-1">
                              <span className="truncate">{cat.name}</span>
                              <button
                                onClick={() => {
                                  setPasteModal({ show: true, section: 'otherincome', categoryId: cat.id, categoryName: cat.name });
                                  setPasteData('');
                                }}
                                className="text-gray-400 hover:text-blue-600 flex-shrink-0"
                                title="Paste row from Excel"
                              >
                                📋
                              </button>
                            </div>
                          </td>
                          {monthlyData.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-0 border ${idx >= 12 ? 'bg-gray-50' : ''}`}>
                                <CurrencyInput 
                                  value={val || 0}
                                  onChange={v => {
                                    setMonthlyTtmOtherIncome(prev => {
                                      const existing = prev[cat.id] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
                                      const newBasisData = [...(existing[selectedValuationBasis] || Array(24).fill(0))];
                                      newBasisData[idx] = v;
                                      return {
                                        ...prev,
                                        [cat.id]: { ...existing, [selectedValuationBasis]: newBasisData }
                                      };
                                    });
                                  }}
                                  className={`w-full p-1 text-xs text-right border-0 ${idx >= 12 ? 'bg-gray-50' : 'bg-transparent'}`}
                                />
                              </td>
                            );
                          })}
                          <td className="p-1 border text-right font-bold bg-blue-50">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })}
                    {/* Other Income Total Row */}
                    {(() => {
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const monthTotals = Array(24).fill(0);
                      otherIncomeCategories.filter(cat => cat.name).forEach(cat => {
                        const monthlyData = monthlyTtmOtherIncome[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                        monthlyData.forEach((v, idx) => { monthTotals[idx] += (v || 0); });
                      });
                      const total = monthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
                      
                      return (
                        <tr className="bg-blue-50 font-bold">
                          <td className="p-2 border sticky left-0 bg-blue-100 w-32 max-w-32 overflow-hidden">Total Other Income</td>
                          {monthTotals.slice(0, displayMonths).map((val, idx) => (
                            <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-blue-50' : ''}`}>{formatCurrency(val)}</td>
                          ))}
                          <td className="p-2 border text-right bg-blue-200">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Other Expense (Monthly) */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div className="bg-slate-200 px-3 py-2 font-bold">📉 Other Expense (Monthly)</div>
              <div className="overflow-x-auto">
                <table className="w-full text-xs min-w-max">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Line Item</th>
                      {monthlyTtmLabels.slice(0, monthlyTtmConfig.showArchive ? 24 : 12).map((label, idx) => (
                        <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                      ))}
                      <th className="p-1 border text-center w-20 bg-slate-200 font-bold">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {otherExpenseCategories.filter(cat => cat.name).map(cat => {
                      const monthlyData = monthlyTtmOtherExpense[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const activeMonths = monthlyData.slice(0, 12);
                      const total = activeMonths.reduce((sum, v) => sum + (v || 0), 0);
                      
                      return (
                        <tr key={cat.id}>
                          <td className="p-1 border font-medium sticky left-0 bg-white w-32 max-w-32 overflow-hidden">
                            <div className="flex items-center justify-between gap-1">
                              <span className="truncate">{cat.name}</span>
                              <button
                                onClick={() => {
                                  setPasteModal({ show: true, section: 'otherexpense', categoryId: cat.id, categoryName: cat.name });
                                  setPasteData('');
                                }}
                                className="text-gray-400 hover:text-blue-600 flex-shrink-0"
                                title="Paste row from Excel"
                              >
                                📋
                              </button>
                            </div>
                          </td>
                          {monthlyData.slice(0, displayMonths).map((val, idx) => {
                            return (
                              <td key={idx} className={`p-0 border ${idx >= 12 ? 'bg-gray-50' : ''}`}>
                                <CurrencyInput 
                                  value={val || 0}
                                  onChange={v => {
                                    setMonthlyTtmOtherExpense(prev => {
                                      const existing = prev[cat.id] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
                                      const newBasisData = [...(existing[selectedValuationBasis] || Array(24).fill(0))];
                                      newBasisData[idx] = v;
                                      return {
                                        ...prev,
                                        [cat.id]: { ...existing, [selectedValuationBasis]: newBasisData }
                                      };
                                    });
                                  }}
                                  className={`w-full p-1 text-xs text-right border-0 ${idx >= 12 ? 'bg-gray-50' : 'bg-transparent'}`}
                                />
                              </td>
                            );
                          })}
                          <td className="p-1 border text-right font-bold bg-slate-100">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })}
                    {/* Other Expense Total Row */}
                    {(() => {
                      const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
                      const monthTotals = Array(24).fill(0);
                      otherExpenseCategories.filter(cat => cat.name).forEach(cat => {
                        const monthlyData = monthlyTtmOtherExpense[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                        monthlyData.forEach((v, idx) => { monthTotals[idx] += (v || 0); });
                      });
                      const total = monthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
                      
                      return (
                        <tr className="bg-slate-200 font-bold">
                          <td className="p-2 border sticky left-0 bg-slate-200 w-32 max-w-32 overflow-hidden">Total Other Expense</td>
                          {monthTotals.slice(0, displayMonths).map((val, idx) => (
                            <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-slate-100' : ''}`}>{formatCurrency(val)}</td>
                          ))}
                          <td className="p-2 border text-right bg-slate-300">{formatCurrency(total)}</td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Net Income - Table format */}
            {(() => {
              const displayMonths = monthlyTtmConfig.showArchive ? 24 : 12;
              
              // Calculate monthly totals
              const revMonthTotals = Array(24).fill(0);
              const cogsMonthTotals = Array(24).fill(0);
              const opexMonthTotals = Array(24).fill(0);
              const otherIncMonthTotals = Array(24).fill(0);
              const otherExpMonthTotals = Array(24).fill(0);
              
              revenueCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmRevenue[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { revMonthTotals[idx] += (v || 0); });
              });
              cogsCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmCogs[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { cogsMonthTotals[idx] += (v || 0); });
              });
              // Include all OpEx
              opexCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmOpex[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { opexMonthTotals[idx] += (v || 0); });
              });
              otherIncomeCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmOtherIncome[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { otherIncMonthTotals[idx] += (v || 0); });
              });
              otherExpenseCategories.filter(cat => cat.name).forEach(cat => {
                const data = monthlyTtmOtherExpense[cat.id]?.[selectedValuationBasis] || Array(24).fill(0);
                data.forEach((v, idx) => { otherExpMonthTotals[idx] += (v || 0); });
              });
              
              // Net Income = Rev - COGS - OpEx + Other Inc - Other Exp
              const niMonthTotals = revMonthTotals.map((r, i) => r - cogsMonthTotals[i] - opexMonthTotals[i] + otherIncMonthTotals[i] - otherExpMonthTotals[i]);
              const niTotal = niMonthTotals.slice(0, 12).reduce((sum, v) => sum + v, 0);
              
              return (
                <div className="border rounded-lg overflow-hidden mb-4">
                  <div className="bg-blue-100 px-3 py-2 font-bold">📈 Net Income</div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs min-w-max">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="p-2 border text-left w-32 max-w-32 overflow-hidden sticky left-0 bg-gray-50">Item</th>
                          {monthlyTtmLabels.slice(0, displayMonths).map((label, idx) => (
                            <th key={idx} className={`p-1 border text-center w-16 ${idx >= 12 ? 'bg-gray-100' : ''}`}>{label}</th>
                          ))}
                          <th className="p-1 border text-center w-20 font-bold">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="bg-blue-50 font-bold">
                          <td className="p-1 border font-bold sticky left-0 bg-blue-50 w-32 max-w-32 overflow-hidden">Net Income</td>
                          {niMonthTotals.slice(0, displayMonths).map((val, idx) => (
                            <td key={idx} className={`p-1 border text-right ${idx >= 12 ? 'bg-blue-100' : ''}`}>{formatCurrency(val)}</td>
                          ))}
                          <td className="p-1 border text-right font-bold bg-blue-200">{formatCurrency(niTotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })()}

            {/* Notes */}
            <div className="p-3 bg-gray-50 rounded-lg text-sm">
              <div className={`text-xs p-2 rounded ${monthlyTtmConfig.useMonthlyForTtm ? 'bg-blue-50 border border-blue-200' : 'bg-slate-50 border border-slate-200'}`}>
                {monthlyTtmConfig.useMonthlyForTtm 
                  ? <>
                      <strong>✅ Sync Mode ON:</strong> Monthly data (months 1-12) automatically populates the TTM column on P&L Entry tab. 
                      <span className="text-green-700"> Enter data here → it flows to TTM.</span>
                    </>
                  : <>
                      <strong>⚠️ Sync Mode OFF:</strong> Monthly data and P&L Entry TTM are independent.
                      <span className="text-yellow-700"> Use this when entering annual TTM totals directly on P&L Entry tab.</span>
                    </>
                }
              </div>
            </div>

            {/* P&L TTM Reconciliation Detail Modal — duplicated here so the chip on the TTM Monthly tab can open it without switching viewMode */}
            {showPnlReconModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowPnlReconModal(false)}>
                <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">⚠ P&L TTM Sync Reconciliation</h3>
                    <button onClick={() => setShowPnlReconModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>
                  <div className="mb-3 text-xs text-gray-600">
                    These line items have a P&L Entry TTM value that doesn't match the sum of their 12 months on the TTM Monthly tab. Investigate by re-pasting the missing data on the TTM Monthly tab, or by removing the stale value on the P&L Entry tab.
                  </div>
                  <div className="mb-4 grid grid-cols-3 gap-3 text-sm">
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Total issues</div><div className="font-bold">{pnlTtmReconciliation.totalIssues}</div></div>
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Cash basis</div><div className="font-bold">{pnlTtmReconciliation.cashIssues}</div></div>
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Accrual basis</div><div className="font-bold">{pnlTtmReconciliation.accrualIssues}</div></div>
                  </div>
                  <div className="overflow-auto max-h-[55vh] border rounded">
                    <table className="w-full text-xs">
                      <thead className="bg-gray-100 sticky top-0">
                        <tr>
                          <th className="p-1.5 text-left">Section</th>
                          <th className="p-1.5 text-left">Line Item</th>
                          <th className="p-1.5 text-center">Basis</th>
                          <th className="p-1.5 text-left">Issue</th>
                          <th className="p-1.5 text-right">P&L Entry TTM</th>
                          <th className="p-1.5 text-right">Monthly Sum</th>
                          <th className="p-1.5 text-right">Diff</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pnlTtmReconciliation.issues.slice().sort((a,b) => Math.abs(b.diff) - Math.abs(a.diff)).map((iss, i) => {
                          const issueLabel = iss.type === 'no_monthly' ? 'No monthly data' : iss.type === 'orphan_monthly' ? 'Orphan monthly (no P&L row)' : 'Mismatch';
                          return (
                            <tr key={i} className="border-t">
                              <td className="p-1.5 text-gray-600">{iss.section}</td>
                              <td className="p-1.5 font-medium">{iss.name}</td>
                              <td className="p-1.5 text-center"><span className={`px-1 rounded text-[10px] ${iss.basis === 'cash' ? 'bg-slate-100 text-slate-700' : 'bg-blue-100 text-blue-700'}`}>{iss.basis}</span></td>
                              <td className="p-1.5 text-gray-700">{issueLabel}</td>
                              <td className="p-1.5 text-right">${Math.round(iss.ttm).toLocaleString()}</td>
                              <td className="p-1.5 text-right">${Math.round(iss.monthlySum).toLocaleString()}</td>
                              <td className="p-1.5 text-right text-red-700">${Math.round(iss.diff).toLocaleString()}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-end gap-2 pt-3 mt-2 border-t">
                    <button onClick={() => setShowPnlReconModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm">Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'salesmonthly' ? (
          /* ========== TTM MONTHLY SALES ========== */
          <div>
            <div className="flex items-center justify-between mb-2">
              <div>
                <h2 className="text-lg font-bold">📅 TTM Monthly Sales</h2>
                <p className="text-sm text-gray-600">Paste monthly sales report — totals auto-sync to the TTM column on the Sales tab.</p>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                    setMonthlySalesPasteData('');
                    setMonthlySalesPastePreview(null);
                    setShowMonthlySalesPasteModal(true);
                  }}
                  className="px-3 py-1.5 bg-purple-600 text-white text-sm rounded hover:bg-purple-700 font-medium"
                >
                  📋 Paste Monthly Sales Report
                </button>
                <button
                  title="Remove customers with no monthly sales data"
                  onClick={() => {
                    const empty = ttmBasisCustomers.filter(c => c.name && !monthlySalesData[String(c.id)]?.[(salesTtmConfig?.basis||'cash')] && !Array.isArray(monthlySalesData[String(c.id)]));
                    if (empty.length === 0) { alert('No empty rows found.'); return; }
                    if (!window.confirm(`Remove ${empty.length} customer${empty.length !== 1 ? 's' : ''} with no monthly data?\n\nThis is undoable.`)) return;
                    captureUndoState('Remove empty monthly sales rows');
                    const keepIds = new Set(ttmBasisCustomers.filter(c => { if (!c.name) return true; const _kd = monthlySalesData[String(c.id)]; const _ka = (_kd&&!Array.isArray(_kd))?(_kd[salesTtmConfig?.basis||'cash']):_kd; return _ka && Array.isArray(_ka) && _ka.some(v=>v!==0); }).map(c => c.id));
                    setTtmBasisCustomers(prev => prev.filter(c => !c.name || keepIds.has(c.id)));
                  }}
                  className="px-3 py-1.5 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300 font-medium"
                >
                  🧹 Remove Empty Rows
                </button>
                <button onClick={() => setViewMode('customers')} className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700">
                  ← Sales Tab
                </button>
                <button onClick={() => setViewMode('salesanalysis')} className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700">
                  View Analysis →
                </button>
              </div>
            </div>

            {/* TTM config */}
            <div className="flex flex-wrap gap-3 mb-3 p-3 bg-gray-100 rounded-lg items-center text-sm">
              <span className="font-medium">TTM Ending:</span>
              <select value={salesTtmConfig.endMonth} onChange={e => setSalesTtmConfig({...salesTtmConfig, endMonth: parseInt(e.target.value)})} className="px-2 py-1 border rounded text-sm">
                {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m,i) => <option key={i} value={i}>{m}</option>)}
              </select>
              <select value={salesTtmConfig.endYear} onChange={e => setSalesTtmConfig({...salesTtmConfig, endYear: parseInt(e.target.value)})} className="px-2 py-1 border rounded text-sm">
                {[2022,2023,2024,2025,2026].map(y => <option key={y} value={y}>{y}</option>)}
              </select>
              <span className="font-medium ml-2">Basis:</span>
              <select value={salesTtmConfig.basis || 'cash'} onChange={e => setSalesTtmConfig({...salesTtmConfig, basis: e.target.value})} className="px-2 py-1 border rounded text-sm">
                <option value="cash">Cash</option>
                <option value="accrual">Accrual</option>
              </select>
              <span className="text-gray-500 text-xs">Period: {salesTtmLabel}</span>
              <label className="flex items-center gap-1 text-sm ml-2" title="When checked: Monthly data syncs to TTM column on Sales tab via Resync button.">
                <input type="checkbox" checked={!!salesTtmConfig.useMonthlyForTtm} onChange={e => setSalesTtmConfig({...salesTtmConfig, useMonthlyForTtm: e.target.checked})} />
                <span>Sync to TTM</span>
                <span className={`text-xs px-1 rounded ${salesTtmConfig.useMonthlyForTtm ? 'bg-blue-200 text-blue-800' : 'bg-gray-200 text-gray-600'}`}>
                  {salesTtmConfig.useMonthlyForTtm ? 'Monthly TTM' : 'Manual TTM'}
                </span>
              </label>
              <button
                onClick={() => {
                  if (Object.keys(monthlySalesData).length === 0) { alert('No monthly data pasted yet.'); return; }
                  const resyncBasis = salesTtmConfig.basis || 'cash';
                  // New model: write to the basis-specific array directly. The other basis is untouched.
                  const targetArr = resyncBasis === 'cash' ? customerSalesCash : customerSalesAccrual;
                  const setTargetArr = resyncBasis === 'cash' ? setCustomerSalesCash : setCustomerSalesAccrual;
                  const otherArr = resyncBasis === 'cash' ? customerSalesAccrual : customerSalesCash;
                  // Pre-compute customers in target array whose TTM would be zeroed (have a non-zero
                  // TTM but no row in monthly data).
                  const toZero = (targetArr || []).filter(c => {
                    if (!c.name) return false;
                    if ((Number(c.ttm) || 0) === 0) return false;
                    return !monthlySalesData[String(c.id)];
                  });
                  const basisLabel = resyncBasis === 'cash' ? 'Cash' : 'Accrual';
                  let confirmMsg = `Resync ${basisLabel} TTM? This will overwrite the TTM column on the ${basisLabel} basis Sales tab from monthly data.`;
                  if (toZero.length > 0) {
                    const preview = toZero.slice(0, 10).map(c => `  • ${c.name} ($${Math.round(Number(c.ttm)||0).toLocaleString()})`).join('\n');
                    const more = toZero.length > 10 ? `\n  …and ${toZero.length - 10} more` : '';
                    confirmMsg = `Resync ${basisLabel} TTM will set ${toZero.length} customer${toZero.length === 1 ? '' : 's'} to $0 because they have no row on the TTM Monthly tab:\n\n${preview}${more}\n\nContinue?`;
                  }
                  if (!window.confirm(confirmMsg)) return;
                  captureUndoState('Resync Sales TTM from monthly data');
                  // Helper: compute monthly sums for a customer; null if no monthly entry
                  const getMonthlySums = (customerId) => {
                    const mData = monthlySalesData[String(customerId)];
                    if (!mData) return null;
                    if (Array.isArray(mData)) {
                      const total = mData.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
                      return { cash: total, accrual: total };
                    }
                    return {
                      cash: (mData.cash || []).slice(0, 12).reduce((s, v) => s + (v || 0), 0),
                      accrual: (mData.accrual || []).slice(0, 12).reduce((s, v) => s + (v || 0), 0),
                    };
                  };
                  // Build the new target array: target's existing rows (preserve year data) + any
                  // customers from the OTHER basis whose names don't match anything in the target.
                  // This keeps the target's customer roster comprehensive so that all customers
                  // with monthly data get TTM values, matching how cash sync naturally covers all.
                  const normalizeName = (n) => (n || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
                  const targetNames = new Set((targetArr || []).filter(c => c.name).map(c => normalizeName(c.name)));
                  const otherNotInTarget = (otherArr || []).filter(c => c.name && !targetNames.has(normalizeName(c.name)));
                  const addedFromOther = otherNotInTarget.length;
                  const merged = [...(targetArr || []), ...otherNotInTarget];
                  setTargetArr(merged.map(customer => {
                    const sums = getMonthlySums(customer.id);
                    if (!sums) {
                      return { ...customer, ttm: 0, ttmCash: 0, ttmAccrual: 0 };
                    }
                    const ttm = resyncBasis === 'cash' ? sums.cash : sums.accrual;
                    return { ...customer, ttm, ttmCash: sums.cash, ttmAccrual: sums.accrual };
                  }));
                  const zeroedSuffix = toZero.length > 0 ? ` ${toZero.length} customer${toZero.length === 1 ? '' : 's'} with no monthly data set to $0.` : '';
                  const addedSuffix = addedFromOther > 0 ? ` Added ${addedFromOther} customer${addedFromOther === 1 ? '' : 's'} from the ${resyncBasis === 'cash' ? 'accrual' : 'cash'} basis report.` : '';
                  alert(`${basisLabel} TTM values resynced from monthly sales data.` + zeroedSuffix + addedSuffix);
                }}
                className="px-2 py-1 bg-orange-600 text-white text-xs rounded hover:bg-orange-700 flex items-center gap-1"
                title="Resync TTM column on Sales tab from monthly data"
              >
                🔄 Resync TTM
              </button>
              <label className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer ml-2">
                <input type="checkbox" checked={showTtmNoData} onChange={e => setShowTtmNoData(e.target.checked)} />
                Show customers with no TTM data
              </label>
              {/* TTM Sync Status Chip — same indicator as Sales tab; lights up when totals diverge */}
              <div className="ml-auto">
                {salesTtmReconciliation.hasMonthlyData && (
                  salesTtmReconciliation.inSync ? (
                    <span
                      className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 border border-green-300 rounded text-xs font-medium"
                      title={`TTM Monthly total ($${Math.round(salesTtmReconciliation.monthlyTotal).toLocaleString()}) matches Sales tab TTM column`}
                    >
                      ✓ Sales tab TTM in sync
                    </span>
                  ) : (
                    <button
                      onClick={() => setShowSalesReconModal(true)}
                      className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-800 border border-red-400 rounded text-xs font-semibold hover:bg-red-200"
                      title="Click to see which customers don't reconcile"
                    >
                      ⚠ Sales tab TTM out of sync — ${Math.abs(Math.round(salesTtmReconciliation.difference)).toLocaleString()} {salesTtmReconciliation.difference > 0 ? 'over' : 'under'} ({salesTtmReconciliation.noMonthlyButHasTtm.length + salesTtmReconciliation.orphanMonthly.length + salesTtmReconciliation.mismatched.length} customer{(salesTtmReconciliation.noMonthlyButHasTtm.length + salesTtmReconciliation.orphanMonthly.length + salesTtmReconciliation.mismatched.length) === 1 ? '' : 's'})
                    </button>
                  )
                )}
              </div>
            </div>

            {/* Monthly Sales Grid */}
            {ttmBasisCustomers.filter(c => c.name).length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                No customers found. Add customers on the Sales tab first, then paste monthly data here.
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-gray-800 text-white">
                      <th className="p-2 text-left border border-gray-600 sticky left-0 bg-gray-800 z-10 w-48">Customer</th>
                      {monthlySalesMonthLabels.map((lbl, i) => (
                        <th key={i} className="p-1.5 text-right border border-gray-600 whitespace-nowrap w-20">{lbl}</th>
                      ))}
                      <th className="p-1.5 text-right border border-gray-600 bg-green-800 whitespace-nowrap w-24">TTM Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ttmBasisCustomers.filter(c => {
                        if (!c.name) return false;
                        if (showTtmNoData) return true;
                        const _mRaw = monthlySalesData[String(c.id)];
                        const monthly = (_mRaw && !Array.isArray(_mRaw)) ? (_mRaw[salesTtmConfig?.basis || 'cash'] || []) : (_mRaw || []);
                        return monthly.some(v => v !== 0);
                      }).map((customer, idx) => {
                      const _mRaw = monthlySalesData[String(customer.id)];
                      const monthly = (_mRaw && !Array.isArray(_mRaw)) ? (_mRaw[salesTtmConfig?.basis || 'cash'] || Array(12).fill(0)) : (_mRaw || Array(12).fill(0));
                      const ttmTotal = monthly.slice(0, 12).reduce((s, v) => s + (v || 0), 0);
                      const hasData = monthly.some(v => v !== 0);
                      const fmt = (v) => v ? '$' + Math.round(v).toLocaleString() : '-';
                      // Detect first/last active month for churn insights
                      const firstActive = monthly.findIndex(v => v > 0);
                      const lastActive = [...monthly].reverse().findIndex(v => v > 0);
                      const lastActiveIdx = lastActive === -1 ? -1 : 11 - lastActive;
                      const isNewThisTtm = firstActive > 0 && firstActive !== -1;
                      const isLostThisTtm = lastActiveIdx !== -1 && lastActiveIdx < 10 && ttmTotal > 0;
                      return (
                        <tr key={customer.id} className={`${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50`}>
                          <td className="p-1.5 border font-medium sticky left-0 bg-inherit z-10">
                            <div className="flex items-center gap-1">
                              {/* Under-contract marker (Colleen 09-02: she was flipping between
                                  this report and the client detail to see who is and isn't).
                                  Same hasContract field the detail screen edits — bold + chip. */}
                              <span className={`truncate max-w-40 ${customer.hasContract === true ? 'font-bold text-blue-900' : ''}`} title={customer.name + (customer.hasContract === true ? ' — under contract' : customer.contractAnswered ? ' — no contract' : '')}>{customer.name}</span>
                              {customer.hasContract === true && <span className="text-xs px-1 bg-blue-100 text-blue-700 rounded whitespace-nowrap" title="Under contract (from the client detail form)">📃</span>}
                              {isNewThisTtm && <span className="text-xs px-1 bg-green-100 text-green-700 rounded whitespace-nowrap">New M{firstActive+1}</span>}
                              {isLostThisTtm && <span className="text-xs px-1 bg-red-100 text-red-700 rounded whitespace-nowrap">Last M{lastActiveIdx+1}</span>}
                              {!hasData && <span className="text-xs text-gray-400 italic">no data</span>}
                            </div>
                          </td>
                          {monthly.slice(0, 12).map((v, mi) => (
                            <td key={mi} className={`p-1 border text-right ${v === 0 ? 'text-gray-300' : 'text-gray-800'}`}>
                              {fmt(v)}
                            </td>
                          ))}
                          <td className={`p-1.5 border text-right font-semibold ${ttmTotal > 0 ? 'text-green-800 bg-green-50' : 'text-gray-400'}`}>
                            {fmt(ttmTotal)}
                          </td>
                        </tr>
                      );
                    })}
                    {/* Totals row */}
                    {(() => {
                      const monthTotals = Array(12).fill(0);
                      ttmBasisCustomers.filter(c => c.name).forEach(c => {
                        const _d3=monthlySalesData[String(c.id)]; const m=(_d3&&!Array.isArray(_d3))?(_d3[salesTtmConfig?.basis||'cash']||[]):(_d3||[]);
                        m.slice(0, 12).forEach((v, i) => { monthTotals[i] += (v || 0); });
                      });
                      const grandTotal = monthTotals.reduce((s, v) => s + v, 0);
                      const fmt = (v) => v ? '$' + Math.round(v).toLocaleString() : '-';
                      return (
                        <tr className="bg-gray-800 text-white font-bold">
                          <td className="p-1.5 border sticky left-0 bg-gray-800 z-10">Total Revenue</td>
                          {monthTotals.map((v, i) => (
                            <td key={i} className="p-1 border text-right">{fmt(v)}</td>
                          ))}
                          <td className="p-1.5 border text-right bg-green-800">{fmt(grandTotal)}</td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            )}

            {/* Paste Modal */}
            {showMonthlySalesPasteModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-xl p-6 w-[700px] max-h-[85vh] overflow-auto">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">📋 Paste Monthly Sales Report</h3>
                    <button onClick={() => { setShowMonthlySalesPasteModal(false); setMonthlySalesPasteData(''); setMonthlySalesPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>

                  <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded text-sm text-blue-800">
                    Paste your Sales by Customer by Month report from QuickBooks. The tool will match customers by name and sync TTM totals to the Sales tab automatically.
                  </div>

                  <div className="mb-3 flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-700">Basis:</span>
                      <select
                        value={salesTtmConfig.basis || 'cash'}
                        onChange={e => setSalesTtmConfig({...salesTtmConfig, basis: e.target.value})}
                        className="px-2 py-1 border rounded text-sm font-bold text-blue-700 bg-blue-50"
                      >
                        <option value="cash">Cash</option>
                        <option value="accrual">Accrual</option>
                      </select>
                      <span className="text-xs text-gray-500">Select the basis of this report before applying</span>
                    </div>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" checked={monthlySalesClearFirst} onChange={e => setMonthlySalesClearFirst(e.target.checked)} className="w-4 h-4" />
                      <span className={`text-sm font-medium ${monthlySalesClearFirst ? "text-amber-700" : "text-gray-600"}`}>Clear & Replace</span>
                      {monthlySalesClearFirst && <span className="text-xs text-amber-600">(clears existing monthly data for this basis)</span>}
                    </label>
                  </div>

                  {!monthlySalesPastePreview ? (
                    <>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Paste Monthly Sales Data</label>
                      <textarea
                        value={monthlySalesPasteData}
                        onChange={e => setMonthlySalesPasteData(e.target.value)}
                        className="w-full h-48 p-2 border rounded font-mono text-xs"
                        placeholder="Paste your QuickBooks Sales by Customer by Month report here..."
                      />
                      <div className="flex gap-2 mt-3">
                        <button
                          onClick={() => { const preview = parseMonthlySalesPaste(); setMonthlySalesPastePreview(preview); }}
                          disabled={!monthlySalesPasteData.trim()}
                          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
                        >
                          Preview →
                        </button>
                        <button onClick={() => { setShowMonthlySalesPasteModal(false); setMonthlySalesPasteData(''); }} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">Cancel</button>
                      </div>
                    </>
                  ) : monthlySalesPastePreview.error ? (
                    <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
                      {monthlySalesPastePreview.error}
                      <button onClick={() => setMonthlySalesPastePreview(null)} className="ml-3 text-blue-600 hover:underline">← Back</button>
                    </div>
                  ) : (
                    <div>
                      <div className="grid grid-cols-3 gap-3 mb-4">
                        <div className="p-3 bg-green-50 rounded border border-green-200 text-center">
                          <div className="text-2xl font-bold text-green-700">{monthlySalesPastePreview.matched.length}</div>
                          <div className="text-xs text-green-600">Matched customers</div>
                        </div>
                        <div className="p-3 bg-blue-50 rounded border border-blue-200 text-center">
                          <div className="text-2xl font-bold text-blue-700">{monthlySalesPastePreview.newCustomers.length}</div>
                          <div className="text-xs text-blue-600">New customers (will be added)</div>
                        </div>
                        <div className="p-3 bg-gray-50 rounded border text-center">
                          <div className="text-lg font-bold text-gray-700">${Math.round(monthlySalesPastePreview.ttmTotal).toLocaleString()}</div>
                          <div className="text-xs text-gray-500">TTM Total</div>
                        </div>
                      </div>

                      {monthlySalesPastePreview.newCustomers.length > 0 && (
                        <div className="mb-3 p-2 bg-blue-50 rounded border border-blue-200 text-xs">
                          <div className="font-medium text-blue-700 mb-1">New customers to be added:</div>
                          {monthlySalesPastePreview.newCustomers.map((c, i) => (
                            <span key={i} className="inline-block mr-2 mb-1 px-2 py-0.5 bg-blue-100 text-blue-800 rounded">{c.name}</span>
                          ))}
                        </div>
                      )}

                      <div className="flex gap-2">
                        <button onClick={applyMonthlySalesPaste} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-medium">
                          ✓ Apply {(salesTtmConfig.basis || 'cash') === 'cash' ? 'Cash' : 'Accrual'} Paste
                        </button>
                        <button onClick={() => setMonthlySalesPastePreview(null)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">← Back</button>
                        <button onClick={() => { setShowMonthlySalesPasteModal(false); setMonthlySalesPasteData(''); setMonthlySalesPastePreview(null); }} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Sales TTM Reconciliation Detail Modal */}
            {showSalesReconModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowSalesReconModal(false)}>
                <div className="bg-white rounded-lg shadow-xl p-6 w-[800px] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">⚠ TTM Sync Reconciliation</h3>
                    <button onClick={() => setShowSalesReconModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
                  </div>
                  <div className="mb-4 grid grid-cols-3 gap-3 text-sm">
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">Sales tab TTM</div><div className="font-bold">${Math.round(salesTtmReconciliation.salesTtmTotal).toLocaleString()}</div></div>
                    <div className="p-2 bg-gray-50 rounded border"><div className="text-gray-500 text-xs">TTM Monthly total</div><div className="font-bold">${Math.round(salesTtmReconciliation.monthlyTotal).toLocaleString()}</div></div>
                    <div className={`p-2 rounded border ${salesTtmReconciliation.inSync ? 'bg-green-50' : 'bg-red-50'}`}><div className="text-gray-500 text-xs">Difference</div><div className={`font-bold ${salesTtmReconciliation.inSync ? 'text-green-700' : 'text-red-700'}`}>${Math.round(salesTtmReconciliation.difference).toLocaleString()}</div></div>
                  </div>
                  {salesTtmReconciliation.noMonthlyButHasTtm.length > 0 && (
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-1">Customers in Sales tab with no TTM Monthly row ({salesTtmReconciliation.noMonthlyButHasTtm.length})</div>
                      <div className="text-xs text-gray-600 mb-2">These customers have a TTM value on the Sales tab but no monthly data. Clicking <strong>Resync TTM</strong> will set their TTM to $0 (the TTM Monthly tab is the source of truth).</div>
                      <div className="overflow-auto max-h-64 border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0"><tr><th className="p-1.5 text-left">Customer</th><th className="p-1.5 text-right">Sales TTM</th></tr></thead>
                          <tbody>
                            {salesTtmReconciliation.noMonthlyButHasTtm.slice().sort((a,b) => b.salesTtm - a.salesTtm).map(c => (
                              <tr key={c.id} className="border-t"><td className="p-1.5">{c.name}</td><td className="p-1.5 text-right">${Math.round(c.salesTtm).toLocaleString()}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {salesTtmReconciliation.mismatched.length > 0 && (
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-1">Customers with mismatched values ({salesTtmReconciliation.mismatched.length})</div>
                      <div className="text-xs text-gray-600 mb-2">Both rows exist but their totals don't agree. Likely a manual edit on the Sales tab after the last Resync, or a basis switch. Clicking <strong>Resync TTM</strong> will overwrite Sales TTM with the monthly sum.</div>
                      <div className="overflow-auto max-h-64 border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0"><tr><th className="p-1.5 text-left">Customer</th><th className="p-1.5 text-right">Sales TTM</th><th className="p-1.5 text-right">Monthly Sum</th><th className="p-1.5 text-right">Diff</th></tr></thead>
                          <tbody>
                            {salesTtmReconciliation.mismatched.slice().sort((a,b) => Math.abs(b.diff) - Math.abs(a.diff)).map(c => (
                              <tr key={c.id} className="border-t"><td className="p-1.5">{c.name}</td><td className="p-1.5 text-right">${Math.round(c.salesTtm).toLocaleString()}</td><td className="p-1.5 text-right">${Math.round(c.monthlySum).toLocaleString()}</td><td className="p-1.5 text-right text-red-700">${Math.round(c.diff).toLocaleString()}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {salesTtmReconciliation.orphanMonthly.length > 0 && (
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-1">Monthly rows with no Sales tab customer ({salesTtmReconciliation.orphanMonthly.length})</div>
                      <div className="text-xs text-gray-600 mb-2">Monthly data exists for these customer IDs but they aren't in the Sales table. Their numbers are not contributing to the Sales TTM total.</div>
                      <div className="overflow-auto max-h-64 border rounded">
                        <table className="w-full text-xs">
                          <thead className="bg-gray-100 sticky top-0"><tr><th className="p-1.5 text-left">Customer ID</th><th className="p-1.5 text-right">Monthly Sum</th></tr></thead>
                          <tbody>
                            {salesTtmReconciliation.orphanMonthly.slice().sort((a,b) => b.monthlySum - a.monthlySum).map(c => (
                              <tr key={c.id} className="border-t"><td className="p-1.5">{c.id}</td><td className="p-1.5 text-right">${Math.round(c.monthlySum).toLocaleString()}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  <div className="flex justify-end gap-2 pt-2 border-t">
                    <button onClick={() => setShowSalesReconModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm">Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'salesanalysis' ? (
          /* ========== SALES ANALYSIS ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold">📊 Sales Analysis</h2>
              <button 
                onClick={() => setViewMode('customers')}
                className="px-3 py-1 bg-gray-600 text-white text-sm rounded hover:bg-gray-700"
              >
                ← Back to Data Entry
              </button>
            </div>
            
            {/* Customer Sales Detail with Flag/Note Capability */}
            {customerSalesData.filter(c => c.name || c.ttm || c.year5 || c.year4 || c.year3).length > 0 && (() => {
              // Calculate totals for comparison base detection
              const localTotals = { year4: 0, year5: 0, ttm: 0 };
              customerSalesData.forEach(c => {
                localTotals.year4 += c.year4 || 0;
                localTotals.year5 += c.year5 || 0;
                localTotals.ttm += c.ttm || 0;
              });
              
              // Calculate comparison base for consistent lost/new detection
              const year5Total = localTotals.year5 || 0;
              const ttmTotal = localTotals.ttm || 0;
              const ttmEqualsYear5 = year5Total > 0 && ttmTotal > 0 && 
                (Math.abs(year5Total - ttmTotal) / Math.max(year5Total, ttmTotal) < 0.05 || year5Total === ttmTotal);
              const churnComparisonBase = ttmEqualsYear5 ? 'year4' : 'year5';
              
              return (
              <div className="border rounded-lg overflow-hidden mb-4">
                <div 
                  className="px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 bg-green-100"
                  onClick={() => setSalesDetailExpanded(!salesDetailExpanded)}
                >
                  <span className="flex items-center gap-2">
                    📋 Customer Sales Detail
                    {Object.keys(manualReviewFlags).filter(k => k.startsWith('sales-detail-') && manualReviewFlags[k]?.flagged).length > 0 && (
                      <span className="px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 text-xs font-normal">
                        🚩 {Object.keys(manualReviewFlags).filter(k => k.startsWith('sales-detail-') && manualReviewFlags[k]?.flagged).length} flagged
                      </span>
                    )}
                  </span>
                  <span>{salesDetailExpanded ? '▼' : '▶'}</span>
                </div>
                {salesDetailExpanded && (
                  <div className="p-3 bg-white">
                    <div className="text-xs text-gray-500 mb-2">
                      💡 Flag customers for follow-up and add notes - flagged items appear in Open Items tab
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs border-collapse">
                        <thead className="bg-slate-100">
                          <tr>
                            <th className="p-2 border text-left">Customer</th>
                            <th className="p-2 border text-center w-16">Contract</th>
                            <th className="p-2 border text-center w-20">Type</th>
                            <th className="p-2 border text-right w-24">{displayCustomerYearLabels.year3 || 'Year 3'}</th>
                            <th className="p-2 border text-right w-24">{displayCustomerYearLabels.year4 || 'Year 4'}</th>
                            <th className="p-2 border text-right w-24">{displayCustomerYearLabels.year5 || 'Year 5'}</th>
                            <th className="p-2 border text-right w-24 bg-blue-50">TTM</th>
                            <th className="p-2 border text-center w-16">Status</th>
                            <th className="p-2 border text-left" style={{minWidth: '200px'}}>Notes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerSalesData.filter(c => c.name || c.ttm || c.year5 || c.year4 || c.year3).map((customer, idx) => {
                            const noteKey = `sales-detail-${customer.id}`;
                            const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                            const isAtRisk = customer.atRisk;
                            // Use churnComparisonBase for consistent lost/new detection
                            const baseValue = customer[churnComparisonBase] || 0;
                            const isLost = baseValue > 0 && (customer.ttm || 0) === 0;
                            const isNew = baseValue === 0 && (customer.ttm || 0) > 0;
                            const hasDeclined = customer.ttm < baseValue * 0.8 && customer.ttm > 0 && baseValue > 0;
                            const customerName = customer.name || `Customer ${idx + 1}`;
                            
                            return (
                              <tr key={customer.id} className={`${isManuallyFlagged ? 'bg-purple-50' : isLost ? 'bg-red-50' : isAtRisk ? 'bg-amber-50' : isNew ? 'bg-green-50' : hasDeclined ? 'bg-orange-50' : ''}`}>
                                <td className="p-1 border font-medium">
                                  {customerName}
                                  {isLost && <span className="ml-1 text-red-600 text-xs">❌ Lost</span>}
                                  {isNew && <span className="ml-1 text-green-600 text-xs">✨ New</span>}
                                  {hasDeclined && !isLost && <span className="ml-1 text-orange-600 text-xs">📉 -20%+</span>}
                                </td>
                                <td className="p-1 border text-center">{customer.hasContract ? '✓' : '—'}</td>
                                <td className="p-1 border text-center text-xs">{customer.customerType || '—'}</td>
                                <td className="p-1 border text-right">{formatCurrency(customer.year3 || 0)}</td>
                                <td className="p-1 border text-right">{formatCurrency(customer.year4 || 0)}</td>
                                <td className="p-1 border text-right">{formatCurrency(customer.year5 || 0)}</td>
                                <td className={`p-1 border text-right font-medium ${isLost ? 'text-red-600' : 'bg-blue-50'}`}>{formatCurrency(customer.ttm || 0)}</td>
                                <td className={`p-1 border text-center text-xs font-medium ${customer.lost ? 'bg-red-100' : isAtRisk ? 'bg-amber-100' : ''}`}>
                                  {customer.lost ? <span className="text-red-600">❌ Lost</span> : isAtRisk ? <span className="text-amber-600">⚠️ At Risk</span> : <span className="text-gray-300">—</span>}
                                </td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={salesDetailNotes[noteKey]}
                                    onChange={(val) => setSalesDetailNotes(prev => ({...prev, [noteKey]: val}))}
                                    hasVariance={isLost || isAtRisk || hasDeclined}
                                    placeholder={isLost ? 'Why was customer lost?' : isAtRisk ? 'At risk reason...' : hasDeclined ? 'Explain revenue decline...' : ''}
                                    isFlagged={isManuallyFlagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev,
                                      [noteKey]: {
                                        ...prev[noteKey],
                                        flagged: !prev[noteKey]?.flagged,
                                        created: prev[noteKey]?.created || Date.now(),
                                        section: 'Sales Detail',
                                        item: `${customerName} (${formatCurrency(customer.ttm || 0)})`
                                      }
                                    }))}
                                    noteKey={noteKey}
                                    resolvedData={manualReviewFlags[noteKey]}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot className="bg-slate-200 font-semibold">
                          <tr>
                            <td className="p-2 border">TOTAL ({customerSalesData.filter(c => c.name || c.ttm || c.year5 || c.year4 || c.year3).length} customers)</td>
                            <td className="p-2 border"></td>
                            <td className="p-2 border"></td>
                            <td className="p-2 border text-right">{formatCurrency(customerSalesData.reduce((s, c) => s + (c.year3 || 0), 0))}</td>
                            <td className="p-2 border text-right">{formatCurrency(customerSalesData.reduce((s, c) => s + (c.year4 || 0), 0))}</td>
                            <td className="p-2 border text-right">{formatCurrency(customerSalesData.reduce((s, c) => s + (c.year5 || 0), 0))}</td>
                            <td className="p-2 border text-right bg-blue-100">{formatCurrency(customerSalesData.reduce((s, c) => s + (c.ttm || 0), 0))}</td>
                            <td className="p-2 border"></td>
                            <td className="p-2 border"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              );
            })()}

            {/* Calculated Metrics */}
            {(() => {
              const totals = { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0, ttm: 0 };
              customerSalesData.forEach(c => {
                totals.year1 += c.year1 || 0;
                totals.year2 += c.year2 || 0;
                totals.year3 += c.year3 || 0;
                totals.year4 += c.year4 || 0;
                totals.year5 += c.year5 || 0;
                totals.ttm += c.ttm || 0;
              });
              
              // Determine which period to use: TTM preferred, Year5 fallback
              const concentrationPeriod = totals.ttm > 0 ? 'ttm' : (totals.year5 > 0 ? 'year5' : 'ttm');
              const concentrationTotal = concentrationPeriod === 'ttm' ? totals.ttm : totals.year5;
              const concentrationSource = totals.ttm > 0 ? 'TTM' : (totals.year5 > 0 ? (displayCustomerYearLabels.year5 || 'Year5') : 'TTM');
              
              // Sort customers by concentration period revenue
              const sortedByConcentration = [...customerSalesData].sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0));
              const top1Pct = concentrationTotal > 0 ? ((sortedByConcentration[0]?.[concentrationPeriod] || 0) / concentrationTotal * 100) : 0;
              const top5Pct = concentrationTotal > 0 ? (sortedByConcentration.slice(0, 5).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / concentrationTotal * 100) : 0;
              const top10Pct = concentrationTotal > 0 ? (sortedByConcentration.slice(0, 10).reduce((s, c) => s + (c[concentrationPeriod] || 0), 0) / concentrationTotal * 100) : 0;
              
              // Retention calculation
              const calcRetention = (prevYear, currYear) => {
                const prevCustomers = customerSalesData.filter(c => (c[prevYear] || 0) > 0);
                const retainedRevenue = prevCustomers.reduce((s, c) => {
                  if (c.lost && currYear === 'ttm') return s;
                  return s + Math.min(c[prevYear] || 0, c[currYear] || 0);
                }, 0);
                const prevTotal = prevCustomers.reduce((s, c) => s + (c[prevYear] || 0), 0);
                return prevTotal > 0 ? (retainedRevenue / prevTotal * 100) : null;
              };
              
              const retention = {
                y1to2: calcRetention('year1', 'year2'),
                y2to3: calcRetention('year2', 'year3'),
                y3to4: calcRetention('year3', 'year4'),
                y4to5: calcRetention('year4', 'year5'),
                y5toTTM: calcRetention('year5', 'ttm')
              };
              
              const avgRetention = [retention.y3to4, retention.y4to5, retention.y5toTTM].filter(r => r !== null);
              const avg3YrRetention = avgRetention.length > 0 ? avgRetention.reduce((a, b) => a + b, 0) / avgRetention.length : null;
              
              // Lost and New customers - Smart detection: if Year5 ≈ TTM, compare to Year4
              const year5Total = totals.year5 || 0;
              const ttmTotal = totals.ttm || 0;
              const year4Total = totals.year4 || 0;
              const ttmEqualsYear5 = year5Total > 0 && ttmTotal > 0 && 
                (Math.abs(year5Total - ttmTotal) / Math.max(year5Total, ttmTotal) < 0.05 || year5Total === ttmTotal);
              const churnComparisonBase = ttmEqualsYear5 ? 'year4' : 'year5';
              const churnComparisonLabel = ttmEqualsYear5 ? (displayCustomerYearLabels.year4 || 'Year 4') : (displayCustomerYearLabels.year5 || 'Year 5');
              
              // Only consider customers with a name OR any meaningful revenue data
              const validCustomers = customerSalesData.filter(c => 
                c.name || (c.year3 || 0) > 0 || (c.year4 || 0) > 0 || (c.year5 || 0) > 0 || (c.ttm || 0) > 0
              );
              
              const lostCustomers = validCustomers.filter(c => {
                if (c.lost) return true; // Owner says lost → lost
                return (c[churnComparisonBase] || 0) > 0 && (c[concentrationPeriod] || 0) === 0;
              });
              const newCustomers = validCustomers.filter(c => !c.lost && (c[churnComparisonBase] || 0) === 0 && (c[concentrationPeriod] || 0) > 0);
              const lostRevenue = lostCustomers.reduce((s, c) => s + Math.max(c[churnComparisonBase] || 0, c[concentrationPeriod] || 0), 0);
              const newRevenue = newCustomers.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
              
              const currentBenchmarks = industryBenchmarks.find(i => i.id === selectedIndustry) || {};
              
              // Contract analysis
              // Remainder-aware + ask-set aware (top-20 fix): the split below
              // describes the clients WITH detail — the un-asked tail is
              // neither contracted nor month-to-month, it's un-asked.
              const customersWithRevenue = customerSalesData.filter(c => (c[concentrationPeriod] || 0) > 0 && !isRemainderRow(c));
              const customersWithTTM = customerSalesData.filter(c => (c.ttm || 0) > 0 && !isRemainderRow(c));
              const dSorted = [...customersWithRevenue].sort((a, b) => (b[concentrationPeriod] || 0) - (a[concentrationPeriod] || 0));
              const dAsk = customersWithRevenue.length <= 40 ? customersWithRevenue : dSorted.slice(0, 20);
              const dAskIds = new Set(dAsk.map(c => c.id));
              const dDetailed = [...dAsk, ...customersWithRevenue.filter(c => !dAskIds.has(c.id) && (c.hasContract === true || c.contractAnswered === true))];
              const contracted = dDetailed.filter(c => c.hasContract);
              const m2m = dDetailed.filter(c => !c.hasContract);
              const contractedRevenue = contracted.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
              const m2mRevenue = m2m.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
              const dDetailedRev = dDetailed.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
              const contractedPct = dDetailedRev > 0 ? (contractedRevenue / dDetailedRev * 100) : 0;
              const totalTTMRevenue = totals.ttm;
              
              // Customer segments
              const b2bClients = customersWithRevenue.filter(c => c.customerType === 'B2B');
              const nonProfitClients = customersWithRevenue.filter(c => c.customerType === 'Non-Profit');
              const governmentClients = customersWithRevenue.filter(c => c.customerType === 'Government');
              const residentialClients = customersWithRevenue.filter(c => c.customerType === 'Residential');
              const atRiskClients = customersWithRevenue.filter(c => c.atRisk);
              const atRiskRevenue = atRiskClients.reduce((s, c) => s + (c[concentrationPeriod] || 0), 0);
              
              return (
                <>
                  {/* Concentration Metrics */}
                  <div className="grid grid-cols-4 gap-3 mb-4">
                    <div className="bg-blue-50 p-3 rounded-lg border">
                      <div className="text-xs text-blue-600 font-semibold">Top Customer {concentrationSource !== 'TTM' ? `(${concentrationSource})` : ''}</div>
                      <div className={`text-2xl font-bold ${top1Pct > 25 ? 'text-red-600' : top1Pct > 15 ? 'text-yellow-600' : 'text-green-600'}`}>
                        {top1Pct.toFixed(1)}%
                      </div>
                      <div className="text-xs text-gray-500">{sortedByConcentration[0]?.name || '-'}</div>
                      {top1Pct > 20 && <div className="text-xs text-red-600 mt-1">⚠️ SBA concern &gt;20%</div>}
                    </div>
                    <div className="bg-blue-50 p-3 rounded-lg border">
                      <div className="text-xs text-blue-600 font-semibold">Top 5 Customers</div>
                      <div className={`text-2xl font-bold ${top5Pct > 60 ? 'text-red-600' : top5Pct > 40 ? 'text-yellow-600' : 'text-green-600'}`}>
                        {top5Pct.toFixed(1)}%
                      </div>
                      <div className="text-xs text-gray-500">of {concentrationSource} revenue</div>
                    </div>
                    <div className="bg-blue-50 p-3 rounded-lg border">
                      <div className="text-xs text-blue-600 font-semibold">Top 10 Customers</div>
                      <div className={`text-2xl font-bold ${top10Pct > 80 ? 'text-yellow-600' : 'text-green-600'}`}>
                        {top10Pct.toFixed(1)}%
                      </div>
                      <div className="text-xs text-gray-500">of {concentrationSource} revenue</div>
                    </div>
                    <div className="bg-slate-50 p-3 rounded-lg border">
                      <div className="text-xs text-purple-600 font-semibold">3yr Avg Retention</div>
                      <div className={`text-2xl font-bold ${avg3YrRetention === null ? 'text-gray-400' : avg3YrRetention >= (currentBenchmarks.customerRetentionRate || 90) ? 'text-green-600' : avg3YrRetention >= 80 ? 'text-yellow-600' : 'text-red-600'}`}>
                        {avg3YrRetention !== null ? `${avg3YrRetention.toFixed(1)}%` : 'N/A'}
                      </div>
                      <div className="text-xs text-gray-500">Benchmark: {currentBenchmarks.customerRetentionRate || 90}%</div>
                    </div>
                  </div>
                  
                  {/* TTM Churn Analysis */}
                  <div className="mb-4 p-3 bg-gray-50 rounded-lg border">
                    <h3 className="font-semibold text-gray-700 mb-1">TTM Customer Churn Analysis</h3>
                    <div className="text-xs text-gray-500 mb-3">
                      Comparing TTM to {churnComparisonLabel}
                      {ttmEqualsYear5 && <span className="ml-1 text-amber-600">(Year 5 = TTM detected, using Year 4 as baseline)</span>}
                    </div>
                    <div className="grid grid-cols-3 gap-3 mb-3">
                      <div className="bg-slate-100 p-3 rounded-lg border border-slate-300">
                        <div className="text-xs text-red-600 font-semibold">Lost Customers</div>
                        <div className="text-xs text-gray-400">{churnComparisonLabel} → {ttmLabel}</div>
                        <div className="text-xl font-bold text-red-700">{lostCustomers.length}</div>
                        <div className="text-xs text-gray-500">{formatCurrency(lostRevenue)} lost</div>
                        {lostCustomers.length > 0 && (
                          <div className="mt-2 pt-2 border-t border-slate-200">
                            <div className="text-xs text-gray-600 max-h-32 overflow-y-auto">
                              {lostCustomers.slice(0, 10).map((c, i) => (
                                <div key={i} className="flex justify-between items-center py-0.5" title={`${churnComparisonBase}=${formatCurrency(c[churnComparisonBase] || 0)}, TTM=${formatCurrency(c.ttm || 0)}${c.lost ? ' (Owner flagged)' : ' (Revenue detected)'}`}>
                                  <span className="truncate mr-2">
                                    {c.lost && <span className="text-red-400 mr-0.5" title="Owner flagged as Lost">⊘</span>}
                                    {c.name || `(unnamed row ${c.id})`}
                                  </span>
                                  <span className="text-red-600 whitespace-nowrap">
                                    {formatCurrency(Math.max(c[churnComparisonBase] || 0, c.ttm || 0))}
                                    {c.lost && (c.ttm || 0) > 0 && <span className="text-amber-500 ml-1" title="Still has TTM revenue">▲</span>}
                                  </span>
                                </div>
                              ))}
                              {lostCustomers.length > 10 && <div className="text-gray-400 text-center mt-1">...+{lostCustomers.length - 10} more</div>}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                        <div className="text-xs text-green-600 font-semibold">New Customers</div>
                        <div className="text-xs text-gray-400">{churnComparisonLabel} → {ttmLabel}</div>
                        <div className="text-xl font-bold text-green-700">{newCustomers.length}</div>
                        <div className="text-xs text-gray-500">{formatCurrency(newRevenue)} added</div>
                        {newCustomers.length > 0 && (
                          <div className="mt-2 pt-2 border-t border-blue-200">
                            <div className="text-xs text-gray-600 max-h-32 overflow-y-auto">
                              {newCustomers.slice(0, 10).map((c, i) => (
                                <div key={i} className="flex justify-between items-center py-0.5" title={`${churnComparisonBase}=${formatCurrency(c[churnComparisonBase] || 0)}, TTM=${formatCurrency(c.ttm || 0)}`}>
                                  <span className="truncate mr-2">{c.name || `(unnamed row ${c.id})`}</span>
                                  <span className="text-green-600 whitespace-nowrap">{formatCurrency(c.ttm || 0)}</span>
                                </div>
                              ))}
                              {newCustomers.length > 10 && <div className="text-gray-400 text-center mt-1">...+{newCustomers.length - 10} more</div>}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={`p-3 rounded-lg border ${newRevenue >= lostRevenue ? 'bg-blue-50 border-blue-200' : 'bg-amber-50 border-amber-200'}`}>
                        <div className="text-xs font-semibold" style={{color: newRevenue >= lostRevenue ? '#059669' : '#DC2626'}}>Net Change</div>
                        <div className="text-xl font-bold" style={{color: newRevenue >= lostRevenue ? '#047857' : '#B91C1C'}}>
                          {newRevenue >= lostRevenue ? '+' : ''}{formatCurrency(newRevenue - lostRevenue)}
                        </div>
                        <div className="text-xs text-gray-500">{newCustomers.length - lostCustomers.length >= 0 ? '+' : ''}{newCustomers.length - lostCustomers.length} customers</div>
                      </div>
                    </div>
                    
                    {/* Pro Forma Alert — lost clients still inflating TTM */}
                    {(() => {
                      const residualLost = lostCustomers.filter(c => c.lost && (c.ttm || c[concentrationPeriod] || 0) > 0);
                      const residualRev = residualLost.reduce((s, c) => s + (c.ttm || c[concentrationPeriod] || 0), 0);
                      if (residualLost.length === 0) return null;
                      return (
                        <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                              <span className="text-amber-600">⚠️</span>
                              <div className="text-sm">
                                <span className="font-semibold text-amber-800">Pro Forma Recommended: </span>
                                <span className="text-amber-700">
                                  {residualLost.length} lost client{residualLost.length !== 1 ? 's' : ''} still have <strong>{formatCurrency(residualRev)}</strong> in TTM — this revenue will roll off and should be projected forward
                                </span>
                              </div>
                            </div>
                            <button 
                              onClick={() => setViewMode('proforma')} 
                              className="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white text-xs rounded whitespace-nowrap"
                            >
                              Pro Forma →
                            </button>
                          </div>
                          <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-amber-700">
                            {residualLost.sort((a, b) => (b.ttm || 0) - (a.ttm || 0)).slice(0, 8).map((c, i) => (
                              <div key={i} className="flex justify-between">
                                <span className="truncate mr-2">{c.name || 'Unnamed'}</span>
                                <span className="font-medium">{formatCurrency(c.ttm || c[concentrationPeriod] || 0)}</span>
                              </div>
                            ))}
                            {residualLost.length > 8 && <div className="text-amber-500">+{residualLost.length - 8} more</div>}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                  
                  {/* 👥 CLIENT BASE (Zac/Mark 10-05, Concise: four screens gave 50+ / 33 / 42 / 38 and none said which
                      was "the" client count). One box, straight from the data: how many billed, how many bill every
                      month, how many of those are under contract — plus the funnel of what we asked the owner and
                      what they answered, and the gap lists by name. Display only; no value change. */}
                  {(() => {
                    const basis = valuationBasisForSales === 'cash' ? 'cash' : 'accrual';
                    const billed = customerSalesData.filter(c => (c.ttm || 0) > 0 && !isRemainderRow(c) && c.name && String(c.name).trim());
                    const monthsOf = (c) => { const m = monthlySalesData && monthlySalesData[String(c.id)]; const arr = m && (m[basis] || m.accrual || m.cash); return Array.isArray(arr) ? arr : null; };
                    const hasMonthly = billed.some(c => monthsOf(c));
                    const isMonthly = (c) => { const a = monthsOf(c); return !!a && a.length >= 12 && a.slice(-12).every(v => (Number(v) || 0) > 0); };
                    const monthly = hasMonthly ? billed.filter(isMonthly) : [];
                    const contracted = billed.filter(c => c.hasContract === true);
                    const both = monthly.filter(c => c.hasContract === true);
                    // What we asked: all billed clients if 40 or fewer, else top 20 in full detail + the rest one question.
                    const askAll = billed.length <= 40;
                    const fullN = askAll ? billed.length : 20;
                    const answered = billed.filter(c => c.hasContract === true || c.contractAnswered === true
                      || (c.contractMonths !== null && c.contractMonths !== undefined) || c.autoRenewal || c.assignable
                      || (c.industry && String(c.industry).trim()) || (c.tenure && parseFloat(c.tenure) > 0));
                    const formerTicked = customerSalesData.filter(c => c.hasContract === true && !((c.ttm || 0) > 0) && !isRemainderRow(c));
                    const monthlyNoContract = monthly.filter(c => c.hasContract !== true);
                    const contractNotMonthly = hasMonthly ? contracted.filter(c => !isMonthly(c)) : [];
                    const k = (n) => (n / 1000 >= 1 ? '$' + Math.round(n / 1000) + 'K' : '$' + Math.round(n));
                    const names = (arr) => arr.slice().sort((a, b) => (b.ttm || 0) - (a.ttm || 0)).map(c => `${c.name} ${k(c.ttm || 0)}`).join(' · ');
                    if (!billed.length) return null;
                    const Stat = ({ n, label, sub, tone }) => (
                      <div className={`p-2 rounded border ${tone}`}>
                        <div className="text-2xl font-bold text-gray-800">{n}</div>
                        <div className="text-xs font-semibold text-gray-700">{label}</div>
                        {sub && <div className="text-[11px] text-gray-500">{sub}</div>}
                      </div>
                    );
                    return (
                      <div className="p-3 bg-white rounded-lg border mb-4">
                        <h3 className="font-semibold text-gray-700 mb-2">👥 Client Base <span className="text-xs font-normal text-gray-400">— trailing 12 months, {basis} basis</span></h3>
                        <div className="grid grid-cols-3 gap-3 mb-2">
                          <Stat n={billed.length} label="Billed in the TTM" sub="any revenue in the last 12 months" tone="bg-gray-50 border-gray-200" />
                          <Stat n={hasMonthly ? monthly.length : '—'} label="Billing every month" sub={hasMonthly ? 'all 12 months on the monthly sales report' : 'monthly sales report not entered'} tone="bg-blue-50 border-blue-200" />
                          <Stat n={hasMonthly ? both.length : '—'} label="Under contract & billing monthly" sub="owner-reported contract + billed all 12 months" tone="bg-green-50 border-green-200" />
                        </div>
                        <div className="text-xs text-gray-700 mb-1">
                          <strong>{billed.length}</strong> clients billed → we asked the owner about <strong>{billed.length}</strong>
                          {askAll ? ' (all in full detail)' : ` (${fullN} in full detail, ${billed.length - fullN} one quick question)`}
                          {' '}→ they answered <strong>{answered.length}</strong> → marked <strong>{contracted.length}</strong> under contract
                          {billed.length - answered.length > 0 && <span className="text-amber-700"> · {billed.length - answered.length} left blank</span>}
                        </div>
                        <div className="space-y-0.5 text-[11px]">
                          {monthlyNoContract.length > 0 && <div className="text-amber-700"><strong>Bill every month, contract not marked ({monthlyNoContract.length}):</strong> {names(monthlyNoContract)} — confirm with the owner</div>}
                          {contractNotMonthly.length > 0 && <div className="text-amber-700"><strong>Marked under contract, not billing every month ({contractNotMonthly.length}):</strong> {names(contractNotMonthly)} — new this year, ended, or not billed monthly?</div>}
                          {formerTicked.length > 0 && <div className="text-gray-500"><strong>Ticked "under contract" but no revenue in the TTM ({formerTicked.length}):</strong> former clients — not counted anywhere above.</div>}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Contract Status & Customer Segments */}
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="p-3 bg-white rounded-lg border">
                      <h3 className="font-semibold text-gray-700 mb-3">Contract Status</h3>
                      <div className="grid grid-cols-2 gap-3">
                        <div className="bg-blue-50 p-2 rounded border border-blue-200">
                          <div className="text-xs text-green-600 font-semibold">Under Contract</div>
                          <div className="text-lg font-bold text-green-700">{contracted.length} clients</div>
                          <div className="text-xs text-gray-500">{formatCurrency(contractedRevenue)} ({contractedPct.toFixed(0)}% of detailed)</div>
                        </div>
                        <div className="bg-slate-50 p-2 rounded border border-slate-200">
                          <div className="text-xs text-yellow-600 font-semibold">Month-to-Month</div>
                          <div className="text-lg font-bold text-yellow-700">{m2m.length} clients</div>
                          <div className="text-xs text-gray-500">{formatCurrency(m2mRevenue)} ({(100-contractedPct).toFixed(0)}%)</div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 bg-white rounded-lg border">
                      <h3 className="font-semibold text-gray-700 mb-3">Customer Segments</h3>
                      <div className="grid grid-cols-4 gap-2">
                        <div className="bg-blue-50 p-2 rounded border border-blue-200">
                          <div className="text-xs text-blue-600 font-semibold" title="Counts toward B2B % in valuation">B2B</div>
                          <div className="text-lg font-bold text-blue-700">{b2bClients.length}</div>
                          <div className="text-xs text-gray-500">{formatCurrency(b2bClients.reduce((s,c) => s + (c.ttm||0), 0))}</div>
                        </div>
                        <div className="bg-green-50 p-2 rounded border border-green-200">
                          <div className="text-xs text-green-600 font-semibold" title="Counts toward B2B % in valuation">Non-Profit</div>
                          <div className="text-lg font-bold text-green-700">{nonProfitClients.length}</div>
                          <div className="text-xs text-gray-500">{formatCurrency(nonProfitClients.reduce((s,c) => s + (c.ttm||0), 0))}</div>
                        </div>
                        <div className="bg-amber-50 p-2 rounded border border-amber-200">
                          <div className="text-xs text-amber-600 font-semibold" title="Neutral impact on valuation">Government</div>
                          <div className="text-lg font-bold text-amber-700">{governmentClients.length}</div>
                          <div className="text-xs text-gray-500">{formatCurrency(governmentClients.reduce((s,c) => s + (c.ttm||0), 0))}</div>
                        </div>
                        <div className="bg-purple-50 p-2 rounded border border-purple-200">
                          <div className="text-xs text-purple-600 font-semibold" title="May reduce valuation multiple">Residential</div>
                          <div className="text-lg font-bold text-purple-700">{residentialClients.length}</div>
                          <div className="text-xs text-gray-500">{formatCurrency(residentialClients.reduce((s,c) => s + (c.ttm||0), 0))}</div>
                        </div>
                      </div>
                      {atRiskClients.length > 0 && (
                        <div className="mt-2 bg-amber-50 p-2 rounded border border-amber-200">
                          <div className="text-xs text-red-600 font-semibold">⚠️ At Risk</div>
                          <div className="text-lg font-bold text-red-700">{atRiskClients.length} clients</div>
                          <div className="text-xs text-gray-500">{formatCurrency(atRiskRevenue)} ({(atRiskRevenue / totalTTMRevenue * 100).toFixed(1)}%)</div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Industry Benchmarks */}
                  <div className="p-3 bg-blue-50 rounded-lg border border-blue-200 mb-4">
                    <h3 className="font-semibold text-blue-800 mb-2">Industry Benchmark Comparison ({currentBenchmarks.name || 'Selected Industry'})</h3>
                    <div className="grid grid-cols-4 gap-3 text-sm">
                      <div>
                        <div className="text-xs text-gray-600">Retention Rate</div>
                        <div className="font-medium">Your: {avg3YrRetention?.toFixed(1) || 'N/A'}%</div>
                        <div className="text-xs text-blue-600">Benchmark: {currentBenchmarks.customerRetentionRate || 90}%</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-600">Top Customer</div>
                        <div className="font-medium">Your: {top1Pct.toFixed(1)}%</div>
                        <div className="text-xs text-blue-600">Target: &lt;15%</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-600" title="% of clients with contracts">Clients Contracted</div>
                        <div className="font-medium">Your: {contractedPct.toFixed(0)}%</div>
                        <div className="text-xs text-blue-600">Target: &gt;70%</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-600">Active Clients</div>
                        <div className="font-medium">Your: {customersWithTTM.length}</div>
                        <div className="text-xs text-blue-600">More = Better diversification</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Revenue Reconciliation - P&L vs Customer Sales */}
                  <div className="border rounded-lg overflow-hidden mb-4">
                    <div className="px-3 py-2 font-bold flex items-center justify-between bg-purple-100">
                      <span className="flex items-center gap-2">
                        🔄 Revenue Reconciliation
                        {Object.keys(manualReviewFlags).filter(k => k.startsWith('rev-recon-') && manualReviewFlags[k]?.flagged).length > 0 && (
                          <span className="px-2 py-0.5 rounded-full bg-purple-200 text-purple-700 text-xs font-normal">
                            🚩 {Object.keys(manualReviewFlags).filter(k => k.startsWith('rev-recon-') && manualReviewFlags[k]?.flagged).length} flagged
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="p-3 bg-white">
                      <div className="text-xs text-gray-500 mb-3">
                        💡 Compare P&L revenue totals against Customer Sales totals. Variances exceeding threshold are highlighted.
                      </div>
                      
                      {/* Threshold controls */}
                      <div className="flex items-center gap-4 mb-3 p-2 bg-gray-50 rounded">
                        <div className="flex items-center gap-2">
                          <label className="text-xs font-medium">Variance Threshold:</label>
                          <input 
                            type="number" 
                            value={monthlyTtmConfig.reconVarianceThreshold || 5}
                            onChange={e => setMonthlyTtmConfig(prev => ({...prev, reconVarianceThreshold: Number(e.target.value)}))}
                            className="w-16 p-1 border rounded text-xs text-center"
                            min="1"
                            max="50"
                          />
                          <span className="text-xs text-gray-500">%</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="text-xs font-medium">Materiality:</label>
                          <span className="text-xs">$</span>
                          <input 
                            type="number" 
                            value={monthlyTtmConfig.reconMaterialityThreshold || 1000}
                            onChange={e => setMonthlyTtmConfig(prev => ({...prev, reconMaterialityThreshold: Number(e.target.value)}))}
                            className="w-20 p-1 border rounded text-xs text-center"
                            min="0"
                            step="500"
                          />
                        </div>
                      </div>
                      
                      {(() => {
                        const reconVarianceThreshold = monthlyTtmConfig.reconVarianceThreshold || 5;
                        const reconMaterialityThreshold = monthlyTtmConfig.reconMaterialityThreshold || 1000;
                        const years = ['year3', 'year4', 'year5', 'ttm'];
                        const yearHeaders = [displayCustomerYearLabels.year3 || 'Year 3', displayCustomerYearLabels.year4 || 'Year 4', displayCustomerYearLabels.year5 || 'Year 5', 'TTM'];
                        
                        // Get P&L totals for each basis
                        const getPlTotal = (basis, yr) => revenueCategories.reduce((sum, cat) => sum + (cat[basis]?.[yr] || 0), 0);
                        
                        const accrualTotals = years.map(yr => getPlTotal('accrual', yr));
                        const cashTotals = years.map(yr => getPlTotal('cash', yr));
                        // Use actual tax return totals (not P&L tax basis) - only year3-5, no TTM
                        const taxTotals = ['year3', 'year4', 'year5'].map(yr => taxReturnTotals?.revenue?.[yr] || 0);
                        const salesTotals = years.map(yr => totals[yr] || 0);
                        
                        // Calculate variances
                        const calcVariance = (plVal, salesVal) => {
                          if (plVal === 0 && salesVal === 0) return { pct: 0, amt: 0, show: false };
                          if (plVal === 0) return { pct: 100, amt: salesVal, show: true };
                          const pct = ((salesVal - plVal) / plVal) * 100;
                          const amt = salesVal - plVal;
                          const show = Math.abs(pct) >= reconVarianceThreshold && Math.abs(amt) >= reconMaterialityThreshold;
                          return { pct, amt, show };
                        };
                        
                        const accrualVariances = years.map((yr, i) => calcVariance(accrualTotals[i], salesTotals[i]));
                        const cashVariances = years.map((yr, i) => calcVariance(cashTotals[i], salesTotals[i]));
                        const taxVariances = ['year3', 'year4', 'year5'].map((yr, i) => calcVariance(taxTotals[i], salesTotals[i]));
                        
                        return (
                          <div className="overflow-x-auto">
                            <table className="w-full text-xs border-collapse">
                              <thead className="bg-slate-100">
                                <tr>
                                  <th className="p-2 border text-left" style={{minWidth: '140px'}}>Source</th>
                                  {yearHeaders.map((lbl, i) => (
                                    <th key={i} className={`p-2 border text-right ${i === 3 ? 'bg-blue-50' : ''}`} style={{minWidth: '90px'}}>{lbl}</th>
                                  ))}
                                  <th className="p-2 border text-left" style={{minWidth: '180px'}}>Notes</th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* Customer Sales Total - Reference Row */}
                                <tr className="bg-green-50 font-medium">
                                  <td className="p-2 border">Customer Sales</td>
                                  {salesTotals.map((val, i) => (
                                    <td key={i} className={`p-2 border text-right ${i === 3 ? 'bg-green-100' : ''}`}>{formatCurrency(val)}</td>
                                  ))}
                                  <td className="p-2 border text-gray-400 text-xs italic">Reference total</td>
                                </tr>
                                
                                {/* Accrual P&L */}
                                {(() => {
                                  const noteKey = 'rev-recon-accrual';
                                  const hasVariance = accrualVariances.some(v => v.show);
                                  const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                  return (
                                    <tr className={isManuallyFlagged ? 'bg-purple-50' : ''}>
                                      <td className="p-2 border font-medium">Accrual P&L</td>
                                      {accrualTotals.map((val, i) => (
                                        <td key={i} className={`p-2 border text-right ${accrualVariances[i].show ? 'bg-amber-100' : ''} ${i === 3 ? 'bg-blue-50' : ''}`}>
                                          {formatCurrency(val)}
                                          {accrualVariances[i].show && (
                                            <div className={`text-xs ${accrualVariances[i].pct > 0 ? 'text-green-600' : 'text-red-600'}`}>
                                              {accrualVariances[i].pct > 0 ? '+' : ''}{accrualVariances[i].pct.toFixed(1)}%
                                            </div>
                                          )}
                                        </td>
                                      ))}
                                      <td className="p-0 border">
                                        <ExpandableNotes
                                          value={monthlyTtmNotes[noteKey]}
                                          onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                          hasVariance={hasVariance}
                                          placeholder={hasVariance ? 'Explain variance...' : ''}
                                          isFlagged={isManuallyFlagged}
                                          onToggleFlag={() => setManualReviewFlags(prev => ({
                                            ...prev, 
                                            [noteKey]: { 
                                              ...prev[noteKey], 
                                              flagged: !prev[noteKey]?.flagged,
                                              created: prev[noteKey]?.created || Date.now(),
                                              section: 'Revenue Reconciliation',
                                              item: 'Accrual P&L vs Customer Sales'
                                            }
                                          }))}
                                          noteKey={noteKey}
                                          resolvedData={manualReviewFlags[noteKey]}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })()}
                                
                                {/* Cash P&L */}
                                {(() => {
                                  const noteKey = 'rev-recon-cash';
                                  const hasVariance = cashVariances.some(v => v.show);
                                  const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                  return (
                                    <tr className={isManuallyFlagged ? 'bg-purple-50' : ''}>
                                      <td className="p-2 border font-medium">Cash P&L</td>
                                      {cashTotals.map((val, i) => (
                                        <td key={i} className={`p-2 border text-right ${cashVariances[i].show ? 'bg-amber-100' : ''} ${i === 3 ? 'bg-blue-50' : ''}`}>
                                          {formatCurrency(val)}
                                          {cashVariances[i].show && (
                                            <div className={`text-xs ${cashVariances[i].pct > 0 ? 'text-green-600' : 'text-red-600'}`}>
                                              {cashVariances[i].pct > 0 ? '+' : ''}{cashVariances[i].pct.toFixed(1)}%
                                            </div>
                                          )}
                                        </td>
                                      ))}
                                      <td className="p-0 border">
                                        <ExpandableNotes
                                          value={monthlyTtmNotes[noteKey]}
                                          onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                          hasVariance={hasVariance}
                                          placeholder={hasVariance ? 'Explain variance...' : ''}
                                          isFlagged={isManuallyFlagged}
                                          onToggleFlag={() => setManualReviewFlags(prev => ({
                                            ...prev, 
                                            [noteKey]: { 
                                              ...prev[noteKey], 
                                              flagged: !prev[noteKey]?.flagged,
                                              created: prev[noteKey]?.created || Date.now(),
                                              section: 'Revenue Reconciliation',
                                              item: 'Cash P&L vs Customer Sales'
                                            }
                                          }))}
                                          noteKey={noteKey}
                                          resolvedData={manualReviewFlags[noteKey]}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })()}
                                
                                {/* Tax Return */}
                                {(() => {
                                  const noteKey = 'rev-recon-tax';
                                  const hasVariance = taxVariances.some(v => v.show);
                                  const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                                  return (
                                    <tr className={isManuallyFlagged ? 'bg-purple-50' : ''}>
                                      <td className="p-2 border font-medium">Tax Return</td>
                                      {taxTotals.map((val, i) => (
                                        <td key={i} className={`p-2 border text-right ${taxVariances[i].show ? 'bg-amber-100' : ''}`}>
                                          {formatCurrency(val)}
                                          {taxVariances[i].show && (
                                            <div className={`text-xs ${taxVariances[i].pct > 0 ? 'text-green-600' : 'text-red-600'}`}>
                                              {taxVariances[i].pct > 0 ? '+' : ''}{taxVariances[i].pct.toFixed(1)}%
                                            </div>
                                          )}
                                        </td>
                                      ))}
                                      <td className="p-2 border bg-gray-50 text-center text-gray-400">—</td>
                                      <td className="p-0 border">
                                        <ExpandableNotes
                                          value={monthlyTtmNotes[noteKey]}
                                          onChange={val => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                          hasVariance={hasVariance}
                                          placeholder={hasVariance ? 'Explain variance...' : ''}
                                          isFlagged={isManuallyFlagged}
                                          onToggleFlag={() => setManualReviewFlags(prev => ({
                                            ...prev, 
                                            [noteKey]: { 
                                              ...prev[noteKey], 
                                              flagged: !prev[noteKey]?.flagged,
                                              created: prev[noteKey]?.created || Date.now(),
                                              section: 'Revenue Reconciliation',
                                              item: 'Tax Return vs Customer Sales'
                                            }
                                          }))}
                                          noteKey={noteKey}
                                          resolvedData={manualReviewFlags[noteKey]}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })()}
                              </tbody>
                            </table>
                            
                            <div className="mt-2 text-xs text-gray-500">
                              Variance shown as (Customer Sales - P&L) / P&L. Positive = Sales higher than P&L. Cells highlighted when variance ≥{reconVarianceThreshold}% and ≥{formatCurrency(reconMaterialityThreshold)}.
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                  
                  {/* Sales Issues & Flags - Standardized Pattern */}
                  {(() => {
                    const salesIssues = [];
                    
                    // (P&L vs Sales variance now handled in Revenue Reconciliation section above)
                    
                    // Customer concentration warnings
                    if (top1Pct > 25) {
                      salesIssues.push({
                        key: 'concentration-top1-high',
                        type: 'Concentration Risk',
                        item: `Top customer: ${top1Pct.toFixed(1)}%`,
                        detail: `${sortedByConcentration[0]?.name || 'Top customer'} exceeds 25% threshold - significant key-man risk`,
                        severity: 'critical'
                      });
                    } else if (top1Pct > 20) {
                      salesIssues.push({
                        key: 'concentration-top1-sba',
                        type: 'SBA Concern',
                        item: `Top customer: ${top1Pct.toFixed(1)}%`,
                        detail: `Exceeds SBA 20% threshold - may require personal guarantee from customer`,
                        severity: 'warning'
                      });
                    }
                    
                    // Retention warnings (use keyMetrics for consistency with outstanding items)
                    if (keyMetrics.avgRetention !== null && keyMetrics.avgRetention < 80) {
                      salesIssues.push({
                        key: 'retention-low',
                        type: 'Retention Issue',
                        item: `3yr retention: ${keyMetrics.avgRetention.toFixed(1)}%`,
                        detail: `Below 80% benchmark - investigate churn causes`,
                        severity: keyMetrics.avgRetention < 70 ? 'critical' : 'warning'
                      });
                    }
                    
                    // At-risk customer warning
                    if (atRiskClients.length > 0) {
                      const atRiskPct = (atRiskRevenue / totalTTMRevenue * 100);
                      salesIssues.push({
                        key: 'at-risk-clients',
                        type: 'At Risk',
                        item: `${atRiskClients.length} at-risk clients`,
                        detail: `${formatCurrency(atRiskRevenue)} (${atRiskPct.toFixed(1)}%) revenue at risk`,
                        severity: atRiskPct > 10 ? 'critical' : 'warning'
                      });
                    }
                    
                    // Lost customer warning
                    if (lostCustomers.length > 0 && lostRevenue > totals.ttm * 0.05) {
                      salesIssues.push({
                        key: 'lost-clients',
                        type: 'Customer Loss',
                        item: `${lostCustomers.length} lost customers`,
                        detail: `${formatCurrency(lostRevenue)} revenue lost since prior year`,
                        severity: lostRevenue > totals.ttm * 0.1 ? 'critical' : 'warning'
                      });
                    }
                    
                    // Low contract coverage
                    if (contractedPct < 50 && customersWithTTM.length >= 5) {
                      salesIssues.push({
                        key: 'low-contract-coverage',
                        type: 'Contract Risk',
                        item: `Only ${contractedPct.toFixed(0)}% under contract`,
                        detail: `${m2m.length} clients on month-to-month - higher churn risk`,
                        severity: contractedPct < 30 ? 'critical' : 'warning'
                      });
                    }
                    
                    const unresolvedCount = salesIssues.filter(i => !custRevenueNotes[i.key]?.reviewed).length;
                    const resolvedCount = salesIssues.filter(i => custRevenueNotes[i.key]?.reviewed).length;
                    
                    return (
                      <div id="flags-salesanalysis" className="border rounded-lg overflow-hidden">
                        <div 
                          className={`px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 ${unresolvedCount > 0 ? 'bg-amber-100' : 'bg-slate-100'}`}
                          onClick={() => setSalesFlagsExpanded(!salesFlagsExpanded)}
                        >
                          <span>🚩 Issues & Flags ({unresolvedCount} unresolved{resolvedCount > 0 ? `, ${resolvedCount} resolved` : ''})</span>
                          <span>{salesFlagsExpanded ? '▼' : '▶'}</span>
                        </div>
                        {salesFlagsExpanded && (
                          <div className="p-3">
                            {salesIssues.length === 0 ? (
                              <div className="text-center text-gray-500 py-4">
                                <span className="text-green-600 font-medium">✓ No issues detected</span>
                              </div>
                            ) : (
                              <div className="space-y-2">
                                {salesIssues.map(issue => {
                                  const isResolved = custRevenueNotes[issue.key]?.reviewed;
                                  return (
                                    <div key={issue.key} id={`resolve-${issue.key}`} className={`p-3 rounded border ${isResolved ? 'bg-slate-50 border-slate-200 opacity-60' : 'bg-white border-amber-300'}`}>
                                      <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-2">
                                          <input 
                                            type="checkbox" 
                                            checked={isResolved || false}
                                            onChange={e => setCustRevenueNotes({...custRevenueNotes, [issue.key]: {...(custRevenueNotes[issue.key] || {}), reviewed: e.target.checked, reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''}})}
                                            className="w-4 h-4"
                                          />
                                          <span className={`text-xs px-2 py-0.5 rounded font-medium ${
                                            issue.severity === 'critical' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'
                                          }`}>{issue.type}</span>
                                          <span className={`font-medium ${isResolved ? 'line-through text-gray-400' : ''}`}>{issue.item}</span>
                                          {isResolved && <span className="text-green-600 text-xs font-medium">✓ Reviewed {custRevenueNotes[issue.key]?.reviewDate}</span>}
                                        </div>
                                      </div>
                                      <div className="text-xs text-gray-600 mb-2">{issue.detail}</div>
                                      <textarea 
                                        value={custRevenueNotes[issue.key]?.notes || ''}
                                        onChange={e => setCustRevenueNotes({...custRevenueNotes, [issue.key]: {...(custRevenueNotes[issue.key] || {}), notes: e.target.value}})}
                                        placeholder="Resolution notes (optional)..."
                                        className="w-full px-2 py-1 border rounded text-xs min-h-[32px]"
                                        rows={1}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </>
              );
            })()}
          {/* ===== TTM MONTHLY SALES ANALYSIS ===== */}
          {(() => {
            const hasMonthlySales = monthlySalesData && Object.keys(monthlySalesData).length > 0;
            if (!hasMonthlySales) return (
              <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200 text-center text-gray-500 text-sm">
                No TTM Monthly Sales data — paste from Data Entry → TTM Sales tab to enable trend analysis.
                <button onClick={() => setViewMode('salesmonthly')} className="ml-3 px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700">Go to TTM Sales →</button>
              </div>
            );

            const basis = salesTtmConfig?.basis || 'cash';
            const getMonthly = (c) => {
              const _m = monthlySalesData[String(c.id)];
              const m = (_m && !Array.isArray(_m)) ? (_m[basis] || []) : (_m || []);
              return (m && Array.isArray(m)) ? m.slice(0, 12) : Array(12).fill(0);
            };

            const customersWithMonthly = ttmBasisCustomers
              .filter(c => c.name && getMonthly(c).some(v => v !== 0))
              .sort((a, b) => {
                const aTotal = getMonthly(a).reduce((s, v) => s + v, 0);
                const bTotal = getMonthly(b).reduce((s, v) => s + v, 0);
                return bTotal - aTotal;
              });

            if (customersWithMonthly.length === 0) return null;

            const grandTotals = monthlySalesMonthLabels.map((_, mi) =>
              customersWithMonthly.reduce((s, c) => s + (getMonthly(c)[mi] || 0), 0)
            );
            const grandTtm = grandTotals.reduce((s, v) => s + v, 0);

            return (
              <div className="mt-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-base font-bold text-gray-800">📅 TTM Monthly Sales — Customer Detail</h3>
                  <div className="text-sm text-gray-500">{customersWithMonthly.length} customers · {monthlySalesMonthLabels[0]} – {monthlySalesMonthLabels[11]}</div>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full text-xs border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="text-left p-2 border font-medium w-40">Customer</th>
                        {monthlySalesMonthLabels.map((lbl, mi) => (
                          <th key={mi} className="text-right p-1 border font-medium whitespace-nowrap">{lbl}</th>
                        ))}
                        <th className="text-right p-2 border font-semibold bg-blue-50">TTM Total</th>
                        <th className="text-right p-2 border font-medium">vs Y5</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customersWithMonthly.slice(0, 30).map(c => {
                        const monthly = getMonthly(c);
                        const ttmTotal = monthly.reduce((s, v) => s + v, 0);
                        const y5 = c.year5 || 0;
                        const delta = y5 > 0 ? ((ttmTotal - y5) / y5 * 100) : null;
                        const hasGap = monthly.some((v, i) => i > 0 && i < 11 && v === 0 && monthly[i-1] > 0 && monthly[i+1] > 0);
                        const lastActive = (() => { for (let i = 11; i >= 0; i--) if (monthly[i] > 0) return i; return -1; })();
                        const rolledOff = lastActive >= 0 && lastActive < 10;

                        return (
                          <tr key={c.id} className={`hover:bg-gray-50 ${rolledOff ? 'bg-red-50' : ''}`}>
                            <td className="p-2 border font-medium truncate max-w-[160px]" title={c.name}>
                              {rolledOff && <span className="text-red-500 mr-1" title="Rolled off">⚠</span>}
                              {c.name}
                            </td>
                            {monthly.map((v, mi) => (
                              <td key={mi} className={`p-1 border text-right ${v === 0 ? 'text-gray-300' : v > 0 ? 'text-gray-800' : 'text-red-600'}`}>
                                {v !== 0 ? `$${Math.round(v).toLocaleString()}` : '—'}
                              </td>
                            ))}
                            <td className="p-2 border text-right font-semibold bg-blue-50">
                              ${Math.round(ttmTotal).toLocaleString()}
                            </td>
                            <td className={`p-2 border text-right text-xs ${delta === null ? 'text-gray-400' : delta > 10 ? 'text-green-600' : delta < -10 ? 'text-red-600' : 'text-gray-600'}`}>
                              {delta === null ? '—' : `${delta > 0 ? '+' : ''}${delta.toFixed(0)}%`}
                            </td>
                          </tr>
                        );
                      })}
                      {customersWithMonthly.length > 30 && (
                        <tr><td colSpan={15} className="p-2 border text-center text-gray-400 italic">...{customersWithMonthly.length - 30} more customers</td></tr>
                      )}
                      <tr className="font-bold bg-gray-100">
                        <td className="p-2 border">TOTAL</td>
                        {grandTotals.map((v, mi) => (
                          <td key={mi} className="p-1 border text-right">${Math.round(v).toLocaleString()}</td>
                        ))}
                        <td className="p-2 border text-right bg-blue-100">${Math.round(grandTtm).toLocaleString()}</td>
                        <td className="p-2 border"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Roll-off risk summary */}
                {(() => {
                  const rolledOff = customersWithMonthly.filter(c => {
                    const m = getMonthly(c);
                    const last = (() => { for (let i = 11; i >= 0; i--) if (m[i] > 0) return i; return -1; })();
                    return last >= 0 && last < 10;
                  });
                  if (rolledOff.length === 0) return null;
                  const rolledOffRev = rolledOff.reduce((s, c) => s + getMonthly(c).reduce((ss, v) => ss + v, 0), 0);
                  return (
                    <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <span className="font-semibold text-red-800">⚠ Roll-Off: </span>
                      <span className="text-red-700">{rolledOff.length} customer{rolledOff.length > 1 ? 's' : ''} stopped paying before month 11 — {rolledOff.map(c => c.name).join(', ')}</span>
                      <span className="text-red-600 ml-2 text-sm">(${Math.round(rolledOffRev).toLocaleString()} TTM revenue at risk)</span>
                    </div>
                  );
                })()}

                {/* Flag/note panel for TTM patterns */}
                {(() => {
                  const issues = [];
                  customersWithMonthly.forEach(c => {
                    const m = getMonthly(c);
                    const ttmTotal = m.reduce((s, v) => s + v, 0);
                    const y5 = c.year5 || 0;
                    const last = (() => { for (let i = 11; i >= 0; i--) if (m[i] > 0) return i; return -1; })();
                    const first = m.findIndex(v => v > 0);

                    if (last >= 0 && last < 10 && ttmTotal > 1000) {
                      issues.push({ key: `ttm-rolloff-${c.id}`, type: 'Roll-Off', severity: 'critical', item: c.name, detail: `Revenue stopped after month ${last + 1} (${monthlySalesMonthLabels[last]}) — $${Math.round(ttmTotal).toLocaleString()} TTM` });
                    }
                    if (first > 1 && ttmTotal > 1000) {
                      issues.push({ key: `ttm-newcust-${c.id}`, type: 'New Customer', severity: 'warning', item: c.name, detail: `First revenue in month ${first + 1} (${monthlySalesMonthLabels[first]}) — only ${12 - first} months of history` });
                    }
                    if (y5 > 2000 && ttmTotal > 0) {
                      const delta = (ttmTotal - y5) / y5;
                      if (delta < -0.25) issues.push({ key: `ttm-decline-${c.id}`, type: 'Revenue Decline', severity: delta < -0.5 ? 'critical' : 'warning', item: c.name, detail: `TTM $${Math.round(ttmTotal).toLocaleString()} vs Y5 $${Math.round(y5).toLocaleString()} (${(delta*100).toFixed(0)}%)` });
                    }
                  });

                  if (issues.length === 0) return (
                    <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700">✓ No significant TTM monthly sales issues detected.</div>
                  );

                  const unresolved = issues.filter(i => !custRevenueNotes[i.key]?.reviewed).length;
                  return (
                    <div className="mt-3">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="font-semibold text-gray-800">TTM Sales Issues</span>
                        {unresolved > 0 && <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded">{unresolved} unresolved</span>}
                      </div>
                      <div className="space-y-2">
                        {issues.map(issue => {
                          const isResolved = custRevenueNotes[issue.key]?.reviewed;
                          return (
                            <div key={issue.key} className={`p-3 rounded border ${isResolved ? 'bg-slate-50 border-slate-200 opacity-60' : 'bg-white border-amber-300'}`}>
                              <div className="flex items-center justify-between mb-1">
                                <div className="flex items-center gap-2">
                                  <input type="checkbox" checked={isResolved || false}
                                    onChange={e => setCustRevenueNotes({...custRevenueNotes, [issue.key]: {...(custRevenueNotes[issue.key] || {}), reviewed: e.target.checked, reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''}})}
                                    className="w-4 h-4" />
                                  <span className={`text-xs px-2 py-0.5 rounded font-medium ${issue.severity === 'critical' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>{issue.type}</span>
                                  <span className={`font-medium text-sm ${isResolved ? 'line-through text-gray-400' : ''}`}>{issue.item}</span>
                                  {isResolved && <span className="text-green-600 text-xs">✓ Reviewed {custRevenueNotes[issue.key]?.reviewDate}</span>}
                                </div>
                              </div>
                              <div className="text-xs text-gray-600 mb-1">{issue.detail}</div>
                              <textarea
                                value={custRevenueNotes[issue.key]?.notes || ''}
                                onChange={e => setCustRevenueNotes({...custRevenueNotes, [issue.key]: {...(custRevenueNotes[issue.key] || {}), notes: e.target.value}})}
                                placeholder="Resolution notes (optional)..."
                                className="w-full px-2 py-1 border rounded text-xs min-h-[28px]" rows={1}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
            );
          })()}
          </div>
        ) : viewMode === 'arapanalysis' ? (
          /* ========== AR/AP ANALYSIS ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold">📋 AR/AP Analysis</h2>
              <button 
                onClick={() => setViewMode('arap')}
                className="px-3 py-1 bg-gray-600 text-white text-sm rounded hover:bg-gray-700"
              >
                ← Back to Data Entry
              </button>
            </div>
            
            {/* Settings Row */}
            {!arReviewChecklist.notApplicable && (
              <div className="flex flex-wrap gap-3 mb-3 p-3 bg-gray-100 rounded-lg items-center">
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium">Materiality Threshold:</label>
                  <span className="text-sm">$</span>
                  <input 
                    type="number" 
                    value={arMaterialityThreshold} 
                    onChange={e => setArMaterialityThreshold(Number(e.target.value))}
                    className="w-20 p-1 border rounded text-sm text-center"
                    min="0"
                    step="500"
                  />
                </div>
                <div className="text-xs text-gray-500">
                  Individual accounts with balances in the last two aging columns above this threshold will be flagged
                </div>
              </div>
            )}
            
            {/* AR Aging Detail with Flag/Note Capability - At Top */}
            {!arReviewChecklist.notApplicable && arAgingLineItems.filter(item => item.customerName || item.current || item.days31to60 || item.days61to90 || item.days91to120 || item.days120plus).length > 0 && (
              <div className="border rounded-lg overflow-hidden mb-4">
                <div 
                  className="px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 bg-blue-100"
                  onClick={() => setArDetailExpanded(!arDetailExpanded)}
                >
                  <span className="flex items-center gap-2">
                    📋 AR Aging Detail
                    {arAgingData.reportDate && <span className="text-xs font-normal text-gray-600 ml-2">({arAgingData.reportDate})</span>}
                    {Object.keys(manualReviewFlags).filter(k => k.startsWith('ar-aging-') && manualReviewFlags[k]?.flagged).length > 0 && (
                      <span className="px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 text-xs font-normal">
                        🚩 {Object.keys(manualReviewFlags).filter(k => k.startsWith('ar-aging-') && manualReviewFlags[k]?.flagged).length} flagged
                      </span>
                    )}
                  </span>
                  <span>{arDetailExpanded ? '▼' : '▶'}</span>
                </div>
                {arDetailExpanded && (
                  <div className="p-3 bg-white">
                    <div className="text-xs text-gray-500 mb-2 p-2 bg-blue-50 rounded border border-blue-200">
                      <div className="font-medium text-gray-700 mb-1">📋 Line Item Review</div>
                      Flag individual accounts for follow-up - flagged items appear in Open Items.
                      <div className="mt-1 text-amber-700 font-medium">
                        ⚠️ Aggregate quality issues (negative balances, high past due %) automatically create Open Items and must be cleared in the <span className="underline">Issues & Flags section below</span>.
                      </div>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs border-collapse">
                        <thead className="bg-slate-100">
                          <tr>
                            <th className="p-2 border text-left">Customer/Invoice</th>
                            <th className="p-2 border text-right w-24">{arAgingBucketLabels.current}</th>
                            <th className="p-2 border text-right w-24">{arAgingBucketLabels.days31to60}</th>
                            <th className="p-2 border text-right w-24">{arAgingBucketLabels.days61to90}</th>
                            <th className="p-2 border text-right w-24">{arAgingBucketLabels.days91to120}</th>
                            <th className="p-2 border text-right w-24">{arAgingBucketLabels.days120plus}</th>
                            <th className="p-2 border text-right w-24 bg-blue-50">Total</th>
                            <th className="p-2 border text-left" style={{minWidth: '200px'}}>Notes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {arAgingLineItems.filter(item => item.customerName || item.current || item.days31to60 || item.days61to90 || item.days91to120 || item.days120plus).map((item, idx) => {
                            const lineTotal = (item.current || 0) + (item.days31to60 || 0) + (item.days61to90 || 0) + (item.days91to120 || 0) + (item.days120plus || 0);
                            const noteKey = `ar-aging-${item.id}`;
                            const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                            const hasOldAR = (item.days91to120 || 0) + (item.days120plus || 0) > 0;
                            const pastDue91Plus = (item.days91to120 || 0) + (item.days120plus || 0);
                            const significantlyPastDue = pastDue91Plus >= arMaterialityThreshold;
                            const hasNegative = lineTotal < 0;
                            const customerName = item.customerName || `Row ${idx + 1}`;
                            
                            return (
                              <tr key={item.id} className={`${isManuallyFlagged ? 'bg-purple-50' : hasNegative ? 'bg-red-50' : significantlyPastDue ? 'bg-amber-50' : ''}`}>
                                <td className="p-1 border font-medium">
                                  {customerName}
                                  {hasNegative && <span className="ml-1 text-red-600 text-xs">⚠️ Neg</span>}
                                  {significantlyPastDue && !hasNegative && <span className="ml-1 text-amber-600 text-xs">⏰ 91+</span>}
                                </td>
                                <td className="p-1 border text-right">{formatCurrency(item.current || 0)}</td>
                                <td className="p-1 border text-right">{formatCurrency(item.days31to60 || 0)}</td>
                                <td className="p-1 border text-right">{formatCurrency(item.days61to90 || 0)}</td>
                                <td className={`p-1 border text-right ${(item.days91to120 || 0) > 0 ? 'bg-amber-100 font-medium' : ''}`}>{formatCurrency(item.days91to120 || 0)}</td>
                                <td className={`p-1 border text-right ${(item.days120plus || 0) > 0 ? 'bg-red-100 font-medium' : ''}`}>{formatCurrency(item.days120plus || 0)}</td>
                                <td className={`p-1 border text-right font-medium ${hasNegative ? 'text-red-600' : 'bg-blue-50'}`}>{formatCurrency(lineTotal)}</td>
                                <td className="p-0 border">
                                  <ExpandableNotes
                                    value={arAgingNotes[noteKey]}
                                    onChange={(val) => setArAgingNotes(prev => ({...prev, [noteKey]: val}))}
                                    hasVariance={hasOldAR || hasNegative}
                                    placeholder={hasNegative ? 'Explain negative balance...' : hasOldAR ? 'Explain old AR...' : ''}
                                    isFlagged={isManuallyFlagged}
                                    onToggleFlag={() => setManualReviewFlags(prev => ({
                                      ...prev,
                                      [noteKey]: {
                                        ...prev[noteKey],
                                        flagged: !prev[noteKey]?.flagged,
                                        created: prev[noteKey]?.created || Date.now(),
                                        section: 'AR Aging',
                                        item: `${customerName} (${formatCurrency(lineTotal)})`
                                      }
                                    }))}
                                    noteKey={noteKey}
                                    resolvedData={manualReviewFlags[noteKey]}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot className="bg-slate-200 font-semibold">
                          <tr>
                            <td className="p-2 border">TOTAL</td>
                            <td className="p-2 border text-right">{formatCurrency(arAgingCalcs.current)}</td>
                            <td className="p-2 border text-right">{formatCurrency(arAgingCalcs.days31to60)}</td>
                            <td className="p-2 border text-right">{formatCurrency(arAgingCalcs.days61to90)}</td>
                            <td className="p-2 border text-right">{formatCurrency(arAgingCalcs.days91to120)}</td>
                            <td className="p-2 border text-right">{formatCurrency(arAgingCalcs.days120plus)}</td>
                            <td className="p-2 border text-right bg-blue-100">{formatCurrency(arAgingCalcs.totalAR)}</td>
                            <td className="p-2 border"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            )}
            
            {/* Benchmarks */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              <div className="p-3 bg-blue-50 rounded-lg border">
                <h3 className="font-semibold text-blue-800 mb-2">📊 AR Benchmarks</h3>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div><div className="text-gray-600">DSO</div><div className="font-medium">Target: 30-45 days</div></div>
                  <div><div className="text-gray-600">Past Due (31+)</div><div className="font-medium">Target: &lt;15%</div></div>
                  <div><div className="text-gray-600">91+ Days</div><div className="font-medium">Target: &lt;5%</div></div>
                  <div><div className="text-gray-600">120+ Days</div><div className="font-medium">Target: &lt;3%</div></div>
                </div>
              </div>
              <div className="p-3 bg-slate-100 rounded-lg border">
                <h3 className="font-semibold text-orange-800 mb-2">📊 AP Benchmarks</h3>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div><div className="text-gray-600">DPO</div><div className="font-medium">Normal: 30-45 days</div></div>
                  <div><div className="text-gray-600">Old Payables (91+)</div><div className="font-medium">Target: &lt;5%</div></div>
                  <div><div className="text-gray-600">DPO &gt; 60 days</div><div className="font-medium">⚠️ Cash stress</div></div>
                  <div><div className="text-gray-600">DSO vs DPO</div><div className="font-medium">DSO &lt; DPO = Good</div></div>
                </div>
              </div>
              <div className="p-3 bg-slate-50 rounded-lg border">
                <h3 className="font-semibold text-purple-800 mb-2">💰 Valuation Impact</h3>
                <div className="text-xs text-gray-700 space-y-1">
                  <p>• <strong>Multiple Engine:</strong> A/R & Collections Quality factor (G)</p>
                  <p>• <strong>Cash Cycle:</strong> DSO - DPO = cash needs</p>
                  <p>• <strong>EBITDA:</strong> Bad debt reserve if 120+ high</p>
                  <p>• <strong>Deal:</strong> Issues → holdback/escrow</p>
                </div>
              </div>
            </div>
            
            {/* AR/AP Metrics */}
            {!arReviewChecklist.notApplicable && (() => {
              const totalAR = arAgingCalcs.totalAR || 0;
              const pastDue = arAgingCalcs.pastDue || 0;
              const seriouslyPastDue = arAgingCalcs.seriouslyPastDue || 0;
              const pastDuePct = totalAR > 0 ? (pastDue / totalAR * 100) : 0;
              const seriouslyPastDuePct = totalAR > 0 ? (seriouslyPastDue / totalAR * 100) : 0;
              const days120PlusPct = totalAR > 0 ? ((arAgingCalcs.days120plus || 0) / totalAR * 100) : 0;
              
              const ttmRevenue = calculations.years[5]?.revenue || 0;
              const ttmCogs = calculations.years[5]?.cogs || 0;
              const ttmOpex = calculations.years[5]?.opex || 0;
              const ttmExpenses = ttmCogs + ttmOpex;
              
              const dso = ttmRevenue > 0 ? (totalAR / ttmRevenue * 365) : null;
              const arPctOfRevenue = ttmRevenue > 0 ? (totalAR / ttmRevenue * 100) : null;
              
              const totalAP = apAnalysis.trackingMode === 'tracked' ? apAgingCalcs.totalAP : 0;
              const dpo = ttmExpenses > 0 && totalAP > 0 ? (totalAP / ttmExpenses * 365) : null;
              const cashConversionCycle = (dso !== null && dpo !== null) ? (dso - dpo) : null;
              
              const safeToFixed = (num, digits = 1) => {
                if (num === null || num === undefined || isNaN(num)) return '0';
                return num.toFixed(digits);
              };
              
              return (
                <>
                  <div className="grid grid-cols-4 gap-3 mb-3">
                    <div className="bg-blue-50 p-3 rounded-lg border">
                      <div className="text-xs text-blue-600 font-semibold">Total AR</div>
                      <div className="text-xl font-bold text-blue-900">{formatCurrency(totalAR)}</div>
                      <div className="text-xs text-gray-500">{safeToFixed(arPctOfRevenue)}% of TTM Rev</div>
                    </div>
                    <div className={`p-3 rounded-lg border ${dso !== null && dso <= 45 ? 'bg-blue-50' : dso !== null && dso <= 60 ? 'bg-slate-50' : 'bg-amber-50'}`}>
                      <div className="text-xs font-semibold" style={{color: dso !== null && dso <= 45 ? '#059669' : dso !== null && dso <= 60 ? '#D97706' : '#DC2626'}}>DSO</div>
                      <div className="text-xl font-bold">{dso !== null ? `${safeToFixed(dso)} days` : 'N/A'}</div>
                      <div className="text-xs text-gray-500">Target: 30-45</div>
                    </div>
                    <div className={`p-3 rounded-lg border ${pastDuePct <= 15 ? 'bg-blue-50' : pastDuePct <= 25 ? 'bg-slate-50' : 'bg-amber-50'}`}>
                      <div className="text-xs font-semibold" style={{color: pastDuePct <= 15 ? '#059669' : pastDuePct <= 25 ? '#D97706' : '#DC2626'}}>AR Past Due (31+)</div>
                      <div className="text-xl font-bold">{safeToFixed(pastDuePct)}%</div>
                      <div className="text-xs text-gray-500">{formatCurrency(pastDue)}</div>
                    </div>
                    <div className={`p-3 rounded-lg border ${seriouslyPastDuePct <= 5 ? 'bg-blue-50' : seriouslyPastDuePct <= 10 ? 'bg-slate-50' : 'bg-amber-50'}`}>
                      <div className="text-xs font-semibold" style={{color: seriouslyPastDuePct <= 5 ? '#059669' : seriouslyPastDuePct <= 10 ? '#D97706' : '#DC2626'}}>AR 91+ Days</div>
                      <div className="text-xl font-bold">{safeToFixed(seriouslyPastDuePct)}%</div>
                      <div className="text-xs text-gray-500">{formatCurrency(seriouslyPastDue)}</div>
                    </div>
                  </div>
                  
                  {/* AP Metrics Row */}
                  {apAnalysis.trackingMode === 'tracked' && (
                    <div className="grid grid-cols-4 gap-3 mb-4">
                      <div className="bg-orange-50 p-3 rounded-lg border">
                        <div className="text-xs text-orange-600 font-semibold">Total AP</div>
                        <div className="text-xl font-bold text-orange-900">{formatCurrency(totalAP)}</div>
                        <div className="text-xs text-gray-500">{ttmExpenses > 0 ? `${safeToFixed(totalAP / ttmExpenses * 100)}% of expenses` : ''}</div>
                      </div>
                      <div className={`p-3 rounded-lg border ${dpo !== null && dpo <= 45 ? 'bg-blue-50' : dpo !== null && dpo <= 60 ? 'bg-slate-50' : 'bg-amber-50'}`}>
                        <div className="text-xs font-semibold" style={{color: dpo !== null && dpo <= 45 ? '#059669' : dpo !== null && dpo <= 60 ? '#D97706' : '#DC2626'}}>DPO</div>
                        <div className="text-xl font-bold">{dpo !== null ? `${safeToFixed(dpo)} days` : 'N/A'}</div>
                        <div className="text-xs text-gray-500">Target: 30-45</div>
                      </div>
                      <div className={`p-3 rounded-lg border ${(() => {
                        const oldPct = totalAP > 0 ? ((apAgingCalcs.oldPayables || 0) / totalAP * 100) : 0;
                        return oldPct <= 5 ? 'bg-blue-50' : oldPct <= 10 ? 'bg-slate-50' : 'bg-amber-50';
                      })()}`}>
                        <div className="text-xs font-semibold" style={{color: (() => {
                          const oldPct = totalAP > 0 ? ((apAgingCalcs.oldPayables || 0) / totalAP * 100) : 0;
                          return oldPct <= 5 ? '#059669' : oldPct <= 10 ? '#D97706' : '#DC2626';
                        })()}}>AP 91+ Days</div>
                        <div className="text-xl font-bold">{totalAP > 0 ? safeToFixed((apAgingCalcs.oldPayables || 0) / totalAP * 100) : '0'}%</div>
                        <div className="text-xs text-gray-500">{formatCurrency(apAgingCalcs.oldPayables || 0)}</div>
                      </div>
                      <div className={`p-3 rounded-lg border ${cashConversionCycle !== null && cashConversionCycle <= 0 ? 'bg-blue-50' : cashConversionCycle !== null && cashConversionCycle <= 30 ? 'bg-slate-50' : 'bg-amber-50'}`}>
                        <div className="text-xs font-semibold">Cash Cycle</div>
                        <div className="text-xl font-bold">{cashConversionCycle !== null ? `${safeToFixed(cashConversionCycle)} days` : 'N/A'}</div>
                        <div className="text-xs text-gray-500">DSO - DPO</div>
                      </div>
                    </div>
                  )}
                  
                  {/* Minimal AP display when not tracking */}
                  {apAnalysis.trackingMode !== 'tracked' && (
                    <div className="mb-4 p-3 bg-gray-50 rounded-lg border text-sm text-gray-600">
                      <span className="font-medium">AP not tracked</span> - Enable AP tracking on the Data Entry tab for DPO and cash cycle analysis.
                    </div>
                  )}
                  
                  {/* AR/AP Issues & Flags - Standardized Pattern */}
                  {(() => {
                    const arapIssues = [];
                    
                    // Negative balances - aggregate flag (line items shown with ⚠️ Neg icon)
                    if (arAgingCalcs.negativeBalances !== 0) {
                      arapIssues.push({
                        key: 'ar-negative-balances',
                        type: 'Negative Balance',
                        item: `Negative AR: ${formatCurrency(arAgingCalcs.negativeBalances)}`,
                        detail: `Potential unapplied credits, overpayments, or accounting errors - see ⚠️ Neg items above`,
                        severity: 'critical'
                      });
                    }
                    
                    // High DSO
                    if (dso !== null && dso > 60) {
                      arapIssues.push({
                        key: 'dso-high',
                        type: 'DSO Issue',
                        item: `DSO: ${safeToFixed(dso)} days`,
                        detail: `Exceeds 60-day threshold - indicates slow collections. Target: 30-45 days.`,
                        severity: dso > 90 ? 'critical' : 'warning'
                      });
                    }
                    
                    // High 120+ day balances (uses actual bucket label)
                    if (days120PlusPct > 3) {
                      const bucket5Label = arAgingBucketLabels?.days120plus || '120+';
                      arapIssues.push({
                        key: 'ar-120plus-high',
                        type: `${bucket5Label} Days`,
                        item: `${bucket5Label} day AR: ${safeToFixed(days120PlusPct)}%`,
                        detail: `${formatCurrency(arAgingCalcs.days120plus || 0)} may be uncollectible. Consider bad debt reserve adjustment.`,
                        severity: days120PlusPct > 10 ? 'critical' : 'warning'
                      });
                    }
                    
                    // High 91+ day balances (uses actual bucket labels for last 2 columns)
                    if (seriouslyPastDuePct > 10) {
                      const bucket4Label = arAgingBucketLabels?.days91to120 || '91-120';
                      const bucket5Label = arAgingBucketLabels?.days120plus || '120+';
                      const seriousLabel = `${bucket4Label.replace(/[^0-9]/g, '').split(/\d+/)[0] || ''}${bucket4Label.match(/\d+/)?.[0] || '91'}+`;
                      arapIssues.push({
                        key: 'ar-91plus-high',
                        type: `${seriousLabel} Days`,
                        item: `${seriousLabel} day AR: ${safeToFixed(seriouslyPastDuePct)}%`,
                        detail: `${formatCurrency(seriouslyPastDue)} seriously past due - investigate collection status`,
                        severity: seriouslyPastDuePct > 20 ? 'critical' : 'warning'
                      });
                    }
                    
                    // High past due overall (uses pastDueStartColumn label)
                    if (pastDuePct > 25) {
                      const startCol = arAgingBucketLabels?.pastDueStartColumn || 2;
                      const colLabels = ['', arAgingBucketLabels?.current || 'Current', arAgingBucketLabels?.days31to60 || '31-60', arAgingBucketLabels?.days61to90 || '61-90', arAgingBucketLabels?.days91to120 || '91-120', arAgingBucketLabels?.days120plus || '120+'];
                      const firstPastDueLabel = colLabels[startCol] || '31+';
                      const startDay = firstPastDueLabel.match(/\d+/)?.[0] || '31';
                      arapIssues.push({
                        key: 'ar-pastdue-high',
                        type: 'Past Due',
                        item: `Past due (${startDay}+): ${safeToFixed(pastDuePct)}%`,
                        detail: `${formatCurrency(pastDue)} past due exceeds 25% threshold`,
                        severity: pastDuePct > 40 ? 'critical' : 'warning'
                      });
                    }
                    
                    // Note: AR vs Balance Sheet reconciliation is now on the Reconciliation tab
                    
                    // High DPO (cash stress)
                    if (dpo !== null && dpo > 60) {
                      arapIssues.push({
                        key: 'dpo-high',
                        type: 'DPO Issue',
                        item: `DPO: ${safeToFixed(dpo)} days`,
                        detail: `High DPO may indicate cash flow stress or strained vendor relationships`,
                        severity: dpo > 90 ? 'critical' : 'warning'
                      });
                    }
                    
                    // Negative cash cycle (positive for business but notable)
                    if (cashConversionCycle !== null && cashConversionCycle > 45) {
                      arapIssues.push({
                        key: 'cash-cycle-long',
                        type: 'Cash Cycle',
                        item: `Cash cycle: ${safeToFixed(cashConversionCycle)} days`,
                        detail: `Long cash conversion cycle indicates working capital needs`,
                        severity: cashConversionCycle > 60 ? 'critical' : 'warning'
                      });
                    }
                    
                    // Note: Individual account issues (negative balances, 91+ days) are flagged inline 
                    // in the AR Aging Detail table with ⚠️ Neg and ⏰ 91+ icons
                    
                    const unresolvedCount = arapIssues.filter(i => !arReviewChecklist[i.key]?.reviewed).length;
                    const resolvedCount = arapIssues.filter(i => arReviewChecklist[i.key]?.reviewed).length;
                    
                    return (
                      <div className="border rounded-lg overflow-hidden mt-4">
                        <div 
                          className={`px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 ${unresolvedCount > 0 ? 'bg-amber-100' : 'bg-slate-100'}`}
                          onClick={() => setArapFlagsExpanded(!arapFlagsExpanded)}
                        >
                          <span>🚩 Issues & Flags ({unresolvedCount} unresolved{resolvedCount > 0 ? `, ${resolvedCount} resolved` : ''})</span>
                          <span>{arapFlagsExpanded ? '▼' : '▶'}</span>
                        </div>
                        {arapFlagsExpanded && (
                          <div className="p-3">
                            <div className="text-xs text-amber-700 mb-3 p-2 bg-amber-50 rounded border border-amber-200">
                              ⚠️ <span className="font-medium">These aggregate quality issues automatically create Open Items.</span> Check each item as reviewed to clear from Open Items. Individual line items can be flagged separately in the AR Aging Detail section above.
                            </div>
                            {arapIssues.length === 0 ? (
                              <div className="text-center text-gray-500 py-4">
                                <span className="text-green-600 font-medium">✓ No issues detected</span>
                              </div>
                            ) : (
                              <div className="space-y-2">
                                {arapIssues.map(issue => {
                                  const isResolved = arReviewChecklist[issue.key]?.reviewed;
                                  return (
                                    <div key={issue.key} className={`p-3 rounded border ${isResolved ? 'bg-slate-50 border-slate-200 opacity-60' : 'bg-white border-amber-300'}`}>
                                      <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-2">
                                          <input 
                                            type="checkbox" 
                                            checked={isResolved || false}
                                            onChange={e => setArReviewChecklist({...arReviewChecklist, [issue.key]: {...(arReviewChecklist[issue.key] || {}), reviewed: e.target.checked, reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''}})}
                                            className="w-4 h-4"
                                          />
                                          <span className={`text-xs px-2 py-0.5 rounded font-medium ${
                                            issue.severity === 'critical' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'
                                          }`}>{issue.type}</span>
                                          <span className={`font-medium ${isResolved ? 'line-through text-gray-400' : ''}`}>{issue.item}</span>
                                          {isResolved && <span className="text-green-600 text-xs font-medium">✓ Reviewed {arReviewChecklist[issue.key]?.reviewDate}</span>}
                                        </div>
                                      </div>
                                      <div className="text-xs text-gray-600 mb-2">{issue.detail}</div>
                                      <textarea 
                                        value={arReviewChecklist[issue.key]?.notes || ''}
                                        onChange={e => setArReviewChecklist({...arReviewChecklist, [issue.key]: {...(arReviewChecklist[issue.key] || {}), notes: e.target.value}})}
                                        placeholder="Resolution notes (optional)..."
                                        className="w-full px-2 py-1 border rounded text-xs min-h-[32px]"
                                        rows={1}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </>
              );
            })()}
            
            {/* AR Review Sign-off - Clears Open Items */}
            {!arReviewChecklist.notApplicable && arAgingLineItems.filter(item => item.customerName || item.current || item.days31to60 || item.days61to90 || item.days91to120 || item.days120plus).length > 0 && (
              <div className={`mt-4 p-3 rounded-lg border ${arReviewChecklist.reportReviewed ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'}`}>
                <div className="flex items-center justify-between">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input 
                      type="checkbox" 
                      checked={arReviewChecklist.reportReviewed || false}
                      onChange={e => setArReviewChecklist({
                        ...arReviewChecklist, 
                        reportReviewed: e.target.checked,
                        reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''
                      })}
                      className="w-4 h-4"
                    />
                    <span className="font-medium">AR Aging Review Complete</span>
                  </label>
                  <div className="flex items-center gap-3">
                    <input 
                      type="text"
                      placeholder="Reviewer"
                      value={arReviewChecklist.reviewedBy || ''}
                      onChange={e => setArReviewChecklist({...arReviewChecklist, reviewedBy: e.target.value})}
                      className="px-2 py-1 border rounded text-sm w-32"
                    />
                    {arReviewChecklist.reviewDate && (
                      <span className="text-xs text-gray-500">on {arReviewChecklist.reviewDate}</span>
                    )}
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Check this box to mark the AR aging review as complete and clear AR Quality items from Open Items.
                </p>
              </div>
            )}
            
            {arReviewChecklist.notApplicable && (
              <div className="p-4 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg">
                <div className="flex items-center gap-3">
                  <span className="text-2xl">🏪</span>
                  <div>
                    <div className="font-semibold text-gray-700">AR Aging Not Applicable</div>
                    <div className="text-sm text-gray-500">This business operates without accounts receivable (retail, cash-based, etc.)</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'reconciliation' ? (
          /* ========== RECONCILIATION - BASIS COMPARISON ========== */
          <div>
            <h2 className="text-lg font-bold mb-2">🔍 Basis Reconciliation</h2>
            <p className="text-sm text-gray-600 mb-3">Compare Sales vs P&L revenue, Cash vs Accrual P&L, and reconcile Tax Return to books.</p>
            
            {/* Settings Row */}
            <div className="flex flex-wrap gap-3 mb-3 p-3 bg-gray-100 rounded-lg items-center">
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium">Tax Filing Basis:</label>
                <span className="p-1 border rounded text-sm bg-white font-medium">{taxFilingBasis === 'cash' ? 'Cash' : 'Accrual'}</span>
              </div>
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium">Variance Threshold:</label>
                <input 
                  type="number" 
                  value={varianceThreshold} 
                  onChange={e => setVarianceThreshold(Number(e.target.value))}
                  className="w-16 p-1 border rounded text-sm text-center"
                  min="0"
                  max="100"
                />
                <span className="text-sm">%</span>
              </div>
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium">Materiality:</label>
                <span className="text-sm">$</span>
                <input 
                  type="number" 
                  value={reconMaterialityThreshold} 
                  onChange={e => setReconMaterialityThreshold(Number(e.target.value))}
                  className="w-20 p-1 border rounded text-sm text-center"
                  min="0"
                  step="100"
                />
              </div>
              <label className="flex items-center gap-1 text-sm">
                <input type="checkbox" checked={showAllYears} onChange={e => setShowAllYears(e.target.checked)} />
                Show All 5 Years
              </label>
            </div>

            {/* Year Sub-tabs */}
            <div className="flex border-b mb-4">
              {(showAllYears 
                ? ['year1', 'year2', 'year3', 'year4', 'year5', 'ttm']
                : ['year3', 'year4', 'year5', 'ttm']
              ).map(key => (
                <button key={key} onClick={() => setReconYearTab(key)} className={`px-4 py-2 text-sm font-medium ${reconYearTab === key ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600 hover:text-gray-900'}`}>
                  {key === 'ttm' ? ttmLabel : (basisYearLabels[key] || key.toUpperCase())}
                </button>
              ))}
            </div>

            {/* SECTION 1: Cash vs Accrual P&L Comparison */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div 
                className="bg-blue-100 px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:bg-blue-200"
                onClick={() => setReconCashVsAccrualExpanded(!reconCashVsAccrualExpanded)}
              >
                <span>📊 Cash vs Accrual P&L Comparison</span>
                <span className="text-lg">{reconCashVsAccrualExpanded ? '▼' : '▶'}</span>
              </div>
              {reconCashVsAccrualExpanded && (
              <div>
                <div className="text-xs p-3 bg-blue-50 border-b border-blue-200">
                  <div className="font-medium text-blue-800 mb-1">ℹ️ Why This Matters</div>
                  <span className="text-gray-600">Cash and Accrual P&L naturally differ due to timing (AR/AP, prepaid expenses, deferred revenue). </span>
                  <span className="text-amber-700 font-medium">Variances are expected at line level - amber highlighting shows items exceeding thresholds. If EBITDA variance exceeds 15%, a Quality of Earnings flag is auto-created.</span>
                </div>
              <table className="w-full text-xs">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="p-2 border text-left" style={{minWidth: '200px'}}>Line Item</th>
                    <th className="p-2 border text-center bg-blue-50 w-28">Cash</th>
                    <th className="p-2 border text-center bg-blue-50 w-28">Accrual</th>
                    <th className="p-2 border text-center w-28">Variance $</th>
                    <th className="p-2 border text-center w-20">Var %</th>
                    <th className="p-2 border text-center w-36">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {/* REVENUE Section */}
                  <tr className="bg-blue-100 font-bold"><td colSpan="6" className="p-2 border">REVENUE</td></tr>
                  {revenueCategories.filter(cat => cat.name).map(cat => {
                    const cashVal = cat.cash?.[reconYearTab] || 0;
                    const accrualVal = cat.accrual?.[reconYearTab] || 0;
                    const variance = accrualVal - cashVal;
                    const variancePct = cashVal !== 0 ? (variance / cashVal) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold && (cashVal !== 0 || accrualVal !== 0);
                    const noteKey = `recon-ca-rev-${cat.id}-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr key={cat.id} className={hasVariance ? 'bg-amber-50' : ''}>
                        <td className="p-2 border pl-4">{cat.name}</td>
                        <td className="p-2 border text-right bg-blue-50">{formatCurrency(cashVal)}</td>
                        <td className="p-2 border text-right bg-blue-50">{formatCurrency(accrualVal)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-slate-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: `Cash vs Accrual: ${cat.name}`
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {/* Revenue Total */}
                  {(() => {
                    const cashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const variance = accrualRev - cashRev;
                    const variancePct = cashRev !== 0 ? (variance / cashRev) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-ca-rev-total-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-blue-200 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">Total Revenue</td>
                        <td className="p-2 border text-right">{formatCurrency(cashRev)}</td>
                        <td className="p-2 border text-right">{formatCurrency(accrualRev)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-slate-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Cash vs Accrual: Total Revenue'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* COGS Section */}
                  <tr className="bg-slate-100 font-semibold"><td colSpan="6" className="p-1.5 border text-sm">COST OF GOODS SOLD</td></tr>
                  {cogsCategories.filter(cat => cat.name).map(cat => {
                    const cashVal = cat.cash?.[reconYearTab] || 0;
                    const accrualVal = cat.accrual?.[reconYearTab] || 0;
                    const variance = accrualVal - cashVal;
                    const variancePct = cashVal !== 0 ? (variance / cashVal) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold && (cashVal !== 0 || accrualVal !== 0);
                    const noteKey = `recon-ca-cogs-${cat.id}-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr key={cat.id} className={hasVariance ? 'bg-amber-50' : ''}>
                        <td className="p-2 border pl-4">{cat.name}</td>
                        <td className="p-2 border text-right bg-blue-50">{formatCurrency(cashVal)}</td>
                        <td className="p-2 border text-right bg-blue-50">{formatCurrency(accrualVal)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-slate-600' : 'text-blue-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: `Cash vs Accrual: ${cat.name}`
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {/* COGS Total */}
                  {(() => {
                    const cashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const variance = accrualCogs - cashCogs;
                    const variancePct = cashCogs !== 0 ? (variance / cashCogs) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-ca-cogs-total-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-slate-300 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">Total COGS</td>
                        <td className="p-2 border text-right">{formatCurrency(cashCogs)}</td>
                        <td className="p-2 border text-right">{formatCurrency(accrualCogs)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-slate-600' : 'text-blue-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Cash vs Accrual: Total COGS'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* GROSS PROFIT */}
                  {(() => {
                    const cashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashGP = cashRev - cashCogs;
                    const accrualGP = accrualRev - accrualCogs;
                    const variance = accrualGP - cashGP;
                    const variancePct = cashGP !== 0 ? (variance / cashGP) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-ca-gp-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-blue-100 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">GROSS PROFIT</td>
                        <td className="p-2 border text-right">{formatCurrency(cashGP)}</td>
                        <td className="p-2 border text-right">{formatCurrency(accrualGP)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-slate-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Cash vs Accrual: Gross Profit'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* OPEX Section */}
                  <tr className="bg-gray-200 font-bold"><td colSpan="6" className="p-2 border">OPERATING EXPENSES</td></tr>
                  {opexCategories.filter(cat => cat.name).map(cat => {
                    const cashVal = cat.cash?.[reconYearTab] || 0;
                    const accrualVal = cat.accrual?.[reconYearTab] || 0;
                    const variance = accrualVal - cashVal;
                    const variancePct = cashVal !== 0 ? (variance / cashVal) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold && (cashVal !== 0 || accrualVal !== 0);
                    const noteKey = `recon-ca-opex-${cat.id}-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr key={cat.id} className={hasVariance ? 'bg-amber-50' : ''}>
                        <td className="p-2 border pl-4">{cat.name}</td>
                        <td className="p-2 border text-right bg-blue-50">{formatCurrency(cashVal)}</td>
                        <td className="p-2 border text-right bg-blue-50">{formatCurrency(accrualVal)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-slate-600' : 'text-blue-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: `Cash vs Accrual: ${cat.name}`
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {/* OpEx Total */}
                  {(() => {
                    const cashOpex = opexCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualOpex = opexCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const variance = accrualOpex - cashOpex;
                    const variancePct = cashOpex !== 0 ? (variance / cashOpex) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-ca-opex-total-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-gray-300 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">Total OpEx</td>
                        <td className="p-2 border text-right">{formatCurrency(cashOpex)}</td>
                        <td className="p-2 border text-right">{formatCurrency(accrualOpex)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-slate-600' : 'text-blue-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Cash vs Accrual: Total OpEx'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* EBITDA - Key total with QoE flag */}
                  {(() => {
                    const cashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashOpex = opexCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualOpex = opexCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    // Add back D/I/A/T for true EBITDA
                    const cashDIAT = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                      sum + (diatCategories?.[key]?.cash?.[reconYearTab] || 0), 0);
                    const accrualDIAT = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                      sum + (diatCategories?.[key]?.accrual?.[reconYearTab] || 0), 0);
                    // Also add back DIAT items embedded in OpEx/OE
                    const diatKeywords = /depreci|interest|amortiz|income\s*tax|tax\s*expense/i;
                    const isDiatLine = (cat) => ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) || diatKeywords.test(cat.name || '');
                    const cashOpexDIAT = [...opexCategories, ...otherExpenseCategories].filter(cat => cat.name && isDiatLine(cat))
                      .reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualOpexDIAT = [...opexCategories, ...otherExpenseCategories].filter(cat => cat.name && isDiatLine(cat))
                      .reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashEbitda = cashRev - cashCogs - cashOpex + cashDIAT + cashOpexDIAT;
                    const accrualEbitda = accrualRev - accrualCogs - accrualOpex + accrualDIAT + accrualOpexDIAT;
                    const variance = accrualEbitda - cashEbitda;
                    const variancePct = cashEbitda !== 0 ? (variance / cashEbitda) * 100 : 0;
                    const hasQoEFlag = Math.abs(variancePct) > 15; // Fixed 15% threshold for EBITDA
                    const noteKey = `recon-ca-ebitda-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-green-100 font-bold ${hasQoEFlag ? 'bg-amber-200 border-l-4 border-amber-500' : ''}`}>
                        <td className="p-2 border">
                          EBITDA {hasQoEFlag && <span className="text-red-600 text-xs ml-1">(⚠️ QoE Flag: &gt;15%)</span>}
                        </td>
                        <td className="p-2 border text-right">{formatCurrency(cashEbitda)}</td>
                        <td className="p-2 border text-right">{formatCurrency(accrualEbitda)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-red-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasQoEFlag ? 'font-bold text-red-600' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasQoEFlag}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Cash vs Accrual: EBITDA'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* Other Income/Expense if present */}
                  {(otherIncomeCategories?.some(cat => cat.name && ((cat.cash?.[reconYearTab] || 0) !== 0 || (cat.accrual?.[reconYearTab] || 0) !== 0)) ||
                    otherExpenseCategories?.some(cat => cat.name && ((cat.cash?.[reconYearTab] || 0) !== 0 || (cat.accrual?.[reconYearTab] || 0) !== 0))) && (
                    <>
                      <tr className="bg-slate-200 font-semibold"><td colSpan="6" className="p-1.5 border text-sm">OTHER INCOME / EXPENSE</td></tr>
                      {otherIncomeCategories?.filter(cat => cat.name && ((cat.cash?.[reconYearTab] || 0) !== 0 || (cat.accrual?.[reconYearTab] || 0) !== 0)).map(cat => {
                        const cashVal = cat.cash?.[reconYearTab] || 0;
                        const accrualVal = cat.accrual?.[reconYearTab] || 0;
                        const variance = accrualVal - cashVal;
                        const variancePct = cashVal !== 0 ? (variance / cashVal) * 100 : 0;
                        const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                        const noteKey = `recon-ca-oi-${cat.id}-${reconYearTab}`;
                        const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                        return (
                          <tr key={cat.id} className={hasVariance ? 'bg-amber-50' : ''}>
                            <td className="p-2 border pl-4 text-green-700">{cat.name}</td>
                            <td className="p-2 border text-right">{formatCurrency(cashVal)}</td>
                            <td className="p-2 border text-right">{formatCurrency(accrualVal)}</td>
                            <td className="p-2 border text-right">{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                            <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                            <td className="p-0 border">
                              <ExpandableNotes
                                value={monthlyTtmNotes[noteKey]}
                                onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                hasVariance={hasVariance}
                                isFlagged={isManuallyFlagged}
                                onToggleFlag={() => setManualReviewFlags(prev => ({
                                  ...prev, 
                                  [noteKey]: { 
                                    ...prev[noteKey], 
                                    flagged: !prev[noteKey]?.flagged,
                                    created: prev[noteKey]?.created || Date.now(),
                                    section: 'Reconciliation',
                                    item: `Cash vs Accrual: ${cat.name}`
                                  }
                                }))}
                                noteKey={noteKey}
                                resolvedData={manualReviewFlags[noteKey]}
                              />
                            </td>
                          </tr>
                        );
                      })}
                      {otherExpenseCategories?.filter(cat => cat.name && ((cat.cash?.[reconYearTab] || 0) !== 0 || (cat.accrual?.[reconYearTab] || 0) !== 0)).map(cat => {
                        const cashVal = cat.cash?.[reconYearTab] || 0;
                        const accrualVal = cat.accrual?.[reconYearTab] || 0;
                        const variance = accrualVal - cashVal;
                        const variancePct = cashVal !== 0 ? (variance / cashVal) * 100 : 0;
                        const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                        const noteKey = `recon-ca-oe-${cat.id}-${reconYearTab}`;
                        const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                        return (
                          <tr key={cat.id} className={hasVariance ? 'bg-amber-50' : ''}>
                            <td className="p-2 border pl-4 text-red-700">{cat.name}</td>
                            <td className="p-2 border text-right">{formatCurrency(cashVal)}</td>
                            <td className="p-2 border text-right">{formatCurrency(accrualVal)}</td>
                            <td className="p-2 border text-right">{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                            <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                            <td className="p-0 border">
                              <ExpandableNotes
                                value={monthlyTtmNotes[noteKey]}
                                onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                hasVariance={hasVariance}
                                isFlagged={isManuallyFlagged}
                                onToggleFlag={() => setManualReviewFlags(prev => ({
                                  ...prev, 
                                  [noteKey]: { 
                                    ...prev[noteKey], 
                                    flagged: !prev[noteKey]?.flagged,
                                    created: prev[noteKey]?.created || Date.now(),
                                    section: 'Reconciliation',
                                    item: `Cash vs Accrual: ${cat.name}`
                                  }
                                }))}
                                noteKey={noteKey}
                                resolvedData={manualReviewFlags[noteKey]}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  )}

                  {/* NET INCOME */}
                  {(() => {
                    const cashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashOpex = opexCategories.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0);
                    const accrualOpex = opexCategories.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0);
                    const cashOI = otherIncomeCategories?.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0) || 0;
                    const accrualOI = otherIncomeCategories?.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0) || 0;
                    const cashOE = otherExpenseCategories?.reduce((sum, cat) => sum + (cat.cash?.[reconYearTab] || 0), 0) || 0;
                    const accrualOE = otherExpenseCategories?.reduce((sum, cat) => sum + (cat.accrual?.[reconYearTab] || 0), 0) || 0;
                    const cashNI = cashRev - cashCogs - cashOpex + cashOI - cashOE;
                    const accrualNI = accrualRev - accrualCogs - accrualOpex + accrualOI - accrualOE;
                    const variance = accrualNI - cashNI;
                    const variancePct = cashNI !== 0 ? (variance / cashNI) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-ca-ni-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-purple-100 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">NET INCOME</td>
                        <td className="p-2 border text-right">{formatCurrency(cashNI)}</td>
                        <td className="p-2 border text-right">{formatCurrency(accrualNI)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-red-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Cash vs Accrual: Net Income'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}
                </tbody>
              </table>
              </div>
              )}
            </div>
            {/* SECTION 2: Tax Return vs Filing Basis P&L */}
            {reconYearTab === 'ttm' ? (
              <div className="border rounded-lg overflow-hidden mb-4 bg-gray-50">
                <div 
                  className="bg-slate-200 px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:bg-slate-300"
                  onClick={() => setReconTaxVsPLExpanded(!reconTaxVsPLExpanded)}
                >
                  <span>📋 Tax Return vs {taxFilingBasis === 'cash' ? 'Cash' : 'Accrual'} P&L (Filing Basis)</span>
                  <span className="text-lg">{reconTaxVsPLExpanded ? '▼' : '▶'}</span>
                </div>
                {reconTaxVsPLExpanded && (
                <div className="p-4 text-center text-gray-600">
                  <p className="font-medium">Tax Return comparison not available for TTM</p>
                  <p className="text-sm mt-1">Tax returns are filed annually. Select a calendar year to compare Tax Return data to books.</p>
                </div>
                )}
              </div>
            ) : (
            <div className="border rounded-lg overflow-hidden mb-4">
              <div 
                className="bg-slate-200 px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:bg-slate-300"
                onClick={() => setReconTaxVsPLExpanded(!reconTaxVsPLExpanded)}
              >
                <span>📋 Tax Return vs {taxFilingBasis === 'cash' ? 'Cash' : 'Accrual'} P&L (Filing Basis)</span>
                <span className="text-lg">{reconTaxVsPLExpanded ? '▼' : '▶'}</span>
              </div>
              {reconTaxVsPLExpanded && (
              <div>
                <div className="text-xs p-3 bg-slate-50 border-b border-slate-200">
                  <div className="font-medium text-slate-800 mb-1">ℹ️ Why This Matters - CRITICAL FOR DUE DILIGENCE</div>
                  <span className="text-gray-600">Lenders and buyer accountants must reconcile tax returns to P&L before closing. </span>
                  <span className="text-red-700 font-medium">Net Income variance &gt;10% triggers Quality of Earnings flag. Common differences: depreciation methods, meals &amp; entertainment (50%), officer life insurance, Section 179.</span>
                </div>
              <table className="w-full text-xs">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="p-2 border text-left" style={{minWidth: '200px'}}>Line Item</th>
                    <th className="p-2 border text-center bg-slate-100 w-28">Tax Return</th>
                    <th className="p-2 border text-center w-28">{taxFilingBasis === 'cash' ? 'Cash P&L' : 'Accrual P&L'}</th>
                    <th className="p-2 border text-center w-28">Variance $</th>
                    <th className="p-2 border text-center w-20">Var %</th>
                    <th className="p-2 border text-center w-36">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {/* REVENUE Section - Total only (tax returns don't have line item detail) */}
                  <tr className="bg-blue-100 font-bold"><td colSpan="6" className="p-2 border">REVENUE</td></tr>
                  {(() => {
                    const taxRev = taxReturnTotals?.revenue?.[reconYearTab] || 0;
                    const basisRev = revenueCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const variance = taxRev - basisRev;
                    const variancePct = basisRev !== 0 ? (variance / basisRev) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-tax-rev-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-blue-200 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">Total Revenue</td>
                        <td className="p-2 border text-right">{formatCurrency(taxRev)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisRev)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-slate-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Tax vs P&L: Revenue'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* COGS Section */}
                  <tr className="bg-slate-100 font-semibold"><td colSpan="6" className="p-1.5 border text-sm">COST OF GOODS SOLD</td></tr>
                  {(() => {
                    const taxCogs = taxReturnTotals?.cogs?.[reconYearTab] || 0;
                    const basisCogs = cogsCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const variance = taxCogs - basisCogs;
                    const variancePct = basisCogs !== 0 ? (variance / basisCogs) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-tax-cogs-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-slate-300 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">Total COGS</td>
                        <td className="p-2 border text-right">{formatCurrency(taxCogs)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisCogs)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-slate-600' : 'text-blue-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Tax vs P&L: COGS'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* Gross Profit */}
                  {(() => {
                    const taxRev = taxReturnTotals?.revenue?.[reconYearTab] || 0;
                    const taxCogs = taxReturnTotals?.cogs?.[reconYearTab] || 0;
                    const taxGP = taxRev - taxCogs;
                    const basisRev = revenueCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisCogs = cogsCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisGP = basisRev - basisCogs;
                    const variance = taxGP - basisGP;
                    const variancePct = basisGP !== 0 ? (variance / basisGP) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-tax-gp-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-blue-100 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">GROSS PROFIT</td>
                        <td className="p-2 border text-right">{formatCurrency(taxGP)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisGP)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-slate-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Tax vs P&L: Gross Profit'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* Operating Expenses */}
                  <tr className="bg-gray-200 font-bold"><td colSpan="6" className="p-2 border">OPERATING EXPENSES</td></tr>
                  {(() => {
                    const taxExpenses = taxReturnTotals?.expenses?.[reconYearTab] || 0;
                    const basisExpenses = opexCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const variance = taxExpenses - basisExpenses;
                    const variancePct = basisExpenses !== 0 ? (variance / basisExpenses) * 100 : 0;
                    const hasVariance = Math.abs(variancePct) >= varianceThreshold && Math.abs(variance) >= reconMaterialityThreshold;
                    const noteKey = `recon-tax-opex-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-gray-300 font-bold ${hasVariance ? 'bg-amber-100' : ''}`}>
                        <td className="p-2 border">Total Operating Expenses</td>
                        <td className="p-2 border text-right">{formatCurrency(taxExpenses)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisExpenses)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-slate-600' : 'text-blue-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasVariance ? 'font-bold text-amber-700' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasVariance}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Tax vs P&L: Operating Expenses'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* Net Income - Critical for QoE */}
                  {(() => {
                    const taxRev = taxReturnTotals?.revenue?.[reconYearTab] || 0;
                    const taxCogs = taxReturnTotals?.cogs?.[reconYearTab] || 0;
                    const taxExpenses = taxReturnTotals?.expenses?.[reconYearTab] || 0;
                    // Tax OI/OE from category-level tax data (Form 1120 lines 4-9 Other Income)
                    const taxOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat.tax?.[reconYearTab] || 0), 0);
                    const taxOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat.tax?.[reconYearTab] || 0), 0);
                    const taxNI = taxRev - taxCogs - taxExpenses + taxOI - taxOE;
                    const basisRev = revenueCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisCogs = cogsCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisOpex = opexCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    // P&L includes DIAT, Other Income, Other Expense
                    const basisDiat = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                      sum + (diatCategories?.[key]?.[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[reconYearTab] || 0), 0);
                    const basisNI = basisRev - basisCogs - basisOpex - basisDiat + basisOI - basisOE;
                    const variance = taxNI - basisNI;
                    const variancePct = basisNI !== 0 ? (variance / basisNI) * 100 : 0;
                    const hasQoEFlag = Math.abs(variancePct) > 10; // Fixed 10% threshold for Tax vs P&L
                    const noteKey = `recon-tax-ni-${reconYearTab}`;
                    const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                    return (
                      <tr className={`bg-purple-100 font-bold ${hasQoEFlag ? 'bg-amber-200 border-l-4 border-amber-500' : ''}`}>
                        <td className="p-2 border">
                          NET INCOME {hasQoEFlag && <span className="text-red-600 text-xs ml-1">(⚠️ QoE Flag: &gt;10%)</span>}
                        </td>
                        <td className="p-2 border text-right">{formatCurrency(taxNI)}</td>
                        <td className="p-2 border text-right">{formatCurrency(basisNI)}</td>
                        <td className={`p-2 border text-right ${variance !== 0 ? (variance > 0 ? 'text-blue-600' : 'text-red-600') : ''}`}>{variance !== 0 ? formatCurrency(variance) : '-'}</td>
                        <td className={`p-2 border text-right ${hasQoEFlag ? 'font-bold text-red-600' : ''}`}>{variancePct !== 0 ? variancePct.toFixed(1) + '%' : '-'}</td>
                        <td className="p-0 border">
                          <ExpandableNotes
                            value={monthlyTtmNotes[noteKey]}
                            onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                            hasVariance={hasQoEFlag}
                            isFlagged={isManuallyFlagged}
                            onToggleFlag={() => setManualReviewFlags(prev => ({
                              ...prev, 
                              [noteKey]: { 
                                ...prev[noteKey], 
                                flagged: !prev[noteKey]?.flagged,
                                created: prev[noteKey]?.created || Date.now(),
                                section: 'Reconciliation',
                                item: 'Tax vs P&L: Net Income'
                              }
                            }))}
                            noteKey={noteKey}
                            resolvedData={manualReviewFlags[noteKey]}
                          />
                        </td>
                      </tr>
                    );
                  })()}
                </tbody>
              </table>
              </div>
              )}
            </div>
            )}

            {/* SECTION 2B: Schedule M-1 Book-to-Tax Reconciliation */}
            {reconYearTab !== 'ttm' && reconYearTab !== 'ytd' && (
            <div className="border rounded-lg overflow-hidden mb-4 ml-4">
              <div 
                className="bg-slate-100 px-3 py-2 font-semibold flex items-center justify-between cursor-pointer hover:bg-slate-200"
                onClick={() => setReconM1Expanded(!reconM1Expanded)}
              >
                <span>📑 Schedule M-1: Book-to-Tax Adjustments</span>
                <span className="text-lg">{reconM1Expanded ? '▼' : '▶'}</span>
              </div>
              {reconM1Expanded && (() => {
                const yearKey = reconYearTab;
                const m1Data = scheduleM1[yearKey] || {};
                
                // Calculate totals
                const m1Items = [
                  { key: 'mealsEntertainment', label: 'Meals & Entertainment (50% non-deductible)', typical: 'Expense on books, 50% added back for tax' },
                  { key: 'depreciation', label: 'Depreciation Difference', typical: 'Different methods/lives for book vs tax' },
                  { key: 'badDebt', label: 'Bad Debt Expense', typical: 'Timing difference - tax uses direct write-off' },
                  { key: 'officerLifeInsurance', label: 'Officer Life Insurance', typical: '100% non-deductible for tax' },
                  { key: 'finesPenalties', label: 'Fines & Penalties', typical: '100% non-deductible for tax' },
                  { key: 'taxExemptInterest', label: 'Tax-Exempt Interest Income', typical: 'Income on books, excluded from tax' },
                  { key: 'section179', label: 'Section 179 Depreciation', typical: 'Accelerated deduction for tax' },
                  { key: 'other1', label: m1Data.other1?.description || 'Other Adjustment 1', isOther: true },
                  { key: 'other2', label: m1Data.other2?.description || 'Other Adjustment 2', isOther: true }
                ];
                
                const totalBookAdj = m1Items.reduce((sum, item) => sum + (m1Data[item.key]?.book || 0), 0);
                const totalTaxAdj = m1Items.reduce((sum, item) => sum + (m1Data[item.key]?.tax || 0), 0);
                const netAdjustment = totalTaxAdj - totalBookAdj;
                
                // Get P&L and Tax NI for comparison
                const taxRev = taxReturnTotals?.revenue?.[yearKey] || 0;
                const taxCogs = taxReturnTotals?.cogs?.[yearKey] || 0;
                const taxExpenses = taxReturnTotals?.expenses?.[yearKey] || 0;
                const m1TaxOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat.tax?.[yearKey] || 0), 0);
                const m1TaxOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat.tax?.[yearKey] || 0), 0);
                const taxNI = taxRev - taxCogs - taxExpenses + m1TaxOI - m1TaxOE;
                
                const basisRev = revenueCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[yearKey] || 0), 0);
                const basisCogs = cogsCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[yearKey] || 0), 0);
                const basisOpex = opexCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[yearKey] || 0), 0);
                const m1BasisDiat = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                  sum + (diatCategories?.[key]?.[taxFilingBasis]?.[yearKey] || 0), 0);
                const m1BasisOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat?.[taxFilingBasis]?.[yearKey] || 0), 0);
                const m1BasisOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat?.[taxFilingBasis]?.[yearKey] || 0), 0);
                const bookNI = basisRev - basisCogs - basisOpex - m1BasisDiat + m1BasisOI - m1BasisOE;
                
                const actualVariance = taxNI - bookNI;
                const unexplainedVariance = actualVariance - netAdjustment;
                const isReconciled = Math.abs(unexplainedVariance) < 100; // Within $100 is considered reconciled
                
                const updateM1 = (itemKey, field, value) => {
                  setScheduleM1(prev => ({
                    ...prev,
                    [yearKey]: {
                      ...prev[yearKey],
                      [itemKey]: {
                        ...prev[yearKey]?.[itemKey],
                        [field]: field === 'notes' || field === 'description' ? value : parseFloat(value) || 0
                      }
                    }
                  }));
                };
                
                return (
                  <div className="p-3 bg-white">
                    <div className="text-xs p-3 mb-3 bg-slate-50 rounded border border-slate-200">
                      <div className="font-bold text-slate-800 mb-2">📑 Schedule M-1: Book-to-Tax Reconciliation</div>
                      
                      <div className="mb-2">
                        <span className="font-semibold text-slate-700">Purpose: </span>
                        <span className="text-gray-600">When the Tax Return vs P&L section shows a variance in Net Income, this doesn't necessarily indicate a problem. Book income (P&L) and taxable income (Tax Return) legitimately differ due to tax code rules. Schedule M-1 documents these known differences to prove the books and tax return are properly reconciled.</span>
                      </div>
                      
                      <div className="mb-2">
                        <span className="font-semibold text-slate-700">Why It Matters for M&A: </span>
                        <span className="text-gray-600">Buyer accountants and lenders will scrutinize this reconciliation during due diligence. A fully reconciled M-1 demonstrates financial statement integrity. Unexplained variances raise red flags about potential unreported income or questionable deductions.</span>
                      </div>
                      
                      <div className="mb-2 p-2 bg-blue-50 rounded border border-blue-200">
                        <div className="font-semibold text-blue-800 mb-1">How to Use This Section:</div>
                        <ol className="text-gray-700 list-decimal list-inside space-y-1">
                          <li><strong>Review the variance</strong> in Tax vs P&L section above - note the Net Income difference</li>
                          <li><strong>Obtain Schedule M-1</strong> from the business's tax return (Form 1120/1120S) or ask the CPA</li>
                          <li><strong>Enter each adjustment</strong> - Book Amount is what's on the P&L, Tax Amount is what's on the return</li>
                          <li><strong>Check reconciliation</strong> - when M-1 adjustments explain the variance, the "Unexplained" box turns green</li>
                          <li><strong>Document in Notes</strong> - add explanations for each material adjustment</li>
                          <li><strong>Save as usual</strong> - entries here save with the deal (the Save button or the 60-second autosave) and will be here when you come back. Fill each year's column once; this is reference material for diligence — it documents the variance, it never changes the valuation math.</li>
                        </ol>
                      </div>
                      
                      <div className="text-gray-500 italic">
                        Common M-1 items: Meals (50% non-deductible), Officer Life Insurance (100% non-deductible), Depreciation differences (Section 179, bonus depreciation), State taxes, Penalties/fines.
                      </div>
                    </div>
                    
                    {/* Summary Cards */}
                    <div className="grid grid-cols-5 gap-2 mb-3 text-xs">
                      <div className="p-2 bg-blue-50 rounded border text-center">
                        <div className="text-blue-600 font-semibold">Book Net Income</div>
                        <div className="text-lg font-bold">{formatCurrency(bookNI)}</div>
                      </div>
                      <div className="p-2 bg-slate-100 rounded border text-center">
                        <div className="text-slate-600 font-semibold">M-1 Adjustments</div>
                        <div className={`text-lg font-bold ${netAdjustment > 0 ? 'text-green-600' : netAdjustment < 0 ? 'text-red-600' : ''}`}>
                          {netAdjustment >= 0 ? '+' : ''}{formatCurrency(netAdjustment)}
                        </div>
                      </div>
                      <div className="p-2 bg-purple-50 rounded border text-center">
                        <div className="text-purple-600 font-semibold">Expected Tax NI</div>
                        <div className="text-lg font-bold">{formatCurrency(bookNI + netAdjustment)}</div>
                      </div>
                      <div className="p-2 bg-slate-200 rounded border text-center">
                        <div className="text-slate-700 font-semibold">Actual Tax NI</div>
                        <div className="text-lg font-bold">{formatCurrency(taxNI)}</div>
                      </div>
                      <div className={`p-2 rounded border text-center ${isReconciled ? 'bg-green-100 border-green-300' : 'bg-amber-100 border-amber-300'}`}>
                        <div className={`font-semibold ${isReconciled ? 'text-green-700' : 'text-amber-700'}`}>Unexplained</div>
                        <div className={`text-lg font-bold ${isReconciled ? 'text-green-600' : 'text-red-600'}`}>
                          {formatCurrency(unexplainedVariance)}
                        </div>
                      </div>
                    </div>
                    
                    {isReconciled ? (
                      <div className="p-2 bg-green-100 rounded border border-green-300 text-xs text-green-800 mb-3">
                        <span className="font-bold">✅ Reconciled:</span> M-1 adjustments explain the book-to-tax variance.
                      </div>
                    ) : (
                      <div className="p-2 bg-amber-100 rounded border border-amber-300 text-xs text-amber-800 mb-3">
                        <span className="font-bold">⚠️ Not Reconciled:</span> {formatCurrency(Math.abs(unexplainedVariance))} variance remains unexplained. Review entries or add additional adjustments.
                      </div>
                    )}
                    
                    {/* M-1 Items Table */}
                    <table className="w-full text-xs">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="p-2 border text-left" style={{minWidth: '200px'}}>Adjustment Item</th>
                          <th className="p-2 border text-center w-28">Book Amount</th>
                          <th className="p-2 border text-center w-28">Tax Amount</th>
                          <th className="p-2 border text-center w-28">Difference</th>
                          <th className="p-2 border text-left">Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {m1Items.map(item => {
                          const data = m1Data[item.key] || { book: 0, tax: 0, notes: '' };
                          const diff = (data.tax || 0) - (data.book || 0);
                          const hasEntry = data.book !== 0 || data.tax !== 0;
                          return (
                            <tr key={item.key} className={hasEntry ? 'bg-blue-50' : ''}>
                              <td className="p-2 border">
                                {item.isOther ? (
                                  <input
                                    type="text"
                                    value={data.description || ''}
                                    onChange={e => updateM1(item.key, 'description', e.target.value)}
                                    className="w-full p-1 text-xs border rounded"
                                    placeholder="Other adjustment description..."
                                  />
                                ) : (
                                  <div>
                                    <div className="font-medium">{item.label}</div>
                                    <div className="text-gray-500 text-xs">{item.typical}</div>
                                  </div>
                                )}
                              </td>
                              <td className="p-1 border">
                                <input
                                  type="number"
                                  value={data.book || ''}
                                  onChange={e => updateM1(item.key, 'book', e.target.value)}
                                  className="w-full p-1 text-xs border rounded text-right"
                                  placeholder="0"
                                />
                              </td>
                              <td className="p-1 border">
                                <input
                                  type="number"
                                  value={data.tax || ''}
                                  onChange={e => updateM1(item.key, 'tax', e.target.value)}
                                  className="w-full p-1 text-xs border rounded text-right"
                                  placeholder="0"
                                />
                              </td>
                              <td className={`p-2 border text-right font-medium ${diff > 0 ? 'text-green-600' : diff < 0 ? 'text-red-600' : 'text-gray-400'}`}>
                                {diff !== 0 ? (diff > 0 ? '+' : '') + formatCurrency(diff) : '-'}
                              </td>
                              <td className="p-1 border">
                                <input
                                  type="text"
                                  value={data.notes || ''}
                                  onChange={e => updateM1(item.key, 'notes', e.target.value)}
                                  className="w-full p-1 text-xs border rounded"
                                  placeholder="Explanation..."
                                />
                              </td>
                            </tr>
                          );
                        })}
                        {/* Totals Row */}
                        <tr className="bg-slate-200 font-bold">
                          <td className="p-2 border">TOTAL M-1 ADJUSTMENTS</td>
                          <td className="p-2 border text-right">{formatCurrency(totalBookAdj)}</td>
                          <td className="p-2 border text-right">{formatCurrency(totalTaxAdj)}</td>
                          <td className={`p-2 border text-right ${netAdjustment > 0 ? 'text-green-600' : netAdjustment < 0 ? 'text-red-600' : ''}`}>
                            {netAdjustment !== 0 ? (netAdjustment > 0 ? '+' : '') + formatCurrency(netAdjustment) : '-'}
                          </td>
                          <td className="p-2 border"></td>
                        </tr>
                      </tbody>
                    </table>
                    
                    <div className="mt-3 p-2 bg-slate-50 rounded text-xs text-gray-600 space-y-1">
                      <div><strong>💡 Tips:</strong></div>
                      <div>• If variance remains unexplained, request the actual Schedule M-1 from the CPA or tax preparer</div>
                      <div>• For S-Corps, M-1 is on Form 1120S Schedule K. For C-Corps, it's on Form 1120 Schedule M-1</div>
                      <div>• Large unexplained variances (&gt;10%) should be flagged in Tax vs P&L section above for due diligence follow-up</div>
                    </div>
                  </div>
                );
              })()}
            </div>
            )}
            {/* SECTION 3: Customer Sales vs P&L Revenue Reconciliation */}
            <div className="border rounded-lg overflow-hidden mb-4">
              <div 
                className="bg-green-100 px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:bg-green-200"
                onClick={() => setReconSalesVsPLExpanded(!reconSalesVsPLExpanded)}
              >
                <span>📋 Customer Sales vs P&L Revenue Reconciliation</span>
                <span className="text-lg">{reconSalesVsPLExpanded ? '▼' : '▶'}</span>
              </div>
              {reconSalesVsPLExpanded && (() => {
                // Calculate P&L totals for each basis
                const getRevenueTotals = (basis) => {
                  const totals = {};
                  ['year1', 'year2', 'year3', 'year4', 'year5', 'ytd', 'ttm'].forEach(yr => {
                    totals[yr] = revenueCategories.reduce((sum, cat) => sum + (cat[basis]?.[yr] || 0), 0);
                  });
                  return totals;
                };
                
                const cashTotals = getRevenueTotals('cash');
                const accrualTotals = getRevenueTotals('accrual');

                // Compare like-for-like: each row pulls from the sales array whose actual basis matches.
                // customerSalesData holds the primary basis; customerSalesDataAlt holds the opposite (if entered).
                // If a basis isn't entered, its Sales Total is $0 and the variance reads honestly
                // (matches Tax Return vs P&L behavior when no tax return is entered).
                const hasAltSales = customerSalesDataAlt.length > 0 && customerSalesDataAlt.some(c => c.name);
                const accrualSalesArr = customerSalesBasis === 'accrual'
                  ? customerSalesData
                  : (hasAltSales ? customerSalesDataAlt : null);
                const cashSalesArr = customerSalesBasis === 'cash'
                  ? customerSalesData
                  : (hasAltSales ? customerSalesDataAlt : null);
                const taxSalesArr = customerSalesBasis === taxFilingBasis
                  ? customerSalesData
                  : (hasAltSales ? customerSalesDataAlt : null);

                const sumYear = (arr, yr) => (arr || []).reduce((s, c) => s + (c[yr] || 0), 0);

                const yearKey = reconYearTab;
                const plCash = cashTotals[yearKey] || 0;
                const plAccrual = accrualTotals[yearKey] || 0;
                const taxRev = taxReturnTotals?.revenue?.[yearKey] || 0;
                const accrualSalesTotal = sumYear(accrualSalesArr, yearKey);
                const cashSalesTotal = sumYear(cashSalesArr, yearKey);
                const salesTotal = sumYear(taxSalesArr, yearKey);

                // Calculate variances for each
                const calcVar = (plVal, salesVal) => {
                  const variance = salesVal - plVal;
                  const variancePct = plVal !== 0 ? (variance / plVal) * 100 : (salesVal !== 0 ? 100 : 0);
                  const hasFlag = Math.abs(variancePct) > 10;
                  return { variance, variancePct, hasFlag };
                };

                const accrualVar = calcVar(plAccrual, accrualSalesTotal);
                const cashVar = calcVar(plCash, cashSalesTotal);
                const taxVar = calcVar(taxRev, salesTotal);
                
                return (
                  <div className="p-3">
                    <div className="text-xs p-2 mb-3 bg-green-50 rounded border border-green-200">
                      <div className="font-medium text-green-800 mb-1">ℹ️ Why This Matters</div>
                      <span className="text-gray-600">Customer sales totals should match P&L revenue. </span>
                      <span className="text-amber-700 font-medium">Variance &gt;10% triggers Quality of Earnings flag indicating potential missing/unreported revenue or data integrity issues.</span>
                    </div>
                    
                    <table className="w-full text-xs mb-3">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="p-2 border text-left" style={{minWidth: '180px'}}>Comparison</th>
                          <th className="p-2 border text-center w-28">P&L Revenue</th>
                          <th className="p-2 border text-center w-28 bg-green-50">Sales Total</th>
                          <th className="p-2 border text-center w-28">Variance $</th>
                          <th className="p-2 border text-center w-20">Var %</th>
                          <th className="p-2 border text-center w-36">Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Accrual P&L vs Sales */}
                        {(() => {
                          const noteKey = `recon-sales-accrual-${yearKey}`;
                          const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                          return (
                            <tr className={accrualVar.hasFlag ? 'bg-amber-50' : ''}>
                              <td className="p-2 border font-medium">
                                Accrual P&L vs Sales
                                {accrualVar.hasFlag && <span className="text-red-600 text-xs ml-1">(⚠️ &gt;10%)</span>}
                              </td>
                              <td className="p-2 border text-right">{formatCurrency(plAccrual)}</td>
                              <td className="p-2 border text-right bg-green-50 font-semibold">{formatCurrency(accrualSalesTotal)}</td>
                              <td className={`p-2 border text-right ${accrualVar.variance > 0 ? 'text-green-600' : accrualVar.variance < 0 ? 'text-red-600' : ''}`}>
                                {formatCurrency(accrualVar.variance)}
                              </td>
                              <td className={`p-2 border text-right ${accrualVar.hasFlag ? 'font-bold text-red-600' : ''}`}>
                                {accrualVar.variancePct.toFixed(1)}%
                              </td>
                              <td className="p-0 border">
                                <ExpandableNotes
                                  value={monthlyTtmNotes[noteKey]}
                                  onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                  hasVariance={accrualVar.hasFlag}
                                  isFlagged={isManuallyFlagged}
                                  onToggleFlag={() => setManualReviewFlags(prev => ({
                                    ...prev, 
                                    [noteKey]: { 
                                      ...prev[noteKey], 
                                      flagged: !prev[noteKey]?.flagged,
                                      created: prev[noteKey]?.created || Date.now(),
                                      section: 'Reconciliation',
                                      item: 'Sales vs Accrual P&L'
                                    }
                                  }))}
                                  noteKey={noteKey}
                                  resolvedData={manualReviewFlags[noteKey]}
                                />
                              </td>
                            </tr>
                          );
                        })()}
                        
                        {/* Cash P&L vs Sales */}
                        {(() => {
                          const noteKey = `recon-sales-cash-${yearKey}`;
                          const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                          return (
                            <tr className={cashVar.hasFlag ? 'bg-amber-50' : ''}>
                              <td className="p-2 border font-medium">
                                Cash P&L vs Sales
                                {cashVar.hasFlag && <span className="text-red-600 text-xs ml-1">(⚠️ &gt;10%)</span>}
                              </td>
                              <td className="p-2 border text-right">{formatCurrency(plCash)}</td>
                              <td className="p-2 border text-right bg-green-50 font-semibold">{formatCurrency(cashSalesTotal)}</td>
                              <td className={`p-2 border text-right ${cashVar.variance > 0 ? 'text-green-600' : cashVar.variance < 0 ? 'text-red-600' : ''}`}>
                                {formatCurrency(cashVar.variance)}
                              </td>
                              <td className={`p-2 border text-right ${cashVar.hasFlag ? 'font-bold text-red-600' : ''}`}>
                                {cashVar.variancePct.toFixed(1)}%
                              </td>
                              <td className="p-0 border">
                                <ExpandableNotes
                                  value={monthlyTtmNotes[noteKey]}
                                  onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                  hasVariance={cashVar.hasFlag}
                                  isFlagged={isManuallyFlagged}
                                  onToggleFlag={() => setManualReviewFlags(prev => ({
                                    ...prev, 
                                    [noteKey]: { 
                                      ...prev[noteKey], 
                                      flagged: !prev[noteKey]?.flagged,
                                      created: prev[noteKey]?.created || Date.now(),
                                      section: 'Reconciliation',
                                      item: 'Sales vs Cash P&L'
                                    }
                                  }))}
                                  noteKey={noteKey}
                                  resolvedData={manualReviewFlags[noteKey]}
                                />
                              </td>
                            </tr>
                          );
                        })()}
                        
                        {/* Tax Return vs Sales - only show for calendar years */}
                        {yearKey !== 'ttm' && yearKey !== 'ytd' && (() => {
                          const noteKey = `recon-sales-tax-${yearKey}`;
                          const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                          return (
                            <tr className={taxVar.hasFlag ? 'bg-amber-50' : ''}>
                              <td className="p-2 border font-medium">
                                Tax Return vs Sales
                                {taxVar.hasFlag && <span className="text-red-600 text-xs ml-1">(⚠️ &gt;10%)</span>}
                              </td>
                              <td className="p-2 border text-right">{formatCurrency(taxRev)}</td>
                              <td className="p-2 border text-right bg-green-50 font-semibold">{formatCurrency(salesTotal)}</td>
                              <td className={`p-2 border text-right ${taxVar.variance > 0 ? 'text-green-600' : taxVar.variance < 0 ? 'text-red-600' : ''}`}>
                                {formatCurrency(taxVar.variance)}
                              </td>
                              <td className={`p-2 border text-right ${taxVar.hasFlag ? 'font-bold text-red-600' : ''}`}>
                                {taxVar.variancePct.toFixed(1)}%
                              </td>
                              <td className="p-0 border">
                                <ExpandableNotes
                                  value={monthlyTtmNotes[noteKey]}
                                  onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                                  hasVariance={taxVar.hasFlag}
                                  isFlagged={isManuallyFlagged}
                                  onToggleFlag={() => setManualReviewFlags(prev => ({
                                    ...prev, 
                                    [noteKey]: { 
                                      ...prev[noteKey], 
                                      flagged: !prev[noteKey]?.flagged,
                                      created: prev[noteKey]?.created || Date.now(),
                                      section: 'Reconciliation',
                                      item: 'Sales vs Tax Return'
                                    }
                                  }))}
                                  noteKey={noteKey}
                                  resolvedData={manualReviewFlags[noteKey]}
                                />
                              </td>
                            </tr>
                          );
                        })()}
                      </tbody>
                    </table>
                    
                    <div className="p-2 bg-green-50 rounded text-xs text-gray-600">
                      <strong>Common reasons for variance:</strong> One-time project revenue not in customer list, 
                      reseller/pass-through revenue, timing differences, customers missing from sales report.
                    </div>
                  </div>
                );
              })()}
            </div>
            
            {/* SECTION 3b: Sales Cash vs Accrual Comparison */}
            {customerSalesDataAlt.length > 0 && customerSalesDataAlt.some(c => c.name) && (() => {
              const primaryData = customerSalesData.filter(c => c.name && (c.year3 > 0 || c.year4 > 0 || c.year5 > 0 || c.ttm > 0));
              const altData = customerSalesDataAlt.filter(c => c.name && (c.year3 > 0 || c.year4 > 0 || c.year5 > 0 || c.ttm > 0));
              const altBasis = customerSalesBasis === 'cash' ? 'accrual' : 'cash';
              
              // Build comparison by matching names
              const allNames = [...new Set([...primaryData.map(c => c.name.toLowerCase().trim()), ...altData.map(c => c.name.toLowerCase().trim())])];
              const comparisons = allNames.map(nameLower => {
                const prim = primaryData.find(c => c.name.toLowerCase().trim() === nameLower);
                const alt = altData.find(c => c.name.toLowerCase().trim() === nameLower);
                const displayName = (prim || alt).name;
                const yrs = {};
                ['year3', 'year4', 'year5', 'ttm'].forEach(yr => {
                  const pVal = prim?.[yr] || 0;
                  const aVal = alt?.[yr] || 0;
                  const diff = pVal - aVal;
                  const pctDiff = aVal !== 0 ? (diff / Math.abs(aVal)) * 100 : (pVal !== 0 ? 100 : 0);
                  yrs[yr] = { primary: pVal, alt: aVal, diff, pctDiff };
                });
                return { name: displayName, yrs, onlyInPrimary: !alt, onlyInAlt: !prim };
              }).sort((a, b) => Math.abs(b.yrs.ttm.diff) - Math.abs(a.yrs.ttm.diff));
              
              // Totals
              const totals = {};
              ['year3', 'year4', 'year5', 'ttm'].forEach(yr => {
                const pTotal = primaryData.reduce((s, c) => s + (c[yr] || 0), 0);
                const aTotal = altData.reduce((s, c) => s + (c[yr] || 0), 0);
                totals[yr] = { primary: pTotal, alt: aTotal, diff: pTotal - aTotal, pctDiff: aTotal !== 0 ? ((pTotal - aTotal) / Math.abs(aTotal)) * 100 : 0 };
              });
              
              const fmtC = (v) => v == null || isNaN(v) ? '-' : (v < 0 ? `($${Math.abs(Math.round(v)).toLocaleString()})` : `$${Math.round(v).toLocaleString()}`);
              const yearLabels = [displayCustomerYearLabels?.year3 || 'Y3', displayCustomerYearLabels?.year4 || 'Y4', displayCustomerYearLabels?.year5 || 'Y5', 'TTM'];
              const yearKeys = ['year3', 'year4', 'year5', 'ttm'];
              
              return (
                <div className="border rounded-lg overflow-hidden mb-4">
                  <div className="bg-teal-100 px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:bg-teal-200"
                    onClick={() => setExpandedSections(prev => ({...prev, reconSalesBasis: !prev.reconSalesBasis}))}>
                    <span>💱 Sales: {customerSalesBasis === 'cash' ? 'Cash' : 'Accrual'} vs {altBasis === 'cash' ? 'Cash' : 'Accrual'} Comparison</span>
                    <span className="text-lg">{expandedSections.reconSalesBasis ? '▼' : '▶'}</span>
                  </div>
                  {expandedSections.reconSalesBasis && (
                    <div className="p-3">
                      <p className="text-sm text-gray-600 mb-3">Compares customer sales revenue between Cash and Accrual basis. Differences indicate timing of revenue recognition — deferred revenue, prepayments, or unbilled work.</p>
                      
                      {/* Summary totals */}
                      <div className="grid grid-cols-4 gap-2 mb-3">
                        {yearKeys.map((yr, yi) => {
                          const t = totals[yr];
                          const isVariance = Math.abs(t.pctDiff) > 5;
                          return (
                            <div key={yr} className={`p-2 rounded border text-center ${isVariance ? 'bg-amber-50 border-amber-300' : 'bg-gray-50'}`}>
                              <div className="text-xs text-gray-500">{yearLabels[yi]} Variance</div>
                              <div className={`text-sm font-bold ${isVariance ? 'text-amber-700' : 'text-gray-700'}`}>{fmtC(t.diff)}</div>
                              <div className="text-xs text-gray-500">{t.pctDiff.toFixed(1)}%</div>
                            </div>
                          );
                        })}
                      </div>
                      
                      {/* Detail table */}
                      <div className="overflow-x-auto">
                        <table className="w-full text-xs border-collapse">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="p-1.5 border text-left">Client</th>
                              {yearKeys.map((yr, yi) => (
                                <React.Fragment key={yr}>
                                  <th className="p-1.5 border text-right">{yearLabels[yi]} {customerSalesBasis === 'cash' ? 'Cash' : 'Accrual'}</th>
                                  <th className="p-1.5 border text-right">{yearLabels[yi]} {altBasis === 'cash' ? 'Cash' : 'Accrual'}</th>
                                  <th className="p-1.5 border text-right">{yearLabels[yi]} Var</th>
                                </React.Fragment>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {comparisons.slice(0, 30).map((comp, idx) => (
                              <tr key={idx} className={comp.onlyInPrimary || comp.onlyInAlt ? 'bg-yellow-50' : ''}>
                                <td className="p-1 border font-medium">{comp.name} {comp.onlyInPrimary ? '⚠️' : comp.onlyInAlt ? '⚠️' : ''}</td>
                                {yearKeys.map(yr => {
                                  const d = comp.yrs[yr];
                                  const highlight = Math.abs(d.pctDiff) > 10 && Math.abs(d.diff) > 500;
                                  return (
                                    <React.Fragment key={yr}>
                                      <td className="p-1 border text-right">{d.primary ? fmtC(d.primary) : '-'}</td>
                                      <td className="p-1 border text-right">{d.alt ? fmtC(d.alt) : '-'}</td>
                                      <td className={`p-1 border text-right ${highlight ? 'text-amber-700 font-bold bg-amber-50' : 'text-gray-500'}`}>{d.diff !== 0 ? fmtC(d.diff) : '-'}</td>
                                    </React.Fragment>
                                  );
                                })}
                              </tr>
                            ))}
                            {/* Totals row */}
                            <tr className="bg-gray-100 font-bold">
                              <td className="p-1.5 border">TOTAL</td>
                              {yearKeys.map(yr => {
                                const t = totals[yr];
                                return (
                                  <React.Fragment key={yr}>
                                    <td className="p-1.5 border text-right">{fmtC(t.primary)}</td>
                                    <td className="p-1.5 border text-right">{fmtC(t.alt)}</td>
                                    <td className={`p-1.5 border text-right ${Math.abs(t.pctDiff) > 5 ? 'text-amber-700' : ''}`}>{fmtC(t.diff)}</td>
                                  </React.Fragment>
                                );
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {comparisons.some(c => c.onlyInPrimary || c.onlyInAlt) && (
                        <p className="text-xs text-amber-600 mt-2">⚠️ Some clients appear in only one basis. This may indicate data entry differences between the Cash and Accrual sales reports.</p>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
            
            {/* SECTION 4: AR Aging to Balance Sheet Reconciliation */}
            {!arReviewChecklist.notApplicable && arAgingCalcs.totalAR > 0 && (
            <div className="border rounded-lg overflow-hidden mb-4">
              <div 
                className="bg-purple-100 px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80"
                onClick={() => setReconArBsExpanded(!reconArBsExpanded)}
              >
                <span>📋 AR Aging vs Balance Sheet</span>
                <span className="text-lg">{reconArBsExpanded ? '▼' : '▶'}</span>
              </div>
              {reconArBsExpanded && (() => {
                const bsAR = bsTradeAR(bsCurrentAssets, 'interim');
                const arTotal = arAgingCalcs.totalAR || 0;
                const variance = arTotal - bsAR;
                const variancePct = bsAR > 0 ? (variance / bsAR * 100) : (arTotal > 0 ? 100 : 0);
                const hasQoEFlag = Math.abs(variancePct) > 5; // Fixed 5% threshold
                const noteKey = `recon-ar-bs`;
                const isManuallyFlagged = manualReviewFlags[noteKey]?.flagged;
                
                return (
                  <div className="p-3 bg-white">
                    <div className="text-xs p-2 mb-3 bg-purple-50 rounded border border-purple-200">
                      <div className="font-medium text-purple-800 mb-1">ℹ️ Why This Matters</div>
                      <span className="text-gray-600">AR Aging report should tie to Balance Sheet Accounts Receivable. </span>
                      <span className="text-amber-700 font-medium">Variance &gt;5% triggers Quality of Earnings flag indicating report date mismatch or posting timing issues.</span>
                    </div>
                    
                    <table className="w-full text-xs mb-3">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="p-2 border text-left" style={{minWidth: '180px'}}>Comparison</th>
                          <th className="p-2 border text-center w-28">AR Aging</th>
                          <th className="p-2 border text-center w-28">Balance Sheet</th>
                          <th className="p-2 border text-center w-28">Variance $</th>
                          <th className="p-2 border text-center w-20">Var %</th>
                          <th className="p-2 border text-center w-36">Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className={hasQoEFlag ? 'bg-amber-100' : 'bg-purple-50'}>
                          <td className="p-2 border font-bold">
                            AR Aging vs Balance Sheet AR
                            {hasQoEFlag && <span className="text-red-600 text-xs ml-1">(⚠️ QoE Flag)</span>}
                          </td>
                          <td className="p-2 border text-right font-semibold">
                            {formatCurrency(arTotal)}
                            <div className="text-xs text-gray-500 font-normal">As of {arAgingData.reportDate || 'N/A'}</div>
                          </td>
                          <td className="p-2 border text-right font-semibold bg-purple-100">
                            {formatCurrency(bsAR)}
                            <div className="text-xs text-gray-500 font-normal">Interim</div>
                          </td>
                          <td className={`p-2 border text-right font-semibold ${variance > 0 ? 'text-green-600' : variance < 0 ? 'text-red-600' : ''}`}>
                            {formatCurrency(variance)}
                          </td>
                          <td className={`p-2 border text-right font-bold ${hasQoEFlag ? 'text-red-600' : ''}`}>
                            {variancePct.toFixed(1)}%
                          </td>
                          <td className="p-0 border">
                            <ExpandableNotes
                              value={monthlyTtmNotes[noteKey]}
                              onChange={(val) => setMonthlyTtmNotes(prev => ({...prev, [noteKey]: val}))}
                              hasVariance={hasQoEFlag}
                              isFlagged={isManuallyFlagged}
                              onToggleFlag={() => setManualReviewFlags(prev => ({
                                ...prev, 
                                [noteKey]: { 
                                  ...prev[noteKey], 
                                  flagged: !prev[noteKey]?.flagged,
                                  created: prev[noteKey]?.created || Date.now(),
                                  section: 'Reconciliation',
                                  item: 'AR Aging vs Balance Sheet'
                                }
                              }))}
                              noteKey={noteKey}
                              resolvedData={manualReviewFlags[noteKey]}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                    <div className="p-2 bg-purple-50 rounded text-xs text-gray-600">
                      <strong>Common reasons for variance:</strong> Report date mismatch (AR aging vs BS date), 
                      transactions posted after AR aging was run, credit memos or adjustments not reflected, 
                      or allowance for doubtful accounts included/excluded.
                    </div>
                  </div>
                );
              })()}
            </div>
            )}

            {/* Quality of Earnings Issues & Flags */}
            {(() => {
              // Calculate quality issues that need review
              const qoeIssues = [];
              
              // Helper to calculate variance percentage
              const calcVariancePct = (val1, val2) => {
                if (val1 === 0 && val2 === 0) return 0;
                if (val1 === 0) return val2 !== 0 ? 100 : 0;
                return Math.abs((val2 - val1) / val1) * 100;
              };
              
              // Check Cash vs Accrual EBITDA
              const checkYear = 'ttm';
              const cashRev = revenueCategories.reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
              const accrualRev = revenueCategories.reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
              const cashCogs = cogsCategories.reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
              const accrualCogs = cogsCategories.reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
              const cashOpex = opexCategories.reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
              const accrualOpex = opexCategories.reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
              // Add back D/I/A/T to get true EBITDA
              // Source 1: Dedicated DIAT fields
              const cashDIAT = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                sum + (diatCategories?.[key]?.cash?.[checkYear] || 0), 0);
              const accrualDIAT = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                sum + (diatCategories?.[key]?.accrual?.[checkYear] || 0), 0);
              // Source 2: OpEx/OE line items that are DIAT
              const diatKeywords = /depreci|interest|amortiz|income\s*tax|tax\s*expense/i;
              const isDiatLine = (cat) => ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory) || diatKeywords.test(cat.name || '');
              const cashOpexDIAT = [...opexCategories, ...otherExpenseCategories].filter(cat => cat.name && isDiatLine(cat))
                .reduce((sum, cat) => sum + (cat.cash?.[checkYear] || 0), 0);
              const accrualOpexDIAT = [...opexCategories, ...otherExpenseCategories].filter(cat => cat.name && isDiatLine(cat))
                .reduce((sum, cat) => sum + (cat.accrual?.[checkYear] || 0), 0);
              const cashEbitda = cashRev - cashCogs - cashOpex + cashDIAT + cashOpexDIAT;
              const accrualEbitda = accrualRev - accrualCogs - accrualOpex + accrualDIAT + accrualOpexDIAT;
              
              if (cashEbitda !== 0 && accrualEbitda !== 0) {
                const ebitdaVariancePct = calcVariancePct(cashEbitda, accrualEbitda);
                if (ebitdaVariancePct > 15) {
                  qoeIssues.push({
                    key: 'qoe_cash_accrual_ebitda',
                    type: 'Cash vs Accrual EBITDA',
                    threshold: '15%',
                    variance: ebitdaVariancePct,
                    detail: `TTM EBITDA — Cash: ${formatCurrency(cashEbitda)} vs Accrual: ${formatCurrency(accrualEbitda)}`,
                    concern: 'Large timing differences may hide earnings quality issues'
                  });
                }
              }
              
              // Check Tax vs P&L Net Income (find most recent year with tax data)
              const taxCheckYear = ['year5', 'year4', 'year3'].find(yr => 
                (taxReturnTotals?.revenue?.[yr] || 0) !== 0 || (taxReturnTotals?.cogs?.[yr] || 0) !== 0
              );
              if (taxCheckYear) {
              const taxRev = taxReturnTotals?.revenue?.[taxCheckYear] || 0;
              const taxCogs = taxReturnTotals?.cogs?.[taxCheckYear] || 0;
              const taxOpex = taxReturnTotals?.expenses?.[taxCheckYear] || 0;
              // Include Other Income/Expense from tax-basis category data
              const taxOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat.tax?.[taxCheckYear] || 0), 0);
              const taxOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat.tax?.[taxCheckYear] || 0), 0);
              const taxNetIncome = taxRev - taxCogs - taxOpex + taxOI - taxOE;
              const yrBasisRev = revenueCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[taxCheckYear] || 0), 0);
              const yrBasisCogs = cogsCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[taxCheckYear] || 0), 0);
              const yrBasisOpex = opexCategories.reduce((sum, cat) => sum + (cat[taxFilingBasis]?.[taxCheckYear] || 0), 0);
              // Include DIAT if entered separately, plus Other Income/Expense for true Net Income
              const yrBasisDiat = ['depreciation','interest','amortization','taxes'].reduce((sum, key) => 
                sum + (diatCategories?.[key]?.[taxFilingBasis]?.[taxCheckYear] || 0), 0);
              const yrBasisOI = otherIncomeCategories.reduce((sum, cat) => sum + (cat?.[taxFilingBasis]?.[taxCheckYear] || 0), 0);
              const yrBasisOE = otherExpenseCategories.reduce((sum, cat) => sum + (cat?.[taxFilingBasis]?.[taxCheckYear] || 0), 0);
              const basisNetIncome = yrBasisRev - yrBasisCogs - yrBasisOpex - yrBasisDiat + yrBasisOI - yrBasisOE;
              
              if (taxNetIncome !== 0 && basisNetIncome !== 0) {
                const taxVariancePct = calcVariancePct(basisNetIncome, taxNetIncome);
                if (taxVariancePct > 10) {
                  qoeIssues.push({
                    key: 'qoe_tax_net_income',
                    type: 'Tax vs P&L Net Income',
                    threshold: '10%',
                    variance: taxVariancePct,
                    detail: `${basisYearLabels?.[taxCheckYear] || taxCheckYear}: ${taxFilingBasis === 'cash' ? 'Cash' : 'Accrual'} P&L: ${formatCurrency(basisNetIncome)} vs Tax: ${formatCurrency(taxNetIncome)}. Filing Basis set to "${taxFilingBasis}" (change on Tax Returns entry tab).`,
                    concern: 'Lenders require tax-to-books reconciliation'
                  });
                }
              }
              }
              
              // Check Sales vs P&L Revenue
              const salesTotal = customerSalesData.reduce((sum, c) => sum + (c[checkYear] || 0), 0);
              const plRevenue = selectedValuationBasis === 'cash' ? cashRev : accrualRev;
              
              if (salesTotal > 0 && plRevenue > 0) {
                const salesVariancePct = calcVariancePct(plRevenue, salesTotal);
                if (salesVariancePct > 5) {
                  qoeIssues.push({
                    key: 'qoe_sales_revenue',
                    type: 'Sales vs P&L Revenue',
                    threshold: '5%',
                    variance: salesVariancePct,
                    detail: `TTM ${selectedValuationBasis === 'cash' ? 'Cash' : 'Accrual'} P&L: ${formatCurrency(plRevenue)} vs Sales: ${formatCurrency(salesTotal)} (using valuation basis)`,
                    concern: 'Revenue sources don\'t reconcile'
                  });
                }
              }
              
              // Check AR Aging vs Balance Sheet
              const bsAR = bsTradeAR(bsCurrentAssets, 'interim');
              const agingAR = arAgingCalcs.totalAR || 0;
              
              if ((bsAR > 0 || agingAR > 0) && bsAR !== agingAR) {
                const arBsVariancePct = calcVariancePct(bsAR, agingAR);
                if (arBsVariancePct > 5) {
                  qoeIssues.push({
                    key: 'qoe_ar_bs',
                    type: 'AR Aging vs Balance Sheet',
                    threshold: '5%',
                    variance: arBsVariancePct,
                    detail: `BS AR: ${formatCurrency(bsAR)} vs Aging: ${formatCurrency(agingAR)}`,
                    concern: 'AR reports should tie - check dates/timing'
                  });
                }
              }
              
              const unresolvedCount = qoeIssues.filter(i => !reconQualityChecklist[i.key]?.reviewed).length;
              const resolvedCount = qoeIssues.filter(i => reconQualityChecklist[i.key]?.reviewed).length;
              
              return (
                <div className="border rounded-lg overflow-hidden mb-4">
                  <div 
                    className={`px-3 py-2 font-bold flex items-center justify-between cursor-pointer hover:opacity-80 ${unresolvedCount > 0 ? 'bg-amber-100' : 'bg-slate-100'}`}
                    onClick={() => setReconQualityExpanded(!reconQualityExpanded)}
                  >
                    <span>🚩 Quality of Earnings Issues ({unresolvedCount} unresolved{resolvedCount > 0 ? `, ${resolvedCount} resolved` : ''})</span>
                    <span>{reconQualityExpanded ? '▼' : '▶'}</span>
                  </div>
                  {reconQualityExpanded && (
                    <div className="p-3">
                      <div className="text-xs text-amber-700 mb-3 p-2 bg-amber-50 rounded border border-amber-200">
                        ⚠️ <span className="font-medium">These quality of earnings issues automatically create Open Items.</span> Check each item as reviewed to clear from Open Items. Issues are detected when total-level variances exceed fixed thresholds that indicate potential quality concerns.
                      </div>
                      {qoeIssues.length === 0 ? (
                        <div className="text-center text-gray-500 py-4">
                          <span className="text-green-600 font-medium">✓ No quality of earnings issues detected</span>
                          <p className="text-xs text-gray-400 mt-1">All reconciliation variances are within acceptable thresholds</p>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          {qoeIssues.map(issue => {
                            const isResolved = reconQualityChecklist[issue.key]?.reviewed;
                            return (
                              <div key={issue.key} className={`p-3 rounded border ${isResolved ? 'bg-slate-50 border-slate-200 opacity-60' : 'bg-white border-amber-300'}`}>
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex items-center gap-2">
                                    <input 
                                      type="checkbox" 
                                      checked={isResolved || false}
                                      onChange={e => setReconQualityChecklist({...reconQualityChecklist, [issue.key]: {...(reconQualityChecklist[issue.key] || {}), reviewed: e.target.checked, reviewDate: e.target.checked ? new Date().toISOString().split('T')[0] : ''}})}
                                      className="w-4 h-4"
                                    />
                                    <span className={`text-xs px-2 py-0.5 rounded font-medium ${isResolved ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                                      {isResolved ? '✓ Reviewed' : '○ Unreviewed'}
                                    </span>
                                    <span className="font-medium text-sm">{issue.type}</span>
                                    <span className="text-xs text-gray-500">(threshold: {issue.threshold})</span>
                                  </div>
                                  <span className={`text-sm font-bold ${issue.variance > 20 ? 'text-red-600' : 'text-amber-600'}`}>
                                    {issue.variance.toFixed(1)}% variance
                                  </span>
                                </div>
                                <div className="text-xs text-gray-600 mb-2">{issue.detail}</div>
                                <div className="text-xs text-amber-700 italic">{issue.concern}</div>
                                <div className="mt-2">
                                  <input 
                                    type="text"
                                    value={reconQualityChecklist[issue.key]?.notes || ''}
                                    onChange={e => setReconQualityChecklist({...reconQualityChecklist, [issue.key]: {...(reconQualityChecklist[issue.key] || {}), notes: e.target.value}})}
                                    className="w-full p-1 text-xs border rounded"
                                    placeholder="Document your review findings..."
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Analysis Notes */}
            <div className="p-3 bg-gray-50 rounded-lg text-sm">
              <p className="font-bold mb-1">📌 Reconciliation & Quality of Earnings</p>
              <ul className="text-xs text-gray-600 list-disc pl-4 space-y-1">
                <li><strong>Cash vs Accrual (15% threshold):</strong> Timing differences are expected. Variances over 15% at EBITDA level may indicate earnings quality concerns.</li>
                <li><strong>Tax vs Books (10% threshold):</strong> Lenders and buyer accountants must reconcile tax returns to P&L. Document all book-to-tax adjustments.</li>
                <li><strong>Sales vs P&L (10% threshold):</strong> Revenue sources should reconcile. Large variances may indicate unreported revenue or quality issues.</li>
                <li><strong>AR vs BS (5% threshold):</strong> AR Aging should tie to Balance Sheet. Variances usually indicate date mismatch or posting timing.</li>
                <li><strong>⚠️ Quality of Earnings:</strong> Issues exceeding fixed thresholds automatically create Open Items and must be reviewed in the Issues & Flags section above.</li>
              </ul>
            </div>
          </div>
        ) : viewMode === 'proformaanalysis' ? (
          /* ========== PRO FORMA ANALYSIS TAB ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold flex items-center gap-2">📊 Pro Forma Analysis</h2>
              <button
                onClick={() => setViewMode('proforma')}
                className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300"
              >
                ← Back to Entry
              </button>
            </div>
            
            {proFormaItems.length === 0 ? (
              <div className="p-8 text-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                <div className="text-gray-400 text-4xl mb-2">📊</div>
                <div className="text-gray-600 font-medium">No Pro Forma Adjustments Entered</div>
                <div className="text-gray-500 text-sm mt-1">
                  <button onClick={() => setViewMode('proforma')} className="text-blue-600 hover:underline">
                    Go to Pro Forma Entry
                  </button> to add acquisitions or new clients.
                </div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* TTM Period Context */}
                <div className="p-3 bg-blue-50 border border-blue-200 rounded">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-medium text-blue-800">TTM Period: {proFormaCalcs.ttmPeriod?.label}</div>
                      <div className="text-xs text-blue-600 mt-1">
                        Items with effective dates within this period are prorated. Future dates contribute $0 to TTM.
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-xs text-gray-500">Items Entered</div>
                      <div className="text-2xl font-bold text-blue-700">{proFormaItems.length}</div>
                    </div>
                  </div>
                </div>
                
                {/* Detailed Item Breakdown */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-gray-100 px-4 py-2 font-bold">📋 Item-by-Item Breakdown</div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="p-2 border text-left">Item</th>
                          <th className="p-2 border text-left">Type</th>
                          <th className="p-2 border text-center">Effective Date</th>
                          <th className="p-2 border text-center">Months in TTM</th>
                          <th className="p-2 border text-right">Annual Revenue</th>
                          <th className="p-2 border text-right">Annual EBITDA</th>
                          <th className="p-2 border text-center">Margin</th>
                          <th className="p-2 border text-center">Retention</th>
                          <th className="p-2 border text-right bg-green-50">Adj. Revenue</th>
                          <th className="p-2 border text-right bg-green-50">Adj. EBITDA</th>
                        </tr>
                      </thead>
                      <tbody>
                        {proFormaCalcs.items?.map((item, idx) => (
                          <tr key={item.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="p-2 border font-medium">{item.name || `Item ${idx + 1}`}</td>
                            <td className="p-2 border">
                              <span className={`px-2 py-0.5 rounded text-xs ${
                                item.type === 'acquisition' ? 'bg-purple-100 text-purple-700' :
                                item.type === 'newclient' ? 'bg-blue-100 text-blue-700' :
                                item.type === 'lostclient' ? 'bg-red-100 text-red-700' :
                                'bg-gray-100 text-gray-700'
                              }`}>
                                {item.type === 'acquisition' ? '🏢 Acquisition' : 
                                 item.type === 'newclient' ? '👤 New Client' :
                                 item.type === 'lostclient' ? '📉 Lost Client' :
                                 item.type === 'pricechange' ? '💰 Price Change' : '📋 Other'}
                              </span>
                            </td>
                            <td className="p-2 border text-center">{item.effectiveDate || '—'}</td>
                            <td className="p-2 border text-center font-medium">{item.monthsInTTM} mo</td>
                            <td className="p-2 border text-right">{formatCurrency(item.annualRevenue || 0)}</td>
                            <td className="p-2 border text-right">{formatCurrency(item.annualEbitdaCalc || 0)}</td>
                            <td className="p-2 border text-center">{(item.ebitdaMarginCalc || 0).toFixed(1)}%{item.type === 'lostclient' && <div className="text-xs text-gray-500">{item.ebitdaMode === 'margin' ? 'costs come out' : item.ebitdaMode === 'custom' ? 'custom' : item.ebitdaMode === 'runrate' ? 'post-loss run rate' : 'overhead stays'}</div>}</td>
                            <td className="p-2 border text-center">{item.retentionPct}%</td>
                            <td className="p-2 border text-right bg-green-50 font-medium text-green-700">
                              {formatCurrency(item.adjustedRevenue || 0)}
                            </td>
                            <td className="p-2 border text-right bg-green-50 font-medium text-green-700">
                              {formatCurrency(item.adjustedEbitda || 0)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="bg-gray-200 font-bold">
                        <tr>
                          <td colSpan="8" className="p-2 border text-right">Total Pro Forma Additions →</td>
                          <td className="p-2 border text-right bg-green-100 text-green-800">
                            +{formatCurrency(proFormaCalcs.totalProratedRevenue)}
                          </td>
                          <td className="p-2 border text-right bg-green-100 text-green-800">
                            +{formatCurrency(proFormaCalcs.totalProratedEbitda)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                
                {/* Historical vs Pro Forma Comparison */}
                <div className="grid grid-cols-2 gap-6">
                  <div className="border rounded-lg overflow-hidden">
                    <div className="bg-gray-100 px-4 py-2 font-bold">📈 Revenue Comparison</div>
                    <div className="p-4">
                      <table className="w-full text-sm">
                        <tbody>
                          <tr className="border-b">
                            <td className="py-2">Historical TTM Revenue</td>
                            <td className="py-2 text-right font-medium">{formatCurrency(proFormaCalcs.historicalTTMRevenue)}</td>
                          </tr>
                          <tr className="border-b text-green-700">
                            <td className="py-2">Pro Forma Additions (Prorated)</td>
                            <td className="py-2 text-right font-medium">+{formatCurrency(proFormaCalcs.totalProratedRevenue)}</td>
                          </tr>
                          <tr className="font-bold text-lg">
                            <td className="py-2">Pro Forma TTM Revenue</td>
                            <td className="py-2 text-right">{formatCurrency(proFormaCalcs.proFormaTTMRevenue)}</td>
                          </tr>
                          <tr className="border-t text-gray-500">
                            <td className="py-2 text-sm">Change</td>
                            <td className="py-2 text-right text-sm">
                              {proFormaCalcs.historicalTTMRevenue > 0 
                                ? `+${((proFormaCalcs.proFormaTTMRevenue / proFormaCalcs.historicalTTMRevenue - 1) * 100).toFixed(1)}%`
                                : '—'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div className="border rounded-lg overflow-hidden">
                    <div className="bg-gray-100 px-4 py-2 font-bold">💰 EBITDA Comparison</div>
                    <div className="p-4">
                      <table className="w-full text-sm">
                        <tbody>
                          <tr className="border-b">
                            <td className="py-2">Historical TTM EBITDA</td>
                            <td className="py-2 text-right font-medium">{formatCurrency(proFormaCalcs.historicalTTMEbitda)}</td>
                          </tr>
                          <tr className="border-b text-green-700">
                            <td className="py-2">Pro Forma Additions (Prorated)</td>
                            <td className="py-2 text-right font-medium">+{formatCurrency(proFormaCalcs.totalProratedEbitda)}</td>
                          </tr>
                          <tr className="font-bold text-lg">
                            <td className="py-2">Pro Forma TTM EBITDA</td>
                            <td className="py-2 text-right">{formatCurrency(proFormaCalcs.proFormaTTMEbitda)}</td>
                          </tr>
                          <tr className="border-t text-gray-500">
                            <td className="py-2 text-sm">Change</td>
                            <td className="py-2 text-right text-sm">
                              {proFormaCalcs.historicalTTMEbitda > 0 
                                ? `+${((proFormaCalcs.proFormaTTMEbitda / proFormaCalcs.historicalTTMEbitda - 1) * 100).toFixed(1)}%`
                                : '—'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                
                {/* Valuation Impact */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-purple-100 px-4 py-2 font-bold text-purple-800">💎 EBITDA Impact Comparison</div>
                  <div className="p-4">
                    <div className="grid grid-cols-3 gap-6">
                      <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <div className="text-sm text-gray-500 mb-1">Historical Basis</div>
                        <div className="text-2xl font-bold">{formatCurrency(proFormaCalcs.historicalTTMEbitda)}</div>
                        <div className="text-xs text-gray-400">TTM EBITDA</div>
                      </div>
                      
                      <div className="text-center p-4 bg-green-50 rounded-lg border-2 border-green-300">
                        <div className="text-sm text-green-700 mb-1">Pro Forma Basis</div>
                        <div className="text-2xl font-bold text-green-800">{formatCurrency(proFormaCalcs.proFormaTTMEbitda)}</div>
                        <div className="text-xs text-green-600">Pro Forma TTM EBITDA</div>
                        <div className="mt-2 pt-2 border-t border-green-200">
                          <div className={`text-sm font-semibold ${proFormaCalcs.proFormaTTMEbitda >= proFormaCalcs.historicalTTMEbitda ? 'text-green-700' : 'text-red-600'}`}>
                            {proFormaCalcs.proFormaTTMEbitda >= proFormaCalcs.historicalTTMEbitda ? '+' : ''}{formatCurrency(proFormaCalcs.proFormaTTMEbitda - proFormaCalcs.historicalTTMEbitda)} vs Historical
                          </div>
                        </div>
                      </div>
                      
                      <div className="text-center p-4 bg-blue-50 rounded-lg">
                        <div className="text-sm text-blue-600 mb-1">Run-Rate Basis</div>
                        <div className="text-2xl font-bold text-blue-800">{formatCurrency(proFormaCalcs.proFormaRunRateEbitda)}</div>
                        <div className="text-xs text-blue-500">Full Year Pro Forma</div>
                        <div className="mt-2 pt-2 border-t border-blue-200">
                          <div className={`text-sm font-semibold ${proFormaCalcs.proFormaRunRateEbitda >= proFormaCalcs.historicalTTMEbitda ? 'text-blue-700' : 'text-red-600'}`}>
                            {proFormaCalcs.proFormaRunRateEbitda >= proFormaCalcs.historicalTTMEbitda ? '+' : ''}{formatCurrency(proFormaCalcs.proFormaRunRateEbitda - proFormaCalcs.historicalTTMEbitda)} vs Historical
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded text-sm">
                      <strong className="text-amber-800">⚠️ Important:</strong> 
                      <span className="text-amber-700"> Pro forma valuations are based on projected, unproven revenue. Buyers may apply a discount to the multiple for pro forma adjustments. 
                      The historical basis remains the most defensible valuation.</span>
                    </div>
                  </div>
                </div>
                
                {/* Navigation */}
                <div className="flex justify-between items-center pt-4 border-t">
                  <button
                    onClick={() => setViewMode('proforma')}
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                  >
                    ← Edit Pro Forma Items
                  </button>
                  <button
                    onClick={() => setViewMode('proformapres')}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    View Presentation Summary →
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'adjustments' ? (
          /* ========== ADJUSTMENTS (Add-backs & Deductions) ========== */
          <div>
            <h2 className="text-lg font-bold mb-3">⚖️ Adjustments Management</h2>

            {/* Adjustments status — explicit Stage Engine signal (Task 13).
                'complete' is what derives the adjustments_entered workflow stage. */}
            <div className={`mb-4 p-2 rounded-lg border text-xs flex items-center flex-wrap gap-2 ${
              adjustmentsStatus === 'complete' ? 'bg-green-50 border-green-200'
              : adjustmentsStatus === 'in_progress' ? 'bg-amber-50 border-amber-200'
              : 'bg-gray-50 border-gray-200'
            }`}>
              <span className="font-semibold text-gray-700">⚖️ Adjustments Status:</span>
              <select
                value={adjustmentsStatus}
                onChange={e => setAdjustmentsStatus(e.target.value)}
                className={`text-xs px-1 py-0.5 border rounded ${
                  adjustmentsStatus === 'complete' ? 'bg-green-100 text-green-700'
                  : adjustmentsStatus === 'in_progress' ? 'bg-amber-100 text-amber-700'
                  : 'bg-gray-100 text-gray-600'
                }`}
              >
                <option value="not_started">Not Started</option>
                <option value="in_progress">In Progress</option>
                <option value="complete">Complete</option>
              </select>
              {adjustmentsStatus === 'complete'
                ? <span className="text-green-600 font-medium">✓ Add-backs &amp; deductions finalized — the workflow stage can advance to Adjustments Entered</span>
                : <span className="text-gray-500">Mark Complete once add-backs &amp; deductions are finalized — this is what advances the workflow stage ({adjustmentItems.length} adjustment{adjustmentItems.length === 1 ? '' : 's'} entered)</span>}
            </div>

            {/* Owner Compensation Section */}
            <div className="bg-slate-50 p-3 rounded-lg mb-4 border border-slate-200">
              <h3 className="font-bold text-purple-800 mb-2">👤 Owner Compensation</h3>
              <div className="grid grid-cols-6 gap-3 mb-3">
                <div className="col-span-4">
                  <table className="w-full text-xs border-collapse">
                    <thead className="bg-slate-200">
                      <tr><th className="p-1 border">Period</th><th className="p-1 border">Salary</th><th className="p-1 border" title="How many owners this year's salary covers (blank = the count in the payroll tax box)">Owners</th><th className="p-1 border" title="This year's replacement cost if it differs (e.g. fewer owners that year). Blank = the Market Replacement Rate">Replacement</th><th className="p-1 border">Source</th><th className="p-1 border w-8">V</th></tr>
                    </thead>
                    <tbody>
                      {['year1', 'year2', 'year3', 'year4', 'year5', 'ttm'].map((period) => (
                        <tr key={period} className={period === 'ttm' ? 'bg-blue-100' : ''}>
                          <td className="p-1 border font-medium">{period === 'ttm' ? 'TTM' : basisYearLabels[period]}</td>
                          <td className="p-1 border"><CurrencyInput value={ownerCompensation[period]?.salary || 0} onChange={v => setOwnerCompensation({...ownerCompensation, [period]: {...(ownerCompensation[period] || {}), salary: v}})} className="w-full p-0.5 border rounded text-xs text-right" /></td>
                          <td className="p-1 border w-12"><input type="number" min="1" max="20" step="1" value={ownerCompensation[period]?.owners ?? ''} placeholder={String(ownerCompensation.ownerCount || 1)} onChange={e => setOwnerCompensation({ ...ownerCompensation, [period]: { ...(ownerCompensation[period] || {}), owners: e.target.value === '' ? null : Math.max(1, parseInt(e.target.value, 10) || 1) } })} className="w-full p-0.5 border rounded text-xs text-center" /></td>
                          <td className="p-1 border w-24"><input type="number" min="0" step="1000" value={ownerCompensation[period]?.market ?? ''} placeholder={String(ownerCompensation.marketReplacement || 0)} onChange={e => setOwnerCompensation({ ...ownerCompensation, [period]: { ...(ownerCompensation[period] || {}), market: e.target.value === '' ? null : Math.max(0, Number(e.target.value) || 0) } })} className="w-full p-0.5 border rounded text-xs text-right" /></td>
                          <td className="p-1 border">
                            <select value={ownerCompensation[period]?.source || 'qa'} onChange={e => setOwnerCompensation({...ownerCompensation, [period]: {...(ownerCompensation[period] || {}), source: e.target.value}})} className="w-full p-0.5 border rounded text-xs">
                              <option value="qa">Q&A Answer</option>
                              <option value="w2">W-2</option>
                              <option value="k1">K-1</option>
                              <option value="payroll">Payroll Report</option>
                              <option value="tax">Tax Return</option>
                            </select>
                          </td>
                          <td className="p-1 border text-center"><input type="checkbox" checked={ownerCompensation[period]?.verified || false} onChange={e => setOwnerCompensation({...ownerCompensation, [period]: {...(ownerCompensation[period] || {}), verified: e.target.checked}})} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="text-xs text-gray-500 mt-1">💡 For owner benefits (health, auto, 401k), set the Add-back % in the Line-Based Add-backs section below, or add separate adjustments</div>
                </div>
                <div className="col-span-2 space-y-2">
                  <div>
                    <label className="flex items-center gap-2 text-sm">
                      <input 
                        type="checkbox" 
                        checked={ownerCompensation.embeddedInWages} 
                        onChange={e => {
                          const newValue = e.target.checked;
                          captureUndoState(newValue ? 'Enable Owner Salary in Wages' : 'Disable Owner Salary in Wages');
                          if (!newValue) {
                            // When unchecking, check for owner salary adjustments that might need removal
                            const ownerSalaryAdjs = adjustmentItems.filter(a => 
                              a.notes === 'Auto-created to remove owner salary embedded in wages' ||
                              (a.category === 'Owner Compensation' && a.type === 'deduct' && a.description?.toLowerCase().includes('owner salary'))
                            );
                            if (ownerSalaryAdjs.length > 0) {
                              if (confirm(`Found ${ownerSalaryAdjs.length} owner salary deduction adjustment(s). Remove them?`)) {
                                const adjIdsToRemove = new Set(ownerSalaryAdjs.map(a => a.id));
                                setAdjustmentItems(adjustmentItems.filter(a => !adjIdsToRemove.has(a.id)));
                              }
                            }
                          }
                          setOwnerCompensation({...ownerCompensation, embeddedInWages: newValue});
                        }} 
                        className="w-4 h-4" 
                      /> 
                      <span className="font-medium">Owner Salary Included in Salaries/Wages Line</span>
                    </label>
                    <div className="text-xs text-gray-500 ml-6">Check this if owner's salary is part of your Salaries expense</div>
                  </div>
                  {ownerCompensation.embeddedInWages && (() => {
                    // Check each period for matching adjustments
                    const salaryLineNames = opexCategories.filter(c => c.name && (c.name.toLowerCase().includes('salar') || c.name.toLowerCase().includes('payroll'))).map(c => c.name);
                    const periodsToCheck = [
                      { key: 'year1', label: basisYearLabels?.year1 || 'Year 1', adjYear: basisYearLabels?.year1 || 'Year 1' },
                      { key: 'year2', label: basisYearLabels?.year2 || 'Year 2', adjYear: basisYearLabels?.year2 || 'Year 2' },
                      { key: 'year3', label: basisYearLabels?.year3 || 'Year 3', adjYear: basisYearLabels?.year3 || 'Year 3' },
                      { key: 'year4', label: basisYearLabels?.year4 || 'Year 4', adjYear: basisYearLabels?.year4 || 'Year 4' },
                      { key: 'year5', label: basisYearLabels?.year5 || 'Year 5', adjYear: basisYearLabels?.year5 || 'Year 5' },
                      { key: 'ttm', label: ttmLabel, adjYear: 'TTM' }
                    ];
                    
                    const periodStatus = periodsToCheck.map(period => {
                      const salary = ownerCompensation[period.key]?.salary || 0;
                      if (salary === 0) return { ...period, salary, status: 'none' };
                      
                      const hasMatch = adjustmentItems.some(a => {
                        if (!a.included || a.type !== 'deduct') return false;
                        const amountMatch = a.amount >= salary * 0.9 && a.amount <= salary * 1.1;
                        const yearMatch = a.year === 'All Years' || a.year === period.adjYear || a.year === period.label;
                        const salaryLineMatch = salaryLineNames.some(name => 
                          a.plLine === `OpEx: ${name}` || a.plLine === name
                        ) || a.plLine === 'Salaries' || a.plLine === 'Salaries & Wages' || 
                           (a.plLine && (a.plLine.toLowerCase().includes('salar') || a.plLine.toLowerCase().includes('payroll'))) ||
                           (a.description && a.description.toLowerCase().includes('owner') && a.description.toLowerCase().includes('salar'));
                        return amountMatch && yearMatch && salaryLineMatch;
                      });
                      return { ...period, salary, status: hasMatch ? 'ok' : 'missing' };
                    });
                    
                    const missingPeriods = periodStatus.filter(p => p.status === 'missing');
                    const okPeriods = periodStatus.filter(p => p.status === 'ok');
                    const hasSalaries = periodStatus.some(p => p.salary > 0);
                    
                    // Check for existing owner salary adjustments
                    const existingOwnerSalaryAdjs = adjustmentItems.filter(a => 
                      a.included && (
                        a.notes === 'Auto-created to remove owner salary embedded in wages' ||
                        (a.category === 'Owner Compensation' && a.type === 'deduct' && a.description?.toLowerCase().includes('owner salary'))
                      )
                    );
                    
                    // If no salaries entered but adjustments exist, warn user
                    if (!hasSalaries && existingOwnerSalaryAdjs.length > 0) {
                      const removeOrphanedAdjs = () => {
                        const adjIdsToRemove = new Set(existingOwnerSalaryAdjs.map(a => a.id));
                        setAdjustmentItems(adjustmentItems.filter(a => !adjIdsToRemove.has(a.id)));
                      };
                      return (
                        <div className="bg-red-100 border border-red-300 p-2 rounded text-sm">
                          <div className="font-medium text-red-800">⚠️ Owner Salary Adjustments Without Salaries</div>
                          <div className="text-xs text-red-700 mt-1">
                            {existingOwnerSalaryAdjs.length} deduction adjustment(s) exist, but no owner salaries are entered.
                            Remove these adjustments or enter the corresponding salary amounts.
                          </div>
                          <button
                            onClick={removeOrphanedAdjs}
                            className="mt-2 px-3 py-1 bg-red-600 text-white text-xs font-semibold rounded hover:bg-red-700"
                          >
                            Remove {existingOwnerSalaryAdjs.length} Adjustment{existingOwnerSalaryAdjs.length > 1 ? 's' : ''}
                          </button>
                        </div>
                      );
                    }
                    
                    if (!hasSalaries) return null;
                    
                    if (missingPeriods.length === 0) {
                      return (
                        <div className="bg-blue-100 border border-blue-300 p-2 rounded text-sm">
                          <div className="font-medium text-green-800 flex items-center gap-1">✓ All Salary Adjustments Found</div>
                          <div className="text-xs text-green-700 mt-1">
                            Matching deduction adjustments exist for all periods with owner salary.
                          </div>
                        </div>
                      );
                    } else {
                      // Find the best salary line from opex categories - prioritize "Salar" matches over "Payroll"
                      const salaryLine = 
                        opexCategories.find(c => c.name && c.name.toLowerCase().includes('salar'))?.name ||
                        opexCategories.find(c => c.name && c.name.toLowerCase().includes('wages'))?.name ||
                        opexCategories.find(c => c.name && c.name.toLowerCase().includes('payroll') && !c.name.toLowerCase().includes('tax') && !c.name.toLowerCase().includes('service'))?.name ||
                        'Salaries & Wages';
                      
                      const autoCreateAdjustments = () => {
                        captureUndoState('Auto-Create Owner Salary Adjustments');
                        const newAdjustments = [...adjustmentItems];
                        missingPeriods.forEach(period => {
                          newAdjustments.push({
                            id: Date.now() + Math.random(),
                            description: `Owner salary - remove from ${salaryLine}`,
                            amount: period.salary,
                            type: 'deduct',
                            category: 'Owner Compensation',
                            year: period.adjYear,
                            plLine: `OpEx: ${salaryLine}`,
                            source: ownerCompensation[period.key]?.source || '',
                            notes: 'Auto-created to remove owner salary embedded in wages',
                            included: true
                          });
                        });
                        setAdjustmentItems(newAdjustments);
                      };
                      
                      return (
                        <div className="bg-amber-100 border border-amber-300 p-2 rounded text-sm">
                          <div className="font-medium text-yellow-800 flex items-center gap-1">⚠️ Action Required - {missingPeriods.length} period(s) need adjustments</div>
                          <div className="text-xs text-yellow-700 mt-1">
                            {missingPeriods.map(p => (
                              <div key={p.key}>• {p.label}: Add deduction for {formatCurrency(p.salary)}</div>
                            ))}
                          </div>
                          {okPeriods.length > 0 && (
                            <div className="text-xs text-green-700 mt-1">
                              ✓ Already adjusted: {okPeriods.map(p => p.label).join(', ')}
                            </div>
                          )}
                          <button
                            onClick={autoCreateAdjustments}
                            className="mt-2 px-3 py-1 bg-blue-600 text-white text-xs font-semibold rounded hover:bg-blue-700"
                          >
                            Auto-Create {missingPeriods.length} Adjustment{missingPeriods.length > 1 ? 's' : ''}
                          </button>
                          <div className="text-xs text-yellow-600 mt-1">
                            Creates deduction adjustments to remove owner salary from {salaryLine}
                          </div>
                        </div>
                      );
                    }
                  })()}
                  {/* Warning for orphaned owner salary adjustments */}
                  {!ownerCompensation.embeddedInWages && (() => {
                    const ownerSalaryAdjs = adjustmentItems.filter(a => 
                      a.included && (
                        a.notes === 'Auto-created to remove owner salary embedded in wages' ||
                        (a.category === 'Owner Compensation' && a.type === 'deduct' && a.description?.toLowerCase().includes('owner salary'))
                      )
                    );
                    if (ownerSalaryAdjs.length === 0) return null;
                    const removeOrphanedAdjs = () => {
                      const adjIdsToRemove = new Set(ownerSalaryAdjs.map(a => a.id));
                      setAdjustmentItems(adjustmentItems.filter(a => !adjIdsToRemove.has(a.id)));
                    };
                    return (
                      <div className="bg-red-100 border border-red-300 p-2 rounded text-sm">
                        <div className="font-medium text-red-800">⚠️ Orphaned Owner Salary Adjustments Found</div>
                        <div className="text-xs text-red-700 mt-1">
                          {ownerSalaryAdjs.length} deduction adjustment(s) for owner salary exist, but "Owner Salary Included in Salaries/Wages Line" is unchecked.
                          This may cause incorrect calculations.
                        </div>
                        <button
                          onClick={removeOrphanedAdjs}
                          className="mt-2 px-3 py-1 bg-red-600 text-white text-xs font-semibold rounded hover:bg-red-700"
                        >
                          Remove {ownerSalaryAdjs.length} Orphaned Adjustment{ownerSalaryAdjs.length > 1 ? 's' : ''}
                        </button>
                      </div>
                    );
                  })()}
                  <div>
                    <label className="block text-xs font-medium text-gray-600">Market Replacement Rate</label>
                    {(() => {
                      // Replacement ROLES (Mark 09-28, VWTC): when the owner does two jobs
                      // (runs it AND bills as a tech), a buyer may need two hires. Optional —
                      // no roles = the single rate as before. With roles, the rate is their
                      // sum. Benefits stay the way Colleen handles them for each company.
                      const roles = Array.isArray(ownerCompensation.replacementRoles) ? ownerCompensation.replacementRoles : [];
                      const setRoles = (next) => setOwnerCompensation({ ...ownerCompensation, replacementRoles: next,
                        marketReplacement: next.length ? next.reduce((s, r) => s + (Number(r.salary) || 0), 0) : ownerCompensation.marketReplacement });
                      if (!roles.length) return (
                        <>
                          <CurrencyInput value={ownerCompensation.marketReplacement} onChange={v => setOwnerCompensation({...ownerCompensation, marketReplacement: v})} className="w-full p-1 border rounded text-sm" />
                          <button type="button" className="mt-1 text-[11px] text-blue-700 hover:underline"
                            title="The owner does more than one job (e.g. runs the company AND bills as a tech) — replace each role separately."
                            onClick={() => setRoles([{ id: Date.now(), role: 'Manager / GM', salary: ownerCompensation.marketReplacement || 0 }, { id: Date.now() + 1, role: 'Second role (e.g. billable tech)', salary: 0 }])}>+ Split into roles</button>
                        </>
                      );
                      return (
                        <div className="space-y-1">
                          {roles.map((r, i) => (
                            <div key={r.id || i} className="flex items-center gap-1">
                              <input type="text" value={r.role || ''} onChange={e => setRoles(roles.map((x, j) => j === i ? { ...x, role: e.target.value } : x))} className="flex-1 p-1 border rounded text-xs" placeholder="Role" />
                              <div className="w-28"><CurrencyInput value={r.salary || 0} onChange={v => setRoles(roles.map((x, j) => j === i ? { ...x, salary: v } : x))} className="w-full p-1 border rounded text-xs" /></div>
                              <button type="button" className="text-gray-400 hover:text-red-600 text-xs px-1" title="Remove this role" onClick={() => setRoles(roles.filter((_, j) => j !== i))}>✕</button>
                            </div>
                          ))}
                          <div className="flex items-center justify-between text-xs">
                            <button type="button" className="text-blue-700 hover:underline" onClick={() => setRoles([...roles, { id: Date.now(), role: '', salary: 0 }])}>+ Add a role</button>
                            <span className="font-semibold text-gray-700">Total {formatCurrency(roles.reduce((s, r) => s + (Number(r.salary) || 0), 0))}</span>
                          </div>
                          <div className="text-[11px] text-gray-500">Salaries only — handle benefits for each role the way you do for this company. Small business / owner-operator buyer? One role may be right; remove the extra.</div>
                        </div>
                      );
                    })()}
                  </div>
                  
                  {/* Payroll Tax Adjustment */}
                  <div className="bg-purple-50 p-2 rounded border border-purple-200">
                    <label className="flex items-center gap-2 text-xs font-medium text-purple-800 mb-1">
                      <input 
                        type="checkbox" 
                        checked={ownerCompensation.includePayrollTax !== false} 
                        onChange={e => setOwnerCompensation({...ownerCompensation, includePayrollTax: e.target.checked})} 
                        className="rounded"
                      />
                      Include Employer Payroll Tax Adjustment
                    </label>
                    {ownerCompensation.includePayrollTax !== false && (
                      <div className="ml-5">
                        <div className="flex items-center gap-2 mb-1">
                          <label className="text-xs text-gray-600">Tax Rate:</label>
                          <input 
                            type="number" 
                            step="0.1" 
                            min="0" 
                            max="20" 
                            value={ownerCompensation.payrollTaxRate || 7.65} 
                            onChange={e => setOwnerCompensation({...ownerCompensation, payrollTaxRate: parseFloat(e.target.value) || 7.65})} 
                            className="w-16 p-0.5 border rounded text-xs text-center"
                          />
                          <span className="text-xs text-gray-500">%</span>
                          <span className="text-xs text-gray-400">(SS 6.2% up to the year's wage base + Medicare 1.45% on all pay)</span>
                        </div>
                        {/* Per person (Mark 10-23, Arakyta): Social Security caps EACH person's pay. */}
                        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-1 text-xs text-gray-600">
                          <label className="flex items-center gap-1">People in the owner salary:
                            <input type="number" min="1" max="20" step="1" value={ownerCompensation.ownerCount ?? ''} placeholder="1"
                              onChange={e => setOwnerCompensation({ ...ownerCompensation, ownerCount: e.target.value === '' ? null : Math.max(1, parseInt(e.target.value, 10) || 1) })}
                              className="w-12 p-0.5 border rounded text-center" /></label>
                          {(Array.isArray(ownerCompensation.replacementRoles) && ownerCompensation.replacementRoles.some(r => Number(r && r.salary) > 0))
                            ? <span>Replacement: {ownerCompensation.replacementRoles.filter(r => Number(r && r.salary) > 0).length} role(s), each taxed on its own</span>
                            : <label className="flex items-center gap-1">People the replacement covers:
                                <input type="number" min="1" max="20" step="1" value={ownerCompensation.replacementCount ?? ''} placeholder="1"
                                  onChange={e => setOwnerCompensation({ ...ownerCompensation, replacementCount: e.target.value === '' ? null : Math.max(1, parseInt(e.target.value, 10) || 1) })}
                                  className="w-12 p-0.5 border rounded text-center" /></label>}
                        </div>
                        {(() => {
                          const salaryDiff = (ownerCompensation.ttm?.salary || 0) - mkFor('ttm');
                          const payrollTaxAdj = -ownerTaxAdj(ownerCompensation.ttm?.salary || 0, mkFor('ttm'), 'ttm');
                          if (salaryDiff === 0) return <div className="text-xs text-gray-500">No salary differential</div>;
                          return (
                            <div className="text-xs">
                              <span className="text-purple-700">
                                {payrollTaxMethod === 'flat' ? formatCurrency(Math.abs(salaryDiff)) + ' × ' + (ownerCompensation.payrollTaxRate || 7.65) + '% = ' : 'Tax on owner pay − tax on the replacement = '}
                              </span>
                              <span className={`font-bold ml-1 ${payrollTaxAdj > 0 ? 'text-green-700' : 'text-red-700'}`}>
                                {payrollTaxAdj > 0 ? '+' : ''}{formatCurrency(payrollTaxAdj)}
                              </span>
                              <span className="text-gray-500 ml-1">({payrollTaxAdj > 0 ? 'add-back' : 'expense'})</span>
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                  
                  <div className="bg-blue-100 p-2 rounded text-sm">
                    <div className="font-medium text-green-800">Owner Salary Adjustment (TTM)</div>
                    {(() => {
                      const salaryDiff = (ownerCompensation.ttm?.salary || 0) - mkFor('ttm');
                      const payrollTaxAdj = -ownerTaxAdj(ownerCompensation.ttm?.salary || 0, mkFor('ttm'), 'ttm');
                      const totalAdj = salaryDiff + payrollTaxAdj;
                      
                      return (
                        <>
                          <div className="text-lg font-bold text-green-900">
                            {totalAdj > 0 ? '+' : (totalAdj < 0 ? '-' : '')}{formatCurrency(Math.abs(totalAdj))}
                          </div>
                          <div className="text-xs text-green-700">
                            Salary: {formatCurrency(ownerCompensation.ttm?.salary || 0)} → Market: {formatCurrency(mkFor('ttm') || 0)}
                            {ownerCompensation.includePayrollTax !== false && payrollTaxAdj !== 0 && (
                              <span className="ml-1">+ Tax: {formatCurrency(Math.abs(payrollTaxAdj))}</span>
                            )}
                          </div>
                          <div className="text-xs text-green-600 mt-1">
                            (EBITDA {totalAdj > 0 ? '+' : '-'}{formatCurrency(Math.abs(totalAdj))})
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <label className="block text-xs font-medium text-gray-600 mb-1">💡 Rate Justification <span className="text-gray-400">(shown in presentation)</span></label>
                <textarea 
                  value={ownerCompensation.marketReplacementNotes} 
                  onChange={e => setOwnerCompensation({...ownerCompensation, marketReplacementNotes: e.target.value})} 
                  placeholder="Explain why this rate was chosen — e.g., owner's role, hours worked, existing management in place, comparable salary data, scope of duties being replaced..."
                  className="w-full p-2 border rounded text-xs" 
                  rows={3}
                />
              </div>
            </div>

            {/* Summary Stats - TTM Focused */}
            <div className="grid grid-cols-5 gap-2 mb-4">
              {(() => {
                // Get TTM values from calculations
                const ttmRevenue = calculations.years[5]?.revenue || 0;
                const ttmActualEbitda = calculations.years[5]?.ebitda || 0;
                const ttmNormalizedEbitda = calculations.years[5]?.adjustedEbitda || 0;
                
                // Net EBITDA adjustment = Normalized - Actual (captures everything including owner salary)
                const netEbitdaAdjustment = ttmNormalizedEbitda - ttmActualEbitda;
                
                // TTM-only adjustments (filter for TTM or All Years)
                const ttmDeductions = adjustmentItems.filter(a => 
                  a.included && a.type === 'deduct' && a.plLine !== 'Revenue' && 
                  (a.year === 'TTM' || a.year === 'All Years')
                ).reduce((sum, a) => sum + a.amount, 0);
                
                const ttmAdditions = adjustmentItems.filter(a => 
                  a.included && a.type === 'add' && a.plLine !== 'Revenue' && 
                  (a.year === 'TTM' || a.year === 'All Years')
                ).reduce((sum, a) => sum + a.amount, 0);
                
                const pctOfRevenue = (val) => ttmRevenue > 0 ? ((val / ttmRevenue) * 100).toFixed(1) : '0.0';
                const pctOfEbitda = (val) => ttmActualEbitda > 0 ? ((val / ttmActualEbitda) * 100).toFixed(1) : '0.0';
                
                return (
                  <>
                    <div className="bg-blue-50 p-2 rounded-lg border-l-4 border-blue-400">
                      <div className="text-xs text-green-600 font-semibold">TTM Expense Deductions (+EBITDA)</div>
                      <div className="text-lg font-bold text-green-900">{formatCurrency(ttmDeductions)}</div>
                      <div className="text-xs text-green-600">{pctOfRevenue(ttmDeductions)}% of Rev • {pctOfEbitda(ttmDeductions)}% of EBITDA</div>
                    </div>
                    <div className="bg-amber-50 p-2 rounded-lg border-l-4 border-amber-500">
                      <div className="text-xs text-red-600 font-semibold">TTM Expense Additions (-EBITDA)</div>
                      <div className="text-lg font-bold text-red-900">{formatCurrency(ttmAdditions)}</div>
                      <div className="text-xs text-red-600">{pctOfRevenue(ttmAdditions)}% of Rev • {pctOfEbitda(ttmAdditions)}% of EBITDA</div>
                    </div>
                    <div className="bg-slate-50 p-2 rounded-lg border-l-4 border-slate-400">
                      <div className="text-xs text-purple-600 font-semibold">Net EBITDA Adjustment (TTM)</div>
                      <div className={`text-lg font-bold ${netEbitdaAdjustment >= 0 ? 'text-green-900' : 'text-red-900'}`}>
                        {netEbitdaAdjustment >= 0 ? '+' : ''}{formatCurrency(netEbitdaAdjustment)}
                      </div>
                      <div className="text-xs text-purple-600">{pctOfRevenue(Math.abs(netEbitdaAdjustment))}% of Rev • {pctOfEbitda(Math.abs(netEbitdaAdjustment))}% of EBITDA</div>
                    </div>
                    <div className="bg-blue-50 p-2 rounded-lg border-l-4 border-blue-500">
                      <div className="text-xs text-blue-600 font-semibold">Documented</div>
                      <div className="text-lg font-bold text-blue-900">{adjustmentItems.filter(a => a.included && a.source).length}</div>
                      <div className="text-xs text-blue-600">of {adjustmentItems.filter(a => a.included).length} adjustments</div>
                    </div>
                    <div className="bg-gray-50 p-2 rounded-lg border-l-4 border-gray-400">
                      <div className="text-xs text-gray-600 font-semibold">Excluded</div>
                      <div className="text-lg font-bold text-gray-900">{adjustmentItems.filter(a => !a.included).length}</div>
                      <div className="text-xs text-gray-600">items</div>
                    </div>
                  </>
                );
              })()}
            </div>

            {/* Category Breakdown */}
            {(() => {
              const includedAdj = adjustmentItems.filter(a => a.included);
              const totalAmount = includedAdj.reduce((sum, a) => sum + a.amount, 0);
              const categoryTotals = {};
              includedAdj.forEach(a => {
                const cat = a.category || 'Other';
                categoryTotals[cat] = (categoryTotals[cat] || 0) + a.amount;
              });
              const sortedCategories = Object.entries(categoryTotals).sort((a, b) => b[1] - a[1]);
              
              if (sortedCategories.length === 0) return null;
              
              return (
                <div className="mb-4 p-3 bg-gray-50 rounded-lg border">
                  <h4 className="font-semibold text-gray-700 mb-2 text-sm">Category Breakdown</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <table className="text-xs">
                      <thead>
                        <tr className="border-b">
                          <th className="text-left p-1">Category</th>
                          <th className="text-right p-1">Amount</th>
                          <th className="text-right p-1">%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedCategories.map(([cat, amt]) => (
                          <tr key={cat} className="border-b border-gray-200">
                            <td className="p-1">{cat}</td>
                            <td className="p-1 text-right">{formatCurrency(amt)}</td>
                            <td className="p-1 text-right font-semibold">{totalAmount > 0 ? ((amt / totalAmount) * 100).toFixed(0) : 0}%</td>
                          </tr>
                        ))}
                        <tr className="font-bold bg-gray-100">
                          <td className="p-1">Total</td>
                          <td className="p-1 text-right">{formatCurrency(totalAmount)}</td>
                          <td className="p-1 text-right">100%</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="flex flex-col justify-center">
                      {sortedCategories.map(([cat, amt]) => {
                        const pct = totalAmount > 0 ? (amt / totalAmount) * 100 : 0;
                        const colors = {
                          'Non-Recurring Expense': 'bg-blue-500',
                          'Owner Benefits': 'bg-blue-600',
                          'Personal Expense': 'bg-blue-400',
                          'Discretionary Expense': 'bg-blue-300',
                          'Related Party (Above Market)': 'bg-slate-500',
                          'Above Market Rent': 'bg-slate-400',
                          'Non-Operating': 'bg-gray-500',
                          'Below Market Rent': 'bg-slate-600',
                          'Below Market Salary': 'bg-slate-700',
                          'Missing Expense': 'bg-slate-500',
                          'Maintenance CapEx': 'bg-slate-400',
                          'Non-Recurring Revenue': 'bg-blue-200',
                          'Lost Customer': 'bg-slate-300',
                          'Revenue Adjustment': 'bg-blue-100',
                          'Other': 'bg-gray-400',
                          'One-Time Expense': 'bg-blue-500' // Legacy support
                        };
                        return (
                          <div key={cat} className="flex items-center gap-2 mb-1">
                            <div className="w-20 text-xs truncate">{cat}</div>
                            <div className="flex-1 h-4 bg-gray-200 rounded overflow-hidden">
                              <div className={`h-full ${colors[cat] || 'bg-gray-500'}`} style={{ width: `${pct}%` }} />
                            </div>
                            <div className="w-10 text-xs text-right">{pct.toFixed(0)}%</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* Line-Based Expense Adjustments - Editable & Collapsible */}
            <div className="mb-4 p-3 bg-green-50 rounded-lg border border-green-200">
              <h4 
                className="font-semibold text-green-800 mb-2 text-sm flex items-center gap-2 cursor-pointer select-none"
                onClick={() => setExpandedSections(prev => ({ ...prev, lineAddbacks: !prev.lineAddbacks }))}
              >
                <span className="text-lg">{expandedSections.lineAddbacks ? '▼' : '▶'}</span>
                📊 Line-Based P&L Adjustments
                <span className="text-xs font-normal text-green-600">(Adjust % of existing P&L lines across all periods)</span>
                {!expandedSections.lineAddbacks && (() => {
                  const allCategories = [...opexCategories, ...otherExpenseCategories, ...otherIncomeCategories];
                  const activeItems = allCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false);
                  const excludedCount = allCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded === false).length;
                  return (
                    <>
                      {activeItems.length > 0 && <span className="ml-2 px-2 py-0.5 bg-green-200 text-green-800 rounded text-xs">{activeItems.length} included</span>}
                      {excludedCount > 0 && <span className="ml-1 px-2 py-0.5 bg-gray-200 text-gray-600 rounded text-xs">{excludedCount} excluded</span>}
                    </>
                  );
                })()}
              </h4>
              
              {/* Always show active adjustments, even when collapsed */}
              {!expandedSections.lineAddbacks && (() => {
                const allCategories = [...opexCategories, ...otherExpenseCategories, ...otherIncomeCategories];
                const activeItems = allCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0);
                if (activeItems.length === 0) return null;
                
                return (
                  <div className="mt-2 overflow-x-auto">
                    <table className="w-full text-xs border-collapse">
                      <thead className="bg-green-100">
                        <tr>
                          <th className="p-1 border w-6 text-center">✓</th>
                          <th className="p-1 border text-left">P&L Line</th>
                          <th className="p-1 border text-center w-14">Adj %</th>
                          <th className="p-1 border text-left w-28">Category</th>
                          <th className="p-1 border text-right w-24 bg-green-200">TTM Adj.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {activeItems.map(cat => {
                          const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
                          const ttmAddback = ttmValue * ((cat.addbackPct || 0) / 100);
                          const isIncluded = cat.adjIncluded !== false;
                          const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                          const isVerified = cat.adjVerSource && cat.adjVerSource !== '';
                          const isOtherExpense = otherExpenseCategories.some(c => c.id === cat.id);
                          const isOtherIncome = otherIncomeCategories.some(c => c.id === cat.id);
                          
                          return (
                            <tr key={cat.id} className={!isIncluded ? 'bg-gray-100 opacity-60' : isDiat ? 'bg-amber-50' : isOtherIncome ? 'bg-blue-50' : isOtherExpense ? 'bg-purple-50' : 'bg-green-50'}>
                              <td className="p-1 border text-center">
                                <input 
                                  type="checkbox" 
                                  checked={isIncluded}
                                  onChange={e => {
                                    if (isOtherIncome) {
                                      setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjIncluded: e.target.checked} : c));
                                    } else if (isOtherExpense) {
                                      setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjIncluded: e.target.checked} : c));
                                    } else {
                                      setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjIncluded: e.target.checked} : c));
                                    }
                                  }}
                                  className="rounded"
                                  title={isIncluded ? 'Included in calculations' : 'Excluded from calculations'}
                                />
                              </td>
                              <td className={`p-1 border font-medium ${!isIncluded ? 'line-through text-gray-500' : ''}`}>
                                {cat.name}
                                {isOtherIncome && <span className="ml-1 text-blue-500 text-xs">(OI)</span>}
                                {isOtherExpense && <span className="ml-1 text-purple-500 text-xs">(OE)</span>}
                                {isVerified && <span className="ml-1 text-green-600">✓</span>}
                              </td>
                              <td className="p-1 border text-center">{cat.addbackPct}%</td>
                              <td className="p-1 border text-xs">{cat.adjCategory || '-'}</td>
                              <td className={`p-1 border text-right font-bold ${!isIncluded ? 'text-gray-400 line-through' : isOtherIncome ? 'text-red-700 bg-red-100' : isDiat ? 'text-amber-800 bg-amber-100' : 'text-green-800 bg-green-100'}`}>
                                {isOtherIncome ? `-${formatCurrency(ttmAddback)}` : `+${formatCurrency(ttmAddback)}`}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                );
              })()}
              
              {expandedSections.lineAddbacks && (
                <>
                  <p className="text-xs text-gray-600 mb-2">
                    Use this for recurring expenses like depreciation, amortization, interest, taxes, or owner benefits that should be added back. Select D/I/A/T categories for EBITDA calculation.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs border-collapse">
                      <thead className="bg-green-100">
                        <tr>
                          <th className="p-1 border w-6 text-center" title="Include in calculations">✓</th>
                          <th className="p-1 border text-left w-36">Expense Line</th>
                          <th className="p-1 border text-center w-16">Adj %</th>
                          <th className="p-1 border text-left w-28">Category</th>
                          <th className="p-1 border text-left">Description</th>
                          <th className="p-1 border text-left w-24">Ver. Source</th>
                          <th className="p-1 border text-left w-24">Doc Ref</th>
                          <th className="p-1 border text-right w-24 bg-green-200">TTM Adj.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Operating Expenses Section Header */}
                        <tr className="bg-red-100">
                          <td colSpan={8} className="p-1 border font-semibold text-red-800">Operating Expenses</td>
                        </tr>
                        {opexCategories.filter(cat => cat.name && cat.name.trim() !== '').map(cat => {
                          const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
                          const ttmAddback = ttmValue * ((cat.addbackPct || 0) / 100);
                          const hasAddback = (cat.addbackPct || 0) > 0;
                          const isIncluded = cat.adjIncluded !== false;
                          const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                          const isVerified = cat.adjVerSource && cat.adjVerSource !== '';
                          const needsDetails = hasAddback && isIncluded && (!cat.adjCategory || !cat.adjVerSource);
                          return (
                            <tr key={cat.id} className={
                              !hasAddback ? 'bg-white hover:bg-gray-50' :
                              !isIncluded ? 'bg-gray-100 opacity-60' :
                              needsDetails ? 'bg-amber-50 border-l-4 border-l-amber-400' :
                              isDiat ? 'bg-amber-50' : 'bg-green-50'
                            }>
                              <td className="p-1 border text-center">
                                {hasAddback && (
                                  <input 
                                    type="checkbox" 
                                    checked={isIncluded}
                                    onChange={e => setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjIncluded: e.target.checked} : c))}
                                    className="rounded"
                                    title={isIncluded ? 'Included in calculations' : 'Excluded from calculations'}
                                  />
                                )}
                              </td>
                              <td className={`p-1 border font-medium ${!isIncluded && hasAddback ? 'line-through text-gray-500' : ''}`}>
                                {cat.name}
                                {isVerified && hasAddback && <span className="ml-1 text-green-600" title="Verified">✓</span>}
                              </td>
                              <td className="p-1 border text-center">
                                <div className="flex items-center justify-center">
                                  <input 
                                    type="number" 
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    value={cat.addbackPct || ''} 
                                    onChange={e => setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, addbackPct: Math.min(100, Math.max(0, Math.round((parseFloat(e.target.value) || 0) * 100) / 100)), adjIncluded: c.adjIncluded !== false ? true : c.adjIncluded} : c))} 
                                    className={`w-10 p-0.5 border rounded text-xs text-center ${hasAddback ? 'bg-green-100 font-bold text-green-800 border-green-400' : 'bg-white'}`}
                                    placeholder="0"
                                  />
                                  <span className="text-gray-400 ml-0.5">%</span>
                                </div>
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <select
                                    value={cat.adjCategory || ''}
                                    onChange={e => setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjCategory: e.target.value} : c))}
                                    className={`w-full p-0.5 border rounded text-xs ${!cat.adjCategory && needsDetails ? 'border-amber-400 bg-amber-50' : ''}`}
                                    disabled={!isIncluded}
                                  >
                                    <option value="">Select...</option>
                                    <optgroup label="Deduct from Expenses (+EBITDA)">
                                      <option value="Owner Benefits">Owner Benefits</option>
                                      <option value="Non-Recurring Expense">Non-Recurring Expense</option>
                                      <option value="Personal Expense">Personal Expense</option>
                                      <option value="Discretionary Expense">Discretionary Expense</option>
                                      <option value="Related Party (Above Market)">Related Party (Above Mkt)</option>
                                      <option value="Above Market Rent">Above Market Rent</option>
                                      <option value="Non-Operating">Non-Operating</option>
                                    </optgroup>
                                    <optgroup label="D/I/A/T (+EBITDA)">
                                      <option value="Depreciation">Depreciation</option>
                                      <option value="Interest">Interest</option>
                                      <option value="Amortization">Amortization</option>
                                      <option value="Taxes">Taxes</option>
                                    </optgroup>
                                    <option value="Other">Other</option>
                                  </select>
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <input
                                    type="text"
                                    value={cat.adjDescription || ''}
                                    onChange={e => setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjDescription: e.target.value} : c))}
                                    className="w-full p-0.5 border rounded text-xs"
                                    placeholder="Describe adjustment..."
                                    disabled={!isIncluded}
                                  />
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <select
                                    value={cat.adjVerSource || ''}
                                    onChange={e => setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjVerSource: e.target.value} : c))}
                                    className={`w-full p-0.5 border rounded text-xs ${!cat.adjVerSource && needsDetails ? 'border-amber-400 bg-amber-50' : ''}`}
                                    disabled={!isIncluded}
                                  >
                                    <option value="">Select...</option>
                                    <option value="P&L">P&L Statement</option>
                                    <option value="Tax Return">Tax Return</option>
                                    <option value="Bank Statement">Bank Statement</option>
                                    <option value="GL Detail">GL Detail</option>
                                    <option value="Invoice">Invoice/Receipt</option>
                                    <option value="Contract">Contract</option>
                                    <option value="Seller Interview">Seller Interview</option>
                                    <option value="Other">Other</option>
                                  </select>
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <input
                                    type="text"
                                    value={cat.adjDocRef || ''}
                                    onChange={e => setOpexCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjDocRef: e.target.value} : c))}
                                    className="w-full p-0.5 border rounded text-xs"
                                    placeholder="Doc ref..."
                                    disabled={!isIncluded}
                                  />
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className={`p-1 border text-right font-bold ${
                                !hasAddback ? 'text-gray-400' : 
                                !isIncluded ? 'text-gray-400 line-through' :
                                isDiat ? 'text-amber-800 bg-amber-100' : 'text-green-800 bg-green-100'
                              }`}>
                                {hasAddback ? `+${formatCurrency(ttmAddback)}` : '-'}
                              </td>
                            </tr>
                          );
                        })}
                        {/* Other Income Section Header */}
                        <tr className="bg-blue-100">
                          <td colSpan={8} className="p-1 border font-semibold text-blue-800">Other Income (deductions remove non-operating income)</td>
                        </tr>
                        {otherIncomeCategories.filter(cat => cat.name && cat.name.trim() !== '').map(cat => {
                          const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
                          const ttmDeduction = ttmValue * ((cat.addbackPct || 0) / 100);
                          const hasAddback = (cat.addbackPct || 0) > 0;
                          const isIncluded = cat.adjIncluded !== false;
                          const isVerified = cat.adjVerSource && cat.adjVerSource !== '';
                          const needsDetails = hasAddback && isIncluded && (!cat.adjCategory || !cat.adjVerSource);
                          return (
                            <tr key={cat.id} className={
                              !hasAddback ? 'bg-white hover:bg-gray-50' :
                              !isIncluded ? 'bg-gray-100 opacity-60' :
                              needsDetails ? 'bg-amber-50 border-l-4 border-l-amber-400' :
                              'bg-blue-50'
                            }>
                              <td className="p-1 border text-center">
                                {hasAddback && (
                                  <input 
                                    type="checkbox" 
                                    checked={isIncluded}
                                    onChange={e => setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjIncluded: e.target.checked} : c))}
                                    className="rounded"
                                    title={isIncluded ? 'Included in calculations' : 'Excluded from calculations'}
                                  />
                                )}
                              </td>
                              <td className={`p-1 border font-medium ${!isIncluded && hasAddback ? 'line-through text-gray-500' : ''}`}>
                                {cat.name}
                                {isVerified && hasAddback && <span className="ml-1 text-green-600" title="Verified">✓</span>}
                              </td>
                              <td className="p-1 border text-center">
                                <div className="flex items-center justify-center gap-0.5">
                                  <input 
                                    type="number" 
                                    value={cat.addbackPct || 0}
                                    onChange={e => setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, addbackPct: Math.min(100, Math.max(0, parseFloat(e.target.value) || 0))} : c))}
                                    className={`w-12 p-0.5 border rounded text-xs text-center ${hasAddback ? 'bg-orange-50 font-bold text-orange-800' : ''}`}
                                    min="0" max="100"
                                  />
                                  <span className="text-xs text-gray-500">%</span>
                                </div>
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <select 
                                    value={cat.adjCategory || ''}
                                    onChange={e => setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjCategory: e.target.value} : c))}
                                    className={`w-full p-0.5 border rounded text-xs ${!cat.adjCategory && isIncluded ? 'border-amber-400 bg-amber-50' : ''}`}
                                    disabled={!isIncluded}
                                  >
                                    <option value="">Select...</option>
                                    <option value="Interest">Interest Income</option>
                                    <option value="Non-Recurring">Non-Recurring</option>
                                    <option value="Non-Operating">Non-Operating</option>
                                    <option value="Related Party">Related Party</option>
                                    <option value="Other">Other</option>
                                  </select>
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <input
                                    type="text"
                                    value={cat.adjDescription || ''}
                                    onChange={e => setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjDescription: e.target.value} : c))}
                                    className="w-full p-0.5 border rounded text-xs"
                                    placeholder="EBITDA adjustment"
                                    disabled={!isIncluded}
                                  />
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <select
                                    value={cat.adjVerSource || ''}
                                    onChange={e => setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjVerSource: e.target.value} : c))}
                                    className={`w-full p-0.5 border rounded text-xs ${!cat.adjVerSource && isIncluded ? 'border-amber-400 bg-amber-50' : ''}`}
                                    disabled={!isIncluded}
                                  >
                                    <option value="">Select...</option>
                                    <option value="P&L">P&L Statement</option>
                                    <option value="Tax Return">Tax Return</option>
                                    <option value="Bank Statement">Bank Statement</option>
                                    <option value="GL Detail">GL Detail</option>
                                    <option value="Invoice">Invoice/Receipt</option>
                                    <option value="Contract">Contract</option>
                                    <option value="Seller Interview">Seller Interview</option>
                                    <option value="Other">Other</option>
                                  </select>
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <input
                                    type="text"
                                    value={cat.adjDocRef || ''}
                                    onChange={e => setOtherIncomeCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjDocRef: e.target.value} : c))}
                                    className="w-full p-0.5 border rounded text-xs"
                                    placeholder="Doc ref..."
                                    disabled={!isIncluded}
                                  />
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className={`p-1 border text-right font-bold ${
                                !hasAddback ? 'text-gray-400' : 
                                !isIncluded ? 'text-gray-400 line-through' :
                                'text-red-700 bg-red-100'
                              }`}>
                                {hasAddback ? `-${formatCurrency(ttmDeduction)}` : '-'}
                              </td>
                            </tr>
                          );
                        })}
                        {/* Other Expense Section Header */}
                        <tr className="bg-purple-100">
                          <td colSpan={8} className="p-1 border font-semibold text-purple-800">Other Expense</td>
                        </tr>
                        {otherExpenseCategories.filter(cat => cat.name && cat.name.trim() !== '').map(cat => {
                          const ttmValue = cat[selectedValuationBasis]?.ttm || 0;
                          const ttmAddback = ttmValue * ((cat.addbackPct || 0) / 100);
                          const hasAddback = (cat.addbackPct || 0) > 0;
                          const isIncluded = cat.adjIncluded !== false;
                          const isDiat = ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory);
                          const isVerified = cat.adjVerSource && cat.adjVerSource !== '';
                          const needsDetails = hasAddback && isIncluded && (!cat.adjCategory || !cat.adjVerSource);
                          return (
                            <tr key={cat.id} className={
                              !hasAddback ? 'bg-white hover:bg-gray-50' :
                              !isIncluded ? 'bg-gray-100 opacity-60' :
                              needsDetails ? 'bg-amber-50 border-l-4 border-l-amber-400' :
                              isDiat ? 'bg-amber-50' : 'bg-purple-50'
                            }>
                              <td className="p-1 border text-center">
                                {hasAddback && (
                                  <input 
                                    type="checkbox" 
                                    checked={isIncluded}
                                    onChange={e => setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjIncluded: e.target.checked} : c))}
                                    className="rounded"
                                    title={isIncluded ? 'Included in calculations' : 'Excluded from calculations'}
                                  />
                                )}
                              </td>
                              <td className={`p-1 border font-medium ${!isIncluded && hasAddback ? 'line-through text-gray-500' : ''}`}>
                                {cat.name}
                                {isVerified && hasAddback && <span className="ml-1 text-green-600" title="Verified">✓</span>}
                              </td>
                              <td className="p-1 border text-center">
                                <div className="flex items-center justify-center">
                                  <input 
                                    type="number" 
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    value={cat.addbackPct || ''} 
                                    onChange={e => setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, addbackPct: Math.min(100, Math.max(0, Math.round((parseFloat(e.target.value) || 0) * 100) / 100)), adjIncluded: c.adjIncluded !== false ? true : c.adjIncluded} : c))} 
                                    className={`w-10 p-0.5 border rounded text-xs text-center ${hasAddback ? 'bg-purple-100 font-bold text-purple-800 border-purple-400' : 'bg-white'}`}
                                    placeholder="0"
                                  />
                                  <span className="text-gray-400 ml-0.5">%</span>
                                </div>
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <select
                                    value={cat.adjCategory || ''}
                                    onChange={e => setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjCategory: e.target.value} : c))}
                                    className={`w-full p-0.5 border rounded text-xs ${!cat.adjCategory && needsDetails ? 'border-amber-400 bg-amber-50' : ''}`}
                                    disabled={!isIncluded}
                                  >
                                    <option value="">Select...</option>
                                    <optgroup label="Deduct from Expenses (+EBITDA)">
                                      <option value="Owner Benefits">Owner Benefits</option>
                                      <option value="Non-Recurring Expense">Non-Recurring Expense</option>
                                      <option value="Personal Expense">Personal Expense</option>
                                      <option value="Discretionary Expense">Discretionary Expense</option>
                                      <option value="Related Party (Above Market)">Related Party (Above Mkt)</option>
                                      <option value="Above Market Rent">Above Market Rent</option>
                                      <option value="Non-Operating">Non-Operating</option>
                                    </optgroup>
                                    <optgroup label="D/I/A/T (+EBITDA)">
                                      <option value="Depreciation">Depreciation</option>
                                      <option value="Interest">Interest</option>
                                      <option value="Amortization">Amortization</option>
                                      <option value="Taxes">Taxes</option>
                                    </optgroup>
                                    <option value="Other">Other</option>
                                  </select>
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <input
                                    type="text"
                                    value={cat.adjDescription || ''}
                                    onChange={e => setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjDescription: e.target.value} : c))}
                                    className="w-full p-0.5 border rounded text-xs"
                                    placeholder="Describe adjustment..."
                                    disabled={!isIncluded}
                                  />
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <select
                                    value={cat.adjVerSource || ''}
                                    onChange={e => setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjVerSource: e.target.value} : c))}
                                    className={`w-full p-0.5 border rounded text-xs ${!cat.adjVerSource && needsDetails ? 'border-amber-400 bg-amber-50' : ''}`}
                                    disabled={!isIncluded}
                                  >
                                    <option value="">Select...</option>
                                    <option value="P&L">P&L Statement</option>
                                    <option value="Tax Return">Tax Return</option>
                                    <option value="Bank Statement">Bank Statement</option>
                                    <option value="GL Detail">GL Detail</option>
                                    <option value="Invoice">Invoice/Receipt</option>
                                    <option value="Contract">Contract</option>
                                    <option value="Seller Interview">Seller Interview</option>
                                    <option value="Other">Other</option>
                                  </select>
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className="p-1 border">
                                {hasAddback ? (
                                  <input
                                    type="text"
                                    value={cat.adjDocRef || ''}
                                    onChange={e => setOtherExpenseCategories(prev => prev.map(c => c.id === cat.id ? {...c, adjDocRef: e.target.value} : c))}
                                    className="w-full p-0.5 border rounded text-xs"
                                    placeholder="Doc ref..."
                                    disabled={!isIncluded}
                                  />
                                ) : <span className="text-gray-300">-</span>}
                              </td>
                              <td className={`p-1 border text-right font-bold ${
                                !hasAddback ? 'text-gray-400' : 
                                !isIncluded ? 'text-gray-400 line-through' :
                                isDiat ? 'text-amber-800 bg-amber-100' : 'text-purple-800 bg-purple-100'
                              }`}>
                                {hasAddback ? `+${formatCurrency(ttmAddback)}` : '-'}
                              </td>
                            </tr>
                          );
                        })}
                        {/* DIAT Totals row */}
                        {(() => {
                          const allExpenseCategories = [...opexCategories, ...otherExpenseCategories];
                          const diatAddbacks = allExpenseCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && ['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory));
                          if (diatAddbacks.length === 0) return null;
                          const unverifiedDiat = diatAddbacks.filter(cat => !cat.adjVerSource).length;
                          return (
                            <tr className="bg-amber-200 font-bold">
                              <td className="p-1 border text-center">
                                {unverifiedDiat > 0 && <span className="text-amber-700" title={`${unverifiedDiat} need verification source`}>⚠</span>}
                              </td>
                              <td className="p-1 border" colSpan={2}>Total D/I/A/T Adjustments</td>
                              <td className="p-1 border text-center text-amber-800" colSpan={4}>{diatAddbacks.length} line{diatAddbacks.length !== 1 ? 's' : ''}</td>
                              <td className="p-1 border text-right text-amber-900 bg-amber-300">
                                +{formatCurrency(diatAddbacks.reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.ttm || 0) * (cat.addbackPct / 100)), 0))}
                              </td>
                            </tr>
                          );
                        })()}
                        {/* Other Add-backs Totals row */}
                        {(() => {
                          const allExpenseCategories = [...opexCategories, ...otherExpenseCategories];
                          const otherAddbacks = allExpenseCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && !['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory));
                          if (otherAddbacks.length === 0) return null;
                          const unverifiedOther = otherAddbacks.filter(cat => !cat.adjVerSource).length;
                          return (
                            <tr className="bg-green-200 font-bold">
                              <td className="p-1 border text-center">
                                {unverifiedOther > 0 && <span className="text-amber-700" title={`${unverifiedOther} need verification source`}>⚠</span>}
                              </td>
                              <td className="p-1 border" colSpan={2}>Total Other Adjustments</td>
                              <td className="p-1 border text-center text-green-800" colSpan={4}>{otherAddbacks.length} line{otherAddbacks.length !== 1 ? 's' : ''}</td>
                              <td className="p-1 border text-right text-green-900 bg-green-300">
                                +{formatCurrency(otherAddbacks.reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.ttm || 0) * (cat.addbackPct / 100)), 0))}
                              </td>
                            </tr>
                          );
                        })()}
                        {/* Other Income Deductions Total row */}
                        {(() => {
                          const oiDeductions = otherIncomeCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false);
                          if (oiDeductions.length === 0) return null;
                          const unverifiedOI = oiDeductions.filter(cat => !cat.adjVerSource).length;
                          return (
                            <tr className="bg-red-200 font-bold">
                              <td className="p-1 border text-center">
                                {unverifiedOI > 0 && <span className="text-amber-700" title={`${unverifiedOI} need verification source`}>⚠</span>}
                              </td>
                              <td className="p-1 border" colSpan={2}>Total Other Income Deductions</td>
                              <td className="p-1 border text-center text-red-800" colSpan={4}>{oiDeductions.length} line{oiDeductions.length !== 1 ? 's' : ''}</td>
                              <td className="p-1 border text-right text-red-900 bg-red-300">
                                -{formatCurrency(oiDeductions.reduce((sum, cat) => sum + ((cat[selectedValuationBasis]?.ttm || 0) * (cat.addbackPct / 100)), 0))}
                              </td>
                            </tr>
                          );
                        })()}
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-between items-center mt-2">
                    <p className="text-xs text-green-700">💡 D/I/A/T categories are added to Net Income to calculate EBITDA. Other Income deductions remove non-operating income from EBITDA.</p>
                    {(() => {
                      const allCategories = [...opexCategories, ...otherExpenseCategories, ...otherIncomeCategories];
                      const activeItems = allCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false);
                      const needsDetailsCount = activeItems.filter(cat => !cat.adjCategory || !cat.adjVerSource).length;
                      if (needsDetailsCount === 0) return null;
                      return (
                        <span className="text-xs text-amber-700 font-medium">
                          ⚠ {needsDetailsCount} adjustment{needsDetailsCount !== 1 ? 's' : ''} need{needsDetailsCount === 1 ? 's' : ''} details
                        </span>
                      );
                    })()}
                  </div>
                </>
              )}
            </div>

            {/* Adjustments Table */}
            <div className="text-xs text-gray-600 mb-2 p-2 bg-purple-50 rounded border border-purple-200 flex items-start gap-2">
              <span className="text-purple-600">💡</span>
              <span><strong>TTM Month Column:</strong> By default, adjustments are spread evenly across all 12 months for Roll-Off Risk Analysis. For one-time items (e.g., a $60K legal fee in March), select the specific month to accurately show normalized monthly EBITDA.</span>
            </div>
            <div className="overflow-x-auto mb-4">
              <table className="w-full text-xs border-collapse">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="p-1 border w-6">✓</th>
                    <th className="p-1 border w-16">Type</th>
                    <th className="p-1 border w-28">Category</th>
                    <th 
                      className="p-1 border w-24 cursor-pointer hover:bg-blue-100 select-none text-blue-700"
                      onClick={() => setAdjustmentSort(prev => ({ 
                        column: 'plLine', 
                        direction: prev.column === 'plLine' && prev.direction === 'asc' ? 'desc' : 'asc' 
                      }))}
                      title="Click to sort by P&L Line"
                    >
                      P&L Line {adjustmentSort.column === 'plLine' ? (adjustmentSort.direction === 'asc' ? '↑' : '↓') : '⇅'}
                    </th>
                    <th className="p-1 border">Description</th>
                    <th className="p-1 border w-20">Amount</th>
                    <th 
                      className="p-1 border w-20 cursor-pointer hover:bg-blue-100 select-none text-blue-700"
                      onClick={() => setAdjustmentSort(prev => ({ 
                        column: 'year', 
                        direction: prev.column === 'year' && prev.direction === 'asc' ? 'desc' : 'asc' 
                      }))}
                      title="Click to sort by Year"
                    >
                      Year {adjustmentSort.column === 'year' ? (adjustmentSort.direction === 'asc' ? '↑' : '↓') : '⇅'}
                    </th>
                    <th className="p-1 border w-20" title="For TTM monthly analysis - apply adjustment to specific month or spread evenly">TTM Month</th>
                    <th className="p-1 border w-28">Ver. Source</th>
                    <th className="p-1 border w-28">Doc Ref</th>
                    <th className="p-1 border w-8" title="Copy options"><Copy className="w-3 h-3 mx-auto" /></th>
                    <th className="p-1 border w-6">×</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Sort adjustmentItems based on current sort state
                    const sortedItems = [...adjustmentItems].sort((a, b) => {
                      if (!adjustmentSort.column) return 0;
                      
                      let aVal = a[adjustmentSort.column] || '';
                      let bVal = b[adjustmentSort.column] || '';
                      
                      // For year, use custom sort order
                      if (adjustmentSort.column === 'year') {
                        const yearOrder = { 'All Years': 0, [basisYearLabels.year1]: 1, [basisYearLabels.year2]: 2, [basisYearLabels.year3]: 3, [basisYearLabels.year4]: 4, [basisYearLabels.year5]: 5, 'TTM': 6 };
                        aVal = yearOrder[aVal] ?? 99;
                        bVal = yearOrder[bVal] ?? 99;
                      }
                      
                      if (aVal < bVal) return adjustmentSort.direction === 'asc' ? -1 : 1;
                      if (aVal > bVal) return adjustmentSort.direction === 'asc' ? 1 : -1;
                      return 0;
                    });
                    
                    return sortedItems.map(item => (
                    <tr key={item.id} className={!item.included ? 'bg-gray-100' : item.type === 'deduct' ? 'bg-blue-50' : 'bg-slate-100'}>
                      <td className="p-1 border text-center"><input type="checkbox" checked={item.included} onChange={e => updateAdjustment(item.id, 'included', e.target.checked)} /></td>
                      <td className="p-1 border">
                        <select value={item.type} onChange={e => updateAdjustment(item.id, 'type', e.target.value)} className={`w-full p-0.5 border rounded text-xs ${item.type === 'deduct' ? 'bg-blue-100' : 'bg-slate-200'}`}>
                          <option value="add">+ Add</option>
                          <option value="deduct">− Deduct</option>
                        </select>
                      </td>
                      <td className="p-1 border">
                        <select value={item.category} onChange={e => updateAdjustment(item.id, 'category', e.target.value)} className="w-full p-0.5 border rounded text-xs">
                          <option value="">Select...</option>
                          <optgroup label="Deduct from Expenses (+EBITDA)">
                            <option value="Owner Benefits">Owner Benefits</option>
                            <option value="Non-Recurring Expense">Non-Recurring Expense</option>
                            <option value="Personal Expense">Personal Expense</option>
                            <option value="Discretionary Expense">Discretionary Expense</option>
                            <option value="Related Party (Above Market)">Related Party (Above Market)</option>
                            <option value="Above Market Rent">Above Market Rent</option>
                            <option value="Non-Operating">Non-Operating</option>
                          </optgroup>
                          <optgroup label="Add to Expenses (-EBITDA)">
                            <option value="Below Market Rent">Below Market Rent</option>
                            <option value="Below Market Salary">Below Market Salary</option>
                            <option value="Missing Expense">Missing Expense</option>
                            <option value="Maintenance CapEx">Maintenance CapEx</option>
                          </optgroup>
                          <optgroup label="Revenue Adjustments">
                            <option value="Non-Recurring Revenue">Non-Recurring Revenue</option>
                            <option value="Lost Customer">Lost Customer</option>
                            <option value="Revenue Adjustment">Revenue Adjustment</option>
                          </optgroup>
                          {/* Colleen 10-14 (Aeroform): depreciation inside COGS. On a COGS/expense line, these show in the D/I/A/T rows + Reported EBITDA, not Other adjustments. */}
                          <optgroup label="D/I/A/T inside COGS or expenses">
                            <option value="Depreciation">Depreciation</option>
                            <option value="Amortization">Amortization</option>
                            <option value="Interest">Interest</option>
                            <option value="Taxes">Taxes</option>
                          </optgroup>
                          <option value="Other">Other</option>
                        </select>
                      </td>
                      <td className="p-1 border">
                        <select value={item.plLine} onChange={e => updateAdjustment(item.id, 'plLine', e.target.value)} className="w-full p-0.5 border rounded text-xs">
                          <option value="">Select Line...</option>
                          {revenueCategories.filter(c => c.name).length > 0 && (
                            <optgroup label="Revenue">
                              {revenueCategories.filter(c => c.name).map(c => (
                                <option key={`rev-${c.id}`} value={`Revenue: ${c.name}`}>{c.name}</option>
                              ))}
                              <option value="Revenue">Revenue (Total)</option>
                            </optgroup>
                          )}
                          {revenueCategories.filter(c => c.name).length === 0 && (
                            <optgroup label="Revenue">
                              <option value="Revenue">Revenue</option>
                            </optgroup>
                          )}
                          {cogsCategories.filter(c => c.name).length > 0 && (
                            <optgroup label="Cost of Goods Sold">
                              {cogsCategories.filter(c => c.name).map(c => (
                                <option key={`cogs-${c.id}`} value={`COGS: ${c.name}`}>{c.name}</option>
                              ))}
                              <option value="COGS">COGS (Total)</option>
                            </optgroup>
                          )}
                          {cogsCategories.filter(c => c.name).length === 0 && (
                            <optgroup label="Cost of Goods Sold">
                              <option value="COGS">COGS</option>
                            </optgroup>
                          )}
                          {opexCategories.filter(c => c.name).length > 0 && (
                            <optgroup label="Operating Expenses">
                              {opexCategories.filter(c => c.name).map(c => (
                                <option key={`opex-${c.id}`} value={`OpEx: ${c.name}`}>{c.name}</option>
                              ))}
                              <option value="Other OpEx">Other OpEx</option>
                            </optgroup>
                          )}
                          {opexCategories.filter(c => c.name).length === 0 && (
                            <optgroup label="Operating Expenses">
                              <option value="Salaries">Salaries & Wages</option>
                              <option value="Rent">Rent</option>
                              <option value="Other OpEx">Other OpEx</option>
                            </optgroup>
                          )}
                          {otherIncomeCategories.filter(c => c.name).length > 0 && (
                            <optgroup label="Other Income (Non-Operating)">
                              {otherIncomeCategories.filter(c => c.name).map(c => (
                                <option key={`oi-${c.id}`} value={`OtherIncome: ${c.name}`}>{c.name}</option>
                              ))}
                              <option value="Other Income">Other Income (Total)</option>
                            </optgroup>
                          )}
                          {otherExpenseCategories.filter(c => c.name).length > 0 && (
                            <optgroup label="Other Expense (Non-Operating)">
                              {otherExpenseCategories.filter(c => c.name).map(c => (
                                <option key={`oe-${c.id}`} value={`OtherExpense: ${c.name}`}>{c.name}</option>
                              ))}
                              <option value="Other Expense">Other Expense (Total)</option>
                            </optgroup>
                          )}
                          <optgroup label="Below the Line">
                            <option value="CapEx">CapEx (Maintenance)</option>
                            <option value="Rent (Market Adj)">Rent (Market Adj)</option>
                            <option value="Depreciation">Depreciation</option>
                            <option value="Amortization">Amortization</option>
                            <option value="Interest">Interest</option>
                            <option value="Taxes">Taxes</option>
                          </optgroup>
                        </select>
                      </td>
                      <td className="p-1 border"><input type="text" value={item.description} onChange={e => updateAdjustment(item.id, 'description', e.target.value)} className="w-full p-0.5 border rounded text-xs" /></td>
                      <td className="p-1 border"><CurrencyInput value={item.amount} onChange={v => updateAdjustment(item.id, 'amount', v)} className="w-full p-0.5 border rounded text-xs text-right" /></td>
                      <td className="p-1 border">
                        <select value={item.year} onChange={e => updateAdjustment(item.id, 'year', e.target.value)} className="w-full p-0.5 border rounded text-xs">
                          <option value="All Years">All Years</option>
                          {[['year1', basisYearLabels.year1], ['year2', basisYearLabels.year2], ['year3', basisYearLabels.year3], ['year4', basisYearLabels.year4], ['year5', basisYearLabels.year5]].map(([yk, label]) => {
                            const hasData = revenueCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0) || 
                                           cogsCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0) ||
                                           opexCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0);
                            return (hasData || item.year === label) ? <option key={yk} value={label}>{label}</option> : null;
                          })}
                          <option value="TTM">TTM</option>
                        </select>
                      </td>
                      <td className="p-1 border">
                        <select 
                          value={item.ttmMonth || 'spread'} 
                          onChange={e => updateAdjustment(item.id, 'ttmMonth', e.target.value)} 
                          className={`w-full p-0.5 border rounded text-xs ${item.ttmMonth && item.ttmMonth !== 'spread' ? 'bg-purple-50 font-medium' : ''}`}
                          title="Apply adjustment to specific TTM month or spread evenly across all months"
                        >
                          <option value="spread">Spread Evenly</option>
                          <optgroup label="Apply to Specific Month">
                            {monthlyTtmLabels.slice(0, 12).map((label, idx) => (
                              <option key={idx} value={label}>{label}</option>
                            ))}
                          </optgroup>
                        </select>
                      </td>
                      <td className="p-1 border">
                        <select value={item.source || ''} onChange={e => updateAdjustment(item.id, 'source', e.target.value)} className={`w-full p-0.5 border rounded text-xs ${item.source ? 'bg-blue-50' : 'bg-amber-50'}`}>
                          <option value="">Select...</option>
                          <option value="Bank Statement">Bank Statement</option>
                          <option value="Credit Card Statement">Credit Card Statement</option>
                          <option value="Invoice/Receipt">Invoice/Receipt</option>
                          <option value="Tax Return">Tax Return</option>
                          <option value="Payroll Report">Payroll Report</option>
                          <option value="W-2/1099/K-1">W-2/1099/K-1</option>
                          <option value="Lease/Contract">Lease/Contract</option>
                          <option value="Seller Confirmation">Seller Confirmation</option>
                          <option value="Market Data">Market Data</option>
                          <option value="Other">Other</option>
                        </select>
                      </td>
                      <td className="p-1 border"><input type="text" value={item.verificationDoc || ''} onChange={e => updateAdjustment(item.id, 'verificationDoc', e.target.value)} className="w-full p-0.5 border rounded text-xs" placeholder="Reference..." /></td>
                      <td className="p-1 border text-center">
                        <button 
                          onClick={(e) => {
                            const rect = e.currentTarget.getBoundingClientRect();
                            setCopyMenuOpen(copyMenuOpen.id === item.id ? { id: null, x: 0, y: 0, item: null, selectedYears: [] } : { id: item.id, x: rect.left, y: rect.top, item, selectedYears: [] });
                          }}
                          className="text-blue-600 hover:text-blue-800 p-0.5" 
                          title="Copy adjustment"
                        >
                          <Copy className="w-3.5 h-3.5" />
                        </button>
                      </td>
                      <td className="p-1 border text-center"><button onClick={() => deleteAdjustment(item.id)} className="text-red-600 font-bold">×</button></td>
                    </tr>
                  ));
                  })()}
                </tbody>
              </table>
            </div>

            {/* Warning Message */}
            {adjustmentWarning && (
              <div className="mb-4 p-3 bg-amber-100 border border-amber-400 rounded-lg text-amber-800 text-sm flex items-center gap-2">
                <span className="text-lg">⚠️</span>
                <span>{adjustmentWarning}</span>
                <button onClick={() => setAdjustmentWarning('')} className="ml-auto text-red-600 hover:text-red-800 font-bold">×</button>
              </div>
            )}

            {/* Add New Adjustment */}
            <div className="p-3 bg-blue-50 rounded-lg mb-4">
              <h4 className="font-semibold text-blue-800 mb-2">Add New Adjustment</h4>
              {/* Colleen's Proximity Wireless case (08-17): passthrough taxes
                  buried in a mixed line — she hunted here for a "Taxes" option
                  that architecturally can't exist on this tab (D/I/A/T is part
                  of EBITDA itself; this tab is the bridge ABOVE it). */}
              <p className="text-xs text-blue-700 mb-2">Looking for <strong>Depreciation / Interest / Amortization / Taxes</strong> (e.g. passthrough taxes inside a mixed line)? Those are part of EBITDA itself, so they don't live here — go to the <strong>Expenses grid</strong>, set the <strong>%</strong> on that line to the portion (decimals OK), and pick the D/I/A/T category there. It lands directly in EBITDA.</p>
              <div className="grid grid-cols-9 gap-1">
                <select value={newAdjustment.type} onChange={e => setNewAdjustment({...newAdjustment, type: e.target.value})} className={`p-1 border rounded text-xs ${newAdjustment.type === 'add' ? 'bg-slate-200' : 'bg-blue-100'}`}>
                  <option value="add">+ Add</option>
                  <option value="deduct">− Deduct</option>
                </select>
                <select value={newAdjustment.category} onChange={e => setNewAdjustment({...newAdjustment, category: e.target.value})} className="p-1 border rounded text-xs">
                  <option value="">Category...</option>
                  <optgroup label="Deduct from Expenses (+EBITDA)">
                    <option value="Owner Benefits">Owner Benefits</option>
                    <option value="Non-Recurring Expense">Non-Recurring Expense</option>
                    <option value="Personal Expense">Personal Expense</option>
                    <option value="Discretionary Expense">Discretionary Expense</option>
                    <option value="Related Party (Above Market)">Related Party (Above Market)</option>
                    <option value="Above Market Rent">Above Market Rent</option>
                    <option value="Non-Operating">Non-Operating</option>
                  </optgroup>
                  <optgroup label="Add to Expenses (-EBITDA)">
                    <option value="Below Market Rent">Below Market Rent</option>
                    <option value="Below Market Salary">Below Market Salary</option>
                    <option value="Missing Expense">Missing Expense</option>
                    <option value="Maintenance CapEx">Maintenance CapEx</option>
                  </optgroup>
                  <optgroup label="Revenue Adjustments">
                    <option value="Non-Recurring Revenue">Non-Recurring Revenue</option>
                    <option value="Lost Customer">Lost Customer</option>
                    <option value="Revenue Adjustment">Revenue Adjustment</option>
                  </optgroup>
                  {/* Colleen 10-14 (Aeroform): depreciation inside COGS. On a COGS/expense line, these show in the D/I/A/T rows + Reported EBITDA, not Other adjustments. */}
                  <optgroup label="D/I/A/T inside COGS or expenses">
                    <option value="Depreciation">Depreciation</option>
                    <option value="Amortization">Amortization</option>
                    <option value="Interest">Interest</option>
                    <option value="Taxes">Taxes</option>
                  </optgroup>
                  <option value="Other">Other</option>
                </select>
                {/* Searchable P&L Line Dropdown */}
                <div className="relative col-span-2">
                  <input
                    type="text"
                    value={plLineDropdownOpen ? plLineSearch : (newAdjustment.plLine || '')}
                    onChange={e => {
                      setPlLineSearch(e.target.value);
                      setPlLineDropdownOpen(true);
                    }}
                    onFocus={() => {
                      setPlLineDropdownOpen(true);
                      setPlLineSearch('');
                    }}
                    onBlur={() => setTimeout(() => setPlLineDropdownOpen(false), 200)}
                    placeholder="Search P&L Line..."
                    className="p-1 border rounded text-xs w-full"
                    style={{textOverflow: 'ellipsis'}}
                    title={newAdjustment.plLine || ''}
                  />
                  {plLineDropdownOpen && (() => {
                    // Build all options with groups
                    const allOptions = [];
                    
                    // Revenue
                    const revCats = revenueCategories.filter(c => c.name);
                    if (revCats.length > 0) {
                      revCats.forEach(c => allOptions.push({ value: `Revenue: ${c.name}`, label: c.name, group: 'Revenue' }));
                      allOptions.push({ value: 'Revenue', label: 'Revenue (Total)', group: 'Revenue' });
                    } else {
                      allOptions.push({ value: 'Revenue', label: 'Revenue', group: 'Revenue' });
                    }
                    
                    // COGS
                    const cogsCats = cogsCategories.filter(c => c.name);
                    if (cogsCats.length > 0) {
                      cogsCats.forEach(c => allOptions.push({ value: `COGS: ${c.name}`, label: c.name, group: 'COGS' }));
                      allOptions.push({ value: 'COGS', label: 'COGS (Total)', group: 'COGS' });
                    } else {
                      allOptions.push({ value: 'COGS', label: 'COGS', group: 'COGS' });
                    }
                    
                    // OpEx
                    const opexCats = opexCategories.filter(c => c.name);
                    if (opexCats.length > 0) {
                      opexCats.forEach(c => allOptions.push({ value: `OpEx: ${c.name}`, label: c.name, group: 'OpEx' }));
                      allOptions.push({ value: 'Other OpEx', label: 'Other OpEx', group: 'OpEx' });
                    } else {
                      allOptions.push({ value: 'Salaries', label: 'Salaries & Wages', group: 'OpEx' });
                      allOptions.push({ value: 'Rent', label: 'Rent', group: 'OpEx' });
                      allOptions.push({ value: 'Other OpEx', label: 'Other OpEx', group: 'OpEx' });
                    }
                    
                    // Other Income
                    const oiCats = otherIncomeCategories.filter(c => c.name);
                    if (oiCats.length > 0) {
                      oiCats.forEach(c => allOptions.push({ value: `OtherIncome: ${c.name}`, label: c.name, group: 'Other Income' }));
                      allOptions.push({ value: 'Other Income', label: 'Other Income (Total)', group: 'Other Income' });
                    }
                    
                    // Other Expense
                    const oeCats = otherExpenseCategories.filter(c => c.name);
                    if (oeCats.length > 0) {
                      oeCats.forEach(c => allOptions.push({ value: `OtherExpense: ${c.name}`, label: c.name, group: 'Other Expense' }));
                      allOptions.push({ value: 'Other Expense', label: 'Other Expense (Total)', group: 'Other Expense' });
                    }
                    
                    // Below the Line
                    allOptions.push({ value: 'CapEx', label: 'CapEx (Maintenance)', group: 'Below the Line' });
                    allOptions.push({ value: 'Rent (Market Adj)', label: 'Rent (Market Adj)', group: 'Below the Line' });
                    allOptions.push({ value: 'Depreciation', label: 'Depreciation', group: 'Below the Line' });
                    allOptions.push({ value: 'Amortization', label: 'Amortization', group: 'Below the Line' });
                    allOptions.push({ value: 'Interest', label: 'Interest', group: 'Below the Line' });
                    allOptions.push({ value: 'Taxes', label: 'Taxes', group: 'Below the Line' });
                    
                    // Filter options based on search
                    const searchLower = plLineSearch.toLowerCase();
                    const filtered = plLineSearch 
                      ? allOptions.filter(opt => 
                          opt.label.toLowerCase().includes(searchLower) || 
                          opt.value.toLowerCase().includes(searchLower) ||
                          opt.group.toLowerCase().includes(searchLower)
                        )
                      : allOptions;
                    
                    // Group filtered options
                    const groups = {};
                    filtered.forEach(opt => {
                      if (!groups[opt.group]) groups[opt.group] = [];
                      groups[opt.group].push(opt);
                    });
                    
                    return (
                      <div className="absolute z-50 mt-1 w-64 max-h-64 overflow-auto bg-white border rounded-lg shadow-lg">
                        {filtered.length === 0 ? (
                          <div className="p-2 text-xs text-gray-500 italic">No matching accounts</div>
                        ) : (
                          Object.entries(groups).map(([groupName, opts]) => (
                            <div key={groupName}>
                              <div className="px-2 py-1 bg-gray-100 text-xs font-semibold text-gray-600 sticky top-0">{groupName}</div>
                              {opts.map(opt => (
                                <div
                                  key={opt.value}
                                  className={`px-3 py-1 text-xs cursor-pointer hover:bg-blue-100 ${newAdjustment.plLine === opt.value ? 'bg-blue-50 font-semibold' : ''}`}
                                  onMouseDown={() => {
                                    setNewAdjustment({...newAdjustment, plLine: opt.value});
                                    setPlLineSearch('');
                                    setPlLineDropdownOpen(false);
                                  }}
                                >
                                  {opt.label}
                                </div>
                              ))}
                            </div>
                          ))
                        )}
                      </div>
                    );
                  })()}
                  {newAdjustment.plLine && !plLineDropdownOpen && (
                    <button 
                      type="button"
                      onClick={() => {
                        setNewAdjustment({...newAdjustment, plLine: ''});
                        setPlLineSearch('');
                      }}
                      className="absolute right-1 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs"
                      title="Clear selection"
                    >
                      ×
                    </button>
                  )}
                </div>
                <input type="text" value={newAdjustment.description} onChange={e => setNewAdjustment({...newAdjustment, description: e.target.value})} placeholder="Description (required)" className="p-1 border rounded text-xs col-span-2" />
                <CurrencyInput value={newAdjustment.amount} onChange={v => setNewAdjustment({...newAdjustment, amount: v})} placeholder="Amount" className="p-1 border rounded text-xs" />
                <select value={newAdjustment.year} onChange={e => setNewAdjustment({...newAdjustment, year: e.target.value})} className="p-1 border rounded text-xs">
                  <option value="All Years">All Years</option>
                  {[['year1', basisYearLabels.year1], ['year2', basisYearLabels.year2], ['year3', basisYearLabels.year3], ['year4', basisYearLabels.year4], ['year5', basisYearLabels.year5]].map(([yk, label]) => {
                    const hasData = revenueCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0) || 
                                   cogsCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0) ||
                                   opexCategories.some(c => Math.abs(c[selectedValuationBasis]?.[yk] || 0) > 0);
                    return hasData ? <option key={yk} value={label}>{label}</option> : null;
                  })}
                  <option value="TTM">TTM</option>
                </select>
                <button 
                  onClick={addNewAdjustment} 
                  disabled={!newAdjustment.plLine || !newAdjustment.amount || !newAdjustment.description.trim()}
                  className={`rounded text-xs font-semibold ${!newAdjustment.plLine || !newAdjustment.amount || !newAdjustment.description.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                  title={!newAdjustment.plLine ? 'Select a P&L Line first' : !newAdjustment.description.trim() ? 'Enter a description' : !newAdjustment.amount ? 'Enter an amount' : 'Add adjustment'}
                >
                  + Add
                </button>
              </div>
              {(newAdjustment.amount > 0 || newAdjustment.description.trim()) && (!newAdjustment.plLine || !newAdjustment.description.trim()) && (
                <div className="text-xs text-orange-600 mt-1">
                  ⚠️ {!newAdjustment.plLine && 'Select a P&L Line'}{!newAdjustment.plLine && !newAdjustment.description.trim() && ' and '}{!newAdjustment.description.trim() && 'Enter a description'} to add this adjustment
                </div>
              )}
              {/* Show available balance for deductions */}
              {newAdjustment.type === 'deduct' && newAdjustment.plLine && (
                <div className="mt-2 text-xs text-gray-600">
                  {(() => {
                    const balance = getLineBalance(newAdjustment.plLine, newAdjustment.year);
                    const existing = getExistingDeductions(newAdjustment.plLine, newAdjustment.year);
                    const available = balance === Infinity ? 'Unlimited' : `$${Math.max(0, balance - existing).toLocaleString()}`;
                    return balance === Infinity 
                      ? null 
                      : <span>💡 <strong>{newAdjustment.plLine}</strong> balance: ${balance.toLocaleString()} | Existing deductions: ${existing.toLocaleString()} | <span className="text-green-700 font-semibold">Available to deduct: {available}</span></span>;
                  })()}
                </div>
              )}
            </div>

            {/* D/I/A/T Standard Add-backs */}
            <div className="p-3 bg-gray-50 rounded-lg">
              <h4 className="font-semibold text-gray-700 mb-2">Standard EBITDA Add-backs (D/I/A/T)</h4>
              <div className="flex gap-6">
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={addbacks.depreciation} onChange={e => setAddbacks({...addbacks, depreciation: e.target.checked})} className="w-4 h-4" /> Add back Depreciation</label>
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={addbacks.amortization} onChange={e => setAddbacks({...addbacks, amortization: e.target.checked})} className="w-4 h-4" /> Add back Amortization</label>
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={addbacks.interest} onChange={e => setAddbacks({...addbacks, interest: e.target.checked})} className="w-4 h-4" /> Add back Interest</label>
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={addbacks.taxes} onChange={e => setAddbacks({...addbacks, taxes: e.target.checked})} className="w-4 h-4" /> Add back Taxes</label>
              </div>
            </div>
          </div>
        ) : viewMode === 'sba' ? (
          /* ========== SBA DEBT COVERAGE ANALYSIS ========== */
          <div>
            <h2 className="text-lg font-bold mb-3">🏦 SBA Debt Coverage Analysis</h2>
            
            {/* Deal Structure */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                <h3 className="font-bold text-blue-800 mb-3">Deal Structure</h3>
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b">
                      <td className="py-2 font-medium">Deal Value (High)</td>
                      <td className="py-2 text-right font-bold text-blue-900">{formatCurrency(sbaAnalysis.dealValue)}</td>
                    </tr>
                    <tr className="border-b bg-blue-50">
                      <td className="py-2 pl-4">Buyer Down Payment</td>
                      <td className="py-2 text-right">
                        <div className="flex items-center justify-end gap-2">
                          <input type="number" value={sbaParams.downPaymentPct} onChange={e => setSbaParams({...sbaParams, downPaymentPct: Number(e.target.value)})} className="w-14 p-1 border rounded text-right text-xs" />
                          <span className="text-xs">%</span>
                          <span className="font-medium w-24 text-right">{formatCurrency(sbaAnalysis.downPayment)}</span>
                        </div>
                      </td>
                    </tr>
                    <tr className="border-b bg-slate-50">
                      <td className="py-2 pl-4">Seller Note</td>
                      <td className="py-2 text-right">
                        <div className="flex items-center justify-end gap-2">
                          <input type="number" value={sbaParams.sellerNotePct} onChange={e => setSbaParams({...sbaParams, sellerNotePct: Number(e.target.value)})} className="w-14 p-1 border rounded text-right text-xs" />
                          <span className="text-xs">%</span>
                          <span className="font-medium w-24 text-right">{formatCurrency(sbaAnalysis.sellerNote)}</span>
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-blue-100">
                      <td className="py-2 pl-4 font-medium">SBA Loan</td>
                      <td className="py-2 text-right">
                        <div className="flex items-center justify-end gap-2">
                          <span className="text-xs text-gray-500">{100 - sbaParams.downPaymentPct - sbaParams.sellerNotePct}%</span>
                          <span className="font-bold w-24 text-right">{formatCurrency(sbaAnalysis.sbaLoan)}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <h3 className="font-bold text-gray-800 mb-3">Loan Terms</h3>
                <table className="w-full text-sm">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="p-2 text-left">Loan</th>
                      <th className="p-2 text-center">Rate</th>
                      <th className="p-2 text-center">Term</th>
                      <th className="p-2 text-right">Annual Pmt</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b bg-blue-50">
                      <td className="p-2 font-medium">SBA Business Loan</td>
                      <td className="p-2 text-center">
                        <div className="flex items-center justify-center gap-1">
                          <input type="number" step="0.25" value={sbaParams.sbaLoanRate} onChange={e => setSbaParams({...sbaParams, sbaLoanRate: Number(e.target.value)})} className="w-14 p-1 border rounded text-right text-xs" />
                          <span className="text-xs">%</span>
                        </div>
                      </td>
                      <td className="p-2 text-center">
                        <div className="flex items-center justify-center gap-1">
                          <input type="number" value={sbaParams.sbaLoanTerm} onChange={e => setSbaParams({...sbaParams, sbaLoanTerm: Number(e.target.value)})} className="w-12 p-1 border rounded text-right text-xs" />
                          <span className="text-xs">yr</span>
                        </div>
                      </td>
                      <td className="p-2 text-right font-medium">{formatCurrency(sbaAnalysis.sbaLoanPayment)}</td>
                    </tr>
                    <tr className="border-b bg-slate-50">
                      <td className="p-2 font-medium">Seller Carry Note</td>
                      <td className="p-2 text-center">
                        <div className="flex items-center justify-center gap-1">
                          <input type="number" step="0.25" value={sbaParams.sellerNoteRate} onChange={e => setSbaParams({...sbaParams, sellerNoteRate: Number(e.target.value)})} className="w-14 p-1 border rounded text-right text-xs" />
                          <span className="text-xs">%</span>
                        </div>
                      </td>
                      <td className="p-2 text-center">
                        <div className="flex items-center justify-center gap-1">
                          <input type="number" value={sbaParams.sellerNoteTerm} onChange={e => setSbaParams({...sbaParams, sellerNoteTerm: Number(e.target.value)})} className="w-12 p-1 border rounded text-right text-xs" />
                          <span className="text-xs">yr</span>
                        </div>
                      </td>
                      <td className="p-2 text-right font-medium">{formatCurrency(sbaAnalysis.sellerNotePayment)}</td>
                    </tr>
                    {sbaAnalysis.reOn && (
                      <tr className="border-b bg-emerald-50">
                        <td className="p-2 font-medium">Real estate loan ({formatCurrency(sbaAnalysis.reLoan)})</td>
                        <td className="p-2 text-center"><div className="flex items-center justify-center gap-1"><input type="number" step="0.25" value={sbaParams.reRate ?? 7.0} onChange={e => setSbaParams({...sbaParams, reRate: Number(e.target.value)})} className="w-14 p-1 border rounded text-right text-xs" /><span className="text-xs">%</span></div></td>
                        <td className="p-2 text-center"><div className="flex items-center justify-center gap-1"><input type="number" value={sbaParams.reTerm ?? 25} onChange={e => setSbaParams({...sbaParams, reTerm: Number(e.target.value)})} className="w-12 p-1 border rounded text-right text-xs" /><span className="text-xs">yr</span></div></td>
                        <td className="p-2 text-right font-medium">{formatCurrency(sbaAnalysis.reLoanPayment)}</td>
                      </tr>
                    )}
                    <tr className="bg-gray-200 font-bold">
                      <td className="p-2" colSpan="3">Total Annual Payments</td>
                      <td className="p-2 text-right">{formatCurrency(sbaAnalysis.totalPayments)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* 🏢 REAL ESTATE IN THE SALE (Mark 10-20): when the property is owned separately (a holding company) and
                sells with the business, add it at market value and check the business can carry both loans. */}
            <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-4 text-sm">
              <label className="flex items-center gap-2 font-semibold text-emerald-900">
                <input type="checkbox" checked={!!sbaParams.reIncluded} onChange={e => setSbaParams({...sbaParams, reIncluded: e.target.checked})} />
                🏢 Real estate sells with the business (owned separately, e.g. a holding company)
              </label>
              {sbaParams.reIncluded && (
                <div className="mt-2 space-y-2">
                  <div className="flex flex-wrap gap-4 items-center">
                    <span>Market value $ <input type="number" step="10000" min="0" value={sbaParams.reValue || ''} onChange={e => setSbaParams({...sbaParams, reValue: Math.max(0, Number(e.target.value) || 0)})} className="w-28 p-1 border rounded text-right" /></span>
                    <span>Rent the business pays today $/yr <input type="number" step="1000" min="0" value={sbaParams.reRent || ''} onChange={e => setSbaParams({...sbaParams, reRent: Math.max(0, Number(e.target.value) || 0)})} className="w-24 p-1 border rounded text-right" /></span>
                    <span>Down payment <input type="number" min="0" max="100" value={sbaParams.reDownPct ?? 10} onChange={e => setSbaParams({...sbaParams, reDownPct: Number(e.target.value)})} className="w-14 p-1 border rounded text-right" /> %</span>
                  </div>
                  <label className="flex items-center gap-2 text-xs text-gray-700">
                    <input type="checkbox" checked={!!sbaParams.reRentAddedBack} onChange={e => setSbaParams({...sbaParams, reRentAddedBack: e.target.checked})} />
                    The rent is already added back in Adjustments (then the business value already includes the real estate: adding it here counts it twice)
                  </label>
                  {sbaParams.reRentAddedBack && <div className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">⚠ Rent already added back: the value above already includes the property. Uncheck “sells with the business”, or remove the rent add-back and value the property here.</div>}
                  <div className="text-xs text-gray-700">
                    Package price: business {formatCurrency(sbaAnalysis.dealValue)} + real estate {formatCurrency(sbaAnalysis.reValue)} = <b>{formatCurrency(sbaAnalysis.packageValue)}</b>.
                    Real estate loan {formatCurrency(sbaAnalysis.reLoan)} (after {formatCurrency(sbaAnalysis.reDown)} down) at {sbaParams.reRate ?? 7.0}% over {sbaParams.reTerm ?? 25} years = {formatCurrency(sbaAnalysis.reLoanPayment)}/yr; the business stops paying {formatCurrency(sbaAnalysis.reRentBack)}/yr rent. The coverage below includes both loans.
                  </div>
                </div>
              )}
            </div>

            {/* Debt Coverage Calculation */}
            <div className="bg-white border-2 border-gray-300 rounded-lg p-4 mb-4">
              <h3 className="font-bold text-gray-800 mb-3">Term Debt Coverage Ratio (TDCR)</h3>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-2">
                  <table className="w-full text-sm">
                    <tbody>
                      <tr className="border-b">
                        <td className="py-2 font-medium">{sbaAnalysis.maintCapex > 0 ? 'Normalized EBITDA after capex (free cash flow)' : 'Normalized EBITDA (TTM)'}</td>
                        <td className="py-2 text-right font-bold text-lg">{formatCurrency(sbaAnalysis.adjustedEbitda)}</td>
                      </tr>
                      {(sbaAnalysis.ownerManager || 0) > 0 && (
                      <tr className="border-b bg-gray-50 text-xs text-gray-600">
                        <td className="py-1 pl-4 italic">Includes market-rate owner salary: {formatCurrency(sbaAnalysis.ownerManager)}</td>
                        <td></td>
                      </tr>
                      )}
                      {sbaAnalysis.reRentBack > 0 && (
                        <tr className="border-b"><td className="py-2 pl-4">+ Rent no longer paid (the buyer owns the real estate)</td><td className="py-2 text-right">{formatCurrency(sbaAnalysis.reRentBack)}</td></tr>
                      )}
                      <tr className="border-b bg-blue-50">
                        <td className="py-2 font-medium">= Cash Available for Debt Service</td>
                        <td className="py-2 text-right font-bold">{formatCurrency(sbaAnalysis.cashAvailable)}</td>
                      </tr>
                      <tr className="border-b text-red-700">
                        <td className="py-2 pl-4">Less: Total Annual Payments</td>
                        <td className="py-2 text-right">({formatCurrency(sbaAnalysis.totalPayments)})</td>
                      </tr>
                      <tr className={`font-bold ${sbaAnalysis.margin >= 0 ? 'bg-blue-100 text-blue-800' : 'bg-amber-100 text-amber-800'}`}>
                        <td className="py-2">Margin (Annual Cash Flow)</td>
                        <td className="py-2 text-right text-lg">{formatCurrency(sbaAnalysis.margin)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="flex flex-col justify-center items-center">
                  <div className={`text-center p-4 rounded-lg ${sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.25 ? 'bg-blue-100 border-2 border-blue-500' : sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.0 ? 'bg-slate-100 border-2 border-slate-400' : 'bg-amber-100 border-2 border-amber-500'}`}>
                    <div className="text-xs text-gray-600 font-medium">TDCR</div>
                    <div className={`text-4xl font-bold ${sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.25 ? 'text-green-700' : sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.0 ? 'text-yellow-700' : 'text-red-700'}`}>
                      {sbaAnalysis.tdcr ? sbaAnalysis.tdcr.toFixed(2) : 'N/A'}x
                    </div>
                    <div className="text-xs mt-1">
                      {sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.25 ? '✅ Meets SBA requirement' : sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.0 ? '⚠️ Marginal' : '❌ Below requirement'}
                    </div>
                  </div>
                  <div className="text-xs text-gray-500 mt-2 text-center">
                    SBA requires ≥ 1.25x
                  </div>
                </div>
              </div>
            </div>

            {/* Key Notes */}
            <div className="bg-amber-50 p-3 rounded-lg border border-amber-200 text-sm">
              <h4 className="font-semibold text-yellow-800 mb-2">📝 SBA Loan Guidelines</h4>
              <ul className="list-disc list-inside text-yellow-900 space-y-1">
                <li><strong>TDCR ≥ 1.25x</strong> is the standard SBA requirement for loan approval</li>
                <li>Deal structure: {sbaParams.downPaymentPct}% down payment + {sbaParams.sellerNotePct}% seller note + {100 - sbaParams.downPaymentPct - sbaParams.sellerNotePct}% SBA loan</li>
                {(ownerCompensation.marketReplacement || 0) > 0
                  ? <li>Normalized EBITDA already includes market-rate owner salary of {formatCurrency(ownerCompensation.marketReplacement)} (edit in Adjustments tab)</li>
                  : <li className="text-amber-800">No owner salary entered: confirm the owner's pay is in payroll at a market rate, or enter it on Adjustments → Owner compensation (this line is staff-only)</li>}
                <li>Customer concentration &gt;20% may require additional scrutiny</li>
              </ul>
            </div>
          </div>
        ) : viewMode === 'presentation' ? (
          <div>
            <div className="flex justify-between items-center mb-2">
              <div>
                <h2 className="text-lg font-bold">🎯 Presentation</h2>
                <p className="text-sm text-gray-600">Client-facing walkthrough of valuation analysis.</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => setShowRoadmapModal(true)}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 flex items-center gap-2"
                  title="Generate client-facing outstanding items list"
                >
                  <Mail className="w-4 h-4" />
                  Outstanding Items
                </button>
                <button
                  onClick={() => setShowReportRequestModal(true)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 flex items-center gap-2"
                  title="Generate document request list for CIM preparation"
                >
                  <FileText className="w-4 h-4" />
                  CIM Prep Request
                </button>
                <button
                  onClick={() => setShowExportModal(true)}
                  className="px-4 py-2 bg-amber-600 text-white rounded-lg font-medium hover:bg-amber-700 flex items-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  Export Reports
                </button>
              </div>
            </div>
            
            {/* Tab buttons */}
            <div className="flex border-b mb-4">
              <button 
                onClick={() => setReviewSection('financials')}
                className={`px-4 py-2 text-sm font-medium ${reviewSection === 'financials' ? 'border-b-2 border-green-700 text-green-700' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Financial Review
              </button>
              <button 
                onClick={() => setReviewSection('drivers')}
                className={`px-4 py-2 text-sm font-medium ${reviewSection === 'drivers' ? 'border-b-2 border-green-700 text-green-700' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Calculated Multiple
              </button>
              <button 
                onClick={() => setReviewSection('result')}
                className={`px-4 py-2 text-sm font-medium ${reviewSection === 'result' ? 'border-b-2 border-green-700 text-green-700' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Valuation Result
              </button>
              <button 
                onClick={() => setReviewSection('process')}
                className={`px-4 py-2 text-sm font-medium ${reviewSection === 'process' ? 'border-b-2 border-green-700 text-green-700' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Vista Process
              </button>
              <button 
                onClick={() => setReviewSection('simulator')}
                className={`px-4 py-2 text-sm font-medium ${reviewSection === 'simulator' ? 'border-b-2 border-green-700 text-green-700' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Value Enhancement
              </button>
              <button 
                onClick={() => setReviewSection('sba')}
                className={`px-4 py-2 text-sm font-medium ${reviewSection === 'sba' ? 'border-b-2 border-green-700 text-green-700' : 'text-gray-600 hover:text-gray-800'}`}
              >
                SBA Analysis
              </button>
            </div>
            
            {/* Pro Forma Basis Toggle (only shows if there's Pro Forma data) */}
            {proFormaCalcs.hasProFormaData && (
              <div className="mb-4 p-3 bg-gradient-to-r from-gray-50 to-green-50 rounded-lg border border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="text-sm font-bold text-gray-700">📊 Valuation Basis</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                      proFormaValuationBasis === 'historical' ? 'bg-gray-200 text-gray-700' :
                      proFormaValuationBasis === 'weighted' ? 'bg-gray-200 text-gray-700' :
                      'bg-green-200 text-green-700'
                    }`}>
                      {selectedBasisCalcs.label}: {formatCurrency(selectedBasisCalcs.ebitda)} EBITDA @ {multipleEngineCalcs.marketHighMultiple?.toFixed(1)}x
                    </span>
                  </div>
                  <div className="flex bg-white rounded-lg p-0.5 shadow-sm border">
                    <button
                      onClick={() => setProFormaValuationBasis('historical')}
                      className={`px-3 py-1 rounded text-xs font-medium transition-all ${
                        proFormaValuationBasis === 'historical' 
                          ? 'bg-gray-700 text-white' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Historical
                    </button>
                    <button
                      onClick={() => setProFormaValuationBasis('weighted')}
                      className={`px-3 py-1 rounded text-xs font-medium transition-all ${
                        proFormaValuationBasis === 'weighted' 
                          ? 'bg-gray-600 text-white' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Weighted
                    </button>
                    <button
                      onClick={() => setProFormaValuationBasis('proforma')}
                      className={`px-3 py-1 rounded text-xs font-medium transition-all ${
                        proFormaValuationBasis === 'proforma' 
                          ? 'bg-green-600 text-white' 
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      Pro Forma
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            {reviewSection === 'financials' && (
              <div>
                {/* Vista Header */}
                <div className="flex items-center gap-4 mb-6 pb-4 border-b-2 border-green-800">
                  <img src={vistaLogoBase64} alt="Vista Business Group" className="h-12" onError={(e) => e.target.style.display = 'none'} />
                  <div>
                    <div className="text-lg font-bold text-green-800">Vista Business Group</div>
                    <div className="text-xs text-gray-500">Confidential Business Valuation</div>
                  </div>
                </div>

                {/* SECTION 1: Understanding Your Normalized Financials */}
                <div className="mb-8">
                  <div className="bg-gray-700 text-white px-4 py-3 rounded-t-lg font-semibold">
                    Understanding Your Normalized Financials
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-5 bg-white">
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5 text-sm text-gray-600">
                      <strong className="text-gray-800">What is "Normalized" EBITDA?</strong> When valuing a business, buyers look beyond reported financials to understand 
                      the true economic earnings available to a new owner. Normalization adjusts for owner-specific expenses (like above-market 
                      compensation), one-time items, and non-operating costs to reveal the sustainable cash flow a buyer can expect. This provides 
                      an apples-to-apples comparison with other acquisition targets and is the foundation of your business valuation.
                    </div>
                    
                    {/* Valuation Basis Banner */}
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-5">
                      <div className="text-center">
                        <span className="text-gray-500 text-xs uppercase tracking-wide">Valuation Basis:</span>
                        <span className="text-gray-800 font-semibold ml-2">
                          {selectedValuationBasis === 'cash' ? 'Cash' : selectedValuationBasis === 'accrual' ? 'Accrual' : 'Tax Return'} Basis
                        </span>
                        <span className="mx-4 text-gray-300">|</span>
                        <span className="text-gray-500 text-xs uppercase tracking-wide">Period:</span>
                        <span className="text-gray-800 font-semibold ml-2">
                          {valuationInputs.weightingMethod === 'ttm' && 'Trailing Twelve Months (TTM)'}
                          {valuationInputs.weightingMethod === 'lastYear' && (basisYearLabels.year5 || 'Year 5')}
                          {valuationInputs.weightingMethod === 'average' && 'Multi-Year Average'}
                          {valuationInputs.weightingMethod === 'weighted' && 'Weighted Average'}
                        </span>
                      </div>
                    </div>

                    {/* Historical P&L Summary Table */}
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr className="bg-gray-700 text-white">
                            <th className="p-3 text-left font-medium" style={{width: '200px'}}>Line Item</th>
                            <th className="p-3 text-right font-medium" style={{width: '100px'}}>{displayYearLabels.year3 || 'Year 3'}</th>
                            <th className="p-3 text-right font-medium" style={{width: '100px'}}>{displayYearLabels.year4 || 'Year 4'}</th>
                            <th className="p-3 text-right font-medium" style={{width: '100px'}}>{displayYearLabels.year5 || 'Year 5'}</th>
                            <th className="p-3 text-right font-medium bg-gray-800" style={{width: '100px'}}>{ttmLabel}</th>
                          </tr>
                        </thead>
                        <tbody>
                      {(() => {
                        // Use the same calculation approach as presentation package (getExportData)
                        const basisKey = selectedValuationBasis === 'tax' ? 'cash' : selectedValuationBasis;
                        
                        // Revenue from categories
                        const rev3 = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0);
                        const rev4 = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0);
                        const rev5 = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0);
                        const revTtm = revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0);
                        
                        // COGS from categories
                        const cogs3 = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0);
                        const cogs4 = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0);
                        const cogs5 = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0);
                        const cogsTtm = cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0);
                        
                        // Gross Profit
                        const gp3 = rev3 - cogs3;
                        const gp4 = rev4 - cogs4;
                        const gp5 = rev5 - cogs5;
                        const gpTtm = revTtm - cogsTtm;
                        
                        // OpEx from categories
                        const opex3 = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0);
                        const opex4 = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0);
                        const opex5 = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0);
                        const opexTtm = opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0);
                        
                        // Other Income
                        const oi3 = otherIncomeAnalysis?.totals?.year3 || 0;
                        const oi4 = otherIncomeAnalysis?.totals?.year4 || 0;
                        const oi5 = otherIncomeAnalysis?.totals?.year5 || 0;
                        const oiTtm = otherIncomeAnalysis?.totals?.ttm || 0;
                        
                        // Other Expense
                        const oe3 = otherExpenseAnalysis?.totals?.year3 || 0;
                        const oe4 = otherExpenseAnalysis?.totals?.year4 || 0;
                        const oe5 = otherExpenseAnalysis?.totals?.year5 || 0;
                        const oeTtm = otherExpenseAnalysis?.totals?.ttm || 0;
                        
                        // Net Income = GP - OpEx + OI - OE
                        const ni3 = gp3 - opex3 + oi3 - oe3;
                        const ni4 = gp4 - opex4 + oi4 - oe4;
                        const ni5 = gp5 - opex5 + oi5 - oe5;
                        const niTtm = gpTtm - opexTtm + oiTtm - oeTtm;
                        
                        // DIAT - includes both dedicated fields AND line-based adjustments with D/I/A/T categories
                        const getDiat = (year) => {
                          const fromDiatCategories = (diatCategories.interest?.[basisKey]?.[year] || 0) + 
                                 (diatCategories.taxes?.[basisKey]?.[year] || 0) + 
                                 (diatCategories.depreciation?.[basisKey]?.[year] || 0) + 
                                 (diatCategories.amortization?.[basisKey]?.[year] || 0);
                          const fromLineBasedOpex = opexCategories.reduce((sum, cat) => {
                            if (!cat.addbackPct || cat.addbackPct <= 0) return sum;
                            if (!['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory)) return sum;
                            if (cat.adjIncluded === false) return sum;
                            const lineValue = cat[selectedValuationBasis]?.[year] || 0;
                            return sum + (lineValue * cat.addbackPct / 100);
                          }, 0);
                          const fromLineBasedOE = otherExpenseCategories.reduce((sum, cat) => {
                            if (!cat.addbackPct || cat.addbackPct <= 0) return sum;
                            if (!['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory)) return sum;
                            if (cat.adjIncluded === false) return sum;
                            const lineValue = cat[selectedValuationBasis]?.[year] || 0;
                            return sum + (lineValue * cat.addbackPct / 100);
                          }, 0);
                          // Manual D/I/A/T adjustments (depreciation inside COGS…) — the engine's period rule.
                          const fromManual = manualDiatSum(adjustmentItems, null, a => a.year === 'All Years' || (year === 'ttm' ? a.year === 'TTM' : a.year === basisYearLabels[year]));
                          return fromDiatCategories + fromLineBasedOpex + fromLineBasedOE + fromManual;
                        };
                        
                        const diat3 = getDiat('year3');
                        const diat4 = getDiat('year4');
                        const diat5 = getDiat('year5');
                        const diatTtm = getDiat('ttm');
                        
                        // EBITDA = Net Income + DIAT
                        const ebitda3 = ni3 + diat3;
                        const ebitda4 = ni4 + diat4;
                        const ebitda5 = ni5 + diat5;
                        const ebitdaTtm = niTtm + diatTtm;
                        
                        return (
                          <>
                            {/* Revenue */}
                            <tr className="bg-white">
                              <td className="p-2 border-b border-gray-200 font-medium text-gray-800">Revenue</td>
                              <td className="p-2 border-b border-gray-200 text-right">{formatCurrency(rev3)}</td>
                              <td className="p-2 border-b border-gray-200 text-right">{formatCurrency(rev4)}</td>
                              <td className="p-2 border-b border-gray-200 text-right">{formatCurrency(rev5)}</td>
                              <td className="p-2 border-b border-gray-200 text-right font-medium bg-gray-50">{formatCurrency(revTtm)}</td>
                            </tr>
                            
                            {/* COGS */}
                            <tr className="bg-white">
                              <td className="p-2 border-b border-gray-200 font-medium text-gray-800">COGS</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">({formatCurrency(cogs3)})</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">({formatCurrency(cogs4)})</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">({formatCurrency(cogs5)})</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600 bg-gray-50">({formatCurrency(cogsTtm)})</td>
                            </tr>
                            
                            {/* Gross Profit */}
                            <tr className="bg-gray-100">
                              <td className="p-2 border-b border-gray-300 font-semibold text-gray-800">Gross Profit</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(gp3)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(gp4)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(gp5)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium bg-gray-200">{formatCurrency(gpTtm)}</td>
                            </tr>
                            <tr className="text-gray-500 text-xs">
                              <td className="p-1 border-b border-gray-200 pl-4 italic">Gross Margin %</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev3 ? ((gp3/rev3)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev4 ? ((gp4/rev4)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev5 ? ((gp5/rev5)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right bg-gray-50">{revTtm ? ((gpTtm/revTtm)*100).toFixed(1) : 0}%</td>
                            </tr>
                            
                            {/* Operating Expenses */}
                            <tr className="bg-white">
                              <td className="p-2 border-b border-gray-200 font-medium text-gray-800">Operating Expenses</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">({formatCurrency(opex3)})</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">({formatCurrency(opex4)})</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">({formatCurrency(opex5)})</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600 bg-gray-50">({formatCurrency(opexTtm)})</td>
                            </tr>
                            
                            {/* Net Income */}
                            <tr className="bg-gray-100">
                              <td className="p-2 border-b border-gray-300 font-semibold text-gray-800">Net Income</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(ni3)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(ni4)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(ni5)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium bg-gray-200">{formatCurrency(niTtm)}</td>
                            </tr>
                            <tr className="text-gray-500 text-xs">
                              <td className="p-1 border-b border-gray-200 pl-4 italic">Net Margin %</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev3 ? ((ni3/rev3)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev4 ? ((ni4/rev4)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev5 ? ((ni5/rev5)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right bg-gray-50">{revTtm ? ((niTtm/revTtm)*100).toFixed(1) : 0}%</td>
                            </tr>
                            
                            {/* ITDA Add-backs */}
                            <tr className="bg-white">
                              <td className="p-2 border-b border-gray-200 font-medium text-gray-600">+ Interest, Taxes, D&A</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">{formatCurrency(diat3)}</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">{formatCurrency(diat4)}</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">{formatCurrency(diat5)}</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600 bg-gray-50">{formatCurrency(diatTtm)}</td>
                            </tr>
                            
                            {/* Reported EBITDA */}
                            <tr className="bg-gray-100">
                              <td className="p-2 border-b border-gray-300 font-semibold text-gray-800">Reported EBITDA</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(ebitda3)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(ebitda4)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium">{formatCurrency(ebitda5)}</td>
                              <td className="p-2 border-b border-gray-300 text-right font-medium bg-gray-200">{formatCurrency(ebitdaTtm)}</td>
                            </tr>
                            <tr className="text-gray-500 text-xs">
                              <td className="p-1 border-b border-gray-200 pl-4 italic">EBITDA Margin %</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev3 ? ((ebitda3/rev3)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev4 ? ((ebitda4/rev4)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{rev5 ? ((ebitda5/rev5)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right bg-gray-50">{revTtm ? ((ebitdaTtm/revTtm)*100).toFixed(1) : 0}%</td>
                            </tr>
                            
                            {/* Normalizing Adjustments */}
                            <tr className="bg-white">
                              <td className="p-2 border-b border-gray-200 font-medium text-gray-600">+ Normalizing Adjustments</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">{formatCurrency(calculations.years[2].adjustedEbitda - ebitda3)}</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">{formatCurrency(calculations.years[3].adjustedEbitda - ebitda4)}</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600">{formatCurrency(calculations.years[4].adjustedEbitda - ebitda5)}</td>
                              <td className="p-2 border-b border-gray-200 text-right text-gray-600 bg-gray-50">{formatCurrency(calculations.years[5].adjustedEbitda - ebitdaTtm)}</td>
                            </tr>
                            <tr className="text-gray-500 text-xs">
                              <td className="p-1 border-b border-gray-200 pl-4 italic">Adjustments as % of Revenue</td>
                              <td className="p-1 border-b border-gray-200 text-right">{calculations.years[2].revenue ? (((calculations.years[2].adjustedEbitda - ebitda3)/calculations.years[2].revenue)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{calculations.years[3].revenue ? (((calculations.years[3].adjustedEbitda - ebitda4)/calculations.years[3].revenue)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{calculations.years[4].revenue ? (((calculations.years[4].adjustedEbitda - ebitda5)/calculations.years[4].revenue)*100).toFixed(1) : 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right bg-gray-50">{calculations.years[5].revenue ? (((calculations.years[5].adjustedEbitda - ebitdaTtm)/calculations.years[5].revenue)*100).toFixed(1) : 0}%</td>
                            </tr>
                            
                            {/* Normalized EBITDA - the only green accent row */}
                            <tr className="bg-green-700 text-white">
                              <td className="p-3 font-bold">{(Number(calculations?.valuation?.maintCapex) || 0) > 0 ? 'Normalized EBITDA after capex' : 'Normalized EBITDA'}</td>
                              <td className="p-3 text-right font-bold">{formatCurrency(calculations.years[2].adjustedEbitda)}</td>
                              <td className="p-3 text-right font-bold">{formatCurrency(calculations.years[3].adjustedEbitda)}</td>
                              <td className="p-3 text-right font-bold">{formatCurrency(calculations.years[4].adjustedEbitda)}</td>
                              <td className="p-3 text-right font-bold bg-green-800">{formatCurrency(calculations.years[5].adjustedEbitda)}</td>
                            </tr>
                            <tr className="text-gray-600 text-xs">
                              <td className="p-1 border-b border-gray-200 pl-4 italic">{(Number(calculations?.valuation?.maintCapex) || 0) > 0 ? 'Normalized EBITDA after capex margin %' : 'Normalized EBITDA Margin %'}</td>
                              <td className="p-1 border-b border-gray-200 text-right">{calculations.years[2].adjustedEbitdaMargin?.toFixed(1) || 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{calculations.years[3].adjustedEbitdaMargin?.toFixed(1) || 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right">{calculations.years[4].adjustedEbitdaMargin?.toFixed(1) || 0}%</td>
                              <td className="p-1 border-b border-gray-200 text-right bg-gray-50">{calculations.years[5].adjustedEbitdaMargin?.toFixed(1) || 0}%</td>
                            </tr>
                          </>
                        );
                      })()}
                    </tbody>
                  </table>
                </div>
                  </div>
                </div>

                {/* SECTION 2: How We Calculate Normalized EBITDA */}
                <div className="mb-8">
                  <div className="bg-gray-700 text-white px-4 py-3 rounded-t-lg font-semibold">
                    How We Calculate Normalized EBITDA
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-5 bg-white">
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5 text-sm text-gray-600">
                      <strong className="text-gray-800">Why Normalize EBITDA?</strong> Buyers don't just look at your reported earnings—they want to understand what they'll 
                      actually earn as the new owner. We start with Net Income, add back non-cash and financing items (D/I/A/T), then adjust for 
                      owner-specific items and non-recurring expenses. This "Normalized EBITDA" is the foundation of your valuation.
                    </div>
                    
                    {/* Owner Compensation Explanation */}
                    {ownerCompensation?.marketReplacement > 0 && (
                      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5">
                        <div className="font-semibold text-gray-700 text-sm mb-2">Understanding Owner Compensation Adjustments</div>
                        <div className="text-xs text-gray-600">
                          <p className="mb-2">
                            <strong>Market Replacement Rate:</strong> {formatCurrency(ownerCompensation.marketReplacement)}/year
                          </p>
                          {ownerCompensation.marketReplacementNotes && (
                            <p className="mb-2 text-gray-700 bg-white border border-gray-200 rounded p-2 italic">
                              <strong className="not-italic">Rationale:</strong> {ownerCompensation.marketReplacementNotes}
                            </p>
                          )}
                          <p className="text-gray-500">
                            This is the estimated cost to hire a professional manager to perform the owner's operational duties. 
                            Owner compensation above this amount is added back because a buyer would not need to pay above-market 
                            salaries. Benefits, perks, and personal expenses run through the business are also added back as they 
                            represent owner discretionary spending rather than true business expenses.
                          </p>
                        </div>
                      </div>
                    )}

                {/* ========== DETAILED EBITDA CALCULATION ========== */}
                
                {(() => {
                  // Use same calculation approach as presentation package
                  const basisKey = selectedValuationBasis === 'tax' ? 'cash' : selectedValuationBasis;
                  const yearLabels = basisYearLabels;
                  const periodKeys = ['year3', 'year4', 'year5', 'ttm'];
                  
                  // Get financials using same method as getExportData
                  const revenueByYear = {
                    year3: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0),
                    year4: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0),
                    year5: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0),
                    ttm: revenueCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0)
                  };
                  const cogsByYear = {
                    year3: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0),
                    year4: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0),
                    year5: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0),
                    ttm: cogsCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0)
                  };
                  const opexByYear = {
                    year3: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year3 || 0), 0),
                    year4: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year4 || 0), 0),
                    year5: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.year5 || 0), 0),
                    ttm: opexCategories.reduce((sum, c) => sum + (c[selectedValuationBasis]?.ttm || 0), 0)
                  };
                  const gpByYear = {
                    year3: revenueByYear.year3 - cogsByYear.year3,
                    year4: revenueByYear.year4 - cogsByYear.year4,
                    year5: revenueByYear.year5 - cogsByYear.year5,
                    ttm: revenueByYear.ttm - cogsByYear.ttm
                  };
                  const oiByYear = {
                    year3: otherIncomeAnalysis?.totals?.year3 || 0,
                    year4: otherIncomeAnalysis?.totals?.year4 || 0,
                    year5: otherIncomeAnalysis?.totals?.year5 || 0,
                    ttm: otherIncomeAnalysis?.totals?.ttm || 0
                  };
                  const oeByYear = {
                    year3: otherExpenseAnalysis?.totals?.year3 || 0,
                    year4: otherExpenseAnalysis?.totals?.year4 || 0,
                    year5: otherExpenseAnalysis?.totals?.year5 || 0,
                    ttm: otherExpenseAnalysis?.totals?.ttm || 0
                  };
                  const niByYear = {
                    year3: gpByYear.year3 - opexByYear.year3 + oiByYear.year3 - oeByYear.year3,
                    year4: gpByYear.year4 - opexByYear.year4 + oiByYear.year4 - oeByYear.year4,
                    year5: gpByYear.year5 - opexByYear.year5 + oiByYear.year5 - oeByYear.year5,
                    ttm: gpByYear.ttm - opexByYear.ttm + oiByYear.ttm - oeByYear.ttm
                  };
                  
                  // (moved above the D/I/A/T breakdown 10-14 — the manual D/I/A/T rows use it)
                  // Helper: does this adjustment apply to this period?
                  const yearMap = {
                    year3: yearLabels.year3 || 'Year 3',
                    year4: yearLabels.year4 || 'Year 4',
                    year5: yearLabels.year5 || 'Year 5',
                    ttm: ttmLabel
                  };
                  // Check if TTM and Year5 are essentially the same period (YTD scenario)
                  // This happens when TTM data IS the YTD data for the current year
                  const year5Label = yearLabels.year5 || '';
                  const ttmLabelLower = (ttmLabel || '').toLowerCase();
                  const year5Year = year5Label.match(/\d{4}/)?.[0] || '';
                  const ttmYear = ttmLabel?.match(/\d{4}/)?.[0] || (ttmLabel?.match(/\d{2}$/)?.[0] ? '20' + ttmLabel.match(/\d{2}$/)[0] : '');
                  const ttmMatchesYear5 = (
                    ttmLabelLower.includes('ytd') ||
                    year5Label.toLowerCase().includes('ytd') ||
                    (year5Year && ttmYear && year5Year === ttmYear)
                    // Removed: ttmLabel.includes(year5Year.slice(-2)) — too loose,
                    // "25" appears inside TTM date ranges like "Mar25 - Feb26" but that
                    // does NOT mean TTM equals Year 5. Only match when 4-digit years align.
                  );
                  const appliesToPeriod = (adj, pk) => {
                    if (adj.year === 'All Years') return true;
                    if (adj.year === yearMap[pk]) return true;
                    // Always match plain "TTM" for the TTM period —
                    // adjustments saved as year="TTM" must show in TTM column
                    // even when ttmLabel is a full string like "TTM (Mar25 - Feb26)"
                    if (pk === 'ttm' && adj.year === 'TTM') return true;
                    // If TTM matches Year5 (YTD scenario), also accept Year5's label for TTM
                    if (pk === 'ttm' && ttmMatchesYear5 && adj.year === yearMap.year5) return true;
                    // NOTE: We do NOT add TTM adjustments to year5 - that would cause double-counting
                    return false;
                  };
                  // D/I/A/T breakdown with line-based adjustments from both OpEx and Other Expense
                  const getDiatComponent = (component, year) => {
                    const fromDiatCategories = diatCategories[component]?.[basisKey]?.[year] || 0;
                    const fromOpexLineBased = opexCategories.reduce((sum, cat) => {
                      if (!cat.addbackPct || cat.addbackPct <= 0) return sum;
                      const catMap = { 'Depreciation': 'depreciation', 'Interest': 'interest', 'Amortization': 'amortization', 'Taxes': 'taxes' };
                      if (catMap[cat.adjCategory] !== component) return sum;
                      if (cat.adjIncluded === false) return sum;
                      return sum + ((cat[selectedValuationBasis]?.[year] || 0) * cat.addbackPct / 100);
                    }, 0);
                    const fromOELineBased = otherExpenseCategories.reduce((sum, cat) => {
                      if (!cat.addbackPct || cat.addbackPct <= 0) return sum;
                      const catMap = { 'Depreciation': 'depreciation', 'Interest': 'interest', 'Amortization': 'amortization', 'Taxes': 'taxes' };
                      if (catMap[cat.adjCategory] !== component) return sum;
                      if (cat.adjIncluded === false) return sum;
                      return sum + ((cat[selectedValuationBasis]?.[year] || 0) * cat.addbackPct / 100);
                    }, 0);
                    // Manual D/I/A/T adjustments (depreciation inside COGS…) — this bridge's own period rule.
                    const fromManual = manualDiatSum(adjustmentItems, component, a => appliesToPeriod(a, year));
                    return fromDiatCategories + fromOpexLineBased + fromOELineBased + fromManual;
                  };

                  const diatBreakdown = {
                    depreciation: { year3: getDiatComponent('depreciation', 'year3'), year4: getDiatComponent('depreciation', 'year4'), year5: getDiatComponent('depreciation', 'year5'), ttm: getDiatComponent('depreciation', 'ttm') },
                    interest: { year3: getDiatComponent('interest', 'year3'), year4: getDiatComponent('interest', 'year4'), year5: getDiatComponent('interest', 'year5'), ttm: getDiatComponent('interest', 'ttm') },
                    amortization: { year3: getDiatComponent('amortization', 'year3'), year4: getDiatComponent('amortization', 'year4'), year5: getDiatComponent('amortization', 'year5'), ttm: getDiatComponent('amortization', 'ttm') },
                    taxes: { year3: getDiatComponent('taxes', 'year3'), year4: getDiatComponent('taxes', 'year4'), year5: getDiatComponent('taxes', 'year5'), ttm: getDiatComponent('taxes', 'ttm') }
                  };
                  
                  const diatTotal = {
                    year3: diatBreakdown.depreciation.year3 + diatBreakdown.interest.year3 + diatBreakdown.amortization.year3 + diatBreakdown.taxes.year3,
                    year4: diatBreakdown.depreciation.year4 + diatBreakdown.interest.year4 + diatBreakdown.amortization.year4 + diatBreakdown.taxes.year4,
                    year5: diatBreakdown.depreciation.year5 + diatBreakdown.interest.year5 + diatBreakdown.amortization.year5 + diatBreakdown.taxes.year5,
                    ttm: diatBreakdown.depreciation.ttm + diatBreakdown.interest.ttm + diatBreakdown.amortization.ttm + diatBreakdown.taxes.ttm
                  };
                  
                  const ebitdaByYear = {
                    year3: niByYear.year3 + diatTotal.year3,
                    year4: niByYear.year4 + diatTotal.year4,
                    year5: niByYear.year5 + diatTotal.year5,
                    ttm: niByYear.ttm + diatTotal.ttm
                  };
                  
                  // Categorize adjustments: Owner Compensation vs Other
                  const ownerCompKeywords = ['owner', 'salary', 'compensation', 'wage', 'bonus', 'benefit', 'health', 'insurance', 'auto', 'vehicle', 'car', 'personal', 'family'];
                  const groupedOwnerComp = {};
                  const groupedOther = {};
                  
                  
                  // Process adjustments
                  adjustmentItems.filter(a => a.included).forEach(adj => {
                    if (isManualDiatAdj(adj)) return;  // shown in the D/I/A/T rows above (Colleen 10-14) — never twice
                    const desc = (adj.description || '').trim();
                    const plLine = adj.plLine || '';
                    const key = plLine + '|' + desc.toLowerCase();
                    const descLower = desc.toLowerCase();
                    const plLineLower = plLine.toLowerCase();
                    const isOwnerComp = adj.category === 'Owner Benefits' || adj.category === 'Personal Expense' || (!adj.category && ownerCompKeywords.some(kw => descLower.includes(kw) || plLineLower.includes(kw)));
                    const targetGroup = isOwnerComp ? groupedOwnerComp : groupedOther;
                    
                    if (!targetGroup[key]) {
                      targetGroup[key] = { plLine: plLine, description: desc || '(No description)', year3: 0, year4: 0, year5: 0, ttm: 0 };
                    }
                    
                    // Calculate EBITDA impact
                    // The shared test (Colleen 10-20: a CapEx line showed "+$30,000" here while it LOWERS EBITDA —
                    // this local copy missed the CapEx and Rent (Market Adj) lines the calculation counts as expenses).
                    const isExpenseLine = isExpensePlLine(plLine);
                    const amount = adj.amount || 0;
                    const ebitdaImpact = isExpenseLine ? (adj.type === 'deduct' ? amount : -amount) : (adj.type === 'add' ? amount : -amount);
                    
                    periodKeys.forEach(pk => {
                      if (appliesToPeriod(adj, pk)) targetGroup[key][pk] += ebitdaImpact;
                    });
                  });
                  
                  // Process line-based adjustments (percentage-based add-backs) - OpEx
                  opexCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && !['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory)).forEach(cat => {
                    const key = cat.name + '|' + cat.addbackPct + '% add-back';
                    const descLower = cat.name.toLowerCase();
                    const isOwnerComp = cat.adjCategory === 'Owner Benefits' || cat.adjCategory === 'Personal Expense' || (!cat.adjCategory && ownerCompKeywords.some(kw => descLower.includes(kw)));
                    const targetGroup = isOwnerComp ? groupedOwnerComp : groupedOther;
                    
                    if (!targetGroup[key]) {
                      targetGroup[key] = { plLine: 'OpEx: ' + cat.name, description: lineAdjLabel(cat.adjDescription, cat.addbackPct, cat.addbackPct + '% add-back'), year3: 0, year4: 0, year5: 0, ttm: 0 };
                    }
                    targetGroup[key].year3 += (cat[selectedValuationBasis]?.year3 || 0) * cat.addbackPct / 100;
                    targetGroup[key].year4 += (cat[selectedValuationBasis]?.year4 || 0) * cat.addbackPct / 100;
                    targetGroup[key].year5 += (cat[selectedValuationBasis]?.year5 || 0) * cat.addbackPct / 100;
                    targetGroup[key].ttm += (cat[selectedValuationBasis]?.ttm || 0) * cat.addbackPct / 100;
                  });
                  
                  // Process line-based adjustments (percentage-based add-backs) - Other Expense
                  otherExpenseCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false && !['Depreciation', 'Interest', 'Amortization', 'Taxes'].includes(cat.adjCategory)).forEach(cat => {
                    const key = cat.name + '|' + cat.addbackPct + '% add-back (OE)';
                    const descLower = cat.name.toLowerCase();
                    const isOwnerComp = cat.adjCategory === 'Owner Benefits' || cat.adjCategory === 'Personal Expense' || (!cat.adjCategory && ownerCompKeywords.some(kw => descLower.includes(kw)));
                    const targetGroup = isOwnerComp ? groupedOwnerComp : groupedOther;
                    
                    if (!targetGroup[key]) {
                      targetGroup[key] = { plLine: 'Other Expense: ' + cat.name, description: lineAdjLabel(cat.adjDescription, cat.addbackPct, cat.addbackPct + '% add-back'), year3: 0, year4: 0, year5: 0, ttm: 0 };
                    }
                    targetGroup[key].year3 += (cat[selectedValuationBasis]?.year3 || 0) * cat.addbackPct / 100;
                    targetGroup[key].year4 += (cat[selectedValuationBasis]?.year4 || 0) * cat.addbackPct / 100;
                    targetGroup[key].year5 += (cat[selectedValuationBasis]?.year5 || 0) * cat.addbackPct / 100;
                    targetGroup[key].ttm += (cat[selectedValuationBasis]?.ttm || 0) * cat.addbackPct / 100;
                  });
                  
                  // Process line-based adjustments - Other Income (non-operating income deducted from EBITDA)
                  // Other Income items with addbackPct reduce EBITDA (non-recurring income is backed out)
                  otherIncomeCategories.filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false).forEach(cat => {
                    const key = cat.name + '|' + cat.addbackPct + '% deduction (OI)';
                    const descLower = cat.name.toLowerCase();
                    const isOwnerComp = cat.adjCategory === 'Owner Benefits' || cat.adjCategory === 'Personal Expense' || (!cat.adjCategory && ownerCompKeywords.some(kw => descLower.includes(kw)));
                    const targetGroup = isOwnerComp ? groupedOwnerComp : groupedOther;
                    if (!targetGroup[key]) {
                      targetGroup[key] = { plLine: 'Other Income: ' + cat.name, description: lineAdjLabel(cat.adjDescription, cat.addbackPct, cat.addbackPct + '% deduction (non-recurring income)'), year3: 0, year4: 0, year5: 0, ttm: 0 };
                    }
                    // Other Income deductions REDUCE EBITDA — sign is negative
                    targetGroup[key].year3 -= (cat[selectedValuationBasis]?.year3 || 0) * cat.addbackPct / 100;
                    targetGroup[key].year4 -= (cat[selectedValuationBasis]?.year4 || 0) * cat.addbackPct / 100;
                    targetGroup[key].year5 -= (cat[selectedValuationBasis]?.year5 || 0) * cat.addbackPct / 100;
                    targetGroup[key].ttm -= (cat[selectedValuationBasis]?.ttm || 0) * cat.addbackPct / 100;
                  });
                  
                  // Add Market Replacement as explicit deduction (the cost a buyer would incur)
                  const marketRate = ownerCompensation?.marketReplacement || 0;
                  const hasMarketRate = marketRate > 0;
                  
                  if (hasMarketRate) {
                    groupedOwnerComp['_marketReplacement'] = {
                      plLine: 'Less: Market Replacement',
                      description: `Cost to hire replacement manager`,
                      year3: -mkFor('year3'),
                      year4: -mkFor('year4'),
                      year5: -mkFor('year5'),
                      ttm: -mkFor('ttm'),
                      sortOrder: 2
                    };
                  }
                  
                  // Add Employer Payroll Tax Adjustment explicitly
                  // Calculate tax savings/cost based on the NET salary adjustment (owner salary - market)
                  // When owner overpaid: excess payroll taxes also get removed → ADDS to EBITDA (positive)
                  // When owner underpaid: additional payroll taxes needed → REDUCES EBITDA (negative)
                  // TTM salary: if not explicitly set and embeddedInWages, fall back to year5 salary
                  const getTtmSalary = (oc) => oc?.ttm?.salary || (oc?.embeddedInWages ? (oc?.year5?.salary || 0) : 0);
                  const ownerSalaryAdj = {
                    year3: (ownerCompensation?.year3?.salary || 0) - mkFor('year3'),
                    year4: (ownerCompensation?.year4?.salary || 0) - mkFor('year4'),
                    year5: (ownerCompensation?.year5?.salary || 0) - mkFor('year5'),
                    ttm: getTtmSalary(ownerCompensation) - mkFor('ttm')
                  };
                  const payrollTaxRate = ownerCompensation?.includePayrollTax !== false ? ((ownerCompensation?.payrollTaxRate || 7.65) / 100) : 0;
                  const ownerPayrollTaxAdj = {
                    year3: -ownerTaxAdj(ownerCompensation?.year3?.salary || 0, marketRate, 'year3'),
                    year4: -ownerTaxAdj(ownerCompensation?.year4?.salary || 0, marketRate, 'year4'),
                    year5: -ownerTaxAdj(ownerCompensation?.year5?.salary || 0, marketRate, 'year5'),
                    ttm: -ownerTaxAdj(getTtmSalary(ownerCompensation), marketRate, 'ttm')
                  };
                  const hasOwnerSalaryAdj = ownerSalaryAdj.year3 !== 0 || ownerSalaryAdj.year4 !== 0 || ownerSalaryAdj.year5 !== 0 || ownerSalaryAdj.ttm !== 0;
                  const hasPayrollTaxAdj = payrollTaxRate > 0 && hasOwnerSalaryAdj;
                  
                  if (hasPayrollTaxAdj) {
                    groupedOwnerComp['_payrollTax'] = {
                      plLine: 'Employer Payroll Tax',
                      description: payrollTaxDesc,
                      year3: ownerPayrollTaxAdj.year3,
                      year4: ownerPayrollTaxAdj.year4,
                      year5: ownerPayrollTaxAdj.year5,
                      ttm: ownerPayrollTaxAdj.ttm,
                      sortOrder: 3
                    };
                  }
                  
                  // Mark salary-removal items with sortOrder 1 so they appear first
                  Object.entries(groupedOwnerComp).forEach(([key, item]) => {
                    if (item.sortOrder === undefined) {
                      const plLineLower = (item.plLine || '').toLowerCase();
                      if (plLineLower.includes('payroll') || plLineLower.includes('salary') || plLineLower.includes('wages')) {
                        item.sortOrder = 1;
                        // Improve description for salary removal items
                        if (item.description && item.description.includes('add-back')) {
                          item.description = 'Owner salary removed from payroll expenses';
                        }
                      } else {
                        item.sortOrder = 4; // Other owner benefits
                      }
                    }
                  });
                  
                  // Calculate totals
                  const ownerCompTotal = { year3: 0, year4: 0, year5: 0, ttm: 0 };
                  Object.values(groupedOwnerComp).forEach(grp => {
                    ownerCompTotal.year3 += grp.year3; ownerCompTotal.year4 += grp.year4;
                    ownerCompTotal.year5 += grp.year5; ownerCompTotal.ttm += grp.ttm;
                  });
                  
                  const otherTotal = { year3: 0, year4: 0, year5: 0, ttm: 0 };
                  Object.values(groupedOther).forEach(grp => {
                    otherTotal.year3 += grp.year3; otherTotal.year4 += grp.year4;
                    otherTotal.year5 += grp.year5; otherTotal.ttm += grp.ttm;
                  });
                  
                  const hasOwnerComp = Object.keys(groupedOwnerComp).length > 0;
                  const hasOther = Object.keys(groupedOther).length > 0;
                  const marketReplacement = ownerCompensation?.marketReplacement || 0;
                  const hasMarketReplacement = marketReplacement > 0;
                  
                  // Net owner comp - market replacement is now included in owner salary adjustment
                  // so we just use the total from groupedOwnerComp
                  const ownerCompNetTotal = {
                    year3: ownerCompTotal.year3,
                    year4: ownerCompTotal.year4,
                    year5: ownerCompTotal.year5,
                    ttm: ownerCompTotal.ttm
                  };
                  
                  // USE CALCULATIONS OBJECT for correct normalized EBITDA (source of truth)
                  // The TTM column must always reflect the actual TTM normalized EBITDA.
                  // Do NOT use valuation.metric here — that holds whichever period the user
                  // selected for valuation (TTM / last year / average / weighted), so it would
                  // overwrite the TTM column with the selected period. ebitdaOptions.ttm is the
                  // genuine TTM adjusted EBITDA regardless of the selected valuation period.
                  const ebitdaOpts = calculations?.ebitdaOptions || {};
                  const calcNormEbitda = {
                    year3: calculations.years[2]?.adjustedEbitda || 0,
                    year4: calculations.years[3]?.adjustedEbitda || 0,
                    year5: calculations.years[4]?.adjustedEbitda || 0,
                    ttm: ebitdaOpts.ttm || calculations.years[5]?.adjustedEbitda || 0
                  };
                  
                  // Total normalizing adjustments = Normalized EBITDA - Reported EBITDA
                  const totalNormalizingAdj = {
                    year3: calcNormEbitda.year3 - ebitdaByYear.year3,
                    year4: calcNormEbitda.year4 - ebitdaByYear.year4,
                    year5: calcNormEbitda.year5 - ebitdaByYear.year5,
                    ttm: calcNormEbitda.ttm - ebitdaByYear.ttm
                  };
                  
                  // Row generator for adjustment groups - professional styling with parentheses for negatives
                  const generateRows = (grouped, sorted = false) => {
                    let items = Object.values(grouped).filter(grp => grp.year3 !== 0 || grp.year4 !== 0 || grp.year5 !== 0 || grp.ttm !== 0);
                    if (sorted) {
                      items = items.sort((a, b) => (a.sortOrder || 99) - (b.sortOrder || 99));
                    }
                    return items.map((grp, idx) => (
                      <tr key={idx} className="bg-white">
                        <td className="p-2 pl-6 text-gray-600">{grp.plLine || '-'}</td>
                        <td className="p-2 text-xs text-gray-400">{grp.description}</td>
                        <td className="p-2 text-right text-gray-700">{grp.year3 !== 0 ? (grp.year3 < 0 ? '(' : '') + formatCurrency(Math.abs(grp.year3)) + (grp.year3 < 0 ? ')' : '') : '-'}</td>
                        <td className="p-2 text-right text-gray-700">{grp.year4 !== 0 ? (grp.year4 < 0 ? '(' : '') + formatCurrency(Math.abs(grp.year4)) + (grp.year4 < 0 ? ')' : '') : '-'}</td>
                        <td className="p-2 text-right text-gray-700">{grp.year5 !== 0 ? (grp.year5 < 0 ? '(' : '') + formatCurrency(Math.abs(grp.year5)) + (grp.year5 < 0 ? ')' : '') : '-'}</td>
                        <td className="p-2 text-right text-gray-700 bg-gray-50">{grp.ttm !== 0 ? (grp.ttm < 0 ? '(' : '') + formatCurrency(Math.abs(grp.ttm)) + (grp.ttm < 0 ? ')' : '') : '-'}</td>
                      </tr>
                    ));
                  };
                  
                  return (
                    <div>
                      {/* Main EBITDA Calculation Table */}
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead>
                            <tr className="bg-gray-700 text-white">
                              <th className="p-3 text-left font-medium" style={{width: '160px'}}>Category</th>
                              <th className="p-3 text-left font-medium">Description</th>
                              <th className="p-3 text-right font-medium" style={{width: '100px'}}>{yearLabels.year3 || 'Year 3'}</th>
                              <th className="p-3 text-right font-medium" style={{width: '100px'}}>{yearLabels.year4 || 'Year 4'}</th>
                              <th className="p-3 text-right font-medium" style={{width: '100px'}}>{yearLabels.year5 || 'Year 5'}</th>
                              <th className="p-3 text-right font-medium bg-gray-800" style={{width: '100px'}}>{ttmLabel}</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                            {/* Starting Point: Net Income */}
                            <tr className="bg-gray-50">
                              <td colSpan="2" className="p-3 font-semibold text-gray-800">Reported Net Income</td>
                              <td className="p-3 text-right font-medium">{formatCurrency(niByYear.year3)}</td>
                              <td className="p-3 text-right font-medium">{formatCurrency(niByYear.year4)}</td>
                              <td className="p-3 text-right font-medium">{formatCurrency(niByYear.year5)}</td>
                              <td className="p-3 text-right font-medium bg-gray-100">{formatCurrency(niByYear.ttm)}</td>
                            </tr>
                            
                            {/* D/I/A/T Section Header */}
                            <tr>
                              <td colSpan="6" className="p-3 bg-white border-t-2 border-gray-300">
                                <span className="font-semibold text-gray-700">Add: Depreciation, Interest, Amortization & Taxes</span>
                                <span className="text-xs text-gray-500 ml-2">Non-cash and financing items</span>
                              </td>
                            </tr>
                            
                            {/* D/I/A/T Individual Rows */}
                            {(diatBreakdown.depreciation.ttm !== 0 || diatBreakdown.depreciation.year3 !== 0 || diatBreakdown.depreciation.year4 !== 0 || diatBreakdown.depreciation.year5 !== 0) && (
                              <tr className="bg-white">
                                <td className="p-2 pl-6 text-gray-600">Depreciation</td>
                                <td className="p-2 text-xs text-gray-400">Non-cash expense</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.depreciation.year3)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.depreciation.year4)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.depreciation.year5)}</td>
                                <td className="p-2 text-right text-gray-700 bg-gray-50">{formatCurrency(diatBreakdown.depreciation.ttm)}</td>
                              </tr>
                            )}
                            {(diatBreakdown.interest.ttm !== 0 || diatBreakdown.interest.year3 !== 0 || diatBreakdown.interest.year4 !== 0 || diatBreakdown.interest.year5 !== 0) && (
                              <tr className="bg-white">
                                <td className="p-2 pl-6 text-gray-600">Interest Expense</td>
                                <td className="p-2 text-xs text-gray-400">Financing cost</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.interest.year3)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.interest.year4)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.interest.year5)}</td>
                                <td className="p-2 text-right text-gray-700 bg-gray-50">{formatCurrency(diatBreakdown.interest.ttm)}</td>
                              </tr>
                            )}
                            {(diatBreakdown.amortization.ttm !== 0 || diatBreakdown.amortization.year3 !== 0 || diatBreakdown.amortization.year4 !== 0 || diatBreakdown.amortization.year5 !== 0) && (
                              <tr className="bg-white">
                                <td className="p-2 pl-6 text-gray-600">Amortization</td>
                                <td className="p-2 text-xs text-gray-400">Non-cash expense</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.amortization.year3)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.amortization.year4)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.amortization.year5)}</td>
                                <td className="p-2 text-right text-gray-700 bg-gray-50">{formatCurrency(diatBreakdown.amortization.ttm)}</td>
                              </tr>
                            )}
                            {(diatBreakdown.taxes.ttm !== 0 || diatBreakdown.taxes.year3 !== 0 || diatBreakdown.taxes.year4 !== 0 || diatBreakdown.taxes.year5 !== 0) && (
                              <tr className="bg-white">
                                <td className="p-2 pl-6 text-gray-600">Income Taxes</td>
                                <td className="p-2 text-xs text-gray-400">Tax expense</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.taxes.year3)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.taxes.year4)}</td>
                                <td className="p-2 text-right text-gray-700">{formatCurrency(diatBreakdown.taxes.year5)}</td>
                                <td className="p-2 text-right text-gray-700 bg-gray-50">{formatCurrency(diatBreakdown.taxes.ttm)}</td>
                              </tr>
                            )}
                            
                            {/* D/I/A/T Subtotal */}
                            <tr className="bg-gray-100 border-t border-gray-300">
                              <td colSpan="2" className="p-2 pl-6 font-medium text-gray-600">Subtotal D/I/A/T</td>
                              <td className="p-2 text-right font-medium text-gray-700">{formatCurrency(diatTotal.year3)}</td>
                              <td className="p-2 text-right font-medium text-gray-700">{formatCurrency(diatTotal.year4)}</td>
                              <td className="p-2 text-right font-medium text-gray-700">{formatCurrency(diatTotal.year5)}</td>
                              <td className="p-2 text-right font-medium text-gray-700 bg-gray-200">{formatCurrency(diatTotal.ttm)}</td>
                            </tr>
                            
                            {/* Reported EBITDA */}
                            <tr className="bg-gray-200 border-t-2 border-gray-400">
                              <td colSpan="2" className="p-3 font-semibold text-gray-800">Reported EBITDA</td>
                              <td className="p-3 text-right font-semibold">{formatCurrency(ebitdaByYear.year3)}</td>
                              <td className="p-3 text-right font-semibold">{formatCurrency(ebitdaByYear.year4)}</td>
                              <td className="p-3 text-right font-semibold">{formatCurrency(ebitdaByYear.year5)}</td>
                              <td className="p-3 text-right font-semibold bg-gray-300">{formatCurrency(ebitdaByYear.ttm)}</td>
                            </tr>
                            
                            {/* Owner Compensation Section */}
                            {(hasOwnerComp || hasMarketReplacement) && (
                              <>
                                <tr>
                                  <td colSpan="6" className="p-3 bg-white border-t-2 border-gray-300">
                                    <div className="font-semibold text-gray-700">Owner Compensation Adjustments</div>
                                    <div className="text-xs text-gray-500 mt-1">
                                      Normalizes owner pay to market rate. If owner was paid above market, EBITDA increases. 
                                      If below market, EBITDA decreases to reflect true operating costs.
                                    </div>
                                  </td>
                                </tr>
                                {generateRows(groupedOwnerComp, true)}
                                
                                {/* Net Owner Compensation */}
                                <tr className="bg-gray-100 border-t border-gray-300">
                                  <td className="p-2 pl-6 font-medium text-gray-600">Net Owner Compensation</td>
                                  <td className="p-2 text-xs text-gray-500">{ownerCompNetTotal.ttm >= 0 ? 'Adds to EBITDA (owner paid above market)' : 'Reduces EBITDA (owner paid below market)'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700">{ownerCompNetTotal.year3 >= 0 ? '' : '('}{formatCurrency(Math.abs(ownerCompNetTotal.year3))}{ownerCompNetTotal.year3 >= 0 ? '' : ')'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700">{ownerCompNetTotal.year4 >= 0 ? '' : '('}{formatCurrency(Math.abs(ownerCompNetTotal.year4))}{ownerCompNetTotal.year4 >= 0 ? '' : ')'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700">{ownerCompNetTotal.year5 >= 0 ? '' : '('}{formatCurrency(Math.abs(ownerCompNetTotal.year5))}{ownerCompNetTotal.year5 >= 0 ? '' : ')'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700 bg-gray-200">{ownerCompNetTotal.ttm >= 0 ? '' : '('}{formatCurrency(Math.abs(ownerCompNetTotal.ttm))}{ownerCompNetTotal.ttm >= 0 ? '' : ')'}</td>
                                </tr>
                              </>
                            )}
                            
                            {/* Other Adjustments Section */}
                            {hasOther && (
                              <>
                                <tr>
                                  <td colSpan="6" className="p-3 bg-white border-t-2 border-gray-300">
                                    <div className="font-semibold text-gray-700">Other Normalizing Adjustments</div>
                                    <div className="text-xs text-gray-500 mt-1">
                                      Non-recurring, discretionary, or non-operating items that won't continue under new ownership.
                                    </div>
                                  </td>
                                </tr>
                                {generateRows(groupedOther)}
                                
                                {/* Other Adjustments Subtotal */}
                                <tr className="bg-gray-100 border-t border-gray-300">
                                  <td colSpan="2" className="p-2 pl-6 font-medium text-gray-600">Subtotal Other Adjustments</td>
                                  <td className="p-2 text-right font-medium text-gray-700">{otherTotal.year3 >= 0 ? '' : '('}{formatCurrency(Math.abs(otherTotal.year3))}{otherTotal.year3 >= 0 ? '' : ')'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700">{otherTotal.year4 >= 0 ? '' : '('}{formatCurrency(Math.abs(otherTotal.year4))}{otherTotal.year4 >= 0 ? '' : ')'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700">{otherTotal.year5 >= 0 ? '' : '('}{formatCurrency(Math.abs(otherTotal.year5))}{otherTotal.year5 >= 0 ? '' : ')'}</td>
                                  <td className="p-2 text-right font-medium text-gray-700 bg-gray-200">{otherTotal.ttm >= 0 ? '' : '('}{formatCurrency(Math.abs(otherTotal.ttm))}{otherTotal.ttm >= 0 ? '' : ')'}</td>
                                </tr>
                              </>
                            )}
                            
                            {/* Total Normalizing Adjustments */}
                            <tr className="bg-gray-200 border-t-2 border-gray-400">
                              <td colSpan="2" className="p-3 font-semibold text-gray-700">Total Normalizing Adjustments</td>
                              <td className="p-3 text-right font-semibold text-gray-700">{totalNormalizingAdj.year3 >= 0 ? '' : '('}{formatCurrency(Math.abs(totalNormalizingAdj.year3))}{totalNormalizingAdj.year3 >= 0 ? '' : ')'}</td>
                              <td className="p-3 text-right font-semibold text-gray-700">{totalNormalizingAdj.year4 >= 0 ? '' : '('}{formatCurrency(Math.abs(totalNormalizingAdj.year4))}{totalNormalizingAdj.year4 >= 0 ? '' : ')'}</td>
                              <td className="p-3 text-right font-semibold text-gray-700">{totalNormalizingAdj.year5 >= 0 ? '' : '('}{formatCurrency(Math.abs(totalNormalizingAdj.year5))}{totalNormalizingAdj.year5 >= 0 ? '' : ')'}</td>
                              <td className="p-3 text-right font-semibold text-gray-700 bg-gray-300">{totalNormalizingAdj.ttm >= 0 ? '' : '('}{formatCurrency(Math.abs(totalNormalizingAdj.ttm))}{totalNormalizingAdj.ttm >= 0 ? '' : ')'}</td>
                            </tr>
                            
                            {/* Final Normalized EBITDA - the main accent */}
                            <tr className="bg-green-700 text-white">
                              <td colSpan="2" className="p-4 font-bold text-base">{adjustmentItems.some(a => a.included && (a.category === 'Maintenance CapEx' || a.plLine === 'CapEx') && (Number(a.amount) || 0) > 0)
                                ? <>Normalized EBITDA after capex <span className="font-normal text-green-100">(free cash flow)</span></>
                                : 'Normalized EBITDA'}</td>
                              <td className="p-4 text-right font-bold">{formatCurrency(calcNormEbitda.year3)}</td>
                              <td className="p-4 text-right font-bold">{formatCurrency(calcNormEbitda.year4)}</td>
                              <td className="p-4 text-right font-bold">{formatCurrency(calcNormEbitda.year5)}</td>
                              <td className="p-4 text-right font-bold text-base bg-green-800">{formatCurrency(calcNormEbitda.ttm)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })()}
                
                    {/* Documentation Note */}
                    <div className="bg-white border border-gray-200 rounded-lg p-3 mt-4 text-xs text-gray-500">
                      <strong className="text-green-700">Documentation Note:</strong> All adjustments are subject to buyer due diligence verification. 
                      We recommend maintaining supporting documentation (pay stubs, expense reports, invoices) for each adjustment.
                    </div>
                  </div>
                </div>

                {/* SECTION 3: Pro Forma Bridge (only shows when Pro Forma data exists) */}
                {proFormaCalcs.hasProFormaData && (
                  <div className="mb-8">
                    <div className="bg-gray-700 text-white px-4 py-3 rounded-t-lg font-semibold flex items-center justify-between">
                      <span>Pro Forma Adjustments</span>
                      {proFormaValuationBasis !== 'historical' && (
                        <span className="text-xs bg-green-600 px-2 py-1 rounded">
                          {proFormaValuationBasis === 'weighted' ? 'Weighted' : 'Pro Forma'} Basis Active
                        </span>
                      )}
                    </div>
                    <div className="border border-gray-300 border-t-0 rounded-b-lg p-5 bg-white">
                      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5 text-sm text-gray-600">
                        <strong className="text-gray-800">What is Pro Forma?</strong> Pro forma adjustments account for significant changes that occurred 
                        during or after the trailing twelve month period—such as acquisitions, major new clients, or lost customers. These adjustments 
                        show what the combined entity's earnings would look like on a full-year run-rate basis, giving buyers a more complete picture 
                        of the business's current earning power.
                      </div>
                      
                      {/* Pro Forma Bridge Table */}
                      <table className="w-full text-sm border-collapse mb-4">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="p-3 text-left font-medium border border-gray-200">Description</th>
                            <th className="p-3 text-center font-medium border border-gray-200">Type</th>
                            <th className="p-3 text-center font-medium border border-gray-200">Effective</th>
                            <th className="p-3 text-right font-medium border border-gray-200">Annual EBITDA</th>
                            <th className="p-3 text-right font-medium border border-gray-200">TTM Contribution</th>
                            <th className="p-3 text-center font-medium border border-gray-200">Val. Credit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Historical Base */}
                          <tr className="bg-gray-50">
                            <td className="p-3 border border-gray-200 font-semibold" colSpan="3">Historical Normalized EBITDA (TTM)</td>
                            <td className="p-3 border border-gray-200 text-right font-semibold" colSpan="2">{formatCurrency(proFormaCalcs.historicalTTMEbitda)}</td>
                            <td className="p-3 border border-gray-200 text-center">—</td>
                          </tr>
                          
                          {/* Pro Forma Items */}
                          {proFormaCalcs.items?.filter(i => i.name).map((item, idx) => (
                            <tr key={item.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                              <td className="p-3 border border-gray-200 pl-6">+ {item.name}</td>
                              <td className="p-3 border border-gray-200 text-center text-xs">
                                {item.type === 'acquisition' ? '🏢 Acquisition' : 
                                 item.type === 'newclient' ? '👤 New Client' :
                                 item.type === 'lostclient' ? '📉 Lost Client' :
                                 item.type === 'pricechange' ? '💰 Price Change' : '📋 Other'}
                              </td>
                              <td className="p-3 border border-gray-200 text-center text-xs">
                                {item.effectiveDate ? new Date(item.effectiveDate).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '—'}
                              </td>
                              <td className="p-3 border border-gray-200 text-right text-gray-600">{formatCurrency(item.annualEbitdaCalc || 0)}</td>
                              <td className="p-3 border border-gray-200 text-right text-green-700">+{formatCurrency(item.adjustedEbitda || 0)}</td>
                              <td className="p-3 border border-gray-200 text-center">
                                <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                                  item.valuationCredit === 100 ? 'bg-green-100 text-green-700' :
                                  item.valuationCredit >= 75 ? 'bg-blue-100 text-blue-700' :
                                  item.valuationCredit >= 50 ? 'bg-amber-100 text-amber-700' :
                                  'bg-red-100 text-red-700'
                                }`}>
                                  {item.valuationCredit}%
                                </span>
                              </td>
                            </tr>
                          ))}
                          
                          {/* Pro Forma Total */}
                          <tr className="bg-green-700 text-white font-bold">
                            <td className="p-3 border border-green-600" colSpan="3">Pro Forma Normalized EBITDA</td>
                            <td className="p-3 border border-green-600 text-right" colSpan="2">{formatCurrency(proFormaCalcs.proFormaTTMEbitda)}</td>
                            <td className="p-3 border border-green-600 text-center text-xs font-normal">
                              +{((proFormaCalcs.proFormaTTMEbitda / proFormaCalcs.historicalTTMEbitda - 1) * 100).toFixed(0)}%
                            </td>
                          </tr>
                          
                          {/* Weighted Total (if different) */}
                          {proFormaCalcs.weightedTTMEbitda !== proFormaCalcs.proFormaTTMEbitda && (
                            <tr className="bg-gray-100 text-gray-700 font-semibold">
                              <td className="p-3 border border-gray-200" colSpan="3">Weighted EBITDA (seasoning-adjusted)</td>
                              <td className="p-3 border border-gray-200 text-right" colSpan="2">{formatCurrency(proFormaCalcs.weightedTTMEbitda)}</td>
                              <td className="p-3 border border-gray-200 text-center text-xs font-normal">
                                +{((proFormaCalcs.weightedTTMEbitda / proFormaCalcs.historicalTTMEbitda - 1) * 100).toFixed(0)}%
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      
                      {/* Notes */}
                      <div className="text-xs text-gray-500">
                        <strong>Notes:</strong>
                        <ul className="mt-1 space-y-0.5 list-disc pl-4">
                          <li>TTM Contribution = prorated portion of annual EBITDA not yet in historical TTM, adjusted for retention</li>
                          <li>Valuation Credit = confidence weighting based on type and months seasoned (acquisitions: 100%, new clients: 15-100%)</li>
                          {proFormaItems.filter(i => i.notes).map((item, idx) => (
                            <li key={idx}>{item.name}: {item.notes}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {/* ========== FINAL: EBITDA USED FOR VALUATION ========== */}
                <div className="p-4 bg-gradient-to-r from-green-50 to-green-100 rounded-lg border-2 border-green-400">
                  <h3 className="font-bold text-green-900 mb-3">
                    EBITDA Used for Valuation
                  </h3>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm text-green-700 font-medium">Basis:</div>
                      <div className="text-lg font-bold text-green-900">
                        {proFormaCalcs.hasProFormaData && proFormaValuationBasis !== 'historical' 
                          ? `${selectedBasisCalcs.label} (includes Pro Forma)`
                          : valuationInputs.weightingMethod === 'ttm' ? 'Trailing Twelve Months (TTM)'
                          : valuationInputs.weightingMethod === 'lastYear' ? 'Last Fiscal Year'
                          : valuationInputs.weightingMethod === 'average' ? 'Simple Average'
                          : 'Weighted Average'}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">
                        {proFormaCalcs.hasProFormaData && proFormaValuationBasis !== 'historical'
                          ? proFormaValuationBasis === 'weighted'
                            ? 'Historical EBITDA plus seasoning-weighted pro forma adjustments'
                            : 'Historical EBITDA plus full pro forma adjustments'
                          : 'Using the most recent performance data for valuation'}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-sm text-green-700 font-medium">{(Number(calculations?.valuation?.maintCapex) || 0) > 0 ? 'Normalized EBITDA after capex, for valuation:' : 'Normalized EBITDA for Valuation:'}</div>
                      {(Number(calculations?.valuation?.maintCapex) || 0) > 0 && (
                        <div className="text-xs text-green-800">Normalized EBITDA before capex {formatCurrency(calculations?.valuation?.metricBeforeCapex || 0)} − maintenance capex {formatCurrency(calculations?.valuation?.maintCapex || 0)}</div>
                      )}
                      <div className="text-3xl font-bold text-green-900">
                        {formatCurrency(proFormaCalcs.hasProFormaData && proFormaValuationBasis !== 'historical' 
                          ? selectedBasisCalcs.ebitda 
                          : calculations?.valuation?.metric || 0)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {reviewSection === 'drivers' && (
              <div>
                {/* Vista Header - Condensed */}
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-300">
                  <img src={vistaLogoBase64} alt="Vista Business Group" className="h-10" onError={(e) => e.target.style.display = 'none'} />
                  <div>
                    <div className="text-base font-bold text-gray-800">Multiple Calculation Methodology</div>
                    <div className="text-xs text-gray-500">How we determined your valuation multiple</div>
                  </div>
                </div>
                
                {/* STEP 1: Company Size → Base Multiple - Visual Chart */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg flex justify-between items-center">
                    <span className="font-semibold">Step 1: Company Size → Base Multiple</span>
                    <span className="text-lg font-bold">{multipleEngineCalcs.rawBaseMultiple.toFixed(2)}x</span>
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="text-sm text-gray-600 mb-3">
                      Your EBITDA{multipleEngineCalcs.fcfMode && multipleEngineCalcs.maintCapexInValue > 0 ? ' (before capex)' : ''} of <strong className="text-gray-800">{formatCurrency(multipleEngineCalcs.tierEbitda ?? multipleEngineCalcs.adjustedEbitda)}</strong> determines your base multiple:
                    </div>
                    <div className="space-y-1">
                      {baseMultipleTable.map((row, idx) => {
                        const _tierE = multipleEngineCalcs.tierEbitda ?? multipleEngineCalcs.adjustedEbitda;
                        const isActive = _tierE >= row.ebitda && (idx === baseMultipleTable.length - 1 || _tierE < baseMultipleTable[idx + 1].ebitda);
                        const barWidth = (row.multiple / 7) * 100;
                        return (
                          <div key={idx} className={`flex items-center gap-2 py-1 px-2 rounded ${isActive ? 'bg-green-50 border border-green-200' : ''}`}>
                            <div className="w-20 text-right text-xs text-gray-500">{formatCurrency(row.ebitda)}+</div>
                            <div className="flex-1 relative h-4 bg-gray-100 rounded overflow-hidden">
                              <div className={`h-full rounded ${isActive ? 'bg-green-600' : 'bg-gray-300'}`} style={{ width: `${Math.min(barWidth, 100)}%` }} />
                            </div>
                            <div className={`w-10 text-right text-xs font-semibold ${isActive ? 'text-green-700' : 'text-gray-500'}`}>{row.multiple.toFixed(1)}x</div>
                            {isActive && <div className="text-green-600 text-xs font-semibold">◀</div>}
                          </div>
                        );
                      })}
                    </div>
                    <div className="mt-3 text-xs text-gray-500 italic">
                      Higher EBITDA = lower buyer risk = higher multiple
                    </div>
                  </div>
                </div>
                
                {/* STEP 2: Industry Adjustment */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg flex justify-between items-center">
                    <span className="font-semibold">Step 2: Industry Adjustment</span>
                    <span className="text-lg font-bold">
                      {industryMultipleAdjustment >= 0 ? '+' : ''}{industryMultipleAdjustment.toFixed(2)}x
                    </span>
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="flex justify-between items-center">
                      <div className="text-sm text-gray-600">
                        <span className="font-medium text-gray-800">{industryBenchmarks.find(i => i.id === selectedIndustry)?.name || 'Selected Industry'}</span>
                        <span className="mx-2">—</span>
                        <span>Industry-specific adjustment based on market demand and deal activity</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* STEP 3: Location & Market */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg flex justify-between items-center">
                    <span className="font-semibold">Step 3: Location & Market Conditions</span>
                    <span className="text-lg font-bold">
                      {((multipleEngineCalcs.scaledLocationAdj || 0) + (marketCondition?.adjustment || 0)) >= 0 ? '+' : ''}{((multipleEngineCalcs.scaledLocationAdj || 0) + (marketCondition?.adjustment || 0)).toFixed(2)}x
                    </span>
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="flex justify-between text-sm">
                      <div>
                        <span className="text-gray-500">Location:</span>
                        <span className="font-medium text-gray-800 ml-1">{dealProfile.locationType === 'major_metro' ? 'Major Metro' : dealProfile.locationType === 'small_city' ? 'Small City' : dealProfile.locationType === 'suburban' ? 'Suburban' : 'Rural'}</span>
                        <span className="text-gray-600 ml-1">({(multipleEngineCalcs.scaledLocationAdj || 0) >= 0 ? '+' : ''}{(multipleEngineCalcs.scaledLocationAdj || 0).toFixed(2)}x)</span>
                      </div>
                      <div>
                        <span className="text-gray-500">Market:</span>
                        <span className="font-medium text-gray-800 ml-1">{marketCondition?.name || 'Neutral'}</span>
                        <span className="text-gray-600 ml-1">({(marketCondition?.adjustment || 0) >= 0 ? '+' : ''}{(marketCondition?.adjustment || 0).toFixed(2)}x)</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Effective Base Multiple */}
                <div className="bg-gray-100 border border-gray-300 rounded-lg p-3 mb-5 flex justify-between items-center">
                  <div>
                    <span className="font-semibold text-gray-800">Effective Base Multiple:</span>
                    <span className="text-sm text-gray-600 ml-2">
                      {multipleEngineCalcs.rawBaseMultiple.toFixed(2)} + {industryMultipleAdjustment >= 0 ? '+' : ''}{industryMultipleAdjustment.toFixed(2)} + {(multipleEngineCalcs.scaledLocationAdj || 0) >= 0 ? '+' : ''}{(multipleEngineCalcs.scaledLocationAdj || 0).toFixed(2)} + {(marketCondition?.adjustment || 0) >= 0 ? '+' : ''}{(marketCondition?.adjustment || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="text-2xl font-bold text-gray-800">{multipleEngineCalcs.baseMultiple.toFixed(2)}x</div>
                </div>
                
                {/* STEP 4: Business Factor Adjustments */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg flex justify-between items-center">
                    <span className="font-semibold">Step 4: Business Factor Adjustments</span>
                    <span className="text-lg font-bold">
                      {multipleEngineCalcs.totalAdjustment >= 0 ? '+' : ''}{multipleEngineCalcs.totalAdjustment.toFixed(2)}x
                    </span>
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-1.5 px-2 font-semibold text-gray-700">Factor</th>
                          <th className="text-left py-1.5 px-2 font-semibold text-gray-700">Status</th>
                          <th className="text-right py-1.5 px-2 font-semibold text-gray-700">Adj</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {Object.entries(multipleEngineCalcs.factors || {}).map(([key, factor]) => {
                          const baseStatus = factor.calculation || (factor.subFactors ? Object.values(factor.subFactors).map(sf => sf.calculation).join(', ') : 'See details');
                          // Provenance note: surface to owner that estimated inputs cap the precision of this adjustment
                          let provenanceNote = null;
                          const dp = factor.dataProvenance;
                          if (dp?.revenueCategoriesEstimated && dp.swing) {
                            const lo = `${dp.swing.min >= 0 ? '+' : ''}${dp.swing.min.toFixed(2)}x`;
                            const hi = `${dp.swing.max >= 0 ? '+' : ''}${dp.swing.max.toFixed(2)}x`;
                            provenanceNote = `Revenue categories estimated (Export Class. Form not provided) — verified data could move this between ${lo} and ${hi}`;
                          } else if (dp && dp.contractDataProvided === false && dp.swing) {
                            const lo = `${dp.swing.min >= 0 ? '+' : ''}${dp.swing.min.toFixed(2)}x`;
                            const hi = `${dp.swing.max >= 0 ? '+' : ''}${dp.swing.max.toFixed(2)}x`;
                            provenanceNote = `Owner did not return the Client Detail Form — verified contract data could move this between ${lo} and ${hi}`;
                          }
                          return (
                            <tr key={key}>
                              <td className="py-1.5 px-2 font-medium text-gray-800 text-xs">{factor.name}</td>
                              <td className="py-1.5 px-2 text-gray-600 text-xs">
                                {baseStatus}
                                {provenanceNote && (
                                  <div className="text-amber-700 italic mt-0.5">⚠ {provenanceNote}</div>
                                )}
                              </td>
                              <td className={`py-1.5 px-2 text-right font-semibold text-xs ${factor.adjustment > 0 ? 'text-green-700' : factor.adjustment < 0 ? 'text-gray-600' : 'text-gray-400'}`}>
                                {factor.adjustment > 0 ? '+' : ''}{factor.adjustment.toFixed(2)}x
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="bg-gray-50 border-t border-gray-300">
                          <td className="py-2 px-2 font-semibold text-gray-800" colSpan="2">Total Factor Adjustments</td>
                          <td className={`py-2 px-2 text-right font-bold ${multipleEngineCalcs.totalAdjustment >= 0 ? 'text-gray-800' : 'text-gray-600'}`}>
                            {multipleEngineCalcs.totalAdjustment >= 0 ? '+' : ''}{multipleEngineCalcs.totalAdjustment.toFixed(2)}x
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                
                {/* Final Multiple Calculation */}
                <div className="border-2 border-gray-300 rounded-lg overflow-hidden">
                  <div className="bg-gray-700 text-white px-4 py-2 flex justify-between items-center">
                    <span className="font-semibold">Final Valuation Multiple</span>
                    <span className="text-sm">
                      Base ({multipleEngineCalcs.baseMultiple.toFixed(2)}x) + Factors ({multipleEngineCalcs.totalAdjustment >= 0 ? '+' : ''}{multipleEngineCalcs.totalAdjustment.toFixed(2)}x)
                    </span>
                  </div>
                  <div className="bg-green-700 text-white p-4">
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="text-2xl font-bold">{multipleEngineCalcs.adjustedMultiple.toFixed(2)}x</div>
                        <div className="text-xs text-green-200">Calculated Multiple{multipleEngineCalcs.floorApplied ? ' (before floor)' : ''}</div>
                      </div>
                      <div className="text-right">
                        <div className="text-sm text-green-100">Valuation Range{multipleEngineCalcs.floorApplied ? ' (floor applied)' : ''}</div>
                        <div className="text-lg font-semibold">{multipleEngineCalcs.typicalMultiple.toFixed(2)}x – {multipleEngineCalcs.marketHighMultiple.toFixed(2)}x</div>
                        <div className="text-xs text-green-200">{multipleEngineCalcs.floorApplied ? `Floor ${multipleEngineCalcs.floorMult.toFixed(1)}x — minimum for ${formatCurrency(multipleEngineCalcs.adjustedEbitda)} EBITDA` : 'Typical (85%) to Market High (100%)'}</div>
                      </div>
                    </div>
                    {multipleEngineCalcs.floorApplied && (
                      <div className="mt-2 pt-2 border-t border-green-600 text-xs text-green-200">
                        The quality factors score below what the base multiple supports, but a business generating {formatCurrency(multipleEngineCalcs.adjustedEbitda)} in annual EBITDA will always attract buyers. The {multipleEngineCalcs.floorMult.toFixed(1)}x floor reflects the minimum market reality. Improving the quality factors above will push the multiple above this floor.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            
            {reviewSection === 'result' && (
              <div>
                {/* Vista Header */}
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-300">
                  <img src={vistaLogoBase64} alt="Vista Business Group" className="h-10" onError={(e) => e.target.style.display = 'none'} />
                  <div>
                    <div className="text-base font-bold text-gray-800">Valuation Summary</div>
                    <div className="text-xs text-gray-500">Business value analysis and deal structure</div>
                  </div>
                </div>
                
                {/* 📊 THEN vs NOW (Mark 10-05): the prior EBITDA we gave the owner next to today's — reviewed together
                    in the presentation; staff open "what moved" for the line-by-line bridge. */}
                <PriorVsNowPanel snapshots={[...(ebitdaSnapshots || []), ...(priorRevisionSnaps || [])]} current={currentSnapshot}
                  fmt={formatCurrency} ownerView />

                {/* Key Metrics Section */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    Key Business Metrics
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    {(() => {
                      // Same wording as the owner's report — keyMetricSpecs (Mark 10-07).
                      const TONE_CLASS = { good: 'text-green-700', warn: 'text-yellow-600', bad: 'text-red-600', neutral: 'text-gray-800', na: 'text-gray-400' };
                      const toTile = (t) => ({
                        label: t.label, value: t.value, valueClass: TONE_CLASS[t.tone] || 'text-gray-800',
                        tone: t.highlight === 'red' ? 'bg-red-50 border border-red-200' : t.highlight === 'green' ? 'bg-green-50 border border-green-200' : 'bg-gray-50',
                        short: t.short, period: t.period, source: t.source,
                        sub: (t.lines || []).length ? <>{t.lines.map((l, i2) => <div key={i2} className={`text-xs ${l.kind === 'warn' ? 'text-amber-600' : 'text-gray-500'}`}>{l.text}</div>)}</> : null,
                        explain: { what: t.what, here: t.here, good: t.good },
                      });
                      const specs = keyMetricSpecs().map(toTile);
                      const tiles1 = specs.slice(0, 6), tiles2 = specs.slice(6, 12);
                      const row = (tiles) => tiles.map((t, k) => <MetricTile key={t.label} {...t} align={k === 0 ? 'left' : k === tiles.length - 1 ? 'right' : 'center'} />);
                      return (
                        <>
                          <div className="grid grid-cols-6 gap-3 mb-3">{row(tiles1)}</div>
                          <div className="grid grid-cols-6 gap-3">{row(tiles2)}</div>
                        </>
                      );
                    })()}
                  </div>
                </div>

                {/* Staff-only notices (reconcile books vs owner answers; lost revenue still in TTM) live on Open Items — never on the owner presentation (Mark 10-06). */}

                {/* Listing Timing Considerations - Only show if there's risk */}
                {rollOffAnalysis.hasData && (rollOffAnalysis.nearTermAtRisk.length > 0 || (rollOffAnalysis.projections?.[3]?.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9)) && (
                  <div className="mb-5">
                    <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                      Listing Timing Considerations
                    </div>
                    <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                      <div className="text-sm text-gray-600 mb-4 p-3 bg-gray-50 rounded border-l-3 border-green-700" style={{borderLeftWidth: '3px', borderLeftColor: '#3d5c35'}}>
                        Based on monthly EBITDA trends, there are timing considerations that may impact your valuation. High-performing months that "roll off" the TTM can reduce EBITDA and consequently lower the business valuation.
                      </div>
                      <div className="grid grid-cols-2 gap-6">
                        {/* Left: Monthly EBITDA Chart */}
                        <div>
                          <div className="text-xs font-semibold text-gray-700 mb-2">Monthly EBITDA Trend (TTM)</div>
                          <div className="flex items-end gap-0.5 h-24 bg-gray-50 p-3 rounded border border-gray-200">
                            {rollOffAnalysis.atRiskMonths?.slice(0, 12).map((m, idx) => {
                              const maxVal = Math.max(...rollOffAnalysis.monthlyEbitda.map(Math.abs));
                              const height = maxVal > 0 ? Math.abs(m.ebitda) / maxVal * 100 : 0;
                              return (
                                <div key={idx} className="flex-1 flex flex-col items-center justify-end h-full">
                                  <div 
                                    className={`w-full rounded-t ${m.isHighRisk ? 'bg-gray-700' : m.isLowRisk ? 'bg-gray-300' : 'bg-green-700'}`}
                                    style={{ height: `${height}%`, minHeight: m.ebitda !== 0 ? '2px' : '0' }}
                                    title={`${m.monthLabel}: ${formatCurrency(m.ebitda)}`}
                                  />
                                </div>
                              );
                            })}
                          </div>
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>← Rolling off first</span>
                            <span>Most recent →</span>
                          </div>
                          <div className="flex items-center gap-4 mt-2 text-xs text-gray-600">
                            <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 bg-gray-700 rounded-sm"></span> Above average</span>
                            <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 bg-green-700 rounded-sm"></span> Normal</span>
                            <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 bg-gray-300 rounded-sm"></span> Below average</span>
                          </div>
                        </div>
                        
                        {/* Right: Impact Analysis */}
                        <div>
                          <div className="text-xs font-semibold text-gray-700 mb-2">Impact Analysis</div>
                          <div className="space-y-3">
                            {rollOffAnalysis.nearTermAtRisk.length > 0 && (
                              <div className="p-3 bg-gray-50 rounded border border-gray-200">
                                <div className="text-sm font-semibold text-gray-700 mb-1">
                                  {rollOffAnalysis.nearTermAtRisk.length} High-Performing Month{rollOffAnalysis.nearTermAtRisk.length > 1 ? 's' : ''} Rolling Off
                                </div>
                                <div className="text-xs text-gray-600 leading-relaxed">
                                  {rollOffAnalysis.nearTermAtRisk.map(m => m.monthLabel).join(', ')} will roll off within the next 4 months.
                                </div>
                                <div className="text-xs text-gray-700 font-medium mt-2 pt-2 border-t border-gray-200">
                                  EBITDA at risk: <span className="text-green-800 font-bold">{formatCurrency(rollOffAnalysis.totalAtRiskEbitda)}</span> • Valuation impact: <span className="text-green-800 font-bold">{formatCurrency(rollOffAnalysis.totalAtRiskValuation)}</span>
                                </div>
                              </div>
                            )}
                            
                            {rollOffAnalysis.projections?.[3]?.newTtm < rollOffAnalysis.currentTtmEbitda * 0.9 && (
                              <div className="p-3 bg-gray-50 rounded border border-gray-200">
                                <div className="text-sm font-semibold text-gray-700 mb-1">Projected TTM Decline</div>
                                <div className="text-xs text-gray-600 leading-relaxed">
                                  If upcoming months match historical average, TTM EBITDA may decline from <strong>{formatCurrency(rollOffAnalysis.currentTtmEbitda)}</strong> to <strong>{formatCurrency(rollOffAnalysis.projections[3].newTtm)}</strong>
                                  <span className="text-red-600 font-semibold ml-1">({((rollOffAnalysis.currentTtmEbitda - rollOffAnalysis.projections[3].newTtm) / rollOffAnalysis.currentTtmEbitda * 100).toFixed(0)}% decline)</span>
                                </div>
                              </div>
                            )}
                            
                            <div className="p-3 rounded border" style={{backgroundColor: '#e8ede6', borderColor: '#d1d9cf'}}>
                              <div className="text-xs leading-relaxed" style={{color: '#3d5c35'}}>
                                <span className="font-semibold">Recommendation:</span> Consider listing timing carefully. If upcoming months are expected to be average or below, accelerating the listing timeline may help capture a higher valuation.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Valuation & Accuracy Section */}
                <div className="grid grid-cols-2 gap-4 mb-5">
                  {/* Valuation Summary */}
                  <div>
                    <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                      Valuation Summary
                    </div>
                    <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                      <div className="space-y-3 mb-4">
                        {multipleEngineCalcs.maintCapexInValue > 0 ? (
                          <>
                            {/* 💵 The bridge (Mark/Zac 10-20): buyers read both EBITDA and free cash flow */}
                            <div className="flex justify-between items-center">
                              <span className="text-gray-600 text-sm">Normalized EBITDA before capex</span>
                              <span className="text-base font-semibold text-gray-800">{formatCurrency(multipleEngineCalcs.ebitdaBeforeCapex)}</span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className="text-gray-600 text-sm">− Normal maintenance capex</span>
                              <span className="text-base font-semibold text-gray-800">{formatCurrency(multipleEngineCalcs.maintCapexInValue)}</span>
                            </div>
                            <div className="flex justify-between items-center border-t pt-2">
                              <span className="text-gray-800 text-sm font-semibold">= Normalized EBITDA after capex (free cash flow, valued)</span>
                              <span className="text-lg font-bold text-gray-800">{formatCurrency(multipleEngineCalcs.adjustedEbitda)}</span>
                            </div>
                          </>
                        ) : (
                        <div className="flex justify-between items-center">
                          <span className="text-gray-600 text-sm">Normalized EBITDA</span>
                          <span className="text-lg font-bold text-gray-800">{formatCurrency(multipleEngineCalcs.adjustedEbitda)}</span>
                        </div>
                        )}
                        <div className="flex justify-between items-center">
                          <span className="text-gray-600 text-sm">Multiple Range</span>
                          <span className="text-lg font-bold text-gray-800">{multipleEngineCalcs.typicalMultiple.toFixed(2)}x – {multipleEngineCalcs.marketHighMultiple.toFixed(2)}x</span>
                        </div>
                      </div>
                      
                      <div className="bg-green-700 text-white rounded-lg p-4 mb-4">
                        <div className="text-center">
                          <div className="text-xs text-green-200 mb-1">Estimated Business Value</div>
                          <div className="text-2xl font-bold">
                            {formatCurrency(multipleEngineCalcs.valuationTypical)} – {formatCurrency(multipleEngineCalcs.valuationMarketHigh)}
                          </div>
                          {multipleEngineCalcs.catchUpCapex > 0 && (
                            <div className="text-xs text-green-200 mt-1">after one-time catch-up equipment spending of {formatCurrency(multipleEngineCalcs.catchUpCapex)}{capexCatchUp.note ? ` (${capexCatchUp.note})` : ''}</div>
                          )}
                        </div>
                      </div>
                      
                      <div className="text-xs text-gray-600 mb-3 leading-relaxed">
                        The majority of offers you receive should fall within this range. Each offer will have a different structure—
                        some may be all-cash (typically lower) while others include seller financing or earnouts (often higher total value). 
                        When evaluating offers, consider both the total amount and the deal structure.
                      </div>
                      
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-600">Range High</span>
                          <span className="font-semibold text-gray-800">{formatCurrency(multipleEngineCalcs.valuationMarketHigh)}</span>
                        </div>
                        <div className="text-xs text-gray-500 pl-2">Competitive process with strategic buyers</div>
                        <div className="flex justify-between items-center">
                          <span className="text-gray-600">Range Low</span>
                          <span className="font-semibold text-gray-700">{formatCurrency(multipleEngineCalcs.valuationTypical)}</span>
                        </div>
                        <div className="text-xs text-gray-500 pl-2">Conservative estimate; most offers above this</div>
                      </div>
                    </div>
                  </div>

                  {/* Accuracy Gauge */}
                  <div>
                    <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                      Valuation Confidence
                    </div>
                    <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                      <div className="relative h-3 bg-gray-200 rounded-full mb-2 overflow-hidden">
                        <div 
                          className="absolute left-0 top-0 h-full rounded-full bg-green-600"
                          style={{ width: `${accuracyGauge.overallScore}%` }}
                        />
                      </div>
                      <div className="flex justify-between text-xs text-gray-400 mb-4">
                        <span>0%</span><span>50%</span><span>100%</span>
                      </div>
                      
                      <div className="text-center mb-4">
                        <div className="text-4xl font-bold text-gray-800">
                          {accuracyGauge.overallScore.toFixed(0)}%
                        </div>
                        <div className="text-sm font-medium text-gray-600">
                          {accuracyGauge.tier}
                        </div>
                      </div>
                      
                      {accuracyGauge.missingItems.length > 0 && (
                        <div className="bg-gray-50 rounded p-3 border border-gray-200">
                          <div className="text-xs font-semibold text-gray-600 mb-2">To improve accuracy:</div>
                          <ul className="text-xs text-gray-600 space-y-1">
                            {accuracyGauge.missingItems.slice(0, 4).map((item, idx) => (
                              <li key={idx} className="flex items-start gap-2"><span className="text-gray-400">•</span><span>{item}</span></li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Deal Structure */}
                {(() => {
                  // Risk premium multipliers (per 10% shift from base)
                  // Seller Note: 2.5% premium (lowest risk - deferred payment with interest)
                  // Equity: 6% premium (medium risk - tied to buyer success, has upside)
                  // Earnout: 10% premium (highest risk - tied to targets, buyer can manipulate)
                  const SELLER_NOTE_PREMIUM = 0.025;  // 2.5% per 10%
                  const EQUITY_PREMIUM = 0.06;        // 6% per 10%
                  const EARNOUT_PREMIUM = 0.10;       // 10% per 10%
                  
                  // Base structure: 90% cash / 10% seller note
                  const BASE_SELLER_NOTE = 10;
                  
                  // Calculate cash (100% minus other components)
                  const cashPct = Math.max(0, 100 - dealStructure.sellerNote - dealStructure.earnout - dealStructure.equity);
                  
                  // Calculate risk premium from deviations from base
                  const sellerNoteDeviation = dealStructure.sellerNote - BASE_SELLER_NOTE;
                  const earnoutDeviation = dealStructure.earnout;
                  const equityDeviation = dealStructure.equity;
                  
                  // Premium = (deviation / 10) * rate
                  const noteRiskPremium = (sellerNoteDeviation / 10) * SELLER_NOTE_PREMIUM;
                  const earnoutRiskPremium = (earnoutDeviation / 10) * EARNOUT_PREMIUM;
                  const equityRiskPremium = (equityDeviation / 10) * EQUITY_PREMIUM;
                  
                  const totalRiskPremium = noteRiskPremium + earnoutRiskPremium + equityRiskPremium;
                  const riskMultiplier = 1 + totalRiskPremium;
                  
                  // Calculate values
                  const baseValue = multipleEngineCalcs.valuationMarketHigh;  // Use market high as base (90/10)
                  const adjustedValue = baseValue * riskMultiplier;
                  
                  // Dollar amounts
                  const cashAmount = adjustedValue * (cashPct / 100);
                  const noteAmount = adjustedValue * (dealStructure.sellerNote / 100);
                  const earnoutAmount = adjustedValue * (dealStructure.earnout / 100);
                  const equityAmount = adjustedValue * (dealStructure.equity / 100);
                  
                  // Reset to base function
                  const resetToBase = () => setDealStructure({ sellerNote: 10, earnout: 0, equity: 0 });
                  
                  // Slider change handler with validation
                  const handleSliderChange = (field, value) => {
                    const newValue = Math.max(0, Math.min(100, value));
                    const newStructure = { ...dealStructure, [field]: newValue };
                    
                    // Ensure total doesn't exceed 100%
                    const total = newStructure.sellerNote + newStructure.earnout + newStructure.equity;
                    if (total <= 100) {
                      setDealStructure(newStructure);
                    }
                  };
                  
                  return (
                    <div className="mb-5">
                      <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg flex justify-between items-center">
                        <span className="font-semibold">Deal Structure Simulator</span>
                        <button onClick={resetToBase} className="text-xs px-2 py-1 bg-gray-600 hover:bg-gray-500 rounded">Reset to 90/10</button>
                      </div>
                      <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                        <p className="text-sm text-gray-600 mb-4">
                          Across our closed transactions, the average deal structure is approximately 90% cash with 10% seller financing. 
                          Your actual offers will vary—use this simulator to see how different structures affect total value.
                        </p>
                      
                        {/* Value Comparison */}
                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div className="p-3 rounded-lg border border-gray-200 bg-gray-50">
                            <div className="text-xs text-gray-500 mb-1">Base Value (90% Cash / 10% Note)</div>
                            <div className="text-xl font-bold text-gray-700">{formatCurrency(baseValue)}</div>
                          </div>
                          <div className={`p-3 rounded-lg border-2 ${totalRiskPremium > 0 ? 'bg-green-50 border-green-300' : totalRiskPremium < 0 ? 'bg-gray-100 border-gray-300' : 'bg-white border-gray-200'}`}>
                            <div className="text-xs text-gray-500 mb-1">Risk-Adjusted Value</div>
                            <div className={`text-xl font-bold ${totalRiskPremium > 0 ? 'text-green-700' : 'text-gray-700'}`}>
                              {formatCurrency(adjustedValue)}
                              {totalRiskPremium !== 0 && (
                                <span className="text-sm ml-2">({totalRiskPremium > 0 ? '+' : ''}{(totalRiskPremium * 100).toFixed(1)}%)</span>
                              )}
                            </div>
                          </div>
                        </div>
                      
                        {/* Stacked Bar Visualization */}
                        <div className="mb-4">
                          <div className="text-xs text-gray-600 mb-1">Deal Composition</div>
                          <div className="h-8 rounded-lg overflow-hidden flex border border-gray-300">
                            {cashPct > 0 && (
                              <div className="bg-gray-700 flex items-center justify-center text-white text-xs font-bold" style={{ width: `${cashPct}%` }}>
                                {cashPct >= 15 && `${cashPct}%`}
                              </div>
                            )}
                            {dealStructure.sellerNote > 0 && (
                              <div className="bg-gray-500 flex items-center justify-center text-white text-xs font-bold" style={{ width: `${dealStructure.sellerNote}%` }}>
                                {dealStructure.sellerNote >= 10 && `${dealStructure.sellerNote}%`}
                              </div>
                            )}
                            {dealStructure.earnout > 0 && (
                              <div className="bg-gray-400 flex items-center justify-center text-white text-xs font-bold" style={{ width: `${dealStructure.earnout}%` }}>
                                {dealStructure.earnout >= 10 && `${dealStructure.earnout}%`}
                              </div>
                            )}
                            {dealStructure.equity > 0 && (
                              <div className="bg-gray-300 flex items-center justify-center text-gray-700 text-xs font-bold" style={{ width: `${dealStructure.equity}%` }}>
                                {dealStructure.equity >= 10 && `${dealStructure.equity}%`}
                              </div>
                            )}
                          </div>
                          <div className="flex justify-between text-xs mt-1 text-gray-600">
                            <span>Cash {cashPct}%</span>
                            <span>Note {dealStructure.sellerNote}%</span>
                            <span>Earnout {dealStructure.earnout}%</span>
                            <span>Equity {dealStructure.equity}%</span>
                          </div>
                        </div>
                      
                      {/* Sliders */}
                      <div className="space-y-3 mb-4">
                        {/* Seller Note Slider */}
                        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-2">
                            <div>
                              <span className="font-semibold text-gray-800">Seller Note</span>
                              <span className="text-xs text-gray-500 ml-2">(+2.5% per 10% above base)</span>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-700">{dealStructure.sellerNote}%</span>
                              <span className="text-sm text-gray-600 ml-2">{formatCurrency(noteAmount)}</span>
                            </div>
                          </div>
                          <input
                            type="range"
                            min="0"
                            max="50"
                            step="5"
                            value={dealStructure.sellerNote}
                            onChange={e => handleSliderChange('sellerNote', parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>0%</span>
                            <span className="text-gray-600">Base: 10%</span>
                            <span>50%</span>
                          </div>
                        </div>
                        
                        {/* Earnout Slider */}
                        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-2">
                            <div>
                              <span className="font-semibold text-gray-800">Earnout</span>
                              <span className="text-xs text-gray-500 ml-2">(+10% per 10% - highest risk)</span>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-700">{dealStructure.earnout}%</span>
                              <span className="text-sm text-gray-600 ml-2">{formatCurrency(earnoutAmount)}</span>
                            </div>
                          </div>
                          <input
                            type="range"
                            min="0"
                            max="40"
                            step="5"
                            value={dealStructure.earnout}
                            onChange={e => handleSliderChange('earnout', parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>0%</span>
                            <span>20%</span>
                            <span>40%</span>
                          </div>
                        </div>
                        
                        {/* Equity Slider */}
                        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-2">
                            <div>
                              <span className="font-semibold text-gray-800">Equity Rollover</span>
                              <span className="text-xs text-gray-500 ml-2">(+6% per 10% - medium risk)</span>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-700">{dealStructure.equity}%</span>
                              <span className="text-sm text-gray-600 ml-2">{formatCurrency(equityAmount)}</span>
                            </div>
                          </div>
                          <input
                            type="range"
                            min="0"
                            max="40"
                            step="5"
                            value={dealStructure.equity}
                            onChange={e => handleSliderChange('equity', parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>0%</span>
                            <span>20%</span>
                            <span>40%</span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Cash at Close (calculated) */}
                      <div className="bg-green-700 text-white rounded-lg p-3">
                        <div className="flex justify-between items-center">
                          <div>
                            <span className="font-bold">Cash at Close</span>
                            <span className="text-xs text-green-200 ml-2">(guaranteed proceeds)</span>
                          </div>
                          <div className="text-right">
                            <span className="text-2xl font-bold">{cashPct}%</span>
                            <span className="text-lg ml-2">{formatCurrency(cashAmount)}</span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Risk Premium Breakdown */}
                      <div className="mt-4 bg-gray-50 rounded-lg p-3 text-sm border border-gray-200">
                        <div className="font-semibold text-gray-700 mb-2">Risk Premium Breakdown:</div>
                        <div className="grid grid-cols-3 gap-2 text-xs">
                          <div className={noteRiskPremium !== 0 ? 'font-medium text-gray-700' : 'text-gray-400'}>
                            Note: {noteRiskPremium >= 0 ? '+' : ''}{(noteRiskPremium * 100).toFixed(1)}%
                          </div>
                          <div className={earnoutRiskPremium !== 0 ? 'font-medium text-gray-700' : 'text-gray-400'}>
                            Earnout: {earnoutRiskPremium >= 0 ? '+' : ''}{(earnoutRiskPremium * 100).toFixed(1)}%
                          </div>
                          <div className={equityRiskPremium !== 0 ? 'font-medium text-gray-700' : 'text-gray-400'}>
                            Equity: {equityRiskPremium >= 0 ? '+' : ''}{(equityRiskPremium * 100).toFixed(1)}%
                          </div>
                        </div>
                        <div className="mt-2 pt-2 border-t border-gray-300 text-gray-600">
                          <strong>Key insight:</strong> A {formatCurrency(adjustedValue)} offer with {100 - cashPct}% at risk 
                          is equivalent to a {formatCurrency(baseValue)} all-cash offer.
                        </div>
                      </div>
                      </div>
                    </div>
                  );
                })()}
                
                {/* Fee Calculator Section */}
                {(() => {
                  const ebitda = multipleEngineCalcs.adjustedEbitda;
                  const highValue = multipleEngineCalcs.valuationMarketHigh;
                  
                  // Retainer: 1% of EBITDA, min $5k, max $20k
                  const retainerRaw = ebitda * 0.01;
                  const retainer = Math.min(20000, Math.max(5000, retainerRaw));
                  
                  // Commission: Tiered schedule on high value
                  // 8% to $1M, 5% $1-2M, 4% $2-3M, 3% $3-4M, 2% over $4M
                  let commission = 0;
                  let remaining = highValue;
                  const tiers = [
                    { limit: 1000000, rate: 0.08 },
                    { limit: 1000000, rate: 0.05 },
                    { limit: 1000000, rate: 0.04 },
                    { limit: 1000000, rate: 0.03 },
                    { limit: Infinity, rate: 0.02 }
                  ];
                  
                  for (const tier of tiers) {
                    if (remaining <= 0) break;
                    const tierAmount = Math.min(remaining, tier.limit);
                    commission += tierAmount * tier.rate;
                    remaining -= tierAmount;
                  }
                  commission = Math.max(40000, commission); // Minimum commission $40,000
                  const minimumApplied = commission === 40000 && highValue > 0;
                  
                  // Retainer is netted from commission - total fee IS the commission
                  const totalFee = commission;
                  const balanceAtClose = commission - retainer;
                  const effectiveRate = highValue > 0 ? (totalFee / highValue) * 100 : 0;
                  
                  return (
                    <div className="mb-5">
                      <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                        Fee Calculator
                      </div>
                      <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <table className="w-full text-sm">
                              <tbody>
                                <tr className="border-b border-gray-200">
                                  <td className="py-2 text-gray-600">Deal Value (High)</td>
                                  <td className="py-2 text-right font-bold text-gray-800">{formatCurrency(highValue)}</td>
                                </tr>
                                <tr className="border-b border-gray-200 bg-gray-50">
                                  <td className="py-2 text-gray-600">Retainer (upfront)</td>
                                  <td className="py-2 text-right font-medium">{formatCurrency(retainer)}</td>
                                </tr>
                                <tr className="border-b border-gray-200">
                                  <td className="py-2 text-gray-600">Balance at Close</td>
                                  <td className="py-2 text-right font-medium">{formatCurrency(balanceAtClose)}</td>
                                </tr>
                                <tr className="font-bold">
                                  <td className="py-2">Total Fee {minimumApplied && <span className="text-xs font-normal text-amber-600">(minimum applied)</span>}</td>
                                  <td className="py-2 text-right text-gray-800">{formatCurrency(totalFee)}</td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="mt-3 bg-green-700 text-white rounded-lg p-3 text-center">
                              <div className="text-xs text-green-200">Effective Commission Rate</div>
                              <div className="text-2xl font-bold">{effectiveRate.toFixed(2)}%</div>
                            </div>
                          </div>
                          <div className="text-xs text-gray-600 bg-gray-50 p-3 rounded border border-gray-200">
                            <div className="font-semibold mb-2 text-gray-700">Commission Schedule:</div>
                            <div>8% on first $1M</div>
                            <div>5% on $1M – $2M</div>
                            <div>4% on $2M – $3M</div>
                            <div>3% on $3M – $4M</div>
                            <div>2% over $4M</div>
                            <div className="mt-2 pt-2 border-t border-gray-300 font-semibold text-gray-700">Minimum Commission: $40,000</div>
                            <div className="mt-2 pt-2 border-t border-gray-300">
                              <div className="font-semibold text-gray-700">Retainer: 1% EBITDA</div>
                              <div className="text-gray-500">(Min $5k / Max $20k)</div>
                              <div className="text-gray-500 italic">Credited against commission</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
            
            {reviewSection === 'process' && (
              <div>
                {/* Vista Header */}
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-300">
                  <img src={vistaLogoBase64} alt="Vista Business Group" className="h-10" onError={(e) => e.target.style.display = 'none'} />
                  <div>
                    <div className="text-base font-bold text-gray-800">The Vista Process</div>
                    <div className="text-xs text-gray-500">Our structured approach to maximizing your exit value</div>
                  </div>
                </div>
                
                {/* Two-Round Auction Process */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    Two-Round Confidential Auction
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <p className="text-sm text-gray-600 mb-4">
                      We run a structured two-round auction designed to create competitive tension among qualified buyers while protecting your confidentiality.
                    </p>
                    
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      {/* Round 1 */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="font-bold text-gray-800 mb-2">Round 1: Initial Offers</div>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>Confidential Information Memorandum (CIM) distributed to pre-qualified buyers</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>Buyers submit initial Indications of Interest (IOI) by a set deadline at the end of marketing</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>We review every IOI with you — price, terms, and fit</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>5–10 top candidates advance to Round 2</span>
                          </li>
                        </ul>
                      </div>
                      
                      {/* Round 2 */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="font-bold text-gray-800 mb-2">Round 2: Final Bids</div>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>Management presentations with serious buyers</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>Site visits and detailed Q&A sessions</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>Final binding offers (LOI) due 14 days after the IOI deadline</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-green-600 mt-0.5">✓</span>
                            <span>Select winning bidder for exclusivity</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-green-800">
                      <strong>Why Two Rounds?</strong> Competition drives value. Round 1 establishes market interest and baseline pricing. Round 2 creates urgency and allows buyers to put their best foot forward knowing they're competing.
                    </div>
                  </div>
                </div>
                
                {/* Timeline */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    Typical Transaction Timeline
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="relative">
                      {/* Timeline bar */}
                      <div className="absolute top-4 left-0 right-0 h-1 bg-gray-200 rounded"></div>
                      <div className="absolute top-4 left-0 h-1 bg-green-600 rounded" style={{ width: '100%' }}></div>
                      
                      {/* Timeline points — keep in step with the owner portal's
                          "How selling a business works" guide (Mark 2026-07-23:
                          the two must match exactly): 1-wk prep · 30-45d
                          marketing · IOI review + mgmt meetings · LOIs due
                          IOI+14d · LOI→close minimum 90 days · ~6 months. */}
                      <div className="flex justify-between relative">
                        <div className="text-center" style={{ width: '16%' }}>
                          <div className="w-3 h-3 bg-green-600 rounded-full mx-auto mb-2 relative z-10"></div>
                          <div className="text-xs font-bold text-gray-700">Week 1</div>
                          <div className="text-xs text-gray-500 mt-1">Preparation</div>
                          <div className="text-xs text-gray-400">CIM, buyer list</div>
                        </div>
                        <div className="text-center" style={{ width: '16%' }}>
                          <div className="w-3 h-3 bg-green-600 rounded-full mx-auto mb-2 relative z-10"></div>
                          <div className="text-xs font-bold text-gray-700">Weeks 2-7</div>
                          <div className="text-xs text-gray-500 mt-1">Marketing</div>
                          <div className="text-xs text-gray-400">30-45 days, IOIs due</div>
                        </div>
                        <div className="text-center" style={{ width: '16%' }}>
                          <div className="w-3 h-3 bg-green-600 rounded-full mx-auto mb-2 relative z-10"></div>
                          <div className="text-xs font-bold text-gray-700">Weeks 7-8</div>
                          <div className="text-xs text-gray-500 mt-1">Round 1</div>
                          <div className="text-xs text-gray-400">IOI review, mgmt meetings</div>
                        </div>
                        <div className="text-center" style={{ width: '16%' }}>
                          <div className="w-3 h-3 bg-green-600 rounded-full mx-auto mb-2 relative z-10"></div>
                          <div className="text-xs font-bold text-gray-700">Weeks 9-10</div>
                          <div className="text-xs text-gray-500 mt-1">Round 2</div>
                          <div className="text-xs text-gray-400">LOIs due IOI + 14d</div>
                        </div>
                        <div className="text-center" style={{ width: '16%' }}>
                          <div className="w-3 h-3 bg-green-600 rounded-full mx-auto mb-2 relative z-10"></div>
                          <div className="text-xs font-bold text-gray-700">Weeks 10-23</div>
                          <div className="text-xs text-gray-500 mt-1">Diligence &amp; Legal</div>
                          <div className="text-xs text-gray-400">~90d: verify, finance, draft</div>
                        </div>
                        <div className="text-center" style={{ width: '16%' }}>
                          <div className="w-3 h-3 bg-green-700 rounded-full mx-auto mb-2 relative z-10 ring-2 ring-green-300"></div>
                          <div className="text-xs font-bold text-green-700">~Week 24</div>
                          <div className="text-xs text-green-600 mt-1">CLOSING</div>
                          <div className="text-xs text-gray-400">Wire transfer</div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-3 text-sm text-gray-600">
                      <strong>Total Timeline:</strong> about 6 months from engagement to close — the signed-LOI-to-closing stretch alone is approximately 90 days (buyer diligence, financing, purchase agreement, transition items). Timeline can vary based on buyer financing, deal complexity, and due diligence findings.
                    </div>
                  </div>
                </div>
                
                {/* Our Role */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    What Vista Handles
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="grid grid-cols-3 gap-4">
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl mb-2">📋</div>
                        <div className="font-semibold text-gray-800 text-sm mb-1">Deal Preparation</div>
                        <div className="text-xs text-gray-500">CIM creation, financial recast, valuation analysis, buyer targeting</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl mb-2">🎯</div>
                        <div className="font-semibold text-gray-800 text-sm mb-1">Buyer Outreach</div>
                        <div className="text-xs text-gray-500">Confidential marketing, buyer qualification, NDA management</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl mb-2">💬</div>
                        <div className="font-semibold text-gray-800 text-sm mb-1">Negotiations</div>
                        <div className="text-xs text-gray-500">Offer analysis, term negotiation, competitive leverage</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl mb-2">🔍</div>
                        <div className="font-semibold text-gray-800 text-sm mb-1">Due Diligence</div>
                        <div className="text-xs text-gray-500">Data room setup, Q&A coordination, issue resolution</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl mb-2">📝</div>
                        <div className="font-semibold text-gray-800 text-sm mb-1">Legal Coordination</div>
                        <div className="text-xs text-gray-500">Assist your legal counsel, manage closing checklist</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl mb-2">🤝</div>
                        <div className="font-semibold text-gray-800 text-sm mb-1">Close & Transition</div>
                        <div className="text-xs text-gray-500">Closing coordination, funds transfer, transition support</div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Why Our Competitive Process Works */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    Why Our Competitive Process Works For You
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="flex gap-3 items-start">
                        <div className="w-6 h-6 bg-green-700 rounded-full text-white text-xs flex items-center justify-center flex-shrink-0">✓</div>
                        <div>
                          <div className="font-semibold text-gray-800 text-sm">You Choose Your Buyer</div>
                          <div className="text-xs text-gray-500">Interview buyers and select the one that's right for you, your employees, and your business—not just the highest bidder.</div>
                        </div>
                      </div>
                      <div className="flex gap-3 items-start">
                        <div className="w-6 h-6 bg-green-700 rounded-full text-white text-xs flex items-center justify-center flex-shrink-0">✓</div>
                        <div>
                          <div className="font-semibold text-gray-800 text-sm">See All Offers at Once</div>
                          <div className="text-xs text-gray-500">Compare every offer side-by-side. Know you're getting the best price without wondering if the next buyer would have offered more.</div>
                        </div>
                      </div>
                      <div className="flex gap-3 items-start">
                        <div className="w-6 h-6 bg-green-700 rounded-full text-white text-xs flex items-center justify-center flex-shrink-0">✓</div>
                        <div>
                          <div className="font-semibold text-gray-800 text-sm">Maximum Leverage</div>
                          <div className="text-xs text-gray-500">With multiple competing buyers, we negotiate from a position of strength—pushing LOIs higher and securing better terms.</div>
                        </div>
                      </div>
                      <div className="flex gap-3 items-start">
                        <div className="w-6 h-6 bg-green-700 rounded-full text-white text-xs flex items-center justify-center flex-shrink-0">✓</div>
                        <div>
                          <div className="font-semibold text-gray-800 text-sm">Built-In Backup Plan</div>
                          <div className="text-xs text-gray-500">If a deal falls through, we go to runner-up bidders immediately. No starting over. This is rare—Vista maintains a near 100% close rate.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* What's Next */}
                <div className="mb-5">
                  <div className="bg-green-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    What's Next?
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="grid grid-cols-2 gap-4">
                      {/* Ready to Sell */}
                      <div className="border-2 border-green-700 rounded-lg p-4">
                        <div className="font-bold text-green-700 mb-2">Ready to Move Forward?</div>
                        <p className="text-sm text-gray-600 mb-3">
                          If you're ready to begin the sale process, we'll send you an Engagement Agreement for review. 
                          Once signed and the retainer is received, we immediately begin preparing your Confidential 
                          Information Memorandum.
                        </p>
                        <div className="bg-green-50 rounded-lg p-3 mb-3">
                          <div className="flex items-center gap-2 mb-2">
                            <div className="w-5 h-5 bg-green-700 rounded-full text-white text-xs flex items-center justify-center font-bold">1</div>
                            <div className="text-sm text-green-800 font-medium">Review & Sign Engagement Agreement</div>
                          </div>
                          <div className="flex items-center gap-2 mb-2">
                            <div className="w-5 h-5 bg-green-700 rounded-full text-white text-xs flex items-center justify-center font-bold">2</div>
                            <div className="text-sm text-green-800 font-medium">Submit Retainer (credited at close)</div>
                          </div>
                          <div className="flex items-center gap-2">
                            <div className="w-5 h-5 bg-green-700 rounded-full text-white text-xs flex items-center justify-center font-bold">3</div>
                            <div className="text-sm text-green-800 font-medium">We Get Started Immediately</div>
                          </div>
                        </div>
                        <div className="bg-green-700 text-white text-center py-2 rounded-lg font-semibold text-sm">
                          ~6 Months from Engagement to Close
                        </div>
                      </div>
                      
                      {/* Not Ready Yet */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="font-bold text-gray-700 mb-2">Not Ready to Sell Yet?</div>
                        <p className="text-sm text-gray-600 mb-3">
                          That's completely fine. Many owners use this valuation as a benchmark to track progress 
                          toward their exit goals. We recommend staying connected so you're prepared when the time is right.
                        </p>
                        <div className="bg-gray-50 rounded-lg p-3">
                          <div className="flex items-start gap-3 mb-3 pb-3 border-b border-gray-200">
                            <div className="text-xl">📅</div>
                            <div>
                              <div className="font-semibold text-green-700 text-sm">6-Month Review Meetings</div>
                              <div className="text-xs text-gray-500">We'll update you on M&A market conditions and discuss your business progress</div>
                            </div>
                          </div>
                          <div className="flex items-start gap-3">
                            <div className="text-xl">📊</div>
                            <div>
                              <div className="font-semibold text-green-700 text-sm">Annual Valuation Updates</div>
                              <div className="text-xs text-gray-500">Every 12 months we'll refresh your valuation to track how your value is changing</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Confidentiality */}
                <div className="bg-gray-100 border border-gray-300 rounded-lg p-4">
                  <div className="font-semibold text-gray-800 mb-2">Confidentiality Protection</div>
                  <p className="text-sm text-gray-600">
                    Your sale process is completely confidential. We use code names in all buyer communications, require signed NDAs before sharing any identifying information, and carefully control information flow. Employees, customers, and competitors will not know your business is for sale unless you choose to tell them.
                  </p>
                </div>
              </div>
            )}
            
            {reviewSection === 'simulator' && (
              <div>
                {/* Vista Header */}
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-300">
                  <img src={vistaLogoBase64} alt="Vista Business Group" className="h-10" onError={(e) => e.target.style.display = 'none'} />
                  <div className="flex-1">
                    <div className="text-base font-bold text-gray-800">Value Enhancement Simulator</div>
                    <div className="text-xs text-gray-500">Model improvements and their impact on business value</div>
                  </div>
                  <button 
                    onClick={() => {
                      // Reset all simulator values
                      setSimEbitdaChange(0);
                      setSimRecurringPct(null);
                      setSimRevenueGrowth(null);
                      setSimRetentionRate(null);
                      setSimTopCustomerPct(null);
                      setSimClientCount(null);
                      setSimMarginImprovement(0);
                      setSimContractImprovements({ extendTerms: false, addAutoRenewal: false, addEscalators: false, addTermPenalty: false });
                      setSimAcquisitionTargetEbitda(300000);
                      setSimTargetQualityAssumption(1.0);
                    }}
                    className="text-sm px-3 py-1 text-gray-600 hover:bg-gray-100 rounded border border-gray-300"
                  >
                    Reset All
                  </button>
                </div>
                
                {/* Disclaimer */}
                <div className="bg-gray-50 border border-gray-200 p-3 rounded-lg mb-4 text-sm text-gray-600">
                  <strong className="text-gray-700">Planning Tool:</strong> Adjust the sliders below to see how business improvements could impact your valuation. 
                  Set goals and track progress toward maximizing your exit value.
                </div>
                
                {(() => {
                  // Get current values from the actual data - prioritize Sales tab data
                  const currentRecurringPct = (revenueScoringMode === 'legacy' ? keyMetrics.recurringPct : keyMetrics.contractedRecurringPct) || 0;
                  const currentGrowthRate = revenueAnalysis?.yoyChanges?.year5toTTM || 0;
                  const currentRetention = keyMetrics.avgRetention || 0;
                  // Use Sales tab data for concentration (keyMetrics) over manual entry
                  const salesTabTopCustomerPct = keyMetrics?.topCustomerPct || 0;
                  const manualTopCustomerPct = multipleAdjustments.concentration?.topCustomerPct || 0;
                  const currentTopCustPct = salesTabTopCustomerPct > 0 ? salesTabTopCustomerPct : manualTopCustomerPct;
                  // Use Sales tab customer count
                  const salesTabClientCount = keyMetrics?.customerCount?.ttm || 0;
                  const manualClientCount = multipleAdjustments.concentration?.totalClientCount || 0;
                  const currentClientCount = salesTabClientCount > 0 ? salesTabClientCount : manualClientCount;
                  // Current EBITDA margin
                  const currentEbitdaMargin = keyMetrics.ebitdaMargin || 0;
                  
                  // Use slider values if set, otherwise current
                  const targetRecurringPct = simRecurringPct !== null ? simRecurringPct : currentRecurringPct;
                  const targetGrowthRate = simRevenueGrowth !== null ? simRevenueGrowth : currentGrowthRate;
                  const targetRetention = simRetentionRate !== null ? simRetentionRate : currentRetention;
                  const targetTopCustPct = simTopCustomerPct !== null ? simTopCustomerPct : currentTopCustPct;
                  const targetClientCount = simClientCount !== null ? simClientCount : currentClientCount;
                  
                  // Calculate multiple adjustments from improvements
                  // Recurring Revenue: benchmark 65%, +0.5x at 85%+
                  const recurringDelta = targetRecurringPct - currentRecurringPct;
                  const recurringMultipleBonus = recurringDelta > 0 ? Math.min(0.5, (recurringDelta / 20) * 0.25) : 0;
                  
                  // Revenue Growth: +0.4x at 20%+, +0.25x at 10%+
                  const growthDelta = targetGrowthRate - currentGrowthRate;
                  let growthMultipleBonus = 0;
                  if (targetGrowthRate >= 20 && currentGrowthRate < 20) growthMultipleBonus = 0.4;
                  else if (targetGrowthRate >= 10 && currentGrowthRate < 10) growthMultipleBonus = 0.25;
                  else if (growthDelta > 0) growthMultipleBonus = Math.min(0.3, growthDelta * 0.02);
                  
                  // Retention: benchmark 92%, +0.5x at 97%+
                  const retentionDelta = targetRetention - currentRetention;
                  const retentionMultipleBonus = retentionDelta > 0 ? Math.min(0.5, (retentionDelta / 10) * 0.25) : 0;
                  
                  // Concentration: lower is better, +0.2x dropping from 25%+ to <15%
                  const concDelta = currentTopCustPct - targetTopCustPct; // positive = improvement
                  let concMultipleBonus = 0;
                  if (currentTopCustPct > 0 && targetTopCustPct > 0) {
                    if (targetTopCustPct <= 10 && currentTopCustPct > 10) concMultipleBonus = 0.2;
                    else if (targetTopCustPct <= 15 && currentTopCustPct > 15) concMultipleBonus = 0.1;
                    else if (concDelta > 0) concMultipleBonus = Math.min(0.2, concDelta * 0.01);
                  }
                  
                  // EBITDA Margin improvement: +0.3x for moving from <15% to 20%+
                  // (Higher margins = more sustainable, more cash to buyers)
                  let marginMultipleBonus = 0;
                  if (currentEbitdaMargin < 20 && simEbitdaChange > 0) {
                    // Assuming margin improvement comes with EBITDA growth
                    marginMultipleBonus = Math.min(0.3, simEbitdaChange * 0.005);
                  }
                  
                  // Contract improvements (includes owner dependency and AR quality)
                  const contractMultipleBonus = 
                    (simContractImprovements.extendTerms ? 0.2 : 0) +
                    (simContractImprovements.addAutoRenewal ? 0.1 : 0) +
                    (simContractImprovements.addEscalators ? 0.15 : 0) +
                    (simContractImprovements.addTermPenalty ? 0.15 : 0) +
                    (simContractImprovements.reduceOwnerDependency ? 0.25 : 0) +
                    (simContractImprovements.improveAR ? 0.15 : 0);
                  
                  // Total multiple bonus
                  const totalMultipleBonus = recurringMultipleBonus + growthMultipleBonus + retentionMultipleBonus + 
                    concMultipleBonus + marginMultipleBonus + contractMultipleBonus;
                  
                  // EBITDA improvement (% growth + margin improvement)
                  const ttmRevenue = calculations.years[5]?.revenue || 0;
                  const marginEbitdaGain = ttmRevenue * (simMarginImprovement / 100);
                  const enhancedEbitda = multipleEngineCalcs.adjustedEbitda * (1 + simEbitdaChange / 100) + marginEbitdaGain;
                  
                  // Calculate new base multiple from enhanced EBITDA (Step 1: Company Size → Base Multiple)
                  let enhancedBaseMultiple = baseMultipleTable[0]?.multiple || 3.0;
                  for (let i = 0; i < baseMultipleTable.length - 1; i++) {
                    if (enhancedEbitda >= baseMultipleTable[i].ebitda && enhancedEbitda < baseMultipleTable[i + 1].ebitda) {
                      const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
                      const multipleRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
                      const progress = (enhancedEbitda - baseMultipleTable[i].ebitda) / range;
                      enhancedBaseMultiple = baseMultipleTable[i].multiple + (multipleRange * progress);
                      break;
                    }
                    if (enhancedEbitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) {
                      enhancedBaseMultiple = baseMultipleTable[baseMultipleTable.length - 1].multiple;
                    }
                  }
                  
                  // Multiple bonus from moving up size tiers
                  const sizeMultipleBonus = enhancedBaseMultiple - multipleEngineCalcs.rawBaseMultiple;
                  
                  // Enhanced values - apply size bonus + factor bonuses (floor at 0)
                  const enhancedMultiple = Math.max(0, multipleEngineCalcs.marketHighMultiple + sizeMultipleBonus + totalMultipleBonus);
                  const enhancedTypical = Math.max(0, multipleEngineCalcs.typicalMultiple + sizeMultipleBonus + totalMultipleBonus);
                  const enhancedValueHigh = enhancedEbitda * enhancedMultiple;
                  const enhancedValueLow = enhancedEbitda * enhancedTypical;
                  const valueIncrease = enhancedValueHigh - multipleEngineCalcs.valuationMarketHigh;
                  
                  return (
                    <div className="grid grid-cols-3 gap-4">
                      {/* Left Column: EBITDA + Multiple Sliders */}
                      <div className="col-span-2 space-y-3">
                        
                        {/* EBITDA Improvement */}
                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-2">
                            <div>
                              <label className="font-bold text-gray-800">EBITDA Growth Target</label>
                              <div className="text-xs text-gray-500">Current: {formatCurrency(multipleEngineCalcs.adjustedEbitda)}</div>
                            </div>
                            <div className="text-right">
                              <span className="text-2xl font-bold text-gray-800">{simEbitdaChange > 0 ? '+' : ''}{simEbitdaChange}%</span>
                              <div className="text-xs text-gray-500">Target: {formatCurrency(enhancedEbitda)}</div>
                            </div>
                          </div>
                          <input 
                            type="range" 
                            min="0" 
                            max="50" 
                            value={simEbitdaChange}
                            onChange={e => setSimEbitdaChange(parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>No change</span>
                            <span>+25%</span>
                            <span>+50%</span>
                          </div>
                          {sizeMultipleBonus > 0 && (
                            <div className="text-xs text-green-700 mt-2 bg-green-50 p-2 rounded border border-green-200">
                              Growing to {formatCurrency(enhancedEbitda)} moves you up the size tier, adding <strong>+{sizeMultipleBonus.toFixed(2)}x</strong> to your multiple!
                            </div>
                          )}
                          <div className="text-xs text-gray-600 mt-2 bg-gray-100 p-2 rounded">
                            EBITDA growth increases value two ways: higher earnings AND potentially a higher multiple from moving up size tiers.
                          </div>
                        </div>
                        
                        {/* Margin Improvement */}
                        {(() => {
                          const currentMargin = currentEbitdaMargin;
                          const ttmRevenue = calculations.years[5]?.revenue || 0;
                          const targetMargin = currentMargin + simMarginImprovement;
                          const marginEbitdaGain = ttmRevenue * (simMarginImprovement / 100);
                          const marginPctIncrease = multipleEngineCalcs.adjustedEbitda > 0 ? (marginEbitdaGain / multipleEngineCalcs.adjustedEbitda * 100) : 0;
                          
                          return (
                            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                              <div className="flex justify-between items-center mb-2">
                                <div>
                                  <label className="font-bold text-gray-800">EBITDA Margin Improvement</label>
                                  <div className="text-xs text-gray-500">Current margin: {currentMargin.toFixed(1)}% on {formatCurrency(ttmRevenue)} revenue</div>
                                </div>
                                <div className="text-right">
                                  <span className="text-2xl font-bold text-gray-800">{targetMargin.toFixed(1)}%</span>
                                  {simMarginImprovement > 0 && (
                                <div className="text-xs text-green-600">+{simMarginImprovement} pts adds {formatCurrency(marginEbitdaGain)} → {formatCurrency(multipleEngineCalcs.adjustedEbitda + marginEbitdaGain)} EBITDA</div>
                                  )}
                                </div>
                              </div>
                              <input 
                                type="range" 
                                min="0" 
                                max="15" 
                                step="0.5"
                                value={simMarginImprovement}
                                onChange={e => setSimMarginImprovement(parseFloat(e.target.value))}
                                className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600"
                              />
                              <div className="flex justify-between text-xs text-gray-400 mt-1">
                                <span>No change</span>
                                <span>+5 pts</span>
                                <span>+10 pts</span>
                                <span>+15 pts</span>
                              </div>
                              {simMarginImprovement > 0 && (
                                <div className="text-xs text-gray-600 mt-2 bg-gray-100 p-2 rounded">
                                  <strong>How to improve margins:</strong> Reduce COGS (negotiate vendors, improve efficiency), cut discretionary OpEx, raise prices, or focus on higher-margin services.
                                </div>
                              )}
                            </div>
                          );
                        })()}
                        
                        <h4 className="font-bold text-gray-700 pt-2">Multiple Improvement Factors</h4>
                        
                        {/* Recurring Revenue % */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-1">
                            <div>
                              <label className="font-medium text-gray-700">Recurring Revenue %</label>
                              <div className="text-xs text-gray-500">Convert project work to managed services</div>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-800">{targetRecurringPct.toFixed(0)}%</span>
                              {recurringMultipleBonus > 0 && <span className="text-green-700 text-sm ml-2">+{recurringMultipleBonus.toFixed(2)}x</span>}
                            </div>
                          </div>
                          <input 
                            type="range" 
                            min={Math.max(0, currentRecurringPct)}
                            max="95" 
                            value={targetRecurringPct}
                            onChange={e => setSimRecurringPct(parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>Current: {currentRecurringPct.toFixed(0)}%</span>
                            <span className="text-gray-600">Target: 85%+</span>
                          </div>
                        </div>
                        
                        {/* Revenue Growth Rate */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-1">
                            <div>
                              <label className="font-medium text-gray-700">Revenue Growth (YoY)</label>
                              <div className="text-xs text-gray-500">Sales initiatives, marketing, acquisitions</div>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-800">{targetGrowthRate >= 0 ? '+' : ''}{targetGrowthRate.toFixed(0)}%</span>
                              {growthMultipleBonus > 0 && <span className="text-green-700 text-sm ml-2">+{growthMultipleBonus.toFixed(2)}x</span>}
                            </div>
                          </div>
                          <input 
                            type="range" 
                            min={Math.min(0, currentGrowthRate)}
                            max="30" 
                            value={targetGrowthRate}
                            onChange={e => setSimRevenueGrowth(parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>Current: {currentGrowthRate >= 0 ? '+' : ''}{currentGrowthRate.toFixed(0)}%</span>
                            <span className="text-gray-600">Target: 15%+</span>
                          </div>
                        </div>
                        
                        {/* Customer Retention Rate */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-1">
                            <div>
                              <label className="font-medium text-gray-700">Customer Retention Rate</label>
                              <div className="text-xs text-gray-500">QBRs, account management, service quality</div>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-800">{targetRetention.toFixed(0)}%</span>
                              {retentionMultipleBonus > 0 && <span className="text-green-700 text-sm ml-2">+{retentionMultipleBonus.toFixed(2)}x</span>}
                            </div>
                          </div>
                          <input 
                            type="range" 
                            min={Math.max(70, currentRetention)}
                            max="99" 
                            value={targetRetention}
                            onChange={e => setSimRetentionRate(parseInt(e.target.value))}
                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-600"
                          />
                          <div className="flex justify-between text-xs text-gray-400 mt-1">
                            <span>Current: {currentRetention.toFixed(0)}%</span>
                            <span className="text-gray-600">Target: 95%+</span>
                          </div>
                        </div>
                        
                        {/* Top Customer Concentration */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-1">
                            <div>
                              <label className="font-medium text-gray-700">Top Customer Concentration</label>
                              <div className="text-xs text-gray-500">
                                {salesTabTopCustomerPct > 0 ? 'From Sales tab' : 'Grow other accounts, diversify client base'}
                              </div>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-gray-800">{targetTopCustPct.toFixed(0)}%</span>
                              {concMultipleBonus > 0 && <span className="text-green-700 text-sm ml-2">+{concMultipleBonus.toFixed(2)}x</span>}
                            </div>
                          </div>
                          {currentTopCustPct > 0 ? (
                            <>
                              <input 
                                type="range" 
                                min="5"
                                max={Math.max(30, currentTopCustPct)} 
                                value={targetTopCustPct}
                                onChange={e => setSimTopCustomerPct(parseInt(e.target.value))}
                                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-600"
                                style={{ direction: 'rtl' }}
                              />
                              <div className="flex justify-between text-xs text-gray-400 mt-1">
                                <span className="text-gray-600">Target: &lt;15%</span>
                                <span>Current: {currentTopCustPct.toFixed(0)}%</span>
                              </div>
                            </>
                          ) : (
                            <div className="text-xs text-gray-600 bg-gray-50 p-2 rounded mt-1 border border-gray-200">
                              Enter customer data in Sales tab to enable this slider
                            </div>
                          )}
                        </div>
                        
                        {/* Contract Improvements Checklist */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-2">
                            <label className="font-medium text-gray-700">Contract Term Improvements</label>
                            {contractMultipleBonus > 0 && <span className="text-green-700 font-bold">+{contractMultipleBonus.toFixed(2)}x</span>}
                          </div>
                          <div className="grid grid-cols-2 gap-2">
                            <label className="flex items-center gap-2 p-2 bg-gray-50 rounded cursor-pointer hover:bg-gray-100 border border-gray-200">
                              <input 
                                type="checkbox" 
                                checked={simContractImprovements.extendTerms}
                                onChange={e => setSimContractImprovements({...simContractImprovements, extendTerms: e.target.checked})}
                                className="rounded"
                              />
                              <div>
                                <div className="text-sm font-medium">Extend to 24+ months</div>
                                <div className="text-xs text-green-700">+0.20x</div>
                              </div>
                            </label>
                            <label className="flex items-center gap-2 p-2 bg-gray-50 rounded cursor-pointer hover:bg-gray-100 border border-gray-200">
                              <input 
                                type="checkbox" 
                                checked={simContractImprovements.addAutoRenewal}
                                onChange={e => setSimContractImprovements({...simContractImprovements, addAutoRenewal: e.target.checked})}
                                className="rounded"
                              />
                              <div>
                                <div className="text-sm font-medium">Add auto-renewal</div>
                                <div className="text-xs text-green-700">+0.10x</div>
                              </div>
                            </label>
                            <label className="flex items-center gap-2 p-2 bg-gray-50 rounded cursor-pointer hover:bg-gray-100 border border-gray-200">
                              <input 
                                type="checkbox" 
                                checked={simContractImprovements.addEscalators}
                                onChange={e => setSimContractImprovements({...simContractImprovements, addEscalators: e.target.checked})}
                                className="rounded"
                              />
                              <div>
                                <div className="text-sm font-medium">3-5% price escalators</div>
                                <div className="text-xs text-green-700">+0.15x</div>
                              </div>
                            </label>
                            <label className="flex items-center gap-2 p-2 bg-gray-50 rounded cursor-pointer hover:bg-gray-100 border border-gray-200">
                              <input 
                                type="checkbox" 
                                checked={simContractImprovements.addTermPenalty}
                                onChange={e => setSimContractImprovements({...simContractImprovements, addTermPenalty: e.target.checked})}
                                className="rounded"
                              />
                              <div>
                                <div className="text-sm font-medium">Early termination penalty</div>
                                <div className="text-xs text-green-700">+0.15x</div>
                              </div>
                            </label>
                          </div>
                          <div className="text-xs text-gray-600 bg-gray-50 p-2 rounded mt-2 border border-gray-200">
                            <strong>Trade-off:</strong> Longer contract terms often require price concessions (5-15% discounts), which may reduce EBITDA. Factor this into your EBITDA growth target above.
                          </div>
                        </div>
                        
                        {/* Owner Dependency */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-1">
                            <div>
                              <label className="font-medium text-gray-700">Owner Dependency Reduction</label>
                              <div className="text-xs text-gray-500">Hire/train management, document processes</div>
                            </div>
                            <div className="text-right">
                              {simContractImprovements.reduceOwnerDependency && <span className="text-green-700 text-sm">+0.25x</span>}
                            </div>
                          </div>
                          <label className="flex items-center gap-2 p-2 bg-gray-50 rounded cursor-pointer hover:bg-gray-100 border border-gray-200">
                            <input 
                              type="checkbox" 
                              checked={simContractImprovements.reduceOwnerDependency || false}
                              onChange={e => setSimContractImprovements({...simContractImprovements, reduceOwnerDependency: e.target.checked})}
                              className="rounded"
                            />
                            <div>
                              <div className="text-sm font-medium">Business can run without owner for 2+ weeks</div>
                              <div className="text-xs text-gray-500">Hire operations manager, cross-train staff, document all processes</div>
                            </div>
                          </label>
                        </div>
                        
                        {/* AR Quality */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <div className="flex justify-between items-center mb-1">
                            <div>
                              <label className="font-medium text-gray-700">AR Quality Improvement</label>
                              <div className="text-xs text-gray-500">Reduce past-due receivables, improve collections</div>
                            </div>
                            <div className="text-right">
                              {simContractImprovements.improveAR && <span className="text-green-700 text-sm">+0.15x</span>}
                            </div>
                          </div>
                          <label className="flex items-center gap-2 p-2 bg-gray-50 rounded cursor-pointer hover:bg-gray-100 border border-gray-200">
                            <input 
                              type="checkbox" 
                              checked={simContractImprovements.improveAR || false}
                              onChange={e => setSimContractImprovements({...simContractImprovements, improveAR: e.target.checked})}
                              className="rounded"
                            />
                            <div>
                              <div className="text-sm font-medium">Reduce past-due AR to &lt;10% of total</div>
                              <div className="text-xs text-gray-500">Implement collections process, enforce payment terms</div>
                            </div>
                          </label>
                        </div>
                      </div>
                      
                      {/* Right Column: Results */}
                      <div className="space-y-3">
                        {/* Current Valuation */}
                        <div className="bg-gray-100 p-4 rounded-lg border border-gray-200">
                          <div className="text-sm font-medium text-gray-600 mb-1">Current Valuation</div>
                          <div className="text-xl font-bold text-gray-800">{formatCurrency(multipleEngineCalcs.valuationTypical)} – {formatCurrency(multipleEngineCalcs.valuationMarketHigh)}</div>
                          <div className="text-xs text-gray-500">@ {multipleEngineCalcs.typicalMultiple.toFixed(2)}x – {multipleEngineCalcs.marketHighMultiple.toFixed(2)}x</div>
                        </div>
                        
                        {/* Enhanced Valuation */}
                        <div className={`p-4 rounded-lg border-2 ${(totalMultipleBonus + sizeMultipleBonus) > 0 || simEbitdaChange > 0 ? 'bg-green-50 border-green-300' : 'bg-gray-50 border-gray-200'}`}>
                          <div className="text-sm font-medium text-gray-700 mb-1">Target Valuation</div>
                          <div className="text-2xl font-bold text-gray-800">{formatCurrency(enhancedValueLow)} – {formatCurrency(enhancedValueHigh)}</div>
                          <div className="text-xs text-gray-600">@ {enhancedTypical.toFixed(2)}x – {enhancedMultiple.toFixed(2)}x</div>
                        </div>
                        
                        {/* Value Increase */}
                        <div className={`p-4 rounded-lg text-center ${valueIncrease > 0 ? 'bg-green-700 text-white' : 'bg-gray-200'}`}>
                          <div className="text-sm opacity-90">Potential Value Increase</div>
                          <div className="text-3xl font-bold">
                            {valueIncrease > 0 ? '+' : ''}{formatCurrency(valueIncrease)}
                          </div>
                          <div className="text-sm opacity-90">
                            ({((valueIncrease / Math.max(1, multipleEngineCalcs.valuationMarketHigh)) * 100).toFixed(0)}% increase)
                          </div>
                        </div>
                        
                        {/* Improvement Breakdown */}
                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                          <h5 className="font-bold text-gray-700 mb-2 text-sm">Impact Breakdown</h5>
                          <div className="space-y-1 text-xs">
                            {simEbitdaChange > 0 && (
                              <div className="flex justify-between">
                                <span>EBITDA Growth +{simEbitdaChange}%</span>
                                <span className="text-green-700">+{formatCurrency(multipleEngineCalcs.adjustedEbitda * (simEbitdaChange / 100))}</span>
                              </div>
                            )}
                            {simMarginImprovement > 0 && (
                              <div className="flex justify-between">
                                <span>Margin +{simMarginImprovement} pts</span>
                                <span className="text-green-700">+{formatCurrency(marginEbitdaGain)}</span>
                              </div>
                            )}
                            {sizeMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Size Tier Upgrade</span>
                                <span className="text-green-700">+{sizeMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {recurringMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Recurring Revenue</span>
                                <span className="text-green-700">+{recurringMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {growthMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Revenue Growth</span>
                                <span className="text-green-700">+{growthMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {retentionMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Customer Retention</span>
                                <span className="text-green-700">+{retentionMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {concMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Reduce Concentration</span>
                                <span className="text-green-700">+{concMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {marginMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Margin Improvement</span>
                                <span className="text-green-700">+{marginMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {simContractImprovements.reduceOwnerDependency && (
                              <div className="flex justify-between">
                                <span>Owner Dependency</span>
                                <span className="text-green-700">+0.25x</span>
                              </div>
                            )}
                            {simContractImprovements.improveAR && (
                              <div className="flex justify-between">
                                <span>AR Quality</span>
                                <span className="text-green-700">+0.15x</span>
                              </div>
                            )}
                            {contractMultipleBonus > 0 && (
                              <div className="flex justify-between">
                                <span>Contract Terms</span>
                                <span className="text-green-700">+{contractMultipleBonus.toFixed(2)}x</span>
                              </div>
                            )}
                            {(totalMultipleBonus + sizeMultipleBonus) > 0 && (
                              <div className="flex justify-between pt-1 border-t font-bold">
                                <span>Total Multiple Bonus</span>
                                <span className="text-green-700">+{(totalMultipleBonus + sizeMultipleBonus).toFixed(2)}x</span>
                              </div>
                            )}
                          </div>
                        </div>
                        
                        {/* Timeline Note */}
                        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 text-xs text-gray-600">
                          <strong>Note:</strong> These improvements typically take 12-24 months to implement and be reflected in buyer valuations.
                        </div>
                        
                        {/* Acquisition Arbitrage */}
                        <div className="mt-4 pt-4 border-t border-gray-300">
                          <h4 className="font-semibold text-gray-800 mb-2">Acquisition Opportunity: Multiple Arbitrage</h4>
                          <p className="text-sm text-gray-600 mb-3">Acquiring a smaller company at a lower multiple, then applying your higher combined multiple, creates instant equity value:</p>
                          
                          {/* Target Size Slider */}
                          <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                            <div className="flex items-center justify-between mb-2">
                              <label className="text-sm font-medium text-gray-700">Target Company EBITDA</label>
                              <span className="text-sm font-bold text-gray-900">{formatCurrency(simAcquisitionTargetEbitda)}</span>
                            </div>
                            <input
                              type="range"
                              min="100000"
                              max="2000000"
                              step="50000"
                              value={simAcquisitionTargetEbitda}
                              onChange={e => setSimAcquisitionTargetEbitda(Number(e.target.value))}
                              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-600"
                            />
                            <div className="flex justify-between text-xs text-gray-500 mt-1">
                              <span>$100K</span>
                              <span>$500K</span>
                              <span>$1M</span>
                              <span>$1.5M</span>
                              <span>$2M</span>
                            </div>
                          </div>
                          
                          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                            {(() => {
                              const targetEbitda = simAcquisitionTargetEbitda;
                              // Target multiple: size-based lookup + industry adjustment + quality assumption
                              // Industry adjustment: same sector context as subject company
                              const industryAdj = industryMultipleAdjustment || 0;
                              let baseForTarget = 3.0;
                              for (let i = baseMultipleTable.length - 1; i >= 0; i--) {
                                if (targetEbitda >= baseMultipleTable[i].ebitda) {
                                  baseForTarget = baseMultipleTable[i].multiple;
                                  break;
                                }
                              }
                              const targetMultiple = baseForTarget + industryAdj + simTargetQualityAssumption;
                              const combinedEbitda = multipleEngineCalcs.adjustedEbitda + targetEbitda;
                              // Find the correct base multiple for combined EBITDA, then apply your factor adjustments
                              let combinedBaseMultiple = multipleEngineCalcs.rawBaseMultiple;
                              for (let i = baseMultipleTable.length - 1; i >= 0; i--) {
                                if (combinedEbitda >= baseMultipleTable[i].ebitda) {
                                  combinedBaseMultiple = baseMultipleTable[i].multiple;
                                  break;
                                }
                              }
                              // Apply the same factor adjustments to combined company
                              const combinedMultiple = combinedBaseMultiple + (multipleEngineCalcs.marketHighMultiple - multipleEngineCalcs.rawBaseMultiple);
                              
                              // Use market high multiple for your company
                              const yourCurrentValue = multipleEngineCalcs.valuationMarketHigh;
                              const purchasePrice = targetEbitda * targetMultiple;
                              const combinedValue = combinedEbitda * combinedMultiple;
                              const instantGain = combinedValue - yourCurrentValue - purchasePrice;
                              const multipleExpansion = combinedMultiple - targetMultiple;
                              
                              return (
                                <>
                                  <div className="grid grid-cols-4 gap-4 text-sm">
                                    <div className="text-center">
                                      <div className="text-xs text-gray-500 mb-1">Your Company</div>
                                      <div className="font-bold">{formatCurrency(multipleEngineCalcs.adjustedEbitda)}</div>
                                      <div className="text-gray-600">× {multipleEngineCalcs.marketHighMultiple.toFixed(1)}x</div>
                                      <div className="font-bold text-gray-800">{formatCurrency(yourCurrentValue)}</div>
                                    </div>
                                    <div className="text-center text-2xl font-bold text-gray-400 flex items-center justify-center">+</div>
                                    <div className="text-center">
                                      <div className="text-xs text-gray-500 mb-1">Acquisition Target</div>
                                      <div className="font-bold">{formatCurrency(targetEbitda)}</div>
                                      <div className="text-gray-600">× {targetMultiple.toFixed(1)}x est. purchase</div>
                                      <div className="font-bold text-gray-600">{formatCurrency(purchasePrice)} purchase</div>
                                    </div>
                                    <div className="text-center bg-green-50 p-2 rounded border border-green-200">
                                      <div className="text-xs text-green-700 mb-1">Combined Value</div>
                                      <div className="font-bold">{formatCurrency(combinedEbitda)}</div>
                                      <div className="text-gray-600">× {combinedMultiple.toFixed(1)}x</div>
                                      <div className="font-bold text-green-700">{formatCurrency(combinedValue)}</div>
                                    </div>
                                  </div>
                                  <div className="mt-3 p-3 bg-green-50 rounded-lg border border-green-200">
                                    <div className="flex justify-between items-center">
                                      <div>
                                        <span className="text-sm text-gray-600">Multiple expansion: </span>
                                        <span className="font-bold text-green-700">{targetMultiple.toFixed(1)}x → {combinedMultiple.toFixed(1)}x (+{multipleExpansion.toFixed(1)}x)</span>
                                      </div>
                                      <div className="text-right">
                                        <span className="text-sm text-gray-600">Instant equity gain: </span>
                                        <span className="font-bold text-green-700 text-lg">{formatCurrency(instantGain)}</span>
                                      </div>
                                    </div>
                                  </div>
                                  {instantGain < 0 && (
                                    <div className="mt-2 text-xs text-gray-600 bg-gray-100 p-2 rounded border border-gray-200">
                                      At this target size, there's no immediate arbitrage gain because the target's multiple is similar to or higher than the combined multiple. Acquisitions may still create value through synergies and operational improvements.
                                    </div>
                                  )}
                                  {/* Multiple breakdown note */}
                                  <div className="mt-2 text-xs text-gray-500 border-t pt-2">
                                    Target multiple breakdown: {baseForTarget.toFixed(1)}x size
                                    {industryAdj !== 0 && <span> {industryAdj > 0 ? '+' : ''}{industryAdj.toFixed(1)}x industry</span>}
                                    {simTargetQualityAssumption !== 0 && <span> {simTargetQualityAssumption > 0 ? '+' : ''}{simTargetQualityAssumption.toFixed(1)}x quality assumption</span>}
                                    <span className="font-medium text-gray-600"> = {targetMultiple.toFixed(1)}x</span>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                          {/* Target quality assumption control */}
                          <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-sm font-medium text-gray-700">Target quality assumption</span>
                              <span className="text-sm font-bold text-gray-800">
                                {simTargetQualityAssumption === 0 ? 'Average (0x)' :
                                 simTargetQualityAssumption < 0 ? `Below avg (${simTargetQualityAssumption.toFixed(1)}x)` :
                                 `Above avg (+${simTargetQualityAssumption.toFixed(1)}x)`}
                              </span>
                            </div>
                            <input
                              type="range"
                              min="-1.0"
                              max="2.0"
                              step="0.5"
                              value={simTargetQualityAssumption}
                              onChange={e => setSimTargetQualityAssumption(Number(e.target.value))}
                              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-600"
                            />
                            <div className="flex justify-between text-xs text-gray-400 mt-1">
                              <span>Distressed (-1x)</span>
                              <span>Average (0x)</span>
                              <span>Solid (+1x)</span>
                              <span>Strong (+2x)</span>
                            </div>
                            <div className="text-xs text-gray-500 mt-1">
                              Default +1x assumes a decent business worth acquiring — conservative estimate hedges toward realistic deal cost.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
                
                {/* ═══════════════════════════════════════════════════════════════ */}
                {/* STRATEGIC VALUE BLUEPRINT - Long-term roadmap to target value  */}
                {/* ═══════════════════════════════════════════════════════════════ */}
                <div className="mt-8 pt-6 border-t-2 border-gray-300">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={vistaLogoBase64} alt="Vista Business Group" className="h-8" onError={(e) => e.target.style.display = 'none'} />
                    <div>
                      <div className="text-lg font-bold text-gray-800">Strategic Value Blueprint</div>
                      <div className="text-xs text-gray-500">Your roadmap from current value to target exit</div>
                    </div>
                  </div>
                  
                  {(() => {
                    // Current state from engine
                    const currentEbitda = multipleEngineCalcs.adjustedEbitda || 0;
                    const currentRevenue = calculations.years?.[5]?.revenue || 0;
                    const currentMultipleHigh = multipleEngineCalcs.marketHighMultiple || 0;
                    const currentMultipleTypical = multipleEngineCalcs.typicalMultiple || 0;
                    const currentValuationHigh = multipleEngineCalcs.valuationMarketHigh || 0;
                    const currentMargin = currentRevenue > 0 ? (currentEbitda / currentRevenue * 100) : 0;
                    
                    // Historical growth rate
                    const rev3 = 0; // Sum revenue categories for year3
                    const revY3 = revenueCategories.reduce((s, c) => s + (c[selectedValuationBasis]?.year3 || 0), 0);
                    const revY4 = revenueCategories.reduce((s, c) => s + (c[selectedValuationBasis]?.year4 || 0), 0);
                    const revY5 = revenueCategories.reduce((s, c) => s + (c[selectedValuationBasis]?.year5 || 0), 0);
                    const historicalGrowthRates = [];
                    if (revY3 > 0 && revY4 > 0) historicalGrowthRates.push((revY4 - revY3) / revY3 * 100);
                    if (revY4 > 0 && revY5 > 0) historicalGrowthRates.push((revY5 - revY4) / revY4 * 100);
                    const avgHistoricalGrowth = historicalGrowthRates.length > 0 ? historicalGrowthRates.reduce((a, b) => a + b, 0) / historicalGrowthRates.length : 0;
                    
                    // Recurring revenue %
                    const recurringPct = keyMetrics?.recurringPct || 0;
                    
                    // Blueprint inputs
                    const targetVal = blueprintTargetValuation || 0;
                    const timelineYrs = blueprintTimelineYears || 0;
                    const targetMargin = blueprintTargetMargin || (simMarginImprovement > 0 ? currentMargin + simMarginImprovement : (currentMargin > 5 ? Math.min(25, Math.max(15, currentMargin + 5)) : 18));
                    
                    // Compute multiple quality bonus from sliders (same logic as simulator above)
                    // If sliders are unchanged from defaults, this returns 0 (uses historic adjustments)
                    const currentRetention = keyMetrics?.customerRetentionRate || keyMetrics?.revenueRetentionRate || 0;
                    const currentTopCustPct = keyMetrics?.topCustomerConcentration || multipleAdjustments.concentration?.topCustomerPct || 0;
                    const currentGrowthRate = avgHistoricalGrowth;
                    
                    const targetRecurringPct = simRecurringPct != null ? simRecurringPct : recurringPct;
                    const targetRetention = simRetentionRate != null ? simRetentionRate : currentRetention;
                    const targetTopCustPct = simTopCustomerPct != null ? simTopCustomerPct : currentTopCustPct;
                    const targetGrowthRate = simRevenueGrowth != null ? simRevenueGrowth : currentGrowthRate;
                    
                    // Recurring revenue bonus
                    let bpRecurringBonus = 0;
                    if (targetRecurringPct > recurringPct) {
                      if (targetRecurringPct >= 80 && recurringPct < 80) bpRecurringBonus = 0.5;
                      else if (targetRecurringPct >= 65 && recurringPct < 65) bpRecurringBonus = 0.3;
                      else bpRecurringBonus = Math.min(0.5, (targetRecurringPct - recurringPct) / 20 * 0.25);
                    }
                    // Growth bonus
                    let bpGrowthBonus = 0;
                    if (targetGrowthRate > currentGrowthRate) {
                      if (targetGrowthRate >= 20 && currentGrowthRate < 20) bpGrowthBonus = 0.5;
                      else if (targetGrowthRate >= 10 && currentGrowthRate < 10) bpGrowthBonus = 0.25;
                      else { const gd = targetGrowthRate - currentGrowthRate; if (gd > 0) bpGrowthBonus = Math.min(0.3, gd * 0.02); }
                    }
                    // Retention bonus
                    const retDelta = targetRetention - currentRetention;
                    const bpRetentionBonus = retDelta > 0 ? Math.min(0.5, (retDelta / 10) * 0.25) : 0;
                    // Concentration bonus
                    let bpConcBonus = 0;
                    if (currentTopCustPct > 0 && targetTopCustPct > 0 && targetTopCustPct < currentTopCustPct) {
                      if (targetTopCustPct <= 10 && currentTopCustPct > 10) bpConcBonus = 0.2;
                      else if (targetTopCustPct <= 15 && currentTopCustPct > 15) bpConcBonus = 0.1;
                      else bpConcBonus = Math.min(0.2, (currentTopCustPct - targetTopCustPct) * 0.01);
                    }
                    // Contract improvements bonus
                    const bpContractBonus = 
                      (simContractImprovements.extendTerms ? 0.2 : 0) +
                      (simContractImprovements.addAutoRenewal ? 0.1 : 0) +
                      (simContractImprovements.addEscalators ? 0.15 : 0) +
                      (simContractImprovements.addTermPenalty ? 0.15 : 0) +
                      (simContractImprovements.reduceOwnerDependency ? 0.25 : 0) +
                      (simContractImprovements.improveAR ? 0.15 : 0);
                    
                    const sliderMultipleBonus = bpRecurringBonus + bpGrowthBonus + bpRetentionBonus + bpConcBonus + bpContractBonus;
                    
                    // ===== FACTOR-BY-FACTOR QUALITY PROJECTION =====
                    // Instead of a flat quality adjustment, project each factor at the target state
                    // and interpolate year-by-year for realistic multiple progression
                    
                    const currentFactors = multipleEngineCalcs.factors || {};
                    const currentTotalAdj = multipleEngineCalcs.totalAdjustment || 0;
                    const benchmarkMargin = currentBenchmarks?.ebitdaMargin || 18;
                    
                    // Helper: Calculate B1 score at given margin
                    const calcB1 = (margin) => {
                      if (margin >= benchmarkMargin + 8) return 0.5;
                      if (margin >= benchmarkMargin + 4) return 0.25;
                      if (margin >= benchmarkMargin - 4) return 0;
                      if (margin >= 10) return 0;
                      return margin >= 5 ? -0.25 : -0.50;
                    };
                    
                    // Helper: Calculate E1 score at given concentration
                    const calcE1 = (topPct, top5Pct) => {
                      let s = 0;
                      if (topPct <= 5) s += 0.15; else if (topPct <= 10) s += 0.1; else if (topPct <= 15) s += 0; else if (topPct <= 25) s -= 0.1; else if (topPct <= 35) s -= 0.2; else s -= 0.35;
                      if (top5Pct <= 20) s += 0.15; else if (top5Pct <= 30) s += 0.1; else if (top5Pct <= 40) s += 0; else if (top5Pct <= 50) s -= 0.05; else if (top5Pct <= 60) s -= 0.1; else if (top5Pct <= 70) s -= 0.2; else s -= 0.35;
                      return s;
                    };
                    
                    // Customer sales data for concentration projection
                    const sortedClients = customerSalesData.filter(c => c.name && c.ttm > 0).sort((a, b) => b.ttm - a.ttm);
                    const currentTopCustRev = sortedClients[0]?.ttm || 0;
                    const currentTop5Rev = sortedClients.slice(0, 5).reduce((s, c) => s + c.ttm, 0);
                    const currentClientCount = sortedClients.length;
                    const currentTop5Pct = keyMetrics?.top5CustomerConcentration || (currentRevenue > 0 ? currentTop5Rev / currentRevenue * 100 : 0);
                    
                    // Pre-estimate: does the Blueprint imply revenue growth?
                    const blueprintImpliesGrowth = targetVal > 0 && timelineYrs > 0;
                    // Estimate growth rate (refined after solve, but needed for A3/A5 scoring)
                    const preEstGrowthRate = blueprintImpliesGrowth ? Math.max(15, avgHistoricalGrowth) : 0;
                    
                    // Build per-factor projections
                    // Each factor: { name, current, projected, improvement, timeline (years), autoProjected, notes }
                    const factorProjections = [];
                    
                    // --- FACTOR A: Revenue Quality ---
                    const factorA = currentFactors.A;
                    const currentAAdj = factorA?.adjustment || 0;
                    let projectedAAdj = currentAAdj;
                    const aSubFactors = [];
                    if (factorA) {
                      const benchRecurring = currentBenchmarks?.recurringRevenuePct || 65;
                      
                      // A1: Revenue Type Mix — use slider target or current
                      const a1Current = factorA.subFactors?.A1?.score || 0;
                      const projRecPct = targetRecurringPct;
                      const projRecDiff = projRecPct - benchRecurring;
                      const projA1 = projRecDiff >= 30 ? 0.75 : projRecDiff >= 20 ? 0.5 : projRecDiff >= 10 ? 0.25 : 
                                     projRecDiff <= -30 ? -0.75 : projRecDiff <= -20 ? -0.5 : projRecDiff <= -10 ? -0.25 : 0;
                      aSubFactors.push({ name: 'Recurring Revenue', current: a1Current, projected: projA1, 
                        type: projA1 !== a1Current ? 'slider' : 'static',
                        note: projA1 !== a1Current ? `Recurring ${recurringPct.toFixed(0)}% → ${projRecPct.toFixed(0)}% (vs ${benchRecurring}% benchmark)` : `Recurring ${recurringPct.toFixed(0)}% (no change)` });
                      
                      // A2: Revenue YoY Stability — Blueprint growth = all positive, low variance
                      const a2Current = factorA.subFactors?.A2?.score || 0;
                      const projA2 = (blueprintImpliesGrowth) ? 0.15 : a2Current; // Consistent positive growth
                      aSubFactors.push({ name: 'YoY Stability', current: a2Current, projected: projA2,
                        type: projA2 !== a2Current ? 'auto' : 'static',
                        note: projA2 !== a2Current ? 'Consistent growth trend' : 'No change' });
                      
                      // A3: Monthly Distribution — with stable growth, normalizes
                      const a3Current = factorA.subFactors?.A3?.score || 0;
                      const projA3 = (blueprintImpliesGrowth) ? Math.max(a3Current, 0) : a3Current;
                      aSubFactors.push({ name: 'Monthly Distribution', current: a3Current, projected: projA3,
                        type: projA3 !== a3Current ? 'auto' : 'static',
                        note: projA3 !== a3Current ? 'Normalizes with scale' : 'No change' });
                      
                      // A4: Customer Type — static
                      const a4Current = factorA.subFactors?.A4?.score || 0;
                      aSubFactors.push({ name: 'Customer Type', current: a4Current, projected: a4Current,
                        type: 'static', note: 'B2B/Residential mix unchanged' });
                      
                      // A5: Growth Quality — with recurring revenue target, growth quality improves
                      const a5Current = factorA.subFactors?.A5?.score || 0;
                      const projA5 = (projRecPct >= 65 && preEstGrowthRate > 5) ? 0.10 : 
                                     (projRecPct >= 50 && preEstGrowthRate > 5) ? 0 : a5Current;
                      aSubFactors.push({ name: 'Growth Quality', current: a5Current, projected: projA5,
                        type: projA5 !== a5Current ? 'auto' : 'static',
                        note: projA5 !== a5Current ? 'Growth driven by recurring' : 'No change' });
                      
                      // A6: Customer Spike — diluted with revenue growth
                      const a6Current = factorA.subFactors?.A6?.score || 0;
                      const projA6 = (preEstGrowthRate > 10) ? 0 : a6Current; // Spikes negligible at high growth
                      aSubFactors.push({ name: 'Customer Spike', current: a6Current, projected: projA6,
                        type: projA6 !== a6Current ? 'auto' : 'static',
                        note: projA6 !== a6Current ? 'Diluted by revenue growth' : a6Current < 0 ? 'Spike persists' : 'No spike' });
                      
                      projectedAAdj = Math.round(aSubFactors.reduce((s, f) => s + f.projected, 0) * 100) / 100;
                    }
                    factorProjections.push({ key: 'A', name: 'Revenue Quality', current: currentAAdj, projected: projectedAAdj, improvement: Math.round((projectedAAdj - currentAAdj) * 100) / 100, timeline: 3, autoProjected: aSubFactors.some(f => f.type === 'auto'), subFactors: aSubFactors, notes: aSubFactors.filter(f => f.projected !== f.current).map(f => f.note).join(', ') || 'No changes' });
                    
                    // --- FACTOR B: EBITDA Quality ---
                    const factorB = currentFactors.B;
                    const currentBAdj = factorB?.adjustment || 0;
                    let projectedBAdj = currentBAdj;
                    const bSubFactors = [];
                    if (factorB) {
                      // B1: EBITDA Margins
                      const b1Current = factorB.subFactors?.B1?.score || 0;
                      const projB1 = calcB1(targetMargin);
                      bSubFactors.push({ name: 'EBITDA Margins', current: b1Current, projected: projB1,
                        type: projB1 !== b1Current ? 'auto' : 'static',
                        note: projB1 !== b1Current ? `Margin ${currentMargin.toFixed(0)}% → ${targetMargin}%` : 'No change' });
                      
                      // B2: Margin Stability
                      const b2Current = factorB.subFactors?.B2?.score || 0;
                      const projB2 = (blueprintImpliesGrowth && targetMargin > currentMargin) ? 0.15 : Math.max(b2Current, 0);
                      bSubFactors.push({ name: 'Margin Stability', current: b2Current, projected: projB2,
                        type: projB2 !== b2Current ? 'auto' : 'static',
                        note: projB2 !== b2Current ? 'Improving trend' : 'No change' });
                      
                      // B4: Negative Months
                      const b4Current = factorB.subFactors?.B4?.score || 0;
                      const projB4 = targetMargin >= 10 ? 0 : b4Current;
                      bSubFactors.push({ name: 'Negative Months', current: b4Current, projected: projB4,
                        type: projB4 !== b4Current ? 'auto' : 'static',
                        note: projB4 !== b4Current ? 'Eliminated at target margin' : (b4Current === 0 ? 'None' : 'Persists') });
                      
                      projectedBAdj = Math.round(bSubFactors.reduce((s, f) => s + f.projected, 0) * 100) / 100;
                    }
                    factorProjections.push({ key: 'B', name: 'EBITDA Quality', current: currentBAdj, projected: projectedBAdj, improvement: Math.round((projectedBAdj - currentBAdj) * 100) / 100, timeline: 3, autoProjected: bSubFactors.some(f => f.type === 'auto'), subFactors: bSubFactors, notes: bSubFactors.filter(f => f.projected !== f.current).map(f => f.note).join(', ') || 'No changes' });
                    
                    // --- FACTOR C: Customer Retention ---
                    const currentCAdj = currentFactors.C?.adjustment || 0;
                    const projectedCAdj = currentCAdj + bpRetentionBonus;
                    factorProjections.push({ key: 'C', name: 'Customer Retention', current: currentCAdj, projected: Math.round(projectedCAdj * 100) / 100, improvement: Math.round(bpRetentionBonus * 100) / 100, timeline: 2, autoProjected: false, notes: bpRetentionBonus > 0 ? `Retention target ${targetRetention.toFixed(0)}%` : 'Using current' });
                    
                    // --- FACTOR D: Contract Terms ---
                    const currentDAdj = currentFactors.D?.adjustment || 0;
                    const projectedDAdj = currentDAdj + bpContractBonus;
                    const dNotes = [];
                    if (simContractImprovements.extendTerms) dNotes.push('Extend terms');
                    if (simContractImprovements.addAutoRenewal) dNotes.push('Auto-renewal');
                    if (simContractImprovements.addEscalators) dNotes.push('Price escalators');
                    if (simContractImprovements.addTermPenalty) dNotes.push('Early termination penalty');
                    factorProjections.push({ key: 'D', name: 'Contract Terms', current: currentDAdj, projected: Math.round(projectedDAdj * 100) / 100, improvement: Math.round(bpContractBonus * 100) / 100, timeline: 1, autoProjected: false, notes: dNotes.join(', ') || 'No changes planned' });
                    
                    // --- FACTOR E: Concentration Risk ---
                    const factorE = currentFactors.E;
                    const currentEAdj = factorE?.adjustment || 0;
                    let projectedEAdj = currentEAdj;
                    const eSubFactors = [];
                    const estTargetRev = targetMargin > 0 ? (targetVal / 4) / (targetMargin / 100) : currentRevenue * 3;
                    if (currentRevenue > 0 && (estTargetRev > currentRevenue || targetTopCustPct > 0) && (currentTopCustRev > 0 || targetTopCustPct > 0)) {
                      // Use the better of: auto-dilution from growth, or slider target
                      const autoProjTopPct = estTargetRev > currentRevenue ? (currentTopCustRev / estTargetRev) * 100 : currentTopCustPct;
                      const autoProjTop5Pct = estTargetRev > currentRevenue ? (currentTop5Rev / estTargetRev) * 100 : currentTop5Pct;
                      // If slider is set, use the lower (better) concentration
                      const finalProjTopPct = (targetTopCustPct > 0 && targetTopCustPct < currentTopCustPct) ? 
                        Math.min(autoProjTopPct, targetTopCustPct) : autoProjTopPct;
                      const finalProjTop5Pct = (targetTopCustPct > 0 && targetTopCustPct < currentTopCustPct) ?
                        Math.min(autoProjTop5Pct, targetTopCustPct * 3) : autoProjTop5Pct; // rough top5 estimate from slider
                      
                      const currentE1 = factorE?.subFactors?.E1?.score || calcE1(currentTopCustPct, currentTop5Pct);
                      const projectedE1 = calcE1(finalProjTopPct, finalProjTop5Pct);
                      const e1IsSlider = targetTopCustPct > 0 && targetTopCustPct < autoProjTopPct;
                      eSubFactors.push({ name: 'Customer Concentration', current: currentE1, projected: projectedE1,
                        type: projectedE1 !== currentE1 ? (e1IsSlider ? 'slider' : 'auto') : 'static',
                        note: projectedE1 !== currentE1 ? `Top ${currentTopCustPct.toFixed(0)}%→${finalProjTopPct.toFixed(0)}%, Top5 ${currentTop5Pct.toFixed(0)}%→${finalProjTop5Pct.toFixed(0)}%` : 'No change' });
                      
                      const currentE1b = factorE?.subFactors?.E1b?.score || 0;
                      const projectedE1b = (bpContractBonus > 0 || currentDAdj >= 0) ? Math.max(currentE1b, 0) : currentE1b;
                      eSubFactors.push({ name: 'Top 5 Contract Status', current: currentE1b, projected: projectedE1b,
                        type: projectedE1b !== currentE1b ? 'auto' : 'static',
                        note: projectedE1b !== currentE1b ? 'Contracts improved' : 'No change' });
                      
                      const currentE2 = factorE?.subFactors?.E2?.score || 0;
                      eSubFactors.push({ name: 'Industry Concentration', current: currentE2, projected: currentE2, type: 'static', note: 'Static' });
                      
                      const currentE3 = factorE?.subFactors?.E3?.score || 0;
                      eSubFactors.push({ name: 'Vendor Concentration', current: currentE3, projected: currentE3, type: 'static', note: 'Static' });
                      
                      const currentE4 = factorE?.subFactors?.E4?.score || 0;
                      const projClientCount = Math.round(currentClientCount * Math.pow(Math.max(estTargetRev, currentRevenue) / currentRevenue, 0.5));
                      const projE4 = projClientCount >= 200 ? 0.2 : projClientCount >= 100 ? 0.15 : projClientCount >= 50 ? 0.1 : projClientCount >= 20 ? 0.05 : currentE4;
                      const gatedProjE4 = finalProjTop5Pct <= 40 ? projE4 : Math.min(projE4, 0);
                      eSubFactors.push({ name: 'Client Diversification', current: currentE4, projected: gatedProjE4,
                        type: gatedProjE4 !== currentE4 ? 'auto' : 'static',
                        note: gatedProjE4 !== currentE4 ? `${currentClientCount}→~${projClientCount} clients` : 'No change' });
                      
                      projectedEAdj = Math.round(eSubFactors.reduce((s, f) => s + f.projected, 0) * 100) / 100;
                    }
                    factorProjections.push({ key: 'E', name: 'Concentration Risk', current: currentEAdj, projected: Math.round(projectedEAdj * 100) / 100, improvement: Math.round((projectedEAdj - currentEAdj) * 100) / 100, timeline: 4, autoProjected: eSubFactors.some(f => f.type === 'auto'), subFactors: eSubFactors, notes: eSubFactors.filter(f => f.projected !== f.current).map(f => f.note).join(', ') || 'No changes' });
                    
                    // --- FACTOR H: Owner Continuity ---
                    const currentHAdj = currentFactors.H?.adjustment || 0;
                    factorProjections.push({ key: 'H', name: 'Owner Continuity', current: currentHAdj, projected: currentHAdj, improvement: 0, timeline: 0, autoProjected: false, notes: 'Determined at exit' });
                    
                    // --- FACTOR I: Other Adjustments ---
                    const currentIAdj = currentFactors.I?.adjustment || 0;
                    factorProjections.push({ key: 'I', name: 'Other Adjustments', current: currentIAdj, projected: currentIAdj, improvement: 0, timeline: 0, autoProjected: false, notes: 'Static' });
                    
                    // --- FACTOR J: Owner Dependency ---
                    const currentJAdj = currentFactors.J?.adjustment || 0;
                    const jFactorData = currentFactors.J || {};
                    let projectedJAdj = currentJAdj;
                    let jNotes = 'No changes planned';
                    if (simContractImprovements.reduceOwnerDependency) {
                      // Project what score looks like after owner delegates:
                      // Hire ops manager → owner goes from full-time to 20hrs/week, revenue dependency <30%
                      // That scores: 20hrs + <30% rev = 0.00x (neutral operations role)
                      // If currently very negative (-0.50x), improvement is significant
                      projectedJAdj = currentJAdj <= -0.50 ? 0 : 
                                      currentJAdj <= -0.25 ? 0.25 : 
                                      currentJAdj < 0.50 ? 0.50 : currentJAdj;
                      const hrs = jFactorData.parsedHours;
                      const revPct = jFactorData.parsedRevenuePct;
                      jNotes = `Hire & delegate: ${hrs ? `${hrs}→20 hrs/wk` : ''}${hrs && revPct > 30 ? ', ' : ''}${revPct > 30 ? `${revPct}%→<30% owner revenue` : ''}`;
                    }
                    const jImprovement = Math.round((projectedJAdj - currentJAdj) * 100) / 100;
                    factorProjections.push({ key: 'J', name: 'Owner Dependency', current: currentJAdj, projected: projectedJAdj, improvement: jImprovement, timeline: 3, autoProjected: false, notes: jNotes });
                    
                    // --- FACTOR G: A/R & Collections Quality ---
                    const currentGAdj = currentFactors.G?.adjustment || 0;
                    const gImprovement = simContractImprovements.improveAR ? 0.15 : 0;
                    factorProjections.push({ key: 'G', name: 'A/R & Collections', current: currentGAdj, projected: Math.round((currentGAdj + gImprovement) * 100) / 100, improvement: Math.round(gImprovement * 100) / 100, timeline: 1, autoProjected: false, notes: gImprovement > 0 ? 'Improve AR collections' : 'No changes planned' });
                    
                    // --- FACTOR K: Franchise ---
                    const currentKAdj = currentFactors.K?.adjustment || 0;
                    factorProjections.push({ key: 'K', name: 'Franchise', current: currentKAdj, projected: currentKAdj, improvement: 0, timeline: 0, autoProjected: false, notes: 'Static' });
                    
                    // Calculate totals
                    const totalCurrentQuality = factorProjections.reduce((s, f) => s + f.current, 0);
                    const totalProjectedQuality = factorProjections.reduce((s, f) => s + f.projected, 0);
                    const totalQualityImprovement = Math.round((totalProjectedQuality - totalCurrentQuality) * 100) / 100;
                    const hasImprovements = factorProjections.some(f => Math.abs(f.improvement) > 0.001);
                    
                    // Year-aware quality adjustment interpolation
                    // Each factor phases in over its timeline
                    const getQualityAtYear = (year, years) => {
                      return factorProjections.reduce((sum, f) => {
                        if (f.timeline <= 0 || f.improvement === 0) return sum + f.current;
                        const factorProgress = Math.min(1, year / f.timeline);
                        return sum + f.current + (f.improvement * factorProgress);
                      }, 0);
                    };
                    
                    // Estimate future multiple based on EBITDA size tier + year-specific quality
                    const estimateMultiple = (ebitda, year = null, years = null) => {
                      let m = baseMultipleTable[0]?.multiple || 3.0;
                      for (let i = 0; i < baseMultipleTable.length - 1; i++) {
                        if (ebitda >= baseMultipleTable[i].ebitda && ebitda < baseMultipleTable[i + 1].ebitda) {
                          const range = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
                          const mRange = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
                          m = baseMultipleTable[i].multiple + (mRange * ((ebitda - baseMultipleTable[i].ebitda) / range));
                          break;
                        }
                        if (ebitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) {
                          m = baseMultipleTable[baseMultipleTable.length - 1].multiple;
                        }
                      }
                      // Use year-specific quality if year provided, otherwise use exit quality
                      const qa = (year !== null && years !== null) ? getQualityAtYear(year, years) : totalProjectedQuality;
                      const calculated = m + qa;
                      // Floor applies in early years (business has value even with bad scores)
                      // but NOT on exit year — exit shows the calculated result of their improvements
                      const isExitYear = (year !== null && years !== null && year >= years);
                      if (isExitYear) return Math.max(0, calculated);
                      const floor = multipleEngineCalcs.getFloorMultiple ? multipleEngineCalcs.getFloorMultiple(ebitda) : 0;
                      return Math.max(floor, calculated);
                    };
                    
                    // Iterative solve: find EBITDA where EBITDA * multiple(EBITDA) >= targetVal (at exit year)
                    let requiredEbitda = targetVal > 0 ? targetVal / 5 : 0;
                    for (let iter = 0; iter < 20 && targetVal > 0; iter++) {
                      const estMult = estimateMultiple(requiredEbitda, timelineYrs, timelineYrs); // Exit year = no floor
                      if (estMult <= 0) break;
                      const newEst = targetVal / estMult;
                      if (Math.abs(newEst - requiredEbitda) < 1000) break;
                      requiredEbitda = (requiredEbitda + newEst) / 2;
                    }
                    requiredEbitda = Math.round(requiredEbitda);
                    const projectedMultiple = estimateMultiple(requiredEbitda, timelineYrs, timelineYrs); // Exit year = no floor
                    const requiredRevenue = targetMargin > 0 ? Math.round(requiredEbitda / (targetMargin / 100)) : 0;
                    
                    // CAGR calculations
                    const revenueCAGR = (currentRevenue > 0 && requiredRevenue > 0 && timelineYrs > 0) ?
                      (Math.pow(requiredRevenue / currentRevenue, 1 / timelineYrs) - 1) * 100 : 0;
                    const ebitdaCAGR = (currentEbitda > 0 && requiredEbitda > 0 && timelineYrs > 0) ?
                      (Math.pow(requiredEbitda / currentEbitda, 1 / timelineYrs) - 1) * 100 : 0;
                    
                    // At historical growth rate, when do we hit target?
                    const yearsAtCurrentGrowth = (avgHistoricalGrowth > 0 && currentRevenue > 0 && requiredRevenue > currentRevenue) ?
                      Math.log(requiredRevenue / currentRevenue) / Math.log(1 + avgHistoricalGrowth / 100) : null;
                    
                    // Year-by-year projections with year-specific multiples
                    const generateProjections = (startRev, startEbitda, startMargin, targetRev, targetMarg, years) => {
                      const projections = [];
                      for (let y = 0; y <= years; y++) {
                        const progress = years > 0 ? y / years : 0;
                        const rev = startRev * Math.pow(targetRev / Math.max(1, startRev), progress);
                        const margin = startMargin + (targetMarg - startMargin) * progress;
                        const ebitda = rev * (margin / 100);
                        const mult = estimateMultiple(ebitda, y, years); // Year-specific quality!
                        const valuation = ebitda * mult;
                        projections.push({
                          year: y,
                          revenue: Math.round(rev),
                          margin: Math.round(margin * 10) / 10,
                          ebitda: Math.round(ebitda),
                          multiple: Math.round(mult * 100) / 100,
                          valuation: Math.round(valuation)
                        });
                      }
                      return projections;
                    };
                    
                    const targetPath = (targetVal > 0 && timelineYrs > 0) ? 
                      generateProjections(currentRevenue, currentEbitda, currentMargin, requiredRevenue, targetMargin, timelineYrs) : [];
                    
                    const currentTrajectory = (avgHistoricalGrowth > 0 && timelineYrs > 0) ?
                      generateProjections(currentRevenue, currentEbitda, currentMargin, currentRevenue * Math.pow(1 + avgHistoricalGrowth / 100, timelineYrs), currentMargin, timelineYrs) : [];
                    
                    // Size tier milestones
                    const sizeTierMilestones = (baseMultipleTable || []).filter(t => t.ebitda > currentEbitda && t.ebitda <= (requiredEbitda * 1.2)).map(t => ({
                      ebitda: t.ebitda,
                      multiple: t.multiple,
                      label: `${formatCurrency(t.ebitda)} EBITDA → ${t.multiple.toFixed(1)}x base`
                    })).slice(-3); // Only show the last 3 tiers closest to target (most meaningful)
                    
                    const hasInputs = targetVal > 0 && timelineYrs > 0;
                    
                    // Export Blueprint as printable HTML
                    
                    return (
                      <div>
                        {/* Input Section */}
                        <div className="bg-gray-50 p-4 rounded-lg border mb-4">
                          <div className="flex justify-between items-start mb-3">
                            <div></div>
                            {hasInputs && (
                              <button onClick={() => { setExportOptions(prev => ({...prev, blueprintReport: true})); setShowExportModal(true); }} className="px-3 py-1.5 bg-green-700 text-white text-xs font-semibold rounded hover:bg-green-800 flex items-center gap-1">
                                <FileText className="w-3 h-3" /> Export Reports
                              </button>
                            )}
                          </div>
                          <div className="grid grid-cols-3 gap-4">
                            <div>
                              <label className="block text-sm font-semibold text-gray-700 mb-1">Target Exit Valuation</label>
                              <div className="flex items-center gap-1">
                                <span className="text-gray-500">$</span>
                                <input type="text" defaultValue={blueprintTargetValuation ? blueprintTargetValuation.toLocaleString() : ''} onBlur={e => { const num = Number(e.target.value.replace(/[^0-9.-]/g, '')); setBlueprintTargetValuation(num > 0 ? num : null); e.target.value = num > 0 ? num.toLocaleString() : ''; }} className="w-full p-2 border rounded text-sm font-bold" placeholder="e.g., 15,000,000" />
                              </div>
                              {currentValuationHigh > 0 && <div className="text-xs text-gray-500 mt-1">Current: {formatCurrency(currentValuationHigh)}</div>}
                            </div>
                            <div>
                              <label className="block text-sm font-semibold text-gray-700 mb-1">Timeline (years)</label>
                              <input type="number" step="1" min="1" max="20" defaultValue={blueprintTimelineYears || ''} onBlur={e => setBlueprintTimelineYears(e.target.value ? Number(e.target.value) : null)} className="w-full p-2 border rounded text-sm font-bold" placeholder="e.g., 10" />
                              {yearsAtCurrentGrowth && hasInputs && <div className="text-xs text-amber-600 mt-1">At current growth: ~{Math.ceil(yearsAtCurrentGrowth)} years</div>}
                            </div>
                            <div>
                              <label className="block text-sm font-semibold text-gray-700 mb-1">Target EBITDA Margin (%)</label>
                              <input type="number" step="1" min="5" max="40" defaultValue={blueprintTargetMargin || ''} onBlur={e => setBlueprintTargetMargin(e.target.value ? Number(e.target.value) : null)} className="w-full p-2 border rounded text-sm font-bold" placeholder={`Current: ${currentMargin.toFixed(1)}%`} />
                              <div className="text-xs text-gray-500 mt-1">Current: {currentMargin.toFixed(1)}% | Industry: {currentBenchmarks?.ebitdaMargin || 18}%</div>
                            </div>
                          </div>
                        </div>
                        
                        {hasInputs && (
                          <>
                            {/* Quality improvement indicator */}
                            {hasImprovements && (
                              <div className="mb-3 p-2 bg-green-50 border border-green-200 rounded-lg text-xs text-green-700 flex items-center gap-2">
                                <span>✓</span> <span>Blueprint projects quality: <strong>{totalCurrentQuality >= 0 ? '+' : ''}{totalCurrentQuality.toFixed(2)}x</strong> today → <strong>{totalProjectedQuality >= 0 ? '+' : ''}{totalProjectedQuality.toFixed(2)}x</strong> at exit (<strong>+{totalQualityImprovement.toFixed(2)}x</strong> across {factorProjections.filter(f => f.improvement > 0.001).length} factors)</span>
                              </div>
                            )}
                            {!hasImprovements && (
                              <div className="mb-3 p-2 bg-gray-50 border border-gray-200 rounded-lg text-xs text-gray-500 flex items-center gap-2">
                                <span>💡</span> <span>Adjust the sliders above (recurring revenue, retention, contracts, etc.) to model additional quality improvements</span>
                              </div>
                            )}
                            <div className="grid grid-cols-4 gap-3 mb-4">
                              <div className="bg-white p-3 rounded-lg border text-center">
                                <div className="text-xs text-gray-500">Required EBITDA</div>
                                <div className="text-xl font-bold text-gray-800">{formatCurrency(requiredEbitda)}</div>
                                <div className="text-xs text-gray-400">from {formatCurrency(currentEbitda)}</div>
                              </div>
                              <div className="bg-white p-3 rounded-lg border text-center">
                                <div className="text-xs text-gray-500">Required Revenue</div>
                                <div className="text-xl font-bold text-gray-800">{formatCurrency(requiredRevenue)}</div>
                                <div className="text-xs text-gray-400">from {formatCurrency(currentRevenue)}</div>
                              </div>
                              <div className="bg-white p-3 rounded-lg border text-center">
                                <div className="text-xs text-gray-500">Projected Multiple</div>
                                <div className="text-xl font-bold text-gray-800">{projectedMultiple.toFixed(2)}x</div>
                                <div className="text-xs text-gray-400">from {currentMultipleHigh.toFixed(2)}x</div>
                                {hasImprovements && <div className="text-xs text-green-600 mt-0.5">includes +{totalQualityImprovement.toFixed(2)}x quality improvement</div>}
                              </div>
                              <div className={`p-3 rounded-lg border text-center ${revenueCAGR <= avgHistoricalGrowth * 1.2 ? 'bg-green-50 border-green-300' : revenueCAGR <= avgHistoricalGrowth * 2 ? 'bg-amber-50 border-amber-300' : 'bg-red-50 border-red-300'}`}>
                                <div className="text-xs text-gray-500">Required Revenue CAGR</div>
                                <div className="text-xl font-bold">{revenueCAGR.toFixed(1)}%</div>
                                <div className="text-xs text-gray-400">historical: {avgHistoricalGrowth.toFixed(1)}%</div>
                              </div>
                            </div>
                            
                            {/* Value Growth Breakdown */}
                            <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 mb-4">
                              <div className="text-sm font-semibold text-blue-800 mb-2">Where Does the Value Come From?</div>
                              <div className="grid grid-cols-3 gap-4 text-sm">
                                <div>
                                  <div className="text-xs text-blue-600 font-medium">Revenue Growth</div>
                                  <div className="font-bold">{formatCurrency(currentRevenue)} → {formatCurrency(requiredRevenue)}</div>
                                  <div className="text-xs text-gray-500">{((requiredRevenue / Math.max(1, currentRevenue) - 1) * 100).toFixed(0)}% total growth ({revenueCAGR.toFixed(1)}% CAGR)</div>
                                </div>
                                <div>
                                  <div className="text-xs text-blue-600 font-medium">Margin Expansion</div>
                                  <div className="font-bold">{currentMargin.toFixed(1)}% → {targetMargin}%</div>
                                  <div className="text-xs text-gray-500">+{(targetMargin - currentMargin).toFixed(1)} percentage points</div>
                                </div>
                                <div>
                                  <div className="text-xs text-blue-600 font-medium">Multiple Expansion</div>
                                  <div className="font-bold">{currentMultipleHigh.toFixed(2)}x → {projectedMultiple.toFixed(2)}x</div>
                                  <div className="text-xs text-gray-500">+{(projectedMultiple - currentMultipleHigh).toFixed(2)}x (size tier + {totalQualityImprovement > 0.001 ? `${totalQualityImprovement.toFixed(2)}x quality improvement` : 'quality factors'})</div>
                                </div>
                              </div>
                            </div>
                            
                            {/* Year-by-Year Milestone Table */}
                            <div className="mb-4">
                              <div className="text-sm font-bold text-gray-700 mb-2">Year-by-Year Milestones — Target Path</div>
                              <div className="overflow-x-auto">
                                <table className="w-full text-xs border-collapse">
                                  <thead>
                                    <tr className="bg-gray-700 text-white">
                                      <th className="p-2 border text-left">Year</th>
                                      <th className="p-2 border text-right">Revenue</th>
                                      <th className="p-2 border text-right">EBITDA Margin</th>
                                      <th className="p-2 border text-right">EBITDA</th>
                                      <th className="p-2 border text-right">Multiple</th>
                                      <th className="p-2 border text-right">Estimated Value</th>
                                      <th className="p-2 border text-center">Milestone</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {targetPath.map((p, idx) => {
                                      // Find size tier milestone at this year
                                      const tierHit = sizeTierMilestones.filter(t => 
                                        idx > 0 && p.ebitda >= t.ebitda && targetPath[idx - 1].ebitda < t.ebitda
                                      ).pop(); // Use last (highest) tier crossed if multiple in one year
                                      const isCurrentYear = idx === 0;
                                      const isFinalYear = idx === targetPath.length - 1;
                                      const pctToGoal = targetVal > 0 ? (p.valuation / targetVal * 100) : 0;
                                      
                                      return (
                                        <tr key={idx} className={`${isCurrentYear ? 'bg-gray-100 font-semibold' : isFinalYear ? 'bg-green-50 font-semibold' : idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                                          <td className="p-2 border font-medium">{isCurrentYear ? 'Today' : isFinalYear ? `Year ${p.year} (Exit)` : `Year ${p.year}`}</td>
                                          <td className="p-2 border text-right">{formatCurrency(p.revenue)}</td>
                                          <td className="p-2 border text-right">{p.margin.toFixed(1)}%</td>
                                          <td className="p-2 border text-right font-medium">{formatCurrency(p.ebitda)}</td>
                                          <td className="p-2 border text-right">{p.multiple.toFixed(2)}x</td>
                                          <td className={`p-2 border text-right font-medium ${isFinalYear ? 'text-green-700' : ''}`}>{formatCurrency(p.valuation)}</td>
                                          <td className="p-2 border text-center">
                                            {isCurrentYear && <span className="text-gray-500">Starting point</span>}
                                            {tierHit && <span className="text-blue-600 font-medium">📈 {tierHit.label}</span>}
                                            {isFinalYear && <span className="text-green-700 font-bold">🎯 Target</span>}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            
                            {/* Current Trajectory Comparison */}
                            {currentTrajectory.length > 0 && avgHistoricalGrowth > 0 && (
                              <div className="mb-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
                                <div className="text-sm font-semibold text-amber-800 mb-1">
                                  Current Trajectory Comparison
                                </div>
                                <div className="text-xs text-amber-700">
                                  At your historical growth rate of {avgHistoricalGrowth.toFixed(1)}% with no margin improvement:
                                </div>
                                <div className="grid grid-cols-3 gap-3 mt-2 text-sm">
                                  <div>
                                    <div className="text-xs text-amber-600">Year {timelineYrs} Revenue</div>
                                    <div className="font-bold text-amber-900">{formatCurrency(currentTrajectory[currentTrajectory.length - 1]?.revenue || 0)}</div>
                                    <div className="text-xs text-gray-500">vs target {formatCurrency(requiredRevenue)}</div>
                                  </div>
                                  <div>
                                    <div className="text-xs text-amber-600">Year {timelineYrs} EBITDA</div>
                                    <div className="font-bold text-amber-900">{formatCurrency(currentTrajectory[currentTrajectory.length - 1]?.ebitda || 0)}</div>
                                    <div className="text-xs text-gray-500">vs target {formatCurrency(requiredEbitda)}</div>
                                  </div>
                                  <div>
                                    <div className="text-xs text-amber-600">Year {timelineYrs} Valuation</div>
                                    <div className="font-bold text-amber-900">{formatCurrency(currentTrajectory[currentTrajectory.length - 1]?.valuation || 0)}</div>
                                    <div className="text-xs text-gray-500">vs target {formatCurrency(targetVal)}</div>
                                  </div>
                                </div>
                                {(currentTrajectory[currentTrajectory.length - 1]?.valuation || 0) < targetVal && (
                                  <div className="text-xs text-amber-700 mt-2 font-medium">
                                    ⚠️ Without changes, you'll reach {formatCurrency(currentTrajectory[currentTrajectory.length - 1]?.valuation || 0)} in {timelineYrs} years — 
                                    {formatCurrency(targetVal - (currentTrajectory[currentTrajectory.length - 1]?.valuation || 0))} short of your goal. 
                                    The gap must come from faster growth, higher margins, or both.
                                  </div>
                                )}
                              </div>
                            )}
                            
                            {/* Value Creation Levers */}
                            <div className="grid grid-cols-2 gap-3 mb-4">
                              {/* Revenue Growth */}
                              <div className="bg-white p-3 rounded-lg border">
                                <div className="text-sm font-bold text-gray-700 mb-2">📈 Revenue Growth Targets</div>
                                <div className="space-y-1 text-xs">
                                  <div className="flex justify-between"><span className="text-gray-600">Annual growth needed</span><span className="font-bold">{revenueCAGR.toFixed(1)}%</span></div>
                                  <div className="flex justify-between"><span className="text-gray-600">New revenue per year (avg)</span><span className="font-bold">{formatCurrency(timelineYrs > 0 ? (requiredRevenue - currentRevenue) / timelineYrs : 0)}</span></div>
                                  <div className="flex justify-between"><span className="text-gray-600">Historical growth rate</span><span className={`font-bold ${avgHistoricalGrowth >= revenueCAGR ? 'text-green-600' : 'text-amber-600'}`}>{avgHistoricalGrowth.toFixed(1)}%</span></div>
                                  <div className="flex justify-between"><span className="text-gray-600">Current recurring revenue</span><span className="font-bold">{recurringPct.toFixed(0)}%</span></div>
                                </div>
                              </div>
                              
                              {/* Margin Improvement */}
                              <div className="bg-white p-3 rounded-lg border">
                                <div className="text-sm font-bold text-gray-700 mb-2">💰 Margin Targets</div>
                                <div className="space-y-1 text-xs">
                                  <div className="flex justify-between"><span className="text-gray-600">Current EBITDA margin</span><span className="font-bold">{currentMargin.toFixed(1)}%</span></div>
                                  <div className="flex justify-between"><span className="text-gray-600">Target EBITDA margin</span><span className="font-bold">{targetMargin}%</span></div>
                                  <div className="flex justify-between"><span className="text-gray-600">Improvement needed</span><span className="font-bold text-green-600">+{(targetMargin - currentMargin).toFixed(1)} pts</span></div>
                                  <div className="flex justify-between"><span className="text-gray-600">Industry benchmark</span><span className="font-bold">{currentBenchmarks?.ebitdaMargin || 18}%</span></div>
                                </div>
                              </div>
                              
                              {/* Multiple Roadmap */}
                              <div className="bg-white p-3 rounded-lg border col-span-2">
                                <div className="text-sm font-bold text-gray-700 mb-3">⭐ Multiple Enhancement Roadmap</div>
                                <div className="grid grid-cols-2 gap-4">
                                  {/* Left: Size-Based Multiple */}
                                  <div>
                                    <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wider">Base Multiple (from EBITDA size)</div>
                                    <div className="space-y-1 text-xs">
                                      <div className="flex justify-between p-1.5 bg-gray-50 rounded"><span className="text-gray-600">Current base ({formatCurrency(currentEbitda)} EBITDA)</span><span className="font-bold">{multipleEngineCalcs.rawBaseMultiple.toFixed(1)}x</span></div>
                                      <div className="flex justify-between p-1.5 bg-green-50 rounded"><span className="text-green-700">Target base ({formatCurrency(requiredEbitda)} EBITDA)</span><span className="font-bold text-green-700">{(() => {
                                        let tb = baseMultipleTable[0]?.multiple || 3.0;
                                        for (let i = 0; i < baseMultipleTable.length - 1; i++) {
                                          if (requiredEbitda >= baseMultipleTable[i].ebitda && requiredEbitda < baseMultipleTable[i + 1].ebitda) {
                                            const r = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
                                            const mr = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
                                            tb = baseMultipleTable[i].multiple + (mr * ((requiredEbitda - baseMultipleTable[i].ebitda) / r));
                                            break;
                                          }
                                          if (requiredEbitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) tb = baseMultipleTable[baseMultipleTable.length - 1].multiple;
                                        }
                                        return tb.toFixed(1);
                                      })()}x</span></div>
                                    </div>
                                    {sizeTierMilestones.length > 0 && (
                                      <div className="mt-2 pt-2 border-t">
                                        <div className="text-xs font-medium text-gray-500 mb-1">Key milestones along the way:</div>
                                        {sizeTierMilestones.map((t, i) => (
                                          <div key={i} className="text-xs text-blue-600 py-0.5">📈 {t.label}</div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                  
                                  {/* Right: Factor-by-Factor Quality Projection */}
                                  <div>
                                    <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wider">Quality Adjustments — Factor Roadmap</div>
                                    <div className="space-y-0.5 text-xs">
                                      {/* Header */}
                                      <div className="flex items-center gap-1 p-1 bg-gray-100 rounded font-semibold text-gray-600">
                                        <div className="flex-1">Factor</div>
                                        <div className="w-14 text-right">Current</div>
                                        <div className="w-14 text-right">Target</div>
                                        <div className="w-14 text-right">Change</div>
                                      </div>
                                      {/* Factor rows with expandable sub-factors */}
                                      {factorProjections.filter(f => f.current !== 0 || f.projected !== 0 || f.improvement !== 0).map(f => (
                                        <div key={f.key}>
                                          {/* Main factor row */}
                                          <div className={`flex items-center gap-1 p-1 rounded ${f.improvement > 0.001 ? 'bg-green-50' : f.improvement < -0.001 ? 'bg-red-50' : 'bg-gray-50'} ${f.subFactors?.length > 0 ? 'cursor-pointer' : ''}`}
                                            onClick={() => f.subFactors?.length > 0 && setExpandedSections(prev => ({...prev, [`bp_${f.key}`]: !prev[`bp_${f.key}`]}))}
                                          >
                                            <div className="flex-1">
                                              <span className="font-medium">{f.subFactors?.length > 0 ? (expandedSections[`bp_${f.key}`] ? '▼' : '▶') : '•'} {f.name}</span>
                                              {f.improvement > 0.001 && !expandedSections[`bp_${f.key}`] && f.notes && <div className="text-[10px] text-gray-500 mt-0.5 ml-3">{f.notes}</div>}
                                            </div>
                                            <div className={`w-14 text-right font-mono ${f.current < 0 ? 'text-red-600' : f.current > 0 ? 'text-green-600' : 'text-gray-500'}`}>{f.current >= 0 ? '+' : ''}{f.current.toFixed(2)}x</div>
                                            <div className={`w-14 text-right font-mono ${f.projected < 0 ? 'text-red-600' : f.projected > 0 ? 'text-green-600' : 'text-gray-500'}`}>{f.projected >= 0 ? '+' : ''}{f.projected.toFixed(2)}x</div>
                                            <div className={`w-14 text-right font-mono font-bold ${f.improvement > 0.001 ? 'text-green-700' : f.improvement < -0.001 ? 'text-red-700' : 'text-gray-400'}`}>{f.improvement > 0 ? '+' : ''}{f.improvement !== 0 ? f.improvement.toFixed(2) + 'x' : '—'}</div>
                                          </div>
                                          {/* Sub-factor rows */}
                                          {f.subFactors?.length > 0 && expandedSections[`bp_${f.key}`] && (
                                            <div className="ml-3 border-l-2 border-gray-200 pl-2 mb-1">
                                              {f.subFactors.map((sf, si) => {
                                                const changed = Math.abs(sf.projected - sf.current) > 0.001;
                                                return (
                                                  <div key={si} className={`flex items-center gap-1 py-0.5 px-1 text-[11px] ${changed ? 'bg-green-50/50' : ''}`}>
                                                    <div className="flex-1">
                                                      <span className="text-gray-700">{sf.name}</span>
                                                      {sf.type === 'auto' && <span className="ml-1 text-[9px] bg-blue-100 text-blue-700 px-1 rounded">📈 auto</span>}
                                                      {sf.type === 'slider' && <span className="ml-1 text-[9px] bg-green-100 text-green-700 px-1 rounded">🎯 target</span>}
                                                      {changed && <div className="text-[9px] text-gray-400 mt-0.5">{sf.note}</div>}
                                                    </div>
                                                    <div className={`w-14 text-right font-mono ${sf.current < 0 ? 'text-red-500' : sf.current > 0 ? 'text-green-500' : 'text-gray-400'}`}>{sf.current >= 0 ? '+' : ''}{sf.current.toFixed(2)}</div>
                                                    <div className={`w-14 text-right font-mono ${sf.projected < 0 ? 'text-red-500' : sf.projected > 0 ? 'text-green-500' : 'text-gray-400'}`}>{sf.projected >= 0 ? '+' : ''}{sf.projected.toFixed(2)}</div>
                                                    <div className={`w-14 text-right font-mono ${changed ? 'text-green-600 font-semibold' : 'text-gray-300'}`}>{changed ? `+${(sf.projected - sf.current).toFixed(2)}` : '—'}</div>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                      {/* Totals */}
                                      <div className="flex items-center gap-1 p-1.5 border-t-2 border-gray-300 font-semibold">
                                        <div className="flex-1">Total Quality Adjustment</div>
                                        <div className={`w-14 text-right font-mono ${totalCurrentQuality < 0 ? 'text-red-600' : 'text-green-600'}`}>{totalCurrentQuality >= 0 ? '+' : ''}{totalCurrentQuality.toFixed(2)}x</div>
                                        <div className={`w-14 text-right font-mono ${totalProjectedQuality < 0 ? 'text-red-600' : 'text-green-600'}`}>{totalProjectedQuality >= 0 ? '+' : ''}{totalProjectedQuality.toFixed(2)}x</div>
                                        <div className={`w-14 text-right font-mono font-bold ${totalQualityImprovement > 0 ? 'text-green-700' : 'text-gray-400'}`}>{totalQualityImprovement > 0 ? '+' : ''}{totalQualityImprovement.toFixed(2)}x</div>
                                      </div>
                                    </div>
                                    
                                    {/* Projected Total Multiple */}
                                    <div className="mt-3 pt-2 border-t">
                                      <div className="flex justify-between text-xs p-1.5 bg-gray-700 text-white rounded font-semibold">
                                        <span>Projected Exit Multiple</span>
                                        <span>{projectedMultiple.toFixed(2)}x</span>
                                      </div>
                                      <div className="text-[10px] text-gray-400 mt-1 text-right">
                                        {(() => {
                                          let tb = baseMultipleTable[0]?.multiple || 3.0;
                                          for (let i = 0; i < baseMultipleTable.length - 1; i++) {
                                            if (requiredEbitda >= baseMultipleTable[i].ebitda && requiredEbitda < baseMultipleTable[i + 1].ebitda) {
                                              const r = baseMultipleTable[i + 1].ebitda - baseMultipleTable[i].ebitda;
                                              const mr = baseMultipleTable[i + 1].multiple - baseMultipleTable[i].multiple;
                                              tb = baseMultipleTable[i].multiple + (mr * ((requiredEbitda - baseMultipleTable[i].ebitda) / r));
                                              break;
                                            }
                                            if (requiredEbitda >= baseMultipleTable[baseMultipleTable.length - 1].ebitda) tb = baseMultipleTable[baseMultipleTable.length - 1].multiple;
                                          }
                                          const calculated = tb + totalProjectedQuality;
                                          const floor = multipleEngineCalcs.getFloorMultiple ? multipleEngineCalcs.getFloorMultiple(requiredEbitda) : 0;
                                          const floorActive = calculated < floor && requiredEbitda > 0;
                                          return floorActive 
                                            ? `= ${tb.toFixed(1)}x base + (${totalProjectedQuality >= 0 ? '+' : ''}${totalProjectedQuality.toFixed(2)}x) quality = ${calculated.toFixed(2)}x → floor ${floor.toFixed(1)}x applied`
                                            : `= ${tb.toFixed(1)}x base + (${totalProjectedQuality >= 0 ? '+' : ''}${totalProjectedQuality.toFixed(2)}x) projected quality`;
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                            </div>
                            
                            {/* 6-Month Review Scoreboard */}
                            <div className="bg-gray-700 text-white p-4 rounded-lg">
                              <div className="text-sm font-bold mb-2">📊 6-Month / 12-Month Review Scoreboard</div>
                              <div className="text-xs opacity-90 mb-3">Track these metrics at every review meeting. Green = on pace. Amber = falling behind. Red = off track.</div>
                              <div className="grid grid-cols-5 gap-2 text-center text-xs">
                                {['Revenue', 'EBITDA Margin', 'EBITDA', 'Top Client %', 'Recurring %'].map((metric, i) => {
                                  const yr1 = targetPath[1];
                                  const targets = yr1 ? [
                                    formatCurrency(yr1.revenue),
                                    `${yr1.margin.toFixed(1)}%`,
                                    formatCurrency(yr1.ebitda),
                                    `<15%`,
                                    `>${(currentBenchmarks?.recurringRevenuePct || 65)}%`
                                  ] : ['—','—','—','—','—'];
                                  return (
                                    <div key={i} className="bg-gray-600 rounded p-2">
                                      <div className="opacity-75 mb-1">{metric}</div>
                                      <div className="font-bold text-green-300">{targets[i]}</div>
                                      <div className="opacity-50 text-[10px]">Year 1 target</div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </>
                        )}
                        
                        {!hasInputs && (
                          <div className="text-center py-8 text-gray-500">
                            <div className="text-4xl mb-3">🎯</div>
                            <div className="text-lg font-medium mb-1">Set Your Exit Goal</div>
                            <div className="text-sm">Enter a target valuation and timeline above to generate your strategic roadmap.</div>
                            <div className="text-xs mt-2 text-gray-400">Current valuation: {formatCurrency(currentValuationHigh)} | Current EBITDA: {formatCurrency(currentEbitda)}</div>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
            )}
            
            {reviewSection === 'sba' && (
              <div>
                {/* Vista Header */}
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-300">
                  <img src={vistaLogoBase64} alt="Vista Business Group" className="h-10" onError={(e) => e.target.style.display = 'none'} />
                  <div>
                    <div className="text-base font-bold text-gray-800">SBA Debt Coverage Analysis</div>
                    <div className="text-xs text-gray-500">Evaluate buyer financing feasibility</div>
                  </div>
                </div>
                
                {/* Deal Structure & Loan Terms */}
                <div className="grid grid-cols-2 gap-4 mb-5">
                  <div>
                    <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                      Deal Structure
                    </div>
                    <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                      <table className="w-full text-sm">
                        <tbody>
                          <tr className="border-b border-gray-200">
                            <td className="py-2 font-medium">Deal Value (High)</td>
                            <td className="py-2 text-right font-bold text-gray-800">{formatCurrency(sbaAnalysis.dealValue)}</td>
                          </tr>
                          {sbaAnalysis.reOn && (
                            <tr className="border-b border-gray-200 bg-emerald-50 text-xs">
                              <td className="py-1 pl-4" colSpan="2">+ Real estate {formatCurrency(sbaAnalysis.reValue)} = package {formatCurrency(sbaAnalysis.packageValue)}; real estate loan {formatCurrency(sbaAnalysis.reLoan)} over {sbaParams.reTerm ?? 25} yrs = {formatCurrency(sbaAnalysis.reLoanPayment)}/yr (included in the payments below)</td>
                            </tr>
                          )}
                          <tr className="border-b border-gray-200 bg-gray-50">
                            <td className="py-2 pl-4">Buyer Down Payment</td>
                            <td className="py-2 text-right">
                              <div className="flex items-center justify-end gap-2">
                                <input type="number" value={sbaParams.downPaymentPct} onChange={e => setSbaParams({...sbaParams, downPaymentPct: Number(e.target.value)})} className="w-14 p-1 border border-gray-300 rounded text-right text-xs" />
                                <span className="text-xs">%</span>
                                <span className="font-medium w-24 text-right">{formatCurrency(sbaAnalysis.downPayment)}</span>
                              </div>
                            </td>
                          </tr>
                          <tr className="border-b border-gray-200">
                            <td className="py-2 pl-4">Seller Note</td>
                            <td className="py-2 text-right">
                              <div className="flex items-center justify-end gap-2">
                                <input type="number" value={sbaParams.sellerNotePct} onChange={e => setSbaParams({...sbaParams, sellerNotePct: Number(e.target.value)})} className="w-14 p-1 border border-gray-300 rounded text-right text-xs" />
                                <span className="text-xs">%</span>
                                <span className="font-medium w-24 text-right">{formatCurrency(sbaAnalysis.sellerNote)}</span>
                              </div>
                            </td>
                          </tr>
                          <tr className="bg-gray-100">
                            <td className="py-2 pl-4 font-medium">SBA Loan</td>
                            <td className="py-2 text-right">
                              <div className="flex items-center justify-end gap-2">
                                <span className="text-xs text-gray-500">{100 - sbaParams.downPaymentPct - sbaParams.sellerNotePct}%</span>
                                <span className="font-bold w-24 text-right">{formatCurrency(sbaAnalysis.sbaLoan)}</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div>
                    <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                      Loan Terms
                    </div>
                    <div className="border border-gray-300 border-t-0 rounded-b-lg bg-white overflow-hidden">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-2 text-left font-semibold text-gray-700">Loan</th>
                            <th className="p-2 text-center font-semibold text-gray-700">Rate</th>
                            <th className="p-2 text-center font-semibold text-gray-700">Term</th>
                            <th className="p-2 text-right font-semibold text-gray-700">Annual Pmt</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b border-gray-200 bg-gray-50">
                            <td className="p-2 font-medium">SBA Business Loan</td>
                            <td className="p-2 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <input type="number" step="0.25" value={sbaParams.sbaLoanRate} onChange={e => setSbaParams({...sbaParams, sbaLoanRate: Number(e.target.value)})} className="w-14 p-1 border border-gray-300 rounded text-right text-xs" />
                                <span className="text-xs">%</span>
                              </div>
                            </td>
                            <td className="p-2 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <input type="number" value={sbaParams.sbaLoanTerm} onChange={e => setSbaParams({...sbaParams, sbaLoanTerm: Number(e.target.value)})} className="w-12 p-1 border border-gray-300 rounded text-right text-xs" />
                                <span className="text-xs">yr</span>
                              </div>
                            </td>
                            <td className="p-2 text-right font-medium">{formatCurrency(sbaAnalysis.sbaLoanPayment)}</td>
                          </tr>
                          <tr className="border-b border-gray-200">
                            <td className="p-2 font-medium">Seller Carry Note</td>
                            <td className="p-2 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <input type="number" step="0.25" value={sbaParams.sellerNoteRate} onChange={e => setSbaParams({...sbaParams, sellerNoteRate: Number(e.target.value)})} className="w-14 p-1 border border-gray-300 rounded text-right text-xs" />
                                <span className="text-xs">%</span>
                              </div>
                            </td>
                            <td className="p-2 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <input type="number" value={sbaParams.sellerNoteTerm} onChange={e => setSbaParams({...sbaParams, sellerNoteTerm: Number(e.target.value)})} className="w-12 p-1 border border-gray-300 rounded text-right text-xs" />
                                <span className="text-xs">yr</span>
                              </div>
                            </td>
                            <td className="p-2 text-right font-medium">{formatCurrency(sbaAnalysis.sellerNotePayment)}</td>
                          </tr>
                          {sbaAnalysis.reOn && (
                            <tr className="border-b border-gray-200">
                              <td className="p-2 font-medium">Real Estate Loan</td>
                              <td className="p-2 text-center">{sbaParams.reRate ?? 7.0}%</td>
                              <td className="p-2 text-center">{sbaParams.reTerm ?? 25} yr</td>
                              <td className="p-2 text-right font-medium">{formatCurrency(sbaAnalysis.reLoanPayment)}</td>
                            </tr>
                          )}
                          <tr className="bg-gray-200 font-bold">
                            <td className="p-2" colSpan="3">Total Annual Payments</td>
                            <td className="p-2 text-right">{formatCurrency(sbaAnalysis.totalPayments)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Debt Coverage Calculation */}
                <div className="mb-5">
                  <div className="bg-gray-700 text-white px-4 py-2 rounded-t-lg font-semibold">
                    Term Debt Coverage Ratio (TDCR)
                  </div>
                  <div className="border border-gray-300 border-t-0 rounded-b-lg p-4 bg-white">
                    <div className="grid grid-cols-3 gap-4">
                      <div className="col-span-2">
                        <table className="w-full text-sm">
                          <tbody>
                            <tr className="border-b border-gray-200">
                              <td className="py-2 font-medium">{sbaAnalysis.maintCapex > 0 ? 'Normalized EBITDA after capex (free cash flow)' : 'Normalized EBITDA (TTM)'}</td>
                              <td className="py-2 text-right font-bold text-lg">{formatCurrency(sbaAnalysis.adjustedEbitda)}</td>
                            </tr>
                            {(sbaAnalysis.ownerManager || 0) > 0 && (
                            <tr className="border-b border-gray-200 bg-gray-50 text-xs text-gray-600">
                              <td className="py-1 pl-4 italic">Includes market-rate owner salary: {formatCurrency(sbaAnalysis.ownerManager)}</td>
                              <td></td>
                            </tr>
                            )}
                            {sbaAnalysis.reRentBack > 0 && (
                              <tr className="border-b border-gray-200"><td className="py-2 pl-4">+ Rent no longer paid (the buyer owns the real estate)</td><td className="py-2 text-right">{formatCurrency(sbaAnalysis.reRentBack)}</td></tr>
                            )}
                            <tr className="border-b border-gray-200 bg-gray-100">
                              <td className="py-2 font-medium">= Cash Available for Debt Service</td>
                              <td className="py-2 text-right font-bold">{formatCurrency(sbaAnalysis.cashAvailable)}</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-2 pl-4">Less: Total Annual Payments</td>
                              <td className="py-2 text-right text-gray-600">({formatCurrency(sbaAnalysis.totalPayments)})</td>
                            </tr>
                            <tr className={`font-bold ${sbaAnalysis.margin >= 0 ? 'bg-green-50' : 'bg-gray-100'}`}>
                              <td className="py-2">Margin (Annual Cash Flow)</td>
                              <td className={`py-2 text-right text-lg ${sbaAnalysis.margin >= 0 ? 'text-green-700' : 'text-gray-600'}`}>{formatCurrency(sbaAnalysis.margin)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="flex flex-col justify-center items-center">
                        <div className={`text-center p-4 rounded-lg border-2 ${sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.25 ? 'bg-green-50 border-green-400' : sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.0 ? 'bg-gray-100 border-gray-400' : 'bg-gray-100 border-gray-400'}`}>
                          <div className="text-xs text-gray-600 font-medium">TDCR</div>
                          <div className={`text-4xl font-bold ${sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.25 ? 'text-green-700' : 'text-gray-700'}`}>
                            {sbaAnalysis.tdcr ? sbaAnalysis.tdcr.toFixed(2) : 'N/A'}x
                          </div>
                          <div className="text-xs mt-1 text-gray-600">
                            {sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.25 ? 'Meets SBA requirement' : sbaAnalysis.tdcr && sbaAnalysis.tdcr >= 1.0 ? 'Marginal coverage' : 'Below requirement'}
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-2 text-center">
                          SBA requires ≥ 1.25x
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Key Notes */}
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <div className="font-semibold text-gray-800 mb-2">SBA Loan Guidelines</div>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• <strong>TDCR ≥ 1.25x</strong> is the standard SBA requirement for loan approval</li>
                    <li>• Deal structure: {sbaParams.downPaymentPct}% down payment + {sbaParams.sellerNotePct}% seller note + {100 - sbaParams.downPaymentPct - sbaParams.sellerNotePct}% SBA loan</li>
                    {(ownerCompensation.marketReplacement || 0) > 0 && <li>• Normalized EBITDA already includes market-rate owner salary of {formatCurrency(ownerCompensation.marketReplacement)}</li>}
                    <li>• Customer concentration &gt;20% may require additional scrutiny</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'proformapres' ? (
          /* ========== PRO FORMA PRESENTATION TAB ========== */
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold flex items-center gap-2">📊 Pro Forma Summary</h2>
              <div className="flex gap-2">
                <button
                  onClick={() => setViewMode('proformaanalysis')}
                  className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300"
                >
                  ← Back to Analysis
                </button>
              </div>
            </div>
            
            {!proFormaCalcs.hasProFormaData ? (
              <div className="p-8 text-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                <div className="text-gray-400 text-4xl mb-2">📊</div>
                <div className="text-gray-600 font-medium">No Pro Forma Data</div>
                <div className="text-gray-500 text-sm mt-1">
                  <button onClick={() => setViewMode('proforma')} className="text-blue-600 hover:underline">
                    Add pro forma adjustments
                  </button> to generate a summary.
                </div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* CIM-Ready Executive Summary */}
                <div className="border-2 border-blue-300 rounded-lg overflow-hidden">
                  <div className="bg-blue-600 text-white px-4 py-3">
                    <div className="font-bold text-lg">Pro Forma Financial Summary</div>
                    <div className="text-blue-100 text-sm">{dealProfile.businessName || 'Company'} • Combined Entity View</div>
                  </div>
                  
                  <div className="p-6 bg-white">
                    {/* Overview Cards */}
                    <div className="grid grid-cols-4 gap-4 mb-6">
                      <div className="bg-gray-50 p-4 rounded-lg text-center">
                        <div className="text-xs text-gray-500 uppercase tracking-wider">Historical TTM</div>
                        <div className="text-xl font-bold text-gray-700">{formatCurrency(proFormaCalcs.historicalTTMRevenue)}</div>
                        <div className="text-xs text-gray-400">Revenue</div>
                      </div>
                      <div className="bg-green-50 p-4 rounded-lg text-center border border-green-200">
                        <div className="text-xs text-green-600 uppercase tracking-wider">Pro Forma TTM</div>
                        <div className="text-xl font-bold text-green-700">{formatCurrency(proFormaCalcs.proFormaTTMRevenue)}</div>
                        <div className="text-xs text-green-500">Revenue (+{proFormaCalcs.historicalTTMRevenue > 0 ? ((proFormaCalcs.proFormaTTMRevenue / proFormaCalcs.historicalTTMRevenue - 1) * 100).toFixed(0) : 0}%)</div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg text-center">
                        <div className="text-xs text-gray-500 uppercase tracking-wider">Historical TTM</div>
                        <div className="text-xl font-bold text-gray-700">{formatCurrency(proFormaCalcs.historicalTTMEbitda)}</div>
                        <div className="text-xs text-gray-400">EBITDA</div>
                      </div>
                      <div className="bg-green-50 p-4 rounded-lg text-center border border-green-200">
                        <div className="text-xs text-green-600 uppercase tracking-wider">Pro Forma TTM</div>
                        <div className="text-xl font-bold text-green-700">{formatCurrency(proFormaCalcs.proFormaTTMEbitda)}</div>
                        <div className="text-xs text-green-500">EBITDA (+{proFormaCalcs.historicalTTMEbitda > 0 ? ((proFormaCalcs.proFormaTTMEbitda / proFormaCalcs.historicalTTMEbitda - 1) * 100).toFixed(0) : 0}%)</div>
                      </div>
                    </div>
                    
                    {/* Pro Forma Adjustments Table */}
                    <div className="mb-6">
                      <h3 className="font-bold text-gray-700 mb-3 border-b pb-2">Pro Forma Adjustments</h3>
                      <table className="w-full text-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-2 text-left">Description</th>
                            <th className="p-2 text-center">Type</th>
                            <th className="p-2 text-center">Effective</th>
                            <th className="p-2 text-right">Annual Revenue</th>
                            <th className="p-2 text-right">Annual EBITDA</th>
                            <th className="p-2 text-center">TTM Contribution</th>
                            <th className="p-2 text-center">Val. Credit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {proFormaCalcs.items?.filter(i => i.name).map((item, idx) => (
                            <tr key={item.id} className={idx % 2 === 0 ? '' : 'bg-gray-50'}>
                              <td className="p-2 font-medium">{item.name}</td>
                              <td className="p-2 text-center">
                                {item.type === 'acquisition' ? 'Acquisition' : 
                                 item.type === 'newclient' ? 'New Client' :
                                 item.type === 'lostclient' ? 'Lost Client' :
                                 item.type === 'pricechange' ? 'Price Change' : 'Other'}
                              </td>
                              <td className="p-2 text-center">{item.effectiveDate ? new Date(item.effectiveDate).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '—'}</td>
                              <td className="p-2 text-right">{formatCurrency(item.annualRevenue || 0)}</td>
                              <td className="p-2 text-right">{formatCurrency(item.annualEbitdaCalc || 0)}</td>
                              <td className="p-2 text-center">
                                <span className="text-green-700">+{formatCurrency(item.adjustedEbitda || 0)}</span>
                                <span className="text-xs text-gray-400 ml-1">({item.monthsInTTM}mo)</span>
                              </td>
                              <td className="p-2 text-center">
                                <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                                  item.valuationCredit === 100 ? 'bg-green-100 text-green-700' :
                                  item.valuationCredit >= 75 ? 'bg-blue-100 text-blue-700' :
                                  item.valuationCredit >= 50 ? 'bg-amber-100 text-amber-700' :
                                  'bg-red-100 text-red-700'
                                }`}>
                                  {item.valuationCredit}%
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="bg-gray-200 font-bold">
                          <tr>
                            <td colSpan="4" className="p-2 text-right">Total Additions</td>
                            <td className="p-2 text-right">{formatCurrency(proFormaCalcs.totalAnnualEbitda)}</td>
                            <td className="p-2 text-center text-green-700">+{formatCurrency(proFormaCalcs.totalProratedEbitda)}</td>
                            <td className="p-2 text-center text-gray-700">+{formatCurrency(proFormaCalcs.totalWeightedEbitda)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    
                    {/* Notes/Assumptions */}
                    <div className="mt-4 text-xs text-gray-500 border-t pt-3">
                      <strong>Assumptions & Notes:</strong>
                      <ul className="mt-1 space-y-0.5">
                        <li>• TTM Period: {proFormaCalcs.ttmPeriod?.label}</li>
                        <li>• Pro forma additions are prorated based on effective date within TTM period</li>
                        <li>• Retention adjustments applied per item (acquisition default: 85%, new client default: 90%)</li>
                        <li>• <strong>Valuation Credit:</strong> Weighted basis applies seasoning-based credit (acquisitions: 100%, new clients: 15-100% based on months active)</li>
                        {proFormaItems.filter(i => i.notes).map((item, idx) => (
                          <li key={idx}>• {item.name}: {item.notes}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                
                {/* Action Buttons */}
                <div className="flex justify-between items-center pt-4">
                  <button
                    onClick={() => setViewMode('proforma')}
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                  >
                    ← Edit Pro Forma Items
                  </button>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setViewMode('presentation')}
                      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      View Main Presentation →
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : viewMode === 'portfolio' ? (
          /* ========== PORTFOLIO CONSOLIDATION TAB ========== */
          <div>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-bold flex items-center gap-2">📁 Portfolio Consolidation</h2>
              <div className="flex gap-2">
                <label className="px-3 py-1 bg-blue-600 text-white text-sm rounded cursor-pointer hover:bg-blue-700">
                  + Add Entities
                  <input type="file" accept=".json" multiple className="hidden" onChange={loadPortfolioEntity} />
                </label>
                <button onClick={() => saveDeal()} disabled={portfolioEntities.length === 0} title="Saves the portfolio with this deal: reopening the deal brings it back." className={`px-3 py-1 text-sm rounded ${portfolioEntities.length === 0 ? 'bg-gray-200 text-gray-400' : 'bg-green-600 text-white hover:bg-green-700'}`}>
                  💾 Save Portfolio
                </button>
                <button onClick={savePortfolio} disabled={portfolioEntities.length === 0} title="Download a .json copy of the portfolio" className={`px-3 py-1 text-sm rounded ${portfolioEntities.length === 0 ? 'bg-gray-100 text-gray-300' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>
                  ⬇ Download
                </button>
                <label className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded cursor-pointer hover:bg-gray-300">
                  📂 Load Portfolio
                  <input type="file" accept=".json" className="hidden" onChange={loadPortfolio} />
                </label>
              </div>
            </div>
            
            {/* Purpose Banner */}
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="text-sm">
                <span className="font-semibold text-blue-800">🎯 Purpose:</span>{' '}
                <span className="text-blue-700">
                  Combine multiple businesses or divisions to show the value of selling as a package. 
                  Load each entity's saved valuation file, enter your combined assessment, and see the size premium.
                </span>
              </div>
            </div>
            
            {/* Portfolio Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Portfolio Name</label>
              <input
                type="text"
                value={portfolioSettings.portfolioName}
                onChange={e => setPortfolioSettings({...portfolioSettings, portfolioName: e.target.value})}
                className="w-64 p-2 border rounded"
                placeholder="e.g., 4 MSP Combined"
              />
            </div>
            
            {/* Entities Section */}
            <div className="bg-white border rounded-lg mb-6">
              <div className="p-3 bg-gray-100 border-b font-semibold text-gray-800">
                Entities ({portfolioEntities.length})
              </div>
              
              {portfolioEntities.length === 0 ? (
                <div className="p-8 text-center text-gray-500">
                  <div className="text-4xl mb-2">📁</div>
                  <div>No entities loaded</div>
                  <div className="text-sm mt-1">Click "+ Add Entities" to import saved valuation files</div>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-3 py-2 text-left font-semibold text-gray-600">Entity</th>
                        <th className="px-3 py-2 text-left font-semibold text-gray-600">TTM Period</th>
                        <th className="px-3 py-2 text-right font-semibold text-gray-600">Revenue</th>
                        <th className="px-3 py-2 text-right font-semibold text-gray-600">Adj. EBITDA</th>
                        <th className="px-3 py-2 text-right font-semibold text-gray-600">Customers</th>
                        <th className="px-3 py-2 text-right font-semibold text-gray-600">Top Cust %</th>
                        <th className="px-3 py-2 text-right font-semibold text-gray-600" title="Market High multiple from the valuation engine">Multiple</th>
                        <th className="px-3 py-2 text-right font-semibold text-gray-600">Standalone Value</th>
                        <th className="px-3 py-2 text-center font-semibold text-gray-600">Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {portfolioEntities.map(entity => (
                        <tr key={entity.id} className="border-t hover:bg-gray-50">
                          <td className="px-3 py-2 font-medium">
                            {entity.name}
                            {entity.usedEngineCalcs && <span className="ml-1 text-xs text-green-600" title="Using engine-calculated multiples">⚙️</span>}
                            {entity.usedPreCalc && !entity.usedEngineCalcs && <span className="ml-1 text-xs text-amber-500" title="Using manual multiples (older save format)">⚠️</span>}
                          </td>
                          <td className="px-3 py-2 text-gray-600">{entity.ttmPeriod}</td>
                          <td className="px-3 py-2 text-right">{formatCurrency(entity.revenue)}</td>
                          <td className="px-3 py-2 text-right">{formatCurrency(entity.adjustedEbitda)}</td>
                          <td className="px-3 py-2 text-right">{entity.customerCount}</td>
                          <td className="px-3 py-2 text-right">{entity.topCustomerPct.toFixed(1)}%</td>
                          <td className="px-3 py-2 text-right" title={entity.multipleMin !== entity.multipleMax ? `${entity.multipleMin?.toFixed(2)}x typical - ${entity.multipleMax?.toFixed(2)}x market high` : ''}>
                            {entity.multiple.toFixed(2)}x
                          </td>
                          <td className="px-3 py-2 text-right font-medium">{formatCurrency(entity.valuation)}</td>
                          <td className="px-3 py-2 text-center">
                            <button
                              onClick={() => setPortfolioEntities(prev => prev.filter(e => e.id !== entity.id))}
                              className="text-red-500 hover:text-red-700"
                              title="Remove entity"
                            >
                              ✕
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="bg-gray-100 font-semibold">
                      <tr>
                        <td className="px-3 py-2">TOTAL (Sum of Parts)</td>
                        <td className="px-3 py-2"></td>
                        <td className="px-3 py-2 text-right">{formatCurrency(portfolioCalcs.combined.revenue)}</td>
                        <td className="px-3 py-2 text-right">{formatCurrency(portfolioCalcs.combined.adjustedEbitda)}</td>
                        <td className="px-3 py-2 text-right">{portfolioCalcs.combined.customerCount}</td>
                        <td className="px-3 py-2 text-right">{portfolioCalcs.combined.topCustomerPct?.toFixed(1)}%</td>
                        <td className="px-3 py-2 text-right">-</td>
                        <td className="px-3 py-2 text-right">{formatCurrency(portfolioCalcs.sumOfPartsValue)}</td>
                        <td className="px-3 py-2"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
              
              {/* TTM Mismatch Warning */}
              {portfolioCalcs.ttmMismatch && (
                <div className="m-3 p-2 bg-amber-50 border border-amber-200 rounded text-amber-800 text-sm">
                  ⚠️ {portfolioCalcs.ttmWarning}
                </div>
              )}
              
              {/* Data source legend */}
              {portfolioEntities.length > 0 && (
                <div className="mx-3 mb-3 text-xs text-gray-500 flex gap-4">
                  <span>⚙️ = Engine-calculated multiples & EBITDA</span>
                  <span>⚠️ = Manual multiples (re-save file for engine data)</span>
                  {portfolioEntities.some(e => !e.usedPreCalc && !e.usedEngineCalcs) && (
                    <span className="text-amber-600">⚠️ Some entities were calculated from raw P&L data — results may differ from the valuation engine</span>
                  )}
                </div>
              )}
            </div>
            
            {portfolioEntities.length > 0 && (
              <>
                {/* Combined Assessment Section */}
                <div className="bg-white border rounded-lg mb-6">
                  <div className="p-3 bg-gray-100 border-b font-semibold text-gray-800 flex justify-between items-center">
                    <span>Combined Assessment</span>
                    <span className="text-xs font-normal text-gray-500">Your judgment for the combined entity</span>
                  </div>
                  <div className="p-4">
                    <div className="grid grid-cols-4 gap-4">
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">% B2B Customers</label>
                        <input
                          type="number"
                          value={portfolioAssessment.pctB2B}
                          onChange={e => setPortfolioAssessment({...portfolioAssessment, pctB2B: e.target.value})}
                          className="w-full p-2 border rounded text-sm"
                          placeholder="0-100"
                          min="0"
                          max="100"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Contract Coverage %</label>
                        <input
                          type="number"
                          value={portfolioAssessment.contractCoverage}
                          onChange={e => setPortfolioAssessment({...portfolioAssessment, contractCoverage: e.target.value})}
                          className="w-full p-2 border rounded text-sm"
                          placeholder="0-100"
                          min="0"
                          max="100"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Owner Dependency</label>
                        <select
                          value={portfolioAssessment.ownerDependency}
                          onChange={e => setPortfolioAssessment({...portfolioAssessment, ownerDependency: e.target.value})}
                          className="w-full p-2 border rounded text-sm"
                        >
                          <option value="">Select...</option>
                          <option value="low">Low (Runs independently)</option>
                          <option value="moderate">Moderate</option>
                          <option value="high">High (Owner-dependent)</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Management Depth</label>
                        <select
                          value={portfolioAssessment.managementDepth}
                          onChange={e => setPortfolioAssessment({...portfolioAssessment, managementDepth: e.target.value})}
                          className="w-full p-2 border rounded text-sm"
                        >
                          <option value="">Select...</option>
                          <option value="strong">Strong (Can absorb transition)</option>
                          <option value="adequate">Adequate</option>
                          <option value="weak">Weak (Needs development)</option>
                        </select>
                      </div>
                    </div>
                    <div className="mt-3">
                      <label className="block text-xs font-medium text-gray-600 mb-1">Notes</label>
                      <textarea
                        value={portfolioAssessment.notes}
                        onChange={e => setPortfolioAssessment({...portfolioAssessment, notes: e.target.value})}
                        className="w-full p-2 border rounded text-sm"
                        rows="2"
                        placeholder="Additional context about the combined entity..."
                      />
                    </div>
                  </div>
                </div>
                
                {/* Combined Valuation Section */}
                <div className="bg-white border rounded-lg mb-6">
                  <div className="p-3 bg-green-600 text-white font-semibold">
                    Combined Valuation
                  </div>
                  <div className="p-4">
                    {/* Row 1: Base Multiple Comparison */}
                    <div className="grid grid-cols-6 gap-3 mb-4">
                      <div className="bg-gray-50 p-3 rounded-lg text-center">
                        <div className="text-xs text-gray-500 uppercase tracking-wide">Combined EBITDA</div>
                        <div className="text-xl font-bold text-gray-800">{formatCurrency(portfolioCalcs.combined.adjustedEbitda)}</div>
                      </div>
                      <div className="bg-gray-100 p-3 rounded-lg text-center border border-gray-300">
                        <div className="text-xs text-gray-500 uppercase tracking-wide">Wtd Avg Base</div>
                        <div className="text-xl font-bold text-gray-600">{portfolioCalcs.individualBaseMultiple?.toFixed(2)}x</div>
                        <div className="text-xs text-gray-400">Individual sizes</div>
                      </div>
                      <div className="bg-green-50 p-3 rounded-lg text-center border border-green-300">
                        <div className="text-xs text-green-600 uppercase tracking-wide">Combined Base</div>
                        <div className="text-xl font-bold text-green-700">{portfolioCalcs.combinedBaseMultiple?.toFixed(2)}x</div>
                        <div className="text-xs text-green-500">From scale</div>
                      </div>
                      <div className={`p-3 rounded-lg text-center border ${portfolioCalcs.sizeBenefit >= 0 ? 'bg-green-50 border-green-300' : 'bg-red-50 border-red-300'}`}>
                        <div className="text-xs text-gray-500 uppercase tracking-wide">Size Benefit</div>
                        <div className={`text-xl font-bold ${portfolioCalcs.sizeBenefit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                          {portfolioCalcs.sizeBenefit >= 0 ? '+' : ''}{portfolioCalcs.sizeBenefit?.toFixed(2)}x
                        </div>
                        <div className="text-xs text-gray-400">Scale advantage</div>
                      </div>
                      <div className="bg-blue-50 p-3 rounded-lg text-center border border-blue-200">
                        <div className="text-xs text-blue-600 uppercase tracking-wide">Wtd Avg Adj</div>
                        <div className="text-xl font-bold text-blue-700">
                          {(portfolioCalcs.weightedAvgAdjustments || 0) >= 0 ? '+' : ''}{(portfolioCalcs.weightedAvgAdjustments || 0).toFixed(2)}x
                        </div>
                        <div className="text-xs text-blue-400">Quality/Ind/Loc</div>
                      </div>
                      <div className="bg-green-100 p-3 rounded-lg text-center border-2 border-green-400">
                        <div className="text-xs text-green-600 uppercase tracking-wide">Final Multiple</div>
                        <div className="text-xl font-bold text-green-700">{portfolioCalcs.combinedTypicalMultiple?.toFixed(2)}x – {portfolioCalcs.combinedMultiple?.toFixed(2)}x</div>
                        <div className="text-xs text-green-500">Typical – Market High</div>
                      </div>
                    </div>
                    
                    {/* Formula explanation */}
                    <div className="text-xs text-gray-500 text-center mb-4 bg-gray-50 p-2 rounded">
                      Combined Base ({portfolioCalcs.combinedBaseMultiple?.toFixed(2)}x) + Weighted Avg Adjustments ({(portfolioCalcs.weightedAvgAdjustments || 0) >= 0 ? '+' : ''}{(portfolioCalcs.weightedAvgAdjustments || 0).toFixed(2)}x) 
                      {(portfolioCalcs.combinedAssessmentAdj || 0) !== 0 && ` + Assessment Adj (${(portfolioCalcs.combinedAssessmentAdj || 0) >= 0 ? '+' : ''}${(portfolioCalcs.combinedAssessmentAdj || 0).toFixed(2)}x)`}
                      = <strong>{portfolioCalcs.combinedMultiple?.toFixed(2)}x</strong> Market High | <strong>{portfolioCalcs.combinedTypicalMultiple?.toFixed(2)}x</strong> Typical (85%)
                    </div>
                    
                    {/* Row 2: Valuation Results */}
                    <div className="grid grid-cols-3 gap-6">
                      <div className="bg-gray-100 p-4 rounded-lg text-center">
                        <div className="text-xs text-gray-500 uppercase tracking-wide">Sum of Parts Value</div>
                        <div className="text-xl font-bold text-gray-700">{formatCurrency(portfolioCalcs.sumOfPartsValue)}</div>
                        <div className="text-xs text-gray-500">Individual valuations added</div>
                      </div>
                      <div className="bg-green-100 p-4 rounded-lg text-center border-2 border-green-400">
                        <div className="text-xs text-green-600 uppercase tracking-wide">Combined Package Value</div>
                        <div className="text-2xl font-bold text-green-700">{formatCurrency(portfolioCalcs.combinedTypicalValuation)} – {formatCurrency(portfolioCalcs.combinedValuation)}</div>
                        <div className="text-xs text-green-600">{formatCurrency(portfolioCalcs.combined.adjustedEbitda)} × {portfolioCalcs.combinedTypicalMultiple?.toFixed(2)}x – {portfolioCalcs.combinedMultiple?.toFixed(2)}x</div>
                      </div>
                      <div className={`p-4 rounded-lg text-center border-2 ${portfolioCalcs.premium >= 0 ? 'bg-blue-100 border-blue-400' : 'bg-red-100 border-red-400'}`}>
                        <div className={`text-xs uppercase tracking-wide ${portfolioCalcs.premium >= 0 ? 'text-blue-600' : 'text-red-600'}`}>
                          {portfolioCalcs.premium >= 0 ? 'Premium for Selling Together' : 'Discount vs Selling Separately'}
                        </div>
                        <div className={`text-2xl font-bold ${portfolioCalcs.premium >= 0 ? 'text-blue-700' : 'text-red-600'}`}>
                          {portfolioCalcs.premium >= 0 ? '+' : ''}{formatCurrency(portfolioCalcs.premium)}
                        </div>
                        <div className={`text-xs ${portfolioCalcs.premium >= 0 ? 'text-blue-600' : 'text-red-600'}`}>
                          {portfolioCalcs.premiumPct >= 0 ? '+' : ''}{portfolioCalcs.premiumPct?.toFixed(1)}% {portfolioCalcs.premium >= 0 ? 'premium' : 'discount'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Proceeds Allocation Section */}
                <div className="bg-white border rounded-lg mb-6">
                  <div className="p-3 bg-gray-100 border-b font-semibold text-gray-800 flex justify-between items-center">
                    <span>💰 Proceeds Allocation</span>
                    <div className="flex items-center gap-2 text-sm font-normal">
                      <span className="text-gray-500">Method:</span>
                      <label className={`px-3 py-1 rounded cursor-pointer ${portfolioSettings.allocationMethod === 'value' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}>
                        <input
                          type="radio"
                          name="allocation"
                          value="value"
                          checked={portfolioSettings.allocationMethod === 'value'}
                          onChange={() => setPortfolioSettings({...portfolioSettings, allocationMethod: 'value'})}
                          className="sr-only"
                        />
                        Individual Value
                      </label>
                      <label className={`px-3 py-1 rounded cursor-pointer ${portfolioSettings.allocationMethod === 'ebitda' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}>
                        <input
                          type="radio"
                          name="allocation"
                          value="ebitda"
                          checked={portfolioSettings.allocationMethod === 'ebitda'}
                          onChange={() => setPortfolioSettings({...portfolioSettings, allocationMethod: 'ebitda'})}
                          className="sr-only"
                        />
                        EBITDA Contribution
                      </label>
                      <label className={`px-3 py-1 rounded cursor-pointer ${portfolioSettings.allocationMethod === 'equal' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                        title="Even split across the entities (e.g. 50/50 for two) — a business agreement between the owners, not a math outcome. Confirm they actually asked for it before presenting this view.">
                        <input
                          type="radio"
                          name="allocation"
                          value="equal"
                          checked={portfolioSettings.allocationMethod === 'equal'}
                          onChange={() => setPortfolioSettings({...portfolioSettings, allocationMethod: 'equal'})}
                          className="sr-only"
                        />
                        Equal Split
                      </label>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-3 py-2 text-left font-semibold text-gray-600">Entity</th>
                            <th className="px-3 py-2 text-right font-semibold text-gray-600">Standalone Value</th>
                            <th className="px-3 py-2 text-right font-semibold text-gray-600">% of Total</th>
                            <th className="px-3 py-2 text-right font-semibold text-gray-600 bg-green-50">Share of Package</th>
                            <th className="px-3 py-2 text-right font-semibold text-gray-600 bg-blue-50">Premium by Selling Together</th>
                          </tr>
                        </thead>
                        <tbody>
                          {portfolioCalcs.allocation.map(entity => (
                            <tr key={entity.id} className="border-t">
                              <td className="px-3 py-2 font-medium">{entity.name}</td>
                              <td className="px-3 py-2 text-right">{formatCurrency(entity.valuation)}</td>
                              <td className="px-3 py-2 text-right">{entity.pctOfTotal.toFixed(1)}%</td>
                              <td className="px-3 py-2 text-right font-semibold bg-green-50 text-green-700">{formatCurrency(entity.shareOfPackage)}</td>
                              <td className="px-3 py-2 text-right font-semibold bg-blue-50 text-blue-700">
                                {entity.premium >= 0 ? '+' : ''}{formatCurrency(entity.premium)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="bg-gray-100 font-semibold">
                          <tr>
                            <td className="px-3 py-2">TOTAL</td>
                            <td className="px-3 py-2 text-right">{formatCurrency(portfolioCalcs.sumOfPartsValue)}</td>
                            <td className="px-3 py-2 text-right">100.0%</td>
                            <td className="px-3 py-2 text-right bg-green-100 text-green-800">{formatCurrency(portfolioCalcs.combinedValuation)}</td>
                            <td className="px-3 py-2 text-right bg-blue-100 text-blue-800">
                              +{formatCurrency(portfolioCalcs.premium)} ({portfolioCalcs.premiumPct?.toFixed(1)}%)
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    
                    <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded text-sm text-amber-800">
                      <strong>💡 {portfolioSettings.allocationMethod === 'value' ? 'Individual Value' : 'EBITDA Contribution'} Method:</strong>{' '}
                      {portfolioSettings.allocationMethod === 'value' 
                        ? 'Allocates based on each entity\'s standalone valuation. Accounts for differences in risk profile and multiple, not just earnings.'
                        : 'Allocates based on each entity\'s EBITDA contribution to the combined total. Simpler but ignores quality differences.'}
                    </div>
                  </div>
                </div>
                
                {/* Generate Report Button */}
                <div className="flex justify-center">
                  <button
                    onClick={() => {
                      // ── Combined presentation, v2 (Zac 09-04, the dental
                      // package: "this PDF reads terrible… there needs to be
                      // a table for the combined number" + his range rule —
                      // low AND high on BOTH sum-of-parts and the package,
                      // never a bare number on one side of the comparison).
                      const pc = portfolioCalcs;
                      const cur = (v) => formatCurrency(v);
                      const entLow = (e) => (e.adjustedEbitda || 0) * (e.multipleMin || e.multiple || 0);
                      const sumLow = portfolioEntities.reduce((s, e) => s + entLow(e), 0);
                      const methodLbl = portfolioSettings.allocationMethod === 'value' ? 'by standalone value'
                        : portfolioSettings.allocationMethod === 'ebitda' ? 'by EBITDA contribution' : 'equal split';
                      const printWindow = window.open('', '_blank');
                      printWindow.document.write(`
                        <html>
                        <head>
                          <title>Combined Valuation — ${portfolioSettings.portfolioName}</title>
                          <style>
                            @page { size: letter; margin: 0.5in; }
                            body { font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #333; max-width: 860px; margin: 0 auto; }
                            h1 { font-family: Georgia, serif; font-size: 22px; color: #1f4d3d; margin: 0; }
                            .sub { color: #8a998a; font-size: 12px; margin: 2px 0 10px; }
                            .rule { border-top: 3px solid #1f4d3d; margin-bottom: 14px; }
                            .stats { display: flex; gap: 40px; margin-bottom: 18px; }
                            .stats .l { font-size: 9px; letter-spacing: 1px; color: #8a998a; text-transform: uppercase; }
                            .stats .v { font-size: 17px; font-weight: bold; color: #222; margin-top: 2px; }
                            table { width: 100%; border-collapse: collapse; margin: 8px 0 18px; }
                            th { text-align: left; color: #1f4d3d; font-size: 10.5px; border-bottom: 2px solid #1f4d3d; padding: 4px 8px; }
                            td { padding: 5px 8px; border-bottom: 1px solid #eef2ee; }
                            .r { text-align: right; }
                            .dim { color: #8a998a; }
                            tr.sum td { font-weight: bold; background: #f4f8f4; border-top: 2px solid #9db49a; }
                            tr.pkg td { font-weight: bold; background: #1f4d3d; color: #fff; font-size: 13px; }
                            tr.prem td { font-weight: bold; color: #1f4d3d; background: #e8f1ea; }
                            h2 { font-size: 14px; color: #1f4d3d; margin: 18px 0 4px; }
                            .note { color: #8a998a; font-size: 10.5px; }
                            .warn { background: #fef3c7; border: 1px solid #f59e0b; border-radius: 6px; padding: 8px 12px; font-size: 11px; margin-bottom: 12px; }
                            .foot { display: flex; justify-content: space-between; margin-top: 26px; padding-top: 8px; border-top: 1px solid #d6e0d6; color: #8a998a; font-size: 10px; }
                          </style>
                        </head>
                        <body>
                          <h1>Combined Business Valuation</h1>
                          <div class="sub">${portfolioSettings.portfolioName} · prepared ${new Date().toLocaleDateString()}</div>
                          <div class="rule"></div>
                          <div class="stats">
                            <div><div class="l">Combined Revenue</div><div class="v">${cur(pc.combined.revenue)}</div></div>
                            <div><div class="l">Combined Adj. EBITDA</div><div class="v">${cur(pc.combined.adjustedEbitda)}</div></div>
                            <div><div class="l">Combined Multiple</div><div class="v">${pc.combinedTypicalMultiple?.toFixed(2)}x – ${pc.combinedMultiple?.toFixed(2)}x</div></div>
                            <div><div class="l">Combined Package Value</div><div class="v" style="color:#1f4d3d">${cur(pc.combinedTypicalValuation)} – ${cur(pc.combinedValuation)}</div></div>
                          </div>
                          ${pc.ttmMismatch ? `<div class="warn">⚠ ${pc.ttmWarning} — combined figures mix periods; align before final numbers.</div>` : ''}

                          <h2>Valuation Build-Up</h2>
                          <table>
                            <thead><tr>
                              <th>Business</th><th class="r">Revenue</th><th class="r">Adj. EBITDA</th>
                              <th class="r">Multiple Range</th><th class="r">Standalone Value Range</th>
                            </tr></thead>
                            <tbody>
                              ${portfolioEntities.map(e => `
                                <tr>
                                  <td>${e.name}<span class="dim">${e.ttmPeriod ? ' · TTM ' + e.ttmPeriod : ''}</span></td>
                                  <td class="r">${cur(e.revenue)}</td>
                                  <td class="r">${cur(e.adjustedEbitda)}</td>
                                  <td class="r">${(e.multipleMin || e.multiple).toFixed(2)}x – ${(e.multipleMax || e.multiple).toFixed(2)}x</td>
                                  <td class="r">${cur(entLow(e))} – ${cur(e.valuation)}</td>
                                </tr>`).join('')}
                              <tr class="sum">
                                <td>Sum of the parts (sold separately)</td>
                                <td class="r">${cur(pc.combined.revenue)}</td>
                                <td class="r">${cur(pc.combined.adjustedEbitda)}</td>
                                <td class="r dim">weighted</td>
                                <td class="r">${cur(sumLow)} – ${cur(pc.sumOfPartsValue)}</td>
                              </tr>
                              <tr class="pkg">
                                <td>COMBINED PACKAGE (sold together)</td>
                                <td class="r">${cur(pc.combined.revenue)}</td>
                                <td class="r">${cur(pc.combined.adjustedEbitda)}</td>
                                <td class="r">${pc.combinedTypicalMultiple?.toFixed(2)}x – ${pc.combinedMultiple?.toFixed(2)}x</td>
                                <td class="r">${cur(pc.combinedTypicalValuation)} – ${cur(pc.combinedValuation)}</td>
                              </tr>
                              <tr class="prem">
                                <td colspan="4">Premium for selling together (top of range vs. sum of parts)</td>
                                <td class="r">+${cur(pc.premium)} (${pc.premiumPct?.toFixed(1)}%)</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="note">The combined multiple = the size-based market multiple for the combined EBITDA (${pc.combinedBaseMultiple?.toFixed(2)}x) ${pc.weightedAvgAdjustments >= 0 ? '+' : ''}${pc.weightedAvgAdjustments?.toFixed(2)}x weighted business-quality adjustments${pc.combinedAssessmentAdj ? ` ${pc.combinedAssessmentAdj >= 0 ? '+' : ''}${pc.combinedAssessmentAdj.toFixed(2)}x combined-entity factors` : ''}. The lower bound reflects the typical-transaction discount applied consistently to every figure above.</div>

                          <h2>Proceeds Allocation <span class="note">(${methodLbl})</span></h2>
                          <table>
                            <thead><tr>
                              <th>Business</th><th class="r">% of Package</th>
                              <th class="r">Share of Package (range)</th><th class="r">vs. Standalone (top of range)</th>
                            </tr></thead>
                            <tbody>
                              ${pc.allocation.map(e => `
                                <tr>
                                  <td>${e.name}</td>
                                  <td class="r">${e.pctOfTotal.toFixed(1)}%</td>
                                  <td class="r">${cur(pc.combinedTypicalValuation * e.pctOfTotal / 100)} – ${cur(e.shareOfPackage)}</td>
                                  <td class="r">${e.premium >= 0 ? '+' : ''}${cur(e.premium)}</td>
                                </tr>`).join('')}
                              <tr class="sum">
                                <td>Total</td><td class="r">100%</td>
                                <td class="r">${cur(pc.combinedTypicalValuation)} – ${cur(pc.combinedValuation)}</td>
                                <td class="r">+${cur(pc.premium)}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="note">${portfolioSettings.allocationMethod === 'value'
                            ? 'Allocation by standalone value reflects each business’s risk profile and multiple, not just earnings.'
                            : portfolioSettings.allocationMethod === 'ebitda'
                              ? 'Allocation by EBITDA contribution splits proceeds in proportion to earnings.'
                              : 'Equal split allocates proceeds evenly between the businesses, per the owners’ agreement.'}</div>

                          <div class="foot"><div>Vista Business Group &nbsp;·&nbsp; Confidential</div><div>${new Date().toLocaleDateString()}</div></div>
                        </body>
                        </html>
                      `);
                      printWindow.document.close();
                      printWindow.print();
                    }}
                    className="px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700"
                  >
                    🖨️ Generate Combined Presentation
                  </button>
                </div>
              </>
            )}
          </div>
        ) : null}

        {/* AR Aging Paste Column Modal */}
        {showARPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[500px] max-h-[80vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Column - AR Aging</h3>
                <button onClick={() => { setShowARPasteModal(false); setArPasteData(''); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {/* Target Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Paste Into</label>
                <select 
                  value={arPasteTarget}
                  onChange={e => setArPasteTarget(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  <option value="customerName">Customer/Invoice Names</option>
                  <option value="current">{arAgingBucketLabels.current}</option>
                  <option value="days31to60">{arAgingBucketLabels.days31to60}</option>
                  <option value="days61to90">{arAgingBucketLabels.days61to90}</option>
                  <option value="days91to120">{arAgingBucketLabels.days91to120}</option>
                  <option value="days120plus">{arAgingBucketLabels.days120plus}</option>
                </select>
              </div>
              
              {/* Paste Area */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Paste Data Below <span className="text-gray-500 font-normal">(one value per line)</span>
                </label>
                <textarea 
                  value={arPasteData}
                  onChange={e => setArPasteData(e.target.value)}
                  placeholder={arPasteTarget === 'customerName' 
                    ? "Copy customer names from Excel...\nAcme Corp\nBeta Industries\nGamma LLC"
                    : "Copy values from Excel...\n5000\n12500\n(750)\n\n3200"}
                  className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-sm"
                />
                <div className="text-xs text-gray-500 mt-1">
                  {(() => {
                    const lines = arPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
                    const total = lines.length;
                    const nonEmpty = lines.filter(v => v.trim()).length;
                    const empty = total - nonEmpty;
                    return `${total} rows (${nonEmpty} with values, ${empty} blank${arPasteTarget !== 'customerName' ? ' → will be $0' : ''})`;
                  })()}
                </div>
              </div>
              
              {/* Tips */}
              <div className="bg-gray-50 p-3 rounded-lg mb-4 text-sm">
                <div className="font-medium text-gray-800 mb-1">💡 Tips:</div>
                <ul className="text-gray-600 text-xs space-y-1">
                  <li>• Copy a column from Excel (Ctrl+C) then paste here (Ctrl+V)</li>
                  <li>• <strong>Blank rows are preserved</strong> - they align with the correct customer row</li>
                  {arPasteTarget !== 'customerName' && (
                    <>
                      <li>• Currency formatting ($1,234.56) will be parsed automatically</li>
                      <li>• Negative numbers can be in parentheses: (1,234) → -1,234</li>
                      <li>• Blank cells → $0</li>
                    </>
                  )}
                  <li>• Rows will be added automatically if needed</li>
                </ul>
              </div>
              
              {/* Buttons */}
              <div className="flex gap-2 justify-end">
                <button 
                  onClick={() => { setShowARPasteModal(false); setArPasteData(''); }}
                  className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button 
                  onClick={applyARPaste}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  disabled={arPasteData.trim() === ''}
                >
                  Apply to {arPasteData.trim() === '' ? 0 : arPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').length} Rows
                </button>
              </div>
            </div>
          </div>
        )}

        {/* AP Aging Paste Column Modal */}
        {showAPPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[500px] max-h-[80vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Column - AP Aging</h3>
                <button onClick={() => { setShowAPPasteModal(false); setApPasteData(''); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {/* Target Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Paste Into</label>
                <select 
                  value={apPasteTarget}
                  onChange={e => setApPasteTarget(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  <option value="vendorName">Vendor/Invoice Names</option>
                  <option value="current">{apAgingBucketLabels.current}</option>
                  <option value="days31to60">{apAgingBucketLabels.days31to60}</option>
                  <option value="days61to90">{apAgingBucketLabels.days61to90}</option>
                  <option value="days91to120">{apAgingBucketLabels.days91to120}</option>
                  <option value="days120plus">{apAgingBucketLabels.days120plus}</option>
                </select>
              </div>
              
              {/* Paste Area */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Paste Data Below <span className="text-gray-500 font-normal">(one value per line)</span>
                </label>
                <textarea 
                  value={apPasteData}
                  onChange={e => setApPasteData(e.target.value)}
                  placeholder={apPasteTarget === 'vendorName' 
                    ? "Copy vendor names from Excel...\nABC Supply\nXYZ Services\nTech Partners"
                    : "Copy values from Excel...\n5000\n12500\n750\n\n3200"}
                  className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-sm"
                />
                <div className="text-xs text-gray-500 mt-1">
                  {(() => {
                    const lines = apPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
                    const total = lines.length;
                    const nonEmpty = lines.filter(v => v.trim()).length;
                    const empty = total - nonEmpty;
                    return `${total} rows (${nonEmpty} with values, ${empty} blank${apPasteTarget !== 'vendorName' ? ' → will be $0' : ''})`;
                  })()}
                </div>
              </div>
              
              {/* Tips */}
              <div className="bg-gray-50 p-3 rounded-lg mb-4 text-sm">
                <div className="font-medium text-gray-800 mb-1">💡 Tips:</div>
                <ul className="text-gray-600 text-xs space-y-1">
                  <li>• Copy a column from Excel (Ctrl+C) then paste here (Ctrl+V)</li>
                  <li>• <strong>Blank rows are preserved</strong> - they align with the correct vendor row</li>
                  {apPasteTarget !== 'vendorName' && (
                    <>
                      <li>• Currency formatting ($1,234.56) will be parsed automatically</li>
                      <li>• Blank cells → $0</li>
                    </>
                  )}
                  <li>• Rows will be added automatically if needed</li>
                </ul>
              </div>
              
              {/* Buttons */}
              <div className="flex gap-2 justify-end">
                <button 
                  onClick={() => { setShowAPPasteModal(false); setApPasteData(''); }}
                  className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button 
                  onClick={applyAPPaste}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  disabled={apPasteData.trim() === ''}
                >
                  Apply to {apPasteData.trim() === '' ? 0 : apPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').length} Rows
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Balance Sheet Paste Column Modal */}
        {showBSPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[500px] max-h-[80vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Column - Balance Sheet</h3>
                <button onClick={() => { setShowBSPasteModal(false); setBsPasteData(''); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {/* Section Info */}
              <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                <span><strong>Section:</strong> {
                  bsPasteSection === 'currentAssets' ? '💵 Current Assets' :
                  bsPasteSection === 'fixedAssets' ? '🏢 Fixed Assets' :
                  bsPasteSection === 'otherAssets' ? '📋 Other Assets' :
                  bsPasteSection === 'currentLiabilities' ? '💳 Current Liabilities' :
                  bsPasteSection === 'longTermLiabilities' ? '🏦 Long-Term Liabilities' :
                  '📊 Equity'
                }</span>
              </div>
              
              {/* Target Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Paste Into</label>
                <select 
                  value={bsPasteTarget}
                  onChange={e => setBsPasteTarget(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  <option value="name">Account Names</option>
                  <option value="year1">{bsYearLabels.year1} Values</option>
                  <option value="year2">{bsYearLabels.year2} Values</option>
                  <option value="year3">{bsYearLabels.year3} Values</option>
                  <option value="interim">{bsYearLabels.interim || 'Interim'} Values</option>
                </select>
              </div>
              
              {/* Paste Area */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Paste Data Below <span className="text-gray-500 font-normal">(one value per line)</span>
                </label>
                <textarea 
                  value={bsPasteData}
                  onChange={e => setBsPasteData(e.target.value)}
                  placeholder={bsPasteTarget === 'name' 
                    ? "Copy account names from Excel...\nCash\nAccounts Receivable\nInventory"
                    : "Copy values from Excel...\n125000\n45000\n(12500)\n\n8000"}
                  className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-sm"
                />
                <div className="text-xs text-gray-500 mt-1">
                  {(() => {
                    const lines = bsPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
                    const total = lines.length;
                    const nonEmpty = lines.filter(v => v.trim()).length;
                    const empty = total - nonEmpty;
                    return `${total} rows (${nonEmpty} with values, ${empty} blank${bsPasteTarget !== 'name' ? ' → will be $0' : ''})`;
                  })()}
                </div>
              </div>
              
              {/* Tips */}
              <div className="bg-gray-50 p-3 rounded-lg mb-4 text-sm">
                <div className="font-medium text-gray-800 mb-1">💡 Tips:</div>
                <ul className="text-gray-600 text-xs space-y-1">
                  <li>• Copy a column from Excel (Ctrl+C) then paste here (Ctrl+V)</li>
                  <li>• <strong>Blank rows are preserved</strong> - they align with the correct account row</li>
                  {bsPasteTarget !== 'name' && (
                    <>
                      <li>• Currency formatting ($1,234.56) will be parsed automatically</li>
                      <li>• Negative numbers can be in parentheses: (1,234) → -1,234</li>
                      <li>• Blank cells → $0</li>
                    </>
                  )}
                  <li>• Rows will be added automatically if needed</li>
                  <li>• <strong>Deferred accounts are skipped</strong> - enter those manually</li>
                </ul>
              </div>
              
              {/* Buttons */}
              <div className="flex gap-2 justify-end">
                <button 
                  onClick={() => { setShowBSPasteModal(false); setBsPasteData(''); }}
                  className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button 
                  onClick={applyBSPaste}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  disabled={bsPasteData.trim() === ''}
                >
                  Apply to {bsPasteData.trim() === '' ? 0 : bsPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').length} Rows
                </button>
              </div>
            </div>
          </div>
        )}

        {/* P&L Paste Column Modal */}
        {showPLPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[500px] max-h-[80vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Column - P&L Entry</h3>
                <button onClick={() => { setShowPLPasteModal(false); setPlPasteData(''); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {/* Section & Year Info */}
              <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                <div className="flex justify-between">
                  <span><strong>Section:</strong> {
                    plPasteSection === 'revenue' ? '📈 Revenue' :
                    plPasteSection === 'cogs' ? '📦 Cost of Goods Sold' :
                    plPasteSection === 'opex' ? '💰 Operating Expenses' :
                    plPasteSection === 'otherIncome' ? '📈 Other Income' :
                    '📉 Other Expense'
                  }</span>
                  <span><strong>Year:</strong> {basisYearTab === 'ttm' ? 'TTM' : basisYearLabels[basisYearTab] || basisYearTab}</span>
                </div>
              </div>
              
              {/* Target Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Paste Into</label>
                <select 
                  value={plPasteTarget}
                  onChange={e => setPlPasteTarget(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  <option value="name">Account Names</option>
                  <option value="cash">Cash Basis Values</option>
                  <option value="accrual">Accrual Basis Values</option>
                  {!['ttm', 'ytd'].includes(basisYearTab) && <option value="tax">Tax Return Values</option>}
                </select>
              </div>
              
              {/* Paste Area */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Paste Data Below <span className="text-gray-500 font-normal">(one value per line)</span>
                </label>
                <textarea 
                  value={plPasteData}
                  onChange={e => setPlPasteData(e.target.value)}
                  placeholder={plPasteTarget === 'name' 
                    ? "Copy account names from Excel...&#10;Managed Services&#10;Break/Fix&#10;Hardware Sales"
                    : "Copy values from Excel...&#10;125000&#10;45000&#10;(12500)&#10;&#10;8000"}
                  className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-sm"
                />
                <div className="text-xs text-gray-500 mt-1">
                  {(() => {
                    const lines = plPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
                    const total = lines.length;
                    const nonEmpty = lines.filter(v => v.trim()).length;
                    const empty = total - nonEmpty;
                    return `${total} rows (${nonEmpty} with values, ${empty} blank${plPasteTarget !== 'name' ? ' → will be $0' : ''})`;
                  })()}
                </div>
              </div>
              
              {/* Tips */}
              <div className="bg-gray-50 p-3 rounded-lg mb-4 text-sm">
                <div className="font-medium text-gray-800 mb-1">💡 Tips:</div>
                <ul className="text-gray-600 text-xs space-y-1">
                  <li>• Copy a column from Excel (Ctrl+C) then paste here (Ctrl+V)</li>
                  <li>• <strong>Blank rows are preserved</strong> - they align with the correct account row</li>
                  {plPasteTarget !== 'name' && (
                    <>
                      <li>• Currency formatting ($1,234.56) will be parsed automatically</li>
                      <li>• Negative numbers can be in parentheses: (1,234) → -1,234</li>
                      <li>• Blank cells → $0</li>
                    </>
                  )}
                  <li>• Rows will be added automatically if needed</li>
                </ul>
              </div>
              
              {/* Buttons */}
              <div className="flex gap-2 justify-end">
                <button 
                  onClick={() => { setShowPLPasteModal(false); setPlPasteData(''); }}
                  className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button 
                  onClick={applyPLPaste}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  disabled={plPasteData.trim() === ''}
                >
                  Apply to {plPasteData.trim() === '' ? 0 : plPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').length} Rows
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Annual P&L Paste Grid Modal */}
        {showAnnualGridPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[700px] max-h-[85vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📊 Paste Grid - Annual P&L</h3>
                <button onClick={() => { setShowAnnualGridPasteModal(false); setAnnualGridPasteData(''); setAnnualGridPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!annualGridPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Section</label>
                      <select 
                        value={annualGridPasteSection}
                        onChange={e => setAnnualGridPasteSection(e.target.value)}
                        className="w-full px-3 py-2 border rounded-lg"
                      >
                        <option value="revenue">📈 Revenue</option>
                        <option value="cogs">📦 Cost of Goods Sold</option>
                        <option value="opex">💰 Operating Expenses</option>
                        <option value="otherIncome">📈 Other Income</option>
                        <option value="otherExpense">📉 Other Expense</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Accounting Basis</label>
                      <select 
                        value={annualGridPasteBasis}
                        onChange={e => setAnnualGridPasteBasis(e.target.value)}
                        className={`w-full px-3 py-2 border rounded-lg ${annualGridPasteBasis === 'cash' ? 'bg-slate-50' : annualGridPasteBasis === 'accrual' ? 'bg-blue-50' : 'bg-amber-50'}`}
                      >
                        <option value="cash">Cash Basis</option>
                        <option value="accrual">Accrual Basis</option>
                        <option value="tax">Tax Return Basis</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-blue-800 mb-1">📋 Smart Year Matching</div>
                    <div className="text-blue-700 text-xs">
                      Paste your P&L report - years are detected automatically from column headers.
                      <div className="mt-1">• Single column → mapped to Year 5 (or matched year)</div>
                      <div>• Multiple columns → matched to existing years or by position</div>
                      <div>• Only years in your paste will be updated - existing data preserved</div>
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Data Below <span className="text-gray-500 font-normal">(Account Name + Year values, tab-separated)</span>
                    </label>
                    <textarea 
                      value={annualGridPasteData}
                      onChange={e => setAnnualGridPasteData(e.target.value)}
                      placeholder={"Account Name\t2022\t2023\t2024\tTTM\nManaged Services\t450000\t520000\t610000\t640000\nProject Revenue\t125000\t148000\t165000\t172000"}
                      className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = annualGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowAnnualGridPasteModal(false); setAnnualGridPasteData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseAnnualGridPaste(annualGridPasteSection, annualGridPasteBasis);
                        setAnnualGridPastePreview(preview);
                      }}
                      disabled={annualGridPasteData.trim() === ''}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    <div className="text-sm font-medium text-gray-700 mb-2">
                      Section: <span className="font-bold">
                        {annualGridPasteSection === 'revenue' ? '📈 Revenue' :
                         annualGridPasteSection === 'cogs' ? '📦 COGS' :
                         annualGridPasteSection === 'opex' ? '💰 OpEx' :
                         annualGridPasteSection === 'otherIncome' ? '📈 Other Income' :
                         '📉 Other Expense'}
                      </span>
                      <span className="ml-3">Basis: <span className={`font-bold px-2 py-0.5 rounded ${annualGridPasteBasis === 'cash' ? 'bg-slate-100' : annualGridPasteBasis === 'accrual' ? 'bg-blue-100' : 'bg-amber-100'}`}>
                        {annualGridPasteBasis === 'cash' ? 'Cash' : annualGridPasteBasis === 'accrual' ? 'Accrual' : 'Tax Return'}
                      </span></span>
                    </div>
                    
                    {/* Year Column Mapping */}
                    {annualGridPastePreview.yearMatchInfo && annualGridPastePreview.yearMatchInfo.length > 0 && (
                      <div className="mb-4 p-3 bg-slate-50 rounded-lg border">
                        <div className="font-medium text-gray-700 mb-2 flex items-center gap-2">
                          📅 Year Column Mapping
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {annualGridPastePreview.yearMatchInfo.map((info, idx) => (
                            <div key={idx} className={`px-2 py-1 rounded text-xs ${
                              info.matchType === 'exact' ? 'bg-green-100 text-green-800' :
                              info.matchType === 'position' ? 'bg-blue-100 text-blue-800' :
                              info.matchType === 'new' ? 'bg-amber-100 text-amber-800' :
                              'bg-gray-100 text-gray-700'
                            }`}>
                              <span className="font-medium">{info.detected}</span>
                              <span className="mx-1">→</span>
                              <span>{info.mappedTo === 'ttm' ? 'TTM' : info.mappedTo.replace('year', 'Year ')}</span>
                              {info.matchType === 'exact' && <span className="ml-1 text-green-600">✓</span>}
                              {info.matchType === 'position' && <span className="ml-1">📍</span>}
                              {info.matchType === 'new' && <span className="ml-1">⚠️</span>}
                            </div>
                          ))}
                        </div>
                        {annualGridPastePreview.yearMatchInfo.some(i => i.warning) && (
                          <div className="mt-2 text-xs text-amber-700 bg-amber-50 p-2 rounded">
                            {annualGridPastePreview.yearMatchInfo.filter(i => i.warning).map((i, idx) => (
                              <div key={idx}>⚠️ {i.warning}</div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    
                    {/* Summary */}
                    <div className="grid grid-cols-3 gap-3 mb-4">
                      <div className="bg-green-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-green-700">{annualGridPastePreview.matched.length}</div>
                        <div className="text-xs text-green-600">Matched Accounts</div>
                      </div>
                      <div className="bg-blue-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-blue-700">{annualGridPastePreview.newRows.length}</div>
                        <div className="text-xs text-blue-600">New Accounts</div>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-gray-500">{annualGridPastePreview.noData.length}</div>
                        <div className="text-xs text-gray-500">Existing (No Data)</div>
                      </div>
                    </div>
                    
                    {/* Matched Rows */}
                    {annualGridPastePreview.matched.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-green-700 mb-1">
                          ✓ Matched ({annualGridPastePreview.matched.length}) - will update only years shown above
                        </div>
                        <div className="max-h-32 overflow-y-auto border rounded text-xs">
                          <table className="w-full">
                            <tbody>
                            {annualGridPastePreview.matched.slice(0, 10).map((row, idx) => (
                              <tr key={idx} className={idx % 2 === 0 ? 'bg-green-50' : 'bg-white'}>
                                <td className="p-1 border-b">{row.name} {row.matchType === 'fuzzy' && <span className="text-orange-500">≈ {row.matchedTo.name}</span>}</td>
                                <td className="p-1 border-b text-right text-gray-500">
                                  {row.yearsPresent && row.yearsPresent.map(y => y === 'ttm' ? 'TTM' : y.replace('year', 'Y')).join(', ')}
                                </td>
                              </tr>
                            ))}
                            {annualGridPastePreview.matched.length > 10 && (
                              <tr className="bg-gray-100">
                                <td colSpan="2" className="p-1 text-center text-gray-500">...and {annualGridPastePreview.matched.length - 10} more</td>
                              </tr>
                            )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    
                    {/* New Rows */}
                    {annualGridPastePreview.newRows.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-blue-700 mb-1">
                          + New ({annualGridPastePreview.newRows.length})
                        </div>
                        <div className="max-h-32 overflow-y-auto border rounded text-xs">
                          <table className="w-full">
                            <tbody>
                            {annualGridPastePreview.newRows.slice(0, 10).map((row, idx) => (
                              <tr key={idx} className={idx % 2 === 0 ? 'bg-blue-50' : 'bg-white'}>
                                <td className="p-1 border-b font-medium">{row.name}</td>
                                <td className="p-1 border-b text-right text-gray-500">
                                  {row.yearsPresent && row.yearsPresent.map(y => y === 'ttm' ? 'TTM' : y.replace('year', 'Y')).join(', ')}
                                </td>
                              </tr>
                            ))}
                            {annualGridPastePreview.newRows.length > 10 && (
                              <tr className="bg-gray-100">
                                <td colSpan="2" className="p-1 text-center text-gray-500">...and {annualGridPastePreview.newRows.length - 10} more</td>
                              </tr>
                            )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => setAnnualGridPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowAnnualGridPasteModal(false); setAnnualGridPasteData(''); setAnnualGridPastePreview(null); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={applyAnnualGridPaste}
                      className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                    >
                      Apply {annualGridPastePreview.matched.length + annualGridPastePreview.newRows.length} Rows
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Full P&L Paste Modal (for new P&L entry tabs) */}
        {showFullPLPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[90vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Full P&L - {fullPLPasteBasis === 'cash' ? 'Cash Basis' : fullPLPasteBasis === 'accrual' ? 'Accrual Basis' : 'Tax Return'}</h3>
                <button onClick={() => { setShowFullPLPasteModal(false); setFullPLPasteData(''); setFullPLPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!fullPLPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className={`mb-4 p-4 ${fullPLPasteBasis === 'cash' ? 'bg-slate-50 border-slate-200' : fullPLPasteBasis === 'accrual' ? 'bg-blue-50 border-blue-200' : 'bg-amber-50 border-amber-200'} border rounded-lg`}>
                    <div className="font-medium mb-2">📋 How to use:</div>
                    <ol className="text-sm space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>Profit & Loss by Year</strong> (or "Comparative P&L")</li>
                      <li>Select <strong>ALL rows</strong> from Income through Net Income</li>
                      <li>Copy (Ctrl+C) - include account names, year columns, and all sections</li>
                      <li>Paste below (Ctrl+V)</li>
                    </ol>
                    <div className="mt-3 text-sm">
                      <strong>Auto-detection:</strong> Revenue, COGS, Expenses, Other Income/Expense sections will be detected automatically. 
                      Subtotals (Total Income, Gross Profit, Net Income) will be <span className="text-gray-500">skipped</span> and used for verification.
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Full P&L Below <span className="text-gray-500 font-normal">(entire P&L with all sections)</span>
                    </label>
                    <textarea 
                      value={fullPLPasteData}
                      onChange={e => setFullPLPasteData(e.target.value)}
                      placeholder={"Account\t2022\t2023\t2024\tTTM\nIncome\nManaged Services\t450000\t520000\t610000\t640000\nProject Revenue\t125000\t148000\t165000\t172000\nTotal Income\t575000\t668000\t775000\t812000\nCost of Goods Sold\nDirect Labor\t120000\t140000\t155000\t162000\nTotal COGS\t120000\t140000\t155000\t162000\nGross Profit\t455000\t528000\t620000\t650000\nExpenses\nPayroll\t200000\t220000\t250000\t260000\nRent\t24000\t24000\t26000\t27000\n..."}
                      className="w-full px-3 py-2 border rounded-lg h-64 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = fullPLPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowFullPLPasteModal(false); setFullPLPasteData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseFullPLPaste();
                        setFullPLPastePreview(preview);
                      }}
                      disabled={fullPLPasteData.trim() === ''}
                      className={`px-4 py-2 ${fullPLPasteBasis === 'cash' ? 'bg-slate-600 hover:bg-slate-700' : fullPLPasteBasis === 'accrual' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-amber-600 hover:bg-amber-700'} text-white rounded-lg disabled:opacity-50`}
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    {/* Basis mismatch warning */}
                    {(() => {
                      const pasteText = fullPLPasteData.toLowerCase();
                      const pasteIsAccrual = pasteText.includes('accrual basis') || pasteText.includes('accrual\nbasis');
                      const pasteIsCash = pasteText.includes('cash basis') || pasteText.includes('cash\nbasis');
                      if (pasteIsAccrual && fullPLPasteBasis === 'cash') return (
                        <div className="mb-3 p-3 bg-red-50 border border-red-300 rounded-lg flex items-start gap-2">
                          <span className="text-red-600 text-lg">⚠</span>
                          <div className="text-sm text-red-800">
                            <strong>Basis mismatch:</strong> This P&L appears to be <strong>Accrual Basis</strong> but you are pasting into the <strong>Cash</strong> columns. Go back and change the basis selector to <strong>Accrual</strong> before applying.
                          </div>
                        </div>
                      );
                      if (pasteIsCash && fullPLPasteBasis === 'accrual') return (
                        <div className="mb-3 p-3 bg-red-50 border border-red-300 rounded-lg flex items-start gap-2">
                          <span className="text-red-600 text-lg">⚠</span>
                          <div className="text-sm text-red-800">
                            <strong>Basis mismatch:</strong> This P&L appears to be <strong>Cash Basis</strong> but you are pasting into the <strong>Accrual</strong> columns. Go back and change the basis selector to <strong>Cash</strong> before applying.
                          </div>
                        </div>
                      );
                      return null;
                    })()}
                    {/* Detection Summary */}
                    <div className="grid grid-cols-6 gap-2 mb-4">
                      <div className="bg-green-50 p-2 rounded-lg text-center border border-green-200">
                        <div className="text-lg font-bold text-green-700">{fullPLPastePreview.parsed.revenue.length}</div>
                        <div className="text-xs text-green-600">Revenue</div>
                      </div>
                      <div className="bg-orange-50 p-2 rounded-lg text-center border border-orange-200">
                        <div className="text-lg font-bold text-orange-700">{fullPLPastePreview.parsed.cogs.length}</div>
                        <div className="text-xs text-orange-600">COGS</div>
                      </div>
                      <div className="bg-red-50 p-2 rounded-lg text-center border border-red-200">
                        <div className="text-lg font-bold text-red-700">{fullPLPastePreview.parsed.opex.length}</div>
                        <div className="text-xs text-red-600">Operating Exp</div>
                      </div>
                      <div className="bg-blue-50 p-2 rounded-lg text-center border border-blue-200">
                        <div className="text-lg font-bold text-blue-700">{fullPLPastePreview.parsed.otherIncome.length}</div>
                        <div className="text-xs text-blue-600">Other Inc</div>
                      </div>
                      <div className="bg-purple-50 p-2 rounded-lg text-center border border-purple-200">
                        <div className="text-lg font-bold text-purple-700">{fullPLPastePreview.parsed.otherExpense.length}</div>
                        <div className="text-xs text-purple-600">Other Exp</div>
                      </div>
                      <div className="bg-gray-100 p-2 rounded-lg text-center border border-gray-300">
                        <div className="text-lg font-bold text-gray-700">{fullPLPastePreview.totalRows}</div>
                        <div className="text-xs text-gray-600">Total Rows</div>
                      </div>
                    </div>
                    
                    {/* Year Columns Mapping */}
                    <div className="mb-3 p-3 bg-gray-50 rounded border">
                      <div className="font-medium mb-2 flex items-center gap-2">
                        📅 Year Column Mapping
                        {fullPLPastePreview.yearMatchInfo?.some(y => y.warning || y.willOverwrite) && (
                          <span className="text-amber-600 text-xs font-normal">⚠️ Review mappings below</span>
                        )}
                      </div>
                      <div className="space-y-1 text-sm">
                        {fullPLPastePreview.yearMatchInfo?.map((info, idx) => (
                          <div key={idx} className={`flex items-center justify-between p-1.5 rounded ${
                            info.matchType === 'exact' ? 'bg-green-50' :
                            info.matchType === 'position' ? 'bg-blue-50' :
                            info.matchType === 'new' || info.willOverwrite ? 'bg-amber-50' :
                            info.matchType === 'ytd_as_ttm' ? 'bg-purple-50' :
                            'bg-gray-100'
                          }`}>
                            <div className="flex items-center gap-2">
                              <span className="font-mono bg-white px-2 py-0.5 rounded border">{info.detected}</span>
                              <span className="text-gray-400">→</span>
                              <span className="font-medium">{info.mappedTo === 'ttm' ? 'TTM' : info.mappedTo.replace('year', 'Year ')}</span>
                              {info.label && info.label !== info.detected && info.label !== 'TTM' && (
                                <span className="text-gray-500 text-xs">(currently: {info.label})</span>
                              )}
                            </div>
                            <div className="flex items-center gap-1">
                              {info.matchType === 'exact' && (
                                <span className="text-green-600 text-xs">✓ Exact match</span>
                              )}
                              {info.matchType === 'position' && (
                                <span className="text-blue-600 text-xs">📍 By position</span>
                              )}
                              {info.matchType === 'ytd_as_ttm' && (
                                <span className="text-purple-600 text-xs">📌 YTD→TTM</span>
                              )}
                              {info.willOverwrite && (
                                <span className="text-amber-600 text-xs font-medium">⚠️ Will overwrite</span>
                              )}
                            </div>
                          </div>
                        )) || (
                          <div className="text-gray-500">
                            {fullPLPastePreview.detectedYears.map(y => y === 'ttm' ? 'TTM' : y.replace('year', 'Year ')).join(', ')}
                          </div>
                        )}
                      </div>
                      {fullPLPastePreview.yearMatchInfo?.some(y => y.warning) && (
                        <div className="mt-2 p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700">
                          {fullPLPastePreview.yearMatchInfo.filter(y => y.warning).map((y, i) => (
                            <div key={i}>⚠️ {y.warning}</div>
                          ))}
                        </div>
                      )}
                    </div>
                    
                    {/* Verification Section */}
                    <div className="mb-4 p-3 bg-white border rounded-lg">
                      <div className="font-medium mb-2">✓ Verification (Calculated vs QuickBooks Subtotals)</div>
                      <div className="grid grid-cols-2 gap-3 text-xs">
                        {Object.entries(fullPLPastePreview.verification).map(([section, data]) => {
                          const sectionLabels = { revenue: 'Revenue', cogs: 'COGS', opex: 'Operating Expenses', otherIncome: 'Other Income', otherExpense: 'Other Expense' };
                          const hasQB = data.qbSubtotal && Object.values(data.qbSubtotal).some(v => v !== 0);
                          
                          return (
                            <div key={section} className="p-2 bg-gray-50 rounded">
                              <div className="font-medium">{sectionLabels[section]} ({data.count} rows)</div>
                              {fullPLPastePreview.detectedYears.slice(0, 3).map(yr => {
                                const calc = data.calculated[yr] || 0;
                                const qb = data.qbSubtotal?.[yr] || 0;
                                const match = !hasQB || Math.abs(calc - qb) < 1;
                                return (
                                  <div key={yr} className="flex justify-between">
                                    <span>{yr === 'ttm' ? 'TTM' : yr.replace('year', 'Y')}: {formatCurrency(calc)}</span>
                                    {hasQB && (
                                      <span className={match ? 'text-green-600' : 'text-red-600'}>
                                        {match ? '✓' : `QB: ${formatCurrency(qb)}`}
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    
                    {/* Skipped Rows */}
                    {fullPLPastePreview.skipped.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-gray-500 mb-1">
                          ⊘ Skipped Subtotals ({fullPLPastePreview.skipped.length})
                        </div>
                        <div className="max-h-24 overflow-y-auto border rounded text-xs bg-gray-50">
                          <div className="p-2 space-y-1">
                            {fullPLPastePreview.skipped.map((row, idx) => (
                              <div key={idx} className="text-gray-500">
                                {row.name} <span className="text-gray-400">({row.reason})</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Preview Tables by Section */}
                    <div className="space-y-3 max-h-64 overflow-y-auto">
                      {[
                        { key: 'revenue', label: 'Revenue', headerClass: 'bg-green-100 text-green-800', rowClass: 'bg-green-50' },
                        { key: 'cogs', label: 'COGS', headerClass: 'bg-orange-100 text-orange-800', rowClass: 'bg-orange-50' },
                        { key: 'opex', label: 'Operating Expenses', headerClass: 'bg-red-100 text-red-800', rowClass: 'bg-red-50' },
                        { key: 'otherIncome', label: 'Other Income', headerClass: 'bg-blue-100 text-blue-800', rowClass: 'bg-blue-50' },
                        { key: 'otherExpense', label: 'Other Expense', headerClass: 'bg-purple-100 text-purple-800', rowClass: 'bg-purple-50' }
                      ].map(({ key, label, headerClass, rowClass }) => {
                        const rows = fullPLPastePreview.parsed[key];
                        if (rows.length === 0) return null;
                        return (
                          <div key={key} className="border rounded overflow-hidden">
                            <div className={`${headerClass} px-2 py-1 text-sm font-medium`}>
                              {label} ({rows.length} rows)
                            </div>
                            <table className="w-full text-xs">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="p-1 text-left">Account</th>
                                  {fullPLPastePreview.detectedYears.map(yr => (
                                    <th key={yr} className="p-1 text-right">{yr === 'ttm' ? 'TTM' : yr.replace('year', 'Y')}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {rows.slice(0, 5).map((row, idx) => (
                                  <tr key={idx} className={idx % 2 === 0 ? rowClass : 'bg-white'}>
                                    <td className="p-1 border-b">{row.name}</td>
                                    {fullPLPastePreview.detectedYears.map(yr => (
                                      <td key={yr} className="p-1 border-b text-right font-mono">{formatCurrency(row.yearValues[yr])}</td>
                                    ))}
                                  </tr>
                                ))}
                                {rows.length > 5 && (
                                  <tr className="bg-gray-50">
                                    <td colSpan={fullPLPastePreview.detectedYears.length + 1} className="p-1 text-center text-gray-500">
                                      ... and {rows.length - 5} more rows
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => setFullPLPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowFullPLPasteModal(false); setFullPLPasteData(''); setFullPLPastePreview(null); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input type="checkbox" checked={annualPasteClearTtmOnly} onChange={e => { setAnnualPasteClearTtmOnly(e.target.checked); if (e.target.checked) setAnnualPasteClearFirst(false); }} />
                      <span className={`text-sm font-medium ${annualPasteClearTtmOnly ? "text-amber-700" : "text-gray-600"}`}>Clear Annual Only</span>
                    </label>
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input type="checkbox" checked={annualPasteClearFirst} onChange={e => { setAnnualPasteClearFirst(e.target.checked); if (e.target.checked) setAnnualPasteClearTtmOnly(false); }} />
                      <span className={`text-sm font-medium ${annualPasteClearFirst ? "text-amber-700" : "text-gray-600"}`}>Clear & Replace</span>
                    </label>
                    <button 
                      onClick={applyFullPLPaste}
                      className={`px-4 py-2 ${annualPasteClearFirst ? 'bg-amber-600 hover:bg-amber-700' : fullPLPasteBasis === 'cash' ? 'bg-slate-600 hover:bg-slate-700' : fullPLPasteBasis === 'accrual' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-amber-600 hover:bg-amber-700'} text-white rounded-lg`}
                    >
                      {annualPasteClearFirst ? '🔄 Clear & ' : annualPasteClearTtmOnly ? '🔄 Clear Annual + ' : ''}Apply {fullPLPastePreview.totalRows} Rows to {fullPLPasteBasis === 'cash' ? 'Cash' : fullPLPasteBasis === 'accrual' ? 'Accrual' : 'Tax Return'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Full Monthly P&L Paste Modal (for TTM Monthly tab) */}
        {showFullMonthlyPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[90vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Full Monthly P&L - {selectedValuationBasis === 'cash' ? 'Cash Basis' : 'Accrual Basis'}</h3>
                <button onClick={() => { setShowFullMonthlyPasteModal(false); setFullMonthlyPasteData(''); setFullMonthlyPastePreview(null); setMonthlyPasteClearFirst(false); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!fullMonthlyPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
                    <div className="font-medium mb-2">📋 How to use:</div>
                    <ol className="text-sm space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>Profit & Loss by Month</strong> (12 month report)</li>
                      <li>Select <strong>ALL rows</strong> from Income through Net Income</li>
                      <li>Copy (Ctrl+C) - include account names, month columns, and all sections</li>
                      <li>Paste below (Ctrl+V)</li>
                    </ol>
                    <div className="mt-3 text-sm">
                      <strong>Auto-detection:</strong> Months (Jan-Dec), sections (Revenue, COGS, Expenses), and subtotals will be detected automatically.
                    </div>
                    <div className="mt-2 text-sm text-purple-700">
                      <strong>Current Basis:</strong> {selectedValuationBasis === 'cash' ? 'Cash' : 'Accrual'} 
                      <span className="text-purple-500 ml-2">(change in Settings Row above if needed)</span>
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Full Monthly P&L Below <span className="text-gray-500 font-normal">(entire P&L with all sections, 12 months)</span>
                    </label>
                    <textarea 
                      value={fullMonthlyPasteData}
                      onChange={e => setFullMonthlyPasteData(e.target.value)}
                      placeholder={"Account\tJan\tFeb\tMar\tApr\tMay\tJun\tJul\tAug\tSep\tOct\tNov\tDec\nIncome\nManaged Services\t45000\t46000\t47000\t48000\t49000\t50000\t51000\t52000\t53000\t54000\t55000\t56000\nProject Revenue\t12000\t11000\t14000\t13000\t15000\t12000\t16000\t14000\t17000\t15000\t18000\t16000\nTotal Income\t57000\t57000\t61000\t61000\t64000\t62000\t67000\t66000\t70000\t69000\t73000\t72000\nCost of Goods Sold\nDirect Labor\t12000\t12500\t13000\t13000\t13500\t14000\t14000\t14500\t15000\t15000\t15500\t16000\n..."}
                      className="w-full px-3 py-2 border rounded-lg h-64 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = fullMonthlyPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  {/* Clear Before Paste Option */}
                  <div className="mb-3">
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={monthlyPasteClearFirst}
                        onChange={(e) => setMonthlyPasteClearFirst(e.target.checked)}
                        className="w-4 h-4"
                      />
                      <span className={`text-sm font-medium ${monthlyPasteClearFirst ? "text-amber-700" : "text-gray-600"}`}>Clear & Replace</span>
                      {monthlyPasteClearFirst && <span className="text-xs text-amber-600">(recommended for annual reviews)</span>}
                    </label>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowFullMonthlyPasteModal(false); setFullMonthlyPasteData(''); setMonthlyPasteClearFirst(false); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseFullMonthlyPLPaste();
                        setFullMonthlyPastePreview(preview);
                      }}
                      disabled={fullMonthlyPasteData.trim() === ''}
                      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg disabled:opacity-50"
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    {/* Detection Summary */}
                    <div className="grid grid-cols-6 gap-2 mb-4">
                      <div className="bg-green-50 p-2 rounded-lg text-center border border-green-200">
                        <div className="text-lg font-bold text-green-700">{fullMonthlyPastePreview.parsed.revenue.length}</div>
                        <div className="text-xs text-green-600">Revenue</div>
                      </div>
                      <div className="bg-orange-50 p-2 rounded-lg text-center border border-orange-200">
                        <div className="text-lg font-bold text-orange-700">{fullMonthlyPastePreview.parsed.cogs.length}</div>
                        <div className="text-xs text-orange-600">COGS</div>
                      </div>
                      <div className="bg-red-50 p-2 rounded-lg text-center border border-red-200">
                        <div className="text-lg font-bold text-red-700">{fullMonthlyPastePreview.parsed.opex.length}</div>
                        <div className="text-xs text-red-600">Operating Exp</div>
                      </div>
                      <div className="bg-blue-50 p-2 rounded-lg text-center border border-blue-200">
                        <div className="text-lg font-bold text-blue-700">{fullMonthlyPastePreview.parsed.otherIncome.length}</div>
                        <div className="text-xs text-blue-600">Other Inc</div>
                      </div>
                      <div className="bg-purple-50 p-2 rounded-lg text-center border border-purple-200">
                        <div className="text-lg font-bold text-purple-700">{fullMonthlyPastePreview.parsed.otherExpense.length}</div>
                        <div className="text-xs text-purple-600">Other Exp</div>
                      </div>
                      <div className="bg-gray-100 p-2 rounded-lg text-center border border-gray-300">
                        <div className="text-lg font-bold text-gray-700">{fullMonthlyPastePreview.totalRows}</div>
                        <div className="text-xs text-gray-600">Total Rows</div>
                      </div>
                    </div>
                    
                    {/* Months Detected */}
                    <div className="mb-3 p-2 bg-gray-50 rounded text-sm">
                      <strong>Months detected:</strong> {fullMonthlyPastePreview.detectedMonths.filter(m => m < 12).length} months 
                      {fullMonthlyPastePreview.detectedMonths.some(m => m >= 12) && ` + ${fullMonthlyPastePreview.detectedMonths.filter(m => m >= 12).length} archive months`}
                    </div>
                    
                    {/* Debug Info - Show when 0 rows detected */}
                    {fullMonthlyPastePreview.totalRows === 0 && fullMonthlyPastePreview.debugInfo && (
                      <div className="mb-3 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm">
                        <div className="font-medium text-amber-800 mb-2">⚠️ Parsing Debug Info</div>
                        <div className="text-xs text-amber-700 space-y-1">
                          <div>• Total lines received: <strong>{fullMonthlyPastePreview.debugInfo.totalLines}</strong></div>
                          <div>• Lines with account names: <strong>{fullMonthlyPastePreview.debugInfo.linesWithNames}</strong></div>
                          <div>• Lines with numeric values: <strong>{fullMonthlyPastePreview.debugInfo.linesWithValues}</strong></div>
                          <div>• Section headers detected: <strong>{fullMonthlyPastePreview.debugInfo.sectionHeaders}</strong></div>
                          <div>• Subtotals skipped: <strong>{fullMonthlyPastePreview.debugInfo.subtotals}</strong></div>
                          <div>• Month columns: {Object.entries(fullMonthlyPastePreview.monthColumns).map(([col, month]) => `col${col}→M${month}`).join(', ') || 'None'}</div>
                        </div>
                        <div className="mt-2 text-xs text-amber-600">
                          If months detected but 0 rows parsed, try copying the ENTIRE P&L including the header row with month names.
                        </div>
                      </div>
                    )}
                    
                    {/* TTM Totals by Section */}
                    <div className="mb-4 p-3 bg-white border rounded-lg">
                      <div className="font-medium mb-2">TTM Totals (Sum of 12 months)</div>
                      <div className="grid grid-cols-5 gap-3 text-xs">
                        {Object.entries(fullMonthlyPastePreview.verification).map(([section, data]) => {
                          const sectionLabels = { revenue: 'Revenue', cogs: 'COGS', opex: 'Operating Exp', otherIncome: 'Other Income', otherExpense: 'Other Expense' };
                          return (
                            <div key={section} className="p-2 bg-gray-50 rounded">
                              <div className="font-medium">{sectionLabels[section]}</div>
                              <div className="text-sm font-mono">{formatCurrency(data.ttmTotal)}</div>
                              <div className="text-gray-500">{data.count} rows</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    
                    {/* Skipped Rows */}
                    {fullMonthlyPastePreview.skipped.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-gray-500 mb-1">
                          ⊘ Skipped Subtotals ({fullMonthlyPastePreview.skipped.length})
                        </div>
                        <div className="max-h-24 overflow-y-auto border rounded text-xs bg-gray-50">
                          <div className="p-2 space-y-1">
                            {fullMonthlyPastePreview.skipped.map((row, idx) => (
                              <div key={idx} className="text-gray-500">
                                {row.name} <span className="text-gray-400">({row.reason})</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Account Search Box */}
                    <div className="mb-3">
                      <div className="flex gap-2 items-center">
                        <input
                          type="text"
                          placeholder="Search for account (e.g., 'Solutions Eng')..."
                          className="flex-1 px-2 py-1 border rounded text-sm"
                          onChange={(e) => {
                            const search = e.target.value.toLowerCase();
                            const results = [];
                            ['revenue', 'cogs', 'opex', 'otherIncome', 'otherExpense'].forEach(section => {
                              fullMonthlyPastePreview.parsed[section].forEach((row, idx) => {
                                if (row.name.toLowerCase().includes(search)) {
                                  const ttm = row.monthValues.slice(0, 12).reduce((s, v) => s + v, 0);
                                  results.push({ section, name: row.name, ttm });
                                }
                              });
                            });
                            // Store search results in a data attribute for display
                            e.target.dataset.results = JSON.stringify(results.slice(0, 10));
                            e.target.dataset.totalMatches = results.length;
                            // Escape before innerHTML — account names come from uploaded
                            // financials, so a crafted line name shouldn't be able to
                            // inject markup into a staff browser. (2026-06-23)
                            const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));
                            // Force re-render by updating parent
                            e.target.nextSibling && (e.target.nextSibling.innerHTML = results.length > 0
                              ? `<div class="text-xs text-green-600 mt-1">${results.length} match${results.length !== 1 ? 'es' : ''}: ${results.slice(0, 5).map(r => `<span class="bg-green-100 px-1 rounded">${esc(r.name.slice(0, 40))} (${esc(r.section)}, $${r.ttm.toLocaleString()})</span>`).join(', ')}${results.length > 5 ? '...' : ''}</div>`
                              : (e.target.value.length > 0 ? `<div class="text-xs text-red-500 mt-1">No matches found for "${esc(e.target.value)}"</div>` : ''));
                          }}
                        />
                        <span className="text-xs text-gray-500">🔍</span>
                      </div>
                      <div></div>
                    </div>
                    
                    {/* Preview Tables by Section */}
                    <div className="space-y-3 max-h-64 overflow-y-auto">
                      {[
                        { key: 'revenue', label: 'Revenue', headerClass: 'bg-green-100 text-green-800', rowClass: 'bg-green-50' },
                        { key: 'cogs', label: 'COGS', headerClass: 'bg-orange-100 text-orange-800', rowClass: 'bg-orange-50' },
                        { key: 'opex', label: 'Operating Expenses', headerClass: 'bg-red-100 text-red-800', rowClass: 'bg-red-50' },
                        { key: 'otherIncome', label: 'Other Income', headerClass: 'bg-blue-100 text-blue-800', rowClass: 'bg-blue-50' },
                        { key: 'otherExpense', label: 'Other Expense', headerClass: 'bg-purple-100 text-purple-800', rowClass: 'bg-purple-50' }
                      ].map(({ key, label, headerClass, rowClass }) => {
                        const rows = fullMonthlyPastePreview.parsed[key];
                        if (rows.length === 0) return null;
                        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                        const sectionTotal = rows.reduce((sum, row) => sum + row.monthValues.slice(0, 12).reduce((s, v) => s + v, 0), 0);
                        return (
                          <div key={key} className="border rounded overflow-hidden">
                            <div className={`${headerClass} px-2 py-1 text-sm font-medium flex justify-between`}>
                              <span>{label} ({rows.length} rows)</span>
                              <span className="font-bold">TTM: {formatCurrency(sectionTotal)}</span>
                            </div>
                            <table className="w-full text-xs">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="p-1 text-left">Account</th>
                                  {monthNames.slice(0, 6).map((m, i) => (
                                    <th key={i} className="p-1 text-right">{m}</th>
                                  ))}
                                  <th className="p-1 text-right">...</th>
                                  <th className="p-1 text-right font-bold">TTM</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.slice(0, 5).map((row, idx) => {
                                  const ttm = row.monthValues.slice(0, 12).reduce((s, v) => s + v, 0);
                                  return (
                                    <tr key={idx} className={idx % 2 === 0 ? rowClass : 'bg-white'}>
                                      <td className="p-1 border-b">{row.name}</td>
                                      {row.monthValues.slice(0, 6).map((v, i) => (
                                        <td key={i} className="p-1 border-b text-right font-mono">{formatCurrency(v)}</td>
                                      ))}
                                      <td className="p-1 border-b text-center text-gray-400">...</td>
                                      <td className="p-1 border-b text-right font-mono font-bold">{formatCurrency(ttm)}</td>
                                    </tr>
                                  );
                                })}
                                {rows.length > 5 && (
                                  <tr className="bg-gray-50">
                                    <td colSpan={9} className="p-1 text-center text-gray-500">
                                      ... and {rows.length - 5} more rows
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  
                  {/* Clear warning if enabled */}
                  {monthlyPasteClearFirst && (
                    <div className="mb-4 p-3 bg-amber-100 border border-amber-300 rounded-lg flex items-center gap-2">
                      <span className="text-amber-700 text-lg">⚠️</span>
                      <div className="text-sm text-amber-800">
                        <strong>Clear & Replace mode:</strong> All existing monthly data will be cleared before importing these {fullMonthlyPastePreview.totalRows} rows.
                        <span className="block text-xs text-amber-600 mt-1">Go back to uncheck "Clear existing monthly data" if you want to merge instead.</span>
                      </div>
                    </div>
                  )}
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => setFullMonthlyPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowFullMonthlyPasteModal(false); setFullMonthlyPasteData(''); setFullMonthlyPastePreview(null); setMonthlyPasteClearFirst(false); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={applyFullMonthlyPLPaste}
                      className={`px-4 py-2 ${monthlyPasteClearFirst ? 'bg-amber-600 hover:bg-amber-700' : 'bg-purple-600 hover:bg-purple-700'} text-white rounded-lg`}
                    >
                      {monthlyPasteClearFirst ? '🔄 Clear & ' : ''}Apply {fullMonthlyPastePreview.totalRows} Rows to {selectedValuationBasis === 'cash' ? 'Cash' : 'Accrual'} Monthly
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Full Balance Sheet Paste Modal */}
        {showFullBSPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[90vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Full Balance Sheet</h3>
                <button onClick={() => { setShowFullBSPasteModal(false); setFullBSPasteData(''); setFullBSPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!fullBSPastePreview ? (
                <>
                  <div className="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
                    <div className="font-medium mb-2">📋 How to use:</div>
                    <ol className="text-sm space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>Balance Sheet by Year</strong> (or comparative report)</li>
                      <li>Select <strong>ALL rows</strong> from Assets through Equity</li>
                      <li>Copy (Ctrl+C) - include account names and year columns</li>
                      <li>Paste below (Ctrl+V)</li>
                    </ol>
                    <div className="mt-3 text-sm">
                      <strong>Auto-detection:</strong> Current Assets, Fixed Assets, Other Assets, Current Liabilities, Long-Term Liabilities, and Equity sections will be detected.
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Full Balance Sheet Below
                    </label>
                    <textarea 
                      value={fullBSPasteData}
                      onChange={e => setFullBSPasteData(e.target.value)}
                      placeholder={"Account\t2022\t2023\t2024\tInterim\nAssets\nCurrent Assets\nCash\t50000\t75000\t100000\t125000\nAccounts Receivable\t150000\t180000\t200000\t220000\n..."}
                      className="w-full px-3 py-2 border rounded-lg h-64 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = fullBSPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button onClick={() => { setShowFullBSPasteModal(false); setFullBSPasteData(''); }} className="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
                    <button 
                      onClick={() => setFullBSPastePreview(parseFullBSPaste())}
                      disabled={fullBSPasteData.trim() === ''}
                      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg disabled:opacity-50"
                    >Preview →</button>
                  </div>
                </>
              ) : (
                <>
                  {/* Monthly Data Warning */}
                  {fullBSPastePreview.monthlyDataWarning && (
                    <div className="mb-4 p-4 bg-amber-50 border-2 border-amber-400 rounded-lg">
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">⚠️</span>
                        <div>
                          <div className="font-bold text-amber-800 mb-1">Monthly Data Detected!</div>
                          <p className="text-sm text-amber-700 mb-2">
                            This appears to be <strong>monthly balance sheet data</strong> (found {fullBSPastePreview.monthsDetected} months: Jan, Feb, Mar, etc.). 
                            This paste modal is for <strong>yearly</strong> data (Year 1, Year 2, Year 3, Interim).
                          </p>
                          <p className="text-sm text-amber-700 mb-3">
                            For monthly balance sheet data, please use the <strong>TTM BS</strong> tab instead.
                          </p>
                          <div className="flex gap-2">
                            <button 
                              onClick={() => {
                                setShowFullBSPasteModal(false);
                                setFullBSPasteData('');
                                setFullBSPastePreview(null);
                                setViewMode('ttmbalancesheet');
                              }}
                              className="px-3 py-1.5 bg-purple-600 text-white text-sm rounded hover:bg-purple-700 font-medium"
                            >
                              Go to TTM BS →
                            </button>
                            <button 
                              onClick={() => setFullBSPastePreview(null)}
                              className="px-3 py-1.5 border border-gray-300 text-sm rounded hover:bg-gray-50"
                            >
                              ← Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {!fullBSPastePreview.monthlyDataWarning && (
                  <div className="mb-4">
                    {/* Detection Summary */}
                    <div className="grid grid-cols-6 gap-2 mb-4">
                      {[
                        { key: 'currentAssets', label: 'Current Assets', color: 'blue' },
                        { key: 'fixedAssets', label: 'Fixed Assets', color: 'slate' },
                        { key: 'otherAssets', label: 'Other Assets', color: 'gray' },
                        { key: 'currentLiabilities', label: 'Current Liab', color: 'orange' },
                        { key: 'longTermLiabilities', label: 'Long-Term Liab', color: 'red' },
                        { key: 'equity', label: 'Equity', color: 'green' }
                      ].map(({ key, label, color }) => (
                        <div key={key} className={`bg-${color}-50 p-2 rounded-lg text-center border border-${color}-200`}>
                          <div className={`text-lg font-bold text-${color}-700`}>{fullBSPastePreview.parsed[key].length}</div>
                          <div className={`text-xs text-${color}-600`}>{label}</div>
                        </div>
                      ))}
                    </div>
                    
                    {/* Year Columns Mapping */}
                    <div className="mb-3 p-3 bg-gray-50 rounded border">
                      <div className="font-medium mb-2 flex items-center gap-2">
                        📅 Year Column Mapping
                        {fullBSPastePreview.yearMatchInfo?.some(y => y.warning || y.willOverwrite) && (
                          <span className="text-amber-600 text-xs font-normal">⚠️ Review mappings below</span>
                        )}
                      </div>
                      <div className="space-y-1 text-sm">
                        {fullBSPastePreview.yearMatchInfo?.map((info, idx) => (
                          <div key={idx} className={`flex items-center justify-between p-1.5 rounded ${
                            info.matchType === 'exact' ? 'bg-green-50' :
                            info.matchType === 'position' ? 'bg-blue-50' :
                            info.matchType === 'new' || info.willOverwrite ? 'bg-amber-50' :
                            'bg-gray-100'
                          }`}>
                            <div className="flex items-center gap-2">
                              <span className="font-mono bg-white px-2 py-0.5 rounded border">{info.detected}</span>
                              <span className="text-gray-400">→</span>
                              <span className="font-medium">{info.mappedTo === 'interim' ? 'Interim' : info.mappedTo.replace('year', 'Year ')}</span>
                              {info.label && info.label !== info.detected && info.label !== 'Interim' && (
                                <span className="text-gray-500 text-xs">(currently: {info.label})</span>
                              )}
                            </div>
                            <div className="flex items-center gap-1">
                              {info.matchType === 'exact' && (
                                <span className="text-green-600 text-xs">✓ Exact match</span>
                              )}
                              {info.matchType === 'position' && (
                                <span className="text-blue-600 text-xs">📍 By position</span>
                              )}
                              {info.willOverwrite && (
                                <span className="text-amber-600 text-xs font-medium">⚠️ Will overwrite</span>
                              )}
                            </div>
                          </div>
                        )) || (
                          <div className="text-gray-500">
                            {fullBSPastePreview.detectedYears.map(y => y === 'interim' ? 'Interim' : `Year ${y.replace('year', '')}`).join(', ')}
                          </div>
                        )}
                      </div>
                      {fullBSPastePreview.yearMatchInfo?.some(y => y.warning) && (
                        <div className="mt-2 p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700">
                          {fullBSPastePreview.yearMatchInfo.filter(y => y.warning).map((y, i) => (
                            <div key={i}>⚠️ {y.warning}</div>
                          ))}
                        </div>
                      )}
                    </div>
                    
                    {/* Skipped */}
                    {fullBSPastePreview.skipped.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-gray-500 mb-1">⊘ Skipped ({fullBSPastePreview.skipped.length})</div>
                        <div className="max-h-20 overflow-y-auto border rounded text-xs bg-gray-50 p-2">
                          {fullBSPastePreview.skipped.map((r, i) => <div key={i} className="text-gray-500">{r.name}</div>)}
                        </div>
                      </div>
                    )}
                    
                    {/* Preview by Section */}
                    <div className="space-y-2 max-h-64 overflow-y-auto">
                      {[
                        { key: 'currentAssets', label: 'Current Assets', headerClass: 'bg-blue-100 text-blue-800' },
                        { key: 'fixedAssets', label: 'Fixed Assets', headerClass: 'bg-slate-100 text-slate-800' },
                        { key: 'otherAssets', label: 'Other Assets', headerClass: 'bg-gray-100 text-gray-800' },
                        { key: 'currentLiabilities', label: 'Current Liabilities', headerClass: 'bg-orange-100 text-orange-800' },
                        { key: 'longTermLiabilities', label: 'Long-Term Liabilities', headerClass: 'bg-red-100 text-red-800' },
                        { key: 'equity', label: 'Equity', headerClass: 'bg-green-100 text-green-800' }
                      ].map(({ key, label, headerClass }) => {
                        const rows = fullBSPastePreview.parsed[key];
                        if (rows.length === 0) return null;
                        return (
                          <div key={key} className="border rounded overflow-hidden">
                            <div className={`${headerClass} px-2 py-1 text-sm font-medium`}>{label} ({rows.length})</div>
                            <table className="w-full text-xs">
                              <tbody>
                                {rows.slice(0, 3).map((row, idx) => (
                                  <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                                    <td className="p-1 border-b">{row.name}</td>
                                    {fullBSPastePreview.detectedYears.map(yr => (
                                      <td key={yr} className="p-1 border-b text-right font-mono">{formatCurrency(row.yearValues[yr])}</td>
                                    ))}
                                  </tr>
                                ))}
                                {rows.length > 3 && <tr><td colSpan={5} className="p-1 text-center text-gray-400">...{rows.length - 3} more</td></tr>}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  )}
                  
                  {!fullBSPastePreview.monthlyDataWarning && (
                  <div className="flex gap-2 justify-end items-center">
                    <button onClick={() => setFullBSPastePreview(null)} className="px-4 py-2 border rounded-lg hover:bg-gray-50">← Back</button>
                    <button onClick={() => { setShowFullBSPasteModal(false); setFullBSPasteData(''); setFullBSPastePreview(null); }} className="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
                    <label className="flex items-center gap-1.5 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg cursor-pointer">
                      <input type="checkbox" checked={bsPasteClearInterimOnly} onChange={e => { setBsPasteClearInterimOnly(e.target.checked); if (e.target.checked) setBsPasteClearFirst(false); }} />
                      <span className="text-sm font-medium text-blue-800">Clear Interim Only</span>
                    </label>
                    <label className="flex items-center gap-1.5 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg cursor-pointer">
                      <input type="checkbox" checked={bsPasteClearFirst} onChange={e => { setBsPasteClearFirst(e.target.checked); if (e.target.checked) setBsPasteClearInterimOnly(false); }} />
                      <span className="text-sm font-medium text-amber-800">Clear & Replace</span>
                    </label>
                    <button onClick={applyFullBSPaste} className={`px-4 py-2 ${bsPasteClearFirst ? 'bg-amber-600 hover:bg-amber-700' : bsPasteClearInterimOnly ? 'bg-blue-600 hover:bg-blue-700' : 'bg-purple-600 hover:bg-purple-700'} text-white rounded-lg`}>
                      {bsPasteClearFirst ? '🔄 Clear & ' : bsPasteClearInterimOnly ? '🔄 Clear Interim + ' : ''}Apply {fullBSPastePreview.totalRows} Rows
                    </button>
                  </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {/* Interim Balance Sheet Paste Modal */}
        {showInterimBSPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[800px] max-h-[90vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Interim Balance Sheet</h3>
                <button onClick={() => { setShowInterimBSPasteModal(false); setInterimBSPasteData(''); setInterimBSPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!interimBSPastePreview ? (
                <>
                  <div className="mb-4 p-4 bg-teal-50 border border-teal-200 rounded-lg">
                    <div className="font-medium mb-2">📋 How to use:</div>
                    <ol className="text-sm space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>Balance Sheet</strong> as of a specific date (e.g., "As of Nov 30, 2024")</li>
                      <li>Select <strong>ALL rows</strong> from Assets through Equity</li>
                      <li>Copy (Ctrl+C) and paste below</li>
                    </ol>
                    <div className="mt-3 text-sm text-teal-700">
                      <strong>Note:</strong> This will update only the <strong>Interim</strong> column. Your Year 1, Year 2, and Year 3 data will not be affected.
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Interim Balance Sheet Below
                    </label>
                    <textarea 
                      value={interimBSPasteData}
                      onChange={e => setInterimBSPasteData(e.target.value)}
                      placeholder={"Account\tTotal\nAssets\nCurrent Assets\nCash\t125000\nAccounts Receivable\t220000\nFixed Assets\nEquipment\t25000\nLiabilities\nCurrent Liabilities\nAccounts Payable\t55000\n..."}
                      className="w-full px-3 py-2 border rounded-lg h-64 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = interimBSPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button onClick={() => { setShowInterimBSPasteModal(false); setInterimBSPasteData(''); }} className="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
                    <button 
                      onClick={() => setInterimBSPastePreview(parseInterimBSPaste())}
                      disabled={interimBSPasteData.trim() === ''}
                      className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg disabled:opacity-50"
                    >Preview →</button>
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-4">
                    {/* Detection Summary */}
                    <div className="grid grid-cols-6 gap-2 mb-4">
                      {[
                        { key: 'currentAssets', label: 'Current Assets', color: 'blue' },
                        { key: 'fixedAssets', label: 'Fixed Assets', color: 'slate' },
                        { key: 'otherAssets', label: 'Other Assets', color: 'gray' },
                        { key: 'currentLiabilities', label: 'Current Liab', color: 'orange' },
                        { key: 'longTermLiabilities', label: 'Long-Term Liab', color: 'red' },
                        { key: 'equity', label: 'Equity', color: 'green' }
                      ].map(({ key, label, color }) => (
                        <div key={key} className={`bg-${color}-50 p-2 rounded-lg text-center border border-${color}-200`}>
                          <div className={`text-lg font-bold text-${color}-700`}>{interimBSPastePreview.parsed[key].length}</div>
                          <div className={`text-xs text-${color}-600`}>{label}</div>
                          <div className={`text-xs text-${color}-500`}>{formatCurrency(interimBSPastePreview.verification[key]?.total || 0)}</div>
                        </div>
                      ))}
                    </div>
                    
                    {/* Skipped */}
                    {interimBSPastePreview.skipped.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-gray-500 mb-1">⊘ Skipped ({interimBSPastePreview.skipped.length})</div>
                        <div className="max-h-20 overflow-y-auto border rounded text-xs bg-gray-50 p-2">
                          {interimBSPastePreview.skipped.map((r, i) => <div key={i} className="text-gray-500">{r.name}</div>)}
                        </div>
                      </div>
                    )}
                    
                    {/* Preview by Section */}
                    <div className="space-y-2 max-h-64 overflow-y-auto">
                      {[
                        { key: 'currentAssets', label: 'Current Assets', headerClass: 'bg-blue-100 text-blue-800' },
                        { key: 'fixedAssets', label: 'Fixed Assets', headerClass: 'bg-slate-100 text-slate-800' },
                        { key: 'otherAssets', label: 'Other Assets', headerClass: 'bg-gray-100 text-gray-800' },
                        { key: 'currentLiabilities', label: 'Current Liabilities', headerClass: 'bg-orange-100 text-orange-800' },
                        { key: 'longTermLiabilities', label: 'Long-Term Liabilities', headerClass: 'bg-red-100 text-red-800' },
                        { key: 'equity', label: 'Equity', headerClass: 'bg-green-100 text-green-800' }
                      ].map(({ key, label, headerClass }) => {
                        const rows = interimBSPastePreview.parsed[key];
                        if (rows.length === 0) return null;
                        return (
                          <div key={key} className="border rounded overflow-hidden">
                            <div className={`${headerClass} px-2 py-1 text-sm font-medium`}>{label} ({rows.length})</div>
                            <table className="w-full text-xs">
                              <tbody>
                                {rows.slice(0, 4).map((row, idx) => (
                                  <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                                    <td className="p-1 border-b">{row.name}</td>
                                    <td className="p-1 border-b text-right font-mono">{formatCurrency(row.value)}</td>
                                  </tr>
                                ))}
                                {rows.length > 4 && <tr><td colSpan={2} className="p-1 text-center text-gray-400">...{rows.length - 4} more</td></tr>}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    </div>
                    
                    {/* Target column indicator */}
                    <div className="mt-4 p-3 bg-teal-50 rounded-lg border border-teal-200">
                      <div className="text-sm text-teal-800">
                        <strong>Target:</strong> These values will be applied to the <strong>Interim</strong> column only.
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end items-center">
                    <label className="flex items-center gap-1.5 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg cursor-pointer mr-auto">
                      <input type="checkbox" checked={interimBSPasteClearFirst} onChange={e => setInterimBSPasteClearFirst(e.target.checked)} />
                      <span className="text-sm font-medium text-amber-800">Clear Interim First</span>
                      {interimBSPasteClearFirst && <span className="text-xs text-amber-600">(zeros all existing interim values before applying)</span>}
                    </label>
                    <button onClick={() => setInterimBSPastePreview(null)} className="px-4 py-2 border rounded-lg hover:bg-gray-50">← Back</button>
                    <button onClick={() => { setShowInterimBSPasteModal(false); setInterimBSPasteData(''); setInterimBSPastePreview(null); setInterimBSPasteClearFirst(false); }} className="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
                    <button onClick={applyInterimBSPaste} className={`px-4 py-2 ${interimBSPasteClearFirst ? 'bg-amber-600 hover:bg-amber-700' : 'bg-teal-600 hover:bg-teal-700'} text-white rounded-lg`}>
                      {interimBSPasteClearFirst ? '🔄 Clear & ' : ''}Apply {interimBSPastePreview.totalRows} Rows to Interim
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Full TTM Balance Sheet Paste Modal */}
        {showFullTtmBSPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[900px] max-h-[90vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📋 Paste Full Monthly Balance Sheet</h3>
                <button onClick={() => { setShowFullTtmBSPasteModal(false); setFullTtmBSPasteData(''); setFullTtmBSPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!fullTtmBSPastePreview ? (
                <>
                  <div className="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
                    <div className="font-medium mb-2">📋 How to use:</div>
                    <ol className="text-sm space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>Balance Sheet by Month</strong> (12 month report)</li>
                      <li>Select <strong>ALL rows</strong> from Assets through Equity</li>
                      <li>Copy (Ctrl+C) and paste below</li>
                    </ol>
                    <div className="mt-3 text-sm">
                      <strong>Auto-detection:</strong> All 6 Balance Sheet sections will be detected (Current Assets, Fixed Assets, Other Assets, Current Liabilities, Long-Term Liabilities, Equity).
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Paste Full Monthly Balance Sheet Data</label>
                    <textarea 
                      value={fullTtmBSPasteData}
                      onChange={e => setFullTtmBSPasteData(e.target.value)}
                      placeholder={"Account\tJan\tFeb\tMar\tApr\tMay\tJun\tJul\tAug\tSep\tOct\tNov\tDec\nAssets\nCurrent Assets\nCash\t50000\t52000\t48000\t55000\t60000\t58000\t62000\t65000\t70000\t68000\t72000\t75000\nAccounts Receivable\t150000\t155000\t160000\t158000\t165000\t170000\t175000\t180000\t185000\t190000\t195000\t200000\nFixed Assets\nEquipment\t25000\t25000\t25000\t25000\t25000\t25000\t25000\t25000\t25000\t25000\t25000\t25000\nLiabilities\nCurrent Liabilities\nAccounts Payable\t30000\t32000\t28000\t35000\t38000\t40000\t42000\t45000\t48000\t50000\t52000\t55000\n..."}
                      className="w-full px-3 py-2 border rounded-lg h-64 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = fullTtmBSPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button onClick={() => { setShowFullTtmBSPasteModal(false); setFullTtmBSPasteData(''); }} className="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
                    <button 
                      onClick={() => setFullTtmBSPastePreview(parseFullTtmBSPaste())}
                      disabled={fullTtmBSPasteData.trim() === ''}
                      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg disabled:opacity-50"
                    >Preview →</button>
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-4">
                    {/* Summary - All 6 sections */}
                    <div className="grid grid-cols-7 gap-2 mb-4">
                      {[
                        { key: 'currentAssets', label: 'Current Assets', color: 'blue' },
                        { key: 'fixedAssets', label: 'Fixed Assets', color: 'slate' },
                        { key: 'otherAssets', label: 'Other Assets', color: 'gray' },
                        { key: 'currentLiabilities', label: 'Current Liab', color: 'orange' },
                        { key: 'longTermLiabilities', label: 'Long-Term Liab', color: 'red' },
                        { key: 'equity', label: 'Equity', color: 'green' }
                      ].map(({ key, label, color }) => (
                        <div key={key} className={`bg-${color}-50 p-2 rounded-lg text-center border border-${color}-200`}>
                          <div className={`text-lg font-bold text-${color}-700`}>{fullTtmBSPastePreview.parsed[key]?.length || 0}</div>
                          <div className={`text-xs text-${color}-600`}>{label}</div>
                        </div>
                      ))}
                      <div className="bg-purple-50 p-2 rounded-lg text-center border border-purple-200">
                        <div className="text-lg font-bold text-purple-700">{fullTtmBSPastePreview.detectedMonths.length}</div>
                        <div className="text-xs text-purple-600">Months</div>
                      </div>
                    </div>
                    
                    {/* Skipped */}
                    {fullTtmBSPastePreview.skipped.length > 0 && (
                      <div className="mb-3">
                        <div className="text-sm font-medium text-gray-500 mb-1">⊘ Skipped ({fullTtmBSPastePreview.skipped.length})</div>
                        <div className="max-h-16 overflow-y-auto border rounded text-xs bg-gray-50 p-2">
                          {fullTtmBSPastePreview.skipped.map((r, i) => <span key={i} className="text-gray-500 mr-2">{r.name}</span>)}
                        </div>
                      </div>
                    )}
                    
                    {/* Preview Tables - All 6 sections */}
                    <div className="space-y-2 max-h-64 overflow-y-auto">
                      {[
                        { key: 'currentAssets', label: 'Current Assets', headerClass: 'bg-blue-100 text-blue-800' },
                        { key: 'fixedAssets', label: 'Fixed Assets', headerClass: 'bg-slate-100 text-slate-800' },
                        { key: 'otherAssets', label: 'Other Assets', headerClass: 'bg-gray-100 text-gray-800' },
                        { key: 'currentLiabilities', label: 'Current Liabilities', headerClass: 'bg-orange-100 text-orange-800' },
                        { key: 'longTermLiabilities', label: 'Long-Term Liabilities', headerClass: 'bg-red-100 text-red-800' },
                        { key: 'equity', label: 'Equity', headerClass: 'bg-green-100 text-green-800' }
                      ].map(({ key, label, headerClass }) => {
                        const rows = fullTtmBSPastePreview.parsed[key] || [];
                        if (rows.length === 0) return null;
                        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                        return (
                          <div key={key} className="border rounded overflow-hidden">
                            <div className={`${headerClass} px-2 py-1 text-sm font-medium`}>{label} ({rows.length})</div>
                            <table className="w-full text-xs">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="p-1 text-left">Account</th>
                                  {monthNames.slice(0, 6).map((m, i) => <th key={i} className="p-1 text-right">{m}</th>)}
                                  <th className="p-1 text-center">...</th>
                                  <th className="p-1 text-right font-bold">Avg</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.slice(0, 3).map((row, idx) => {
                                  const nz = row.monthValues.filter(v => v !== 0);
                                  const avg = nz.length > 0 ? nz.reduce((a, b) => a + b, 0) / nz.length : 0;
                                  return (
                                    <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                                      <td className="p-1 border-b">{row.name}</td>
                                      {row.monthValues.slice(0, 6).map((v, i) => <td key={i} className="p-1 border-b text-right font-mono">{formatCurrency(v)}</td>)}
                                      <td className="p-1 border-b text-center text-gray-400">...</td>
                                      <td className="p-1 border-b text-right font-mono font-bold">{formatCurrency(avg)}</td>
                                    </tr>
                                  );
                                })}
                                {rows.length > 3 && <tr><td colSpan={9} className="p-1 text-center text-gray-400">...{rows.length - 3} more</td></tr>}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end items-center">
                    <label className="flex items-center gap-2 text-sm text-gray-600 mr-4 cursor-pointer">
                      <input type="checkbox" checked={fullTtmBSPasteClearFirst} onChange={e => setFullTtmBSPasteClearFirst(e.target.checked)} className="rounded" />
                      <span className={fullTtmBSPasteClearFirst ? 'text-amber-700 font-medium' : ''}>Clear & Replace</span>
                      {fullTtmBSPasteClearFirst && <span className="text-xs text-amber-600">(clears existing monthly BS data)</span>}
                    </label>
                    <button onClick={() => setFullTtmBSPastePreview(null)} className="px-4 py-2 border rounded-lg hover:bg-gray-50">← Back</button>
                    <button onClick={() => { setShowFullTtmBSPasteModal(false); setFullTtmBSPasteData(''); setFullTtmBSPastePreview(null); setFullTtmBSPasteClearFirst(false); }} className="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
                    <button onClick={applyFullTtmBSPaste} className={`px-4 py-2 ${fullTtmBSPasteClearFirst ? 'bg-amber-600 hover:bg-amber-700' : 'bg-purple-600 hover:bg-purple-700'} text-white rounded-lg`}>
                      {fullTtmBSPasteClearFirst ? '🔄 Clear & ' : ''}Apply {fullTtmBSPastePreview.totalRows} Rows
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Client Detail Import Options Modal */}
        {showClientImportModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[500px]">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📤 Import Client Detail Form</h3>
                <button onClick={() => { setShowClientImportModal(false); setClientImportFile(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              <div className="mb-4 p-3 bg-gray-100 rounded-lg">
                <div className="text-sm font-medium text-gray-700">File: <span className="text-blue-600">{clientImportFile?.name}</span></div>
              </div>
              
              <div className="mb-4">
                <div className="font-medium text-gray-700 mb-2">Import Mode:</div>
                
                <label className="flex items-start gap-3 p-3 border rounded-lg mb-2 cursor-pointer hover:bg-blue-50 transition-colors">
                  <input 
                    type="radio" 
                    checked={clientImportOverwrite} 
                    onChange={() => setClientImportOverwrite(true)}
                    className="mt-1"
                  />
                  <div>
                    <div className="font-semibold text-gray-800">🔄 Overwrite (Recommended)</div>
                    <div className="text-xs text-gray-600 mt-1">
                      Replace ALL client details with values from the Excel file.<br/>
                      <strong>Clears all client detail first</strong> (every client, cash and accrual), then loads this file — clients not in the file end up blank.<br/>
                      <span className="text-green-700">Use this for a corrected or re-numbered report. Undo works.</span>
                    </div>
                  </div>
                </label>
                
                <label className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:bg-blue-50 transition-colors">
                  <input 
                    type="radio" 
                    checked={!clientImportOverwrite} 
                    onChange={() => setClientImportOverwrite(false)}
                    className="mt-1"
                  />
                  <div>
                    <div className="font-semibold text-gray-800">➕ Merge (Add Only)</div>
                    <div className="text-xs text-gray-600 mt-1">
                      Only update fields that have values in the Excel file.<br/>
                      Empty cells in Excel will <strong>keep</strong> existing values in the tool.<br/>
                      <span className="text-amber-700">Use this to add new info without losing existing data.</span>
                    </div>
                  </div>
                </label>
              </div>
              
              <div className="bg-amber-50 border border-amber-200 p-3 rounded-lg mb-4 text-xs">
                <div className="font-medium text-amber-800">💡 Tip: Undo Available</div>
                <div className="text-amber-700">If the import doesn't work as expected, use <strong>Ctrl+Z</strong> (or click the Undo button) to revert.</div>
              </div>
              
              <div className="flex justify-end gap-2">
                <button 
                  onClick={() => { setShowClientImportModal(false); setClientImportFile(null); }}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button 
                  onClick={() => importClientDetailTemplate(null, clientImportOverwrite)}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold"
                >
                  Import {clientImportOverwrite ? '(Overwrite)' : '(Merge)'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Sales Grid Paste Modal */}
        {showSalesGridPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[700px] max-h-[85vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📊 Paste Grid - Customer Sales</h3>
                <button onClick={() => { setShowSalesGridPasteModal(false); setSalesGridPasteData(''); setSalesGridPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!salesGridPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-blue-800 mb-1">📋 Smart Year Matching</div>
                    <div className="text-blue-700 text-xs">
                      Paste your Sales by Customer report - years are detected automatically from column headers.
                      <div className="mt-1">• <strong>5-Year Report</strong> (year columns only) → maps to Year 1-5</div>
                      <div>• <strong>TTM Report</strong> (has "Total" column) → uses Total for TTM only</div>
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-gray-800 mb-1">💡 How to use:</div>
                    <ol className="text-gray-600 text-xs space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>Sales by Customer Summary</strong></li>
                      <li>For 5-Year Report: Display columns by <strong>Years</strong> (no Total column)</li>
                      <li>For TTM Report: Display columns by <strong>Years</strong> with <strong>Total</strong> column</li>
                      <li>Select all customer rows (include header row)</li>
                      <li>Copy (Ctrl+C) and paste below (Ctrl+V)</li>
                    </ol>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Data Below <span className="text-gray-500 font-normal">(Customer Name + Year values, tab-separated)</span>
                    </label>
                    <textarea 
                      value={salesGridPasteData}
                      onChange={e => setSalesGridPasteData(e.target.value)}
                      placeholder={"5-Year Report Example:\nCustomer Name\t2021\t2022\t2023\t2024\t2025\nAcme Corp\t50000\t61000\t72000\t85000\t92000\n\nTTM Report Example:\nCustomer Name\t2025\t2026\tTotal\nAcme Corp\t45000\t47000\t92000"}
                      className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = salesGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowSalesGridPasteModal(false); setSalesGridPasteData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseSalesGridPaste();
                        setSalesGridPastePreview(preview);
                      }}
                      disabled={salesGridPasteData.trim() === ''}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    {/* Year Column Mapping */}
                    {salesGridPastePreview.yearMatchInfo && salesGridPastePreview.yearMatchInfo.length > 0 && (
                      <div className="mb-4 p-3 bg-slate-50 rounded-lg border">
                        <div className="font-medium text-gray-700 mb-2 flex items-center gap-2">
                          📅 Year Column Mapping
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {salesGridPastePreview.yearMatchInfo.map((info, idx) => (
                            <div key={idx} className={`px-2 py-1 rounded text-xs ${
                              info.matchType === 'exact' ? 'bg-green-100 text-green-800' :
                              info.matchType === 'position' ? 'bg-blue-100 text-blue-800' :
                              info.matchType === 'new' ? 'bg-amber-100 text-amber-800' :
                              info.matchType === 'skipped' ? 'bg-gray-200 text-gray-500' :
                              'bg-gray-100 text-gray-700'
                            }`}>
                              <span className="font-medium">{info.detected}</span>
                              {info.matchType === 'skipped' ? (
                                <span className="mx-1 line-through">→ skipped</span>
                              ) : (
                                <>
                                  <span className="mx-1">→</span>
                                  <span>{info.mappedTo === 'ttm' ? 'TTM' : info.mappedTo.replace('year', 'Year ')}</span>
                                </>
                              )}
                              {info.matchType === 'exact' && <span className="ml-1 text-green-600">✓</span>}
                              {info.matchType === 'position' && <span className="ml-1">📍</span>}
                              {info.matchType === 'new' && <span className="ml-1">⚠️</span>}
                              {info.matchType === 'skipped' && <span className="ml-1">⏭️</span>}
                            </div>
                          ))}
                        </div>
                        {salesGridPastePreview.yearMatchInfo.some(i => i.warning) && (
                          <div className="mt-2 text-xs text-amber-700 bg-amber-50 p-2 rounded">
                            {salesGridPastePreview.yearMatchInfo.filter(i => i.warning).map((i, idx) => (
                              <div key={idx}>⚠️ {i.warning}</div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    
                    {/* Summary */}
                    <div className="grid grid-cols-3 gap-3 mb-4">
                      <div className="bg-green-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-green-700">{salesGridPastePreview.matched.length}</div>
                        <div className="text-xs text-green-600">Matched Customers</div>
                      </div>
                      <div className="bg-blue-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-blue-700">{salesGridPastePreview.newRows.length}</div>
                        <div className="text-xs text-blue-600">New Customers</div>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-gray-500">{salesGridPastePreview.noData.length}</div>
                        <div className="text-xs text-gray-500">Existing (No Data)</div>
                      </div>
                    </div>
                    
                    {/* Matched rows */}
                    {salesGridPastePreview.matched.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-green-700 mb-2">✓ Will Update ({salesGridPastePreview.matched.length})</div>
                        <div className="bg-green-50 rounded-lg p-2 max-h-32 overflow-y-auto text-xs">
                          {salesGridPastePreview.matched.map((row, idx) => (
                            <div key={idx} className="flex justify-between py-1 border-b border-green-100 last:border-0">
                              <span className="font-medium">{row.name}</span>
                              <span className="text-green-600">
                                {row.matchType === 'fuzzy' && <span className="text-orange-500 mr-2">≈ {row.matchedTo.name}</span>}
                                TTM: ${(row.yearValues.ttm || 0).toLocaleString()}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* New rows */}
                    {salesGridPastePreview.newRows.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-blue-700 mb-2">+ Will Add ({salesGridPastePreview.newRows.length})</div>
                        <div className="bg-blue-50 rounded-lg p-2 max-h-32 overflow-y-auto text-xs">
                          {salesGridPastePreview.newRows.map((row, idx) => (
                            <div key={idx} className="flex justify-between py-1 border-b border-blue-100 last:border-0">
                              <span className="font-medium">{row.name}</span>
                              <span className="text-blue-600">TTM: ${(row.yearValues.ttm || 0).toLocaleString()}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* Existing with no data */}
                    {salesGridPastePreview.noData.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-gray-500 mb-2">○ No Match Found ({salesGridPastePreview.noData.length})</div>
                        <div className="bg-gray-50 rounded-lg p-2 max-h-24 overflow-y-auto text-xs text-gray-500">
                          {salesGridPastePreview.noData.slice(0, 10).map((item, idx) => (
                            <span key={idx} className="inline-block mr-2">{item.name}{idx < Math.min(salesGridPastePreview.noData.length, 10) - 1 ? ',' : ''}</span>
                          ))}
                          {salesGridPastePreview.noData.length > 10 && <span>... and {salesGridPastePreview.noData.length - 10} more</span>}
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex gap-2 justify-end items-center flex-wrap">
                    <div className="flex items-center gap-3 mr-auto text-sm">
                      <label className="flex items-center gap-1.5 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={salesGridClearTtmOnly}
                          onChange={e => { setSalesGridClearTtmOnly(e.target.checked); if (e.target.checked) setSalesGridClearReplace(false); }}
                        />
                        <span className={`text-sm font-medium ${salesGridClearTtmOnly ? "text-amber-700" : "text-gray-600"}`}>Clear Annual Only</span>
                        {salesGridClearTtmOnly && <span className="text-xs text-amber-600">(zeros year1-5 on all existing, preserves TTM)</span>}
                      </label>
                      <label className="flex items-center gap-1.5 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={salesGridClearReplace}
                          onChange={e => { setSalesGridClearReplace(e.target.checked); if (e.target.checked) setSalesGridClearTtmOnly(false); }}
                        />
                        <span className={salesGridClearReplace ? 'text-red-700 font-medium' : 'text-gray-600'}>
                          Clear & Replace
                        </span>
                        {salesGridClearReplace && <span className="text-xs text-red-500">(removes all existing sales data)</span>}
                      </label>
                    </div>
                    <button 
                      onClick={() => setSalesGridPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowSalesGridPasteModal(false); setSalesGridPasteData(''); setSalesGridPastePreview(null); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={applySalesGridPaste}
                      className={`px-4 py-2 text-white rounded-lg ${salesGridClearReplace ? 'bg-red-600 hover:bg-red-700' : salesGridClearTtmOnly ? 'bg-amber-600 hover:bg-amber-700' : 'bg-purple-600 hover:bg-purple-700'}`}
                    >
                      {salesGridClearReplace ? '⚠ Clear & Replace' : salesGridClearTtmOnly ? '🔄 Clear Annual + Apply' : 'Apply'} {salesGridPastePreview.matched.length + salesGridPastePreview.newRows.length} Customers
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Client Details Paste Grid Modal */}
        {showClientDetailsPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[750px] max-h-[85vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📊 Paste Grid - Client Details</h3>
                <button onClick={() => { setShowClientDetailsPasteModal(false); setClientDetailsPasteData(''); setClientDetailsPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!clientDetailsPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className="bg-purple-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-purple-800 mb-1">📋 How to use:</div>
                    <ol className="text-purple-700 text-xs space-y-1 list-decimal list-inside">
                      <li>Export client details from your PSA/CRM (ConnectWise, Datto, HaloPSA, etc.)</li>
                      <li>Include header row with column names</li>
                      <li>Columns auto-detected: Customer/Client, Type, Billing, Endpoints, Industry, Contract dates, etc.</li>
                      <li>Copy all rows including header (Ctrl+C)</li>
                      <li>Paste below (Ctrl+V)</li>
                    </ol>
                    <div className="mt-2 text-xs text-purple-600">
                      <strong>Recognized columns:</strong> Customer/Client/Name, Type/B2B, Billing/Frequency, Endpoints/Devices/Seats, Industry/Vertical, Tenure/Years, Contract, Start, End/Expiry, Auto-Renew, Assignable, Escalator, Escalator %, Term Penalty, At Risk, Notes
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Data Below <span className="text-gray-500 font-normal">(Header + Data rows, tab-separated)</span>
                    </label>
                    <textarea 
                      value={clientDetailsPasteData}
                      onChange={e => setClientDetailsPasteData(e.target.value)}
                      placeholder={"Customer Name\tType\tBilling\tEndpoints\tIndustry\nAcme Corp\tB2B\tMonthly\t45\tManufacturing\nCity Hospital\tB2B\tAnnually\t200\tHealthcare\nSmith Residence\tResidential\tMonthly\t5\t"}
                      className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = clientDetailsPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${Math.max(0, lines.length - 1)} data rows detected (excluding header)`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowClientDetailsPasteModal(false); setClientDetailsPasteData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseClientDetailsPaste();
                        setClientDetailsPastePreview(preview);
                      }}
                      disabled={clientDetailsPasteData.trim() === ''}
                      className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    {/* Detected Columns */}
                    <div className="bg-blue-50 p-3 rounded-lg mb-4">
                      <div className="text-sm font-medium text-blue-800 mb-2">Detected Columns ({clientDetailsPastePreview.headers.length} matched):</div>
                      <div className="flex flex-wrap gap-2 mb-2">
                        {clientDetailsPastePreview.headers.map((h, idx) => (
                          <span key={idx} className="px-2 py-1 bg-white rounded text-xs border">
                            <span className="font-medium">{h.field}</span> ← "{h.header}"
                          </span>
                        ))}
                      </div>
                      {clientDetailsPastePreview.headers.length < 5 && (
                        <div className="text-xs text-amber-700 mt-2 p-2 bg-amber-50 rounded">
                          ⚠️ Only {clientDetailsPastePreview.headers.length} columns detected. If columns are missing, check that your headers include words like: type, status, contract, effective, length, auto, renew, assign, escalator, penalty, billing, tenure
                        </div>
                      )}
                      {clientDetailsPastePreview.debugInfo && (
                        <details className="mt-2">
                          <summary className="text-xs text-gray-500 cursor-pointer">Debug: Raw header row (row {clientDetailsPastePreview.debugInfo.headerRowIndex || 0})</summary>
                          <div className="mt-1 p-2 bg-gray-100 rounded text-xs font-mono overflow-auto">
                            {clientDetailsPastePreview.debugInfo.headerRow.map((h, i) => (
                              <span key={i} className={`mr-2 ${clientDetailsPastePreview.columnMap && Object.values(clientDetailsPastePreview.columnMap).includes(i) ? 'bg-green-200' : ''}`}>
                                [{i}]:"{h}"
                              </span>
                            ))}
                          </div>
                        </details>
                      )}
                    </div>
                    
                    {/* Summary */}
                    <div className="grid grid-cols-2 gap-3 mb-4">
                      <div className="bg-green-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-green-700">{clientDetailsPastePreview.matched.length}</div>
                        <div className="text-xs text-green-600">Matched to Existing Customers</div>
                      </div>
                      <div className="bg-amber-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-amber-700">{clientDetailsPastePreview.notFound.length}</div>
                        <div className="text-xs text-amber-600">Not Found (will be skipped)</div>
                      </div>
                    </div>
                    
                    {/* Matched Preview */}
                    {clientDetailsPastePreview.matched.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-green-700 mb-2">✓ Will Update ({clientDetailsPastePreview.matched.length}):</div>
                        <div className="max-h-40 overflow-auto border rounded">
                          <table className="w-full text-xs">
                            <thead className="bg-green-50 sticky top-0">
                              <tr>
                                <th className="px-2 py-1 text-left">Pasted Name</th>
                                <th className="px-2 py-1 text-left">→ Matched To</th>
                                <th className="px-2 py-1 text-left">Fields to Update</th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientDetailsPastePreview.matched.slice(0, 20).map((row, idx) => (
                                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                  <td className="px-2 py-1">{row.name}</td>
                                  <td className="px-2 py-1 text-green-600">{row.matchedTo.name}</td>
                                  <td className="px-2 py-1 text-gray-500">
                                    {[
                                      row.customerType !== undefined && row.customerType !== '' && `Type: ${row.customerType}`,
                                      (row.atRisk || row.lost || row.statusRaw) && `Status: ${row.lost ? 'Lost' : row.atRisk ? 'At Risk' : 'Active'}`,
                                      row.hasContract !== undefined && `Contract: ${row.hasContract ? 'Yes' : 'No'}`,
                                      row.effectiveDate !== undefined && row.effectiveDate !== '' && `Effective: ${row.effectiveDate}`,
                                      (row.contractLength !== undefined && row.contractLength !== null) ? `Length: ${row.contractLength === 'mtm' ? 'M2M' : row.contractLength + ' mo'}` : null,
                                      row.autoRenewal !== undefined && `Auto-Renew: ${row.autoRenewal ? 'Y' : 'N'}`,
                                      (row.renewedContractLength !== undefined && row.renewedContractLength !== null) ? `Renewed: ${row.renewedContractLength === 'mtm' ? 'M2M' : row.renewedContractLength + ' mo'}` : null,
                                      row.assignable !== undefined && `Assignable: ${row.assignable ? 'Y' : 'N'}`,
                                      row.priceEscalator !== undefined && `Escalator: ${row.priceEscalator ? 'Y' : 'N'}`,
                                      row.escalatorPercent !== undefined && row.escalatorPercent > 0 && `Esc%: ${row.escalatorPercent}%`,
                                      row.earlyTermPenalty !== undefined && `Term Penalty: ${row.earlyTermPenalty ? 'Y' : 'N'}`,
                                      row.billingFrequency !== undefined && row.billingFrequency !== '' && `Billing: ${row.billingFrequency}`,
                                      row.industry !== undefined && row.industry !== '' && `Industry: ${row.industry}`,
                                      row.tenure !== undefined && row.tenure !== '' && `Tenure: ${row.tenure}`,
                                    ].filter(Boolean).join(', ') || 'No changes detected'}
                                  </td>
                                </tr>
                              ))}
                              {clientDetailsPastePreview.matched.length > 20 && (
                                <tr className="bg-gray-100">
                                  <td colSpan="3" className="px-2 py-1 text-center text-gray-500">
                                    ... and {clientDetailsPastePreview.matched.length - 20} more
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    
                    {/* Not Found Preview */}
                    {clientDetailsPastePreview.notFound.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-amber-700 mb-2">⚠️ Not Found - Will Skip ({clientDetailsPastePreview.notFound.length}):</div>
                        <div className="max-h-32 overflow-auto border rounded bg-amber-50 p-2">
                          <div className="text-xs text-amber-700">
                            {clientDetailsPastePreview.notFound.slice(0, 15).map(row => row.name).join(', ')}
                            {clientDetailsPastePreview.notFound.length > 15 && `, ... and ${clientDetailsPastePreview.notFound.length - 15} more`}
                          </div>
                          <div className="text-xs text-amber-600 mt-1">
                            Tip: Add these customers to the Sales Data grid first, then re-paste.
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <label className="flex items-start gap-2 mb-2 text-sm text-gray-700 cursor-pointer">
                    <input type="checkbox" checked={clientPasteReplaceAll} onChange={e => setClientPasteReplaceAll(e.target.checked)} className="mt-1" />
                    <span><strong>Replace all client detail</strong> — clears every client's detail first, then applies this paste (blank cells stay blank; clients not in the paste end up empty). Untick to only add to / update what's there.</span>
                  </label>
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => setClientDetailsPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowClientDetailsPasteModal(false); setClientDetailsPasteData(''); setClientDetailsPastePreview(null); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={applyClientDetailsPaste}
                      disabled={clientDetailsPastePreview.matched.length === 0}
                      className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
                    >
                      Apply to {clientDetailsPastePreview.matched.length} Customers
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Client Notes Expansion Modal */}
        {expandedNoteCustomer && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[500px] max-h-[80vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📝 Notes: {expandedNoteCustomer.name}</h3>
                <button 
                  onClick={() => setExpandedNoteCustomer(null)} 
                  className="text-gray-500 hover:text-gray-700 text-xl"
                >
                  &times;
                </button>
              </div>
              
              <textarea
                value={expandedNoteCustomer.notes}
                onChange={e => setExpandedNoteCustomer({ ...expandedNoteCustomer, notes: e.target.value })}
                className="w-full h-48 p-3 border rounded-lg text-sm resize-none"
                placeholder="Enter notes about this customer..."
                autoFocus
              />
              
              <div className="flex justify-end gap-2 mt-4">
                <button
                  onClick={() => setExpandedNoteCustomer(null)}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setCustomerSalesData(customerSalesData.map(c => 
                      c.id === expandedNoteCustomer.id 
                        ? { ...c, notes: expandedNoteCustomer.notes } 
                        : c
                    ));
                    setExpandedNoteCustomer(null);
                  }}
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Save Notes
                </button>
              </div>
            </div>
          </div>
        )}

        {/* AR Aging Grid Paste Modal */}
        {showARGridPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[700px] max-h-[85vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📊 Paste Grid - AR Aging Report</h3>
                <button onClick={() => { setShowARGridPasteModal(false); setArGridPasteData(''); setArGridPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!arGridPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Column Format</label>
                    <select 
                      value={arGridColumnMap}
                      onChange={e => setArGridColumnMap(e.target.value)}
                      className="w-full px-3 py-2 border rounded-lg bg-blue-50"
                    >
                      <option value="5col">5 Buckets: Current | 31-60 | 61-90 | 91-120 | 120+</option>
                      <option value="4col">4 Buckets: Current | 31-60 | 61-90 | 90+</option>
                      <option value="3col">3 Buckets: Current | 31-60 | 60+</option>
                      <option value="6col">6 Columns: Current | 31-60 | 61-90 | 91-120 | 120+ | Total (ignored)</option>
                    </select>
                    <div className="text-xs text-gray-500 mt-1">
                      Select the format that matches your AR Aging report columns
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-blue-800 mb-1">📋 How to use:</div>
                    <ol className="text-blue-700 text-xs space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>A/R Aging Summary</strong> or <strong>A/R Aging Detail</strong></li>
                      <li>Select all customer rows (exclude totals)</li>
                      <li>Copy (Ctrl+C) - include customer names and aging columns</li>
                      <li>Paste below (Ctrl+V)</li>
                    </ol>
                    <div className="mt-2 text-xs text-blue-600">
                      {arGridColumnMap === '5col' && 'Expected: Customer | Current | 31-60 | 61-90 | 91-120 | 120+'}
                      {arGridColumnMap === '4col' && 'Expected: Customer | Current | 31-60 | 61-90 | 90+'}
                      {arGridColumnMap === '3col' && 'Expected: Customer | Current | 31-60 | 60+'}
                      {arGridColumnMap === '6col' && 'Expected: Customer | Current | 31-60 | 61-90 | 91-120 | 120+ | Total'}
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Data Below <span className="text-gray-500 font-normal">(Customer Name + Aging buckets, tab-separated)</span>
                    </label>
                    <textarea 
                      value={arGridPasteData}
                      onChange={e => setArGridPasteData(e.target.value)}
                      placeholder={
                        arGridColumnMap === '5col' ? "Customer Name\tCurrent\t31-60\t61-90\t91-120\t120+\nAcme Corp\t15000\t5000\t2000\t500\t0\nTechStart LLC\t8000\t0\t0\t0\t0" :
                        arGridColumnMap === '4col' ? "Customer Name\tCurrent\t31-60\t61-90\t90+\nAcme Corp\t15000\t5000\t2000\t500\nTechStart LLC\t8000\t0\t0\t0" :
                        "Customer Name\tCurrent\t31-60\t60+\nAcme Corp\t15000\t5000\t2500\nTechStart LLC\t8000\t0\t0"
                      }
                      className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = arGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowARGridPasteModal(false); setArGridPasteData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseARGridPaste();
                        setArGridPastePreview(preview);
                      }}
                      disabled={arGridPasteData.trim() === ''}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    {/* Debug Info - Column Detection */}
                    {arGridPastePreview.debugInfo && (
                      <div className="mb-3 p-2 bg-gray-100 rounded text-xs font-mono">
                        <div className="font-bold mb-1">Column Detection:</div>
                        <div>Header: {arGridPastePreview.debugInfo.headerCells?.join(', ')}</div>
                        <div>Customer col: {arGridPastePreview.debugInfo.customerNameCol}</div>
                        <div>Aging cols: {JSON.stringify(arGridPastePreview.debugInfo.agingColumns)}</div>
                        <div>Has Current: {String(arGridPastePreview.debugInfo.hasCurrent)}, Has 1-30: {String(arGridPastePreview.debugInfo.has1to30)}</div>
                      </div>
                    )}
                    
                    {/* Summary */}
                    <div className="grid grid-cols-4 gap-3 mb-4">
                      <div className="bg-green-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-green-700">{arGridPastePreview.matched.length}</div>
                        <div className="text-xs text-green-600">Matched</div>
                      </div>
                      <div className="bg-blue-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-blue-700">{arGridPastePreview.newRows.length}</div>
                        <div className="text-xs text-blue-600">New</div>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-gray-500">{arGridPastePreview.noData.length}</div>
                        <div className="text-xs text-gray-500">No Match</div>
                      </div>
                      <div className="bg-purple-50 p-3 rounded-lg text-center">
                        <div className="text-lg font-bold text-purple-700">${(arGridPastePreview.totalAR || 0).toLocaleString()}</div>
                        <div className="text-xs text-purple-600">Total AR</div>
                      </div>
                    </div>
                    
                    {/* Matched rows */}
                    {arGridPastePreview.matched.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-green-700 mb-2">✓ Will Update ({arGridPastePreview.matched.length})</div>
                        <div className="bg-green-50 rounded-lg p-2 max-h-32 overflow-y-auto text-xs">
                          {arGridPastePreview.matched.map((row, idx) => (
                            <div key={idx} className="flex justify-between py-1 border-b border-green-100 last:border-0">
                              <span className="font-medium">{row.customerName}</span>
                              <span className="text-green-600">
                                {row.matchType === 'fuzzy' && <span className="text-orange-500 mr-2">≈ {row.matchedTo.customerName}</span>}
                                Total: ${(row.lineTotal || 0).toLocaleString()}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* New rows */}
                    {arGridPastePreview.newRows.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-blue-700 mb-2">+ Will Add ({arGridPastePreview.newRows.length})</div>
                        <div className="bg-blue-50 rounded-lg p-2 max-h-32 overflow-y-auto text-xs">
                          {arGridPastePreview.newRows.map((row, idx) => (
                            <div key={idx} className="flex justify-between py-1 border-b border-blue-100 last:border-0">
                              <span className="font-medium">{row.customerName}</span>
                              <span className="text-blue-600">Total: ${(row.lineTotal || 0).toLocaleString()}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* Existing with no data */}
                    {arGridPastePreview.noData.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-gray-500 mb-2">○ No Match Found ({arGridPastePreview.noData.length})</div>
                        <div className="bg-gray-50 rounded-lg p-2 max-h-24 overflow-y-auto text-xs text-gray-500">
                          {arGridPastePreview.noData.slice(0, 10).map((item, idx) => (
                            <span key={idx} className="inline-block mr-2">{item.customerName}{idx < Math.min(arGridPastePreview.noData.length, 10) - 1 ? ',' : ''}</span>
                          ))}
                          {arGridPastePreview.noData.length > 10 && <span>... and {arGridPastePreview.noData.length - 10} more</span>}
                        </div>
                      </div>
                    )}
                    
                    {/* Sample Data Preview - First 5 rows with all bucket values */}
                    {arGridPastePreview.parsed && arGridPastePreview.parsed.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-indigo-700 mb-2">Sample Data (first 5 rows) - Column totals at bottom</div>
                        <div className="overflow-x-auto">
                          <table className="w-full text-xs border">
                            <thead className="bg-indigo-50">
                              <tr>
                                <th className="p-1 border text-left">Customer</th>
                                <th className="p-1 border text-right">Current</th>
                                <th className="p-1 border text-right">31-60</th>
                                <th className="p-1 border text-right">61-90</th>
                                <th className="p-1 border text-right">91-120</th>
                                <th className="p-1 border text-right">120+</th>
                                <th className="p-1 border text-right font-bold">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {arGridPastePreview.parsed.slice(0, 5).map((row, idx) => (
                                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                  <td className="p-1 border">{row.customerName?.slice(0, 30)}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.current || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days31to60 || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days61to90 || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days91to120 || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days120plus || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono font-bold">{(row.lineTotal || 0).toLocaleString()}</td>
                                </tr>
                              ))}
                              <tr className="bg-indigo-100 font-bold">
                                <td className="p-1 border">ALL ROWS TOTAL ({arGridPastePreview.parsed.length})</td>
                                <td className="p-1 border text-right font-mono">${arGridPastePreview.parsed.reduce((s, r) => s + (r.values?.current || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${arGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days31to60 || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${arGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days61to90 || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${arGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days91to120 || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${arGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days120plus || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${(arGridPastePreview.totalAR || 0).toLocaleString()}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <label className="flex items-center gap-2 text-sm text-gray-600">
                      <input type="checkbox" checked={arGridPasteClearReplace} onChange={e => setArGridPasteClearReplace(e.target.checked)} />
                      <span className={`text-sm font-medium ${arGridPasteClearReplace ? "text-amber-700" : "text-gray-600"}`}>Clear & Replace</span>
                    </label>
                    <div className="flex gap-2">
                    <button 
                      onClick={() => setArGridPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowARGridPasteModal(false); setArGridPasteData(''); setArGridPastePreview(null); setArGridPasteClearReplace(false); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={applyARGridPaste}
                      className={`px-4 py-2 ${arGridPasteClearReplace ? 'bg-amber-600 hover:bg-amber-700' : 'bg-purple-600 hover:bg-purple-700'} text-white rounded-lg`}
                    >
                      {arGridPasteClearReplace ? '🔄 Clear & Replace' : 'Apply'} {arGridPastePreview.matched.length + arGridPastePreview.newRows.length} Customers
                    </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* AP Aging Grid Paste Modal */}
        {showAPGridPasteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-[700px] max-h-[85vh] overflow-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📊 Paste Grid - AP Aging Report</h3>
                <button onClick={() => { setShowAPGridPasteModal(false); setApGridPasteData(''); setApGridPastePreview(null); }} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              
              {!apGridPastePreview ? (
                <>
                  {/* Step 1: Paste Data */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Column Format</label>
                    <select 
                      value={apGridColumnMap}
                      onChange={e => setApGridColumnMap(e.target.value)}
                      className="w-full px-3 py-2 border rounded-lg bg-blue-50"
                    >
                      <option value="5col">5 Buckets: Current | 31-60 | 61-90 | 91-120 | 120+</option>
                      <option value="4col">4 Buckets: Current | 31-60 | 61-90 | 90+</option>
                      <option value="3col">3 Buckets: Current | 31-60 | 60+</option>
                      <option value="6col">6 Columns: Current | 31-60 | 61-90 | 91-120 | 120+ | Total (ignored)</option>
                    </select>
                    <div className="text-xs text-gray-500 mt-1">
                      Select the format that matches your AP Aging report columns
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-3 rounded-lg mb-4 text-sm">
                    <div className="font-medium text-blue-800 mb-1">📋 How to use:</div>
                    <ol className="text-blue-700 text-xs space-y-1 list-decimal list-inside">
                      <li>In QuickBooks, run <strong>A/P Aging Summary</strong> or <strong>A/P Aging Detail</strong></li>
                      <li>Select all vendor rows (exclude totals)</li>
                      <li>Copy (Ctrl+C) - include vendor names and aging columns</li>
                      <li>Paste below (Ctrl+V)</li>
                    </ol>
                    <div className="mt-2 text-xs text-blue-600">
                      {apGridColumnMap === '5col' && 'Expected: Vendor | Current | 31-60 | 61-90 | 91-120 | 120+'}
                      {apGridColumnMap === '4col' && 'Expected: Vendor | Current | 31-60 | 61-90 | 90+'}
                      {apGridColumnMap === '3col' && 'Expected: Vendor | Current | 31-60 | 60+'}
                      {apGridColumnMap === '6col' && 'Expected: Vendor | Current | 31-60 | 61-90 | 91-120 | 120+ | Total'}
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Paste Data Below <span className="text-gray-500 font-normal">(Vendor Name + Aging buckets, tab-separated)</span>
                    </label>
                    <textarea 
                      value={apGridPasteData}
                      onChange={e => setApGridPasteData(e.target.value)}
                      placeholder={
                        apGridColumnMap === '5col' ? "Vendor Name\tCurrent\t31-60\t61-90\t91-120\t120+\nSupplier A\t5000\t2000\t500\t0\t0\nVendor B\t3000\t0\t0\t0\t0" :
                        apGridColumnMap === '4col' ? "Vendor Name\tCurrent\t31-60\t61-90\t90+\nSupplier A\t5000\t2000\t500\t0\nVendor B\t3000\t0\t0\t0" :
                        "Vendor Name\tCurrent\t31-60\t60+\nSupplier A\t5000\t2000\t500\nVendor B\t3000\t0\t0"
                      }
                      className="w-full px-3 py-2 border rounded-lg h-48 font-mono text-xs"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lines = apGridPasteData.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());
                        return `${lines.length} rows detected`;
                      })()}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 justify-end">
                    <button 
                      onClick={() => { setShowAPGridPasteModal(false); setApGridPasteData(''); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={() => {
                        const preview = parseAPGridPaste();
                        setApGridPastePreview(preview);
                      }}
                      disabled={apGridPasteData.trim() === ''}
                      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg disabled:opacity-50"
                    >
                      Preview →
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step 2: Preview & Confirm */}
                  <div className="mb-4">
                    {/* Debug Info - Column Detection */}
                    {apGridPastePreview.debugInfo && (
                      <div className="mb-3 p-2 bg-gray-100 rounded text-xs font-mono">
                        <div className="font-bold mb-1">Column Detection:</div>
                        <div>Header: {apGridPastePreview.debugInfo.headerCells?.join(', ')}</div>
                        <div>Vendor col: {apGridPastePreview.debugInfo.vendorNameCol}</div>
                        <div>Aging cols: {JSON.stringify(apGridPastePreview.debugInfo.agingColumns)}</div>
                        <div>Has Current: {String(apGridPastePreview.debugInfo.hasCurrent)}, Has 1-30: {String(apGridPastePreview.debugInfo.has1to30)}</div>
                      </div>
                    )}
                    
                    {/* Summary */}
                    <div className="grid grid-cols-4 gap-3 mb-4">
                      <div className="bg-green-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-green-700">{apGridPastePreview.matched.length}</div>
                        <div className="text-xs text-green-600">Matched</div>
                      </div>
                      <div className="bg-blue-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-blue-700">{apGridPastePreview.newRows.length}</div>
                        <div className="text-xs text-blue-600">New</div>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg text-center">
                        <div className="text-2xl font-bold text-gray-500">{apGridPastePreview.noData.length}</div>
                        <div className="text-xs text-gray-500">No Match</div>
                      </div>
                      <div className="bg-purple-50 p-3 rounded-lg text-center">
                        <div className="text-lg font-bold text-purple-700">${(apGridPastePreview.totalAP || 0).toLocaleString()}</div>
                        <div className="text-xs text-purple-600">Total AP</div>
                      </div>
                    </div>
                    
                    {/* Matched rows */}
                    {apGridPastePreview.matched.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-green-700 mb-2">✓ Will Update ({apGridPastePreview.matched.length})</div>
                        <div className="bg-green-50 rounded-lg p-2 max-h-32 overflow-y-auto text-xs">
                          {apGridPastePreview.matched.map((row, idx) => (
                            <div key={idx} className="flex justify-between py-1 border-b border-green-100 last:border-0">
                              <span className="font-medium">{row.vendorName}</span>
                              <span className="text-green-600">
                                {row.matchType === 'fuzzy' && <span className="text-orange-500 mr-2">≈ {row.matchedTo.vendorName}</span>}
                                Total: ${(row.lineTotal || 0).toLocaleString()}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* New rows */}
                    {apGridPastePreview.newRows.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-blue-700 mb-2">+ Will Add ({apGridPastePreview.newRows.length})</div>
                        <div className="bg-blue-50 rounded-lg p-2 max-h-32 overflow-y-auto text-xs">
                          {apGridPastePreview.newRows.map((row, idx) => (
                            <div key={idx} className="flex justify-between py-1 border-b border-blue-100 last:border-0">
                              <span className="font-medium">{row.vendorName}</span>
                              <span className="text-blue-600">Total: ${(row.lineTotal || 0).toLocaleString()}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* Existing with no data */}
                    {apGridPastePreview.noData.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-gray-500 mb-2">○ No Match Found ({apGridPastePreview.noData.length})</div>
                        <div className="bg-gray-50 rounded-lg p-2 max-h-24 overflow-y-auto text-xs text-gray-500">
                          {apGridPastePreview.noData.slice(0, 10).map((item, idx) => (
                            <span key={idx} className="inline-block mr-2">{item.vendorName}{idx < Math.min(apGridPastePreview.noData.length, 10) - 1 ? ',' : ''}</span>
                          ))}
                          {apGridPastePreview.noData.length > 10 && <span>... and {apGridPastePreview.noData.length - 10} more</span>}
                        </div>
                      </div>
                    )}
                    
                    {/* Sample Data Preview */}
                    {apGridPastePreview.parsed && apGridPastePreview.parsed.length > 0 && (
                      <div className="mb-4">
                        <div className="text-sm font-medium text-indigo-700 mb-2">Sample Data (first 5 rows) - Column totals at bottom</div>
                        <div className="overflow-x-auto">
                          <table className="w-full text-xs border">
                            <thead className="bg-indigo-50">
                              <tr>
                                <th className="p-1 border text-left">Vendor</th>
                                <th className="p-1 border text-right">Current</th>
                                <th className="p-1 border text-right">31-60</th>
                                <th className="p-1 border text-right">61-90</th>
                                <th className="p-1 border text-right">91-120</th>
                                <th className="p-1 border text-right">120+</th>
                                <th className="p-1 border text-right font-bold">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {apGridPastePreview.parsed.slice(0, 5).map((row, idx) => (
                                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                  <td className="p-1 border">{row.vendorName?.slice(0, 30)}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.current || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days31to60 || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days61to90 || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days91to120 || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono">{(row.values?.days120plus || 0).toLocaleString()}</td>
                                  <td className="p-1 border text-right font-mono font-bold">{(row.lineTotal || 0).toLocaleString()}</td>
                                </tr>
                              ))}
                              <tr className="bg-indigo-100 font-bold">
                                <td className="p-1 border">ALL ROWS TOTAL ({apGridPastePreview.parsed.length})</td>
                                <td className="p-1 border text-right font-mono">${apGridPastePreview.parsed.reduce((s, r) => s + (r.values?.current || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${apGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days31to60 || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${apGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days61to90 || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${apGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days91to120 || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${apGridPastePreview.parsed.reduce((s, r) => s + (r.values?.days120plus || 0), 0).toLocaleString()}</td>
                                <td className="p-1 border text-right font-mono">${(apGridPastePreview.totalAP || 0).toLocaleString()}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <label className="flex items-center gap-2 text-sm text-gray-600">
                      <input type="checkbox" checked={apGridPasteClearReplace} onChange={e => setApGridPasteClearReplace(e.target.checked)} />
                      <span className={`text-sm font-medium ${apGridPasteClearReplace ? "text-amber-700" : "text-gray-600"}`}>Clear & Replace</span>
                    </label>
                    <div className="flex gap-2">
                    <button 
                      onClick={() => setApGridPastePreview(null)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      ← Back
                    </button>
                    <button 
                      onClick={() => { setShowAPGridPasteModal(false); setApGridPasteData(''); setApGridPastePreview(null); setApGridPasteClearReplace(false); }}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button 
                      onClick={applyAPGridPaste}
                      className={`px-4 py-2 ${apGridPasteClearReplace ? 'bg-amber-600 hover:bg-amber-700' : 'bg-purple-600 hover:bg-purple-700'} text-white rounded-lg`}
                    >
                      {apGridPasteClearReplace ? '🔄 Clear & Replace' : 'Apply'} {apGridPastePreview.matched.length + apGridPastePreview.newRows.length} Vendors
                    </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Paste Answers from Word Modal */}
        {showPasteAnswersModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 max-w-4xl w-full shadow-xl max-h-[90vh] flex flex-col">
              <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                📥 Paste Answers from Word Document
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Paste the Q&A document from the owner. The tool will attempt to match answers to questions automatically.
                <br />
                <span className="text-gray-500">Supported formats: Numbered questions (1., 2., etc.) with answers on the following lines.</span>
              </p>
              
              <div className="grid grid-cols-2 gap-4 flex-1 min-h-0">
                {/* Left: Paste Area */}
                <div className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">Paste Q&A Text:</label>
                  <textarea
                    value={pasteAnswersText}
                    onChange={(e) => {
                      const text = e.target.value;
                      setPasteAnswersText(text);
                      
                      // Parse the text to extract answers
                      if (!text.trim()) {
                        setPasteAnswersPreview([]);
                        setPasteAnswersSkipped([]);
                        return;
                      }
                      
                      // Build sorted questions list with display numbers
                      const sortedQuestions = sortDiscoveryQuestions(sellerQA);
                      
                      // Parse pasted text - look for numbered items
                      const lines = text.split('\n');
                      const parsed = [];
                      let currentQuestion = null;
                      let currentQuestionText = '';
                      let currentAnswer = [];
                      
                      for (let i = 0; i < lines.length; i++) {
                        const line = lines[i];
                        // Check for numbered question (1., 2., Q1, Q2, etc.)
                        const questionMatch = line.match(/^(\d+)[\.\)]\s*(.+)/);
                        
                        if (questionMatch) {
                          // Save previous question/answer
                          if (currentQuestion !== null) {
                            parsed.push({
                              questionNum: currentQuestion,
                              questionText: currentQuestionText,
                              answer: currentAnswer.join('\n').trim()
                            });
                          }
                          currentQuestion = parseInt(questionMatch[1]);
                          currentQuestionText = questionMatch[2];
                          // Check if answer is on the same line after a colon or "Answer:"
                          const restOfLine = questionMatch[2];
                          const answerOnSameLine = restOfLine.match(/(?:Answer[:\s]*)?(.+)/i);
                          if (answerOnSameLine && !sortedQuestions.some(q => restOfLine.toLowerCase().includes(q.question.toLowerCase().substring(0, 30)))) {
                            // This might be an answer on the same line if it doesn't look like a question
                            currentAnswer = [];
                          } else {
                            currentAnswer = [];
                          }
                        } else if (currentQuestion !== null) {
                          // Check if this line starts with "Answer:" or similar
                          const answerLabel = line.match(/^(?:Answer|Response|A)[:\s]+(.*)$/i);
                          if (answerLabel) {
                            currentAnswer.push(answerLabel[1]);
                          } else if (line.trim()) {
                            currentAnswer.push(line);
                          }
                        }
                      }
                      
                      // Don't forget the last one
                      if (currentQuestion !== null) {
                        parsed.push({
                          questionNum: currentQuestion,
                          questionText: currentQuestionText,
                          answer: currentAnswer.join('\n').trim()
                        });
                      }

                      // Match to actual questions (Mark 09-28): by the QUESTION TEXT
                      // first, the number only as a fallback. A questionnaire
                      // downloaded before a question was added or retired has
                      // different numbers (pre-09-25 Real Estate was #29, which is
                      // contingent liabilities today) — matching by number alone
                      // would land answers on the wrong question. A numbered line
                      // that reads like a question but isn't one we ask any more
                      // is set aside (shown, never imported), not number-matched.
                      const norm = t => String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
                      const textMatch = (text) => {
                        const n = norm(text);
                        if (n.length < 15) return null;
                        return sortedQuestions.find(q => {
                          const qn = norm(q.question);
                          return n.startsWith(qn.substring(0, 40)) || qn.startsWith(n.substring(0, 40));
                        }) || null;
                      };
                      const skipped = [];
                      const preview = parsed.map(p => {
                        let matchedQuestion = textMatch(p.questionText);
                        if (!matchedQuestion) {
                          const looksLikeQuestion = /\?\s*$/.test(p.questionText || '') || norm(p.questionText).length >= 40;
                          if (looksLikeQuestion) {
                            if (p.answer) skipped.push({ questionNum: p.questionNum, questionText: p.questionText, answer: p.answer });
                            return null;
                          }
                          const questionIdx = p.questionNum - 1;
                          matchedQuestion = questionIdx >= 0 && questionIdx < sortedQuestions.length
                            ? sortedQuestions[questionIdx]
                            : null;
                        }
                        const displayNum = sortedQuestions.indexOf(matchedQuestion) + 1;
                        return {
                          questionNum: displayNum || p.questionNum,
                          pastedNum: p.questionNum,
                          answer: p.answer,
                          matchedId: matchedQuestion?.id,
                          matchedQuestion: matchedQuestion?.question?.substring(0, 60) + (matchedQuestion?.question?.length > 60 ? '...' : ''),
                          currentAnswer: matchedQuestion?.answer,
                          willOverwrite: matchedQuestion?.answer && matchedQuestion.answer.trim().length > 0
                        };
                      }).filter(p => p && p.answer && p.matchedId);

                      setPasteAnswersPreview(preview);
                      setPasteAnswersSkipped(skipped);
                    }}
                    className="flex-1 p-3 border rounded-lg text-sm font-mono resize-none"
                    placeholder="Paste the Q&A document here...

Example format:
1. Why are you considering selling?
We want to retire and enjoy our grandchildren.

2. Who are the owners/partners?
John Smith (60%) and Jane Doe (40%)

3. What percentage are businesses vs residential?
85% business, 15% residential"
                  />
                </div>
                
                {/* Right: Preview */}
                <div className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">
                    Preview ({pasteAnswersPreview.length} answers matched):
                  </label>
                  <div className="flex-1 border rounded-lg p-2 overflow-y-auto bg-gray-50">
                    {pasteAnswersPreview.length === 0 ? (
                      <div className="text-gray-400 text-sm text-center py-8">
                        Paste Q&A text on the left to see preview...
                      </div>
                    ) : (
                      <div className="space-y-2">
                        {pasteAnswersPreview.map((item, idx) => (
                          <div key={idx} className={`p-2 rounded text-xs ${item.willOverwrite ? 'bg-amber-50 border border-amber-200' : 'bg-green-50 border border-green-200'}`}>
                            <div className="font-medium text-gray-700 mb-1">
                              Q{item.questionNum}: {item.matchedQuestion}
                              {item.pastedNum !== item.questionNum && (
                                <span className="ml-1 font-normal text-blue-700">(was #{item.pastedNum} on their copy)</span>
                              )}
                            </div>
                            <div className="text-gray-600 bg-white p-1 rounded">
                              {item.answer.length > 100 ? item.answer.substring(0, 100) + '...' : item.answer}
                            </div>
                            {item.willOverwrite && (
                              <div className="text-amber-600 mt-1 text-xs">⚠️ Will overwrite existing answer</div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                    {pasteAnswersSkipped.length > 0 && (
                      <div className="mt-2 space-y-2">
                        <div className="text-xs font-medium text-red-700">
                          Not imported — {pasteAnswersSkipped.length} question{pasteAnswersSkipped.length !== 1 ? 's' : ''} we no longer ask (older questionnaire). Read the answer; if it matters, add it to the right question by hand.
                        </div>
                        {pasteAnswersSkipped.map((item, idx) => (
                          <div key={'skip' + idx} className="p-2 rounded text-xs bg-red-50 border border-red-200">
                            <div className="font-medium text-gray-700 mb-1">#{item.questionNum}: {item.questionText.length > 60 ? item.questionText.substring(0, 60) + '...' : item.questionText}</div>
                            <div className="text-gray-600 bg-white p-1 rounded">{item.answer.length > 100 ? item.answer.substring(0, 100) + '...' : item.answer}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex justify-between items-center mt-4 pt-4 border-t">
                <div className="text-sm text-gray-500">
                  {pasteAnswersPreview.filter(p => p.willOverwrite).length > 0 && (
                    <span className="text-amber-600">
                      ⚠️ {pasteAnswersPreview.filter(p => p.willOverwrite).length} answer(s) will be overwritten
                    </span>
                  )}
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setShowPasteAnswersModal(false)}
                    className="px-4 py-2 text-gray-600 hover:text-gray-800"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      if (pasteAnswersPreview.length === 0) {
                        alert('No answers to import. Please paste Q&A text first.');
                        return;
                      }
                      
                      // Apply answers to sellerQA
                      const updatedQA = sellerQA.map(qa => {
                        const match = pasteAnswersPreview.find(p => p.matchedId === qa.id);
                        if (match) {
                          const updates = {
                            ...qa,
                            answer: match.answer,
                            status: 'answered'
                          };
                          // For select-type questions, try to match the answer to an option
                          if (qa.selectOptions && qa.selectOptions.length > 0) {
                            const answerLower = match.answer.toLowerCase().trim();
                            // Try exact label match first
                            let matched = qa.selectOptions.find(opt => opt.label.toLowerCase() === answerLower);
                            // Try partial match (answer contains the label or vice versa)
                            if (!matched) matched = qa.selectOptions.find(opt => answerLower.includes(opt.label.toLowerCase()) || opt.label.toLowerCase().includes(answerLower));
                            // Try matching percentage numbers in the answer to option ranges
                            if (!matched) {
                              const pctMatch = answerLower.match(/(\d+)\s*[-–]\s*(\d+)|(\d+)\s*%/);
                              if (pctMatch) {
                                const pctVal = pctMatch[3] ? parseInt(pctMatch[3]) : (parseInt(pctMatch[1]) + parseInt(pctMatch[2])) / 2;
                                // Find the closest option by checking if pctVal falls in the range implied by the label
                                matched = qa.selectOptions.find(opt => {
                                  const rangeMatch = opt.label.match(/(\d+)\s*[-–]\s*(\d+)/);
                                  if (rangeMatch) {
                                    const low = parseInt(rangeMatch[1]);
                                    const high = parseInt(rangeMatch[2]);
                                    return pctVal >= low && pctVal <= high;
                                  }
                                  return false;
                                });
                              }
                            }
                            if (matched) {
                              updates.numericValue = matched.value;
                              updates.answer = matched.label; // Normalize to the exact label
                            }
                          }
                          return updates;
                        }
                        return qa;
                      });
                      
                      setSellerQA(updatedQA);
                      setShowPasteAnswersModal(false);
                      setPasteAnswersText('');
                      setPasteAnswersPreview([]);
                      setPasteAnswersSkipped([]);
                      
                      alert(`Successfully imported ${pasteAnswersPreview.length} answer(s)!`);
                    }}
                    disabled={pasteAnswersPreview.length === 0}
                    className={`px-4 py-2 rounded-lg font-medium ${
                      pasteAnswersPreview.length > 0
                        ? 'bg-green-600 text-white hover:bg-green-700'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                  >
                    Import {pasteAnswersPreview.length} Answer{pasteAnswersPreview.length !== 1 ? 's' : ''}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Outstanding Items Config Modal */}
        {showRoadmapModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-xl max-h-[90vh] flex flex-col">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <Mail className="w-5 h-5 text-green-600" />
                Outstanding Items
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Configure what to include in the client-facing document.
              </p>
              
              <div className="space-y-3 mb-4">
                <label className="flex items-center gap-3 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={roadmapConfig.showValuation}
                    onChange={e => setRoadmapConfig({...roadmapConfig, showValuation: e.target.checked})}
                    className="w-4 h-4 rounded"
                  />
                  <div>
                    <div className="font-medium text-sm">Show Preliminary Valuation Range</div>
                    <div className="text-xs text-gray-500">Include valuation range and confidence score</div>
                  </div>
                </label>
                
                <label className="flex items-center gap-3 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={roadmapConfig.showAskOwner}
                    onChange={e => setRoadmapConfig({...roadmapConfig, showAskOwner: e.target.checked})}
                    className="w-4 h-4 rounded"
                  />
                  <div>
                    <div className="font-medium text-sm">Show "Questions for You" Section</div>
                    <div className="text-xs text-gray-500">Research items marked "📧 Yes" plus flagged Open Items ({
                      (researchItems || []).filter(r => (r.askOwner || r.status === 'ask_owner') && r.status !== 'complete').length +
                      Object.entries(manualReviewFlags || {}).filter(([k, v]) => v?.flagged && v?.notes).length
                    } items)</div>
                  </div>
                </label>
                
                <label className="flex items-center gap-3 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={roadmapConfig.showCompletedItems}
                    onChange={e => setRoadmapConfig({...roadmapConfig, showCompletedItems: e.target.checked})}
                    className="w-4 h-4 rounded"
                  />
                  <div>
                    <div className="font-medium text-sm">Show Completed Items</div>
                    <div className="text-xs text-gray-500">List documents already received</div>
                  </div>
                </label>
              </div>
              
              {/* Custom Requests Section */}
              <div className="border-t pt-4 mb-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="font-medium text-sm">Custom Requests</div>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => setRoadmapConfig({
                        ...roadmapConfig,
                        customRequests: [...(roadmapConfig.customRequests || []), { id: Date.now(), type: 'document', text: '' }]
                      })}
                      className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
                    >
                      + Document
                    </button>
                    <button
                      type="button"
                      onClick={() => setRoadmapConfig({
                        ...roadmapConfig,
                        customRequests: [...(roadmapConfig.customRequests || []), { id: Date.now(), type: 'question', text: '' }]
                      })}
                      className="px-2 py-1 text-xs bg-amber-100 text-amber-700 rounded hover:bg-amber-200"
                    >
                      + Question
                    </button>
                  </div>
                </div>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {(roadmapConfig.customRequests || []).map((req, idx) => (
                    <div key={req.id} className="flex items-center gap-2">
                      <span className={`text-xs px-1.5 py-0.5 rounded ${req.type === 'document' ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'}`}>
                        {req.type === 'document' ? '📄' : '❓'}
                      </span>
                      <input
                        type="text"
                        value={req.text}
                        onChange={e => {
                          const updated = [...(roadmapConfig.customRequests || [])];
                          updated[idx] = { ...updated[idx], text: e.target.value };
                          setRoadmapConfig({ ...roadmapConfig, customRequests: updated });
                        }}
                        placeholder={req.type === 'document' ? 'Document name...' : 'Question...'}
                        className="flex-1 p-1.5 border rounded text-sm"
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const updated = (roadmapConfig.customRequests || []).filter((_, i) => i !== idx);
                          setRoadmapConfig({ ...roadmapConfig, customRequests: updated });
                        }}
                        className="p-1 text-gray-400 hover:text-red-500"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                  {(roadmapConfig.customRequests || []).length === 0 && (
                    <div className="text-xs text-gray-400 italic text-center py-2">
                      Add custom document requests or questions
                    </div>
                  )}
                </div>
              </div>
              
              <div className="flex gap-3 mt-auto pt-4 border-t">
                <button
                  type="button"
                  onClick={() => setShowRoadmapModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowRoadmapModal(false);
                    generateClientStatusReport();
                  }}
                  className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium"
                >
                  Generate Roadmap
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Export Reports Modal */}
        {showExportModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-xl max-h-[90vh] flex flex-col">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <FileText className="w-5 h-5" />
                Export Reports
              </h3>
              
              <div className="space-y-3 mb-6 overflow-y-auto flex-1 pr-2">
                {/* Presentation Package */}
                <label className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg cursor-pointer hover:bg-blue-100 border border-blue-200">
                  <input 
                    type="checkbox" 
                    checked={exportOptions.presentationPackage}
                    onChange={e => setExportOptions({...exportOptions, presentationPackage: e.target.checked})}
                    className="mt-1 rounded"
                  />
                  <div>
                    <div className="font-semibold text-blue-900">📊 Presentation Package</div>
                    <div className="text-xs text-blue-700">
                      Combined report with Financial Summary, Valuation Drivers, and Valuation Result
                    </div>
                  </div>
                </label>
                
                {/* Value Enhancement */}
                <label className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg cursor-pointer hover:bg-blue-100 border border-blue-200">
                  <input 
                    type="checkbox" 
                    checked={exportOptions.valueEnhancement}
                    onChange={e => setExportOptions({...exportOptions, valueEnhancement: e.target.checked})}
                    className="mt-1 rounded"
                  />
                  <div>
                    <div className="font-semibold text-blue-900">🚀 Value Enhancement Plan</div>
                    <div className="text-xs text-blue-700">
                      Goals and targets for maximizing exit value (short-term improvements)
                    </div>
                  </div>
                </label>
                
                {/* Strategic Blueprint */}
                <label className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg cursor-pointer hover:bg-blue-100 border border-blue-200">
                  <input 
                    type="checkbox" 
                    checked={exportOptions.blueprintReport}
                    onChange={e => setExportOptions({...exportOptions, blueprintReport: e.target.checked})}
                    className="mt-1 rounded"
                  />
                  <div>
                    <div className="font-semibold text-blue-900">🎯 Strategic Value Blueprint</div>
                    <div className="text-xs text-blue-700">
                      Long-term roadmap with year-by-year milestones to target exit valuation
                      {(!blueprintTargetValuation || !blueprintTimelineYears) && <span className="text-amber-600 ml-1">(set target on Value Enhancement tab first)</span>}
                    </div>
                  </div>
                </label>
                
                {/* Analysis Package */}
                <label className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 border border-gray-200">
                  <input 
                    type="checkbox" 
                    checked={exportOptions.analysisPackage}
                    onChange={e => setExportOptions({...exportOptions, analysisPackage: e.target.checked})}
                    className="mt-1 rounded"
                  />
                  <div>
                    <div className="font-semibold text-gray-700">📈 Analysis Package</div>
                    <div className="text-xs text-gray-500">
                      Income Statement views (Full, Trend, Normalized) - Coming Soon
                    </div>
                  </div>
                </label>
                
                {/* Pro Forma Summary — only when the deal has pro forma data */}
                {proFormaCalcs.hasProFormaData && (
                  <label className="flex items-start gap-3 p-3 bg-green-50 rounded-lg cursor-pointer hover:bg-green-100 border border-green-200">
                    <input
                      type="checkbox"
                      checked={exportOptions.proFormaReport}
                      onChange={e => setExportOptions({...exportOptions, proFormaReport: e.target.checked})}
                      className="mt-1 rounded"
                    />
                    <div>
                      <div className="font-semibold text-green-900">📊 Pro Forma Summary</div>
                      <div className="text-xs text-green-700">
                        Combined entity analysis including acquisitions/new clients with historical vs pro forma valuation comparison
                      </div>
                    </div>
                  </label>
                )}

                {/* 🏦 Financing check (Colleen 10-20): ticked by itself once real estate is in the sale */}
                <label className="flex items-start gap-3 p-3 bg-emerald-50 rounded-lg cursor-pointer hover:bg-emerald-100 border border-emerald-200">
                  <input type="checkbox" checked={!!exportOptions.sbaReport} onChange={e => setExportOptions({...exportOptions, sbaReport: e.target.checked})} className="mt-1 rounded" />
                  <div>
                    <div className="font-semibold text-emerald-900">🏦 Financing Check (SBA{sbaParams.reIncluded ? ' + real estate' : ''})</div>
                    <div className="text-xs text-emerald-700">How a buyer would finance it and whether the cash flow covers the payments (1.25× test){sbaParams.reIncluded ? ', including the real estate package' : ''}. From 4. Valuation → SBA Analysis.</div>
                  </div>
                </label>
              </div>
              
              <div className="flex gap-3 justify-end">
                <button
                  onClick={() => setShowExportModal(false)}
                  className="px-4 py-2 rounded text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={exportReports}
                  disabled={!exportOptions.presentationPackage && !exportOptions.valueEnhancement && !exportOptions.blueprintReport && !exportOptions.analysisPackage && !exportOptions.proFormaReport && !exportOptions.sbaReport}
                  className="px-4 py-2 rounded text-white bg-blue-600 hover:bg-blue-700 font-medium disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  Export Selected
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Clear Confirmation Modal */}
        {showClearConfirm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl">
              <h3 className="text-lg font-bold text-gray-900 mb-2">Clear All Data?</h3>
              <p className="text-gray-600 mb-4">
                This will remove all entered data and start fresh. Your prior data is <span className="font-semibold">archived to the revision history first</span> — recoverable across sessions. The <span className="font-semibold text-yellow-700">Undo</span> button also restores it in this session.
              </p>
              <div className="flex gap-3 justify-end">
                <button
                  onClick={() => setShowClearConfirm(false)}
                  className="px-4 py-2 rounded text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmClearDeal}
                  className="px-4 py-2 rounded text-white bg-red-600 hover:bg-red-700 font-medium"
                >
                  Clear All Data
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Sales Export Modal */}
        {showSalesExportModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col shadow-xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">📊 Sales Summary Export</h3>
                <button 
                  onClick={() => setShowSalesExportModal(false)}
                  className="text-gray-500 hover:text-gray-700 text-xl"
                >
                  ×
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-3">Copy this summary for your CIM or other documents:</p>
              <textarea 
                readOnly
                value={salesExportText}
                className="flex-1 w-full p-3 border rounded-lg font-mono text-xs bg-gray-50 min-h-[300px]"
                onClick={e => e.target.select()}
              />
              <div className="flex gap-2 justify-end mt-4">
                <button 
                  onClick={() => setShowSalesExportModal(false)}
                  className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                >
                  Close
                </button>
                <button 
                  onClick={() => {
                    const textarea = document.createElement('textarea');
                    textarea.value = salesExportText;
                    textarea.style.position = 'fixed';
                    textarea.style.left = '-9999px';
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                      document.execCommand('copy');
                      alert('Copied to clipboard!');
                    } catch (err) {
                      alert('Please select the text and copy manually (Ctrl+C / Cmd+C)');
                    }
                    document.body.removeChild(textarea);
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  📋 Copy to Clipboard
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Paste Row Modal */}
        {pasteModal.show && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl mx-4 shadow-xl">
              <h3 className="text-lg font-bold text-gray-900 mb-2">📋 Paste Row Data</h3>
              <p className="text-gray-600 mb-2">
                Pasting into: <span className="font-semibold">{pasteModal.categoryName}</span> ({pasteModal.section})
              </p>
              <p className="text-xs text-gray-500 mb-3">
                Copy a row from Excel (12 months of data, tab-separated). Values will be mapped left to right to match your TTM months.
              </p>
              <textarea
                value={pasteData}
                onChange={e => setPasteData(e.target.value)}
                placeholder="Paste your Excel row here (e.g., 33143    40085    36446    46759    35112    36112    37112    36362    36675    32348    35645    34771)"
                className="w-full h-24 p-3 border rounded text-sm font-mono"
                autoFocus
              />
              <div className="mt-3 p-2 bg-gray-50 rounded text-xs">
                <span className="font-medium">Preview:</span>{' '}
                {pasteData ? (() => {
                  // Split on tabs, newlines, or multiple spaces (NOT commas within numbers)
                  const values = pasteData.split(/[\t\n\r]+|\s{2,}/).map(v => {
                    // Remove $ and commas from within numbers, then parse
                    const cleaned = v.replace(/[$,]/g, '').trim();
                    if (cleaned === '') return null; // Empty cell
                    const num = parseFloat(cleaned);
                    // Keep full precision for preview
                    return isNaN(num) ? null : num;
                  }).filter(v => v !== null); // Only filter out empty strings, NOT zeros
                  return values.slice(0, 12).map((v, i) => (
                    <span key={i} className="inline-block mx-1 px-1 bg-blue-100 rounded">{v % 1 !== 0 ? v.toFixed(2) : v.toLocaleString()}</span>
                  ));
                })() : <span className="text-gray-400">No data yet</span>}
              </div>
              <div className="flex gap-3 justify-end mt-4">
                <button
                  onClick={() => setPasteModal({ show: false, section: null, categoryId: null, categoryName: '' })}
                  className="px-4 py-2 rounded text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    // Capture state before paste
                    captureUndoState(`Paste ${pasteModal.section || 'data'}`);
                    
                    // Split on tabs, newlines, or multiple spaces (NOT commas within numbers)
                    const values = pasteData.split(/[\t\n\r]+|\s{2,}/).map(v => {
                      const cleaned = v.replace(/[$,]/g, '').trim();
                      if (cleaned === '') return null; // Empty cell
                      const num = parseFloat(cleaned);
                      // Keep full precision for accurate totals
                      return isNaN(num) ? null : num;
                    }).filter(v => v !== null); // Only filter out empty strings, NOT zeros
                    
                    // Pad or trim to 12 values
                    const finalValues = [...values.slice(0, 12), ...Array(Math.max(0, 12 - values.length)).fill(0)];
                    
                    // Apply to the appropriate section
                    const updateMonthlyData = (setter) => {
                      setter(prev => {
                        const existing = prev[pasteModal.categoryId] || { cash: Array(24).fill(0), accrual: Array(24).fill(0) };
                        const newBasisData = [...(existing[selectedValuationBasis] || Array(24).fill(0))];
                        finalValues.forEach((v, i) => { newBasisData[i] = v; });
                        return {
                          ...prev,
                          [pasteModal.categoryId]: { ...existing, [selectedValuationBasis]: newBasisData }
                        };
                      });
                    };
                    
                    switch(pasteModal.section) {
                      case 'revenue': updateMonthlyData(setMonthlyTtmRevenue); break;
                      case 'cogs': updateMonthlyData(setMonthlyTtmCogs); break;
                      case 'opex': updateMonthlyData(setMonthlyTtmOpex); break;
                      case 'otherincome': updateMonthlyData(setMonthlyTtmOtherIncome); break;
                      case 'otherexpense': updateMonthlyData(setMonthlyTtmOtherExpense); break;
                      case 'diat':
                        setMonthlyTtmDiat(prev => {
                          const type = pasteModal.categoryId; // depreciation, interest, amortization, or taxes
                          const newBasisData = [...(prev[type]?.[selectedValuationBasis] || Array(24).fill(0))];
                          finalValues.forEach((v, i) => { newBasisData[i] = v; });
                          return {
                            ...prev,
                            [type]: { ...prev[type], [selectedValuationBasis]: newBasisData }
                          };
                        });
                        break;
                    }
                    
                    setPasteModal({ show: false, section: null, categoryId: null, categoryName: '' });
                    setPasteData('');
                  }}
                  className="px-4 py-2 rounded text-white bg-blue-600 hover:bg-blue-700 font-medium"
                >
                  Apply Data
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Revenue Type Split Editor Modal */}
        {splitEditorCategory && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-[500px] max-h-[90vh] overflow-auto">
              <div className="sticky top-0 bg-white border-b p-4">
                <div className="flex justify-between items-center">
                  <h2 className="text-lg font-bold text-gray-800">✂️ Split Revenue by Type</h2>
                  <button onClick={() => setSplitEditorCategory(null)} className="text-gray-500 hover:text-gray-700 text-xl">×</button>
                </div>
                <p className="text-sm text-gray-600 mt-1">{splitEditorCategory.name}</p>
                <p className="text-xs text-amber-600 mt-1">Enter the % of this revenue line that belongs to each type. Total must equal 100%.</p>
              </div>
              <div className="p-4">
                {(() => {
                  const currentSplits = splitEditorCategory.typeSplits || {};
                  const totalPct = Object.values(currentSplits).reduce((sum, v) => sum + (parseFloat(v) || 0), 0);
                  const isValid = Math.abs(totalPct - 100) < 0.1;
                  
                  return (
                    <div>
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="bg-gray-50">
                            <th className="text-left p-2 border">Type</th>
                            <th className="text-center p-2 border w-20">Weight</th>
                            <th className="text-center p-2 border w-24">% of Line</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTypes.filter(t => !t.legacy).map(type => (
                            <tr key={type.id} className={currentSplits[type.id] > 0 ? 'bg-blue-50' : ''}>
                              <td className="p-2 border">
                                <div className="font-medium">{type.label.split(' - ')[0]}</div>
                                <div className="text-xs text-gray-500">{type.label.includes(' - ') ? type.label.split(' - ')[1] : ''}</div>
                              </td>
                              <td className="p-2 border text-center font-mono text-gray-600">{(type.weight * 100).toFixed(0)}%</td>
                              <td className="p-2 border">
                                <input
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="5"
                                  value={currentSplits[type.id] || ''}
                                  onChange={(e) => {
                                    const val = parseFloat(e.target.value) || 0;
                                    setRevenueCategories(prev => prev.map(c => {
                                      if (c.id !== splitEditorCategory.id) return c;
                                      const newSplits = { ...c.typeSplits };
                                      if (val > 0) {
                                        newSplits[type.id] = val;
                                      } else {
                                        delete newSplits[type.id];
                                      }
                                      return { ...c, typeSplits: newSplits };
                                    }));
                                    // Update local state for the modal
                                    setSplitEditorCategory(prev => {
                                      const newSplits = { ...prev.typeSplits };
                                      if (val > 0) {
                                        newSplits[type.id] = val;
                                      } else {
                                        delete newSplits[type.id];
                                      }
                                      return { ...prev, typeSplits: newSplits };
                                    });
                                  }}
                                  className="w-full p-1 border rounded text-center"
                                  placeholder="0"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr className={isValid ? 'bg-green-100' : 'bg-red-100'}>
                            <td className="p-2 border font-bold" colSpan="2">Total</td>
                            <td className={`p-2 border text-center font-bold ${isValid ? 'text-green-700' : 'text-red-700'}`}>
                              {totalPct.toFixed(0)}%
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                      
                      {/* Calculated effective weight */}
                      <div className="mt-4 p-3 bg-gray-50 rounded border">
                        <div className="text-sm font-medium text-gray-700">Effective Weighted Recurring:</div>
                        <div className="text-lg font-bold text-blue-700">
                          {isValid ? (
                            <>
                              {(Object.entries(currentSplits).reduce((sum, [typeId, pct]) => {
                                const weight = revenueTypes.find(t => t.id === typeId)?.weight || 0;
                                return sum + (pct / 100) * weight;
                              }, 0) * 100).toFixed(0)}% of this line counts as recurring
                            </>
                          ) : (
                            <span className="text-red-600">Total must equal 100%</span>
                          )}
                        </div>
                        {isValid && (
                          <div className="text-xs text-gray-500 mt-1">
                            {Object.entries(currentSplits).filter(([_, pct]) => pct > 0).map(([typeId, pct]) => {
                              const type = revenueTypes.find(t => t.id === typeId);
                              return `${pct}% × ${(type?.weight * 100).toFixed(0)}%`;
                            }).join(' + ')}
                          </div>
                        )}
                      </div>
                      
                      <div className="mt-4 flex justify-between">
                        <button
                          onClick={() => {
                            // Clear splits and revert to single type
                            setRevenueCategories(prev => prev.map(c => 
                              c.id === splitEditorCategory.id ? { ...c, typeSplits: {} } : c
                            ));
                            setSplitEditorCategory(prev => ({ ...prev, typeSplits: {} }));
                          }}
                          className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-sm"
                        >
                          Clear Split
                        </button>
                        <button
                          onClick={() => setSplitEditorCategory(null)}
                          className={`px-4 py-1.5 rounded text-sm ${isValid ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-gray-300 text-gray-500'}`}
                          disabled={!isValid && totalPct > 0}
                        >
                          {isValid || totalPct === 0 ? 'Done' : 'Fix Total First'}
                        </button>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        )}

        {/* Revenue Type Definitions Help Panel */}
        {showRevenueTypeHelp && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-50">
            <div className="bg-white w-[600px] h-full overflow-auto shadow-xl">
              <div className="sticky top-0 bg-white border-b p-4 flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-800">📚 Revenue Type Definitions</h2>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={() => {
                      const text = `REVENUE TYPE DEFINITIONS
For Business Valuation Classification

Please review each revenue line item and help us classify it into one of these categories.

THE TEST FOR EVERY LINE: does this revenue repeat by agreement?
"Under contract" is not the test — a signed contract for a one-time
project is still one-time revenue.

═══════════════════════════════════════════════════════════════
1. CONTRACTED - DEFINED REVENUE
═══════════════════════════════════════════════════════════════

DEFINITION:
Revenue where a written agreement obligates REPEATING payments of a defined amount — monthly, quarterly, or annual — for the duration of the contract. A signed contract for a single project does NOT belong here, even though it is technically "under contract."

EXAMPLES:
• Managed services or service-plan agreement: "$5,000/month for 24 months"
• Maintenance or monitoring agreement with a fixed recurring fee
• Subscription with an annual commitment
• Retainer agreements with a defined monthly fee

VERIFICATION NEEDED:
Copy of signed agreement showing dollar amount and term.

═══════════════════════════════════════════════════════════════
2. SERVICE PROJECTS - CONTRACTED CLIENT
═══════════════════════════════════════════════════════════════

DEFINITION:
Service, labor, or project work performed for a client who ALSO has an ongoing service agreement with you. Each project is one-time, but the relationship itself is contractual and recurring. If the client's only contract is the project contract itself, this is NOT the right category — see 4 or 5.

EXAMPLES:
• An install or upgrade for a customer on your maintenance plan
• Implementation work for a client with an active subscription
• A project for a client you provide monthly monitoring to
• Consulting hours for clients under an ongoing agreement

VERIFICATION NEEDED:
Active MSA or agreement on file for this client + sales report shows project revenue from this client.

═══════════════════════════════════════════════════════════════
3. HARDWARE/PRODUCT - CONTRACTED CLIENT
═══════════════════════════════════════════════════════════════

DEFINITION:
Hardware, equipment, or product sales to clients under contract. While the client relationship is ongoing, hardware purchases are inherently lumpy and unpredictable. A client may buy $300K in servers one year and $0 the next.

EXAMPLES:
• Server purchases for an MSA client
• Workstation rollouts for a managed services customer
• Firewall replacements for a contracted client
• Software license resales to existing clients

VERIFICATION NEEDED:
Active MSA or agreement on file + sales report showing hardware/product revenue. Check year-over-year consistency.

═══════════════════════════════════════════════════════════════
4. REPEAT - UNCONTRACTED
═══════════════════════════════════════════════════════════════

DEFINITION:
Consistent, recurring revenue from a client with no formal contract or MSA, where the pattern of purchasing demonstrates ongoing relationship. Client could leave at any time but hasn't.

EXAMPLES:
• Monthly break/fix client who's been with you for 5 years, no contract
• Annual software renewal client with no formal agreement
• Client who buys from you quarterly for 3+ years
• Consulting client who engages you every year for the same project

VERIFICATION NEEDED:
No contract on file (or contract has expired) + sales report shows 2+ years of consistent revenue from this client.

═══════════════════════════════════════════════════════════════
5. TRANSACTIONAL / NEW
═══════════════════════════════════════════════════════════════

DEFINITION:
One-time revenue, new client revenue with no established pattern, or revenue with no expectation of recurrence — INCLUDING signed one-time project contracts (a construction job, a wiring or AV project, a system install). Contracted does not mean recurring. Not predictable for valuation purposes.

EXAMPLES:
• A one-time project under its own contract (build, install, wiring job)
• First project for a new client
• One-time hardware sale with no ongoing relationship
• Emergency work for a non-client

═══════════════════════════════════════════════════════════════
WHY THIS MATTERS
═══════════════════════════════════════════════════════════════

Accurate revenue classification is critical to business valuation. Buyers and their advisors will scrutinize how revenue is categorized during due diligence. Revenue that is predictable, contractually protected, and verified with documentation commands higher valuations than revenue that is one-time or uncontracted.

Classifying revenue accurately upfront avoids surprises later in the process and builds buyer confidence in the business.

═══════════════════════════════════════════════════════════════
ACTION REQUESTED
═══════════════════════════════════════════════════════════════

For each revenue line or category in your financials, please indicate:
1. Which classification applies (1, 2, 3, 4, or 5)
2. If contracts exist, please provide copies
3. For repeat clients without contracts, confirm the tenure (years as customer)

Thank you for your help with this classification!
`;
                      navigator.clipboard.writeText(text);
                      alert('Definitions copied to clipboard! You can paste this into an email.');
                    }}
                    className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 flex items-center gap-1"
                  >
                    📋 Copy Definitions
                  </button>
                  <button 
                    onClick={() => {
                      // Build worksheet with actual revenue lines
                      const revLines = revenueCategories.filter(c => c.name).map(c => {
                        const basisData = c[selectedValuationBasis] || c.cash || {};
                        const currentType = revenueTypes.find(t => t.id === c.revenueType && !t.legacy);
                        return {
                          name: c.name,
                          ttm: basisData.ttm || 0,
                          currentType: currentType?.label || 'Not Set'
                        };
                      });
                      
                      let worksheet = `REVENUE CLASSIFICATION WORKSHEET
${dealProfile.companyName || 'Company Name'}
Generated: ${new Date().toLocaleDateString()}

═══════════════════════════════════════════════════════════════
INSTRUCTIONS
═══════════════════════════════════════════════════════════════

Please review each revenue line below and confirm or update the classification.
For each line, mark the appropriate type (1-4) and note any supporting documentation.

THE TEST: does the revenue repeat by agreement? "Under contract" is not
the test — a signed contract for a one-time project is still one-time.

CLASSIFICATION OPTIONS:
  1 = Contracted - Defined Revenue
      → A written agreement obligates REPEATING payments (monthly/annual).
        NOT one-time project contracts, even signed ones.

  2 = Project - Contracted Client
      → Project work for clients who ALSO have an ongoing service agreement.

  3 = Repeat - Uncontracted
      → Clients who come back again and again with no ongoing agreement (2+ years).

  4 = Transactional / New
      → One-time work and new clients — including signed one-time project contracts.

═══════════════════════════════════════════════════════════════
YOUR REVENUE LINES
═══════════════════════════════════════════════════════════════

`;
                      revLines.forEach((line, idx) => {
                        worksheet += `${idx + 1}. ${line.name}
   TTM Revenue: ${formatCurrency(line.ttm)}
   Current Classification: ${line.currentType}
   
   Your Classification: [ 1 / 2 / 3 / 4 ] ___
   
   Contract on file? [ Yes / No ] ___
   If yes, contract value/term: _______________
   Years as customer (if no contract): ___
   
   Notes: _________________________________

`;
                      });
                      
                      worksheet += `
═══════════════════════════════════════════════════════════════
DOCUMENTATION NEEDED
═══════════════════════════════════════════════════════════════

For lines marked as Type 1 (Contracted):
• Copy of signed agreement showing amount and term

For lines marked as Type 2 (Project - Contracted Client):
• Copy of active MSA or master agreement

For lines marked as Type 3 (Repeat - Uncontracted):
• Confirmation of customer tenure (years)

Please return this worksheet with your notes and any supporting contracts.

Thank you!
`;
                      navigator.clipboard.writeText(worksheet);
                      alert('Worksheet with your revenue lines copied! Paste into an email to send to the owner.');
                    }}
                    className="px-3 py-1.5 bg-purple-600 text-white rounded text-sm hover:bg-purple-700 flex items-center gap-1"
                  >
                    📝 Copy Worksheet
                  </button>
                  <button 
                    onClick={() => setShowRevenueTypeHelp(false)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    &times;
                  </button>
                </div>
              </div>
              
              <div className="p-6 space-y-6">
                {/* Intro */}
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <p className="text-sm text-gray-700">
                    Revenue classification helps determine how predictable and defensible each revenue stream is, which directly impacts valuation.
                    Each category is designed to be <strong>verifiable</strong> with documents you collect during due diligence.
                    <strong> The test for every line: does the revenue repeat by agreement?</strong> "Under contract" is not the test — a signed contract
                    for a one-time project (a build, an install, a wiring job) is still one-time revenue.
                  </p>
                </div>

                {/* Category 1: Contracted - Defined Revenue */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-blue-600 text-white p-3 flex justify-between items-center">
                    <h3 className="font-bold">1. Contracted - Defined Revenue</h3>
                    <span className="bg-white text-green-700 px-2 py-1 rounded font-bold text-xs">HIGHEST</span>
                  </div>
                  <div className="p-4 space-y-3">
                    <div>
                      <div className="font-semibold text-gray-700">Definition:</div>
                      <p className="text-sm text-gray-600">Revenue where a written agreement obligates <strong>repeating</strong> payments of a defined amount — monthly, quarterly, or annual — for the contract duration. A signed contract for a single project does <strong>not</strong> belong here, even though it is technically "under contract" (common misclassification in project businesses — contractors, builders, installers).</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Examples:</div>
                      <ul className="text-sm text-gray-600 list-disc list-inside">
                        <li>MSP managed services agreement: "$5,000/month for 24 months"</li>
                        <li>SaaS subscription with annual commitment</li>
                        <li>Retainer agreements with defined monthly fee</li>
                        <li>Maintenance contracts with fixed annual fee</li>
                        <li>VAR recurring commission where vendor contract specifies ongoing %</li>
                      </ul>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Verification:</div>
                      <p className="text-sm text-gray-600">Copy of signed agreement showing dollar amount and term. Revenue on sales report matches contract terms.</p>
                    </div>
                    <div className="bg-amber-50 p-3 rounded border border-amber-200">
                      <div className="font-semibold text-yellow-800">⚠️ Red Flags / Due Diligence:</div>
                      <ul className="text-sm text-yellow-700 list-disc list-inside mt-1">
                        <li><strong>Contract Cliff (VARs):</strong> Long-term contracts can mask non-renewal risk. Review contract end dates, historical renewal rates, and pipeline strength.</li>
                        <li><strong>Auto-renewal clauses:</strong> Stronger than contracts requiring active renewal</li>
                        <li><strong>Termination for convenience:</strong> 30-day out clauses reduce effective stickiness</li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Category 2: Service Projects - Contracted Client */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-blue-500 text-white p-3 flex justify-between items-center">
                    <h3 className="font-bold">2. Service Projects - Contracted Client</h3>
                    <span className="bg-white text-green-600 px-2 py-1 rounded font-bold text-xs">HIGH</span>
                  </div>
                  <div className="p-4 space-y-3">
                    <div>
                      <div className="font-semibold text-gray-700">Definition:</div>
                      <p className="text-sm text-gray-600">Project, hourly, or variable-scope work performed for a client who <strong>also</strong> has an ongoing service agreement with you — each project is one-time, but the relationship is contractual and recurring. If the client's only contract is the project contract itself, this is <strong>not</strong> the right category — see 4 or 5.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Examples:</div>
                      <ul className="text-sm text-gray-600 list-disc list-inside">
                        <li>Network upgrade project for an MSP client under MSA</li>
                        <li>Implementation work for a SaaS customer with active subscription</li>
                        <li>Consulting hours billed to contracted managed services clients</li>
                        <li>Security assessment for a client you provide monthly monitoring to</li>
                      </ul>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Verification:</div>
                      <p className="text-sm text-gray-600">Active MSA or agreement on file for this client + sales report shows project revenue from this client.</p>
                    </div>
                    <div className="bg-blue-50 p-3 rounded border border-blue-200">
                      <div className="font-semibold text-blue-800">💡 Healthy Benchmark:</div>
                      <p className="text-sm text-blue-700">Companies with strong MSA client bases often show 60-70% contracted revenue and 30-40% project revenue from those same clients. The project work is often higher margin and indicates healthy, expanding client relationships.</p>
                    </div>
                  </div>
                </div>

                {/* Category 3: Hardware/Product - Contracted Client */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-blue-400 text-white p-3 flex justify-between items-center">
                    <h3 className="font-bold">3. Hardware/Product - Contracted Client</h3>
                    <span className="bg-white text-blue-600 px-2 py-1 rounded font-bold text-xs">MODERATE-HIGH</span>
                  </div>
                  <div className="p-4 space-y-3">
                    <div>
                      <div className="font-semibold text-gray-700">Definition:</div>
                      <p className="text-sm text-gray-600">Hardware, equipment, one-time or perpetual software licenses, or product sales to clients under an active MSA or service contract. The product revenue is lumpy and timing-unpredictable, but the contracted relationship creates stickiness and repeat buying patterns.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Examples:</div>
                      <ul className="text-sm text-gray-600 list-disc list-inside">
                        <li>Server and workstation purchases by managed services clients</li>
                        <li>Firewall and network equipment replacements for MSA clients</li>
                        <li>One-time / perpetual software license sales (recurring subscriptions are category 6)</li>
                        <li>Hardware refresh projects for clients under service agreements</li>
                      </ul>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Verification:</div>
                      <p className="text-sm text-gray-600">Active MSA or agreement on file for this client + sales report shows hardware/product revenue from this client.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Weight Rationale:</div>
                      <p className="text-sm text-gray-600">Weighted at 25% because hardware sales are timing-unpredictable (clients don't buy servers every month), but the contracted relationship creates preference and repeat business. Lower than service projects because hardware often has lower margins and less stickiness.</p>
                    </div>
                  </div>
                </div>

                {/* Category 4: Repeat - Uncontracted */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-amber-500 text-white p-3 flex justify-between items-center">
                    <h3 className="font-bold">4. Repeat - Uncontracted</h3>
                    <span className="bg-white text-yellow-600 px-2 py-1 rounded font-bold text-xs">MODERATE</span>
                  </div>
                  <div className="p-4 space-y-3">
                    <div>
                      <div className="font-semibold text-gray-700">Definition:</div>
                      <p className="text-sm text-gray-600">Consistent, recurring revenue from a client with no formal contract or MSA, where the pattern of purchasing demonstrates ongoing relationship. Client could leave at any time but hasn't.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Examples:</div>
                      <ul className="text-sm text-gray-600 list-disc list-inside">
                        <li>Monthly break/fix client who's been with you for 5 years, no contract</li>
                        <li>Annual software renewal client with no formal agreement</li>
                        <li>Client who buys from you quarterly for 3+ years</li>
                        <li>Consulting client who engages you every year for the same project</li>
                      </ul>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Verification:</div>
                      <p className="text-sm text-gray-600">No contract on file (or contract has expired) + sales report shows 2+ years of consistent revenue from this client.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Buyer Perspective:</div>
                      <p className="text-sm text-gray-600">History suggests they'll continue, but there's no legal or structural reason they can't leave tomorrow. Acquirers view this revenue as less predictable than contracted revenue.</p>
                    </div>
                  </div>
                </div>

                {/* Category 5: Transactional / New */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-gray-500 text-white p-3 flex justify-between items-center">
                    <h3 className="font-bold">5. Transactional / New</h3>
                    <span className="bg-white text-gray-600 px-2 py-1 rounded font-bold text-xs">LOWEST</span>
                  </div>
                  <div className="p-4 space-y-3">
                    <div>
                      <div className="font-semibold text-gray-700">Definition:</div>
                      <p className="text-sm text-gray-600">One-time revenue, new client revenue with no established pattern, or revenue with no expectation of recurrence — <strong>including signed one-time project contracts</strong> (a construction job, a wiring or AV project, a system install). Contracted ≠ recurring. Not predictable for valuation purposes.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Examples:</div>
                      <ul className="text-sm text-gray-600 list-disc list-inside">
                        <li>A one-time project under its own contract (build, install, wiring job)</li>
                        <li>First project for a new client</li>
                        <li>One-time hardware sale with no ongoing relationship</li>
                        <li>Emergency work for a non-client</li>
                      </ul>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Buyer Perspective:</div>
                      <p className="text-sm text-gray-600">An acquirer cannot rely on this revenue continuing. The company must continuously sell to replace it.</p>
                    </div>
                    <div className="bg-gray-100 p-3 rounded border">
                      <div className="font-semibold text-gray-700">Note:</div>
                      <p className="text-sm text-gray-600">High % of transactional revenue isn't necessarily bad if gross margins are high, sales pipeline is strong, win rates are stable, and there's a clear path to convert new clients to contracted/repeat.</p>
                    </div>
                  </div>
                </div>

                {/* Category 6: Recurring Licensing / Subscription Resale (09-23) */}
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-blue-500 text-white p-3 flex justify-between items-center">
                    <h3 className="font-bold">6. Recurring Licensing / Subscription Resale</h3>
                    <span className="bg-white text-blue-600 px-2 py-1 rounded font-bold text-xs">HIGH</span>
                  </div>
                  <div className="p-4 space-y-3">
                    <div>
                      <div className="font-semibold text-gray-700">Definition:</div>
                      <p className="text-sm text-gray-600">Software subscriptions and licenses the company resells that renew by agreement — monthly or annual — to clients under an ongoing service relationship. It repeats without a new sale, which is what makes it recurring; it is thin-margin, the vendor sets the terms, and the vendor can bill the client directly, which is why it is not full credit.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Examples:</div>
                      <ul className="text-sm text-gray-600 list-disc list-inside">
                        <li>Microsoft 365 / Google Workspace seats billed monthly under the MSA</li>
                        <li>Security-agent, backup and email-filtering subscriptions billed per seat</li>
                        <li>Annual software subscriptions renewed for service-plan clients</li>
                      </ul>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Verification:</div>
                      <p className="text-sm text-gray-600">Sales by Customer Detail shows the same line recurring each month (or annually) for the client; a service agreement is on file. A one-time or perpetual license is category 3, not 6.</p>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-700">Weight Rationale:</div>
                      <p className="text-sm text-gray-600">Weighted at 75%: it renews by agreement like category 1, but margins are thin, the vendor controls pricing and terms, and a buyer prices the risk that the vendor takes the client direct. Industry recurring-revenue benchmarks count recurring licensing as recurring, so leaving it at 25% understates the business against them.</p>
                    </div>
                  </div>
                </div>

                {/* How it affects valuation */}
                <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
                  <h3 className="font-bold text-purple-800 mb-2">How These Categories Affect Valuation</h3>
                  <p className="text-sm text-gray-700 mb-3">
                    Revenue classification determines the <strong>Weighted Recurring Revenue %</strong>, which feeds into the Multiple Engine's Revenue Quality factor. 
                    Categories higher on this list carry more weight because they represent more predictable, defensible revenue streams.
                  </p>
                  <div className="bg-white p-3 rounded border text-sm">
                    <div className="text-gray-700">
                      <div className="font-semibold mb-2">Predictability Ranking (highest to lowest):</div>
                      <div className="space-y-1">
                        <div className="flex items-center gap-2"><span className="w-3 h-3 rounded bg-blue-600 inline-block"></span> Contracted - Defined Revenue</div>
                        <div className="flex items-center gap-2"><span className="w-3 h-3 rounded bg-blue-500 inline-block"></span> Service Projects - Contracted Client</div>
                        <div className="flex items-center gap-2"><span className="w-3 h-3 rounded bg-blue-400 inline-block"></span> Hardware/Product - Contracted Client</div>
                        <div className="flex items-center gap-2"><span className="w-3 h-3 rounded bg-amber-500 inline-block"></span> Repeat - Uncontracted</div>
                        <div className="flex items-center gap-2"><span className="w-3 h-3 rounded bg-gray-400 inline-block"></span> Transactional / New</div>
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    Accurate classification is critical — misclassifying revenue will surface during buyer due diligence and can erode deal credibility.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Adjustment Copy Menu - Fixed position overlay */}
        {copyMenuOpen.id && copyMenuOpen.item && (
          <>
            {/* Backdrop to close menu */}
            <div 
              className="fixed inset-0 z-40" 
              onClick={() => setCopyMenuOpen({ id: null, x: 0, y: 0, item: null, selectedYears: [] })}
            />
            {/* Menu */}
            <div 
              className="fixed z-50 bg-white border shadow-xl rounded-lg text-sm w-52"
              style={{ 
                left: Math.min(copyMenuOpen.x - 160, window.innerWidth - 220), 
                top: Math.max(copyMenuOpen.y - 280, 10)
              }}
            >
              <div className="px-3 py-2 bg-gray-50 border-b font-medium text-gray-700 rounded-t-lg">
                Copy Adjustment
              </div>
              <button 
                onClick={() => { 
                  // Validate duplicate for same year (only for deductions)
                  if (copyMenuOpen.item.type === 'deduct') {
                    const validation = validateDeduction(copyMenuOpen.item.plLine, copyMenuOpen.item.year, copyMenuOpen.item.amount);
                    if (!validation.valid) {
                      alert(`Cannot duplicate: ${validation.message}`);
                      return;
                    }
                  }
                  setAdjustmentItems([...adjustmentItems, { ...copyMenuOpen.item, id: Date.now(), source: '' }]); 
                  setCopyMenuOpen({ id: null, x: 0, y: 0, item: null, selectedYears: [] }); 
                }}
                className="block w-full text-left px-3 py-2 hover:bg-gray-100 border-b"
              >
                📋 Duplicate row (same year)
              </button>
              
              {/* Multi-select years */}
              <div className="px-3 py-2 text-gray-500 text-xs font-medium bg-gray-50">
                Select periods to copy to:
              </div>
              {[basisYearLabels.year3, basisYearLabels.year4, basisYearLabels.year5, 'TTM'].filter(y => y !== copyMenuOpen.item.year).map(year => {
                // Check if this year would be valid for deductions
                const wouldExceed = copyMenuOpen.item.type === 'deduct' && 
                  !validateDeduction(copyMenuOpen.item.plLine, year, copyMenuOpen.item.amount).valid;
                return (
                  <label 
                    key={year}
                    className={`flex items-center px-3 py-2 cursor-pointer ${wouldExceed ? 'bg-amber-50 text-amber-600' : 'hover:bg-gray-100'}`}
                    title={wouldExceed ? 'Deduction would exceed account balance for this year' : ''}
                  >
                    <input 
                      type="checkbox"
                      checked={copyMenuOpen.selectedYears.includes(year)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setCopyMenuOpen({...copyMenuOpen, selectedYears: [...copyMenuOpen.selectedYears, year]});
                        } else {
                          setCopyMenuOpen({...copyMenuOpen, selectedYears: copyMenuOpen.selectedYears.filter(y => y !== year)});
                        }
                      }}
                      className="mr-2"
                    />
                    {year}
                    {wouldExceed && <span className="ml-1 text-xs">⚠️</span>}
                  </label>
                );
              })}
              
              {/* Quick select all */}
              <div className="border-t px-3 py-1.5 flex justify-between text-xs">
                <button 
                  onClick={() => {
                    const allYears = [basisYearLabels.year3, basisYearLabels.year4, basisYearLabels.year5, 'TTM'].filter(y => y !== copyMenuOpen.item.year);
                    setCopyMenuOpen({...copyMenuOpen, selectedYears: allYears});
                  }}
                  className="text-blue-600 hover:underline"
                >
                  Select all
                </button>
                <button 
                  onClick={() => setCopyMenuOpen({...copyMenuOpen, selectedYears: []})}
                  className="text-gray-500 hover:underline"
                >
                  Clear
                </button>
              </div>
              
              {/* Action buttons */}
              <div className="border-t p-2 flex gap-2">
                <button 
                  onClick={() => setCopyMenuOpen({ id: null, x: 0, y: 0, item: null, selectedYears: [] })}
                  className="flex-1 px-3 py-1.5 text-gray-600 hover:bg-gray-100 rounded border"
                >
                  Cancel
                </button>
                <button 
                  onClick={() => {
                    if (copyMenuOpen.selectedYears.length > 0) {
                      // Validate each year for deductions
                      const validYears = [];
                      const invalidYears = [];
                      
                      copyMenuOpen.selectedYears.forEach(year => {
                        if (copyMenuOpen.item.type === 'deduct') {
                          const validation = validateDeduction(copyMenuOpen.item.plLine, year, copyMenuOpen.item.amount);
                          if (validation.valid) {
                            validYears.push(year);
                          } else {
                            invalidYears.push(year);
                          }
                        } else {
                          validYears.push(year); // Adds don't need validation
                        }
                      });
                      
                      // Only add valid years
                      if (validYears.length > 0) {
                        const newItems = validYears.map(year => ({ 
                          ...copyMenuOpen.item, 
                          id: Date.now() + Math.random(), 
                          year, 
                          source: '' 
                        }));
                        setAdjustmentItems([...adjustmentItems, ...newItems]);
                      }
                      
                      // Alert about invalid years
                      if (invalidYears.length > 0) {
                        alert(`Could not copy to ${invalidYears.join(', ')} - deduction would exceed account balance.${validYears.length > 0 ? ` Copied to ${validYears.join(', ')} successfully.` : ''}`);
                      }
                    }
                    setCopyMenuOpen({ id: null, x: 0, y: 0, item: null, selectedYears: [] });
                  }}
                  disabled={copyMenuOpen.selectedYears.length === 0}
                  className={`flex-1 px-3 py-1.5 rounded font-medium ${
                    copyMenuOpen.selectedYears.length > 0 
                      ? 'bg-blue-600 text-white hover:bg-blue-700' 
                      : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  }`}
                >
                  Copy ({copyMenuOpen.selectedYears.length})
                </button>
              </div>
            </div>
          </>
        )}
        
        {/* ========== FLOATING QUICK NOTE BUTTON ========== */}
        {(() => {
          const openResearchCount = researchItems.filter(r => r.status !== 'complete' && !r.reviewerNote).length;
          const openReviewerCount = researchItems.filter(r => r.status !== 'complete' && r.reviewerNote).length;
          
          const handleAddQuickNote = () => {
            if (!quickNoteText.trim()) return;
            
            const newItem = {
              id: Date.now(),
              item: quickNoteText.trim(),
              notes: `Added from: ${currentSectionName}`,
              priority: quickNotePriority,
              status: 'open',
              createdAt: new Date().toLocaleDateString(),
              source: currentSectionName,
              askOwner: quickNoteAskOwner,
              reviewerNote: quickNoteReviewer
            };
            
            setResearchItems([...researchItems, newItem]);
            setQuickNoteText('');
            setQuickNotePriority('medium');
            setQuickNoteAskOwner(false);
            setQuickNoteReviewer(false);
            setShowQuickNote(false);
          };
          
          return (
            <>
              {/* Floating Button */}
              <button
                onClick={() => setShowQuickNote(true)}
                className="fixed bottom-6 right-6 w-14 h-14 bg-purple-600 hover:bg-purple-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 z-40"
                title="Quick Note (Ctrl+Q)"
              >
                <span className="text-2xl">📝</span>
                {(openResearchCount + openReviewerCount) > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-amber-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {(openResearchCount + openReviewerCount) > 9 ? '9+' : (openResearchCount + openReviewerCount)}
                  </span>
                )}
                {openReviewerCount > 0 && (
                  <span className="absolute -top-1 -left-1 w-5 h-5 bg-indigo-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {openReviewerCount}
                  </span>
                )}
              </button>
              
              {/* Quick Note Modal */}
              {showQuickNote && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" onClick={() => setShowQuickNote(false)}>
                  <div className="bg-white rounded-lg shadow-xl w-96 max-w-[90vw]" onClick={e => e.stopPropagation()}>
                    <div className="bg-purple-600 text-white px-4 py-3 rounded-t-lg flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-xl">📝</span>
                        <span className="font-bold">Quick Note</span>
                      </div>
                      <button onClick={() => setShowQuickNote(false)} className="text-white hover:text-purple-200 text-xl">×</button>
                    </div>
                    
                    <div className="p-4">
                      <div className="mb-3">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Current Location</label>
                        <div className="px-3 py-2 bg-gray-100 rounded text-sm text-gray-700 flex items-center gap-2">
                          <span>📍</span>
                          {currentSectionName}
                        </div>
                      </div>
                      
                      <div className="mb-3">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Question / Note</label>
                        <textarea
                          autoFocus
                          value={quickNoteText}
                          onChange={e => setQuickNoteText(e.target.value)}
                          onKeyDown={e => {
                            if (e.key === 'Enter' && !e.shiftKey && quickNoteText.trim()) {
                              e.preventDefault();
                              handleAddQuickNote();
                            }
                            if (e.key === 'Escape') {
                              setShowQuickNote(false);
                            }
                          }}
                          placeholder="What caught your attention? What needs follow-up?"
                          className="w-full px-3 py-2 border rounded text-sm min-h-[80px] focus:ring-2 focus:ring-purple-300 focus:border-purple-400"
                          rows={3}
                        />
                      </div>
                      
                      <div className="mb-4">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Priority</label>
                        <div className="flex gap-2">
                          {[
                            { value: 'high', label: '🔴 High', color: 'bg-red-100 border-red-300 text-red-700' },
                            { value: 'medium', label: '🟡 Medium', color: 'bg-amber-100 border-amber-300 text-amber-700' },
                            { value: 'low', label: '🔵 Low', color: 'bg-blue-100 border-blue-300 text-blue-700' }
                          ].map(p => (
                            <button
                              key={p.value}
                              onClick={() => setQuickNotePriority(p.value)}
                              className={`flex-1 px-3 py-2 rounded border text-sm font-medium transition-all ${
                                quickNotePriority === p.value 
                                  ? `${p.color} ring-2 ring-offset-1 ring-purple-400` 
                                  : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100'
                              }`}
                            >
                              {p.label}
                            </button>
                          ))}
                        </div>
                      </div>
                      
                      {/* Ask Owner Toggle */}
                      <div className="mb-4">
                        <label 
                          className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                            quickNoteAskOwner 
                              ? 'bg-orange-50 border-orange-400' 
                              : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                          }`}
                          onClick={() => setQuickNoteAskOwner(!quickNoteAskOwner)}
                        >
                          <div className={`w-10 h-6 rounded-full relative transition-colors ${quickNoteAskOwner ? 'bg-orange-500' : 'bg-gray-300'}`}>
                            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform ${quickNoteAskOwner ? 'translate-x-5' : 'translate-x-1'}`}></div>
                          </div>
                          <div>
                            <div className={`font-medium text-sm ${quickNoteAskOwner ? 'text-orange-700' : 'text-gray-700'}`}>
                              📧 Ask Owner
                            </div>
                            <div className="text-xs text-gray-500">Include in Owner Questions report</div>
                          </div>
                        </label>
                      </div>
                      
                      {/* Reviewer Note Toggle */}
                      <div className="mb-4">
                        <label 
                          className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                            quickNoteReviewer 
                              ? 'bg-indigo-50 border-indigo-400' 
                              : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                          }`}
                          onClick={() => setQuickNoteReviewer(!quickNoteReviewer)}
                        >
                          <div className={`w-10 h-6 rounded-full relative transition-colors ${quickNoteReviewer ? 'bg-indigo-500' : 'bg-gray-300'}`}>
                            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform ${quickNoteReviewer ? 'translate-x-5' : 'translate-x-1'}`}></div>
                          </div>
                          <div>
                            <div className={`font-medium text-sm ${quickNoteReviewer ? 'text-indigo-700' : 'text-gray-700'}`}>
                              🔎 Reviewer Note
                            </div>
                            <div className="text-xs text-gray-500">Flag as supervisor review comment</div>
                          </div>
                        </label>
                      </div>
                      
                      <div className="flex gap-2">
                        <button
                          onClick={() => setShowQuickNote(false)}
                          className="flex-1 px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleAddQuickNote}
                          disabled={!quickNoteText.trim()}
                          className={`flex-1 px-4 py-2 rounded font-medium ${
                            quickNoteText.trim()
                              ? quickNoteReviewer 
                                ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                                : 'bg-purple-600 text-white hover:bg-purple-700'
                              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                          }`}
                        >
                          {quickNoteReviewer ? '🔎 Add Reviewer Note' : 'Add to Research'}
                        </button>
                      </div>
                      
                      <p className="text-xs text-gray-400 mt-3 text-center">
                        Press Enter to add • Escape to cancel
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </>
          );
        })()}
      </div>
      
      {/* CIM Prep Request Modal */}
      {showReportRequestModal && (() => {
        const companyName = dealProfile.companyName || '[Company Name]';
        const today = new Date();
        // Prior month end
        const priorMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        const priorMonthEnd = priorMonth.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        const priorMonthShort = priorMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        
        // TTM start: 12 months before prior month end
        const ttmStart = new Date(priorMonth.getFullYear() - 1, priorMonth.getMonth() + 1, 1);
        const ttmStartStr = ttmStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        const ttmRange = `${ttmStartStr} through ${priorMonthShort}`;
        
        // Determine basis
        const hasCash = revenueCategories.some(c => c.cash && Object.values(c.cash).some(v => v !== 0));
        const hasAccrual = revenueCategories.some(c => c.accrual && Object.values(c.accrual).some(v => v !== 0));
        const hasDualBasis = hasCash && hasAccrual;
        const basisLabel = hasDualBasis ? 'Cash AND Accrual' : selectedValuationBasis === 'accrual' ? 'Accrual' : 'Cash';
        
        // Check what's in use
        const hasMonthlyData = monthlyTtmRevenue && Object.keys(monthlyTtmRevenue).length > 0;
        const hasBalSheet = bsCurrentAssets.some(a => a.year1 || a.year2 || a.year3 || a.interim);
        const hasAR = arAgingLineItems && arAgingLineItems.length > 0 && arAgingLineItems.some(li => li.customerName);
        const hasSalesData = customerSalesData.some(c => c.name && c.ttm > 0);
        const hasDualSales = customerSalesDataAlt.length > 0 && customerSalesDataAlt.some(c => c.name);
        const salesBasisLabel = hasDualSales ? 'Cash AND Accrual' : basisLabel;
        // Partial add-backs (Zac 10-01): P&L lines added back at less than 100%. Full add-backs carry over as
        // before; the partial ones need fresh amounts for the TTM, so the request names them.
        const partialAdjNames = [...opexCategories, ...otherExpenseCategories, ...otherIncomeCategories]
          .filter(cat => cat.name && (cat.addbackPct || 0) > 0 && (cat.addbackPct || 0) < 100 && cat.adjIncluded !== false)
          .map(cat => `   • ${cat.name}${cat.adjDescription ? ` — ${cat.adjDescription}` : ''}`);

        const reportLines = [
          `CIM PREP REQUEST — ${companyName}`,
          `Prepared: ${today.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`,
          ``,
          `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`,
          `KEY DATES`,
          `  TTM Period:        ${ttmRange}`,
          `  AR / AP Aging as of: ${priorMonthEnd}`,
          `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`,
          ``,
          `⚠ IMPORTANT: All report dates must align exactly as shown above.`,
          `   Mismatched dates will cause reconciliation errors.`,
          ``,
          `Please provide the following reports exported from your accounting system in Excel format.`,
          ``,
          `FINANCIAL STATEMENTS`,
          `1. Profit & Loss by Month (Cash AND Accrual)`,
          `   Period: ${ttmRange}  (one column per month)`,
          ``,
          `2. Balance Sheet by Month`,
          `   Period: ${ttmRange}  (one column per month, TTM only)`,
          ``,
          `RECEIVABLES & PAYABLES`,
          `3. Accounts Receivable Aging Detail`,
          `   As of: ${priorMonthEnd}  ← must match Balance Sheet date`,
          ``,
          `4. Accounts Payable Aging Detail`,
          `   As of: ${priorMonthEnd}  ← must match Balance Sheet date`,
          ``,
          `SALES`,
          `5. Sales by Customer Summary by Month (${salesBasisLabel})`,
          `   Period: ${ttmRange}  (TTM only, one column per month)`,
          ``,
          `PAYROLL`,
          `6. Owner Payroll Report`,
          `   Period: ${ttmRange}`,
          `   (Owners only — total compensation per owner: wages, bonuses, and employer-paid benefits)`,
          ``,
          `UPDATED PARTIAL EBITDA ADJUSTMENTS`,
          `7. We will apply the same 100% addback treatment to those we did previously.`,
          `   For the partial adjustments, we will need amounts for the period below.`,
          `   Period: ${ttmRange}`,
          ...(partialAdjNames.length ? partialAdjNames : [`   (No partial adjustments on file — nothing needed here.)`]),
          ``,
          `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`,
          `NOTES`,
          `• All financial reports should use the SAME end date: ${priorMonthEnd}`,
          `• P&L reports should show all expense line items — do not summarize or collapse.`,
          `• If both Cash and Accrual versions are available, please provide both.`,
          `• If a report is unavailable, let us know and we will work with what you have.`,
          `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`,
        ];
        
        const reportText = reportLines.join('\n');
        
        return (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-[600px] max-h-[85vh] overflow-auto">
              <div className="flex justify-between items-center p-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900">📋 CIM Prep Request</h2>
                <button onClick={() => setShowReportRequestModal(false)} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
              </div>
              <div className="p-4">
                <p className="text-sm text-gray-600 mb-3">Copy this list and send to the client or account manager. Dates are pre-calculated based on prior month end.</p>
                <textarea 
                  readOnly 
                  value={reportText} 
                  className="w-full h-[400px] p-3 border rounded text-sm font-mono bg-gray-50 resize-none" 
                  onClick={e => e.target.select()}
                />
                <div className="flex justify-between items-center mt-3">
                  <div className="text-xs text-gray-500">
                    Click the text to select all, then Ctrl+C to copy
                  </div>
                  <div className="flex gap-2">
                    <button 
                      onClick={() => setShowReportRequestModal(false)} 
                      className="px-4 py-2 text-gray-600 hover:text-gray-800 text-sm"
                    >
                      Close
                    </button>
                    <button 
                      onClick={() => {
                        navigator.clipboard.writeText(reportText).then(() => {
                          alert('Report request copied to clipboard!');
                        }).catch(() => {
                          // Fallback
                          const ta = document.createElement('textarea');
                          ta.value = reportText;
                          document.body.appendChild(ta);
                          ta.select();
                          document.execCommand('copy');
                          document.body.removeChild(ta);
                          alert('Report request copied to clipboard!');
                        });
                      }}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
                    >
                      📋 Copy to Clipboard
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* CIM Export Modal */}
      {showCIMExportModal && (() => {
        // Validate data before export. `warnings` are advisory; `blocking`
        // are hard stops that prevent the export from running. The Vista ID
        // requirement is blocking because Deal Manager joins by it — an
        // export without one is unusable downstream.
        const validateCIMData = () => {
          const warnings = [];
          const blocking = [];

          const vid = (dealProfile?.vistaId || '').trim();
          if (!/^\d{6}$/.test(vid)) {
            blocking.push('Vista ID is required (6 digits from Zoho). Enter it next to the Export for CIM button on the page behind this modal.');
          }

          if (!dealProfile?.companyName) warnings.push('Company name is missing');

          // Force-a-pick (08-27): a CIM must never ship on the silent MSP
          // default — the industry drives benchmarks, the base multiple,
          // and the CIM's own Industry line.
          if (!selectedIndustry) blocking.push('Industry not selected (Setup → Deal Profile) — benchmarks and the base multiple key off it; a CIM cannot ship without it.');

          const hasFinancialData = revenueCategories.some(c => c.cash?.year3 > 0 || c.accrual?.year3 > 0);
          if (!hasFinancialData) warnings.push('Limited financial data entered');

          if (!adjustmentItems || adjustmentItems.length === 0) warnings.push('No add-backs entered');

          const activeClients = customerSalesData.filter(c => c.name && (c.ttm > 0 || c.year5 > 0));
          const missingContracts = activeClients.filter(c => !c.contractEnd).length;
          if (missingContracts > 0) warnings.push(`${missingContracts} clients missing contract dates`);

          // Check customer concentration
          const totalClientRev = activeClients.reduce((sum, c) => sum + (c.ttm || c.year5 || 0), 0);
          const topClientRev = Math.max(...activeClients.map(c => c.ttm || c.year5 || 0), 0);
          const concentration = totalClientRev > 0 ? (topClientRev / totalClientRev) * 100 : 0;
          if (concentration > 25) warnings.push(`Top client concentration is ${concentration.toFixed(1)}%`);

          // CIM Data Collection readiness (Mark 2026-07-14): the qualitative tabs
          // (Tech Stack etc.) only export when entered, and Leads forget they
          // exist. Advisory only — a deal may legitimately skip some (the CIM
          // section can be toggled off per deal in the generator).
          const missingQual = [
            // Phase-3 fold: only nag about Technology Stack when the panel is
            // ENABLED for this deal (MSP preset / Show) — a hidden panel is a
            // deliberate "not this business", not forgotten data entry.
            (cimTypedPanels || []).includes('techStack') && !(Object.values(cimTechStack || {}).some(v => v) || (cimVendors || []).some(v => (v.technology || '').trim())) && 'Technology Stack',
            (cimEmployees || []).length === 0 && 'Employee Roster',
            !Object.values(cimFacility || {}).some(v => v) && 'Facility',
            !Object.values(cimLegal || {}).some(v => v) && 'Legal & Non-Compete',
            !((cimGrowth || []).some(g => g.description) || Object.values(cimGrowthExtra || {}).some(v => v)) && 'Growth Opportunities'
          ].filter(Boolean);
          if (missingQual.length > 0) {
            warnings.push(`CIM Data Collection tabs without data (won't export): ${missingQual.join(', ')} — enter on Setup → CIM Data Collection, or toggle the CIM section off for this deal in the generator.`);
          }

          setCimValidationWarnings(warnings);
          setCimBlockingErrors(blocking);
          return { warnings, blocking };
        };

        // Generate CIM Export
        const generateCIMExport = async () => {
          setCimExporting(true);
          const { blocking } = validateCIMData();
          // Hard-stop on missing Vista ID etc. — the modal already shows the
          // red banner; we just need to abort before any work runs.
          if (blocking.length > 0) {
            setCimExporting(false);
            return;
          }

          try {
            const wb = XLSX.utils.book_new();

            // Per-export reconciliation log. Anything that doesn't tie to the
            // engine value (within $1) gets pushed here. After all sheets are
            // built we either render warnings on the sheets themselves or
            // block the export entirely.
            const cimReconciliationIssues = [];

            // JSONB payload mirrored to Supabase `cim_exports` after the
            // Excel write succeeds. Each tab pushes its row array here as
            // it's built, so the DB record contains the same data the
            // Excel does — Deal Manager joins by vista_id and reads
            // export_data->'Tab Name' to answer buyer questions.
            const exportData = {};

            // Get year labels
            const years = [
              basisYearLabels?.year3 || '2022',
              basisYearLabels?.year4 || '2023', 
              basisYearLabels?.year5 || '2024',
              'TTM'
            ];
            
            // TTM label = the DATA's window end, never today (Thatcher 2026-07-30:
            // the export said "TTM as of 7/2026" while the books ran through June).
            // Always the COMPLETE month-end date — "June 30, 2026", never "6/2026"
            // (Mark 2026-07-30). Priority: explicit basis-tab labels → the TTM
            // monthly config the figures are actually keyed to → today last.
            const monthEndLabel = (mIdx0, year) => new Date(year, mIdx0 + 1, 0)
              .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
            const ttmDateStr = (() => {
              const m = parseInt(basisYearLabels?.ttmEndMonth, 10), y = parseInt(basisYearLabels?.ttmEndYear, 10);
              if (m >= 1 && m <= 12 && y > 1900) return monthEndLabel(m - 1, y);
              if (monthlyTtmConfig && monthlyTtmConfig.endYear != null && monthlyTtmConfig.endMonth != null)
                return monthEndLabel(monthlyTtmConfig.endMonth, monthlyTtmConfig.endYear);
              return new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
            })();
            
            // Helper functions
            const formatCurrency = (val) => {
              if (val === null || val === undefined || isNaN(val)) return '-';
              // Round to nearest integer for display
              const absVal = Math.abs(Math.round(val));
              const formatted = absVal.toLocaleString('en-US');
              return val < 0 ? `($${formatted})` : `$${formatted}`;
            };
            
            const formatPercent = (val) => {
              if (val === null || val === undefined || isNaN(val)) return '-';
              return `${(val * 100).toFixed(1)}%`;
            };
            
            const safeDivide = (num, denom) => (!denom || denom === 0) ? 0 : num / denom;
            
            // Get financial data from active basis
            const basis = selectedValuationBasis || 'cash';
            
            const sumCategoryByYear = (categories, yearKey) => 
              categories.reduce((sum, cat) => sum + (cat[basis]?.[yearKey] || 0), 0);
            
            // Calculate totals for each year
            const getYearTotals = (yearKey) => {
              const revenue = sumCategoryByYear(revenueCategories, yearKey);
              const cogs = sumCategoryByYear(cogsCategories, yearKey);
              const opex = sumCategoryByYear(opexCategories, yearKey);
              const interest = diatCategories.interest?.[basis]?.[yearKey] || 0;
              const depreciation = diatCategories.depreciation?.[basis]?.[yearKey] || 0;
              const amortization = diatCategories.amortization?.[basis]?.[yearKey] || 0;
              const taxes = diatCategories.taxes?.[basis]?.[yearKey] || 0;
              const otherIncome = otherIncomeCategories.reduce((sum, cat) => sum + (cat[basis]?.[yearKey] || 0), 0);
              const otherExpense = otherExpenseCategories.reduce((sum, cat) => sum + (cat[basis]?.[yearKey] || 0), 0);
              
              const grossProfit = revenue - cogs;
              const netIncome = grossProfit - opex - interest - depreciation - amortization - taxes + otherIncome - otherExpense;
              
              return { revenue, cogs, opex, interest, depreciation, amortization, taxes, otherIncome, otherExpense, grossProfit, netIncome };
            };
            
            const y3 = getYearTotals('year3');
            const y4 = getYearTotals('year4');
            const y5 = getYearTotals('year5');
            const ttm = getYearTotals('ttm');

            // ---- Build inputs for the shared Normalized EBITDA model ----
            // These mirror the structures the in-app Norm EBITDA view uses,
            // so the Excel breakdown reconciles to the same engine numbers.
            //
            // Includes three sources:
            //   - OpEx + Other Expense addbacks (positive — expense removed
            //     from cost base, EBITDA goes up).
            //   - Other Income addbacks NEGATED (negative — non-operating
            //     income removed from EBITDA). Engine handles this via
            //     `otherIncomeLineDeductions`; without negation here the
            //     model would overstate EBITDA by exactly that sum.
            const lineBasedAdjustmentsForModel = [
              ...opexCategories
                .filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                .map(cat => ({
                  name: cat.name,
                  source: 'OpEx',
                  addbackPct: cat.addbackPct,
                  category: cat.adjCategory || 'Other',
                  description: cat.adjDescription || '',
                  year3: (cat[basis]?.year3 || 0) * ((cat.addbackPct || 0) / 100),
                  year4: (cat[basis]?.year4 || 0) * ((cat.addbackPct || 0) / 100),
                  year5: (cat[basis]?.year5 || 0) * ((cat.addbackPct || 0) / 100),
                  ttm:   (cat[basis]?.ttm   || 0) * ((cat.addbackPct || 0) / 100)
                })),
              ...otherExpenseCategories
                .filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                .map(cat => ({
                  name: cat.name,
                  source: 'Other Expense',
                  addbackPct: cat.addbackPct,
                  category: cat.adjCategory || 'Other',
                  description: cat.adjDescription || '',
                  year3: (cat[basis]?.year3 || 0) * ((cat.addbackPct || 0) / 100),
                  year4: (cat[basis]?.year4 || 0) * ((cat.addbackPct || 0) / 100),
                  year5: (cat[basis]?.year5 || 0) * ((cat.addbackPct || 0) / 100),
                  ttm:   (cat[basis]?.ttm   || 0) * ((cat.addbackPct || 0) / 100)
                })),
              ...otherIncomeCategories
                .filter(cat => cat.name && (cat.addbackPct || 0) > 0 && cat.adjIncluded !== false)
                .map(cat => ({
                  name: cat.name,
                  source: 'Other Income',
                  addbackPct: cat.addbackPct,
                  category: cat.adjCategory || 'Other',
                  description: cat.adjDescription || '',
                  year3: -((cat[basis]?.year3 || 0) * ((cat.addbackPct || 0) / 100)),
                  year4: -((cat[basis]?.year4 || 0) * ((cat.addbackPct || 0) / 100)),
                  year5: -((cat[basis]?.year5 || 0) * ((cat.addbackPct || 0) / 100)),
                  ttm:   -((cat[basis]?.ttm   || 0) * ((cat.addbackPct || 0) / 100))
                }))
            ];

            const diatBreakdownForModel = {
              depreciation: { year3: diatCategories.depreciation?.[basis]?.year3 || 0, year4: diatCategories.depreciation?.[basis]?.year4 || 0, year5: diatCategories.depreciation?.[basis]?.year5 || 0, ttm: diatCategories.depreciation?.[basis]?.ttm || 0 },
              interest:     { year3: diatCategories.interest?.[basis]?.year3     || 0, year4: diatCategories.interest?.[basis]?.year4     || 0, year5: diatCategories.interest?.[basis]?.year5     || 0, ttm: diatCategories.interest?.[basis]?.ttm     || 0 },
              amortization: { year3: diatCategories.amortization?.[basis]?.year3 || 0, year4: diatCategories.amortization?.[basis]?.year4 || 0, year5: diatCategories.amortization?.[basis]?.year5 || 0, ttm: diatCategories.amortization?.[basis]?.ttm || 0 },
              taxes:        { year3: diatCategories.taxes?.[basis]?.year3        || 0, year4: diatCategories.taxes?.[basis]?.year4        || 0, year5: diatCategories.taxes?.[basis]?.year5        || 0, ttm: diatCategories.taxes?.[basis]?.ttm        || 0 }
            };

            // Reconcile against the historical TTM engine value — the breakdown
            // rows are built from historical net income + D/I/A/T + adjustments,
            // so the engine target must also be historical. multipleEngineCalcs
            // returns Pro Forma / Weighted EBITDA when those bases are selected,
            // which would cause a false reconciliation mismatch.
            const engineEbitdaForModel = {
              year3: calculations?.years?.[2]?.adjustedEbitda || 0,
              year4: calculations?.years?.[3]?.adjustedEbitda || 0,
              year5: calculations?.years?.[4]?.adjustedEbitda || 0,
              ttm:   calculations?.years?.[5]?.adjustedEbitda || 0
            };

            const ebitdaModel = buildNormalizedEbitdaModel({
              adjustments: adjustmentItems.filter(a => a.included),
              lineBasedAdjustments: lineBasedAdjustmentsForModel,
              diatBreakdown: diatBreakdownForModel,
              ownerCompensation,
              yearLabels: { year3: basisYearLabels?.year3, year4: basisYearLabels?.year4, year5: basisYearLabels?.year5 },
              payrollTaxMethod, payrollTaxYears,
              ttmLabel: 'TTM',
              netIncome: { year3: y3.netIncome, year4: y4.netIncome, year5: y5.netIncome, ttm: ttm.netIncome },
              engineEbitda: engineEbitdaForModel
            });

            // ===== INCOME STATEMENT SHEET =====
            if (cimExportOptions.incomeStatement) {
              // Use the same combined D/I/A/T as Norm EBITDA tab. When users
              // tag depreciation/interest line items as opex addbacks, those
              // values live inside `opex` — so we subtract them out so the
              // G&A row reflects pure G&A and D/I/A/T appears on its own
              // row with the right total.
              const diatTot = ebitdaModel.diat.total;
              const gaPure = {
                year3: y3.opex - diatTot.year3,
                year4: y4.opex - diatTot.year4,
                year5: y5.opex - diatTot.year5,
                ttm:   ttm.opex - diatTot.ttm
              };

              const incomeRows = [
                ['COMPARISON OF INCOME AND EXPENSES - ' + (basis === 'cash' ? 'CASH' : 'ACCRUAL') + ' BASIS'],
                [''],
                ['Income Statement', years[0], years[1], years[2], `TTM as of ${ttmDateStr}`],
                [''],
                ['Net Sales Revenue', formatCurrency(y3.revenue), formatCurrency(y4.revenue), formatCurrency(y5.revenue), formatCurrency(ttm.revenue)],
                [''],
                ['Cost of Goods Sold', formatCurrency(y3.cogs), formatCurrency(y4.cogs), formatCurrency(y5.cogs), formatCurrency(ttm.cogs)],
                ['  % of Net Sales Revenue', formatPercent(safeDivide(y3.cogs, y3.revenue)), formatPercent(safeDivide(y4.cogs, y4.revenue)), formatPercent(safeDivide(y5.cogs, y5.revenue)), formatPercent(safeDivide(ttm.cogs, ttm.revenue))],
                [''],
                ['Gross Profit', formatCurrency(y3.grossProfit), formatCurrency(y4.grossProfit), formatCurrency(y5.grossProfit), formatCurrency(ttm.grossProfit)],
                ['  % Gross Profit Margin', formatPercent(safeDivide(y3.grossProfit, y3.revenue)), formatPercent(safeDivide(y4.grossProfit, y4.revenue)), formatPercent(safeDivide(y5.grossProfit, y5.revenue)), formatPercent(safeDivide(ttm.grossProfit, ttm.revenue))],
                [''],
                ['Total General & Admin.', formatCurrency(gaPure.year3), formatCurrency(gaPure.year4), formatCurrency(gaPure.year5), formatCurrency(gaPure.ttm)],
                ['  % of Net Sales Revenue', formatPercent(safeDivide(gaPure.year3, y3.revenue)), formatPercent(safeDivide(gaPure.year4, y4.revenue)), formatPercent(safeDivide(gaPure.year5, y5.revenue)), formatPercent(safeDivide(gaPure.ttm, ttm.revenue))],
                [''],
                ['Depreciation, Interest, Amortization & Taxes', formatCurrency(diatTot.year3), formatCurrency(diatTot.year4), formatCurrency(diatTot.year5), formatCurrency(diatTot.ttm)],
                [''],
                ['Other Income / (Expense)', formatCurrency(y3.otherIncome - y3.otherExpense), formatCurrency(y4.otherIncome - y4.otherExpense), formatCurrency(y5.otherIncome - y5.otherExpense), formatCurrency(ttm.otherIncome - ttm.otherExpense)],
                [''],
                ['Net Income', formatCurrency(y3.netIncome), formatCurrency(y4.netIncome), formatCurrency(y5.netIncome), formatCurrency(ttm.netIncome)],
                ['  % of Net Sales Revenue', formatPercent(safeDivide(y3.netIncome, y3.revenue)), formatPercent(safeDivide(y4.netIncome, y4.revenue)), formatPercent(safeDivide(y5.netIncome, y5.revenue)), formatPercent(safeDivide(ttm.netIncome, ttm.revenue))]
              ];

              // Cross-sheet check: G&A + D/I/A/T must equal raw opex (these
              // came from the same source). Net Income shown here must match
              // Norm EBITDA tab. Both are tautologies given the math above
              // but worth asserting in case someone refactors carelessly.
              const gaPlusDiatTtm = gaPure.ttm + diatTot.ttm;
              if (Math.abs(gaPlusDiatTtm - ttm.opex) > 1) {
                cimReconciliationIssues.push({
                  sheet: 'Income Statement',
                  detail: `G&A + D/I/A/T does not equal opex total (TTM diff: ${formatCurrency(gaPlusDiatTtm - ttm.opex)})`
                });
              }

              const wsIncome = XLSX.utils.aoa_to_sheet(incomeRows);
              wsIncome['!cols'] = [{ wch: 32 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 18 }];
              exportData['Income Statement'] = incomeRows;
              XLSX.utils.book_append_sheet(wb, wsIncome, 'Income Statement');
            }

            // ===== TAX RETURN RECONCILIATION =====
            // Reconciles the entered tax-return totals against the book P&L on
            // the SAME basis the returns were filed on (taxFilingBasis), for
            // each of the 3 prior calendar years. Tax returns have no line-item
            // detail, so we reconcile totals/subtotals only — mirroring the
            // in-app "Tax Return vs Filing Basis P&L" table exactly so the CIM
            // matches what the analyst sees on the Reconciliation tab.
            if (cimExportOptions.taxReconciliation) {
              const taxBasis = taxFilingBasis === 'accrual' ? 'accrual' : 'cash';
              const basisLabelTax = taxBasis === 'cash' ? 'Cash' : 'Accrual';
              const reconYearKeys = ['year3', 'year4', 'year5'];

              const sumBasis = (cats, yr) => (cats || []).reduce((s, c) => s + (c[taxBasis]?.[yr] || 0), 0);

              // Variance is Tax Return − Book P&L (matches in-app sign convention).
              const fmtPctVar = (variance, book) => {
                if (variance === 0) return '-';
                const pct = book !== 0 ? (variance / book) * 100 : 100;
                return `${pct.toFixed(1)}%`;
              };
              const pctVar = (variance, book) => (book !== 0 ? (variance / book) * 100 : (variance !== 0 ? 100 : 0));

              const reconRows = [
                ['TAX RETURN TO P&L RECONCILIATION'],
                [`Tax returns reconciled against ${basisLabelTax} P&L (filing basis). Prior 3 calendar years.`],
                ['Lenders and buyer accountants reconcile tax returns to the books before closing. Net Income variance >10% triggers a Quality of Earnings flag. Common differences: depreciation methods, 50% meals, officer life insurance, Section 179.'],
                ['']
              ];

              reconYearKeys.forEach((yr, idx) => {
                const yearLabel = years[idx];

                // Per Zac: reconcile Total Revenue and Net Income only. COGS,
                // Gross Profit, and OpEx are intentionally omitted — the OpEx
                // subtotal can't tie line-for-line because tax-return expenses
                // embed D/I/A/T that the books break out separately.
                const taxRev = taxReturnTotals?.revenue?.[yr] || 0;
                const taxCogs = taxReturnTotals?.cogs?.[yr] || 0;
                const taxExp = taxReturnTotals?.expenses?.[yr] || 0;
                const taxOI = otherIncomeCategories.reduce((s, c) => s + (c.tax?.[yr] || 0), 0);
                const taxOE = otherExpenseCategories.reduce((s, c) => s + (c.tax?.[yr] || 0), 0);
                const taxNI = taxRev - taxCogs - taxExp + taxOI - taxOE;

                const bRev = sumBasis(revenueCategories, yr);
                const bCogs = sumBasis(cogsCategories, yr);
                const bOpex = sumBasis(opexCategories, yr);
                const bDiat = ['depreciation', 'interest', 'amortization', 'taxes']
                  .reduce((s, k) => s + (diatCategories?.[k]?.[taxBasis]?.[yr] || 0), 0);
                const bOI = sumBasis(otherIncomeCategories, yr);
                const bOE = sumBasis(otherExpenseCategories, yr);
                const bNI = bRev - bCogs - bOpex - bDiat + bOI - bOE;

                reconRows.push([`${yearLabel} — Tax Return vs ${basisLabelTax} P&L (Filing Basis)`]);
                reconRows.push(['Line Item', 'Tax Return', `${basisLabelTax} P&L`, 'Variance $', 'Variance %']);

                // If no tax-return data was entered for this year, flag it on the
                // sheet rather than showing a row of zeros that looks reconciled.
                if (taxRev === 0 && taxCogs === 0 && taxExp === 0) {
                  reconRows.push(['No tax return data entered for this year', '', '', '', '']);
                  reconRows.push(['']);
                  return;
                }

                const line = (label, taxVal, bookVal) =>
                  [label, formatCurrency(taxVal), formatCurrency(bookVal), formatCurrency(taxVal - bookVal), fmtPctVar(taxVal - bookVal, bookVal)];

                reconRows.push(line('Total Revenue', taxRev, bRev));

                const niVar = taxNI - bNI;
                const niPct = pctVar(niVar, bNI);
                const qoeFlag = Math.abs(niPct) > 10;
                reconRows.push([
                  qoeFlag ? 'Net Income  ⚠️ QoE Flag (>10%)' : 'Net Income',
                  formatCurrency(taxNI), formatCurrency(bNI), formatCurrency(niVar), fmtPctVar(niVar, bNI)
                ]);
                reconRows.push(['']);
              });

              const wsRecon = XLSX.utils.aoa_to_sheet(reconRows);
              wsRecon['!cols'] = [{ wch: 32 }, { wch: 16 }, { wch: 16 }, { wch: 14 }, { wch: 12 }];
              exportData['Tax Return Reconciliation'] = reconRows;
              XLSX.utils.book_append_sheet(wb, wsRecon, 'Tax Reconciliation');
            }

            // ===== BALANCE SHEET =====
            if (cimExportOptions.balanceSheet) {
              const latestYear = 'interim';
              // Same date discipline as the TTM label, and always the COMPLETE
              // month-end date (Mark 2026-07-30): a bare "Jun 2026" interim label
              // upgrades to "June 30, 2026"; a custom label is honored verbatim;
              // else the TTM monthly window end; 'Current' only when nothing exists.
              const bsDate = (() => {
                const lbl = String(bsYearLabels?.interim || '').trim();
                const my = lbl.match(/^([A-Za-z]{3,9})\.?\s+(\d{4})$/);
                if (my) {
                  const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
                  const mi = MONTHS.findIndex(mn => mn.startsWith(my[1].toLowerCase().slice(0, 3)));
                  if (mi >= 0) return monthEndLabel(mi, parseInt(my[2], 10));
                }
                if (lbl) return lbl;
                if (monthlyTtmConfig && monthlyTtmConfig.endYear != null && monthlyTtmConfig.endMonth != null)
                  return monthEndLabel(monthlyTtmConfig.endMonth, monthlyTtmConfig.endYear);
                return 'Current';
              })();
              
              const sumBS = (items, yr) => items.reduce((sum, item) => sum + (item[yr] || 0), 0);
              
              const totalCurrentAssets = sumBS(bsCurrentAssets, latestYear);
              const totalFixedAssets = sumBS(bsFixedAssets, latestYear);
              const totalOtherAssets = sumBS(bsOtherAssets, latestYear);
              const totalAssets = totalCurrentAssets + totalFixedAssets + totalOtherAssets;
              
              const totalCurrentLiab = sumBS(bsCurrentLiabilities, latestYear);
              const totalLTLiab = sumBS(bsLongTermLiabilities, latestYear);
              const totalLiabilities = totalCurrentLiab + totalLTLiab;
              
              const totalEquity = sumBS(bsEquity, latestYear);
              
              const bsRows = [
                ['BUSINESS BALANCE SHEET - ACCRUAL BASIS'],
                [''],
                ['Assets', `As of ${bsDate}`],
                [''],
                ['Current Assets', '']
              ];
              
              bsCurrentAssets.filter(a => a.name).forEach(a => {
                bsRows.push([`  ${a.name}`, formatCurrency(a[latestYear] || 0)]);
              });
              bsRows.push(['Total Current Assets', formatCurrency(totalCurrentAssets)]);
              bsRows.push(['']);
              bsRows.push(['Fixed Assets', '']);
              bsFixedAssets.filter(a => a.name).forEach(a => {
                bsRows.push([`  ${a.name}`, formatCurrency(a[latestYear] || 0)]);
              });
              bsRows.push(['Total Fixed Assets', formatCurrency(totalFixedAssets)]);
              bsRows.push(['']);
              if (bsOtherAssets.some(a => a.name)) {
                bsRows.push(['Other Assets', '']);
                bsOtherAssets.filter(a => a.name).forEach(a => {
                  bsRows.push([`  ${a.name}`, formatCurrency(a[latestYear] || 0)]);
                });
                bsRows.push(['Total Other Assets', formatCurrency(totalOtherAssets)]);
                bsRows.push(['']);
              }
              bsRows.push(['Total Assets', formatCurrency(totalAssets)]);
              bsRows.push(['']);
              bsRows.push(['']);
              bsRows.push(['Liabilities', '']);
              bsRows.push(['']);
              bsRows.push(['Current Liabilities', '']);
              bsCurrentLiabilities.filter(a => a.name).forEach(a => {
                bsRows.push([`  ${a.name}`, formatCurrency(a[latestYear] || 0)]);
              });
              bsRows.push(['Total Current Liabilities', formatCurrency(totalCurrentLiab)]);
              bsRows.push(['']);
              bsRows.push(['Long-Term Liabilities', '']);
              bsLongTermLiabilities.filter(a => a.name).forEach(a => {
                bsRows.push([`  ${a.name}`, formatCurrency(a[latestYear] || 0)]);
              });
              bsRows.push(['Total Long-Term Liabilities', formatCurrency(totalLTLiab)]);
              bsRows.push(['']);
              bsRows.push(['Total Liabilities', formatCurrency(totalLiabilities)]);
              bsRows.push(['']);
              bsRows.push(['Equity', '']);
              bsEquity.filter(a => a.name).forEach(a => {
                bsRows.push([`  ${a.name}`, formatCurrency(a[latestYear] || 0)]);
              });
              bsRows.push(['Total Equity', formatCurrency(totalEquity)]);
              
              const wsBalance = XLSX.utils.aoa_to_sheet(bsRows);
              wsBalance['!cols'] = [{ wch: 30 }, { wch: 18 }];
              exportData['Balance Sheet'] = bsRows;
              XLSX.utils.book_append_sheet(wb, wsBalance, 'Balance Sheet');
            }
            
            // ===== NORMALIZED EBITDA =====
            if (cimExportOptions.normalizedEbitda) {
              // Render rows from the shared model so the Excel breakdown
              // matches the in-app Norm EBITDA view exactly: D/I/A/T pulled
              // from combined sources, owner-comp & other adjustments
              // consolidated per description across years (no per-year row
              // duplication, no double-count of owner salary).
              const m = ebitdaModel;
              const fmtRow4 = (label, vals) => [label, formatCurrency(vals.year3), formatCurrency(vals.year4), formatCurrency(vals.year5), formatCurrency(vals.ttm)];

              const ebitdaRows = [
                ['NORMALIZED EBITDA CALCULATIONS - ' + (basis === 'cash' ? 'CASH' : 'ACCRUAL') + ' BASIS'],
                [''],
                ['', years[0], years[1], years[2], `TTM as of ${ttmDateStr}`],
                [''],
                fmtRow4('Sales Revenue', { year3: y3.revenue, year4: y4.revenue, year5: y5.revenue, ttm: ttm.revenue }),
                [''],
                fmtRow4('Reported Net Income', m.netIncome)
              ];

              // ----- D/I/A/T section: only show categories with non-zero values -----
              const diatHasAny = m.diat.total.year3 || m.diat.total.year4 || m.diat.total.year5 || m.diat.total.ttm;
              if (diatHasAny) {
                ebitdaRows.push(['']);
                ebitdaRows.push(['Add Back D/I/A/T:', '', '', '', '']);
                const diatLabels = [
                  ['Depreciation', m.diat.depreciation],
                  ['Interest',     m.diat.interest],
                  ['Amortization', m.diat.amortization],
                  ['Taxes',        m.diat.taxes]
                ];
                diatLabels.forEach(([label, vals]) => {
                  if (vals.year3 || vals.year4 || vals.year5 || vals.ttm) {
                    ebitdaRows.push(fmtRow4('  ' + label, vals));
                  }
                });
                ebitdaRows.push(fmtRow4('  Subtotal D/I/A/T', m.diat.total));
              }

              ebitdaRows.push(['']);
              ebitdaRows.push(fmtRow4('= Reported EBITDA', m.reportedEbitda));

              // Excel label = SOURCE LINE ITEM first, description after
              // (Zac 08-26, data-room use post-IOI: "what we really need is
              // what line item the addback comes from so buyers can map the
              // adjustments" — descriptions like "Related to Prism…" were
              // hiding the plLine entirely). "OpEx: 758 Automobile Expense —
              // Related to Prism…"; graceful when either half is missing.
              const labelFor = (row) => {
                const desc = (row.description || '').trim();
                const line = (row.plLine || '').trim();
                const isGenericPct = /^\d+(?:\.\d+)?% add-back$/.test(desc);
                const realDesc = desc && desc !== '(No description)' && !isGenericPct ? desc : '';
                if (line && realDesc) return '  ' + line + ' — ' + realDesc;
                if (line) return '  ' + line + (isGenericPct ? ' (' + desc + ')' : '');
                if (realDesc) return '  ' + realDesc;
                return '  ' + (desc || 'Adjustment');
              };

              // ----- Owner Compensation Adjustments (consolidated rows) -----
              if (m.ownerCompRows.length > 0) {
                ebitdaRows.push(['']);
                ebitdaRows.push(['Owner Compensation Adjustments:', '', '', '', '']);
                m.ownerCompRows.forEach(row => {
                  ebitdaRows.push(fmtRow4(labelFor(row), row));
                });
                ebitdaRows.push(fmtRow4('  Subtotal Owner Comp', m.totals.ownerComp));
              }

              // ----- Other Discretionary Adjustments (consolidated rows) -----
              if (m.otherRows.length > 0) {
                ebitdaRows.push(['']);
                ebitdaRows.push(['Other Discretionary Adjustments:', '', '', '', '']);
                m.otherRows.forEach(row => {
                  ebitdaRows.push(fmtRow4(labelFor(row), row));
                });
                ebitdaRows.push(fmtRow4('  Subtotal Other', m.totals.other));
              }

              ebitdaRows.push(['']);
              ebitdaRows.push(fmtRow4('Total Normalizing Adjustments', m.totals.normalizing));
              ebitdaRows.push(['']);
              ebitdaRows.push(fmtRow4('= Normalized EBITDA', m.adjustedEbitda));

              // ----- Reconciliation row -----
              // Bridge total (what the breakdown above sums to) vs. engine
              // value (what the in-app valuation uses). If they differ by
              // more than $1 in any column, surface it on the sheet AND
              // record an export-blocking issue.
              ebitdaRows.push(['']);
              ebitdaRows.push(['Reconciliation Check', '', '', '', '']);
              ebitdaRows.push(fmtRow4('  Sum of breakdown above', m.reconciliation.breakdownTotal));
              ebitdaRows.push(fmtRow4('  Engine Normalized EBITDA', m.reconciliation.engineTotal));
              const fmtDiff = (v) => {
                const ok = Math.abs(v) <= 1;
                return ok ? 'OK' : `MISMATCH: ${formatCurrency(v)}`;
              };
              ebitdaRows.push([
                '  Difference (breakdown - engine)',
                fmtDiff(m.reconciliation.diff.year3),
                fmtDiff(m.reconciliation.diff.year4),
                fmtDiff(m.reconciliation.diff.year5),
                fmtDiff(m.reconciliation.diff.ttm)
              ]);
              if (!m.reconciliation.allMatch) {
                cimReconciliationIssues.push({
                  sheet: 'Normalized EBITDA',
                  detail: `Breakdown does not reconcile to engine value. Diff (TTM): ${formatCurrency(m.reconciliation.diff.ttm)}`
                });
              }

              const wsEbitda = XLSX.utils.aoa_to_sheet(ebitdaRows);
              wsEbitda['!cols'] = [{ wch: 40 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 18 }];
              // Convert currency string cells to real numbers with accounting format
              // so Excel can calculate with them (fixes "not showing as numbers" issue)
              // IMPORTANT: only convert cells that have a currency MARKER ($ or
              // paren-wrap). Pure digit strings like "2023" are year labels,
              // not values — the old regex caught those and turned 2023 into
              // $2,023 in the year header row.
              const currencyFmt = '"$"#,##0_);("$"#,##0)';
              Object.keys(wsEbitda).filter(k => !k.startsWith('!')).forEach(cellRef => {
                const cell = wsEbitda[cellRef];
                if (cell && cell.t === 's' && typeof cell.v === 'string') {
                  const v = cell.v.trim();
                  // Require a currency marker: $ sign, or paren-wrap (negative).
                  // Without this guard, year labels and other pure-integer
                  // strings get reformatted as currency.
                  const hasCurrencyMarker = v.includes('$') || (v.startsWith('(') && v.endsWith(')'));
                  if (!hasCurrencyMarker) return;
                  const isCurrencyLike = /^[\$\(\-]?[\d,]+(\.\d+)?\)?$/.test(v) ||
                                         /^\(\$?[\d,]+(\.\d+)?\)$/.test(v);
                  if (!isCurrencyLike) return; // leave description strings alone
                  const stripped = v.replace(/[$,()]/g, '').trim();
                  const negative = v.startsWith('(') || v.startsWith('-');
                  const num = parseFloat(stripped);
                  if (!isNaN(num) && stripped !== '') {
                    cell.t = 'n';
                    cell.v = negative ? -Math.abs(num) : num;
                    cell.z = currencyFmt;
                    delete cell.w;
                  }
                }
              });
              exportData['Normalized EBITDA'] = ebitdaRows;
              XLSX.utils.book_append_sheet(wb, wsEbitda, 'Normalized EBITDA');
            }
            
            // ===== REVENUE BY CLIENT =====
            if (cimExportOptions.revenueByClient) {
              const custYears = [
                displayCustomerYearLabels.year3 || '2022',
                displayCustomerYearLabels.year4 || '2023',
                displayCustomerYearLabels.year5 || '2024'
              ];
              
              // Lead-defined attribute columns append after 'Industry'. Only
              // NAMED columns export; buildClients treats any header beyond
              // the known set as an attribute, so the names here ARE the CIM
              // column headers.
              const attrCols = (cimClientAttrCols || []).filter(c => (c.name || '').trim());
              const clientHeaders = [
                'Client',
                custYears[0], custYears[1], custYears[2],
                'YTD ' + new Date().getFullYear(),
                'TTM',
                'Contract',
                'Contract Start',
                'Contract End',
                'Billing',
                'Tenure',
                'Industry',
                ...attrCols.map(c => c.name.trim())
              ];
              
              const clientRows = [
                ['REVENUE BY CLIENT'],
                [''],
                clientHeaders
              ];
              
              let totals = { year3: 0, year4: 0, year5: 0, ttm: 0 };

              // Sort by TTM revenue descending
              const sortedClients = [...customerSalesData]
                .filter(c => c.name && (c.ttm > 0 || c.year5 > 0 || c.year4 > 0 || c.year3 > 0))
                .sort((a, b) => (b.ttm || b.year5 || 0) - (a.ttm || a.year5 || 0));

              // STABLE Client #N (Lead Review D5): a client keeps the same number
              // across every export of this deal — the number is the owner's
              // decoder ring and the buyer's reference across CIM versions, so
              // renumbering when revenue ranks shift is a consistency break.
              // Numbers persist on the client rows (cimClientNum, saved with the
              // deal data); first export assigns by TTM rank, later exports reuse
              // and only ever ADD numbers for new clients.
              const numByName = new Map(customerSalesData.filter(c => c.name && c.cimClientNum > 0).map(c => [c.name, c.cimClientNum]));
              let nextClientNum = Math.max(0, ...numByName.values()) + 1;
              const newAssignments = new Map();
              sortedClients.forEach(client => {
                if (!numByName.has(client.name)) {
                  numByName.set(client.name, nextClientNum);
                  newAssignments.set(client.name, nextClientNum);
                  nextClientNum++;
                }
              });
              if (newAssignments.size > 0) {
                setCustomerSalesData(prev => prev.map(c => newAssignments.has(c.name) ? { ...c, cimClientNum: newAssignments.get(c.name) } : c));
                setHasUnsavedChanges(true); // numbers must survive to the next export — save the deal
              }

              sortedClients.forEach(client => {
                const clientNum = numByName.get(client.name);
                const clientLabel = cimExportOptions.anonymizeClients ? `Client #${clientNum}` : (client.name || `Client #${clientNum}`);
                
                const cy3 = client.year3 || 0;
                const cy4 = client.year4 || 0;
                const cy5 = client.year5 || 0;
                const cytd = client.ytd || 0;
                const cttm = client.ttm || 0;
                
                // Tenure (Lead Review D5 fix): the owner-provided relationship
                // length (client.tenure, from the Client Detail form) WINS —
                // contractStart is only the CURRENT contract's start, so deriving
                // tenure from it understates long relationships that renewed
                // recently (a 15-year client on a 2024 renewal showed "2 Years").
                // The contract-date parse is now the fallback for clients where
                // the owner gave no tenure.
                let tenure = '';
                if (client.tenure !== null && client.tenure !== '' && client.tenure !== undefined) {
                  const tStr = String(client.tenure).trim();
                  const tNum = parseInt(tStr);
                  if (tStr && (!isNaN(tNum) ? tNum > 0 && tNum <= 50 : true)) {
                    tenure = typeof client.tenure === 'number' && client.tenure > 0 ? `${client.tenure} Year${client.tenure !== 1 ? 's' : ''}` : tStr;
                  }
                }
                const csVal = (client.contractStart || '').trim();
                if (!tenure && csVal && /^\d{1,2}\/\d{2,4}$/.test(csVal)) {
                  const parts = csVal.split('/');
                  const yr = parseInt(parts[1]) < 100 ? 2000 + parseInt(parts[1]) : parseInt(parts[1]);
                  const start = new Date(yr, parseInt(parts[0]) - 1, 1);
                  const now = new Date();
                  if (!isNaN(start.getTime()) && yr >= 1990 && start <= now) {
                    const yrs = Math.floor((now - start) / (365.25 * 24 * 60 * 60 * 1000));
                    tenure = yrs < 1 ? 'New' : `${yrs} Year${yrs > 1 ? 's' : ''}`;
                  }
                }
                
                clientRows.push([
                  clientLabel,
                  cy3 ? formatCurrency(cy3) : '',
                  cy4 ? formatCurrency(cy4) : '',
                  cy5 ? formatCurrency(cy5) : '',
                  cytd ? formatCurrency(cytd) : '',
                  cttm ? formatCurrency(cttm) : '',
                  client.hasContract ? 'X' : '',
                  client.contractStart || '',
                  client.contractEnd || '',
                  client.billingFrequency || '',
                  tenure,
                  client.industry || '',
                  ...attrCols.map(c => String((client.attrs || {})[c.id] == null ? '' : (client.attrs || {})[c.id]).trim())
                ]);
                
                totals.year3 += cy3;
                totals.year4 += cy4;
                totals.year5 += cy5;
                totals.ytd += cytd;
                totals.ttm += cttm;
              });
              
              clientRows.push(['']);
              clientRows.push([
                'TOTAL',
                formatCurrency(totals.year3),
                formatCurrency(totals.year4),
                formatCurrency(totals.year5),
                formatCurrency(totals.ytd),
                formatCurrency(totals.ttm),
                '', '', '', '', '', ''
              ]);
              
              const wsClients = XLSX.utils.aoa_to_sheet(clientRows);
              wsClients['!cols'] = [
                { wch: 22 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 14 },
                { wch: 8 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 16 }
              ];
              exportData['Revenue by Client'] = clientRows;
              XLSX.utils.book_append_sheet(wb, wsClients, 'Revenue by Client');
            }
            
            // ===== KEY METRICS =====
            if (cimExportOptions.keyMetrics) {
              // Concentration is TTM, ONE number everywhere (Zac 2026-07-14):
              // mirror keyMetrics' period logic exactly (TTM when any client has
              // TTM revenue; wholesale year5 fallback only when none do) — never
              // the old per-client `ttm || year5` blend, which produced a
              // different denominator AND client count than the dashboard/engine
              // and the CIM's Revenue-by-Client table (33.5% vs 42.4% on Workstate).
              const concPeriod = customerSalesData.some(c => (c.ttm || 0) > 0) ? 'ttm' : 'year5';
              const activeClients = customerSalesData.filter(c => c.name && (c[concPeriod] || 0) > 0);
              const totalClientRev = activeClients.reduce((sum, c) => sum + (c[concPeriod] || 0), 0);
              
              const normalizedEbitdaVal = multipleEngineCalcs?.adjustedEbitda || 0;
              const marketComp = ocMarketFor(ownerCompensation, 'ttm');
              const payrollTaxRateKM = ownerCompensation.includePayrollTax !== false ? ((ownerCompensation.payrollTaxRate || 7.65) / 100) : 0;
              const totalCompDeduction = marketComp + (payrollTaxRateKM ? employerPayrollTax(marketComp, payrollTaxYear('ttm'), ownerCompensation.payrollTaxRate || 7.65, payrollTaxMethod) : 0);
              // adjustedEbitda from multipleEngineCalcs is already fully normalized (market comp already deducted)
              // Show it as Normalized EBITDA; Adjusted EBITDA is before the comp deduction
              const adjustedEbitdaSDE = normalizedEbitdaVal + totalCompDeduction;
              
              const metricsRows = [
                ['KEY METRICS SUMMARY'],
                [''],
                ['Financial Metrics', 'Value', 'Notes'],
                ['TTM Revenue', ttm.revenue || totalClientRev, ''],
                ['TTM Gross Profit', ttm.grossProfit, `${formatPercent(safeDivide(ttm.grossProfit, ttm.revenue))} margin`],
                ['TTM Net Income', ttm.netIncome, `${formatPercent(safeDivide(ttm.netIncome, ttm.revenue))} margin`],
                ['Adjusted EBITDA', adjustedEbitdaSDE, ''],
                ['Normalized EBITDA', normalizedEbitdaVal, marketComp > 0 ? `After ${formatCurrency(marketComp)} mgmt comp` : ''],
                [''],
                ['Revenue Quality', '', ''],
                ['Recurring Revenue %', `${(keyMetrics?.recurringPct || 0).toFixed(1)}%`, 'Weighted calculation'],
                // Straight from keyMetrics — the same values the dashboard shows
                // and the multiple engine (E1/E4) consumes, so all surfaces agree.
                ['Customer Concentration (Top Client)', `${(keyMetrics?.topCustomerPct || 0).toFixed(1)}%`, ''],
                ['Top 5 Concentration', `${(keyMetrics?.top5CustomersPct || 0).toFixed(1)}%`, ''],
                [''],
                ['Operational Metrics', '', ''],
                // Counts as strings so the bulk currency-format loop below
                // (which auto-formats every numeric cell) leaves them alone.
                ['Number of Active Clients', String(activeClients.length), ''],
                ['Endpoints Under Management', keyMetrics?.endpoints != null && keyMetrics?.endpoints !== '' ? String(keyMetrics.endpoints) : '', ''],
                ['Average Revenue per Client', safeDivide(totalClientRev, activeClients.length), ''],
                [''],
                ['Valuation Indicators', '', ''],
                ['Suggested Multiple Range', `${(multipleEngineCalcs?.typicalMultiple || 0).toFixed(2)}x - ${(multipleEngineCalcs?.marketHighMultiple || 0).toFixed(2)}x`, 'From Multiple Engine'],
                ['Implied Valuation Range', `${formatCurrency(multipleEngineCalcs?.valuationTypical)} - ${formatCurrency(multipleEngineCalcs?.valuationMarketHigh)}`, ''],
                ['Midpoint Valuation', (((multipleEngineCalcs?.valuationTypical || 0) + (multipleEngineCalcs?.valuationMarketHigh || 0)) / 2), '']
              ];
              
              // Cross-sheet consistency: the Normalized EBITDA shown here
              // must match the Norm EBITDA tab's engine value within $1.
              // Skip when the valuation uses a Pro Forma / Weighted basis or a
              // non-TTM weighting — in those cases the Key Metrics figure is
              // the valuation metric, which legitimately differs from the
              // historical TTM bridge on the Norm EBITDA tab.
              const usesProFormaBasis = proFormaCalcs?.hasProFormaData && proFormaValuationBasis !== 'historical';
              const usesNonTtmWeighting = valuationInputs?.weightingMethod && valuationInputs.weightingMethod !== 'ttm';
              if (!usesProFormaBasis && !usesNonTtmWeighting &&
                  Math.abs(normalizedEbitdaVal - ebitdaModel.adjustedEbitda.ttm) > 1) {
                cimReconciliationIssues.push({
                  sheet: 'Key Metrics',
                  detail: `Normalized EBITDA TTM (${formatCurrency(normalizedEbitdaVal)}) does not match Norm EBITDA tab (${formatCurrency(ebitdaModel.adjustedEbitda.ttm)})`
                });
              }

              const wsMetrics = XLSX.utils.aoa_to_sheet(metricsRows);
              wsMetrics['!cols'] = [{ wch: 35 }, { wch: 22 }, { wch: 30 }];
              // Convert numeric cells to real numbers with currency format
              const kmCurrencyFmt = '"$"#,##0_);("$"#,##0)';
              Object.keys(wsMetrics).filter(k => !k.startsWith('!')).forEach(cellRef => {
                const cell = wsMetrics[cellRef];
                if (cell && cell.t === 'n') {
                  cell.z = kmCurrencyFmt;
                }
              });
              exportData['Key Metrics'] = metricsRows;
              XLSX.utils.book_append_sheet(wb, wsMetrics, 'Key Metrics');
            }
            
            // ===== BUSINESS SUMMARY =====
            if (cimExportOptions.businessSummary) {
              // Same TTM-first period logic as keyMetrics / the Key Metrics sheet
              // (Zac 2026-07-14: concentration + active-client figures are TTM,
              // one number everywhere). The old `ttm || year5` blend counted
              // clients with no TTM revenue as active (13 vs 12 on Workstate).
              const concPeriod = customerSalesData.some(c => (c.ttm || 0) > 0) ? 'ttm' : 'year5';
              const activeClients = customerSalesData.filter(c => c.name && (c[concPeriod] || 0) > 0);
              const totalClientRev = activeClients.reduce((sum, c) => sum + (c[concPeriod] || 0), 0);
              
              const summaryRows = [
                ['BUSINESS DETAILS SUMMARY'],
                [''],
                ['Company Information', ''],
                // Vista ID first: the CIM generator reads it to key the deal's
                // per-deal section config (cim_section_configs, migration 026) —
                // without it the payload can't identify which deal it belongs to.
                ['Vista ID', (dealProfile?.vistaId || '').trim()],
                // Deal Lead → the CIM generator auto-selects this Lead's contact
                // block (cover, running header, Acquisition Process, Inquiries)
                // via leadIdFromExport, so the memorandum names the right person
                // with no manual pick. Stored as the Lead's first name (Zac /
                // Thatcher); the generator matches on first name.
                ['Deal Lead', (workflow?.lead || '').trim()],
                ['Company Legal Name', dealProfile?.companyName || ''],
                // CIM Business Details additions (Zac 2026-07-27) — blank
                // values survive here; the CIM's buildDetails drops empty rows.
                ['DBA / Trade Name', dealProfile?.dbaName || ''],
                ['Ownership', dealProfile?.ownershipText || ''],
                ['Year Established', dealProfile?.yearEstablished || ''],
                ['Legal Status', dealProfile?.legalStatus || ''],
                ['State of Incorporation', dealProfile?.stateOfIncorporation || ''],
                ['Location', dealProfile?.city && dealProfile?.state ? `${dealProfile.city}, ${dealProfile.state}` : ''],
                ['Location Type', dealProfile?.locationType || ''],
                ['Hours of Operation', dealProfile?.hoursOfOperation || ''],
                ['Website', dealProfile?.website || ''],
                ['Industry Sector', selectedSector || ''],
                ['Industry', selectedIndustryObj?.name || selectedIndustry || ''],
                ['Industry Mix', dealProfile?.industryMix || ''],
                ['Fiscal Year End', dealProfile?.fiscalYearEndMonth === 12 ? 'December (Calendar Year)' : `Month ${dealProfile?.fiscalYearEndMonth || 12}`],
                ['Valuation Basis', (basis === 'cash' ? 'Cash' : basis === 'accrual' ? 'Accrual' : 'Tax')],
                [''],
                ['Business Model', ''],
                ['Customer Type', businessModel?.customerType || ''],
                ['Industries Served', businessModel?.industriesServed || ''],
                ['Geographic Scope', businessModel?.geographicScope || ''],
                ['Geographic Detail', businessModel?.geographicDetail || ''],
                ['Product/Service Description', businessModel?.descriptionOverride || ''],
                [''],
                ['Operating Metrics', ''],
                ['Number of Employees', keyMetrics?.employeeCount?.toString() || ''],
                ['Revenue per Employee', keyMetrics?.revenuePerEmployee ? formatCurrency(keyMetrics.revenuePerEmployee) : ''],
                ['Number of Active Clients', activeClients.length.toString()],
                ['Average Revenue per Client', formatCurrency(safeDivide(totalClientRev, activeClients.length))],
                ['B2B Client %', keyMetrics?.b2bPct != null ? `${keyMetrics.b2bPct.toFixed(0)}%` : ''],
                [''],
                ['Revenue Quality', ''],
                ['Weighted Recurring Revenue %', `${(keyMetrics?.recurringPct || 0).toFixed(1)}%`],
                ['Contracted Recurring %', `${(keyMetrics?.contractedRecurringPct || 0).toFixed(1)}%`],
                // THE BUYER VIEW (Mark/Zac/Colleen 10-06): what the CIM may say. The weighted % above is the
                // valuation mix (projects 0.5, hardware 0.25…) and never appears in a buyer document.
                ...(() => {
                  const strict = keyMetrics?.contractedRecurringPct || 0;
                  const client = Math.max(strict, keyMetrics?.contractedClientRevPct || 0);
                  return [
                    ['Revenue Under Recurring Contracts %', `${strict.toFixed(1)}%`],
                    ['Revenue From Contracted Clients Outside Contract %', `${Math.max(0, client - strict).toFixed(1)}%`],
                    ['Revenue From Clients Without a Contract %', `${Math.max(0, 100 - client).toFixed(1)}%`],
                  ];
                })(),
                ['Revenue CAGR', keyMetrics?.revCAGR != null ? `${keyMetrics.revCAGR.toFixed(1)}%` : 'N/A'],
                ['EBITDA CAGR', keyMetrics?.ebitdaCAGR != null ? `${keyMetrics.ebitdaCAGR.toFixed(1)}%` : 'N/A'],
                [''],
                ['Contract Quality', ''],
                ['Revenue Under Contract', keyMetrics?.contractedPct > 0 ? `${keyMetrics.contractedPct.toFixed(0)}%` : 'N/A'],
                ['Average Contract Length', keyMetrics?.avgContractMonths ? `${keyMetrics.avgContractMonths.toFixed(0)} months` : 'N/A'],
                ['Contracts Assignable', keyMetrics?.assignablePct > 0 ? `${keyMetrics.assignablePct.toFixed(0)}%` : 'N/A'],
                ['Price Escalators', keyMetrics?.escalatorPct > 0 ? `${keyMetrics.escalatorPct.toFixed(0)}% (avg ${keyMetrics.avgEscalatorRate?.toFixed(1) || 0}%)` : 'N/A'],
                ['Auto-Renewal', keyMetrics?.autoRenewalPct > 0 ? `${keyMetrics.autoRenewalPct.toFixed(0)}%` : 'N/A'],
                ['Early Term Penalty', keyMetrics?.termPenaltyPct > 0 ? `${keyMetrics.termPenaltyPct.toFixed(0)}%` : 'N/A'],
                [''],
                ['Customer Concentration', ''],
                ['Top Client %', `${(keyMetrics?.topCustomerPct || 0).toFixed(1)}%`],
                ['Top 5 Clients %', `${(keyMetrics?.top5CustomersPct || 0).toFixed(1)}%`],
                ['Top 10 Clients %', `${(keyMetrics?.top10CustomersPct || 0).toFixed(1)}%`],
                [''],
                ['Owner Information', ''],
                ['Owner Salary (TTM)', formatCurrency(ownerCompensation.ttm?.salary || 0)],
                ['Market Replacement Cost', formatCurrency(ownerCompensation.marketReplacement || 0)],
                ['Owner Hours/Week', multipleAdjustments?.ownerDependency?.hoursPerWeek ? `${multipleAdjustments.ownerDependency.hoursPerWeek}` : (sellerQA?.find(q => q.id === 15)?.numericValue ? `${sellerQA.find(q => q.id === 15).numericValue}` : '')],
                ['Owner Revenue Managed %', (() => { const q26 = sellerQA?.find(q => q.id === 26); return q26?.numericValue != null ? `${q26.numericValue}%` : ''; })()],
                ['Owner Staying Post-Sale', (() => { const q17 = sellerQA?.find(q => q.id === 17); if (q17?.answer) return q17.answer; const ot = multipleAdjustments?.ownerTransition?.ownersStaying; return ot === 'yes' ? 'Yes' : ot === 'no' ? 'No' : ''; })()],
                ['Owner Transition Notes', multipleAdjustments?.ownerTransition?.notes || ''],
                ['Owner Dependency Level', multipleAdjustments?.ownerDependency?.involvementLevel !== 'unknown' ? multipleAdjustments?.ownerDependency?.involvementLevel || '' : ''],
                ['Owner Dependency Notes', multipleAdjustments?.ownerDependency?.notes || ''],
                [''],
                ['Competitive Positioning', ''],
                ['Competitors & Differentiation', (() => { const q27 = sellerQA?.find(q => q.id === 27); return q27?.answer || ''; })()],
                [''],
                ['Company History', ''],
                ['History & Milestones', (() => { const q28 = sellerQA?.find(q => q.id === 28); return q28?.answer || ''; })()],
                [''],
                ...(multipleAdjustments.franchise?.isFranchise ? [
                  ['Franchise Information', ''],
                  ['Franchise', multipleAdjustments.franchise.franchiseName || 'Yes'],
                  ['Royalty Rate', multipleAdjustments.franchise.royaltyRate ? `${multipleAdjustments.franchise.royaltyRate}% of revenue` : ''],
                  ['Marketing Fund Rate', multipleAdjustments.franchise.marketingFundRate ? `${multipleAdjustments.franchise.marketingFundRate}% of revenue` : ''],
                  ['Transfer Fee', multipleAdjustments.franchise.transferFee ? formatCurrency(multipleAdjustments.franchise.transferFee) : ''],
                  ['Remaining Franchise Term', multipleAdjustments.franchise.remainingTermYears ? `${multipleAdjustments.franchise.remainingTermYears} years` : ''],
                  ['Franchisor Approval Required', multipleAdjustments.franchise.franchisorApproval ? 'Yes' : 'No'],
                  ['Exclusive Territory', multipleAdjustments.franchise.territoryExclusive ? 'Yes' : 'No'],
                  ['Territory/Franchise Notes', multipleAdjustments.franchise.notes || ''],
                  ['']
                ] : []),
                ['Valuation Indicators', ''],
                ['Suggested Multiple Range', `${(multipleEngineCalcs?.typicalMultiple || 0).toFixed(2)}x - ${(multipleEngineCalcs?.marketHighMultiple || 0).toFixed(2)}x`],
                ['Implied Valuation Range', `${formatCurrency(multipleEngineCalcs?.valuationTypical)} - ${formatCurrency(multipleEngineCalcs?.valuationMarketHigh)}`],
                ['Midpoint Valuation', formatCurrency(((multipleEngineCalcs?.valuationTypical || 0) + (multipleEngineCalcs?.valuationMarketHigh || 0)) / 2)]
              ];
              
              const wsSummary = XLSX.utils.aoa_to_sheet(summaryRows);
              wsSummary['!cols'] = [{ wch: 35 }, { wch: 40 }];
              exportData['Business Summary'] = summaryRows;
              XLSX.utils.book_append_sheet(wb, wsSummary, 'Business Summary');
            }
            
            // ===== OPEX DETAIL =====
            if (cimExportOptions.opexDetail) {
              const opexRows = [
                ['OPERATING EXPENSE DETAIL - ' + (basis === 'cash' ? 'CASH' : 'ACCRUAL') + ' BASIS'],
                [''],
                ['Expense Category', years[0], years[1], years[2], `TTM as of ${ttmDateStr}`, '% of Revenue (TTM)'],
                ['']
              ];
              
              opexCategories.filter(c => c.name).forEach(cat => {
                const v3 = cat[basis]?.year3 || 0;
                const v4 = cat[basis]?.year4 || 0;
                const v5 = cat[basis]?.year5 || 0;
                const vttm = cat[basis]?.ttm || 0;
                const pctRev = ttm.revenue > 0 ? (vttm / ttm.revenue) : 0;
                opexRows.push([cat.name, formatCurrency(v3), formatCurrency(v4), formatCurrency(v5), formatCurrency(vttm), formatPercent(pctRev)]);
              });
              
              const opexTotal = (yr) => opexCategories.reduce((s, c) => s + (c[basis]?.[yr] || 0), 0);
              opexRows.push(['']);
              opexRows.push(['Total Operating Expenses', formatCurrency(opexTotal('year3')), formatCurrency(opexTotal('year4')), formatCurrency(opexTotal('year5')), formatCurrency(opexTotal('ttm')), formatPercent(ttm.revenue > 0 ? opexTotal('ttm') / ttm.revenue : 0)]);
              
              const wsOpex = XLSX.utils.aoa_to_sheet(opexRows);
              wsOpex['!cols'] = [{ wch: 30 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 18 }, { wch: 16 }];
              exportData['OpEx Detail'] = opexRows;
              XLSX.utils.book_append_sheet(wb, wsOpex, 'OpEx Detail');
            }
            
            // ===== REVENUE BREAKDOWN =====
            if (cimExportOptions.revenueBreakdown) {
              // Type labels come from the component's canonical `revenueTypes`
              // (in scope here) — a stale local shadow of it used to live here
              // with different ids, so any line typed hardware_contracted /
              // repeat_uncontracted / a legacy alias leaked its RAW ID into the
              // buyer-facing teaser donut (Thatcher's teaser, 2026-07-20).
              
              const revRows = [
                ['REVENUE BREAKDOWN BY CATEGORY - ' + (basis === 'cash' ? 'CASH' : 'ACCRUAL') + ' BASIS'],
                [''],
                ['Revenue Line', 'Revenue Type', years[0], years[1], years[2], `TTM as of ${ttmDateStr}`, '% of TTM Total'],
                ['']
              ];
              
              revenueCategories.filter(c => c.name).forEach(cat => {
                const v3 = cat[basis]?.year3 || 0;
                const v4 = cat[basis]?.year4 || 0;
                const v5 = cat[basis]?.year5 || 0;
                const vttm = cat[basis]?.ttm || 0;
                const typeLabel = revenueTypes.find(t => t.id === cat.revenueType)?.label || cat.revenueType || '';
                const pctTotal = ttm.revenue > 0 ? (vttm / ttm.revenue) : 0;
                revRows.push([cat.name, typeLabel, formatCurrency(v3), formatCurrency(v4), formatCurrency(v5), formatCurrency(vttm), formatPercent(pctTotal)]);
              });
              
              revRows.push(['']);
              revRows.push(['Total Revenue', '', formatCurrency(y3.revenue), formatCurrency(y4.revenue), formatCurrency(y5.revenue), formatCurrency(ttm.revenue), '100.0%']);
              revRows.push(['']);
              revRows.push(['Revenue Quality Metrics', '', '', '', '', '', '']);
              revRows.push(['Weighted Recurring Revenue %', `${(keyMetrics?.recurringPct || 0).toFixed(1)}%`]);
              revRows.push(['Contracted Recurring %', `${(keyMetrics?.contractedRecurringPct || 0).toFixed(1)}%`]);
              if (revenueAnalysis?.monthlyCV) revRows.push(['Revenue CV (Monthly Volatility)', `${revenueAnalysis.monthlyCV.toFixed(1)}%`, '', '', '', '', 'Lower = more stable']);
              
              const wsRev = XLSX.utils.aoa_to_sheet(revRows);
              wsRev['!cols'] = [{ wch: 30 }, { wch: 24 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 18 }, { wch: 14 }];
              exportData['Revenue Breakdown'] = revRows;
              XLSX.utils.book_append_sheet(wb, wsRev, 'Revenue Breakdown');
            }
            
            // ===== MONTHLY REVENUE TREND =====
            if (cimExportOptions.monthlyTrend) {
              const basisKey = basis === 'tax' ? 'cash' : basis;
              const monthLabels = monthlyTtmLabels || [];
              const hasMonthly = monthLabels.length >= 12;
              
              if (hasMonthly) {
                const monthRows = [
                  ['MONTHLY REVENUE & EBITDA TREND'],
                  [''],
                  ['Month', ...monthLabels.slice(0, 12), 'TTM Total']
                ];
                
                // Revenue by month
                const monthlyRevTotals = Array(12).fill(0);
                Object.values(monthlyTtmRevenue).forEach(catData => {
                  const data = catData?.[basisKey] || [];
                  for (let i = 0; i < 12; i++) monthlyRevTotals[i] += (data[i] || 0);
                });
                monthRows.push(['Revenue', ...monthlyRevTotals.map(v => formatCurrency(v)), formatCurrency(monthlyRevTotals.reduce((a, b) => a + b, 0))]);
                
                // COGS by month
                const monthlyCogsTotals = Array(12).fill(0);
                Object.values(monthlyTtmCogs).forEach(catData => {
                  const data = catData?.[basisKey] || [];
                  for (let i = 0; i < 12; i++) monthlyCogsTotals[i] += (data[i] || 0);
                });
                monthRows.push(['COGS', ...monthlyCogsTotals.map(v => formatCurrency(v)), formatCurrency(monthlyCogsTotals.reduce((a, b) => a + b, 0))]);
                
                // Gross Profit
                const monthlyGP = monthlyRevTotals.map((r, i) => r - monthlyCogsTotals[i]);
                monthRows.push(['Gross Profit', ...monthlyGP.map(v => formatCurrency(v)), formatCurrency(monthlyGP.reduce((a, b) => a + b, 0))]);
                
                // OpEx by month
                const monthlyOpexTotals = Array(12).fill(0);
                Object.values(monthlyTtmOpex).forEach(catData => {
                  const data = catData?.[basisKey] || [];
                  for (let i = 0; i < 12; i++) monthlyOpexTotals[i] += (data[i] || 0);
                });
                monthRows.push(['Operating Expenses', ...monthlyOpexTotals.map(v => formatCurrency(v)), formatCurrency(monthlyOpexTotals.reduce((a, b) => a + b, 0))]);
                
                // Net Income by month (approximate)
                const monthlyNI = monthlyGP.map((gp, i) => gp - monthlyOpexTotals[i]);
                monthRows.push(['Net Income (Est.)', ...monthlyNI.map(v => formatCurrency(v)), formatCurrency(monthlyNI.reduce((a, b) => a + b, 0))]);
                
                const wsMonthly = XLSX.utils.aoa_to_sheet(monthRows);
                wsMonthly['!cols'] = [{ wch: 20 }, ...Array(12).fill({ wch: 12 }), { wch: 14 }];
                exportData['Monthly Trend'] = monthRows;
                XLSX.utils.book_append_sheet(wb, wsMonthly, 'Monthly Trend');
              }
            }
            
            // ===== CUSTOMER RETENTION & CHURN =====
            if (cimExportOptions.retentionChurn) {
              const churnRows = [
                ['CUSTOMER RETENTION & CHURN ANALYSIS'],
                [''],
                ['Metric', 'Value', 'Notes'],
                ['']
              ];
              
              if (keyMetrics?.avgRetention != null) churnRows.push(['Customer Retention Rate', `${keyMetrics.avgRetention.toFixed(1)}%`, 'Percentage of clients retained year-over-year']);
              if (keyMetrics?.avgNRR != null) churnRows.push(['Net Revenue Retention (NRR)', `${keyMetrics.avgNRR.toFixed(1)}%`, '>100% means existing clients spend more over time']);
              churnRows.push(['Active Client Count', `${(keyMetrics?.customerCount?.ttm || keyMetrics?.customerCount?.year5 || 0)}`, '']);
              if (keyMetrics?.customerCountGrowing) churnRows.push(['Client Count Trend', 'Growing', '']);
              churnRows.push(['']);
              
              // Lost customers
              if (keyMetrics?.lostCustomers?.length > 0) {
                const churnBase = keyMetrics.churnComparisonBase || 'year5';
                churnRows.push(['Lost Customers', '', '']);
                churnRows.push(['Client', 'Lost Revenue', 'Notes']);
                keyMetrics.lostCustomers.forEach(c => {
                  const rev = Math.max(c[churnBase] || 0, c.ttm || 0);
                  churnRows.push([c.name || 'Unknown', formatCurrency(rev), '']);
                });
                churnRows.push(['Total Lost Revenue', formatCurrency(keyMetrics.lostRevenue || 0), '']);
                churnRows.push(['']);
              }
              
              // New customers
              if (keyMetrics?.newCustomers?.length > 0) {
                churnRows.push(['New Customers', '', '']);
                churnRows.push(['Client', 'New Revenue', 'Notes']);
                keyMetrics.newCustomers.forEach(c => {
                  churnRows.push([c.name || 'Unknown', formatCurrency(c.ttm || 0), '']);
                });
                churnRows.push(['Total New Revenue', formatCurrency(keyMetrics.newRevenue || 0), '']);
              }
              
              const wsChurn = XLSX.utils.aoa_to_sheet(churnRows);
              wsChurn['!cols'] = [{ wch: 30 }, { wch: 20 }, { wch: 40 }];
              exportData['Retention & Churn'] = churnRows;
              XLSX.utils.book_append_sheet(wb, wsChurn, 'Retention & Churn');
            }
            
            // ===== AR/AP QUALITY =====
            if (cimExportOptions.arApQuality) {
              const arapRows = [
                ['AR/AP QUALITY SUMMARY'],
                [''],
                ['Accounts Receivable', 'Value', 'Notes'],
                ['Total AR', formatCurrency(arAgingCalcs?.totalAR || 0), ''],
                ['AR Past Due', formatCurrency(arAgingCalcs?.pastDue || 0), keyMetrics?.pastDuePct != null ? `${keyMetrics.pastDuePct.toFixed(1)}% of total` : ''],
                ['AR Seriously Past Due', formatCurrency(arAgingCalcs?.seriouslyPastDue || 0), keyMetrics?.seriouslyPastDuePct != null ? `${keyMetrics.seriouslyPastDuePct.toFixed(1)}% of total` : ''],
                ['Days Sales Outstanding (DSO)', keyMetrics?.dso != null ? `${keyMetrics.dso.toFixed(0)} days` : 'N/A', 'Target: 30-45 days'],
                ['']
              ];
              
              // AR line items
              const arItems = arAgingLineItems.filter(i => i.customerName);
              if (arItems.length > 0) {
                const seriousStart = arAgingBucketLabels?.seriousPastDueStartColumn || 4;
                arapRows.push(['AR Aging Detail', '', '']);
                arapRows.push(['Customer', arAgingBucketLabels?.current || 'Current', arAgingBucketLabels?.days31to60 || '31-60', arAgingBucketLabels?.days61to90 || '61-90', arAgingBucketLabels?.days91to120 || '91-120', arAgingBucketLabels?.days120plus || '120+', 'Total']);
                arItems.forEach(item => {
                  const total = (item.current || 0) + (item.days31to60 || 0) + (item.days61to90 || 0) + (item.days91to120 || 0) + (item.days120plus || 0);
                  arapRows.push([item.customerName, formatCurrency(item.current || 0), formatCurrency(item.days31to60 || 0), formatCurrency(item.days61to90 || 0), formatCurrency(item.days91to120 || 0), formatCurrency(item.days120plus || 0), formatCurrency(total)]);
                });
                arapRows.push(['']);
              }
              
              // Working capital lives on its own dedicated sheet (see
              // below) — keeping AR-AP Quality focused on AR aging + DSO.
              // The legacy "Net Working Capital" row used the point-in-time
              // interim BS (cash-inclusive), which is the wrong metric for
              // a CIM. The new Working Capital sheet shows the operating
              // NWC peg from the 12-month TTM BS analysis.

              const wsARAP = XLSX.utils.aoa_to_sheet(arapRows);
              wsARAP['!cols'] = [{ wch: 25 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 14 }];
              exportData['AR-AP Quality'] = arapRows;
              XLSX.utils.book_append_sheet(wb, wsARAP, 'AR-AP Quality');
            }

            // ===== WORKING CAPITAL =====
            if (cimExportOptions.workingCapital) {
              const wc = wcCalculations || {};
              const wcq = multipleAdjustments?.workingCapitalQuality || {};

              if (!wc.hasData) {
                const placeholderRows = [
                  ['WORKING CAPITAL ANALYSIS'],
                  [''],
                  ['No TTM monthly balance sheet data has been entered.'],
                  [''],
                  ['To populate this sheet, enter monthly current asset and current liability'],
                  ['values on the TTM Balance Sheet tab in the valuation tool, then re-export.']
                ];
                const wsWcEmpty = XLSX.utils.aoa_to_sheet(placeholderRows);
                wsWcEmpty['!cols'] = [{ wch: 80 }];
                exportData['Working Capital'] = placeholderRows;
                XLSX.utils.book_append_sheet(wb, wsWcEmpty, 'Working Capital');
              } else {

              // Methodology label
              const methodLabel = wc.wcPegLabel || 'Average';
              const validMonthsCount = wc.validMonths || 0;

              // Operating account names — only those flagged `included`.
              const operatingCAaccounts = (ttmBsCurrentAssets || []).filter(a => a.included && a.name);
              const operatingCLaccounts = (ttmBsCurrentLiabilities || []).filter(a => a.included && a.name);

              const wcRows = [
                ['WORKING CAPITAL ANALYSIS - OPERATING NWC PEG'],
                [''],
                ['Headline'],
                ['Operating Working Capital Peg', wc.wcPeg || 0, methodLabel],
                // Count as string so the bulk currency-format loop skips it.
                ['Months in Calculation', String(validMonthsCount), validMonthsCount >= 12 ? 'Full TTM' : 'Partial period'],
                [''],
                ['Definition'],
                ['Operating Working Capital = Operating Current Assets - Operating Current Liabilities.'],
                ['Cash, debt, and balance-sheet items unrelated to day-to-day operations are excluded.'],
                ['The peg is the level of working capital a buyer needs to fund ongoing operations.'],
                [''],
                ['Accounts Included in Operating Working Capital'],
                ['Operating Current Assets', '', ''],
              ];
              if (operatingCAaccounts.length === 0) {
                wcRows.push(['  (none flagged as operating)', '', '']);
              } else {
                operatingCAaccounts.forEach(a => wcRows.push(['  ' + a.name, '', '']));
              }
              wcRows.push(['Operating Current Liabilities', '', '']);
              if (operatingCLaccounts.length === 0) {
                wcRows.push(['  (none flagged as operating)', '', '']);
              } else {
                operatingCLaccounts.forEach(a => wcRows.push(['  ' + a.name, '', '']));
              }

              wcRows.push(['']);
              wcRows.push(['Monthly Trend (Operating)']);
              wcRows.push(['Month', 'Operating CA', 'Operating CL', 'Operating NWC']);

              const monthly = wc.monthlyData || [];
              monthly.forEach(m => {
                wcRows.push([m.label, m.operatingCA || 0, m.operatingCL || 0, m.operatingNWC || 0]);
              });

              if (wc.hasData) {
                wcRows.push(['']);
                wcRows.push(['Statistics']);
                wcRows.push(['Average Operating NWC', wc.operatingAvgNWC || 0, '']);
                wcRows.push(['Average Operating CA', wc.operatingAvgCA || 0, '']);
                wcRows.push(['Average Operating CL', wc.operatingAvgCL || 0, '']);
                wcRows.push(['Minimum Operating NWC', wc.stats?.min || 0, wc.stats?.minMonth || '']);
                wcRows.push(['Maximum Operating NWC', wc.stats?.max || 0, wc.stats?.maxMonth || '']);
                wcRows.push(['Range (Max - Min)', wc.stats?.range || 0, '']);
              }

              if (wc.anomalies && wc.anomalies.length > 0) {
                wcRows.push(['']);
                wcRows.push(['Month-over-Month Anomalies (>25% change)']);
                wcRows.push(['From', 'To', 'Change ($)', 'Change (%)']);
                wc.anomalies.forEach(a => {
                  wcRows.push([a.fromMonth, a.toMonth, a.change || 0, `${(a.pctChange || 0).toFixed(1)}%`]);
                });
              }

              if (wcq.arPastDueNotes || wcq.arSeriousNotes || wcq.negativeBalancesNotes) {
                wcRows.push(['']);
                wcRows.push(['Quality Notes']);
                if (wcq.arPastDueNotes) wcRows.push(['AR Past Due', wcq.arPastDueNotes]);
                if (wcq.arSeriousNotes) wcRows.push(['AR Seriously Past Due', wcq.arSeriousNotes]);
                if (wcq.negativeBalancesNotes) wcRows.push(['Negative Balances', wcq.negativeBalancesNotes]);
              }

              const wsWC = XLSX.utils.aoa_to_sheet(wcRows);
              wsWC['!cols'] = [{ wch: 32 }, { wch: 16 }, { wch: 16 }, { wch: 16 }];

              // Format numeric cells as currency. Skip rows where the value
              // is text (definition paragraphs, account names).
              const wcCurrencyFmt = '"$"#,##0_);("$"#,##0)';
              Object.keys(wsWC).filter(k => !k.startsWith('!')).forEach(cellRef => {
                const cell = wsWC[cellRef];
                if (cell && cell.t === 'n') {
                  cell.z = wcCurrencyFmt;
                }
              });

              exportData['Working Capital'] = wcRows;
              XLSX.utils.book_append_sheet(wb, wsWC, 'Working Capital');

              // Reconciliation: the headline peg in this sheet must equal
              // wcCalculations.wcPeg exactly. (Tautology by construction,
              // but worth asserting in case a future refactor breaks it.)
              if (wc.hasData && Math.abs((wc.wcPeg || 0) - (wcCalculations?.wcPeg || 0)) > 1) {
                cimReconciliationIssues.push({
                  sheet: 'Working Capital',
                  detail: `Sheet peg ${formatCurrency(wc.wcPeg)} does not match wcCalculations.wcPeg ${formatCurrency(wcCalculations?.wcPeg)}`
                });
              }
              } // end else (hasData)
            }
            
            // ===== SELLER Q&A =====
            if (cimExportOptions.sellerQA) {
              const qaRows = [
                ['SELLER DISCOVERY Q&A'],
                ['']
              ];
              
              const sectionNames = {
                foundational: 'Foundational',
                business_model: 'Business Model',
                operations: 'Operations',
                owner: 'Owner Involvement',
                financial: 'Financial / Accounting',
                real_estate: 'Real Estate'
              };
              
              const sections = ['foundational', 'business_model', 'operations', 'owner', 'financial', 'real_estate'];
              sections.forEach(section => {
                const sectionQAs = sellerQA.filter(qa => qa.section === section && qa.answer);
                if (sectionQAs.length === 0) return;
                
                qaRows.push([sectionNames[section] || section, '']);
                qaRows.push(['Question', 'Answer']);
                sectionQAs.forEach(qa => {
                  qaRows.push([qa.question, qa.answer]);
                  // Include follow-ups with answers
                  if (qa.followUps) {
                    qa.followUps.filter(fu => fu.answer).forEach(fu => {
                      qaRows.push([`  Follow-up: ${fu.question}`, fu.answer]);
                    });
                  }
                });
                qaRows.push(['']);
              });
              
              const wsQA = XLSX.utils.aoa_to_sheet(qaRows);
              wsQA['!cols'] = [{ wch: 60 }, { wch: 60 }];
              exportData['Seller Q&A'] = qaRows;
              XLSX.utils.book_append_sheet(wb, wsQA, 'Seller Q&A');
            }

            // ===== STRENGTHS & RISKS =====
            if (cimExportOptions.strengthsRisks) {
              const srRows = [
                ['STRENGTHS & RISKS ANALYSIS'],
                [''],
              ];
              
              const bench = selectedIndustryObj?.benchmarks || { recurringRevenuePct: 50, ebitdaMargin: 15, topCustomerConcentration: 15, top5CustomerConcentration: 40, customerRetentionRate: 85, industryGrowthRate: 5 };
              const strengths = [];
              const risks = [];
              
              // Revenue quality
              const recurPct = keyMetrics?.recurringPct || 0;
              if (recurPct >= bench.recurringRevenuePct) {
                strengths.push({ text: `${recurPct.toFixed(0)}% recurring revenue`, detail: `exceeds ${bench.recurringRevenuePct}% industry benchmark` });
              } else if (recurPct > 0 && recurPct < bench.recurringRevenuePct * 0.7) {
                risks.push({ text: `Low recurring revenue (${recurPct.toFixed(0)}%)`, detail: `industry benchmark: ${bench.recurringRevenuePct}%`, severity: 'warning' });
              }
              
              // Revenue growth
              const revCAGR = keyMetrics?.revCAGR;
              if (revCAGR !== null && revCAGR !== undefined) {
                if (revCAGR < -5) {
                  risks.push({ text: `Revenue shrinking (${revCAGR.toFixed(1)}% CAGR)`, detail: 'negative growth trend impacts valuation', severity: 'critical' });
                } else if (revCAGR >= bench.industryGrowthRate) {
                  strengths.push({ text: `Strong revenue growth (${revCAGR.toFixed(1)}% CAGR)`, detail: `above ${bench.industryGrowthRate}% industry rate` });
                } else if (revCAGR > 5) {
                  strengths.push({ text: `Revenue growing (${revCAGR.toFixed(1)}% CAGR)`, detail: 'positive growth trajectory' });
                }
              }
              
              // EBITDA margin
              const ebitdaMargin = keyMetrics?.ebitdaMargin || 0;
              if (ebitdaMargin >= bench.ebitdaMargin) {
                strengths.push({ text: `${ebitdaMargin.toFixed(1)}% EBITDA margin`, detail: `above ${bench.ebitdaMargin}% industry average` });
              } else if (ebitdaMargin > 0 && ebitdaMargin < bench.ebitdaMargin * 0.6) {
                risks.push({ text: `Below-market margins (${ebitdaMargin.toFixed(1)}%)`, detail: `industry average: ${bench.ebitdaMargin}%`, severity: 'warning' });
              }
              
              // EBITDA growth
              const ebitdaCAGR = keyMetrics?.ebitdaCAGR;
              if (ebitdaCAGR !== null && ebitdaCAGR !== undefined) {
                if (ebitdaCAGR > 10) strengths.push({ text: `EBITDA growing ${ebitdaCAGR.toFixed(0)}% CAGR`, detail: 'strong earnings trajectory' });
                else if (ebitdaCAGR < -20) risks.push({ text: `EBITDA declining (${ebitdaCAGR.toFixed(0)}% CAGR)`, detail: 'severe earnings deterioration', severity: 'critical' });
                else if (ebitdaCAGR < -5) risks.push({ text: `EBITDA declining (${ebitdaCAGR.toFixed(0)}% CAGR)`, detail: 'earnings deterioration', severity: 'warning' });
              }
              
              // Concentration
              const topCustPct = keyMetrics?.topCustomerPct || 0;
              if (topCustPct > 0 && topCustPct <= bench.topCustomerConcentration) {
                strengths.push({ text: `Low customer concentration (${topCustPct.toFixed(1)}% top)`, detail: `within ${bench.topCustomerConcentration}% industry target` });
              } else if (topCustPct > 25) {
                risks.push({ text: `High concentration: top customer = ${topCustPct.toFixed(1)}%`, detail: 'key-person dependency risk', severity: 'critical' });
              } else if (topCustPct > bench.topCustomerConcentration) {
                risks.push({ text: `Elevated concentration (${topCustPct.toFixed(1)}% top customer)`, detail: `industry target: <${bench.topCustomerConcentration}%`, severity: 'warning' });
              }
              
              const top5Pct = keyMetrics?.top5CustomersPct || 0;
              if (top5Pct > 50) risks.push({ text: `Top 5 customers = ${top5Pct.toFixed(0)}% of revenue`, detail: 'narrow revenue base', severity: 'warning' });
              
              // Customer spike
              if (keyMetrics?.hasCustomerSpike && keyMetrics?.customerSpikes?.length > 0) {
                const topSpike = keyMetrics.customerSpikes[0];
                risks.push({ text: `Single customer spike driving ${topSpike.shareOfGrowth.toFixed(0)}% of revenue growth`, detail: `${topSpike.name}: growth may not be sustainable`, severity: 'critical' });
              }
              
              // Retention
              const retention = keyMetrics?.avgRetention;
              if (retention != null && retention >= bench.customerRetentionRate) {
                strengths.push({ text: `${retention.toFixed(0)}% revenue retention`, detail: `exceeds ${bench.customerRetentionRate}% benchmark` });
              } else if (retention != null && retention < bench.customerRetentionRate * 0.9) {
                risks.push({ text: `Low retention (${retention.toFixed(0)}%)`, detail: `benchmark: ${bench.customerRetentionRate}%`, severity: 'warning' });
              }
              
              // NRR
              const nrr = keyMetrics?.avgNRR;
              if (nrr != null && nrr >= 105) strengths.push({ text: `${nrr.toFixed(0)}% net revenue retention`, detail: 'existing customers expanding' });
              else if (nrr != null && nrr < 85) risks.push({ text: `Low NRR (${nrr.toFixed(0)}%)`, detail: 'existing customers shrinking', severity: 'warning' });
              
              // Customer growth
              if (keyMetrics?.customerCountGrowing) strengths.push({ text: 'Growing customer count', detail: `${keyMetrics.customerCount?.ttm || 0} active clients` });
              
              // Contracts
              const contractPct = keyMetrics?.contractedPct || 0;
              if (contractPct >= 70) {
                strengths.push({ text: `${contractPct.toFixed(0)}% of clients under contract`, detail: keyMetrics?.assignablePct >= 70 ? `${keyMetrics.assignablePct.toFixed(0)}% assignable` : 'review assignability' });
              } else if (contractPct > 0 && contractPct < 40) {
                risks.push({ text: `Only ${contractPct.toFixed(0)}% clients under contract`, detail: 'revenue at risk without binding agreements', severity: 'warning' });
              }
              
              // AR quality
              const pastDuePct = keyMetrics?.pastDuePct;
              const dso = keyMetrics?.dso;
              if (pastDuePct != null && pastDuePct > 30) {
                risks.push({ text: `${pastDuePct.toFixed(0)}% of AR past due`, detail: dso ? `DSO: ${dso.toFixed(0)} days` : 'review collection practices', severity: 'warning' });
              } else if (pastDuePct != null && pastDuePct <= 10) {
                strengths.push({ text: 'Clean AR aging', detail: dso ? `DSO: ${dso.toFixed(0)} days, only ${pastDuePct.toFixed(0)}% past due` : `only ${pastDuePct.toFixed(0)}% past due` });
              }
              
              // Large adjustments
              const adjPct = keyMetrics?.adjustmentsToEbitdaPct;
              if (adjPct != null && adjPct > 50) risks.push({ text: `Adjustments = ${adjPct.toFixed(0)}% of base EBITDA`, detail: 'heavy normalization may face buyer skepticism', severity: 'warning' });
              
              // Revenue stability
              const revCV = revenueAnalysis?.monthlyCV || 0;
              if (revenueAnalysis?.hasMonthlyData && revCV > 25) {
                risks.push({ text: `High revenue volatility (${revCV.toFixed(0)}% CV)`, detail: 'unpredictable cash flow', severity: 'warning' });
              } else if (revenueAnalysis?.hasMonthlyData && revCV < 10) {
                strengths.push({ text: 'Stable monthly revenue', detail: `low volatility (${revCV.toFixed(0)}% CV)` });
              }
              
              // Sort risks: critical first
              risks.sort((a, b) => (a.severity === 'critical' ? 0 : 1) - (b.severity === 'critical' ? 0 : 1));
              
              if (strengths.length > 0) {
                srRows.push(['STRENGTHS', '']);
                strengths.forEach(s => srRows.push([s.text, s.detail]));
                srRows.push(['']);
              }
              
              if (risks.length > 0) {
                srRows.push(['RISKS', 'Severity']);
                risks.forEach(r => srRows.push([`${r.severity === 'critical' ? '[CRITICAL] ' : '[WARNING] '}${r.text}`, r.detail]));
                srRows.push(['']);
              }
              
              const wsSR = XLSX.utils.aoa_to_sheet(srRows);
              wsSR['!cols'] = [{ wch: 55 }, { wch: 55 }];
              exportData['Strengths & Risks'] = srRows;
              XLSX.utils.book_append_sheet(wb, wsSR, 'Strengths & Risks');
            }

            // ===== TECHNOLOGY STACK =====
            // Prefer the per-vendor table (Technology | Use | Contract Term |
            // Monthly Cost — the "Needed" form) when the deal has one; the CIM
            // renders Term + Monthly Cost columns from it. Fall back to the older
            // category buckets for deals entered before the vendor table existed.
            const cimVendorRows = (cimVendors || []).filter(v => (v.technology || '').trim());
            if (cimVendorRows.length > 0) {
              const techRows = [
                ['TECHNOLOGY STACK'],
                [''],
                ['Technology', 'Use', 'Contract Term', 'Monthly Cost'],
                ...cimVendorRows.map(v => [
                  (v.technology || '').trim(),
                  (v.use || '').trim(),
                  (v.term || '').trim(),
                  (v.monthlyCost || '').trim()
                ])
              ];
              const wsTech = XLSX.utils.aoa_to_sheet(techRows);
              wsTech['!cols'] = [{ wch: 28 }, { wch: 30 }, { wch: 22 }, { wch: 16 }];
              exportData['Technology Stack'] = techRows;
              XLSX.utils.book_append_sheet(wb, wsTech, 'Technology Stack');
            } else if (Object.values(cimTechStack || {}).some(v => v)) {
              const techRows = [
                ['TECHNOLOGY STACK'],
                [''],
                ['Category', 'Tools / Platforms'],
                ['RMM Tool', cimTechStack?.rmm || ''],
                ['PSA Tool', cimTechStack?.psa || ''],
                ['Security Stack (EDR, Email, DNS)', cimTechStack?.security || ''],
                ['Backup Solution', cimTechStack?.backup || ''],
                ['Cloud Platforms', cimTechStack?.cloud || ''],
                ['Microsoft Partner Tier', cimTechStack?.microsoftTier || ''],
                ['Vendor Partner Relationships', cimTechStack?.vendorPartners || ''],
                ['Key Software Subscriptions (COGS)', cimTechStack?.keySoftware || '']
              ];
              const wsTech = XLSX.utils.aoa_to_sheet(techRows);
              wsTech['!cols'] = [{ wch: 35 }, { wch: 55 }];
              exportData['Technology Stack'] = techRows;
              XLSX.utils.book_append_sheet(wb, wsTech, 'Technology Stack');
            }
            // end tech stack if

            // ===== CONTRACT SNAPSHOT (D6 "rate-card" feed) =====
            // Master service-agreement mechanics → the CIM's Pricing section
            // (key/value table). Only filled fields are written.
            if (Object.values(cimContractTerms || {}).some(v => v)) {
              const csFields = [
                ['Contract Term', cimContractTerms?.term],
                ['Renewal', cimContractTerms?.renewal],
                ['Termination for Convenience', cimContractTerms?.termConvenience],
                ['Termination for Cause', cimContractTerms?.termCause],
                ['Pricing', cimContractTerms?.pricing],
                ['Price Increase', cimContractTerms?.priceIncrease],
                ['Assignability', cimContractTerms?.assignability],
                ['Auto-scaling / Overage Fees', cimContractTerms?.overageFees],
                ['Usage Limits', cimContractTerms?.usageLimits],
                ['Payment Terms', cimContractTerms?.paymentTerms],
                ['All Clients on Similar Contracts?', cimContractTerms?.similarContracts]
              ];
              const csRows = [
                ['CONTRACT SNAPSHOT'],
                [''],
                ['Field', 'Detail'],
                ...csFields.filter(f => f[1] && String(f[1]).trim()).map(f => [f[0], String(f[1]).trim()])
              ];
              const wsCS = XLSX.utils.aoa_to_sheet(csRows);
              wsCS['!cols'] = [{ wch: 32 }, { wch: 60 }];
              exportData['Contract Snapshot'] = csRows;
              XLSX.utils.book_append_sheet(wb, wsCS, 'Contract Snapshot');
            }
            
            // ===== EMPLOYEES =====
            if ((cimEmployees || []).length > 0) {
              // Comp RANGES only (no individual pay in the CIM); rounded to whole
              // dollars. Blank when a group's bounds aren't both set.
              const fmtRange = (lo, hi) => {
                const a = Number(lo), b = Number(hi);
                if (!a || !b) return '';
                return '$' + Math.round(a).toLocaleString('en-US') + ' to $' + Math.round(b).toLocaleString('en-US');
              };
              const empRows = [
                ['EMPLOYEE ROSTER'],
                [''],
                // Metadata the generator reads: disclosure mode + comp ranges + incentives.
                ['Disclosure Mode', (cimEmpDisclosure === 'management' ? 'management' : 'full')],
                ['Management Comp Range', fmtRange(cimEmpComp?.mgmtLow, cimEmpComp?.mgmtHigh)],
                ['Non-Management Comp Range', fmtRange(cimEmpComp?.nonMgmtLow, cimEmpComp?.nonMgmtHigh)],
                ['Incentive Programs', (cimEmpIncentives || '').trim()],
                [''],
                ['Name/Role', 'Title', 'Management', 'FT/PT', 'Start Date', 'Role Description', 'Certifications', 'W2/1099', 'Comp Type', 'Base Salary/Rate', 'Commission', 'Recent Comp Changes']
              ];
              (cimEmployees || []).forEach(emp => {
                empRows.push([
                  emp.name || '', emp.title || '', emp.isManagement ? 'Yes' : 'No', emp.ftpt || '', emp.startDate || '',
                  emp.roleDescription || '', emp.certifications || '', emp.w2or1099 || '',
                  emp.compType || '', emp.baseSalary ? formatCurrency(emp.baseSalary) : '',
                  emp.commission || '', emp.recentChanges || ''
                ]);
              });
              empRows.push(['']);
              empRows.push(['Total Headcount', keyMetrics?.employeeCount?.toString() || (cimEmployees.length > 0 ? cimEmployees.length.toString() : '')]);

              const wsEmp = XLSX.utils.aoa_to_sheet(empRows);
              wsEmp['!cols'] = [{ wch: 20 }, { wch: 18 }, { wch: 11 }, { wch: 6 }, { wch: 12 }, { wch: 30 }, { wch: 20 }, { wch: 8 }, { wch: 12 }, { wch: 14 }, { wch: 18 }, { wch: 22 }];
              exportData['Employees'] = empRows;
              XLSX.utils.book_append_sheet(wb, wsEmp, 'Employees');
            }

            // ===== FF&E / INVENTORY =====
            if ((cimFFE || []).some(f => (f.item || '').trim())) {
              const ffeRows = [
                ['FF&E / INVENTORY'],
                [''],
                ['Disclosure Mode', (cimFFEDisclosure === 'addendum' ? 'addendum' : 'cim')],
                [''],
                ['Item / Description', 'Category', 'Year', 'Hours / Usage', 'Include', 'Notes']
              ];
              (cimFFE || []).forEach(f => {
                if (!(f.item || '').trim()) return;
                ffeRows.push([(f.item || '').trim(), (f.category || '').trim(), (f.year || '').trim(), (f.hours || '').trim(), f.include === false ? 'No' : 'Yes', (f.notes || '').trim()]);
              });
              const wsFFE = XLSX.utils.aoa_to_sheet(ffeRows);
              wsFFE['!cols'] = [{ wch: 34 }, { wch: 18 }, { wch: 8 }, { wch: 14 }, { wch: 8 }, { wch: 30 }];
              exportData['FF&E'] = ffeRows;
              XLSX.utils.book_append_sheet(wb, wsFFE, 'FF&E');
            }
            // end employees if
            
            // ===== FACILITY =====
            if (Object.values(cimFacility || {}).some(v => v)) {
              const facRows = [
                ['FACILITY INFORMATION'],
                [''],
                ['Field', 'Details'],
                ['Physical Address', cimFacility?.address || ''],
                ['Owned or Leased', cimFacility?.ownedOrLeased || ''],
                ['Monthly Lease Rate', cimFacility?.monthlyRate || ''],
                ['Lease Expiration', cimFacility?.leaseExpiration || ''],
                ['Renewal Options', cimFacility?.renewalOptions || ''],
                ['Square Footage', cimFacility?.sqft || ''],
                ['Can Operate Remotely?', cimFacility?.canOperateRemotely || ''],
                ['If Owned: Sell or Lease to Buyer?', cimFacility?.sellerWillSellOrLease || '']
              ];
              const wsFac = XLSX.utils.aoa_to_sheet(facRows);
              wsFac['!cols'] = [{ wch: 30 }, { wch: 50 }];
              exportData['Facility'] = facRows;
              XLSX.utils.book_append_sheet(wb, wsFac, 'Facility');
            }
            // end facility if
            
            // ===== LEGAL & NON-COMPETE =====
            if (Object.values(cimLegal || {}).some(v => v)) {
              const legalRows = [
                ['LEGAL & NON-COMPETE'],
                [''],
                ['Field', 'Details'],
                ['Pending Legal Matters', cimLegal?.pendingLegalMatters || ''],
                ['Legal Matter Details', cimLegal?.pendingLegalDetails || ''],
                ['Non-Compete (Years)', cimLegal?.nonCompeteYears || ''],
                ['Non-Compete (Geographic Scope)', cimLegal?.nonCompeteScope || ''],
                ['Contract Assignability Confirmed', cimLegal?.contractAssignability || ''],
                ['Multi-Year Vendor Agreements', cimLegal?.multiYearVendorAgreements || ''],
                ['Vendor Agreement Details', cimLegal?.vendorAgreementDetails || '']
              ];
              const wsLegal = XLSX.utils.aoa_to_sheet(legalRows);
              wsLegal['!cols'] = [{ wch: 32 }, { wch: 55 }];
              exportData['Legal & Non-Compete'] = legalRows;
              XLSX.utils.book_append_sheet(wb, wsLegal, 'Legal & Non-Compete');
            }
            // end legal if
            
            // ===== GROWTH OPPORTUNITIES =====
            if ((cimGrowth || []).some(g => g.description) || Object.values(cimGrowthExtra || {}).some(v => v)) {
              const growthRows = [
                ['GROWTH OPPORTUNITIES'],
                [''],
                ['Opportunity', 'Description', 'Why Achievable', 'Estimated Upside']
              ];
              (cimGrowth || []).forEach((opp, idx) => {
                if (opp.description) {
                  growthRows.push([`Growth Opportunity ${idx + 1}`, opp.description, opp.achievability || '', opp.estimatedUpside || '']);
                }
              });
              growthRows.push(['']);
              if (cimGrowthExtra?.maTargets) growthRows.push(['M&A Targets', cimGrowthExtra.maTargets, '', '']);
              if (cimGrowthExtra?.untappedServices) growthRows.push(['Untapped Service Lines', cimGrowthExtra.untappedServices, '', '']);
              if (cimGrowthExtra?.geoExpansion) growthRows.push(['Geographic Expansion', cimGrowthExtra.geoExpansion, '', '']);
              
              const wsGrowth = XLSX.utils.aoa_to_sheet(growthRows);
              wsGrowth['!cols'] = [{ wch: 22 }, { wch: 40 }, { wch: 35 }, { wch: 20 }];
              exportData['Growth Opportunities'] = growthRows;
              XLSX.utils.book_append_sheet(wb, wsGrowth, 'Growth Opportunities');
            }
            // end growth if

            // ----- Custom Data Groups (generic builder Phase 1) -----
            // ONE sheet holds every Lead-defined group as blocks, so group
            // names never fight Excel's 31-char sheet-name limit or collide:
            //   ['__group__', name, kind, sectionKey]
            //   kv:    [label, value] rows
            //   table: ['__columns__', ...colNames] then data rows
            //   (blank row between groups)
            // Only groups with a name AND at least one non-empty entry export.
            {
              const groupRows = [];
              (cimCustomGroups || []).forEach(g => {
                const name = (g.name || '').trim();
                if (!name) return;
                if ((g.kind || 'kv') === 'kv') {
                  // Value required: a label with no value is an unfilled preset
                  // prompt, and a blank fact must never ship in a CIM.
                  const facts = (g.kv || []).filter(r => (r.v || '').trim());
                  if (!facts.length) return;
                  groupRows.push(['__group__', name, 'kv', g.section || 'businessOverview']);
                  facts.forEach(r => groupRows.push([(r.k || '').trim(), (r.v || '').trim()]));
                } else {
                  const cols = (g.columns || []).map(c => (c || '').trim());
                  const dataRows = (g.rows || []).filter(r => (r || []).some(c => (c || '').trim()));
                  if (!dataRows.length) return;
                  groupRows.push(['__group__', name, 'table', g.section || 'businessOverview']);
                  groupRows.push(['__columns__', ...cols]);
                  dataRows.forEach(r => groupRows.push(cols.map((_, ci) => (r[ci] || '').trim())));
                }
                groupRows.push([]);
              });
              if (groupRows.length > 0) {
                const wsCustom = XLSX.utils.aoa_to_sheet(groupRows);
                wsCustom['!cols'] = [{ wch: 32 }, { wch: 40 }, { wch: 25 }, { wch: 25 }];
                exportData['Custom Groups'] = groupRows;
                XLSX.utils.book_append_sheet(wb, wsCustom, 'Custom Groups');
              }
            }

            // ----- Reconciliation guard -----
            // If any sheet's numbers don't reconcile to the engine, refuse
            // to write the workbook. The CIM is high-stakes; better to
            // surface a bug than ship wrong numbers to a buyer.
            if (cimReconciliationIssues.length > 0) {
              const detail = cimReconciliationIssues
                .map(i => `• ${i.sheet}: ${i.detail}`)
                .join('\n');
              console.error('CIM Export reconciliation failures:', cimReconciliationIssues);
              alert(
                'CIM export blocked — numbers do not reconcile.\n\n' +
                detail +
                '\n\nThis is a bug in the export, not your data. Please report it ' +
                'with this message and the export file is NOT being generated.'
              );
              return;
            }

            // Persist this export to Supabase so Deal Manager (sharing
            // the same Supabase project) can read CIM data directly to
            // answer buyer questions, without anyone manually uploading
            // the Excel. Fire-and-forget by design: if Supabase is down
            // or RLS rejects the write, log it but still produce the
            // Excel — humans still need the file.
            if (supabaseClient) {
              const vistaIdForInsert = (dealProfile.vistaId || '').trim();
              supabaseClient
                .from('cim_exports')
                .insert({
                  vista_id:     vistaIdForInsert,
                  export_data:  exportData,
                  generated_by: userEmail || null
                })
                .then(({ error: cimDbErr }) => {
                  if (cimDbErr) console.warn('CIM export DB write failed (Excel still produced):', cimDbErr.message);
                });
            }

            // Generate filename and download
            const companyName = (dealProfile?.companyName || 'Company').replace(/[^a-zA-Z0-9]/g, '_');
            const dateStr = new Date().toISOString().split('T')[0];
            const filename = `${companyName}_CIM_Export_${dateStr}.xlsx`;

            XLSX.writeFile(wb, filename);
            setShowCIMExportModal(false);
            
          } catch (error) {
            console.error('CIM Export error:', error);
            alert('Error generating CIM export. Check console for details.');
          } finally {
            setCimExporting(false);
          }
        };
        
        return (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white">
                <div className="flex items-center gap-2">
                  <FileText className="w-5 h-5 text-green-700" />
                  <h2 className="text-lg font-semibold text-gray-900">Export for CIM</h2>
                </div>
                <button onClick={() => { setCimExporting(false); setShowCIMExportModal(false); }} className="text-gray-400 hover:text-gray-600 text-xl font-bold">
                  ×
                </button>
              </div>
              
              {/* Content */}
              <div className="p-4">
                <p className="text-sm text-gray-600 mb-4">
                  Generate CIM-ready financial tables and reports. All outputs will be combined into a single Excel workbook matching the CIM format.
                </p>
                
                {/* Export Options */}
                <div className="space-y-2 mb-4">
                  <label className="text-sm font-medium text-gray-700">Select outputs to include:</label>
                  
                  {[
                    { key: 'incomeStatement', label: 'Income Statement Comparison', desc: 'Revenue, COGS, GP, OpEx, Net Income' },
                    { key: 'balanceSheet', label: 'Balance Sheet', desc: 'Assets, Liabilities, Equity' },
                    { key: 'normalizedEbitda', label: 'Normalized EBITDA Calculations', desc: 'Net Income + Add-backs - Normalized Comp' },
                    { key: 'taxReconciliation', label: 'Tax Return Reconciliation', desc: 'Revenue & Net Income vs filing-basis P&L, prior 3 years' },
                    { key: 'workingCapital', label: 'Working Capital Peg', desc: '12-month operating NWC analysis' },
                    { key: 'revenueByClient', label: 'Revenue by Client', desc: 'Client list with contract details' },
                    { key: 'keyMetrics', label: 'Key Metrics Summary', desc: 'Financial & operational metrics' },
                    { key: 'businessSummary', label: 'Business Details Summary', desc: 'Company info & operating data' },
                    { key: 'opexDetail', label: 'OpEx Detail', desc: 'Operating expenses by category, 3yr + TTM' },
                    { key: 'revenueBreakdown', label: 'Revenue Breakdown', desc: 'Revenue by category + quality metrics' },
                    { key: 'monthlyTrend', label: 'Monthly Trend', desc: 'Monthly revenue & EBITDA trend (when 12 months present)' },
                    { key: 'retentionChurn', label: 'Retention & Churn', desc: 'Retention, NRR, lost/new customers' },
                    { key: 'arApQuality', label: 'AR-AP Quality', desc: 'AR aging, DSO' },
                    { key: 'sellerQA', label: 'Seller Q&A', desc: 'Discovery Q&A by section' },
                    { key: 'strengthsRisks', label: 'Strengths & Risks', desc: 'Benchmark-based analysis' }
                  ].map(option => (
                    <label key={option.key} className="flex items-start gap-2 cursor-pointer p-2 hover:bg-gray-50 rounded">
                      <input
                        type="checkbox"
                        checked={cimExportOptions[option.key]}
                        onChange={(e) => setCimExportOptions(prev => ({ ...prev, [option.key]: e.target.checked }))}
                        className="w-4 h-4 text-green-600 rounded border-gray-300 focus:ring-green-500 mt-0.5"
                      />
                      <div>
                        <span className="text-sm font-medium text-gray-700">{option.label}</span>
                        <p className="text-xs text-gray-500">{option.desc}</p>
                      </div>
                    </label>
                  ))}

                  {/* CIM Data Collection tabs export automatically when the deal has
                      the data entered (same conditions as the exporter) — surfaced
                      here so staff can tell what the workbook will carry without
                      scrolling the tabs. (Mark 2026-07-13: "can't tell they're exporting") */}
                  <div className="mt-3 p-2 bg-gray-50 rounded">
                    <p className="text-xs font-medium text-gray-600 mb-1">Also included automatically (from CIM Data Collection, when data is entered):</p>
                    {[
                      { label: 'Technology Stack', has: Object.values(cimTechStack || {}).some(v => v) || (cimVendors || []).some(v => (v.technology || '').trim()) },
                      { label: 'Contract Snapshot', has: Object.values(cimContractTerms || {}).some(v => v) },
                      { label: 'Employees', has: (cimEmployees || []).length > 0 },
                      { label: 'Facility', has: Object.values(cimFacility || {}).some(v => v) },
                      { label: 'Legal & Non-Compete', has: Object.values(cimLegal || {}).some(v => v) },
                      { label: 'Growth Opportunities', has: (cimGrowth || []).some(g => g.description) || Object.values(cimGrowthExtra || {}).some(v => v) },
                      { label: 'Custom Groups', has: (cimCustomGroups || []).some(g => (g.name || '').trim() && (((g.kind || 'kv') === 'kv' ? (g.kv || []).some(r => (r.v || '').trim()) : (g.rows || []).some(r => (r || []).some(c => (c || '').trim()))))) }
                    ].map(t => (
                      <span key={t.label} className={`inline-flex items-center gap-1 text-xs mr-3 ${t.has ? 'text-green-700' : 'text-gray-400'}`}>
                        {t.has ? '✓' : '–'} {t.label}{t.has ? '' : ' (no data)'}
                      </span>
                    ))}
                  </div>
                </div>
                
                {/* Client Anonymization Option */}
                {cimExportOptions.revenueByClient && (
                  <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={cimExportOptions.anonymizeClients}
                        onChange={(e) => setCimExportOptions(prev => ({ ...prev, anonymizeClients: e.target.checked }))}
                        className="w-4 h-4 text-green-600 rounded border-gray-300 focus:ring-green-500"
                      />
                      <span className="text-sm text-gray-700">Anonymize client names (Client #1, #2, etc.)</span>
                    </label>
                  </div>
                )}
                
                {/* Blocking Errors — hard stops, export disabled */}
                {cimBlockingErrors.length > 0 && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-300 rounded-lg">
                    <div className="flex items-center gap-2 mb-2">
                      <AlertCircle className="w-4 h-4 text-red-600" />
                      <span className="text-sm font-medium text-red-800">Cannot Export</span>
                    </div>
                    <ul className="text-sm text-red-700 space-y-1">
                      {cimBlockingErrors.map((err, idx) => (
                        <li key={idx}>• {err}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Validation Warnings — advisory, export still allowed */}
                {cimValidationWarnings.length > 0 && (
                  <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <div className="flex items-center gap-2 mb-2">
                      <AlertTriangle className="w-4 h-4 text-amber-600" />
                      <span className="text-sm font-medium text-amber-800">Data Warnings</span>
                    </div>
                    <ul className="text-sm text-amber-700 space-y-1">
                      {cimValidationWarnings.map((warning, idx) => (
                        <li key={idx}>• {warning}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                {/* Validate Button */}
                <button
                  onClick={validateCIMData}
                  className="w-full mb-4 px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  Check Data Completeness
                </button>
              </div>
              
              {/* Footer */}
              <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-200 bg-gray-50 rounded-b-lg sticky bottom-0">
                <button
                  onClick={() => { setCimExporting(false); setShowCIMExportModal(false); }}
                  className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900"
                >
                  Cancel
                </button>
                <button
                  onClick={generateCIMExport}
                  disabled={cimExporting || cimBlockingErrors.length > 0 || !Object.entries(cimExportOptions).some(([k, v]) => k !== 'anonymizeClients' && v)}
                  className="flex items-center gap-2 px-4 py-2 bg-green-700 text-white text-sm font-medium rounded-lg hover:bg-green-800 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {cimExporting ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Generating...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Generate Export
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};


    // "New version — reload" banner (Mark's go 2026-07-27; three stale-tab
    // confusions in one day on 07-24, eleven deploys today). Polls /health
    // every 5 minutes and compares the served app.js hash against the one
    // this tab booted with; a mismatch raises a fixed banner with one-click
    // reload. "Later" hides it for this tab until reload — the browser's own
    // unsaved-changes guard still protects the editor on reload.
    // Reload back to the open deal + tab (never the dashboard); plain reload elsewhere.
    const vtReloadHere = () => {
      const d = window.__vtOpenDeal;
      if (d && d.id) window.location.replace('/?valuation=' + encodeURIComponent(d.id) + (d.view ? '&view=' + encodeURIComponent(d.view) : ''));
      else window.location.reload();
    };
    const StaleVersionBanner = () => {
      const [stale, setStale] = useState(false);
      const [dismissed, setDismissed] = useState(false);
      useEffect(() => {
        let baseline = null, cancelled = false;
        const check = async () => {
          try {
            const r = await fetch('/health');
            const d = await r.json();
            if (cancelled || !d || !d.appVersion) return;
            if (baseline === null) { baseline = d.appVersion; return; }
            if (d.appVersion !== baseline) setStale(true);
          } catch (_) { /* offline blip ≠ staleness */ }
        };
        check();
        const t = setInterval(check, 5 * 60 * 1000);
        return () => { cancelled = true; clearInterval(t); };
      }, []);
      // AUTO-RELOAD (Mark 08-20 — Adam's stale tab hid his SE plate for
      // days and ran pre-08-17 code that half-ate his ⏰ clicks; a banner
      // that waits to be believed isn't protection): once stale, the tab
      // reloads ITSELF — the moment it goes to the background (5s grace so
      // the hidden-tab autosave finishes first), or after 30 minutes of the
      // banner being ignored in the foreground. NEVER with unsaved editor
      // changes (__vtHasUnsavedChanges) — those tabs keep the banner and
      // wait. "Later" hides the banner but does not opt out of healing.
      useEffect(() => {
        if (!stale) return;
        let reloading = false;
        const staleSince = Date.now();
        // Idle guard (Adam 08-20: the foreground reload fired mid-typing in
        // a dashboard card — the editor flag doesn't cover card inputs). No
        // foreground reload within 5 minutes of any keystroke or click; a
        // hidden tab needs no guard (nobody types in a hidden tab).
        let lastActivity = Date.now();
        const bump = () => { lastActivity = Date.now(); };
        window.addEventListener('keydown', bump, true);
        window.addEventListener('pointerdown', bump, true);
        const IDLE_MS = 5 * 60 * 1000;
        // Colleen's fix (09-01, the five-deploy day): the hidden-tab reload
        // used a 5s grace — so a quick hop to QuickBooks or Gmail reloaded
        // the tab and dumped her back on the dashboard mid-task. A tab now
        // only self-heals when it's been hidden a WHILE (10 min) — that's
        // Adam's actually-stale tab, not Colleen's alt-tab. An active user's
        // tab keeps the banner and waits.
        const HIDDEN_MS = 10 * 60 * 1000;
        let hiddenSince = document.hidden ? Date.now() : null;
        const dirty = () => window.__vtHasUnsavedChanges || window.__vtPortfolioDirty;
        const tryReload = (delay) => {
          if (reloading || dirty()) return;
          reloading = true;
          setTimeout(() => {
            if (dirty()
                || (document.hidden
                  ? (hiddenSince === null || Date.now() - hiddenSince < HIDDEN_MS)
                  : Date.now() - lastActivity < IDLE_MS)) { reloading = false; return; }
            vtReloadHere();
          }, delay);
        };
        // NO foreground self-reload (Colleen 09-30: presenting on a call is "idle" — talking, not clicking —
        // and the reload dumped the client onto her dashboard, other clients' names on the cards). An
        // on-screen tab keeps the banner and waits for a click; only a tab hidden 10+ minutes heals itself,
        // and it comes back to the deal it was on (vtReloadHere).
        const tick = () => {
          if (document.hidden) {
            if (hiddenSince === null) hiddenSince = Date.now();
            if (Date.now() - hiddenSince >= HIDDEN_MS) tryReload(5000);
          } else {
            hiddenSince = null;
          }
        };
        tick();
        const t = setInterval(tick, 60 * 1000);
        document.addEventListener('visibilitychange', tick);
        return () => { clearInterval(t); document.removeEventListener('visibilitychange', tick); window.removeEventListener('keydown', bump, true); window.removeEventListener('pointerdown', bump, true); };
      }, [stale]);
      if (!stale || dismissed) return null;
      return (
        <div className="fixed top-0 inset-x-0 z-[60] bg-indigo-600 text-white text-sm px-4 py-2 flex items-center justify-center gap-3 shadow">
          <span>A new version of the Valuation Tool was deployed — reload when it suits you (you'll come back to this deal).</span>
          <button onClick={() => vtReloadHere()} className="px-3 py-1 rounded bg-white text-indigo-700 text-xs font-bold hover:bg-indigo-50">Reload now</button>
          <button onClick={() => setDismissed(true)} className="text-indigo-200 hover:text-white text-xs" title="Hide the banner — the tab still reloads itself once you're away from it (never while you have unsaved edits).">Later</button>
        </div>
      );
    };

    // Render the app. The banner mounts OUTSIDE AuthGate — the gate does
    // React.cloneElement(children) and therefore requires exactly ONE child
    // (two children took production down on 2026-07-27; local boots never
    // reach the authed clone path, so the boot check missed it).
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<React.Fragment><StaleVersionBanner /><AuthGate><VistaApp /></AuthGate></React.Fragment>);
